"use strict";
(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
    get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
  }) : x)(function(x) {
    if (typeof require !== "undefined")
      return require.apply(this, arguments);
    throw new Error('Dynamic require of "' + x + '" is not supported');
  });
  var __esm = (fn, res) => function __init() {
    return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
  };
  var __commonJS = (cb, mod) => function __require2() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // <define:process>
  var define_process_default;
  var init_define_process = __esm({
    "<define:process>"() {
      define_process_default = { env: { NODE_ENV: "production", STANDALONE: "true" } };
    }
  });

  // node_modules/base64-js/index.js
  var require_base64_js = __commonJS({
    "node_modules/base64-js/index.js"(exports2) {
      "use strict";
      init_define_process();
      exports2.byteLength = byteLength;
      exports2.toByteArray = toByteArray;
      exports2.fromByteArray = fromByteArray;
      var lookup = [];
      var revLookup = [];
      var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
      var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      for (i = 0, len = code.length; i < len; ++i) {
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
      }
      var i;
      var len;
      revLookup["-".charCodeAt(0)] = 62;
      revLookup["_".charCodeAt(0)] = 63;
      function getLens(b64) {
        var len2 = b64.length;
        if (len2 % 4 > 0) {
          throw new Error("Invalid string. Length must be a multiple of 4");
        }
        var validLen = b64.indexOf("=");
        if (validLen === -1)
          validLen = len2;
        var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
        return [validLen, placeHoldersLen];
      }
      function byteLength(b64) {
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
      }
      function _byteLength(b64, validLen, placeHoldersLen) {
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
      }
      function toByteArray(b64) {
        var tmp;
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
        var curByte = 0;
        var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
        var i2;
        for (i2 = 0; i2 < len2; i2 += 4) {
          tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
          arr[curByte++] = tmp >> 16 & 255;
          arr[curByte++] = tmp >> 8 & 255;
          arr[curByte++] = tmp & 255;
        }
        if (placeHoldersLen === 2) {
          tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
          arr[curByte++] = tmp & 255;
        }
        if (placeHoldersLen === 1) {
          tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
          arr[curByte++] = tmp >> 8 & 255;
          arr[curByte++] = tmp & 255;
        }
        return arr;
      }
      function tripletToBase64(num) {
        return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
      }
      function encodeChunk(uint8, start, end) {
        var tmp;
        var output = [];
        for (var i2 = start; i2 < end; i2 += 3) {
          tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
          output.push(tripletToBase64(tmp));
        }
        return output.join("");
      }
      function fromByteArray(uint8) {
        var tmp;
        var len2 = uint8.length;
        var extraBytes = len2 % 3;
        var parts = [];
        var maxChunkLength = 16383;
        for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
          parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
        }
        if (extraBytes === 1) {
          tmp = uint8[len2 - 1];
          parts.push(
            lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
          );
        } else if (extraBytes === 2) {
          tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
          parts.push(
            lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
          );
        }
        return parts.join("");
      }
    }
  });

  // node_modules/ieee754/index.js
  var require_ieee754 = __commonJS({
    "node_modules/ieee754/index.js"(exports2) {
      init_define_process();
      exports2.read = function(buffer, offset, isLE, mLen, nBytes) {
        var e, m;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = -7;
        var i = isLE ? nBytes - 1 : 0;
        var d = isLE ? -1 : 1;
        var s = buffer[offset + i];
        i += d;
        e = s & (1 << -nBits) - 1;
        s >>= -nBits;
        nBits += eLen;
        for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
        }
        m = e & (1 << -nBits) - 1;
        e >>= -nBits;
        nBits += mLen;
        for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
        }
        if (e === 0) {
          e = 1 - eBias;
        } else if (e === eMax) {
          return m ? NaN : (s ? -1 : 1) * Infinity;
        } else {
          m = m + Math.pow(2, mLen);
          e = e - eBias;
        }
        return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
      };
      exports2.write = function(buffer, value, offset, isLE, mLen, nBytes) {
        var e, m, c;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
        var i = isLE ? 0 : nBytes - 1;
        var d = isLE ? 1 : -1;
        var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
        value = Math.abs(value);
        if (isNaN(value) || value === Infinity) {
          m = isNaN(value) ? 1 : 0;
          e = eMax;
        } else {
          e = Math.floor(Math.log(value) / Math.LN2);
          if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
          }
          if (e + eBias >= 1) {
            value += rt / c;
          } else {
            value += rt * Math.pow(2, 1 - eBias);
          }
          if (value * c >= 2) {
            e++;
            c /= 2;
          }
          if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
          } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
          } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
          }
        }
        for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
        }
        e = e << mLen | m;
        eLen += mLen;
        for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
        }
        buffer[offset + i - d] |= s * 128;
      };
    }
  });

  // node_modules/buffer/index.js
  var require_buffer = __commonJS({
    "node_modules/buffer/index.js"(exports2) {
      "use strict";
      init_define_process();
      var base64 = require_base64_js();
      var ieee754 = require_ieee754();
      var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
      exports2.Buffer = Buffer5;
      exports2.SlowBuffer = SlowBuffer;
      exports2.INSPECT_MAX_BYTES = 50;
      var K_MAX_LENGTH = 2147483647;
      exports2.kMaxLength = K_MAX_LENGTH;
      Buffer5.TYPED_ARRAY_SUPPORT = typedArraySupport();
      if (!Buffer5.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
        console.error(
          "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
        );
      }
      function typedArraySupport() {
        try {
          const arr = new Uint8Array(1);
          const proto = { foo: function() {
            return 42;
          } };
          Object.setPrototypeOf(proto, Uint8Array.prototype);
          Object.setPrototypeOf(arr, proto);
          return arr.foo() === 42;
        } catch (e) {
          return false;
        }
      }
      Object.defineProperty(Buffer5.prototype, "parent", {
        enumerable: true,
        get: function() {
          if (!Buffer5.isBuffer(this))
            return void 0;
          return this.buffer;
        }
      });
      Object.defineProperty(Buffer5.prototype, "offset", {
        enumerable: true,
        get: function() {
          if (!Buffer5.isBuffer(this))
            return void 0;
          return this.byteOffset;
        }
      });
      function createBuffer(length) {
        if (length > K_MAX_LENGTH) {
          throw new RangeError('The value "' + length + '" is invalid for option "size"');
        }
        const buf = new Uint8Array(length);
        Object.setPrototypeOf(buf, Buffer5.prototype);
        return buf;
      }
      function Buffer5(arg, encodingOrOffset, length) {
        if (typeof arg === "number") {
          if (typeof encodingOrOffset === "string") {
            throw new TypeError(
              'The "string" argument must be of type string. Received type number'
            );
          }
          return allocUnsafe2(arg);
        }
        return from(arg, encodingOrOffset, length);
      }
      Buffer5.poolSize = 8192;
      function from(value, encodingOrOffset, length) {
        if (typeof value === "string") {
          return fromString(value, encodingOrOffset);
        }
        if (ArrayBuffer.isView(value)) {
          return fromArrayView(value);
        }
        if (value == null) {
          throw new TypeError(
            "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
          );
        }
        if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
          return fromArrayBuffer(value, encodingOrOffset, length);
        }
        if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
          return fromArrayBuffer(value, encodingOrOffset, length);
        }
        if (typeof value === "number") {
          throw new TypeError(
            'The "value" argument must not be of type number. Received type number'
          );
        }
        const valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) {
          return Buffer5.from(valueOf, encodingOrOffset, length);
        }
        const b = fromObject(value);
        if (b)
          return b;
        if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
          return Buffer5.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
        }
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
        );
      }
      Buffer5.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
      };
      Object.setPrototypeOf(Buffer5.prototype, Uint8Array.prototype);
      Object.setPrototypeOf(Buffer5, Uint8Array);
      function assertSize(size2) {
        if (typeof size2 !== "number") {
          throw new TypeError('"size" argument must be of type number');
        } else if (size2 < 0) {
          throw new RangeError('The value "' + size2 + '" is invalid for option "size"');
        }
      }
      function alloc(size2, fill2, encoding) {
        assertSize(size2);
        if (size2 <= 0) {
          return createBuffer(size2);
        }
        if (fill2 !== void 0) {
          return typeof encoding === "string" ? createBuffer(size2).fill(fill2, encoding) : createBuffer(size2).fill(fill2);
        }
        return createBuffer(size2);
      }
      Buffer5.alloc = function(size2, fill2, encoding) {
        return alloc(size2, fill2, encoding);
      };
      function allocUnsafe2(size2) {
        assertSize(size2);
        return createBuffer(size2 < 0 ? 0 : checked(size2) | 0);
      }
      Buffer5.allocUnsafe = function(size2) {
        return allocUnsafe2(size2);
      };
      Buffer5.allocUnsafeSlow = function(size2) {
        return allocUnsafe2(size2);
      };
      function fromString(string, encoding) {
        if (typeof encoding !== "string" || encoding === "") {
          encoding = "utf8";
        }
        if (!Buffer5.isEncoding(encoding)) {
          throw new TypeError("Unknown encoding: " + encoding);
        }
        const length = byteLength(string, encoding) | 0;
        let buf = createBuffer(length);
        const actual = buf.write(string, encoding);
        if (actual !== length) {
          buf = buf.slice(0, actual);
        }
        return buf;
      }
      function fromArrayLike(array) {
        const length = array.length < 0 ? 0 : checked(array.length) | 0;
        const buf = createBuffer(length);
        for (let i = 0; i < length; i += 1) {
          buf[i] = array[i] & 255;
        }
        return buf;
      }
      function fromArrayView(arrayView) {
        if (isInstance(arrayView, Uint8Array)) {
          const copy = new Uint8Array(arrayView);
          return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
        }
        return fromArrayLike(arrayView);
      }
      function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) {
          throw new RangeError('"offset" is outside of buffer bounds');
        }
        if (array.byteLength < byteOffset + (length || 0)) {
          throw new RangeError('"length" is outside of buffer bounds');
        }
        let buf;
        if (byteOffset === void 0 && length === void 0) {
          buf = new Uint8Array(array);
        } else if (length === void 0) {
          buf = new Uint8Array(array, byteOffset);
        } else {
          buf = new Uint8Array(array, byteOffset, length);
        }
        Object.setPrototypeOf(buf, Buffer5.prototype);
        return buf;
      }
      function fromObject(obj) {
        if (Buffer5.isBuffer(obj)) {
          const len = checked(obj.length) | 0;
          const buf = createBuffer(len);
          if (buf.length === 0) {
            return buf;
          }
          obj.copy(buf, 0, 0, len);
          return buf;
        }
        if (obj.length !== void 0) {
          if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
            return createBuffer(0);
          }
          return fromArrayLike(obj);
        }
        if (obj.type === "Buffer" && Array.isArray(obj.data)) {
          return fromArrayLike(obj.data);
        }
      }
      function checked(length) {
        if (length >= K_MAX_LENGTH) {
          throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
        }
        return length | 0;
      }
      function SlowBuffer(length) {
        if (+length != length) {
          length = 0;
        }
        return Buffer5.alloc(+length);
      }
      Buffer5.isBuffer = function isBuffer2(b) {
        return b != null && b._isBuffer === true && b !== Buffer5.prototype;
      };
      Buffer5.compare = function compare(a, b) {
        if (isInstance(a, Uint8Array))
          a = Buffer5.from(a, a.offset, a.byteLength);
        if (isInstance(b, Uint8Array))
          b = Buffer5.from(b, b.offset, b.byteLength);
        if (!Buffer5.isBuffer(a) || !Buffer5.isBuffer(b)) {
          throw new TypeError(
            'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
          );
        }
        if (a === b)
          return 0;
        let x = a.length;
        let y = b.length;
        for (let i = 0, len = Math.min(x, y); i < len; ++i) {
          if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
          }
        }
        if (x < y)
          return -1;
        if (y < x)
          return 1;
        return 0;
      };
      Buffer5.isEncoding = function isEncoding(encoding) {
        switch (String(encoding).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return true;
          default:
            return false;
        }
      };
      Buffer5.concat = function concat2(list, length) {
        if (!Array.isArray(list)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        }
        if (list.length === 0) {
          return Buffer5.alloc(0);
        }
        let i;
        if (length === void 0) {
          length = 0;
          for (i = 0; i < list.length; ++i) {
            length += list[i].length;
          }
        }
        const buffer = Buffer5.allocUnsafe(length);
        let pos = 0;
        for (i = 0; i < list.length; ++i) {
          let buf = list[i];
          if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
              if (!Buffer5.isBuffer(buf))
                buf = Buffer5.from(buf);
              buf.copy(buffer, pos);
            } else {
              Uint8Array.prototype.set.call(
                buffer,
                buf,
                pos
              );
            }
          } else if (!Buffer5.isBuffer(buf)) {
            throw new TypeError('"list" argument must be an Array of Buffers');
          } else {
            buf.copy(buffer, pos);
          }
          pos += buf.length;
        }
        return buffer;
      };
      function byteLength(string, encoding) {
        if (Buffer5.isBuffer(string)) {
          return string.length;
        }
        if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
          return string.byteLength;
        }
        if (typeof string !== "string") {
          throw new TypeError(
            'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string
          );
        }
        const len = string.length;
        const mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0)
          return 0;
        let loweredCase = false;
        for (; ; ) {
          switch (encoding) {
            case "ascii":
            case "latin1":
            case "binary":
              return len;
            case "utf8":
            case "utf-8":
              return utf8ToBytes(string).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return len * 2;
            case "hex":
              return len >>> 1;
            case "base64":
              return base64ToBytes(string).length;
            default:
              if (loweredCase) {
                return mustMatch ? -1 : utf8ToBytes(string).length;
              }
              encoding = ("" + encoding).toLowerCase();
              loweredCase = true;
          }
        }
      }
      Buffer5.byteLength = byteLength;
      function slowToString(encoding, start, end) {
        let loweredCase = false;
        if (start === void 0 || start < 0) {
          start = 0;
        }
        if (start > this.length) {
          return "";
        }
        if (end === void 0 || end > this.length) {
          end = this.length;
        }
        if (end <= 0) {
          return "";
        }
        end >>>= 0;
        start >>>= 0;
        if (end <= start) {
          return "";
        }
        if (!encoding)
          encoding = "utf8";
        while (true) {
          switch (encoding) {
            case "hex":
              return hexSlice(this, start, end);
            case "utf8":
            case "utf-8":
              return utf8Slice(this, start, end);
            case "ascii":
              return asciiSlice(this, start, end);
            case "latin1":
            case "binary":
              return latin1Slice(this, start, end);
            case "base64":
              return base64Slice(this, start, end);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return utf16leSlice(this, start, end);
            default:
              if (loweredCase)
                throw new TypeError("Unknown encoding: " + encoding);
              encoding = (encoding + "").toLowerCase();
              loweredCase = true;
          }
        }
      }
      Buffer5.prototype._isBuffer = true;
      function swap(b, n, m) {
        const i = b[n];
        b[n] = b[m];
        b[m] = i;
      }
      Buffer5.prototype.swap16 = function swap16() {
        const len = this.length;
        if (len % 2 !== 0) {
          throw new RangeError("Buffer size must be a multiple of 16-bits");
        }
        for (let i = 0; i < len; i += 2) {
          swap(this, i, i + 1);
        }
        return this;
      };
      Buffer5.prototype.swap32 = function swap32() {
        const len = this.length;
        if (len % 4 !== 0) {
          throw new RangeError("Buffer size must be a multiple of 32-bits");
        }
        for (let i = 0; i < len; i += 4) {
          swap(this, i, i + 3);
          swap(this, i + 1, i + 2);
        }
        return this;
      };
      Buffer5.prototype.swap64 = function swap64() {
        const len = this.length;
        if (len % 8 !== 0) {
          throw new RangeError("Buffer size must be a multiple of 64-bits");
        }
        for (let i = 0; i < len; i += 8) {
          swap(this, i, i + 7);
          swap(this, i + 1, i + 6);
          swap(this, i + 2, i + 5);
          swap(this, i + 3, i + 4);
        }
        return this;
      };
      Buffer5.prototype.toString = function toString2() {
        const length = this.length;
        if (length === 0)
          return "";
        if (arguments.length === 0)
          return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
      };
      Buffer5.prototype.toLocaleString = Buffer5.prototype.toString;
      Buffer5.prototype.equals = function equals(b) {
        if (!Buffer5.isBuffer(b))
          throw new TypeError("Argument must be a Buffer");
        if (this === b)
          return true;
        return Buffer5.compare(this, b) === 0;
      };
      Buffer5.prototype.inspect = function inspect() {
        let str = "";
        const max2 = exports2.INSPECT_MAX_BYTES;
        str = this.toString("hex", 0, max2).replace(/(.{2})/g, "$1 ").trim();
        if (this.length > max2)
          str += " ... ";
        return "<Buffer " + str + ">";
      };
      if (customInspectSymbol) {
        Buffer5.prototype[customInspectSymbol] = Buffer5.prototype.inspect;
      }
      Buffer5.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, Uint8Array)) {
          target = Buffer5.from(target, target.offset, target.byteLength);
        }
        if (!Buffer5.isBuffer(target)) {
          throw new TypeError(
            'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target
          );
        }
        if (start === void 0) {
          start = 0;
        }
        if (end === void 0) {
          end = target ? target.length : 0;
        }
        if (thisStart === void 0) {
          thisStart = 0;
        }
        if (thisEnd === void 0) {
          thisEnd = this.length;
        }
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
          throw new RangeError("out of range index");
        }
        if (thisStart >= thisEnd && start >= end) {
          return 0;
        }
        if (thisStart >= thisEnd) {
          return -1;
        }
        if (start >= end) {
          return 1;
        }
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target)
          return 0;
        let x = thisEnd - thisStart;
        let y = end - start;
        const len = Math.min(x, y);
        const thisCopy = this.slice(thisStart, thisEnd);
        const targetCopy = target.slice(start, end);
        for (let i = 0; i < len; ++i) {
          if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
          }
        }
        if (x < y)
          return -1;
        if (y < x)
          return 1;
        return 0;
      };
      function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        if (buffer.length === 0)
          return -1;
        if (typeof byteOffset === "string") {
          encoding = byteOffset;
          byteOffset = 0;
        } else if (byteOffset > 2147483647) {
          byteOffset = 2147483647;
        } else if (byteOffset < -2147483648) {
          byteOffset = -2147483648;
        }
        byteOffset = +byteOffset;
        if (numberIsNaN(byteOffset)) {
          byteOffset = dir ? 0 : buffer.length - 1;
        }
        if (byteOffset < 0)
          byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
          if (dir)
            return -1;
          else
            byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
          if (dir)
            byteOffset = 0;
          else
            return -1;
        }
        if (typeof val === "string") {
          val = Buffer5.from(val, encoding);
        }
        if (Buffer5.isBuffer(val)) {
          if (val.length === 0) {
            return -1;
          }
          return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === "number") {
          val = val & 255;
          if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) {
              return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            } else {
              return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
          }
          return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
        }
        throw new TypeError("val must be string, number or Buffer");
      }
      function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        let indexSize = 1;
        let arrLength = arr.length;
        let valLength = val.length;
        if (encoding !== void 0) {
          encoding = String(encoding).toLowerCase();
          if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) {
              return -1;
            }
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
          }
        }
        function read(buf, i2) {
          if (indexSize === 1) {
            return buf[i2];
          } else {
            return buf.readUInt16BE(i2 * indexSize);
          }
        }
        let i;
        if (dir) {
          let foundIndex = -1;
          for (i = byteOffset; i < arrLength; i++) {
            if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
              if (foundIndex === -1)
                foundIndex = i;
              if (i - foundIndex + 1 === valLength)
                return foundIndex * indexSize;
            } else {
              if (foundIndex !== -1)
                i -= i - foundIndex;
              foundIndex = -1;
            }
          }
        } else {
          if (byteOffset + valLength > arrLength)
            byteOffset = arrLength - valLength;
          for (i = byteOffset; i >= 0; i--) {
            let found = true;
            for (let j = 0; j < valLength; j++) {
              if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
              }
            }
            if (found)
              return i;
          }
        }
        return -1;
      }
      Buffer5.prototype.includes = function includes2(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
      };
      Buffer5.prototype.indexOf = function indexOf2(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
      };
      Buffer5.prototype.lastIndexOf = function lastIndexOf2(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
      };
      function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        const remaining = buf.length - offset;
        if (!length) {
          length = remaining;
        } else {
          length = Number(length);
          if (length > remaining) {
            length = remaining;
          }
        }
        const strLen = string.length;
        if (length > strLen / 2) {
          length = strLen / 2;
        }
        let i;
        for (i = 0; i < length; ++i) {
          const parsed = parseInt(string.substr(i * 2, 2), 16);
          if (numberIsNaN(parsed))
            return i;
          buf[offset + i] = parsed;
        }
        return i;
      }
      function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
      }
      function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
      }
      function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
      }
      function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
      }
      Buffer5.prototype.write = function write(string, offset, length, encoding) {
        if (offset === void 0) {
          encoding = "utf8";
          length = this.length;
          offset = 0;
        } else if (length === void 0 && typeof offset === "string") {
          encoding = offset;
          length = this.length;
          offset = 0;
        } else if (isFinite(offset)) {
          offset = offset >>> 0;
          if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === void 0)
              encoding = "utf8";
          } else {
            encoding = length;
            length = void 0;
          }
        } else {
          throw new Error(
            "Buffer.write(string, encoding, offset[, length]) is no longer supported"
          );
        }
        const remaining = this.length - offset;
        if (length === void 0 || length > remaining)
          length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
          throw new RangeError("Attempt to write outside buffer bounds");
        }
        if (!encoding)
          encoding = "utf8";
        let loweredCase = false;
        for (; ; ) {
          switch (encoding) {
            case "hex":
              return hexWrite(this, string, offset, length);
            case "utf8":
            case "utf-8":
              return utf8Write(this, string, offset, length);
            case "ascii":
            case "latin1":
            case "binary":
              return asciiWrite(this, string, offset, length);
            case "base64":
              return base64Write(this, string, offset, length);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return ucs2Write(this, string, offset, length);
            default:
              if (loweredCase)
                throw new TypeError("Unknown encoding: " + encoding);
              encoding = ("" + encoding).toLowerCase();
              loweredCase = true;
          }
        }
      };
      Buffer5.prototype.toJSON = function toJSON() {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) {
          return base64.fromByteArray(buf);
        } else {
          return base64.fromByteArray(buf.slice(start, end));
        }
      }
      function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        const res = [];
        let i = start;
        while (i < end) {
          const firstByte = buf[i];
          let codePoint = null;
          let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
          if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch (bytesPerSequence) {
              case 1:
                if (firstByte < 128) {
                  codePoint = firstByte;
                }
                break;
              case 2:
                secondByte = buf[i + 1];
                if ((secondByte & 192) === 128) {
                  tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                  if (tempCodePoint > 127) {
                    codePoint = tempCodePoint;
                  }
                }
                break;
              case 3:
                secondByte = buf[i + 1];
                thirdByte = buf[i + 2];
                if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                  tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                  if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                    codePoint = tempCodePoint;
                  }
                }
                break;
              case 4:
                secondByte = buf[i + 1];
                thirdByte = buf[i + 2];
                fourthByte = buf[i + 3];
                if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                  tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                  if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                    codePoint = tempCodePoint;
                  }
                }
            }
          }
          if (codePoint === null) {
            codePoint = 65533;
            bytesPerSequence = 1;
          } else if (codePoint > 65535) {
            codePoint -= 65536;
            res.push(codePoint >>> 10 & 1023 | 55296);
            codePoint = 56320 | codePoint & 1023;
          }
          res.push(codePoint);
          i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
      }
      var MAX_ARGUMENTS_LENGTH = 4096;
      function decodeCodePointsArray(codePoints) {
        const len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) {
          return String.fromCharCode.apply(String, codePoints);
        }
        let res = "";
        let i = 0;
        while (i < len) {
          res += String.fromCharCode.apply(
            String,
            codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
          );
        }
        return res;
      }
      function asciiSlice(buf, start, end) {
        let ret = "";
        end = Math.min(buf.length, end);
        for (let i = start; i < end; ++i) {
          ret += String.fromCharCode(buf[i] & 127);
        }
        return ret;
      }
      function latin1Slice(buf, start, end) {
        let ret = "";
        end = Math.min(buf.length, end);
        for (let i = start; i < end; ++i) {
          ret += String.fromCharCode(buf[i]);
        }
        return ret;
      }
      function hexSlice(buf, start, end) {
        const len = buf.length;
        if (!start || start < 0)
          start = 0;
        if (!end || end < 0 || end > len)
          end = len;
        let out = "";
        for (let i = start; i < end; ++i) {
          out += hexSliceLookupTable[buf[i]];
        }
        return out;
      }
      function utf16leSlice(buf, start, end) {
        const bytes = buf.slice(start, end);
        let res = "";
        for (let i = 0; i < bytes.length - 1; i += 2) {
          res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        }
        return res;
      }
      Buffer5.prototype.slice = function slice2(start, end) {
        const len = this.length;
        start = ~~start;
        end = end === void 0 ? len : ~~end;
        if (start < 0) {
          start += len;
          if (start < 0)
            start = 0;
        } else if (start > len) {
          start = len;
        }
        if (end < 0) {
          end += len;
          if (end < 0)
            end = 0;
        } else if (end > len) {
          end = len;
        }
        if (end < start)
          end = start;
        const newBuf = this.subarray(start, end);
        Object.setPrototypeOf(newBuf, Buffer5.prototype);
        return newBuf;
      };
      function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0)
          throw new RangeError("offset is not uint");
        if (offset + ext > length)
          throw new RangeError("Trying to access beyond buffer length");
      }
      Buffer5.prototype.readUintLE = Buffer5.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert)
          checkOffset(offset, byteLength2, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while (++i < byteLength2 && (mul *= 256)) {
          val += this[offset + i] * mul;
        }
        return val;
      };
      Buffer5.prototype.readUintBE = Buffer5.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) {
          checkOffset(offset, byteLength2, this.length);
        }
        let val = this[offset + --byteLength2];
        let mul = 1;
        while (byteLength2 > 0 && (mul *= 256)) {
          val += this[offset + --byteLength2] * mul;
        }
        return val;
      };
      Buffer5.prototype.readUint8 = Buffer5.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 1, this.length);
        return this[offset];
      };
      Buffer5.prototype.readUint16LE = Buffer5.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
      };
      Buffer5.prototype.readUint16BE = Buffer5.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
      };
      Buffer5.prototype.readUint32LE = Buffer5.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
      };
      Buffer5.prototype.readUint32BE = Buffer5.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
      };
      Buffer5.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last2 = this[offset + 7];
        if (first === void 0 || last2 === void 0) {
          boundsError(offset, this.length - 8);
        }
        const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
        const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last2 * 2 ** 24;
        return BigInt(lo) + (BigInt(hi) << BigInt(32));
      });
      Buffer5.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last2 = this[offset + 7];
        if (first === void 0 || last2 === void 0) {
          boundsError(offset, this.length - 8);
        }
        const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
        const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last2;
        return (BigInt(hi) << BigInt(32)) + BigInt(lo);
      });
      Buffer5.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert)
          checkOffset(offset, byteLength2, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while (++i < byteLength2 && (mul *= 256)) {
          val += this[offset + i] * mul;
        }
        mul *= 128;
        if (val >= mul)
          val -= Math.pow(2, 8 * byteLength2);
        return val;
      };
      Buffer5.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert)
          checkOffset(offset, byteLength2, this.length);
        let i = byteLength2;
        let mul = 1;
        let val = this[offset + --i];
        while (i > 0 && (mul *= 256)) {
          val += this[offset + --i] * mul;
        }
        mul *= 128;
        if (val >= mul)
          val -= Math.pow(2, 8 * byteLength2);
        return val;
      };
      Buffer5.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 1, this.length);
        if (!(this[offset] & 128))
          return this[offset];
        return (255 - this[offset] + 1) * -1;
      };
      Buffer5.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 2, this.length);
        const val = this[offset] | this[offset + 1] << 8;
        return val & 32768 ? val | 4294901760 : val;
      };
      Buffer5.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 2, this.length);
        const val = this[offset + 1] | this[offset] << 8;
        return val & 32768 ? val | 4294901760 : val;
      };
      Buffer5.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
      };
      Buffer5.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
      };
      Buffer5.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last2 = this[offset + 7];
        if (first === void 0 || last2 === void 0) {
          boundsError(offset, this.length - 8);
        }
        const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last2 << 24);
        return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
      });
      Buffer5.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last2 = this[offset + 7];
        if (first === void 0 || last2 === void 0) {
          boundsError(offset, this.length - 8);
        }
        const val = (first << 24) + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
        return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last2);
      });
      Buffer5.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return ieee754.read(this, offset, true, 23, 4);
      };
      Buffer5.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return ieee754.read(this, offset, false, 23, 4);
      };
      Buffer5.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 8, this.length);
        return ieee754.read(this, offset, true, 52, 8);
      };
      Buffer5.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 8, this.length);
        return ieee754.read(this, offset, false, 52, 8);
      };
      function checkInt(buf, value, offset, ext, max2, min2) {
        if (!Buffer5.isBuffer(buf))
          throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max2 || value < min2)
          throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length)
          throw new RangeError("Index out of range");
      }
      Buffer5.prototype.writeUintLE = Buffer5.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) {
          const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
          checkInt(this, value, offset, byteLength2, maxBytes, 0);
        }
        let mul = 1;
        let i = 0;
        this[offset] = value & 255;
        while (++i < byteLength2 && (mul *= 256)) {
          this[offset + i] = value / mul & 255;
        }
        return offset + byteLength2;
      };
      Buffer5.prototype.writeUintBE = Buffer5.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) {
          const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
          checkInt(this, value, offset, byteLength2, maxBytes, 0);
        }
        let i = byteLength2 - 1;
        let mul = 1;
        this[offset + i] = value & 255;
        while (--i >= 0 && (mul *= 256)) {
          this[offset + i] = value / mul & 255;
        }
        return offset + byteLength2;
      };
      Buffer5.prototype.writeUint8 = Buffer5.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 1, 255, 0);
        this[offset] = value & 255;
        return offset + 1;
      };
      Buffer5.prototype.writeUint16LE = Buffer5.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 2, 65535, 0);
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
        return offset + 2;
      };
      Buffer5.prototype.writeUint16BE = Buffer5.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 2, 65535, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 255;
        return offset + 2;
      };
      Buffer5.prototype.writeUint32LE = Buffer5.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 4, 4294967295, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 255;
        return offset + 4;
      };
      Buffer5.prototype.writeUint32BE = Buffer5.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 4, 4294967295, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 255;
        return offset + 4;
      };
      function wrtBigUInt64LE(buf, value, offset, min2, max2) {
        checkIntBI(value, min2, max2, buf, offset, 7);
        let lo = Number(value & BigInt(4294967295));
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(4294967295));
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        return offset;
      }
      function wrtBigUInt64BE(buf, value, offset, min2, max2) {
        checkIntBI(value, min2, max2, buf, offset, 7);
        let lo = Number(value & BigInt(4294967295));
        buf[offset + 7] = lo;
        lo = lo >> 8;
        buf[offset + 6] = lo;
        lo = lo >> 8;
        buf[offset + 5] = lo;
        lo = lo >> 8;
        buf[offset + 4] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(4294967295));
        buf[offset + 3] = hi;
        hi = hi >> 8;
        buf[offset + 2] = hi;
        hi = hi >> 8;
        buf[offset + 1] = hi;
        hi = hi >> 8;
        buf[offset] = hi;
        return offset + 8;
      }
      Buffer5.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
      });
      Buffer5.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
      });
      Buffer5.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          const limit = Math.pow(2, 8 * byteLength2 - 1);
          checkInt(this, value, offset, byteLength2, limit - 1, -limit);
        }
        let i = 0;
        let mul = 1;
        let sub = 0;
        this[offset] = value & 255;
        while (++i < byteLength2 && (mul *= 256)) {
          if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
            sub = 1;
          }
          this[offset + i] = (value / mul >> 0) - sub & 255;
        }
        return offset + byteLength2;
      };
      Buffer5.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          const limit = Math.pow(2, 8 * byteLength2 - 1);
          checkInt(this, value, offset, byteLength2, limit - 1, -limit);
        }
        let i = byteLength2 - 1;
        let mul = 1;
        let sub = 0;
        this[offset + i] = value & 255;
        while (--i >= 0 && (mul *= 256)) {
          if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
            sub = 1;
          }
          this[offset + i] = (value / mul >> 0) - sub & 255;
        }
        return offset + byteLength2;
      };
      Buffer5.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 1, 127, -128);
        if (value < 0)
          value = 255 + value + 1;
        this[offset] = value & 255;
        return offset + 1;
      };
      Buffer5.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 2, 32767, -32768);
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
        return offset + 2;
      };
      Buffer5.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 2, 32767, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 255;
        return offset + 2;
      };
      Buffer5.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 4, 2147483647, -2147483648);
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
      };
      Buffer5.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 4, 2147483647, -2147483648);
        if (value < 0)
          value = 4294967295 + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 255;
        return offset + 4;
      };
      Buffer5.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      });
      Buffer5.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      });
      function checkIEEE754(buf, value, offset, ext, max2, min2) {
        if (offset + ext > buf.length)
          throw new RangeError("Index out of range");
        if (offset < 0)
          throw new RangeError("Index out of range");
      }
      function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          checkIEEE754(buf, value, offset, 4, 34028234663852886e22, -34028234663852886e22);
        }
        ieee754.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
      }
      Buffer5.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
      };
      Buffer5.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
      };
      function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          checkIEEE754(buf, value, offset, 8, 17976931348623157e292, -17976931348623157e292);
        }
        ieee754.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
      }
      Buffer5.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
      };
      Buffer5.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
      };
      Buffer5.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer5.isBuffer(target))
          throw new TypeError("argument should be a Buffer");
        if (!start)
          start = 0;
        if (!end && end !== 0)
          end = this.length;
        if (targetStart >= target.length)
          targetStart = target.length;
        if (!targetStart)
          targetStart = 0;
        if (end > 0 && end < start)
          end = start;
        if (end === start)
          return 0;
        if (target.length === 0 || this.length === 0)
          return 0;
        if (targetStart < 0) {
          throw new RangeError("targetStart out of bounds");
        }
        if (start < 0 || start >= this.length)
          throw new RangeError("Index out of range");
        if (end < 0)
          throw new RangeError("sourceEnd out of bounds");
        if (end > this.length)
          end = this.length;
        if (target.length - targetStart < end - start) {
          end = target.length - targetStart + start;
        }
        const len = end - start;
        if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
          this.copyWithin(targetStart, start, end);
        } else {
          Uint8Array.prototype.set.call(
            target,
            this.subarray(start, end),
            targetStart
          );
        }
        return len;
      };
      Buffer5.prototype.fill = function fill2(val, start, end, encoding) {
        if (typeof val === "string") {
          if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
          } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
          }
          if (encoding !== void 0 && typeof encoding !== "string") {
            throw new TypeError("encoding must be a string");
          }
          if (typeof encoding === "string" && !Buffer5.isEncoding(encoding)) {
            throw new TypeError("Unknown encoding: " + encoding);
          }
          if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") {
              val = code;
            }
          }
        } else if (typeof val === "number") {
          val = val & 255;
        } else if (typeof val === "boolean") {
          val = Number(val);
        }
        if (start < 0 || this.length < start || this.length < end) {
          throw new RangeError("Out of range index");
        }
        if (end <= start) {
          return this;
        }
        start = start >>> 0;
        end = end === void 0 ? this.length : end >>> 0;
        if (!val)
          val = 0;
        let i;
        if (typeof val === "number") {
          for (i = start; i < end; ++i) {
            this[i] = val;
          }
        } else {
          const bytes = Buffer5.isBuffer(val) ? val : Buffer5.from(val, encoding);
          const len = bytes.length;
          if (len === 0) {
            throw new TypeError('The value "' + val + '" is invalid for argument "value"');
          }
          for (i = 0; i < end - start; ++i) {
            this[i + start] = bytes[i % len];
          }
        }
        return this;
      };
      var errors = {};
      function E(sym, getMessage, Base) {
        errors[sym] = class NodeError extends Base {
          constructor() {
            super();
            Object.defineProperty(this, "message", {
              value: getMessage.apply(this, arguments),
              writable: true,
              configurable: true
            });
            this.name = `${this.name} [${sym}]`;
            this.stack;
            delete this.name;
          }
          get code() {
            return sym;
          }
          set code(value) {
            Object.defineProperty(this, "code", {
              configurable: true,
              enumerable: true,
              value,
              writable: true
            });
          }
          toString() {
            return `${this.name} [${sym}]: ${this.message}`;
          }
        };
      }
      E(
        "ERR_BUFFER_OUT_OF_BOUNDS",
        function(name) {
          if (name) {
            return `${name} is outside of buffer bounds`;
          }
          return "Attempt to access memory outside buffer bounds";
        },
        RangeError
      );
      E(
        "ERR_INVALID_ARG_TYPE",
        function(name, actual) {
          return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
        },
        TypeError
      );
      E(
        "ERR_OUT_OF_RANGE",
        function(str, range2, input) {
          let msg = `The value of "${str}" is out of range.`;
          let received = input;
          if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
            received = addNumericalSeparator(String(input));
          } else if (typeof input === "bigint") {
            received = String(input);
            if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
              received = addNumericalSeparator(received);
            }
            received += "n";
          }
          msg += ` It must be ${range2}. Received ${received}`;
          return msg;
        },
        RangeError
      );
      function addNumericalSeparator(val) {
        let res = "";
        let i = val.length;
        const start = val[0] === "-" ? 1 : 0;
        for (; i >= start + 4; i -= 3) {
          res = `_${val.slice(i - 3, i)}${res}`;
        }
        return `${val.slice(0, i)}${res}`;
      }
      function checkBounds(buf, offset, byteLength2) {
        validateNumber(offset, "offset");
        if (buf[offset] === void 0 || buf[offset + byteLength2] === void 0) {
          boundsError(offset, buf.length - (byteLength2 + 1));
        }
      }
      function checkIntBI(value, min2, max2, buf, offset, byteLength2) {
        if (value > max2 || value < min2) {
          const n = typeof min2 === "bigint" ? "n" : "";
          let range2;
          if (byteLength2 > 3) {
            if (min2 === 0 || min2 === BigInt(0)) {
              range2 = `>= 0${n} and < 2${n} ** ${(byteLength2 + 1) * 8}${n}`;
            } else {
              range2 = `>= -(2${n} ** ${(byteLength2 + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength2 + 1) * 8 - 1}${n}`;
            }
          } else {
            range2 = `>= ${min2}${n} and <= ${max2}${n}`;
          }
          throw new errors.ERR_OUT_OF_RANGE("value", range2, value);
        }
        checkBounds(buf, offset, byteLength2);
      }
      function validateNumber(value, name) {
        if (typeof value !== "number") {
          throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
        }
      }
      function boundsError(value, length, type) {
        if (Math.floor(value) !== value) {
          validateNumber(value, type);
          throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
        }
        if (length < 0) {
          throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
        }
        throw new errors.ERR_OUT_OF_RANGE(
          type || "offset",
          `>= ${type ? 1 : 0} and <= ${length}`,
          value
        );
      }
      var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
      function base64clean(str) {
        str = str.split("=")[0];
        str = str.trim().replace(INVALID_BASE64_RE, "");
        if (str.length < 2)
          return "";
        while (str.length % 4 !== 0) {
          str = str + "=";
        }
        return str;
      }
      function utf8ToBytes(string, units) {
        units = units || Infinity;
        let codePoint;
        const length = string.length;
        let leadSurrogate = null;
        const bytes = [];
        for (let i = 0; i < length; ++i) {
          codePoint = string.charCodeAt(i);
          if (codePoint > 55295 && codePoint < 57344) {
            if (!leadSurrogate) {
              if (codePoint > 56319) {
                if ((units -= 3) > -1)
                  bytes.push(239, 191, 189);
                continue;
              } else if (i + 1 === length) {
                if ((units -= 3) > -1)
                  bytes.push(239, 191, 189);
                continue;
              }
              leadSurrogate = codePoint;
              continue;
            }
            if (codePoint < 56320) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              leadSurrogate = codePoint;
              continue;
            }
            codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
          } else if (leadSurrogate) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
          }
          leadSurrogate = null;
          if (codePoint < 128) {
            if ((units -= 1) < 0)
              break;
            bytes.push(codePoint);
          } else if (codePoint < 2048) {
            if ((units -= 2) < 0)
              break;
            bytes.push(
              codePoint >> 6 | 192,
              codePoint & 63 | 128
            );
          } else if (codePoint < 65536) {
            if ((units -= 3) < 0)
              break;
            bytes.push(
              codePoint >> 12 | 224,
              codePoint >> 6 & 63 | 128,
              codePoint & 63 | 128
            );
          } else if (codePoint < 1114112) {
            if ((units -= 4) < 0)
              break;
            bytes.push(
              codePoint >> 18 | 240,
              codePoint >> 12 & 63 | 128,
              codePoint >> 6 & 63 | 128,
              codePoint & 63 | 128
            );
          } else {
            throw new Error("Invalid code point");
          }
        }
        return bytes;
      }
      function asciiToBytes(str) {
        const byteArray = [];
        for (let i = 0; i < str.length; ++i) {
          byteArray.push(str.charCodeAt(i) & 255);
        }
        return byteArray;
      }
      function utf16leToBytes(str, units) {
        let c, hi, lo;
        const byteArray = [];
        for (let i = 0; i < str.length; ++i) {
          if ((units -= 2) < 0)
            break;
          c = str.charCodeAt(i);
          hi = c >> 8;
          lo = c % 256;
          byteArray.push(lo);
          byteArray.push(hi);
        }
        return byteArray;
      }
      function base64ToBytes(str) {
        return base64.toByteArray(base64clean(str));
      }
      function blitBuffer(src, dst, offset, length) {
        let i;
        for (i = 0; i < length; ++i) {
          if (i + offset >= dst.length || i >= src.length)
            break;
          dst[i + offset] = src[i];
        }
        return i;
      }
      function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
      }
      function numberIsNaN(obj) {
        return obj !== obj;
      }
      var hexSliceLookupTable = function() {
        const alphabet = "0123456789abcdef";
        const table = new Array(256);
        for (let i = 0; i < 16; ++i) {
          const i16 = i * 16;
          for (let j = 0; j < 16; ++j) {
            table[i16 + j] = alphabet[i] + alphabet[j];
          }
        }
        return table;
      }();
      function defineBigIntMethod(fn) {
        return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
      }
      function BufferBigIntNotDefined() {
        throw new Error("BigInt not supported");
      }
    }
  });

  // node_modules/lower-case/lower-case.js
  var require_lower_case = __commonJS({
    "node_modules/lower-case/lower-case.js"(exports2, module2) {
      init_define_process();
      var LANGUAGES = {
        tr: {
          regexp: /\u0130|\u0049|\u0049\u0307/g,
          map: {
            "\u0130": "i",
            "I": "\u0131",
            "I\u0307": "i"
          }
        },
        az: {
          regexp: /[\u0130]/g,
          map: {
            "\u0130": "i",
            "I": "\u0131",
            "I\u0307": "i"
          }
        },
        lt: {
          regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
          map: {
            "I": "i\u0307",
            "J": "j\u0307",
            "\u012E": "\u012F\u0307",
            "\xCC": "i\u0307\u0300",
            "\xCD": "i\u0307\u0301",
            "\u0128": "i\u0307\u0303"
          }
        }
      };
      module2.exports = function(str, locale) {
        var lang = LANGUAGES[locale];
        str = str == null ? "" : String(str);
        if (lang) {
          str = str.replace(lang.regexp, function(m) {
            return lang.map[m];
          });
        }
        return str.toLowerCase();
      };
    }
  });

  // node_modules/no-case/vendor/non-word-regexp.js
  var require_non_word_regexp = __commonJS({
    "node_modules/no-case/vendor/non-word-regexp.js"(exports2, module2) {
      init_define_process();
      module2.exports = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g;
    }
  });

  // node_modules/no-case/vendor/camel-case-regexp.js
  var require_camel_case_regexp = __commonJS({
    "node_modules/no-case/vendor/camel-case-regexp.js"(exports2, module2) {
      init_define_process();
      module2.exports = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g;
    }
  });

  // node_modules/no-case/vendor/camel-case-upper-regexp.js
  var require_camel_case_upper_regexp = __commonJS({
    "node_modules/no-case/vendor/camel-case-upper-regexp.js"(exports2, module2) {
      init_define_process();
      module2.exports = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g;
    }
  });

  // node_modules/no-case/no-case.js
  var require_no_case = __commonJS({
    "node_modules/no-case/no-case.js"(exports2, module2) {
      init_define_process();
      var lowerCase2 = require_lower_case();
      var NON_WORD_REGEXP = require_non_word_regexp();
      var CAMEL_CASE_REGEXP = require_camel_case_regexp();
      var CAMEL_CASE_UPPER_REGEXP = require_camel_case_upper_regexp();
      module2.exports = function(str, locale, replacement) {
        if (str == null) {
          return "";
        }
        replacement = typeof replacement !== "string" ? " " : replacement;
        function replace2(match, index, value) {
          if (index === 0 || index === value.length - match.length) {
            return "";
          }
          return replacement;
        }
        str = String(str).replace(CAMEL_CASE_REGEXP, "$1 $2").replace(CAMEL_CASE_UPPER_REGEXP, "$1 $2").replace(NON_WORD_REGEXP, replace2);
        return lowerCase2(str, locale);
      };
    }
  });

  // node_modules/dot-case/dot-case.js
  var require_dot_case = __commonJS({
    "node_modules/dot-case/dot-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, ".");
      };
    }
  });

  // node_modules/upper-case/upper-case.js
  var require_upper_case = __commonJS({
    "node_modules/upper-case/upper-case.js"(exports2, module2) {
      init_define_process();
      var LANGUAGES = {
        tr: {
          regexp: /[\u0069]/g,
          map: {
            "i": "\u0130"
          }
        },
        az: {
          regexp: /[\u0069]/g,
          map: {
            "i": "\u0130"
          }
        },
        lt: {
          regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
          map: {
            "i\u0307": "I",
            "j\u0307": "J",
            "\u012F\u0307": "\u012E",
            "i\u0307\u0300": "\xCC",
            "i\u0307\u0301": "\xCD",
            "i\u0307\u0303": "\u0128"
          }
        }
      };
      module2.exports = function(str, locale) {
        var lang = LANGUAGES[locale];
        str = str == null ? "" : String(str);
        if (lang) {
          str = str.replace(lang.regexp, function(m) {
            return lang.map[m];
          });
        }
        return str.toUpperCase();
      };
    }
  });

  // node_modules/swap-case/swap-case.js
  var require_swap_case = __commonJS({
    "node_modules/swap-case/swap-case.js"(exports2, module2) {
      init_define_process();
      var upperCase2 = require_upper_case();
      var lowerCase2 = require_lower_case();
      module2.exports = function(str, locale) {
        if (str == null) {
          return "";
        }
        var result2 = "";
        for (var i = 0; i < str.length; i++) {
          var c = str[i];
          var u = upperCase2(c, locale);
          result2 += u === c ? lowerCase2(c, locale) : u;
        }
        return result2;
      };
    }
  });

  // node_modules/path-case/path-case.js
  var require_path_case = __commonJS({
    "node_modules/path-case/path-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "/");
      };
    }
  });

  // node_modules/camel-case/camel-case.js
  var require_camel_case = __commonJS({
    "node_modules/camel-case/camel-case.js"(exports2, module2) {
      init_define_process();
      var upperCase2 = require_upper_case();
      var noCase = require_no_case();
      module2.exports = function(value, locale, mergeNumbers) {
        var result2 = noCase(value, locale);
        if (!mergeNumbers) {
          result2 = result2.replace(/ (?=\d)/g, "_");
        }
        return result2.replace(/ (.)/g, function(m, $1) {
          return upperCase2($1, locale);
        });
      };
    }
  });

  // node_modules/snake-case/snake-case.js
  var require_snake_case = __commonJS({
    "node_modules/snake-case/snake-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "_");
      };
    }
  });

  // node_modules/title-case/title-case.js
  var require_title_case = __commonJS({
    "node_modules/title-case/title-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      var upperCase2 = require_upper_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale).replace(/^.| ./g, function(m) {
          return upperCase2(m, locale);
        });
      };
    }
  });

  // node_modules/param-case/param-case.js
  var require_param_case = __commonJS({
    "node_modules/param-case/param-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "-");
      };
    }
  });

  // node_modules/header-case/header-case.js
  var require_header_case = __commonJS({
    "node_modules/header-case/header-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      var upperCase2 = require_upper_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "-").replace(/^.|-./g, function(m) {
          return upperCase2(m, locale);
        });
      };
    }
  });

  // node_modules/upper-case-first/upper-case-first.js
  var require_upper_case_first = __commonJS({
    "node_modules/upper-case-first/upper-case-first.js"(exports2, module2) {
      init_define_process();
      var upperCase2 = require_upper_case();
      module2.exports = function(str, locale) {
        if (str == null) {
          return "";
        }
        str = String(str);
        return upperCase2(str.charAt(0), locale) + str.substr(1);
      };
    }
  });

  // node_modules/pascal-case/pascal-case.js
  var require_pascal_case = __commonJS({
    "node_modules/pascal-case/pascal-case.js"(exports2, module2) {
      init_define_process();
      var camelCase2 = require_camel_case();
      var upperCaseFirst2 = require_upper_case_first();
      module2.exports = function(value, locale, mergeNumbers) {
        return upperCaseFirst2(camelCase2(value, locale, mergeNumbers), locale);
      };
    }
  });

  // node_modules/constant-case/constant-case.js
  var require_constant_case = __commonJS({
    "node_modules/constant-case/constant-case.js"(exports2, module2) {
      init_define_process();
      var upperCase2 = require_upper_case();
      var snakeCase2 = require_snake_case();
      module2.exports = function(value, locale) {
        return upperCase2(snakeCase2(value, locale), locale);
      };
    }
  });

  // node_modules/sentence-case/sentence-case.js
  var require_sentence_case = __commonJS({
    "node_modules/sentence-case/sentence-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      var upperCaseFirst2 = require_upper_case_first();
      module2.exports = function(value, locale) {
        return upperCaseFirst2(noCase(value, locale), locale);
      };
    }
  });

  // node_modules/is-upper-case/is-upper-case.js
  var require_is_upper_case = __commonJS({
    "node_modules/is-upper-case/is-upper-case.js"(exports2, module2) {
      init_define_process();
      var upperCase2 = require_upper_case();
      module2.exports = function(string, locale) {
        return upperCase2(string, locale) === string;
      };
    }
  });

  // node_modules/is-lower-case/is-lower-case.js
  var require_is_lower_case = __commonJS({
    "node_modules/is-lower-case/is-lower-case.js"(exports2, module2) {
      init_define_process();
      var lowerCase2 = require_lower_case();
      module2.exports = function(string, locale) {
        return lowerCase2(string, locale) === string;
      };
    }
  });

  // node_modules/lower-case-first/lower-case-first.js
  var require_lower_case_first = __commonJS({
    "node_modules/lower-case-first/lower-case-first.js"(exports2, module2) {
      init_define_process();
      var lowerCase2 = require_lower_case();
      module2.exports = function(str, locale) {
        if (str == null) {
          return "";
        }
        str = String(str);
        return lowerCase2(str.charAt(0), locale) + str.substr(1);
      };
    }
  });

  // node_modules/change-case/change-case.js
  var require_change_case = __commonJS({
    "node_modules/change-case/change-case.js"(exports2) {
      init_define_process();
      exports2.no = exports2.noCase = require_no_case();
      exports2.dot = exports2.dotCase = require_dot_case();
      exports2.swap = exports2.swapCase = require_swap_case();
      exports2.path = exports2.pathCase = require_path_case();
      exports2.upper = exports2.upperCase = require_upper_case();
      exports2.lower = exports2.lowerCase = require_lower_case();
      exports2.camel = exports2.camelCase = require_camel_case();
      exports2.snake = exports2.snakeCase = require_snake_case();
      exports2.title = exports2.titleCase = require_title_case();
      exports2.param = exports2.paramCase = require_param_case();
      exports2.kebab = exports2.kebabCase = exports2.paramCase;
      exports2.hyphen = exports2.hyphenCase = exports2.paramCase;
      exports2.header = exports2.headerCase = require_header_case();
      exports2.pascal = exports2.pascalCase = require_pascal_case();
      exports2.constant = exports2.constantCase = require_constant_case();
      exports2.sentence = exports2.sentenceCase = require_sentence_case();
      exports2.isUpper = exports2.isUpperCase = require_is_upper_case();
      exports2.isLower = exports2.isLowerCase = require_is_lower_case();
      exports2.ucFirst = exports2.upperCaseFirst = require_upper_case_first();
      exports2.lcFirst = exports2.lowerCaseFirst = require_lower_case_first();
    }
  });

  // node_modules/any-base/src/converter.js
  var require_converter = __commonJS({
    "node_modules/any-base/src/converter.js"(exports2, module2) {
      "use strict";
      init_define_process();
      function Converter(srcAlphabet, dstAlphabet) {
        if (!srcAlphabet || !dstAlphabet || !srcAlphabet.length || !dstAlphabet.length) {
          throw new Error("Bad alphabet");
        }
        this.srcAlphabet = srcAlphabet;
        this.dstAlphabet = dstAlphabet;
      }
      Converter.prototype.convert = function(number) {
        var i, divide2, newlen, numberMap = {}, fromBase = this.srcAlphabet.length, toBase = this.dstAlphabet.length, length = number.length, result2 = typeof number === "string" ? "" : [];
        if (!this.isValid(number)) {
          throw new Error('Number "' + number + '" contains of non-alphabetic digits (' + this.srcAlphabet + ")");
        }
        if (this.srcAlphabet === this.dstAlphabet) {
          return number;
        }
        for (i = 0; i < length; i++) {
          numberMap[i] = this.srcAlphabet.indexOf(number[i]);
        }
        do {
          divide2 = 0;
          newlen = 0;
          for (i = 0; i < length; i++) {
            divide2 = divide2 * fromBase + numberMap[i];
            if (divide2 >= toBase) {
              numberMap[newlen++] = parseInt(divide2 / toBase, 10);
              divide2 = divide2 % toBase;
            } else if (newlen > 0) {
              numberMap[newlen++] = 0;
            }
          }
          length = newlen;
          result2 = this.dstAlphabet.slice(divide2, divide2 + 1).concat(result2);
        } while (newlen !== 0);
        return result2;
      };
      Converter.prototype.isValid = function(number) {
        var i = 0;
        for (; i < number.length; ++i) {
          if (this.srcAlphabet.indexOf(number[i]) === -1) {
            return false;
          }
        }
        return true;
      };
      module2.exports = Converter;
    }
  });

  // node_modules/any-base/index.js
  var require_any_base = __commonJS({
    "node_modules/any-base/index.js"(exports2, module2) {
      init_define_process();
      var Converter = require_converter();
      function anyBase(srcAlphabet, dstAlphabet) {
        var converter = new Converter(srcAlphabet, dstAlphabet);
        return function(number) {
          return converter.convert(number);
        };
      }
      anyBase.BIN = "01";
      anyBase.OCT = "01234567";
      anyBase.DEC = "0123456789";
      anyBase.HEX = "0123456789abcdef";
      module2.exports = anyBase;
    }
  });

  // node_modules/uuid/lib/rng-browser.js
  var require_rng_browser = __commonJS({
    "node_modules/uuid/lib/rng-browser.js"(exports2, module2) {
      init_define_process();
      var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
      if (getRandomValues) {
        rnds8 = new Uint8Array(16);
        module2.exports = function whatwgRNG() {
          getRandomValues(rnds8);
          return rnds8;
        };
      } else {
        rnds = new Array(16);
        module2.exports = function mathRNG() {
          for (var i = 0, r; i < 16; i++) {
            if ((i & 3) === 0)
              r = Math.random() * 4294967296;
            rnds[i] = r >>> ((i & 3) << 3) & 255;
          }
          return rnds;
        };
      }
      var rnds8;
      var rnds;
    }
  });

  // node_modules/uuid/lib/bytesToUuid.js
  var require_bytesToUuid = __commonJS({
    "node_modules/uuid/lib/bytesToUuid.js"(exports2, module2) {
      init_define_process();
      var byteToHex = [];
      for (i = 0; i < 256; ++i) {
        byteToHex[i] = (i + 256).toString(16).substr(1);
      }
      var i;
      function bytesToUuid(buf, offset) {
        var i2 = offset || 0;
        var bth = byteToHex;
        return [
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]]
        ].join("");
      }
      module2.exports = bytesToUuid;
    }
  });

  // node_modules/uuid/v4.js
  var require_v4 = __commonJS({
    "node_modules/uuid/v4.js"(exports2, module2) {
      init_define_process();
      var rng = require_rng_browser();
      var bytesToUuid = require_bytesToUuid();
      function v4(options, buf, offset) {
        var i = buf && offset || 0;
        if (typeof options == "string") {
          buf = options === "binary" ? new Array(16) : null;
          options = null;
        }
        options = options || {};
        var rnds = options.random || (options.rng || rng)();
        rnds[6] = rnds[6] & 15 | 64;
        rnds[8] = rnds[8] & 63 | 128;
        if (buf) {
          for (var ii = 0; ii < 16; ++ii) {
            buf[i + ii] = rnds[ii];
          }
        }
        return buf || bytesToUuid(rnds);
      }
      module2.exports = v4;
    }
  });

  // node_modules/short-uuid/index.js
  var require_short_uuid = __commonJS({
    "node_modules/short-uuid/index.js"(exports2, module2) {
      init_define_process();
      var anyBase = require_any_base();
      var uuidV4 = require_v4();
      var flickrBase58 = "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ";
      var cookieBase90 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%&'()*+-./:<=>?@[]^_`{|}~";
      var toFlickr;
      function shortenUUID(longId, translator) {
        return translator(longId.toLowerCase().replace(/-/g, ""));
      }
      function enlargeUUID(shortId, translator) {
        var uu1 = translator(shortId);
        var leftPad = "";
        var m;
        for (var i = 0, len = 32 - uu1.length; i < len; ++i) {
          leftPad += "0";
        }
        m = (leftPad + uu1).match(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/);
        return [m[1], m[2], m[3], m[4], m[5]].join("-");
      }
      module2.exports = function() {
        function MakeConvertor(toAlphabet) {
          var useAlphabet = toAlphabet || flickrBase58;
          var fromHex = anyBase(anyBase.HEX, useAlphabet);
          var toHex = anyBase(useAlphabet, anyBase.HEX);
          var generate4 = function() {
            return shortenUUID(uuidV4(), fromHex);
          };
          return {
            new: generate4,
            generate: generate4,
            uuid: uuidV4,
            fromUUID: function(uuid) {
              return shortenUUID(uuid, fromHex);
            },
            toUUID: function(shortUuid) {
              return enlargeUUID(shortUuid, toHex);
            },
            alphabet: useAlphabet
          };
        }
        MakeConvertor.constants = {
          flickrBase58,
          cookieBase90
        };
        MakeConvertor.uuid = uuidV4;
        MakeConvertor.generate = function() {
          if (!toFlickr) {
            toFlickr = anyBase(anyBase.HEX, flickrBase58);
          }
          return shortenUUID(uuidV4(), toFlickr);
        };
        return MakeConvertor;
      }();
    }
  });

  // ../../node_modules/util/support/isBufferBrowser.js
  var require_isBufferBrowser = __commonJS({
    "../../node_modules/util/support/isBufferBrowser.js"(exports2, module2) {
      init_define_process();
      module2.exports = function isBuffer2(arg) {
        return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
      };
    }
  });

  // ../../node_modules/util/node_modules/inherits/inherits_browser.js
  var require_inherits_browser = __commonJS({
    "../../node_modules/util/node_modules/inherits/inherits_browser.js"(exports2, module2) {
      init_define_process();
      if (typeof Object.create === "function") {
        module2.exports = function inherits(ctor, superCtor) {
          ctor.super_ = superCtor;
          ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
              value: ctor,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
        };
      } else {
        module2.exports = function inherits(ctor, superCtor) {
          ctor.super_ = superCtor;
          var TempCtor = function() {
          };
          TempCtor.prototype = superCtor.prototype;
          ctor.prototype = new TempCtor();
          ctor.prototype.constructor = ctor;
        };
      }
    }
  });

  // ../../node_modules/util/util.js
  var require_util = __commonJS({
    "../../node_modules/util/util.js"(exports2) {
      init_define_process();
      var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors2(obj) {
        var keys2 = Object.keys(obj);
        var descriptors = {};
        for (var i = 0; i < keys2.length; i++) {
          descriptors[keys2[i]] = Object.getOwnPropertyDescriptor(obj, keys2[i]);
        }
        return descriptors;
      };
      var formatRegExp = /%[sdj%]/g;
      exports2.format = function(f) {
        if (!isString2(f)) {
          var objects = [];
          for (var i = 0; i < arguments.length; i++) {
            objects.push(inspect(arguments[i]));
          }
          return objects.join(" ");
        }
        var i = 1;
        var args = arguments;
        var len = args.length;
        var str = String(f).replace(formatRegExp, function(x2) {
          if (x2 === "%%")
            return "%";
          if (i >= len)
            return x2;
          switch (x2) {
            case "%s":
              return String(args[i++]);
            case "%d":
              return Number(args[i++]);
            case "%j":
              try {
                return JSON.stringify(args[i++]);
              } catch (_) {
                return "[Circular]";
              }
            default:
              return x2;
          }
        });
        for (var x = args[i]; i < len; x = args[++i]) {
          if (isNull2(x) || !isObject2(x)) {
            str += " " + x;
          } else {
            str += " " + inspect(x);
          }
        }
        return str;
      };
      exports2.deprecate = function(fn, msg) {
        if (typeof define_process_default !== "undefined" && define_process_default.noDeprecation === true) {
          return fn;
        }
        if (typeof define_process_default === "undefined") {
          return function() {
            return exports2.deprecate(fn, msg).apply(this, arguments);
          };
        }
        var warned = false;
        function deprecated() {
          if (!warned) {
            if (define_process_default.throwDeprecation) {
              throw new Error(msg);
            } else if (define_process_default.traceDeprecation) {
              console.trace(msg);
            } else {
              console.error(msg);
            }
            warned = true;
          }
          return fn.apply(this, arguments);
        }
        return deprecated;
      };
      var debugs = {};
      var debugEnviron;
      exports2.debuglog = function(set2) {
        if (isUndefined2(debugEnviron))
          debugEnviron = define_process_default.env.NODE_DEBUG || "";
        set2 = set2.toUpperCase();
        if (!debugs[set2]) {
          if (new RegExp("\\b" + set2 + "\\b", "i").test(debugEnviron)) {
            var pid = define_process_default.pid;
            debugs[set2] = function() {
              var msg = exports2.format.apply(exports2, arguments);
              console.error("%s %d: %s", set2, pid, msg);
            };
          } else {
            debugs[set2] = function() {
            };
          }
        }
        return debugs[set2];
      };
      function inspect(obj, opts) {
        var ctx = {
          seen: [],
          stylize: stylizeNoColor
        };
        if (arguments.length >= 3)
          ctx.depth = arguments[2];
        if (arguments.length >= 4)
          ctx.colors = arguments[3];
        if (isBoolean2(opts)) {
          ctx.showHidden = opts;
        } else if (opts) {
          exports2._extend(ctx, opts);
        }
        if (isUndefined2(ctx.showHidden))
          ctx.showHidden = false;
        if (isUndefined2(ctx.depth))
          ctx.depth = 2;
        if (isUndefined2(ctx.colors))
          ctx.colors = false;
        if (isUndefined2(ctx.customInspect))
          ctx.customInspect = true;
        if (ctx.colors)
          ctx.stylize = stylizeWithColor;
        return formatValue(ctx, obj, ctx.depth);
      }
      exports2.inspect = inspect;
      inspect.colors = {
        "bold": [1, 22],
        "italic": [3, 23],
        "underline": [4, 24],
        "inverse": [7, 27],
        "white": [37, 39],
        "grey": [90, 39],
        "black": [30, 39],
        "blue": [34, 39],
        "cyan": [36, 39],
        "green": [32, 39],
        "magenta": [35, 39],
        "red": [31, 39],
        "yellow": [33, 39]
      };
      inspect.styles = {
        "special": "cyan",
        "number": "yellow",
        "boolean": "yellow",
        "undefined": "grey",
        "null": "bold",
        "string": "green",
        "date": "magenta",
        "regexp": "red"
      };
      function stylizeWithColor(str, styleType) {
        var style = inspect.styles[styleType];
        if (style) {
          return "\x1B[" + inspect.colors[style][0] + "m" + str + "\x1B[" + inspect.colors[style][1] + "m";
        } else {
          return str;
        }
      }
      function stylizeNoColor(str, styleType) {
        return str;
      }
      function arrayToHash(array) {
        var hash = {};
        array.forEach(function(val, idx) {
          hash[val] = true;
        });
        return hash;
      }
      function formatValue(ctx, value, recurseTimes) {
        if (ctx.customInspect && value && isFunction2(value.inspect) && value.inspect !== exports2.inspect && !(value.constructor && value.constructor.prototype === value)) {
          var ret = value.inspect(recurseTimes, ctx);
          if (!isString2(ret)) {
            ret = formatValue(ctx, ret, recurseTimes);
          }
          return ret;
        }
        var primitive = formatPrimitive(ctx, value);
        if (primitive) {
          return primitive;
        }
        var keys2 = Object.keys(value);
        var visibleKeys = arrayToHash(keys2);
        if (ctx.showHidden) {
          keys2 = Object.getOwnPropertyNames(value);
        }
        if (isError2(value) && (keys2.indexOf("message") >= 0 || keys2.indexOf("description") >= 0)) {
          return formatError(value);
        }
        if (keys2.length === 0) {
          if (isFunction2(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
          }
          if (isRegExp2(value)) {
            return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
          }
          if (isDate2(value)) {
            return ctx.stylize(Date.prototype.toString.call(value), "date");
          }
          if (isError2(value)) {
            return formatError(value);
          }
        }
        var base = "", array = false, braces = ["{", "}"];
        if (isArray2(value)) {
          array = true;
          braces = ["[", "]"];
        }
        if (isFunction2(value)) {
          var n = value.name ? ": " + value.name : "";
          base = " [Function" + n + "]";
        }
        if (isRegExp2(value)) {
          base = " " + RegExp.prototype.toString.call(value);
        }
        if (isDate2(value)) {
          base = " " + Date.prototype.toUTCString.call(value);
        }
        if (isError2(value)) {
          base = " " + formatError(value);
        }
        if (keys2.length === 0 && (!array || value.length == 0)) {
          return braces[0] + base + braces[1];
        }
        if (recurseTimes < 0) {
          if (isRegExp2(value)) {
            return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
          } else {
            return ctx.stylize("[Object]", "special");
          }
        }
        ctx.seen.push(value);
        var output;
        if (array) {
          output = formatArray(ctx, value, recurseTimes, visibleKeys, keys2);
        } else {
          output = keys2.map(function(key) {
            return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
          });
        }
        ctx.seen.pop();
        return reduceToSingleString(output, base, braces);
      }
      function formatPrimitive(ctx, value) {
        if (isUndefined2(value))
          return ctx.stylize("undefined", "undefined");
        if (isString2(value)) {
          var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return ctx.stylize(simple, "string");
        }
        if (isNumber2(value))
          return ctx.stylize("" + value, "number");
        if (isBoolean2(value))
          return ctx.stylize("" + value, "boolean");
        if (isNull2(value))
          return ctx.stylize("null", "null");
      }
      function formatError(value) {
        return "[" + Error.prototype.toString.call(value) + "]";
      }
      function formatArray(ctx, value, recurseTimes, visibleKeys, keys2) {
        var output = [];
        for (var i = 0, l = value.length; i < l; ++i) {
          if (hasOwnProperty26(value, String(i))) {
            output.push(formatProperty(
              ctx,
              value,
              recurseTimes,
              visibleKeys,
              String(i),
              true
            ));
          } else {
            output.push("");
          }
        }
        keys2.forEach(function(key) {
          if (!key.match(/^\d+$/)) {
            output.push(formatProperty(
              ctx,
              value,
              recurseTimes,
              visibleKeys,
              key,
              true
            ));
          }
        });
        return output;
      }
      function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
        var name, str, desc;
        desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
        if (desc.get) {
          if (desc.set) {
            str = ctx.stylize("[Getter/Setter]", "special");
          } else {
            str = ctx.stylize("[Getter]", "special");
          }
        } else {
          if (desc.set) {
            str = ctx.stylize("[Setter]", "special");
          }
        }
        if (!hasOwnProperty26(visibleKeys, key)) {
          name = "[" + key + "]";
        }
        if (!str) {
          if (ctx.seen.indexOf(desc.value) < 0) {
            if (isNull2(recurseTimes)) {
              str = formatValue(ctx, desc.value, null);
            } else {
              str = formatValue(ctx, desc.value, recurseTimes - 1);
            }
            if (str.indexOf("\n") > -1) {
              if (array) {
                str = str.split("\n").map(function(line) {
                  return "  " + line;
                }).join("\n").substr(2);
              } else {
                str = "\n" + str.split("\n").map(function(line) {
                  return "   " + line;
                }).join("\n");
              }
            }
          } else {
            str = ctx.stylize("[Circular]", "special");
          }
        }
        if (isUndefined2(name)) {
          if (array && key.match(/^\d+$/)) {
            return str;
          }
          name = JSON.stringify("" + key);
          if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, "name");
          } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
          }
        }
        return name + ": " + str;
      }
      function reduceToSingleString(output, base, braces) {
        var numLinesEst = 0;
        var length = output.reduce(function(prev, cur) {
          numLinesEst++;
          if (cur.indexOf("\n") >= 0)
            numLinesEst++;
          return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0);
        if (length > 60) {
          return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
        }
        return braces[0] + base + " " + output.join(", ") + " " + braces[1];
      }
      function isArray2(ar) {
        return Array.isArray(ar);
      }
      exports2.isArray = isArray2;
      function isBoolean2(arg) {
        return typeof arg === "boolean";
      }
      exports2.isBoolean = isBoolean2;
      function isNull2(arg) {
        return arg === null;
      }
      exports2.isNull = isNull2;
      function isNullOrUndefined(arg) {
        return arg == null;
      }
      exports2.isNullOrUndefined = isNullOrUndefined;
      function isNumber2(arg) {
        return typeof arg === "number";
      }
      exports2.isNumber = isNumber2;
      function isString2(arg) {
        return typeof arg === "string";
      }
      exports2.isString = isString2;
      function isSymbol2(arg) {
        return typeof arg === "symbol";
      }
      exports2.isSymbol = isSymbol2;
      function isUndefined2(arg) {
        return arg === void 0;
      }
      exports2.isUndefined = isUndefined2;
      function isRegExp2(re) {
        return isObject2(re) && objectToString2(re) === "[object RegExp]";
      }
      exports2.isRegExp = isRegExp2;
      function isObject2(arg) {
        return typeof arg === "object" && arg !== null;
      }
      exports2.isObject = isObject2;
      function isDate2(d) {
        return isObject2(d) && objectToString2(d) === "[object Date]";
      }
      exports2.isDate = isDate2;
      function isError2(e) {
        return isObject2(e) && (objectToString2(e) === "[object Error]" || e instanceof Error);
      }
      exports2.isError = isError2;
      function isFunction2(arg) {
        return typeof arg === "function";
      }
      exports2.isFunction = isFunction2;
      function isPrimitive(arg) {
        return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || typeof arg === "undefined";
      }
      exports2.isPrimitive = isPrimitive;
      exports2.isBuffer = require_isBufferBrowser();
      function objectToString2(o) {
        return Object.prototype.toString.call(o);
      }
      function pad2(n) {
        return n < 10 ? "0" + n.toString(10) : n.toString(10);
      }
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      function timestamp() {
        var d = new Date();
        var time = [
          pad2(d.getHours()),
          pad2(d.getMinutes()),
          pad2(d.getSeconds())
        ].join(":");
        return [d.getDate(), months[d.getMonth()], time].join(" ");
      }
      exports2.log = function() {
        console.log("%s - %s", timestamp(), exports2.format.apply(exports2, arguments));
      };
      exports2.inherits = require_inherits_browser();
      exports2._extend = function(origin, add2) {
        if (!add2 || !isObject2(add2))
          return origin;
        var keys2 = Object.keys(add2);
        var i = keys2.length;
        while (i--) {
          origin[keys2[i]] = add2[keys2[i]];
        }
        return origin;
      };
      function hasOwnProperty26(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
      }
      var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : void 0;
      exports2.promisify = function promisify(original) {
        if (typeof original !== "function")
          throw new TypeError('The "original" argument must be of type Function');
        if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
          var fn = original[kCustomPromisifiedSymbol];
          if (typeof fn !== "function") {
            throw new TypeError('The "util.promisify.custom" argument must be of type Function');
          }
          Object.defineProperty(fn, kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
          });
          return fn;
        }
        function fn() {
          var promiseResolve, promiseReject;
          var promise = new Promise(function(resolve, reject2) {
            promiseResolve = resolve;
            promiseReject = reject2;
          });
          var args = [];
          for (var i = 0; i < arguments.length; i++) {
            args.push(arguments[i]);
          }
          args.push(function(err, value) {
            if (err) {
              promiseReject(err);
            } else {
              promiseResolve(value);
            }
          });
          try {
            original.apply(this, args);
          } catch (err) {
            promiseReject(err);
          }
          return promise;
        }
        Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
        if (kCustomPromisifiedSymbol)
          Object.defineProperty(fn, kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
          });
        return Object.defineProperties(
          fn,
          getOwnPropertyDescriptors(original)
        );
      };
      exports2.promisify.custom = kCustomPromisifiedSymbol;
      function callbackifyOnRejected(reason, cb) {
        if (!reason) {
          var newReason = new Error("Promise was rejected with a falsy value");
          newReason.reason = reason;
          reason = newReason;
        }
        return cb(reason);
      }
      function callbackify(original) {
        if (typeof original !== "function") {
          throw new TypeError('The "original" argument must be of type Function');
        }
        function callbackified() {
          var args = [];
          for (var i = 0; i < arguments.length; i++) {
            args.push(arguments[i]);
          }
          var maybeCb = args.pop();
          if (typeof maybeCb !== "function") {
            throw new TypeError("The last argument must be of type Function");
          }
          var self2 = this;
          var cb = function() {
            return maybeCb.apply(self2, arguments);
          };
          original.apply(this, args).then(
            function(ret) {
              define_process_default.nextTick(cb, null, ret);
            },
            function(rej) {
              define_process_default.nextTick(callbackifyOnRejected, rej, cb);
            }
          );
        }
        Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
        Object.defineProperties(
          callbackified,
          getOwnPropertyDescriptors(original)
        );
        return callbackified;
      }
      exports2.callbackify = callbackify;
    }
  });

  // node_modules/ret/lib/types.js
  var require_types = __commonJS({
    "node_modules/ret/lib/types.js"(exports2, module2) {
      init_define_process();
      module2.exports = {
        ROOT: 0,
        GROUP: 1,
        POSITION: 2,
        SET: 3,
        RANGE: 4,
        REPETITION: 5,
        REFERENCE: 6,
        CHAR: 7
      };
    }
  });

  // node_modules/ret/lib/sets.js
  var require_sets = __commonJS({
    "node_modules/ret/lib/sets.js"(exports2) {
      init_define_process();
      var types = require_types();
      var INTS = function() {
        return [{ type: types.RANGE, from: 48, to: 57 }];
      };
      var WORDS = function() {
        return [
          { type: types.CHAR, value: 95 },
          { type: types.RANGE, from: 97, to: 122 },
          { type: types.RANGE, from: 65, to: 90 }
        ].concat(INTS());
      };
      var WHITESPACE = function() {
        return [
          { type: types.CHAR, value: 9 },
          { type: types.CHAR, value: 10 },
          { type: types.CHAR, value: 11 },
          { type: types.CHAR, value: 12 },
          { type: types.CHAR, value: 13 },
          { type: types.CHAR, value: 32 },
          { type: types.CHAR, value: 160 },
          { type: types.CHAR, value: 5760 },
          { type: types.CHAR, value: 6158 },
          { type: types.CHAR, value: 8192 },
          { type: types.CHAR, value: 8193 },
          { type: types.CHAR, value: 8194 },
          { type: types.CHAR, value: 8195 },
          { type: types.CHAR, value: 8196 },
          { type: types.CHAR, value: 8197 },
          { type: types.CHAR, value: 8198 },
          { type: types.CHAR, value: 8199 },
          { type: types.CHAR, value: 8200 },
          { type: types.CHAR, value: 8201 },
          { type: types.CHAR, value: 8202 },
          { type: types.CHAR, value: 8232 },
          { type: types.CHAR, value: 8233 },
          { type: types.CHAR, value: 8239 },
          { type: types.CHAR, value: 8287 },
          { type: types.CHAR, value: 12288 },
          { type: types.CHAR, value: 65279 }
        ];
      };
      var NOTANYCHAR = function() {
        return [
          { type: types.CHAR, value: 10 },
          { type: types.CHAR, value: 13 },
          { type: types.CHAR, value: 8232 },
          { type: types.CHAR, value: 8233 }
        ];
      };
      exports2.words = function() {
        return { type: types.SET, set: WORDS(), not: false };
      };
      exports2.notWords = function() {
        return { type: types.SET, set: WORDS(), not: true };
      };
      exports2.ints = function() {
        return { type: types.SET, set: INTS(), not: false };
      };
      exports2.notInts = function() {
        return { type: types.SET, set: INTS(), not: true };
      };
      exports2.whitespace = function() {
        return { type: types.SET, set: WHITESPACE(), not: false };
      };
      exports2.notWhitespace = function() {
        return { type: types.SET, set: WHITESPACE(), not: true };
      };
      exports2.anyChar = function() {
        return { type: types.SET, set: NOTANYCHAR(), not: true };
      };
    }
  });

  // node_modules/ret/lib/util.js
  var require_util2 = __commonJS({
    "node_modules/ret/lib/util.js"(exports2) {
      init_define_process();
      var types = require_types();
      var sets = require_sets();
      var CTRL = "@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^ ?";
      var SLSH = { "0": 0, "t": 9, "n": 10, "v": 11, "f": 12, "r": 13 };
      exports2.strToChars = function(str) {
        var chars_regex = /(\[\\b\])|(\\)?\\(?:u([A-F0-9]{4})|x([A-F0-9]{2})|(0?[0-7]{2})|c([@A-Z\[\\\]\^?])|([0tnvfr]))/g;
        str = str.replace(chars_regex, function(s, b, lbs, a16, b16, c8, dctrl, eslsh) {
          if (lbs) {
            return s;
          }
          var code = b ? 8 : a16 ? parseInt(a16, 16) : b16 ? parseInt(b16, 16) : c8 ? parseInt(c8, 8) : dctrl ? CTRL.indexOf(dctrl) : SLSH[eslsh];
          var c = String.fromCharCode(code);
          if (/[\[\]{}\^$.|?*+()]/.test(c)) {
            c = "\\" + c;
          }
          return c;
        });
        return str;
      };
      exports2.tokenizeClass = function(str, regexpStr) {
        var tokens = [];
        var regexp = /\\(?:(w)|(d)|(s)|(W)|(D)|(S))|((?:(?:\\)(.)|([^\]\\]))-(?:\\)?([^\]]))|(\])|(?:\\)?(.)/g;
        var rs, c;
        while ((rs = regexp.exec(str)) != null) {
          if (rs[1]) {
            tokens.push(sets.words());
          } else if (rs[2]) {
            tokens.push(sets.ints());
          } else if (rs[3]) {
            tokens.push(sets.whitespace());
          } else if (rs[4]) {
            tokens.push(sets.notWords());
          } else if (rs[5]) {
            tokens.push(sets.notInts());
          } else if (rs[6]) {
            tokens.push(sets.notWhitespace());
          } else if (rs[7]) {
            tokens.push({
              type: types.RANGE,
              from: (rs[8] || rs[9]).charCodeAt(0),
              to: rs[10].charCodeAt(0)
            });
          } else if (c = rs[12]) {
            tokens.push({
              type: types.CHAR,
              value: c.charCodeAt(0)
            });
          } else {
            return [tokens, regexp.lastIndex];
          }
        }
        exports2.error(regexpStr, "Unterminated character class");
      };
      exports2.error = function(regexp, msg) {
        throw new SyntaxError("Invalid regular expression: /" + regexp + "/: " + msg);
      };
    }
  });

  // node_modules/ret/lib/positions.js
  var require_positions = __commonJS({
    "node_modules/ret/lib/positions.js"(exports2) {
      init_define_process();
      var types = require_types();
      exports2.wordBoundary = function() {
        return { type: types.POSITION, value: "b" };
      };
      exports2.nonWordBoundary = function() {
        return { type: types.POSITION, value: "B" };
      };
      exports2.begin = function() {
        return { type: types.POSITION, value: "^" };
      };
      exports2.end = function() {
        return { type: types.POSITION, value: "$" };
      };
    }
  });

  // node_modules/ret/lib/index.js
  var require_lib = __commonJS({
    "node_modules/ret/lib/index.js"(exports2, module2) {
      init_define_process();
      var util = require_util2();
      var types = require_types();
      var sets = require_sets();
      var positions = require_positions();
      module2.exports = function(regexpStr) {
        var i = 0, l, c, start = { type: types.ROOT, stack: [] }, lastGroup = start, last2 = start.stack, groupStack = [];
        var repeatErr = function(i2) {
          util.error(regexpStr, "Nothing to repeat at column " + (i2 - 1));
        };
        var str = util.strToChars(regexpStr);
        l = str.length;
        while (i < l) {
          c = str[i++];
          switch (c) {
            case "\\":
              c = str[i++];
              switch (c) {
                case "b":
                  last2.push(positions.wordBoundary());
                  break;
                case "B":
                  last2.push(positions.nonWordBoundary());
                  break;
                case "w":
                  last2.push(sets.words());
                  break;
                case "W":
                  last2.push(sets.notWords());
                  break;
                case "d":
                  last2.push(sets.ints());
                  break;
                case "D":
                  last2.push(sets.notInts());
                  break;
                case "s":
                  last2.push(sets.whitespace());
                  break;
                case "S":
                  last2.push(sets.notWhitespace());
                  break;
                default:
                  if (/\d/.test(c)) {
                    last2.push({ type: types.REFERENCE, value: parseInt(c, 10) });
                  } else {
                    last2.push({ type: types.CHAR, value: c.charCodeAt(0) });
                  }
              }
              break;
            case "^":
              last2.push(positions.begin());
              break;
            case "$":
              last2.push(positions.end());
              break;
            case "[":
              var not;
              if (str[i] === "^") {
                not = true;
                i++;
              } else {
                not = false;
              }
              var classTokens = util.tokenizeClass(str.slice(i), regexpStr);
              i += classTokens[1];
              last2.push({
                type: types.SET,
                set: classTokens[0],
                not
              });
              break;
            case ".":
              last2.push(sets.anyChar());
              break;
            case "(":
              var group = {
                type: types.GROUP,
                stack: [],
                remember: true
              };
              c = str[i];
              if (c === "?") {
                c = str[i + 1];
                i += 2;
                if (c === "=") {
                  group.followedBy = true;
                } else if (c === "!") {
                  group.notFollowedBy = true;
                } else if (c !== ":") {
                  util.error(
                    regexpStr,
                    "Invalid group, character '" + c + "' after '?' at column " + (i - 1)
                  );
                }
                group.remember = false;
              }
              last2.push(group);
              groupStack.push(lastGroup);
              lastGroup = group;
              last2 = group.stack;
              break;
            case ")":
              if (groupStack.length === 0) {
                util.error(regexpStr, "Unmatched ) at column " + (i - 1));
              }
              lastGroup = groupStack.pop();
              last2 = lastGroup.options ? lastGroup.options[lastGroup.options.length - 1] : lastGroup.stack;
              break;
            case "|":
              if (!lastGroup.options) {
                lastGroup.options = [lastGroup.stack];
                delete lastGroup.stack;
              }
              var stack = [];
              lastGroup.options.push(stack);
              last2 = stack;
              break;
            case "{":
              var rs = /^(\d+)(,(\d+)?)?\}/.exec(str.slice(i)), min2, max2;
              if (rs !== null) {
                if (last2.length === 0) {
                  repeatErr(i);
                }
                min2 = parseInt(rs[1], 10);
                max2 = rs[2] ? rs[3] ? parseInt(rs[3], 10) : Infinity : min2;
                i += rs[0].length;
                last2.push({
                  type: types.REPETITION,
                  min: min2,
                  max: max2,
                  value: last2.pop()
                });
              } else {
                last2.push({
                  type: types.CHAR,
                  value: 123
                });
              }
              break;
            case "?":
              if (last2.length === 0) {
                repeatErr(i);
              }
              last2.push({
                type: types.REPETITION,
                min: 0,
                max: 1,
                value: last2.pop()
              });
              break;
            case "+":
              if (last2.length === 0) {
                repeatErr(i);
              }
              last2.push({
                type: types.REPETITION,
                min: 1,
                max: Infinity,
                value: last2.pop()
              });
              break;
            case "*":
              if (last2.length === 0) {
                repeatErr(i);
              }
              last2.push({
                type: types.REPETITION,
                min: 0,
                max: Infinity,
                value: last2.pop()
              });
              break;
            default:
              last2.push({
                type: types.CHAR,
                value: c.charCodeAt(0)
              });
          }
        }
        if (groupStack.length !== 0) {
          util.error(regexpStr, "Unterminated group");
        }
        return start;
      };
      module2.exports.types = types;
    }
  });

  // node_modules/safe-regex/index.js
  var require_safe_regex = __commonJS({
    "node_modules/safe-regex/index.js"(exports2, module2) {
      init_define_process();
      var parse3 = require_lib();
      var types = parse3.types;
      module2.exports = function(re, opts) {
        if (!opts)
          opts = {};
        var replimit = opts.limit === void 0 ? 25 : opts.limit;
        if (isRegExp2(re))
          re = re.source;
        else if (typeof re !== "string")
          re = String(re);
        try {
          re = parse3(re);
        } catch (err) {
          return false;
        }
        var reps = 0;
        return function walk(node, starHeight) {
          if (node.type === types.REPETITION) {
            starHeight++;
            reps++;
            if (starHeight > 1)
              return false;
            if (reps > replimit)
              return false;
          }
          if (node.options) {
            for (var i = 0, len = node.options.length; i < len; i++) {
              var ok = walk({ stack: node.options[i] }, starHeight);
              if (!ok)
                return false;
            }
          }
          var stack = node.stack || node.value && node.value.stack;
          if (!stack)
            return true;
          for (var i = 0; i < stack.length; i++) {
            var ok = walk(stack[i], starHeight);
            if (!ok)
              return false;
          }
          return true;
        }(re, 0);
      };
      function isRegExp2(x) {
        return {}.toString.call(x) === "[object RegExp]";
      }
    }
  });

  // node_modules/isobject/index.js
  var require_isobject = __commonJS({
    "node_modules/isobject/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function isObject2(val) {
        return val != null && typeof val === "object" && Array.isArray(val) === false;
      };
    }
  });

  // node_modules/is-descriptor/node_modules/kind-of/index.js
  var require_kind_of = __commonJS({
    "node_modules/is-descriptor/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (val === void 0)
          return "undefined";
        if (val === null)
          return "null";
        var type = typeof val;
        if (type === "boolean")
          return "boolean";
        if (type === "string")
          return "string";
        if (type === "number")
          return "number";
        if (type === "symbol")
          return "symbol";
        if (type === "function") {
          return isGeneratorFn(val) ? "generatorfunction" : "function";
        }
        if (isArray2(val))
          return "array";
        if (isBuffer2(val))
          return "buffer";
        if (isArguments2(val))
          return "arguments";
        if (isDate2(val))
          return "date";
        if (isError2(val))
          return "error";
        if (isRegexp(val))
          return "regexp";
        switch (ctorName(val)) {
          case "Symbol":
            return "symbol";
          case "Promise":
            return "promise";
          case "WeakMap":
            return "weakmap";
          case "WeakSet":
            return "weakset";
          case "Map":
            return "map";
          case "Set":
            return "set";
          case "Int8Array":
            return "int8array";
          case "Uint8Array":
            return "uint8array";
          case "Uint8ClampedArray":
            return "uint8clampedarray";
          case "Int16Array":
            return "int16array";
          case "Uint16Array":
            return "uint16array";
          case "Int32Array":
            return "int32array";
          case "Uint32Array":
            return "uint32array";
          case "Float32Array":
            return "float32array";
          case "Float64Array":
            return "float64array";
        }
        if (isGeneratorObj(val)) {
          return "generator";
        }
        type = toString2.call(val);
        switch (type) {
          case "[object Object]":
            return "object";
          case "[object Map Iterator]":
            return "mapiterator";
          case "[object Set Iterator]":
            return "setiterator";
          case "[object String Iterator]":
            return "stringiterator";
          case "[object Array Iterator]":
            return "arrayiterator";
        }
        return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
      };
      function ctorName(val) {
        return typeof val.constructor === "function" ? val.constructor.name : null;
      }
      function isArray2(val) {
        if (Array.isArray)
          return Array.isArray(val);
        return val instanceof Array;
      }
      function isError2(val) {
        return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
      }
      function isDate2(val) {
        if (val instanceof Date)
          return true;
        return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
      }
      function isRegexp(val) {
        if (val instanceof RegExp)
          return true;
        return typeof val.flags === "string" && typeof val.ignoreCase === "boolean" && typeof val.multiline === "boolean" && typeof val.global === "boolean";
      }
      function isGeneratorFn(name, val) {
        return ctorName(name) === "GeneratorFunction";
      }
      function isGeneratorObj(val) {
        return typeof val.throw === "function" && typeof val.return === "function" && typeof val.next === "function";
      }
      function isArguments2(val) {
        try {
          if (typeof val.length === "number" && typeof val.callee === "function") {
            return true;
          }
        } catch (err) {
          if (err.message.indexOf("callee") !== -1) {
            return true;
          }
        }
        return false;
      }
      function isBuffer2(val) {
        if (val.constructor && typeof val.constructor.isBuffer === "function") {
          return val.constructor.isBuffer(val);
        }
        return false;
      }
    }
  });

  // node_modules/is-accessor-descriptor/node_modules/kind-of/index.js
  var require_kind_of2 = __commonJS({
    "node_modules/is-accessor-descriptor/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (val === void 0)
          return "undefined";
        if (val === null)
          return "null";
        var type = typeof val;
        if (type === "boolean")
          return "boolean";
        if (type === "string")
          return "string";
        if (type === "number")
          return "number";
        if (type === "symbol")
          return "symbol";
        if (type === "function") {
          return isGeneratorFn(val) ? "generatorfunction" : "function";
        }
        if (isArray2(val))
          return "array";
        if (isBuffer2(val))
          return "buffer";
        if (isArguments2(val))
          return "arguments";
        if (isDate2(val))
          return "date";
        if (isError2(val))
          return "error";
        if (isRegexp(val))
          return "regexp";
        switch (ctorName(val)) {
          case "Symbol":
            return "symbol";
          case "Promise":
            return "promise";
          case "WeakMap":
            return "weakmap";
          case "WeakSet":
            return "weakset";
          case "Map":
            return "map";
          case "Set":
            return "set";
          case "Int8Array":
            return "int8array";
          case "Uint8Array":
            return "uint8array";
          case "Uint8ClampedArray":
            return "uint8clampedarray";
          case "Int16Array":
            return "int16array";
          case "Uint16Array":
            return "uint16array";
          case "Int32Array":
            return "int32array";
          case "Uint32Array":
            return "uint32array";
          case "Float32Array":
            return "float32array";
          case "Float64Array":
            return "float64array";
        }
        if (isGeneratorObj(val)) {
          return "generator";
        }
        type = toString2.call(val);
        switch (type) {
          case "[object Object]":
            return "object";
          case "[object Map Iterator]":
            return "mapiterator";
          case "[object Set Iterator]":
            return "setiterator";
          case "[object String Iterator]":
            return "stringiterator";
          case "[object Array Iterator]":
            return "arrayiterator";
        }
        return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
      };
      function ctorName(val) {
        return typeof val.constructor === "function" ? val.constructor.name : null;
      }
      function isArray2(val) {
        if (Array.isArray)
          return Array.isArray(val);
        return val instanceof Array;
      }
      function isError2(val) {
        return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
      }
      function isDate2(val) {
        if (val instanceof Date)
          return true;
        return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
      }
      function isRegexp(val) {
        if (val instanceof RegExp)
          return true;
        return typeof val.flags === "string" && typeof val.ignoreCase === "boolean" && typeof val.multiline === "boolean" && typeof val.global === "boolean";
      }
      function isGeneratorFn(name, val) {
        return ctorName(name) === "GeneratorFunction";
      }
      function isGeneratorObj(val) {
        return typeof val.throw === "function" && typeof val.return === "function" && typeof val.next === "function";
      }
      function isArguments2(val) {
        try {
          if (typeof val.length === "number" && typeof val.callee === "function") {
            return true;
          }
        } catch (err) {
          if (err.message.indexOf("callee") !== -1) {
            return true;
          }
        }
        return false;
      }
      function isBuffer2(val) {
        if (val.constructor && typeof val.constructor.isBuffer === "function") {
          return val.constructor.isBuffer(val);
        }
        return false;
      }
    }
  });

  // node_modules/is-accessor-descriptor/index.js
  var require_is_accessor_descriptor = __commonJS({
    "node_modules/is-accessor-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of2();
      var accessor = {
        get: "function",
        set: "function",
        configurable: "boolean",
        enumerable: "boolean"
      };
      function isAccessorDescriptor(obj, prop) {
        if (typeof prop === "string") {
          var val = Object.getOwnPropertyDescriptor(obj, prop);
          return typeof val !== "undefined";
        }
        if (typeOf(obj) !== "object") {
          return false;
        }
        if (has2(obj, "value") || has2(obj, "writable")) {
          return false;
        }
        if (!has2(obj, "get") || typeof obj.get !== "function") {
          return false;
        }
        if (has2(obj, "set") && typeof obj[key] !== "function" && typeof obj[key] !== "undefined") {
          return false;
        }
        for (var key in obj) {
          if (!accessor.hasOwnProperty(key)) {
            continue;
          }
          if (typeOf(obj[key]) === accessor[key]) {
            continue;
          }
          if (typeof obj[key] !== "undefined") {
            return false;
          }
        }
        return true;
      }
      function has2(obj, key) {
        return {}.hasOwnProperty.call(obj, key);
      }
      module2.exports = isAccessorDescriptor;
    }
  });

  // node_modules/is-data-descriptor/node_modules/kind-of/index.js
  var require_kind_of3 = __commonJS({
    "node_modules/is-data-descriptor/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (val === void 0)
          return "undefined";
        if (val === null)
          return "null";
        var type = typeof val;
        if (type === "boolean")
          return "boolean";
        if (type === "string")
          return "string";
        if (type === "number")
          return "number";
        if (type === "symbol")
          return "symbol";
        if (type === "function") {
          return isGeneratorFn(val) ? "generatorfunction" : "function";
        }
        if (isArray2(val))
          return "array";
        if (isBuffer2(val))
          return "buffer";
        if (isArguments2(val))
          return "arguments";
        if (isDate2(val))
          return "date";
        if (isError2(val))
          return "error";
        if (isRegexp(val))
          return "regexp";
        switch (ctorName(val)) {
          case "Symbol":
            return "symbol";
          case "Promise":
            return "promise";
          case "WeakMap":
            return "weakmap";
          case "WeakSet":
            return "weakset";
          case "Map":
            return "map";
          case "Set":
            return "set";
          case "Int8Array":
            return "int8array";
          case "Uint8Array":
            return "uint8array";
          case "Uint8ClampedArray":
            return "uint8clampedarray";
          case "Int16Array":
            return "int16array";
          case "Uint16Array":
            return "uint16array";
          case "Int32Array":
            return "int32array";
          case "Uint32Array":
            return "uint32array";
          case "Float32Array":
            return "float32array";
          case "Float64Array":
            return "float64array";
        }
        if (isGeneratorObj(val)) {
          return "generator";
        }
        type = toString2.call(val);
        switch (type) {
          case "[object Object]":
            return "object";
          case "[object Map Iterator]":
            return "mapiterator";
          case "[object Set Iterator]":
            return "setiterator";
          case "[object String Iterator]":
            return "stringiterator";
          case "[object Array Iterator]":
            return "arrayiterator";
        }
        return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
      };
      function ctorName(val) {
        return typeof val.constructor === "function" ? val.constructor.name : null;
      }
      function isArray2(val) {
        if (Array.isArray)
          return Array.isArray(val);
        return val instanceof Array;
      }
      function isError2(val) {
        return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
      }
      function isDate2(val) {
        if (val instanceof Date)
          return true;
        return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
      }
      function isRegexp(val) {
        if (val instanceof RegExp)
          return true;
        return typeof val.flags === "string" && typeof val.ignoreCase === "boolean" && typeof val.multiline === "boolean" && typeof val.global === "boolean";
      }
      function isGeneratorFn(name, val) {
        return ctorName(name) === "GeneratorFunction";
      }
      function isGeneratorObj(val) {
        return typeof val.throw === "function" && typeof val.return === "function" && typeof val.next === "function";
      }
      function isArguments2(val) {
        try {
          if (typeof val.length === "number" && typeof val.callee === "function") {
            return true;
          }
        } catch (err) {
          if (err.message.indexOf("callee") !== -1) {
            return true;
          }
        }
        return false;
      }
      function isBuffer2(val) {
        if (val.constructor && typeof val.constructor.isBuffer === "function") {
          return val.constructor.isBuffer(val);
        }
        return false;
      }
    }
  });

  // node_modules/is-data-descriptor/index.js
  var require_is_data_descriptor = __commonJS({
    "node_modules/is-data-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of3();
      module2.exports = function isDataDescriptor(obj, prop) {
        var data = {
          configurable: "boolean",
          enumerable: "boolean",
          writable: "boolean"
        };
        if (typeOf(obj) !== "object") {
          return false;
        }
        if (typeof prop === "string") {
          var val = Object.getOwnPropertyDescriptor(obj, prop);
          return typeof val !== "undefined";
        }
        if (!("value" in obj) && !("writable" in obj)) {
          return false;
        }
        for (var key in obj) {
          if (key === "value")
            continue;
          if (!data.hasOwnProperty(key)) {
            continue;
          }
          if (typeOf(obj[key]) === data[key]) {
            continue;
          }
          if (typeof obj[key] !== "undefined") {
            return false;
          }
        }
        return true;
      };
    }
  });

  // node_modules/is-descriptor/index.js
  var require_is_descriptor = __commonJS({
    "node_modules/is-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of();
      var isAccessor = require_is_accessor_descriptor();
      var isData = require_is_data_descriptor();
      module2.exports = function isDescriptor(obj, key) {
        if (typeOf(obj) !== "object") {
          return false;
        }
        if ("get" in obj) {
          return isAccessor(obj, key);
        }
        return isData(obj, key);
      };
    }
  });

  // node_modules/to-regex/node_modules/define-property/index.js
  var require_define_property = __commonJS({
    "node_modules/to-regex/node_modules/define-property/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isobject = require_isobject();
      var isDescriptor = require_is_descriptor();
      var define2 = typeof Reflect !== "undefined" && Reflect.defineProperty ? Reflect.defineProperty : Object.defineProperty;
      module2.exports = function defineProperty2(obj, key, val) {
        if (!isobject(obj) && typeof obj !== "function" && !Array.isArray(obj)) {
          throw new TypeError("expected an object, function, or array");
        }
        if (typeof key !== "string") {
          throw new TypeError('expected "key" to be a string');
        }
        if (isDescriptor(val)) {
          define2(obj, key, val);
          return obj;
        }
        define2(obj, key, {
          configurable: true,
          enumerable: false,
          writable: true,
          value: val
        });
        return obj;
      };
    }
  });

  // node_modules/is-plain-object/index.js
  var require_is_plain_object = __commonJS({
    "node_modules/is-plain-object/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      function isObjectObject(o) {
        return isObject2(o) === true && Object.prototype.toString.call(o) === "[object Object]";
      }
      module2.exports = function isPlainObject2(o) {
        var ctor, prot;
        if (isObjectObject(o) === false)
          return false;
        ctor = o.constructor;
        if (typeof ctor !== "function")
          return false;
        prot = ctor.prototype;
        if (isObjectObject(prot) === false)
          return false;
        if (prot.hasOwnProperty("isPrototypeOf") === false) {
          return false;
        }
        return true;
      };
    }
  });

  // node_modules/extend-shallow/node_modules/is-extendable/index.js
  var require_is_extendable = __commonJS({
    "node_modules/extend-shallow/node_modules/is-extendable/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isPlainObject2 = require_is_plain_object();
      module2.exports = function isExtendable(val) {
        return isPlainObject2(val) || typeof val === "function" || Array.isArray(val);
      };
    }
  });

  // node_modules/assign-symbols/index.js
  var require_assign_symbols = __commonJS({
    "node_modules/assign-symbols/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function(receiver, objects) {
        if (receiver === null || typeof receiver === "undefined") {
          throw new TypeError("expected first argument to be an object.");
        }
        if (typeof objects === "undefined" || typeof Symbol === "undefined") {
          return receiver;
        }
        if (typeof Object.getOwnPropertySymbols !== "function") {
          return receiver;
        }
        var isEnumerable = Object.prototype.propertyIsEnumerable;
        var target = Object(receiver);
        var len = arguments.length, i = 0;
        while (++i < len) {
          var provider = Object(arguments[i]);
          var names = Object.getOwnPropertySymbols(provider);
          for (var j = 0; j < names.length; j++) {
            var key = names[j];
            if (isEnumerable.call(provider, key)) {
              target[key] = provider[key];
            }
          }
        }
        return target;
      };
    }
  });

  // node_modules/extend-shallow/index.js
  var require_extend_shallow = __commonJS({
    "node_modules/extend-shallow/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isExtendable = require_is_extendable();
      var assignSymbols = require_assign_symbols();
      module2.exports = Object.assign || function(obj) {
        if (obj === null || typeof obj === "undefined") {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        if (!isObject2(obj)) {
          obj = {};
        }
        for (var i = 1; i < arguments.length; i++) {
          var val = arguments[i];
          if (isString2(val)) {
            val = toObject(val);
          }
          if (isObject2(val)) {
            assign2(obj, val);
            assignSymbols(obj, val);
          }
        }
        return obj;
      };
      function assign2(a, b) {
        for (var key in b) {
          if (hasOwn(b, key)) {
            a[key] = b[key];
          }
        }
      }
      function isString2(val) {
        return val && typeof val === "string";
      }
      function toObject(str) {
        var obj = {};
        for (var i in str) {
          obj[i] = str[i];
        }
        return obj;
      }
      function isObject2(val) {
        return val && typeof val === "object" || isExtendable(val);
      }
      function hasOwn(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
      }
    }
  });

  // node_modules/regex-not/index.js
  var require_regex_not = __commonJS({
    "node_modules/regex-not/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var extend = require_extend_shallow();
      var safe = require_safe_regex();
      function toRegex(pattern, options) {
        return new RegExp(toRegex.create(pattern, options));
      }
      toRegex.create = function(pattern, options) {
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        var opts = extend({}, options);
        if (opts.contains === true) {
          opts.strictNegate = false;
        }
        var open = opts.strictOpen !== false ? "^" : "";
        var close = opts.strictClose !== false ? "$" : "";
        var endChar = opts.endChar ? opts.endChar : "+";
        var str = pattern;
        if (opts.strictNegate === false) {
          str = "(?:(?!(?:" + pattern + ")).)" + endChar;
        } else {
          str = "(?:(?!^(?:" + pattern + ")$).)" + endChar;
        }
        var res = open + str + close;
        if (opts.safe === true && safe(res) === false) {
          throw new Error("potentially unsafe regular expression: " + res);
        }
        return res;
      };
      module2.exports = toRegex;
    }
  });

  // node_modules/to-regex/index.js
  var require_to_regex = __commonJS({
    "node_modules/to-regex/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var safe = require_safe_regex();
      var define2 = require_define_property();
      var extend = require_extend_shallow();
      var not = require_regex_not();
      var MAX_LENGTH = 1024 * 64;
      var cache = {};
      module2.exports = function(patterns, options) {
        if (!Array.isArray(patterns)) {
          return makeRe(patterns, options);
        }
        return makeRe(patterns.join("|"), options);
      };
      function makeRe(pattern, options) {
        if (pattern instanceof RegExp) {
          return pattern;
        }
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        if (pattern.length > MAX_LENGTH) {
          throw new Error("expected pattern to be less than " + MAX_LENGTH + " characters");
        }
        var key = pattern;
        if (!options || options && options.cache !== false) {
          key = createKey(pattern, options);
          if (cache.hasOwnProperty(key)) {
            return cache[key];
          }
        }
        var opts = extend({}, options);
        if (opts.contains === true) {
          if (opts.negate === true) {
            opts.strictNegate = false;
          } else {
            opts.strict = false;
          }
        }
        if (opts.strict === false) {
          opts.strictOpen = false;
          opts.strictClose = false;
        }
        var open = opts.strictOpen !== false ? "^" : "";
        var close = opts.strictClose !== false ? "$" : "";
        var flags = opts.flags || "";
        var regex;
        if (opts.nocase === true && !/i/.test(flags)) {
          flags += "i";
        }
        try {
          if (opts.negate || typeof opts.strictNegate === "boolean") {
            pattern = not.create(pattern, opts);
          }
          var str = open + "(?:" + pattern + ")" + close;
          regex = new RegExp(str, flags);
          if (opts.safe === true && safe(regex) === false) {
            throw new Error("potentially unsafe regular expression: " + regex.source);
          }
        } catch (err) {
          if (opts.strictErrors === true || opts.safe === true) {
            err.key = key;
            err.pattern = pattern;
            err.originalOptions = options;
            err.createdOptions = opts;
            throw err;
          }
          try {
            regex = new RegExp("^" + pattern.replace(/(\W)/g, "\\$1") + "$");
          } catch (err2) {
            regex = /.^/;
          }
        }
        if (opts.cache !== false) {
          memoize2(regex, key, pattern, opts);
        }
        return regex;
      }
      function memoize2(regex, key, pattern, options) {
        define2(regex, "cached", true);
        define2(regex, "pattern", pattern);
        define2(regex, "options", options);
        define2(regex, "key", key);
        cache[key] = regex;
      }
      function createKey(pattern, options) {
        if (!options)
          return pattern;
        var key = pattern;
        for (var prop in options) {
          if (options.hasOwnProperty(prop)) {
            key += ";" + prop + "=" + String(options[prop]);
          }
        }
        return key;
      }
      module2.exports.makeRe = makeRe;
    }
  });

  // node_modules/nanomatch/lib/compilers.js
  var require_compilers = __commonJS({
    "node_modules/nanomatch/lib/compilers.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function(nanomatch, options) {
        function slash() {
          if (options && typeof options.slash === "string") {
            return options.slash;
          }
          if (options && typeof options.slash === "function") {
            return options.slash.call(nanomatch);
          }
          return "\\\\/";
        }
        function star() {
          if (options && typeof options.star === "string") {
            return options.star;
          }
          if (options && typeof options.star === "function") {
            return options.star.call(nanomatch);
          }
          return "[^" + slash() + "]*?";
        }
        var ast = nanomatch.ast = nanomatch.parser.ast;
        ast.state = nanomatch.parser.state;
        nanomatch.compiler.state = ast.state;
        nanomatch.compiler.set("not", function(node) {
          var prev = this.prev();
          if (this.options.nonegate === true || prev.type !== "bos") {
            return this.emit("\\" + node.val, node);
          }
          return this.emit(node.val, node);
        }).set("escape", function(node) {
          if (this.options.unescape && /^[-\w_.]/.test(node.val)) {
            return this.emit(node.val, node);
          }
          return this.emit("\\" + node.val, node);
        }).set("quoted", function(node) {
          return this.emit(node.val, node);
        }).set("dollar", function(node) {
          if (node.parent.type === "bracket") {
            return this.emit(node.val, node);
          }
          return this.emit("\\" + node.val, node);
        }).set("dot", function(node) {
          if (node.dotfiles === true)
            this.dotfiles = true;
          return this.emit("\\" + node.val, node);
        }).set("backslash", function(node) {
          return this.emit(node.val, node);
        }).set("slash", function(node, nodes, i) {
          var val = "[" + slash() + "]";
          var parent2 = node.parent;
          var prev = this.prev();
          while (parent2.type === "paren" && !parent2.hasSlash) {
            parent2.hasSlash = true;
            parent2 = parent2.parent;
          }
          if (prev.addQmark) {
            val += "?";
          }
          if (node.rest.slice(0, 2) === "\\b") {
            return this.emit(val, node);
          }
          if (node.parsed === "**" || node.parsed === "./**") {
            this.output = "(?:" + this.output;
            return this.emit(val + ")?", node);
          }
          if (node.parsed === "!**" && this.options.nonegate !== true) {
            return this.emit(val + "?\\b", node);
          }
          return this.emit(val, node);
        }).set("bracket", function(node) {
          var close = node.close;
          var open = !node.escaped ? "[" : "\\[";
          var negated = node.negated;
          var inner = node.inner;
          var val = node.val;
          if (node.escaped === true) {
            inner = inner.replace(/\\?(\W)/g, "\\$1");
            negated = "";
          }
          if (inner === "]-") {
            inner = "\\]\\-";
          }
          if (negated && inner.indexOf(".") === -1) {
            inner += ".";
          }
          if (negated && inner.indexOf("/") === -1) {
            inner += "/";
          }
          val = open + negated + inner + close;
          return this.emit(val, node);
        }).set("square", function(node) {
          var val = (/^\W/.test(node.val) ? "\\" : "") + node.val;
          return this.emit(val, node);
        }).set("qmark", function(node) {
          var prev = this.prev();
          var val = "[^.\\\\/]";
          if (this.options.dot || prev.type !== "bos" && prev.type !== "slash") {
            val = "[^\\\\/]";
          }
          if (node.parsed.slice(-1) === "(") {
            var ch = node.rest.charAt(0);
            if (ch === "!" || ch === "=" || ch === ":") {
              return this.emit(node.val, node);
            }
          }
          if (node.val.length > 1) {
            val += "{" + node.val.length + "}";
          }
          return this.emit(val, node);
        }).set("plus", function(node) {
          var prev = node.parsed.slice(-1);
          if (prev === "]" || prev === ")") {
            return this.emit(node.val, node);
          }
          if (!this.output || /[?*+]/.test(ch) && node.parent.type !== "bracket") {
            return this.emit("\\+", node);
          }
          var ch = this.output.slice(-1);
          if (/\w/.test(ch) && !node.inside) {
            return this.emit("+\\+?", node);
          }
          return this.emit("+", node);
        }).set("globstar", function(node, nodes, i) {
          if (!this.output) {
            this.state.leadingGlobstar = true;
          }
          var prev = this.prev();
          var before2 = this.prev(2);
          var next = this.next();
          var after2 = this.next(2);
          var type = prev.type;
          var val = node.val;
          if (prev.type === "slash" && next.type === "slash") {
            if (before2.type === "text") {
              this.output += "?";
              if (after2.type !== "text") {
                this.output += "\\b";
              }
            }
          }
          var parsed = node.parsed;
          if (parsed.charAt(0) === "!") {
            parsed = parsed.slice(1);
          }
          var isInside = node.isInside.paren || node.isInside.brace;
          if (parsed && type !== "slash" && type !== "bos" && !isInside) {
            val = star();
          } else {
            val = this.options.dot !== true ? "(?:(?!(?:[" + slash() + "]|^)\\.).)*?" : "(?:(?!(?:[" + slash() + "]|^)(?:\\.{1,2})($|[" + slash() + "]))(?!\\.{2}).)*?";
          }
          if ((type === "slash" || type === "bos") && this.options.dot !== true) {
            val = "(?!\\.)" + val;
          }
          if (prev.type === "slash" && next.type === "slash" && before2.type !== "text") {
            if (after2.type === "text" || after2.type === "star") {
              node.addQmark = true;
            }
          }
          if (this.options.capture) {
            val = "(" + val + ")";
          }
          return this.emit(val, node);
        }).set("star", function(node, nodes, i) {
          var prior = nodes[i - 2] || {};
          var prev = this.prev();
          var next = this.next();
          var type = prev.type;
          function isStart(n) {
            return n.type === "bos" || n.type === "slash";
          }
          if (this.output === "" && this.options.contains !== true) {
            this.output = "(?![" + slash() + "])";
          }
          if (type === "bracket" && this.options.bash === false) {
            var str = next && next.type === "bracket" ? star() : "*?";
            if (!prev.nodes || prev.nodes[1].type !== "posix") {
              return this.emit(str, node);
            }
          }
          var prefix = !this.dotfiles && type !== "text" && type !== "escape" ? this.options.dot ? "(?!(?:^|[" + slash() + "])\\.{1,2}(?:$|[" + slash() + "]))" : "(?!\\.)" : "";
          if (isStart(prev) || isStart(prior) && type === "not") {
            if (prefix !== "(?!\\.)") {
              prefix += "(?!(\\.{2}|\\.[" + slash() + "]))(?=.)";
            } else {
              prefix += "(?=.)";
            }
          } else if (prefix === "(?!\\.)") {
            prefix = "";
          }
          if (prev.type === "not" && prior.type === "bos" && this.options.dot === true) {
            this.output = "(?!\\.)" + this.output;
          }
          var output = prefix + star();
          if (this.options.capture) {
            output = "(" + output + ")";
          }
          return this.emit(output, node);
        }).set("text", function(node) {
          return this.emit(node.val, node);
        }).set("eos", function(node) {
          var prev = this.prev();
          var val = node.val;
          this.output = "(?:\\.[" + slash() + "](?=.))?" + this.output;
          if (this.state.metachar && prev.type !== "qmark" && prev.type !== "slash") {
            val += this.options.contains ? "[" + slash() + "]?" : "(?:[" + slash() + "]|$)";
          }
          return this.emit(val, node);
        });
        if (options && typeof options.compilers === "function") {
          options.compilers(nanomatch.compiler);
        }
      };
    }
  });

  // node_modules/nanomatch/lib/parsers.js
  var require_parsers = __commonJS({
    "node_modules/nanomatch/lib/parsers.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var regexNot = require_regex_not();
      var toRegex = require_to_regex();
      var cached;
      var NOT_REGEX = `[\\[!*+?$^"'.\\\\/]+`;
      var not = createTextRegex(NOT_REGEX);
      module2.exports = function(nanomatch, options) {
        var parser3 = nanomatch.parser;
        var opts = parser3.options;
        parser3.state = {
          slashes: 0,
          paths: []
        };
        parser3.ast.state = parser3.state;
        parser3.capture("prefix", function() {
          if (this.parsed)
            return;
          var m = this.match(/^\.[\\/]/);
          if (!m)
            return;
          this.state.strictOpen = !!this.options.strictOpen;
          this.state.addPrefix = true;
        }).capture("escape", function() {
          if (this.isInside("bracket"))
            return;
          var pos = this.position();
          var m = this.match(/^(?:\\(.)|([$^]))/);
          if (!m)
            return;
          return pos({
            type: "escape",
            val: m[2] || m[1]
          });
        }).capture("quoted", function() {
          var pos = this.position();
          var m = this.match(/^["']/);
          if (!m)
            return;
          var quote = m[0];
          if (this.input.indexOf(quote) === -1) {
            return pos({
              type: "escape",
              val: quote
            });
          }
          var tok = advanceTo(this.input, quote);
          this.consume(tok.len);
          return pos({
            type: "quoted",
            val: tok.esc
          });
        }).capture("not", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(this.notRegex || /^!+/);
          if (!m)
            return;
          var val = m[0];
          var isNegated = val.length % 2 === 1;
          if (parsed === "" && !isNegated) {
            val = "";
          }
          if (parsed === "" && isNegated && this.options.nonegate !== true) {
            this.bos.val = "(?!^(?:";
            this.append = ")$).*";
            val = "";
          }
          return pos({
            type: "not",
            val
          });
        }).capture("dot", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(/^\.+/);
          if (!m)
            return;
          var val = m[0];
          this.state.dot = val === "." && (parsed === "" || parsed.slice(-1) === "/");
          return pos({
            type: "dot",
            dotfiles: this.state.dot,
            val
          });
        }).capture("plus", /^\+(?!\()/).capture("qmark", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(/^\?+(?!\()/);
          if (!m)
            return;
          this.state.metachar = true;
          this.state.qmark = true;
          return pos({
            type: "qmark",
            parsed,
            val: m[0]
          });
        }).capture("globstar", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(/^\*{2}(?![*(])(?=[,)/]|$)/);
          if (!m)
            return;
          var type = opts.noglobstar !== true ? "globstar" : "star";
          var node = pos({ type, parsed });
          this.state.metachar = true;
          while (this.input.slice(0, 4) === "/**/") {
            this.input = this.input.slice(3);
          }
          node.isInside = {
            brace: this.isInside("brace"),
            paren: this.isInside("paren")
          };
          if (type === "globstar") {
            this.state.globstar = true;
            node.val = "**";
          } else {
            this.state.star = true;
            node.val = "*";
          }
          return node;
        }).capture("star", function() {
          var pos = this.position();
          var starRe = /^(?:\*(?![*(])|[*]{3,}(?!\()|[*]{2}(?![(/]|$)|\*(?=\*\())/;
          var m = this.match(starRe);
          if (!m)
            return;
          this.state.metachar = true;
          this.state.star = true;
          return pos({
            type: "star",
            val: m[0]
          });
        }).capture("slash", function() {
          var pos = this.position();
          var m = this.match(/^\//);
          if (!m)
            return;
          this.state.slashes++;
          return pos({
            type: "slash",
            val: m[0]
          });
        }).capture("backslash", function() {
          var pos = this.position();
          var m = this.match(/^\\(?![*+?(){}[\]'"])/);
          if (!m)
            return;
          var val = m[0];
          if (this.isInside("bracket")) {
            val = "\\";
          } else if (val.length > 1) {
            val = "\\\\";
          }
          return pos({
            type: "backslash",
            val
          });
        }).capture("square", function() {
          if (this.isInside("bracket"))
            return;
          var pos = this.position();
          var m = this.match(/^\[([^!^\\])\]/);
          if (!m)
            return;
          return pos({
            type: "square",
            val: m[1]
          });
        }).capture("bracket", function() {
          var pos = this.position();
          var m = this.match(/^(?:\[([!^]?)([^\]]+|\]-)(\]|[^*+?]+)|\[)/);
          if (!m)
            return;
          var val = m[0];
          var negated = m[1] ? "^" : "";
          var inner = (m[2] || "").replace(/\\\\+/, "\\\\");
          var close = m[3] || "";
          if (m[2] && inner.length < m[2].length) {
            val = val.replace(/\\\\+/, "\\\\");
          }
          var esc = this.input.slice(0, 2);
          if (inner === "" && esc === "\\]") {
            inner += esc;
            this.consume(2);
            var str = this.input;
            var idx = -1;
            var ch;
            while (ch = str[++idx]) {
              this.consume(1);
              if (ch === "]") {
                close = ch;
                break;
              }
              inner += ch;
            }
          }
          return pos({
            type: "bracket",
            val,
            escaped: close !== "]",
            negated,
            inner,
            close
          });
        }).capture("text", function() {
          if (this.isInside("bracket"))
            return;
          var pos = this.position();
          var m = this.match(not);
          if (!m || !m[0])
            return;
          return pos({
            type: "text",
            val: m[0]
          });
        });
        if (options && typeof options.parsers === "function") {
          options.parsers(nanomatch.parser);
        }
      };
      function advanceTo(input, endChar) {
        var ch = input.charAt(0);
        var tok = { len: 1, val: "", esc: "" };
        var idx = 0;
        function advance() {
          if (ch !== "\\") {
            tok.esc += "\\" + ch;
            tok.val += ch;
          }
          ch = input.charAt(++idx);
          tok.len++;
          if (ch === "\\") {
            advance();
            advance();
          }
        }
        while (ch && ch !== endChar) {
          advance();
        }
        return tok;
      }
      function createTextRegex(pattern) {
        if (cached)
          return cached;
        var opts = { contains: true, strictClose: false };
        var not2 = regexNot.create(pattern, opts);
        var re = toRegex("^(?:[*]\\((?=.)|" + not2 + ")", opts);
        return cached = re;
      }
      module2.exports.not = NOT_REGEX;
    }
  });

  // node_modules/map-cache/index.js
  var require_map_cache = __commonJS({
    "node_modules/map-cache/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var hasOwn = Object.prototype.hasOwnProperty;
      module2.exports = MapCache2;
      function MapCache2(data) {
        this.__data__ = data || {};
      }
      MapCache2.prototype.set = function mapSet(key, value) {
        if (key !== "__proto__") {
          this.__data__[key] = value;
        }
        return this;
      };
      MapCache2.prototype.get = function mapGet(key) {
        return key === "__proto__" ? void 0 : this.__data__[key];
      };
      MapCache2.prototype.has = function mapHas(key) {
        return key !== "__proto__" && hasOwn.call(this.__data__, key);
      };
      MapCache2.prototype.del = function mapDelete(key) {
        return this.has(key) && delete this.__data__[key];
      };
    }
  });

  // node_modules/fragment-cache/index.js
  var require_fragment_cache = __commonJS({
    "node_modules/fragment-cache/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var MapCache2 = require_map_cache();
      function FragmentCache(caches) {
        this.caches = caches || {};
      }
      FragmentCache.prototype = {
        cache: function(cacheName) {
          return this.caches[cacheName] || (this.caches[cacheName] = new MapCache2());
        },
        set: function(cacheName, key, val) {
          var cache = this.cache(cacheName);
          cache.set(key, val);
          return cache;
        },
        has: function(cacheName, key) {
          return typeof this.get(cacheName, key) !== "undefined";
        },
        get: function(name, key) {
          var cache = this.cache(name);
          if (typeof key === "string") {
            return cache.get(key);
          }
          return cache;
        }
      };
      exports2 = module2.exports = FragmentCache;
    }
  });

  // node_modules/nanomatch/lib/cache.js
  var require_cache = __commonJS({
    "node_modules/nanomatch/lib/cache.js"(exports2, module2) {
      init_define_process();
      module2.exports = new (require_fragment_cache())();
    }
  });

  // node_modules/path-browserify/index.js
  var require_path_browserify = __commonJS({
    "node_modules/path-browserify/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      function assertPath(path) {
        if (typeof path !== "string") {
          throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
        }
      }
      function normalizeStringPosix(path, allowAboveRoot) {
        var res = "";
        var lastSegmentLength = 0;
        var lastSlash = -1;
        var dots = 0;
        var code;
        for (var i = 0; i <= path.length; ++i) {
          if (i < path.length)
            code = path.charCodeAt(i);
          else if (code === 47)
            break;
          else
            code = 47;
          if (code === 47) {
            if (lastSlash === i - 1 || dots === 1) {
            } else if (lastSlash !== i - 1 && dots === 2) {
              if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                if (res.length > 2) {
                  var lastSlashIndex = res.lastIndexOf("/");
                  if (lastSlashIndex !== res.length - 1) {
                    if (lastSlashIndex === -1) {
                      res = "";
                      lastSegmentLength = 0;
                    } else {
                      res = res.slice(0, lastSlashIndex);
                      lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                    }
                    lastSlash = i;
                    dots = 0;
                    continue;
                  }
                } else if (res.length === 2 || res.length === 1) {
                  res = "";
                  lastSegmentLength = 0;
                  lastSlash = i;
                  dots = 0;
                  continue;
                }
              }
              if (allowAboveRoot) {
                if (res.length > 0)
                  res += "/..";
                else
                  res = "..";
                lastSegmentLength = 2;
              }
            } else {
              if (res.length > 0)
                res += "/" + path.slice(lastSlash + 1, i);
              else
                res = path.slice(lastSlash + 1, i);
              lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
          } else if (code === 46 && dots !== -1) {
            ++dots;
          } else {
            dots = -1;
          }
        }
        return res;
      }
      function _format(sep, pathObject) {
        var dir = pathObject.dir || pathObject.root;
        var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
        if (!dir) {
          return base;
        }
        if (dir === pathObject.root) {
          return dir + base;
        }
        return dir + sep + base;
      }
      var posix = {
        resolve: function resolve() {
          var resolvedPath = "";
          var resolvedAbsolute = false;
          var cwd;
          for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
            var path;
            if (i >= 0)
              path = arguments[i];
            else {
              if (cwd === void 0)
                cwd = define_process_default.cwd();
              path = cwd;
            }
            assertPath(path);
            if (path.length === 0) {
              continue;
            }
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47;
          }
          resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);
          if (resolvedAbsolute) {
            if (resolvedPath.length > 0)
              return "/" + resolvedPath;
            else
              return "/";
          } else if (resolvedPath.length > 0) {
            return resolvedPath;
          } else {
            return ".";
          }
        },
        normalize: function normalize(path) {
          assertPath(path);
          if (path.length === 0)
            return ".";
          var isAbsolute = path.charCodeAt(0) === 47;
          var trailingSeparator = path.charCodeAt(path.length - 1) === 47;
          path = normalizeStringPosix(path, !isAbsolute);
          if (path.length === 0 && !isAbsolute)
            path = ".";
          if (path.length > 0 && trailingSeparator)
            path += "/";
          if (isAbsolute)
            return "/" + path;
          return path;
        },
        isAbsolute: function isAbsolute(path) {
          assertPath(path);
          return path.length > 0 && path.charCodeAt(0) === 47;
        },
        join: function join2() {
          if (arguments.length === 0)
            return ".";
          var joined;
          for (var i = 0; i < arguments.length; ++i) {
            var arg = arguments[i];
            assertPath(arg);
            if (arg.length > 0) {
              if (joined === void 0)
                joined = arg;
              else
                joined += "/" + arg;
            }
          }
          if (joined === void 0)
            return ".";
          return posix.normalize(joined);
        },
        relative: function relative(from, to) {
          assertPath(from);
          assertPath(to);
          if (from === to)
            return "";
          from = posix.resolve(from);
          to = posix.resolve(to);
          if (from === to)
            return "";
          var fromStart = 1;
          for (; fromStart < from.length; ++fromStart) {
            if (from.charCodeAt(fromStart) !== 47)
              break;
          }
          var fromEnd = from.length;
          var fromLen = fromEnd - fromStart;
          var toStart = 1;
          for (; toStart < to.length; ++toStart) {
            if (to.charCodeAt(toStart) !== 47)
              break;
          }
          var toEnd = to.length;
          var toLen = toEnd - toStart;
          var length = fromLen < toLen ? fromLen : toLen;
          var lastCommonSep = -1;
          var i = 0;
          for (; i <= length; ++i) {
            if (i === length) {
              if (toLen > length) {
                if (to.charCodeAt(toStart + i) === 47) {
                  return to.slice(toStart + i + 1);
                } else if (i === 0) {
                  return to.slice(toStart + i);
                }
              } else if (fromLen > length) {
                if (from.charCodeAt(fromStart + i) === 47) {
                  lastCommonSep = i;
                } else if (i === 0) {
                  lastCommonSep = 0;
                }
              }
              break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode)
              break;
            else if (fromCode === 47)
              lastCommonSep = i;
          }
          var out = "";
          for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
            if (i === fromEnd || from.charCodeAt(i) === 47) {
              if (out.length === 0)
                out += "..";
              else
                out += "/..";
            }
          }
          if (out.length > 0)
            return out + to.slice(toStart + lastCommonSep);
          else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47)
              ++toStart;
            return to.slice(toStart);
          }
        },
        _makeLong: function _makeLong(path) {
          return path;
        },
        dirname: function dirname(path) {
          assertPath(path);
          if (path.length === 0)
            return ".";
          var code = path.charCodeAt(0);
          var hasRoot = code === 47;
          var end = -1;
          var matchedSlash = true;
          for (var i = path.length - 1; i >= 1; --i) {
            code = path.charCodeAt(i);
            if (code === 47) {
              if (!matchedSlash) {
                end = i;
                break;
              }
            } else {
              matchedSlash = false;
            }
          }
          if (end === -1)
            return hasRoot ? "/" : ".";
          if (hasRoot && end === 1)
            return "//";
          return path.slice(0, end);
        },
        basename: function basename(path, ext) {
          if (ext !== void 0 && typeof ext !== "string")
            throw new TypeError('"ext" argument must be a string');
          assertPath(path);
          var start = 0;
          var end = -1;
          var matchedSlash = true;
          var i;
          if (ext !== void 0 && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path)
              return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for (i = path.length - 1; i >= 0; --i) {
              var code = path.charCodeAt(i);
              if (code === 47) {
                if (!matchedSlash) {
                  start = i + 1;
                  break;
                }
              } else {
                if (firstNonSlashEnd === -1) {
                  matchedSlash = false;
                  firstNonSlashEnd = i + 1;
                }
                if (extIdx >= 0) {
                  if (code === ext.charCodeAt(extIdx)) {
                    if (--extIdx === -1) {
                      end = i;
                    }
                  } else {
                    extIdx = -1;
                    end = firstNonSlashEnd;
                  }
                }
              }
            }
            if (start === end)
              end = firstNonSlashEnd;
            else if (end === -1)
              end = path.length;
            return path.slice(start, end);
          } else {
            for (i = path.length - 1; i >= 0; --i) {
              if (path.charCodeAt(i) === 47) {
                if (!matchedSlash) {
                  start = i + 1;
                  break;
                }
              } else if (end === -1) {
                matchedSlash = false;
                end = i + 1;
              }
            }
            if (end === -1)
              return "";
            return path.slice(start, end);
          }
        },
        extname: function extname(path) {
          assertPath(path);
          var startDot = -1;
          var startPart = 0;
          var end = -1;
          var matchedSlash = true;
          var preDotState = 0;
          for (var i = path.length - 1; i >= 0; --i) {
            var code = path.charCodeAt(i);
            if (code === 47) {
              if (!matchedSlash) {
                startPart = i + 1;
                break;
              }
              continue;
            }
            if (end === -1) {
              matchedSlash = false;
              end = i + 1;
            }
            if (code === 46) {
              if (startDot === -1)
                startDot = i;
              else if (preDotState !== 1)
                preDotState = 1;
            } else if (startDot !== -1) {
              preDotState = -1;
            }
          }
          if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            return "";
          }
          return path.slice(startDot, end);
        },
        format: function format(pathObject) {
          if (pathObject === null || typeof pathObject !== "object") {
            throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
          }
          return _format("/", pathObject);
        },
        parse: function parse3(path) {
          assertPath(path);
          var ret = { root: "", dir: "", base: "", ext: "", name: "" };
          if (path.length === 0)
            return ret;
          var code = path.charCodeAt(0);
          var isAbsolute = code === 47;
          var start;
          if (isAbsolute) {
            ret.root = "/";
            start = 1;
          } else {
            start = 0;
          }
          var startDot = -1;
          var startPart = 0;
          var end = -1;
          var matchedSlash = true;
          var i = path.length - 1;
          var preDotState = 0;
          for (; i >= start; --i) {
            code = path.charCodeAt(i);
            if (code === 47) {
              if (!matchedSlash) {
                startPart = i + 1;
                break;
              }
              continue;
            }
            if (end === -1) {
              matchedSlash = false;
              end = i + 1;
            }
            if (code === 46) {
              if (startDot === -1)
                startDot = i;
              else if (preDotState !== 1)
                preDotState = 1;
            } else if (startDot !== -1) {
              preDotState = -1;
            }
          }
          if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
              if (startPart === 0 && isAbsolute)
                ret.base = ret.name = path.slice(1, end);
              else
                ret.base = ret.name = path.slice(startPart, end);
            }
          } else {
            if (startPart === 0 && isAbsolute) {
              ret.name = path.slice(1, startDot);
              ret.base = path.slice(1, end);
            } else {
              ret.name = path.slice(startPart, startDot);
              ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
          }
          if (startPart > 0)
            ret.dir = path.slice(0, startPart - 1);
          else if (isAbsolute)
            ret.dir = "/";
          return ret;
        },
        sep: "/",
        delimiter: ":",
        win32: null,
        posix: null
      };
      posix.posix = posix;
      module2.exports = posix;
    }
  });

  // node_modules/is-windows/index.js
  var require_is_windows = __commonJS({
    "node_modules/is-windows/index.js"(exports2, module2) {
      init_define_process();
      (function(factory2) {
        if (exports2 && typeof exports2 === "object" && typeof module2 !== "undefined") {
          module2.exports = factory2();
        } else if (typeof define === "function" && define.amd) {
          define([], factory2);
        } else if (typeof window !== "undefined") {
          window.isWindows = factory2();
        } else if (typeof global !== "undefined") {
          global.isWindows = factory2();
        } else if (typeof self !== "undefined") {
          self.isWindows = factory2();
        } else {
          this.isWindows = factory2();
        }
      })(function() {
        "use strict";
        return function isWindows() {
          return define_process_default && (define_process_default.platform === "win32" || /^(msys|cygwin)$/.test(define_process_default.env.OSTYPE));
        };
      });
    }
  });

  // node_modules/base/node_modules/define-property/index.js
  var require_define_property2 = __commonJS({
    "node_modules/base/node_modules/define-property/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isDescriptor = require_is_descriptor();
      module2.exports = function defineProperty2(obj, prop, val) {
        if (typeof obj !== "object" && typeof obj !== "function") {
          throw new TypeError("expected an object or function.");
        }
        if (typeof prop !== "string") {
          throw new TypeError("expected `prop` to be a string.");
        }
        if (isDescriptor(val) && ("set" in val || "get" in val)) {
          return Object.defineProperty(obj, prop, val);
        }
        return Object.defineProperty(obj, prop, {
          configurable: true,
          enumerable: false,
          writable: true,
          value: val
        });
      };
    }
  });

  // node_modules/component-emitter/index.js
  var require_component_emitter = __commonJS({
    "node_modules/component-emitter/index.js"(exports2, module2) {
      init_define_process();
      if (typeof module2 !== "undefined") {
        module2.exports = Emitter;
      }
      function Emitter(obj) {
        if (obj)
          return mixin3(obj);
      }
      function mixin3(obj) {
        for (var key in Emitter.prototype) {
          obj[key] = Emitter.prototype[key];
        }
        return obj;
      }
      Emitter.prototype.on = Emitter.prototype.addEventListener = function(event, fn) {
        this._callbacks = this._callbacks || {};
        (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
        return this;
      };
      Emitter.prototype.once = function(event, fn) {
        function on() {
          this.off(event, on);
          fn.apply(this, arguments);
        }
        on.fn = fn;
        this.on(event, on);
        return this;
      };
      Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(event, fn) {
        this._callbacks = this._callbacks || {};
        if (0 == arguments.length) {
          this._callbacks = {};
          return this;
        }
        var callbacks = this._callbacks["$" + event];
        if (!callbacks)
          return this;
        if (1 == arguments.length) {
          delete this._callbacks["$" + event];
          return this;
        }
        var cb;
        for (var i = 0; i < callbacks.length; i++) {
          cb = callbacks[i];
          if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
          }
        }
        if (callbacks.length === 0) {
          delete this._callbacks["$" + event];
        }
        return this;
      };
      Emitter.prototype.emit = function(event) {
        this._callbacks = this._callbacks || {};
        var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
        for (var i = 1; i < arguments.length; i++) {
          args[i - 1] = arguments[i];
        }
        if (callbacks) {
          callbacks = callbacks.slice(0);
          for (var i = 0, len = callbacks.length; i < len; ++i) {
            callbacks[i].apply(this, args);
          }
        }
        return this;
      };
      Emitter.prototype.listeners = function(event) {
        this._callbacks = this._callbacks || {};
        return this._callbacks["$" + event] || [];
      };
      Emitter.prototype.hasListeners = function(event) {
        return !!this.listeners(event).length;
      };
    }
  });

  // node_modules/object-visit/index.js
  var require_object_visit = __commonJS({
    "node_modules/object-visit/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      module2.exports = function visit(thisArg, method2, target, val) {
        if (!isObject2(thisArg) && typeof thisArg !== "function") {
          throw new Error("object-visit expects `thisArg` to be an object.");
        }
        if (typeof method2 !== "string") {
          throw new Error("object-visit expects `method` name to be a string");
        }
        if (typeof thisArg[method2] !== "function") {
          return thisArg;
        }
        var args = [].slice.call(arguments, 3);
        target = target || {};
        for (var key in target) {
          var arr = [key, target[key]].concat(args);
          thisArg[method2].apply(thisArg, arr);
        }
        return thisArg;
      };
    }
  });

  // node_modules/map-visit/index.js
  var require_map_visit = __commonJS({
    "node_modules/map-visit/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var util = require_util();
      var visit = require_object_visit();
      module2.exports = function mapVisit(collection, method2, val) {
        if (isObject2(val)) {
          return visit.apply(null, arguments);
        }
        if (!Array.isArray(val)) {
          throw new TypeError("expected an array: " + util.inspect(val));
        }
        var args = [].slice.call(arguments, 3);
        for (var i = 0; i < val.length; i++) {
          var ele = val[i];
          if (isObject2(ele)) {
            visit.apply(null, [collection, method2, ele].concat(args));
          } else {
            collection[method2].apply(collection, [ele].concat(args));
          }
        }
      };
      function isObject2(val) {
        return val && (typeof val === "function" || !Array.isArray(val) && typeof val === "object");
      }
    }
  });

  // node_modules/collection-visit/index.js
  var require_collection_visit = __commonJS({
    "node_modules/collection-visit/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var visit = require_object_visit();
      var mapVisit = require_map_visit();
      module2.exports = function(collection, method2, val) {
        var result2;
        if (typeof val === "string" && method2 in collection) {
          var args = [].slice.call(arguments, 2);
          result2 = collection[method2].apply(collection, args);
        } else if (Array.isArray(val)) {
          result2 = mapVisit.apply(null, arguments);
        } else {
          result2 = visit.apply(null, arguments);
        }
        if (typeof result2 !== "undefined") {
          return result2;
        }
        return collection;
      };
    }
  });

  // node_modules/is-buffer/index.js
  var require_is_buffer = __commonJS({
    "node_modules/is-buffer/index.js"(exports2, module2) {
      init_define_process();
      module2.exports = function(obj) {
        return obj != null && (isBuffer2(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
      };
      function isBuffer2(obj) {
        return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
      }
      function isSlowBuffer(obj) {
        return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer2(obj.slice(0, 0));
      }
    }
  });

  // node_modules/kind-of/index.js
  var require_kind_of4 = __commonJS({
    "node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var isBuffer2 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // node_modules/to-object-path/index.js
  var require_to_object_path = __commonJS({
    "node_modules/to-object-path/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of4();
      module2.exports = function toPath2(args) {
        if (typeOf(args) !== "arguments") {
          args = arguments;
        }
        return filter2(args).join(".");
      };
      function filter2(arr) {
        var len = arr.length;
        var idx = -1;
        var res = [];
        while (++idx < len) {
          var ele = arr[idx];
          if (typeOf(ele) === "arguments" || Array.isArray(ele)) {
            res.push.apply(res, filter2(ele));
          } else if (typeof ele === "string") {
            res.push(ele);
          }
        }
        return res;
      }
    }
  });

  // node_modules/is-extendable/index.js
  var require_is_extendable2 = __commonJS({
    "node_modules/is-extendable/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function isExtendable(val) {
        return typeof val !== "undefined" && val !== null && (typeof val === "object" || typeof val === "function");
      };
    }
  });

  // node_modules/arr-union/index.js
  var require_arr_union = __commonJS({
    "node_modules/arr-union/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function union2(init) {
        if (!Array.isArray(init)) {
          throw new TypeError("arr-union expects the first argument to be an array.");
        }
        var len = arguments.length;
        var i = 0;
        while (++i < len) {
          var arg = arguments[i];
          if (!arg)
            continue;
          if (!Array.isArray(arg)) {
            arg = [arg];
          }
          for (var j = 0; j < arg.length; j++) {
            var ele = arg[j];
            if (init.indexOf(ele) >= 0) {
              continue;
            }
            init.push(ele);
          }
        }
        return init;
      };
    }
  });

  // node_modules/get-value/index.js
  var require_get_value = __commonJS({
    "node_modules/get-value/index.js"(exports2, module2) {
      init_define_process();
      module2.exports = function(obj, prop, a, b, c) {
        if (!isObject2(obj) || !prop) {
          return obj;
        }
        prop = toString2(prop);
        if (a)
          prop += "." + toString2(a);
        if (b)
          prop += "." + toString2(b);
        if (c)
          prop += "." + toString2(c);
        if (prop in obj) {
          return obj[prop];
        }
        var segs = prop.split(".");
        var len = segs.length;
        var i = -1;
        while (obj && ++i < len) {
          var key = segs[i];
          while (key[key.length - 1] === "\\") {
            key = key.slice(0, -1) + "." + segs[++i];
          }
          obj = obj[key];
        }
        return obj;
      };
      function isObject2(val) {
        return val !== null && (typeof val === "object" || typeof val === "function");
      }
      function toString2(val) {
        if (!val)
          return "";
        if (Array.isArray(val)) {
          return val.join(".");
        }
        return val;
      }
    }
  });

  // node_modules/split-string/index.js
  var require_split_string = __commonJS({
    "node_modules/split-string/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var extend = require_extend_shallow();
      module2.exports = function(str, options, fn) {
        if (typeof str !== "string") {
          throw new TypeError("expected a string");
        }
        if (typeof options === "function") {
          fn = options;
          options = null;
        }
        if (typeof options === "string") {
          options = { sep: options };
        }
        var opts = extend({ sep: "." }, options);
        var quotes = opts.quotes || ['"', "'", "`"];
        var brackets;
        if (opts.brackets === true) {
          brackets = {
            "<": ">",
            "(": ")",
            "[": "]",
            "{": "}"
          };
        } else if (opts.brackets) {
          brackets = opts.brackets;
        }
        var tokens = [];
        var stack = [];
        var arr = [""];
        var sep = opts.sep;
        var len = str.length;
        var idx = -1;
        var closeIdx;
        function expected() {
          if (brackets && stack.length) {
            return brackets[stack[stack.length - 1]];
          }
        }
        while (++idx < len) {
          var ch = str[idx];
          var next = str[idx + 1];
          var tok = { val: ch, idx, arr, str };
          tokens.push(tok);
          if (ch === "\\") {
            tok.val = keepEscaping(opts, str, idx) === true ? ch + next : next;
            tok.escaped = true;
            if (typeof fn === "function") {
              fn(tok);
            }
            arr[arr.length - 1] += tok.val;
            idx++;
            continue;
          }
          if (brackets && brackets[ch]) {
            stack.push(ch);
            var e = expected();
            var i = idx + 1;
            if (str.indexOf(e, i + 1) !== -1) {
              while (stack.length && i < len) {
                var s = str[++i];
                if (s === "\\") {
                  s++;
                  continue;
                }
                if (quotes.indexOf(s) !== -1) {
                  i = getClosingQuote(str, s, i + 1);
                  continue;
                }
                e = expected();
                if (stack.length && str.indexOf(e, i + 1) === -1) {
                  break;
                }
                if (brackets[s]) {
                  stack.push(s);
                  continue;
                }
                if (e === s) {
                  stack.pop();
                }
              }
            }
            closeIdx = i;
            if (closeIdx === -1) {
              arr[arr.length - 1] += ch;
              continue;
            }
            ch = str.slice(idx, closeIdx + 1);
            tok.val = ch;
            tok.idx = idx = closeIdx;
          }
          if (quotes.indexOf(ch) !== -1) {
            closeIdx = getClosingQuote(str, ch, idx + 1);
            if (closeIdx === -1) {
              arr[arr.length - 1] += ch;
              continue;
            }
            if (keepQuotes(ch, opts) === true) {
              ch = str.slice(idx, closeIdx + 1);
            } else {
              ch = str.slice(idx + 1, closeIdx);
            }
            tok.val = ch;
            tok.idx = idx = closeIdx;
          }
          if (typeof fn === "function") {
            fn(tok, tokens);
            ch = tok.val;
            idx = tok.idx;
          }
          if (tok.val === sep && tok.split !== false) {
            arr.push("");
            continue;
          }
          arr[arr.length - 1] += tok.val;
        }
        return arr;
      };
      function getClosingQuote(str, ch, i, brackets) {
        var idx = str.indexOf(ch, i);
        if (str.charAt(idx - 1) === "\\") {
          return getClosingQuote(str, ch, idx + 1);
        }
        return idx;
      }
      function keepQuotes(ch, opts) {
        if (opts.keepDoubleQuotes === true && ch === '"')
          return true;
        if (opts.keepSingleQuotes === true && ch === "'")
          return true;
        return opts.keepQuotes;
      }
      function keepEscaping(opts, str, idx) {
        if (typeof opts.keepEscaping === "function") {
          return opts.keepEscaping(str, idx);
        }
        return opts.keepEscaping === true || str[idx + 1] === "\\";
      }
    }
  });

  // node_modules/set-value/node_modules/extend-shallow/index.js
  var require_extend_shallow2 = __commonJS({
    "node_modules/set-value/node_modules/extend-shallow/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_is_extendable2();
      module2.exports = function extend(o) {
        if (!isObject2(o)) {
          o = {};
        }
        var len = arguments.length;
        for (var i = 1; i < len; i++) {
          var obj = arguments[i];
          if (isObject2(obj)) {
            assign2(o, obj);
          }
        }
        return o;
      };
      function assign2(a, b) {
        for (var key in b) {
          if (hasOwn(b, key)) {
            a[key] = b[key];
          }
        }
      }
      function hasOwn(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
      }
    }
  });

  // node_modules/set-value/index.js
  var require_set_value = __commonJS({
    "node_modules/set-value/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var split2 = require_split_string();
      var extend = require_extend_shallow2();
      var isPlainObject2 = require_is_plain_object();
      var isObject2 = require_is_extendable2();
      module2.exports = function(obj, prop, val) {
        if (!isObject2(obj)) {
          return obj;
        }
        if (Array.isArray(prop)) {
          prop = [].concat.apply([], prop).join(".");
        }
        if (typeof prop !== "string") {
          return obj;
        }
        var keys2 = split2(prop, { sep: ".", brackets: true }).filter(isValidKey);
        var len = keys2.length;
        var idx = -1;
        var current = obj;
        while (++idx < len) {
          var key = keys2[idx];
          if (idx !== len - 1) {
            if (!isObject2(current[key])) {
              current[key] = {};
            }
            current = current[key];
            continue;
          }
          if (isPlainObject2(current[key]) && isPlainObject2(val)) {
            current[key] = extend({}, current[key], val);
          } else {
            current[key] = val;
          }
        }
        return obj;
      };
      function isValidKey(key) {
        return key !== "__proto__" && key !== "constructor" && key !== "prototype";
      }
    }
  });

  // node_modules/union-value/index.js
  var require_union_value = __commonJS({
    "node_modules/union-value/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_is_extendable2();
      var union2 = require_arr_union();
      var get2 = require_get_value();
      var set2 = require_set_value();
      module2.exports = function unionValue(obj, prop, value) {
        if (!isObject2(obj)) {
          throw new TypeError("union-value expects the first argument to be an object.");
        }
        if (typeof prop !== "string") {
          throw new TypeError("union-value expects `prop` to be a string.");
        }
        var arr = arrayify(get2(obj, prop));
        set2(obj, prop, union2(arr, arrayify(value)));
        return obj;
      };
      function arrayify(val) {
        if (val === null || typeof val === "undefined") {
          return [];
        }
        if (Array.isArray(val)) {
          return val;
        }
        return [val];
      }
    }
  });

  // node_modules/isarray/index.js
  var require_isarray = __commonJS({
    "node_modules/isarray/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = {}.toString;
      module2.exports = Array.isArray || function(arr) {
        return toString2.call(arr) == "[object Array]";
      };
    }
  });

  // node_modules/unset-value/node_modules/has-value/node_modules/isobject/index.js
  var require_isobject2 = __commonJS({
    "node_modules/unset-value/node_modules/has-value/node_modules/isobject/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isArray2 = require_isarray();
      module2.exports = function isObject2(val) {
        return val != null && typeof val === "object" && isArray2(val) === false;
      };
    }
  });

  // node_modules/unset-value/node_modules/has-values/index.js
  var require_has_values = __commonJS({
    "node_modules/unset-value/node_modules/has-values/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function hasValue(o, noZero) {
        if (o === null || o === void 0) {
          return false;
        }
        if (typeof o === "boolean") {
          return true;
        }
        if (typeof o === "number") {
          if (o === 0 && noZero === true) {
            return false;
          }
          return true;
        }
        if (o.length !== void 0) {
          return o.length !== 0;
        }
        for (var key in o) {
          if (o.hasOwnProperty(key)) {
            return true;
          }
        }
        return false;
      };
    }
  });

  // node_modules/unset-value/node_modules/has-value/index.js
  var require_has_value = __commonJS({
    "node_modules/unset-value/node_modules/has-value/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject2();
      var hasValues = require_has_values();
      var get2 = require_get_value();
      module2.exports = function(obj, prop, noZero) {
        if (isObject2(obj)) {
          return hasValues(get2(obj, prop), noZero);
        }
        return hasValues(obj, prop);
      };
    }
  });

  // node_modules/unset-value/index.js
  var require_unset_value = __commonJS({
    "node_modules/unset-value/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      var has2 = require_has_value();
      module2.exports = function unset2(obj, prop) {
        if (!isObject2(obj)) {
          throw new TypeError("expected an object.");
        }
        if (obj.hasOwnProperty(prop)) {
          delete obj[prop];
          return true;
        }
        if (has2(obj, prop)) {
          var segs = prop.split(".");
          var last2 = segs.pop();
          while (segs.length && segs[segs.length - 1].slice(-1) === "\\") {
            last2 = segs.pop().slice(0, -1) + "." + last2;
          }
          while (segs.length)
            obj = obj[prop = segs.shift()];
          return delete obj[last2];
        }
        return true;
      };
    }
  });

  // node_modules/has-values/node_modules/kind-of/index.js
  var require_kind_of5 = __commonJS({
    "node_modules/has-values/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var isBuffer2 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (type === "[object Promise]") {
          return "promise";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // node_modules/has-values/node_modules/is-number/node_modules/kind-of/index.js
  var require_kind_of6 = __commonJS({
    "node_modules/has-values/node_modules/is-number/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var isBuffer2 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // node_modules/has-values/node_modules/is-number/index.js
  var require_is_number = __commonJS({
    "node_modules/has-values/node_modules/is-number/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of6();
      module2.exports = function isNumber2(num) {
        var type = typeOf(num);
        if (type === "string") {
          if (!num.trim())
            return false;
        } else if (type !== "number") {
          return false;
        }
        return num - num + 1 >= 0;
      };
    }
  });

  // node_modules/has-values/index.js
  var require_has_values2 = __commonJS({
    "node_modules/has-values/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of5();
      var isNumber2 = require_is_number();
      module2.exports = function hasValue(val) {
        if (isNumber2(val)) {
          return true;
        }
        switch (typeOf(val)) {
          case "null":
          case "boolean":
          case "function":
            return true;
          case "string":
          case "arguments":
            return val.length !== 0;
          case "error":
            return val.message !== "";
          case "array":
            var len = val.length;
            if (len === 0) {
              return false;
            }
            for (var i = 0; i < len; i++) {
              if (hasValue(val[i])) {
                return true;
              }
            }
            return false;
          case "file":
          case "map":
          case "set":
            return val.size !== 0;
          case "object":
            var keys2 = Object.keys(val);
            if (keys2.length === 0) {
              return false;
            }
            for (var i = 0; i < keys2.length; i++) {
              var key = keys2[i];
              if (hasValue(val[key])) {
                return true;
              }
            }
            return false;
          default: {
            return false;
          }
        }
      };
    }
  });

  // node_modules/has-value/index.js
  var require_has_value2 = __commonJS({
    "node_modules/has-value/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      var hasValues = require_has_values2();
      var get2 = require_get_value();
      module2.exports = function(val, prop) {
        return hasValues(isObject2(val) && prop ? get2(val, prop) : val);
      };
    }
  });

  // node_modules/cache-base/index.js
  var require_cache_base = __commonJS({
    "node_modules/cache-base/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      var Emitter = require_component_emitter();
      var visit = require_collection_visit();
      var toPath2 = require_to_object_path();
      var union2 = require_union_value();
      var del = require_unset_value();
      var get2 = require_get_value();
      var has2 = require_has_value2();
      var set2 = require_set_value();
      function namespace(prop) {
        function Cache(cache) {
          if (prop) {
            this[prop] = {};
          }
          if (cache) {
            this.set(cache);
          }
        }
        Emitter(Cache.prototype);
        Cache.prototype.set = function(key, val) {
          if (Array.isArray(key) && arguments.length === 2) {
            key = toPath2(key);
          }
          if (isObject2(key) || Array.isArray(key)) {
            this.visit("set", key);
          } else {
            set2(prop ? this[prop] : this, key, val);
            this.emit("set", key, val);
          }
          return this;
        };
        Cache.prototype.union = function(key, val) {
          if (Array.isArray(key) && arguments.length === 2) {
            key = toPath2(key);
          }
          var ctx = prop ? this[prop] : this;
          union2(ctx, key, arrayify(val));
          this.emit("union", val);
          return this;
        };
        Cache.prototype.get = function(key) {
          key = toPath2(arguments);
          var ctx = prop ? this[prop] : this;
          var val = get2(ctx, key);
          this.emit("get", key, val);
          return val;
        };
        Cache.prototype.has = function(key) {
          key = toPath2(arguments);
          var ctx = prop ? this[prop] : this;
          var val = get2(ctx, key);
          var has3 = typeof val !== "undefined";
          this.emit("has", key, has3);
          return has3;
        };
        Cache.prototype.del = function(key) {
          if (Array.isArray(key)) {
            this.visit("del", key);
          } else {
            del(prop ? this[prop] : this, key);
            this.emit("del", key);
          }
          return this;
        };
        Cache.prototype.clear = function() {
          if (prop) {
            this[prop] = {};
          }
        };
        Cache.prototype.visit = function(method2, val) {
          visit(this, method2, val);
          return this;
        };
        return Cache;
      }
      function arrayify(val) {
        return val ? Array.isArray(val) ? val : [val] : [];
      }
      module2.exports = namespace();
      module2.exports.namespace = namespace;
    }
  });

  // node_modules/mixin-deep/node_modules/is-extendable/index.js
  var require_is_extendable3 = __commonJS({
    "node_modules/mixin-deep/node_modules/is-extendable/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isPlainObject2 = require_is_plain_object();
      module2.exports = function isExtendable(val) {
        return isPlainObject2(val) || typeof val === "function" || Array.isArray(val);
      };
    }
  });

  // node_modules/for-in/index.js
  var require_for_in = __commonJS({
    "node_modules/for-in/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function forIn2(obj, fn, thisArg) {
        for (var key in obj) {
          if (fn.call(thisArg, obj[key], key, obj) === false) {
            break;
          }
        }
      };
    }
  });

  // node_modules/mixin-deep/index.js
  var require_mixin_deep = __commonJS({
    "node_modules/mixin-deep/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isExtendable = require_is_extendable3();
      var forIn2 = require_for_in();
      function mixinDeep(target, objects) {
        var len = arguments.length, i = 0;
        while (++i < len) {
          var obj = arguments[i];
          if (isObject2(obj)) {
            forIn2(obj, copy, target);
          }
        }
        return target;
      }
      function copy(val, key) {
        if (!isValidKey(key)) {
          return;
        }
        var obj = this[key];
        if (isObject2(val) && isObject2(obj)) {
          mixinDeep(obj, val);
        } else {
          this[key] = val;
        }
      }
      function isObject2(val) {
        return isExtendable(val) && !Array.isArray(val);
      }
      function isValidKey(key) {
        return key !== "__proto__" && key !== "constructor" && key !== "prototype";
      }
      module2.exports = mixinDeep;
    }
  });

  // node_modules/pascalcase/index.js
  var require_pascalcase = __commonJS({
    "node_modules/pascalcase/index.js"(exports2, module2) {
      init_define_process();
      function pascalcase(str) {
        if (typeof str !== "string") {
          throw new TypeError("expected a string.");
        }
        str = str.replace(/([A-Z])/g, " $1");
        if (str.length === 1) {
          return str.toUpperCase();
        }
        str = str.replace(/^[\W_]+|[\W_]+$/g, "").toLowerCase();
        str = str.charAt(0).toUpperCase() + str.slice(1);
        return str.replace(/[\W_]+(\w|$)/g, function(_, ch) {
          return ch.toUpperCase();
        });
      }
      module2.exports = pascalcase;
    }
  });

  // node_modules/define-property/node_modules/kind-of/index.js
  var require_kind_of7 = __commonJS({
    "node_modules/define-property/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        var type = typeof val;
        if (type === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (type === "string" || val instanceof String) {
          return "string";
        }
        if (type === "number" || val instanceof Number) {
          return "number";
        }
        if (type === "function" || val instanceof Function) {
          if (typeof val.constructor.name !== "undefined" && val.constructor.name.slice(0, 9) === "Generator") {
            return "generatorfunction";
          }
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (type === "[object Promise]") {
          return "promise";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Map Iterator]") {
          return "mapiterator";
        }
        if (type === "[object Set Iterator]") {
          return "setiterator";
        }
        if (type === "[object String Iterator]") {
          return "stringiterator";
        }
        if (type === "[object Array Iterator]") {
          return "arrayiterator";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
      function isBuffer2(val) {
        return val.constructor && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
      }
    }
  });

  // node_modules/define-property/node_modules/is-accessor-descriptor/node_modules/kind-of/index.js
  var require_kind_of8 = __commonJS({
    "node_modules/define-property/node_modules/is-accessor-descriptor/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var isBuffer2 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // node_modules/define-property/node_modules/is-accessor-descriptor/index.js
  var require_is_accessor_descriptor2 = __commonJS({
    "node_modules/define-property/node_modules/is-accessor-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of8();
      var accessor = {
        get: "function",
        set: "function",
        configurable: "boolean",
        enumerable: "boolean"
      };
      function isAccessorDescriptor(obj, prop) {
        if (typeof prop === "string") {
          var val = Object.getOwnPropertyDescriptor(obj, prop);
          return typeof val !== "undefined";
        }
        if (typeOf(obj) !== "object") {
          return false;
        }
        if (has2(obj, "value") || has2(obj, "writable")) {
          return false;
        }
        if (!has2(obj, "get") || typeof obj.get !== "function") {
          return false;
        }
        if (has2(obj, "set") && typeof obj[key] !== "function" && typeof obj[key] !== "undefined") {
          return false;
        }
        for (var key in obj) {
          if (!accessor.hasOwnProperty(key)) {
            continue;
          }
          if (typeOf(obj[key]) === accessor[key]) {
            continue;
          }
          if (typeof obj[key] !== "undefined") {
            return false;
          }
        }
        return true;
      }
      function has2(obj, key) {
        return {}.hasOwnProperty.call(obj, key);
      }
      module2.exports = isAccessorDescriptor;
    }
  });

  // node_modules/define-property/node_modules/is-data-descriptor/node_modules/kind-of/index.js
  var require_kind_of9 = __commonJS({
    "node_modules/define-property/node_modules/is-data-descriptor/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var isBuffer2 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // node_modules/define-property/node_modules/is-data-descriptor/index.js
  var require_is_data_descriptor2 = __commonJS({
    "node_modules/define-property/node_modules/is-data-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of9();
      var data = {
        configurable: "boolean",
        enumerable: "boolean",
        writable: "boolean"
      };
      function isDataDescriptor(obj, prop) {
        if (typeOf(obj) !== "object") {
          return false;
        }
        if (typeof prop === "string") {
          var val = Object.getOwnPropertyDescriptor(obj, prop);
          return typeof val !== "undefined";
        }
        if (!("value" in obj) && !("writable" in obj)) {
          return false;
        }
        for (var key in obj) {
          if (key === "value")
            continue;
          if (!data.hasOwnProperty(key)) {
            continue;
          }
          if (typeOf(obj[key]) === data[key]) {
            continue;
          }
          if (typeof obj[key] !== "undefined") {
            return false;
          }
        }
        return true;
      }
      module2.exports = isDataDescriptor;
    }
  });

  // node_modules/define-property/node_modules/is-descriptor/index.js
  var require_is_descriptor2 = __commonJS({
    "node_modules/define-property/node_modules/is-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of7();
      var isAccessor = require_is_accessor_descriptor2();
      var isData = require_is_data_descriptor2();
      module2.exports = function isDescriptor(obj, key) {
        if (typeOf(obj) !== "object") {
          return false;
        }
        if ("get" in obj) {
          return isAccessor(obj, key);
        }
        return isData(obj, key);
      };
    }
  });

  // node_modules/define-property/index.js
  var require_define_property3 = __commonJS({
    "node_modules/define-property/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isDescriptor = require_is_descriptor2();
      module2.exports = function defineProperty2(obj, prop, val) {
        if (typeof obj !== "object" && typeof obj !== "function") {
          throw new TypeError("expected an object or function.");
        }
        if (typeof prop !== "string") {
          throw new TypeError("expected `prop` to be a string.");
        }
        if (isDescriptor(val) && ("set" in val || "get" in val)) {
          return Object.defineProperty(obj, prop, val);
        }
        return Object.defineProperty(obj, prop, {
          configurable: true,
          enumerable: false,
          writable: true,
          value: val
        });
      };
    }
  });

  // node_modules/copy-descriptor/index.js
  var require_copy_descriptor = __commonJS({
    "node_modules/copy-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function copyDescriptor(receiver, provider, from, to) {
        if (!isObject2(provider) && typeof provider !== "function") {
          to = from;
          from = provider;
          provider = receiver;
        }
        if (!isObject2(receiver) && typeof receiver !== "function") {
          throw new TypeError("expected the first argument to be an object");
        }
        if (!isObject2(provider) && typeof provider !== "function") {
          throw new TypeError("expected provider to be an object");
        }
        if (typeof to !== "string") {
          to = from;
        }
        if (typeof from !== "string") {
          throw new TypeError("expected key to be a string");
        }
        if (!(from in provider)) {
          throw new Error('property "' + from + '" does not exist');
        }
        var val = Object.getOwnPropertyDescriptor(provider, from);
        if (val)
          Object.defineProperty(receiver, to, val);
      };
      function isObject2(val) {
        return {}.toString.call(val) === "[object Object]";
      }
    }
  });

  // node_modules/object-copy/index.js
  var require_object_copy = __commonJS({
    "node_modules/object-copy/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of4();
      var copyDescriptor = require_copy_descriptor();
      var define2 = require_define_property3();
      function copy(receiver, provider, omit2) {
        if (!isObject2(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!isObject2(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        var props = nativeKeys2(provider);
        var keys2 = Object.keys(provider);
        var len = props.length;
        omit2 = arrayify(omit2);
        while (len--) {
          var key = props[len];
          if (has2(keys2, key)) {
            define2(receiver, key, provider[key]);
          } else if (!(key in receiver) && !has2(omit2, key)) {
            copyDescriptor(receiver, provider, key);
          }
        }
      }
      function isObject2(val) {
        return typeOf(val) === "object" || typeof val === "function";
      }
      function has2(obj, val) {
        val = arrayify(val);
        var len = val.length;
        if (isObject2(obj)) {
          for (var key in obj) {
            if (val.indexOf(key) > -1) {
              return true;
            }
          }
          var keys2 = nativeKeys2(obj);
          return has2(keys2, val);
        }
        if (Array.isArray(obj)) {
          var arr = obj;
          while (len--) {
            if (arr.indexOf(val[len]) > -1) {
              return true;
            }
          }
          return false;
        }
        throw new TypeError("expected an array or object.");
      }
      function arrayify(val) {
        return val ? Array.isArray(val) ? val : [val] : [];
      }
      function hasConstructor(val) {
        return isObject2(val) && typeof val.constructor !== "undefined";
      }
      function nativeKeys2(val) {
        if (!hasConstructor(val))
          return [];
        return Object.getOwnPropertyNames(val);
      }
      module2.exports = copy;
      module2.exports.has = has2;
    }
  });

  // node_modules/static-extend/index.js
  var require_static_extend = __commonJS({
    "node_modules/static-extend/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var copy = require_object_copy();
      var define2 = require_define_property3();
      var util = require_util();
      function extend(Parent, extendFn) {
        if (typeof Parent !== "function") {
          throw new TypeError("expected Parent to be a function.");
        }
        return function(Ctor, proto) {
          if (typeof Ctor !== "function") {
            throw new TypeError("expected Ctor to be a function.");
          }
          util.inherits(Ctor, Parent);
          copy(Ctor, Parent);
          if (typeof proto === "object") {
            var obj = Object.create(proto);
            for (var k in obj) {
              Ctor.prototype[k] = obj[k];
            }
          }
          define2(Ctor.prototype, "_parent_", {
            configurable: true,
            set: function() {
            },
            get: function() {
              return Parent.prototype;
            }
          });
          if (typeof extendFn === "function") {
            extendFn(Ctor, Parent);
          }
          Ctor.extend = extend(Ctor, extendFn);
        };
      }
      module2.exports = extend;
    }
  });

  // node_modules/class-utils/index.js
  var require_class_utils = __commonJS({
    "node_modules/class-utils/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var util = require_util();
      var union2 = require_arr_union();
      var define2 = require_define_property3();
      var staticExtend = require_static_extend();
      var isObj = require_isobject();
      var cu = module2.exports;
      cu.isObject = function isObject2(val) {
        return isObj(val) || typeof val === "function";
      };
      cu.has = function has2(obj, val) {
        val = cu.arrayify(val);
        var len = val.length;
        if (cu.isObject(obj)) {
          for (var key in obj) {
            if (val.indexOf(key) > -1) {
              return true;
            }
          }
          var keys2 = cu.nativeKeys(obj);
          return cu.has(keys2, val);
        }
        if (Array.isArray(obj)) {
          var arr = obj;
          while (len--) {
            if (arr.indexOf(val[len]) > -1) {
              return true;
            }
          }
          return false;
        }
        throw new TypeError("expected an array or object.");
      };
      cu.hasAll = function hasAll(val, values2) {
        values2 = cu.arrayify(values2);
        var len = values2.length;
        while (len--) {
          if (!cu.has(val, values2[len])) {
            return false;
          }
        }
        return true;
      };
      cu.arrayify = function arrayify(val) {
        return val ? Array.isArray(val) ? val : [val] : [];
      };
      cu.noop = function noop3() {
        return;
      };
      cu.identity = function identity2(val) {
        return val;
      };
      cu.hasConstructor = function hasConstructor(val) {
        return cu.isObject(val) && typeof val.constructor !== "undefined";
      };
      cu.nativeKeys = function nativeKeys2(val) {
        if (!cu.hasConstructor(val))
          return [];
        var keys2 = Object.getOwnPropertyNames(val);
        if ("caller" in val)
          keys2.push("caller");
        return keys2;
      };
      cu.getDescriptor = function getDescriptor(obj, key) {
        if (!cu.isObject(obj)) {
          throw new TypeError("expected an object.");
        }
        if (typeof key !== "string") {
          throw new TypeError("expected key to be a string.");
        }
        return Object.getOwnPropertyDescriptor(obj, key);
      };
      cu.copyDescriptor = function copyDescriptor(receiver, provider, name) {
        if (!cu.isObject(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!cu.isObject(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        if (typeof name !== "string") {
          throw new TypeError("expected name to be a string.");
        }
        var val = cu.getDescriptor(provider, name);
        if (val)
          Object.defineProperty(receiver, name, val);
      };
      cu.copy = function copy(receiver, provider, omit2) {
        if (!cu.isObject(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!cu.isObject(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        var props = Object.getOwnPropertyNames(provider);
        var keys2 = Object.keys(provider);
        var len = props.length, key;
        omit2 = cu.arrayify(omit2);
        while (len--) {
          key = props[len];
          if (cu.has(keys2, key)) {
            define2(receiver, key, provider[key]);
          } else if (!(key in receiver) && !cu.has(omit2, key)) {
            cu.copyDescriptor(receiver, provider, key);
          }
        }
      };
      cu.inherit = function inherit(receiver, provider, omit2) {
        if (!cu.isObject(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!cu.isObject(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        var keys2 = [];
        for (var key in provider) {
          keys2.push(key);
          receiver[key] = provider[key];
        }
        keys2 = keys2.concat(cu.arrayify(omit2));
        var a = provider.prototype || provider;
        var b = receiver.prototype || receiver;
        cu.copy(b, a, keys2);
      };
      cu.extend = function() {
        return staticExtend.apply(null, arguments);
      };
      cu.bubble = function(Parent, events) {
        events = events || [];
        Parent.bubble = function(Child, arr) {
          if (Array.isArray(arr)) {
            events = union2([], events, arr);
          }
          var len = events.length;
          var idx = -1;
          while (++idx < len) {
            var name = events[idx];
            Parent.on(name, Child.emit.bind(Child, name));
          }
          cu.bubble(Child, events);
        };
      };
    }
  });

  // node_modules/base/index.js
  var require_base = __commonJS({
    "node_modules/base/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var util = require_util();
      var define2 = require_define_property2();
      var CacheBase = require_cache_base();
      var Emitter = require_component_emitter();
      var isObject2 = require_isobject();
      var merge2 = require_mixin_deep();
      var pascal = require_pascalcase();
      var cu = require_class_utils();
      function namespace(name) {
        var Cache = name ? CacheBase.namespace(name) : CacheBase;
        var fns = [];
        function Base(config, options) {
          if (!(this instanceof Base)) {
            return new Base(config, options);
          }
          Cache.call(this, config);
          this.is("base");
          this.initBase(config, options);
        }
        util.inherits(Base, Cache);
        Emitter(Base);
        Base.prototype.initBase = function(config, options) {
          this.options = merge2({}, this.options, options);
          this.cache = this.cache || {};
          this.define("registered", {});
          if (name)
            this[name] = {};
          this.define("_callbacks", this._callbacks);
          if (isObject2(config)) {
            this.visit("set", config);
          }
          Base.run(this, "use", fns);
        };
        Base.prototype.is = function(name2) {
          if (typeof name2 !== "string") {
            throw new TypeError("expected name to be a string");
          }
          this.define("is" + pascal(name2), true);
          this.define("_name", name2);
          this.define("_appname", name2);
          return this;
        };
        Base.prototype.isRegistered = function(name2, register) {
          if (this.registered.hasOwnProperty(name2)) {
            return true;
          }
          if (register !== false) {
            this.registered[name2] = true;
            this.emit("plugin", name2);
          }
          return false;
        };
        Base.prototype.use = function(fn) {
          fn.call(this, this);
          return this;
        };
        Base.prototype.define = function(key, val) {
          if (isObject2(key)) {
            return this.visit("define", key);
          }
          define2(this, key, val);
          return this;
        };
        Base.prototype.mixin = function(key, val) {
          Base.prototype[key] = val;
          return this;
        };
        Base.prototype.mixins = Base.prototype.mixins || [];
        Object.defineProperty(Base.prototype, "base", {
          configurable: true,
          get: function() {
            return this.parent ? this.parent.base : this;
          }
        });
        define2(Base, "use", function(fn) {
          fns.push(fn);
          return Base;
        });
        define2(Base, "run", function(obj, prop, arr) {
          var len = arr.length, i = 0;
          while (len--) {
            obj[prop](arr[i++]);
          }
          return Base;
        });
        define2(Base, "extend", cu.extend(Base, function(Ctor, Parent) {
          Ctor.prototype.mixins = Ctor.prototype.mixins || [];
          define2(Ctor, "mixin", function(fn) {
            var mixin3 = fn(Ctor.prototype, Ctor);
            if (typeof mixin3 === "function") {
              Ctor.prototype.mixins.push(mixin3);
            }
            return Ctor;
          });
          define2(Ctor, "mixins", function(Child) {
            Base.run(Child, "mixin", Ctor.prototype.mixins);
            return Ctor;
          });
          Ctor.prototype.mixin = function(key, value) {
            Ctor.prototype[key] = value;
            return this;
          };
          return Base;
        }));
        define2(Base, "mixin", function(fn) {
          var mixin3 = fn(Base.prototype, Base);
          if (typeof mixin3 === "function") {
            Base.prototype.mixins.push(mixin3);
          }
          return Base;
        });
        define2(Base, "mixins", function(Child) {
          Base.run(Child, "mixin", Base.prototype.mixins);
          return Base;
        });
        define2(Base, "inherit", cu.inherit);
        define2(Base, "bubble", cu.bubble);
        return Base;
      }
      module2.exports = namespace();
      module2.exports.namespace = namespace;
    }
  });

  // node_modules/use/index.js
  var require_use = __commonJS({
    "node_modules/use/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function base(app, options) {
        if (!isObject2(app) && typeof app !== "function") {
          throw new TypeError("expected an object or function");
        }
        var opts = isObject2(options) ? options : {};
        var prop = typeof opts.prop === "string" ? opts.prop : "fns";
        if (!Array.isArray(app[prop])) {
          define2(app, prop, []);
        }
        define2(app, "use", use);
        define2(app, "run", function(val) {
          if (!isObject2(val))
            return;
          if (!val.use || !val.run) {
            define2(val, prop, val[prop] || []);
            define2(val, "use", use);
          }
          if (!val[prop] || val[prop].indexOf(base) === -1) {
            val.use(base);
          }
          var self2 = this || app;
          var fns = self2[prop];
          var len = fns.length;
          var idx = -1;
          while (++idx < len) {
            val.use(fns[idx]);
          }
          return val;
        });
        function use(type, fn, options2) {
          var offset = 1;
          if (typeof type === "string" || Array.isArray(type)) {
            fn = wrap2(type, fn);
            offset++;
          } else {
            options2 = fn;
            fn = type;
          }
          if (typeof fn !== "function") {
            throw new TypeError("expected a function");
          }
          var self2 = this || app;
          var fns = self2[prop];
          var args = [].slice.call(arguments, offset);
          args.unshift(self2);
          if (typeof opts.hook === "function") {
            opts.hook.apply(self2, args);
          }
          var val = fn.apply(self2, args);
          if (typeof val === "function" && fns.indexOf(val) === -1) {
            fns.push(val);
          }
          return self2;
        }
        function wrap2(type, fn) {
          return function plugin() {
            return this.type === type ? fn.apply(this, arguments) : plugin;
          };
        }
        return app;
      };
      function isObject2(val) {
        return val && typeof val === "object" && !Array.isArray(val);
      }
      function define2(obj, key, val) {
        Object.defineProperty(obj, key, {
          configurable: true,
          writable: true,
          value: val
        });
      }
    }
  });

  // node_modules/snapdragon/node_modules/ms/index.js
  var require_ms = __commonJS({
    "node_modules/snapdragon/node_modules/ms/index.js"(exports2, module2) {
      init_define_process();
      var s = 1e3;
      var m = s * 60;
      var h = m * 60;
      var d = h * 24;
      var y = d * 365.25;
      module2.exports = function(val, options) {
        options = options || {};
        var type = typeof val;
        if (type === "string" && val.length > 0) {
          return parse3(val);
        } else if (type === "number" && isNaN(val) === false) {
          return options.long ? fmtLong(val) : fmtShort(val);
        }
        throw new Error(
          "val is not a non-empty string or a valid number. val=" + JSON.stringify(val)
        );
      };
      function parse3(str) {
        str = String(str);
        if (str.length > 100) {
          return;
        }
        var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
          str
        );
        if (!match) {
          return;
        }
        var n = parseFloat(match[1]);
        var type = (match[2] || "ms").toLowerCase();
        switch (type) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return n * y;
          case "days":
          case "day":
          case "d":
            return n * d;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return n * h;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return n * m;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return n * s;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return n;
          default:
            return void 0;
        }
      }
      function fmtShort(ms) {
        if (ms >= d) {
          return Math.round(ms / d) + "d";
        }
        if (ms >= h) {
          return Math.round(ms / h) + "h";
        }
        if (ms >= m) {
          return Math.round(ms / m) + "m";
        }
        if (ms >= s) {
          return Math.round(ms / s) + "s";
        }
        return ms + "ms";
      }
      function fmtLong(ms) {
        return plural(ms, d, "day") || plural(ms, h, "hour") || plural(ms, m, "minute") || plural(ms, s, "second") || ms + " ms";
      }
      function plural(ms, n, name) {
        if (ms < n) {
          return;
        }
        if (ms < n * 1.5) {
          return Math.floor(ms / n) + " " + name;
        }
        return Math.ceil(ms / n) + " " + name + "s";
      }
    }
  });

  // node_modules/snapdragon/node_modules/debug/src/debug.js
  var require_debug = __commonJS({
    "node_modules/snapdragon/node_modules/debug/src/debug.js"(exports2, module2) {
      init_define_process();
      exports2 = module2.exports = createDebug2.debug = createDebug2["default"] = createDebug2;
      exports2.coerce = coerce;
      exports2.disable = disable;
      exports2.enable = enable;
      exports2.enabled = enabled;
      exports2.humanize = require_ms();
      exports2.names = [];
      exports2.skips = [];
      exports2.formatters = {};
      var prevTime;
      function selectColor(namespace) {
        var hash = 0, i;
        for (i in namespace) {
          hash = (hash << 5) - hash + namespace.charCodeAt(i);
          hash |= 0;
        }
        return exports2.colors[Math.abs(hash) % exports2.colors.length];
      }
      function createDebug2(namespace) {
        function debug2() {
          if (!debug2.enabled)
            return;
          var self2 = debug2;
          var curr = +new Date();
          var ms = curr - (prevTime || curr);
          self2.diff = ms;
          self2.prev = prevTime;
          self2.curr = curr;
          prevTime = curr;
          var args = new Array(arguments.length);
          for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i];
          }
          args[0] = exports2.coerce(args[0]);
          if ("string" !== typeof args[0]) {
            args.unshift("%O");
          }
          var index = 0;
          args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            if (match === "%%")
              return match;
            index++;
            var formatter = exports2.formatters[format];
            if ("function" === typeof formatter) {
              var val = args[index];
              match = formatter.call(self2, val);
              args.splice(index, 1);
              index--;
            }
            return match;
          });
          exports2.formatArgs.call(self2, args);
          var logFn = debug2.log || exports2.log || console.log.bind(console);
          logFn.apply(self2, args);
        }
        debug2.namespace = namespace;
        debug2.enabled = exports2.enabled(namespace);
        debug2.useColors = exports2.useColors();
        debug2.color = selectColor(namespace);
        if ("function" === typeof exports2.init) {
          exports2.init(debug2);
        }
        return debug2;
      }
      function enable(namespaces) {
        exports2.save(namespaces);
        exports2.names = [];
        exports2.skips = [];
        var split2 = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        var len = split2.length;
        for (var i = 0; i < len; i++) {
          if (!split2[i])
            continue;
          namespaces = split2[i].replace(/\*/g, ".*?");
          if (namespaces[0] === "-") {
            exports2.skips.push(new RegExp("^" + namespaces.substr(1) + "$"));
          } else {
            exports2.names.push(new RegExp("^" + namespaces + "$"));
          }
        }
      }
      function disable() {
        exports2.enable("");
      }
      function enabled(name) {
        var i, len;
        for (i = 0, len = exports2.skips.length; i < len; i++) {
          if (exports2.skips[i].test(name)) {
            return false;
          }
        }
        for (i = 0, len = exports2.names.length; i < len; i++) {
          if (exports2.names[i].test(name)) {
            return true;
          }
        }
        return false;
      }
      function coerce(val) {
        if (val instanceof Error)
          return val.stack || val.message;
        return val;
      }
    }
  });

  // node_modules/snapdragon/node_modules/debug/src/browser.js
  var require_browser = __commonJS({
    "node_modules/snapdragon/node_modules/debug/src/browser.js"(exports2, module2) {
      init_define_process();
      exports2 = module2.exports = require_debug();
      exports2.log = log;
      exports2.formatArgs = formatArgs;
      exports2.save = save;
      exports2.load = load;
      exports2.useColors = useColors;
      exports2.storage = "undefined" != typeof chrome && "undefined" != typeof chrome.storage ? chrome.storage.local : localstorage();
      exports2.colors = [
        "lightseagreen",
        "forestgreen",
        "goldenrod",
        "dodgerblue",
        "darkorchid",
        "crimson"
      ];
      function useColors() {
        if (typeof window !== "undefined" && window.process && window.process.type === "renderer") {
          return true;
        }
        return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }
      exports2.formatters.j = function(v) {
        try {
          return JSON.stringify(v);
        } catch (err) {
          return "[UnexpectedJSONParseError]: " + err.message;
        }
      };
      function formatArgs(args) {
        var useColors2 = this.useColors;
        args[0] = (useColors2 ? "%c" : "") + this.namespace + (useColors2 ? " %c" : " ") + args[0] + (useColors2 ? "%c " : " ") + "+" + exports2.humanize(this.diff);
        if (!useColors2)
          return;
        var c = "color: " + this.color;
        args.splice(1, 0, c, "color: inherit");
        var index = 0;
        var lastC = 0;
        args[0].replace(/%[a-zA-Z%]/g, function(match) {
          if ("%%" === match)
            return;
          index++;
          if ("%c" === match) {
            lastC = index;
          }
        });
        args.splice(lastC, 0, c);
      }
      function log() {
        return "object" === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
      }
      function save(namespaces) {
        try {
          if (null == namespaces) {
            exports2.storage.removeItem("debug");
          } else {
            exports2.storage.debug = namespaces;
          }
        } catch (e) {
        }
      }
      function load() {
        var r;
        try {
          r = exports2.storage.debug;
        } catch (e) {
        }
        if (!r && typeof define_process_default !== "undefined" && "env" in define_process_default) {
          r = define_process_default.env.DEBUG;
        }
        return r;
      }
      exports2.enable(load());
      function localstorage() {
        try {
          return window.localStorage;
        } catch (e) {
        }
      }
    }
  });

  // node_modules/snapdragon/node_modules/extend-shallow/index.js
  var require_extend_shallow3 = __commonJS({
    "node_modules/snapdragon/node_modules/extend-shallow/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_is_extendable2();
      module2.exports = function extend(o) {
        if (!isObject2(o)) {
          o = {};
        }
        var len = arguments.length;
        for (var i = 1; i < len; i++) {
          var obj = arguments[i];
          if (isObject2(obj)) {
            assign2(o, obj);
          }
        }
        return o;
      };
      function assign2(a, b) {
        for (var key in b) {
          if (hasOwn(b, key)) {
            a[key] = b[key];
          }
        }
      }
      function hasOwn(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
      }
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/base64.js
  var require_base64 = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/base64.js"(exports2) {
      init_define_process();
      var intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
      exports2.encode = function(number) {
        if (0 <= number && number < intToCharMap.length) {
          return intToCharMap[number];
        }
        throw new TypeError("Must be between 0 and 63: " + number);
      };
      exports2.decode = function(charCode) {
        var bigA = 65;
        var bigZ = 90;
        var littleA = 97;
        var littleZ = 122;
        var zero = 48;
        var nine = 57;
        var plus = 43;
        var slash = 47;
        var littleOffset = 26;
        var numberOffset = 52;
        if (bigA <= charCode && charCode <= bigZ) {
          return charCode - bigA;
        }
        if (littleA <= charCode && charCode <= littleZ) {
          return charCode - littleA + littleOffset;
        }
        if (zero <= charCode && charCode <= nine) {
          return charCode - zero + numberOffset;
        }
        if (charCode == plus) {
          return 62;
        }
        if (charCode == slash) {
          return 63;
        }
        return -1;
      };
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/base64-vlq.js
  var require_base64_vlq = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/base64-vlq.js"(exports2) {
      init_define_process();
      var base64 = require_base64();
      var VLQ_BASE_SHIFT = 5;
      var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
      var VLQ_BASE_MASK = VLQ_BASE - 1;
      var VLQ_CONTINUATION_BIT = VLQ_BASE;
      function toVLQSigned(aValue) {
        return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
      }
      function fromVLQSigned(aValue) {
        var isNegative = (aValue & 1) === 1;
        var shifted = aValue >> 1;
        return isNegative ? -shifted : shifted;
      }
      exports2.encode = function base64VLQ_encode(aValue) {
        var encoded = "";
        var digit;
        var vlq = toVLQSigned(aValue);
        do {
          digit = vlq & VLQ_BASE_MASK;
          vlq >>>= VLQ_BASE_SHIFT;
          if (vlq > 0) {
            digit |= VLQ_CONTINUATION_BIT;
          }
          encoded += base64.encode(digit);
        } while (vlq > 0);
        return encoded;
      };
      exports2.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
        var strLen = aStr.length;
        var result2 = 0;
        var shift = 0;
        var continuation, digit;
        do {
          if (aIndex >= strLen) {
            throw new Error("Expected more digits in base 64 VLQ value.");
          }
          digit = base64.decode(aStr.charCodeAt(aIndex++));
          if (digit === -1) {
            throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
          }
          continuation = !!(digit & VLQ_CONTINUATION_BIT);
          digit &= VLQ_BASE_MASK;
          result2 = result2 + (digit << shift);
          shift += VLQ_BASE_SHIFT;
        } while (continuation);
        aOutParam.value = fromVLQSigned(result2);
        aOutParam.rest = aIndex;
      };
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/util.js
  var require_util3 = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/util.js"(exports2) {
      init_define_process();
      function getArg(aArgs, aName, aDefaultValue) {
        if (aName in aArgs) {
          return aArgs[aName];
        } else if (arguments.length === 3) {
          return aDefaultValue;
        } else {
          throw new Error('"' + aName + '" is a required argument.');
        }
      }
      exports2.getArg = getArg;
      var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
      var dataUrlRegexp = /^data:.+\,.+$/;
      function urlParse(aUrl) {
        var match = aUrl.match(urlRegexp);
        if (!match) {
          return null;
        }
        return {
          scheme: match[1],
          auth: match[2],
          host: match[3],
          port: match[4],
          path: match[5]
        };
      }
      exports2.urlParse = urlParse;
      function urlGenerate(aParsedUrl) {
        var url = "";
        if (aParsedUrl.scheme) {
          url += aParsedUrl.scheme + ":";
        }
        url += "//";
        if (aParsedUrl.auth) {
          url += aParsedUrl.auth + "@";
        }
        if (aParsedUrl.host) {
          url += aParsedUrl.host;
        }
        if (aParsedUrl.port) {
          url += ":" + aParsedUrl.port;
        }
        if (aParsedUrl.path) {
          url += aParsedUrl.path;
        }
        return url;
      }
      exports2.urlGenerate = urlGenerate;
      function normalize(aPath) {
        var path = aPath;
        var url = urlParse(aPath);
        if (url) {
          if (!url.path) {
            return aPath;
          }
          path = url.path;
        }
        var isAbsolute = exports2.isAbsolute(path);
        var parts = path.split(/\/+/);
        for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
          part = parts[i];
          if (part === ".") {
            parts.splice(i, 1);
          } else if (part === "..") {
            up++;
          } else if (up > 0) {
            if (part === "") {
              parts.splice(i + 1, up);
              up = 0;
            } else {
              parts.splice(i, 2);
              up--;
            }
          }
        }
        path = parts.join("/");
        if (path === "") {
          path = isAbsolute ? "/" : ".";
        }
        if (url) {
          url.path = path;
          return urlGenerate(url);
        }
        return path;
      }
      exports2.normalize = normalize;
      function join2(aRoot, aPath) {
        if (aRoot === "") {
          aRoot = ".";
        }
        if (aPath === "") {
          aPath = ".";
        }
        var aPathUrl = urlParse(aPath);
        var aRootUrl = urlParse(aRoot);
        if (aRootUrl) {
          aRoot = aRootUrl.path || "/";
        }
        if (aPathUrl && !aPathUrl.scheme) {
          if (aRootUrl) {
            aPathUrl.scheme = aRootUrl.scheme;
          }
          return urlGenerate(aPathUrl);
        }
        if (aPathUrl || aPath.match(dataUrlRegexp)) {
          return aPath;
        }
        if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
          aRootUrl.host = aPath;
          return urlGenerate(aRootUrl);
        }
        var joined = aPath.charAt(0) === "/" ? aPath : normalize(aRoot.replace(/\/+$/, "") + "/" + aPath);
        if (aRootUrl) {
          aRootUrl.path = joined;
          return urlGenerate(aRootUrl);
        }
        return joined;
      }
      exports2.join = join2;
      exports2.isAbsolute = function(aPath) {
        return aPath.charAt(0) === "/" || !!aPath.match(urlRegexp);
      };
      function relative(aRoot, aPath) {
        if (aRoot === "") {
          aRoot = ".";
        }
        aRoot = aRoot.replace(/\/$/, "");
        var level = 0;
        while (aPath.indexOf(aRoot + "/") !== 0) {
          var index = aRoot.lastIndexOf("/");
          if (index < 0) {
            return aPath;
          }
          aRoot = aRoot.slice(0, index);
          if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
            return aPath;
          }
          ++level;
        }
        return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
      }
      exports2.relative = relative;
      var supportsNullProto = function() {
        var obj = /* @__PURE__ */ Object.create(null);
        return !("__proto__" in obj);
      }();
      function identity2(s) {
        return s;
      }
      function toSetString(aStr) {
        if (isProtoString(aStr)) {
          return "$" + aStr;
        }
        return aStr;
      }
      exports2.toSetString = supportsNullProto ? identity2 : toSetString;
      function fromSetString(aStr) {
        if (isProtoString(aStr)) {
          return aStr.slice(1);
        }
        return aStr;
      }
      exports2.fromSetString = supportsNullProto ? identity2 : fromSetString;
      function isProtoString(s) {
        if (!s) {
          return false;
        }
        var length = s.length;
        if (length < 9) {
          return false;
        }
        if (s.charCodeAt(length - 1) !== 95 || s.charCodeAt(length - 2) !== 95 || s.charCodeAt(length - 3) !== 111 || s.charCodeAt(length - 4) !== 116 || s.charCodeAt(length - 5) !== 111 || s.charCodeAt(length - 6) !== 114 || s.charCodeAt(length - 7) !== 112 || s.charCodeAt(length - 8) !== 95 || s.charCodeAt(length - 9) !== 95) {
          return false;
        }
        for (var i = length - 10; i >= 0; i--) {
          if (s.charCodeAt(i) !== 36) {
            return false;
          }
        }
        return true;
      }
      function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
        var cmp = mappingA.source - mappingB.source;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalLine - mappingB.originalLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalColumn - mappingB.originalColumn;
        if (cmp !== 0 || onlyCompareOriginal) {
          return cmp;
        }
        cmp = mappingA.generatedColumn - mappingB.generatedColumn;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.generatedLine - mappingB.generatedLine;
        if (cmp !== 0) {
          return cmp;
        }
        return mappingA.name - mappingB.name;
      }
      exports2.compareByOriginalPositions = compareByOriginalPositions;
      function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
        var cmp = mappingA.generatedLine - mappingB.generatedLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.generatedColumn - mappingB.generatedColumn;
        if (cmp !== 0 || onlyCompareGenerated) {
          return cmp;
        }
        cmp = mappingA.source - mappingB.source;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalLine - mappingB.originalLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalColumn - mappingB.originalColumn;
        if (cmp !== 0) {
          return cmp;
        }
        return mappingA.name - mappingB.name;
      }
      exports2.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
      function strcmp(aStr1, aStr2) {
        if (aStr1 === aStr2) {
          return 0;
        }
        if (aStr1 > aStr2) {
          return 1;
        }
        return -1;
      }
      function compareByGeneratedPositionsInflated(mappingA, mappingB) {
        var cmp = mappingA.generatedLine - mappingB.generatedLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.generatedColumn - mappingB.generatedColumn;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = strcmp(mappingA.source, mappingB.source);
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalLine - mappingB.originalLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalColumn - mappingB.originalColumn;
        if (cmp !== 0) {
          return cmp;
        }
        return strcmp(mappingA.name, mappingB.name);
      }
      exports2.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/array-set.js
  var require_array_set = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/array-set.js"(exports2) {
      init_define_process();
      var util = require_util3();
      var has2 = Object.prototype.hasOwnProperty;
      var hasNativeMap = typeof Map !== "undefined";
      function ArraySet() {
        this._array = [];
        this._set = hasNativeMap ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
      }
      ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
        var set2 = new ArraySet();
        for (var i = 0, len = aArray.length; i < len; i++) {
          set2.add(aArray[i], aAllowDuplicates);
        }
        return set2;
      };
      ArraySet.prototype.size = function ArraySet_size() {
        return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
      };
      ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
        var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
        var isDuplicate = hasNativeMap ? this.has(aStr) : has2.call(this._set, sStr);
        var idx = this._array.length;
        if (!isDuplicate || aAllowDuplicates) {
          this._array.push(aStr);
        }
        if (!isDuplicate) {
          if (hasNativeMap) {
            this._set.set(aStr, idx);
          } else {
            this._set[sStr] = idx;
          }
        }
      };
      ArraySet.prototype.has = function ArraySet_has(aStr) {
        if (hasNativeMap) {
          return this._set.has(aStr);
        } else {
          var sStr = util.toSetString(aStr);
          return has2.call(this._set, sStr);
        }
      };
      ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
        if (hasNativeMap) {
          var idx = this._set.get(aStr);
          if (idx >= 0) {
            return idx;
          }
        } else {
          var sStr = util.toSetString(aStr);
          if (has2.call(this._set, sStr)) {
            return this._set[sStr];
          }
        }
        throw new Error('"' + aStr + '" is not in the set.');
      };
      ArraySet.prototype.at = function ArraySet_at(aIdx) {
        if (aIdx >= 0 && aIdx < this._array.length) {
          return this._array[aIdx];
        }
        throw new Error("No element indexed by " + aIdx);
      };
      ArraySet.prototype.toArray = function ArraySet_toArray() {
        return this._array.slice();
      };
      exports2.ArraySet = ArraySet;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/mapping-list.js
  var require_mapping_list = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/mapping-list.js"(exports2) {
      init_define_process();
      var util = require_util3();
      function generatedPositionAfter(mappingA, mappingB) {
        var lineA = mappingA.generatedLine;
        var lineB = mappingB.generatedLine;
        var columnA = mappingA.generatedColumn;
        var columnB = mappingB.generatedColumn;
        return lineB > lineA || lineB == lineA && columnB >= columnA || util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
      }
      function MappingList() {
        this._array = [];
        this._sorted = true;
        this._last = { generatedLine: -1, generatedColumn: 0 };
      }
      MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
        this._array.forEach(aCallback, aThisArg);
      };
      MappingList.prototype.add = function MappingList_add(aMapping) {
        if (generatedPositionAfter(this._last, aMapping)) {
          this._last = aMapping;
          this._array.push(aMapping);
        } else {
          this._sorted = false;
          this._array.push(aMapping);
        }
      };
      MappingList.prototype.toArray = function MappingList_toArray() {
        if (!this._sorted) {
          this._array.sort(util.compareByGeneratedPositionsInflated);
          this._sorted = true;
        }
        return this._array;
      };
      exports2.MappingList = MappingList;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/source-map-generator.js
  var require_source_map_generator = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/source-map-generator.js"(exports2) {
      init_define_process();
      var base64VLQ = require_base64_vlq();
      var util = require_util3();
      var ArraySet = require_array_set().ArraySet;
      var MappingList = require_mapping_list().MappingList;
      function SourceMapGenerator(aArgs) {
        if (!aArgs) {
          aArgs = {};
        }
        this._file = util.getArg(aArgs, "file", null);
        this._sourceRoot = util.getArg(aArgs, "sourceRoot", null);
        this._skipValidation = util.getArg(aArgs, "skipValidation", false);
        this._sources = new ArraySet();
        this._names = new ArraySet();
        this._mappings = new MappingList();
        this._sourcesContents = null;
      }
      SourceMapGenerator.prototype._version = 3;
      SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
        var sourceRoot = aSourceMapConsumer.sourceRoot;
        var generator = new SourceMapGenerator({
          file: aSourceMapConsumer.file,
          sourceRoot
        });
        aSourceMapConsumer.eachMapping(function(mapping) {
          var newMapping = {
            generated: {
              line: mapping.generatedLine,
              column: mapping.generatedColumn
            }
          };
          if (mapping.source != null) {
            newMapping.source = mapping.source;
            if (sourceRoot != null) {
              newMapping.source = util.relative(sourceRoot, newMapping.source);
            }
            newMapping.original = {
              line: mapping.originalLine,
              column: mapping.originalColumn
            };
            if (mapping.name != null) {
              newMapping.name = mapping.name;
            }
          }
          generator.addMapping(newMapping);
        });
        aSourceMapConsumer.sources.forEach(function(sourceFile) {
          var content = aSourceMapConsumer.sourceContentFor(sourceFile);
          if (content != null) {
            generator.setSourceContent(sourceFile, content);
          }
        });
        return generator;
      };
      SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
        var generated = util.getArg(aArgs, "generated");
        var original = util.getArg(aArgs, "original", null);
        var source = util.getArg(aArgs, "source", null);
        var name = util.getArg(aArgs, "name", null);
        if (!this._skipValidation) {
          this._validateMapping(generated, original, source, name);
        }
        if (source != null) {
          source = String(source);
          if (!this._sources.has(source)) {
            this._sources.add(source);
          }
        }
        if (name != null) {
          name = String(name);
          if (!this._names.has(name)) {
            this._names.add(name);
          }
        }
        this._mappings.add({
          generatedLine: generated.line,
          generatedColumn: generated.column,
          originalLine: original != null && original.line,
          originalColumn: original != null && original.column,
          source,
          name
        });
      };
      SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
        var source = aSourceFile;
        if (this._sourceRoot != null) {
          source = util.relative(this._sourceRoot, source);
        }
        if (aSourceContent != null) {
          if (!this._sourcesContents) {
            this._sourcesContents = /* @__PURE__ */ Object.create(null);
          }
          this._sourcesContents[util.toSetString(source)] = aSourceContent;
        } else if (this._sourcesContents) {
          delete this._sourcesContents[util.toSetString(source)];
          if (Object.keys(this._sourcesContents).length === 0) {
            this._sourcesContents = null;
          }
        }
      };
      SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
        var sourceFile = aSourceFile;
        if (aSourceFile == null) {
          if (aSourceMapConsumer.file == null) {
            throw new Error(
              `SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`
            );
          }
          sourceFile = aSourceMapConsumer.file;
        }
        var sourceRoot = this._sourceRoot;
        if (sourceRoot != null) {
          sourceFile = util.relative(sourceRoot, sourceFile);
        }
        var newSources = new ArraySet();
        var newNames = new ArraySet();
        this._mappings.unsortedForEach(function(mapping) {
          if (mapping.source === sourceFile && mapping.originalLine != null) {
            var original = aSourceMapConsumer.originalPositionFor({
              line: mapping.originalLine,
              column: mapping.originalColumn
            });
            if (original.source != null) {
              mapping.source = original.source;
              if (aSourceMapPath != null) {
                mapping.source = util.join(aSourceMapPath, mapping.source);
              }
              if (sourceRoot != null) {
                mapping.source = util.relative(sourceRoot, mapping.source);
              }
              mapping.originalLine = original.line;
              mapping.originalColumn = original.column;
              if (original.name != null) {
                mapping.name = original.name;
              }
            }
          }
          var source = mapping.source;
          if (source != null && !newSources.has(source)) {
            newSources.add(source);
          }
          var name = mapping.name;
          if (name != null && !newNames.has(name)) {
            newNames.add(name);
          }
        }, this);
        this._sources = newSources;
        this._names = newNames;
        aSourceMapConsumer.sources.forEach(function(sourceFile2) {
          var content = aSourceMapConsumer.sourceContentFor(sourceFile2);
          if (content != null) {
            if (aSourceMapPath != null) {
              sourceFile2 = util.join(aSourceMapPath, sourceFile2);
            }
            if (sourceRoot != null) {
              sourceFile2 = util.relative(sourceRoot, sourceFile2);
            }
            this.setSourceContent(sourceFile2, content);
          }
        }, this);
      };
      SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
        if (aOriginal && typeof aOriginal.line !== "number" && typeof aOriginal.column !== "number") {
          throw new Error(
            "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values."
          );
        }
        if (aGenerated && "line" in aGenerated && "column" in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) {
          return;
        } else if (aGenerated && "line" in aGenerated && "column" in aGenerated && aOriginal && "line" in aOriginal && "column" in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) {
          return;
        } else {
          throw new Error("Invalid mapping: " + JSON.stringify({
            generated: aGenerated,
            source: aSource,
            original: aOriginal,
            name: aName
          }));
        }
      };
      SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
        var previousGeneratedColumn = 0;
        var previousGeneratedLine = 1;
        var previousOriginalColumn = 0;
        var previousOriginalLine = 0;
        var previousName = 0;
        var previousSource = 0;
        var result2 = "";
        var next;
        var mapping;
        var nameIdx;
        var sourceIdx;
        var mappings = this._mappings.toArray();
        for (var i = 0, len = mappings.length; i < len; i++) {
          mapping = mappings[i];
          next = "";
          if (mapping.generatedLine !== previousGeneratedLine) {
            previousGeneratedColumn = 0;
            while (mapping.generatedLine !== previousGeneratedLine) {
              next += ";";
              previousGeneratedLine++;
            }
          } else {
            if (i > 0) {
              if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
                continue;
              }
              next += ",";
            }
          }
          next += base64VLQ.encode(mapping.generatedColumn - previousGeneratedColumn);
          previousGeneratedColumn = mapping.generatedColumn;
          if (mapping.source != null) {
            sourceIdx = this._sources.indexOf(mapping.source);
            next += base64VLQ.encode(sourceIdx - previousSource);
            previousSource = sourceIdx;
            next += base64VLQ.encode(mapping.originalLine - 1 - previousOriginalLine);
            previousOriginalLine = mapping.originalLine - 1;
            next += base64VLQ.encode(mapping.originalColumn - previousOriginalColumn);
            previousOriginalColumn = mapping.originalColumn;
            if (mapping.name != null) {
              nameIdx = this._names.indexOf(mapping.name);
              next += base64VLQ.encode(nameIdx - previousName);
              previousName = nameIdx;
            }
          }
          result2 += next;
        }
        return result2;
      };
      SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
        return aSources.map(function(source) {
          if (!this._sourcesContents) {
            return null;
          }
          if (aSourceRoot != null) {
            source = util.relative(aSourceRoot, source);
          }
          var key = util.toSetString(source);
          return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
        }, this);
      };
      SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
        var map2 = {
          version: this._version,
          sources: this._sources.toArray(),
          names: this._names.toArray(),
          mappings: this._serializeMappings()
        };
        if (this._file != null) {
          map2.file = this._file;
        }
        if (this._sourceRoot != null) {
          map2.sourceRoot = this._sourceRoot;
        }
        if (this._sourcesContents) {
          map2.sourcesContent = this._generateSourcesContent(map2.sources, map2.sourceRoot);
        }
        return map2;
      };
      SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
        return JSON.stringify(this.toJSON());
      };
      exports2.SourceMapGenerator = SourceMapGenerator;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/binary-search.js
  var require_binary_search = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/binary-search.js"(exports2) {
      init_define_process();
      exports2.GREATEST_LOWER_BOUND = 1;
      exports2.LEAST_UPPER_BOUND = 2;
      function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
        var mid = Math.floor((aHigh - aLow) / 2) + aLow;
        var cmp = aCompare(aNeedle, aHaystack[mid], true);
        if (cmp === 0) {
          return mid;
        } else if (cmp > 0) {
          if (aHigh - mid > 1) {
            return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
          }
          if (aBias == exports2.LEAST_UPPER_BOUND) {
            return aHigh < aHaystack.length ? aHigh : -1;
          } else {
            return mid;
          }
        } else {
          if (mid - aLow > 1) {
            return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
          }
          if (aBias == exports2.LEAST_UPPER_BOUND) {
            return mid;
          } else {
            return aLow < 0 ? -1 : aLow;
          }
        }
      }
      exports2.search = function search(aNeedle, aHaystack, aCompare, aBias) {
        if (aHaystack.length === 0) {
          return -1;
        }
        var index = recursiveSearch(
          -1,
          aHaystack.length,
          aNeedle,
          aHaystack,
          aCompare,
          aBias || exports2.GREATEST_LOWER_BOUND
        );
        if (index < 0) {
          return -1;
        }
        while (index - 1 >= 0) {
          if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
            break;
          }
          --index;
        }
        return index;
      };
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/quick-sort.js
  var require_quick_sort = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/quick-sort.js"(exports2) {
      init_define_process();
      function swap(ary2, x, y) {
        var temp = ary2[x];
        ary2[x] = ary2[y];
        ary2[y] = temp;
      }
      function randomIntInRange(low, high) {
        return Math.round(low + Math.random() * (high - low));
      }
      function doQuickSort(ary2, comparator, p, r) {
        if (p < r) {
          var pivotIndex = randomIntInRange(p, r);
          var i = p - 1;
          swap(ary2, pivotIndex, r);
          var pivot = ary2[r];
          for (var j = p; j < r; j++) {
            if (comparator(ary2[j], pivot) <= 0) {
              i += 1;
              swap(ary2, i, j);
            }
          }
          swap(ary2, i + 1, j);
          var q = i + 1;
          doQuickSort(ary2, comparator, p, q - 1);
          doQuickSort(ary2, comparator, q + 1, r);
        }
      }
      exports2.quickSort = function(ary2, comparator) {
        doQuickSort(ary2, comparator, 0, ary2.length - 1);
      };
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/source-map-consumer.js
  var require_source_map_consumer = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/source-map-consumer.js"(exports2) {
      init_define_process();
      var util = require_util3();
      var binarySearch = require_binary_search();
      var ArraySet = require_array_set().ArraySet;
      var base64VLQ = require_base64_vlq();
      var quickSort = require_quick_sort().quickSort;
      function SourceMapConsumer(aSourceMap) {
        var sourceMap = aSourceMap;
        if (typeof aSourceMap === "string") {
          sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
        }
        return sourceMap.sections != null ? new IndexedSourceMapConsumer(sourceMap) : new BasicSourceMapConsumer(sourceMap);
      }
      SourceMapConsumer.fromSourceMap = function(aSourceMap) {
        return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
      };
      SourceMapConsumer.prototype._version = 3;
      SourceMapConsumer.prototype.__generatedMappings = null;
      Object.defineProperty(SourceMapConsumer.prototype, "_generatedMappings", {
        get: function() {
          if (!this.__generatedMappings) {
            this._parseMappings(this._mappings, this.sourceRoot);
          }
          return this.__generatedMappings;
        }
      });
      SourceMapConsumer.prototype.__originalMappings = null;
      Object.defineProperty(SourceMapConsumer.prototype, "_originalMappings", {
        get: function() {
          if (!this.__originalMappings) {
            this._parseMappings(this._mappings, this.sourceRoot);
          }
          return this.__originalMappings;
        }
      });
      SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
        var c = aStr.charAt(index);
        return c === ";" || c === ",";
      };
      SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
        throw new Error("Subclasses must implement _parseMappings");
      };
      SourceMapConsumer.GENERATED_ORDER = 1;
      SourceMapConsumer.ORIGINAL_ORDER = 2;
      SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
      SourceMapConsumer.LEAST_UPPER_BOUND = 2;
      SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
        var context = aContext || null;
        var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
        var mappings;
        switch (order) {
          case SourceMapConsumer.GENERATED_ORDER:
            mappings = this._generatedMappings;
            break;
          case SourceMapConsumer.ORIGINAL_ORDER:
            mappings = this._originalMappings;
            break;
          default:
            throw new Error("Unknown order of iteration.");
        }
        var sourceRoot = this.sourceRoot;
        mappings.map(function(mapping) {
          var source = mapping.source === null ? null : this._sources.at(mapping.source);
          if (source != null && sourceRoot != null) {
            source = util.join(sourceRoot, source);
          }
          return {
            source,
            generatedLine: mapping.generatedLine,
            generatedColumn: mapping.generatedColumn,
            originalLine: mapping.originalLine,
            originalColumn: mapping.originalColumn,
            name: mapping.name === null ? null : this._names.at(mapping.name)
          };
        }, this).forEach(aCallback, context);
      };
      SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
        var line = util.getArg(aArgs, "line");
        var needle = {
          source: util.getArg(aArgs, "source"),
          originalLine: line,
          originalColumn: util.getArg(aArgs, "column", 0)
        };
        if (this.sourceRoot != null) {
          needle.source = util.relative(this.sourceRoot, needle.source);
        }
        if (!this._sources.has(needle.source)) {
          return [];
        }
        needle.source = this._sources.indexOf(needle.source);
        var mappings = [];
        var index = this._findMapping(
          needle,
          this._originalMappings,
          "originalLine",
          "originalColumn",
          util.compareByOriginalPositions,
          binarySearch.LEAST_UPPER_BOUND
        );
        if (index >= 0) {
          var mapping = this._originalMappings[index];
          if (aArgs.column === void 0) {
            var originalLine = mapping.originalLine;
            while (mapping && mapping.originalLine === originalLine) {
              mappings.push({
                line: util.getArg(mapping, "generatedLine", null),
                column: util.getArg(mapping, "generatedColumn", null),
                lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
              });
              mapping = this._originalMappings[++index];
            }
          } else {
            var originalColumn = mapping.originalColumn;
            while (mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn) {
              mappings.push({
                line: util.getArg(mapping, "generatedLine", null),
                column: util.getArg(mapping, "generatedColumn", null),
                lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
              });
              mapping = this._originalMappings[++index];
            }
          }
        }
        return mappings;
      };
      exports2.SourceMapConsumer = SourceMapConsumer;
      function BasicSourceMapConsumer(aSourceMap) {
        var sourceMap = aSourceMap;
        if (typeof aSourceMap === "string") {
          sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
        }
        var version = util.getArg(sourceMap, "version");
        var sources = util.getArg(sourceMap, "sources");
        var names = util.getArg(sourceMap, "names", []);
        var sourceRoot = util.getArg(sourceMap, "sourceRoot", null);
        var sourcesContent = util.getArg(sourceMap, "sourcesContent", null);
        var mappings = util.getArg(sourceMap, "mappings");
        var file2 = util.getArg(sourceMap, "file", null);
        if (version != this._version) {
          throw new Error("Unsupported version: " + version);
        }
        sources = sources.map(String).map(util.normalize).map(function(source) {
          return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source) ? util.relative(sourceRoot, source) : source;
        });
        this._names = ArraySet.fromArray(names.map(String), true);
        this._sources = ArraySet.fromArray(sources, true);
        this.sourceRoot = sourceRoot;
        this.sourcesContent = sourcesContent;
        this._mappings = mappings;
        this.file = file2;
      }
      BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
      BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
      BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap) {
        var smc = Object.create(BasicSourceMapConsumer.prototype);
        var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
        var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
        smc.sourceRoot = aSourceMap._sourceRoot;
        smc.sourcesContent = aSourceMap._generateSourcesContent(
          smc._sources.toArray(),
          smc.sourceRoot
        );
        smc.file = aSourceMap._file;
        var generatedMappings = aSourceMap._mappings.toArray().slice();
        var destGeneratedMappings = smc.__generatedMappings = [];
        var destOriginalMappings = smc.__originalMappings = [];
        for (var i = 0, length = generatedMappings.length; i < length; i++) {
          var srcMapping = generatedMappings[i];
          var destMapping = new Mapping();
          destMapping.generatedLine = srcMapping.generatedLine;
          destMapping.generatedColumn = srcMapping.generatedColumn;
          if (srcMapping.source) {
            destMapping.source = sources.indexOf(srcMapping.source);
            destMapping.originalLine = srcMapping.originalLine;
            destMapping.originalColumn = srcMapping.originalColumn;
            if (srcMapping.name) {
              destMapping.name = names.indexOf(srcMapping.name);
            }
            destOriginalMappings.push(destMapping);
          }
          destGeneratedMappings.push(destMapping);
        }
        quickSort(smc.__originalMappings, util.compareByOriginalPositions);
        return smc;
      };
      BasicSourceMapConsumer.prototype._version = 3;
      Object.defineProperty(BasicSourceMapConsumer.prototype, "sources", {
        get: function() {
          return this._sources.toArray().map(function(s) {
            return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
          }, this);
        }
      });
      function Mapping() {
        this.generatedLine = 0;
        this.generatedColumn = 0;
        this.source = null;
        this.originalLine = null;
        this.originalColumn = null;
        this.name = null;
      }
      BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
        var generatedLine = 1;
        var previousGeneratedColumn = 0;
        var previousOriginalLine = 0;
        var previousOriginalColumn = 0;
        var previousSource = 0;
        var previousName = 0;
        var length = aStr.length;
        var index = 0;
        var cachedSegments = {};
        var temp = {};
        var originalMappings = [];
        var generatedMappings = [];
        var mapping, str, segment, end, value;
        while (index < length) {
          if (aStr.charAt(index) === ";") {
            generatedLine++;
            index++;
            previousGeneratedColumn = 0;
          } else if (aStr.charAt(index) === ",") {
            index++;
          } else {
            mapping = new Mapping();
            mapping.generatedLine = generatedLine;
            for (end = index; end < length; end++) {
              if (this._charIsMappingSeparator(aStr, end)) {
                break;
              }
            }
            str = aStr.slice(index, end);
            segment = cachedSegments[str];
            if (segment) {
              index += str.length;
            } else {
              segment = [];
              while (index < end) {
                base64VLQ.decode(aStr, index, temp);
                value = temp.value;
                index = temp.rest;
                segment.push(value);
              }
              if (segment.length === 2) {
                throw new Error("Found a source, but no line and column");
              }
              if (segment.length === 3) {
                throw new Error("Found a source and line, but no column");
              }
              cachedSegments[str] = segment;
            }
            mapping.generatedColumn = previousGeneratedColumn + segment[0];
            previousGeneratedColumn = mapping.generatedColumn;
            if (segment.length > 1) {
              mapping.source = previousSource + segment[1];
              previousSource += segment[1];
              mapping.originalLine = previousOriginalLine + segment[2];
              previousOriginalLine = mapping.originalLine;
              mapping.originalLine += 1;
              mapping.originalColumn = previousOriginalColumn + segment[3];
              previousOriginalColumn = mapping.originalColumn;
              if (segment.length > 4) {
                mapping.name = previousName + segment[4];
                previousName += segment[4];
              }
            }
            generatedMappings.push(mapping);
            if (typeof mapping.originalLine === "number") {
              originalMappings.push(mapping);
            }
          }
        }
        quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
        this.__generatedMappings = generatedMappings;
        quickSort(originalMappings, util.compareByOriginalPositions);
        this.__originalMappings = originalMappings;
      };
      BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
        if (aNeedle[aLineName] <= 0) {
          throw new TypeError("Line must be greater than or equal to 1, got " + aNeedle[aLineName]);
        }
        if (aNeedle[aColumnName] < 0) {
          throw new TypeError("Column must be greater than or equal to 0, got " + aNeedle[aColumnName]);
        }
        return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
      };
      BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
        for (var index = 0; index < this._generatedMappings.length; ++index) {
          var mapping = this._generatedMappings[index];
          if (index + 1 < this._generatedMappings.length) {
            var nextMapping = this._generatedMappings[index + 1];
            if (mapping.generatedLine === nextMapping.generatedLine) {
              mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
              continue;
            }
          }
          mapping.lastGeneratedColumn = Infinity;
        }
      };
      BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
        var needle = {
          generatedLine: util.getArg(aArgs, "line"),
          generatedColumn: util.getArg(aArgs, "column")
        };
        var index = this._findMapping(
          needle,
          this._generatedMappings,
          "generatedLine",
          "generatedColumn",
          util.compareByGeneratedPositionsDeflated,
          util.getArg(aArgs, "bias", SourceMapConsumer.GREATEST_LOWER_BOUND)
        );
        if (index >= 0) {
          var mapping = this._generatedMappings[index];
          if (mapping.generatedLine === needle.generatedLine) {
            var source = util.getArg(mapping, "source", null);
            if (source !== null) {
              source = this._sources.at(source);
              if (this.sourceRoot != null) {
                source = util.join(this.sourceRoot, source);
              }
            }
            var name = util.getArg(mapping, "name", null);
            if (name !== null) {
              name = this._names.at(name);
            }
            return {
              source,
              line: util.getArg(mapping, "originalLine", null),
              column: util.getArg(mapping, "originalColumn", null),
              name
            };
          }
        }
        return {
          source: null,
          line: null,
          column: null,
          name: null
        };
      };
      BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
        if (!this.sourcesContent) {
          return false;
        }
        return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
          return sc == null;
        });
      };
      BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
        if (!this.sourcesContent) {
          return null;
        }
        if (this.sourceRoot != null) {
          aSource = util.relative(this.sourceRoot, aSource);
        }
        if (this._sources.has(aSource)) {
          return this.sourcesContent[this._sources.indexOf(aSource)];
        }
        var url;
        if (this.sourceRoot != null && (url = util.urlParse(this.sourceRoot))) {
          var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
          if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) {
            return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
          }
          if ((!url.path || url.path == "/") && this._sources.has("/" + aSource)) {
            return this.sourcesContent[this._sources.indexOf("/" + aSource)];
          }
        }
        if (nullOnMissing) {
          return null;
        } else {
          throw new Error('"' + aSource + '" is not in the SourceMap.');
        }
      };
      BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
        var source = util.getArg(aArgs, "source");
        if (this.sourceRoot != null) {
          source = util.relative(this.sourceRoot, source);
        }
        if (!this._sources.has(source)) {
          return {
            line: null,
            column: null,
            lastColumn: null
          };
        }
        source = this._sources.indexOf(source);
        var needle = {
          source,
          originalLine: util.getArg(aArgs, "line"),
          originalColumn: util.getArg(aArgs, "column")
        };
        var index = this._findMapping(
          needle,
          this._originalMappings,
          "originalLine",
          "originalColumn",
          util.compareByOriginalPositions,
          util.getArg(aArgs, "bias", SourceMapConsumer.GREATEST_LOWER_BOUND)
        );
        if (index >= 0) {
          var mapping = this._originalMappings[index];
          if (mapping.source === needle.source) {
            return {
              line: util.getArg(mapping, "generatedLine", null),
              column: util.getArg(mapping, "generatedColumn", null),
              lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
            };
          }
        }
        return {
          line: null,
          column: null,
          lastColumn: null
        };
      };
      exports2.BasicSourceMapConsumer = BasicSourceMapConsumer;
      function IndexedSourceMapConsumer(aSourceMap) {
        var sourceMap = aSourceMap;
        if (typeof aSourceMap === "string") {
          sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
        }
        var version = util.getArg(sourceMap, "version");
        var sections = util.getArg(sourceMap, "sections");
        if (version != this._version) {
          throw new Error("Unsupported version: " + version);
        }
        this._sources = new ArraySet();
        this._names = new ArraySet();
        var lastOffset = {
          line: -1,
          column: 0
        };
        this._sections = sections.map(function(s) {
          if (s.url) {
            throw new Error("Support for url field in sections not implemented.");
          }
          var offset = util.getArg(s, "offset");
          var offsetLine = util.getArg(offset, "line");
          var offsetColumn = util.getArg(offset, "column");
          if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) {
            throw new Error("Section offsets must be ordered and non-overlapping.");
          }
          lastOffset = offset;
          return {
            generatedOffset: {
              generatedLine: offsetLine + 1,
              generatedColumn: offsetColumn + 1
            },
            consumer: new SourceMapConsumer(util.getArg(s, "map"))
          };
        });
      }
      IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
      IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
      IndexedSourceMapConsumer.prototype._version = 3;
      Object.defineProperty(IndexedSourceMapConsumer.prototype, "sources", {
        get: function() {
          var sources = [];
          for (var i = 0; i < this._sections.length; i++) {
            for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
              sources.push(this._sections[i].consumer.sources[j]);
            }
          }
          return sources;
        }
      });
      IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
        var needle = {
          generatedLine: util.getArg(aArgs, "line"),
          generatedColumn: util.getArg(aArgs, "column")
        };
        var sectionIndex = binarySearch.search(
          needle,
          this._sections,
          function(needle2, section2) {
            var cmp = needle2.generatedLine - section2.generatedOffset.generatedLine;
            if (cmp) {
              return cmp;
            }
            return needle2.generatedColumn - section2.generatedOffset.generatedColumn;
          }
        );
        var section = this._sections[sectionIndex];
        if (!section) {
          return {
            source: null,
            line: null,
            column: null,
            name: null
          };
        }
        return section.consumer.originalPositionFor({
          line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
          column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
          bias: aArgs.bias
        });
      };
      IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
        return this._sections.every(function(s) {
          return s.consumer.hasContentsOfAllSources();
        });
      };
      IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
        for (var i = 0; i < this._sections.length; i++) {
          var section = this._sections[i];
          var content = section.consumer.sourceContentFor(aSource, true);
          if (content) {
            return content;
          }
        }
        if (nullOnMissing) {
          return null;
        } else {
          throw new Error('"' + aSource + '" is not in the SourceMap.');
        }
      };
      IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
        for (var i = 0; i < this._sections.length; i++) {
          var section = this._sections[i];
          if (section.consumer.sources.indexOf(util.getArg(aArgs, "source")) === -1) {
            continue;
          }
          var generatedPosition = section.consumer.generatedPositionFor(aArgs);
          if (generatedPosition) {
            var ret = {
              line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
              column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
            };
            return ret;
          }
        }
        return {
          line: null,
          column: null
        };
      };
      IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
        this.__generatedMappings = [];
        this.__originalMappings = [];
        for (var i = 0; i < this._sections.length; i++) {
          var section = this._sections[i];
          var sectionMappings = section.consumer._generatedMappings;
          for (var j = 0; j < sectionMappings.length; j++) {
            var mapping = sectionMappings[j];
            var source = section.consumer._sources.at(mapping.source);
            if (section.consumer.sourceRoot !== null) {
              source = util.join(section.consumer.sourceRoot, source);
            }
            this._sources.add(source);
            source = this._sources.indexOf(source);
            var name = section.consumer._names.at(mapping.name);
            this._names.add(name);
            name = this._names.indexOf(name);
            var adjustedMapping = {
              source,
              generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
              generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
              originalLine: mapping.originalLine,
              originalColumn: mapping.originalColumn,
              name
            };
            this.__generatedMappings.push(adjustedMapping);
            if (typeof adjustedMapping.originalLine === "number") {
              this.__originalMappings.push(adjustedMapping);
            }
          }
        }
        quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
        quickSort(this.__originalMappings, util.compareByOriginalPositions);
      };
      exports2.IndexedSourceMapConsumer = IndexedSourceMapConsumer;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/source-node.js
  var require_source_node = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/source-node.js"(exports2) {
      init_define_process();
      var SourceMapGenerator = require_source_map_generator().SourceMapGenerator;
      var util = require_util3();
      var REGEX_NEWLINE = /(\r?\n)/;
      var NEWLINE_CODE = 10;
      var isSourceNode = "$$$isSourceNode$$$";
      function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
        this.children = [];
        this.sourceContents = {};
        this.line = aLine == null ? null : aLine;
        this.column = aColumn == null ? null : aColumn;
        this.source = aSource == null ? null : aSource;
        this.name = aName == null ? null : aName;
        this[isSourceNode] = true;
        if (aChunks != null)
          this.add(aChunks);
      }
      SourceNode.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
        var node = new SourceNode();
        var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
        var remainingLinesIndex = 0;
        var shiftNextLine = function() {
          var lineContents = getNextLine();
          var newLine = getNextLine() || "";
          return lineContents + newLine;
          function getNextLine() {
            return remainingLinesIndex < remainingLines.length ? remainingLines[remainingLinesIndex++] : void 0;
          }
        };
        var lastGeneratedLine = 1, lastGeneratedColumn = 0;
        var lastMapping = null;
        aSourceMapConsumer.eachMapping(function(mapping) {
          if (lastMapping !== null) {
            if (lastGeneratedLine < mapping.generatedLine) {
              addMappingWithCode(lastMapping, shiftNextLine());
              lastGeneratedLine++;
              lastGeneratedColumn = 0;
            } else {
              var nextLine = remainingLines[remainingLinesIndex];
              var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
              remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
              lastGeneratedColumn = mapping.generatedColumn;
              addMappingWithCode(lastMapping, code);
              lastMapping = mapping;
              return;
            }
          }
          while (lastGeneratedLine < mapping.generatedLine) {
            node.add(shiftNextLine());
            lastGeneratedLine++;
          }
          if (lastGeneratedColumn < mapping.generatedColumn) {
            var nextLine = remainingLines[remainingLinesIndex];
            node.add(nextLine.substr(0, mapping.generatedColumn));
            remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
            lastGeneratedColumn = mapping.generatedColumn;
          }
          lastMapping = mapping;
        }, this);
        if (remainingLinesIndex < remainingLines.length) {
          if (lastMapping) {
            addMappingWithCode(lastMapping, shiftNextLine());
          }
          node.add(remainingLines.splice(remainingLinesIndex).join(""));
        }
        aSourceMapConsumer.sources.forEach(function(sourceFile) {
          var content = aSourceMapConsumer.sourceContentFor(sourceFile);
          if (content != null) {
            if (aRelativePath != null) {
              sourceFile = util.join(aRelativePath, sourceFile);
            }
            node.setSourceContent(sourceFile, content);
          }
        });
        return node;
        function addMappingWithCode(mapping, code) {
          if (mapping === null || mapping.source === void 0) {
            node.add(code);
          } else {
            var source = aRelativePath ? util.join(aRelativePath, mapping.source) : mapping.source;
            node.add(new SourceNode(
              mapping.originalLine,
              mapping.originalColumn,
              source,
              code,
              mapping.name
            ));
          }
        }
      };
      SourceNode.prototype.add = function SourceNode_add(aChunk) {
        if (Array.isArray(aChunk)) {
          aChunk.forEach(function(chunk2) {
            this.add(chunk2);
          }, this);
        } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
          if (aChunk) {
            this.children.push(aChunk);
          }
        } else {
          throw new TypeError(
            "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
          );
        }
        return this;
      };
      SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
        if (Array.isArray(aChunk)) {
          for (var i = aChunk.length - 1; i >= 0; i--) {
            this.prepend(aChunk[i]);
          }
        } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
          this.children.unshift(aChunk);
        } else {
          throw new TypeError(
            "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
          );
        }
        return this;
      };
      SourceNode.prototype.walk = function SourceNode_walk(aFn) {
        var chunk2;
        for (var i = 0, len = this.children.length; i < len; i++) {
          chunk2 = this.children[i];
          if (chunk2[isSourceNode]) {
            chunk2.walk(aFn);
          } else {
            if (chunk2 !== "") {
              aFn(chunk2, {
                source: this.source,
                line: this.line,
                column: this.column,
                name: this.name
              });
            }
          }
        }
      };
      SourceNode.prototype.join = function SourceNode_join(aSep) {
        var newChildren;
        var i;
        var len = this.children.length;
        if (len > 0) {
          newChildren = [];
          for (i = 0; i < len - 1; i++) {
            newChildren.push(this.children[i]);
            newChildren.push(aSep);
          }
          newChildren.push(this.children[i]);
          this.children = newChildren;
        }
        return this;
      };
      SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
        var lastChild = this.children[this.children.length - 1];
        if (lastChild[isSourceNode]) {
          lastChild.replaceRight(aPattern, aReplacement);
        } else if (typeof lastChild === "string") {
          this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
        } else {
          this.children.push("".replace(aPattern, aReplacement));
        }
        return this;
      };
      SourceNode.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
        this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
      };
      SourceNode.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
        for (var i = 0, len = this.children.length; i < len; i++) {
          if (this.children[i][isSourceNode]) {
            this.children[i].walkSourceContents(aFn);
          }
        }
        var sources = Object.keys(this.sourceContents);
        for (var i = 0, len = sources.length; i < len; i++) {
          aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
        }
      };
      SourceNode.prototype.toString = function SourceNode_toString() {
        var str = "";
        this.walk(function(chunk2) {
          str += chunk2;
        });
        return str;
      };
      SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
        var generated = {
          code: "",
          line: 1,
          column: 0
        };
        var map2 = new SourceMapGenerator(aArgs);
        var sourceMappingActive = false;
        var lastOriginalSource = null;
        var lastOriginalLine = null;
        var lastOriginalColumn = null;
        var lastOriginalName = null;
        this.walk(function(chunk2, original) {
          generated.code += chunk2;
          if (original.source !== null && original.line !== null && original.column !== null) {
            if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) {
              map2.addMapping({
                source: original.source,
                original: {
                  line: original.line,
                  column: original.column
                },
                generated: {
                  line: generated.line,
                  column: generated.column
                },
                name: original.name
              });
            }
            lastOriginalSource = original.source;
            lastOriginalLine = original.line;
            lastOriginalColumn = original.column;
            lastOriginalName = original.name;
            sourceMappingActive = true;
          } else if (sourceMappingActive) {
            map2.addMapping({
              generated: {
                line: generated.line,
                column: generated.column
              }
            });
            lastOriginalSource = null;
            sourceMappingActive = false;
          }
          for (var idx = 0, length = chunk2.length; idx < length; idx++) {
            if (chunk2.charCodeAt(idx) === NEWLINE_CODE) {
              generated.line++;
              generated.column = 0;
              if (idx + 1 === length) {
                lastOriginalSource = null;
                sourceMappingActive = false;
              } else if (sourceMappingActive) {
                map2.addMapping({
                  source: original.source,
                  original: {
                    line: original.line,
                    column: original.column
                  },
                  generated: {
                    line: generated.line,
                    column: generated.column
                  },
                  name: original.name
                });
              }
            } else {
              generated.column++;
            }
          }
        });
        this.walkSourceContents(function(sourceFile, sourceContent) {
          map2.setSourceContent(sourceFile, sourceContent);
        });
        return { code: generated.code, map: map2 };
      };
      exports2.SourceNode = SourceNode;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/source-map.js
  var require_source_map = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/source-map.js"(exports2) {
      init_define_process();
      exports2.SourceMapGenerator = require_source_map_generator().SourceMapGenerator;
      exports2.SourceMapConsumer = require_source_map_consumer().SourceMapConsumer;
      exports2.SourceNode = require_source_node().SourceNode;
    }
  });

  // node_modules/source-map-url/source-map-url.js
  var require_source_map_url = __commonJS({
    "node_modules/source-map-url/source-map-url.js"(exports2, module2) {
      init_define_process();
      void function(root2, factory2) {
        if (typeof define === "function" && define.amd) {
          define(factory2);
        } else if (typeof exports2 === "object") {
          module2.exports = factory2();
        } else {
          root2.sourceMappingURL = factory2();
        }
      }(exports2, function() {
        var innerRegex = /[#@] sourceMappingURL=([^\s'"]*)/;
        var regex = RegExp(
          "(?:/\\*(?:\\s*\r?\n(?://)?)?(?:" + innerRegex.source + ")\\s*\\*/|//(?:" + innerRegex.source + "))\\s*"
        );
        return {
          regex,
          _innerRegex: innerRegex,
          getFrom: function(code) {
            var match = code.match(regex);
            return match ? match[1] || match[2] || "" : null;
          },
          existsIn: function(code) {
            return regex.test(code);
          },
          removeFrom: function(code) {
            return code.replace(regex, "");
          },
          insertBefore: function(code, string) {
            var match = code.match(regex);
            if (match) {
              return code.slice(0, match.index) + string + code.slice(match.index);
            } else {
              return code + string;
            }
          }
        };
      });
    }
  });

  // node_modules/resolve-url/resolve-url.js
  var require_resolve_url = __commonJS({
    "node_modules/resolve-url/resolve-url.js"(exports2, module2) {
      init_define_process();
      void function(root2, factory2) {
        if (typeof define === "function" && define.amd) {
          define(factory2);
        } else if (typeof exports2 === "object") {
          module2.exports = factory2();
        } else {
          root2.resolveUrl = factory2();
        }
      }(exports2, function() {
        function resolveUrl() {
          var numUrls = arguments.length;
          if (numUrls === 0) {
            throw new Error("resolveUrl requires at least one argument; got none.");
          }
          var base = document.createElement("base");
          base.href = arguments[0];
          if (numUrls === 1) {
            return base.href;
          }
          var head2 = document.getElementsByTagName("head")[0];
          head2.insertBefore(base, head2.firstChild);
          var a = document.createElement("a");
          var resolved;
          for (var index = 1; index < numUrls; index++) {
            a.href = arguments[index];
            resolved = a.href;
            base.href = resolved;
          }
          head2.removeChild(base);
          return resolved;
        }
        return resolveUrl;
      });
    }
  });

  // node_modules/source-map-resolve/source-map-resolve.js
  var require_source_map_resolve = __commonJS({
    "node_modules/source-map-resolve/source-map-resolve.js"(exports2, module2) {
      init_define_process();
      void function(root2, factory2) {
        if (typeof define === "function" && define.amd) {
          define(["source-map-url", "resolve-url"], factory2);
        } else if (typeof exports2 === "object") {
          var sourceMappingURL = require_source_map_url();
          var resolveUrl = require_resolve_url();
          module2.exports = factory2(sourceMappingURL, resolveUrl);
        } else {
          root2.sourceMapResolve = factory2(root2.sourceMappingURL, root2.resolveUrl);
        }
      }(exports2, function(sourceMappingURL, resolveUrl) {
        function callbackAsync(callback, error, result2) {
          setImmediate(function() {
            callback(error, result2);
          });
        }
        function parseMapToJSON(string, data) {
          try {
            return JSON.parse(string.replace(/^\)\]\}'/, ""));
          } catch (error) {
            error.sourceMapData = data;
            throw error;
          }
        }
        function readSync(read, url, data) {
          var readUrl = url;
          try {
            return String(read(readUrl));
          } catch (error) {
            error.sourceMapData = data;
            throw error;
          }
        }
        function resolveSourceMap(code, codeUrl, read, callback) {
          var mapData;
          try {
            mapData = resolveSourceMapHelper(code, codeUrl);
          } catch (error) {
            return callbackAsync(callback, error);
          }
          if (!mapData || mapData.map) {
            return callbackAsync(callback, null, mapData);
          }
          var readUrl = mapData.url;
          read(readUrl, function(error, result2) {
            if (error) {
              error.sourceMapData = mapData;
              return callback(error);
            }
            mapData.map = String(result2);
            try {
              mapData.map = parseMapToJSON(mapData.map, mapData);
            } catch (error2) {
              return callback(error2);
            }
            callback(null, mapData);
          });
        }
        function resolveSourceMapSync(code, codeUrl, read) {
          var mapData = resolveSourceMapHelper(code, codeUrl);
          if (!mapData || mapData.map) {
            return mapData;
          }
          mapData.map = readSync(read, mapData.url, mapData);
          mapData.map = parseMapToJSON(mapData.map, mapData);
          return mapData;
        }
        var dataUriRegex = /^data:([^,;]*)(;[^,;]*)*(?:,(.*))?$/;
        var jsonMimeTypeRegex = /^(?:application|text)\/json$/;
        var jsonCharacterEncoding = "utf-8";
        function base64ToBuf(b64) {
          var binStr = atob(b64);
          var len = binStr.length;
          var arr = new Uint8Array(len);
          for (var i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
          }
          return arr;
        }
        function decodeBase64String(b64) {
          if (typeof TextDecoder === "undefined" || typeof Uint8Array === "undefined") {
            return atob(b64);
          }
          var buf = base64ToBuf(b64);
          var decoder = new TextDecoder(jsonCharacterEncoding, { fatal: true });
          return decoder.decode(buf);
        }
        function resolveSourceMapHelper(code, codeUrl) {
          var url = sourceMappingURL.getFrom(code);
          if (!url) {
            return null;
          }
          var dataUri = url.match(dataUriRegex);
          if (dataUri) {
            var mimeType = dataUri[1] || "text/plain";
            var lastParameter = dataUri[2] || "";
            var encoded = dataUri[3] || "";
            var data = {
              sourceMappingURL: url,
              url: null,
              sourcesRelativeTo: codeUrl,
              map: encoded
            };
            if (!jsonMimeTypeRegex.test(mimeType)) {
              var error = new Error("Unuseful data uri mime type: " + mimeType);
              error.sourceMapData = data;
              throw error;
            }
            try {
              data.map = parseMapToJSON(
                lastParameter === ";base64" ? decodeBase64String(encoded) : decodeURIComponent(encoded),
                data
              );
            } catch (error2) {
              error2.sourceMapData = data;
              throw error2;
            }
            return data;
          }
          var mapUrl = resolveUrl(codeUrl, url);
          return {
            sourceMappingURL: url,
            url: mapUrl,
            sourcesRelativeTo: mapUrl,
            map: null
          };
        }
        function resolveSources(map2, mapUrl, read, options, callback) {
          if (typeof options === "function") {
            callback = options;
            options = {};
          }
          var pending = map2.sources ? map2.sources.length : 0;
          var result2 = {
            sourcesResolved: [],
            sourcesContent: []
          };
          if (pending === 0) {
            callbackAsync(callback, null, result2);
            return;
          }
          var done = function() {
            pending--;
            if (pending === 0) {
              callback(null, result2);
            }
          };
          resolveSourcesHelper(map2, mapUrl, options, function(fullUrl, sourceContent, index) {
            result2.sourcesResolved[index] = fullUrl;
            if (typeof sourceContent === "string") {
              result2.sourcesContent[index] = sourceContent;
              callbackAsync(done, null);
            } else {
              var readUrl = fullUrl;
              read(readUrl, function(error, source) {
                result2.sourcesContent[index] = error ? error : String(source);
                done();
              });
            }
          });
        }
        function resolveSourcesSync(map2, mapUrl, read, options) {
          var result2 = {
            sourcesResolved: [],
            sourcesContent: []
          };
          if (!map2.sources || map2.sources.length === 0) {
            return result2;
          }
          resolveSourcesHelper(map2, mapUrl, options, function(fullUrl, sourceContent, index) {
            result2.sourcesResolved[index] = fullUrl;
            if (read !== null) {
              if (typeof sourceContent === "string") {
                result2.sourcesContent[index] = sourceContent;
              } else {
                var readUrl = fullUrl;
                try {
                  result2.sourcesContent[index] = String(read(readUrl));
                } catch (error) {
                  result2.sourcesContent[index] = error;
                }
              }
            }
          });
          return result2;
        }
        var endingSlash = /\/?$/;
        function resolveSourcesHelper(map2, mapUrl, options, fn) {
          options = options || {};
          var fullUrl;
          var sourceContent;
          var sourceRoot;
          for (var index = 0, len = map2.sources.length; index < len; index++) {
            sourceRoot = null;
            if (typeof options.sourceRoot === "string") {
              sourceRoot = options.sourceRoot;
            } else if (typeof map2.sourceRoot === "string" && options.sourceRoot !== false) {
              sourceRoot = map2.sourceRoot;
            }
            if (sourceRoot === null || sourceRoot === "") {
              fullUrl = resolveUrl(mapUrl, map2.sources[index]);
            } else {
              fullUrl = resolveUrl(mapUrl, sourceRoot.replace(endingSlash, "/"), map2.sources[index]);
            }
            sourceContent = (map2.sourcesContent || [])[index];
            fn(fullUrl, sourceContent, index);
          }
        }
        function resolve(code, codeUrl, read, options, callback) {
          if (typeof options === "function") {
            callback = options;
            options = {};
          }
          if (code === null) {
            var mapUrl = codeUrl;
            var data = {
              sourceMappingURL: null,
              url: mapUrl,
              sourcesRelativeTo: mapUrl,
              map: null
            };
            var readUrl = mapUrl;
            read(readUrl, function(error, result2) {
              if (error) {
                error.sourceMapData = data;
                return callback(error);
              }
              data.map = String(result2);
              try {
                data.map = parseMapToJSON(data.map, data);
              } catch (error2) {
                return callback(error2);
              }
              _resolveSources(data);
            });
          } else {
            resolveSourceMap(code, codeUrl, read, function(error, mapData) {
              if (error) {
                return callback(error);
              }
              if (!mapData) {
                return callback(null, null);
              }
              _resolveSources(mapData);
            });
          }
          function _resolveSources(mapData) {
            resolveSources(mapData.map, mapData.sourcesRelativeTo, read, options, function(error, result2) {
              if (error) {
                return callback(error);
              }
              mapData.sourcesResolved = result2.sourcesResolved;
              mapData.sourcesContent = result2.sourcesContent;
              callback(null, mapData);
            });
          }
        }
        function resolveSync(code, codeUrl, read, options) {
          var mapData;
          if (code === null) {
            var mapUrl = codeUrl;
            mapData = {
              sourceMappingURL: null,
              url: mapUrl,
              sourcesRelativeTo: mapUrl,
              map: null
            };
            mapData.map = readSync(read, mapUrl, mapData);
            mapData.map = parseMapToJSON(mapData.map, mapData);
          } else {
            mapData = resolveSourceMapSync(code, codeUrl, read);
            if (!mapData) {
              return null;
            }
          }
          var result2 = resolveSourcesSync(mapData.map, mapData.sourcesRelativeTo, read, options);
          mapData.sourcesResolved = result2.sourcesResolved;
          mapData.sourcesContent = result2.sourcesContent;
          return mapData;
        }
        return {
          resolveSourceMap,
          resolveSourceMapSync,
          resolveSources,
          resolveSourcesSync,
          resolve,
          resolveSync,
          parseMapToJSON
        };
      });
    }
  });

  // node_modules/snapdragon/lib/utils.js
  var require_utils = __commonJS({
    "node_modules/snapdragon/lib/utils.js"(exports2) {
      "use strict";
      init_define_process();
      exports2.extend = require_extend_shallow3();
      exports2.SourceMap = require_source_map();
      exports2.sourceMapResolve = require_source_map_resolve();
      exports2.unixify = function(fp) {
        return fp.split(/\\+/).join("/");
      };
      exports2.isString = function(str) {
        return str && typeof str === "string";
      };
      exports2.arrayify = function(val) {
        if (typeof val === "string")
          return [val];
        return val ? Array.isArray(val) ? val : [val] : [];
      };
      exports2.last = function(arr, n) {
        return arr[arr.length - (n || 1)];
      };
    }
  });

  // ignore:fs
  var require_fs = __commonJS({
    "ignore:fs"() {
      init_define_process();
    }
  });

  // node_modules/snapdragon/lib/source-maps.js
  var require_source_maps = __commonJS({
    "node_modules/snapdragon/lib/source-maps.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var fs = require_fs();
      var path = require_path_browserify();
      var define2 = require_define_property3();
      var utils = require_utils();
      module2.exports = mixin3;
      function mixin3(compiler) {
        define2(compiler, "_comment", compiler.comment);
        compiler.map = new utils.SourceMap.SourceMapGenerator();
        compiler.position = { line: 1, column: 1 };
        compiler.content = {};
        compiler.files = {};
        for (var key in exports2) {
          define2(compiler, key, exports2[key]);
        }
      }
      exports2.updatePosition = function(str) {
        var lines = str.match(/\n/g);
        if (lines)
          this.position.line += lines.length;
        var i = str.lastIndexOf("\n");
        this.position.column = ~i ? str.length - i : this.position.column + str.length;
      };
      exports2.emit = function(str, node) {
        var position = node.position || {};
        var source = position.source;
        if (source) {
          if (position.filepath) {
            source = utils.unixify(position.filepath);
          }
          this.map.addMapping({
            source,
            generated: {
              line: this.position.line,
              column: Math.max(this.position.column - 1, 0)
            },
            original: {
              line: position.start.line,
              column: position.start.column - 1
            }
          });
          if (position.content) {
            this.addContent(source, position);
          }
          if (position.filepath) {
            this.addFile(source, position);
          }
          this.updatePosition(str);
          this.output += str;
        }
        return str;
      };
      exports2.addFile = function(file2, position) {
        if (typeof position.content !== "string")
          return;
        if (Object.prototype.hasOwnProperty.call(this.files, file2))
          return;
        this.files[file2] = position.content;
      };
      exports2.addContent = function(source, position) {
        if (typeof position.content !== "string")
          return;
        if (Object.prototype.hasOwnProperty.call(this.content, source))
          return;
        this.map.setSourceContent(source, position.content);
      };
      exports2.applySourceMaps = function() {
        Object.keys(this.files).forEach(function(file2) {
          var content = this.files[file2];
          this.map.setSourceContent(file2, content);
          if (this.options.inputSourcemaps === true) {
            var originalMap = utils.sourceMapResolve.resolveSync(content, file2, fs.readFileSync);
            if (originalMap) {
              var map2 = new utils.SourceMap.SourceMapConsumer(originalMap.map);
              var relativeTo = originalMap.sourcesRelativeTo;
              this.map.applySourceMap(map2, file2, utils.unixify(path.dirname(relativeTo)));
            }
          }
        }, this);
      };
      exports2.comment = function(node) {
        if (/^# sourceMappingURL=/.test(node.comment)) {
          return this.emit("", node.position);
        }
        return this._comment(node);
      };
    }
  });

  // node_modules/snapdragon/lib/compiler.js
  var require_compiler = __commonJS({
    "node_modules/snapdragon/lib/compiler.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var use = require_use();
      var define2 = require_define_property3();
      var debug2 = require_browser()("snapdragon:compiler");
      var utils = require_utils();
      function Compiler(options, state) {
        debug2("initializing", __filename);
        this.options = utils.extend({ source: "string" }, options);
        this.state = state || {};
        this.compilers = {};
        this.output = "";
        this.set("eos", function(node) {
          return this.emit(node.val, node);
        });
        this.set("noop", function(node) {
          return this.emit(node.val, node);
        });
        this.set("bos", function(node) {
          return this.emit(node.val, node);
        });
        use(this);
      }
      Compiler.prototype = {
        error: function(msg, node) {
          var pos = node.position || { start: { column: 0 } };
          var message = this.options.source + " column:" + pos.start.column + ": " + msg;
          var err = new Error(message);
          err.reason = msg;
          err.column = pos.start.column;
          err.source = this.pattern;
          if (this.options.silent) {
            this.errors.push(err);
          } else {
            throw err;
          }
        },
        define: function(key, val) {
          define2(this, key, val);
          return this;
        },
        emit: function(str, node) {
          this.output += str;
          return str;
        },
        set: function(name, fn) {
          this.compilers[name] = fn;
          return this;
        },
        get: function(name) {
          return this.compilers[name];
        },
        prev: function(n) {
          return this.ast.nodes[this.idx - (n || 1)] || { type: "bos", val: "" };
        },
        next: function(n) {
          return this.ast.nodes[this.idx + (n || 1)] || { type: "eos", val: "" };
        },
        visit: function(node, nodes, i) {
          var fn = this.compilers[node.type];
          this.idx = i;
          if (typeof fn !== "function") {
            throw this.error('compiler "' + node.type + '" is not registered', node);
          }
          return fn.call(this, node, nodes, i);
        },
        mapVisit: function(nodes) {
          if (!Array.isArray(nodes)) {
            throw new TypeError("expected an array");
          }
          var len = nodes.length;
          var idx = -1;
          while (++idx < len) {
            this.visit(nodes[idx], nodes, idx);
          }
          return this;
        },
        compile: function(ast, options) {
          var opts = utils.extend({}, this.options, options);
          this.ast = ast;
          this.parsingErrors = this.ast.errors;
          this.output = "";
          if (opts.sourcemap) {
            var sourcemaps = require_source_maps();
            sourcemaps(this);
            this.mapVisit(this.ast.nodes);
            this.applySourceMaps();
            this.map = opts.sourcemap === "generator" ? this.map : this.map.toJSON();
            return this;
          }
          this.mapVisit(this.ast.nodes);
          return this;
        }
      };
      module2.exports = Compiler;
    }
  });

  // node_modules/snapdragon/lib/position.js
  var require_position = __commonJS({
    "node_modules/snapdragon/lib/position.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var define2 = require_define_property3();
      module2.exports = function Position(start, parser3) {
        this.start = start;
        this.end = { line: parser3.line, column: parser3.column };
        define2(this, "content", parser3.orig);
        define2(this, "source", parser3.options.source);
      };
    }
  });

  // node_modules/snapdragon/lib/parser.js
  var require_parser = __commonJS({
    "node_modules/snapdragon/lib/parser.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var use = require_use();
      var util = require_util();
      var Cache = require_map_cache();
      var define2 = require_define_property3();
      var debug2 = require_browser()("snapdragon:parser");
      var Position = require_position();
      var utils = require_utils();
      function Parser(options) {
        debug2("initializing", __filename);
        this.options = utils.extend({ source: "string" }, options);
        this.init(this.options);
        use(this);
      }
      Parser.prototype = {
        constructor: Parser,
        init: function(options) {
          this.orig = "";
          this.input = "";
          this.parsed = "";
          this.column = 1;
          this.line = 1;
          this.regex = new Cache();
          this.errors = this.errors || [];
          this.parsers = this.parsers || {};
          this.types = this.types || [];
          this.sets = this.sets || {};
          this.fns = this.fns || [];
          this.currentType = "root";
          var pos = this.position();
          this.bos = pos({ type: "bos", val: "" });
          this.ast = {
            type: "root",
            errors: this.errors,
            nodes: [this.bos]
          };
          define2(this.bos, "parent", this.ast);
          this.nodes = [this.ast];
          this.count = 0;
          this.setCount = 0;
          this.stack = [];
        },
        error: function(msg, node) {
          var pos = node.position || { start: { column: 0, line: 0 } };
          var line = pos.start.line;
          var column = pos.start.column;
          var source = this.options.source;
          var message = source + " <line:" + line + " column:" + column + ">: " + msg;
          var err = new Error(message);
          err.source = source;
          err.reason = msg;
          err.pos = pos;
          if (this.options.silent) {
            this.errors.push(err);
          } else {
            throw err;
          }
        },
        define: function(key, val) {
          define2(this, key, val);
          return this;
        },
        position: function() {
          var start = { line: this.line, column: this.column };
          var self2 = this;
          return function(node) {
            define2(node, "position", new Position(start, self2));
            return node;
          };
        },
        set: function(type, fn) {
          if (this.types.indexOf(type) === -1) {
            this.types.push(type);
          }
          this.parsers[type] = fn.bind(this);
          return this;
        },
        get: function(name) {
          return this.parsers[name];
        },
        push: function(type, token) {
          this.sets[type] = this.sets[type] || [];
          this.count++;
          this.stack.push(token);
          return this.sets[type].push(token);
        },
        pop: function(type) {
          this.sets[type] = this.sets[type] || [];
          this.count--;
          this.stack.pop();
          return this.sets[type].pop();
        },
        isInside: function(type) {
          this.sets[type] = this.sets[type] || [];
          return this.sets[type].length > 0;
        },
        isType: function(node, type) {
          return node && node.type === type;
        },
        prev: function(n) {
          return this.stack.length > 0 ? utils.last(this.stack, n) : utils.last(this.nodes, n);
        },
        consume: function(len) {
          this.input = this.input.substr(len);
        },
        updatePosition: function(str, len) {
          var lines = str.match(/\n/g);
          if (lines)
            this.line += lines.length;
          var i = str.lastIndexOf("\n");
          this.column = ~i ? len - i : this.column + len;
          this.parsed += str;
          this.consume(len);
        },
        match: function(regex) {
          var m = regex.exec(this.input);
          if (m) {
            this.updatePosition(m[0], m[0].length);
            return m;
          }
        },
        capture: function(type, regex) {
          if (typeof regex === "function") {
            return this.set.apply(this, arguments);
          }
          this.regex.set(type, regex);
          this.set(type, function() {
            var parsed = this.parsed;
            var pos = this.position();
            var m = this.match(regex);
            if (!m || !m[0])
              return;
            var prev = this.prev();
            var node = pos({
              type,
              val: m[0],
              parsed,
              rest: this.input
            });
            if (m[1]) {
              node.inner = m[1];
            }
            define2(node, "inside", this.stack.length > 0);
            define2(node, "parent", prev);
            prev.nodes.push(node);
          }.bind(this));
          return this;
        },
        capturePair: function(type, openRegex, closeRegex, fn) {
          this.sets[type] = this.sets[type] || [];
          this.set(type + ".open", function() {
            var parsed = this.parsed;
            var pos = this.position();
            var m = this.match(openRegex);
            if (!m || !m[0])
              return;
            var val = m[0];
            this.setCount++;
            this.specialChars = true;
            var open = pos({
              type: type + ".open",
              val,
              rest: this.input
            });
            if (typeof m[1] !== "undefined") {
              open.inner = m[1];
            }
            var prev = this.prev();
            var node = pos({
              type,
              nodes: [open]
            });
            define2(node, "rest", this.input);
            define2(node, "parsed", parsed);
            define2(node, "prefix", m[1]);
            define2(node, "parent", prev);
            define2(open, "parent", node);
            if (typeof fn === "function") {
              fn.call(this, open, node);
            }
            this.push(type, node);
            prev.nodes.push(node);
          });
          this.set(type + ".close", function() {
            var pos = this.position();
            var m = this.match(closeRegex);
            if (!m || !m[0])
              return;
            var parent2 = this.pop(type);
            var node = pos({
              type: type + ".close",
              rest: this.input,
              suffix: m[1],
              val: m[0]
            });
            if (!this.isType(parent2, type)) {
              if (this.options.strict) {
                throw new Error('missing opening "' + type + '"');
              }
              this.setCount--;
              node.escaped = true;
              return node;
            }
            if (node.suffix === "\\") {
              parent2.escaped = true;
              node.escaped = true;
            }
            parent2.nodes.push(node);
            define2(node, "parent", parent2);
          });
          return this;
        },
        eos: function() {
          var pos = this.position();
          if (this.input)
            return;
          var prev = this.prev();
          while (prev.type !== "root" && !prev.visited) {
            if (this.options.strict === true) {
              throw new SyntaxError("invalid syntax:" + util.inspect(prev, null, 2));
            }
            if (!hasDelims(prev)) {
              prev.parent.escaped = true;
              prev.escaped = true;
            }
            visit(prev, function(node) {
              if (!hasDelims(node.parent)) {
                node.parent.escaped = true;
                node.escaped = true;
              }
            });
            prev = prev.parent;
          }
          var tok = pos({
            type: "eos",
            val: this.append || ""
          });
          define2(tok, "parent", this.ast);
          return tok;
        },
        next: function() {
          var parsed = this.parsed;
          var len = this.types.length;
          var idx = -1;
          var tok;
          while (++idx < len) {
            if (tok = this.parsers[this.types[idx]].call(this)) {
              define2(tok, "rest", this.input);
              define2(tok, "parsed", parsed);
              this.last = tok;
              return tok;
            }
          }
        },
        parse: function(input) {
          if (typeof input !== "string") {
            throw new TypeError("expected a string");
          }
          this.init(this.options);
          this.orig = input;
          this.input = input;
          var self2 = this;
          function parse3() {
            input = self2.input;
            var node2 = self2.next();
            if (node2) {
              var prev = self2.prev();
              if (prev) {
                define2(node2, "parent", prev);
                if (prev.nodes) {
                  prev.nodes.push(node2);
                }
              }
              if (self2.sets.hasOwnProperty(prev.type)) {
                self2.currentType = prev.type;
              }
            }
            if (self2.input && input === self2.input) {
              throw new Error('no parsers registered for: "' + self2.input.slice(0, 5) + '"');
            }
          }
          while (this.input)
            parse3();
          if (this.stack.length && this.options.strict) {
            var node = this.stack.pop();
            throw this.error("missing opening " + node.type + ': "' + this.orig + '"');
          }
          var eos = this.eos();
          var tok = this.prev();
          if (tok.type !== "eos") {
            this.ast.nodes.push(eos);
          }
          return this.ast;
        }
      };
      function visit(node, fn) {
        if (!node.visited) {
          define2(node, "visited", true);
          return node.nodes ? mapVisit(node.nodes, fn) : fn(node);
        }
        return node;
      }
      function mapVisit(nodes, fn) {
        var len = nodes.length;
        var idx = -1;
        while (++idx < len) {
          visit(nodes[idx], fn);
        }
      }
      function hasOpen(node) {
        return node.nodes && node.nodes[0].type === node.type + ".open";
      }
      function hasClose(node) {
        return node.nodes && utils.last(node.nodes).type === node.type + ".close";
      }
      function hasDelims(node) {
        return hasOpen(node) && hasClose(node);
      }
      module2.exports = Parser;
    }
  });

  // node_modules/snapdragon/index.js
  var require_snapdragon = __commonJS({
    "node_modules/snapdragon/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var Base = require_base();
      var define2 = require_define_property3();
      var Compiler = require_compiler();
      var Parser = require_parser();
      var utils = require_utils();
      function Snapdragon(options) {
        Base.call(this, null, options);
        this.options = utils.extend({ source: "string" }, this.options);
        this.compiler = new Compiler(this.options);
        this.parser = new Parser(this.options);
        Object.defineProperty(this, "compilers", {
          get: function() {
            return this.compiler.compilers;
          }
        });
        Object.defineProperty(this, "parsers", {
          get: function() {
            return this.parser.parsers;
          }
        });
        Object.defineProperty(this, "regex", {
          get: function() {
            return this.parser.regex;
          }
        });
      }
      Base.extend(Snapdragon);
      Snapdragon.prototype.capture = function() {
        return this.parser.capture.apply(this.parser, arguments);
      };
      Snapdragon.prototype.use = function(fn) {
        fn.call(this, this);
        return this;
      };
      Snapdragon.prototype.parse = function(str, options) {
        this.options = utils.extend({}, this.options, options);
        var parsed = this.parser.parse(str, this.options);
        define2(parsed, "parser", this.parser);
        return parsed;
      };
      Snapdragon.prototype.compile = function(ast, options) {
        this.options = utils.extend({}, this.options, options);
        var compiled = this.compiler.compile(ast, this.options);
        define2(compiled, "compiler", this.compiler);
        return compiled;
      };
      module2.exports = Snapdragon;
      module2.exports.Compiler = Compiler;
      module2.exports.Parser = Parser;
    }
  });

  // node_modules/nanomatch/node_modules/define-property/index.js
  var require_define_property4 = __commonJS({
    "node_modules/nanomatch/node_modules/define-property/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isobject = require_isobject();
      var isDescriptor = require_is_descriptor();
      var define2 = typeof Reflect !== "undefined" && Reflect.defineProperty ? Reflect.defineProperty : Object.defineProperty;
      module2.exports = function defineProperty2(obj, key, val) {
        if (!isobject(obj) && typeof obj !== "function" && !Array.isArray(obj)) {
          throw new TypeError("expected an object, function, or array");
        }
        if (typeof key !== "string") {
          throw new TypeError('expected "key" to be a string');
        }
        if (isDescriptor(val)) {
          define2(obj, key, val);
          return obj;
        }
        define2(obj, key, {
          configurable: true,
          enumerable: false,
          writable: true,
          value: val
        });
        return obj;
      };
    }
  });

  // node_modules/arr-diff/index.js
  var require_arr_diff = __commonJS({
    "node_modules/arr-diff/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function diff(arr) {
        var len = arguments.length;
        var idx = 0;
        while (++idx < len) {
          arr = diffArray(arr, arguments[idx]);
        }
        return arr;
      };
      function diffArray(one, two) {
        if (!Array.isArray(two)) {
          return one.slice();
        }
        var tlen = two.length;
        var olen = one.length;
        var idx = -1;
        var arr = [];
        while (++idx < olen) {
          var ele = one[idx];
          var hasEle = false;
          for (var i = 0; i < tlen; i++) {
            var val = two[i];
            if (ele === val) {
              hasEle = true;
              break;
            }
          }
          if (hasEle === false) {
            arr.push(ele);
          }
        }
        return arr;
      }
    }
  });

  // node_modules/object.pick/index.js
  var require_object = __commonJS({
    "node_modules/object.pick/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      module2.exports = function pick2(obj, keys2) {
        if (!isObject2(obj) && typeof obj !== "function") {
          return {};
        }
        var res = {};
        if (typeof keys2 === "string") {
          if (keys2 in obj) {
            res[keys2] = obj[keys2];
          }
          return res;
        }
        var len = keys2.length;
        var idx = -1;
        while (++idx < len) {
          var key = keys2[idx];
          if (key in obj) {
            res[key] = obj[key];
          }
        }
        return res;
      };
    }
  });

  // node_modules/nanomatch/node_modules/kind-of/index.js
  var require_kind_of10 = __commonJS({
    "node_modules/nanomatch/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (val === void 0)
          return "undefined";
        if (val === null)
          return "null";
        var type = typeof val;
        if (type === "boolean")
          return "boolean";
        if (type === "string")
          return "string";
        if (type === "number")
          return "number";
        if (type === "symbol")
          return "symbol";
        if (type === "function") {
          return isGeneratorFn(val) ? "generatorfunction" : "function";
        }
        if (isArray2(val))
          return "array";
        if (isBuffer2(val))
          return "buffer";
        if (isArguments2(val))
          return "arguments";
        if (isDate2(val))
          return "date";
        if (isError2(val))
          return "error";
        if (isRegexp(val))
          return "regexp";
        switch (ctorName(val)) {
          case "Symbol":
            return "symbol";
          case "Promise":
            return "promise";
          case "WeakMap":
            return "weakmap";
          case "WeakSet":
            return "weakset";
          case "Map":
            return "map";
          case "Set":
            return "set";
          case "Int8Array":
            return "int8array";
          case "Uint8Array":
            return "uint8array";
          case "Uint8ClampedArray":
            return "uint8clampedarray";
          case "Int16Array":
            return "int16array";
          case "Uint16Array":
            return "uint16array";
          case "Int32Array":
            return "int32array";
          case "Uint32Array":
            return "uint32array";
          case "Float32Array":
            return "float32array";
          case "Float64Array":
            return "float64array";
        }
        if (isGeneratorObj(val)) {
          return "generator";
        }
        type = toString2.call(val);
        switch (type) {
          case "[object Object]":
            return "object";
          case "[object Map Iterator]":
            return "mapiterator";
          case "[object Set Iterator]":
            return "setiterator";
          case "[object String Iterator]":
            return "stringiterator";
          case "[object Array Iterator]":
            return "arrayiterator";
        }
        return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
      };
      function ctorName(val) {
        return typeof val.constructor === "function" ? val.constructor.name : null;
      }
      function isArray2(val) {
        if (Array.isArray)
          return Array.isArray(val);
        return val instanceof Array;
      }
      function isError2(val) {
        return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
      }
      function isDate2(val) {
        if (val instanceof Date)
          return true;
        return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
      }
      function isRegexp(val) {
        if (val instanceof RegExp)
          return true;
        return typeof val.flags === "string" && typeof val.ignoreCase === "boolean" && typeof val.multiline === "boolean" && typeof val.global === "boolean";
      }
      function isGeneratorFn(name, val) {
        return ctorName(name) === "GeneratorFunction";
      }
      function isGeneratorObj(val) {
        return typeof val.throw === "function" && typeof val.return === "function" && typeof val.next === "function";
      }
      function isArguments2(val) {
        try {
          if (typeof val.length === "number" && typeof val.callee === "function") {
            return true;
          }
        } catch (err) {
          if (err.message.indexOf("callee") !== -1) {
            return true;
          }
        }
        return false;
      }
      function isBuffer2(val) {
        if (val.constructor && typeof val.constructor.isBuffer === "function") {
          return val.constructor.isBuffer(val);
        }
        return false;
      }
    }
  });

  // node_modules/array-unique/index.js
  var require_array_unique = __commonJS({
    "node_modules/array-unique/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function unique(arr) {
        if (!Array.isArray(arr)) {
          throw new TypeError("array-unique expects an array.");
        }
        var len = arr.length;
        var i = -1;
        while (i++ < len) {
          var j = i + 1;
          for (; j < arr.length; ++j) {
            if (arr[i] === arr[j]) {
              arr.splice(j--, 1);
            }
          }
        }
        return arr;
      };
      module2.exports.immutable = function uniqueImmutable(arr) {
        if (!Array.isArray(arr)) {
          throw new TypeError("array-unique expects an array.");
        }
        var arrLen = arr.length;
        var newArr = new Array(arrLen);
        for (var i = 0; i < arrLen; i++) {
          newArr[i] = arr[i];
        }
        return module2.exports(newArr);
      };
    }
  });

  // node_modules/nanomatch/lib/utils.js
  var require_utils2 = __commonJS({
    "node_modules/nanomatch/lib/utils.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var utils = module2.exports;
      var path = require_path_browserify();
      var isWindows = require_is_windows()();
      var Snapdragon = require_snapdragon();
      utils.define = require_define_property4();
      utils.diff = require_arr_diff();
      utils.extend = require_extend_shallow();
      utils.pick = require_object();
      utils.typeOf = require_kind_of10();
      utils.unique = require_array_unique();
      utils.isEmptyString = function(val) {
        return String(val) === "" || String(val) === "./";
      };
      utils.isWindows = function() {
        return path.sep === "\\" || isWindows === true;
      };
      utils.last = function(arr, n) {
        return arr[arr.length - (n || 1)];
      };
      utils.instantiate = function(ast, options) {
        var snapdragon;
        if (utils.typeOf(ast) === "object" && ast.snapdragon) {
          snapdragon = ast.snapdragon;
        } else if (utils.typeOf(options) === "object" && options.snapdragon) {
          snapdragon = options.snapdragon;
        } else {
          snapdragon = new Snapdragon(options);
        }
        utils.define(snapdragon, "parse", function(str, options2) {
          var parsed = Snapdragon.prototype.parse.call(this, str, options2);
          parsed.input = str;
          var last2 = this.parser.stack.pop();
          if (last2 && this.options.strictErrors !== true) {
            var open = last2.nodes[0];
            var inner = last2.nodes[1];
            if (last2.type === "bracket") {
              if (inner.val.charAt(0) === "[") {
                inner.val = "\\" + inner.val;
              }
            } else {
              open.val = "\\" + open.val;
              var sibling = open.parent.nodes[1];
              if (sibling.type === "star") {
                sibling.loose = true;
              }
            }
          }
          utils.define(parsed, "parser", this.parser);
          return parsed;
        });
        return snapdragon;
      };
      utils.createKey = function(pattern, options) {
        if (typeof options === "undefined") {
          return pattern;
        }
        var key = pattern;
        for (var prop in options) {
          if (options.hasOwnProperty(prop)) {
            key += ";" + prop + "=" + String(options[prop]);
          }
        }
        return key;
      };
      utils.arrayify = function(val) {
        if (typeof val === "string")
          return [val];
        return val ? Array.isArray(val) ? val : [val] : [];
      };
      utils.isString = function(val) {
        return typeof val === "string";
      };
      utils.isRegex = function(val) {
        return utils.typeOf(val) === "regexp";
      };
      utils.isObject = function(val) {
        return utils.typeOf(val) === "object";
      };
      utils.escapeRegex = function(str) {
        return str.replace(/[-[\]{}()^$|*+?.\\/\s]/g, "\\$&");
      };
      utils.combineDupes = function(input, patterns) {
        patterns = utils.arrayify(patterns).join("|").split("|");
        patterns = patterns.map(function(s) {
          return s.replace(/\\?([+*\\/])/g, "\\$1");
        });
        var substr = patterns.join("|");
        var regex = new RegExp("(" + substr + ")(?=\\1)", "g");
        return input.replace(regex, "");
      };
      utils.hasSpecialChars = function(str) {
        return /(?:(?:(^|\/)[!.])|[*?+()|[\]{}]|[+@]\()/.test(str);
      };
      utils.toPosixPath = function(str) {
        return str.replace(/\\+/g, "/");
      };
      utils.unescape = function(str) {
        return utils.toPosixPath(str.replace(/\\(?=[*+?!.])/g, ""));
      };
      utils.stripDrive = function(fp) {
        return utils.isWindows() ? fp.replace(/^[a-z]:[\\/]+?/i, "/") : fp;
      };
      utils.stripPrefix = function(str) {
        if (str.charAt(0) === "." && (str.charAt(1) === "/" || str.charAt(1) === "\\")) {
          return str.slice(2);
        }
        return str;
      };
      utils.isSimpleChar = function(str) {
        return str.trim() === "" || str === ".";
      };
      utils.isSlash = function(str) {
        return str === "/" || str === "\\/" || str === "\\" || str === "\\\\";
      };
      utils.matchPath = function(pattern, options) {
        return options && options.contains ? utils.containsPattern(pattern, options) : utils.equalsPattern(pattern, options);
      };
      utils._equals = function(filepath, unixPath, pattern) {
        return pattern === filepath || pattern === unixPath;
      };
      utils._contains = function(filepath, unixPath, pattern) {
        return filepath.indexOf(pattern) !== -1 || unixPath.indexOf(pattern) !== -1;
      };
      utils.equalsPattern = function(pattern, options) {
        var unixify = utils.unixify(options);
        options = options || {};
        return function fn(filepath) {
          var equal = utils._equals(filepath, unixify(filepath), pattern);
          if (equal === true || options.nocase !== true) {
            return equal;
          }
          var lower = filepath.toLowerCase();
          return utils._equals(lower, unixify(lower), pattern);
        };
      };
      utils.containsPattern = function(pattern, options) {
        var unixify = utils.unixify(options);
        options = options || {};
        return function(filepath) {
          var contains = utils._contains(filepath, unixify(filepath), pattern);
          if (contains === true || options.nocase !== true) {
            return contains;
          }
          var lower = filepath.toLowerCase();
          return utils._contains(lower, unixify(lower), pattern);
        };
      };
      utils.matchBasename = function(re) {
        return function(filepath) {
          return re.test(filepath) || re.test(path.basename(filepath));
        };
      };
      utils.identity = function(val) {
        return val;
      };
      utils.value = function(str, unixify, options) {
        if (options && options.unixify === false) {
          return str;
        }
        if (options && typeof options.unixify === "function") {
          return options.unixify(str);
        }
        return unixify(str);
      };
      utils.unixify = function(options) {
        var opts = options || {};
        return function(filepath) {
          if (opts.stripPrefix !== false) {
            filepath = utils.stripPrefix(filepath);
          }
          if (opts.unescape === true) {
            filepath = utils.unescape(filepath);
          }
          if (opts.unixify === true || utils.isWindows()) {
            filepath = utils.toPosixPath(filepath);
          }
          return filepath;
        };
      };
    }
  });

  // node_modules/nanomatch/index.js
  var require_nanomatch = __commonJS({
    "node_modules/nanomatch/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var util = require_util();
      var toRegex = require_to_regex();
      var extend = require_extend_shallow();
      var compilers = require_compilers();
      var parsers = require_parsers();
      var cache = require_cache();
      var utils = require_utils2();
      var MAX_LENGTH = 1024 * 64;
      function nanomatch(list, patterns, options) {
        patterns = utils.arrayify(patterns);
        list = utils.arrayify(list);
        var len = patterns.length;
        if (list.length === 0 || len === 0) {
          return [];
        }
        if (len === 1) {
          return nanomatch.match(list, patterns[0], options);
        }
        var negated = false;
        var omit2 = [];
        var keep = [];
        var idx = -1;
        while (++idx < len) {
          var pattern = patterns[idx];
          if (typeof pattern === "string" && pattern.charCodeAt(0) === 33) {
            omit2.push.apply(omit2, nanomatch.match(list, pattern.slice(1), options));
            negated = true;
          } else {
            keep.push.apply(keep, nanomatch.match(list, pattern, options));
          }
        }
        if (negated && keep.length === 0) {
          if (options && options.unixify === false) {
            keep = list.slice();
          } else {
            var unixify = utils.unixify(options);
            for (var i = 0; i < list.length; i++) {
              keep.push(unixify(list[i]));
            }
          }
        }
        var matches2 = utils.diff(keep, omit2);
        if (!options || options.nodupes !== false) {
          return utils.unique(matches2);
        }
        return matches2;
      }
      nanomatch.match = function(list, pattern, options) {
        if (Array.isArray(pattern)) {
          throw new TypeError("expected pattern to be a string");
        }
        var unixify = utils.unixify(options);
        var isMatch2 = memoize2("match", pattern, options, nanomatch.matcher);
        var matches2 = [];
        list = utils.arrayify(list);
        var len = list.length;
        var idx = -1;
        while (++idx < len) {
          var ele = list[idx];
          if (ele === pattern || isMatch2(ele)) {
            matches2.push(utils.value(ele, unixify, options));
          }
        }
        if (typeof options === "undefined") {
          return utils.unique(matches2);
        }
        if (matches2.length === 0) {
          if (options.failglob === true) {
            throw new Error('no matches found for "' + pattern + '"');
          }
          if (options.nonull === true || options.nullglob === true) {
            return [options.unescape ? utils.unescape(pattern) : pattern];
          }
        }
        if (options.ignore) {
          matches2 = nanomatch.not(matches2, options.ignore, options);
        }
        return options.nodupes !== false ? utils.unique(matches2) : matches2;
      };
      nanomatch.isMatch = function(str, pattern, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (utils.isEmptyString(str) || utils.isEmptyString(pattern)) {
          return false;
        }
        var equals = utils.equalsPattern(options);
        if (equals(str)) {
          return true;
        }
        var isMatch2 = memoize2("isMatch", pattern, options, nanomatch.matcher);
        return isMatch2(str);
      };
      nanomatch.some = function(list, patterns, options) {
        if (typeof list === "string") {
          list = [list];
        }
        for (var i = 0; i < list.length; i++) {
          if (nanomatch(list[i], patterns, options).length === 1) {
            return true;
          }
        }
        return false;
      };
      nanomatch.every = function(list, patterns, options) {
        if (typeof list === "string") {
          list = [list];
        }
        for (var i = 0; i < list.length; i++) {
          if (nanomatch(list[i], patterns, options).length !== 1) {
            return false;
          }
        }
        return true;
      };
      nanomatch.any = function(str, patterns, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (utils.isEmptyString(str) || utils.isEmptyString(patterns)) {
          return false;
        }
        if (typeof patterns === "string") {
          patterns = [patterns];
        }
        for (var i = 0; i < patterns.length; i++) {
          if (nanomatch.isMatch(str, patterns[i], options)) {
            return true;
          }
        }
        return false;
      };
      nanomatch.all = function(str, patterns, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (typeof patterns === "string") {
          patterns = [patterns];
        }
        for (var i = 0; i < patterns.length; i++) {
          if (!nanomatch.isMatch(str, patterns[i], options)) {
            return false;
          }
        }
        return true;
      };
      nanomatch.not = function(list, patterns, options) {
        var opts = extend({}, options);
        var ignore = opts.ignore;
        delete opts.ignore;
        list = utils.arrayify(list);
        var matches2 = utils.diff(list, nanomatch(list, patterns, opts));
        if (ignore) {
          matches2 = utils.diff(matches2, nanomatch(list, ignore));
        }
        return opts.nodupes !== false ? utils.unique(matches2) : matches2;
      };
      nanomatch.contains = function(str, patterns, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (typeof patterns === "string") {
          if (utils.isEmptyString(str) || utils.isEmptyString(patterns)) {
            return false;
          }
          var equals = utils.equalsPattern(patterns, options);
          if (equals(str)) {
            return true;
          }
          var contains = utils.containsPattern(patterns, options);
          if (contains(str)) {
            return true;
          }
        }
        var opts = extend({}, options, { contains: true });
        return nanomatch.any(str, patterns, opts);
      };
      nanomatch.matchBase = function(pattern, options) {
        if (pattern && pattern.indexOf("/") !== -1 || !options)
          return false;
        return options.basename === true || options.matchBase === true;
      };
      nanomatch.matchKeys = function(obj, patterns, options) {
        if (!utils.isObject(obj)) {
          throw new TypeError("expected the first argument to be an object");
        }
        var keys2 = nanomatch(Object.keys(obj), patterns, options);
        return utils.pick(obj, keys2);
      };
      nanomatch.matcher = function matcher(pattern, options) {
        if (utils.isEmptyString(pattern)) {
          return function() {
            return false;
          };
        }
        if (Array.isArray(pattern)) {
          return compose(pattern, options, matcher);
        }
        if (pattern instanceof RegExp) {
          return test(pattern);
        }
        if (!utils.isString(pattern)) {
          throw new TypeError("expected pattern to be an array, string or regex");
        }
        if (!utils.hasSpecialChars(pattern)) {
          if (options && options.nocase === true) {
            pattern = pattern.toLowerCase();
          }
          return utils.matchPath(pattern, options);
        }
        var re = nanomatch.makeRe(pattern, options);
        if (nanomatch.matchBase(pattern, options)) {
          return utils.matchBasename(re, options);
        }
        function test(regex) {
          var equals = utils.equalsPattern(options);
          var unixify = utils.unixify(options);
          return function(str) {
            if (equals(str)) {
              return true;
            }
            if (regex.test(unixify(str))) {
              return true;
            }
            return false;
          };
        }
        var matcherFn = test(re);
        utils.define(matcherFn, "result", re.result);
        return matcherFn;
      };
      nanomatch.capture = function(pattern, str, options) {
        var re = nanomatch.makeRe(pattern, extend({ capture: true }, options));
        var unixify = utils.unixify(options);
        function match() {
          return function(string) {
            var match2 = re.exec(unixify(string));
            if (!match2) {
              return null;
            }
            return match2.slice(1);
          };
        }
        var capture = memoize2("capture", pattern, options, match);
        return capture(str);
      };
      nanomatch.makeRe = function(pattern, options) {
        if (pattern instanceof RegExp) {
          return pattern;
        }
        if (typeof pattern !== "string") {
          throw new TypeError("expected pattern to be a string");
        }
        if (pattern.length > MAX_LENGTH) {
          throw new Error("expected pattern to be less than " + MAX_LENGTH + " characters");
        }
        function makeRe() {
          var opts = utils.extend({ wrap: false }, options);
          var result2 = nanomatch.create(pattern, opts);
          var regex = toRegex(result2.output, opts);
          utils.define(regex, "result", result2);
          return regex;
        }
        return memoize2("makeRe", pattern, options, makeRe);
      };
      nanomatch.create = function(pattern, options) {
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        function create2() {
          return nanomatch.compile(nanomatch.parse(pattern, options), options);
        }
        return memoize2("create", pattern, options, create2);
      };
      nanomatch.parse = function(pattern, options) {
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        function parse3() {
          var snapdragon = utils.instantiate(null, options);
          parsers(snapdragon, options);
          var ast = snapdragon.parse(pattern, options);
          utils.define(ast, "snapdragon", snapdragon);
          ast.input = pattern;
          return ast;
        }
        return memoize2("parse", pattern, options, parse3);
      };
      nanomatch.compile = function(ast, options) {
        if (typeof ast === "string") {
          ast = nanomatch.parse(ast, options);
        }
        function compile() {
          var snapdragon = utils.instantiate(ast, options);
          compilers(snapdragon, options);
          return snapdragon.compile(ast, options);
        }
        return memoize2("compile", ast.input, options, compile);
      };
      nanomatch.clearCache = function() {
        nanomatch.cache.__data__ = {};
      };
      function compose(patterns, options, matcher) {
        var matchers;
        return memoize2("compose", String(patterns), options, function() {
          return function(file2) {
            if (!matchers) {
              matchers = [];
              for (var i = 0; i < patterns.length; i++) {
                matchers.push(matcher(patterns[i], options));
              }
            }
            var len = matchers.length;
            while (len--) {
              if (matchers[len](file2) === true) {
                return true;
              }
            }
            return false;
          };
        });
      }
      function memoize2(type, pattern, options, fn) {
        var key = utils.createKey(type + "=" + pattern, options);
        if (options && options.cache === false) {
          return fn(pattern, options);
        }
        if (cache.has(type, key)) {
          return cache.get(type, key);
        }
        var val = fn(pattern, options);
        cache.set(type, key, val);
        return val;
      }
      nanomatch.compilers = compilers;
      nanomatch.parsers = parsers;
      nanomatch.cache = cache;
      module2.exports = nanomatch;
    }
  });

  // node_modules/jszip/dist/jszip.min.js
  var require_jszip_min = __commonJS({
    "node_modules/jszip/dist/jszip.min.js"(exports2, module2) {
      init_define_process();
      !function(e) {
        if ("object" == typeof exports2 && "undefined" != typeof module2)
          module2.exports = e();
        else if ("function" == typeof define && define.amd)
          define([], e);
        else {
          ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).JSZip = e();
        }
      }(function() {
        return function s(a, o, h) {
          function u(r, e2) {
            if (!o[r]) {
              if (!a[r]) {
                var t3 = "function" == typeof __require && __require;
                if (!e2 && t3)
                  return t3(r, true);
                if (l)
                  return l(r, true);
                var n = new Error("Cannot find module '" + r + "'");
                throw n.code = "MODULE_NOT_FOUND", n;
              }
              var i = o[r] = { exports: {} };
              a[r][0].call(i.exports, function(e3) {
                var t4 = a[r][1][e3];
                return u(t4 || e3);
              }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
          }
          for (var l = "function" == typeof __require && __require, e = 0; e < h.length; e++)
            u(h[e]);
          return u;
        }({ 1: [function(e, t3, r) {
          "use strict";
          var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          r.encode = function(e2) {
            for (var t4, r2, n, i, s, a, o, h = [], u = 0, l = e2.length, f = l, c2 = "string" !== d.getTypeOf(e2); u < e2.length; )
              f = l - u, n = c2 ? (t4 = e2[u++], r2 = u < l ? e2[u++] : 0, u < l ? e2[u++] : 0) : (t4 = e2.charCodeAt(u++), r2 = u < l ? e2.charCodeAt(u++) : 0, u < l ? e2.charCodeAt(u++) : 0), i = t4 >> 2, s = (3 & t4) << 4 | r2 >> 4, a = 1 < f ? (15 & r2) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
            return h.join("");
          }, r.decode = function(e2) {
            var t4, r2, n, i, s, a, o = 0, h = 0, u = "data:";
            if (e2.substr(0, u.length) === u)
              throw new Error("Invalid base64 input, it looks like a data url.");
            var l, f = 3 * (e2 = e2.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
            if (e2.charAt(e2.length - 1) === p.charAt(64) && f--, e2.charAt(e2.length - 2) === p.charAt(64) && f--, f % 1 != 0)
              throw new Error("Invalid base64 input, bad content length.");
            for (l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e2.length; )
              t4 = p.indexOf(e2.charAt(o++)) << 2 | (i = p.indexOf(e2.charAt(o++))) >> 4, r2 = (15 & i) << 4 | (s = p.indexOf(e2.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e2.charAt(o++))), l[h++] = t4, 64 !== s && (l[h++] = r2), 64 !== a && (l[h++] = n);
            return l;
          };
        }, { "./support": 30, "./utils": 32 }], 2: [function(e, t3, r) {
          "use strict";
          var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
          function o(e2, t4, r2, n2, i2) {
            this.compressedSize = e2, this.uncompressedSize = t4, this.crc32 = r2, this.compression = n2, this.compressedContent = i2;
          }
          o.prototype = { getContentWorker: function() {
            var e2 = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t4 = this;
            return e2.on("end", function() {
              if (this.streamInfo.data_length !== t4.uncompressedSize)
                throw new Error("Bug : uncompressed data size mismatch");
            }), e2;
          }, getCompressedWorker: function() {
            return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
          } }, o.createWorkerFrom = function(e2, t4, r2) {
            return e2.pipe(new s()).pipe(new a("uncompressedSize")).pipe(t4.compressWorker(r2)).pipe(new a("compressedSize")).withStreamInfo("compression", t4);
          }, t3.exports = o;
        }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(e, t3, r) {
          "use strict";
          var n = e("./stream/GenericWorker");
          r.STORE = { magic: "\0\0", compressWorker: function() {
            return new n("STORE compression");
          }, uncompressWorker: function() {
            return new n("STORE decompression");
          } }, r.DEFLATE = e("./flate");
        }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(e, t3, r) {
          "use strict";
          var n = e("./utils");
          var o = function() {
            for (var e2, t4 = [], r2 = 0; r2 < 256; r2++) {
              e2 = r2;
              for (var n2 = 0; n2 < 8; n2++)
                e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
              t4[r2] = e2;
            }
            return t4;
          }();
          t3.exports = function(e2, t4) {
            return void 0 !== e2 && e2.length ? "string" !== n.getTypeOf(e2) ? function(e3, t5, r2, n2) {
              var i = o, s = n2 + r2;
              e3 ^= -1;
              for (var a = n2; a < s; a++)
                e3 = e3 >>> 8 ^ i[255 & (e3 ^ t5[a])];
              return -1 ^ e3;
            }(0 | t4, e2, e2.length, 0) : function(e3, t5, r2, n2) {
              var i = o, s = n2 + r2;
              e3 ^= -1;
              for (var a = n2; a < s; a++)
                e3 = e3 >>> 8 ^ i[255 & (e3 ^ t5.charCodeAt(a))];
              return -1 ^ e3;
            }(0 | t4, e2, e2.length, 0) : 0;
          };
        }, { "./utils": 32 }], 5: [function(e, t3, r) {
          "use strict";
          r.base64 = false, r.binary = false, r.dir = false, r.createFolders = true, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
        }, {}], 6: [function(e, t3, r) {
          "use strict";
          var n = null;
          n = "undefined" != typeof Promise ? Promise : e("lie"), t3.exports = { Promise: n };
        }, { lie: 37 }], 7: [function(e, t3, r) {
          "use strict";
          var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
          function h(e2, t4) {
            a.call(this, "FlateWorker/" + e2), this._pako = null, this._pakoAction = e2, this._pakoOptions = t4, this.meta = {};
          }
          r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e2) {
            this.meta = e2.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e2.data), false);
          }, h.prototype.flush = function() {
            a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], true);
          }, h.prototype.cleanUp = function() {
            a.prototype.cleanUp.call(this), this._pako = null;
          }, h.prototype._createPako = function() {
            this._pako = new i[this._pakoAction]({ raw: true, level: this._pakoOptions.level || -1 });
            var t4 = this;
            this._pako.onData = function(e2) {
              t4.push({ data: e2, meta: t4.meta });
            };
          }, r.compressWorker = function(e2) {
            return new h("Deflate", e2);
          }, r.uncompressWorker = function() {
            return new h("Inflate", {});
          };
        }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(e, t3, r) {
          "use strict";
          function A(e2, t4) {
            var r2, n2 = "";
            for (r2 = 0; r2 < t4; r2++)
              n2 += String.fromCharCode(255 & e2), e2 >>>= 8;
            return n2;
          }
          function n(e2, t4, r2, n2, i2, s2) {
            var a, o, h = e2.file, u = e2.compression, l = s2 !== O.utf8encode, f = I.transformTo("string", s2(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s2(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
            t4 && !r2 || (x.crc32 = e2.crc32, x.compressedSize = e2.compressedSize, x.uncompressedSize = e2.uncompressedSize);
            var S = 0;
            t4 && (S |= 8), l || !_ && !g || (S |= 2048);
            var z = 0, C = 0;
            w && (z |= 16), "UNIX" === i2 ? (C = 798, z |= function(e3, t5) {
              var r3 = e3;
              return e3 || (r3 = t5 ? 16893 : 33204), (65535 & r3) << 16;
            }(h.unixPermissions, w)) : (C = 20, z |= function(e3) {
              return 63 & (e3 || 0);
            }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
            var E = "";
            return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), { fileRecord: R.LOCAL_FILE_HEADER + E + f + b, dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n2, 4) + f + b + p };
          }
          var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
          function s(e2, t4, r2, n2) {
            i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t4, this.zipPlatform = r2, this.encodeFileName = n2, this.streamFiles = e2, this.accumulate = false, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
          }
          I.inherits(s, i), s.prototype.push = function(e2) {
            var t4 = e2.meta.percent || 0, r2 = this.entriesCount, n2 = this._sources.length;
            this.accumulate ? this.contentBuffer.push(e2) : (this.bytesWritten += e2.data.length, i.prototype.push.call(this, { data: e2.data, meta: { currentFile: this.currentFile, percent: r2 ? (t4 + 100 * (r2 - n2 - 1)) / r2 : 100 } }));
          }, s.prototype.openedSource = function(e2) {
            this.currentSourceOffset = this.bytesWritten, this.currentFile = e2.file.name;
            var t4 = this.streamFiles && !e2.file.dir;
            if (t4) {
              var r2 = n(e2, t4, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
              this.push({ data: r2.fileRecord, meta: { percent: 0 } });
            } else
              this.accumulate = true;
          }, s.prototype.closedSource = function(e2) {
            this.accumulate = false;
            var t4 = this.streamFiles && !e2.file.dir, r2 = n(e2, t4, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
            if (this.dirRecords.push(r2.dirRecord), t4)
              this.push({ data: function(e3) {
                return R.DATA_DESCRIPTOR + A(e3.crc32, 4) + A(e3.compressedSize, 4) + A(e3.uncompressedSize, 4);
              }(e2), meta: { percent: 100 } });
            else
              for (this.push({ data: r2.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
                this.push(this.contentBuffer.shift());
            this.currentFile = null;
          }, s.prototype.flush = function() {
            for (var e2 = this.bytesWritten, t4 = 0; t4 < this.dirRecords.length; t4++)
              this.push({ data: this.dirRecords[t4], meta: { percent: 100 } });
            var r2 = this.bytesWritten - e2, n2 = function(e3, t5, r3, n3, i2) {
              var s2 = I.transformTo("string", i2(n3));
              return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e3, 2) + A(e3, 2) + A(t5, 4) + A(r3, 4) + A(s2.length, 2) + s2;
            }(this.dirRecords.length, r2, e2, this.zipComment, this.encodeFileName);
            this.push({ data: n2, meta: { percent: 100 } });
          }, s.prototype.prepareNextSource = function() {
            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
          }, s.prototype.registerPrevious = function(e2) {
            this._sources.push(e2);
            var t4 = this;
            return e2.on("data", function(e3) {
              t4.processChunk(e3);
            }), e2.on("end", function() {
              t4.closedSource(t4.previous.streamInfo), t4._sources.length ? t4.prepareNextSource() : t4.end();
            }), e2.on("error", function(e3) {
              t4.error(e3);
            }), this;
          }, s.prototype.resume = function() {
            return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), true) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), true));
          }, s.prototype.error = function(e2) {
            var t4 = this._sources;
            if (!i.prototype.error.call(this, e2))
              return false;
            for (var r2 = 0; r2 < t4.length; r2++)
              try {
                t4[r2].error(e2);
              } catch (e3) {
              }
            return true;
          }, s.prototype.lock = function() {
            i.prototype.lock.call(this);
            for (var e2 = this._sources, t4 = 0; t4 < e2.length; t4++)
              e2[t4].lock();
          }, t3.exports = s;
        }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(e, t3, r) {
          "use strict";
          var u = e("../compressions"), n = e("./ZipFileWorker");
          r.generateWorker = function(e2, a, t4) {
            var o = new n(a.streamFiles, t4, a.platform, a.encodeFileName), h = 0;
            try {
              e2.forEach(function(e3, t5) {
                h++;
                var r2 = function(e4, t6) {
                  var r3 = e4 || t6, n3 = u[r3];
                  if (!n3)
                    throw new Error(r3 + " is not a valid compression method !");
                  return n3;
                }(t5.options.compression, a.compression), n2 = t5.options.compressionOptions || a.compressionOptions || {}, i = t5.dir, s = t5.date;
                t5._compressWorker(r2, n2).withStreamInfo("file", { name: e3, dir: i, date: s, comment: t5.comment || "", unixPermissions: t5.unixPermissions, dosPermissions: t5.dosPermissions }).pipe(o);
              }), o.entriesCount = h;
            } catch (e3) {
              o.error(e3);
            }
            return o;
          };
        }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(e, t3, r) {
          "use strict";
          function n() {
            if (!(this instanceof n))
              return new n();
            if (arguments.length)
              throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
            this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
              var e2 = new n();
              for (var t4 in this)
                "function" != typeof this[t4] && (e2[t4] = this[t4]);
              return e2;
            };
          }
          (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e2, t4) {
            return new n().loadAsync(e2, t4);
          }, n.external = e("./external"), t3.exports = n;
        }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(e, t3, r) {
          "use strict";
          var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
          function f(n2) {
            return new i.Promise(function(e2, t4) {
              var r2 = n2.decompressed.getContentWorker().pipe(new a());
              r2.on("error", function(e3) {
                t4(e3);
              }).on("end", function() {
                r2.streamInfo.crc32 !== n2.decompressed.crc32 ? t4(new Error("Corrupted zip : CRC32 mismatch")) : e2();
              }).resume();
            });
          }
          t3.exports = function(e2, o) {
            var h = this;
            return o = u.extend(o || {}, { base64: false, checkCRC32: false, optimizedBinaryString: false, createFolders: false, decodeFileName: n.utf8decode }), l.isNode && l.isStream(e2) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e2, true, o.optimizedBinaryString, o.base64).then(function(e3) {
              var t4 = new s(o);
              return t4.load(e3), t4;
            }).then(function(e3) {
              var t4 = [i.Promise.resolve(e3)], r2 = e3.files;
              if (o.checkCRC32)
                for (var n2 = 0; n2 < r2.length; n2++)
                  t4.push(f(r2[n2]));
              return i.Promise.all(t4);
            }).then(function(e3) {
              for (var t4 = e3.shift(), r2 = t4.files, n2 = 0; n2 < r2.length; n2++) {
                var i2 = r2[n2], s2 = i2.fileNameStr, a2 = u.resolve(i2.fileNameStr);
                h.file(a2, i2.decompressed, { binary: true, optimizedBinaryString: true, date: i2.date, dir: i2.dir, comment: i2.fileCommentStr.length ? i2.fileCommentStr : null, unixPermissions: i2.unixPermissions, dosPermissions: i2.dosPermissions, createFolders: o.createFolders }), i2.dir || (h.file(a2).unsafeOriginalName = s2);
              }
              return t4.zipComment.length && (h.comment = t4.zipComment), h;
            });
          };
        }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("../stream/GenericWorker");
          function s(e2, t4) {
            i.call(this, "Nodejs stream input adapter for " + e2), this._upstreamEnded = false, this._bindStream(t4);
          }
          n.inherits(s, i), s.prototype._bindStream = function(e2) {
            var t4 = this;
            (this._stream = e2).pause(), e2.on("data", function(e3) {
              t4.push({ data: e3, meta: { percent: 0 } });
            }).on("error", function(e3) {
              t4.isPaused ? this.generatedError = e3 : t4.error(e3);
            }).on("end", function() {
              t4.isPaused ? t4._upstreamEnded = true : t4.end();
            });
          }, s.prototype.pause = function() {
            return !!i.prototype.pause.call(this) && (this._stream.pause(), true);
          }, s.prototype.resume = function() {
            return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), true);
          }, t3.exports = s;
        }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(e, t3, r) {
          "use strict";
          var i = e("readable-stream").Readable;
          function n(e2, t4, r2) {
            i.call(this, t4), this._helper = e2;
            var n2 = this;
            e2.on("data", function(e3, t5) {
              n2.push(e3) || n2._helper.pause(), r2 && r2(t5);
            }).on("error", function(e3) {
              n2.emit("error", e3);
            }).on("end", function() {
              n2.push(null);
            });
          }
          e("../utils").inherits(n, i), n.prototype._read = function() {
            this._helper.resume();
          }, t3.exports = n;
        }, { "../utils": 32, "readable-stream": 16 }], 14: [function(e, t3, r) {
          "use strict";
          t3.exports = { isNode: "undefined" != typeof Buffer, newBufferFrom: function(e2, t4) {
            if (Buffer.from && Buffer.from !== Uint8Array.from)
              return Buffer.from(e2, t4);
            if ("number" == typeof e2)
              throw new Error('The "data" argument must not be a number');
            return new Buffer(e2, t4);
          }, allocBuffer: function(e2) {
            if (Buffer.alloc)
              return Buffer.alloc(e2);
            var t4 = new Buffer(e2);
            return t4.fill(0), t4;
          }, isBuffer: function(e2) {
            return Buffer.isBuffer(e2);
          }, isStream: function(e2) {
            return e2 && "function" == typeof e2.on && "function" == typeof e2.pause && "function" == typeof e2.resume;
          } };
        }, {}], 15: [function(e, t3, r) {
          "use strict";
          function s(e2, t4, r2) {
            var n2, i2 = u.getTypeOf(t4), s2 = u.extend(r2 || {}, f);
            s2.date = s2.date || new Date(), null !== s2.compression && (s2.compression = s2.compression.toUpperCase()), "string" == typeof s2.unixPermissions && (s2.unixPermissions = parseInt(s2.unixPermissions, 8)), s2.unixPermissions && 16384 & s2.unixPermissions && (s2.dir = true), s2.dosPermissions && 16 & s2.dosPermissions && (s2.dir = true), s2.dir && (e2 = g(e2)), s2.createFolders && (n2 = _(e2)) && b.call(this, n2, true);
            var a2 = "string" === i2 && false === s2.binary && false === s2.base64;
            r2 && void 0 !== r2.binary || (s2.binary = !a2), (t4 instanceof c && 0 === t4.uncompressedSize || s2.dir || !t4 || 0 === t4.length) && (s2.base64 = false, s2.binary = true, t4 = "", s2.compression = "STORE", i2 = "string");
            var o2 = null;
            o2 = t4 instanceof c || t4 instanceof l ? t4 : p.isNode && p.isStream(t4) ? new m(e2, t4) : u.prepareContent(e2, t4, s2.binary, s2.optimizedBinaryString, s2.base64);
            var h2 = new d(e2, o2, s2);
            this.files[e2] = h2;
          }
          var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e2) {
            "/" === e2.slice(-1) && (e2 = e2.substring(0, e2.length - 1));
            var t4 = e2.lastIndexOf("/");
            return 0 < t4 ? e2.substring(0, t4) : "";
          }, g = function(e2) {
            return "/" !== e2.slice(-1) && (e2 += "/"), e2;
          }, b = function(e2, t4) {
            return t4 = void 0 !== t4 ? t4 : f.createFolders, e2 = g(e2), this.files[e2] || s.call(this, e2, null, { dir: true, createFolders: t4 }), this.files[e2];
          };
          function h(e2) {
            return "[object RegExp]" === Object.prototype.toString.call(e2);
          }
          var n = { load: function() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          }, forEach: function(e2) {
            var t4, r2, n2;
            for (t4 in this.files)
              n2 = this.files[t4], (r2 = t4.slice(this.root.length, t4.length)) && t4.slice(0, this.root.length) === this.root && e2(r2, n2);
          }, filter: function(r2) {
            var n2 = [];
            return this.forEach(function(e2, t4) {
              r2(e2, t4) && n2.push(t4);
            }), n2;
          }, file: function(e2, t4, r2) {
            if (1 !== arguments.length)
              return e2 = this.root + e2, s.call(this, e2, t4, r2), this;
            if (h(e2)) {
              var n2 = e2;
              return this.filter(function(e3, t5) {
                return !t5.dir && n2.test(e3);
              });
            }
            var i2 = this.files[this.root + e2];
            return i2 && !i2.dir ? i2 : null;
          }, folder: function(r2) {
            if (!r2)
              return this;
            if (h(r2))
              return this.filter(function(e3, t5) {
                return t5.dir && r2.test(e3);
              });
            var e2 = this.root + r2, t4 = b.call(this, e2), n2 = this.clone();
            return n2.root = t4.name, n2;
          }, remove: function(r2) {
            r2 = this.root + r2;
            var e2 = this.files[r2];
            if (e2 || ("/" !== r2.slice(-1) && (r2 += "/"), e2 = this.files[r2]), e2 && !e2.dir)
              delete this.files[r2];
            else
              for (var t4 = this.filter(function(e3, t5) {
                return t5.name.slice(0, r2.length) === r2;
              }), n2 = 0; n2 < t4.length; n2++)
                delete this.files[t4[n2].name];
            return this;
          }, generate: function() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          }, generateInternalStream: function(e2) {
            var t4, r2 = {};
            try {
              if ((r2 = u.extend(e2 || {}, { streamFiles: false, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: i.utf8encode })).type = r2.type.toLowerCase(), r2.compression = r2.compression.toUpperCase(), "binarystring" === r2.type && (r2.type = "string"), !r2.type)
                throw new Error("No output type specified.");
              u.checkSupport(r2.type), "darwin" !== r2.platform && "freebsd" !== r2.platform && "linux" !== r2.platform && "sunos" !== r2.platform || (r2.platform = "UNIX"), "win32" === r2.platform && (r2.platform = "DOS");
              var n2 = r2.comment || this.comment || "";
              t4 = o.generateWorker(this, r2, n2);
            } catch (e3) {
              (t4 = new l("error")).error(e3);
            }
            return new a(t4, r2.type || "string", r2.mimeType);
          }, generateAsync: function(e2, t4) {
            return this.generateInternalStream(e2).accumulate(t4);
          }, generateNodeStream: function(e2, t4) {
            return (e2 = e2 || {}).type || (e2.type = "nodebuffer"), this.generateInternalStream(e2).toNodejsStream(t4);
          } };
          t3.exports = n;
        }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(e, t3, r) {
          "use strict";
          t3.exports = e("stream");
        }, { stream: void 0 }], 17: [function(e, t3, r) {
          "use strict";
          var n = e("./DataReader");
          function i(e2) {
            n.call(this, e2);
            for (var t4 = 0; t4 < this.data.length; t4++)
              e2[t4] = 255 & e2[t4];
          }
          e("../utils").inherits(i, n), i.prototype.byteAt = function(e2) {
            return this.data[this.zero + e2];
          }, i.prototype.lastIndexOfSignature = function(e2) {
            for (var t4 = e2.charCodeAt(0), r2 = e2.charCodeAt(1), n2 = e2.charCodeAt(2), i2 = e2.charCodeAt(3), s = this.length - 4; 0 <= s; --s)
              if (this.data[s] === t4 && this.data[s + 1] === r2 && this.data[s + 2] === n2 && this.data[s + 3] === i2)
                return s - this.zero;
            return -1;
          }, i.prototype.readAndCheckSignature = function(e2) {
            var t4 = e2.charCodeAt(0), r2 = e2.charCodeAt(1), n2 = e2.charCodeAt(2), i2 = e2.charCodeAt(3), s = this.readData(4);
            return t4 === s[0] && r2 === s[1] && n2 === s[2] && i2 === s[3];
          }, i.prototype.readData = function(e2) {
            if (this.checkOffset(e2), 0 === e2)
              return [];
            var t4 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./DataReader": 18 }], 18: [function(e, t3, r) {
          "use strict";
          var n = e("../utils");
          function i(e2) {
            this.data = e2, this.length = e2.length, this.index = 0, this.zero = 0;
          }
          i.prototype = { checkOffset: function(e2) {
            this.checkIndex(this.index + e2);
          }, checkIndex: function(e2) {
            if (this.length < this.zero + e2 || e2 < 0)
              throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e2 + "). Corrupted zip ?");
          }, setIndex: function(e2) {
            this.checkIndex(e2), this.index = e2;
          }, skip: function(e2) {
            this.setIndex(this.index + e2);
          }, byteAt: function() {
          }, readInt: function(e2) {
            var t4, r2 = 0;
            for (this.checkOffset(e2), t4 = this.index + e2 - 1; t4 >= this.index; t4--)
              r2 = (r2 << 8) + this.byteAt(t4);
            return this.index += e2, r2;
          }, readString: function(e2) {
            return n.transformTo("string", this.readData(e2));
          }, readData: function() {
          }, lastIndexOfSignature: function() {
          }, readAndCheckSignature: function() {
          }, readDate: function() {
            var e2 = this.readInt(4);
            return new Date(Date.UTC(1980 + (e2 >> 25 & 127), (e2 >> 21 & 15) - 1, e2 >> 16 & 31, e2 >> 11 & 31, e2 >> 5 & 63, (31 & e2) << 1));
          } }, t3.exports = i;
        }, { "../utils": 32 }], 19: [function(e, t3, r) {
          "use strict";
          var n = e("./Uint8ArrayReader");
          function i(e2) {
            n.call(this, e2);
          }
          e("../utils").inherits(i, n), i.prototype.readData = function(e2) {
            this.checkOffset(e2);
            var t4 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(e, t3, r) {
          "use strict";
          var n = e("./DataReader");
          function i(e2) {
            n.call(this, e2);
          }
          e("../utils").inherits(i, n), i.prototype.byteAt = function(e2) {
            return this.data.charCodeAt(this.zero + e2);
          }, i.prototype.lastIndexOfSignature = function(e2) {
            return this.data.lastIndexOf(e2) - this.zero;
          }, i.prototype.readAndCheckSignature = function(e2) {
            return e2 === this.readData(4);
          }, i.prototype.readData = function(e2) {
            this.checkOffset(e2);
            var t4 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./DataReader": 18 }], 21: [function(e, t3, r) {
          "use strict";
          var n = e("./ArrayReader");
          function i(e2) {
            n.call(this, e2);
          }
          e("../utils").inherits(i, n), i.prototype.readData = function(e2) {
            if (this.checkOffset(e2), 0 === e2)
              return new Uint8Array(0);
            var t4 = this.data.subarray(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
          t3.exports = function(e2) {
            var t4 = n.getTypeOf(e2);
            return n.checkSupport(t4), "string" !== t4 || i.uint8array ? "nodebuffer" === t4 ? new o(e2) : i.uint8array ? new h(n.transformTo("uint8array", e2)) : new s(n.transformTo("array", e2)) : new a(e2);
          };
        }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(e, t3, r) {
          "use strict";
          r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\x07\b";
        }, {}], 24: [function(e, t3, r) {
          "use strict";
          var n = e("./GenericWorker"), i = e("../utils");
          function s(e2) {
            n.call(this, "ConvertWorker to " + e2), this.destType = e2;
          }
          i.inherits(s, n), s.prototype.processChunk = function(e2) {
            this.push({ data: i.transformTo(this.destType, e2.data), meta: e2.meta });
          }, t3.exports = s;
        }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(e, t3, r) {
          "use strict";
          var n = e("./GenericWorker"), i = e("../crc32");
          function s() {
            n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
          }
          e("../utils").inherits(s, n), s.prototype.processChunk = function(e2) {
            this.streamInfo.crc32 = i(e2.data, this.streamInfo.crc32 || 0), this.push(e2);
          }, t3.exports = s;
        }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("./GenericWorker");
          function s(e2) {
            i.call(this, "DataLengthProbe for " + e2), this.propName = e2, this.withStreamInfo(e2, 0);
          }
          n.inherits(s, i), s.prototype.processChunk = function(e2) {
            if (e2) {
              var t4 = this.streamInfo[this.propName] || 0;
              this.streamInfo[this.propName] = t4 + e2.data.length;
            }
            i.prototype.processChunk.call(this, e2);
          }, t3.exports = s;
        }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("./GenericWorker");
          function s(e2) {
            i.call(this, "DataWorker");
            var t4 = this;
            this.dataIsReady = false, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = false, e2.then(function(e3) {
              t4.dataIsReady = true, t4.data = e3, t4.max = e3 && e3.length || 0, t4.type = n.getTypeOf(e3), t4.isPaused || t4._tickAndRepeat();
            }, function(e3) {
              t4.error(e3);
            });
          }
          n.inherits(s, i), s.prototype.cleanUp = function() {
            i.prototype.cleanUp.call(this), this.data = null;
          }, s.prototype.resume = function() {
            return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = true, n.delay(this._tickAndRepeat, [], this)), true);
          }, s.prototype._tickAndRepeat = function() {
            this._tickScheduled = false, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = true));
          }, s.prototype._tick = function() {
            if (this.isPaused || this.isFinished)
              return false;
            var e2 = null, t4 = Math.min(this.max, this.index + 16384);
            if (this.index >= this.max)
              return this.end();
            switch (this.type) {
              case "string":
                e2 = this.data.substring(this.index, t4);
                break;
              case "uint8array":
                e2 = this.data.subarray(this.index, t4);
                break;
              case "array":
              case "nodebuffer":
                e2 = this.data.slice(this.index, t4);
            }
            return this.index = t4, this.push({ data: e2, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
          }, t3.exports = s;
        }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(e, t3, r) {
          "use strict";
          function n(e2) {
            this.name = e2 || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = true, this.isFinished = false, this.isLocked = false, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
          }
          n.prototype = { push: function(e2) {
            this.emit("data", e2);
          }, end: function() {
            if (this.isFinished)
              return false;
            this.flush();
            try {
              this.emit("end"), this.cleanUp(), this.isFinished = true;
            } catch (e2) {
              this.emit("error", e2);
            }
            return true;
          }, error: function(e2) {
            return !this.isFinished && (this.isPaused ? this.generatedError = e2 : (this.isFinished = true, this.emit("error", e2), this.previous && this.previous.error(e2), this.cleanUp()), true);
          }, on: function(e2, t4) {
            return this._listeners[e2].push(t4), this;
          }, cleanUp: function() {
            this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
          }, emit: function(e2, t4) {
            if (this._listeners[e2])
              for (var r2 = 0; r2 < this._listeners[e2].length; r2++)
                this._listeners[e2][r2].call(this, t4);
          }, pipe: function(e2) {
            return e2.registerPrevious(this);
          }, registerPrevious: function(e2) {
            if (this.isLocked)
              throw new Error("The stream '" + this + "' has already been used.");
            this.streamInfo = e2.streamInfo, this.mergeStreamInfo(), this.previous = e2;
            var t4 = this;
            return e2.on("data", function(e3) {
              t4.processChunk(e3);
            }), e2.on("end", function() {
              t4.end();
            }), e2.on("error", function(e3) {
              t4.error(e3);
            }), this;
          }, pause: function() {
            return !this.isPaused && !this.isFinished && (this.isPaused = true, this.previous && this.previous.pause(), true);
          }, resume: function() {
            if (!this.isPaused || this.isFinished)
              return false;
            var e2 = this.isPaused = false;
            return this.generatedError && (this.error(this.generatedError), e2 = true), this.previous && this.previous.resume(), !e2;
          }, flush: function() {
          }, processChunk: function(e2) {
            this.push(e2);
          }, withStreamInfo: function(e2, t4) {
            return this.extraStreamInfo[e2] = t4, this.mergeStreamInfo(), this;
          }, mergeStreamInfo: function() {
            for (var e2 in this.extraStreamInfo)
              Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e2) && (this.streamInfo[e2] = this.extraStreamInfo[e2]);
          }, lock: function() {
            if (this.isLocked)
              throw new Error("The stream '" + this + "' has already been used.");
            this.isLocked = true, this.previous && this.previous.lock();
          }, toString: function() {
            var e2 = "Worker " + this.name;
            return this.previous ? this.previous + " -> " + e2 : e2;
          } }, t3.exports = n;
        }, {}], 29: [function(e, t3, r) {
          "use strict";
          var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
          if (n.nodestream)
            try {
              o = e("../nodejs/NodejsStreamOutputAdapter");
            } catch (e2) {
            }
          function l(e2, o2) {
            return new a.Promise(function(t4, r2) {
              var n2 = [], i2 = e2._internalType, s2 = e2._outputType, a2 = e2._mimeType;
              e2.on("data", function(e3, t5) {
                n2.push(e3), o2 && o2(t5);
              }).on("error", function(e3) {
                n2 = [], r2(e3);
              }).on("end", function() {
                try {
                  var e3 = function(e4, t5, r3) {
                    switch (e4) {
                      case "blob":
                        return h.newBlob(h.transformTo("arraybuffer", t5), r3);
                      case "base64":
                        return u.encode(t5);
                      default:
                        return h.transformTo(e4, t5);
                    }
                  }(s2, function(e4, t5) {
                    var r3, n3 = 0, i3 = null, s3 = 0;
                    for (r3 = 0; r3 < t5.length; r3++)
                      s3 += t5[r3].length;
                    switch (e4) {
                      case "string":
                        return t5.join("");
                      case "array":
                        return Array.prototype.concat.apply([], t5);
                      case "uint8array":
                        for (i3 = new Uint8Array(s3), r3 = 0; r3 < t5.length; r3++)
                          i3.set(t5[r3], n3), n3 += t5[r3].length;
                        return i3;
                      case "nodebuffer":
                        return Buffer.concat(t5);
                      default:
                        throw new Error("concat : unsupported type '" + e4 + "'");
                    }
                  }(i2, n2), a2);
                  t4(e3);
                } catch (e4) {
                  r2(e4);
                }
                n2 = [];
              }).resume();
            });
          }
          function f(e2, t4, r2) {
            var n2 = t4;
            switch (t4) {
              case "blob":
              case "arraybuffer":
                n2 = "uint8array";
                break;
              case "base64":
                n2 = "string";
            }
            try {
              this._internalType = n2, this._outputType = t4, this._mimeType = r2, h.checkSupport(n2), this._worker = e2.pipe(new i(n2)), e2.lock();
            } catch (e3) {
              this._worker = new s("error"), this._worker.error(e3);
            }
          }
          f.prototype = { accumulate: function(e2) {
            return l(this, e2);
          }, on: function(e2, t4) {
            var r2 = this;
            return "data" === e2 ? this._worker.on(e2, function(e3) {
              t4.call(r2, e3.data, e3.meta);
            }) : this._worker.on(e2, function() {
              h.delay(t4, arguments, r2);
            }), this;
          }, resume: function() {
            return h.delay(this._worker.resume, [], this._worker), this;
          }, pause: function() {
            return this._worker.pause(), this;
          }, toNodejsStream: function(e2) {
            if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType)
              throw new Error(this._outputType + " is not supported by this method");
            return new o(this, { objectMode: "nodebuffer" !== this._outputType }, e2);
          } }, t3.exports = f;
        }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(e, t3, r) {
          "use strict";
          if (r.base64 = true, r.array = true, r.string = true, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer)
            r.blob = false;
          else {
            var n = new ArrayBuffer(0);
            try {
              r.blob = 0 === new Blob([n], { type: "application/zip" }).size;
            } catch (e2) {
              try {
                var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
              } catch (e3) {
                r.blob = false;
              }
            }
          }
          try {
            r.nodestream = !!e("readable-stream").Readable;
          } catch (e2) {
            r.nodestream = false;
          }
        }, { "readable-stream": 16 }], 31: [function(e, t3, s) {
          "use strict";
          for (var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)
            u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
          u[254] = u[254] = 1;
          function a() {
            n.call(this, "utf-8 decode"), this.leftOver = null;
          }
          function l() {
            n.call(this, "utf-8 encode");
          }
          s.utf8encode = function(e2) {
            return h.nodebuffer ? r.newBufferFrom(e2, "utf-8") : function(e3) {
              var t4, r2, n2, i2, s2, a2 = e3.length, o2 = 0;
              for (i2 = 0; i2 < a2; i2++)
                55296 == (64512 & (r2 = e3.charCodeAt(i2))) && i2 + 1 < a2 && 56320 == (64512 & (n2 = e3.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), o2 += r2 < 128 ? 1 : r2 < 2048 ? 2 : r2 < 65536 ? 3 : 4;
              for (t4 = h.uint8array ? new Uint8Array(o2) : new Array(o2), i2 = s2 = 0; s2 < o2; i2++)
                55296 == (64512 & (r2 = e3.charCodeAt(i2))) && i2 + 1 < a2 && 56320 == (64512 & (n2 = e3.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), r2 < 128 ? t4[s2++] = r2 : (r2 < 2048 ? t4[s2++] = 192 | r2 >>> 6 : (r2 < 65536 ? t4[s2++] = 224 | r2 >>> 12 : (t4[s2++] = 240 | r2 >>> 18, t4[s2++] = 128 | r2 >>> 12 & 63), t4[s2++] = 128 | r2 >>> 6 & 63), t4[s2++] = 128 | 63 & r2);
              return t4;
            }(e2);
          }, s.utf8decode = function(e2) {
            return h.nodebuffer ? o.transformTo("nodebuffer", e2).toString("utf-8") : function(e3) {
              var t4, r2, n2, i2, s2 = e3.length, a2 = new Array(2 * s2);
              for (t4 = r2 = 0; t4 < s2; )
                if ((n2 = e3[t4++]) < 128)
                  a2[r2++] = n2;
                else if (4 < (i2 = u[n2]))
                  a2[r2++] = 65533, t4 += i2 - 1;
                else {
                  for (n2 &= 2 === i2 ? 31 : 3 === i2 ? 15 : 7; 1 < i2 && t4 < s2; )
                    n2 = n2 << 6 | 63 & e3[t4++], i2--;
                  1 < i2 ? a2[r2++] = 65533 : n2 < 65536 ? a2[r2++] = n2 : (n2 -= 65536, a2[r2++] = 55296 | n2 >> 10 & 1023, a2[r2++] = 56320 | 1023 & n2);
                }
              return a2.length !== r2 && (a2.subarray ? a2 = a2.subarray(0, r2) : a2.length = r2), o.applyFromCharCode(a2);
            }(e2 = o.transformTo(h.uint8array ? "uint8array" : "array", e2));
          }, o.inherits(a, n), a.prototype.processChunk = function(e2) {
            var t4 = o.transformTo(h.uint8array ? "uint8array" : "array", e2.data);
            if (this.leftOver && this.leftOver.length) {
              if (h.uint8array) {
                var r2 = t4;
                (t4 = new Uint8Array(r2.length + this.leftOver.length)).set(this.leftOver, 0), t4.set(r2, this.leftOver.length);
              } else
                t4 = this.leftOver.concat(t4);
              this.leftOver = null;
            }
            var n2 = function(e3, t5) {
              var r3;
              for ((t5 = t5 || e3.length) > e3.length && (t5 = e3.length), r3 = t5 - 1; 0 <= r3 && 128 == (192 & e3[r3]); )
                r3--;
              return r3 < 0 ? t5 : 0 === r3 ? t5 : r3 + u[e3[r3]] > t5 ? r3 : t5;
            }(t4), i2 = t4;
            n2 !== t4.length && (h.uint8array ? (i2 = t4.subarray(0, n2), this.leftOver = t4.subarray(n2, t4.length)) : (i2 = t4.slice(0, n2), this.leftOver = t4.slice(n2, t4.length))), this.push({ data: s.utf8decode(i2), meta: e2.meta });
          }, a.prototype.flush = function() {
            this.leftOver && this.leftOver.length && (this.push({ data: s.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
          }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e2) {
            this.push({ data: s.utf8encode(e2.data), meta: e2.meta });
          }, s.Utf8EncodeWorker = l;
        }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(e, t3, a) {
          "use strict";
          var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
          function n(e2) {
            return e2;
          }
          function l(e2, t4) {
            for (var r2 = 0; r2 < e2.length; ++r2)
              t4[r2] = 255 & e2.charCodeAt(r2);
            return t4;
          }
          e("setimmediate"), a.newBlob = function(t4, r2) {
            a.checkSupport("blob");
            try {
              return new Blob([t4], { type: r2 });
            } catch (e2) {
              try {
                var n2 = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                return n2.append(t4), n2.getBlob(r2);
              } catch (e3) {
                throw new Error("Bug : can't construct the Blob.");
              }
            }
          };
          var i = { stringifyByChunk: function(e2, t4, r2) {
            var n2 = [], i2 = 0, s2 = e2.length;
            if (s2 <= r2)
              return String.fromCharCode.apply(null, e2);
            for (; i2 < s2; )
              "array" === t4 || "nodebuffer" === t4 ? n2.push(String.fromCharCode.apply(null, e2.slice(i2, Math.min(i2 + r2, s2)))) : n2.push(String.fromCharCode.apply(null, e2.subarray(i2, Math.min(i2 + r2, s2)))), i2 += r2;
            return n2.join("");
          }, stringifyByChar: function(e2) {
            for (var t4 = "", r2 = 0; r2 < e2.length; r2++)
              t4 += String.fromCharCode(e2[r2]);
            return t4;
          }, applyCanBeUsed: { uint8array: function() {
            try {
              return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
            } catch (e2) {
              return false;
            }
          }(), nodebuffer: function() {
            try {
              return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
            } catch (e2) {
              return false;
            }
          }() } };
          function s(e2) {
            var t4 = 65536, r2 = a.getTypeOf(e2), n2 = true;
            if ("uint8array" === r2 ? n2 = i.applyCanBeUsed.uint8array : "nodebuffer" === r2 && (n2 = i.applyCanBeUsed.nodebuffer), n2)
              for (; 1 < t4; )
                try {
                  return i.stringifyByChunk(e2, r2, t4);
                } catch (e3) {
                  t4 = Math.floor(t4 / 2);
                }
            return i.stringifyByChar(e2);
          }
          function f(e2, t4) {
            for (var r2 = 0; r2 < e2.length; r2++)
              t4[r2] = e2[r2];
            return t4;
          }
          a.applyFromCharCode = s;
          var c = {};
          c.string = { string: n, array: function(e2) {
            return l(e2, new Array(e2.length));
          }, arraybuffer: function(e2) {
            return c.string.uint8array(e2).buffer;
          }, uint8array: function(e2) {
            return l(e2, new Uint8Array(e2.length));
          }, nodebuffer: function(e2) {
            return l(e2, r.allocBuffer(e2.length));
          } }, c.array = { string: s, array: n, arraybuffer: function(e2) {
            return new Uint8Array(e2).buffer;
          }, uint8array: function(e2) {
            return new Uint8Array(e2);
          }, nodebuffer: function(e2) {
            return r.newBufferFrom(e2);
          } }, c.arraybuffer = { string: function(e2) {
            return s(new Uint8Array(e2));
          }, array: function(e2) {
            return f(new Uint8Array(e2), new Array(e2.byteLength));
          }, arraybuffer: n, uint8array: function(e2) {
            return new Uint8Array(e2);
          }, nodebuffer: function(e2) {
            return r.newBufferFrom(new Uint8Array(e2));
          } }, c.uint8array = { string: s, array: function(e2) {
            return f(e2, new Array(e2.length));
          }, arraybuffer: function(e2) {
            return e2.buffer;
          }, uint8array: n, nodebuffer: function(e2) {
            return r.newBufferFrom(e2);
          } }, c.nodebuffer = { string: s, array: function(e2) {
            return f(e2, new Array(e2.length));
          }, arraybuffer: function(e2) {
            return c.nodebuffer.uint8array(e2).buffer;
          }, uint8array: function(e2) {
            return f(e2, new Uint8Array(e2.length));
          }, nodebuffer: n }, a.transformTo = function(e2, t4) {
            if (t4 = t4 || "", !e2)
              return t4;
            a.checkSupport(e2);
            var r2 = a.getTypeOf(t4);
            return c[r2][e2](t4);
          }, a.resolve = function(e2) {
            for (var t4 = e2.split("/"), r2 = [], n2 = 0; n2 < t4.length; n2++) {
              var i2 = t4[n2];
              "." === i2 || "" === i2 && 0 !== n2 && n2 !== t4.length - 1 || (".." === i2 ? r2.pop() : r2.push(i2));
            }
            return r2.join("/");
          }, a.getTypeOf = function(e2) {
            return "string" == typeof e2 ? "string" : "[object Array]" === Object.prototype.toString.call(e2) ? "array" : o.nodebuffer && r.isBuffer(e2) ? "nodebuffer" : o.uint8array && e2 instanceof Uint8Array ? "uint8array" : o.arraybuffer && e2 instanceof ArrayBuffer ? "arraybuffer" : void 0;
          }, a.checkSupport = function(e2) {
            if (!o[e2.toLowerCase()])
              throw new Error(e2 + " is not supported by this platform");
          }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e2) {
            var t4, r2, n2 = "";
            for (r2 = 0; r2 < (e2 || "").length; r2++)
              n2 += "\\x" + ((t4 = e2.charCodeAt(r2)) < 16 ? "0" : "") + t4.toString(16).toUpperCase();
            return n2;
          }, a.delay = function(e2, t4, r2) {
            setImmediate(function() {
              e2.apply(r2 || null, t4 || []);
            });
          }, a.inherits = function(e2, t4) {
            function r2() {
            }
            r2.prototype = t4.prototype, e2.prototype = new r2();
          }, a.extend = function() {
            var e2, t4, r2 = {};
            for (e2 = 0; e2 < arguments.length; e2++)
              for (t4 in arguments[e2])
                Object.prototype.hasOwnProperty.call(arguments[e2], t4) && void 0 === r2[t4] && (r2[t4] = arguments[e2][t4]);
            return r2;
          }, a.prepareContent = function(r2, e2, n2, i2, s2) {
            return u.Promise.resolve(e2).then(function(n3) {
              return o.blob && (n3 instanceof Blob || -1 !== ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(n3))) && "undefined" != typeof FileReader ? new u.Promise(function(t4, r3) {
                var e3 = new FileReader();
                e3.onload = function(e4) {
                  t4(e4.target.result);
                }, e3.onerror = function(e4) {
                  r3(e4.target.error);
                }, e3.readAsArrayBuffer(n3);
              }) : n3;
            }).then(function(e3) {
              var t4 = a.getTypeOf(e3);
              return t4 ? ("arraybuffer" === t4 ? e3 = a.transformTo("uint8array", e3) : "string" === t4 && (s2 ? e3 = h.decode(e3) : n2 && true !== i2 && (e3 = function(e4) {
                return l(e4, o.uint8array ? new Uint8Array(e4.length) : new Array(e4.length));
              }(e3))), e3) : u.Promise.reject(new Error("Can't read the data of '" + r2 + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
            });
          };
        }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(e, t3, r) {
          "use strict";
          var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
          function h(e2) {
            this.files = [], this.loadOptions = e2;
          }
          h.prototype = { checkSignature: function(e2) {
            if (!this.reader.readAndCheckSignature(e2)) {
              this.reader.index -= 4;
              var t4 = this.reader.readString(4);
              throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t4) + ", expected " + i.pretty(e2) + ")");
            }
          }, isSignature: function(e2, t4) {
            var r2 = this.reader.index;
            this.reader.setIndex(e2);
            var n2 = this.reader.readString(4) === t4;
            return this.reader.setIndex(r2), n2;
          }, readBlockEndOfCentral: function() {
            this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
            var e2 = this.reader.readData(this.zipCommentLength), t4 = o.uint8array ? "uint8array" : "array", r2 = i.transformTo(t4, e2);
            this.zipComment = this.loadOptions.decodeFileName(r2);
          }, readBlockZip64EndOfCentral: function() {
            this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
            for (var e2, t4, r2, n2 = this.zip64EndOfCentralSize - 44; 0 < n2; )
              e2 = this.reader.readInt(2), t4 = this.reader.readInt(4), r2 = this.reader.readData(t4), this.zip64ExtensibleData[e2] = { id: e2, length: t4, value: r2 };
          }, readBlockZip64EndOfCentralLocator: function() {
            if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
              throw new Error("Multi-volumes zip are not supported");
          }, readLocalFiles: function() {
            var e2, t4;
            for (e2 = 0; e2 < this.files.length; e2++)
              t4 = this.files[e2], this.reader.setIndex(t4.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t4.readLocalPart(this.reader), t4.handleUTF8(), t4.processAttributes();
          }, readCentralDir: function() {
            var e2;
            for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER); )
              (e2 = new a({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e2);
            if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length)
              throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
          }, readEndOfCentral: function() {
            var e2 = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
            if (e2 < 0)
              throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
            this.reader.setIndex(e2);
            var t4 = e2;
            if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
              if (this.zip64 = true, (e2 = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
              if (this.reader.setIndex(e2), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
              this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
            }
            var r2 = this.centralDirOffset + this.centralDirSize;
            this.zip64 && (r2 += 20, r2 += 12 + this.zip64EndOfCentralSize);
            var n2 = t4 - r2;
            if (0 < n2)
              this.isSignature(t4, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n2);
            else if (n2 < 0)
              throw new Error("Corrupted zip: missing " + Math.abs(n2) + " bytes.");
          }, prepareReader: function(e2) {
            this.reader = n(e2);
          }, load: function(e2) {
            this.prepareReader(e2), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
          } }, t3.exports = h;
        }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(e, t3, r) {
          "use strict";
          var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
          function l(e2, t4) {
            this.options = e2, this.loadOptions = t4;
          }
          l.prototype = { isEncrypted: function() {
            return 1 == (1 & this.bitFlag);
          }, useUTF8: function() {
            return 2048 == (2048 & this.bitFlag);
          }, readLocalPart: function(e2) {
            var t4, r2;
            if (e2.skip(22), this.fileNameLength = e2.readInt(2), r2 = e2.readInt(2), this.fileName = e2.readData(this.fileNameLength), e2.skip(r2), -1 === this.compressedSize || -1 === this.uncompressedSize)
              throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
            if (null === (t4 = function(e3) {
              for (var t5 in h)
                if (Object.prototype.hasOwnProperty.call(h, t5) && h[t5].magic === e3)
                  return h[t5];
              return null;
            }(this.compressionMethod)))
              throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
            this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t4, e2.readData(this.compressedSize));
          }, readCentralPart: function(e2) {
            this.versionMadeBy = e2.readInt(2), e2.skip(2), this.bitFlag = e2.readInt(2), this.compressionMethod = e2.readString(2), this.date = e2.readDate(), this.crc32 = e2.readInt(4), this.compressedSize = e2.readInt(4), this.uncompressedSize = e2.readInt(4);
            var t4 = e2.readInt(2);
            if (this.extraFieldsLength = e2.readInt(2), this.fileCommentLength = e2.readInt(2), this.diskNumberStart = e2.readInt(2), this.internalFileAttributes = e2.readInt(2), this.externalFileAttributes = e2.readInt(4), this.localHeaderOffset = e2.readInt(4), this.isEncrypted())
              throw new Error("Encrypted zip are not supported");
            e2.skip(t4), this.readExtraFields(e2), this.parseZIP64ExtraField(e2), this.fileComment = e2.readData(this.fileCommentLength);
          }, processAttributes: function() {
            this.unixPermissions = null, this.dosPermissions = null;
            var e2 = this.versionMadeBy >> 8;
            this.dir = !!(16 & this.externalFileAttributes), 0 == e2 && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e2 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = true);
          }, parseZIP64ExtraField: function() {
            if (this.extraFields[1]) {
              var e2 = n(this.extraFields[1].value);
              this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e2.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e2.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e2.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e2.readInt(4));
            }
          }, readExtraFields: function(e2) {
            var t4, r2, n2, i2 = e2.index + this.extraFieldsLength;
            for (this.extraFields || (this.extraFields = {}); e2.index + 4 < i2; )
              t4 = e2.readInt(2), r2 = e2.readInt(2), n2 = e2.readData(r2), this.extraFields[t4] = { id: t4, length: r2, value: n2 };
            e2.setIndex(i2);
          }, handleUTF8: function() {
            var e2 = u.uint8array ? "uint8array" : "array";
            if (this.useUTF8())
              this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
            else {
              var t4 = this.findExtraFieldUnicodePath();
              if (null !== t4)
                this.fileNameStr = t4;
              else {
                var r2 = s.transformTo(e2, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(r2);
              }
              var n2 = this.findExtraFieldUnicodeComment();
              if (null !== n2)
                this.fileCommentStr = n2;
              else {
                var i2 = s.transformTo(e2, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(i2);
              }
            }
          }, findExtraFieldUnicodePath: function() {
            var e2 = this.extraFields[28789];
            if (e2) {
              var t4 = n(e2.value);
              return 1 !== t4.readInt(1) ? null : a(this.fileName) !== t4.readInt(4) ? null : o.utf8decode(t4.readData(e2.length - 5));
            }
            return null;
          }, findExtraFieldUnicodeComment: function() {
            var e2 = this.extraFields[25461];
            if (e2) {
              var t4 = n(e2.value);
              return 1 !== t4.readInt(1) ? null : a(this.fileComment) !== t4.readInt(4) ? null : o.utf8decode(t4.readData(e2.length - 5));
            }
            return null;
          } }, t3.exports = l;
        }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(e, t3, r) {
          "use strict";
          function n(e2, t4, r2) {
            this.name = e2, this.dir = r2.dir, this.date = r2.date, this.comment = r2.comment, this.unixPermissions = r2.unixPermissions, this.dosPermissions = r2.dosPermissions, this._data = t4, this._dataBinary = r2.binary, this.options = { compression: r2.compression, compressionOptions: r2.compressionOptions };
          }
          var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
          n.prototype = { internalStream: function(e2) {
            var t4 = null, r2 = "string";
            try {
              if (!e2)
                throw new Error("No output type specified.");
              var n2 = "string" === (r2 = e2.toLowerCase()) || "text" === r2;
              "binarystring" !== r2 && "text" !== r2 || (r2 = "string"), t4 = this._decompressWorker();
              var i2 = !this._dataBinary;
              i2 && !n2 && (t4 = t4.pipe(new a.Utf8EncodeWorker())), !i2 && n2 && (t4 = t4.pipe(new a.Utf8DecodeWorker()));
            } catch (e3) {
              (t4 = new h("error")).error(e3);
            }
            return new s(t4, r2, "");
          }, async: function(e2, t4) {
            return this.internalStream(e2).accumulate(t4);
          }, nodeStream: function(e2, t4) {
            return this.internalStream(e2 || "nodebuffer").toNodejsStream(t4);
          }, _compressWorker: function(e2, t4) {
            if (this._data instanceof o && this._data.compression.magic === e2.magic)
              return this._data.getCompressedWorker();
            var r2 = this._decompressWorker();
            return this._dataBinary || (r2 = r2.pipe(new a.Utf8EncodeWorker())), o.createWorkerFrom(r2, e2, t4);
          }, _decompressWorker: function() {
            return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
          } };
          for (var u = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], l = function() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          }, f = 0; f < u.length; f++)
            n.prototype[u[f]] = l;
          t3.exports = n;
        }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(e, l, t3) {
          (function(t4) {
            "use strict";
            var r, n, e2 = t4.MutationObserver || t4.WebKitMutationObserver;
            if (e2) {
              var i = 0, s = new e2(u), a = t4.document.createTextNode("");
              s.observe(a, { characterData: true }), r = function() {
                a.data = i = ++i % 2;
              };
            } else if (t4.setImmediate || void 0 === t4.MessageChannel)
              r = "document" in t4 && "onreadystatechange" in t4.document.createElement("script") ? function() {
                var e3 = t4.document.createElement("script");
                e3.onreadystatechange = function() {
                  u(), e3.onreadystatechange = null, e3.parentNode.removeChild(e3), e3 = null;
                }, t4.document.documentElement.appendChild(e3);
              } : function() {
                setTimeout(u, 0);
              };
            else {
              var o = new t4.MessageChannel();
              o.port1.onmessage = u, r = function() {
                o.port2.postMessage(0);
              };
            }
            var h = [];
            function u() {
              var e3, t5;
              n = true;
              for (var r2 = h.length; r2; ) {
                for (t5 = h, h = [], e3 = -1; ++e3 < r2; )
                  t5[e3]();
                r2 = h.length;
              }
              n = false;
            }
            l.exports = function(e3) {
              1 !== h.push(e3) || n || r();
            };
          }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {}], 37: [function(e, t3, r) {
          "use strict";
          var i = e("immediate");
          function u() {
          }
          var l = {}, s = ["REJECTED"], a = ["FULFILLED"], n = ["PENDING"];
          function o(e2) {
            if ("function" != typeof e2)
              throw new TypeError("resolver must be a function");
            this.state = n, this.queue = [], this.outcome = void 0, e2 !== u && d(this, e2);
          }
          function h(e2, t4, r2) {
            this.promise = e2, "function" == typeof t4 && (this.onFulfilled = t4, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r2 && (this.onRejected = r2, this.callRejected = this.otherCallRejected);
          }
          function f(t4, r2, n2) {
            i(function() {
              var e2;
              try {
                e2 = r2(n2);
              } catch (e3) {
                return l.reject(t4, e3);
              }
              e2 === t4 ? l.reject(t4, new TypeError("Cannot resolve promise with itself")) : l.resolve(t4, e2);
            });
          }
          function c(e2) {
            var t4 = e2 && e2.then;
            if (e2 && ("object" == typeof e2 || "function" == typeof e2) && "function" == typeof t4)
              return function() {
                t4.apply(e2, arguments);
              };
          }
          function d(t4, e2) {
            var r2 = false;
            function n2(e3) {
              r2 || (r2 = true, l.reject(t4, e3));
            }
            function i2(e3) {
              r2 || (r2 = true, l.resolve(t4, e3));
            }
            var s2 = p(function() {
              e2(i2, n2);
            });
            "error" === s2.status && n2(s2.value);
          }
          function p(e2, t4) {
            var r2 = {};
            try {
              r2.value = e2(t4), r2.status = "success";
            } catch (e3) {
              r2.status = "error", r2.value = e3;
            }
            return r2;
          }
          (t3.exports = o).prototype.finally = function(t4) {
            if ("function" != typeof t4)
              return this;
            var r2 = this.constructor;
            return this.then(function(e2) {
              return r2.resolve(t4()).then(function() {
                return e2;
              });
            }, function(e2) {
              return r2.resolve(t4()).then(function() {
                throw e2;
              });
            });
          }, o.prototype.catch = function(e2) {
            return this.then(null, e2);
          }, o.prototype.then = function(e2, t4) {
            if ("function" != typeof e2 && this.state === a || "function" != typeof t4 && this.state === s)
              return this;
            var r2 = new this.constructor(u);
            this.state !== n ? f(r2, this.state === a ? e2 : t4, this.outcome) : this.queue.push(new h(r2, e2, t4));
            return r2;
          }, h.prototype.callFulfilled = function(e2) {
            l.resolve(this.promise, e2);
          }, h.prototype.otherCallFulfilled = function(e2) {
            f(this.promise, this.onFulfilled, e2);
          }, h.prototype.callRejected = function(e2) {
            l.reject(this.promise, e2);
          }, h.prototype.otherCallRejected = function(e2) {
            f(this.promise, this.onRejected, e2);
          }, l.resolve = function(e2, t4) {
            var r2 = p(c, t4);
            if ("error" === r2.status)
              return l.reject(e2, r2.value);
            var n2 = r2.value;
            if (n2)
              d(e2, n2);
            else {
              e2.state = a, e2.outcome = t4;
              for (var i2 = -1, s2 = e2.queue.length; ++i2 < s2; )
                e2.queue[i2].callFulfilled(t4);
            }
            return e2;
          }, l.reject = function(e2, t4) {
            e2.state = s, e2.outcome = t4;
            for (var r2 = -1, n2 = e2.queue.length; ++r2 < n2; )
              e2.queue[r2].callRejected(t4);
            return e2;
          }, o.resolve = function(e2) {
            if (e2 instanceof this)
              return e2;
            return l.resolve(new this(u), e2);
          }, o.reject = function(e2) {
            var t4 = new this(u);
            return l.reject(t4, e2);
          }, o.all = function(e2) {
            var r2 = this;
            if ("[object Array]" !== Object.prototype.toString.call(e2))
              return this.reject(new TypeError("must be an array"));
            var n2 = e2.length, i2 = false;
            if (!n2)
              return this.resolve([]);
            var s2 = new Array(n2), a2 = 0, t4 = -1, o2 = new this(u);
            for (; ++t4 < n2; )
              h2(e2[t4], t4);
            return o2;
            function h2(e3, t5) {
              r2.resolve(e3).then(function(e4) {
                s2[t5] = e4, ++a2 !== n2 || i2 || (i2 = true, l.resolve(o2, s2));
              }, function(e4) {
                i2 || (i2 = true, l.reject(o2, e4));
              });
            }
          }, o.race = function(e2) {
            var t4 = this;
            if ("[object Array]" !== Object.prototype.toString.call(e2))
              return this.reject(new TypeError("must be an array"));
            var r2 = e2.length, n2 = false;
            if (!r2)
              return this.resolve([]);
            var i2 = -1, s2 = new this(u);
            for (; ++i2 < r2; )
              a2 = e2[i2], t4.resolve(a2).then(function(e3) {
                n2 || (n2 = true, l.resolve(s2, e3));
              }, function(e3) {
                n2 || (n2 = true, l.reject(s2, e3));
              });
            var a2;
            return s2;
          };
        }, { immediate: 36 }], 38: [function(e, t3, r) {
          "use strict";
          var n = {};
          (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t3.exports = n;
        }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(e, t3, r) {
          "use strict";
          var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
          function p(e2) {
            if (!(this instanceof p))
              return new p(e2);
            this.options = o.assign({ level: f, method: d, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: c, to: "" }, e2 || {});
            var t4 = this.options;
            t4.raw && 0 < t4.windowBits ? t4.windowBits = -t4.windowBits : t4.gzip && 0 < t4.windowBits && t4.windowBits < 16 && (t4.windowBits += 16), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
            var r2 = a.deflateInit2(this.strm, t4.level, t4.method, t4.windowBits, t4.memLevel, t4.strategy);
            if (r2 !== l)
              throw new Error(i[r2]);
            if (t4.header && a.deflateSetHeader(this.strm, t4.header), t4.dictionary) {
              var n2;
              if (n2 = "string" == typeof t4.dictionary ? h.string2buf(t4.dictionary) : "[object ArrayBuffer]" === u.call(t4.dictionary) ? new Uint8Array(t4.dictionary) : t4.dictionary, (r2 = a.deflateSetDictionary(this.strm, n2)) !== l)
                throw new Error(i[r2]);
              this._dict_set = true;
            }
          }
          function n(e2, t4) {
            var r2 = new p(t4);
            if (r2.push(e2, true), r2.err)
              throw r2.msg || i[r2.err];
            return r2.result;
          }
          p.prototype.push = function(e2, t4) {
            var r2, n2, i2 = this.strm, s2 = this.options.chunkSize;
            if (this.ended)
              return false;
            n2 = t4 === ~~t4 ? t4 : true === t4 ? 4 : 0, "string" == typeof e2 ? i2.input = h.string2buf(e2) : "[object ArrayBuffer]" === u.call(e2) ? i2.input = new Uint8Array(e2) : i2.input = e2, i2.next_in = 0, i2.avail_in = i2.input.length;
            do {
              if (0 === i2.avail_out && (i2.output = new o.Buf8(s2), i2.next_out = 0, i2.avail_out = s2), 1 !== (r2 = a.deflate(i2, n2)) && r2 !== l)
                return this.onEnd(r2), !(this.ended = true);
              0 !== i2.avail_out && (0 !== i2.avail_in || 4 !== n2 && 2 !== n2) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i2.output, i2.next_out))) : this.onData(o.shrinkBuf(i2.output, i2.next_out)));
            } while ((0 < i2.avail_in || 0 === i2.avail_out) && 1 !== r2);
            return 4 === n2 ? (r2 = a.deflateEnd(this.strm), this.onEnd(r2), this.ended = true, r2 === l) : 2 !== n2 || (this.onEnd(l), !(i2.avail_out = 0));
          }, p.prototype.onData = function(e2) {
            this.chunks.push(e2);
          }, p.prototype.onEnd = function(e2) {
            e2 === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e2, this.msg = this.strm.msg;
          }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e2, t4) {
            return (t4 = t4 || {}).raw = true, n(e2, t4);
          }, r.gzip = function(e2, t4) {
            return (t4 = t4 || {}).gzip = true, n(e2, t4);
          };
        }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(e, t3, r) {
          "use strict";
          var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
          function a(e2) {
            if (!(this instanceof a))
              return new a(e2);
            this.options = d.assign({ chunkSize: 16384, windowBits: 0, to: "" }, e2 || {});
            var t4 = this.options;
            t4.raw && 0 <= t4.windowBits && t4.windowBits < 16 && (t4.windowBits = -t4.windowBits, 0 === t4.windowBits && (t4.windowBits = -15)), !(0 <= t4.windowBits && t4.windowBits < 16) || e2 && e2.windowBits || (t4.windowBits += 32), 15 < t4.windowBits && t4.windowBits < 48 && 0 == (15 & t4.windowBits) && (t4.windowBits |= 15), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
            var r2 = c.inflateInit2(this.strm, t4.windowBits);
            if (r2 !== m.Z_OK)
              throw new Error(n[r2]);
            this.header = new s(), c.inflateGetHeader(this.strm, this.header);
          }
          function o(e2, t4) {
            var r2 = new a(t4);
            if (r2.push(e2, true), r2.err)
              throw r2.msg || n[r2.err];
            return r2.result;
          }
          a.prototype.push = function(e2, t4) {
            var r2, n2, i2, s2, a2, o2, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = false;
            if (this.ended)
              return false;
            n2 = t4 === ~~t4 ? t4 : true === t4 ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e2 ? h.input = p.binstring2buf(e2) : "[object ArrayBuffer]" === _.call(e2) ? h.input = new Uint8Array(e2) : h.input = e2, h.next_in = 0, h.avail_in = h.input.length;
            do {
              if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r2 = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o2 = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r2 = c.inflateSetDictionary(this.strm, o2)), r2 === m.Z_BUF_ERROR && true === f && (r2 = m.Z_OK, f = false), r2 !== m.Z_STREAM_END && r2 !== m.Z_OK)
                return this.onEnd(r2), !(this.ended = true);
              h.next_out && (0 !== h.avail_out && r2 !== m.Z_STREAM_END && (0 !== h.avail_in || n2 !== m.Z_FINISH && n2 !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i2 = p.utf8border(h.output, h.next_out), s2 = h.next_out - i2, a2 = p.buf2string(h.output, i2), h.next_out = s2, h.avail_out = u - s2, s2 && d.arraySet(h.output, h.output, i2, s2, 0), this.onData(a2)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = true);
            } while ((0 < h.avail_in || 0 === h.avail_out) && r2 !== m.Z_STREAM_END);
            return r2 === m.Z_STREAM_END && (n2 = m.Z_FINISH), n2 === m.Z_FINISH ? (r2 = c.inflateEnd(this.strm), this.onEnd(r2), this.ended = true, r2 === m.Z_OK) : n2 !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), !(h.avail_out = 0));
          }, a.prototype.onData = function(e2) {
            this.chunks.push(e2);
          }, a.prototype.onEnd = function(e2) {
            e2 === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e2, this.msg = this.strm.msg;
          }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e2, t4) {
            return (t4 = t4 || {}).raw = true, o(e2, t4);
          }, r.ungzip = o;
        }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(e, t3, r) {
          "use strict";
          var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
          r.assign = function(e2) {
            for (var t4 = Array.prototype.slice.call(arguments, 1); t4.length; ) {
              var r2 = t4.shift();
              if (r2) {
                if ("object" != typeof r2)
                  throw new TypeError(r2 + "must be non-object");
                for (var n2 in r2)
                  r2.hasOwnProperty(n2) && (e2[n2] = r2[n2]);
              }
            }
            return e2;
          }, r.shrinkBuf = function(e2, t4) {
            return e2.length === t4 ? e2 : e2.subarray ? e2.subarray(0, t4) : (e2.length = t4, e2);
          };
          var i = { arraySet: function(e2, t4, r2, n2, i2) {
            if (t4.subarray && e2.subarray)
              e2.set(t4.subarray(r2, r2 + n2), i2);
            else
              for (var s2 = 0; s2 < n2; s2++)
                e2[i2 + s2] = t4[r2 + s2];
          }, flattenChunks: function(e2) {
            var t4, r2, n2, i2, s2, a;
            for (t4 = n2 = 0, r2 = e2.length; t4 < r2; t4++)
              n2 += e2[t4].length;
            for (a = new Uint8Array(n2), t4 = i2 = 0, r2 = e2.length; t4 < r2; t4++)
              s2 = e2[t4], a.set(s2, i2), i2 += s2.length;
            return a;
          } }, s = { arraySet: function(e2, t4, r2, n2, i2) {
            for (var s2 = 0; s2 < n2; s2++)
              e2[i2 + s2] = t4[r2 + s2];
          }, flattenChunks: function(e2) {
            return [].concat.apply([], e2);
          } };
          r.setTyped = function(e2) {
            e2 ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
          }, r.setTyped(n);
        }, {}], 42: [function(e, t3, r) {
          "use strict";
          var h = e("./common"), i = true, s = true;
          try {
            String.fromCharCode.apply(null, [0]);
          } catch (e2) {
            i = false;
          }
          try {
            String.fromCharCode.apply(null, new Uint8Array(1));
          } catch (e2) {
            s = false;
          }
          for (var u = new h.Buf8(256), n = 0; n < 256; n++)
            u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
          function l(e2, t4) {
            if (t4 < 65537 && (e2.subarray && s || !e2.subarray && i))
              return String.fromCharCode.apply(null, h.shrinkBuf(e2, t4));
            for (var r2 = "", n2 = 0; n2 < t4; n2++)
              r2 += String.fromCharCode(e2[n2]);
            return r2;
          }
          u[254] = u[254] = 1, r.string2buf = function(e2) {
            var t4, r2, n2, i2, s2, a = e2.length, o = 0;
            for (i2 = 0; i2 < a; i2++)
              55296 == (64512 & (r2 = e2.charCodeAt(i2))) && i2 + 1 < a && 56320 == (64512 & (n2 = e2.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), o += r2 < 128 ? 1 : r2 < 2048 ? 2 : r2 < 65536 ? 3 : 4;
            for (t4 = new h.Buf8(o), i2 = s2 = 0; s2 < o; i2++)
              55296 == (64512 & (r2 = e2.charCodeAt(i2))) && i2 + 1 < a && 56320 == (64512 & (n2 = e2.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), r2 < 128 ? t4[s2++] = r2 : (r2 < 2048 ? t4[s2++] = 192 | r2 >>> 6 : (r2 < 65536 ? t4[s2++] = 224 | r2 >>> 12 : (t4[s2++] = 240 | r2 >>> 18, t4[s2++] = 128 | r2 >>> 12 & 63), t4[s2++] = 128 | r2 >>> 6 & 63), t4[s2++] = 128 | 63 & r2);
            return t4;
          }, r.buf2binstring = function(e2) {
            return l(e2, e2.length);
          }, r.binstring2buf = function(e2) {
            for (var t4 = new h.Buf8(e2.length), r2 = 0, n2 = t4.length; r2 < n2; r2++)
              t4[r2] = e2.charCodeAt(r2);
            return t4;
          }, r.buf2string = function(e2, t4) {
            var r2, n2, i2, s2, a = t4 || e2.length, o = new Array(2 * a);
            for (r2 = n2 = 0; r2 < a; )
              if ((i2 = e2[r2++]) < 128)
                o[n2++] = i2;
              else if (4 < (s2 = u[i2]))
                o[n2++] = 65533, r2 += s2 - 1;
              else {
                for (i2 &= 2 === s2 ? 31 : 3 === s2 ? 15 : 7; 1 < s2 && r2 < a; )
                  i2 = i2 << 6 | 63 & e2[r2++], s2--;
                1 < s2 ? o[n2++] = 65533 : i2 < 65536 ? o[n2++] = i2 : (i2 -= 65536, o[n2++] = 55296 | i2 >> 10 & 1023, o[n2++] = 56320 | 1023 & i2);
              }
            return l(o, n2);
          }, r.utf8border = function(e2, t4) {
            var r2;
            for ((t4 = t4 || e2.length) > e2.length && (t4 = e2.length), r2 = t4 - 1; 0 <= r2 && 128 == (192 & e2[r2]); )
              r2--;
            return r2 < 0 ? t4 : 0 === r2 ? t4 : r2 + u[e2[r2]] > t4 ? r2 : t4;
          };
        }, { "./common": 41 }], 43: [function(e, t3, r) {
          "use strict";
          t3.exports = function(e2, t4, r2, n) {
            for (var i = 65535 & e2 | 0, s = e2 >>> 16 & 65535 | 0, a = 0; 0 !== r2; ) {
              for (r2 -= a = 2e3 < r2 ? 2e3 : r2; s = s + (i = i + t4[n++] | 0) | 0, --a; )
                ;
              i %= 65521, s %= 65521;
            }
            return i | s << 16 | 0;
          };
        }, {}], 44: [function(e, t3, r) {
          "use strict";
          t3.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
        }, {}], 45: [function(e, t3, r) {
          "use strict";
          var o = function() {
            for (var e2, t4 = [], r2 = 0; r2 < 256; r2++) {
              e2 = r2;
              for (var n = 0; n < 8; n++)
                e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
              t4[r2] = e2;
            }
            return t4;
          }();
          t3.exports = function(e2, t4, r2, n) {
            var i = o, s = n + r2;
            e2 ^= -1;
            for (var a = n; a < s; a++)
              e2 = e2 >>> 8 ^ i[255 & (e2 ^ t4[a])];
            return -1 ^ e2;
          };
        }, {}], 46: [function(e, t3, r) {
          "use strict";
          var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
          function R(e2, t4) {
            return e2.msg = n[t4], t4;
          }
          function T(e2) {
            return (e2 << 1) - (4 < e2 ? 9 : 0);
          }
          function D(e2) {
            for (var t4 = e2.length; 0 <= --t4; )
              e2[t4] = 0;
          }
          function F(e2) {
            var t4 = e2.state, r2 = t4.pending;
            r2 > e2.avail_out && (r2 = e2.avail_out), 0 !== r2 && (c.arraySet(e2.output, t4.pending_buf, t4.pending_out, r2, e2.next_out), e2.next_out += r2, t4.pending_out += r2, e2.total_out += r2, e2.avail_out -= r2, t4.pending -= r2, 0 === t4.pending && (t4.pending_out = 0));
          }
          function N(e2, t4) {
            u._tr_flush_block(e2, 0 <= e2.block_start ? e2.block_start : -1, e2.strstart - e2.block_start, t4), e2.block_start = e2.strstart, F(e2.strm);
          }
          function U(e2, t4) {
            e2.pending_buf[e2.pending++] = t4;
          }
          function P(e2, t4) {
            e2.pending_buf[e2.pending++] = t4 >>> 8 & 255, e2.pending_buf[e2.pending++] = 255 & t4;
          }
          function L(e2, t4) {
            var r2, n2, i2 = e2.max_chain_length, s2 = e2.strstart, a2 = e2.prev_length, o2 = e2.nice_match, h2 = e2.strstart > e2.w_size - z ? e2.strstart - (e2.w_size - z) : 0, u2 = e2.window, l2 = e2.w_mask, f2 = e2.prev, c2 = e2.strstart + S, d2 = u2[s2 + a2 - 1], p2 = u2[s2 + a2];
            e2.prev_length >= e2.good_match && (i2 >>= 2), o2 > e2.lookahead && (o2 = e2.lookahead);
            do {
              if (u2[(r2 = t4) + a2] === p2 && u2[r2 + a2 - 1] === d2 && u2[r2] === u2[s2] && u2[++r2] === u2[s2 + 1]) {
                s2 += 2, r2++;
                do {
                } while (u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && s2 < c2);
                if (n2 = S - (c2 - s2), s2 = c2 - S, a2 < n2) {
                  if (e2.match_start = t4, o2 <= (a2 = n2))
                    break;
                  d2 = u2[s2 + a2 - 1], p2 = u2[s2 + a2];
                }
              }
            } while ((t4 = f2[t4 & l2]) > h2 && 0 != --i2);
            return a2 <= e2.lookahead ? a2 : e2.lookahead;
          }
          function j(e2) {
            var t4, r2, n2, i2, s2, a2, o2, h2, u2, l2, f2 = e2.w_size;
            do {
              if (i2 = e2.window_size - e2.lookahead - e2.strstart, e2.strstart >= f2 + (f2 - z)) {
                for (c.arraySet(e2.window, e2.window, f2, f2, 0), e2.match_start -= f2, e2.strstart -= f2, e2.block_start -= f2, t4 = r2 = e2.hash_size; n2 = e2.head[--t4], e2.head[t4] = f2 <= n2 ? n2 - f2 : 0, --r2; )
                  ;
                for (t4 = r2 = f2; n2 = e2.prev[--t4], e2.prev[t4] = f2 <= n2 ? n2 - f2 : 0, --r2; )
                  ;
                i2 += f2;
              }
              if (0 === e2.strm.avail_in)
                break;
              if (a2 = e2.strm, o2 = e2.window, h2 = e2.strstart + e2.lookahead, u2 = i2, l2 = void 0, l2 = a2.avail_in, u2 < l2 && (l2 = u2), r2 = 0 === l2 ? 0 : (a2.avail_in -= l2, c.arraySet(o2, a2.input, a2.next_in, l2, h2), 1 === a2.state.wrap ? a2.adler = d(a2.adler, o2, l2, h2) : 2 === a2.state.wrap && (a2.adler = p(a2.adler, o2, l2, h2)), a2.next_in += l2, a2.total_in += l2, l2), e2.lookahead += r2, e2.lookahead + e2.insert >= x)
                for (s2 = e2.strstart - e2.insert, e2.ins_h = e2.window[s2], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[s2 + 1]) & e2.hash_mask; e2.insert && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[s2 + x - 1]) & e2.hash_mask, e2.prev[s2 & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = s2, s2++, e2.insert--, !(e2.lookahead + e2.insert < x)); )
                  ;
            } while (e2.lookahead < z && 0 !== e2.strm.avail_in);
          }
          function Z(e2, t4) {
            for (var r2, n2; ; ) {
              if (e2.lookahead < z) {
                if (j(e2), e2.lookahead < z && t4 === l)
                  return A;
                if (0 === e2.lookahead)
                  break;
              }
              if (r2 = 0, e2.lookahead >= x && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), 0 !== r2 && e2.strstart - r2 <= e2.w_size - z && (e2.match_length = L(e2, r2)), e2.match_length >= x)
                if (n2 = u._tr_tally(e2, e2.strstart - e2.match_start, e2.match_length - x), e2.lookahead -= e2.match_length, e2.match_length <= e2.max_lazy_match && e2.lookahead >= x) {
                  for (e2.match_length--; e2.strstart++, e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart, 0 != --e2.match_length; )
                    ;
                  e2.strstart++;
                } else
                  e2.strstart += e2.match_length, e2.match_length = 0, e2.ins_h = e2.window[e2.strstart], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + 1]) & e2.hash_mask;
              else
                n2 = u._tr_tally(e2, 0, e2.window[e2.strstart]), e2.lookahead--, e2.strstart++;
              if (n2 && (N(e2, false), 0 === e2.strm.avail_out))
                return A;
            }
            return e2.insert = e2.strstart < x - 1 ? e2.strstart : x - 1, t4 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : e2.last_lit && (N(e2, false), 0 === e2.strm.avail_out) ? A : I;
          }
          function W(e2, t4) {
            for (var r2, n2, i2; ; ) {
              if (e2.lookahead < z) {
                if (j(e2), e2.lookahead < z && t4 === l)
                  return A;
                if (0 === e2.lookahead)
                  break;
              }
              if (r2 = 0, e2.lookahead >= x && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), e2.prev_length = e2.match_length, e2.prev_match = e2.match_start, e2.match_length = x - 1, 0 !== r2 && e2.prev_length < e2.max_lazy_match && e2.strstart - r2 <= e2.w_size - z && (e2.match_length = L(e2, r2), e2.match_length <= 5 && (1 === e2.strategy || e2.match_length === x && 4096 < e2.strstart - e2.match_start) && (e2.match_length = x - 1)), e2.prev_length >= x && e2.match_length <= e2.prev_length) {
                for (i2 = e2.strstart + e2.lookahead - x, n2 = u._tr_tally(e2, e2.strstart - 1 - e2.prev_match, e2.prev_length - x), e2.lookahead -= e2.prev_length - 1, e2.prev_length -= 2; ++e2.strstart <= i2 && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), 0 != --e2.prev_length; )
                  ;
                if (e2.match_available = 0, e2.match_length = x - 1, e2.strstart++, n2 && (N(e2, false), 0 === e2.strm.avail_out))
                  return A;
              } else if (e2.match_available) {
                if ((n2 = u._tr_tally(e2, 0, e2.window[e2.strstart - 1])) && N(e2, false), e2.strstart++, e2.lookahead--, 0 === e2.strm.avail_out)
                  return A;
              } else
                e2.match_available = 1, e2.strstart++, e2.lookahead--;
            }
            return e2.match_available && (n2 = u._tr_tally(e2, 0, e2.window[e2.strstart - 1]), e2.match_available = 0), e2.insert = e2.strstart < x - 1 ? e2.strstart : x - 1, t4 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : e2.last_lit && (N(e2, false), 0 === e2.strm.avail_out) ? A : I;
          }
          function M(e2, t4, r2, n2, i2) {
            this.good_length = e2, this.max_lazy = t4, this.nice_length = r2, this.max_chain = n2, this.func = i2;
          }
          function H() {
            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
          }
          function G(e2) {
            var t4;
            return e2 && e2.state ? (e2.total_in = e2.total_out = 0, e2.data_type = i, (t4 = e2.state).pending = 0, t4.pending_out = 0, t4.wrap < 0 && (t4.wrap = -t4.wrap), t4.status = t4.wrap ? C : E, e2.adler = 2 === t4.wrap ? 0 : 1, t4.last_flush = l, u._tr_init(t4), m) : R(e2, _);
          }
          function K(e2) {
            var t4 = G(e2);
            return t4 === m && function(e3) {
              e3.window_size = 2 * e3.w_size, D(e3.head), e3.max_lazy_match = h[e3.level].max_lazy, e3.good_match = h[e3.level].good_length, e3.nice_match = h[e3.level].nice_length, e3.max_chain_length = h[e3.level].max_chain, e3.strstart = 0, e3.block_start = 0, e3.lookahead = 0, e3.insert = 0, e3.match_length = e3.prev_length = x - 1, e3.match_available = 0, e3.ins_h = 0;
            }(e2.state), t4;
          }
          function Y(e2, t4, r2, n2, i2, s2) {
            if (!e2)
              return _;
            var a2 = 1;
            if (t4 === g && (t4 = 6), n2 < 0 ? (a2 = 0, n2 = -n2) : 15 < n2 && (a2 = 2, n2 -= 16), i2 < 1 || y < i2 || r2 !== v || n2 < 8 || 15 < n2 || t4 < 0 || 9 < t4 || s2 < 0 || b < s2)
              return R(e2, _);
            8 === n2 && (n2 = 9);
            var o2 = new H();
            return (e2.state = o2).strm = e2, o2.wrap = a2, o2.gzhead = null, o2.w_bits = n2, o2.w_size = 1 << o2.w_bits, o2.w_mask = o2.w_size - 1, o2.hash_bits = i2 + 7, o2.hash_size = 1 << o2.hash_bits, o2.hash_mask = o2.hash_size - 1, o2.hash_shift = ~~((o2.hash_bits + x - 1) / x), o2.window = new c.Buf8(2 * o2.w_size), o2.head = new c.Buf16(o2.hash_size), o2.prev = new c.Buf16(o2.w_size), o2.lit_bufsize = 1 << i2 + 6, o2.pending_buf_size = 4 * o2.lit_bufsize, o2.pending_buf = new c.Buf8(o2.pending_buf_size), o2.d_buf = 1 * o2.lit_bufsize, o2.l_buf = 3 * o2.lit_bufsize, o2.level = t4, o2.strategy = s2, o2.method = r2, K(e2);
          }
          h = [new M(0, 0, 0, 0, function(e2, t4) {
            var r2 = 65535;
            for (r2 > e2.pending_buf_size - 5 && (r2 = e2.pending_buf_size - 5); ; ) {
              if (e2.lookahead <= 1) {
                if (j(e2), 0 === e2.lookahead && t4 === l)
                  return A;
                if (0 === e2.lookahead)
                  break;
              }
              e2.strstart += e2.lookahead, e2.lookahead = 0;
              var n2 = e2.block_start + r2;
              if ((0 === e2.strstart || e2.strstart >= n2) && (e2.lookahead = e2.strstart - n2, e2.strstart = n2, N(e2, false), 0 === e2.strm.avail_out))
                return A;
              if (e2.strstart - e2.block_start >= e2.w_size - z && (N(e2, false), 0 === e2.strm.avail_out))
                return A;
            }
            return e2.insert = 0, t4 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : (e2.strstart > e2.block_start && (N(e2, false), e2.strm.avail_out), A);
          }), new M(4, 4, 8, 4, Z), new M(4, 5, 16, 8, Z), new M(4, 6, 32, 32, Z), new M(4, 4, 16, 16, W), new M(8, 16, 32, 32, W), new M(8, 16, 128, 128, W), new M(8, 32, 128, 256, W), new M(32, 128, 258, 1024, W), new M(32, 258, 258, 4096, W)], r.deflateInit = function(e2, t4) {
            return Y(e2, t4, v, 15, 8, 0);
          }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e2, t4) {
            return e2 && e2.state ? 2 !== e2.state.wrap ? _ : (e2.state.gzhead = t4, m) : _;
          }, r.deflate = function(e2, t4) {
            var r2, n2, i2, s2;
            if (!e2 || !e2.state || 5 < t4 || t4 < 0)
              return e2 ? R(e2, _) : _;
            if (n2 = e2.state, !e2.output || !e2.input && 0 !== e2.avail_in || 666 === n2.status && t4 !== f)
              return R(e2, 0 === e2.avail_out ? -5 : _);
            if (n2.strm = e2, r2 = n2.last_flush, n2.last_flush = t4, n2.status === C)
              if (2 === n2.wrap)
                e2.adler = 0, U(n2, 31), U(n2, 139), U(n2, 8), n2.gzhead ? (U(n2, (n2.gzhead.text ? 1 : 0) + (n2.gzhead.hcrc ? 2 : 0) + (n2.gzhead.extra ? 4 : 0) + (n2.gzhead.name ? 8 : 0) + (n2.gzhead.comment ? 16 : 0)), U(n2, 255 & n2.gzhead.time), U(n2, n2.gzhead.time >> 8 & 255), U(n2, n2.gzhead.time >> 16 & 255), U(n2, n2.gzhead.time >> 24 & 255), U(n2, 9 === n2.level ? 2 : 2 <= n2.strategy || n2.level < 2 ? 4 : 0), U(n2, 255 & n2.gzhead.os), n2.gzhead.extra && n2.gzhead.extra.length && (U(n2, 255 & n2.gzhead.extra.length), U(n2, n2.gzhead.extra.length >> 8 & 255)), n2.gzhead.hcrc && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending, 0)), n2.gzindex = 0, n2.status = 69) : (U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 9 === n2.level ? 2 : 2 <= n2.strategy || n2.level < 2 ? 4 : 0), U(n2, 3), n2.status = E);
              else {
                var a2 = v + (n2.w_bits - 8 << 4) << 8;
                a2 |= (2 <= n2.strategy || n2.level < 2 ? 0 : n2.level < 6 ? 1 : 6 === n2.level ? 2 : 3) << 6, 0 !== n2.strstart && (a2 |= 32), a2 += 31 - a2 % 31, n2.status = E, P(n2, a2), 0 !== n2.strstart && (P(n2, e2.adler >>> 16), P(n2, 65535 & e2.adler)), e2.adler = 1;
              }
            if (69 === n2.status)
              if (n2.gzhead.extra) {
                for (i2 = n2.pending; n2.gzindex < (65535 & n2.gzhead.extra.length) && (n2.pending !== n2.pending_buf_size || (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending !== n2.pending_buf_size)); )
                  U(n2, 255 & n2.gzhead.extra[n2.gzindex]), n2.gzindex++;
                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), n2.gzindex === n2.gzhead.extra.length && (n2.gzindex = 0, n2.status = 73);
              } else
                n2.status = 73;
            if (73 === n2.status)
              if (n2.gzhead.name) {
                i2 = n2.pending;
                do {
                  if (n2.pending === n2.pending_buf_size && (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending === n2.pending_buf_size)) {
                    s2 = 1;
                    break;
                  }
                  s2 = n2.gzindex < n2.gzhead.name.length ? 255 & n2.gzhead.name.charCodeAt(n2.gzindex++) : 0, U(n2, s2);
                } while (0 !== s2);
                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), 0 === s2 && (n2.gzindex = 0, n2.status = 91);
              } else
                n2.status = 91;
            if (91 === n2.status)
              if (n2.gzhead.comment) {
                i2 = n2.pending;
                do {
                  if (n2.pending === n2.pending_buf_size && (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending === n2.pending_buf_size)) {
                    s2 = 1;
                    break;
                  }
                  s2 = n2.gzindex < n2.gzhead.comment.length ? 255 & n2.gzhead.comment.charCodeAt(n2.gzindex++) : 0, U(n2, s2);
                } while (0 !== s2);
                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), 0 === s2 && (n2.status = 103);
              } else
                n2.status = 103;
            if (103 === n2.status && (n2.gzhead.hcrc ? (n2.pending + 2 > n2.pending_buf_size && F(e2), n2.pending + 2 <= n2.pending_buf_size && (U(n2, 255 & e2.adler), U(n2, e2.adler >> 8 & 255), e2.adler = 0, n2.status = E)) : n2.status = E), 0 !== n2.pending) {
              if (F(e2), 0 === e2.avail_out)
                return n2.last_flush = -1, m;
            } else if (0 === e2.avail_in && T(t4) <= T(r2) && t4 !== f)
              return R(e2, -5);
            if (666 === n2.status && 0 !== e2.avail_in)
              return R(e2, -5);
            if (0 !== e2.avail_in || 0 !== n2.lookahead || t4 !== l && 666 !== n2.status) {
              var o2 = 2 === n2.strategy ? function(e3, t5) {
                for (var r3; ; ) {
                  if (0 === e3.lookahead && (j(e3), 0 === e3.lookahead)) {
                    if (t5 === l)
                      return A;
                    break;
                  }
                  if (e3.match_length = 0, r3 = u._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++, r3 && (N(e3, false), 0 === e3.strm.avail_out))
                    return A;
                }
                return e3.insert = 0, t5 === f ? (N(e3, true), 0 === e3.strm.avail_out ? O : B) : e3.last_lit && (N(e3, false), 0 === e3.strm.avail_out) ? A : I;
              }(n2, t4) : 3 === n2.strategy ? function(e3, t5) {
                for (var r3, n3, i3, s3, a3 = e3.window; ; ) {
                  if (e3.lookahead <= S) {
                    if (j(e3), e3.lookahead <= S && t5 === l)
                      return A;
                    if (0 === e3.lookahead)
                      break;
                  }
                  if (e3.match_length = 0, e3.lookahead >= x && 0 < e3.strstart && (n3 = a3[i3 = e3.strstart - 1]) === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3]) {
                    s3 = e3.strstart + S;
                    do {
                    } while (n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && i3 < s3);
                    e3.match_length = S - (s3 - i3), e3.match_length > e3.lookahead && (e3.match_length = e3.lookahead);
                  }
                  if (e3.match_length >= x ? (r3 = u._tr_tally(e3, 1, e3.match_length - x), e3.lookahead -= e3.match_length, e3.strstart += e3.match_length, e3.match_length = 0) : (r3 = u._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++), r3 && (N(e3, false), 0 === e3.strm.avail_out))
                    return A;
                }
                return e3.insert = 0, t5 === f ? (N(e3, true), 0 === e3.strm.avail_out ? O : B) : e3.last_lit && (N(e3, false), 0 === e3.strm.avail_out) ? A : I;
              }(n2, t4) : h[n2.level].func(n2, t4);
              if (o2 !== O && o2 !== B || (n2.status = 666), o2 === A || o2 === O)
                return 0 === e2.avail_out && (n2.last_flush = -1), m;
              if (o2 === I && (1 === t4 ? u._tr_align(n2) : 5 !== t4 && (u._tr_stored_block(n2, 0, 0, false), 3 === t4 && (D(n2.head), 0 === n2.lookahead && (n2.strstart = 0, n2.block_start = 0, n2.insert = 0))), F(e2), 0 === e2.avail_out))
                return n2.last_flush = -1, m;
            }
            return t4 !== f ? m : n2.wrap <= 0 ? 1 : (2 === n2.wrap ? (U(n2, 255 & e2.adler), U(n2, e2.adler >> 8 & 255), U(n2, e2.adler >> 16 & 255), U(n2, e2.adler >> 24 & 255), U(n2, 255 & e2.total_in), U(n2, e2.total_in >> 8 & 255), U(n2, e2.total_in >> 16 & 255), U(n2, e2.total_in >> 24 & 255)) : (P(n2, e2.adler >>> 16), P(n2, 65535 & e2.adler)), F(e2), 0 < n2.wrap && (n2.wrap = -n2.wrap), 0 !== n2.pending ? m : 1);
          }, r.deflateEnd = function(e2) {
            var t4;
            return e2 && e2.state ? (t4 = e2.state.status) !== C && 69 !== t4 && 73 !== t4 && 91 !== t4 && 103 !== t4 && t4 !== E && 666 !== t4 ? R(e2, _) : (e2.state = null, t4 === E ? R(e2, -3) : m) : _;
          }, r.deflateSetDictionary = function(e2, t4) {
            var r2, n2, i2, s2, a2, o2, h2, u2, l2 = t4.length;
            if (!e2 || !e2.state)
              return _;
            if (2 === (s2 = (r2 = e2.state).wrap) || 1 === s2 && r2.status !== C || r2.lookahead)
              return _;
            for (1 === s2 && (e2.adler = d(e2.adler, t4, l2, 0)), r2.wrap = 0, l2 >= r2.w_size && (0 === s2 && (D(r2.head), r2.strstart = 0, r2.block_start = 0, r2.insert = 0), u2 = new c.Buf8(r2.w_size), c.arraySet(u2, t4, l2 - r2.w_size, r2.w_size, 0), t4 = u2, l2 = r2.w_size), a2 = e2.avail_in, o2 = e2.next_in, h2 = e2.input, e2.avail_in = l2, e2.next_in = 0, e2.input = t4, j(r2); r2.lookahead >= x; ) {
              for (n2 = r2.strstart, i2 = r2.lookahead - (x - 1); r2.ins_h = (r2.ins_h << r2.hash_shift ^ r2.window[n2 + x - 1]) & r2.hash_mask, r2.prev[n2 & r2.w_mask] = r2.head[r2.ins_h], r2.head[r2.ins_h] = n2, n2++, --i2; )
                ;
              r2.strstart = n2, r2.lookahead = x - 1, j(r2);
            }
            return r2.strstart += r2.lookahead, r2.block_start = r2.strstart, r2.insert = r2.lookahead, r2.lookahead = 0, r2.match_length = r2.prev_length = x - 1, r2.match_available = 0, e2.next_in = o2, e2.input = h2, e2.avail_in = a2, r2.wrap = s2, m;
          }, r.deflateInfo = "pako deflate (from Nodeca project)";
        }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(e, t3, r) {
          "use strict";
          t3.exports = function() {
            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = false;
          };
        }, {}], 48: [function(e, t3, r) {
          "use strict";
          t3.exports = function(e2, t4) {
            var r2, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
            r2 = e2.state, n = e2.next_in, z = e2.input, i = n + (e2.avail_in - 5), s = e2.next_out, C = e2.output, a = s - (t4 - e2.avail_out), o = s + (e2.avail_out - 257), h = r2.dmax, u = r2.wsize, l = r2.whave, f = r2.wnext, c = r2.window, d = r2.hold, p = r2.bits, m = r2.lencode, _ = r2.distcode, g = (1 << r2.lenbits) - 1, b = (1 << r2.distbits) - 1;
            e:
              do {
                p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                t:
                  for (; ; ) {
                    if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255))
                      C[s++] = 65535 & v;
                    else {
                      if (!(16 & y)) {
                        if (0 == (64 & y)) {
                          v = m[(65535 & v) + (d & (1 << y) - 1)];
                          continue t;
                        }
                        if (32 & y) {
                          r2.mode = 12;
                          break e;
                        }
                        e2.msg = "invalid literal/length code", r2.mode = 30;
                        break e;
                      }
                      w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                      r:
                        for (; ; ) {
                          if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                            if (0 == (64 & y)) {
                              v = _[(65535 & v) + (d & (1 << y) - 1)];
                              continue r;
                            }
                            e2.msg = "invalid distance code", r2.mode = 30;
                            break e;
                          }
                          if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                            e2.msg = "invalid distance too far back", r2.mode = 30;
                            break e;
                          }
                          if (d >>>= y, p -= y, (y = s - a) < k) {
                            if (l < (y = k - y) && r2.sane) {
                              e2.msg = "invalid distance too far back", r2.mode = 30;
                              break e;
                            }
                            if (S = c, (x = 0) === f) {
                              if (x += u - y, y < w) {
                                for (w -= y; C[s++] = c[x++], --y; )
                                  ;
                                x = s - k, S = C;
                              }
                            } else if (f < y) {
                              if (x += u + f - y, (y -= f) < w) {
                                for (w -= y; C[s++] = c[x++], --y; )
                                  ;
                                if (x = 0, f < w) {
                                  for (w -= y = f; C[s++] = c[x++], --y; )
                                    ;
                                  x = s - k, S = C;
                                }
                              }
                            } else if (x += f - y, y < w) {
                              for (w -= y; C[s++] = c[x++], --y; )
                                ;
                              x = s - k, S = C;
                            }
                            for (; 2 < w; )
                              C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                            w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                          } else {
                            for (x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3); )
                              ;
                            w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                          }
                          break;
                        }
                    }
                    break;
                  }
              } while (n < i && s < o);
            n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e2.next_in = n, e2.next_out = s, e2.avail_in = n < i ? i - n + 5 : 5 - (n - i), e2.avail_out = s < o ? o - s + 257 : 257 - (s - o), r2.hold = d, r2.bits = p;
          };
        }, {}], 49: [function(e, t3, r) {
          "use strict";
          var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
          function L(e2) {
            return (e2 >>> 24 & 255) + (e2 >>> 8 & 65280) + ((65280 & e2) << 8) + ((255 & e2) << 24);
          }
          function s() {
            this.mode = 0, this.last = false, this.wrap = 0, this.havedict = false, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
          }
          function a(e2) {
            var t4;
            return e2 && e2.state ? (t4 = e2.state, e2.total_in = e2.total_out = t4.total = 0, e2.msg = "", t4.wrap && (e2.adler = 1 & t4.wrap), t4.mode = P, t4.last = 0, t4.havedict = 0, t4.dmax = 32768, t4.head = null, t4.hold = 0, t4.bits = 0, t4.lencode = t4.lendyn = new I.Buf32(n), t4.distcode = t4.distdyn = new I.Buf32(i), t4.sane = 1, t4.back = -1, N) : U;
          }
          function o(e2) {
            var t4;
            return e2 && e2.state ? ((t4 = e2.state).wsize = 0, t4.whave = 0, t4.wnext = 0, a(e2)) : U;
          }
          function h(e2, t4) {
            var r2, n2;
            return e2 && e2.state ? (n2 = e2.state, t4 < 0 ? (r2 = 0, t4 = -t4) : (r2 = 1 + (t4 >> 4), t4 < 48 && (t4 &= 15)), t4 && (t4 < 8 || 15 < t4) ? U : (null !== n2.window && n2.wbits !== t4 && (n2.window = null), n2.wrap = r2, n2.wbits = t4, o(e2))) : U;
          }
          function u(e2, t4) {
            var r2, n2;
            return e2 ? (n2 = new s(), (e2.state = n2).window = null, (r2 = h(e2, t4)) !== N && (e2.state = null), r2) : U;
          }
          var l, f, c = true;
          function j(e2) {
            if (c) {
              var t4;
              for (l = new I.Buf32(512), f = new I.Buf32(32), t4 = 0; t4 < 144; )
                e2.lens[t4++] = 8;
              for (; t4 < 256; )
                e2.lens[t4++] = 9;
              for (; t4 < 280; )
                e2.lens[t4++] = 7;
              for (; t4 < 288; )
                e2.lens[t4++] = 8;
              for (T(D, e2.lens, 0, 288, l, 0, e2.work, { bits: 9 }), t4 = 0; t4 < 32; )
                e2.lens[t4++] = 5;
              T(F, e2.lens, 0, 32, f, 0, e2.work, { bits: 5 }), c = false;
            }
            e2.lencode = l, e2.lenbits = 9, e2.distcode = f, e2.distbits = 5;
          }
          function Z(e2, t4, r2, n2) {
            var i2, s2 = e2.state;
            return null === s2.window && (s2.wsize = 1 << s2.wbits, s2.wnext = 0, s2.whave = 0, s2.window = new I.Buf8(s2.wsize)), n2 >= s2.wsize ? (I.arraySet(s2.window, t4, r2 - s2.wsize, s2.wsize, 0), s2.wnext = 0, s2.whave = s2.wsize) : (n2 < (i2 = s2.wsize - s2.wnext) && (i2 = n2), I.arraySet(s2.window, t4, r2 - n2, i2, s2.wnext), (n2 -= i2) ? (I.arraySet(s2.window, t4, r2 - n2, n2, 0), s2.wnext = n2, s2.whave = s2.wsize) : (s2.wnext += i2, s2.wnext === s2.wsize && (s2.wnext = 0), s2.whave < s2.wsize && (s2.whave += i2))), 0;
          }
          r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e2) {
            return u(e2, 15);
          }, r.inflateInit2 = u, r.inflate = function(e2, t4) {
            var r2, n2, i2, s2, a2, o2, h2, u2, l2, f2, c2, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
            if (!e2 || !e2.state || !e2.output || !e2.input && 0 !== e2.avail_in)
              return U;
            12 === (r2 = e2.state).mode && (r2.mode = 13), a2 = e2.next_out, i2 = e2.output, h2 = e2.avail_out, s2 = e2.next_in, n2 = e2.input, o2 = e2.avail_in, u2 = r2.hold, l2 = r2.bits, f2 = o2, c2 = h2, x = N;
            e:
              for (; ; )
                switch (r2.mode) {
                  case P:
                    if (0 === r2.wrap) {
                      r2.mode = 13;
                      break;
                    }
                    for (; l2 < 16; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (2 & r2.wrap && 35615 === u2) {
                      E[r2.check = 0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0), l2 = u2 = 0, r2.mode = 2;
                      break;
                    }
                    if (r2.flags = 0, r2.head && (r2.head.done = false), !(1 & r2.wrap) || (((255 & u2) << 8) + (u2 >> 8)) % 31) {
                      e2.msg = "incorrect header check", r2.mode = 30;
                      break;
                    }
                    if (8 != (15 & u2)) {
                      e2.msg = "unknown compression method", r2.mode = 30;
                      break;
                    }
                    if (l2 -= 4, k = 8 + (15 & (u2 >>>= 4)), 0 === r2.wbits)
                      r2.wbits = k;
                    else if (k > r2.wbits) {
                      e2.msg = "invalid window size", r2.mode = 30;
                      break;
                    }
                    r2.dmax = 1 << k, e2.adler = r2.check = 1, r2.mode = 512 & u2 ? 10 : 12, l2 = u2 = 0;
                    break;
                  case 2:
                    for (; l2 < 16; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (r2.flags = u2, 8 != (255 & r2.flags)) {
                      e2.msg = "unknown compression method", r2.mode = 30;
                      break;
                    }
                    if (57344 & r2.flags) {
                      e2.msg = "unknown header flags set", r2.mode = 30;
                      break;
                    }
                    r2.head && (r2.head.text = u2 >> 8 & 1), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0, r2.mode = 3;
                  case 3:
                    for (; l2 < 32; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    r2.head && (r2.head.time = u2), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, E[2] = u2 >>> 16 & 255, E[3] = u2 >>> 24 & 255, r2.check = B(r2.check, E, 4, 0)), l2 = u2 = 0, r2.mode = 4;
                  case 4:
                    for (; l2 < 16; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    r2.head && (r2.head.xflags = 255 & u2, r2.head.os = u2 >> 8), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0, r2.mode = 5;
                  case 5:
                    if (1024 & r2.flags) {
                      for (; l2 < 16; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.length = u2, r2.head && (r2.head.extra_len = u2), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0;
                    } else
                      r2.head && (r2.head.extra = null);
                    r2.mode = 6;
                  case 6:
                    if (1024 & r2.flags && (o2 < (d = r2.length) && (d = o2), d && (r2.head && (k = r2.head.extra_len - r2.length, r2.head.extra || (r2.head.extra = new Array(r2.head.extra_len)), I.arraySet(r2.head.extra, n2, s2, d, k)), 512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, r2.length -= d), r2.length))
                      break e;
                    r2.length = 0, r2.mode = 7;
                  case 7:
                    if (2048 & r2.flags) {
                      if (0 === o2)
                        break e;
                      for (d = 0; k = n2[s2 + d++], r2.head && k && r2.length < 65536 && (r2.head.name += String.fromCharCode(k)), k && d < o2; )
                        ;
                      if (512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, k)
                        break e;
                    } else
                      r2.head && (r2.head.name = null);
                    r2.length = 0, r2.mode = 8;
                  case 8:
                    if (4096 & r2.flags) {
                      if (0 === o2)
                        break e;
                      for (d = 0; k = n2[s2 + d++], r2.head && k && r2.length < 65536 && (r2.head.comment += String.fromCharCode(k)), k && d < o2; )
                        ;
                      if (512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, k)
                        break e;
                    } else
                      r2.head && (r2.head.comment = null);
                    r2.mode = 9;
                  case 9:
                    if (512 & r2.flags) {
                      for (; l2 < 16; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      if (u2 !== (65535 & r2.check)) {
                        e2.msg = "header crc mismatch", r2.mode = 30;
                        break;
                      }
                      l2 = u2 = 0;
                    }
                    r2.head && (r2.head.hcrc = r2.flags >> 9 & 1, r2.head.done = true), e2.adler = r2.check = 0, r2.mode = 12;
                    break;
                  case 10:
                    for (; l2 < 32; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    e2.adler = r2.check = L(u2), l2 = u2 = 0, r2.mode = 11;
                  case 11:
                    if (0 === r2.havedict)
                      return e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, 2;
                    e2.adler = r2.check = 1, r2.mode = 12;
                  case 12:
                    if (5 === t4 || 6 === t4)
                      break e;
                  case 13:
                    if (r2.last) {
                      u2 >>>= 7 & l2, l2 -= 7 & l2, r2.mode = 27;
                      break;
                    }
                    for (; l2 < 3; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    switch (r2.last = 1 & u2, l2 -= 1, 3 & (u2 >>>= 1)) {
                      case 0:
                        r2.mode = 14;
                        break;
                      case 1:
                        if (j(r2), r2.mode = 20, 6 !== t4)
                          break;
                        u2 >>>= 2, l2 -= 2;
                        break e;
                      case 2:
                        r2.mode = 17;
                        break;
                      case 3:
                        e2.msg = "invalid block type", r2.mode = 30;
                    }
                    u2 >>>= 2, l2 -= 2;
                    break;
                  case 14:
                    for (u2 >>>= 7 & l2, l2 -= 7 & l2; l2 < 32; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if ((65535 & u2) != (u2 >>> 16 ^ 65535)) {
                      e2.msg = "invalid stored block lengths", r2.mode = 30;
                      break;
                    }
                    if (r2.length = 65535 & u2, l2 = u2 = 0, r2.mode = 15, 6 === t4)
                      break e;
                  case 15:
                    r2.mode = 16;
                  case 16:
                    if (d = r2.length) {
                      if (o2 < d && (d = o2), h2 < d && (d = h2), 0 === d)
                        break e;
                      I.arraySet(i2, n2, s2, d, a2), o2 -= d, s2 += d, h2 -= d, a2 += d, r2.length -= d;
                      break;
                    }
                    r2.mode = 12;
                    break;
                  case 17:
                    for (; l2 < 14; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (r2.nlen = 257 + (31 & u2), u2 >>>= 5, l2 -= 5, r2.ndist = 1 + (31 & u2), u2 >>>= 5, l2 -= 5, r2.ncode = 4 + (15 & u2), u2 >>>= 4, l2 -= 4, 286 < r2.nlen || 30 < r2.ndist) {
                      e2.msg = "too many length or distance symbols", r2.mode = 30;
                      break;
                    }
                    r2.have = 0, r2.mode = 18;
                  case 18:
                    for (; r2.have < r2.ncode; ) {
                      for (; l2 < 3; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.lens[A[r2.have++]] = 7 & u2, u2 >>>= 3, l2 -= 3;
                    }
                    for (; r2.have < 19; )
                      r2.lens[A[r2.have++]] = 0;
                    if (r2.lencode = r2.lendyn, r2.lenbits = 7, S = { bits: r2.lenbits }, x = T(0, r2.lens, 0, 19, r2.lencode, 0, r2.work, S), r2.lenbits = S.bits, x) {
                      e2.msg = "invalid code lengths set", r2.mode = 30;
                      break;
                    }
                    r2.have = 0, r2.mode = 19;
                  case 19:
                    for (; r2.have < r2.nlen + r2.ndist; ) {
                      for (; g = (C = r2.lencode[u2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2); ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      if (b < 16)
                        u2 >>>= _, l2 -= _, r2.lens[r2.have++] = b;
                      else {
                        if (16 === b) {
                          for (z = _ + 2; l2 < z; ) {
                            if (0 === o2)
                              break e;
                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                          }
                          if (u2 >>>= _, l2 -= _, 0 === r2.have) {
                            e2.msg = "invalid bit length repeat", r2.mode = 30;
                            break;
                          }
                          k = r2.lens[r2.have - 1], d = 3 + (3 & u2), u2 >>>= 2, l2 -= 2;
                        } else if (17 === b) {
                          for (z = _ + 3; l2 < z; ) {
                            if (0 === o2)
                              break e;
                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                          }
                          l2 -= _, k = 0, d = 3 + (7 & (u2 >>>= _)), u2 >>>= 3, l2 -= 3;
                        } else {
                          for (z = _ + 7; l2 < z; ) {
                            if (0 === o2)
                              break e;
                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                          }
                          l2 -= _, k = 0, d = 11 + (127 & (u2 >>>= _)), u2 >>>= 7, l2 -= 7;
                        }
                        if (r2.have + d > r2.nlen + r2.ndist) {
                          e2.msg = "invalid bit length repeat", r2.mode = 30;
                          break;
                        }
                        for (; d--; )
                          r2.lens[r2.have++] = k;
                      }
                    }
                    if (30 === r2.mode)
                      break;
                    if (0 === r2.lens[256]) {
                      e2.msg = "invalid code -- missing end-of-block", r2.mode = 30;
                      break;
                    }
                    if (r2.lenbits = 9, S = { bits: r2.lenbits }, x = T(D, r2.lens, 0, r2.nlen, r2.lencode, 0, r2.work, S), r2.lenbits = S.bits, x) {
                      e2.msg = "invalid literal/lengths set", r2.mode = 30;
                      break;
                    }
                    if (r2.distbits = 6, r2.distcode = r2.distdyn, S = { bits: r2.distbits }, x = T(F, r2.lens, r2.nlen, r2.ndist, r2.distcode, 0, r2.work, S), r2.distbits = S.bits, x) {
                      e2.msg = "invalid distances set", r2.mode = 30;
                      break;
                    }
                    if (r2.mode = 20, 6 === t4)
                      break e;
                  case 20:
                    r2.mode = 21;
                  case 21:
                    if (6 <= o2 && 258 <= h2) {
                      e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, R(e2, c2), a2 = e2.next_out, i2 = e2.output, h2 = e2.avail_out, s2 = e2.next_in, n2 = e2.input, o2 = e2.avail_in, u2 = r2.hold, l2 = r2.bits, 12 === r2.mode && (r2.back = -1);
                      break;
                    }
                    for (r2.back = 0; g = (C = r2.lencode[u2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2); ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (g && 0 == (240 & g)) {
                      for (v = _, y = g, w = b; g = (C = r2.lencode[w + ((u2 & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l2); ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      u2 >>>= v, l2 -= v, r2.back += v;
                    }
                    if (u2 >>>= _, l2 -= _, r2.back += _, r2.length = b, 0 === g) {
                      r2.mode = 26;
                      break;
                    }
                    if (32 & g) {
                      r2.back = -1, r2.mode = 12;
                      break;
                    }
                    if (64 & g) {
                      e2.msg = "invalid literal/length code", r2.mode = 30;
                      break;
                    }
                    r2.extra = 15 & g, r2.mode = 22;
                  case 22:
                    if (r2.extra) {
                      for (z = r2.extra; l2 < z; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.length += u2 & (1 << r2.extra) - 1, u2 >>>= r2.extra, l2 -= r2.extra, r2.back += r2.extra;
                    }
                    r2.was = r2.length, r2.mode = 23;
                  case 23:
                    for (; g = (C = r2.distcode[u2 & (1 << r2.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2); ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (0 == (240 & g)) {
                      for (v = _, y = g, w = b; g = (C = r2.distcode[w + ((u2 & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l2); ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      u2 >>>= v, l2 -= v, r2.back += v;
                    }
                    if (u2 >>>= _, l2 -= _, r2.back += _, 64 & g) {
                      e2.msg = "invalid distance code", r2.mode = 30;
                      break;
                    }
                    r2.offset = b, r2.extra = 15 & g, r2.mode = 24;
                  case 24:
                    if (r2.extra) {
                      for (z = r2.extra; l2 < z; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.offset += u2 & (1 << r2.extra) - 1, u2 >>>= r2.extra, l2 -= r2.extra, r2.back += r2.extra;
                    }
                    if (r2.offset > r2.dmax) {
                      e2.msg = "invalid distance too far back", r2.mode = 30;
                      break;
                    }
                    r2.mode = 25;
                  case 25:
                    if (0 === h2)
                      break e;
                    if (d = c2 - h2, r2.offset > d) {
                      if ((d = r2.offset - d) > r2.whave && r2.sane) {
                        e2.msg = "invalid distance too far back", r2.mode = 30;
                        break;
                      }
                      p = d > r2.wnext ? (d -= r2.wnext, r2.wsize - d) : r2.wnext - d, d > r2.length && (d = r2.length), m = r2.window;
                    } else
                      m = i2, p = a2 - r2.offset, d = r2.length;
                    for (h2 < d && (d = h2), h2 -= d, r2.length -= d; i2[a2++] = m[p++], --d; )
                      ;
                    0 === r2.length && (r2.mode = 21);
                    break;
                  case 26:
                    if (0 === h2)
                      break e;
                    i2[a2++] = r2.length, h2--, r2.mode = 21;
                    break;
                  case 27:
                    if (r2.wrap) {
                      for (; l2 < 32; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 |= n2[s2++] << l2, l2 += 8;
                      }
                      if (c2 -= h2, e2.total_out += c2, r2.total += c2, c2 && (e2.adler = r2.check = r2.flags ? B(r2.check, i2, c2, a2 - c2) : O(r2.check, i2, c2, a2 - c2)), c2 = h2, (r2.flags ? u2 : L(u2)) !== r2.check) {
                        e2.msg = "incorrect data check", r2.mode = 30;
                        break;
                      }
                      l2 = u2 = 0;
                    }
                    r2.mode = 28;
                  case 28:
                    if (r2.wrap && r2.flags) {
                      for (; l2 < 32; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      if (u2 !== (4294967295 & r2.total)) {
                        e2.msg = "incorrect length check", r2.mode = 30;
                        break;
                      }
                      l2 = u2 = 0;
                    }
                    r2.mode = 29;
                  case 29:
                    x = 1;
                    break e;
                  case 30:
                    x = -3;
                    break e;
                  case 31:
                    return -4;
                  case 32:
                  default:
                    return U;
                }
            return e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, (r2.wsize || c2 !== e2.avail_out && r2.mode < 30 && (r2.mode < 27 || 4 !== t4)) && Z(e2, e2.output, e2.next_out, c2 - e2.avail_out) ? (r2.mode = 31, -4) : (f2 -= e2.avail_in, c2 -= e2.avail_out, e2.total_in += f2, e2.total_out += c2, r2.total += c2, r2.wrap && c2 && (e2.adler = r2.check = r2.flags ? B(r2.check, i2, c2, e2.next_out - c2) : O(r2.check, i2, c2, e2.next_out - c2)), e2.data_type = r2.bits + (r2.last ? 64 : 0) + (12 === r2.mode ? 128 : 0) + (20 === r2.mode || 15 === r2.mode ? 256 : 0), (0 == f2 && 0 === c2 || 4 === t4) && x === N && (x = -5), x);
          }, r.inflateEnd = function(e2) {
            if (!e2 || !e2.state)
              return U;
            var t4 = e2.state;
            return t4.window && (t4.window = null), e2.state = null, N;
          }, r.inflateGetHeader = function(e2, t4) {
            var r2;
            return e2 && e2.state ? 0 == (2 & (r2 = e2.state).wrap) ? U : ((r2.head = t4).done = false, N) : U;
          }, r.inflateSetDictionary = function(e2, t4) {
            var r2, n2 = t4.length;
            return e2 && e2.state ? 0 !== (r2 = e2.state).wrap && 11 !== r2.mode ? U : 11 === r2.mode && O(1, t4, n2, 0) !== r2.check ? -3 : Z(e2, t4, n2, n2) ? (r2.mode = 31, -4) : (r2.havedict = 1, N) : U;
          }, r.inflateInfo = "pako inflate (from Nodeca project)";
        }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(e, t3, r) {
          "use strict";
          var D = e("../utils/common"), F = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], N = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], U = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], P = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
          t3.exports = function(e2, t4, r2, n, i, s, a, o) {
            var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
            for (b = 0; b <= 15; b++)
              O[b] = 0;
            for (v = 0; v < n; v++)
              O[t4[r2 + v]]++;
            for (k = g, w = 15; 1 <= w && 0 === O[w]; w--)
              ;
            if (w < k && (k = w), 0 === w)
              return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
            for (y = 1; y < w && 0 === O[y]; y++)
              ;
            for (k < y && (k = y), b = z = 1; b <= 15; b++)
              if (z <<= 1, (z -= O[b]) < 0)
                return -1;
            if (0 < z && (0 === e2 || 1 !== w))
              return -1;
            for (B[1] = 0, b = 1; b < 15; b++)
              B[b + 1] = B[b] + O[b];
            for (v = 0; v < n; v++)
              0 !== t4[r2 + v] && (a[B[t4[r2 + v]]++] = v);
            if (d = 0 === e2 ? (A = R = a, 19) : 1 === e2 ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e2 && 852 < C || 2 === e2 && 592 < C)
              return 1;
            for (; ; ) {
              for (p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u; )
                ;
              for (h = 1 << b - 1; E & h; )
                h >>= 1;
              if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                if (b === w)
                  break;
                b = t4[r2 + a[v]];
              }
              if (k < b && (E & f) !== l) {
                for (0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0); )
                  x++, z <<= 1;
                if (C += 1 << x, 1 === e2 && 852 < C || 2 === e2 && 592 < C)
                  return 1;
                i[l = E & f] = k << 24 | x << 16 | c - s | 0;
              }
            }
            return 0 !== E && (i[c + E] = b - S << 24 | 64 << 16 | 0), o.bits = k, 0;
          };
        }, { "../utils/common": 41 }], 51: [function(e, t3, r) {
          "use strict";
          t3.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
        }, {}], 52: [function(e, t3, r) {
          "use strict";
          var i = e("../utils/common"), o = 0, h = 1;
          function n(e2) {
            for (var t4 = e2.length; 0 <= --t4; )
              e2[t4] = 0;
          }
          var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], k = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], x = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], S = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], z = new Array(2 * (l + 2));
          n(z);
          var C = new Array(2 * f);
          n(C);
          var E = new Array(512);
          n(E);
          var A = new Array(256);
          n(A);
          var I = new Array(a);
          n(I);
          var O, B, R, T = new Array(f);
          function D(e2, t4, r2, n2, i2) {
            this.static_tree = e2, this.extra_bits = t4, this.extra_base = r2, this.elems = n2, this.max_length = i2, this.has_stree = e2 && e2.length;
          }
          function F(e2, t4) {
            this.dyn_tree = e2, this.max_code = 0, this.stat_desc = t4;
          }
          function N(e2) {
            return e2 < 256 ? E[e2] : E[256 + (e2 >>> 7)];
          }
          function U(e2, t4) {
            e2.pending_buf[e2.pending++] = 255 & t4, e2.pending_buf[e2.pending++] = t4 >>> 8 & 255;
          }
          function P(e2, t4, r2) {
            e2.bi_valid > d - r2 ? (e2.bi_buf |= t4 << e2.bi_valid & 65535, U(e2, e2.bi_buf), e2.bi_buf = t4 >> d - e2.bi_valid, e2.bi_valid += r2 - d) : (e2.bi_buf |= t4 << e2.bi_valid & 65535, e2.bi_valid += r2);
          }
          function L(e2, t4, r2) {
            P(e2, r2[2 * t4], r2[2 * t4 + 1]);
          }
          function j(e2, t4) {
            for (var r2 = 0; r2 |= 1 & e2, e2 >>>= 1, r2 <<= 1, 0 < --t4; )
              ;
            return r2 >>> 1;
          }
          function Z(e2, t4, r2) {
            var n2, i2, s2 = new Array(g + 1), a2 = 0;
            for (n2 = 1; n2 <= g; n2++)
              s2[n2] = a2 = a2 + r2[n2 - 1] << 1;
            for (i2 = 0; i2 <= t4; i2++) {
              var o2 = e2[2 * i2 + 1];
              0 !== o2 && (e2[2 * i2] = j(s2[o2]++, o2));
            }
          }
          function W(e2) {
            var t4;
            for (t4 = 0; t4 < l; t4++)
              e2.dyn_ltree[2 * t4] = 0;
            for (t4 = 0; t4 < f; t4++)
              e2.dyn_dtree[2 * t4] = 0;
            for (t4 = 0; t4 < c; t4++)
              e2.bl_tree[2 * t4] = 0;
            e2.dyn_ltree[2 * m] = 1, e2.opt_len = e2.static_len = 0, e2.last_lit = e2.matches = 0;
          }
          function M(e2) {
            8 < e2.bi_valid ? U(e2, e2.bi_buf) : 0 < e2.bi_valid && (e2.pending_buf[e2.pending++] = e2.bi_buf), e2.bi_buf = 0, e2.bi_valid = 0;
          }
          function H(e2, t4, r2, n2) {
            var i2 = 2 * t4, s2 = 2 * r2;
            return e2[i2] < e2[s2] || e2[i2] === e2[s2] && n2[t4] <= n2[r2];
          }
          function G(e2, t4, r2) {
            for (var n2 = e2.heap[r2], i2 = r2 << 1; i2 <= e2.heap_len && (i2 < e2.heap_len && H(t4, e2.heap[i2 + 1], e2.heap[i2], e2.depth) && i2++, !H(t4, n2, e2.heap[i2], e2.depth)); )
              e2.heap[r2] = e2.heap[i2], r2 = i2, i2 <<= 1;
            e2.heap[r2] = n2;
          }
          function K(e2, t4, r2) {
            var n2, i2, s2, a2, o2 = 0;
            if (0 !== e2.last_lit)
              for (; n2 = e2.pending_buf[e2.d_buf + 2 * o2] << 8 | e2.pending_buf[e2.d_buf + 2 * o2 + 1], i2 = e2.pending_buf[e2.l_buf + o2], o2++, 0 === n2 ? L(e2, i2, t4) : (L(e2, (s2 = A[i2]) + u + 1, t4), 0 !== (a2 = w[s2]) && P(e2, i2 -= I[s2], a2), L(e2, s2 = N(--n2), r2), 0 !== (a2 = k[s2]) && P(e2, n2 -= T[s2], a2)), o2 < e2.last_lit; )
                ;
            L(e2, m, t4);
          }
          function Y(e2, t4) {
            var r2, n2, i2, s2 = t4.dyn_tree, a2 = t4.stat_desc.static_tree, o2 = t4.stat_desc.has_stree, h2 = t4.stat_desc.elems, u2 = -1;
            for (e2.heap_len = 0, e2.heap_max = _, r2 = 0; r2 < h2; r2++)
              0 !== s2[2 * r2] ? (e2.heap[++e2.heap_len] = u2 = r2, e2.depth[r2] = 0) : s2[2 * r2 + 1] = 0;
            for (; e2.heap_len < 2; )
              s2[2 * (i2 = e2.heap[++e2.heap_len] = u2 < 2 ? ++u2 : 0)] = 1, e2.depth[i2] = 0, e2.opt_len--, o2 && (e2.static_len -= a2[2 * i2 + 1]);
            for (t4.max_code = u2, r2 = e2.heap_len >> 1; 1 <= r2; r2--)
              G(e2, s2, r2);
            for (i2 = h2; r2 = e2.heap[1], e2.heap[1] = e2.heap[e2.heap_len--], G(e2, s2, 1), n2 = e2.heap[1], e2.heap[--e2.heap_max] = r2, e2.heap[--e2.heap_max] = n2, s2[2 * i2] = s2[2 * r2] + s2[2 * n2], e2.depth[i2] = (e2.depth[r2] >= e2.depth[n2] ? e2.depth[r2] : e2.depth[n2]) + 1, s2[2 * r2 + 1] = s2[2 * n2 + 1] = i2, e2.heap[1] = i2++, G(e2, s2, 1), 2 <= e2.heap_len; )
              ;
            e2.heap[--e2.heap_max] = e2.heap[1], function(e3, t5) {
              var r3, n3, i3, s3, a3, o3, h3 = t5.dyn_tree, u3 = t5.max_code, l2 = t5.stat_desc.static_tree, f2 = t5.stat_desc.has_stree, c2 = t5.stat_desc.extra_bits, d2 = t5.stat_desc.extra_base, p2 = t5.stat_desc.max_length, m2 = 0;
              for (s3 = 0; s3 <= g; s3++)
                e3.bl_count[s3] = 0;
              for (h3[2 * e3.heap[e3.heap_max] + 1] = 0, r3 = e3.heap_max + 1; r3 < _; r3++)
                p2 < (s3 = h3[2 * h3[2 * (n3 = e3.heap[r3]) + 1] + 1] + 1) && (s3 = p2, m2++), h3[2 * n3 + 1] = s3, u3 < n3 || (e3.bl_count[s3]++, a3 = 0, d2 <= n3 && (a3 = c2[n3 - d2]), o3 = h3[2 * n3], e3.opt_len += o3 * (s3 + a3), f2 && (e3.static_len += o3 * (l2[2 * n3 + 1] + a3)));
              if (0 !== m2) {
                do {
                  for (s3 = p2 - 1; 0 === e3.bl_count[s3]; )
                    s3--;
                  e3.bl_count[s3]--, e3.bl_count[s3 + 1] += 2, e3.bl_count[p2]--, m2 -= 2;
                } while (0 < m2);
                for (s3 = p2; 0 !== s3; s3--)
                  for (n3 = e3.bl_count[s3]; 0 !== n3; )
                    u3 < (i3 = e3.heap[--r3]) || (h3[2 * i3 + 1] !== s3 && (e3.opt_len += (s3 - h3[2 * i3 + 1]) * h3[2 * i3], h3[2 * i3 + 1] = s3), n3--);
              }
            }(e2, t4), Z(s2, u2, e2.bl_count);
          }
          function X(e2, t4, r2) {
            var n2, i2, s2 = -1, a2 = t4[1], o2 = 0, h2 = 7, u2 = 4;
            for (0 === a2 && (h2 = 138, u2 = 3), t4[2 * (r2 + 1) + 1] = 65535, n2 = 0; n2 <= r2; n2++)
              i2 = a2, a2 = t4[2 * (n2 + 1) + 1], ++o2 < h2 && i2 === a2 || (o2 < u2 ? e2.bl_tree[2 * i2] += o2 : 0 !== i2 ? (i2 !== s2 && e2.bl_tree[2 * i2]++, e2.bl_tree[2 * b]++) : o2 <= 10 ? e2.bl_tree[2 * v]++ : e2.bl_tree[2 * y]++, s2 = i2, u2 = (o2 = 0) === a2 ? (h2 = 138, 3) : i2 === a2 ? (h2 = 6, 3) : (h2 = 7, 4));
          }
          function V(e2, t4, r2) {
            var n2, i2, s2 = -1, a2 = t4[1], o2 = 0, h2 = 7, u2 = 4;
            for (0 === a2 && (h2 = 138, u2 = 3), n2 = 0; n2 <= r2; n2++)
              if (i2 = a2, a2 = t4[2 * (n2 + 1) + 1], !(++o2 < h2 && i2 === a2)) {
                if (o2 < u2)
                  for (; L(e2, i2, e2.bl_tree), 0 != --o2; )
                    ;
                else
                  0 !== i2 ? (i2 !== s2 && (L(e2, i2, e2.bl_tree), o2--), L(e2, b, e2.bl_tree), P(e2, o2 - 3, 2)) : o2 <= 10 ? (L(e2, v, e2.bl_tree), P(e2, o2 - 3, 3)) : (L(e2, y, e2.bl_tree), P(e2, o2 - 11, 7));
                s2 = i2, u2 = (o2 = 0) === a2 ? (h2 = 138, 3) : i2 === a2 ? (h2 = 6, 3) : (h2 = 7, 4);
              }
          }
          n(T);
          var q = false;
          function J(e2, t4, r2, n2) {
            P(e2, (s << 1) + (n2 ? 1 : 0), 3), function(e3, t5, r3, n3) {
              M(e3), n3 && (U(e3, r3), U(e3, ~r3)), i.arraySet(e3.pending_buf, e3.window, t5, r3, e3.pending), e3.pending += r3;
            }(e2, t4, r2, true);
          }
          r._tr_init = function(e2) {
            q || (function() {
              var e3, t4, r2, n2, i2, s2 = new Array(g + 1);
              for (n2 = r2 = 0; n2 < a - 1; n2++)
                for (I[n2] = r2, e3 = 0; e3 < 1 << w[n2]; e3++)
                  A[r2++] = n2;
              for (A[r2 - 1] = n2, n2 = i2 = 0; n2 < 16; n2++)
                for (T[n2] = i2, e3 = 0; e3 < 1 << k[n2]; e3++)
                  E[i2++] = n2;
              for (i2 >>= 7; n2 < f; n2++)
                for (T[n2] = i2 << 7, e3 = 0; e3 < 1 << k[n2] - 7; e3++)
                  E[256 + i2++] = n2;
              for (t4 = 0; t4 <= g; t4++)
                s2[t4] = 0;
              for (e3 = 0; e3 <= 143; )
                z[2 * e3 + 1] = 8, e3++, s2[8]++;
              for (; e3 <= 255; )
                z[2 * e3 + 1] = 9, e3++, s2[9]++;
              for (; e3 <= 279; )
                z[2 * e3 + 1] = 7, e3++, s2[7]++;
              for (; e3 <= 287; )
                z[2 * e3 + 1] = 8, e3++, s2[8]++;
              for (Z(z, l + 1, s2), e3 = 0; e3 < f; e3++)
                C[2 * e3 + 1] = 5, C[2 * e3] = j(e3, 5);
              O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
            }(), q = true), e2.l_desc = new F(e2.dyn_ltree, O), e2.d_desc = new F(e2.dyn_dtree, B), e2.bl_desc = new F(e2.bl_tree, R), e2.bi_buf = 0, e2.bi_valid = 0, W(e2);
          }, r._tr_stored_block = J, r._tr_flush_block = function(e2, t4, r2, n2) {
            var i2, s2, a2 = 0;
            0 < e2.level ? (2 === e2.strm.data_type && (e2.strm.data_type = function(e3) {
              var t5, r3 = 4093624447;
              for (t5 = 0; t5 <= 31; t5++, r3 >>>= 1)
                if (1 & r3 && 0 !== e3.dyn_ltree[2 * t5])
                  return o;
              if (0 !== e3.dyn_ltree[18] || 0 !== e3.dyn_ltree[20] || 0 !== e3.dyn_ltree[26])
                return h;
              for (t5 = 32; t5 < u; t5++)
                if (0 !== e3.dyn_ltree[2 * t5])
                  return h;
              return o;
            }(e2)), Y(e2, e2.l_desc), Y(e2, e2.d_desc), a2 = function(e3) {
              var t5;
              for (X(e3, e3.dyn_ltree, e3.l_desc.max_code), X(e3, e3.dyn_dtree, e3.d_desc.max_code), Y(e3, e3.bl_desc), t5 = c - 1; 3 <= t5 && 0 === e3.bl_tree[2 * S[t5] + 1]; t5--)
                ;
              return e3.opt_len += 3 * (t5 + 1) + 5 + 5 + 4, t5;
            }(e2), i2 = e2.opt_len + 3 + 7 >>> 3, (s2 = e2.static_len + 3 + 7 >>> 3) <= i2 && (i2 = s2)) : i2 = s2 = r2 + 5, r2 + 4 <= i2 && -1 !== t4 ? J(e2, t4, r2, n2) : 4 === e2.strategy || s2 === i2 ? (P(e2, 2 + (n2 ? 1 : 0), 3), K(e2, z, C)) : (P(e2, 4 + (n2 ? 1 : 0), 3), function(e3, t5, r3, n3) {
              var i3;
              for (P(e3, t5 - 257, 5), P(e3, r3 - 1, 5), P(e3, n3 - 4, 4), i3 = 0; i3 < n3; i3++)
                P(e3, e3.bl_tree[2 * S[i3] + 1], 3);
              V(e3, e3.dyn_ltree, t5 - 1), V(e3, e3.dyn_dtree, r3 - 1);
            }(e2, e2.l_desc.max_code + 1, e2.d_desc.max_code + 1, a2 + 1), K(e2, e2.dyn_ltree, e2.dyn_dtree)), W(e2), n2 && M(e2);
          }, r._tr_tally = function(e2, t4, r2) {
            return e2.pending_buf[e2.d_buf + 2 * e2.last_lit] = t4 >>> 8 & 255, e2.pending_buf[e2.d_buf + 2 * e2.last_lit + 1] = 255 & t4, e2.pending_buf[e2.l_buf + e2.last_lit] = 255 & r2, e2.last_lit++, 0 === t4 ? e2.dyn_ltree[2 * r2]++ : (e2.matches++, t4--, e2.dyn_ltree[2 * (A[r2] + u + 1)]++, e2.dyn_dtree[2 * N(t4)]++), e2.last_lit === e2.lit_bufsize - 1;
          }, r._tr_align = function(e2) {
            P(e2, 2, 3), L(e2, m, z), function(e3) {
              16 === e3.bi_valid ? (U(e3, e3.bi_buf), e3.bi_buf = 0, e3.bi_valid = 0) : 8 <= e3.bi_valid && (e3.pending_buf[e3.pending++] = 255 & e3.bi_buf, e3.bi_buf >>= 8, e3.bi_valid -= 8);
            }(e2);
          };
        }, { "../utils/common": 41 }], 53: [function(e, t3, r) {
          "use strict";
          t3.exports = function() {
            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
          };
        }, {}], 54: [function(e, t3, r) {
          (function(e2) {
            !function(r2, n) {
              "use strict";
              if (!r2.setImmediate) {
                var i, s, t4, a, o = 1, h = {}, u = false, l = r2.document, e3 = Object.getPrototypeOf && Object.getPrototypeOf(r2);
                e3 = e3 && e3.setTimeout ? e3 : r2, i = "[object process]" === {}.toString.call(r2.process) ? function(e4) {
                  define_process_default.nextTick(function() {
                    c(e4);
                  });
                } : function() {
                  if (r2.postMessage && !r2.importScripts) {
                    var e4 = true, t5 = r2.onmessage;
                    return r2.onmessage = function() {
                      e4 = false;
                    }, r2.postMessage("", "*"), r2.onmessage = t5, e4;
                  }
                }() ? (a = "setImmediate$" + Math.random() + "$", r2.addEventListener ? r2.addEventListener("message", d, false) : r2.attachEvent("onmessage", d), function(e4) {
                  r2.postMessage(a + e4, "*");
                }) : r2.MessageChannel ? ((t4 = new MessageChannel()).port1.onmessage = function(e4) {
                  c(e4.data);
                }, function(e4) {
                  t4.port2.postMessage(e4);
                }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e4) {
                  var t5 = l.createElement("script");
                  t5.onreadystatechange = function() {
                    c(e4), t5.onreadystatechange = null, s.removeChild(t5), t5 = null;
                  }, s.appendChild(t5);
                }) : function(e4) {
                  setTimeout(c, 0, e4);
                }, e3.setImmediate = function(e4) {
                  "function" != typeof e4 && (e4 = new Function("" + e4));
                  for (var t5 = new Array(arguments.length - 1), r3 = 0; r3 < t5.length; r3++)
                    t5[r3] = arguments[r3 + 1];
                  var n2 = { callback: e4, args: t5 };
                  return h[o] = n2, i(o), o++;
                }, e3.clearImmediate = f;
              }
              function f(e4) {
                delete h[e4];
              }
              function c(e4) {
                if (u)
                  setTimeout(c, 0, e4);
                else {
                  var t5 = h[e4];
                  if (t5) {
                    u = true;
                    try {
                      !function(e5) {
                        var t6 = e5.callback, r3 = e5.args;
                        switch (r3.length) {
                          case 0:
                            t6();
                            break;
                          case 1:
                            t6(r3[0]);
                            break;
                          case 2:
                            t6(r3[0], r3[1]);
                            break;
                          case 3:
                            t6(r3[0], r3[1], r3[2]);
                            break;
                          default:
                            t6.apply(n, r3);
                        }
                      }(t5);
                    } finally {
                      f(e4), u = false;
                    }
                  }
                }
              }
              function d(e4) {
                e4.source === r2 && "string" == typeof e4.data && 0 === e4.data.indexOf(a) && c(+e4.data.slice(a.length));
              }
            }("undefined" == typeof self ? void 0 === e2 ? this : e2 : self);
          }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {}] }, {}, [10])(10);
      });
    }
  });

  // node_modules/@babel/parser/lib/index.js
  var require_lib2 = __commonJS({
    "node_modules/@babel/parser/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", { value: true });
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null)
          return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0)
            continue;
          target[key] = source[key];
        }
        return target;
      }
      var Position = class {
        constructor(line, col, index) {
          this.line = void 0;
          this.column = void 0;
          this.index = void 0;
          this.line = line;
          this.column = col;
          this.index = index;
        }
      };
      var SourceLocation = class {
        constructor(start, end) {
          this.start = void 0;
          this.end = void 0;
          this.filename = void 0;
          this.identifierName = void 0;
          this.start = start;
          this.end = end;
        }
      };
      function createPositionWithColumnOffset(position, columnOffset) {
        const {
          line,
          column,
          index
        } = position;
        return new Position(line, column + columnOffset, index + columnOffset);
      }
      var ParseErrorCode = {
        SyntaxError: "BABEL_PARSER_SYNTAX_ERROR",
        SourceTypeModuleError: "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED"
      };
      var reflect = (keys2, last2 = keys2.length - 1) => ({
        get() {
          return keys2.reduce((object, key) => object[key], this);
        },
        set(value) {
          keys2.reduce(
            (item, key, i) => i === last2 ? item[key] = value : item[key],
            this
          );
        }
      });
      var instantiate = (constructor, properties, descriptors) => Object.keys(descriptors).map((key) => [key, descriptors[key]]).filter(([, descriptor]) => !!descriptor).map(([key, descriptor]) => [key, typeof descriptor === "function" ? {
        value: descriptor,
        enumerable: false
      } : typeof descriptor.reflect === "string" ? Object.assign({}, descriptor, reflect(descriptor.reflect.split("."))) : descriptor]).reduce((instance, [key, descriptor]) => Object.defineProperty(instance, key, Object.assign({
        configurable: true
      }, descriptor)), Object.assign(new constructor(), properties));
      var ModuleErrors = {
        ImportMetaOutsideModule: {
          message: `import.meta may appear only with 'sourceType: "module"'`,
          code: ParseErrorCode.SourceTypeModuleError
        },
        ImportOutsideModule: {
          message: `'import' and 'export' may appear only with 'sourceType: "module"'`,
          code: ParseErrorCode.SourceTypeModuleError
        }
      };
      var NodeDescriptions = {
        ArrayPattern: "array destructuring pattern",
        AssignmentExpression: "assignment expression",
        AssignmentPattern: "assignment expression",
        ArrowFunctionExpression: "arrow function expression",
        ConditionalExpression: "conditional expression",
        CatchClause: "catch clause",
        ForOfStatement: "for-of statement",
        ForInStatement: "for-in statement",
        ForStatement: "for-loop",
        FormalParameters: "function parameter list",
        Identifier: "identifier",
        ImportSpecifier: "import specifier",
        ImportDefaultSpecifier: "import default specifier",
        ImportNamespaceSpecifier: "import namespace specifier",
        ObjectPattern: "object destructuring pattern",
        ParenthesizedExpression: "parenthesized expression",
        RestElement: "rest element",
        UpdateExpression: {
          true: "prefix operation",
          false: "postfix operation"
        },
        VariableDeclarator: "variable declaration",
        YieldExpression: "yield expression"
      };
      var toNodeDescription = ({
        type,
        prefix: prefix2
      }) => type === "UpdateExpression" ? NodeDescriptions.UpdateExpression[String(prefix2)] : NodeDescriptions[type];
      var StandardErrors = {
        AccessorIsGenerator: ({
          kind
        }) => `A ${kind}ter cannot be a generator.`,
        ArgumentsInClass: "'arguments' is only allowed in functions and class methods.",
        AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block.",
        AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function.",
        AwaitBindingIdentifierInStaticBlock: "Can not use 'await' as identifier inside a static block.",
        AwaitExpressionFormalParameter: "'await' is not allowed in async function parameters.",
        AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules.",
        AwaitNotInAsyncFunction: "'await' is only allowed within async functions.",
        BadGetterArity: "A 'get' accesor must not have any formal parameters.",
        BadSetterArity: "A 'set' accesor must have exactly one formal parameter.",
        BadSetterRestParameter: "A 'set' accesor function argument must not be a rest parameter.",
        ConstructorClassField: "Classes may not have a field named 'constructor'.",
        ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'.",
        ConstructorIsAccessor: "Class constructor may not be an accessor.",
        ConstructorIsAsync: "Constructor can't be an async function.",
        ConstructorIsGenerator: "Constructor can't be a generator.",
        DeclarationMissingInitializer: ({
          kind
        }) => `Missing initializer in ${kind} declaration.`,
        DecoratorArgumentsOutsideParentheses: "Decorator arguments must be moved inside parentheses: use '@(decorator(args))' instead of '@(decorator)(args)'.",
        DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. You can set the 'decoratorsBeforeExport' option to false to use the 'export @decorator class {}' syntax.",
        DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?",
        DecoratorExportClass: "Using the export keyword between a decorator and a class is not allowed. Please use `export @dec class` instead.",
        DecoratorSemicolon: "Decorators must not be followed by a semicolon.",
        DecoratorStaticBlock: "Decorators can't be used with a static block.",
        DeletePrivateField: "Deleting a private field is not allowed.",
        DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.",
        DuplicateConstructor: "Duplicate constructor in the same class.",
        DuplicateDefaultExport: "Only one default export allowed per module.",
        DuplicateExport: ({
          exportName
        }) => `\`${exportName}\` has already been exported. Exported identifiers must be unique.`,
        DuplicateProto: "Redefinition of __proto__ property.",
        DuplicateRegExpFlags: "Duplicate regular expression flag.",
        ElementAfterRest: "Rest element must be last element.",
        EscapedCharNotAnIdentifier: "Invalid Unicode escape.",
        ExportBindingIsString: ({
          localName,
          exportName
        }) => `A string literal cannot be used as an exported binding without \`from\`.
- Did you mean \`export { '${localName}' as '${exportName}' } from 'some-module'\`?`,
        ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'.",
        ForInOfLoopInitializer: ({
          type
        }) => `'${type === "ForInStatement" ? "for-in" : "for-of"}' loop variable declaration may not have an initializer.`,
        ForInUsing: "For-in loop may not start with 'using' declaration.",
        ForOfAsync: "The left-hand side of a for-of loop may not be 'async'.",
        ForOfLet: "The left-hand side of a for-of loop may not start with 'let'.",
        GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block.",
        IllegalBreakContinue: ({
          type
        }) => `Unsyntactic ${type === "BreakStatement" ? "break" : "continue"}.`,
        IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list.",
        IllegalReturn: "'return' outside of function.",
        ImportBindingIsString: ({
          importName
        }) => `A string literal cannot be used as an imported binding.
- Did you mean \`import { "${importName}" as foo }\`?`,
        ImportCallArgumentTrailingComma: "Trailing comma is disallowed inside import(...) arguments.",
        ImportCallArity: ({
          maxArgumentCount
        }) => `\`import()\` requires exactly ${maxArgumentCount === 1 ? "one argument" : "one or two arguments"}.`,
        ImportCallNotNewExpression: "Cannot use new with import(...).",
        ImportCallSpreadArgument: "`...` is not allowed in `import()`.",
        ImportJSONBindingNotDefault: "A JSON module can only be imported with `default`.",
        ImportReflectionHasAssertion: "`import module x` cannot have assertions.",
        ImportReflectionNotBinding: 'Only `import module x from "./module"` is valid.',
        IncompatibleRegExpUVFlags: "The 'u' and 'v' regular expression flags cannot be enabled at the same time.",
        InvalidBigIntLiteral: "Invalid BigIntLiteral.",
        InvalidCodePoint: "Code point out of bounds.",
        InvalidCoverInitializedName: "Invalid shorthand property initializer.",
        InvalidDecimal: "Invalid decimal.",
        InvalidDigit: ({
          radix
        }) => `Expected number in radix ${radix}.`,
        InvalidEscapeSequence: "Bad character escape sequence.",
        InvalidEscapeSequenceTemplate: "Invalid escape sequence in template.",
        InvalidEscapedReservedWord: ({
          reservedWord
        }) => `Escape sequence in keyword ${reservedWord}.`,
        InvalidIdentifier: ({
          identifierName
        }) => `Invalid identifier ${identifierName}.`,
        InvalidLhs: ({
          ancestor
        }) => `Invalid left-hand side in ${toNodeDescription(ancestor)}.`,
        InvalidLhsBinding: ({
          ancestor
        }) => `Binding invalid left-hand side in ${toNodeDescription(ancestor)}.`,
        InvalidNumber: "Invalid number.",
        InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'.",
        InvalidOrUnexpectedToken: ({
          unexpected
        }) => `Unexpected character '${unexpected}'.`,
        InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern.",
        InvalidPrivateFieldResolution: ({
          identifierName
        }) => `Private name #${identifierName} is not defined.`,
        InvalidPropertyBindingPattern: "Binding member expression.",
        InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions.",
        InvalidRestAssignmentPattern: "Invalid rest operator's argument.",
        LabelRedeclaration: ({
          labelName
        }) => `Label '${labelName}' is already declared.`,
        LetInLexicalBinding: "'let' is not allowed to be used as a name in 'let' or 'const' declarations.",
        LineTerminatorBeforeArrow: "No line break is allowed before '=>'.",
        MalformedRegExpFlags: "Invalid regular expression flag.",
        MissingClassName: "A class name is required.",
        MissingEqInAssignment: "Only '=' operator can be used for specifying default value.",
        MissingSemicolon: "Missing semicolon.",
        MissingPlugin: ({
          missingPlugin
        }) => `This experimental syntax requires enabling the parser plugin: ${missingPlugin.map((name) => JSON.stringify(name)).join(", ")}.`,
        MissingOneOfPlugins: ({
          missingPlugin
        }) => `This experimental syntax requires enabling one of the following parser plugin(s): ${missingPlugin.map((name) => JSON.stringify(name)).join(", ")}.`,
        MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX.",
        MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators.",
        ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`.",
        ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values.",
        ModuleAttributesWithDuplicateKeys: ({
          key
        }) => `Duplicate key "${key}" is not allowed in module attributes.`,
        ModuleExportNameHasLoneSurrogate: ({
          surrogateCharCode
        }) => `An export name cannot include a lone surrogate, found '\\u${surrogateCharCode.toString(16)}'.`,
        ModuleExportUndefined: ({
          localName
        }) => `Export '${localName}' is not defined.`,
        MultipleDefaultsInSwitch: "Multiple default clauses.",
        NewlineAfterThrow: "Illegal newline after throw.",
        NoCatchOrFinally: "Missing catch or finally clause.",
        NumberIdentifier: "Identifier directly after number.",
        NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences.",
        ObsoleteAwaitStar: "'await*' has been removed from the async functions proposal. Use Promise.all() instead.",
        OptionalChainingNoNew: "Constructors in/after an Optional Chain are not allowed.",
        OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain.",
        OverrideOnConstructor: "'override' modifier cannot appear on a constructor declaration.",
        ParamDupe: "Argument name clash.",
        PatternHasAccessor: "Object pattern can't contain getter or setter.",
        PatternHasMethod: "Object pattern can't contain methods.",
        PrivateInExpectedIn: ({
          identifierName
        }) => `Private names are only allowed in property accesses (\`obj.#${identifierName}\`) or in \`in\` expressions (\`#${identifierName} in obj\`).`,
        PrivateNameRedeclaration: ({
          identifierName
        }) => `Duplicate private name #${identifierName}.`,
        RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.",
        RecordNoProto: "'__proto__' is not allowed in Record expressions.",
        RestTrailingComma: "Unexpected trailing comma after rest element.",
        SloppyFunction: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement.",
        StaticPrototype: "Classes may not have static property named prototype.",
        SuperNotAllowed: "`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?",
        SuperPrivateField: "Private fields can't be accessed on super.",
        TrailingDecorator: "Decorators must be attached to a class element.",
        TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.",
        UnexpectedArgumentPlaceholder: "Unexpected argument placeholder.",
        UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.',
        UnexpectedDigitAfterHash: "Unexpected digit after hash token.",
        UnexpectedImportExport: "'import' and 'export' may only appear at the top level.",
        UnexpectedKeyword: ({
          keyword
        }) => `Unexpected keyword '${keyword}'.`,
        UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration.",
        UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context.",
        UnexpectedNewTarget: "`new.target` can only be used in functions or class properties.",
        UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits.",
        UnexpectedPrivateField: "Unexpected private name.",
        UnexpectedReservedWord: ({
          reservedWord
        }) => `Unexpected reserved word '${reservedWord}'.`,
        UnexpectedSuper: "'super' is only allowed in object methods and classes.",
        UnexpectedToken: ({
          expected,
          unexpected
        }) => `Unexpected token${unexpected ? ` '${unexpected}'.` : ""}${expected ? `, expected "${expected}"` : ""}`,
        UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.",
        UnexpectedUsingDeclaration: "Using declaration cannot appear in the top level when source type is `script`.",
        UnsupportedBind: "Binding should be performed on object property.",
        UnsupportedDecoratorExport: "A decorated export must export a class declaration.",
        UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.",
        UnsupportedImport: "`import` can only be used in `import()` or `import.meta`.",
        UnsupportedMetaProperty: ({
          target,
          onlyValidPropertyName
        }) => `The only valid meta property for ${target} is ${target}.${onlyValidPropertyName}.`,
        UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters.",
        UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties.",
        UnsupportedSuper: "'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop]).",
        UnterminatedComment: "Unterminated comment.",
        UnterminatedRegExp: "Unterminated regular expression.",
        UnterminatedString: "Unterminated string constant.",
        UnterminatedTemplate: "Unterminated template.",
        UsingDeclarationHasBindingPattern: "Using declaration cannot have destructuring patterns.",
        VarRedeclaration: ({
          identifierName
        }) => `Identifier '${identifierName}' has already been declared.`,
        YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator.",
        YieldInParameter: "Yield expression is not allowed in formal parameters.",
        ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0."
      };
      var StrictModeErrors = {
        StrictDelete: "Deleting local variable in strict mode.",
        StrictEvalArguments: ({
          referenceName
        }) => `Assigning to '${referenceName}' in strict mode.`,
        StrictEvalArgumentsBinding: ({
          bindingName
        }) => `Binding '${bindingName}' in strict mode.`,
        StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block.",
        StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'.",
        StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode.",
        StrictWith: "'with' in strict mode."
      };
      var UnparenthesizedPipeBodyDescriptions = /* @__PURE__ */ new Set(["ArrowFunctionExpression", "AssignmentExpression", "ConditionalExpression", "YieldExpression"]);
      var PipelineOperatorErrors = {
        PipeBodyIsTighter: "Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence.",
        PipeTopicRequiresHackPipes: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.',
        PipeTopicUnbound: "Topic reference is unbound; it must be inside a pipe body.",
        PipeTopicUnconfiguredToken: ({
          token
        }) => `Invalid topic token ${token}. In order to use ${token} as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "${token}" }.`,
        PipeTopicUnused: "Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once.",
        PipeUnparenthesizedBody: ({
          type
        }) => `Hack-style pipe body cannot be an unparenthesized ${toNodeDescription({
          type
        })}; please wrap it in parentheses.`,
        PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.',
        PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression.",
        PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression.",
        PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference.",
        PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding.",
        PrimaryTopicRequiresSmartPipeline: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.'
      };
      var _excluded$1 = ["toMessage"];
      var _excluded2$1 = ["message"];
      function toParseErrorConstructor(_ref) {
        let {
          toMessage
        } = _ref, properties = _objectWithoutPropertiesLoose(_ref, _excluded$1);
        return function constructor({
          loc,
          details
        }) {
          return instantiate(SyntaxError, Object.assign({}, properties, {
            loc
          }), {
            clone(overrides = {}) {
              const loc2 = overrides.loc || {};
              return constructor({
                loc: new Position("line" in loc2 ? loc2.line : this.loc.line, "column" in loc2 ? loc2.column : this.loc.column, "index" in loc2 ? loc2.index : this.loc.index),
                details: Object.assign({}, this.details, overrides.details)
              });
            },
            details: {
              value: details,
              enumerable: false
            },
            message: {
              get() {
                return `${toMessage(this.details)} (${this.loc.line}:${this.loc.column})`;
              },
              set(value) {
                Object.defineProperty(this, "message", {
                  value
                });
              }
            },
            pos: {
              reflect: "loc.index",
              enumerable: true
            },
            missingPlugin: "missingPlugin" in details && {
              reflect: "details.missingPlugin",
              enumerable: true
            }
          });
        };
      }
      function ParseErrorEnum(argument, syntaxPlugin) {
        if (Array.isArray(argument)) {
          return (parseErrorTemplates) => ParseErrorEnum(parseErrorTemplates, argument[0]);
        }
        const ParseErrorConstructors = {};
        for (const reasonCode of Object.keys(argument)) {
          const template2 = argument[reasonCode];
          const _ref2 = typeof template2 === "string" ? {
            message: () => template2
          } : typeof template2 === "function" ? {
            message: template2
          } : template2, {
            message
          } = _ref2, rest2 = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
          const toMessage = typeof message === "string" ? () => message : message;
          ParseErrorConstructors[reasonCode] = toParseErrorConstructor(Object.assign({
            code: ParseErrorCode.SyntaxError,
            reasonCode,
            toMessage
          }, syntaxPlugin ? {
            syntaxPlugin
          } : {}, rest2));
        }
        return ParseErrorConstructors;
      }
      var Errors = Object.assign({}, ParseErrorEnum(ModuleErrors), ParseErrorEnum(StandardErrors), ParseErrorEnum(StrictModeErrors), ParseErrorEnum`pipelineOperator`(PipelineOperatorErrors));
      var {
        defineProperty: defineProperty2
      } = Object;
      var toUnenumerable = (object, key) => defineProperty2(object, key, {
        enumerable: false,
        value: object[key]
      });
      function toESTreeLocation(node) {
        node.loc.start && toUnenumerable(node.loc.start, "index");
        node.loc.end && toUnenumerable(node.loc.end, "index");
        return node;
      }
      var estree = (superClass) => class ESTreeParserMixin extends superClass {
        parse() {
          const file2 = toESTreeLocation(super.parse());
          if (this.options.tokens) {
            file2.tokens = file2.tokens.map(toESTreeLocation);
          }
          return file2;
        }
        parseRegExpLiteral({
          pattern,
          flags
        }) {
          let regex = null;
          try {
            regex = new RegExp(pattern, flags);
          } catch (e) {
          }
          const node = this.estreeParseLiteral(regex);
          node.regex = {
            pattern,
            flags
          };
          return node;
        }
        parseBigIntLiteral(value) {
          let bigInt;
          try {
            bigInt = BigInt(value);
          } catch (_unused) {
            bigInt = null;
          }
          const node = this.estreeParseLiteral(bigInt);
          node.bigint = String(node.value || value);
          return node;
        }
        parseDecimalLiteral(value) {
          const decimal = null;
          const node = this.estreeParseLiteral(decimal);
          node.decimal = String(node.value || value);
          return node;
        }
        estreeParseLiteral(value) {
          return this.parseLiteral(value, "Literal");
        }
        parseStringLiteral(value) {
          return this.estreeParseLiteral(value);
        }
        parseNumericLiteral(value) {
          return this.estreeParseLiteral(value);
        }
        parseNullLiteral() {
          return this.estreeParseLiteral(null);
        }
        parseBooleanLiteral(value) {
          return this.estreeParseLiteral(value);
        }
        directiveToStmt(directive) {
          const expression = directive.value;
          delete directive.value;
          expression.type = "Literal";
          expression.raw = expression.extra.raw;
          expression.value = expression.extra.expressionValue;
          const stmt = directive;
          stmt.type = "ExpressionStatement";
          stmt.expression = expression;
          stmt.directive = expression.extra.rawValue;
          delete expression.extra;
          return stmt;
        }
        initFunction(node, isAsync) {
          super.initFunction(node, isAsync);
          node.expression = false;
        }
        checkDeclaration(node) {
          if (node != null && this.isObjectProperty(node)) {
            this.checkDeclaration(node.value);
          } else {
            super.checkDeclaration(node);
          }
        }
        getObjectOrClassMethodParams(method2) {
          return method2.value.params;
        }
        isValidDirective(stmt) {
          var _stmt$expression$extr;
          return stmt.type === "ExpressionStatement" && stmt.expression.type === "Literal" && typeof stmt.expression.value === "string" && !((_stmt$expression$extr = stmt.expression.extra) != null && _stmt$expression$extr.parenthesized);
        }
        parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse) {
          super.parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse);
          const directiveStatements = node.directives.map((d) => this.directiveToStmt(d));
          node.body = directiveStatements.concat(node.body);
          delete node.directives;
        }
        pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
          this.parseMethod(method2, isGenerator, isAsync, isConstructor, allowsDirectSuper, "ClassMethod", true);
          if (method2.typeParameters) {
            method2.value.typeParameters = method2.typeParameters;
            delete method2.typeParameters;
          }
          classBody.body.push(method2);
        }
        parsePrivateName() {
          const node = super.parsePrivateName();
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return node;
            }
          }
          return this.convertPrivateNameToPrivateIdentifier(node);
        }
        convertPrivateNameToPrivateIdentifier(node) {
          const name = super.getPrivateNameSV(node);
          node = node;
          delete node.id;
          node.name = name;
          node.type = "PrivateIdentifier";
          return node;
        }
        isPrivateName(node) {
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return super.isPrivateName(node);
            }
          }
          return node.type === "PrivateIdentifier";
        }
        getPrivateNameSV(node) {
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return super.getPrivateNameSV(node);
            }
          }
          return node.name;
        }
        parseLiteral(value, type) {
          const node = super.parseLiteral(value, type);
          node.raw = node.extra.raw;
          delete node.extra;
          return node;
        }
        parseFunctionBody(node, allowExpression, isMethod = false) {
          super.parseFunctionBody(node, allowExpression, isMethod);
          node.expression = node.body.type !== "BlockStatement";
        }
        parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope = false) {
          let funcNode = this.startNode();
          funcNode.kind = node.kind;
          funcNode = super.parseMethod(
            funcNode,
            isGenerator,
            isAsync,
            isConstructor,
            allowDirectSuper,
            type,
            inClassScope
          );
          funcNode.type = "FunctionExpression";
          delete funcNode.kind;
          node.value = funcNode;
          if (type === "ClassPrivateMethod") {
            node.computed = false;
          }
          return this.finishNode(
            node,
            "MethodDefinition"
          );
        }
        parseClassProperty(...args) {
          const propertyNode = super.parseClassProperty(...args);
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return propertyNode;
            }
          }
          propertyNode.type = "PropertyDefinition";
          return propertyNode;
        }
        parseClassPrivateProperty(...args) {
          const propertyNode = super.parseClassPrivateProperty(...args);
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return propertyNode;
            }
          }
          propertyNode.type = "PropertyDefinition";
          propertyNode.computed = false;
          return propertyNode;
        }
        parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor) {
          const node = super.parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor);
          if (node) {
            node.type = "Property";
            if (node.kind === "method") {
              node.kind = "init";
            }
            node.shorthand = false;
          }
          return node;
        }
        parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors) {
          const node = super.parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors);
          if (node) {
            node.kind = "init";
            node.type = "Property";
          }
          return node;
        }
        isValidLVal(type, isUnparenthesizedInAssign, binding) {
          return type === "Property" ? "value" : super.isValidLVal(type, isUnparenthesizedInAssign, binding);
        }
        isAssignable(node, isBinding) {
          if (node != null && this.isObjectProperty(node)) {
            return this.isAssignable(node.value, isBinding);
          }
          return super.isAssignable(node, isBinding);
        }
        toAssignable(node, isLHS = false) {
          if (node != null && this.isObjectProperty(node)) {
            const {
              key,
              value
            } = node;
            if (this.isPrivateName(key)) {
              this.classScope.usePrivateName(this.getPrivateNameSV(key), key.loc.start);
            }
            this.toAssignable(value, isLHS);
          } else {
            super.toAssignable(node, isLHS);
          }
        }
        toAssignableObjectExpressionProp(prop, isLast, isLHS) {
          if (prop.kind === "get" || prop.kind === "set") {
            this.raise(Errors.PatternHasAccessor, {
              at: prop.key
            });
          } else if (prop.method) {
            this.raise(Errors.PatternHasMethod, {
              at: prop.key
            });
          } else {
            super.toAssignableObjectExpressionProp(prop, isLast, isLHS);
          }
        }
        finishCallExpression(unfinished, optional) {
          const node = super.finishCallExpression(unfinished, optional);
          if (node.callee.type === "Import") {
            node.type = "ImportExpression";
            node.source = node.arguments[0];
            if (this.hasPlugin("importAssertions")) {
              var _node$arguments$;
              node.attributes = (_node$arguments$ = node.arguments[1]) != null ? _node$arguments$ : null;
            }
            delete node.arguments;
            delete node.callee;
          }
          return node;
        }
        toReferencedArguments(node) {
          if (node.type === "ImportExpression") {
            return;
          }
          super.toReferencedArguments(node);
        }
        parseExport(unfinished, decorators) {
          const exportStartLoc = this.state.lastTokStartLoc;
          const node = super.parseExport(unfinished, decorators);
          switch (node.type) {
            case "ExportAllDeclaration":
              node.exported = null;
              break;
            case "ExportNamedDeclaration":
              if (node.specifiers.length === 1 && node.specifiers[0].type === "ExportNamespaceSpecifier") {
                node.type = "ExportAllDeclaration";
                node.exported = node.specifiers[0].exported;
                delete node.specifiers;
              }
            case "ExportDefaultDeclaration":
              {
                var _declaration$decorato;
                const {
                  declaration
                } = node;
                if ((declaration == null ? void 0 : declaration.type) === "ClassDeclaration" && ((_declaration$decorato = declaration.decorators) == null ? void 0 : _declaration$decorato.length) > 0 && declaration.start === node.start) {
                  this.resetStartLocation(
                    node,
                    exportStartLoc
                  );
                }
              }
              break;
          }
          return node;
        }
        parseSubscript(base, startLoc, noCalls, state) {
          const node = super.parseSubscript(base, startLoc, noCalls, state);
          if (state.optionalChainMember) {
            if (node.type === "OptionalMemberExpression" || node.type === "OptionalCallExpression") {
              node.type = node.type.substring(8);
            }
            if (state.stop) {
              const chain2 = this.startNodeAtNode(node);
              chain2.expression = node;
              return this.finishNode(chain2, "ChainExpression");
            }
          } else if (node.type === "MemberExpression" || node.type === "CallExpression") {
            node.optional = false;
          }
          return node;
        }
        hasPropertyAsPrivateName(node) {
          if (node.type === "ChainExpression") {
            node = node.expression;
          }
          return super.hasPropertyAsPrivateName(node);
        }
        isOptionalChain(node) {
          return node.type === "ChainExpression";
        }
        isObjectProperty(node) {
          return node.type === "Property" && node.kind === "init" && !node.method;
        }
        isObjectMethod(node) {
          return node.method || node.kind === "get" || node.kind === "set";
        }
        finishNodeAt(node, type, endLoc) {
          return toESTreeLocation(super.finishNodeAt(node, type, endLoc));
        }
        resetStartLocation(node, startLoc) {
          super.resetStartLocation(node, startLoc);
          toESTreeLocation(node);
        }
        resetEndLocation(node, endLoc = this.state.lastTokEndLoc) {
          super.resetEndLocation(node, endLoc);
          toESTreeLocation(node);
        }
      };
      var TokContext = class {
        constructor(token, preserveSpace) {
          this.token = void 0;
          this.preserveSpace = void 0;
          this.token = token;
          this.preserveSpace = !!preserveSpace;
        }
      };
      var types = {
        brace: new TokContext("{"),
        j_oTag: new TokContext("<tag"),
        j_cTag: new TokContext("</tag"),
        j_expr: new TokContext("<tag>...</tag>", true)
      };
      {
        types.template = new TokContext("`", true);
      }
      var beforeExpr = true;
      var startsExpr = true;
      var isLoop = true;
      var isAssign = true;
      var prefix = true;
      var postfix = true;
      var ExportedTokenType = class {
        constructor(label, conf = {}) {
          this.label = void 0;
          this.keyword = void 0;
          this.beforeExpr = void 0;
          this.startsExpr = void 0;
          this.rightAssociative = void 0;
          this.isLoop = void 0;
          this.isAssign = void 0;
          this.prefix = void 0;
          this.postfix = void 0;
          this.binop = void 0;
          this.label = label;
          this.keyword = conf.keyword;
          this.beforeExpr = !!conf.beforeExpr;
          this.startsExpr = !!conf.startsExpr;
          this.rightAssociative = !!conf.rightAssociative;
          this.isLoop = !!conf.isLoop;
          this.isAssign = !!conf.isAssign;
          this.prefix = !!conf.prefix;
          this.postfix = !!conf.postfix;
          this.binop = conf.binop != null ? conf.binop : null;
          {
            this.updateContext = null;
          }
        }
      };
      var keywords$1 = /* @__PURE__ */ new Map();
      function createKeyword(name, options = {}) {
        options.keyword = name;
        const token = createToken(name, options);
        keywords$1.set(name, token);
        return token;
      }
      function createBinop(name, binop) {
        return createToken(name, {
          beforeExpr,
          binop
        });
      }
      var tokenTypeCounter = -1;
      var tokenTypes = [];
      var tokenLabels = [];
      var tokenBinops = [];
      var tokenBeforeExprs = [];
      var tokenStartsExprs = [];
      var tokenPrefixes = [];
      function createToken(name, options = {}) {
        var _options$binop, _options$beforeExpr, _options$startsExpr, _options$prefix;
        ++tokenTypeCounter;
        tokenLabels.push(name);
        tokenBinops.push((_options$binop = options.binop) != null ? _options$binop : -1);
        tokenBeforeExprs.push((_options$beforeExpr = options.beforeExpr) != null ? _options$beforeExpr : false);
        tokenStartsExprs.push((_options$startsExpr = options.startsExpr) != null ? _options$startsExpr : false);
        tokenPrefixes.push((_options$prefix = options.prefix) != null ? _options$prefix : false);
        tokenTypes.push(new ExportedTokenType(name, options));
        return tokenTypeCounter;
      }
      function createKeywordLike(name, options = {}) {
        var _options$binop2, _options$beforeExpr2, _options$startsExpr2, _options$prefix2;
        ++tokenTypeCounter;
        keywords$1.set(name, tokenTypeCounter);
        tokenLabels.push(name);
        tokenBinops.push((_options$binop2 = options.binop) != null ? _options$binop2 : -1);
        tokenBeforeExprs.push((_options$beforeExpr2 = options.beforeExpr) != null ? _options$beforeExpr2 : false);
        tokenStartsExprs.push((_options$startsExpr2 = options.startsExpr) != null ? _options$startsExpr2 : false);
        tokenPrefixes.push((_options$prefix2 = options.prefix) != null ? _options$prefix2 : false);
        tokenTypes.push(new ExportedTokenType("name", options));
        return tokenTypeCounter;
      }
      var tt = {
        bracketL: createToken("[", {
          beforeExpr,
          startsExpr
        }),
        bracketHashL: createToken("#[", {
          beforeExpr,
          startsExpr
        }),
        bracketBarL: createToken("[|", {
          beforeExpr,
          startsExpr
        }),
        bracketR: createToken("]"),
        bracketBarR: createToken("|]"),
        braceL: createToken("{", {
          beforeExpr,
          startsExpr
        }),
        braceBarL: createToken("{|", {
          beforeExpr,
          startsExpr
        }),
        braceHashL: createToken("#{", {
          beforeExpr,
          startsExpr
        }),
        braceR: createToken("}"),
        braceBarR: createToken("|}"),
        parenL: createToken("(", {
          beforeExpr,
          startsExpr
        }),
        parenR: createToken(")"),
        comma: createToken(",", {
          beforeExpr
        }),
        semi: createToken(";", {
          beforeExpr
        }),
        colon: createToken(":", {
          beforeExpr
        }),
        doubleColon: createToken("::", {
          beforeExpr
        }),
        dot: createToken("."),
        question: createToken("?", {
          beforeExpr
        }),
        questionDot: createToken("?."),
        arrow: createToken("=>", {
          beforeExpr
        }),
        template: createToken("template"),
        ellipsis: createToken("...", {
          beforeExpr
        }),
        backQuote: createToken("`", {
          startsExpr
        }),
        dollarBraceL: createToken("${", {
          beforeExpr,
          startsExpr
        }),
        templateTail: createToken("...`", {
          startsExpr
        }),
        templateNonTail: createToken("...${", {
          beforeExpr,
          startsExpr
        }),
        at: createToken("@"),
        hash: createToken("#", {
          startsExpr
        }),
        interpreterDirective: createToken("#!..."),
        eq: createToken("=", {
          beforeExpr,
          isAssign
        }),
        assign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        slashAssign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        xorAssign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        moduloAssign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        incDec: createToken("++/--", {
          prefix,
          postfix,
          startsExpr
        }),
        bang: createToken("!", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        tilde: createToken("~", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        doubleCaret: createToken("^^", {
          startsExpr
        }),
        doubleAt: createToken("@@", {
          startsExpr
        }),
        pipeline: createBinop("|>", 0),
        nullishCoalescing: createBinop("??", 1),
        logicalOR: createBinop("||", 1),
        logicalAND: createBinop("&&", 2),
        bitwiseOR: createBinop("|", 3),
        bitwiseXOR: createBinop("^", 4),
        bitwiseAND: createBinop("&", 5),
        equality: createBinop("==/!=/===/!==", 6),
        lt: createBinop("</>/<=/>=", 7),
        gt: createBinop("</>/<=/>=", 7),
        relational: createBinop("</>/<=/>=", 7),
        bitShift: createBinop("<</>>/>>>", 8),
        bitShiftL: createBinop("<</>>/>>>", 8),
        bitShiftR: createBinop("<</>>/>>>", 8),
        plusMin: createToken("+/-", {
          beforeExpr,
          binop: 9,
          prefix,
          startsExpr
        }),
        modulo: createToken("%", {
          binop: 10,
          startsExpr
        }),
        star: createToken("*", {
          binop: 10
        }),
        slash: createBinop("/", 10),
        exponent: createToken("**", {
          beforeExpr,
          binop: 11,
          rightAssociative: true
        }),
        _in: createKeyword("in", {
          beforeExpr,
          binop: 7
        }),
        _instanceof: createKeyword("instanceof", {
          beforeExpr,
          binop: 7
        }),
        _break: createKeyword("break"),
        _case: createKeyword("case", {
          beforeExpr
        }),
        _catch: createKeyword("catch"),
        _continue: createKeyword("continue"),
        _debugger: createKeyword("debugger"),
        _default: createKeyword("default", {
          beforeExpr
        }),
        _else: createKeyword("else", {
          beforeExpr
        }),
        _finally: createKeyword("finally"),
        _function: createKeyword("function", {
          startsExpr
        }),
        _if: createKeyword("if"),
        _return: createKeyword("return", {
          beforeExpr
        }),
        _switch: createKeyword("switch"),
        _throw: createKeyword("throw", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _try: createKeyword("try"),
        _var: createKeyword("var"),
        _const: createKeyword("const"),
        _with: createKeyword("with"),
        _new: createKeyword("new", {
          beforeExpr,
          startsExpr
        }),
        _this: createKeyword("this", {
          startsExpr
        }),
        _super: createKeyword("super", {
          startsExpr
        }),
        _class: createKeyword("class", {
          startsExpr
        }),
        _extends: createKeyword("extends", {
          beforeExpr
        }),
        _export: createKeyword("export"),
        _import: createKeyword("import", {
          startsExpr
        }),
        _null: createKeyword("null", {
          startsExpr
        }),
        _true: createKeyword("true", {
          startsExpr
        }),
        _false: createKeyword("false", {
          startsExpr
        }),
        _typeof: createKeyword("typeof", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _void: createKeyword("void", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _delete: createKeyword("delete", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _do: createKeyword("do", {
          isLoop,
          beforeExpr
        }),
        _for: createKeyword("for", {
          isLoop
        }),
        _while: createKeyword("while", {
          isLoop
        }),
        _as: createKeywordLike("as", {
          startsExpr
        }),
        _assert: createKeywordLike("assert", {
          startsExpr
        }),
        _async: createKeywordLike("async", {
          startsExpr
        }),
        _await: createKeywordLike("await", {
          startsExpr
        }),
        _from: createKeywordLike("from", {
          startsExpr
        }),
        _get: createKeywordLike("get", {
          startsExpr
        }),
        _let: createKeywordLike("let", {
          startsExpr
        }),
        _meta: createKeywordLike("meta", {
          startsExpr
        }),
        _of: createKeywordLike("of", {
          startsExpr
        }),
        _sent: createKeywordLike("sent", {
          startsExpr
        }),
        _set: createKeywordLike("set", {
          startsExpr
        }),
        _static: createKeywordLike("static", {
          startsExpr
        }),
        _using: createKeywordLike("using", {
          startsExpr
        }),
        _yield: createKeywordLike("yield", {
          startsExpr
        }),
        _asserts: createKeywordLike("asserts", {
          startsExpr
        }),
        _checks: createKeywordLike("checks", {
          startsExpr
        }),
        _exports: createKeywordLike("exports", {
          startsExpr
        }),
        _global: createKeywordLike("global", {
          startsExpr
        }),
        _implements: createKeywordLike("implements", {
          startsExpr
        }),
        _intrinsic: createKeywordLike("intrinsic", {
          startsExpr
        }),
        _infer: createKeywordLike("infer", {
          startsExpr
        }),
        _is: createKeywordLike("is", {
          startsExpr
        }),
        _mixins: createKeywordLike("mixins", {
          startsExpr
        }),
        _proto: createKeywordLike("proto", {
          startsExpr
        }),
        _require: createKeywordLike("require", {
          startsExpr
        }),
        _satisfies: createKeywordLike("satisfies", {
          startsExpr
        }),
        _keyof: createKeywordLike("keyof", {
          startsExpr
        }),
        _readonly: createKeywordLike("readonly", {
          startsExpr
        }),
        _unique: createKeywordLike("unique", {
          startsExpr
        }),
        _abstract: createKeywordLike("abstract", {
          startsExpr
        }),
        _declare: createKeywordLike("declare", {
          startsExpr
        }),
        _enum: createKeywordLike("enum", {
          startsExpr
        }),
        _module: createKeywordLike("module", {
          startsExpr
        }),
        _namespace: createKeywordLike("namespace", {
          startsExpr
        }),
        _interface: createKeywordLike("interface", {
          startsExpr
        }),
        _type: createKeywordLike("type", {
          startsExpr
        }),
        _opaque: createKeywordLike("opaque", {
          startsExpr
        }),
        name: createToken("name", {
          startsExpr
        }),
        string: createToken("string", {
          startsExpr
        }),
        num: createToken("num", {
          startsExpr
        }),
        bigint: createToken("bigint", {
          startsExpr
        }),
        decimal: createToken("decimal", {
          startsExpr
        }),
        regexp: createToken("regexp", {
          startsExpr
        }),
        privateName: createToken("#name", {
          startsExpr
        }),
        eof: createToken("eof"),
        jsxName: createToken("jsxName"),
        jsxText: createToken("jsxText", {
          beforeExpr: true
        }),
        jsxTagStart: createToken("jsxTagStart", {
          startsExpr: true
        }),
        jsxTagEnd: createToken("jsxTagEnd"),
        placeholder: createToken("%%", {
          startsExpr: true
        })
      };
      function tokenIsIdentifier(token) {
        return token >= 93 && token <= 130;
      }
      function tokenKeywordOrIdentifierIsKeyword(token) {
        return token <= 92;
      }
      function tokenIsKeywordOrIdentifier(token) {
        return token >= 58 && token <= 130;
      }
      function tokenIsLiteralPropertyName(token) {
        return token >= 58 && token <= 134;
      }
      function tokenComesBeforeExpression(token) {
        return tokenBeforeExprs[token];
      }
      function tokenCanStartExpression(token) {
        return tokenStartsExprs[token];
      }
      function tokenIsAssignment(token) {
        return token >= 29 && token <= 33;
      }
      function tokenIsFlowInterfaceOrTypeOrOpaque(token) {
        return token >= 127 && token <= 129;
      }
      function tokenIsLoop(token) {
        return token >= 90 && token <= 92;
      }
      function tokenIsKeyword(token) {
        return token >= 58 && token <= 92;
      }
      function tokenIsOperator(token) {
        return token >= 39 && token <= 59;
      }
      function tokenIsPostfix(token) {
        return token === 34;
      }
      function tokenIsPrefix(token) {
        return tokenPrefixes[token];
      }
      function tokenIsTSTypeOperator(token) {
        return token >= 119 && token <= 121;
      }
      function tokenIsTSDeclarationStart(token) {
        return token >= 122 && token <= 128;
      }
      function tokenLabelName(token) {
        return tokenLabels[token];
      }
      function tokenOperatorPrecedence(token) {
        return tokenBinops[token];
      }
      function tokenIsRightAssociative(token) {
        return token === 57;
      }
      function tokenIsTemplate(token) {
        return token >= 24 && token <= 25;
      }
      function getExportedToken(token) {
        return tokenTypes[token];
      }
      {
        tokenTypes[8].updateContext = (context) => {
          context.pop();
        };
        tokenTypes[5].updateContext = tokenTypes[7].updateContext = tokenTypes[23].updateContext = (context) => {
          context.push(types.brace);
        };
        tokenTypes[22].updateContext = (context) => {
          if (context[context.length - 1] === types.template) {
            context.pop();
          } else {
            context.push(types.template);
          }
        };
        tokenTypes[140].updateContext = (context) => {
          context.push(types.j_expr, types.j_oTag);
        };
      }
      var nonASCIIidentifierStartChars = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
      var nonASCIIidentifierChars = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F";
      var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
      var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
      nonASCIIidentifierStartChars = nonASCIIidentifierChars = null;
      var astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938, 6, 4191];
      var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
      function isInAstralSet(code, set2) {
        let pos = 65536;
        for (let i = 0, length = set2.length; i < length; i += 2) {
          pos += set2[i];
          if (pos > code)
            return false;
          pos += set2[i + 1];
          if (pos >= code)
            return true;
        }
        return false;
      }
      function isIdentifierStart(code) {
        if (code < 65)
          return code === 36;
        if (code <= 90)
          return true;
        if (code < 97)
          return code === 95;
        if (code <= 122)
          return true;
        if (code <= 65535) {
          return code >= 170 && nonASCIIidentifierStart.test(String.fromCharCode(code));
        }
        return isInAstralSet(code, astralIdentifierStartCodes);
      }
      function isIdentifierChar(code) {
        if (code < 48)
          return code === 36;
        if (code < 58)
          return true;
        if (code < 65)
          return false;
        if (code <= 90)
          return true;
        if (code < 97)
          return code === 95;
        if (code <= 122)
          return true;
        if (code <= 65535) {
          return code >= 170 && nonASCIIidentifier.test(String.fromCharCode(code));
        }
        return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes);
      }
      var reservedWords = {
        keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"],
        strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"],
        strictBind: ["eval", "arguments"]
      };
      var keywords = new Set(reservedWords.keyword);
      var reservedWordsStrictSet = new Set(reservedWords.strict);
      var reservedWordsStrictBindSet = new Set(reservedWords.strictBind);
      function isReservedWord(word, inModule) {
        return inModule && word === "await" || word === "enum";
      }
      function isStrictReservedWord(word, inModule) {
        return isReservedWord(word, inModule) || reservedWordsStrictSet.has(word);
      }
      function isStrictBindOnlyReservedWord(word) {
        return reservedWordsStrictBindSet.has(word);
      }
      function isStrictBindReservedWord(word, inModule) {
        return isStrictReservedWord(word, inModule) || isStrictBindOnlyReservedWord(word);
      }
      function isKeyword(word) {
        return keywords.has(word);
      }
      function isIteratorStart(current, next, next2) {
        return current === 64 && next === 64 && isIdentifierStart(next2);
      }
      var reservedWordLikeSet = /* @__PURE__ */ new Set([
        "break",
        "case",
        "catch",
        "continue",
        "debugger",
        "default",
        "do",
        "else",
        "finally",
        "for",
        "function",
        "if",
        "return",
        "switch",
        "throw",
        "try",
        "var",
        "const",
        "while",
        "with",
        "new",
        "this",
        "super",
        "class",
        "extends",
        "export",
        "import",
        "null",
        "true",
        "false",
        "in",
        "instanceof",
        "typeof",
        "void",
        "delete",
        "implements",
        "interface",
        "let",
        "package",
        "private",
        "protected",
        "public",
        "static",
        "yield",
        "eval",
        "arguments",
        "enum",
        "await"
      ]);
      function canBeReservedWord(word) {
        return reservedWordLikeSet.has(word);
      }
      var SCOPE_OTHER = 0;
      var SCOPE_PROGRAM = 1;
      var SCOPE_FUNCTION = 2;
      var SCOPE_ARROW = 4;
      var SCOPE_SIMPLE_CATCH = 8;
      var SCOPE_SUPER = 16;
      var SCOPE_DIRECT_SUPER = 32;
      var SCOPE_CLASS = 64;
      var SCOPE_STATIC_BLOCK = 128;
      var SCOPE_TS_MODULE = 256;
      var SCOPE_VAR = SCOPE_PROGRAM | SCOPE_FUNCTION | SCOPE_STATIC_BLOCK | SCOPE_TS_MODULE;
      var BIND_KIND_VALUE = 1;
      var BIND_KIND_TYPE = 2;
      var BIND_SCOPE_VAR = 4;
      var BIND_SCOPE_LEXICAL = 8;
      var BIND_SCOPE_FUNCTION = 16;
      var BIND_FLAGS_NONE = 64;
      var BIND_FLAGS_CLASS = 128;
      var BIND_FLAGS_TS_ENUM = 256;
      var BIND_FLAGS_TS_CONST_ENUM = 512;
      var BIND_FLAGS_TS_EXPORT_ONLY = 1024;
      var BIND_FLAGS_FLOW_DECLARE_FN = 2048;
      var BIND_FLAGS_TS_IMPORT = 4096;
      var BIND_CLASS = BIND_KIND_VALUE | BIND_KIND_TYPE | BIND_SCOPE_LEXICAL | BIND_FLAGS_CLASS;
      var BIND_LEXICAL = BIND_KIND_VALUE | 0 | BIND_SCOPE_LEXICAL | 0;
      var BIND_VAR = BIND_KIND_VALUE | 0 | BIND_SCOPE_VAR | 0;
      var BIND_FUNCTION = BIND_KIND_VALUE | 0 | BIND_SCOPE_FUNCTION | 0;
      var BIND_TS_INTERFACE = 0 | BIND_KIND_TYPE | 0 | BIND_FLAGS_CLASS;
      var BIND_TS_TYPE = 0 | BIND_KIND_TYPE | 0 | 0;
      var BIND_TS_ENUM = BIND_KIND_VALUE | BIND_KIND_TYPE | BIND_SCOPE_LEXICAL | BIND_FLAGS_TS_ENUM;
      var BIND_TS_AMBIENT = 0 | 0 | 0 | BIND_FLAGS_TS_EXPORT_ONLY;
      var BIND_NONE = 0 | 0 | 0 | BIND_FLAGS_NONE;
      var BIND_OUTSIDE = BIND_KIND_VALUE | 0 | 0 | BIND_FLAGS_NONE;
      var BIND_TS_CONST_ENUM = BIND_TS_ENUM | BIND_FLAGS_TS_CONST_ENUM;
      var BIND_TS_NAMESPACE = 0 | 0 | 0 | BIND_FLAGS_TS_EXPORT_ONLY;
      var BIND_TS_TYPE_IMPORT = 0 | BIND_KIND_TYPE | 0 | BIND_FLAGS_TS_IMPORT;
      var BIND_FLOW_DECLARE_FN = BIND_FLAGS_FLOW_DECLARE_FN;
      var CLASS_ELEMENT_FLAG_STATIC = 4;
      var CLASS_ELEMENT_KIND_GETTER = 2;
      var CLASS_ELEMENT_KIND_SETTER = 1;
      var CLASS_ELEMENT_KIND_ACCESSOR = CLASS_ELEMENT_KIND_GETTER | CLASS_ELEMENT_KIND_SETTER;
      var CLASS_ELEMENT_STATIC_GETTER = CLASS_ELEMENT_KIND_GETTER | CLASS_ELEMENT_FLAG_STATIC;
      var CLASS_ELEMENT_STATIC_SETTER = CLASS_ELEMENT_KIND_SETTER | CLASS_ELEMENT_FLAG_STATIC;
      var CLASS_ELEMENT_INSTANCE_GETTER = CLASS_ELEMENT_KIND_GETTER;
      var CLASS_ELEMENT_INSTANCE_SETTER = CLASS_ELEMENT_KIND_SETTER;
      var CLASS_ELEMENT_OTHER = 0;
      var Scope2 = class {
        constructor(flags) {
          this.var = /* @__PURE__ */ new Set();
          this.lexical = /* @__PURE__ */ new Set();
          this.functions = /* @__PURE__ */ new Set();
          this.flags = flags;
        }
      };
      var ScopeHandler = class {
        constructor(parser3, inModule) {
          this.parser = void 0;
          this.scopeStack = [];
          this.inModule = void 0;
          this.undefinedExports = /* @__PURE__ */ new Map();
          this.parser = parser3;
          this.inModule = inModule;
        }
        get inTopLevel() {
          return (this.currentScope().flags & SCOPE_PROGRAM) > 0;
        }
        get inFunction() {
          return (this.currentVarScopeFlags() & SCOPE_FUNCTION) > 0;
        }
        get allowSuper() {
          return (this.currentThisScopeFlags() & SCOPE_SUPER) > 0;
        }
        get allowDirectSuper() {
          return (this.currentThisScopeFlags() & SCOPE_DIRECT_SUPER) > 0;
        }
        get inClass() {
          return (this.currentThisScopeFlags() & SCOPE_CLASS) > 0;
        }
        get inClassAndNotInNonArrowFunction() {
          const flags = this.currentThisScopeFlags();
          return (flags & SCOPE_CLASS) > 0 && (flags & SCOPE_FUNCTION) === 0;
        }
        get inStaticBlock() {
          for (let i = this.scopeStack.length - 1; ; i--) {
            const {
              flags
            } = this.scopeStack[i];
            if (flags & SCOPE_STATIC_BLOCK) {
              return true;
            }
            if (flags & (SCOPE_VAR | SCOPE_CLASS)) {
              return false;
            }
          }
        }
        get inNonArrowFunction() {
          return (this.currentThisScopeFlags() & SCOPE_FUNCTION) > 0;
        }
        get treatFunctionsAsVar() {
          return this.treatFunctionsAsVarInScope(this.currentScope());
        }
        createScope(flags) {
          return new Scope2(flags);
        }
        enter(flags) {
          this.scopeStack.push(this.createScope(flags));
        }
        exit() {
          const scope = this.scopeStack.pop();
          return scope.flags;
        }
        treatFunctionsAsVarInScope(scope) {
          return !!(scope.flags & (SCOPE_FUNCTION | SCOPE_STATIC_BLOCK) || !this.parser.inModule && scope.flags & SCOPE_PROGRAM);
        }
        declareName(name, bindingType, loc) {
          let scope = this.currentScope();
          if (bindingType & BIND_SCOPE_LEXICAL || bindingType & BIND_SCOPE_FUNCTION) {
            this.checkRedeclarationInScope(scope, name, bindingType, loc);
            if (bindingType & BIND_SCOPE_FUNCTION) {
              scope.functions.add(name);
            } else {
              scope.lexical.add(name);
            }
            if (bindingType & BIND_SCOPE_LEXICAL) {
              this.maybeExportDefined(scope, name);
            }
          } else if (bindingType & BIND_SCOPE_VAR) {
            for (let i = this.scopeStack.length - 1; i >= 0; --i) {
              scope = this.scopeStack[i];
              this.checkRedeclarationInScope(scope, name, bindingType, loc);
              scope.var.add(name);
              this.maybeExportDefined(scope, name);
              if (scope.flags & SCOPE_VAR)
                break;
            }
          }
          if (this.parser.inModule && scope.flags & SCOPE_PROGRAM) {
            this.undefinedExports.delete(name);
          }
        }
        maybeExportDefined(scope, name) {
          if (this.parser.inModule && scope.flags & SCOPE_PROGRAM) {
            this.undefinedExports.delete(name);
          }
        }
        checkRedeclarationInScope(scope, name, bindingType, loc) {
          if (this.isRedeclaredInScope(scope, name, bindingType)) {
            this.parser.raise(Errors.VarRedeclaration, {
              at: loc,
              identifierName: name
            });
          }
        }
        isRedeclaredInScope(scope, name, bindingType) {
          if (!(bindingType & BIND_KIND_VALUE))
            return false;
          if (bindingType & BIND_SCOPE_LEXICAL) {
            return scope.lexical.has(name) || scope.functions.has(name) || scope.var.has(name);
          }
          if (bindingType & BIND_SCOPE_FUNCTION) {
            return scope.lexical.has(name) || !this.treatFunctionsAsVarInScope(scope) && scope.var.has(name);
          }
          return scope.lexical.has(name) && !(scope.flags & SCOPE_SIMPLE_CATCH && scope.lexical.values().next().value === name) || !this.treatFunctionsAsVarInScope(scope) && scope.functions.has(name);
        }
        checkLocalExport(id) {
          const {
            name
          } = id;
          const topLevelScope = this.scopeStack[0];
          if (!topLevelScope.lexical.has(name) && !topLevelScope.var.has(name) && !topLevelScope.functions.has(name)) {
            this.undefinedExports.set(name, id.loc.start);
          }
        }
        currentScope() {
          return this.scopeStack[this.scopeStack.length - 1];
        }
        currentVarScopeFlags() {
          for (let i = this.scopeStack.length - 1; ; i--) {
            const {
              flags
            } = this.scopeStack[i];
            if (flags & SCOPE_VAR) {
              return flags;
            }
          }
        }
        currentThisScopeFlags() {
          for (let i = this.scopeStack.length - 1; ; i--) {
            const {
              flags
            } = this.scopeStack[i];
            if (flags & (SCOPE_VAR | SCOPE_CLASS) && !(flags & SCOPE_ARROW)) {
              return flags;
            }
          }
        }
      };
      var FlowScope = class extends Scope2 {
        constructor(...args) {
          super(...args);
          this.declareFunctions = /* @__PURE__ */ new Set();
        }
      };
      var FlowScopeHandler = class extends ScopeHandler {
        createScope(flags) {
          return new FlowScope(flags);
        }
        declareName(name, bindingType, loc) {
          const scope = this.currentScope();
          if (bindingType & BIND_FLAGS_FLOW_DECLARE_FN) {
            this.checkRedeclarationInScope(scope, name, bindingType, loc);
            this.maybeExportDefined(scope, name);
            scope.declareFunctions.add(name);
            return;
          }
          super.declareName(name, bindingType, loc);
        }
        isRedeclaredInScope(scope, name, bindingType) {
          if (super.isRedeclaredInScope(scope, name, bindingType))
            return true;
          if (bindingType & BIND_FLAGS_FLOW_DECLARE_FN) {
            return !scope.declareFunctions.has(name) && (scope.lexical.has(name) || scope.functions.has(name));
          }
          return false;
        }
        checkLocalExport(id) {
          if (!this.scopeStack[0].declareFunctions.has(id.name)) {
            super.checkLocalExport(id);
          }
        }
      };
      var BaseParser = class {
        constructor() {
          this.sawUnambiguousESM = false;
          this.ambiguousScriptDifferentAst = false;
        }
        hasPlugin(pluginConfig) {
          if (typeof pluginConfig === "string") {
            return this.plugins.has(pluginConfig);
          } else {
            const [pluginName, pluginOptions] = pluginConfig;
            if (!this.hasPlugin(pluginName)) {
              return false;
            }
            const actualOptions = this.plugins.get(pluginName);
            for (const key of Object.keys(pluginOptions)) {
              if ((actualOptions == null ? void 0 : actualOptions[key]) !== pluginOptions[key]) {
                return false;
              }
            }
            return true;
          }
        }
        getPluginOption(plugin, name) {
          var _this$plugins$get;
          return (_this$plugins$get = this.plugins.get(plugin)) == null ? void 0 : _this$plugins$get[name];
        }
      };
      function setTrailingComments(node, comments) {
        if (node.trailingComments === void 0) {
          node.trailingComments = comments;
        } else {
          node.trailingComments.unshift(...comments);
        }
      }
      function setLeadingComments(node, comments) {
        if (node.leadingComments === void 0) {
          node.leadingComments = comments;
        } else {
          node.leadingComments.unshift(...comments);
        }
      }
      function setInnerComments(node, comments) {
        if (node.innerComments === void 0) {
          node.innerComments = comments;
        } else {
          node.innerComments.unshift(...comments);
        }
      }
      function adjustInnerComments(node, elements, commentWS) {
        let lastElement = null;
        let i = elements.length;
        while (lastElement === null && i > 0) {
          lastElement = elements[--i];
        }
        if (lastElement === null || lastElement.start > commentWS.start) {
          setInnerComments(node, commentWS.comments);
        } else {
          setTrailingComments(lastElement, commentWS.comments);
        }
      }
      var CommentsParser = class extends BaseParser {
        addComment(comment) {
          if (this.filename)
            comment.loc.filename = this.filename;
          this.state.comments.push(comment);
        }
        processComment(node) {
          const {
            commentStack
          } = this.state;
          const commentStackLength = commentStack.length;
          if (commentStackLength === 0)
            return;
          let i = commentStackLength - 1;
          const lastCommentWS = commentStack[i];
          if (lastCommentWS.start === node.end) {
            lastCommentWS.leadingNode = node;
            i--;
          }
          const {
            start: nodeStart
          } = node;
          for (; i >= 0; i--) {
            const commentWS = commentStack[i];
            const commentEnd = commentWS.end;
            if (commentEnd > nodeStart) {
              commentWS.containingNode = node;
              this.finalizeComment(commentWS);
              commentStack.splice(i, 1);
            } else {
              if (commentEnd === nodeStart) {
                commentWS.trailingNode = node;
              }
              break;
            }
          }
        }
        finalizeComment(commentWS) {
          const {
            comments
          } = commentWS;
          if (commentWS.leadingNode !== null || commentWS.trailingNode !== null) {
            if (commentWS.leadingNode !== null) {
              setTrailingComments(commentWS.leadingNode, comments);
            }
            if (commentWS.trailingNode !== null) {
              setLeadingComments(commentWS.trailingNode, comments);
            }
          } else {
            const {
              containingNode: node,
              start: commentStart
            } = commentWS;
            if (this.input.charCodeAt(commentStart - 1) === 44) {
              switch (node.type) {
                case "ObjectExpression":
                case "ObjectPattern":
                case "RecordExpression":
                  adjustInnerComments(node, node.properties, commentWS);
                  break;
                case "CallExpression":
                case "OptionalCallExpression":
                  adjustInnerComments(node, node.arguments, commentWS);
                  break;
                case "FunctionDeclaration":
                case "FunctionExpression":
                case "ArrowFunctionExpression":
                case "ObjectMethod":
                case "ClassMethod":
                case "ClassPrivateMethod":
                  adjustInnerComments(node, node.params, commentWS);
                  break;
                case "ArrayExpression":
                case "ArrayPattern":
                case "TupleExpression":
                  adjustInnerComments(node, node.elements, commentWS);
                  break;
                case "ExportNamedDeclaration":
                case "ImportDeclaration":
                  adjustInnerComments(node, node.specifiers, commentWS);
                  break;
                default: {
                  setInnerComments(node, comments);
                }
              }
            } else {
              setInnerComments(node, comments);
            }
          }
        }
        finalizeRemainingComments() {
          const {
            commentStack
          } = this.state;
          for (let i = commentStack.length - 1; i >= 0; i--) {
            this.finalizeComment(commentStack[i]);
          }
          this.state.commentStack = [];
        }
        resetPreviousNodeTrailingComments(node) {
          const {
            commentStack
          } = this.state;
          const {
            length
          } = commentStack;
          if (length === 0)
            return;
          const commentWS = commentStack[length - 1];
          if (commentWS.leadingNode === node) {
            commentWS.leadingNode = null;
          }
        }
        takeSurroundingComments(node, start, end) {
          const {
            commentStack
          } = this.state;
          const commentStackLength = commentStack.length;
          if (commentStackLength === 0)
            return;
          let i = commentStackLength - 1;
          for (; i >= 0; i--) {
            const commentWS = commentStack[i];
            const commentEnd = commentWS.end;
            const commentStart = commentWS.start;
            if (commentStart === end) {
              commentWS.leadingNode = node;
            } else if (commentEnd === start) {
              commentWS.trailingNode = node;
            } else if (commentEnd < start) {
              break;
            }
          }
        }
      };
      var lineBreak = /\r\n?|[\n\u2028\u2029]/;
      var lineBreakG = new RegExp(lineBreak.source, "g");
      function isNewLine(code) {
        switch (code) {
          case 10:
          case 13:
          case 8232:
          case 8233:
            return true;
          default:
            return false;
        }
      }
      var skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
      var skipWhiteSpaceInLine = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/y;
      var skipWhiteSpaceToLineBreak = new RegExp(
        "(?=(" + skipWhiteSpaceInLine.source + "))\\1" + /(?=[\n\r\u2028\u2029]|\/\*(?!.*?\*\/)|$)/.source,
        "y"
      );
      function isWhitespace(code) {
        switch (code) {
          case 9:
          case 11:
          case 12:
          case 32:
          case 160:
          case 5760:
          case 8192:
          case 8193:
          case 8194:
          case 8195:
          case 8196:
          case 8197:
          case 8198:
          case 8199:
          case 8200:
          case 8201:
          case 8202:
          case 8239:
          case 8287:
          case 12288:
          case 65279:
            return true;
          default:
            return false;
        }
      }
      var State = class {
        constructor() {
          this.strict = void 0;
          this.curLine = void 0;
          this.lineStart = void 0;
          this.startLoc = void 0;
          this.endLoc = void 0;
          this.errors = [];
          this.potentialArrowAt = -1;
          this.noArrowAt = [];
          this.noArrowParamsConversionAt = [];
          this.maybeInArrowParameters = false;
          this.inType = false;
          this.noAnonFunctionType = false;
          this.hasFlowComment = false;
          this.isAmbientContext = false;
          this.inAbstractClass = false;
          this.inDisallowConditionalTypesContext = false;
          this.topicContext = {
            maxNumOfResolvableTopics: 0,
            maxTopicIndex: null
          };
          this.soloAwait = false;
          this.inFSharpPipelineDirectBody = false;
          this.labels = [];
          this.comments = [];
          this.commentStack = [];
          this.pos = 0;
          this.type = 137;
          this.value = null;
          this.start = 0;
          this.end = 0;
          this.lastTokEndLoc = null;
          this.lastTokStartLoc = null;
          this.lastTokStart = 0;
          this.context = [types.brace];
          this.canStartJSXElement = true;
          this.containsEsc = false;
          this.firstInvalidTemplateEscapePos = null;
          this.strictErrors = /* @__PURE__ */ new Map();
          this.tokensLength = 0;
        }
        init({
          strictMode,
          sourceType,
          startLine,
          startColumn
        }) {
          this.strict = strictMode === false ? false : strictMode === true ? true : sourceType === "module";
          this.curLine = startLine;
          this.lineStart = -startColumn;
          this.startLoc = this.endLoc = new Position(startLine, startColumn, 0);
        }
        curPosition() {
          return new Position(this.curLine, this.pos - this.lineStart, this.pos);
        }
        clone(skipArrays) {
          const state = new State();
          const keys2 = Object.keys(this);
          for (let i = 0, length = keys2.length; i < length; i++) {
            const key = keys2[i];
            let val = this[key];
            if (!skipArrays && Array.isArray(val)) {
              val = val.slice();
            }
            state[key] = val;
          }
          return state;
        }
      };
      var _isDigit = function isDigit(code) {
        return code >= 48 && code <= 57;
      };
      var forbiddenNumericSeparatorSiblings = {
        decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]),
        hex: /* @__PURE__ */ new Set([46, 88, 95, 120])
      };
      var isAllowedNumericSeparatorSibling = {
        bin: (ch) => ch === 48 || ch === 49,
        oct: (ch) => ch >= 48 && ch <= 55,
        dec: (ch) => ch >= 48 && ch <= 57,
        hex: (ch) => ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102
      };
      function readStringContents(type, input, pos, lineStart, curLine, errors) {
        const initialPos = pos;
        const initialLineStart = lineStart;
        const initialCurLine = curLine;
        let out = "";
        let firstInvalidLoc = null;
        let chunkStart = pos;
        const {
          length
        } = input;
        for (; ; ) {
          if (pos >= length) {
            errors.unterminated(initialPos, initialLineStart, initialCurLine);
            out += input.slice(chunkStart, pos);
            break;
          }
          const ch = input.charCodeAt(pos);
          if (isStringEnd(type, ch, input, pos)) {
            out += input.slice(chunkStart, pos);
            break;
          }
          if (ch === 92) {
            out += input.slice(chunkStart, pos);
            const res = readEscapedChar(input, pos, lineStart, curLine, type === "template", errors);
            if (res.ch === null && !firstInvalidLoc) {
              firstInvalidLoc = {
                pos,
                lineStart,
                curLine
              };
            } else {
              out += res.ch;
            }
            ({
              pos,
              lineStart,
              curLine
            } = res);
            chunkStart = pos;
          } else if (ch === 8232 || ch === 8233) {
            ++pos;
            ++curLine;
            lineStart = pos;
          } else if (ch === 10 || ch === 13) {
            if (type === "template") {
              out += input.slice(chunkStart, pos) + "\n";
              ++pos;
              if (ch === 13 && input.charCodeAt(pos) === 10) {
                ++pos;
              }
              ++curLine;
              chunkStart = lineStart = pos;
            } else {
              errors.unterminated(initialPos, initialLineStart, initialCurLine);
            }
          } else {
            ++pos;
          }
        }
        return {
          pos,
          str: out,
          firstInvalidLoc,
          lineStart,
          curLine,
          containsInvalid: !!firstInvalidLoc
        };
      }
      function isStringEnd(type, ch, input, pos) {
        if (type === "template") {
          return ch === 96 || ch === 36 && input.charCodeAt(pos + 1) === 123;
        }
        return ch === (type === "double" ? 34 : 39);
      }
      function readEscapedChar(input, pos, lineStart, curLine, inTemplate, errors) {
        const throwOnInvalid = !inTemplate;
        pos++;
        const res = (ch2) => ({
          pos,
          ch: ch2,
          lineStart,
          curLine
        });
        const ch = input.charCodeAt(pos++);
        switch (ch) {
          case 110:
            return res("\n");
          case 114:
            return res("\r");
          case 120: {
            let code;
            ({
              code,
              pos
            } = readHexChar(input, pos, lineStart, curLine, 2, false, throwOnInvalid, errors));
            return res(code === null ? null : String.fromCharCode(code));
          }
          case 117: {
            let code;
            ({
              code,
              pos
            } = readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors));
            return res(code === null ? null : String.fromCodePoint(code));
          }
          case 116:
            return res("	");
          case 98:
            return res("\b");
          case 118:
            return res("\v");
          case 102:
            return res("\f");
          case 13:
            if (input.charCodeAt(pos) === 10) {
              ++pos;
            }
          case 10:
            lineStart = pos;
            ++curLine;
          case 8232:
          case 8233:
            return res("");
          case 56:
          case 57:
            if (inTemplate) {
              return res(null);
            } else {
              errors.strictNumericEscape(pos - 1, lineStart, curLine);
            }
          default:
            if (ch >= 48 && ch <= 55) {
              const startPos = pos - 1;
              const match = input.slice(startPos, pos + 2).match(/^[0-7]+/);
              let octalStr = match[0];
              let octal = parseInt(octalStr, 8);
              if (octal > 255) {
                octalStr = octalStr.slice(0, -1);
                octal = parseInt(octalStr, 8);
              }
              pos += octalStr.length - 1;
              const next = input.charCodeAt(pos);
              if (octalStr !== "0" || next === 56 || next === 57) {
                if (inTemplate) {
                  return res(null);
                } else {
                  errors.strictNumericEscape(startPos, lineStart, curLine);
                }
              }
              return res(String.fromCharCode(octal));
            }
            return res(String.fromCharCode(ch));
        }
      }
      function readHexChar(input, pos, lineStart, curLine, len, forceLen, throwOnInvalid, errors) {
        const initialPos = pos;
        let n;
        ({
          n,
          pos
        } = readInt(input, pos, lineStart, curLine, 16, len, forceLen, false, errors, !throwOnInvalid));
        if (n === null) {
          if (throwOnInvalid) {
            errors.invalidEscapeSequence(initialPos, lineStart, curLine);
          } else {
            pos = initialPos - 1;
          }
        }
        return {
          code: n,
          pos
        };
      }
      function readInt(input, pos, lineStart, curLine, radix, len, forceLen, allowNumSeparator, errors, bailOnError) {
        const start = pos;
        const forbiddenSiblings = radix === 16 ? forbiddenNumericSeparatorSiblings.hex : forbiddenNumericSeparatorSiblings.decBinOct;
        const isAllowedSibling = radix === 16 ? isAllowedNumericSeparatorSibling.hex : radix === 10 ? isAllowedNumericSeparatorSibling.dec : radix === 8 ? isAllowedNumericSeparatorSibling.oct : isAllowedNumericSeparatorSibling.bin;
        let invalid = false;
        let total = 0;
        for (let i = 0, e = len == null ? Infinity : len; i < e; ++i) {
          const code = input.charCodeAt(pos);
          let val;
          if (code === 95 && allowNumSeparator !== "bail") {
            const prev = input.charCodeAt(pos - 1);
            const next = input.charCodeAt(pos + 1);
            if (!allowNumSeparator) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.numericSeparatorInEscapeSequence(pos, lineStart, curLine);
            } else if (Number.isNaN(next) || !isAllowedSibling(next) || forbiddenSiblings.has(prev) || forbiddenSiblings.has(next)) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.unexpectedNumericSeparator(pos, lineStart, curLine);
            }
            ++pos;
            continue;
          }
          if (code >= 97) {
            val = code - 97 + 10;
          } else if (code >= 65) {
            val = code - 65 + 10;
          } else if (_isDigit(code)) {
            val = code - 48;
          } else {
            val = Infinity;
          }
          if (val >= radix) {
            if (val <= 9 && bailOnError) {
              return {
                n: null,
                pos
              };
            } else if (val <= 9 && errors.invalidDigit(pos, lineStart, curLine, radix)) {
              val = 0;
            } else if (forceLen) {
              val = 0;
              invalid = true;
            } else {
              break;
            }
          }
          ++pos;
          total = total * radix + val;
        }
        if (pos === start || len != null && pos - start !== len || invalid) {
          return {
            n: null,
            pos
          };
        }
        return {
          n: total,
          pos
        };
      }
      function readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors) {
        const ch = input.charCodeAt(pos);
        let code;
        if (ch === 123) {
          ++pos;
          ({
            code,
            pos
          } = readHexChar(input, pos, lineStart, curLine, input.indexOf("}", pos) - pos, true, throwOnInvalid, errors));
          ++pos;
          if (code !== null && code > 1114111) {
            if (throwOnInvalid) {
              errors.invalidCodePoint(pos, lineStart, curLine);
            } else {
              return {
                code: null,
                pos
              };
            }
          }
        } else {
          ({
            code,
            pos
          } = readHexChar(input, pos, lineStart, curLine, 4, false, throwOnInvalid, errors));
        }
        return {
          code,
          pos
        };
      }
      var _excluded = ["at"];
      var _excluded2 = ["at"];
      function buildPosition(pos, lineStart, curLine) {
        return new Position(curLine, pos - lineStart, pos);
      }
      var VALID_REGEX_FLAGS = /* @__PURE__ */ new Set([103, 109, 115, 105, 121, 117, 100, 118]);
      var Token = class {
        constructor(state) {
          this.type = state.type;
          this.value = state.value;
          this.start = state.start;
          this.end = state.end;
          this.loc = new SourceLocation(state.startLoc, state.endLoc);
        }
      };
      var Tokenizer = class extends CommentsParser {
        constructor(options, input) {
          super();
          this.isLookahead = void 0;
          this.tokens = [];
          this.errorHandlers_readInt = {
            invalidDigit: (pos, lineStart, curLine, radix) => {
              if (!this.options.errorRecovery)
                return false;
              this.raise(Errors.InvalidDigit, {
                at: buildPosition(pos, lineStart, curLine),
                radix
              });
              return true;
            },
            numericSeparatorInEscapeSequence: this.errorBuilder(Errors.NumericSeparatorInEscapeSequence),
            unexpectedNumericSeparator: this.errorBuilder(Errors.UnexpectedNumericSeparator)
          };
          this.errorHandlers_readCodePoint = Object.assign({}, this.errorHandlers_readInt, {
            invalidEscapeSequence: this.errorBuilder(Errors.InvalidEscapeSequence),
            invalidCodePoint: this.errorBuilder(Errors.InvalidCodePoint)
          });
          this.errorHandlers_readStringContents_string = Object.assign({}, this.errorHandlers_readCodePoint, {
            strictNumericEscape: (pos, lineStart, curLine) => {
              this.recordStrictModeErrors(Errors.StrictNumericEscape, {
                at: buildPosition(pos, lineStart, curLine)
              });
            },
            unterminated: (pos, lineStart, curLine) => {
              throw this.raise(Errors.UnterminatedString, {
                at: buildPosition(pos - 1, lineStart, curLine)
              });
            }
          });
          this.errorHandlers_readStringContents_template = Object.assign({}, this.errorHandlers_readCodePoint, {
            strictNumericEscape: this.errorBuilder(Errors.StrictNumericEscape),
            unterminated: (pos, lineStart, curLine) => {
              throw this.raise(Errors.UnterminatedTemplate, {
                at: buildPosition(pos, lineStart, curLine)
              });
            }
          });
          this.state = new State();
          this.state.init(options);
          this.input = input;
          this.length = input.length;
          this.isLookahead = false;
        }
        pushToken(token) {
          this.tokens.length = this.state.tokensLength;
          this.tokens.push(token);
          ++this.state.tokensLength;
        }
        next() {
          this.checkKeywordEscapes();
          if (this.options.tokens) {
            this.pushToken(new Token(this.state));
          }
          this.state.lastTokStart = this.state.start;
          this.state.lastTokEndLoc = this.state.endLoc;
          this.state.lastTokStartLoc = this.state.startLoc;
          this.nextToken();
        }
        eat(type) {
          if (this.match(type)) {
            this.next();
            return true;
          } else {
            return false;
          }
        }
        match(type) {
          return this.state.type === type;
        }
        createLookaheadState(state) {
          return {
            pos: state.pos,
            value: null,
            type: state.type,
            start: state.start,
            end: state.end,
            context: [this.curContext()],
            inType: state.inType,
            startLoc: state.startLoc,
            lastTokEndLoc: state.lastTokEndLoc,
            curLine: state.curLine,
            lineStart: state.lineStart,
            curPosition: state.curPosition
          };
        }
        lookahead() {
          const old = this.state;
          this.state = this.createLookaheadState(old);
          this.isLookahead = true;
          this.nextToken();
          this.isLookahead = false;
          const curr = this.state;
          this.state = old;
          return curr;
        }
        nextTokenStart() {
          return this.nextTokenStartSince(this.state.pos);
        }
        nextTokenStartSince(pos) {
          skipWhiteSpace.lastIndex = pos;
          return skipWhiteSpace.test(this.input) ? skipWhiteSpace.lastIndex : pos;
        }
        lookaheadCharCode() {
          return this.input.charCodeAt(this.nextTokenStart());
        }
        codePointAtPos(pos) {
          let cp = this.input.charCodeAt(pos);
          if ((cp & 64512) === 55296 && ++pos < this.input.length) {
            const trail = this.input.charCodeAt(pos);
            if ((trail & 64512) === 56320) {
              cp = 65536 + ((cp & 1023) << 10) + (trail & 1023);
            }
          }
          return cp;
        }
        setStrict(strict) {
          this.state.strict = strict;
          if (strict) {
            this.state.strictErrors.forEach(([toParseError, at2]) => this.raise(toParseError, {
              at: at2
            }));
            this.state.strictErrors.clear();
          }
        }
        curContext() {
          return this.state.context[this.state.context.length - 1];
        }
        nextToken() {
          this.skipSpace();
          this.state.start = this.state.pos;
          if (!this.isLookahead)
            this.state.startLoc = this.state.curPosition();
          if (this.state.pos >= this.length) {
            this.finishToken(137);
            return;
          }
          this.getTokenFromCode(this.codePointAtPos(this.state.pos));
        }
        skipBlockComment(commentEnd) {
          let startLoc;
          if (!this.isLookahead)
            startLoc = this.state.curPosition();
          const start = this.state.pos;
          const end = this.input.indexOf(commentEnd, start + 2);
          if (end === -1) {
            throw this.raise(Errors.UnterminatedComment, {
              at: this.state.curPosition()
            });
          }
          this.state.pos = end + commentEnd.length;
          lineBreakG.lastIndex = start + 2;
          while (lineBreakG.test(this.input) && lineBreakG.lastIndex <= end) {
            ++this.state.curLine;
            this.state.lineStart = lineBreakG.lastIndex;
          }
          if (this.isLookahead)
            return;
          const comment = {
            type: "CommentBlock",
            value: this.input.slice(start + 2, end),
            start,
            end: end + commentEnd.length,
            loc: new SourceLocation(startLoc, this.state.curPosition())
          };
          if (this.options.tokens)
            this.pushToken(comment);
          return comment;
        }
        skipLineComment(startSkip) {
          const start = this.state.pos;
          let startLoc;
          if (!this.isLookahead)
            startLoc = this.state.curPosition();
          let ch = this.input.charCodeAt(this.state.pos += startSkip);
          if (this.state.pos < this.length) {
            while (!isNewLine(ch) && ++this.state.pos < this.length) {
              ch = this.input.charCodeAt(this.state.pos);
            }
          }
          if (this.isLookahead)
            return;
          const end = this.state.pos;
          const value = this.input.slice(start + startSkip, end);
          const comment = {
            type: "CommentLine",
            value,
            start,
            end,
            loc: new SourceLocation(startLoc, this.state.curPosition())
          };
          if (this.options.tokens)
            this.pushToken(comment);
          return comment;
        }
        skipSpace() {
          const spaceStart = this.state.pos;
          const comments = [];
          loop:
            while (this.state.pos < this.length) {
              const ch = this.input.charCodeAt(this.state.pos);
              switch (ch) {
                case 32:
                case 160:
                case 9:
                  ++this.state.pos;
                  break;
                case 13:
                  if (this.input.charCodeAt(this.state.pos + 1) === 10) {
                    ++this.state.pos;
                  }
                case 10:
                case 8232:
                case 8233:
                  ++this.state.pos;
                  ++this.state.curLine;
                  this.state.lineStart = this.state.pos;
                  break;
                case 47:
                  switch (this.input.charCodeAt(this.state.pos + 1)) {
                    case 42: {
                      const comment = this.skipBlockComment("*/");
                      if (comment !== void 0) {
                        this.addComment(comment);
                        if (this.options.attachComment)
                          comments.push(comment);
                      }
                      break;
                    }
                    case 47: {
                      const comment = this.skipLineComment(2);
                      if (comment !== void 0) {
                        this.addComment(comment);
                        if (this.options.attachComment)
                          comments.push(comment);
                      }
                      break;
                    }
                    default:
                      break loop;
                  }
                  break;
                default:
                  if (isWhitespace(ch)) {
                    ++this.state.pos;
                  } else if (ch === 45 && !this.inModule) {
                    const pos = this.state.pos;
                    if (this.input.charCodeAt(pos + 1) === 45 && this.input.charCodeAt(pos + 2) === 62 && (spaceStart === 0 || this.state.lineStart > spaceStart)) {
                      const comment = this.skipLineComment(3);
                      if (comment !== void 0) {
                        this.addComment(comment);
                        if (this.options.attachComment)
                          comments.push(comment);
                      }
                    } else {
                      break loop;
                    }
                  } else if (ch === 60 && !this.inModule) {
                    const pos = this.state.pos;
                    if (this.input.charCodeAt(pos + 1) === 33 && this.input.charCodeAt(pos + 2) === 45 && this.input.charCodeAt(pos + 3) === 45) {
                      const comment = this.skipLineComment(4);
                      if (comment !== void 0) {
                        this.addComment(comment);
                        if (this.options.attachComment)
                          comments.push(comment);
                      }
                    } else {
                      break loop;
                    }
                  } else {
                    break loop;
                  }
              }
            }
          if (comments.length > 0) {
            const end = this.state.pos;
            const commentWhitespace = {
              start: spaceStart,
              end,
              comments,
              leadingNode: null,
              trailingNode: null,
              containingNode: null
            };
            this.state.commentStack.push(commentWhitespace);
          }
        }
        finishToken(type, val) {
          this.state.end = this.state.pos;
          this.state.endLoc = this.state.curPosition();
          const prevType = this.state.type;
          this.state.type = type;
          this.state.value = val;
          if (!this.isLookahead) {
            this.updateContext(prevType);
          }
        }
        replaceToken(type) {
          this.state.type = type;
          this.updateContext();
        }
        readToken_numberSign() {
          if (this.state.pos === 0 && this.readToken_interpreter()) {
            return;
          }
          const nextPos = this.state.pos + 1;
          const next = this.codePointAtPos(nextPos);
          if (next >= 48 && next <= 57) {
            throw this.raise(Errors.UnexpectedDigitAfterHash, {
              at: this.state.curPosition()
            });
          }
          if (next === 123 || next === 91 && this.hasPlugin("recordAndTuple")) {
            this.expectPlugin("recordAndTuple");
            if (this.getPluginOption("recordAndTuple", "syntaxType") === "bar") {
              throw this.raise(next === 123 ? Errors.RecordExpressionHashIncorrectStartSyntaxType : Errors.TupleExpressionHashIncorrectStartSyntaxType, {
                at: this.state.curPosition()
              });
            }
            this.state.pos += 2;
            if (next === 123) {
              this.finishToken(7);
            } else {
              this.finishToken(1);
            }
          } else if (isIdentifierStart(next)) {
            ++this.state.pos;
            this.finishToken(136, this.readWord1(next));
          } else if (next === 92) {
            ++this.state.pos;
            this.finishToken(136, this.readWord1());
          } else {
            this.finishOp(27, 1);
          }
        }
        readToken_dot() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next >= 48 && next <= 57) {
            this.readNumber(true);
            return;
          }
          if (next === 46 && this.input.charCodeAt(this.state.pos + 2) === 46) {
            this.state.pos += 3;
            this.finishToken(21);
          } else {
            ++this.state.pos;
            this.finishToken(16);
          }
        }
        readToken_slash() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 61) {
            this.finishOp(31, 2);
          } else {
            this.finishOp(56, 1);
          }
        }
        readToken_interpreter() {
          if (this.state.pos !== 0 || this.length < 2)
            return false;
          let ch = this.input.charCodeAt(this.state.pos + 1);
          if (ch !== 33)
            return false;
          const start = this.state.pos;
          this.state.pos += 1;
          while (!isNewLine(ch) && ++this.state.pos < this.length) {
            ch = this.input.charCodeAt(this.state.pos);
          }
          const value = this.input.slice(start + 2, this.state.pos);
          this.finishToken(28, value);
          return true;
        }
        readToken_mult_modulo(code) {
          let type = code === 42 ? 55 : 54;
          let width = 1;
          let next = this.input.charCodeAt(this.state.pos + 1);
          if (code === 42 && next === 42) {
            width++;
            next = this.input.charCodeAt(this.state.pos + 2);
            type = 57;
          }
          if (next === 61 && !this.state.inType) {
            width++;
            type = code === 37 ? 33 : 30;
          }
          this.finishOp(type, width);
        }
        readToken_pipe_amp(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === code) {
            if (this.input.charCodeAt(this.state.pos + 2) === 61) {
              this.finishOp(30, 3);
            } else {
              this.finishOp(code === 124 ? 41 : 42, 2);
            }
            return;
          }
          if (code === 124) {
            if (next === 62) {
              this.finishOp(39, 2);
              return;
            }
            if (this.hasPlugin("recordAndTuple") && next === 125) {
              if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                throw this.raise(Errors.RecordExpressionBarIncorrectEndSyntaxType, {
                  at: this.state.curPosition()
                });
              }
              this.state.pos += 2;
              this.finishToken(9);
              return;
            }
            if (this.hasPlugin("recordAndTuple") && next === 93) {
              if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                throw this.raise(Errors.TupleExpressionBarIncorrectEndSyntaxType, {
                  at: this.state.curPosition()
                });
              }
              this.state.pos += 2;
              this.finishToken(4);
              return;
            }
          }
          if (next === 61) {
            this.finishOp(30, 2);
            return;
          }
          this.finishOp(code === 124 ? 43 : 45, 1);
        }
        readToken_caret() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 61 && !this.state.inType) {
            this.finishOp(32, 2);
          } else if (next === 94 && this.hasPlugin(["pipelineOperator", {
            proposal: "hack",
            topicToken: "^^"
          }])) {
            this.finishOp(37, 2);
            const lookaheadCh = this.input.codePointAt(this.state.pos);
            if (lookaheadCh === 94) {
              throw this.unexpected();
            }
          } else {
            this.finishOp(44, 1);
          }
        }
        readToken_atSign() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 64 && this.hasPlugin(["pipelineOperator", {
            proposal: "hack",
            topicToken: "@@"
          }])) {
            this.finishOp(38, 2);
          } else {
            this.finishOp(26, 1);
          }
        }
        readToken_plus_min(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === code) {
            this.finishOp(34, 2);
            return;
          }
          if (next === 61) {
            this.finishOp(30, 2);
          } else {
            this.finishOp(53, 1);
          }
        }
        readToken_lt() {
          const {
            pos
          } = this.state;
          const next = this.input.charCodeAt(pos + 1);
          if (next === 60) {
            if (this.input.charCodeAt(pos + 2) === 61) {
              this.finishOp(30, 3);
              return;
            }
            this.finishOp(51, 2);
            return;
          }
          if (next === 61) {
            this.finishOp(49, 2);
            return;
          }
          this.finishOp(47, 1);
        }
        readToken_gt() {
          const {
            pos
          } = this.state;
          const next = this.input.charCodeAt(pos + 1);
          if (next === 62) {
            const size2 = this.input.charCodeAt(pos + 2) === 62 ? 3 : 2;
            if (this.input.charCodeAt(pos + size2) === 61) {
              this.finishOp(30, size2 + 1);
              return;
            }
            this.finishOp(52, size2);
            return;
          }
          if (next === 61) {
            this.finishOp(49, 2);
            return;
          }
          this.finishOp(48, 1);
        }
        readToken_eq_excl(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 61) {
            this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
            return;
          }
          if (code === 61 && next === 62) {
            this.state.pos += 2;
            this.finishToken(19);
            return;
          }
          this.finishOp(code === 61 ? 29 : 35, 1);
        }
        readToken_question() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          const next2 = this.input.charCodeAt(this.state.pos + 2);
          if (next === 63) {
            if (next2 === 61) {
              this.finishOp(30, 3);
            } else {
              this.finishOp(40, 2);
            }
          } else if (next === 46 && !(next2 >= 48 && next2 <= 57)) {
            this.state.pos += 2;
            this.finishToken(18);
          } else {
            ++this.state.pos;
            this.finishToken(17);
          }
        }
        getTokenFromCode(code) {
          switch (code) {
            case 46:
              this.readToken_dot();
              return;
            case 40:
              ++this.state.pos;
              this.finishToken(10);
              return;
            case 41:
              ++this.state.pos;
              this.finishToken(11);
              return;
            case 59:
              ++this.state.pos;
              this.finishToken(13);
              return;
            case 44:
              ++this.state.pos;
              this.finishToken(12);
              return;
            case 91:
              if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                  throw this.raise(Errors.TupleExpressionBarIncorrectStartSyntaxType, {
                    at: this.state.curPosition()
                  });
                }
                this.state.pos += 2;
                this.finishToken(2);
              } else {
                ++this.state.pos;
                this.finishToken(0);
              }
              return;
            case 93:
              ++this.state.pos;
              this.finishToken(3);
              return;
            case 123:
              if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                  throw this.raise(Errors.RecordExpressionBarIncorrectStartSyntaxType, {
                    at: this.state.curPosition()
                  });
                }
                this.state.pos += 2;
                this.finishToken(6);
              } else {
                ++this.state.pos;
                this.finishToken(5);
              }
              return;
            case 125:
              ++this.state.pos;
              this.finishToken(8);
              return;
            case 58:
              if (this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58) {
                this.finishOp(15, 2);
              } else {
                ++this.state.pos;
                this.finishToken(14);
              }
              return;
            case 63:
              this.readToken_question();
              return;
            case 96:
              this.readTemplateToken();
              return;
            case 48: {
              const next = this.input.charCodeAt(this.state.pos + 1);
              if (next === 120 || next === 88) {
                this.readRadixNumber(16);
                return;
              }
              if (next === 111 || next === 79) {
                this.readRadixNumber(8);
                return;
              }
              if (next === 98 || next === 66) {
                this.readRadixNumber(2);
                return;
              }
            }
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
              this.readNumber(false);
              return;
            case 34:
            case 39:
              this.readString(code);
              return;
            case 47:
              this.readToken_slash();
              return;
            case 37:
            case 42:
              this.readToken_mult_modulo(code);
              return;
            case 124:
            case 38:
              this.readToken_pipe_amp(code);
              return;
            case 94:
              this.readToken_caret();
              return;
            case 43:
            case 45:
              this.readToken_plus_min(code);
              return;
            case 60:
              this.readToken_lt();
              return;
            case 62:
              this.readToken_gt();
              return;
            case 61:
            case 33:
              this.readToken_eq_excl(code);
              return;
            case 126:
              this.finishOp(36, 1);
              return;
            case 64:
              this.readToken_atSign();
              return;
            case 35:
              this.readToken_numberSign();
              return;
            case 92:
              this.readWord();
              return;
            default:
              if (isIdentifierStart(code)) {
                this.readWord(code);
                return;
              }
          }
          throw this.raise(Errors.InvalidOrUnexpectedToken, {
            at: this.state.curPosition(),
            unexpected: String.fromCodePoint(code)
          });
        }
        finishOp(type, size2) {
          const str = this.input.slice(this.state.pos, this.state.pos + size2);
          this.state.pos += size2;
          this.finishToken(type, str);
        }
        readRegexp() {
          const startLoc = this.state.startLoc;
          const start = this.state.start + 1;
          let escaped, inClass;
          let {
            pos
          } = this.state;
          for (; ; ++pos) {
            if (pos >= this.length) {
              throw this.raise(Errors.UnterminatedRegExp, {
                at: createPositionWithColumnOffset(startLoc, 1)
              });
            }
            const ch = this.input.charCodeAt(pos);
            if (isNewLine(ch)) {
              throw this.raise(Errors.UnterminatedRegExp, {
                at: createPositionWithColumnOffset(startLoc, 1)
              });
            }
            if (escaped) {
              escaped = false;
            } else {
              if (ch === 91) {
                inClass = true;
              } else if (ch === 93 && inClass) {
                inClass = false;
              } else if (ch === 47 && !inClass) {
                break;
              }
              escaped = ch === 92;
            }
          }
          const content = this.input.slice(start, pos);
          ++pos;
          let mods = "";
          const nextPos = () => createPositionWithColumnOffset(startLoc, pos + 2 - start);
          while (pos < this.length) {
            const cp = this.codePointAtPos(pos);
            const char = String.fromCharCode(cp);
            if (VALID_REGEX_FLAGS.has(cp)) {
              if (cp === 118) {
                this.expectPlugin("regexpUnicodeSets", nextPos());
                if (mods.includes("u")) {
                  this.raise(Errors.IncompatibleRegExpUVFlags, {
                    at: nextPos()
                  });
                }
              } else if (cp === 117) {
                if (mods.includes("v")) {
                  this.raise(Errors.IncompatibleRegExpUVFlags, {
                    at: nextPos()
                  });
                }
              }
              if (mods.includes(char)) {
                this.raise(Errors.DuplicateRegExpFlags, {
                  at: nextPos()
                });
              }
            } else if (isIdentifierChar(cp) || cp === 92) {
              this.raise(Errors.MalformedRegExpFlags, {
                at: nextPos()
              });
            } else {
              break;
            }
            ++pos;
            mods += char;
          }
          this.state.pos = pos;
          this.finishToken(135, {
            pattern: content,
            flags: mods
          });
        }
        readInt(radix, len, forceLen = false, allowNumSeparator = true) {
          const {
            n,
            pos
          } = readInt(this.input, this.state.pos, this.state.lineStart, this.state.curLine, radix, len, forceLen, allowNumSeparator, this.errorHandlers_readInt, false);
          this.state.pos = pos;
          return n;
        }
        readRadixNumber(radix) {
          const startLoc = this.state.curPosition();
          let isBigInt = false;
          this.state.pos += 2;
          const val = this.readInt(radix);
          if (val == null) {
            this.raise(Errors.InvalidDigit, {
              at: createPositionWithColumnOffset(startLoc, 2),
              radix
            });
          }
          const next = this.input.charCodeAt(this.state.pos);
          if (next === 110) {
            ++this.state.pos;
            isBigInt = true;
          } else if (next === 109) {
            throw this.raise(Errors.InvalidDecimal, {
              at: startLoc
            });
          }
          if (isIdentifierStart(this.codePointAtPos(this.state.pos))) {
            throw this.raise(Errors.NumberIdentifier, {
              at: this.state.curPosition()
            });
          }
          if (isBigInt) {
            const str = this.input.slice(startLoc.index, this.state.pos).replace(/[_n]/g, "");
            this.finishToken(133, str);
            return;
          }
          this.finishToken(132, val);
        }
        readNumber(startsWithDot) {
          const start = this.state.pos;
          const startLoc = this.state.curPosition();
          let isFloat = false;
          let isBigInt = false;
          let isDecimal = false;
          let hasExponent = false;
          let isOctal = false;
          if (!startsWithDot && this.readInt(10) === null) {
            this.raise(Errors.InvalidNumber, {
              at: this.state.curPosition()
            });
          }
          const hasLeadingZero = this.state.pos - start >= 2 && this.input.charCodeAt(start) === 48;
          if (hasLeadingZero) {
            const integer = this.input.slice(start, this.state.pos);
            this.recordStrictModeErrors(Errors.StrictOctalLiteral, {
              at: startLoc
            });
            if (!this.state.strict) {
              const underscorePos = integer.indexOf("_");
              if (underscorePos > 0) {
                this.raise(Errors.ZeroDigitNumericSeparator, {
                  at: createPositionWithColumnOffset(startLoc, underscorePos)
                });
              }
            }
            isOctal = hasLeadingZero && !/[89]/.test(integer);
          }
          let next = this.input.charCodeAt(this.state.pos);
          if (next === 46 && !isOctal) {
            ++this.state.pos;
            this.readInt(10);
            isFloat = true;
            next = this.input.charCodeAt(this.state.pos);
          }
          if ((next === 69 || next === 101) && !isOctal) {
            next = this.input.charCodeAt(++this.state.pos);
            if (next === 43 || next === 45) {
              ++this.state.pos;
            }
            if (this.readInt(10) === null) {
              this.raise(Errors.InvalidOrMissingExponent, {
                at: startLoc
              });
            }
            isFloat = true;
            hasExponent = true;
            next = this.input.charCodeAt(this.state.pos);
          }
          if (next === 110) {
            if (isFloat || hasLeadingZero) {
              this.raise(Errors.InvalidBigIntLiteral, {
                at: startLoc
              });
            }
            ++this.state.pos;
            isBigInt = true;
          }
          if (next === 109) {
            this.expectPlugin("decimal", this.state.curPosition());
            if (hasExponent || hasLeadingZero) {
              this.raise(Errors.InvalidDecimal, {
                at: startLoc
              });
            }
            ++this.state.pos;
            isDecimal = true;
          }
          if (isIdentifierStart(this.codePointAtPos(this.state.pos))) {
            throw this.raise(Errors.NumberIdentifier, {
              at: this.state.curPosition()
            });
          }
          const str = this.input.slice(start, this.state.pos).replace(/[_mn]/g, "");
          if (isBigInt) {
            this.finishToken(133, str);
            return;
          }
          if (isDecimal) {
            this.finishToken(134, str);
            return;
          }
          const val = isOctal ? parseInt(str, 8) : parseFloat(str);
          this.finishToken(132, val);
        }
        readCodePoint(throwOnInvalid) {
          const {
            code,
            pos
          } = readCodePoint(this.input, this.state.pos, this.state.lineStart, this.state.curLine, throwOnInvalid, this.errorHandlers_readCodePoint);
          this.state.pos = pos;
          return code;
        }
        readString(quote) {
          const {
            str,
            pos,
            curLine,
            lineStart
          } = readStringContents(
            quote === 34 ? "double" : "single",
            this.input,
            this.state.pos + 1,
            this.state.lineStart,
            this.state.curLine,
            this.errorHandlers_readStringContents_string
          );
          this.state.pos = pos + 1;
          this.state.lineStart = lineStart;
          this.state.curLine = curLine;
          this.finishToken(131, str);
        }
        readTemplateContinuation() {
          if (!this.match(8)) {
            this.unexpected(null, 8);
          }
          this.state.pos--;
          this.readTemplateToken();
        }
        readTemplateToken() {
          const opening = this.input[this.state.pos];
          const {
            str,
            firstInvalidLoc,
            pos,
            curLine,
            lineStart
          } = readStringContents(
            "template",
            this.input,
            this.state.pos + 1,
            this.state.lineStart,
            this.state.curLine,
            this.errorHandlers_readStringContents_template
          );
          this.state.pos = pos + 1;
          this.state.lineStart = lineStart;
          this.state.curLine = curLine;
          if (firstInvalidLoc) {
            this.state.firstInvalidTemplateEscapePos = new Position(firstInvalidLoc.curLine, firstInvalidLoc.pos - firstInvalidLoc.lineStart, firstInvalidLoc.pos);
          }
          if (this.input.codePointAt(pos) === 96) {
            this.finishToken(24, firstInvalidLoc ? null : opening + str + "`");
          } else {
            this.state.pos++;
            this.finishToken(25, firstInvalidLoc ? null : opening + str + "${");
          }
        }
        recordStrictModeErrors(toParseError, {
          at: at2
        }) {
          const index = at2.index;
          if (this.state.strict && !this.state.strictErrors.has(index)) {
            this.raise(toParseError, {
              at: at2
            });
          } else {
            this.state.strictErrors.set(index, [toParseError, at2]);
          }
        }
        readWord1(firstCode) {
          this.state.containsEsc = false;
          let word = "";
          const start = this.state.pos;
          let chunkStart = this.state.pos;
          if (firstCode !== void 0) {
            this.state.pos += firstCode <= 65535 ? 1 : 2;
          }
          while (this.state.pos < this.length) {
            const ch = this.codePointAtPos(this.state.pos);
            if (isIdentifierChar(ch)) {
              this.state.pos += ch <= 65535 ? 1 : 2;
            } else if (ch === 92) {
              this.state.containsEsc = true;
              word += this.input.slice(chunkStart, this.state.pos);
              const escStart = this.state.curPosition();
              const identifierCheck = this.state.pos === start ? isIdentifierStart : isIdentifierChar;
              if (this.input.charCodeAt(++this.state.pos) !== 117) {
                this.raise(Errors.MissingUnicodeEscape, {
                  at: this.state.curPosition()
                });
                chunkStart = this.state.pos - 1;
                continue;
              }
              ++this.state.pos;
              const esc = this.readCodePoint(true);
              if (esc !== null) {
                if (!identifierCheck(esc)) {
                  this.raise(Errors.EscapedCharNotAnIdentifier, {
                    at: escStart
                  });
                }
                word += String.fromCodePoint(esc);
              }
              chunkStart = this.state.pos;
            } else {
              break;
            }
          }
          return word + this.input.slice(chunkStart, this.state.pos);
        }
        readWord(firstCode) {
          const word = this.readWord1(firstCode);
          const type = keywords$1.get(word);
          if (type !== void 0) {
            this.finishToken(type, tokenLabelName(type));
          } else {
            this.finishToken(130, word);
          }
        }
        checkKeywordEscapes() {
          const {
            type
          } = this.state;
          if (tokenIsKeyword(type) && this.state.containsEsc) {
            this.raise(Errors.InvalidEscapedReservedWord, {
              at: this.state.startLoc,
              reservedWord: tokenLabelName(type)
            });
          }
        }
        raise(toParseError, raiseProperties) {
          const {
            at: at2
          } = raiseProperties, details = _objectWithoutPropertiesLoose(raiseProperties, _excluded);
          const loc = at2 instanceof Position ? at2 : at2.loc.start;
          const error = toParseError({
            loc,
            details
          });
          if (!this.options.errorRecovery)
            throw error;
          if (!this.isLookahead)
            this.state.errors.push(error);
          return error;
        }
        raiseOverwrite(toParseError, raiseProperties) {
          const {
            at: at2
          } = raiseProperties, details = _objectWithoutPropertiesLoose(raiseProperties, _excluded2);
          const loc = at2 instanceof Position ? at2 : at2.loc.start;
          const pos = loc.index;
          const errors = this.state.errors;
          for (let i = errors.length - 1; i >= 0; i--) {
            const error = errors[i];
            if (error.loc.index === pos) {
              return errors[i] = toParseError({
                loc,
                details
              });
            }
            if (error.loc.index < pos)
              break;
          }
          return this.raise(toParseError, raiseProperties);
        }
        updateContext(prevType) {
        }
        unexpected(loc, type) {
          throw this.raise(Errors.UnexpectedToken, {
            expected: type ? tokenLabelName(type) : null,
            at: loc != null ? loc : this.state.startLoc
          });
        }
        expectPlugin(pluginName, loc) {
          if (this.hasPlugin(pluginName)) {
            return true;
          }
          throw this.raise(Errors.MissingPlugin, {
            at: loc != null ? loc : this.state.startLoc,
            missingPlugin: [pluginName]
          });
        }
        expectOnePlugin(pluginNames) {
          if (!pluginNames.some((name) => this.hasPlugin(name))) {
            throw this.raise(Errors.MissingOneOfPlugins, {
              at: this.state.startLoc,
              missingPlugin: pluginNames
            });
          }
        }
        errorBuilder(error) {
          return (pos, lineStart, curLine) => {
            this.raise(error, {
              at: buildPosition(pos, lineStart, curLine)
            });
          };
        }
      };
      var ClassScope = class {
        constructor() {
          this.privateNames = /* @__PURE__ */ new Set();
          this.loneAccessors = /* @__PURE__ */ new Map();
          this.undefinedPrivateNames = /* @__PURE__ */ new Map();
        }
      };
      var ClassScopeHandler = class {
        constructor(parser3) {
          this.parser = void 0;
          this.stack = [];
          this.undefinedPrivateNames = /* @__PURE__ */ new Map();
          this.parser = parser3;
        }
        current() {
          return this.stack[this.stack.length - 1];
        }
        enter() {
          this.stack.push(new ClassScope());
        }
        exit() {
          const oldClassScope = this.stack.pop();
          const current = this.current();
          for (const [name, loc] of Array.from(oldClassScope.undefinedPrivateNames)) {
            if (current) {
              if (!current.undefinedPrivateNames.has(name)) {
                current.undefinedPrivateNames.set(name, loc);
              }
            } else {
              this.parser.raise(Errors.InvalidPrivateFieldResolution, {
                at: loc,
                identifierName: name
              });
            }
          }
        }
        declarePrivateName(name, elementType, loc) {
          const {
            privateNames,
            loneAccessors,
            undefinedPrivateNames
          } = this.current();
          let redefined = privateNames.has(name);
          if (elementType & CLASS_ELEMENT_KIND_ACCESSOR) {
            const accessor = redefined && loneAccessors.get(name);
            if (accessor) {
              const oldStatic = accessor & CLASS_ELEMENT_FLAG_STATIC;
              const newStatic = elementType & CLASS_ELEMENT_FLAG_STATIC;
              const oldKind = accessor & CLASS_ELEMENT_KIND_ACCESSOR;
              const newKind = elementType & CLASS_ELEMENT_KIND_ACCESSOR;
              redefined = oldKind === newKind || oldStatic !== newStatic;
              if (!redefined)
                loneAccessors.delete(name);
            } else if (!redefined) {
              loneAccessors.set(name, elementType);
            }
          }
          if (redefined) {
            this.parser.raise(Errors.PrivateNameRedeclaration, {
              at: loc,
              identifierName: name
            });
          }
          privateNames.add(name);
          undefinedPrivateNames.delete(name);
        }
        usePrivateName(name, loc) {
          let classScope;
          for (classScope of this.stack) {
            if (classScope.privateNames.has(name))
              return;
          }
          if (classScope) {
            classScope.undefinedPrivateNames.set(name, loc);
          } else {
            this.parser.raise(Errors.InvalidPrivateFieldResolution, {
              at: loc,
              identifierName: name
            });
          }
        }
      };
      var kExpression = 0;
      var kMaybeArrowParameterDeclaration = 1;
      var kMaybeAsyncArrowParameterDeclaration = 2;
      var kParameterDeclaration = 3;
      var ExpressionScope = class {
        constructor(type = kExpression) {
          this.type = void 0;
          this.type = type;
        }
        canBeArrowParameterDeclaration() {
          return this.type === kMaybeAsyncArrowParameterDeclaration || this.type === kMaybeArrowParameterDeclaration;
        }
        isCertainlyParameterDeclaration() {
          return this.type === kParameterDeclaration;
        }
      };
      var ArrowHeadParsingScope = class extends ExpressionScope {
        constructor(type) {
          super(type);
          this.declarationErrors = /* @__PURE__ */ new Map();
        }
        recordDeclarationError(ParsingErrorClass, {
          at: at2
        }) {
          const index = at2.index;
          this.declarationErrors.set(index, [ParsingErrorClass, at2]);
        }
        clearDeclarationError(index) {
          this.declarationErrors.delete(index);
        }
        iterateErrors(iterator) {
          this.declarationErrors.forEach(iterator);
        }
      };
      var ExpressionScopeHandler = class {
        constructor(parser3) {
          this.parser = void 0;
          this.stack = [new ExpressionScope()];
          this.parser = parser3;
        }
        enter(scope) {
          this.stack.push(scope);
        }
        exit() {
          this.stack.pop();
        }
        recordParameterInitializerError(toParseError, {
          at: node
        }) {
          const origin = {
            at: node.loc.start
          };
          const {
            stack
          } = this;
          let i = stack.length - 1;
          let scope = stack[i];
          while (!scope.isCertainlyParameterDeclaration()) {
            if (scope.canBeArrowParameterDeclaration()) {
              scope.recordDeclarationError(toParseError, origin);
            } else {
              return;
            }
            scope = stack[--i];
          }
          this.parser.raise(toParseError, origin);
        }
        recordArrowParemeterBindingError(error, {
          at: node
        }) {
          const {
            stack
          } = this;
          const scope = stack[stack.length - 1];
          const origin = {
            at: node.loc.start
          };
          if (scope.isCertainlyParameterDeclaration()) {
            this.parser.raise(error, origin);
          } else if (scope.canBeArrowParameterDeclaration()) {
            scope.recordDeclarationError(error, origin);
          } else {
            return;
          }
        }
        recordAsyncArrowParametersError({
          at: at2
        }) {
          const {
            stack
          } = this;
          let i = stack.length - 1;
          let scope = stack[i];
          while (scope.canBeArrowParameterDeclaration()) {
            if (scope.type === kMaybeAsyncArrowParameterDeclaration) {
              scope.recordDeclarationError(Errors.AwaitBindingIdentifier, {
                at: at2
              });
            }
            scope = stack[--i];
          }
        }
        validateAsPattern() {
          const {
            stack
          } = this;
          const currentScope = stack[stack.length - 1];
          if (!currentScope.canBeArrowParameterDeclaration())
            return;
          currentScope.iterateErrors(([toParseError, loc]) => {
            this.parser.raise(toParseError, {
              at: loc
            });
            let i = stack.length - 2;
            let scope = stack[i];
            while (scope.canBeArrowParameterDeclaration()) {
              scope.clearDeclarationError(loc.index);
              scope = stack[--i];
            }
          });
        }
      };
      function newParameterDeclarationScope() {
        return new ExpressionScope(kParameterDeclaration);
      }
      function newArrowHeadScope() {
        return new ArrowHeadParsingScope(kMaybeArrowParameterDeclaration);
      }
      function newAsyncArrowScope() {
        return new ArrowHeadParsingScope(kMaybeAsyncArrowParameterDeclaration);
      }
      function newExpressionScope() {
        return new ExpressionScope();
      }
      var PARAM = 0;
      var PARAM_YIELD = 1;
      var PARAM_AWAIT = 2;
      var PARAM_RETURN = 4;
      var PARAM_IN = 8;
      var ProductionParameterHandler = class {
        constructor() {
          this.stacks = [];
        }
        enter(flags) {
          this.stacks.push(flags);
        }
        exit() {
          this.stacks.pop();
        }
        currentFlags() {
          return this.stacks[this.stacks.length - 1];
        }
        get hasAwait() {
          return (this.currentFlags() & PARAM_AWAIT) > 0;
        }
        get hasYield() {
          return (this.currentFlags() & PARAM_YIELD) > 0;
        }
        get hasReturn() {
          return (this.currentFlags() & PARAM_RETURN) > 0;
        }
        get hasIn() {
          return (this.currentFlags() & PARAM_IN) > 0;
        }
      };
      function functionFlags(isAsync, isGenerator) {
        return (isAsync ? PARAM_AWAIT : 0) | (isGenerator ? PARAM_YIELD : 0);
      }
      var UtilParser = class extends Tokenizer {
        addExtra(node, key, value, enumerable = true) {
          if (!node)
            return;
          const extra = node.extra = node.extra || {};
          if (enumerable) {
            extra[key] = value;
          } else {
            Object.defineProperty(extra, key, {
              enumerable,
              value
            });
          }
        }
        isContextual(token) {
          return this.state.type === token && !this.state.containsEsc;
        }
        isUnparsedContextual(nameStart, name) {
          const nameEnd = nameStart + name.length;
          if (this.input.slice(nameStart, nameEnd) === name) {
            const nextCh = this.input.charCodeAt(nameEnd);
            return !(isIdentifierChar(nextCh) || (nextCh & 64512) === 55296);
          }
          return false;
        }
        isLookaheadContextual(name) {
          const next = this.nextTokenStart();
          return this.isUnparsedContextual(next, name);
        }
        eatContextual(token) {
          if (this.isContextual(token)) {
            this.next();
            return true;
          }
          return false;
        }
        expectContextual(token, toParseError) {
          if (!this.eatContextual(token)) {
            if (toParseError != null) {
              throw this.raise(toParseError, {
                at: this.state.startLoc
              });
            }
            throw this.unexpected(null, token);
          }
        }
        canInsertSemicolon() {
          return this.match(137) || this.match(8) || this.hasPrecedingLineBreak();
        }
        hasPrecedingLineBreak() {
          return lineBreak.test(this.input.slice(this.state.lastTokEndLoc.index, this.state.start));
        }
        hasFollowingLineBreak() {
          skipWhiteSpaceToLineBreak.lastIndex = this.state.end;
          return skipWhiteSpaceToLineBreak.test(this.input);
        }
        isLineTerminator() {
          return this.eat(13) || this.canInsertSemicolon();
        }
        semicolon(allowAsi = true) {
          if (allowAsi ? this.isLineTerminator() : this.eat(13))
            return;
          this.raise(Errors.MissingSemicolon, {
            at: this.state.lastTokEndLoc
          });
        }
        expect(type, loc) {
          this.eat(type) || this.unexpected(loc, type);
        }
        tryParse(fn, oldState = this.state.clone()) {
          const abortSignal = {
            node: null
          };
          try {
            const node = fn((node2 = null) => {
              abortSignal.node = node2;
              throw abortSignal;
            });
            if (this.state.errors.length > oldState.errors.length) {
              const failState = this.state;
              this.state = oldState;
              this.state.tokensLength = failState.tokensLength;
              return {
                node,
                error: failState.errors[oldState.errors.length],
                thrown: false,
                aborted: false,
                failState
              };
            }
            return {
              node,
              error: null,
              thrown: false,
              aborted: false,
              failState: null
            };
          } catch (error) {
            const failState = this.state;
            this.state = oldState;
            if (error instanceof SyntaxError) {
              return {
                node: null,
                error,
                thrown: true,
                aborted: false,
                failState
              };
            }
            if (error === abortSignal) {
              return {
                node: abortSignal.node,
                error: null,
                thrown: false,
                aborted: true,
                failState
              };
            }
            throw error;
          }
        }
        checkExpressionErrors(refExpressionErrors, andThrow) {
          if (!refExpressionErrors)
            return false;
          const {
            shorthandAssignLoc,
            doubleProtoLoc,
            privateKeyLoc,
            optionalParametersLoc
          } = refExpressionErrors;
          const hasErrors = !!shorthandAssignLoc || !!doubleProtoLoc || !!optionalParametersLoc || !!privateKeyLoc;
          if (!andThrow) {
            return hasErrors;
          }
          if (shorthandAssignLoc != null) {
            this.raise(Errors.InvalidCoverInitializedName, {
              at: shorthandAssignLoc
            });
          }
          if (doubleProtoLoc != null) {
            this.raise(Errors.DuplicateProto, {
              at: doubleProtoLoc
            });
          }
          if (privateKeyLoc != null) {
            this.raise(Errors.UnexpectedPrivateField, {
              at: privateKeyLoc
            });
          }
          if (optionalParametersLoc != null) {
            this.unexpected(optionalParametersLoc);
          }
        }
        isLiteralPropertyName() {
          return tokenIsLiteralPropertyName(this.state.type);
        }
        isPrivateName(node) {
          return node.type === "PrivateName";
        }
        getPrivateNameSV(node) {
          return node.id.name;
        }
        hasPropertyAsPrivateName(node) {
          return (node.type === "MemberExpression" || node.type === "OptionalMemberExpression") && this.isPrivateName(node.property);
        }
        isOptionalChain(node) {
          return node.type === "OptionalMemberExpression" || node.type === "OptionalCallExpression";
        }
        isObjectProperty(node) {
          return node.type === "ObjectProperty";
        }
        isObjectMethod(node) {
          return node.type === "ObjectMethod";
        }
        initializeScopes(inModule = this.options.sourceType === "module") {
          const oldLabels = this.state.labels;
          this.state.labels = [];
          const oldExportedIdentifiers = this.exportedIdentifiers;
          this.exportedIdentifiers = /* @__PURE__ */ new Set();
          const oldInModule = this.inModule;
          this.inModule = inModule;
          const oldScope = this.scope;
          const ScopeHandler2 = this.getScopeHandler();
          this.scope = new ScopeHandler2(this, inModule);
          const oldProdParam = this.prodParam;
          this.prodParam = new ProductionParameterHandler();
          const oldClassScope = this.classScope;
          this.classScope = new ClassScopeHandler(this);
          const oldExpressionScope = this.expressionScope;
          this.expressionScope = new ExpressionScopeHandler(this);
          return () => {
            this.state.labels = oldLabels;
            this.exportedIdentifiers = oldExportedIdentifiers;
            this.inModule = oldInModule;
            this.scope = oldScope;
            this.prodParam = oldProdParam;
            this.classScope = oldClassScope;
            this.expressionScope = oldExpressionScope;
          };
        }
        enterInitialScopes() {
          let paramFlags = PARAM;
          if (this.inModule) {
            paramFlags |= PARAM_AWAIT;
          }
          this.scope.enter(SCOPE_PROGRAM);
          this.prodParam.enter(paramFlags);
        }
        checkDestructuringPrivate(refExpressionErrors) {
          const {
            privateKeyLoc
          } = refExpressionErrors;
          if (privateKeyLoc !== null) {
            this.expectPlugin("destructuringPrivate", privateKeyLoc);
          }
        }
      };
      var ExpressionErrors = class {
        constructor() {
          this.shorthandAssignLoc = null;
          this.doubleProtoLoc = null;
          this.privateKeyLoc = null;
          this.optionalParametersLoc = null;
        }
      };
      var Node2 = class {
        constructor(parser3, pos, loc) {
          this.type = "";
          this.start = pos;
          this.end = 0;
          this.loc = new SourceLocation(loc);
          if (parser3 != null && parser3.options.ranges)
            this.range = [pos, 0];
          if (parser3 != null && parser3.filename)
            this.loc.filename = parser3.filename;
        }
      };
      var NodePrototype = Node2.prototype;
      {
        NodePrototype.__clone = function() {
          const newNode = new Node2(void 0, this.start, this.loc.start);
          const keys2 = Object.keys(this);
          for (let i = 0, length = keys2.length; i < length; i++) {
            const key = keys2[i];
            if (key !== "leadingComments" && key !== "trailingComments" && key !== "innerComments") {
              newNode[key] = this[key];
            }
          }
          return newNode;
        };
      }
      function clonePlaceholder(node) {
        return cloneIdentifier(node);
      }
      function cloneIdentifier(node) {
        const {
          type,
          start,
          end,
          loc,
          range: range2,
          extra,
          name
        } = node;
        const cloned = Object.create(NodePrototype);
        cloned.type = type;
        cloned.start = start;
        cloned.end = end;
        cloned.loc = loc;
        cloned.range = range2;
        cloned.extra = extra;
        cloned.name = name;
        if (type === "Placeholder") {
          cloned.expectedNode = node.expectedNode;
        }
        return cloned;
      }
      function cloneStringLiteral(node) {
        const {
          type,
          start,
          end,
          loc,
          range: range2,
          extra
        } = node;
        if (type === "Placeholder") {
          return clonePlaceholder(node);
        }
        const cloned = Object.create(NodePrototype);
        cloned.type = type;
        cloned.start = start;
        cloned.end = end;
        cloned.loc = loc;
        cloned.range = range2;
        if (node.raw !== void 0) {
          cloned.raw = node.raw;
        } else {
          cloned.extra = extra;
        }
        cloned.value = node.value;
        return cloned;
      }
      var NodeUtils = class extends UtilParser {
        startNode() {
          return new Node2(this, this.state.start, this.state.startLoc);
        }
        startNodeAt(loc) {
          return new Node2(this, loc.index, loc);
        }
        startNodeAtNode(type) {
          return this.startNodeAt(type.loc.start);
        }
        finishNode(node, type) {
          return this.finishNodeAt(node, type, this.state.lastTokEndLoc);
        }
        finishNodeAt(node, type, endLoc) {
          node.type = type;
          node.end = endLoc.index;
          node.loc.end = endLoc;
          if (this.options.ranges)
            node.range[1] = endLoc.index;
          if (this.options.attachComment)
            this.processComment(node);
          return node;
        }
        resetStartLocation(node, startLoc) {
          node.start = startLoc.index;
          node.loc.start = startLoc;
          if (this.options.ranges)
            node.range[0] = startLoc.index;
        }
        resetEndLocation(node, endLoc = this.state.lastTokEndLoc) {
          node.end = endLoc.index;
          node.loc.end = endLoc;
          if (this.options.ranges)
            node.range[1] = endLoc.index;
        }
        resetStartLocationFromNode(node, locationNode) {
          this.resetStartLocation(node, locationNode.loc.start);
        }
      };
      var reservedTypes = /* @__PURE__ */ new Set(["_", "any", "bool", "boolean", "empty", "extends", "false", "interface", "mixed", "null", "number", "static", "string", "true", "typeof", "void"]);
      var FlowErrors = ParseErrorEnum`flow`({
        AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.",
        AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module.",
        AssignReservedType: ({
          reservedType
        }) => `Cannot overwrite reserved type ${reservedType}.`,
        DeclareClassElement: "The `declare` modifier can only appear on class fields.",
        DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.",
        DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement.",
        EnumBooleanMemberNotInitialized: ({
          memberName,
          enumName
        }) => `Boolean enum members need to be initialized. Use either \`${memberName} = true,\` or \`${memberName} = false,\` in enum \`${enumName}\`.`,
        EnumDuplicateMemberName: ({
          memberName,
          enumName
        }) => `Enum member names need to be unique, but the name \`${memberName}\` has already been used before in enum \`${enumName}\`.`,
        EnumInconsistentMemberValues: ({
          enumName
        }) => `Enum \`${enumName}\` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.`,
        EnumInvalidExplicitType: ({
          invalidEnumType,
          enumName
        }) => `Enum type \`${invalidEnumType}\` is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${enumName}\`.`,
        EnumInvalidExplicitTypeUnknownSupplied: ({
          enumName
        }) => `Supplied enum type is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${enumName}\`.`,
        EnumInvalidMemberInitializerPrimaryType: ({
          enumName,
          memberName,
          explicitType
        }) => `Enum \`${enumName}\` has type \`${explicitType}\`, so the initializer of \`${memberName}\` needs to be a ${explicitType} literal.`,
        EnumInvalidMemberInitializerSymbolType: ({
          enumName,
          memberName
        }) => `Symbol enum members cannot be initialized. Use \`${memberName},\` in enum \`${enumName}\`.`,
        EnumInvalidMemberInitializerUnknownType: ({
          enumName,
          memberName
        }) => `The enum member initializer for \`${memberName}\` needs to be a literal (either a boolean, number, or string) in enum \`${enumName}\`.`,
        EnumInvalidMemberName: ({
          enumName,
          memberName,
          suggestion
        }) => `Enum member names cannot start with lowercase 'a' through 'z'. Instead of using \`${memberName}\`, consider using \`${suggestion}\`, in enum \`${enumName}\`.`,
        EnumNumberMemberNotInitialized: ({
          enumName,
          memberName
        }) => `Number enum members need to be initialized, e.g. \`${memberName} = 1\` in enum \`${enumName}\`.`,
        EnumStringMemberInconsistentlyInitailized: ({
          enumName
        }) => `String enum members need to consistently either all use initializers, or use no initializers, in enum \`${enumName}\`.`,
        GetterMayNotHaveThisParam: "A getter cannot have a `this` parameter.",
        ImportReflectionHasImportType: "An `import module` declaration can not use `type` or `typeof` keyword.",
        ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements.",
        InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type.",
        InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions.",
        InexactVariance: "Explicit inexact syntax cannot have variance.",
        InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`.",
        MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.",
        NestedDeclareModule: "`declare module` cannot be used inside another `declare module`.",
        NestedFlowComment: "Cannot have a flow comment inside another flow comment.",
        PatternIsOptional: Object.assign({
          message: "A binding pattern parameter cannot be optional in an implementation signature."
        }, {
          reasonCode: "OptionalBindingPattern"
        }),
        SetterMayNotHaveThisParam: "A setter cannot have a `this` parameter.",
        SpreadVariance: "Spread properties cannot have variance.",
        ThisParamAnnotationRequired: "A type annotation is required for the `this` parameter.",
        ThisParamBannedInConstructor: "Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions.",
        ThisParamMayNotBeOptional: "The `this` parameter cannot be optional.",
        ThisParamMustBeFirst: "The `this` parameter must be the first function parameter.",
        ThisParamNoDefault: "The `this` parameter may not have a default value.",
        TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.",
        TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis.",
        UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object.",
        UnexpectedReservedType: ({
          reservedType
        }) => `Unexpected reserved type ${reservedType}.`,
        UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new.",
        UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.",
        UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions.",
        UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint".',
        UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration.",
        UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`.",
        UnsupportedDeclareExportKind: ({
          unsupportedExportKind,
          suggestion
        }) => `\`declare export ${unsupportedExportKind}\` is not supported. Use \`${suggestion}\` instead.`,
        UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module.",
        UnterminatedFlowComment: "Unterminated flow-comment."
      });
      function isEsModuleType(bodyElement) {
        return bodyElement.type === "DeclareExportAllDeclaration" || bodyElement.type === "DeclareExportDeclaration" && (!bodyElement.declaration || bodyElement.declaration.type !== "TypeAlias" && bodyElement.declaration.type !== "InterfaceDeclaration");
      }
      function hasTypeImportKind(node) {
        return node.importKind === "type" || node.importKind === "typeof";
      }
      function isMaybeDefaultImport(type) {
        return tokenIsKeywordOrIdentifier(type) && type !== 97;
      }
      var exportSuggestions = {
        const: "declare export var",
        let: "declare export var",
        type: "export type",
        interface: "export interface"
      };
      function partition2(list, test) {
        const list1 = [];
        const list2 = [];
        for (let i = 0; i < list.length; i++) {
          (test(list[i], i, list) ? list1 : list2).push(list[i]);
        }
        return [list1, list2];
      }
      var FLOW_PRAGMA_REGEX = /\*?\s*@((?:no)?flow)\b/;
      var flow2 = (superClass) => class FlowParserMixin extends superClass {
        constructor(...args) {
          super(...args);
          this.flowPragma = void 0;
        }
        getScopeHandler() {
          return FlowScopeHandler;
        }
        shouldParseTypes() {
          return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
        }
        shouldParseEnums() {
          return !!this.getPluginOption("flow", "enums");
        }
        finishToken(type, val) {
          if (type !== 131 && type !== 13 && type !== 28) {
            if (this.flowPragma === void 0) {
              this.flowPragma = null;
            }
          }
          return super.finishToken(type, val);
        }
        addComment(comment) {
          if (this.flowPragma === void 0) {
            const matches2 = FLOW_PRAGMA_REGEX.exec(comment.value);
            if (!matches2)
              ;
            else if (matches2[1] === "flow") {
              this.flowPragma = "flow";
            } else if (matches2[1] === "noflow") {
              this.flowPragma = "noflow";
            } else {
              throw new Error("Unexpected flow pragma");
            }
          }
          return super.addComment(comment);
        }
        flowParseTypeInitialiser(tok) {
          const oldInType = this.state.inType;
          this.state.inType = true;
          this.expect(tok || 14);
          const type = this.flowParseType();
          this.state.inType = oldInType;
          return type;
        }
        flowParsePredicate() {
          const node = this.startNode();
          const moduloLoc = this.state.startLoc;
          this.next();
          this.expectContextual(108);
          if (this.state.lastTokStart > moduloLoc.index + 1) {
            this.raise(FlowErrors.UnexpectedSpaceBetweenModuloChecks, {
              at: moduloLoc
            });
          }
          if (this.eat(10)) {
            node.value = super.parseExpression();
            this.expect(11);
            return this.finishNode(node, "DeclaredPredicate");
          } else {
            return this.finishNode(node, "InferredPredicate");
          }
        }
        flowParseTypeAndPredicateInitialiser() {
          const oldInType = this.state.inType;
          this.state.inType = true;
          this.expect(14);
          let type = null;
          let predicate = null;
          if (this.match(54)) {
            this.state.inType = oldInType;
            predicate = this.flowParsePredicate();
          } else {
            type = this.flowParseType();
            this.state.inType = oldInType;
            if (this.match(54)) {
              predicate = this.flowParsePredicate();
            }
          }
          return [type, predicate];
        }
        flowParseDeclareClass(node) {
          this.next();
          this.flowParseInterfaceish(node, true);
          return this.finishNode(node, "DeclareClass");
        }
        flowParseDeclareFunction(node) {
          this.next();
          const id = node.id = this.parseIdentifier();
          const typeNode = this.startNode();
          const typeContainer = this.startNode();
          if (this.match(47)) {
            typeNode.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            typeNode.typeParameters = null;
          }
          this.expect(10);
          const tmp = this.flowParseFunctionTypeParams();
          typeNode.params = tmp.params;
          typeNode.rest = tmp.rest;
          typeNode.this = tmp._this;
          this.expect(11);
          [typeNode.returnType, node.predicate] = this.flowParseTypeAndPredicateInitialiser();
          typeContainer.typeAnnotation = this.finishNode(typeNode, "FunctionTypeAnnotation");
          id.typeAnnotation = this.finishNode(typeContainer, "TypeAnnotation");
          this.resetEndLocation(id);
          this.semicolon();
          this.scope.declareName(node.id.name, BIND_FLOW_DECLARE_FN, node.id.loc.start);
          return this.finishNode(node, "DeclareFunction");
        }
        flowParseDeclare(node, insideModule) {
          if (this.match(80)) {
            return this.flowParseDeclareClass(node);
          } else if (this.match(68)) {
            return this.flowParseDeclareFunction(node);
          } else if (this.match(74)) {
            return this.flowParseDeclareVariable(node);
          } else if (this.eatContextual(125)) {
            if (this.match(16)) {
              return this.flowParseDeclareModuleExports(node);
            } else {
              if (insideModule) {
                this.raise(FlowErrors.NestedDeclareModule, {
                  at: this.state.lastTokStartLoc
                });
              }
              return this.flowParseDeclareModule(node);
            }
          } else if (this.isContextual(128)) {
            return this.flowParseDeclareTypeAlias(node);
          } else if (this.isContextual(129)) {
            return this.flowParseDeclareOpaqueType(node);
          } else if (this.isContextual(127)) {
            return this.flowParseDeclareInterface(node);
          } else if (this.match(82)) {
            return this.flowParseDeclareExportDeclaration(node, insideModule);
          } else {
            throw this.unexpected();
          }
        }
        flowParseDeclareVariable(node) {
          this.next();
          node.id = this.flowParseTypeAnnotatableIdentifier(true);
          this.scope.declareName(node.id.name, BIND_VAR, node.id.loc.start);
          this.semicolon();
          return this.finishNode(node, "DeclareVariable");
        }
        flowParseDeclareModule(node) {
          this.scope.enter(SCOPE_OTHER);
          if (this.match(131)) {
            node.id = super.parseExprAtom();
          } else {
            node.id = this.parseIdentifier();
          }
          const bodyNode = node.body = this.startNode();
          const body = bodyNode.body = [];
          this.expect(5);
          while (!this.match(8)) {
            let bodyNode2 = this.startNode();
            if (this.match(83)) {
              this.next();
              if (!this.isContextual(128) && !this.match(87)) {
                this.raise(FlowErrors.InvalidNonTypeImportInDeclareModule, {
                  at: this.state.lastTokStartLoc
                });
              }
              super.parseImport(bodyNode2);
            } else {
              this.expectContextual(123, FlowErrors.UnsupportedStatementInDeclareModule);
              bodyNode2 = this.flowParseDeclare(bodyNode2, true);
            }
            body.push(bodyNode2);
          }
          this.scope.exit();
          this.expect(8);
          this.finishNode(bodyNode, "BlockStatement");
          let kind = null;
          let hasModuleExport = false;
          body.forEach((bodyElement) => {
            if (isEsModuleType(bodyElement)) {
              if (kind === "CommonJS") {
                this.raise(FlowErrors.AmbiguousDeclareModuleKind, {
                  at: bodyElement
                });
              }
              kind = "ES";
            } else if (bodyElement.type === "DeclareModuleExports") {
              if (hasModuleExport) {
                this.raise(FlowErrors.DuplicateDeclareModuleExports, {
                  at: bodyElement
                });
              }
              if (kind === "ES") {
                this.raise(FlowErrors.AmbiguousDeclareModuleKind, {
                  at: bodyElement
                });
              }
              kind = "CommonJS";
              hasModuleExport = true;
            }
          });
          node.kind = kind || "CommonJS";
          return this.finishNode(node, "DeclareModule");
        }
        flowParseDeclareExportDeclaration(node, insideModule) {
          this.expect(82);
          if (this.eat(65)) {
            if (this.match(68) || this.match(80)) {
              node.declaration = this.flowParseDeclare(this.startNode());
            } else {
              node.declaration = this.flowParseType();
              this.semicolon();
            }
            node.default = true;
            return this.finishNode(node, "DeclareExportDeclaration");
          } else {
            if (this.match(75) || this.isLet() || (this.isContextual(128) || this.isContextual(127)) && !insideModule) {
              const label = this.state.value;
              throw this.raise(FlowErrors.UnsupportedDeclareExportKind, {
                at: this.state.startLoc,
                unsupportedExportKind: label,
                suggestion: exportSuggestions[label]
              });
            }
            if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(129)) {
              node.declaration = this.flowParseDeclare(this.startNode());
              node.default = false;
              return this.finishNode(node, "DeclareExportDeclaration");
            } else if (this.match(55) || this.match(5) || this.isContextual(127) || this.isContextual(128) || this.isContextual(129)) {
              node = this.parseExport(node, null);
              if (node.type === "ExportNamedDeclaration") {
                node.type = "ExportDeclaration";
                node.default = false;
                delete node.exportKind;
              }
              node.type = "Declare" + node.type;
              return node;
            }
          }
          throw this.unexpected();
        }
        flowParseDeclareModuleExports(node) {
          this.next();
          this.expectContextual(109);
          node.typeAnnotation = this.flowParseTypeAnnotation();
          this.semicolon();
          return this.finishNode(node, "DeclareModuleExports");
        }
        flowParseDeclareTypeAlias(node) {
          this.next();
          const finished = this.flowParseTypeAlias(node);
          finished.type = "DeclareTypeAlias";
          return finished;
        }
        flowParseDeclareOpaqueType(node) {
          this.next();
          const finished = this.flowParseOpaqueType(node, true);
          finished.type = "DeclareOpaqueType";
          return finished;
        }
        flowParseDeclareInterface(node) {
          this.next();
          this.flowParseInterfaceish(node);
          return this.finishNode(node, "DeclareInterface");
        }
        flowParseInterfaceish(node, isClass = false) {
          node.id = this.flowParseRestrictedIdentifier(!isClass, true);
          this.scope.declareName(node.id.name, isClass ? BIND_FUNCTION : BIND_LEXICAL, node.id.loc.start);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            node.typeParameters = null;
          }
          node.extends = [];
          node.implements = [];
          node.mixins = [];
          if (this.eat(81)) {
            do {
              node.extends.push(this.flowParseInterfaceExtends());
            } while (!isClass && this.eat(12));
          }
          if (this.isContextual(115)) {
            this.next();
            do {
              node.mixins.push(this.flowParseInterfaceExtends());
            } while (this.eat(12));
          }
          if (this.isContextual(111)) {
            this.next();
            do {
              node.implements.push(this.flowParseInterfaceExtends());
            } while (this.eat(12));
          }
          node.body = this.flowParseObjectType({
            allowStatic: isClass,
            allowExact: false,
            allowSpread: false,
            allowProto: isClass,
            allowInexact: false
          });
        }
        flowParseInterfaceExtends() {
          const node = this.startNode();
          node.id = this.flowParseQualifiedTypeIdentifier();
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterInstantiation();
          } else {
            node.typeParameters = null;
          }
          return this.finishNode(node, "InterfaceExtends");
        }
        flowParseInterface(node) {
          this.flowParseInterfaceish(node);
          return this.finishNode(node, "InterfaceDeclaration");
        }
        checkNotUnderscore(word) {
          if (word === "_") {
            this.raise(FlowErrors.UnexpectedReservedUnderscore, {
              at: this.state.startLoc
            });
          }
        }
        checkReservedType(word, startLoc, declaration) {
          if (!reservedTypes.has(word))
            return;
          this.raise(declaration ? FlowErrors.AssignReservedType : FlowErrors.UnexpectedReservedType, {
            at: startLoc,
            reservedType: word
          });
        }
        flowParseRestrictedIdentifier(liberal, declaration) {
          this.checkReservedType(this.state.value, this.state.startLoc, declaration);
          return this.parseIdentifier(liberal);
        }
        flowParseTypeAlias(node) {
          node.id = this.flowParseRestrictedIdentifier(false, true);
          this.scope.declareName(node.id.name, BIND_LEXICAL, node.id.loc.start);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            node.typeParameters = null;
          }
          node.right = this.flowParseTypeInitialiser(29);
          this.semicolon();
          return this.finishNode(node, "TypeAlias");
        }
        flowParseOpaqueType(node, declare) {
          this.expectContextual(128);
          node.id = this.flowParseRestrictedIdentifier(true, true);
          this.scope.declareName(node.id.name, BIND_LEXICAL, node.id.loc.start);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            node.typeParameters = null;
          }
          node.supertype = null;
          if (this.match(14)) {
            node.supertype = this.flowParseTypeInitialiser(14);
          }
          node.impltype = null;
          if (!declare) {
            node.impltype = this.flowParseTypeInitialiser(29);
          }
          this.semicolon();
          return this.finishNode(node, "OpaqueType");
        }
        flowParseTypeParameter(requireDefault = false) {
          const nodeStartLoc = this.state.startLoc;
          const node = this.startNode();
          const variance = this.flowParseVariance();
          const ident = this.flowParseTypeAnnotatableIdentifier();
          node.name = ident.name;
          node.variance = variance;
          node.bound = ident.typeAnnotation;
          if (this.match(29)) {
            this.eat(29);
            node.default = this.flowParseType();
          } else {
            if (requireDefault) {
              this.raise(FlowErrors.MissingTypeParamDefault, {
                at: nodeStartLoc
              });
            }
          }
          return this.finishNode(node, "TypeParameter");
        }
        flowParseTypeParameterDeclaration() {
          const oldInType = this.state.inType;
          const node = this.startNode();
          node.params = [];
          this.state.inType = true;
          if (this.match(47) || this.match(140)) {
            this.next();
          } else {
            this.unexpected();
          }
          let defaultRequired = false;
          do {
            const typeParameter = this.flowParseTypeParameter(defaultRequired);
            node.params.push(typeParameter);
            if (typeParameter.default) {
              defaultRequired = true;
            }
            if (!this.match(48)) {
              this.expect(12);
            }
          } while (!this.match(48));
          this.expect(48);
          this.state.inType = oldInType;
          return this.finishNode(node, "TypeParameterDeclaration");
        }
        flowParseTypeParameterInstantiation() {
          const node = this.startNode();
          const oldInType = this.state.inType;
          node.params = [];
          this.state.inType = true;
          this.expect(47);
          const oldNoAnonFunctionType = this.state.noAnonFunctionType;
          this.state.noAnonFunctionType = false;
          while (!this.match(48)) {
            node.params.push(this.flowParseType());
            if (!this.match(48)) {
              this.expect(12);
            }
          }
          this.state.noAnonFunctionType = oldNoAnonFunctionType;
          this.expect(48);
          this.state.inType = oldInType;
          return this.finishNode(node, "TypeParameterInstantiation");
        }
        flowParseTypeParameterInstantiationCallOrNew() {
          const node = this.startNode();
          const oldInType = this.state.inType;
          node.params = [];
          this.state.inType = true;
          this.expect(47);
          while (!this.match(48)) {
            node.params.push(this.flowParseTypeOrImplicitInstantiation());
            if (!this.match(48)) {
              this.expect(12);
            }
          }
          this.expect(48);
          this.state.inType = oldInType;
          return this.finishNode(node, "TypeParameterInstantiation");
        }
        flowParseInterfaceType() {
          const node = this.startNode();
          this.expectContextual(127);
          node.extends = [];
          if (this.eat(81)) {
            do {
              node.extends.push(this.flowParseInterfaceExtends());
            } while (this.eat(12));
          }
          node.body = this.flowParseObjectType({
            allowStatic: false,
            allowExact: false,
            allowSpread: false,
            allowProto: false,
            allowInexact: false
          });
          return this.finishNode(node, "InterfaceTypeAnnotation");
        }
        flowParseObjectPropertyKey() {
          return this.match(132) || this.match(131) ? super.parseExprAtom() : this.parseIdentifier(true);
        }
        flowParseObjectTypeIndexer(node, isStatic, variance) {
          node.static = isStatic;
          if (this.lookahead().type === 14) {
            node.id = this.flowParseObjectPropertyKey();
            node.key = this.flowParseTypeInitialiser();
          } else {
            node.id = null;
            node.key = this.flowParseType();
          }
          this.expect(3);
          node.value = this.flowParseTypeInitialiser();
          node.variance = variance;
          return this.finishNode(node, "ObjectTypeIndexer");
        }
        flowParseObjectTypeInternalSlot(node, isStatic) {
          node.static = isStatic;
          node.id = this.flowParseObjectPropertyKey();
          this.expect(3);
          this.expect(3);
          if (this.match(47) || this.match(10)) {
            node.method = true;
            node.optional = false;
            node.value = this.flowParseObjectTypeMethodish(this.startNodeAt(node.loc.start));
          } else {
            node.method = false;
            if (this.eat(17)) {
              node.optional = true;
            }
            node.value = this.flowParseTypeInitialiser();
          }
          return this.finishNode(node, "ObjectTypeInternalSlot");
        }
        flowParseObjectTypeMethodish(node) {
          node.params = [];
          node.rest = null;
          node.typeParameters = null;
          node.this = null;
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          this.expect(10);
          if (this.match(78)) {
            node.this = this.flowParseFunctionTypeParam(true);
            node.this.name = null;
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          while (!this.match(11) && !this.match(21)) {
            node.params.push(this.flowParseFunctionTypeParam(false));
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          if (this.eat(21)) {
            node.rest = this.flowParseFunctionTypeParam(false);
          }
          this.expect(11);
          node.returnType = this.flowParseTypeInitialiser();
          return this.finishNode(node, "FunctionTypeAnnotation");
        }
        flowParseObjectTypeCallProperty(node, isStatic) {
          const valueNode = this.startNode();
          node.static = isStatic;
          node.value = this.flowParseObjectTypeMethodish(valueNode);
          return this.finishNode(node, "ObjectTypeCallProperty");
        }
        flowParseObjectType({
          allowStatic,
          allowExact,
          allowSpread,
          allowProto,
          allowInexact
        }) {
          const oldInType = this.state.inType;
          this.state.inType = true;
          const nodeStart = this.startNode();
          nodeStart.callProperties = [];
          nodeStart.properties = [];
          nodeStart.indexers = [];
          nodeStart.internalSlots = [];
          let endDelim;
          let exact;
          let inexact = false;
          if (allowExact && this.match(6)) {
            this.expect(6);
            endDelim = 9;
            exact = true;
          } else {
            this.expect(5);
            endDelim = 8;
            exact = false;
          }
          nodeStart.exact = exact;
          while (!this.match(endDelim)) {
            let isStatic = false;
            let protoStartLoc = null;
            let inexactStartLoc = null;
            const node = this.startNode();
            if (allowProto && this.isContextual(116)) {
              const lookahead = this.lookahead();
              if (lookahead.type !== 14 && lookahead.type !== 17) {
                this.next();
                protoStartLoc = this.state.startLoc;
                allowStatic = false;
              }
            }
            if (allowStatic && this.isContextual(104)) {
              const lookahead = this.lookahead();
              if (lookahead.type !== 14 && lookahead.type !== 17) {
                this.next();
                isStatic = true;
              }
            }
            const variance = this.flowParseVariance();
            if (this.eat(0)) {
              if (protoStartLoc != null) {
                this.unexpected(protoStartLoc);
              }
              if (this.eat(0)) {
                if (variance) {
                  this.unexpected(variance.loc.start);
                }
                nodeStart.internalSlots.push(this.flowParseObjectTypeInternalSlot(node, isStatic));
              } else {
                nodeStart.indexers.push(this.flowParseObjectTypeIndexer(node, isStatic, variance));
              }
            } else if (this.match(10) || this.match(47)) {
              if (protoStartLoc != null) {
                this.unexpected(protoStartLoc);
              }
              if (variance) {
                this.unexpected(variance.loc.start);
              }
              nodeStart.callProperties.push(this.flowParseObjectTypeCallProperty(node, isStatic));
            } else {
              let kind = "init";
              if (this.isContextual(98) || this.isContextual(103)) {
                const lookahead = this.lookahead();
                if (tokenIsLiteralPropertyName(lookahead.type)) {
                  kind = this.state.value;
                  this.next();
                }
              }
              const propOrInexact = this.flowParseObjectTypeProperty(node, isStatic, protoStartLoc, variance, kind, allowSpread, allowInexact != null ? allowInexact : !exact);
              if (propOrInexact === null) {
                inexact = true;
                inexactStartLoc = this.state.lastTokStartLoc;
              } else {
                nodeStart.properties.push(propOrInexact);
              }
            }
            this.flowObjectTypeSemicolon();
            if (inexactStartLoc && !this.match(8) && !this.match(9)) {
              this.raise(FlowErrors.UnexpectedExplicitInexactInObject, {
                at: inexactStartLoc
              });
            }
          }
          this.expect(endDelim);
          if (allowSpread) {
            nodeStart.inexact = inexact;
          }
          const out = this.finishNode(nodeStart, "ObjectTypeAnnotation");
          this.state.inType = oldInType;
          return out;
        }
        flowParseObjectTypeProperty(node, isStatic, protoStartLoc, variance, kind, allowSpread, allowInexact) {
          if (this.eat(21)) {
            const isInexactToken = this.match(12) || this.match(13) || this.match(8) || this.match(9);
            if (isInexactToken) {
              if (!allowSpread) {
                this.raise(FlowErrors.InexactInsideNonObject, {
                  at: this.state.lastTokStartLoc
                });
              } else if (!allowInexact) {
                this.raise(FlowErrors.InexactInsideExact, {
                  at: this.state.lastTokStartLoc
                });
              }
              if (variance) {
                this.raise(FlowErrors.InexactVariance, {
                  at: variance
                });
              }
              return null;
            }
            if (!allowSpread) {
              this.raise(FlowErrors.UnexpectedSpreadType, {
                at: this.state.lastTokStartLoc
              });
            }
            if (protoStartLoc != null) {
              this.unexpected(protoStartLoc);
            }
            if (variance) {
              this.raise(FlowErrors.SpreadVariance, {
                at: variance
              });
            }
            node.argument = this.flowParseType();
            return this.finishNode(node, "ObjectTypeSpreadProperty");
          } else {
            node.key = this.flowParseObjectPropertyKey();
            node.static = isStatic;
            node.proto = protoStartLoc != null;
            node.kind = kind;
            let optional = false;
            if (this.match(47) || this.match(10)) {
              node.method = true;
              if (protoStartLoc != null) {
                this.unexpected(protoStartLoc);
              }
              if (variance) {
                this.unexpected(variance.loc.start);
              }
              node.value = this.flowParseObjectTypeMethodish(this.startNodeAt(node.loc.start));
              if (kind === "get" || kind === "set") {
                this.flowCheckGetterSetterParams(node);
              }
              if (!allowSpread && node.key.name === "constructor" && node.value.this) {
                this.raise(FlowErrors.ThisParamBannedInConstructor, {
                  at: node.value.this
                });
              }
            } else {
              if (kind !== "init")
                this.unexpected();
              node.method = false;
              if (this.eat(17)) {
                optional = true;
              }
              node.value = this.flowParseTypeInitialiser();
              node.variance = variance;
            }
            node.optional = optional;
            return this.finishNode(node, "ObjectTypeProperty");
          }
        }
        flowCheckGetterSetterParams(property2) {
          const paramCount = property2.kind === "get" ? 0 : 1;
          const length = property2.value.params.length + (property2.value.rest ? 1 : 0);
          if (property2.value.this) {
            this.raise(property2.kind === "get" ? FlowErrors.GetterMayNotHaveThisParam : FlowErrors.SetterMayNotHaveThisParam, {
              at: property2.value.this
            });
          }
          if (length !== paramCount) {
            this.raise(property2.kind === "get" ? Errors.BadGetterArity : Errors.BadSetterArity, {
              at: property2
            });
          }
          if (property2.kind === "set" && property2.value.rest) {
            this.raise(Errors.BadSetterRestParameter, {
              at: property2
            });
          }
        }
        flowObjectTypeSemicolon() {
          if (!this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9)) {
            this.unexpected();
          }
        }
        flowParseQualifiedTypeIdentifier(startLoc, id) {
          var _startLoc;
          (_startLoc = startLoc) != null ? _startLoc : startLoc = this.state.startLoc;
          let node = id || this.flowParseRestrictedIdentifier(true);
          while (this.eat(16)) {
            const node2 = this.startNodeAt(startLoc);
            node2.qualification = node;
            node2.id = this.flowParseRestrictedIdentifier(true);
            node = this.finishNode(node2, "QualifiedTypeIdentifier");
          }
          return node;
        }
        flowParseGenericType(startLoc, id) {
          const node = this.startNodeAt(startLoc);
          node.typeParameters = null;
          node.id = this.flowParseQualifiedTypeIdentifier(startLoc, id);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterInstantiation();
          }
          return this.finishNode(node, "GenericTypeAnnotation");
        }
        flowParseTypeofType() {
          const node = this.startNode();
          this.expect(87);
          node.argument = this.flowParsePrimaryType();
          return this.finishNode(node, "TypeofTypeAnnotation");
        }
        flowParseTupleType() {
          const node = this.startNode();
          node.types = [];
          this.expect(0);
          while (this.state.pos < this.length && !this.match(3)) {
            node.types.push(this.flowParseType());
            if (this.match(3))
              break;
            this.expect(12);
          }
          this.expect(3);
          return this.finishNode(node, "TupleTypeAnnotation");
        }
        flowParseFunctionTypeParam(first) {
          let name = null;
          let optional = false;
          let typeAnnotation = null;
          const node = this.startNode();
          const lh = this.lookahead();
          const isThis = this.state.type === 78;
          if (lh.type === 14 || lh.type === 17) {
            if (isThis && !first) {
              this.raise(FlowErrors.ThisParamMustBeFirst, {
                at: node
              });
            }
            name = this.parseIdentifier(isThis);
            if (this.eat(17)) {
              optional = true;
              if (isThis) {
                this.raise(FlowErrors.ThisParamMayNotBeOptional, {
                  at: node
                });
              }
            }
            typeAnnotation = this.flowParseTypeInitialiser();
          } else {
            typeAnnotation = this.flowParseType();
          }
          node.name = name;
          node.optional = optional;
          node.typeAnnotation = typeAnnotation;
          return this.finishNode(node, "FunctionTypeParam");
        }
        reinterpretTypeAsFunctionTypeParam(type) {
          const node = this.startNodeAt(type.loc.start);
          node.name = null;
          node.optional = false;
          node.typeAnnotation = type;
          return this.finishNode(node, "FunctionTypeParam");
        }
        flowParseFunctionTypeParams(params = []) {
          let rest2 = null;
          let _this = null;
          if (this.match(78)) {
            _this = this.flowParseFunctionTypeParam(true);
            _this.name = null;
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          while (!this.match(11) && !this.match(21)) {
            params.push(this.flowParseFunctionTypeParam(false));
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          if (this.eat(21)) {
            rest2 = this.flowParseFunctionTypeParam(false);
          }
          return {
            params,
            rest: rest2,
            _this
          };
        }
        flowIdentToTypeAnnotation(startLoc, node, id) {
          switch (id.name) {
            case "any":
              return this.finishNode(node, "AnyTypeAnnotation");
            case "bool":
            case "boolean":
              return this.finishNode(node, "BooleanTypeAnnotation");
            case "mixed":
              return this.finishNode(node, "MixedTypeAnnotation");
            case "empty":
              return this.finishNode(node, "EmptyTypeAnnotation");
            case "number":
              return this.finishNode(node, "NumberTypeAnnotation");
            case "string":
              return this.finishNode(node, "StringTypeAnnotation");
            case "symbol":
              return this.finishNode(node, "SymbolTypeAnnotation");
            default:
              this.checkNotUnderscore(id.name);
              return this.flowParseGenericType(startLoc, id);
          }
        }
        flowParsePrimaryType() {
          const startLoc = this.state.startLoc;
          const node = this.startNode();
          let tmp;
          let type;
          let isGroupedType = false;
          const oldNoAnonFunctionType = this.state.noAnonFunctionType;
          switch (this.state.type) {
            case 5:
              return this.flowParseObjectType({
                allowStatic: false,
                allowExact: false,
                allowSpread: true,
                allowProto: false,
                allowInexact: true
              });
            case 6:
              return this.flowParseObjectType({
                allowStatic: false,
                allowExact: true,
                allowSpread: true,
                allowProto: false,
                allowInexact: false
              });
            case 0:
              this.state.noAnonFunctionType = false;
              type = this.flowParseTupleType();
              this.state.noAnonFunctionType = oldNoAnonFunctionType;
              return type;
            case 47:
              node.typeParameters = this.flowParseTypeParameterDeclaration();
              this.expect(10);
              tmp = this.flowParseFunctionTypeParams();
              node.params = tmp.params;
              node.rest = tmp.rest;
              node.this = tmp._this;
              this.expect(11);
              this.expect(19);
              node.returnType = this.flowParseType();
              return this.finishNode(node, "FunctionTypeAnnotation");
            case 10:
              this.next();
              if (!this.match(11) && !this.match(21)) {
                if (tokenIsIdentifier(this.state.type) || this.match(78)) {
                  const token = this.lookahead().type;
                  isGroupedType = token !== 17 && token !== 14;
                } else {
                  isGroupedType = true;
                }
              }
              if (isGroupedType) {
                this.state.noAnonFunctionType = false;
                type = this.flowParseType();
                this.state.noAnonFunctionType = oldNoAnonFunctionType;
                if (this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19)) {
                  this.expect(11);
                  return type;
                } else {
                  this.eat(12);
                }
              }
              if (type) {
                tmp = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(type)]);
              } else {
                tmp = this.flowParseFunctionTypeParams();
              }
              node.params = tmp.params;
              node.rest = tmp.rest;
              node.this = tmp._this;
              this.expect(11);
              this.expect(19);
              node.returnType = this.flowParseType();
              node.typeParameters = null;
              return this.finishNode(node, "FunctionTypeAnnotation");
            case 131:
              return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
            case 85:
            case 86:
              node.value = this.match(85);
              this.next();
              return this.finishNode(node, "BooleanLiteralTypeAnnotation");
            case 53:
              if (this.state.value === "-") {
                this.next();
                if (this.match(132)) {
                  return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", node);
                }
                if (this.match(133)) {
                  return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", node);
                }
                throw this.raise(FlowErrors.UnexpectedSubtractionOperand, {
                  at: this.state.startLoc
                });
              }
              throw this.unexpected();
            case 132:
              return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
            case 133:
              return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
            case 88:
              this.next();
              return this.finishNode(node, "VoidTypeAnnotation");
            case 84:
              this.next();
              return this.finishNode(node, "NullLiteralTypeAnnotation");
            case 78:
              this.next();
              return this.finishNode(node, "ThisTypeAnnotation");
            case 55:
              this.next();
              return this.finishNode(node, "ExistsTypeAnnotation");
            case 87:
              return this.flowParseTypeofType();
            default:
              if (tokenIsKeyword(this.state.type)) {
                const label = tokenLabelName(this.state.type);
                this.next();
                return super.createIdentifier(node, label);
              } else if (tokenIsIdentifier(this.state.type)) {
                if (this.isContextual(127)) {
                  return this.flowParseInterfaceType();
                }
                return this.flowIdentToTypeAnnotation(startLoc, node, this.parseIdentifier());
              }
          }
          throw this.unexpected();
        }
        flowParsePostfixType() {
          const startLoc = this.state.startLoc;
          let type = this.flowParsePrimaryType();
          let seenOptionalIndexedAccess = false;
          while ((this.match(0) || this.match(18)) && !this.canInsertSemicolon()) {
            const node = this.startNodeAt(startLoc);
            const optional = this.eat(18);
            seenOptionalIndexedAccess = seenOptionalIndexedAccess || optional;
            this.expect(0);
            if (!optional && this.match(3)) {
              node.elementType = type;
              this.next();
              type = this.finishNode(node, "ArrayTypeAnnotation");
            } else {
              node.objectType = type;
              node.indexType = this.flowParseType();
              this.expect(3);
              if (seenOptionalIndexedAccess) {
                node.optional = optional;
                type = this.finishNode(
                  node,
                  "OptionalIndexedAccessType"
                );
              } else {
                type = this.finishNode(
                  node,
                  "IndexedAccessType"
                );
              }
            }
          }
          return type;
        }
        flowParsePrefixType() {
          const node = this.startNode();
          if (this.eat(17)) {
            node.typeAnnotation = this.flowParsePrefixType();
            return this.finishNode(node, "NullableTypeAnnotation");
          } else {
            return this.flowParsePostfixType();
          }
        }
        flowParseAnonFunctionWithoutParens() {
          const param = this.flowParsePrefixType();
          if (!this.state.noAnonFunctionType && this.eat(19)) {
            const node = this.startNodeAt(param.loc.start);
            node.params = [this.reinterpretTypeAsFunctionTypeParam(param)];
            node.rest = null;
            node.this = null;
            node.returnType = this.flowParseType();
            node.typeParameters = null;
            return this.finishNode(node, "FunctionTypeAnnotation");
          }
          return param;
        }
        flowParseIntersectionType() {
          const node = this.startNode();
          this.eat(45);
          const type = this.flowParseAnonFunctionWithoutParens();
          node.types = [type];
          while (this.eat(45)) {
            node.types.push(this.flowParseAnonFunctionWithoutParens());
          }
          return node.types.length === 1 ? type : this.finishNode(node, "IntersectionTypeAnnotation");
        }
        flowParseUnionType() {
          const node = this.startNode();
          this.eat(43);
          const type = this.flowParseIntersectionType();
          node.types = [type];
          while (this.eat(43)) {
            node.types.push(this.flowParseIntersectionType());
          }
          return node.types.length === 1 ? type : this.finishNode(node, "UnionTypeAnnotation");
        }
        flowParseType() {
          const oldInType = this.state.inType;
          this.state.inType = true;
          const type = this.flowParseUnionType();
          this.state.inType = oldInType;
          return type;
        }
        flowParseTypeOrImplicitInstantiation() {
          if (this.state.type === 130 && this.state.value === "_") {
            const startLoc = this.state.startLoc;
            const node = this.parseIdentifier();
            return this.flowParseGenericType(startLoc, node);
          } else {
            return this.flowParseType();
          }
        }
        flowParseTypeAnnotation() {
          const node = this.startNode();
          node.typeAnnotation = this.flowParseTypeInitialiser();
          return this.finishNode(node, "TypeAnnotation");
        }
        flowParseTypeAnnotatableIdentifier(allowPrimitiveOverride) {
          const ident = allowPrimitiveOverride ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
          if (this.match(14)) {
            ident.typeAnnotation = this.flowParseTypeAnnotation();
            this.resetEndLocation(ident);
          }
          return ident;
        }
        typeCastToParameter(node) {
          node.expression.typeAnnotation = node.typeAnnotation;
          this.resetEndLocation(node.expression, node.typeAnnotation.loc.end);
          return node.expression;
        }
        flowParseVariance() {
          let variance = null;
          if (this.match(53)) {
            variance = this.startNode();
            if (this.state.value === "+") {
              variance.kind = "plus";
            } else {
              variance.kind = "minus";
            }
            this.next();
            return this.finishNode(variance, "Variance");
          }
          return variance;
        }
        parseFunctionBody(node, allowExpressionBody, isMethod = false) {
          if (allowExpressionBody) {
            return this.forwardNoArrowParamsConversionAt(node, () => super.parseFunctionBody(node, true, isMethod));
          }
          return super.parseFunctionBody(node, false, isMethod);
        }
        parseFunctionBodyAndFinish(node, type, isMethod = false) {
          if (this.match(14)) {
            const typeNode = this.startNode();
            [
              typeNode.typeAnnotation,
              node.predicate
            ] = this.flowParseTypeAndPredicateInitialiser();
            node.returnType = typeNode.typeAnnotation ? this.finishNode(typeNode, "TypeAnnotation") : null;
          }
          return super.parseFunctionBodyAndFinish(node, type, isMethod);
        }
        parseStatementLike(flags) {
          if (this.state.strict && this.isContextual(127)) {
            const lookahead = this.lookahead();
            if (tokenIsKeywordOrIdentifier(lookahead.type)) {
              const node = this.startNode();
              this.next();
              return this.flowParseInterface(node);
            }
          } else if (this.shouldParseEnums() && this.isContextual(124)) {
            const node = this.startNode();
            this.next();
            return this.flowParseEnumDeclaration(node);
          }
          const stmt = super.parseStatementLike(flags);
          if (this.flowPragma === void 0 && !this.isValidDirective(stmt)) {
            this.flowPragma = null;
          }
          return stmt;
        }
        parseExpressionStatement(node, expr, decorators) {
          if (expr.type === "Identifier") {
            if (expr.name === "declare") {
              if (this.match(80) || tokenIsIdentifier(this.state.type) || this.match(68) || this.match(74) || this.match(82)) {
                return this.flowParseDeclare(node);
              }
            } else if (tokenIsIdentifier(this.state.type)) {
              if (expr.name === "interface") {
                return this.flowParseInterface(node);
              } else if (expr.name === "type") {
                return this.flowParseTypeAlias(node);
              } else if (expr.name === "opaque") {
                return this.flowParseOpaqueType(node, false);
              }
            }
          }
          return super.parseExpressionStatement(node, expr, decorators);
        }
        shouldParseExportDeclaration() {
          const {
            type
          } = this.state;
          if (tokenIsFlowInterfaceOrTypeOrOpaque(type) || this.shouldParseEnums() && type === 124) {
            return !this.state.containsEsc;
          }
          return super.shouldParseExportDeclaration();
        }
        isExportDefaultSpecifier() {
          const {
            type
          } = this.state;
          if (tokenIsFlowInterfaceOrTypeOrOpaque(type) || this.shouldParseEnums() && type === 124) {
            return this.state.containsEsc;
          }
          return super.isExportDefaultSpecifier();
        }
        parseExportDefaultExpression() {
          if (this.shouldParseEnums() && this.isContextual(124)) {
            const node = this.startNode();
            this.next();
            return this.flowParseEnumDeclaration(node);
          }
          return super.parseExportDefaultExpression();
        }
        parseConditional(expr, startLoc, refExpressionErrors) {
          if (!this.match(17))
            return expr;
          if (this.state.maybeInArrowParameters) {
            const nextCh = this.lookaheadCharCode();
            if (nextCh === 44 || nextCh === 61 || nextCh === 58 || nextCh === 41) {
              this.setOptionalParametersError(refExpressionErrors);
              return expr;
            }
          }
          this.expect(17);
          const state = this.state.clone();
          const originalNoArrowAt = this.state.noArrowAt;
          const node = this.startNodeAt(startLoc);
          let {
            consequent,
            failed
          } = this.tryParseConditionalConsequent();
          let [valid, invalid] = this.getArrowLikeExpressions(consequent);
          if (failed || invalid.length > 0) {
            const noArrowAt = [...originalNoArrowAt];
            if (invalid.length > 0) {
              this.state = state;
              this.state.noArrowAt = noArrowAt;
              for (let i = 0; i < invalid.length; i++) {
                noArrowAt.push(invalid[i].start);
              }
              ({
                consequent,
                failed
              } = this.tryParseConditionalConsequent());
              [valid, invalid] = this.getArrowLikeExpressions(consequent);
            }
            if (failed && valid.length > 1) {
              this.raise(FlowErrors.AmbiguousConditionalArrow, {
                at: state.startLoc
              });
            }
            if (failed && valid.length === 1) {
              this.state = state;
              noArrowAt.push(valid[0].start);
              this.state.noArrowAt = noArrowAt;
              ({
                consequent,
                failed
              } = this.tryParseConditionalConsequent());
            }
          }
          this.getArrowLikeExpressions(consequent, true);
          this.state.noArrowAt = originalNoArrowAt;
          this.expect(14);
          node.test = expr;
          node.consequent = consequent;
          node.alternate = this.forwardNoArrowParamsConversionAt(node, () => this.parseMaybeAssign(void 0, void 0));
          return this.finishNode(node, "ConditionalExpression");
        }
        tryParseConditionalConsequent() {
          this.state.noArrowParamsConversionAt.push(this.state.start);
          const consequent = this.parseMaybeAssignAllowIn();
          const failed = !this.match(14);
          this.state.noArrowParamsConversionAt.pop();
          return {
            consequent,
            failed
          };
        }
        getArrowLikeExpressions(node, disallowInvalid) {
          const stack = [node];
          const arrows = [];
          while (stack.length !== 0) {
            const node2 = stack.pop();
            if (node2.type === "ArrowFunctionExpression") {
              if (node2.typeParameters || !node2.returnType) {
                this.finishArrowValidation(node2);
              } else {
                arrows.push(node2);
              }
              stack.push(node2.body);
            } else if (node2.type === "ConditionalExpression") {
              stack.push(node2.consequent);
              stack.push(node2.alternate);
            }
          }
          if (disallowInvalid) {
            arrows.forEach((node2) => this.finishArrowValidation(node2));
            return [arrows, []];
          }
          return partition2(arrows, (node2) => node2.params.every((param) => this.isAssignable(param, true)));
        }
        finishArrowValidation(node) {
          var _node$extra;
          this.toAssignableList(
            node.params,
            (_node$extra = node.extra) == null ? void 0 : _node$extra.trailingCommaLoc,
            false
          );
          this.scope.enter(SCOPE_FUNCTION | SCOPE_ARROW);
          super.checkParams(node, false, true);
          this.scope.exit();
        }
        forwardNoArrowParamsConversionAt(node, parse4) {
          let result2;
          if (this.state.noArrowParamsConversionAt.indexOf(node.start) !== -1) {
            this.state.noArrowParamsConversionAt.push(this.state.start);
            result2 = parse4();
            this.state.noArrowParamsConversionAt.pop();
          } else {
            result2 = parse4();
          }
          return result2;
        }
        parseParenItem(node, startLoc) {
          node = super.parseParenItem(node, startLoc);
          if (this.eat(17)) {
            node.optional = true;
            this.resetEndLocation(node);
          }
          if (this.match(14)) {
            const typeCastNode = this.startNodeAt(startLoc);
            typeCastNode.expression = node;
            typeCastNode.typeAnnotation = this.flowParseTypeAnnotation();
            return this.finishNode(typeCastNode, "TypeCastExpression");
          }
          return node;
        }
        assertModuleNodeAllowed(node) {
          if (node.type === "ImportDeclaration" && (node.importKind === "type" || node.importKind === "typeof") || node.type === "ExportNamedDeclaration" && node.exportKind === "type" || node.type === "ExportAllDeclaration" && node.exportKind === "type") {
            return;
          }
          super.assertModuleNodeAllowed(node);
        }
        parseExport(node, decorators) {
          const decl = super.parseExport(node, decorators);
          if (decl.type === "ExportNamedDeclaration" || decl.type === "ExportAllDeclaration") {
            decl.exportKind = decl.exportKind || "value";
          }
          return decl;
        }
        parseExportDeclaration(node) {
          if (this.isContextual(128)) {
            node.exportKind = "type";
            const declarationNode = this.startNode();
            this.next();
            if (this.match(5)) {
              node.specifiers = this.parseExportSpecifiers(true);
              super.parseExportFrom(node);
              return null;
            } else {
              return this.flowParseTypeAlias(declarationNode);
            }
          } else if (this.isContextual(129)) {
            node.exportKind = "type";
            const declarationNode = this.startNode();
            this.next();
            return this.flowParseOpaqueType(declarationNode, false);
          } else if (this.isContextual(127)) {
            node.exportKind = "type";
            const declarationNode = this.startNode();
            this.next();
            return this.flowParseInterface(declarationNode);
          } else if (this.shouldParseEnums() && this.isContextual(124)) {
            node.exportKind = "value";
            const declarationNode = this.startNode();
            this.next();
            return this.flowParseEnumDeclaration(declarationNode);
          } else {
            return super.parseExportDeclaration(node);
          }
        }
        eatExportStar(node) {
          if (super.eatExportStar(node))
            return true;
          if (this.isContextual(128) && this.lookahead().type === 55) {
            node.exportKind = "type";
            this.next();
            this.next();
            return true;
          }
          return false;
        }
        maybeParseExportNamespaceSpecifier(node) {
          const {
            startLoc
          } = this.state;
          const hasNamespace = super.maybeParseExportNamespaceSpecifier(node);
          if (hasNamespace && node.exportKind === "type") {
            this.unexpected(startLoc);
          }
          return hasNamespace;
        }
        parseClassId(node, isStatement, optionalId) {
          super.parseClassId(node, isStatement, optionalId);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          }
        }
        parseClassMember(classBody, member, state) {
          const {
            startLoc
          } = this.state;
          if (this.isContextual(123)) {
            if (super.parseClassMemberFromModifier(classBody, member)) {
              return;
            }
            member.declare = true;
          }
          super.parseClassMember(classBody, member, state);
          if (member.declare) {
            if (member.type !== "ClassProperty" && member.type !== "ClassPrivateProperty" && member.type !== "PropertyDefinition") {
              this.raise(FlowErrors.DeclareClassElement, {
                at: startLoc
              });
            } else if (member.value) {
              this.raise(FlowErrors.DeclareClassFieldInitializer, {
                at: member.value
              });
            }
          }
        }
        isIterator(word) {
          return word === "iterator" || word === "asyncIterator";
        }
        readIterator() {
          const word = super.readWord1();
          const fullWord = "@@" + word;
          if (!this.isIterator(word) || !this.state.inType) {
            this.raise(Errors.InvalidIdentifier, {
              at: this.state.curPosition(),
              identifierName: fullWord
            });
          }
          this.finishToken(130, fullWord);
        }
        getTokenFromCode(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (code === 123 && next === 124) {
            return this.finishOp(6, 2);
          } else if (this.state.inType && (code === 62 || code === 60)) {
            return this.finishOp(code === 62 ? 48 : 47, 1);
          } else if (this.state.inType && code === 63) {
            if (next === 46) {
              return this.finishOp(18, 2);
            }
            return this.finishOp(17, 1);
          } else if (isIteratorStart(code, next, this.input.charCodeAt(this.state.pos + 2))) {
            this.state.pos += 2;
            return this.readIterator();
          } else {
            return super.getTokenFromCode(code);
          }
        }
        isAssignable(node, isBinding) {
          if (node.type === "TypeCastExpression") {
            return this.isAssignable(node.expression, isBinding);
          } else {
            return super.isAssignable(node, isBinding);
          }
        }
        toAssignable(node, isLHS = false) {
          if (!isLHS && node.type === "AssignmentExpression" && node.left.type === "TypeCastExpression") {
            node.left = this.typeCastToParameter(node.left);
          }
          super.toAssignable(node, isLHS);
        }
        toAssignableList(exprList, trailingCommaLoc, isLHS) {
          for (let i = 0; i < exprList.length; i++) {
            const expr = exprList[i];
            if ((expr == null ? void 0 : expr.type) === "TypeCastExpression") {
              exprList[i] = this.typeCastToParameter(expr);
            }
          }
          super.toAssignableList(exprList, trailingCommaLoc, isLHS);
        }
        toReferencedList(exprList, isParenthesizedExpr) {
          for (let i = 0; i < exprList.length; i++) {
            var _expr$extra;
            const expr = exprList[i];
            if (expr && expr.type === "TypeCastExpression" && !((_expr$extra = expr.extra) != null && _expr$extra.parenthesized) && (exprList.length > 1 || !isParenthesizedExpr)) {
              this.raise(FlowErrors.TypeCastInPattern, {
                at: expr.typeAnnotation
              });
            }
          }
          return exprList;
        }
        parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
          const node = super.parseArrayLike(close, canBePattern, isTuple, refExpressionErrors);
          if (canBePattern && !this.state.maybeInArrowParameters) {
            this.toReferencedList(node.elements);
          }
          return node;
        }
        isValidLVal(type, isParenthesized, binding) {
          return type === "TypeCastExpression" || super.isValidLVal(type, isParenthesized, binding);
        }
        parseClassProperty(node) {
          if (this.match(14)) {
            node.typeAnnotation = this.flowParseTypeAnnotation();
          }
          return super.parseClassProperty(node);
        }
        parseClassPrivateProperty(node) {
          if (this.match(14)) {
            node.typeAnnotation = this.flowParseTypeAnnotation();
          }
          return super.parseClassPrivateProperty(node);
        }
        isClassMethod() {
          return this.match(47) || super.isClassMethod();
        }
        isClassProperty() {
          return this.match(14) || super.isClassProperty();
        }
        isNonstaticConstructor(method2) {
          return !this.match(14) && super.isNonstaticConstructor(method2);
        }
        pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
          if (method2.variance) {
            this.unexpected(method2.variance.loc.start);
          }
          delete method2.variance;
          if (this.match(47)) {
            method2.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          super.pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper);
          if (method2.params && isConstructor) {
            const params = method2.params;
            if (params.length > 0 && this.isThisParam(params[0])) {
              this.raise(FlowErrors.ThisParamBannedInConstructor, {
                at: method2
              });
            }
          } else if (method2.type === "MethodDefinition" && isConstructor && method2.value.params) {
            const params = method2.value.params;
            if (params.length > 0 && this.isThisParam(params[0])) {
              this.raise(FlowErrors.ThisParamBannedInConstructor, {
                at: method2
              });
            }
          }
        }
        pushClassPrivateMethod(classBody, method2, isGenerator, isAsync) {
          if (method2.variance) {
            this.unexpected(method2.variance.loc.start);
          }
          delete method2.variance;
          if (this.match(47)) {
            method2.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          super.pushClassPrivateMethod(classBody, method2, isGenerator, isAsync);
        }
        parseClassSuper(node) {
          super.parseClassSuper(node);
          if (node.superClass && this.match(47)) {
            node.superTypeParameters = this.flowParseTypeParameterInstantiation();
          }
          if (this.isContextual(111)) {
            this.next();
            const implemented = node.implements = [];
            do {
              const node2 = this.startNode();
              node2.id = this.flowParseRestrictedIdentifier(true);
              if (this.match(47)) {
                node2.typeParameters = this.flowParseTypeParameterInstantiation();
              } else {
                node2.typeParameters = null;
              }
              implemented.push(this.finishNode(node2, "ClassImplements"));
            } while (this.eat(12));
          }
        }
        checkGetterSetterParams(method2) {
          super.checkGetterSetterParams(method2);
          const params = this.getObjectOrClassMethodParams(method2);
          if (params.length > 0) {
            const param = params[0];
            if (this.isThisParam(param) && method2.kind === "get") {
              this.raise(FlowErrors.GetterMayNotHaveThisParam, {
                at: param
              });
            } else if (this.isThisParam(param)) {
              this.raise(FlowErrors.SetterMayNotHaveThisParam, {
                at: param
              });
            }
          }
        }
        parsePropertyNamePrefixOperator(node) {
          node.variance = this.flowParseVariance();
        }
        parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
          if (prop.variance) {
            this.unexpected(prop.variance.loc.start);
          }
          delete prop.variance;
          let typeParameters;
          if (this.match(47) && !isAccessor) {
            typeParameters = this.flowParseTypeParameterDeclaration();
            if (!this.match(10))
              this.unexpected();
          }
          const result2 = super.parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors);
          if (typeParameters) {
            (result2.value || result2).typeParameters = typeParameters;
          }
          return result2;
        }
        parseAssignableListItemTypes(param) {
          if (this.eat(17)) {
            if (param.type !== "Identifier") {
              this.raise(FlowErrors.PatternIsOptional, {
                at: param
              });
            }
            if (this.isThisParam(param)) {
              this.raise(FlowErrors.ThisParamMayNotBeOptional, {
                at: param
              });
            }
            param.optional = true;
          }
          if (this.match(14)) {
            param.typeAnnotation = this.flowParseTypeAnnotation();
          } else if (this.isThisParam(param)) {
            this.raise(FlowErrors.ThisParamAnnotationRequired, {
              at: param
            });
          }
          if (this.match(29) && this.isThisParam(param)) {
            this.raise(FlowErrors.ThisParamNoDefault, {
              at: param
            });
          }
          this.resetEndLocation(param);
          return param;
        }
        parseMaybeDefault(startLoc, left) {
          const node = super.parseMaybeDefault(startLoc, left);
          if (node.type === "AssignmentPattern" && node.typeAnnotation && node.right.start < node.typeAnnotation.start) {
            this.raise(FlowErrors.TypeBeforeInitializer, {
              at: node.typeAnnotation
            });
          }
          return node;
        }
        shouldParseDefaultImport(node) {
          if (!hasTypeImportKind(node)) {
            return super.shouldParseDefaultImport(node);
          }
          return isMaybeDefaultImport(this.state.type);
        }
        checkImportReflection(node) {
          super.checkImportReflection(node);
          if (node.module && node.importKind !== "value") {
            this.raise(FlowErrors.ImportReflectionHasImportType, {
              at: node.specifiers[0].loc.start
            });
          }
        }
        parseImportSpecifierLocal(node, specifier, type) {
          specifier.local = hasTypeImportKind(node) ? this.flowParseRestrictedIdentifier(true, true) : this.parseIdentifier();
          node.specifiers.push(this.finishImportSpecifier(specifier, type));
        }
        maybeParseDefaultImportSpecifier(node) {
          node.importKind = "value";
          let kind = null;
          if (this.match(87)) {
            kind = "typeof";
          } else if (this.isContextual(128)) {
            kind = "type";
          }
          if (kind) {
            const lh = this.lookahead();
            const {
              type
            } = lh;
            if (kind === "type" && type === 55) {
              this.unexpected(null, lh.type);
            }
            if (isMaybeDefaultImport(type) || type === 5 || type === 55) {
              this.next();
              node.importKind = kind;
            }
          }
          return super.maybeParseDefaultImportSpecifier(node);
        }
        parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
          const firstIdent = specifier.imported;
          let specifierTypeKind = null;
          if (firstIdent.type === "Identifier") {
            if (firstIdent.name === "type") {
              specifierTypeKind = "type";
            } else if (firstIdent.name === "typeof") {
              specifierTypeKind = "typeof";
            }
          }
          let isBinding = false;
          if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
            const as_ident = this.parseIdentifier(true);
            if (specifierTypeKind !== null && !tokenIsKeywordOrIdentifier(this.state.type)) {
              specifier.imported = as_ident;
              specifier.importKind = specifierTypeKind;
              specifier.local = cloneIdentifier(as_ident);
            } else {
              specifier.imported = firstIdent;
              specifier.importKind = null;
              specifier.local = this.parseIdentifier();
            }
          } else {
            if (specifierTypeKind !== null && tokenIsKeywordOrIdentifier(this.state.type)) {
              specifier.imported = this.parseIdentifier(true);
              specifier.importKind = specifierTypeKind;
            } else {
              if (importedIsString) {
                throw this.raise(Errors.ImportBindingIsString, {
                  at: specifier,
                  importName: firstIdent.value
                });
              }
              specifier.imported = firstIdent;
              specifier.importKind = null;
            }
            if (this.eatContextual(93)) {
              specifier.local = this.parseIdentifier();
            } else {
              isBinding = true;
              specifier.local = cloneIdentifier(specifier.imported);
            }
          }
          const specifierIsTypeImport = hasTypeImportKind(specifier);
          if (isInTypeOnlyImport && specifierIsTypeImport) {
            this.raise(FlowErrors.ImportTypeShorthandOnlyInPureImport, {
              at: specifier
            });
          }
          if (isInTypeOnlyImport || specifierIsTypeImport) {
            this.checkReservedType(specifier.local.name, specifier.local.loc.start, true);
          }
          if (isBinding && !isInTypeOnlyImport && !specifierIsTypeImport) {
            this.checkReservedWord(specifier.local.name, specifier.loc.start, true, true);
          }
          return this.finishImportSpecifier(specifier, "ImportSpecifier");
        }
        parseBindingAtom() {
          switch (this.state.type) {
            case 78:
              return this.parseIdentifier(true);
            default:
              return super.parseBindingAtom();
          }
        }
        parseFunctionParams(node, allowModifiers) {
          const kind = node.kind;
          if (kind !== "get" && kind !== "set" && this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          super.parseFunctionParams(node, allowModifiers);
        }
        parseVarId(decl, kind) {
          super.parseVarId(decl, kind);
          if (this.match(14)) {
            decl.id.typeAnnotation = this.flowParseTypeAnnotation();
            this.resetEndLocation(decl.id);
          }
        }
        parseAsyncArrowFromCallExpression(node, call) {
          if (this.match(14)) {
            const oldNoAnonFunctionType = this.state.noAnonFunctionType;
            this.state.noAnonFunctionType = true;
            node.returnType = this.flowParseTypeAnnotation();
            this.state.noAnonFunctionType = oldNoAnonFunctionType;
          }
          return super.parseAsyncArrowFromCallExpression(node, call);
        }
        shouldParseAsyncArrow() {
          return this.match(14) || super.shouldParseAsyncArrow();
        }
        parseMaybeAssign(refExpressionErrors, afterLeftParse) {
          var _jsx;
          let state = null;
          let jsx2;
          if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
            state = this.state.clone();
            jsx2 = this.tryParse(() => super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
            if (!jsx2.error)
              return jsx2.node;
            const {
              context
            } = this.state;
            const currentContext = context[context.length - 1];
            if (currentContext === types.j_oTag || currentContext === types.j_expr) {
              context.pop();
            }
          }
          if ((_jsx = jsx2) != null && _jsx.error || this.match(47)) {
            var _jsx2, _jsx3;
            state = state || this.state.clone();
            let typeParameters;
            const arrow = this.tryParse((abort) => {
              var _arrowExpression$extr;
              typeParameters = this.flowParseTypeParameterDeclaration();
              const arrowExpression2 = this.forwardNoArrowParamsConversionAt(typeParameters, () => {
                const result2 = super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
                this.resetStartLocationFromNode(result2, typeParameters);
                return result2;
              });
              if ((_arrowExpression$extr = arrowExpression2.extra) != null && _arrowExpression$extr.parenthesized)
                abort();
              const expr = this.maybeUnwrapTypeCastExpression(arrowExpression2);
              if (expr.type !== "ArrowFunctionExpression")
                abort();
              expr.typeParameters = typeParameters;
              this.resetStartLocationFromNode(expr, typeParameters);
              return arrowExpression2;
            }, state);
            let arrowExpression = null;
            if (arrow.node && this.maybeUnwrapTypeCastExpression(arrow.node).type === "ArrowFunctionExpression") {
              if (!arrow.error && !arrow.aborted) {
                if (arrow.node.async) {
                  this.raise(FlowErrors.UnexpectedTypeParameterBeforeAsyncArrowFunction, {
                    at: typeParameters
                  });
                }
                return arrow.node;
              }
              arrowExpression = arrow.node;
            }
            if ((_jsx2 = jsx2) != null && _jsx2.node) {
              this.state = jsx2.failState;
              return jsx2.node;
            }
            if (arrowExpression) {
              this.state = arrow.failState;
              return arrowExpression;
            }
            if ((_jsx3 = jsx2) != null && _jsx3.thrown)
              throw jsx2.error;
            if (arrow.thrown)
              throw arrow.error;
            throw this.raise(FlowErrors.UnexpectedTokenAfterTypeParameter, {
              at: typeParameters
            });
          }
          return super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
        }
        parseArrow(node) {
          if (this.match(14)) {
            const result2 = this.tryParse(() => {
              const oldNoAnonFunctionType = this.state.noAnonFunctionType;
              this.state.noAnonFunctionType = true;
              const typeNode = this.startNode();
              [
                typeNode.typeAnnotation,
                node.predicate
              ] = this.flowParseTypeAndPredicateInitialiser();
              this.state.noAnonFunctionType = oldNoAnonFunctionType;
              if (this.canInsertSemicolon())
                this.unexpected();
              if (!this.match(19))
                this.unexpected();
              return typeNode;
            });
            if (result2.thrown)
              return null;
            if (result2.error)
              this.state = result2.failState;
            node.returnType = result2.node.typeAnnotation ? this.finishNode(result2.node, "TypeAnnotation") : null;
          }
          return super.parseArrow(node);
        }
        shouldParseArrow(params) {
          return this.match(14) || super.shouldParseArrow(params);
        }
        setArrowFunctionParameters(node, params) {
          if (this.state.noArrowParamsConversionAt.indexOf(node.start) !== -1) {
            node.params = params;
          } else {
            super.setArrowFunctionParameters(node, params);
          }
        }
        checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged = true) {
          if (isArrowFunction && this.state.noArrowParamsConversionAt.indexOf(node.start) !== -1) {
            return;
          }
          for (let i = 0; i < node.params.length; i++) {
            if (this.isThisParam(node.params[i]) && i > 0) {
              this.raise(FlowErrors.ThisParamMustBeFirst, {
                at: node.params[i]
              });
            }
          }
          return super.checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged);
        }
        parseParenAndDistinguishExpression(canBeArrow) {
          return super.parseParenAndDistinguishExpression(canBeArrow && this.state.noArrowAt.indexOf(this.state.start) === -1);
        }
        parseSubscripts(base, startLoc, noCalls) {
          if (base.type === "Identifier" && base.name === "async" && this.state.noArrowAt.indexOf(startLoc.index) !== -1) {
            this.next();
            const node = this.startNodeAt(startLoc);
            node.callee = base;
            node.arguments = super.parseCallExpressionArguments(11, false);
            base = this.finishNode(node, "CallExpression");
          } else if (base.type === "Identifier" && base.name === "async" && this.match(47)) {
            const state = this.state.clone();
            const arrow = this.tryParse((abort) => this.parseAsyncArrowWithTypeParameters(startLoc) || abort(), state);
            if (!arrow.error && !arrow.aborted)
              return arrow.node;
            const result2 = this.tryParse(() => super.parseSubscripts(base, startLoc, noCalls), state);
            if (result2.node && !result2.error)
              return result2.node;
            if (arrow.node) {
              this.state = arrow.failState;
              return arrow.node;
            }
            if (result2.node) {
              this.state = result2.failState;
              return result2.node;
            }
            throw arrow.error || result2.error;
          }
          return super.parseSubscripts(base, startLoc, noCalls);
        }
        parseSubscript(base, startLoc, noCalls, subscriptState) {
          if (this.match(18) && this.isLookaheadToken_lt()) {
            subscriptState.optionalChainMember = true;
            if (noCalls) {
              subscriptState.stop = true;
              return base;
            }
            this.next();
            const node = this.startNodeAt(startLoc);
            node.callee = base;
            node.typeArguments = this.flowParseTypeParameterInstantiation();
            this.expect(10);
            node.arguments = this.parseCallExpressionArguments(11, false);
            node.optional = true;
            return this.finishCallExpression(node, true);
          } else if (!noCalls && this.shouldParseTypes() && this.match(47)) {
            const node = this.startNodeAt(startLoc);
            node.callee = base;
            const result2 = this.tryParse(() => {
              node.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew();
              this.expect(10);
              node.arguments = super.parseCallExpressionArguments(11, false);
              if (subscriptState.optionalChainMember) {
                node.optional = false;
              }
              return this.finishCallExpression(node, subscriptState.optionalChainMember);
            });
            if (result2.node) {
              if (result2.error)
                this.state = result2.failState;
              return result2.node;
            }
          }
          return super.parseSubscript(base, startLoc, noCalls, subscriptState);
        }
        parseNewCallee(node) {
          super.parseNewCallee(node);
          let targs = null;
          if (this.shouldParseTypes() && this.match(47)) {
            targs = this.tryParse(() => this.flowParseTypeParameterInstantiationCallOrNew()).node;
          }
          node.typeArguments = targs;
        }
        parseAsyncArrowWithTypeParameters(startLoc) {
          const node = this.startNodeAt(startLoc);
          this.parseFunctionParams(node);
          if (!this.parseArrow(node))
            return;
          return super.parseArrowExpression(node, void 0, true);
        }
        readToken_mult_modulo(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (code === 42 && next === 47 && this.state.hasFlowComment) {
            this.state.hasFlowComment = false;
            this.state.pos += 2;
            this.nextToken();
            return;
          }
          super.readToken_mult_modulo(code);
        }
        readToken_pipe_amp(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (code === 124 && next === 125) {
            this.finishOp(9, 2);
            return;
          }
          super.readToken_pipe_amp(code);
        }
        parseTopLevel(file2, program3) {
          const fileNode = super.parseTopLevel(file2, program3);
          if (this.state.hasFlowComment) {
            this.raise(FlowErrors.UnterminatedFlowComment, {
              at: this.state.curPosition()
            });
          }
          return fileNode;
        }
        skipBlockComment() {
          if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
            if (this.state.hasFlowComment) {
              throw this.raise(FlowErrors.NestedFlowComment, {
                at: this.state.startLoc
              });
            }
            this.hasFlowCommentCompletion();
            const commentSkip = this.skipFlowComment();
            if (commentSkip) {
              this.state.pos += commentSkip;
              this.state.hasFlowComment = true;
            }
            return;
          }
          return super.skipBlockComment(this.state.hasFlowComment ? "*-/" : "*/");
        }
        skipFlowComment() {
          const {
            pos
          } = this.state;
          let shiftToFirstNonWhiteSpace = 2;
          while ([32, 9].includes(
            this.input.charCodeAt(pos + shiftToFirstNonWhiteSpace)
          )) {
            shiftToFirstNonWhiteSpace++;
          }
          const ch2 = this.input.charCodeAt(shiftToFirstNonWhiteSpace + pos);
          const ch3 = this.input.charCodeAt(shiftToFirstNonWhiteSpace + pos + 1);
          if (ch2 === 58 && ch3 === 58) {
            return shiftToFirstNonWhiteSpace + 2;
          }
          if (this.input.slice(shiftToFirstNonWhiteSpace + pos, shiftToFirstNonWhiteSpace + pos + 12) === "flow-include") {
            return shiftToFirstNonWhiteSpace + 12;
          }
          if (ch2 === 58 && ch3 !== 58) {
            return shiftToFirstNonWhiteSpace;
          }
          return false;
        }
        hasFlowCommentCompletion() {
          const end = this.input.indexOf("*/", this.state.pos);
          if (end === -1) {
            throw this.raise(Errors.UnterminatedComment, {
              at: this.state.curPosition()
            });
          }
        }
        flowEnumErrorBooleanMemberNotInitialized(loc, {
          enumName,
          memberName
        }) {
          this.raise(FlowErrors.EnumBooleanMemberNotInitialized, {
            at: loc,
            memberName,
            enumName
          });
        }
        flowEnumErrorInvalidMemberInitializer(loc, enumContext) {
          return this.raise(!enumContext.explicitType ? FlowErrors.EnumInvalidMemberInitializerUnknownType : enumContext.explicitType === "symbol" ? FlowErrors.EnumInvalidMemberInitializerSymbolType : FlowErrors.EnumInvalidMemberInitializerPrimaryType, Object.assign({
            at: loc
          }, enumContext));
        }
        flowEnumErrorNumberMemberNotInitialized(loc, {
          enumName,
          memberName
        }) {
          this.raise(FlowErrors.EnumNumberMemberNotInitialized, {
            at: loc,
            enumName,
            memberName
          });
        }
        flowEnumErrorStringMemberInconsistentlyInitailized(node, {
          enumName
        }) {
          this.raise(FlowErrors.EnumStringMemberInconsistentlyInitailized, {
            at: node,
            enumName
          });
        }
        flowEnumMemberInit() {
          const startLoc = this.state.startLoc;
          const endOfInit = () => this.match(12) || this.match(8);
          switch (this.state.type) {
            case 132: {
              const literal = this.parseNumericLiteral(this.state.value);
              if (endOfInit()) {
                return {
                  type: "number",
                  loc: literal.loc.start,
                  value: literal
                };
              }
              return {
                type: "invalid",
                loc: startLoc
              };
            }
            case 131: {
              const literal = this.parseStringLiteral(this.state.value);
              if (endOfInit()) {
                return {
                  type: "string",
                  loc: literal.loc.start,
                  value: literal
                };
              }
              return {
                type: "invalid",
                loc: startLoc
              };
            }
            case 85:
            case 86: {
              const literal = this.parseBooleanLiteral(this.match(85));
              if (endOfInit()) {
                return {
                  type: "boolean",
                  loc: literal.loc.start,
                  value: literal
                };
              }
              return {
                type: "invalid",
                loc: startLoc
              };
            }
            default:
              return {
                type: "invalid",
                loc: startLoc
              };
          }
        }
        flowEnumMemberRaw() {
          const loc = this.state.startLoc;
          const id = this.parseIdentifier(true);
          const init = this.eat(29) ? this.flowEnumMemberInit() : {
            type: "none",
            loc
          };
          return {
            id,
            init
          };
        }
        flowEnumCheckExplicitTypeMismatch(loc, context, expectedType) {
          const {
            explicitType
          } = context;
          if (explicitType === null) {
            return;
          }
          if (explicitType !== expectedType) {
            this.flowEnumErrorInvalidMemberInitializer(loc, context);
          }
        }
        flowEnumMembers({
          enumName,
          explicitType
        }) {
          const seenNames = /* @__PURE__ */ new Set();
          const members = {
            booleanMembers: [],
            numberMembers: [],
            stringMembers: [],
            defaultedMembers: []
          };
          let hasUnknownMembers = false;
          while (!this.match(8)) {
            if (this.eat(21)) {
              hasUnknownMembers = true;
              break;
            }
            const memberNode = this.startNode();
            const {
              id,
              init
            } = this.flowEnumMemberRaw();
            const memberName = id.name;
            if (memberName === "") {
              continue;
            }
            if (/^[a-z]/.test(memberName)) {
              this.raise(FlowErrors.EnumInvalidMemberName, {
                at: id,
                memberName,
                suggestion: memberName[0].toUpperCase() + memberName.slice(1),
                enumName
              });
            }
            if (seenNames.has(memberName)) {
              this.raise(FlowErrors.EnumDuplicateMemberName, {
                at: id,
                memberName,
                enumName
              });
            }
            seenNames.add(memberName);
            const context = {
              enumName,
              explicitType,
              memberName
            };
            memberNode.id = id;
            switch (init.type) {
              case "boolean": {
                this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "boolean");
                memberNode.init = init.value;
                members.booleanMembers.push(this.finishNode(memberNode, "EnumBooleanMember"));
                break;
              }
              case "number": {
                this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "number");
                memberNode.init = init.value;
                members.numberMembers.push(this.finishNode(memberNode, "EnumNumberMember"));
                break;
              }
              case "string": {
                this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "string");
                memberNode.init = init.value;
                members.stringMembers.push(this.finishNode(memberNode, "EnumStringMember"));
                break;
              }
              case "invalid": {
                throw this.flowEnumErrorInvalidMemberInitializer(init.loc, context);
              }
              case "none": {
                switch (explicitType) {
                  case "boolean":
                    this.flowEnumErrorBooleanMemberNotInitialized(init.loc, context);
                    break;
                  case "number":
                    this.flowEnumErrorNumberMemberNotInitialized(init.loc, context);
                    break;
                  default:
                    members.defaultedMembers.push(this.finishNode(memberNode, "EnumDefaultedMember"));
                }
              }
            }
            if (!this.match(8)) {
              this.expect(12);
            }
          }
          return {
            members,
            hasUnknownMembers
          };
        }
        flowEnumStringMembers(initializedMembers, defaultedMembers, {
          enumName
        }) {
          if (initializedMembers.length === 0) {
            return defaultedMembers;
          } else if (defaultedMembers.length === 0) {
            return initializedMembers;
          } else if (defaultedMembers.length > initializedMembers.length) {
            for (const member of initializedMembers) {
              this.flowEnumErrorStringMemberInconsistentlyInitailized(member, {
                enumName
              });
            }
            return defaultedMembers;
          } else {
            for (const member of defaultedMembers) {
              this.flowEnumErrorStringMemberInconsistentlyInitailized(member, {
                enumName
              });
            }
            return initializedMembers;
          }
        }
        flowEnumParseExplicitType({
          enumName
        }) {
          if (!this.eatContextual(101))
            return null;
          if (!tokenIsIdentifier(this.state.type)) {
            throw this.raise(FlowErrors.EnumInvalidExplicitTypeUnknownSupplied, {
              at: this.state.startLoc,
              enumName
            });
          }
          const {
            value
          } = this.state;
          this.next();
          if (value !== "boolean" && value !== "number" && value !== "string" && value !== "symbol") {
            this.raise(FlowErrors.EnumInvalidExplicitType, {
              at: this.state.startLoc,
              enumName,
              invalidEnumType: value
            });
          }
          return value;
        }
        flowEnumBody(node, id) {
          const enumName = id.name;
          const nameLoc = id.loc.start;
          const explicitType = this.flowEnumParseExplicitType({
            enumName
          });
          this.expect(5);
          const {
            members,
            hasUnknownMembers
          } = this.flowEnumMembers({
            enumName,
            explicitType
          });
          node.hasUnknownMembers = hasUnknownMembers;
          switch (explicitType) {
            case "boolean":
              node.explicitType = true;
              node.members = members.booleanMembers;
              this.expect(8);
              return this.finishNode(node, "EnumBooleanBody");
            case "number":
              node.explicitType = true;
              node.members = members.numberMembers;
              this.expect(8);
              return this.finishNode(node, "EnumNumberBody");
            case "string":
              node.explicitType = true;
              node.members = this.flowEnumStringMembers(members.stringMembers, members.defaultedMembers, {
                enumName
              });
              this.expect(8);
              return this.finishNode(node, "EnumStringBody");
            case "symbol":
              node.members = members.defaultedMembers;
              this.expect(8);
              return this.finishNode(node, "EnumSymbolBody");
            default: {
              const empty = () => {
                node.members = [];
                this.expect(8);
                return this.finishNode(node, "EnumStringBody");
              };
              node.explicitType = false;
              const boolsLen = members.booleanMembers.length;
              const numsLen = members.numberMembers.length;
              const strsLen = members.stringMembers.length;
              const defaultedLen = members.defaultedMembers.length;
              if (!boolsLen && !numsLen && !strsLen && !defaultedLen) {
                return empty();
              } else if (!boolsLen && !numsLen) {
                node.members = this.flowEnumStringMembers(members.stringMembers, members.defaultedMembers, {
                  enumName
                });
                this.expect(8);
                return this.finishNode(node, "EnumStringBody");
              } else if (!numsLen && !strsLen && boolsLen >= defaultedLen) {
                for (const member of members.defaultedMembers) {
                  this.flowEnumErrorBooleanMemberNotInitialized(member.loc.start, {
                    enumName,
                    memberName: member.id.name
                  });
                }
                node.members = members.booleanMembers;
                this.expect(8);
                return this.finishNode(node, "EnumBooleanBody");
              } else if (!boolsLen && !strsLen && numsLen >= defaultedLen) {
                for (const member of members.defaultedMembers) {
                  this.flowEnumErrorNumberMemberNotInitialized(member.loc.start, {
                    enumName,
                    memberName: member.id.name
                  });
                }
                node.members = members.numberMembers;
                this.expect(8);
                return this.finishNode(node, "EnumNumberBody");
              } else {
                this.raise(FlowErrors.EnumInconsistentMemberValues, {
                  at: nameLoc,
                  enumName
                });
                return empty();
              }
            }
          }
        }
        flowParseEnumDeclaration(node) {
          const id = this.parseIdentifier();
          node.id = id;
          node.body = this.flowEnumBody(this.startNode(), id);
          return this.finishNode(node, "EnumDeclaration");
        }
        isLookaheadToken_lt() {
          const next = this.nextTokenStart();
          if (this.input.charCodeAt(next) === 60) {
            const afterNext = this.input.charCodeAt(next + 1);
            return afterNext !== 60 && afterNext !== 61;
          }
          return false;
        }
        maybeUnwrapTypeCastExpression(node) {
          return node.type === "TypeCastExpression" ? node.expression : node;
        }
      };
      var entities = {
        __proto__: null,
        quot: '"',
        amp: "&",
        apos: "'",
        lt: "<",
        gt: ">",
        nbsp: "\xA0",
        iexcl: "\xA1",
        cent: "\xA2",
        pound: "\xA3",
        curren: "\xA4",
        yen: "\xA5",
        brvbar: "\xA6",
        sect: "\xA7",
        uml: "\xA8",
        copy: "\xA9",
        ordf: "\xAA",
        laquo: "\xAB",
        not: "\xAC",
        shy: "\xAD",
        reg: "\xAE",
        macr: "\xAF",
        deg: "\xB0",
        plusmn: "\xB1",
        sup2: "\xB2",
        sup3: "\xB3",
        acute: "\xB4",
        micro: "\xB5",
        para: "\xB6",
        middot: "\xB7",
        cedil: "\xB8",
        sup1: "\xB9",
        ordm: "\xBA",
        raquo: "\xBB",
        frac14: "\xBC",
        frac12: "\xBD",
        frac34: "\xBE",
        iquest: "\xBF",
        Agrave: "\xC0",
        Aacute: "\xC1",
        Acirc: "\xC2",
        Atilde: "\xC3",
        Auml: "\xC4",
        Aring: "\xC5",
        AElig: "\xC6",
        Ccedil: "\xC7",
        Egrave: "\xC8",
        Eacute: "\xC9",
        Ecirc: "\xCA",
        Euml: "\xCB",
        Igrave: "\xCC",
        Iacute: "\xCD",
        Icirc: "\xCE",
        Iuml: "\xCF",
        ETH: "\xD0",
        Ntilde: "\xD1",
        Ograve: "\xD2",
        Oacute: "\xD3",
        Ocirc: "\xD4",
        Otilde: "\xD5",
        Ouml: "\xD6",
        times: "\xD7",
        Oslash: "\xD8",
        Ugrave: "\xD9",
        Uacute: "\xDA",
        Ucirc: "\xDB",
        Uuml: "\xDC",
        Yacute: "\xDD",
        THORN: "\xDE",
        szlig: "\xDF",
        agrave: "\xE0",
        aacute: "\xE1",
        acirc: "\xE2",
        atilde: "\xE3",
        auml: "\xE4",
        aring: "\xE5",
        aelig: "\xE6",
        ccedil: "\xE7",
        egrave: "\xE8",
        eacute: "\xE9",
        ecirc: "\xEA",
        euml: "\xEB",
        igrave: "\xEC",
        iacute: "\xED",
        icirc: "\xEE",
        iuml: "\xEF",
        eth: "\xF0",
        ntilde: "\xF1",
        ograve: "\xF2",
        oacute: "\xF3",
        ocirc: "\xF4",
        otilde: "\xF5",
        ouml: "\xF6",
        divide: "\xF7",
        oslash: "\xF8",
        ugrave: "\xF9",
        uacute: "\xFA",
        ucirc: "\xFB",
        uuml: "\xFC",
        yacute: "\xFD",
        thorn: "\xFE",
        yuml: "\xFF",
        OElig: "\u0152",
        oelig: "\u0153",
        Scaron: "\u0160",
        scaron: "\u0161",
        Yuml: "\u0178",
        fnof: "\u0192",
        circ: "\u02C6",
        tilde: "\u02DC",
        Alpha: "\u0391",
        Beta: "\u0392",
        Gamma: "\u0393",
        Delta: "\u0394",
        Epsilon: "\u0395",
        Zeta: "\u0396",
        Eta: "\u0397",
        Theta: "\u0398",
        Iota: "\u0399",
        Kappa: "\u039A",
        Lambda: "\u039B",
        Mu: "\u039C",
        Nu: "\u039D",
        Xi: "\u039E",
        Omicron: "\u039F",
        Pi: "\u03A0",
        Rho: "\u03A1",
        Sigma: "\u03A3",
        Tau: "\u03A4",
        Upsilon: "\u03A5",
        Phi: "\u03A6",
        Chi: "\u03A7",
        Psi: "\u03A8",
        Omega: "\u03A9",
        alpha: "\u03B1",
        beta: "\u03B2",
        gamma: "\u03B3",
        delta: "\u03B4",
        epsilon: "\u03B5",
        zeta: "\u03B6",
        eta: "\u03B7",
        theta: "\u03B8",
        iota: "\u03B9",
        kappa: "\u03BA",
        lambda: "\u03BB",
        mu: "\u03BC",
        nu: "\u03BD",
        xi: "\u03BE",
        omicron: "\u03BF",
        pi: "\u03C0",
        rho: "\u03C1",
        sigmaf: "\u03C2",
        sigma: "\u03C3",
        tau: "\u03C4",
        upsilon: "\u03C5",
        phi: "\u03C6",
        chi: "\u03C7",
        psi: "\u03C8",
        omega: "\u03C9",
        thetasym: "\u03D1",
        upsih: "\u03D2",
        piv: "\u03D6",
        ensp: "\u2002",
        emsp: "\u2003",
        thinsp: "\u2009",
        zwnj: "\u200C",
        zwj: "\u200D",
        lrm: "\u200E",
        rlm: "\u200F",
        ndash: "\u2013",
        mdash: "\u2014",
        lsquo: "\u2018",
        rsquo: "\u2019",
        sbquo: "\u201A",
        ldquo: "\u201C",
        rdquo: "\u201D",
        bdquo: "\u201E",
        dagger: "\u2020",
        Dagger: "\u2021",
        bull: "\u2022",
        hellip: "\u2026",
        permil: "\u2030",
        prime: "\u2032",
        Prime: "\u2033",
        lsaquo: "\u2039",
        rsaquo: "\u203A",
        oline: "\u203E",
        frasl: "\u2044",
        euro: "\u20AC",
        image: "\u2111",
        weierp: "\u2118",
        real: "\u211C",
        trade: "\u2122",
        alefsym: "\u2135",
        larr: "\u2190",
        uarr: "\u2191",
        rarr: "\u2192",
        darr: "\u2193",
        harr: "\u2194",
        crarr: "\u21B5",
        lArr: "\u21D0",
        uArr: "\u21D1",
        rArr: "\u21D2",
        dArr: "\u21D3",
        hArr: "\u21D4",
        forall: "\u2200",
        part: "\u2202",
        exist: "\u2203",
        empty: "\u2205",
        nabla: "\u2207",
        isin: "\u2208",
        notin: "\u2209",
        ni: "\u220B",
        prod: "\u220F",
        sum: "\u2211",
        minus: "\u2212",
        lowast: "\u2217",
        radic: "\u221A",
        prop: "\u221D",
        infin: "\u221E",
        ang: "\u2220",
        and: "\u2227",
        or: "\u2228",
        cap: "\u2229",
        cup: "\u222A",
        int: "\u222B",
        there4: "\u2234",
        sim: "\u223C",
        cong: "\u2245",
        asymp: "\u2248",
        ne: "\u2260",
        equiv: "\u2261",
        le: "\u2264",
        ge: "\u2265",
        sub: "\u2282",
        sup: "\u2283",
        nsub: "\u2284",
        sube: "\u2286",
        supe: "\u2287",
        oplus: "\u2295",
        otimes: "\u2297",
        perp: "\u22A5",
        sdot: "\u22C5",
        lceil: "\u2308",
        rceil: "\u2309",
        lfloor: "\u230A",
        rfloor: "\u230B",
        lang: "\u2329",
        rang: "\u232A",
        loz: "\u25CA",
        spades: "\u2660",
        clubs: "\u2663",
        hearts: "\u2665",
        diams: "\u2666"
      };
      var JsxErrors = ParseErrorEnum`jsx`({
        AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression.",
        MissingClosingTagElement: ({
          openingTagName
        }) => `Expected corresponding JSX closing tag for <${openingTagName}>.`,
        MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>.",
        UnexpectedSequenceExpression: "Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?",
        UnexpectedToken: ({
          unexpected,
          HTMLEntity
        }) => `Unexpected token \`${unexpected}\`. Did you mean \`${HTMLEntity}\` or \`{'${unexpected}'}\`?`,
        UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text.",
        UnterminatedJsxContent: "Unterminated JSX contents.",
        UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?"
      });
      function isFragment(object) {
        return object ? object.type === "JSXOpeningFragment" || object.type === "JSXClosingFragment" : false;
      }
      function getQualifiedJSXName(object) {
        if (object.type === "JSXIdentifier") {
          return object.name;
        }
        if (object.type === "JSXNamespacedName") {
          return object.namespace.name + ":" + object.name.name;
        }
        if (object.type === "JSXMemberExpression") {
          return getQualifiedJSXName(object.object) + "." + getQualifiedJSXName(object.property);
        }
        throw new Error("Node had unexpected type: " + object.type);
      }
      var jsx = (superClass) => class JSXParserMixin extends superClass {
        jsxReadToken() {
          let out = "";
          let chunkStart = this.state.pos;
          for (; ; ) {
            if (this.state.pos >= this.length) {
              throw this.raise(JsxErrors.UnterminatedJsxContent, {
                at: this.state.startLoc
              });
            }
            const ch = this.input.charCodeAt(this.state.pos);
            switch (ch) {
              case 60:
              case 123:
                if (this.state.pos === this.state.start) {
                  if (ch === 60 && this.state.canStartJSXElement) {
                    ++this.state.pos;
                    return this.finishToken(140);
                  }
                  return super.getTokenFromCode(ch);
                }
                out += this.input.slice(chunkStart, this.state.pos);
                return this.finishToken(139, out);
              case 38:
                out += this.input.slice(chunkStart, this.state.pos);
                out += this.jsxReadEntity();
                chunkStart = this.state.pos;
                break;
              case 62:
              case 125:
              default:
                if (isNewLine(ch)) {
                  out += this.input.slice(chunkStart, this.state.pos);
                  out += this.jsxReadNewLine(true);
                  chunkStart = this.state.pos;
                } else {
                  ++this.state.pos;
                }
            }
          }
        }
        jsxReadNewLine(normalizeCRLF) {
          const ch = this.input.charCodeAt(this.state.pos);
          let out;
          ++this.state.pos;
          if (ch === 13 && this.input.charCodeAt(this.state.pos) === 10) {
            ++this.state.pos;
            out = normalizeCRLF ? "\n" : "\r\n";
          } else {
            out = String.fromCharCode(ch);
          }
          ++this.state.curLine;
          this.state.lineStart = this.state.pos;
          return out;
        }
        jsxReadString(quote) {
          let out = "";
          let chunkStart = ++this.state.pos;
          for (; ; ) {
            if (this.state.pos >= this.length) {
              throw this.raise(Errors.UnterminatedString, {
                at: this.state.startLoc
              });
            }
            const ch = this.input.charCodeAt(this.state.pos);
            if (ch === quote)
              break;
            if (ch === 38) {
              out += this.input.slice(chunkStart, this.state.pos);
              out += this.jsxReadEntity();
              chunkStart = this.state.pos;
            } else if (isNewLine(ch)) {
              out += this.input.slice(chunkStart, this.state.pos);
              out += this.jsxReadNewLine(false);
              chunkStart = this.state.pos;
            } else {
              ++this.state.pos;
            }
          }
          out += this.input.slice(chunkStart, this.state.pos++);
          return this.finishToken(131, out);
        }
        jsxReadEntity() {
          const startPos = ++this.state.pos;
          if (this.codePointAtPos(this.state.pos) === 35) {
            ++this.state.pos;
            let radix = 10;
            if (this.codePointAtPos(this.state.pos) === 120) {
              radix = 16;
              ++this.state.pos;
            }
            const codePoint = this.readInt(radix, void 0, false, "bail");
            if (codePoint !== null && this.codePointAtPos(this.state.pos) === 59) {
              ++this.state.pos;
              return String.fromCodePoint(codePoint);
            }
          } else {
            let count = 0;
            let semi = false;
            while (count++ < 10 && this.state.pos < this.length && !(semi = this.codePointAtPos(this.state.pos) == 59)) {
              ++this.state.pos;
            }
            if (semi) {
              const desc = this.input.slice(startPos, this.state.pos);
              const entity = entities[desc];
              ++this.state.pos;
              if (entity) {
                return entity;
              }
            }
          }
          this.state.pos = startPos;
          return "&";
        }
        jsxReadWord() {
          let ch;
          const start = this.state.pos;
          do {
            ch = this.input.charCodeAt(++this.state.pos);
          } while (isIdentifierChar(ch) || ch === 45);
          return this.finishToken(138, this.input.slice(start, this.state.pos));
        }
        jsxParseIdentifier() {
          const node = this.startNode();
          if (this.match(138)) {
            node.name = this.state.value;
          } else if (tokenIsKeyword(this.state.type)) {
            node.name = tokenLabelName(this.state.type);
          } else {
            this.unexpected();
          }
          this.next();
          return this.finishNode(node, "JSXIdentifier");
        }
        jsxParseNamespacedName() {
          const startLoc = this.state.startLoc;
          const name = this.jsxParseIdentifier();
          if (!this.eat(14))
            return name;
          const node = this.startNodeAt(startLoc);
          node.namespace = name;
          node.name = this.jsxParseIdentifier();
          return this.finishNode(node, "JSXNamespacedName");
        }
        jsxParseElementName() {
          const startLoc = this.state.startLoc;
          let node = this.jsxParseNamespacedName();
          if (node.type === "JSXNamespacedName") {
            return node;
          }
          while (this.eat(16)) {
            const newNode = this.startNodeAt(startLoc);
            newNode.object = node;
            newNode.property = this.jsxParseIdentifier();
            node = this.finishNode(newNode, "JSXMemberExpression");
          }
          return node;
        }
        jsxParseAttributeValue() {
          let node;
          switch (this.state.type) {
            case 5:
              node = this.startNode();
              this.setContext(types.brace);
              this.next();
              node = this.jsxParseExpressionContainer(node, types.j_oTag);
              if (node.expression.type === "JSXEmptyExpression") {
                this.raise(JsxErrors.AttributeIsEmpty, {
                  at: node
                });
              }
              return node;
            case 140:
            case 131:
              return this.parseExprAtom();
            default:
              throw this.raise(JsxErrors.UnsupportedJsxValue, {
                at: this.state.startLoc
              });
          }
        }
        jsxParseEmptyExpression() {
          const node = this.startNodeAt(this.state.lastTokEndLoc);
          return this.finishNodeAt(node, "JSXEmptyExpression", this.state.startLoc);
        }
        jsxParseSpreadChild(node) {
          this.next();
          node.expression = this.parseExpression();
          this.setContext(types.j_expr);
          this.state.canStartJSXElement = true;
          this.expect(8);
          return this.finishNode(node, "JSXSpreadChild");
        }
        jsxParseExpressionContainer(node, previousContext) {
          if (this.match(8)) {
            node.expression = this.jsxParseEmptyExpression();
          } else {
            const expression = this.parseExpression();
            node.expression = expression;
          }
          this.setContext(previousContext);
          this.state.canStartJSXElement = true;
          this.expect(8);
          return this.finishNode(node, "JSXExpressionContainer");
        }
        jsxParseAttribute() {
          const node = this.startNode();
          if (this.match(5)) {
            this.setContext(types.brace);
            this.next();
            this.expect(21);
            node.argument = this.parseMaybeAssignAllowIn();
            this.setContext(types.j_oTag);
            this.state.canStartJSXElement = true;
            this.expect(8);
            return this.finishNode(node, "JSXSpreadAttribute");
          }
          node.name = this.jsxParseNamespacedName();
          node.value = this.eat(29) ? this.jsxParseAttributeValue() : null;
          return this.finishNode(node, "JSXAttribute");
        }
        jsxParseOpeningElementAt(startLoc) {
          const node = this.startNodeAt(startLoc);
          if (this.eat(141)) {
            return this.finishNode(node, "JSXOpeningFragment");
          }
          node.name = this.jsxParseElementName();
          return this.jsxParseOpeningElementAfterName(node);
        }
        jsxParseOpeningElementAfterName(node) {
          const attributes = [];
          while (!this.match(56) && !this.match(141)) {
            attributes.push(this.jsxParseAttribute());
          }
          node.attributes = attributes;
          node.selfClosing = this.eat(56);
          this.expect(141);
          return this.finishNode(node, "JSXOpeningElement");
        }
        jsxParseClosingElementAt(startLoc) {
          const node = this.startNodeAt(startLoc);
          if (this.eat(141)) {
            return this.finishNode(node, "JSXClosingFragment");
          }
          node.name = this.jsxParseElementName();
          this.expect(141);
          return this.finishNode(node, "JSXClosingElement");
        }
        jsxParseElementAt(startLoc) {
          const node = this.startNodeAt(startLoc);
          const children = [];
          const openingElement = this.jsxParseOpeningElementAt(startLoc);
          let closingElement = null;
          if (!openingElement.selfClosing) {
            contents:
              for (; ; ) {
                switch (this.state.type) {
                  case 140:
                    startLoc = this.state.startLoc;
                    this.next();
                    if (this.eat(56)) {
                      closingElement = this.jsxParseClosingElementAt(startLoc);
                      break contents;
                    }
                    children.push(this.jsxParseElementAt(startLoc));
                    break;
                  case 139:
                    children.push(this.parseExprAtom());
                    break;
                  case 5: {
                    const node2 = this.startNode();
                    this.setContext(types.brace);
                    this.next();
                    if (this.match(21)) {
                      children.push(this.jsxParseSpreadChild(node2));
                    } else {
                      children.push(this.jsxParseExpressionContainer(node2, types.j_expr));
                    }
                    break;
                  }
                  default:
                    throw this.unexpected();
                }
              }
            if (isFragment(openingElement) && !isFragment(closingElement) && closingElement !== null) {
              this.raise(JsxErrors.MissingClosingTagFragment, {
                at: closingElement
              });
            } else if (!isFragment(openingElement) && isFragment(closingElement)) {
              this.raise(JsxErrors.MissingClosingTagElement, {
                at: closingElement,
                openingTagName: getQualifiedJSXName(openingElement.name)
              });
            } else if (!isFragment(openingElement) && !isFragment(closingElement)) {
              if (getQualifiedJSXName(closingElement.name) !== getQualifiedJSXName(openingElement.name)) {
                this.raise(JsxErrors.MissingClosingTagElement, {
                  at: closingElement,
                  openingTagName: getQualifiedJSXName(openingElement.name)
                });
              }
            }
          }
          if (isFragment(openingElement)) {
            node.openingFragment = openingElement;
            node.closingFragment = closingElement;
          } else {
            node.openingElement = openingElement;
            node.closingElement = closingElement;
          }
          node.children = children;
          if (this.match(47)) {
            throw this.raise(JsxErrors.UnwrappedAdjacentJSXElements, {
              at: this.state.startLoc
            });
          }
          return isFragment(openingElement) ? this.finishNode(node, "JSXFragment") : this.finishNode(node, "JSXElement");
        }
        jsxParseElement() {
          const startLoc = this.state.startLoc;
          this.next();
          return this.jsxParseElementAt(startLoc);
        }
        setContext(newContext) {
          const {
            context
          } = this.state;
          context[context.length - 1] = newContext;
        }
        parseExprAtom(refExpressionErrors) {
          if (this.match(139)) {
            return this.parseLiteral(this.state.value, "JSXText");
          } else if (this.match(140)) {
            return this.jsxParseElement();
          } else if (this.match(47) && this.input.charCodeAt(this.state.pos) !== 33) {
            this.replaceToken(140);
            return this.jsxParseElement();
          } else {
            return super.parseExprAtom(refExpressionErrors);
          }
        }
        skipSpace() {
          const curContext = this.curContext();
          if (!curContext.preserveSpace)
            super.skipSpace();
        }
        getTokenFromCode(code) {
          const context = this.curContext();
          if (context === types.j_expr) {
            return this.jsxReadToken();
          }
          if (context === types.j_oTag || context === types.j_cTag) {
            if (isIdentifierStart(code)) {
              return this.jsxReadWord();
            }
            if (code === 62) {
              ++this.state.pos;
              return this.finishToken(141);
            }
            if ((code === 34 || code === 39) && context === types.j_oTag) {
              return this.jsxReadString(code);
            }
          }
          if (code === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33) {
            ++this.state.pos;
            return this.finishToken(140);
          }
          return super.getTokenFromCode(code);
        }
        updateContext(prevType) {
          const {
            context,
            type
          } = this.state;
          if (type === 56 && prevType === 140) {
            context.splice(-2, 2, types.j_cTag);
            this.state.canStartJSXElement = false;
          } else if (type === 140) {
            context.push(types.j_oTag);
          } else if (type === 141) {
            const out = context[context.length - 1];
            if (out === types.j_oTag && prevType === 56 || out === types.j_cTag) {
              context.pop();
              this.state.canStartJSXElement = context[context.length - 1] === types.j_expr;
            } else {
              this.setContext(types.j_expr);
              this.state.canStartJSXElement = true;
            }
          } else {
            this.state.canStartJSXElement = tokenComesBeforeExpression(type);
          }
        }
      };
      var TypeScriptScope = class extends Scope2 {
        constructor(...args) {
          super(...args);
          this.types = /* @__PURE__ */ new Set();
          this.enums = /* @__PURE__ */ new Set();
          this.constEnums = /* @__PURE__ */ new Set();
          this.classes = /* @__PURE__ */ new Set();
          this.exportOnlyBindings = /* @__PURE__ */ new Set();
        }
      };
      var TypeScriptScopeHandler = class extends ScopeHandler {
        constructor(...args) {
          super(...args);
          this.importsStack = [];
        }
        createScope(flags) {
          this.importsStack.push(/* @__PURE__ */ new Set());
          return new TypeScriptScope(flags);
        }
        enter(flags) {
          if (flags == SCOPE_TS_MODULE) {
            this.importsStack.push(/* @__PURE__ */ new Set());
          }
          super.enter(flags);
        }
        exit() {
          const flags = super.exit();
          if (flags == SCOPE_TS_MODULE) {
            this.importsStack.pop();
          }
          return flags;
        }
        hasImport(name, allowShadow) {
          const len = this.importsStack.length;
          if (this.importsStack[len - 1].has(name)) {
            return true;
          }
          if (!allowShadow && len > 1) {
            for (let i = 0; i < len - 1; i++) {
              if (this.importsStack[i].has(name))
                return true;
            }
          }
          return false;
        }
        declareName(name, bindingType, loc) {
          if (bindingType & BIND_FLAGS_TS_IMPORT) {
            if (this.hasImport(name, true)) {
              this.parser.raise(Errors.VarRedeclaration, {
                at: loc,
                identifierName: name
              });
            }
            this.importsStack[this.importsStack.length - 1].add(name);
            return;
          }
          const scope = this.currentScope();
          if (bindingType & BIND_FLAGS_TS_EXPORT_ONLY) {
            this.maybeExportDefined(scope, name);
            scope.exportOnlyBindings.add(name);
            return;
          }
          super.declareName(name, bindingType, loc);
          if (bindingType & BIND_KIND_TYPE) {
            if (!(bindingType & BIND_KIND_VALUE)) {
              this.checkRedeclarationInScope(scope, name, bindingType, loc);
              this.maybeExportDefined(scope, name);
            }
            scope.types.add(name);
          }
          if (bindingType & BIND_FLAGS_TS_ENUM)
            scope.enums.add(name);
          if (bindingType & BIND_FLAGS_TS_CONST_ENUM)
            scope.constEnums.add(name);
          if (bindingType & BIND_FLAGS_CLASS)
            scope.classes.add(name);
        }
        isRedeclaredInScope(scope, name, bindingType) {
          if (scope.enums.has(name)) {
            if (bindingType & BIND_FLAGS_TS_ENUM) {
              const isConst = !!(bindingType & BIND_FLAGS_TS_CONST_ENUM);
              const wasConst = scope.constEnums.has(name);
              return isConst !== wasConst;
            }
            return true;
          }
          if (bindingType & BIND_FLAGS_CLASS && scope.classes.has(name)) {
            if (scope.lexical.has(name)) {
              return !!(bindingType & BIND_KIND_VALUE);
            } else {
              return false;
            }
          }
          if (bindingType & BIND_KIND_TYPE && scope.types.has(name)) {
            return true;
          }
          return super.isRedeclaredInScope(scope, name, bindingType);
        }
        checkLocalExport(id) {
          const {
            name
          } = id;
          if (this.hasImport(name))
            return;
          const len = this.scopeStack.length;
          for (let i = len - 1; i >= 0; i--) {
            const scope = this.scopeStack[i];
            if (scope.types.has(name) || scope.exportOnlyBindings.has(name))
              return;
          }
          super.checkLocalExport(id);
        }
      };
      var getOwn$1 = (object, key) => Object.hasOwnProperty.call(object, key) && object[key];
      function nonNull(x) {
        if (x == null) {
          throw new Error(`Unexpected ${x} value.`);
        }
        return x;
      }
      function assert(x) {
        if (!x) {
          throw new Error("Assert fail");
        }
      }
      var TSErrors = ParseErrorEnum`typescript`({
        AbstractMethodHasImplementation: ({
          methodName
        }) => `Method '${methodName}' cannot have an implementation because it is marked abstract.`,
        AbstractPropertyHasInitializer: ({
          propertyName
        }) => `Property '${propertyName}' cannot have an initializer because it is marked abstract.`,
        AccesorCannotDeclareThisParameter: "'get' and 'set' accessors cannot declare 'this' parameters.",
        AccesorCannotHaveTypeParameters: "An accessor cannot have type parameters.",
        ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier.",
        ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier.",
        ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference: "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference.",
        ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.",
        DeclareAccessor: ({
          kind
        }) => `'declare' is not allowed in ${kind}ters.`,
        DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.",
        DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.",
        DuplicateAccessibilityModifier: ({
          modifier
        }) => `Accessibility modifier already seen.`,
        DuplicateModifier: ({
          modifier
        }) => `Duplicate modifier: '${modifier}'.`,
        EmptyHeritageClauseType: ({
          token
        }) => `'${token}' list cannot be empty.`,
        EmptyTypeArguments: "Type argument list cannot be empty.",
        EmptyTypeParameters: "Type parameter list cannot be empty.",
        ExpectedAmbientAfterExportDeclare: "'export declare' must be followed by an ambient declaration.",
        ImportAliasHasImportType: "An import alias can not use 'import type'.",
        ImportReflectionHasImportType: "An `import module` declaration can not use `type` modifier",
        IncompatibleModifiers: ({
          modifiers
        }) => `'${modifiers[0]}' modifier cannot be used with '${modifiers[1]}' modifier.`,
        IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier.",
        IndexSignatureHasAccessibility: ({
          modifier
        }) => `Index signatures cannot have an accessibility modifier ('${modifier}').`,
        IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier.",
        IndexSignatureHasOverride: "'override' modifier cannot appear on an index signature.",
        IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier.",
        InitializerNotAllowedInAmbientContext: "Initializers are not allowed in ambient contexts.",
        InvalidModifierOnTypeMember: ({
          modifier
        }) => `'${modifier}' modifier cannot appear on a type member.`,
        InvalidModifierOnTypeParameter: ({
          modifier
        }) => `'${modifier}' modifier cannot appear on a type parameter.`,
        InvalidModifierOnTypeParameterPositions: ({
          modifier
        }) => `'${modifier}' modifier can only appear on a type parameter of a class, interface or type alias.`,
        InvalidModifiersOrder: ({
          orderedModifiers
        }) => `'${orderedModifiers[0]}' modifier must precede '${orderedModifiers[1]}' modifier.`,
        InvalidPropertyAccessAfterInstantiationExpression: "Invalid property access after an instantiation expression. You can either wrap the instantiation expression in parentheses, or delete the type arguments.",
        InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.",
        MissingInterfaceName: "'interface' declarations must be followed by an identifier.",
        MixedLabeledAndUnlabeledElements: "Tuple members must all have names or all not have names.",
        NonAbstractClassHasAbstractMethod: "Abstract methods can only appear within an abstract class.",
        NonClassMethodPropertyHasAbstractModifer: "'abstract' modifier can only appear on a class, method, or property declaration.",
        OptionalTypeBeforeRequired: "A required element cannot follow an optional element.",
        OverrideNotInSubClass: "This member cannot have an 'override' modifier because its containing class does not extend another class.",
        PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.",
        PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.",
        PrivateElementHasAccessibility: ({
          modifier
        }) => `Private elements cannot have an accessibility modifier ('${modifier}').`,
        ReadonlyForMethodSignature: "'readonly' modifier can only appear on a property declaration or index signature.",
        ReservedArrowTypeParam: "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`.",
        ReservedTypeAssertion: "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead.",
        SetAccesorCannotHaveOptionalParameter: "A 'set' accessor cannot have an optional parameter.",
        SetAccesorCannotHaveRestParameter: "A 'set' accessor cannot have rest parameter.",
        SetAccesorCannotHaveReturnType: "A 'set' accessor cannot have a return type annotation.",
        SingleTypeParameterWithoutTrailingComma: ({
          typeParameterName
        }) => `Single type parameter ${typeParameterName} should have a trailing comma. Example usage: <${typeParameterName},>.`,
        StaticBlockCannotHaveModifier: "Static class blocks cannot have any modifier.",
        TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.",
        TypeImportCannotSpecifyDefaultAndNamed: "A type-only import can specify a default import or named bindings, but not both.",
        TypeModifierIsUsedInTypeExports: "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement.",
        TypeModifierIsUsedInTypeImports: "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement.",
        UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.",
        UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.",
        UnexpectedTypeAnnotation: "Did not expect a type annotation here.",
        UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.",
        UnsupportedImportTypeArgument: "Argument in a type import must be a string literal.",
        UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.",
        UnsupportedSignatureParameterKind: ({
          type
        }) => `Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ${type}.`
      });
      function keywordTypeFromName(value) {
        switch (value) {
          case "any":
            return "TSAnyKeyword";
          case "boolean":
            return "TSBooleanKeyword";
          case "bigint":
            return "TSBigIntKeyword";
          case "never":
            return "TSNeverKeyword";
          case "number":
            return "TSNumberKeyword";
          case "object":
            return "TSObjectKeyword";
          case "string":
            return "TSStringKeyword";
          case "symbol":
            return "TSSymbolKeyword";
          case "undefined":
            return "TSUndefinedKeyword";
          case "unknown":
            return "TSUnknownKeyword";
          default:
            return void 0;
        }
      }
      function tsIsAccessModifier(modifier) {
        return modifier === "private" || modifier === "public" || modifier === "protected";
      }
      function tsIsVarianceAnnotations(modifier) {
        return modifier === "in" || modifier === "out";
      }
      var typescript = (superClass) => class TypeScriptParserMixin extends superClass {
        getScopeHandler() {
          return TypeScriptScopeHandler;
        }
        tsIsIdentifier() {
          return tokenIsIdentifier(this.state.type);
        }
        tsTokenCanFollowModifier() {
          return (this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(136) || this.isLiteralPropertyName()) && !this.hasPrecedingLineBreak();
        }
        tsNextTokenCanFollowModifier() {
          this.next();
          return this.tsTokenCanFollowModifier();
        }
        tsParseModifier(allowedModifiers, stopOnStartOfClassStaticBlock) {
          if (!tokenIsIdentifier(this.state.type) && this.state.type !== 58) {
            return void 0;
          }
          const modifier = this.state.value;
          if (allowedModifiers.indexOf(modifier) !== -1) {
            if (stopOnStartOfClassStaticBlock && this.tsIsStartOfStaticBlocks()) {
              return void 0;
            }
            if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this))) {
              return modifier;
            }
          }
          return void 0;
        }
        tsParseModifiers({
          modified,
          allowedModifiers,
          disallowedModifiers,
          stopOnStartOfClassStaticBlock,
          errorTemplate = TSErrors.InvalidModifierOnTypeMember
        }) {
          const enforceOrder = (loc, modifier, before2, after2) => {
            if (modifier === before2 && modified[after2]) {
              this.raise(TSErrors.InvalidModifiersOrder, {
                at: loc,
                orderedModifiers: [before2, after2]
              });
            }
          };
          const incompatible = (loc, modifier, mod1, mod2) => {
            if (modified[mod1] && modifier === mod2 || modified[mod2] && modifier === mod1) {
              this.raise(TSErrors.IncompatibleModifiers, {
                at: loc,
                modifiers: [mod1, mod2]
              });
            }
          };
          for (; ; ) {
            const {
              startLoc
            } = this.state;
            const modifier = this.tsParseModifier(allowedModifiers.concat(disallowedModifiers != null ? disallowedModifiers : []), stopOnStartOfClassStaticBlock);
            if (!modifier)
              break;
            if (tsIsAccessModifier(modifier)) {
              if (modified.accessibility) {
                this.raise(TSErrors.DuplicateAccessibilityModifier, {
                  at: startLoc,
                  modifier
                });
              } else {
                enforceOrder(startLoc, modifier, modifier, "override");
                enforceOrder(startLoc, modifier, modifier, "static");
                enforceOrder(startLoc, modifier, modifier, "readonly");
                modified.accessibility = modifier;
              }
            } else if (tsIsVarianceAnnotations(modifier)) {
              if (modified[modifier]) {
                this.raise(TSErrors.DuplicateModifier, {
                  at: startLoc,
                  modifier
                });
              }
              modified[modifier] = true;
              enforceOrder(startLoc, modifier, "in", "out");
            } else {
              if (Object.hasOwnProperty.call(modified, modifier)) {
                this.raise(TSErrors.DuplicateModifier, {
                  at: startLoc,
                  modifier
                });
              } else {
                enforceOrder(startLoc, modifier, "static", "readonly");
                enforceOrder(startLoc, modifier, "static", "override");
                enforceOrder(startLoc, modifier, "override", "readonly");
                enforceOrder(startLoc, modifier, "abstract", "override");
                incompatible(startLoc, modifier, "declare", "override");
                incompatible(startLoc, modifier, "static", "abstract");
              }
              modified[modifier] = true;
            }
            if (disallowedModifiers != null && disallowedModifiers.includes(modifier)) {
              this.raise(errorTemplate, {
                at: startLoc,
                modifier
              });
            }
          }
        }
        tsIsListTerminator(kind) {
          switch (kind) {
            case "EnumMembers":
            case "TypeMembers":
              return this.match(8);
            case "HeritageClauseElement":
              return this.match(5);
            case "TupleElementTypes":
              return this.match(3);
            case "TypeParametersOrArguments":
              return this.match(48);
          }
          throw new Error("Unreachable");
        }
        tsParseList(kind, parseElement) {
          const result2 = [];
          while (!this.tsIsListTerminator(kind)) {
            result2.push(parseElement());
          }
          return result2;
        }
        tsParseDelimitedList(kind, parseElement, refTrailingCommaPos) {
          return nonNull(this.tsParseDelimitedListWorker(kind, parseElement, true, refTrailingCommaPos));
        }
        tsParseDelimitedListWorker(kind, parseElement, expectSuccess, refTrailingCommaPos) {
          const result2 = [];
          let trailingCommaPos = -1;
          for (; ; ) {
            if (this.tsIsListTerminator(kind)) {
              break;
            }
            trailingCommaPos = -1;
            const element = parseElement();
            if (element == null) {
              return void 0;
            }
            result2.push(element);
            if (this.eat(12)) {
              trailingCommaPos = this.state.lastTokStart;
              continue;
            }
            if (this.tsIsListTerminator(kind)) {
              break;
            }
            if (expectSuccess) {
              this.expect(12);
            }
            return void 0;
          }
          if (refTrailingCommaPos) {
            refTrailingCommaPos.value = trailingCommaPos;
          }
          return result2;
        }
        tsParseBracketedList(kind, parseElement, bracket, skipFirstToken, refTrailingCommaPos) {
          if (!skipFirstToken) {
            if (bracket) {
              this.expect(0);
            } else {
              this.expect(47);
            }
          }
          const result2 = this.tsParseDelimitedList(kind, parseElement, refTrailingCommaPos);
          if (bracket) {
            this.expect(3);
          } else {
            this.expect(48);
          }
          return result2;
        }
        tsParseImportType() {
          const node = this.startNode();
          this.expect(83);
          this.expect(10);
          if (!this.match(131)) {
            this.raise(TSErrors.UnsupportedImportTypeArgument, {
              at: this.state.startLoc
            });
          }
          node.argument = super.parseExprAtom();
          this.expect(11);
          if (this.eat(16)) {
            node.qualifier = this.tsParseEntityName();
          }
          if (this.match(47)) {
            node.typeParameters = this.tsParseTypeArguments();
          }
          return this.finishNode(node, "TSImportType");
        }
        tsParseEntityName(allowReservedWords = true) {
          let entity = this.parseIdentifier(allowReservedWords);
          while (this.eat(16)) {
            const node = this.startNodeAtNode(entity);
            node.left = entity;
            node.right = this.parseIdentifier(allowReservedWords);
            entity = this.finishNode(node, "TSQualifiedName");
          }
          return entity;
        }
        tsParseTypeReference() {
          const node = this.startNode();
          node.typeName = this.tsParseEntityName();
          if (!this.hasPrecedingLineBreak() && this.match(47)) {
            node.typeParameters = this.tsParseTypeArguments();
          }
          return this.finishNode(node, "TSTypeReference");
        }
        tsParseThisTypePredicate(lhs) {
          this.next();
          const node = this.startNodeAtNode(lhs);
          node.parameterName = lhs;
          node.typeAnnotation = this.tsParseTypeAnnotation(false);
          node.asserts = false;
          return this.finishNode(node, "TSTypePredicate");
        }
        tsParseThisTypeNode() {
          const node = this.startNode();
          this.next();
          return this.finishNode(node, "TSThisType");
        }
        tsParseTypeQuery() {
          const node = this.startNode();
          this.expect(87);
          if (this.match(83)) {
            node.exprName = this.tsParseImportType();
          } else {
            node.exprName = this.tsParseEntityName();
          }
          if (!this.hasPrecedingLineBreak() && this.match(47)) {
            node.typeParameters = this.tsParseTypeArguments();
          }
          return this.finishNode(node, "TSTypeQuery");
        }
        tsParseInOutModifiers(node) {
          this.tsParseModifiers({
            modified: node,
            allowedModifiers: ["in", "out"],
            disallowedModifiers: ["public", "private", "protected", "readonly", "declare", "abstract", "override"],
            errorTemplate: TSErrors.InvalidModifierOnTypeParameter
          });
        }
        tsParseNoneModifiers(node) {
          this.tsParseModifiers({
            modified: node,
            allowedModifiers: [],
            disallowedModifiers: ["in", "out"],
            errorTemplate: TSErrors.InvalidModifierOnTypeParameterPositions
          });
        }
        tsParseTypeParameter(parseModifiers = this.tsParseNoneModifiers.bind(this)) {
          const node = this.startNode();
          parseModifiers(node);
          node.name = this.tsParseTypeParameterName();
          node.constraint = this.tsEatThenParseType(81);
          node.default = this.tsEatThenParseType(29);
          return this.finishNode(node, "TSTypeParameter");
        }
        tsTryParseTypeParameters(parseModifiers) {
          if (this.match(47)) {
            return this.tsParseTypeParameters(parseModifiers);
          }
        }
        tsParseTypeParameters(parseModifiers) {
          const node = this.startNode();
          if (this.match(47) || this.match(140)) {
            this.next();
          } else {
            this.unexpected();
          }
          const refTrailingCommaPos = {
            value: -1
          };
          node.params = this.tsParseBracketedList(
            "TypeParametersOrArguments",
            this.tsParseTypeParameter.bind(this, parseModifiers),
            false,
            true,
            refTrailingCommaPos
          );
          if (node.params.length === 0) {
            this.raise(TSErrors.EmptyTypeParameters, {
              at: node
            });
          }
          if (refTrailingCommaPos.value !== -1) {
            this.addExtra(node, "trailingComma", refTrailingCommaPos.value);
          }
          return this.finishNode(node, "TSTypeParameterDeclaration");
        }
        tsFillSignature(returnToken, signature) {
          const returnTokenRequired = returnToken === 19;
          const paramsKey = "parameters";
          const returnTypeKey = "typeAnnotation";
          signature.typeParameters = this.tsTryParseTypeParameters();
          this.expect(10);
          signature[paramsKey] = this.tsParseBindingListForSignature();
          if (returnTokenRequired) {
            signature[returnTypeKey] = this.tsParseTypeOrTypePredicateAnnotation(returnToken);
          } else if (this.match(returnToken)) {
            signature[returnTypeKey] = this.tsParseTypeOrTypePredicateAnnotation(returnToken);
          }
        }
        tsParseBindingListForSignature() {
          return super.parseBindingList(11, 41).map((pattern) => {
            if (pattern.type !== "Identifier" && pattern.type !== "RestElement" && pattern.type !== "ObjectPattern" && pattern.type !== "ArrayPattern") {
              this.raise(TSErrors.UnsupportedSignatureParameterKind, {
                at: pattern,
                type: pattern.type
              });
            }
            return pattern;
          });
        }
        tsParseTypeMemberSemicolon() {
          if (!this.eat(12) && !this.isLineTerminator()) {
            this.expect(13);
          }
        }
        tsParseSignatureMember(kind, node) {
          this.tsFillSignature(14, node);
          this.tsParseTypeMemberSemicolon();
          return this.finishNode(node, kind);
        }
        tsIsUnambiguouslyIndexSignature() {
          this.next();
          if (tokenIsIdentifier(this.state.type)) {
            this.next();
            return this.match(14);
          }
          return false;
        }
        tsTryParseIndexSignature(node) {
          if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this)))) {
            return void 0;
          }
          this.expect(0);
          const id = this.parseIdentifier();
          id.typeAnnotation = this.tsParseTypeAnnotation();
          this.resetEndLocation(id);
          this.expect(3);
          node.parameters = [id];
          const type = this.tsTryParseTypeAnnotation();
          if (type)
            node.typeAnnotation = type;
          this.tsParseTypeMemberSemicolon();
          return this.finishNode(node, "TSIndexSignature");
        }
        tsParsePropertyOrMethodSignature(node, readonly) {
          if (this.eat(17))
            node.optional = true;
          const nodeAny = node;
          if (this.match(10) || this.match(47)) {
            if (readonly) {
              this.raise(TSErrors.ReadonlyForMethodSignature, {
                at: node
              });
            }
            const method2 = nodeAny;
            if (method2.kind && this.match(47)) {
              this.raise(TSErrors.AccesorCannotHaveTypeParameters, {
                at: this.state.curPosition()
              });
            }
            this.tsFillSignature(14, method2);
            this.tsParseTypeMemberSemicolon();
            const paramsKey = "parameters";
            const returnTypeKey = "typeAnnotation";
            if (method2.kind === "get") {
              if (method2[paramsKey].length > 0) {
                this.raise(Errors.BadGetterArity, {
                  at: this.state.curPosition()
                });
                if (this.isThisParam(method2[paramsKey][0])) {
                  this.raise(TSErrors.AccesorCannotDeclareThisParameter, {
                    at: this.state.curPosition()
                  });
                }
              }
            } else if (method2.kind === "set") {
              if (method2[paramsKey].length !== 1) {
                this.raise(Errors.BadSetterArity, {
                  at: this.state.curPosition()
                });
              } else {
                const firstParameter = method2[paramsKey][0];
                if (this.isThisParam(firstParameter)) {
                  this.raise(TSErrors.AccesorCannotDeclareThisParameter, {
                    at: this.state.curPosition()
                  });
                }
                if (firstParameter.type === "Identifier" && firstParameter.optional) {
                  this.raise(TSErrors.SetAccesorCannotHaveOptionalParameter, {
                    at: this.state.curPosition()
                  });
                }
                if (firstParameter.type === "RestElement") {
                  this.raise(TSErrors.SetAccesorCannotHaveRestParameter, {
                    at: this.state.curPosition()
                  });
                }
              }
              if (method2[returnTypeKey]) {
                this.raise(TSErrors.SetAccesorCannotHaveReturnType, {
                  at: method2[returnTypeKey]
                });
              }
            } else {
              method2.kind = "method";
            }
            return this.finishNode(method2, "TSMethodSignature");
          } else {
            const property2 = nodeAny;
            if (readonly)
              property2.readonly = true;
            const type = this.tsTryParseTypeAnnotation();
            if (type)
              property2.typeAnnotation = type;
            this.tsParseTypeMemberSemicolon();
            return this.finishNode(property2, "TSPropertySignature");
          }
        }
        tsParseTypeMember() {
          const node = this.startNode();
          if (this.match(10) || this.match(47)) {
            return this.tsParseSignatureMember("TSCallSignatureDeclaration", node);
          }
          if (this.match(77)) {
            const id = this.startNode();
            this.next();
            if (this.match(10) || this.match(47)) {
              return this.tsParseSignatureMember("TSConstructSignatureDeclaration", node);
            } else {
              node.key = this.createIdentifier(id, "new");
              return this.tsParsePropertyOrMethodSignature(node, false);
            }
          }
          this.tsParseModifiers({
            modified: node,
            allowedModifiers: ["readonly"],
            disallowedModifiers: ["declare", "abstract", "private", "protected", "public", "static", "override"]
          });
          const idx = this.tsTryParseIndexSignature(node);
          if (idx) {
            return idx;
          }
          super.parsePropertyName(node);
          if (!node.computed && node.key.type === "Identifier" && (node.key.name === "get" || node.key.name === "set") && this.tsTokenCanFollowModifier()) {
            node.kind = node.key.name;
            super.parsePropertyName(node);
          }
          return this.tsParsePropertyOrMethodSignature(node, !!node.readonly);
        }
        tsParseTypeLiteral() {
          const node = this.startNode();
          node.members = this.tsParseObjectTypeMembers();
          return this.finishNode(node, "TSTypeLiteral");
        }
        tsParseObjectTypeMembers() {
          this.expect(5);
          const members = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
          this.expect(8);
          return members;
        }
        tsIsStartOfMappedType() {
          this.next();
          if (this.eat(53)) {
            return this.isContextual(120);
          }
          if (this.isContextual(120)) {
            this.next();
          }
          if (!this.match(0)) {
            return false;
          }
          this.next();
          if (!this.tsIsIdentifier()) {
            return false;
          }
          this.next();
          return this.match(58);
        }
        tsParseMappedTypeParameter() {
          const node = this.startNode();
          node.name = this.tsParseTypeParameterName();
          node.constraint = this.tsExpectThenParseType(58);
          return this.finishNode(node, "TSTypeParameter");
        }
        tsParseMappedType() {
          const node = this.startNode();
          this.expect(5);
          if (this.match(53)) {
            node.readonly = this.state.value;
            this.next();
            this.expectContextual(120);
          } else if (this.eatContextual(120)) {
            node.readonly = true;
          }
          this.expect(0);
          node.typeParameter = this.tsParseMappedTypeParameter();
          node.nameType = this.eatContextual(93) ? this.tsParseType() : null;
          this.expect(3);
          if (this.match(53)) {
            node.optional = this.state.value;
            this.next();
            this.expect(17);
          } else if (this.eat(17)) {
            node.optional = true;
          }
          node.typeAnnotation = this.tsTryParseType();
          this.semicolon();
          this.expect(8);
          return this.finishNode(node, "TSMappedType");
        }
        tsParseTupleType() {
          const node = this.startNode();
          node.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), true, false);
          let seenOptionalElement = false;
          let labeledElements = null;
          node.elementTypes.forEach((elementNode) => {
            var _labeledElements;
            const {
              type
            } = elementNode;
            if (seenOptionalElement && type !== "TSRestType" && type !== "TSOptionalType" && !(type === "TSNamedTupleMember" && elementNode.optional)) {
              this.raise(TSErrors.OptionalTypeBeforeRequired, {
                at: elementNode
              });
            }
            seenOptionalElement || (seenOptionalElement = type === "TSNamedTupleMember" && elementNode.optional || type === "TSOptionalType");
            let checkType = type;
            if (type === "TSRestType") {
              elementNode = elementNode.typeAnnotation;
              checkType = elementNode.type;
            }
            const isLabeled = checkType === "TSNamedTupleMember";
            (_labeledElements = labeledElements) != null ? _labeledElements : labeledElements = isLabeled;
            if (labeledElements !== isLabeled) {
              this.raise(TSErrors.MixedLabeledAndUnlabeledElements, {
                at: elementNode
              });
            }
          });
          return this.finishNode(node, "TSTupleType");
        }
        tsParseTupleElementType() {
          const {
            startLoc
          } = this.state;
          const rest2 = this.eat(21);
          let type = this.tsParseType();
          const optional = this.eat(17);
          const labeled = this.eat(14);
          if (labeled) {
            const labeledNode = this.startNodeAtNode(type);
            labeledNode.optional = optional;
            if (type.type === "TSTypeReference" && !type.typeParameters && type.typeName.type === "Identifier") {
              labeledNode.label = type.typeName;
            } else {
              this.raise(TSErrors.InvalidTupleMemberLabel, {
                at: type
              });
              labeledNode.label = type;
            }
            labeledNode.elementType = this.tsParseType();
            type = this.finishNode(labeledNode, "TSNamedTupleMember");
          } else if (optional) {
            const optionalTypeNode = this.startNodeAtNode(type);
            optionalTypeNode.typeAnnotation = type;
            type = this.finishNode(optionalTypeNode, "TSOptionalType");
          }
          if (rest2) {
            const restNode = this.startNodeAt(startLoc);
            restNode.typeAnnotation = type;
            type = this.finishNode(restNode, "TSRestType");
          }
          return type;
        }
        tsParseParenthesizedType() {
          const node = this.startNode();
          this.expect(10);
          node.typeAnnotation = this.tsParseType();
          this.expect(11);
          return this.finishNode(node, "TSParenthesizedType");
        }
        tsParseFunctionOrConstructorType(type, abstract) {
          const node = this.startNode();
          if (type === "TSConstructorType") {
            node.abstract = !!abstract;
            if (abstract)
              this.next();
            this.next();
          }
          this.tsInAllowConditionalTypesContext(() => this.tsFillSignature(19, node));
          return this.finishNode(node, type);
        }
        tsParseLiteralTypeNode() {
          const node = this.startNode();
          node.literal = (() => {
            switch (this.state.type) {
              case 132:
              case 133:
              case 131:
              case 85:
              case 86:
                return super.parseExprAtom();
              default:
                throw this.unexpected();
            }
          })();
          return this.finishNode(node, "TSLiteralType");
        }
        tsParseTemplateLiteralType() {
          const node = this.startNode();
          node.literal = super.parseTemplate(false);
          return this.finishNode(node, "TSLiteralType");
        }
        parseTemplateSubstitution() {
          if (this.state.inType)
            return this.tsParseType();
          return super.parseTemplateSubstitution();
        }
        tsParseThisTypeOrThisTypePredicate() {
          const thisKeyword = this.tsParseThisTypeNode();
          if (this.isContextual(114) && !this.hasPrecedingLineBreak()) {
            return this.tsParseThisTypePredicate(thisKeyword);
          } else {
            return thisKeyword;
          }
        }
        tsParseNonArrayType() {
          switch (this.state.type) {
            case 131:
            case 132:
            case 133:
            case 85:
            case 86:
              return this.tsParseLiteralTypeNode();
            case 53:
              if (this.state.value === "-") {
                const node = this.startNode();
                const nextToken = this.lookahead();
                if (nextToken.type !== 132 && nextToken.type !== 133) {
                  throw this.unexpected();
                }
                node.literal = this.parseMaybeUnary();
                return this.finishNode(node, "TSLiteralType");
              }
              break;
            case 78:
              return this.tsParseThisTypeOrThisTypePredicate();
            case 87:
              return this.tsParseTypeQuery();
            case 83:
              return this.tsParseImportType();
            case 5:
              return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
            case 0:
              return this.tsParseTupleType();
            case 10:
              return this.tsParseParenthesizedType();
            case 25:
            case 24:
              return this.tsParseTemplateLiteralType();
            default: {
              const {
                type
              } = this.state;
              if (tokenIsIdentifier(type) || type === 88 || type === 84) {
                const nodeType = type === 88 ? "TSVoidKeyword" : type === 84 ? "TSNullKeyword" : keywordTypeFromName(this.state.value);
                if (nodeType !== void 0 && this.lookaheadCharCode() !== 46) {
                  const node = this.startNode();
                  this.next();
                  return this.finishNode(node, nodeType);
                }
                return this.tsParseTypeReference();
              }
            }
          }
          throw this.unexpected();
        }
        tsParseArrayTypeOrHigher() {
          let type = this.tsParseNonArrayType();
          while (!this.hasPrecedingLineBreak() && this.eat(0)) {
            if (this.match(3)) {
              const node = this.startNodeAtNode(type);
              node.elementType = type;
              this.expect(3);
              type = this.finishNode(node, "TSArrayType");
            } else {
              const node = this.startNodeAtNode(type);
              node.objectType = type;
              node.indexType = this.tsParseType();
              this.expect(3);
              type = this.finishNode(node, "TSIndexedAccessType");
            }
          }
          return type;
        }
        tsParseTypeOperator() {
          const node = this.startNode();
          const operator = this.state.value;
          this.next();
          node.operator = operator;
          node.typeAnnotation = this.tsParseTypeOperatorOrHigher();
          if (operator === "readonly") {
            this.tsCheckTypeAnnotationForReadOnly(
              node
            );
          }
          return this.finishNode(node, "TSTypeOperator");
        }
        tsCheckTypeAnnotationForReadOnly(node) {
          switch (node.typeAnnotation.type) {
            case "TSTupleType":
            case "TSArrayType":
              return;
            default:
              this.raise(TSErrors.UnexpectedReadonly, {
                at: node
              });
          }
        }
        tsParseInferType() {
          const node = this.startNode();
          this.expectContextual(113);
          const typeParameter = this.startNode();
          typeParameter.name = this.tsParseTypeParameterName();
          typeParameter.constraint = this.tsTryParse(() => this.tsParseConstraintForInferType());
          node.typeParameter = this.finishNode(typeParameter, "TSTypeParameter");
          return this.finishNode(node, "TSInferType");
        }
        tsParseConstraintForInferType() {
          if (this.eat(81)) {
            const constraint = this.tsInDisallowConditionalTypesContext(() => this.tsParseType());
            if (this.state.inDisallowConditionalTypesContext || !this.match(17)) {
              return constraint;
            }
          }
        }
        tsParseTypeOperatorOrHigher() {
          const isTypeOperator = tokenIsTSTypeOperator(this.state.type) && !this.state.containsEsc;
          return isTypeOperator ? this.tsParseTypeOperator() : this.isContextual(113) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(() => this.tsParseArrayTypeOrHigher());
        }
        tsParseUnionOrIntersectionType(kind, parseConstituentType, operator) {
          const node = this.startNode();
          const hasLeadingOperator = this.eat(operator);
          const types2 = [];
          do {
            types2.push(parseConstituentType());
          } while (this.eat(operator));
          if (types2.length === 1 && !hasLeadingOperator) {
            return types2[0];
          }
          node.types = types2;
          return this.finishNode(node, kind);
        }
        tsParseIntersectionTypeOrHigher() {
          return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
        }
        tsParseUnionTypeOrHigher() {
          return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
        }
        tsIsStartOfFunctionType() {
          if (this.match(47)) {
            return true;
          }
          return this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
        }
        tsSkipParameterStart() {
          if (tokenIsIdentifier(this.state.type) || this.match(78)) {
            this.next();
            return true;
          }
          if (this.match(5)) {
            const {
              errors
            } = this.state;
            const previousErrorCount = errors.length;
            try {
              this.parseObjectLike(8, true);
              return errors.length === previousErrorCount;
            } catch (_unused) {
              return false;
            }
          }
          if (this.match(0)) {
            this.next();
            const {
              errors
            } = this.state;
            const previousErrorCount = errors.length;
            try {
              super.parseBindingList(3, 93, true);
              return errors.length === previousErrorCount;
            } catch (_unused2) {
              return false;
            }
          }
          return false;
        }
        tsIsUnambiguouslyStartOfFunctionType() {
          this.next();
          if (this.match(11) || this.match(21)) {
            return true;
          }
          if (this.tsSkipParameterStart()) {
            if (this.match(14) || this.match(12) || this.match(17) || this.match(29)) {
              return true;
            }
            if (this.match(11)) {
              this.next();
              if (this.match(19)) {
                return true;
              }
            }
          }
          return false;
        }
        tsParseTypeOrTypePredicateAnnotation(returnToken) {
          return this.tsInType(() => {
            const t3 = this.startNode();
            this.expect(returnToken);
            const node = this.startNode();
            const asserts = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
            if (asserts && this.match(78)) {
              let thisTypePredicate = this.tsParseThisTypeOrThisTypePredicate();
              if (thisTypePredicate.type === "TSThisType") {
                node.parameterName = thisTypePredicate;
                node.asserts = true;
                node.typeAnnotation = null;
                thisTypePredicate = this.finishNode(node, "TSTypePredicate");
              } else {
                this.resetStartLocationFromNode(thisTypePredicate, node);
                thisTypePredicate.asserts = true;
              }
              t3.typeAnnotation = thisTypePredicate;
              return this.finishNode(t3, "TSTypeAnnotation");
            }
            const typePredicateVariable = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
            if (!typePredicateVariable) {
              if (!asserts) {
                return this.tsParseTypeAnnotation(false, t3);
              }
              node.parameterName = this.parseIdentifier();
              node.asserts = asserts;
              node.typeAnnotation = null;
              t3.typeAnnotation = this.finishNode(node, "TSTypePredicate");
              return this.finishNode(t3, "TSTypeAnnotation");
            }
            const type = this.tsParseTypeAnnotation(false);
            node.parameterName = typePredicateVariable;
            node.typeAnnotation = type;
            node.asserts = asserts;
            t3.typeAnnotation = this.finishNode(node, "TSTypePredicate");
            return this.finishNode(t3, "TSTypeAnnotation");
          });
        }
        tsTryParseTypeOrTypePredicateAnnotation() {
          return this.match(14) ? this.tsParseTypeOrTypePredicateAnnotation(14) : void 0;
        }
        tsTryParseTypeAnnotation() {
          return this.match(14) ? this.tsParseTypeAnnotation() : void 0;
        }
        tsTryParseType() {
          return this.tsEatThenParseType(14);
        }
        tsParseTypePredicatePrefix() {
          const id = this.parseIdentifier();
          if (this.isContextual(114) && !this.hasPrecedingLineBreak()) {
            this.next();
            return id;
          }
        }
        tsParseTypePredicateAsserts() {
          if (this.state.type !== 107) {
            return false;
          }
          const containsEsc = this.state.containsEsc;
          this.next();
          if (!tokenIsIdentifier(this.state.type) && !this.match(78)) {
            return false;
          }
          if (containsEsc) {
            this.raise(Errors.InvalidEscapedReservedWord, {
              at: this.state.lastTokStartLoc,
              reservedWord: "asserts"
            });
          }
          return true;
        }
        tsParseTypeAnnotation(eatColon = true, t3 = this.startNode()) {
          this.tsInType(() => {
            if (eatColon)
              this.expect(14);
            t3.typeAnnotation = this.tsParseType();
          });
          return this.finishNode(t3, "TSTypeAnnotation");
        }
        tsParseType() {
          assert(this.state.inType);
          const type = this.tsParseNonConditionalType();
          if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81)) {
            return type;
          }
          const node = this.startNodeAtNode(type);
          node.checkType = type;
          node.extendsType = this.tsInDisallowConditionalTypesContext(() => this.tsParseNonConditionalType());
          this.expect(17);
          node.trueType = this.tsInAllowConditionalTypesContext(() => this.tsParseType());
          this.expect(14);
          node.falseType = this.tsInAllowConditionalTypesContext(() => this.tsParseType());
          return this.finishNode(node, "TSConditionalType");
        }
        isAbstractConstructorSignature() {
          return this.isContextual(122) && this.lookahead().type === 77;
        }
        tsParseNonConditionalType() {
          if (this.tsIsStartOfFunctionType()) {
            return this.tsParseFunctionOrConstructorType("TSFunctionType");
          }
          if (this.match(77)) {
            return this.tsParseFunctionOrConstructorType("TSConstructorType");
          } else if (this.isAbstractConstructorSignature()) {
            return this.tsParseFunctionOrConstructorType("TSConstructorType", true);
          }
          return this.tsParseUnionTypeOrHigher();
        }
        tsParseTypeAssertion() {
          if (this.getPluginOption("typescript", "disallowAmbiguousJSXLike")) {
            this.raise(TSErrors.ReservedTypeAssertion, {
              at: this.state.startLoc
            });
          }
          const node = this.startNode();
          node.typeAnnotation = this.tsInType(() => {
            this.next();
            return this.match(75) ? this.tsParseTypeReference() : this.tsParseType();
          });
          this.expect(48);
          node.expression = this.parseMaybeUnary();
          return this.finishNode(node, "TSTypeAssertion");
        }
        tsParseHeritageClause(token) {
          const originalStartLoc = this.state.startLoc;
          const delimitedList = this.tsParseDelimitedList("HeritageClauseElement", () => {
            const node = this.startNode();
            node.expression = this.tsParseEntityName();
            if (this.match(47)) {
              node.typeParameters = this.tsParseTypeArguments();
            }
            return this.finishNode(node, "TSExpressionWithTypeArguments");
          });
          if (!delimitedList.length) {
            this.raise(TSErrors.EmptyHeritageClauseType, {
              at: originalStartLoc,
              token
            });
          }
          return delimitedList;
        }
        tsParseInterfaceDeclaration(node, properties = {}) {
          if (this.hasFollowingLineBreak())
            return null;
          this.expectContextual(127);
          if (properties.declare)
            node.declare = true;
          if (tokenIsIdentifier(this.state.type)) {
            node.id = this.parseIdentifier();
            this.checkIdentifier(node.id, BIND_TS_INTERFACE);
          } else {
            node.id = null;
            this.raise(TSErrors.MissingInterfaceName, {
              at: this.state.startLoc
            });
          }
          node.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this));
          if (this.eat(81)) {
            node.extends = this.tsParseHeritageClause("extends");
          }
          const body = this.startNode();
          body.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this));
          node.body = this.finishNode(body, "TSInterfaceBody");
          return this.finishNode(node, "TSInterfaceDeclaration");
        }
        tsParseTypeAliasDeclaration(node) {
          node.id = this.parseIdentifier();
          this.checkIdentifier(node.id, BIND_TS_TYPE);
          node.typeAnnotation = this.tsInType(() => {
            node.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this));
            this.expect(29);
            if (this.isContextual(112) && this.lookahead().type !== 16) {
              const node2 = this.startNode();
              this.next();
              return this.finishNode(node2, "TSIntrinsicKeyword");
            }
            return this.tsParseType();
          });
          this.semicolon();
          return this.finishNode(node, "TSTypeAliasDeclaration");
        }
        tsInNoContext(cb) {
          const oldContext = this.state.context;
          this.state.context = [oldContext[0]];
          try {
            return cb();
          } finally {
            this.state.context = oldContext;
          }
        }
        tsInType(cb) {
          const oldInType = this.state.inType;
          this.state.inType = true;
          try {
            return cb();
          } finally {
            this.state.inType = oldInType;
          }
        }
        tsInDisallowConditionalTypesContext(cb) {
          const oldInDisallowConditionalTypesContext = this.state.inDisallowConditionalTypesContext;
          this.state.inDisallowConditionalTypesContext = true;
          try {
            return cb();
          } finally {
            this.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
          }
        }
        tsInAllowConditionalTypesContext(cb) {
          const oldInDisallowConditionalTypesContext = this.state.inDisallowConditionalTypesContext;
          this.state.inDisallowConditionalTypesContext = false;
          try {
            return cb();
          } finally {
            this.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
          }
        }
        tsEatThenParseType(token) {
          return !this.match(token) ? void 0 : this.tsNextThenParseType();
        }
        tsExpectThenParseType(token) {
          return this.tsDoThenParseType(() => this.expect(token));
        }
        tsNextThenParseType() {
          return this.tsDoThenParseType(() => this.next());
        }
        tsDoThenParseType(cb) {
          return this.tsInType(() => {
            cb();
            return this.tsParseType();
          });
        }
        tsParseEnumMember() {
          const node = this.startNode();
          node.id = this.match(131) ? super.parseStringLiteral(this.state.value) : this.parseIdentifier(true);
          if (this.eat(29)) {
            node.initializer = super.parseMaybeAssignAllowIn();
          }
          return this.finishNode(node, "TSEnumMember");
        }
        tsParseEnumDeclaration(node, properties = {}) {
          if (properties.const)
            node.const = true;
          if (properties.declare)
            node.declare = true;
          this.expectContextual(124);
          node.id = this.parseIdentifier();
          this.checkIdentifier(node.id, node.const ? BIND_TS_CONST_ENUM : BIND_TS_ENUM);
          this.expect(5);
          node.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this));
          this.expect(8);
          return this.finishNode(node, "TSEnumDeclaration");
        }
        tsParseModuleBlock() {
          const node = this.startNode();
          this.scope.enter(SCOPE_OTHER);
          this.expect(5);
          super.parseBlockOrModuleBlockBody(node.body = [], void 0, true, 8);
          this.scope.exit();
          return this.finishNode(node, "TSModuleBlock");
        }
        tsParseModuleOrNamespaceDeclaration(node, nested = false) {
          node.id = this.parseIdentifier();
          if (!nested) {
            this.checkIdentifier(node.id, BIND_TS_NAMESPACE);
          }
          if (this.eat(16)) {
            const inner = this.startNode();
            this.tsParseModuleOrNamespaceDeclaration(inner, true);
            node.body = inner;
          } else {
            this.scope.enter(SCOPE_TS_MODULE);
            this.prodParam.enter(PARAM);
            node.body = this.tsParseModuleBlock();
            this.prodParam.exit();
            this.scope.exit();
          }
          return this.finishNode(node, "TSModuleDeclaration");
        }
        tsParseAmbientExternalModuleDeclaration(node) {
          if (this.isContextual(110)) {
            node.global = true;
            node.id = this.parseIdentifier();
          } else if (this.match(131)) {
            node.id = super.parseStringLiteral(this.state.value);
          } else {
            this.unexpected();
          }
          if (this.match(5)) {
            this.scope.enter(SCOPE_TS_MODULE);
            this.prodParam.enter(PARAM);
            node.body = this.tsParseModuleBlock();
            this.prodParam.exit();
            this.scope.exit();
          } else {
            this.semicolon();
          }
          return this.finishNode(node, "TSModuleDeclaration");
        }
        tsParseImportEqualsDeclaration(node, isExport) {
          node.isExport = isExport || false;
          node.id = this.parseIdentifier();
          this.checkIdentifier(node.id, BIND_FLAGS_TS_IMPORT);
          this.expect(29);
          const moduleReference = this.tsParseModuleReference();
          if (node.importKind === "type" && moduleReference.type !== "TSExternalModuleReference") {
            this.raise(TSErrors.ImportAliasHasImportType, {
              at: moduleReference
            });
          }
          node.moduleReference = moduleReference;
          this.semicolon();
          return this.finishNode(node, "TSImportEqualsDeclaration");
        }
        tsIsExternalModuleReference() {
          return this.isContextual(117) && this.lookaheadCharCode() === 40;
        }
        tsParseModuleReference() {
          return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(false);
        }
        tsParseExternalModuleReference() {
          const node = this.startNode();
          this.expectContextual(117);
          this.expect(10);
          if (!this.match(131)) {
            throw this.unexpected();
          }
          node.expression = super.parseExprAtom();
          this.expect(11);
          return this.finishNode(node, "TSExternalModuleReference");
        }
        tsLookAhead(f) {
          const state = this.state.clone();
          const res = f();
          this.state = state;
          return res;
        }
        tsTryParseAndCatch(f) {
          const result2 = this.tryParse((abort) => f() || abort());
          if (result2.aborted || !result2.node)
            return void 0;
          if (result2.error)
            this.state = result2.failState;
          return result2.node;
        }
        tsTryParse(f) {
          const state = this.state.clone();
          const result2 = f();
          if (result2 !== void 0 && result2 !== false) {
            return result2;
          } else {
            this.state = state;
            return void 0;
          }
        }
        tsTryParseDeclare(nany) {
          if (this.isLineTerminator()) {
            return;
          }
          let starttype = this.state.type;
          let kind;
          if (this.isContextual(99)) {
            starttype = 74;
            kind = "let";
          }
          return this.tsInAmbientContext(() => {
            if (starttype === 68) {
              nany.declare = true;
              return super.parseFunctionStatement(nany, false, false);
            }
            if (starttype === 80) {
              nany.declare = true;
              return this.parseClass(nany, true, false);
            }
            if (starttype === 124) {
              return this.tsParseEnumDeclaration(nany, {
                declare: true
              });
            }
            if (starttype === 110) {
              return this.tsParseAmbientExternalModuleDeclaration(nany);
            }
            if (starttype === 75 || starttype === 74) {
              if (!this.match(75) || !this.isLookaheadContextual("enum")) {
                nany.declare = true;
                return this.parseVarStatement(nany, kind || this.state.value, true);
              }
              this.expect(75);
              return this.tsParseEnumDeclaration(nany, {
                const: true,
                declare: true
              });
            }
            if (starttype === 127) {
              const result2 = this.tsParseInterfaceDeclaration(nany, {
                declare: true
              });
              if (result2)
                return result2;
            }
            if (tokenIsIdentifier(starttype)) {
              return this.tsParseDeclaration(nany, this.state.value, true, null);
            }
          });
        }
        tsTryParseExportDeclaration() {
          return this.tsParseDeclaration(this.startNode(), this.state.value, true, null);
        }
        tsParseExpressionStatement(node, expr, decorators) {
          switch (expr.name) {
            case "declare": {
              const declaration = this.tsTryParseDeclare(node);
              if (declaration) {
                declaration.declare = true;
                return declaration;
              }
              break;
            }
            case "global":
              if (this.match(5)) {
                this.scope.enter(SCOPE_TS_MODULE);
                this.prodParam.enter(PARAM);
                const mod = node;
                mod.global = true;
                mod.id = expr;
                mod.body = this.tsParseModuleBlock();
                this.scope.exit();
                this.prodParam.exit();
                return this.finishNode(mod, "TSModuleDeclaration");
              }
              break;
            default:
              return this.tsParseDeclaration(node, expr.name, false, decorators);
          }
        }
        tsParseDeclaration(node, value, next, decorators) {
          switch (value) {
            case "abstract":
              if (this.tsCheckLineTerminator(next) && (this.match(80) || tokenIsIdentifier(this.state.type))) {
                return this.tsParseAbstractDeclaration(node, decorators);
              }
              break;
            case "module":
              if (this.tsCheckLineTerminator(next)) {
                if (this.match(131)) {
                  return this.tsParseAmbientExternalModuleDeclaration(node);
                } else if (tokenIsIdentifier(this.state.type)) {
                  return this.tsParseModuleOrNamespaceDeclaration(node);
                }
              }
              break;
            case "namespace":
              if (this.tsCheckLineTerminator(next) && tokenIsIdentifier(this.state.type)) {
                return this.tsParseModuleOrNamespaceDeclaration(node);
              }
              break;
            case "type":
              if (this.tsCheckLineTerminator(next) && tokenIsIdentifier(this.state.type)) {
                return this.tsParseTypeAliasDeclaration(node);
              }
              break;
          }
        }
        tsCheckLineTerminator(next) {
          if (next) {
            if (this.hasFollowingLineBreak())
              return false;
            this.next();
            return true;
          }
          return !this.isLineTerminator();
        }
        tsTryParseGenericAsyncArrowFunction(startLoc) {
          if (!this.match(47)) {
            return void 0;
          }
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          this.state.maybeInArrowParameters = true;
          const res = this.tsTryParseAndCatch(() => {
            const node = this.startNodeAt(startLoc);
            node.typeParameters = this.tsParseTypeParameters();
            super.parseFunctionParams(node);
            node.returnType = this.tsTryParseTypeOrTypePredicateAnnotation();
            this.expect(19);
            return node;
          });
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          if (!res) {
            return void 0;
          }
          return super.parseArrowExpression(res, null, true);
        }
        tsParseTypeArgumentsInExpression() {
          if (this.reScan_lt() !== 47) {
            return void 0;
          }
          return this.tsParseTypeArguments();
        }
        tsParseTypeArguments() {
          const node = this.startNode();
          node.params = this.tsInType(() => this.tsInNoContext(() => {
            this.expect(47);
            return this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this));
          }));
          if (node.params.length === 0) {
            this.raise(TSErrors.EmptyTypeArguments, {
              at: node
            });
          }
          this.expect(48);
          return this.finishNode(node, "TSTypeParameterInstantiation");
        }
        tsIsDeclarationStart() {
          return tokenIsTSDeclarationStart(this.state.type);
        }
        isExportDefaultSpecifier() {
          if (this.tsIsDeclarationStart())
            return false;
          return super.isExportDefaultSpecifier();
        }
        parseAssignableListItem(allowModifiers, decorators) {
          const startLoc = this.state.startLoc;
          let accessibility;
          let readonly = false;
          let override = false;
          if (allowModifiers !== void 0) {
            const modified = {};
            this.tsParseModifiers({
              modified,
              allowedModifiers: ["public", "private", "protected", "override", "readonly"]
            });
            accessibility = modified.accessibility;
            override = modified.override;
            readonly = modified.readonly;
            if (allowModifiers === false && (accessibility || readonly || override)) {
              this.raise(TSErrors.UnexpectedParameterModifier, {
                at: startLoc
              });
            }
          }
          const left = this.parseMaybeDefault();
          this.parseAssignableListItemTypes(left);
          const elt = this.parseMaybeDefault(left.loc.start, left);
          if (accessibility || readonly || override) {
            const pp = this.startNodeAt(startLoc);
            if (decorators.length) {
              pp.decorators = decorators;
            }
            if (accessibility)
              pp.accessibility = accessibility;
            if (readonly)
              pp.readonly = readonly;
            if (override)
              pp.override = override;
            if (elt.type !== "Identifier" && elt.type !== "AssignmentPattern") {
              this.raise(TSErrors.UnsupportedParameterPropertyKind, {
                at: pp
              });
            }
            pp.parameter = elt;
            return this.finishNode(pp, "TSParameterProperty");
          }
          if (decorators.length) {
            left.decorators = decorators;
          }
          return elt;
        }
        isSimpleParameter(node) {
          return node.type === "TSParameterProperty" && super.isSimpleParameter(node.parameter) || super.isSimpleParameter(node);
        }
        parseFunctionBodyAndFinish(node, type, isMethod = false) {
          if (this.match(14)) {
            node.returnType = this.tsParseTypeOrTypePredicateAnnotation(14);
          }
          const bodilessType = type === "FunctionDeclaration" ? "TSDeclareFunction" : type === "ClassMethod" || type === "ClassPrivateMethod" ? "TSDeclareMethod" : void 0;
          if (bodilessType && !this.match(5) && this.isLineTerminator()) {
            return this.finishNode(node, bodilessType);
          }
          if (bodilessType === "TSDeclareFunction" && this.state.isAmbientContext) {
            this.raise(TSErrors.DeclareFunctionHasImplementation, {
              at: node
            });
            if (node.declare) {
              return super.parseFunctionBodyAndFinish(node, bodilessType, isMethod);
            }
          }
          return super.parseFunctionBodyAndFinish(node, type, isMethod);
        }
        registerFunctionStatementId(node) {
          if (!node.body && node.id) {
            this.checkIdentifier(node.id, BIND_TS_AMBIENT);
          } else {
            super.registerFunctionStatementId(node);
          }
        }
        tsCheckForInvalidTypeCasts(items) {
          items.forEach((node) => {
            if ((node == null ? void 0 : node.type) === "TSTypeCastExpression") {
              this.raise(TSErrors.UnexpectedTypeAnnotation, {
                at: node.typeAnnotation
              });
            }
          });
        }
        toReferencedList(exprList, isInParens) {
          this.tsCheckForInvalidTypeCasts(exprList);
          return exprList;
        }
        parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
          const node = super.parseArrayLike(close, canBePattern, isTuple, refExpressionErrors);
          if (node.type === "ArrayExpression") {
            this.tsCheckForInvalidTypeCasts(node.elements);
          }
          return node;
        }
        parseSubscript(base, startLoc, noCalls, state) {
          if (!this.hasPrecedingLineBreak() && this.match(35)) {
            this.state.canStartJSXElement = false;
            this.next();
            const nonNullExpression = this.startNodeAt(startLoc);
            nonNullExpression.expression = base;
            return this.finishNode(nonNullExpression, "TSNonNullExpression");
          }
          let isOptionalCall = false;
          if (this.match(18) && this.lookaheadCharCode() === 60) {
            if (noCalls) {
              state.stop = true;
              return base;
            }
            state.optionalChainMember = isOptionalCall = true;
            this.next();
          }
          if (this.match(47) || this.match(51)) {
            let missingParenErrorLoc;
            const result2 = this.tsTryParseAndCatch(() => {
              if (!noCalls && this.atPossibleAsyncArrow(base)) {
                const asyncArrowFn = this.tsTryParseGenericAsyncArrowFunction(startLoc);
                if (asyncArrowFn) {
                  return asyncArrowFn;
                }
              }
              const typeArguments = this.tsParseTypeArgumentsInExpression();
              if (!typeArguments)
                return;
              if (isOptionalCall && !this.match(10)) {
                missingParenErrorLoc = this.state.curPosition();
                return;
              }
              if (tokenIsTemplate(this.state.type)) {
                const result3 = super.parseTaggedTemplateExpression(base, startLoc, state);
                result3.typeParameters = typeArguments;
                return result3;
              }
              if (!noCalls && this.eat(10)) {
                const node2 = this.startNodeAt(startLoc);
                node2.callee = base;
                node2.arguments = this.parseCallExpressionArguments(11, false);
                this.tsCheckForInvalidTypeCasts(node2.arguments);
                node2.typeParameters = typeArguments;
                if (state.optionalChainMember) {
                  node2.optional = isOptionalCall;
                }
                return this.finishCallExpression(node2, state.optionalChainMember);
              }
              const tokenType = this.state.type;
              if (tokenType === 48 || tokenType === 52 || tokenType !== 10 && tokenCanStartExpression(tokenType) && !this.hasPrecedingLineBreak()) {
                return;
              }
              const node = this.startNodeAt(startLoc);
              node.expression = base;
              node.typeParameters = typeArguments;
              return this.finishNode(node, "TSInstantiationExpression");
            });
            if (missingParenErrorLoc) {
              this.unexpected(missingParenErrorLoc, 10);
            }
            if (result2) {
              if (result2.type === "TSInstantiationExpression" && (this.match(16) || this.match(18) && this.lookaheadCharCode() !== 40)) {
                this.raise(TSErrors.InvalidPropertyAccessAfterInstantiationExpression, {
                  at: this.state.startLoc
                });
              }
              return result2;
            }
          }
          return super.parseSubscript(base, startLoc, noCalls, state);
        }
        parseNewCallee(node) {
          var _callee$extra;
          super.parseNewCallee(node);
          const {
            callee
          } = node;
          if (callee.type === "TSInstantiationExpression" && !((_callee$extra = callee.extra) != null && _callee$extra.parenthesized)) {
            node.typeParameters = callee.typeParameters;
            node.callee = callee.expression;
          }
        }
        parseExprOp(left, leftStartLoc, minPrec) {
          let isSatisfies;
          if (tokenOperatorPrecedence(58) > minPrec && !this.hasPrecedingLineBreak() && (this.isContextual(93) || (isSatisfies = this.isContextual(118)))) {
            const node = this.startNodeAt(leftStartLoc);
            node.expression = left;
            node.typeAnnotation = this.tsInType(() => {
              this.next();
              if (this.match(75)) {
                if (isSatisfies) {
                  this.raise(Errors.UnexpectedKeyword, {
                    at: this.state.startLoc,
                    keyword: "const"
                  });
                }
                return this.tsParseTypeReference();
              }
              return this.tsParseType();
            });
            this.finishNode(node, isSatisfies ? "TSSatisfiesExpression" : "TSAsExpression");
            this.reScan_lt_gt();
            return this.parseExprOp(
              node,
              leftStartLoc,
              minPrec
            );
          }
          return super.parseExprOp(left, leftStartLoc, minPrec);
        }
        checkReservedWord(word, startLoc, checkKeywords, isBinding) {
          if (!this.state.isAmbientContext) {
            super.checkReservedWord(word, startLoc, checkKeywords, isBinding);
          }
        }
        checkImportReflection(node) {
          super.checkImportReflection(node);
          if (node.module && node.importKind !== "value") {
            this.raise(TSErrors.ImportReflectionHasImportType, {
              at: node.specifiers[0].loc.start
            });
          }
        }
        checkDuplicateExports() {
        }
        parseImport(node) {
          node.importKind = "value";
          if (tokenIsIdentifier(this.state.type) || this.match(55) || this.match(5)) {
            let ahead = this.lookahead();
            if (this.isContextual(128) && ahead.type !== 12 && ahead.type !== 97 && ahead.type !== 29) {
              node.importKind = "type";
              this.next();
              ahead = this.lookahead();
            }
            if (tokenIsIdentifier(this.state.type) && ahead.type === 29) {
              return this.tsParseImportEqualsDeclaration(node);
            }
          }
          const importNode = super.parseImport(node);
          if (importNode.importKind === "type" && importNode.specifiers.length > 1 && importNode.specifiers[0].type === "ImportDefaultSpecifier") {
            this.raise(TSErrors.TypeImportCannotSpecifyDefaultAndNamed, {
              at: importNode
            });
          }
          return importNode;
        }
        parseExport(node, decorators) {
          if (this.match(83)) {
            this.next();
            if (this.isContextual(128) && this.lookaheadCharCode() !== 61) {
              node.importKind = "type";
              this.next();
            } else {
              node.importKind = "value";
            }
            return this.tsParseImportEqualsDeclaration(node, true);
          } else if (this.eat(29)) {
            const assign2 = node;
            assign2.expression = super.parseExpression();
            this.semicolon();
            return this.finishNode(assign2, "TSExportAssignment");
          } else if (this.eatContextual(93)) {
            const decl = node;
            this.expectContextual(126);
            decl.id = this.parseIdentifier();
            this.semicolon();
            return this.finishNode(decl, "TSNamespaceExportDeclaration");
          } else {
            if (this.isContextual(128) && this.lookahead().type === 5) {
              this.next();
              node.exportKind = "type";
            } else {
              node.exportKind = "value";
            }
            return super.parseExport(node, decorators);
          }
        }
        isAbstractClass() {
          return this.isContextual(122) && this.lookahead().type === 80;
        }
        parseExportDefaultExpression() {
          if (this.isAbstractClass()) {
            const cls = this.startNode();
            this.next();
            cls.abstract = true;
            return this.parseClass(cls, true, true);
          }
          if (this.match(127)) {
            const result2 = this.tsParseInterfaceDeclaration(this.startNode());
            if (result2)
              return result2;
          }
          return super.parseExportDefaultExpression();
        }
        parseVarStatement(node, kind, allowMissingInitializer = false) {
          const {
            isAmbientContext
          } = this.state;
          const declaration = super.parseVarStatement(node, kind, allowMissingInitializer || isAmbientContext);
          if (!isAmbientContext)
            return declaration;
          for (const {
            id,
            init
          } of declaration.declarations) {
            if (!init)
              continue;
            if (kind !== "const" || !!id.typeAnnotation) {
              this.raise(TSErrors.InitializerNotAllowedInAmbientContext, {
                at: init
              });
            } else if (init.type !== "StringLiteral" && init.type !== "BooleanLiteral" && init.type !== "NumericLiteral" && init.type !== "BigIntLiteral" && (init.type !== "TemplateLiteral" || init.expressions.length > 0) && !isPossiblyLiteralEnum(init)) {
              this.raise(TSErrors.ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference, {
                at: init
              });
            }
          }
          return declaration;
        }
        parseStatementContent(flags, decorators) {
          if (this.match(75) && this.isLookaheadContextual("enum")) {
            const node = this.startNode();
            this.expect(75);
            return this.tsParseEnumDeclaration(node, {
              const: true
            });
          }
          if (this.isContextual(124)) {
            return this.tsParseEnumDeclaration(this.startNode());
          }
          if (this.isContextual(127)) {
            const result2 = this.tsParseInterfaceDeclaration(this.startNode());
            if (result2)
              return result2;
          }
          return super.parseStatementContent(flags, decorators);
        }
        parseAccessModifier() {
          return this.tsParseModifier(["public", "protected", "private"]);
        }
        tsHasSomeModifiers(member, modifiers) {
          return modifiers.some((modifier) => {
            if (tsIsAccessModifier(modifier)) {
              return member.accessibility === modifier;
            }
            return !!member[modifier];
          });
        }
        tsIsStartOfStaticBlocks() {
          return this.isContextual(104) && this.lookaheadCharCode() === 123;
        }
        parseClassMember(classBody, member, state) {
          const modifiers = ["declare", "private", "public", "protected", "override", "abstract", "readonly", "static"];
          this.tsParseModifiers({
            modified: member,
            allowedModifiers: modifiers,
            disallowedModifiers: ["in", "out"],
            stopOnStartOfClassStaticBlock: true,
            errorTemplate: TSErrors.InvalidModifierOnTypeParameterPositions
          });
          const callParseClassMemberWithIsStatic = () => {
            if (this.tsIsStartOfStaticBlocks()) {
              this.next();
              this.next();
              if (this.tsHasSomeModifiers(member, modifiers)) {
                this.raise(TSErrors.StaticBlockCannotHaveModifier, {
                  at: this.state.curPosition()
                });
              }
              super.parseClassStaticBlock(classBody, member);
            } else {
              this.parseClassMemberWithIsStatic(classBody, member, state, !!member.static);
            }
          };
          if (member.declare) {
            this.tsInAmbientContext(callParseClassMemberWithIsStatic);
          } else {
            callParseClassMemberWithIsStatic();
          }
        }
        parseClassMemberWithIsStatic(classBody, member, state, isStatic) {
          const idx = this.tsTryParseIndexSignature(member);
          if (idx) {
            classBody.body.push(idx);
            if (member.abstract) {
              this.raise(TSErrors.IndexSignatureHasAbstract, {
                at: member
              });
            }
            if (member.accessibility) {
              this.raise(TSErrors.IndexSignatureHasAccessibility, {
                at: member,
                modifier: member.accessibility
              });
            }
            if (member.declare) {
              this.raise(TSErrors.IndexSignatureHasDeclare, {
                at: member
              });
            }
            if (member.override) {
              this.raise(TSErrors.IndexSignatureHasOverride, {
                at: member
              });
            }
            return;
          }
          if (!this.state.inAbstractClass && member.abstract) {
            this.raise(TSErrors.NonAbstractClassHasAbstractMethod, {
              at: member
            });
          }
          if (member.override) {
            if (!state.hadSuperClass) {
              this.raise(TSErrors.OverrideNotInSubClass, {
                at: member
              });
            }
          }
          super.parseClassMemberWithIsStatic(classBody, member, state, isStatic);
        }
        parsePostMemberNameModifiers(methodOrProp) {
          const optional = this.eat(17);
          if (optional)
            methodOrProp.optional = true;
          if (methodOrProp.readonly && this.match(10)) {
            this.raise(TSErrors.ClassMethodHasReadonly, {
              at: methodOrProp
            });
          }
          if (methodOrProp.declare && this.match(10)) {
            this.raise(TSErrors.ClassMethodHasDeclare, {
              at: methodOrProp
            });
          }
        }
        parseExpressionStatement(node, expr, decorators) {
          const decl = expr.type === "Identifier" ? this.tsParseExpressionStatement(node, expr, decorators) : void 0;
          return decl || super.parseExpressionStatement(node, expr, decorators);
        }
        shouldParseExportDeclaration() {
          if (this.tsIsDeclarationStart())
            return true;
          return super.shouldParseExportDeclaration();
        }
        parseConditional(expr, startLoc, refExpressionErrors) {
          if (!this.state.maybeInArrowParameters || !this.match(17)) {
            return super.parseConditional(expr, startLoc, refExpressionErrors);
          }
          const result2 = this.tryParse(() => super.parseConditional(expr, startLoc));
          if (!result2.node) {
            if (result2.error) {
              super.setOptionalParametersError(refExpressionErrors, result2.error);
            }
            return expr;
          }
          if (result2.error)
            this.state = result2.failState;
          return result2.node;
        }
        parseParenItem(node, startLoc) {
          node = super.parseParenItem(node, startLoc);
          if (this.eat(17)) {
            node.optional = true;
            this.resetEndLocation(node);
          }
          if (this.match(14)) {
            const typeCastNode = this.startNodeAt(startLoc);
            typeCastNode.expression = node;
            typeCastNode.typeAnnotation = this.tsParseTypeAnnotation();
            return this.finishNode(typeCastNode, "TSTypeCastExpression");
          }
          return node;
        }
        parseExportDeclaration(node) {
          if (!this.state.isAmbientContext && this.isContextual(123)) {
            return this.tsInAmbientContext(() => this.parseExportDeclaration(node));
          }
          const startLoc = this.state.startLoc;
          const isDeclare = this.eatContextual(123);
          if (isDeclare && (this.isContextual(123) || !this.shouldParseExportDeclaration())) {
            throw this.raise(TSErrors.ExpectedAmbientAfterExportDeclare, {
              at: this.state.startLoc
            });
          }
          const isIdentifier2 = tokenIsIdentifier(this.state.type);
          const declaration = isIdentifier2 && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(node);
          if (!declaration)
            return null;
          if (declaration.type === "TSInterfaceDeclaration" || declaration.type === "TSTypeAliasDeclaration" || isDeclare) {
            node.exportKind = "type";
          }
          if (isDeclare) {
            this.resetStartLocation(declaration, startLoc);
            declaration.declare = true;
          }
          return declaration;
        }
        parseClassId(node, isStatement, optionalId, bindingType) {
          if ((!isStatement || optionalId) && this.isContextual(111)) {
            return;
          }
          super.parseClassId(node, isStatement, optionalId, node.declare ? BIND_TS_AMBIENT : BIND_CLASS);
          const typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this));
          if (typeParameters)
            node.typeParameters = typeParameters;
        }
        parseClassPropertyAnnotation(node) {
          if (!node.optional && this.eat(35)) {
            node.definite = true;
          }
          const type = this.tsTryParseTypeAnnotation();
          if (type)
            node.typeAnnotation = type;
        }
        parseClassProperty(node) {
          this.parseClassPropertyAnnotation(node);
          if (this.state.isAmbientContext && !(node.readonly && !node.typeAnnotation) && this.match(29)) {
            this.raise(TSErrors.DeclareClassFieldHasInitializer, {
              at: this.state.startLoc
            });
          }
          if (node.abstract && this.match(29)) {
            const {
              key
            } = node;
            this.raise(TSErrors.AbstractPropertyHasInitializer, {
              at: this.state.startLoc,
              propertyName: key.type === "Identifier" && !node.computed ? key.name : `[${this.input.slice(key.start, key.end)}]`
            });
          }
          return super.parseClassProperty(node);
        }
        parseClassPrivateProperty(node) {
          if (node.abstract) {
            this.raise(TSErrors.PrivateElementHasAbstract, {
              at: node
            });
          }
          if (node.accessibility) {
            this.raise(TSErrors.PrivateElementHasAccessibility, {
              at: node,
              modifier: node.accessibility
            });
          }
          this.parseClassPropertyAnnotation(node);
          return super.parseClassPrivateProperty(node);
        }
        pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
          const typeParameters = this.tsTryParseTypeParameters();
          if (typeParameters && isConstructor) {
            this.raise(TSErrors.ConstructorHasTypeParameters, {
              at: typeParameters
            });
          }
          const {
            declare = false,
            kind
          } = method2;
          if (declare && (kind === "get" || kind === "set")) {
            this.raise(TSErrors.DeclareAccessor, {
              at: method2,
              kind
            });
          }
          if (typeParameters)
            method2.typeParameters = typeParameters;
          super.pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper);
        }
        pushClassPrivateMethod(classBody, method2, isGenerator, isAsync) {
          const typeParameters = this.tsTryParseTypeParameters();
          if (typeParameters)
            method2.typeParameters = typeParameters;
          super.pushClassPrivateMethod(classBody, method2, isGenerator, isAsync);
        }
        declareClassPrivateMethodInScope(node, kind) {
          if (node.type === "TSDeclareMethod")
            return;
          if (node.type === "MethodDefinition" && !node.value.body)
            return;
          super.declareClassPrivateMethodInScope(node, kind);
        }
        parseClassSuper(node) {
          super.parseClassSuper(node);
          if (node.superClass && (this.match(47) || this.match(51))) {
            node.superTypeParameters = this.tsParseTypeArgumentsInExpression();
          }
          if (this.eatContextual(111)) {
            node.implements = this.tsParseHeritageClause("implements");
          }
        }
        parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
          const typeParameters = this.tsTryParseTypeParameters();
          if (typeParameters)
            prop.typeParameters = typeParameters;
          return super.parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors);
        }
        parseFunctionParams(node, allowModifiers) {
          const typeParameters = this.tsTryParseTypeParameters();
          if (typeParameters)
            node.typeParameters = typeParameters;
          super.parseFunctionParams(node, allowModifiers);
        }
        parseVarId(decl, kind) {
          super.parseVarId(decl, kind);
          if (decl.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35)) {
            decl.definite = true;
          }
          const type = this.tsTryParseTypeAnnotation();
          if (type) {
            decl.id.typeAnnotation = type;
            this.resetEndLocation(decl.id);
          }
        }
        parseAsyncArrowFromCallExpression(node, call) {
          if (this.match(14)) {
            node.returnType = this.tsParseTypeAnnotation();
          }
          return super.parseAsyncArrowFromCallExpression(node, call);
        }
        parseMaybeAssign(refExpressionErrors, afterLeftParse) {
          var _jsx, _jsx2, _typeCast, _jsx3, _typeCast2, _jsx4, _typeCast3;
          let state;
          let jsx2;
          let typeCast;
          if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
            state = this.state.clone();
            jsx2 = this.tryParse(() => super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
            if (!jsx2.error)
              return jsx2.node;
            const {
              context
            } = this.state;
            const currentContext = context[context.length - 1];
            if (currentContext === types.j_oTag || currentContext === types.j_expr) {
              context.pop();
            }
          }
          if (!((_jsx = jsx2) != null && _jsx.error) && !this.match(47)) {
            return super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
          }
          if (!state || state === this.state)
            state = this.state.clone();
          let typeParameters;
          const arrow = this.tryParse((abort) => {
            var _expr$extra, _typeParameters;
            typeParameters = this.tsParseTypeParameters();
            const expr = super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
            if (expr.type !== "ArrowFunctionExpression" || (_expr$extra = expr.extra) != null && _expr$extra.parenthesized) {
              abort();
            }
            if (((_typeParameters = typeParameters) == null ? void 0 : _typeParameters.params.length) !== 0) {
              this.resetStartLocationFromNode(expr, typeParameters);
            }
            expr.typeParameters = typeParameters;
            return expr;
          }, state);
          if (!arrow.error && !arrow.aborted) {
            if (typeParameters)
              this.reportReservedArrowTypeParam(typeParameters);
            return arrow.node;
          }
          if (!jsx2) {
            assert(!this.hasPlugin("jsx"));
            typeCast = this.tryParse(() => super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
            if (!typeCast.error)
              return typeCast.node;
          }
          if ((_jsx2 = jsx2) != null && _jsx2.node) {
            this.state = jsx2.failState;
            return jsx2.node;
          }
          if (arrow.node) {
            this.state = arrow.failState;
            if (typeParameters)
              this.reportReservedArrowTypeParam(typeParameters);
            return arrow.node;
          }
          if ((_typeCast = typeCast) != null && _typeCast.node) {
            this.state = typeCast.failState;
            return typeCast.node;
          }
          if ((_jsx3 = jsx2) != null && _jsx3.thrown)
            throw jsx2.error;
          if (arrow.thrown)
            throw arrow.error;
          if ((_typeCast2 = typeCast) != null && _typeCast2.thrown)
            throw typeCast.error;
          throw ((_jsx4 = jsx2) == null ? void 0 : _jsx4.error) || arrow.error || ((_typeCast3 = typeCast) == null ? void 0 : _typeCast3.error);
        }
        reportReservedArrowTypeParam(node) {
          var _node$extra;
          if (node.params.length === 1 && !((_node$extra = node.extra) != null && _node$extra.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike")) {
            this.raise(TSErrors.ReservedArrowTypeParam, {
              at: node
            });
          }
        }
        parseMaybeUnary(refExpressionErrors, sawUnary) {
          if (!this.hasPlugin("jsx") && this.match(47)) {
            return this.tsParseTypeAssertion();
          } else {
            return super.parseMaybeUnary(refExpressionErrors, sawUnary);
          }
        }
        parseArrow(node) {
          if (this.match(14)) {
            const result2 = this.tryParse((abort) => {
              const returnType = this.tsParseTypeOrTypePredicateAnnotation(14);
              if (this.canInsertSemicolon() || !this.match(19))
                abort();
              return returnType;
            });
            if (result2.aborted)
              return;
            if (!result2.thrown) {
              if (result2.error)
                this.state = result2.failState;
              node.returnType = result2.node;
            }
          }
          return super.parseArrow(node);
        }
        parseAssignableListItemTypes(param) {
          if (this.eat(17)) {
            if (param.type !== "Identifier" && !this.state.isAmbientContext && !this.state.inType) {
              this.raise(TSErrors.PatternIsOptional, {
                at: param
              });
            }
            param.optional = true;
          }
          const type = this.tsTryParseTypeAnnotation();
          if (type)
            param.typeAnnotation = type;
          this.resetEndLocation(param);
          return param;
        }
        isAssignable(node, isBinding) {
          switch (node.type) {
            case "TSTypeCastExpression":
              return this.isAssignable(node.expression, isBinding);
            case "TSParameterProperty":
              return true;
            default:
              return super.isAssignable(node, isBinding);
          }
        }
        toAssignable(node, isLHS = false) {
          switch (node.type) {
            case "ParenthesizedExpression":
              this.toAssignableParenthesizedExpression(node, isLHS);
              break;
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSNonNullExpression":
            case "TSTypeAssertion":
              if (isLHS) {
                this.expressionScope.recordArrowParemeterBindingError(TSErrors.UnexpectedTypeCastInParameter, {
                  at: node
                });
              } else {
                this.raise(TSErrors.UnexpectedTypeCastInParameter, {
                  at: node
                });
              }
              this.toAssignable(node.expression, isLHS);
              break;
            case "AssignmentExpression":
              if (!isLHS && node.left.type === "TSTypeCastExpression") {
                node.left = this.typeCastToParameter(node.left);
              }
            default:
              super.toAssignable(node, isLHS);
          }
        }
        toAssignableParenthesizedExpression(node, isLHS) {
          switch (node.expression.type) {
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSNonNullExpression":
            case "TSTypeAssertion":
            case "ParenthesizedExpression":
              this.toAssignable(node.expression, isLHS);
              break;
            default:
              super.toAssignable(node, isLHS);
          }
        }
        checkToRestConversion(node, allowPattern) {
          switch (node.type) {
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSTypeAssertion":
            case "TSNonNullExpression":
              this.checkToRestConversion(node.expression, false);
              break;
            default:
              super.checkToRestConversion(node, allowPattern);
          }
        }
        isValidLVal(type, isUnparenthesizedInAssign, binding) {
          return getOwn$1({
            TSTypeCastExpression: true,
            TSParameterProperty: "parameter",
            TSNonNullExpression: "expression",
            TSAsExpression: (binding !== BIND_NONE || !isUnparenthesizedInAssign) && ["expression", true],
            TSSatisfiesExpression: (binding !== BIND_NONE || !isUnparenthesizedInAssign) && ["expression", true],
            TSTypeAssertion: (binding !== BIND_NONE || !isUnparenthesizedInAssign) && ["expression", true]
          }, type) || super.isValidLVal(type, isUnparenthesizedInAssign, binding);
        }
        parseBindingAtom() {
          switch (this.state.type) {
            case 78:
              return this.parseIdentifier(true);
            default:
              return super.parseBindingAtom();
          }
        }
        parseMaybeDecoratorArguments(expr) {
          if (this.match(47) || this.match(51)) {
            const typeArguments = this.tsParseTypeArgumentsInExpression();
            if (this.match(10)) {
              const call = super.parseMaybeDecoratorArguments(expr);
              call.typeParameters = typeArguments;
              return call;
            }
            this.unexpected(null, 10);
          }
          return super.parseMaybeDecoratorArguments(expr);
        }
        checkCommaAfterRest(close) {
          if (this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === close) {
            this.next();
            return false;
          } else {
            return super.checkCommaAfterRest(close);
          }
        }
        isClassMethod() {
          return this.match(47) || super.isClassMethod();
        }
        isClassProperty() {
          return this.match(35) || this.match(14) || super.isClassProperty();
        }
        parseMaybeDefault(startLoc, left) {
          const node = super.parseMaybeDefault(startLoc, left);
          if (node.type === "AssignmentPattern" && node.typeAnnotation && node.right.start < node.typeAnnotation.start) {
            this.raise(TSErrors.TypeAnnotationAfterAssign, {
              at: node.typeAnnotation
            });
          }
          return node;
        }
        getTokenFromCode(code) {
          if (this.state.inType) {
            if (code === 62) {
              return this.finishOp(48, 1);
            }
            if (code === 60) {
              return this.finishOp(47, 1);
            }
          }
          return super.getTokenFromCode(code);
        }
        reScan_lt_gt() {
          const {
            type
          } = this.state;
          if (type === 47) {
            this.state.pos -= 1;
            this.readToken_lt();
          } else if (type === 48) {
            this.state.pos -= 1;
            this.readToken_gt();
          }
        }
        reScan_lt() {
          const {
            type
          } = this.state;
          if (type === 51) {
            this.state.pos -= 2;
            this.finishOp(47, 1);
            return 47;
          }
          return type;
        }
        toAssignableList(exprList, trailingCommaLoc, isLHS) {
          for (let i = 0; i < exprList.length; i++) {
            const expr = exprList[i];
            if ((expr == null ? void 0 : expr.type) === "TSTypeCastExpression") {
              exprList[i] = this.typeCastToParameter(expr);
            }
          }
          super.toAssignableList(exprList, trailingCommaLoc, isLHS);
        }
        typeCastToParameter(node) {
          node.expression.typeAnnotation = node.typeAnnotation;
          this.resetEndLocation(node.expression, node.typeAnnotation.loc.end);
          return node.expression;
        }
        shouldParseArrow(params) {
          if (this.match(14)) {
            return params.every((expr) => this.isAssignable(expr, true));
          }
          return super.shouldParseArrow(params);
        }
        shouldParseAsyncArrow() {
          return this.match(14) || super.shouldParseAsyncArrow();
        }
        canHaveLeadingDecorator() {
          return super.canHaveLeadingDecorator() || this.isAbstractClass();
        }
        jsxParseOpeningElementAfterName(node) {
          if (this.match(47) || this.match(51)) {
            const typeArguments = this.tsTryParseAndCatch(() => this.tsParseTypeArgumentsInExpression());
            if (typeArguments)
              node.typeParameters = typeArguments;
          }
          return super.jsxParseOpeningElementAfterName(node);
        }
        getGetterSetterExpectedParamCount(method2) {
          const baseCount = super.getGetterSetterExpectedParamCount(method2);
          const params = this.getObjectOrClassMethodParams(method2);
          const firstParam = params[0];
          const hasContextParam = firstParam && this.isThisParam(firstParam);
          return hasContextParam ? baseCount + 1 : baseCount;
        }
        parseCatchClauseParam() {
          const param = super.parseCatchClauseParam();
          const type = this.tsTryParseTypeAnnotation();
          if (type) {
            param.typeAnnotation = type;
            this.resetEndLocation(param);
          }
          return param;
        }
        tsInAmbientContext(cb) {
          const oldIsAmbientContext = this.state.isAmbientContext;
          this.state.isAmbientContext = true;
          try {
            return cb();
          } finally {
            this.state.isAmbientContext = oldIsAmbientContext;
          }
        }
        parseClass(node, isStatement, optionalId) {
          const oldInAbstractClass = this.state.inAbstractClass;
          this.state.inAbstractClass = !!node.abstract;
          try {
            return super.parseClass(node, isStatement, optionalId);
          } finally {
            this.state.inAbstractClass = oldInAbstractClass;
          }
        }
        tsParseAbstractDeclaration(node, decorators) {
          if (this.match(80)) {
            node.abstract = true;
            return this.maybeTakeDecorators(decorators, this.parseClass(node, true, false));
          } else if (this.isContextual(127)) {
            if (!this.hasFollowingLineBreak()) {
              node.abstract = true;
              this.raise(TSErrors.NonClassMethodPropertyHasAbstractModifer, {
                at: node
              });
              return this.tsParseInterfaceDeclaration(node);
            }
          } else {
            this.unexpected(null, 80);
          }
        }
        parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope) {
          const method2 = super.parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope);
          if (method2.abstract) {
            const hasBody = this.hasPlugin("estree") ? !!method2.value.body : !!method2.body;
            if (hasBody) {
              const {
                key
              } = method2;
              this.raise(TSErrors.AbstractMethodHasImplementation, {
                at: method2,
                methodName: key.type === "Identifier" && !method2.computed ? key.name : `[${this.input.slice(key.start, key.end)}]`
              });
            }
          }
          return method2;
        }
        tsParseTypeParameterName() {
          const typeName = this.parseIdentifier();
          return typeName.name;
        }
        shouldParseAsAmbientContext() {
          return !!this.getPluginOption("typescript", "dts");
        }
        parse() {
          if (this.shouldParseAsAmbientContext()) {
            this.state.isAmbientContext = true;
          }
          return super.parse();
        }
        getExpression() {
          if (this.shouldParseAsAmbientContext()) {
            this.state.isAmbientContext = true;
          }
          return super.getExpression();
        }
        parseExportSpecifier(node, isString2, isInTypeExport, isMaybeTypeOnly) {
          if (!isString2 && isMaybeTypeOnly) {
            this.parseTypeOnlyImportExportSpecifier(node, false, isInTypeExport);
            return this.finishNode(node, "ExportSpecifier");
          }
          node.exportKind = "value";
          return super.parseExportSpecifier(node, isString2, isInTypeExport, isMaybeTypeOnly);
        }
        parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
          if (!importedIsString && isMaybeTypeOnly) {
            this.parseTypeOnlyImportExportSpecifier(specifier, true, isInTypeOnlyImport);
            return this.finishNode(specifier, "ImportSpecifier");
          }
          specifier.importKind = "value";
          return super.parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, isInTypeOnlyImport ? BIND_TS_TYPE_IMPORT : BIND_FLAGS_TS_IMPORT);
        }
        parseTypeOnlyImportExportSpecifier(node, isImport, isInTypeOnlyImportExport) {
          const leftOfAsKey = isImport ? "imported" : "local";
          const rightOfAsKey = isImport ? "local" : "exported";
          let leftOfAs = node[leftOfAsKey];
          let rightOfAs;
          let hasTypeSpecifier = false;
          let canParseAsKeyword = true;
          const loc = leftOfAs.loc.start;
          if (this.isContextual(93)) {
            const firstAs = this.parseIdentifier();
            if (this.isContextual(93)) {
              const secondAs = this.parseIdentifier();
              if (tokenIsKeywordOrIdentifier(this.state.type)) {
                hasTypeSpecifier = true;
                leftOfAs = firstAs;
                rightOfAs = isImport ? this.parseIdentifier() : this.parseModuleExportName();
                canParseAsKeyword = false;
              } else {
                rightOfAs = secondAs;
                canParseAsKeyword = false;
              }
            } else if (tokenIsKeywordOrIdentifier(this.state.type)) {
              canParseAsKeyword = false;
              rightOfAs = isImport ? this.parseIdentifier() : this.parseModuleExportName();
            } else {
              hasTypeSpecifier = true;
              leftOfAs = firstAs;
            }
          } else if (tokenIsKeywordOrIdentifier(this.state.type)) {
            hasTypeSpecifier = true;
            if (isImport) {
              leftOfAs = this.parseIdentifier(true);
              if (!this.isContextual(93)) {
                this.checkReservedWord(leftOfAs.name, leftOfAs.loc.start, true, true);
              }
            } else {
              leftOfAs = this.parseModuleExportName();
            }
          }
          if (hasTypeSpecifier && isInTypeOnlyImportExport) {
            this.raise(isImport ? TSErrors.TypeModifierIsUsedInTypeImports : TSErrors.TypeModifierIsUsedInTypeExports, {
              at: loc
            });
          }
          node[leftOfAsKey] = leftOfAs;
          node[rightOfAsKey] = rightOfAs;
          const kindKey = isImport ? "importKind" : "exportKind";
          node[kindKey] = hasTypeSpecifier ? "type" : "value";
          if (canParseAsKeyword && this.eatContextual(93)) {
            node[rightOfAsKey] = isImport ? this.parseIdentifier() : this.parseModuleExportName();
          }
          if (!node[rightOfAsKey]) {
            node[rightOfAsKey] = cloneIdentifier(node[leftOfAsKey]);
          }
          if (isImport) {
            this.checkIdentifier(node[rightOfAsKey], hasTypeSpecifier ? BIND_TS_TYPE_IMPORT : BIND_FLAGS_TS_IMPORT);
          }
        }
      };
      function isPossiblyLiteralEnum(expression) {
        if (expression.type !== "MemberExpression")
          return false;
        const {
          computed,
          property: property2
        } = expression;
        if (computed && property2.type !== "StringLiteral" && (property2.type !== "TemplateLiteral" || property2.expressions.length > 0)) {
          return false;
        }
        return isUncomputedMemberExpressionChain(expression.object);
      }
      function isUncomputedMemberExpressionChain(expression) {
        if (expression.type === "Identifier")
          return true;
        if (expression.type !== "MemberExpression")
          return false;
        if (expression.computed)
          return false;
        return isUncomputedMemberExpressionChain(expression.object);
      }
      var PlaceholderErrors = ParseErrorEnum`placeholders`({
        ClassNameIsRequired: "A class name is required.",
        UnexpectedSpace: "Unexpected space in placeholder."
      });
      var placeholders = (superClass) => class PlaceholdersParserMixin extends superClass {
        parsePlaceholder(expectedNode) {
          if (this.match(142)) {
            const node = this.startNode();
            this.next();
            this.assertNoSpace();
            node.name = super.parseIdentifier(true);
            this.assertNoSpace();
            this.expect(142);
            return this.finishPlaceholder(node, expectedNode);
          }
        }
        finishPlaceholder(node, expectedNode) {
          const isFinished = !!(node.expectedNode && node.type === "Placeholder");
          node.expectedNode = expectedNode;
          return isFinished ? node : this.finishNode(node, "Placeholder");
        }
        getTokenFromCode(code) {
          if (code === 37 && this.input.charCodeAt(this.state.pos + 1) === 37) {
            return this.finishOp(142, 2);
          }
          return super.getTokenFromCode(code);
        }
        parseExprAtom(refExpressionErrors) {
          return this.parsePlaceholder("Expression") || super.parseExprAtom(refExpressionErrors);
        }
        parseIdentifier(liberal) {
          return this.parsePlaceholder("Identifier") || super.parseIdentifier(liberal);
        }
        checkReservedWord(word, startLoc, checkKeywords, isBinding) {
          if (word !== void 0) {
            super.checkReservedWord(word, startLoc, checkKeywords, isBinding);
          }
        }
        parseBindingAtom() {
          return this.parsePlaceholder("Pattern") || super.parseBindingAtom();
        }
        isValidLVal(type, isParenthesized, binding) {
          return type === "Placeholder" || super.isValidLVal(type, isParenthesized, binding);
        }
        toAssignable(node, isLHS) {
          if (node && node.type === "Placeholder" && node.expectedNode === "Expression") {
            node.expectedNode = "Pattern";
          } else {
            super.toAssignable(node, isLHS);
          }
        }
        chStartsBindingIdentifier(ch, pos) {
          if (super.chStartsBindingIdentifier(ch, pos)) {
            return true;
          }
          const nextToken = this.lookahead();
          if (nextToken.type === 142) {
            return true;
          }
          return false;
        }
        verifyBreakContinue(node, isBreak) {
          if (node.label && node.label.type === "Placeholder")
            return;
          super.verifyBreakContinue(node, isBreak);
        }
        parseExpressionStatement(node, expr) {
          if (expr.type !== "Placeholder" || expr.extra && expr.extra.parenthesized) {
            return super.parseExpressionStatement(node, expr);
          }
          if (this.match(14)) {
            const stmt = node;
            stmt.label = this.finishPlaceholder(expr, "Identifier");
            this.next();
            stmt.body = super.parseStatementOrFunctionDeclaration(false);
            return this.finishNode(stmt, "LabeledStatement");
          }
          this.semicolon();
          node.name = expr.name;
          return this.finishPlaceholder(node, "Statement");
        }
        parseBlock(allowDirectives, createNewLexicalScope, afterBlockParse) {
          return this.parsePlaceholder("BlockStatement") || super.parseBlock(allowDirectives, createNewLexicalScope, afterBlockParse);
        }
        parseFunctionId(requireId) {
          return this.parsePlaceholder("Identifier") || super.parseFunctionId(requireId);
        }
        parseClass(node, isStatement, optionalId) {
          const type = isStatement ? "ClassDeclaration" : "ClassExpression";
          this.next();
          const oldStrict = this.state.strict;
          const placeholder = this.parsePlaceholder("Identifier");
          if (placeholder) {
            if (this.match(81) || this.match(142) || this.match(5)) {
              node.id = placeholder;
            } else if (optionalId || !isStatement) {
              node.id = null;
              node.body = this.finishPlaceholder(placeholder, "ClassBody");
              return this.finishNode(node, type);
            } else {
              throw this.raise(PlaceholderErrors.ClassNameIsRequired, {
                at: this.state.startLoc
              });
            }
          } else {
            this.parseClassId(node, isStatement, optionalId);
          }
          super.parseClassSuper(node);
          node.body = this.parsePlaceholder("ClassBody") || super.parseClassBody(!!node.superClass, oldStrict);
          return this.finishNode(node, type);
        }
        parseExport(node, decorators) {
          const placeholder = this.parsePlaceholder("Identifier");
          if (!placeholder)
            return super.parseExport(node, decorators);
          if (!this.isContextual(97) && !this.match(12)) {
            node.specifiers = [];
            node.source = null;
            node.declaration = this.finishPlaceholder(placeholder, "Declaration");
            return this.finishNode(node, "ExportNamedDeclaration");
          }
          this.expectPlugin("exportDefaultFrom");
          const specifier = this.startNode();
          specifier.exported = placeholder;
          node.specifiers = [this.finishNode(specifier, "ExportDefaultSpecifier")];
          return super.parseExport(node, decorators);
        }
        isExportDefaultSpecifier() {
          if (this.match(65)) {
            const next = this.nextTokenStart();
            if (this.isUnparsedContextual(next, "from")) {
              if (this.input.startsWith(tokenLabelName(142), this.nextTokenStartSince(next + 4))) {
                return true;
              }
            }
          }
          return super.isExportDefaultSpecifier();
        }
        maybeParseExportDefaultSpecifier(node) {
          if (node.specifiers && node.specifiers.length > 0) {
            return true;
          }
          return super.maybeParseExportDefaultSpecifier(node);
        }
        checkExport(node) {
          const {
            specifiers
          } = node;
          if (specifiers != null && specifiers.length) {
            node.specifiers = specifiers.filter(
              (node2) => node2.exported.type === "Placeholder"
            );
          }
          super.checkExport(node);
          node.specifiers = specifiers;
        }
        parseImport(node) {
          const placeholder = this.parsePlaceholder("Identifier");
          if (!placeholder)
            return super.parseImport(node);
          node.specifiers = [];
          if (!this.isContextual(97) && !this.match(12)) {
            node.source = this.finishPlaceholder(placeholder, "StringLiteral");
            this.semicolon();
            return this.finishNode(node, "ImportDeclaration");
          }
          const specifier = this.startNodeAtNode(placeholder);
          specifier.local = placeholder;
          node.specifiers.push(this.finishNode(specifier, "ImportDefaultSpecifier"));
          if (this.eat(12)) {
            const hasStarImport = this.maybeParseStarImportSpecifier(node);
            if (!hasStarImport)
              this.parseNamedImportSpecifiers(node);
          }
          this.expectContextual(97);
          node.source = this.parseImportSource();
          this.semicolon();
          return this.finishNode(node, "ImportDeclaration");
        }
        parseImportSource() {
          return this.parsePlaceholder("StringLiteral") || super.parseImportSource();
        }
        assertNoSpace() {
          if (this.state.start > this.state.lastTokEndLoc.index) {
            this.raise(PlaceholderErrors.UnexpectedSpace, {
              at: this.state.lastTokEndLoc
            });
          }
        }
      };
      var v8intrinsic = (superClass) => class V8IntrinsicMixin extends superClass {
        parseV8Intrinsic() {
          if (this.match(54)) {
            const v8IntrinsicStartLoc = this.state.startLoc;
            const node = this.startNode();
            this.next();
            if (tokenIsIdentifier(this.state.type)) {
              const name = this.parseIdentifierName();
              const identifier3 = this.createIdentifier(node, name);
              identifier3.type = "V8IntrinsicIdentifier";
              if (this.match(10)) {
                return identifier3;
              }
            }
            this.unexpected(v8IntrinsicStartLoc);
          }
        }
        parseExprAtom(refExpressionErrors) {
          return this.parseV8Intrinsic() || super.parseExprAtom(refExpressionErrors);
        }
      };
      function hasPlugin(plugins3, expectedConfig) {
        const [expectedName, expectedOptions] = typeof expectedConfig === "string" ? [expectedConfig, {}] : expectedConfig;
        const expectedKeys = Object.keys(expectedOptions);
        const expectedOptionsIsEmpty = expectedKeys.length === 0;
        return plugins3.some((p) => {
          if (typeof p === "string") {
            return expectedOptionsIsEmpty && p === expectedName;
          } else {
            const [pluginName, pluginOptions] = p;
            if (pluginName !== expectedName) {
              return false;
            }
            for (const key of expectedKeys) {
              if (pluginOptions[key] !== expectedOptions[key]) {
                return false;
              }
            }
            return true;
          }
        });
      }
      function getPluginOption(plugins3, name, option) {
        const plugin = plugins3.find((plugin2) => {
          if (Array.isArray(plugin2)) {
            return plugin2[0] === name;
          } else {
            return plugin2 === name;
          }
        });
        if (plugin && Array.isArray(plugin) && plugin.length > 1) {
          return plugin[1][option];
        }
        return null;
      }
      var PIPELINE_PROPOSALS = ["minimal", "fsharp", "hack", "smart"];
      var TOPIC_TOKENS = ["^^", "@@", "^", "%", "#"];
      var RECORD_AND_TUPLE_SYNTAX_TYPES = ["hash", "bar"];
      function validatePlugins(plugins3) {
        if (hasPlugin(plugins3, "decorators")) {
          if (hasPlugin(plugins3, "decorators-legacy")) {
            throw new Error("Cannot use the decorators and decorators-legacy plugin together");
          }
          const decoratorsBeforeExport = getPluginOption(plugins3, "decorators", "decoratorsBeforeExport");
          if (decoratorsBeforeExport != null && typeof decoratorsBeforeExport !== "boolean") {
            throw new Error("'decoratorsBeforeExport' must be a boolean.");
          }
          const allowCallParenthesized = getPluginOption(plugins3, "decorators", "allowCallParenthesized");
          if (allowCallParenthesized != null && typeof allowCallParenthesized !== "boolean") {
            throw new Error("'allowCallParenthesized' must be a boolean.");
          }
        }
        if (hasPlugin(plugins3, "flow") && hasPlugin(plugins3, "typescript")) {
          throw new Error("Cannot combine flow and typescript plugins.");
        }
        if (hasPlugin(plugins3, "placeholders") && hasPlugin(plugins3, "v8intrinsic")) {
          throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
        }
        if (hasPlugin(plugins3, "pipelineOperator")) {
          const proposal = getPluginOption(plugins3, "pipelineOperator", "proposal");
          if (!PIPELINE_PROPOSALS.includes(proposal)) {
            const proposalList = PIPELINE_PROPOSALS.map((p) => `"${p}"`).join(", ");
            throw new Error(`"pipelineOperator" requires "proposal" option whose value must be one of: ${proposalList}.`);
          }
          const tupleSyntaxIsHash = hasPlugin(plugins3, ["recordAndTuple", {
            syntaxType: "hash"
          }]);
          if (proposal === "hack") {
            if (hasPlugin(plugins3, "placeholders")) {
              throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
            }
            if (hasPlugin(plugins3, "v8intrinsic")) {
              throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
            }
            const topicToken = getPluginOption(plugins3, "pipelineOperator", "topicToken");
            if (!TOPIC_TOKENS.includes(topicToken)) {
              const tokenList = TOPIC_TOKENS.map((t3) => `"${t3}"`).join(", ");
              throw new Error(`"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: ${tokenList}.`);
            }
            if (topicToken === "#" && tupleSyntaxIsHash) {
              throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "hack", topicToken: "#" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
            }
          } else if (proposal === "smart" && tupleSyntaxIsHash) {
            throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "smart" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
          }
        }
        if (hasPlugin(plugins3, "moduleAttributes")) {
          {
            if (hasPlugin(plugins3, "importAssertions")) {
              throw new Error("Cannot combine importAssertions and moduleAttributes plugins.");
            }
            const moduleAttributesVersionPluginOption = getPluginOption(plugins3, "moduleAttributes", "version");
            if (moduleAttributesVersionPluginOption !== "may-2020") {
              throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
            }
          }
        }
        if (hasPlugin(plugins3, "recordAndTuple") && getPluginOption(plugins3, "recordAndTuple", "syntaxType") != null && !RECORD_AND_TUPLE_SYNTAX_TYPES.includes(getPluginOption(plugins3, "recordAndTuple", "syntaxType"))) {
          throw new Error("The 'syntaxType' option of the 'recordAndTuple' plugin must be one of: " + RECORD_AND_TUPLE_SYNTAX_TYPES.map((p) => `'${p}'`).join(", "));
        }
        if (hasPlugin(plugins3, "asyncDoExpressions") && !hasPlugin(plugins3, "doExpressions")) {
          const error = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
          error.missingPlugins = "doExpressions";
          throw error;
        }
      }
      var mixinPlugins = {
        estree,
        jsx,
        flow: flow2,
        typescript,
        v8intrinsic,
        placeholders
      };
      var mixinPluginNames = Object.keys(mixinPlugins);
      var defaultOptions = {
        sourceType: "script",
        sourceFilename: void 0,
        startColumn: 0,
        startLine: 1,
        allowAwaitOutsideFunction: false,
        allowReturnOutsideFunction: false,
        allowImportExportEverywhere: false,
        allowSuperOutsideMethod: false,
        allowUndeclaredExports: false,
        plugins: [],
        strictMode: null,
        ranges: false,
        tokens: false,
        createParenthesizedExpressions: false,
        errorRecovery: false,
        attachComment: true
      };
      function getOptions(opts) {
        const options = {};
        for (const key of Object.keys(defaultOptions)) {
          options[key] = opts && opts[key] != null ? opts[key] : defaultOptions[key];
        }
        return options;
      }
      var getOwn = (object, key) => Object.hasOwnProperty.call(object, key) && object[key];
      var unwrapParenthesizedExpression = (node) => {
        return node.type === "ParenthesizedExpression" ? unwrapParenthesizedExpression(node.expression) : node;
      };
      var LValParser = class extends NodeUtils {
        toAssignable(node, isLHS = false) {
          var _node$extra, _node$extra3;
          let parenthesized = void 0;
          if (node.type === "ParenthesizedExpression" || (_node$extra = node.extra) != null && _node$extra.parenthesized) {
            parenthesized = unwrapParenthesizedExpression(node);
            if (isLHS) {
              if (parenthesized.type === "Identifier") {
                this.expressionScope.recordArrowParemeterBindingError(Errors.InvalidParenthesizedAssignment, {
                  at: node
                });
              } else if (parenthesized.type !== "MemberExpression") {
                this.raise(Errors.InvalidParenthesizedAssignment, {
                  at: node
                });
              }
            } else {
              this.raise(Errors.InvalidParenthesizedAssignment, {
                at: node
              });
            }
          }
          switch (node.type) {
            case "Identifier":
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              break;
            case "ObjectExpression":
              node.type = "ObjectPattern";
              for (let i = 0, length = node.properties.length, last2 = length - 1; i < length; i++) {
                var _node$extra2;
                const prop = node.properties[i];
                const isLast = i === last2;
                this.toAssignableObjectExpressionProp(prop, isLast, isLHS);
                if (isLast && prop.type === "RestElement" && (_node$extra2 = node.extra) != null && _node$extra2.trailingCommaLoc) {
                  this.raise(Errors.RestTrailingComma, {
                    at: node.extra.trailingCommaLoc
                  });
                }
              }
              break;
            case "ObjectProperty": {
              const {
                key,
                value
              } = node;
              if (this.isPrivateName(key)) {
                this.classScope.usePrivateName(this.getPrivateNameSV(key), key.loc.start);
              }
              this.toAssignable(value, isLHS);
              break;
            }
            case "SpreadElement": {
              throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
            }
            case "ArrayExpression":
              node.type = "ArrayPattern";
              this.toAssignableList(node.elements, (_node$extra3 = node.extra) == null ? void 0 : _node$extra3.trailingCommaLoc, isLHS);
              break;
            case "AssignmentExpression":
              if (node.operator !== "=") {
                this.raise(Errors.MissingEqInAssignment, {
                  at: node.left.loc.end
                });
              }
              node.type = "AssignmentPattern";
              delete node.operator;
              this.toAssignable(node.left, isLHS);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(parenthesized, isLHS);
              break;
          }
        }
        toAssignableObjectExpressionProp(prop, isLast, isLHS) {
          if (prop.type === "ObjectMethod") {
            this.raise(prop.kind === "get" || prop.kind === "set" ? Errors.PatternHasAccessor : Errors.PatternHasMethod, {
              at: prop.key
            });
          } else if (prop.type === "SpreadElement") {
            prop.type = "RestElement";
            const arg = prop.argument;
            this.checkToRestConversion(arg, false);
            this.toAssignable(arg, isLHS);
            if (!isLast) {
              this.raise(Errors.RestTrailingComma, {
                at: prop
              });
            }
          } else {
            this.toAssignable(prop, isLHS);
          }
        }
        toAssignableList(exprList, trailingCommaLoc, isLHS) {
          const end = exprList.length - 1;
          for (let i = 0; i <= end; i++) {
            const elt = exprList[i];
            if (!elt)
              continue;
            if (elt.type === "SpreadElement") {
              elt.type = "RestElement";
              const arg = elt.argument;
              this.checkToRestConversion(arg, true);
              this.toAssignable(arg, isLHS);
            } else {
              this.toAssignable(elt, isLHS);
            }
            if (elt.type === "RestElement") {
              if (i < end) {
                this.raise(Errors.RestTrailingComma, {
                  at: elt
                });
              } else if (trailingCommaLoc) {
                this.raise(Errors.RestTrailingComma, {
                  at: trailingCommaLoc
                });
              }
            }
          }
        }
        isAssignable(node, isBinding) {
          switch (node.type) {
            case "Identifier":
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              return true;
            case "ObjectExpression": {
              const last2 = node.properties.length - 1;
              return node.properties.every((prop, i) => {
                return prop.type !== "ObjectMethod" && (i === last2 || prop.type !== "SpreadElement") && this.isAssignable(prop);
              });
            }
            case "ObjectProperty":
              return this.isAssignable(node.value);
            case "SpreadElement":
              return this.isAssignable(node.argument);
            case "ArrayExpression":
              return node.elements.every((element) => element === null || this.isAssignable(element));
            case "AssignmentExpression":
              return node.operator === "=";
            case "ParenthesizedExpression":
              return this.isAssignable(node.expression);
            case "MemberExpression":
            case "OptionalMemberExpression":
              return !isBinding;
            default:
              return false;
          }
        }
        toReferencedList(exprList, isParenthesizedExpr) {
          return exprList;
        }
        toReferencedListDeep(exprList, isParenthesizedExpr) {
          this.toReferencedList(exprList, isParenthesizedExpr);
          for (const expr of exprList) {
            if ((expr == null ? void 0 : expr.type) === "ArrayExpression") {
              this.toReferencedListDeep(expr.elements);
            }
          }
        }
        parseSpread(refExpressionErrors) {
          const node = this.startNode();
          this.next();
          node.argument = this.parseMaybeAssignAllowIn(refExpressionErrors, void 0);
          return this.finishNode(node, "SpreadElement");
        }
        parseRestBinding() {
          const node = this.startNode();
          this.next();
          node.argument = this.parseBindingAtom();
          return this.finishNode(node, "RestElement");
        }
        parseBindingAtom() {
          switch (this.state.type) {
            case 0: {
              const node = this.startNode();
              this.next();
              node.elements = this.parseBindingList(3, 93, true);
              return this.finishNode(node, "ArrayPattern");
            }
            case 5:
              return this.parseObjectLike(8, true);
          }
          return this.parseIdentifier();
        }
        parseBindingList(close, closeCharCode, allowEmpty, allowModifiers) {
          const elts = [];
          let first = true;
          while (!this.eat(close)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
            }
            if (allowEmpty && this.match(12)) {
              elts.push(null);
            } else if (this.eat(close)) {
              break;
            } else if (this.match(21)) {
              elts.push(this.parseAssignableListItemTypes(this.parseRestBinding()));
              if (!this.checkCommaAfterRest(closeCharCode)) {
                this.expect(close);
                break;
              }
            } else {
              const decorators = [];
              if (this.match(26) && this.hasPlugin("decorators")) {
                this.raise(Errors.UnsupportedParameterDecorator, {
                  at: this.state.startLoc
                });
              }
              while (this.match(26)) {
                decorators.push(this.parseDecorator());
              }
              elts.push(this.parseAssignableListItem(allowModifiers, decorators));
            }
          }
          return elts;
        }
        parseBindingRestProperty(prop) {
          this.next();
          prop.argument = this.parseIdentifier();
          this.checkCommaAfterRest(125);
          return this.finishNode(prop, "RestElement");
        }
        parseBindingProperty() {
          const prop = this.startNode();
          const {
            type,
            startLoc
          } = this.state;
          if (type === 21) {
            return this.parseBindingRestProperty(prop);
          } else if (type === 136) {
            this.expectPlugin("destructuringPrivate", startLoc);
            this.classScope.usePrivateName(this.state.value, startLoc);
            prop.key = this.parsePrivateName();
          } else {
            this.parsePropertyName(prop);
          }
          prop.method = false;
          return this.parseObjPropValue(prop, startLoc, false, false, true, false);
        }
        parseAssignableListItem(allowModifiers, decorators) {
          const left = this.parseMaybeDefault();
          this.parseAssignableListItemTypes(left);
          const elt = this.parseMaybeDefault(left.loc.start, left);
          if (decorators.length) {
            left.decorators = decorators;
          }
          return elt;
        }
        parseAssignableListItemTypes(param) {
          return param;
        }
        parseMaybeDefault(startLoc, left) {
          var _startLoc, _left;
          (_startLoc = startLoc) != null ? _startLoc : startLoc = this.state.startLoc;
          left = (_left = left) != null ? _left : this.parseBindingAtom();
          if (!this.eat(29))
            return left;
          const node = this.startNodeAt(startLoc);
          node.left = left;
          node.right = this.parseMaybeAssignAllowIn();
          return this.finishNode(node, "AssignmentPattern");
        }
        isValidLVal(type, isUnparenthesizedInAssign, binding) {
          return getOwn(
            {
              AssignmentPattern: "left",
              RestElement: "argument",
              ObjectProperty: "value",
              ParenthesizedExpression: "expression",
              ArrayPattern: "elements",
              ObjectPattern: "properties"
            },
            type
          );
        }
        checkLVal(expression, {
          in: ancestor,
          binding = BIND_NONE,
          checkClashes = false,
          strictModeChanged = false,
          allowingSloppyLetBinding = !(binding & BIND_SCOPE_LEXICAL),
          hasParenthesizedAncestor = false
        }) {
          var _expression$extra;
          const type = expression.type;
          if (this.isObjectMethod(expression))
            return;
          if (type === "MemberExpression") {
            if (binding !== BIND_NONE) {
              this.raise(Errors.InvalidPropertyBindingPattern, {
                at: expression
              });
            }
            return;
          }
          if (expression.type === "Identifier") {
            this.checkIdentifier(expression, binding, strictModeChanged, allowingSloppyLetBinding);
            const {
              name
            } = expression;
            if (checkClashes) {
              if (checkClashes.has(name)) {
                this.raise(Errors.ParamDupe, {
                  at: expression
                });
              } else {
                checkClashes.add(name);
              }
            }
            return;
          }
          const validity = this.isValidLVal(expression.type, !(hasParenthesizedAncestor || (_expression$extra = expression.extra) != null && _expression$extra.parenthesized) && ancestor.type === "AssignmentExpression", binding);
          if (validity === true)
            return;
          if (validity === false) {
            const ParseErrorClass = binding === BIND_NONE ? Errors.InvalidLhs : Errors.InvalidLhsBinding;
            this.raise(ParseErrorClass, {
              at: expression,
              ancestor: ancestor.type === "UpdateExpression" ? {
                type: "UpdateExpression",
                prefix: ancestor.prefix
              } : {
                type: ancestor.type
              }
            });
            return;
          }
          const [key, isParenthesizedExpression] = Array.isArray(validity) ? validity : [validity, type === "ParenthesizedExpression"];
          const nextAncestor = expression.type === "ArrayPattern" || expression.type === "ObjectPattern" || expression.type === "ParenthesizedExpression" ? expression : ancestor;
          for (const child of [].concat(expression[key])) {
            if (child) {
              this.checkLVal(child, {
                in: nextAncestor,
                binding,
                checkClashes,
                allowingSloppyLetBinding,
                strictModeChanged,
                hasParenthesizedAncestor: isParenthesizedExpression
              });
            }
          }
        }
        checkIdentifier(at2, bindingType, strictModeChanged = false, allowLetBinding = !(bindingType & BIND_SCOPE_LEXICAL)) {
          if (this.state.strict && (strictModeChanged ? isStrictBindReservedWord(at2.name, this.inModule) : isStrictBindOnlyReservedWord(at2.name))) {
            if (bindingType === BIND_NONE) {
              this.raise(Errors.StrictEvalArguments, {
                at: at2,
                referenceName: at2.name
              });
            } else {
              this.raise(Errors.StrictEvalArgumentsBinding, {
                at: at2,
                bindingName: at2.name
              });
            }
          }
          if (!allowLetBinding && at2.name === "let") {
            this.raise(Errors.LetInLexicalBinding, {
              at: at2
            });
          }
          if (!(bindingType & BIND_NONE)) {
            this.declareNameFromIdentifier(at2, bindingType);
          }
        }
        declareNameFromIdentifier(identifier3, binding) {
          this.scope.declareName(identifier3.name, binding, identifier3.loc.start);
        }
        checkToRestConversion(node, allowPattern) {
          switch (node.type) {
            case "ParenthesizedExpression":
              this.checkToRestConversion(node.expression, allowPattern);
              break;
            case "Identifier":
            case "MemberExpression":
              break;
            case "ArrayExpression":
            case "ObjectExpression":
              if (allowPattern)
                break;
            default:
              this.raise(Errors.InvalidRestAssignmentPattern, {
                at: node
              });
          }
        }
        checkCommaAfterRest(close) {
          if (!this.match(12)) {
            return false;
          }
          this.raise(this.lookaheadCharCode() === close ? Errors.RestTrailingComma : Errors.ElementAfterRest, {
            at: this.state.startLoc
          });
          return true;
        }
      };
      var ExpressionParser = class extends LValParser {
        checkProto(prop, isRecord, protoRef, refExpressionErrors) {
          if (prop.type === "SpreadElement" || this.isObjectMethod(prop) || prop.computed || prop.shorthand) {
            return;
          }
          const key = prop.key;
          const name = key.type === "Identifier" ? key.name : key.value;
          if (name === "__proto__") {
            if (isRecord) {
              this.raise(Errors.RecordNoProto, {
                at: key
              });
              return;
            }
            if (protoRef.used) {
              if (refExpressionErrors) {
                if (refExpressionErrors.doubleProtoLoc === null) {
                  refExpressionErrors.doubleProtoLoc = key.loc.start;
                }
              } else {
                this.raise(Errors.DuplicateProto, {
                  at: key
                });
              }
            }
            protoRef.used = true;
          }
        }
        shouldExitDescending(expr, potentialArrowAt) {
          return expr.type === "ArrowFunctionExpression" && expr.start === potentialArrowAt;
        }
        getExpression() {
          this.enterInitialScopes();
          this.nextToken();
          const expr = this.parseExpression();
          if (!this.match(137)) {
            this.unexpected();
          }
          this.finalizeRemainingComments();
          expr.comments = this.state.comments;
          expr.errors = this.state.errors;
          if (this.options.tokens) {
            expr.tokens = this.tokens;
          }
          return expr;
        }
        parseExpression(disallowIn, refExpressionErrors) {
          if (disallowIn) {
            return this.disallowInAnd(() => this.parseExpressionBase(refExpressionErrors));
          }
          return this.allowInAnd(() => this.parseExpressionBase(refExpressionErrors));
        }
        parseExpressionBase(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const expr = this.parseMaybeAssign(refExpressionErrors);
          if (this.match(12)) {
            const node = this.startNodeAt(startLoc);
            node.expressions = [expr];
            while (this.eat(12)) {
              node.expressions.push(this.parseMaybeAssign(refExpressionErrors));
            }
            this.toReferencedList(node.expressions);
            return this.finishNode(node, "SequenceExpression");
          }
          return expr;
        }
        parseMaybeAssignDisallowIn(refExpressionErrors, afterLeftParse) {
          return this.disallowInAnd(() => this.parseMaybeAssign(refExpressionErrors, afterLeftParse));
        }
        parseMaybeAssignAllowIn(refExpressionErrors, afterLeftParse) {
          return this.allowInAnd(() => this.parseMaybeAssign(refExpressionErrors, afterLeftParse));
        }
        setOptionalParametersError(refExpressionErrors, resultError) {
          var _resultError$loc;
          refExpressionErrors.optionalParametersLoc = (_resultError$loc = resultError == null ? void 0 : resultError.loc) != null ? _resultError$loc : this.state.startLoc;
        }
        parseMaybeAssign(refExpressionErrors, afterLeftParse) {
          const startLoc = this.state.startLoc;
          if (this.isContextual(106)) {
            if (this.prodParam.hasYield) {
              let left2 = this.parseYield();
              if (afterLeftParse) {
                left2 = afterLeftParse.call(this, left2, startLoc);
              }
              return left2;
            }
          }
          let ownExpressionErrors;
          if (refExpressionErrors) {
            ownExpressionErrors = false;
          } else {
            refExpressionErrors = new ExpressionErrors();
            ownExpressionErrors = true;
          }
          const {
            type
          } = this.state;
          if (type === 10 || tokenIsIdentifier(type)) {
            this.state.potentialArrowAt = this.state.start;
          }
          let left = this.parseMaybeConditional(refExpressionErrors);
          if (afterLeftParse) {
            left = afterLeftParse.call(this, left, startLoc);
          }
          if (tokenIsAssignment(this.state.type)) {
            const node = this.startNodeAt(startLoc);
            const operator = this.state.value;
            node.operator = operator;
            if (this.match(29)) {
              this.toAssignable(left, true);
              node.left = left;
              const startIndex = startLoc.index;
              if (refExpressionErrors.doubleProtoLoc != null && refExpressionErrors.doubleProtoLoc.index >= startIndex) {
                refExpressionErrors.doubleProtoLoc = null;
              }
              if (refExpressionErrors.shorthandAssignLoc != null && refExpressionErrors.shorthandAssignLoc.index >= startIndex) {
                refExpressionErrors.shorthandAssignLoc = null;
              }
              if (refExpressionErrors.privateKeyLoc != null && refExpressionErrors.privateKeyLoc.index >= startIndex) {
                this.checkDestructuringPrivate(refExpressionErrors);
                refExpressionErrors.privateKeyLoc = null;
              }
            } else {
              node.left = left;
            }
            this.next();
            node.right = this.parseMaybeAssign();
            this.checkLVal(left, {
              in: this.finishNode(node, "AssignmentExpression")
            });
            return node;
          } else if (ownExpressionErrors) {
            this.checkExpressionErrors(refExpressionErrors, true);
          }
          return left;
        }
        parseMaybeConditional(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const potentialArrowAt = this.state.potentialArrowAt;
          const expr = this.parseExprOps(refExpressionErrors);
          if (this.shouldExitDescending(expr, potentialArrowAt)) {
            return expr;
          }
          return this.parseConditional(expr, startLoc, refExpressionErrors);
        }
        parseConditional(expr, startLoc, refExpressionErrors) {
          if (this.eat(17)) {
            const node = this.startNodeAt(startLoc);
            node.test = expr;
            node.consequent = this.parseMaybeAssignAllowIn();
            this.expect(14);
            node.alternate = this.parseMaybeAssign();
            return this.finishNode(node, "ConditionalExpression");
          }
          return expr;
        }
        parseMaybeUnaryOrPrivate(refExpressionErrors) {
          return this.match(136) ? this.parsePrivateName() : this.parseMaybeUnary(refExpressionErrors);
        }
        parseExprOps(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const potentialArrowAt = this.state.potentialArrowAt;
          const expr = this.parseMaybeUnaryOrPrivate(refExpressionErrors);
          if (this.shouldExitDescending(expr, potentialArrowAt)) {
            return expr;
          }
          return this.parseExprOp(expr, startLoc, -1);
        }
        parseExprOp(left, leftStartLoc, minPrec) {
          if (this.isPrivateName(left)) {
            const value = this.getPrivateNameSV(left);
            if (minPrec >= tokenOperatorPrecedence(58) || !this.prodParam.hasIn || !this.match(58)) {
              this.raise(Errors.PrivateInExpectedIn, {
                at: left,
                identifierName: value
              });
            }
            this.classScope.usePrivateName(value, left.loc.start);
          }
          const op = this.state.type;
          if (tokenIsOperator(op) && (this.prodParam.hasIn || !this.match(58))) {
            let prec = tokenOperatorPrecedence(op);
            if (prec > minPrec) {
              if (op === 39) {
                this.expectPlugin("pipelineOperator");
                if (this.state.inFSharpPipelineDirectBody) {
                  return left;
                }
                this.checkPipelineAtInfixOperator(left, leftStartLoc);
              }
              const node = this.startNodeAt(leftStartLoc);
              node.left = left;
              node.operator = this.state.value;
              const logical = op === 41 || op === 42;
              const coalesce = op === 40;
              if (coalesce) {
                prec = tokenOperatorPrecedence(42);
              }
              this.next();
              if (op === 39 && this.hasPlugin(["pipelineOperator", {
                proposal: "minimal"
              }])) {
                if (this.state.type === 96 && this.prodParam.hasAwait) {
                  throw this.raise(Errors.UnexpectedAwaitAfterPipelineBody, {
                    at: this.state.startLoc
                  });
                }
              }
              node.right = this.parseExprOpRightExpr(op, prec);
              const finishedNode = this.finishNode(node, logical || coalesce ? "LogicalExpression" : "BinaryExpression");
              const nextOp = this.state.type;
              if (coalesce && (nextOp === 41 || nextOp === 42) || logical && nextOp === 40) {
                throw this.raise(Errors.MixingCoalesceWithLogical, {
                  at: this.state.startLoc
                });
              }
              return this.parseExprOp(finishedNode, leftStartLoc, minPrec);
            }
          }
          return left;
        }
        parseExprOpRightExpr(op, prec) {
          const startLoc = this.state.startLoc;
          switch (op) {
            case 39:
              switch (this.getPluginOption("pipelineOperator", "proposal")) {
                case "hack":
                  return this.withTopicBindingContext(() => {
                    return this.parseHackPipeBody();
                  });
                case "smart":
                  return this.withTopicBindingContext(() => {
                    if (this.prodParam.hasYield && this.isContextual(106)) {
                      throw this.raise(Errors.PipeBodyIsTighter, {
                        at: this.state.startLoc
                      });
                    }
                    return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(op, prec), startLoc);
                  });
                case "fsharp":
                  return this.withSoloAwaitPermittingContext(() => {
                    return this.parseFSharpPipelineBody(prec);
                  });
              }
            default:
              return this.parseExprOpBaseRightExpr(op, prec);
          }
        }
        parseExprOpBaseRightExpr(op, prec) {
          const startLoc = this.state.startLoc;
          return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), startLoc, tokenIsRightAssociative(op) ? prec - 1 : prec);
        }
        parseHackPipeBody() {
          var _body$extra;
          const {
            startLoc
          } = this.state;
          const body = this.parseMaybeAssign();
          const requiredParentheses = UnparenthesizedPipeBodyDescriptions.has(
            body.type
          );
          if (requiredParentheses && !((_body$extra = body.extra) != null && _body$extra.parenthesized)) {
            this.raise(Errors.PipeUnparenthesizedBody, {
              at: startLoc,
              type: body.type
            });
          }
          if (!this.topicReferenceWasUsedInCurrentContext()) {
            this.raise(Errors.PipeTopicUnused, {
              at: startLoc
            });
          }
          return body;
        }
        checkExponentialAfterUnary(node) {
          if (this.match(57)) {
            this.raise(Errors.UnexpectedTokenUnaryExponentiation, {
              at: node.argument
            });
          }
        }
        parseMaybeUnary(refExpressionErrors, sawUnary) {
          const startLoc = this.state.startLoc;
          const isAwait = this.isContextual(96);
          if (isAwait && this.isAwaitAllowed()) {
            this.next();
            const expr2 = this.parseAwait(startLoc);
            if (!sawUnary)
              this.checkExponentialAfterUnary(expr2);
            return expr2;
          }
          const update2 = this.match(34);
          const node = this.startNode();
          if (tokenIsPrefix(this.state.type)) {
            node.operator = this.state.value;
            node.prefix = true;
            if (this.match(72)) {
              this.expectPlugin("throwExpressions");
            }
            const isDelete = this.match(89);
            this.next();
            node.argument = this.parseMaybeUnary(null, true);
            this.checkExpressionErrors(refExpressionErrors, true);
            if (this.state.strict && isDelete) {
              const arg = node.argument;
              if (arg.type === "Identifier") {
                this.raise(Errors.StrictDelete, {
                  at: node
                });
              } else if (this.hasPropertyAsPrivateName(arg)) {
                this.raise(Errors.DeletePrivateField, {
                  at: node
                });
              }
            }
            if (!update2) {
              if (!sawUnary) {
                this.checkExponentialAfterUnary(node);
              }
              return this.finishNode(node, "UnaryExpression");
            }
          }
          const expr = this.parseUpdate(
            node,
            update2,
            refExpressionErrors
          );
          if (isAwait) {
            const {
              type
            } = this.state;
            const startsExpr2 = this.hasPlugin("v8intrinsic") ? tokenCanStartExpression(type) : tokenCanStartExpression(type) && !this.match(54);
            if (startsExpr2 && !this.isAmbiguousAwait()) {
              this.raiseOverwrite(Errors.AwaitNotInAsyncContext, {
                at: startLoc
              });
              return this.parseAwait(startLoc);
            }
          }
          return expr;
        }
        parseUpdate(node, update2, refExpressionErrors) {
          if (update2) {
            const updateExpressionNode = node;
            this.checkLVal(updateExpressionNode.argument, {
              in: this.finishNode(updateExpressionNode, "UpdateExpression")
            });
            return node;
          }
          const startLoc = this.state.startLoc;
          let expr = this.parseExprSubscripts(refExpressionErrors);
          if (this.checkExpressionErrors(refExpressionErrors, false))
            return expr;
          while (tokenIsPostfix(this.state.type) && !this.canInsertSemicolon()) {
            const node2 = this.startNodeAt(startLoc);
            node2.operator = this.state.value;
            node2.prefix = false;
            node2.argument = expr;
            this.next();
            this.checkLVal(expr, {
              in: expr = this.finishNode(node2, "UpdateExpression")
            });
          }
          return expr;
        }
        parseExprSubscripts(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const potentialArrowAt = this.state.potentialArrowAt;
          const expr = this.parseExprAtom(refExpressionErrors);
          if (this.shouldExitDescending(expr, potentialArrowAt)) {
            return expr;
          }
          return this.parseSubscripts(expr, startLoc);
        }
        parseSubscripts(base, startLoc, noCalls) {
          const state = {
            optionalChainMember: false,
            maybeAsyncArrow: this.atPossibleAsyncArrow(base),
            stop: false
          };
          do {
            base = this.parseSubscript(base, startLoc, noCalls, state);
            state.maybeAsyncArrow = false;
          } while (!state.stop);
          return base;
        }
        parseSubscript(base, startLoc, noCalls, state) {
          const {
            type
          } = this.state;
          if (!noCalls && type === 15) {
            return this.parseBind(base, startLoc, noCalls, state);
          } else if (tokenIsTemplate(type)) {
            return this.parseTaggedTemplateExpression(base, startLoc, state);
          }
          let optional = false;
          if (type === 18) {
            if (noCalls && this.lookaheadCharCode() === 40) {
              state.stop = true;
              return base;
            }
            state.optionalChainMember = optional = true;
            this.next();
          }
          if (!noCalls && this.match(10)) {
            return this.parseCoverCallAndAsyncArrowHead(base, startLoc, state, optional);
          } else {
            const computed = this.eat(0);
            if (computed || optional || this.eat(16)) {
              return this.parseMember(base, startLoc, state, computed, optional);
            } else {
              state.stop = true;
              return base;
            }
          }
        }
        parseMember(base, startLoc, state, computed, optional) {
          const node = this.startNodeAt(startLoc);
          node.object = base;
          node.computed = computed;
          if (computed) {
            node.property = this.parseExpression();
            this.expect(3);
          } else if (this.match(136)) {
            if (base.type === "Super") {
              this.raise(Errors.SuperPrivateField, {
                at: startLoc
              });
            }
            this.classScope.usePrivateName(this.state.value, this.state.startLoc);
            node.property = this.parsePrivateName();
          } else {
            node.property = this.parseIdentifier(true);
          }
          if (state.optionalChainMember) {
            node.optional = optional;
            return this.finishNode(node, "OptionalMemberExpression");
          } else {
            return this.finishNode(node, "MemberExpression");
          }
        }
        parseBind(base, startLoc, noCalls, state) {
          const node = this.startNodeAt(startLoc);
          node.object = base;
          this.next();
          node.callee = this.parseNoCallExpr();
          state.stop = true;
          return this.parseSubscripts(this.finishNode(node, "BindExpression"), startLoc, noCalls);
        }
        parseCoverCallAndAsyncArrowHead(base, startLoc, state, optional) {
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          let refExpressionErrors = null;
          this.state.maybeInArrowParameters = true;
          this.next();
          const node = this.startNodeAt(startLoc);
          node.callee = base;
          const {
            maybeAsyncArrow,
            optionalChainMember
          } = state;
          if (maybeAsyncArrow) {
            this.expressionScope.enter(newAsyncArrowScope());
            refExpressionErrors = new ExpressionErrors();
          }
          if (optionalChainMember) {
            node.optional = optional;
          }
          if (optional) {
            node.arguments = this.parseCallExpressionArguments(11);
          } else {
            node.arguments = this.parseCallExpressionArguments(
              11,
              base.type === "Import",
              base.type !== "Super",
              node,
              refExpressionErrors
            );
          }
          let finishedNode = this.finishCallExpression(node, optionalChainMember);
          if (maybeAsyncArrow && this.shouldParseAsyncArrow() && !optional) {
            state.stop = true;
            this.checkDestructuringPrivate(refExpressionErrors);
            this.expressionScope.validateAsPattern();
            this.expressionScope.exit();
            finishedNode = this.parseAsyncArrowFromCallExpression(this.startNodeAt(startLoc), finishedNode);
          } else {
            if (maybeAsyncArrow) {
              this.checkExpressionErrors(refExpressionErrors, true);
              this.expressionScope.exit();
            }
            this.toReferencedArguments(finishedNode);
          }
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          return finishedNode;
        }
        toReferencedArguments(node, isParenthesizedExpr) {
          this.toReferencedListDeep(node.arguments, isParenthesizedExpr);
        }
        parseTaggedTemplateExpression(base, startLoc, state) {
          const node = this.startNodeAt(startLoc);
          node.tag = base;
          node.quasi = this.parseTemplate(true);
          if (state.optionalChainMember) {
            this.raise(Errors.OptionalChainingNoTemplate, {
              at: startLoc
            });
          }
          return this.finishNode(node, "TaggedTemplateExpression");
        }
        atPossibleAsyncArrow(base) {
          return base.type === "Identifier" && base.name === "async" && this.state.lastTokEndLoc.index === base.end && !this.canInsertSemicolon() && base.end - base.start === 5 && base.start === this.state.potentialArrowAt;
        }
        finishCallExpression(node, optional) {
          if (node.callee.type === "Import") {
            if (node.arguments.length === 2) {
              {
                if (!this.hasPlugin("moduleAttributes")) {
                  this.expectPlugin("importAssertions");
                }
              }
            }
            if (node.arguments.length === 0 || node.arguments.length > 2) {
              this.raise(Errors.ImportCallArity, {
                at: node,
                maxArgumentCount: this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? 2 : 1
              });
            } else {
              for (const arg of node.arguments) {
                if (arg.type === "SpreadElement") {
                  this.raise(Errors.ImportCallSpreadArgument, {
                    at: arg
                  });
                }
              }
            }
          }
          return this.finishNode(node, optional ? "OptionalCallExpression" : "CallExpression");
        }
        parseCallExpressionArguments(close, dynamicImport, allowPlaceholder, nodeForExtra, refExpressionErrors) {
          const elts = [];
          let first = true;
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = false;
          while (!this.eat(close)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.match(close)) {
                if (dynamicImport && !this.hasPlugin("importAssertions") && !this.hasPlugin("moduleAttributes")) {
                  this.raise(Errors.ImportCallArgumentTrailingComma, {
                    at: this.state.lastTokStartLoc
                  });
                }
                if (nodeForExtra) {
                  this.addTrailingCommaExtraToNode(nodeForExtra);
                }
                this.next();
                break;
              }
            }
            elts.push(this.parseExprListItem(false, refExpressionErrors, allowPlaceholder));
          }
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          return elts;
        }
        shouldParseAsyncArrow() {
          return this.match(19) && !this.canInsertSemicolon();
        }
        parseAsyncArrowFromCallExpression(node, call) {
          var _call$extra;
          this.resetPreviousNodeTrailingComments(call);
          this.expect(19);
          this.parseArrowExpression(node, call.arguments, true, (_call$extra = call.extra) == null ? void 0 : _call$extra.trailingCommaLoc);
          if (call.innerComments) {
            setInnerComments(node, call.innerComments);
          }
          if (call.callee.trailingComments) {
            setInnerComments(node, call.callee.trailingComments);
          }
          return node;
        }
        parseNoCallExpr() {
          const startLoc = this.state.startLoc;
          return this.parseSubscripts(this.parseExprAtom(), startLoc, true);
        }
        parseExprAtom(refExpressionErrors) {
          let node;
          let decorators = null;
          const {
            type
          } = this.state;
          switch (type) {
            case 79:
              return this.parseSuper();
            case 83:
              node = this.startNode();
              this.next();
              if (this.match(16)) {
                return this.parseImportMetaProperty(node);
              }
              if (!this.match(10)) {
                this.raise(Errors.UnsupportedImport, {
                  at: this.state.lastTokStartLoc
                });
              }
              return this.finishNode(node, "Import");
            case 78:
              node = this.startNode();
              this.next();
              return this.finishNode(node, "ThisExpression");
            case 90: {
              return this.parseDo(this.startNode(), false);
            }
            case 56:
            case 31: {
              this.readRegexp();
              return this.parseRegExpLiteral(this.state.value);
            }
            case 132:
              return this.parseNumericLiteral(this.state.value);
            case 133:
              return this.parseBigIntLiteral(this.state.value);
            case 134:
              return this.parseDecimalLiteral(this.state.value);
            case 131:
              return this.parseStringLiteral(this.state.value);
            case 84:
              return this.parseNullLiteral();
            case 85:
              return this.parseBooleanLiteral(true);
            case 86:
              return this.parseBooleanLiteral(false);
            case 10: {
              const canBeArrow = this.state.potentialArrowAt === this.state.start;
              return this.parseParenAndDistinguishExpression(canBeArrow);
            }
            case 2:
            case 1: {
              return this.parseArrayLike(this.state.type === 2 ? 4 : 3, false, true);
            }
            case 0: {
              return this.parseArrayLike(3, true, false, refExpressionErrors);
            }
            case 6:
            case 7: {
              return this.parseObjectLike(this.state.type === 6 ? 9 : 8, false, true);
            }
            case 5: {
              return this.parseObjectLike(8, false, false, refExpressionErrors);
            }
            case 68:
              return this.parseFunctionOrFunctionSent();
            case 26:
              decorators = this.parseDecorators();
            case 80:
              return this.parseClass(this.maybeTakeDecorators(decorators, this.startNode()), false);
            case 77:
              return this.parseNewOrNewTarget();
            case 25:
            case 24:
              return this.parseTemplate(false);
            case 15: {
              node = this.startNode();
              this.next();
              node.object = null;
              const callee = node.callee = this.parseNoCallExpr();
              if (callee.type === "MemberExpression") {
                return this.finishNode(node, "BindExpression");
              } else {
                throw this.raise(Errors.UnsupportedBind, {
                  at: callee
                });
              }
            }
            case 136: {
              this.raise(Errors.PrivateInExpectedIn, {
                at: this.state.startLoc,
                identifierName: this.state.value
              });
              return this.parsePrivateName();
            }
            case 33: {
              return this.parseTopicReferenceThenEqualsSign(54, "%");
            }
            case 32: {
              return this.parseTopicReferenceThenEqualsSign(44, "^");
            }
            case 37:
            case 38: {
              return this.parseTopicReference("hack");
            }
            case 44:
            case 54:
            case 27: {
              const pipeProposal = this.getPluginOption("pipelineOperator", "proposal");
              if (pipeProposal) {
                return this.parseTopicReference(pipeProposal);
              } else {
                throw this.unexpected();
              }
            }
            case 47: {
              const lookaheadCh = this.input.codePointAt(this.nextTokenStart());
              if (isIdentifierStart(lookaheadCh) || lookaheadCh === 62) {
                this.expectOnePlugin(["jsx", "flow", "typescript"]);
                break;
              } else {
                throw this.unexpected();
              }
            }
            default:
              if (tokenIsIdentifier(type)) {
                if (this.isContextual(125) && this.lookaheadCharCode() === 123 && !this.hasFollowingLineBreak()) {
                  return this.parseModuleExpression();
                }
                const canBeArrow = this.state.potentialArrowAt === this.state.start;
                const containsEsc = this.state.containsEsc;
                const id = this.parseIdentifier();
                if (!containsEsc && id.name === "async" && !this.canInsertSemicolon()) {
                  const {
                    type: type2
                  } = this.state;
                  if (type2 === 68) {
                    this.resetPreviousNodeTrailingComments(id);
                    this.next();
                    return this.parseAsyncFunctionExpression(this.startNodeAtNode(id));
                  } else if (tokenIsIdentifier(type2)) {
                    if (this.lookaheadCharCode() === 61) {
                      return this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(id));
                    } else {
                      return id;
                    }
                  } else if (type2 === 90) {
                    this.resetPreviousNodeTrailingComments(id);
                    return this.parseDo(this.startNodeAtNode(id), true);
                  }
                }
                if (canBeArrow && this.match(19) && !this.canInsertSemicolon()) {
                  this.next();
                  return this.parseArrowExpression(this.startNodeAtNode(id), [id], false);
                }
                return id;
              } else {
                throw this.unexpected();
              }
          }
        }
        parseTopicReferenceThenEqualsSign(topicTokenType, topicTokenValue) {
          const pipeProposal = this.getPluginOption("pipelineOperator", "proposal");
          if (pipeProposal) {
            this.state.type = topicTokenType;
            this.state.value = topicTokenValue;
            this.state.pos--;
            this.state.end--;
            this.state.endLoc = createPositionWithColumnOffset(this.state.endLoc, -1);
            return this.parseTopicReference(pipeProposal);
          } else {
            throw this.unexpected();
          }
        }
        parseTopicReference(pipeProposal) {
          const node = this.startNode();
          const startLoc = this.state.startLoc;
          const tokenType = this.state.type;
          this.next();
          return this.finishTopicReference(node, startLoc, pipeProposal, tokenType);
        }
        finishTopicReference(node, startLoc, pipeProposal, tokenType) {
          if (this.testTopicReferenceConfiguration(pipeProposal, startLoc, tokenType)) {
            const nodeType = pipeProposal === "smart" ? "PipelinePrimaryTopicReference" : "TopicReference";
            if (!this.topicReferenceIsAllowedInCurrentContext()) {
              this.raise(
                pipeProposal === "smart" ? Errors.PrimaryTopicNotAllowed : Errors.PipeTopicUnbound,
                {
                  at: startLoc
                }
              );
            }
            this.registerTopicReference();
            return this.finishNode(node, nodeType);
          } else {
            throw this.raise(Errors.PipeTopicUnconfiguredToken, {
              at: startLoc,
              token: tokenLabelName(tokenType)
            });
          }
        }
        testTopicReferenceConfiguration(pipeProposal, startLoc, tokenType) {
          switch (pipeProposal) {
            case "hack": {
              return this.hasPlugin(["pipelineOperator", {
                topicToken: tokenLabelName(tokenType)
              }]);
            }
            case "smart":
              return tokenType === 27;
            default:
              throw this.raise(Errors.PipeTopicRequiresHackPipes, {
                at: startLoc
              });
          }
        }
        parseAsyncArrowUnaryFunction(node) {
          this.prodParam.enter(functionFlags(true, this.prodParam.hasYield));
          const params = [this.parseIdentifier()];
          this.prodParam.exit();
          if (this.hasPrecedingLineBreak()) {
            this.raise(Errors.LineTerminatorBeforeArrow, {
              at: this.state.curPosition()
            });
          }
          this.expect(19);
          return this.parseArrowExpression(node, params, true);
        }
        parseDo(node, isAsync) {
          this.expectPlugin("doExpressions");
          if (isAsync) {
            this.expectPlugin("asyncDoExpressions");
          }
          node.async = isAsync;
          this.next();
          const oldLabels = this.state.labels;
          this.state.labels = [];
          if (isAsync) {
            this.prodParam.enter(PARAM_AWAIT);
            node.body = this.parseBlock();
            this.prodParam.exit();
          } else {
            node.body = this.parseBlock();
          }
          this.state.labels = oldLabels;
          return this.finishNode(node, "DoExpression");
        }
        parseSuper() {
          const node = this.startNode();
          this.next();
          if (this.match(10) && !this.scope.allowDirectSuper && !this.options.allowSuperOutsideMethod) {
            this.raise(Errors.SuperNotAllowed, {
              at: node
            });
          } else if (!this.scope.allowSuper && !this.options.allowSuperOutsideMethod) {
            this.raise(Errors.UnexpectedSuper, {
              at: node
            });
          }
          if (!this.match(10) && !this.match(0) && !this.match(16)) {
            this.raise(Errors.UnsupportedSuper, {
              at: node
            });
          }
          return this.finishNode(node, "Super");
        }
        parsePrivateName() {
          const node = this.startNode();
          const id = this.startNodeAt(
            createPositionWithColumnOffset(this.state.startLoc, 1)
          );
          const name = this.state.value;
          this.next();
          node.id = this.createIdentifier(id, name);
          return this.finishNode(node, "PrivateName");
        }
        parseFunctionOrFunctionSent() {
          const node = this.startNode();
          this.next();
          if (this.prodParam.hasYield && this.match(16)) {
            const meta = this.createIdentifier(this.startNodeAtNode(node), "function");
            this.next();
            if (this.match(102)) {
              this.expectPlugin("functionSent");
            } else if (!this.hasPlugin("functionSent")) {
              this.unexpected();
            }
            return this.parseMetaProperty(node, meta, "sent");
          }
          return this.parseFunction(node);
        }
        parseMetaProperty(node, meta, propertyName) {
          node.meta = meta;
          const containsEsc = this.state.containsEsc;
          node.property = this.parseIdentifier(true);
          if (node.property.name !== propertyName || containsEsc) {
            this.raise(Errors.UnsupportedMetaProperty, {
              at: node.property,
              target: meta.name,
              onlyValidPropertyName: propertyName
            });
          }
          return this.finishNode(node, "MetaProperty");
        }
        parseImportMetaProperty(node) {
          const id = this.createIdentifier(this.startNodeAtNode(node), "import");
          this.next();
          if (this.isContextual(100)) {
            if (!this.inModule) {
              this.raise(Errors.ImportMetaOutsideModule, {
                at: id
              });
            }
            this.sawUnambiguousESM = true;
          }
          return this.parseMetaProperty(node, id, "meta");
        }
        parseLiteralAtNode(value, type, node) {
          this.addExtra(node, "rawValue", value);
          this.addExtra(node, "raw", this.input.slice(node.start, this.state.end));
          node.value = value;
          this.next();
          return this.finishNode(node, type);
        }
        parseLiteral(value, type) {
          const node = this.startNode();
          return this.parseLiteralAtNode(value, type, node);
        }
        parseStringLiteral(value) {
          return this.parseLiteral(value, "StringLiteral");
        }
        parseNumericLiteral(value) {
          return this.parseLiteral(value, "NumericLiteral");
        }
        parseBigIntLiteral(value) {
          return this.parseLiteral(value, "BigIntLiteral");
        }
        parseDecimalLiteral(value) {
          return this.parseLiteral(value, "DecimalLiteral");
        }
        parseRegExpLiteral(value) {
          const node = this.parseLiteral(value.value, "RegExpLiteral");
          node.pattern = value.pattern;
          node.flags = value.flags;
          return node;
        }
        parseBooleanLiteral(value) {
          const node = this.startNode();
          node.value = value;
          this.next();
          return this.finishNode(node, "BooleanLiteral");
        }
        parseNullLiteral() {
          const node = this.startNode();
          this.next();
          return this.finishNode(node, "NullLiteral");
        }
        parseParenAndDistinguishExpression(canBeArrow) {
          const startLoc = this.state.startLoc;
          let val;
          this.next();
          this.expressionScope.enter(newArrowHeadScope());
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.maybeInArrowParameters = true;
          this.state.inFSharpPipelineDirectBody = false;
          const innerStartLoc = this.state.startLoc;
          const exprList = [];
          const refExpressionErrors = new ExpressionErrors();
          let first = true;
          let spreadStartLoc;
          let optionalCommaStartLoc;
          while (!this.match(11)) {
            if (first) {
              first = false;
            } else {
              this.expect(12, refExpressionErrors.optionalParametersLoc === null ? null : refExpressionErrors.optionalParametersLoc);
              if (this.match(11)) {
                optionalCommaStartLoc = this.state.startLoc;
                break;
              }
            }
            if (this.match(21)) {
              const spreadNodeStartLoc = this.state.startLoc;
              spreadStartLoc = this.state.startLoc;
              exprList.push(this.parseParenItem(this.parseRestBinding(), spreadNodeStartLoc));
              if (!this.checkCommaAfterRest(41)) {
                break;
              }
            } else {
              exprList.push(this.parseMaybeAssignAllowIn(refExpressionErrors, this.parseParenItem));
            }
          }
          const innerEndLoc = this.state.lastTokEndLoc;
          this.expect(11);
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          let arrowNode = this.startNodeAt(startLoc);
          if (canBeArrow && this.shouldParseArrow(exprList) && (arrowNode = this.parseArrow(arrowNode))) {
            this.checkDestructuringPrivate(refExpressionErrors);
            this.expressionScope.validateAsPattern();
            this.expressionScope.exit();
            this.parseArrowExpression(arrowNode, exprList, false);
            return arrowNode;
          }
          this.expressionScope.exit();
          if (!exprList.length) {
            this.unexpected(this.state.lastTokStartLoc);
          }
          if (optionalCommaStartLoc)
            this.unexpected(optionalCommaStartLoc);
          if (spreadStartLoc)
            this.unexpected(spreadStartLoc);
          this.checkExpressionErrors(refExpressionErrors, true);
          this.toReferencedListDeep(exprList, true);
          if (exprList.length > 1) {
            val = this.startNodeAt(innerStartLoc);
            val.expressions = exprList;
            this.finishNode(val, "SequenceExpression");
            this.resetEndLocation(val, innerEndLoc);
          } else {
            val = exprList[0];
          }
          return this.wrapParenthesis(
            startLoc,
            val
          );
        }
        wrapParenthesis(startLoc, expression) {
          if (!this.options.createParenthesizedExpressions) {
            this.addExtra(expression, "parenthesized", true);
            this.addExtra(expression, "parenStart", startLoc.index);
            this.takeSurroundingComments(expression, startLoc.index, this.state.lastTokEndLoc.index);
            return expression;
          }
          const parenExpression = this.startNodeAt(startLoc);
          parenExpression.expression = expression;
          return this.finishNode(parenExpression, "ParenthesizedExpression");
        }
        shouldParseArrow(params) {
          return !this.canInsertSemicolon();
        }
        parseArrow(node) {
          if (this.eat(19)) {
            return node;
          }
        }
        parseParenItem(node, startLoc) {
          return node;
        }
        parseNewOrNewTarget() {
          const node = this.startNode();
          this.next();
          if (this.match(16)) {
            const meta = this.createIdentifier(this.startNodeAtNode(node), "new");
            this.next();
            const metaProp = this.parseMetaProperty(node, meta, "target");
            if (!this.scope.inNonArrowFunction && !this.scope.inClass) {
              this.raise(Errors.UnexpectedNewTarget, {
                at: metaProp
              });
            }
            return metaProp;
          }
          return this.parseNew(node);
        }
        parseNew(node) {
          this.parseNewCallee(node);
          if (this.eat(10)) {
            const args = this.parseExprList(11);
            this.toReferencedList(args);
            node.arguments = args;
          } else {
            node.arguments = [];
          }
          return this.finishNode(node, "NewExpression");
        }
        parseNewCallee(node) {
          node.callee = this.parseNoCallExpr();
          if (node.callee.type === "Import") {
            this.raise(Errors.ImportCallNotNewExpression, {
              at: node.callee
            });
          } else if (this.isOptionalChain(node.callee)) {
            this.raise(Errors.OptionalChainingNoNew, {
              at: this.state.lastTokEndLoc
            });
          } else if (this.eat(18)) {
            this.raise(Errors.OptionalChainingNoNew, {
              at: this.state.startLoc
            });
          }
        }
        parseTemplateElement(isTagged) {
          const {
            start,
            startLoc,
            end,
            value
          } = this.state;
          const elemStart = start + 1;
          const elem = this.startNodeAt(createPositionWithColumnOffset(startLoc, 1));
          if (value === null) {
            if (!isTagged) {
              this.raise(Errors.InvalidEscapeSequenceTemplate, {
                at: createPositionWithColumnOffset(this.state.firstInvalidTemplateEscapePos, 1)
              });
            }
          }
          const isTail = this.match(24);
          const endOffset = isTail ? -1 : -2;
          const elemEnd = end + endOffset;
          elem.value = {
            raw: this.input.slice(elemStart, elemEnd).replace(/\r\n?/g, "\n"),
            cooked: value === null ? null : value.slice(1, endOffset)
          };
          elem.tail = isTail;
          this.next();
          const finishedNode = this.finishNode(elem, "TemplateElement");
          this.resetEndLocation(finishedNode, createPositionWithColumnOffset(this.state.lastTokEndLoc, endOffset));
          return finishedNode;
        }
        parseTemplate(isTagged) {
          const node = this.startNode();
          node.expressions = [];
          let curElt = this.parseTemplateElement(isTagged);
          node.quasis = [curElt];
          while (!curElt.tail) {
            node.expressions.push(this.parseTemplateSubstitution());
            this.readTemplateContinuation();
            node.quasis.push(curElt = this.parseTemplateElement(isTagged));
          }
          return this.finishNode(node, "TemplateLiteral");
        }
        parseTemplateSubstitution() {
          return this.parseExpression();
        }
        parseObjectLike(close, isPattern, isRecord, refExpressionErrors) {
          if (isRecord) {
            this.expectPlugin("recordAndTuple");
          }
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = false;
          const propHash = /* @__PURE__ */ Object.create(null);
          let first = true;
          const node = this.startNode();
          node.properties = [];
          this.next();
          while (!this.match(close)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.match(close)) {
                this.addTrailingCommaExtraToNode(
                  node
                );
                break;
              }
            }
            let prop;
            if (isPattern) {
              prop = this.parseBindingProperty();
            } else {
              prop = this.parsePropertyDefinition(refExpressionErrors);
              this.checkProto(prop, isRecord, propHash, refExpressionErrors);
            }
            if (isRecord && !this.isObjectProperty(prop) && prop.type !== "SpreadElement") {
              this.raise(Errors.InvalidRecordProperty, {
                at: prop
              });
            }
            if (prop.shorthand) {
              this.addExtra(prop, "shorthand", true);
            }
            node.properties.push(prop);
          }
          this.next();
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          let type = "ObjectExpression";
          if (isPattern) {
            type = "ObjectPattern";
          } else if (isRecord) {
            type = "RecordExpression";
          }
          return this.finishNode(node, type);
        }
        addTrailingCommaExtraToNode(node) {
          this.addExtra(node, "trailingComma", this.state.lastTokStart);
          this.addExtra(node, "trailingCommaLoc", this.state.lastTokStartLoc, false);
        }
        maybeAsyncOrAccessorProp(prop) {
          return !prop.computed && prop.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
        }
        parsePropertyDefinition(refExpressionErrors) {
          let decorators = [];
          if (this.match(26)) {
            if (this.hasPlugin("decorators")) {
              this.raise(Errors.UnsupportedPropertyDecorator, {
                at: this.state.startLoc
              });
            }
            while (this.match(26)) {
              decorators.push(this.parseDecorator());
            }
          }
          const prop = this.startNode();
          let isAsync = false;
          let isAccessor = false;
          let startLoc;
          if (this.match(21)) {
            if (decorators.length)
              this.unexpected();
            return this.parseSpread();
          }
          if (decorators.length) {
            prop.decorators = decorators;
            decorators = [];
          }
          prop.method = false;
          if (refExpressionErrors) {
            startLoc = this.state.startLoc;
          }
          let isGenerator = this.eat(55);
          this.parsePropertyNamePrefixOperator(prop);
          const containsEsc = this.state.containsEsc;
          const key = this.parsePropertyName(prop, refExpressionErrors);
          if (!isGenerator && !containsEsc && this.maybeAsyncOrAccessorProp(prop)) {
            const keyName = key.name;
            if (keyName === "async" && !this.hasPrecedingLineBreak()) {
              isAsync = true;
              this.resetPreviousNodeTrailingComments(key);
              isGenerator = this.eat(55);
              this.parsePropertyName(prop);
            }
            if (keyName === "get" || keyName === "set") {
              isAccessor = true;
              this.resetPreviousNodeTrailingComments(key);
              prop.kind = keyName;
              if (this.match(55)) {
                isGenerator = true;
                this.raise(Errors.AccessorIsGenerator, {
                  at: this.state.curPosition(),
                  kind: keyName
                });
                this.next();
              }
              this.parsePropertyName(prop);
            }
          }
          return this.parseObjPropValue(prop, startLoc, isGenerator, isAsync, false, isAccessor, refExpressionErrors);
        }
        getGetterSetterExpectedParamCount(method2) {
          return method2.kind === "get" ? 0 : 1;
        }
        getObjectOrClassMethodParams(method2) {
          return method2.params;
        }
        checkGetterSetterParams(method2) {
          var _params;
          const paramCount = this.getGetterSetterExpectedParamCount(method2);
          const params = this.getObjectOrClassMethodParams(method2);
          if (params.length !== paramCount) {
            this.raise(method2.kind === "get" ? Errors.BadGetterArity : Errors.BadSetterArity, {
              at: method2
            });
          }
          if (method2.kind === "set" && ((_params = params[params.length - 1]) == null ? void 0 : _params.type) === "RestElement") {
            this.raise(Errors.BadSetterRestParameter, {
              at: method2
            });
          }
        }
        parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor) {
          if (isAccessor) {
            const finishedProp = this.parseMethod(
              prop,
              isGenerator,
              false,
              false,
              false,
              "ObjectMethod"
            );
            this.checkGetterSetterParams(finishedProp);
            return finishedProp;
          }
          if (isAsync || isGenerator || this.match(10)) {
            if (isPattern)
              this.unexpected();
            prop.kind = "method";
            prop.method = true;
            return this.parseMethod(prop, isGenerator, isAsync, false, false, "ObjectMethod");
          }
        }
        parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors) {
          prop.shorthand = false;
          if (this.eat(14)) {
            prop.value = isPattern ? this.parseMaybeDefault(this.state.startLoc) : this.parseMaybeAssignAllowIn(refExpressionErrors);
            return this.finishNode(prop, "ObjectProperty");
          }
          if (!prop.computed && prop.key.type === "Identifier") {
            this.checkReservedWord(prop.key.name, prop.key.loc.start, true, false);
            if (isPattern) {
              prop.value = this.parseMaybeDefault(startLoc, cloneIdentifier(prop.key));
            } else if (this.match(29)) {
              const shorthandAssignLoc = this.state.startLoc;
              if (refExpressionErrors != null) {
                if (refExpressionErrors.shorthandAssignLoc === null) {
                  refExpressionErrors.shorthandAssignLoc = shorthandAssignLoc;
                }
              } else {
                this.raise(Errors.InvalidCoverInitializedName, {
                  at: shorthandAssignLoc
                });
              }
              prop.value = this.parseMaybeDefault(startLoc, cloneIdentifier(prop.key));
            } else {
              prop.value = cloneIdentifier(prop.key);
            }
            prop.shorthand = true;
            return this.finishNode(prop, "ObjectProperty");
          }
        }
        parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
          const node = this.parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor) || this.parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors);
          if (!node)
            this.unexpected();
          return node;
        }
        parsePropertyName(prop, refExpressionErrors) {
          if (this.eat(0)) {
            prop.computed = true;
            prop.key = this.parseMaybeAssignAllowIn();
            this.expect(3);
          } else {
            const {
              type,
              value
            } = this.state;
            let key;
            if (tokenIsKeywordOrIdentifier(type)) {
              key = this.parseIdentifier(true);
            } else {
              switch (type) {
                case 132:
                  key = this.parseNumericLiteral(value);
                  break;
                case 131:
                  key = this.parseStringLiteral(value);
                  break;
                case 133:
                  key = this.parseBigIntLiteral(value);
                  break;
                case 134:
                  key = this.parseDecimalLiteral(value);
                  break;
                case 136: {
                  const privateKeyLoc = this.state.startLoc;
                  if (refExpressionErrors != null) {
                    if (refExpressionErrors.privateKeyLoc === null) {
                      refExpressionErrors.privateKeyLoc = privateKeyLoc;
                    }
                  } else {
                    this.raise(Errors.UnexpectedPrivateField, {
                      at: privateKeyLoc
                    });
                  }
                  key = this.parsePrivateName();
                  break;
                }
                default:
                  throw this.unexpected();
              }
            }
            prop.key = key;
            if (type !== 136) {
              prop.computed = false;
            }
          }
          return prop.key;
        }
        initFunction(node, isAsync) {
          node.id = null;
          node.generator = false;
          node.async = isAsync;
        }
        parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope = false) {
          this.initFunction(node, isAsync);
          node.generator = isGenerator;
          const allowModifiers = isConstructor;
          this.scope.enter(SCOPE_FUNCTION | SCOPE_SUPER | (inClassScope ? SCOPE_CLASS : 0) | (allowDirectSuper ? SCOPE_DIRECT_SUPER : 0));
          this.prodParam.enter(functionFlags(isAsync, node.generator));
          this.parseFunctionParams(node, allowModifiers);
          const finishedNode = this.parseFunctionBodyAndFinish(node, type, true);
          this.prodParam.exit();
          this.scope.exit();
          return finishedNode;
        }
        parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
          if (isTuple) {
            this.expectPlugin("recordAndTuple");
          }
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = false;
          const node = this.startNode();
          this.next();
          node.elements = this.parseExprList(
            close,
            !isTuple,
            refExpressionErrors,
            node
          );
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          return this.finishNode(node, isTuple ? "TupleExpression" : "ArrayExpression");
        }
        parseArrowExpression(node, params, isAsync, trailingCommaLoc) {
          this.scope.enter(SCOPE_FUNCTION | SCOPE_ARROW);
          let flags = functionFlags(isAsync, false);
          if (!this.match(5) && this.prodParam.hasIn) {
            flags |= PARAM_IN;
          }
          this.prodParam.enter(flags);
          this.initFunction(node, isAsync);
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          if (params) {
            this.state.maybeInArrowParameters = true;
            this.setArrowFunctionParameters(node, params, trailingCommaLoc);
          }
          this.state.maybeInArrowParameters = false;
          this.parseFunctionBody(node, true);
          this.prodParam.exit();
          this.scope.exit();
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          return this.finishNode(node, "ArrowFunctionExpression");
        }
        setArrowFunctionParameters(node, params, trailingCommaLoc) {
          this.toAssignableList(params, trailingCommaLoc, false);
          node.params = params;
        }
        parseFunctionBodyAndFinish(node, type, isMethod = false) {
          this.parseFunctionBody(node, false, isMethod);
          return this.finishNode(node, type);
        }
        parseFunctionBody(node, allowExpression, isMethod = false) {
          const isExpression = allowExpression && !this.match(5);
          this.expressionScope.enter(newExpressionScope());
          if (isExpression) {
            node.body = this.parseMaybeAssign();
            this.checkParams(node, false, allowExpression, false);
          } else {
            const oldStrict = this.state.strict;
            const oldLabels = this.state.labels;
            this.state.labels = [];
            this.prodParam.enter(this.prodParam.currentFlags() | PARAM_RETURN);
            node.body = this.parseBlock(
              true,
              false,
              (hasStrictModeDirective) => {
                const nonSimple = !this.isSimpleParamList(node.params);
                if (hasStrictModeDirective && nonSimple) {
                  this.raise(Errors.IllegalLanguageModeDirective, {
                    at: (node.kind === "method" || node.kind === "constructor") && !!node.key ? node.key.loc.end : node
                  });
                }
                const strictModeChanged = !oldStrict && this.state.strict;
                this.checkParams(node, !this.state.strict && !allowExpression && !isMethod && !nonSimple, allowExpression, strictModeChanged);
                if (this.state.strict && node.id) {
                  this.checkIdentifier(node.id, BIND_OUTSIDE, strictModeChanged);
                }
              }
            );
            this.prodParam.exit();
            this.state.labels = oldLabels;
          }
          this.expressionScope.exit();
        }
        isSimpleParameter(node) {
          return node.type === "Identifier";
        }
        isSimpleParamList(params) {
          for (let i = 0, len = params.length; i < len; i++) {
            if (!this.isSimpleParameter(params[i]))
              return false;
          }
          return true;
        }
        checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged = true) {
          const checkClashes = !allowDuplicates && /* @__PURE__ */ new Set();
          const formalParameters = {
            type: "FormalParameters"
          };
          for (const param of node.params) {
            this.checkLVal(param, {
              in: formalParameters,
              binding: BIND_VAR,
              checkClashes,
              strictModeChanged
            });
          }
        }
        parseExprList(close, allowEmpty, refExpressionErrors, nodeForExtra) {
          const elts = [];
          let first = true;
          while (!this.eat(close)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.match(close)) {
                if (nodeForExtra) {
                  this.addTrailingCommaExtraToNode(nodeForExtra);
                }
                this.next();
                break;
              }
            }
            elts.push(this.parseExprListItem(allowEmpty, refExpressionErrors));
          }
          return elts;
        }
        parseExprListItem(allowEmpty, refExpressionErrors, allowPlaceholder) {
          let elt;
          if (this.match(12)) {
            if (!allowEmpty) {
              this.raise(Errors.UnexpectedToken, {
                at: this.state.curPosition(),
                unexpected: ","
              });
            }
            elt = null;
          } else if (this.match(21)) {
            const spreadNodeStartLoc = this.state.startLoc;
            elt = this.parseParenItem(this.parseSpread(refExpressionErrors), spreadNodeStartLoc);
          } else if (this.match(17)) {
            this.expectPlugin("partialApplication");
            if (!allowPlaceholder) {
              this.raise(Errors.UnexpectedArgumentPlaceholder, {
                at: this.state.startLoc
              });
            }
            const node = this.startNode();
            this.next();
            elt = this.finishNode(node, "ArgumentPlaceholder");
          } else {
            elt = this.parseMaybeAssignAllowIn(refExpressionErrors, this.parseParenItem);
          }
          return elt;
        }
        parseIdentifier(liberal) {
          const node = this.startNode();
          const name = this.parseIdentifierName(liberal);
          return this.createIdentifier(node, name);
        }
        createIdentifier(node, name) {
          node.name = name;
          node.loc.identifierName = name;
          return this.finishNode(node, "Identifier");
        }
        parseIdentifierName(liberal) {
          let name;
          const {
            startLoc,
            type
          } = this.state;
          if (tokenIsKeywordOrIdentifier(type)) {
            name = this.state.value;
          } else {
            throw this.unexpected();
          }
          const tokenIsKeyword2 = tokenKeywordOrIdentifierIsKeyword(type);
          if (liberal) {
            if (tokenIsKeyword2) {
              this.replaceToken(130);
            }
          } else {
            this.checkReservedWord(name, startLoc, tokenIsKeyword2, false);
          }
          this.next();
          return name;
        }
        checkReservedWord(word, startLoc, checkKeywords, isBinding) {
          if (word.length > 10) {
            return;
          }
          if (!canBeReservedWord(word)) {
            return;
          }
          if (word === "yield") {
            if (this.prodParam.hasYield) {
              this.raise(Errors.YieldBindingIdentifier, {
                at: startLoc
              });
              return;
            }
          } else if (word === "await") {
            if (this.prodParam.hasAwait) {
              this.raise(Errors.AwaitBindingIdentifier, {
                at: startLoc
              });
              return;
            }
            if (this.scope.inStaticBlock) {
              this.raise(Errors.AwaitBindingIdentifierInStaticBlock, {
                at: startLoc
              });
              return;
            }
            this.expressionScope.recordAsyncArrowParametersError({
              at: startLoc
            });
          } else if (word === "arguments") {
            if (this.scope.inClassAndNotInNonArrowFunction) {
              this.raise(Errors.ArgumentsInClass, {
                at: startLoc
              });
              return;
            }
          }
          if (checkKeywords && isKeyword(word)) {
            this.raise(Errors.UnexpectedKeyword, {
              at: startLoc,
              keyword: word
            });
            return;
          }
          const reservedTest = !this.state.strict ? isReservedWord : isBinding ? isStrictBindReservedWord : isStrictReservedWord;
          if (reservedTest(word, this.inModule)) {
            this.raise(Errors.UnexpectedReservedWord, {
              at: startLoc,
              reservedWord: word
            });
          }
        }
        isAwaitAllowed() {
          if (this.prodParam.hasAwait)
            return true;
          if (this.options.allowAwaitOutsideFunction && !this.scope.inFunction) {
            return true;
          }
          return false;
        }
        parseAwait(startLoc) {
          const node = this.startNodeAt(startLoc);
          this.expressionScope.recordParameterInitializerError(Errors.AwaitExpressionFormalParameter, {
            at: node
          });
          if (this.eat(55)) {
            this.raise(Errors.ObsoleteAwaitStar, {
              at: node
            });
          }
          if (!this.scope.inFunction && !this.options.allowAwaitOutsideFunction) {
            if (this.isAmbiguousAwait()) {
              this.ambiguousScriptDifferentAst = true;
            } else {
              this.sawUnambiguousESM = true;
            }
          }
          if (!this.state.soloAwait) {
            node.argument = this.parseMaybeUnary(null, true);
          }
          return this.finishNode(node, "AwaitExpression");
        }
        isAmbiguousAwait() {
          if (this.hasPrecedingLineBreak())
            return true;
          const {
            type
          } = this.state;
          return type === 53 || type === 10 || type === 0 || tokenIsTemplate(type) || type === 101 && !this.state.containsEsc || type === 135 || type === 56 || this.hasPlugin("v8intrinsic") && type === 54;
        }
        parseYield() {
          const node = this.startNode();
          this.expressionScope.recordParameterInitializerError(Errors.YieldInParameter, {
            at: node
          });
          this.next();
          let delegating = false;
          let argument = null;
          if (!this.hasPrecedingLineBreak()) {
            delegating = this.eat(55);
            switch (this.state.type) {
              case 13:
              case 137:
              case 8:
              case 11:
              case 3:
              case 9:
              case 14:
              case 12:
                if (!delegating)
                  break;
              default:
                argument = this.parseMaybeAssign();
            }
          }
          node.delegate = delegating;
          node.argument = argument;
          return this.finishNode(node, "YieldExpression");
        }
        checkPipelineAtInfixOperator(left, leftStartLoc) {
          if (this.hasPlugin(["pipelineOperator", {
            proposal: "smart"
          }])) {
            if (left.type === "SequenceExpression") {
              this.raise(Errors.PipelineHeadSequenceExpression, {
                at: leftStartLoc
              });
            }
          }
        }
        parseSmartPipelineBodyInStyle(childExpr, startLoc) {
          if (this.isSimpleReference(childExpr)) {
            const bodyNode = this.startNodeAt(startLoc);
            bodyNode.callee = childExpr;
            return this.finishNode(bodyNode, "PipelineBareFunction");
          } else {
            const bodyNode = this.startNodeAt(startLoc);
            this.checkSmartPipeTopicBodyEarlyErrors(startLoc);
            bodyNode.expression = childExpr;
            return this.finishNode(bodyNode, "PipelineTopicExpression");
          }
        }
        isSimpleReference(expression) {
          switch (expression.type) {
            case "MemberExpression":
              return !expression.computed && this.isSimpleReference(expression.object);
            case "Identifier":
              return true;
            default:
              return false;
          }
        }
        checkSmartPipeTopicBodyEarlyErrors(startLoc) {
          if (this.match(19)) {
            throw this.raise(Errors.PipelineBodyNoArrow, {
              at: this.state.startLoc
            });
          }
          if (!this.topicReferenceWasUsedInCurrentContext()) {
            this.raise(Errors.PipelineTopicUnused, {
              at: startLoc
            });
          }
        }
        withTopicBindingContext(callback) {
          const outerContextTopicState = this.state.topicContext;
          this.state.topicContext = {
            maxNumOfResolvableTopics: 1,
            maxTopicIndex: null
          };
          try {
            return callback();
          } finally {
            this.state.topicContext = outerContextTopicState;
          }
        }
        withSmartMixTopicForbiddingContext(callback) {
          if (this.hasPlugin(["pipelineOperator", {
            proposal: "smart"
          }])) {
            const outerContextTopicState = this.state.topicContext;
            this.state.topicContext = {
              maxNumOfResolvableTopics: 0,
              maxTopicIndex: null
            };
            try {
              return callback();
            } finally {
              this.state.topicContext = outerContextTopicState;
            }
          } else {
            return callback();
          }
        }
        withSoloAwaitPermittingContext(callback) {
          const outerContextSoloAwaitState = this.state.soloAwait;
          this.state.soloAwait = true;
          try {
            return callback();
          } finally {
            this.state.soloAwait = outerContextSoloAwaitState;
          }
        }
        allowInAnd(callback) {
          const flags = this.prodParam.currentFlags();
          const prodParamToSet = PARAM_IN & ~flags;
          if (prodParamToSet) {
            this.prodParam.enter(flags | PARAM_IN);
            try {
              return callback();
            } finally {
              this.prodParam.exit();
            }
          }
          return callback();
        }
        disallowInAnd(callback) {
          const flags = this.prodParam.currentFlags();
          const prodParamToClear = PARAM_IN & flags;
          if (prodParamToClear) {
            this.prodParam.enter(flags & ~PARAM_IN);
            try {
              return callback();
            } finally {
              this.prodParam.exit();
            }
          }
          return callback();
        }
        registerTopicReference() {
          this.state.topicContext.maxTopicIndex = 0;
        }
        topicReferenceIsAllowedInCurrentContext() {
          return this.state.topicContext.maxNumOfResolvableTopics >= 1;
        }
        topicReferenceWasUsedInCurrentContext() {
          return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
        }
        parseFSharpPipelineBody(prec) {
          const startLoc = this.state.startLoc;
          this.state.potentialArrowAt = this.state.start;
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = true;
          const ret = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), startLoc, prec);
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          return ret;
        }
        parseModuleExpression() {
          this.expectPlugin("moduleBlocks");
          const node = this.startNode();
          this.next();
          if (!this.match(5)) {
            this.unexpected(null, 5);
          }
          const program3 = this.startNodeAt(this.state.endLoc);
          this.next();
          const revertScopes = this.initializeScopes(true);
          this.enterInitialScopes();
          try {
            node.body = this.parseProgram(program3, 8, "module");
          } finally {
            revertScopes();
          }
          return this.finishNode(node, "ModuleExpression");
        }
        parsePropertyNamePrefixOperator(prop) {
        }
      };
      var loopLabel = {
        kind: "loop"
      };
      var switchLabel = {
        kind: "switch"
      };
      var ParseFunctionFlag = {
        Expression: 0,
        Declaration: 1,
        HangingDeclaration: 2,
        NullableId: 4,
        Async: 8
      };
      var ParseStatementFlag = {
        StatementOnly: 0,
        AllowImportExport: 1,
        AllowDeclaration: 2,
        AllowFunctionDeclaration: 4,
        AllowLabeledFunction: 8
      };
      var loneSurrogate = /[\uD800-\uDFFF]/u;
      var keywordRelationalOperator = /in(?:stanceof)?/y;
      function babel7CompatTokens(tokens, input) {
        for (let i = 0; i < tokens.length; i++) {
          const token = tokens[i];
          const {
            type
          } = token;
          if (typeof type === "number") {
            {
              if (type === 136) {
                const {
                  loc,
                  start,
                  value,
                  end
                } = token;
                const hashEndPos = start + 1;
                const hashEndLoc = createPositionWithColumnOffset(loc.start, 1);
                tokens.splice(i, 1, new Token({
                  type: getExportedToken(27),
                  value: "#",
                  start,
                  end: hashEndPos,
                  startLoc: loc.start,
                  endLoc: hashEndLoc
                }), new Token({
                  type: getExportedToken(130),
                  value,
                  start: hashEndPos,
                  end,
                  startLoc: hashEndLoc,
                  endLoc: loc.end
                }));
                i++;
                continue;
              }
              if (tokenIsTemplate(type)) {
                const {
                  loc,
                  start,
                  value,
                  end
                } = token;
                const backquoteEnd = start + 1;
                const backquoteEndLoc = createPositionWithColumnOffset(loc.start, 1);
                let startToken;
                if (input.charCodeAt(start) === 96) {
                  startToken = new Token({
                    type: getExportedToken(22),
                    value: "`",
                    start,
                    end: backquoteEnd,
                    startLoc: loc.start,
                    endLoc: backquoteEndLoc
                  });
                } else {
                  startToken = new Token({
                    type: getExportedToken(8),
                    value: "}",
                    start,
                    end: backquoteEnd,
                    startLoc: loc.start,
                    endLoc: backquoteEndLoc
                  });
                }
                let templateValue, templateElementEnd, templateElementEndLoc, endToken;
                if (type === 24) {
                  templateElementEnd = end - 1;
                  templateElementEndLoc = createPositionWithColumnOffset(loc.end, -1);
                  templateValue = value === null ? null : value.slice(1, -1);
                  endToken = new Token({
                    type: getExportedToken(22),
                    value: "`",
                    start: templateElementEnd,
                    end,
                    startLoc: templateElementEndLoc,
                    endLoc: loc.end
                  });
                } else {
                  templateElementEnd = end - 2;
                  templateElementEndLoc = createPositionWithColumnOffset(loc.end, -2);
                  templateValue = value === null ? null : value.slice(1, -2);
                  endToken = new Token({
                    type: getExportedToken(23),
                    value: "${",
                    start: templateElementEnd,
                    end,
                    startLoc: templateElementEndLoc,
                    endLoc: loc.end
                  });
                }
                tokens.splice(i, 1, startToken, new Token({
                  type: getExportedToken(20),
                  value: templateValue,
                  start: backquoteEnd,
                  end: templateElementEnd,
                  startLoc: backquoteEndLoc,
                  endLoc: templateElementEndLoc
                }), endToken);
                i += 2;
                continue;
              }
            }
            token.type = getExportedToken(type);
          }
        }
        return tokens;
      }
      var StatementParser = class extends ExpressionParser {
        parseTopLevel(file2, program3) {
          file2.program = this.parseProgram(program3);
          file2.comments = this.state.comments;
          if (this.options.tokens) {
            file2.tokens = babel7CompatTokens(this.tokens, this.input);
          }
          return this.finishNode(file2, "File");
        }
        parseProgram(program3, end = 137, sourceType = this.options.sourceType) {
          program3.sourceType = sourceType;
          program3.interpreter = this.parseInterpreterDirective();
          this.parseBlockBody(program3, true, true, end);
          if (this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0) {
            for (const [localName, at2] of Array.from(this.scope.undefinedExports)) {
              this.raise(Errors.ModuleExportUndefined, {
                at: at2,
                localName
              });
            }
          }
          let finishedProgram;
          if (end === 137) {
            finishedProgram = this.finishNode(program3, "Program");
          } else {
            finishedProgram = this.finishNodeAt(program3, "Program", createPositionWithColumnOffset(this.state.startLoc, -1));
          }
          return finishedProgram;
        }
        stmtToDirective(stmt) {
          const directive = stmt;
          directive.type = "Directive";
          directive.value = directive.expression;
          delete directive.expression;
          const directiveLiteral = directive.value;
          const expressionValue = directiveLiteral.value;
          const raw = this.input.slice(directiveLiteral.start, directiveLiteral.end);
          const val = directiveLiteral.value = raw.slice(1, -1);
          this.addExtra(directiveLiteral, "raw", raw);
          this.addExtra(directiveLiteral, "rawValue", val);
          this.addExtra(directiveLiteral, "expressionValue", expressionValue);
          directiveLiteral.type = "DirectiveLiteral";
          return directive;
        }
        parseInterpreterDirective() {
          if (!this.match(28)) {
            return null;
          }
          const node = this.startNode();
          node.value = this.state.value;
          this.next();
          return this.finishNode(node, "InterpreterDirective");
        }
        isLet() {
          if (!this.isContextual(99)) {
            return false;
          }
          return this.hasFollowingBindingAtom();
        }
        chStartsBindingIdentifier(ch, pos) {
          if (isIdentifierStart(ch)) {
            keywordRelationalOperator.lastIndex = pos;
            if (keywordRelationalOperator.test(this.input)) {
              const endCh = this.codePointAtPos(keywordRelationalOperator.lastIndex);
              if (!isIdentifierChar(endCh) && endCh !== 92) {
                return false;
              }
            }
            return true;
          } else if (ch === 92) {
            return true;
          } else {
            return false;
          }
        }
        chStartsBindingPattern(ch) {
          return ch === 91 || ch === 123;
        }
        hasFollowingBindingAtom() {
          const next = this.nextTokenStart();
          const nextCh = this.codePointAtPos(next);
          return this.chStartsBindingPattern(nextCh) || this.chStartsBindingIdentifier(nextCh, next);
        }
        hasFollowingBindingIdentifier() {
          const next = this.nextTokenStart();
          const nextCh = this.codePointAtPos(next);
          return this.chStartsBindingIdentifier(nextCh, next);
        }
        startsUsingForOf() {
          const lookahead = this.lookahead();
          if (lookahead.type === 101 && !lookahead.containsEsc) {
            return false;
          } else {
            this.expectPlugin("explicitResourceManagement");
            return true;
          }
        }
        parseModuleItem() {
          return this.parseStatementLike(ParseStatementFlag.AllowImportExport | ParseStatementFlag.AllowDeclaration | ParseStatementFlag.AllowFunctionDeclaration | ParseStatementFlag.AllowLabeledFunction);
        }
        parseStatementListItem() {
          return this.parseStatementLike(ParseStatementFlag.AllowDeclaration | ParseStatementFlag.AllowFunctionDeclaration | ParseStatementFlag.AllowLabeledFunction);
        }
        parseStatementOrFunctionDeclaration(disallowLabeledFunction) {
          return this.parseStatementLike(ParseStatementFlag.AllowFunctionDeclaration | (disallowLabeledFunction ? 0 : ParseStatementFlag.AllowLabeledFunction));
        }
        parseStatement() {
          return this.parseStatementLike(ParseStatementFlag.StatementOnly);
        }
        parseStatementLike(flags) {
          let decorators = null;
          if (this.match(26)) {
            decorators = this.parseDecorators(true);
          }
          return this.parseStatementContent(flags, decorators);
        }
        parseStatementContent(flags, decorators) {
          const starttype = this.state.type;
          const node = this.startNode();
          const allowDeclaration = !!(flags & ParseStatementFlag.AllowDeclaration);
          const allowFunctionDeclaration = !!(flags & ParseStatementFlag.AllowFunctionDeclaration);
          const topLevel = flags & ParseStatementFlag.AllowImportExport;
          switch (starttype) {
            case 60:
              return this.parseBreakContinueStatement(node, true);
            case 63:
              return this.parseBreakContinueStatement(node, false);
            case 64:
              return this.parseDebuggerStatement(node);
            case 90:
              return this.parseDoWhileStatement(node);
            case 91:
              return this.parseForStatement(node);
            case 68:
              if (this.lookaheadCharCode() === 46)
                break;
              if (!allowDeclaration) {
                if (this.state.strict) {
                  this.raise(Errors.StrictFunction, {
                    at: this.state.startLoc
                  });
                } else if (!allowFunctionDeclaration) {
                  this.raise(Errors.SloppyFunction, {
                    at: this.state.startLoc
                  });
                }
              }
              return this.parseFunctionStatement(node, false, !allowDeclaration && allowFunctionDeclaration);
            case 80:
              if (!allowDeclaration)
                this.unexpected();
              return this.parseClass(this.maybeTakeDecorators(decorators, node), true);
            case 69:
              return this.parseIfStatement(node);
            case 70:
              return this.parseReturnStatement(node);
            case 71:
              return this.parseSwitchStatement(node);
            case 72:
              return this.parseThrowStatement(node);
            case 73:
              return this.parseTryStatement(node);
            case 105:
              if (this.hasFollowingLineBreak() || this.state.containsEsc || !this.hasFollowingBindingIdentifier()) {
                break;
              }
              this.expectPlugin("explicitResourceManagement");
              if (!this.scope.inModule && this.scope.inTopLevel) {
                this.raise(Errors.UnexpectedUsingDeclaration, {
                  at: this.state.startLoc
                });
              } else if (!allowDeclaration) {
                this.raise(Errors.UnexpectedLexicalDeclaration, {
                  at: this.state.startLoc
                });
              }
              return this.parseVarStatement(node, "using");
            case 99: {
              if (this.state.containsEsc) {
                break;
              }
              const next = this.nextTokenStart();
              const nextCh = this.codePointAtPos(next);
              if (nextCh !== 91) {
                if (!allowDeclaration && this.hasFollowingLineBreak())
                  break;
                if (!this.chStartsBindingIdentifier(nextCh, next) && nextCh !== 123) {
                  break;
                }
              }
            }
            case 75: {
              if (!allowDeclaration) {
                this.raise(Errors.UnexpectedLexicalDeclaration, {
                  at: this.state.startLoc
                });
              }
            }
            case 74: {
              const kind = this.state.value;
              return this.parseVarStatement(node, kind);
            }
            case 92:
              return this.parseWhileStatement(node);
            case 76:
              return this.parseWithStatement(node);
            case 5:
              return this.parseBlock();
            case 13:
              return this.parseEmptyStatement(node);
            case 83: {
              const nextTokenCharCode = this.lookaheadCharCode();
              if (nextTokenCharCode === 40 || nextTokenCharCode === 46) {
                break;
              }
            }
            case 82: {
              if (!this.options.allowImportExportEverywhere && !topLevel) {
                this.raise(Errors.UnexpectedImportExport, {
                  at: this.state.startLoc
                });
              }
              this.next();
              let result2;
              if (starttype === 83) {
                result2 = this.parseImport(node);
                if (result2.type === "ImportDeclaration" && (!result2.importKind || result2.importKind === "value")) {
                  this.sawUnambiguousESM = true;
                }
              } else {
                result2 = this.parseExport(node, decorators);
                if (result2.type === "ExportNamedDeclaration" && (!result2.exportKind || result2.exportKind === "value") || result2.type === "ExportAllDeclaration" && (!result2.exportKind || result2.exportKind === "value") || result2.type === "ExportDefaultDeclaration") {
                  this.sawUnambiguousESM = true;
                }
              }
              this.assertModuleNodeAllowed(result2);
              return result2;
            }
            default: {
              if (this.isAsyncFunction()) {
                if (!allowDeclaration) {
                  this.raise(Errors.AsyncFunctionInSingleStatementContext, {
                    at: this.state.startLoc
                  });
                }
                this.next();
                return this.parseFunctionStatement(node, true, !allowDeclaration && allowFunctionDeclaration);
              }
            }
          }
          const maybeName = this.state.value;
          const expr = this.parseExpression();
          if (tokenIsIdentifier(starttype) && expr.type === "Identifier" && this.eat(14)) {
            return this.parseLabeledStatement(
              node,
              maybeName,
              expr,
              flags
            );
          } else {
            return this.parseExpressionStatement(node, expr, decorators);
          }
        }
        assertModuleNodeAllowed(node) {
          if (!this.options.allowImportExportEverywhere && !this.inModule) {
            this.raise(Errors.ImportOutsideModule, {
              at: node
            });
          }
        }
        decoratorsEnabledBeforeExport() {
          if (this.hasPlugin("decorators-legacy"))
            return true;
          return this.hasPlugin("decorators") && !!this.getPluginOption("decorators", "decoratorsBeforeExport");
        }
        maybeTakeDecorators(maybeDecorators, classNode, exportNode) {
          if (maybeDecorators) {
            classNode.decorators = maybeDecorators;
            this.resetStartLocationFromNode(classNode, maybeDecorators[0]);
            if (exportNode)
              this.resetStartLocationFromNode(exportNode, classNode);
          }
          return classNode;
        }
        canHaveLeadingDecorator() {
          return this.match(80);
        }
        parseDecorators(allowExport) {
          const decorators = [];
          do {
            decorators.push(this.parseDecorator());
          } while (this.match(26));
          if (this.match(82)) {
            if (!allowExport) {
              this.unexpected();
            }
            if (!this.decoratorsEnabledBeforeExport()) {
              this.raise(Errors.DecoratorExportClass, {
                at: this.state.startLoc
              });
            }
          } else if (!this.canHaveLeadingDecorator()) {
            throw this.raise(Errors.UnexpectedLeadingDecorator, {
              at: this.state.startLoc
            });
          }
          return decorators;
        }
        parseDecorator() {
          this.expectOnePlugin(["decorators", "decorators-legacy"]);
          const node = this.startNode();
          this.next();
          if (this.hasPlugin("decorators")) {
            const startLoc = this.state.startLoc;
            let expr;
            if (this.match(10)) {
              const startLoc2 = this.state.startLoc;
              this.next();
              expr = this.parseExpression();
              this.expect(11);
              expr = this.wrapParenthesis(startLoc2, expr);
              const paramsStartLoc = this.state.startLoc;
              node.expression = this.parseMaybeDecoratorArguments(expr);
              if (this.getPluginOption("decorators", "allowCallParenthesized") === false && node.expression !== expr) {
                this.raise(Errors.DecoratorArgumentsOutsideParentheses, {
                  at: paramsStartLoc
                });
              }
            } else {
              expr = this.parseIdentifier(false);
              while (this.eat(16)) {
                const node2 = this.startNodeAt(startLoc);
                node2.object = expr;
                if (this.match(136)) {
                  this.classScope.usePrivateName(this.state.value, this.state.startLoc);
                  node2.property = this.parsePrivateName();
                } else {
                  node2.property = this.parseIdentifier(true);
                }
                node2.computed = false;
                expr = this.finishNode(node2, "MemberExpression");
              }
              node.expression = this.parseMaybeDecoratorArguments(expr);
            }
          } else {
            node.expression = this.parseExprSubscripts();
          }
          return this.finishNode(node, "Decorator");
        }
        parseMaybeDecoratorArguments(expr) {
          if (this.eat(10)) {
            const node = this.startNodeAtNode(expr);
            node.callee = expr;
            node.arguments = this.parseCallExpressionArguments(11, false);
            this.toReferencedList(node.arguments);
            return this.finishNode(node, "CallExpression");
          }
          return expr;
        }
        parseBreakContinueStatement(node, isBreak) {
          this.next();
          if (this.isLineTerminator()) {
            node.label = null;
          } else {
            node.label = this.parseIdentifier();
            this.semicolon();
          }
          this.verifyBreakContinue(node, isBreak);
          return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
        }
        verifyBreakContinue(node, isBreak) {
          let i;
          for (i = 0; i < this.state.labels.length; ++i) {
            const lab = this.state.labels[i];
            if (node.label == null || lab.name === node.label.name) {
              if (lab.kind != null && (isBreak || lab.kind === "loop"))
                break;
              if (node.label && isBreak)
                break;
            }
          }
          if (i === this.state.labels.length) {
            const type = isBreak ? "BreakStatement" : "ContinueStatement";
            this.raise(Errors.IllegalBreakContinue, {
              at: node,
              type
            });
          }
        }
        parseDebuggerStatement(node) {
          this.next();
          this.semicolon();
          return this.finishNode(node, "DebuggerStatement");
        }
        parseHeaderExpression() {
          this.expect(10);
          const val = this.parseExpression();
          this.expect(11);
          return val;
        }
        parseDoWhileStatement(node) {
          this.next();
          this.state.labels.push(loopLabel);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement());
          this.state.labels.pop();
          this.expect(92);
          node.test = this.parseHeaderExpression();
          this.eat(13);
          return this.finishNode(node, "DoWhileStatement");
        }
        parseForStatement(node) {
          this.next();
          this.state.labels.push(loopLabel);
          let awaitAt = null;
          if (this.isAwaitAllowed() && this.eatContextual(96)) {
            awaitAt = this.state.lastTokStartLoc;
          }
          this.scope.enter(SCOPE_OTHER);
          this.expect(10);
          if (this.match(13)) {
            if (awaitAt !== null) {
              this.unexpected(awaitAt);
            }
            return this.parseFor(node, null);
          }
          const startsWithLet = this.isContextual(99);
          const startsWithUsing = this.isContextual(105) && !this.hasFollowingLineBreak();
          const isLetOrUsing = startsWithLet && this.hasFollowingBindingAtom() || startsWithUsing && this.hasFollowingBindingIdentifier() && this.startsUsingForOf();
          if (this.match(74) || this.match(75) || isLetOrUsing) {
            const initNode = this.startNode();
            const kind = this.state.value;
            this.next();
            this.parseVar(initNode, true, kind);
            const init2 = this.finishNode(initNode, "VariableDeclaration");
            const isForIn = this.match(58);
            if (isForIn && startsWithUsing) {
              this.raise(Errors.ForInUsing, {
                at: init2
              });
            }
            if ((isForIn || this.isContextual(101)) && init2.declarations.length === 1) {
              return this.parseForIn(node, init2, awaitAt);
            }
            if (awaitAt !== null) {
              this.unexpected(awaitAt);
            }
            return this.parseFor(node, init2);
          }
          const startsWithAsync = this.isContextual(95);
          const refExpressionErrors = new ExpressionErrors();
          const init = this.parseExpression(true, refExpressionErrors);
          const isForOf = this.isContextual(101);
          if (isForOf) {
            if (startsWithLet) {
              this.raise(Errors.ForOfLet, {
                at: init
              });
            }
            if (awaitAt === null && startsWithAsync && init.type === "Identifier") {
              this.raise(Errors.ForOfAsync, {
                at: init
              });
            }
          }
          if (isForOf || this.match(58)) {
            this.checkDestructuringPrivate(refExpressionErrors);
            this.toAssignable(init, true);
            const type = isForOf ? "ForOfStatement" : "ForInStatement";
            this.checkLVal(init, {
              in: {
                type
              }
            });
            return this.parseForIn(
              node,
              init,
              awaitAt
            );
          } else {
            this.checkExpressionErrors(refExpressionErrors, true);
          }
          if (awaitAt !== null) {
            this.unexpected(awaitAt);
          }
          return this.parseFor(node, init);
        }
        parseFunctionStatement(node, isAsync, isHangingDeclaration) {
          this.next();
          return this.parseFunction(node, ParseFunctionFlag.Declaration | (isHangingDeclaration ? ParseFunctionFlag.HangingDeclaration : 0) | (isAsync ? ParseFunctionFlag.Async : 0));
        }
        parseIfStatement(node) {
          this.next();
          node.test = this.parseHeaderExpression();
          node.consequent = this.parseStatementOrFunctionDeclaration(
            true
          );
          node.alternate = this.eat(66) ? this.parseStatementOrFunctionDeclaration(true) : null;
          return this.finishNode(node, "IfStatement");
        }
        parseReturnStatement(node) {
          if (!this.prodParam.hasReturn && !this.options.allowReturnOutsideFunction) {
            this.raise(Errors.IllegalReturn, {
              at: this.state.startLoc
            });
          }
          this.next();
          if (this.isLineTerminator()) {
            node.argument = null;
          } else {
            node.argument = this.parseExpression();
            this.semicolon();
          }
          return this.finishNode(node, "ReturnStatement");
        }
        parseSwitchStatement(node) {
          this.next();
          node.discriminant = this.parseHeaderExpression();
          const cases = node.cases = [];
          this.expect(5);
          this.state.labels.push(switchLabel);
          this.scope.enter(SCOPE_OTHER);
          let cur;
          for (let sawDefault; !this.match(8); ) {
            if (this.match(61) || this.match(65)) {
              const isCase = this.match(61);
              if (cur)
                this.finishNode(cur, "SwitchCase");
              cases.push(cur = this.startNode());
              cur.consequent = [];
              this.next();
              if (isCase) {
                cur.test = this.parseExpression();
              } else {
                if (sawDefault) {
                  this.raise(Errors.MultipleDefaultsInSwitch, {
                    at: this.state.lastTokStartLoc
                  });
                }
                sawDefault = true;
                cur.test = null;
              }
              this.expect(14);
            } else {
              if (cur) {
                cur.consequent.push(this.parseStatementListItem());
              } else {
                this.unexpected();
              }
            }
          }
          this.scope.exit();
          if (cur)
            this.finishNode(cur, "SwitchCase");
          this.next();
          this.state.labels.pop();
          return this.finishNode(node, "SwitchStatement");
        }
        parseThrowStatement(node) {
          this.next();
          if (this.hasPrecedingLineBreak()) {
            this.raise(Errors.NewlineAfterThrow, {
              at: this.state.lastTokEndLoc
            });
          }
          node.argument = this.parseExpression();
          this.semicolon();
          return this.finishNode(node, "ThrowStatement");
        }
        parseCatchClauseParam() {
          const param = this.parseBindingAtom();
          const simple = param.type === "Identifier";
          this.scope.enter(simple ? SCOPE_SIMPLE_CATCH : 0);
          this.checkLVal(param, {
            in: {
              type: "CatchClause"
            },
            binding: BIND_LEXICAL,
            allowingSloppyLetBinding: true
          });
          return param;
        }
        parseTryStatement(node) {
          this.next();
          node.block = this.parseBlock();
          node.handler = null;
          if (this.match(62)) {
            const clause = this.startNode();
            this.next();
            if (this.match(10)) {
              this.expect(10);
              clause.param = this.parseCatchClauseParam();
              this.expect(11);
            } else {
              clause.param = null;
              this.scope.enter(SCOPE_OTHER);
            }
            clause.body = this.withSmartMixTopicForbiddingContext(() => this.parseBlock(false, false));
            this.scope.exit();
            node.handler = this.finishNode(clause, "CatchClause");
          }
          node.finalizer = this.eat(67) ? this.parseBlock() : null;
          if (!node.handler && !node.finalizer) {
            this.raise(Errors.NoCatchOrFinally, {
              at: node
            });
          }
          return this.finishNode(node, "TryStatement");
        }
        parseVarStatement(node, kind, allowMissingInitializer = false) {
          this.next();
          this.parseVar(node, false, kind, allowMissingInitializer);
          this.semicolon();
          return this.finishNode(node, "VariableDeclaration");
        }
        parseWhileStatement(node) {
          this.next();
          node.test = this.parseHeaderExpression();
          this.state.labels.push(loopLabel);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement());
          this.state.labels.pop();
          return this.finishNode(node, "WhileStatement");
        }
        parseWithStatement(node) {
          if (this.state.strict) {
            this.raise(Errors.StrictWith, {
              at: this.state.startLoc
            });
          }
          this.next();
          node.object = this.parseHeaderExpression();
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement());
          return this.finishNode(node, "WithStatement");
        }
        parseEmptyStatement(node) {
          this.next();
          return this.finishNode(node, "EmptyStatement");
        }
        parseLabeledStatement(node, maybeName, expr, flags) {
          for (const label of this.state.labels) {
            if (label.name === maybeName) {
              this.raise(Errors.LabelRedeclaration, {
                at: expr,
                labelName: maybeName
              });
            }
          }
          const kind = tokenIsLoop(this.state.type) ? "loop" : this.match(71) ? "switch" : null;
          for (let i = this.state.labels.length - 1; i >= 0; i--) {
            const label = this.state.labels[i];
            if (label.statementStart === node.start) {
              label.statementStart = this.state.start;
              label.kind = kind;
            } else {
              break;
            }
          }
          this.state.labels.push({
            name: maybeName,
            kind,
            statementStart: this.state.start
          });
          node.body = flags & ParseStatementFlag.AllowLabeledFunction ? this.parseStatementOrFunctionDeclaration(false) : this.parseStatement();
          this.state.labels.pop();
          node.label = expr;
          return this.finishNode(node, "LabeledStatement");
        }
        parseExpressionStatement(node, expr, decorators) {
          node.expression = expr;
          this.semicolon();
          return this.finishNode(node, "ExpressionStatement");
        }
        parseBlock(allowDirectives = false, createNewLexicalScope = true, afterBlockParse) {
          const node = this.startNode();
          if (allowDirectives) {
            this.state.strictErrors.clear();
          }
          this.expect(5);
          if (createNewLexicalScope) {
            this.scope.enter(SCOPE_OTHER);
          }
          this.parseBlockBody(node, allowDirectives, false, 8, afterBlockParse);
          if (createNewLexicalScope) {
            this.scope.exit();
          }
          return this.finishNode(node, "BlockStatement");
        }
        isValidDirective(stmt) {
          return stmt.type === "ExpressionStatement" && stmt.expression.type === "StringLiteral" && !stmt.expression.extra.parenthesized;
        }
        parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse) {
          const body = node.body = [];
          const directives = node.directives = [];
          this.parseBlockOrModuleBlockBody(body, allowDirectives ? directives : void 0, topLevel, end, afterBlockParse);
        }
        parseBlockOrModuleBlockBody(body, directives, topLevel, end, afterBlockParse) {
          const oldStrict = this.state.strict;
          let hasStrictModeDirective = false;
          let parsedNonDirective = false;
          while (!this.match(end)) {
            const stmt = topLevel ? this.parseModuleItem() : this.parseStatementListItem();
            if (directives && !parsedNonDirective) {
              if (this.isValidDirective(stmt)) {
                const directive = this.stmtToDirective(stmt);
                directives.push(directive);
                if (!hasStrictModeDirective && directive.value.value === "use strict") {
                  hasStrictModeDirective = true;
                  this.setStrict(true);
                }
                continue;
              }
              parsedNonDirective = true;
              this.state.strictErrors.clear();
            }
            body.push(stmt);
          }
          if (afterBlockParse) {
            afterBlockParse.call(this, hasStrictModeDirective);
          }
          if (!oldStrict) {
            this.setStrict(false);
          }
          this.next();
        }
        parseFor(node, init) {
          node.init = init;
          this.semicolon(false);
          node.test = this.match(13) ? null : this.parseExpression();
          this.semicolon(false);
          node.update = this.match(11) ? null : this.parseExpression();
          this.expect(11);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement());
          this.scope.exit();
          this.state.labels.pop();
          return this.finishNode(node, "ForStatement");
        }
        parseForIn(node, init, awaitAt) {
          const isForIn = this.match(58);
          this.next();
          if (isForIn) {
            if (awaitAt !== null)
              this.unexpected(awaitAt);
          } else {
            node.await = awaitAt !== null;
          }
          if (init.type === "VariableDeclaration" && init.declarations[0].init != null && (!isForIn || this.state.strict || init.kind !== "var" || init.declarations[0].id.type !== "Identifier")) {
            this.raise(Errors.ForInOfLoopInitializer, {
              at: init,
              type: isForIn ? "ForInStatement" : "ForOfStatement"
            });
          }
          if (init.type === "AssignmentPattern") {
            this.raise(Errors.InvalidLhs, {
              at: init,
              ancestor: {
                type: "ForStatement"
              }
            });
          }
          node.left = init;
          node.right = isForIn ? this.parseExpression() : this.parseMaybeAssignAllowIn();
          this.expect(11);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement());
          this.scope.exit();
          this.state.labels.pop();
          return this.finishNode(node, isForIn ? "ForInStatement" : "ForOfStatement");
        }
        parseVar(node, isFor, kind, allowMissingInitializer = false) {
          const declarations = node.declarations = [];
          node.kind = kind;
          for (; ; ) {
            const decl = this.startNode();
            this.parseVarId(decl, kind);
            decl.init = !this.eat(29) ? null : isFor ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn();
            if (decl.init === null && !allowMissingInitializer) {
              if (decl.id.type !== "Identifier" && !(isFor && (this.match(58) || this.isContextual(101)))) {
                this.raise(Errors.DeclarationMissingInitializer, {
                  at: this.state.lastTokEndLoc,
                  kind: "destructuring"
                });
              } else if (kind === "const" && !(this.match(58) || this.isContextual(101))) {
                this.raise(Errors.DeclarationMissingInitializer, {
                  at: this.state.lastTokEndLoc,
                  kind: "const"
                });
              }
            }
            declarations.push(this.finishNode(decl, "VariableDeclarator"));
            if (!this.eat(12))
              break;
          }
          return node;
        }
        parseVarId(decl, kind) {
          const id = this.parseBindingAtom();
          this.checkLVal(id, {
            in: {
              type: "VariableDeclarator"
            },
            binding: kind === "var" ? BIND_VAR : BIND_LEXICAL
          });
          decl.id = id;
        }
        parseAsyncFunctionExpression(node) {
          return this.parseFunction(node, ParseFunctionFlag.Async);
        }
        parseFunction(node, flags = ParseFunctionFlag.Expression) {
          const hangingDeclaration = flags & ParseFunctionFlag.HangingDeclaration;
          const isDeclaration = !!(flags & ParseFunctionFlag.Declaration);
          const requireId = isDeclaration && !(flags & ParseFunctionFlag.NullableId);
          const isAsync = !!(flags & ParseFunctionFlag.Async);
          this.initFunction(node, isAsync);
          if (this.match(55)) {
            if (hangingDeclaration) {
              this.raise(Errors.GeneratorInSingleStatementContext, {
                at: this.state.startLoc
              });
            }
            this.next();
            node.generator = true;
          }
          if (isDeclaration) {
            node.id = this.parseFunctionId(requireId);
          }
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          this.state.maybeInArrowParameters = false;
          this.scope.enter(SCOPE_FUNCTION);
          this.prodParam.enter(functionFlags(isAsync, node.generator));
          if (!isDeclaration) {
            node.id = this.parseFunctionId();
          }
          this.parseFunctionParams(node, false);
          this.withSmartMixTopicForbiddingContext(() => {
            this.parseFunctionBodyAndFinish(node, isDeclaration ? "FunctionDeclaration" : "FunctionExpression");
          });
          this.prodParam.exit();
          this.scope.exit();
          if (isDeclaration && !hangingDeclaration) {
            this.registerFunctionStatementId(node);
          }
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          return node;
        }
        parseFunctionId(requireId) {
          return requireId || tokenIsIdentifier(this.state.type) ? this.parseIdentifier() : null;
        }
        parseFunctionParams(node, allowModifiers) {
          this.expect(10);
          this.expressionScope.enter(newParameterDeclarationScope());
          node.params = this.parseBindingList(11, 41, false, allowModifiers);
          this.expressionScope.exit();
        }
        registerFunctionStatementId(node) {
          if (!node.id)
            return;
          this.scope.declareName(node.id.name, this.state.strict || node.generator || node.async ? this.scope.treatFunctionsAsVar ? BIND_VAR : BIND_LEXICAL : BIND_FUNCTION, node.id.loc.start);
        }
        parseClass(node, isStatement, optionalId) {
          this.next();
          const oldStrict = this.state.strict;
          this.state.strict = true;
          this.parseClassId(node, isStatement, optionalId);
          this.parseClassSuper(node);
          node.body = this.parseClassBody(!!node.superClass, oldStrict);
          return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression");
        }
        isClassProperty() {
          return this.match(29) || this.match(13) || this.match(8);
        }
        isClassMethod() {
          return this.match(10);
        }
        isNonstaticConstructor(method2) {
          return !method2.computed && !method2.static && (method2.key.name === "constructor" || method2.key.value === "constructor");
        }
        parseClassBody(hadSuperClass, oldStrict) {
          this.classScope.enter();
          const state = {
            hadConstructor: false,
            hadSuperClass
          };
          let decorators = [];
          const classBody = this.startNode();
          classBody.body = [];
          this.expect(5);
          this.withSmartMixTopicForbiddingContext(() => {
            while (!this.match(8)) {
              if (this.eat(13)) {
                if (decorators.length > 0) {
                  throw this.raise(Errors.DecoratorSemicolon, {
                    at: this.state.lastTokEndLoc
                  });
                }
                continue;
              }
              if (this.match(26)) {
                decorators.push(this.parseDecorator());
                continue;
              }
              const member = this.startNode();
              if (decorators.length) {
                member.decorators = decorators;
                this.resetStartLocationFromNode(member, decorators[0]);
                decorators = [];
              }
              this.parseClassMember(classBody, member, state);
              if (member.kind === "constructor" && member.decorators && member.decorators.length > 0) {
                this.raise(Errors.DecoratorConstructor, {
                  at: member
                });
              }
            }
          });
          this.state.strict = oldStrict;
          this.next();
          if (decorators.length) {
            throw this.raise(Errors.TrailingDecorator, {
              at: this.state.startLoc
            });
          }
          this.classScope.exit();
          return this.finishNode(classBody, "ClassBody");
        }
        parseClassMemberFromModifier(classBody, member) {
          const key = this.parseIdentifier(true);
          if (this.isClassMethod()) {
            const method2 = member;
            method2.kind = "method";
            method2.computed = false;
            method2.key = key;
            method2.static = false;
            this.pushClassMethod(classBody, method2, false, false, false, false);
            return true;
          } else if (this.isClassProperty()) {
            const prop = member;
            prop.computed = false;
            prop.key = key;
            prop.static = false;
            classBody.body.push(this.parseClassProperty(prop));
            return true;
          }
          this.resetPreviousNodeTrailingComments(key);
          return false;
        }
        parseClassMember(classBody, member, state) {
          const isStatic = this.isContextual(104);
          if (isStatic) {
            if (this.parseClassMemberFromModifier(classBody, member)) {
              return;
            }
            if (this.eat(5)) {
              this.parseClassStaticBlock(classBody, member);
              return;
            }
          }
          this.parseClassMemberWithIsStatic(classBody, member, state, isStatic);
        }
        parseClassMemberWithIsStatic(classBody, member, state, isStatic) {
          const publicMethod = member;
          const privateMethod = member;
          const publicProp = member;
          const privateProp = member;
          const accessorProp = member;
          const method2 = publicMethod;
          const publicMember = publicMethod;
          member.static = isStatic;
          this.parsePropertyNamePrefixOperator(member);
          if (this.eat(55)) {
            method2.kind = "method";
            const isPrivateName = this.match(136);
            this.parseClassElementName(method2);
            if (isPrivateName) {
              this.pushClassPrivateMethod(classBody, privateMethod, true, false);
              return;
            }
            if (this.isNonstaticConstructor(publicMethod)) {
              this.raise(Errors.ConstructorIsGenerator, {
                at: publicMethod.key
              });
            }
            this.pushClassMethod(classBody, publicMethod, true, false, false, false);
            return;
          }
          const isContextual = tokenIsIdentifier(this.state.type) && !this.state.containsEsc;
          const isPrivate = this.match(136);
          const key = this.parseClassElementName(member);
          const maybeQuestionTokenStartLoc = this.state.startLoc;
          this.parsePostMemberNameModifiers(publicMember);
          if (this.isClassMethod()) {
            method2.kind = "method";
            if (isPrivate) {
              this.pushClassPrivateMethod(classBody, privateMethod, false, false);
              return;
            }
            const isConstructor = this.isNonstaticConstructor(publicMethod);
            let allowsDirectSuper = false;
            if (isConstructor) {
              publicMethod.kind = "constructor";
              if (state.hadConstructor && !this.hasPlugin("typescript")) {
                this.raise(Errors.DuplicateConstructor, {
                  at: key
                });
              }
              if (isConstructor && this.hasPlugin("typescript") && member.override) {
                this.raise(Errors.OverrideOnConstructor, {
                  at: key
                });
              }
              state.hadConstructor = true;
              allowsDirectSuper = state.hadSuperClass;
            }
            this.pushClassMethod(classBody, publicMethod, false, false, isConstructor, allowsDirectSuper);
          } else if (this.isClassProperty()) {
            if (isPrivate) {
              this.pushClassPrivateProperty(classBody, privateProp);
            } else {
              this.pushClassProperty(classBody, publicProp);
            }
          } else if (isContextual && key.name === "async" && !this.isLineTerminator()) {
            this.resetPreviousNodeTrailingComments(key);
            const isGenerator = this.eat(55);
            if (publicMember.optional) {
              this.unexpected(maybeQuestionTokenStartLoc);
            }
            method2.kind = "method";
            const isPrivate2 = this.match(136);
            this.parseClassElementName(method2);
            this.parsePostMemberNameModifiers(publicMember);
            if (isPrivate2) {
              this.pushClassPrivateMethod(classBody, privateMethod, isGenerator, true);
            } else {
              if (this.isNonstaticConstructor(publicMethod)) {
                this.raise(Errors.ConstructorIsAsync, {
                  at: publicMethod.key
                });
              }
              this.pushClassMethod(classBody, publicMethod, isGenerator, true, false, false);
            }
          } else if (isContextual && (key.name === "get" || key.name === "set") && !(this.match(55) && this.isLineTerminator())) {
            this.resetPreviousNodeTrailingComments(key);
            method2.kind = key.name;
            const isPrivate2 = this.match(136);
            this.parseClassElementName(publicMethod);
            if (isPrivate2) {
              this.pushClassPrivateMethod(classBody, privateMethod, false, false);
            } else {
              if (this.isNonstaticConstructor(publicMethod)) {
                this.raise(Errors.ConstructorIsAccessor, {
                  at: publicMethod.key
                });
              }
              this.pushClassMethod(classBody, publicMethod, false, false, false, false);
            }
            this.checkGetterSetterParams(publicMethod);
          } else if (isContextual && key.name === "accessor" && !this.isLineTerminator()) {
            this.expectPlugin("decoratorAutoAccessors");
            this.resetPreviousNodeTrailingComments(key);
            const isPrivate2 = this.match(136);
            this.parseClassElementName(publicProp);
            this.pushClassAccessorProperty(classBody, accessorProp, isPrivate2);
          } else if (this.isLineTerminator()) {
            if (isPrivate) {
              this.pushClassPrivateProperty(classBody, privateProp);
            } else {
              this.pushClassProperty(classBody, publicProp);
            }
          } else {
            this.unexpected();
          }
        }
        parseClassElementName(member) {
          const {
            type,
            value
          } = this.state;
          if ((type === 130 || type === 131) && member.static && value === "prototype") {
            this.raise(Errors.StaticPrototype, {
              at: this.state.startLoc
            });
          }
          if (type === 136) {
            if (value === "constructor") {
              this.raise(Errors.ConstructorClassPrivateField, {
                at: this.state.startLoc
              });
            }
            const key = this.parsePrivateName();
            member.key = key;
            return key;
          }
          return this.parsePropertyName(member);
        }
        parseClassStaticBlock(classBody, member) {
          var _member$decorators;
          this.scope.enter(SCOPE_CLASS | SCOPE_STATIC_BLOCK | SCOPE_SUPER);
          const oldLabels = this.state.labels;
          this.state.labels = [];
          this.prodParam.enter(PARAM);
          const body = member.body = [];
          this.parseBlockOrModuleBlockBody(body, void 0, false, 8);
          this.prodParam.exit();
          this.scope.exit();
          this.state.labels = oldLabels;
          classBody.body.push(this.finishNode(member, "StaticBlock"));
          if ((_member$decorators = member.decorators) != null && _member$decorators.length) {
            this.raise(Errors.DecoratorStaticBlock, {
              at: member
            });
          }
        }
        pushClassProperty(classBody, prop) {
          if (!prop.computed && (prop.key.name === "constructor" || prop.key.value === "constructor")) {
            this.raise(Errors.ConstructorClassField, {
              at: prop.key
            });
          }
          classBody.body.push(this.parseClassProperty(prop));
        }
        pushClassPrivateProperty(classBody, prop) {
          const node = this.parseClassPrivateProperty(prop);
          classBody.body.push(node);
          this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), CLASS_ELEMENT_OTHER, node.key.loc.start);
        }
        pushClassAccessorProperty(classBody, prop, isPrivate) {
          if (!isPrivate && !prop.computed) {
            const key = prop.key;
            if (key.name === "constructor" || key.value === "constructor") {
              this.raise(Errors.ConstructorClassField, {
                at: key
              });
            }
          }
          const node = this.parseClassAccessorProperty(prop);
          classBody.body.push(node);
          if (isPrivate) {
            this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), CLASS_ELEMENT_OTHER, node.key.loc.start);
          }
        }
        pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
          classBody.body.push(this.parseMethod(method2, isGenerator, isAsync, isConstructor, allowsDirectSuper, "ClassMethod", true));
        }
        pushClassPrivateMethod(classBody, method2, isGenerator, isAsync) {
          const node = this.parseMethod(method2, isGenerator, isAsync, false, false, "ClassPrivateMethod", true);
          classBody.body.push(node);
          const kind = node.kind === "get" ? node.static ? CLASS_ELEMENT_STATIC_GETTER : CLASS_ELEMENT_INSTANCE_GETTER : node.kind === "set" ? node.static ? CLASS_ELEMENT_STATIC_SETTER : CLASS_ELEMENT_INSTANCE_SETTER : CLASS_ELEMENT_OTHER;
          this.declareClassPrivateMethodInScope(node, kind);
        }
        declareClassPrivateMethodInScope(node, kind) {
          this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), kind, node.key.loc.start);
        }
        parsePostMemberNameModifiers(methodOrProp) {
        }
        parseClassPrivateProperty(node) {
          this.parseInitializer(node);
          this.semicolon();
          return this.finishNode(node, "ClassPrivateProperty");
        }
        parseClassProperty(node) {
          this.parseInitializer(node);
          this.semicolon();
          return this.finishNode(node, "ClassProperty");
        }
        parseClassAccessorProperty(node) {
          this.parseInitializer(node);
          this.semicolon();
          return this.finishNode(node, "ClassAccessorProperty");
        }
        parseInitializer(node) {
          this.scope.enter(SCOPE_CLASS | SCOPE_SUPER);
          this.expressionScope.enter(newExpressionScope());
          this.prodParam.enter(PARAM);
          node.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null;
          this.expressionScope.exit();
          this.prodParam.exit();
          this.scope.exit();
        }
        parseClassId(node, isStatement, optionalId, bindingType = BIND_CLASS) {
          if (tokenIsIdentifier(this.state.type)) {
            node.id = this.parseIdentifier();
            if (isStatement) {
              this.declareNameFromIdentifier(node.id, bindingType);
            }
          } else {
            if (optionalId || !isStatement) {
              node.id = null;
            } else {
              throw this.raise(Errors.MissingClassName, {
                at: this.state.startLoc
              });
            }
          }
        }
        parseClassSuper(node) {
          node.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
        }
        parseExport(node, decorators) {
          const hasDefault = this.maybeParseExportDefaultSpecifier(
            node
          );
          const parseAfterDefault = !hasDefault || this.eat(12);
          const hasStar = parseAfterDefault && this.eatExportStar(
            node
          );
          const hasNamespace = hasStar && this.maybeParseExportNamespaceSpecifier(
            node
          );
          const parseAfterNamespace = parseAfterDefault && (!hasNamespace || this.eat(12));
          const isFromRequired = hasDefault || hasStar;
          if (hasStar && !hasNamespace) {
            if (hasDefault)
              this.unexpected();
            if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, {
                at: node
              });
            }
            this.parseExportFrom(node, true);
            return this.finishNode(node, "ExportAllDeclaration");
          }
          const hasSpecifiers = this.maybeParseExportNamedSpecifiers(
            node
          );
          if (hasDefault && parseAfterDefault && !hasStar && !hasSpecifiers || hasNamespace && parseAfterNamespace && !hasSpecifiers) {
            throw this.unexpected(null, 5);
          }
          let hasDeclaration;
          if (isFromRequired || hasSpecifiers) {
            hasDeclaration = false;
            if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, {
                at: node
              });
            }
            this.parseExportFrom(node, isFromRequired);
          } else {
            hasDeclaration = this.maybeParseExportDeclaration(node);
          }
          if (isFromRequired || hasSpecifiers || hasDeclaration) {
            var _node2$declaration;
            const node2 = node;
            this.checkExport(node2, true, false, !!node2.source);
            if (((_node2$declaration = node2.declaration) == null ? void 0 : _node2$declaration.type) === "ClassDeclaration") {
              this.maybeTakeDecorators(decorators, node2.declaration, node2);
            } else if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, {
                at: node
              });
            }
            return this.finishNode(node2, "ExportNamedDeclaration");
          }
          if (this.eat(65)) {
            const node2 = node;
            const decl = this.parseExportDefaultExpression();
            node2.declaration = decl;
            if (decl.type === "ClassDeclaration") {
              this.maybeTakeDecorators(decorators, decl, node2);
            } else if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, {
                at: node
              });
            }
            this.checkExport(node2, true, true);
            return this.finishNode(node2, "ExportDefaultDeclaration");
          }
          throw this.unexpected(null, 5);
        }
        eatExportStar(node) {
          return this.eat(55);
        }
        maybeParseExportDefaultSpecifier(node) {
          if (this.isExportDefaultSpecifier()) {
            this.expectPlugin("exportDefaultFrom");
            const specifier = this.startNode();
            specifier.exported = this.parseIdentifier(true);
            node.specifiers = [this.finishNode(specifier, "ExportDefaultSpecifier")];
            return true;
          }
          return false;
        }
        maybeParseExportNamespaceSpecifier(node) {
          if (this.isContextual(93)) {
            if (!node.specifiers)
              node.specifiers = [];
            const specifier = this.startNodeAt(this.state.lastTokStartLoc);
            this.next();
            specifier.exported = this.parseModuleExportName();
            node.specifiers.push(this.finishNode(specifier, "ExportNamespaceSpecifier"));
            return true;
          }
          return false;
        }
        maybeParseExportNamedSpecifiers(node) {
          if (this.match(5)) {
            if (!node.specifiers)
              node.specifiers = [];
            const isTypeExport = node.exportKind === "type";
            node.specifiers.push(...this.parseExportSpecifiers(isTypeExport));
            node.source = null;
            node.declaration = null;
            if (this.hasPlugin("importAssertions")) {
              node.assertions = [];
            }
            return true;
          }
          return false;
        }
        maybeParseExportDeclaration(node) {
          if (this.shouldParseExportDeclaration()) {
            node.specifiers = [];
            node.source = null;
            if (this.hasPlugin("importAssertions")) {
              node.assertions = [];
            }
            node.declaration = this.parseExportDeclaration(node);
            return true;
          }
          return false;
        }
        isAsyncFunction() {
          if (!this.isContextual(95))
            return false;
          const next = this.nextTokenStart();
          return !lineBreak.test(this.input.slice(this.state.pos, next)) && this.isUnparsedContextual(next, "function");
        }
        parseExportDefaultExpression() {
          const expr = this.startNode();
          if (this.match(68)) {
            this.next();
            return this.parseFunction(expr, ParseFunctionFlag.Declaration | ParseFunctionFlag.NullableId);
          } else if (this.isAsyncFunction()) {
            this.next();
            this.next();
            return this.parseFunction(expr, ParseFunctionFlag.Declaration | ParseFunctionFlag.NullableId | ParseFunctionFlag.Async);
          }
          if (this.match(80)) {
            return this.parseClass(expr, true, true);
          }
          if (this.match(26)) {
            if (this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport")) {
              this.raise(Errors.DecoratorBeforeExport, {
                at: this.state.startLoc
              });
            }
            return this.parseClass(this.maybeTakeDecorators(this.parseDecorators(false), this.startNode()), true, true);
          }
          if (this.match(75) || this.match(74) || this.isLet()) {
            throw this.raise(Errors.UnsupportedDefaultExport, {
              at: this.state.startLoc
            });
          }
          const res = this.parseMaybeAssignAllowIn();
          this.semicolon();
          return res;
        }
        parseExportDeclaration(node) {
          if (this.match(80)) {
            const node2 = this.parseClass(this.startNode(), true, false);
            return node2;
          }
          return this.parseStatementListItem();
        }
        isExportDefaultSpecifier() {
          const {
            type
          } = this.state;
          if (tokenIsIdentifier(type)) {
            if (type === 95 && !this.state.containsEsc || type === 99) {
              return false;
            }
            if ((type === 128 || type === 127) && !this.state.containsEsc) {
              const {
                type: nextType
              } = this.lookahead();
              if (tokenIsIdentifier(nextType) && nextType !== 97 || nextType === 5) {
                this.expectOnePlugin(["flow", "typescript"]);
                return false;
              }
            }
          } else if (!this.match(65)) {
            return false;
          }
          const next = this.nextTokenStart();
          const hasFrom = this.isUnparsedContextual(next, "from");
          if (this.input.charCodeAt(next) === 44 || tokenIsIdentifier(this.state.type) && hasFrom) {
            return true;
          }
          if (this.match(65) && hasFrom) {
            const nextAfterFrom = this.input.charCodeAt(this.nextTokenStartSince(next + 4));
            return nextAfterFrom === 34 || nextAfterFrom === 39;
          }
          return false;
        }
        parseExportFrom(node, expect) {
          if (this.eatContextual(97)) {
            node.source = this.parseImportSource();
            this.checkExport(node);
            const assertions = this.maybeParseImportAssertions();
            if (assertions) {
              node.assertions = assertions;
              this.checkJSONModuleImport(node);
            }
          } else if (expect) {
            this.unexpected();
          }
          this.semicolon();
        }
        shouldParseExportDeclaration() {
          const {
            type
          } = this.state;
          if (type === 26) {
            this.expectOnePlugin(["decorators", "decorators-legacy"]);
            if (this.hasPlugin("decorators")) {
              if (this.getPluginOption("decorators", "decoratorsBeforeExport")) {
                throw this.raise(Errors.DecoratorBeforeExport, {
                  at: this.state.startLoc
                });
              }
              return true;
            }
          }
          return type === 74 || type === 75 || type === 68 || type === 80 || this.isLet() || this.isAsyncFunction();
        }
        checkExport(node, checkNames, isDefault, isFrom) {
          if (checkNames) {
            if (isDefault) {
              this.checkDuplicateExports(node, "default");
              if (this.hasPlugin("exportDefaultFrom")) {
                var _declaration$extra;
                const declaration = node.declaration;
                if (declaration.type === "Identifier" && declaration.name === "from" && declaration.end - declaration.start === 4 && !((_declaration$extra = declaration.extra) != null && _declaration$extra.parenthesized)) {
                  this.raise(Errors.ExportDefaultFromAsIdentifier, {
                    at: declaration
                  });
                }
              }
            } else if (node.specifiers && node.specifiers.length) {
              for (const specifier of node.specifiers) {
                const {
                  exported
                } = specifier;
                const exportName = exported.type === "Identifier" ? exported.name : exported.value;
                this.checkDuplicateExports(specifier, exportName);
                if (!isFrom && specifier.local) {
                  const {
                    local
                  } = specifier;
                  if (local.type !== "Identifier") {
                    this.raise(Errors.ExportBindingIsString, {
                      at: specifier,
                      localName: local.value,
                      exportName
                    });
                  } else {
                    this.checkReservedWord(local.name, local.loc.start, true, false);
                    this.scope.checkLocalExport(local);
                  }
                }
              }
            } else if (node.declaration) {
              if (node.declaration.type === "FunctionDeclaration" || node.declaration.type === "ClassDeclaration") {
                const id = node.declaration.id;
                if (!id)
                  throw new Error("Assertion failure");
                this.checkDuplicateExports(node, id.name);
              } else if (node.declaration.type === "VariableDeclaration") {
                for (const declaration of node.declaration.declarations) {
                  this.checkDeclaration(declaration.id);
                }
              }
            }
          }
        }
        checkDeclaration(node) {
          if (node.type === "Identifier") {
            this.checkDuplicateExports(node, node.name);
          } else if (node.type === "ObjectPattern") {
            for (const prop of node.properties) {
              this.checkDeclaration(prop);
            }
          } else if (node.type === "ArrayPattern") {
            for (const elem of node.elements) {
              if (elem) {
                this.checkDeclaration(elem);
              }
            }
          } else if (node.type === "ObjectProperty") {
            this.checkDeclaration(node.value);
          } else if (node.type === "RestElement") {
            this.checkDeclaration(node.argument);
          } else if (node.type === "AssignmentPattern") {
            this.checkDeclaration(node.left);
          }
        }
        checkDuplicateExports(node, exportName) {
          if (this.exportedIdentifiers.has(exportName)) {
            if (exportName === "default") {
              this.raise(Errors.DuplicateDefaultExport, {
                at: node
              });
            } else {
              this.raise(Errors.DuplicateExport, {
                at: node,
                exportName
              });
            }
          }
          this.exportedIdentifiers.add(exportName);
        }
        parseExportSpecifiers(isInTypeExport) {
          const nodes = [];
          let first = true;
          this.expect(5);
          while (!this.eat(8)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.eat(8))
                break;
            }
            const isMaybeTypeOnly = this.isContextual(128);
            const isString2 = this.match(131);
            const node = this.startNode();
            node.local = this.parseModuleExportName();
            nodes.push(this.parseExportSpecifier(node, isString2, isInTypeExport, isMaybeTypeOnly));
          }
          return nodes;
        }
        parseExportSpecifier(node, isString2, isInTypeExport, isMaybeTypeOnly) {
          if (this.eatContextual(93)) {
            node.exported = this.parseModuleExportName();
          } else if (isString2) {
            node.exported = cloneStringLiteral(node.local);
          } else if (!node.exported) {
            node.exported = cloneIdentifier(node.local);
          }
          return this.finishNode(node, "ExportSpecifier");
        }
        parseModuleExportName() {
          if (this.match(131)) {
            const result2 = this.parseStringLiteral(this.state.value);
            const surrogate = result2.value.match(loneSurrogate);
            if (surrogate) {
              this.raise(Errors.ModuleExportNameHasLoneSurrogate, {
                at: result2,
                surrogateCharCode: surrogate[0].charCodeAt(0)
              });
            }
            return result2;
          }
          return this.parseIdentifier(true);
        }
        isJSONModuleImport(node) {
          if (node.assertions != null) {
            return node.assertions.some(({
              key,
              value
            }) => {
              return value.value === "json" && (key.type === "Identifier" ? key.name === "type" : key.value === "type");
            });
          }
          return false;
        }
        checkImportReflection(node) {
          if (node.module) {
            var _node$assertions;
            if (node.specifiers.length !== 1 || node.specifiers[0].type !== "ImportDefaultSpecifier") {
              this.raise(Errors.ImportReflectionNotBinding, {
                at: node.specifiers[0].loc.start
              });
            }
            if (((_node$assertions = node.assertions) == null ? void 0 : _node$assertions.length) > 0) {
              this.raise(Errors.ImportReflectionHasAssertion, {
                at: node.specifiers[0].loc.start
              });
            }
          }
        }
        checkJSONModuleImport(node) {
          if (this.isJSONModuleImport(node) && node.type !== "ExportAllDeclaration") {
            const {
              specifiers
            } = node;
            if (specifiers != null) {
              const nonDefaultNamedSpecifier = specifiers.find((specifier) => {
                let imported;
                if (specifier.type === "ExportSpecifier") {
                  imported = specifier.local;
                } else if (specifier.type === "ImportSpecifier") {
                  imported = specifier.imported;
                }
                if (imported !== void 0) {
                  return imported.type === "Identifier" ? imported.name !== "default" : imported.value !== "default";
                }
              });
              if (nonDefaultNamedSpecifier !== void 0) {
                this.raise(Errors.ImportJSONBindingNotDefault, {
                  at: nonDefaultNamedSpecifier.loc.start
                });
              }
            }
          }
        }
        parseMaybeImportReflection(node) {
          let isImportReflection = false;
          if (this.isContextual(125)) {
            const lookahead = this.lookahead();
            const nextType = lookahead.type;
            if (tokenIsIdentifier(nextType)) {
              if (nextType !== 97) {
                isImportReflection = true;
              } else {
                const nextNextTokenFirstChar = this.input.charCodeAt(this.nextTokenStartSince(lookahead.end));
                if (nextNextTokenFirstChar === 102) {
                  isImportReflection = true;
                }
              }
            } else if (nextType !== 12) {
              isImportReflection = true;
            }
          }
          if (isImportReflection) {
            this.expectPlugin("importReflection");
            this.next();
            node.module = true;
          } else if (this.hasPlugin("importReflection")) {
            node.module = false;
          }
        }
        parseImport(node) {
          node.specifiers = [];
          if (!this.match(131)) {
            this.parseMaybeImportReflection(node);
            const hasDefault = this.maybeParseDefaultImportSpecifier(node);
            const parseNext = !hasDefault || this.eat(12);
            const hasStar = parseNext && this.maybeParseStarImportSpecifier(node);
            if (parseNext && !hasStar)
              this.parseNamedImportSpecifiers(node);
            this.expectContextual(97);
          }
          node.source = this.parseImportSource();
          const assertions = this.maybeParseImportAssertions();
          if (assertions) {
            node.assertions = assertions;
          } else {
            const attributes = this.maybeParseModuleAttributes();
            if (attributes) {
              node.attributes = attributes;
            }
          }
          this.checkImportReflection(node);
          this.checkJSONModuleImport(node);
          this.semicolon();
          return this.finishNode(node, "ImportDeclaration");
        }
        parseImportSource() {
          if (!this.match(131))
            this.unexpected();
          return this.parseExprAtom();
        }
        shouldParseDefaultImport(node) {
          return tokenIsIdentifier(this.state.type);
        }
        parseImportSpecifierLocal(node, specifier, type) {
          specifier.local = this.parseIdentifier();
          node.specifiers.push(this.finishImportSpecifier(specifier, type));
        }
        finishImportSpecifier(specifier, type, bindingType = BIND_LEXICAL) {
          this.checkLVal(specifier.local, {
            in: specifier,
            binding: bindingType
          });
          return this.finishNode(specifier, type);
        }
        parseAssertEntries() {
          const attrs = [];
          const attrNames = /* @__PURE__ */ new Set();
          do {
            if (this.match(8)) {
              break;
            }
            const node = this.startNode();
            const keyName = this.state.value;
            if (attrNames.has(keyName)) {
              this.raise(Errors.ModuleAttributesWithDuplicateKeys, {
                at: this.state.startLoc,
                key: keyName
              });
            }
            attrNames.add(keyName);
            if (this.match(131)) {
              node.key = this.parseStringLiteral(keyName);
            } else {
              node.key = this.parseIdentifier(true);
            }
            this.expect(14);
            if (!this.match(131)) {
              throw this.raise(Errors.ModuleAttributeInvalidValue, {
                at: this.state.startLoc
              });
            }
            node.value = this.parseStringLiteral(this.state.value);
            attrs.push(this.finishNode(node, "ImportAttribute"));
          } while (this.eat(12));
          return attrs;
        }
        maybeParseModuleAttributes() {
          if (this.match(76) && !this.hasPrecedingLineBreak()) {
            this.expectPlugin("moduleAttributes");
            this.next();
          } else {
            if (this.hasPlugin("moduleAttributes"))
              return [];
            return null;
          }
          const attrs = [];
          const attributes = /* @__PURE__ */ new Set();
          do {
            const node = this.startNode();
            node.key = this.parseIdentifier(true);
            if (node.key.name !== "type") {
              this.raise(Errors.ModuleAttributeDifferentFromType, {
                at: node.key
              });
            }
            if (attributes.has(node.key.name)) {
              this.raise(Errors.ModuleAttributesWithDuplicateKeys, {
                at: node.key,
                key: node.key.name
              });
            }
            attributes.add(node.key.name);
            this.expect(14);
            if (!this.match(131)) {
              throw this.raise(Errors.ModuleAttributeInvalidValue, {
                at: this.state.startLoc
              });
            }
            node.value = this.parseStringLiteral(this.state.value);
            this.finishNode(node, "ImportAttribute");
            attrs.push(node);
          } while (this.eat(12));
          return attrs;
        }
        maybeParseImportAssertions() {
          if (this.isContextual(94) && !this.hasPrecedingLineBreak()) {
            this.expectPlugin("importAssertions");
            this.next();
          } else {
            if (this.hasPlugin("importAssertions"))
              return [];
            return null;
          }
          this.eat(5);
          const attrs = this.parseAssertEntries();
          this.eat(8);
          return attrs;
        }
        maybeParseDefaultImportSpecifier(node) {
          if (this.shouldParseDefaultImport(node)) {
            this.parseImportSpecifierLocal(node, this.startNode(), "ImportDefaultSpecifier");
            return true;
          }
          return false;
        }
        maybeParseStarImportSpecifier(node) {
          if (this.match(55)) {
            const specifier = this.startNode();
            this.next();
            this.expectContextual(93);
            this.parseImportSpecifierLocal(node, specifier, "ImportNamespaceSpecifier");
            return true;
          }
          return false;
        }
        parseNamedImportSpecifiers(node) {
          let first = true;
          this.expect(5);
          while (!this.eat(8)) {
            if (first) {
              first = false;
            } else {
              if (this.eat(14)) {
                throw this.raise(Errors.DestructureNamedImport, {
                  at: this.state.startLoc
                });
              }
              this.expect(12);
              if (this.eat(8))
                break;
            }
            const specifier = this.startNode();
            const importedIsString = this.match(131);
            const isMaybeTypeOnly = this.isContextual(128);
            specifier.imported = this.parseModuleExportName();
            const importSpecifier = this.parseImportSpecifier(specifier, importedIsString, node.importKind === "type" || node.importKind === "typeof", isMaybeTypeOnly, void 0);
            node.specifiers.push(importSpecifier);
          }
        }
        parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
          if (this.eatContextual(93)) {
            specifier.local = this.parseIdentifier();
          } else {
            const {
              imported
            } = specifier;
            if (importedIsString) {
              throw this.raise(Errors.ImportBindingIsString, {
                at: specifier,
                importName: imported.value
              });
            }
            this.checkReservedWord(imported.name, specifier.loc.start, true, true);
            if (!specifier.local) {
              specifier.local = cloneIdentifier(imported);
            }
          }
          return this.finishImportSpecifier(specifier, "ImportSpecifier", bindingType);
        }
        isThisParam(param) {
          return param.type === "Identifier" && param.name === "this";
        }
      };
      var Parser = class extends StatementParser {
        constructor(options, input) {
          options = getOptions(options);
          super(options, input);
          this.options = options;
          this.initializeScopes();
          this.plugins = pluginsMap(this.options.plugins);
          this.filename = options.sourceFilename;
        }
        getScopeHandler() {
          return ScopeHandler;
        }
        parse() {
          this.enterInitialScopes();
          const file2 = this.startNode();
          const program3 = this.startNode();
          this.nextToken();
          file2.errors = null;
          this.parseTopLevel(file2, program3);
          file2.errors = this.state.errors;
          return file2;
        }
      };
      function pluginsMap(plugins3) {
        const pluginMap = /* @__PURE__ */ new Map();
        for (const plugin of plugins3) {
          const [name, options] = Array.isArray(plugin) ? plugin : [plugin, {}];
          if (!pluginMap.has(name))
            pluginMap.set(name, options || {});
        }
        return pluginMap;
      }
      function parse3(input, options) {
        var _options;
        if (((_options = options) == null ? void 0 : _options.sourceType) === "unambiguous") {
          options = Object.assign({}, options);
          try {
            options.sourceType = "module";
            const parser3 = getParser(options, input);
            const ast = parser3.parse();
            if (parser3.sawUnambiguousESM) {
              return ast;
            }
            if (parser3.ambiguousScriptDifferentAst) {
              try {
                options.sourceType = "script";
                return getParser(options, input).parse();
              } catch (_unused) {
              }
            } else {
              ast.program.sourceType = "script";
            }
            return ast;
          } catch (moduleError) {
            try {
              options.sourceType = "script";
              return getParser(options, input).parse();
            } catch (_unused2) {
            }
            throw moduleError;
          }
        } else {
          return getParser(options, input).parse();
        }
      }
      function parseExpression3(input, options) {
        const parser3 = getParser(options, input);
        if (parser3.options.strictMode) {
          parser3.state.strict = true;
        }
        return parser3.getExpression();
      }
      function generateExportedTokenTypes(internalTokenTypes) {
        const tokenTypes2 = {};
        for (const typeName of Object.keys(internalTokenTypes)) {
          tokenTypes2[typeName] = getExportedToken(internalTokenTypes[typeName]);
        }
        return tokenTypes2;
      }
      var tokTypes = generateExportedTokenTypes(tt);
      function getParser(options, input) {
        let cls = Parser;
        if (options != null && options.plugins) {
          validatePlugins(options.plugins);
          cls = getParserClass(options.plugins);
        }
        return new cls(options, input);
      }
      var parserClassCache = {};
      function getParserClass(pluginsFromOptions) {
        const pluginList = mixinPluginNames.filter((name) => hasPlugin(pluginsFromOptions, name));
        const key = pluginList.join("/");
        let cls = parserClassCache[key];
        if (!cls) {
          cls = Parser;
          for (const plugin of pluginList) {
            cls = mixinPlugins[plugin](cls);
          }
          parserClassCache[key] = cls;
        }
        return cls;
      }
      exports2.parse = parse3;
      exports2.parseExpression = parseExpression3;
      exports2.tokTypes = tokTypes;
    }
  });

  // node_modules/@jridgewell/set-array/dist/set-array.umd.js
  var require_set_array_umd = __commonJS({
    "node_modules/@jridgewell/set-array/dist/set-array.umd.js"(exports2, module2) {
      init_define_process();
      (function(global2, factory2) {
        typeof exports2 === "object" && typeof module2 !== "undefined" ? factory2(exports2) : typeof define === "function" && define.amd ? define(["exports"], factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory2(global2.setArray = {}));
      })(exports2, function(exports3) {
        "use strict";
        exports3.get = void 0;
        exports3.put = void 0;
        exports3.pop = void 0;
        class SetArray {
          constructor() {
            this._indexes = { __proto__: null };
            this.array = [];
          }
        }
        (() => {
          exports3.get = (strarr, key) => strarr._indexes[key];
          exports3.put = (strarr, key) => {
            const index = exports3.get(strarr, key);
            if (index !== void 0)
              return index;
            const { array, _indexes: indexes } = strarr;
            return indexes[key] = array.push(key) - 1;
          };
          exports3.pop = (strarr) => {
            const { array, _indexes: indexes } = strarr;
            if (array.length === 0)
              return;
            const last2 = array.pop();
            indexes[last2] = void 0;
          };
        })();
        exports3.SetArray = SetArray;
        Object.defineProperty(exports3, "__esModule", { value: true });
      });
    }
  });

  // node_modules/@jridgewell/sourcemap-codec/dist/sourcemap-codec.umd.js
  var require_sourcemap_codec_umd = __commonJS({
    "node_modules/@jridgewell/sourcemap-codec/dist/sourcemap-codec.umd.js"(exports2, module2) {
      init_define_process();
      (function(global2, factory2) {
        typeof exports2 === "object" && typeof module2 !== "undefined" ? factory2(exports2) : typeof define === "function" && define.amd ? define(["exports"], factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory2(global2.sourcemapCodec = {}));
      })(exports2, function(exports3) {
        "use strict";
        const comma = ",".charCodeAt(0);
        const semicolon = ";".charCodeAt(0);
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        const intToChar = new Uint8Array(64);
        const charToInt = new Uint8Array(128);
        for (let i = 0; i < chars.length; i++) {
          const c = chars.charCodeAt(i);
          intToChar[i] = c;
          charToInt[c] = i;
        }
        const td = typeof TextDecoder !== "undefined" ? /* @__PURE__ */ new TextDecoder() : typeof Buffer !== "undefined" ? {
          decode(buf) {
            const out = Buffer.from(buf.buffer, buf.byteOffset, buf.byteLength);
            return out.toString();
          }
        } : {
          decode(buf) {
            let out = "";
            for (let i = 0; i < buf.length; i++) {
              out += String.fromCharCode(buf[i]);
            }
            return out;
          }
        };
        function decode(mappings) {
          const state = new Int32Array(5);
          const decoded = [];
          let index = 0;
          do {
            const semi = indexOf2(mappings, index);
            const line = [];
            let sorted = true;
            let lastCol = 0;
            state[0] = 0;
            for (let i = index; i < semi; i++) {
              let seg;
              i = decodeInteger(mappings, i, state, 0);
              const col = state[0];
              if (col < lastCol)
                sorted = false;
              lastCol = col;
              if (hasMoreVlq(mappings, i, semi)) {
                i = decodeInteger(mappings, i, state, 1);
                i = decodeInteger(mappings, i, state, 2);
                i = decodeInteger(mappings, i, state, 3);
                if (hasMoreVlq(mappings, i, semi)) {
                  i = decodeInteger(mappings, i, state, 4);
                  seg = [col, state[1], state[2], state[3], state[4]];
                } else {
                  seg = [col, state[1], state[2], state[3]];
                }
              } else {
                seg = [col];
              }
              line.push(seg);
            }
            if (!sorted)
              sort(line);
            decoded.push(line);
            index = semi + 1;
          } while (index <= mappings.length);
          return decoded;
        }
        function indexOf2(mappings, index) {
          const idx = mappings.indexOf(";", index);
          return idx === -1 ? mappings.length : idx;
        }
        function decodeInteger(mappings, pos, state, j) {
          let value = 0;
          let shift = 0;
          let integer = 0;
          do {
            const c = mappings.charCodeAt(pos++);
            integer = charToInt[c];
            value |= (integer & 31) << shift;
            shift += 5;
          } while (integer & 32);
          const shouldNegate = value & 1;
          value >>>= 1;
          if (shouldNegate) {
            value = -2147483648 | -value;
          }
          state[j] += value;
          return pos;
        }
        function hasMoreVlq(mappings, i, length) {
          if (i >= length)
            return false;
          return mappings.charCodeAt(i) !== comma;
        }
        function sort(line) {
          line.sort(sortComparator);
        }
        function sortComparator(a, b) {
          return a[0] - b[0];
        }
        function encode(decoded) {
          const state = new Int32Array(5);
          const bufLength = 1024 * 16;
          const subLength = bufLength - 36;
          const buf = new Uint8Array(bufLength);
          const sub = buf.subarray(0, subLength);
          let pos = 0;
          let out = "";
          for (let i = 0; i < decoded.length; i++) {
            const line = decoded[i];
            if (i > 0) {
              if (pos === bufLength) {
                out += td.decode(buf);
                pos = 0;
              }
              buf[pos++] = semicolon;
            }
            if (line.length === 0)
              continue;
            state[0] = 0;
            for (let j = 0; j < line.length; j++) {
              const segment = line[j];
              if (pos > subLength) {
                out += td.decode(sub);
                buf.copyWithin(0, subLength, pos);
                pos -= subLength;
              }
              if (j > 0)
                buf[pos++] = comma;
              pos = encodeInteger(buf, pos, state, segment, 0);
              if (segment.length === 1)
                continue;
              pos = encodeInteger(buf, pos, state, segment, 1);
              pos = encodeInteger(buf, pos, state, segment, 2);
              pos = encodeInteger(buf, pos, state, segment, 3);
              if (segment.length === 4)
                continue;
              pos = encodeInteger(buf, pos, state, segment, 4);
            }
          }
          return out + td.decode(buf.subarray(0, pos));
        }
        function encodeInteger(buf, pos, state, segment, j) {
          const next = segment[j];
          let num = next - state[j];
          state[j] = next;
          num = num < 0 ? -num << 1 | 1 : num << 1;
          do {
            let clamped = num & 31;
            num >>>= 5;
            if (num > 0)
              clamped |= 32;
            buf[pos++] = intToChar[clamped];
          } while (num > 0);
          return pos;
        }
        exports3.decode = decode;
        exports3.encode = encode;
        Object.defineProperty(exports3, "__esModule", { value: true });
      });
    }
  });

  // node_modules/@jridgewell/resolve-uri/dist/resolve-uri.umd.js
  var require_resolve_uri_umd = __commonJS({
    "node_modules/@jridgewell/resolve-uri/dist/resolve-uri.umd.js"(exports2, module2) {
      init_define_process();
      (function(global2, factory2) {
        typeof exports2 === "object" && typeof module2 !== "undefined" ? module2.exports = factory2() : typeof define === "function" && define.amd ? define(factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, global2.resolveURI = factory2());
      })(exports2, function() {
        "use strict";
        const schemeRegex = /^[\w+.-]+:\/\//;
        const urlRegex = /^([\w+.-]+:)\/\/([^@/#?]*@)?([^:/#?]*)(:\d+)?(\/[^#?]*)?(\?[^#]*)?(#.*)?/;
        const fileRegex = /^file:(?:\/\/((?![a-z]:)[^/#?]*)?)?(\/?[^#?]*)(\?[^#]*)?(#.*)?/i;
        var UrlType;
        (function(UrlType2) {
          UrlType2[UrlType2["Empty"] = 1] = "Empty";
          UrlType2[UrlType2["Hash"] = 2] = "Hash";
          UrlType2[UrlType2["Query"] = 3] = "Query";
          UrlType2[UrlType2["RelativePath"] = 4] = "RelativePath";
          UrlType2[UrlType2["AbsolutePath"] = 5] = "AbsolutePath";
          UrlType2[UrlType2["SchemeRelative"] = 6] = "SchemeRelative";
          UrlType2[UrlType2["Absolute"] = 7] = "Absolute";
        })(UrlType || (UrlType = {}));
        function isAbsoluteUrl(input) {
          return schemeRegex.test(input);
        }
        function isSchemeRelativeUrl(input) {
          return input.startsWith("//");
        }
        function isAbsolutePath(input) {
          return input.startsWith("/");
        }
        function isFileUrl(input) {
          return input.startsWith("file:");
        }
        function isRelative(input) {
          return /^[.?#]/.test(input);
        }
        function parseAbsoluteUrl(input) {
          const match = urlRegex.exec(input);
          return makeUrl(match[1], match[2] || "", match[3], match[4] || "", match[5] || "/", match[6] || "", match[7] || "");
        }
        function parseFileUrl(input) {
          const match = fileRegex.exec(input);
          const path = match[2];
          return makeUrl("file:", "", match[1] || "", "", isAbsolutePath(path) ? path : "/" + path, match[3] || "", match[4] || "");
        }
        function makeUrl(scheme, user, host, port, path, query, hash) {
          return {
            scheme,
            user,
            host,
            port,
            path,
            query,
            hash,
            type: UrlType.Absolute
          };
        }
        function parseUrl(input) {
          if (isSchemeRelativeUrl(input)) {
            const url2 = parseAbsoluteUrl("http:" + input);
            url2.scheme = "";
            url2.type = UrlType.SchemeRelative;
            return url2;
          }
          if (isAbsolutePath(input)) {
            const url2 = parseAbsoluteUrl("http://foo.com" + input);
            url2.scheme = "";
            url2.host = "";
            url2.type = UrlType.AbsolutePath;
            return url2;
          }
          if (isFileUrl(input))
            return parseFileUrl(input);
          if (isAbsoluteUrl(input))
            return parseAbsoluteUrl(input);
          const url = parseAbsoluteUrl("http://foo.com/" + input);
          url.scheme = "";
          url.host = "";
          url.type = input ? input.startsWith("?") ? UrlType.Query : input.startsWith("#") ? UrlType.Hash : UrlType.RelativePath : UrlType.Empty;
          return url;
        }
        function stripPathFilename(path) {
          if (path.endsWith("/.."))
            return path;
          const index = path.lastIndexOf("/");
          return path.slice(0, index + 1);
        }
        function mergePaths(url, base) {
          normalizePath(base, base.type);
          if (url.path === "/") {
            url.path = base.path;
          } else {
            url.path = stripPathFilename(base.path) + url.path;
          }
        }
        function normalizePath(url, type) {
          const rel = type <= UrlType.RelativePath;
          const pieces = url.path.split("/");
          let pointer = 1;
          let positive = 0;
          let addTrailingSlash = false;
          for (let i = 1; i < pieces.length; i++) {
            const piece = pieces[i];
            if (!piece) {
              addTrailingSlash = true;
              continue;
            }
            addTrailingSlash = false;
            if (piece === ".")
              continue;
            if (piece === "..") {
              if (positive) {
                addTrailingSlash = true;
                positive--;
                pointer--;
              } else if (rel) {
                pieces[pointer++] = piece;
              }
              continue;
            }
            pieces[pointer++] = piece;
            positive++;
          }
          let path = "";
          for (let i = 1; i < pointer; i++) {
            path += "/" + pieces[i];
          }
          if (!path || addTrailingSlash && !path.endsWith("/..")) {
            path += "/";
          }
          url.path = path;
        }
        function resolve(input, base) {
          if (!input && !base)
            return "";
          const url = parseUrl(input);
          let inputType = url.type;
          if (base && inputType !== UrlType.Absolute) {
            const baseUrl = parseUrl(base);
            const baseType = baseUrl.type;
            switch (inputType) {
              case UrlType.Empty:
                url.hash = baseUrl.hash;
              case UrlType.Hash:
                url.query = baseUrl.query;
              case UrlType.Query:
              case UrlType.RelativePath:
                mergePaths(url, baseUrl);
              case UrlType.AbsolutePath:
                url.user = baseUrl.user;
                url.host = baseUrl.host;
                url.port = baseUrl.port;
              case UrlType.SchemeRelative:
                url.scheme = baseUrl.scheme;
            }
            if (baseType > inputType)
              inputType = baseType;
          }
          normalizePath(url, inputType);
          const queryHash = url.query + url.hash;
          switch (inputType) {
            case UrlType.Hash:
            case UrlType.Query:
              return queryHash;
            case UrlType.RelativePath: {
              const path = url.path.slice(1);
              if (!path)
                return queryHash || ".";
              if (isRelative(base || input) && !isRelative(path)) {
                return "./" + path + queryHash;
              }
              return path + queryHash;
            }
            case UrlType.AbsolutePath:
              return url.path + queryHash;
            default:
              return url.scheme + "//" + url.user + url.host + url.port + url.path + queryHash;
          }
        }
        return resolve;
      });
    }
  });

  // node_modules/@jridgewell/trace-mapping/dist/trace-mapping.umd.js
  var require_trace_mapping_umd = __commonJS({
    "node_modules/@jridgewell/trace-mapping/dist/trace-mapping.umd.js"(exports2, module2) {
      init_define_process();
      (function(global2, factory2) {
        typeof exports2 === "object" && typeof module2 !== "undefined" ? factory2(exports2, require_sourcemap_codec_umd(), require_resolve_uri_umd()) : typeof define === "function" && define.amd ? define(["exports", "@jridgewell/sourcemap-codec", "@jridgewell/resolve-uri"], factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory2(global2.traceMapping = {}, global2.sourcemapCodec, global2.resolveURI));
      })(exports2, function(exports3, sourcemapCodec, resolveUri) {
        "use strict";
        function _interopDefaultLegacy(e) {
          return e && typeof e === "object" && "default" in e ? e : { "default": e };
        }
        var resolveUri__default = /* @__PURE__ */ _interopDefaultLegacy(resolveUri);
        function resolve(input, base) {
          if (base && !base.endsWith("/"))
            base += "/";
          return resolveUri__default["default"](input, base);
        }
        function stripFilename(path) {
          if (!path)
            return "";
          const index = path.lastIndexOf("/");
          return path.slice(0, index + 1);
        }
        const COLUMN = 0;
        const SOURCES_INDEX = 1;
        const SOURCE_LINE = 2;
        const SOURCE_COLUMN = 3;
        const NAMES_INDEX = 4;
        const REV_GENERATED_LINE = 1;
        const REV_GENERATED_COLUMN = 2;
        function maybeSort(mappings, owned) {
          const unsortedIndex = nextUnsortedSegmentLine(mappings, 0);
          if (unsortedIndex === mappings.length)
            return mappings;
          if (!owned)
            mappings = mappings.slice();
          for (let i = unsortedIndex; i < mappings.length; i = nextUnsortedSegmentLine(mappings, i + 1)) {
            mappings[i] = sortSegments(mappings[i], owned);
          }
          return mappings;
        }
        function nextUnsortedSegmentLine(mappings, start) {
          for (let i = start; i < mappings.length; i++) {
            if (!isSorted(mappings[i]))
              return i;
          }
          return mappings.length;
        }
        function isSorted(line) {
          for (let j = 1; j < line.length; j++) {
            if (line[j][COLUMN] < line[j - 1][COLUMN]) {
              return false;
            }
          }
          return true;
        }
        function sortSegments(line, owned) {
          if (!owned)
            line = line.slice();
          return line.sort(sortComparator);
        }
        function sortComparator(a, b) {
          return a[COLUMN] - b[COLUMN];
        }
        let found = false;
        function binarySearch(haystack, needle, low, high) {
          while (low <= high) {
            const mid = low + (high - low >> 1);
            const cmp = haystack[mid][COLUMN] - needle;
            if (cmp === 0) {
              found = true;
              return mid;
            }
            if (cmp < 0) {
              low = mid + 1;
            } else {
              high = mid - 1;
            }
          }
          found = false;
          return low - 1;
        }
        function upperBound(haystack, needle, index) {
          for (let i = index + 1; i < haystack.length; index = i++) {
            if (haystack[i][COLUMN] !== needle)
              break;
          }
          return index;
        }
        function lowerBound(haystack, needle, index) {
          for (let i = index - 1; i >= 0; index = i--) {
            if (haystack[i][COLUMN] !== needle)
              break;
          }
          return index;
        }
        function memoizedState() {
          return {
            lastKey: -1,
            lastNeedle: -1,
            lastIndex: -1
          };
        }
        function memoizedBinarySearch(haystack, needle, state, key) {
          const { lastKey, lastNeedle, lastIndex } = state;
          let low = 0;
          let high = haystack.length - 1;
          if (key === lastKey) {
            if (needle === lastNeedle) {
              found = lastIndex !== -1 && haystack[lastIndex][COLUMN] === needle;
              return lastIndex;
            }
            if (needle >= lastNeedle) {
              low = lastIndex === -1 ? 0 : lastIndex;
            } else {
              high = lastIndex;
            }
          }
          state.lastKey = key;
          state.lastNeedle = needle;
          return state.lastIndex = binarySearch(haystack, needle, low, high);
        }
        function buildBySources(decoded, memos) {
          const sources = memos.map(buildNullArray);
          for (let i = 0; i < decoded.length; i++) {
            const line = decoded[i];
            for (let j = 0; j < line.length; j++) {
              const seg = line[j];
              if (seg.length === 1)
                continue;
              const sourceIndex = seg[SOURCES_INDEX];
              const sourceLine = seg[SOURCE_LINE];
              const sourceColumn = seg[SOURCE_COLUMN];
              const originalSource = sources[sourceIndex];
              const originalLine = originalSource[sourceLine] || (originalSource[sourceLine] = []);
              const memo = memos[sourceIndex];
              const index = upperBound(originalLine, sourceColumn, memoizedBinarySearch(originalLine, sourceColumn, memo, sourceLine));
              insert(originalLine, memo.lastIndex = index + 1, [sourceColumn, i, seg[COLUMN]]);
            }
          }
          return sources;
        }
        function insert(array, index, value) {
          for (let i = array.length; i > index; i--) {
            array[i] = array[i - 1];
          }
          array[index] = value;
        }
        function buildNullArray() {
          return { __proto__: null };
        }
        const AnyMap = function(map2, mapUrl) {
          const parsed = typeof map2 === "string" ? JSON.parse(map2) : map2;
          if (!("sections" in parsed))
            return new TraceMap(parsed, mapUrl);
          const mappings = [];
          const sources = [];
          const sourcesContent = [];
          const names = [];
          recurse(parsed, mapUrl, mappings, sources, sourcesContent, names, 0, 0, Infinity, Infinity);
          const joined = {
            version: 3,
            file: parsed.file,
            names,
            sources,
            sourcesContent,
            mappings
          };
          return exports3.presortedDecodedMap(joined);
        };
        function recurse(input, mapUrl, mappings, sources, sourcesContent, names, lineOffset, columnOffset, stopLine, stopColumn) {
          const { sections } = input;
          for (let i = 0; i < sections.length; i++) {
            const { map: map2, offset } = sections[i];
            let sl = stopLine;
            let sc = stopColumn;
            if (i + 1 < sections.length) {
              const nextOffset = sections[i + 1].offset;
              sl = Math.min(stopLine, lineOffset + nextOffset.line);
              if (sl === stopLine) {
                sc = Math.min(stopColumn, columnOffset + nextOffset.column);
              } else if (sl < stopLine) {
                sc = columnOffset + nextOffset.column;
              }
            }
            addSection(map2, mapUrl, mappings, sources, sourcesContent, names, lineOffset + offset.line, columnOffset + offset.column, sl, sc);
          }
        }
        function addSection(input, mapUrl, mappings, sources, sourcesContent, names, lineOffset, columnOffset, stopLine, stopColumn) {
          if ("sections" in input)
            return recurse(...arguments);
          const map2 = new TraceMap(input, mapUrl);
          const sourcesOffset = sources.length;
          const namesOffset = names.length;
          const decoded = exports3.decodedMappings(map2);
          const { resolvedSources, sourcesContent: contents } = map2;
          append(sources, resolvedSources);
          append(names, map2.names);
          if (contents)
            append(sourcesContent, contents);
          else
            for (let i = 0; i < resolvedSources.length; i++)
              sourcesContent.push(null);
          for (let i = 0; i < decoded.length; i++) {
            const lineI = lineOffset + i;
            if (lineI > stopLine)
              return;
            const out = getLine(mappings, lineI);
            const cOffset = i === 0 ? columnOffset : 0;
            const line = decoded[i];
            for (let j = 0; j < line.length; j++) {
              const seg = line[j];
              const column = cOffset + seg[COLUMN];
              if (lineI === stopLine && column >= stopColumn)
                return;
              if (seg.length === 1) {
                out.push([column]);
                continue;
              }
              const sourcesIndex = sourcesOffset + seg[SOURCES_INDEX];
              const sourceLine = seg[SOURCE_LINE];
              const sourceColumn = seg[SOURCE_COLUMN];
              out.push(seg.length === 4 ? [column, sourcesIndex, sourceLine, sourceColumn] : [column, sourcesIndex, sourceLine, sourceColumn, namesOffset + seg[NAMES_INDEX]]);
            }
          }
        }
        function append(arr, other) {
          for (let i = 0; i < other.length; i++)
            arr.push(other[i]);
        }
        function getLine(arr, index) {
          for (let i = arr.length; i <= index; i++)
            arr[i] = [];
          return arr[index];
        }
        const LINE_GTR_ZERO = "`line` must be greater than 0 (lines start at line 1)";
        const COL_GTR_EQ_ZERO = "`column` must be greater than or equal to 0 (columns start at column 0)";
        const LEAST_UPPER_BOUND = -1;
        const GREATEST_LOWER_BOUND = 1;
        exports3.encodedMappings = void 0;
        exports3.decodedMappings = void 0;
        exports3.traceSegment = void 0;
        exports3.originalPositionFor = void 0;
        exports3.generatedPositionFor = void 0;
        exports3.allGeneratedPositionsFor = void 0;
        exports3.eachMapping = void 0;
        exports3.sourceContentFor = void 0;
        exports3.presortedDecodedMap = void 0;
        exports3.decodedMap = void 0;
        exports3.encodedMap = void 0;
        class TraceMap {
          constructor(map2, mapUrl) {
            const isString2 = typeof map2 === "string";
            if (!isString2 && map2._decodedMemo)
              return map2;
            const parsed = isString2 ? JSON.parse(map2) : map2;
            const { version, file: file2, names, sourceRoot, sources, sourcesContent } = parsed;
            this.version = version;
            this.file = file2;
            this.names = names;
            this.sourceRoot = sourceRoot;
            this.sources = sources;
            this.sourcesContent = sourcesContent;
            const from = resolve(sourceRoot || "", stripFilename(mapUrl));
            this.resolvedSources = sources.map((s) => resolve(s || "", from));
            const { mappings } = parsed;
            if (typeof mappings === "string") {
              this._encoded = mappings;
              this._decoded = void 0;
            } else {
              this._encoded = void 0;
              this._decoded = maybeSort(mappings, isString2);
            }
            this._decodedMemo = memoizedState();
            this._bySources = void 0;
            this._bySourceMemos = void 0;
          }
        }
        (() => {
          exports3.encodedMappings = (map2) => {
            var _a;
            return (_a = map2._encoded) !== null && _a !== void 0 ? _a : map2._encoded = sourcemapCodec.encode(map2._decoded);
          };
          exports3.decodedMappings = (map2) => {
            return map2._decoded || (map2._decoded = sourcemapCodec.decode(map2._encoded));
          };
          exports3.traceSegment = (map2, line, column) => {
            const decoded = exports3.decodedMappings(map2);
            if (line >= decoded.length)
              return null;
            const segments = decoded[line];
            const index = traceSegmentInternal(segments, map2._decodedMemo, line, column, GREATEST_LOWER_BOUND);
            return index === -1 ? null : segments[index];
          };
          exports3.originalPositionFor = (map2, { line, column, bias }) => {
            line--;
            if (line < 0)
              throw new Error(LINE_GTR_ZERO);
            if (column < 0)
              throw new Error(COL_GTR_EQ_ZERO);
            const decoded = exports3.decodedMappings(map2);
            if (line >= decoded.length)
              return OMapping(null, null, null, null);
            const segments = decoded[line];
            const index = traceSegmentInternal(segments, map2._decodedMemo, line, column, bias || GREATEST_LOWER_BOUND);
            if (index === -1)
              return OMapping(null, null, null, null);
            const segment = segments[index];
            if (segment.length === 1)
              return OMapping(null, null, null, null);
            const { names, resolvedSources } = map2;
            return OMapping(resolvedSources[segment[SOURCES_INDEX]], segment[SOURCE_LINE] + 1, segment[SOURCE_COLUMN], segment.length === 5 ? names[segment[NAMES_INDEX]] : null);
          };
          exports3.allGeneratedPositionsFor = (map2, { source, line, column, bias }) => {
            return generatedPosition(map2, source, line, column, bias || LEAST_UPPER_BOUND, true);
          };
          exports3.generatedPositionFor = (map2, { source, line, column, bias }) => {
            return generatedPosition(map2, source, line, column, bias || GREATEST_LOWER_BOUND, false);
          };
          exports3.eachMapping = (map2, cb) => {
            const decoded = exports3.decodedMappings(map2);
            const { names, resolvedSources } = map2;
            for (let i = 0; i < decoded.length; i++) {
              const line = decoded[i];
              for (let j = 0; j < line.length; j++) {
                const seg = line[j];
                const generatedLine = i + 1;
                const generatedColumn = seg[0];
                let source = null;
                let originalLine = null;
                let originalColumn = null;
                let name = null;
                if (seg.length !== 1) {
                  source = resolvedSources[seg[1]];
                  originalLine = seg[2] + 1;
                  originalColumn = seg[3];
                }
                if (seg.length === 5)
                  name = names[seg[4]];
                cb({
                  generatedLine,
                  generatedColumn,
                  source,
                  originalLine,
                  originalColumn,
                  name
                });
              }
            }
          };
          exports3.sourceContentFor = (map2, source) => {
            const { sources, resolvedSources, sourcesContent } = map2;
            if (sourcesContent == null)
              return null;
            let index = sources.indexOf(source);
            if (index === -1)
              index = resolvedSources.indexOf(source);
            return index === -1 ? null : sourcesContent[index];
          };
          exports3.presortedDecodedMap = (map2, mapUrl) => {
            const tracer = new TraceMap(clone2(map2, []), mapUrl);
            tracer._decoded = map2.mappings;
            return tracer;
          };
          exports3.decodedMap = (map2) => {
            return clone2(map2, exports3.decodedMappings(map2));
          };
          exports3.encodedMap = (map2) => {
            return clone2(map2, exports3.encodedMappings(map2));
          };
          function generatedPosition(map2, source, line, column, bias, all) {
            line--;
            if (line < 0)
              throw new Error(LINE_GTR_ZERO);
            if (column < 0)
              throw new Error(COL_GTR_EQ_ZERO);
            const { sources, resolvedSources } = map2;
            let sourceIndex = sources.indexOf(source);
            if (sourceIndex === -1)
              sourceIndex = resolvedSources.indexOf(source);
            if (sourceIndex === -1)
              return all ? [] : GMapping(null, null);
            const generated = map2._bySources || (map2._bySources = buildBySources(exports3.decodedMappings(map2), map2._bySourceMemos = sources.map(memoizedState)));
            const segments = generated[sourceIndex][line];
            if (segments == null)
              return all ? [] : GMapping(null, null);
            const memo = map2._bySourceMemos[sourceIndex];
            if (all)
              return sliceGeneratedPositions(segments, memo, line, column, bias);
            const index = traceSegmentInternal(segments, memo, line, column, bias);
            if (index === -1)
              return GMapping(null, null);
            const segment = segments[index];
            return GMapping(segment[REV_GENERATED_LINE] + 1, segment[REV_GENERATED_COLUMN]);
          }
        })();
        function clone2(map2, mappings) {
          return {
            version: map2.version,
            file: map2.file,
            names: map2.names,
            sourceRoot: map2.sourceRoot,
            sources: map2.sources,
            sourcesContent: map2.sourcesContent,
            mappings
          };
        }
        function OMapping(source, line, column, name) {
          return { source, line, column, name };
        }
        function GMapping(line, column) {
          return { line, column };
        }
        function traceSegmentInternal(segments, memo, line, column, bias) {
          let index = memoizedBinarySearch(segments, column, memo, line);
          if (found) {
            index = (bias === LEAST_UPPER_BOUND ? upperBound : lowerBound)(segments, column, index);
          } else if (bias === LEAST_UPPER_BOUND)
            index++;
          if (index === -1 || index === segments.length)
            return -1;
          return index;
        }
        function sliceGeneratedPositions(segments, memo, line, column, bias) {
          let min2 = traceSegmentInternal(segments, memo, line, column, GREATEST_LOWER_BOUND);
          if (!found && bias === LEAST_UPPER_BOUND)
            min2++;
          if (min2 === -1 || min2 === segments.length)
            return [];
          const matchedColumn = found ? column : segments[min2][COLUMN];
          if (!found)
            min2 = lowerBound(segments, matchedColumn, min2);
          const max2 = upperBound(segments, matchedColumn, min2);
          const result2 = [];
          for (; min2 <= max2; min2++) {
            const segment = segments[min2];
            result2.push(GMapping(segment[REV_GENERATED_LINE] + 1, segment[REV_GENERATED_COLUMN]));
          }
          return result2;
        }
        exports3.AnyMap = AnyMap;
        exports3.GREATEST_LOWER_BOUND = GREATEST_LOWER_BOUND;
        exports3.LEAST_UPPER_BOUND = LEAST_UPPER_BOUND;
        exports3.TraceMap = TraceMap;
        Object.defineProperty(exports3, "__esModule", { value: true });
      });
    }
  });

  // node_modules/@jridgewell/gen-mapping/dist/gen-mapping.umd.js
  var require_gen_mapping_umd = __commonJS({
    "node_modules/@jridgewell/gen-mapping/dist/gen-mapping.umd.js"(exports2, module2) {
      init_define_process();
      (function(global2, factory2) {
        typeof exports2 === "object" && typeof module2 !== "undefined" ? factory2(exports2, require_set_array_umd(), require_sourcemap_codec_umd(), require_trace_mapping_umd()) : typeof define === "function" && define.amd ? define(["exports", "@jridgewell/set-array", "@jridgewell/sourcemap-codec", "@jridgewell/trace-mapping"], factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory2(global2.genMapping = {}, global2.setArray, global2.sourcemapCodec, global2.traceMapping));
      })(exports2, function(exports3, setArray, sourcemapCodec, traceMapping) {
        "use strict";
        const COLUMN = 0;
        const SOURCES_INDEX = 1;
        const SOURCE_LINE = 2;
        const SOURCE_COLUMN = 3;
        const NAMES_INDEX = 4;
        const NO_NAME = -1;
        exports3.addSegment = void 0;
        exports3.addMapping = void 0;
        exports3.maybeAddSegment = void 0;
        exports3.maybeAddMapping = void 0;
        exports3.setSourceContent = void 0;
        exports3.toDecodedMap = void 0;
        exports3.toEncodedMap = void 0;
        exports3.fromMap = void 0;
        exports3.allMappings = void 0;
        let addSegmentInternal;
        class GenMapping {
          constructor({ file: file2, sourceRoot } = {}) {
            this._names = new setArray.SetArray();
            this._sources = new setArray.SetArray();
            this._sourcesContent = [];
            this._mappings = [];
            this.file = file2;
            this.sourceRoot = sourceRoot;
          }
        }
        (() => {
          exports3.addSegment = (map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content) => {
            return addSegmentInternal(false, map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
          };
          exports3.maybeAddSegment = (map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content) => {
            return addSegmentInternal(true, map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
          };
          exports3.addMapping = (map2, mapping) => {
            return addMappingInternal(false, map2, mapping);
          };
          exports3.maybeAddMapping = (map2, mapping) => {
            return addMappingInternal(true, map2, mapping);
          };
          exports3.setSourceContent = (map2, source, content) => {
            const { _sources: sources, _sourcesContent: sourcesContent } = map2;
            sourcesContent[setArray.put(sources, source)] = content;
          };
          exports3.toDecodedMap = (map2) => {
            const { file: file2, sourceRoot, _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names } = map2;
            removeEmptyFinalLines(mappings);
            return {
              version: 3,
              file: file2 || void 0,
              names: names.array,
              sourceRoot: sourceRoot || void 0,
              sources: sources.array,
              sourcesContent,
              mappings
            };
          };
          exports3.toEncodedMap = (map2) => {
            const decoded = exports3.toDecodedMap(map2);
            return Object.assign(Object.assign({}, decoded), { mappings: sourcemapCodec.encode(decoded.mappings) });
          };
          exports3.allMappings = (map2) => {
            const out = [];
            const { _mappings: mappings, _sources: sources, _names: names } = map2;
            for (let i = 0; i < mappings.length; i++) {
              const line = mappings[i];
              for (let j = 0; j < line.length; j++) {
                const seg = line[j];
                const generated = { line: i + 1, column: seg[COLUMN] };
                let source = void 0;
                let original = void 0;
                let name = void 0;
                if (seg.length !== 1) {
                  source = sources.array[seg[SOURCES_INDEX]];
                  original = { line: seg[SOURCE_LINE] + 1, column: seg[SOURCE_COLUMN] };
                  if (seg.length === 5)
                    name = names.array[seg[NAMES_INDEX]];
                }
                out.push({ generated, source, original, name });
              }
            }
            return out;
          };
          exports3.fromMap = (input) => {
            const map2 = new traceMapping.TraceMap(input);
            const gen = new GenMapping({ file: map2.file, sourceRoot: map2.sourceRoot });
            putAll(gen._names, map2.names);
            putAll(gen._sources, map2.sources);
            gen._sourcesContent = map2.sourcesContent || map2.sources.map(() => null);
            gen._mappings = traceMapping.decodedMappings(map2);
            return gen;
          };
          addSegmentInternal = (skipable, map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content) => {
            const { _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names } = map2;
            const line = getLine(mappings, genLine);
            const index = getColumnIndex(line, genColumn);
            if (!source) {
              if (skipable && skipSourceless(line, index))
                return;
              return insert(line, index, [genColumn]);
            }
            const sourcesIndex = setArray.put(sources, source);
            const namesIndex = name ? setArray.put(names, name) : NO_NAME;
            if (sourcesIndex === sourcesContent.length)
              sourcesContent[sourcesIndex] = content !== null && content !== void 0 ? content : null;
            if (skipable && skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex)) {
              return;
            }
            return insert(line, index, name ? [genColumn, sourcesIndex, sourceLine, sourceColumn, namesIndex] : [genColumn, sourcesIndex, sourceLine, sourceColumn]);
          };
        })();
        function getLine(mappings, index) {
          for (let i = mappings.length; i <= index; i++) {
            mappings[i] = [];
          }
          return mappings[index];
        }
        function getColumnIndex(line, genColumn) {
          let index = line.length;
          for (let i = index - 1; i >= 0; index = i--) {
            const current = line[i];
            if (genColumn >= current[COLUMN])
              break;
          }
          return index;
        }
        function insert(array, index, value) {
          for (let i = array.length; i > index; i--) {
            array[i] = array[i - 1];
          }
          array[index] = value;
        }
        function removeEmptyFinalLines(mappings) {
          const { length } = mappings;
          let len = length;
          for (let i = len - 1; i >= 0; len = i, i--) {
            if (mappings[i].length > 0)
              break;
          }
          if (len < length)
            mappings.length = len;
        }
        function putAll(strarr, array) {
          for (let i = 0; i < array.length; i++)
            setArray.put(strarr, array[i]);
        }
        function skipSourceless(line, index) {
          if (index === 0)
            return true;
          const prev = line[index - 1];
          return prev.length === 1;
        }
        function skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex) {
          if (index === 0)
            return false;
          const prev = line[index - 1];
          if (prev.length === 1)
            return false;
          return sourcesIndex === prev[SOURCES_INDEX] && sourceLine === prev[SOURCE_LINE] && sourceColumn === prev[SOURCE_COLUMN] && namesIndex === (prev.length === 5 ? prev[NAMES_INDEX] : NO_NAME);
        }
        function addMappingInternal(skipable, map2, mapping) {
          const { generated, source, original, name, content } = mapping;
          if (!source) {
            return addSegmentInternal(skipable, map2, generated.line - 1, generated.column, null, null, null, null, null);
          }
          const s = source;
          return addSegmentInternal(skipable, map2, generated.line - 1, generated.column, s, original.line - 1, original.column, name, content);
        }
        exports3.GenMapping = GenMapping;
        Object.defineProperty(exports3, "__esModule", { value: true });
      });
    }
  });

  // node_modules/@babel/generator/lib/source-map.js
  var require_source_map2 = __commonJS({
    "node_modules/@babel/generator/lib/source-map.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _genMapping = require_gen_mapping_umd();
      var SourceMap = class {
        constructor(opts, code) {
          var _opts$sourceFileName;
          this._map = void 0;
          this._rawMappings = void 0;
          this._sourceFileName = void 0;
          this._lastGenLine = 0;
          this._lastSourceLine = 0;
          this._lastSourceColumn = 0;
          const map2 = this._map = new _genMapping.GenMapping({
            sourceRoot: opts.sourceRoot
          });
          this._sourceFileName = (_opts$sourceFileName = opts.sourceFileName) == null ? void 0 : _opts$sourceFileName.replace(/\\/g, "/");
          this._rawMappings = void 0;
          if (typeof code === "string") {
            (0, _genMapping.setSourceContent)(map2, this._sourceFileName, code);
          } else if (typeof code === "object") {
            Object.keys(code).forEach((sourceFileName) => {
              (0, _genMapping.setSourceContent)(map2, sourceFileName.replace(/\\/g, "/"), code[sourceFileName]);
            });
          }
        }
        get() {
          return (0, _genMapping.toEncodedMap)(this._map);
        }
        getDecoded() {
          return (0, _genMapping.toDecodedMap)(this._map);
        }
        getRawMappings() {
          return this._rawMappings || (this._rawMappings = (0, _genMapping.allMappings)(this._map));
        }
        mark(generated, line, column, identifierName, filename) {
          this._rawMappings = void 0;
          (0, _genMapping.maybeAddMapping)(this._map, {
            name: identifierName,
            generated,
            source: line == null ? void 0 : (filename == null ? void 0 : filename.replace(/\\/g, "/")) || this._sourceFileName,
            original: line == null ? void 0 : {
              line,
              column
            }
          });
        }
      };
      exports2.default = SourceMap;
    }
  });

  // node_modules/@babel/generator/lib/buffer.js
  var require_buffer2 = __commonJS({
    "node_modules/@babel/generator/lib/buffer.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var Buffer5 = class {
        constructor(map2) {
          this._map = null;
          this._buf = "";
          this._str = "";
          this._appendCount = 0;
          this._last = 0;
          this._queue = [];
          this._queueCursor = 0;
          this._position = {
            line: 1,
            column: 0
          };
          this._sourcePosition = {
            identifierName: void 0,
            line: void 0,
            column: void 0,
            filename: void 0
          };
          this._map = map2;
          this._allocQueue();
        }
        _allocQueue() {
          const queue = this._queue;
          for (let i = 0; i < 16; i++) {
            queue.push({
              char: 0,
              repeat: 1,
              line: void 0,
              column: void 0,
              identifierName: void 0,
              filename: ""
            });
          }
        }
        _pushQueue(char, repeat2, line, column, identifierName, filename) {
          const cursor = this._queueCursor;
          if (cursor === this._queue.length) {
            this._allocQueue();
          }
          const item = this._queue[cursor];
          item.char = char;
          item.repeat = repeat2;
          item.line = line;
          item.column = column;
          item.identifierName = identifierName;
          item.filename = filename;
          this._queueCursor++;
        }
        _popQueue() {
          if (this._queueCursor === 0) {
            throw new Error("Cannot pop from empty queue");
          }
          return this._queue[--this._queueCursor];
        }
        get() {
          this._flush();
          const map2 = this._map;
          const result2 = {
            code: (this._buf + this._str).trimRight(),
            decodedMap: map2 == null ? void 0 : map2.getDecoded(),
            get map() {
              const resultMap = map2 ? map2.get() : null;
              result2.map = resultMap;
              return resultMap;
            },
            set map(value) {
              Object.defineProperty(result2, "map", {
                value,
                writable: true
              });
            },
            get rawMappings() {
              const mappings = map2 == null ? void 0 : map2.getRawMappings();
              result2.rawMappings = mappings;
              return mappings;
            },
            set rawMappings(value) {
              Object.defineProperty(result2, "rawMappings", {
                value,
                writable: true
              });
            }
          };
          return result2;
        }
        append(str, maybeNewline) {
          this._flush();
          this._append(str, this._sourcePosition, maybeNewline);
        }
        appendChar(char) {
          this._flush();
          this._appendChar(char, 1, this._sourcePosition);
        }
        queue(char) {
          if (char === 10) {
            while (this._queueCursor !== 0) {
              const char2 = this._queue[this._queueCursor - 1].char;
              if (char2 !== 32 && char2 !== 9) {
                break;
              }
              this._queueCursor--;
            }
          }
          const sourcePosition = this._sourcePosition;
          this._pushQueue(char, 1, sourcePosition.line, sourcePosition.column, sourcePosition.identifierName, sourcePosition.filename);
        }
        queueIndentation(char, repeat2) {
          this._pushQueue(char, repeat2, void 0, void 0, void 0, void 0);
        }
        _flush() {
          const queueCursor = this._queueCursor;
          const queue = this._queue;
          for (let i = 0; i < queueCursor; i++) {
            const item = queue[i];
            this._appendChar(item.char, item.repeat, item);
          }
          this._queueCursor = 0;
        }
        _appendChar(char, repeat2, sourcePos) {
          this._last = char;
          this._str += repeat2 > 1 ? String.fromCharCode(char).repeat(repeat2) : String.fromCharCode(char);
          if (char !== 10) {
            this._mark(sourcePos.line, sourcePos.column, sourcePos.identifierName, sourcePos.filename);
            this._position.column += repeat2;
          } else {
            this._position.line++;
            this._position.column = 0;
          }
        }
        _append(str, sourcePos, maybeNewline) {
          const len = str.length;
          const position = this._position;
          this._last = str.charCodeAt(len - 1);
          if (++this._appendCount > 4096) {
            +this._str;
            this._buf += this._str;
            this._str = str;
            this._appendCount = 0;
          } else {
            this._str += str;
          }
          if (!maybeNewline && !this._map) {
            position.column += len;
            return;
          }
          const {
            column,
            identifierName,
            filename
          } = sourcePos;
          let line = sourcePos.line;
          let i = str.indexOf("\n");
          let last2 = 0;
          if (i !== 0) {
            this._mark(line, column, identifierName, filename);
          }
          while (i !== -1) {
            position.line++;
            position.column = 0;
            last2 = i + 1;
            if (last2 < len) {
              this._mark(++line, 0, identifierName, filename);
            }
            i = str.indexOf("\n", last2);
          }
          position.column += len - last2;
        }
        _mark(line, column, identifierName, filename) {
          var _this$_map;
          (_this$_map = this._map) == null ? void 0 : _this$_map.mark(this._position, line, column, identifierName, filename);
        }
        removeTrailingNewline() {
          const queueCursor = this._queueCursor;
          if (queueCursor !== 0 && this._queue[queueCursor - 1].char === 10) {
            this._queueCursor--;
          }
        }
        removeLastSemicolon() {
          const queueCursor = this._queueCursor;
          if (queueCursor !== 0 && this._queue[queueCursor - 1].char === 59) {
            this._queueCursor--;
          }
        }
        getLastChar() {
          const queueCursor = this._queueCursor;
          return queueCursor !== 0 ? this._queue[queueCursor - 1].char : this._last;
        }
        getNewlineCount() {
          const queueCursor = this._queueCursor;
          let count = 0;
          if (queueCursor === 0)
            return this._last === 10 ? 1 : 0;
          for (let i = queueCursor - 1; i >= 0; i--) {
            if (this._queue[i].char !== 10) {
              break;
            }
            count++;
          }
          return count === queueCursor && this._last === 10 ? count + 1 : count;
        }
        endsWithCharAndNewline() {
          const queue = this._queue;
          const queueCursor = this._queueCursor;
          if (queueCursor !== 0) {
            const lastCp = queue[queueCursor - 1].char;
            if (lastCp !== 10)
              return;
            if (queueCursor > 1) {
              return queue[queueCursor - 2].char;
            } else {
              return this._last;
            }
          }
        }
        hasContent() {
          return this._queueCursor !== 0 || !!this._last;
        }
        exactSource(loc, cb) {
          if (!this._map)
            return cb();
          this.source("start", loc);
          cb();
          this.source("end", loc);
        }
        source(prop, loc) {
          if (!this._map)
            return;
          this._normalizePosition(prop, loc, 0, 0);
        }
        sourceWithOffset(prop, loc, lineOffset, columnOffset) {
          if (!this._map)
            return;
          this._normalizePosition(prop, loc, lineOffset, columnOffset);
        }
        withSource(prop, loc, cb) {
          if (!this._map)
            return cb();
          this.source(prop, loc);
          cb();
        }
        _normalizePosition(prop, loc, lineOffset, columnOffset) {
          const pos = loc[prop];
          const target = this._sourcePosition;
          target.identifierName = prop === "start" && loc.identifierName || void 0;
          if (pos) {
            target.line = pos.line + lineOffset;
            target.column = pos.column + columnOffset;
            target.filename = loc.filename;
          }
        }
        getCurrentColumn() {
          const queue = this._queue;
          const queueCursor = this._queueCursor;
          let lastIndex = -1;
          let len = 0;
          for (let i = 0; i < queueCursor; i++) {
            const item = queue[i];
            if (item.char === 10) {
              lastIndex = len;
            }
            len += item.repeat;
          }
          return lastIndex === -1 ? this._position.column + len : len - 1 - lastIndex;
        }
        getCurrentLine() {
          let count = 0;
          const queue = this._queue;
          for (let i = 0; i < this._queueCursor; i++) {
            if (queue[i].char === 10) {
              count++;
            }
          }
          return this._position.line + count;
        }
      };
      exports2.default = Buffer5;
    }
  });

  // node_modules/@babel/types/lib/utils/shallowEqual.js
  var require_shallowEqual = __commonJS({
    "node_modules/@babel/types/lib/utils/shallowEqual.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = shallowEqual;
      function shallowEqual(actual, expected) {
        const keys2 = Object.keys(expected);
        for (const key of keys2) {
          if (actual[key] !== expected[key]) {
            return false;
          }
        }
        return true;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/generated/index.js
  var require_generated = __commonJS({
    "node_modules/@babel/types/lib/validators/generated/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.isAccessor = isAccessor;
      exports2.isAnyTypeAnnotation = isAnyTypeAnnotation;
      exports2.isArgumentPlaceholder = isArgumentPlaceholder;
      exports2.isArrayExpression = isArrayExpression;
      exports2.isArrayPattern = isArrayPattern;
      exports2.isArrayTypeAnnotation = isArrayTypeAnnotation;
      exports2.isArrowFunctionExpression = isArrowFunctionExpression;
      exports2.isAssignmentExpression = isAssignmentExpression;
      exports2.isAssignmentPattern = isAssignmentPattern;
      exports2.isAwaitExpression = isAwaitExpression;
      exports2.isBigIntLiteral = isBigIntLiteral;
      exports2.isBinary = isBinary;
      exports2.isBinaryExpression = isBinaryExpression;
      exports2.isBindExpression = isBindExpression;
      exports2.isBlock = isBlock;
      exports2.isBlockParent = isBlockParent;
      exports2.isBlockStatement = isBlockStatement;
      exports2.isBooleanLiteral = isBooleanLiteral;
      exports2.isBooleanLiteralTypeAnnotation = isBooleanLiteralTypeAnnotation;
      exports2.isBooleanTypeAnnotation = isBooleanTypeAnnotation;
      exports2.isBreakStatement = isBreakStatement;
      exports2.isCallExpression = isCallExpression;
      exports2.isCatchClause = isCatchClause;
      exports2.isClass = isClass;
      exports2.isClassAccessorProperty = isClassAccessorProperty;
      exports2.isClassBody = isClassBody;
      exports2.isClassDeclaration = isClassDeclaration;
      exports2.isClassExpression = isClassExpression;
      exports2.isClassImplements = isClassImplements;
      exports2.isClassMethod = isClassMethod;
      exports2.isClassPrivateMethod = isClassPrivateMethod;
      exports2.isClassPrivateProperty = isClassPrivateProperty;
      exports2.isClassProperty = isClassProperty;
      exports2.isCompletionStatement = isCompletionStatement;
      exports2.isConditional = isConditional;
      exports2.isConditionalExpression = isConditionalExpression;
      exports2.isContinueStatement = isContinueStatement;
      exports2.isDebuggerStatement = isDebuggerStatement;
      exports2.isDecimalLiteral = isDecimalLiteral;
      exports2.isDeclaration = isDeclaration;
      exports2.isDeclareClass = isDeclareClass;
      exports2.isDeclareExportAllDeclaration = isDeclareExportAllDeclaration;
      exports2.isDeclareExportDeclaration = isDeclareExportDeclaration;
      exports2.isDeclareFunction = isDeclareFunction;
      exports2.isDeclareInterface = isDeclareInterface;
      exports2.isDeclareModule = isDeclareModule;
      exports2.isDeclareModuleExports = isDeclareModuleExports;
      exports2.isDeclareOpaqueType = isDeclareOpaqueType;
      exports2.isDeclareTypeAlias = isDeclareTypeAlias;
      exports2.isDeclareVariable = isDeclareVariable;
      exports2.isDeclaredPredicate = isDeclaredPredicate;
      exports2.isDecorator = isDecorator;
      exports2.isDirective = isDirective;
      exports2.isDirectiveLiteral = isDirectiveLiteral;
      exports2.isDoExpression = isDoExpression;
      exports2.isDoWhileStatement = isDoWhileStatement;
      exports2.isEmptyStatement = isEmptyStatement;
      exports2.isEmptyTypeAnnotation = isEmptyTypeAnnotation;
      exports2.isEnumBody = isEnumBody;
      exports2.isEnumBooleanBody = isEnumBooleanBody;
      exports2.isEnumBooleanMember = isEnumBooleanMember;
      exports2.isEnumDeclaration = isEnumDeclaration;
      exports2.isEnumDefaultedMember = isEnumDefaultedMember;
      exports2.isEnumMember = isEnumMember;
      exports2.isEnumNumberBody = isEnumNumberBody;
      exports2.isEnumNumberMember = isEnumNumberMember;
      exports2.isEnumStringBody = isEnumStringBody;
      exports2.isEnumStringMember = isEnumStringMember;
      exports2.isEnumSymbolBody = isEnumSymbolBody;
      exports2.isExistsTypeAnnotation = isExistsTypeAnnotation;
      exports2.isExportAllDeclaration = isExportAllDeclaration;
      exports2.isExportDeclaration = isExportDeclaration;
      exports2.isExportDefaultDeclaration = isExportDefaultDeclaration;
      exports2.isExportDefaultSpecifier = isExportDefaultSpecifier;
      exports2.isExportNamedDeclaration = isExportNamedDeclaration;
      exports2.isExportNamespaceSpecifier = isExportNamespaceSpecifier;
      exports2.isExportSpecifier = isExportSpecifier;
      exports2.isExpression = isExpression;
      exports2.isExpressionStatement = isExpressionStatement;
      exports2.isExpressionWrapper = isExpressionWrapper;
      exports2.isFile = isFile;
      exports2.isFlow = isFlow;
      exports2.isFlowBaseAnnotation = isFlowBaseAnnotation;
      exports2.isFlowDeclaration = isFlowDeclaration;
      exports2.isFlowPredicate = isFlowPredicate;
      exports2.isFlowType = isFlowType;
      exports2.isFor = isFor;
      exports2.isForInStatement = isForInStatement;
      exports2.isForOfStatement = isForOfStatement;
      exports2.isForStatement = isForStatement;
      exports2.isForXStatement = isForXStatement;
      exports2.isFunction = isFunction2;
      exports2.isFunctionDeclaration = isFunctionDeclaration;
      exports2.isFunctionExpression = isFunctionExpression;
      exports2.isFunctionParent = isFunctionParent;
      exports2.isFunctionTypeAnnotation = isFunctionTypeAnnotation;
      exports2.isFunctionTypeParam = isFunctionTypeParam;
      exports2.isGenericTypeAnnotation = isGenericTypeAnnotation;
      exports2.isIdentifier = isIdentifier2;
      exports2.isIfStatement = isIfStatement;
      exports2.isImmutable = isImmutable;
      exports2.isImport = isImport;
      exports2.isImportAttribute = isImportAttribute;
      exports2.isImportDeclaration = isImportDeclaration;
      exports2.isImportDefaultSpecifier = isImportDefaultSpecifier;
      exports2.isImportNamespaceSpecifier = isImportNamespaceSpecifier;
      exports2.isImportSpecifier = isImportSpecifier;
      exports2.isIndexedAccessType = isIndexedAccessType;
      exports2.isInferredPredicate = isInferredPredicate;
      exports2.isInterfaceDeclaration = isInterfaceDeclaration;
      exports2.isInterfaceExtends = isInterfaceExtends;
      exports2.isInterfaceTypeAnnotation = isInterfaceTypeAnnotation;
      exports2.isInterpreterDirective = isInterpreterDirective;
      exports2.isIntersectionTypeAnnotation = isIntersectionTypeAnnotation;
      exports2.isJSX = isJSX;
      exports2.isJSXAttribute = isJSXAttribute;
      exports2.isJSXClosingElement = isJSXClosingElement;
      exports2.isJSXClosingFragment = isJSXClosingFragment;
      exports2.isJSXElement = isJSXElement;
      exports2.isJSXEmptyExpression = isJSXEmptyExpression;
      exports2.isJSXExpressionContainer = isJSXExpressionContainer;
      exports2.isJSXFragment = isJSXFragment;
      exports2.isJSXIdentifier = isJSXIdentifier;
      exports2.isJSXMemberExpression = isJSXMemberExpression;
      exports2.isJSXNamespacedName = isJSXNamespacedName;
      exports2.isJSXOpeningElement = isJSXOpeningElement;
      exports2.isJSXOpeningFragment = isJSXOpeningFragment;
      exports2.isJSXSpreadAttribute = isJSXSpreadAttribute;
      exports2.isJSXSpreadChild = isJSXSpreadChild;
      exports2.isJSXText = isJSXText;
      exports2.isLVal = isLVal;
      exports2.isLabeledStatement = isLabeledStatement;
      exports2.isLiteral = isLiteral;
      exports2.isLogicalExpression = isLogicalExpression;
      exports2.isLoop = isLoop;
      exports2.isMemberExpression = isMemberExpression;
      exports2.isMetaProperty = isMetaProperty;
      exports2.isMethod = isMethod;
      exports2.isMiscellaneous = isMiscellaneous;
      exports2.isMixedTypeAnnotation = isMixedTypeAnnotation;
      exports2.isModuleDeclaration = isModuleDeclaration;
      exports2.isModuleExpression = isModuleExpression;
      exports2.isModuleSpecifier = isModuleSpecifier;
      exports2.isNewExpression = isNewExpression;
      exports2.isNoop = isNoop;
      exports2.isNullLiteral = isNullLiteral;
      exports2.isNullLiteralTypeAnnotation = isNullLiteralTypeAnnotation;
      exports2.isNullableTypeAnnotation = isNullableTypeAnnotation;
      exports2.isNumberLiteral = isNumberLiteral;
      exports2.isNumberLiteralTypeAnnotation = isNumberLiteralTypeAnnotation;
      exports2.isNumberTypeAnnotation = isNumberTypeAnnotation;
      exports2.isNumericLiteral = isNumericLiteral;
      exports2.isObjectExpression = isObjectExpression;
      exports2.isObjectMember = isObjectMember;
      exports2.isObjectMethod = isObjectMethod;
      exports2.isObjectPattern = isObjectPattern;
      exports2.isObjectProperty = isObjectProperty;
      exports2.isObjectTypeAnnotation = isObjectTypeAnnotation;
      exports2.isObjectTypeCallProperty = isObjectTypeCallProperty;
      exports2.isObjectTypeIndexer = isObjectTypeIndexer;
      exports2.isObjectTypeInternalSlot = isObjectTypeInternalSlot;
      exports2.isObjectTypeProperty = isObjectTypeProperty;
      exports2.isObjectTypeSpreadProperty = isObjectTypeSpreadProperty;
      exports2.isOpaqueType = isOpaqueType;
      exports2.isOptionalCallExpression = isOptionalCallExpression;
      exports2.isOptionalIndexedAccessType = isOptionalIndexedAccessType;
      exports2.isOptionalMemberExpression = isOptionalMemberExpression;
      exports2.isParenthesizedExpression = isParenthesizedExpression;
      exports2.isPattern = isPattern;
      exports2.isPatternLike = isPatternLike;
      exports2.isPipelineBareFunction = isPipelineBareFunction;
      exports2.isPipelinePrimaryTopicReference = isPipelinePrimaryTopicReference;
      exports2.isPipelineTopicExpression = isPipelineTopicExpression;
      exports2.isPlaceholder = isPlaceholder;
      exports2.isPrivate = isPrivate;
      exports2.isPrivateName = isPrivateName;
      exports2.isProgram = isProgram;
      exports2.isProperty = isProperty;
      exports2.isPureish = isPureish;
      exports2.isQualifiedTypeIdentifier = isQualifiedTypeIdentifier;
      exports2.isRecordExpression = isRecordExpression;
      exports2.isRegExpLiteral = isRegExpLiteral;
      exports2.isRegexLiteral = isRegexLiteral;
      exports2.isRestElement = isRestElement;
      exports2.isRestProperty = isRestProperty;
      exports2.isReturnStatement = isReturnStatement;
      exports2.isScopable = isScopable;
      exports2.isSequenceExpression = isSequenceExpression;
      exports2.isSpreadElement = isSpreadElement;
      exports2.isSpreadProperty = isSpreadProperty;
      exports2.isStandardized = isStandardized;
      exports2.isStatement = isStatement;
      exports2.isStaticBlock = isStaticBlock;
      exports2.isStringLiteral = isStringLiteral;
      exports2.isStringLiteralTypeAnnotation = isStringLiteralTypeAnnotation;
      exports2.isStringTypeAnnotation = isStringTypeAnnotation;
      exports2.isSuper = isSuper;
      exports2.isSwitchCase = isSwitchCase;
      exports2.isSwitchStatement = isSwitchStatement;
      exports2.isSymbolTypeAnnotation = isSymbolTypeAnnotation;
      exports2.isTSAnyKeyword = isTSAnyKeyword;
      exports2.isTSArrayType = isTSArrayType;
      exports2.isTSAsExpression = isTSAsExpression;
      exports2.isTSBaseType = isTSBaseType;
      exports2.isTSBigIntKeyword = isTSBigIntKeyword;
      exports2.isTSBooleanKeyword = isTSBooleanKeyword;
      exports2.isTSCallSignatureDeclaration = isTSCallSignatureDeclaration;
      exports2.isTSConditionalType = isTSConditionalType;
      exports2.isTSConstructSignatureDeclaration = isTSConstructSignatureDeclaration;
      exports2.isTSConstructorType = isTSConstructorType;
      exports2.isTSDeclareFunction = isTSDeclareFunction;
      exports2.isTSDeclareMethod = isTSDeclareMethod;
      exports2.isTSEntityName = isTSEntityName;
      exports2.isTSEnumDeclaration = isTSEnumDeclaration;
      exports2.isTSEnumMember = isTSEnumMember;
      exports2.isTSExportAssignment = isTSExportAssignment;
      exports2.isTSExpressionWithTypeArguments = isTSExpressionWithTypeArguments;
      exports2.isTSExternalModuleReference = isTSExternalModuleReference;
      exports2.isTSFunctionType = isTSFunctionType;
      exports2.isTSImportEqualsDeclaration = isTSImportEqualsDeclaration;
      exports2.isTSImportType = isTSImportType;
      exports2.isTSIndexSignature = isTSIndexSignature;
      exports2.isTSIndexedAccessType = isTSIndexedAccessType;
      exports2.isTSInferType = isTSInferType;
      exports2.isTSInstantiationExpression = isTSInstantiationExpression;
      exports2.isTSInterfaceBody = isTSInterfaceBody;
      exports2.isTSInterfaceDeclaration = isTSInterfaceDeclaration;
      exports2.isTSIntersectionType = isTSIntersectionType;
      exports2.isTSIntrinsicKeyword = isTSIntrinsicKeyword;
      exports2.isTSLiteralType = isTSLiteralType;
      exports2.isTSMappedType = isTSMappedType;
      exports2.isTSMethodSignature = isTSMethodSignature;
      exports2.isTSModuleBlock = isTSModuleBlock;
      exports2.isTSModuleDeclaration = isTSModuleDeclaration;
      exports2.isTSNamedTupleMember = isTSNamedTupleMember;
      exports2.isTSNamespaceExportDeclaration = isTSNamespaceExportDeclaration;
      exports2.isTSNeverKeyword = isTSNeverKeyword;
      exports2.isTSNonNullExpression = isTSNonNullExpression;
      exports2.isTSNullKeyword = isTSNullKeyword;
      exports2.isTSNumberKeyword = isTSNumberKeyword;
      exports2.isTSObjectKeyword = isTSObjectKeyword;
      exports2.isTSOptionalType = isTSOptionalType;
      exports2.isTSParameterProperty = isTSParameterProperty;
      exports2.isTSParenthesizedType = isTSParenthesizedType;
      exports2.isTSPropertySignature = isTSPropertySignature;
      exports2.isTSQualifiedName = isTSQualifiedName;
      exports2.isTSRestType = isTSRestType;
      exports2.isTSSatisfiesExpression = isTSSatisfiesExpression;
      exports2.isTSStringKeyword = isTSStringKeyword;
      exports2.isTSSymbolKeyword = isTSSymbolKeyword;
      exports2.isTSThisType = isTSThisType;
      exports2.isTSTupleType = isTSTupleType;
      exports2.isTSType = isTSType;
      exports2.isTSTypeAliasDeclaration = isTSTypeAliasDeclaration;
      exports2.isTSTypeAnnotation = isTSTypeAnnotation;
      exports2.isTSTypeAssertion = isTSTypeAssertion;
      exports2.isTSTypeElement = isTSTypeElement;
      exports2.isTSTypeLiteral = isTSTypeLiteral;
      exports2.isTSTypeOperator = isTSTypeOperator;
      exports2.isTSTypeParameter = isTSTypeParameter;
      exports2.isTSTypeParameterDeclaration = isTSTypeParameterDeclaration;
      exports2.isTSTypeParameterInstantiation = isTSTypeParameterInstantiation;
      exports2.isTSTypePredicate = isTSTypePredicate;
      exports2.isTSTypeQuery = isTSTypeQuery;
      exports2.isTSTypeReference = isTSTypeReference;
      exports2.isTSUndefinedKeyword = isTSUndefinedKeyword;
      exports2.isTSUnionType = isTSUnionType;
      exports2.isTSUnknownKeyword = isTSUnknownKeyword;
      exports2.isTSVoidKeyword = isTSVoidKeyword;
      exports2.isTaggedTemplateExpression = isTaggedTemplateExpression;
      exports2.isTemplateElement = isTemplateElement;
      exports2.isTemplateLiteral = isTemplateLiteral;
      exports2.isTerminatorless = isTerminatorless;
      exports2.isThisExpression = isThisExpression;
      exports2.isThisTypeAnnotation = isThisTypeAnnotation;
      exports2.isThrowStatement = isThrowStatement;
      exports2.isTopicReference = isTopicReference;
      exports2.isTryStatement = isTryStatement;
      exports2.isTupleExpression = isTupleExpression;
      exports2.isTupleTypeAnnotation = isTupleTypeAnnotation;
      exports2.isTypeAlias = isTypeAlias;
      exports2.isTypeAnnotation = isTypeAnnotation;
      exports2.isTypeCastExpression = isTypeCastExpression;
      exports2.isTypeParameter = isTypeParameter;
      exports2.isTypeParameterDeclaration = isTypeParameterDeclaration;
      exports2.isTypeParameterInstantiation = isTypeParameterInstantiation;
      exports2.isTypeScript = isTypeScript;
      exports2.isTypeofTypeAnnotation = isTypeofTypeAnnotation;
      exports2.isUnaryExpression = isUnaryExpression;
      exports2.isUnaryLike = isUnaryLike;
      exports2.isUnionTypeAnnotation = isUnionTypeAnnotation;
      exports2.isUpdateExpression = isUpdateExpression;
      exports2.isUserWhitespacable = isUserWhitespacable;
      exports2.isV8IntrinsicIdentifier = isV8IntrinsicIdentifier;
      exports2.isVariableDeclaration = isVariableDeclaration;
      exports2.isVariableDeclarator = isVariableDeclarator;
      exports2.isVariance = isVariance;
      exports2.isVoidTypeAnnotation = isVoidTypeAnnotation;
      exports2.isWhile = isWhile;
      exports2.isWhileStatement = isWhileStatement;
      exports2.isWithStatement = isWithStatement;
      exports2.isYieldExpression = isYieldExpression;
      var _shallowEqual = require_shallowEqual();
      function isArrayExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ArrayExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isAssignmentExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "AssignmentExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBinaryExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BinaryExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isInterpreterDirective(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "InterpreterDirective") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDirective(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Directive") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDirectiveLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DirectiveLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBlockStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BlockStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBreakStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BreakStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isCallExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "CallExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isCatchClause(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "CatchClause") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isConditionalExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ConditionalExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isContinueStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ContinueStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDebuggerStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DebuggerStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDoWhileStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DoWhileStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEmptyStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EmptyStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExpressionStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExpressionStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFile(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "File") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isForInStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ForInStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isForStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ForStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunctionDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "FunctionDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunctionExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "FunctionExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isIdentifier2(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Identifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isIfStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "IfStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isLabeledStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "LabeledStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStringLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "StringLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNumericLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NumericLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNullLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NullLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBooleanLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BooleanLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isRegExpLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "RegExpLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isLogicalExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "LogicalExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isMemberExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "MemberExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNewExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NewExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isProgram(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Program") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectMethod(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectMethod") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isRestElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "RestElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isReturnStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ReturnStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSequenceExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SequenceExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isParenthesizedExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ParenthesizedExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSwitchCase(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SwitchCase") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSwitchStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SwitchStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isThisExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ThisExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isThrowStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ThrowStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTryStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TryStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isUnaryExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "UnaryExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isUpdateExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "UpdateExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isVariableDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "VariableDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isVariableDeclarator(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "VariableDeclarator") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isWhileStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "WhileStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isWithStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "WithStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isAssignmentPattern(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "AssignmentPattern") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isArrayPattern(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ArrayPattern") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isArrowFunctionExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ArrowFunctionExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportAllDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportAllDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportDefaultDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportDefaultDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportNamedDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportNamedDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isForOfStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ForOfStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImportDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ImportDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImportDefaultSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ImportDefaultSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImportNamespaceSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ImportNamespaceSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImportSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ImportSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isMetaProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "MetaProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassMethod(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassMethod") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectPattern(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectPattern") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSpreadElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SpreadElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSuper(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Super") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTaggedTemplateExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TaggedTemplateExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTemplateElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TemplateElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTemplateLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TemplateLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isYieldExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "YieldExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isAwaitExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "AwaitExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImport(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Import") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBigIntLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BigIntLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportNamespaceSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportNamespaceSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isOptionalMemberExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "OptionalMemberExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isOptionalCallExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "OptionalCallExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassAccessorProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassAccessorProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassPrivateProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassPrivateProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassPrivateMethod(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassPrivateMethod") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPrivateName(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "PrivateName") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStaticBlock(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "StaticBlock") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isAnyTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "AnyTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isArrayTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ArrayTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBooleanTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BooleanTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBooleanLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BooleanLiteralTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNullLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NullLiteralTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassImplements(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassImplements") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareClass(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareClass") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareFunction(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareFunction") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareInterface(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareInterface") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareModule(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareModule") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareModuleExports(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareModuleExports") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareTypeAlias(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareTypeAlias") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareOpaqueType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareOpaqueType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareVariable(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareVariable") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareExportDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareExportDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareExportAllDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareExportAllDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclaredPredicate(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclaredPredicate") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExistsTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExistsTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunctionTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "FunctionTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunctionTypeParam(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "FunctionTypeParam") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isGenericTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "GenericTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isInferredPredicate(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "InferredPredicate") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isInterfaceExtends(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "InterfaceExtends") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isInterfaceDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "InterfaceDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isInterfaceTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "InterfaceTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isIntersectionTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "IntersectionTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isMixedTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "MixedTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEmptyTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EmptyTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNullableTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NullableTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNumberLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NumberLiteralTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNumberTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NumberTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeInternalSlot(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeInternalSlot") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeCallProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeCallProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeIndexer(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeIndexer") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeSpreadProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeSpreadProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isOpaqueType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "OpaqueType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isQualifiedTypeIdentifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "QualifiedTypeIdentifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStringLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "StringLiteralTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStringTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "StringTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSymbolTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SymbolTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isThisTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ThisTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTupleTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TupleTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeofTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeofTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeAlias(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeAlias") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeCastExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeCastExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeParameter(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeParameter") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeParameterDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeParameterDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeParameterInstantiation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeParameterInstantiation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isUnionTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "UnionTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isVariance(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Variance") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isVoidTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "VoidTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumBooleanBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumBooleanBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumNumberBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumNumberBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumStringBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumStringBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumSymbolBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumSymbolBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumBooleanMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumBooleanMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumNumberMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumNumberMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumStringMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumStringMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumDefaultedMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumDefaultedMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isIndexedAccessType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "IndexedAccessType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isOptionalIndexedAccessType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "OptionalIndexedAccessType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXAttribute(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXAttribute") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXClosingElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXClosingElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXEmptyExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXEmptyExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXExpressionContainer(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXExpressionContainer") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXSpreadChild(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXSpreadChild") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXIdentifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXIdentifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXMemberExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXMemberExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXNamespacedName(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXNamespacedName") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXOpeningElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXOpeningElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXSpreadAttribute(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXSpreadAttribute") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXText(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXText") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXFragment(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXFragment") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXOpeningFragment(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXOpeningFragment") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXClosingFragment(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXClosingFragment") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNoop(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Noop") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPlaceholder(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Placeholder") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isV8IntrinsicIdentifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "V8IntrinsicIdentifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isArgumentPlaceholder(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ArgumentPlaceholder") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBindExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BindExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImportAttribute(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ImportAttribute") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDecorator(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Decorator") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDoExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DoExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportDefaultSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportDefaultSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isRecordExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "RecordExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTupleExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TupleExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDecimalLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DecimalLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isModuleExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ModuleExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTopicReference(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TopicReference") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPipelineTopicExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "PipelineTopicExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPipelineBareFunction(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "PipelineBareFunction") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPipelinePrimaryTopicReference(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "PipelinePrimaryTopicReference") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSParameterProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSParameterProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSDeclareFunction(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSDeclareFunction") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSDeclareMethod(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSDeclareMethod") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSQualifiedName(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSQualifiedName") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSCallSignatureDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSCallSignatureDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSConstructSignatureDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSConstructSignatureDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSPropertySignature(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSPropertySignature") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSMethodSignature(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSMethodSignature") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSIndexSignature(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSIndexSignature") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSAnyKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSAnyKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSBooleanKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSBooleanKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSBigIntKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSBigIntKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSIntrinsicKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSIntrinsicKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNeverKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNeverKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNullKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNullKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNumberKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNumberKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSObjectKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSObjectKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSStringKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSStringKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSSymbolKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSSymbolKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSUndefinedKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSUndefinedKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSUnknownKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSUnknownKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSVoidKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSVoidKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSThisType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSThisType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSFunctionType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSFunctionType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSConstructorType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSConstructorType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeReference(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeReference") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypePredicate(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypePredicate") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeQuery(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeQuery") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSArrayType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSArrayType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTupleType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTupleType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSOptionalType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSOptionalType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSRestType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSRestType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNamedTupleMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNamedTupleMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSUnionType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSUnionType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSIntersectionType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSIntersectionType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSConditionalType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSConditionalType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSInferType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSInferType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSParenthesizedType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSParenthesizedType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeOperator(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeOperator") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSIndexedAccessType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSIndexedAccessType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSMappedType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSMappedType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSLiteralType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSLiteralType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSExpressionWithTypeArguments(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSExpressionWithTypeArguments") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSInterfaceDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSInterfaceDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSInterfaceBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSInterfaceBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeAliasDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeAliasDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSInstantiationExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSInstantiationExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSAsExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSAsExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSSatisfiesExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSSatisfiesExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeAssertion(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeAssertion") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSEnumDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSEnumDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSEnumMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSEnumMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSModuleDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSModuleDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSModuleBlock(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSModuleBlock") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSImportType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSImportType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSImportEqualsDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSImportEqualsDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSExternalModuleReference(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSExternalModuleReference") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNonNullExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNonNullExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSExportAssignment(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSExportAssignment") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNamespaceExportDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNamespaceExportDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeParameterInstantiation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeParameterInstantiation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeParameterDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeParameterDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeParameter(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeParameter") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStandardized(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ArrayExpression" === nodeType || "AssignmentExpression" === nodeType || "BinaryExpression" === nodeType || "InterpreterDirective" === nodeType || "Directive" === nodeType || "DirectiveLiteral" === nodeType || "BlockStatement" === nodeType || "BreakStatement" === nodeType || "CallExpression" === nodeType || "CatchClause" === nodeType || "ConditionalExpression" === nodeType || "ContinueStatement" === nodeType || "DebuggerStatement" === nodeType || "DoWhileStatement" === nodeType || "EmptyStatement" === nodeType || "ExpressionStatement" === nodeType || "File" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "Identifier" === nodeType || "IfStatement" === nodeType || "LabeledStatement" === nodeType || "StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "RegExpLiteral" === nodeType || "LogicalExpression" === nodeType || "MemberExpression" === nodeType || "NewExpression" === nodeType || "Program" === nodeType || "ObjectExpression" === nodeType || "ObjectMethod" === nodeType || "ObjectProperty" === nodeType || "RestElement" === nodeType || "ReturnStatement" === nodeType || "SequenceExpression" === nodeType || "ParenthesizedExpression" === nodeType || "SwitchCase" === nodeType || "SwitchStatement" === nodeType || "ThisExpression" === nodeType || "ThrowStatement" === nodeType || "TryStatement" === nodeType || "UnaryExpression" === nodeType || "UpdateExpression" === nodeType || "VariableDeclaration" === nodeType || "VariableDeclarator" === nodeType || "WhileStatement" === nodeType || "WithStatement" === nodeType || "AssignmentPattern" === nodeType || "ArrayPattern" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassBody" === nodeType || "ClassExpression" === nodeType || "ClassDeclaration" === nodeType || "ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType || "ExportSpecifier" === nodeType || "ForOfStatement" === nodeType || "ImportDeclaration" === nodeType || "ImportDefaultSpecifier" === nodeType || "ImportNamespaceSpecifier" === nodeType || "ImportSpecifier" === nodeType || "MetaProperty" === nodeType || "ClassMethod" === nodeType || "ObjectPattern" === nodeType || "SpreadElement" === nodeType || "Super" === nodeType || "TaggedTemplateExpression" === nodeType || "TemplateElement" === nodeType || "TemplateLiteral" === nodeType || "YieldExpression" === nodeType || "AwaitExpression" === nodeType || "Import" === nodeType || "BigIntLiteral" === nodeType || "ExportNamespaceSpecifier" === nodeType || "OptionalMemberExpression" === nodeType || "OptionalCallExpression" === nodeType || "ClassProperty" === nodeType || "ClassAccessorProperty" === nodeType || "ClassPrivateProperty" === nodeType || "ClassPrivateMethod" === nodeType || "PrivateName" === nodeType || "StaticBlock" === nodeType || nodeType === "Placeholder" && ("Identifier" === node.expectedNode || "StringLiteral" === node.expectedNode || "BlockStatement" === node.expectedNode || "ClassBody" === node.expectedNode)) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ArrayExpression" === nodeType || "AssignmentExpression" === nodeType || "BinaryExpression" === nodeType || "CallExpression" === nodeType || "ConditionalExpression" === nodeType || "FunctionExpression" === nodeType || "Identifier" === nodeType || "StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "RegExpLiteral" === nodeType || "LogicalExpression" === nodeType || "MemberExpression" === nodeType || "NewExpression" === nodeType || "ObjectExpression" === nodeType || "SequenceExpression" === nodeType || "ParenthesizedExpression" === nodeType || "ThisExpression" === nodeType || "UnaryExpression" === nodeType || "UpdateExpression" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassExpression" === nodeType || "MetaProperty" === nodeType || "Super" === nodeType || "TaggedTemplateExpression" === nodeType || "TemplateLiteral" === nodeType || "YieldExpression" === nodeType || "AwaitExpression" === nodeType || "Import" === nodeType || "BigIntLiteral" === nodeType || "OptionalMemberExpression" === nodeType || "OptionalCallExpression" === nodeType || "TypeCastExpression" === nodeType || "JSXElement" === nodeType || "JSXFragment" === nodeType || "BindExpression" === nodeType || "DoExpression" === nodeType || "RecordExpression" === nodeType || "TupleExpression" === nodeType || "DecimalLiteral" === nodeType || "ModuleExpression" === nodeType || "TopicReference" === nodeType || "PipelineTopicExpression" === nodeType || "PipelineBareFunction" === nodeType || "PipelinePrimaryTopicReference" === nodeType || "TSInstantiationExpression" === nodeType || "TSAsExpression" === nodeType || "TSSatisfiesExpression" === nodeType || "TSTypeAssertion" === nodeType || "TSNonNullExpression" === nodeType || nodeType === "Placeholder" && ("Expression" === node.expectedNode || "Identifier" === node.expectedNode || "StringLiteral" === node.expectedNode)) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBinary(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BinaryExpression" === nodeType || "LogicalExpression" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isScopable(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BlockStatement" === nodeType || "CatchClause" === nodeType || "DoWhileStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "Program" === nodeType || "ObjectMethod" === nodeType || "SwitchStatement" === nodeType || "WhileStatement" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassExpression" === nodeType || "ClassDeclaration" === nodeType || "ForOfStatement" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType || "StaticBlock" === nodeType || "TSModuleBlock" === nodeType || nodeType === "Placeholder" && "BlockStatement" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBlockParent(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BlockStatement" === nodeType || "CatchClause" === nodeType || "DoWhileStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "Program" === nodeType || "ObjectMethod" === nodeType || "SwitchStatement" === nodeType || "WhileStatement" === nodeType || "ArrowFunctionExpression" === nodeType || "ForOfStatement" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType || "StaticBlock" === nodeType || "TSModuleBlock" === nodeType || nodeType === "Placeholder" && "BlockStatement" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBlock(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BlockStatement" === nodeType || "Program" === nodeType || "TSModuleBlock" === nodeType || nodeType === "Placeholder" && "BlockStatement" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BlockStatement" === nodeType || "BreakStatement" === nodeType || "ContinueStatement" === nodeType || "DebuggerStatement" === nodeType || "DoWhileStatement" === nodeType || "EmptyStatement" === nodeType || "ExpressionStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "FunctionDeclaration" === nodeType || "IfStatement" === nodeType || "LabeledStatement" === nodeType || "ReturnStatement" === nodeType || "SwitchStatement" === nodeType || "ThrowStatement" === nodeType || "TryStatement" === nodeType || "VariableDeclaration" === nodeType || "WhileStatement" === nodeType || "WithStatement" === nodeType || "ClassDeclaration" === nodeType || "ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType || "ForOfStatement" === nodeType || "ImportDeclaration" === nodeType || "DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "InterfaceDeclaration" === nodeType || "OpaqueType" === nodeType || "TypeAlias" === nodeType || "EnumDeclaration" === nodeType || "TSDeclareFunction" === nodeType || "TSInterfaceDeclaration" === nodeType || "TSTypeAliasDeclaration" === nodeType || "TSEnumDeclaration" === nodeType || "TSModuleDeclaration" === nodeType || "TSImportEqualsDeclaration" === nodeType || "TSExportAssignment" === nodeType || "TSNamespaceExportDeclaration" === nodeType || nodeType === "Placeholder" && ("Statement" === node.expectedNode || "Declaration" === node.expectedNode || "BlockStatement" === node.expectedNode)) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTerminatorless(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BreakStatement" === nodeType || "ContinueStatement" === nodeType || "ReturnStatement" === nodeType || "ThrowStatement" === nodeType || "YieldExpression" === nodeType || "AwaitExpression" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isCompletionStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BreakStatement" === nodeType || "ContinueStatement" === nodeType || "ReturnStatement" === nodeType || "ThrowStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isConditional(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ConditionalExpression" === nodeType || "IfStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isLoop(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("DoWhileStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "WhileStatement" === nodeType || "ForOfStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isWhile(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("DoWhileStatement" === nodeType || "WhileStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExpressionWrapper(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ExpressionStatement" === nodeType || "ParenthesizedExpression" === nodeType || "TypeCastExpression" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFor(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ForInStatement" === nodeType || "ForStatement" === nodeType || "ForOfStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isForXStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ForInStatement" === nodeType || "ForOfStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunction2(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "ObjectMethod" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunctionParent(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "ObjectMethod" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType || "StaticBlock" === nodeType || "TSModuleBlock" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPureish(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "RegExpLiteral" === nodeType || "ArrowFunctionExpression" === nodeType || "BigIntLiteral" === nodeType || "DecimalLiteral" === nodeType || nodeType === "Placeholder" && "StringLiteral" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("FunctionDeclaration" === nodeType || "VariableDeclaration" === nodeType || "ClassDeclaration" === nodeType || "ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType || "ImportDeclaration" === nodeType || "DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "InterfaceDeclaration" === nodeType || "OpaqueType" === nodeType || "TypeAlias" === nodeType || "EnumDeclaration" === nodeType || "TSDeclareFunction" === nodeType || "TSInterfaceDeclaration" === nodeType || "TSTypeAliasDeclaration" === nodeType || "TSEnumDeclaration" === nodeType || "TSModuleDeclaration" === nodeType || nodeType === "Placeholder" && "Declaration" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPatternLike(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("Identifier" === nodeType || "RestElement" === nodeType || "AssignmentPattern" === nodeType || "ArrayPattern" === nodeType || "ObjectPattern" === nodeType || "TSAsExpression" === nodeType || "TSSatisfiesExpression" === nodeType || "TSTypeAssertion" === nodeType || "TSNonNullExpression" === nodeType || nodeType === "Placeholder" && ("Pattern" === node.expectedNode || "Identifier" === node.expectedNode)) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isLVal(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("Identifier" === nodeType || "MemberExpression" === nodeType || "RestElement" === nodeType || "AssignmentPattern" === nodeType || "ArrayPattern" === nodeType || "ObjectPattern" === nodeType || "TSParameterProperty" === nodeType || "TSAsExpression" === nodeType || "TSSatisfiesExpression" === nodeType || "TSTypeAssertion" === nodeType || "TSNonNullExpression" === nodeType || nodeType === "Placeholder" && ("Pattern" === node.expectedNode || "Identifier" === node.expectedNode)) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSEntityName(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("Identifier" === nodeType || "TSQualifiedName" === nodeType || nodeType === "Placeholder" && "Identifier" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "RegExpLiteral" === nodeType || "TemplateLiteral" === nodeType || "BigIntLiteral" === nodeType || "DecimalLiteral" === nodeType || nodeType === "Placeholder" && "StringLiteral" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImmutable(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "BigIntLiteral" === nodeType || "JSXAttribute" === nodeType || "JSXClosingElement" === nodeType || "JSXElement" === nodeType || "JSXExpressionContainer" === nodeType || "JSXSpreadChild" === nodeType || "JSXOpeningElement" === nodeType || "JSXText" === nodeType || "JSXFragment" === nodeType || "JSXOpeningFragment" === nodeType || "JSXClosingFragment" === nodeType || "DecimalLiteral" === nodeType || nodeType === "Placeholder" && "StringLiteral" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isUserWhitespacable(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ObjectMethod" === nodeType || "ObjectProperty" === nodeType || "ObjectTypeInternalSlot" === nodeType || "ObjectTypeCallProperty" === nodeType || "ObjectTypeIndexer" === nodeType || "ObjectTypeProperty" === nodeType || "ObjectTypeSpreadProperty" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isMethod(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ObjectMethod" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ObjectMethod" === nodeType || "ObjectProperty" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ObjectProperty" === nodeType || "ClassProperty" === nodeType || "ClassAccessorProperty" === nodeType || "ClassPrivateProperty" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isUnaryLike(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("UnaryExpression" === nodeType || "SpreadElement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPattern(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("AssignmentPattern" === nodeType || "ArrayPattern" === nodeType || "ObjectPattern" === nodeType || nodeType === "Placeholder" && "Pattern" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClass(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ClassExpression" === nodeType || "ClassDeclaration" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isModuleDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType || "ImportDeclaration" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isModuleSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ExportSpecifier" === nodeType || "ImportDefaultSpecifier" === nodeType || "ImportNamespaceSpecifier" === nodeType || "ImportSpecifier" === nodeType || "ExportNamespaceSpecifier" === nodeType || "ExportDefaultSpecifier" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isAccessor(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ClassAccessorProperty" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPrivate(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ClassPrivateProperty" === nodeType || "ClassPrivateMethod" === nodeType || "PrivateName" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFlow(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("AnyTypeAnnotation" === nodeType || "ArrayTypeAnnotation" === nodeType || "BooleanTypeAnnotation" === nodeType || "BooleanLiteralTypeAnnotation" === nodeType || "NullLiteralTypeAnnotation" === nodeType || "ClassImplements" === nodeType || "DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "DeclaredPredicate" === nodeType || "ExistsTypeAnnotation" === nodeType || "FunctionTypeAnnotation" === nodeType || "FunctionTypeParam" === nodeType || "GenericTypeAnnotation" === nodeType || "InferredPredicate" === nodeType || "InterfaceExtends" === nodeType || "InterfaceDeclaration" === nodeType || "InterfaceTypeAnnotation" === nodeType || "IntersectionTypeAnnotation" === nodeType || "MixedTypeAnnotation" === nodeType || "EmptyTypeAnnotation" === nodeType || "NullableTypeAnnotation" === nodeType || "NumberLiteralTypeAnnotation" === nodeType || "NumberTypeAnnotation" === nodeType || "ObjectTypeAnnotation" === nodeType || "ObjectTypeInternalSlot" === nodeType || "ObjectTypeCallProperty" === nodeType || "ObjectTypeIndexer" === nodeType || "ObjectTypeProperty" === nodeType || "ObjectTypeSpreadProperty" === nodeType || "OpaqueType" === nodeType || "QualifiedTypeIdentifier" === nodeType || "StringLiteralTypeAnnotation" === nodeType || "StringTypeAnnotation" === nodeType || "SymbolTypeAnnotation" === nodeType || "ThisTypeAnnotation" === nodeType || "TupleTypeAnnotation" === nodeType || "TypeofTypeAnnotation" === nodeType || "TypeAlias" === nodeType || "TypeAnnotation" === nodeType || "TypeCastExpression" === nodeType || "TypeParameter" === nodeType || "TypeParameterDeclaration" === nodeType || "TypeParameterInstantiation" === nodeType || "UnionTypeAnnotation" === nodeType || "Variance" === nodeType || "VoidTypeAnnotation" === nodeType || "EnumDeclaration" === nodeType || "EnumBooleanBody" === nodeType || "EnumNumberBody" === nodeType || "EnumStringBody" === nodeType || "EnumSymbolBody" === nodeType || "EnumBooleanMember" === nodeType || "EnumNumberMember" === nodeType || "EnumStringMember" === nodeType || "EnumDefaultedMember" === nodeType || "IndexedAccessType" === nodeType || "OptionalIndexedAccessType" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFlowType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("AnyTypeAnnotation" === nodeType || "ArrayTypeAnnotation" === nodeType || "BooleanTypeAnnotation" === nodeType || "BooleanLiteralTypeAnnotation" === nodeType || "NullLiteralTypeAnnotation" === nodeType || "ExistsTypeAnnotation" === nodeType || "FunctionTypeAnnotation" === nodeType || "GenericTypeAnnotation" === nodeType || "InterfaceTypeAnnotation" === nodeType || "IntersectionTypeAnnotation" === nodeType || "MixedTypeAnnotation" === nodeType || "EmptyTypeAnnotation" === nodeType || "NullableTypeAnnotation" === nodeType || "NumberLiteralTypeAnnotation" === nodeType || "NumberTypeAnnotation" === nodeType || "ObjectTypeAnnotation" === nodeType || "StringLiteralTypeAnnotation" === nodeType || "StringTypeAnnotation" === nodeType || "SymbolTypeAnnotation" === nodeType || "ThisTypeAnnotation" === nodeType || "TupleTypeAnnotation" === nodeType || "TypeofTypeAnnotation" === nodeType || "UnionTypeAnnotation" === nodeType || "VoidTypeAnnotation" === nodeType || "IndexedAccessType" === nodeType || "OptionalIndexedAccessType" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFlowBaseAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("AnyTypeAnnotation" === nodeType || "BooleanTypeAnnotation" === nodeType || "NullLiteralTypeAnnotation" === nodeType || "MixedTypeAnnotation" === nodeType || "EmptyTypeAnnotation" === nodeType || "NumberTypeAnnotation" === nodeType || "StringTypeAnnotation" === nodeType || "SymbolTypeAnnotation" === nodeType || "ThisTypeAnnotation" === nodeType || "VoidTypeAnnotation" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFlowDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "InterfaceDeclaration" === nodeType || "OpaqueType" === nodeType || "TypeAlias" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFlowPredicate(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("DeclaredPredicate" === nodeType || "InferredPredicate" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("EnumBooleanBody" === nodeType || "EnumNumberBody" === nodeType || "EnumStringBody" === nodeType || "EnumSymbolBody" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("EnumBooleanMember" === nodeType || "EnumNumberMember" === nodeType || "EnumStringMember" === nodeType || "EnumDefaultedMember" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSX(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("JSXAttribute" === nodeType || "JSXClosingElement" === nodeType || "JSXElement" === nodeType || "JSXEmptyExpression" === nodeType || "JSXExpressionContainer" === nodeType || "JSXSpreadChild" === nodeType || "JSXIdentifier" === nodeType || "JSXMemberExpression" === nodeType || "JSXNamespacedName" === nodeType || "JSXOpeningElement" === nodeType || "JSXSpreadAttribute" === nodeType || "JSXText" === nodeType || "JSXFragment" === nodeType || "JSXOpeningFragment" === nodeType || "JSXClosingFragment" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isMiscellaneous(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("Noop" === nodeType || "Placeholder" === nodeType || "V8IntrinsicIdentifier" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeScript(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("TSParameterProperty" === nodeType || "TSDeclareFunction" === nodeType || "TSDeclareMethod" === nodeType || "TSQualifiedName" === nodeType || "TSCallSignatureDeclaration" === nodeType || "TSConstructSignatureDeclaration" === nodeType || "TSPropertySignature" === nodeType || "TSMethodSignature" === nodeType || "TSIndexSignature" === nodeType || "TSAnyKeyword" === nodeType || "TSBooleanKeyword" === nodeType || "TSBigIntKeyword" === nodeType || "TSIntrinsicKeyword" === nodeType || "TSNeverKeyword" === nodeType || "TSNullKeyword" === nodeType || "TSNumberKeyword" === nodeType || "TSObjectKeyword" === nodeType || "TSStringKeyword" === nodeType || "TSSymbolKeyword" === nodeType || "TSUndefinedKeyword" === nodeType || "TSUnknownKeyword" === nodeType || "TSVoidKeyword" === nodeType || "TSThisType" === nodeType || "TSFunctionType" === nodeType || "TSConstructorType" === nodeType || "TSTypeReference" === nodeType || "TSTypePredicate" === nodeType || "TSTypeQuery" === nodeType || "TSTypeLiteral" === nodeType || "TSArrayType" === nodeType || "TSTupleType" === nodeType || "TSOptionalType" === nodeType || "TSRestType" === nodeType || "TSNamedTupleMember" === nodeType || "TSUnionType" === nodeType || "TSIntersectionType" === nodeType || "TSConditionalType" === nodeType || "TSInferType" === nodeType || "TSParenthesizedType" === nodeType || "TSTypeOperator" === nodeType || "TSIndexedAccessType" === nodeType || "TSMappedType" === nodeType || "TSLiteralType" === nodeType || "TSExpressionWithTypeArguments" === nodeType || "TSInterfaceDeclaration" === nodeType || "TSInterfaceBody" === nodeType || "TSTypeAliasDeclaration" === nodeType || "TSInstantiationExpression" === nodeType || "TSAsExpression" === nodeType || "TSSatisfiesExpression" === nodeType || "TSTypeAssertion" === nodeType || "TSEnumDeclaration" === nodeType || "TSEnumMember" === nodeType || "TSModuleDeclaration" === nodeType || "TSModuleBlock" === nodeType || "TSImportType" === nodeType || "TSImportEqualsDeclaration" === nodeType || "TSExternalModuleReference" === nodeType || "TSNonNullExpression" === nodeType || "TSExportAssignment" === nodeType || "TSNamespaceExportDeclaration" === nodeType || "TSTypeAnnotation" === nodeType || "TSTypeParameterInstantiation" === nodeType || "TSTypeParameterDeclaration" === nodeType || "TSTypeParameter" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("TSCallSignatureDeclaration" === nodeType || "TSConstructSignatureDeclaration" === nodeType || "TSPropertySignature" === nodeType || "TSMethodSignature" === nodeType || "TSIndexSignature" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("TSAnyKeyword" === nodeType || "TSBooleanKeyword" === nodeType || "TSBigIntKeyword" === nodeType || "TSIntrinsicKeyword" === nodeType || "TSNeverKeyword" === nodeType || "TSNullKeyword" === nodeType || "TSNumberKeyword" === nodeType || "TSObjectKeyword" === nodeType || "TSStringKeyword" === nodeType || "TSSymbolKeyword" === nodeType || "TSUndefinedKeyword" === nodeType || "TSUnknownKeyword" === nodeType || "TSVoidKeyword" === nodeType || "TSThisType" === nodeType || "TSFunctionType" === nodeType || "TSConstructorType" === nodeType || "TSTypeReference" === nodeType || "TSTypePredicate" === nodeType || "TSTypeQuery" === nodeType || "TSTypeLiteral" === nodeType || "TSArrayType" === nodeType || "TSTupleType" === nodeType || "TSOptionalType" === nodeType || "TSRestType" === nodeType || "TSUnionType" === nodeType || "TSIntersectionType" === nodeType || "TSConditionalType" === nodeType || "TSInferType" === nodeType || "TSParenthesizedType" === nodeType || "TSTypeOperator" === nodeType || "TSIndexedAccessType" === nodeType || "TSMappedType" === nodeType || "TSLiteralType" === nodeType || "TSExpressionWithTypeArguments" === nodeType || "TSImportType" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSBaseType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("TSAnyKeyword" === nodeType || "TSBooleanKeyword" === nodeType || "TSBigIntKeyword" === nodeType || "TSIntrinsicKeyword" === nodeType || "TSNeverKeyword" === nodeType || "TSNullKeyword" === nodeType || "TSNumberKeyword" === nodeType || "TSObjectKeyword" === nodeType || "TSStringKeyword" === nodeType || "TSSymbolKeyword" === nodeType || "TSUndefinedKeyword" === nodeType || "TSUnknownKeyword" === nodeType || "TSVoidKeyword" === nodeType || "TSThisType" === nodeType || "TSLiteralType" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNumberLiteral(node, opts) {
        console.trace("The node type NumberLiteral has been renamed to NumericLiteral");
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NumberLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isRegexLiteral(node, opts) {
        console.trace("The node type RegexLiteral has been renamed to RegExpLiteral");
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "RegexLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isRestProperty(node, opts) {
        console.trace("The node type RestProperty has been renamed to RestElement");
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "RestProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSpreadProperty(node, opts) {
        console.trace("The node type SpreadProperty has been renamed to SpreadElement");
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SpreadProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/matchesPattern.js
  var require_matchesPattern = __commonJS({
    "node_modules/@babel/types/lib/validators/matchesPattern.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = matchesPattern;
      var _generated = require_generated();
      function matchesPattern(member, match, allowPartial) {
        if (!(0, _generated.isMemberExpression)(member))
          return false;
        const parts = Array.isArray(match) ? match : match.split(".");
        const nodes = [];
        let node;
        for (node = member; (0, _generated.isMemberExpression)(node); node = node.object) {
          nodes.push(node.property);
        }
        nodes.push(node);
        if (nodes.length < parts.length)
          return false;
        if (!allowPartial && nodes.length > parts.length)
          return false;
        for (let i = 0, j = nodes.length - 1; i < parts.length; i++, j--) {
          const node2 = nodes[j];
          let value;
          if ((0, _generated.isIdentifier)(node2)) {
            value = node2.name;
          } else if ((0, _generated.isStringLiteral)(node2)) {
            value = node2.value;
          } else if ((0, _generated.isThisExpression)(node2)) {
            value = "this";
          } else {
            return false;
          }
          if (parts[i] !== value)
            return false;
        }
        return true;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/buildMatchMemberExpression.js
  var require_buildMatchMemberExpression = __commonJS({
    "node_modules/@babel/types/lib/validators/buildMatchMemberExpression.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = buildMatchMemberExpression;
      var _matchesPattern = require_matchesPattern();
      function buildMatchMemberExpression(match, allowPartial) {
        const parts = match.split(".");
        return (member) => (0, _matchesPattern.default)(member, parts, allowPartial);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/react/isReactComponent.js
  var require_isReactComponent = __commonJS({
    "node_modules/@babel/types/lib/validators/react/isReactComponent.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _buildMatchMemberExpression = require_buildMatchMemberExpression();
      var isReactComponent = (0, _buildMatchMemberExpression.default)("React.Component");
      var _default = isReactComponent;
      exports2.default = _default;
    }
  });

  // node_modules/@babel/types/lib/validators/react/isCompatTag.js
  var require_isCompatTag = __commonJS({
    "node_modules/@babel/types/lib/validators/react/isCompatTag.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isCompatTag;
      function isCompatTag(tagName) {
        return !!tagName && /^[a-z]/.test(tagName);
      }
    }
  });

  // node_modules/to-fast-properties/index.js
  var require_to_fast_properties = __commonJS({
    "node_modules/to-fast-properties/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var fastProto = null;
      function FastObject(o) {
        if (fastProto !== null && typeof fastProto.property) {
          const result2 = fastProto;
          fastProto = FastObject.prototype = null;
          return result2;
        }
        fastProto = FastObject.prototype = o == null ? /* @__PURE__ */ Object.create(null) : o;
        return new FastObject();
      }
      FastObject();
      module2.exports = function toFastproperties(o) {
        return FastObject(o);
      };
    }
  });

  // node_modules/@babel/types/lib/validators/isType.js
  var require_isType = __commonJS({
    "node_modules/@babel/types/lib/validators/isType.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isType;
      var _definitions = require_definitions();
      function isType(nodeType, targetType) {
        if (nodeType === targetType)
          return true;
        if (_definitions.ALIAS_KEYS[targetType])
          return false;
        const aliases = _definitions.FLIPPED_ALIAS_KEYS[targetType];
        if (aliases) {
          if (aliases[0] === nodeType)
            return true;
          for (const alias of aliases) {
            if (nodeType === alias)
              return true;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isPlaceholderType.js
  var require_isPlaceholderType = __commonJS({
    "node_modules/@babel/types/lib/validators/isPlaceholderType.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isPlaceholderType;
      var _definitions = require_definitions();
      function isPlaceholderType(placeholderType, targetType) {
        if (placeholderType === targetType)
          return true;
        const aliases = _definitions.PLACEHOLDERS_ALIAS[placeholderType];
        if (aliases) {
          for (const alias of aliases) {
            if (targetType === alias)
              return true;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/is.js
  var require_is = __commonJS({
    "node_modules/@babel/types/lib/validators/is.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = is;
      var _shallowEqual = require_shallowEqual();
      var _isType = require_isType();
      var _isPlaceholderType = require_isPlaceholderType();
      var _definitions = require_definitions();
      function is(type, node, opts) {
        if (!node)
          return false;
        const matches2 = (0, _isType.default)(node.type, type);
        if (!matches2) {
          if (!opts && node.type === "Placeholder" && type in _definitions.FLIPPED_ALIAS_KEYS) {
            return (0, _isPlaceholderType.default)(node.expectedNode, type);
          }
          return false;
        }
        if (typeof opts === "undefined") {
          return true;
        } else {
          return (0, _shallowEqual.default)(node, opts);
        }
      }
    }
  });

  // node_modules/@babel/helper-validator-identifier/lib/identifier.js
  var require_identifier = __commonJS({
    "node_modules/@babel/helper-validator-identifier/lib/identifier.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.isIdentifierChar = isIdentifierChar;
      exports2.isIdentifierName = isIdentifierName;
      exports2.isIdentifierStart = isIdentifierStart;
      var nonASCIIidentifierStartChars = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
      var nonASCIIidentifierChars = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F";
      var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
      var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
      nonASCIIidentifierStartChars = nonASCIIidentifierChars = null;
      var astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938, 6, 4191];
      var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
      function isInAstralSet(code, set2) {
        let pos = 65536;
        for (let i = 0, length = set2.length; i < length; i += 2) {
          pos += set2[i];
          if (pos > code)
            return false;
          pos += set2[i + 1];
          if (pos >= code)
            return true;
        }
        return false;
      }
      function isIdentifierStart(code) {
        if (code < 65)
          return code === 36;
        if (code <= 90)
          return true;
        if (code < 97)
          return code === 95;
        if (code <= 122)
          return true;
        if (code <= 65535) {
          return code >= 170 && nonASCIIidentifierStart.test(String.fromCharCode(code));
        }
        return isInAstralSet(code, astralIdentifierStartCodes);
      }
      function isIdentifierChar(code) {
        if (code < 48)
          return code === 36;
        if (code < 58)
          return true;
        if (code < 65)
          return false;
        if (code <= 90)
          return true;
        if (code < 97)
          return code === 95;
        if (code <= 122)
          return true;
        if (code <= 65535) {
          return code >= 170 && nonASCIIidentifier.test(String.fromCharCode(code));
        }
        return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes);
      }
      function isIdentifierName(name) {
        let isFirst = true;
        for (let i = 0; i < name.length; i++) {
          let cp = name.charCodeAt(i);
          if ((cp & 64512) === 55296 && i + 1 < name.length) {
            const trail = name.charCodeAt(++i);
            if ((trail & 64512) === 56320) {
              cp = 65536 + ((cp & 1023) << 10) + (trail & 1023);
            }
          }
          if (isFirst) {
            isFirst = false;
            if (!isIdentifierStart(cp)) {
              return false;
            }
          } else if (!isIdentifierChar(cp)) {
            return false;
          }
        }
        return !isFirst;
      }
    }
  });

  // node_modules/@babel/helper-validator-identifier/lib/keyword.js
  var require_keyword = __commonJS({
    "node_modules/@babel/helper-validator-identifier/lib/keyword.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.isKeyword = isKeyword;
      exports2.isReservedWord = isReservedWord;
      exports2.isStrictBindOnlyReservedWord = isStrictBindOnlyReservedWord;
      exports2.isStrictBindReservedWord = isStrictBindReservedWord;
      exports2.isStrictReservedWord = isStrictReservedWord;
      var reservedWords = {
        keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"],
        strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"],
        strictBind: ["eval", "arguments"]
      };
      var keywords = new Set(reservedWords.keyword);
      var reservedWordsStrictSet = new Set(reservedWords.strict);
      var reservedWordsStrictBindSet = new Set(reservedWords.strictBind);
      function isReservedWord(word, inModule) {
        return inModule && word === "await" || word === "enum";
      }
      function isStrictReservedWord(word, inModule) {
        return isReservedWord(word, inModule) || reservedWordsStrictSet.has(word);
      }
      function isStrictBindOnlyReservedWord(word) {
        return reservedWordsStrictBindSet.has(word);
      }
      function isStrictBindReservedWord(word, inModule) {
        return isStrictReservedWord(word, inModule) || isStrictBindOnlyReservedWord(word);
      }
      function isKeyword(word) {
        return keywords.has(word);
      }
    }
  });

  // node_modules/@babel/helper-validator-identifier/lib/index.js
  var require_lib3 = __commonJS({
    "node_modules/@babel/helper-validator-identifier/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      Object.defineProperty(exports2, "isIdentifierChar", {
        enumerable: true,
        get: function() {
          return _identifier.isIdentifierChar;
        }
      });
      Object.defineProperty(exports2, "isIdentifierName", {
        enumerable: true,
        get: function() {
          return _identifier.isIdentifierName;
        }
      });
      Object.defineProperty(exports2, "isIdentifierStart", {
        enumerable: true,
        get: function() {
          return _identifier.isIdentifierStart;
        }
      });
      Object.defineProperty(exports2, "isKeyword", {
        enumerable: true,
        get: function() {
          return _keyword.isKeyword;
        }
      });
      Object.defineProperty(exports2, "isReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isReservedWord;
        }
      });
      Object.defineProperty(exports2, "isStrictBindOnlyReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isStrictBindOnlyReservedWord;
        }
      });
      Object.defineProperty(exports2, "isStrictBindReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isStrictBindReservedWord;
        }
      });
      Object.defineProperty(exports2, "isStrictReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isStrictReservedWord;
        }
      });
      var _identifier = require_identifier();
      var _keyword = require_keyword();
    }
  });

  // node_modules/@babel/types/lib/validators/isValidIdentifier.js
  var require_isValidIdentifier = __commonJS({
    "node_modules/@babel/types/lib/validators/isValidIdentifier.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isValidIdentifier2;
      var _helperValidatorIdentifier = require_lib3();
      function isValidIdentifier2(name, reserved = true) {
        if (typeof name !== "string")
          return false;
        if (reserved) {
          if ((0, _helperValidatorIdentifier.isKeyword)(name) || (0, _helperValidatorIdentifier.isStrictReservedWord)(name, true)) {
            return false;
          }
        }
        return (0, _helperValidatorIdentifier.isIdentifierName)(name);
      }
    }
  });

  // node_modules/@babel/helper-string-parser/lib/index.js
  var require_lib4 = __commonJS({
    "node_modules/@babel/helper-string-parser/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.readCodePoint = readCodePoint;
      exports2.readInt = readInt;
      exports2.readStringContents = readStringContents;
      var _isDigit = function isDigit(code) {
        return code >= 48 && code <= 57;
      };
      var forbiddenNumericSeparatorSiblings = {
        decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]),
        hex: /* @__PURE__ */ new Set([46, 88, 95, 120])
      };
      var isAllowedNumericSeparatorSibling = {
        bin: (ch) => ch === 48 || ch === 49,
        oct: (ch) => ch >= 48 && ch <= 55,
        dec: (ch) => ch >= 48 && ch <= 57,
        hex: (ch) => ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102
      };
      function readStringContents(type, input, pos, lineStart, curLine, errors) {
        const initialPos = pos;
        const initialLineStart = lineStart;
        const initialCurLine = curLine;
        let out = "";
        let firstInvalidLoc = null;
        let chunkStart = pos;
        const {
          length
        } = input;
        for (; ; ) {
          if (pos >= length) {
            errors.unterminated(initialPos, initialLineStart, initialCurLine);
            out += input.slice(chunkStart, pos);
            break;
          }
          const ch = input.charCodeAt(pos);
          if (isStringEnd(type, ch, input, pos)) {
            out += input.slice(chunkStart, pos);
            break;
          }
          if (ch === 92) {
            out += input.slice(chunkStart, pos);
            const res = readEscapedChar(input, pos, lineStart, curLine, type === "template", errors);
            if (res.ch === null && !firstInvalidLoc) {
              firstInvalidLoc = {
                pos,
                lineStart,
                curLine
              };
            } else {
              out += res.ch;
            }
            ({
              pos,
              lineStart,
              curLine
            } = res);
            chunkStart = pos;
          } else if (ch === 8232 || ch === 8233) {
            ++pos;
            ++curLine;
            lineStart = pos;
          } else if (ch === 10 || ch === 13) {
            if (type === "template") {
              out += input.slice(chunkStart, pos) + "\n";
              ++pos;
              if (ch === 13 && input.charCodeAt(pos) === 10) {
                ++pos;
              }
              ++curLine;
              chunkStart = lineStart = pos;
            } else {
              errors.unterminated(initialPos, initialLineStart, initialCurLine);
            }
          } else {
            ++pos;
          }
        }
        return {
          pos,
          str: out,
          firstInvalidLoc,
          lineStart,
          curLine,
          containsInvalid: !!firstInvalidLoc
        };
      }
      function isStringEnd(type, ch, input, pos) {
        if (type === "template") {
          return ch === 96 || ch === 36 && input.charCodeAt(pos + 1) === 123;
        }
        return ch === (type === "double" ? 34 : 39);
      }
      function readEscapedChar(input, pos, lineStart, curLine, inTemplate, errors) {
        const throwOnInvalid = !inTemplate;
        pos++;
        const res = (ch2) => ({
          pos,
          ch: ch2,
          lineStart,
          curLine
        });
        const ch = input.charCodeAt(pos++);
        switch (ch) {
          case 110:
            return res("\n");
          case 114:
            return res("\r");
          case 120: {
            let code;
            ({
              code,
              pos
            } = readHexChar(input, pos, lineStart, curLine, 2, false, throwOnInvalid, errors));
            return res(code === null ? null : String.fromCharCode(code));
          }
          case 117: {
            let code;
            ({
              code,
              pos
            } = readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors));
            return res(code === null ? null : String.fromCodePoint(code));
          }
          case 116:
            return res("	");
          case 98:
            return res("\b");
          case 118:
            return res("\v");
          case 102:
            return res("\f");
          case 13:
            if (input.charCodeAt(pos) === 10) {
              ++pos;
            }
          case 10:
            lineStart = pos;
            ++curLine;
          case 8232:
          case 8233:
            return res("");
          case 56:
          case 57:
            if (inTemplate) {
              return res(null);
            } else {
              errors.strictNumericEscape(pos - 1, lineStart, curLine);
            }
          default:
            if (ch >= 48 && ch <= 55) {
              const startPos = pos - 1;
              const match = input.slice(startPos, pos + 2).match(/^[0-7]+/);
              let octalStr = match[0];
              let octal = parseInt(octalStr, 8);
              if (octal > 255) {
                octalStr = octalStr.slice(0, -1);
                octal = parseInt(octalStr, 8);
              }
              pos += octalStr.length - 1;
              const next = input.charCodeAt(pos);
              if (octalStr !== "0" || next === 56 || next === 57) {
                if (inTemplate) {
                  return res(null);
                } else {
                  errors.strictNumericEscape(startPos, lineStart, curLine);
                }
              }
              return res(String.fromCharCode(octal));
            }
            return res(String.fromCharCode(ch));
        }
      }
      function readHexChar(input, pos, lineStart, curLine, len, forceLen, throwOnInvalid, errors) {
        const initialPos = pos;
        let n;
        ({
          n,
          pos
        } = readInt(input, pos, lineStart, curLine, 16, len, forceLen, false, errors, !throwOnInvalid));
        if (n === null) {
          if (throwOnInvalid) {
            errors.invalidEscapeSequence(initialPos, lineStart, curLine);
          } else {
            pos = initialPos - 1;
          }
        }
        return {
          code: n,
          pos
        };
      }
      function readInt(input, pos, lineStart, curLine, radix, len, forceLen, allowNumSeparator, errors, bailOnError) {
        const start = pos;
        const forbiddenSiblings = radix === 16 ? forbiddenNumericSeparatorSiblings.hex : forbiddenNumericSeparatorSiblings.decBinOct;
        const isAllowedSibling = radix === 16 ? isAllowedNumericSeparatorSibling.hex : radix === 10 ? isAllowedNumericSeparatorSibling.dec : radix === 8 ? isAllowedNumericSeparatorSibling.oct : isAllowedNumericSeparatorSibling.bin;
        let invalid = false;
        let total = 0;
        for (let i = 0, e = len == null ? Infinity : len; i < e; ++i) {
          const code = input.charCodeAt(pos);
          let val;
          if (code === 95 && allowNumSeparator !== "bail") {
            const prev = input.charCodeAt(pos - 1);
            const next = input.charCodeAt(pos + 1);
            if (!allowNumSeparator) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.numericSeparatorInEscapeSequence(pos, lineStart, curLine);
            } else if (Number.isNaN(next) || !isAllowedSibling(next) || forbiddenSiblings.has(prev) || forbiddenSiblings.has(next)) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.unexpectedNumericSeparator(pos, lineStart, curLine);
            }
            ++pos;
            continue;
          }
          if (code >= 97) {
            val = code - 97 + 10;
          } else if (code >= 65) {
            val = code - 65 + 10;
          } else if (_isDigit(code)) {
            val = code - 48;
          } else {
            val = Infinity;
          }
          if (val >= radix) {
            if (val <= 9 && bailOnError) {
              return {
                n: null,
                pos
              };
            } else if (val <= 9 && errors.invalidDigit(pos, lineStart, curLine, radix)) {
              val = 0;
            } else if (forceLen) {
              val = 0;
              invalid = true;
            } else {
              break;
            }
          }
          ++pos;
          total = total * radix + val;
        }
        if (pos === start || len != null && pos - start !== len || invalid) {
          return {
            n: null,
            pos
          };
        }
        return {
          n: total,
          pos
        };
      }
      function readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors) {
        const ch = input.charCodeAt(pos);
        let code;
        if (ch === 123) {
          ++pos;
          ({
            code,
            pos
          } = readHexChar(input, pos, lineStart, curLine, input.indexOf("}", pos) - pos, true, throwOnInvalid, errors));
          ++pos;
          if (code !== null && code > 1114111) {
            if (throwOnInvalid) {
              errors.invalidCodePoint(pos, lineStart, curLine);
            } else {
              return {
                code: null,
                pos
              };
            }
          }
        } else {
          ({
            code,
            pos
          } = readHexChar(input, pos, lineStart, curLine, 4, false, throwOnInvalid, errors));
        }
        return {
          code,
          pos
        };
      }
    }
  });

  // node_modules/@babel/types/lib/constants/index.js
  var require_constants = __commonJS({
    "node_modules/@babel/types/lib/constants/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.UPDATE_OPERATORS = exports2.UNARY_OPERATORS = exports2.STRING_UNARY_OPERATORS = exports2.STATEMENT_OR_BLOCK_KEYS = exports2.NUMBER_UNARY_OPERATORS = exports2.NUMBER_BINARY_OPERATORS = exports2.NOT_LOCAL_BINDING = exports2.LOGICAL_OPERATORS = exports2.INHERIT_KEYS = exports2.FOR_INIT_KEYS = exports2.FLATTENABLE_KEYS = exports2.EQUALITY_BINARY_OPERATORS = exports2.COMPARISON_BINARY_OPERATORS = exports2.COMMENT_KEYS = exports2.BOOLEAN_UNARY_OPERATORS = exports2.BOOLEAN_NUMBER_BINARY_OPERATORS = exports2.BOOLEAN_BINARY_OPERATORS = exports2.BLOCK_SCOPED_SYMBOL = exports2.BINARY_OPERATORS = exports2.ASSIGNMENT_OPERATORS = void 0;
      var STATEMENT_OR_BLOCK_KEYS = ["consequent", "body", "alternate"];
      exports2.STATEMENT_OR_BLOCK_KEYS = STATEMENT_OR_BLOCK_KEYS;
      var FLATTENABLE_KEYS = ["body", "expressions"];
      exports2.FLATTENABLE_KEYS = FLATTENABLE_KEYS;
      var FOR_INIT_KEYS = ["left", "init"];
      exports2.FOR_INIT_KEYS = FOR_INIT_KEYS;
      var COMMENT_KEYS = ["leadingComments", "trailingComments", "innerComments"];
      exports2.COMMENT_KEYS = COMMENT_KEYS;
      var LOGICAL_OPERATORS = ["||", "&&", "??"];
      exports2.LOGICAL_OPERATORS = LOGICAL_OPERATORS;
      var UPDATE_OPERATORS = ["++", "--"];
      exports2.UPDATE_OPERATORS = UPDATE_OPERATORS;
      var BOOLEAN_NUMBER_BINARY_OPERATORS = [">", "<", ">=", "<="];
      exports2.BOOLEAN_NUMBER_BINARY_OPERATORS = BOOLEAN_NUMBER_BINARY_OPERATORS;
      var EQUALITY_BINARY_OPERATORS = ["==", "===", "!=", "!=="];
      exports2.EQUALITY_BINARY_OPERATORS = EQUALITY_BINARY_OPERATORS;
      var COMPARISON_BINARY_OPERATORS = [...EQUALITY_BINARY_OPERATORS, "in", "instanceof"];
      exports2.COMPARISON_BINARY_OPERATORS = COMPARISON_BINARY_OPERATORS;
      var BOOLEAN_BINARY_OPERATORS = [...COMPARISON_BINARY_OPERATORS, ...BOOLEAN_NUMBER_BINARY_OPERATORS];
      exports2.BOOLEAN_BINARY_OPERATORS = BOOLEAN_BINARY_OPERATORS;
      var NUMBER_BINARY_OPERATORS = ["-", "/", "%", "*", "**", "&", "|", ">>", ">>>", "<<", "^"];
      exports2.NUMBER_BINARY_OPERATORS = NUMBER_BINARY_OPERATORS;
      var BINARY_OPERATORS = ["+", ...NUMBER_BINARY_OPERATORS, ...BOOLEAN_BINARY_OPERATORS, "|>"];
      exports2.BINARY_OPERATORS = BINARY_OPERATORS;
      var ASSIGNMENT_OPERATORS = ["=", "+=", ...NUMBER_BINARY_OPERATORS.map((op) => op + "="), ...LOGICAL_OPERATORS.map((op) => op + "=")];
      exports2.ASSIGNMENT_OPERATORS = ASSIGNMENT_OPERATORS;
      var BOOLEAN_UNARY_OPERATORS = ["delete", "!"];
      exports2.BOOLEAN_UNARY_OPERATORS = BOOLEAN_UNARY_OPERATORS;
      var NUMBER_UNARY_OPERATORS = ["+", "-", "~"];
      exports2.NUMBER_UNARY_OPERATORS = NUMBER_UNARY_OPERATORS;
      var STRING_UNARY_OPERATORS = ["typeof"];
      exports2.STRING_UNARY_OPERATORS = STRING_UNARY_OPERATORS;
      var UNARY_OPERATORS = ["void", "throw", ...BOOLEAN_UNARY_OPERATORS, ...NUMBER_UNARY_OPERATORS, ...STRING_UNARY_OPERATORS];
      exports2.UNARY_OPERATORS = UNARY_OPERATORS;
      var INHERIT_KEYS = {
        optional: ["typeAnnotation", "typeParameters", "returnType"],
        force: ["start", "loc", "end"]
      };
      exports2.INHERIT_KEYS = INHERIT_KEYS;
      var BLOCK_SCOPED_SYMBOL = Symbol.for("var used to be block scoped");
      exports2.BLOCK_SCOPED_SYMBOL = BLOCK_SCOPED_SYMBOL;
      var NOT_LOCAL_BINDING = Symbol.for("should not be considered a local binding");
      exports2.NOT_LOCAL_BINDING = NOT_LOCAL_BINDING;
    }
  });

  // node_modules/@babel/types/lib/definitions/utils.js
  var require_utils3 = __commonJS({
    "node_modules/@babel/types/lib/definitions/utils.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.VISITOR_KEYS = exports2.NODE_PARENT_VALIDATIONS = exports2.NODE_FIELDS = exports2.FLIPPED_ALIAS_KEYS = exports2.DEPRECATED_KEYS = exports2.BUILDER_KEYS = exports2.ALIAS_KEYS = void 0;
      exports2.arrayOf = arrayOf;
      exports2.arrayOfType = arrayOfType;
      exports2.assertEach = assertEach;
      exports2.assertNodeOrValueType = assertNodeOrValueType;
      exports2.assertNodeType = assertNodeType;
      exports2.assertOneOf = assertOneOf;
      exports2.assertOptionalChainStart = assertOptionalChainStart;
      exports2.assertShape = assertShape;
      exports2.assertValueType = assertValueType;
      exports2.chain = chain2;
      exports2.default = defineType;
      exports2.defineAliasedType = defineAliasedType;
      exports2.typeIs = typeIs;
      exports2.validate = validate;
      exports2.validateArrayOfType = validateArrayOfType;
      exports2.validateOptional = validateOptional;
      exports2.validateOptionalType = validateOptionalType;
      exports2.validateType = validateType;
      var _is = require_is();
      var _validate = require_validate();
      var VISITOR_KEYS = {};
      exports2.VISITOR_KEYS = VISITOR_KEYS;
      var ALIAS_KEYS = {};
      exports2.ALIAS_KEYS = ALIAS_KEYS;
      var FLIPPED_ALIAS_KEYS = {};
      exports2.FLIPPED_ALIAS_KEYS = FLIPPED_ALIAS_KEYS;
      var NODE_FIELDS = {};
      exports2.NODE_FIELDS = NODE_FIELDS;
      var BUILDER_KEYS = {};
      exports2.BUILDER_KEYS = BUILDER_KEYS;
      var DEPRECATED_KEYS = {};
      exports2.DEPRECATED_KEYS = DEPRECATED_KEYS;
      var NODE_PARENT_VALIDATIONS = {};
      exports2.NODE_PARENT_VALIDATIONS = NODE_PARENT_VALIDATIONS;
      function getType(val) {
        if (Array.isArray(val)) {
          return "array";
        } else if (val === null) {
          return "null";
        } else {
          return typeof val;
        }
      }
      function validate(validate2) {
        return {
          validate: validate2
        };
      }
      function typeIs(typeName) {
        return typeof typeName === "string" ? assertNodeType(typeName) : assertNodeType(...typeName);
      }
      function validateType(typeName) {
        return validate(typeIs(typeName));
      }
      function validateOptional(validate2) {
        return {
          validate: validate2,
          optional: true
        };
      }
      function validateOptionalType(typeName) {
        return {
          validate: typeIs(typeName),
          optional: true
        };
      }
      function arrayOf(elementType) {
        return chain2(assertValueType("array"), assertEach(elementType));
      }
      function arrayOfType(typeName) {
        return arrayOf(typeIs(typeName));
      }
      function validateArrayOfType(typeName) {
        return validate(arrayOfType(typeName));
      }
      function assertEach(callback) {
        function validator(node, key, val) {
          if (!Array.isArray(val))
            return;
          for (let i = 0; i < val.length; i++) {
            const subkey = `${key}[${i}]`;
            const v = val[i];
            callback(node, subkey, v);
            if (define_process_default.env.BABEL_TYPES_8_BREAKING)
              (0, _validate.validateChild)(node, subkey, v);
          }
        }
        validator.each = callback;
        return validator;
      }
      function assertOneOf(...values2) {
        function validate2(node, key, val) {
          if (values2.indexOf(val) < 0) {
            throw new TypeError(`Property ${key} expected value to be one of ${JSON.stringify(values2)} but got ${JSON.stringify(val)}`);
          }
        }
        validate2.oneOf = values2;
        return validate2;
      }
      function assertNodeType(...types) {
        function validate2(node, key, val) {
          for (const type of types) {
            if ((0, _is.default)(type, val)) {
              (0, _validate.validateChild)(node, key, val);
              return;
            }
          }
          throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types)} but instead got ${JSON.stringify(val == null ? void 0 : val.type)}`);
        }
        validate2.oneOfNodeTypes = types;
        return validate2;
      }
      function assertNodeOrValueType(...types) {
        function validate2(node, key, val) {
          for (const type of types) {
            if (getType(val) === type || (0, _is.default)(type, val)) {
              (0, _validate.validateChild)(node, key, val);
              return;
            }
          }
          throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types)} but instead got ${JSON.stringify(val == null ? void 0 : val.type)}`);
        }
        validate2.oneOfNodeOrValueTypes = types;
        return validate2;
      }
      function assertValueType(type) {
        function validate2(node, key, val) {
          const valid = getType(val) === type;
          if (!valid) {
            throw new TypeError(`Property ${key} expected type of ${type} but got ${getType(val)}`);
          }
        }
        validate2.type = type;
        return validate2;
      }
      function assertShape(shape) {
        function validate2(node, key, val) {
          const errors = [];
          for (const property2 of Object.keys(shape)) {
            try {
              (0, _validate.validateField)(node, property2, val[property2], shape[property2]);
            } catch (error) {
              if (error instanceof TypeError) {
                errors.push(error.message);
                continue;
              }
              throw error;
            }
          }
          if (errors.length) {
            throw new TypeError(`Property ${key} of ${node.type} expected to have the following:
${errors.join("\n")}`);
          }
        }
        validate2.shapeOf = shape;
        return validate2;
      }
      function assertOptionalChainStart() {
        function validate2(node) {
          var _current;
          let current = node;
          while (node) {
            const {
              type
            } = current;
            if (type === "OptionalCallExpression") {
              if (current.optional)
                return;
              current = current.callee;
              continue;
            }
            if (type === "OptionalMemberExpression") {
              if (current.optional)
                return;
              current = current.object;
              continue;
            }
            break;
          }
          throw new TypeError(`Non-optional ${node.type} must chain from an optional OptionalMemberExpression or OptionalCallExpression. Found chain from ${(_current = current) == null ? void 0 : _current.type}`);
        }
        return validate2;
      }
      function chain2(...fns) {
        function validate2(...args) {
          for (const fn of fns) {
            fn(...args);
          }
        }
        validate2.chainOf = fns;
        if (fns.length >= 2 && "type" in fns[0] && fns[0].type === "array" && !("each" in fns[1])) {
          throw new Error(`An assertValueType("array") validator can only be followed by an assertEach(...) validator.`);
        }
        return validate2;
      }
      var validTypeOpts = ["aliases", "builder", "deprecatedAlias", "fields", "inherits", "visitor", "validate"];
      var validFieldKeys = ["default", "optional", "validate"];
      var store = {};
      function defineAliasedType(...aliases) {
        return (type, opts = {}) => {
          let defined = opts.aliases;
          if (!defined) {
            var _store$opts$inherits$, _defined;
            if (opts.inherits)
              defined = (_store$opts$inherits$ = store[opts.inherits].aliases) == null ? void 0 : _store$opts$inherits$.slice();
            (_defined = defined) != null ? _defined : defined = [];
            opts.aliases = defined;
          }
          const additional = aliases.filter((a) => !defined.includes(a));
          defined.unshift(...additional);
          return defineType(type, opts);
        };
      }
      function defineType(type, opts = {}) {
        const inherits = opts.inherits && store[opts.inherits] || {};
        let fields = opts.fields;
        if (!fields) {
          fields = {};
          if (inherits.fields) {
            const keys2 = Object.getOwnPropertyNames(inherits.fields);
            for (const key of keys2) {
              const field = inherits.fields[key];
              const def = field.default;
              if (Array.isArray(def) ? def.length > 0 : def && typeof def === "object") {
                throw new Error("field defaults can only be primitives or empty arrays currently");
              }
              fields[key] = {
                default: Array.isArray(def) ? [] : def,
                optional: field.optional,
                validate: field.validate
              };
            }
          }
        }
        const visitor = opts.visitor || inherits.visitor || [];
        const aliases = opts.aliases || inherits.aliases || [];
        const builder = opts.builder || inherits.builder || opts.visitor || [];
        for (const k of Object.keys(opts)) {
          if (validTypeOpts.indexOf(k) === -1) {
            throw new Error(`Unknown type option "${k}" on ${type}`);
          }
        }
        if (opts.deprecatedAlias) {
          DEPRECATED_KEYS[opts.deprecatedAlias] = type;
        }
        for (const key of visitor.concat(builder)) {
          fields[key] = fields[key] || {};
        }
        for (const key of Object.keys(fields)) {
          const field = fields[key];
          if (field.default !== void 0 && builder.indexOf(key) === -1) {
            field.optional = true;
          }
          if (field.default === void 0) {
            field.default = null;
          } else if (!field.validate && field.default != null) {
            field.validate = assertValueType(getType(field.default));
          }
          for (const k of Object.keys(field)) {
            if (validFieldKeys.indexOf(k) === -1) {
              throw new Error(`Unknown field key "${k}" on ${type}.${key}`);
            }
          }
        }
        VISITOR_KEYS[type] = opts.visitor = visitor;
        BUILDER_KEYS[type] = opts.builder = builder;
        NODE_FIELDS[type] = opts.fields = fields;
        ALIAS_KEYS[type] = opts.aliases = aliases;
        aliases.forEach((alias) => {
          FLIPPED_ALIAS_KEYS[alias] = FLIPPED_ALIAS_KEYS[alias] || [];
          FLIPPED_ALIAS_KEYS[alias].push(type);
        });
        if (opts.validate) {
          NODE_PARENT_VALIDATIONS[type] = opts.validate;
        }
        store[type] = opts;
      }
    }
  });

  // node_modules/@babel/types/lib/definitions/core.js
  var require_core = __commonJS({
    "node_modules/@babel/types/lib/definitions/core.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.patternLikeCommon = exports2.functionTypeAnnotationCommon = exports2.functionDeclarationCommon = exports2.functionCommon = exports2.classMethodOrPropertyCommon = exports2.classMethodOrDeclareMethodCommon = void 0;
      var _is = require_is();
      var _isValidIdentifier = require_isValidIdentifier();
      var _helperValidatorIdentifier = require_lib3();
      var _helperStringParser = require_lib4();
      var _constants = require_constants();
      var _utils = require_utils3();
      var defineType = (0, _utils.defineAliasedType)("Standardized");
      defineType("ArrayExpression", {
        fields: {
          elements: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeOrValueType)("null", "Expression", "SpreadElement"))),
            default: !define_process_default.env.BABEL_TYPES_8_BREAKING ? [] : void 0
          }
        },
        visitor: ["elements"],
        aliases: ["Expression"]
      });
      defineType("AssignmentExpression", {
        fields: {
          operator: {
            validate: function() {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING) {
                return (0, _utils.assertValueType)("string");
              }
              const identifier3 = (0, _utils.assertOneOf)(..._constants.ASSIGNMENT_OPERATORS);
              const pattern = (0, _utils.assertOneOf)("=");
              return function(node, key, val) {
                const validator = (0, _is.default)("Pattern", node.left) ? pattern : identifier3;
                validator(node, key, val);
              };
            }()
          },
          left: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("LVal") : (0, _utils.assertNodeType)("Identifier", "MemberExpression", "ArrayPattern", "ObjectPattern", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        builder: ["operator", "left", "right"],
        visitor: ["left", "right"],
        aliases: ["Expression"]
      });
      defineType("BinaryExpression", {
        builder: ["operator", "left", "right"],
        fields: {
          operator: {
            validate: (0, _utils.assertOneOf)(..._constants.BINARY_OPERATORS)
          },
          left: {
            validate: function() {
              const expression = (0, _utils.assertNodeType)("Expression");
              const inOp = (0, _utils.assertNodeType)("Expression", "PrivateName");
              const validator = Object.assign(
                function(node, key, val) {
                  const validator2 = node.operator === "in" ? inOp : expression;
                  validator2(node, key, val);
                },
                {
                  oneOfNodeTypes: ["Expression", "PrivateName"]
                }
              );
              return validator;
            }()
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        visitor: ["left", "right"],
        aliases: ["Binary", "Expression"]
      });
      defineType("InterpreterDirective", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("Directive", {
        visitor: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertNodeType)("DirectiveLiteral")
          }
        }
      });
      defineType("DirectiveLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("BlockStatement", {
        builder: ["body", "directives"],
        visitor: ["directives", "body"],
        fields: {
          directives: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Directive"))),
            default: []
          },
          body: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Statement")))
          }
        },
        aliases: ["Scopable", "BlockParent", "Block", "Statement"]
      });
      defineType("BreakStatement", {
        visitor: ["label"],
        fields: {
          label: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          }
        },
        aliases: ["Statement", "Terminatorless", "CompletionStatement"]
      });
      defineType("CallExpression", {
        visitor: ["callee", "arguments", "typeParameters", "typeArguments"],
        builder: ["callee", "arguments"],
        aliases: ["Expression"],
        fields: Object.assign({
          callee: {
            validate: (0, _utils.assertNodeType)("Expression", "Super", "V8IntrinsicIdentifier")
          },
          arguments: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression", "SpreadElement", "JSXNamespacedName", "ArgumentPlaceholder")))
          }
        }, !define_process_default.env.BABEL_TYPES_8_BREAKING ? {
          optional: {
            validate: (0, _utils.assertOneOf)(true, false),
            optional: true
          }
        } : {}, {
          typeArguments: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation"),
            optional: true
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TSTypeParameterInstantiation"),
            optional: true
          }
        })
      });
      defineType("CatchClause", {
        visitor: ["param", "body"],
        fields: {
          param: {
            validate: (0, _utils.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        },
        aliases: ["Scopable", "BlockParent"]
      });
      defineType("ConditionalExpression", {
        visitor: ["test", "consequent", "alternate"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          consequent: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          alternate: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Expression", "Conditional"]
      });
      defineType("ContinueStatement", {
        visitor: ["label"],
        fields: {
          label: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          }
        },
        aliases: ["Statement", "Terminatorless", "CompletionStatement"]
      });
      defineType("DebuggerStatement", {
        aliases: ["Statement"]
      });
      defineType("DoWhileStatement", {
        visitor: ["test", "body"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        },
        aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"]
      });
      defineType("EmptyStatement", {
        aliases: ["Statement"]
      });
      defineType("ExpressionStatement", {
        visitor: ["expression"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Statement", "ExpressionWrapper"]
      });
      defineType("File", {
        builder: ["program", "comments", "tokens"],
        visitor: ["program"],
        fields: {
          program: {
            validate: (0, _utils.assertNodeType)("Program")
          },
          comments: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? Object.assign(() => {
            }, {
              each: {
                oneOfNodeTypes: ["CommentBlock", "CommentLine"]
              }
            }) : (0, _utils.assertEach)((0, _utils.assertNodeType)("CommentBlock", "CommentLine")),
            optional: true
          },
          tokens: {
            validate: (0, _utils.assertEach)(Object.assign(() => {
            }, {
              type: "any"
            })),
            optional: true
          }
        }
      });
      defineType("ForInStatement", {
        visitor: ["left", "right", "body"],
        aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
        fields: {
          left: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("VariableDeclaration", "LVal") : (0, _utils.assertNodeType)("VariableDeclaration", "Identifier", "MemberExpression", "ArrayPattern", "ObjectPattern", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("ForStatement", {
        visitor: ["init", "test", "update", "body"],
        aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop"],
        fields: {
          init: {
            validate: (0, _utils.assertNodeType)("VariableDeclaration", "Expression"),
            optional: true
          },
          test: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          update: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      var functionCommon = () => ({
        params: {
          validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Identifier", "Pattern", "RestElement")))
        },
        generator: {
          default: false
        },
        async: {
          default: false
        }
      });
      exports2.functionCommon = functionCommon;
      var functionTypeAnnotationCommon = () => ({
        returnType: {
          validate: (0, _utils.assertNodeType)(
            "TypeAnnotation",
            "TSTypeAnnotation",
            "Noop"
          ),
          optional: true
        },
        typeParameters: {
          validate: (0, _utils.assertNodeType)(
            "TypeParameterDeclaration",
            "TSTypeParameterDeclaration",
            "Noop"
          ),
          optional: true
        }
      });
      exports2.functionTypeAnnotationCommon = functionTypeAnnotationCommon;
      var functionDeclarationCommon = () => Object.assign({}, functionCommon(), {
        declare: {
          validate: (0, _utils.assertValueType)("boolean"),
          optional: true
        },
        id: {
          validate: (0, _utils.assertNodeType)("Identifier"),
          optional: true
        }
      });
      exports2.functionDeclarationCommon = functionDeclarationCommon;
      defineType("FunctionDeclaration", {
        builder: ["id", "params", "body", "generator", "async"],
        visitor: ["id", "params", "body", "returnType", "typeParameters"],
        fields: Object.assign({}, functionDeclarationCommon(), functionTypeAnnotationCommon(), {
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          },
          predicate: {
            validate: (0, _utils.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
          }
        }),
        aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Statement", "Pureish", "Declaration"],
        validate: function() {
          if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
            return () => {
            };
          const identifier3 = (0, _utils.assertNodeType)("Identifier");
          return function(parent2, key, node) {
            if (!(0, _is.default)("ExportDefaultDeclaration", parent2)) {
              identifier3(node, "id", node.id);
            }
          };
        }()
      });
      defineType("FunctionExpression", {
        inherits: "FunctionDeclaration",
        aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
        fields: Object.assign({}, functionCommon(), functionTypeAnnotationCommon(), {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          },
          predicate: {
            validate: (0, _utils.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
          }
        })
      });
      var patternLikeCommon = () => ({
        typeAnnotation: {
          validate: (0, _utils.assertNodeType)(
            "TypeAnnotation",
            "TSTypeAnnotation",
            "Noop"
          ),
          optional: true
        },
        decorators: {
          validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
          optional: true
        }
      });
      exports2.patternLikeCommon = patternLikeCommon;
      defineType("Identifier", {
        builder: ["name"],
        visitor: ["typeAnnotation", "decorators"],
        aliases: ["Expression", "PatternLike", "LVal", "TSEntityName"],
        fields: Object.assign({}, patternLikeCommon(), {
          name: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (!(0, _isValidIdentifier.default)(val, false)) {
                throw new TypeError(`"${val}" is not a valid identifier name`);
              }
            }, {
              type: "string"
            }))
          },
          optional: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        }),
        validate(parent2, key, node) {
          if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
            return;
          const match = /\.(\w+)$/.exec(key);
          if (!match)
            return;
          const [, parentKey] = match;
          const nonComp = {
            computed: false
          };
          if (parentKey === "property") {
            if ((0, _is.default)("MemberExpression", parent2, nonComp))
              return;
            if ((0, _is.default)("OptionalMemberExpression", parent2, nonComp))
              return;
          } else if (parentKey === "key") {
            if ((0, _is.default)("Property", parent2, nonComp))
              return;
            if ((0, _is.default)("Method", parent2, nonComp))
              return;
          } else if (parentKey === "exported") {
            if ((0, _is.default)("ExportSpecifier", parent2))
              return;
          } else if (parentKey === "imported") {
            if ((0, _is.default)("ImportSpecifier", parent2, {
              imported: node
            }))
              return;
          } else if (parentKey === "meta") {
            if ((0, _is.default)("MetaProperty", parent2, {
              meta: node
            }))
              return;
          }
          if (((0, _helperValidatorIdentifier.isKeyword)(node.name) || (0, _helperValidatorIdentifier.isReservedWord)(node.name, false)) && node.name !== "this") {
            throw new TypeError(`"${node.name}" is not a valid identifier`);
          }
        }
      });
      defineType("IfStatement", {
        visitor: ["test", "consequent", "alternate"],
        aliases: ["Statement", "Conditional"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          consequent: {
            validate: (0, _utils.assertNodeType)("Statement")
          },
          alternate: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("LabeledStatement", {
        visitor: ["label", "body"],
        aliases: ["Statement"],
        fields: {
          label: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("StringLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("NumericLiteral", {
        builder: ["value"],
        deprecatedAlias: "NumberLiteral",
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("number")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("NullLiteral", {
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("BooleanLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("boolean")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("RegExpLiteral", {
        builder: ["pattern", "flags"],
        deprecatedAlias: "RegexLiteral",
        aliases: ["Expression", "Pureish", "Literal"],
        fields: {
          pattern: {
            validate: (0, _utils.assertValueType)("string")
          },
          flags: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              const invalid = /[^gimsuy]/.exec(val);
              if (invalid) {
                throw new TypeError(`"${invalid[0]}" is not a valid RegExp flag`);
              }
            }, {
              type: "string"
            })),
            default: ""
          }
        }
      });
      defineType("LogicalExpression", {
        builder: ["operator", "left", "right"],
        visitor: ["left", "right"],
        aliases: ["Binary", "Expression"],
        fields: {
          operator: {
            validate: (0, _utils.assertOneOf)(..._constants.LOGICAL_OPERATORS)
          },
          left: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("MemberExpression", {
        builder: ["object", "property", "computed", ...!define_process_default.env.BABEL_TYPES_8_BREAKING ? ["optional"] : []],
        visitor: ["object", "property"],
        aliases: ["Expression", "LVal"],
        fields: Object.assign({
          object: {
            validate: (0, _utils.assertNodeType)("Expression", "Super")
          },
          property: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "PrivateName");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = function(node, key, val) {
                const validator2 = node.computed ? computed : normal;
                validator2(node, key, val);
              };
              validator.oneOfNodeTypes = ["Expression", "Identifier", "PrivateName"];
              return validator;
            }()
          },
          computed: {
            default: false
          }
        }, !define_process_default.env.BABEL_TYPES_8_BREAKING ? {
          optional: {
            validate: (0, _utils.assertOneOf)(true, false),
            optional: true
          }
        } : {})
      });
      defineType("NewExpression", {
        inherits: "CallExpression"
      });
      defineType("Program", {
        visitor: ["directives", "body"],
        builder: ["body", "directives", "sourceType", "interpreter"],
        fields: {
          sourceFile: {
            validate: (0, _utils.assertValueType)("string")
          },
          sourceType: {
            validate: (0, _utils.assertOneOf)("script", "module"),
            default: "script"
          },
          interpreter: {
            validate: (0, _utils.assertNodeType)("InterpreterDirective"),
            default: null,
            optional: true
          },
          directives: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Directive"))),
            default: []
          },
          body: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Statement")))
          }
        },
        aliases: ["Scopable", "BlockParent", "Block"]
      });
      defineType("ObjectExpression", {
        visitor: ["properties"],
        aliases: ["Expression"],
        fields: {
          properties: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ObjectMethod", "ObjectProperty", "SpreadElement")))
          }
        }
      });
      defineType("ObjectMethod", {
        builder: ["kind", "key", "params", "body", "computed", "generator", "async"],
        fields: Object.assign({}, functionCommon(), functionTypeAnnotationCommon(), {
          kind: Object.assign({
            validate: (0, _utils.assertOneOf)("method", "get", "set")
          }, !define_process_default.env.BABEL_TYPES_8_BREAKING ? {
            default: "method"
          } : {}),
          computed: {
            default: false
          },
          key: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = function(node, key, val) {
                const validator2 = node.computed ? computed : normal;
                validator2(node, key, val);
              };
              validator.oneOfNodeTypes = ["Expression", "Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral"];
              return validator;
            }()
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        }),
        visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
        aliases: ["UserWhitespacable", "Function", "Scopable", "BlockParent", "FunctionParent", "Method", "ObjectMember"]
      });
      defineType("ObjectProperty", {
        builder: ["key", "value", "computed", "shorthand", ...!define_process_default.env.BABEL_TYPES_8_BREAKING ? ["decorators"] : []],
        fields: {
          computed: {
            default: false
          },
          key: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "PrivateName");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = Object.assign(function(node, key, val) {
                const validator2 = node.computed ? computed : normal;
                validator2(node, key, val);
              }, {
                oneOfNodeTypes: ["Expression", "Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "PrivateName"]
              });
              return validator;
            }()
          },
          value: {
            validate: (0, _utils.assertNodeType)("Expression", "PatternLike")
          },
          shorthand: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("boolean"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (val && node.computed) {
                throw new TypeError("Property shorthand of ObjectProperty cannot be true if computed is true");
              }
            }, {
              type: "boolean"
            }), function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (val && !(0, _is.default)("Identifier", node.key)) {
                throw new TypeError("Property shorthand of ObjectProperty cannot be true if key is not an Identifier");
              }
            }),
            default: false
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          }
        },
        visitor: ["key", "value", "decorators"],
        aliases: ["UserWhitespacable", "Property", "ObjectMember"],
        validate: function() {
          const pattern = (0, _utils.assertNodeType)("Identifier", "Pattern", "TSAsExpression", "TSSatisfiesExpression", "TSNonNullExpression", "TSTypeAssertion");
          const expression = (0, _utils.assertNodeType)("Expression");
          return function(parent2, key, node) {
            if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
              return;
            const validator = (0, _is.default)("ObjectPattern", parent2) ? pattern : expression;
            validator(node, "value", node.value);
          };
        }()
      });
      defineType("RestElement", {
        visitor: ["argument", "typeAnnotation"],
        builder: ["argument"],
        aliases: ["LVal", "PatternLike"],
        deprecatedAlias: "RestProperty",
        fields: Object.assign({}, patternLikeCommon(), {
          argument: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("LVal") : (0, _utils.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern", "MemberExpression", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          },
          optional: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        }),
        validate(parent2, key) {
          if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
            return;
          const match = /(\w+)\[(\d+)\]/.exec(key);
          if (!match)
            throw new Error("Internal Babel error: malformed key.");
          const [, listKey, index] = match;
          if (parent2[listKey].length > +index + 1) {
            throw new TypeError(`RestElement must be last element of ${listKey}`);
          }
        }
      });
      defineType("ReturnStatement", {
        visitor: ["argument"],
        aliases: ["Statement", "Terminatorless", "CompletionStatement"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          }
        }
      });
      defineType("SequenceExpression", {
        visitor: ["expressions"],
        fields: {
          expressions: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression")))
          }
        },
        aliases: ["Expression"]
      });
      defineType("ParenthesizedExpression", {
        visitor: ["expression"],
        aliases: ["Expression", "ExpressionWrapper"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("SwitchCase", {
        visitor: ["test", "consequent"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          consequent: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Statement")))
          }
        }
      });
      defineType("SwitchStatement", {
        visitor: ["discriminant", "cases"],
        aliases: ["Statement", "BlockParent", "Scopable"],
        fields: {
          discriminant: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          cases: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("SwitchCase")))
          }
        }
      });
      defineType("ThisExpression", {
        aliases: ["Expression"]
      });
      defineType("ThrowStatement", {
        visitor: ["argument"],
        aliases: ["Statement", "Terminatorless", "CompletionStatement"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("TryStatement", {
        visitor: ["block", "handler", "finalizer"],
        aliases: ["Statement"],
        fields: {
          block: {
            validate: (0, _utils.chain)((0, _utils.assertNodeType)("BlockStatement"), Object.assign(function(node) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (!node.handler && !node.finalizer) {
                throw new TypeError("TryStatement expects either a handler or finalizer, or both");
              }
            }, {
              oneOfNodeTypes: ["BlockStatement"]
            }))
          },
          handler: {
            optional: true,
            validate: (0, _utils.assertNodeType)("CatchClause")
          },
          finalizer: {
            optional: true,
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        }
      });
      defineType("UnaryExpression", {
        builder: ["operator", "argument", "prefix"],
        fields: {
          prefix: {
            default: true
          },
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          operator: {
            validate: (0, _utils.assertOneOf)(..._constants.UNARY_OPERATORS)
          }
        },
        visitor: ["argument"],
        aliases: ["UnaryLike", "Expression"]
      });
      defineType("UpdateExpression", {
        builder: ["operator", "argument", "prefix"],
        fields: {
          prefix: {
            default: false
          },
          argument: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("Expression") : (0, _utils.assertNodeType)("Identifier", "MemberExpression")
          },
          operator: {
            validate: (0, _utils.assertOneOf)(..._constants.UPDATE_OPERATORS)
          }
        },
        visitor: ["argument"],
        aliases: ["Expression"]
      });
      defineType("VariableDeclaration", {
        builder: ["kind", "declarations"],
        visitor: ["declarations"],
        aliases: ["Statement", "Declaration"],
        fields: {
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          kind: {
            validate: (0, _utils.assertOneOf)(
              "var",
              "let",
              "const",
              "using"
            )
          },
          declarations: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("VariableDeclarator")))
          }
        },
        validate(parent2, key, node) {
          if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
            return;
          if (!(0, _is.default)("ForXStatement", parent2, {
            left: node
          }))
            return;
          if (node.declarations.length !== 1) {
            throw new TypeError(`Exactly one VariableDeclarator is required in the VariableDeclaration of a ${parent2.type}`);
          }
        }
      });
      defineType("VariableDeclarator", {
        visitor: ["id", "init"],
        fields: {
          id: {
            validate: function() {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING) {
                return (0, _utils.assertNodeType)("LVal");
              }
              const normal = (0, _utils.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern");
              const without2 = (0, _utils.assertNodeType)("Identifier");
              return function(node, key, val) {
                const validator = node.init ? normal : without2;
                validator(node, key, val);
              };
            }()
          },
          definite: {
            optional: true,
            validate: (0, _utils.assertValueType)("boolean")
          },
          init: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("WhileStatement", {
        visitor: ["test", "body"],
        aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("WithStatement", {
        visitor: ["object", "body"],
        aliases: ["Statement"],
        fields: {
          object: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("AssignmentPattern", {
        visitor: ["left", "right", "decorators"],
        builder: ["left", "right"],
        aliases: ["Pattern", "PatternLike", "LVal"],
        fields: Object.assign({}, patternLikeCommon(), {
          left: {
            validate: (0, _utils.assertNodeType)("Identifier", "ObjectPattern", "ArrayPattern", "MemberExpression", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          }
        })
      });
      defineType("ArrayPattern", {
        visitor: ["elements", "typeAnnotation"],
        builder: ["elements"],
        aliases: ["Pattern", "PatternLike", "LVal"],
        fields: Object.assign({}, patternLikeCommon(), {
          elements: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeOrValueType)("null", "PatternLike", "LVal")))
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          optional: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        })
      });
      defineType("ArrowFunctionExpression", {
        builder: ["params", "body", "async"],
        visitor: ["params", "body", "returnType", "typeParameters"],
        aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
        fields: Object.assign({}, functionCommon(), functionTypeAnnotationCommon(), {
          expression: {
            validate: (0, _utils.assertValueType)("boolean")
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement", "Expression")
          },
          predicate: {
            validate: (0, _utils.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
          }
        })
      });
      defineType("ClassBody", {
        visitor: ["body"],
        fields: {
          body: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ClassMethod", "ClassPrivateMethod", "ClassProperty", "ClassPrivateProperty", "ClassAccessorProperty", "TSDeclareMethod", "TSIndexSignature", "StaticBlock")))
          }
        }
      });
      defineType("ClassExpression", {
        builder: ["id", "superClass", "body", "decorators"],
        visitor: ["id", "body", "superClass", "mixins", "typeParameters", "superTypeParameters", "implements", "decorators"],
        aliases: ["Scopable", "Class", "Expression"],
        fields: {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)(
              "TypeParameterDeclaration",
              "TSTypeParameterDeclaration",
              "Noop"
            ),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("ClassBody")
          },
          superClass: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          },
          superTypeParameters: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
          },
          implements: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSExpressionWithTypeArguments", "ClassImplements"))),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          mixins: {
            validate: (0, _utils.assertNodeType)("InterfaceExtends"),
            optional: true
          }
        }
      });
      defineType("ClassDeclaration", {
        inherits: "ClassExpression",
        aliases: ["Scopable", "Class", "Statement", "Declaration"],
        fields: {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)(
              "TypeParameterDeclaration",
              "TSTypeParameterDeclaration",
              "Noop"
            ),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("ClassBody")
          },
          superClass: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          },
          superTypeParameters: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
          },
          implements: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSExpressionWithTypeArguments", "ClassImplements"))),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          mixins: {
            validate: (0, _utils.assertNodeType)("InterfaceExtends"),
            optional: true
          },
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          abstract: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        },
        validate: function() {
          const identifier3 = (0, _utils.assertNodeType)("Identifier");
          return function(parent2, key, node) {
            if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
              return;
            if (!(0, _is.default)("ExportDefaultDeclaration", parent2)) {
              identifier3(node, "id", node.id);
            }
          };
        }()
      });
      defineType("ExportAllDeclaration", {
        visitor: ["source"],
        aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
        fields: {
          source: {
            validate: (0, _utils.assertNodeType)("StringLiteral")
          },
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("type", "value")),
          assertions: {
            optional: true,
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ImportAttribute")))
          }
        }
      });
      defineType("ExportDefaultDeclaration", {
        visitor: ["declaration"],
        aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
        fields: {
          declaration: {
            validate: (0, _utils.assertNodeType)("TSDeclareFunction", "FunctionDeclaration", "ClassDeclaration", "Expression")
          },
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("value"))
        }
      });
      defineType("ExportNamedDeclaration", {
        visitor: ["declaration", "specifiers", "source"],
        aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
        fields: {
          declaration: {
            optional: true,
            validate: (0, _utils.chain)((0, _utils.assertNodeType)("Declaration"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (val && node.specifiers.length) {
                throw new TypeError("Only declaration or specifiers is allowed on ExportNamedDeclaration");
              }
            }, {
              oneOfNodeTypes: ["Declaration"]
            }), function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (val && node.source) {
                throw new TypeError("Cannot export a declaration from a source");
              }
            })
          },
          assertions: {
            optional: true,
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ImportAttribute")))
          },
          specifiers: {
            default: [],
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)(function() {
              const sourced = (0, _utils.assertNodeType)("ExportSpecifier", "ExportDefaultSpecifier", "ExportNamespaceSpecifier");
              const sourceless = (0, _utils.assertNodeType)("ExportSpecifier");
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return sourced;
              return function(node, key, val) {
                const validator = node.source ? sourced : sourceless;
                validator(node, key, val);
              };
            }()))
          },
          source: {
            validate: (0, _utils.assertNodeType)("StringLiteral"),
            optional: true
          },
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("type", "value"))
        }
      });
      defineType("ExportSpecifier", {
        visitor: ["local", "exported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          exported: {
            validate: (0, _utils.assertNodeType)("Identifier", "StringLiteral")
          },
          exportKind: {
            validate: (0, _utils.assertOneOf)("type", "value"),
            optional: true
          }
        }
      });
      defineType("ForOfStatement", {
        visitor: ["left", "right", "body"],
        builder: ["left", "right", "body", "await"],
        aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
        fields: {
          left: {
            validate: function() {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING) {
                return (0, _utils.assertNodeType)("VariableDeclaration", "LVal");
              }
              const declaration = (0, _utils.assertNodeType)("VariableDeclaration");
              const lval = (0, _utils.assertNodeType)("Identifier", "MemberExpression", "ArrayPattern", "ObjectPattern", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression");
              return function(node, key, val) {
                if ((0, _is.default)("VariableDeclaration", val)) {
                  declaration(node, key, val);
                } else {
                  lval(node, key, val);
                }
              };
            }()
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          },
          await: {
            default: false
          }
        }
      });
      defineType("ImportDeclaration", {
        visitor: ["specifiers", "source"],
        aliases: ["Statement", "Declaration", "ModuleDeclaration"],
        fields: {
          assertions: {
            optional: true,
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ImportAttribute")))
          },
          module: {
            optional: true,
            validate: (0, _utils.assertValueType)("boolean")
          },
          specifiers: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ImportSpecifier", "ImportDefaultSpecifier", "ImportNamespaceSpecifier")))
          },
          source: {
            validate: (0, _utils.assertNodeType)("StringLiteral")
          },
          importKind: {
            validate: (0, _utils.assertOneOf)("type", "typeof", "value"),
            optional: true
          }
        }
      });
      defineType("ImportDefaultSpecifier", {
        visitor: ["local"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("ImportNamespaceSpecifier", {
        visitor: ["local"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("ImportSpecifier", {
        visitor: ["local", "imported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          imported: {
            validate: (0, _utils.assertNodeType)("Identifier", "StringLiteral")
          },
          importKind: {
            validate: (0, _utils.assertOneOf)("type", "typeof", "value"),
            optional: true
          }
        }
      });
      defineType("MetaProperty", {
        visitor: ["meta", "property"],
        aliases: ["Expression"],
        fields: {
          meta: {
            validate: (0, _utils.chain)((0, _utils.assertNodeType)("Identifier"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              let property2;
              switch (val.name) {
                case "function":
                  property2 = "sent";
                  break;
                case "new":
                  property2 = "target";
                  break;
                case "import":
                  property2 = "meta";
                  break;
              }
              if (!(0, _is.default)("Identifier", node.property, {
                name: property2
              })) {
                throw new TypeError("Unrecognised MetaProperty");
              }
            }, {
              oneOfNodeTypes: ["Identifier"]
            }))
          },
          property: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      var classMethodOrPropertyCommon = () => ({
        abstract: {
          validate: (0, _utils.assertValueType)("boolean"),
          optional: true
        },
        accessibility: {
          validate: (0, _utils.assertOneOf)("public", "private", "protected"),
          optional: true
        },
        static: {
          default: false
        },
        override: {
          default: false
        },
        computed: {
          default: false
        },
        optional: {
          validate: (0, _utils.assertValueType)("boolean"),
          optional: true
        },
        key: {
          validate: (0, _utils.chain)(function() {
            const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral");
            const computed = (0, _utils.assertNodeType)("Expression");
            return function(node, key, val) {
              const validator = node.computed ? computed : normal;
              validator(node, key, val);
            };
          }(), (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "Expression"))
        }
      });
      exports2.classMethodOrPropertyCommon = classMethodOrPropertyCommon;
      var classMethodOrDeclareMethodCommon = () => Object.assign({}, functionCommon(), classMethodOrPropertyCommon(), {
        params: {
          validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Identifier", "Pattern", "RestElement", "TSParameterProperty")))
        },
        kind: {
          validate: (0, _utils.assertOneOf)("get", "set", "method", "constructor"),
          default: "method"
        },
        access: {
          validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), (0, _utils.assertOneOf)("public", "private", "protected")),
          optional: true
        },
        decorators: {
          validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
          optional: true
        }
      });
      exports2.classMethodOrDeclareMethodCommon = classMethodOrDeclareMethodCommon;
      defineType("ClassMethod", {
        aliases: ["Function", "Scopable", "BlockParent", "FunctionParent", "Method"],
        builder: ["kind", "key", "params", "body", "computed", "static", "generator", "async"],
        visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
        fields: Object.assign({}, classMethodOrDeclareMethodCommon(), functionTypeAnnotationCommon(), {
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        })
      });
      defineType("ObjectPattern", {
        visitor: ["properties", "typeAnnotation", "decorators"],
        builder: ["properties"],
        aliases: ["Pattern", "PatternLike", "LVal"],
        fields: Object.assign({}, patternLikeCommon(), {
          properties: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("RestElement", "ObjectProperty")))
          }
        })
      });
      defineType("SpreadElement", {
        visitor: ["argument"],
        aliases: ["UnaryLike"],
        deprecatedAlias: "SpreadProperty",
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("Super", {
        aliases: ["Expression"]
      });
      defineType("TaggedTemplateExpression", {
        visitor: ["tag", "quasi", "typeParameters"],
        builder: ["tag", "quasi"],
        aliases: ["Expression"],
        fields: {
          tag: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          quasi: {
            validate: (0, _utils.assertNodeType)("TemplateLiteral")
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
          }
        }
      });
      defineType("TemplateElement", {
        builder: ["value", "tail"],
        fields: {
          value: {
            validate: (0, _utils.chain)((0, _utils.assertShape)({
              raw: {
                validate: (0, _utils.assertValueType)("string")
              },
              cooked: {
                validate: (0, _utils.assertValueType)("string"),
                optional: true
              }
            }), function templateElementCookedValidator(node) {
              const raw = node.value.raw;
              let unterminatedCalled = false;
              const error = () => {
                throw new Error("Internal @babel/types error.");
              };
              const {
                str,
                firstInvalidLoc
              } = (0, _helperStringParser.readStringContents)("template", raw, 0, 0, 0, {
                unterminated() {
                  unterminatedCalled = true;
                },
                strictNumericEscape: error,
                invalidEscapeSequence: error,
                numericSeparatorInEscapeSequence: error,
                unexpectedNumericSeparator: error,
                invalidDigit: error,
                invalidCodePoint: error
              });
              if (!unterminatedCalled)
                throw new Error("Invalid raw");
              node.value.cooked = firstInvalidLoc ? null : str;
            })
          },
          tail: {
            default: false
          }
        }
      });
      defineType("TemplateLiteral", {
        visitor: ["quasis", "expressions"],
        aliases: ["Expression", "Literal"],
        fields: {
          quasis: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TemplateElement")))
          },
          expressions: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)(
              "Expression",
              "TSType"
            )), function(node, key, val) {
              if (node.quasis.length !== val.length + 1) {
                throw new TypeError(`Number of ${node.type} quasis should be exactly one more than the number of expressions.
Expected ${val.length + 1} quasis but got ${node.quasis.length}`);
              }
            })
          }
        }
      });
      defineType("YieldExpression", {
        builder: ["argument", "delegate"],
        visitor: ["argument"],
        aliases: ["Expression", "Terminatorless"],
        fields: {
          delegate: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("boolean"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (val && !node.argument) {
                throw new TypeError("Property delegate of YieldExpression cannot be true if there is no argument");
              }
            }, {
              type: "boolean"
            })),
            default: false
          },
          argument: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("AwaitExpression", {
        builder: ["argument"],
        visitor: ["argument"],
        aliases: ["Expression", "Terminatorless"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("Import", {
        aliases: ["Expression"]
      });
      defineType("BigIntLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("ExportNamespaceSpecifier", {
        visitor: ["exported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          exported: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("OptionalMemberExpression", {
        builder: ["object", "property", "computed", "optional"],
        visitor: ["object", "property"],
        aliases: ["Expression"],
        fields: {
          object: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          property: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = Object.assign(
                function(node, key, val) {
                  const validator2 = node.computed ? computed : normal;
                  validator2(node, key, val);
                },
                {
                  oneOfNodeTypes: ["Expression", "Identifier"]
                }
              );
              return validator;
            }()
          },
          computed: {
            default: false
          },
          optional: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertValueType)("boolean") : (0, _utils.chain)((0, _utils.assertValueType)("boolean"), (0, _utils.assertOptionalChainStart)())
          }
        }
      });
      defineType("OptionalCallExpression", {
        visitor: ["callee", "arguments", "typeParameters", "typeArguments"],
        builder: ["callee", "arguments", "optional"],
        aliases: ["Expression"],
        fields: {
          callee: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          arguments: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression", "SpreadElement", "JSXNamespacedName", "ArgumentPlaceholder")))
          },
          optional: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertValueType)("boolean") : (0, _utils.chain)((0, _utils.assertValueType)("boolean"), (0, _utils.assertOptionalChainStart)())
          },
          typeArguments: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation"),
            optional: true
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TSTypeParameterInstantiation"),
            optional: true
          }
        }
      });
      defineType("ClassProperty", {
        visitor: ["key", "value", "typeAnnotation", "decorators"],
        builder: ["key", "value", "typeAnnotation", "decorators", "computed", "static"],
        aliases: ["Property"],
        fields: Object.assign({}, classMethodOrPropertyCommon(), {
          value: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          definite: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)(
              "TypeAnnotation",
              "TSTypeAnnotation",
              "Noop"
            ),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          variance: {
            validate: (0, _utils.assertNodeType)("Variance"),
            optional: true
          }
        })
      });
      defineType("ClassAccessorProperty", {
        visitor: ["key", "value", "typeAnnotation", "decorators"],
        builder: ["key", "value", "typeAnnotation", "decorators", "computed", "static"],
        aliases: ["Property", "Accessor"],
        fields: Object.assign({}, classMethodOrPropertyCommon(), {
          key: {
            validate: (0, _utils.chain)(function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "PrivateName");
              const computed = (0, _utils.assertNodeType)("Expression");
              return function(node, key, val) {
                const validator = node.computed ? computed : normal;
                validator(node, key, val);
              };
            }(), (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "Expression", "PrivateName"))
          },
          value: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          definite: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)(
              "TypeAnnotation",
              "TSTypeAnnotation",
              "Noop"
            ),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          variance: {
            validate: (0, _utils.assertNodeType)("Variance"),
            optional: true
          }
        })
      });
      defineType("ClassPrivateProperty", {
        visitor: ["key", "value", "decorators", "typeAnnotation"],
        builder: ["key", "value", "decorators", "static"],
        aliases: ["Property", "Private"],
        fields: {
          key: {
            validate: (0, _utils.assertNodeType)("PrivateName")
          },
          value: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)(
              "TypeAnnotation",
              "TSTypeAnnotation",
              "Noop"
            ),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          static: {
            validate: (0, _utils.assertValueType)("boolean"),
            default: false
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          definite: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          variance: {
            validate: (0, _utils.assertNodeType)("Variance"),
            optional: true
          }
        }
      });
      defineType("ClassPrivateMethod", {
        builder: ["kind", "key", "params", "body", "static"],
        visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
        aliases: ["Function", "Scopable", "BlockParent", "FunctionParent", "Method", "Private"],
        fields: Object.assign({}, classMethodOrDeclareMethodCommon(), functionTypeAnnotationCommon(), {
          kind: {
            validate: (0, _utils.assertOneOf)("get", "set", "method"),
            default: "method"
          },
          key: {
            validate: (0, _utils.assertNodeType)("PrivateName")
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        })
      });
      defineType("PrivateName", {
        visitor: ["id"],
        aliases: ["Private"],
        fields: {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("StaticBlock", {
        visitor: ["body"],
        fields: {
          body: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Statement")))
          }
        },
        aliases: ["Scopable", "BlockParent", "FunctionParent"]
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/flow.js
  var require_flow = __commonJS({
    "node_modules/@babel/types/lib/definitions/flow.js"() {
      "use strict";
      init_define_process();
      var _utils = require_utils3();
      var defineType = (0, _utils.defineAliasedType)("Flow");
      var defineInterfaceishType = (name) => {
        defineType(name, {
          builder: ["id", "typeParameters", "extends", "body"],
          visitor: ["id", "typeParameters", "extends", "mixins", "implements", "body"],
          aliases: ["FlowDeclaration", "Statement", "Declaration"],
          fields: {
            id: (0, _utils.validateType)("Identifier"),
            typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
            extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends")),
            mixins: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends")),
            implements: (0, _utils.validateOptional)((0, _utils.arrayOfType)("ClassImplements")),
            body: (0, _utils.validateType)("ObjectTypeAnnotation")
          }
        });
      };
      defineType("AnyTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ArrayTypeAnnotation", {
        visitor: ["elementType"],
        aliases: ["FlowType"],
        fields: {
          elementType: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("BooleanTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("BooleanLiteralTypeAnnotation", {
        builder: ["value"],
        aliases: ["FlowType"],
        fields: {
          value: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("NullLiteralTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ClassImplements", {
        visitor: ["id", "typeParameters"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
        }
      });
      defineInterfaceishType("DeclareClass");
      defineType("DeclareFunction", {
        visitor: ["id"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          predicate: (0, _utils.validateOptionalType)("DeclaredPredicate")
        }
      });
      defineInterfaceishType("DeclareInterface");
      defineType("DeclareModule", {
        builder: ["id", "body", "kind"],
        visitor: ["id", "body"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
          body: (0, _utils.validateType)("BlockStatement"),
          kind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("CommonJS", "ES"))
        }
      });
      defineType("DeclareModuleExports", {
        visitor: ["typeAnnotation"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TypeAnnotation")
        }
      });
      defineType("DeclareTypeAlias", {
        visitor: ["id", "typeParameters", "right"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          right: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("DeclareOpaqueType", {
        visitor: ["id", "typeParameters", "supertype"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          supertype: (0, _utils.validateOptionalType)("FlowType"),
          impltype: (0, _utils.validateOptionalType)("FlowType")
        }
      });
      defineType("DeclareVariable", {
        visitor: ["id"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier")
        }
      });
      defineType("DeclareExportDeclaration", {
        visitor: ["declaration", "specifiers", "source"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          declaration: (0, _utils.validateOptionalType)("Flow"),
          specifiers: (0, _utils.validateOptional)((0, _utils.arrayOfType)(["ExportSpecifier", "ExportNamespaceSpecifier"])),
          source: (0, _utils.validateOptionalType)("StringLiteral"),
          default: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("DeclareExportAllDeclaration", {
        visitor: ["source"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          source: (0, _utils.validateType)("StringLiteral"),
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("type", "value"))
        }
      });
      defineType("DeclaredPredicate", {
        visitor: ["value"],
        aliases: ["FlowPredicate"],
        fields: {
          value: (0, _utils.validateType)("Flow")
        }
      });
      defineType("ExistsTypeAnnotation", {
        aliases: ["FlowType"]
      });
      defineType("FunctionTypeAnnotation", {
        visitor: ["typeParameters", "params", "rest", "returnType"],
        aliases: ["FlowType"],
        fields: {
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          params: (0, _utils.validate)((0, _utils.arrayOfType)("FunctionTypeParam")),
          rest: (0, _utils.validateOptionalType)("FunctionTypeParam"),
          this: (0, _utils.validateOptionalType)("FunctionTypeParam"),
          returnType: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("FunctionTypeParam", {
        visitor: ["name", "typeAnnotation"],
        fields: {
          name: (0, _utils.validateOptionalType)("Identifier"),
          typeAnnotation: (0, _utils.validateType)("FlowType"),
          optional: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("GenericTypeAnnotation", {
        visitor: ["id", "typeParameters"],
        aliases: ["FlowType"],
        fields: {
          id: (0, _utils.validateType)(["Identifier", "QualifiedTypeIdentifier"]),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
        }
      });
      defineType("InferredPredicate", {
        aliases: ["FlowPredicate"]
      });
      defineType("InterfaceExtends", {
        visitor: ["id", "typeParameters"],
        fields: {
          id: (0, _utils.validateType)(["Identifier", "QualifiedTypeIdentifier"]),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
        }
      });
      defineInterfaceishType("InterfaceDeclaration");
      defineType("InterfaceTypeAnnotation", {
        visitor: ["extends", "body"],
        aliases: ["FlowType"],
        fields: {
          extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends")),
          body: (0, _utils.validateType)("ObjectTypeAnnotation")
        }
      });
      defineType("IntersectionTypeAnnotation", {
        visitor: ["types"],
        aliases: ["FlowType"],
        fields: {
          types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("MixedTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("EmptyTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("NullableTypeAnnotation", {
        visitor: ["typeAnnotation"],
        aliases: ["FlowType"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("NumberLiteralTypeAnnotation", {
        builder: ["value"],
        aliases: ["FlowType"],
        fields: {
          value: (0, _utils.validate)((0, _utils.assertValueType)("number"))
        }
      });
      defineType("NumberTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ObjectTypeAnnotation", {
        visitor: ["properties", "indexers", "callProperties", "internalSlots"],
        aliases: ["FlowType"],
        builder: ["properties", "indexers", "callProperties", "internalSlots", "exact"],
        fields: {
          properties: (0, _utils.validate)((0, _utils.arrayOfType)(["ObjectTypeProperty", "ObjectTypeSpreadProperty"])),
          indexers: {
            validate: (0, _utils.arrayOfType)("ObjectTypeIndexer"),
            optional: true,
            default: []
          },
          callProperties: {
            validate: (0, _utils.arrayOfType)("ObjectTypeCallProperty"),
            optional: true,
            default: []
          },
          internalSlots: {
            validate: (0, _utils.arrayOfType)("ObjectTypeInternalSlot"),
            optional: true,
            default: []
          },
          exact: {
            validate: (0, _utils.assertValueType)("boolean"),
            default: false
          },
          inexact: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeInternalSlot", {
        visitor: ["id", "value", "optional", "static", "method"],
        aliases: ["UserWhitespacable"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          value: (0, _utils.validateType)("FlowType"),
          optional: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          method: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeCallProperty", {
        visitor: ["value"],
        aliases: ["UserWhitespacable"],
        fields: {
          value: (0, _utils.validateType)("FlowType"),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeIndexer", {
        visitor: ["id", "key", "value", "variance"],
        aliases: ["UserWhitespacable"],
        fields: {
          id: (0, _utils.validateOptionalType)("Identifier"),
          key: (0, _utils.validateType)("FlowType"),
          value: (0, _utils.validateType)("FlowType"),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          variance: (0, _utils.validateOptionalType)("Variance")
        }
      });
      defineType("ObjectTypeProperty", {
        visitor: ["key", "value", "variance"],
        aliases: ["UserWhitespacable"],
        fields: {
          key: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
          value: (0, _utils.validateType)("FlowType"),
          kind: (0, _utils.validate)((0, _utils.assertOneOf)("init", "get", "set")),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          proto: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          optional: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          variance: (0, _utils.validateOptionalType)("Variance"),
          method: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeSpreadProperty", {
        visitor: ["argument"],
        aliases: ["UserWhitespacable"],
        fields: {
          argument: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("OpaqueType", {
        visitor: ["id", "typeParameters", "supertype", "impltype"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          supertype: (0, _utils.validateOptionalType)("FlowType"),
          impltype: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("QualifiedTypeIdentifier", {
        visitor: ["id", "qualification"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          qualification: (0, _utils.validateType)(["Identifier", "QualifiedTypeIdentifier"])
        }
      });
      defineType("StringLiteralTypeAnnotation", {
        builder: ["value"],
        aliases: ["FlowType"],
        fields: {
          value: (0, _utils.validate)((0, _utils.assertValueType)("string"))
        }
      });
      defineType("StringTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("SymbolTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ThisTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("TupleTypeAnnotation", {
        visitor: ["types"],
        aliases: ["FlowType"],
        fields: {
          types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("TypeofTypeAnnotation", {
        visitor: ["argument"],
        aliases: ["FlowType"],
        fields: {
          argument: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("TypeAlias", {
        visitor: ["id", "typeParameters", "right"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          right: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("TypeAnnotation", {
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("TypeCastExpression", {
        visitor: ["expression", "typeAnnotation"],
        aliases: ["ExpressionWrapper", "Expression"],
        fields: {
          expression: (0, _utils.validateType)("Expression"),
          typeAnnotation: (0, _utils.validateType)("TypeAnnotation")
        }
      });
      defineType("TypeParameter", {
        visitor: ["bound", "default", "variance"],
        fields: {
          name: (0, _utils.validate)((0, _utils.assertValueType)("string")),
          bound: (0, _utils.validateOptionalType)("TypeAnnotation"),
          default: (0, _utils.validateOptionalType)("FlowType"),
          variance: (0, _utils.validateOptionalType)("Variance")
        }
      });
      defineType("TypeParameterDeclaration", {
        visitor: ["params"],
        fields: {
          params: (0, _utils.validate)((0, _utils.arrayOfType)("TypeParameter"))
        }
      });
      defineType("TypeParameterInstantiation", {
        visitor: ["params"],
        fields: {
          params: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("UnionTypeAnnotation", {
        visitor: ["types"],
        aliases: ["FlowType"],
        fields: {
          types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("Variance", {
        builder: ["kind"],
        fields: {
          kind: (0, _utils.validate)((0, _utils.assertOneOf)("minus", "plus"))
        }
      });
      defineType("VoidTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("EnumDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "body"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          body: (0, _utils.validateType)(["EnumBooleanBody", "EnumNumberBody", "EnumStringBody", "EnumSymbolBody"])
        }
      });
      defineType("EnumBooleanBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          explicitType: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          members: (0, _utils.validateArrayOfType)("EnumBooleanMember"),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumNumberBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          explicitType: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          members: (0, _utils.validateArrayOfType)("EnumNumberMember"),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumStringBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          explicitType: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          members: (0, _utils.validateArrayOfType)(["EnumStringMember", "EnumDefaultedMember"]),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumSymbolBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          members: (0, _utils.validateArrayOfType)("EnumDefaultedMember"),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumBooleanMember", {
        aliases: ["EnumMember"],
        visitor: ["id"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          init: (0, _utils.validateType)("BooleanLiteral")
        }
      });
      defineType("EnumNumberMember", {
        aliases: ["EnumMember"],
        visitor: ["id", "init"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          init: (0, _utils.validateType)("NumericLiteral")
        }
      });
      defineType("EnumStringMember", {
        aliases: ["EnumMember"],
        visitor: ["id", "init"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          init: (0, _utils.validateType)("StringLiteral")
        }
      });
      defineType("EnumDefaultedMember", {
        aliases: ["EnumMember"],
        visitor: ["id"],
        fields: {
          id: (0, _utils.validateType)("Identifier")
        }
      });
      defineType("IndexedAccessType", {
        visitor: ["objectType", "indexType"],
        aliases: ["FlowType"],
        fields: {
          objectType: (0, _utils.validateType)("FlowType"),
          indexType: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("OptionalIndexedAccessType", {
        visitor: ["objectType", "indexType"],
        aliases: ["FlowType"],
        fields: {
          objectType: (0, _utils.validateType)("FlowType"),
          indexType: (0, _utils.validateType)("FlowType"),
          optional: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/jsx.js
  var require_jsx = __commonJS({
    "node_modules/@babel/types/lib/definitions/jsx.js"() {
      "use strict";
      init_define_process();
      var _utils = require_utils3();
      var defineType = (0, _utils.defineAliasedType)("JSX");
      defineType("JSXAttribute", {
        visitor: ["name", "value"],
        aliases: ["Immutable"],
        fields: {
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXNamespacedName")
          },
          value: {
            optional: true,
            validate: (0, _utils.assertNodeType)("JSXElement", "JSXFragment", "StringLiteral", "JSXExpressionContainer")
          }
        }
      });
      defineType("JSXClosingElement", {
        visitor: ["name"],
        aliases: ["Immutable"],
        fields: {
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXMemberExpression", "JSXNamespacedName")
          }
        }
      });
      defineType("JSXElement", {
        builder: ["openingElement", "closingElement", "children", "selfClosing"],
        visitor: ["openingElement", "children", "closingElement"],
        aliases: ["Immutable", "Expression"],
        fields: Object.assign({
          openingElement: {
            validate: (0, _utils.assertNodeType)("JSXOpeningElement")
          },
          closingElement: {
            optional: true,
            validate: (0, _utils.assertNodeType)("JSXClosingElement")
          },
          children: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement", "JSXFragment")))
          }
        }, {
          selfClosing: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        })
      });
      defineType("JSXEmptyExpression", {});
      defineType("JSXExpressionContainer", {
        visitor: ["expression"],
        aliases: ["Immutable"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression", "JSXEmptyExpression")
          }
        }
      });
      defineType("JSXSpreadChild", {
        visitor: ["expression"],
        aliases: ["Immutable"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("JSXIdentifier", {
        builder: ["name"],
        fields: {
          name: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("JSXMemberExpression", {
        visitor: ["object", "property"],
        fields: {
          object: {
            validate: (0, _utils.assertNodeType)("JSXMemberExpression", "JSXIdentifier")
          },
          property: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier")
          }
        }
      });
      defineType("JSXNamespacedName", {
        visitor: ["namespace", "name"],
        fields: {
          namespace: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier")
          },
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier")
          }
        }
      });
      defineType("JSXOpeningElement", {
        builder: ["name", "attributes", "selfClosing"],
        visitor: ["name", "attributes"],
        aliases: ["Immutable"],
        fields: {
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXMemberExpression", "JSXNamespacedName")
          },
          selfClosing: {
            default: false
          },
          attributes: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("JSXAttribute", "JSXSpreadAttribute")))
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
          }
        }
      });
      defineType("JSXSpreadAttribute", {
        visitor: ["argument"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("JSXText", {
        aliases: ["Immutable"],
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("JSXFragment", {
        builder: ["openingFragment", "closingFragment", "children"],
        visitor: ["openingFragment", "children", "closingFragment"],
        aliases: ["Immutable", "Expression"],
        fields: {
          openingFragment: {
            validate: (0, _utils.assertNodeType)("JSXOpeningFragment")
          },
          closingFragment: {
            validate: (0, _utils.assertNodeType)("JSXClosingFragment")
          },
          children: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement", "JSXFragment")))
          }
        }
      });
      defineType("JSXOpeningFragment", {
        aliases: ["Immutable"]
      });
      defineType("JSXClosingFragment", {
        aliases: ["Immutable"]
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/placeholders.js
  var require_placeholders = __commonJS({
    "node_modules/@babel/types/lib/definitions/placeholders.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.PLACEHOLDERS_FLIPPED_ALIAS = exports2.PLACEHOLDERS_ALIAS = exports2.PLACEHOLDERS = void 0;
      var _utils = require_utils3();
      var PLACEHOLDERS = ["Identifier", "StringLiteral", "Expression", "Statement", "Declaration", "BlockStatement", "ClassBody", "Pattern"];
      exports2.PLACEHOLDERS = PLACEHOLDERS;
      var PLACEHOLDERS_ALIAS = {
        Declaration: ["Statement"],
        Pattern: ["PatternLike", "LVal"]
      };
      exports2.PLACEHOLDERS_ALIAS = PLACEHOLDERS_ALIAS;
      for (const type of PLACEHOLDERS) {
        const alias = _utils.ALIAS_KEYS[type];
        if (alias != null && alias.length)
          PLACEHOLDERS_ALIAS[type] = alias;
      }
      var PLACEHOLDERS_FLIPPED_ALIAS = {};
      exports2.PLACEHOLDERS_FLIPPED_ALIAS = PLACEHOLDERS_FLIPPED_ALIAS;
      Object.keys(PLACEHOLDERS_ALIAS).forEach((type) => {
        PLACEHOLDERS_ALIAS[type].forEach((alias) => {
          if (!Object.hasOwnProperty.call(PLACEHOLDERS_FLIPPED_ALIAS, alias)) {
            PLACEHOLDERS_FLIPPED_ALIAS[alias] = [];
          }
          PLACEHOLDERS_FLIPPED_ALIAS[alias].push(type);
        });
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/misc.js
  var require_misc = __commonJS({
    "node_modules/@babel/types/lib/definitions/misc.js"() {
      "use strict";
      init_define_process();
      var _utils = require_utils3();
      var _placeholders = require_placeholders();
      var defineType = (0, _utils.defineAliasedType)("Miscellaneous");
      {
        defineType("Noop", {
          visitor: []
        });
      }
      defineType("Placeholder", {
        visitor: [],
        builder: ["expectedNode", "name"],
        fields: {
          name: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          expectedNode: {
            validate: (0, _utils.assertOneOf)(..._placeholders.PLACEHOLDERS)
          }
        }
      });
      defineType("V8IntrinsicIdentifier", {
        builder: ["name"],
        fields: {
          name: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/experimental.js
  var require_experimental = __commonJS({
    "node_modules/@babel/types/lib/definitions/experimental.js"() {
      "use strict";
      init_define_process();
      var _utils = require_utils3();
      (0, _utils.default)("ArgumentPlaceholder", {});
      (0, _utils.default)("BindExpression", {
        visitor: ["object", "callee"],
        aliases: ["Expression"],
        fields: !define_process_default.env.BABEL_TYPES_8_BREAKING ? {
          object: {
            validate: Object.assign(() => {
            }, {
              oneOfNodeTypes: ["Expression"]
            })
          },
          callee: {
            validate: Object.assign(() => {
            }, {
              oneOfNodeTypes: ["Expression"]
            })
          }
        } : {
          object: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          callee: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      (0, _utils.default)("ImportAttribute", {
        visitor: ["key", "value"],
        fields: {
          key: {
            validate: (0, _utils.assertNodeType)("Identifier", "StringLiteral")
          },
          value: {
            validate: (0, _utils.assertNodeType)("StringLiteral")
          }
        }
      });
      (0, _utils.default)("Decorator", {
        visitor: ["expression"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      (0, _utils.default)("DoExpression", {
        visitor: ["body"],
        builder: ["body", "async"],
        aliases: ["Expression"],
        fields: {
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          },
          async: {
            validate: (0, _utils.assertValueType)("boolean"),
            default: false
          }
        }
      });
      (0, _utils.default)("ExportDefaultSpecifier", {
        visitor: ["exported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          exported: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      (0, _utils.default)("RecordExpression", {
        visitor: ["properties"],
        aliases: ["Expression"],
        fields: {
          properties: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ObjectProperty", "SpreadElement")))
          }
        }
      });
      (0, _utils.default)("TupleExpression", {
        fields: {
          elements: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression", "SpreadElement"))),
            default: []
          }
        },
        visitor: ["elements"],
        aliases: ["Expression"]
      });
      (0, _utils.default)("DecimalLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      (0, _utils.default)("ModuleExpression", {
        visitor: ["body"],
        fields: {
          body: {
            validate: (0, _utils.assertNodeType)("Program")
          }
        },
        aliases: ["Expression"]
      });
      (0, _utils.default)("TopicReference", {
        aliases: ["Expression"]
      });
      (0, _utils.default)("PipelineTopicExpression", {
        builder: ["expression"],
        visitor: ["expression"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Expression"]
      });
      (0, _utils.default)("PipelineBareFunction", {
        builder: ["callee"],
        visitor: ["callee"],
        fields: {
          callee: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Expression"]
      });
      (0, _utils.default)("PipelinePrimaryTopicReference", {
        aliases: ["Expression"]
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/typescript.js
  var require_typescript = __commonJS({
    "node_modules/@babel/types/lib/definitions/typescript.js"() {
      "use strict";
      init_define_process();
      var _utils = require_utils3();
      var _core = require_core();
      var _is = require_is();
      var defineType = (0, _utils.defineAliasedType)("TypeScript");
      var bool = (0, _utils.assertValueType)("boolean");
      var tSFunctionTypeAnnotationCommon = () => ({
        returnType: {
          validate: (0, _utils.assertNodeType)("TSTypeAnnotation", "Noop"),
          optional: true
        },
        typeParameters: {
          validate: (0, _utils.assertNodeType)("TSTypeParameterDeclaration", "Noop"),
          optional: true
        }
      });
      defineType("TSParameterProperty", {
        aliases: ["LVal"],
        visitor: ["parameter"],
        fields: {
          accessibility: {
            validate: (0, _utils.assertOneOf)("public", "private", "protected"),
            optional: true
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          parameter: {
            validate: (0, _utils.assertNodeType)("Identifier", "AssignmentPattern")
          },
          override: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          }
        }
      });
      defineType("TSDeclareFunction", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "typeParameters", "params", "returnType"],
        fields: Object.assign({}, (0, _core.functionDeclarationCommon)(), tSFunctionTypeAnnotationCommon())
      });
      defineType("TSDeclareMethod", {
        visitor: ["decorators", "key", "typeParameters", "params", "returnType"],
        fields: Object.assign({}, (0, _core.classMethodOrDeclareMethodCommon)(), tSFunctionTypeAnnotationCommon())
      });
      defineType("TSQualifiedName", {
        aliases: ["TSEntityName"],
        visitor: ["left", "right"],
        fields: {
          left: (0, _utils.validateType)("TSEntityName"),
          right: (0, _utils.validateType)("Identifier")
        }
      });
      var signatureDeclarationCommon = () => ({
        typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
        ["parameters"]: (0, _utils.validateArrayOfType)(["Identifier", "RestElement"]),
        ["typeAnnotation"]: (0, _utils.validateOptionalType)("TSTypeAnnotation")
      });
      var callConstructSignatureDeclaration = {
        aliases: ["TSTypeElement"],
        visitor: ["typeParameters", "parameters", "typeAnnotation"],
        fields: signatureDeclarationCommon()
      };
      defineType("TSCallSignatureDeclaration", callConstructSignatureDeclaration);
      defineType("TSConstructSignatureDeclaration", callConstructSignatureDeclaration);
      var namedTypeElementCommon = () => ({
        key: (0, _utils.validateType)("Expression"),
        computed: {
          default: false
        },
        optional: (0, _utils.validateOptional)(bool)
      });
      defineType("TSPropertySignature", {
        aliases: ["TSTypeElement"],
        visitor: ["key", "typeAnnotation", "initializer"],
        fields: Object.assign({}, namedTypeElementCommon(), {
          readonly: (0, _utils.validateOptional)(bool),
          typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation"),
          initializer: (0, _utils.validateOptionalType)("Expression"),
          kind: {
            validate: (0, _utils.assertOneOf)("get", "set")
          }
        })
      });
      defineType("TSMethodSignature", {
        aliases: ["TSTypeElement"],
        visitor: ["key", "typeParameters", "parameters", "typeAnnotation"],
        fields: Object.assign({}, signatureDeclarationCommon(), namedTypeElementCommon(), {
          kind: {
            validate: (0, _utils.assertOneOf)("method", "get", "set")
          }
        })
      });
      defineType("TSIndexSignature", {
        aliases: ["TSTypeElement"],
        visitor: ["parameters", "typeAnnotation"],
        fields: {
          readonly: (0, _utils.validateOptional)(bool),
          static: (0, _utils.validateOptional)(bool),
          parameters: (0, _utils.validateArrayOfType)("Identifier"),
          typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation")
        }
      });
      var tsKeywordTypes = ["TSAnyKeyword", "TSBooleanKeyword", "TSBigIntKeyword", "TSIntrinsicKeyword", "TSNeverKeyword", "TSNullKeyword", "TSNumberKeyword", "TSObjectKeyword", "TSStringKeyword", "TSSymbolKeyword", "TSUndefinedKeyword", "TSUnknownKeyword", "TSVoidKeyword"];
      for (const type of tsKeywordTypes) {
        defineType(type, {
          aliases: ["TSType", "TSBaseType"],
          visitor: [],
          fields: {}
        });
      }
      defineType("TSThisType", {
        aliases: ["TSType", "TSBaseType"],
        visitor: [],
        fields: {}
      });
      var fnOrCtrBase = {
        aliases: ["TSType"],
        visitor: ["typeParameters", "parameters", "typeAnnotation"]
      };
      defineType("TSFunctionType", Object.assign({}, fnOrCtrBase, {
        fields: signatureDeclarationCommon()
      }));
      defineType("TSConstructorType", Object.assign({}, fnOrCtrBase, {
        fields: Object.assign({}, signatureDeclarationCommon(), {
          abstract: (0, _utils.validateOptional)(bool)
        })
      }));
      defineType("TSTypeReference", {
        aliases: ["TSType"],
        visitor: ["typeName", "typeParameters"],
        fields: {
          typeName: (0, _utils.validateType)("TSEntityName"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      defineType("TSTypePredicate", {
        aliases: ["TSType"],
        visitor: ["parameterName", "typeAnnotation"],
        builder: ["parameterName", "typeAnnotation", "asserts"],
        fields: {
          parameterName: (0, _utils.validateType)(["Identifier", "TSThisType"]),
          typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation"),
          asserts: (0, _utils.validateOptional)(bool)
        }
      });
      defineType("TSTypeQuery", {
        aliases: ["TSType"],
        visitor: ["exprName", "typeParameters"],
        fields: {
          exprName: (0, _utils.validateType)(["TSEntityName", "TSImportType"]),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      defineType("TSTypeLiteral", {
        aliases: ["TSType"],
        visitor: ["members"],
        fields: {
          members: (0, _utils.validateArrayOfType)("TSTypeElement")
        }
      });
      defineType("TSArrayType", {
        aliases: ["TSType"],
        visitor: ["elementType"],
        fields: {
          elementType: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSTupleType", {
        aliases: ["TSType"],
        visitor: ["elementTypes"],
        fields: {
          elementTypes: (0, _utils.validateArrayOfType)(["TSType", "TSNamedTupleMember"])
        }
      });
      defineType("TSOptionalType", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSRestType", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSNamedTupleMember", {
        visitor: ["label", "elementType"],
        builder: ["label", "elementType", "optional"],
        fields: {
          label: (0, _utils.validateType)("Identifier"),
          optional: {
            validate: bool,
            default: false
          },
          elementType: (0, _utils.validateType)("TSType")
        }
      });
      var unionOrIntersection = {
        aliases: ["TSType"],
        visitor: ["types"],
        fields: {
          types: (0, _utils.validateArrayOfType)("TSType")
        }
      };
      defineType("TSUnionType", unionOrIntersection);
      defineType("TSIntersectionType", unionOrIntersection);
      defineType("TSConditionalType", {
        aliases: ["TSType"],
        visitor: ["checkType", "extendsType", "trueType", "falseType"],
        fields: {
          checkType: (0, _utils.validateType)("TSType"),
          extendsType: (0, _utils.validateType)("TSType"),
          trueType: (0, _utils.validateType)("TSType"),
          falseType: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSInferType", {
        aliases: ["TSType"],
        visitor: ["typeParameter"],
        fields: {
          typeParameter: (0, _utils.validateType)("TSTypeParameter")
        }
      });
      defineType("TSParenthesizedType", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSTypeOperator", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        fields: {
          operator: (0, _utils.validate)((0, _utils.assertValueType)("string")),
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSIndexedAccessType", {
        aliases: ["TSType"],
        visitor: ["objectType", "indexType"],
        fields: {
          objectType: (0, _utils.validateType)("TSType"),
          indexType: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSMappedType", {
        aliases: ["TSType"],
        visitor: ["typeParameter", "typeAnnotation", "nameType"],
        fields: {
          readonly: (0, _utils.validateOptional)((0, _utils.assertOneOf)(true, false, "+", "-")),
          typeParameter: (0, _utils.validateType)("TSTypeParameter"),
          optional: (0, _utils.validateOptional)((0, _utils.assertOneOf)(true, false, "+", "-")),
          typeAnnotation: (0, _utils.validateOptionalType)("TSType"),
          nameType: (0, _utils.validateOptionalType)("TSType")
        }
      });
      defineType("TSLiteralType", {
        aliases: ["TSType", "TSBaseType"],
        visitor: ["literal"],
        fields: {
          literal: {
            validate: function() {
              const unaryExpression = (0, _utils.assertNodeType)("NumericLiteral", "BigIntLiteral");
              const unaryOperator = (0, _utils.assertOneOf)("-");
              const literal = (0, _utils.assertNodeType)("NumericLiteral", "StringLiteral", "BooleanLiteral", "BigIntLiteral", "TemplateLiteral");
              function validator(parent2, key, node) {
                if ((0, _is.default)("UnaryExpression", node)) {
                  unaryOperator(node, "operator", node.operator);
                  unaryExpression(node, "argument", node.argument);
                } else {
                  literal(parent2, key, node);
                }
              }
              validator.oneOfNodeTypes = ["NumericLiteral", "StringLiteral", "BooleanLiteral", "BigIntLiteral", "TemplateLiteral", "UnaryExpression"];
              return validator;
            }()
          }
        }
      });
      defineType("TSExpressionWithTypeArguments", {
        aliases: ["TSType"],
        visitor: ["expression", "typeParameters"],
        fields: {
          expression: (0, _utils.validateType)("TSEntityName"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      defineType("TSInterfaceDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "typeParameters", "extends", "body"],
        fields: {
          declare: (0, _utils.validateOptional)(bool),
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
          extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("TSExpressionWithTypeArguments")),
          body: (0, _utils.validateType)("TSInterfaceBody")
        }
      });
      defineType("TSInterfaceBody", {
        visitor: ["body"],
        fields: {
          body: (0, _utils.validateArrayOfType)("TSTypeElement")
        }
      });
      defineType("TSTypeAliasDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "typeParameters", "typeAnnotation"],
        fields: {
          declare: (0, _utils.validateOptional)(bool),
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSInstantiationExpression", {
        aliases: ["Expression"],
        visitor: ["expression", "typeParameters"],
        fields: {
          expression: (0, _utils.validateType)("Expression"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      var TSTypeExpression = {
        aliases: ["Expression", "LVal", "PatternLike"],
        visitor: ["expression", "typeAnnotation"],
        fields: {
          expression: (0, _utils.validateType)("Expression"),
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      };
      defineType("TSAsExpression", TSTypeExpression);
      defineType("TSSatisfiesExpression", TSTypeExpression);
      defineType("TSTypeAssertion", {
        aliases: ["Expression", "LVal", "PatternLike"],
        visitor: ["typeAnnotation", "expression"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType"),
          expression: (0, _utils.validateType)("Expression")
        }
      });
      defineType("TSEnumDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "members"],
        fields: {
          declare: (0, _utils.validateOptional)(bool),
          const: (0, _utils.validateOptional)(bool),
          id: (0, _utils.validateType)("Identifier"),
          members: (0, _utils.validateArrayOfType)("TSEnumMember"),
          initializer: (0, _utils.validateOptionalType)("Expression")
        }
      });
      defineType("TSEnumMember", {
        visitor: ["id", "initializer"],
        fields: {
          id: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
          initializer: (0, _utils.validateOptionalType)("Expression")
        }
      });
      defineType("TSModuleDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "body"],
        fields: {
          declare: (0, _utils.validateOptional)(bool),
          global: (0, _utils.validateOptional)(bool),
          id: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
          body: (0, _utils.validateType)(["TSModuleBlock", "TSModuleDeclaration"])
        }
      });
      defineType("TSModuleBlock", {
        aliases: ["Scopable", "Block", "BlockParent", "FunctionParent"],
        visitor: ["body"],
        fields: {
          body: (0, _utils.validateArrayOfType)("Statement")
        }
      });
      defineType("TSImportType", {
        aliases: ["TSType"],
        visitor: ["argument", "qualifier", "typeParameters"],
        fields: {
          argument: (0, _utils.validateType)("StringLiteral"),
          qualifier: (0, _utils.validateOptionalType)("TSEntityName"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      defineType("TSImportEqualsDeclaration", {
        aliases: ["Statement"],
        visitor: ["id", "moduleReference"],
        fields: {
          isExport: (0, _utils.validate)(bool),
          id: (0, _utils.validateType)("Identifier"),
          moduleReference: (0, _utils.validateType)(["TSEntityName", "TSExternalModuleReference"]),
          importKind: {
            validate: (0, _utils.assertOneOf)("type", "value"),
            optional: true
          }
        }
      });
      defineType("TSExternalModuleReference", {
        visitor: ["expression"],
        fields: {
          expression: (0, _utils.validateType)("StringLiteral")
        }
      });
      defineType("TSNonNullExpression", {
        aliases: ["Expression", "LVal", "PatternLike"],
        visitor: ["expression"],
        fields: {
          expression: (0, _utils.validateType)("Expression")
        }
      });
      defineType("TSExportAssignment", {
        aliases: ["Statement"],
        visitor: ["expression"],
        fields: {
          expression: (0, _utils.validateType)("Expression")
        }
      });
      defineType("TSNamespaceExportDeclaration", {
        aliases: ["Statement"],
        visitor: ["id"],
        fields: {
          id: (0, _utils.validateType)("Identifier")
        }
      });
      defineType("TSTypeAnnotation", {
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)("TSType")
          }
        }
      });
      defineType("TSTypeParameterInstantiation", {
        visitor: ["params"],
        fields: {
          params: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSType")))
          }
        }
      });
      defineType("TSTypeParameterDeclaration", {
        visitor: ["params"],
        fields: {
          params: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSTypeParameter")))
          }
        }
      });
      defineType("TSTypeParameter", {
        builder: ["constraint", "default", "name"],
        visitor: ["constraint", "default"],
        fields: {
          name: {
            validate: (0, _utils.assertValueType)("string")
          },
          in: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          out: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          constraint: {
            validate: (0, _utils.assertNodeType)("TSType"),
            optional: true
          },
          default: {
            validate: (0, _utils.assertNodeType)("TSType"),
            optional: true
          }
        }
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/index.js
  var require_definitions = __commonJS({
    "node_modules/@babel/types/lib/definitions/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      Object.defineProperty(exports2, "ALIAS_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.ALIAS_KEYS;
        }
      });
      Object.defineProperty(exports2, "BUILDER_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.BUILDER_KEYS;
        }
      });
      Object.defineProperty(exports2, "DEPRECATED_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.DEPRECATED_KEYS;
        }
      });
      Object.defineProperty(exports2, "FLIPPED_ALIAS_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.FLIPPED_ALIAS_KEYS;
        }
      });
      Object.defineProperty(exports2, "NODE_FIELDS", {
        enumerable: true,
        get: function() {
          return _utils.NODE_FIELDS;
        }
      });
      Object.defineProperty(exports2, "NODE_PARENT_VALIDATIONS", {
        enumerable: true,
        get: function() {
          return _utils.NODE_PARENT_VALIDATIONS;
        }
      });
      Object.defineProperty(exports2, "PLACEHOLDERS", {
        enumerable: true,
        get: function() {
          return _placeholders.PLACEHOLDERS;
        }
      });
      Object.defineProperty(exports2, "PLACEHOLDERS_ALIAS", {
        enumerable: true,
        get: function() {
          return _placeholders.PLACEHOLDERS_ALIAS;
        }
      });
      Object.defineProperty(exports2, "PLACEHOLDERS_FLIPPED_ALIAS", {
        enumerable: true,
        get: function() {
          return _placeholders.PLACEHOLDERS_FLIPPED_ALIAS;
        }
      });
      exports2.TYPES = void 0;
      Object.defineProperty(exports2, "VISITOR_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.VISITOR_KEYS;
        }
      });
      var _toFastProperties = require_to_fast_properties();
      require_core();
      require_flow();
      require_jsx();
      require_misc();
      require_experimental();
      require_typescript();
      var _utils = require_utils3();
      var _placeholders = require_placeholders();
      _toFastProperties(_utils.VISITOR_KEYS);
      _toFastProperties(_utils.ALIAS_KEYS);
      _toFastProperties(_utils.FLIPPED_ALIAS_KEYS);
      _toFastProperties(_utils.NODE_FIELDS);
      _toFastProperties(_utils.BUILDER_KEYS);
      _toFastProperties(_utils.DEPRECATED_KEYS);
      _toFastProperties(_placeholders.PLACEHOLDERS_ALIAS);
      _toFastProperties(_placeholders.PLACEHOLDERS_FLIPPED_ALIAS);
      var TYPES = [].concat(Object.keys(_utils.VISITOR_KEYS), Object.keys(_utils.FLIPPED_ALIAS_KEYS), Object.keys(_utils.DEPRECATED_KEYS));
      exports2.TYPES = TYPES;
    }
  });

  // node_modules/@babel/types/lib/validators/validate.js
  var require_validate = __commonJS({
    "node_modules/@babel/types/lib/validators/validate.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = validate;
      exports2.validateChild = validateChild;
      exports2.validateField = validateField;
      var _definitions = require_definitions();
      function validate(node, key, val) {
        if (!node)
          return;
        const fields = _definitions.NODE_FIELDS[node.type];
        if (!fields)
          return;
        const field = fields[key];
        validateField(node, key, val, field);
        validateChild(node, key, val);
      }
      function validateField(node, key, val, field) {
        if (!(field != null && field.validate))
          return;
        if (field.optional && val == null)
          return;
        field.validate(node, key, val);
      }
      function validateChild(node, key, val) {
        if (val == null)
          return;
        const validate2 = _definitions.NODE_PARENT_VALIDATIONS[val.type];
        if (!validate2)
          return;
        validate2(node, key, val);
      }
    }
  });

  // node_modules/@babel/types/lib/builders/validateNode.js
  var require_validateNode = __commonJS({
    "node_modules/@babel/types/lib/builders/validateNode.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = validateNode;
      var _validate = require_validate();
      var _ = require_lib5();
      function validateNode(node) {
        const keys2 = _.BUILDER_KEYS[node.type];
        for (const key of keys2) {
          (0, _validate.default)(node, key, node[key]);
        }
        return node;
      }
    }
  });

  // node_modules/@babel/types/lib/builders/generated/index.js
  var require_generated2 = __commonJS({
    "node_modules/@babel/types/lib/builders/generated/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.anyTypeAnnotation = anyTypeAnnotation;
      exports2.argumentPlaceholder = argumentPlaceholder;
      exports2.arrayExpression = arrayExpression;
      exports2.arrayPattern = arrayPattern;
      exports2.arrayTypeAnnotation = arrayTypeAnnotation;
      exports2.arrowFunctionExpression = arrowFunctionExpression2;
      exports2.assignmentExpression = assignmentExpression;
      exports2.assignmentPattern = assignmentPattern;
      exports2.awaitExpression = awaitExpression;
      exports2.bigIntLiteral = bigIntLiteral;
      exports2.binaryExpression = binaryExpression;
      exports2.bindExpression = bindExpression;
      exports2.blockStatement = blockStatement;
      exports2.booleanLiteral = booleanLiteral;
      exports2.booleanLiteralTypeAnnotation = booleanLiteralTypeAnnotation;
      exports2.booleanTypeAnnotation = booleanTypeAnnotation;
      exports2.breakStatement = breakStatement;
      exports2.callExpression = callExpression;
      exports2.catchClause = catchClause;
      exports2.classAccessorProperty = classAccessorProperty;
      exports2.classBody = classBody;
      exports2.classDeclaration = classDeclaration;
      exports2.classExpression = classExpression;
      exports2.classImplements = classImplements;
      exports2.classMethod = classMethod2;
      exports2.classPrivateMethod = classPrivateMethod;
      exports2.classPrivateProperty = classPrivateProperty;
      exports2.classProperty = classProperty;
      exports2.conditionalExpression = conditionalExpression;
      exports2.continueStatement = continueStatement;
      exports2.debuggerStatement = debuggerStatement;
      exports2.decimalLiteral = decimalLiteral;
      exports2.declareClass = declareClass;
      exports2.declareExportAllDeclaration = declareExportAllDeclaration;
      exports2.declareExportDeclaration = declareExportDeclaration;
      exports2.declareFunction = declareFunction;
      exports2.declareInterface = declareInterface;
      exports2.declareModule = declareModule;
      exports2.declareModuleExports = declareModuleExports;
      exports2.declareOpaqueType = declareOpaqueType;
      exports2.declareTypeAlias = declareTypeAlias;
      exports2.declareVariable = declareVariable;
      exports2.declaredPredicate = declaredPredicate;
      exports2.decorator = decorator;
      exports2.directive = directive;
      exports2.directiveLiteral = directiveLiteral;
      exports2.doExpression = doExpression;
      exports2.doWhileStatement = doWhileStatement;
      exports2.emptyStatement = emptyStatement;
      exports2.emptyTypeAnnotation = emptyTypeAnnotation;
      exports2.enumBooleanBody = enumBooleanBody;
      exports2.enumBooleanMember = enumBooleanMember;
      exports2.enumDeclaration = enumDeclaration;
      exports2.enumDefaultedMember = enumDefaultedMember;
      exports2.enumNumberBody = enumNumberBody;
      exports2.enumNumberMember = enumNumberMember;
      exports2.enumStringBody = enumStringBody;
      exports2.enumStringMember = enumStringMember;
      exports2.enumSymbolBody = enumSymbolBody;
      exports2.existsTypeAnnotation = existsTypeAnnotation;
      exports2.exportAllDeclaration = exportAllDeclaration;
      exports2.exportDefaultDeclaration = exportDefaultDeclaration;
      exports2.exportDefaultSpecifier = exportDefaultSpecifier;
      exports2.exportNamedDeclaration = exportNamedDeclaration;
      exports2.exportNamespaceSpecifier = exportNamespaceSpecifier;
      exports2.exportSpecifier = exportSpecifier;
      exports2.expressionStatement = expressionStatement2;
      exports2.file = file2;
      exports2.forInStatement = forInStatement;
      exports2.forOfStatement = forOfStatement;
      exports2.forStatement = forStatement;
      exports2.functionDeclaration = functionDeclaration;
      exports2.functionExpression = functionExpression;
      exports2.functionTypeAnnotation = functionTypeAnnotation;
      exports2.functionTypeParam = functionTypeParam;
      exports2.genericTypeAnnotation = genericTypeAnnotation;
      exports2.identifier = identifier3;
      exports2.ifStatement = ifStatement;
      exports2.import = _import;
      exports2.importAttribute = importAttribute;
      exports2.importDeclaration = importDeclaration;
      exports2.importDefaultSpecifier = importDefaultSpecifier;
      exports2.importNamespaceSpecifier = importNamespaceSpecifier;
      exports2.importSpecifier = importSpecifier;
      exports2.indexedAccessType = indexedAccessType;
      exports2.inferredPredicate = inferredPredicate;
      exports2.interfaceDeclaration = interfaceDeclaration;
      exports2.interfaceExtends = interfaceExtends;
      exports2.interfaceTypeAnnotation = interfaceTypeAnnotation;
      exports2.interpreterDirective = interpreterDirective;
      exports2.intersectionTypeAnnotation = intersectionTypeAnnotation;
      exports2.jSXAttribute = exports2.jsxAttribute = jsxAttribute;
      exports2.jSXClosingElement = exports2.jsxClosingElement = jsxClosingElement;
      exports2.jSXClosingFragment = exports2.jsxClosingFragment = jsxClosingFragment;
      exports2.jSXElement = exports2.jsxElement = jsxElement;
      exports2.jSXEmptyExpression = exports2.jsxEmptyExpression = jsxEmptyExpression;
      exports2.jSXExpressionContainer = exports2.jsxExpressionContainer = jsxExpressionContainer;
      exports2.jSXFragment = exports2.jsxFragment = jsxFragment;
      exports2.jSXIdentifier = exports2.jsxIdentifier = jsxIdentifier;
      exports2.jSXMemberExpression = exports2.jsxMemberExpression = jsxMemberExpression;
      exports2.jSXNamespacedName = exports2.jsxNamespacedName = jsxNamespacedName;
      exports2.jSXOpeningElement = exports2.jsxOpeningElement = jsxOpeningElement;
      exports2.jSXOpeningFragment = exports2.jsxOpeningFragment = jsxOpeningFragment;
      exports2.jSXSpreadAttribute = exports2.jsxSpreadAttribute = jsxSpreadAttribute;
      exports2.jSXSpreadChild = exports2.jsxSpreadChild = jsxSpreadChild;
      exports2.jSXText = exports2.jsxText = jsxText;
      exports2.labeledStatement = labeledStatement;
      exports2.logicalExpression = logicalExpression;
      exports2.memberExpression = memberExpression;
      exports2.metaProperty = metaProperty;
      exports2.mixedTypeAnnotation = mixedTypeAnnotation;
      exports2.moduleExpression = moduleExpression;
      exports2.newExpression = newExpression;
      exports2.noop = noop3;
      exports2.nullLiteral = nullLiteral;
      exports2.nullLiteralTypeAnnotation = nullLiteralTypeAnnotation;
      exports2.nullableTypeAnnotation = nullableTypeAnnotation;
      exports2.numberLiteral = NumberLiteral;
      exports2.numberLiteralTypeAnnotation = numberLiteralTypeAnnotation;
      exports2.numberTypeAnnotation = numberTypeAnnotation;
      exports2.numericLiteral = numericLiteral;
      exports2.objectExpression = objectExpression;
      exports2.objectMethod = objectMethod;
      exports2.objectPattern = objectPattern;
      exports2.objectProperty = objectProperty;
      exports2.objectTypeAnnotation = objectTypeAnnotation;
      exports2.objectTypeCallProperty = objectTypeCallProperty;
      exports2.objectTypeIndexer = objectTypeIndexer;
      exports2.objectTypeInternalSlot = objectTypeInternalSlot;
      exports2.objectTypeProperty = objectTypeProperty;
      exports2.objectTypeSpreadProperty = objectTypeSpreadProperty;
      exports2.opaqueType = opaqueType;
      exports2.optionalCallExpression = optionalCallExpression;
      exports2.optionalIndexedAccessType = optionalIndexedAccessType;
      exports2.optionalMemberExpression = optionalMemberExpression;
      exports2.parenthesizedExpression = parenthesizedExpression;
      exports2.pipelineBareFunction = pipelineBareFunction;
      exports2.pipelinePrimaryTopicReference = pipelinePrimaryTopicReference;
      exports2.pipelineTopicExpression = pipelineTopicExpression;
      exports2.placeholder = placeholder;
      exports2.privateName = privateName;
      exports2.program = program3;
      exports2.qualifiedTypeIdentifier = qualifiedTypeIdentifier;
      exports2.recordExpression = recordExpression;
      exports2.regExpLiteral = regExpLiteral;
      exports2.regexLiteral = RegexLiteral;
      exports2.restElement = restElement;
      exports2.restProperty = RestProperty;
      exports2.returnStatement = returnStatement;
      exports2.sequenceExpression = sequenceExpression;
      exports2.spreadElement = spreadElement;
      exports2.spreadProperty = SpreadProperty;
      exports2.staticBlock = staticBlock;
      exports2.stringLiteral = stringLiteral;
      exports2.stringLiteralTypeAnnotation = stringLiteralTypeAnnotation;
      exports2.stringTypeAnnotation = stringTypeAnnotation;
      exports2.super = _super;
      exports2.switchCase = switchCase;
      exports2.switchStatement = switchStatement;
      exports2.symbolTypeAnnotation = symbolTypeAnnotation;
      exports2.taggedTemplateExpression = taggedTemplateExpression;
      exports2.templateElement = templateElement;
      exports2.templateLiteral = templateLiteral;
      exports2.thisExpression = thisExpression;
      exports2.thisTypeAnnotation = thisTypeAnnotation;
      exports2.throwStatement = throwStatement;
      exports2.topicReference = topicReference;
      exports2.tryStatement = tryStatement;
      exports2.tSAnyKeyword = exports2.tsAnyKeyword = tsAnyKeyword;
      exports2.tSArrayType = exports2.tsArrayType = tsArrayType;
      exports2.tSAsExpression = exports2.tsAsExpression = tsAsExpression;
      exports2.tSBigIntKeyword = exports2.tsBigIntKeyword = tsBigIntKeyword;
      exports2.tSBooleanKeyword = exports2.tsBooleanKeyword = tsBooleanKeyword;
      exports2.tSCallSignatureDeclaration = exports2.tsCallSignatureDeclaration = tsCallSignatureDeclaration;
      exports2.tSConditionalType = exports2.tsConditionalType = tsConditionalType;
      exports2.tSConstructSignatureDeclaration = exports2.tsConstructSignatureDeclaration = tsConstructSignatureDeclaration;
      exports2.tSConstructorType = exports2.tsConstructorType = tsConstructorType;
      exports2.tSDeclareFunction = exports2.tsDeclareFunction = tsDeclareFunction;
      exports2.tSDeclareMethod = exports2.tsDeclareMethod = tsDeclareMethod;
      exports2.tSEnumDeclaration = exports2.tsEnumDeclaration = tsEnumDeclaration;
      exports2.tSEnumMember = exports2.tsEnumMember = tsEnumMember;
      exports2.tSExportAssignment = exports2.tsExportAssignment = tsExportAssignment;
      exports2.tSExpressionWithTypeArguments = exports2.tsExpressionWithTypeArguments = tsExpressionWithTypeArguments;
      exports2.tSExternalModuleReference = exports2.tsExternalModuleReference = tsExternalModuleReference;
      exports2.tSFunctionType = exports2.tsFunctionType = tsFunctionType;
      exports2.tSImportEqualsDeclaration = exports2.tsImportEqualsDeclaration = tsImportEqualsDeclaration;
      exports2.tSImportType = exports2.tsImportType = tsImportType;
      exports2.tSIndexSignature = exports2.tsIndexSignature = tsIndexSignature;
      exports2.tSIndexedAccessType = exports2.tsIndexedAccessType = tsIndexedAccessType;
      exports2.tSInferType = exports2.tsInferType = tsInferType;
      exports2.tSInstantiationExpression = exports2.tsInstantiationExpression = tsInstantiationExpression;
      exports2.tSInterfaceBody = exports2.tsInterfaceBody = tsInterfaceBody;
      exports2.tSInterfaceDeclaration = exports2.tsInterfaceDeclaration = tsInterfaceDeclaration;
      exports2.tSIntersectionType = exports2.tsIntersectionType = tsIntersectionType;
      exports2.tSIntrinsicKeyword = exports2.tsIntrinsicKeyword = tsIntrinsicKeyword;
      exports2.tSLiteralType = exports2.tsLiteralType = tsLiteralType;
      exports2.tSMappedType = exports2.tsMappedType = tsMappedType;
      exports2.tSMethodSignature = exports2.tsMethodSignature = tsMethodSignature;
      exports2.tSModuleBlock = exports2.tsModuleBlock = tsModuleBlock;
      exports2.tSModuleDeclaration = exports2.tsModuleDeclaration = tsModuleDeclaration;
      exports2.tSNamedTupleMember = exports2.tsNamedTupleMember = tsNamedTupleMember;
      exports2.tSNamespaceExportDeclaration = exports2.tsNamespaceExportDeclaration = tsNamespaceExportDeclaration;
      exports2.tSNeverKeyword = exports2.tsNeverKeyword = tsNeverKeyword;
      exports2.tSNonNullExpression = exports2.tsNonNullExpression = tsNonNullExpression;
      exports2.tSNullKeyword = exports2.tsNullKeyword = tsNullKeyword;
      exports2.tSNumberKeyword = exports2.tsNumberKeyword = tsNumberKeyword;
      exports2.tSObjectKeyword = exports2.tsObjectKeyword = tsObjectKeyword;
      exports2.tSOptionalType = exports2.tsOptionalType = tsOptionalType;
      exports2.tSParameterProperty = exports2.tsParameterProperty = tsParameterProperty;
      exports2.tSParenthesizedType = exports2.tsParenthesizedType = tsParenthesizedType;
      exports2.tSPropertySignature = exports2.tsPropertySignature = tsPropertySignature;
      exports2.tSQualifiedName = exports2.tsQualifiedName = tsQualifiedName;
      exports2.tSRestType = exports2.tsRestType = tsRestType;
      exports2.tSSatisfiesExpression = exports2.tsSatisfiesExpression = tsSatisfiesExpression;
      exports2.tSStringKeyword = exports2.tsStringKeyword = tsStringKeyword;
      exports2.tSSymbolKeyword = exports2.tsSymbolKeyword = tsSymbolKeyword;
      exports2.tSThisType = exports2.tsThisType = tsThisType;
      exports2.tSTupleType = exports2.tsTupleType = tsTupleType;
      exports2.tSTypeAliasDeclaration = exports2.tsTypeAliasDeclaration = tsTypeAliasDeclaration;
      exports2.tSTypeAnnotation = exports2.tsTypeAnnotation = tsTypeAnnotation;
      exports2.tSTypeAssertion = exports2.tsTypeAssertion = tsTypeAssertion;
      exports2.tSTypeLiteral = exports2.tsTypeLiteral = tsTypeLiteral;
      exports2.tSTypeOperator = exports2.tsTypeOperator = tsTypeOperator;
      exports2.tSTypeParameter = exports2.tsTypeParameter = tsTypeParameter;
      exports2.tSTypeParameterDeclaration = exports2.tsTypeParameterDeclaration = tsTypeParameterDeclaration;
      exports2.tSTypeParameterInstantiation = exports2.tsTypeParameterInstantiation = tsTypeParameterInstantiation;
      exports2.tSTypePredicate = exports2.tsTypePredicate = tsTypePredicate;
      exports2.tSTypeQuery = exports2.tsTypeQuery = tsTypeQuery;
      exports2.tSTypeReference = exports2.tsTypeReference = tsTypeReference;
      exports2.tSUndefinedKeyword = exports2.tsUndefinedKeyword = tsUndefinedKeyword;
      exports2.tSUnionType = exports2.tsUnionType = tsUnionType;
      exports2.tSUnknownKeyword = exports2.tsUnknownKeyword = tsUnknownKeyword;
      exports2.tSVoidKeyword = exports2.tsVoidKeyword = tsVoidKeyword;
      exports2.tupleExpression = tupleExpression;
      exports2.tupleTypeAnnotation = tupleTypeAnnotation;
      exports2.typeAlias = typeAlias;
      exports2.typeAnnotation = typeAnnotation;
      exports2.typeCastExpression = typeCastExpression;
      exports2.typeParameter = typeParameter;
      exports2.typeParameterDeclaration = typeParameterDeclaration;
      exports2.typeParameterInstantiation = typeParameterInstantiation;
      exports2.typeofTypeAnnotation = typeofTypeAnnotation;
      exports2.unaryExpression = unaryExpression;
      exports2.unionTypeAnnotation = unionTypeAnnotation;
      exports2.updateExpression = updateExpression;
      exports2.v8IntrinsicIdentifier = v8IntrinsicIdentifier;
      exports2.variableDeclaration = variableDeclaration;
      exports2.variableDeclarator = variableDeclarator;
      exports2.variance = variance;
      exports2.voidTypeAnnotation = voidTypeAnnotation;
      exports2.whileStatement = whileStatement;
      exports2.withStatement = withStatement;
      exports2.yieldExpression = yieldExpression;
      var _validateNode = require_validateNode();
      function arrayExpression(elements = []) {
        return (0, _validateNode.default)({
          type: "ArrayExpression",
          elements
        });
      }
      function assignmentExpression(operator, left, right) {
        return (0, _validateNode.default)({
          type: "AssignmentExpression",
          operator,
          left,
          right
        });
      }
      function binaryExpression(operator, left, right) {
        return (0, _validateNode.default)({
          type: "BinaryExpression",
          operator,
          left,
          right
        });
      }
      function interpreterDirective(value) {
        return (0, _validateNode.default)({
          type: "InterpreterDirective",
          value
        });
      }
      function directive(value) {
        return (0, _validateNode.default)({
          type: "Directive",
          value
        });
      }
      function directiveLiteral(value) {
        return (0, _validateNode.default)({
          type: "DirectiveLiteral",
          value
        });
      }
      function blockStatement(body, directives = []) {
        return (0, _validateNode.default)({
          type: "BlockStatement",
          body,
          directives
        });
      }
      function breakStatement(label = null) {
        return (0, _validateNode.default)({
          type: "BreakStatement",
          label
        });
      }
      function callExpression(callee, _arguments) {
        return (0, _validateNode.default)({
          type: "CallExpression",
          callee,
          arguments: _arguments
        });
      }
      function catchClause(param = null, body) {
        return (0, _validateNode.default)({
          type: "CatchClause",
          param,
          body
        });
      }
      function conditionalExpression(test, consequent, alternate) {
        return (0, _validateNode.default)({
          type: "ConditionalExpression",
          test,
          consequent,
          alternate
        });
      }
      function continueStatement(label = null) {
        return (0, _validateNode.default)({
          type: "ContinueStatement",
          label
        });
      }
      function debuggerStatement() {
        return {
          type: "DebuggerStatement"
        };
      }
      function doWhileStatement(test, body) {
        return (0, _validateNode.default)({
          type: "DoWhileStatement",
          test,
          body
        });
      }
      function emptyStatement() {
        return {
          type: "EmptyStatement"
        };
      }
      function expressionStatement2(expression) {
        return (0, _validateNode.default)({
          type: "ExpressionStatement",
          expression
        });
      }
      function file2(program4, comments = null, tokens = null) {
        return (0, _validateNode.default)({
          type: "File",
          program: program4,
          comments,
          tokens
        });
      }
      function forInStatement(left, right, body) {
        return (0, _validateNode.default)({
          type: "ForInStatement",
          left,
          right,
          body
        });
      }
      function forStatement(init = null, test = null, update2 = null, body) {
        return (0, _validateNode.default)({
          type: "ForStatement",
          init,
          test,
          update: update2,
          body
        });
      }
      function functionDeclaration(id = null, params, body, generator = false, async = false) {
        return (0, _validateNode.default)({
          type: "FunctionDeclaration",
          id,
          params,
          body,
          generator,
          async
        });
      }
      function functionExpression(id = null, params, body, generator = false, async = false) {
        return (0, _validateNode.default)({
          type: "FunctionExpression",
          id,
          params,
          body,
          generator,
          async
        });
      }
      function identifier3(name) {
        return (0, _validateNode.default)({
          type: "Identifier",
          name
        });
      }
      function ifStatement(test, consequent, alternate = null) {
        return (0, _validateNode.default)({
          type: "IfStatement",
          test,
          consequent,
          alternate
        });
      }
      function labeledStatement(label, body) {
        return (0, _validateNode.default)({
          type: "LabeledStatement",
          label,
          body
        });
      }
      function stringLiteral(value) {
        return (0, _validateNode.default)({
          type: "StringLiteral",
          value
        });
      }
      function numericLiteral(value) {
        return (0, _validateNode.default)({
          type: "NumericLiteral",
          value
        });
      }
      function nullLiteral() {
        return {
          type: "NullLiteral"
        };
      }
      function booleanLiteral(value) {
        return (0, _validateNode.default)({
          type: "BooleanLiteral",
          value
        });
      }
      function regExpLiteral(pattern, flags = "") {
        return (0, _validateNode.default)({
          type: "RegExpLiteral",
          pattern,
          flags
        });
      }
      function logicalExpression(operator, left, right) {
        return (0, _validateNode.default)({
          type: "LogicalExpression",
          operator,
          left,
          right
        });
      }
      function memberExpression(object, property2, computed = false, optional = null) {
        return (0, _validateNode.default)({
          type: "MemberExpression",
          object,
          property: property2,
          computed,
          optional
        });
      }
      function newExpression(callee, _arguments) {
        return (0, _validateNode.default)({
          type: "NewExpression",
          callee,
          arguments: _arguments
        });
      }
      function program3(body, directives = [], sourceType = "script", interpreter = null) {
        return (0, _validateNode.default)({
          type: "Program",
          body,
          directives,
          sourceType,
          interpreter,
          sourceFile: null
        });
      }
      function objectExpression(properties) {
        return (0, _validateNode.default)({
          type: "ObjectExpression",
          properties
        });
      }
      function objectMethod(kind = "method", key, params, body, computed = false, generator = false, async = false) {
        return (0, _validateNode.default)({
          type: "ObjectMethod",
          kind,
          key,
          params,
          body,
          computed,
          generator,
          async
        });
      }
      function objectProperty(key, value, computed = false, shorthand = false, decorators = null) {
        return (0, _validateNode.default)({
          type: "ObjectProperty",
          key,
          value,
          computed,
          shorthand,
          decorators
        });
      }
      function restElement(argument) {
        return (0, _validateNode.default)({
          type: "RestElement",
          argument
        });
      }
      function returnStatement(argument = null) {
        return (0, _validateNode.default)({
          type: "ReturnStatement",
          argument
        });
      }
      function sequenceExpression(expressions) {
        return (0, _validateNode.default)({
          type: "SequenceExpression",
          expressions
        });
      }
      function parenthesizedExpression(expression) {
        return (0, _validateNode.default)({
          type: "ParenthesizedExpression",
          expression
        });
      }
      function switchCase(test = null, consequent) {
        return (0, _validateNode.default)({
          type: "SwitchCase",
          test,
          consequent
        });
      }
      function switchStatement(discriminant, cases) {
        return (0, _validateNode.default)({
          type: "SwitchStatement",
          discriminant,
          cases
        });
      }
      function thisExpression() {
        return {
          type: "ThisExpression"
        };
      }
      function throwStatement(argument) {
        return (0, _validateNode.default)({
          type: "ThrowStatement",
          argument
        });
      }
      function tryStatement(block, handler = null, finalizer = null) {
        return (0, _validateNode.default)({
          type: "TryStatement",
          block,
          handler,
          finalizer
        });
      }
      function unaryExpression(operator, argument, prefix = true) {
        return (0, _validateNode.default)({
          type: "UnaryExpression",
          operator,
          argument,
          prefix
        });
      }
      function updateExpression(operator, argument, prefix = false) {
        return (0, _validateNode.default)({
          type: "UpdateExpression",
          operator,
          argument,
          prefix
        });
      }
      function variableDeclaration(kind, declarations) {
        return (0, _validateNode.default)({
          type: "VariableDeclaration",
          kind,
          declarations
        });
      }
      function variableDeclarator(id, init = null) {
        return (0, _validateNode.default)({
          type: "VariableDeclarator",
          id,
          init
        });
      }
      function whileStatement(test, body) {
        return (0, _validateNode.default)({
          type: "WhileStatement",
          test,
          body
        });
      }
      function withStatement(object, body) {
        return (0, _validateNode.default)({
          type: "WithStatement",
          object,
          body
        });
      }
      function assignmentPattern(left, right) {
        return (0, _validateNode.default)({
          type: "AssignmentPattern",
          left,
          right
        });
      }
      function arrayPattern(elements) {
        return (0, _validateNode.default)({
          type: "ArrayPattern",
          elements
        });
      }
      function arrowFunctionExpression2(params, body, async = false) {
        return (0, _validateNode.default)({
          type: "ArrowFunctionExpression",
          params,
          body,
          async,
          expression: null
        });
      }
      function classBody(body) {
        return (0, _validateNode.default)({
          type: "ClassBody",
          body
        });
      }
      function classExpression(id = null, superClass = null, body, decorators = null) {
        return (0, _validateNode.default)({
          type: "ClassExpression",
          id,
          superClass,
          body,
          decorators
        });
      }
      function classDeclaration(id, superClass = null, body, decorators = null) {
        return (0, _validateNode.default)({
          type: "ClassDeclaration",
          id,
          superClass,
          body,
          decorators
        });
      }
      function exportAllDeclaration(source) {
        return (0, _validateNode.default)({
          type: "ExportAllDeclaration",
          source
        });
      }
      function exportDefaultDeclaration(declaration) {
        return (0, _validateNode.default)({
          type: "ExportDefaultDeclaration",
          declaration
        });
      }
      function exportNamedDeclaration(declaration = null, specifiers = [], source = null) {
        return (0, _validateNode.default)({
          type: "ExportNamedDeclaration",
          declaration,
          specifiers,
          source
        });
      }
      function exportSpecifier(local, exported) {
        return (0, _validateNode.default)({
          type: "ExportSpecifier",
          local,
          exported
        });
      }
      function forOfStatement(left, right, body, _await = false) {
        return (0, _validateNode.default)({
          type: "ForOfStatement",
          left,
          right,
          body,
          await: _await
        });
      }
      function importDeclaration(specifiers, source) {
        return (0, _validateNode.default)({
          type: "ImportDeclaration",
          specifiers,
          source
        });
      }
      function importDefaultSpecifier(local) {
        return (0, _validateNode.default)({
          type: "ImportDefaultSpecifier",
          local
        });
      }
      function importNamespaceSpecifier(local) {
        return (0, _validateNode.default)({
          type: "ImportNamespaceSpecifier",
          local
        });
      }
      function importSpecifier(local, imported) {
        return (0, _validateNode.default)({
          type: "ImportSpecifier",
          local,
          imported
        });
      }
      function metaProperty(meta, property2) {
        return (0, _validateNode.default)({
          type: "MetaProperty",
          meta,
          property: property2
        });
      }
      function classMethod2(kind = "method", key, params, body, computed = false, _static = false, generator = false, async = false) {
        return (0, _validateNode.default)({
          type: "ClassMethod",
          kind,
          key,
          params,
          body,
          computed,
          static: _static,
          generator,
          async
        });
      }
      function objectPattern(properties) {
        return (0, _validateNode.default)({
          type: "ObjectPattern",
          properties
        });
      }
      function spreadElement(argument) {
        return (0, _validateNode.default)({
          type: "SpreadElement",
          argument
        });
      }
      function _super() {
        return {
          type: "Super"
        };
      }
      function taggedTemplateExpression(tag, quasi) {
        return (0, _validateNode.default)({
          type: "TaggedTemplateExpression",
          tag,
          quasi
        });
      }
      function templateElement(value, tail2 = false) {
        return (0, _validateNode.default)({
          type: "TemplateElement",
          value,
          tail: tail2
        });
      }
      function templateLiteral(quasis, expressions) {
        return (0, _validateNode.default)({
          type: "TemplateLiteral",
          quasis,
          expressions
        });
      }
      function yieldExpression(argument = null, delegate = false) {
        return (0, _validateNode.default)({
          type: "YieldExpression",
          argument,
          delegate
        });
      }
      function awaitExpression(argument) {
        return (0, _validateNode.default)({
          type: "AwaitExpression",
          argument
        });
      }
      function _import() {
        return {
          type: "Import"
        };
      }
      function bigIntLiteral(value) {
        return (0, _validateNode.default)({
          type: "BigIntLiteral",
          value
        });
      }
      function exportNamespaceSpecifier(exported) {
        return (0, _validateNode.default)({
          type: "ExportNamespaceSpecifier",
          exported
        });
      }
      function optionalMemberExpression(object, property2, computed = false, optional) {
        return (0, _validateNode.default)({
          type: "OptionalMemberExpression",
          object,
          property: property2,
          computed,
          optional
        });
      }
      function optionalCallExpression(callee, _arguments, optional) {
        return (0, _validateNode.default)({
          type: "OptionalCallExpression",
          callee,
          arguments: _arguments,
          optional
        });
      }
      function classProperty(key, value = null, typeAnnotation2 = null, decorators = null, computed = false, _static = false) {
        return (0, _validateNode.default)({
          type: "ClassProperty",
          key,
          value,
          typeAnnotation: typeAnnotation2,
          decorators,
          computed,
          static: _static
        });
      }
      function classAccessorProperty(key, value = null, typeAnnotation2 = null, decorators = null, computed = false, _static = false) {
        return (0, _validateNode.default)({
          type: "ClassAccessorProperty",
          key,
          value,
          typeAnnotation: typeAnnotation2,
          decorators,
          computed,
          static: _static
        });
      }
      function classPrivateProperty(key, value = null, decorators = null, _static = false) {
        return (0, _validateNode.default)({
          type: "ClassPrivateProperty",
          key,
          value,
          decorators,
          static: _static
        });
      }
      function classPrivateMethod(kind = "method", key, params, body, _static = false) {
        return (0, _validateNode.default)({
          type: "ClassPrivateMethod",
          kind,
          key,
          params,
          body,
          static: _static
        });
      }
      function privateName(id) {
        return (0, _validateNode.default)({
          type: "PrivateName",
          id
        });
      }
      function staticBlock(body) {
        return (0, _validateNode.default)({
          type: "StaticBlock",
          body
        });
      }
      function anyTypeAnnotation() {
        return {
          type: "AnyTypeAnnotation"
        };
      }
      function arrayTypeAnnotation(elementType) {
        return (0, _validateNode.default)({
          type: "ArrayTypeAnnotation",
          elementType
        });
      }
      function booleanTypeAnnotation() {
        return {
          type: "BooleanTypeAnnotation"
        };
      }
      function booleanLiteralTypeAnnotation(value) {
        return (0, _validateNode.default)({
          type: "BooleanLiteralTypeAnnotation",
          value
        });
      }
      function nullLiteralTypeAnnotation() {
        return {
          type: "NullLiteralTypeAnnotation"
        };
      }
      function classImplements(id, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "ClassImplements",
          id,
          typeParameters
        });
      }
      function declareClass(id, typeParameters = null, _extends = null, body) {
        return (0, _validateNode.default)({
          type: "DeclareClass",
          id,
          typeParameters,
          extends: _extends,
          body
        });
      }
      function declareFunction(id) {
        return (0, _validateNode.default)({
          type: "DeclareFunction",
          id
        });
      }
      function declareInterface(id, typeParameters = null, _extends = null, body) {
        return (0, _validateNode.default)({
          type: "DeclareInterface",
          id,
          typeParameters,
          extends: _extends,
          body
        });
      }
      function declareModule(id, body, kind = null) {
        return (0, _validateNode.default)({
          type: "DeclareModule",
          id,
          body,
          kind
        });
      }
      function declareModuleExports(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "DeclareModuleExports",
          typeAnnotation: typeAnnotation2
        });
      }
      function declareTypeAlias(id, typeParameters = null, right) {
        return (0, _validateNode.default)({
          type: "DeclareTypeAlias",
          id,
          typeParameters,
          right
        });
      }
      function declareOpaqueType(id, typeParameters = null, supertype = null) {
        return (0, _validateNode.default)({
          type: "DeclareOpaqueType",
          id,
          typeParameters,
          supertype
        });
      }
      function declareVariable(id) {
        return (0, _validateNode.default)({
          type: "DeclareVariable",
          id
        });
      }
      function declareExportDeclaration(declaration = null, specifiers = null, source = null) {
        return (0, _validateNode.default)({
          type: "DeclareExportDeclaration",
          declaration,
          specifiers,
          source
        });
      }
      function declareExportAllDeclaration(source) {
        return (0, _validateNode.default)({
          type: "DeclareExportAllDeclaration",
          source
        });
      }
      function declaredPredicate(value) {
        return (0, _validateNode.default)({
          type: "DeclaredPredicate",
          value
        });
      }
      function existsTypeAnnotation() {
        return {
          type: "ExistsTypeAnnotation"
        };
      }
      function functionTypeAnnotation(typeParameters = null, params, rest2 = null, returnType) {
        return (0, _validateNode.default)({
          type: "FunctionTypeAnnotation",
          typeParameters,
          params,
          rest: rest2,
          returnType
        });
      }
      function functionTypeParam(name = null, typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "FunctionTypeParam",
          name,
          typeAnnotation: typeAnnotation2
        });
      }
      function genericTypeAnnotation(id, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "GenericTypeAnnotation",
          id,
          typeParameters
        });
      }
      function inferredPredicate() {
        return {
          type: "InferredPredicate"
        };
      }
      function interfaceExtends(id, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "InterfaceExtends",
          id,
          typeParameters
        });
      }
      function interfaceDeclaration(id, typeParameters = null, _extends = null, body) {
        return (0, _validateNode.default)({
          type: "InterfaceDeclaration",
          id,
          typeParameters,
          extends: _extends,
          body
        });
      }
      function interfaceTypeAnnotation(_extends = null, body) {
        return (0, _validateNode.default)({
          type: "InterfaceTypeAnnotation",
          extends: _extends,
          body
        });
      }
      function intersectionTypeAnnotation(types) {
        return (0, _validateNode.default)({
          type: "IntersectionTypeAnnotation",
          types
        });
      }
      function mixedTypeAnnotation() {
        return {
          type: "MixedTypeAnnotation"
        };
      }
      function emptyTypeAnnotation() {
        return {
          type: "EmptyTypeAnnotation"
        };
      }
      function nullableTypeAnnotation(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "NullableTypeAnnotation",
          typeAnnotation: typeAnnotation2
        });
      }
      function numberLiteralTypeAnnotation(value) {
        return (0, _validateNode.default)({
          type: "NumberLiteralTypeAnnotation",
          value
        });
      }
      function numberTypeAnnotation() {
        return {
          type: "NumberTypeAnnotation"
        };
      }
      function objectTypeAnnotation(properties, indexers = [], callProperties = [], internalSlots = [], exact = false) {
        return (0, _validateNode.default)({
          type: "ObjectTypeAnnotation",
          properties,
          indexers,
          callProperties,
          internalSlots,
          exact
        });
      }
      function objectTypeInternalSlot(id, value, optional, _static, method2) {
        return (0, _validateNode.default)({
          type: "ObjectTypeInternalSlot",
          id,
          value,
          optional,
          static: _static,
          method: method2
        });
      }
      function objectTypeCallProperty(value) {
        return (0, _validateNode.default)({
          type: "ObjectTypeCallProperty",
          value,
          static: null
        });
      }
      function objectTypeIndexer(id = null, key, value, variance2 = null) {
        return (0, _validateNode.default)({
          type: "ObjectTypeIndexer",
          id,
          key,
          value,
          variance: variance2,
          static: null
        });
      }
      function objectTypeProperty(key, value, variance2 = null) {
        return (0, _validateNode.default)({
          type: "ObjectTypeProperty",
          key,
          value,
          variance: variance2,
          kind: null,
          method: null,
          optional: null,
          proto: null,
          static: null
        });
      }
      function objectTypeSpreadProperty(argument) {
        return (0, _validateNode.default)({
          type: "ObjectTypeSpreadProperty",
          argument
        });
      }
      function opaqueType(id, typeParameters = null, supertype = null, impltype) {
        return (0, _validateNode.default)({
          type: "OpaqueType",
          id,
          typeParameters,
          supertype,
          impltype
        });
      }
      function qualifiedTypeIdentifier(id, qualification) {
        return (0, _validateNode.default)({
          type: "QualifiedTypeIdentifier",
          id,
          qualification
        });
      }
      function stringLiteralTypeAnnotation(value) {
        return (0, _validateNode.default)({
          type: "StringLiteralTypeAnnotation",
          value
        });
      }
      function stringTypeAnnotation() {
        return {
          type: "StringTypeAnnotation"
        };
      }
      function symbolTypeAnnotation() {
        return {
          type: "SymbolTypeAnnotation"
        };
      }
      function thisTypeAnnotation() {
        return {
          type: "ThisTypeAnnotation"
        };
      }
      function tupleTypeAnnotation(types) {
        return (0, _validateNode.default)({
          type: "TupleTypeAnnotation",
          types
        });
      }
      function typeofTypeAnnotation(argument) {
        return (0, _validateNode.default)({
          type: "TypeofTypeAnnotation",
          argument
        });
      }
      function typeAlias(id, typeParameters = null, right) {
        return (0, _validateNode.default)({
          type: "TypeAlias",
          id,
          typeParameters,
          right
        });
      }
      function typeAnnotation(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TypeAnnotation",
          typeAnnotation: typeAnnotation2
        });
      }
      function typeCastExpression(expression, typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TypeCastExpression",
          expression,
          typeAnnotation: typeAnnotation2
        });
      }
      function typeParameter(bound = null, _default = null, variance2 = null) {
        return (0, _validateNode.default)({
          type: "TypeParameter",
          bound,
          default: _default,
          variance: variance2,
          name: null
        });
      }
      function typeParameterDeclaration(params) {
        return (0, _validateNode.default)({
          type: "TypeParameterDeclaration",
          params
        });
      }
      function typeParameterInstantiation(params) {
        return (0, _validateNode.default)({
          type: "TypeParameterInstantiation",
          params
        });
      }
      function unionTypeAnnotation(types) {
        return (0, _validateNode.default)({
          type: "UnionTypeAnnotation",
          types
        });
      }
      function variance(kind) {
        return (0, _validateNode.default)({
          type: "Variance",
          kind
        });
      }
      function voidTypeAnnotation() {
        return {
          type: "VoidTypeAnnotation"
        };
      }
      function enumDeclaration(id, body) {
        return (0, _validateNode.default)({
          type: "EnumDeclaration",
          id,
          body
        });
      }
      function enumBooleanBody(members) {
        return (0, _validateNode.default)({
          type: "EnumBooleanBody",
          members,
          explicitType: null,
          hasUnknownMembers: null
        });
      }
      function enumNumberBody(members) {
        return (0, _validateNode.default)({
          type: "EnumNumberBody",
          members,
          explicitType: null,
          hasUnknownMembers: null
        });
      }
      function enumStringBody(members) {
        return (0, _validateNode.default)({
          type: "EnumStringBody",
          members,
          explicitType: null,
          hasUnknownMembers: null
        });
      }
      function enumSymbolBody(members) {
        return (0, _validateNode.default)({
          type: "EnumSymbolBody",
          members,
          hasUnknownMembers: null
        });
      }
      function enumBooleanMember(id) {
        return (0, _validateNode.default)({
          type: "EnumBooleanMember",
          id,
          init: null
        });
      }
      function enumNumberMember(id, init) {
        return (0, _validateNode.default)({
          type: "EnumNumberMember",
          id,
          init
        });
      }
      function enumStringMember(id, init) {
        return (0, _validateNode.default)({
          type: "EnumStringMember",
          id,
          init
        });
      }
      function enumDefaultedMember(id) {
        return (0, _validateNode.default)({
          type: "EnumDefaultedMember",
          id
        });
      }
      function indexedAccessType(objectType, indexType) {
        return (0, _validateNode.default)({
          type: "IndexedAccessType",
          objectType,
          indexType
        });
      }
      function optionalIndexedAccessType(objectType, indexType) {
        return (0, _validateNode.default)({
          type: "OptionalIndexedAccessType",
          objectType,
          indexType,
          optional: null
        });
      }
      function jsxAttribute(name, value = null) {
        return (0, _validateNode.default)({
          type: "JSXAttribute",
          name,
          value
        });
      }
      function jsxClosingElement(name) {
        return (0, _validateNode.default)({
          type: "JSXClosingElement",
          name
        });
      }
      function jsxElement(openingElement, closingElement = null, children, selfClosing = null) {
        return (0, _validateNode.default)({
          type: "JSXElement",
          openingElement,
          closingElement,
          children,
          selfClosing
        });
      }
      function jsxEmptyExpression() {
        return {
          type: "JSXEmptyExpression"
        };
      }
      function jsxExpressionContainer(expression) {
        return (0, _validateNode.default)({
          type: "JSXExpressionContainer",
          expression
        });
      }
      function jsxSpreadChild(expression) {
        return (0, _validateNode.default)({
          type: "JSXSpreadChild",
          expression
        });
      }
      function jsxIdentifier(name) {
        return (0, _validateNode.default)({
          type: "JSXIdentifier",
          name
        });
      }
      function jsxMemberExpression(object, property2) {
        return (0, _validateNode.default)({
          type: "JSXMemberExpression",
          object,
          property: property2
        });
      }
      function jsxNamespacedName(namespace, name) {
        return (0, _validateNode.default)({
          type: "JSXNamespacedName",
          namespace,
          name
        });
      }
      function jsxOpeningElement(name, attributes, selfClosing = false) {
        return (0, _validateNode.default)({
          type: "JSXOpeningElement",
          name,
          attributes,
          selfClosing
        });
      }
      function jsxSpreadAttribute(argument) {
        return (0, _validateNode.default)({
          type: "JSXSpreadAttribute",
          argument
        });
      }
      function jsxText(value) {
        return (0, _validateNode.default)({
          type: "JSXText",
          value
        });
      }
      function jsxFragment(openingFragment, closingFragment, children) {
        return (0, _validateNode.default)({
          type: "JSXFragment",
          openingFragment,
          closingFragment,
          children
        });
      }
      function jsxOpeningFragment() {
        return {
          type: "JSXOpeningFragment"
        };
      }
      function jsxClosingFragment() {
        return {
          type: "JSXClosingFragment"
        };
      }
      function noop3() {
        return {
          type: "Noop"
        };
      }
      function placeholder(expectedNode, name) {
        return (0, _validateNode.default)({
          type: "Placeholder",
          expectedNode,
          name
        });
      }
      function v8IntrinsicIdentifier(name) {
        return (0, _validateNode.default)({
          type: "V8IntrinsicIdentifier",
          name
        });
      }
      function argumentPlaceholder() {
        return {
          type: "ArgumentPlaceholder"
        };
      }
      function bindExpression(object, callee) {
        return (0, _validateNode.default)({
          type: "BindExpression",
          object,
          callee
        });
      }
      function importAttribute(key, value) {
        return (0, _validateNode.default)({
          type: "ImportAttribute",
          key,
          value
        });
      }
      function decorator(expression) {
        return (0, _validateNode.default)({
          type: "Decorator",
          expression
        });
      }
      function doExpression(body, async = false) {
        return (0, _validateNode.default)({
          type: "DoExpression",
          body,
          async
        });
      }
      function exportDefaultSpecifier(exported) {
        return (0, _validateNode.default)({
          type: "ExportDefaultSpecifier",
          exported
        });
      }
      function recordExpression(properties) {
        return (0, _validateNode.default)({
          type: "RecordExpression",
          properties
        });
      }
      function tupleExpression(elements = []) {
        return (0, _validateNode.default)({
          type: "TupleExpression",
          elements
        });
      }
      function decimalLiteral(value) {
        return (0, _validateNode.default)({
          type: "DecimalLiteral",
          value
        });
      }
      function moduleExpression(body) {
        return (0, _validateNode.default)({
          type: "ModuleExpression",
          body
        });
      }
      function topicReference() {
        return {
          type: "TopicReference"
        };
      }
      function pipelineTopicExpression(expression) {
        return (0, _validateNode.default)({
          type: "PipelineTopicExpression",
          expression
        });
      }
      function pipelineBareFunction(callee) {
        return (0, _validateNode.default)({
          type: "PipelineBareFunction",
          callee
        });
      }
      function pipelinePrimaryTopicReference() {
        return {
          type: "PipelinePrimaryTopicReference"
        };
      }
      function tsParameterProperty(parameter) {
        return (0, _validateNode.default)({
          type: "TSParameterProperty",
          parameter
        });
      }
      function tsDeclareFunction(id = null, typeParameters = null, params, returnType = null) {
        return (0, _validateNode.default)({
          type: "TSDeclareFunction",
          id,
          typeParameters,
          params,
          returnType
        });
      }
      function tsDeclareMethod(decorators = null, key, typeParameters = null, params, returnType = null) {
        return (0, _validateNode.default)({
          type: "TSDeclareMethod",
          decorators,
          key,
          typeParameters,
          params,
          returnType
        });
      }
      function tsQualifiedName(left, right) {
        return (0, _validateNode.default)({
          type: "TSQualifiedName",
          left,
          right
        });
      }
      function tsCallSignatureDeclaration(typeParameters = null, parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSCallSignatureDeclaration",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsConstructSignatureDeclaration(typeParameters = null, parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSConstructSignatureDeclaration",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsPropertySignature(key, typeAnnotation2 = null, initializer = null) {
        return (0, _validateNode.default)({
          type: "TSPropertySignature",
          key,
          typeAnnotation: typeAnnotation2,
          initializer,
          kind: null
        });
      }
      function tsMethodSignature(key, typeParameters = null, parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSMethodSignature",
          key,
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2,
          kind: null
        });
      }
      function tsIndexSignature(parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSIndexSignature",
          parameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsAnyKeyword() {
        return {
          type: "TSAnyKeyword"
        };
      }
      function tsBooleanKeyword() {
        return {
          type: "TSBooleanKeyword"
        };
      }
      function tsBigIntKeyword() {
        return {
          type: "TSBigIntKeyword"
        };
      }
      function tsIntrinsicKeyword() {
        return {
          type: "TSIntrinsicKeyword"
        };
      }
      function tsNeverKeyword() {
        return {
          type: "TSNeverKeyword"
        };
      }
      function tsNullKeyword() {
        return {
          type: "TSNullKeyword"
        };
      }
      function tsNumberKeyword() {
        return {
          type: "TSNumberKeyword"
        };
      }
      function tsObjectKeyword() {
        return {
          type: "TSObjectKeyword"
        };
      }
      function tsStringKeyword() {
        return {
          type: "TSStringKeyword"
        };
      }
      function tsSymbolKeyword() {
        return {
          type: "TSSymbolKeyword"
        };
      }
      function tsUndefinedKeyword() {
        return {
          type: "TSUndefinedKeyword"
        };
      }
      function tsUnknownKeyword() {
        return {
          type: "TSUnknownKeyword"
        };
      }
      function tsVoidKeyword() {
        return {
          type: "TSVoidKeyword"
        };
      }
      function tsThisType() {
        return {
          type: "TSThisType"
        };
      }
      function tsFunctionType(typeParameters = null, parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSFunctionType",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsConstructorType(typeParameters = null, parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSConstructorType",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsTypeReference(typeName, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "TSTypeReference",
          typeName,
          typeParameters
        });
      }
      function tsTypePredicate(parameterName, typeAnnotation2 = null, asserts = null) {
        return (0, _validateNode.default)({
          type: "TSTypePredicate",
          parameterName,
          typeAnnotation: typeAnnotation2,
          asserts
        });
      }
      function tsTypeQuery(exprName, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "TSTypeQuery",
          exprName,
          typeParameters
        });
      }
      function tsTypeLiteral(members) {
        return (0, _validateNode.default)({
          type: "TSTypeLiteral",
          members
        });
      }
      function tsArrayType(elementType) {
        return (0, _validateNode.default)({
          type: "TSArrayType",
          elementType
        });
      }
      function tsTupleType(elementTypes) {
        return (0, _validateNode.default)({
          type: "TSTupleType",
          elementTypes
        });
      }
      function tsOptionalType(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSOptionalType",
          typeAnnotation: typeAnnotation2
        });
      }
      function tsRestType(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSRestType",
          typeAnnotation: typeAnnotation2
        });
      }
      function tsNamedTupleMember(label, elementType, optional = false) {
        return (0, _validateNode.default)({
          type: "TSNamedTupleMember",
          label,
          elementType,
          optional
        });
      }
      function tsUnionType(types) {
        return (0, _validateNode.default)({
          type: "TSUnionType",
          types
        });
      }
      function tsIntersectionType(types) {
        return (0, _validateNode.default)({
          type: "TSIntersectionType",
          types
        });
      }
      function tsConditionalType(checkType, extendsType, trueType, falseType) {
        return (0, _validateNode.default)({
          type: "TSConditionalType",
          checkType,
          extendsType,
          trueType,
          falseType
        });
      }
      function tsInferType(typeParameter2) {
        return (0, _validateNode.default)({
          type: "TSInferType",
          typeParameter: typeParameter2
        });
      }
      function tsParenthesizedType(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSParenthesizedType",
          typeAnnotation: typeAnnotation2
        });
      }
      function tsTypeOperator(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSTypeOperator",
          typeAnnotation: typeAnnotation2,
          operator: null
        });
      }
      function tsIndexedAccessType(objectType, indexType) {
        return (0, _validateNode.default)({
          type: "TSIndexedAccessType",
          objectType,
          indexType
        });
      }
      function tsMappedType(typeParameter2, typeAnnotation2 = null, nameType = null) {
        return (0, _validateNode.default)({
          type: "TSMappedType",
          typeParameter: typeParameter2,
          typeAnnotation: typeAnnotation2,
          nameType
        });
      }
      function tsLiteralType(literal) {
        return (0, _validateNode.default)({
          type: "TSLiteralType",
          literal
        });
      }
      function tsExpressionWithTypeArguments(expression, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "TSExpressionWithTypeArguments",
          expression,
          typeParameters
        });
      }
      function tsInterfaceDeclaration(id, typeParameters = null, _extends = null, body) {
        return (0, _validateNode.default)({
          type: "TSInterfaceDeclaration",
          id,
          typeParameters,
          extends: _extends,
          body
        });
      }
      function tsInterfaceBody(body) {
        return (0, _validateNode.default)({
          type: "TSInterfaceBody",
          body
        });
      }
      function tsTypeAliasDeclaration(id, typeParameters = null, typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSTypeAliasDeclaration",
          id,
          typeParameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsInstantiationExpression(expression, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "TSInstantiationExpression",
          expression,
          typeParameters
        });
      }
      function tsAsExpression(expression, typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSAsExpression",
          expression,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsSatisfiesExpression(expression, typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSSatisfiesExpression",
          expression,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsTypeAssertion(typeAnnotation2, expression) {
        return (0, _validateNode.default)({
          type: "TSTypeAssertion",
          typeAnnotation: typeAnnotation2,
          expression
        });
      }
      function tsEnumDeclaration(id, members) {
        return (0, _validateNode.default)({
          type: "TSEnumDeclaration",
          id,
          members
        });
      }
      function tsEnumMember(id, initializer = null) {
        return (0, _validateNode.default)({
          type: "TSEnumMember",
          id,
          initializer
        });
      }
      function tsModuleDeclaration(id, body) {
        return (0, _validateNode.default)({
          type: "TSModuleDeclaration",
          id,
          body
        });
      }
      function tsModuleBlock(body) {
        return (0, _validateNode.default)({
          type: "TSModuleBlock",
          body
        });
      }
      function tsImportType(argument, qualifier = null, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "TSImportType",
          argument,
          qualifier,
          typeParameters
        });
      }
      function tsImportEqualsDeclaration(id, moduleReference) {
        return (0, _validateNode.default)({
          type: "TSImportEqualsDeclaration",
          id,
          moduleReference,
          isExport: null
        });
      }
      function tsExternalModuleReference(expression) {
        return (0, _validateNode.default)({
          type: "TSExternalModuleReference",
          expression
        });
      }
      function tsNonNullExpression(expression) {
        return (0, _validateNode.default)({
          type: "TSNonNullExpression",
          expression
        });
      }
      function tsExportAssignment(expression) {
        return (0, _validateNode.default)({
          type: "TSExportAssignment",
          expression
        });
      }
      function tsNamespaceExportDeclaration(id) {
        return (0, _validateNode.default)({
          type: "TSNamespaceExportDeclaration",
          id
        });
      }
      function tsTypeAnnotation(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSTypeAnnotation",
          typeAnnotation: typeAnnotation2
        });
      }
      function tsTypeParameterInstantiation(params) {
        return (0, _validateNode.default)({
          type: "TSTypeParameterInstantiation",
          params
        });
      }
      function tsTypeParameterDeclaration(params) {
        return (0, _validateNode.default)({
          type: "TSTypeParameterDeclaration",
          params
        });
      }
      function tsTypeParameter(constraint = null, _default = null, name) {
        return (0, _validateNode.default)({
          type: "TSTypeParameter",
          constraint,
          default: _default,
          name
        });
      }
      function NumberLiteral(value) {
        console.trace("The node type NumberLiteral has been renamed to NumericLiteral");
        return numericLiteral(value);
      }
      function RegexLiteral(pattern, flags = "") {
        console.trace("The node type RegexLiteral has been renamed to RegExpLiteral");
        return regExpLiteral(pattern, flags);
      }
      function RestProperty(argument) {
        console.trace("The node type RestProperty has been renamed to RestElement");
        return restElement(argument);
      }
      function SpreadProperty(argument) {
        console.trace("The node type SpreadProperty has been renamed to SpreadElement");
        return spreadElement(argument);
      }
    }
  });

  // node_modules/@babel/types/lib/utils/react/cleanJSXElementLiteralChild.js
  var require_cleanJSXElementLiteralChild = __commonJS({
    "node_modules/@babel/types/lib/utils/react/cleanJSXElementLiteralChild.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = cleanJSXElementLiteralChild;
      var _generated = require_generated2();
      function cleanJSXElementLiteralChild(child, args) {
        const lines = child.value.split(/\r\n|\n|\r/);
        let lastNonEmptyLine = 0;
        for (let i = 0; i < lines.length; i++) {
          if (lines[i].match(/[^ \t]/)) {
            lastNonEmptyLine = i;
          }
        }
        let str = "";
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          const isFirstLine = i === 0;
          const isLastLine = i === lines.length - 1;
          const isLastNonEmptyLine = i === lastNonEmptyLine;
          let trimmedLine = line.replace(/\t/g, " ");
          if (!isFirstLine) {
            trimmedLine = trimmedLine.replace(/^[ ]+/, "");
          }
          if (!isLastLine) {
            trimmedLine = trimmedLine.replace(/[ ]+$/, "");
          }
          if (trimmedLine) {
            if (!isLastNonEmptyLine) {
              trimmedLine += " ";
            }
            str += trimmedLine;
          }
        }
        if (str)
          args.push((0, _generated.stringLiteral)(str));
      }
    }
  });

  // node_modules/@babel/types/lib/builders/react/buildChildren.js
  var require_buildChildren = __commonJS({
    "node_modules/@babel/types/lib/builders/react/buildChildren.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = buildChildren;
      var _generated = require_generated();
      var _cleanJSXElementLiteralChild = require_cleanJSXElementLiteralChild();
      function buildChildren(node) {
        const elements = [];
        for (let i = 0; i < node.children.length; i++) {
          let child = node.children[i];
          if ((0, _generated.isJSXText)(child)) {
            (0, _cleanJSXElementLiteralChild.default)(child, elements);
            continue;
          }
          if ((0, _generated.isJSXExpressionContainer)(child))
            child = child.expression;
          if ((0, _generated.isJSXEmptyExpression)(child))
            continue;
          elements.push(child);
        }
        return elements;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isNode.js
  var require_isNode = __commonJS({
    "node_modules/@babel/types/lib/validators/isNode.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isNode;
      var _definitions = require_definitions();
      function isNode(node) {
        return !!(node && _definitions.VISITOR_KEYS[node.type]);
      }
    }
  });

  // node_modules/@babel/types/lib/asserts/assertNode.js
  var require_assertNode = __commonJS({
    "node_modules/@babel/types/lib/asserts/assertNode.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = assertNode;
      var _isNode = require_isNode();
      function assertNode(node) {
        if (!(0, _isNode.default)(node)) {
          var _node$type;
          const type = (_node$type = node == null ? void 0 : node.type) != null ? _node$type : JSON.stringify(node);
          throw new TypeError(`Not a valid node of type "${type}"`);
        }
      }
    }
  });

  // node_modules/@babel/types/lib/asserts/generated/index.js
  var require_generated3 = __commonJS({
    "node_modules/@babel/types/lib/asserts/generated/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.assertAccessor = assertAccessor;
      exports2.assertAnyTypeAnnotation = assertAnyTypeAnnotation;
      exports2.assertArgumentPlaceholder = assertArgumentPlaceholder;
      exports2.assertArrayExpression = assertArrayExpression;
      exports2.assertArrayPattern = assertArrayPattern;
      exports2.assertArrayTypeAnnotation = assertArrayTypeAnnotation;
      exports2.assertArrowFunctionExpression = assertArrowFunctionExpression;
      exports2.assertAssignmentExpression = assertAssignmentExpression;
      exports2.assertAssignmentPattern = assertAssignmentPattern;
      exports2.assertAwaitExpression = assertAwaitExpression;
      exports2.assertBigIntLiteral = assertBigIntLiteral;
      exports2.assertBinary = assertBinary;
      exports2.assertBinaryExpression = assertBinaryExpression;
      exports2.assertBindExpression = assertBindExpression;
      exports2.assertBlock = assertBlock;
      exports2.assertBlockParent = assertBlockParent;
      exports2.assertBlockStatement = assertBlockStatement;
      exports2.assertBooleanLiteral = assertBooleanLiteral;
      exports2.assertBooleanLiteralTypeAnnotation = assertBooleanLiteralTypeAnnotation;
      exports2.assertBooleanTypeAnnotation = assertBooleanTypeAnnotation;
      exports2.assertBreakStatement = assertBreakStatement;
      exports2.assertCallExpression = assertCallExpression;
      exports2.assertCatchClause = assertCatchClause;
      exports2.assertClass = assertClass;
      exports2.assertClassAccessorProperty = assertClassAccessorProperty;
      exports2.assertClassBody = assertClassBody;
      exports2.assertClassDeclaration = assertClassDeclaration;
      exports2.assertClassExpression = assertClassExpression;
      exports2.assertClassImplements = assertClassImplements;
      exports2.assertClassMethod = assertClassMethod;
      exports2.assertClassPrivateMethod = assertClassPrivateMethod;
      exports2.assertClassPrivateProperty = assertClassPrivateProperty;
      exports2.assertClassProperty = assertClassProperty;
      exports2.assertCompletionStatement = assertCompletionStatement;
      exports2.assertConditional = assertConditional;
      exports2.assertConditionalExpression = assertConditionalExpression;
      exports2.assertContinueStatement = assertContinueStatement;
      exports2.assertDebuggerStatement = assertDebuggerStatement;
      exports2.assertDecimalLiteral = assertDecimalLiteral;
      exports2.assertDeclaration = assertDeclaration;
      exports2.assertDeclareClass = assertDeclareClass;
      exports2.assertDeclareExportAllDeclaration = assertDeclareExportAllDeclaration;
      exports2.assertDeclareExportDeclaration = assertDeclareExportDeclaration;
      exports2.assertDeclareFunction = assertDeclareFunction;
      exports2.assertDeclareInterface = assertDeclareInterface;
      exports2.assertDeclareModule = assertDeclareModule;
      exports2.assertDeclareModuleExports = assertDeclareModuleExports;
      exports2.assertDeclareOpaqueType = assertDeclareOpaqueType;
      exports2.assertDeclareTypeAlias = assertDeclareTypeAlias;
      exports2.assertDeclareVariable = assertDeclareVariable;
      exports2.assertDeclaredPredicate = assertDeclaredPredicate;
      exports2.assertDecorator = assertDecorator;
      exports2.assertDirective = assertDirective;
      exports2.assertDirectiveLiteral = assertDirectiveLiteral;
      exports2.assertDoExpression = assertDoExpression;
      exports2.assertDoWhileStatement = assertDoWhileStatement;
      exports2.assertEmptyStatement = assertEmptyStatement;
      exports2.assertEmptyTypeAnnotation = assertEmptyTypeAnnotation;
      exports2.assertEnumBody = assertEnumBody;
      exports2.assertEnumBooleanBody = assertEnumBooleanBody;
      exports2.assertEnumBooleanMember = assertEnumBooleanMember;
      exports2.assertEnumDeclaration = assertEnumDeclaration;
      exports2.assertEnumDefaultedMember = assertEnumDefaultedMember;
      exports2.assertEnumMember = assertEnumMember;
      exports2.assertEnumNumberBody = assertEnumNumberBody;
      exports2.assertEnumNumberMember = assertEnumNumberMember;
      exports2.assertEnumStringBody = assertEnumStringBody;
      exports2.assertEnumStringMember = assertEnumStringMember;
      exports2.assertEnumSymbolBody = assertEnumSymbolBody;
      exports2.assertExistsTypeAnnotation = assertExistsTypeAnnotation;
      exports2.assertExportAllDeclaration = assertExportAllDeclaration;
      exports2.assertExportDeclaration = assertExportDeclaration;
      exports2.assertExportDefaultDeclaration = assertExportDefaultDeclaration;
      exports2.assertExportDefaultSpecifier = assertExportDefaultSpecifier;
      exports2.assertExportNamedDeclaration = assertExportNamedDeclaration;
      exports2.assertExportNamespaceSpecifier = assertExportNamespaceSpecifier;
      exports2.assertExportSpecifier = assertExportSpecifier;
      exports2.assertExpression = assertExpression;
      exports2.assertExpressionStatement = assertExpressionStatement;
      exports2.assertExpressionWrapper = assertExpressionWrapper;
      exports2.assertFile = assertFile;
      exports2.assertFlow = assertFlow;
      exports2.assertFlowBaseAnnotation = assertFlowBaseAnnotation;
      exports2.assertFlowDeclaration = assertFlowDeclaration;
      exports2.assertFlowPredicate = assertFlowPredicate;
      exports2.assertFlowType = assertFlowType;
      exports2.assertFor = assertFor;
      exports2.assertForInStatement = assertForInStatement;
      exports2.assertForOfStatement = assertForOfStatement;
      exports2.assertForStatement = assertForStatement;
      exports2.assertForXStatement = assertForXStatement;
      exports2.assertFunction = assertFunction;
      exports2.assertFunctionDeclaration = assertFunctionDeclaration;
      exports2.assertFunctionExpression = assertFunctionExpression;
      exports2.assertFunctionParent = assertFunctionParent;
      exports2.assertFunctionTypeAnnotation = assertFunctionTypeAnnotation;
      exports2.assertFunctionTypeParam = assertFunctionTypeParam;
      exports2.assertGenericTypeAnnotation = assertGenericTypeAnnotation;
      exports2.assertIdentifier = assertIdentifier;
      exports2.assertIfStatement = assertIfStatement;
      exports2.assertImmutable = assertImmutable;
      exports2.assertImport = assertImport;
      exports2.assertImportAttribute = assertImportAttribute;
      exports2.assertImportDeclaration = assertImportDeclaration;
      exports2.assertImportDefaultSpecifier = assertImportDefaultSpecifier;
      exports2.assertImportNamespaceSpecifier = assertImportNamespaceSpecifier;
      exports2.assertImportSpecifier = assertImportSpecifier;
      exports2.assertIndexedAccessType = assertIndexedAccessType;
      exports2.assertInferredPredicate = assertInferredPredicate;
      exports2.assertInterfaceDeclaration = assertInterfaceDeclaration;
      exports2.assertInterfaceExtends = assertInterfaceExtends;
      exports2.assertInterfaceTypeAnnotation = assertInterfaceTypeAnnotation;
      exports2.assertInterpreterDirective = assertInterpreterDirective;
      exports2.assertIntersectionTypeAnnotation = assertIntersectionTypeAnnotation;
      exports2.assertJSX = assertJSX;
      exports2.assertJSXAttribute = assertJSXAttribute;
      exports2.assertJSXClosingElement = assertJSXClosingElement;
      exports2.assertJSXClosingFragment = assertJSXClosingFragment;
      exports2.assertJSXElement = assertJSXElement;
      exports2.assertJSXEmptyExpression = assertJSXEmptyExpression;
      exports2.assertJSXExpressionContainer = assertJSXExpressionContainer;
      exports2.assertJSXFragment = assertJSXFragment;
      exports2.assertJSXIdentifier = assertJSXIdentifier;
      exports2.assertJSXMemberExpression = assertJSXMemberExpression;
      exports2.assertJSXNamespacedName = assertJSXNamespacedName;
      exports2.assertJSXOpeningElement = assertJSXOpeningElement;
      exports2.assertJSXOpeningFragment = assertJSXOpeningFragment;
      exports2.assertJSXSpreadAttribute = assertJSXSpreadAttribute;
      exports2.assertJSXSpreadChild = assertJSXSpreadChild;
      exports2.assertJSXText = assertJSXText;
      exports2.assertLVal = assertLVal;
      exports2.assertLabeledStatement = assertLabeledStatement;
      exports2.assertLiteral = assertLiteral;
      exports2.assertLogicalExpression = assertLogicalExpression;
      exports2.assertLoop = assertLoop;
      exports2.assertMemberExpression = assertMemberExpression;
      exports2.assertMetaProperty = assertMetaProperty;
      exports2.assertMethod = assertMethod;
      exports2.assertMiscellaneous = assertMiscellaneous;
      exports2.assertMixedTypeAnnotation = assertMixedTypeAnnotation;
      exports2.assertModuleDeclaration = assertModuleDeclaration;
      exports2.assertModuleExpression = assertModuleExpression;
      exports2.assertModuleSpecifier = assertModuleSpecifier;
      exports2.assertNewExpression = assertNewExpression;
      exports2.assertNoop = assertNoop;
      exports2.assertNullLiteral = assertNullLiteral;
      exports2.assertNullLiteralTypeAnnotation = assertNullLiteralTypeAnnotation;
      exports2.assertNullableTypeAnnotation = assertNullableTypeAnnotation;
      exports2.assertNumberLiteral = assertNumberLiteral;
      exports2.assertNumberLiteralTypeAnnotation = assertNumberLiteralTypeAnnotation;
      exports2.assertNumberTypeAnnotation = assertNumberTypeAnnotation;
      exports2.assertNumericLiteral = assertNumericLiteral;
      exports2.assertObjectExpression = assertObjectExpression;
      exports2.assertObjectMember = assertObjectMember;
      exports2.assertObjectMethod = assertObjectMethod;
      exports2.assertObjectPattern = assertObjectPattern;
      exports2.assertObjectProperty = assertObjectProperty;
      exports2.assertObjectTypeAnnotation = assertObjectTypeAnnotation;
      exports2.assertObjectTypeCallProperty = assertObjectTypeCallProperty;
      exports2.assertObjectTypeIndexer = assertObjectTypeIndexer;
      exports2.assertObjectTypeInternalSlot = assertObjectTypeInternalSlot;
      exports2.assertObjectTypeProperty = assertObjectTypeProperty;
      exports2.assertObjectTypeSpreadProperty = assertObjectTypeSpreadProperty;
      exports2.assertOpaqueType = assertOpaqueType;
      exports2.assertOptionalCallExpression = assertOptionalCallExpression;
      exports2.assertOptionalIndexedAccessType = assertOptionalIndexedAccessType;
      exports2.assertOptionalMemberExpression = assertOptionalMemberExpression;
      exports2.assertParenthesizedExpression = assertParenthesizedExpression;
      exports2.assertPattern = assertPattern;
      exports2.assertPatternLike = assertPatternLike;
      exports2.assertPipelineBareFunction = assertPipelineBareFunction;
      exports2.assertPipelinePrimaryTopicReference = assertPipelinePrimaryTopicReference;
      exports2.assertPipelineTopicExpression = assertPipelineTopicExpression;
      exports2.assertPlaceholder = assertPlaceholder;
      exports2.assertPrivate = assertPrivate;
      exports2.assertPrivateName = assertPrivateName;
      exports2.assertProgram = assertProgram;
      exports2.assertProperty = assertProperty;
      exports2.assertPureish = assertPureish;
      exports2.assertQualifiedTypeIdentifier = assertQualifiedTypeIdentifier;
      exports2.assertRecordExpression = assertRecordExpression;
      exports2.assertRegExpLiteral = assertRegExpLiteral;
      exports2.assertRegexLiteral = assertRegexLiteral;
      exports2.assertRestElement = assertRestElement;
      exports2.assertRestProperty = assertRestProperty;
      exports2.assertReturnStatement = assertReturnStatement;
      exports2.assertScopable = assertScopable;
      exports2.assertSequenceExpression = assertSequenceExpression;
      exports2.assertSpreadElement = assertSpreadElement;
      exports2.assertSpreadProperty = assertSpreadProperty;
      exports2.assertStandardized = assertStandardized;
      exports2.assertStatement = assertStatement;
      exports2.assertStaticBlock = assertStaticBlock;
      exports2.assertStringLiteral = assertStringLiteral;
      exports2.assertStringLiteralTypeAnnotation = assertStringLiteralTypeAnnotation;
      exports2.assertStringTypeAnnotation = assertStringTypeAnnotation;
      exports2.assertSuper = assertSuper;
      exports2.assertSwitchCase = assertSwitchCase;
      exports2.assertSwitchStatement = assertSwitchStatement;
      exports2.assertSymbolTypeAnnotation = assertSymbolTypeAnnotation;
      exports2.assertTSAnyKeyword = assertTSAnyKeyword;
      exports2.assertTSArrayType = assertTSArrayType;
      exports2.assertTSAsExpression = assertTSAsExpression;
      exports2.assertTSBaseType = assertTSBaseType;
      exports2.assertTSBigIntKeyword = assertTSBigIntKeyword;
      exports2.assertTSBooleanKeyword = assertTSBooleanKeyword;
      exports2.assertTSCallSignatureDeclaration = assertTSCallSignatureDeclaration;
      exports2.assertTSConditionalType = assertTSConditionalType;
      exports2.assertTSConstructSignatureDeclaration = assertTSConstructSignatureDeclaration;
      exports2.assertTSConstructorType = assertTSConstructorType;
      exports2.assertTSDeclareFunction = assertTSDeclareFunction;
      exports2.assertTSDeclareMethod = assertTSDeclareMethod;
      exports2.assertTSEntityName = assertTSEntityName;
      exports2.assertTSEnumDeclaration = assertTSEnumDeclaration;
      exports2.assertTSEnumMember = assertTSEnumMember;
      exports2.assertTSExportAssignment = assertTSExportAssignment;
      exports2.assertTSExpressionWithTypeArguments = assertTSExpressionWithTypeArguments;
      exports2.assertTSExternalModuleReference = assertTSExternalModuleReference;
      exports2.assertTSFunctionType = assertTSFunctionType;
      exports2.assertTSImportEqualsDeclaration = assertTSImportEqualsDeclaration;
      exports2.assertTSImportType = assertTSImportType;
      exports2.assertTSIndexSignature = assertTSIndexSignature;
      exports2.assertTSIndexedAccessType = assertTSIndexedAccessType;
      exports2.assertTSInferType = assertTSInferType;
      exports2.assertTSInstantiationExpression = assertTSInstantiationExpression;
      exports2.assertTSInterfaceBody = assertTSInterfaceBody;
      exports2.assertTSInterfaceDeclaration = assertTSInterfaceDeclaration;
      exports2.assertTSIntersectionType = assertTSIntersectionType;
      exports2.assertTSIntrinsicKeyword = assertTSIntrinsicKeyword;
      exports2.assertTSLiteralType = assertTSLiteralType;
      exports2.assertTSMappedType = assertTSMappedType;
      exports2.assertTSMethodSignature = assertTSMethodSignature;
      exports2.assertTSModuleBlock = assertTSModuleBlock;
      exports2.assertTSModuleDeclaration = assertTSModuleDeclaration;
      exports2.assertTSNamedTupleMember = assertTSNamedTupleMember;
      exports2.assertTSNamespaceExportDeclaration = assertTSNamespaceExportDeclaration;
      exports2.assertTSNeverKeyword = assertTSNeverKeyword;
      exports2.assertTSNonNullExpression = assertTSNonNullExpression;
      exports2.assertTSNullKeyword = assertTSNullKeyword;
      exports2.assertTSNumberKeyword = assertTSNumberKeyword;
      exports2.assertTSObjectKeyword = assertTSObjectKeyword;
      exports2.assertTSOptionalType = assertTSOptionalType;
      exports2.assertTSParameterProperty = assertTSParameterProperty;
      exports2.assertTSParenthesizedType = assertTSParenthesizedType;
      exports2.assertTSPropertySignature = assertTSPropertySignature;
      exports2.assertTSQualifiedName = assertTSQualifiedName;
      exports2.assertTSRestType = assertTSRestType;
      exports2.assertTSSatisfiesExpression = assertTSSatisfiesExpression;
      exports2.assertTSStringKeyword = assertTSStringKeyword;
      exports2.assertTSSymbolKeyword = assertTSSymbolKeyword;
      exports2.assertTSThisType = assertTSThisType;
      exports2.assertTSTupleType = assertTSTupleType;
      exports2.assertTSType = assertTSType;
      exports2.assertTSTypeAliasDeclaration = assertTSTypeAliasDeclaration;
      exports2.assertTSTypeAnnotation = assertTSTypeAnnotation;
      exports2.assertTSTypeAssertion = assertTSTypeAssertion;
      exports2.assertTSTypeElement = assertTSTypeElement;
      exports2.assertTSTypeLiteral = assertTSTypeLiteral;
      exports2.assertTSTypeOperator = assertTSTypeOperator;
      exports2.assertTSTypeParameter = assertTSTypeParameter;
      exports2.assertTSTypeParameterDeclaration = assertTSTypeParameterDeclaration;
      exports2.assertTSTypeParameterInstantiation = assertTSTypeParameterInstantiation;
      exports2.assertTSTypePredicate = assertTSTypePredicate;
      exports2.assertTSTypeQuery = assertTSTypeQuery;
      exports2.assertTSTypeReference = assertTSTypeReference;
      exports2.assertTSUndefinedKeyword = assertTSUndefinedKeyword;
      exports2.assertTSUnionType = assertTSUnionType;
      exports2.assertTSUnknownKeyword = assertTSUnknownKeyword;
      exports2.assertTSVoidKeyword = assertTSVoidKeyword;
      exports2.assertTaggedTemplateExpression = assertTaggedTemplateExpression;
      exports2.assertTemplateElement = assertTemplateElement;
      exports2.assertTemplateLiteral = assertTemplateLiteral;
      exports2.assertTerminatorless = assertTerminatorless;
      exports2.assertThisExpression = assertThisExpression;
      exports2.assertThisTypeAnnotation = assertThisTypeAnnotation;
      exports2.assertThrowStatement = assertThrowStatement;
      exports2.assertTopicReference = assertTopicReference;
      exports2.assertTryStatement = assertTryStatement;
      exports2.assertTupleExpression = assertTupleExpression;
      exports2.assertTupleTypeAnnotation = assertTupleTypeAnnotation;
      exports2.assertTypeAlias = assertTypeAlias;
      exports2.assertTypeAnnotation = assertTypeAnnotation;
      exports2.assertTypeCastExpression = assertTypeCastExpression;
      exports2.assertTypeParameter = assertTypeParameter;
      exports2.assertTypeParameterDeclaration = assertTypeParameterDeclaration;
      exports2.assertTypeParameterInstantiation = assertTypeParameterInstantiation;
      exports2.assertTypeScript = assertTypeScript;
      exports2.assertTypeofTypeAnnotation = assertTypeofTypeAnnotation;
      exports2.assertUnaryExpression = assertUnaryExpression;
      exports2.assertUnaryLike = assertUnaryLike;
      exports2.assertUnionTypeAnnotation = assertUnionTypeAnnotation;
      exports2.assertUpdateExpression = assertUpdateExpression;
      exports2.assertUserWhitespacable = assertUserWhitespacable;
      exports2.assertV8IntrinsicIdentifier = assertV8IntrinsicIdentifier;
      exports2.assertVariableDeclaration = assertVariableDeclaration;
      exports2.assertVariableDeclarator = assertVariableDeclarator;
      exports2.assertVariance = assertVariance;
      exports2.assertVoidTypeAnnotation = assertVoidTypeAnnotation;
      exports2.assertWhile = assertWhile;
      exports2.assertWhileStatement = assertWhileStatement;
      exports2.assertWithStatement = assertWithStatement;
      exports2.assertYieldExpression = assertYieldExpression;
      var _is = require_is();
      function assert(type, node, opts) {
        if (!(0, _is.default)(type, node, opts)) {
          throw new Error(`Expected type "${type}" with option ${JSON.stringify(opts)}, but instead got "${node.type}".`);
        }
      }
      function assertArrayExpression(node, opts) {
        assert("ArrayExpression", node, opts);
      }
      function assertAssignmentExpression(node, opts) {
        assert("AssignmentExpression", node, opts);
      }
      function assertBinaryExpression(node, opts) {
        assert("BinaryExpression", node, opts);
      }
      function assertInterpreterDirective(node, opts) {
        assert("InterpreterDirective", node, opts);
      }
      function assertDirective(node, opts) {
        assert("Directive", node, opts);
      }
      function assertDirectiveLiteral(node, opts) {
        assert("DirectiveLiteral", node, opts);
      }
      function assertBlockStatement(node, opts) {
        assert("BlockStatement", node, opts);
      }
      function assertBreakStatement(node, opts) {
        assert("BreakStatement", node, opts);
      }
      function assertCallExpression(node, opts) {
        assert("CallExpression", node, opts);
      }
      function assertCatchClause(node, opts) {
        assert("CatchClause", node, opts);
      }
      function assertConditionalExpression(node, opts) {
        assert("ConditionalExpression", node, opts);
      }
      function assertContinueStatement(node, opts) {
        assert("ContinueStatement", node, opts);
      }
      function assertDebuggerStatement(node, opts) {
        assert("DebuggerStatement", node, opts);
      }
      function assertDoWhileStatement(node, opts) {
        assert("DoWhileStatement", node, opts);
      }
      function assertEmptyStatement(node, opts) {
        assert("EmptyStatement", node, opts);
      }
      function assertExpressionStatement(node, opts) {
        assert("ExpressionStatement", node, opts);
      }
      function assertFile(node, opts) {
        assert("File", node, opts);
      }
      function assertForInStatement(node, opts) {
        assert("ForInStatement", node, opts);
      }
      function assertForStatement(node, opts) {
        assert("ForStatement", node, opts);
      }
      function assertFunctionDeclaration(node, opts) {
        assert("FunctionDeclaration", node, opts);
      }
      function assertFunctionExpression(node, opts) {
        assert("FunctionExpression", node, opts);
      }
      function assertIdentifier(node, opts) {
        assert("Identifier", node, opts);
      }
      function assertIfStatement(node, opts) {
        assert("IfStatement", node, opts);
      }
      function assertLabeledStatement(node, opts) {
        assert("LabeledStatement", node, opts);
      }
      function assertStringLiteral(node, opts) {
        assert("StringLiteral", node, opts);
      }
      function assertNumericLiteral(node, opts) {
        assert("NumericLiteral", node, opts);
      }
      function assertNullLiteral(node, opts) {
        assert("NullLiteral", node, opts);
      }
      function assertBooleanLiteral(node, opts) {
        assert("BooleanLiteral", node, opts);
      }
      function assertRegExpLiteral(node, opts) {
        assert("RegExpLiteral", node, opts);
      }
      function assertLogicalExpression(node, opts) {
        assert("LogicalExpression", node, opts);
      }
      function assertMemberExpression(node, opts) {
        assert("MemberExpression", node, opts);
      }
      function assertNewExpression(node, opts) {
        assert("NewExpression", node, opts);
      }
      function assertProgram(node, opts) {
        assert("Program", node, opts);
      }
      function assertObjectExpression(node, opts) {
        assert("ObjectExpression", node, opts);
      }
      function assertObjectMethod(node, opts) {
        assert("ObjectMethod", node, opts);
      }
      function assertObjectProperty(node, opts) {
        assert("ObjectProperty", node, opts);
      }
      function assertRestElement(node, opts) {
        assert("RestElement", node, opts);
      }
      function assertReturnStatement(node, opts) {
        assert("ReturnStatement", node, opts);
      }
      function assertSequenceExpression(node, opts) {
        assert("SequenceExpression", node, opts);
      }
      function assertParenthesizedExpression(node, opts) {
        assert("ParenthesizedExpression", node, opts);
      }
      function assertSwitchCase(node, opts) {
        assert("SwitchCase", node, opts);
      }
      function assertSwitchStatement(node, opts) {
        assert("SwitchStatement", node, opts);
      }
      function assertThisExpression(node, opts) {
        assert("ThisExpression", node, opts);
      }
      function assertThrowStatement(node, opts) {
        assert("ThrowStatement", node, opts);
      }
      function assertTryStatement(node, opts) {
        assert("TryStatement", node, opts);
      }
      function assertUnaryExpression(node, opts) {
        assert("UnaryExpression", node, opts);
      }
      function assertUpdateExpression(node, opts) {
        assert("UpdateExpression", node, opts);
      }
      function assertVariableDeclaration(node, opts) {
        assert("VariableDeclaration", node, opts);
      }
      function assertVariableDeclarator(node, opts) {
        assert("VariableDeclarator", node, opts);
      }
      function assertWhileStatement(node, opts) {
        assert("WhileStatement", node, opts);
      }
      function assertWithStatement(node, opts) {
        assert("WithStatement", node, opts);
      }
      function assertAssignmentPattern(node, opts) {
        assert("AssignmentPattern", node, opts);
      }
      function assertArrayPattern(node, opts) {
        assert("ArrayPattern", node, opts);
      }
      function assertArrowFunctionExpression(node, opts) {
        assert("ArrowFunctionExpression", node, opts);
      }
      function assertClassBody(node, opts) {
        assert("ClassBody", node, opts);
      }
      function assertClassExpression(node, opts) {
        assert("ClassExpression", node, opts);
      }
      function assertClassDeclaration(node, opts) {
        assert("ClassDeclaration", node, opts);
      }
      function assertExportAllDeclaration(node, opts) {
        assert("ExportAllDeclaration", node, opts);
      }
      function assertExportDefaultDeclaration(node, opts) {
        assert("ExportDefaultDeclaration", node, opts);
      }
      function assertExportNamedDeclaration(node, opts) {
        assert("ExportNamedDeclaration", node, opts);
      }
      function assertExportSpecifier(node, opts) {
        assert("ExportSpecifier", node, opts);
      }
      function assertForOfStatement(node, opts) {
        assert("ForOfStatement", node, opts);
      }
      function assertImportDeclaration(node, opts) {
        assert("ImportDeclaration", node, opts);
      }
      function assertImportDefaultSpecifier(node, opts) {
        assert("ImportDefaultSpecifier", node, opts);
      }
      function assertImportNamespaceSpecifier(node, opts) {
        assert("ImportNamespaceSpecifier", node, opts);
      }
      function assertImportSpecifier(node, opts) {
        assert("ImportSpecifier", node, opts);
      }
      function assertMetaProperty(node, opts) {
        assert("MetaProperty", node, opts);
      }
      function assertClassMethod(node, opts) {
        assert("ClassMethod", node, opts);
      }
      function assertObjectPattern(node, opts) {
        assert("ObjectPattern", node, opts);
      }
      function assertSpreadElement(node, opts) {
        assert("SpreadElement", node, opts);
      }
      function assertSuper(node, opts) {
        assert("Super", node, opts);
      }
      function assertTaggedTemplateExpression(node, opts) {
        assert("TaggedTemplateExpression", node, opts);
      }
      function assertTemplateElement(node, opts) {
        assert("TemplateElement", node, opts);
      }
      function assertTemplateLiteral(node, opts) {
        assert("TemplateLiteral", node, opts);
      }
      function assertYieldExpression(node, opts) {
        assert("YieldExpression", node, opts);
      }
      function assertAwaitExpression(node, opts) {
        assert("AwaitExpression", node, opts);
      }
      function assertImport(node, opts) {
        assert("Import", node, opts);
      }
      function assertBigIntLiteral(node, opts) {
        assert("BigIntLiteral", node, opts);
      }
      function assertExportNamespaceSpecifier(node, opts) {
        assert("ExportNamespaceSpecifier", node, opts);
      }
      function assertOptionalMemberExpression(node, opts) {
        assert("OptionalMemberExpression", node, opts);
      }
      function assertOptionalCallExpression(node, opts) {
        assert("OptionalCallExpression", node, opts);
      }
      function assertClassProperty(node, opts) {
        assert("ClassProperty", node, opts);
      }
      function assertClassAccessorProperty(node, opts) {
        assert("ClassAccessorProperty", node, opts);
      }
      function assertClassPrivateProperty(node, opts) {
        assert("ClassPrivateProperty", node, opts);
      }
      function assertClassPrivateMethod(node, opts) {
        assert("ClassPrivateMethod", node, opts);
      }
      function assertPrivateName(node, opts) {
        assert("PrivateName", node, opts);
      }
      function assertStaticBlock(node, opts) {
        assert("StaticBlock", node, opts);
      }
      function assertAnyTypeAnnotation(node, opts) {
        assert("AnyTypeAnnotation", node, opts);
      }
      function assertArrayTypeAnnotation(node, opts) {
        assert("ArrayTypeAnnotation", node, opts);
      }
      function assertBooleanTypeAnnotation(node, opts) {
        assert("BooleanTypeAnnotation", node, opts);
      }
      function assertBooleanLiteralTypeAnnotation(node, opts) {
        assert("BooleanLiteralTypeAnnotation", node, opts);
      }
      function assertNullLiteralTypeAnnotation(node, opts) {
        assert("NullLiteralTypeAnnotation", node, opts);
      }
      function assertClassImplements(node, opts) {
        assert("ClassImplements", node, opts);
      }
      function assertDeclareClass(node, opts) {
        assert("DeclareClass", node, opts);
      }
      function assertDeclareFunction(node, opts) {
        assert("DeclareFunction", node, opts);
      }
      function assertDeclareInterface(node, opts) {
        assert("DeclareInterface", node, opts);
      }
      function assertDeclareModule(node, opts) {
        assert("DeclareModule", node, opts);
      }
      function assertDeclareModuleExports(node, opts) {
        assert("DeclareModuleExports", node, opts);
      }
      function assertDeclareTypeAlias(node, opts) {
        assert("DeclareTypeAlias", node, opts);
      }
      function assertDeclareOpaqueType(node, opts) {
        assert("DeclareOpaqueType", node, opts);
      }
      function assertDeclareVariable(node, opts) {
        assert("DeclareVariable", node, opts);
      }
      function assertDeclareExportDeclaration(node, opts) {
        assert("DeclareExportDeclaration", node, opts);
      }
      function assertDeclareExportAllDeclaration(node, opts) {
        assert("DeclareExportAllDeclaration", node, opts);
      }
      function assertDeclaredPredicate(node, opts) {
        assert("DeclaredPredicate", node, opts);
      }
      function assertExistsTypeAnnotation(node, opts) {
        assert("ExistsTypeAnnotation", node, opts);
      }
      function assertFunctionTypeAnnotation(node, opts) {
        assert("FunctionTypeAnnotation", node, opts);
      }
      function assertFunctionTypeParam(node, opts) {
        assert("FunctionTypeParam", node, opts);
      }
      function assertGenericTypeAnnotation(node, opts) {
        assert("GenericTypeAnnotation", node, opts);
      }
      function assertInferredPredicate(node, opts) {
        assert("InferredPredicate", node, opts);
      }
      function assertInterfaceExtends(node, opts) {
        assert("InterfaceExtends", node, opts);
      }
      function assertInterfaceDeclaration(node, opts) {
        assert("InterfaceDeclaration", node, opts);
      }
      function assertInterfaceTypeAnnotation(node, opts) {
        assert("InterfaceTypeAnnotation", node, opts);
      }
      function assertIntersectionTypeAnnotation(node, opts) {
        assert("IntersectionTypeAnnotation", node, opts);
      }
      function assertMixedTypeAnnotation(node, opts) {
        assert("MixedTypeAnnotation", node, opts);
      }
      function assertEmptyTypeAnnotation(node, opts) {
        assert("EmptyTypeAnnotation", node, opts);
      }
      function assertNullableTypeAnnotation(node, opts) {
        assert("NullableTypeAnnotation", node, opts);
      }
      function assertNumberLiteralTypeAnnotation(node, opts) {
        assert("NumberLiteralTypeAnnotation", node, opts);
      }
      function assertNumberTypeAnnotation(node, opts) {
        assert("NumberTypeAnnotation", node, opts);
      }
      function assertObjectTypeAnnotation(node, opts) {
        assert("ObjectTypeAnnotation", node, opts);
      }
      function assertObjectTypeInternalSlot(node, opts) {
        assert("ObjectTypeInternalSlot", node, opts);
      }
      function assertObjectTypeCallProperty(node, opts) {
        assert("ObjectTypeCallProperty", node, opts);
      }
      function assertObjectTypeIndexer(node, opts) {
        assert("ObjectTypeIndexer", node, opts);
      }
      function assertObjectTypeProperty(node, opts) {
        assert("ObjectTypeProperty", node, opts);
      }
      function assertObjectTypeSpreadProperty(node, opts) {
        assert("ObjectTypeSpreadProperty", node, opts);
      }
      function assertOpaqueType(node, opts) {
        assert("OpaqueType", node, opts);
      }
      function assertQualifiedTypeIdentifier(node, opts) {
        assert("QualifiedTypeIdentifier", node, opts);
      }
      function assertStringLiteralTypeAnnotation(node, opts) {
        assert("StringLiteralTypeAnnotation", node, opts);
      }
      function assertStringTypeAnnotation(node, opts) {
        assert("StringTypeAnnotation", node, opts);
      }
      function assertSymbolTypeAnnotation(node, opts) {
        assert("SymbolTypeAnnotation", node, opts);
      }
      function assertThisTypeAnnotation(node, opts) {
        assert("ThisTypeAnnotation", node, opts);
      }
      function assertTupleTypeAnnotation(node, opts) {
        assert("TupleTypeAnnotation", node, opts);
      }
      function assertTypeofTypeAnnotation(node, opts) {
        assert("TypeofTypeAnnotation", node, opts);
      }
      function assertTypeAlias(node, opts) {
        assert("TypeAlias", node, opts);
      }
      function assertTypeAnnotation(node, opts) {
        assert("TypeAnnotation", node, opts);
      }
      function assertTypeCastExpression(node, opts) {
        assert("TypeCastExpression", node, opts);
      }
      function assertTypeParameter(node, opts) {
        assert("TypeParameter", node, opts);
      }
      function assertTypeParameterDeclaration(node, opts) {
        assert("TypeParameterDeclaration", node, opts);
      }
      function assertTypeParameterInstantiation(node, opts) {
        assert("TypeParameterInstantiation", node, opts);
      }
      function assertUnionTypeAnnotation(node, opts) {
        assert("UnionTypeAnnotation", node, opts);
      }
      function assertVariance(node, opts) {
        assert("Variance", node, opts);
      }
      function assertVoidTypeAnnotation(node, opts) {
        assert("VoidTypeAnnotation", node, opts);
      }
      function assertEnumDeclaration(node, opts) {
        assert("EnumDeclaration", node, opts);
      }
      function assertEnumBooleanBody(node, opts) {
        assert("EnumBooleanBody", node, opts);
      }
      function assertEnumNumberBody(node, opts) {
        assert("EnumNumberBody", node, opts);
      }
      function assertEnumStringBody(node, opts) {
        assert("EnumStringBody", node, opts);
      }
      function assertEnumSymbolBody(node, opts) {
        assert("EnumSymbolBody", node, opts);
      }
      function assertEnumBooleanMember(node, opts) {
        assert("EnumBooleanMember", node, opts);
      }
      function assertEnumNumberMember(node, opts) {
        assert("EnumNumberMember", node, opts);
      }
      function assertEnumStringMember(node, opts) {
        assert("EnumStringMember", node, opts);
      }
      function assertEnumDefaultedMember(node, opts) {
        assert("EnumDefaultedMember", node, opts);
      }
      function assertIndexedAccessType(node, opts) {
        assert("IndexedAccessType", node, opts);
      }
      function assertOptionalIndexedAccessType(node, opts) {
        assert("OptionalIndexedAccessType", node, opts);
      }
      function assertJSXAttribute(node, opts) {
        assert("JSXAttribute", node, opts);
      }
      function assertJSXClosingElement(node, opts) {
        assert("JSXClosingElement", node, opts);
      }
      function assertJSXElement(node, opts) {
        assert("JSXElement", node, opts);
      }
      function assertJSXEmptyExpression(node, opts) {
        assert("JSXEmptyExpression", node, opts);
      }
      function assertJSXExpressionContainer(node, opts) {
        assert("JSXExpressionContainer", node, opts);
      }
      function assertJSXSpreadChild(node, opts) {
        assert("JSXSpreadChild", node, opts);
      }
      function assertJSXIdentifier(node, opts) {
        assert("JSXIdentifier", node, opts);
      }
      function assertJSXMemberExpression(node, opts) {
        assert("JSXMemberExpression", node, opts);
      }
      function assertJSXNamespacedName(node, opts) {
        assert("JSXNamespacedName", node, opts);
      }
      function assertJSXOpeningElement(node, opts) {
        assert("JSXOpeningElement", node, opts);
      }
      function assertJSXSpreadAttribute(node, opts) {
        assert("JSXSpreadAttribute", node, opts);
      }
      function assertJSXText(node, opts) {
        assert("JSXText", node, opts);
      }
      function assertJSXFragment(node, opts) {
        assert("JSXFragment", node, opts);
      }
      function assertJSXOpeningFragment(node, opts) {
        assert("JSXOpeningFragment", node, opts);
      }
      function assertJSXClosingFragment(node, opts) {
        assert("JSXClosingFragment", node, opts);
      }
      function assertNoop(node, opts) {
        assert("Noop", node, opts);
      }
      function assertPlaceholder(node, opts) {
        assert("Placeholder", node, opts);
      }
      function assertV8IntrinsicIdentifier(node, opts) {
        assert("V8IntrinsicIdentifier", node, opts);
      }
      function assertArgumentPlaceholder(node, opts) {
        assert("ArgumentPlaceholder", node, opts);
      }
      function assertBindExpression(node, opts) {
        assert("BindExpression", node, opts);
      }
      function assertImportAttribute(node, opts) {
        assert("ImportAttribute", node, opts);
      }
      function assertDecorator(node, opts) {
        assert("Decorator", node, opts);
      }
      function assertDoExpression(node, opts) {
        assert("DoExpression", node, opts);
      }
      function assertExportDefaultSpecifier(node, opts) {
        assert("ExportDefaultSpecifier", node, opts);
      }
      function assertRecordExpression(node, opts) {
        assert("RecordExpression", node, opts);
      }
      function assertTupleExpression(node, opts) {
        assert("TupleExpression", node, opts);
      }
      function assertDecimalLiteral(node, opts) {
        assert("DecimalLiteral", node, opts);
      }
      function assertModuleExpression(node, opts) {
        assert("ModuleExpression", node, opts);
      }
      function assertTopicReference(node, opts) {
        assert("TopicReference", node, opts);
      }
      function assertPipelineTopicExpression(node, opts) {
        assert("PipelineTopicExpression", node, opts);
      }
      function assertPipelineBareFunction(node, opts) {
        assert("PipelineBareFunction", node, opts);
      }
      function assertPipelinePrimaryTopicReference(node, opts) {
        assert("PipelinePrimaryTopicReference", node, opts);
      }
      function assertTSParameterProperty(node, opts) {
        assert("TSParameterProperty", node, opts);
      }
      function assertTSDeclareFunction(node, opts) {
        assert("TSDeclareFunction", node, opts);
      }
      function assertTSDeclareMethod(node, opts) {
        assert("TSDeclareMethod", node, opts);
      }
      function assertTSQualifiedName(node, opts) {
        assert("TSQualifiedName", node, opts);
      }
      function assertTSCallSignatureDeclaration(node, opts) {
        assert("TSCallSignatureDeclaration", node, opts);
      }
      function assertTSConstructSignatureDeclaration(node, opts) {
        assert("TSConstructSignatureDeclaration", node, opts);
      }
      function assertTSPropertySignature(node, opts) {
        assert("TSPropertySignature", node, opts);
      }
      function assertTSMethodSignature(node, opts) {
        assert("TSMethodSignature", node, opts);
      }
      function assertTSIndexSignature(node, opts) {
        assert("TSIndexSignature", node, opts);
      }
      function assertTSAnyKeyword(node, opts) {
        assert("TSAnyKeyword", node, opts);
      }
      function assertTSBooleanKeyword(node, opts) {
        assert("TSBooleanKeyword", node, opts);
      }
      function assertTSBigIntKeyword(node, opts) {
        assert("TSBigIntKeyword", node, opts);
      }
      function assertTSIntrinsicKeyword(node, opts) {
        assert("TSIntrinsicKeyword", node, opts);
      }
      function assertTSNeverKeyword(node, opts) {
        assert("TSNeverKeyword", node, opts);
      }
      function assertTSNullKeyword(node, opts) {
        assert("TSNullKeyword", node, opts);
      }
      function assertTSNumberKeyword(node, opts) {
        assert("TSNumberKeyword", node, opts);
      }
      function assertTSObjectKeyword(node, opts) {
        assert("TSObjectKeyword", node, opts);
      }
      function assertTSStringKeyword(node, opts) {
        assert("TSStringKeyword", node, opts);
      }
      function assertTSSymbolKeyword(node, opts) {
        assert("TSSymbolKeyword", node, opts);
      }
      function assertTSUndefinedKeyword(node, opts) {
        assert("TSUndefinedKeyword", node, opts);
      }
      function assertTSUnknownKeyword(node, opts) {
        assert("TSUnknownKeyword", node, opts);
      }
      function assertTSVoidKeyword(node, opts) {
        assert("TSVoidKeyword", node, opts);
      }
      function assertTSThisType(node, opts) {
        assert("TSThisType", node, opts);
      }
      function assertTSFunctionType(node, opts) {
        assert("TSFunctionType", node, opts);
      }
      function assertTSConstructorType(node, opts) {
        assert("TSConstructorType", node, opts);
      }
      function assertTSTypeReference(node, opts) {
        assert("TSTypeReference", node, opts);
      }
      function assertTSTypePredicate(node, opts) {
        assert("TSTypePredicate", node, opts);
      }
      function assertTSTypeQuery(node, opts) {
        assert("TSTypeQuery", node, opts);
      }
      function assertTSTypeLiteral(node, opts) {
        assert("TSTypeLiteral", node, opts);
      }
      function assertTSArrayType(node, opts) {
        assert("TSArrayType", node, opts);
      }
      function assertTSTupleType(node, opts) {
        assert("TSTupleType", node, opts);
      }
      function assertTSOptionalType(node, opts) {
        assert("TSOptionalType", node, opts);
      }
      function assertTSRestType(node, opts) {
        assert("TSRestType", node, opts);
      }
      function assertTSNamedTupleMember(node, opts) {
        assert("TSNamedTupleMember", node, opts);
      }
      function assertTSUnionType(node, opts) {
        assert("TSUnionType", node, opts);
      }
      function assertTSIntersectionType(node, opts) {
        assert("TSIntersectionType", node, opts);
      }
      function assertTSConditionalType(node, opts) {
        assert("TSConditionalType", node, opts);
      }
      function assertTSInferType(node, opts) {
        assert("TSInferType", node, opts);
      }
      function assertTSParenthesizedType(node, opts) {
        assert("TSParenthesizedType", node, opts);
      }
      function assertTSTypeOperator(node, opts) {
        assert("TSTypeOperator", node, opts);
      }
      function assertTSIndexedAccessType(node, opts) {
        assert("TSIndexedAccessType", node, opts);
      }
      function assertTSMappedType(node, opts) {
        assert("TSMappedType", node, opts);
      }
      function assertTSLiteralType(node, opts) {
        assert("TSLiteralType", node, opts);
      }
      function assertTSExpressionWithTypeArguments(node, opts) {
        assert("TSExpressionWithTypeArguments", node, opts);
      }
      function assertTSInterfaceDeclaration(node, opts) {
        assert("TSInterfaceDeclaration", node, opts);
      }
      function assertTSInterfaceBody(node, opts) {
        assert("TSInterfaceBody", node, opts);
      }
      function assertTSTypeAliasDeclaration(node, opts) {
        assert("TSTypeAliasDeclaration", node, opts);
      }
      function assertTSInstantiationExpression(node, opts) {
        assert("TSInstantiationExpression", node, opts);
      }
      function assertTSAsExpression(node, opts) {
        assert("TSAsExpression", node, opts);
      }
      function assertTSSatisfiesExpression(node, opts) {
        assert("TSSatisfiesExpression", node, opts);
      }
      function assertTSTypeAssertion(node, opts) {
        assert("TSTypeAssertion", node, opts);
      }
      function assertTSEnumDeclaration(node, opts) {
        assert("TSEnumDeclaration", node, opts);
      }
      function assertTSEnumMember(node, opts) {
        assert("TSEnumMember", node, opts);
      }
      function assertTSModuleDeclaration(node, opts) {
        assert("TSModuleDeclaration", node, opts);
      }
      function assertTSModuleBlock(node, opts) {
        assert("TSModuleBlock", node, opts);
      }
      function assertTSImportType(node, opts) {
        assert("TSImportType", node, opts);
      }
      function assertTSImportEqualsDeclaration(node, opts) {
        assert("TSImportEqualsDeclaration", node, opts);
      }
      function assertTSExternalModuleReference(node, opts) {
        assert("TSExternalModuleReference", node, opts);
      }
      function assertTSNonNullExpression(node, opts) {
        assert("TSNonNullExpression", node, opts);
      }
      function assertTSExportAssignment(node, opts) {
        assert("TSExportAssignment", node, opts);
      }
      function assertTSNamespaceExportDeclaration(node, opts) {
        assert("TSNamespaceExportDeclaration", node, opts);
      }
      function assertTSTypeAnnotation(node, opts) {
        assert("TSTypeAnnotation", node, opts);
      }
      function assertTSTypeParameterInstantiation(node, opts) {
        assert("TSTypeParameterInstantiation", node, opts);
      }
      function assertTSTypeParameterDeclaration(node, opts) {
        assert("TSTypeParameterDeclaration", node, opts);
      }
      function assertTSTypeParameter(node, opts) {
        assert("TSTypeParameter", node, opts);
      }
      function assertStandardized(node, opts) {
        assert("Standardized", node, opts);
      }
      function assertExpression(node, opts) {
        assert("Expression", node, opts);
      }
      function assertBinary(node, opts) {
        assert("Binary", node, opts);
      }
      function assertScopable(node, opts) {
        assert("Scopable", node, opts);
      }
      function assertBlockParent(node, opts) {
        assert("BlockParent", node, opts);
      }
      function assertBlock(node, opts) {
        assert("Block", node, opts);
      }
      function assertStatement(node, opts) {
        assert("Statement", node, opts);
      }
      function assertTerminatorless(node, opts) {
        assert("Terminatorless", node, opts);
      }
      function assertCompletionStatement(node, opts) {
        assert("CompletionStatement", node, opts);
      }
      function assertConditional(node, opts) {
        assert("Conditional", node, opts);
      }
      function assertLoop(node, opts) {
        assert("Loop", node, opts);
      }
      function assertWhile(node, opts) {
        assert("While", node, opts);
      }
      function assertExpressionWrapper(node, opts) {
        assert("ExpressionWrapper", node, opts);
      }
      function assertFor(node, opts) {
        assert("For", node, opts);
      }
      function assertForXStatement(node, opts) {
        assert("ForXStatement", node, opts);
      }
      function assertFunction(node, opts) {
        assert("Function", node, opts);
      }
      function assertFunctionParent(node, opts) {
        assert("FunctionParent", node, opts);
      }
      function assertPureish(node, opts) {
        assert("Pureish", node, opts);
      }
      function assertDeclaration(node, opts) {
        assert("Declaration", node, opts);
      }
      function assertPatternLike(node, opts) {
        assert("PatternLike", node, opts);
      }
      function assertLVal(node, opts) {
        assert("LVal", node, opts);
      }
      function assertTSEntityName(node, opts) {
        assert("TSEntityName", node, opts);
      }
      function assertLiteral(node, opts) {
        assert("Literal", node, opts);
      }
      function assertImmutable(node, opts) {
        assert("Immutable", node, opts);
      }
      function assertUserWhitespacable(node, opts) {
        assert("UserWhitespacable", node, opts);
      }
      function assertMethod(node, opts) {
        assert("Method", node, opts);
      }
      function assertObjectMember(node, opts) {
        assert("ObjectMember", node, opts);
      }
      function assertProperty(node, opts) {
        assert("Property", node, opts);
      }
      function assertUnaryLike(node, opts) {
        assert("UnaryLike", node, opts);
      }
      function assertPattern(node, opts) {
        assert("Pattern", node, opts);
      }
      function assertClass(node, opts) {
        assert("Class", node, opts);
      }
      function assertModuleDeclaration(node, opts) {
        assert("ModuleDeclaration", node, opts);
      }
      function assertExportDeclaration(node, opts) {
        assert("ExportDeclaration", node, opts);
      }
      function assertModuleSpecifier(node, opts) {
        assert("ModuleSpecifier", node, opts);
      }
      function assertAccessor(node, opts) {
        assert("Accessor", node, opts);
      }
      function assertPrivate(node, opts) {
        assert("Private", node, opts);
      }
      function assertFlow(node, opts) {
        assert("Flow", node, opts);
      }
      function assertFlowType(node, opts) {
        assert("FlowType", node, opts);
      }
      function assertFlowBaseAnnotation(node, opts) {
        assert("FlowBaseAnnotation", node, opts);
      }
      function assertFlowDeclaration(node, opts) {
        assert("FlowDeclaration", node, opts);
      }
      function assertFlowPredicate(node, opts) {
        assert("FlowPredicate", node, opts);
      }
      function assertEnumBody(node, opts) {
        assert("EnumBody", node, opts);
      }
      function assertEnumMember(node, opts) {
        assert("EnumMember", node, opts);
      }
      function assertJSX(node, opts) {
        assert("JSX", node, opts);
      }
      function assertMiscellaneous(node, opts) {
        assert("Miscellaneous", node, opts);
      }
      function assertTypeScript(node, opts) {
        assert("TypeScript", node, opts);
      }
      function assertTSTypeElement(node, opts) {
        assert("TSTypeElement", node, opts);
      }
      function assertTSType(node, opts) {
        assert("TSType", node, opts);
      }
      function assertTSBaseType(node, opts) {
        assert("TSBaseType", node, opts);
      }
      function assertNumberLiteral(node, opts) {
        console.trace("The node type NumberLiteral has been renamed to NumericLiteral");
        assert("NumberLiteral", node, opts);
      }
      function assertRegexLiteral(node, opts) {
        console.trace("The node type RegexLiteral has been renamed to RegExpLiteral");
        assert("RegexLiteral", node, opts);
      }
      function assertRestProperty(node, opts) {
        console.trace("The node type RestProperty has been renamed to RestElement");
        assert("RestProperty", node, opts);
      }
      function assertSpreadProperty(node, opts) {
        console.trace("The node type SpreadProperty has been renamed to SpreadElement");
        assert("SpreadProperty", node, opts);
      }
    }
  });

  // node_modules/@babel/types/lib/builders/flow/createTypeAnnotationBasedOnTypeof.js
  var require_createTypeAnnotationBasedOnTypeof = __commonJS({
    "node_modules/@babel/types/lib/builders/flow/createTypeAnnotationBasedOnTypeof.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _generated = require_generated2();
      var _default = createTypeAnnotationBasedOnTypeof;
      exports2.default = _default;
      function createTypeAnnotationBasedOnTypeof(type) {
        switch (type) {
          case "string":
            return (0, _generated.stringTypeAnnotation)();
          case "number":
            return (0, _generated.numberTypeAnnotation)();
          case "undefined":
            return (0, _generated.voidTypeAnnotation)();
          case "boolean":
            return (0, _generated.booleanTypeAnnotation)();
          case "function":
            return (0, _generated.genericTypeAnnotation)((0, _generated.identifier)("Function"));
          case "object":
            return (0, _generated.genericTypeAnnotation)((0, _generated.identifier)("Object"));
          case "symbol":
            return (0, _generated.genericTypeAnnotation)((0, _generated.identifier)("Symbol"));
          case "bigint":
            return (0, _generated.anyTypeAnnotation)();
        }
        throw new Error("Invalid typeof value: " + type);
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/flow/removeTypeDuplicates.js
  var require_removeTypeDuplicates = __commonJS({
    "node_modules/@babel/types/lib/modifications/flow/removeTypeDuplicates.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = removeTypeDuplicates;
      var _generated = require_generated();
      function getQualifiedName(node) {
        return (0, _generated.isIdentifier)(node) ? node.name : `${node.id.name}.${getQualifiedName(node.qualification)}`;
      }
      function removeTypeDuplicates(nodes) {
        const generics = /* @__PURE__ */ new Map();
        const bases = /* @__PURE__ */ new Map();
        const typeGroups = /* @__PURE__ */ new Set();
        const types = [];
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          if (!node)
            continue;
          if (types.indexOf(node) >= 0) {
            continue;
          }
          if ((0, _generated.isAnyTypeAnnotation)(node)) {
            return [node];
          }
          if ((0, _generated.isFlowBaseAnnotation)(node)) {
            bases.set(node.type, node);
            continue;
          }
          if ((0, _generated.isUnionTypeAnnotation)(node)) {
            if (!typeGroups.has(node.types)) {
              nodes = nodes.concat(node.types);
              typeGroups.add(node.types);
            }
            continue;
          }
          if ((0, _generated.isGenericTypeAnnotation)(node)) {
            const name = getQualifiedName(node.id);
            if (generics.has(name)) {
              let existing = generics.get(name);
              if (existing.typeParameters) {
                if (node.typeParameters) {
                  existing.typeParameters.params = removeTypeDuplicates(existing.typeParameters.params.concat(node.typeParameters.params));
                }
              } else {
                existing = node.typeParameters;
              }
            } else {
              generics.set(name, node);
            }
            continue;
          }
          types.push(node);
        }
        for (const [, baseType] of bases) {
          types.push(baseType);
        }
        for (const [, genericName] of generics) {
          types.push(genericName);
        }
        return types;
      }
    }
  });

  // node_modules/@babel/types/lib/builders/flow/createFlowUnionType.js
  var require_createFlowUnionType = __commonJS({
    "node_modules/@babel/types/lib/builders/flow/createFlowUnionType.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = createFlowUnionType;
      var _generated = require_generated2();
      var _removeTypeDuplicates = require_removeTypeDuplicates();
      function createFlowUnionType(types) {
        const flattened = (0, _removeTypeDuplicates.default)(types);
        if (flattened.length === 1) {
          return flattened[0];
        } else {
          return (0, _generated.unionTypeAnnotation)(flattened);
        }
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/typescript/removeTypeDuplicates.js
  var require_removeTypeDuplicates2 = __commonJS({
    "node_modules/@babel/types/lib/modifications/typescript/removeTypeDuplicates.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = removeTypeDuplicates;
      var _generated = require_generated();
      function getQualifiedName(node) {
        return (0, _generated.isIdentifier)(node) ? node.name : `${node.right.name}.${getQualifiedName(node.left)}`;
      }
      function removeTypeDuplicates(nodes) {
        const generics = /* @__PURE__ */ new Map();
        const bases = /* @__PURE__ */ new Map();
        const typeGroups = /* @__PURE__ */ new Set();
        const types = [];
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          if (!node)
            continue;
          if (types.indexOf(node) >= 0) {
            continue;
          }
          if ((0, _generated.isTSAnyKeyword)(node)) {
            return [node];
          }
          if ((0, _generated.isTSBaseType)(node)) {
            bases.set(node.type, node);
            continue;
          }
          if ((0, _generated.isTSUnionType)(node)) {
            if (!typeGroups.has(node.types)) {
              nodes.push(...node.types);
              typeGroups.add(node.types);
            }
            continue;
          }
          if ((0, _generated.isTSTypeReference)(node) && node.typeParameters) {
            const name = getQualifiedName(node.typeName);
            if (generics.has(name)) {
              let existing = generics.get(name);
              if (existing.typeParameters) {
                if (node.typeParameters) {
                  existing.typeParameters.params = removeTypeDuplicates(existing.typeParameters.params.concat(node.typeParameters.params));
                }
              } else {
                existing = node.typeParameters;
              }
            } else {
              generics.set(name, node);
            }
            continue;
          }
          types.push(node);
        }
        for (const [, baseType] of bases) {
          types.push(baseType);
        }
        for (const [, genericName] of generics) {
          types.push(genericName);
        }
        return types;
      }
    }
  });

  // node_modules/@babel/types/lib/builders/typescript/createTSUnionType.js
  var require_createTSUnionType = __commonJS({
    "node_modules/@babel/types/lib/builders/typescript/createTSUnionType.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = createTSUnionType;
      var _generated = require_generated2();
      var _removeTypeDuplicates = require_removeTypeDuplicates2();
      var _index = require_generated();
      function createTSUnionType(typeAnnotations) {
        const types = typeAnnotations.map((type) => {
          return (0, _index.isTSTypeAnnotation)(type) ? type.typeAnnotation : type;
        });
        const flattened = (0, _removeTypeDuplicates.default)(types);
        if (flattened.length === 1) {
          return flattened[0];
        } else {
          return (0, _generated.tsUnionType)(flattened);
        }
      }
    }
  });

  // node_modules/@babel/types/lib/builders/generated/uppercase.js
  var require_uppercase = __commonJS({
    "node_modules/@babel/types/lib/builders/generated/uppercase.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      Object.defineProperty(exports2, "AnyTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.anyTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ArgumentPlaceholder", {
        enumerable: true,
        get: function() {
          return _index.argumentPlaceholder;
        }
      });
      Object.defineProperty(exports2, "ArrayExpression", {
        enumerable: true,
        get: function() {
          return _index.arrayExpression;
        }
      });
      Object.defineProperty(exports2, "ArrayPattern", {
        enumerable: true,
        get: function() {
          return _index.arrayPattern;
        }
      });
      Object.defineProperty(exports2, "ArrayTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.arrayTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ArrowFunctionExpression", {
        enumerable: true,
        get: function() {
          return _index.arrowFunctionExpression;
        }
      });
      Object.defineProperty(exports2, "AssignmentExpression", {
        enumerable: true,
        get: function() {
          return _index.assignmentExpression;
        }
      });
      Object.defineProperty(exports2, "AssignmentPattern", {
        enumerable: true,
        get: function() {
          return _index.assignmentPattern;
        }
      });
      Object.defineProperty(exports2, "AwaitExpression", {
        enumerable: true,
        get: function() {
          return _index.awaitExpression;
        }
      });
      Object.defineProperty(exports2, "BigIntLiteral", {
        enumerable: true,
        get: function() {
          return _index.bigIntLiteral;
        }
      });
      Object.defineProperty(exports2, "BinaryExpression", {
        enumerable: true,
        get: function() {
          return _index.binaryExpression;
        }
      });
      Object.defineProperty(exports2, "BindExpression", {
        enumerable: true,
        get: function() {
          return _index.bindExpression;
        }
      });
      Object.defineProperty(exports2, "BlockStatement", {
        enumerable: true,
        get: function() {
          return _index.blockStatement;
        }
      });
      Object.defineProperty(exports2, "BooleanLiteral", {
        enumerable: true,
        get: function() {
          return _index.booleanLiteral;
        }
      });
      Object.defineProperty(exports2, "BooleanLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.booleanLiteralTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "BooleanTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.booleanTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "BreakStatement", {
        enumerable: true,
        get: function() {
          return _index.breakStatement;
        }
      });
      Object.defineProperty(exports2, "CallExpression", {
        enumerable: true,
        get: function() {
          return _index.callExpression;
        }
      });
      Object.defineProperty(exports2, "CatchClause", {
        enumerable: true,
        get: function() {
          return _index.catchClause;
        }
      });
      Object.defineProperty(exports2, "ClassAccessorProperty", {
        enumerable: true,
        get: function() {
          return _index.classAccessorProperty;
        }
      });
      Object.defineProperty(exports2, "ClassBody", {
        enumerable: true,
        get: function() {
          return _index.classBody;
        }
      });
      Object.defineProperty(exports2, "ClassDeclaration", {
        enumerable: true,
        get: function() {
          return _index.classDeclaration;
        }
      });
      Object.defineProperty(exports2, "ClassExpression", {
        enumerable: true,
        get: function() {
          return _index.classExpression;
        }
      });
      Object.defineProperty(exports2, "ClassImplements", {
        enumerable: true,
        get: function() {
          return _index.classImplements;
        }
      });
      Object.defineProperty(exports2, "ClassMethod", {
        enumerable: true,
        get: function() {
          return _index.classMethod;
        }
      });
      Object.defineProperty(exports2, "ClassPrivateMethod", {
        enumerable: true,
        get: function() {
          return _index.classPrivateMethod;
        }
      });
      Object.defineProperty(exports2, "ClassPrivateProperty", {
        enumerable: true,
        get: function() {
          return _index.classPrivateProperty;
        }
      });
      Object.defineProperty(exports2, "ClassProperty", {
        enumerable: true,
        get: function() {
          return _index.classProperty;
        }
      });
      Object.defineProperty(exports2, "ConditionalExpression", {
        enumerable: true,
        get: function() {
          return _index.conditionalExpression;
        }
      });
      Object.defineProperty(exports2, "ContinueStatement", {
        enumerable: true,
        get: function() {
          return _index.continueStatement;
        }
      });
      Object.defineProperty(exports2, "DebuggerStatement", {
        enumerable: true,
        get: function() {
          return _index.debuggerStatement;
        }
      });
      Object.defineProperty(exports2, "DecimalLiteral", {
        enumerable: true,
        get: function() {
          return _index.decimalLiteral;
        }
      });
      Object.defineProperty(exports2, "DeclareClass", {
        enumerable: true,
        get: function() {
          return _index.declareClass;
        }
      });
      Object.defineProperty(exports2, "DeclareExportAllDeclaration", {
        enumerable: true,
        get: function() {
          return _index.declareExportAllDeclaration;
        }
      });
      Object.defineProperty(exports2, "DeclareExportDeclaration", {
        enumerable: true,
        get: function() {
          return _index.declareExportDeclaration;
        }
      });
      Object.defineProperty(exports2, "DeclareFunction", {
        enumerable: true,
        get: function() {
          return _index.declareFunction;
        }
      });
      Object.defineProperty(exports2, "DeclareInterface", {
        enumerable: true,
        get: function() {
          return _index.declareInterface;
        }
      });
      Object.defineProperty(exports2, "DeclareModule", {
        enumerable: true,
        get: function() {
          return _index.declareModule;
        }
      });
      Object.defineProperty(exports2, "DeclareModuleExports", {
        enumerable: true,
        get: function() {
          return _index.declareModuleExports;
        }
      });
      Object.defineProperty(exports2, "DeclareOpaqueType", {
        enumerable: true,
        get: function() {
          return _index.declareOpaqueType;
        }
      });
      Object.defineProperty(exports2, "DeclareTypeAlias", {
        enumerable: true,
        get: function() {
          return _index.declareTypeAlias;
        }
      });
      Object.defineProperty(exports2, "DeclareVariable", {
        enumerable: true,
        get: function() {
          return _index.declareVariable;
        }
      });
      Object.defineProperty(exports2, "DeclaredPredicate", {
        enumerable: true,
        get: function() {
          return _index.declaredPredicate;
        }
      });
      Object.defineProperty(exports2, "Decorator", {
        enumerable: true,
        get: function() {
          return _index.decorator;
        }
      });
      Object.defineProperty(exports2, "Directive", {
        enumerable: true,
        get: function() {
          return _index.directive;
        }
      });
      Object.defineProperty(exports2, "DirectiveLiteral", {
        enumerable: true,
        get: function() {
          return _index.directiveLiteral;
        }
      });
      Object.defineProperty(exports2, "DoExpression", {
        enumerable: true,
        get: function() {
          return _index.doExpression;
        }
      });
      Object.defineProperty(exports2, "DoWhileStatement", {
        enumerable: true,
        get: function() {
          return _index.doWhileStatement;
        }
      });
      Object.defineProperty(exports2, "EmptyStatement", {
        enumerable: true,
        get: function() {
          return _index.emptyStatement;
        }
      });
      Object.defineProperty(exports2, "EmptyTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.emptyTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "EnumBooleanBody", {
        enumerable: true,
        get: function() {
          return _index.enumBooleanBody;
        }
      });
      Object.defineProperty(exports2, "EnumBooleanMember", {
        enumerable: true,
        get: function() {
          return _index.enumBooleanMember;
        }
      });
      Object.defineProperty(exports2, "EnumDeclaration", {
        enumerable: true,
        get: function() {
          return _index.enumDeclaration;
        }
      });
      Object.defineProperty(exports2, "EnumDefaultedMember", {
        enumerable: true,
        get: function() {
          return _index.enumDefaultedMember;
        }
      });
      Object.defineProperty(exports2, "EnumNumberBody", {
        enumerable: true,
        get: function() {
          return _index.enumNumberBody;
        }
      });
      Object.defineProperty(exports2, "EnumNumberMember", {
        enumerable: true,
        get: function() {
          return _index.enumNumberMember;
        }
      });
      Object.defineProperty(exports2, "EnumStringBody", {
        enumerable: true,
        get: function() {
          return _index.enumStringBody;
        }
      });
      Object.defineProperty(exports2, "EnumStringMember", {
        enumerable: true,
        get: function() {
          return _index.enumStringMember;
        }
      });
      Object.defineProperty(exports2, "EnumSymbolBody", {
        enumerable: true,
        get: function() {
          return _index.enumSymbolBody;
        }
      });
      Object.defineProperty(exports2, "ExistsTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.existsTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ExportAllDeclaration", {
        enumerable: true,
        get: function() {
          return _index.exportAllDeclaration;
        }
      });
      Object.defineProperty(exports2, "ExportDefaultDeclaration", {
        enumerable: true,
        get: function() {
          return _index.exportDefaultDeclaration;
        }
      });
      Object.defineProperty(exports2, "ExportDefaultSpecifier", {
        enumerable: true,
        get: function() {
          return _index.exportDefaultSpecifier;
        }
      });
      Object.defineProperty(exports2, "ExportNamedDeclaration", {
        enumerable: true,
        get: function() {
          return _index.exportNamedDeclaration;
        }
      });
      Object.defineProperty(exports2, "ExportNamespaceSpecifier", {
        enumerable: true,
        get: function() {
          return _index.exportNamespaceSpecifier;
        }
      });
      Object.defineProperty(exports2, "ExportSpecifier", {
        enumerable: true,
        get: function() {
          return _index.exportSpecifier;
        }
      });
      Object.defineProperty(exports2, "ExpressionStatement", {
        enumerable: true,
        get: function() {
          return _index.expressionStatement;
        }
      });
      Object.defineProperty(exports2, "File", {
        enumerable: true,
        get: function() {
          return _index.file;
        }
      });
      Object.defineProperty(exports2, "ForInStatement", {
        enumerable: true,
        get: function() {
          return _index.forInStatement;
        }
      });
      Object.defineProperty(exports2, "ForOfStatement", {
        enumerable: true,
        get: function() {
          return _index.forOfStatement;
        }
      });
      Object.defineProperty(exports2, "ForStatement", {
        enumerable: true,
        get: function() {
          return _index.forStatement;
        }
      });
      Object.defineProperty(exports2, "FunctionDeclaration", {
        enumerable: true,
        get: function() {
          return _index.functionDeclaration;
        }
      });
      Object.defineProperty(exports2, "FunctionExpression", {
        enumerable: true,
        get: function() {
          return _index.functionExpression;
        }
      });
      Object.defineProperty(exports2, "FunctionTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.functionTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "FunctionTypeParam", {
        enumerable: true,
        get: function() {
          return _index.functionTypeParam;
        }
      });
      Object.defineProperty(exports2, "GenericTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.genericTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "Identifier", {
        enumerable: true,
        get: function() {
          return _index.identifier;
        }
      });
      Object.defineProperty(exports2, "IfStatement", {
        enumerable: true,
        get: function() {
          return _index.ifStatement;
        }
      });
      Object.defineProperty(exports2, "Import", {
        enumerable: true,
        get: function() {
          return _index.import;
        }
      });
      Object.defineProperty(exports2, "ImportAttribute", {
        enumerable: true,
        get: function() {
          return _index.importAttribute;
        }
      });
      Object.defineProperty(exports2, "ImportDeclaration", {
        enumerable: true,
        get: function() {
          return _index.importDeclaration;
        }
      });
      Object.defineProperty(exports2, "ImportDefaultSpecifier", {
        enumerable: true,
        get: function() {
          return _index.importDefaultSpecifier;
        }
      });
      Object.defineProperty(exports2, "ImportNamespaceSpecifier", {
        enumerable: true,
        get: function() {
          return _index.importNamespaceSpecifier;
        }
      });
      Object.defineProperty(exports2, "ImportSpecifier", {
        enumerable: true,
        get: function() {
          return _index.importSpecifier;
        }
      });
      Object.defineProperty(exports2, "IndexedAccessType", {
        enumerable: true,
        get: function() {
          return _index.indexedAccessType;
        }
      });
      Object.defineProperty(exports2, "InferredPredicate", {
        enumerable: true,
        get: function() {
          return _index.inferredPredicate;
        }
      });
      Object.defineProperty(exports2, "InterfaceDeclaration", {
        enumerable: true,
        get: function() {
          return _index.interfaceDeclaration;
        }
      });
      Object.defineProperty(exports2, "InterfaceExtends", {
        enumerable: true,
        get: function() {
          return _index.interfaceExtends;
        }
      });
      Object.defineProperty(exports2, "InterfaceTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.interfaceTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "InterpreterDirective", {
        enumerable: true,
        get: function() {
          return _index.interpreterDirective;
        }
      });
      Object.defineProperty(exports2, "IntersectionTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.intersectionTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "JSXAttribute", {
        enumerable: true,
        get: function() {
          return _index.jsxAttribute;
        }
      });
      Object.defineProperty(exports2, "JSXClosingElement", {
        enumerable: true,
        get: function() {
          return _index.jsxClosingElement;
        }
      });
      Object.defineProperty(exports2, "JSXClosingFragment", {
        enumerable: true,
        get: function() {
          return _index.jsxClosingFragment;
        }
      });
      Object.defineProperty(exports2, "JSXElement", {
        enumerable: true,
        get: function() {
          return _index.jsxElement;
        }
      });
      Object.defineProperty(exports2, "JSXEmptyExpression", {
        enumerable: true,
        get: function() {
          return _index.jsxEmptyExpression;
        }
      });
      Object.defineProperty(exports2, "JSXExpressionContainer", {
        enumerable: true,
        get: function() {
          return _index.jsxExpressionContainer;
        }
      });
      Object.defineProperty(exports2, "JSXFragment", {
        enumerable: true,
        get: function() {
          return _index.jsxFragment;
        }
      });
      Object.defineProperty(exports2, "JSXIdentifier", {
        enumerable: true,
        get: function() {
          return _index.jsxIdentifier;
        }
      });
      Object.defineProperty(exports2, "JSXMemberExpression", {
        enumerable: true,
        get: function() {
          return _index.jsxMemberExpression;
        }
      });
      Object.defineProperty(exports2, "JSXNamespacedName", {
        enumerable: true,
        get: function() {
          return _index.jsxNamespacedName;
        }
      });
      Object.defineProperty(exports2, "JSXOpeningElement", {
        enumerable: true,
        get: function() {
          return _index.jsxOpeningElement;
        }
      });
      Object.defineProperty(exports2, "JSXOpeningFragment", {
        enumerable: true,
        get: function() {
          return _index.jsxOpeningFragment;
        }
      });
      Object.defineProperty(exports2, "JSXSpreadAttribute", {
        enumerable: true,
        get: function() {
          return _index.jsxSpreadAttribute;
        }
      });
      Object.defineProperty(exports2, "JSXSpreadChild", {
        enumerable: true,
        get: function() {
          return _index.jsxSpreadChild;
        }
      });
      Object.defineProperty(exports2, "JSXText", {
        enumerable: true,
        get: function() {
          return _index.jsxText;
        }
      });
      Object.defineProperty(exports2, "LabeledStatement", {
        enumerable: true,
        get: function() {
          return _index.labeledStatement;
        }
      });
      Object.defineProperty(exports2, "LogicalExpression", {
        enumerable: true,
        get: function() {
          return _index.logicalExpression;
        }
      });
      Object.defineProperty(exports2, "MemberExpression", {
        enumerable: true,
        get: function() {
          return _index.memberExpression;
        }
      });
      Object.defineProperty(exports2, "MetaProperty", {
        enumerable: true,
        get: function() {
          return _index.metaProperty;
        }
      });
      Object.defineProperty(exports2, "MixedTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.mixedTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ModuleExpression", {
        enumerable: true,
        get: function() {
          return _index.moduleExpression;
        }
      });
      Object.defineProperty(exports2, "NewExpression", {
        enumerable: true,
        get: function() {
          return _index.newExpression;
        }
      });
      Object.defineProperty(exports2, "Noop", {
        enumerable: true,
        get: function() {
          return _index.noop;
        }
      });
      Object.defineProperty(exports2, "NullLiteral", {
        enumerable: true,
        get: function() {
          return _index.nullLiteral;
        }
      });
      Object.defineProperty(exports2, "NullLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.nullLiteralTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "NullableTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.nullableTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "NumberLiteral", {
        enumerable: true,
        get: function() {
          return _index.numberLiteral;
        }
      });
      Object.defineProperty(exports2, "NumberLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.numberLiteralTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "NumberTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.numberTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "NumericLiteral", {
        enumerable: true,
        get: function() {
          return _index.numericLiteral;
        }
      });
      Object.defineProperty(exports2, "ObjectExpression", {
        enumerable: true,
        get: function() {
          return _index.objectExpression;
        }
      });
      Object.defineProperty(exports2, "ObjectMethod", {
        enumerable: true,
        get: function() {
          return _index.objectMethod;
        }
      });
      Object.defineProperty(exports2, "ObjectPattern", {
        enumerable: true,
        get: function() {
          return _index.objectPattern;
        }
      });
      Object.defineProperty(exports2, "ObjectProperty", {
        enumerable: true,
        get: function() {
          return _index.objectProperty;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.objectTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeCallProperty", {
        enumerable: true,
        get: function() {
          return _index.objectTypeCallProperty;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeIndexer", {
        enumerable: true,
        get: function() {
          return _index.objectTypeIndexer;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeInternalSlot", {
        enumerable: true,
        get: function() {
          return _index.objectTypeInternalSlot;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeProperty", {
        enumerable: true,
        get: function() {
          return _index.objectTypeProperty;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeSpreadProperty", {
        enumerable: true,
        get: function() {
          return _index.objectTypeSpreadProperty;
        }
      });
      Object.defineProperty(exports2, "OpaqueType", {
        enumerable: true,
        get: function() {
          return _index.opaqueType;
        }
      });
      Object.defineProperty(exports2, "OptionalCallExpression", {
        enumerable: true,
        get: function() {
          return _index.optionalCallExpression;
        }
      });
      Object.defineProperty(exports2, "OptionalIndexedAccessType", {
        enumerable: true,
        get: function() {
          return _index.optionalIndexedAccessType;
        }
      });
      Object.defineProperty(exports2, "OptionalMemberExpression", {
        enumerable: true,
        get: function() {
          return _index.optionalMemberExpression;
        }
      });
      Object.defineProperty(exports2, "ParenthesizedExpression", {
        enumerable: true,
        get: function() {
          return _index.parenthesizedExpression;
        }
      });
      Object.defineProperty(exports2, "PipelineBareFunction", {
        enumerable: true,
        get: function() {
          return _index.pipelineBareFunction;
        }
      });
      Object.defineProperty(exports2, "PipelinePrimaryTopicReference", {
        enumerable: true,
        get: function() {
          return _index.pipelinePrimaryTopicReference;
        }
      });
      Object.defineProperty(exports2, "PipelineTopicExpression", {
        enumerable: true,
        get: function() {
          return _index.pipelineTopicExpression;
        }
      });
      Object.defineProperty(exports2, "Placeholder", {
        enumerable: true,
        get: function() {
          return _index.placeholder;
        }
      });
      Object.defineProperty(exports2, "PrivateName", {
        enumerable: true,
        get: function() {
          return _index.privateName;
        }
      });
      Object.defineProperty(exports2, "Program", {
        enumerable: true,
        get: function() {
          return _index.program;
        }
      });
      Object.defineProperty(exports2, "QualifiedTypeIdentifier", {
        enumerable: true,
        get: function() {
          return _index.qualifiedTypeIdentifier;
        }
      });
      Object.defineProperty(exports2, "RecordExpression", {
        enumerable: true,
        get: function() {
          return _index.recordExpression;
        }
      });
      Object.defineProperty(exports2, "RegExpLiteral", {
        enumerable: true,
        get: function() {
          return _index.regExpLiteral;
        }
      });
      Object.defineProperty(exports2, "RegexLiteral", {
        enumerable: true,
        get: function() {
          return _index.regexLiteral;
        }
      });
      Object.defineProperty(exports2, "RestElement", {
        enumerable: true,
        get: function() {
          return _index.restElement;
        }
      });
      Object.defineProperty(exports2, "RestProperty", {
        enumerable: true,
        get: function() {
          return _index.restProperty;
        }
      });
      Object.defineProperty(exports2, "ReturnStatement", {
        enumerable: true,
        get: function() {
          return _index.returnStatement;
        }
      });
      Object.defineProperty(exports2, "SequenceExpression", {
        enumerable: true,
        get: function() {
          return _index.sequenceExpression;
        }
      });
      Object.defineProperty(exports2, "SpreadElement", {
        enumerable: true,
        get: function() {
          return _index.spreadElement;
        }
      });
      Object.defineProperty(exports2, "SpreadProperty", {
        enumerable: true,
        get: function() {
          return _index.spreadProperty;
        }
      });
      Object.defineProperty(exports2, "StaticBlock", {
        enumerable: true,
        get: function() {
          return _index.staticBlock;
        }
      });
      Object.defineProperty(exports2, "StringLiteral", {
        enumerable: true,
        get: function() {
          return _index.stringLiteral;
        }
      });
      Object.defineProperty(exports2, "StringLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.stringLiteralTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "StringTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.stringTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "Super", {
        enumerable: true,
        get: function() {
          return _index.super;
        }
      });
      Object.defineProperty(exports2, "SwitchCase", {
        enumerable: true,
        get: function() {
          return _index.switchCase;
        }
      });
      Object.defineProperty(exports2, "SwitchStatement", {
        enumerable: true,
        get: function() {
          return _index.switchStatement;
        }
      });
      Object.defineProperty(exports2, "SymbolTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.symbolTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "TSAnyKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsAnyKeyword;
        }
      });
      Object.defineProperty(exports2, "TSArrayType", {
        enumerable: true,
        get: function() {
          return _index.tsArrayType;
        }
      });
      Object.defineProperty(exports2, "TSAsExpression", {
        enumerable: true,
        get: function() {
          return _index.tsAsExpression;
        }
      });
      Object.defineProperty(exports2, "TSBigIntKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsBigIntKeyword;
        }
      });
      Object.defineProperty(exports2, "TSBooleanKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsBooleanKeyword;
        }
      });
      Object.defineProperty(exports2, "TSCallSignatureDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsCallSignatureDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSConditionalType", {
        enumerable: true,
        get: function() {
          return _index.tsConditionalType;
        }
      });
      Object.defineProperty(exports2, "TSConstructSignatureDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsConstructSignatureDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSConstructorType", {
        enumerable: true,
        get: function() {
          return _index.tsConstructorType;
        }
      });
      Object.defineProperty(exports2, "TSDeclareFunction", {
        enumerable: true,
        get: function() {
          return _index.tsDeclareFunction;
        }
      });
      Object.defineProperty(exports2, "TSDeclareMethod", {
        enumerable: true,
        get: function() {
          return _index.tsDeclareMethod;
        }
      });
      Object.defineProperty(exports2, "TSEnumDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsEnumDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSEnumMember", {
        enumerable: true,
        get: function() {
          return _index.tsEnumMember;
        }
      });
      Object.defineProperty(exports2, "TSExportAssignment", {
        enumerable: true,
        get: function() {
          return _index.tsExportAssignment;
        }
      });
      Object.defineProperty(exports2, "TSExpressionWithTypeArguments", {
        enumerable: true,
        get: function() {
          return _index.tsExpressionWithTypeArguments;
        }
      });
      Object.defineProperty(exports2, "TSExternalModuleReference", {
        enumerable: true,
        get: function() {
          return _index.tsExternalModuleReference;
        }
      });
      Object.defineProperty(exports2, "TSFunctionType", {
        enumerable: true,
        get: function() {
          return _index.tsFunctionType;
        }
      });
      Object.defineProperty(exports2, "TSImportEqualsDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsImportEqualsDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSImportType", {
        enumerable: true,
        get: function() {
          return _index.tsImportType;
        }
      });
      Object.defineProperty(exports2, "TSIndexSignature", {
        enumerable: true,
        get: function() {
          return _index.tsIndexSignature;
        }
      });
      Object.defineProperty(exports2, "TSIndexedAccessType", {
        enumerable: true,
        get: function() {
          return _index.tsIndexedAccessType;
        }
      });
      Object.defineProperty(exports2, "TSInferType", {
        enumerable: true,
        get: function() {
          return _index.tsInferType;
        }
      });
      Object.defineProperty(exports2, "TSInstantiationExpression", {
        enumerable: true,
        get: function() {
          return _index.tsInstantiationExpression;
        }
      });
      Object.defineProperty(exports2, "TSInterfaceBody", {
        enumerable: true,
        get: function() {
          return _index.tsInterfaceBody;
        }
      });
      Object.defineProperty(exports2, "TSInterfaceDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsInterfaceDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSIntersectionType", {
        enumerable: true,
        get: function() {
          return _index.tsIntersectionType;
        }
      });
      Object.defineProperty(exports2, "TSIntrinsicKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsIntrinsicKeyword;
        }
      });
      Object.defineProperty(exports2, "TSLiteralType", {
        enumerable: true,
        get: function() {
          return _index.tsLiteralType;
        }
      });
      Object.defineProperty(exports2, "TSMappedType", {
        enumerable: true,
        get: function() {
          return _index.tsMappedType;
        }
      });
      Object.defineProperty(exports2, "TSMethodSignature", {
        enumerable: true,
        get: function() {
          return _index.tsMethodSignature;
        }
      });
      Object.defineProperty(exports2, "TSModuleBlock", {
        enumerable: true,
        get: function() {
          return _index.tsModuleBlock;
        }
      });
      Object.defineProperty(exports2, "TSModuleDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsModuleDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSNamedTupleMember", {
        enumerable: true,
        get: function() {
          return _index.tsNamedTupleMember;
        }
      });
      Object.defineProperty(exports2, "TSNamespaceExportDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsNamespaceExportDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSNeverKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsNeverKeyword;
        }
      });
      Object.defineProperty(exports2, "TSNonNullExpression", {
        enumerable: true,
        get: function() {
          return _index.tsNonNullExpression;
        }
      });
      Object.defineProperty(exports2, "TSNullKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsNullKeyword;
        }
      });
      Object.defineProperty(exports2, "TSNumberKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsNumberKeyword;
        }
      });
      Object.defineProperty(exports2, "TSObjectKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsObjectKeyword;
        }
      });
      Object.defineProperty(exports2, "TSOptionalType", {
        enumerable: true,
        get: function() {
          return _index.tsOptionalType;
        }
      });
      Object.defineProperty(exports2, "TSParameterProperty", {
        enumerable: true,
        get: function() {
          return _index.tsParameterProperty;
        }
      });
      Object.defineProperty(exports2, "TSParenthesizedType", {
        enumerable: true,
        get: function() {
          return _index.tsParenthesizedType;
        }
      });
      Object.defineProperty(exports2, "TSPropertySignature", {
        enumerable: true,
        get: function() {
          return _index.tsPropertySignature;
        }
      });
      Object.defineProperty(exports2, "TSQualifiedName", {
        enumerable: true,
        get: function() {
          return _index.tsQualifiedName;
        }
      });
      Object.defineProperty(exports2, "TSRestType", {
        enumerable: true,
        get: function() {
          return _index.tsRestType;
        }
      });
      Object.defineProperty(exports2, "TSSatisfiesExpression", {
        enumerable: true,
        get: function() {
          return _index.tsSatisfiesExpression;
        }
      });
      Object.defineProperty(exports2, "TSStringKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsStringKeyword;
        }
      });
      Object.defineProperty(exports2, "TSSymbolKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsSymbolKeyword;
        }
      });
      Object.defineProperty(exports2, "TSThisType", {
        enumerable: true,
        get: function() {
          return _index.tsThisType;
        }
      });
      Object.defineProperty(exports2, "TSTupleType", {
        enumerable: true,
        get: function() {
          return _index.tsTupleType;
        }
      });
      Object.defineProperty(exports2, "TSTypeAliasDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsTypeAliasDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.tsTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "TSTypeAssertion", {
        enumerable: true,
        get: function() {
          return _index.tsTypeAssertion;
        }
      });
      Object.defineProperty(exports2, "TSTypeLiteral", {
        enumerable: true,
        get: function() {
          return _index.tsTypeLiteral;
        }
      });
      Object.defineProperty(exports2, "TSTypeOperator", {
        enumerable: true,
        get: function() {
          return _index.tsTypeOperator;
        }
      });
      Object.defineProperty(exports2, "TSTypeParameter", {
        enumerable: true,
        get: function() {
          return _index.tsTypeParameter;
        }
      });
      Object.defineProperty(exports2, "TSTypeParameterDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsTypeParameterDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSTypeParameterInstantiation", {
        enumerable: true,
        get: function() {
          return _index.tsTypeParameterInstantiation;
        }
      });
      Object.defineProperty(exports2, "TSTypePredicate", {
        enumerable: true,
        get: function() {
          return _index.tsTypePredicate;
        }
      });
      Object.defineProperty(exports2, "TSTypeQuery", {
        enumerable: true,
        get: function() {
          return _index.tsTypeQuery;
        }
      });
      Object.defineProperty(exports2, "TSTypeReference", {
        enumerable: true,
        get: function() {
          return _index.tsTypeReference;
        }
      });
      Object.defineProperty(exports2, "TSUndefinedKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsUndefinedKeyword;
        }
      });
      Object.defineProperty(exports2, "TSUnionType", {
        enumerable: true,
        get: function() {
          return _index.tsUnionType;
        }
      });
      Object.defineProperty(exports2, "TSUnknownKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsUnknownKeyword;
        }
      });
      Object.defineProperty(exports2, "TSVoidKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsVoidKeyword;
        }
      });
      Object.defineProperty(exports2, "TaggedTemplateExpression", {
        enumerable: true,
        get: function() {
          return _index.taggedTemplateExpression;
        }
      });
      Object.defineProperty(exports2, "TemplateElement", {
        enumerable: true,
        get: function() {
          return _index.templateElement;
        }
      });
      Object.defineProperty(exports2, "TemplateLiteral", {
        enumerable: true,
        get: function() {
          return _index.templateLiteral;
        }
      });
      Object.defineProperty(exports2, "ThisExpression", {
        enumerable: true,
        get: function() {
          return _index.thisExpression;
        }
      });
      Object.defineProperty(exports2, "ThisTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.thisTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ThrowStatement", {
        enumerable: true,
        get: function() {
          return _index.throwStatement;
        }
      });
      Object.defineProperty(exports2, "TopicReference", {
        enumerable: true,
        get: function() {
          return _index.topicReference;
        }
      });
      Object.defineProperty(exports2, "TryStatement", {
        enumerable: true,
        get: function() {
          return _index.tryStatement;
        }
      });
      Object.defineProperty(exports2, "TupleExpression", {
        enumerable: true,
        get: function() {
          return _index.tupleExpression;
        }
      });
      Object.defineProperty(exports2, "TupleTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.tupleTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "TypeAlias", {
        enumerable: true,
        get: function() {
          return _index.typeAlias;
        }
      });
      Object.defineProperty(exports2, "TypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.typeAnnotation;
        }
      });
      Object.defineProperty(exports2, "TypeCastExpression", {
        enumerable: true,
        get: function() {
          return _index.typeCastExpression;
        }
      });
      Object.defineProperty(exports2, "TypeParameter", {
        enumerable: true,
        get: function() {
          return _index.typeParameter;
        }
      });
      Object.defineProperty(exports2, "TypeParameterDeclaration", {
        enumerable: true,
        get: function() {
          return _index.typeParameterDeclaration;
        }
      });
      Object.defineProperty(exports2, "TypeParameterInstantiation", {
        enumerable: true,
        get: function() {
          return _index.typeParameterInstantiation;
        }
      });
      Object.defineProperty(exports2, "TypeofTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.typeofTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "UnaryExpression", {
        enumerable: true,
        get: function() {
          return _index.unaryExpression;
        }
      });
      Object.defineProperty(exports2, "UnionTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.unionTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "UpdateExpression", {
        enumerable: true,
        get: function() {
          return _index.updateExpression;
        }
      });
      Object.defineProperty(exports2, "V8IntrinsicIdentifier", {
        enumerable: true,
        get: function() {
          return _index.v8IntrinsicIdentifier;
        }
      });
      Object.defineProperty(exports2, "VariableDeclaration", {
        enumerable: true,
        get: function() {
          return _index.variableDeclaration;
        }
      });
      Object.defineProperty(exports2, "VariableDeclarator", {
        enumerable: true,
        get: function() {
          return _index.variableDeclarator;
        }
      });
      Object.defineProperty(exports2, "Variance", {
        enumerable: true,
        get: function() {
          return _index.variance;
        }
      });
      Object.defineProperty(exports2, "VoidTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.voidTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "WhileStatement", {
        enumerable: true,
        get: function() {
          return _index.whileStatement;
        }
      });
      Object.defineProperty(exports2, "WithStatement", {
        enumerable: true,
        get: function() {
          return _index.withStatement;
        }
      });
      Object.defineProperty(exports2, "YieldExpression", {
        enumerable: true,
        get: function() {
          return _index.yieldExpression;
        }
      });
      var _index = require_generated2();
    }
  });

  // node_modules/@babel/types/lib/clone/cloneNode.js
  var require_cloneNode = __commonJS({
    "node_modules/@babel/types/lib/clone/cloneNode.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = cloneNode;
      var _definitions = require_definitions();
      var _generated = require_generated();
      var has2 = Function.call.bind(Object.prototype.hasOwnProperty);
      function cloneIfNode(obj, deep, withoutLoc, commentsCache) {
        if (obj && typeof obj.type === "string") {
          return cloneNodeInternal(obj, deep, withoutLoc, commentsCache);
        }
        return obj;
      }
      function cloneIfNodeOrArray(obj, deep, withoutLoc, commentsCache) {
        if (Array.isArray(obj)) {
          return obj.map((node) => cloneIfNode(node, deep, withoutLoc, commentsCache));
        }
        return cloneIfNode(obj, deep, withoutLoc, commentsCache);
      }
      function cloneNode(node, deep = true, withoutLoc = false) {
        return cloneNodeInternal(node, deep, withoutLoc, /* @__PURE__ */ new Map());
      }
      function cloneNodeInternal(node, deep = true, withoutLoc = false, commentsCache) {
        if (!node)
          return node;
        const {
          type
        } = node;
        const newNode = {
          type: node.type
        };
        if ((0, _generated.isIdentifier)(node)) {
          newNode.name = node.name;
          if (has2(node, "optional") && typeof node.optional === "boolean") {
            newNode.optional = node.optional;
          }
          if (has2(node, "typeAnnotation")) {
            newNode.typeAnnotation = deep ? cloneIfNodeOrArray(node.typeAnnotation, true, withoutLoc, commentsCache) : node.typeAnnotation;
          }
        } else if (!has2(_definitions.NODE_FIELDS, type)) {
          throw new Error(`Unknown node type: "${type}"`);
        } else {
          for (const field of Object.keys(_definitions.NODE_FIELDS[type])) {
            if (has2(node, field)) {
              if (deep) {
                newNode[field] = (0, _generated.isFile)(node) && field === "comments" ? maybeCloneComments(node.comments, deep, withoutLoc, commentsCache) : cloneIfNodeOrArray(
                  node[field],
                  true,
                  withoutLoc,
                  commentsCache
                );
              } else {
                newNode[field] = node[field];
              }
            }
          }
        }
        if (has2(node, "loc")) {
          if (withoutLoc) {
            newNode.loc = null;
          } else {
            newNode.loc = node.loc;
          }
        }
        if (has2(node, "leadingComments")) {
          newNode.leadingComments = maybeCloneComments(node.leadingComments, deep, withoutLoc, commentsCache);
        }
        if (has2(node, "innerComments")) {
          newNode.innerComments = maybeCloneComments(node.innerComments, deep, withoutLoc, commentsCache);
        }
        if (has2(node, "trailingComments")) {
          newNode.trailingComments = maybeCloneComments(node.trailingComments, deep, withoutLoc, commentsCache);
        }
        if (has2(node, "extra")) {
          newNode.extra = Object.assign({}, node.extra);
        }
        return newNode;
      }
      function maybeCloneComments(comments, deep, withoutLoc, commentsCache) {
        if (!comments || !deep) {
          return comments;
        }
        return comments.map((comment) => {
          const cache = commentsCache.get(comment);
          if (cache)
            return cache;
          const {
            type,
            value,
            loc
          } = comment;
          const ret = {
            type,
            value,
            loc
          };
          if (withoutLoc) {
            ret.loc = null;
          }
          commentsCache.set(comment, ret);
          return ret;
        });
      }
    }
  });

  // node_modules/@babel/types/lib/clone/clone.js
  var require_clone = __commonJS({
    "node_modules/@babel/types/lib/clone/clone.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = clone2;
      var _cloneNode = require_cloneNode();
      function clone2(node) {
        return (0, _cloneNode.default)(node, false);
      }
    }
  });

  // node_modules/@babel/types/lib/clone/cloneDeep.js
  var require_cloneDeep = __commonJS({
    "node_modules/@babel/types/lib/clone/cloneDeep.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = cloneDeep2;
      var _cloneNode = require_cloneNode();
      function cloneDeep2(node) {
        return (0, _cloneNode.default)(node);
      }
    }
  });

  // node_modules/@babel/types/lib/clone/cloneDeepWithoutLoc.js
  var require_cloneDeepWithoutLoc = __commonJS({
    "node_modules/@babel/types/lib/clone/cloneDeepWithoutLoc.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = cloneDeepWithoutLoc;
      var _cloneNode = require_cloneNode();
      function cloneDeepWithoutLoc(node) {
        return (0, _cloneNode.default)(node, true, true);
      }
    }
  });

  // node_modules/@babel/types/lib/clone/cloneWithoutLoc.js
  var require_cloneWithoutLoc = __commonJS({
    "node_modules/@babel/types/lib/clone/cloneWithoutLoc.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = cloneWithoutLoc;
      var _cloneNode = require_cloneNode();
      function cloneWithoutLoc(node) {
        return (0, _cloneNode.default)(node, false, true);
      }
    }
  });

  // node_modules/@babel/types/lib/comments/addComments.js
  var require_addComments = __commonJS({
    "node_modules/@babel/types/lib/comments/addComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = addComments;
      function addComments(node, type, comments) {
        if (!comments || !node)
          return node;
        const key = `${type}Comments`;
        if (node[key]) {
          if (type === "leading") {
            node[key] = comments.concat(node[key]);
          } else {
            node[key].push(...comments);
          }
        } else {
          node[key] = comments;
        }
        return node;
      }
    }
  });

  // node_modules/@babel/types/lib/comments/addComment.js
  var require_addComment = __commonJS({
    "node_modules/@babel/types/lib/comments/addComment.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = addComment;
      var _addComments = require_addComments();
      function addComment(node, type, content, line) {
        return (0, _addComments.default)(node, type, [{
          type: line ? "CommentLine" : "CommentBlock",
          value: content
        }]);
      }
    }
  });

  // node_modules/@babel/types/lib/utils/inherit.js
  var require_inherit = __commonJS({
    "node_modules/@babel/types/lib/utils/inherit.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inherit;
      function inherit(key, child, parent2) {
        if (child && parent2) {
          child[key] = Array.from(new Set([].concat(child[key], parent2[key]).filter(Boolean)));
        }
      }
    }
  });

  // node_modules/@babel/types/lib/comments/inheritInnerComments.js
  var require_inheritInnerComments = __commonJS({
    "node_modules/@babel/types/lib/comments/inheritInnerComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inheritInnerComments;
      var _inherit = require_inherit();
      function inheritInnerComments(child, parent2) {
        (0, _inherit.default)("innerComments", child, parent2);
      }
    }
  });

  // node_modules/@babel/types/lib/comments/inheritLeadingComments.js
  var require_inheritLeadingComments = __commonJS({
    "node_modules/@babel/types/lib/comments/inheritLeadingComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inheritLeadingComments;
      var _inherit = require_inherit();
      function inheritLeadingComments(child, parent2) {
        (0, _inherit.default)("leadingComments", child, parent2);
      }
    }
  });

  // node_modules/@babel/types/lib/comments/inheritTrailingComments.js
  var require_inheritTrailingComments = __commonJS({
    "node_modules/@babel/types/lib/comments/inheritTrailingComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inheritTrailingComments;
      var _inherit = require_inherit();
      function inheritTrailingComments(child, parent2) {
        (0, _inherit.default)("trailingComments", child, parent2);
      }
    }
  });

  // node_modules/@babel/types/lib/comments/inheritsComments.js
  var require_inheritsComments = __commonJS({
    "node_modules/@babel/types/lib/comments/inheritsComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inheritsComments;
      var _inheritTrailingComments = require_inheritTrailingComments();
      var _inheritLeadingComments = require_inheritLeadingComments();
      var _inheritInnerComments = require_inheritInnerComments();
      function inheritsComments(child, parent2) {
        (0, _inheritTrailingComments.default)(child, parent2);
        (0, _inheritLeadingComments.default)(child, parent2);
        (0, _inheritInnerComments.default)(child, parent2);
        return child;
      }
    }
  });

  // node_modules/@babel/types/lib/comments/removeComments.js
  var require_removeComments = __commonJS({
    "node_modules/@babel/types/lib/comments/removeComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = removeComments;
      var _constants = require_constants();
      function removeComments(node) {
        _constants.COMMENT_KEYS.forEach((key) => {
          node[key] = null;
        });
        return node;
      }
    }
  });

  // node_modules/@babel/types/lib/constants/generated/index.js
  var require_generated4 = __commonJS({
    "node_modules/@babel/types/lib/constants/generated/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.WHILE_TYPES = exports2.USERWHITESPACABLE_TYPES = exports2.UNARYLIKE_TYPES = exports2.TYPESCRIPT_TYPES = exports2.TSTYPE_TYPES = exports2.TSTYPEELEMENT_TYPES = exports2.TSENTITYNAME_TYPES = exports2.TSBASETYPE_TYPES = exports2.TERMINATORLESS_TYPES = exports2.STATEMENT_TYPES = exports2.STANDARDIZED_TYPES = exports2.SCOPABLE_TYPES = exports2.PUREISH_TYPES = exports2.PROPERTY_TYPES = exports2.PRIVATE_TYPES = exports2.PATTERN_TYPES = exports2.PATTERNLIKE_TYPES = exports2.OBJECTMEMBER_TYPES = exports2.MODULESPECIFIER_TYPES = exports2.MODULEDECLARATION_TYPES = exports2.MISCELLANEOUS_TYPES = exports2.METHOD_TYPES = exports2.LVAL_TYPES = exports2.LOOP_TYPES = exports2.LITERAL_TYPES = exports2.JSX_TYPES = exports2.IMMUTABLE_TYPES = exports2.FUNCTION_TYPES = exports2.FUNCTIONPARENT_TYPES = exports2.FOR_TYPES = exports2.FORXSTATEMENT_TYPES = exports2.FLOW_TYPES = exports2.FLOWTYPE_TYPES = exports2.FLOWPREDICATE_TYPES = exports2.FLOWDECLARATION_TYPES = exports2.FLOWBASEANNOTATION_TYPES = exports2.EXPRESSION_TYPES = exports2.EXPRESSIONWRAPPER_TYPES = exports2.EXPORTDECLARATION_TYPES = exports2.ENUMMEMBER_TYPES = exports2.ENUMBODY_TYPES = exports2.DECLARATION_TYPES = exports2.CONDITIONAL_TYPES = exports2.COMPLETIONSTATEMENT_TYPES = exports2.CLASS_TYPES = exports2.BLOCK_TYPES = exports2.BLOCKPARENT_TYPES = exports2.BINARY_TYPES = exports2.ACCESSOR_TYPES = void 0;
      var _definitions = require_definitions();
      var STANDARDIZED_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Standardized"];
      exports2.STANDARDIZED_TYPES = STANDARDIZED_TYPES;
      var EXPRESSION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Expression"];
      exports2.EXPRESSION_TYPES = EXPRESSION_TYPES;
      var BINARY_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Binary"];
      exports2.BINARY_TYPES = BINARY_TYPES;
      var SCOPABLE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Scopable"];
      exports2.SCOPABLE_TYPES = SCOPABLE_TYPES;
      var BLOCKPARENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["BlockParent"];
      exports2.BLOCKPARENT_TYPES = BLOCKPARENT_TYPES;
      var BLOCK_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Block"];
      exports2.BLOCK_TYPES = BLOCK_TYPES;
      var STATEMENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Statement"];
      exports2.STATEMENT_TYPES = STATEMENT_TYPES;
      var TERMINATORLESS_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Terminatorless"];
      exports2.TERMINATORLESS_TYPES = TERMINATORLESS_TYPES;
      var COMPLETIONSTATEMENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["CompletionStatement"];
      exports2.COMPLETIONSTATEMENT_TYPES = COMPLETIONSTATEMENT_TYPES;
      var CONDITIONAL_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Conditional"];
      exports2.CONDITIONAL_TYPES = CONDITIONAL_TYPES;
      var LOOP_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Loop"];
      exports2.LOOP_TYPES = LOOP_TYPES;
      var WHILE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["While"];
      exports2.WHILE_TYPES = WHILE_TYPES;
      var EXPRESSIONWRAPPER_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ExpressionWrapper"];
      exports2.EXPRESSIONWRAPPER_TYPES = EXPRESSIONWRAPPER_TYPES;
      var FOR_TYPES = _definitions.FLIPPED_ALIAS_KEYS["For"];
      exports2.FOR_TYPES = FOR_TYPES;
      var FORXSTATEMENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ForXStatement"];
      exports2.FORXSTATEMENT_TYPES = FORXSTATEMENT_TYPES;
      var FUNCTION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Function"];
      exports2.FUNCTION_TYPES = FUNCTION_TYPES;
      var FUNCTIONPARENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["FunctionParent"];
      exports2.FUNCTIONPARENT_TYPES = FUNCTIONPARENT_TYPES;
      var PUREISH_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Pureish"];
      exports2.PUREISH_TYPES = PUREISH_TYPES;
      var DECLARATION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Declaration"];
      exports2.DECLARATION_TYPES = DECLARATION_TYPES;
      var PATTERNLIKE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["PatternLike"];
      exports2.PATTERNLIKE_TYPES = PATTERNLIKE_TYPES;
      var LVAL_TYPES = _definitions.FLIPPED_ALIAS_KEYS["LVal"];
      exports2.LVAL_TYPES = LVAL_TYPES;
      var TSENTITYNAME_TYPES = _definitions.FLIPPED_ALIAS_KEYS["TSEntityName"];
      exports2.TSENTITYNAME_TYPES = TSENTITYNAME_TYPES;
      var LITERAL_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Literal"];
      exports2.LITERAL_TYPES = LITERAL_TYPES;
      var IMMUTABLE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Immutable"];
      exports2.IMMUTABLE_TYPES = IMMUTABLE_TYPES;
      var USERWHITESPACABLE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["UserWhitespacable"];
      exports2.USERWHITESPACABLE_TYPES = USERWHITESPACABLE_TYPES;
      var METHOD_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Method"];
      exports2.METHOD_TYPES = METHOD_TYPES;
      var OBJECTMEMBER_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ObjectMember"];
      exports2.OBJECTMEMBER_TYPES = OBJECTMEMBER_TYPES;
      var PROPERTY_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Property"];
      exports2.PROPERTY_TYPES = PROPERTY_TYPES;
      var UNARYLIKE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["UnaryLike"];
      exports2.UNARYLIKE_TYPES = UNARYLIKE_TYPES;
      var PATTERN_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Pattern"];
      exports2.PATTERN_TYPES = PATTERN_TYPES;
      var CLASS_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Class"];
      exports2.CLASS_TYPES = CLASS_TYPES;
      var MODULEDECLARATION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ModuleDeclaration"];
      exports2.MODULEDECLARATION_TYPES = MODULEDECLARATION_TYPES;
      var EXPORTDECLARATION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ExportDeclaration"];
      exports2.EXPORTDECLARATION_TYPES = EXPORTDECLARATION_TYPES;
      var MODULESPECIFIER_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ModuleSpecifier"];
      exports2.MODULESPECIFIER_TYPES = MODULESPECIFIER_TYPES;
      var ACCESSOR_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Accessor"];
      exports2.ACCESSOR_TYPES = ACCESSOR_TYPES;
      var PRIVATE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Private"];
      exports2.PRIVATE_TYPES = PRIVATE_TYPES;
      var FLOW_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Flow"];
      exports2.FLOW_TYPES = FLOW_TYPES;
      var FLOWTYPE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["FlowType"];
      exports2.FLOWTYPE_TYPES = FLOWTYPE_TYPES;
      var FLOWBASEANNOTATION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["FlowBaseAnnotation"];
      exports2.FLOWBASEANNOTATION_TYPES = FLOWBASEANNOTATION_TYPES;
      var FLOWDECLARATION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["FlowDeclaration"];
      exports2.FLOWDECLARATION_TYPES = FLOWDECLARATION_TYPES;
      var FLOWPREDICATE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["FlowPredicate"];
      exports2.FLOWPREDICATE_TYPES = FLOWPREDICATE_TYPES;
      var ENUMBODY_TYPES = _definitions.FLIPPED_ALIAS_KEYS["EnumBody"];
      exports2.ENUMBODY_TYPES = ENUMBODY_TYPES;
      var ENUMMEMBER_TYPES = _definitions.FLIPPED_ALIAS_KEYS["EnumMember"];
      exports2.ENUMMEMBER_TYPES = ENUMMEMBER_TYPES;
      var JSX_TYPES = _definitions.FLIPPED_ALIAS_KEYS["JSX"];
      exports2.JSX_TYPES = JSX_TYPES;
      var MISCELLANEOUS_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Miscellaneous"];
      exports2.MISCELLANEOUS_TYPES = MISCELLANEOUS_TYPES;
      var TYPESCRIPT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["TypeScript"];
      exports2.TYPESCRIPT_TYPES = TYPESCRIPT_TYPES;
      var TSTYPEELEMENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["TSTypeElement"];
      exports2.TSTYPEELEMENT_TYPES = TSTYPEELEMENT_TYPES;
      var TSTYPE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["TSType"];
      exports2.TSTYPE_TYPES = TSTYPE_TYPES;
      var TSBASETYPE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["TSBaseType"];
      exports2.TSBASETYPE_TYPES = TSBASETYPE_TYPES;
    }
  });

  // node_modules/@babel/types/lib/converters/toBlock.js
  var require_toBlock = __commonJS({
    "node_modules/@babel/types/lib/converters/toBlock.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toBlock;
      var _generated = require_generated();
      var _generated2 = require_generated2();
      function toBlock(node, parent2) {
        if ((0, _generated.isBlockStatement)(node)) {
          return node;
        }
        let blockNodes = [];
        if ((0, _generated.isEmptyStatement)(node)) {
          blockNodes = [];
        } else {
          if (!(0, _generated.isStatement)(node)) {
            if ((0, _generated.isFunction)(parent2)) {
              node = (0, _generated2.returnStatement)(node);
            } else {
              node = (0, _generated2.expressionStatement)(node);
            }
          }
          blockNodes = [node];
        }
        return (0, _generated2.blockStatement)(blockNodes);
      }
    }
  });

  // node_modules/@babel/types/lib/converters/ensureBlock.js
  var require_ensureBlock = __commonJS({
    "node_modules/@babel/types/lib/converters/ensureBlock.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = ensureBlock;
      var _toBlock = require_toBlock();
      function ensureBlock(node, key = "body") {
        const result2 = (0, _toBlock.default)(node[key], node);
        node[key] = result2;
        return result2;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toIdentifier.js
  var require_toIdentifier = __commonJS({
    "node_modules/@babel/types/lib/converters/toIdentifier.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toIdentifier;
      var _isValidIdentifier = require_isValidIdentifier();
      var _helperValidatorIdentifier = require_lib3();
      function toIdentifier(input) {
        input = input + "";
        let name = "";
        for (const c of input) {
          name += (0, _helperValidatorIdentifier.isIdentifierChar)(c.codePointAt(0)) ? c : "-";
        }
        name = name.replace(/^[-0-9]+/, "");
        name = name.replace(/[-\s]+(.)?/g, function(match, c) {
          return c ? c.toUpperCase() : "";
        });
        if (!(0, _isValidIdentifier.default)(name)) {
          name = `_${name}`;
        }
        return name || "_";
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toBindingIdentifierName.js
  var require_toBindingIdentifierName = __commonJS({
    "node_modules/@babel/types/lib/converters/toBindingIdentifierName.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toBindingIdentifierName;
      var _toIdentifier = require_toIdentifier();
      function toBindingIdentifierName(name) {
        name = (0, _toIdentifier.default)(name);
        if (name === "eval" || name === "arguments")
          name = "_" + name;
        return name;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toComputedKey.js
  var require_toComputedKey = __commonJS({
    "node_modules/@babel/types/lib/converters/toComputedKey.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toComputedKey;
      var _generated = require_generated();
      var _generated2 = require_generated2();
      function toComputedKey(node, key = node.key || node.property) {
        if (!node.computed && (0, _generated.isIdentifier)(key))
          key = (0, _generated2.stringLiteral)(key.name);
        return key;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toExpression.js
  var require_toExpression = __commonJS({
    "node_modules/@babel/types/lib/converters/toExpression.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _generated = require_generated();
      var _default = toExpression;
      exports2.default = _default;
      function toExpression(node) {
        if ((0, _generated.isExpressionStatement)(node)) {
          node = node.expression;
        }
        if ((0, _generated.isExpression)(node)) {
          return node;
        }
        if ((0, _generated.isClass)(node)) {
          node.type = "ClassExpression";
        } else if ((0, _generated.isFunction)(node)) {
          node.type = "FunctionExpression";
        }
        if (!(0, _generated.isExpression)(node)) {
          throw new Error(`cannot turn ${node.type} to an expression`);
        }
        return node;
      }
    }
  });

  // node_modules/@babel/types/lib/traverse/traverseFast.js
  var require_traverseFast = __commonJS({
    "node_modules/@babel/types/lib/traverse/traverseFast.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = traverseFast;
      var _definitions = require_definitions();
      function traverseFast(node, enter, opts) {
        if (!node)
          return;
        const keys2 = _definitions.VISITOR_KEYS[node.type];
        if (!keys2)
          return;
        opts = opts || {};
        enter(node, opts);
        for (const key of keys2) {
          const subNode = node[key];
          if (Array.isArray(subNode)) {
            for (const node2 of subNode) {
              traverseFast(node2, enter, opts);
            }
          } else {
            traverseFast(subNode, enter, opts);
          }
        }
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/removeProperties.js
  var require_removeProperties = __commonJS({
    "node_modules/@babel/types/lib/modifications/removeProperties.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = removeProperties;
      var _constants = require_constants();
      var CLEAR_KEYS = [
        "tokens",
        "start",
        "end",
        "loc",
        "raw",
        "rawValue"
      ];
      var CLEAR_KEYS_PLUS_COMMENTS = [..._constants.COMMENT_KEYS, "comments", ...CLEAR_KEYS];
      function removeProperties(node, opts = {}) {
        const map2 = opts.preserveComments ? CLEAR_KEYS : CLEAR_KEYS_PLUS_COMMENTS;
        for (const key of map2) {
          if (node[key] != null)
            node[key] = void 0;
        }
        for (const key of Object.keys(node)) {
          if (key[0] === "_" && node[key] != null)
            node[key] = void 0;
        }
        const symbols = Object.getOwnPropertySymbols(node);
        for (const sym of symbols) {
          node[sym] = null;
        }
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/removePropertiesDeep.js
  var require_removePropertiesDeep = __commonJS({
    "node_modules/@babel/types/lib/modifications/removePropertiesDeep.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = removePropertiesDeep;
      var _traverseFast = require_traverseFast();
      var _removeProperties = require_removeProperties();
      function removePropertiesDeep(tree, opts) {
        (0, _traverseFast.default)(tree, _removeProperties.default, opts);
        return tree;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toKeyAlias.js
  var require_toKeyAlias = __commonJS({
    "node_modules/@babel/types/lib/converters/toKeyAlias.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toKeyAlias;
      var _generated = require_generated();
      var _cloneNode = require_cloneNode();
      var _removePropertiesDeep = require_removePropertiesDeep();
      function toKeyAlias(node, key = node.key) {
        let alias;
        if (node.kind === "method") {
          return toKeyAlias.increment() + "";
        } else if ((0, _generated.isIdentifier)(key)) {
          alias = key.name;
        } else if ((0, _generated.isStringLiteral)(key)) {
          alias = JSON.stringify(key.value);
        } else {
          alias = JSON.stringify((0, _removePropertiesDeep.default)((0, _cloneNode.default)(key)));
        }
        if (node.computed) {
          alias = `[${alias}]`;
        }
        if (node.static) {
          alias = `static:${alias}`;
        }
        return alias;
      }
      toKeyAlias.uid = 0;
      toKeyAlias.increment = function() {
        if (toKeyAlias.uid >= Number.MAX_SAFE_INTEGER) {
          return toKeyAlias.uid = 0;
        } else {
          return toKeyAlias.uid++;
        }
      };
    }
  });

  // node_modules/@babel/types/lib/retrievers/getBindingIdentifiers.js
  var require_getBindingIdentifiers = __commonJS({
    "node_modules/@babel/types/lib/retrievers/getBindingIdentifiers.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = getBindingIdentifiers;
      var _generated = require_generated();
      function getBindingIdentifiers(node, duplicates, outerOnly) {
        const search = [].concat(node);
        const ids = /* @__PURE__ */ Object.create(null);
        while (search.length) {
          const id = search.shift();
          if (!id)
            continue;
          const keys2 = getBindingIdentifiers.keys[id.type];
          if ((0, _generated.isIdentifier)(id)) {
            if (duplicates) {
              const _ids = ids[id.name] = ids[id.name] || [];
              _ids.push(id);
            } else {
              ids[id.name] = id;
            }
            continue;
          }
          if ((0, _generated.isExportDeclaration)(id) && !(0, _generated.isExportAllDeclaration)(id)) {
            if ((0, _generated.isDeclaration)(id.declaration)) {
              search.push(id.declaration);
            }
            continue;
          }
          if (outerOnly) {
            if ((0, _generated.isFunctionDeclaration)(id)) {
              search.push(id.id);
              continue;
            }
            if ((0, _generated.isFunctionExpression)(id)) {
              continue;
            }
          }
          if (keys2) {
            for (let i = 0; i < keys2.length; i++) {
              const key = keys2[i];
              const nodes = id[key];
              if (nodes) {
                Array.isArray(nodes) ? search.push(...nodes) : search.push(nodes);
              }
            }
          }
        }
        return ids;
      }
      getBindingIdentifiers.keys = {
        DeclareClass: ["id"],
        DeclareFunction: ["id"],
        DeclareModule: ["id"],
        DeclareVariable: ["id"],
        DeclareInterface: ["id"],
        DeclareTypeAlias: ["id"],
        DeclareOpaqueType: ["id"],
        InterfaceDeclaration: ["id"],
        TypeAlias: ["id"],
        OpaqueType: ["id"],
        CatchClause: ["param"],
        LabeledStatement: ["label"],
        UnaryExpression: ["argument"],
        AssignmentExpression: ["left"],
        ImportSpecifier: ["local"],
        ImportNamespaceSpecifier: ["local"],
        ImportDefaultSpecifier: ["local"],
        ImportDeclaration: ["specifiers"],
        ExportSpecifier: ["exported"],
        ExportNamespaceSpecifier: ["exported"],
        ExportDefaultSpecifier: ["exported"],
        FunctionDeclaration: ["id", "params"],
        FunctionExpression: ["id", "params"],
        ArrowFunctionExpression: ["params"],
        ObjectMethod: ["params"],
        ClassMethod: ["params"],
        ClassPrivateMethod: ["params"],
        ForInStatement: ["left"],
        ForOfStatement: ["left"],
        ClassDeclaration: ["id"],
        ClassExpression: ["id"],
        RestElement: ["argument"],
        UpdateExpression: ["argument"],
        ObjectProperty: ["value"],
        AssignmentPattern: ["left"],
        ArrayPattern: ["elements"],
        ObjectPattern: ["properties"],
        VariableDeclaration: ["declarations"],
        VariableDeclarator: ["id"]
      };
    }
  });

  // node_modules/@babel/types/lib/converters/gatherSequenceExpressions.js
  var require_gatherSequenceExpressions = __commonJS({
    "node_modules/@babel/types/lib/converters/gatherSequenceExpressions.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = gatherSequenceExpressions;
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      var _generated = require_generated();
      var _generated2 = require_generated2();
      var _cloneNode = require_cloneNode();
      function gatherSequenceExpressions(nodes, scope, declars) {
        const exprs = [];
        let ensureLastUndefined = true;
        for (const node of nodes) {
          if (!(0, _generated.isEmptyStatement)(node)) {
            ensureLastUndefined = false;
          }
          if ((0, _generated.isExpression)(node)) {
            exprs.push(node);
          } else if ((0, _generated.isExpressionStatement)(node)) {
            exprs.push(node.expression);
          } else if ((0, _generated.isVariableDeclaration)(node)) {
            if (node.kind !== "var")
              return;
            for (const declar of node.declarations) {
              const bindings = (0, _getBindingIdentifiers.default)(declar);
              for (const key of Object.keys(bindings)) {
                declars.push({
                  kind: node.kind,
                  id: (0, _cloneNode.default)(bindings[key])
                });
              }
              if (declar.init) {
                exprs.push((0, _generated2.assignmentExpression)("=", declar.id, declar.init));
              }
            }
            ensureLastUndefined = true;
          } else if ((0, _generated.isIfStatement)(node)) {
            const consequent = node.consequent ? gatherSequenceExpressions([node.consequent], scope, declars) : scope.buildUndefinedNode();
            const alternate = node.alternate ? gatherSequenceExpressions([node.alternate], scope, declars) : scope.buildUndefinedNode();
            if (!consequent || !alternate)
              return;
            exprs.push((0, _generated2.conditionalExpression)(node.test, consequent, alternate));
          } else if ((0, _generated.isBlockStatement)(node)) {
            const body = gatherSequenceExpressions(node.body, scope, declars);
            if (!body)
              return;
            exprs.push(body);
          } else if ((0, _generated.isEmptyStatement)(node)) {
            if (nodes.indexOf(node) === 0) {
              ensureLastUndefined = true;
            }
          } else {
            return;
          }
        }
        if (ensureLastUndefined) {
          exprs.push(scope.buildUndefinedNode());
        }
        if (exprs.length === 1) {
          return exprs[0];
        } else {
          return (0, _generated2.sequenceExpression)(exprs);
        }
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toSequenceExpression.js
  var require_toSequenceExpression = __commonJS({
    "node_modules/@babel/types/lib/converters/toSequenceExpression.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toSequenceExpression;
      var _gatherSequenceExpressions = require_gatherSequenceExpressions();
      function toSequenceExpression(nodes, scope) {
        if (!(nodes != null && nodes.length))
          return;
        const declars = [];
        const result2 = (0, _gatherSequenceExpressions.default)(nodes, scope, declars);
        if (!result2)
          return;
        for (const declar of declars) {
          scope.push(declar);
        }
        return result2;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toStatement.js
  var require_toStatement = __commonJS({
    "node_modules/@babel/types/lib/converters/toStatement.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _generated = require_generated();
      var _generated2 = require_generated2();
      var _default = toStatement;
      exports2.default = _default;
      function toStatement(node, ignore) {
        if ((0, _generated.isStatement)(node)) {
          return node;
        }
        let mustHaveId = false;
        let newType;
        if ((0, _generated.isClass)(node)) {
          mustHaveId = true;
          newType = "ClassDeclaration";
        } else if ((0, _generated.isFunction)(node)) {
          mustHaveId = true;
          newType = "FunctionDeclaration";
        } else if ((0, _generated.isAssignmentExpression)(node)) {
          return (0, _generated2.expressionStatement)(node);
        }
        if (mustHaveId && !node.id) {
          newType = false;
        }
        if (!newType) {
          if (ignore) {
            return false;
          } else {
            throw new Error(`cannot turn ${node.type} to a statement`);
          }
        }
        node.type = newType;
        return node;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/valueToNode.js
  var require_valueToNode = __commonJS({
    "node_modules/@babel/types/lib/converters/valueToNode.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _isValidIdentifier = require_isValidIdentifier();
      var _generated = require_generated2();
      var _default = valueToNode;
      exports2.default = _default;
      var objectToString2 = Function.call.bind(Object.prototype.toString);
      function isRegExp2(value) {
        return objectToString2(value) === "[object RegExp]";
      }
      function isPlainObject2(value) {
        if (typeof value !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") {
          return false;
        }
        const proto = Object.getPrototypeOf(value);
        return proto === null || Object.getPrototypeOf(proto) === null;
      }
      function valueToNode(value) {
        if (value === void 0) {
          return (0, _generated.identifier)("undefined");
        }
        if (value === true || value === false) {
          return (0, _generated.booleanLiteral)(value);
        }
        if (value === null) {
          return (0, _generated.nullLiteral)();
        }
        if (typeof value === "string") {
          return (0, _generated.stringLiteral)(value);
        }
        if (typeof value === "number") {
          let result2;
          if (Number.isFinite(value)) {
            result2 = (0, _generated.numericLiteral)(Math.abs(value));
          } else {
            let numerator;
            if (Number.isNaN(value)) {
              numerator = (0, _generated.numericLiteral)(0);
            } else {
              numerator = (0, _generated.numericLiteral)(1);
            }
            result2 = (0, _generated.binaryExpression)("/", numerator, (0, _generated.numericLiteral)(0));
          }
          if (value < 0 || Object.is(value, -0)) {
            result2 = (0, _generated.unaryExpression)("-", result2);
          }
          return result2;
        }
        if (isRegExp2(value)) {
          const pattern = value.source;
          const flags = value.toString().match(/\/([a-z]+|)$/)[1];
          return (0, _generated.regExpLiteral)(pattern, flags);
        }
        if (Array.isArray(value)) {
          return (0, _generated.arrayExpression)(value.map(valueToNode));
        }
        if (isPlainObject2(value)) {
          const props = [];
          for (const key of Object.keys(value)) {
            let nodeKey;
            if ((0, _isValidIdentifier.default)(key)) {
              nodeKey = (0, _generated.identifier)(key);
            } else {
              nodeKey = (0, _generated.stringLiteral)(key);
            }
            props.push((0, _generated.objectProperty)(nodeKey, valueToNode(
              value[key]
            )));
          }
          return (0, _generated.objectExpression)(props);
        }
        throw new Error("don't know how to turn this value into a node");
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/appendToMemberExpression.js
  var require_appendToMemberExpression = __commonJS({
    "node_modules/@babel/types/lib/modifications/appendToMemberExpression.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = appendToMemberExpression;
      var _generated = require_generated2();
      function appendToMemberExpression(member, append, computed = false) {
        member.object = (0, _generated.memberExpression)(member.object, member.property, member.computed);
        member.property = append;
        member.computed = !!computed;
        return member;
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/inherits.js
  var require_inherits = __commonJS({
    "node_modules/@babel/types/lib/modifications/inherits.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inherits;
      var _constants = require_constants();
      var _inheritsComments = require_inheritsComments();
      function inherits(child, parent2) {
        if (!child || !parent2)
          return child;
        for (const key of _constants.INHERIT_KEYS.optional) {
          if (child[key] == null) {
            child[key] = parent2[key];
          }
        }
        for (const key of Object.keys(parent2)) {
          if (key[0] === "_" && key !== "__clone") {
            child[key] = parent2[key];
          }
        }
        for (const key of _constants.INHERIT_KEYS.force) {
          child[key] = parent2[key];
        }
        (0, _inheritsComments.default)(child, parent2);
        return child;
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/prependToMemberExpression.js
  var require_prependToMemberExpression = __commonJS({
    "node_modules/@babel/types/lib/modifications/prependToMemberExpression.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = prependToMemberExpression;
      var _generated = require_generated2();
      var _ = require_lib5();
      function prependToMemberExpression(member, prepend) {
        if ((0, _.isSuper)(member.object)) {
          throw new Error("Cannot prepend node to super property access (`super.foo`).");
        }
        member.object = (0, _generated.memberExpression)(prepend, member.object);
        return member;
      }
    }
  });

  // node_modules/@babel/types/lib/retrievers/getOuterBindingIdentifiers.js
  var require_getOuterBindingIdentifiers = __commonJS({
    "node_modules/@babel/types/lib/retrievers/getOuterBindingIdentifiers.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      var _default = getOuterBindingIdentifiers;
      exports2.default = _default;
      function getOuterBindingIdentifiers(node, duplicates) {
        return (0, _getBindingIdentifiers.default)(node, duplicates, true);
      }
    }
  });

  // node_modules/@babel/types/lib/traverse/traverse.js
  var require_traverse = __commonJS({
    "node_modules/@babel/types/lib/traverse/traverse.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = traverse3;
      var _definitions = require_definitions();
      function traverse3(node, handlers, state) {
        if (typeof handlers === "function") {
          handlers = {
            enter: handlers
          };
        }
        const {
          enter,
          exit
        } = handlers;
        traverseSimpleImpl(node, enter, exit, state, []);
      }
      function traverseSimpleImpl(node, enter, exit, state, ancestors) {
        const keys2 = _definitions.VISITOR_KEYS[node.type];
        if (!keys2)
          return;
        if (enter)
          enter(node, ancestors, state);
        for (const key of keys2) {
          const subNode = node[key];
          if (Array.isArray(subNode)) {
            for (let i = 0; i < subNode.length; i++) {
              const child = subNode[i];
              if (!child)
                continue;
              ancestors.push({
                node,
                key,
                index: i
              });
              traverseSimpleImpl(child, enter, exit, state, ancestors);
              ancestors.pop();
            }
          } else if (subNode) {
            ancestors.push({
              node,
              key
            });
            traverseSimpleImpl(subNode, enter, exit, state, ancestors);
            ancestors.pop();
          }
        }
        if (exit)
          exit(node, ancestors, state);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isBinding.js
  var require_isBinding = __commonJS({
    "node_modules/@babel/types/lib/validators/isBinding.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isBinding;
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      function isBinding(node, parent2, grandparent) {
        if (grandparent && node.type === "Identifier" && parent2.type === "ObjectProperty" && grandparent.type === "ObjectExpression") {
          return false;
        }
        const keys2 = _getBindingIdentifiers.default.keys[parent2.type];
        if (keys2) {
          for (let i = 0; i < keys2.length; i++) {
            const key = keys2[i];
            const val = parent2[key];
            if (Array.isArray(val)) {
              if (val.indexOf(node) >= 0)
                return true;
            } else {
              if (val === node)
                return true;
            }
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isLet.js
  var require_isLet = __commonJS({
    "node_modules/@babel/types/lib/validators/isLet.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isLet;
      var _generated = require_generated();
      var _constants = require_constants();
      function isLet(node) {
        return (0, _generated.isVariableDeclaration)(node) && (node.kind !== "var" || node[_constants.BLOCK_SCOPED_SYMBOL]);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isBlockScoped.js
  var require_isBlockScoped = __commonJS({
    "node_modules/@babel/types/lib/validators/isBlockScoped.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isBlockScoped;
      var _generated = require_generated();
      var _isLet = require_isLet();
      function isBlockScoped(node) {
        return (0, _generated.isFunctionDeclaration)(node) || (0, _generated.isClassDeclaration)(node) || (0, _isLet.default)(node);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isImmutable.js
  var require_isImmutable = __commonJS({
    "node_modules/@babel/types/lib/validators/isImmutable.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isImmutable;
      var _isType = require_isType();
      var _generated = require_generated();
      function isImmutable(node) {
        if ((0, _isType.default)(node.type, "Immutable"))
          return true;
        if ((0, _generated.isIdentifier)(node)) {
          if (node.name === "undefined") {
            return true;
          } else {
            return false;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isNodesEquivalent.js
  var require_isNodesEquivalent = __commonJS({
    "node_modules/@babel/types/lib/validators/isNodesEquivalent.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isNodesEquivalent;
      var _definitions = require_definitions();
      function isNodesEquivalent(a, b) {
        if (typeof a !== "object" || typeof b !== "object" || a == null || b == null) {
          return a === b;
        }
        if (a.type !== b.type) {
          return false;
        }
        const fields = Object.keys(_definitions.NODE_FIELDS[a.type] || a.type);
        const visitorKeys = _definitions.VISITOR_KEYS[a.type];
        for (const field of fields) {
          const val_a = a[field];
          const val_b = b[field];
          if (typeof val_a !== typeof val_b) {
            return false;
          }
          if (val_a == null && val_b == null) {
            continue;
          } else if (val_a == null || val_b == null) {
            return false;
          }
          if (Array.isArray(val_a)) {
            if (!Array.isArray(val_b)) {
              return false;
            }
            if (val_a.length !== val_b.length) {
              return false;
            }
            for (let i = 0; i < val_a.length; i++) {
              if (!isNodesEquivalent(val_a[i], val_b[i])) {
                return false;
              }
            }
            continue;
          }
          if (typeof val_a === "object" && !(visitorKeys != null && visitorKeys.includes(field))) {
            for (const key of Object.keys(val_a)) {
              if (val_a[key] !== val_b[key]) {
                return false;
              }
            }
            continue;
          }
          if (!isNodesEquivalent(val_a, val_b)) {
            return false;
          }
        }
        return true;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isReferenced.js
  var require_isReferenced = __commonJS({
    "node_modules/@babel/types/lib/validators/isReferenced.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isReferenced;
      function isReferenced(node, parent2, grandparent) {
        switch (parent2.type) {
          case "MemberExpression":
          case "OptionalMemberExpression":
            if (parent2.property === node) {
              return !!parent2.computed;
            }
            return parent2.object === node;
          case "JSXMemberExpression":
            return parent2.object === node;
          case "VariableDeclarator":
            return parent2.init === node;
          case "ArrowFunctionExpression":
            return parent2.body === node;
          case "PrivateName":
            return false;
          case "ClassMethod":
          case "ClassPrivateMethod":
          case "ObjectMethod":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return false;
          case "ObjectProperty":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return !grandparent || grandparent.type !== "ObjectPattern";
          case "ClassProperty":
          case "ClassAccessorProperty":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return true;
          case "ClassPrivateProperty":
            return parent2.key !== node;
          case "ClassDeclaration":
          case "ClassExpression":
            return parent2.superClass === node;
          case "AssignmentExpression":
            return parent2.right === node;
          case "AssignmentPattern":
            return parent2.right === node;
          case "LabeledStatement":
            return false;
          case "CatchClause":
            return false;
          case "RestElement":
            return false;
          case "BreakStatement":
          case "ContinueStatement":
            return false;
          case "FunctionDeclaration":
          case "FunctionExpression":
            return false;
          case "ExportNamespaceSpecifier":
          case "ExportDefaultSpecifier":
            return false;
          case "ExportSpecifier":
            if (grandparent != null && grandparent.source) {
              return false;
            }
            return parent2.local === node;
          case "ImportDefaultSpecifier":
          case "ImportNamespaceSpecifier":
          case "ImportSpecifier":
            return false;
          case "ImportAttribute":
            return false;
          case "JSXAttribute":
            return false;
          case "ObjectPattern":
          case "ArrayPattern":
            return false;
          case "MetaProperty":
            return false;
          case "ObjectTypeProperty":
            return parent2.key !== node;
          case "TSEnumMember":
            return parent2.id !== node;
          case "TSPropertySignature":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return true;
        }
        return true;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isScope.js
  var require_isScope = __commonJS({
    "node_modules/@babel/types/lib/validators/isScope.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isScope;
      var _generated = require_generated();
      function isScope(node, parent2) {
        if ((0, _generated.isBlockStatement)(node) && ((0, _generated.isFunction)(parent2) || (0, _generated.isCatchClause)(parent2))) {
          return false;
        }
        if ((0, _generated.isPattern)(node) && ((0, _generated.isFunction)(parent2) || (0, _generated.isCatchClause)(parent2))) {
          return true;
        }
        return (0, _generated.isScopable)(node);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isSpecifierDefault.js
  var require_isSpecifierDefault = __commonJS({
    "node_modules/@babel/types/lib/validators/isSpecifierDefault.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isSpecifierDefault;
      var _generated = require_generated();
      function isSpecifierDefault(specifier) {
        return (0, _generated.isImportDefaultSpecifier)(specifier) || (0, _generated.isIdentifier)(specifier.imported || specifier.exported, {
          name: "default"
        });
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isValidES3Identifier.js
  var require_isValidES3Identifier = __commonJS({
    "node_modules/@babel/types/lib/validators/isValidES3Identifier.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isValidES3Identifier;
      var _isValidIdentifier = require_isValidIdentifier();
      var RESERVED_WORDS_ES3_ONLY = /* @__PURE__ */ new Set(["abstract", "boolean", "byte", "char", "double", "enum", "final", "float", "goto", "implements", "int", "interface", "long", "native", "package", "private", "protected", "public", "short", "static", "synchronized", "throws", "transient", "volatile"]);
      function isValidES3Identifier(name) {
        return (0, _isValidIdentifier.default)(name) && !RESERVED_WORDS_ES3_ONLY.has(name);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isVar.js
  var require_isVar = __commonJS({
    "node_modules/@babel/types/lib/validators/isVar.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isVar;
      var _generated = require_generated();
      var _constants = require_constants();
      function isVar(node) {
        return (0, _generated.isVariableDeclaration)(node, {
          kind: "var"
        }) && !node[_constants.BLOCK_SCOPED_SYMBOL];
      }
    }
  });

  // node_modules/@babel/types/lib/ast-types/generated/index.js
  var require_generated5 = __commonJS({
    "node_modules/@babel/types/lib/ast-types/generated/index.js"() {
      init_define_process();
    }
  });

  // node_modules/@babel/types/lib/index.js
  var require_lib5 = __commonJS({
    "node_modules/@babel/types/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      var _exportNames = {
        react: true,
        assertNode: true,
        createTypeAnnotationBasedOnTypeof: true,
        createUnionTypeAnnotation: true,
        createFlowUnionType: true,
        createTSUnionType: true,
        cloneNode: true,
        clone: true,
        cloneDeep: true,
        cloneDeepWithoutLoc: true,
        cloneWithoutLoc: true,
        addComment: true,
        addComments: true,
        inheritInnerComments: true,
        inheritLeadingComments: true,
        inheritsComments: true,
        inheritTrailingComments: true,
        removeComments: true,
        ensureBlock: true,
        toBindingIdentifierName: true,
        toBlock: true,
        toComputedKey: true,
        toExpression: true,
        toIdentifier: true,
        toKeyAlias: true,
        toSequenceExpression: true,
        toStatement: true,
        valueToNode: true,
        appendToMemberExpression: true,
        inherits: true,
        prependToMemberExpression: true,
        removeProperties: true,
        removePropertiesDeep: true,
        removeTypeDuplicates: true,
        getBindingIdentifiers: true,
        getOuterBindingIdentifiers: true,
        traverse: true,
        traverseFast: true,
        shallowEqual: true,
        is: true,
        isBinding: true,
        isBlockScoped: true,
        isImmutable: true,
        isLet: true,
        isNode: true,
        isNodesEquivalent: true,
        isPlaceholderType: true,
        isReferenced: true,
        isScope: true,
        isSpecifierDefault: true,
        isType: true,
        isValidES3Identifier: true,
        isValidIdentifier: true,
        isVar: true,
        matchesPattern: true,
        validate: true,
        buildMatchMemberExpression: true
      };
      Object.defineProperty(exports2, "addComment", {
        enumerable: true,
        get: function() {
          return _addComment.default;
        }
      });
      Object.defineProperty(exports2, "addComments", {
        enumerable: true,
        get: function() {
          return _addComments.default;
        }
      });
      Object.defineProperty(exports2, "appendToMemberExpression", {
        enumerable: true,
        get: function() {
          return _appendToMemberExpression.default;
        }
      });
      Object.defineProperty(exports2, "assertNode", {
        enumerable: true,
        get: function() {
          return _assertNode.default;
        }
      });
      Object.defineProperty(exports2, "buildMatchMemberExpression", {
        enumerable: true,
        get: function() {
          return _buildMatchMemberExpression.default;
        }
      });
      Object.defineProperty(exports2, "clone", {
        enumerable: true,
        get: function() {
          return _clone.default;
        }
      });
      Object.defineProperty(exports2, "cloneDeep", {
        enumerable: true,
        get: function() {
          return _cloneDeep.default;
        }
      });
      Object.defineProperty(exports2, "cloneDeepWithoutLoc", {
        enumerable: true,
        get: function() {
          return _cloneDeepWithoutLoc.default;
        }
      });
      Object.defineProperty(exports2, "cloneNode", {
        enumerable: true,
        get: function() {
          return _cloneNode.default;
        }
      });
      Object.defineProperty(exports2, "cloneWithoutLoc", {
        enumerable: true,
        get: function() {
          return _cloneWithoutLoc.default;
        }
      });
      Object.defineProperty(exports2, "createFlowUnionType", {
        enumerable: true,
        get: function() {
          return _createFlowUnionType.default;
        }
      });
      Object.defineProperty(exports2, "createTSUnionType", {
        enumerable: true,
        get: function() {
          return _createTSUnionType.default;
        }
      });
      Object.defineProperty(exports2, "createTypeAnnotationBasedOnTypeof", {
        enumerable: true,
        get: function() {
          return _createTypeAnnotationBasedOnTypeof.default;
        }
      });
      Object.defineProperty(exports2, "createUnionTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _createFlowUnionType.default;
        }
      });
      Object.defineProperty(exports2, "ensureBlock", {
        enumerable: true,
        get: function() {
          return _ensureBlock.default;
        }
      });
      Object.defineProperty(exports2, "getBindingIdentifiers", {
        enumerable: true,
        get: function() {
          return _getBindingIdentifiers.default;
        }
      });
      Object.defineProperty(exports2, "getOuterBindingIdentifiers", {
        enumerable: true,
        get: function() {
          return _getOuterBindingIdentifiers.default;
        }
      });
      Object.defineProperty(exports2, "inheritInnerComments", {
        enumerable: true,
        get: function() {
          return _inheritInnerComments.default;
        }
      });
      Object.defineProperty(exports2, "inheritLeadingComments", {
        enumerable: true,
        get: function() {
          return _inheritLeadingComments.default;
        }
      });
      Object.defineProperty(exports2, "inheritTrailingComments", {
        enumerable: true,
        get: function() {
          return _inheritTrailingComments.default;
        }
      });
      Object.defineProperty(exports2, "inherits", {
        enumerable: true,
        get: function() {
          return _inherits.default;
        }
      });
      Object.defineProperty(exports2, "inheritsComments", {
        enumerable: true,
        get: function() {
          return _inheritsComments.default;
        }
      });
      Object.defineProperty(exports2, "is", {
        enumerable: true,
        get: function() {
          return _is.default;
        }
      });
      Object.defineProperty(exports2, "isBinding", {
        enumerable: true,
        get: function() {
          return _isBinding.default;
        }
      });
      Object.defineProperty(exports2, "isBlockScoped", {
        enumerable: true,
        get: function() {
          return _isBlockScoped.default;
        }
      });
      Object.defineProperty(exports2, "isImmutable", {
        enumerable: true,
        get: function() {
          return _isImmutable.default;
        }
      });
      Object.defineProperty(exports2, "isLet", {
        enumerable: true,
        get: function() {
          return _isLet.default;
        }
      });
      Object.defineProperty(exports2, "isNode", {
        enumerable: true,
        get: function() {
          return _isNode.default;
        }
      });
      Object.defineProperty(exports2, "isNodesEquivalent", {
        enumerable: true,
        get: function() {
          return _isNodesEquivalent.default;
        }
      });
      Object.defineProperty(exports2, "isPlaceholderType", {
        enumerable: true,
        get: function() {
          return _isPlaceholderType.default;
        }
      });
      Object.defineProperty(exports2, "isReferenced", {
        enumerable: true,
        get: function() {
          return _isReferenced.default;
        }
      });
      Object.defineProperty(exports2, "isScope", {
        enumerable: true,
        get: function() {
          return _isScope.default;
        }
      });
      Object.defineProperty(exports2, "isSpecifierDefault", {
        enumerable: true,
        get: function() {
          return _isSpecifierDefault.default;
        }
      });
      Object.defineProperty(exports2, "isType", {
        enumerable: true,
        get: function() {
          return _isType.default;
        }
      });
      Object.defineProperty(exports2, "isValidES3Identifier", {
        enumerable: true,
        get: function() {
          return _isValidES3Identifier.default;
        }
      });
      Object.defineProperty(exports2, "isValidIdentifier", {
        enumerable: true,
        get: function() {
          return _isValidIdentifier.default;
        }
      });
      Object.defineProperty(exports2, "isVar", {
        enumerable: true,
        get: function() {
          return _isVar.default;
        }
      });
      Object.defineProperty(exports2, "matchesPattern", {
        enumerable: true,
        get: function() {
          return _matchesPattern.default;
        }
      });
      Object.defineProperty(exports2, "prependToMemberExpression", {
        enumerable: true,
        get: function() {
          return _prependToMemberExpression.default;
        }
      });
      exports2.react = void 0;
      Object.defineProperty(exports2, "removeComments", {
        enumerable: true,
        get: function() {
          return _removeComments.default;
        }
      });
      Object.defineProperty(exports2, "removeProperties", {
        enumerable: true,
        get: function() {
          return _removeProperties.default;
        }
      });
      Object.defineProperty(exports2, "removePropertiesDeep", {
        enumerable: true,
        get: function() {
          return _removePropertiesDeep.default;
        }
      });
      Object.defineProperty(exports2, "removeTypeDuplicates", {
        enumerable: true,
        get: function() {
          return _removeTypeDuplicates.default;
        }
      });
      Object.defineProperty(exports2, "shallowEqual", {
        enumerable: true,
        get: function() {
          return _shallowEqual.default;
        }
      });
      Object.defineProperty(exports2, "toBindingIdentifierName", {
        enumerable: true,
        get: function() {
          return _toBindingIdentifierName.default;
        }
      });
      Object.defineProperty(exports2, "toBlock", {
        enumerable: true,
        get: function() {
          return _toBlock.default;
        }
      });
      Object.defineProperty(exports2, "toComputedKey", {
        enumerable: true,
        get: function() {
          return _toComputedKey.default;
        }
      });
      Object.defineProperty(exports2, "toExpression", {
        enumerable: true,
        get: function() {
          return _toExpression.default;
        }
      });
      Object.defineProperty(exports2, "toIdentifier", {
        enumerable: true,
        get: function() {
          return _toIdentifier.default;
        }
      });
      Object.defineProperty(exports2, "toKeyAlias", {
        enumerable: true,
        get: function() {
          return _toKeyAlias.default;
        }
      });
      Object.defineProperty(exports2, "toSequenceExpression", {
        enumerable: true,
        get: function() {
          return _toSequenceExpression.default;
        }
      });
      Object.defineProperty(exports2, "toStatement", {
        enumerable: true,
        get: function() {
          return _toStatement.default;
        }
      });
      Object.defineProperty(exports2, "traverse", {
        enumerable: true,
        get: function() {
          return _traverse.default;
        }
      });
      Object.defineProperty(exports2, "traverseFast", {
        enumerable: true,
        get: function() {
          return _traverseFast.default;
        }
      });
      Object.defineProperty(exports2, "validate", {
        enumerable: true,
        get: function() {
          return _validate.default;
        }
      });
      Object.defineProperty(exports2, "valueToNode", {
        enumerable: true,
        get: function() {
          return _valueToNode.default;
        }
      });
      var _isReactComponent = require_isReactComponent();
      var _isCompatTag = require_isCompatTag();
      var _buildChildren = require_buildChildren();
      var _assertNode = require_assertNode();
      var _generated = require_generated3();
      Object.keys(_generated).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _generated[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _generated[key];
          }
        });
      });
      var _createTypeAnnotationBasedOnTypeof = require_createTypeAnnotationBasedOnTypeof();
      var _createFlowUnionType = require_createFlowUnionType();
      var _createTSUnionType = require_createTSUnionType();
      var _generated2 = require_generated2();
      Object.keys(_generated2).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _generated2[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _generated2[key];
          }
        });
      });
      var _uppercase = require_uppercase();
      Object.keys(_uppercase).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _uppercase[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _uppercase[key];
          }
        });
      });
      var _cloneNode = require_cloneNode();
      var _clone = require_clone();
      var _cloneDeep = require_cloneDeep();
      var _cloneDeepWithoutLoc = require_cloneDeepWithoutLoc();
      var _cloneWithoutLoc = require_cloneWithoutLoc();
      var _addComment = require_addComment();
      var _addComments = require_addComments();
      var _inheritInnerComments = require_inheritInnerComments();
      var _inheritLeadingComments = require_inheritLeadingComments();
      var _inheritsComments = require_inheritsComments();
      var _inheritTrailingComments = require_inheritTrailingComments();
      var _removeComments = require_removeComments();
      var _generated3 = require_generated4();
      Object.keys(_generated3).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _generated3[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _generated3[key];
          }
        });
      });
      var _constants = require_constants();
      Object.keys(_constants).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _constants[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _constants[key];
          }
        });
      });
      var _ensureBlock = require_ensureBlock();
      var _toBindingIdentifierName = require_toBindingIdentifierName();
      var _toBlock = require_toBlock();
      var _toComputedKey = require_toComputedKey();
      var _toExpression = require_toExpression();
      var _toIdentifier = require_toIdentifier();
      var _toKeyAlias = require_toKeyAlias();
      var _toSequenceExpression = require_toSequenceExpression();
      var _toStatement = require_toStatement();
      var _valueToNode = require_valueToNode();
      var _definitions = require_definitions();
      Object.keys(_definitions).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _definitions[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _definitions[key];
          }
        });
      });
      var _appendToMemberExpression = require_appendToMemberExpression();
      var _inherits = require_inherits();
      var _prependToMemberExpression = require_prependToMemberExpression();
      var _removeProperties = require_removeProperties();
      var _removePropertiesDeep = require_removePropertiesDeep();
      var _removeTypeDuplicates = require_removeTypeDuplicates();
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      var _getOuterBindingIdentifiers = require_getOuterBindingIdentifiers();
      var _traverse = require_traverse();
      Object.keys(_traverse).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _traverse[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _traverse[key];
          }
        });
      });
      var _traverseFast = require_traverseFast();
      var _shallowEqual = require_shallowEqual();
      var _is = require_is();
      var _isBinding = require_isBinding();
      var _isBlockScoped = require_isBlockScoped();
      var _isImmutable = require_isImmutable();
      var _isLet = require_isLet();
      var _isNode = require_isNode();
      var _isNodesEquivalent = require_isNodesEquivalent();
      var _isPlaceholderType = require_isPlaceholderType();
      var _isReferenced = require_isReferenced();
      var _isScope = require_isScope();
      var _isSpecifierDefault = require_isSpecifierDefault();
      var _isType = require_isType();
      var _isValidES3Identifier = require_isValidES3Identifier();
      var _isValidIdentifier = require_isValidIdentifier();
      var _isVar = require_isVar();
      var _matchesPattern = require_matchesPattern();
      var _validate = require_validate();
      var _buildMatchMemberExpression = require_buildMatchMemberExpression();
      var _generated4 = require_generated();
      Object.keys(_generated4).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _generated4[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _generated4[key];
          }
        });
      });
      var _generated5 = require_generated5();
      Object.keys(_generated5).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _generated5[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _generated5[key];
          }
        });
      });
      var react = {
        isReactComponent: _isReactComponent.default,
        isCompatTag: _isCompatTag.default,
        buildChildren: _buildChildren.default
      };
      exports2.react = react;
    }
  });

  // node_modules/@babel/generator/lib/node/whitespace.js
  var require_whitespace = __commonJS({
    "node_modules/@babel/generator/lib/node/whitespace.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.nodes = void 0;
      var _t = require_lib5();
      var {
        FLIPPED_ALIAS_KEYS,
        isArrayExpression,
        isAssignmentExpression,
        isBinary,
        isBlockStatement,
        isCallExpression,
        isFunction: isFunction2,
        isIdentifier: isIdentifier2,
        isLiteral,
        isMemberExpression,
        isObjectExpression,
        isOptionalCallExpression,
        isOptionalMemberExpression,
        isStringLiteral
      } = _t;
      function crawlInternal(node, state) {
        if (!node)
          return state;
        if (isMemberExpression(node) || isOptionalMemberExpression(node)) {
          crawlInternal(node.object, state);
          if (node.computed)
            crawlInternal(node.property, state);
        } else if (isBinary(node) || isAssignmentExpression(node)) {
          crawlInternal(node.left, state);
          crawlInternal(node.right, state);
        } else if (isCallExpression(node) || isOptionalCallExpression(node)) {
          state.hasCall = true;
          crawlInternal(node.callee, state);
        } else if (isFunction2(node)) {
          state.hasFunction = true;
        } else if (isIdentifier2(node)) {
          state.hasHelper = state.hasHelper || node.callee && isHelper(node.callee);
        }
        return state;
      }
      function crawl(node) {
        return crawlInternal(node, {
          hasCall: false,
          hasFunction: false,
          hasHelper: false
        });
      }
      function isHelper(node) {
        if (!node)
          return false;
        if (isMemberExpression(node)) {
          return isHelper(node.object) || isHelper(node.property);
        } else if (isIdentifier2(node)) {
          return node.name === "require" || node.name.charCodeAt(0) === 95;
        } else if (isCallExpression(node)) {
          return isHelper(node.callee);
        } else if (isBinary(node) || isAssignmentExpression(node)) {
          return isIdentifier2(node.left) && isHelper(node.left) || isHelper(node.right);
        } else {
          return false;
        }
      }
      function isType(node) {
        return isLiteral(node) || isObjectExpression(node) || isArrayExpression(node) || isIdentifier2(node) || isMemberExpression(node);
      }
      var nodes = {
        AssignmentExpression(node) {
          const state = crawl(node.right);
          if (state.hasCall && state.hasHelper || state.hasFunction) {
            return state.hasFunction ? 1 | 2 : 2;
          }
        },
        SwitchCase(node, parent2) {
          return (!!node.consequent.length || parent2.cases[0] === node ? 1 : 0) | (!node.consequent.length && parent2.cases[parent2.cases.length - 1] === node ? 2 : 0);
        },
        LogicalExpression(node) {
          if (isFunction2(node.left) || isFunction2(node.right)) {
            return 2;
          }
        },
        Literal(node) {
          if (isStringLiteral(node) && node.value === "use strict") {
            return 2;
          }
        },
        CallExpression(node) {
          if (isFunction2(node.callee) || isHelper(node)) {
            return 1 | 2;
          }
        },
        OptionalCallExpression(node) {
          if (isFunction2(node.callee)) {
            return 1 | 2;
          }
        },
        VariableDeclaration(node) {
          for (let i = 0; i < node.declarations.length; i++) {
            const declar = node.declarations[i];
            let enabled = isHelper(declar.id) && !isType(declar.init);
            if (!enabled && declar.init) {
              const state = crawl(declar.init);
              enabled = isHelper(declar.init) && state.hasCall || state.hasFunction;
            }
            if (enabled) {
              return 1 | 2;
            }
          }
        },
        IfStatement(node) {
          if (isBlockStatement(node.consequent)) {
            return 1 | 2;
          }
        }
      };
      exports2.nodes = nodes;
      nodes.ObjectProperty = nodes.ObjectTypeProperty = nodes.ObjectMethod = function(node, parent2) {
        if (parent2.properties[0] === node) {
          return 1;
        }
      };
      nodes.ObjectTypeCallProperty = function(node, parent2) {
        var _parent$properties;
        if (parent2.callProperties[0] === node && !((_parent$properties = parent2.properties) != null && _parent$properties.length)) {
          return 1;
        }
      };
      nodes.ObjectTypeIndexer = function(node, parent2) {
        var _parent$properties2, _parent$callPropertie;
        if (parent2.indexers[0] === node && !((_parent$properties2 = parent2.properties) != null && _parent$properties2.length) && !((_parent$callPropertie = parent2.callProperties) != null && _parent$callPropertie.length)) {
          return 1;
        }
      };
      nodes.ObjectTypeInternalSlot = function(node, parent2) {
        var _parent$properties3, _parent$callPropertie2, _parent$indexers;
        if (parent2.internalSlots[0] === node && !((_parent$properties3 = parent2.properties) != null && _parent$properties3.length) && !((_parent$callPropertie2 = parent2.callProperties) != null && _parent$callPropertie2.length) && !((_parent$indexers = parent2.indexers) != null && _parent$indexers.length)) {
          return 1;
        }
      };
      [["Function", true], ["Class", true], ["Loop", true], ["LabeledStatement", true], ["SwitchStatement", true], ["TryStatement", true]].forEach(function([type, amounts]) {
        [type].concat(FLIPPED_ALIAS_KEYS[type] || []).forEach(function(type2) {
          const ret = amounts ? 1 | 2 : 0;
          nodes[type2] = () => ret;
        });
      });
    }
  });

  // node_modules/@babel/generator/lib/node/parentheses.js
  var require_parentheses = __commonJS({
    "node_modules/@babel/generator/lib/node/parentheses.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ArrowFunctionExpression = ArrowFunctionExpression;
      exports2.AssignmentExpression = AssignmentExpression;
      exports2.Binary = Binary;
      exports2.BinaryExpression = BinaryExpression;
      exports2.ClassExpression = ClassExpression;
      exports2.ConditionalExpression = ConditionalExpression;
      exports2.DoExpression = DoExpression;
      exports2.FunctionExpression = FunctionExpression;
      exports2.FunctionTypeAnnotation = FunctionTypeAnnotation;
      exports2.Identifier = Identifier;
      exports2.LogicalExpression = LogicalExpression;
      exports2.NullableTypeAnnotation = NullableTypeAnnotation;
      exports2.ObjectExpression = ObjectExpression;
      exports2.OptionalIndexedAccessType = OptionalIndexedAccessType;
      exports2.OptionalCallExpression = exports2.OptionalMemberExpression = OptionalMemberExpression;
      exports2.SequenceExpression = SequenceExpression;
      exports2.TSTypeAssertion = exports2.TSSatisfiesExpression = exports2.TSAsExpression = TSAsExpression;
      exports2.TSInferType = TSInferType;
      exports2.TSInstantiationExpression = TSInstantiationExpression;
      exports2.TSIntersectionType = exports2.TSUnionType = TSUnionType;
      exports2.UnaryLike = UnaryLike;
      exports2.IntersectionTypeAnnotation = exports2.UnionTypeAnnotation = UnionTypeAnnotation;
      exports2.UpdateExpression = UpdateExpression;
      exports2.AwaitExpression = exports2.YieldExpression = YieldExpression;
      var _t = require_lib5();
      var {
        isArrayTypeAnnotation,
        isArrowFunctionExpression,
        isAssignmentExpression,
        isAwaitExpression,
        isBinary,
        isBinaryExpression,
        isUpdateExpression,
        isCallExpression,
        isClass,
        isClassExpression,
        isConditional,
        isConditionalExpression,
        isExportDeclaration,
        isExportDefaultDeclaration,
        isExpressionStatement,
        isFor,
        isForInStatement,
        isForOfStatement,
        isForStatement,
        isFunctionExpression,
        isIfStatement,
        isIndexedAccessType,
        isIntersectionTypeAnnotation,
        isLogicalExpression,
        isMemberExpression,
        isNewExpression,
        isNullableTypeAnnotation,
        isObjectPattern,
        isOptionalCallExpression,
        isOptionalMemberExpression,
        isReturnStatement,
        isSequenceExpression,
        isSwitchStatement,
        isTSArrayType,
        isTSAsExpression,
        isTSInstantiationExpression,
        isTSIntersectionType,
        isTSNonNullExpression,
        isTSOptionalType,
        isTSRestType,
        isTSTypeAssertion,
        isTSUnionType,
        isTaggedTemplateExpression,
        isThrowStatement,
        isTypeAnnotation,
        isUnaryLike,
        isUnionTypeAnnotation,
        isVariableDeclarator,
        isWhileStatement,
        isYieldExpression,
        isTSSatisfiesExpression
      } = _t;
      var PRECEDENCE = {
        "||": 0,
        "??": 0,
        "|>": 0,
        "&&": 1,
        "|": 2,
        "^": 3,
        "&": 4,
        "==": 5,
        "===": 5,
        "!=": 5,
        "!==": 5,
        "<": 6,
        ">": 6,
        "<=": 6,
        ">=": 6,
        in: 6,
        instanceof: 6,
        ">>": 7,
        "<<": 7,
        ">>>": 7,
        "+": 8,
        "-": 8,
        "*": 9,
        "/": 9,
        "%": 9,
        "**": 10
      };
      var isClassExtendsClause = (node, parent2) => isClass(parent2, {
        superClass: node
      });
      var hasPostfixPart = (node, parent2) => (isMemberExpression(parent2) || isOptionalMemberExpression(parent2)) && parent2.object === node || (isCallExpression(parent2) || isOptionalCallExpression(parent2) || isNewExpression(parent2)) && parent2.callee === node || isTaggedTemplateExpression(parent2) && parent2.tag === node || isTSNonNullExpression(parent2);
      function NullableTypeAnnotation(node, parent2) {
        return isArrayTypeAnnotation(parent2);
      }
      function FunctionTypeAnnotation(node, parent2, printStack) {
        if (printStack.length < 3)
          return;
        return isUnionTypeAnnotation(parent2) || isIntersectionTypeAnnotation(parent2) || isArrayTypeAnnotation(parent2) || isTypeAnnotation(parent2) && isArrowFunctionExpression(printStack[printStack.length - 3]);
      }
      function UpdateExpression(node, parent2) {
        return hasPostfixPart(node, parent2) || isClassExtendsClause(node, parent2);
      }
      function ObjectExpression(node, parent2, printStack) {
        return isFirstInContext(printStack, 1 | 2);
      }
      function DoExpression(node, parent2, printStack) {
        return !node.async && isFirstInContext(printStack, 1);
      }
      function Binary(node, parent2) {
        if (node.operator === "**" && isBinaryExpression(parent2, {
          operator: "**"
        })) {
          return parent2.left === node;
        }
        if (isClassExtendsClause(node, parent2)) {
          return true;
        }
        if (hasPostfixPart(node, parent2) || isUnaryLike(parent2) || isAwaitExpression(parent2)) {
          return true;
        }
        if (isBinary(parent2)) {
          const parentOp = parent2.operator;
          const parentPos = PRECEDENCE[parentOp];
          const nodeOp = node.operator;
          const nodePos = PRECEDENCE[nodeOp];
          if (parentPos === nodePos && parent2.right === node && !isLogicalExpression(parent2) || parentPos > nodePos) {
            return true;
          }
        }
      }
      function UnionTypeAnnotation(node, parent2) {
        return isArrayTypeAnnotation(parent2) || isNullableTypeAnnotation(parent2) || isIntersectionTypeAnnotation(parent2) || isUnionTypeAnnotation(parent2);
      }
      function OptionalIndexedAccessType(node, parent2) {
        return isIndexedAccessType(parent2, {
          objectType: node
        });
      }
      function TSAsExpression() {
        return true;
      }
      function TSUnionType(node, parent2) {
        return isTSArrayType(parent2) || isTSOptionalType(parent2) || isTSIntersectionType(parent2) || isTSUnionType(parent2) || isTSRestType(parent2);
      }
      function TSInferType(node, parent2) {
        return isTSArrayType(parent2) || isTSOptionalType(parent2);
      }
      function TSInstantiationExpression(node, parent2) {
        return (isCallExpression(parent2) || isOptionalCallExpression(parent2) || isNewExpression(parent2) || isTSInstantiationExpression(parent2)) && !!parent2.typeParameters;
      }
      function BinaryExpression(node, parent2) {
        return node.operator === "in" && (isVariableDeclarator(parent2) || isFor(parent2));
      }
      function SequenceExpression(node, parent2) {
        if (isForStatement(parent2) || isThrowStatement(parent2) || isReturnStatement(parent2) || isIfStatement(parent2) && parent2.test === node || isWhileStatement(parent2) && parent2.test === node || isForInStatement(parent2) && parent2.right === node || isSwitchStatement(parent2) && parent2.discriminant === node || isExpressionStatement(parent2) && parent2.expression === node) {
          return false;
        }
        return true;
      }
      function YieldExpression(node, parent2) {
        return isBinary(parent2) || isUnaryLike(parent2) || hasPostfixPart(node, parent2) || isAwaitExpression(parent2) && isYieldExpression(node) || isConditionalExpression(parent2) && node === parent2.test || isClassExtendsClause(node, parent2);
      }
      function ClassExpression(node, parent2, printStack) {
        return isFirstInContext(printStack, 1 | 4);
      }
      function UnaryLike(node, parent2) {
        return hasPostfixPart(node, parent2) || isBinaryExpression(parent2, {
          operator: "**",
          left: node
        }) || isClassExtendsClause(node, parent2);
      }
      function FunctionExpression(node, parent2, printStack) {
        return isFirstInContext(printStack, 1 | 4);
      }
      function ArrowFunctionExpression(node, parent2) {
        return isExportDeclaration(parent2) || ConditionalExpression(node, parent2);
      }
      function ConditionalExpression(node, parent2) {
        if (isUnaryLike(parent2) || isBinary(parent2) || isConditionalExpression(parent2, {
          test: node
        }) || isAwaitExpression(parent2) || isTSTypeAssertion(parent2) || isTSAsExpression(parent2) || isTSSatisfiesExpression(parent2)) {
          return true;
        }
        return UnaryLike(node, parent2);
      }
      function OptionalMemberExpression(node, parent2) {
        return isCallExpression(parent2, {
          callee: node
        }) || isMemberExpression(parent2, {
          object: node
        });
      }
      function AssignmentExpression(node, parent2) {
        if (isObjectPattern(node.left)) {
          return true;
        } else {
          return ConditionalExpression(node, parent2);
        }
      }
      function LogicalExpression(node, parent2) {
        switch (node.operator) {
          case "||":
            if (!isLogicalExpression(parent2))
              return false;
            return parent2.operator === "??" || parent2.operator === "&&";
          case "&&":
            return isLogicalExpression(parent2, {
              operator: "??"
            });
          case "??":
            return isLogicalExpression(parent2) && parent2.operator !== "??";
        }
      }
      function Identifier(node, parent2, printStack) {
        var _node$extra;
        if ((_node$extra = node.extra) != null && _node$extra.parenthesized && isAssignmentExpression(parent2, {
          left: node
        }) && (isFunctionExpression(parent2.right) || isClassExpression(parent2.right)) && parent2.right.id == null) {
          return true;
        }
        if (node.name === "let") {
          const isFollowedByBracket = isMemberExpression(parent2, {
            object: node,
            computed: true
          }) || isOptionalMemberExpression(parent2, {
            object: node,
            computed: true,
            optional: false
          });
          return isFirstInContext(printStack, isFollowedByBracket ? 1 | 8 | 16 | 32 : 32);
        }
        return node.name === "async" && isForOfStatement(parent2) && node === parent2.left;
      }
      function isFirstInContext(printStack, checkParam) {
        const expressionStatement2 = checkParam & 1;
        const arrowBody = checkParam & 2;
        const exportDefault = checkParam & 4;
        const forHead = checkParam & 8;
        const forInHead = checkParam & 16;
        const forOfHead = checkParam & 32;
        let i = printStack.length - 1;
        if (i <= 0)
          return;
        let node = printStack[i];
        i--;
        let parent2 = printStack[i];
        while (i >= 0) {
          if (expressionStatement2 && isExpressionStatement(parent2, {
            expression: node
          }) || exportDefault && isExportDefaultDeclaration(parent2, {
            declaration: node
          }) || arrowBody && isArrowFunctionExpression(parent2, {
            body: node
          }) || forHead && isForStatement(parent2, {
            init: node
          }) || forInHead && isForInStatement(parent2, {
            left: node
          }) || forOfHead && isForOfStatement(parent2, {
            left: node
          })) {
            return true;
          }
          if (i > 0 && (hasPostfixPart(node, parent2) && !isNewExpression(parent2) || isSequenceExpression(parent2) && parent2.expressions[0] === node || isUpdateExpression(parent2) && !parent2.prefix || isConditional(parent2, {
            test: node
          }) || isBinary(parent2, {
            left: node
          }) || isAssignmentExpression(parent2, {
            left: node
          }))) {
            node = parent2;
            i--;
            parent2 = printStack[i];
          } else {
            return false;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/generator/lib/node/index.js
  var require_node = __commonJS({
    "node_modules/@babel/generator/lib/node/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.needsParens = needsParens;
      exports2.needsWhitespace = needsWhitespace;
      exports2.needsWhitespaceAfter = needsWhitespaceAfter;
      exports2.needsWhitespaceBefore = needsWhitespaceBefore;
      var whitespace = require_whitespace();
      var parens = require_parentheses();
      var _t = require_lib5();
      var {
        FLIPPED_ALIAS_KEYS,
        isCallExpression,
        isExpressionStatement,
        isMemberExpression,
        isNewExpression
      } = _t;
      function expandAliases(obj) {
        const newObj = {};
        function add2(type, func) {
          const fn = newObj[type];
          newObj[type] = fn ? function(node, parent2, stack) {
            const result2 = fn(node, parent2, stack);
            return result2 == null ? func(node, parent2, stack) : result2;
          } : func;
        }
        for (const type of Object.keys(obj)) {
          const aliases = FLIPPED_ALIAS_KEYS[type];
          if (aliases) {
            for (const alias of aliases) {
              add2(alias, obj[type]);
            }
          } else {
            add2(type, obj[type]);
          }
        }
        return newObj;
      }
      var expandedParens = expandAliases(parens);
      var expandedWhitespaceNodes = expandAliases(whitespace.nodes);
      function find2(obj, node, parent2, printStack) {
        const fn = obj[node.type];
        return fn ? fn(node, parent2, printStack) : null;
      }
      function isOrHasCallExpression(node) {
        if (isCallExpression(node)) {
          return true;
        }
        return isMemberExpression(node) && isOrHasCallExpression(node.object);
      }
      function needsWhitespace(node, parent2, type) {
        if (!node)
          return false;
        if (isExpressionStatement(node)) {
          node = node.expression;
        }
        const flag = find2(expandedWhitespaceNodes, node, parent2);
        if (typeof flag === "number") {
          return (flag & type) !== 0;
        }
        return false;
      }
      function needsWhitespaceBefore(node, parent2) {
        return needsWhitespace(node, parent2, 1);
      }
      function needsWhitespaceAfter(node, parent2) {
        return needsWhitespace(node, parent2, 2);
      }
      function needsParens(node, parent2, printStack) {
        if (!parent2)
          return false;
        if (isNewExpression(parent2) && parent2.callee === node) {
          if (isOrHasCallExpression(node))
            return true;
        }
        return find2(expandedParens, node, parent2, printStack);
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/template-literals.js
  var require_template_literals = __commonJS({
    "node_modules/@babel/generator/lib/generators/template-literals.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.TaggedTemplateExpression = TaggedTemplateExpression;
      exports2.TemplateElement = TemplateElement;
      exports2.TemplateLiteral = TemplateLiteral;
      function TaggedTemplateExpression(node) {
        this.print(node.tag, node);
        this.print(node.typeParameters, node);
        this.print(node.quasi, node);
      }
      function TemplateElement(node, parent2) {
        const isFirst = parent2.quasis[0] === node;
        const isLast = parent2.quasis[parent2.quasis.length - 1] === node;
        const value = (isFirst ? "`" : "}") + node.value.raw + (isLast ? "`" : "${");
        this.token(value, true);
      }
      function TemplateLiteral(node) {
        const quasis = node.quasis;
        for (let i = 0; i < quasis.length; i++) {
          this.print(quasis[i], node);
          if (i + 1 < quasis.length) {
            this.print(node.expressions[i], node);
          }
        }
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/expressions.js
  var require_expressions = __commonJS({
    "node_modules/@babel/generator/lib/generators/expressions.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.LogicalExpression = exports2.BinaryExpression = exports2.AssignmentExpression = AssignmentExpression;
      exports2.AssignmentPattern = AssignmentPattern;
      exports2.AwaitExpression = AwaitExpression;
      exports2.BindExpression = BindExpression;
      exports2.CallExpression = CallExpression;
      exports2.ConditionalExpression = ConditionalExpression;
      exports2.Decorator = Decorator;
      exports2.DoExpression = DoExpression;
      exports2.EmptyStatement = EmptyStatement;
      exports2.ExpressionStatement = ExpressionStatement;
      exports2.Import = Import;
      exports2.MemberExpression = MemberExpression;
      exports2.MetaProperty = MetaProperty;
      exports2.ModuleExpression = ModuleExpression;
      exports2.NewExpression = NewExpression;
      exports2.OptionalCallExpression = OptionalCallExpression;
      exports2.OptionalMemberExpression = OptionalMemberExpression;
      exports2.ParenthesizedExpression = ParenthesizedExpression;
      exports2.PrivateName = PrivateName;
      exports2.SequenceExpression = SequenceExpression;
      exports2.Super = Super;
      exports2.ThisExpression = ThisExpression;
      exports2.UnaryExpression = UnaryExpression;
      exports2.UpdateExpression = UpdateExpression;
      exports2.V8IntrinsicIdentifier = V8IntrinsicIdentifier;
      exports2.YieldExpression = YieldExpression;
      var _t = require_lib5();
      var n = require_node();
      var {
        isCallExpression,
        isLiteral,
        isMemberExpression,
        isNewExpression
      } = _t;
      function UnaryExpression(node) {
        if (node.operator === "void" || node.operator === "delete" || node.operator === "typeof" || node.operator === "throw") {
          this.word(node.operator);
          this.space();
        } else {
          this.token(node.operator);
        }
        this.print(node.argument, node);
      }
      function DoExpression(node) {
        if (node.async) {
          this.word("async", true);
          this.space();
        }
        this.word("do");
        this.space();
        this.print(node.body, node);
      }
      function ParenthesizedExpression(node) {
        this.tokenChar(40);
        this.print(node.expression, node);
        this.tokenChar(41);
      }
      function UpdateExpression(node) {
        if (node.prefix) {
          this.token(node.operator);
          this.print(node.argument, node);
        } else {
          this.printTerminatorless(node.argument, node, true);
          this.token(node.operator);
        }
      }
      function ConditionalExpression(node) {
        this.print(node.test, node);
        this.space();
        this.tokenChar(63);
        this.space();
        this.print(node.consequent, node);
        this.space();
        this.tokenChar(58);
        this.space();
        this.print(node.alternate, node);
      }
      function NewExpression(node, parent2) {
        this.word("new");
        this.space();
        this.print(node.callee, node);
        if (this.format.minified && node.arguments.length === 0 && !node.optional && !isCallExpression(parent2, {
          callee: node
        }) && !isMemberExpression(parent2) && !isNewExpression(parent2)) {
          return;
        }
        this.print(node.typeArguments, node);
        this.print(node.typeParameters, node);
        if (node.optional) {
          this.token("?.");
        }
        this.tokenChar(40);
        this.printList(node.arguments, node);
        this.tokenChar(41);
      }
      function SequenceExpression(node) {
        this.printList(node.expressions, node);
      }
      function ThisExpression() {
        this.word("this");
      }
      function Super() {
        this.word("super");
      }
      function isDecoratorMemberExpression(node) {
        switch (node.type) {
          case "Identifier":
            return true;
          case "MemberExpression":
            return !node.computed && node.property.type === "Identifier" && isDecoratorMemberExpression(node.object);
          default:
            return false;
        }
      }
      function shouldParenthesizeDecoratorExpression(node) {
        if (node.type === "ParenthesizedExpression") {
          return false;
        }
        return !isDecoratorMemberExpression(node.type === "CallExpression" ? node.callee : node);
      }
      function Decorator(node) {
        this.tokenChar(64);
        const {
          expression
        } = node;
        if (shouldParenthesizeDecoratorExpression(expression)) {
          this.tokenChar(40);
          this.print(expression, node);
          this.tokenChar(41);
        } else {
          this.print(expression, node);
        }
        this.newline();
      }
      function OptionalMemberExpression(node) {
        this.print(node.object, node);
        if (!node.computed && isMemberExpression(node.property)) {
          throw new TypeError("Got a MemberExpression for MemberExpression property");
        }
        let computed = node.computed;
        if (isLiteral(node.property) && typeof node.property.value === "number") {
          computed = true;
        }
        if (node.optional) {
          this.token("?.");
        }
        if (computed) {
          this.tokenChar(91);
          this.print(node.property, node);
          this.tokenChar(93);
        } else {
          if (!node.optional) {
            this.tokenChar(46);
          }
          this.print(node.property, node);
        }
      }
      function OptionalCallExpression(node) {
        this.print(node.callee, node);
        this.print(node.typeParameters, node);
        if (node.optional) {
          this.token("?.");
        }
        this.print(node.typeArguments, node);
        this.tokenChar(40);
        this.printList(node.arguments, node);
        this.tokenChar(41);
      }
      function CallExpression(node) {
        this.print(node.callee, node);
        this.print(node.typeArguments, node);
        this.print(node.typeParameters, node);
        this.tokenChar(40);
        this.printList(node.arguments, node);
        this.tokenChar(41);
      }
      function Import() {
        this.word("import");
      }
      function AwaitExpression(node) {
        this.word("await");
        if (node.argument) {
          this.space();
          this.printTerminatorless(node.argument, node, false);
        }
      }
      function YieldExpression(node) {
        this.word("yield", true);
        if (node.delegate) {
          this.tokenChar(42);
          if (node.argument) {
            this.space();
            this.print(node.argument, node);
          }
        } else {
          if (node.argument) {
            this.space();
            this.printTerminatorless(node.argument, node, false);
          }
        }
      }
      function EmptyStatement() {
        this.semicolon(true);
      }
      function ExpressionStatement(node) {
        this.print(node.expression, node);
        this.semicolon();
      }
      function AssignmentPattern(node) {
        this.print(node.left, node);
        if (node.left.optional)
          this.tokenChar(63);
        this.print(node.left.typeAnnotation, node);
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.right, node);
      }
      function AssignmentExpression(node, parent2) {
        const parens = this.inForStatementInitCounter && node.operator === "in" && !n.needsParens(node, parent2);
        if (parens) {
          this.tokenChar(40);
        }
        this.print(node.left, node);
        this.space();
        if (node.operator === "in" || node.operator === "instanceof") {
          this.word(node.operator);
        } else {
          this.token(node.operator);
        }
        this.space();
        this.print(node.right, node);
        if (parens) {
          this.tokenChar(41);
        }
      }
      function BindExpression(node) {
        this.print(node.object, node);
        this.token("::");
        this.print(node.callee, node);
      }
      function MemberExpression(node) {
        this.print(node.object, node);
        if (!node.computed && isMemberExpression(node.property)) {
          throw new TypeError("Got a MemberExpression for MemberExpression property");
        }
        let computed = node.computed;
        if (isLiteral(node.property) && typeof node.property.value === "number") {
          computed = true;
        }
        if (computed) {
          this.tokenChar(91);
          this.print(node.property, node);
          this.tokenChar(93);
        } else {
          this.tokenChar(46);
          this.print(node.property, node);
        }
      }
      function MetaProperty(node) {
        this.print(node.meta, node);
        this.tokenChar(46);
        this.print(node.property, node);
      }
      function PrivateName(node) {
        this.tokenChar(35);
        this.print(node.id, node);
      }
      function V8IntrinsicIdentifier(node) {
        this.tokenChar(37);
        this.word(node.name);
      }
      function ModuleExpression(node) {
        this.word("module", true);
        this.space();
        this.tokenChar(123);
        this.indent();
        const {
          body
        } = node;
        if (body.body.length || body.directives.length) {
          this.newline();
        }
        this.print(body, node);
        this.dedent();
        this.sourceWithOffset("end", node.loc, 0, -1);
        this.rightBrace();
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/statements.js
  var require_statements = __commonJS({
    "node_modules/@babel/generator/lib/generators/statements.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.BreakStatement = BreakStatement;
      exports2.CatchClause = CatchClause;
      exports2.ContinueStatement = ContinueStatement;
      exports2.DebuggerStatement = DebuggerStatement;
      exports2.DoWhileStatement = DoWhileStatement;
      exports2.ForOfStatement = exports2.ForInStatement = void 0;
      exports2.ForStatement = ForStatement;
      exports2.IfStatement = IfStatement;
      exports2.LabeledStatement = LabeledStatement;
      exports2.ReturnStatement = ReturnStatement;
      exports2.SwitchCase = SwitchCase;
      exports2.SwitchStatement = SwitchStatement;
      exports2.ThrowStatement = ThrowStatement;
      exports2.TryStatement = TryStatement;
      exports2.VariableDeclaration = VariableDeclaration;
      exports2.VariableDeclarator = VariableDeclarator;
      exports2.WhileStatement = WhileStatement;
      exports2.WithStatement = WithStatement;
      var _t = require_lib5();
      var {
        isFor,
        isForStatement,
        isIfStatement,
        isStatement
      } = _t;
      function WithStatement(node) {
        this.word("with");
        this.space();
        this.tokenChar(40);
        this.print(node.object, node);
        this.tokenChar(41);
        this.printBlock(node);
      }
      function IfStatement(node) {
        this.word("if");
        this.space();
        this.tokenChar(40);
        this.print(node.test, node);
        this.tokenChar(41);
        this.space();
        const needsBlock = node.alternate && isIfStatement(getLastStatement(node.consequent));
        if (needsBlock) {
          this.tokenChar(123);
          this.newline();
          this.indent();
        }
        this.printAndIndentOnComments(node.consequent, node);
        if (needsBlock) {
          this.dedent();
          this.newline();
          this.tokenChar(125);
        }
        if (node.alternate) {
          if (this.endsWith(125))
            this.space();
          this.word("else");
          this.space();
          this.printAndIndentOnComments(node.alternate, node);
        }
      }
      function getLastStatement(statement) {
        const {
          body
        } = statement;
        if (isStatement(body) === false) {
          return statement;
        }
        return getLastStatement(body);
      }
      function ForStatement(node) {
        this.word("for");
        this.space();
        this.tokenChar(40);
        this.inForStatementInitCounter++;
        this.print(node.init, node);
        this.inForStatementInitCounter--;
        this.tokenChar(59);
        if (node.test) {
          this.space();
          this.print(node.test, node);
        }
        this.tokenChar(59);
        if (node.update) {
          this.space();
          this.print(node.update, node);
        }
        this.tokenChar(41);
        this.printBlock(node);
      }
      function WhileStatement(node) {
        this.word("while");
        this.space();
        this.tokenChar(40);
        this.print(node.test, node);
        this.tokenChar(41);
        this.printBlock(node);
      }
      function ForXStatement(node) {
        this.word("for");
        this.space();
        const isForOf = node.type === "ForOfStatement";
        if (isForOf && node.await) {
          this.word("await");
          this.space();
        }
        this.noIndentInnerCommentsHere();
        this.tokenChar(40);
        this.print(node.left, node);
        this.space();
        this.word(isForOf ? "of" : "in");
        this.space();
        this.print(node.right, node);
        this.tokenChar(41);
        this.printBlock(node);
      }
      var ForInStatement = ForXStatement;
      exports2.ForInStatement = ForInStatement;
      var ForOfStatement = ForXStatement;
      exports2.ForOfStatement = ForOfStatement;
      function DoWhileStatement(node) {
        this.word("do");
        this.space();
        this.print(node.body, node);
        this.space();
        this.word("while");
        this.space();
        this.tokenChar(40);
        this.print(node.test, node);
        this.tokenChar(41);
        this.semicolon();
      }
      function printStatementAfterKeyword(printer, node, parent2, isLabel) {
        if (node) {
          printer.space();
          printer.printTerminatorless(node, parent2, isLabel);
        }
        printer.semicolon();
      }
      function BreakStatement(node) {
        this.word("break");
        printStatementAfterKeyword(this, node.label, node, true);
      }
      function ContinueStatement(node) {
        this.word("continue");
        printStatementAfterKeyword(this, node.label, node, true);
      }
      function ReturnStatement(node) {
        this.word("return");
        printStatementAfterKeyword(this, node.argument, node, false);
      }
      function ThrowStatement(node) {
        this.word("throw");
        printStatementAfterKeyword(this, node.argument, node, false);
      }
      function LabeledStatement(node) {
        this.print(node.label, node);
        this.tokenChar(58);
        this.space();
        this.print(node.body, node);
      }
      function TryStatement(node) {
        this.word("try");
        this.space();
        this.print(node.block, node);
        this.space();
        if (node.handlers) {
          this.print(node.handlers[0], node);
        } else {
          this.print(node.handler, node);
        }
        if (node.finalizer) {
          this.space();
          this.word("finally");
          this.space();
          this.print(node.finalizer, node);
        }
      }
      function CatchClause(node) {
        this.word("catch");
        this.space();
        if (node.param) {
          this.tokenChar(40);
          this.print(node.param, node);
          this.print(node.param.typeAnnotation, node);
          this.tokenChar(41);
          this.space();
        }
        this.print(node.body, node);
      }
      function SwitchStatement(node) {
        this.word("switch");
        this.space();
        this.tokenChar(40);
        this.print(node.discriminant, node);
        this.tokenChar(41);
        this.space();
        this.tokenChar(123);
        this.printSequence(node.cases, node, {
          indent: true,
          addNewlines(leading, cas) {
            if (!leading && node.cases[node.cases.length - 1] === cas)
              return -1;
          }
        });
        this.tokenChar(125);
      }
      function SwitchCase(node) {
        if (node.test) {
          this.word("case");
          this.space();
          this.print(node.test, node);
          this.tokenChar(58);
        } else {
          this.word("default");
          this.tokenChar(58);
        }
        if (node.consequent.length) {
          this.newline();
          this.printSequence(node.consequent, node, {
            indent: true
          });
        }
      }
      function DebuggerStatement() {
        this.word("debugger");
        this.semicolon();
      }
      function VariableDeclaration(node, parent2) {
        if (node.declare) {
          this.word("declare");
          this.space();
        }
        const {
          kind
        } = node;
        this.word(kind, kind === "using");
        this.space();
        let hasInits = false;
        if (!isFor(parent2)) {
          for (const declar of node.declarations) {
            if (declar.init) {
              hasInits = true;
            }
          }
        }
        this.printList(node.declarations, node, {
          separator: hasInits ? function() {
            this.tokenChar(44);
            this.newline();
          } : void 0,
          indent: node.declarations.length > 1 ? true : false
        });
        if (isFor(parent2)) {
          if (isForStatement(parent2)) {
            if (parent2.init === node)
              return;
          } else {
            if (parent2.left === node)
              return;
          }
        }
        this.semicolon();
      }
      function VariableDeclarator(node) {
        this.print(node.id, node);
        if (node.definite)
          this.tokenChar(33);
        this.print(node.id.typeAnnotation, node);
        if (node.init) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.init, node);
        }
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/classes.js
  var require_classes = __commonJS({
    "node_modules/@babel/generator/lib/generators/classes.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ClassAccessorProperty = ClassAccessorProperty;
      exports2.ClassBody = ClassBody;
      exports2.ClassExpression = exports2.ClassDeclaration = ClassDeclaration;
      exports2.ClassMethod = ClassMethod;
      exports2.ClassPrivateMethod = ClassPrivateMethod;
      exports2.ClassPrivateProperty = ClassPrivateProperty;
      exports2.ClassProperty = ClassProperty;
      exports2.StaticBlock = StaticBlock;
      exports2._classMethodHead = _classMethodHead;
      var _t = require_lib5();
      var {
        isExportDefaultDeclaration,
        isExportNamedDeclaration
      } = _t;
      function ClassDeclaration(node, parent2) {
        {
          if (!this.format.decoratorsBeforeExport || !isExportDefaultDeclaration(parent2) && !isExportNamedDeclaration(parent2)) {
            this.printJoin(node.decorators, node);
          }
        }
        if (node.declare) {
          this.word("declare");
          this.space();
        }
        if (node.abstract) {
          this.word("abstract");
          this.space();
        }
        this.word("class");
        if (node.id) {
          this.space();
          this.print(node.id, node);
        }
        this.print(node.typeParameters, node);
        if (node.superClass) {
          this.space();
          this.word("extends");
          this.space();
          this.print(node.superClass, node);
          this.print(node.superTypeParameters, node);
        }
        if (node.implements) {
          this.space();
          this.word("implements");
          this.space();
          this.printList(node.implements, node);
        }
        this.space();
        this.print(node.body, node);
      }
      function ClassBody(node) {
        this.tokenChar(123);
        if (node.body.length === 0) {
          this.tokenChar(125);
        } else {
          this.newline();
          this.indent();
          this.printSequence(node.body, node);
          this.dedent();
          if (!this.endsWith(10))
            this.newline();
          this.sourceWithOffset("end", node.loc, 0, -1);
          this.rightBrace();
        }
      }
      function ClassProperty(node) {
        var _node$key$loc, _node$key$loc$end;
        this.printJoin(node.decorators, node);
        const endLine = (_node$key$loc = node.key.loc) == null ? void 0 : (_node$key$loc$end = _node$key$loc.end) == null ? void 0 : _node$key$loc$end.line;
        if (endLine)
          this.catchUp(endLine);
        this.tsPrintClassMemberModifiers(node);
        if (node.computed) {
          this.tokenChar(91);
          this.print(node.key, node);
          this.tokenChar(93);
        } else {
          this._variance(node);
          this.print(node.key, node);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
        if (node.definite) {
          this.tokenChar(33);
        }
        this.print(node.typeAnnotation, node);
        if (node.value) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.value, node);
        }
        this.semicolon();
      }
      function ClassAccessorProperty(node) {
        var _node$key$loc2, _node$key$loc2$end;
        this.printJoin(node.decorators, node);
        const endLine = (_node$key$loc2 = node.key.loc) == null ? void 0 : (_node$key$loc2$end = _node$key$loc2.end) == null ? void 0 : _node$key$loc2$end.line;
        if (endLine)
          this.catchUp(endLine);
        this.tsPrintClassMemberModifiers(node);
        this.word("accessor", true);
        this.space();
        if (node.computed) {
          this.tokenChar(91);
          this.print(node.key, node);
          this.tokenChar(93);
        } else {
          this._variance(node);
          this.print(node.key, node);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
        if (node.definite) {
          this.tokenChar(33);
        }
        this.print(node.typeAnnotation, node);
        if (node.value) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.value, node);
        }
        this.semicolon();
      }
      function ClassPrivateProperty(node) {
        this.printJoin(node.decorators, node);
        if (node.static) {
          this.word("static");
          this.space();
        }
        this.print(node.key, node);
        this.print(node.typeAnnotation, node);
        if (node.value) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.value, node);
        }
        this.semicolon();
      }
      function ClassMethod(node) {
        this._classMethodHead(node);
        this.space();
        this.print(node.body, node);
      }
      function ClassPrivateMethod(node) {
        this._classMethodHead(node);
        this.space();
        this.print(node.body, node);
      }
      function _classMethodHead(node) {
        var _node$key$loc3, _node$key$loc3$end;
        this.printJoin(node.decorators, node);
        const endLine = (_node$key$loc3 = node.key.loc) == null ? void 0 : (_node$key$loc3$end = _node$key$loc3.end) == null ? void 0 : _node$key$loc3$end.line;
        if (endLine)
          this.catchUp(endLine);
        this.tsPrintClassMemberModifiers(node);
        this._methodHead(node);
      }
      function StaticBlock(node) {
        this.word("static");
        this.space();
        this.tokenChar(123);
        if (node.body.length === 0) {
          this.tokenChar(125);
        } else {
          this.newline();
          this.printSequence(node.body, node, {
            indent: true
          });
          this.sourceWithOffset("end", node.loc, 0, -1);
          this.rightBrace();
        }
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/methods.js
  var require_methods = __commonJS({
    "node_modules/@babel/generator/lib/generators/methods.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ArrowFunctionExpression = ArrowFunctionExpression;
      exports2.FunctionDeclaration = exports2.FunctionExpression = FunctionExpression;
      exports2._functionHead = _functionHead;
      exports2._methodHead = _methodHead;
      exports2._param = _param;
      exports2._parameters = _parameters;
      exports2._params = _params;
      exports2._predicate = _predicate;
      var _t = require_lib5();
      var {
        isIdentifier: isIdentifier2
      } = _t;
      function _params(node) {
        this.print(node.typeParameters, node);
        this.tokenChar(40);
        this._parameters(node.params, node);
        this.tokenChar(41);
        const noLineTerminator = node.type === "ArrowFunctionExpression";
        this.print(node.returnType, node, noLineTerminator);
        this._noLineTerminator = noLineTerminator;
      }
      function _parameters(parameters, parent2) {
        const paramLength = parameters.length;
        for (let i = 0; i < paramLength; i++) {
          this._param(parameters[i], parent2);
          if (i < parameters.length - 1) {
            this.tokenChar(44);
            this.space();
          }
        }
      }
      function _param(parameter, parent2) {
        this.printJoin(parameter.decorators, parameter);
        this.print(parameter, parent2);
        if (parameter.optional) {
          this.tokenChar(63);
        }
        this.print(
          parameter.typeAnnotation,
          parameter
        );
      }
      function _methodHead(node) {
        const kind = node.kind;
        const key = node.key;
        if (kind === "get" || kind === "set") {
          this.word(kind);
          this.space();
        }
        if (node.async) {
          this.word("async", true);
          this.space();
        }
        if (kind === "method" || kind === "init") {
          if (node.generator) {
            this.tokenChar(42);
          }
        }
        if (node.computed) {
          this.tokenChar(91);
          this.print(key, node);
          this.tokenChar(93);
        } else {
          this.print(key, node);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
        this._params(node);
      }
      function _predicate(node, noLineTerminatorAfter) {
        if (node.predicate) {
          if (!node.returnType) {
            this.tokenChar(58);
          }
          this.space();
          this.print(node.predicate, node, noLineTerminatorAfter);
        }
      }
      function _functionHead(node) {
        if (node.async) {
          this.word("async");
          this._endsWithInnerRaw = false;
          this.space();
        }
        this.word("function");
        if (node.generator) {
          this._endsWithInnerRaw = false;
          this.tokenChar(42);
        }
        this.space();
        if (node.id) {
          this.print(node.id, node);
        }
        this._params(node);
        if (node.type !== "TSDeclareFunction") {
          this._predicate(node);
        }
      }
      function FunctionExpression(node) {
        this._functionHead(node);
        this.space();
        this.print(node.body, node);
      }
      function ArrowFunctionExpression(node) {
        if (node.async) {
          this.word("async", true);
          this.space();
        }
        let firstParam;
        if (!this.format.retainLines && node.params.length === 1 && isIdentifier2(firstParam = node.params[0]) && !hasTypesOrComments(node, firstParam)) {
          this.print(firstParam, node, true);
        } else {
          this._params(node);
        }
        this._predicate(node, true);
        this.space();
        this.printInnerComments();
        this.token("=>");
        this.space();
        this.print(node.body, node);
      }
      function hasTypesOrComments(node, param) {
        var _param$leadingComment, _param$trailingCommen;
        return !!(node.typeParameters || node.returnType || node.predicate || param.typeAnnotation || param.optional || (_param$leadingComment = param.leadingComments) != null && _param$leadingComment.length || (_param$trailingCommen = param.trailingComments) != null && _param$trailingCommen.length);
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/modules.js
  var require_modules = __commonJS({
    "node_modules/@babel/generator/lib/generators/modules.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ExportAllDeclaration = ExportAllDeclaration;
      exports2.ExportDefaultDeclaration = ExportDefaultDeclaration;
      exports2.ExportDefaultSpecifier = ExportDefaultSpecifier;
      exports2.ExportNamedDeclaration = ExportNamedDeclaration;
      exports2.ExportNamespaceSpecifier = ExportNamespaceSpecifier;
      exports2.ExportSpecifier = ExportSpecifier;
      exports2.ImportAttribute = ImportAttribute;
      exports2.ImportDeclaration = ImportDeclaration;
      exports2.ImportDefaultSpecifier = ImportDefaultSpecifier;
      exports2.ImportNamespaceSpecifier = ImportNamespaceSpecifier;
      exports2.ImportSpecifier = ImportSpecifier;
      exports2._printAssertions = _printAssertions;
      var _t = require_lib5();
      var {
        isClassDeclaration,
        isExportDefaultSpecifier,
        isExportNamespaceSpecifier,
        isImportDefaultSpecifier,
        isImportNamespaceSpecifier,
        isStatement
      } = _t;
      function ImportSpecifier(node) {
        if (node.importKind === "type" || node.importKind === "typeof") {
          this.word(node.importKind);
          this.space();
        }
        this.print(node.imported, node);
        if (node.local && node.local.name !== node.imported.name) {
          this.space();
          this.word("as");
          this.space();
          this.print(node.local, node);
        }
      }
      function ImportDefaultSpecifier(node) {
        this.print(node.local, node);
      }
      function ExportDefaultSpecifier(node) {
        this.print(node.exported, node);
      }
      function ExportSpecifier(node) {
        if (node.exportKind === "type") {
          this.word("type");
          this.space();
        }
        this.print(node.local, node);
        if (node.exported && node.local.name !== node.exported.name) {
          this.space();
          this.word("as");
          this.space();
          this.print(node.exported, node);
        }
      }
      function ExportNamespaceSpecifier(node) {
        this.tokenChar(42);
        this.space();
        this.word("as");
        this.space();
        this.print(node.exported, node);
      }
      function _printAssertions(node) {
        this.word("assert");
        this.space();
        this.tokenChar(123);
        this.space();
        this.printList(node.assertions, node);
        this.space();
        this.tokenChar(125);
      }
      function ExportAllDeclaration(node) {
        var _node$assertions;
        this.word("export");
        this.space();
        if (node.exportKind === "type") {
          this.word("type");
          this.space();
        }
        this.tokenChar(42);
        this.space();
        this.word("from");
        this.space();
        if ((_node$assertions = node.assertions) != null && _node$assertions.length) {
          this.print(node.source, node, true);
          this.space();
          this._printAssertions(node);
        } else {
          this.print(node.source, node);
        }
        this.semicolon();
      }
      function ExportNamedDeclaration(node) {
        {
          if (this.format.decoratorsBeforeExport && isClassDeclaration(node.declaration)) {
            this.printJoin(node.declaration.decorators, node);
          }
        }
        this.word("export");
        this.space();
        if (node.declaration) {
          const declar = node.declaration;
          this.print(declar, node);
          if (!isStatement(declar))
            this.semicolon();
        } else {
          if (node.exportKind === "type") {
            this.word("type");
            this.space();
          }
          const specifiers = node.specifiers.slice(0);
          let hasSpecial = false;
          for (; ; ) {
            const first = specifiers[0];
            if (isExportDefaultSpecifier(first) || isExportNamespaceSpecifier(first)) {
              hasSpecial = true;
              this.print(specifiers.shift(), node);
              if (specifiers.length) {
                this.tokenChar(44);
                this.space();
              }
            } else {
              break;
            }
          }
          if (specifiers.length || !specifiers.length && !hasSpecial) {
            this.tokenChar(123);
            if (specifiers.length) {
              this.space();
              this.printList(specifiers, node);
              this.space();
            }
            this.tokenChar(125);
          }
          if (node.source) {
            var _node$assertions2;
            this.space();
            this.word("from");
            this.space();
            if ((_node$assertions2 = node.assertions) != null && _node$assertions2.length) {
              this.print(node.source, node, true);
              this.space();
              this._printAssertions(node);
            } else {
              this.print(node.source, node);
            }
          }
          this.semicolon();
        }
      }
      function ExportDefaultDeclaration(node) {
        {
          if (this.format.decoratorsBeforeExport && isClassDeclaration(node.declaration)) {
            this.printJoin(node.declaration.decorators, node);
          }
        }
        this.word("export");
        this.noIndentInnerCommentsHere();
        this.space();
        this.word("default");
        this.space();
        const declar = node.declaration;
        this.print(declar, node);
        if (!isStatement(declar))
          this.semicolon();
      }
      function ImportDeclaration(node) {
        var _node$assertions3;
        this.word("import");
        this.space();
        const isTypeKind = node.importKind === "type" || node.importKind === "typeof";
        if (isTypeKind) {
          this.noIndentInnerCommentsHere();
          this.word(node.importKind);
          this.space();
        } else if (node.module) {
          this.noIndentInnerCommentsHere();
          this.word("module");
          this.space();
        }
        const specifiers = node.specifiers.slice(0);
        const hasSpecifiers = !!specifiers.length;
        while (hasSpecifiers) {
          const first = specifiers[0];
          if (isImportDefaultSpecifier(first) || isImportNamespaceSpecifier(first)) {
            this.print(specifiers.shift(), node);
            if (specifiers.length) {
              this.tokenChar(44);
              this.space();
            }
          } else {
            break;
          }
        }
        if (specifiers.length) {
          this.tokenChar(123);
          this.space();
          this.printList(specifiers, node);
          this.space();
          this.tokenChar(125);
        } else if (isTypeKind && !hasSpecifiers) {
          this.tokenChar(123);
          this.tokenChar(125);
        }
        if (hasSpecifiers || isTypeKind) {
          this.space();
          this.word("from");
          this.space();
        }
        if ((_node$assertions3 = node.assertions) != null && _node$assertions3.length) {
          this.print(node.source, node, true);
          this.space();
          this._printAssertions(node);
        } else {
          this.print(node.source, node);
        }
        {
          var _node$attributes;
          if ((_node$attributes = node.attributes) != null && _node$attributes.length) {
            this.space();
            this.word("with");
            this.space();
            this.printList(node.attributes, node);
          }
        }
        this.semicolon();
      }
      function ImportAttribute(node) {
        this.print(node.key);
        this.tokenChar(58);
        this.space();
        this.print(node.value);
      }
      function ImportNamespaceSpecifier(node) {
        this.tokenChar(42);
        this.space();
        this.word("as");
        this.space();
        this.print(node.local, node);
      }
    }
  });

  // node_modules/jsesc/jsesc.js
  var require_jsesc = __commonJS({
    "node_modules/jsesc/jsesc.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var object = {};
      var hasOwnProperty26 = object.hasOwnProperty;
      var forOwn2 = (object2, callback) => {
        for (const key in object2) {
          if (hasOwnProperty26.call(object2, key)) {
            callback(key, object2[key]);
          }
        }
      };
      var extend = (destination, source) => {
        if (!source) {
          return destination;
        }
        forOwn2(source, (key, value) => {
          destination[key] = value;
        });
        return destination;
      };
      var forEach2 = (array, callback) => {
        const length = array.length;
        let index = -1;
        while (++index < length) {
          callback(array[index]);
        }
      };
      var toString2 = object.toString;
      var isArray2 = Array.isArray;
      var isBuffer2 = Buffer.isBuffer;
      var isObject2 = (value) => {
        return toString2.call(value) == "[object Object]";
      };
      var isString2 = (value) => {
        return typeof value == "string" || toString2.call(value) == "[object String]";
      };
      var isNumber2 = (value) => {
        return typeof value == "number" || toString2.call(value) == "[object Number]";
      };
      var isFunction2 = (value) => {
        return typeof value == "function";
      };
      var isMap2 = (value) => {
        return toString2.call(value) == "[object Map]";
      };
      var isSet2 = (value) => {
        return toString2.call(value) == "[object Set]";
      };
      var singleEscapes = {
        '"': '\\"',
        "'": "\\'",
        "\\": "\\\\",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "	": "\\t"
      };
      var regexSingleEscape = /["'\\\b\f\n\r\t]/;
      var regexDigit = /[0-9]/;
      var regexWhitelist = /[ !#-&\(-\[\]-_a-~]/;
      var jsesc = (argument, options) => {
        const increaseIndentation = () => {
          oldIndent = indent;
          ++options.indentLevel;
          indent = options.indent.repeat(options.indentLevel);
        };
        const defaults2 = {
          "escapeEverything": false,
          "minimal": false,
          "isScriptContext": false,
          "quotes": "single",
          "wrap": false,
          "es6": false,
          "json": false,
          "compact": true,
          "lowercaseHex": false,
          "numbers": "decimal",
          "indent": "	",
          "indentLevel": 0,
          "__inline1__": false,
          "__inline2__": false
        };
        const json = options && options.json;
        if (json) {
          defaults2.quotes = "double";
          defaults2.wrap = true;
        }
        options = extend(defaults2, options);
        if (options.quotes != "single" && options.quotes != "double" && options.quotes != "backtick") {
          options.quotes = "single";
        }
        const quote = options.quotes == "double" ? '"' : options.quotes == "backtick" ? "`" : "'";
        const compact2 = options.compact;
        const lowercaseHex = options.lowercaseHex;
        let indent = options.indent.repeat(options.indentLevel);
        let oldIndent = "";
        const inline1 = options.__inline1__;
        const inline2 = options.__inline2__;
        const newLine = compact2 ? "" : "\n";
        let result2;
        let isEmpty2 = true;
        const useBinNumbers = options.numbers == "binary";
        const useOctNumbers = options.numbers == "octal";
        const useDecNumbers = options.numbers == "decimal";
        const useHexNumbers = options.numbers == "hexadecimal";
        if (json && argument && isFunction2(argument.toJSON)) {
          argument = argument.toJSON();
        }
        if (!isString2(argument)) {
          if (isMap2(argument)) {
            if (argument.size == 0) {
              return "new Map()";
            }
            if (!compact2) {
              options.__inline1__ = true;
              options.__inline2__ = false;
            }
            return "new Map(" + jsesc(Array.from(argument), options) + ")";
          }
          if (isSet2(argument)) {
            if (argument.size == 0) {
              return "new Set()";
            }
            return "new Set(" + jsesc(Array.from(argument), options) + ")";
          }
          if (isBuffer2(argument)) {
            if (argument.length == 0) {
              return "Buffer.from([])";
            }
            return "Buffer.from(" + jsesc(Array.from(argument), options) + ")";
          }
          if (isArray2(argument)) {
            result2 = [];
            options.wrap = true;
            if (inline1) {
              options.__inline1__ = false;
              options.__inline2__ = true;
            }
            if (!inline2) {
              increaseIndentation();
            }
            forEach2(argument, (value) => {
              isEmpty2 = false;
              if (inline2) {
                options.__inline2__ = false;
              }
              result2.push(
                (compact2 || inline2 ? "" : indent) + jsesc(value, options)
              );
            });
            if (isEmpty2) {
              return "[]";
            }
            if (inline2) {
              return "[" + result2.join(", ") + "]";
            }
            return "[" + newLine + result2.join("," + newLine) + newLine + (compact2 ? "" : oldIndent) + "]";
          } else if (isNumber2(argument)) {
            if (json) {
              return JSON.stringify(argument);
            }
            if (useDecNumbers) {
              return String(argument);
            }
            if (useHexNumbers) {
              let hexadecimal = argument.toString(16);
              if (!lowercaseHex) {
                hexadecimal = hexadecimal.toUpperCase();
              }
              return "0x" + hexadecimal;
            }
            if (useBinNumbers) {
              return "0b" + argument.toString(2);
            }
            if (useOctNumbers) {
              return "0o" + argument.toString(8);
            }
          } else if (!isObject2(argument)) {
            if (json) {
              return JSON.stringify(argument) || "null";
            }
            return String(argument);
          } else {
            result2 = [];
            options.wrap = true;
            increaseIndentation();
            forOwn2(argument, (key, value) => {
              isEmpty2 = false;
              result2.push(
                (compact2 ? "" : indent) + jsesc(key, options) + ":" + (compact2 ? "" : " ") + jsesc(value, options)
              );
            });
            if (isEmpty2) {
              return "{}";
            }
            return "{" + newLine + result2.join("," + newLine) + newLine + (compact2 ? "" : oldIndent) + "}";
          }
        }
        const string = argument;
        let index = -1;
        const length = string.length;
        result2 = "";
        while (++index < length) {
          const character = string.charAt(index);
          if (options.es6) {
            const first = string.charCodeAt(index);
            if (first >= 55296 && first <= 56319 && length > index + 1) {
              const second = string.charCodeAt(index + 1);
              if (second >= 56320 && second <= 57343) {
                const codePoint = (first - 55296) * 1024 + second - 56320 + 65536;
                let hexadecimal2 = codePoint.toString(16);
                if (!lowercaseHex) {
                  hexadecimal2 = hexadecimal2.toUpperCase();
                }
                result2 += "\\u{" + hexadecimal2 + "}";
                ++index;
                continue;
              }
            }
          }
          if (!options.escapeEverything) {
            if (regexWhitelist.test(character)) {
              result2 += character;
              continue;
            }
            if (character == '"') {
              result2 += quote == character ? '\\"' : character;
              continue;
            }
            if (character == "`") {
              result2 += quote == character ? "\\`" : character;
              continue;
            }
            if (character == "'") {
              result2 += quote == character ? "\\'" : character;
              continue;
            }
          }
          if (character == "\0" && !json && !regexDigit.test(string.charAt(index + 1))) {
            result2 += "\\0";
            continue;
          }
          if (regexSingleEscape.test(character)) {
            result2 += singleEscapes[character];
            continue;
          }
          const charCode = character.charCodeAt(0);
          if (options.minimal && charCode != 8232 && charCode != 8233) {
            result2 += character;
            continue;
          }
          let hexadecimal = charCode.toString(16);
          if (!lowercaseHex) {
            hexadecimal = hexadecimal.toUpperCase();
          }
          const longhand = hexadecimal.length > 2 || json;
          const escaped = "\\" + (longhand ? "u" : "x") + ("0000" + hexadecimal).slice(longhand ? -4 : -2);
          result2 += escaped;
          continue;
        }
        if (options.wrap) {
          result2 = quote + result2 + quote;
        }
        if (quote == "`") {
          result2 = result2.replace(/\$\{/g, "\\${");
        }
        if (options.isScriptContext) {
          return result2.replace(/<\/(script|style)/gi, "<\\/$1").replace(/<!--/g, json ? "\\u003C!--" : "\\x3C!--");
        }
        return result2;
      };
      jsesc.version = "2.5.2";
      module2.exports = jsesc;
    }
  });

  // node_modules/@babel/generator/lib/generators/types.js
  var require_types2 = __commonJS({
    "node_modules/@babel/generator/lib/generators/types.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ArgumentPlaceholder = ArgumentPlaceholder;
      exports2.ArrayPattern = exports2.ArrayExpression = ArrayExpression;
      exports2.BigIntLiteral = BigIntLiteral;
      exports2.BooleanLiteral = BooleanLiteral;
      exports2.DecimalLiteral = DecimalLiteral;
      exports2.Identifier = Identifier;
      exports2.NullLiteral = NullLiteral;
      exports2.NumericLiteral = NumericLiteral;
      exports2.ObjectPattern = exports2.ObjectExpression = ObjectExpression;
      exports2.ObjectMethod = ObjectMethod;
      exports2.ObjectProperty = ObjectProperty;
      exports2.PipelineBareFunction = PipelineBareFunction;
      exports2.PipelinePrimaryTopicReference = PipelinePrimaryTopicReference;
      exports2.PipelineTopicExpression = PipelineTopicExpression;
      exports2.RecordExpression = RecordExpression;
      exports2.RegExpLiteral = RegExpLiteral;
      exports2.SpreadElement = exports2.RestElement = RestElement;
      exports2.StringLiteral = StringLiteral;
      exports2.TopicReference = TopicReference;
      exports2.TupleExpression = TupleExpression;
      var _t = require_lib5();
      var _jsesc = require_jsesc();
      var {
        isAssignmentPattern,
        isIdentifier: isIdentifier2
      } = _t;
      function Identifier(node) {
        this.word(node.name);
      }
      function ArgumentPlaceholder() {
        this.tokenChar(63);
      }
      function RestElement(node) {
        this.token("...");
        this.print(node.argument, node);
      }
      function ObjectExpression(node) {
        const props = node.properties;
        this.tokenChar(123);
        if (props.length) {
          this.space();
          this.printList(props, node, {
            indent: true,
            statement: true
          });
          this.space();
        }
        this.sourceWithOffset("end", node.loc, 0, -1);
        this.tokenChar(125);
      }
      function ObjectMethod(node) {
        this.printJoin(node.decorators, node);
        this._methodHead(node);
        this.space();
        this.print(node.body, node);
      }
      function ObjectProperty(node) {
        this.printJoin(node.decorators, node);
        if (node.computed) {
          this.tokenChar(91);
          this.print(node.key, node);
          this.tokenChar(93);
        } else {
          if (isAssignmentPattern(node.value) && isIdentifier2(node.key) && node.key.name === node.value.left.name) {
            this.print(node.value, node);
            return;
          }
          this.print(node.key, node);
          if (node.shorthand && isIdentifier2(node.key) && isIdentifier2(node.value) && node.key.name === node.value.name) {
            return;
          }
        }
        this.tokenChar(58);
        this.space();
        this.print(node.value, node);
      }
      function ArrayExpression(node) {
        const elems = node.elements;
        const len = elems.length;
        this.tokenChar(91);
        for (let i = 0; i < elems.length; i++) {
          const elem = elems[i];
          if (elem) {
            if (i > 0)
              this.space();
            this.print(elem, node);
            if (i < len - 1)
              this.tokenChar(44);
          } else {
            this.tokenChar(44);
          }
        }
        this.tokenChar(93);
      }
      function RecordExpression(node) {
        const props = node.properties;
        let startToken;
        let endToken;
        if (this.format.recordAndTupleSyntaxType === "bar") {
          startToken = "{|";
          endToken = "|}";
        } else if (this.format.recordAndTupleSyntaxType !== "hash" && this.format.recordAndTupleSyntaxType != null) {
          throw new Error(`The "recordAndTupleSyntaxType" generator option must be "bar" or "hash" (${JSON.stringify(this.format.recordAndTupleSyntaxType)} received).`);
        } else {
          startToken = "#{";
          endToken = "}";
        }
        this.token(startToken);
        if (props.length) {
          this.space();
          this.printList(props, node, {
            indent: true,
            statement: true
          });
          this.space();
        }
        this.token(endToken);
      }
      function TupleExpression(node) {
        const elems = node.elements;
        const len = elems.length;
        let startToken;
        let endToken;
        if (this.format.recordAndTupleSyntaxType === "bar") {
          startToken = "[|";
          endToken = "|]";
        } else if (this.format.recordAndTupleSyntaxType === "hash") {
          startToken = "#[";
          endToken = "]";
        } else {
          throw new Error(`${this.format.recordAndTupleSyntaxType} is not a valid recordAndTuple syntax type`);
        }
        this.token(startToken);
        for (let i = 0; i < elems.length; i++) {
          const elem = elems[i];
          if (elem) {
            if (i > 0)
              this.space();
            this.print(elem, node);
            if (i < len - 1)
              this.tokenChar(44);
          }
        }
        this.token(endToken);
      }
      function RegExpLiteral(node) {
        this.word(`/${node.pattern}/${node.flags}`);
      }
      function BooleanLiteral(node) {
        this.word(node.value ? "true" : "false");
      }
      function NullLiteral() {
        this.word("null");
      }
      function NumericLiteral(node) {
        const raw = this.getPossibleRaw(node);
        const opts = this.format.jsescOption;
        const value = node.value + "";
        if (opts.numbers) {
          this.number(_jsesc(node.value, opts));
        } else if (raw == null) {
          this.number(value);
        } else if (this.format.minified) {
          this.number(raw.length < value.length ? raw : value);
        } else {
          this.number(raw);
        }
      }
      function StringLiteral(node) {
        const raw = this.getPossibleRaw(node);
        if (!this.format.minified && raw !== void 0) {
          this.token(raw);
          return;
        }
        const val = _jsesc(node.value, Object.assign(this.format.jsescOption, this.format.jsonCompatibleStrings && {
          json: true
        }));
        return this.token(val);
      }
      function BigIntLiteral(node) {
        const raw = this.getPossibleRaw(node);
        if (!this.format.minified && raw !== void 0) {
          this.word(raw);
          return;
        }
        this.word(node.value + "n");
      }
      function DecimalLiteral(node) {
        const raw = this.getPossibleRaw(node);
        if (!this.format.minified && raw !== void 0) {
          this.word(raw);
          return;
        }
        this.word(node.value + "m");
      }
      var validTopicTokenSet = /* @__PURE__ */ new Set(["^^", "@@", "^", "%", "#"]);
      function TopicReference() {
        const {
          topicToken
        } = this.format;
        if (validTopicTokenSet.has(topicToken)) {
          this.token(topicToken);
        } else {
          const givenTopicTokenJSON = JSON.stringify(topicToken);
          const validTopics = Array.from(validTopicTokenSet, (v) => JSON.stringify(v));
          throw new Error(`The "topicToken" generator option must be one of ${validTopics.join(", ")} (${givenTopicTokenJSON} received instead).`);
        }
      }
      function PipelineTopicExpression(node) {
        this.print(node.expression, node);
      }
      function PipelineBareFunction(node) {
        this.print(node.callee, node);
      }
      function PipelinePrimaryTopicReference() {
        this.tokenChar(35);
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/flow.js
  var require_flow2 = __commonJS({
    "node_modules/@babel/generator/lib/generators/flow.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.AnyTypeAnnotation = AnyTypeAnnotation;
      exports2.ArrayTypeAnnotation = ArrayTypeAnnotation;
      exports2.BooleanLiteralTypeAnnotation = BooleanLiteralTypeAnnotation;
      exports2.BooleanTypeAnnotation = BooleanTypeAnnotation;
      exports2.DeclareClass = DeclareClass;
      exports2.DeclareExportAllDeclaration = DeclareExportAllDeclaration;
      exports2.DeclareExportDeclaration = DeclareExportDeclaration;
      exports2.DeclareFunction = DeclareFunction;
      exports2.DeclareInterface = DeclareInterface;
      exports2.DeclareModule = DeclareModule;
      exports2.DeclareModuleExports = DeclareModuleExports;
      exports2.DeclareOpaqueType = DeclareOpaqueType;
      exports2.DeclareTypeAlias = DeclareTypeAlias;
      exports2.DeclareVariable = DeclareVariable;
      exports2.DeclaredPredicate = DeclaredPredicate;
      exports2.EmptyTypeAnnotation = EmptyTypeAnnotation;
      exports2.EnumBooleanBody = EnumBooleanBody;
      exports2.EnumBooleanMember = EnumBooleanMember;
      exports2.EnumDeclaration = EnumDeclaration;
      exports2.EnumDefaultedMember = EnumDefaultedMember;
      exports2.EnumNumberBody = EnumNumberBody;
      exports2.EnumNumberMember = EnumNumberMember;
      exports2.EnumStringBody = EnumStringBody;
      exports2.EnumStringMember = EnumStringMember;
      exports2.EnumSymbolBody = EnumSymbolBody;
      exports2.ExistsTypeAnnotation = ExistsTypeAnnotation;
      exports2.FunctionTypeAnnotation = FunctionTypeAnnotation;
      exports2.FunctionTypeParam = FunctionTypeParam;
      exports2.IndexedAccessType = IndexedAccessType;
      exports2.InferredPredicate = InferredPredicate;
      exports2.InterfaceDeclaration = InterfaceDeclaration;
      exports2.GenericTypeAnnotation = exports2.ClassImplements = exports2.InterfaceExtends = InterfaceExtends;
      exports2.InterfaceTypeAnnotation = InterfaceTypeAnnotation;
      exports2.IntersectionTypeAnnotation = IntersectionTypeAnnotation;
      exports2.MixedTypeAnnotation = MixedTypeAnnotation;
      exports2.NullLiteralTypeAnnotation = NullLiteralTypeAnnotation;
      exports2.NullableTypeAnnotation = NullableTypeAnnotation;
      Object.defineProperty(exports2, "NumberLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _types2.NumericLiteral;
        }
      });
      exports2.NumberTypeAnnotation = NumberTypeAnnotation;
      exports2.ObjectTypeAnnotation = ObjectTypeAnnotation;
      exports2.ObjectTypeCallProperty = ObjectTypeCallProperty;
      exports2.ObjectTypeIndexer = ObjectTypeIndexer;
      exports2.ObjectTypeInternalSlot = ObjectTypeInternalSlot;
      exports2.ObjectTypeProperty = ObjectTypeProperty;
      exports2.ObjectTypeSpreadProperty = ObjectTypeSpreadProperty;
      exports2.OpaqueType = OpaqueType;
      exports2.OptionalIndexedAccessType = OptionalIndexedAccessType;
      exports2.QualifiedTypeIdentifier = QualifiedTypeIdentifier;
      Object.defineProperty(exports2, "StringLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _types2.StringLiteral;
        }
      });
      exports2.StringTypeAnnotation = StringTypeAnnotation;
      exports2.SymbolTypeAnnotation = SymbolTypeAnnotation;
      exports2.ThisTypeAnnotation = ThisTypeAnnotation;
      exports2.TupleTypeAnnotation = TupleTypeAnnotation;
      exports2.TypeAlias = TypeAlias;
      exports2.TypeAnnotation = TypeAnnotation;
      exports2.TypeCastExpression = TypeCastExpression;
      exports2.TypeParameter = TypeParameter;
      exports2.TypeParameterDeclaration = exports2.TypeParameterInstantiation = TypeParameterInstantiation;
      exports2.TypeofTypeAnnotation = TypeofTypeAnnotation;
      exports2.UnionTypeAnnotation = UnionTypeAnnotation;
      exports2.Variance = Variance;
      exports2.VoidTypeAnnotation = VoidTypeAnnotation;
      exports2._interfaceish = _interfaceish;
      exports2._variance = _variance;
      var _t = require_lib5();
      var _modules = require_modules();
      var _types2 = require_types2();
      var {
        isDeclareExportDeclaration,
        isStatement
      } = _t;
      function AnyTypeAnnotation() {
        this.word("any");
      }
      function ArrayTypeAnnotation(node) {
        this.print(node.elementType, node, true);
        this.tokenChar(91);
        this.tokenChar(93);
      }
      function BooleanTypeAnnotation() {
        this.word("boolean");
      }
      function BooleanLiteralTypeAnnotation(node) {
        this.word(node.value ? "true" : "false");
      }
      function NullLiteralTypeAnnotation() {
        this.word("null");
      }
      function DeclareClass(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.word("class");
        this.space();
        this._interfaceish(node);
      }
      function DeclareFunction(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.word("function");
        this.space();
        this.print(node.id, node);
        this.print(node.id.typeAnnotation.typeAnnotation, node);
        if (node.predicate) {
          this.space();
          this.print(node.predicate, node);
        }
        this.semicolon();
      }
      function InferredPredicate() {
        this.tokenChar(37);
        this.word("checks");
      }
      function DeclaredPredicate(node) {
        this.tokenChar(37);
        this.word("checks");
        this.tokenChar(40);
        this.print(node.value, node);
        this.tokenChar(41);
      }
      function DeclareInterface(node) {
        this.word("declare");
        this.space();
        this.InterfaceDeclaration(node);
      }
      function DeclareModule(node) {
        this.word("declare");
        this.space();
        this.word("module");
        this.space();
        this.print(node.id, node);
        this.space();
        this.print(node.body, node);
      }
      function DeclareModuleExports(node) {
        this.word("declare");
        this.space();
        this.word("module");
        this.tokenChar(46);
        this.word("exports");
        this.print(node.typeAnnotation, node);
      }
      function DeclareTypeAlias(node) {
        this.word("declare");
        this.space();
        this.TypeAlias(node);
      }
      function DeclareOpaqueType(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.OpaqueType(node);
      }
      function DeclareVariable(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.word("var");
        this.space();
        this.print(node.id, node);
        this.print(node.id.typeAnnotation, node);
        this.semicolon();
      }
      function DeclareExportDeclaration(node) {
        this.word("declare");
        this.space();
        this.word("export");
        this.space();
        if (node.default) {
          this.word("default");
          this.space();
        }
        FlowExportDeclaration.call(this, node);
      }
      function DeclareExportAllDeclaration(node) {
        this.word("declare");
        this.space();
        _modules.ExportAllDeclaration.call(this, node);
      }
      function EnumDeclaration(node) {
        const {
          id,
          body
        } = node;
        this.word("enum");
        this.space();
        this.print(id, node);
        this.print(body, node);
      }
      function enumExplicitType(context, name, hasExplicitType) {
        if (hasExplicitType) {
          context.space();
          context.word("of");
          context.space();
          context.word(name);
        }
        context.space();
      }
      function enumBody(context, node) {
        const {
          members
        } = node;
        context.token("{");
        context.indent();
        context.newline();
        for (const member of members) {
          context.print(member, node);
          context.newline();
        }
        if (node.hasUnknownMembers) {
          context.token("...");
          context.newline();
        }
        context.dedent();
        context.token("}");
      }
      function EnumBooleanBody(node) {
        const {
          explicitType
        } = node;
        enumExplicitType(this, "boolean", explicitType);
        enumBody(this, node);
      }
      function EnumNumberBody(node) {
        const {
          explicitType
        } = node;
        enumExplicitType(this, "number", explicitType);
        enumBody(this, node);
      }
      function EnumStringBody(node) {
        const {
          explicitType
        } = node;
        enumExplicitType(this, "string", explicitType);
        enumBody(this, node);
      }
      function EnumSymbolBody(node) {
        enumExplicitType(this, "symbol", true);
        enumBody(this, node);
      }
      function EnumDefaultedMember(node) {
        const {
          id
        } = node;
        this.print(id, node);
        this.tokenChar(44);
      }
      function enumInitializedMember(context, node) {
        const {
          id,
          init
        } = node;
        context.print(id, node);
        context.space();
        context.token("=");
        context.space();
        context.print(init, node);
        context.token(",");
      }
      function EnumBooleanMember(node) {
        enumInitializedMember(this, node);
      }
      function EnumNumberMember(node) {
        enumInitializedMember(this, node);
      }
      function EnumStringMember(node) {
        enumInitializedMember(this, node);
      }
      function FlowExportDeclaration(node) {
        if (node.declaration) {
          const declar = node.declaration;
          this.print(declar, node);
          if (!isStatement(declar))
            this.semicolon();
        } else {
          this.tokenChar(123);
          if (node.specifiers.length) {
            this.space();
            this.printList(node.specifiers, node);
            this.space();
          }
          this.tokenChar(125);
          if (node.source) {
            this.space();
            this.word("from");
            this.space();
            this.print(node.source, node);
          }
          this.semicolon();
        }
      }
      function ExistsTypeAnnotation() {
        this.tokenChar(42);
      }
      function FunctionTypeAnnotation(node, parent2) {
        this.print(node.typeParameters, node);
        this.tokenChar(40);
        if (node.this) {
          this.word("this");
          this.tokenChar(58);
          this.space();
          this.print(node.this.typeAnnotation, node);
          if (node.params.length || node.rest) {
            this.tokenChar(44);
            this.space();
          }
        }
        this.printList(node.params, node);
        if (node.rest) {
          if (node.params.length) {
            this.tokenChar(44);
            this.space();
          }
          this.token("...");
          this.print(node.rest, node);
        }
        this.tokenChar(41);
        if (parent2 && (parent2.type === "ObjectTypeCallProperty" || parent2.type === "ObjectTypeInternalSlot" || parent2.type === "DeclareFunction" || parent2.type === "ObjectTypeProperty" && parent2.method)) {
          this.tokenChar(58);
        } else {
          this.space();
          this.token("=>");
        }
        this.space();
        this.print(node.returnType, node);
      }
      function FunctionTypeParam(node) {
        this.print(node.name, node);
        if (node.optional)
          this.tokenChar(63);
        if (node.name) {
          this.tokenChar(58);
          this.space();
        }
        this.print(node.typeAnnotation, node);
      }
      function InterfaceExtends(node) {
        this.print(node.id, node);
        this.print(node.typeParameters, node, true);
      }
      function _interfaceish(node) {
        var _node$extends;
        this.print(node.id, node);
        this.print(node.typeParameters, node);
        if ((_node$extends = node.extends) != null && _node$extends.length) {
          this.space();
          this.word("extends");
          this.space();
          this.printList(node.extends, node);
        }
        if (node.mixins && node.mixins.length) {
          this.space();
          this.word("mixins");
          this.space();
          this.printList(node.mixins, node);
        }
        if (node.implements && node.implements.length) {
          this.space();
          this.word("implements");
          this.space();
          this.printList(node.implements, node);
        }
        this.space();
        this.print(node.body, node);
      }
      function _variance(node) {
        if (node.variance) {
          if (node.variance.kind === "plus") {
            this.tokenChar(43);
          } else if (node.variance.kind === "minus") {
            this.tokenChar(45);
          }
        }
      }
      function InterfaceDeclaration(node) {
        this.word("interface");
        this.space();
        this._interfaceish(node);
      }
      function andSeparator() {
        this.space();
        this.tokenChar(38);
        this.space();
      }
      function InterfaceTypeAnnotation(node) {
        this.word("interface");
        if (node.extends && node.extends.length) {
          this.space();
          this.word("extends");
          this.space();
          this.printList(node.extends, node);
        }
        this.space();
        this.print(node.body, node);
      }
      function IntersectionTypeAnnotation(node) {
        this.printJoin(node.types, node, {
          separator: andSeparator
        });
      }
      function MixedTypeAnnotation() {
        this.word("mixed");
      }
      function EmptyTypeAnnotation() {
        this.word("empty");
      }
      function NullableTypeAnnotation(node) {
        this.tokenChar(63);
        this.print(node.typeAnnotation, node);
      }
      function NumberTypeAnnotation() {
        this.word("number");
      }
      function StringTypeAnnotation() {
        this.word("string");
      }
      function ThisTypeAnnotation() {
        this.word("this");
      }
      function TupleTypeAnnotation(node) {
        this.tokenChar(91);
        this.printList(node.types, node);
        this.tokenChar(93);
      }
      function TypeofTypeAnnotation(node) {
        this.word("typeof");
        this.space();
        this.print(node.argument, node);
      }
      function TypeAlias(node) {
        this.word("type");
        this.space();
        this.print(node.id, node);
        this.print(node.typeParameters, node);
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.right, node);
        this.semicolon();
      }
      function TypeAnnotation(node) {
        this.tokenChar(58);
        this.space();
        if (node.optional)
          this.tokenChar(63);
        this.print(node.typeAnnotation, node);
      }
      function TypeParameterInstantiation(node) {
        this.tokenChar(60);
        this.printList(node.params, node, {});
        this.tokenChar(62);
      }
      function TypeParameter(node) {
        this._variance(node);
        this.word(node.name);
        if (node.bound) {
          this.print(node.bound, node);
        }
        if (node.default) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.default, node);
        }
      }
      function OpaqueType(node) {
        this.word("opaque");
        this.space();
        this.word("type");
        this.space();
        this.print(node.id, node);
        this.print(node.typeParameters, node);
        if (node.supertype) {
          this.tokenChar(58);
          this.space();
          this.print(node.supertype, node);
        }
        if (node.impltype) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.impltype, node);
        }
        this.semicolon();
      }
      function ObjectTypeAnnotation(node) {
        if (node.exact) {
          this.token("{|");
        } else {
          this.tokenChar(123);
        }
        const props = [...node.properties, ...node.callProperties || [], ...node.indexers || [], ...node.internalSlots || []];
        if (props.length) {
          this.newline();
          this.space();
          this.printJoin(props, node, {
            addNewlines(leading) {
              if (leading && !props[0])
                return 1;
            },
            indent: true,
            statement: true,
            iterator: () => {
              if (props.length !== 1 || node.inexact) {
                this.tokenChar(44);
                this.space();
              }
            }
          });
          this.space();
        }
        if (node.inexact) {
          this.indent();
          this.token("...");
          if (props.length) {
            this.newline();
          }
          this.dedent();
        }
        if (node.exact) {
          this.token("|}");
        } else {
          this.tokenChar(125);
        }
      }
      function ObjectTypeInternalSlot(node) {
        if (node.static) {
          this.word("static");
          this.space();
        }
        this.tokenChar(91);
        this.tokenChar(91);
        this.print(node.id, node);
        this.tokenChar(93);
        this.tokenChar(93);
        if (node.optional)
          this.tokenChar(63);
        if (!node.method) {
          this.tokenChar(58);
          this.space();
        }
        this.print(node.value, node);
      }
      function ObjectTypeCallProperty(node) {
        if (node.static) {
          this.word("static");
          this.space();
        }
        this.print(node.value, node);
      }
      function ObjectTypeIndexer(node) {
        if (node.static) {
          this.word("static");
          this.space();
        }
        this._variance(node);
        this.tokenChar(91);
        if (node.id) {
          this.print(node.id, node);
          this.tokenChar(58);
          this.space();
        }
        this.print(node.key, node);
        this.tokenChar(93);
        this.tokenChar(58);
        this.space();
        this.print(node.value, node);
      }
      function ObjectTypeProperty(node) {
        if (node.proto) {
          this.word("proto");
          this.space();
        }
        if (node.static) {
          this.word("static");
          this.space();
        }
        if (node.kind === "get" || node.kind === "set") {
          this.word(node.kind);
          this.space();
        }
        this._variance(node);
        this.print(node.key, node);
        if (node.optional)
          this.tokenChar(63);
        if (!node.method) {
          this.tokenChar(58);
          this.space();
        }
        this.print(node.value, node);
      }
      function ObjectTypeSpreadProperty(node) {
        this.token("...");
        this.print(node.argument, node);
      }
      function QualifiedTypeIdentifier(node) {
        this.print(node.qualification, node);
        this.tokenChar(46);
        this.print(node.id, node);
      }
      function SymbolTypeAnnotation() {
        this.word("symbol");
      }
      function orSeparator() {
        this.space();
        this.tokenChar(124);
        this.space();
      }
      function UnionTypeAnnotation(node) {
        this.printJoin(node.types, node, {
          separator: orSeparator
        });
      }
      function TypeCastExpression(node) {
        this.tokenChar(40);
        this.print(node.expression, node);
        this.print(node.typeAnnotation, node);
        this.tokenChar(41);
      }
      function Variance(node) {
        if (node.kind === "plus") {
          this.tokenChar(43);
        } else {
          this.tokenChar(45);
        }
      }
      function VoidTypeAnnotation() {
        this.word("void");
      }
      function IndexedAccessType(node) {
        this.print(node.objectType, node, true);
        this.tokenChar(91);
        this.print(node.indexType, node);
        this.tokenChar(93);
      }
      function OptionalIndexedAccessType(node) {
        this.print(node.objectType, node);
        if (node.optional) {
          this.token("?.");
        }
        this.tokenChar(91);
        this.print(node.indexType, node);
        this.tokenChar(93);
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/base.js
  var require_base2 = __commonJS({
    "node_modules/@babel/generator/lib/generators/base.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.BlockStatement = BlockStatement;
      exports2.Directive = Directive;
      exports2.DirectiveLiteral = DirectiveLiteral;
      exports2.File = File;
      exports2.InterpreterDirective = InterpreterDirective;
      exports2.Placeholder = Placeholder;
      exports2.Program = Program;
      function File(node) {
        if (node.program) {
          this.print(node.program.interpreter, node);
        }
        this.print(node.program, node);
      }
      function Program(node) {
        var _node$directives;
        this.noIndentInnerCommentsHere();
        this.printInnerComments();
        const directivesLen = (_node$directives = node.directives) == null ? void 0 : _node$directives.length;
        if (directivesLen) {
          var _node$directives$trai;
          const newline = node.body.length ? 2 : 1;
          this.printSequence(node.directives, node, {
            trailingCommentsLineOffset: newline
          });
          if (!((_node$directives$trai = node.directives[directivesLen - 1].trailingComments) != null && _node$directives$trai.length)) {
            this.newline(newline);
          }
        }
        this.printSequence(node.body, node);
      }
      function BlockStatement(node) {
        var _node$directives2;
        this.tokenChar(123);
        const directivesLen = (_node$directives2 = node.directives) == null ? void 0 : _node$directives2.length;
        if (directivesLen) {
          var _node$directives$trai2;
          const newline = node.body.length ? 2 : 1;
          this.printSequence(node.directives, node, {
            indent: true,
            trailingCommentsLineOffset: newline
          });
          if (!((_node$directives$trai2 = node.directives[directivesLen - 1].trailingComments) != null && _node$directives$trai2.length)) {
            this.newline(newline);
          }
        }
        this.printSequence(node.body, node, {
          indent: true
        });
        this.sourceWithOffset("end", node.loc, 0, -1);
        this.rightBrace();
      }
      function Directive(node) {
        this.print(node.value, node);
        this.semicolon();
      }
      var unescapedSingleQuoteRE = /(?:^|[^\\])(?:\\\\)*'/;
      var unescapedDoubleQuoteRE = /(?:^|[^\\])(?:\\\\)*"/;
      function DirectiveLiteral(node) {
        const raw = this.getPossibleRaw(node);
        if (!this.format.minified && raw !== void 0) {
          this.token(raw);
          return;
        }
        const {
          value
        } = node;
        if (!unescapedDoubleQuoteRE.test(value)) {
          this.token(`"${value}"`);
        } else if (!unescapedSingleQuoteRE.test(value)) {
          this.token(`'${value}'`);
        } else {
          throw new Error("Malformed AST: it is not possible to print a directive containing both unescaped single and double quotes.");
        }
      }
      function InterpreterDirective(node) {
        this.token(`#!${node.value}`);
        this.newline(1, true);
      }
      function Placeholder(node) {
        this.token("%%");
        this.print(node.name);
        this.token("%%");
        if (node.expectedNode === "Statement") {
          this.semicolon();
        }
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/jsx.js
  var require_jsx2 = __commonJS({
    "node_modules/@babel/generator/lib/generators/jsx.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.JSXAttribute = JSXAttribute;
      exports2.JSXClosingElement = JSXClosingElement;
      exports2.JSXClosingFragment = JSXClosingFragment;
      exports2.JSXElement = JSXElement;
      exports2.JSXEmptyExpression = JSXEmptyExpression;
      exports2.JSXExpressionContainer = JSXExpressionContainer;
      exports2.JSXFragment = JSXFragment;
      exports2.JSXIdentifier = JSXIdentifier;
      exports2.JSXMemberExpression = JSXMemberExpression;
      exports2.JSXNamespacedName = JSXNamespacedName;
      exports2.JSXOpeningElement = JSXOpeningElement;
      exports2.JSXOpeningFragment = JSXOpeningFragment;
      exports2.JSXSpreadAttribute = JSXSpreadAttribute;
      exports2.JSXSpreadChild = JSXSpreadChild;
      exports2.JSXText = JSXText;
      function JSXAttribute(node) {
        this.print(node.name, node);
        if (node.value) {
          this.tokenChar(61);
          this.print(node.value, node);
        }
      }
      function JSXIdentifier(node) {
        this.word(node.name);
      }
      function JSXNamespacedName(node) {
        this.print(node.namespace, node);
        this.tokenChar(58);
        this.print(node.name, node);
      }
      function JSXMemberExpression(node) {
        this.print(node.object, node);
        this.tokenChar(46);
        this.print(node.property, node);
      }
      function JSXSpreadAttribute(node) {
        this.tokenChar(123);
        this.token("...");
        this.print(node.argument, node);
        this.tokenChar(125);
      }
      function JSXExpressionContainer(node) {
        this.tokenChar(123);
        this.print(node.expression, node);
        this.tokenChar(125);
      }
      function JSXSpreadChild(node) {
        this.tokenChar(123);
        this.token("...");
        this.print(node.expression, node);
        this.tokenChar(125);
      }
      function JSXText(node) {
        const raw = this.getPossibleRaw(node);
        if (raw !== void 0) {
          this.token(raw, true);
        } else {
          this.token(node.value, true);
        }
      }
      function JSXElement(node) {
        const open = node.openingElement;
        this.print(open, node);
        if (open.selfClosing)
          return;
        this.indent();
        for (const child of node.children) {
          this.print(child, node);
        }
        this.dedent();
        this.print(node.closingElement, node);
      }
      function spaceSeparator() {
        this.space();
      }
      function JSXOpeningElement(node) {
        this.tokenChar(60);
        this.print(node.name, node);
        this.print(node.typeParameters, node);
        if (node.attributes.length > 0) {
          this.space();
          this.printJoin(node.attributes, node, {
            separator: spaceSeparator
          });
        }
        if (node.selfClosing) {
          this.space();
          this.token("/>");
        } else {
          this.tokenChar(62);
        }
      }
      function JSXClosingElement(node) {
        this.token("</");
        this.print(node.name, node);
        this.tokenChar(62);
      }
      function JSXEmptyExpression() {
        this.printInnerComments();
      }
      function JSXFragment(node) {
        this.print(node.openingFragment, node);
        this.indent();
        for (const child of node.children) {
          this.print(child, node);
        }
        this.dedent();
        this.print(node.closingFragment, node);
      }
      function JSXOpeningFragment() {
        this.tokenChar(60);
        this.tokenChar(62);
      }
      function JSXClosingFragment() {
        this.token("</");
        this.tokenChar(62);
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/typescript.js
  var require_typescript2 = __commonJS({
    "node_modules/@babel/generator/lib/generators/typescript.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.TSAnyKeyword = TSAnyKeyword;
      exports2.TSArrayType = TSArrayType;
      exports2.TSSatisfiesExpression = exports2.TSAsExpression = TSTypeExpression;
      exports2.TSBigIntKeyword = TSBigIntKeyword;
      exports2.TSBooleanKeyword = TSBooleanKeyword;
      exports2.TSCallSignatureDeclaration = TSCallSignatureDeclaration;
      exports2.TSConditionalType = TSConditionalType;
      exports2.TSConstructSignatureDeclaration = TSConstructSignatureDeclaration;
      exports2.TSConstructorType = TSConstructorType;
      exports2.TSDeclareFunction = TSDeclareFunction;
      exports2.TSDeclareMethod = TSDeclareMethod;
      exports2.TSEnumDeclaration = TSEnumDeclaration;
      exports2.TSEnumMember = TSEnumMember;
      exports2.TSExportAssignment = TSExportAssignment;
      exports2.TSExpressionWithTypeArguments = TSExpressionWithTypeArguments;
      exports2.TSExternalModuleReference = TSExternalModuleReference;
      exports2.TSFunctionType = TSFunctionType;
      exports2.TSImportEqualsDeclaration = TSImportEqualsDeclaration;
      exports2.TSImportType = TSImportType;
      exports2.TSIndexSignature = TSIndexSignature;
      exports2.TSIndexedAccessType = TSIndexedAccessType;
      exports2.TSInferType = TSInferType;
      exports2.TSInstantiationExpression = TSInstantiationExpression;
      exports2.TSInterfaceBody = TSInterfaceBody;
      exports2.TSInterfaceDeclaration = TSInterfaceDeclaration;
      exports2.TSIntersectionType = TSIntersectionType;
      exports2.TSIntrinsicKeyword = TSIntrinsicKeyword;
      exports2.TSLiteralType = TSLiteralType;
      exports2.TSMappedType = TSMappedType;
      exports2.TSMethodSignature = TSMethodSignature;
      exports2.TSModuleBlock = TSModuleBlock;
      exports2.TSModuleDeclaration = TSModuleDeclaration;
      exports2.TSNamedTupleMember = TSNamedTupleMember;
      exports2.TSNamespaceExportDeclaration = TSNamespaceExportDeclaration;
      exports2.TSNeverKeyword = TSNeverKeyword;
      exports2.TSNonNullExpression = TSNonNullExpression;
      exports2.TSNullKeyword = TSNullKeyword;
      exports2.TSNumberKeyword = TSNumberKeyword;
      exports2.TSObjectKeyword = TSObjectKeyword;
      exports2.TSOptionalType = TSOptionalType;
      exports2.TSParameterProperty = TSParameterProperty;
      exports2.TSParenthesizedType = TSParenthesizedType;
      exports2.TSPropertySignature = TSPropertySignature;
      exports2.TSQualifiedName = TSQualifiedName;
      exports2.TSRestType = TSRestType;
      exports2.TSStringKeyword = TSStringKeyword;
      exports2.TSSymbolKeyword = TSSymbolKeyword;
      exports2.TSThisType = TSThisType;
      exports2.TSTupleType = TSTupleType;
      exports2.TSTypeAliasDeclaration = TSTypeAliasDeclaration;
      exports2.TSTypeAnnotation = TSTypeAnnotation;
      exports2.TSTypeAssertion = TSTypeAssertion;
      exports2.TSTypeLiteral = TSTypeLiteral;
      exports2.TSTypeOperator = TSTypeOperator;
      exports2.TSTypeParameter = TSTypeParameter;
      exports2.TSTypeParameterDeclaration = exports2.TSTypeParameterInstantiation = TSTypeParameterInstantiation;
      exports2.TSTypePredicate = TSTypePredicate;
      exports2.TSTypeQuery = TSTypeQuery;
      exports2.TSTypeReference = TSTypeReference;
      exports2.TSUndefinedKeyword = TSUndefinedKeyword;
      exports2.TSUnionType = TSUnionType;
      exports2.TSUnknownKeyword = TSUnknownKeyword;
      exports2.TSVoidKeyword = TSVoidKeyword;
      exports2.tsPrintClassMemberModifiers = tsPrintClassMemberModifiers;
      exports2.tsPrintFunctionOrConstructorType = tsPrintFunctionOrConstructorType;
      exports2.tsPrintPropertyOrMethodName = tsPrintPropertyOrMethodName;
      exports2.tsPrintSignatureDeclarationBase = tsPrintSignatureDeclarationBase;
      exports2.tsPrintTypeLiteralOrInterfaceBody = tsPrintTypeLiteralOrInterfaceBody;
      function TSTypeAnnotation(node) {
        this.tokenChar(58);
        this.space();
        if (node.optional)
          this.tokenChar(63);
        this.print(node.typeAnnotation, node);
      }
      function TSTypeParameterInstantiation(node, parent2) {
        this.tokenChar(60);
        this.printList(node.params, node, {});
        if (parent2.type === "ArrowFunctionExpression" && node.params.length === 1) {
          this.tokenChar(44);
        }
        this.tokenChar(62);
      }
      function TSTypeParameter(node) {
        if (node.in) {
          this.word("in");
          this.space();
        }
        if (node.out) {
          this.word("out");
          this.space();
        }
        this.word(node.name);
        if (node.constraint) {
          this.space();
          this.word("extends");
          this.space();
          this.print(node.constraint, node);
        }
        if (node.default) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.default, node);
        }
      }
      function TSParameterProperty(node) {
        if (node.accessibility) {
          this.word(node.accessibility);
          this.space();
        }
        if (node.readonly) {
          this.word("readonly");
          this.space();
        }
        this._param(node.parameter);
      }
      function TSDeclareFunction(node) {
        if (node.declare) {
          this.word("declare");
          this.space();
        }
        this._functionHead(node);
        this.tokenChar(59);
      }
      function TSDeclareMethod(node) {
        this._classMethodHead(node);
        this.tokenChar(59);
      }
      function TSQualifiedName(node) {
        this.print(node.left, node);
        this.tokenChar(46);
        this.print(node.right, node);
      }
      function TSCallSignatureDeclaration(node) {
        this.tsPrintSignatureDeclarationBase(node);
        this.tokenChar(59);
      }
      function TSConstructSignatureDeclaration(node) {
        this.word("new");
        this.space();
        this.tsPrintSignatureDeclarationBase(node);
        this.tokenChar(59);
      }
      function TSPropertySignature(node) {
        const {
          readonly,
          initializer
        } = node;
        if (readonly) {
          this.word("readonly");
          this.space();
        }
        this.tsPrintPropertyOrMethodName(node);
        this.print(node.typeAnnotation, node);
        if (initializer) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(initializer, node);
        }
        this.tokenChar(59);
      }
      function tsPrintPropertyOrMethodName(node) {
        if (node.computed) {
          this.tokenChar(91);
        }
        this.print(node.key, node);
        if (node.computed) {
          this.tokenChar(93);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
      }
      function TSMethodSignature(node) {
        const {
          kind
        } = node;
        if (kind === "set" || kind === "get") {
          this.word(kind);
          this.space();
        }
        this.tsPrintPropertyOrMethodName(node);
        this.tsPrintSignatureDeclarationBase(node);
        this.tokenChar(59);
      }
      function TSIndexSignature(node) {
        const {
          readonly,
          static: isStatic
        } = node;
        if (isStatic) {
          this.word("static");
          this.space();
        }
        if (readonly) {
          this.word("readonly");
          this.space();
        }
        this.tokenChar(91);
        this._parameters(node.parameters, node);
        this.tokenChar(93);
        this.print(node.typeAnnotation, node);
        this.tokenChar(59);
      }
      function TSAnyKeyword() {
        this.word("any");
      }
      function TSBigIntKeyword() {
        this.word("bigint");
      }
      function TSUnknownKeyword() {
        this.word("unknown");
      }
      function TSNumberKeyword() {
        this.word("number");
      }
      function TSObjectKeyword() {
        this.word("object");
      }
      function TSBooleanKeyword() {
        this.word("boolean");
      }
      function TSStringKeyword() {
        this.word("string");
      }
      function TSSymbolKeyword() {
        this.word("symbol");
      }
      function TSVoidKeyword() {
        this.word("void");
      }
      function TSUndefinedKeyword() {
        this.word("undefined");
      }
      function TSNullKeyword() {
        this.word("null");
      }
      function TSNeverKeyword() {
        this.word("never");
      }
      function TSIntrinsicKeyword() {
        this.word("intrinsic");
      }
      function TSThisType() {
        this.word("this");
      }
      function TSFunctionType(node) {
        this.tsPrintFunctionOrConstructorType(node);
      }
      function TSConstructorType(node) {
        if (node.abstract) {
          this.word("abstract");
          this.space();
        }
        this.word("new");
        this.space();
        this.tsPrintFunctionOrConstructorType(node);
      }
      function tsPrintFunctionOrConstructorType(node) {
        const {
          typeParameters
        } = node;
        const parameters = node.parameters;
        this.print(typeParameters, node);
        this.tokenChar(40);
        this._parameters(parameters, node);
        this.tokenChar(41);
        this.space();
        this.token("=>");
        this.space();
        const returnType = node.typeAnnotation;
        this.print(returnType.typeAnnotation, node);
      }
      function TSTypeReference(node) {
        this.print(node.typeName, node, true);
        this.print(node.typeParameters, node, true);
      }
      function TSTypePredicate(node) {
        if (node.asserts) {
          this.word("asserts");
          this.space();
        }
        this.print(node.parameterName);
        if (node.typeAnnotation) {
          this.space();
          this.word("is");
          this.space();
          this.print(node.typeAnnotation.typeAnnotation);
        }
      }
      function TSTypeQuery(node) {
        this.word("typeof");
        this.space();
        this.print(node.exprName);
        if (node.typeParameters) {
          this.print(node.typeParameters, node);
        }
      }
      function TSTypeLiteral(node) {
        this.tsPrintTypeLiteralOrInterfaceBody(node.members, node);
      }
      function tsPrintTypeLiteralOrInterfaceBody(members, node) {
        tsPrintBraced(this, members, node);
      }
      function tsPrintBraced(printer, members, node) {
        printer.token("{");
        if (members.length) {
          printer.indent();
          printer.newline();
          for (const member of members) {
            printer.print(member, node);
            printer.newline();
          }
          printer.dedent();
        }
        printer.sourceWithOffset("end", node.loc, 0, -1);
        printer.rightBrace();
      }
      function TSArrayType(node) {
        this.print(node.elementType, node, true);
        this.token("[]");
      }
      function TSTupleType(node) {
        this.tokenChar(91);
        this.printList(node.elementTypes, node);
        this.tokenChar(93);
      }
      function TSOptionalType(node) {
        this.print(node.typeAnnotation, node);
        this.tokenChar(63);
      }
      function TSRestType(node) {
        this.token("...");
        this.print(node.typeAnnotation, node);
      }
      function TSNamedTupleMember(node) {
        this.print(node.label, node);
        if (node.optional)
          this.tokenChar(63);
        this.tokenChar(58);
        this.space();
        this.print(node.elementType, node);
      }
      function TSUnionType(node) {
        tsPrintUnionOrIntersectionType(this, node, "|");
      }
      function TSIntersectionType(node) {
        tsPrintUnionOrIntersectionType(this, node, "&");
      }
      function tsPrintUnionOrIntersectionType(printer, node, sep) {
        printer.printJoin(node.types, node, {
          separator() {
            this.space();
            this.token(sep);
            this.space();
          }
        });
      }
      function TSConditionalType(node) {
        this.print(node.checkType);
        this.space();
        this.word("extends");
        this.space();
        this.print(node.extendsType);
        this.space();
        this.tokenChar(63);
        this.space();
        this.print(node.trueType);
        this.space();
        this.tokenChar(58);
        this.space();
        this.print(node.falseType);
      }
      function TSInferType(node) {
        this.token("infer");
        this.space();
        this.print(node.typeParameter);
      }
      function TSParenthesizedType(node) {
        this.tokenChar(40);
        this.print(node.typeAnnotation, node);
        this.tokenChar(41);
      }
      function TSTypeOperator(node) {
        this.word(node.operator);
        this.space();
        this.print(node.typeAnnotation, node);
      }
      function TSIndexedAccessType(node) {
        this.print(node.objectType, node, true);
        this.tokenChar(91);
        this.print(node.indexType, node);
        this.tokenChar(93);
      }
      function TSMappedType(node) {
        const {
          nameType,
          optional,
          readonly,
          typeParameter
        } = node;
        this.tokenChar(123);
        this.space();
        if (readonly) {
          tokenIfPlusMinus(this, readonly);
          this.word("readonly");
          this.space();
        }
        this.tokenChar(91);
        this.word(typeParameter.name);
        this.space();
        this.word("in");
        this.space();
        this.print(typeParameter.constraint, typeParameter);
        if (nameType) {
          this.space();
          this.word("as");
          this.space();
          this.print(nameType, node);
        }
        this.tokenChar(93);
        if (optional) {
          tokenIfPlusMinus(this, optional);
          this.tokenChar(63);
        }
        this.tokenChar(58);
        this.space();
        this.print(node.typeAnnotation, node);
        this.space();
        this.tokenChar(125);
      }
      function tokenIfPlusMinus(self2, tok) {
        if (tok !== true) {
          self2.token(tok);
        }
      }
      function TSLiteralType(node) {
        this.print(node.literal, node);
      }
      function TSExpressionWithTypeArguments(node) {
        this.print(node.expression, node);
        this.print(node.typeParameters, node);
      }
      function TSInterfaceDeclaration(node) {
        const {
          declare,
          id,
          typeParameters,
          extends: extendz,
          body
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        this.word("interface");
        this.space();
        this.print(id, node);
        this.print(typeParameters, node);
        if (extendz != null && extendz.length) {
          this.space();
          this.word("extends");
          this.space();
          this.printList(extendz, node);
        }
        this.space();
        this.print(body, node);
      }
      function TSInterfaceBody(node) {
        this.tsPrintTypeLiteralOrInterfaceBody(node.body, node);
      }
      function TSTypeAliasDeclaration(node) {
        const {
          declare,
          id,
          typeParameters,
          typeAnnotation
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        this.word("type");
        this.space();
        this.print(id, node);
        this.print(typeParameters, node);
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(typeAnnotation, node);
        this.tokenChar(59);
      }
      function TSTypeExpression(node) {
        var _expression$trailingC;
        const {
          type,
          expression,
          typeAnnotation
        } = node;
        const forceParens = !!((_expression$trailingC = expression.trailingComments) != null && _expression$trailingC.length);
        this.print(expression, node, true, void 0, forceParens);
        this.space();
        this.word(type === "TSAsExpression" ? "as" : "satisfies");
        this.space();
        this.print(typeAnnotation, node);
      }
      function TSTypeAssertion(node) {
        const {
          typeAnnotation,
          expression
        } = node;
        this.tokenChar(60);
        this.print(typeAnnotation, node);
        this.tokenChar(62);
        this.space();
        this.print(expression, node);
      }
      function TSInstantiationExpression(node) {
        this.print(node.expression, node);
        this.print(node.typeParameters, node);
      }
      function TSEnumDeclaration(node) {
        const {
          declare,
          const: isConst,
          id,
          members
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        if (isConst) {
          this.word("const");
          this.space();
        }
        this.word("enum");
        this.space();
        this.print(id, node);
        this.space();
        tsPrintBraced(this, members, node);
      }
      function TSEnumMember(node) {
        const {
          id,
          initializer
        } = node;
        this.print(id, node);
        if (initializer) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(initializer, node);
        }
        this.tokenChar(44);
      }
      function TSModuleDeclaration(node) {
        const {
          declare,
          id
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        if (!node.global) {
          this.word(id.type === "Identifier" ? "namespace" : "module");
          this.space();
        }
        this.print(id, node);
        if (!node.body) {
          this.tokenChar(59);
          return;
        }
        let body = node.body;
        while (body.type === "TSModuleDeclaration") {
          this.tokenChar(46);
          this.print(body.id, body);
          body = body.body;
        }
        this.space();
        this.print(body, node);
      }
      function TSModuleBlock(node) {
        tsPrintBraced(this, node.body, node);
      }
      function TSImportType(node) {
        const {
          argument,
          qualifier,
          typeParameters
        } = node;
        this.word("import");
        this.tokenChar(40);
        this.print(argument, node);
        this.tokenChar(41);
        if (qualifier) {
          this.tokenChar(46);
          this.print(qualifier, node);
        }
        if (typeParameters) {
          this.print(typeParameters, node);
        }
      }
      function TSImportEqualsDeclaration(node) {
        const {
          isExport,
          id,
          moduleReference
        } = node;
        if (isExport) {
          this.word("export");
          this.space();
        }
        this.word("import");
        this.space();
        this.print(id, node);
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(moduleReference, node);
        this.tokenChar(59);
      }
      function TSExternalModuleReference(node) {
        this.token("require(");
        this.print(node.expression, node);
        this.tokenChar(41);
      }
      function TSNonNullExpression(node) {
        this.print(node.expression, node);
        this.tokenChar(33);
      }
      function TSExportAssignment(node) {
        this.word("export");
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.expression, node);
        this.tokenChar(59);
      }
      function TSNamespaceExportDeclaration(node) {
        this.word("export");
        this.space();
        this.word("as");
        this.space();
        this.word("namespace");
        this.space();
        this.print(node.id, node);
      }
      function tsPrintSignatureDeclarationBase(node) {
        const {
          typeParameters
        } = node;
        const parameters = node.parameters;
        this.print(typeParameters, node);
        this.tokenChar(40);
        this._parameters(parameters, node);
        this.tokenChar(41);
        const returnType = node.typeAnnotation;
        this.print(returnType, node);
      }
      function tsPrintClassMemberModifiers(node) {
        const isField = node.type === "ClassAccessorProperty" || node.type === "ClassProperty";
        if (isField && node.declare) {
          this.word("declare");
          this.space();
        }
        if (node.accessibility) {
          this.word(node.accessibility);
          this.space();
        }
        if (node.static) {
          this.word("static");
          this.space();
        }
        if (node.override) {
          this.word("override");
          this.space();
        }
        if (node.abstract) {
          this.word("abstract");
          this.space();
        }
        if (isField && node.readonly) {
          this.word("readonly");
          this.space();
        }
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/index.js
  var require_generators = __commonJS({
    "node_modules/@babel/generator/lib/generators/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      var _templateLiterals = require_template_literals();
      Object.keys(_templateLiterals).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _templateLiterals[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _templateLiterals[key];
          }
        });
      });
      var _expressions = require_expressions();
      Object.keys(_expressions).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _expressions[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _expressions[key];
          }
        });
      });
      var _statements = require_statements();
      Object.keys(_statements).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _statements[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _statements[key];
          }
        });
      });
      var _classes = require_classes();
      Object.keys(_classes).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _classes[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _classes[key];
          }
        });
      });
      var _methods = require_methods();
      Object.keys(_methods).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _methods[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _methods[key];
          }
        });
      });
      var _modules = require_modules();
      Object.keys(_modules).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _modules[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _modules[key];
          }
        });
      });
      var _types = require_types2();
      Object.keys(_types).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _types[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _types[key];
          }
        });
      });
      var _flow = require_flow2();
      Object.keys(_flow).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _flow[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _flow[key];
          }
        });
      });
      var _base = require_base2();
      Object.keys(_base).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _base[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _base[key];
          }
        });
      });
      var _jsx = require_jsx2();
      Object.keys(_jsx).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _jsx[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _jsx[key];
          }
        });
      });
      var _typescript = require_typescript2();
      Object.keys(_typescript).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _typescript[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _typescript[key];
          }
        });
      });
    }
  });

  // node_modules/@babel/generator/lib/printer.js
  var require_printer = __commonJS({
    "node_modules/@babel/generator/lib/printer.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _buffer = require_buffer2();
      var n = require_node();
      var _t = require_lib5();
      var generatorFunctions = require_generators();
      var {
        isFunction: isFunction2,
        isStatement,
        isClassBody,
        isTSInterfaceBody
      } = _t;
      var SCIENTIFIC_NOTATION = /e/i;
      var ZERO_DECIMAL_INTEGER = /\.0+$/;
      var NON_DECIMAL_LITERAL = /^0[box]/;
      var PURE_ANNOTATION_RE = /^\s*[@#]__PURE__\s*$/;
      var HAS_NEWLINE = /[\n\r\u2028\u2029]/;
      var HAS_BlOCK_COMMENT_END = /\*\//;
      var {
        needsParens
      } = n;
      var Printer = class {
        constructor(format, map2) {
          this.inForStatementInitCounter = 0;
          this._printStack = [];
          this._indent = 0;
          this._indentChar = 0;
          this._indentRepeat = 0;
          this._insideAux = false;
          this._parenPushNewlineState = null;
          this._noLineTerminator = false;
          this._printAuxAfterOnNextUserNode = false;
          this._printedComments = /* @__PURE__ */ new Set();
          this._endsWithInteger = false;
          this._endsWithWord = false;
          this._lastCommentLine = 0;
          this._endsWithInnerRaw = false;
          this._indentInnerComments = true;
          this.format = format;
          this._buf = new _buffer.default(map2);
          this._indentChar = format.indent.style.charCodeAt(0);
          this._indentRepeat = format.indent.style.length;
        }
        generate(ast) {
          this.print(ast);
          this._maybeAddAuxComment();
          return this._buf.get();
        }
        indent() {
          if (this.format.compact || this.format.concise)
            return;
          this._indent++;
        }
        dedent() {
          if (this.format.compact || this.format.concise)
            return;
          this._indent--;
        }
        semicolon(force = false) {
          this._maybeAddAuxComment();
          if (force) {
            this._appendChar(59);
          } else {
            this._queue(59);
          }
          this._noLineTerminator = false;
        }
        rightBrace() {
          if (this.format.minified) {
            this._buf.removeLastSemicolon();
          }
          this.tokenChar(125);
        }
        space(force = false) {
          if (this.format.compact)
            return;
          if (force) {
            this._space();
          } else if (this._buf.hasContent()) {
            const lastCp = this.getLastChar();
            if (lastCp !== 32 && lastCp !== 10) {
              this._space();
            }
          }
        }
        word(str, noLineTerminatorAfter = false) {
          this._maybePrintInnerComments();
          if (this._endsWithWord || str.charCodeAt(0) === 47 && this.endsWith(47)) {
            this._space();
          }
          this._maybeAddAuxComment();
          this._append(str, false);
          this._endsWithWord = true;
          this._noLineTerminator = noLineTerminatorAfter;
        }
        number(str) {
          this.word(str);
          this._endsWithInteger = Number.isInteger(+str) && !NON_DECIMAL_LITERAL.test(str) && !SCIENTIFIC_NOTATION.test(str) && !ZERO_DECIMAL_INTEGER.test(str) && str.charCodeAt(str.length - 1) !== 46;
        }
        token(str, maybeNewline = false) {
          this._maybePrintInnerComments();
          const lastChar = this.getLastChar();
          const strFirst = str.charCodeAt(0);
          if (lastChar === 33 && str === "--" || strFirst === 43 && lastChar === 43 || strFirst === 45 && lastChar === 45 || strFirst === 46 && this._endsWithInteger) {
            this._space();
          }
          this._maybeAddAuxComment();
          this._append(str, maybeNewline);
          this._noLineTerminator = false;
        }
        tokenChar(char) {
          this._maybePrintInnerComments();
          const lastChar = this.getLastChar();
          if (char === 43 && lastChar === 43 || char === 45 && lastChar === 45 || char === 46 && this._endsWithInteger) {
            this._space();
          }
          this._maybeAddAuxComment();
          this._appendChar(char);
          this._noLineTerminator = false;
        }
        newline(i = 1, force) {
          if (i <= 0)
            return;
          if (!force) {
            if (this.format.retainLines || this.format.compact)
              return;
            if (this.format.concise) {
              this.space();
              return;
            }
          }
          if (i > 2)
            i = 2;
          i -= this._buf.getNewlineCount();
          for (let j = 0; j < i; j++) {
            this._newline();
          }
          return;
        }
        endsWith(char) {
          return this.getLastChar() === char;
        }
        getLastChar() {
          return this._buf.getLastChar();
        }
        endsWithCharAndNewline() {
          return this._buf.endsWithCharAndNewline();
        }
        removeTrailingNewline() {
          this._buf.removeTrailingNewline();
        }
        exactSource(loc, cb) {
          if (!loc)
            return cb();
          this._catchUp("start", loc);
          this._buf.exactSource(loc, cb);
        }
        source(prop, loc) {
          if (!loc)
            return;
          this._catchUp(prop, loc);
          this._buf.source(prop, loc);
        }
        sourceWithOffset(prop, loc, lineOffset, columnOffset) {
          if (!loc)
            return;
          this._catchUp(prop, loc);
          this._buf.sourceWithOffset(prop, loc, lineOffset, columnOffset);
        }
        withSource(prop, loc, cb) {
          if (!loc)
            return cb();
          this._catchUp(prop, loc);
          this._buf.withSource(prop, loc, cb);
        }
        _space() {
          this._queue(32);
        }
        _newline() {
          this._queue(10);
        }
        _append(str, maybeNewline) {
          this._maybeAddParen(str);
          this._maybeIndent(str.charCodeAt(0));
          this._buf.append(str, maybeNewline);
          this._endsWithWord = false;
          this._endsWithInteger = false;
        }
        _appendChar(char) {
          this._maybeAddParenChar(char);
          this._maybeIndent(char);
          this._buf.appendChar(char);
          this._endsWithWord = false;
          this._endsWithInteger = false;
        }
        _queue(char) {
          this._maybeAddParenChar(char);
          this._maybeIndent(char);
          this._buf.queue(char);
          this._endsWithWord = false;
          this._endsWithInteger = false;
        }
        _maybeIndent(firstChar) {
          if (this._indent && firstChar !== 10 && this.endsWith(10)) {
            this._buf.queueIndentation(this._indentChar, this._getIndent());
          }
        }
        _shouldIndent(firstChar) {
          if (this._indent && firstChar !== 10 && this.endsWith(10)) {
            return true;
          }
        }
        _maybeAddParenChar(char) {
          const parenPushNewlineState = this._parenPushNewlineState;
          if (!parenPushNewlineState)
            return;
          if (char === 32) {
            return;
          }
          if (char !== 10) {
            this._parenPushNewlineState = null;
            return;
          }
          this.tokenChar(40);
          this.indent();
          parenPushNewlineState.printed = true;
        }
        _maybeAddParen(str) {
          const parenPushNewlineState = this._parenPushNewlineState;
          if (!parenPushNewlineState)
            return;
          const len = str.length;
          let i;
          for (i = 0; i < len && str.charCodeAt(i) === 32; i++)
            continue;
          if (i === len) {
            return;
          }
          const cha = str.charCodeAt(i);
          if (cha !== 10) {
            if (cha !== 47 || i + 1 === len) {
              this._parenPushNewlineState = null;
              return;
            }
            const chaPost = str.charCodeAt(i + 1);
            if (chaPost === 42) {
              if (PURE_ANNOTATION_RE.test(str.slice(i + 2, len - 2))) {
                return;
              }
            } else if (chaPost !== 47) {
              this._parenPushNewlineState = null;
              return;
            }
          }
          this.tokenChar(40);
          this.indent();
          parenPushNewlineState.printed = true;
        }
        catchUp(line) {
          if (!this.format.retainLines)
            return;
          const count = line - this._buf.getCurrentLine();
          for (let i = 0; i < count; i++) {
            this._newline();
          }
        }
        _catchUp(prop, loc) {
          if (!this.format.retainLines)
            return;
          const pos = loc ? loc[prop] : null;
          if ((pos == null ? void 0 : pos.line) != null) {
            const count = pos.line - this._buf.getCurrentLine();
            for (let i = 0; i < count; i++) {
              this._newline();
            }
          }
        }
        _getIndent() {
          return this._indentRepeat * this._indent;
        }
        printTerminatorless(node, parent2, isLabel) {
          if (isLabel) {
            this._noLineTerminator = true;
            this.print(node, parent2);
          } else {
            const terminatorState = {
              printed: false
            };
            this._parenPushNewlineState = terminatorState;
            this.print(node, parent2);
            if (terminatorState.printed) {
              this.dedent();
              this.newline();
              this.tokenChar(41);
            }
          }
        }
        print(node, parent2, noLineTerminatorAfter, trailingCommentsLineOffset, forceParens) {
          if (!node)
            return;
          this._endsWithInnerRaw = false;
          const nodeType = node.type;
          const format = this.format;
          const oldConcise = format.concise;
          if (node._compact) {
            format.concise = true;
          }
          const printMethod = this[nodeType];
          if (printMethod === void 0) {
            throw new ReferenceError(`unknown node of type ${JSON.stringify(nodeType)} with constructor ${JSON.stringify(node.constructor.name)}`);
          }
          this._printStack.push(node);
          const oldInAux = this._insideAux;
          this._insideAux = node.loc == void 0;
          this._maybeAddAuxComment(this._insideAux && !oldInAux);
          let shouldPrintParens = false;
          if (forceParens) {
            shouldPrintParens = true;
          } else if (format.retainFunctionParens && nodeType === "FunctionExpression" && node.extra && node.extra.parenthesized) {
            shouldPrintParens = true;
          } else {
            shouldPrintParens = needsParens(node, parent2, this._printStack);
          }
          if (shouldPrintParens) {
            this.tokenChar(40);
            this._endsWithInnerRaw = false;
          }
          this._lastCommentLine = 0;
          this._printLeadingComments(node, parent2);
          const loc = nodeType === "Program" || nodeType === "File" ? null : node.loc;
          this.exactSource(loc, printMethod.bind(this, node, parent2));
          if (shouldPrintParens) {
            this._printTrailingComments(node, parent2);
            this.tokenChar(41);
            this._noLineTerminator = noLineTerminatorAfter;
          } else if (noLineTerminatorAfter && !this._noLineTerminator) {
            this._noLineTerminator = true;
            this._printTrailingComments(node, parent2);
          } else {
            this._printTrailingComments(node, parent2, trailingCommentsLineOffset);
          }
          this._printStack.pop();
          format.concise = oldConcise;
          this._insideAux = oldInAux;
          this._endsWithInnerRaw = false;
        }
        _maybeAddAuxComment(enteredPositionlessNode) {
          if (enteredPositionlessNode)
            this._printAuxBeforeComment();
          if (!this._insideAux)
            this._printAuxAfterComment();
        }
        _printAuxBeforeComment() {
          if (this._printAuxAfterOnNextUserNode)
            return;
          this._printAuxAfterOnNextUserNode = true;
          const comment = this.format.auxiliaryCommentBefore;
          if (comment) {
            this._printComment({
              type: "CommentBlock",
              value: comment
            }, 0);
          }
        }
        _printAuxAfterComment() {
          if (!this._printAuxAfterOnNextUserNode)
            return;
          this._printAuxAfterOnNextUserNode = false;
          const comment = this.format.auxiliaryCommentAfter;
          if (comment) {
            this._printComment({
              type: "CommentBlock",
              value: comment
            }, 0);
          }
        }
        getPossibleRaw(node) {
          const extra = node.extra;
          if (extra && extra.raw != null && extra.rawValue != null && node.value === extra.rawValue) {
            return extra.raw;
          }
        }
        printJoin(nodes, parent2, opts = {}) {
          if (!(nodes != null && nodes.length))
            return;
          if (opts.indent)
            this.indent();
          const newlineOpts = {
            addNewlines: opts.addNewlines,
            nextNodeStartLine: 0
          };
          const separator = opts.separator ? opts.separator.bind(this) : null;
          const len = nodes.length;
          for (let i = 0; i < len; i++) {
            const node = nodes[i];
            if (!node)
              continue;
            if (opts.statement)
              this._printNewline(i === 0, newlineOpts);
            this.print(node, parent2, void 0, opts.trailingCommentsLineOffset || 0);
            opts.iterator == null ? void 0 : opts.iterator(node, i);
            if (i < len - 1)
              separator == null ? void 0 : separator();
            if (opts.statement) {
              if (i + 1 === len) {
                this.newline(1);
              } else {
                var _nextNode$loc;
                const nextNode = nodes[i + 1];
                newlineOpts.nextNodeStartLine = ((_nextNode$loc = nextNode.loc) == null ? void 0 : _nextNode$loc.start.line) || 0;
                this._printNewline(true, newlineOpts);
              }
            }
          }
          if (opts.indent)
            this.dedent();
        }
        printAndIndentOnComments(node, parent2) {
          const indent = node.leadingComments && node.leadingComments.length > 0;
          if (indent)
            this.indent();
          this.print(node, parent2);
          if (indent)
            this.dedent();
        }
        printBlock(parent2) {
          const node = parent2.body;
          if (node.type !== "EmptyStatement") {
            this.space();
          }
          this.print(node, parent2);
        }
        _printTrailingComments(node, parent2, lineOffset) {
          const {
            innerComments,
            trailingComments
          } = node;
          if (innerComments != null && innerComments.length) {
            this._printComments(2, innerComments, node, parent2, lineOffset);
          }
          if (trailingComments != null && trailingComments.length) {
            this._printComments(2, trailingComments, node, parent2, lineOffset);
          }
        }
        _printLeadingComments(node, parent2) {
          const comments = node.leadingComments;
          if (!(comments != null && comments.length))
            return;
          this._printComments(0, comments, node, parent2);
        }
        _maybePrintInnerComments() {
          if (this._endsWithInnerRaw)
            this.printInnerComments();
          this._endsWithInnerRaw = true;
          this._indentInnerComments = true;
        }
        printInnerComments() {
          const node = this._printStack[this._printStack.length - 1];
          const comments = node.innerComments;
          if (!(comments != null && comments.length))
            return;
          const hasSpace = this.endsWith(32);
          const indent = this._indentInnerComments;
          const printedCommentsCount = this._printedComments.size;
          if (indent)
            this.indent();
          this._printComments(1, comments, node);
          if (hasSpace && printedCommentsCount !== this._printedComments.size) {
            this.space();
          }
          if (indent)
            this.dedent();
        }
        noIndentInnerCommentsHere() {
          this._indentInnerComments = false;
        }
        printSequence(nodes, parent2, opts = {}) {
          opts.statement = true;
          return this.printJoin(nodes, parent2, opts);
        }
        printList(items, parent2, opts = {}) {
          if (opts.separator == null) {
            opts.separator = commaSeparator;
          }
          return this.printJoin(items, parent2, opts);
        }
        _printNewline(newLine, opts) {
          if (this.format.retainLines || this.format.compact)
            return;
          if (this.format.concise) {
            this.space();
            return;
          }
          if (!newLine) {
            return;
          }
          const startLine = opts.nextNodeStartLine;
          const lastCommentLine = this._lastCommentLine;
          if (startLine > 0 && lastCommentLine > 0) {
            const offset = startLine - lastCommentLine;
            if (offset >= 0) {
              this.newline(offset || 1);
              return;
            }
          }
          if (this._buf.hasContent()) {
            this.newline(1);
          }
        }
        _shouldPrintComment(comment) {
          if (comment.ignore)
            return 0;
          if (this._printedComments.has(comment))
            return 0;
          if (this._noLineTerminator && (HAS_NEWLINE.test(comment.value) || HAS_BlOCK_COMMENT_END.test(comment.value))) {
            return 2;
          }
          this._printedComments.add(comment);
          if (!this.format.shouldPrintComment(comment.value)) {
            return 0;
          }
          return 1;
        }
        _printComment(comment, skipNewLines) {
          const noLineTerminator = this._noLineTerminator;
          const isBlockComment = comment.type === "CommentBlock";
          const printNewLines = isBlockComment && skipNewLines !== 1 && !this._noLineTerminator;
          if (printNewLines && this._buf.hasContent() && skipNewLines !== 2) {
            this.newline(1);
          }
          const lastCharCode = this.getLastChar();
          if (lastCharCode !== 91 && lastCharCode !== 123) {
            this.space();
          }
          let val;
          if (isBlockComment) {
            val = `/*${comment.value}*/`;
            if (this.format.indent.adjustMultilineComment) {
              var _comment$loc;
              const offset = (_comment$loc = comment.loc) == null ? void 0 : _comment$loc.start.column;
              if (offset) {
                const newlineRegex = new RegExp("\\n\\s{1," + offset + "}", "g");
                val = val.replace(newlineRegex, "\n");
              }
              let indentSize = this.format.retainLines ? 0 : this._buf.getCurrentColumn();
              if (this._shouldIndent(47) || this.format.retainLines) {
                indentSize += this._getIndent();
              }
              val = val.replace(/\n(?!$)/g, `
${" ".repeat(indentSize)}`);
            }
          } else if (!noLineTerminator) {
            val = `//${comment.value}`;
          } else {
            val = `/*${comment.value}*/`;
          }
          if (this.endsWith(47))
            this._space();
          this.source("start", comment.loc);
          this._append(val, isBlockComment);
          if (!isBlockComment && !noLineTerminator) {
            this.newline(1, true);
          }
          if (printNewLines && skipNewLines !== 3) {
            this.newline(1);
          }
        }
        _printComments(type, comments, node, parent2, lineOffset = 0) {
          const nodeLoc = node.loc;
          const len = comments.length;
          let hasLoc = !!nodeLoc;
          const nodeStartLine = hasLoc ? nodeLoc.start.line : 0;
          const nodeEndLine = hasLoc ? nodeLoc.end.line : 0;
          let lastLine = 0;
          let leadingCommentNewline = 0;
          const maybeNewline = this._noLineTerminator ? function() {
          } : this.newline.bind(this);
          for (let i = 0; i < len; i++) {
            const comment = comments[i];
            const shouldPrint = this._shouldPrintComment(comment);
            if (shouldPrint === 2) {
              hasLoc = false;
              break;
            }
            if (hasLoc && comment.loc && shouldPrint === 1) {
              const commentStartLine = comment.loc.start.line;
              const commentEndLine = comment.loc.end.line;
              if (type === 0) {
                let offset = 0;
                if (i === 0) {
                  if (this._buf.hasContent() && (comment.type === "CommentLine" || commentStartLine != commentEndLine)) {
                    offset = leadingCommentNewline = 1;
                  }
                } else {
                  offset = commentStartLine - lastLine;
                }
                lastLine = commentEndLine;
                maybeNewline(offset);
                this._printComment(comment, 1);
                if (i + 1 === len) {
                  maybeNewline(Math.max(nodeStartLine - lastLine, leadingCommentNewline));
                  lastLine = nodeStartLine;
                }
              } else if (type === 1) {
                const offset = commentStartLine - (i === 0 ? nodeStartLine : lastLine);
                lastLine = commentEndLine;
                maybeNewline(offset);
                this._printComment(comment, 1);
                if (i + 1 === len) {
                  maybeNewline(Math.min(1, nodeEndLine - lastLine));
                  lastLine = nodeEndLine;
                }
              } else {
                const offset = commentStartLine - (i === 0 ? nodeEndLine - lineOffset : lastLine);
                lastLine = commentEndLine;
                maybeNewline(offset);
                this._printComment(comment, 1);
              }
            } else {
              hasLoc = false;
              if (shouldPrint !== 1) {
                continue;
              }
              if (len === 1) {
                const singleLine = comment.loc ? comment.loc.start.line === comment.loc.end.line : !HAS_NEWLINE.test(comment.value);
                const shouldSkipNewline = singleLine && !isStatement(node) && !isClassBody(parent2) && !isTSInterfaceBody(parent2);
                if (type === 0) {
                  this._printComment(comment, shouldSkipNewline && node.type !== "ObjectExpression" || singleLine && isFunction2(parent2, {
                    body: node
                  }) ? 1 : 0);
                } else if (shouldSkipNewline && type === 2) {
                  this._printComment(comment, 1);
                } else {
                  this._printComment(comment, 0);
                }
              } else if (type === 1 && !(node.type === "ObjectExpression" && node.properties.length > 1) && node.type !== "ClassBody" && node.type !== "TSInterfaceBody") {
                this._printComment(comment, i === 0 ? 2 : i === len - 1 ? 3 : 0);
              } else {
                this._printComment(comment, 0);
              }
            }
          }
          if (type === 2 && hasLoc && lastLine) {
            this._lastCommentLine = lastLine;
          }
        }
      };
      Object.assign(Printer.prototype, generatorFunctions);
      {
        Printer.prototype.Noop = function Noop() {
        };
      }
      var _default = Printer;
      exports2.default = _default;
      function commaSeparator() {
        this.tokenChar(44);
        this.space();
      }
    }
  });

  // node_modules/@babel/generator/lib/index.js
  var require_lib6 = __commonJS({
    "node_modules/@babel/generator/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.CodeGenerator = void 0;
      exports2.default = generate4;
      var _sourceMap = require_source_map2();
      var _printer = require_printer();
      var Generator = class extends _printer.default {
        constructor(ast, opts = {}, code) {
          const format = normalizeOptions(code, opts);
          const map2 = opts.sourceMaps ? new _sourceMap.default(opts, code) : null;
          super(format, map2);
          this.ast = void 0;
          this.ast = ast;
        }
        generate() {
          return super.generate(this.ast);
        }
      };
      function normalizeOptions(code, opts) {
        const format = {
          auxiliaryCommentBefore: opts.auxiliaryCommentBefore,
          auxiliaryCommentAfter: opts.auxiliaryCommentAfter,
          shouldPrintComment: opts.shouldPrintComment,
          retainLines: opts.retainLines,
          retainFunctionParens: opts.retainFunctionParens,
          comments: opts.comments == null || opts.comments,
          compact: opts.compact,
          minified: opts.minified,
          concise: opts.concise,
          indent: {
            adjustMultilineComment: true,
            style: "  "
          },
          jsescOption: Object.assign({
            quotes: "double",
            wrap: true,
            minimal: false
          }, opts.jsescOption),
          recordAndTupleSyntaxType: opts.recordAndTupleSyntaxType,
          topicToken: opts.topicToken
        };
        {
          format.decoratorsBeforeExport = !!opts.decoratorsBeforeExport;
          format.jsonCompatibleStrings = opts.jsonCompatibleStrings;
        }
        if (format.minified) {
          format.compact = true;
          format.shouldPrintComment = format.shouldPrintComment || (() => format.comments);
        } else {
          format.shouldPrintComment = format.shouldPrintComment || ((value) => format.comments || value.includes("@license") || value.includes("@preserve"));
        }
        if (format.compact === "auto") {
          format.compact = code.length > 5e5;
          if (format.compact) {
            console.error(`[BABEL] Note: The code generator has deoptimised the styling of ${opts.filename} as it exceeds the max of ${"500KB"}.`);
          }
        }
        if (format.compact) {
          format.indent.adjustMultilineComment = false;
        }
        const {
          auxiliaryCommentBefore,
          auxiliaryCommentAfter,
          shouldPrintComment
        } = format;
        if (auxiliaryCommentBefore && !shouldPrintComment(auxiliaryCommentBefore)) {
          format.auxiliaryCommentBefore = void 0;
        }
        if (auxiliaryCommentAfter && !shouldPrintComment(auxiliaryCommentAfter)) {
          format.auxiliaryCommentAfter = void 0;
        }
        return format;
      }
      var CodeGenerator = class {
        constructor(ast, opts, code) {
          this._generator = void 0;
          this._generator = new Generator(ast, opts, code);
        }
        generate() {
          return this._generator.generate();
        }
      };
      exports2.CodeGenerator = CodeGenerator;
      function generate4(ast, opts, code) {
        const gen = new Generator(ast, opts, code);
        return gen.generate();
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/lib/virtual-types.js
  var require_virtual_types = __commonJS({
    "node_modules/@babel/traverse/lib/path/lib/virtual-types.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.Var = exports2.User = exports2.Statement = exports2.SpreadProperty = exports2.Scope = exports2.RestProperty = exports2.ReferencedMemberExpression = exports2.ReferencedIdentifier = exports2.Referenced = exports2.Pure = exports2.NumericLiteralTypeAnnotation = exports2.Generated = exports2.ForAwaitStatement = exports2.Flow = exports2.Expression = exports2.ExistentialTypeParam = exports2.BlockScoped = exports2.BindingIdentifier = void 0;
      var ReferencedIdentifier = ["Identifier", "JSXIdentifier"];
      exports2.ReferencedIdentifier = ReferencedIdentifier;
      var ReferencedMemberExpression = ["MemberExpression"];
      exports2.ReferencedMemberExpression = ReferencedMemberExpression;
      var BindingIdentifier = ["Identifier"];
      exports2.BindingIdentifier = BindingIdentifier;
      var Statement = ["Statement"];
      exports2.Statement = Statement;
      var Expression = ["Expression"];
      exports2.Expression = Expression;
      var Scope2 = ["Scopable", "Pattern"];
      exports2.Scope = Scope2;
      var Referenced = null;
      exports2.Referenced = Referenced;
      var BlockScoped = null;
      exports2.BlockScoped = BlockScoped;
      var Var = ["VariableDeclaration"];
      exports2.Var = Var;
      var User = null;
      exports2.User = User;
      var Generated = null;
      exports2.Generated = Generated;
      var Pure = null;
      exports2.Pure = Pure;
      var Flow = ["Flow", "ImportDeclaration", "ExportDeclaration", "ImportSpecifier"];
      exports2.Flow = Flow;
      var RestProperty = ["RestElement"];
      exports2.RestProperty = RestProperty;
      var SpreadProperty = ["RestElement"];
      exports2.SpreadProperty = SpreadProperty;
      var ExistentialTypeParam = ["ExistsTypeAnnotation"];
      exports2.ExistentialTypeParam = ExistentialTypeParam;
      var NumericLiteralTypeAnnotation = ["NumberLiteralTypeAnnotation"];
      exports2.NumericLiteralTypeAnnotation = NumericLiteralTypeAnnotation;
      var ForAwaitStatement = ["ForOfStatement"];
      exports2.ForAwaitStatement = ForAwaitStatement;
    }
  });

  // node_modules/@babel/traverse/lib/visitors.js
  var require_visitors = __commonJS({
    "node_modules/@babel/traverse/lib/visitors.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.explode = explode;
      exports2.merge = merge2;
      exports2.verify = verify;
      var virtualTypes = require_virtual_types();
      var _t = require_lib5();
      var {
        DEPRECATED_KEYS,
        FLIPPED_ALIAS_KEYS,
        TYPES
      } = _t;
      function isVirtualType(type) {
        return type in virtualTypes;
      }
      function explode(visitor) {
        if (visitor._exploded)
          return visitor;
        visitor._exploded = true;
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          const parts = nodeType.split("|");
          if (parts.length === 1)
            continue;
          const fns = visitor[nodeType];
          delete visitor[nodeType];
          for (const part of parts) {
            visitor[part] = fns;
          }
        }
        verify(visitor);
        delete visitor.__esModule;
        ensureEntranceObjects(visitor);
        ensureCallbackArrays(visitor);
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          if (!isVirtualType(nodeType))
            continue;
          const fns = visitor[nodeType];
          for (const type of Object.keys(fns)) {
            fns[type] = wrapCheck(nodeType, fns[type]);
          }
          delete visitor[nodeType];
          const types = virtualTypes[nodeType];
          if (types !== null) {
            for (const type of types) {
              if (visitor[type]) {
                mergePair(visitor[type], fns);
              } else {
                visitor[type] = fns;
              }
            }
          } else {
            mergePair(visitor, fns);
          }
        }
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          const fns = visitor[nodeType];
          let aliases = FLIPPED_ALIAS_KEYS[nodeType];
          const deprecatedKey = DEPRECATED_KEYS[nodeType];
          if (deprecatedKey) {
            console.trace(`Visitor defined for ${nodeType} but it has been renamed to ${deprecatedKey}`);
            aliases = [deprecatedKey];
          }
          if (!aliases)
            continue;
          delete visitor[nodeType];
          for (const alias of aliases) {
            const existing = visitor[alias];
            if (existing) {
              mergePair(existing, fns);
            } else {
              visitor[alias] = Object.assign({}, fns);
            }
          }
        }
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          ensureCallbackArrays(
            visitor[nodeType]
          );
        }
        return visitor;
      }
      function verify(visitor) {
        if (visitor._verified)
          return;
        if (typeof visitor === "function") {
          throw new Error("You passed `traverse()` a function when it expected a visitor object, are you sure you didn't mean `{ enter: Function }`?");
        }
        for (const nodeType of Object.keys(visitor)) {
          if (nodeType === "enter" || nodeType === "exit") {
            validateVisitorMethods(nodeType, visitor[nodeType]);
          }
          if (shouldIgnoreKey(nodeType))
            continue;
          if (TYPES.indexOf(nodeType) < 0) {
            throw new Error(`You gave us a visitor for the node type ${nodeType} but it's not a valid type`);
          }
          const visitors = visitor[nodeType];
          if (typeof visitors === "object") {
            for (const visitorKey of Object.keys(visitors)) {
              if (visitorKey === "enter" || visitorKey === "exit") {
                validateVisitorMethods(`${nodeType}.${visitorKey}`, visitors[visitorKey]);
              } else {
                throw new Error(`You passed \`traverse()\` a visitor object with the property ${nodeType} that has the invalid property ${visitorKey}`);
              }
            }
          }
        }
        visitor._verified = true;
      }
      function validateVisitorMethods(path, val) {
        const fns = [].concat(val);
        for (const fn of fns) {
          if (typeof fn !== "function") {
            throw new TypeError(`Non-function found defined in ${path} with type ${typeof fn}`);
          }
        }
      }
      function merge2(visitors, states = [], wrapper) {
        const rootVisitor = {};
        for (let i = 0; i < visitors.length; i++) {
          const visitor = visitors[i];
          const state = states[i];
          explode(visitor);
          for (const type of Object.keys(visitor)) {
            let visitorType = visitor[type];
            if (state || wrapper) {
              visitorType = wrapWithStateOrWrapper(visitorType, state, wrapper);
            }
            const nodeVisitor = rootVisitor[type] || (rootVisitor[type] = {});
            mergePair(nodeVisitor, visitorType);
          }
        }
        return rootVisitor;
      }
      function wrapWithStateOrWrapper(oldVisitor, state, wrapper) {
        const newVisitor = {};
        for (const key of Object.keys(oldVisitor)) {
          let fns = oldVisitor[key];
          if (!Array.isArray(fns))
            continue;
          fns = fns.map(function(fn) {
            let newFn = fn;
            if (state) {
              newFn = function(path) {
                return fn.call(state, path, state);
              };
            }
            if (wrapper) {
              newFn = wrapper(state.key, key, newFn);
            }
            if (newFn !== fn) {
              newFn.toString = () => fn.toString();
            }
            return newFn;
          });
          newVisitor[key] = fns;
        }
        return newVisitor;
      }
      function ensureEntranceObjects(obj) {
        for (const key of Object.keys(obj)) {
          if (shouldIgnoreKey(key))
            continue;
          const fns = obj[key];
          if (typeof fns === "function") {
            obj[key] = {
              enter: fns
            };
          }
        }
      }
      function ensureCallbackArrays(obj) {
        if (obj.enter && !Array.isArray(obj.enter))
          obj.enter = [obj.enter];
        if (obj.exit && !Array.isArray(obj.exit))
          obj.exit = [obj.exit];
      }
      function wrapCheck(nodeType, fn) {
        const newFn = function(path) {
          if (path[`is${nodeType}`]()) {
            return fn.apply(this, arguments);
          }
        };
        newFn.toString = () => fn.toString();
        return newFn;
      }
      function shouldIgnoreKey(key) {
        if (key[0] === "_")
          return true;
        if (key === "enter" || key === "exit" || key === "shouldSkip")
          return true;
        if (key === "denylist" || key === "noScope" || key === "skipKeys" || key === "blacklist") {
          return true;
        }
        return false;
      }
      function mergePair(dest, src) {
        for (const key of Object.keys(src)) {
          dest[key] = [].concat(dest[key] || [], src[key]);
        }
      }
    }
  });

  // node_modules/@babel/traverse/lib/cache.js
  var require_cache2 = __commonJS({
    "node_modules/@babel/traverse/lib/cache.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.clear = clear;
      exports2.clearPath = clearPath;
      exports2.clearScope = clearScope;
      exports2.scope = exports2.path = void 0;
      var path = /* @__PURE__ */ new WeakMap();
      exports2.path = path;
      var scope = /* @__PURE__ */ new WeakMap();
      exports2.scope = scope;
      function clear() {
        clearPath();
        clearScope();
      }
      function clearPath() {
        exports2.path = path = /* @__PURE__ */ new WeakMap();
      }
      function clearScope() {
        exports2.scope = scope = /* @__PURE__ */ new WeakMap();
      }
    }
  });

  // node_modules/ms/index.js
  var require_ms2 = __commonJS({
    "node_modules/ms/index.js"(exports2, module2) {
      init_define_process();
      var s = 1e3;
      var m = s * 60;
      var h = m * 60;
      var d = h * 24;
      var w = d * 7;
      var y = d * 365.25;
      module2.exports = function(val, options) {
        options = options || {};
        var type = typeof val;
        if (type === "string" && val.length > 0) {
          return parse3(val);
        } else if (type === "number" && isFinite(val)) {
          return options.long ? fmtLong(val) : fmtShort(val);
        }
        throw new Error(
          "val is not a non-empty string or a valid number. val=" + JSON.stringify(val)
        );
      };
      function parse3(str) {
        str = String(str);
        if (str.length > 100) {
          return;
        }
        var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
          str
        );
        if (!match) {
          return;
        }
        var n = parseFloat(match[1]);
        var type = (match[2] || "ms").toLowerCase();
        switch (type) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return n * y;
          case "weeks":
          case "week":
          case "w":
            return n * w;
          case "days":
          case "day":
          case "d":
            return n * d;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return n * h;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return n * m;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return n * s;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return n;
          default:
            return void 0;
        }
      }
      function fmtShort(ms) {
        var msAbs = Math.abs(ms);
        if (msAbs >= d) {
          return Math.round(ms / d) + "d";
        }
        if (msAbs >= h) {
          return Math.round(ms / h) + "h";
        }
        if (msAbs >= m) {
          return Math.round(ms / m) + "m";
        }
        if (msAbs >= s) {
          return Math.round(ms / s) + "s";
        }
        return ms + "ms";
      }
      function fmtLong(ms) {
        var msAbs = Math.abs(ms);
        if (msAbs >= d) {
          return plural(ms, msAbs, d, "day");
        }
        if (msAbs >= h) {
          return plural(ms, msAbs, h, "hour");
        }
        if (msAbs >= m) {
          return plural(ms, msAbs, m, "minute");
        }
        if (msAbs >= s) {
          return plural(ms, msAbs, s, "second");
        }
        return ms + " ms";
      }
      function plural(ms, msAbs, n, name) {
        var isPlural = msAbs >= n * 1.5;
        return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
      }
    }
  });

  // node_modules/debug/src/common.js
  var require_common = __commonJS({
    "node_modules/debug/src/common.js"(exports2, module2) {
      init_define_process();
      function setup(env) {
        createDebug2.debug = createDebug2;
        createDebug2.default = createDebug2;
        createDebug2.coerce = coerce;
        createDebug2.disable = disable;
        createDebug2.enable = enable;
        createDebug2.enabled = enabled;
        createDebug2.humanize = require_ms2();
        createDebug2.destroy = destroy;
        Object.keys(env).forEach((key) => {
          createDebug2[key] = env[key];
        });
        createDebug2.names = [];
        createDebug2.skips = [];
        createDebug2.formatters = {};
        function selectColor(namespace) {
          let hash = 0;
          for (let i = 0; i < namespace.length; i++) {
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0;
          }
          return createDebug2.colors[Math.abs(hash) % createDebug2.colors.length];
        }
        createDebug2.selectColor = selectColor;
        function createDebug2(namespace) {
          let prevTime;
          let enableOverride = null;
          let namespacesCache;
          let enabledCache;
          function debug2(...args) {
            if (!debug2.enabled) {
              return;
            }
            const self2 = debug2;
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self2.diff = ms;
            self2.prev = prevTime;
            self2.curr = curr;
            prevTime = curr;
            args[0] = createDebug2.coerce(args[0]);
            if (typeof args[0] !== "string") {
              args.unshift("%O");
            }
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
              if (match === "%%") {
                return "%";
              }
              index++;
              const formatter = createDebug2.formatters[format];
              if (typeof formatter === "function") {
                const val = args[index];
                match = formatter.call(self2, val);
                args.splice(index, 1);
                index--;
              }
              return match;
            });
            createDebug2.formatArgs.call(self2, args);
            const logFn = self2.log || createDebug2.log;
            logFn.apply(self2, args);
          }
          debug2.namespace = namespace;
          debug2.useColors = createDebug2.useColors();
          debug2.color = createDebug2.selectColor(namespace);
          debug2.extend = extend;
          debug2.destroy = createDebug2.destroy;
          Object.defineProperty(debug2, "enabled", {
            enumerable: true,
            configurable: false,
            get: () => {
              if (enableOverride !== null) {
                return enableOverride;
              }
              if (namespacesCache !== createDebug2.namespaces) {
                namespacesCache = createDebug2.namespaces;
                enabledCache = createDebug2.enabled(namespace);
              }
              return enabledCache;
            },
            set: (v) => {
              enableOverride = v;
            }
          });
          if (typeof createDebug2.init === "function") {
            createDebug2.init(debug2);
          }
          return debug2;
        }
        function extend(namespace, delimiter) {
          const newDebug = createDebug2(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
          newDebug.log = this.log;
          return newDebug;
        }
        function enable(namespaces) {
          createDebug2.save(namespaces);
          createDebug2.namespaces = namespaces;
          createDebug2.names = [];
          createDebug2.skips = [];
          let i;
          const split2 = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
          const len = split2.length;
          for (i = 0; i < len; i++) {
            if (!split2[i]) {
              continue;
            }
            namespaces = split2[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") {
              createDebug2.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            } else {
              createDebug2.names.push(new RegExp("^" + namespaces + "$"));
            }
          }
        }
        function disable() {
          const namespaces = [
            ...createDebug2.names.map(toNamespace),
            ...createDebug2.skips.map(toNamespace).map((namespace) => "-" + namespace)
          ].join(",");
          createDebug2.enable("");
          return namespaces;
        }
        function enabled(name) {
          if (name[name.length - 1] === "*") {
            return true;
          }
          let i;
          let len;
          for (i = 0, len = createDebug2.skips.length; i < len; i++) {
            if (createDebug2.skips[i].test(name)) {
              return false;
            }
          }
          for (i = 0, len = createDebug2.names.length; i < len; i++) {
            if (createDebug2.names[i].test(name)) {
              return true;
            }
          }
          return false;
        }
        function toNamespace(regexp) {
          return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
        }
        function coerce(val) {
          if (val instanceof Error) {
            return val.stack || val.message;
          }
          return val;
        }
        function destroy() {
          console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
        createDebug2.enable(createDebug2.load());
        return createDebug2;
      }
      module2.exports = setup;
    }
  });

  // node_modules/debug/src/browser.js
  var require_browser2 = __commonJS({
    "node_modules/debug/src/browser.js"(exports2, module2) {
      init_define_process();
      exports2.formatArgs = formatArgs;
      exports2.save = save;
      exports2.load = load;
      exports2.useColors = useColors;
      exports2.storage = localstorage();
      exports2.destroy = (() => {
        let warned = false;
        return () => {
          if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
          }
        };
      })();
      exports2.colors = [
        "#0000CC",
        "#0000FF",
        "#0033CC",
        "#0033FF",
        "#0066CC",
        "#0066FF",
        "#0099CC",
        "#0099FF",
        "#00CC00",
        "#00CC33",
        "#00CC66",
        "#00CC99",
        "#00CCCC",
        "#00CCFF",
        "#3300CC",
        "#3300FF",
        "#3333CC",
        "#3333FF",
        "#3366CC",
        "#3366FF",
        "#3399CC",
        "#3399FF",
        "#33CC00",
        "#33CC33",
        "#33CC66",
        "#33CC99",
        "#33CCCC",
        "#33CCFF",
        "#6600CC",
        "#6600FF",
        "#6633CC",
        "#6633FF",
        "#66CC00",
        "#66CC33",
        "#9900CC",
        "#9900FF",
        "#9933CC",
        "#9933FF",
        "#99CC00",
        "#99CC33",
        "#CC0000",
        "#CC0033",
        "#CC0066",
        "#CC0099",
        "#CC00CC",
        "#CC00FF",
        "#CC3300",
        "#CC3333",
        "#CC3366",
        "#CC3399",
        "#CC33CC",
        "#CC33FF",
        "#CC6600",
        "#CC6633",
        "#CC9900",
        "#CC9933",
        "#CCCC00",
        "#CCCC33",
        "#FF0000",
        "#FF0033",
        "#FF0066",
        "#FF0099",
        "#FF00CC",
        "#FF00FF",
        "#FF3300",
        "#FF3333",
        "#FF3366",
        "#FF3399",
        "#FF33CC",
        "#FF33FF",
        "#FF6600",
        "#FF6633",
        "#FF9900",
        "#FF9933",
        "#FFCC00",
        "#FFCC33"
      ];
      function useColors() {
        if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) {
          return true;
        }
        if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
          return false;
        }
        return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }
      function formatArgs(args) {
        args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module2.exports.humanize(this.diff);
        if (!this.useColors) {
          return;
        }
        const c = "color: " + this.color;
        args.splice(1, 0, c, "color: inherit");
        let index = 0;
        let lastC = 0;
        args[0].replace(/%[a-zA-Z%]/g, (match) => {
          if (match === "%%") {
            return;
          }
          index++;
          if (match === "%c") {
            lastC = index;
          }
        });
        args.splice(lastC, 0, c);
      }
      exports2.log = console.debug || console.log || (() => {
      });
      function save(namespaces) {
        try {
          if (namespaces) {
            exports2.storage.setItem("debug", namespaces);
          } else {
            exports2.storage.removeItem("debug");
          }
        } catch (error) {
        }
      }
      function load() {
        let r;
        try {
          r = exports2.storage.getItem("debug");
        } catch (error) {
        }
        if (!r && typeof define_process_default !== "undefined" && "env" in define_process_default) {
          r = define_process_default.env.DEBUG;
        }
        return r;
      }
      function localstorage() {
        try {
          return localStorage;
        } catch (error) {
        }
      }
      module2.exports = require_common()(exports2);
      var { formatters } = module2.exports;
      formatters.j = function(v) {
        try {
          return JSON.stringify(v);
        } catch (error) {
          return "[UnexpectedJSONParseError]: " + error.message;
        }
      };
    }
  });

  // node_modules/@babel/helper-split-export-declaration/lib/index.js
  var require_lib7 = __commonJS({
    "node_modules/@babel/helper-split-export-declaration/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = splitExportDeclaration;
      var _t = require_lib5();
      var {
        cloneNode,
        exportNamedDeclaration,
        exportSpecifier,
        identifier: identifier3,
        variableDeclaration,
        variableDeclarator
      } = _t;
      function splitExportDeclaration(exportDeclaration) {
        if (!exportDeclaration.isExportDeclaration() || exportDeclaration.isExportAllDeclaration()) {
          throw new Error("Only default and named export declarations can be split.");
        }
        if (exportDeclaration.isExportDefaultDeclaration()) {
          const declaration2 = exportDeclaration.get("declaration");
          const standaloneDeclaration = declaration2.isFunctionDeclaration() || declaration2.isClassDeclaration();
          const scope = declaration2.isScope() ? declaration2.scope.parent : declaration2.scope;
          let id = declaration2.node.id;
          let needBindingRegistration = false;
          if (!id) {
            needBindingRegistration = true;
            id = scope.generateUidIdentifier("default");
            if (standaloneDeclaration || declaration2.isFunctionExpression() || declaration2.isClassExpression()) {
              declaration2.node.id = cloneNode(id);
            }
          }
          const updatedDeclaration = standaloneDeclaration ? declaration2.node : variableDeclaration("var", [variableDeclarator(cloneNode(id), declaration2.node)]);
          const updatedExportDeclaration = exportNamedDeclaration(null, [exportSpecifier(cloneNode(id), identifier3("default"))]);
          exportDeclaration.insertAfter(updatedExportDeclaration);
          exportDeclaration.replaceWith(updatedDeclaration);
          if (needBindingRegistration) {
            scope.registerDeclaration(exportDeclaration);
          }
          return exportDeclaration;
        } else if (exportDeclaration.get("specifiers").length > 0) {
          throw new Error("It doesn't make sense to split exported specifiers.");
        }
        const declaration = exportDeclaration.get("declaration");
        const bindingIdentifiers = declaration.getOuterBindingIdentifiers();
        const specifiers = Object.keys(bindingIdentifiers).map((name) => {
          return exportSpecifier(identifier3(name), identifier3(name));
        });
        const aliasDeclar = exportNamedDeclaration(null, specifiers);
        exportDeclaration.insertAfter(aliasDeclar);
        exportDeclaration.replaceWith(declaration.node);
        return exportDeclaration;
      }
    }
  });

  // node_modules/@babel/helper-environment-visitor/lib/index.js
  var require_lib8 = __commonJS({
    "node_modules/@babel/helper-environment-visitor/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      exports2.requeueComputedKeyAndDecorators = requeueComputedKeyAndDecorators;
      exports2.skipAllButComputedKey = skipAllButComputedKey;
      function skipAllButComputedKey(path) {
        path.skip();
        if (path.node.computed) {
          path.context.maybeQueue(path.get("key"));
        }
      }
      function requeueComputedKeyAndDecorators(path) {
        const {
          context,
          node
        } = path;
        if (node.computed) {
          context.maybeQueue(path.get("key"));
        }
        if (node.decorators) {
          for (const decorator of path.get("decorators")) {
            context.maybeQueue(decorator);
          }
        }
      }
      var visitor = {
        FunctionParent(path) {
          if (path.isArrowFunctionExpression()) {
            return;
          } else {
            path.skip();
            if (path.isMethod()) {
              requeueComputedKeyAndDecorators(path);
            }
          }
        },
        Property(path) {
          if (path.isObjectProperty()) {
            return;
          }
          path.skip();
          requeueComputedKeyAndDecorators(path);
        }
      };
      var _default = visitor;
      exports2.default = _default;
    }
  });

  // node_modules/@babel/traverse/lib/scope/lib/renamer.js
  var require_renamer = __commonJS({
    "node_modules/@babel/traverse/lib/scope/lib/renamer.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _helperSplitExportDeclaration = require_lib7();
      var t3 = require_lib5();
      var _helperEnvironmentVisitor = require_lib8();
      var renameVisitor = {
        ReferencedIdentifier({
          node
        }, state) {
          if (node.name === state.oldName) {
            node.name = state.newName;
          }
        },
        Scope(path, state) {
          if (!path.scope.bindingIdentifierEquals(state.oldName, state.binding.identifier)) {
            path.skip();
            if (path.isMethod()) {
              (0, _helperEnvironmentVisitor.requeueComputedKeyAndDecorators)(path);
            }
          }
        },
        "AssignmentExpression|Declaration|VariableDeclarator"(path, state) {
          if (path.isVariableDeclaration())
            return;
          const ids = path.getOuterBindingIdentifiers();
          for (const name in ids) {
            if (name === state.oldName)
              ids[name].name = state.newName;
          }
        }
      };
      var Renamer = class {
        constructor(binding, oldName, newName) {
          this.newName = newName;
          this.oldName = oldName;
          this.binding = binding;
        }
        maybeConvertFromExportDeclaration(parentDeclar) {
          const maybeExportDeclar = parentDeclar.parentPath;
          if (!maybeExportDeclar.isExportDeclaration()) {
            return;
          }
          if (maybeExportDeclar.isExportDefaultDeclaration()) {
            const {
              declaration
            } = maybeExportDeclar.node;
            if (t3.isDeclaration(declaration) && !declaration.id) {
              return;
            }
          }
          if (maybeExportDeclar.isExportAllDeclaration()) {
            return;
          }
          (0, _helperSplitExportDeclaration.default)(maybeExportDeclar);
        }
        maybeConvertFromClassFunctionDeclaration(path) {
          return path;
        }
        maybeConvertFromClassFunctionExpression(path) {
          return path;
        }
        rename(block) {
          const {
            binding,
            oldName,
            newName
          } = this;
          const {
            scope,
            path
          } = binding;
          const parentDeclar = path.find((path2) => path2.isDeclaration() || path2.isFunctionExpression() || path2.isClassExpression());
          if (parentDeclar) {
            const bindingIds = parentDeclar.getOuterBindingIdentifiers();
            if (bindingIds[oldName] === binding.identifier) {
              this.maybeConvertFromExportDeclaration(parentDeclar);
            }
          }
          const blockToTraverse = block || scope.block;
          if ((blockToTraverse == null ? void 0 : blockToTraverse.type) === "SwitchStatement") {
            blockToTraverse.cases.forEach((c) => {
              scope.traverse(c, renameVisitor, this);
            });
          } else {
            scope.traverse(blockToTraverse, renameVisitor, this);
          }
          if (!block) {
            scope.removeOwnBinding(oldName);
            scope.bindings[newName] = binding;
            this.binding.identifier.name = newName;
          }
          if (parentDeclar) {
            this.maybeConvertFromClassFunctionDeclaration(path);
            this.maybeConvertFromClassFunctionExpression(path);
          }
        }
      };
      exports2.default = Renamer;
    }
  });

  // node_modules/@babel/traverse/lib/scope/binding.js
  var require_binding = __commonJS({
    "node_modules/@babel/traverse/lib/scope/binding.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var Binding = class {
        constructor({
          identifier: identifier3,
          scope,
          path,
          kind
        }) {
          this.identifier = void 0;
          this.scope = void 0;
          this.path = void 0;
          this.kind = void 0;
          this.constantViolations = [];
          this.constant = true;
          this.referencePaths = [];
          this.referenced = false;
          this.references = 0;
          this.identifier = identifier3;
          this.scope = scope;
          this.path = path;
          this.kind = kind;
          if ((kind === "var" || kind === "hoisted") && isDeclaredInLoop(path || (() => {
            throw new Error("Internal Babel error: unreachable ");
          })())) {
            this.reassign(path);
          }
          this.clearValue();
        }
        deoptValue() {
          this.clearValue();
          this.hasDeoptedValue = true;
        }
        setValue(value) {
          if (this.hasDeoptedValue)
            return;
          this.hasValue = true;
          this.value = value;
        }
        clearValue() {
          this.hasDeoptedValue = false;
          this.hasValue = false;
          this.value = null;
        }
        reassign(path) {
          this.constant = false;
          if (this.constantViolations.indexOf(path) !== -1) {
            return;
          }
          this.constantViolations.push(path);
        }
        reference(path) {
          if (this.referencePaths.indexOf(path) !== -1) {
            return;
          }
          this.referenced = true;
          this.references++;
          this.referencePaths.push(path);
        }
        dereference() {
          this.references--;
          this.referenced = !!this.references;
        }
      };
      exports2.default = Binding;
      function isDeclaredInLoop(path) {
        for (let {
          parentPath,
          key
        } = path; parentPath; {
          parentPath,
          key
        } = parentPath) {
          if (parentPath.isFunctionParent())
            return false;
          if (parentPath.isWhile() || parentPath.isForXStatement() || parentPath.isForStatement() && key === "body") {
            return true;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/traverse/node_modules/globals/globals.json
  var require_globals = __commonJS({
    "node_modules/@babel/traverse/node_modules/globals/globals.json"(exports2, module2) {
      module2.exports = {
        builtin: {
          Array: false,
          ArrayBuffer: false,
          Atomics: false,
          BigInt: false,
          BigInt64Array: false,
          BigUint64Array: false,
          Boolean: false,
          constructor: false,
          DataView: false,
          Date: false,
          decodeURI: false,
          decodeURIComponent: false,
          encodeURI: false,
          encodeURIComponent: false,
          Error: false,
          escape: false,
          eval: false,
          EvalError: false,
          Float32Array: false,
          Float64Array: false,
          Function: false,
          globalThis: false,
          hasOwnProperty: false,
          Infinity: false,
          Int16Array: false,
          Int32Array: false,
          Int8Array: false,
          isFinite: false,
          isNaN: false,
          isPrototypeOf: false,
          JSON: false,
          Map: false,
          Math: false,
          NaN: false,
          Number: false,
          Object: false,
          parseFloat: false,
          parseInt: false,
          Promise: false,
          propertyIsEnumerable: false,
          Proxy: false,
          RangeError: false,
          ReferenceError: false,
          Reflect: false,
          RegExp: false,
          Set: false,
          SharedArrayBuffer: false,
          String: false,
          Symbol: false,
          SyntaxError: false,
          toLocaleString: false,
          toString: false,
          TypeError: false,
          Uint16Array: false,
          Uint32Array: false,
          Uint8Array: false,
          Uint8ClampedArray: false,
          undefined: false,
          unescape: false,
          URIError: false,
          valueOf: false,
          WeakMap: false,
          WeakSet: false
        },
        es5: {
          Array: false,
          Boolean: false,
          constructor: false,
          Date: false,
          decodeURI: false,
          decodeURIComponent: false,
          encodeURI: false,
          encodeURIComponent: false,
          Error: false,
          escape: false,
          eval: false,
          EvalError: false,
          Function: false,
          hasOwnProperty: false,
          Infinity: false,
          isFinite: false,
          isNaN: false,
          isPrototypeOf: false,
          JSON: false,
          Math: false,
          NaN: false,
          Number: false,
          Object: false,
          parseFloat: false,
          parseInt: false,
          propertyIsEnumerable: false,
          RangeError: false,
          ReferenceError: false,
          RegExp: false,
          String: false,
          SyntaxError: false,
          toLocaleString: false,
          toString: false,
          TypeError: false,
          undefined: false,
          unescape: false,
          URIError: false,
          valueOf: false
        },
        es2015: {
          Array: false,
          ArrayBuffer: false,
          Boolean: false,
          constructor: false,
          DataView: false,
          Date: false,
          decodeURI: false,
          decodeURIComponent: false,
          encodeURI: false,
          encodeURIComponent: false,
          Error: false,
          escape: false,
          eval: false,
          EvalError: false,
          Float32Array: false,
          Float64Array: false,
          Function: false,
          hasOwnProperty: false,
          Infinity: false,
          Int16Array: false,
          Int32Array: false,
          Int8Array: false,
          isFinite: false,
          isNaN: false,
          isPrototypeOf: false,
          JSON: false,
          Map: false,
          Math: false,
          NaN: false,
          Number: false,
          Object: false,
          parseFloat: false,
          parseInt: false,
          Promise: false,
          propertyIsEnumerable: false,
          Proxy: false,
          RangeError: false,
          ReferenceError: false,
          Reflect: false,
          RegExp: false,
          Set: false,
          String: false,
          Symbol: false,
          SyntaxError: false,
          toLocaleString: false,
          toString: false,
          TypeError: false,
          Uint16Array: false,
          Uint32Array: false,
          Uint8Array: false,
          Uint8ClampedArray: false,
          undefined: false,
          unescape: false,
          URIError: false,
          valueOf: false,
          WeakMap: false,
          WeakSet: false
        },
        es2017: {
          Array: false,
          ArrayBuffer: false,
          Atomics: false,
          Boolean: false,
          constructor: false,
          DataView: false,
          Date: false,
          decodeURI: false,
          decodeURIComponent: false,
          encodeURI: false,
          encodeURIComponent: false,
          Error: false,
          escape: false,
          eval: false,
          EvalError: false,
          Float32Array: false,
          Float64Array: false,
          Function: false,
          hasOwnProperty: false,
          Infinity: false,
          Int16Array: false,
          Int32Array: false,
          Int8Array: false,
          isFinite: false,
          isNaN: false,
          isPrototypeOf: false,
          JSON: false,
          Map: false,
          Math: false,
          NaN: false,
          Number: false,
          Object: false,
          parseFloat: false,
          parseInt: false,
          Promise: false,
          propertyIsEnumerable: false,
          Proxy: false,
          RangeError: false,
          ReferenceError: false,
          Reflect: false,
          RegExp: false,
          Set: false,
          SharedArrayBuffer: false,
          String: false,
          Symbol: false,
          SyntaxError: false,
          toLocaleString: false,
          toString: false,
          TypeError: false,
          Uint16Array: false,
          Uint32Array: false,
          Uint8Array: false,
          Uint8ClampedArray: false,
          undefined: false,
          unescape: false,
          URIError: false,
          valueOf: false,
          WeakMap: false,
          WeakSet: false
        },
        browser: {
          AbortController: false,
          AbortSignal: false,
          addEventListener: false,
          alert: false,
          AnalyserNode: false,
          Animation: false,
          AnimationEffectReadOnly: false,
          AnimationEffectTiming: false,
          AnimationEffectTimingReadOnly: false,
          AnimationEvent: false,
          AnimationPlaybackEvent: false,
          AnimationTimeline: false,
          applicationCache: false,
          ApplicationCache: false,
          ApplicationCacheErrorEvent: false,
          atob: false,
          Attr: false,
          Audio: false,
          AudioBuffer: false,
          AudioBufferSourceNode: false,
          AudioContext: false,
          AudioDestinationNode: false,
          AudioListener: false,
          AudioNode: false,
          AudioParam: false,
          AudioProcessingEvent: false,
          AudioScheduledSourceNode: false,
          "AudioWorkletGlobalScope ": false,
          AudioWorkletNode: false,
          AudioWorkletProcessor: false,
          BarProp: false,
          BaseAudioContext: false,
          BatteryManager: false,
          BeforeUnloadEvent: false,
          BiquadFilterNode: false,
          Blob: false,
          BlobEvent: false,
          blur: false,
          BroadcastChannel: false,
          btoa: false,
          BudgetService: false,
          ByteLengthQueuingStrategy: false,
          Cache: false,
          caches: false,
          CacheStorage: false,
          cancelAnimationFrame: false,
          cancelIdleCallback: false,
          CanvasCaptureMediaStreamTrack: false,
          CanvasGradient: false,
          CanvasPattern: false,
          CanvasRenderingContext2D: false,
          ChannelMergerNode: false,
          ChannelSplitterNode: false,
          CharacterData: false,
          clearInterval: false,
          clearTimeout: false,
          clientInformation: false,
          ClipboardEvent: false,
          close: false,
          closed: false,
          CloseEvent: false,
          Comment: false,
          CompositionEvent: false,
          confirm: false,
          console: false,
          ConstantSourceNode: false,
          ConvolverNode: false,
          CountQueuingStrategy: false,
          createImageBitmap: false,
          Credential: false,
          CredentialsContainer: false,
          crypto: false,
          Crypto: false,
          CryptoKey: false,
          CSS: false,
          CSSConditionRule: false,
          CSSFontFaceRule: false,
          CSSGroupingRule: false,
          CSSImportRule: false,
          CSSKeyframeRule: false,
          CSSKeyframesRule: false,
          CSSMediaRule: false,
          CSSNamespaceRule: false,
          CSSPageRule: false,
          CSSRule: false,
          CSSRuleList: false,
          CSSStyleDeclaration: false,
          CSSStyleRule: false,
          CSSStyleSheet: false,
          CSSSupportsRule: false,
          CustomElementRegistry: false,
          customElements: false,
          CustomEvent: false,
          DataTransfer: false,
          DataTransferItem: false,
          DataTransferItemList: false,
          defaultstatus: false,
          defaultStatus: false,
          DelayNode: false,
          DeviceMotionEvent: false,
          DeviceOrientationEvent: false,
          devicePixelRatio: false,
          dispatchEvent: false,
          document: false,
          Document: false,
          DocumentFragment: false,
          DocumentType: false,
          DOMError: false,
          DOMException: false,
          DOMImplementation: false,
          DOMMatrix: false,
          DOMMatrixReadOnly: false,
          DOMParser: false,
          DOMPoint: false,
          DOMPointReadOnly: false,
          DOMQuad: false,
          DOMRect: false,
          DOMRectReadOnly: false,
          DOMStringList: false,
          DOMStringMap: false,
          DOMTokenList: false,
          DragEvent: false,
          DynamicsCompressorNode: false,
          Element: false,
          ErrorEvent: false,
          event: false,
          Event: false,
          EventSource: false,
          EventTarget: false,
          external: false,
          fetch: false,
          File: false,
          FileList: false,
          FileReader: false,
          find: false,
          focus: false,
          FocusEvent: false,
          FontFace: false,
          FontFaceSetLoadEvent: false,
          FormData: false,
          frameElement: false,
          frames: false,
          GainNode: false,
          Gamepad: false,
          GamepadButton: false,
          GamepadEvent: false,
          getComputedStyle: false,
          getSelection: false,
          HashChangeEvent: false,
          Headers: false,
          history: false,
          History: false,
          HTMLAllCollection: false,
          HTMLAnchorElement: false,
          HTMLAreaElement: false,
          HTMLAudioElement: false,
          HTMLBaseElement: false,
          HTMLBodyElement: false,
          HTMLBRElement: false,
          HTMLButtonElement: false,
          HTMLCanvasElement: false,
          HTMLCollection: false,
          HTMLContentElement: false,
          HTMLDataElement: false,
          HTMLDataListElement: false,
          HTMLDetailsElement: false,
          HTMLDialogElement: false,
          HTMLDirectoryElement: false,
          HTMLDivElement: false,
          HTMLDListElement: false,
          HTMLDocument: false,
          HTMLElement: false,
          HTMLEmbedElement: false,
          HTMLFieldSetElement: false,
          HTMLFontElement: false,
          HTMLFormControlsCollection: false,
          HTMLFormElement: false,
          HTMLFrameElement: false,
          HTMLFrameSetElement: false,
          HTMLHeadElement: false,
          HTMLHeadingElement: false,
          HTMLHRElement: false,
          HTMLHtmlElement: false,
          HTMLIFrameElement: false,
          HTMLImageElement: false,
          HTMLInputElement: false,
          HTMLLabelElement: false,
          HTMLLegendElement: false,
          HTMLLIElement: false,
          HTMLLinkElement: false,
          HTMLMapElement: false,
          HTMLMarqueeElement: false,
          HTMLMediaElement: false,
          HTMLMenuElement: false,
          HTMLMetaElement: false,
          HTMLMeterElement: false,
          HTMLModElement: false,
          HTMLObjectElement: false,
          HTMLOListElement: false,
          HTMLOptGroupElement: false,
          HTMLOptionElement: false,
          HTMLOptionsCollection: false,
          HTMLOutputElement: false,
          HTMLParagraphElement: false,
          HTMLParamElement: false,
          HTMLPictureElement: false,
          HTMLPreElement: false,
          HTMLProgressElement: false,
          HTMLQuoteElement: false,
          HTMLScriptElement: false,
          HTMLSelectElement: false,
          HTMLShadowElement: false,
          HTMLSlotElement: false,
          HTMLSourceElement: false,
          HTMLSpanElement: false,
          HTMLStyleElement: false,
          HTMLTableCaptionElement: false,
          HTMLTableCellElement: false,
          HTMLTableColElement: false,
          HTMLTableElement: false,
          HTMLTableRowElement: false,
          HTMLTableSectionElement: false,
          HTMLTemplateElement: false,
          HTMLTextAreaElement: false,
          HTMLTimeElement: false,
          HTMLTitleElement: false,
          HTMLTrackElement: false,
          HTMLUListElement: false,
          HTMLUnknownElement: false,
          HTMLVideoElement: false,
          IDBCursor: false,
          IDBCursorWithValue: false,
          IDBDatabase: false,
          IDBFactory: false,
          IDBIndex: false,
          IDBKeyRange: false,
          IDBObjectStore: false,
          IDBOpenDBRequest: false,
          IDBRequest: false,
          IDBTransaction: false,
          IDBVersionChangeEvent: false,
          IdleDeadline: false,
          IIRFilterNode: false,
          Image: false,
          ImageBitmap: false,
          ImageBitmapRenderingContext: false,
          ImageCapture: false,
          ImageData: false,
          indexedDB: false,
          innerHeight: false,
          innerWidth: false,
          InputEvent: false,
          IntersectionObserver: false,
          IntersectionObserverEntry: false,
          Intl: false,
          isSecureContext: false,
          KeyboardEvent: false,
          KeyframeEffect: false,
          KeyframeEffectReadOnly: false,
          length: false,
          localStorage: false,
          location: true,
          Location: false,
          locationbar: false,
          matchMedia: false,
          MediaDeviceInfo: false,
          MediaDevices: false,
          MediaElementAudioSourceNode: false,
          MediaEncryptedEvent: false,
          MediaError: false,
          MediaKeyMessageEvent: false,
          MediaKeySession: false,
          MediaKeyStatusMap: false,
          MediaKeySystemAccess: false,
          MediaList: false,
          MediaQueryList: false,
          MediaQueryListEvent: false,
          MediaRecorder: false,
          MediaSettingsRange: false,
          MediaSource: false,
          MediaStream: false,
          MediaStreamAudioDestinationNode: false,
          MediaStreamAudioSourceNode: false,
          MediaStreamEvent: false,
          MediaStreamTrack: false,
          MediaStreamTrackEvent: false,
          menubar: false,
          MessageChannel: false,
          MessageEvent: false,
          MessagePort: false,
          MIDIAccess: false,
          MIDIConnectionEvent: false,
          MIDIInput: false,
          MIDIInputMap: false,
          MIDIMessageEvent: false,
          MIDIOutput: false,
          MIDIOutputMap: false,
          MIDIPort: false,
          MimeType: false,
          MimeTypeArray: false,
          MouseEvent: false,
          moveBy: false,
          moveTo: false,
          MutationEvent: false,
          MutationObserver: false,
          MutationRecord: false,
          name: false,
          NamedNodeMap: false,
          NavigationPreloadManager: false,
          navigator: false,
          Navigator: false,
          NetworkInformation: false,
          Node: false,
          NodeFilter: false,
          NodeIterator: false,
          NodeList: false,
          Notification: false,
          OfflineAudioCompletionEvent: false,
          OfflineAudioContext: false,
          offscreenBuffering: false,
          OffscreenCanvas: true,
          onabort: true,
          onafterprint: true,
          onanimationend: true,
          onanimationiteration: true,
          onanimationstart: true,
          onappinstalled: true,
          onauxclick: true,
          onbeforeinstallprompt: true,
          onbeforeprint: true,
          onbeforeunload: true,
          onblur: true,
          oncancel: true,
          oncanplay: true,
          oncanplaythrough: true,
          onchange: true,
          onclick: true,
          onclose: true,
          oncontextmenu: true,
          oncuechange: true,
          ondblclick: true,
          ondevicemotion: true,
          ondeviceorientation: true,
          ondeviceorientationabsolute: true,
          ondrag: true,
          ondragend: true,
          ondragenter: true,
          ondragleave: true,
          ondragover: true,
          ondragstart: true,
          ondrop: true,
          ondurationchange: true,
          onemptied: true,
          onended: true,
          onerror: true,
          onfocus: true,
          ongotpointercapture: true,
          onhashchange: true,
          oninput: true,
          oninvalid: true,
          onkeydown: true,
          onkeypress: true,
          onkeyup: true,
          onlanguagechange: true,
          onload: true,
          onloadeddata: true,
          onloadedmetadata: true,
          onloadstart: true,
          onlostpointercapture: true,
          onmessage: true,
          onmessageerror: true,
          onmousedown: true,
          onmouseenter: true,
          onmouseleave: true,
          onmousemove: true,
          onmouseout: true,
          onmouseover: true,
          onmouseup: true,
          onmousewheel: true,
          onoffline: true,
          ononline: true,
          onpagehide: true,
          onpageshow: true,
          onpause: true,
          onplay: true,
          onplaying: true,
          onpointercancel: true,
          onpointerdown: true,
          onpointerenter: true,
          onpointerleave: true,
          onpointermove: true,
          onpointerout: true,
          onpointerover: true,
          onpointerup: true,
          onpopstate: true,
          onprogress: true,
          onratechange: true,
          onrejectionhandled: true,
          onreset: true,
          onresize: true,
          onscroll: true,
          onsearch: true,
          onseeked: true,
          onseeking: true,
          onselect: true,
          onstalled: true,
          onstorage: true,
          onsubmit: true,
          onsuspend: true,
          ontimeupdate: true,
          ontoggle: true,
          ontransitionend: true,
          onunhandledrejection: true,
          onunload: true,
          onvolumechange: true,
          onwaiting: true,
          onwheel: true,
          open: false,
          openDatabase: false,
          opener: false,
          Option: false,
          origin: false,
          OscillatorNode: false,
          outerHeight: false,
          outerWidth: false,
          PageTransitionEvent: false,
          pageXOffset: false,
          pageYOffset: false,
          PannerNode: false,
          parent: false,
          Path2D: false,
          PaymentAddress: false,
          PaymentRequest: false,
          PaymentRequestUpdateEvent: false,
          PaymentResponse: false,
          performance: false,
          Performance: false,
          PerformanceEntry: false,
          PerformanceLongTaskTiming: false,
          PerformanceMark: false,
          PerformanceMeasure: false,
          PerformanceNavigation: false,
          PerformanceNavigationTiming: false,
          PerformanceObserver: false,
          PerformanceObserverEntryList: false,
          PerformancePaintTiming: false,
          PerformanceResourceTiming: false,
          PerformanceTiming: false,
          PeriodicWave: false,
          Permissions: false,
          PermissionStatus: false,
          personalbar: false,
          PhotoCapabilities: false,
          Plugin: false,
          PluginArray: false,
          PointerEvent: false,
          PopStateEvent: false,
          postMessage: false,
          Presentation: false,
          PresentationAvailability: false,
          PresentationConnection: false,
          PresentationConnectionAvailableEvent: false,
          PresentationConnectionCloseEvent: false,
          PresentationConnectionList: false,
          PresentationReceiver: false,
          PresentationRequest: false,
          print: false,
          ProcessingInstruction: false,
          ProgressEvent: false,
          PromiseRejectionEvent: false,
          prompt: false,
          PushManager: false,
          PushSubscription: false,
          PushSubscriptionOptions: false,
          queueMicrotask: false,
          RadioNodeList: false,
          Range: false,
          ReadableStream: false,
          registerProcessor: false,
          RemotePlayback: false,
          removeEventListener: false,
          Request: false,
          requestAnimationFrame: false,
          requestIdleCallback: false,
          resizeBy: false,
          ResizeObserver: false,
          ResizeObserverEntry: false,
          resizeTo: false,
          Response: false,
          RTCCertificate: false,
          RTCDataChannel: false,
          RTCDataChannelEvent: false,
          RTCDtlsTransport: false,
          RTCIceCandidate: false,
          RTCIceGatherer: false,
          RTCIceTransport: false,
          RTCPeerConnection: false,
          RTCPeerConnectionIceEvent: false,
          RTCRtpContributingSource: false,
          RTCRtpReceiver: false,
          RTCRtpSender: false,
          RTCSctpTransport: false,
          RTCSessionDescription: false,
          RTCStatsReport: false,
          RTCTrackEvent: false,
          screen: false,
          Screen: false,
          screenLeft: false,
          ScreenOrientation: false,
          screenTop: false,
          screenX: false,
          screenY: false,
          ScriptProcessorNode: false,
          scroll: false,
          scrollbars: false,
          scrollBy: false,
          scrollTo: false,
          scrollX: false,
          scrollY: false,
          SecurityPolicyViolationEvent: false,
          Selection: false,
          self: false,
          ServiceWorker: false,
          ServiceWorkerContainer: false,
          ServiceWorkerRegistration: false,
          sessionStorage: false,
          setInterval: false,
          setTimeout: false,
          ShadowRoot: false,
          SharedWorker: false,
          SourceBuffer: false,
          SourceBufferList: false,
          speechSynthesis: false,
          SpeechSynthesisEvent: false,
          SpeechSynthesisUtterance: false,
          StaticRange: false,
          status: false,
          statusbar: false,
          StereoPannerNode: false,
          stop: false,
          Storage: false,
          StorageEvent: false,
          StorageManager: false,
          styleMedia: false,
          StyleSheet: false,
          StyleSheetList: false,
          SubtleCrypto: false,
          SVGAElement: false,
          SVGAngle: false,
          SVGAnimatedAngle: false,
          SVGAnimatedBoolean: false,
          SVGAnimatedEnumeration: false,
          SVGAnimatedInteger: false,
          SVGAnimatedLength: false,
          SVGAnimatedLengthList: false,
          SVGAnimatedNumber: false,
          SVGAnimatedNumberList: false,
          SVGAnimatedPreserveAspectRatio: false,
          SVGAnimatedRect: false,
          SVGAnimatedString: false,
          SVGAnimatedTransformList: false,
          SVGAnimateElement: false,
          SVGAnimateMotionElement: false,
          SVGAnimateTransformElement: false,
          SVGAnimationElement: false,
          SVGCircleElement: false,
          SVGClipPathElement: false,
          SVGComponentTransferFunctionElement: false,
          SVGDefsElement: false,
          SVGDescElement: false,
          SVGDiscardElement: false,
          SVGElement: false,
          SVGEllipseElement: false,
          SVGFEBlendElement: false,
          SVGFEColorMatrixElement: false,
          SVGFEComponentTransferElement: false,
          SVGFECompositeElement: false,
          SVGFEConvolveMatrixElement: false,
          SVGFEDiffuseLightingElement: false,
          SVGFEDisplacementMapElement: false,
          SVGFEDistantLightElement: false,
          SVGFEDropShadowElement: false,
          SVGFEFloodElement: false,
          SVGFEFuncAElement: false,
          SVGFEFuncBElement: false,
          SVGFEFuncGElement: false,
          SVGFEFuncRElement: false,
          SVGFEGaussianBlurElement: false,
          SVGFEImageElement: false,
          SVGFEMergeElement: false,
          SVGFEMergeNodeElement: false,
          SVGFEMorphologyElement: false,
          SVGFEOffsetElement: false,
          SVGFEPointLightElement: false,
          SVGFESpecularLightingElement: false,
          SVGFESpotLightElement: false,
          SVGFETileElement: false,
          SVGFETurbulenceElement: false,
          SVGFilterElement: false,
          SVGForeignObjectElement: false,
          SVGGElement: false,
          SVGGeometryElement: false,
          SVGGradientElement: false,
          SVGGraphicsElement: false,
          SVGImageElement: false,
          SVGLength: false,
          SVGLengthList: false,
          SVGLinearGradientElement: false,
          SVGLineElement: false,
          SVGMarkerElement: false,
          SVGMaskElement: false,
          SVGMatrix: false,
          SVGMetadataElement: false,
          SVGMPathElement: false,
          SVGNumber: false,
          SVGNumberList: false,
          SVGPathElement: false,
          SVGPatternElement: false,
          SVGPoint: false,
          SVGPointList: false,
          SVGPolygonElement: false,
          SVGPolylineElement: false,
          SVGPreserveAspectRatio: false,
          SVGRadialGradientElement: false,
          SVGRect: false,
          SVGRectElement: false,
          SVGScriptElement: false,
          SVGSetElement: false,
          SVGStopElement: false,
          SVGStringList: false,
          SVGStyleElement: false,
          SVGSVGElement: false,
          SVGSwitchElement: false,
          SVGSymbolElement: false,
          SVGTextContentElement: false,
          SVGTextElement: false,
          SVGTextPathElement: false,
          SVGTextPositioningElement: false,
          SVGTitleElement: false,
          SVGTransform: false,
          SVGTransformList: false,
          SVGTSpanElement: false,
          SVGUnitTypes: false,
          SVGUseElement: false,
          SVGViewElement: false,
          TaskAttributionTiming: false,
          Text: false,
          TextDecoder: false,
          TextEncoder: false,
          TextEvent: false,
          TextMetrics: false,
          TextTrack: false,
          TextTrackCue: false,
          TextTrackCueList: false,
          TextTrackList: false,
          TimeRanges: false,
          toolbar: false,
          top: false,
          Touch: false,
          TouchEvent: false,
          TouchList: false,
          TrackEvent: false,
          TransitionEvent: false,
          TreeWalker: false,
          UIEvent: false,
          URL: false,
          URLSearchParams: false,
          ValidityState: false,
          visualViewport: false,
          VisualViewport: false,
          VTTCue: false,
          WaveShaperNode: false,
          WebAssembly: false,
          WebGL2RenderingContext: false,
          WebGLActiveInfo: false,
          WebGLBuffer: false,
          WebGLContextEvent: false,
          WebGLFramebuffer: false,
          WebGLProgram: false,
          WebGLQuery: false,
          WebGLRenderbuffer: false,
          WebGLRenderingContext: false,
          WebGLSampler: false,
          WebGLShader: false,
          WebGLShaderPrecisionFormat: false,
          WebGLSync: false,
          WebGLTexture: false,
          WebGLTransformFeedback: false,
          WebGLUniformLocation: false,
          WebGLVertexArrayObject: false,
          WebSocket: false,
          WheelEvent: false,
          window: false,
          Window: false,
          Worker: false,
          WritableStream: false,
          XMLDocument: false,
          XMLHttpRequest: false,
          XMLHttpRequestEventTarget: false,
          XMLHttpRequestUpload: false,
          XMLSerializer: false,
          XPathEvaluator: false,
          XPathExpression: false,
          XPathResult: false,
          XSLTProcessor: false
        },
        worker: {
          addEventListener: false,
          applicationCache: false,
          atob: false,
          Blob: false,
          BroadcastChannel: false,
          btoa: false,
          Cache: false,
          caches: false,
          clearInterval: false,
          clearTimeout: false,
          close: true,
          console: false,
          fetch: false,
          FileReaderSync: false,
          FormData: false,
          Headers: false,
          IDBCursor: false,
          IDBCursorWithValue: false,
          IDBDatabase: false,
          IDBFactory: false,
          IDBIndex: false,
          IDBKeyRange: false,
          IDBObjectStore: false,
          IDBOpenDBRequest: false,
          IDBRequest: false,
          IDBTransaction: false,
          IDBVersionChangeEvent: false,
          ImageData: false,
          importScripts: true,
          indexedDB: false,
          location: false,
          MessageChannel: false,
          MessagePort: false,
          name: false,
          navigator: false,
          Notification: false,
          onclose: true,
          onconnect: true,
          onerror: true,
          onlanguagechange: true,
          onmessage: true,
          onoffline: true,
          ononline: true,
          onrejectionhandled: true,
          onunhandledrejection: true,
          performance: false,
          Performance: false,
          PerformanceEntry: false,
          PerformanceMark: false,
          PerformanceMeasure: false,
          PerformanceNavigation: false,
          PerformanceResourceTiming: false,
          PerformanceTiming: false,
          postMessage: true,
          Promise: false,
          queueMicrotask: false,
          removeEventListener: false,
          Request: false,
          Response: false,
          self: true,
          ServiceWorkerRegistration: false,
          setInterval: false,
          setTimeout: false,
          TextDecoder: false,
          TextEncoder: false,
          URL: false,
          URLSearchParams: false,
          WebSocket: false,
          Worker: false,
          WorkerGlobalScope: false,
          XMLHttpRequest: false
        },
        node: {
          __dirname: false,
          __filename: false,
          Buffer: false,
          clearImmediate: false,
          clearInterval: false,
          clearTimeout: false,
          console: false,
          exports: true,
          global: false,
          Intl: false,
          module: false,
          process: false,
          queueMicrotask: false,
          require: false,
          setImmediate: false,
          setInterval: false,
          setTimeout: false,
          TextDecoder: false,
          TextEncoder: false,
          URL: false,
          URLSearchParams: false
        },
        commonjs: {
          exports: true,
          global: false,
          module: false,
          require: false
        },
        amd: {
          define: false,
          require: false
        },
        mocha: {
          after: false,
          afterEach: false,
          before: false,
          beforeEach: false,
          context: false,
          describe: false,
          it: false,
          mocha: false,
          run: false,
          setup: false,
          specify: false,
          suite: false,
          suiteSetup: false,
          suiteTeardown: false,
          teardown: false,
          test: false,
          xcontext: false,
          xdescribe: false,
          xit: false,
          xspecify: false
        },
        jasmine: {
          afterAll: false,
          afterEach: false,
          beforeAll: false,
          beforeEach: false,
          describe: false,
          expect: false,
          fail: false,
          fdescribe: false,
          fit: false,
          it: false,
          jasmine: false,
          pending: false,
          runs: false,
          spyOn: false,
          spyOnProperty: false,
          waits: false,
          waitsFor: false,
          xdescribe: false,
          xit: false
        },
        jest: {
          afterAll: false,
          afterEach: false,
          beforeAll: false,
          beforeEach: false,
          describe: false,
          expect: false,
          fdescribe: false,
          fit: false,
          it: false,
          jest: false,
          pit: false,
          require: false,
          test: false,
          xdescribe: false,
          xit: false,
          xtest: false
        },
        qunit: {
          asyncTest: false,
          deepEqual: false,
          equal: false,
          expect: false,
          module: false,
          notDeepEqual: false,
          notEqual: false,
          notOk: false,
          notPropEqual: false,
          notStrictEqual: false,
          ok: false,
          propEqual: false,
          QUnit: false,
          raises: false,
          start: false,
          stop: false,
          strictEqual: false,
          test: false,
          throws: false
        },
        phantomjs: {
          console: true,
          exports: true,
          phantom: true,
          require: true,
          WebPage: true
        },
        couch: {
          emit: false,
          exports: false,
          getRow: false,
          log: false,
          module: false,
          provides: false,
          require: false,
          respond: false,
          send: false,
          start: false,
          sum: false
        },
        rhino: {
          defineClass: false,
          deserialize: false,
          gc: false,
          help: false,
          importClass: false,
          importPackage: false,
          java: false,
          load: false,
          loadClass: false,
          Packages: false,
          print: false,
          quit: false,
          readFile: false,
          readUrl: false,
          runCommand: false,
          seal: false,
          serialize: false,
          spawn: false,
          sync: false,
          toint32: false,
          version: false
        },
        nashorn: {
          __DIR__: false,
          __FILE__: false,
          __LINE__: false,
          com: false,
          edu: false,
          exit: false,
          java: false,
          Java: false,
          javafx: false,
          JavaImporter: false,
          javax: false,
          JSAdapter: false,
          load: false,
          loadWithNewGlobal: false,
          org: false,
          Packages: false,
          print: false,
          quit: false
        },
        wsh: {
          ActiveXObject: true,
          Enumerator: true,
          GetObject: true,
          ScriptEngine: true,
          ScriptEngineBuildVersion: true,
          ScriptEngineMajorVersion: true,
          ScriptEngineMinorVersion: true,
          VBArray: true,
          WScript: true,
          WSH: true,
          XDomainRequest: true
        },
        jquery: {
          $: false,
          jQuery: false
        },
        yui: {
          YAHOO: false,
          YAHOO_config: false,
          YUI: false,
          YUI_config: false
        },
        shelljs: {
          cat: false,
          cd: false,
          chmod: false,
          config: false,
          cp: false,
          dirs: false,
          echo: false,
          env: false,
          error: false,
          exec: false,
          exit: false,
          find: false,
          grep: false,
          ln: false,
          ls: false,
          mkdir: false,
          mv: false,
          popd: false,
          pushd: false,
          pwd: false,
          rm: false,
          sed: false,
          set: false,
          target: false,
          tempdir: false,
          test: false,
          touch: false,
          which: false
        },
        prototypejs: {
          $: false,
          $$: false,
          $A: false,
          $break: false,
          $continue: false,
          $F: false,
          $H: false,
          $R: false,
          $w: false,
          Abstract: false,
          Ajax: false,
          Autocompleter: false,
          Builder: false,
          Class: false,
          Control: false,
          Draggable: false,
          Draggables: false,
          Droppables: false,
          Effect: false,
          Element: false,
          Enumerable: false,
          Event: false,
          Field: false,
          Form: false,
          Hash: false,
          Insertion: false,
          ObjectRange: false,
          PeriodicalExecuter: false,
          Position: false,
          Prototype: false,
          Scriptaculous: false,
          Selector: false,
          Sortable: false,
          SortableObserver: false,
          Sound: false,
          Template: false,
          Toggle: false,
          Try: false
        },
        meteor: {
          _: false,
          $: false,
          Accounts: false,
          AccountsClient: false,
          AccountsCommon: false,
          AccountsServer: false,
          App: false,
          Assets: false,
          Blaze: false,
          check: false,
          Cordova: false,
          DDP: false,
          DDPRateLimiter: false,
          DDPServer: false,
          Deps: false,
          EJSON: false,
          Email: false,
          HTTP: false,
          Log: false,
          Match: false,
          Meteor: false,
          Mongo: false,
          MongoInternals: false,
          Npm: false,
          Package: false,
          Plugin: false,
          process: false,
          Random: false,
          ReactiveDict: false,
          ReactiveVar: false,
          Router: false,
          ServiceConfiguration: false,
          Session: false,
          share: false,
          Spacebars: false,
          Template: false,
          Tinytest: false,
          Tracker: false,
          UI: false,
          Utils: false,
          WebApp: false,
          WebAppInternals: false
        },
        mongo: {
          _isWindows: false,
          _rand: false,
          BulkWriteResult: false,
          cat: false,
          cd: false,
          connect: false,
          db: false,
          getHostName: false,
          getMemInfo: false,
          hostname: false,
          ISODate: false,
          listFiles: false,
          load: false,
          ls: false,
          md5sumFile: false,
          mkdir: false,
          Mongo: false,
          NumberInt: false,
          NumberLong: false,
          ObjectId: false,
          PlanCache: false,
          print: false,
          printjson: false,
          pwd: false,
          quit: false,
          removeFile: false,
          rs: false,
          sh: false,
          UUID: false,
          version: false,
          WriteResult: false
        },
        applescript: {
          $: false,
          Application: false,
          Automation: false,
          console: false,
          delay: false,
          Library: false,
          ObjC: false,
          ObjectSpecifier: false,
          Path: false,
          Progress: false,
          Ref: false
        },
        serviceworker: {
          addEventListener: false,
          applicationCache: false,
          atob: false,
          Blob: false,
          BroadcastChannel: false,
          btoa: false,
          Cache: false,
          caches: false,
          CacheStorage: false,
          clearInterval: false,
          clearTimeout: false,
          Client: false,
          clients: false,
          Clients: false,
          close: true,
          console: false,
          ExtendableEvent: false,
          ExtendableMessageEvent: false,
          fetch: false,
          FetchEvent: false,
          FileReaderSync: false,
          FormData: false,
          Headers: false,
          IDBCursor: false,
          IDBCursorWithValue: false,
          IDBDatabase: false,
          IDBFactory: false,
          IDBIndex: false,
          IDBKeyRange: false,
          IDBObjectStore: false,
          IDBOpenDBRequest: false,
          IDBRequest: false,
          IDBTransaction: false,
          IDBVersionChangeEvent: false,
          ImageData: false,
          importScripts: false,
          indexedDB: false,
          location: false,
          MessageChannel: false,
          MessagePort: false,
          name: false,
          navigator: false,
          Notification: false,
          onclose: true,
          onconnect: true,
          onerror: true,
          onfetch: true,
          oninstall: true,
          onlanguagechange: true,
          onmessage: true,
          onmessageerror: true,
          onnotificationclick: true,
          onnotificationclose: true,
          onoffline: true,
          ononline: true,
          onpush: true,
          onpushsubscriptionchange: true,
          onrejectionhandled: true,
          onsync: true,
          onunhandledrejection: true,
          performance: false,
          Performance: false,
          PerformanceEntry: false,
          PerformanceMark: false,
          PerformanceMeasure: false,
          PerformanceNavigation: false,
          PerformanceResourceTiming: false,
          PerformanceTiming: false,
          postMessage: true,
          Promise: false,
          queueMicrotask: false,
          registration: false,
          removeEventListener: false,
          Request: false,
          Response: false,
          self: false,
          ServiceWorker: false,
          ServiceWorkerContainer: false,
          ServiceWorkerGlobalScope: false,
          ServiceWorkerMessageEvent: false,
          ServiceWorkerRegistration: false,
          setInterval: false,
          setTimeout: false,
          skipWaiting: false,
          TextDecoder: false,
          TextEncoder: false,
          URL: false,
          URLSearchParams: false,
          WebSocket: false,
          WindowClient: false,
          Worker: false,
          WorkerGlobalScope: false,
          XMLHttpRequest: false
        },
        atomtest: {
          advanceClock: false,
          fakeClearInterval: false,
          fakeClearTimeout: false,
          fakeSetInterval: false,
          fakeSetTimeout: false,
          resetTimeouts: false,
          waitsForPromise: false
        },
        embertest: {
          andThen: false,
          click: false,
          currentPath: false,
          currentRouteName: false,
          currentURL: false,
          fillIn: false,
          find: false,
          findAll: false,
          findWithAssert: false,
          keyEvent: false,
          pauseTest: false,
          resumeTest: false,
          triggerEvent: false,
          visit: false,
          wait: false
        },
        protractor: {
          $: false,
          $$: false,
          browser: false,
          by: false,
          By: false,
          DartObject: false,
          element: false,
          protractor: false
        },
        "shared-node-browser": {
          clearInterval: false,
          clearTimeout: false,
          console: false,
          setInterval: false,
          setTimeout: false,
          URL: false,
          URLSearchParams: false
        },
        webextensions: {
          browser: false,
          chrome: false,
          opr: false
        },
        greasemonkey: {
          cloneInto: false,
          createObjectIn: false,
          exportFunction: false,
          GM: false,
          GM_addStyle: false,
          GM_deleteValue: false,
          GM_getResourceText: false,
          GM_getResourceURL: false,
          GM_getValue: false,
          GM_info: false,
          GM_listValues: false,
          GM_log: false,
          GM_openInTab: false,
          GM_registerMenuCommand: false,
          GM_setClipboard: false,
          GM_setValue: false,
          GM_xmlhttpRequest: false,
          unsafeWindow: false
        },
        devtools: {
          $: false,
          $_: false,
          $$: false,
          $0: false,
          $1: false,
          $2: false,
          $3: false,
          $4: false,
          $x: false,
          chrome: false,
          clear: false,
          copy: false,
          debug: false,
          dir: false,
          dirxml: false,
          getEventListeners: false,
          inspect: false,
          keys: false,
          monitor: false,
          monitorEvents: false,
          profile: false,
          profileEnd: false,
          queryObjects: false,
          table: false,
          undebug: false,
          unmonitor: false,
          unmonitorEvents: false,
          values: false
        }
      };
    }
  });

  // node_modules/@babel/traverse/node_modules/globals/index.js
  var require_globals2 = __commonJS({
    "node_modules/@babel/traverse/node_modules/globals/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = require_globals();
    }
  });

  // node_modules/@babel/traverse/lib/scope/index.js
  var require_scope = __commonJS({
    "node_modules/@babel/traverse/lib/scope/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _renamer = require_renamer();
      var _index = require_lib14();
      var _binding = require_binding();
      var _globals = require_globals2();
      var _t = require_lib5();
      var _cache = require_cache2();
      var {
        NOT_LOCAL_BINDING,
        callExpression,
        cloneNode,
        getBindingIdentifiers,
        identifier: identifier3,
        isArrayExpression,
        isBinary,
        isClass,
        isClassBody,
        isClassDeclaration,
        isExportAllDeclaration,
        isExportDefaultDeclaration,
        isExportNamedDeclaration,
        isFunctionDeclaration,
        isIdentifier: isIdentifier2,
        isImportDeclaration,
        isLiteral,
        isMethod,
        isModuleDeclaration,
        isModuleSpecifier,
        isNullLiteral,
        isObjectExpression,
        isProperty,
        isPureish,
        isRegExpLiteral,
        isSuper,
        isTaggedTemplateExpression,
        isTemplateLiteral,
        isThisExpression,
        isUnaryExpression,
        isVariableDeclaration,
        matchesPattern,
        memberExpression,
        numericLiteral,
        toIdentifier,
        unaryExpression,
        variableDeclaration,
        variableDeclarator,
        isRecordExpression,
        isTupleExpression,
        isObjectProperty,
        isTopicReference,
        isMetaProperty,
        isPrivateName
      } = _t;
      function gatherNodeParts(node, parts) {
        switch (node == null ? void 0 : node.type) {
          default:
            if (isModuleDeclaration(node)) {
              if ((isExportAllDeclaration(node) || isExportNamedDeclaration(node) || isImportDeclaration(node)) && node.source) {
                gatherNodeParts(node.source, parts);
              } else if ((isExportNamedDeclaration(node) || isImportDeclaration(node)) && node.specifiers && node.specifiers.length) {
                for (const e of node.specifiers)
                  gatherNodeParts(e, parts);
              } else if ((isExportDefaultDeclaration(node) || isExportNamedDeclaration(node)) && node.declaration) {
                gatherNodeParts(node.declaration, parts);
              }
            } else if (isModuleSpecifier(node)) {
              gatherNodeParts(node.local, parts);
            } else if (isLiteral(node) && !isNullLiteral(node) && !isRegExpLiteral(node) && !isTemplateLiteral(node)) {
              parts.push(node.value);
            }
            break;
          case "MemberExpression":
          case "OptionalMemberExpression":
          case "JSXMemberExpression":
            gatherNodeParts(node.object, parts);
            gatherNodeParts(node.property, parts);
            break;
          case "Identifier":
          case "JSXIdentifier":
            parts.push(node.name);
            break;
          case "CallExpression":
          case "OptionalCallExpression":
          case "NewExpression":
            gatherNodeParts(node.callee, parts);
            break;
          case "ObjectExpression":
          case "ObjectPattern":
            for (const e of node.properties) {
              gatherNodeParts(e, parts);
            }
            break;
          case "SpreadElement":
          case "RestElement":
            gatherNodeParts(node.argument, parts);
            break;
          case "ObjectProperty":
          case "ObjectMethod":
          case "ClassProperty":
          case "ClassMethod":
          case "ClassPrivateProperty":
          case "ClassPrivateMethod":
            gatherNodeParts(node.key, parts);
            break;
          case "ThisExpression":
            parts.push("this");
            break;
          case "Super":
            parts.push("super");
            break;
          case "Import":
            parts.push("import");
            break;
          case "DoExpression":
            parts.push("do");
            break;
          case "YieldExpression":
            parts.push("yield");
            gatherNodeParts(node.argument, parts);
            break;
          case "AwaitExpression":
            parts.push("await");
            gatherNodeParts(node.argument, parts);
            break;
          case "AssignmentExpression":
            gatherNodeParts(node.left, parts);
            break;
          case "VariableDeclarator":
            gatherNodeParts(node.id, parts);
            break;
          case "FunctionExpression":
          case "FunctionDeclaration":
          case "ClassExpression":
          case "ClassDeclaration":
            gatherNodeParts(node.id, parts);
            break;
          case "PrivateName":
            gatherNodeParts(node.id, parts);
            break;
          case "ParenthesizedExpression":
            gatherNodeParts(node.expression, parts);
            break;
          case "UnaryExpression":
          case "UpdateExpression":
            gatherNodeParts(node.argument, parts);
            break;
          case "MetaProperty":
            gatherNodeParts(node.meta, parts);
            gatherNodeParts(node.property, parts);
            break;
          case "JSXElement":
            gatherNodeParts(node.openingElement, parts);
            break;
          case "JSXOpeningElement":
            gatherNodeParts(node.name, parts);
            break;
          case "JSXFragment":
            gatherNodeParts(node.openingFragment, parts);
            break;
          case "JSXOpeningFragment":
            parts.push("Fragment");
            break;
          case "JSXNamespacedName":
            gatherNodeParts(node.namespace, parts);
            gatherNodeParts(node.name, parts);
            break;
        }
      }
      var collectorVisitor = {
        ForStatement(path) {
          const declar = path.get("init");
          if (declar.isVar()) {
            const {
              scope
            } = path;
            const parentScope = scope.getFunctionParent() || scope.getProgramParent();
            parentScope.registerBinding("var", declar);
          }
        },
        Declaration(path) {
          if (path.isBlockScoped())
            return;
          if (path.isImportDeclaration())
            return;
          if (path.isExportDeclaration())
            return;
          const parent2 = path.scope.getFunctionParent() || path.scope.getProgramParent();
          parent2.registerDeclaration(path);
        },
        ImportDeclaration(path) {
          const parent2 = path.scope.getBlockParent();
          parent2.registerDeclaration(path);
        },
        ReferencedIdentifier(path, state) {
          state.references.push(path);
        },
        ForXStatement(path, state) {
          const left = path.get("left");
          if (left.isPattern() || left.isIdentifier()) {
            state.constantViolations.push(path);
          } else if (left.isVar()) {
            const {
              scope
            } = path;
            const parentScope = scope.getFunctionParent() || scope.getProgramParent();
            parentScope.registerBinding("var", left);
          }
        },
        ExportDeclaration: {
          exit(path) {
            const {
              node,
              scope
            } = path;
            if (isExportAllDeclaration(node))
              return;
            const declar = node.declaration;
            if (isClassDeclaration(declar) || isFunctionDeclaration(declar)) {
              const id = declar.id;
              if (!id)
                return;
              const binding = scope.getBinding(id.name);
              binding == null ? void 0 : binding.reference(path);
            } else if (isVariableDeclaration(declar)) {
              for (const decl of declar.declarations) {
                for (const name of Object.keys(getBindingIdentifiers(decl))) {
                  const binding = scope.getBinding(name);
                  binding == null ? void 0 : binding.reference(path);
                }
              }
            }
          }
        },
        LabeledStatement(path) {
          path.scope.getBlockParent().registerDeclaration(path);
        },
        AssignmentExpression(path, state) {
          state.assignments.push(path);
        },
        UpdateExpression(path, state) {
          state.constantViolations.push(path);
        },
        UnaryExpression(path, state) {
          if (path.node.operator === "delete") {
            state.constantViolations.push(path);
          }
        },
        BlockScoped(path) {
          let scope = path.scope;
          if (scope.path === path)
            scope = scope.parent;
          const parent2 = scope.getBlockParent();
          parent2.registerDeclaration(path);
          if (path.isClassDeclaration() && path.node.id) {
            const id = path.node.id;
            const name = id.name;
            path.scope.bindings[name] = path.scope.parent.getBinding(name);
          }
        },
        CatchClause(path) {
          path.scope.registerBinding("let", path);
        },
        Function(path) {
          const params = path.get("params");
          for (const param of params) {
            path.scope.registerBinding("param", param);
          }
          if (path.isFunctionExpression() && path.has("id") && !path.get("id").node[NOT_LOCAL_BINDING]) {
            path.scope.registerBinding("local", path.get("id"), path);
          }
        },
        ClassExpression(path) {
          if (path.has("id") && !path.get("id").node[NOT_LOCAL_BINDING]) {
            path.scope.registerBinding("local", path);
          }
        }
      };
      var uid = 0;
      var Scope2 = class {
        constructor(path) {
          this.uid = void 0;
          this.path = void 0;
          this.block = void 0;
          this.labels = void 0;
          this.inited = void 0;
          this.bindings = void 0;
          this.references = void 0;
          this.globals = void 0;
          this.uids = void 0;
          this.data = void 0;
          this.crawling = void 0;
          const {
            node
          } = path;
          const cached = _cache.scope.get(node);
          if ((cached == null ? void 0 : cached.path) === path) {
            return cached;
          }
          _cache.scope.set(node, this);
          this.uid = uid++;
          this.block = node;
          this.path = path;
          this.labels = /* @__PURE__ */ new Map();
          this.inited = false;
        }
        get parent() {
          var _parent;
          let parent2, path = this.path;
          do {
            const shouldSkip = path.key === "key" || path.listKey === "decorators";
            path = path.parentPath;
            if (shouldSkip && path.isMethod())
              path = path.parentPath;
            if (path && path.isScope())
              parent2 = path;
          } while (path && !parent2);
          return (_parent = parent2) == null ? void 0 : _parent.scope;
        }
        get parentBlock() {
          return this.path.parent;
        }
        get hub() {
          return this.path.hub;
        }
        traverse(node, opts, state) {
          (0, _index.default)(node, opts, this, state, this.path);
        }
        generateDeclaredUidIdentifier(name) {
          const id = this.generateUidIdentifier(name);
          this.push({
            id
          });
          return cloneNode(id);
        }
        generateUidIdentifier(name) {
          return identifier3(this.generateUid(name));
        }
        generateUid(name = "temp") {
          name = toIdentifier(name).replace(/^_+/, "").replace(/[0-9]+$/g, "");
          let uid2;
          let i = 1;
          do {
            uid2 = this._generateUid(name, i);
            i++;
          } while (this.hasLabel(uid2) || this.hasBinding(uid2) || this.hasGlobal(uid2) || this.hasReference(uid2));
          const program3 = this.getProgramParent();
          program3.references[uid2] = true;
          program3.uids[uid2] = true;
          return uid2;
        }
        _generateUid(name, i) {
          let id = name;
          if (i > 1)
            id += i;
          return `_${id}`;
        }
        generateUidBasedOnNode(node, defaultName) {
          const parts = [];
          gatherNodeParts(node, parts);
          let id = parts.join("$");
          id = id.replace(/^_/, "") || defaultName || "ref";
          return this.generateUid(id.slice(0, 20));
        }
        generateUidIdentifierBasedOnNode(node, defaultName) {
          return identifier3(this.generateUidBasedOnNode(node, defaultName));
        }
        isStatic(node) {
          if (isThisExpression(node) || isSuper(node) || isTopicReference(node)) {
            return true;
          }
          if (isIdentifier2(node)) {
            const binding = this.getBinding(node.name);
            if (binding) {
              return binding.constant;
            } else {
              return this.hasBinding(node.name);
            }
          }
          return false;
        }
        maybeGenerateMemoised(node, dontPush) {
          if (this.isStatic(node)) {
            return null;
          } else {
            const id = this.generateUidIdentifierBasedOnNode(node);
            if (!dontPush) {
              this.push({
                id
              });
              return cloneNode(id);
            }
            return id;
          }
        }
        checkBlockScopedCollisions(local, kind, name, id) {
          if (kind === "param")
            return;
          if (local.kind === "local")
            return;
          const duplicate = kind === "let" || local.kind === "let" || local.kind === "const" || local.kind === "module" || local.kind === "param" && kind === "const";
          if (duplicate) {
            throw this.hub.buildError(id, `Duplicate declaration "${name}"`, TypeError);
          }
        }
        rename(oldName, newName, block) {
          const binding = this.getBinding(oldName);
          if (binding) {
            newName = newName || this.generateUidIdentifier(oldName).name;
            return new _renamer.default(binding, oldName, newName).rename(block);
          }
        }
        _renameFromMap(map2, oldName, newName, value) {
          if (map2[oldName]) {
            map2[newName] = value;
            map2[oldName] = null;
          }
        }
        dump() {
          const sep = "-".repeat(60);
          console.log(sep);
          let scope = this;
          do {
            console.log("#", scope.block.type);
            for (const name of Object.keys(scope.bindings)) {
              const binding = scope.bindings[name];
              console.log(" -", name, {
                constant: binding.constant,
                references: binding.references,
                violations: binding.constantViolations.length,
                kind: binding.kind
              });
            }
          } while (scope = scope.parent);
          console.log(sep);
        }
        toArray(node, i, arrayLikeIsIterable) {
          if (isIdentifier2(node)) {
            const binding = this.getBinding(node.name);
            if (binding != null && binding.constant && binding.path.isGenericType("Array")) {
              return node;
            }
          }
          if (isArrayExpression(node)) {
            return node;
          }
          if (isIdentifier2(node, {
            name: "arguments"
          })) {
            return callExpression(memberExpression(memberExpression(memberExpression(identifier3("Array"), identifier3("prototype")), identifier3("slice")), identifier3("call")), [node]);
          }
          let helperName;
          const args = [node];
          if (i === true) {
            helperName = "toConsumableArray";
          } else if (typeof i === "number") {
            args.push(numericLiteral(i));
            helperName = "slicedToArray";
          } else {
            helperName = "toArray";
          }
          if (arrayLikeIsIterable) {
            args.unshift(this.hub.addHelper(helperName));
            helperName = "maybeArrayLike";
          }
          return callExpression(this.hub.addHelper(helperName), args);
        }
        hasLabel(name) {
          return !!this.getLabel(name);
        }
        getLabel(name) {
          return this.labels.get(name);
        }
        registerLabel(path) {
          this.labels.set(path.node.label.name, path);
        }
        registerDeclaration(path) {
          if (path.isLabeledStatement()) {
            this.registerLabel(path);
          } else if (path.isFunctionDeclaration()) {
            this.registerBinding("hoisted", path.get("id"), path);
          } else if (path.isVariableDeclaration()) {
            const declarations = path.get("declarations");
            const {
              kind
            } = path.node;
            for (const declar of declarations) {
              this.registerBinding(kind === "using" ? "const" : kind, declar);
            }
          } else if (path.isClassDeclaration()) {
            if (path.node.declare)
              return;
            this.registerBinding("let", path);
          } else if (path.isImportDeclaration()) {
            const specifiers = path.get("specifiers");
            for (const specifier of specifiers) {
              this.registerBinding("module", specifier);
            }
          } else if (path.isExportDeclaration()) {
            const declar = path.get("declaration");
            if (declar.isClassDeclaration() || declar.isFunctionDeclaration() || declar.isVariableDeclaration()) {
              this.registerDeclaration(declar);
            }
          } else {
            this.registerBinding("unknown", path);
          }
        }
        buildUndefinedNode() {
          return unaryExpression("void", numericLiteral(0), true);
        }
        registerConstantViolation(path) {
          const ids = path.getBindingIdentifiers();
          for (const name of Object.keys(ids)) {
            const binding = this.getBinding(name);
            if (binding)
              binding.reassign(path);
          }
        }
        registerBinding(kind, path, bindingPath = path) {
          if (!kind)
            throw new ReferenceError("no `kind`");
          if (path.isVariableDeclaration()) {
            const declarators = path.get("declarations");
            for (const declar of declarators) {
              this.registerBinding(kind, declar);
            }
            return;
          }
          const parent2 = this.getProgramParent();
          const ids = path.getOuterBindingIdentifiers(true);
          for (const name of Object.keys(ids)) {
            parent2.references[name] = true;
            for (const id of ids[name]) {
              const local = this.getOwnBinding(name);
              if (local) {
                if (local.identifier === id)
                  continue;
                this.checkBlockScopedCollisions(local, kind, name, id);
              }
              if (local) {
                this.registerConstantViolation(bindingPath);
              } else {
                this.bindings[name] = new _binding.default({
                  identifier: id,
                  scope: this,
                  path: bindingPath,
                  kind
                });
              }
            }
          }
        }
        addGlobal(node) {
          this.globals[node.name] = node;
        }
        hasUid(name) {
          let scope = this;
          do {
            if (scope.uids[name])
              return true;
          } while (scope = scope.parent);
          return false;
        }
        hasGlobal(name) {
          let scope = this;
          do {
            if (scope.globals[name])
              return true;
          } while (scope = scope.parent);
          return false;
        }
        hasReference(name) {
          return !!this.getProgramParent().references[name];
        }
        isPure(node, constantsOnly) {
          if (isIdentifier2(node)) {
            const binding = this.getBinding(node.name);
            if (!binding)
              return false;
            if (constantsOnly)
              return binding.constant;
            return true;
          } else if (isThisExpression(node) || isMetaProperty(node) || isTopicReference(node) || isPrivateName(node)) {
            return true;
          } else if (isClass(node)) {
            var _node$decorators;
            if (node.superClass && !this.isPure(node.superClass, constantsOnly)) {
              return false;
            }
            if (((_node$decorators = node.decorators) == null ? void 0 : _node$decorators.length) > 0) {
              return false;
            }
            return this.isPure(node.body, constantsOnly);
          } else if (isClassBody(node)) {
            for (const method2 of node.body) {
              if (!this.isPure(method2, constantsOnly))
                return false;
            }
            return true;
          } else if (isBinary(node)) {
            return this.isPure(node.left, constantsOnly) && this.isPure(node.right, constantsOnly);
          } else if (isArrayExpression(node) || isTupleExpression(node)) {
            for (const elem of node.elements) {
              if (elem !== null && !this.isPure(elem, constantsOnly))
                return false;
            }
            return true;
          } else if (isObjectExpression(node) || isRecordExpression(node)) {
            for (const prop of node.properties) {
              if (!this.isPure(prop, constantsOnly))
                return false;
            }
            return true;
          } else if (isMethod(node)) {
            var _node$decorators2;
            if (node.computed && !this.isPure(node.key, constantsOnly))
              return false;
            if (((_node$decorators2 = node.decorators) == null ? void 0 : _node$decorators2.length) > 0) {
              return false;
            }
            return true;
          } else if (isProperty(node)) {
            var _node$decorators3;
            if (node.computed && !this.isPure(node.key, constantsOnly))
              return false;
            if (((_node$decorators3 = node.decorators) == null ? void 0 : _node$decorators3.length) > 0) {
              return false;
            }
            if (isObjectProperty(node) || node.static) {
              if (node.value !== null && !this.isPure(node.value, constantsOnly)) {
                return false;
              }
            }
            return true;
          } else if (isUnaryExpression(node)) {
            return this.isPure(node.argument, constantsOnly);
          } else if (isTaggedTemplateExpression(node)) {
            return matchesPattern(node.tag, "String.raw") && !this.hasBinding("String", true) && this.isPure(node.quasi, constantsOnly);
          } else if (isTemplateLiteral(node)) {
            for (const expression of node.expressions) {
              if (!this.isPure(expression, constantsOnly))
                return false;
            }
            return true;
          } else {
            return isPureish(node);
          }
        }
        setData(key, val) {
          return this.data[key] = val;
        }
        getData(key) {
          let scope = this;
          do {
            const data = scope.data[key];
            if (data != null)
              return data;
          } while (scope = scope.parent);
        }
        removeData(key) {
          let scope = this;
          do {
            const data = scope.data[key];
            if (data != null)
              scope.data[key] = null;
          } while (scope = scope.parent);
        }
        init() {
          if (!this.inited) {
            this.inited = true;
            this.crawl();
          }
        }
        crawl() {
          const path = this.path;
          this.references = /* @__PURE__ */ Object.create(null);
          this.bindings = /* @__PURE__ */ Object.create(null);
          this.globals = /* @__PURE__ */ Object.create(null);
          this.uids = /* @__PURE__ */ Object.create(null);
          this.data = /* @__PURE__ */ Object.create(null);
          const programParent = this.getProgramParent();
          if (programParent.crawling)
            return;
          const state = {
            references: [],
            constantViolations: [],
            assignments: []
          };
          this.crawling = true;
          if (path.type !== "Program" && collectorVisitor._exploded) {
            for (const visit of collectorVisitor.enter) {
              visit(path, state);
            }
            const typeVisitors = collectorVisitor[path.type];
            if (typeVisitors) {
              for (const visit of typeVisitors.enter) {
                visit(path, state);
              }
            }
          }
          path.traverse(collectorVisitor, state);
          this.crawling = false;
          for (const path2 of state.assignments) {
            const ids = path2.getBindingIdentifiers();
            for (const name of Object.keys(ids)) {
              if (path2.scope.getBinding(name))
                continue;
              programParent.addGlobal(ids[name]);
            }
            path2.scope.registerConstantViolation(path2);
          }
          for (const ref of state.references) {
            const binding = ref.scope.getBinding(ref.node.name);
            if (binding) {
              binding.reference(ref);
            } else {
              programParent.addGlobal(ref.node);
            }
          }
          for (const path2 of state.constantViolations) {
            path2.scope.registerConstantViolation(path2);
          }
        }
        push(opts) {
          let path = this.path;
          if (path.isPattern()) {
            path = this.getPatternParent().path;
          } else if (!path.isBlockStatement() && !path.isProgram()) {
            path = this.getBlockParent().path;
          }
          if (path.isSwitchStatement()) {
            path = (this.getFunctionParent() || this.getProgramParent()).path;
          }
          if (path.isLoop() || path.isCatchClause() || path.isFunction()) {
            path.ensureBlock();
            path = path.get("body");
          }
          const unique = opts.unique;
          const kind = opts.kind || "var";
          const blockHoist = opts._blockHoist == null ? 2 : opts._blockHoist;
          const dataKey = `declaration:${kind}:${blockHoist}`;
          let declarPath = !unique && path.getData(dataKey);
          if (!declarPath) {
            const declar = variableDeclaration(kind, []);
            declar._blockHoist = blockHoist;
            [declarPath] = path.unshiftContainer("body", [declar]);
            if (!unique)
              path.setData(dataKey, declarPath);
          }
          const declarator = variableDeclarator(opts.id, opts.init);
          const len = declarPath.node.declarations.push(declarator);
          path.scope.registerBinding(kind, declarPath.get("declarations")[len - 1]);
        }
        getProgramParent() {
          let scope = this;
          do {
            if (scope.path.isProgram()) {
              return scope;
            }
          } while (scope = scope.parent);
          throw new Error("Couldn't find a Program");
        }
        getFunctionParent() {
          let scope = this;
          do {
            if (scope.path.isFunctionParent()) {
              return scope;
            }
          } while (scope = scope.parent);
          return null;
        }
        getBlockParent() {
          let scope = this;
          do {
            if (scope.path.isBlockParent()) {
              return scope;
            }
          } while (scope = scope.parent);
          throw new Error("We couldn't find a BlockStatement, For, Switch, Function, Loop or Program...");
        }
        getPatternParent() {
          let scope = this;
          do {
            if (!scope.path.isPattern()) {
              return scope.getBlockParent();
            }
          } while (scope = scope.parent.parent);
          throw new Error("We couldn't find a BlockStatement, For, Switch, Function, Loop or Program...");
        }
        getAllBindings() {
          const ids = /* @__PURE__ */ Object.create(null);
          let scope = this;
          do {
            for (const key of Object.keys(scope.bindings)) {
              if (key in ids === false) {
                ids[key] = scope.bindings[key];
              }
            }
            scope = scope.parent;
          } while (scope);
          return ids;
        }
        getAllBindingsOfKind(...kinds) {
          const ids = /* @__PURE__ */ Object.create(null);
          for (const kind of kinds) {
            let scope = this;
            do {
              for (const name of Object.keys(scope.bindings)) {
                const binding = scope.bindings[name];
                if (binding.kind === kind)
                  ids[name] = binding;
              }
              scope = scope.parent;
            } while (scope);
          }
          return ids;
        }
        bindingIdentifierEquals(name, node) {
          return this.getBindingIdentifier(name) === node;
        }
        getBinding(name) {
          let scope = this;
          let previousPath;
          do {
            const binding = scope.getOwnBinding(name);
            if (binding) {
              var _previousPath;
              if ((_previousPath = previousPath) != null && _previousPath.isPattern() && binding.kind !== "param" && binding.kind !== "local") {
              } else {
                return binding;
              }
            } else if (!binding && name === "arguments" && scope.path.isFunction() && !scope.path.isArrowFunctionExpression()) {
              break;
            }
            previousPath = scope.path;
          } while (scope = scope.parent);
        }
        getOwnBinding(name) {
          return this.bindings[name];
        }
        getBindingIdentifier(name) {
          var _this$getBinding;
          return (_this$getBinding = this.getBinding(name)) == null ? void 0 : _this$getBinding.identifier;
        }
        getOwnBindingIdentifier(name) {
          const binding = this.bindings[name];
          return binding == null ? void 0 : binding.identifier;
        }
        hasOwnBinding(name) {
          return !!this.getOwnBinding(name);
        }
        hasBinding(name, noGlobals) {
          if (!name)
            return false;
          if (this.hasOwnBinding(name))
            return true;
          if (this.parentHasBinding(name, noGlobals))
            return true;
          if (this.hasUid(name))
            return true;
          if (!noGlobals && Scope2.globals.includes(name))
            return true;
          if (!noGlobals && Scope2.contextVariables.includes(name))
            return true;
          return false;
        }
        parentHasBinding(name, noGlobals) {
          var _this$parent;
          return (_this$parent = this.parent) == null ? void 0 : _this$parent.hasBinding(name, noGlobals);
        }
        moveBindingTo(name, scope) {
          const info = this.getBinding(name);
          if (info) {
            info.scope.removeOwnBinding(name);
            info.scope = scope;
            scope.bindings[name] = info;
          }
        }
        removeOwnBinding(name) {
          delete this.bindings[name];
        }
        removeBinding(name) {
          var _this$getBinding2;
          (_this$getBinding2 = this.getBinding(name)) == null ? void 0 : _this$getBinding2.scope.removeOwnBinding(name);
          let scope = this;
          do {
            if (scope.uids[name]) {
              scope.uids[name] = false;
            }
          } while (scope = scope.parent);
        }
      };
      exports2.default = Scope2;
      Scope2.globals = Object.keys(_globals.builtin);
      Scope2.contextVariables = ["arguments", "undefined", "Infinity", "NaN"];
    }
  });

  // node_modules/@babel/traverse/lib/path/ancestry.js
  var require_ancestry = __commonJS({
    "node_modules/@babel/traverse/lib/path/ancestry.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.find = find2;
      exports2.findParent = findParent;
      exports2.getAncestry = getAncestry;
      exports2.getDeepestCommonAncestorFrom = getDeepestCommonAncestorFrom;
      exports2.getEarliestCommonAncestorFrom = getEarliestCommonAncestorFrom;
      exports2.getFunctionParent = getFunctionParent;
      exports2.getStatementParent = getStatementParent;
      exports2.inType = inType;
      exports2.isAncestor = isAncestor;
      exports2.isDescendant = isDescendant;
      var _t = require_lib5();
      var {
        VISITOR_KEYS
      } = _t;
      function findParent(callback) {
        let path = this;
        while (path = path.parentPath) {
          if (callback(path))
            return path;
        }
        return null;
      }
      function find2(callback) {
        let path = this;
        do {
          if (callback(path))
            return path;
        } while (path = path.parentPath);
        return null;
      }
      function getFunctionParent() {
        return this.findParent((p) => p.isFunction());
      }
      function getStatementParent() {
        let path = this;
        do {
          if (!path.parentPath || Array.isArray(path.container) && path.isStatement()) {
            break;
          } else {
            path = path.parentPath;
          }
        } while (path);
        if (path && (path.isProgram() || path.isFile())) {
          throw new Error("File/Program node, we can't possibly find a statement parent to this");
        }
        return path;
      }
      function getEarliestCommonAncestorFrom(paths) {
        return this.getDeepestCommonAncestorFrom(paths, function(deepest, i, ancestries) {
          let earliest;
          const keys2 = VISITOR_KEYS[deepest.type];
          for (const ancestry of ancestries) {
            const path = ancestry[i + 1];
            if (!earliest) {
              earliest = path;
              continue;
            }
            if (path.listKey && earliest.listKey === path.listKey) {
              if (path.key < earliest.key) {
                earliest = path;
                continue;
              }
            }
            const earliestKeyIndex = keys2.indexOf(earliest.parentKey);
            const currentKeyIndex = keys2.indexOf(path.parentKey);
            if (earliestKeyIndex > currentKeyIndex) {
              earliest = path;
            }
          }
          return earliest;
        });
      }
      function getDeepestCommonAncestorFrom(paths, filter2) {
        if (!paths.length) {
          return this;
        }
        if (paths.length === 1) {
          return paths[0];
        }
        let minDepth = Infinity;
        let lastCommonIndex, lastCommon;
        const ancestries = paths.map((path) => {
          const ancestry = [];
          do {
            ancestry.unshift(path);
          } while ((path = path.parentPath) && path !== this);
          if (ancestry.length < minDepth) {
            minDepth = ancestry.length;
          }
          return ancestry;
        });
        const first = ancestries[0];
        depthLoop:
          for (let i = 0; i < minDepth; i++) {
            const shouldMatch = first[i];
            for (const ancestry of ancestries) {
              if (ancestry[i] !== shouldMatch) {
                break depthLoop;
              }
            }
            lastCommonIndex = i;
            lastCommon = shouldMatch;
          }
        if (lastCommon) {
          if (filter2) {
            return filter2(lastCommon, lastCommonIndex, ancestries);
          } else {
            return lastCommon;
          }
        } else {
          throw new Error("Couldn't find intersection");
        }
      }
      function getAncestry() {
        let path = this;
        const paths = [];
        do {
          paths.push(path);
        } while (path = path.parentPath);
        return paths;
      }
      function isAncestor(maybeDescendant) {
        return maybeDescendant.isDescendant(this);
      }
      function isDescendant(maybeAncestor) {
        return !!this.findParent((parent2) => parent2 === maybeAncestor);
      }
      function inType(...candidateTypes) {
        let path = this;
        while (path) {
          for (const type of candidateTypes) {
            if (path.node.type === type)
              return true;
          }
          path = path.parentPath;
        }
        return false;
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/inference/util.js
  var require_util4 = __commonJS({
    "node_modules/@babel/traverse/lib/path/inference/util.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.createUnionType = createUnionType;
      var _t = require_lib5();
      var {
        createFlowUnionType,
        createTSUnionType,
        createUnionTypeAnnotation,
        isFlowType,
        isTSType
      } = _t;
      function createUnionType(types) {
        {
          if (isFlowType(types[0])) {
            if (createFlowUnionType) {
              return createFlowUnionType(types);
            }
            return createUnionTypeAnnotation(types);
          } else {
            if (createTSUnionType) {
              return createTSUnionType(types);
            }
          }
        }
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/inference/inferer-reference.js
  var require_inferer_reference = __commonJS({
    "node_modules/@babel/traverse/lib/path/inference/inferer-reference.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = _default;
      var _t = require_lib5();
      var _util = require_util4();
      var {
        BOOLEAN_NUMBER_BINARY_OPERATORS,
        createTypeAnnotationBasedOnTypeof,
        numberTypeAnnotation,
        voidTypeAnnotation
      } = _t;
      function _default(node) {
        if (!this.isReferenced())
          return;
        const binding = this.scope.getBinding(node.name);
        if (binding) {
          if (binding.identifier.typeAnnotation) {
            return binding.identifier.typeAnnotation;
          } else {
            return getTypeAnnotationBindingConstantViolations(binding, this, node.name);
          }
        }
        if (node.name === "undefined") {
          return voidTypeAnnotation();
        } else if (node.name === "NaN" || node.name === "Infinity") {
          return numberTypeAnnotation();
        } else if (node.name === "arguments") {
        }
      }
      function getTypeAnnotationBindingConstantViolations(binding, path, name) {
        const types = [];
        const functionConstantViolations = [];
        let constantViolations = getConstantViolationsBefore(binding, path, functionConstantViolations);
        const testType = getConditionalAnnotation(binding, path, name);
        if (testType) {
          const testConstantViolations = getConstantViolationsBefore(binding, testType.ifStatement);
          constantViolations = constantViolations.filter((path2) => testConstantViolations.indexOf(path2) < 0);
          types.push(testType.typeAnnotation);
        }
        if (constantViolations.length) {
          constantViolations.push(...functionConstantViolations);
          for (const violation of constantViolations) {
            types.push(violation.getTypeAnnotation());
          }
        }
        if (!types.length) {
          return;
        }
        return (0, _util.createUnionType)(types);
      }
      function getConstantViolationsBefore(binding, path, functions2) {
        const violations = binding.constantViolations.slice();
        violations.unshift(binding.path);
        return violations.filter((violation) => {
          violation = violation.resolve();
          const status = violation._guessExecutionStatusRelativeTo(path);
          if (functions2 && status === "unknown")
            functions2.push(violation);
          return status === "before";
        });
      }
      function inferAnnotationFromBinaryExpression(name, path) {
        const operator = path.node.operator;
        const right = path.get("right").resolve();
        const left = path.get("left").resolve();
        let target;
        if (left.isIdentifier({
          name
        })) {
          target = right;
        } else if (right.isIdentifier({
          name
        })) {
          target = left;
        }
        if (target) {
          if (operator === "===") {
            return target.getTypeAnnotation();
          }
          if (BOOLEAN_NUMBER_BINARY_OPERATORS.indexOf(operator) >= 0) {
            return numberTypeAnnotation();
          }
          return;
        }
        if (operator !== "===" && operator !== "==")
          return;
        let typeofPath;
        let typePath;
        if (left.isUnaryExpression({
          operator: "typeof"
        })) {
          typeofPath = left;
          typePath = right;
        } else if (right.isUnaryExpression({
          operator: "typeof"
        })) {
          typeofPath = right;
          typePath = left;
        }
        if (!typeofPath)
          return;
        if (!typeofPath.get("argument").isIdentifier({
          name
        }))
          return;
        typePath = typePath.resolve();
        if (!typePath.isLiteral())
          return;
        const typeValue = typePath.node.value;
        if (typeof typeValue !== "string")
          return;
        return createTypeAnnotationBasedOnTypeof(typeValue);
      }
      function getParentConditionalPath(binding, path, name) {
        let parentPath;
        while (parentPath = path.parentPath) {
          if (parentPath.isIfStatement() || parentPath.isConditionalExpression()) {
            if (path.key === "test") {
              return;
            }
            return parentPath;
          }
          if (parentPath.isFunction()) {
            if (parentPath.parentPath.scope.getBinding(name) !== binding)
              return;
          }
          path = parentPath;
        }
      }
      function getConditionalAnnotation(binding, path, name) {
        const ifStatement = getParentConditionalPath(binding, path, name);
        if (!ifStatement)
          return;
        const test = ifStatement.get("test");
        const paths = [test];
        const types = [];
        for (let i = 0; i < paths.length; i++) {
          const path2 = paths[i];
          if (path2.isLogicalExpression()) {
            if (path2.node.operator === "&&") {
              paths.push(path2.get("left"));
              paths.push(path2.get("right"));
            }
          } else if (path2.isBinaryExpression()) {
            const type = inferAnnotationFromBinaryExpression(name, path2);
            if (type)
              types.push(type);
          }
        }
        if (types.length) {
          return {
            typeAnnotation: (0, _util.createUnionType)(types),
            ifStatement
          };
        }
        return getConditionalAnnotation(binding, ifStatement, name);
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/inference/inferers.js
  var require_inferers = __commonJS({
    "node_modules/@babel/traverse/lib/path/inference/inferers.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ArrayExpression = ArrayExpression;
      exports2.AssignmentExpression = AssignmentExpression;
      exports2.BinaryExpression = BinaryExpression;
      exports2.BooleanLiteral = BooleanLiteral;
      exports2.CallExpression = CallExpression;
      exports2.ConditionalExpression = ConditionalExpression;
      exports2.ClassDeclaration = exports2.ClassExpression = exports2.FunctionDeclaration = exports2.ArrowFunctionExpression = exports2.FunctionExpression = Func;
      Object.defineProperty(exports2, "Identifier", {
        enumerable: true,
        get: function() {
          return _infererReference.default;
        }
      });
      exports2.LogicalExpression = LogicalExpression;
      exports2.NewExpression = NewExpression;
      exports2.NullLiteral = NullLiteral;
      exports2.NumericLiteral = NumericLiteral;
      exports2.ObjectExpression = ObjectExpression;
      exports2.ParenthesizedExpression = ParenthesizedExpression;
      exports2.RegExpLiteral = RegExpLiteral;
      exports2.RestElement = RestElement;
      exports2.SequenceExpression = SequenceExpression;
      exports2.StringLiteral = StringLiteral;
      exports2.TSAsExpression = TSAsExpression;
      exports2.TSNonNullExpression = TSNonNullExpression;
      exports2.TaggedTemplateExpression = TaggedTemplateExpression;
      exports2.TemplateLiteral = TemplateLiteral;
      exports2.TypeCastExpression = TypeCastExpression;
      exports2.UnaryExpression = UnaryExpression;
      exports2.UpdateExpression = UpdateExpression;
      exports2.VariableDeclarator = VariableDeclarator;
      var _t = require_lib5();
      var _infererReference = require_inferer_reference();
      var _util = require_util4();
      var {
        BOOLEAN_BINARY_OPERATORS,
        BOOLEAN_UNARY_OPERATORS,
        NUMBER_BINARY_OPERATORS,
        NUMBER_UNARY_OPERATORS,
        STRING_UNARY_OPERATORS,
        anyTypeAnnotation,
        arrayTypeAnnotation,
        booleanTypeAnnotation,
        buildMatchMemberExpression,
        genericTypeAnnotation,
        identifier: identifier3,
        nullLiteralTypeAnnotation,
        numberTypeAnnotation,
        stringTypeAnnotation,
        tupleTypeAnnotation,
        unionTypeAnnotation,
        voidTypeAnnotation,
        isIdentifier: isIdentifier2
      } = _t;
      function VariableDeclarator() {
        if (!this.get("id").isIdentifier())
          return;
        return this.get("init").getTypeAnnotation();
      }
      function TypeCastExpression(node) {
        return node.typeAnnotation;
      }
      TypeCastExpression.validParent = true;
      function TSAsExpression(node) {
        return node.typeAnnotation;
      }
      TSAsExpression.validParent = true;
      function TSNonNullExpression() {
        return this.get("expression").getTypeAnnotation();
      }
      function NewExpression(node) {
        if (node.callee.type === "Identifier") {
          return genericTypeAnnotation(node.callee);
        }
      }
      function TemplateLiteral() {
        return stringTypeAnnotation();
      }
      function UnaryExpression(node) {
        const operator = node.operator;
        if (operator === "void") {
          return voidTypeAnnotation();
        } else if (NUMBER_UNARY_OPERATORS.indexOf(operator) >= 0) {
          return numberTypeAnnotation();
        } else if (STRING_UNARY_OPERATORS.indexOf(operator) >= 0) {
          return stringTypeAnnotation();
        } else if (BOOLEAN_UNARY_OPERATORS.indexOf(operator) >= 0) {
          return booleanTypeAnnotation();
        }
      }
      function BinaryExpression(node) {
        const operator = node.operator;
        if (NUMBER_BINARY_OPERATORS.indexOf(operator) >= 0) {
          return numberTypeAnnotation();
        } else if (BOOLEAN_BINARY_OPERATORS.indexOf(operator) >= 0) {
          return booleanTypeAnnotation();
        } else if (operator === "+") {
          const right = this.get("right");
          const left = this.get("left");
          if (left.isBaseType("number") && right.isBaseType("number")) {
            return numberTypeAnnotation();
          } else if (left.isBaseType("string") || right.isBaseType("string")) {
            return stringTypeAnnotation();
          }
          return unionTypeAnnotation([stringTypeAnnotation(), numberTypeAnnotation()]);
        }
      }
      function LogicalExpression() {
        const argumentTypes = [this.get("left").getTypeAnnotation(), this.get("right").getTypeAnnotation()];
        return (0, _util.createUnionType)(argumentTypes);
      }
      function ConditionalExpression() {
        const argumentTypes = [this.get("consequent").getTypeAnnotation(), this.get("alternate").getTypeAnnotation()];
        return (0, _util.createUnionType)(argumentTypes);
      }
      function SequenceExpression() {
        return this.get("expressions").pop().getTypeAnnotation();
      }
      function ParenthesizedExpression() {
        return this.get("expression").getTypeAnnotation();
      }
      function AssignmentExpression() {
        return this.get("right").getTypeAnnotation();
      }
      function UpdateExpression(node) {
        const operator = node.operator;
        if (operator === "++" || operator === "--") {
          return numberTypeAnnotation();
        }
      }
      function StringLiteral() {
        return stringTypeAnnotation();
      }
      function NumericLiteral() {
        return numberTypeAnnotation();
      }
      function BooleanLiteral() {
        return booleanTypeAnnotation();
      }
      function NullLiteral() {
        return nullLiteralTypeAnnotation();
      }
      function RegExpLiteral() {
        return genericTypeAnnotation(identifier3("RegExp"));
      }
      function ObjectExpression() {
        return genericTypeAnnotation(identifier3("Object"));
      }
      function ArrayExpression() {
        return genericTypeAnnotation(identifier3("Array"));
      }
      function RestElement() {
        return ArrayExpression();
      }
      RestElement.validParent = true;
      function Func() {
        return genericTypeAnnotation(identifier3("Function"));
      }
      var isArrayFrom = buildMatchMemberExpression("Array.from");
      var isObjectKeys = buildMatchMemberExpression("Object.keys");
      var isObjectValues = buildMatchMemberExpression("Object.values");
      var isObjectEntries = buildMatchMemberExpression("Object.entries");
      function CallExpression() {
        const {
          callee
        } = this.node;
        if (isObjectKeys(callee)) {
          return arrayTypeAnnotation(stringTypeAnnotation());
        } else if (isArrayFrom(callee) || isObjectValues(callee) || isIdentifier2(callee, {
          name: "Array"
        })) {
          return arrayTypeAnnotation(anyTypeAnnotation());
        } else if (isObjectEntries(callee)) {
          return arrayTypeAnnotation(tupleTypeAnnotation([stringTypeAnnotation(), anyTypeAnnotation()]));
        }
        return resolveCall(this.get("callee"));
      }
      function TaggedTemplateExpression() {
        return resolveCall(this.get("tag"));
      }
      function resolveCall(callee) {
        callee = callee.resolve();
        if (callee.isFunction()) {
          const {
            node
          } = callee;
          if (node.async) {
            if (node.generator) {
              return genericTypeAnnotation(identifier3("AsyncIterator"));
            } else {
              return genericTypeAnnotation(identifier3("Promise"));
            }
          } else {
            if (node.generator) {
              return genericTypeAnnotation(identifier3("Iterator"));
            } else if (callee.node.returnType) {
              return callee.node.returnType;
            } else {
            }
          }
        }
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/inference/index.js
  var require_inference = __commonJS({
    "node_modules/@babel/traverse/lib/path/inference/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._getTypeAnnotation = _getTypeAnnotation;
      exports2.baseTypeStrictlyMatches = baseTypeStrictlyMatches;
      exports2.couldBeBaseType = couldBeBaseType;
      exports2.getTypeAnnotation = getTypeAnnotation;
      exports2.isBaseType = isBaseType;
      exports2.isGenericType = isGenericType;
      var inferers = require_inferers();
      var _t = require_lib5();
      var {
        anyTypeAnnotation,
        isAnyTypeAnnotation,
        isArrayTypeAnnotation,
        isBooleanTypeAnnotation,
        isEmptyTypeAnnotation,
        isFlowBaseAnnotation,
        isGenericTypeAnnotation,
        isIdentifier: isIdentifier2,
        isMixedTypeAnnotation,
        isNumberTypeAnnotation,
        isStringTypeAnnotation,
        isTSArrayType,
        isTSTypeAnnotation,
        isTSTypeReference,
        isTupleTypeAnnotation,
        isTypeAnnotation,
        isUnionTypeAnnotation,
        isVoidTypeAnnotation,
        stringTypeAnnotation,
        voidTypeAnnotation
      } = _t;
      function getTypeAnnotation() {
        let type = this.getData("typeAnnotation");
        if (type != null) {
          return type;
        }
        type = this._getTypeAnnotation() || anyTypeAnnotation();
        if (isTypeAnnotation(type) || isTSTypeAnnotation(type)) {
          type = type.typeAnnotation;
        }
        this.setData("typeAnnotation", type);
        return type;
      }
      var typeAnnotationInferringNodes = /* @__PURE__ */ new WeakSet();
      function _getTypeAnnotation() {
        const node = this.node;
        if (!node) {
          if (this.key === "init" && this.parentPath.isVariableDeclarator()) {
            const declar = this.parentPath.parentPath;
            const declarParent = declar.parentPath;
            if (declar.key === "left" && declarParent.isForInStatement()) {
              return stringTypeAnnotation();
            }
            if (declar.key === "left" && declarParent.isForOfStatement()) {
              return anyTypeAnnotation();
            }
            return voidTypeAnnotation();
          } else {
            return;
          }
        }
        if (node.typeAnnotation) {
          return node.typeAnnotation;
        }
        if (typeAnnotationInferringNodes.has(node)) {
          return;
        }
        typeAnnotationInferringNodes.add(node);
        try {
          var _inferer;
          let inferer = inferers[node.type];
          if (inferer) {
            return inferer.call(this, node);
          }
          inferer = inferers[this.parentPath.type];
          if ((_inferer = inferer) != null && _inferer.validParent) {
            return this.parentPath.getTypeAnnotation();
          }
        } finally {
          typeAnnotationInferringNodes.delete(node);
        }
      }
      function isBaseType(baseName, soft) {
        return _isBaseType(baseName, this.getTypeAnnotation(), soft);
      }
      function _isBaseType(baseName, type, soft) {
        if (baseName === "string") {
          return isStringTypeAnnotation(type);
        } else if (baseName === "number") {
          return isNumberTypeAnnotation(type);
        } else if (baseName === "boolean") {
          return isBooleanTypeAnnotation(type);
        } else if (baseName === "any") {
          return isAnyTypeAnnotation(type);
        } else if (baseName === "mixed") {
          return isMixedTypeAnnotation(type);
        } else if (baseName === "empty") {
          return isEmptyTypeAnnotation(type);
        } else if (baseName === "void") {
          return isVoidTypeAnnotation(type);
        } else {
          if (soft) {
            return false;
          } else {
            throw new Error(`Unknown base type ${baseName}`);
          }
        }
      }
      function couldBeBaseType(name) {
        const type = this.getTypeAnnotation();
        if (isAnyTypeAnnotation(type))
          return true;
        if (isUnionTypeAnnotation(type)) {
          for (const type2 of type.types) {
            if (isAnyTypeAnnotation(type2) || _isBaseType(name, type2, true)) {
              return true;
            }
          }
          return false;
        } else {
          return _isBaseType(name, type, true);
        }
      }
      function baseTypeStrictlyMatches(rightArg) {
        const left = this.getTypeAnnotation();
        const right = rightArg.getTypeAnnotation();
        if (!isAnyTypeAnnotation(left) && isFlowBaseAnnotation(left)) {
          return right.type === left.type;
        }
        return false;
      }
      function isGenericType(genericName) {
        const type = this.getTypeAnnotation();
        if (genericName === "Array") {
          if (isTSArrayType(type) || isArrayTypeAnnotation(type) || isTupleTypeAnnotation(type)) {
            return true;
          }
        }
        return isGenericTypeAnnotation(type) && isIdentifier2(type.id, {
          name: genericName
        }) || isTSTypeReference(type) && isIdentifier2(type.typeName, {
          name: genericName
        });
      }
    }
  });

  // node_modules/js-tokens/index.js
  var require_js_tokens = __commonJS({
    "node_modules/js-tokens/index.js"(exports2) {
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = /((['"])(?:(?!\2|\\).|\\(?:\r\n|[\s\S]))*(\2)?|`(?:[^`\\$]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{[^}]*\}?)*\}?)*(`)?)|(\/\/.*)|(\/\*(?:[^*]|\*(?!\/))*(\*\/)?)|(\/(?!\*)(?:\[(?:(?![\]\\]).|\\.)*\]|(?![\/\]\\]).|\\.)+\/(?:(?!\s*(?:\b|[\u0080-\uFFFF$\\'"~({]|[+\-!](?!=)|\.?\d))|[gmiyus]{1,6}\b(?![\u0080-\uFFFF$\\]|\s*(?:[+\-*%&|^<>!=?({]|\/(?![\/*])))))|(0[xX][\da-fA-F]+|0[oO][0-7]+|0[bB][01]+|(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?)|((?!\d)(?:(?!\s)[$\w\u0080-\uFFFF]|\\u[\da-fA-F]{4}|\\u\{[\da-fA-F]+\})+)|(--|\+\+|&&|\|\||=>|\.{3}|(?:[+\-\/%&|^]|\*{1,2}|<{1,2}|>{1,3}|!=?|={1,2})=?|[?~.,:;[\](){}])|(\s+)|(^$|[\s\S])/g;
      exports2.matchToToken = function(match) {
        var token = { type: "invalid", value: match[0], closed: void 0 };
        if (match[1])
          token.type = "string", token.closed = !!(match[3] || match[4]);
        else if (match[5])
          token.type = "comment";
        else if (match[6])
          token.type = "comment", token.closed = !!match[7];
        else if (match[8])
          token.type = "regex";
        else if (match[9])
          token.type = "number";
        else if (match[10])
          token.type = "name";
        else if (match[11])
          token.type = "punctuator";
        else if (match[12])
          token.type = "whitespace";
        return token;
      };
    }
  });

  // node_modules/escape-string-regexp/index.js
  var require_escape_string_regexp = __commonJS({
    "node_modules/escape-string-regexp/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
      module2.exports = function(str) {
        if (typeof str !== "string") {
          throw new TypeError("Expected a string");
        }
        return str.replace(matchOperatorsRe, "\\$&");
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/color-name/index.js
  var require_color_name = __commonJS({
    "node_modules/@babel/highlight/node_modules/color-name/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = {
        "aliceblue": [240, 248, 255],
        "antiquewhite": [250, 235, 215],
        "aqua": [0, 255, 255],
        "aquamarine": [127, 255, 212],
        "azure": [240, 255, 255],
        "beige": [245, 245, 220],
        "bisque": [255, 228, 196],
        "black": [0, 0, 0],
        "blanchedalmond": [255, 235, 205],
        "blue": [0, 0, 255],
        "blueviolet": [138, 43, 226],
        "brown": [165, 42, 42],
        "burlywood": [222, 184, 135],
        "cadetblue": [95, 158, 160],
        "chartreuse": [127, 255, 0],
        "chocolate": [210, 105, 30],
        "coral": [255, 127, 80],
        "cornflowerblue": [100, 149, 237],
        "cornsilk": [255, 248, 220],
        "crimson": [220, 20, 60],
        "cyan": [0, 255, 255],
        "darkblue": [0, 0, 139],
        "darkcyan": [0, 139, 139],
        "darkgoldenrod": [184, 134, 11],
        "darkgray": [169, 169, 169],
        "darkgreen": [0, 100, 0],
        "darkgrey": [169, 169, 169],
        "darkkhaki": [189, 183, 107],
        "darkmagenta": [139, 0, 139],
        "darkolivegreen": [85, 107, 47],
        "darkorange": [255, 140, 0],
        "darkorchid": [153, 50, 204],
        "darkred": [139, 0, 0],
        "darksalmon": [233, 150, 122],
        "darkseagreen": [143, 188, 143],
        "darkslateblue": [72, 61, 139],
        "darkslategray": [47, 79, 79],
        "darkslategrey": [47, 79, 79],
        "darkturquoise": [0, 206, 209],
        "darkviolet": [148, 0, 211],
        "deeppink": [255, 20, 147],
        "deepskyblue": [0, 191, 255],
        "dimgray": [105, 105, 105],
        "dimgrey": [105, 105, 105],
        "dodgerblue": [30, 144, 255],
        "firebrick": [178, 34, 34],
        "floralwhite": [255, 250, 240],
        "forestgreen": [34, 139, 34],
        "fuchsia": [255, 0, 255],
        "gainsboro": [220, 220, 220],
        "ghostwhite": [248, 248, 255],
        "gold": [255, 215, 0],
        "goldenrod": [218, 165, 32],
        "gray": [128, 128, 128],
        "green": [0, 128, 0],
        "greenyellow": [173, 255, 47],
        "grey": [128, 128, 128],
        "honeydew": [240, 255, 240],
        "hotpink": [255, 105, 180],
        "indianred": [205, 92, 92],
        "indigo": [75, 0, 130],
        "ivory": [255, 255, 240],
        "khaki": [240, 230, 140],
        "lavender": [230, 230, 250],
        "lavenderblush": [255, 240, 245],
        "lawngreen": [124, 252, 0],
        "lemonchiffon": [255, 250, 205],
        "lightblue": [173, 216, 230],
        "lightcoral": [240, 128, 128],
        "lightcyan": [224, 255, 255],
        "lightgoldenrodyellow": [250, 250, 210],
        "lightgray": [211, 211, 211],
        "lightgreen": [144, 238, 144],
        "lightgrey": [211, 211, 211],
        "lightpink": [255, 182, 193],
        "lightsalmon": [255, 160, 122],
        "lightseagreen": [32, 178, 170],
        "lightskyblue": [135, 206, 250],
        "lightslategray": [119, 136, 153],
        "lightslategrey": [119, 136, 153],
        "lightsteelblue": [176, 196, 222],
        "lightyellow": [255, 255, 224],
        "lime": [0, 255, 0],
        "limegreen": [50, 205, 50],
        "linen": [250, 240, 230],
        "magenta": [255, 0, 255],
        "maroon": [128, 0, 0],
        "mediumaquamarine": [102, 205, 170],
        "mediumblue": [0, 0, 205],
        "mediumorchid": [186, 85, 211],
        "mediumpurple": [147, 112, 219],
        "mediumseagreen": [60, 179, 113],
        "mediumslateblue": [123, 104, 238],
        "mediumspringgreen": [0, 250, 154],
        "mediumturquoise": [72, 209, 204],
        "mediumvioletred": [199, 21, 133],
        "midnightblue": [25, 25, 112],
        "mintcream": [245, 255, 250],
        "mistyrose": [255, 228, 225],
        "moccasin": [255, 228, 181],
        "navajowhite": [255, 222, 173],
        "navy": [0, 0, 128],
        "oldlace": [253, 245, 230],
        "olive": [128, 128, 0],
        "olivedrab": [107, 142, 35],
        "orange": [255, 165, 0],
        "orangered": [255, 69, 0],
        "orchid": [218, 112, 214],
        "palegoldenrod": [238, 232, 170],
        "palegreen": [152, 251, 152],
        "paleturquoise": [175, 238, 238],
        "palevioletred": [219, 112, 147],
        "papayawhip": [255, 239, 213],
        "peachpuff": [255, 218, 185],
        "peru": [205, 133, 63],
        "pink": [255, 192, 203],
        "plum": [221, 160, 221],
        "powderblue": [176, 224, 230],
        "purple": [128, 0, 128],
        "rebeccapurple": [102, 51, 153],
        "red": [255, 0, 0],
        "rosybrown": [188, 143, 143],
        "royalblue": [65, 105, 225],
        "saddlebrown": [139, 69, 19],
        "salmon": [250, 128, 114],
        "sandybrown": [244, 164, 96],
        "seagreen": [46, 139, 87],
        "seashell": [255, 245, 238],
        "sienna": [160, 82, 45],
        "silver": [192, 192, 192],
        "skyblue": [135, 206, 235],
        "slateblue": [106, 90, 205],
        "slategray": [112, 128, 144],
        "slategrey": [112, 128, 144],
        "snow": [255, 250, 250],
        "springgreen": [0, 255, 127],
        "steelblue": [70, 130, 180],
        "tan": [210, 180, 140],
        "teal": [0, 128, 128],
        "thistle": [216, 191, 216],
        "tomato": [255, 99, 71],
        "turquoise": [64, 224, 208],
        "violet": [238, 130, 238],
        "wheat": [245, 222, 179],
        "white": [255, 255, 255],
        "whitesmoke": [245, 245, 245],
        "yellow": [255, 255, 0],
        "yellowgreen": [154, 205, 50]
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/color-convert/conversions.js
  var require_conversions = __commonJS({
    "node_modules/@babel/highlight/node_modules/color-convert/conversions.js"(exports2, module2) {
      init_define_process();
      var cssKeywords = require_color_name();
      var reverseKeywords = {};
      for (key in cssKeywords) {
        if (cssKeywords.hasOwnProperty(key)) {
          reverseKeywords[cssKeywords[key]] = key;
        }
      }
      var key;
      var convert = module2.exports = {
        rgb: { channels: 3, labels: "rgb" },
        hsl: { channels: 3, labels: "hsl" },
        hsv: { channels: 3, labels: "hsv" },
        hwb: { channels: 3, labels: "hwb" },
        cmyk: { channels: 4, labels: "cmyk" },
        xyz: { channels: 3, labels: "xyz" },
        lab: { channels: 3, labels: "lab" },
        lch: { channels: 3, labels: "lch" },
        hex: { channels: 1, labels: ["hex"] },
        keyword: { channels: 1, labels: ["keyword"] },
        ansi16: { channels: 1, labels: ["ansi16"] },
        ansi256: { channels: 1, labels: ["ansi256"] },
        hcg: { channels: 3, labels: ["h", "c", "g"] },
        apple: { channels: 3, labels: ["r16", "g16", "b16"] },
        gray: { channels: 1, labels: ["gray"] }
      };
      for (model in convert) {
        if (convert.hasOwnProperty(model)) {
          if (!("channels" in convert[model])) {
            throw new Error("missing channels property: " + model);
          }
          if (!("labels" in convert[model])) {
            throw new Error("missing channel labels property: " + model);
          }
          if (convert[model].labels.length !== convert[model].channels) {
            throw new Error("channel and label counts mismatch: " + model);
          }
          channels = convert[model].channels;
          labels = convert[model].labels;
          delete convert[model].channels;
          delete convert[model].labels;
          Object.defineProperty(convert[model], "channels", { value: channels });
          Object.defineProperty(convert[model], "labels", { value: labels });
        }
      }
      var channels;
      var labels;
      var model;
      convert.rgb.hsl = function(rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var min2 = Math.min(r, g, b);
        var max2 = Math.max(r, g, b);
        var delta = max2 - min2;
        var h;
        var s;
        var l;
        if (max2 === min2) {
          h = 0;
        } else if (r === max2) {
          h = (g - b) / delta;
        } else if (g === max2) {
          h = 2 + (b - r) / delta;
        } else if (b === max2) {
          h = 4 + (r - g) / delta;
        }
        h = Math.min(h * 60, 360);
        if (h < 0) {
          h += 360;
        }
        l = (min2 + max2) / 2;
        if (max2 === min2) {
          s = 0;
        } else if (l <= 0.5) {
          s = delta / (max2 + min2);
        } else {
          s = delta / (2 - max2 - min2);
        }
        return [h, s * 100, l * 100];
      };
      convert.rgb.hsv = function(rgb) {
        var rdif;
        var gdif;
        var bdif;
        var h;
        var s;
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var v = Math.max(r, g, b);
        var diff = v - Math.min(r, g, b);
        var diffc = function(c) {
          return (v - c) / 6 / diff + 1 / 2;
        };
        if (diff === 0) {
          h = s = 0;
        } else {
          s = diff / v;
          rdif = diffc(r);
          gdif = diffc(g);
          bdif = diffc(b);
          if (r === v) {
            h = bdif - gdif;
          } else if (g === v) {
            h = 1 / 3 + rdif - bdif;
          } else if (b === v) {
            h = 2 / 3 + gdif - rdif;
          }
          if (h < 0) {
            h += 1;
          } else if (h > 1) {
            h -= 1;
          }
        }
        return [
          h * 360,
          s * 100,
          v * 100
        ];
      };
      convert.rgb.hwb = function(rgb) {
        var r = rgb[0];
        var g = rgb[1];
        var b = rgb[2];
        var h = convert.rgb.hsl(rgb)[0];
        var w = 1 / 255 * Math.min(r, Math.min(g, b));
        b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
        return [h, w * 100, b * 100];
      };
      convert.rgb.cmyk = function(rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var c;
        var m;
        var y;
        var k;
        k = Math.min(1 - r, 1 - g, 1 - b);
        c = (1 - r - k) / (1 - k) || 0;
        m = (1 - g - k) / (1 - k) || 0;
        y = (1 - b - k) / (1 - k) || 0;
        return [c * 100, m * 100, y * 100, k * 100];
      };
      function comparativeDistance(x, y) {
        return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
      }
      convert.rgb.keyword = function(rgb) {
        var reversed = reverseKeywords[rgb];
        if (reversed) {
          return reversed;
        }
        var currentClosestDistance = Infinity;
        var currentClosestKeyword;
        for (var keyword in cssKeywords) {
          if (cssKeywords.hasOwnProperty(keyword)) {
            var value = cssKeywords[keyword];
            var distance = comparativeDistance(rgb, value);
            if (distance < currentClosestDistance) {
              currentClosestDistance = distance;
              currentClosestKeyword = keyword;
            }
          }
        }
        return currentClosestKeyword;
      };
      convert.keyword.rgb = function(keyword) {
        return cssKeywords[keyword];
      };
      convert.rgb.xyz = function(rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
        var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
        var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
        return [x * 100, y * 100, z * 100];
      };
      convert.rgb.lab = function(rgb) {
        var xyz = convert.rgb.xyz(rgb);
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 8856e-6 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 8856e-6 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 8856e-6 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.hsl.rgb = function(hsl) {
        var h = hsl[0] / 360;
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var t1;
        var t22;
        var t3;
        var rgb;
        var val;
        if (s === 0) {
          val = l * 255;
          return [val, val, val];
        }
        if (l < 0.5) {
          t22 = l * (1 + s);
        } else {
          t22 = l + s - l * s;
        }
        t1 = 2 * l - t22;
        rgb = [0, 0, 0];
        for (var i = 0; i < 3; i++) {
          t3 = h + 1 / 3 * -(i - 1);
          if (t3 < 0) {
            t3++;
          }
          if (t3 > 1) {
            t3--;
          }
          if (6 * t3 < 1) {
            val = t1 + (t22 - t1) * 6 * t3;
          } else if (2 * t3 < 1) {
            val = t22;
          } else if (3 * t3 < 2) {
            val = t1 + (t22 - t1) * (2 / 3 - t3) * 6;
          } else {
            val = t1;
          }
          rgb[i] = val * 255;
        }
        return rgb;
      };
      convert.hsl.hsv = function(hsl) {
        var h = hsl[0];
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var smin = s;
        var lmin = Math.max(l, 0.01);
        var sv;
        var v;
        l *= 2;
        s *= l <= 1 ? l : 2 - l;
        smin *= lmin <= 1 ? lmin : 2 - lmin;
        v = (l + s) / 2;
        sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
        return [h, sv * 100, v * 100];
      };
      convert.hsv.rgb = function(hsv) {
        var h = hsv[0] / 60;
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var hi = Math.floor(h) % 6;
        var f = h - Math.floor(h);
        var p = 255 * v * (1 - s);
        var q = 255 * v * (1 - s * f);
        var t3 = 255 * v * (1 - s * (1 - f));
        v *= 255;
        switch (hi) {
          case 0:
            return [v, t3, p];
          case 1:
            return [q, v, p];
          case 2:
            return [p, v, t3];
          case 3:
            return [p, q, v];
          case 4:
            return [t3, p, v];
          case 5:
            return [v, p, q];
        }
      };
      convert.hsv.hsl = function(hsv) {
        var h = hsv[0];
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var vmin = Math.max(v, 0.01);
        var lmin;
        var sl;
        var l;
        l = (2 - s) * v;
        lmin = (2 - s) * vmin;
        sl = s * vmin;
        sl /= lmin <= 1 ? lmin : 2 - lmin;
        sl = sl || 0;
        l /= 2;
        return [h, sl * 100, l * 100];
      };
      convert.hwb.rgb = function(hwb) {
        var h = hwb[0] / 360;
        var wh = hwb[1] / 100;
        var bl = hwb[2] / 100;
        var ratio = wh + bl;
        var i;
        var v;
        var f;
        var n;
        if (ratio > 1) {
          wh /= ratio;
          bl /= ratio;
        }
        i = Math.floor(6 * h);
        v = 1 - bl;
        f = 6 * h - i;
        if ((i & 1) !== 0) {
          f = 1 - f;
        }
        n = wh + f * (v - wh);
        var r;
        var g;
        var b;
        switch (i) {
          default:
          case 6:
          case 0:
            r = v;
            g = n;
            b = wh;
            break;
          case 1:
            r = n;
            g = v;
            b = wh;
            break;
          case 2:
            r = wh;
            g = v;
            b = n;
            break;
          case 3:
            r = wh;
            g = n;
            b = v;
            break;
          case 4:
            r = n;
            g = wh;
            b = v;
            break;
          case 5:
            r = v;
            g = wh;
            b = n;
            break;
        }
        return [r * 255, g * 255, b * 255];
      };
      convert.cmyk.rgb = function(cmyk) {
        var c = cmyk[0] / 100;
        var m = cmyk[1] / 100;
        var y = cmyk[2] / 100;
        var k = cmyk[3] / 100;
        var r;
        var g;
        var b;
        r = 1 - Math.min(1, c * (1 - k) + k);
        g = 1 - Math.min(1, m * (1 - k) + k);
        b = 1 - Math.min(1, y * (1 - k) + k);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.rgb = function(xyz) {
        var x = xyz[0] / 100;
        var y = xyz[1] / 100;
        var z = xyz[2] / 100;
        var r;
        var g;
        var b;
        r = x * 3.2406 + y * -1.5372 + z * -0.4986;
        g = x * -0.9689 + y * 1.8758 + z * 0.0415;
        b = x * 0.0557 + y * -0.204 + z * 1.057;
        r = r > 31308e-7 ? 1.055 * Math.pow(r, 1 / 2.4) - 0.055 : r * 12.92;
        g = g > 31308e-7 ? 1.055 * Math.pow(g, 1 / 2.4) - 0.055 : g * 12.92;
        b = b > 31308e-7 ? 1.055 * Math.pow(b, 1 / 2.4) - 0.055 : b * 12.92;
        r = Math.min(Math.max(0, r), 1);
        g = Math.min(Math.max(0, g), 1);
        b = Math.min(Math.max(0, b), 1);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.lab = function(xyz) {
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 8856e-6 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 8856e-6 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 8856e-6 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.lab.xyz = function(lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var x;
        var y;
        var z;
        y = (l + 16) / 116;
        x = a / 500 + y;
        z = y - b / 200;
        var y2 = Math.pow(y, 3);
        var x2 = Math.pow(x, 3);
        var z2 = Math.pow(z, 3);
        y = y2 > 8856e-6 ? y2 : (y - 16 / 116) / 7.787;
        x = x2 > 8856e-6 ? x2 : (x - 16 / 116) / 7.787;
        z = z2 > 8856e-6 ? z2 : (z - 16 / 116) / 7.787;
        x *= 95.047;
        y *= 100;
        z *= 108.883;
        return [x, y, z];
      };
      convert.lab.lch = function(lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var hr;
        var h;
        var c;
        hr = Math.atan2(b, a);
        h = hr * 360 / 2 / Math.PI;
        if (h < 0) {
          h += 360;
        }
        c = Math.sqrt(a * a + b * b);
        return [l, c, h];
      };
      convert.lch.lab = function(lch) {
        var l = lch[0];
        var c = lch[1];
        var h = lch[2];
        var a;
        var b;
        var hr;
        hr = h / 360 * 2 * Math.PI;
        a = c * Math.cos(hr);
        b = c * Math.sin(hr);
        return [l, a, b];
      };
      convert.rgb.ansi16 = function(args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2];
        value = Math.round(value / 50);
        if (value === 0) {
          return 30;
        }
        var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
        if (value === 2) {
          ansi += 60;
        }
        return ansi;
      };
      convert.hsv.ansi16 = function(args) {
        return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
      };
      convert.rgb.ansi256 = function(args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        if (r === g && g === b) {
          if (r < 8) {
            return 16;
          }
          if (r > 248) {
            return 231;
          }
          return Math.round((r - 8) / 247 * 24) + 232;
        }
        var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
        return ansi;
      };
      convert.ansi16.rgb = function(args) {
        var color = args % 10;
        if (color === 0 || color === 7) {
          if (args > 50) {
            color += 3.5;
          }
          color = color / 10.5 * 255;
          return [color, color, color];
        }
        var mult = (~~(args > 50) + 1) * 0.5;
        var r = (color & 1) * mult * 255;
        var g = (color >> 1 & 1) * mult * 255;
        var b = (color >> 2 & 1) * mult * 255;
        return [r, g, b];
      };
      convert.ansi256.rgb = function(args) {
        if (args >= 232) {
          var c = (args - 232) * 10 + 8;
          return [c, c, c];
        }
        args -= 16;
        var rem;
        var r = Math.floor(args / 36) / 5 * 255;
        var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
        var b = rem % 6 / 5 * 255;
        return [r, g, b];
      };
      convert.rgb.hex = function(args) {
        var integer = ((Math.round(args[0]) & 255) << 16) + ((Math.round(args[1]) & 255) << 8) + (Math.round(args[2]) & 255);
        var string = integer.toString(16).toUpperCase();
        return "000000".substring(string.length) + string;
      };
      convert.hex.rgb = function(args) {
        var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
        if (!match) {
          return [0, 0, 0];
        }
        var colorString = match[0];
        if (match[0].length === 3) {
          colorString = colorString.split("").map(function(char) {
            return char + char;
          }).join("");
        }
        var integer = parseInt(colorString, 16);
        var r = integer >> 16 & 255;
        var g = integer >> 8 & 255;
        var b = integer & 255;
        return [r, g, b];
      };
      convert.rgb.hcg = function(rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var max2 = Math.max(Math.max(r, g), b);
        var min2 = Math.min(Math.min(r, g), b);
        var chroma = max2 - min2;
        var grayscale;
        var hue;
        if (chroma < 1) {
          grayscale = min2 / (1 - chroma);
        } else {
          grayscale = 0;
        }
        if (chroma <= 0) {
          hue = 0;
        } else if (max2 === r) {
          hue = (g - b) / chroma % 6;
        } else if (max2 === g) {
          hue = 2 + (b - r) / chroma;
        } else {
          hue = 4 + (r - g) / chroma + 4;
        }
        hue /= 6;
        hue %= 1;
        return [hue * 360, chroma * 100, grayscale * 100];
      };
      convert.hsl.hcg = function(hsl) {
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var c = 1;
        var f = 0;
        if (l < 0.5) {
          c = 2 * s * l;
        } else {
          c = 2 * s * (1 - l);
        }
        if (c < 1) {
          f = (l - 0.5 * c) / (1 - c);
        }
        return [hsl[0], c * 100, f * 100];
      };
      convert.hsv.hcg = function(hsv) {
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var c = s * v;
        var f = 0;
        if (c < 1) {
          f = (v - c) / (1 - c);
        }
        return [hsv[0], c * 100, f * 100];
      };
      convert.hcg.rgb = function(hcg) {
        var h = hcg[0] / 360;
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        if (c === 0) {
          return [g * 255, g * 255, g * 255];
        }
        var pure = [0, 0, 0];
        var hi = h % 1 * 6;
        var v = hi % 1;
        var w = 1 - v;
        var mg = 0;
        switch (Math.floor(hi)) {
          case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
          case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
          case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
          case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
          case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
          default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
        }
        mg = (1 - c) * g;
        return [
          (c * pure[0] + mg) * 255,
          (c * pure[1] + mg) * 255,
          (c * pure[2] + mg) * 255
        ];
      };
      convert.hcg.hsv = function(hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1 - c);
        var f = 0;
        if (v > 0) {
          f = c / v;
        }
        return [hcg[0], f * 100, v * 100];
      };
      convert.hcg.hsl = function(hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var l = g * (1 - c) + 0.5 * c;
        var s = 0;
        if (l > 0 && l < 0.5) {
          s = c / (2 * l);
        } else if (l >= 0.5 && l < 1) {
          s = c / (2 * (1 - l));
        }
        return [hcg[0], s * 100, l * 100];
      };
      convert.hcg.hwb = function(hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1 - c);
        return [hcg[0], (v - c) * 100, (1 - v) * 100];
      };
      convert.hwb.hcg = function(hwb) {
        var w = hwb[1] / 100;
        var b = hwb[2] / 100;
        var v = 1 - b;
        var c = v - w;
        var g = 0;
        if (c < 1) {
          g = (v - c) / (1 - c);
        }
        return [hwb[0], c * 100, g * 100];
      };
      convert.apple.rgb = function(apple) {
        return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
      };
      convert.rgb.apple = function(rgb) {
        return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
      };
      convert.gray.rgb = function(args) {
        return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
      };
      convert.gray.hsl = convert.gray.hsv = function(args) {
        return [0, 0, args[0]];
      };
      convert.gray.hwb = function(gray) {
        return [0, 100, gray[0]];
      };
      convert.gray.cmyk = function(gray) {
        return [0, 0, 0, gray[0]];
      };
      convert.gray.lab = function(gray) {
        return [gray[0], 0, 0];
      };
      convert.gray.hex = function(gray) {
        var val = Math.round(gray[0] / 100 * 255) & 255;
        var integer = (val << 16) + (val << 8) + val;
        var string = integer.toString(16).toUpperCase();
        return "000000".substring(string.length) + string;
      };
      convert.rgb.gray = function(rgb) {
        var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
        return [val / 255 * 100];
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/color-convert/route.js
  var require_route = __commonJS({
    "node_modules/@babel/highlight/node_modules/color-convert/route.js"(exports2, module2) {
      init_define_process();
      var conversions = require_conversions();
      function buildGraph() {
        var graph = {};
        var models = Object.keys(conversions);
        for (var len = models.length, i = 0; i < len; i++) {
          graph[models[i]] = {
            distance: -1,
            parent: null
          };
        }
        return graph;
      }
      function deriveBFS(fromModel) {
        var graph = buildGraph();
        var queue = [fromModel];
        graph[fromModel].distance = 0;
        while (queue.length) {
          var current = queue.pop();
          var adjacents = Object.keys(conversions[current]);
          for (var len = adjacents.length, i = 0; i < len; i++) {
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
              node.distance = graph[current].distance + 1;
              node.parent = current;
              queue.unshift(adjacent);
            }
          }
        }
        return graph;
      }
      function link(from, to) {
        return function(args) {
          return to(from(args));
        };
      }
      function wrapConversion(toModel, graph) {
        var path = [graph[toModel].parent, toModel];
        var fn = conversions[graph[toModel].parent][toModel];
        var cur = graph[toModel].parent;
        while (graph[cur].parent) {
          path.unshift(graph[cur].parent);
          fn = link(conversions[graph[cur].parent][cur], fn);
          cur = graph[cur].parent;
        }
        fn.conversion = path;
        return fn;
      }
      module2.exports = function(fromModel) {
        var graph = deriveBFS(fromModel);
        var conversion = {};
        var models = Object.keys(graph);
        for (var len = models.length, i = 0; i < len; i++) {
          var toModel = models[i];
          var node = graph[toModel];
          if (node.parent === null) {
            continue;
          }
          conversion[toModel] = wrapConversion(toModel, graph);
        }
        return conversion;
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/color-convert/index.js
  var require_color_convert = __commonJS({
    "node_modules/@babel/highlight/node_modules/color-convert/index.js"(exports2, module2) {
      init_define_process();
      var conversions = require_conversions();
      var route = require_route();
      var convert = {};
      var models = Object.keys(conversions);
      function wrapRaw(fn) {
        var wrappedFn = function(args) {
          if (args === void 0 || args === null) {
            return args;
          }
          if (arguments.length > 1) {
            args = Array.prototype.slice.call(arguments);
          }
          return fn(args);
        };
        if ("conversion" in fn) {
          wrappedFn.conversion = fn.conversion;
        }
        return wrappedFn;
      }
      function wrapRounded(fn) {
        var wrappedFn = function(args) {
          if (args === void 0 || args === null) {
            return args;
          }
          if (arguments.length > 1) {
            args = Array.prototype.slice.call(arguments);
          }
          var result2 = fn(args);
          if (typeof result2 === "object") {
            for (var len = result2.length, i = 0; i < len; i++) {
              result2[i] = Math.round(result2[i]);
            }
          }
          return result2;
        };
        if ("conversion" in fn) {
          wrappedFn.conversion = fn.conversion;
        }
        return wrappedFn;
      }
      models.forEach(function(fromModel) {
        convert[fromModel] = {};
        Object.defineProperty(convert[fromModel], "channels", { value: conversions[fromModel].channels });
        Object.defineProperty(convert[fromModel], "labels", { value: conversions[fromModel].labels });
        var routes = route(fromModel);
        var routeModels = Object.keys(routes);
        routeModels.forEach(function(toModel) {
          var fn = routes[toModel];
          convert[fromModel][toModel] = wrapRounded(fn);
          convert[fromModel][toModel].raw = wrapRaw(fn);
        });
      });
      module2.exports = convert;
    }
  });

  // node_modules/@babel/highlight/node_modules/ansi-styles/index.js
  var require_ansi_styles = __commonJS({
    "node_modules/@babel/highlight/node_modules/ansi-styles/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var colorConvert = require_color_convert();
      var wrapAnsi16 = (fn, offset) => function() {
        const code = fn.apply(colorConvert, arguments);
        return `\x1B[${code + offset}m`;
      };
      var wrapAnsi256 = (fn, offset) => function() {
        const code = fn.apply(colorConvert, arguments);
        return `\x1B[${38 + offset};5;${code}m`;
      };
      var wrapAnsi16m = (fn, offset) => function() {
        const rgb = fn.apply(colorConvert, arguments);
        return `\x1B[${38 + offset};2;${rgb[0]};${rgb[1]};${rgb[2]}m`;
      };
      function assembleStyles() {
        const codes = /* @__PURE__ */ new Map();
        const styles = {
          modifier: {
            reset: [0, 0],
            bold: [1, 22],
            dim: [2, 22],
            italic: [3, 23],
            underline: [4, 24],
            inverse: [7, 27],
            hidden: [8, 28],
            strikethrough: [9, 29]
          },
          color: {
            black: [30, 39],
            red: [31, 39],
            green: [32, 39],
            yellow: [33, 39],
            blue: [34, 39],
            magenta: [35, 39],
            cyan: [36, 39],
            white: [37, 39],
            gray: [90, 39],
            redBright: [91, 39],
            greenBright: [92, 39],
            yellowBright: [93, 39],
            blueBright: [94, 39],
            magentaBright: [95, 39],
            cyanBright: [96, 39],
            whiteBright: [97, 39]
          },
          bgColor: {
            bgBlack: [40, 49],
            bgRed: [41, 49],
            bgGreen: [42, 49],
            bgYellow: [43, 49],
            bgBlue: [44, 49],
            bgMagenta: [45, 49],
            bgCyan: [46, 49],
            bgWhite: [47, 49],
            bgBlackBright: [100, 49],
            bgRedBright: [101, 49],
            bgGreenBright: [102, 49],
            bgYellowBright: [103, 49],
            bgBlueBright: [104, 49],
            bgMagentaBright: [105, 49],
            bgCyanBright: [106, 49],
            bgWhiteBright: [107, 49]
          }
        };
        styles.color.grey = styles.color.gray;
        for (const groupName of Object.keys(styles)) {
          const group = styles[groupName];
          for (const styleName of Object.keys(group)) {
            const style = group[styleName];
            styles[styleName] = {
              open: `\x1B[${style[0]}m`,
              close: `\x1B[${style[1]}m`
            };
            group[styleName] = styles[styleName];
            codes.set(style[0], style[1]);
          }
          Object.defineProperty(styles, groupName, {
            value: group,
            enumerable: false
          });
          Object.defineProperty(styles, "codes", {
            value: codes,
            enumerable: false
          });
        }
        const ansi2ansi = (n) => n;
        const rgb2rgb = (r, g, b) => [r, g, b];
        styles.color.close = "\x1B[39m";
        styles.bgColor.close = "\x1B[49m";
        styles.color.ansi = {
          ansi: wrapAnsi16(ansi2ansi, 0)
        };
        styles.color.ansi256 = {
          ansi256: wrapAnsi256(ansi2ansi, 0)
        };
        styles.color.ansi16m = {
          rgb: wrapAnsi16m(rgb2rgb, 0)
        };
        styles.bgColor.ansi = {
          ansi: wrapAnsi16(ansi2ansi, 10)
        };
        styles.bgColor.ansi256 = {
          ansi256: wrapAnsi256(ansi2ansi, 10)
        };
        styles.bgColor.ansi16m = {
          rgb: wrapAnsi16m(rgb2rgb, 10)
        };
        for (let key of Object.keys(colorConvert)) {
          if (typeof colorConvert[key] !== "object") {
            continue;
          }
          const suite = colorConvert[key];
          if (key === "ansi16") {
            key = "ansi";
          }
          if ("ansi16" in suite) {
            styles.color.ansi[key] = wrapAnsi16(suite.ansi16, 0);
            styles.bgColor.ansi[key] = wrapAnsi16(suite.ansi16, 10);
          }
          if ("ansi256" in suite) {
            styles.color.ansi256[key] = wrapAnsi256(suite.ansi256, 0);
            styles.bgColor.ansi256[key] = wrapAnsi256(suite.ansi256, 10);
          }
          if ("rgb" in suite) {
            styles.color.ansi16m[key] = wrapAnsi16m(suite.rgb, 0);
            styles.bgColor.ansi16m[key] = wrapAnsi16m(suite.rgb, 10);
          }
        }
        return styles;
      }
      Object.defineProperty(module2, "exports", {
        enumerable: true,
        get: assembleStyles
      });
    }
  });

  // node_modules/@babel/highlight/node_modules/supports-color/browser.js
  var require_browser3 = __commonJS({
    "node_modules/@babel/highlight/node_modules/supports-color/browser.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = {
        stdout: false,
        stderr: false
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/chalk/templates.js
  var require_templates = __commonJS({
    "node_modules/@babel/highlight/node_modules/chalk/templates.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var TEMPLATE_REGEX = /(?:\\(u[a-f\d]{4}|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi;
      var STYLE_REGEX = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g;
      var STRING_REGEX = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/;
      var ESCAPE_REGEX = /\\(u[a-f\d]{4}|x[a-f\d]{2}|.)|([^\\])/gi;
      var ESCAPES = /* @__PURE__ */ new Map([
        ["n", "\n"],
        ["r", "\r"],
        ["t", "	"],
        ["b", "\b"],
        ["f", "\f"],
        ["v", "\v"],
        ["0", "\0"],
        ["\\", "\\"],
        ["e", "\x1B"],
        ["a", "\x07"]
      ]);
      function unescape2(c) {
        if (c[0] === "u" && c.length === 5 || c[0] === "x" && c.length === 3) {
          return String.fromCharCode(parseInt(c.slice(1), 16));
        }
        return ESCAPES.get(c) || c;
      }
      function parseArguments(name, args) {
        const results = [];
        const chunks = args.trim().split(/\s*,\s*/g);
        let matches2;
        for (const chunk2 of chunks) {
          if (!isNaN(chunk2)) {
            results.push(Number(chunk2));
          } else if (matches2 = chunk2.match(STRING_REGEX)) {
            results.push(matches2[2].replace(ESCAPE_REGEX, (m, escape2, chr) => escape2 ? unescape2(escape2) : chr));
          } else {
            throw new Error(`Invalid Chalk template style argument: ${chunk2} (in style '${name}')`);
          }
        }
        return results;
      }
      function parseStyle(style) {
        STYLE_REGEX.lastIndex = 0;
        const results = [];
        let matches2;
        while ((matches2 = STYLE_REGEX.exec(style)) !== null) {
          const name = matches2[1];
          if (matches2[2]) {
            const args = parseArguments(name, matches2[2]);
            results.push([name].concat(args));
          } else {
            results.push([name]);
          }
        }
        return results;
      }
      function buildStyle(chalk, styles) {
        const enabled = {};
        for (const layer of styles) {
          for (const style of layer.styles) {
            enabled[style[0]] = layer.inverse ? null : style.slice(1);
          }
        }
        let current = chalk;
        for (const styleName of Object.keys(enabled)) {
          if (Array.isArray(enabled[styleName])) {
            if (!(styleName in current)) {
              throw new Error(`Unknown Chalk style: ${styleName}`);
            }
            if (enabled[styleName].length > 0) {
              current = current[styleName].apply(current, enabled[styleName]);
            } else {
              current = current[styleName];
            }
          }
        }
        return current;
      }
      module2.exports = (chalk, tmp) => {
        const styles = [];
        const chunks = [];
        let chunk2 = [];
        tmp.replace(TEMPLATE_REGEX, (m, escapeChar, inverse, style, close, chr) => {
          if (escapeChar) {
            chunk2.push(unescape2(escapeChar));
          } else if (style) {
            const str = chunk2.join("");
            chunk2 = [];
            chunks.push(styles.length === 0 ? str : buildStyle(chalk, styles)(str));
            styles.push({ inverse, styles: parseStyle(style) });
          } else if (close) {
            if (styles.length === 0) {
              throw new Error("Found extraneous } in Chalk template literal");
            }
            chunks.push(buildStyle(chalk, styles)(chunk2.join("")));
            chunk2 = [];
            styles.pop();
          } else {
            chunk2.push(chr);
          }
        });
        chunks.push(chunk2.join(""));
        if (styles.length > 0) {
          const errMsg = `Chalk template literal is missing ${styles.length} closing bracket${styles.length === 1 ? "" : "s"} (\`}\`)`;
          throw new Error(errMsg);
        }
        return chunks.join("");
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/chalk/index.js
  var require_chalk = __commonJS({
    "node_modules/@babel/highlight/node_modules/chalk/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var escapeStringRegexp = require_escape_string_regexp();
      var ansiStyles = require_ansi_styles();
      var stdoutColor = require_browser3().stdout;
      var template2 = require_templates();
      var isSimpleWindowsTerm = define_process_default.platform === "win32" && !(define_process_default.env.TERM || "").toLowerCase().startsWith("xterm");
      var levelMapping = ["ansi", "ansi", "ansi256", "ansi16m"];
      var skipModels = /* @__PURE__ */ new Set(["gray"]);
      var styles = /* @__PURE__ */ Object.create(null);
      function applyOptions(obj, options) {
        options = options || {};
        const scLevel = stdoutColor ? stdoutColor.level : 0;
        obj.level = options.level === void 0 ? scLevel : options.level;
        obj.enabled = "enabled" in options ? options.enabled : obj.level > 0;
      }
      function Chalk(options) {
        if (!this || !(this instanceof Chalk) || this.template) {
          const chalk = {};
          applyOptions(chalk, options);
          chalk.template = function() {
            const args = [].slice.call(arguments);
            return chalkTag.apply(null, [chalk.template].concat(args));
          };
          Object.setPrototypeOf(chalk, Chalk.prototype);
          Object.setPrototypeOf(chalk.template, chalk);
          chalk.template.constructor = Chalk;
          return chalk.template;
        }
        applyOptions(this, options);
      }
      if (isSimpleWindowsTerm) {
        ansiStyles.blue.open = "\x1B[94m";
      }
      for (const key of Object.keys(ansiStyles)) {
        ansiStyles[key].closeRe = new RegExp(escapeStringRegexp(ansiStyles[key].close), "g");
        styles[key] = {
          get() {
            const codes = ansiStyles[key];
            return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, key);
          }
        };
      }
      styles.visible = {
        get() {
          return build.call(this, this._styles || [], true, "visible");
        }
      };
      ansiStyles.color.closeRe = new RegExp(escapeStringRegexp(ansiStyles.color.close), "g");
      for (const model of Object.keys(ansiStyles.color.ansi)) {
        if (skipModels.has(model)) {
          continue;
        }
        styles[model] = {
          get() {
            const level = this.level;
            return function() {
              const open = ansiStyles.color[levelMapping[level]][model].apply(null, arguments);
              const codes = {
                open,
                close: ansiStyles.color.close,
                closeRe: ansiStyles.color.closeRe
              };
              return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, model);
            };
          }
        };
      }
      ansiStyles.bgColor.closeRe = new RegExp(escapeStringRegexp(ansiStyles.bgColor.close), "g");
      for (const model of Object.keys(ansiStyles.bgColor.ansi)) {
        if (skipModels.has(model)) {
          continue;
        }
        const bgModel = "bg" + model[0].toUpperCase() + model.slice(1);
        styles[bgModel] = {
          get() {
            const level = this.level;
            return function() {
              const open = ansiStyles.bgColor[levelMapping[level]][model].apply(null, arguments);
              const codes = {
                open,
                close: ansiStyles.bgColor.close,
                closeRe: ansiStyles.bgColor.closeRe
              };
              return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, model);
            };
          }
        };
      }
      var proto = Object.defineProperties(() => {
      }, styles);
      function build(_styles, _empty, key) {
        const builder = function() {
          return applyStyle.apply(builder, arguments);
        };
        builder._styles = _styles;
        builder._empty = _empty;
        const self2 = this;
        Object.defineProperty(builder, "level", {
          enumerable: true,
          get() {
            return self2.level;
          },
          set(level) {
            self2.level = level;
          }
        });
        Object.defineProperty(builder, "enabled", {
          enumerable: true,
          get() {
            return self2.enabled;
          },
          set(enabled) {
            self2.enabled = enabled;
          }
        });
        builder.hasGrey = this.hasGrey || key === "gray" || key === "grey";
        builder.__proto__ = proto;
        return builder;
      }
      function applyStyle() {
        const args = arguments;
        const argsLen = args.length;
        let str = String(arguments[0]);
        if (argsLen === 0) {
          return "";
        }
        if (argsLen > 1) {
          for (let a = 1; a < argsLen; a++) {
            str += " " + args[a];
          }
        }
        if (!this.enabled || this.level <= 0 || !str) {
          return this._empty ? "" : str;
        }
        const originalDim = ansiStyles.dim.open;
        if (isSimpleWindowsTerm && this.hasGrey) {
          ansiStyles.dim.open = "";
        }
        for (const code of this._styles.slice().reverse()) {
          str = code.open + str.replace(code.closeRe, code.open) + code.close;
          str = str.replace(/\r?\n/g, `${code.close}$&${code.open}`);
        }
        ansiStyles.dim.open = originalDim;
        return str;
      }
      function chalkTag(chalk, strings) {
        if (!Array.isArray(strings)) {
          return [].slice.call(arguments, 1).join(" ");
        }
        const args = [].slice.call(arguments, 2);
        const parts = [strings.raw[0]];
        for (let i = 1; i < strings.length; i++) {
          parts.push(String(args[i - 1]).replace(/[{}\\]/g, "\\$&"));
          parts.push(String(strings.raw[i]));
        }
        return template2(chalk, parts.join(""));
      }
      Object.defineProperties(Chalk.prototype, styles);
      module2.exports = Chalk();
      module2.exports.supportsColor = stdoutColor;
      module2.exports.default = module2.exports;
    }
  });

  // node_modules/@babel/highlight/lib/index.js
  var require_lib9 = __commonJS({
    "node_modules/@babel/highlight/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = highlight;
      exports2.getChalk = getChalk;
      exports2.shouldHighlight = shouldHighlight;
      var _jsTokens = require_js_tokens();
      var _helperValidatorIdentifier = require_lib3();
      var _chalk = require_chalk();
      var sometimesKeywords = /* @__PURE__ */ new Set(["as", "async", "from", "get", "of", "set"]);
      function getDefs(chalk) {
        return {
          keyword: chalk.cyan,
          capitalized: chalk.yellow,
          jsxIdentifier: chalk.yellow,
          punctuator: chalk.yellow,
          number: chalk.magenta,
          string: chalk.green,
          regex: chalk.magenta,
          comment: chalk.grey,
          invalid: chalk.white.bgRed.bold
        };
      }
      var NEWLINE = /\r\n|[\n\r\u2028\u2029]/;
      var BRACKET = /^[()[\]{}]$/;
      var tokenize;
      {
        const JSX_TAG = /^[a-z][\w-]*$/i;
        const getTokenType = function(token, offset, text) {
          if (token.type === "name") {
            if ((0, _helperValidatorIdentifier.isKeyword)(token.value) || (0, _helperValidatorIdentifier.isStrictReservedWord)(token.value, true) || sometimesKeywords.has(token.value)) {
              return "keyword";
            }
            if (JSX_TAG.test(token.value) && (text[offset - 1] === "<" || text.slice(offset - 2, offset) == "</")) {
              return "jsxIdentifier";
            }
            if (token.value[0] !== token.value[0].toLowerCase()) {
              return "capitalized";
            }
          }
          if (token.type === "punctuator" && BRACKET.test(token.value)) {
            return "bracket";
          }
          if (token.type === "invalid" && (token.value === "@" || token.value === "#")) {
            return "punctuator";
          }
          return token.type;
        };
        tokenize = function* (text) {
          let match;
          while (match = _jsTokens.default.exec(text)) {
            const token = _jsTokens.matchToToken(match);
            yield {
              type: getTokenType(token, match.index, text),
              value: token.value
            };
          }
        };
      }
      function highlightTokens(defs, text) {
        let highlighted = "";
        for (const {
          type,
          value
        } of tokenize(text)) {
          const colorize = defs[type];
          if (colorize) {
            highlighted += value.split(NEWLINE).map((str) => colorize(str)).join("\n");
          } else {
            highlighted += value;
          }
        }
        return highlighted;
      }
      function shouldHighlight(options) {
        return !!_chalk.supportsColor || options.forceColor;
      }
      function getChalk(options) {
        return options.forceColor ? new _chalk.constructor({
          enabled: true,
          level: 1
        }) : _chalk;
      }
      function highlight(code, options = {}) {
        if (code !== "" && shouldHighlight(options)) {
          const chalk = getChalk(options);
          const defs = getDefs(chalk);
          return highlightTokens(defs, code);
        } else {
          return code;
        }
      }
    }
  });

  // node_modules/@babel/code-frame/lib/index.js
  var require_lib10 = __commonJS({
    "node_modules/@babel/code-frame/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.codeFrameColumns = codeFrameColumns;
      exports2.default = _default;
      var _highlight = require_lib9();
      var deprecationWarningShown = false;
      function getDefs(chalk) {
        return {
          gutter: chalk.grey,
          marker: chalk.red.bold,
          message: chalk.red.bold
        };
      }
      var NEWLINE = /\r\n|[\n\r\u2028\u2029]/;
      function getMarkerLines(loc, source, opts) {
        const startLoc = Object.assign({
          column: 0,
          line: -1
        }, loc.start);
        const endLoc = Object.assign({}, startLoc, loc.end);
        const {
          linesAbove = 2,
          linesBelow = 3
        } = opts || {};
        const startLine = startLoc.line;
        const startColumn = startLoc.column;
        const endLine = endLoc.line;
        const endColumn = endLoc.column;
        let start = Math.max(startLine - (linesAbove + 1), 0);
        let end = Math.min(source.length, endLine + linesBelow);
        if (startLine === -1) {
          start = 0;
        }
        if (endLine === -1) {
          end = source.length;
        }
        const lineDiff = endLine - startLine;
        const markerLines = {};
        if (lineDiff) {
          for (let i = 0; i <= lineDiff; i++) {
            const lineNumber = i + startLine;
            if (!startColumn) {
              markerLines[lineNumber] = true;
            } else if (i === 0) {
              const sourceLength = source[lineNumber - 1].length;
              markerLines[lineNumber] = [startColumn, sourceLength - startColumn + 1];
            } else if (i === lineDiff) {
              markerLines[lineNumber] = [0, endColumn];
            } else {
              const sourceLength = source[lineNumber - i].length;
              markerLines[lineNumber] = [0, sourceLength];
            }
          }
        } else {
          if (startColumn === endColumn) {
            if (startColumn) {
              markerLines[startLine] = [startColumn, 0];
            } else {
              markerLines[startLine] = true;
            }
          } else {
            markerLines[startLine] = [startColumn, endColumn - startColumn];
          }
        }
        return {
          start,
          end,
          markerLines
        };
      }
      function codeFrameColumns(rawLines, loc, opts = {}) {
        const highlighted = (opts.highlightCode || opts.forceColor) && (0, _highlight.shouldHighlight)(opts);
        const chalk = (0, _highlight.getChalk)(opts);
        const defs = getDefs(chalk);
        const maybeHighlight = (chalkFn, string) => {
          return highlighted ? chalkFn(string) : string;
        };
        const lines = rawLines.split(NEWLINE);
        const {
          start,
          end,
          markerLines
        } = getMarkerLines(loc, lines, opts);
        const hasColumns = loc.start && typeof loc.start.column === "number";
        const numberMaxWidth = String(end).length;
        const highlightedLines = highlighted ? (0, _highlight.default)(rawLines, opts) : rawLines;
        let frame = highlightedLines.split(NEWLINE, end).slice(start, end).map((line, index) => {
          const number = start + 1 + index;
          const paddedNumber = ` ${number}`.slice(-numberMaxWidth);
          const gutter = ` ${paddedNumber} |`;
          const hasMarker = markerLines[number];
          const lastMarkerLine = !markerLines[number + 1];
          if (hasMarker) {
            let markerLine = "";
            if (Array.isArray(hasMarker)) {
              const markerSpacing = line.slice(0, Math.max(hasMarker[0] - 1, 0)).replace(/[^\t]/g, " ");
              const numberOfMarkers = hasMarker[1] || 1;
              markerLine = ["\n ", maybeHighlight(defs.gutter, gutter.replace(/\d/g, " ")), " ", markerSpacing, maybeHighlight(defs.marker, "^").repeat(numberOfMarkers)].join("");
              if (lastMarkerLine && opts.message) {
                markerLine += " " + maybeHighlight(defs.message, opts.message);
              }
            }
            return [maybeHighlight(defs.marker, ">"), maybeHighlight(defs.gutter, gutter), line.length > 0 ? ` ${line}` : "", markerLine].join("");
          } else {
            return ` ${maybeHighlight(defs.gutter, gutter)}${line.length > 0 ? ` ${line}` : ""}`;
          }
        }).join("\n");
        if (opts.message && !hasColumns) {
          frame = `${" ".repeat(numberMaxWidth + 1)}${opts.message}
${frame}`;
        }
        if (highlighted) {
          return chalk.reset(frame);
        } else {
          return frame;
        }
      }
      function _default(rawLines, lineNumber, colNumber, opts = {}) {
        if (!deprecationWarningShown) {
          deprecationWarningShown = true;
          const message = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
          if (define_process_default.emitWarning) {
            define_process_default.emitWarning(message, "DeprecationWarning");
          } else {
            const deprecationError = new Error(message);
            deprecationError.name = "DeprecationWarning";
            console.warn(new Error(message));
          }
        }
        colNumber = Math.max(colNumber, 0);
        const location = {
          start: {
            column: colNumber,
            line: lineNumber
          }
        };
        return codeFrameColumns(rawLines, location, opts);
      }
    }
  });

  // node_modules/@babel/helper-hoist-variables/lib/index.js
  var require_lib11 = __commonJS({
    "node_modules/@babel/helper-hoist-variables/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = hoistVariables;
      var _t = require_lib5();
      var {
        assignmentExpression,
        expressionStatement: expressionStatement2,
        identifier: identifier3
      } = _t;
      var visitor = {
        Scope(path, state) {
          if (state.kind === "let")
            path.skip();
        },
        FunctionParent(path) {
          path.skip();
        },
        VariableDeclaration(path, state) {
          if (state.kind && path.node.kind !== state.kind)
            return;
          const nodes = [];
          const declarations = path.get("declarations");
          let firstId;
          for (const declar of declarations) {
            firstId = declar.node.id;
            if (declar.node.init) {
              nodes.push(expressionStatement2(assignmentExpression("=", declar.node.id, declar.node.init)));
            }
            for (const name of Object.keys(declar.getBindingIdentifiers())) {
              state.emit(identifier3(name), name, declar.node.init !== null);
            }
          }
          if (path.parentPath.isFor({
            left: path.node
          })) {
            path.replaceWith(firstId);
          } else {
            path.replaceWithMultiple(nodes);
          }
        }
      };
      function hoistVariables(path, emit, kind = "var") {
        path.traverse(visitor, {
          kind,
          emit
        });
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/replacement.js
  var require_replacement = __commonJS({
    "node_modules/@babel/traverse/lib/path/replacement.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._replaceWith = _replaceWith;
      exports2.replaceExpressionWithStatements = replaceExpressionWithStatements;
      exports2.replaceInline = replaceInline;
      exports2.replaceWith = replaceWith;
      exports2.replaceWithMultiple = replaceWithMultiple;
      exports2.replaceWithSourceString = replaceWithSourceString;
      var _codeFrame = require_lib10();
      var _index = require_lib14();
      var _index2 = require_path();
      var _cache = require_cache2();
      var _parser = require_lib2();
      var _t = require_lib5();
      var _helperHoistVariables = require_lib11();
      var {
        FUNCTION_TYPES,
        arrowFunctionExpression: arrowFunctionExpression2,
        assignmentExpression,
        awaitExpression,
        blockStatement,
        callExpression,
        cloneNode,
        expressionStatement: expressionStatement2,
        identifier: identifier3,
        inheritLeadingComments,
        inheritTrailingComments,
        inheritsComments,
        isExpression,
        isProgram,
        isStatement,
        removeComments,
        returnStatement,
        toSequenceExpression,
        validate,
        yieldExpression
      } = _t;
      function replaceWithMultiple(nodes) {
        var _pathCache$get;
        this.resync();
        nodes = this._verifyNodeList(nodes);
        inheritLeadingComments(nodes[0], this.node);
        inheritTrailingComments(nodes[nodes.length - 1], this.node);
        (_pathCache$get = _cache.path.get(this.parent)) == null ? void 0 : _pathCache$get.delete(this.node);
        this.node = this.container[this.key] = null;
        const paths = this.insertAfter(nodes);
        if (this.node) {
          this.requeue();
        } else {
          this.remove();
        }
        return paths;
      }
      function replaceWithSourceString(replacement) {
        this.resync();
        let ast;
        try {
          replacement = `(${replacement})`;
          ast = (0, _parser.parse)(replacement);
        } catch (err) {
          const loc = err.loc;
          if (loc) {
            err.message += " - make sure this is an expression.\n" + (0, _codeFrame.codeFrameColumns)(replacement, {
              start: {
                line: loc.line,
                column: loc.column + 1
              }
            });
            err.code = "BABEL_REPLACE_SOURCE_ERROR";
          }
          throw err;
        }
        const expressionAST = ast.program.body[0].expression;
        _index.default.removeProperties(expressionAST);
        return this.replaceWith(expressionAST);
      }
      function replaceWith(replacementPath) {
        this.resync();
        if (this.removed) {
          throw new Error("You can't replace this node, we've already removed it");
        }
        let replacement = replacementPath instanceof _index2.default ? replacementPath.node : replacementPath;
        if (!replacement) {
          throw new Error("You passed `path.replaceWith()` a falsy node, use `path.remove()` instead");
        }
        if (this.node === replacement) {
          return [this];
        }
        if (this.isProgram() && !isProgram(replacement)) {
          throw new Error("You can only replace a Program root node with another Program node");
        }
        if (Array.isArray(replacement)) {
          throw new Error("Don't use `path.replaceWith()` with an array of nodes, use `path.replaceWithMultiple()`");
        }
        if (typeof replacement === "string") {
          throw new Error("Don't use `path.replaceWith()` with a source string, use `path.replaceWithSourceString()`");
        }
        let nodePath = "";
        if (this.isNodeType("Statement") && isExpression(replacement)) {
          if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement) && !this.parentPath.isExportDefaultDeclaration()) {
            replacement = expressionStatement2(replacement);
            nodePath = "expression";
          }
        }
        if (this.isNodeType("Expression") && isStatement(replacement)) {
          if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement)) {
            return this.replaceExpressionWithStatements([replacement]);
          }
        }
        const oldNode = this.node;
        if (oldNode) {
          inheritsComments(replacement, oldNode);
          removeComments(oldNode);
        }
        this._replaceWith(replacement);
        this.type = replacement.type;
        this.setScope();
        this.requeue();
        return [nodePath ? this.get(nodePath) : this];
      }
      function _replaceWith(node) {
        var _pathCache$get2;
        if (!this.container) {
          throw new ReferenceError("Container is falsy");
        }
        if (this.inList) {
          validate(this.parent, this.key, [node]);
        } else {
          validate(this.parent, this.key, node);
        }
        this.debug(`Replace with ${node == null ? void 0 : node.type}`);
        (_pathCache$get2 = _cache.path.get(this.parent)) == null ? void 0 : _pathCache$get2.set(node, this).delete(this.node);
        this.node = this.container[this.key] = node;
      }
      function replaceExpressionWithStatements(nodes) {
        this.resync();
        const nodesAsSequenceExpression = toSequenceExpression(nodes, this.scope);
        if (nodesAsSequenceExpression) {
          return this.replaceWith(nodesAsSequenceExpression)[0].get("expressions");
        }
        const functionParent = this.getFunctionParent();
        const isParentAsync = functionParent == null ? void 0 : functionParent.is("async");
        const isParentGenerator = functionParent == null ? void 0 : functionParent.is("generator");
        const container = arrowFunctionExpression2([], blockStatement(nodes));
        this.replaceWith(callExpression(container, []));
        const callee = this.get("callee");
        (0, _helperHoistVariables.default)(callee.get("body"), (id) => {
          this.scope.push({
            id
          });
        }, "var");
        const completionRecords = this.get("callee").getCompletionRecords();
        for (const path of completionRecords) {
          if (!path.isExpressionStatement())
            continue;
          const loop = path.findParent((path2) => path2.isLoop());
          if (loop) {
            let uid = loop.getData("expressionReplacementReturnUid");
            if (!uid) {
              uid = callee.scope.generateDeclaredUidIdentifier("ret");
              callee.get("body").pushContainer("body", returnStatement(cloneNode(uid)));
              loop.setData("expressionReplacementReturnUid", uid);
            } else {
              uid = identifier3(uid.name);
            }
            path.get("expression").replaceWith(assignmentExpression("=", cloneNode(uid), path.node.expression));
          } else {
            path.replaceWith(returnStatement(path.node.expression));
          }
        }
        callee.arrowFunctionToExpression();
        const newCallee = callee;
        const needToAwaitFunction = isParentAsync && _index.default.hasType(this.get("callee.body").node, "AwaitExpression", FUNCTION_TYPES);
        const needToYieldFunction = isParentGenerator && _index.default.hasType(this.get("callee.body").node, "YieldExpression", FUNCTION_TYPES);
        if (needToAwaitFunction) {
          newCallee.set("async", true);
          if (!needToYieldFunction) {
            this.replaceWith(awaitExpression(this.node));
          }
        }
        if (needToYieldFunction) {
          newCallee.set("generator", true);
          this.replaceWith(yieldExpression(this.node, true));
        }
        return newCallee.get("body.body");
      }
      function replaceInline(nodes) {
        this.resync();
        if (Array.isArray(nodes)) {
          if (Array.isArray(this.container)) {
            nodes = this._verifyNodeList(nodes);
            const paths = this._containerInsertAfter(nodes);
            this.remove();
            return paths;
          } else {
            return this.replaceWithMultiple(nodes);
          }
        } else {
          return this.replaceWith(nodes);
        }
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/evaluation.js
  var require_evaluation = __commonJS({
    "node_modules/@babel/traverse/lib/path/evaluation.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.evaluate = evaluate;
      exports2.evaluateTruthy = evaluateTruthy;
      var VALID_CALLEES = ["String", "Number", "Math"];
      var INVALID_METHODS = ["random"];
      function isValidCallee(val) {
        return VALID_CALLEES.includes(
          val
        );
      }
      function isInvalidMethod(val) {
        return INVALID_METHODS.includes(
          val
        );
      }
      function evaluateTruthy() {
        const res = this.evaluate();
        if (res.confident)
          return !!res.value;
      }
      function deopt(path, state) {
        if (!state.confident)
          return;
        state.deoptPath = path;
        state.confident = false;
      }
      function evaluateCached(path, state) {
        const {
          node
        } = path;
        const {
          seen
        } = state;
        if (seen.has(node)) {
          const existing = seen.get(node);
          if (existing.resolved) {
            return existing.value;
          } else {
            deopt(path, state);
            return;
          }
        } else {
          const item = {
            resolved: false
          };
          seen.set(node, item);
          const val = _evaluate(path, state);
          if (state.confident) {
            item.resolved = true;
            item.value = val;
          }
          return val;
        }
      }
      function _evaluate(path, state) {
        if (!state.confident)
          return;
        if (path.isSequenceExpression()) {
          const exprs = path.get("expressions");
          return evaluateCached(exprs[exprs.length - 1], state);
        }
        if (path.isStringLiteral() || path.isNumericLiteral() || path.isBooleanLiteral()) {
          return path.node.value;
        }
        if (path.isNullLiteral()) {
          return null;
        }
        if (path.isTemplateLiteral()) {
          return evaluateQuasis(path, path.node.quasis, state);
        }
        if (path.isTaggedTemplateExpression() && path.get("tag").isMemberExpression()) {
          const object = path.get("tag.object");
          const {
            node: {
              name
            }
          } = object;
          const property2 = path.get("tag.property");
          if (object.isIdentifier() && name === "String" && !path.scope.getBinding(name) && property2.isIdentifier() && property2.node.name === "raw") {
            return evaluateQuasis(path, path.node.quasi.quasis, state, true);
          }
        }
        if (path.isConditionalExpression()) {
          const testResult = evaluateCached(path.get("test"), state);
          if (!state.confident)
            return;
          if (testResult) {
            return evaluateCached(path.get("consequent"), state);
          } else {
            return evaluateCached(path.get("alternate"), state);
          }
        }
        if (path.isExpressionWrapper()) {
          return evaluateCached(path.get("expression"), state);
        }
        if (path.isMemberExpression() && !path.parentPath.isCallExpression({
          callee: path.node
        })) {
          const property2 = path.get("property");
          const object = path.get("object");
          if (object.isLiteral() && property2.isIdentifier()) {
            const value = object.node.value;
            const type = typeof value;
            if (type === "number" || type === "string") {
              return value[property2.node.name];
            }
          }
        }
        if (path.isReferencedIdentifier()) {
          const binding = path.scope.getBinding(path.node.name);
          if (binding && binding.constantViolations.length > 0) {
            return deopt(binding.path, state);
          }
          if (binding && path.node.start < binding.path.node.end) {
            return deopt(binding.path, state);
          }
          if (binding != null && binding.hasValue) {
            return binding.value;
          } else {
            if (path.node.name === "undefined") {
              return binding ? deopt(binding.path, state) : void 0;
            } else if (path.node.name === "Infinity") {
              return binding ? deopt(binding.path, state) : Infinity;
            } else if (path.node.name === "NaN") {
              return binding ? deopt(binding.path, state) : NaN;
            }
            const resolved = path.resolve();
            if (resolved === path) {
              return deopt(path, state);
            } else {
              return evaluateCached(resolved, state);
            }
          }
        }
        if (path.isUnaryExpression({
          prefix: true
        })) {
          if (path.node.operator === "void") {
            return void 0;
          }
          const argument = path.get("argument");
          if (path.node.operator === "typeof" && (argument.isFunction() || argument.isClass())) {
            return "function";
          }
          const arg = evaluateCached(argument, state);
          if (!state.confident)
            return;
          switch (path.node.operator) {
            case "!":
              return !arg;
            case "+":
              return +arg;
            case "-":
              return -arg;
            case "~":
              return ~arg;
            case "typeof":
              return typeof arg;
          }
        }
        if (path.isArrayExpression()) {
          const arr = [];
          const elems = path.get("elements");
          for (const elem of elems) {
            const elemValue = elem.evaluate();
            if (elemValue.confident) {
              arr.push(elemValue.value);
            } else {
              return deopt(elemValue.deopt, state);
            }
          }
          return arr;
        }
        if (path.isObjectExpression()) {
          const obj = {};
          const props = path.get("properties");
          for (const prop of props) {
            if (prop.isObjectMethod() || prop.isSpreadElement()) {
              return deopt(prop, state);
            }
            const keyPath = prop.get("key");
            let key;
            if (prop.node.computed) {
              key = keyPath.evaluate();
              if (!key.confident) {
                return deopt(key.deopt, state);
              }
              key = key.value;
            } else if (keyPath.isIdentifier()) {
              key = keyPath.node.name;
            } else {
              key = keyPath.node.value;
            }
            const valuePath = prop.get("value");
            let value = valuePath.evaluate();
            if (!value.confident) {
              return deopt(value.deopt, state);
            }
            value = value.value;
            obj[key] = value;
          }
          return obj;
        }
        if (path.isLogicalExpression()) {
          const wasConfident = state.confident;
          const left = evaluateCached(path.get("left"), state);
          const leftConfident = state.confident;
          state.confident = wasConfident;
          const right = evaluateCached(path.get("right"), state);
          const rightConfident = state.confident;
          switch (path.node.operator) {
            case "||":
              state.confident = leftConfident && (!!left || rightConfident);
              if (!state.confident)
                return;
              return left || right;
            case "&&":
              state.confident = leftConfident && (!left || rightConfident);
              if (!state.confident)
                return;
              return left && right;
            case "??":
              state.confident = leftConfident && (left != null || rightConfident);
              if (!state.confident)
                return;
              return left != null ? left : right;
          }
        }
        if (path.isBinaryExpression()) {
          const left = evaluateCached(path.get("left"), state);
          if (!state.confident)
            return;
          const right = evaluateCached(path.get("right"), state);
          if (!state.confident)
            return;
          switch (path.node.operator) {
            case "-":
              return left - right;
            case "+":
              return left + right;
            case "/":
              return left / right;
            case "*":
              return left * right;
            case "%":
              return left % right;
            case "**":
              return Math.pow(left, right);
            case "<":
              return left < right;
            case ">":
              return left > right;
            case "<=":
              return left <= right;
            case ">=":
              return left >= right;
            case "==":
              return left == right;
            case "!=":
              return left != right;
            case "===":
              return left === right;
            case "!==":
              return left !== right;
            case "|":
              return left | right;
            case "&":
              return left & right;
            case "^":
              return left ^ right;
            case "<<":
              return left << right;
            case ">>":
              return left >> right;
            case ">>>":
              return left >>> right;
          }
        }
        if (path.isCallExpression()) {
          const callee = path.get("callee");
          let context;
          let func;
          if (callee.isIdentifier() && !path.scope.getBinding(callee.node.name) && isValidCallee(callee.node.name)) {
            func = global[callee.node.name];
          }
          if (callee.isMemberExpression()) {
            const object = callee.get("object");
            const property2 = callee.get("property");
            if (object.isIdentifier() && property2.isIdentifier() && isValidCallee(object.node.name) && !isInvalidMethod(property2.node.name)) {
              context = global[object.node.name];
              func = context[property2.node.name];
            }
            if (object.isLiteral() && property2.isIdentifier()) {
              const type = typeof object.node.value;
              if (type === "string" || type === "number") {
                context = object.node.value;
                func = context[property2.node.name];
              }
            }
          }
          if (func) {
            const args = path.get("arguments").map((arg) => evaluateCached(arg, state));
            if (!state.confident)
              return;
            return func.apply(context, args);
          }
        }
        deopt(path, state);
      }
      function evaluateQuasis(path, quasis, state, raw = false) {
        let str = "";
        let i = 0;
        const exprs = path.get("expressions");
        for (const elem of quasis) {
          if (!state.confident)
            break;
          str += raw ? elem.value.raw : elem.value.cooked;
          const expr = exprs[i++];
          if (expr)
            str += String(evaluateCached(expr, state));
        }
        if (!state.confident)
          return;
        return str;
      }
      function evaluate() {
        const state = {
          confident: true,
          deoptPath: null,
          seen: /* @__PURE__ */ new Map()
        };
        let value = evaluateCached(this, state);
        if (!state.confident)
          value = void 0;
        return {
          confident: state.confident,
          deopt: state.deoptPath,
          value
        };
      }
    }
  });

  // node_modules/@babel/template/lib/formatters.js
  var require_formatters = __commonJS({
    "node_modules/@babel/template/lib/formatters.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.statements = exports2.statement = exports2.smart = exports2.program = exports2.expression = void 0;
      var _t = require_lib5();
      var {
        assertExpressionStatement
      } = _t;
      function makeStatementFormatter(fn) {
        return {
          code: (str) => `/* @babel/template */;
${str}`,
          validate: () => {
          },
          unwrap: (ast) => {
            return fn(ast.program.body.slice(1));
          }
        };
      }
      var smart = makeStatementFormatter((body) => {
        if (body.length > 1) {
          return body;
        } else {
          return body[0];
        }
      });
      exports2.smart = smart;
      var statements = makeStatementFormatter((body) => body);
      exports2.statements = statements;
      var statement = makeStatementFormatter((body) => {
        if (body.length === 0) {
          throw new Error("Found nothing to return.");
        }
        if (body.length > 1) {
          throw new Error("Found multiple statements but wanted one");
        }
        return body[0];
      });
      exports2.statement = statement;
      var expression = {
        code: (str) => `(
${str}
)`,
        validate: (ast) => {
          if (ast.program.body.length > 1) {
            throw new Error("Found multiple statements but wanted one");
          }
          if (expression.unwrap(ast).start === 0) {
            throw new Error("Parse result included parens.");
          }
        },
        unwrap: ({
          program: program4
        }) => {
          const [stmt] = program4.body;
          assertExpressionStatement(stmt);
          return stmt.expression;
        }
      };
      exports2.expression = expression;
      var program3 = {
        code: (str) => str,
        validate: () => {
        },
        unwrap: (ast) => ast.program
      };
      exports2.program = program3;
    }
  });

  // node_modules/@babel/template/lib/options.js
  var require_options = __commonJS({
    "node_modules/@babel/template/lib/options.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.merge = merge2;
      exports2.normalizeReplacements = normalizeReplacements;
      exports2.validate = validate;
      var _excluded = ["placeholderWhitelist", "placeholderPattern", "preserveComments", "syntacticPlaceholders"];
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null)
          return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0)
            continue;
          target[key] = source[key];
        }
        return target;
      }
      function merge2(a, b) {
        const {
          placeholderWhitelist = a.placeholderWhitelist,
          placeholderPattern = a.placeholderPattern,
          preserveComments = a.preserveComments,
          syntacticPlaceholders = a.syntacticPlaceholders
        } = b;
        return {
          parser: Object.assign({}, a.parser, b.parser),
          placeholderWhitelist,
          placeholderPattern,
          preserveComments,
          syntacticPlaceholders
        };
      }
      function validate(opts) {
        if (opts != null && typeof opts !== "object") {
          throw new Error("Unknown template options.");
        }
        const _ref = opts || {}, {
          placeholderWhitelist,
          placeholderPattern,
          preserveComments,
          syntacticPlaceholders
        } = _ref, parser3 = _objectWithoutPropertiesLoose(_ref, _excluded);
        if (placeholderWhitelist != null && !(placeholderWhitelist instanceof Set)) {
          throw new Error("'.placeholderWhitelist' must be a Set, null, or undefined");
        }
        if (placeholderPattern != null && !(placeholderPattern instanceof RegExp) && placeholderPattern !== false) {
          throw new Error("'.placeholderPattern' must be a RegExp, false, null, or undefined");
        }
        if (preserveComments != null && typeof preserveComments !== "boolean") {
          throw new Error("'.preserveComments' must be a boolean, null, or undefined");
        }
        if (syntacticPlaceholders != null && typeof syntacticPlaceholders !== "boolean") {
          throw new Error("'.syntacticPlaceholders' must be a boolean, null, or undefined");
        }
        if (syntacticPlaceholders === true && (placeholderWhitelist != null || placeholderPattern != null)) {
          throw new Error("'.placeholderWhitelist' and '.placeholderPattern' aren't compatible with '.syntacticPlaceholders: true'");
        }
        return {
          parser: parser3,
          placeholderWhitelist: placeholderWhitelist || void 0,
          placeholderPattern: placeholderPattern == null ? void 0 : placeholderPattern,
          preserveComments: preserveComments == null ? void 0 : preserveComments,
          syntacticPlaceholders: syntacticPlaceholders == null ? void 0 : syntacticPlaceholders
        };
      }
      function normalizeReplacements(replacements) {
        if (Array.isArray(replacements)) {
          return replacements.reduce((acc, replacement, i) => {
            acc["$" + i] = replacement;
            return acc;
          }, {});
        } else if (typeof replacements === "object" || replacements == null) {
          return replacements || void 0;
        }
        throw new Error("Template replacements must be an array, object, null, or undefined");
      }
    }
  });

  // node_modules/@babel/template/lib/parse.js
  var require_parse = __commonJS({
    "node_modules/@babel/template/lib/parse.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = parseAndBuildMetadata;
      var _t = require_lib5();
      var _parser = require_lib2();
      var _codeFrame = require_lib10();
      var {
        isCallExpression,
        isExpressionStatement,
        isFunction: isFunction2,
        isIdentifier: isIdentifier2,
        isJSXIdentifier,
        isNewExpression,
        isPlaceholder,
        isStatement,
        isStringLiteral,
        removePropertiesDeep,
        traverse: traverse3
      } = _t;
      var PATTERN = /^[_$A-Z0-9]+$/;
      function parseAndBuildMetadata(formatter, code, opts) {
        const {
          placeholderWhitelist,
          placeholderPattern,
          preserveComments,
          syntacticPlaceholders
        } = opts;
        const ast = parseWithCodeFrame(code, opts.parser, syntacticPlaceholders);
        removePropertiesDeep(ast, {
          preserveComments
        });
        formatter.validate(ast);
        const syntactic = {
          placeholders: [],
          placeholderNames: /* @__PURE__ */ new Set()
        };
        const legacy = {
          placeholders: [],
          placeholderNames: /* @__PURE__ */ new Set()
        };
        const isLegacyRef = {
          value: void 0
        };
        traverse3(ast, placeholderVisitorHandler, {
          syntactic,
          legacy,
          isLegacyRef,
          placeholderWhitelist,
          placeholderPattern,
          syntacticPlaceholders
        });
        return Object.assign({
          ast
        }, isLegacyRef.value ? legacy : syntactic);
      }
      function placeholderVisitorHandler(node, ancestors, state) {
        var _state$placeholderWhi;
        let name;
        if (isPlaceholder(node)) {
          if (state.syntacticPlaceholders === false) {
            throw new Error("%%foo%%-style placeholders can't be used when '.syntacticPlaceholders' is false.");
          } else {
            name = node.name.name;
            state.isLegacyRef.value = false;
          }
        } else if (state.isLegacyRef.value === false || state.syntacticPlaceholders) {
          return;
        } else if (isIdentifier2(node) || isJSXIdentifier(node)) {
          name = node.name;
          state.isLegacyRef.value = true;
        } else if (isStringLiteral(node)) {
          name = node.value;
          state.isLegacyRef.value = true;
        } else {
          return;
        }
        if (!state.isLegacyRef.value && (state.placeholderPattern != null || state.placeholderWhitelist != null)) {
          throw new Error("'.placeholderWhitelist' and '.placeholderPattern' aren't compatible with '.syntacticPlaceholders: true'");
        }
        if (state.isLegacyRef.value && (state.placeholderPattern === false || !(state.placeholderPattern || PATTERN).test(name)) && !((_state$placeholderWhi = state.placeholderWhitelist) != null && _state$placeholderWhi.has(name))) {
          return;
        }
        ancestors = ancestors.slice();
        const {
          node: parent2,
          key
        } = ancestors[ancestors.length - 1];
        let type;
        if (isStringLiteral(node) || isPlaceholder(node, {
          expectedNode: "StringLiteral"
        })) {
          type = "string";
        } else if (isNewExpression(parent2) && key === "arguments" || isCallExpression(parent2) && key === "arguments" || isFunction2(parent2) && key === "params") {
          type = "param";
        } else if (isExpressionStatement(parent2) && !isPlaceholder(node)) {
          type = "statement";
          ancestors = ancestors.slice(0, -1);
        } else if (isStatement(node) && isPlaceholder(node)) {
          type = "statement";
        } else {
          type = "other";
        }
        const {
          placeholders,
          placeholderNames
        } = state.isLegacyRef.value ? state.legacy : state.syntactic;
        placeholders.push({
          name,
          type,
          resolve: (ast) => resolveAncestors(ast, ancestors),
          isDuplicate: placeholderNames.has(name)
        });
        placeholderNames.add(name);
      }
      function resolveAncestors(ast, ancestors) {
        let parent2 = ast;
        for (let i = 0; i < ancestors.length - 1; i++) {
          const {
            key: key2,
            index: index2
          } = ancestors[i];
          if (index2 === void 0) {
            parent2 = parent2[key2];
          } else {
            parent2 = parent2[key2][index2];
          }
        }
        const {
          key,
          index
        } = ancestors[ancestors.length - 1];
        return {
          parent: parent2,
          key,
          index
        };
      }
      function parseWithCodeFrame(code, parserOpts, syntacticPlaceholders) {
        const plugins3 = (parserOpts.plugins || []).slice();
        if (syntacticPlaceholders !== false) {
          plugins3.push("placeholders");
        }
        parserOpts = Object.assign({
          allowReturnOutsideFunction: true,
          allowSuperOutsideMethod: true,
          sourceType: "module"
        }, parserOpts, {
          plugins: plugins3
        });
        try {
          return (0, _parser.parse)(code, parserOpts);
        } catch (err) {
          const loc = err.loc;
          if (loc) {
            err.message += "\n" + (0, _codeFrame.codeFrameColumns)(code, {
              start: loc
            });
            err.code = "BABEL_TEMPLATE_PARSE_ERROR";
          }
          throw err;
        }
      }
    }
  });

  // node_modules/@babel/template/lib/populate.js
  var require_populate = __commonJS({
    "node_modules/@babel/template/lib/populate.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = populatePlaceholders;
      var _t = require_lib5();
      var {
        blockStatement,
        cloneNode,
        emptyStatement,
        expressionStatement: expressionStatement2,
        identifier: identifier3,
        isStatement,
        isStringLiteral,
        stringLiteral,
        validate
      } = _t;
      function populatePlaceholders(metadata, replacements) {
        const ast = cloneNode(metadata.ast);
        if (replacements) {
          metadata.placeholders.forEach((placeholder) => {
            if (!Object.prototype.hasOwnProperty.call(replacements, placeholder.name)) {
              const placeholderName = placeholder.name;
              throw new Error(`Error: No substitution given for "${placeholderName}". If this is not meant to be a
            placeholder you may want to consider passing one of the following options to @babel/template:
            - { placeholderPattern: false, placeholderWhitelist: new Set(['${placeholderName}'])}
            - { placeholderPattern: /^${placeholderName}$/ }`);
            }
          });
          Object.keys(replacements).forEach((key) => {
            if (!metadata.placeholderNames.has(key)) {
              throw new Error(`Unknown substitution "${key}" given`);
            }
          });
        }
        metadata.placeholders.slice().reverse().forEach((placeholder) => {
          try {
            applyReplacement(placeholder, ast, replacements && replacements[placeholder.name] || null);
          } catch (e) {
            e.message = `@babel/template placeholder "${placeholder.name}": ${e.message}`;
            throw e;
          }
        });
        return ast;
      }
      function applyReplacement(placeholder, ast, replacement) {
        if (placeholder.isDuplicate) {
          if (Array.isArray(replacement)) {
            replacement = replacement.map((node) => cloneNode(node));
          } else if (typeof replacement === "object") {
            replacement = cloneNode(replacement);
          }
        }
        const {
          parent: parent2,
          key,
          index
        } = placeholder.resolve(ast);
        if (placeholder.type === "string") {
          if (typeof replacement === "string") {
            replacement = stringLiteral(replacement);
          }
          if (!replacement || !isStringLiteral(replacement)) {
            throw new Error("Expected string substitution");
          }
        } else if (placeholder.type === "statement") {
          if (index === void 0) {
            if (!replacement) {
              replacement = emptyStatement();
            } else if (Array.isArray(replacement)) {
              replacement = blockStatement(replacement);
            } else if (typeof replacement === "string") {
              replacement = expressionStatement2(identifier3(replacement));
            } else if (!isStatement(replacement)) {
              replacement = expressionStatement2(replacement);
            }
          } else {
            if (replacement && !Array.isArray(replacement)) {
              if (typeof replacement === "string") {
                replacement = identifier3(replacement);
              }
              if (!isStatement(replacement)) {
                replacement = expressionStatement2(replacement);
              }
            }
          }
        } else if (placeholder.type === "param") {
          if (typeof replacement === "string") {
            replacement = identifier3(replacement);
          }
          if (index === void 0)
            throw new Error("Assertion failure.");
        } else {
          if (typeof replacement === "string") {
            replacement = identifier3(replacement);
          }
          if (Array.isArray(replacement)) {
            throw new Error("Cannot replace single expression with an array.");
          }
        }
        if (index === void 0) {
          validate(parent2, key, replacement);
          parent2[key] = replacement;
        } else {
          const items = parent2[key].slice();
          if (placeholder.type === "statement" || placeholder.type === "param") {
            if (replacement == null) {
              items.splice(index, 1);
            } else if (Array.isArray(replacement)) {
              items.splice(index, 1, ...replacement);
            } else {
              items[index] = replacement;
            }
          } else {
            items[index] = replacement;
          }
          validate(parent2, key, items);
          parent2[key] = items;
        }
      }
    }
  });

  // node_modules/@babel/template/lib/string.js
  var require_string = __commonJS({
    "node_modules/@babel/template/lib/string.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = stringTemplate;
      var _options = require_options();
      var _parse = require_parse();
      var _populate = require_populate();
      function stringTemplate(formatter, code, opts) {
        code = formatter.code(code);
        let metadata;
        return (arg) => {
          const replacements = (0, _options.normalizeReplacements)(arg);
          if (!metadata)
            metadata = (0, _parse.default)(formatter, code, opts);
          return formatter.unwrap((0, _populate.default)(metadata, replacements));
        };
      }
    }
  });

  // node_modules/@babel/template/lib/literal.js
  var require_literal = __commonJS({
    "node_modules/@babel/template/lib/literal.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = literalTemplate;
      var _options = require_options();
      var _parse = require_parse();
      var _populate = require_populate();
      function literalTemplate(formatter, tpl, opts) {
        const {
          metadata,
          names
        } = buildLiteralData(formatter, tpl, opts);
        return (arg) => {
          const defaultReplacements = {};
          arg.forEach((replacement, i) => {
            defaultReplacements[names[i]] = replacement;
          });
          return (arg2) => {
            const replacements = (0, _options.normalizeReplacements)(arg2);
            if (replacements) {
              Object.keys(replacements).forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(defaultReplacements, key)) {
                  throw new Error("Unexpected replacement overlap.");
                }
              });
            }
            return formatter.unwrap((0, _populate.default)(metadata, replacements ? Object.assign(replacements, defaultReplacements) : defaultReplacements));
          };
        };
      }
      function buildLiteralData(formatter, tpl, opts) {
        let names;
        let nameSet;
        let metadata;
        let prefix = "";
        do {
          prefix += "$";
          const result2 = buildTemplateCode(tpl, prefix);
          names = result2.names;
          nameSet = new Set(names);
          metadata = (0, _parse.default)(formatter, formatter.code(result2.code), {
            parser: opts.parser,
            placeholderWhitelist: new Set(result2.names.concat(opts.placeholderWhitelist ? Array.from(opts.placeholderWhitelist) : [])),
            placeholderPattern: opts.placeholderPattern,
            preserveComments: opts.preserveComments,
            syntacticPlaceholders: opts.syntacticPlaceholders
          });
        } while (metadata.placeholders.some((placeholder) => placeholder.isDuplicate && nameSet.has(placeholder.name)));
        return {
          metadata,
          names
        };
      }
      function buildTemplateCode(tpl, prefix) {
        const names = [];
        let code = tpl[0];
        for (let i = 1; i < tpl.length; i++) {
          const value = `${prefix}${i - 1}`;
          names.push(value);
          code += value + tpl[i];
        }
        return {
          names,
          code
        };
      }
    }
  });

  // node_modules/@babel/template/lib/builder.js
  var require_builder = __commonJS({
    "node_modules/@babel/template/lib/builder.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = createTemplateBuilder;
      var _options = require_options();
      var _string = require_string();
      var _literal = require_literal();
      var NO_PLACEHOLDER = (0, _options.validate)({
        placeholderPattern: false
      });
      function createTemplateBuilder(formatter, defaultOpts) {
        const templateFnCache = /* @__PURE__ */ new WeakMap();
        const templateAstCache = /* @__PURE__ */ new WeakMap();
        const cachedOpts = defaultOpts || (0, _options.validate)(null);
        return Object.assign((tpl, ...args) => {
          if (typeof tpl === "string") {
            if (args.length > 1)
              throw new Error("Unexpected extra params.");
            return extendedTrace((0, _string.default)(formatter, tpl, (0, _options.merge)(cachedOpts, (0, _options.validate)(args[0]))));
          } else if (Array.isArray(tpl)) {
            let builder = templateFnCache.get(tpl);
            if (!builder) {
              builder = (0, _literal.default)(formatter, tpl, cachedOpts);
              templateFnCache.set(tpl, builder);
            }
            return extendedTrace(builder(args));
          } else if (typeof tpl === "object" && tpl) {
            if (args.length > 0)
              throw new Error("Unexpected extra params.");
            return createTemplateBuilder(formatter, (0, _options.merge)(cachedOpts, (0, _options.validate)(tpl)));
          }
          throw new Error(`Unexpected template param ${typeof tpl}`);
        }, {
          ast: (tpl, ...args) => {
            if (typeof tpl === "string") {
              if (args.length > 1)
                throw new Error("Unexpected extra params.");
              return (0, _string.default)(formatter, tpl, (0, _options.merge)((0, _options.merge)(cachedOpts, (0, _options.validate)(args[0])), NO_PLACEHOLDER))();
            } else if (Array.isArray(tpl)) {
              let builder = templateAstCache.get(tpl);
              if (!builder) {
                builder = (0, _literal.default)(formatter, tpl, (0, _options.merge)(cachedOpts, NO_PLACEHOLDER));
                templateAstCache.set(tpl, builder);
              }
              return builder(args)();
            }
            throw new Error(`Unexpected template param ${typeof tpl}`);
          }
        });
      }
      function extendedTrace(fn) {
        let rootStack = "";
        try {
          throw new Error();
        } catch (error) {
          if (error.stack) {
            rootStack = error.stack.split("\n").slice(3).join("\n");
          }
        }
        return (arg) => {
          try {
            return fn(arg);
          } catch (err) {
            err.stack += `
    =============
${rootStack}`;
            throw err;
          }
        };
      }
    }
  });

  // node_modules/@babel/template/lib/index.js
  var require_lib12 = __commonJS({
    "node_modules/@babel/template/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.statements = exports2.statement = exports2.smart = exports2.program = exports2.expression = exports2.default = void 0;
      var formatters = require_formatters();
      var _builder = require_builder();
      var smart = (0, _builder.default)(formatters.smart);
      exports2.smart = smart;
      var statement = (0, _builder.default)(formatters.statement);
      exports2.statement = statement;
      var statements = (0, _builder.default)(formatters.statements);
      exports2.statements = statements;
      var expression = (0, _builder.default)(formatters.expression);
      exports2.expression = expression;
      var program3 = (0, _builder.default)(formatters.program);
      exports2.program = program3;
      var _default = Object.assign(smart.bind(void 0), {
        smart,
        statement,
        statements,
        expression,
        program: program3,
        ast: smart.ast
      });
      exports2.default = _default;
    }
  });

  // node_modules/@babel/helper-function-name/lib/index.js
  var require_lib13 = __commonJS({
    "node_modules/@babel/helper-function-name/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = _default;
      var _template = require_lib12();
      var _t = require_lib5();
      var {
        NOT_LOCAL_BINDING,
        cloneNode,
        identifier: identifier3,
        isAssignmentExpression,
        isAssignmentPattern,
        isFunction: isFunction2,
        isIdentifier: isIdentifier2,
        isLiteral,
        isNullLiteral,
        isObjectMethod,
        isObjectProperty,
        isRegExpLiteral,
        isRestElement,
        isTemplateLiteral,
        isVariableDeclarator,
        toBindingIdentifierName
      } = _t;
      function getFunctionArity(node) {
        const count = node.params.findIndex((param) => isAssignmentPattern(param) || isRestElement(param));
        return count === -1 ? node.params.length : count;
      }
      var buildPropertyMethodAssignmentWrapper = _template.default.statement(`
  (function (FUNCTION_KEY) {
    function FUNCTION_ID() {
      return FUNCTION_KEY.apply(this, arguments);
    }

    FUNCTION_ID.toString = function () {
      return FUNCTION_KEY.toString();
    }

    return FUNCTION_ID;
  })(FUNCTION)
`);
      var buildGeneratorPropertyMethodAssignmentWrapper = _template.default.statement(`
  (function (FUNCTION_KEY) {
    function* FUNCTION_ID() {
      return yield* FUNCTION_KEY.apply(this, arguments);
    }

    FUNCTION_ID.toString = function () {
      return FUNCTION_KEY.toString();
    };

    return FUNCTION_ID;
  })(FUNCTION)
`);
      var visitor = {
        "ReferencedIdentifier|BindingIdentifier"(path, state) {
          if (path.node.name !== state.name)
            return;
          const localDeclar = path.scope.getBindingIdentifier(state.name);
          if (localDeclar !== state.outerDeclar)
            return;
          state.selfReference = true;
          path.stop();
        }
      };
      function getNameFromLiteralId(id) {
        if (isNullLiteral(id)) {
          return "null";
        }
        if (isRegExpLiteral(id)) {
          return `_${id.pattern}_${id.flags}`;
        }
        if (isTemplateLiteral(id)) {
          return id.quasis.map((quasi) => quasi.value.raw).join("");
        }
        if (id.value !== void 0) {
          return id.value + "";
        }
        return "";
      }
      function wrap2(state, method2, id, scope) {
        if (state.selfReference) {
          if (scope.hasBinding(id.name) && !scope.hasGlobal(id.name)) {
            scope.rename(id.name);
          } else {
            if (!isFunction2(method2))
              return;
            let build = buildPropertyMethodAssignmentWrapper;
            if (method2.generator) {
              build = buildGeneratorPropertyMethodAssignmentWrapper;
            }
            const template2 = build({
              FUNCTION: method2,
              FUNCTION_ID: id,
              FUNCTION_KEY: scope.generateUidIdentifier(id.name)
            }).expression;
            const params = template2.callee.body.body[0].params;
            for (let i = 0, len = getFunctionArity(method2); i < len; i++) {
              params.push(scope.generateUidIdentifier("x"));
            }
            return template2;
          }
        }
        method2.id = id;
        scope.getProgramParent().references[id.name] = true;
      }
      function visit(node, name, scope) {
        const state = {
          selfAssignment: false,
          selfReference: false,
          outerDeclar: scope.getBindingIdentifier(name),
          name
        };
        const binding = scope.getOwnBinding(name);
        if (binding) {
          if (binding.kind === "param") {
            state.selfReference = true;
          } else {
          }
        } else if (state.outerDeclar || scope.hasGlobal(name)) {
          scope.traverse(node, visitor, state);
        }
        return state;
      }
      function _default({
        node,
        parent: parent2,
        scope,
        id
      }, localBinding = false, supportUnicodeId = false) {
        if (node.id)
          return;
        if ((isObjectProperty(parent2) || isObjectMethod(parent2, {
          kind: "method"
        })) && (!parent2.computed || isLiteral(parent2.key))) {
          id = parent2.key;
        } else if (isVariableDeclarator(parent2)) {
          id = parent2.id;
          if (isIdentifier2(id) && !localBinding) {
            const binding = scope.parent.getBinding(id.name);
            if (binding && binding.constant && scope.getBinding(id.name) === binding) {
              node.id = cloneNode(id);
              node.id[NOT_LOCAL_BINDING] = true;
              return;
            }
          }
        } else if (isAssignmentExpression(parent2, {
          operator: "="
        })) {
          id = parent2.left;
        } else if (!id) {
          return;
        }
        let name;
        if (id && isLiteral(id)) {
          name = getNameFromLiteralId(id);
        } else if (id && isIdentifier2(id)) {
          name = id.name;
        }
        if (name === void 0) {
          return;
        }
        if (!supportUnicodeId && isFunction2(node) && /[\uD800-\uDFFF]/.test(name)) {
          return;
        }
        name = toBindingIdentifierName(name);
        const newId = identifier3(name);
        newId[NOT_LOCAL_BINDING] = true;
        const state = visit(node, name, scope);
        return wrap2(state, node, newId, scope) || node;
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/conversion.js
  var require_conversion = __commonJS({
    "node_modules/@babel/traverse/lib/path/conversion.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.arrowFunctionToExpression = arrowFunctionToExpression;
      exports2.arrowFunctionToShadowed = arrowFunctionToShadowed;
      exports2.ensureBlock = ensureBlock;
      exports2.toComputedKey = toComputedKey;
      exports2.unwrapFunctionEnvironment = unwrapFunctionEnvironment;
      var _t = require_lib5();
      var _helperEnvironmentVisitor = require_lib8();
      var _helperFunctionName = require_lib13();
      var _visitors = require_visitors();
      var {
        arrowFunctionExpression: arrowFunctionExpression2,
        assignmentExpression,
        binaryExpression,
        blockStatement,
        callExpression,
        conditionalExpression,
        expressionStatement: expressionStatement2,
        identifier: identifier3,
        isIdentifier: isIdentifier2,
        jsxIdentifier,
        logicalExpression,
        LOGICAL_OPERATORS,
        memberExpression,
        metaProperty,
        numericLiteral,
        objectExpression,
        restElement,
        returnStatement,
        sequenceExpression,
        spreadElement,
        stringLiteral,
        super: _super,
        thisExpression,
        toExpression,
        unaryExpression
      } = _t;
      function toComputedKey() {
        let key;
        if (this.isMemberExpression()) {
          key = this.node.property;
        } else if (this.isProperty() || this.isMethod()) {
          key = this.node.key;
        } else {
          throw new ReferenceError("todo");
        }
        if (!this.node.computed) {
          if (isIdentifier2(key))
            key = stringLiteral(key.name);
        }
        return key;
      }
      function ensureBlock() {
        const body = this.get("body");
        const bodyNode = body.node;
        if (Array.isArray(body)) {
          throw new Error("Can't convert array path to a block statement");
        }
        if (!bodyNode) {
          throw new Error("Can't convert node without a body");
        }
        if (body.isBlockStatement()) {
          return bodyNode;
        }
        const statements = [];
        let stringPath = "body";
        let key;
        let listKey;
        if (body.isStatement()) {
          listKey = "body";
          key = 0;
          statements.push(body.node);
        } else {
          stringPath += ".body.0";
          if (this.isFunction()) {
            key = "argument";
            statements.push(returnStatement(body.node));
          } else {
            key = "expression";
            statements.push(expressionStatement2(body.node));
          }
        }
        this.node.body = blockStatement(statements);
        const parentPath = this.get(stringPath);
        body.setup(parentPath, listKey ? parentPath.node[listKey] : parentPath.node, listKey, key);
        return this.node;
      }
      function arrowFunctionToShadowed() {
        if (!this.isArrowFunctionExpression())
          return;
        this.arrowFunctionToExpression();
      }
      function unwrapFunctionEnvironment() {
        if (!this.isArrowFunctionExpression() && !this.isFunctionExpression() && !this.isFunctionDeclaration()) {
          throw this.buildCodeFrameError("Can only unwrap the environment of a function.");
        }
        hoistFunctionEnvironment(this);
      }
      function setType(path, type) {
        path.node.type = type;
      }
      function arrowFunctionToExpression({
        allowInsertArrow = true,
        allowInsertArrowWithRest = allowInsertArrow,
        specCompliant = false,
        noNewArrows = !specCompliant
      } = {}) {
        if (!this.isArrowFunctionExpression()) {
          throw this.buildCodeFrameError("Cannot convert non-arrow function to a function expression.");
        }
        const {
          thisBinding,
          fnPath: fn
        } = hoistFunctionEnvironment(this, noNewArrows, allowInsertArrow, allowInsertArrowWithRest);
        fn.ensureBlock();
        setType(fn, "FunctionExpression");
        if (!noNewArrows) {
          const checkBinding = thisBinding ? null : fn.scope.generateUidIdentifier("arrowCheckId");
          if (checkBinding) {
            fn.parentPath.scope.push({
              id: checkBinding,
              init: objectExpression([])
            });
          }
          fn.get("body").unshiftContainer("body", expressionStatement2(callExpression(this.hub.addHelper("newArrowCheck"), [thisExpression(), checkBinding ? identifier3(checkBinding.name) : identifier3(thisBinding)])));
          fn.replaceWith(callExpression(memberExpression(
            (0, _helperFunctionName.default)(this, true) || fn.node,
            identifier3("bind")
          ), [checkBinding ? identifier3(checkBinding.name) : thisExpression()]));
          return fn.get("callee.object");
        }
        return fn;
      }
      var getSuperCallsVisitor = (0, _visitors.merge)([{
        CallExpression(child, {
          allSuperCalls
        }) {
          if (!child.get("callee").isSuper())
            return;
          allSuperCalls.push(child);
        }
      }, _helperEnvironmentVisitor.default]);
      function hoistFunctionEnvironment(fnPath, noNewArrows = true, allowInsertArrow = true, allowInsertArrowWithRest = true) {
        let arrowParent;
        let thisEnvFn = fnPath.findParent((p) => {
          if (p.isArrowFunctionExpression()) {
            var _arrowParent;
            (_arrowParent = arrowParent) != null ? _arrowParent : arrowParent = p;
            return false;
          }
          return p.isFunction() || p.isProgram() || p.isClassProperty({
            static: false
          }) || p.isClassPrivateProperty({
            static: false
          });
        });
        const inConstructor = thisEnvFn.isClassMethod({
          kind: "constructor"
        });
        if (thisEnvFn.isClassProperty() || thisEnvFn.isClassPrivateProperty()) {
          if (arrowParent) {
            thisEnvFn = arrowParent;
          } else if (allowInsertArrow) {
            fnPath.replaceWith(callExpression(arrowFunctionExpression2([], toExpression(fnPath.node)), []));
            thisEnvFn = fnPath.get("callee");
            fnPath = thisEnvFn.get("body");
          } else {
            throw fnPath.buildCodeFrameError("Unable to transform arrow inside class property");
          }
        }
        const {
          thisPaths,
          argumentsPaths,
          newTargetPaths,
          superProps,
          superCalls
        } = getScopeInformation(fnPath);
        if (inConstructor && superCalls.length > 0) {
          if (!allowInsertArrow) {
            throw superCalls[0].buildCodeFrameError("When using '@babel/plugin-transform-arrow-functions', it's not possible to compile `super()` in an arrow function without compiling classes.\nPlease add '@babel/plugin-transform-classes' to your Babel configuration.");
          }
          if (!allowInsertArrowWithRest) {
            throw superCalls[0].buildCodeFrameError("When using '@babel/plugin-transform-parameters', it's not possible to compile `super()` in an arrow function with default or rest parameters without compiling classes.\nPlease add '@babel/plugin-transform-classes' to your Babel configuration.");
          }
          const allSuperCalls = [];
          thisEnvFn.traverse(getSuperCallsVisitor, {
            allSuperCalls
          });
          const superBinding = getSuperBinding(thisEnvFn);
          allSuperCalls.forEach((superCall) => {
            const callee = identifier3(superBinding);
            callee.loc = superCall.node.callee.loc;
            superCall.get("callee").replaceWith(callee);
          });
        }
        if (argumentsPaths.length > 0) {
          const argumentsBinding = getBinding(thisEnvFn, "arguments", () => {
            const args = () => identifier3("arguments");
            if (thisEnvFn.scope.path.isProgram()) {
              return conditionalExpression(binaryExpression("===", unaryExpression("typeof", args()), stringLiteral("undefined")), thisEnvFn.scope.buildUndefinedNode(), args());
            } else {
              return args();
            }
          });
          argumentsPaths.forEach((argumentsChild) => {
            const argsRef = identifier3(argumentsBinding);
            argsRef.loc = argumentsChild.node.loc;
            argumentsChild.replaceWith(argsRef);
          });
        }
        if (newTargetPaths.length > 0) {
          const newTargetBinding = getBinding(thisEnvFn, "newtarget", () => metaProperty(identifier3("new"), identifier3("target")));
          newTargetPaths.forEach((targetChild) => {
            const targetRef = identifier3(newTargetBinding);
            targetRef.loc = targetChild.node.loc;
            targetChild.replaceWith(targetRef);
          });
        }
        if (superProps.length > 0) {
          if (!allowInsertArrow) {
            throw superProps[0].buildCodeFrameError("When using '@babel/plugin-transform-arrow-functions', it's not possible to compile `super.prop` in an arrow function without compiling classes.\nPlease add '@babel/plugin-transform-classes' to your Babel configuration.");
          }
          const flatSuperProps = superProps.reduce((acc, superProp) => acc.concat(standardizeSuperProperty(superProp)), []);
          flatSuperProps.forEach((superProp) => {
            const key = superProp.node.computed ? "" : superProp.get("property").node.name;
            const superParentPath = superProp.parentPath;
            const isAssignment = superParentPath.isAssignmentExpression({
              left: superProp.node
            });
            const isCall = superParentPath.isCallExpression({
              callee: superProp.node
            });
            const isTaggedTemplate = superParentPath.isTaggedTemplateExpression({
              tag: superProp.node
            });
            const superBinding = getSuperPropBinding(thisEnvFn, isAssignment, key);
            const args = [];
            if (superProp.node.computed) {
              args.push(superProp.get("property").node);
            }
            if (isAssignment) {
              const value = superParentPath.node.right;
              args.push(value);
            }
            const call = callExpression(identifier3(superBinding), args);
            if (isCall) {
              superParentPath.unshiftContainer("arguments", thisExpression());
              superProp.replaceWith(memberExpression(call, identifier3("call")));
              thisPaths.push(superParentPath.get("arguments.0"));
            } else if (isAssignment) {
              superParentPath.replaceWith(call);
            } else if (isTaggedTemplate) {
              superProp.replaceWith(callExpression(memberExpression(call, identifier3("bind"), false), [thisExpression()]));
              thisPaths.push(superProp.get("arguments.0"));
            } else {
              superProp.replaceWith(call);
            }
          });
        }
        let thisBinding;
        if (thisPaths.length > 0 || !noNewArrows) {
          thisBinding = getThisBinding(thisEnvFn, inConstructor);
          if (noNewArrows || inConstructor && hasSuperClass(thisEnvFn)) {
            thisPaths.forEach((thisChild) => {
              const thisRef = thisChild.isJSX() ? jsxIdentifier(thisBinding) : identifier3(thisBinding);
              thisRef.loc = thisChild.node.loc;
              thisChild.replaceWith(thisRef);
            });
            if (!noNewArrows)
              thisBinding = null;
          }
        }
        return {
          thisBinding,
          fnPath
        };
      }
      function isLogicalOp(op) {
        return LOGICAL_OPERATORS.includes(op);
      }
      function standardizeSuperProperty(superProp) {
        if (superProp.parentPath.isAssignmentExpression() && superProp.parentPath.node.operator !== "=") {
          const assignmentPath = superProp.parentPath;
          const op = assignmentPath.node.operator.slice(0, -1);
          const value = assignmentPath.node.right;
          const isLogicalAssignment = isLogicalOp(op);
          if (superProp.node.computed) {
            const tmp = superProp.scope.generateDeclaredUidIdentifier("tmp");
            const object = superProp.node.object;
            const property2 = superProp.node.property;
            assignmentPath.get("left").replaceWith(memberExpression(object, assignmentExpression("=", tmp, property2), true));
            assignmentPath.get("right").replaceWith(rightExpression(isLogicalAssignment ? "=" : op, memberExpression(object, identifier3(tmp.name), true), value));
          } else {
            const object = superProp.node.object;
            const property2 = superProp.node.property;
            assignmentPath.get("left").replaceWith(memberExpression(object, property2));
            assignmentPath.get("right").replaceWith(rightExpression(isLogicalAssignment ? "=" : op, memberExpression(object, identifier3(property2.name)), value));
          }
          if (isLogicalAssignment) {
            assignmentPath.replaceWith(logicalExpression(op, assignmentPath.node.left, assignmentPath.node.right));
          } else {
            assignmentPath.node.operator = "=";
          }
          return [assignmentPath.get("left"), assignmentPath.get("right").get("left")];
        } else if (superProp.parentPath.isUpdateExpression()) {
          const updateExpr = superProp.parentPath;
          const tmp = superProp.scope.generateDeclaredUidIdentifier("tmp");
          const computedKey = superProp.node.computed ? superProp.scope.generateDeclaredUidIdentifier("prop") : null;
          const parts = [assignmentExpression("=", tmp, memberExpression(superProp.node.object, computedKey ? assignmentExpression("=", computedKey, superProp.node.property) : superProp.node.property, superProp.node.computed)), assignmentExpression("=", memberExpression(superProp.node.object, computedKey ? identifier3(computedKey.name) : superProp.node.property, superProp.node.computed), binaryExpression(
            superProp.parentPath.node.operator[0],
            identifier3(tmp.name),
            numericLiteral(1)
          ))];
          if (!superProp.parentPath.node.prefix) {
            parts.push(identifier3(tmp.name));
          }
          updateExpr.replaceWith(sequenceExpression(parts));
          const left = updateExpr.get("expressions.0.right");
          const right = updateExpr.get("expressions.1.left");
          return [left, right];
        }
        return [superProp];
        function rightExpression(op, left, right) {
          if (op === "=") {
            return assignmentExpression("=", left, right);
          } else {
            return binaryExpression(op, left, right);
          }
        }
      }
      function hasSuperClass(thisEnvFn) {
        return thisEnvFn.isClassMethod() && !!thisEnvFn.parentPath.parentPath.node.superClass;
      }
      var assignSuperThisVisitor = (0, _visitors.merge)([{
        CallExpression(child, {
          supers,
          thisBinding
        }) {
          if (!child.get("callee").isSuper())
            return;
          if (supers.has(child.node))
            return;
          supers.add(child.node);
          child.replaceWithMultiple([child.node, assignmentExpression("=", identifier3(thisBinding), identifier3("this"))]);
        }
      }, _helperEnvironmentVisitor.default]);
      function getThisBinding(thisEnvFn, inConstructor) {
        return getBinding(thisEnvFn, "this", (thisBinding) => {
          if (!inConstructor || !hasSuperClass(thisEnvFn))
            return thisExpression();
          thisEnvFn.traverse(assignSuperThisVisitor, {
            supers: /* @__PURE__ */ new WeakSet(),
            thisBinding
          });
        });
      }
      function getSuperBinding(thisEnvFn) {
        return getBinding(thisEnvFn, "supercall", () => {
          const argsBinding = thisEnvFn.scope.generateUidIdentifier("args");
          return arrowFunctionExpression2([restElement(argsBinding)], callExpression(_super(), [spreadElement(identifier3(argsBinding.name))]));
        });
      }
      function getSuperPropBinding(thisEnvFn, isAssignment, propName) {
        const op = isAssignment ? "set" : "get";
        return getBinding(thisEnvFn, `superprop_${op}:${propName || ""}`, () => {
          const argsList = [];
          let fnBody;
          if (propName) {
            fnBody = memberExpression(_super(), identifier3(propName));
          } else {
            const method2 = thisEnvFn.scope.generateUidIdentifier("prop");
            argsList.unshift(method2);
            fnBody = memberExpression(_super(), identifier3(method2.name), true);
          }
          if (isAssignment) {
            const valueIdent = thisEnvFn.scope.generateUidIdentifier("value");
            argsList.push(valueIdent);
            fnBody = assignmentExpression("=", fnBody, identifier3(valueIdent.name));
          }
          return arrowFunctionExpression2(argsList, fnBody);
        });
      }
      function getBinding(thisEnvFn, key, init) {
        const cacheKey = "binding:" + key;
        let data = thisEnvFn.getData(cacheKey);
        if (!data) {
          const id = thisEnvFn.scope.generateUidIdentifier(key);
          data = id.name;
          thisEnvFn.setData(cacheKey, data);
          thisEnvFn.scope.push({
            id,
            init: init(data)
          });
        }
        return data;
      }
      var getScopeInformationVisitor = (0, _visitors.merge)([{
        ThisExpression(child, {
          thisPaths
        }) {
          thisPaths.push(child);
        },
        JSXIdentifier(child, {
          thisPaths
        }) {
          if (child.node.name !== "this")
            return;
          if (!child.parentPath.isJSXMemberExpression({
            object: child.node
          }) && !child.parentPath.isJSXOpeningElement({
            name: child.node
          })) {
            return;
          }
          thisPaths.push(child);
        },
        CallExpression(child, {
          superCalls
        }) {
          if (child.get("callee").isSuper())
            superCalls.push(child);
        },
        MemberExpression(child, {
          superProps
        }) {
          if (child.get("object").isSuper())
            superProps.push(child);
        },
        Identifier(child, {
          argumentsPaths
        }) {
          if (!child.isReferencedIdentifier({
            name: "arguments"
          }))
            return;
          let curr = child.scope;
          do {
            if (curr.hasOwnBinding("arguments")) {
              curr.rename("arguments");
              return;
            }
            if (curr.path.isFunction() && !curr.path.isArrowFunctionExpression()) {
              break;
            }
          } while (curr = curr.parent);
          argumentsPaths.push(child);
        },
        MetaProperty(child, {
          newTargetPaths
        }) {
          if (!child.get("meta").isIdentifier({
            name: "new"
          }))
            return;
          if (!child.get("property").isIdentifier({
            name: "target"
          }))
            return;
          newTargetPaths.push(child);
        }
      }, _helperEnvironmentVisitor.default]);
      function getScopeInformation(fnPath) {
        const thisPaths = [];
        const argumentsPaths = [];
        const newTargetPaths = [];
        const superProps = [];
        const superCalls = [];
        fnPath.traverse(getScopeInformationVisitor, {
          thisPaths,
          argumentsPaths,
          newTargetPaths,
          superProps,
          superCalls
        });
        return {
          thisPaths,
          argumentsPaths,
          newTargetPaths,
          superProps,
          superCalls
        };
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/introspection.js
  var require_introspection = __commonJS({
    "node_modules/@babel/traverse/lib/path/introspection.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._guessExecutionStatusRelativeTo = _guessExecutionStatusRelativeTo;
      exports2._resolve = _resolve;
      exports2.canHaveVariableDeclarationOrExpression = canHaveVariableDeclarationOrExpression;
      exports2.canSwapBetweenExpressionAndStatement = canSwapBetweenExpressionAndStatement;
      exports2.equals = equals;
      exports2.getSource = getSource;
      exports2.has = has2;
      exports2.is = void 0;
      exports2.isCompletionRecord = isCompletionRecord;
      exports2.isConstantExpression = isConstantExpression;
      exports2.isInStrictMode = isInStrictMode;
      exports2.isNodeType = isNodeType;
      exports2.isStatementOrBlock = isStatementOrBlock;
      exports2.isStatic = isStatic;
      exports2.isnt = isnt;
      exports2.matchesPattern = matchesPattern;
      exports2.referencesImport = referencesImport;
      exports2.resolve = resolve;
      exports2.willIMaybeExecuteBefore = willIMaybeExecuteBefore;
      var _t = require_lib5();
      var {
        STATEMENT_OR_BLOCK_KEYS,
        VISITOR_KEYS,
        isBlockStatement,
        isExpression,
        isIdentifier: isIdentifier2,
        isLiteral,
        isStringLiteral,
        isType,
        matchesPattern: _matchesPattern
      } = _t;
      function matchesPattern(pattern, allowPartial) {
        return _matchesPattern(this.node, pattern, allowPartial);
      }
      function has2(key) {
        const val = this.node && this.node[key];
        if (val && Array.isArray(val)) {
          return !!val.length;
        } else {
          return !!val;
        }
      }
      function isStatic() {
        return this.scope.isStatic(this.node);
      }
      var is = has2;
      exports2.is = is;
      function isnt(key) {
        return !this.has(key);
      }
      function equals(key, value) {
        return this.node[key] === value;
      }
      function isNodeType(type) {
        return isType(this.type, type);
      }
      function canHaveVariableDeclarationOrExpression() {
        return (this.key === "init" || this.key === "left") && this.parentPath.isFor();
      }
      function canSwapBetweenExpressionAndStatement(replacement) {
        if (this.key !== "body" || !this.parentPath.isArrowFunctionExpression()) {
          return false;
        }
        if (this.isExpression()) {
          return isBlockStatement(replacement);
        } else if (this.isBlockStatement()) {
          return isExpression(replacement);
        }
        return false;
      }
      function isCompletionRecord(allowInsideFunction) {
        let path = this;
        let first = true;
        do {
          const {
            type,
            container
          } = path;
          if (!first && (path.isFunction() || type === "StaticBlock")) {
            return !!allowInsideFunction;
          }
          first = false;
          if (Array.isArray(container) && path.key !== container.length - 1) {
            return false;
          }
        } while ((path = path.parentPath) && !path.isProgram() && !path.isDoExpression());
        return true;
      }
      function isStatementOrBlock() {
        if (this.parentPath.isLabeledStatement() || isBlockStatement(this.container)) {
          return false;
        } else {
          return STATEMENT_OR_BLOCK_KEYS.includes(this.key);
        }
      }
      function referencesImport(moduleSource, importName) {
        if (!this.isReferencedIdentifier()) {
          if (this.isJSXMemberExpression() && this.node.property.name === importName || (this.isMemberExpression() || this.isOptionalMemberExpression()) && (this.node.computed ? isStringLiteral(this.node.property, {
            value: importName
          }) : this.node.property.name === importName)) {
            const object = this.get("object");
            return object.isReferencedIdentifier() && object.referencesImport(moduleSource, "*");
          }
          return false;
        }
        const binding = this.scope.getBinding(this.node.name);
        if (!binding || binding.kind !== "module")
          return false;
        const path = binding.path;
        const parent2 = path.parentPath;
        if (!parent2.isImportDeclaration())
          return false;
        if (parent2.node.source.value === moduleSource) {
          if (!importName)
            return true;
        } else {
          return false;
        }
        if (path.isImportDefaultSpecifier() && importName === "default") {
          return true;
        }
        if (path.isImportNamespaceSpecifier() && importName === "*") {
          return true;
        }
        if (path.isImportSpecifier() && isIdentifier2(path.node.imported, {
          name: importName
        })) {
          return true;
        }
        return false;
      }
      function getSource() {
        const node = this.node;
        if (node.end) {
          const code = this.hub.getCode();
          if (code)
            return code.slice(node.start, node.end);
        }
        return "";
      }
      function willIMaybeExecuteBefore(target) {
        return this._guessExecutionStatusRelativeTo(target) !== "after";
      }
      function getOuterFunction(path) {
        return (path.scope.getFunctionParent() || path.scope.getProgramParent()).path;
      }
      function isExecutionUncertain(type, key) {
        switch (type) {
          case "LogicalExpression":
            return key === "right";
          case "ConditionalExpression":
          case "IfStatement":
            return key === "consequent" || key === "alternate";
          case "WhileStatement":
          case "DoWhileStatement":
          case "ForInStatement":
          case "ForOfStatement":
            return key === "body";
          case "ForStatement":
            return key === "body" || key === "update";
          case "SwitchStatement":
            return key === "cases";
          case "TryStatement":
            return key === "handler";
          case "AssignmentPattern":
            return key === "right";
          case "OptionalMemberExpression":
            return key === "property";
          case "OptionalCallExpression":
            return key === "arguments";
          default:
            return false;
        }
      }
      function isExecutionUncertainInList(paths, maxIndex) {
        for (let i = 0; i < maxIndex; i++) {
          const path = paths[i];
          if (isExecutionUncertain(path.parent.type, path.parentKey)) {
            return true;
          }
        }
        return false;
      }
      function _guessExecutionStatusRelativeTo(target) {
        return _guessExecutionStatusRelativeToCached(this, target, /* @__PURE__ */ new Map());
      }
      function _guessExecutionStatusRelativeToCached(base, target, cache) {
        const funcParent = {
          this: getOuterFunction(base),
          target: getOuterFunction(target)
        };
        if (funcParent.target.node !== funcParent.this.node) {
          return _guessExecutionStatusRelativeToDifferentFunctionsCached(base, funcParent.target, cache);
        }
        const paths = {
          target: target.getAncestry(),
          this: base.getAncestry()
        };
        if (paths.target.indexOf(base) >= 0)
          return "after";
        if (paths.this.indexOf(target) >= 0)
          return "before";
        let commonPath;
        const commonIndex = {
          target: 0,
          this: 0
        };
        while (!commonPath && commonIndex.this < paths.this.length) {
          const path = paths.this[commonIndex.this];
          commonIndex.target = paths.target.indexOf(path);
          if (commonIndex.target >= 0) {
            commonPath = path;
          } else {
            commonIndex.this++;
          }
        }
        if (!commonPath) {
          throw new Error("Internal Babel error - The two compared nodes don't appear to belong to the same program.");
        }
        if (isExecutionUncertainInList(paths.this, commonIndex.this - 1) || isExecutionUncertainInList(paths.target, commonIndex.target - 1)) {
          return "unknown";
        }
        const divergence = {
          this: paths.this[commonIndex.this - 1],
          target: paths.target[commonIndex.target - 1]
        };
        if (divergence.target.listKey && divergence.this.listKey && divergence.target.container === divergence.this.container) {
          return divergence.target.key > divergence.this.key ? "before" : "after";
        }
        const keys2 = VISITOR_KEYS[commonPath.type];
        const keyPosition = {
          this: keys2.indexOf(divergence.this.parentKey),
          target: keys2.indexOf(divergence.target.parentKey)
        };
        return keyPosition.target > keyPosition.this ? "before" : "after";
      }
      var executionOrderCheckedNodes = /* @__PURE__ */ new Set();
      function _guessExecutionStatusRelativeToDifferentFunctionsInternal(base, target, cache) {
        if (!target.isFunctionDeclaration() || target.parentPath.isExportDeclaration()) {
          return "unknown";
        }
        const binding = target.scope.getBinding(target.node.id.name);
        if (!binding.references)
          return "before";
        const referencePaths = binding.referencePaths;
        let allStatus;
        for (const path of referencePaths) {
          const childOfFunction = !!path.find((path2) => path2.node === target.node);
          if (childOfFunction)
            continue;
          if (path.key !== "callee" || !path.parentPath.isCallExpression()) {
            return "unknown";
          }
          if (executionOrderCheckedNodes.has(path.node))
            continue;
          executionOrderCheckedNodes.add(path.node);
          try {
            const status = _guessExecutionStatusRelativeToCached(base, path, cache);
            if (allStatus && allStatus !== status) {
              return "unknown";
            } else {
              allStatus = status;
            }
          } finally {
            executionOrderCheckedNodes.delete(path.node);
          }
        }
        return allStatus;
      }
      function _guessExecutionStatusRelativeToDifferentFunctionsCached(base, target, cache) {
        let nodeMap = cache.get(base.node);
        if (!nodeMap) {
          cache.set(base.node, nodeMap = /* @__PURE__ */ new Map());
        } else if (nodeMap.has(target.node)) {
          return nodeMap.get(target.node);
        }
        const result2 = _guessExecutionStatusRelativeToDifferentFunctionsInternal(base, target, cache);
        nodeMap.set(target.node, result2);
        return result2;
      }
      function resolve(dangerous, resolved) {
        return this._resolve(dangerous, resolved) || this;
      }
      function _resolve(dangerous, resolved) {
        if (resolved && resolved.indexOf(this) >= 0)
          return;
        resolved = resolved || [];
        resolved.push(this);
        if (this.isVariableDeclarator()) {
          if (this.get("id").isIdentifier()) {
            return this.get("init").resolve(dangerous, resolved);
          } else {
          }
        } else if (this.isReferencedIdentifier()) {
          const binding = this.scope.getBinding(this.node.name);
          if (!binding)
            return;
          if (!binding.constant)
            return;
          if (binding.kind === "module")
            return;
          if (binding.path !== this) {
            const ret = binding.path.resolve(dangerous, resolved);
            if (this.find((parent2) => parent2.node === ret.node))
              return;
            return ret;
          }
        } else if (this.isTypeCastExpression()) {
          return this.get("expression").resolve(dangerous, resolved);
        } else if (dangerous && this.isMemberExpression()) {
          const targetKey = this.toComputedKey();
          if (!isLiteral(targetKey))
            return;
          const targetName = targetKey.value;
          const target = this.get("object").resolve(dangerous, resolved);
          if (target.isObjectExpression()) {
            const props = target.get("properties");
            for (const prop of props) {
              if (!prop.isProperty())
                continue;
              const key = prop.get("key");
              let match = prop.isnt("computed") && key.isIdentifier({
                name: targetName
              });
              match = match || key.isLiteral({
                value: targetName
              });
              if (match)
                return prop.get("value").resolve(dangerous, resolved);
            }
          } else if (target.isArrayExpression() && !isNaN(+targetName)) {
            const elems = target.get("elements");
            const elem = elems[targetName];
            if (elem)
              return elem.resolve(dangerous, resolved);
          }
        }
      }
      function isConstantExpression() {
        if (this.isIdentifier()) {
          const binding = this.scope.getBinding(this.node.name);
          if (!binding)
            return false;
          return binding.constant;
        }
        if (this.isLiteral()) {
          if (this.isRegExpLiteral()) {
            return false;
          }
          if (this.isTemplateLiteral()) {
            return this.get("expressions").every((expression) => expression.isConstantExpression());
          }
          return true;
        }
        if (this.isUnaryExpression()) {
          if (this.node.operator !== "void") {
            return false;
          }
          return this.get("argument").isConstantExpression();
        }
        if (this.isBinaryExpression()) {
          const {
            operator
          } = this.node;
          return operator !== "in" && operator !== "instanceof" && this.get("left").isConstantExpression() && this.get("right").isConstantExpression();
        }
        return false;
      }
      function isInStrictMode() {
        const start = this.isProgram() ? this : this.parentPath;
        const strictParent = start.find((path) => {
          if (path.isProgram({
            sourceType: "module"
          }))
            return true;
          if (path.isClass())
            return true;
          if (path.isArrowFunctionExpression() && !path.get("body").isBlockStatement()) {
            return false;
          }
          let body;
          if (path.isFunction()) {
            body = path.node.body;
          } else if (path.isProgram()) {
            body = path.node;
          } else {
            return false;
          }
          for (const directive of body.directives) {
            if (directive.value.value === "use strict") {
              return true;
            }
          }
        });
        return !!strictParent;
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/context.js
  var require_context = __commonJS({
    "node_modules/@babel/traverse/lib/path/context.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._call = _call;
      exports2._getQueueContexts = _getQueueContexts;
      exports2._resyncKey = _resyncKey;
      exports2._resyncList = _resyncList;
      exports2._resyncParent = _resyncParent;
      exports2._resyncRemoved = _resyncRemoved;
      exports2.call = call;
      exports2.isBlacklisted = exports2.isDenylisted = isDenylisted;
      exports2.popContext = popContext;
      exports2.pushContext = pushContext;
      exports2.requeue = requeue;
      exports2.resync = resync;
      exports2.setContext = setContext;
      exports2.setKey = setKey;
      exports2.setScope = setScope;
      exports2.setup = setup;
      exports2.skip = skip;
      exports2.skipKey = skipKey;
      exports2.stop = stop;
      exports2.visit = visit;
      var _traverseNode = require_traverse_node();
      var _index = require_path();
      function call(key) {
        const opts = this.opts;
        this.debug(key);
        if (this.node) {
          if (this._call(opts[key]))
            return true;
        }
        if (this.node) {
          return this._call(opts[this.node.type] && opts[this.node.type][key]);
        }
        return false;
      }
      function _call(fns) {
        if (!fns)
          return false;
        for (const fn of fns) {
          if (!fn)
            continue;
          const node = this.node;
          if (!node)
            return true;
          const ret = fn.call(this.state, this, this.state);
          if (ret && typeof ret === "object" && typeof ret.then === "function") {
            throw new Error(`You appear to be using a plugin with an async traversal visitor, which your current version of Babel does not support. If you're using a published plugin, you may need to upgrade your @babel/core version.`);
          }
          if (ret) {
            throw new Error(`Unexpected return value from visitor method ${fn}`);
          }
          if (this.node !== node)
            return true;
          if (this._traverseFlags > 0)
            return true;
        }
        return false;
      }
      function isDenylisted() {
        var _this$opts$denylist;
        const denylist = (_this$opts$denylist = this.opts.denylist) != null ? _this$opts$denylist : this.opts.blacklist;
        return denylist && denylist.indexOf(this.node.type) > -1;
      }
      function restoreContext(path, context) {
        if (path.context !== context) {
          path.context = context;
          path.state = context.state;
          path.opts = context.opts;
        }
      }
      function visit() {
        if (!this.node) {
          return false;
        }
        if (this.isDenylisted()) {
          return false;
        }
        if (this.opts.shouldSkip && this.opts.shouldSkip(this)) {
          return false;
        }
        const currentContext = this.context;
        if (this.shouldSkip || this.call("enter")) {
          this.debug("Skip...");
          return this.shouldStop;
        }
        restoreContext(this, currentContext);
        this.debug("Recursing into...");
        this.shouldStop = (0, _traverseNode.traverseNode)(this.node, this.opts, this.scope, this.state, this, this.skipKeys);
        restoreContext(this, currentContext);
        this.call("exit");
        return this.shouldStop;
      }
      function skip() {
        this.shouldSkip = true;
      }
      function skipKey(key) {
        if (this.skipKeys == null) {
          this.skipKeys = {};
        }
        this.skipKeys[key] = true;
      }
      function stop() {
        this._traverseFlags |= _index.SHOULD_SKIP | _index.SHOULD_STOP;
      }
      function setScope() {
        if (this.opts && this.opts.noScope)
          return;
        let path = this.parentPath;
        if ((this.key === "key" || this.listKey === "decorators") && path.isMethod() || this.key === "discriminant" && path.isSwitchStatement()) {
          path = path.parentPath;
        }
        let target;
        while (path && !target) {
          if (path.opts && path.opts.noScope)
            return;
          target = path.scope;
          path = path.parentPath;
        }
        this.scope = this.getScope(target);
        if (this.scope)
          this.scope.init();
      }
      function setContext(context) {
        if (this.skipKeys != null) {
          this.skipKeys = {};
        }
        this._traverseFlags = 0;
        if (context) {
          this.context = context;
          this.state = context.state;
          this.opts = context.opts;
        }
        this.setScope();
        return this;
      }
      function resync() {
        if (this.removed)
          return;
        this._resyncParent();
        this._resyncList();
        this._resyncKey();
      }
      function _resyncParent() {
        if (this.parentPath) {
          this.parent = this.parentPath.node;
        }
      }
      function _resyncKey() {
        if (!this.container)
          return;
        if (this.node === this.container[this.key]) {
          return;
        }
        if (Array.isArray(this.container)) {
          for (let i = 0; i < this.container.length; i++) {
            if (this.container[i] === this.node) {
              return this.setKey(i);
            }
          }
        } else {
          for (const key of Object.keys(this.container)) {
            if (this.container[key] === this.node) {
              return this.setKey(key);
            }
          }
        }
        this.key = null;
      }
      function _resyncList() {
        if (!this.parent || !this.inList)
          return;
        const newContainer = this.parent[this.listKey];
        if (this.container === newContainer)
          return;
        this.container = newContainer || null;
      }
      function _resyncRemoved() {
        if (this.key == null || !this.container || this.container[this.key] !== this.node) {
          this._markRemoved();
        }
      }
      function popContext() {
        this.contexts.pop();
        if (this.contexts.length > 0) {
          this.setContext(this.contexts[this.contexts.length - 1]);
        } else {
          this.setContext(void 0);
        }
      }
      function pushContext(context) {
        this.contexts.push(context);
        this.setContext(context);
      }
      function setup(parentPath, container, listKey, key) {
        this.listKey = listKey;
        this.container = container;
        this.parentPath = parentPath || this.parentPath;
        this.setKey(key);
      }
      function setKey(key) {
        var _this$node;
        this.key = key;
        this.node = this.container[this.key];
        this.type = (_this$node = this.node) == null ? void 0 : _this$node.type;
      }
      function requeue(pathToQueue = this) {
        if (pathToQueue.removed)
          return;
        ;
        const contexts = this.contexts;
        for (const context of contexts) {
          context.maybeQueue(pathToQueue);
        }
      }
      function _getQueueContexts() {
        let path = this;
        let contexts = this.contexts;
        while (!contexts.length) {
          path = path.parentPath;
          if (!path)
            break;
          contexts = path.contexts;
        }
        return contexts;
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/lib/removal-hooks.js
  var require_removal_hooks = __commonJS({
    "node_modules/@babel/traverse/lib/path/lib/removal-hooks.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.hooks = void 0;
      var hooks = [function(self2, parent2) {
        const removeParent = self2.key === "test" && (parent2.isWhile() || parent2.isSwitchCase()) || self2.key === "declaration" && parent2.isExportDeclaration() || self2.key === "body" && parent2.isLabeledStatement() || self2.listKey === "declarations" && parent2.isVariableDeclaration() && parent2.node.declarations.length === 1 || self2.key === "expression" && parent2.isExpressionStatement();
        if (removeParent) {
          parent2.remove();
          return true;
        }
      }, function(self2, parent2) {
        if (parent2.isSequenceExpression() && parent2.node.expressions.length === 1) {
          parent2.replaceWith(parent2.node.expressions[0]);
          return true;
        }
      }, function(self2, parent2) {
        if (parent2.isBinary()) {
          if (self2.key === "left") {
            parent2.replaceWith(parent2.node.right);
          } else {
            parent2.replaceWith(parent2.node.left);
          }
          return true;
        }
      }, function(self2, parent2) {
        if (parent2.isIfStatement() && self2.key === "consequent" || self2.key === "body" && (parent2.isLoop() || parent2.isArrowFunctionExpression())) {
          self2.replaceWith({
            type: "BlockStatement",
            body: []
          });
          return true;
        }
      }];
      exports2.hooks = hooks;
    }
  });

  // node_modules/@babel/traverse/lib/path/removal.js
  var require_removal = __commonJS({
    "node_modules/@babel/traverse/lib/path/removal.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._assertUnremoved = _assertUnremoved;
      exports2._callRemovalHooks = _callRemovalHooks;
      exports2._markRemoved = _markRemoved;
      exports2._remove = _remove;
      exports2._removeFromScope = _removeFromScope;
      exports2.remove = remove2;
      var _removalHooks = require_removal_hooks();
      var _cache = require_cache2();
      var _index = require_path();
      function remove2() {
        var _this$opts;
        this._assertUnremoved();
        this.resync();
        if (!((_this$opts = this.opts) != null && _this$opts.noScope)) {
          this._removeFromScope();
        }
        if (this._callRemovalHooks()) {
          this._markRemoved();
          return;
        }
        this.shareCommentsWithSiblings();
        this._remove();
        this._markRemoved();
      }
      function _removeFromScope() {
        const bindings = this.getBindingIdentifiers();
        Object.keys(bindings).forEach((name) => this.scope.removeBinding(name));
      }
      function _callRemovalHooks() {
        for (const fn of _removalHooks.hooks) {
          if (fn(this, this.parentPath))
            return true;
        }
      }
      function _remove() {
        if (Array.isArray(this.container)) {
          this.container.splice(this.key, 1);
          this.updateSiblingKeys(this.key, -1);
        } else {
          this._replaceWith(null);
        }
      }
      function _markRemoved() {
        this._traverseFlags |= _index.SHOULD_SKIP | _index.REMOVED;
        if (this.parent)
          _cache.path.get(this.parent).delete(this.node);
        this.node = null;
      }
      function _assertUnremoved() {
        if (this.removed) {
          throw this.buildCodeFrameError("NodePath has been removed so is read-only.");
        }
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/lib/hoister.js
  var require_hoister = __commonJS({
    "node_modules/@babel/traverse/lib/path/lib/hoister.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _t = require_lib5();
      var _t2 = _t;
      var {
        react
      } = _t;
      var {
        cloneNode,
        jsxExpressionContainer,
        variableDeclaration,
        variableDeclarator
      } = _t2;
      var referenceVisitor = {
        ReferencedIdentifier(path, state) {
          if (path.isJSXIdentifier() && react.isCompatTag(path.node.name) && !path.parentPath.isJSXMemberExpression()) {
            return;
          }
          if (path.node.name === "this") {
            let scope = path.scope;
            do {
              if (scope.path.isFunction() && !scope.path.isArrowFunctionExpression()) {
                break;
              }
            } while (scope = scope.parent);
            if (scope)
              state.breakOnScopePaths.push(scope.path);
          }
          const binding = path.scope.getBinding(path.node.name);
          if (!binding)
            return;
          for (const violation of binding.constantViolations) {
            if (violation.scope !== binding.path.scope) {
              state.mutableBinding = true;
              path.stop();
              return;
            }
          }
          if (binding !== state.scope.getBinding(path.node.name))
            return;
          state.bindings[path.node.name] = binding;
        }
      };
      var PathHoister = class {
        constructor(path, scope) {
          this.breakOnScopePaths = void 0;
          this.bindings = void 0;
          this.mutableBinding = void 0;
          this.scopes = void 0;
          this.scope = void 0;
          this.path = void 0;
          this.attachAfter = void 0;
          this.breakOnScopePaths = [];
          this.bindings = {};
          this.mutableBinding = false;
          this.scopes = [];
          this.scope = scope;
          this.path = path;
          this.attachAfter = false;
        }
        isCompatibleScope(scope) {
          for (const key of Object.keys(this.bindings)) {
            const binding = this.bindings[key];
            if (!scope.bindingIdentifierEquals(key, binding.identifier)) {
              return false;
            }
          }
          return true;
        }
        getCompatibleScopes() {
          let scope = this.path.scope;
          do {
            if (this.isCompatibleScope(scope)) {
              this.scopes.push(scope);
            } else {
              break;
            }
            if (this.breakOnScopePaths.indexOf(scope.path) >= 0) {
              break;
            }
          } while (scope = scope.parent);
        }
        getAttachmentPath() {
          let path = this._getAttachmentPath();
          if (!path)
            return;
          let targetScope = path.scope;
          if (targetScope.path === path) {
            targetScope = path.scope.parent;
          }
          if (targetScope.path.isProgram() || targetScope.path.isFunction()) {
            for (const name of Object.keys(this.bindings)) {
              if (!targetScope.hasOwnBinding(name))
                continue;
              const binding = this.bindings[name];
              if (binding.kind === "param" || binding.path.parentKey === "params") {
                continue;
              }
              const bindingParentPath = this.getAttachmentParentForPath(binding.path);
              if (bindingParentPath.key >= path.key) {
                this.attachAfter = true;
                path = binding.path;
                for (const violationPath of binding.constantViolations) {
                  if (this.getAttachmentParentForPath(violationPath).key > path.key) {
                    path = violationPath;
                  }
                }
              }
            }
          }
          return path;
        }
        _getAttachmentPath() {
          const scopes = this.scopes;
          const scope = scopes.pop();
          if (!scope)
            return;
          if (scope.path.isFunction()) {
            if (this.hasOwnParamBindings(scope)) {
              if (this.scope === scope)
                return;
              const bodies = scope.path.get("body").get("body");
              for (let i = 0; i < bodies.length; i++) {
                if (bodies[i].node._blockHoist)
                  continue;
                return bodies[i];
              }
            } else {
              return this.getNextScopeAttachmentParent();
            }
          } else if (scope.path.isProgram()) {
            return this.getNextScopeAttachmentParent();
          }
        }
        getNextScopeAttachmentParent() {
          const scope = this.scopes.pop();
          if (scope)
            return this.getAttachmentParentForPath(scope.path);
        }
        getAttachmentParentForPath(path) {
          do {
            if (!path.parentPath || Array.isArray(path.container) && path.isStatement()) {
              return path;
            }
          } while (path = path.parentPath);
        }
        hasOwnParamBindings(scope) {
          for (const name of Object.keys(this.bindings)) {
            if (!scope.hasOwnBinding(name))
              continue;
            const binding = this.bindings[name];
            if (binding.kind === "param" && binding.constant)
              return true;
          }
          return false;
        }
        run() {
          this.path.traverse(referenceVisitor, this);
          if (this.mutableBinding)
            return;
          this.getCompatibleScopes();
          const attachTo = this.getAttachmentPath();
          if (!attachTo)
            return;
          if (attachTo.getFunctionParent() === this.path.getFunctionParent())
            return;
          let uid = attachTo.scope.generateUidIdentifier("ref");
          const declarator = variableDeclarator(uid, this.path.node);
          const insertFn = this.attachAfter ? "insertAfter" : "insertBefore";
          const [attached] = attachTo[insertFn]([attachTo.isVariableDeclarator() ? declarator : variableDeclaration("var", [declarator])]);
          const parent2 = this.path.parentPath;
          if (parent2.isJSXElement() && this.path.container === parent2.node.children) {
            uid = jsxExpressionContainer(uid);
          }
          this.path.replaceWith(cloneNode(uid));
          return attachTo.isVariableDeclarator() ? attached.get("init") : attached.get("declarations.0.init");
        }
      };
      exports2.default = PathHoister;
    }
  });

  // node_modules/@babel/traverse/lib/path/modification.js
  var require_modification = __commonJS({
    "node_modules/@babel/traverse/lib/path/modification.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._containerInsert = _containerInsert;
      exports2._containerInsertAfter = _containerInsertAfter;
      exports2._containerInsertBefore = _containerInsertBefore;
      exports2._verifyNodeList = _verifyNodeList;
      exports2.hoist = hoist;
      exports2.insertAfter = insertAfter;
      exports2.insertBefore = insertBefore;
      exports2.pushContainer = pushContainer;
      exports2.unshiftContainer = unshiftContainer;
      exports2.updateSiblingKeys = updateSiblingKeys;
      var _cache = require_cache2();
      var _hoister = require_hoister();
      var _index = require_path();
      var _t = require_lib5();
      var {
        arrowFunctionExpression: arrowFunctionExpression2,
        assertExpression,
        assignmentExpression,
        blockStatement,
        callExpression,
        cloneNode,
        expressionStatement: expressionStatement2,
        isAssignmentExpression,
        isCallExpression,
        isExpression,
        isIdentifier: isIdentifier2,
        isSequenceExpression,
        isSuper,
        thisExpression
      } = _t;
      function insertBefore(nodes_) {
        this._assertUnremoved();
        const nodes = this._verifyNodeList(nodes_);
        const {
          parentPath
        } = this;
        if (parentPath.isExpressionStatement() || parentPath.isLabeledStatement() || parentPath.isExportNamedDeclaration() || parentPath.isExportDefaultDeclaration() && this.isDeclaration()) {
          return parentPath.insertBefore(nodes);
        } else if (this.isNodeType("Expression") && !this.isJSXElement() || parentPath.isForStatement() && this.key === "init") {
          if (this.node)
            nodes.push(this.node);
          return this.replaceExpressionWithStatements(nodes);
        } else if (Array.isArray(this.container)) {
          return this._containerInsertBefore(nodes);
        } else if (this.isStatementOrBlock()) {
          const node = this.node;
          const shouldInsertCurrentNode = node && (!this.isExpressionStatement() || node.expression != null);
          this.replaceWith(blockStatement(shouldInsertCurrentNode ? [node] : []));
          return this.unshiftContainer(
            "body",
            nodes
          );
        } else {
          throw new Error("We don't know what to do with this node type. We were previously a Statement but we can't fit in here?");
        }
      }
      function _containerInsert(from, nodes) {
        this.updateSiblingKeys(from, nodes.length);
        const paths = [];
        this.container.splice(from, 0, ...nodes);
        for (let i = 0; i < nodes.length; i++) {
          const to = from + i;
          const path = this.getSibling(to);
          paths.push(path);
          if (this.context && this.context.queue) {
            path.pushContext(this.context);
          }
        }
        const contexts = this._getQueueContexts();
        for (const path of paths) {
          path.setScope();
          path.debug("Inserted.");
          for (const context of contexts) {
            context.maybeQueue(path, true);
          }
        }
        return paths;
      }
      function _containerInsertBefore(nodes) {
        return this._containerInsert(this.key, nodes);
      }
      function _containerInsertAfter(nodes) {
        return this._containerInsert(this.key + 1, nodes);
      }
      var last2 = (arr) => arr[arr.length - 1];
      function isHiddenInSequenceExpression(path) {
        return isSequenceExpression(path.parent) && (last2(path.parent.expressions) !== path.node || isHiddenInSequenceExpression(path.parentPath));
      }
      function isAlmostConstantAssignment(node, scope) {
        if (!isAssignmentExpression(node) || !isIdentifier2(node.left)) {
          return false;
        }
        const blockScope = scope.getBlockParent();
        return blockScope.hasOwnBinding(node.left.name) && blockScope.getOwnBinding(node.left.name).constantViolations.length <= 1;
      }
      function insertAfter(nodes_) {
        this._assertUnremoved();
        if (this.isSequenceExpression()) {
          return last2(this.get("expressions")).insertAfter(nodes_);
        }
        const nodes = this._verifyNodeList(nodes_);
        const {
          parentPath
        } = this;
        if (parentPath.isExpressionStatement() || parentPath.isLabeledStatement() || parentPath.isExportNamedDeclaration() || parentPath.isExportDefaultDeclaration() && this.isDeclaration()) {
          return parentPath.insertAfter(nodes.map((node) => {
            return isExpression(node) ? expressionStatement2(node) : node;
          }));
        } else if (this.isNodeType("Expression") && !this.isJSXElement() && !parentPath.isJSXElement() || parentPath.isForStatement() && this.key === "init") {
          if (this.node) {
            const node = this.node;
            let {
              scope
            } = this;
            if (scope.path.isPattern()) {
              assertExpression(node);
              this.replaceWith(callExpression(arrowFunctionExpression2([], node), []));
              this.get("callee.body").insertAfter(nodes);
              return [this];
            }
            if (isHiddenInSequenceExpression(this)) {
              nodes.unshift(node);
            } else if (isCallExpression(node) && isSuper(node.callee)) {
              nodes.unshift(node);
              nodes.push(thisExpression());
            } else if (isAlmostConstantAssignment(node, scope)) {
              nodes.unshift(node);
              nodes.push(cloneNode(node.left));
            } else if (scope.isPure(node, true)) {
              nodes.push(node);
            } else {
              if (parentPath.isMethod({
                computed: true,
                key: node
              })) {
                scope = scope.parent;
              }
              const temp = scope.generateDeclaredUidIdentifier();
              nodes.unshift(expressionStatement2(
                assignmentExpression("=", cloneNode(temp), node)
              ));
              nodes.push(expressionStatement2(cloneNode(temp)));
            }
          }
          return this.replaceExpressionWithStatements(nodes);
        } else if (Array.isArray(this.container)) {
          return this._containerInsertAfter(nodes);
        } else if (this.isStatementOrBlock()) {
          const node = this.node;
          const shouldInsertCurrentNode = node && (!this.isExpressionStatement() || node.expression != null);
          this.replaceWith(blockStatement(shouldInsertCurrentNode ? [node] : []));
          return this.pushContainer("body", nodes);
        } else {
          throw new Error("We don't know what to do with this node type. We were previously a Statement but we can't fit in here?");
        }
      }
      function updateSiblingKeys(fromIndex, incrementBy) {
        if (!this.parent)
          return;
        const paths = _cache.path.get(this.parent);
        for (const [, path] of paths) {
          if (path.key >= fromIndex) {
            path.key += incrementBy;
          }
        }
      }
      function _verifyNodeList(nodes) {
        if (!nodes) {
          return [];
        }
        if (!Array.isArray(nodes)) {
          nodes = [nodes];
        }
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          let msg;
          if (!node) {
            msg = "has falsy node";
          } else if (typeof node !== "object") {
            msg = "contains a non-object node";
          } else if (!node.type) {
            msg = "without a type";
          } else if (node instanceof _index.default) {
            msg = "has a NodePath when it expected a raw object";
          }
          if (msg) {
            const type = Array.isArray(node) ? "array" : typeof node;
            throw new Error(`Node list ${msg} with the index of ${i} and type of ${type}`);
          }
        }
        return nodes;
      }
      function unshiftContainer(listKey, nodes) {
        this._assertUnremoved();
        nodes = this._verifyNodeList(nodes);
        const path = _index.default.get({
          parentPath: this,
          parent: this.node,
          container: this.node[listKey],
          listKey,
          key: 0
        }).setContext(this.context);
        return path._containerInsertBefore(
          nodes
        );
      }
      function pushContainer(listKey, nodes) {
        this._assertUnremoved();
        const verifiedNodes = this._verifyNodeList(
          nodes
        );
        const container = this.node[listKey];
        const path = _index.default.get({
          parentPath: this,
          parent: this.node,
          container,
          listKey,
          key: container.length
        }).setContext(this.context);
        return path.replaceWithMultiple(verifiedNodes);
      }
      function hoist(scope = this.scope) {
        const hoister = new _hoister.default(this, scope);
        return hoister.run();
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/family.js
  var require_family = __commonJS({
    "node_modules/@babel/traverse/lib/path/family.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._getKey = _getKey;
      exports2._getPattern = _getPattern;
      exports2.get = get2;
      exports2.getAllNextSiblings = getAllNextSiblings;
      exports2.getAllPrevSiblings = getAllPrevSiblings;
      exports2.getBindingIdentifierPaths = getBindingIdentifierPaths;
      exports2.getBindingIdentifiers = getBindingIdentifiers;
      exports2.getCompletionRecords = getCompletionRecords;
      exports2.getNextSibling = getNextSibling;
      exports2.getOpposite = getOpposite;
      exports2.getOuterBindingIdentifierPaths = getOuterBindingIdentifierPaths;
      exports2.getOuterBindingIdentifiers = getOuterBindingIdentifiers;
      exports2.getPrevSibling = getPrevSibling;
      exports2.getSibling = getSibling;
      var _index = require_path();
      var _t = require_lib5();
      var {
        getBindingIdentifiers: _getBindingIdentifiers,
        getOuterBindingIdentifiers: _getOuterBindingIdentifiers,
        isDeclaration,
        numericLiteral,
        unaryExpression
      } = _t;
      var NORMAL_COMPLETION = 0;
      var BREAK_COMPLETION = 1;
      function NormalCompletion(path) {
        return {
          type: NORMAL_COMPLETION,
          path
        };
      }
      function BreakCompletion(path) {
        return {
          type: BREAK_COMPLETION,
          path
        };
      }
      function getOpposite() {
        if (this.key === "left") {
          return this.getSibling("right");
        } else if (this.key === "right") {
          return this.getSibling("left");
        }
        return null;
      }
      function addCompletionRecords(path, records, context) {
        if (path) {
          records.push(..._getCompletionRecords(path, context));
        }
        return records;
      }
      function completionRecordForSwitch(cases, records, context) {
        let lastNormalCompletions = [];
        for (let i = 0; i < cases.length; i++) {
          const casePath = cases[i];
          const caseCompletions = _getCompletionRecords(casePath, context);
          const normalCompletions = [];
          const breakCompletions = [];
          for (const c of caseCompletions) {
            if (c.type === NORMAL_COMPLETION) {
              normalCompletions.push(c);
            }
            if (c.type === BREAK_COMPLETION) {
              breakCompletions.push(c);
            }
          }
          if (normalCompletions.length) {
            lastNormalCompletions = normalCompletions;
          }
          records.push(...breakCompletions);
        }
        records.push(...lastNormalCompletions);
        return records;
      }
      function normalCompletionToBreak(completions) {
        completions.forEach((c) => {
          c.type = BREAK_COMPLETION;
        });
      }
      function replaceBreakStatementInBreakCompletion(completions, reachable) {
        completions.forEach((c) => {
          if (c.path.isBreakStatement({
            label: null
          })) {
            if (reachable) {
              c.path.replaceWith(unaryExpression("void", numericLiteral(0)));
            } else {
              c.path.remove();
            }
          }
        });
      }
      function getStatementListCompletion(paths, context) {
        const completions = [];
        if (context.canHaveBreak) {
          let lastNormalCompletions = [];
          for (let i = 0; i < paths.length; i++) {
            const path = paths[i];
            const newContext = Object.assign({}, context, {
              inCaseClause: false
            });
            if (path.isBlockStatement() && (context.inCaseClause || context.shouldPopulateBreak)) {
              newContext.shouldPopulateBreak = true;
            } else {
              newContext.shouldPopulateBreak = false;
            }
            const statementCompletions = _getCompletionRecords(path, newContext);
            if (statementCompletions.length > 0 && statementCompletions.every((c) => c.type === BREAK_COMPLETION)) {
              if (lastNormalCompletions.length > 0 && statementCompletions.every((c) => c.path.isBreakStatement({
                label: null
              }))) {
                normalCompletionToBreak(lastNormalCompletions);
                completions.push(...lastNormalCompletions);
                if (lastNormalCompletions.some((c) => c.path.isDeclaration())) {
                  completions.push(...statementCompletions);
                  replaceBreakStatementInBreakCompletion(statementCompletions, true);
                }
                replaceBreakStatementInBreakCompletion(statementCompletions, false);
              } else {
                completions.push(...statementCompletions);
                if (!context.shouldPopulateBreak) {
                  replaceBreakStatementInBreakCompletion(statementCompletions, true);
                }
              }
              break;
            }
            if (i === paths.length - 1) {
              completions.push(...statementCompletions);
            } else {
              lastNormalCompletions = [];
              for (let i2 = 0; i2 < statementCompletions.length; i2++) {
                const c = statementCompletions[i2];
                if (c.type === BREAK_COMPLETION) {
                  completions.push(c);
                }
                if (c.type === NORMAL_COMPLETION) {
                  lastNormalCompletions.push(c);
                }
              }
            }
          }
        } else if (paths.length) {
          for (let i = paths.length - 1; i >= 0; i--) {
            const pathCompletions = _getCompletionRecords(paths[i], context);
            if (pathCompletions.length > 1 || pathCompletions.length === 1 && !pathCompletions[0].path.isVariableDeclaration()) {
              completions.push(...pathCompletions);
              break;
            }
          }
        }
        return completions;
      }
      function _getCompletionRecords(path, context) {
        let records = [];
        if (path.isIfStatement()) {
          records = addCompletionRecords(path.get("consequent"), records, context);
          records = addCompletionRecords(path.get("alternate"), records, context);
        } else if (path.isDoExpression() || path.isFor() || path.isWhile() || path.isLabeledStatement()) {
          return addCompletionRecords(path.get("body"), records, context);
        } else if (path.isProgram() || path.isBlockStatement()) {
          return getStatementListCompletion(path.get("body"), context);
        } else if (path.isFunction()) {
          return _getCompletionRecords(path.get("body"), context);
        } else if (path.isTryStatement()) {
          records = addCompletionRecords(path.get("block"), records, context);
          records = addCompletionRecords(path.get("handler"), records, context);
        } else if (path.isCatchClause()) {
          return addCompletionRecords(path.get("body"), records, context);
        } else if (path.isSwitchStatement()) {
          return completionRecordForSwitch(path.get("cases"), records, context);
        } else if (path.isSwitchCase()) {
          return getStatementListCompletion(path.get("consequent"), {
            canHaveBreak: true,
            shouldPopulateBreak: false,
            inCaseClause: true
          });
        } else if (path.isBreakStatement()) {
          records.push(BreakCompletion(path));
        } else {
          records.push(NormalCompletion(path));
        }
        return records;
      }
      function getCompletionRecords() {
        const records = _getCompletionRecords(this, {
          canHaveBreak: false,
          shouldPopulateBreak: false,
          inCaseClause: false
        });
        return records.map((r) => r.path);
      }
      function getSibling(key) {
        return _index.default.get({
          parentPath: this.parentPath,
          parent: this.parent,
          container: this.container,
          listKey: this.listKey,
          key
        }).setContext(this.context);
      }
      function getPrevSibling() {
        return this.getSibling(this.key - 1);
      }
      function getNextSibling() {
        return this.getSibling(this.key + 1);
      }
      function getAllNextSiblings() {
        let _key = this.key;
        let sibling = this.getSibling(++_key);
        const siblings = [];
        while (sibling.node) {
          siblings.push(sibling);
          sibling = this.getSibling(++_key);
        }
        return siblings;
      }
      function getAllPrevSiblings() {
        let _key = this.key;
        let sibling = this.getSibling(--_key);
        const siblings = [];
        while (sibling.node) {
          siblings.push(sibling);
          sibling = this.getSibling(--_key);
        }
        return siblings;
      }
      function get2(key, context = true) {
        if (context === true)
          context = this.context;
        const parts = key.split(".");
        if (parts.length === 1) {
          return this._getKey(key, context);
        } else {
          return this._getPattern(parts, context);
        }
      }
      function _getKey(key, context) {
        const node = this.node;
        const container = node[key];
        if (Array.isArray(container)) {
          return container.map((_, i) => {
            return _index.default.get({
              listKey: key,
              parentPath: this,
              parent: node,
              container,
              key: i
            }).setContext(context);
          });
        } else {
          return _index.default.get({
            parentPath: this,
            parent: node,
            container: node,
            key
          }).setContext(context);
        }
      }
      function _getPattern(parts, context) {
        let path = this;
        for (const part of parts) {
          if (part === ".") {
            path = path.parentPath;
          } else {
            if (Array.isArray(path)) {
              path = path[part];
            } else {
              path = path.get(part, context);
            }
          }
        }
        return path;
      }
      function getBindingIdentifiers(duplicates) {
        return _getBindingIdentifiers(this.node, duplicates);
      }
      function getOuterBindingIdentifiers(duplicates) {
        return _getOuterBindingIdentifiers(this.node, duplicates);
      }
      function getBindingIdentifierPaths(duplicates = false, outerOnly = false) {
        const path = this;
        const search = [path];
        const ids = /* @__PURE__ */ Object.create(null);
        while (search.length) {
          const id = search.shift();
          if (!id)
            continue;
          if (!id.node)
            continue;
          const keys2 = _getBindingIdentifiers.keys[id.node.type];
          if (id.isIdentifier()) {
            if (duplicates) {
              const _ids = ids[id.node.name] = ids[id.node.name] || [];
              _ids.push(id);
            } else {
              ids[id.node.name] = id;
            }
            continue;
          }
          if (id.isExportDeclaration()) {
            const declaration = id.get("declaration");
            if (isDeclaration(declaration)) {
              search.push(declaration);
            }
            continue;
          }
          if (outerOnly) {
            if (id.isFunctionDeclaration()) {
              search.push(id.get("id"));
              continue;
            }
            if (id.isFunctionExpression()) {
              continue;
            }
          }
          if (keys2) {
            for (let i = 0; i < keys2.length; i++) {
              const key = keys2[i];
              const child = id.get(key);
              if (Array.isArray(child)) {
                search.push(...child);
              } else if (child.node) {
                search.push(child);
              }
            }
          }
        }
        return ids;
      }
      function getOuterBindingIdentifierPaths(duplicates = false) {
        return this.getBindingIdentifierPaths(duplicates, true);
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/comments.js
  var require_comments = __commonJS({
    "node_modules/@babel/traverse/lib/path/comments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.addComment = addComment;
      exports2.addComments = addComments;
      exports2.shareCommentsWithSiblings = shareCommentsWithSiblings;
      var _t = require_lib5();
      var {
        addComment: _addComment,
        addComments: _addComments
      } = _t;
      function shareCommentsWithSiblings() {
        if (typeof this.key === "string")
          return;
        const node = this.node;
        if (!node)
          return;
        const trailing = node.trailingComments;
        const leading = node.leadingComments;
        if (!trailing && !leading)
          return;
        const prev = this.getSibling(this.key - 1);
        const next = this.getSibling(this.key + 1);
        const hasPrev = Boolean(prev.node);
        const hasNext = Boolean(next.node);
        if (hasPrev && !hasNext) {
          prev.addComments("trailing", trailing);
        } else if (hasNext && !hasPrev) {
          next.addComments("leading", leading);
        }
      }
      function addComment(type, content, line) {
        _addComment(this.node, type, content, line);
      }
      function addComments(type, comments) {
        _addComments(this.node, type, comments);
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/lib/virtual-types-validator.js
  var require_virtual_types_validator = __commonJS({
    "node_modules/@babel/traverse/lib/path/lib/virtual-types-validator.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.isBindingIdentifier = isBindingIdentifier;
      exports2.isBlockScoped = isBlockScoped;
      exports2.isExistentialTypeParam = isExistentialTypeParam;
      exports2.isExpression = isExpression;
      exports2.isFlow = isFlow;
      exports2.isForAwaitStatement = isForAwaitStatement;
      exports2.isGenerated = isGenerated;
      exports2.isNumericLiteralTypeAnnotation = isNumericLiteralTypeAnnotation;
      exports2.isPure = isPure;
      exports2.isReferenced = isReferenced;
      exports2.isReferencedIdentifier = isReferencedIdentifier;
      exports2.isReferencedMemberExpression = isReferencedMemberExpression;
      exports2.isRestProperty = isRestProperty;
      exports2.isScope = isScope;
      exports2.isSpreadProperty = isSpreadProperty;
      exports2.isStatement = isStatement;
      exports2.isUser = isUser;
      exports2.isVar = isVar;
      var _t = require_lib5();
      var {
        isBinding,
        isBlockScoped: nodeIsBlockScoped,
        isExportDeclaration,
        isExpression: nodeIsExpression,
        isFlow: nodeIsFlow,
        isForStatement,
        isForXStatement,
        isIdentifier: isIdentifier2,
        isImportDeclaration,
        isImportSpecifier,
        isJSXIdentifier,
        isJSXMemberExpression,
        isMemberExpression,
        isRestElement: nodeIsRestElement,
        isReferenced: nodeIsReferenced,
        isScope: nodeIsScope,
        isStatement: nodeIsStatement,
        isVar: nodeIsVar,
        isVariableDeclaration,
        react,
        isForOfStatement
      } = _t;
      var {
        isCompatTag
      } = react;
      function isReferencedIdentifier(opts) {
        const {
          node,
          parent: parent2
        } = this;
        if (!isIdentifier2(node, opts) && !isJSXMemberExpression(parent2, opts)) {
          if (isJSXIdentifier(node, opts)) {
            if (isCompatTag(node.name))
              return false;
          } else {
            return false;
          }
        }
        return nodeIsReferenced(node, parent2, this.parentPath.parent);
      }
      function isReferencedMemberExpression() {
        const {
          node,
          parent: parent2
        } = this;
        return isMemberExpression(node) && nodeIsReferenced(node, parent2);
      }
      function isBindingIdentifier() {
        const {
          node,
          parent: parent2
        } = this;
        const grandparent = this.parentPath.parent;
        return isIdentifier2(node) && isBinding(node, parent2, grandparent);
      }
      function isStatement() {
        const {
          node,
          parent: parent2
        } = this;
        if (nodeIsStatement(node)) {
          if (isVariableDeclaration(node)) {
            if (isForXStatement(parent2, {
              left: node
            }))
              return false;
            if (isForStatement(parent2, {
              init: node
            }))
              return false;
          }
          return true;
        } else {
          return false;
        }
      }
      function isExpression() {
        if (this.isIdentifier()) {
          return this.isReferencedIdentifier();
        } else {
          return nodeIsExpression(this.node);
        }
      }
      function isScope() {
        return nodeIsScope(this.node, this.parent);
      }
      function isReferenced() {
        return nodeIsReferenced(this.node, this.parent);
      }
      function isBlockScoped() {
        return nodeIsBlockScoped(this.node);
      }
      function isVar() {
        return nodeIsVar(this.node);
      }
      function isUser() {
        return this.node && !!this.node.loc;
      }
      function isGenerated() {
        return !this.isUser();
      }
      function isPure(constantsOnly) {
        return this.scope.isPure(this.node, constantsOnly);
      }
      function isFlow() {
        const {
          node
        } = this;
        if (nodeIsFlow(node)) {
          return true;
        } else if (isImportDeclaration(node)) {
          return node.importKind === "type" || node.importKind === "typeof";
        } else if (isExportDeclaration(node)) {
          return node.exportKind === "type";
        } else if (isImportSpecifier(node)) {
          return node.importKind === "type" || node.importKind === "typeof";
        } else {
          return false;
        }
      }
      function isRestProperty() {
        return nodeIsRestElement(this.node) && this.parentPath && this.parentPath.isObjectPattern();
      }
      function isSpreadProperty() {
        return nodeIsRestElement(this.node) && this.parentPath && this.parentPath.isObjectExpression();
      }
      function isForAwaitStatement() {
        return isForOfStatement(this.node, {
          await: true
        });
      }
      function isExistentialTypeParam() {
        throw new Error("`path.isExistentialTypeParam` has been renamed to `path.isExistsTypeAnnotation()` in Babel 7.");
      }
      function isNumericLiteralTypeAnnotation() {
        throw new Error("`path.isNumericLiteralTypeAnnotation()` has been renamed to `path.isNumberLiteralTypeAnnotation()` in Babel 7.");
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/index.js
  var require_path = __commonJS({
    "node_modules/@babel/traverse/lib/path/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = exports2.SHOULD_STOP = exports2.SHOULD_SKIP = exports2.REMOVED = void 0;
      var virtualTypes = require_virtual_types();
      var _debug = require_browser2();
      var _index = require_lib14();
      var _scope = require_scope();
      var _t = require_lib5();
      var t3 = _t;
      var _cache = require_cache2();
      var _generator = require_lib6();
      var NodePath_ancestry = require_ancestry();
      var NodePath_inference = require_inference();
      var NodePath_replacement = require_replacement();
      var NodePath_evaluation = require_evaluation();
      var NodePath_conversion = require_conversion();
      var NodePath_introspection = require_introspection();
      var NodePath_context = require_context();
      var NodePath_removal = require_removal();
      var NodePath_modification = require_modification();
      var NodePath_family = require_family();
      var NodePath_comments = require_comments();
      var NodePath_virtual_types_validator = require_virtual_types_validator();
      var {
        validate
      } = _t;
      var debug2 = _debug("babel");
      var REMOVED = 1 << 0;
      exports2.REMOVED = REMOVED;
      var SHOULD_STOP = 1 << 1;
      exports2.SHOULD_STOP = SHOULD_STOP;
      var SHOULD_SKIP = 1 << 2;
      exports2.SHOULD_SKIP = SHOULD_SKIP;
      var NodePath2 = class {
        constructor(hub, parent2) {
          this.contexts = [];
          this.state = null;
          this.opts = null;
          this._traverseFlags = 0;
          this.skipKeys = null;
          this.parentPath = null;
          this.container = null;
          this.listKey = null;
          this.key = null;
          this.node = null;
          this.type = null;
          this.parent = parent2;
          this.hub = hub;
          this.data = null;
          this.context = null;
          this.scope = null;
        }
        static get({
          hub,
          parentPath,
          parent: parent2,
          container,
          listKey,
          key
        }) {
          if (!hub && parentPath) {
            hub = parentPath.hub;
          }
          if (!parent2) {
            throw new Error("To get a node path the parent needs to exist");
          }
          const targetNode = container[key];
          let paths = _cache.path.get(parent2);
          if (!paths) {
            paths = /* @__PURE__ */ new Map();
            _cache.path.set(parent2, paths);
          }
          let path = paths.get(targetNode);
          if (!path) {
            path = new NodePath2(hub, parent2);
            if (targetNode)
              paths.set(targetNode, path);
          }
          path.setup(parentPath, container, listKey, key);
          return path;
        }
        getScope(scope) {
          return this.isScope() ? new _scope.default(this) : scope;
        }
        setData(key, val) {
          if (this.data == null) {
            this.data = /* @__PURE__ */ Object.create(null);
          }
          return this.data[key] = val;
        }
        getData(key, def) {
          if (this.data == null) {
            this.data = /* @__PURE__ */ Object.create(null);
          }
          let val = this.data[key];
          if (val === void 0 && def !== void 0)
            val = this.data[key] = def;
          return val;
        }
        hasNode() {
          return this.node != null;
        }
        buildCodeFrameError(msg, Error2 = SyntaxError) {
          return this.hub.buildError(this.node, msg, Error2);
        }
        traverse(visitor, state) {
          (0, _index.default)(this.node, visitor, this.scope, state, this);
        }
        set(key, node) {
          validate(this.node, key, node);
          this.node[key] = node;
        }
        getPathLocation() {
          const parts = [];
          let path = this;
          do {
            let key = path.key;
            if (path.inList)
              key = `${path.listKey}[${key}]`;
            parts.unshift(key);
          } while (path = path.parentPath);
          return parts.join(".");
        }
        debug(message) {
          if (!debug2.enabled)
            return;
          debug2(`${this.getPathLocation()} ${this.type}: ${message}`);
        }
        toString() {
          return (0, _generator.default)(this.node).code;
        }
        get inList() {
          return !!this.listKey;
        }
        set inList(inList) {
          if (!inList) {
            this.listKey = null;
          }
        }
        get parentKey() {
          return this.listKey || this.key;
        }
        get shouldSkip() {
          return !!(this._traverseFlags & SHOULD_SKIP);
        }
        set shouldSkip(v) {
          if (v) {
            this._traverseFlags |= SHOULD_SKIP;
          } else {
            this._traverseFlags &= ~SHOULD_SKIP;
          }
        }
        get shouldStop() {
          return !!(this._traverseFlags & SHOULD_STOP);
        }
        set shouldStop(v) {
          if (v) {
            this._traverseFlags |= SHOULD_STOP;
          } else {
            this._traverseFlags &= ~SHOULD_STOP;
          }
        }
        get removed() {
          return !!(this._traverseFlags & REMOVED);
        }
        set removed(v) {
          if (v) {
            this._traverseFlags |= REMOVED;
          } else {
            this._traverseFlags &= ~REMOVED;
          }
        }
      };
      Object.assign(NodePath2.prototype, NodePath_ancestry, NodePath_inference, NodePath_replacement, NodePath_evaluation, NodePath_conversion, NodePath_introspection, NodePath_context, NodePath_removal, NodePath_modification, NodePath_family, NodePath_comments);
      {
        NodePath2.prototype._guessExecutionStatusRelativeToDifferentFunctions = NodePath_introspection._guessExecutionStatusRelativeTo;
      }
      for (const type of t3.TYPES) {
        const typeKey = `is${type}`;
        const fn = t3[typeKey];
        NodePath2.prototype[typeKey] = function(opts) {
          return fn(this.node, opts);
        };
        NodePath2.prototype[`assert${type}`] = function(opts) {
          if (!fn(this.node, opts)) {
            throw new TypeError(`Expected node path of type ${type}`);
          }
        };
      }
      Object.assign(NodePath2.prototype, NodePath_virtual_types_validator);
      for (const type of Object.keys(virtualTypes)) {
        if (type[0] === "_")
          continue;
        if (!t3.TYPES.includes(type))
          t3.TYPES.push(type);
      }
      var _default = NodePath2;
      exports2.default = _default;
    }
  });

  // node_modules/@babel/traverse/lib/context.js
  var require_context2 = __commonJS({
    "node_modules/@babel/traverse/lib/context.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _path = require_path();
      var _t = require_lib5();
      var {
        VISITOR_KEYS
      } = _t;
      var TraversalContext = class {
        constructor(scope, opts, state, parentPath) {
          this.queue = null;
          this.priorityQueue = null;
          this.parentPath = parentPath;
          this.scope = scope;
          this.state = state;
          this.opts = opts;
        }
        shouldVisit(node) {
          const opts = this.opts;
          if (opts.enter || opts.exit)
            return true;
          if (opts[node.type])
            return true;
          const keys2 = VISITOR_KEYS[node.type];
          if (!(keys2 != null && keys2.length))
            return false;
          for (const key of keys2) {
            if (node[key]) {
              return true;
            }
          }
          return false;
        }
        create(node, container, key, listKey) {
          return _path.default.get({
            parentPath: this.parentPath,
            parent: node,
            container,
            key,
            listKey
          });
        }
        maybeQueue(path, notPriority) {
          if (this.queue) {
            if (notPriority) {
              this.queue.push(path);
            } else {
              this.priorityQueue.push(path);
            }
          }
        }
        visitMultiple(container, parent2, listKey) {
          if (container.length === 0)
            return false;
          const queue = [];
          for (let key = 0; key < container.length; key++) {
            const node = container[key];
            if (node && this.shouldVisit(node)) {
              queue.push(this.create(parent2, container, key, listKey));
            }
          }
          return this.visitQueue(queue);
        }
        visitSingle(node, key) {
          if (this.shouldVisit(
            node[key]
          )) {
            return this.visitQueue([this.create(node, node, key)]);
          } else {
            return false;
          }
        }
        visitQueue(queue) {
          this.queue = queue;
          this.priorityQueue = [];
          const visited = /* @__PURE__ */ new WeakSet();
          let stop = false;
          for (const path of queue) {
            path.resync();
            if (path.contexts.length === 0 || path.contexts[path.contexts.length - 1] !== this) {
              path.pushContext(this);
            }
            if (path.key === null)
              continue;
            const {
              node
            } = path;
            if (visited.has(node))
              continue;
            if (node)
              visited.add(node);
            if (path.visit()) {
              stop = true;
              break;
            }
            if (this.priorityQueue.length) {
              stop = this.visitQueue(this.priorityQueue);
              this.priorityQueue = [];
              this.queue = queue;
              if (stop)
                break;
            }
          }
          for (const path of queue) {
            path.popContext();
          }
          this.queue = null;
          return stop;
        }
        visit(node, key) {
          const nodes = node[key];
          if (!nodes)
            return false;
          if (Array.isArray(nodes)) {
            return this.visitMultiple(nodes, node, key);
          } else {
            return this.visitSingle(node, key);
          }
        }
      };
      exports2.default = TraversalContext;
    }
  });

  // node_modules/@babel/traverse/lib/traverse-node.js
  var require_traverse_node = __commonJS({
    "node_modules/@babel/traverse/lib/traverse-node.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.traverseNode = traverseNode;
      var _context = require_context2();
      var _t = require_lib5();
      var {
        VISITOR_KEYS
      } = _t;
      function traverseNode(node, opts, scope, state, path, skipKeys) {
        const keys2 = VISITOR_KEYS[node.type];
        if (!keys2)
          return false;
        const context = new _context.default(scope, opts, state, path);
        for (const key of keys2) {
          if (skipKeys && skipKeys[key])
            continue;
          if (context.visit(node, key)) {
            return true;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/traverse/lib/hub.js
  var require_hub = __commonJS({
    "node_modules/@babel/traverse/lib/hub.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var Hub = class {
        getCode() {
        }
        getScope() {
        }
        addHelper() {
          throw new Error("Helpers are not supported by the default hub.");
        }
        buildError(node, msg, Error2 = TypeError) {
          return new Error2(msg);
        }
      };
      exports2.default = Hub;
    }
  });

  // node_modules/@babel/traverse/lib/index.js
  var require_lib14 = __commonJS({
    "node_modules/@babel/traverse/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      Object.defineProperty(exports2, "Hub", {
        enumerable: true,
        get: function() {
          return _hub.default;
        }
      });
      Object.defineProperty(exports2, "NodePath", {
        enumerable: true,
        get: function() {
          return _path.default;
        }
      });
      Object.defineProperty(exports2, "Scope", {
        enumerable: true,
        get: function() {
          return _scope.default;
        }
      });
      exports2.visitors = exports2.default = void 0;
      var visitors = require_visitors();
      exports2.visitors = visitors;
      var _t = require_lib5();
      var cache = require_cache2();
      var _traverseNode = require_traverse_node();
      var _path = require_path();
      var _scope = require_scope();
      var _hub = require_hub();
      var {
        VISITOR_KEYS,
        removeProperties,
        traverseFast
      } = _t;
      function traverse3(parent2, opts = {}, scope, state, parentPath) {
        if (!parent2)
          return;
        if (!opts.noScope && !scope) {
          if (parent2.type !== "Program" && parent2.type !== "File") {
            throw new Error(`You must pass a scope and parentPath unless traversing a Program/File. Instead of that you tried to traverse a ${parent2.type} node without passing scope and parentPath.`);
          }
        }
        if (!VISITOR_KEYS[parent2.type]) {
          return;
        }
        visitors.explode(opts);
        (0, _traverseNode.traverseNode)(parent2, opts, scope, state, parentPath);
      }
      var _default = traverse3;
      exports2.default = _default;
      traverse3.visitors = visitors;
      traverse3.verify = visitors.verify;
      traverse3.explode = visitors.explode;
      traverse3.cheap = function(node, enter) {
        return traverseFast(node, enter);
      };
      traverse3.node = function(node, opts, scope, state, path, skipKeys) {
        (0, _traverseNode.traverseNode)(node, opts, scope, state, path, skipKeys);
      };
      traverse3.clearNode = function(node, opts) {
        removeProperties(node, opts);
        cache.path.delete(node);
      };
      traverse3.removeProperties = function(tree, opts) {
        traverseFast(tree, traverse3.clearNode, opts);
        return tree;
      };
      function hasDenylistedType(path, state) {
        if (path.node.type === state.type) {
          state.has = true;
          path.stop();
        }
      }
      traverse3.hasType = function(tree, type, denylistTypes) {
        if (denylistTypes != null && denylistTypes.includes(tree.type))
          return false;
        if (tree.type === type)
          return true;
        const state = {
          has: false,
          type
        };
        traverse3(tree, {
          noScope: true,
          denylist: denylistTypes,
          enter: hasDenylistedType
        }, null, state);
        return state.has;
      };
      traverse3.cache = cache;
    }
  });

  // node_modules/prettier/standalone.js
  var require_standalone = __commonJS({
    "node_modules/prettier/standalone.js"(exports2, module2) {
      init_define_process();
      (function(e) {
        if (typeof exports2 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var f = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          f.prettier = e();
        }
      })(function() {
        "use strict";
        var Ne = (e, n) => () => (n || e((n = { exports: {} }).exports, n), n.exports);
        var Qe = Ne((Ng, nu) => {
          var ur = function(e) {
            return e && e.Math == Math && e;
          };
          nu.exports = ur(typeof globalThis == "object" && globalThis) || ur(typeof window == "object" && window) || ur(typeof self == "object" && self) || ur(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var dt = Ne((wg, uu) => {
          uu.exports = function(e) {
            try {
              return !!e();
            } catch {
              return true;
            }
          };
        });
        var Ft = Ne((_g, su) => {
          var vo = dt();
          su.exports = !vo(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var sr = Ne((Pg, iu) => {
          var Co = dt();
          iu.exports = !Co(function() {
            var e = function() {
            }.bind();
            return typeof e != "function" || e.hasOwnProperty("prototype");
          });
        });
        var At = Ne((Ig, au) => {
          var Eo = sr(), ir = Function.prototype.call;
          au.exports = Eo ? ir.bind(ir) : function() {
            return ir.apply(ir, arguments);
          };
        });
        var pu = Ne((cu) => {
          "use strict";
          var ou = {}.propertyIsEnumerable, lu = Object.getOwnPropertyDescriptor, Fo = lu && !ou.call({ 1: 2 }, 1);
          cu.f = Fo ? function(n) {
            var t3 = lu(this, n);
            return !!t3 && t3.enumerable;
          } : ou;
        });
        var ar = Ne((Lg, fu) => {
          fu.exports = function(e, n) {
            return { enumerable: !(e & 1), configurable: !(e & 2), writable: !(e & 4), value: n };
          };
        });
        var ct = Ne((jg, du) => {
          var Du = sr(), mu = Function.prototype, Ao = mu.bind, Mr = mu.call, So = Du && Ao.bind(Mr, Mr);
          du.exports = Du ? function(e) {
            return e && So(e);
          } : function(e) {
            return e && function() {
              return Mr.apply(e, arguments);
            };
          };
        });
        var or = Ne((Og, yu) => {
          var gu = ct(), xo = gu({}.toString), bo = gu("".slice);
          yu.exports = function(e) {
            return bo(xo(e), 8, -1);
          };
        });
        var vu = Ne((qg, hu) => {
          var To = Qe(), Bo = ct(), No = dt(), wo = or(), Rr = To.Object, _o = Bo("".split);
          hu.exports = No(function() {
            return !Rr("z").propertyIsEnumerable(0);
          }) ? function(e) {
            return wo(e) == "String" ? _o(e, "") : Rr(e);
          } : Rr;
        });
        var $r = Ne((Mg, Cu) => {
          var Po = Qe(), Io = Po.TypeError;
          Cu.exports = function(e) {
            if (e == null)
              throw Io("Can't call method on " + e);
            return e;
          };
        });
        var lr = Ne((Rg, Eu) => {
          var ko = vu(), Lo = $r();
          Eu.exports = function(e) {
            return ko(Lo(e));
          };
        });
        var pt = Ne(($g, Fu) => {
          Fu.exports = function(e) {
            return typeof e == "function";
          };
        });
        var St = Ne((Vg, Au) => {
          var jo = pt();
          Au.exports = function(e) {
            return typeof e == "object" ? e !== null : jo(e);
          };
        });
        var $t = Ne((Wg, Su) => {
          var Vr = Qe(), Oo = pt(), qo = function(e) {
            return Oo(e) ? e : void 0;
          };
          Su.exports = function(e, n) {
            return arguments.length < 2 ? qo(Vr[e]) : Vr[e] && Vr[e][n];
          };
        });
        var Wr = Ne((Hg, xu) => {
          var Mo = ct();
          xu.exports = Mo({}.isPrototypeOf);
        });
        var Tu = Ne((Gg, bu) => {
          var Ro = $t();
          bu.exports = Ro("navigator", "userAgent") || "";
        });
        var ku = Ne((Ug, Iu) => {
          var Pu = Qe(), Hr = Tu(), Bu = Pu.process, Nu = Pu.Deno, wu = Bu && Bu.versions || Nu && Nu.version, _u = wu && wu.v8, mt, cr;
          _u && (mt = _u.split("."), cr = mt[0] > 0 && mt[0] < 4 ? 1 : +(mt[0] + mt[1]));
          !cr && Hr && (mt = Hr.match(/Edge\/(\d+)/), (!mt || mt[1] >= 74) && (mt = Hr.match(/Chrome\/(\d+)/), mt && (cr = +mt[1])));
          Iu.exports = cr;
        });
        var Gr = Ne((Jg, ju) => {
          var Lu = ku(), $o = dt();
          ju.exports = !!Object.getOwnPropertySymbols && !$o(function() {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && Lu && Lu < 41;
          });
        });
        var Ur = Ne((zg, Ou) => {
          var Vo = Gr();
          Ou.exports = Vo && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var Jr = Ne((Xg, qu) => {
          var Wo = Qe(), Ho = $t(), Go = pt(), Uo = Wr(), Jo = Ur(), zo = Wo.Object;
          qu.exports = Jo ? function(e) {
            return typeof e == "symbol";
          } : function(e) {
            var n = Ho("Symbol");
            return Go(n) && Uo(n.prototype, zo(e));
          };
        });
        var pr = Ne((Kg, Mu) => {
          var Xo = Qe(), Ko = Xo.String;
          Mu.exports = function(e) {
            try {
              return Ko(e);
            } catch {
              return "Object";
            }
          };
        });
        var Vt = Ne((Yg, Ru) => {
          var Yo = Qe(), Qo = pt(), Zo = pr(), el = Yo.TypeError;
          Ru.exports = function(e) {
            if (Qo(e))
              return e;
            throw el(Zo(e) + " is not a function");
          };
        });
        var fr = Ne((Qg, $u) => {
          var tl = Vt();
          $u.exports = function(e, n) {
            var t3 = e[n];
            return t3 == null ? void 0 : tl(t3);
          };
        });
        var Wu = Ne((Zg, Vu) => {
          var rl = Qe(), zr = At(), Xr = pt(), Kr = St(), nl = rl.TypeError;
          Vu.exports = function(e, n) {
            var t3, s;
            if (n === "string" && Xr(t3 = e.toString) && !Kr(s = zr(t3, e)) || Xr(t3 = e.valueOf) && !Kr(s = zr(t3, e)) || n !== "string" && Xr(t3 = e.toString) && !Kr(s = zr(t3, e)))
              return s;
            throw nl("Can't convert object to primitive value");
          };
        });
        var Gu = Ne((e0, Hu) => {
          Hu.exports = false;
        });
        var Dr = Ne((t0, Ju) => {
          var Uu = Qe(), ul = Object.defineProperty;
          Ju.exports = function(e, n) {
            try {
              ul(Uu, e, { value: n, configurable: true, writable: true });
            } catch {
              Uu[e] = n;
            }
            return n;
          };
        });
        var mr = Ne((r0, Xu) => {
          var sl = Qe(), il = Dr(), zu = "__core-js_shared__", al = sl[zu] || il(zu, {});
          Xu.exports = al;
        });
        var Yr = Ne((n0, Yu) => {
          var ol = Gu(), Ku = mr();
          (Yu.exports = function(e, n) {
            return Ku[e] || (Ku[e] = n !== void 0 ? n : {});
          })("versions", []).push({ version: "3.22.2", mode: ol ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.22.2/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var dr = Ne((u0, Qu) => {
          var ll = Qe(), cl = $r(), pl = ll.Object;
          Qu.exports = function(e) {
            return pl(cl(e));
          };
        });
        var ht = Ne((s0, Zu) => {
          var fl = ct(), Dl = dr(), ml = fl({}.hasOwnProperty);
          Zu.exports = Object.hasOwn || function(n, t3) {
            return ml(Dl(n), t3);
          };
        });
        var Qr = Ne((i0, es) => {
          var dl = ct(), gl = 0, yl = Math.random(), hl = dl(1 .toString);
          es.exports = function(e) {
            return "Symbol(" + (e === void 0 ? "" : e) + ")_" + hl(++gl + yl, 36);
          };
        });
        var bt = Ne((a0, ss) => {
          var vl = Qe(), Cl = Yr(), ts = ht(), El = Qr(), rs = Gr(), us = Ur(), _t = Cl("wks"), xt = vl.Symbol, ns = xt && xt.for, Fl = us ? xt : xt && xt.withoutSetter || El;
          ss.exports = function(e) {
            if (!ts(_t, e) || !(rs || typeof _t[e] == "string")) {
              var n = "Symbol." + e;
              rs && ts(xt, e) ? _t[e] = xt[e] : us && ns ? _t[e] = ns(n) : _t[e] = Fl(n);
            }
            return _t[e];
          };
        });
        var ls = Ne((o0, os) => {
          var Al = Qe(), Sl = At(), is = St(), as = Jr(), xl = fr(), bl = Wu(), Tl = bt(), Bl = Al.TypeError, Nl = Tl("toPrimitive");
          os.exports = function(e, n) {
            if (!is(e) || as(e))
              return e;
            var t3 = xl(e, Nl), s;
            if (t3) {
              if (n === void 0 && (n = "default"), s = Sl(t3, e, n), !is(s) || as(s))
                return s;
              throw Bl("Can't convert object to primitive value");
            }
            return n === void 0 && (n = "number"), bl(e, n);
          };
        });
        var gr = Ne((l0, cs) => {
          var wl = ls(), _l = Jr();
          cs.exports = function(e) {
            var n = wl(e, "string");
            return _l(n) ? n : n + "";
          };
        });
        var Ds = Ne((c0, fs) => {
          var Pl = Qe(), ps = St(), Zr = Pl.document, Il = ps(Zr) && ps(Zr.createElement);
          fs.exports = function(e) {
            return Il ? Zr.createElement(e) : {};
          };
        });
        var en = Ne((p0, ms) => {
          var kl = Ft(), Ll = dt(), jl = Ds();
          ms.exports = !kl && !Ll(function() {
            return Object.defineProperty(jl("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var tn = Ne((gs) => {
          var Ol = Ft(), ql = At(), Ml = pu(), Rl = ar(), $l = lr(), Vl = gr(), Wl = ht(), Hl = en(), ds = Object.getOwnPropertyDescriptor;
          gs.f = Ol ? ds : function(n, t3) {
            if (n = $l(n), t3 = Vl(t3), Hl)
              try {
                return ds(n, t3);
              } catch {
              }
            if (Wl(n, t3))
              return Rl(!ql(Ml.f, n, t3), n[t3]);
          };
        });
        var hs = Ne((D0, ys) => {
          var Gl = Ft(), Ul = dt();
          ys.exports = Gl && Ul(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var Pt = Ne((m0, Cs) => {
          var vs = Qe(), Jl = St(), zl = vs.String, Xl = vs.TypeError;
          Cs.exports = function(e) {
            if (Jl(e))
              return e;
            throw Xl(zl(e) + " is not an object");
          };
        });
        var hr = Ne((Fs) => {
          var Kl = Qe(), Yl = Ft(), Ql = en(), Zl = hs(), yr = Pt(), Es = gr(), ec = Kl.TypeError, rn = Object.defineProperty, tc = Object.getOwnPropertyDescriptor, nn = "enumerable", un = "configurable", sn = "writable";
          Fs.f = Yl ? Zl ? function(n, t3, s) {
            if (yr(n), t3 = Es(t3), yr(s), typeof n == "function" && t3 === "prototype" && "value" in s && sn in s && !s[sn]) {
              var a = tc(n, t3);
              a && a[sn] && (n[t3] = s.value, s = { configurable: un in s ? s[un] : a[un], enumerable: nn in s ? s[nn] : a[nn], writable: false });
            }
            return rn(n, t3, s);
          } : rn : function(n, t3, s) {
            if (yr(n), t3 = Es(t3), yr(s), Ql)
              try {
                return rn(n, t3, s);
              } catch {
              }
            if ("get" in s || "set" in s)
              throw ec("Accessors not supported");
            return "value" in s && (n[t3] = s.value), n;
          };
        });
        var vr = Ne((g0, As) => {
          var rc = Ft(), nc = hr(), uc = ar();
          As.exports = rc ? function(e, n, t3) {
            return nc.f(e, n, uc(1, t3));
          } : function(e, n, t3) {
            return e[n] = t3, e;
          };
        });
        var Cr = Ne((y0, Ss) => {
          var sc = ct(), ic = pt(), an = mr(), ac = sc(Function.toString);
          ic(an.inspectSource) || (an.inspectSource = function(e) {
            return ac(e);
          });
          Ss.exports = an.inspectSource;
        });
        var Ts = Ne((h0, bs) => {
          var oc = Qe(), lc = pt(), cc = Cr(), xs = oc.WeakMap;
          bs.exports = lc(xs) && /native code/.test(cc(xs));
        });
        var ws = Ne((v0, Ns) => {
          var pc = Yr(), fc = Qr(), Bs = pc("keys");
          Ns.exports = function(e) {
            return Bs[e] || (Bs[e] = fc(e));
          };
        });
        var on = Ne((C0, _s) => {
          _s.exports = {};
        });
        var Os = Ne((E0, js) => {
          var Dc = Ts(), Ls = Qe(), ln = ct(), mc = St(), dc = vr(), cn = ht(), pn = mr(), gc = ws(), yc = on(), Ps = "Object already initialized", Dn = Ls.TypeError, hc = Ls.WeakMap, Er, Wt, Fr, vc = function(e) {
            return Fr(e) ? Wt(e) : Er(e, {});
          }, Cc = function(e) {
            return function(n) {
              var t3;
              if (!mc(n) || (t3 = Wt(n)).type !== e)
                throw Dn("Incompatible receiver, " + e + " required");
              return t3;
            };
          };
          Dc || pn.state ? (vt = pn.state || (pn.state = new hc()), Is = ln(vt.get), fn = ln(vt.has), ks = ln(vt.set), Er = function(e, n) {
            if (fn(vt, e))
              throw new Dn(Ps);
            return n.facade = e, ks(vt, e, n), n;
          }, Wt = function(e) {
            return Is(vt, e) || {};
          }, Fr = function(e) {
            return fn(vt, e);
          }) : (Tt = gc("state"), yc[Tt] = true, Er = function(e, n) {
            if (cn(e, Tt))
              throw new Dn(Ps);
            return n.facade = e, dc(e, Tt, n), n;
          }, Wt = function(e) {
            return cn(e, Tt) ? e[Tt] : {};
          }, Fr = function(e) {
            return cn(e, Tt);
          });
          var vt, Is, fn, ks, Tt;
          js.exports = { set: Er, get: Wt, has: Fr, enforce: vc, getterFor: Cc };
        });
        var Rs = Ne((F0, Ms) => {
          var mn = Ft(), Ec = ht(), qs = Function.prototype, Fc = mn && Object.getOwnPropertyDescriptor, dn = Ec(qs, "name"), Ac = dn && function() {
          }.name === "something", Sc = dn && (!mn || mn && Fc(qs, "name").configurable);
          Ms.exports = { EXISTS: dn, PROPER: Ac, CONFIGURABLE: Sc };
        });
        var Gs = Ne((A0, Hs) => {
          var xc = Qe(), $s = pt(), bc = ht(), Vs = vr(), Tc = Dr(), Bc = Cr(), Ws = Os(), Nc = Rs().CONFIGURABLE, wc = Ws.get, _c = Ws.enforce, Pc = String(String).split("String");
          (Hs.exports = function(e, n, t3, s) {
            var a = s ? !!s.unsafe : false, r = s ? !!s.enumerable : false, u = s ? !!s.noTargetGet : false, i = s && s.name !== void 0 ? s.name : n, l;
            if ($s(t3) && (String(i).slice(0, 7) === "Symbol(" && (i = "[" + String(i).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!bc(t3, "name") || Nc && t3.name !== i) && Vs(t3, "name", i), l = _c(t3), l.source || (l.source = Pc.join(typeof i == "string" ? i : ""))), e === xc) {
              r ? e[n] = t3 : Tc(n, t3);
              return;
            } else
              a ? !u && e[n] && (r = true) : delete e[n];
            r ? e[n] = t3 : Vs(e, n, t3);
          })(Function.prototype, "toString", function() {
            return $s(this) && wc(this).source || Bc(this);
          });
        });
        var Ar = Ne((S0, Us) => {
          var Ic = Math.ceil, kc = Math.floor;
          Us.exports = function(e) {
            var n = +e;
            return n !== n || n === 0 ? 0 : (n > 0 ? kc : Ic)(n);
          };
        });
        var zs = Ne((x0, Js) => {
          var Lc = Ar(), jc = Math.max, Oc = Math.min;
          Js.exports = function(e, n) {
            var t3 = Lc(e);
            return t3 < 0 ? jc(t3 + n, 0) : Oc(t3, n);
          };
        });
        var Ks = Ne((b0, Xs) => {
          var qc = Ar(), Mc = Math.min;
          Xs.exports = function(e) {
            return e > 0 ? Mc(qc(e), 9007199254740991) : 0;
          };
        });
        var It = Ne((T0, Ys) => {
          var Rc = Ks();
          Ys.exports = function(e) {
            return Rc(e.length);
          };
        });
        var ei = Ne((B0, Zs) => {
          var $c = lr(), Vc = zs(), Wc = It(), Qs = function(e) {
            return function(n, t3, s) {
              var a = $c(n), r = Wc(a), u = Vc(s, r), i;
              if (e && t3 != t3) {
                for (; r > u; )
                  if (i = a[u++], i != i)
                    return true;
              } else
                for (; r > u; u++)
                  if ((e || u in a) && a[u] === t3)
                    return e || u || 0;
              return !e && -1;
            };
          };
          Zs.exports = { includes: Qs(true), indexOf: Qs(false) };
        });
        var ni = Ne((N0, ri) => {
          var Hc = ct(), gn = ht(), Gc = lr(), Uc = ei().indexOf, Jc = on(), ti = Hc([].push);
          ri.exports = function(e, n) {
            var t3 = Gc(e), s = 0, a = [], r;
            for (r in t3)
              !gn(Jc, r) && gn(t3, r) && ti(a, r);
            for (; n.length > s; )
              gn(t3, r = n[s++]) && (~Uc(a, r) || ti(a, r));
            return a;
          };
        });
        var si = Ne((w0, ui) => {
          ui.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var ai = Ne((ii) => {
          var zc = ni(), Xc = si(), Kc = Xc.concat("length", "prototype");
          ii.f = Object.getOwnPropertyNames || function(n) {
            return zc(n, Kc);
          };
        });
        var li = Ne((oi) => {
          oi.f = Object.getOwnPropertySymbols;
        });
        var pi = Ne((I0, ci) => {
          var Yc = $t(), Qc = ct(), Zc = ai(), ep = li(), tp = Pt(), rp = Qc([].concat);
          ci.exports = Yc("Reflect", "ownKeys") || function(n) {
            var t3 = Zc.f(tp(n)), s = ep.f;
            return s ? rp(t3, s(n)) : t3;
          };
        });
        var mi = Ne((k0, Di) => {
          var fi = ht(), np = pi(), up = tn(), sp = hr();
          Di.exports = function(e, n, t3) {
            for (var s = np(n), a = sp.f, r = up.f, u = 0; u < s.length; u++) {
              var i = s[u];
              !fi(e, i) && !(t3 && fi(t3, i)) && a(e, i, r(n, i));
            }
          };
        });
        var gi = Ne((L0, di) => {
          var ip = dt(), ap = pt(), op = /#|\.prototype\./, Ht = function(e, n) {
            var t3 = cp[lp(e)];
            return t3 == fp ? true : t3 == pp ? false : ap(n) ? ip(n) : !!n;
          }, lp = Ht.normalize = function(e) {
            return String(e).replace(op, ".").toLowerCase();
          }, cp = Ht.data = {}, pp = Ht.NATIVE = "N", fp = Ht.POLYFILL = "P";
          di.exports = Ht;
        });
        var Gt = Ne((j0, yi) => {
          var yn = Qe(), Dp = tn().f, mp = vr(), dp = Gs(), gp = Dr(), yp = mi(), hp = gi();
          yi.exports = function(e, n) {
            var t3 = e.target, s = e.global, a = e.stat, r, u, i, l, c, y;
            if (s ? u = yn : a ? u = yn[t3] || gp(t3, {}) : u = (yn[t3] || {}).prototype, u)
              for (i in n) {
                if (c = n[i], e.noTargetGet ? (y = Dp(u, i), l = y && y.value) : l = u[i], r = hp(s ? i : t3 + (a ? "." : "#") + i, e.forced), !r && l !== void 0) {
                  if (typeof c == typeof l)
                    continue;
                  yp(c, l);
                }
                (e.sham || l && l.sham) && mp(c, "sham", true), dp(u, i, c, e);
              }
          };
        });
        var hn = Ne((O0, hi) => {
          var vp = or();
          hi.exports = Array.isArray || function(n) {
            return vp(n) == "Array";
          };
        });
        var vn = Ne((q0, Ci) => {
          var vi = ct(), Cp = Vt(), Ep = sr(), Fp = vi(vi.bind);
          Ci.exports = function(e, n) {
            return Cp(e), n === void 0 ? e : Ep ? Fp(e, n) : function() {
              return e.apply(n, arguments);
            };
          };
        });
        var Cn = Ne((M0, Fi) => {
          "use strict";
          var Ap = Qe(), Sp = hn(), xp = It(), bp = vn(), Tp = Ap.TypeError, Ei = function(e, n, t3, s, a, r, u, i) {
            for (var l = a, c = 0, y = u ? bp(u, i) : false, h, g; c < s; ) {
              if (c in t3) {
                if (h = y ? y(t3[c], c, n) : t3[c], r > 0 && Sp(h))
                  g = xp(h), l = Ei(e, n, h, g, l, r - 1) - 1;
                else {
                  if (l >= 9007199254740991)
                    throw Tp("Exceed the acceptable array length");
                  e[l] = h;
                }
                l++;
              }
              c++;
            }
            return l;
          };
          Fi.exports = Ei;
        });
        var xi = Ne((R0, Si) => {
          var Bp = bt(), Np = Bp("toStringTag"), Ai = {};
          Ai[Np] = "z";
          Si.exports = String(Ai) === "[object z]";
        });
        var En = Ne(($0, bi) => {
          var wp = Qe(), _p = xi(), Pp = pt(), Sr = or(), Ip = bt(), kp = Ip("toStringTag"), Lp = wp.Object, jp = Sr(function() {
            return arguments;
          }()) == "Arguments", Op = function(e, n) {
            try {
              return e[n];
            } catch {
            }
          };
          bi.exports = _p ? Sr : function(e) {
            var n, t3, s;
            return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t3 = Op(n = Lp(e), kp)) == "string" ? t3 : jp ? Sr(n) : (s = Sr(n)) == "Object" && Pp(n.callee) ? "Arguments" : s;
          };
        });
        var Pi = Ne((V0, _i) => {
          var qp = ct(), Mp = dt(), Ti = pt(), Rp = En(), $p = $t(), Vp = Cr(), Bi = function() {
          }, Wp = [], Ni = $p("Reflect", "construct"), Fn = /^\s*(?:class|function)\b/, Hp = qp(Fn.exec), Gp = !Fn.exec(Bi), Ut = function(n) {
            if (!Ti(n))
              return false;
            try {
              return Ni(Bi, Wp, n), true;
            } catch {
              return false;
            }
          }, wi = function(n) {
            if (!Ti(n))
              return false;
            switch (Rp(n)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return false;
            }
            try {
              return Gp || !!Hp(Fn, Vp(n));
            } catch {
              return true;
            }
          };
          wi.sham = true;
          _i.exports = !Ni || Mp(function() {
            var e;
            return Ut(Ut.call) || !Ut(Object) || !Ut(function() {
              e = true;
            }) || e;
          }) ? wi : Ut;
        });
        var ji = Ne((W0, Li) => {
          var Up = Qe(), Ii = hn(), Jp = Pi(), zp = St(), Xp = bt(), Kp = Xp("species"), ki = Up.Array;
          Li.exports = function(e) {
            var n;
            return Ii(e) && (n = e.constructor, Jp(n) && (n === ki || Ii(n.prototype)) ? n = void 0 : zp(n) && (n = n[Kp], n === null && (n = void 0))), n === void 0 ? ki : n;
          };
        });
        var An = Ne((H0, Oi) => {
          var Yp = ji();
          Oi.exports = function(e, n) {
            return new (Yp(e))(n === 0 ? 0 : n);
          };
        });
        var qi = Ne(() => {
          "use strict";
          var Qp = Gt(), Zp = Cn(), ef = Vt(), tf = dr(), rf = It(), nf = An();
          Qp({ target: "Array", proto: true }, { flatMap: function(n) {
            var t3 = tf(this), s = rf(t3), a;
            return ef(n), a = nf(t3, 0), a.length = Zp(a, t3, t3, s, 0, 1, n, arguments.length > 1 ? arguments[1] : void 0), a;
          } });
        });
        var Sn = Ne((J0, Mi) => {
          Mi.exports = {};
        });
        var $i = Ne((z0, Ri) => {
          var uf = bt(), sf = Sn(), af = uf("iterator"), of = Array.prototype;
          Ri.exports = function(e) {
            return e !== void 0 && (sf.Array === e || of[af] === e);
          };
        });
        var xn = Ne((X0, Wi) => {
          var lf = En(), Vi = fr(), cf = Sn(), pf = bt(), ff = pf("iterator");
          Wi.exports = function(e) {
            if (e != null)
              return Vi(e, ff) || Vi(e, "@@iterator") || cf[lf(e)];
          };
        });
        var Gi = Ne((K0, Hi) => {
          var Df = Qe(), mf = At(), df = Vt(), gf = Pt(), yf = pr(), hf = xn(), vf = Df.TypeError;
          Hi.exports = function(e, n) {
            var t3 = arguments.length < 2 ? hf(e) : n;
            if (df(t3))
              return gf(mf(t3, e));
            throw vf(yf(e) + " is not iterable");
          };
        });
        var zi = Ne((Y0, Ji) => {
          var Cf = At(), Ui = Pt(), Ef = fr();
          Ji.exports = function(e, n, t3) {
            var s, a;
            Ui(e);
            try {
              if (s = Ef(e, "return"), !s) {
                if (n === "throw")
                  throw t3;
                return t3;
              }
              s = Cf(s, e);
            } catch (r) {
              a = true, s = r;
            }
            if (n === "throw")
              throw t3;
            if (a)
              throw s;
            return Ui(s), t3;
          };
        });
        var Zi = Ne((Q0, Qi) => {
          var Ff = Qe(), Af = vn(), Sf = At(), xf = Pt(), bf = pr(), Tf = $i(), Bf = It(), Xi = Wr(), Nf = Gi(), wf = xn(), Ki = zi(), _f = Ff.TypeError, xr = function(e, n) {
            this.stopped = e, this.result = n;
          }, Yi = xr.prototype;
          Qi.exports = function(e, n, t3) {
            var s = t3 && t3.that, a = !!(t3 && t3.AS_ENTRIES), r = !!(t3 && t3.IS_ITERATOR), u = !!(t3 && t3.INTERRUPTED), i = Af(n, s), l, c, y, h, g, p, D, v = function(T) {
              return l && Ki(l, "normal", T), new xr(true, T);
            }, w = function(T) {
              return a ? (xf(T), u ? i(T[0], T[1], v) : i(T[0], T[1])) : u ? i(T, v) : i(T);
            };
            if (r)
              l = e;
            else {
              if (c = wf(e), !c)
                throw _f(bf(e) + " is not iterable");
              if (Tf(c)) {
                for (y = 0, h = Bf(e); h > y; y++)
                  if (g = w(e[y]), g && Xi(Yi, g))
                    return g;
                return new xr(false);
              }
              l = Nf(e, c);
            }
            for (p = l.next; !(D = Sf(p, l)).done; ) {
              try {
                g = w(D.value);
              } catch (T) {
                Ki(l, "throw", T);
              }
              if (typeof g == "object" && g && Xi(Yi, g))
                return g;
            }
            return new xr(false);
          };
        });
        var ta = Ne((Z0, ea) => {
          "use strict";
          var Pf = gr(), If = hr(), kf = ar();
          ea.exports = function(e, n, t3) {
            var s = Pf(n);
            s in e ? If.f(e, s, kf(0, t3)) : e[s] = t3;
          };
        });
        var ra = Ne(() => {
          var Lf = Gt(), jf = Zi(), Of = ta();
          Lf({ target: "Object", stat: true }, { fromEntries: function(n) {
            var t3 = {};
            return jf(n, function(s, a) {
              Of(t3, s, a);
            }, { AS_ENTRIES: true }), t3;
          } });
        });
        var na = Ne(() => {
          var qf = Gt(), Mf = Qe();
          qf({ global: true }, { globalThis: Mf });
        });
        var ua = Ne(() => {
          na();
        });
        var sa = Ne(() => {
          "use strict";
          var Rf = Gt(), $f = Cn(), Vf = dr(), Wf = It(), Hf = Ar(), Gf = An();
          Rf({ target: "Array", proto: true }, { flat: function() {
            var n = arguments.length ? arguments[0] : void 0, t3 = Vf(this), s = Wf(t3), a = Gf(t3, 0);
            return a.length = $f(a, t3, t3, s, 0, n === void 0 ? 1 : Hf(n)), a;
          } });
        });
        var Tg = Ne((ly, mo) => {
          var Uf = ["cliName", "cliCategory", "cliDescription"], Jf = ["_"], zf = ["languageId"];
          function Ln(e, n) {
            if (e == null)
              return {};
            var t3 = Xf(e, n), s, a;
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              for (a = 0; a < r.length; a++)
                s = r[a], !(n.indexOf(s) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, s) || (t3[s] = e[s]));
            }
            return t3;
          }
          function Xf(e, n) {
            if (e == null)
              return {};
            var t3 = {}, s = Object.keys(e), a, r;
            for (r = 0; r < s.length; r++)
              a = s[r], !(n.indexOf(a) >= 0) && (t3[a] = e[a]);
            return t3;
          }
          qi();
          ra();
          ua();
          sa();
          var Kf = Object.create, wr = Object.defineProperty, Yf = Object.getOwnPropertyDescriptor, jn = Object.getOwnPropertyNames, Qf = Object.getPrototypeOf, Zf = Object.prototype.hasOwnProperty, gt2 = (e, n) => function() {
            return e && (n = (0, e[jn(e)[0]])(e = 0)), n;
          }, ee = (e, n) => function() {
            return n || (0, e[jn(e)[0]])((n = { exports: {} }).exports, n), n.exports;
          }, zt = (e, n) => {
            for (var t3 in n)
              wr(e, t3, { get: n[t3], enumerable: true });
          }, pa = (e, n, t3, s) => {
            if (n && typeof n == "object" || typeof n == "function")
              for (let a of jn(n))
                !Zf.call(e, a) && a !== t3 && wr(e, a, { get: () => n[a], enumerable: !(s = Yf(n, a)) || s.enumerable });
            return e;
          }, eD = (e, n, t3) => (t3 = e != null ? Kf(Qf(e)) : {}, pa(n || !e || !e.__esModule ? wr(t3, "default", { value: e, enumerable: true }) : t3, e)), ft = (e) => pa(wr({}, "__esModule", { value: true }), e), ia, aa, Nt, re = gt2({ "<define:process>"() {
            ia = {}, aa = [], Nt = { env: ia, argv: aa };
          } }), fa = ee({ "package.json"(e, n) {
            n.exports = { version: "2.8.0" };
          } }), tD = ee({ "node_modules/diff/lib/diff/base.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.default = n;
            function n() {
            }
            n.prototype = { diff: function(r, u) {
              var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = i.callback;
              typeof i == "function" && (l = i, i = {}), this.options = i;
              var c = this;
              function y(A) {
                return l ? (setTimeout(function() {
                  l(void 0, A);
                }, 0), true) : A;
              }
              r = this.castInput(r), u = this.castInput(u), r = this.removeEmpty(this.tokenize(r)), u = this.removeEmpty(this.tokenize(u));
              var h = u.length, g = r.length, p = 1, D = h + g, v = [{ newPos: -1, components: [] }], w = this.extractCommon(v[0], u, r, 0);
              if (v[0].newPos + 1 >= h && w + 1 >= g)
                return y([{ value: this.join(u), count: u.length }]);
              function T() {
                for (var A = -1 * p; A <= p; A += 2) {
                  var B = void 0, I = v[A - 1], P = v[A + 1], R = (P ? P.newPos : 0) - A;
                  I && (v[A - 1] = void 0);
                  var f = I && I.newPos + 1 < h, x = P && 0 <= R && R < g;
                  if (!f && !x) {
                    v[A] = void 0;
                    continue;
                  }
                  if (!f || x && I.newPos < P.newPos ? (B = s(P), c.pushComponent(B.components, void 0, true)) : (B = I, B.newPos++, c.pushComponent(B.components, true, void 0)), R = c.extractCommon(B, u, r, A), B.newPos + 1 >= h && R + 1 >= g)
                    return y(t3(c, B.components, u, r, c.useLongestToken));
                  v[A] = B;
                }
                p++;
              }
              if (l)
                (function A() {
                  setTimeout(function() {
                    if (p > D)
                      return l();
                    T() || A();
                  }, 0);
                })();
              else
                for (; p <= D; ) {
                  var F = T();
                  if (F)
                    return F;
                }
            }, pushComponent: function(r, u, i) {
              var l = r[r.length - 1];
              l && l.added === u && l.removed === i ? r[r.length - 1] = { count: l.count + 1, added: u, removed: i } : r.push({ count: 1, added: u, removed: i });
            }, extractCommon: function(r, u, i, l) {
              for (var c = u.length, y = i.length, h = r.newPos, g = h - l, p = 0; h + 1 < c && g + 1 < y && this.equals(u[h + 1], i[g + 1]); )
                h++, g++, p++;
              return p && r.components.push({ count: p }), r.newPos = h, g;
            }, equals: function(r, u) {
              return this.options.comparator ? this.options.comparator(r, u) : r === u || this.options.ignoreCase && r.toLowerCase() === u.toLowerCase();
            }, removeEmpty: function(r) {
              for (var u = [], i = 0; i < r.length; i++)
                r[i] && u.push(r[i]);
              return u;
            }, castInput: function(r) {
              return r;
            }, tokenize: function(r) {
              return r.split("");
            }, join: function(r) {
              return r.join("");
            } };
            function t3(a, r, u, i, l) {
              for (var c = 0, y = r.length, h = 0, g = 0; c < y; c++) {
                var p = r[c];
                if (p.removed) {
                  if (p.value = a.join(i.slice(g, g + p.count)), g += p.count, c && r[c - 1].added) {
                    var v = r[c - 1];
                    r[c - 1] = r[c], r[c] = v;
                  }
                } else {
                  if (!p.added && l) {
                    var D = u.slice(h, h + p.count);
                    D = D.map(function(T, F) {
                      var A = i[g + F];
                      return A.length > T.length ? A : T;
                    }), p.value = a.join(D);
                  } else
                    p.value = a.join(u.slice(h, h + p.count));
                  h += p.count, p.added || (g += p.count);
                }
              }
              var w = r[y - 1];
              return y > 1 && typeof w.value == "string" && (w.added || w.removed) && a.equals("", w.value) && (r[y - 2].value += w.value, r.pop()), r;
            }
            function s(a) {
              return { newPos: a.newPos, components: a.components.slice(0) };
            }
          } }), rD = ee({ "node_modules/diff/lib/diff/array.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.diffArrays = a, e.arrayDiff = void 0;
            var n = t3(tD());
            function t3(r) {
              return r && r.__esModule ? r : { default: r };
            }
            var s = new n.default();
            e.arrayDiff = s, s.tokenize = function(r) {
              return r.slice();
            }, s.join = s.removeEmpty = function(r) {
              return r;
            };
            function a(r, u, i) {
              return s.diff(r, u, i);
            }
          } }), On = ee({ "src/document/doc-builders.js"(e, n) {
            "use strict";
            re();
            function t3(E) {
              return { type: "concat", parts: E };
            }
            function s(E) {
              return { type: "indent", contents: E };
            }
            function a(E, o) {
              return { type: "align", contents: o, n: E };
            }
            function r(E) {
              let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              return { type: "group", id: o.id, contents: E, break: Boolean(o.shouldBreak), expandedStates: o.expandedStates };
            }
            function u(E) {
              return a(Number.NEGATIVE_INFINITY, E);
            }
            function i(E) {
              return a({ type: "root" }, E);
            }
            function l(E) {
              return a(-1, E);
            }
            function c(E, o) {
              return r(E[0], Object.assign(Object.assign({}, o), {}, { expandedStates: E }));
            }
            function y(E) {
              return { type: "fill", parts: E };
            }
            function h(E, o) {
              let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              return { type: "if-break", breakContents: E, flatContents: o, groupId: d.groupId };
            }
            function g(E, o) {
              return { type: "indent-if-break", contents: E, groupId: o.groupId, negate: o.negate };
            }
            function p(E) {
              return { type: "line-suffix", contents: E };
            }
            var D = { type: "line-suffix-boundary" }, v = { type: "break-parent" }, w = { type: "trim" }, T = { type: "line", hard: true }, F = { type: "line", hard: true, literal: true }, A = { type: "line" }, B = { type: "line", soft: true }, I = t3([T, v]), P = t3([F, v]), R = { type: "cursor", placeholder: Symbol("cursor") };
            function f(E, o) {
              let d = [];
              for (let C = 0; C < o.length; C++)
                C !== 0 && d.push(E), d.push(o[C]);
              return t3(d);
            }
            function x(E, o, d) {
              let C = E;
              if (o > 0) {
                for (let _ = 0; _ < Math.floor(o / d); ++_)
                  C = s(C);
                C = a(o % d, C), C = a(Number.NEGATIVE_INFINITY, C);
              }
              return C;
            }
            function m(E, o) {
              return { type: "label", label: E, contents: o };
            }
            n.exports = { concat: t3, join: f, line: A, softline: B, hardline: I, literalline: P, group: r, conditionalGroup: c, fill: y, lineSuffix: p, lineSuffixBoundary: D, cursor: R, breakParent: v, ifBreak: h, trim: w, indent: s, indentIfBreak: g, align: a, addAlignmentToDoc: x, markAsRoot: i, dedentToRoot: u, dedent: l, hardlineWithoutBreakParent: T, literallineWithoutBreakParent: F, label: m };
          } }), qn = ee({ "src/common/end-of-line.js"(e, n) {
            "use strict";
            re();
            function t3(u) {
              let i = u.indexOf("\r");
              return i >= 0 ? u.charAt(i + 1) === `
` ? "crlf" : "cr" : "lf";
            }
            function s(u) {
              switch (u) {
                case "cr":
                  return "\r";
                case "crlf":
                  return `\r
`;
                default:
                  return `
`;
              }
            }
            function a(u, i) {
              let l;
              switch (i) {
                case `
`:
                  l = /\n/g;
                  break;
                case "\r":
                  l = /\r/g;
                  break;
                case `\r
`:
                  l = /\r\n/g;
                  break;
                default:
                  throw new Error(`Unexpected "eol" ${JSON.stringify(i)}.`);
              }
              let c = u.match(l);
              return c ? c.length : 0;
            }
            function r(u) {
              return u.replace(/\r\n?/g, `
`);
            }
            n.exports = { guessEndOfLine: t3, convertEndOfLineToChars: s, countEndOfLineChars: a, normalizeEndOfLine: r };
          } }), lt2 = ee({ "src/utils/get-last.js"(e, n) {
            "use strict";
            re();
            var t3 = (s) => s[s.length - 1];
            n.exports = t3;
          } });
          function nD() {
            let { onlyFirst: e = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
            return new RegExp(n, e ? void 0 : "g");
          }
          var uD = gt2({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
            re();
          } });
          function sD(e) {
            if (typeof e != "string")
              throw new TypeError(`Expected a \`string\`, got \`${typeof e}\``);
            return e.replace(nD(), "");
          }
          var iD = gt2({ "node_modules/strip-ansi/index.js"() {
            re(), uD();
          } });
          function aD(e) {
            return Number.isInteger(e) ? e >= 4352 && (e <= 4447 || e === 9001 || e === 9002 || 11904 <= e && e <= 12871 && e !== 12351 || 12880 <= e && e <= 19903 || 19968 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510 || 110592 <= e && e <= 110593 || 127488 <= e && e <= 127569 || 131072 <= e && e <= 262141) : false;
          }
          var oD = gt2({ "node_modules/is-fullwidth-code-point/index.js"() {
            re();
          } }), lD = ee({ "node_modules/emoji-regex/index.js"(e, n) {
            "use strict";
            re(), n.exports = function() {
              return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
            };
          } }), Da = {};
          zt(Da, { default: () => cD });
          function cD(e) {
            if (typeof e != "string" || e.length === 0 || (e = sD(e), e.length === 0))
              return 0;
            e = e.replace((0, ma.default)(), "  ");
            let n = 0;
            for (let t3 = 0; t3 < e.length; t3++) {
              let s = e.codePointAt(t3);
              s <= 31 || s >= 127 && s <= 159 || s >= 768 && s <= 879 || (s > 65535 && t3++, n += aD(s) ? 2 : 1);
            }
            return n;
          }
          var ma, pD = gt2({ "node_modules/string-width/index.js"() {
            re(), iD(), oD(), ma = eD(lD());
          } }), da = ee({ "src/utils/get-string-width.js"(e, n) {
            "use strict";
            re();
            var t3 = (pD(), ft(Da)).default, s = /[^\x20-\x7F]/;
            function a(r) {
              return r ? s.test(r) ? t3(r) : r.length : 0;
            }
            n.exports = a;
          } }), Xt = ee({ "src/document/doc-utils.js"(e, n) {
            "use strict";
            re();
            var t3 = lt2(), { literalline: s, join: a } = On(), r = (o) => Array.isArray(o) || o && o.type === "concat", u = (o) => {
              if (Array.isArray(o))
                return o;
              if (o.type !== "concat" && o.type !== "fill")
                throw new Error("Expect doc type to be `concat` or `fill`.");
              return o.parts;
            }, i = {};
            function l(o, d, C, _) {
              let b = [o];
              for (; b.length > 0; ) {
                let N = b.pop();
                if (N === i) {
                  C(b.pop());
                  continue;
                }
                if (C && b.push(N, i), !d || d(N) !== false)
                  if (r(N) || N.type === "fill") {
                    let k = u(N);
                    for (let $ = k.length, M = $ - 1; M >= 0; --M)
                      b.push(k[M]);
                  } else if (N.type === "if-break")
                    N.flatContents && b.push(N.flatContents), N.breakContents && b.push(N.breakContents);
                  else if (N.type === "group" && N.expandedStates)
                    if (_)
                      for (let k = N.expandedStates.length, $ = k - 1; $ >= 0; --$)
                        b.push(N.expandedStates[$]);
                    else
                      b.push(N.contents);
                  else
                    N.contents && b.push(N.contents);
              }
            }
            function c(o, d) {
              let C = /* @__PURE__ */ new Map();
              return _(o);
              function _(N) {
                if (C.has(N))
                  return C.get(N);
                let k = b(N);
                return C.set(N, k), k;
              }
              function b(N) {
                if (Array.isArray(N))
                  return d(N.map(_));
                if (N.type === "concat" || N.type === "fill") {
                  let k = N.parts.map(_);
                  return d(Object.assign(Object.assign({}, N), {}, { parts: k }));
                }
                if (N.type === "if-break") {
                  let k = N.breakContents && _(N.breakContents), $ = N.flatContents && _(N.flatContents);
                  return d(Object.assign(Object.assign({}, N), {}, { breakContents: k, flatContents: $ }));
                }
                if (N.type === "group" && N.expandedStates) {
                  let k = N.expandedStates.map(_), $ = k[0];
                  return d(Object.assign(Object.assign({}, N), {}, { contents: $, expandedStates: k }));
                }
                if (N.contents) {
                  let k = _(N.contents);
                  return d(Object.assign(Object.assign({}, N), {}, { contents: k }));
                }
                return d(N);
              }
            }
            function y(o, d, C) {
              let _ = C, b = false;
              function N(k) {
                let $ = d(k);
                if ($ !== void 0 && (b = true, _ = $), b)
                  return false;
              }
              return l(o, N), _;
            }
            function h(o) {
              if (o.type === "group" && o.break || o.type === "line" && o.hard || o.type === "break-parent")
                return true;
            }
            function g(o) {
              return y(o, h, false);
            }
            function p(o) {
              if (o.length > 0) {
                let d = t3(o);
                !d.expandedStates && !d.break && (d.break = "propagated");
              }
              return null;
            }
            function D(o) {
              let d = /* @__PURE__ */ new Set(), C = [];
              function _(N) {
                if (N.type === "break-parent" && p(C), N.type === "group") {
                  if (C.push(N), d.has(N))
                    return false;
                  d.add(N);
                }
              }
              function b(N) {
                N.type === "group" && C.pop().break && p(C);
              }
              l(o, _, b, true);
            }
            function v(o) {
              return o.type === "line" && !o.hard ? o.soft ? "" : " " : o.type === "if-break" ? o.flatContents || "" : o;
            }
            function w(o) {
              return c(o, v);
            }
            var T = (o, d) => o && o.type === "line" && o.hard && d && d.type === "break-parent";
            function F(o) {
              if (!o)
                return o;
              if (r(o) || o.type === "fill") {
                let d = u(o);
                for (; d.length > 1 && T(...d.slice(-2)); )
                  d.length -= 2;
                if (d.length > 0) {
                  let C = F(t3(d));
                  d[d.length - 1] = C;
                }
                return Array.isArray(o) ? d : Object.assign(Object.assign({}, o), {}, { parts: d });
              }
              switch (o.type) {
                case "align":
                case "indent":
                case "indent-if-break":
                case "group":
                case "line-suffix":
                case "label": {
                  let d = F(o.contents);
                  return Object.assign(Object.assign({}, o), {}, { contents: d });
                }
                case "if-break": {
                  let d = F(o.breakContents), C = F(o.flatContents);
                  return Object.assign(Object.assign({}, o), {}, { breakContents: d, flatContents: C });
                }
              }
              return o;
            }
            function A(o) {
              return F(I(o));
            }
            function B(o) {
              switch (o.type) {
                case "fill":
                  if (o.parts.every((C) => C === ""))
                    return "";
                  break;
                case "group":
                  if (!o.contents && !o.id && !o.break && !o.expandedStates)
                    return "";
                  if (o.contents.type === "group" && o.contents.id === o.id && o.contents.break === o.break && o.contents.expandedStates === o.expandedStates)
                    return o.contents;
                  break;
                case "align":
                case "indent":
                case "indent-if-break":
                case "line-suffix":
                  if (!o.contents)
                    return "";
                  break;
                case "if-break":
                  if (!o.flatContents && !o.breakContents)
                    return "";
                  break;
              }
              if (!r(o))
                return o;
              let d = [];
              for (let C of u(o)) {
                if (!C)
                  continue;
                let [_, ...b] = r(C) ? u(C) : [C];
                typeof _ == "string" && typeof t3(d) == "string" ? d[d.length - 1] += _ : d.push(_), d.push(...b);
              }
              return d.length === 0 ? "" : d.length === 1 ? d[0] : Array.isArray(o) ? d : Object.assign(Object.assign({}, o), {}, { parts: d });
            }
            function I(o) {
              return c(o, (d) => B(d));
            }
            function P(o) {
              let d = [], C = o.filter(Boolean);
              for (; C.length > 0; ) {
                let _ = C.shift();
                if (!!_) {
                  if (r(_)) {
                    C.unshift(...u(_));
                    continue;
                  }
                  if (d.length > 0 && typeof t3(d) == "string" && typeof _ == "string") {
                    d[d.length - 1] += _;
                    continue;
                  }
                  d.push(_);
                }
              }
              return d;
            }
            function R(o) {
              return c(o, (d) => Array.isArray(d) ? P(d) : d.parts ? Object.assign(Object.assign({}, d), {}, { parts: P(d.parts) }) : d);
            }
            function f(o) {
              return c(o, (d) => typeof d == "string" && d.includes(`
`) ? x(d) : d);
            }
            function x(o) {
              let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s;
              return a(d, o.split(`
`)).parts;
            }
            function m(o) {
              if (o.type === "line")
                return true;
            }
            function E(o) {
              return y(o, m, false);
            }
            n.exports = { isConcat: r, getDocParts: u, willBreak: g, traverseDoc: l, findInDoc: y, mapDoc: c, propagateBreaks: D, removeLines: w, stripTrailingHardline: A, normalizeParts: P, normalizeDoc: R, cleanDoc: I, replaceTextEndOfLine: x, replaceEndOfLine: f, canBreak: E };
          } }), fD = ee({ "src/document/doc-printer.js"(e, n) {
            "use strict";
            re();
            var { convertEndOfLineToChars: t3 } = qn(), s = lt2(), a = da(), { fill: r, cursor: u, indent: i } = On(), { isConcat: l, getDocParts: c } = Xt(), y, h = 1, g = 2;
            function p() {
              return { value: "", length: 0, queue: [] };
            }
            function D(B, I) {
              return w(B, { type: "indent" }, I);
            }
            function v(B, I, P) {
              return I === Number.NEGATIVE_INFINITY ? B.root || p() : I < 0 ? w(B, { type: "dedent" }, P) : I ? I.type === "root" ? Object.assign(Object.assign({}, B), {}, { root: B }) : w(B, { type: typeof I == "string" ? "stringAlign" : "numberAlign", n: I }, P) : B;
            }
            function w(B, I, P) {
              let R = I.type === "dedent" ? B.queue.slice(0, -1) : [...B.queue, I], f = "", x = 0, m = 0, E = 0;
              for (let k of R)
                switch (k.type) {
                  case "indent":
                    C(), P.useTabs ? o(1) : d(P.tabWidth);
                    break;
                  case "stringAlign":
                    C(), f += k.n, x += k.n.length;
                    break;
                  case "numberAlign":
                    m += 1, E += k.n;
                    break;
                  default:
                    throw new Error(`Unexpected type '${k.type}'`);
                }
              return b(), Object.assign(Object.assign({}, B), {}, { value: f, length: x, queue: R });
              function o(k) {
                f += "	".repeat(k), x += P.tabWidth * k;
              }
              function d(k) {
                f += " ".repeat(k), x += k;
              }
              function C() {
                P.useTabs ? _() : b();
              }
              function _() {
                m > 0 && o(m), N();
              }
              function b() {
                E > 0 && d(E), N();
              }
              function N() {
                m = 0, E = 0;
              }
            }
            function T(B) {
              if (B.length === 0)
                return 0;
              let I = 0;
              for (; B.length > 0 && typeof s(B) == "string" && /^[\t ]*$/.test(s(B)); )
                I += B.pop().length;
              if (B.length > 0 && typeof s(B) == "string") {
                let P = s(B).replace(/[\t ]*$/, "");
                I += s(B).length - P.length, B[B.length - 1] = P;
              }
              return I;
            }
            function F(B, I, P, R, f) {
              let x = I.length, m = [B], E = [];
              for (; P >= 0; ) {
                if (m.length === 0) {
                  if (x === 0)
                    return true;
                  m.push(I[--x]);
                  continue;
                }
                let { mode: o, doc: d } = m.pop();
                if (typeof d == "string")
                  E.push(d), P -= a(d);
                else if (l(d) || d.type === "fill") {
                  let C = c(d);
                  for (let _ = C.length - 1; _ >= 0; _--)
                    m.push({ mode: o, doc: C[_] });
                } else
                  switch (d.type) {
                    case "indent":
                    case "align":
                    case "indent-if-break":
                    case "label":
                      m.push({ mode: o, doc: d.contents });
                      break;
                    case "trim":
                      P += T(E);
                      break;
                    case "group": {
                      if (f && d.break)
                        return false;
                      let C = d.break ? h : o, _ = d.expandedStates && C === h ? s(d.expandedStates) : d.contents;
                      m.push({ mode: C, doc: _ });
                      break;
                    }
                    case "if-break": {
                      let _ = (d.groupId ? y[d.groupId] || g : o) === h ? d.breakContents : d.flatContents;
                      _ && m.push({ mode: o, doc: _ });
                      break;
                    }
                    case "line":
                      if (o === h || d.hard)
                        return true;
                      d.soft || (E.push(" "), P--);
                      break;
                    case "line-suffix":
                      R = true;
                      break;
                    case "line-suffix-boundary":
                      if (R)
                        return false;
                      break;
                  }
              }
              return false;
            }
            function A(B, I) {
              y = {};
              let P = I.printWidth, R = t3(I.endOfLine), f = 0, x = [{ ind: p(), mode: h, doc: B }], m = [], E = false, o = [];
              for (; x.length > 0; ) {
                let { ind: C, mode: _, doc: b } = x.pop();
                if (typeof b == "string") {
                  let N = R !== `
` ? b.replace(/\n/g, R) : b;
                  m.push(N), f += a(N);
                } else if (l(b)) {
                  let N = c(b);
                  for (let k = N.length - 1; k >= 0; k--)
                    x.push({ ind: C, mode: _, doc: N[k] });
                } else
                  switch (b.type) {
                    case "cursor":
                      m.push(u.placeholder);
                      break;
                    case "indent":
                      x.push({ ind: D(C, I), mode: _, doc: b.contents });
                      break;
                    case "align":
                      x.push({ ind: v(C, b.n, I), mode: _, doc: b.contents });
                      break;
                    case "trim":
                      f -= T(m);
                      break;
                    case "group":
                      switch (_) {
                        case g:
                          if (!E) {
                            x.push({ ind: C, mode: b.break ? h : g, doc: b.contents });
                            break;
                          }
                        case h: {
                          E = false;
                          let N = { ind: C, mode: g, doc: b.contents }, k = P - f, $ = o.length > 0;
                          if (!b.break && F(N, x, k, $))
                            x.push(N);
                          else if (b.expandedStates) {
                            let M = s(b.expandedStates);
                            if (b.break) {
                              x.push({ ind: C, mode: h, doc: M });
                              break;
                            } else
                              for (let q = 1; q < b.expandedStates.length + 1; q++)
                                if (q >= b.expandedStates.length) {
                                  x.push({ ind: C, mode: h, doc: M });
                                  break;
                                } else {
                                  let J = b.expandedStates[q], L = { ind: C, mode: g, doc: J };
                                  if (F(L, x, k, $)) {
                                    x.push(L);
                                    break;
                                  }
                                }
                          } else
                            x.push({ ind: C, mode: h, doc: b.contents });
                          break;
                        }
                      }
                      b.id && (y[b.id] = s(x).mode);
                      break;
                    case "fill": {
                      let N = P - f, { parts: k } = b;
                      if (k.length === 0)
                        break;
                      let [$, M] = k, q = { ind: C, mode: g, doc: $ }, J = { ind: C, mode: h, doc: $ }, L = F(q, [], N, o.length > 0, true);
                      if (k.length === 1) {
                        L ? x.push(q) : x.push(J);
                        break;
                      }
                      let Y = { ind: C, mode: g, doc: M }, V = { ind: C, mode: h, doc: M };
                      if (k.length === 2) {
                        L ? x.push(Y, q) : x.push(V, J);
                        break;
                      }
                      k.splice(0, 2);
                      let O = { ind: C, mode: _, doc: r(k) }, K = k[0];
                      F({ ind: C, mode: g, doc: [$, M, K] }, [], N, o.length > 0, true) ? x.push(O, Y, q) : L ? x.push(O, V, q) : x.push(O, V, J);
                      break;
                    }
                    case "if-break":
                    case "indent-if-break": {
                      let N = b.groupId ? y[b.groupId] : _;
                      if (N === h) {
                        let k = b.type === "if-break" ? b.breakContents : b.negate ? b.contents : i(b.contents);
                        k && x.push({ ind: C, mode: _, doc: k });
                      }
                      if (N === g) {
                        let k = b.type === "if-break" ? b.flatContents : b.negate ? i(b.contents) : b.contents;
                        k && x.push({ ind: C, mode: _, doc: k });
                      }
                      break;
                    }
                    case "line-suffix":
                      o.push({ ind: C, mode: _, doc: b.contents });
                      break;
                    case "line-suffix-boundary":
                      o.length > 0 && x.push({ ind: C, mode: _, doc: { type: "line", hard: true } });
                      break;
                    case "line":
                      switch (_) {
                        case g:
                          if (b.hard)
                            E = true;
                          else {
                            b.soft || (m.push(" "), f += 1);
                            break;
                          }
                        case h:
                          if (o.length > 0) {
                            x.push({ ind: C, mode: _, doc: b }, ...o.reverse()), o.length = 0;
                            break;
                          }
                          b.literal ? C.root ? (m.push(R, C.root.value), f = C.root.length) : (m.push(R), f = 0) : (f -= T(m), m.push(R + C.value), f = C.length);
                          break;
                      }
                      break;
                    case "label":
                      x.push({ ind: C, mode: _, doc: b.contents });
                      break;
                    default:
                  }
                x.length === 0 && o.length > 0 && (x.push(...o.reverse()), o.length = 0);
              }
              let d = m.indexOf(u.placeholder);
              if (d !== -1) {
                let C = m.indexOf(u.placeholder, d + 1), _ = m.slice(0, d).join(""), b = m.slice(d + 1, C).join(""), N = m.slice(C + 1).join("");
                return { formatted: _ + b + N, cursorNodeStart: _.length, cursorNodeText: b };
              }
              return { formatted: m.join("") };
            }
            n.exports = { printDocToString: A };
          } }), DD = ee({ "src/document/doc-debug.js"(e, n) {
            "use strict";
            re();
            var { isConcat: t3, getDocParts: s } = Xt();
            function a(u) {
              if (!u)
                return "";
              if (t3(u)) {
                let i = [];
                for (let l of s(u))
                  if (t3(l))
                    i.push(...a(l).parts);
                  else {
                    let c = a(l);
                    c !== "" && i.push(c);
                  }
                return { type: "concat", parts: i };
              }
              return u.type === "if-break" ? Object.assign(Object.assign({}, u), {}, { breakContents: a(u.breakContents), flatContents: a(u.flatContents) }) : u.type === "group" ? Object.assign(Object.assign({}, u), {}, { contents: a(u.contents), expandedStates: u.expandedStates && u.expandedStates.map(a) }) : u.type === "fill" ? { type: "fill", parts: u.parts.map(a) } : u.contents ? Object.assign(Object.assign({}, u), {}, { contents: a(u.contents) }) : u;
            }
            function r(u) {
              let i = /* @__PURE__ */ Object.create(null), l = /* @__PURE__ */ new Set();
              return c(a(u));
              function c(h, g, p) {
                if (typeof h == "string")
                  return JSON.stringify(h);
                if (t3(h)) {
                  let D = s(h).map(c).filter(Boolean);
                  return D.length === 1 ? D[0] : `[${D.join(", ")}]`;
                }
                if (h.type === "line") {
                  let D = Array.isArray(p) && p[g + 1] && p[g + 1].type === "break-parent";
                  return h.literal ? D ? "literalline" : "literallineWithoutBreakParent" : h.hard ? D ? "hardline" : "hardlineWithoutBreakParent" : h.soft ? "softline" : "line";
                }
                if (h.type === "break-parent")
                  return Array.isArray(p) && p[g - 1] && p[g - 1].type === "line" && p[g - 1].hard ? void 0 : "breakParent";
                if (h.type === "trim")
                  return "trim";
                if (h.type === "indent")
                  return "indent(" + c(h.contents) + ")";
                if (h.type === "align")
                  return h.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + c(h.contents) + ")" : h.n < 0 ? "dedent(" + c(h.contents) + ")" : h.n.type === "root" ? "markAsRoot(" + c(h.contents) + ")" : "align(" + JSON.stringify(h.n) + ", " + c(h.contents) + ")";
                if (h.type === "if-break")
                  return "ifBreak(" + c(h.breakContents) + (h.flatContents ? ", " + c(h.flatContents) : "") + (h.groupId ? (h.flatContents ? "" : ', ""') + `, { groupId: ${y(h.groupId)} }` : "") + ")";
                if (h.type === "indent-if-break") {
                  let D = [];
                  h.negate && D.push("negate: true"), h.groupId && D.push(`groupId: ${y(h.groupId)}`);
                  let v = D.length > 0 ? `, { ${D.join(", ")} }` : "";
                  return `indentIfBreak(${c(h.contents)}${v})`;
                }
                if (h.type === "group") {
                  let D = [];
                  h.break && h.break !== "propagated" && D.push("shouldBreak: true"), h.id && D.push(`id: ${y(h.id)}`);
                  let v = D.length > 0 ? `, { ${D.join(", ")} }` : "";
                  return h.expandedStates ? `conditionalGroup([${h.expandedStates.map((w) => c(w)).join(",")}]${v})` : `group(${c(h.contents)}${v})`;
                }
                if (h.type === "fill")
                  return `fill([${h.parts.map((D) => c(D)).join(", ")}])`;
                if (h.type === "line-suffix")
                  return "lineSuffix(" + c(h.contents) + ")";
                if (h.type === "line-suffix-boundary")
                  return "lineSuffixBoundary";
                if (h.type === "label")
                  return `label(${JSON.stringify(h.label)}, ${c(h.contents)})`;
                throw new Error("Unknown doc type " + h.type);
              }
              function y(h) {
                if (typeof h != "symbol")
                  return JSON.stringify(String(h));
                if (h in i)
                  return i[h];
                let g = String(h).slice(7, -1) || "symbol";
                for (let p = 0; ; p++) {
                  let D = g + (p > 0 ? ` #${p}` : "");
                  if (!l.has(D))
                    return l.add(D), i[h] = `Symbol.for(${JSON.stringify(D)})`;
                }
              }
            }
            n.exports = { printDocToDebug: r };
          } }), qe = ee({ "src/document/index.js"(e, n) {
            "use strict";
            re(), n.exports = { builders: On(), printer: fD(), utils: Xt(), debug: DD() };
          } }), ga = {};
          zt(ga, { default: () => mD });
          function mD(e) {
            if (typeof e != "string")
              throw new TypeError("Expected a string");
            return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
          }
          var dD = gt2({ "node_modules/escape-string-regexp/index.js"() {
            re();
          } }), ya = ee({ "node_modules/semver/internal/debug.js"(e, n) {
            re();
            var t3 = typeof Nt == "object" && Nt.env && Nt.env.NODE_DEBUG && /\bsemver\b/i.test(Nt.env.NODE_DEBUG) ? function() {
              for (var s = arguments.length, a = new Array(s), r = 0; r < s; r++)
                a[r] = arguments[r];
              return console.error("SEMVER", ...a);
            } : () => {
            };
            n.exports = t3;
          } }), ha = ee({ "node_modules/semver/internal/constants.js"(e, n) {
            re();
            var t3 = "2.0.0", s = 256, a = Number.MAX_SAFE_INTEGER || 9007199254740991, r = 16;
            n.exports = { SEMVER_SPEC_VERSION: t3, MAX_LENGTH: s, MAX_SAFE_INTEGER: a, MAX_SAFE_COMPONENT_LENGTH: r };
          } }), gD = ee({ "node_modules/semver/internal/re.js"(e, n) {
            re();
            var { MAX_SAFE_COMPONENT_LENGTH: t3 } = ha(), s = ya();
            e = n.exports = {};
            var a = e.re = [], r = e.src = [], u = e.t = {}, i = 0, l = (c, y, h) => {
              let g = i++;
              s(c, g, y), u[c] = g, r[g] = y, a[g] = new RegExp(y, h ? "g" : void 0);
            };
            l("NUMERICIDENTIFIER", "0|[1-9]\\d*"), l("NUMERICIDENTIFIERLOOSE", "[0-9]+"), l("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), l("MAINVERSION", `(${r[u.NUMERICIDENTIFIER]})\\.(${r[u.NUMERICIDENTIFIER]})\\.(${r[u.NUMERICIDENTIFIER]})`), l("MAINVERSIONLOOSE", `(${r[u.NUMERICIDENTIFIERLOOSE]})\\.(${r[u.NUMERICIDENTIFIERLOOSE]})\\.(${r[u.NUMERICIDENTIFIERLOOSE]})`), l("PRERELEASEIDENTIFIER", `(?:${r[u.NUMERICIDENTIFIER]}|${r[u.NONNUMERICIDENTIFIER]})`), l("PRERELEASEIDENTIFIERLOOSE", `(?:${r[u.NUMERICIDENTIFIERLOOSE]}|${r[u.NONNUMERICIDENTIFIER]})`), l("PRERELEASE", `(?:-(${r[u.PRERELEASEIDENTIFIER]}(?:\\.${r[u.PRERELEASEIDENTIFIER]})*))`), l("PRERELEASELOOSE", `(?:-?(${r[u.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${r[u.PRERELEASEIDENTIFIERLOOSE]})*))`), l("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), l("BUILD", `(?:\\+(${r[u.BUILDIDENTIFIER]}(?:\\.${r[u.BUILDIDENTIFIER]})*))`), l("FULLPLAIN", `v?${r[u.MAINVERSION]}${r[u.PRERELEASE]}?${r[u.BUILD]}?`), l("FULL", `^${r[u.FULLPLAIN]}$`), l("LOOSEPLAIN", `[v=\\s]*${r[u.MAINVERSIONLOOSE]}${r[u.PRERELEASELOOSE]}?${r[u.BUILD]}?`), l("LOOSE", `^${r[u.LOOSEPLAIN]}$`), l("GTLT", "((?:<|>)?=?)"), l("XRANGEIDENTIFIERLOOSE", `${r[u.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), l("XRANGEIDENTIFIER", `${r[u.NUMERICIDENTIFIER]}|x|X|\\*`), l("XRANGEPLAIN", `[v=\\s]*(${r[u.XRANGEIDENTIFIER]})(?:\\.(${r[u.XRANGEIDENTIFIER]})(?:\\.(${r[u.XRANGEIDENTIFIER]})(?:${r[u.PRERELEASE]})?${r[u.BUILD]}?)?)?`), l("XRANGEPLAINLOOSE", `[v=\\s]*(${r[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${r[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${r[u.XRANGEIDENTIFIERLOOSE]})(?:${r[u.PRERELEASELOOSE]})?${r[u.BUILD]}?)?)?`), l("XRANGE", `^${r[u.GTLT]}\\s*${r[u.XRANGEPLAIN]}$`), l("XRANGELOOSE", `^${r[u.GTLT]}\\s*${r[u.XRANGEPLAINLOOSE]}$`), l("COERCE", `(^|[^\\d])(\\d{1,${t3}})(?:\\.(\\d{1,${t3}}))?(?:\\.(\\d{1,${t3}}))?(?:$|[^\\d])`), l("COERCERTL", r[u.COERCE], true), l("LONETILDE", "(?:~>?)"), l("TILDETRIM", `(\\s*)${r[u.LONETILDE]}\\s+`, true), e.tildeTrimReplace = "$1~", l("TILDE", `^${r[u.LONETILDE]}${r[u.XRANGEPLAIN]}$`), l("TILDELOOSE", `^${r[u.LONETILDE]}${r[u.XRANGEPLAINLOOSE]}$`), l("LONECARET", "(?:\\^)"), l("CARETTRIM", `(\\s*)${r[u.LONECARET]}\\s+`, true), e.caretTrimReplace = "$1^", l("CARET", `^${r[u.LONECARET]}${r[u.XRANGEPLAIN]}$`), l("CARETLOOSE", `^${r[u.LONECARET]}${r[u.XRANGEPLAINLOOSE]}$`), l("COMPARATORLOOSE", `^${r[u.GTLT]}\\s*(${r[u.LOOSEPLAIN]})$|^$`), l("COMPARATOR", `^${r[u.GTLT]}\\s*(${r[u.FULLPLAIN]})$|^$`), l("COMPARATORTRIM", `(\\s*)${r[u.GTLT]}\\s*(${r[u.LOOSEPLAIN]}|${r[u.XRANGEPLAIN]})`, true), e.comparatorTrimReplace = "$1$2$3", l("HYPHENRANGE", `^\\s*(${r[u.XRANGEPLAIN]})\\s+-\\s+(${r[u.XRANGEPLAIN]})\\s*$`), l("HYPHENRANGELOOSE", `^\\s*(${r[u.XRANGEPLAINLOOSE]})\\s+-\\s+(${r[u.XRANGEPLAINLOOSE]})\\s*$`), l("STAR", "(<|>)?=?\\s*\\*"), l("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), l("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
          } }), yD = ee({ "node_modules/semver/internal/parse-options.js"(e, n) {
            re();
            var t3 = ["includePrerelease", "loose", "rtl"], s = (a) => a ? typeof a != "object" ? { loose: true } : t3.filter((r) => a[r]).reduce((r, u) => (r[u] = true, r), {}) : {};
            n.exports = s;
          } }), hD = ee({ "node_modules/semver/internal/identifiers.js"(e, n) {
            re();
            var t3 = /^[0-9]+$/, s = (r, u) => {
              let i = t3.test(r), l = t3.test(u);
              return i && l && (r = +r, u = +u), r === u ? 0 : i && !l ? -1 : l && !i ? 1 : r < u ? -1 : 1;
            }, a = (r, u) => s(u, r);
            n.exports = { compareIdentifiers: s, rcompareIdentifiers: a };
          } }), vD = ee({ "node_modules/semver/classes/semver.js"(e, n) {
            re();
            var t3 = ya(), { MAX_LENGTH: s, MAX_SAFE_INTEGER: a } = ha(), { re: r, t: u } = gD(), i = yD(), { compareIdentifiers: l } = hD(), c = class {
              constructor(y, h) {
                if (h = i(h), y instanceof c) {
                  if (y.loose === !!h.loose && y.includePrerelease === !!h.includePrerelease)
                    return y;
                  y = y.version;
                } else if (typeof y != "string")
                  throw new TypeError(`Invalid Version: ${y}`);
                if (y.length > s)
                  throw new TypeError(`version is longer than ${s} characters`);
                t3("SemVer", y, h), this.options = h, this.loose = !!h.loose, this.includePrerelease = !!h.includePrerelease;
                let g = y.trim().match(h.loose ? r[u.LOOSE] : r[u.FULL]);
                if (!g)
                  throw new TypeError(`Invalid Version: ${y}`);
                if (this.raw = y, this.major = +g[1], this.minor = +g[2], this.patch = +g[3], this.major > a || this.major < 0)
                  throw new TypeError("Invalid major version");
                if (this.minor > a || this.minor < 0)
                  throw new TypeError("Invalid minor version");
                if (this.patch > a || this.patch < 0)
                  throw new TypeError("Invalid patch version");
                g[4] ? this.prerelease = g[4].split(".").map((p) => {
                  if (/^[0-9]+$/.test(p)) {
                    let D = +p;
                    if (D >= 0 && D < a)
                      return D;
                  }
                  return p;
                }) : this.prerelease = [], this.build = g[5] ? g[5].split(".") : [], this.format();
              }
              format() {
                return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
              }
              toString() {
                return this.version;
              }
              compare(y) {
                if (t3("SemVer.compare", this.version, this.options, y), !(y instanceof c)) {
                  if (typeof y == "string" && y === this.version)
                    return 0;
                  y = new c(y, this.options);
                }
                return y.version === this.version ? 0 : this.compareMain(y) || this.comparePre(y);
              }
              compareMain(y) {
                return y instanceof c || (y = new c(y, this.options)), l(this.major, y.major) || l(this.minor, y.minor) || l(this.patch, y.patch);
              }
              comparePre(y) {
                if (y instanceof c || (y = new c(y, this.options)), this.prerelease.length && !y.prerelease.length)
                  return -1;
                if (!this.prerelease.length && y.prerelease.length)
                  return 1;
                if (!this.prerelease.length && !y.prerelease.length)
                  return 0;
                let h = 0;
                do {
                  let g = this.prerelease[h], p = y.prerelease[h];
                  if (t3("prerelease compare", h, g, p), g === void 0 && p === void 0)
                    return 0;
                  if (p === void 0)
                    return 1;
                  if (g === void 0)
                    return -1;
                  if (g === p)
                    continue;
                  return l(g, p);
                } while (++h);
              }
              compareBuild(y) {
                y instanceof c || (y = new c(y, this.options));
                let h = 0;
                do {
                  let g = this.build[h], p = y.build[h];
                  if (t3("prerelease compare", h, g, p), g === void 0 && p === void 0)
                    return 0;
                  if (p === void 0)
                    return 1;
                  if (g === void 0)
                    return -1;
                  if (g === p)
                    continue;
                  return l(g, p);
                } while (++h);
              }
              inc(y, h) {
                switch (y) {
                  case "premajor":
                    this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", h);
                    break;
                  case "preminor":
                    this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", h);
                    break;
                  case "prepatch":
                    this.prerelease.length = 0, this.inc("patch", h), this.inc("pre", h);
                    break;
                  case "prerelease":
                    this.prerelease.length === 0 && this.inc("patch", h), this.inc("pre", h);
                    break;
                  case "major":
                    (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                    break;
                  case "minor":
                    (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                    break;
                  case "patch":
                    this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                    break;
                  case "pre":
                    if (this.prerelease.length === 0)
                      this.prerelease = [0];
                    else {
                      let g = this.prerelease.length;
                      for (; --g >= 0; )
                        typeof this.prerelease[g] == "number" && (this.prerelease[g]++, g = -2);
                      g === -1 && this.prerelease.push(0);
                    }
                    h && (l(this.prerelease[0], h) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [h, 0]) : this.prerelease = [h, 0]);
                    break;
                  default:
                    throw new Error(`invalid increment argument: ${y}`);
                }
                return this.format(), this.raw = this.version, this;
              }
            };
            n.exports = c;
          } }), Mn = ee({ "node_modules/semver/functions/compare.js"(e, n) {
            re();
            var t3 = vD(), s = (a, r, u) => new t3(a, u).compare(new t3(r, u));
            n.exports = s;
          } }), CD = ee({ "node_modules/semver/functions/lt.js"(e, n) {
            re();
            var t3 = Mn(), s = (a, r, u) => t3(a, r, u) < 0;
            n.exports = s;
          } }), ED = ee({ "node_modules/semver/functions/gte.js"(e, n) {
            re();
            var t3 = Mn(), s = (a, r, u) => t3(a, r, u) >= 0;
            n.exports = s;
          } }), FD = ee({ "src/utils/arrayify.js"(e, n) {
            "use strict";
            re(), n.exports = (t3, s) => Object.entries(t3).map((a) => {
              let [r, u] = a;
              return Object.assign({ [s]: r }, u);
            });
          } }), AD = ee({ "node_modules/outdent/lib/index.js"(e, n) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.outdent = void 0;
            function t3() {
              for (var F = [], A = 0; A < arguments.length; A++)
                F[A] = arguments[A];
            }
            function s() {
              return typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : a();
            }
            function a() {
              return { add: t3, delete: t3, get: t3, set: t3, has: function(F) {
                return false;
              } };
            }
            var r = Object.prototype.hasOwnProperty, u = function(F, A) {
              return r.call(F, A);
            };
            function i(F, A) {
              for (var B in A)
                u(A, B) && (F[B] = A[B]);
              return F;
            }
            var l = /^[ \t]*(?:\r\n|\r|\n)/, c = /(?:\r\n|\r|\n)[ \t]*$/, y = /^(?:[\r\n]|$)/, h = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, g = /^[ \t]*[\r\n][ \t\r\n]*$/;
            function p(F, A, B) {
              var I = 0, P = F[0].match(h);
              P && (I = P[1].length);
              var R = "(\\r\\n|\\r|\\n).{0," + I + "}", f = new RegExp(R, "g");
              A && (F = F.slice(1));
              var x = B.newline, m = B.trimLeadingNewline, E = B.trimTrailingNewline, o = typeof x == "string", d = F.length, C = F.map(function(_, b) {
                return _ = _.replace(f, "$1"), b === 0 && m && (_ = _.replace(l, "")), b === d - 1 && E && (_ = _.replace(c, "")), o && (_ = _.replace(/\r\n|\n|\r/g, function(N) {
                  return x;
                })), _;
              });
              return C;
            }
            function D(F, A) {
              for (var B = "", I = 0, P = F.length; I < P; I++)
                B += F[I], I < P - 1 && (B += A[I]);
              return B;
            }
            function v(F) {
              return u(F, "raw") && u(F, "length");
            }
            function w(F) {
              var A = s(), B = s();
              function I(R) {
                for (var f = [], x = 1; x < arguments.length; x++)
                  f[x - 1] = arguments[x];
                if (v(R)) {
                  var m = R, E = (f[0] === I || f[0] === T) && g.test(m[0]) && y.test(m[1]), o = E ? B : A, d = o.get(m);
                  if (d || (d = p(m, E, F), o.set(m, d)), f.length === 0)
                    return d[0];
                  var C = D(d, E ? f.slice(1) : f);
                  return C;
                } else
                  return w(i(i({}, F), R || {}));
              }
              var P = i(I, { string: function(R) {
                return p([R], false, F)[0];
              } });
              return P;
            }
            var T = w({ trimLeadingNewline: true, trimTrailingNewline: true });
            if (e.outdent = T, e.default = T, typeof n < "u")
              try {
                n.exports = T, Object.defineProperty(T, "__esModule", { value: true }), T.default = T, T.outdent = T;
              } catch {
              }
          } }), SD = ee({ "src/main/core-options.js"(e, n) {
            "use strict";
            re();
            var { outdent: t3 } = AD(), s = "Config", a = "Editor", r = "Format", u = "Other", i = "Output", l = "Global", c = "Special", y = { cursorOffset: { since: "1.4.0", category: c, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `, cliCategory: a }, endOfLine: { since: "1.15.0", category: l, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: t3`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        ` }] }, filepath: { since: "1.4.0", category: c, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: u, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: c, type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: u }, parser: { since: "0.0.10", category: l, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (h) => typeof h == "string" || typeof h == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: true, default: [{ value: [] }], category: l, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (h) => typeof h == "string" || typeof h == "object", cliName: "plugin", cliCategory: s }, pluginSearchDirs: { since: "1.13.0", type: "path", array: true, default: [{ value: [] }], category: l, description: t3`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `, exception: (h) => typeof h == "string" || typeof h == "object", cliName: "plugin-search-dir", cliCategory: s }, printWidth: { since: "0.0.0", category: l, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: c, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: a }, rangeStart: { since: "1.4.0", category: c, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: a }, requirePragma: { since: "1.7.0", category: c, type: "boolean", default: false, description: t3`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `, cliCategory: u }, tabWidth: { type: "int", category: l, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: l, type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: l, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
            n.exports = { CATEGORY_CONFIG: s, CATEGORY_EDITOR: a, CATEGORY_FORMAT: r, CATEGORY_OTHER: u, CATEGORY_OUTPUT: i, CATEGORY_GLOBAL: l, CATEGORY_SPECIAL: c, options: y };
          } }), Rn = ee({ "src/main/support.js"(e, n) {
            "use strict";
            re();
            var t3 = { compare: Mn(), lt: CD(), gte: ED() }, s = FD(), a = fa().version, r = SD().options;
            function u() {
              let { plugins: l = [], showUnreleased: c = false, showDeprecated: y = false, showInternal: h = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = a.split("-", 1)[0], p = l.flatMap((F) => F.languages || []).filter(v), D = s(Object.assign({}, ...l.map((F) => {
                let { options: A } = F;
                return A;
              }), r), "name").filter((F) => v(F) && w(F)).sort((F, A) => F.name === A.name ? 0 : F.name < A.name ? -1 : 1).map(T).map((F) => {
                F = Object.assign({}, F), Array.isArray(F.default) && (F.default = F.default.length === 1 ? F.default[0].value : F.default.filter(v).sort((B, I) => t3.compare(I.since, B.since))[0].value), Array.isArray(F.choices) && (F.choices = F.choices.filter((B) => v(B) && w(B)), F.name === "parser" && i(F, p, l));
                let A = Object.fromEntries(l.filter((B) => B.defaultOptions && B.defaultOptions[F.name] !== void 0).map((B) => [B.name, B.defaultOptions[F.name]]));
                return Object.assign(Object.assign({}, F), {}, { pluginDefaults: A });
              });
              return { languages: p, options: D };
              function v(F) {
                return c || !("since" in F) || F.since && t3.gte(g, F.since);
              }
              function w(F) {
                return y || !("deprecated" in F) || F.deprecated && t3.lt(g, F.deprecated);
              }
              function T(F) {
                if (h)
                  return F;
                let { cliName: A, cliCategory: B, cliDescription: I } = F;
                return Ln(F, Uf);
              }
            }
            function i(l, c, y) {
              let h = new Set(l.choices.map((g) => g.value));
              for (let g of c)
                if (g.parsers) {
                  for (let p of g.parsers)
                    if (!h.has(p)) {
                      h.add(p);
                      let D = y.find((w) => w.parsers && w.parsers[p]), v = g.name;
                      D && D.name && (v += ` (plugin: ${D.name})`), l.choices.push({ value: p, description: v });
                    }
                }
            }
            n.exports = { getSupportInfo: u };
          } }), $n = ee({ "src/utils/is-non-empty-array.js"(e, n) {
            "use strict";
            re();
            function t3(s) {
              return Array.isArray(s) && s.length > 0;
            }
            n.exports = t3;
          } }), _r = ee({ "src/utils/text/skip.js"(e, n) {
            "use strict";
            re();
            function t3(i) {
              return (l, c, y) => {
                let h = y && y.backwards;
                if (c === false)
                  return false;
                let { length: g } = l, p = c;
                for (; p >= 0 && p < g; ) {
                  let D = l.charAt(p);
                  if (i instanceof RegExp) {
                    if (!i.test(D))
                      return p;
                  } else if (!i.includes(D))
                    return p;
                  h ? p-- : p++;
                }
                return p === -1 || p === g ? p : false;
              };
            }
            var s = t3(/\s/), a = t3(" 	"), r = t3(",; 	"), u = t3(/[^\n\r]/);
            n.exports = { skipWhitespace: s, skipSpaces: a, skipToLineEnd: r, skipEverythingButNewLine: u };
          } }), va = ee({ "src/utils/text/skip-inline-comment.js"(e, n) {
            "use strict";
            re();
            function t3(s, a) {
              if (a === false)
                return false;
              if (s.charAt(a) === "/" && s.charAt(a + 1) === "*") {
                for (let r = a + 2; r < s.length; ++r)
                  if (s.charAt(r) === "*" && s.charAt(r + 1) === "/")
                    return r + 2;
              }
              return a;
            }
            n.exports = t3;
          } }), Ca = ee({ "src/utils/text/skip-trailing-comment.js"(e, n) {
            "use strict";
            re();
            var { skipEverythingButNewLine: t3 } = _r();
            function s(a, r) {
              return r === false ? false : a.charAt(r) === "/" && a.charAt(r + 1) === "/" ? t3(a, r) : r;
            }
            n.exports = s;
          } }), Ea = ee({ "src/utils/text/skip-newline.js"(e, n) {
            "use strict";
            re();
            function t3(s, a, r) {
              let u = r && r.backwards;
              if (a === false)
                return false;
              let i = s.charAt(a);
              if (u) {
                if (s.charAt(a - 1) === "\r" && i === `
`)
                  return a - 2;
                if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029")
                  return a - 1;
              } else {
                if (i === "\r" && s.charAt(a + 1) === `
`)
                  return a + 2;
                if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029")
                  return a + 1;
              }
              return a;
            }
            n.exports = t3;
          } }), xD = ee({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(e, n) {
            "use strict";
            re();
            var t3 = va(), s = Ea(), a = Ca(), { skipSpaces: r } = _r();
            function u(i, l) {
              let c = null, y = l;
              for (; y !== c; )
                c = y, y = r(i, y), y = t3(i, y), y = a(i, y), y = s(i, y);
              return y;
            }
            n.exports = u;
          } }), Ge = ee({ "src/common/util.js"(e, n) {
            "use strict";
            re();
            var { default: t3 } = (dD(), ft(ga)), s = lt2(), { getSupportInfo: a } = Rn(), r = $n(), u = da(), { skipWhitespace: i, skipSpaces: l, skipToLineEnd: c, skipEverythingButNewLine: y } = _r(), h = va(), g = Ca(), p = Ea(), D = xD(), v = (V) => V[V.length - 2];
            function w(V) {
              return (O, K, se) => {
                let Q = se && se.backwards;
                if (K === false)
                  return false;
                let { length: le } = O, W = K;
                for (; W >= 0 && W < le; ) {
                  let X = O.charAt(W);
                  if (V instanceof RegExp) {
                    if (!V.test(X))
                      return W;
                  } else if (!V.includes(X))
                    return W;
                  Q ? W-- : W++;
                }
                return W === -1 || W === le ? W : false;
              };
            }
            function T(V, O) {
              let K = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, se = l(V, K.backwards ? O - 1 : O, K), Q = p(V, se, K);
              return se !== Q;
            }
            function F(V, O, K) {
              for (let se = O; se < K; ++se)
                if (V.charAt(se) === `
`)
                  return true;
              return false;
            }
            function A(V, O, K) {
              let se = K(O) - 1;
              se = l(V, se, { backwards: true }), se = p(V, se, { backwards: true }), se = l(V, se, { backwards: true });
              let Q = p(V, se, { backwards: true });
              return se !== Q;
            }
            function B(V, O) {
              let K = null, se = O;
              for (; se !== K; )
                K = se, se = c(V, se), se = h(V, se), se = l(V, se);
              return se = g(V, se), se = p(V, se), se !== false && T(V, se);
            }
            function I(V, O, K) {
              return B(V, K(O));
            }
            function P(V, O, K) {
              return D(V, K(O));
            }
            function R(V, O, K) {
              return V.charAt(P(V, O, K));
            }
            function f(V, O) {
              let K = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              return l(V, K.backwards ? O - 1 : O, K) !== O;
            }
            function x(V, O) {
              let K = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, se = 0;
              for (let Q = K; Q < V.length; ++Q)
                V[Q] === "	" ? se = se + O - se % O : se++;
              return se;
            }
            function m(V, O) {
              let K = V.lastIndexOf(`
`);
              return K === -1 ? 0 : x(V.slice(K + 1).match(/^[\t ]*/)[0], O);
            }
            function E(V, O) {
              let K = { quote: '"', regex: /"/g, escaped: "&quot;" }, se = { quote: "'", regex: /'/g, escaped: "&apos;" }, Q = O === "'" ? se : K, le = Q === se ? K : se, W = Q;
              if (V.includes(Q.quote) || V.includes(le.quote)) {
                let X = (V.match(Q.regex) || []).length, oe = (V.match(le.regex) || []).length;
                W = X > oe ? le : Q;
              }
              return W;
            }
            function o(V, O) {
              let K = V.slice(1, -1), se = O.parser === "json" || O.parser === "json5" && O.quoteProps === "preserve" && !O.singleQuote ? '"' : O.__isInHtmlAttribute ? "'" : E(K, O.singleQuote ? "'" : '"').quote;
              return d(K, se, !(O.parser === "css" || O.parser === "less" || O.parser === "scss" || O.__embeddedInHtml));
            }
            function d(V, O, K) {
              let se = O === '"' ? "'" : '"', Q = /\\(.)|(["'])/gs, le = V.replace(Q, (W, X, oe) => X === se ? X : oe === O ? "\\" + oe : oe || (K && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(X) ? X : "\\" + X));
              return O + le + O;
            }
            function C(V) {
              return V.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
            }
            function _(V, O) {
              let K = V.match(new RegExp(`(${t3(O)})+`, "g"));
              return K === null ? 0 : K.reduce((se, Q) => Math.max(se, Q.length / O.length), 0);
            }
            function b(V, O) {
              let K = V.match(new RegExp(`(${t3(O)})+`, "g"));
              if (K === null)
                return 0;
              let se = /* @__PURE__ */ new Map(), Q = 0;
              for (let le of K) {
                let W = le.length / O.length;
                se.set(W, true), W > Q && (Q = W);
              }
              for (let le = 1; le < Q; le++)
                if (!se.get(le))
                  return le;
              return Q + 1;
            }
            function N(V, O) {
              (V.comments || (V.comments = [])).push(O), O.printed = false, O.nodeDescription = Y(V);
            }
            function k(V, O) {
              O.leading = true, O.trailing = false, N(V, O);
            }
            function $(V, O, K) {
              O.leading = false, O.trailing = false, K && (O.marker = K), N(V, O);
            }
            function M(V, O) {
              O.leading = false, O.trailing = true, N(V, O);
            }
            function q(V, O) {
              let { languages: K } = a({ plugins: O.plugins }), se = K.find((Q) => {
                let { name: le } = Q;
                return le.toLowerCase() === V;
              }) || K.find((Q) => {
                let { aliases: le } = Q;
                return Array.isArray(le) && le.includes(V);
              }) || K.find((Q) => {
                let { extensions: le } = Q;
                return Array.isArray(le) && le.includes(`.${V}`);
              });
              return se && se.parsers[0];
            }
            function J(V) {
              return V && V.type === "front-matter";
            }
            function L(V) {
              let O = /* @__PURE__ */ new WeakMap();
              return function(K) {
                return O.has(K) || O.set(K, Symbol(V)), O.get(K);
              };
            }
            function Y(V) {
              let O = V.type || V.kind || "(unknown type)", K = String(V.name || V.id && (typeof V.id == "object" ? V.id.name : V.id) || V.key && (typeof V.key == "object" ? V.key.name : V.key) || V.value && (typeof V.value == "object" ? "" : String(V.value)) || V.operator || "");
              return K.length > 20 && (K = K.slice(0, 19) + "\u2026"), O + (K ? " " + K : "");
            }
            n.exports = { inferParserByLanguage: q, getStringWidth: u, getMaxContinuousCount: _, getMinNotPresentContinuousCount: b, getPenultimate: v, getLast: s, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: D, getNextNonSpaceNonCommentCharacterIndex: P, getNextNonSpaceNonCommentCharacter: R, skip: w, skipWhitespace: i, skipSpaces: l, skipToLineEnd: c, skipEverythingButNewLine: y, skipInlineComment: h, skipTrailingComment: g, skipNewline: p, isNextLineEmptyAfterIndex: B, isNextLineEmpty: I, isPreviousLineEmpty: A, hasNewline: T, hasNewlineInRange: F, hasSpaces: f, getAlignmentSize: x, getIndentSize: m, getPreferredQuote: E, printString: o, printNumber: C, makeString: d, addLeadingComment: k, addDanglingComment: $, addTrailingComment: M, isFrontMatterNode: J, isNonEmptyArray: r, createGroupIdMapper: L };
          } }), Fa = {};
          zt(Fa, { basename: () => Ta, default: () => Na, delimiter: () => wn, dirname: () => ba, extname: () => Ba, isAbsolute: () => Wn, join: () => Sa, normalize: () => Vn, relative: () => xa, resolve: () => Nr, sep: () => Nn });
          function Aa(e, n) {
            for (var t3 = 0, s = e.length - 1; s >= 0; s--) {
              var a = e[s];
              a === "." ? e.splice(s, 1) : a === ".." ? (e.splice(s, 1), t3++) : t3 && (e.splice(s, 1), t3--);
            }
            if (n)
              for (; t3--; t3)
                e.unshift("..");
            return e;
          }
          function Nr() {
            for (var e = "", n = false, t3 = arguments.length - 1; t3 >= -1 && !n; t3--) {
              var s = t3 >= 0 ? arguments[t3] : "/";
              if (typeof s != "string")
                throw new TypeError("Arguments to path.resolve must be strings");
              if (!s)
                continue;
              e = s + "/" + e, n = s.charAt(0) === "/";
            }
            return e = Aa(Hn(e.split("/"), function(a) {
              return !!a;
            }), !n).join("/"), (n ? "/" : "") + e || ".";
          }
          function Vn(e) {
            var n = Wn(e), t3 = wa(e, -1) === "/";
            return e = Aa(Hn(e.split("/"), function(s) {
              return !!s;
            }), !n).join("/"), !e && !n && (e = "."), e && t3 && (e += "/"), (n ? "/" : "") + e;
          }
          function Wn(e) {
            return e.charAt(0) === "/";
          }
          function Sa() {
            var e = Array.prototype.slice.call(arguments, 0);
            return Vn(Hn(e, function(n, t3) {
              if (typeof n != "string")
                throw new TypeError("Arguments to path.join must be strings");
              return n;
            }).join("/"));
          }
          function xa(e, n) {
            e = Nr(e).substr(1), n = Nr(n).substr(1);
            function t3(c) {
              for (var y = 0; y < c.length && c[y] === ""; y++)
                ;
              for (var h = c.length - 1; h >= 0 && c[h] === ""; h--)
                ;
              return y > h ? [] : c.slice(y, h - y + 1);
            }
            for (var s = t3(e.split("/")), a = t3(n.split("/")), r = Math.min(s.length, a.length), u = r, i = 0; i < r; i++)
              if (s[i] !== a[i]) {
                u = i;
                break;
              }
            for (var l = [], i = u; i < s.length; i++)
              l.push("..");
            return l = l.concat(a.slice(u)), l.join("/");
          }
          function ba(e) {
            var n = Pr(e), t3 = n[0], s = n[1];
            return !t3 && !s ? "." : (s && (s = s.substr(0, s.length - 1)), t3 + s);
          }
          function Ta(e, n) {
            var t3 = Pr(e)[2];
            return n && t3.substr(-1 * n.length) === n && (t3 = t3.substr(0, t3.length - n.length)), t3;
          }
          function Ba(e) {
            return Pr(e)[3];
          }
          function Hn(e, n) {
            if (e.filter)
              return e.filter(n);
            for (var t3 = [], s = 0; s < e.length; s++)
              n(e[s], s, e) && t3.push(e[s]);
            return t3;
          }
          var oa, Pr, Nn, wn, Na, wa, bD = gt2({ "node-modules-polyfills:path"() {
            re(), oa = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, Pr = function(e) {
              return oa.exec(e).slice(1);
            }, Nn = "/", wn = ":", Na = { extname: Ba, basename: Ta, dirname: ba, sep: Nn, delimiter: wn, relative: xa, join: Sa, isAbsolute: Wn, normalize: Vn, resolve: Nr }, wa = "ab".substr(-1) === "b" ? function(e, n, t3) {
              return e.substr(n, t3);
            } : function(e, n, t3) {
              return n < 0 && (n = e.length + n), e.substr(n, t3);
            };
          } }), TD = ee({ "node-modules-polyfills-commonjs:path"(e, n) {
            re();
            var t3 = (bD(), ft(Fa));
            if (t3 && t3.default) {
              n.exports = t3.default;
              for (let s in t3)
                n.exports[s] = t3[s];
            } else
              t3 && (n.exports = t3);
          } }), Kt = ee({ "src/common/errors.js"(e, n) {
            "use strict";
            re();
            var t3 = class extends Error {
            }, s = class extends Error {
            }, a = class extends Error {
            }, r = class extends Error {
            };
            n.exports = { ConfigError: t3, DebugError: s, UndefinedParserError: a, ArgExpansionBailout: r };
          } }), yt = {};
          zt(yt, { __assign: () => Br, __asyncDelegator: () => RD, __asyncGenerator: () => MD, __asyncValues: () => $D, __await: () => Jt, __awaiter: () => ID, __classPrivateFieldGet: () => GD, __classPrivateFieldSet: () => UD, __createBinding: () => LD, __decorate: () => wD, __exportStar: () => jD, __extends: () => BD, __generator: () => kD, __importDefault: () => HD, __importStar: () => WD, __makeTemplateObject: () => VD, __metadata: () => PD, __param: () => _D, __read: () => _a, __rest: () => ND, __spread: () => OD, __spreadArrays: () => qD, __values: () => _n });
          function BD(e, n) {
            Tr(e, n);
            function t3() {
              this.constructor = e;
            }
            e.prototype = n === null ? Object.create(n) : (t3.prototype = n.prototype, new t3());
          }
          function ND(e, n) {
            var t3 = {};
            for (var s in e)
              Object.prototype.hasOwnProperty.call(e, s) && n.indexOf(s) < 0 && (t3[s] = e[s]);
            if (e != null && typeof Object.getOwnPropertySymbols == "function")
              for (var a = 0, s = Object.getOwnPropertySymbols(e); a < s.length; a++)
                n.indexOf(s[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, s[a]) && (t3[s[a]] = e[s[a]]);
            return t3;
          }
          function wD(e, n, t3, s) {
            var a = arguments.length, r = a < 3 ? n : s === null ? s = Object.getOwnPropertyDescriptor(n, t3) : s, u;
            if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
              r = Reflect.decorate(e, n, t3, s);
            else
              for (var i = e.length - 1; i >= 0; i--)
                (u = e[i]) && (r = (a < 3 ? u(r) : a > 3 ? u(n, t3, r) : u(n, t3)) || r);
            return a > 3 && r && Object.defineProperty(n, t3, r), r;
          }
          function _D(e, n) {
            return function(t3, s) {
              n(t3, s, e);
            };
          }
          function PD(e, n) {
            if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
              return Reflect.metadata(e, n);
          }
          function ID(e, n, t3, s) {
            function a(r) {
              return r instanceof t3 ? r : new t3(function(u) {
                u(r);
              });
            }
            return new (t3 || (t3 = Promise))(function(r, u) {
              function i(y) {
                try {
                  c(s.next(y));
                } catch (h) {
                  u(h);
                }
              }
              function l(y) {
                try {
                  c(s.throw(y));
                } catch (h) {
                  u(h);
                }
              }
              function c(y) {
                y.done ? r(y.value) : a(y.value).then(i, l);
              }
              c((s = s.apply(e, n || [])).next());
            });
          }
          function kD(e, n) {
            var t3 = { label: 0, sent: function() {
              if (r[0] & 1)
                throw r[1];
              return r[1];
            }, trys: [], ops: [] }, s, a, r, u;
            return u = { next: i(0), throw: i(1), return: i(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
              return this;
            }), u;
            function i(c) {
              return function(y) {
                return l([c, y]);
              };
            }
            function l(c) {
              if (s)
                throw new TypeError("Generator is already executing.");
              for (; t3; )
                try {
                  if (s = 1, a && (r = c[0] & 2 ? a.return : c[0] ? a.throw || ((r = a.return) && r.call(a), 0) : a.next) && !(r = r.call(a, c[1])).done)
                    return r;
                  switch (a = 0, r && (c = [c[0] & 2, r.value]), c[0]) {
                    case 0:
                    case 1:
                      r = c;
                      break;
                    case 4:
                      return t3.label++, { value: c[1], done: false };
                    case 5:
                      t3.label++, a = c[1], c = [0];
                      continue;
                    case 7:
                      c = t3.ops.pop(), t3.trys.pop();
                      continue;
                    default:
                      if (r = t3.trys, !(r = r.length > 0 && r[r.length - 1]) && (c[0] === 6 || c[0] === 2)) {
                        t3 = 0;
                        continue;
                      }
                      if (c[0] === 3 && (!r || c[1] > r[0] && c[1] < r[3])) {
                        t3.label = c[1];
                        break;
                      }
                      if (c[0] === 6 && t3.label < r[1]) {
                        t3.label = r[1], r = c;
                        break;
                      }
                      if (r && t3.label < r[2]) {
                        t3.label = r[2], t3.ops.push(c);
                        break;
                      }
                      r[2] && t3.ops.pop(), t3.trys.pop();
                      continue;
                  }
                  c = n.call(e, t3);
                } catch (y) {
                  c = [6, y], a = 0;
                } finally {
                  s = r = 0;
                }
              if (c[0] & 5)
                throw c[1];
              return { value: c[0] ? c[1] : void 0, done: true };
            }
          }
          function LD(e, n, t3, s) {
            s === void 0 && (s = t3), e[s] = n[t3];
          }
          function jD(e, n) {
            for (var t3 in e)
              t3 !== "default" && !n.hasOwnProperty(t3) && (n[t3] = e[t3]);
          }
          function _n(e) {
            var n = typeof Symbol == "function" && Symbol.iterator, t3 = n && e[n], s = 0;
            if (t3)
              return t3.call(e);
            if (e && typeof e.length == "number")
              return { next: function() {
                return e && s >= e.length && (e = void 0), { value: e && e[s++], done: !e };
              } };
            throw new TypeError(n ? "Object is not iterable." : "Symbol.iterator is not defined.");
          }
          function _a(e, n) {
            var t3 = typeof Symbol == "function" && e[Symbol.iterator];
            if (!t3)
              return e;
            var s = t3.call(e), a, r = [], u;
            try {
              for (; (n === void 0 || n-- > 0) && !(a = s.next()).done; )
                r.push(a.value);
            } catch (i) {
              u = { error: i };
            } finally {
              try {
                a && !a.done && (t3 = s.return) && t3.call(s);
              } finally {
                if (u)
                  throw u.error;
              }
            }
            return r;
          }
          function OD() {
            for (var e = [], n = 0; n < arguments.length; n++)
              e = e.concat(_a(arguments[n]));
            return e;
          }
          function qD() {
            for (var e = 0, n = 0, t3 = arguments.length; n < t3; n++)
              e += arguments[n].length;
            for (var s = Array(e), a = 0, n = 0; n < t3; n++)
              for (var r = arguments[n], u = 0, i = r.length; u < i; u++, a++)
                s[a] = r[u];
            return s;
          }
          function Jt(e) {
            return this instanceof Jt ? (this.v = e, this) : new Jt(e);
          }
          function MD(e, n, t3) {
            if (!Symbol.asyncIterator)
              throw new TypeError("Symbol.asyncIterator is not defined.");
            var s = t3.apply(e, n || []), a, r = [];
            return a = {}, u("next"), u("throw"), u("return"), a[Symbol.asyncIterator] = function() {
              return this;
            }, a;
            function u(g) {
              s[g] && (a[g] = function(p) {
                return new Promise(function(D, v) {
                  r.push([g, p, D, v]) > 1 || i(g, p);
                });
              });
            }
            function i(g, p) {
              try {
                l(s[g](p));
              } catch (D) {
                h(r[0][3], D);
              }
            }
            function l(g) {
              g.value instanceof Jt ? Promise.resolve(g.value.v).then(c, y) : h(r[0][2], g);
            }
            function c(g) {
              i("next", g);
            }
            function y(g) {
              i("throw", g);
            }
            function h(g, p) {
              g(p), r.shift(), r.length && i(r[0][0], r[0][1]);
            }
          }
          function RD(e) {
            var n, t3;
            return n = {}, s("next"), s("throw", function(a) {
              throw a;
            }), s("return"), n[Symbol.iterator] = function() {
              return this;
            }, n;
            function s(a, r) {
              n[a] = e[a] ? function(u) {
                return (t3 = !t3) ? { value: Jt(e[a](u)), done: a === "return" } : r ? r(u) : u;
              } : r;
            }
          }
          function $D(e) {
            if (!Symbol.asyncIterator)
              throw new TypeError("Symbol.asyncIterator is not defined.");
            var n = e[Symbol.asyncIterator], t3;
            return n ? n.call(e) : (e = typeof _n == "function" ? _n(e) : e[Symbol.iterator](), t3 = {}, s("next"), s("throw"), s("return"), t3[Symbol.asyncIterator] = function() {
              return this;
            }, t3);
            function s(r) {
              t3[r] = e[r] && function(u) {
                return new Promise(function(i, l) {
                  u = e[r](u), a(i, l, u.done, u.value);
                });
              };
            }
            function a(r, u, i, l) {
              Promise.resolve(l).then(function(c) {
                r({ value: c, done: i });
              }, u);
            }
          }
          function VD(e, n) {
            return Object.defineProperty ? Object.defineProperty(e, "raw", { value: n }) : e.raw = n, e;
          }
          function WD(e) {
            if (e && e.__esModule)
              return e;
            var n = {};
            if (e != null)
              for (var t3 in e)
                Object.hasOwnProperty.call(e, t3) && (n[t3] = e[t3]);
            return n.default = e, n;
          }
          function HD(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function GD(e, n) {
            if (!n.has(e))
              throw new TypeError("attempted to get private field on non-instance");
            return n.get(e);
          }
          function UD(e, n, t3) {
            if (!n.has(e))
              throw new TypeError("attempted to set private field on non-instance");
            return n.set(e, t3), t3;
          }
          var Tr, Br, Ct = gt2({ "node_modules/tslib/tslib.es6.js"() {
            re(), Tr = function(e, n) {
              return Tr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t3, s) {
                t3.__proto__ = s;
              } || function(t3, s) {
                for (var a in s)
                  s.hasOwnProperty(a) && (t3[a] = s[a]);
              }, Tr(e, n);
            }, Br = function() {
              return Br = Object.assign || function(n) {
                for (var t3, s = 1, a = arguments.length; s < a; s++) {
                  t3 = arguments[s];
                  for (var r in t3)
                    Object.prototype.hasOwnProperty.call(t3, r) && (n[r] = t3[r]);
                }
                return n;
              }, Br.apply(this, arguments);
            };
          } }), Pa = ee({ "node_modules/vnopts/lib/descriptors/api.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.apiDescriptor = { key: (n) => /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(n) ? n : JSON.stringify(n), value(n) {
              if (n === null || typeof n != "object")
                return JSON.stringify(n);
              if (Array.isArray(n))
                return `[${n.map((s) => e.apiDescriptor.value(s)).join(", ")}]`;
              let t3 = Object.keys(n);
              return t3.length === 0 ? "{}" : `{ ${t3.map((s) => `${e.apiDescriptor.key(s)}: ${e.apiDescriptor.value(n[s])}`).join(", ")} }`;
            }, pair: (n) => {
              let { key: t3, value: s } = n;
              return e.apiDescriptor.value({ [t3]: s });
            } };
          } }), JD = ee({ "node_modules/vnopts/lib/descriptors/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (Ct(), ft(yt));
            n.__exportStar(Pa(), e);
          } }), Ir = ee({ "scripts/build/shims/chalk.cjs"(e, n) {
            "use strict";
            re();
            var t3 = (s) => s;
            t3.grey = t3, t3.red = t3, t3.bold = t3, t3.yellow = t3, t3.blue = t3, t3.default = t3, n.exports = t3;
          } }), Ia = ee({ "node_modules/vnopts/lib/handlers/deprecated/common.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Ir();
            e.commonDeprecatedHandler = (t3, s, a) => {
              let { descriptor: r } = a, u = [`${n.default.yellow(typeof t3 == "string" ? r.key(t3) : r.pair(t3))} is deprecated`];
              return s && u.push(`we now treat it as ${n.default.blue(typeof s == "string" ? r.key(s) : r.pair(s))}`), u.join("; ") + ".";
            };
          } }), zD = ee({ "node_modules/vnopts/lib/handlers/deprecated/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (Ct(), ft(yt));
            n.__exportStar(Ia(), e);
          } }), XD = ee({ "node_modules/vnopts/lib/handlers/invalid/common.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Ir();
            e.commonInvalidHandler = (t3, s, a) => [`Invalid ${n.default.red(a.descriptor.key(t3))} value.`, `Expected ${n.default.blue(a.schemas[t3].expected(a))},`, `but received ${n.default.red(a.descriptor.value(s))}.`].join(" ");
          } }), ka = ee({ "node_modules/vnopts/lib/handlers/invalid/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (Ct(), ft(yt));
            n.__exportStar(XD(), e);
          } }), KD = ee({ "node_modules/vnopts/node_modules/leven/index.js"(e, n) {
            "use strict";
            re();
            var t3 = [], s = [];
            n.exports = function(a, r) {
              if (a === r)
                return 0;
              var u = a;
              a.length > r.length && (a = r, r = u);
              var i = a.length, l = r.length;
              if (i === 0)
                return l;
              if (l === 0)
                return i;
              for (; i > 0 && a.charCodeAt(~-i) === r.charCodeAt(~-l); )
                i--, l--;
              if (i === 0)
                return l;
              for (var c = 0; c < i && a.charCodeAt(c) === r.charCodeAt(c); )
                c++;
              if (i -= c, l -= c, i === 0)
                return l;
              for (var y, h, g, p, D = 0, v = 0; D < i; )
                s[c + D] = a.charCodeAt(c + D), t3[D] = ++D;
              for (; v < l; )
                for (y = r.charCodeAt(c + v), g = v++, h = v, D = 0; D < i; D++)
                  p = y === s[c + D] ? g : g + 1, g = t3[D], h = t3[D] = g > h ? p > h ? h + 1 : p : p > g ? g + 1 : p;
              return h;
            };
          } }), La = ee({ "node_modules/vnopts/lib/handlers/unknown/leven.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Ir(), t3 = KD();
            e.levenUnknownHandler = (s, a, r) => {
              let { descriptor: u, logger: i, schemas: l } = r, c = [`Ignored unknown option ${n.default.yellow(u.pair({ key: s, value: a }))}.`], y = Object.keys(l).sort().find((h) => t3(s, h) < 3);
              y && c.push(`Did you mean ${n.default.blue(u.key(y))}?`), i.warn(c.join(" "));
            };
          } }), YD = ee({ "node_modules/vnopts/lib/handlers/unknown/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (Ct(), ft(yt));
            n.__exportStar(La(), e);
          } }), QD = ee({ "node_modules/vnopts/lib/handlers/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (Ct(), ft(yt));
            n.__exportStar(zD(), e), n.__exportStar(ka(), e), n.__exportStar(YD(), e);
          } }), Et = ee({ "node_modules/vnopts/lib/schema.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = ["default", "expected", "validate", "deprecated", "forward", "redirect", "overlap", "preprocess", "postprocess"];
            function t3(r, u) {
              let i = new r(u), l = Object.create(i);
              for (let c of n)
                c in u && (l[c] = a(u[c], i, s.prototype[c].length));
              return l;
            }
            e.createSchema = t3;
            var s = class {
              constructor(r) {
                this.name = r.name;
              }
              static create(r) {
                return t3(this, r);
              }
              default(r) {
              }
              expected(r) {
                return "nothing";
              }
              validate(r, u) {
                return false;
              }
              deprecated(r, u) {
                return false;
              }
              forward(r, u) {
              }
              redirect(r, u) {
              }
              overlap(r, u, i) {
                return r;
              }
              preprocess(r, u) {
                return r;
              }
              postprocess(r, u) {
                return r;
              }
            };
            e.Schema = s;
            function a(r, u, i) {
              return typeof r == "function" ? function() {
                for (var l = arguments.length, c = new Array(l), y = 0; y < l; y++)
                  c[y] = arguments[y];
                return r(...c.slice(0, i - 1), u, ...c.slice(i - 1));
              } : () => r;
            }
          } }), ZD = ee({ "node_modules/vnopts/lib/schemas/alias.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Et(), t3 = class extends n.Schema {
              constructor(s) {
                super(s), this._sourceName = s.sourceName;
              }
              expected(s) {
                return s.schemas[this._sourceName].expected(s);
              }
              validate(s, a) {
                return a.schemas[this._sourceName].validate(s, a);
              }
              redirect(s, a) {
                return this._sourceName;
              }
            };
            e.AliasSchema = t3;
          } }), em = ee({ "node_modules/vnopts/lib/schemas/any.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Et(), t3 = class extends n.Schema {
              expected() {
                return "anything";
              }
              validate() {
                return true;
              }
            };
            e.AnySchema = t3;
          } }), tm = ee({ "node_modules/vnopts/lib/schemas/array.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (Ct(), ft(yt)), t3 = Et(), s = class extends t3.Schema {
              constructor(r) {
                var { valueSchema: u, name: i = u.name } = r, l = n.__rest(r, ["valueSchema", "name"]);
                super(Object.assign({}, l, { name: i })), this._valueSchema = u;
              }
              expected(r) {
                return `an array of ${this._valueSchema.expected(r)}`;
              }
              validate(r, u) {
                if (!Array.isArray(r))
                  return false;
                let i = [];
                for (let l of r) {
                  let c = u.normalizeValidateResult(this._valueSchema.validate(l, u), l);
                  c !== true && i.push(c.value);
                }
                return i.length === 0 ? true : { value: i };
              }
              deprecated(r, u) {
                let i = [];
                for (let l of r) {
                  let c = u.normalizeDeprecatedResult(this._valueSchema.deprecated(l, u), l);
                  c !== false && i.push(...c.map((y) => {
                    let { value: h } = y;
                    return { value: [h] };
                  }));
                }
                return i;
              }
              forward(r, u) {
                let i = [];
                for (let l of r) {
                  let c = u.normalizeForwardResult(this._valueSchema.forward(l, u), l);
                  i.push(...c.map(a));
                }
                return i;
              }
              redirect(r, u) {
                let i = [], l = [];
                for (let c of r) {
                  let y = u.normalizeRedirectResult(this._valueSchema.redirect(c, u), c);
                  "remain" in y && i.push(y.remain), l.push(...y.redirect.map(a));
                }
                return i.length === 0 ? { redirect: l } : { redirect: l, remain: i };
              }
              overlap(r, u) {
                return r.concat(u);
              }
            };
            e.ArraySchema = s;
            function a(r) {
              let { from: u, to: i } = r;
              return { from: [u], to: i };
            }
          } }), rm = ee({ "node_modules/vnopts/lib/schemas/boolean.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Et(), t3 = class extends n.Schema {
              expected() {
                return "true or false";
              }
              validate(s) {
                return typeof s == "boolean";
              }
            };
            e.BooleanSchema = t3;
          } }), Gn = ee({ "node_modules/vnopts/lib/utils.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            function n(p, D) {
              let v = /* @__PURE__ */ Object.create(null);
              for (let w of p) {
                let T = w[D];
                if (v[T])
                  throw new Error(`Duplicate ${D} ${JSON.stringify(T)}`);
                v[T] = w;
              }
              return v;
            }
            e.recordFromArray = n;
            function t3(p, D) {
              let v = /* @__PURE__ */ new Map();
              for (let w of p) {
                let T = w[D];
                if (v.has(T))
                  throw new Error(`Duplicate ${D} ${JSON.stringify(T)}`);
                v.set(T, w);
              }
              return v;
            }
            e.mapFromArray = t3;
            function s() {
              let p = /* @__PURE__ */ Object.create(null);
              return (D) => {
                let v = JSON.stringify(D);
                return p[v] ? true : (p[v] = true, false);
              };
            }
            e.createAutoChecklist = s;
            function a(p, D) {
              let v = [], w = [];
              for (let T of p)
                D(T) ? v.push(T) : w.push(T);
              return [v, w];
            }
            e.partition = a;
            function r(p) {
              return p === Math.floor(p);
            }
            e.isInt = r;
            function u(p, D) {
              if (p === D)
                return 0;
              let v = typeof p, w = typeof D, T = ["undefined", "object", "boolean", "number", "string"];
              return v !== w ? T.indexOf(v) - T.indexOf(w) : v !== "string" ? Number(p) - Number(D) : p.localeCompare(D);
            }
            e.comparePrimitive = u;
            function i(p) {
              return p === void 0 ? {} : p;
            }
            e.normalizeDefaultResult = i;
            function l(p, D) {
              return p === true ? true : p === false ? { value: D } : p;
            }
            e.normalizeValidateResult = l;
            function c(p, D) {
              let v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
              return p === false ? false : p === true ? v ? true : [{ value: D }] : "value" in p ? [p] : p.length === 0 ? false : p;
            }
            e.normalizeDeprecatedResult = c;
            function y(p, D) {
              return typeof p == "string" || "key" in p ? { from: D, to: p } : "from" in p ? { from: p.from, to: p.to } : { from: D, to: p.to };
            }
            e.normalizeTransferResult = y;
            function h(p, D) {
              return p === void 0 ? [] : Array.isArray(p) ? p.map((v) => y(v, D)) : [y(p, D)];
            }
            e.normalizeForwardResult = h;
            function g(p, D) {
              let v = h(typeof p == "object" && "redirect" in p ? p.redirect : p, D);
              return v.length === 0 ? { remain: D, redirect: v } : typeof p == "object" && "remain" in p ? { remain: p.remain, redirect: v } : { redirect: v };
            }
            e.normalizeRedirectResult = g;
          } }), nm2 = ee({ "node_modules/vnopts/lib/schemas/choice.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Et(), t3 = Gn(), s = class extends n.Schema {
              constructor(a) {
                super(a), this._choices = t3.mapFromArray(a.choices.map((r) => r && typeof r == "object" ? r : { value: r }), "value");
              }
              expected(a) {
                let { descriptor: r } = a, u = Array.from(this._choices.keys()).map((c) => this._choices.get(c)).filter((c) => !c.deprecated).map((c) => c.value).sort(t3.comparePrimitive).map(r.value), i = u.slice(0, -2), l = u.slice(-2);
                return i.concat(l.join(" or ")).join(", ");
              }
              validate(a) {
                return this._choices.has(a);
              }
              deprecated(a) {
                let r = this._choices.get(a);
                return r && r.deprecated ? { value: a } : false;
              }
              forward(a) {
                let r = this._choices.get(a);
                return r ? r.forward : void 0;
              }
              redirect(a) {
                let r = this._choices.get(a);
                return r ? r.redirect : void 0;
              }
            };
            e.ChoiceSchema = s;
          } }), ja = ee({ "node_modules/vnopts/lib/schemas/number.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Et(), t3 = class extends n.Schema {
              expected() {
                return "a number";
              }
              validate(s, a) {
                return typeof s == "number";
              }
            };
            e.NumberSchema = t3;
          } }), um = ee({ "node_modules/vnopts/lib/schemas/integer.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Gn(), t3 = ja(), s = class extends t3.NumberSchema {
              expected() {
                return "an integer";
              }
              validate(a, r) {
                return r.normalizeValidateResult(super.validate(a, r), a) === true && n.isInt(a);
              }
            };
            e.IntegerSchema = s;
          } }), sm = ee({ "node_modules/vnopts/lib/schemas/string.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Et(), t3 = class extends n.Schema {
              expected() {
                return "a string";
              }
              validate(s) {
                return typeof s == "string";
              }
            };
            e.StringSchema = t3;
          } }), im = ee({ "node_modules/vnopts/lib/schemas/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (Ct(), ft(yt));
            n.__exportStar(ZD(), e), n.__exportStar(em(), e), n.__exportStar(tm(), e), n.__exportStar(rm(), e), n.__exportStar(nm2(), e), n.__exportStar(um(), e), n.__exportStar(ja(), e), n.__exportStar(sm(), e);
          } }), am = ee({ "node_modules/vnopts/lib/defaults.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Pa(), t3 = Ia(), s = ka(), a = La();
            e.defaultDescriptor = n.apiDescriptor, e.defaultUnknownHandler = a.levenUnknownHandler, e.defaultInvalidHandler = s.commonInvalidHandler, e.defaultDeprecatedHandler = t3.commonDeprecatedHandler;
          } }), om = ee({ "node_modules/vnopts/lib/normalize.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = am(), t3 = Gn();
            e.normalize = (a, r, u) => new s(r, u).normalize(a);
            var s = class {
              constructor(a, r) {
                let { logger: u = console, descriptor: i = n.defaultDescriptor, unknown: l = n.defaultUnknownHandler, invalid: c = n.defaultInvalidHandler, deprecated: y = n.defaultDeprecatedHandler } = r || {};
                this._utils = { descriptor: i, logger: u || { warn: () => {
                } }, schemas: t3.recordFromArray(a, "name"), normalizeDefaultResult: t3.normalizeDefaultResult, normalizeDeprecatedResult: t3.normalizeDeprecatedResult, normalizeForwardResult: t3.normalizeForwardResult, normalizeRedirectResult: t3.normalizeRedirectResult, normalizeValidateResult: t3.normalizeValidateResult }, this._unknownHandler = l, this._invalidHandler = c, this._deprecatedHandler = y, this.cleanHistory();
              }
              cleanHistory() {
                this._hasDeprecationWarned = t3.createAutoChecklist();
              }
              normalize(a) {
                let r = {}, u = [a], i = () => {
                  for (; u.length !== 0; ) {
                    let l = u.shift(), c = this._applyNormalization(l, r);
                    u.push(...c);
                  }
                };
                i();
                for (let l of Object.keys(this._utils.schemas)) {
                  let c = this._utils.schemas[l];
                  if (!(l in r)) {
                    let y = t3.normalizeDefaultResult(c.default(this._utils));
                    "value" in y && u.push({ [l]: y.value });
                  }
                }
                i();
                for (let l of Object.keys(this._utils.schemas)) {
                  let c = this._utils.schemas[l];
                  l in r && (r[l] = c.postprocess(r[l], this._utils));
                }
                return r;
              }
              _applyNormalization(a, r) {
                let u = [], [i, l] = t3.partition(Object.keys(a), (c) => c in this._utils.schemas);
                for (let c of i) {
                  let y = this._utils.schemas[c], h = y.preprocess(a[c], this._utils), g = t3.normalizeValidateResult(y.validate(h, this._utils), h);
                  if (g !== true) {
                    let { value: T } = g, F = this._invalidHandler(c, T, this._utils);
                    throw typeof F == "string" ? new Error(F) : F;
                  }
                  let p = (T) => {
                    let { from: F, to: A } = T;
                    u.push(typeof A == "string" ? { [A]: F } : { [A.key]: A.value });
                  }, D = (T) => {
                    let { value: F, redirectTo: A } = T, B = t3.normalizeDeprecatedResult(y.deprecated(F, this._utils), h, true);
                    if (B !== false)
                      if (B === true)
                        this._hasDeprecationWarned(c) || this._utils.logger.warn(this._deprecatedHandler(c, A, this._utils));
                      else
                        for (let { value: I } of B) {
                          let P = { key: c, value: I };
                          if (!this._hasDeprecationWarned(P)) {
                            let R = typeof A == "string" ? { key: A, value: I } : A;
                            this._utils.logger.warn(this._deprecatedHandler(P, R, this._utils));
                          }
                        }
                  };
                  t3.normalizeForwardResult(y.forward(h, this._utils), h).forEach(p);
                  let w = t3.normalizeRedirectResult(y.redirect(h, this._utils), h);
                  if (w.redirect.forEach(p), "remain" in w) {
                    let T = w.remain;
                    r[c] = c in r ? y.overlap(r[c], T, this._utils) : T, D({ value: T });
                  }
                  for (let { from: T, to: F } of w.redirect)
                    D({ value: T, redirectTo: F });
                }
                for (let c of l) {
                  let y = a[c], h = this._unknownHandler(c, y, this._utils);
                  if (h)
                    for (let g of Object.keys(h)) {
                      let p = { [g]: h[g] };
                      g in this._utils.schemas ? u.push(p) : Object.assign(r, p);
                    }
                }
                return u;
              }
            };
            e.Normalizer = s;
          } }), lm = ee({ "node_modules/vnopts/lib/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (Ct(), ft(yt));
            n.__exportStar(JD(), e), n.__exportStar(QD(), e), n.__exportStar(im(), e), n.__exportStar(om(), e), n.__exportStar(Et(), e);
          } }), cm = ee({ "src/main/options-normalizer.js"(e, n) {
            "use strict";
            re();
            var t3 = lm(), s = lt2(), a = { key: (g) => g.length === 1 ? `-${g}` : `--${g}`, value: (g) => t3.apiDescriptor.value(g), pair: (g) => {
              let { key: p, value: D } = g;
              return D === false ? `--no-${p}` : D === true ? a.key(p) : D === "" ? `${a.key(p)} without an argument` : `${a.key(p)}=${D}`;
            } }, r = (g) => {
              let { colorsModule: p, levenshteinDistance: D } = g;
              return class extends t3.ChoiceSchema {
                constructor(w) {
                  let { name: T, flags: F } = w;
                  super({ name: T, choices: F }), this._flags = [...F].sort();
                }
                preprocess(w, T) {
                  if (typeof w == "string" && w.length > 0 && !this._flags.includes(w)) {
                    let F = this._flags.find((A) => D(A, w) < 3);
                    if (F)
                      return T.logger.warn([`Unknown flag ${p.yellow(T.descriptor.value(w))},`, `did you mean ${p.blue(T.descriptor.value(F))}?`].join(" ")), F;
                  }
                  return w;
                }
                expected() {
                  return "a flag";
                }
              };
            }, u;
            function i(g, p) {
              let { logger: D = false, isCLI: v = false, passThrough: w = false, colorsModule: T = null, levenshteinDistance: F = null } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, A = w ? Array.isArray(w) ? (x, m) => w.includes(x) ? { [x]: m } : void 0 : (x, m) => ({ [x]: m }) : (x, m, E) => {
                let o = E.schemas, { _: d } = o, C = Ln(o, Jf);
                return t3.levenUnknownHandler(x, m, Object.assign(Object.assign({}, E), {}, { schemas: C }));
              }, B = v ? a : t3.apiDescriptor, I = l(p, { isCLI: v, colorsModule: T, levenshteinDistance: F }), P = new t3.Normalizer(I, { logger: D, unknown: A, descriptor: B }), R = D !== false;
              R && u && (P._hasDeprecationWarned = u);
              let f = P.normalize(g);
              return R && (u = P._hasDeprecationWarned), v && f["plugin-search"] === false && (f["plugin-search-dir"] = false), f;
            }
            function l(g, p) {
              let { isCLI: D, colorsModule: v, levenshteinDistance: w } = p, T = [];
              D && T.push(t3.AnySchema.create({ name: "_" }));
              for (let F of g)
                T.push(c(F, { isCLI: D, optionInfos: g, colorsModule: v, levenshteinDistance: w })), F.alias && D && T.push(t3.AliasSchema.create({ name: F.alias, sourceName: F.name }));
              return T;
            }
            function c(g, p) {
              let { isCLI: D, optionInfos: v, colorsModule: w, levenshteinDistance: T } = p, { name: F } = g;
              if (F === "plugin-search-dir" || F === "pluginSearchDirs")
                return t3.AnySchema.create({ name: F, preprocess(P) {
                  return P === false || (P = Array.isArray(P) ? P : [P]), P;
                }, validate(P) {
                  return P === false ? true : P.every((R) => typeof R == "string");
                }, expected() {
                  return "false or paths to plugin search dir";
                } });
              let A = { name: F }, B, I = {};
              switch (g.type) {
                case "int":
                  B = t3.IntegerSchema, D && (A.preprocess = Number);
                  break;
                case "string":
                  B = t3.StringSchema;
                  break;
                case "choice":
                  B = t3.ChoiceSchema, A.choices = g.choices.map((P) => typeof P == "object" && P.redirect ? Object.assign(Object.assign({}, P), {}, { redirect: { to: { key: g.name, value: P.redirect } } }) : P);
                  break;
                case "boolean":
                  B = t3.BooleanSchema;
                  break;
                case "flag":
                  B = r({ colorsModule: w, levenshteinDistance: T }), A.flags = v.flatMap((P) => [P.alias, P.description && P.name, P.oppositeDescription && `no-${P.name}`].filter(Boolean));
                  break;
                case "path":
                  B = t3.StringSchema;
                  break;
                default:
                  throw new Error(`Unexpected type ${g.type}`);
              }
              if (g.exception ? A.validate = (P, R, f) => g.exception(P) || R.validate(P, f) : A.validate = (P, R, f) => P === void 0 || R.validate(P, f), g.redirect && (I.redirect = (P) => P ? { to: { key: g.redirect.option, value: g.redirect.value } } : void 0), g.deprecated && (I.deprecated = true), D && !g.array) {
                let P = A.preprocess || ((R) => R);
                A.preprocess = (R, f, x) => f.preprocess(P(Array.isArray(R) ? s(R) : R), x);
              }
              return g.array ? t3.ArraySchema.create(Object.assign(Object.assign(Object.assign({}, D ? { preprocess: (P) => Array.isArray(P) ? P : [P] } : {}), I), {}, { valueSchema: B.create(A) })) : B.create(Object.assign(Object.assign({}, A), I));
            }
            function y(g, p, D) {
              return i(g, p, D);
            }
            function h(g, p, D) {
              return i(g, p, Object.assign({ isCLI: true }, D));
            }
            n.exports = { normalizeApiOptions: y, normalizeCliOptions: h };
          } }), it = ee({ "src/language-js/loc.js"(e, n) {
            "use strict";
            re();
            var t3 = $n();
            function s(l) {
              var c, y;
              let h = l.range ? l.range[0] : l.start, g = (c = (y = l.declaration) === null || y === void 0 ? void 0 : y.decorators) !== null && c !== void 0 ? c : l.decorators;
              return t3(g) ? Math.min(s(g[0]), h) : h;
            }
            function a(l) {
              return l.range ? l.range[1] : l.end;
            }
            function r(l, c) {
              let y = s(l);
              return Number.isInteger(y) && y === s(c);
            }
            function u(l, c) {
              let y = a(l);
              return Number.isInteger(y) && y === a(c);
            }
            function i(l, c) {
              return r(l, c) && u(l, c);
            }
            n.exports = { locStart: s, locEnd: a, hasSameLocStart: r, hasSameLoc: i };
          } }), pm = ee({ "src/main/load-parser.js"(e, n) {
            re(), n.exports = () => {
            };
          } }), fm = ee({ "scripts/build/shims/babel-highlight.cjs"(e, n) {
            "use strict";
            re();
            var t3 = Ir(), s = { shouldHighlight: () => false, getChalk: () => t3 };
            n.exports = s;
          } }), Dm = ee({ "node_modules/@babel/code-frame/lib/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.codeFrameColumns = u, e.default = i;
            var n = fm(), t3 = false;
            function s(l) {
              return { gutter: l.grey, marker: l.red.bold, message: l.red.bold };
            }
            var a = /\r\n|[\n\r\u2028\u2029]/;
            function r(l, c, y) {
              let h = Object.assign({ column: 0, line: -1 }, l.start), g = Object.assign({}, h, l.end), { linesAbove: p = 2, linesBelow: D = 3 } = y || {}, v = h.line, w = h.column, T = g.line, F = g.column, A = Math.max(v - (p + 1), 0), B = Math.min(c.length, T + D);
              v === -1 && (A = 0), T === -1 && (B = c.length);
              let I = T - v, P = {};
              if (I)
                for (let R = 0; R <= I; R++) {
                  let f = R + v;
                  if (!w)
                    P[f] = true;
                  else if (R === 0) {
                    let x = c[f - 1].length;
                    P[f] = [w, x - w + 1];
                  } else if (R === I)
                    P[f] = [0, F];
                  else {
                    let x = c[f - R].length;
                    P[f] = [0, x];
                  }
                }
              else
                w === F ? w ? P[v] = [w, 0] : P[v] = true : P[v] = [w, F - w];
              return { start: A, end: B, markerLines: P };
            }
            function u(l, c) {
              let y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h = (y.highlightCode || y.forceColor) && (0, n.shouldHighlight)(y), g = (0, n.getChalk)(y), p = s(g), D = (R, f) => h ? R(f) : f, v = l.split(a), { start: w, end: T, markerLines: F } = r(c, v, y), A = c.start && typeof c.start.column == "number", B = String(T).length, P = (h ? (0, n.default)(l, y) : l).split(a, T).slice(w, T).map((R, f) => {
                let x = w + 1 + f, E = ` ${` ${x}`.slice(-B)} |`, o = F[x], d = !F[x + 1];
                if (o) {
                  let C = "";
                  if (Array.isArray(o)) {
                    let _ = R.slice(0, Math.max(o[0] - 1, 0)).replace(/[^\t]/g, " "), b = o[1] || 1;
                    C = [`
 `, D(p.gutter, E.replace(/\d/g, " ")), " ", _, D(p.marker, "^").repeat(b)].join(""), d && y.message && (C += " " + D(p.message, y.message));
                  }
                  return [D(p.marker, ">"), D(p.gutter, E), R.length > 0 ? ` ${R}` : "", C].join("");
                } else
                  return ` ${D(p.gutter, E)}${R.length > 0 ? ` ${R}` : ""}`;
              }).join(`
`);
              return y.message && !A && (P = `${" ".repeat(B + 1)}${y.message}
${P}`), h ? g.reset(P) : P;
            }
            function i(l, c, y) {
              let h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
              if (!t3) {
                t3 = true;
                let p = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
                if (Nt.emitWarning)
                  Nt.emitWarning(p, "DeprecationWarning");
                else {
                  let D = new Error(p);
                  D.name = "DeprecationWarning", console.warn(new Error(p));
                }
              }
              return y = Math.max(y, 0), u(l, { start: { column: y, line: c } }, h);
            }
          } }), Un = ee({ "src/main/parser.js"(e, n) {
            "use strict";
            re();
            var { ConfigError: t3 } = Kt(), s = it(), a = pm(), { locStart: r, locEnd: u } = s, i = Object.getOwnPropertyNames, l = Object.getOwnPropertyDescriptor;
            function c(g) {
              let p = {};
              for (let D of g.plugins)
                if (!!D.parsers)
                  for (let v of i(D.parsers))
                    Object.defineProperty(p, v, l(D.parsers, v));
              return p;
            }
            function y(g) {
              let p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c(g);
              if (typeof g.parser == "function")
                return { parse: g.parser, astFormat: "estree", locStart: r, locEnd: u };
              if (typeof g.parser == "string") {
                if (Object.prototype.hasOwnProperty.call(p, g.parser))
                  return p[g.parser];
                throw new t3(`Couldn't resolve parser "${g.parser}". Parsers must be explicitly added to the standalone bundle.`);
              }
            }
            function h(g, p) {
              let D = c(p), v = Object.defineProperties({}, Object.fromEntries(Object.keys(D).map((T) => [T, { enumerable: true, get() {
                return D[T].parse;
              } }]))), w = y(p, D);
              try {
                return w.preprocess && (g = w.preprocess(g, p)), { text: g, ast: w.parse(g, v, p) };
              } catch (T) {
                let { loc: F } = T;
                if (F) {
                  let { codeFrameColumns: A } = Dm();
                  throw T.codeFrame = A(g, F, { highlightCode: true }), T.message += `
` + T.codeFrame, T;
                }
                throw T;
              }
            }
            n.exports = { parse: h, resolveParser: y };
          } }), Oa = ee({ "src/main/options.js"(e, n) {
            "use strict";
            re();
            var t3 = TD(), { UndefinedParserError: s } = Kt(), { getSupportInfo: a } = Rn(), r = cm(), { resolveParser: u } = Un(), i = { astFormat: "estree", printer: {}, originalText: void 0, locStart: null, locEnd: null };
            function l(h) {
              let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p = Object.assign({}, h), D = a({ plugins: h.plugins, showUnreleased: true, showDeprecated: true }).options, v = Object.assign(Object.assign({}, i), Object.fromEntries(D.filter((B) => B.default !== void 0).map((B) => [B.name, B.default])));
              if (!p.parser) {
                if (!p.filepath)
                  (g.logger || console).warn("No parser and no filepath given, using 'babel' the parser now but this will throw an error in the future. Please specify a parser or a filepath so one can be inferred."), p.parser = "babel";
                else if (p.parser = y(p.filepath, p.plugins), !p.parser)
                  throw new s(`No parser could be inferred for file: ${p.filepath}`);
              }
              let w = u(r.normalizeApiOptions(p, [D.find((B) => B.name === "parser")], { passThrough: true, logger: false }));
              p.astFormat = w.astFormat, p.locEnd = w.locEnd, p.locStart = w.locStart;
              let T = c(p);
              p.printer = T.printers[p.astFormat];
              let F = Object.fromEntries(D.filter((B) => B.pluginDefaults && B.pluginDefaults[T.name] !== void 0).map((B) => [B.name, B.pluginDefaults[T.name]])), A = Object.assign(Object.assign({}, v), F);
              for (let [B, I] of Object.entries(A))
                (p[B] === null || p[B] === void 0) && (p[B] = I);
              return p.parser === "json" && (p.trailingComma = "none"), r.normalizeApiOptions(p, D, Object.assign({ passThrough: Object.keys(i) }, g));
            }
            function c(h) {
              let { astFormat: g } = h;
              if (!g)
                throw new Error("getPlugin() requires astFormat to be set");
              let p = h.plugins.find((D) => D.printers && D.printers[g]);
              if (!p)
                throw new Error(`Couldn't find plugin for AST format "${g}"`);
              return p;
            }
            function y(h, g) {
              let p = t3.basename(h).toLowerCase(), v = a({ plugins: g }).languages.filter((w) => w.since !== null).find((w) => w.extensions && w.extensions.some((T) => p.endsWith(T)) || w.filenames && w.filenames.some((T) => T.toLowerCase() === p));
              return v && v.parsers[0];
            }
            n.exports = { normalize: l, hiddenDefaults: i, inferParser: y };
          } }), mm = ee({ "src/main/massage-ast.js"(e, n) {
            "use strict";
            re();
            function t3(s, a, r) {
              if (Array.isArray(s))
                return s.map((c) => t3(c, a, r)).filter(Boolean);
              if (!s || typeof s != "object")
                return s;
              let u = a.printer.massageAstNode, i;
              u && u.ignoredProperties ? i = u.ignoredProperties : i = /* @__PURE__ */ new Set();
              let l = {};
              for (let [c, y] of Object.entries(s))
                !i.has(c) && typeof y != "function" && (l[c] = t3(y, a, s));
              if (u) {
                let c = u(s, l, r);
                if (c === null)
                  return;
                if (c)
                  return c;
              }
              return l;
            }
            n.exports = t3;
          } }), Yt = ee({ "scripts/build/shims/assert.cjs"(e, n) {
            "use strict";
            re();
            var t3 = () => {
            };
            t3.ok = t3, t3.strictEqual = t3, n.exports = t3;
          } }), et = ee({ "src/main/comments.js"(e, n) {
            "use strict";
            re();
            var t3 = Yt(), { builders: { line: s, hardline: a, breakParent: r, indent: u, lineSuffix: i, join: l, cursor: c } } = qe(), { hasNewline: y, skipNewline: h, skipSpaces: g, isPreviousLineEmpty: p, addLeadingComment: D, addDanglingComment: v, addTrailingComment: w } = Ge(), T = /* @__PURE__ */ new WeakMap();
            function F(k, $, M) {
              if (!k)
                return;
              let { printer: q, locStart: J, locEnd: L } = $;
              if (M) {
                if (q.canAttachComment && q.canAttachComment(k)) {
                  let V;
                  for (V = M.length - 1; V >= 0 && !(J(M[V]) <= J(k) && L(M[V]) <= L(k)); --V)
                    ;
                  M.splice(V + 1, 0, k);
                  return;
                }
              } else if (T.has(k))
                return T.get(k);
              let Y = q.getCommentChildNodes && q.getCommentChildNodes(k, $) || typeof k == "object" && Object.entries(k).filter((V) => {
                let [O] = V;
                return O !== "enclosingNode" && O !== "precedingNode" && O !== "followingNode" && O !== "tokens" && O !== "comments" && O !== "parent";
              }).map((V) => {
                let [, O] = V;
                return O;
              });
              if (!!Y) {
                M || (M = [], T.set(k, M));
                for (let V of Y)
                  F(V, $, M);
                return M;
              }
            }
            function A(k, $, M, q) {
              let { locStart: J, locEnd: L } = M, Y = J($), V = L($), O = F(k, M), K, se, Q = 0, le = O.length;
              for (; Q < le; ) {
                let W = Q + le >> 1, X = O[W], oe = J(X), ae = L(X);
                if (oe <= Y && V <= ae)
                  return A(X, $, M, X);
                if (ae <= Y) {
                  K = X, Q = W + 1;
                  continue;
                }
                if (V <= oe) {
                  se = X, le = W;
                  continue;
                }
                throw new Error("Comment location overlaps with node location");
              }
              if (q && q.type === "TemplateLiteral") {
                let { quasis: W } = q, X = E(W, $, M);
                K && E(W, K, M) !== X && (K = null), se && E(W, se, M) !== X && (se = null);
              }
              return { enclosingNode: q, precedingNode: K, followingNode: se };
            }
            var B = () => false;
            function I(k, $, M, q) {
              if (!Array.isArray(k))
                return;
              let J = [], { locStart: L, locEnd: Y, printer: { handleComments: V = {} } } = q, { avoidAstMutation: O, ownLine: K = B, endOfLine: se = B, remaining: Q = B } = V, le = k.map((W, X) => Object.assign(Object.assign({}, A($, W, q)), {}, { comment: W, text: M, options: q, ast: $, isLastComment: k.length - 1 === X }));
              for (let [W, X] of le.entries()) {
                let { comment: oe, precedingNode: ae, enclosingNode: Ae, followingNode: z, text: H, options: Z, ast: ne, isLastComment: fe } = X;
                if (Z.parser === "json" || Z.parser === "json5" || Z.parser === "__js_expression" || Z.parser === "__vue_expression" || Z.parser === "__vue_ts_expression") {
                  if (L(oe) - L(ne) <= 0) {
                    D(ne, oe);
                    continue;
                  }
                  if (Y(oe) - Y(ne) >= 0) {
                    w(ne, oe);
                    continue;
                  }
                }
                let ge;
                if (O ? ge = [X] : (oe.enclosingNode = Ae, oe.precedingNode = ae, oe.followingNode = z, ge = [oe, H, Z, ne, fe]), R(H, Z, le, W))
                  oe.placement = "ownLine", K(...ge) || (z ? D(z, oe) : ae ? w(ae, oe) : v(Ae || ne, oe));
                else if (f(H, Z, le, W))
                  oe.placement = "endOfLine", se(...ge) || (ae ? w(ae, oe) : z ? D(z, oe) : v(Ae || ne, oe));
                else if (oe.placement = "remaining", !Q(...ge))
                  if (ae && z) {
                    let Ce = J.length;
                    Ce > 0 && J[Ce - 1].followingNode !== z && x(J, H, Z), J.push(X);
                  } else
                    ae ? w(ae, oe) : z ? D(z, oe) : v(Ae || ne, oe);
              }
              if (x(J, M, q), !O)
                for (let W of k)
                  delete W.precedingNode, delete W.enclosingNode, delete W.followingNode;
            }
            var P = (k) => !/[\S\n\u2028\u2029]/.test(k);
            function R(k, $, M, q) {
              let { comment: J, precedingNode: L } = M[q], { locStart: Y, locEnd: V } = $, O = Y(J);
              if (L)
                for (let K = q - 1; K >= 0; K--) {
                  let { comment: se, precedingNode: Q } = M[K];
                  if (Q !== L || !P(k.slice(V(se), O)))
                    break;
                  O = Y(se);
                }
              return y(k, O, { backwards: true });
            }
            function f(k, $, M, q) {
              let { comment: J, followingNode: L } = M[q], { locStart: Y, locEnd: V } = $, O = V(J);
              if (L)
                for (let K = q + 1; K < M.length; K++) {
                  let { comment: se, followingNode: Q } = M[K];
                  if (Q !== L || !P(k.slice(O, Y(se))))
                    break;
                  O = V(se);
                }
              return y(k, O);
            }
            function x(k, $, M) {
              let q = k.length;
              if (q === 0)
                return;
              let { precedingNode: J, followingNode: L, enclosingNode: Y } = k[0], V = M.printer.getGapRegex && M.printer.getGapRegex(Y) || /^[\s(]*$/, O = M.locStart(L), K;
              for (K = q; K > 0; --K) {
                let { comment: se, precedingNode: Q, followingNode: le } = k[K - 1];
                t3.strictEqual(Q, J), t3.strictEqual(le, L);
                let W = $.slice(M.locEnd(se), O);
                if (V.test(W))
                  O = M.locStart(se);
                else
                  break;
              }
              for (let [se, { comment: Q }] of k.entries())
                se < K ? w(J, Q) : D(L, Q);
              for (let se of [J, L])
                se.comments && se.comments.length > 1 && se.comments.sort((Q, le) => M.locStart(Q) - M.locStart(le));
              k.length = 0;
            }
            function m(k, $) {
              let M = k.getValue();
              return M.printed = true, $.printer.printComment(k, $);
            }
            function E(k, $, M) {
              let q = M.locStart($) - 1;
              for (let J = 1; J < k.length; ++J)
                if (q < M.locStart(k[J]))
                  return J - 1;
              return 0;
            }
            function o(k, $) {
              let M = k.getValue(), q = [m(k, $)], { printer: J, originalText: L, locStart: Y, locEnd: V } = $;
              if (J.isBlockComment && J.isBlockComment(M)) {
                let se = y(L, V(M)) ? y(L, Y(M), { backwards: true }) ? a : s : " ";
                q.push(se);
              } else
                q.push(a);
              let K = h(L, g(L, V(M)));
              return K !== false && y(L, K) && q.push(a), q;
            }
            function d(k, $) {
              let M = k.getValue(), q = m(k, $), { printer: J, originalText: L, locStart: Y } = $, V = J.isBlockComment && J.isBlockComment(M);
              if (y(L, Y(M), { backwards: true })) {
                let K = p(L, M, Y);
                return i([a, K ? a : "", q]);
              }
              let O = [" ", q];
              return V || (O = [i(O), r]), O;
            }
            function C(k, $, M, q) {
              let J = [], L = k.getValue();
              return !L || !L.comments || (k.each(() => {
                let Y = k.getValue();
                !Y.leading && !Y.trailing && (!q || q(Y)) && J.push(m(k, $));
              }, "comments"), J.length === 0) ? "" : M ? l(a, J) : u([a, l(a, J)]);
            }
            function _(k, $, M) {
              let q = k.getValue();
              if (!q)
                return {};
              let J = q.comments || [];
              M && (J = J.filter((O) => !M.has(O)));
              let L = q === $.cursorNode;
              if (J.length === 0) {
                let O = L ? c : "";
                return { leading: O, trailing: O };
              }
              let Y = [], V = [];
              return k.each(() => {
                let O = k.getValue();
                if (M && M.has(O))
                  return;
                let { leading: K, trailing: se } = O;
                K ? Y.push(o(k, $)) : se && V.push(d(k, $));
              }, "comments"), L && (Y.unshift(c), V.push(c)), { leading: Y, trailing: V };
            }
            function b(k, $, M, q) {
              let { leading: J, trailing: L } = _(k, M, q);
              return !J && !L ? $ : [J, $, L];
            }
            function N(k) {
              if (!!k)
                for (let $ of k) {
                  if (!$.printed)
                    throw new Error('Comment "' + $.value.trim() + '" was not printed. Please report this error!');
                  delete $.printed;
                }
            }
            n.exports = { attach: I, printComments: b, printCommentsSeparately: _, printDanglingComments: C, getSortedChildNodes: F, ensureAllCommentsPrinted: N };
          } }), dm = ee({ "src/common/ast-path.js"(e, n) {
            "use strict";
            re();
            var t3 = lt2();
            function s(u, i) {
              let l = a(u.stack, i);
              return l === -1 ? null : u.stack[l];
            }
            function a(u, i) {
              for (let l = u.length - 1; l >= 0; l -= 2) {
                let c = u[l];
                if (c && !Array.isArray(c) && --i < 0)
                  return l;
              }
              return -1;
            }
            var r = class {
              constructor(u) {
                this.stack = [u];
              }
              getName() {
                let { stack: u } = this, { length: i } = u;
                return i > 1 ? u[i - 2] : null;
              }
              getValue() {
                return t3(this.stack);
              }
              getNode() {
                let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return s(this, u);
              }
              getParentNode() {
                let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return s(this, u + 1);
              }
              call(u) {
                let { stack: i } = this, { length: l } = i, c = t3(i);
                for (var y = arguments.length, h = new Array(y > 1 ? y - 1 : 0), g = 1; g < y; g++)
                  h[g - 1] = arguments[g];
                for (let D of h)
                  c = c[D], i.push(D, c);
                let p = u(this);
                return i.length = l, p;
              }
              callParent(u) {
                let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, l = a(this.stack, i + 1), c = this.stack.splice(l + 1), y = u(this);
                return this.stack.push(...c), y;
              }
              each(u) {
                let { stack: i } = this, { length: l } = i, c = t3(i);
                for (var y = arguments.length, h = new Array(y > 1 ? y - 1 : 0), g = 1; g < y; g++)
                  h[g - 1] = arguments[g];
                for (let p of h)
                  c = c[p], i.push(p, c);
                for (let p = 0; p < c.length; ++p)
                  i.push(p, c[p]), u(this, p, c), i.length -= 2;
                i.length = l;
              }
              map(u) {
                let i = [];
                for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), y = 1; y < l; y++)
                  c[y - 1] = arguments[y];
                return this.each((h, g, p) => {
                  i[g] = u(h, g, p);
                }, ...c), i;
              }
              try(u) {
                let { stack: i } = this, l = [...i];
                try {
                  return u();
                } finally {
                  i.length = 0, i.push(...l);
                }
              }
              match() {
                let u = this.stack.length - 1, i = null, l = this.stack[u--];
                for (var c = arguments.length, y = new Array(c), h = 0; h < c; h++)
                  y[h] = arguments[h];
                for (let g of y) {
                  if (l === void 0)
                    return false;
                  let p = null;
                  if (typeof i == "number" && (p = i, i = this.stack[u--], l = this.stack[u--]), g && !g(l, i, p))
                    return false;
                  i = this.stack[u--], l = this.stack[u--];
                }
                return true;
              }
              findAncestor(u) {
                let i = this.stack.length - 1, l = null, c = this.stack[i--];
                for (; c; ) {
                  let y = null;
                  if (typeof l == "number" && (y = l, l = this.stack[i--], c = this.stack[i--]), l !== null && u(c, l, y))
                    return c;
                  l = this.stack[i--], c = this.stack[i--];
                }
              }
            };
            n.exports = r;
          } }), gm = ee({ "src/main/multiparser.js"(e, n) {
            "use strict";
            re();
            var { utils: { stripTrailingHardline: t3 } } = qe(), { normalize: s } = Oa(), a = et();
            function r(i, l, c, y) {
              if (c.printer.embed && c.embeddedLanguageFormatting === "auto")
                return c.printer.embed(i, l, (h, g, p) => u(h, g, c, y, p), c);
            }
            function u(i, l, c, y) {
              let { stripTrailingHardline: h = false } = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, g = s(Object.assign(Object.assign(Object.assign({}, c), l), {}, { parentParser: c.parser, originalText: i }), { passThrough: true }), p = Un().parse(i, g), { ast: D } = p;
              i = p.text;
              let v = D.comments;
              delete D.comments, a.attach(v, D, i, g), g[Symbol.for("comments")] = v || [], g[Symbol.for("tokens")] = D.tokens || [];
              let w = y(D, g);
              return a.ensureAllCommentsPrinted(v), h ? typeof w == "string" ? w.replace(/(?:\r?\n)*$/, "") : t3(w) : w;
            }
            n.exports = { printSubtree: r };
          } }), ym = ee({ "src/main/ast-to-doc.js"(e, n) {
            "use strict";
            re();
            var t3 = dm(), { builders: { hardline: s, addAlignmentToDoc: a }, utils: { propagateBreaks: r } } = qe(), { printComments: u } = et(), i = gm();
            function l(h, g) {
              let p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, { printer: D } = g;
              D.preprocess && (h = D.preprocess(h, g));
              let v = /* @__PURE__ */ new Map(), w = new t3(h), T = F();
              return p > 0 && (T = a([s, T], p, g.tabWidth)), r(T), T;
              function F(B, I) {
                return B === void 0 || B === w ? A(I) : Array.isArray(B) ? w.call(() => A(I), ...B) : w.call(() => A(I), B);
              }
              function A(B) {
                let I = w.getValue(), P = I && typeof I == "object" && B === void 0;
                if (P && v.has(I))
                  return v.get(I);
                let R = y(w, g, F, B);
                return P && v.set(I, R), R;
              }
            }
            function c(h, g) {
              let { originalText: p, [Symbol.for("comments")]: D, locStart: v, locEnd: w } = g, T = v(h), F = w(h), A = /* @__PURE__ */ new Set();
              for (let B of D)
                v(B) >= T && w(B) <= F && (B.printed = true, A.add(B));
              return { doc: p.slice(T, F), printedComments: A };
            }
            function y(h, g, p, D) {
              let v = h.getValue(), { printer: w } = g, T, F;
              if (w.hasPrettierIgnore && w.hasPrettierIgnore(h))
                ({ doc: T, printedComments: F } = c(v, g));
              else {
                if (v)
                  try {
                    T = i.printSubtree(h, p, g, l);
                  } catch (A) {
                    if (globalThis.PRETTIER_DEBUG)
                      throw A;
                  }
                T || (T = w.print(h, g, p, D));
              }
              return (!w.willPrintOwnComments || !w.willPrintOwnComments(h, g)) && (T = u(h, T, g, F)), T;
            }
            n.exports = l;
          } }), hm = ee({ "src/main/range-util.js"(e, n) {
            "use strict";
            re();
            var t3 = Yt(), s = et(), a = (D) => {
              let { parser: v } = D;
              return v === "json" || v === "json5" || v === "json-stringify";
            };
            function r(D, v) {
              let w = [D.node, ...D.parentNodes], T = /* @__PURE__ */ new Set([v.node, ...v.parentNodes]);
              return w.find((F) => y.has(F.type) && T.has(F));
            }
            function u(D) {
              let v = D.length - 1;
              for (; ; ) {
                let w = D[v];
                if (w && (w.type === "Program" || w.type === "File"))
                  v--;
                else
                  break;
              }
              return D.slice(0, v + 1);
            }
            function i(D, v, w) {
              let { locStart: T, locEnd: F } = w, A = D.node, B = v.node;
              if (A === B)
                return { startNode: A, endNode: B };
              let I = T(D.node);
              for (let R of u(v.parentNodes))
                if (T(R) >= I)
                  B = R;
                else
                  break;
              let P = F(v.node);
              for (let R of u(D.parentNodes)) {
                if (F(R) <= P)
                  A = R;
                else
                  break;
                if (A === B)
                  break;
              }
              return { startNode: A, endNode: B };
            }
            function l(D, v, w, T) {
              let F = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], A = arguments.length > 5 ? arguments[5] : void 0, { locStart: B, locEnd: I } = w, P = B(D), R = I(D);
              if (!(v > R || v < P || A === "rangeEnd" && v === P || A === "rangeStart" && v === R)) {
                for (let f of s.getSortedChildNodes(D, w)) {
                  let x = l(f, v, w, T, [D, ...F], A);
                  if (x)
                    return x;
                }
                if (!T || T(D, F[0]))
                  return { node: D, parentNodes: F };
              }
            }
            function c(D, v) {
              return v !== "DeclareExportDeclaration" && D !== "TypeParameterDeclaration" && (D === "Directive" || D === "TypeAlias" || D === "TSExportAssignment" || D.startsWith("Declare") || D.startsWith("TSDeclare") || D.endsWith("Statement") || D.endsWith("Declaration"));
            }
            var y = /* @__PURE__ */ new Set(["ObjectExpression", "ArrayExpression", "StringLiteral", "NumericLiteral", "BooleanLiteral", "NullLiteral", "UnaryExpression", "TemplateLiteral"]), h = /* @__PURE__ */ new Set(["OperationDefinition", "FragmentDefinition", "VariableDefinition", "TypeExtensionDefinition", "ObjectTypeDefinition", "FieldDefinition", "DirectiveDefinition", "EnumTypeDefinition", "EnumValueDefinition", "InputValueDefinition", "InputObjectTypeDefinition", "SchemaDefinition", "OperationTypeDefinition", "InterfaceTypeDefinition", "UnionTypeDefinition", "ScalarTypeDefinition"]);
            function g(D, v, w) {
              if (!v)
                return false;
              switch (D.parser) {
                case "flow":
                case "babel":
                case "babel-flow":
                case "babel-ts":
                case "typescript":
                case "acorn":
                case "espree":
                case "meriyah":
                case "__babel_estree":
                  return c(v.type, w && w.type);
                case "json":
                case "json5":
                case "json-stringify":
                  return y.has(v.type);
                case "graphql":
                  return h.has(v.kind);
                case "vue":
                  return v.tag !== "root";
              }
              return false;
            }
            function p(D, v, w) {
              let { rangeStart: T, rangeEnd: F, locStart: A, locEnd: B } = v;
              t3.ok(F > T);
              let I = D.slice(T, F).search(/\S/), P = I === -1;
              if (!P)
                for (T += I; F > T && !/\S/.test(D[F - 1]); --F)
                  ;
              let R = l(w, T, v, (E, o) => g(v, E, o), [], "rangeStart"), f = P ? R : l(w, F, v, (E) => g(v, E), [], "rangeEnd");
              if (!R || !f)
                return { rangeStart: 0, rangeEnd: 0 };
              let x, m;
              if (a(v)) {
                let E = r(R, f);
                x = E, m = E;
              } else
                ({ startNode: x, endNode: m } = i(R, f, v));
              return { rangeStart: Math.min(A(x), A(m)), rangeEnd: Math.max(B(x), B(m)) };
            }
            n.exports = { calculateRange: p, findNodeAtOffset: l };
          } }), vm = ee({ "src/main/core.js"(e, n) {
            "use strict";
            re();
            var { diffArrays: t3 } = rD(), { printer: { printDocToString: s }, debug: { printDocToDebug: a } } = qe(), { getAlignmentSize: r } = Ge(), { guessEndOfLine: u, convertEndOfLineToChars: i, countEndOfLineChars: l, normalizeEndOfLine: c } = qn(), y = Oa().normalize, h = mm(), g = et(), p = Un(), D = ym(), v = hm(), w = "\uFEFF", T = Symbol("cursor");
            function F(m, E, o) {
              let d = E.comments;
              return d && (delete E.comments, g.attach(d, E, m, o)), o[Symbol.for("comments")] = d || [], o[Symbol.for("tokens")] = E.tokens || [], o.originalText = m, d;
            }
            function A(m, E) {
              let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
              if (!m || m.trim().length === 0)
                return { formatted: "", cursorOffset: -1, comments: [] };
              let { ast: d, text: C } = p.parse(m, E);
              if (E.cursorOffset >= 0) {
                let k = v.findNodeAtOffset(d, E.cursorOffset, E);
                k && k.node && (E.cursorNode = k.node);
              }
              let _ = F(C, d, E), b = D(d, E, o), N = s(b, E);
              if (g.ensureAllCommentsPrinted(_), o > 0) {
                let k = N.formatted.trim();
                N.cursorNodeStart !== void 0 && (N.cursorNodeStart -= N.formatted.indexOf(k)), N.formatted = k + i(E.endOfLine);
              }
              if (E.cursorOffset >= 0) {
                let k, $, M, q, J;
                if (E.cursorNode && N.cursorNodeText ? (k = E.locStart(E.cursorNode), $ = C.slice(k, E.locEnd(E.cursorNode)), M = E.cursorOffset - k, q = N.cursorNodeStart, J = N.cursorNodeText) : (k = 0, $ = C, M = E.cursorOffset, q = 0, J = N.formatted), $ === J)
                  return { formatted: N.formatted, cursorOffset: q + M, comments: _ };
                let L = [...$];
                L.splice(M, 0, T);
                let Y = [...J], V = t3(L, Y), O = q;
                for (let K of V)
                  if (K.removed) {
                    if (K.value.includes(T))
                      break;
                  } else
                    O += K.count;
                return { formatted: N.formatted, cursorOffset: O, comments: _ };
              }
              return { formatted: N.formatted, cursorOffset: -1, comments: _ };
            }
            function B(m, E) {
              let { ast: o, text: d } = p.parse(m, E), { rangeStart: C, rangeEnd: _ } = v.calculateRange(d, E, o), b = d.slice(C, _), N = Math.min(C, d.lastIndexOf(`
`, C) + 1), k = d.slice(N, C).match(/^\s*/)[0], $ = r(k, E.tabWidth), M = A(b, Object.assign(Object.assign({}, E), {}, { rangeStart: 0, rangeEnd: Number.POSITIVE_INFINITY, cursorOffset: E.cursorOffset > C && E.cursorOffset <= _ ? E.cursorOffset - C : -1, endOfLine: "lf" }), $), q = M.formatted.trimEnd(), { cursorOffset: J } = E;
              J > _ ? J += q.length - b.length : M.cursorOffset >= 0 && (J = M.cursorOffset + C);
              let L = d.slice(0, C) + q + d.slice(_);
              if (E.endOfLine !== "lf") {
                let Y = i(E.endOfLine);
                J >= 0 && Y === `\r
` && (J += l(L.slice(0, J), `
`)), L = L.replace(/\n/g, Y);
              }
              return { formatted: L, cursorOffset: J, comments: M.comments };
            }
            function I(m, E, o) {
              return typeof E != "number" || Number.isNaN(E) || E < 0 || E > m.length ? o : E;
            }
            function P(m, E) {
              let { cursorOffset: o, rangeStart: d, rangeEnd: C } = E;
              return o = I(m, o, -1), d = I(m, d, 0), C = I(m, C, m.length), Object.assign(Object.assign({}, E), {}, { cursorOffset: o, rangeStart: d, rangeEnd: C });
            }
            function R(m, E) {
              let { cursorOffset: o, rangeStart: d, rangeEnd: C, endOfLine: _ } = P(m, E), b = m.charAt(0) === w;
              if (b && (m = m.slice(1), o--, d--, C--), _ === "auto" && (_ = u(m)), m.includes("\r")) {
                let N = (k) => l(m.slice(0, Math.max(k, 0)), `\r
`);
                o -= N(o), d -= N(d), C -= N(C), m = c(m);
              }
              return { hasBOM: b, text: m, options: P(m, Object.assign(Object.assign({}, E), {}, { cursorOffset: o, rangeStart: d, rangeEnd: C, endOfLine: _ })) };
            }
            function f(m, E) {
              let o = p.resolveParser(E);
              return !o.hasPragma || o.hasPragma(m);
            }
            function x(m, E) {
              let { hasBOM: o, text: d, options: C } = R(m, y(E));
              if (C.rangeStart >= C.rangeEnd && d !== "" || C.requirePragma && !f(d, C))
                return { formatted: m, cursorOffset: E.cursorOffset, comments: [] };
              let _;
              return C.rangeStart > 0 || C.rangeEnd < d.length ? _ = B(d, C) : (!C.requirePragma && C.insertPragma && C.printer.insertPragma && !f(d, C) && (d = C.printer.insertPragma(d)), _ = A(d, C)), o && (_.formatted = w + _.formatted, _.cursorOffset >= 0 && _.cursorOffset++), _;
            }
            n.exports = { formatWithCursor: x, parse(m, E, o) {
              let { text: d, options: C } = R(m, y(E)), _ = p.parse(d, C);
              return o && (_.ast = h(_.ast, C)), _;
            }, formatAST(m, E) {
              E = y(E);
              let o = D(m, E);
              return s(o, E);
            }, formatDoc(m, E) {
              return x(a(m), Object.assign(Object.assign({}, E), {}, { parser: "__js_expression" })).formatted;
            }, printToDoc(m, E) {
              E = y(E);
              let { ast: o, text: d } = p.parse(m, E);
              return F(d, o, E), D(o, E);
            }, printDocToString(m, E) {
              return s(m, y(E));
            } };
          } }), Cm = ee({ "src/common/util-shared.js"(e, n) {
            "use strict";
            re();
            var { getMaxContinuousCount: t3, getStringWidth: s, getAlignmentSize: a, getIndentSize: r, skip: u, skipWhitespace: i, skipSpaces: l, skipNewline: c, skipToLineEnd: y, skipEverythingButNewLine: h, skipInlineComment: g, skipTrailingComment: p, hasNewline: D, hasNewlineInRange: v, hasSpaces: w, isNextLineEmpty: T, isNextLineEmptyAfterIndex: F, isPreviousLineEmpty: A, getNextNonSpaceNonCommentCharacterIndex: B, makeString: I, addLeadingComment: P, addDanglingComment: R, addTrailingComment: f } = Ge();
            n.exports = { getMaxContinuousCount: t3, getStringWidth: s, getAlignmentSize: a, getIndentSize: r, skip: u, skipWhitespace: i, skipSpaces: l, skipNewline: c, skipToLineEnd: y, skipEverythingButNewLine: h, skipInlineComment: g, skipTrailingComment: p, hasNewline: D, hasNewlineInRange: v, hasSpaces: w, isNextLineEmpty: T, isNextLineEmptyAfterIndex: F, isPreviousLineEmpty: A, getNextNonSpaceNonCommentCharacterIndex: B, makeString: I, addLeadingComment: P, addDanglingComment: R, addTrailingComment: f };
          } }), wt = ee({ "src/utils/create-language.js"(e, n) {
            "use strict";
            re(), n.exports = function(t3, s) {
              let { languageId: a } = t3, r = Ln(t3, zf);
              return Object.assign(Object.assign({ linguistLanguageId: a }, r), s(t3));
            };
          } }), Em = ee({ "node_modules/esutils/lib/ast.js"(e, n) {
            re(), function() {
              "use strict";
              function t3(l) {
                if (l == null)
                  return false;
                switch (l.type) {
                  case "ArrayExpression":
                  case "AssignmentExpression":
                  case "BinaryExpression":
                  case "CallExpression":
                  case "ConditionalExpression":
                  case "FunctionExpression":
                  case "Identifier":
                  case "Literal":
                  case "LogicalExpression":
                  case "MemberExpression":
                  case "NewExpression":
                  case "ObjectExpression":
                  case "SequenceExpression":
                  case "ThisExpression":
                  case "UnaryExpression":
                  case "UpdateExpression":
                    return true;
                }
                return false;
              }
              function s(l) {
                if (l == null)
                  return false;
                switch (l.type) {
                  case "DoWhileStatement":
                  case "ForInStatement":
                  case "ForStatement":
                  case "WhileStatement":
                    return true;
                }
                return false;
              }
              function a(l) {
                if (l == null)
                  return false;
                switch (l.type) {
                  case "BlockStatement":
                  case "BreakStatement":
                  case "ContinueStatement":
                  case "DebuggerStatement":
                  case "DoWhileStatement":
                  case "EmptyStatement":
                  case "ExpressionStatement":
                  case "ForInStatement":
                  case "ForStatement":
                  case "IfStatement":
                  case "LabeledStatement":
                  case "ReturnStatement":
                  case "SwitchStatement":
                  case "ThrowStatement":
                  case "TryStatement":
                  case "VariableDeclaration":
                  case "WhileStatement":
                  case "WithStatement":
                    return true;
                }
                return false;
              }
              function r(l) {
                return a(l) || l != null && l.type === "FunctionDeclaration";
              }
              function u(l) {
                switch (l.type) {
                  case "IfStatement":
                    return l.alternate != null ? l.alternate : l.consequent;
                  case "LabeledStatement":
                  case "ForStatement":
                  case "ForInStatement":
                  case "WhileStatement":
                  case "WithStatement":
                    return l.body;
                }
                return null;
              }
              function i(l) {
                var c;
                if (l.type !== "IfStatement" || l.alternate == null)
                  return false;
                c = l.consequent;
                do {
                  if (c.type === "IfStatement" && c.alternate == null)
                    return true;
                  c = u(c);
                } while (c);
                return false;
              }
              n.exports = { isExpression: t3, isStatement: a, isIterationStatement: s, isSourceElement: r, isProblematicIfStatement: i, trailingStatement: u };
            }();
          } }), qa = ee({ "node_modules/esutils/lib/code.js"(e, n) {
            re(), function() {
              "use strict";
              var t3, s, a, r, u, i;
              s = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/, NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/ }, t3 = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/, NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/ };
              function l(F) {
                return 48 <= F && F <= 57;
              }
              function c(F) {
                return 48 <= F && F <= 57 || 97 <= F && F <= 102 || 65 <= F && F <= 70;
              }
              function y(F) {
                return F >= 48 && F <= 55;
              }
              a = [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279];
              function h(F) {
                return F === 32 || F === 9 || F === 11 || F === 12 || F === 160 || F >= 5760 && a.indexOf(F) >= 0;
              }
              function g(F) {
                return F === 10 || F === 13 || F === 8232 || F === 8233;
              }
              function p(F) {
                if (F <= 65535)
                  return String.fromCharCode(F);
                var A = String.fromCharCode(Math.floor((F - 65536) / 1024) + 55296), B = String.fromCharCode((F - 65536) % 1024 + 56320);
                return A + B;
              }
              for (r = new Array(128), i = 0; i < 128; ++i)
                r[i] = i >= 97 && i <= 122 || i >= 65 && i <= 90 || i === 36 || i === 95;
              for (u = new Array(128), i = 0; i < 128; ++i)
                u[i] = i >= 97 && i <= 122 || i >= 65 && i <= 90 || i >= 48 && i <= 57 || i === 36 || i === 95;
              function D(F) {
                return F < 128 ? r[F] : s.NonAsciiIdentifierStart.test(p(F));
              }
              function v(F) {
                return F < 128 ? u[F] : s.NonAsciiIdentifierPart.test(p(F));
              }
              function w(F) {
                return F < 128 ? r[F] : t3.NonAsciiIdentifierStart.test(p(F));
              }
              function T(F) {
                return F < 128 ? u[F] : t3.NonAsciiIdentifierPart.test(p(F));
              }
              n.exports = { isDecimalDigit: l, isHexDigit: c, isOctalDigit: y, isWhiteSpace: h, isLineTerminator: g, isIdentifierStartES5: D, isIdentifierPartES5: v, isIdentifierStartES6: w, isIdentifierPartES6: T };
            }();
          } }), Fm = ee({ "node_modules/esutils/lib/keyword.js"(e, n) {
            re(), function() {
              "use strict";
              var t3 = qa();
              function s(D) {
                switch (D) {
                  case "implements":
                  case "interface":
                  case "package":
                  case "private":
                  case "protected":
                  case "public":
                  case "static":
                  case "let":
                    return true;
                  default:
                    return false;
                }
              }
              function a(D, v) {
                return !v && D === "yield" ? false : r(D, v);
              }
              function r(D, v) {
                if (v && s(D))
                  return true;
                switch (D.length) {
                  case 2:
                    return D === "if" || D === "in" || D === "do";
                  case 3:
                    return D === "var" || D === "for" || D === "new" || D === "try";
                  case 4:
                    return D === "this" || D === "else" || D === "case" || D === "void" || D === "with" || D === "enum";
                  case 5:
                    return D === "while" || D === "break" || D === "catch" || D === "throw" || D === "const" || D === "yield" || D === "class" || D === "super";
                  case 6:
                    return D === "return" || D === "typeof" || D === "delete" || D === "switch" || D === "export" || D === "import";
                  case 7:
                    return D === "default" || D === "finally" || D === "extends";
                  case 8:
                    return D === "function" || D === "continue" || D === "debugger";
                  case 10:
                    return D === "instanceof";
                  default:
                    return false;
                }
              }
              function u(D, v) {
                return D === "null" || D === "true" || D === "false" || a(D, v);
              }
              function i(D, v) {
                return D === "null" || D === "true" || D === "false" || r(D, v);
              }
              function l(D) {
                return D === "eval" || D === "arguments";
              }
              function c(D) {
                var v, w, T;
                if (D.length === 0 || (T = D.charCodeAt(0), !t3.isIdentifierStartES5(T)))
                  return false;
                for (v = 1, w = D.length; v < w; ++v)
                  if (T = D.charCodeAt(v), !t3.isIdentifierPartES5(T))
                    return false;
                return true;
              }
              function y(D, v) {
                return (D - 55296) * 1024 + (v - 56320) + 65536;
              }
              function h(D) {
                var v, w, T, F, A;
                if (D.length === 0)
                  return false;
                for (A = t3.isIdentifierStartES6, v = 0, w = D.length; v < w; ++v) {
                  if (T = D.charCodeAt(v), 55296 <= T && T <= 56319) {
                    if (++v, v >= w || (F = D.charCodeAt(v), !(56320 <= F && F <= 57343)))
                      return false;
                    T = y(T, F);
                  }
                  if (!A(T))
                    return false;
                  A = t3.isIdentifierPartES6;
                }
                return true;
              }
              function g(D, v) {
                return c(D) && !u(D, v);
              }
              function p(D, v) {
                return h(D) && !i(D, v);
              }
              n.exports = { isKeywordES5: a, isKeywordES6: r, isReservedWordES5: u, isReservedWordES6: i, isRestrictedWord: l, isIdentifierNameES5: c, isIdentifierNameES6: h, isIdentifierES5: g, isIdentifierES6: p };
            }();
          } }), Am = ee({ "node_modules/esutils/lib/utils.js"(e) {
            re(), function() {
              "use strict";
              e.ast = Em(), e.code = qa(), e.keyword = Fm();
            }();
          } }), Lt = ee({ "src/language-js/utils/is-block-comment.js"(e, n) {
            "use strict";
            re();
            var t3 = /* @__PURE__ */ new Set(["Block", "CommentBlock", "MultiLine"]), s = (a) => t3.has(a == null ? void 0 : a.type);
            n.exports = s;
          } }), Sm = ee({ "src/language-js/utils/is-node-matches.js"(e, n) {
            "use strict";
            re();
            function t3(a, r) {
              let u = r.split(".");
              for (let i = u.length - 1; i >= 0; i--) {
                let l = u[i];
                if (i === 0)
                  return a.type === "Identifier" && a.name === l;
                if (a.type !== "MemberExpression" || a.optional || a.computed || a.property.type !== "Identifier" || a.property.name !== l)
                  return false;
                a = a.object;
              }
            }
            function s(a, r) {
              return r.some((u) => t3(a, u));
            }
            n.exports = s;
          } }), Ke = ee({ "src/language-js/utils/index.js"(e, n) {
            "use strict";
            re();
            var t3 = Am().keyword.isIdentifierNameES5, { getLast: s, hasNewline: a, skipWhitespace: r, isNonEmptyArray: u, isNextLineEmptyAfterIndex: i, getStringWidth: l } = Ge(), { locStart: c, locEnd: y, hasSameLocStart: h } = it(), g = Lt(), p = Sm(), D = "(?:(?=.)\\s)", v = new RegExp(`^${D}*:`), w = new RegExp(`^${D}*::`);
            function T(j) {
              var me, Ie;
              return ((me = j.extra) === null || me === void 0 ? void 0 : me.parenthesized) && g((Ie = j.trailingComments) === null || Ie === void 0 ? void 0 : Ie[0]) && v.test(j.trailingComments[0].value);
            }
            function F(j) {
              let me = j == null ? void 0 : j[0];
              return g(me) && w.test(me.value);
            }
            function A(j, me) {
              if (!j || typeof j != "object")
                return false;
              if (Array.isArray(j))
                return j.some((je) => A(je, me));
              let Ie = me(j);
              return typeof Ie == "boolean" ? Ie : Object.values(j).some((je) => A(je, me));
            }
            function B(j) {
              return j.type === "AssignmentExpression" || j.type === "BinaryExpression" || j.type === "LogicalExpression" || j.type === "NGPipeExpression" || j.type === "ConditionalExpression" || oe(j) || ae(j) || j.type === "SequenceExpression" || j.type === "TaggedTemplateExpression" || j.type === "BindExpression" || j.type === "UpdateExpression" && !j.prefix || nt(j) || j.type === "TSNonNullExpression";
            }
            function I(j) {
              var me, Ie, je, Ye, ut, ze;
              return j.expressions ? j.expressions[0] : (me = (Ie = (je = (Ye = (ut = (ze = j.left) !== null && ze !== void 0 ? ze : j.test) !== null && ut !== void 0 ? ut : j.callee) !== null && Ye !== void 0 ? Ye : j.object) !== null && je !== void 0 ? je : j.tag) !== null && Ie !== void 0 ? Ie : j.argument) !== null && me !== void 0 ? me : j.expression;
            }
            function P(j, me) {
              if (me.expressions)
                return ["expressions", 0];
              if (me.left)
                return ["left"];
              if (me.test)
                return ["test"];
              if (me.object)
                return ["object"];
              if (me.callee)
                return ["callee"];
              if (me.tag)
                return ["tag"];
              if (me.argument)
                return ["argument"];
              if (me.expression)
                return ["expression"];
              throw new Error("Unexpected node has no left side.");
            }
            function R(j) {
              return j = new Set(j), (me) => j.has(me == null ? void 0 : me.type);
            }
            var f = R(["Line", "CommentLine", "SingleLine", "HashbangComment", "HTMLOpen", "HTMLClose"]), x = R(["ExportDefaultDeclaration", "ExportDefaultSpecifier", "DeclareExportDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration"]);
            function m(j) {
              let me = j.getParentNode();
              return j.getName() === "declaration" && x(me) ? me : null;
            }
            var E = R(["BooleanLiteral", "DirectiveLiteral", "Literal", "NullLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "RegExpLiteral", "StringLiteral", "TemplateLiteral", "TSTypeLiteral", "JSXText"]);
            function o(j) {
              return j.type === "NumericLiteral" || j.type === "Literal" && typeof j.value == "number";
            }
            function d(j) {
              return j.type === "UnaryExpression" && (j.operator === "+" || j.operator === "-") && o(j.argument);
            }
            function C(j) {
              return j.type === "StringLiteral" || j.type === "Literal" && typeof j.value == "string";
            }
            var _ = R(["ObjectTypeAnnotation", "TSTypeLiteral", "TSMappedType"]), b = R(["FunctionExpression", "ArrowFunctionExpression"]);
            function N(j) {
              return j.type === "FunctionExpression" || j.type === "ArrowFunctionExpression" && j.body.type === "BlockStatement";
            }
            function k(j) {
              return oe(j) && j.callee.type === "Identifier" && ["async", "inject", "fakeAsync", "waitForAsync"].includes(j.callee.name);
            }
            var $ = R(["JSXElement", "JSXFragment"]);
            function M(j, me) {
              if (j.parentParser !== "markdown" && j.parentParser !== "mdx")
                return false;
              let Ie = me.getNode();
              if (!Ie.expression || !$(Ie.expression))
                return false;
              let je = me.getParentNode();
              return je.type === "Program" && je.body.length === 1;
            }
            function q(j) {
              return j.kind === "get" || j.kind === "set";
            }
            function J(j) {
              return q(j) || h(j, j.value);
            }
            function L(j) {
              return (j.type === "ObjectTypeProperty" || j.type === "ObjectTypeInternalSlot") && j.value.type === "FunctionTypeAnnotation" && !j.static && !J(j);
            }
            function Y(j) {
              return (j.type === "TypeAnnotation" || j.type === "TSTypeAnnotation") && j.typeAnnotation.type === "FunctionTypeAnnotation" && !j.static && !h(j, j.typeAnnotation);
            }
            var V = R(["BinaryExpression", "LogicalExpression", "NGPipeExpression"]);
            function O(j) {
              return ae(j) || j.type === "BindExpression" && Boolean(j.object);
            }
            var K = /* @__PURE__ */ new Set(["AnyTypeAnnotation", "TSAnyKeyword", "NullLiteralTypeAnnotation", "TSNullKeyword", "ThisTypeAnnotation", "TSThisType", "NumberTypeAnnotation", "TSNumberKeyword", "VoidTypeAnnotation", "TSVoidKeyword", "BooleanTypeAnnotation", "TSBooleanKeyword", "BigIntTypeAnnotation", "TSBigIntKeyword", "SymbolTypeAnnotation", "TSSymbolKeyword", "StringTypeAnnotation", "TSStringKeyword", "BooleanLiteralTypeAnnotation", "StringLiteralTypeAnnotation", "BigIntLiteralTypeAnnotation", "NumberLiteralTypeAnnotation", "TSLiteralType", "TSTemplateLiteralType", "EmptyTypeAnnotation", "MixedTypeAnnotation", "TSNeverKeyword", "TSObjectKeyword", "TSUndefinedKeyword", "TSUnknownKeyword"]);
            function se(j) {
              return j ? !!((j.type === "GenericTypeAnnotation" || j.type === "TSTypeReference") && !j.typeParameters || K.has(j.type)) : false;
            }
            function Q(j) {
              let me = /^(?:before|after)(?:Each|All)$/;
              return j.callee.type === "Identifier" && me.test(j.callee.name) && j.arguments.length === 1;
            }
            var le = ["it", "it.only", "it.skip", "describe", "describe.only", "describe.skip", "test", "test.only", "test.skip", "test.step", "test.describe", "test.describe.only", "test.describe.parallel", "test.describe.parallel.only", "test.describe.serial", "test.describe.serial.only", "skip", "xit", "xdescribe", "xtest", "fit", "fdescribe", "ftest"];
            function W(j) {
              return p(j, le);
            }
            function X(j, me) {
              if (j.type !== "CallExpression")
                return false;
              if (j.arguments.length === 1) {
                if (k(j) && me && X(me))
                  return b(j.arguments[0]);
                if (Q(j))
                  return k(j.arguments[0]);
              } else if ((j.arguments.length === 2 || j.arguments.length === 3) && (j.arguments[0].type === "TemplateLiteral" || C(j.arguments[0])) && W(j.callee))
                return j.arguments[2] && !o(j.arguments[2]) ? false : (j.arguments.length === 2 ? b(j.arguments[1]) : N(j.arguments[1]) && Fe(j.arguments[1]).length <= 1) || k(j.arguments[1]);
              return false;
            }
            var oe = R(["CallExpression", "OptionalCallExpression"]), ae = R(["MemberExpression", "OptionalMemberExpression"]);
            function Ae(j) {
              let me = "expressions";
              j.type === "TSTemplateLiteralType" && (me = "types");
              let Ie = j[me];
              return Ie.length === 0 ? false : Ie.every((je) => {
                if (ue(je))
                  return false;
                if (je.type === "Identifier" || je.type === "ThisExpression")
                  return true;
                if (ae(je)) {
                  let Ye = je;
                  for (; ae(Ye); )
                    if (Ye.property.type !== "Identifier" && Ye.property.type !== "Literal" && Ye.property.type !== "StringLiteral" && Ye.property.type !== "NumericLiteral" || (Ye = Ye.object, ue(Ye)))
                      return false;
                  return Ye.type === "Identifier" || Ye.type === "ThisExpression";
                }
                return false;
              });
            }
            function z(j, me) {
              return j === "+" || j === "-" ? j + me : me;
            }
            function H(j, me) {
              let Ie = c(me), je = r(j, y(me));
              return je !== false && j.slice(Ie, Ie + 2) === "/*" && j.slice(je, je + 2) === "*/";
            }
            function Z(j, me) {
              return $(me) ? Ve(me) : ue(me, ke.Leading, (Ie) => a(j, y(Ie)));
            }
            function ne(j, me) {
              return me.parser !== "json" && C(j.key) && ce(j.key).slice(1, -1) === j.key.value && (t3(j.key.value) && !(me.parser === "babel-ts" && j.type === "ClassProperty" || me.parser === "typescript" && j.type === "PropertyDefinition") || fe(j.key.value) && String(Number(j.key.value)) === j.key.value && (me.parser === "babel" || me.parser === "acorn" || me.parser === "espree" || me.parser === "meriyah" || me.parser === "__babel_estree"));
            }
            function fe(j) {
              return /^(?:\d+|\d+\.\d+)$/.test(j);
            }
            function ge(j, me) {
              let Ie = /^[fx]?(?:describe|it|test)$/;
              return me.type === "TaggedTemplateExpression" && me.quasi === j && me.tag.type === "MemberExpression" && me.tag.property.type === "Identifier" && me.tag.property.name === "each" && (me.tag.object.type === "Identifier" && Ie.test(me.tag.object.name) || me.tag.object.type === "MemberExpression" && me.tag.object.property.type === "Identifier" && (me.tag.object.property.name === "only" || me.tag.object.property.name === "skip") && me.tag.object.object.type === "Identifier" && Ie.test(me.tag.object.object.name));
            }
            function Ce(j) {
              return j.quasis.some((me) => me.value.raw.includes(`
`));
            }
            function _e(j, me) {
              return (j.type === "TemplateLiteral" && Ce(j) || j.type === "TaggedTemplateExpression" && Ce(j.quasi)) && !a(me, c(j), { backwards: true });
            }
            function Oe(j) {
              if (!ue(j))
                return false;
              let me = s(st(j, ke.Dangling));
              return me && !g(me);
            }
            function pe(j) {
              if (j.length <= 1)
                return false;
              let me = 0;
              for (let Ie of j)
                if (b(Ie)) {
                  if (me += 1, me > 1)
                    return true;
                } else if (oe(Ie)) {
                  for (let je of Ie.arguments)
                    if (b(je))
                      return true;
                }
              return false;
            }
            function ie(j) {
              let me = j.getValue(), Ie = j.getParentNode();
              return oe(me) && oe(Ie) && Ie.callee === me && me.arguments.length > Ie.arguments.length && Ie.arguments.length > 0;
            }
            function ve(j, me) {
              if (me >= 2)
                return false;
              let Ie = (ze) => ve(ze, me + 1), je = j.type === "Literal" && "regex" in j && j.regex.pattern || j.type === "RegExpLiteral" && j.pattern;
              if (je && l(je) > 5)
                return false;
              if (j.type === "Literal" || j.type === "BigIntLiteral" || j.type === "DecimalLiteral" || j.type === "BooleanLiteral" || j.type === "NullLiteral" || j.type === "NumericLiteral" || j.type === "RegExpLiteral" || j.type === "StringLiteral" || j.type === "Identifier" || j.type === "ThisExpression" || j.type === "Super" || j.type === "PrivateName" || j.type === "PrivateIdentifier" || j.type === "ArgumentPlaceholder" || j.type === "Import")
                return true;
              if (j.type === "TemplateLiteral")
                return j.quasis.every((ze) => !ze.value.raw.includes(`
`)) && j.expressions.every(Ie);
              if (j.type === "ObjectExpression")
                return j.properties.every((ze) => !ze.computed && (ze.shorthand || ze.value && Ie(ze.value)));
              if (j.type === "ArrayExpression")
                return j.elements.every((ze) => ze === null || Ie(ze));
              if (He(j))
                return (j.type === "ImportExpression" || ve(j.callee, me)) && Je(j).every(Ie);
              if (ae(j))
                return ve(j.object, me) && ve(j.property, me);
              let Ye = { "!": true, "-": true, "+": true, "~": true };
              if (j.type === "UnaryExpression" && Ye[j.operator])
                return ve(j.argument, me);
              let ut = { "++": true, "--": true };
              return j.type === "UpdateExpression" && ut[j.operator] ? ve(j.argument, me) : j.type === "TSNonNullExpression" ? ve(j.expression, me) : false;
            }
            function ce(j) {
              var me, Ie;
              return (me = (Ie = j.extra) === null || Ie === void 0 ? void 0 : Ie.raw) !== null && me !== void 0 ? me : j.raw;
            }
            function U(j) {
              return j;
            }
            function de(j) {
              return j.filepath && /\.tsx$/i.test(j.filepath);
            }
            function De(j) {
              let me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "es5";
              return j.trailingComma === "es5" && me === "es5" || j.trailingComma === "all" && (me === "all" || me === "es5");
            }
            function he(j, me) {
              switch (j = Ee(j), j.type) {
                case "FunctionExpression":
                case "ClassExpression":
                case "DoExpression":
                  return me;
                case "ObjectExpression":
                  return true;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return he(j.object, me);
                case "TaggedTemplateExpression":
                  return j.tag.type === "FunctionExpression" ? false : he(j.tag, me);
                case "CallExpression":
                case "OptionalCallExpression":
                  return j.callee.type === "FunctionExpression" ? false : he(j.callee, me);
                case "ConditionalExpression":
                  return he(j.test, me);
                case "UpdateExpression":
                  return !j.prefix && he(j.argument, me);
                case "BindExpression":
                  return j.object && he(j.object, me);
                case "SequenceExpression":
                  return he(j.expressions[0], me);
                case "TSSatisfiesExpression":
                case "TSAsExpression":
                case "TSNonNullExpression":
                  return he(j.expression, me);
                default:
                  return false;
              }
            }
            var Be = { "==": true, "!=": true, "===": true, "!==": true }, Se = { "*": true, "/": true, "%": true }, ye = { ">>": true, ">>>": true, "<<": true };
            function S(j, me) {
              return !(te(me) !== te(j) || j === "**" || Be[j] && Be[me] || me === "%" && Se[j] || j === "%" && Se[me] || me !== j && Se[me] && Se[j] || ye[j] && ye[me]);
            }
            var G = new Map([["|>"], ["??"], ["||"], ["&&"], ["|"], ["^"], ["&"], ["==", "===", "!=", "!=="], ["<", ">", "<=", ">=", "in", "instanceof"], [">>", "<<", ">>>"], ["+", "-"], ["*", "/", "%"], ["**"]].flatMap((j, me) => j.map((Ie) => [Ie, me])));
            function te(j) {
              return G.get(j);
            }
            function Ee(j) {
              for (; j.left; )
                j = j.left;
              return j;
            }
            function Re(j) {
              return Boolean(ye[j]) || j === "|" || j === "^" || j === "&";
            }
            function Te(j) {
              var me;
              if (j.rest)
                return true;
              let Ie = Fe(j);
              return ((me = s(Ie)) === null || me === void 0 ? void 0 : me.type) === "RestElement";
            }
            var Pe = /* @__PURE__ */ new WeakMap();
            function Fe(j) {
              if (Pe.has(j))
                return Pe.get(j);
              let me = [];
              return j.this && me.push(j.this), Array.isArray(j.parameters) ? me.push(...j.parameters) : Array.isArray(j.params) && me.push(...j.params), j.rest && me.push(j.rest), Pe.set(j, me), me;
            }
            function Ze(j, me) {
              let Ie = j.getValue(), je = 0, Ye = (ut) => me(ut, je++);
              Ie.this && j.call(Ye, "this"), Array.isArray(Ie.parameters) ? j.each(Ye, "parameters") : Array.isArray(Ie.params) && j.each(Ye, "params"), Ie.rest && j.call(Ye, "rest");
            }
            var xe = /* @__PURE__ */ new WeakMap();
            function Je(j) {
              if (xe.has(j))
                return xe.get(j);
              let me = j.arguments;
              return j.type === "ImportExpression" && (me = [j.source], j.attributes && me.push(j.attributes)), xe.set(j, me), me;
            }
            function we(j, me) {
              let Ie = j.getValue();
              Ie.type === "ImportExpression" ? (j.call((je) => me(je, 0), "source"), Ie.attributes && j.call((je) => me(je, 1), "attributes")) : j.each(me, "arguments");
            }
            function Le(j) {
              return j.value.trim() === "prettier-ignore" && !j.unignore;
            }
            function Ve(j) {
              return j && (j.prettierIgnore || ue(j, ke.PrettierIgnore));
            }
            function be(j) {
              let me = j.getValue();
              return Ve(me);
            }
            var ke = { Leading: 1 << 1, Trailing: 1 << 2, Dangling: 1 << 3, Block: 1 << 4, Line: 1 << 5, PrettierIgnore: 1 << 6, First: 1 << 7, Last: 1 << 8 }, Me = (j, me) => {
              if (typeof j == "function" && (me = j, j = 0), j || me)
                return (Ie, je, Ye) => !(j & ke.Leading && !Ie.leading || j & ke.Trailing && !Ie.trailing || j & ke.Dangling && (Ie.leading || Ie.trailing) || j & ke.Block && !g(Ie) || j & ke.Line && !f(Ie) || j & ke.First && je !== 0 || j & ke.Last && je !== Ye.length - 1 || j & ke.PrettierIgnore && !Le(Ie) || me && !me(Ie));
            };
            function ue(j, me, Ie) {
              if (!u(j == null ? void 0 : j.comments))
                return false;
              let je = Me(me, Ie);
              return je ? j.comments.some(je) : true;
            }
            function st(j, me, Ie) {
              if (!Array.isArray(j == null ? void 0 : j.comments))
                return [];
              let je = Me(me, Ie);
              return je ? j.comments.filter(je) : j.comments;
            }
            var rt = (j, me) => {
              let { originalText: Ie } = me;
              return i(Ie, y(j));
            };
            function He(j) {
              return oe(j) || j.type === "NewExpression" || j.type === "ImportExpression";
            }
            function Ue(j) {
              return j && (j.type === "ObjectProperty" || j.type === "Property" && !j.method && j.kind === "init");
            }
            function Xe(j) {
              return Boolean(j.__isUsingHackPipeline);
            }
            var at2 = Symbol("ifWithoutBlockAndSameLineComment");
            function nt(j) {
              return j.type === "TSAsExpression" || j.type === "TSSatisfiesExpression";
            }
            n.exports = { getFunctionParameters: Fe, iterateFunctionParametersPath: Ze, getCallArguments: Je, iterateCallArgumentsPath: we, hasRestParameter: Te, getLeftSide: I, getLeftSidePathName: P, getParentExportDeclaration: m, getTypeScriptMappedTypeModifier: z, hasFlowAnnotationComment: F, hasFlowShorthandAnnotationComment: T, hasLeadingOwnLineComment: Z, hasNakedLeftSide: B, hasNode: A, hasIgnoreComment: be, hasNodeIgnoreComment: Ve, identity: U, isBinaryish: V, isCallLikeExpression: He, isEnabledHackPipeline: Xe, isLineComment: f, isPrettierIgnoreComment: Le, isCallExpression: oe, isMemberExpression: ae, isExportDeclaration: x, isFlowAnnotationComment: H, isFunctionCompositionArgs: pe, isFunctionNotation: J, isFunctionOrArrowExpression: b, isGetterOrSetter: q, isJestEachTemplateLiteral: ge, isJsxNode: $, isLiteral: E, isLongCurriedCallExpression: ie, isSimpleCallArgument: ve, isMemberish: O, isNumericLiteral: o, isSignedNumericLiteral: d, isObjectProperty: Ue, isObjectType: _, isObjectTypePropertyAFunction: L, isSimpleType: se, isSimpleNumber: fe, isSimpleTemplateLiteral: Ae, isStringLiteral: C, isStringPropSafeToUnquote: ne, isTemplateOnItsOwnLine: _e, isTestCall: X, isTheOnlyJsxElementInMarkdown: M, isTSXFile: de, isTypeAnnotationAFunction: Y, isNextLineEmpty: rt, needsHardlineAfterDanglingComment: Oe, rawText: ce, shouldPrintComma: De, isBitwiseOperator: Re, shouldFlatten: S, startsWithNoLookaheadToken: he, getPrecedence: te, hasComment: ue, getComments: st, CommentCheckFlags: ke, markerForIfWithoutBlockAndSameLineComment: at2, isTSTypeExpression: nt };
          } }), jt = ee({ "src/language-js/print/template-literal.js"(e, n) {
            "use strict";
            re();
            var t3 = lt2(), { getStringWidth: s, getIndentSize: a } = Ge(), { builders: { join: r, hardline: u, softline: i, group: l, indent: c, align: y, lineSuffixBoundary: h, addAlignmentToDoc: g }, printer: { printDocToString: p }, utils: { mapDoc: D } } = qe(), { isBinaryish: v, isJestEachTemplateLiteral: w, isSimpleTemplateLiteral: T, hasComment: F, isMemberExpression: A, isTSTypeExpression: B } = Ke();
            function I(E, o, d) {
              let C = E.getValue();
              if (C.type === "TemplateLiteral" && w(C, E.getParentNode())) {
                let M = P(E, d, o);
                if (M)
                  return M;
              }
              let b = "expressions";
              C.type === "TSTemplateLiteralType" && (b = "types");
              let N = [], k = E.map(o, b), $ = T(C);
              return $ && (k = k.map((M) => p(M, Object.assign(Object.assign({}, d), {}, { printWidth: Number.POSITIVE_INFINITY })).formatted)), N.push(h, "`"), E.each((M) => {
                let q = M.getName();
                if (N.push(o()), q < k.length) {
                  let { tabWidth: J } = d, L = M.getValue(), Y = a(L.value.raw, J), V = k[q];
                  if (!$) {
                    let K = C[b][q];
                    (F(K) || A(K) || K.type === "ConditionalExpression" || K.type === "SequenceExpression" || B(K) || v(K)) && (V = [c([i, V]), i]);
                  }
                  let O = Y === 0 && L.value.raw.endsWith(`
`) ? y(Number.NEGATIVE_INFINITY, V) : g(V, Y, J);
                  N.push(l(["${", O, h, "}"]));
                }
              }, "quasis"), N.push("`"), N;
            }
            function P(E, o, d) {
              let C = E.getNode(), _ = C.quasis[0].value.raw.trim().split(/\s*\|\s*/);
              if (_.length > 1 || _.some((b) => b.length > 0)) {
                o.__inJestEach = true;
                let b = E.map(d, "expressions");
                o.__inJestEach = false;
                let N = [], k = b.map((L) => "${" + p(L, Object.assign(Object.assign({}, o), {}, { printWidth: Number.POSITIVE_INFINITY, endOfLine: "lf" })).formatted + "}"), $ = [{ hasLineBreak: false, cells: [] }];
                for (let L = 1; L < C.quasis.length; L++) {
                  let Y = t3($), V = k[L - 1];
                  Y.cells.push(V), V.includes(`
`) && (Y.hasLineBreak = true), C.quasis[L].value.raw.includes(`
`) && $.push({ hasLineBreak: false, cells: [] });
                }
                let M = Math.max(_.length, ...$.map((L) => L.cells.length)), q = Array.from({ length: M }).fill(0), J = [{ cells: _ }, ...$.filter((L) => L.cells.length > 0)];
                for (let { cells: L } of J.filter((Y) => !Y.hasLineBreak))
                  for (let [Y, V] of L.entries())
                    q[Y] = Math.max(q[Y], s(V));
                return N.push(h, "`", c([u, r(u, J.map((L) => r(" | ", L.cells.map((Y, V) => L.hasLineBreak ? Y : Y + " ".repeat(q[V] - s(Y))))))]), u, "`"), N;
              }
            }
            function R(E, o) {
              let d = E.getValue(), C = o();
              return F(d) && (C = l([c([i, C]), i])), ["${", C, h, "}"];
            }
            function f(E, o) {
              return E.map((d) => R(d, o), "expressions");
            }
            function x(E, o) {
              return D(E, (d) => typeof d == "string" ? o ? d.replace(/(\\*)`/g, "$1$1\\`") : m(d) : d);
            }
            function m(E) {
              return E.replace(/([\\`]|\${)/g, "\\$1");
            }
            n.exports = { printTemplateLiteral: I, printTemplateExpressions: f, escapeTemplateCharacters: x, uncookTemplateElementValue: m };
          } }), xm = ee({ "src/language-js/embed/markdown.js"(e, n) {
            "use strict";
            re();
            var { builders: { indent: t3, softline: s, literalline: a, dedentToRoot: r } } = qe(), { escapeTemplateCharacters: u } = jt();
            function i(c, y, h) {
              let p = c.getValue().quasis[0].value.raw.replace(/((?:\\\\)*)\\`/g, (T, F) => "\\".repeat(F.length / 2) + "`"), D = l(p), v = D !== "";
              v && (p = p.replace(new RegExp(`^${D}`, "gm"), ""));
              let w = u(h(p, { parser: "markdown", __inJsTemplate: true }, { stripTrailingHardline: true }), true);
              return ["`", v ? t3([s, w]) : [a, r(w)], s, "`"];
            }
            function l(c) {
              let y = c.match(/^([^\S\n]*)\S/m);
              return y === null ? "" : y[1];
            }
            n.exports = i;
          } }), bm = ee({ "src/language-js/embed/css.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3 } = Ge(), { builders: { indent: s, hardline: a, softline: r }, utils: { mapDoc: u, replaceEndOfLine: i, cleanDoc: l } } = qe(), { printTemplateExpressions: c } = jt();
            function y(p, D, v) {
              let w = p.getValue(), T = w.quasis.map((P) => P.value.raw), F = 0, A = T.reduce((P, R, f) => f === 0 ? R : P + "@prettier-placeholder-" + F++ + "-id" + R, ""), B = v(A, { parser: "scss" }, { stripTrailingHardline: true }), I = c(p, D);
              return h(B, w, I);
            }
            function h(p, D, v) {
              if (D.quasis.length === 1 && !D.quasis[0].value.raw.trim())
                return "``";
              let T = g(p, v);
              if (!T)
                throw new Error("Couldn't insert all the expressions");
              return ["`", s([a, T]), r, "`"];
            }
            function g(p, D) {
              if (!t3(D))
                return p;
              let v = 0, w = u(l(p), (T) => typeof T != "string" || !T.includes("@prettier-placeholder") ? T : T.split(/@prettier-placeholder-(\d+)-id/).map((F, A) => A % 2 === 0 ? i(F) : (v++, D[F])));
              return D.length === v ? w : null;
            }
            n.exports = y;
          } }), Tm = ee({ "src/language-js/embed/graphql.js"(e, n) {
            "use strict";
            re();
            var { builders: { indent: t3, join: s, hardline: a } } = qe(), { escapeTemplateCharacters: r, printTemplateExpressions: u } = jt();
            function i(c, y, h) {
              let g = c.getValue(), p = g.quasis.length;
              if (p === 1 && g.quasis[0].value.raw.trim() === "")
                return "``";
              let D = u(c, y), v = [];
              for (let w = 0; w < p; w++) {
                let T = g.quasis[w], F = w === 0, A = w === p - 1, B = T.value.cooked, I = B.split(`
`), P = I.length, R = D[w], f = P > 2 && I[0].trim() === "" && I[1].trim() === "", x = P > 2 && I[P - 1].trim() === "" && I[P - 2].trim() === "", m = I.every((o) => /^\s*(?:#[^\n\r]*)?$/.test(o));
                if (!A && /#[^\n\r]*$/.test(I[P - 1]))
                  return null;
                let E = null;
                m ? E = l(I) : E = h(B, { parser: "graphql" }, { stripTrailingHardline: true }), E ? (E = r(E, false), !F && f && v.push(""), v.push(E), !A && x && v.push("")) : !F && !A && f && v.push(""), R && v.push(R);
              }
              return ["`", t3([a, s(a, v)]), a, "`"];
            }
            function l(c) {
              let y = [], h = false, g = c.map((p) => p.trim());
              for (let [p, D] of g.entries())
                D !== "" && (g[p - 1] === "" && h ? y.push([a, D]) : y.push(D), h = true);
              return y.length === 0 ? null : s(a, y);
            }
            n.exports = i;
          } }), Bm = ee({ "src/language-js/embed/html.js"(e, n) {
            "use strict";
            re();
            var { builders: { indent: t3, line: s, hardline: a, group: r }, utils: { mapDoc: u } } = qe(), { printTemplateExpressions: i, uncookTemplateElementValue: l } = jt(), c = 0;
            function y(h, g, p, D, v) {
              let { parser: w } = v, T = h.getValue(), F = c;
              c = c + 1 >>> 0;
              let A = (d) => `PRETTIER_HTML_PLACEHOLDER_${d}_${F}_IN_JS`, B = T.quasis.map((d, C, _) => C === _.length - 1 ? d.value.cooked : d.value.cooked + A(C)).join(""), I = i(h, g);
              if (I.length === 0 && B.trim().length === 0)
                return "``";
              let P = new RegExp(A("(\\d+)"), "g"), R = 0, f = p(B, { parser: w, __onHtmlRoot(d) {
                R = d.children.length;
              } }, { stripTrailingHardline: true }), x = u(f, (d) => {
                if (typeof d != "string")
                  return d;
                let C = [], _ = d.split(P);
                for (let b = 0; b < _.length; b++) {
                  let N = _[b];
                  if (b % 2 === 0) {
                    N && (N = l(N), D.__embeddedInHtml && (N = N.replace(/<\/(script)\b/gi, "<\\/$1")), C.push(N));
                    continue;
                  }
                  let k = Number(N);
                  C.push(I[k]);
                }
                return C;
              }), m = /^\s/.test(B) ? " " : "", E = /\s$/.test(B) ? " " : "", o = D.htmlWhitespaceSensitivity === "ignore" ? a : m && E ? s : null;
              return r(o ? ["`", t3([o, r(x)]), o, "`"] : ["`", m, R > 1 ? t3(r(x)) : r(x), E, "`"]);
            }
            n.exports = y;
          } }), Nm = ee({ "src/language-js/embed.js"(e, n) {
            "use strict";
            re();
            var { hasComment: t3, CommentCheckFlags: s, isObjectProperty: a } = Ke(), r = xm(), u = bm(), i = Tm(), l = Bm();
            function c(f) {
              if (g(f) || w(f) || T(f) || p(f))
                return "css";
              if (B(f))
                return "graphql";
              if (P(f))
                return "html";
              if (D(f))
                return "angular";
              if (h(f))
                return "markdown";
            }
            function y(f, x, m, E) {
              let o = f.getValue();
              if (o.type !== "TemplateLiteral" || R(o))
                return;
              let d = c(f);
              if (!!d) {
                if (d === "markdown")
                  return r(f, x, m);
                if (d === "css")
                  return u(f, x, m);
                if (d === "graphql")
                  return i(f, x, m);
                if (d === "html" || d === "angular")
                  return l(f, x, m, E, { parser: d });
              }
            }
            function h(f) {
              let x = f.getValue(), m = f.getParentNode();
              return m && m.type === "TaggedTemplateExpression" && x.quasis.length === 1 && m.tag.type === "Identifier" && (m.tag.name === "md" || m.tag.name === "markdown");
            }
            function g(f) {
              let x = f.getValue(), m = f.getParentNode(), E = f.getParentNode(1);
              return E && x.quasis && m.type === "JSXExpressionContainer" && E.type === "JSXElement" && E.openingElement.name.name === "style" && E.openingElement.attributes.some((o) => o.name.name === "jsx") || m && m.type === "TaggedTemplateExpression" && m.tag.type === "Identifier" && m.tag.name === "css" || m && m.type === "TaggedTemplateExpression" && m.tag.type === "MemberExpression" && m.tag.object.name === "css" && (m.tag.property.name === "global" || m.tag.property.name === "resolve");
            }
            function p(f) {
              return f.match((x) => x.type === "TemplateLiteral", (x, m) => x.type === "ArrayExpression" && m === "elements", (x, m) => a(x) && x.key.type === "Identifier" && x.key.name === "styles" && m === "value", ...v);
            }
            function D(f) {
              return f.match((x) => x.type === "TemplateLiteral", (x, m) => a(x) && x.key.type === "Identifier" && x.key.name === "template" && m === "value", ...v);
            }
            var v = [(f, x) => f.type === "ObjectExpression" && x === "properties", (f, x) => f.type === "CallExpression" && f.callee.type === "Identifier" && f.callee.name === "Component" && x === "arguments", (f, x) => f.type === "Decorator" && x === "expression"];
            function w(f) {
              let x = f.getParentNode();
              if (!x || x.type !== "TaggedTemplateExpression")
                return false;
              let m = x.tag.type === "ParenthesizedExpression" ? x.tag.expression : x.tag;
              switch (m.type) {
                case "MemberExpression":
                  return F(m.object) || A(m);
                case "CallExpression":
                  return F(m.callee) || m.callee.type === "MemberExpression" && (m.callee.object.type === "MemberExpression" && (F(m.callee.object.object) || A(m.callee.object)) || m.callee.object.type === "CallExpression" && F(m.callee.object.callee));
                case "Identifier":
                  return m.name === "css";
                default:
                  return false;
              }
            }
            function T(f) {
              let x = f.getParentNode(), m = f.getParentNode(1);
              return m && x.type === "JSXExpressionContainer" && m.type === "JSXAttribute" && m.name.type === "JSXIdentifier" && m.name.name === "css";
            }
            function F(f) {
              return f.type === "Identifier" && f.name === "styled";
            }
            function A(f) {
              return /^[A-Z]/.test(f.object.name) && f.property.name === "extend";
            }
            function B(f) {
              let x = f.getValue(), m = f.getParentNode();
              return I(x, "GraphQL") || m && (m.type === "TaggedTemplateExpression" && (m.tag.type === "MemberExpression" && m.tag.object.name === "graphql" && m.tag.property.name === "experimental" || m.tag.type === "Identifier" && (m.tag.name === "gql" || m.tag.name === "graphql")) || m.type === "CallExpression" && m.callee.type === "Identifier" && m.callee.name === "graphql");
            }
            function I(f, x) {
              return t3(f, s.Block | s.Leading, (m) => {
                let { value: E } = m;
                return E === ` ${x} `;
              });
            }
            function P(f) {
              return I(f.getValue(), "HTML") || f.match((x) => x.type === "TemplateLiteral", (x, m) => x.type === "TaggedTemplateExpression" && x.tag.type === "Identifier" && x.tag.name === "html" && m === "quasi");
            }
            function R(f) {
              let { quasis: x } = f;
              return x.some((m) => {
                let { value: { cooked: E } } = m;
                return E === null;
              });
            }
            n.exports = y;
          } }), wm = ee({ "src/language-js/clean.js"(e, n) {
            "use strict";
            re();
            var t3 = Lt(), s = /* @__PURE__ */ new Set(["range", "raw", "comments", "leadingComments", "trailingComments", "innerComments", "extra", "start", "end", "loc", "flags", "errors", "tokens"]), a = (u) => {
              for (let i of u.quasis)
                delete i.value;
            };
            function r(u, i, l) {
              if (u.type === "Program" && delete i.sourceType, (u.type === "BigIntLiteral" || u.type === "BigIntLiteralTypeAnnotation") && i.value && (i.value = i.value.toLowerCase()), (u.type === "BigIntLiteral" || u.type === "Literal") && i.bigint && (i.bigint = i.bigint.toLowerCase()), u.type === "DecimalLiteral" && (i.value = Number(i.value)), u.type === "Literal" && i.decimal && (i.decimal = Number(i.decimal)), u.type === "EmptyStatement" || u.type === "JSXText" || u.type === "JSXExpressionContainer" && (u.expression.type === "Literal" || u.expression.type === "StringLiteral") && u.expression.value === " ")
                return null;
              if ((u.type === "Property" || u.type === "ObjectProperty" || u.type === "MethodDefinition" || u.type === "ClassProperty" || u.type === "ClassMethod" || u.type === "PropertyDefinition" || u.type === "TSDeclareMethod" || u.type === "TSPropertySignature" || u.type === "ObjectTypeProperty") && typeof u.key == "object" && u.key && (u.key.type === "Literal" || u.key.type === "NumericLiteral" || u.key.type === "StringLiteral" || u.key.type === "Identifier") && delete i.key, u.type === "JSXElement" && u.openingElement.name.name === "style" && u.openingElement.attributes.some((h) => h.name.name === "jsx"))
                for (let { type: h, expression: g } of i.children)
                  h === "JSXExpressionContainer" && g.type === "TemplateLiteral" && a(g);
              u.type === "JSXAttribute" && u.name.name === "css" && u.value.type === "JSXExpressionContainer" && u.value.expression.type === "TemplateLiteral" && a(i.value.expression), u.type === "JSXAttribute" && u.value && u.value.type === "Literal" && /["']|&quot;|&apos;/.test(u.value.value) && (i.value.value = i.value.value.replace(/["']|&quot;|&apos;/g, '"'));
              let c = u.expression || u.callee;
              if (u.type === "Decorator" && c.type === "CallExpression" && c.callee.name === "Component" && c.arguments.length === 1) {
                let h = u.expression.arguments[0].properties;
                for (let [g, p] of i.expression.arguments[0].properties.entries())
                  switch (h[g].key.name) {
                    case "styles":
                      p.value.type === "ArrayExpression" && a(p.value.elements[0]);
                      break;
                    case "template":
                      p.value.type === "TemplateLiteral" && a(p.value);
                      break;
                  }
              }
              if (u.type === "TaggedTemplateExpression" && (u.tag.type === "MemberExpression" || u.tag.type === "Identifier" && (u.tag.name === "gql" || u.tag.name === "graphql" || u.tag.name === "css" || u.tag.name === "md" || u.tag.name === "markdown" || u.tag.name === "html") || u.tag.type === "CallExpression") && a(i.quasi), u.type === "TemplateLiteral") {
                var y;
                (((y = u.leadingComments) === null || y === void 0 ? void 0 : y.some((g) => t3(g) && ["GraphQL", "HTML"].some((p) => g.value === ` ${p} `))) || l.type === "CallExpression" && l.callee.name === "graphql" || !u.leadingComments) && a(i);
              }
              if (u.type === "InterpreterDirective" && (i.value = i.value.trimEnd()), (u.type === "TSIntersectionType" || u.type === "TSUnionType") && u.types.length === 1)
                return i.types[0];
            }
            r.ignoredProperties = s, n.exports = r;
          } }), Ma = {};
          zt(Ma, { EOL: () => kn, arch: () => _m, cpus: () => Ua, default: () => Ya, endianness: () => Ra, freemem: () => Ha, getNetworkInterfaces: () => Ka, hostname: () => $a, loadavg: () => Va, networkInterfaces: () => Xa, platform: () => Pm, release: () => za, tmpDir: () => Pn, tmpdir: () => In, totalmem: () => Ga, type: () => Ja, uptime: () => Wa });
          function Ra() {
            if (typeof br > "u") {
              var e = new ArrayBuffer(2), n = new Uint8Array(e), t3 = new Uint16Array(e);
              if (n[0] = 1, n[1] = 2, t3[0] === 258)
                br = "BE";
              else if (t3[0] === 513)
                br = "LE";
              else
                throw new Error("unable to figure out endianess");
            }
            return br;
          }
          function $a() {
            return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
          }
          function Va() {
            return [];
          }
          function Wa() {
            return 0;
          }
          function Ha() {
            return Number.MAX_VALUE;
          }
          function Ga() {
            return Number.MAX_VALUE;
          }
          function Ua() {
            return [];
          }
          function Ja() {
            return "Browser";
          }
          function za() {
            return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
          }
          function Xa() {
          }
          function Ka() {
          }
          function _m() {
            return "javascript";
          }
          function Pm() {
            return "browser";
          }
          function Pn() {
            return "/tmp";
          }
          var br, In, kn, Ya, Im = gt2({ "node-modules-polyfills:os"() {
            re(), In = Pn, kn = `
`, Ya = { EOL: kn, tmpdir: In, tmpDir: Pn, networkInterfaces: Xa, getNetworkInterfaces: Ka, release: za, type: Ja, cpus: Ua, totalmem: Ga, freemem: Ha, uptime: Wa, loadavg: Va, hostname: $a, endianness: Ra };
          } }), km = ee({ "node-modules-polyfills-commonjs:os"(e, n) {
            re();
            var t3 = (Im(), ft(Ma));
            if (t3 && t3.default) {
              n.exports = t3.default;
              for (let s in t3)
                n.exports[s] = t3[s];
            } else
              t3 && (n.exports = t3);
          } }), Lm = ee({ "node_modules/detect-newline/index.js"(e, n) {
            "use strict";
            re();
            var t3 = (s) => {
              if (typeof s != "string")
                throw new TypeError("Expected a string");
              let a = s.match(/(?:\r?\n)/g) || [];
              if (a.length === 0)
                return;
              let r = a.filter((i) => i === `\r
`).length, u = a.length - r;
              return r > u ? `\r
` : `
`;
            };
            n.exports = t3, n.exports.graceful = (s) => typeof s == "string" && t3(s) || `
`;
          } }), jm = ee({ "node_modules/jest-docblock/build/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.extract = p, e.parse = v, e.parseWithComments = w, e.print = T, e.strip = D;
            function n() {
              let A = km();
              return n = function() {
                return A;
              }, A;
            }
            function t3() {
              let A = s(Lm());
              return t3 = function() {
                return A;
              }, A;
            }
            function s(A) {
              return A && A.__esModule ? A : { default: A };
            }
            var a = /\*\/$/, r = /^\/\*\*?/, u = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, i = /(^|\s+)\/\/([^\r\n]*)/g, l = /^(\r?\n)+/, c = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, y = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, h = /(\r?\n|^) *\* ?/g, g = [];
            function p(A) {
              let B = A.match(u);
              return B ? B[0].trimLeft() : "";
            }
            function D(A) {
              let B = A.match(u);
              return B && B[0] ? A.substring(B[0].length) : A;
            }
            function v(A) {
              return w(A).pragmas;
            }
            function w(A) {
              let B = (0, t3().default)(A) || n().EOL;
              A = A.replace(r, "").replace(a, "").replace(h, "$1");
              let I = "";
              for (; I !== A; )
                I = A, A = A.replace(c, `${B}$1 $2${B}`);
              A = A.replace(l, "").trimRight();
              let P = /* @__PURE__ */ Object.create(null), R = A.replace(y, "").replace(l, "").trimRight(), f;
              for (; f = y.exec(A); ) {
                let x = f[2].replace(i, "");
                typeof P[f[1]] == "string" || Array.isArray(P[f[1]]) ? P[f[1]] = g.concat(P[f[1]], x) : P[f[1]] = x;
              }
              return { comments: R, pragmas: P };
            }
            function T(A) {
              let { comments: B = "", pragmas: I = {} } = A, P = (0, t3().default)(B) || n().EOL, R = "/**", f = " *", x = " */", m = Object.keys(I), E = m.map((d) => F(d, I[d])).reduce((d, C) => d.concat(C), []).map((d) => `${f} ${d}${P}`).join("");
              if (!B) {
                if (m.length === 0)
                  return "";
                if (m.length === 1 && !Array.isArray(I[m[0]])) {
                  let d = I[m[0]];
                  return `${R} ${F(m[0], d)[0]}${x}`;
                }
              }
              let o = B.split(P).map((d) => `${f} ${d}`).join(P) + P;
              return R + P + (B ? o : "") + (B && m.length ? f + P : "") + E + x;
            }
            function F(A, B) {
              return g.concat(B).map((I) => `@${A} ${I}`.trim());
            }
          } }), Om = ee({ "src/language-js/utils/get-shebang.js"(e, n) {
            "use strict";
            re();
            function t3(s) {
              if (!s.startsWith("#!"))
                return "";
              let a = s.indexOf(`
`);
              return a === -1 ? s : s.slice(0, a);
            }
            n.exports = t3;
          } }), Qa = ee({ "src/language-js/pragma.js"(e, n) {
            "use strict";
            re();
            var { parseWithComments: t3, strip: s, extract: a, print: r } = jm(), { normalizeEndOfLine: u } = qn(), i = Om();
            function l(h) {
              let g = i(h);
              g && (h = h.slice(g.length + 1));
              let p = a(h), { pragmas: D, comments: v } = t3(p);
              return { shebang: g, text: h, pragmas: D, comments: v };
            }
            function c(h) {
              let g = Object.keys(l(h).pragmas);
              return g.includes("prettier") || g.includes("format");
            }
            function y(h) {
              let { shebang: g, text: p, pragmas: D, comments: v } = l(h), w = s(p), T = r({ pragmas: Object.assign({ format: "" }, D), comments: v.trimStart() });
              return (g ? `${g}
` : "") + u(T) + (w.startsWith(`
`) ? `
` : `

`) + w;
            }
            n.exports = { hasPragma: c, insertPragma: y };
          } }), Za = ee({ "src/language-js/comments.js"(e, n) {
            "use strict";
            re();
            var { getLast: t3, hasNewline: s, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: a, getNextNonSpaceNonCommentCharacter: r, hasNewlineInRange: u, addLeadingComment: i, addTrailingComment: l, addDanglingComment: c, getNextNonSpaceNonCommentCharacterIndex: y, isNonEmptyArray: h } = Ge(), { getFunctionParameters: g, isPrettierIgnoreComment: p, isJsxNode: D, hasFlowShorthandAnnotationComment: v, hasFlowAnnotationComment: w, hasIgnoreComment: T, isCallLikeExpression: F, getCallArguments: A, isCallExpression: B, isMemberExpression: I, isObjectProperty: P, isLineComment: R, getComments: f, CommentCheckFlags: x, markerForIfWithoutBlockAndSameLineComment: m } = Ke(), { locStart: E, locEnd: o } = it(), d = Lt();
            function C(ye) {
              return [ce, ae, L, M, q, J, K, ge, Z, fe, Ce, _e, Q, Ae, z].some((S) => S(ye));
            }
            function _(ye) {
              return [$, ae, Y, Ce, M, q, J, K, Ae, H, ne, fe, ie, z, de].some((S) => S(ye));
            }
            function b(ye) {
              return [ce, M, q, V, oe, Q, fe, X, W, U, z, ve].some((S) => S(ye));
            }
            function N(ye, S) {
              let G = (ye.body || ye.properties).find((te) => {
                let { type: Ee } = te;
                return Ee !== "EmptyStatement";
              });
              G ? i(G, S) : c(ye, S);
            }
            function k(ye, S) {
              ye.type === "BlockStatement" ? N(ye, S) : i(ye, S);
            }
            function $(ye) {
              let { comment: S, followingNode: G } = ye;
              return G && Be(S) ? (i(G, S), true) : false;
            }
            function M(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te, followingNode: Ee, text: Re } = ye;
              if ((te == null ? void 0 : te.type) !== "IfStatement" || !Ee)
                return false;
              if (r(Re, S, o) === ")")
                return l(G, S), true;
              if (G === te.consequent && Ee === te.alternate) {
                if (G.type === "BlockStatement")
                  l(G, S);
                else {
                  let Pe = S.type === "SingleLine" || S.loc.start.line === S.loc.end.line, Fe = S.loc.start.line === G.loc.start.line;
                  Pe && Fe ? c(G, S, m) : c(te, S);
                }
                return true;
              }
              return Ee.type === "BlockStatement" ? (N(Ee, S), true) : Ee.type === "IfStatement" ? (k(Ee.consequent, S), true) : te.consequent === Ee ? (i(Ee, S), true) : false;
            }
            function q(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te, followingNode: Ee, text: Re } = ye;
              return (te == null ? void 0 : te.type) !== "WhileStatement" || !Ee ? false : r(Re, S, o) === ")" ? (l(G, S), true) : Ee.type === "BlockStatement" ? (N(Ee, S), true) : te.body === Ee ? (i(Ee, S), true) : false;
            }
            function J(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te, followingNode: Ee } = ye;
              return (te == null ? void 0 : te.type) !== "TryStatement" && (te == null ? void 0 : te.type) !== "CatchClause" || !Ee ? false : te.type === "CatchClause" && G ? (l(G, S), true) : Ee.type === "BlockStatement" ? (N(Ee, S), true) : Ee.type === "TryStatement" ? (k(Ee.finalizer, S), true) : Ee.type === "CatchClause" ? (k(Ee.body, S), true) : false;
            }
            function L(ye) {
              let { comment: S, enclosingNode: G, followingNode: te } = ye;
              return I(G) && (te == null ? void 0 : te.type) === "Identifier" ? (i(G, S), true) : false;
            }
            function Y(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te, followingNode: Ee, text: Re } = ye, Te = G && !u(Re, o(G), E(S));
              return (!G || !Te) && ((te == null ? void 0 : te.type) === "ConditionalExpression" || (te == null ? void 0 : te.type) === "TSConditionalType") && Ee ? (i(Ee, S), true) : false;
            }
            function V(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te } = ye;
              return P(te) && te.shorthand && te.key === G && te.value.type === "AssignmentPattern" ? (l(te.value.left, S), true) : false;
            }
            var O = /* @__PURE__ */ new Set(["ClassDeclaration", "ClassExpression", "DeclareClass", "DeclareInterface", "InterfaceDeclaration", "TSInterfaceDeclaration"]);
            function K(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te, followingNode: Ee } = ye;
              if (O.has(te == null ? void 0 : te.type)) {
                if (h(te.decorators) && !(Ee && Ee.type === "Decorator"))
                  return l(t3(te.decorators), S), true;
                if (te.body && Ee === te.body)
                  return N(te.body, S), true;
                if (Ee) {
                  if (te.superClass && Ee === te.superClass && G && (G === te.id || G === te.typeParameters))
                    return l(G, S), true;
                  for (let Re of ["implements", "extends", "mixins"])
                    if (te[Re] && Ee === te[Re][0])
                      return G && (G === te.id || G === te.typeParameters || G === te.superClass) ? l(G, S) : c(te, S, Re), true;
                }
              }
              return false;
            }
            var se = /* @__PURE__ */ new Set(["ClassMethod", "ClassProperty", "PropertyDefinition", "TSAbstractPropertyDefinition", "TSAbstractMethodDefinition", "TSDeclareMethod", "MethodDefinition"]);
            function Q(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te, text: Ee } = ye;
              return te && G && r(Ee, S, o) === "(" && (te.type === "Property" || te.type === "TSDeclareMethod" || te.type === "TSAbstractMethodDefinition") && G.type === "Identifier" && te.key === G && r(Ee, G, o) !== ":" || (G == null ? void 0 : G.type) === "Decorator" && se.has(te == null ? void 0 : te.type) ? (l(G, S), true) : false;
            }
            var le = /* @__PURE__ */ new Set(["FunctionDeclaration", "FunctionExpression", "ClassMethod", "MethodDefinition", "ObjectMethod"]);
            function W(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te, text: Ee } = ye;
              return r(Ee, S, o) !== "(" ? false : G && le.has(te == null ? void 0 : te.type) ? (l(G, S), true) : false;
            }
            function X(ye) {
              let { comment: S, enclosingNode: G, text: te } = ye;
              if ((G == null ? void 0 : G.type) !== "ArrowFunctionExpression")
                return false;
              let Ee = y(te, S, o);
              return Ee !== false && te.slice(Ee, Ee + 2) === "=>" ? (c(G, S), true) : false;
            }
            function oe(ye) {
              let { comment: S, enclosingNode: G, text: te } = ye;
              return r(te, S, o) !== ")" ? false : G && (De(G) && g(G).length === 0 || F(G) && A(G).length === 0) ? (c(G, S), true) : ((G == null ? void 0 : G.type) === "MethodDefinition" || (G == null ? void 0 : G.type) === "TSAbstractMethodDefinition") && g(G.value).length === 0 ? (c(G.value, S), true) : false;
            }
            function ae(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te, followingNode: Ee, text: Re } = ye;
              if ((G == null ? void 0 : G.type) === "FunctionTypeParam" && (te == null ? void 0 : te.type) === "FunctionTypeAnnotation" && (Ee == null ? void 0 : Ee.type) !== "FunctionTypeParam" || ((G == null ? void 0 : G.type) === "Identifier" || (G == null ? void 0 : G.type) === "AssignmentPattern") && te && De(te) && r(Re, S, o) === ")")
                return l(G, S), true;
              if ((te == null ? void 0 : te.type) === "FunctionDeclaration" && (Ee == null ? void 0 : Ee.type) === "BlockStatement") {
                let Te = (() => {
                  let Pe = g(te);
                  if (Pe.length > 0)
                    return a(Re, o(t3(Pe)));
                  let Fe = a(Re, o(te.id));
                  return Fe !== false && a(Re, Fe + 1);
                })();
                if (E(S) > Te)
                  return N(Ee, S), true;
              }
              return false;
            }
            function Ae(ye) {
              let { comment: S, enclosingNode: G } = ye;
              return (G == null ? void 0 : G.type) === "LabeledStatement" ? (i(G, S), true) : false;
            }
            function z(ye) {
              let { comment: S, enclosingNode: G } = ye;
              return ((G == null ? void 0 : G.type) === "ContinueStatement" || (G == null ? void 0 : G.type) === "BreakStatement") && !G.label ? (l(G, S), true) : false;
            }
            function H(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te } = ye;
              return B(te) && G && te.callee === G && te.arguments.length > 0 ? (i(te.arguments[0], S), true) : false;
            }
            function Z(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te, followingNode: Ee } = ye;
              return (te == null ? void 0 : te.type) === "UnionTypeAnnotation" || (te == null ? void 0 : te.type) === "TSUnionType" ? (p(S) && (Ee.prettierIgnore = true, S.unignore = true), G ? (l(G, S), true) : false) : (((Ee == null ? void 0 : Ee.type) === "UnionTypeAnnotation" || (Ee == null ? void 0 : Ee.type) === "TSUnionType") && p(S) && (Ee.types[0].prettierIgnore = true, S.unignore = true), false);
            }
            function ne(ye) {
              let { comment: S, enclosingNode: G } = ye;
              return P(G) ? (i(G, S), true) : false;
            }
            function fe(ye) {
              let { comment: S, enclosingNode: G, followingNode: te, ast: Ee, isLastComment: Re } = ye;
              return Ee && Ee.body && Ee.body.length === 0 ? (Re ? c(Ee, S) : i(Ee, S), true) : (G == null ? void 0 : G.type) === "Program" && (G == null ? void 0 : G.body.length) === 0 && !h(G.directives) ? (Re ? c(G, S) : i(G, S), true) : (te == null ? void 0 : te.type) === "Program" && (te == null ? void 0 : te.body.length) === 0 && (G == null ? void 0 : G.type) === "ModuleExpression" ? (c(te, S), true) : false;
            }
            function ge(ye) {
              let { comment: S, enclosingNode: G } = ye;
              return (G == null ? void 0 : G.type) === "ForInStatement" || (G == null ? void 0 : G.type) === "ForOfStatement" ? (i(G, S), true) : false;
            }
            function Ce(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te, text: Ee } = ye;
              if ((te == null ? void 0 : te.type) === "ImportSpecifier" || (te == null ? void 0 : te.type) === "ExportSpecifier")
                return i(te, S), true;
              let Re = (G == null ? void 0 : G.type) === "ImportSpecifier" && (te == null ? void 0 : te.type) === "ImportDeclaration", Te = (G == null ? void 0 : G.type) === "ExportSpecifier" && (te == null ? void 0 : te.type) === "ExportNamedDeclaration";
              return (Re || Te) && s(Ee, o(S)) ? (l(G, S), true) : false;
            }
            function _e(ye) {
              let { comment: S, enclosingNode: G } = ye;
              return (G == null ? void 0 : G.type) === "AssignmentPattern" ? (i(G, S), true) : false;
            }
            var Oe = /* @__PURE__ */ new Set(["VariableDeclarator", "AssignmentExpression", "TypeAlias", "TSTypeAliasDeclaration"]), pe = /* @__PURE__ */ new Set(["ObjectExpression", "ArrayExpression", "TemplateLiteral", "TaggedTemplateExpression", "ObjectTypeAnnotation", "TSTypeLiteral"]);
            function ie(ye) {
              let { comment: S, enclosingNode: G, followingNode: te } = ye;
              return Oe.has(G == null ? void 0 : G.type) && te && (pe.has(te.type) || d(S)) ? (i(te, S), true) : false;
            }
            function ve(ye) {
              let { comment: S, enclosingNode: G, followingNode: te, text: Ee } = ye;
              return !te && ((G == null ? void 0 : G.type) === "TSMethodSignature" || (G == null ? void 0 : G.type) === "TSDeclareFunction" || (G == null ? void 0 : G.type) === "TSAbstractMethodDefinition") && r(Ee, S, o) === ";" ? (l(G, S), true) : false;
            }
            function ce(ye) {
              let { comment: S, enclosingNode: G, followingNode: te } = ye;
              if (p(S) && (G == null ? void 0 : G.type) === "TSMappedType" && (te == null ? void 0 : te.type) === "TSTypeParameter" && te.constraint)
                return G.prettierIgnore = true, S.unignore = true, true;
            }
            function U(ye) {
              let { comment: S, precedingNode: G, enclosingNode: te, followingNode: Ee } = ye;
              return (te == null ? void 0 : te.type) !== "TSMappedType" ? false : (Ee == null ? void 0 : Ee.type) === "TSTypeParameter" && Ee.name ? (i(Ee.name, S), true) : (G == null ? void 0 : G.type) === "TSTypeParameter" && G.constraint ? (l(G.constraint, S), true) : false;
            }
            function de(ye) {
              let { comment: S, enclosingNode: G, followingNode: te } = ye;
              return !G || G.type !== "SwitchCase" || G.test ? false : (te.type === "BlockStatement" && R(S) ? N(te, S) : c(G, S), true);
            }
            function De(ye) {
              return ye.type === "ArrowFunctionExpression" || ye.type === "FunctionExpression" || ye.type === "FunctionDeclaration" || ye.type === "ObjectMethod" || ye.type === "ClassMethod" || ye.type === "TSDeclareFunction" || ye.type === "TSCallSignatureDeclaration" || ye.type === "TSConstructSignatureDeclaration" || ye.type === "TSMethodSignature" || ye.type === "TSConstructorType" || ye.type === "TSFunctionType" || ye.type === "TSDeclareMethod";
            }
            function he(ye, S) {
              if ((S.parser === "typescript" || S.parser === "flow" || S.parser === "acorn" || S.parser === "espree" || S.parser === "meriyah" || S.parser === "__babel_estree") && ye.type === "MethodDefinition" && ye.value && ye.value.type === "FunctionExpression" && g(ye.value).length === 0 && !ye.value.returnType && !h(ye.value.typeParameters) && ye.value.body)
                return [...ye.decorators || [], ye.key, ye.value.body];
            }
            function Be(ye) {
              return d(ye) && ye.value[0] === "*" && /@type\b/.test(ye.value);
            }
            function Se(ye) {
              let S = ye.getValue(), G = ye.getParentNode(), te = (Ee) => w(f(Ee, x.Leading)) || w(f(Ee, x.Trailing));
              return (S && (D(S) || v(S) || B(G) && te(S)) || G && (G.type === "JSXSpreadAttribute" || G.type === "JSXSpreadChild" || G.type === "UnionTypeAnnotation" || G.type === "TSUnionType" || (G.type === "ClassDeclaration" || G.type === "ClassExpression") && G.superClass === S)) && (!T(ye) || G.type === "UnionTypeAnnotation" || G.type === "TSUnionType");
            }
            n.exports = { handleOwnLineComment: C, handleEndOfLineComment: _, handleRemainingComment: b, isTypeCastComment: Be, getCommentChildNodes: he, willPrintOwnComments: Se };
          } }), Ot = ee({ "src/language-js/needs-parens.js"(e, n) {
            "use strict";
            re();
            var t3 = lt2(), s = $n(), { getFunctionParameters: a, getLeftSidePathName: r, hasFlowShorthandAnnotationComment: u, hasNakedLeftSide: i, hasNode: l, isBitwiseOperator: c, startsWithNoLookaheadToken: y, shouldFlatten: h, getPrecedence: g, isCallExpression: p, isMemberExpression: D, isObjectProperty: v, isTSTypeExpression: w } = Ke();
            function T(f, x) {
              let m = f.getParentNode();
              if (!m)
                return false;
              let E = f.getName(), o = f.getNode();
              if (x.__isInHtmlInterpolation && !x.bracketSpacing && I(o) && P(f))
                return true;
              if (F(o))
                return false;
              if (x.parser !== "flow" && u(f.getValue()))
                return true;
              if (o.type === "Identifier")
                return !!(o.extra && o.extra.parenthesized && /^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(o.name) || E === "left" && o.name === "async" && m.type === "ForOfStatement" && !m.await);
              switch (m.type) {
                case "ParenthesizedExpression":
                  return false;
                case "ClassDeclaration":
                case "ClassExpression": {
                  if (E === "superClass" && (o.type === "ArrowFunctionExpression" || o.type === "AssignmentExpression" || o.type === "AwaitExpression" || o.type === "BinaryExpression" || o.type === "ConditionalExpression" || o.type === "LogicalExpression" || o.type === "NewExpression" || o.type === "ObjectExpression" || o.type === "SequenceExpression" || o.type === "TaggedTemplateExpression" || o.type === "UnaryExpression" || o.type === "UpdateExpression" || o.type === "YieldExpression" || o.type === "TSNonNullExpression"))
                    return true;
                  break;
                }
                case "ExportDefaultDeclaration":
                  return R(f, x) || o.type === "SequenceExpression";
                case "Decorator": {
                  if (E === "expression") {
                    let d = false, C = false, _ = o;
                    for (; _; )
                      switch (_.type) {
                        case "MemberExpression":
                          C = true, _ = _.object;
                          break;
                        case "CallExpression":
                          if (C || d)
                            return x.parser !== "typescript";
                          d = true, _ = _.callee;
                          break;
                        case "Identifier":
                          return false;
                        case "TaggedTemplateExpression":
                          return x.parser !== "typescript";
                        default:
                          return true;
                      }
                    return true;
                  }
                  break;
                }
                case "ExpressionStatement": {
                  if (y(o, true))
                    return true;
                  break;
                }
                case "ArrowFunctionExpression": {
                  if (E === "body" && o.type !== "SequenceExpression" && y(o, false))
                    return true;
                  break;
                }
              }
              switch (o.type) {
                case "UpdateExpression":
                  if (m.type === "UnaryExpression")
                    return o.prefix && (o.operator === "++" && m.operator === "+" || o.operator === "--" && m.operator === "-");
                case "UnaryExpression":
                  switch (m.type) {
                    case "UnaryExpression":
                      return o.operator === m.operator && (o.operator === "+" || o.operator === "-");
                    case "BindExpression":
                      return true;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return E === "object";
                    case "TaggedTemplateExpression":
                      return true;
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return E === "callee";
                    case "BinaryExpression":
                      return E === "left" && m.operator === "**";
                    case "TSNonNullExpression":
                      return true;
                    default:
                      return false;
                  }
                case "BinaryExpression": {
                  if (m.type === "UpdateExpression" || o.operator === "in" && A(f))
                    return true;
                  if (o.operator === "|>" && o.extra && o.extra.parenthesized) {
                    let d = f.getParentNode(1);
                    if (d.type === "BinaryExpression" && d.operator === "|>")
                      return true;
                  }
                }
                case "TSTypeAssertion":
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "LogicalExpression":
                  switch (m.type) {
                    case "TSSatisfiesExpression":
                    case "TSAsExpression":
                      return !w(o);
                    case "ConditionalExpression":
                      return w(o);
                    case "CallExpression":
                    case "NewExpression":
                    case "OptionalCallExpression":
                      return E === "callee";
                    case "ClassExpression":
                    case "ClassDeclaration":
                      return E === "superClass";
                    case "TSTypeAssertion":
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "JSXSpreadAttribute":
                    case "SpreadElement":
                    case "SpreadProperty":
                    case "BindExpression":
                    case "AwaitExpression":
                    case "TSNonNullExpression":
                    case "UpdateExpression":
                      return true;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return E === "object";
                    case "AssignmentExpression":
                    case "AssignmentPattern":
                      return E === "left" && (o.type === "TSTypeAssertion" || w(o));
                    case "LogicalExpression":
                      if (o.type === "LogicalExpression")
                        return m.operator !== o.operator;
                    case "BinaryExpression": {
                      let { operator: d, type: C } = o;
                      if (!d && C !== "TSTypeAssertion")
                        return true;
                      let _ = g(d), b = m.operator, N = g(b);
                      return N > _ || E === "right" && N === _ || N === _ && !h(b, d) ? true : N < _ && d === "%" ? b === "+" || b === "-" : !!c(b);
                    }
                    default:
                      return false;
                  }
                case "SequenceExpression":
                  switch (m.type) {
                    case "ReturnStatement":
                      return false;
                    case "ForStatement":
                      return false;
                    case "ExpressionStatement":
                      return E !== "expression";
                    case "ArrowFunctionExpression":
                      return E !== "body";
                    default:
                      return true;
                  }
                case "YieldExpression":
                  if (m.type === "UnaryExpression" || m.type === "AwaitExpression" || w(m) || m.type === "TSNonNullExpression")
                    return true;
                case "AwaitExpression":
                  switch (m.type) {
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "LogicalExpression":
                    case "SpreadElement":
                    case "SpreadProperty":
                    case "TSAsExpression":
                    case "TSSatisfiesExpression":
                    case "TSNonNullExpression":
                    case "BindExpression":
                      return true;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return E === "object";
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return E === "callee";
                    case "ConditionalExpression":
                      return E === "test";
                    case "BinaryExpression":
                      return !(!o.argument && m.operator === "|>");
                    default:
                      return false;
                  }
                case "TSConditionalType":
                  if (E === "extendsType" && m.type === "TSConditionalType")
                    return true;
                case "TSFunctionType":
                case "TSConstructorType":
                  if (E === "extendsType" && m.type === "TSConditionalType") {
                    let d = (o.returnType || o.typeAnnotation).typeAnnotation;
                    if (d.type === "TSInferType" && d.typeParameter.constraint)
                      return true;
                  }
                  if (E === "checkType" && m.type === "TSConditionalType")
                    return true;
                case "TSUnionType":
                case "TSIntersectionType":
                  if ((m.type === "TSUnionType" || m.type === "TSIntersectionType") && m.types.length > 1 && (!o.types || o.types.length > 1))
                    return true;
                case "TSInferType":
                  if (o.type === "TSInferType" && m.type === "TSRestType")
                    return false;
                case "TSTypeOperator":
                  return m.type === "TSArrayType" || m.type === "TSOptionalType" || m.type === "TSRestType" || E === "objectType" && m.type === "TSIndexedAccessType" || m.type === "TSTypeOperator" || m.type === "TSTypeAnnotation" && f.getParentNode(1).type.startsWith("TSJSDoc");
                case "ArrayTypeAnnotation":
                  return m.type === "NullableTypeAnnotation";
                case "IntersectionTypeAnnotation":
                case "UnionTypeAnnotation":
                  return m.type === "ArrayTypeAnnotation" || m.type === "NullableTypeAnnotation" || m.type === "IntersectionTypeAnnotation" || m.type === "UnionTypeAnnotation" || E === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType");
                case "NullableTypeAnnotation":
                  return m.type === "ArrayTypeAnnotation" || E === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType");
                case "FunctionTypeAnnotation": {
                  let d = m.type === "NullableTypeAnnotation" ? f.getParentNode(1) : m;
                  return d.type === "UnionTypeAnnotation" || d.type === "IntersectionTypeAnnotation" || d.type === "ArrayTypeAnnotation" || E === "objectType" && (d.type === "IndexedAccessType" || d.type === "OptionalIndexedAccessType") || d.type === "NullableTypeAnnotation" || m.type === "FunctionTypeParam" && m.name === null && a(o).some((C) => C.typeAnnotation && C.typeAnnotation.type === "NullableTypeAnnotation");
                }
                case "OptionalIndexedAccessType":
                  return E === "objectType" && m.type === "IndexedAccessType";
                case "TypeofTypeAnnotation":
                  return E === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType");
                case "StringLiteral":
                case "NumericLiteral":
                case "Literal":
                  if (typeof o.value == "string" && m.type === "ExpressionStatement" && !m.directive) {
                    let d = f.getParentNode(1);
                    return d.type === "Program" || d.type === "BlockStatement";
                  }
                  return E === "object" && m.type === "MemberExpression" && typeof o.value == "number";
                case "AssignmentExpression": {
                  let d = f.getParentNode(1);
                  return E === "body" && m.type === "ArrowFunctionExpression" ? true : E === "key" && (m.type === "ClassProperty" || m.type === "PropertyDefinition") && m.computed || (E === "init" || E === "update") && m.type === "ForStatement" ? false : m.type === "ExpressionStatement" ? o.left.type === "ObjectPattern" : !(E === "key" && m.type === "TSPropertySignature" || m.type === "AssignmentExpression" || m.type === "SequenceExpression" && d && d.type === "ForStatement" && (d.init === m || d.update === m) || E === "value" && m.type === "Property" && d && d.type === "ObjectPattern" && d.properties.includes(m) || m.type === "NGChainedExpression");
                }
                case "ConditionalExpression":
                  switch (m.type) {
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "SpreadElement":
                    case "SpreadProperty":
                    case "BinaryExpression":
                    case "LogicalExpression":
                    case "NGPipeExpression":
                    case "ExportDefaultDeclaration":
                    case "AwaitExpression":
                    case "JSXSpreadAttribute":
                    case "TSTypeAssertion":
                    case "TypeCastExpression":
                    case "TSAsExpression":
                    case "TSSatisfiesExpression":
                    case "TSNonNullExpression":
                      return true;
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return E === "callee";
                    case "ConditionalExpression":
                      return E === "test";
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return E === "object";
                    default:
                      return false;
                  }
                case "FunctionExpression":
                  switch (m.type) {
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return E === "callee";
                    case "TaggedTemplateExpression":
                      return true;
                    default:
                      return false;
                  }
                case "ArrowFunctionExpression":
                  switch (m.type) {
                    case "BinaryExpression":
                      return m.operator !== "|>" || o.extra && o.extra.parenthesized;
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return E === "callee";
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return E === "object";
                    case "TSAsExpression":
                    case "TSSatisfiesExpression":
                    case "TSNonNullExpression":
                    case "BindExpression":
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "LogicalExpression":
                    case "AwaitExpression":
                    case "TSTypeAssertion":
                      return true;
                    case "ConditionalExpression":
                      return E === "test";
                    default:
                      return false;
                  }
                case "ClassExpression":
                  if (s(o.decorators))
                    return true;
                  switch (m.type) {
                    case "NewExpression":
                      return E === "callee";
                    default:
                      return false;
                  }
                case "OptionalMemberExpression":
                case "OptionalCallExpression": {
                  let d = f.getParentNode(1);
                  if (E === "object" && m.type === "MemberExpression" || E === "callee" && (m.type === "CallExpression" || m.type === "NewExpression") || m.type === "TSNonNullExpression" && d.type === "MemberExpression" && d.object === m)
                    return true;
                }
                case "CallExpression":
                case "MemberExpression":
                case "TaggedTemplateExpression":
                case "TSNonNullExpression":
                  if (E === "callee" && (m.type === "BindExpression" || m.type === "NewExpression")) {
                    let d = o;
                    for (; d; )
                      switch (d.type) {
                        case "CallExpression":
                        case "OptionalCallExpression":
                          return true;
                        case "MemberExpression":
                        case "OptionalMemberExpression":
                        case "BindExpression":
                          d = d.object;
                          break;
                        case "TaggedTemplateExpression":
                          d = d.tag;
                          break;
                        case "TSNonNullExpression":
                          d = d.expression;
                          break;
                        default:
                          return false;
                      }
                  }
                  return false;
                case "BindExpression":
                  return E === "callee" && (m.type === "BindExpression" || m.type === "NewExpression") || E === "object" && D(m);
                case "NGPipeExpression":
                  return !(m.type === "NGRoot" || m.type === "NGMicrosyntaxExpression" || m.type === "ObjectProperty" && !(o.extra && o.extra.parenthesized) || m.type === "ArrayExpression" || p(m) && m.arguments[E] === o || E === "right" && m.type === "NGPipeExpression" || E === "property" && m.type === "MemberExpression" || m.type === "AssignmentExpression");
                case "JSXFragment":
                case "JSXElement":
                  return E === "callee" || E === "left" && m.type === "BinaryExpression" && m.operator === "<" || m.type !== "ArrayExpression" && m.type !== "ArrowFunctionExpression" && m.type !== "AssignmentExpression" && m.type !== "AssignmentPattern" && m.type !== "BinaryExpression" && m.type !== "NewExpression" && m.type !== "ConditionalExpression" && m.type !== "ExpressionStatement" && m.type !== "JsExpressionRoot" && m.type !== "JSXAttribute" && m.type !== "JSXElement" && m.type !== "JSXExpressionContainer" && m.type !== "JSXFragment" && m.type !== "LogicalExpression" && !p(m) && !v(m) && m.type !== "ReturnStatement" && m.type !== "ThrowStatement" && m.type !== "TypeCastExpression" && m.type !== "VariableDeclarator" && m.type !== "YieldExpression";
                case "TypeAnnotation":
                  return E === "returnType" && m.type === "ArrowFunctionExpression" && B(o);
              }
              return false;
            }
            function F(f) {
              return f.type === "BlockStatement" || f.type === "BreakStatement" || f.type === "ClassBody" || f.type === "ClassDeclaration" || f.type === "ClassMethod" || f.type === "ClassProperty" || f.type === "PropertyDefinition" || f.type === "ClassPrivateProperty" || f.type === "ContinueStatement" || f.type === "DebuggerStatement" || f.type === "DeclareClass" || f.type === "DeclareExportAllDeclaration" || f.type === "DeclareExportDeclaration" || f.type === "DeclareFunction" || f.type === "DeclareInterface" || f.type === "DeclareModule" || f.type === "DeclareModuleExports" || f.type === "DeclareVariable" || f.type === "DoWhileStatement" || f.type === "EnumDeclaration" || f.type === "ExportAllDeclaration" || f.type === "ExportDefaultDeclaration" || f.type === "ExportNamedDeclaration" || f.type === "ExpressionStatement" || f.type === "ForInStatement" || f.type === "ForOfStatement" || f.type === "ForStatement" || f.type === "FunctionDeclaration" || f.type === "IfStatement" || f.type === "ImportDeclaration" || f.type === "InterfaceDeclaration" || f.type === "LabeledStatement" || f.type === "MethodDefinition" || f.type === "ReturnStatement" || f.type === "SwitchStatement" || f.type === "ThrowStatement" || f.type === "TryStatement" || f.type === "TSDeclareFunction" || f.type === "TSEnumDeclaration" || f.type === "TSImportEqualsDeclaration" || f.type === "TSInterfaceDeclaration" || f.type === "TSModuleDeclaration" || f.type === "TSNamespaceExportDeclaration" || f.type === "TypeAlias" || f.type === "VariableDeclaration" || f.type === "WhileStatement" || f.type === "WithStatement";
            }
            function A(f) {
              let x = 0, m = f.getValue();
              for (; m; ) {
                let E = f.getParentNode(x++);
                if (E && E.type === "ForStatement" && E.init === m)
                  return true;
                m = E;
              }
              return false;
            }
            function B(f) {
              return l(f, (x) => x.type === "ObjectTypeAnnotation" && l(x, (m) => m.type === "FunctionTypeAnnotation" || void 0) || void 0);
            }
            function I(f) {
              switch (f.type) {
                case "ObjectExpression":
                  return true;
                default:
                  return false;
              }
            }
            function P(f) {
              let x = f.getValue(), m = f.getParentNode(), E = f.getName();
              switch (m.type) {
                case "NGPipeExpression":
                  if (typeof E == "number" && m.arguments[E] === x && m.arguments.length - 1 === E)
                    return f.callParent(P);
                  break;
                case "ObjectProperty":
                  if (E === "value") {
                    let o = f.getParentNode(1);
                    return t3(o.properties) === m;
                  }
                  break;
                case "BinaryExpression":
                case "LogicalExpression":
                  if (E === "right")
                    return f.callParent(P);
                  break;
                case "ConditionalExpression":
                  if (E === "alternate")
                    return f.callParent(P);
                  break;
                case "UnaryExpression":
                  if (m.prefix)
                    return f.callParent(P);
                  break;
              }
              return false;
            }
            function R(f, x) {
              let m = f.getValue(), E = f.getParentNode();
              return m.type === "FunctionExpression" || m.type === "ClassExpression" ? E.type === "ExportDefaultDeclaration" || !T(f, x) : !i(m) || E.type !== "ExportDefaultDeclaration" && T(f, x) ? false : f.call((o) => R(o, x), ...r(f, m));
            }
            n.exports = T;
          } }), eo = ee({ "src/language-js/print-preprocess.js"(e, n) {
            "use strict";
            re();
            function t3(s, a) {
              switch (a.parser) {
                case "json":
                case "json5":
                case "json-stringify":
                case "__js_expression":
                case "__vue_expression":
                case "__vue_ts_expression":
                  return Object.assign(Object.assign({}, s), {}, { type: a.parser.startsWith("__") ? "JsExpressionRoot" : "JsonRoot", node: s, comments: [], rootMarker: a.rootMarker });
                default:
                  return s;
              }
            }
            n.exports = t3;
          } }), qm = ee({ "src/language-js/print/html-binding.js"(e, n) {
            "use strict";
            re();
            var { builders: { join: t3, line: s, group: a, softline: r, indent: u } } = qe();
            function i(c, y, h) {
              let g = c.getValue();
              if (y.__onHtmlBindingRoot && c.getName() === null && y.__onHtmlBindingRoot(g, y), g.type === "File") {
                if (y.__isVueForBindingLeft)
                  return c.call((p) => {
                    let D = t3([",", s], p.map(h, "params")), { params: v } = p.getValue();
                    return v.length === 1 ? D : ["(", u([r, a(D)]), r, ")"];
                  }, "program", "body", 0);
                if (y.__isVueBindings)
                  return c.call((p) => t3([",", s], p.map(h, "params")), "program", "body", 0);
              }
            }
            function l(c) {
              switch (c.type) {
                case "MemberExpression":
                  switch (c.property.type) {
                    case "Identifier":
                    case "NumericLiteral":
                    case "StringLiteral":
                      return l(c.object);
                  }
                  return false;
                case "Identifier":
                  return true;
                default:
                  return false;
              }
            }
            n.exports = { isVueEventBindingExpression: l, printHtmlBinding: i };
          } }), Jn = ee({ "src/language-js/print/binaryish.js"(e, n) {
            "use strict";
            re();
            var { printComments: t3 } = et(), { getLast: s } = Ge(), { builders: { join: a, line: r, softline: u, group: i, indent: l, align: c, indentIfBreak: y }, utils: { cleanDoc: h, getDocParts: g, isConcat: p } } = qe(), { hasLeadingOwnLineComment: D, isBinaryish: v, isJsxNode: w, shouldFlatten: T, hasComment: F, CommentCheckFlags: A, isCallExpression: B, isMemberExpression: I, isObjectProperty: P, isEnabledHackPipeline: R } = Ke(), f = 0;
            function x(o, d, C) {
              let _ = o.getValue(), b = o.getParentNode(), N = o.getParentNode(1), k = _ !== b.body && (b.type === "IfStatement" || b.type === "WhileStatement" || b.type === "SwitchStatement" || b.type === "DoWhileStatement"), $ = R(d) && _.operator === "|>", M = m(o, C, d, false, k);
              if (k)
                return M;
              if ($)
                return i(M);
              if (B(b) && b.callee === _ || b.type === "UnaryExpression" || I(b) && !b.computed)
                return i([l([u, ...M]), u]);
              let q = b.type === "ReturnStatement" || b.type === "ThrowStatement" || b.type === "JSXExpressionContainer" && N.type === "JSXAttribute" || _.operator !== "|" && b.type === "JsExpressionRoot" || _.type !== "NGPipeExpression" && (b.type === "NGRoot" && d.parser === "__ng_binding" || b.type === "NGMicrosyntaxExpression" && N.type === "NGMicrosyntax" && N.body.length === 1) || _ === b.body && b.type === "ArrowFunctionExpression" || _ !== b.body && b.type === "ForStatement" || b.type === "ConditionalExpression" && N.type !== "ReturnStatement" && N.type !== "ThrowStatement" && !B(N) || b.type === "TemplateLiteral", J = b.type === "AssignmentExpression" || b.type === "VariableDeclarator" || b.type === "ClassProperty" || b.type === "PropertyDefinition" || b.type === "TSAbstractPropertyDefinition" || b.type === "ClassPrivateProperty" || P(b), L = v(_.left) && T(_.operator, _.left.operator);
              if (q || E(_) && !L || !E(_) && J)
                return i(M);
              if (M.length === 0)
                return "";
              let Y = w(_.right), V = M.findIndex((W) => typeof W != "string" && !Array.isArray(W) && W.type === "group"), O = M.slice(0, V === -1 ? 1 : V + 1), K = M.slice(O.length, Y ? -1 : void 0), se = Symbol("logicalChain-" + ++f), Q = i([...O, l(K)], { id: se });
              if (!Y)
                return Q;
              let le = s(M);
              return i([Q, y(le, { groupId: se })]);
            }
            function m(o, d, C, _, b) {
              let N = o.getValue();
              if (!v(N))
                return [i(d())];
              let k = [];
              T(N.operator, N.left.operator) ? k = o.call((K) => m(K, d, C, true, b), "left") : k.push(i(d("left")));
              let $ = E(N), M = (N.operator === "|>" || N.type === "NGPipeExpression" || N.operator === "|" && C.parser === "__vue_expression") && !D(C.originalText, N.right), q = N.type === "NGPipeExpression" ? "|" : N.operator, J = N.type === "NGPipeExpression" && N.arguments.length > 0 ? i(l([r, ": ", a([r, ": "], o.map(d, "arguments").map((K) => c(2, i(K))))])) : "", L;
              if ($)
                L = [q, " ", d("right"), J];
              else {
                let se = R(C) && q === "|>" ? o.call((Q) => m(Q, d, C, true, b), "right") : d("right");
                L = [M ? r : "", q, M ? " " : r, se, J];
              }
              let Y = o.getParentNode(), V = F(N.left, A.Trailing | A.Line), O = V || !(b && N.type === "LogicalExpression") && Y.type !== N.type && N.left.type !== N.type && N.right.type !== N.type;
              if (k.push(M ? "" : " ", O ? i(L, { shouldBreak: V }) : L), _ && F(N)) {
                let K = h(t3(o, k, C));
                return p(K) || K.type === "fill" ? g(K) : [K];
              }
              return k;
            }
            function E(o) {
              return o.type !== "LogicalExpression" ? false : !!(o.right.type === "ObjectExpression" && o.right.properties.length > 0 || o.right.type === "ArrayExpression" && o.right.elements.length > 0 || w(o.right));
            }
            n.exports = { printBinaryishExpression: x, shouldInlineLogicalExpression: E };
          } }), Mm = ee({ "src/language-js/print/angular.js"(e, n) {
            "use strict";
            re();
            var { builders: { join: t3, line: s, group: a } } = qe(), { hasNode: r, hasComment: u, getComments: i } = Ke(), { printBinaryishExpression: l } = Jn();
            function c(g, p, D) {
              let v = g.getValue();
              if (!!v.type.startsWith("NG"))
                switch (v.type) {
                  case "NGRoot":
                    return [D("node"), u(v.node) ? " //" + i(v.node)[0].value.trimEnd() : ""];
                  case "NGPipeExpression":
                    return l(g, p, D);
                  case "NGChainedExpression":
                    return a(t3([";", s], g.map((w) => h(w) ? D() : ["(", D(), ")"], "expressions")));
                  case "NGEmptyExpression":
                    return "";
                  case "NGQuotedExpression":
                    return [v.prefix, ": ", v.value.trim()];
                  case "NGMicrosyntax":
                    return g.map((w, T) => [T === 0 ? "" : y(w.getValue(), T, v) ? " " : [";", s], D()], "body");
                  case "NGMicrosyntaxKey":
                    return /^[$_a-z][\w$]*(?:-[$_a-z][\w$])*$/i.test(v.name) ? v.name : JSON.stringify(v.name);
                  case "NGMicrosyntaxExpression":
                    return [D("expression"), v.alias === null ? "" : [" as ", D("alias")]];
                  case "NGMicrosyntaxKeyedExpression": {
                    let w = g.getName(), T = g.getParentNode(), F = y(v, w, T) || (w === 1 && (v.key.name === "then" || v.key.name === "else") || w === 2 && v.key.name === "else" && T.body[w - 1].type === "NGMicrosyntaxKeyedExpression" && T.body[w - 1].key.name === "then") && T.body[0].type === "NGMicrosyntaxExpression";
                    return [D("key"), F ? " " : ": ", D("expression")];
                  }
                  case "NGMicrosyntaxLet":
                    return ["let ", D("key"), v.value === null ? "" : [" = ", D("value")]];
                  case "NGMicrosyntaxAs":
                    return [D("key"), " as ", D("alias")];
                  default:
                    throw new Error(`Unknown Angular node type: ${JSON.stringify(v.type)}.`);
                }
            }
            function y(g, p, D) {
              return g.type === "NGMicrosyntaxKeyedExpression" && g.key.name === "of" && p === 1 && D.body[0].type === "NGMicrosyntaxLet" && D.body[0].value === null;
            }
            function h(g) {
              return r(g.getValue(), (p) => {
                switch (p.type) {
                  case void 0:
                    return false;
                  case "CallExpression":
                  case "OptionalCallExpression":
                  case "AssignmentExpression":
                    return true;
                }
              });
            }
            n.exports = { printAngular: c };
          } }), Rm = ee({ "src/language-js/print/jsx.js"(e, n) {
            "use strict";
            re();
            var { printComments: t3, printDanglingComments: s } = et(), { builders: { line: a, hardline: r, softline: u, group: i, indent: l, conditionalGroup: c, fill: y, ifBreak: h, lineSuffixBoundary: g, join: p }, utils: { willBreak: D } } = qe(), { getLast: v, getPreferredQuote: w } = Ge(), { isJsxNode: T, rawText: F, isLiteral: A, isCallExpression: B, isStringLiteral: I, isBinaryish: P, hasComment: R, CommentCheckFlags: f, hasNodeIgnoreComment: x } = Ke(), m = Ot(), { willPrintOwnComments: E } = Za(), o = (H) => H === "" || H === a || H === r || H === u;
            function d(H, Z, ne) {
              let fe = H.getValue();
              if (fe.type === "JSXElement" && oe(fe))
                return [ne("openingElement"), ne("closingElement")];
              let ge = fe.type === "JSXElement" ? ne("openingElement") : ne("openingFragment"), Ce = fe.type === "JSXElement" ? ne("closingElement") : ne("closingFragment");
              if (fe.children.length === 1 && fe.children[0].type === "JSXExpressionContainer" && (fe.children[0].expression.type === "TemplateLiteral" || fe.children[0].expression.type === "TaggedTemplateExpression"))
                return [ge, ...H.map(ne, "children"), Ce];
              fe.children = fe.children.map((S) => Ae(S) ? { type: "JSXText", value: " ", raw: " " } : S);
              let _e = fe.children.some(T), Oe = fe.children.filter((S) => S.type === "JSXExpressionContainer").length > 1, pe = fe.type === "JSXElement" && fe.openingElement.attributes.length > 1, ie = D(ge) || _e || pe || Oe, ve = H.getParentNode().rootMarker === "mdx", ce = Z.singleQuote ? "{' '}" : '{" "}', U = ve ? " " : h([ce, u], " "), de = fe.openingElement && fe.openingElement.name && fe.openingElement.name.name === "fbt", De = C(H, Z, ne, U, de), he = fe.children.some((S) => ae(S));
              for (let S = De.length - 2; S >= 0; S--) {
                let G = De[S] === "" && De[S + 1] === "", te = De[S] === r && De[S + 1] === "" && De[S + 2] === r, Ee = (De[S] === u || De[S] === r) && De[S + 1] === "" && De[S + 2] === U, Re = De[S] === U && De[S + 1] === "" && (De[S + 2] === u || De[S + 2] === r), Te = De[S] === U && De[S + 1] === "" && De[S + 2] === U, Pe = De[S] === u && De[S + 1] === "" && De[S + 2] === r || De[S] === r && De[S + 1] === "" && De[S + 2] === u;
                te && he || G || Ee || Te || Pe ? De.splice(S, 2) : Re && De.splice(S + 1, 2);
              }
              for (; De.length > 0 && o(v(De)); )
                De.pop();
              for (; De.length > 1 && o(De[0]) && o(De[1]); )
                De.shift(), De.shift();
              let Be = [];
              for (let [S, G] of De.entries()) {
                if (G === U) {
                  if (S === 1 && De[S - 1] === "") {
                    if (De.length === 2) {
                      Be.push(ce);
                      continue;
                    }
                    Be.push([ce, r]);
                    continue;
                  } else if (S === De.length - 1) {
                    Be.push(ce);
                    continue;
                  } else if (De[S - 1] === "" && De[S - 2] === r) {
                    Be.push(ce);
                    continue;
                  }
                }
                Be.push(G), D(G) && (ie = true);
              }
              let Se = he ? y(Be) : i(Be, { shouldBreak: true });
              if (ve)
                return Se;
              let ye = i([ge, l([r, Se]), r, Ce]);
              return ie ? ye : c([i([ge, ...De, Ce]), ye]);
            }
            function C(H, Z, ne, fe, ge) {
              let Ce = [];
              return H.each((_e, Oe, pe) => {
                let ie = _e.getValue();
                if (A(ie)) {
                  let ve = F(ie);
                  if (ae(ie)) {
                    let ce = ve.split(le);
                    if (ce[0] === "") {
                      if (Ce.push(""), ce.shift(), /\n/.test(ce[0])) {
                        let de = pe[Oe + 1];
                        Ce.push(b(ge, ce[1], ie, de));
                      } else
                        Ce.push(fe);
                      ce.shift();
                    }
                    let U;
                    if (v(ce) === "" && (ce.pop(), U = ce.pop()), ce.length === 0)
                      return;
                    for (let [de, De] of ce.entries())
                      de % 2 === 1 ? Ce.push(a) : Ce.push(De);
                    if (U !== void 0)
                      if (/\n/.test(U)) {
                        let de = pe[Oe + 1];
                        Ce.push(b(ge, v(Ce), ie, de));
                      } else
                        Ce.push(fe);
                    else {
                      let de = pe[Oe + 1];
                      Ce.push(_(ge, v(Ce), ie, de));
                    }
                  } else
                    /\n/.test(ve) ? ve.match(/\n/g).length > 1 && Ce.push("", r) : Ce.push("", fe);
                } else {
                  let ve = ne();
                  Ce.push(ve);
                  let ce = pe[Oe + 1];
                  if (ce && ae(ce)) {
                    let de = X(F(ce)).split(le)[0];
                    Ce.push(_(ge, de, ie, ce));
                  } else
                    Ce.push(r);
                }
              }, "children"), Ce;
            }
            function _(H, Z, ne, fe) {
              return H ? "" : ne.type === "JSXElement" && !ne.closingElement || fe && fe.type === "JSXElement" && !fe.closingElement ? Z.length === 1 ? u : r : u;
            }
            function b(H, Z, ne, fe) {
              return H ? r : Z.length === 1 ? ne.type === "JSXElement" && !ne.closingElement || fe && fe.type === "JSXElement" && !fe.closingElement ? r : u : r;
            }
            function N(H, Z, ne) {
              let fe = H.getParentNode();
              if (!fe || { ArrayExpression: true, JSXAttribute: true, JSXElement: true, JSXExpressionContainer: true, JSXFragment: true, ExpressionStatement: true, CallExpression: true, OptionalCallExpression: true, ConditionalExpression: true, JsExpressionRoot: true }[fe.type])
                return Z;
              let Ce = H.match(void 0, (Oe) => Oe.type === "ArrowFunctionExpression", B, (Oe) => Oe.type === "JSXExpressionContainer"), _e = m(H, ne);
              return i([_e ? "" : h("("), l([u, Z]), u, _e ? "" : h(")")], { shouldBreak: Ce });
            }
            function k(H, Z, ne) {
              let fe = H.getValue(), ge = [];
              if (ge.push(ne("name")), fe.value) {
                let Ce;
                if (I(fe.value)) {
                  let Oe = F(fe.value).slice(1, -1).replace(/&apos;/g, "'").replace(/&quot;/g, '"'), { escaped: pe, quote: ie, regex: ve } = w(Oe, Z.jsxSingleQuote ? "'" : '"');
                  Oe = Oe.replace(ve, pe), Ce = [ie, Oe, ie];
                } else
                  Ce = ne("value");
                ge.push("=", Ce);
              }
              return ge;
            }
            function $(H, Z, ne) {
              let fe = H.getValue(), ge = (Ce, _e) => Ce.type === "JSXEmptyExpression" || !R(Ce) && (Ce.type === "ArrayExpression" || Ce.type === "ObjectExpression" || Ce.type === "ArrowFunctionExpression" || Ce.type === "AwaitExpression" && (ge(Ce.argument, Ce) || Ce.argument.type === "JSXElement") || B(Ce) || Ce.type === "FunctionExpression" || Ce.type === "TemplateLiteral" || Ce.type === "TaggedTemplateExpression" || Ce.type === "DoExpression" || T(_e) && (Ce.type === "ConditionalExpression" || P(Ce)));
              return ge(fe.expression, H.getParentNode(0)) ? i(["{", ne("expression"), g, "}"]) : i(["{", l([u, ne("expression")]), u, g, "}"]);
            }
            function M(H, Z, ne) {
              let fe = H.getValue(), ge = fe.name && R(fe.name) || fe.typeParameters && R(fe.typeParameters);
              if (fe.selfClosing && fe.attributes.length === 0 && !ge)
                return ["<", ne("name"), ne("typeParameters"), " />"];
              if (fe.attributes && fe.attributes.length === 1 && fe.attributes[0].value && I(fe.attributes[0].value) && !fe.attributes[0].value.value.includes(`
`) && !ge && !R(fe.attributes[0]))
                return i(["<", ne("name"), ne("typeParameters"), " ", ...H.map(ne, "attributes"), fe.selfClosing ? " />" : ">"]);
              let Ce = fe.attributes && fe.attributes.some((Oe) => Oe.value && I(Oe.value) && Oe.value.value.includes(`
`)), _e = Z.singleAttributePerLine && fe.attributes.length > 1 ? r : a;
              return i(["<", ne("name"), ne("typeParameters"), l(H.map(() => [_e, ne()], "attributes")), ...q(fe, Z, ge)], { shouldBreak: Ce });
            }
            function q(H, Z, ne) {
              return H.selfClosing ? [a, "/>"] : J(H, Z, ne) ? [">"] : [u, ">"];
            }
            function J(H, Z, ne) {
              let fe = H.attributes.length > 0 && R(v(H.attributes), f.Trailing);
              return H.attributes.length === 0 && !ne || (Z.bracketSameLine || Z.jsxBracketSameLine) && (!ne || H.attributes.length > 0) && !fe;
            }
            function L(H, Z, ne) {
              let fe = H.getValue(), ge = [];
              ge.push("</");
              let Ce = ne("name");
              return R(fe.name, f.Leading | f.Line) ? ge.push(l([r, Ce]), r) : R(fe.name, f.Leading | f.Block) ? ge.push(" ", Ce) : ge.push(Ce), ge.push(">"), ge;
            }
            function Y(H, Z) {
              let ne = H.getValue(), fe = R(ne), ge = R(ne, f.Line), Ce = ne.type === "JSXOpeningFragment";
              return [Ce ? "<" : "</", l([ge ? r : fe && !Ce ? " " : "", s(H, Z, true)]), ge ? r : "", ">"];
            }
            function V(H, Z, ne) {
              let fe = t3(H, d(H, Z, ne), Z);
              return N(H, fe, Z);
            }
            function O(H, Z) {
              let ne = H.getValue(), fe = R(ne, f.Line);
              return [s(H, Z, !fe), fe ? r : ""];
            }
            function K(H, Z, ne) {
              let fe = H.getValue();
              return ["{", H.call((ge) => {
                let Ce = ["...", ne()], _e = ge.getValue();
                return !R(_e) || !E(ge) ? Ce : [l([u, t3(ge, Ce, Z)]), u];
              }, fe.type === "JSXSpreadAttribute" ? "argument" : "expression"), "}"];
            }
            function se(H, Z, ne) {
              let fe = H.getValue();
              if (!!fe.type.startsWith("JSX"))
                switch (fe.type) {
                  case "JSXAttribute":
                    return k(H, Z, ne);
                  case "JSXIdentifier":
                    return String(fe.name);
                  case "JSXNamespacedName":
                    return p(":", [ne("namespace"), ne("name")]);
                  case "JSXMemberExpression":
                    return p(".", [ne("object"), ne("property")]);
                  case "JSXSpreadAttribute":
                    return K(H, Z, ne);
                  case "JSXSpreadChild":
                    return K(H, Z, ne);
                  case "JSXExpressionContainer":
                    return $(H, Z, ne);
                  case "JSXFragment":
                  case "JSXElement":
                    return V(H, Z, ne);
                  case "JSXOpeningElement":
                    return M(H, Z, ne);
                  case "JSXClosingElement":
                    return L(H, Z, ne);
                  case "JSXOpeningFragment":
                  case "JSXClosingFragment":
                    return Y(H, Z);
                  case "JSXEmptyExpression":
                    return O(H, Z);
                  case "JSXText":
                    throw new Error("JSXTest should be handled by JSXElement");
                  default:
                    throw new Error(`Unknown JSX node type: ${JSON.stringify(fe.type)}.`);
                }
            }
            var Q = ` 
\r	`, le = new RegExp("([" + Q + "]+)"), W = new RegExp("[^" + Q + "]"), X = (H) => H.replace(new RegExp("(?:^" + le.source + "|" + le.source + "$)"), "");
            function oe(H) {
              if (H.children.length === 0)
                return true;
              if (H.children.length > 1)
                return false;
              let Z = H.children[0];
              return A(Z) && !ae(Z);
            }
            function ae(H) {
              return A(H) && (W.test(F(H)) || !/\n/.test(F(H)));
            }
            function Ae(H) {
              return H.type === "JSXExpressionContainer" && A(H.expression) && H.expression.value === " " && !R(H.expression);
            }
            function z(H) {
              let Z = H.getValue(), ne = H.getParentNode();
              if (!ne || !Z || !T(Z) || !T(ne))
                return false;
              let fe = ne.children.indexOf(Z), ge = null;
              for (let Ce = fe; Ce > 0; Ce--) {
                let _e = ne.children[Ce - 1];
                if (!(_e.type === "JSXText" && !ae(_e))) {
                  ge = _e;
                  break;
                }
              }
              return ge && ge.type === "JSXExpressionContainer" && ge.expression.type === "JSXEmptyExpression" && x(ge.expression);
            }
            n.exports = { hasJsxIgnoreComment: z, printJsx: se };
          } }), Dt = ee({ "src/language-js/print/misc.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3 } = Ge(), { builders: { indent: s, join: a, line: r } } = qe(), { isFlowAnnotationComment: u } = Ke();
            function i(v) {
              let w = v.getValue();
              return !w.optional || w.type === "Identifier" && w === v.getParentNode().key ? "" : w.type === "OptionalCallExpression" || w.type === "OptionalMemberExpression" && w.computed ? "?." : "?";
            }
            function l(v) {
              return v.getValue().definite || v.match(void 0, (w, T) => T === "id" && w.type === "VariableDeclarator" && w.definite) ? "!" : "";
            }
            function c(v, w, T) {
              let F = v.getValue();
              return F.typeArguments ? T("typeArguments") : F.typeParameters ? T("typeParameters") : "";
            }
            function y(v, w, T) {
              let F = v.getValue();
              if (!F.typeAnnotation)
                return "";
              let A = v.getParentNode(), B = A.type === "DeclareFunction" && A.id === F;
              return u(w.originalText, F.typeAnnotation) ? [" /*: ", T("typeAnnotation"), " */"] : [B ? "" : ": ", T("typeAnnotation")];
            }
            function h(v, w, T) {
              return ["::", T("callee")];
            }
            function g(v, w, T) {
              let F = v.getValue();
              return t3(F.modifiers) ? [a(" ", v.map(T, "modifiers")), " "] : "";
            }
            function p(v, w, T) {
              return v.type === "EmptyStatement" ? ";" : v.type === "BlockStatement" || T ? [" ", w] : s([r, w]);
            }
            function D(v, w, T) {
              return ["...", T("argument"), y(v, w, T)];
            }
            n.exports = { printOptionalToken: i, printDefiniteToken: l, printFunctionTypeParameters: c, printBindExpressionCallee: h, printTypeScriptModifiers: g, printTypeAnnotation: y, printRestSpread: D, adjustClause: p };
          } }), Qt = ee({ "src/language-js/print/array.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { builders: { line: s, softline: a, hardline: r, group: u, indent: i, ifBreak: l, fill: c } } = qe(), { getLast: y, hasNewline: h } = Ge(), { shouldPrintComma: g, hasComment: p, CommentCheckFlags: D, isNextLineEmpty: v, isNumericLiteral: w, isSignedNumericLiteral: T } = Ke(), { locStart: F } = it(), { printOptionalToken: A, printTypeAnnotation: B } = Dt();
            function I(x, m, E) {
              let o = x.getValue(), d = [], C = o.type === "TupleExpression" ? "#[" : "[", _ = "]";
              if (o.elements.length === 0)
                p(o, D.Dangling) ? d.push(u([C, t3(x, m), a, _])) : d.push(C, _);
              else {
                let b = y(o.elements), N = !(b && b.type === "RestElement"), k = b === null, $ = Symbol("array"), M = !m.__inJestEach && o.elements.length > 1 && o.elements.every((L, Y, V) => {
                  let O = L && L.type;
                  if (O !== "ArrayExpression" && O !== "ObjectExpression")
                    return false;
                  let K = V[Y + 1];
                  if (K && O !== K.type)
                    return false;
                  let se = O === "ArrayExpression" ? "elements" : "properties";
                  return L[se] && L[se].length > 1;
                }), q = P(o, m), J = N ? k ? "," : g(m) ? q ? l(",", "", { groupId: $ }) : l(",") : "" : "";
                d.push(u([C, i([a, q ? f(x, m, E, J) : [R(x, m, "elements", E), J], t3(x, m, true)]), a, _], { shouldBreak: M, id: $ }));
              }
              return d.push(A(x), B(x, m, E)), d;
            }
            function P(x, m) {
              return x.elements.length > 1 && x.elements.every((E) => E && (w(E) || T(E) && !p(E.argument)) && !p(E, D.Trailing | D.Line, (o) => !h(m.originalText, F(o), { backwards: true })));
            }
            function R(x, m, E, o) {
              let d = [], C = [];
              return x.each((_) => {
                d.push(C, u(o())), C = [",", s], _.getValue() && v(_.getValue(), m) && C.push(a);
              }, E), d;
            }
            function f(x, m, E, o) {
              let d = [];
              return x.each((C, _, b) => {
                let N = _ === b.length - 1;
                d.push([E(), N ? o : ","]), N || d.push(v(C.getValue(), m) ? [r, r] : p(b[_ + 1], D.Leading | D.Line) ? r : s);
              }, "elements"), c(d);
            }
            n.exports = { printArray: I, printArrayItems: R, isConciselyPrintedArray: P };
          } }), to = ee({ "src/language-js/print/call-arguments.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { getLast: s, getPenultimate: a } = Ge(), { getFunctionParameters: r, hasComment: u, CommentCheckFlags: i, isFunctionCompositionArgs: l, isJsxNode: c, isLongCurriedCallExpression: y, shouldPrintComma: h, getCallArguments: g, iterateCallArgumentsPath: p, isNextLineEmpty: D, isCallExpression: v, isStringLiteral: w, isObjectProperty: T, isTSTypeExpression: F } = Ke(), { builders: { line: A, hardline: B, softline: I, group: P, indent: R, conditionalGroup: f, ifBreak: x, breakParent: m }, utils: { willBreak: E } } = qe(), { ArgExpansionBailout: o } = Kt(), { isConciselyPrintedArray: d } = Qt();
            function C(q, J, L) {
              let Y = q.getValue(), V = Y.type === "ImportExpression", O = g(Y);
              if (O.length === 0)
                return ["(", t3(q, J, true), ")"];
              if (k(O))
                return ["(", L(["arguments", 0]), ", ", L(["arguments", 1]), ")"];
              let K = false, se = false, Q = O.length - 1, le = [];
              p(q, (z, H) => {
                let Z = z.getNode(), ne = [L()];
                H === Q || (D(Z, J) ? (H === 0 && (se = true), K = true, ne.push(",", B, B)) : ne.push(",", A)), le.push(ne);
              });
              let W = !(V || Y.callee && Y.callee.type === "Import") && h(J, "all") ? "," : "";
              function X() {
                return P(["(", R([A, ...le]), W, A, ")"], { shouldBreak: true });
              }
              if (K || q.getParentNode().type !== "Decorator" && l(O))
                return X();
              let oe = N(O), ae = b(O, J);
              if (oe || ae) {
                if (oe ? le.slice(1).some(E) : le.slice(0, -1).some(E))
                  return X();
                let z = [];
                try {
                  q.try(() => {
                    p(q, (H, Z) => {
                      oe && Z === 0 && (z = [[L([], { expandFirstArg: true }), le.length > 1 ? "," : "", se ? B : A, se ? B : ""], ...le.slice(1)]), ae && Z === Q && (z = [...le.slice(0, -1), L([], { expandLastArg: true })]);
                    });
                  });
                } catch (H) {
                  if (H instanceof o)
                    return X();
                  throw H;
                }
                return [le.some(E) ? m : "", f([["(", ...z, ")"], oe ? ["(", P(z[0], { shouldBreak: true }), ...z.slice(1), ")"] : ["(", ...le.slice(0, -1), P(s(z), { shouldBreak: true }), ")"], X()])];
              }
              let Ae = ["(", R([I, ...le]), x(W), I, ")"];
              return y(q) ? Ae : P(Ae, { shouldBreak: le.some(E) || K });
            }
            function _(q) {
              let J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
              return q.type === "ObjectExpression" && (q.properties.length > 0 || u(q)) || q.type === "ArrayExpression" && (q.elements.length > 0 || u(q)) || q.type === "TSTypeAssertion" && _(q.expression) || F(q) && _(q.expression) || q.type === "FunctionExpression" || q.type === "ArrowFunctionExpression" && (!q.returnType || !q.returnType.typeAnnotation || q.returnType.typeAnnotation.type !== "TSTypeReference" || $(q.body)) && (q.body.type === "BlockStatement" || q.body.type === "ArrowFunctionExpression" && _(q.body, true) || q.body.type === "ObjectExpression" || q.body.type === "ArrayExpression" || !J && (v(q.body) || q.body.type === "ConditionalExpression") || c(q.body)) || q.type === "DoExpression" || q.type === "ModuleExpression";
            }
            function b(q, J) {
              let L = s(q), Y = a(q);
              return !u(L, i.Leading) && !u(L, i.Trailing) && _(L) && (!Y || Y.type !== L.type) && (q.length !== 2 || Y.type !== "ArrowFunctionExpression" || L.type !== "ArrayExpression") && !(q.length > 1 && L.type === "ArrayExpression" && d(L, J));
            }
            function N(q) {
              if (q.length !== 2)
                return false;
              let [J, L] = q;
              return J.type === "ModuleExpression" && M(L) ? true : !u(J) && (J.type === "FunctionExpression" || J.type === "ArrowFunctionExpression" && J.body.type === "BlockStatement") && L.type !== "FunctionExpression" && L.type !== "ArrowFunctionExpression" && L.type !== "ConditionalExpression" && !_(L);
            }
            function k(q) {
              return q.length === 2 && q[0].type === "ArrowFunctionExpression" && r(q[0]).length === 0 && q[0].body.type === "BlockStatement" && q[1].type === "ArrayExpression" && !q.some((J) => u(J));
            }
            function $(q) {
              return q.type === "BlockStatement" && (q.body.some((J) => J.type !== "EmptyStatement") || u(q, i.Dangling));
            }
            function M(q) {
              return q.type === "ObjectExpression" && q.properties.length === 1 && T(q.properties[0]) && q.properties[0].key.type === "Identifier" && q.properties[0].key.name === "type" && w(q.properties[0].value) && q.properties[0].value.value === "module";
            }
            n.exports = C;
          } }), ro = ee({ "src/language-js/print/member.js"(e, n) {
            "use strict";
            re();
            var { builders: { softline: t3, group: s, indent: a, label: r } } = qe(), { isNumericLiteral: u, isMemberExpression: i, isCallExpression: l } = Ke(), { printOptionalToken: c } = Dt();
            function y(g, p, D) {
              let v = g.getValue(), w = g.getParentNode(), T, F = 0;
              do
                T = g.getParentNode(F), F++;
              while (T && (i(T) || T.type === "TSNonNullExpression"));
              let A = D("object"), B = h(g, p, D), I = T && (T.type === "NewExpression" || T.type === "BindExpression" || T.type === "AssignmentExpression" && T.left.type !== "Identifier") || v.computed || v.object.type === "Identifier" && v.property.type === "Identifier" && !i(w) || (w.type === "AssignmentExpression" || w.type === "VariableDeclarator") && (l(v.object) && v.object.arguments.length > 0 || v.object.type === "TSNonNullExpression" && l(v.object.expression) && v.object.expression.arguments.length > 0 || A.label === "member-chain");
              return r(A.label === "member-chain" ? "member-chain" : "member", [A, I ? B : s(a([t3, B]))]);
            }
            function h(g, p, D) {
              let v = D("property"), w = g.getValue(), T = c(g);
              return w.computed ? !w.property || u(w.property) ? [T, "[", v, "]"] : s([T, "[", a([t3, v]), t3, "]"]) : [T, ".", v];
            }
            n.exports = { printMemberExpression: y, printMemberLookup: h };
          } }), $m = ee({ "src/language-js/print/member-chain.js"(e, n) {
            "use strict";
            re();
            var { printComments: t3 } = et(), { getLast: s, isNextLineEmptyAfterIndex: a, getNextNonSpaceNonCommentCharacterIndex: r } = Ge(), u = Ot(), { isCallExpression: i, isMemberExpression: l, isFunctionOrArrowExpression: c, isLongCurriedCallExpression: y, isMemberish: h, isNumericLiteral: g, isSimpleCallArgument: p, hasComment: D, CommentCheckFlags: v, isNextLineEmpty: w } = Ke(), { locEnd: T } = it(), { builders: { join: F, hardline: A, group: B, indent: I, conditionalGroup: P, breakParent: R, label: f }, utils: { willBreak: x } } = qe(), m = to(), { printMemberLookup: E } = ro(), { printOptionalToken: o, printFunctionTypeParameters: d, printBindExpressionCallee: C } = Dt();
            function _(b, N, k) {
              let $ = b.getParentNode(), M = !$ || $.type === "ExpressionStatement", q = [];
              function J(ie) {
                let { originalText: ve } = N, ce = r(ve, ie, T);
                return ve.charAt(ce) === ")" ? ce !== false && a(ve, ce + 1) : w(ie, N);
              }
              function L(ie) {
                let ve = ie.getValue();
                i(ve) && (h(ve.callee) || i(ve.callee)) ? (q.unshift({ node: ve, printed: [t3(ie, [o(ie), d(ie, N, k), m(ie, N, k)], N), J(ve) ? A : ""] }), ie.call((ce) => L(ce), "callee")) : h(ve) ? (q.unshift({ node: ve, needsParens: u(ie, N), printed: t3(ie, l(ve) ? E(ie, N, k) : C(ie, N, k), N) }), ie.call((ce) => L(ce), "object")) : ve.type === "TSNonNullExpression" ? (q.unshift({ node: ve, printed: t3(ie, "!", N) }), ie.call((ce) => L(ce), "expression")) : q.unshift({ node: ve, printed: k() });
              }
              let Y = b.getValue();
              q.unshift({ node: Y, printed: [o(b), d(b, N, k), m(b, N, k)] }), Y.callee && b.call((ie) => L(ie), "callee");
              let V = [], O = [q[0]], K = 1;
              for (; K < q.length && (q[K].node.type === "TSNonNullExpression" || i(q[K].node) || l(q[K].node) && q[K].node.computed && g(q[K].node.property)); ++K)
                O.push(q[K]);
              if (!i(q[0].node))
                for (; K + 1 < q.length && (h(q[K].node) && h(q[K + 1].node)); ++K)
                  O.push(q[K]);
              V.push(O), O = [];
              let se = false;
              for (; K < q.length; ++K) {
                if (se && h(q[K].node)) {
                  if (q[K].node.computed && g(q[K].node.property)) {
                    O.push(q[K]);
                    continue;
                  }
                  V.push(O), O = [], se = false;
                }
                (i(q[K].node) || q[K].node.type === "ImportExpression") && (se = true), O.push(q[K]), D(q[K].node, v.Trailing) && (V.push(O), O = [], se = false);
              }
              O.length > 0 && V.push(O);
              function Q(ie) {
                return /^[A-Z]|^[$_]+$/.test(ie);
              }
              function le(ie) {
                return ie.length <= N.tabWidth;
              }
              function W(ie) {
                let ve = ie[1].length > 0 && ie[1][0].node.computed;
                if (ie[0].length === 1) {
                  let U = ie[0][0].node;
                  return U.type === "ThisExpression" || U.type === "Identifier" && (Q(U.name) || M && le(U.name) || ve);
                }
                let ce = s(ie[0]).node;
                return l(ce) && ce.property.type === "Identifier" && (Q(ce.property.name) || ve);
              }
              let X = V.length >= 2 && !D(V[1][0].node) && W(V);
              function oe(ie) {
                let ve = ie.map((ce) => ce.printed);
                return ie.length > 0 && s(ie).needsParens ? ["(", ...ve, ")"] : ve;
              }
              function ae(ie) {
                return ie.length === 0 ? "" : I(B([A, F(A, ie.map(oe))]));
              }
              let Ae = V.map(oe), z = Ae, H = X ? 3 : 2, Z = V.flat(), ne = Z.slice(1, -1).some((ie) => D(ie.node, v.Leading)) || Z.slice(0, -1).some((ie) => D(ie.node, v.Trailing)) || V[H] && D(V[H][0].node, v.Leading);
              if (V.length <= H && !ne)
                return y(b) ? z : B(z);
              let fe = s(V[X ? 1 : 0]).node, ge = !i(fe) && J(fe), Ce = [oe(V[0]), X ? V.slice(1, 2).map(oe) : "", ge ? A : "", ae(V.slice(X ? 2 : 1))], _e = q.map((ie) => {
                let { node: ve } = ie;
                return ve;
              }).filter(i);
              function Oe() {
                let ie = s(s(V)).node, ve = s(Ae);
                return i(ie) && x(ve) && _e.slice(0, -1).some((ce) => ce.arguments.some(c));
              }
              let pe;
              return ne || _e.length > 2 && _e.some((ie) => !ie.arguments.every((ve) => p(ve, 0))) || Ae.slice(0, -1).some(x) || Oe() ? pe = B(Ce) : pe = [x(z) || ge ? R : "", P([z, Ce])], f("member-chain", pe);
            }
            n.exports = _;
          } }), no = ee({ "src/language-js/print/call-expression.js"(e, n) {
            "use strict";
            re();
            var { builders: { join: t3, group: s } } = qe(), a = Ot(), { getCallArguments: r, hasFlowAnnotationComment: u, isCallExpression: i, isMemberish: l, isStringLiteral: c, isTemplateOnItsOwnLine: y, isTestCall: h, iterateCallArgumentsPath: g } = Ke(), p = $m(), D = to(), { printOptionalToken: v, printFunctionTypeParameters: w } = Dt();
            function T(A, B, I) {
              let P = A.getValue(), R = A.getParentNode(), f = P.type === "NewExpression", x = P.type === "ImportExpression", m = v(A), E = r(P);
              if (E.length > 0 && (!x && !f && F(P, R) || E.length === 1 && y(E[0], B.originalText) || !f && h(P, R))) {
                let C = [];
                return g(A, () => {
                  C.push(I());
                }), [f ? "new " : "", I("callee"), m, w(A, B, I), "(", t3(", ", C), ")"];
              }
              let o = (B.parser === "babel" || B.parser === "babel-flow") && P.callee && P.callee.type === "Identifier" && u(P.callee.trailingComments);
              if (o && (P.callee.trailingComments[0].printed = true), !x && !f && l(P.callee) && !A.call((C) => a(C, B), "callee"))
                return p(A, B, I);
              let d = [f ? "new " : "", x ? "import" : I("callee"), m, o ? `/*:: ${P.callee.trailingComments[0].value.slice(2).trim()} */` : "", w(A, B, I), D(A, B, I)];
              return x || i(P.callee) ? s(d) : d;
            }
            function F(A, B) {
              if (A.callee.type !== "Identifier")
                return false;
              if (A.callee.name === "require")
                return true;
              if (A.callee.name === "define") {
                let I = r(A);
                return B.type === "ExpressionStatement" && (I.length === 1 || I.length === 2 && I[0].type === "ArrayExpression" || I.length === 3 && c(I[0]) && I[1].type === "ArrayExpression");
              }
              return false;
            }
            n.exports = { printCallExpression: T };
          } }), Zt = ee({ "src/language-js/print/assignment.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3, getStringWidth: s } = Ge(), { builders: { line: a, group: r, indent: u, indentIfBreak: i, lineSuffixBoundary: l }, utils: { cleanDoc: c, willBreak: y, canBreak: h } } = qe(), { hasLeadingOwnLineComment: g, isBinaryish: p, isStringLiteral: D, isLiteral: v, isNumericLiteral: w, isCallExpression: T, isMemberExpression: F, getCallArguments: A, rawText: B, hasComment: I, isSignedNumericLiteral: P, isObjectProperty: R } = Ke(), { shouldInlineLogicalExpression: f } = Jn(), { printCallExpression: x } = no();
            function m(W, X, oe, ae, Ae, z) {
              let H = d(W, X, oe, ae, z), Z = oe(z, { assignmentLayout: H });
              switch (H) {
                case "break-after-operator":
                  return r([r(ae), Ae, r(u([a, Z]))]);
                case "never-break-after-operator":
                  return r([r(ae), Ae, " ", Z]);
                case "fluid": {
                  let ne = Symbol("assignment");
                  return r([r(ae), Ae, r(u(a), { id: ne }), l, i(Z, { groupId: ne })]);
                }
                case "break-lhs":
                  return r([ae, Ae, " ", r(Z)]);
                case "chain":
                  return [r(ae), Ae, a, Z];
                case "chain-tail":
                  return [r(ae), Ae, u([a, Z])];
                case "chain-tail-arrow-chain":
                  return [r(ae), Ae, Z];
                case "only-left":
                  return ae;
              }
            }
            function E(W, X, oe) {
              let ae = W.getValue();
              return m(W, X, oe, oe("left"), [" ", ae.operator], "right");
            }
            function o(W, X, oe) {
              return m(W, X, oe, oe("id"), " =", "init");
            }
            function d(W, X, oe, ae, Ae) {
              let z = W.getValue(), H = z[Ae];
              if (!H)
                return "only-left";
              let Z = !b(H);
              if (W.match(b, N, (Ce) => !Z || Ce.type !== "ExpressionStatement" && Ce.type !== "VariableDeclaration"))
                return Z ? H.type === "ArrowFunctionExpression" && H.body.type === "ArrowFunctionExpression" ? "chain-tail-arrow-chain" : "chain-tail" : "chain";
              if (!Z && b(H.right) || g(X.originalText, H))
                return "break-after-operator";
              if (H.type === "CallExpression" && H.callee.name === "require" || X.parser === "json5" || X.parser === "json")
                return "never-break-after-operator";
              if (_(z) || k(z) || q(z) || J(z) && h(ae))
                return "break-lhs";
              let ge = se(z, ae, X);
              return W.call(() => C(W, X, oe, ge), Ae) ? "break-after-operator" : ge || H.type === "TemplateLiteral" || H.type === "TaggedTemplateExpression" || H.type === "BooleanLiteral" || w(H) || H.type === "ClassExpression" ? "never-break-after-operator" : "fluid";
            }
            function C(W, X, oe, ae) {
              let Ae = W.getValue();
              if (p(Ae) && !f(Ae))
                return true;
              switch (Ae.type) {
                case "StringLiteralTypeAnnotation":
                case "SequenceExpression":
                  return true;
                case "ConditionalExpression": {
                  let { test: Z } = Ae;
                  return p(Z) && !f(Z);
                }
                case "ClassExpression":
                  return t3(Ae.decorators);
              }
              if (ae)
                return false;
              let z = Ae, H = [];
              for (; ; )
                if (z.type === "UnaryExpression")
                  z = z.argument, H.push("argument");
                else if (z.type === "TSNonNullExpression")
                  z = z.expression, H.push("expression");
                else
                  break;
              return !!(D(z) || W.call(() => V(W, X, oe), ...H));
            }
            function _(W) {
              if (N(W)) {
                let X = W.left || W.id;
                return X.type === "ObjectPattern" && X.properties.length > 2 && X.properties.some((oe) => R(oe) && (!oe.shorthand || oe.value && oe.value.type === "AssignmentPattern"));
              }
              return false;
            }
            function b(W) {
              return W.type === "AssignmentExpression";
            }
            function N(W) {
              return b(W) || W.type === "VariableDeclarator";
            }
            function k(W) {
              let X = $(W);
              if (t3(X)) {
                let oe = W.type === "TSTypeAliasDeclaration" ? "constraint" : "bound";
                if (X.length > 1 && X.some((ae) => ae[oe] || ae.default))
                  return true;
              }
              return false;
            }
            function $(W) {
              return M(W) && W.typeParameters && W.typeParameters.params ? W.typeParameters.params : null;
            }
            function M(W) {
              return W.type === "TSTypeAliasDeclaration" || W.type === "TypeAlias";
            }
            function q(W) {
              if (W.type !== "VariableDeclarator")
                return false;
              let { typeAnnotation: X } = W.id;
              if (!X || !X.typeAnnotation)
                return false;
              let oe = L(X.typeAnnotation);
              return t3(oe) && oe.length > 1 && oe.some((ae) => t3(L(ae)) || ae.type === "TSConditionalType");
            }
            function J(W) {
              return W.type === "VariableDeclarator" && W.init && W.init.type === "ArrowFunctionExpression";
            }
            function L(W) {
              return Y(W) && W.typeParameters && W.typeParameters.params ? W.typeParameters.params : null;
            }
            function Y(W) {
              return W.type === "TSTypeReference" || W.type === "GenericTypeAnnotation";
            }
            function V(W, X, oe) {
              let ae = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, Ae = W.getValue(), z = () => V(W, X, oe, true);
              if (Ae.type === "TSNonNullExpression")
                return W.call(z, "expression");
              if (T(Ae)) {
                if (x(W, X, oe).label === "member-chain")
                  return false;
                let Z = A(Ae);
                return !(Z.length === 0 || Z.length === 1 && K(Z[0], X)) || Q(Ae, oe) ? false : W.call(z, "callee");
              }
              return F(Ae) ? W.call(z, "object") : ae && (Ae.type === "Identifier" || Ae.type === "ThisExpression");
            }
            var O = 0.25;
            function K(W, X) {
              let { printWidth: oe } = X;
              if (I(W))
                return false;
              let ae = oe * O;
              if (W.type === "ThisExpression" || W.type === "Identifier" && W.name.length <= ae || P(W) && !I(W.argument))
                return true;
              let Ae = W.type === "Literal" && "regex" in W && W.regex.pattern || W.type === "RegExpLiteral" && W.pattern;
              return Ae ? Ae.length <= ae : D(W) ? B(W).length <= ae : W.type === "TemplateLiteral" ? W.expressions.length === 0 && W.quasis[0].value.raw.length <= ae && !W.quasis[0].value.raw.includes(`
`) : v(W);
            }
            function se(W, X, oe) {
              if (!R(W))
                return false;
              X = c(X);
              let ae = 3;
              return typeof X == "string" && s(X) < oe.tabWidth + ae;
            }
            function Q(W, X) {
              let oe = le(W);
              if (t3(oe)) {
                if (oe.length > 1)
                  return true;
                if (oe.length === 1) {
                  let Ae = oe[0];
                  if (Ae.type === "TSUnionType" || Ae.type === "UnionTypeAnnotation" || Ae.type === "TSIntersectionType" || Ae.type === "IntersectionTypeAnnotation" || Ae.type === "TSTypeLiteral" || Ae.type === "ObjectTypeAnnotation")
                    return true;
                }
                let ae = W.typeParameters ? "typeParameters" : "typeArguments";
                if (y(X(ae)))
                  return true;
              }
              return false;
            }
            function le(W) {
              return W.typeParameters && W.typeParameters.params || W.typeArguments && W.typeArguments.params;
            }
            n.exports = { printVariableDeclarator: o, printAssignmentExpression: E, printAssignment: m, isArrowFunctionVariableDeclarator: J };
          } }), kr = ee({ "src/language-js/print/function-parameters.js"(e, n) {
            "use strict";
            re();
            var { getNextNonSpaceNonCommentCharacter: t3 } = Ge(), { printDanglingComments: s } = et(), { builders: { line: a, hardline: r, softline: u, group: i, indent: l, ifBreak: c }, utils: { removeLines: y, willBreak: h } } = qe(), { getFunctionParameters: g, iterateFunctionParametersPath: p, isSimpleType: D, isTestCall: v, isTypeAnnotationAFunction: w, isObjectType: T, isObjectTypePropertyAFunction: F, hasRestParameter: A, shouldPrintComma: B, hasComment: I, isNextLineEmpty: P } = Ke(), { locEnd: R } = it(), { ArgExpansionBailout: f } = Kt(), { printFunctionTypeParameters: x } = Dt();
            function m(C, _, b, N, k) {
              let $ = C.getValue(), M = g($), q = k ? x(C, b, _) : "";
              if (M.length === 0)
                return [q, "(", s(C, b, true, (se) => t3(b.originalText, se, R) === ")"), ")"];
              let J = C.getParentNode(), L = v(J), Y = E($), V = [];
              if (p(C, (se, Q) => {
                let le = Q === M.length - 1;
                le && $.rest && V.push("..."), V.push(_()), !le && (V.push(","), L || Y ? V.push(" ") : P(M[Q], b) ? V.push(r, r) : V.push(a));
              }), N) {
                if (h(q) || h(V))
                  throw new f();
                return i([y(q), "(", y(V), ")"]);
              }
              let O = M.every((se) => !se.decorators);
              return Y && O ? [q, "(", ...V, ")"] : L ? [q, "(", ...V, ")"] : (F(J) || w(J) || J.type === "TypeAlias" || J.type === "UnionTypeAnnotation" || J.type === "TSUnionType" || J.type === "IntersectionTypeAnnotation" || J.type === "FunctionTypeAnnotation" && J.returnType === $) && M.length === 1 && M[0].name === null && $.this !== M[0] && M[0].typeAnnotation && $.typeParameters === null && D(M[0].typeAnnotation) && !$.rest ? b.arrowParens === "always" ? ["(", ...V, ")"] : V : [q, "(", l([u, ...V]), c(!A($) && B(b, "all") ? "," : ""), u, ")"];
            }
            function E(C) {
              if (!C)
                return false;
              let _ = g(C);
              if (_.length !== 1)
                return false;
              let [b] = _;
              return !I(b) && (b.type === "ObjectPattern" || b.type === "ArrayPattern" || b.type === "Identifier" && b.typeAnnotation && (b.typeAnnotation.type === "TypeAnnotation" || b.typeAnnotation.type === "TSTypeAnnotation") && T(b.typeAnnotation.typeAnnotation) || b.type === "FunctionTypeParam" && T(b.typeAnnotation) || b.type === "AssignmentPattern" && (b.left.type === "ObjectPattern" || b.left.type === "ArrayPattern") && (b.right.type === "Identifier" || b.right.type === "ObjectExpression" && b.right.properties.length === 0 || b.right.type === "ArrayExpression" && b.right.elements.length === 0));
            }
            function o(C) {
              let _;
              return C.returnType ? (_ = C.returnType, _.typeAnnotation && (_ = _.typeAnnotation)) : C.typeAnnotation && (_ = C.typeAnnotation), _;
            }
            function d(C, _) {
              let b = o(C);
              if (!b)
                return false;
              let N = C.typeParameters && C.typeParameters.params;
              if (N) {
                if (N.length > 1)
                  return false;
                if (N.length === 1) {
                  let k = N[0];
                  if (k.constraint || k.default)
                    return false;
                }
              }
              return g(C).length === 1 && (T(b) || h(_));
            }
            n.exports = { printFunctionParameters: m, shouldHugFunctionParameters: E, shouldGroupFunctionParameters: d };
          } }), Lr = ee({ "src/language-js/print/type-annotation.js"(e, n) {
            "use strict";
            re();
            var { printComments: t3, printDanglingComments: s } = et(), { isNonEmptyArray: a } = Ge(), { builders: { group: r, join: u, line: i, softline: l, indent: c, align: y, ifBreak: h } } = qe(), g = Ot(), { locStart: p } = it(), { isSimpleType: D, isObjectType: v, hasLeadingOwnLineComment: w, isObjectTypePropertyAFunction: T, shouldPrintComma: F } = Ke(), { printAssignment: A } = Zt(), { printFunctionParameters: B, shouldGroupFunctionParameters: I } = kr(), { printArrayItems: P } = Qt();
            function R(b) {
              if (D(b) || v(b))
                return true;
              if (b.type === "UnionTypeAnnotation" || b.type === "TSUnionType") {
                let N = b.types.filter(($) => $.type === "VoidTypeAnnotation" || $.type === "TSVoidKeyword" || $.type === "NullLiteralTypeAnnotation" || $.type === "TSNullKeyword").length, k = b.types.some(($) => $.type === "ObjectTypeAnnotation" || $.type === "TSTypeLiteral" || $.type === "GenericTypeAnnotation" || $.type === "TSTypeReference");
                if (b.types.length - 1 === N && k)
                  return true;
              }
              return false;
            }
            function f(b, N, k) {
              let $ = N.semi ? ";" : "", M = b.getValue(), q = [];
              return q.push("opaque type ", k("id"), k("typeParameters")), M.supertype && q.push(": ", k("supertype")), M.impltype && q.push(" = ", k("impltype")), q.push($), q;
            }
            function x(b, N, k) {
              let $ = N.semi ? ";" : "", M = b.getValue(), q = [];
              M.declare && q.push("declare "), q.push("type ", k("id"), k("typeParameters"));
              let J = M.type === "TSTypeAliasDeclaration" ? "typeAnnotation" : "right";
              return [A(b, N, k, q, " =", J), $];
            }
            function m(b, N, k) {
              let $ = b.getValue(), M = b.map(k, "types"), q = [], J = false;
              for (let L = 0; L < M.length; ++L)
                L === 0 ? q.push(M[L]) : v($.types[L - 1]) && v($.types[L]) ? q.push([" & ", J ? c(M[L]) : M[L]]) : !v($.types[L - 1]) && !v($.types[L]) ? q.push(c([" &", i, M[L]])) : (L > 1 && (J = true), q.push(" & ", L > 1 ? c(M[L]) : M[L]));
              return r(q);
            }
            function E(b, N, k) {
              let $ = b.getValue(), M = b.getParentNode(), q = M.type !== "TypeParameterInstantiation" && M.type !== "TSTypeParameterInstantiation" && M.type !== "GenericTypeAnnotation" && M.type !== "TSTypeReference" && M.type !== "TSTypeAssertion" && M.type !== "TupleTypeAnnotation" && M.type !== "TSTupleType" && !(M.type === "FunctionTypeParam" && !M.name && b.getParentNode(1).this !== M) && !((M.type === "TypeAlias" || M.type === "VariableDeclarator" || M.type === "TSTypeAliasDeclaration") && w(N.originalText, $)), J = R($), L = b.map((O) => {
                let K = k();
                return J || (K = y(2, K)), t3(O, K, N);
              }, "types");
              if (J)
                return u(" | ", L);
              let Y = q && !w(N.originalText, $), V = [h([Y ? i : "", "| "]), u([i, "| "], L)];
              return g(b, N) ? r([c(V), l]) : M.type === "TupleTypeAnnotation" && M.types.length > 1 || M.type === "TSTupleType" && M.elementTypes.length > 1 ? r([c([h(["(", l]), V]), l, h(")")]) : r(q ? c(V) : V);
            }
            function o(b, N, k) {
              let $ = b.getValue(), M = [], q = b.getParentNode(0), J = b.getParentNode(1), L = b.getParentNode(2), Y = $.type === "TSFunctionType" || !((q.type === "ObjectTypeProperty" || q.type === "ObjectTypeInternalSlot") && !q.variance && !q.optional && p(q) === p($) || q.type === "ObjectTypeCallProperty" || L && L.type === "DeclareFunction"), V = Y && (q.type === "TypeAnnotation" || q.type === "TSTypeAnnotation"), O = V && Y && (q.type === "TypeAnnotation" || q.type === "TSTypeAnnotation") && J.type === "ArrowFunctionExpression";
              T(q) && (Y = true, V = true), O && M.push("(");
              let K = B(b, k, N, false, true), se = $.returnType || $.predicate || $.typeAnnotation ? [Y ? " => " : ": ", k("returnType"), k("predicate"), k("typeAnnotation")] : "", Q = I($, se);
              return M.push(Q ? r(K) : K), se && M.push(se), O && M.push(")"), r(M);
            }
            function d(b, N, k) {
              let $ = b.getValue(), M = $.type === "TSTupleType" ? "elementTypes" : "types", q = $[M], J = a(q), L = J ? l : "";
              return r(["[", c([L, P(b, N, M, k)]), h(J && F(N, "all") ? "," : ""), s(b, N, true), L, "]"]);
            }
            function C(b, N, k) {
              let $ = b.getValue(), M = $.type === "OptionalIndexedAccessType" && $.optional ? "?.[" : "[";
              return [k("objectType"), M, k("indexType"), "]"];
            }
            function _(b, N, k) {
              let $ = b.getValue();
              return [$.postfix ? "" : k, N("typeAnnotation"), $.postfix ? k : ""];
            }
            n.exports = { printOpaqueType: f, printTypeAlias: x, printIntersectionType: m, printUnionType: E, printFunctionType: o, printTupleType: d, printIndexedAccessType: C, shouldHugType: R, printJSDocType: _ };
          } }), jr = ee({ "src/language-js/print/type-parameters.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { builders: { join: s, line: a, hardline: r, softline: u, group: i, indent: l, ifBreak: c } } = qe(), { isTestCall: y, hasComment: h, CommentCheckFlags: g, isTSXFile: p, shouldPrintComma: D, getFunctionParameters: v, isObjectType: w } = Ke(), { createGroupIdMapper: T } = Ge(), { shouldHugType: F } = Lr(), { isArrowFunctionVariableDeclarator: A } = Zt(), B = T("typeParameters");
            function I(f, x, m, E) {
              let o = f.getValue();
              if (!o[E])
                return "";
              if (!Array.isArray(o[E]))
                return m(E);
              let d = f.getNode(2), C = d && y(d);
              if (!f.match((k) => !(k[E].length === 1 && w(k[E][0])), void 0, (k, $) => $ === "typeAnnotation", (k) => k.type === "Identifier", A) && (C || o[E].length === 0 || o[E].length === 1 && (o[E][0].type === "NullableTypeAnnotation" || F(o[E][0]))))
                return ["<", s(", ", f.map(m, E)), P(f, x), ">"];
              let N = o.type === "TSTypeParameterInstantiation" ? "" : v(o).length === 1 && p(x) && !o[E][0].constraint && f.getParentNode().type === "ArrowFunctionExpression" ? "," : D(x, "all") ? c(",") : "";
              return i(["<", l([u, s([",", a], f.map(m, E))]), N, u, ">"], { id: B(o) });
            }
            function P(f, x) {
              let m = f.getValue();
              if (!h(m, g.Dangling))
                return "";
              let E = !h(m, g.Line), o = t3(f, x, E);
              return E ? o : [o, r];
            }
            function R(f, x, m) {
              let E = f.getValue(), o = [], d = f.getParentNode();
              return d.type === "TSMappedType" ? (o.push("[", m("name")), E.constraint && o.push(" in ", m("constraint")), d.nameType && o.push(" as ", f.callParent(() => m("nameType"))), o.push("]"), o) : (E.variance && o.push(m("variance")), E.in && o.push("in "), E.out && o.push("out "), o.push(m("name")), E.bound && o.push(": ", m("bound")), E.constraint && o.push(" extends ", m("constraint")), E.default && o.push(" = ", m("default")), o);
            }
            n.exports = { printTypeParameter: R, printTypeParameters: I, getTypeParametersGroupId: B };
          } }), er = ee({ "src/language-js/print/property.js"(e, n) {
            "use strict";
            re();
            var { printComments: t3 } = et(), { printString: s, printNumber: a } = Ge(), { isNumericLiteral: r, isSimpleNumber: u, isStringLiteral: i, isStringPropSafeToUnquote: l, rawText: c } = Ke(), { printAssignment: y } = Zt(), h = /* @__PURE__ */ new WeakMap();
            function g(D, v, w) {
              let T = D.getNode();
              if (T.computed)
                return ["[", w("key"), "]"];
              let F = D.getParentNode(), { key: A } = T;
              if (T.type === "ClassPrivateProperty" && A.type === "Identifier")
                return ["#", w("key")];
              if (v.quoteProps === "consistent" && !h.has(F)) {
                let B = (F.properties || F.body || F.members).some((I) => !I.computed && I.key && i(I.key) && !l(I, v));
                h.set(F, B);
              }
              if ((A.type === "Identifier" || r(A) && u(a(c(A))) && String(A.value) === a(c(A)) && !(v.parser === "typescript" || v.parser === "babel-ts")) && (v.parser === "json" || v.quoteProps === "consistent" && h.get(F))) {
                let B = s(JSON.stringify(A.type === "Identifier" ? A.name : A.value.toString()), v);
                return D.call((I) => t3(I, B, v), "key");
              }
              return l(T, v) && (v.quoteProps === "as-needed" || v.quoteProps === "consistent" && !h.get(F)) ? D.call((B) => t3(B, /^\d/.test(A.value) ? a(A.value) : A.value, v), "key") : w("key");
            }
            function p(D, v, w) {
              return D.getValue().shorthand ? w("value") : y(D, v, w, g(D, v, w), ":", "value");
            }
            n.exports = { printProperty: p, printPropertyKey: g };
          } }), Or = ee({ "src/language-js/print/function.js"(e, n) {
            "use strict";
            re();
            var t3 = Yt(), { printDanglingComments: s, printCommentsSeparately: a } = et(), r = lt2(), { getNextNonSpaceNonCommentCharacterIndex: u } = Ge(), { builders: { line: i, softline: l, group: c, indent: y, ifBreak: h, hardline: g, join: p, indentIfBreak: D }, utils: { removeLines: v, willBreak: w } } = qe(), { ArgExpansionBailout: T } = Kt(), { getFunctionParameters: F, hasLeadingOwnLineComment: A, isFlowAnnotationComment: B, isJsxNode: I, isTemplateOnItsOwnLine: P, shouldPrintComma: R, startsWithNoLookaheadToken: f, isBinaryish: x, isLineComment: m, hasComment: E, getComments: o, CommentCheckFlags: d, isCallLikeExpression: C, isCallExpression: _, getCallArguments: b, hasNakedLeftSide: N, getLeftSide: k } = Ke(), { locEnd: $ } = it(), { printFunctionParameters: M, shouldGroupFunctionParameters: q } = kr(), { printPropertyKey: J } = er(), { printFunctionTypeParameters: L } = Dt();
            function Y(H, Z, ne, fe) {
              let ge = H.getValue(), Ce = false;
              if ((ge.type === "FunctionDeclaration" || ge.type === "FunctionExpression") && fe && fe.expandLastArg) {
                let ve = H.getParentNode();
                _(ve) && b(ve).length > 1 && (Ce = true);
              }
              let _e = [];
              ge.type === "TSDeclareFunction" && ge.declare && _e.push("declare "), ge.async && _e.push("async "), ge.generator ? _e.push("function* ") : _e.push("function "), ge.id && _e.push(Z("id"));
              let Oe = M(H, Z, ne, Ce), pe = X(H, Z, ne), ie = q(ge, pe);
              return _e.push(L(H, ne, Z), c([ie ? c(Oe) : Oe, pe]), ge.body ? " " : "", Z("body")), ne.semi && (ge.declare || !ge.body) && _e.push(";"), _e;
            }
            function V(H, Z, ne) {
              let fe = H.getNode(), { kind: ge } = fe, Ce = fe.value || fe, _e = [];
              return !ge || ge === "init" || ge === "method" || ge === "constructor" ? Ce.async && _e.push("async ") : (t3.ok(ge === "get" || ge === "set"), _e.push(ge, " ")), Ce.generator && _e.push("*"), _e.push(J(H, Z, ne), fe.optional || fe.key.optional ? "?" : ""), fe === Ce ? _e.push(O(H, Z, ne)) : Ce.type === "FunctionExpression" ? _e.push(H.call((Oe) => O(Oe, Z, ne), "value")) : _e.push(ne("value")), _e;
            }
            function O(H, Z, ne) {
              let fe = H.getNode(), ge = M(H, ne, Z), Ce = X(H, ne, Z), _e = q(fe, Ce), Oe = [L(H, Z, ne), c([_e ? c(ge) : ge, Ce])];
              return fe.body ? Oe.push(" ", ne("body")) : Oe.push(Z.semi ? ";" : ""), Oe;
            }
            function K(H, Z, ne, fe) {
              let ge = H.getValue(), Ce = [];
              if (ge.async && Ce.push("async "), W(H, Z))
                Ce.push(ne(["params", 0]));
              else {
                let Oe = fe && (fe.expandLastArg || fe.expandFirstArg), pe = X(H, ne, Z);
                if (Oe) {
                  if (w(pe))
                    throw new T();
                  pe = c(v(pe));
                }
                Ce.push(c([M(H, ne, Z, Oe, true), pe]));
              }
              let _e = s(H, Z, true, (Oe) => {
                let pe = u(Z.originalText, Oe, $);
                return pe !== false && Z.originalText.slice(pe, pe + 2) === "=>";
              });
              return _e && Ce.push(" ", _e), Ce;
            }
            function se(H, Z, ne, fe, ge, Ce) {
              let _e = H.getName(), Oe = H.getParentNode(), pe = C(Oe) && _e === "callee", ie = Boolean(Z && Z.assignmentLayout), ve = Ce.body.type !== "BlockStatement" && Ce.body.type !== "ObjectExpression" && Ce.body.type !== "SequenceExpression", ce = pe && ve || Z && Z.assignmentLayout === "chain-tail-arrow-chain", U = Symbol("arrow-chain");
              return Ce.body.type === "SequenceExpression" && (ge = c(["(", y([l, ge]), l, ")"])), c([c(y([pe || ie ? l : "", c(p([" =>", i], ne), { shouldBreak: fe })]), { id: U, shouldBreak: ce }), " =>", D(ve ? y([i, ge]) : [" ", ge], { groupId: U }), pe ? h(l, "", { groupId: U }) : ""]);
            }
            function Q(H, Z, ne, fe) {
              let ge = H.getValue(), Ce = [], _e = [], Oe = false;
              if (function U() {
                let de = K(H, Z, ne, fe);
                if (Ce.length === 0)
                  Ce.push(de);
                else {
                  let { leading: De, trailing: he } = a(H, Z);
                  Ce.push([De, de]), _e.unshift(he);
                }
                Oe = Oe || ge.returnType && F(ge).length > 0 || ge.typeParameters || F(ge).some((De) => De.type !== "Identifier"), ge.body.type !== "ArrowFunctionExpression" || fe && fe.expandLastArg ? _e.unshift(ne("body", fe)) : (ge = ge.body, H.call(U, "body"));
              }(), Ce.length > 1)
                return se(H, fe, Ce, Oe, _e, ge);
              let pe = Ce;
              if (pe.push(" =>"), !A(Z.originalText, ge.body) && (ge.body.type === "ArrayExpression" || ge.body.type === "ObjectExpression" || ge.body.type === "BlockStatement" || I(ge.body) || P(ge.body, Z.originalText) || ge.body.type === "ArrowFunctionExpression" || ge.body.type === "DoExpression"))
                return c([...pe, " ", _e]);
              if (ge.body.type === "SequenceExpression")
                return c([...pe, c([" (", y([l, _e]), l, ")"])]);
              let ie = (fe && fe.expandLastArg || H.getParentNode().type === "JSXExpressionContainer") && !E(ge), ve = fe && fe.expandLastArg && R(Z, "all"), ce = ge.body.type === "ConditionalExpression" && !f(ge.body, false);
              return c([...pe, c([y([i, ce ? h("", "(") : "", _e, ce ? h("", ")") : ""]), ie ? [h(ve ? "," : ""), l] : ""])]);
            }
            function le(H) {
              let Z = F(H);
              return Z.length === 1 && !H.typeParameters && !E(H, d.Dangling) && Z[0].type === "Identifier" && !Z[0].typeAnnotation && !E(Z[0]) && !Z[0].optional && !H.predicate && !H.returnType;
            }
            function W(H, Z) {
              if (Z.arrowParens === "always")
                return false;
              if (Z.arrowParens === "avoid") {
                let ne = H.getValue();
                return le(ne);
              }
              return false;
            }
            function X(H, Z, ne) {
              let fe = H.getValue(), ge = Z("returnType");
              if (fe.returnType && B(ne.originalText, fe.returnType))
                return [" /*: ", ge, " */"];
              let Ce = [ge];
              return fe.returnType && fe.returnType.typeAnnotation && Ce.unshift(": "), fe.predicate && Ce.push(fe.returnType ? " " : ": ", Z("predicate")), Ce;
            }
            function oe(H, Z, ne) {
              let fe = H.getValue(), ge = Z.semi ? ";" : "", Ce = [];
              fe.argument && (z(Z, fe.argument) ? Ce.push([" (", y([g, ne("argument")]), g, ")"]) : x(fe.argument) || fe.argument.type === "SequenceExpression" ? Ce.push(c([h(" (", " "), y([l, ne("argument")]), l, h(")")])) : Ce.push(" ", ne("argument")));
              let _e = o(fe), Oe = r(_e), pe = Oe && m(Oe);
              return pe && Ce.push(ge), E(fe, d.Dangling) && Ce.push(" ", s(H, Z, true)), pe || Ce.push(ge), Ce;
            }
            function ae(H, Z, ne) {
              return ["return", oe(H, Z, ne)];
            }
            function Ae(H, Z, ne) {
              return ["throw", oe(H, Z, ne)];
            }
            function z(H, Z) {
              if (A(H.originalText, Z))
                return true;
              if (N(Z)) {
                let ne = Z, fe;
                for (; fe = k(ne); )
                  if (ne = fe, A(H.originalText, ne))
                    return true;
              }
              return false;
            }
            n.exports = { printFunction: Y, printArrowFunction: Q, printMethod: V, printReturnStatement: ae, printThrowStatement: Ae, printMethodInternal: O, shouldPrintParamsWithoutParens: W };
          } }), zn = ee({ "src/language-js/print/decorators.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3, hasNewline: s } = Ge(), { builders: { line: a, hardline: r, join: u, breakParent: i, group: l } } = qe(), { locStart: c, locEnd: y } = it(), { getParentExportDeclaration: h } = Ke();
            function g(T, F, A) {
              let B = T.getValue();
              return l([u(a, T.map(A, "decorators")), v(B, F) ? r : a]);
            }
            function p(T, F, A) {
              return [u(r, T.map(A, "declaration", "decorators")), r];
            }
            function D(T, F, A) {
              let B = T.getValue(), { decorators: I } = B;
              if (!t3(I) || w(T.getParentNode()))
                return;
              let P = B.type === "ClassExpression" || B.type === "ClassDeclaration" || v(B, F);
              return [h(T) ? r : P ? i : "", u(a, T.map(A, "decorators")), a];
            }
            function v(T, F) {
              return T.decorators.some((A) => s(F.originalText, y(A)));
            }
            function w(T) {
              if (T.type !== "ExportDefaultDeclaration" && T.type !== "ExportNamedDeclaration" && T.type !== "DeclareExportDeclaration")
                return false;
              let F = T.declaration && T.declaration.decorators;
              return t3(F) && c(T) === c(F[0]);
            }
            n.exports = { printDecorators: D, printClassMemberDecorators: g, printDecoratorsBeforeExport: p, hasDecoratorsBeforeExport: w };
          } }), tr = ee({ "src/language-js/print/class.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3, createGroupIdMapper: s } = Ge(), { printComments: a, printDanglingComments: r } = et(), { builders: { join: u, line: i, hardline: l, softline: c, group: y, indent: h, ifBreak: g } } = qe(), { hasComment: p, CommentCheckFlags: D } = Ke(), { getTypeParametersGroupId: v } = jr(), { printMethod: w } = Or(), { printOptionalToken: T, printTypeAnnotation: F, printDefiniteToken: A } = Dt(), { printPropertyKey: B } = er(), { printAssignment: I } = Zt(), { printClassMemberDecorators: P } = zn();
            function R(b, N, k) {
              let $ = b.getValue(), M = [];
              $.declare && M.push("declare "), $.abstract && M.push("abstract "), M.push("class");
              let q = $.id && p($.id, D.Trailing) || $.typeParameters && p($.typeParameters, D.Trailing) || $.superClass && p($.superClass) || t3($.extends) || t3($.mixins) || t3($.implements), J = [], L = [];
              if ($.id && J.push(" ", k("id")), J.push(k("typeParameters")), $.superClass) {
                let Y = [d(b, N, k), k("superTypeParameters")], V = b.call((O) => ["extends ", a(O, Y, N)], "superClass");
                q ? L.push(i, y(V)) : L.push(" ", V);
              } else
                L.push(o(b, N, k, "extends"));
              if (L.push(o(b, N, k, "mixins"), o(b, N, k, "implements")), q) {
                let Y;
                E($) ? Y = [...J, h(L)] : Y = h([...J, L]), M.push(y(Y, { id: f($) }));
              } else
                M.push(...J, ...L);
              return M.push(" ", k("body")), M;
            }
            var f = s("heritageGroup");
            function x(b) {
              return g(l, "", { groupId: f(b) });
            }
            function m(b) {
              return ["superClass", "extends", "mixins", "implements"].filter((N) => Boolean(b[N])).length > 1;
            }
            function E(b) {
              return b.typeParameters && !p(b.typeParameters, D.Trailing | D.Line) && !m(b);
            }
            function o(b, N, k, $) {
              let M = b.getValue();
              if (!t3(M[$]))
                return "";
              let q = r(b, N, true, (J) => {
                let { marker: L } = J;
                return L === $;
              });
              return [E(M) ? g(" ", i, { groupId: v(M.typeParameters) }) : i, q, q && l, $, y(h([i, u([",", i], b.map(k, $))]))];
            }
            function d(b, N, k) {
              let $ = k("superClass");
              return b.getParentNode().type === "AssignmentExpression" ? y(g(["(", h([c, $]), c, ")"], $)) : $;
            }
            function C(b, N, k) {
              let $ = b.getValue(), M = [];
              return t3($.decorators) && M.push(P(b, N, k)), $.accessibility && M.push($.accessibility + " "), $.readonly && M.push("readonly "), $.declare && M.push("declare "), $.static && M.push("static "), ($.type === "TSAbstractMethodDefinition" || $.abstract) && M.push("abstract "), $.override && M.push("override "), M.push(w(b, N, k)), M;
            }
            function _(b, N, k) {
              let $ = b.getValue(), M = [], q = N.semi ? ";" : "";
              return t3($.decorators) && M.push(P(b, N, k)), $.accessibility && M.push($.accessibility + " "), $.declare && M.push("declare "), $.static && M.push("static "), ($.type === "TSAbstractPropertyDefinition" || $.abstract) && M.push("abstract "), $.override && M.push("override "), $.readonly && M.push("readonly "), $.variance && M.push(k("variance")), $.type === "ClassAccessorProperty" && M.push("accessor "), M.push(B(b, N, k), T(b), A(b), F(b, N, k)), [I(b, N, k, M, " =", "value"), q];
            }
            n.exports = { printClass: R, printClassMethod: C, printClassProperty: _, printHardlineAfterHeritage: x };
          } }), uo = ee({ "src/language-js/print/interface.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3 } = Ge(), { builders: { join: s, line: a, group: r, indent: u, ifBreak: i } } = qe(), { hasComment: l, identity: c, CommentCheckFlags: y } = Ke(), { getTypeParametersGroupId: h } = jr(), { printTypeScriptModifiers: g } = Dt();
            function p(D, v, w) {
              let T = D.getValue(), F = [];
              T.declare && F.push("declare "), T.type === "TSInterfaceDeclaration" && F.push(T.abstract ? "abstract " : "", g(D, v, w)), F.push("interface");
              let A = [], B = [];
              T.type !== "InterfaceTypeAnnotation" && A.push(" ", w("id"), w("typeParameters"));
              let I = T.typeParameters && !l(T.typeParameters, y.Trailing | y.Line);
              return t3(T.extends) && B.push(I ? i(" ", a, { groupId: h(T.typeParameters) }) : a, "extends ", (T.extends.length === 1 ? c : u)(s([",", a], D.map(w, "extends")))), T.id && l(T.id, y.Trailing) || t3(T.extends) ? I ? F.push(r([...A, u(B)])) : F.push(r(u([...A, ...B]))) : F.push(...A, ...B), F.push(" ", w("body")), r(F);
            }
            n.exports = { printInterface: p };
          } }), so = ee({ "src/language-js/print/module.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3 } = Ge(), { builders: { softline: s, group: a, indent: r, join: u, line: i, ifBreak: l, hardline: c } } = qe(), { printDanglingComments: y } = et(), { hasComment: h, CommentCheckFlags: g, shouldPrintComma: p, needsHardlineAfterDanglingComment: D, isStringLiteral: v, rawText: w } = Ke(), { locStart: T, hasSameLoc: F } = it(), { hasDecoratorsBeforeExport: A, printDecoratorsBeforeExport: B } = zn();
            function I(_, b, N) {
              let k = _.getValue(), $ = b.semi ? ";" : "", M = [], { importKind: q } = k;
              return M.push("import"), q && q !== "value" && M.push(" ", q), M.push(m(_, b, N), x(_, b, N), o(_, b, N), $), M;
            }
            function P(_, b, N) {
              let k = _.getValue(), $ = [];
              A(k) && $.push(B(_, b, N));
              let { type: M, exportKind: q, declaration: J } = k;
              return $.push("export"), (k.default || M === "ExportDefaultDeclaration") && $.push(" default"), h(k, g.Dangling) && ($.push(" ", y(_, b, true)), D(k) && $.push(c)), J ? $.push(" ", N("declaration")) : $.push(q === "type" ? " type" : "", m(_, b, N), x(_, b, N), o(_, b, N)), f(k, b) && $.push(";"), $;
            }
            function R(_, b, N) {
              let k = _.getValue(), $ = b.semi ? ";" : "", M = [], { exportKind: q, exported: J } = k;
              return M.push("export"), q === "type" && M.push(" type"), M.push(" *"), J && M.push(" as ", N("exported")), M.push(x(_, b, N), o(_, b, N), $), M;
            }
            function f(_, b) {
              if (!b.semi)
                return false;
              let { type: N, declaration: k } = _, $ = _.default || N === "ExportDefaultDeclaration";
              if (!k)
                return true;
              let { type: M } = k;
              return !!($ && M !== "ClassDeclaration" && M !== "FunctionDeclaration" && M !== "TSInterfaceDeclaration" && M !== "DeclareClass" && M !== "DeclareFunction" && M !== "TSDeclareFunction" && M !== "EnumDeclaration");
            }
            function x(_, b, N) {
              let k = _.getValue();
              if (!k.source)
                return "";
              let $ = [];
              return E(k, b) || $.push(" from"), $.push(" ", N("source")), $;
            }
            function m(_, b, N) {
              let k = _.getValue();
              if (E(k, b))
                return "";
              let $ = [" "];
              if (t3(k.specifiers)) {
                let M = [], q = [];
                _.each(() => {
                  let J = _.getValue().type;
                  if (J === "ExportNamespaceSpecifier" || J === "ExportDefaultSpecifier" || J === "ImportNamespaceSpecifier" || J === "ImportDefaultSpecifier")
                    M.push(N());
                  else if (J === "ExportSpecifier" || J === "ImportSpecifier")
                    q.push(N());
                  else
                    throw new Error(`Unknown specifier type ${JSON.stringify(J)}`);
                }, "specifiers"), $.push(u(", ", M)), q.length > 0 && (M.length > 0 && $.push(", "), q.length > 1 || M.length > 0 || k.specifiers.some((L) => h(L)) ? $.push(a(["{", r([b.bracketSpacing ? i : s, u([",", i], q)]), l(p(b) ? "," : ""), b.bracketSpacing ? i : s, "}"])) : $.push(["{", b.bracketSpacing ? " " : "", ...q, b.bracketSpacing ? " " : "", "}"]));
              } else
                $.push("{}");
              return $;
            }
            function E(_, b) {
              let { type: N, importKind: k, source: $, specifiers: M } = _;
              return N !== "ImportDeclaration" || t3(M) || k === "type" ? false : !/{\s*}/.test(b.originalText.slice(T(_), T($)));
            }
            function o(_, b, N) {
              let k = _.getNode();
              return t3(k.assertions) ? [" assert {", b.bracketSpacing ? " " : "", u(", ", _.map(N, "assertions")), b.bracketSpacing ? " " : "", "}"] : "";
            }
            function d(_, b, N) {
              let k = _.getNode(), { type: $ } = k, M = [], q = $ === "ImportSpecifier" ? k.importKind : k.exportKind;
              q && q !== "value" && M.push(q, " ");
              let J = $.startsWith("Import"), L = J ? "imported" : "local", Y = J ? "local" : "exported", V = k[L], O = k[Y], K = "", se = "";
              return $ === "ExportNamespaceSpecifier" || $ === "ImportNamespaceSpecifier" ? K = "*" : V && (K = N(L)), O && !C(k) && (se = N(Y)), M.push(K, K && se ? " as " : "", se), M;
            }
            function C(_) {
              if (_.type !== "ImportSpecifier" && _.type !== "ExportSpecifier")
                return false;
              let { local: b, [_.type === "ImportSpecifier" ? "imported" : "exported"]: N } = _;
              if (b.type !== N.type || !F(b, N))
                return false;
              if (v(b))
                return b.value === N.value && w(b) === w(N);
              switch (b.type) {
                case "Identifier":
                  return b.name === N.name;
                default:
                  return false;
              }
            }
            n.exports = { printImportDeclaration: I, printExportDeclaration: P, printExportAllDeclaration: R, printModuleSpecifier: d };
          } }), Xn = ee({ "src/language-js/print/object.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { builders: { line: s, softline: a, group: r, indent: u, ifBreak: i, hardline: l } } = qe(), { getLast: c, hasNewlineInRange: y, hasNewline: h, isNonEmptyArray: g } = Ge(), { shouldPrintComma: p, hasComment: D, getComments: v, CommentCheckFlags: w, isNextLineEmpty: T } = Ke(), { locStart: F, locEnd: A } = it(), { printOptionalToken: B, printTypeAnnotation: I } = Dt(), { shouldHugFunctionParameters: P } = kr(), { shouldHugType: R } = Lr(), { printHardlineAfterHeritage: f } = tr();
            function x(m, E, o) {
              let d = E.semi ? ";" : "", C = m.getValue(), _;
              C.type === "TSTypeLiteral" ? _ = "members" : C.type === "TSInterfaceBody" ? _ = "body" : _ = "properties";
              let b = C.type === "ObjectTypeAnnotation", N = [_];
              b && N.push("indexers", "callProperties", "internalSlots");
              let k = N.map((W) => C[W][0]).sort((W, X) => F(W) - F(X))[0], $ = m.getParentNode(0), M = b && $ && ($.type === "InterfaceDeclaration" || $.type === "DeclareInterface" || $.type === "DeclareClass") && m.getName() === "body", q = C.type === "TSInterfaceBody" || M || C.type === "ObjectPattern" && $.type !== "FunctionDeclaration" && $.type !== "FunctionExpression" && $.type !== "ArrowFunctionExpression" && $.type !== "ObjectMethod" && $.type !== "ClassMethod" && $.type !== "ClassPrivateMethod" && $.type !== "AssignmentPattern" && $.type !== "CatchClause" && C.properties.some((W) => W.value && (W.value.type === "ObjectPattern" || W.value.type === "ArrayPattern")) || C.type !== "ObjectPattern" && k && y(E.originalText, F(C), F(k)), J = M ? ";" : C.type === "TSInterfaceBody" || C.type === "TSTypeLiteral" ? i(d, ";") : ",", L = C.type === "RecordExpression" ? "#{" : C.exact ? "{|" : "{", Y = C.exact ? "|}" : "}", V = [];
              for (let W of N)
                m.each((X) => {
                  let oe = X.getValue();
                  V.push({ node: oe, printed: o(), loc: F(oe) });
                }, W);
              N.length > 1 && V.sort((W, X) => W.loc - X.loc);
              let O = [], K = V.map((W) => {
                let X = [...O, r(W.printed)];
                return O = [J, s], (W.node.type === "TSPropertySignature" || W.node.type === "TSMethodSignature" || W.node.type === "TSConstructSignatureDeclaration") && D(W.node, w.PrettierIgnore) && O.shift(), T(W.node, E) && O.push(l), X;
              });
              if (C.inexact) {
                let W;
                if (D(C, w.Dangling)) {
                  let X = D(C, w.Line);
                  W = [t3(m, E, true), X || h(E.originalText, A(c(v(C)))) ? l : s, "..."];
                } else
                  W = ["..."];
                K.push([...O, ...W]);
              }
              let se = c(C[_]), Q = !(C.inexact || se && se.type === "RestElement" || se && (se.type === "TSPropertySignature" || se.type === "TSCallSignatureDeclaration" || se.type === "TSMethodSignature" || se.type === "TSConstructSignatureDeclaration") && D(se, w.PrettierIgnore)), le;
              if (K.length === 0) {
                if (!D(C, w.Dangling))
                  return [L, Y, I(m, E, o)];
                le = r([L, t3(m, E), a, Y, B(m), I(m, E, o)]);
              } else
                le = [M && g(C.properties) ? f($) : "", L, u([E.bracketSpacing ? s : a, ...K]), i(Q && (J !== "," || p(E)) ? J : ""), E.bracketSpacing ? s : a, Y, B(m), I(m, E, o)];
              return m.match((W) => W.type === "ObjectPattern" && !W.decorators, (W, X, oe) => P(W) && (X === "params" || X === "parameters" || X === "this" || X === "rest") && oe === 0) || m.match(R, (W, X) => X === "typeAnnotation", (W, X) => X === "typeAnnotation", (W, X, oe) => P(W) && (X === "params" || X === "parameters" || X === "this" || X === "rest") && oe === 0) || !q && m.match((W) => W.type === "ObjectPattern", (W) => W.type === "AssignmentExpression" || W.type === "VariableDeclarator") ? le : r(le, { shouldBreak: q });
            }
            n.exports = { printObject: x };
          } }), Vm = ee({ "src/language-js/print/flow.js"(e, n) {
            "use strict";
            re();
            var t3 = Yt(), { printDanglingComments: s } = et(), { printString: a, printNumber: r } = Ge(), { builders: { hardline: u, softline: i, group: l, indent: c } } = qe(), { getParentExportDeclaration: y, isFunctionNotation: h, isGetterOrSetter: g, rawText: p, shouldPrintComma: D } = Ke(), { locStart: v, locEnd: w } = it(), { replaceTextEndOfLine: T } = Xt(), { printClass: F } = tr(), { printOpaqueType: A, printTypeAlias: B, printIntersectionType: I, printUnionType: P, printFunctionType: R, printTupleType: f, printIndexedAccessType: x } = Lr(), { printInterface: m } = uo(), { printTypeParameter: E, printTypeParameters: o } = jr(), { printExportDeclaration: d, printExportAllDeclaration: C } = so(), { printArrayItems: _ } = Qt(), { printObject: b } = Xn(), { printPropertyKey: N } = er(), { printOptionalToken: k, printTypeAnnotation: $, printRestSpread: M } = Dt();
            function q(L, Y, V) {
              let O = L.getValue(), K = Y.semi ? ";" : "", se = [];
              switch (O.type) {
                case "DeclareClass":
                  return J(L, F(L, Y, V));
                case "DeclareFunction":
                  return J(L, ["function ", V("id"), O.predicate ? " " : "", V("predicate"), K]);
                case "DeclareModule":
                  return J(L, ["module ", V("id"), " ", V("body")]);
                case "DeclareModuleExports":
                  return J(L, ["module.exports", ": ", V("typeAnnotation"), K]);
                case "DeclareVariable":
                  return J(L, ["var ", V("id"), K]);
                case "DeclareOpaqueType":
                  return J(L, A(L, Y, V));
                case "DeclareInterface":
                  return J(L, m(L, Y, V));
                case "DeclareTypeAlias":
                  return J(L, B(L, Y, V));
                case "DeclareExportDeclaration":
                  return J(L, d(L, Y, V));
                case "DeclareExportAllDeclaration":
                  return J(L, C(L, Y, V));
                case "OpaqueType":
                  return A(L, Y, V);
                case "TypeAlias":
                  return B(L, Y, V);
                case "IntersectionTypeAnnotation":
                  return I(L, Y, V);
                case "UnionTypeAnnotation":
                  return P(L, Y, V);
                case "FunctionTypeAnnotation":
                  return R(L, Y, V);
                case "TupleTypeAnnotation":
                  return f(L, Y, V);
                case "GenericTypeAnnotation":
                  return [V("id"), o(L, Y, V, "typeParameters")];
                case "IndexedAccessType":
                case "OptionalIndexedAccessType":
                  return x(L, Y, V);
                case "TypeAnnotation":
                  return V("typeAnnotation");
                case "TypeParameter":
                  return E(L, Y, V);
                case "TypeofTypeAnnotation":
                  return ["typeof ", V("argument")];
                case "ExistsTypeAnnotation":
                  return "*";
                case "EmptyTypeAnnotation":
                  return "empty";
                case "MixedTypeAnnotation":
                  return "mixed";
                case "ArrayTypeAnnotation":
                  return [V("elementType"), "[]"];
                case "BooleanLiteralTypeAnnotation":
                  return String(O.value);
                case "EnumDeclaration":
                  return ["enum ", V("id"), " ", V("body")];
                case "EnumBooleanBody":
                case "EnumNumberBody":
                case "EnumStringBody":
                case "EnumSymbolBody": {
                  if (O.type === "EnumSymbolBody" || O.explicitType) {
                    let Q = null;
                    switch (O.type) {
                      case "EnumBooleanBody":
                        Q = "boolean";
                        break;
                      case "EnumNumberBody":
                        Q = "number";
                        break;
                      case "EnumStringBody":
                        Q = "string";
                        break;
                      case "EnumSymbolBody":
                        Q = "symbol";
                        break;
                    }
                    se.push("of ", Q, " ");
                  }
                  if (O.members.length === 0 && !O.hasUnknownMembers)
                    se.push(l(["{", s(L, Y), i, "}"]));
                  else {
                    let Q = O.members.length > 0 ? [u, _(L, Y, "members", V), O.hasUnknownMembers || D(Y) ? "," : ""] : [];
                    se.push(l(["{", c([...Q, ...O.hasUnknownMembers ? [u, "..."] : []]), s(L, Y, true), u, "}"]));
                  }
                  return se;
                }
                case "EnumBooleanMember":
                case "EnumNumberMember":
                case "EnumStringMember":
                  return [V("id"), " = ", typeof O.init == "object" ? V("init") : String(O.init)];
                case "EnumDefaultedMember":
                  return V("id");
                case "FunctionTypeParam": {
                  let Q = O.name ? V("name") : L.getParentNode().this === O ? "this" : "";
                  return [Q, k(L), Q ? ": " : "", V("typeAnnotation")];
                }
                case "InterfaceDeclaration":
                case "InterfaceTypeAnnotation":
                  return m(L, Y, V);
                case "ClassImplements":
                case "InterfaceExtends":
                  return [V("id"), V("typeParameters")];
                case "NullableTypeAnnotation":
                  return ["?", V("typeAnnotation")];
                case "Variance": {
                  let { kind: Q } = O;
                  return t3.ok(Q === "plus" || Q === "minus"), Q === "plus" ? "+" : "-";
                }
                case "ObjectTypeCallProperty":
                  return O.static && se.push("static "), se.push(V("value")), se;
                case "ObjectTypeIndexer":
                  return [O.static ? "static " : "", O.variance ? V("variance") : "", "[", V("id"), O.id ? ": " : "", V("key"), "]: ", V("value")];
                case "ObjectTypeProperty": {
                  let Q = "";
                  return O.proto ? Q = "proto " : O.static && (Q = "static "), [Q, g(O) ? O.kind + " " : "", O.variance ? V("variance") : "", N(L, Y, V), k(L), h(O) ? "" : ": ", V("value")];
                }
                case "ObjectTypeAnnotation":
                  return b(L, Y, V);
                case "ObjectTypeInternalSlot":
                  return [O.static ? "static " : "", "[[", V("id"), "]]", k(L), O.method ? "" : ": ", V("value")];
                case "ObjectTypeSpreadProperty":
                  return M(L, Y, V);
                case "QualifiedTypeofIdentifier":
                case "QualifiedTypeIdentifier":
                  return [V("qualification"), ".", V("id")];
                case "StringLiteralTypeAnnotation":
                  return T(a(p(O), Y));
                case "NumberLiteralTypeAnnotation":
                  t3.strictEqual(typeof O.value, "number");
                case "BigIntLiteralTypeAnnotation":
                  return O.extra ? r(O.extra.raw) : r(O.raw);
                case "TypeCastExpression":
                  return ["(", V("expression"), $(L, Y, V), ")"];
                case "TypeParameterDeclaration":
                case "TypeParameterInstantiation": {
                  let Q = o(L, Y, V, "params");
                  if (Y.parser === "flow") {
                    let le = v(O), W = w(O), X = Y.originalText.lastIndexOf("/*", le), oe = Y.originalText.indexOf("*/", W);
                    if (X !== -1 && oe !== -1) {
                      let ae = Y.originalText.slice(X + 2, oe).trim();
                      if (ae.startsWith("::") && !ae.includes("/*") && !ae.includes("*/"))
                        return ["/*:: ", Q, " */"];
                    }
                  }
                  return Q;
                }
                case "InferredPredicate":
                  return "%checks";
                case "DeclaredPredicate":
                  return ["%checks(", V("value"), ")"];
                case "AnyTypeAnnotation":
                  return "any";
                case "BooleanTypeAnnotation":
                  return "boolean";
                case "BigIntTypeAnnotation":
                  return "bigint";
                case "NullLiteralTypeAnnotation":
                  return "null";
                case "NumberTypeAnnotation":
                  return "number";
                case "SymbolTypeAnnotation":
                  return "symbol";
                case "StringTypeAnnotation":
                  return "string";
                case "VoidTypeAnnotation":
                  return "void";
                case "ThisTypeAnnotation":
                  return "this";
                case "Node":
                case "Printable":
                case "SourceLocation":
                case "Position":
                case "Statement":
                case "Function":
                case "Pattern":
                case "Expression":
                case "Declaration":
                case "Specifier":
                case "NamedSpecifier":
                case "Comment":
                case "MemberTypeAnnotation":
                case "Type":
                  throw new Error("unprintable type: " + JSON.stringify(O.type));
              }
            }
            function J(L, Y) {
              let V = y(L);
              return V ? (t3.strictEqual(V.type, "DeclareExportDeclaration"), Y) : ["declare ", Y];
            }
            n.exports = { printFlow: q };
          } }), Wm = ee({ "src/language-js/utils/is-ts-keyword-type.js"(e, n) {
            "use strict";
            re();
            function t3(s) {
              let { type: a } = s;
              return a.startsWith("TS") && a.endsWith("Keyword");
            }
            n.exports = t3;
          } }), io = ee({ "src/language-js/print/ternary.js"(e, n) {
            "use strict";
            re();
            var { hasNewlineInRange: t3 } = Ge(), { isJsxNode: s, getComments: a, isCallExpression: r, isMemberExpression: u, isTSTypeExpression: i } = Ke(), { locStart: l, locEnd: c } = it(), y = Lt(), { builders: { line: h, softline: g, group: p, indent: D, align: v, ifBreak: w, dedent: T, breakParent: F } } = qe();
            function A(f) {
              let x = [f];
              for (let m = 0; m < x.length; m++) {
                let E = x[m];
                for (let o of ["test", "consequent", "alternate"]) {
                  let d = E[o];
                  if (s(d))
                    return true;
                  d.type === "ConditionalExpression" && x.push(d);
                }
              }
              return false;
            }
            function B(f, x, m) {
              let E = f.getValue(), o = E.type === "ConditionalExpression", d = o ? "alternate" : "falseType", C = f.getParentNode(), _ = o ? m("test") : [m("checkType"), " ", "extends", " ", m("extendsType")];
              return C.type === E.type && C[d] === E ? v(2, _) : _;
            }
            var I = /* @__PURE__ */ new Map([["AssignmentExpression", "right"], ["VariableDeclarator", "init"], ["ReturnStatement", "argument"], ["ThrowStatement", "argument"], ["UnaryExpression", "argument"], ["YieldExpression", "argument"]]);
            function P(f) {
              let x = f.getValue();
              if (x.type !== "ConditionalExpression")
                return false;
              let m, E = x;
              for (let o = 0; !m; o++) {
                let d = f.getParentNode(o);
                if (r(d) && d.callee === E || u(d) && d.object === E || d.type === "TSNonNullExpression" && d.expression === E) {
                  E = d;
                  continue;
                }
                d.type === "NewExpression" && d.callee === E || i(d) && d.expression === E ? (m = f.getParentNode(o + 1), E = d) : m = d;
              }
              return E === x ? false : m[I.get(m.type)] === E;
            }
            function R(f, x, m) {
              let E = f.getValue(), o = E.type === "ConditionalExpression", d = o ? "consequent" : "trueType", C = o ? "alternate" : "falseType", _ = o ? ["test"] : ["checkType", "extendsType"], b = E[d], N = E[C], k = [], $ = false, M = f.getParentNode(), q = M.type === E.type && _.some((ae) => M[ae] === E), J = M.type === E.type && !q, L, Y, V = 0;
              do
                Y = L || E, L = f.getParentNode(V), V++;
              while (L && L.type === E.type && _.every((ae) => L[ae] !== Y));
              let O = L || M, K = Y;
              if (o && (s(E[_[0]]) || s(b) || s(N) || A(K))) {
                $ = true, J = true;
                let ae = (z) => [w("("), D([g, z]), g, w(")")], Ae = (z) => z.type === "NullLiteral" || z.type === "Literal" && z.value === null || z.type === "Identifier" && z.name === "undefined";
                k.push(" ? ", Ae(b) ? m(d) : ae(m(d)), " : ", N.type === E.type || Ae(N) ? m(C) : ae(m(C)));
              } else {
                let ae = [h, "? ", b.type === E.type ? w("", "(") : "", v(2, m(d)), b.type === E.type ? w("", ")") : "", h, ": ", N.type === E.type ? m(C) : v(2, m(C))];
                k.push(M.type !== E.type || M[C] === E || q ? ae : x.useTabs ? T(D(ae)) : v(Math.max(0, x.tabWidth - 2), ae));
              }
              let Q = [..._.map((ae) => a(E[ae])), a(b), a(N)].flat().some((ae) => y(ae) && t3(x.originalText, l(ae), c(ae))), le = (ae) => M === O ? p(ae, { shouldBreak: Q }) : Q ? [ae, F] : ae, W = !$ && (u(M) || M.type === "NGPipeExpression" && M.left === E) && !M.computed, X = P(f), oe = le([B(f, x, m), J ? k : D(k), o && W && !X ? g : ""]);
              return q || X ? p([D([g, oe]), g]) : oe;
            }
            n.exports = { printTernary: R };
          } }), ao = ee({ "src/language-js/print/statement.js"(e, n) {
            "use strict";
            re();
            var { builders: { hardline: t3 } } = qe(), s = Ot(), { getLeftSidePathName: a, hasNakedLeftSide: r, isJsxNode: u, isTheOnlyJsxElementInMarkdown: i, hasComment: l, CommentCheckFlags: c, isNextLineEmpty: y } = Ke(), { shouldPrintParamsWithoutParens: h } = Or();
            function g(B, I, P, R) {
              let f = B.getValue(), x = [], m = f.type === "ClassBody", E = p(f[R]);
              return B.each((o, d, C) => {
                let _ = o.getValue();
                if (_.type === "EmptyStatement")
                  return;
                let b = P();
                !I.semi && !m && !i(I, o) && D(o, I) ? l(_, c.Leading) ? x.push(P([], { needsSemi: true })) : x.push(";", b) : x.push(b), !I.semi && m && F(_) && A(_, C[d + 1]) && x.push(";"), _ !== E && (x.push(t3), y(_, I) && x.push(t3));
              }, R), x;
            }
            function p(B) {
              for (let I = B.length - 1; I >= 0; I--) {
                let P = B[I];
                if (P.type !== "EmptyStatement")
                  return P;
              }
            }
            function D(B, I) {
              return B.getNode().type !== "ExpressionStatement" ? false : B.call((R) => v(R, I), "expression");
            }
            function v(B, I) {
              let P = B.getValue();
              switch (P.type) {
                case "ParenthesizedExpression":
                case "TypeCastExpression":
                case "ArrayExpression":
                case "ArrayPattern":
                case "TemplateLiteral":
                case "TemplateElement":
                case "RegExpLiteral":
                  return true;
                case "ArrowFunctionExpression": {
                  if (!h(B, I))
                    return true;
                  break;
                }
                case "UnaryExpression": {
                  let { prefix: R, operator: f } = P;
                  if (R && (f === "+" || f === "-"))
                    return true;
                  break;
                }
                case "BindExpression": {
                  if (!P.object)
                    return true;
                  break;
                }
                case "Literal": {
                  if (P.regex)
                    return true;
                  break;
                }
                default:
                  if (u(P))
                    return true;
              }
              return s(B, I) ? true : r(P) ? B.call((R) => v(R, I), ...a(B, P)) : false;
            }
            function w(B, I, P) {
              return g(B, I, P, "body");
            }
            function T(B, I, P) {
              return g(B, I, P, "consequent");
            }
            var F = (B) => {
              let { type: I } = B;
              return I === "ClassProperty" || I === "PropertyDefinition" || I === "ClassPrivateProperty" || I === "ClassAccessorProperty";
            };
            function A(B, I) {
              let P = B.key && B.key.name;
              if ((P === "static" || P === "get" || P === "set") && !B.value && !B.typeAnnotation)
                return true;
              if (!I || I.static || I.accessibility)
                return false;
              if (!I.computed) {
                let R = I.key && I.key.name;
                if (R === "in" || R === "instanceof")
                  return true;
              }
              if (F(I) && I.variance && !I.static && !I.declare)
                return true;
              switch (I.type) {
                case "ClassProperty":
                case "PropertyDefinition":
                case "TSAbstractPropertyDefinition":
                  return I.computed;
                case "MethodDefinition":
                case "TSAbstractMethodDefinition":
                case "ClassMethod":
                case "ClassPrivateMethod": {
                  if ((I.value ? I.value.async : I.async) || I.kind === "get" || I.kind === "set")
                    return false;
                  let f = I.value ? I.value.generator : I.generator;
                  return !!(I.computed || f);
                }
                case "TSIndexSignature":
                  return true;
              }
              return false;
            }
            n.exports = { printBody: w, printSwitchCaseConsequent: T };
          } }), oo = ee({ "src/language-js/print/block.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { isNonEmptyArray: s } = Ge(), { builders: { hardline: a, indent: r } } = qe(), { hasComment: u, CommentCheckFlags: i, isNextLineEmpty: l } = Ke(), { printHardlineAfterHeritage: c } = tr(), { printBody: y } = ao();
            function h(p, D, v) {
              let w = p.getValue(), T = [];
              if (w.type === "StaticBlock" && T.push("static "), w.type === "ClassBody" && s(w.body)) {
                let A = p.getParentNode();
                T.push(c(A));
              }
              T.push("{");
              let F = g(p, D, v);
              if (F)
                T.push(r([a, F]), a);
              else {
                let A = p.getParentNode(), B = p.getParentNode(1);
                A.type === "ArrowFunctionExpression" || A.type === "FunctionExpression" || A.type === "FunctionDeclaration" || A.type === "ObjectMethod" || A.type === "ClassMethod" || A.type === "ClassPrivateMethod" || A.type === "ForStatement" || A.type === "WhileStatement" || A.type === "DoWhileStatement" || A.type === "DoExpression" || A.type === "CatchClause" && !B.finalizer || A.type === "TSModuleDeclaration" || A.type === "TSDeclareFunction" || w.type === "StaticBlock" || w.type === "ClassBody" || T.push(a);
              }
              return T.push("}"), T;
            }
            function g(p, D, v) {
              let w = p.getValue(), T = s(w.directives), F = w.body.some((I) => I.type !== "EmptyStatement"), A = u(w, i.Dangling);
              if (!T && !F && !A)
                return "";
              let B = [];
              if (T && p.each((I, P, R) => {
                B.push(v()), (P < R.length - 1 || F || A) && (B.push(a), l(I.getValue(), D) && B.push(a));
              }, "directives"), F && B.push(y(p, D, v)), A && B.push(t3(p, D, true)), w.type === "Program") {
                let I = p.getParentNode();
                (!I || I.type !== "ModuleExpression") && B.push(a);
              }
              return B;
            }
            n.exports = { printBlock: h, printBlockBody: g };
          } }), Hm = ee({ "src/language-js/print/typescript.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { hasNewlineInRange: s } = Ge(), { builders: { join: a, line: r, hardline: u, softline: i, group: l, indent: c, conditionalGroup: y, ifBreak: h } } = qe(), { isLiteral: g, getTypeScriptMappedTypeModifier: p, shouldPrintComma: D, isCallExpression: v, isMemberExpression: w } = Ke(), T = Wm(), { locStart: F, locEnd: A } = it(), { printOptionalToken: B, printTypeScriptModifiers: I } = Dt(), { printTernary: P } = io(), { printFunctionParameters: R, shouldGroupFunctionParameters: f } = kr(), { printTemplateLiteral: x } = jt(), { printArrayItems: m } = Qt(), { printObject: E } = Xn(), { printClassProperty: o, printClassMethod: d } = tr(), { printTypeParameter: C, printTypeParameters: _ } = jr(), { printPropertyKey: b } = er(), { printFunction: N, printMethodInternal: k } = Or(), { printInterface: $ } = uo(), { printBlock: M } = oo(), { printTypeAlias: q, printIntersectionType: J, printUnionType: L, printFunctionType: Y, printTupleType: V, printIndexedAccessType: O, printJSDocType: K } = Lr();
            function se(Q, le, W) {
              let X = Q.getValue();
              if (!X.type.startsWith("TS"))
                return;
              if (T(X))
                return X.type.slice(2, -7).toLowerCase();
              let oe = le.semi ? ";" : "", ae = [];
              switch (X.type) {
                case "TSThisType":
                  return "this";
                case "TSTypeAssertion": {
                  let Ae = !(X.expression.type === "ArrayExpression" || X.expression.type === "ObjectExpression"), z = l(["<", c([i, W("typeAnnotation")]), i, ">"]), H = [h("("), c([i, W("expression")]), i, h(")")];
                  return Ae ? y([[z, W("expression")], [z, l(H, { shouldBreak: true })], [z, W("expression")]]) : l([z, W("expression")]);
                }
                case "TSDeclareFunction":
                  return N(Q, W, le);
                case "TSExportAssignment":
                  return ["export = ", W("expression"), oe];
                case "TSModuleBlock":
                  return M(Q, le, W);
                case "TSInterfaceBody":
                case "TSTypeLiteral":
                  return E(Q, le, W);
                case "TSTypeAliasDeclaration":
                  return q(Q, le, W);
                case "TSQualifiedName":
                  return a(".", [W("left"), W("right")]);
                case "TSAbstractMethodDefinition":
                case "TSDeclareMethod":
                  return d(Q, le, W);
                case "TSAbstractPropertyDefinition":
                  return o(Q, le, W);
                case "TSInterfaceHeritage":
                case "TSExpressionWithTypeArguments":
                  return ae.push(W("expression")), X.typeParameters && ae.push(W("typeParameters")), ae;
                case "TSTemplateLiteralType":
                  return x(Q, W, le);
                case "TSNamedTupleMember":
                  return [W("label"), X.optional ? "?" : "", ": ", W("elementType")];
                case "TSRestType":
                  return ["...", W("typeAnnotation")];
                case "TSOptionalType":
                  return [W("typeAnnotation"), "?"];
                case "TSInterfaceDeclaration":
                  return $(Q, le, W);
                case "TSClassImplements":
                  return [W("expression"), W("typeParameters")];
                case "TSTypeParameterDeclaration":
                case "TSTypeParameterInstantiation":
                  return _(Q, le, W, "params");
                case "TSTypeParameter":
                  return C(Q, le, W);
                case "TSSatisfiesExpression":
                case "TSAsExpression": {
                  let Ae = X.type === "TSAsExpression" ? "as" : "satisfies";
                  ae.push(W("expression"), ` ${Ae} `, W("typeAnnotation"));
                  let z = Q.getParentNode();
                  return v(z) && z.callee === X || w(z) && z.object === X ? l([c([i, ...ae]), i]) : ae;
                }
                case "TSArrayType":
                  return [W("elementType"), "[]"];
                case "TSPropertySignature":
                  return X.readonly && ae.push("readonly "), ae.push(b(Q, le, W), B(Q)), X.typeAnnotation && ae.push(": ", W("typeAnnotation")), X.initializer && ae.push(" = ", W("initializer")), ae;
                case "TSParameterProperty":
                  return X.accessibility && ae.push(X.accessibility + " "), X.export && ae.push("export "), X.static && ae.push("static "), X.override && ae.push("override "), X.readonly && ae.push("readonly "), ae.push(W("parameter")), ae;
                case "TSTypeQuery":
                  return ["typeof ", W("exprName"), W("typeParameters")];
                case "TSIndexSignature": {
                  let Ae = Q.getParentNode(), z = X.parameters.length > 1 ? h(D(le) ? "," : "") : "", H = l([c([i, a([", ", i], Q.map(W, "parameters"))]), z, i]);
                  return [X.export ? "export " : "", X.accessibility ? [X.accessibility, " "] : "", X.static ? "static " : "", X.readonly ? "readonly " : "", X.declare ? "declare " : "", "[", X.parameters ? H : "", X.typeAnnotation ? "]: " : "]", X.typeAnnotation ? W("typeAnnotation") : "", Ae.type === "ClassBody" ? oe : ""];
                }
                case "TSTypePredicate":
                  return [X.asserts ? "asserts " : "", W("parameterName"), X.typeAnnotation ? [" is ", W("typeAnnotation")] : ""];
                case "TSNonNullExpression":
                  return [W("expression"), "!"];
                case "TSImportType":
                  return [X.isTypeOf ? "typeof " : "", "import(", W(X.parameter ? "parameter" : "argument"), ")", X.qualifier ? [".", W("qualifier")] : "", _(Q, le, W, "typeParameters")];
                case "TSLiteralType":
                  return W("literal");
                case "TSIndexedAccessType":
                  return O(Q, le, W);
                case "TSConstructSignatureDeclaration":
                case "TSCallSignatureDeclaration":
                case "TSConstructorType": {
                  if (X.type === "TSConstructorType" && X.abstract && ae.push("abstract "), X.type !== "TSCallSignatureDeclaration" && ae.push("new "), ae.push(l(R(Q, W, le, false, true))), X.returnType || X.typeAnnotation) {
                    let Ae = X.type === "TSConstructorType";
                    ae.push(Ae ? " => " : ": ", W("returnType"), W("typeAnnotation"));
                  }
                  return ae;
                }
                case "TSTypeOperator":
                  return [X.operator, " ", W("typeAnnotation")];
                case "TSMappedType": {
                  let Ae = s(le.originalText, F(X), A(X));
                  return l(["{", c([le.bracketSpacing ? r : i, X.readonly ? [p(X.readonly, "readonly"), " "] : "", I(Q, le, W), W("typeParameter"), X.optional ? p(X.optional, "?") : "", X.typeAnnotation ? ": " : "", W("typeAnnotation"), h(oe)]), t3(Q, le, true), le.bracketSpacing ? r : i, "}"], { shouldBreak: Ae });
                }
                case "TSMethodSignature": {
                  let Ae = X.kind && X.kind !== "method" ? `${X.kind} ` : "";
                  ae.push(X.accessibility ? [X.accessibility, " "] : "", Ae, X.export ? "export " : "", X.static ? "static " : "", X.readonly ? "readonly " : "", X.abstract ? "abstract " : "", X.declare ? "declare " : "", X.computed ? "[" : "", W("key"), X.computed ? "]" : "", B(Q));
                  let z = R(Q, W, le, false, true), H = X.returnType ? "returnType" : "typeAnnotation", Z = X[H], ne = Z ? W(H) : "", fe = f(X, ne);
                  return ae.push(fe ? l(z) : z), Z && ae.push(": ", l(ne)), l(ae);
                }
                case "TSNamespaceExportDeclaration":
                  return ae.push("export as namespace ", W("id")), le.semi && ae.push(";"), l(ae);
                case "TSEnumDeclaration":
                  return X.declare && ae.push("declare "), X.modifiers && ae.push(I(Q, le, W)), X.const && ae.push("const "), ae.push("enum ", W("id"), " "), X.members.length === 0 ? ae.push(l(["{", t3(Q, le), i, "}"])) : ae.push(l(["{", c([u, m(Q, le, "members", W), D(le, "es5") ? "," : ""]), t3(Q, le, true), u, "}"])), ae;
                case "TSEnumMember":
                  return X.computed ? ae.push("[", W("id"), "]") : ae.push(W("id")), X.initializer && ae.push(" = ", W("initializer")), ae;
                case "TSImportEqualsDeclaration":
                  return X.isExport && ae.push("export "), ae.push("import "), X.importKind && X.importKind !== "value" && ae.push(X.importKind, " "), ae.push(W("id"), " = ", W("moduleReference")), le.semi && ae.push(";"), l(ae);
                case "TSExternalModuleReference":
                  return ["require(", W("expression"), ")"];
                case "TSModuleDeclaration": {
                  let Ae = Q.getParentNode(), z = g(X.id), H = Ae.type === "TSModuleDeclaration", Z = X.body && X.body.type === "TSModuleDeclaration";
                  if (H)
                    ae.push(".");
                  else {
                    X.declare && ae.push("declare "), ae.push(I(Q, le, W));
                    let ne = le.originalText.slice(F(X), F(X.id));
                    X.id.type === "Identifier" && X.id.name === "global" && !/namespace|module/.test(ne) || ae.push(z || /(?:^|\s)module(?:\s|$)/.test(ne) ? "module " : "namespace ");
                  }
                  return ae.push(W("id")), Z ? ae.push(W("body")) : X.body ? ae.push(" ", l(W("body"))) : ae.push(oe), ae;
                }
                case "TSConditionalType":
                  return P(Q, le, W);
                case "TSInferType":
                  return ["infer", " ", W("typeParameter")];
                case "TSIntersectionType":
                  return J(Q, le, W);
                case "TSUnionType":
                  return L(Q, le, W);
                case "TSFunctionType":
                  return Y(Q, le, W);
                case "TSTupleType":
                  return V(Q, le, W);
                case "TSTypeReference":
                  return [W("typeName"), _(Q, le, W, "typeParameters")];
                case "TSTypeAnnotation":
                  return W("typeAnnotation");
                case "TSEmptyBodyFunctionExpression":
                  return k(Q, le, W);
                case "TSJSDocAllType":
                  return "*";
                case "TSJSDocUnknownType":
                  return "?";
                case "TSJSDocNullableType":
                  return K(Q, W, "?");
                case "TSJSDocNonNullableType":
                  return K(Q, W, "!");
                case "TSInstantiationExpression":
                  return [W("expression"), W("typeParameters")];
                default:
                  throw new Error(`Unknown TypeScript node type: ${JSON.stringify(X.type)}.`);
              }
            }
            n.exports = { printTypescript: se };
          } }), Gm = ee({ "src/language-js/print/comment.js"(e, n) {
            "use strict";
            re();
            var { hasNewline: t3 } = Ge(), { builders: { join: s, hardline: a }, utils: { replaceTextEndOfLine: r } } = qe(), { isLineComment: u } = Ke(), { locStart: i, locEnd: l } = it(), c = Lt();
            function y(p, D) {
              let v = p.getValue();
              if (u(v))
                return D.originalText.slice(i(v), l(v)).trimEnd();
              if (c(v)) {
                if (h(v)) {
                  let F = g(v);
                  return v.trailing && !t3(D.originalText, i(v), { backwards: true }) ? [a, F] : F;
                }
                let w = l(v), T = D.originalText.slice(w - 3, w) === "*-/";
                return ["/*", r(v.value), T ? "*-/" : "*/"];
              }
              throw new Error("Not a comment: " + JSON.stringify(v));
            }
            function h(p) {
              let D = `*${p.value}*`.split(`
`);
              return D.length > 1 && D.every((v) => v.trim()[0] === "*");
            }
            function g(p) {
              let D = p.value.split(`
`);
              return ["/*", s(a, D.map((v, w) => w === 0 ? v.trimEnd() : " " + (w < D.length - 1 ? v.trim() : v.trimStart()))), "*/"];
            }
            n.exports = { printComment: y };
          } }), Um = ee({ "src/language-js/print/literal.js"(e, n) {
            "use strict";
            re();
            var { printString: t3, printNumber: s } = Ge(), { replaceTextEndOfLine: a } = Xt();
            function r(l, c) {
              let y = l.getNode();
              switch (y.type) {
                case "RegExpLiteral":
                  return i(y);
                case "BigIntLiteral":
                  return u(y.bigint || y.extra.raw);
                case "NumericLiteral":
                  return s(y.extra.raw);
                case "StringLiteral":
                  return a(t3(y.extra.raw, c));
                case "NullLiteral":
                  return "null";
                case "BooleanLiteral":
                  return String(y.value);
                case "DecimalLiteral":
                  return s(y.value) + "m";
                case "Literal": {
                  if (y.regex)
                    return i(y.regex);
                  if (y.bigint)
                    return u(y.raw);
                  if (y.decimal)
                    return s(y.decimal) + "m";
                  let { value: h } = y;
                  return typeof h == "number" ? s(y.raw) : typeof h == "string" ? a(t3(y.raw, c)) : String(h);
                }
              }
            }
            function u(l) {
              return l.toLowerCase();
            }
            function i(l) {
              let { pattern: c, flags: y } = l;
              return y = [...y].sort().join(""), `/${c}/${y}`;
            }
            n.exports = { printLiteral: r };
          } }), Jm = ee({ "src/language-js/printer-estree.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { hasNewline: s } = Ge(), { builders: { join: a, line: r, hardline: u, softline: i, group: l, indent: c }, utils: { replaceTextEndOfLine: y } } = qe(), h = Nm(), g = wm(), { insertPragma: p } = Qa(), D = Za(), v = Ot(), w = eo(), { hasFlowShorthandAnnotationComment: T, hasComment: F, CommentCheckFlags: A, isTheOnlyJsxElementInMarkdown: B, isLineComment: I, isNextLineEmpty: P, needsHardlineAfterDanglingComment: R, rawText: f, hasIgnoreComment: x, isCallExpression: m, isMemberExpression: E, markerForIfWithoutBlockAndSameLineComment: o } = Ke(), { locStart: d, locEnd: C } = it(), _ = Lt(), { printHtmlBinding: b, isVueEventBindingExpression: N } = qm(), { printAngular: k } = Mm(), { printJsx: $, hasJsxIgnoreComment: M } = Rm(), { printFlow: q } = Vm(), { printTypescript: J } = Hm(), { printOptionalToken: L, printBindExpressionCallee: Y, printTypeAnnotation: V, adjustClause: O, printRestSpread: K, printDefiniteToken: se } = Dt(), { printImportDeclaration: Q, printExportDeclaration: le, printExportAllDeclaration: W, printModuleSpecifier: X } = so(), { printTernary: oe } = io(), { printTemplateLiteral: ae } = jt(), { printArray: Ae } = Qt(), { printObject: z } = Xn(), { printClass: H, printClassMethod: Z, printClassProperty: ne } = tr(), { printProperty: fe } = er(), { printFunction: ge, printArrowFunction: Ce, printMethod: _e, printReturnStatement: Oe, printThrowStatement: pe } = Or(), { printCallExpression: ie } = no(), { printVariableDeclarator: ve, printAssignmentExpression: ce } = Zt(), { printBinaryishExpression: U } = Jn(), { printSwitchCaseConsequent: de } = ao(), { printMemberExpression: De } = ro(), { printBlock: he, printBlockBody: Be } = oo(), { printComment: Se } = Gm(), { printLiteral: ye } = Um(), { printDecorators: S } = zn();
            function G(Te, Pe, Fe, Ze) {
              let xe = te(Te, Pe, Fe, Ze);
              if (!xe)
                return "";
              let Je = Te.getValue(), { type: we } = Je;
              if (we === "ClassMethod" || we === "ClassPrivateMethod" || we === "ClassProperty" || we === "ClassAccessorProperty" || we === "PropertyDefinition" || we === "TSAbstractPropertyDefinition" || we === "ClassPrivateProperty" || we === "MethodDefinition" || we === "TSAbstractMethodDefinition" || we === "TSDeclareMethod")
                return xe;
              let Le = [xe], Ve = S(Te, Pe, Fe), be = Je.type === "ClassExpression" && Ve;
              if (Ve && (Le = [...Ve, xe], !be))
                return l(Le);
              if (!v(Te, Pe))
                return Ze && Ze.needsSemi && Le.unshift(";"), Le.length === 1 && Le[0] === xe ? xe : Le;
              if (be && (Le = [c([r, ...Le])]), Le.unshift("("), Ze && Ze.needsSemi && Le.unshift(";"), T(Je)) {
                let [Me] = Je.trailingComments;
                Le.push(" /*", Me.value.trimStart(), "*/"), Me.printed = true;
              }
              return be && Le.push(r), Le.push(")"), Le;
            }
            function te(Te, Pe, Fe, Ze) {
              let xe = Te.getValue(), Je = Pe.semi ? ";" : "";
              if (!xe)
                return "";
              if (typeof xe == "string")
                return xe;
              for (let Le of [ye, b, k, $, q, J]) {
                let Ve = Le(Te, Pe, Fe);
                if (typeof Ve < "u")
                  return Ve;
              }
              let we = [];
              switch (xe.type) {
                case "JsExpressionRoot":
                  return Fe("node");
                case "JsonRoot":
                  return [Fe("node"), u];
                case "File":
                  return xe.program && xe.program.interpreter && we.push(Fe(["program", "interpreter"])), we.push(Fe("program")), we;
                case "Program":
                  return Be(Te, Pe, Fe);
                case "EmptyStatement":
                  return "";
                case "ExpressionStatement": {
                  if (xe.directive)
                    return [Ee(xe.expression, Pe), Je];
                  if (Pe.parser === "__vue_event_binding" || Pe.parser === "__vue_ts_event_binding") {
                    let Ve = Te.getParentNode();
                    if (Ve.type === "Program" && Ve.body.length === 1 && Ve.body[0] === xe)
                      return [Fe("expression"), N(xe.expression) ? ";" : ""];
                  }
                  let Le = t3(Te, Pe, true, (Ve) => {
                    let { marker: be } = Ve;
                    return be === o;
                  });
                  return [Fe("expression"), B(Pe, Te) ? "" : Je, Le ? [" ", Le] : ""];
                }
                case "ParenthesizedExpression":
                  return !F(xe.expression) && (xe.expression.type === "ObjectExpression" || xe.expression.type === "ArrayExpression") ? ["(", Fe("expression"), ")"] : l(["(", c([i, Fe("expression")]), i, ")"]);
                case "AssignmentExpression":
                  return ce(Te, Pe, Fe);
                case "VariableDeclarator":
                  return ve(Te, Pe, Fe);
                case "BinaryExpression":
                case "LogicalExpression":
                  return U(Te, Pe, Fe);
                case "AssignmentPattern":
                  return [Fe("left"), " = ", Fe("right")];
                case "OptionalMemberExpression":
                case "MemberExpression":
                  return De(Te, Pe, Fe);
                case "MetaProperty":
                  return [Fe("meta"), ".", Fe("property")];
                case "BindExpression":
                  return xe.object && we.push(Fe("object")), we.push(l(c([i, Y(Te, Pe, Fe)]))), we;
                case "Identifier":
                  return [xe.name, L(Te), se(Te), V(Te, Pe, Fe)];
                case "V8IntrinsicIdentifier":
                  return ["%", xe.name];
                case "SpreadElement":
                case "SpreadElementPattern":
                case "SpreadProperty":
                case "SpreadPropertyPattern":
                case "RestElement":
                  return K(Te, Pe, Fe);
                case "FunctionDeclaration":
                case "FunctionExpression":
                  return ge(Te, Fe, Pe, Ze);
                case "ArrowFunctionExpression":
                  return Ce(Te, Pe, Fe, Ze);
                case "YieldExpression":
                  return we.push("yield"), xe.delegate && we.push("*"), xe.argument && we.push(" ", Fe("argument")), we;
                case "AwaitExpression": {
                  if (we.push("await"), xe.argument) {
                    we.push(" ", Fe("argument"));
                    let Le = Te.getParentNode();
                    if (m(Le) && Le.callee === xe || E(Le) && Le.object === xe) {
                      we = [c([i, ...we]), i];
                      let Ve = Te.findAncestor((be) => be.type === "AwaitExpression" || be.type === "BlockStatement");
                      if (!Ve || Ve.type !== "AwaitExpression")
                        return l(we);
                    }
                  }
                  return we;
                }
                case "ExportDefaultDeclaration":
                case "ExportNamedDeclaration":
                  return le(Te, Pe, Fe);
                case "ExportAllDeclaration":
                  return W(Te, Pe, Fe);
                case "ImportDeclaration":
                  return Q(Te, Pe, Fe);
                case "ImportSpecifier":
                case "ExportSpecifier":
                case "ImportNamespaceSpecifier":
                case "ExportNamespaceSpecifier":
                case "ImportDefaultSpecifier":
                case "ExportDefaultSpecifier":
                  return X(Te, Pe, Fe);
                case "ImportAttribute":
                  return [Fe("key"), ": ", Fe("value")];
                case "Import":
                  return "import";
                case "BlockStatement":
                case "StaticBlock":
                case "ClassBody":
                  return he(Te, Pe, Fe);
                case "ThrowStatement":
                  return pe(Te, Pe, Fe);
                case "ReturnStatement":
                  return Oe(Te, Pe, Fe);
                case "NewExpression":
                case "ImportExpression":
                case "OptionalCallExpression":
                case "CallExpression":
                  return ie(Te, Pe, Fe);
                case "ObjectExpression":
                case "ObjectPattern":
                case "RecordExpression":
                  return z(Te, Pe, Fe);
                case "ObjectProperty":
                case "Property":
                  return xe.method || xe.kind === "get" || xe.kind === "set" ? _e(Te, Pe, Fe) : fe(Te, Pe, Fe);
                case "ObjectMethod":
                  return _e(Te, Pe, Fe);
                case "Decorator":
                  return ["@", Fe("expression")];
                case "ArrayExpression":
                case "ArrayPattern":
                case "TupleExpression":
                  return Ae(Te, Pe, Fe);
                case "SequenceExpression": {
                  let Le = Te.getParentNode(0);
                  if (Le.type === "ExpressionStatement" || Le.type === "ForStatement") {
                    let Ve = [];
                    return Te.each((be, ke) => {
                      ke === 0 ? Ve.push(Fe()) : Ve.push(",", c([r, Fe()]));
                    }, "expressions"), l(Ve);
                  }
                  return l(a([",", r], Te.map(Fe, "expressions")));
                }
                case "ThisExpression":
                  return "this";
                case "Super":
                  return "super";
                case "Directive":
                  return [Fe("value"), Je];
                case "DirectiveLiteral":
                  return Ee(xe, Pe);
                case "UnaryExpression":
                  return we.push(xe.operator), /[a-z]$/.test(xe.operator) && we.push(" "), F(xe.argument) ? we.push(l(["(", c([i, Fe("argument")]), i, ")"])) : we.push(Fe("argument")), we;
                case "UpdateExpression":
                  return we.push(Fe("argument"), xe.operator), xe.prefix && we.reverse(), we;
                case "ConditionalExpression":
                  return oe(Te, Pe, Fe);
                case "VariableDeclaration": {
                  let Le = Te.map(Fe, "declarations"), Ve = Te.getParentNode(), be = Ve.type === "ForStatement" || Ve.type === "ForInStatement" || Ve.type === "ForOfStatement", ke = xe.declarations.some((ue) => ue.init), Me;
                  return Le.length === 1 && !F(xe.declarations[0]) ? Me = Le[0] : Le.length > 0 && (Me = c(Le[0])), we = [xe.declare ? "declare " : "", xe.kind, Me ? [" ", Me] : "", c(Le.slice(1).map((ue) => [",", ke && !be ? u : r, ue]))], be && Ve.body !== xe || we.push(Je), l(we);
                }
                case "WithStatement":
                  return l(["with (", Fe("object"), ")", O(xe.body, Fe("body"))]);
                case "IfStatement": {
                  let Le = O(xe.consequent, Fe("consequent")), Ve = l(["if (", l([c([i, Fe("test")]), i]), ")", Le]);
                  if (we.push(Ve), xe.alternate) {
                    let be = F(xe.consequent, A.Trailing | A.Line) || R(xe), ke = xe.consequent.type === "BlockStatement" && !be;
                    we.push(ke ? " " : u), F(xe, A.Dangling) && we.push(t3(Te, Pe, true), be ? u : " "), we.push("else", l(O(xe.alternate, Fe("alternate"), xe.alternate.type === "IfStatement")));
                  }
                  return we;
                }
                case "ForStatement": {
                  let Le = O(xe.body, Fe("body")), Ve = t3(Te, Pe, true), be = Ve ? [Ve, i] : "";
                  return !xe.init && !xe.test && !xe.update ? [be, l(["for (;;)", Le])] : [be, l(["for (", l([c([i, Fe("init"), ";", r, Fe("test"), ";", r, Fe("update")]), i]), ")", Le])];
                }
                case "WhileStatement":
                  return l(["while (", l([c([i, Fe("test")]), i]), ")", O(xe.body, Fe("body"))]);
                case "ForInStatement":
                  return l(["for (", Fe("left"), " in ", Fe("right"), ")", O(xe.body, Fe("body"))]);
                case "ForOfStatement":
                  return l(["for", xe.await ? " await" : "", " (", Fe("left"), " of ", Fe("right"), ")", O(xe.body, Fe("body"))]);
                case "DoWhileStatement": {
                  let Le = O(xe.body, Fe("body"));
                  return we = [l(["do", Le])], xe.body.type === "BlockStatement" ? we.push(" ") : we.push(u), we.push("while (", l([c([i, Fe("test")]), i]), ")", Je), we;
                }
                case "DoExpression":
                  return [xe.async ? "async " : "", "do ", Fe("body")];
                case "BreakStatement":
                  return we.push("break"), xe.label && we.push(" ", Fe("label")), we.push(Je), we;
                case "ContinueStatement":
                  return we.push("continue"), xe.label && we.push(" ", Fe("label")), we.push(Je), we;
                case "LabeledStatement":
                  return xe.body.type === "EmptyStatement" ? [Fe("label"), ":;"] : [Fe("label"), ": ", Fe("body")];
                case "TryStatement":
                  return ["try ", Fe("block"), xe.handler ? [" ", Fe("handler")] : "", xe.finalizer ? [" finally ", Fe("finalizer")] : ""];
                case "CatchClause":
                  if (xe.param) {
                    let Le = F(xe.param, (be) => !_(be) || be.leading && s(Pe.originalText, C(be)) || be.trailing && s(Pe.originalText, d(be), { backwards: true })), Ve = Fe("param");
                    return ["catch ", Le ? ["(", c([i, Ve]), i, ") "] : ["(", Ve, ") "], Fe("body")];
                  }
                  return ["catch ", Fe("body")];
                case "SwitchStatement":
                  return [l(["switch (", c([i, Fe("discriminant")]), i, ")"]), " {", xe.cases.length > 0 ? c([u, a(u, Te.map((Le, Ve, be) => {
                    let ke = Le.getValue();
                    return [Fe(), Ve !== be.length - 1 && P(ke, Pe) ? u : ""];
                  }, "cases"))]) : "", u, "}"];
                case "SwitchCase": {
                  xe.test ? we.push("case ", Fe("test"), ":") : we.push("default:"), F(xe, A.Dangling) && we.push(" ", t3(Te, Pe, true));
                  let Le = xe.consequent.filter((Ve) => Ve.type !== "EmptyStatement");
                  if (Le.length > 0) {
                    let Ve = de(Te, Pe, Fe);
                    we.push(Le.length === 1 && Le[0].type === "BlockStatement" ? [" ", Ve] : c([u, Ve]));
                  }
                  return we;
                }
                case "DebuggerStatement":
                  return ["debugger", Je];
                case "ClassDeclaration":
                case "ClassExpression":
                  return H(Te, Pe, Fe);
                case "ClassMethod":
                case "ClassPrivateMethod":
                case "MethodDefinition":
                  return Z(Te, Pe, Fe);
                case "ClassProperty":
                case "PropertyDefinition":
                case "ClassPrivateProperty":
                case "ClassAccessorProperty":
                  return ne(Te, Pe, Fe);
                case "TemplateElement":
                  return y(xe.value.raw);
                case "TemplateLiteral":
                  return ae(Te, Fe, Pe);
                case "TaggedTemplateExpression":
                  return [Fe("tag"), Fe("typeParameters"), Fe("quasi")];
                case "PrivateIdentifier":
                  return ["#", Fe("name")];
                case "PrivateName":
                  return ["#", Fe("id")];
                case "InterpreterDirective":
                  return we.push("#!", xe.value, u), P(xe, Pe) && we.push(u), we;
                case "TopicReference":
                  return "%";
                case "ArgumentPlaceholder":
                  return "?";
                case "ModuleExpression": {
                  we.push("module {");
                  let Le = Fe("body");
                  return Le && we.push(c([u, Le]), u), we.push("}"), we;
                }
                default:
                  throw new Error("unknown type: " + JSON.stringify(xe.type));
              }
            }
            function Ee(Te, Pe) {
              let Fe = f(Te), Ze = Fe.slice(1, -1);
              if (Ze.includes('"') || Ze.includes("'"))
                return Fe;
              let xe = Pe.singleQuote ? "'" : '"';
              return xe + Ze + xe;
            }
            function Re(Te) {
              return Te.type && !_(Te) && !I(Te) && Te.type !== "EmptyStatement" && Te.type !== "TemplateElement" && Te.type !== "Import" && Te.type !== "TSEmptyBodyFunctionExpression";
            }
            n.exports = { preprocess: w, print: G, embed: h, insertPragma: p, massageAstNode: g, hasPrettierIgnore(Te) {
              return x(Te) || M(Te);
            }, willPrintOwnComments: D.willPrintOwnComments, canAttachComment: Re, printComment: Se, isBlockComment: _, handleComments: { avoidAstMutation: true, ownLine: D.handleOwnLineComment, endOfLine: D.handleEndOfLineComment, remaining: D.handleRemainingComment }, getCommentChildNodes: D.getCommentChildNodes };
          } }), zm = ee({ "src/language-js/printer-estree-json.js"(e, n) {
            "use strict";
            re();
            var { builders: { hardline: t3, indent: s, join: a } } = qe(), r = eo();
            function u(c, y, h) {
              let g = c.getValue();
              switch (g.type) {
                case "JsonRoot":
                  return [h("node"), t3];
                case "ArrayExpression": {
                  if (g.elements.length === 0)
                    return "[]";
                  let p = c.map(() => c.getValue() === null ? "null" : h(), "elements");
                  return ["[", s([t3, a([",", t3], p)]), t3, "]"];
                }
                case "ObjectExpression":
                  return g.properties.length === 0 ? "{}" : ["{", s([t3, a([",", t3], c.map(h, "properties"))]), t3, "}"];
                case "ObjectProperty":
                  return [h("key"), ": ", h("value")];
                case "UnaryExpression":
                  return [g.operator === "+" ? "" : g.operator, h("argument")];
                case "NullLiteral":
                  return "null";
                case "BooleanLiteral":
                  return g.value ? "true" : "false";
                case "StringLiteral":
                case "NumericLiteral":
                  return JSON.stringify(g.value);
                case "Identifier": {
                  let p = c.getParentNode();
                  return p && p.type === "ObjectProperty" && p.key === g ? JSON.stringify(g.name) : g.name;
                }
                case "TemplateLiteral":
                  return h(["quasis", 0]);
                case "TemplateElement":
                  return JSON.stringify(g.value.cooked);
                default:
                  throw new Error("unknown type: " + JSON.stringify(g.type));
              }
            }
            var i = /* @__PURE__ */ new Set(["start", "end", "extra", "loc", "comments", "leadingComments", "trailingComments", "innerComments", "errors", "range", "tokens"]);
            function l(c, y) {
              let { type: h } = c;
              if (h === "ObjectProperty" && c.key.type === "Identifier") {
                y.key = { type: "StringLiteral", value: c.key.name };
                return;
              }
              if (h === "UnaryExpression" && c.operator === "+")
                return y.argument;
              if (h === "ArrayExpression") {
                for (let [g, p] of c.elements.entries())
                  p === null && y.elements.splice(g, 0, { type: "NullLiteral" });
                return;
              }
              if (h === "TemplateLiteral")
                return { type: "StringLiteral", value: c.quasis[0].value.cooked };
            }
            l.ignoredProperties = i, n.exports = { preprocess: r, print: u, massageAstNode: l };
          } }), qt = ee({ "src/common/common-options.js"(e, n) {
            "use strict";
            re();
            var t3 = "Common";
            n.exports = { bracketSpacing: { since: "0.0.0", category: t3, type: "boolean", default: true, description: "Print spaces between brackets.", oppositeDescription: "Do not print spaces between brackets." }, singleQuote: { since: "0.0.0", category: t3, type: "boolean", default: false, description: "Use single quotes instead of double quotes." }, proseWrap: { since: "1.8.2", category: t3, type: "choice", default: [{ since: "1.8.2", value: true }, { since: "1.9.0", value: "preserve" }], description: "How to wrap prose.", choices: [{ since: "1.9.0", value: "always", description: "Wrap prose if it exceeds the print width." }, { since: "1.9.0", value: "never", description: "Do not wrap prose." }, { since: "1.9.0", value: "preserve", description: "Wrap prose as-is." }] }, bracketSameLine: { since: "2.4.0", category: t3, type: "boolean", default: false, description: "Put > of opening tags on the last line instead of on a new line." }, singleAttributePerLine: { since: "2.6.0", category: t3, type: "boolean", default: false, description: "Enforce single attribute per line in HTML, Vue and JSX." } };
          } }), Xm = ee({ "src/language-js/options.js"(e, n) {
            "use strict";
            re();
            var t3 = qt(), s = "JavaScript";
            n.exports = { arrowParens: { since: "1.9.0", category: s, type: "choice", default: [{ since: "1.9.0", value: "avoid" }, { since: "2.0.0", value: "always" }], description: "Include parentheses around a sole arrow function parameter.", choices: [{ value: "always", description: "Always include parens. Example: `(x) => x`" }, { value: "avoid", description: "Omit parens when possible. Example: `x => x`" }] }, bracketSameLine: t3.bracketSameLine, bracketSpacing: t3.bracketSpacing, jsxBracketSameLine: { since: "0.17.0", category: s, type: "boolean", description: "Put > on the last line instead of at a new line.", deprecated: "2.4.0" }, semi: { since: "1.0.0", category: s, type: "boolean", default: true, description: "Print semicolons.", oppositeDescription: "Do not print semicolons, except at the beginning of lines which may need them." }, singleQuote: t3.singleQuote, jsxSingleQuote: { since: "1.15.0", category: s, type: "boolean", default: false, description: "Use single quotes in JSX." }, quoteProps: { since: "1.17.0", category: s, type: "choice", default: "as-needed", description: "Change when properties in objects are quoted.", choices: [{ value: "as-needed", description: "Only add quotes around object properties where required." }, { value: "consistent", description: "If at least one property in an object requires quotes, quote all properties." }, { value: "preserve", description: "Respect the input use of quotes in object properties." }] }, trailingComma: { since: "0.0.0", category: s, type: "choice", default: [{ since: "0.0.0", value: false }, { since: "0.19.0", value: "none" }, { since: "2.0.0", value: "es5" }], description: "Print trailing commas wherever possible when multi-line.", choices: [{ value: "es5", description: "Trailing commas where valid in ES5 (objects, arrays, etc.)" }, { value: "none", description: "No trailing commas." }, { value: "all", description: "Trailing commas wherever possible (including function arguments)." }] }, singleAttributePerLine: t3.singleAttributePerLine };
          } }), Km = ee({ "src/language-js/parse/parsers.js"() {
            re();
          } }), bn = ee({ "node_modules/linguist-languages/data/JavaScript.json"(e, n) {
            n.exports = { name: "JavaScript", type: "programming", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", color: "#f1e05a", aliases: ["js", "node"], extensions: [".js", "._js", ".bones", ".cjs", ".es", ".es6", ".frag", ".gs", ".jake", ".javascript", ".jsb", ".jscad", ".jsfl", ".jslib", ".jsm", ".jspre", ".jss", ".jsx", ".mjs", ".njs", ".pac", ".sjs", ".ssjs", ".xsjs", ".xsjslib"], filenames: ["Jakefile"], interpreters: ["chakra", "d8", "gjs", "js", "node", "nodejs", "qjs", "rhino", "v8", "v8-shell"], languageId: 183 };
          } }), Ym = ee({ "node_modules/linguist-languages/data/TypeScript.json"(e, n) {
            n.exports = { name: "TypeScript", type: "programming", color: "#3178c6", aliases: ["ts"], interpreters: ["deno", "ts-node"], extensions: [".ts", ".cts", ".mts"], tmScope: "source.ts", aceMode: "typescript", codemirrorMode: "javascript", codemirrorMimeType: "application/typescript", languageId: 378 };
          } }), Qm = ee({ "node_modules/linguist-languages/data/TSX.json"(e, n) {
            n.exports = { name: "TSX", type: "programming", color: "#3178c6", group: "TypeScript", extensions: [".tsx"], tmScope: "source.tsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", languageId: 94901924 };
          } }), la = ee({ "node_modules/linguist-languages/data/JSON.json"(e, n) {
            n.exports = { name: "JSON", type: "data", color: "#292929", tmScope: "source.json", aceMode: "json", codemirrorMode: "javascript", codemirrorMimeType: "application/json", aliases: ["geojson", "jsonl", "topojson"], extensions: [".json", ".4DForm", ".4DProject", ".avsc", ".geojson", ".gltf", ".har", ".ice", ".JSON-tmLanguage", ".jsonl", ".mcmeta", ".tfstate", ".tfstate.backup", ".topojson", ".webapp", ".webmanifest", ".yy", ".yyp"], filenames: [".arcconfig", ".auto-changelog", ".c8rc", ".htmlhintrc", ".imgbotconfig", ".nycrc", ".tern-config", ".tern-project", ".watchmanconfig", "Pipfile.lock", "composer.lock", "mcmod.info"], languageId: 174 };
          } }), Zm = ee({ "node_modules/linguist-languages/data/JSON with Comments.json"(e, n) {
            n.exports = { name: "JSON with Comments", type: "data", color: "#292929", group: "JSON", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", aliases: ["jsonc"], extensions: [".jsonc", ".code-snippets", ".sublime-build", ".sublime-commands", ".sublime-completions", ".sublime-keymap", ".sublime-macro", ".sublime-menu", ".sublime-mousemap", ".sublime-project", ".sublime-settings", ".sublime-theme", ".sublime-workspace", ".sublime_metrics", ".sublime_session"], filenames: [".babelrc", ".devcontainer.json", ".eslintrc.json", ".jscsrc", ".jshintrc", ".jslintrc", "api-extractor.json", "devcontainer.json", "jsconfig.json", "language-configuration.json", "tsconfig.json", "tslint.json"], languageId: 423 };
          } }), ed = ee({ "node_modules/linguist-languages/data/JSON5.json"(e, n) {
            n.exports = { name: "JSON5", type: "data", color: "#267CB9", extensions: [".json5"], tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "application/json", languageId: 175 };
          } }), td = ee({ "src/language-js/index.js"(e, n) {
            "use strict";
            re();
            var t3 = wt(), s = Jm(), a = zm(), r = Xm(), u = Km(), i = [t3(bn(), (c) => ({ since: "0.0.0", parsers: ["babel", "acorn", "espree", "meriyah", "babel-flow", "babel-ts", "flow", "typescript"], vscodeLanguageIds: ["javascript", "mongo"], interpreters: [...c.interpreters, "zx"], extensions: [...c.extensions.filter((y) => y !== ".jsx"), ".wxs"] })), t3(bn(), () => ({ name: "Flow", since: "0.0.0", parsers: ["flow", "babel-flow"], vscodeLanguageIds: ["javascript"], aliases: [], filenames: [], extensions: [".js.flow"] })), t3(bn(), () => ({ name: "JSX", since: "0.0.0", parsers: ["babel", "babel-flow", "babel-ts", "flow", "typescript", "espree", "meriyah"], vscodeLanguageIds: ["javascriptreact"], aliases: void 0, filenames: void 0, extensions: [".jsx"], group: "JavaScript", interpreters: void 0, tmScope: "source.js.jsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", color: void 0 })), t3(Ym(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescript"] })), t3(Qm(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescriptreact"] })), t3(la(), () => ({ name: "JSON.stringify", since: "1.13.0", parsers: ["json-stringify"], vscodeLanguageIds: ["json"], extensions: [".importmap"], filenames: ["package.json", "package-lock.json", "composer.json"] })), t3(la(), (c) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["json"], extensions: c.extensions.filter((y) => y !== ".jsonl") })), t3(Zm(), (c) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["jsonc"], filenames: [...c.filenames, ".eslintrc", ".swcrc"] })), t3(ed(), () => ({ since: "1.13.0", parsers: ["json5"], vscodeLanguageIds: ["json5"] }))], l = { estree: s, "estree-json": a };
            n.exports = { languages: i, options: r, printers: l, parsers: u };
          } }), rd = ee({ "src/language-css/clean.js"(e, n) {
            "use strict";
            re();
            var { isFrontMatterNode: t3 } = Ge(), s = lt2(), a = /* @__PURE__ */ new Set(["raw", "raws", "sourceIndex", "source", "before", "after", "trailingComma"]);
            function r(i, l, c) {
              if (t3(i) && i.lang === "yaml" && delete l.value, i.type === "css-comment" && c.type === "css-root" && c.nodes.length > 0 && ((c.nodes[0] === i || t3(c.nodes[0]) && c.nodes[1] === i) && (delete l.text, /^\*\s*@(?:format|prettier)\s*$/.test(i.text)) || c.type === "css-root" && s(c.nodes) === i))
                return null;
              if (i.type === "value-root" && delete l.text, (i.type === "media-query" || i.type === "media-query-list" || i.type === "media-feature-expression") && delete l.value, i.type === "css-rule" && delete l.params, i.type === "selector-combinator" && (l.value = l.value.replace(/\s+/g, " ")), i.type === "media-feature" && (l.value = l.value.replace(/ /g, "")), (i.type === "value-word" && (i.isColor && i.isHex || ["initial", "inherit", "unset", "revert"].includes(l.value.replace().toLowerCase())) || i.type === "media-feature" || i.type === "selector-root-invalid" || i.type === "selector-pseudo") && (l.value = l.value.toLowerCase()), i.type === "css-decl" && (l.prop = l.prop.toLowerCase()), (i.type === "css-atrule" || i.type === "css-import") && (l.name = l.name.toLowerCase()), i.type === "value-number" && (l.unit = l.unit.toLowerCase()), (i.type === "media-feature" || i.type === "media-keyword" || i.type === "media-type" || i.type === "media-unknown" || i.type === "media-url" || i.type === "media-value" || i.type === "selector-attribute" || i.type === "selector-string" || i.type === "selector-class" || i.type === "selector-combinator" || i.type === "value-string") && l.value && (l.value = u(l.value)), i.type === "selector-attribute" && (l.attribute = l.attribute.trim(), l.namespace && typeof l.namespace == "string" && (l.namespace = l.namespace.trim(), l.namespace.length === 0 && (l.namespace = true)), l.value && (l.value = l.value.trim().replace(/^["']|["']$/g, ""), delete l.quoted)), (i.type === "media-value" || i.type === "media-type" || i.type === "value-number" || i.type === "selector-root-invalid" || i.type === "selector-class" || i.type === "selector-combinator" || i.type === "selector-tag") && l.value && (l.value = l.value.replace(/([\d+.Ee-]+)([A-Za-z]*)/g, (y, h, g) => {
                let p = Number(h);
                return Number.isNaN(p) ? y : p + g.toLowerCase();
              })), i.type === "selector-tag") {
                let y = i.value.toLowerCase();
                ["from", "to"].includes(y) && (l.value = y);
              }
              if (i.type === "css-atrule" && i.name.toLowerCase() === "supports" && delete l.value, i.type === "selector-unknown" && delete l.value, i.type === "value-comma_group") {
                let y = i.groups.findIndex((h) => h.type === "value-number" && h.unit === "...");
                y !== -1 && (l.groups[y].unit = "", l.groups.splice(y + 1, 0, { type: "value-word", value: "...", isColor: false, isHex: false }));
              }
            }
            r.ignoredProperties = a;
            function u(i) {
              return i.replace(/'/g, '"').replace(/\\([^\dA-Fa-f])/g, "$1");
            }
            n.exports = r;
          } }), Kn = ee({ "src/utils/front-matter/print.js"(e, n) {
            "use strict";
            re();
            var { builders: { hardline: t3, markAsRoot: s } } = qe();
            function a(r, u) {
              if (r.lang === "yaml") {
                let i = r.value.trim(), l = i ? u(i, { parser: "yaml" }, { stripTrailingHardline: true }) : "";
                return s([r.startDelimiter, t3, l, l ? t3 : "", r.endDelimiter]);
              }
            }
            n.exports = a;
          } }), nd = ee({ "src/language-css/embed.js"(e, n) {
            "use strict";
            re();
            var { builders: { hardline: t3 } } = qe(), s = Kn();
            function a(r, u, i) {
              let l = r.getValue();
              if (l.type === "front-matter") {
                let c = s(l, i);
                return c ? [c, t3] : "";
              }
            }
            n.exports = a;
          } }), lo = ee({ "src/utils/front-matter/parse.js"(e, n) {
            "use strict";
            re();
            var t3 = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
            function s(a) {
              let r = a.match(t3);
              if (!r)
                return { content: a };
              let { startDelimiter: u, language: i, value: l = "", endDelimiter: c } = r.groups, y = i.trim() || "yaml";
              if (u === "+++" && (y = "toml"), y !== "yaml" && u !== c)
                return { content: a };
              let [h] = r;
              return { frontMatter: { type: "front-matter", lang: y, value: l, startDelimiter: u, endDelimiter: c, raw: h.replace(/\n$/, "") }, content: h.replace(/[^\n]/g, " ") + a.slice(h.length) };
            }
            n.exports = s;
          } }), ud = ee({ "src/language-css/pragma.js"(e, n) {
            "use strict";
            re();
            var t3 = Qa(), s = lo();
            function a(u) {
              return t3.hasPragma(s(u).content);
            }
            function r(u) {
              let { frontMatter: i, content: l } = s(u);
              return (i ? i.raw + `

` : "") + t3.insertPragma(l);
            }
            n.exports = { hasPragma: a, insertPragma: r };
          } }), sd = ee({ "src/language-css/utils/index.js"(e, n) {
            "use strict";
            re();
            var t3 = /* @__PURE__ */ new Set(["red", "green", "blue", "alpha", "a", "rgb", "hue", "h", "saturation", "s", "lightness", "l", "whiteness", "w", "blackness", "b", "tint", "shade", "blend", "blenda", "contrast", "hsl", "hsla", "hwb", "hwba"]);
            function s(z, H) {
              let Z = Array.isArray(H) ? H : [H], ne = -1, fe;
              for (; fe = z.getParentNode(++ne); )
                if (Z.includes(fe.type))
                  return ne;
              return -1;
            }
            function a(z, H) {
              let Z = s(z, H);
              return Z === -1 ? null : z.getParentNode(Z);
            }
            function r(z) {
              var H;
              let Z = a(z, "css-decl");
              return Z == null || (H = Z.prop) === null || H === void 0 ? void 0 : H.toLowerCase();
            }
            var u = /* @__PURE__ */ new Set(["initial", "inherit", "unset", "revert"]);
            function i(z) {
              return u.has(z.toLowerCase());
            }
            function l(z, H) {
              let Z = a(z, "css-atrule");
              return (Z == null ? void 0 : Z.name) && Z.name.toLowerCase().endsWith("keyframes") && ["from", "to"].includes(H.toLowerCase());
            }
            function c(z) {
              return z.includes("$") || z.includes("@") || z.includes("#") || z.startsWith("%") || z.startsWith("--") || z.startsWith(":--") || z.includes("(") && z.includes(")") ? z : z.toLowerCase();
            }
            function y(z, H) {
              var Z;
              let ne = a(z, "value-func");
              return (ne == null || (Z = ne.value) === null || Z === void 0 ? void 0 : Z.toLowerCase()) === H;
            }
            function h(z) {
              var H;
              let Z = a(z, "css-rule"), ne = Z == null || (H = Z.raws) === null || H === void 0 ? void 0 : H.selector;
              return ne && (ne.startsWith(":import") || ne.startsWith(":export"));
            }
            function g(z, H) {
              let Z = Array.isArray(H) ? H : [H], ne = a(z, "css-atrule");
              return ne && Z.includes(ne.name.toLowerCase());
            }
            function p(z) {
              let H = z.getValue(), Z = a(z, "css-atrule");
              return (Z == null ? void 0 : Z.name) === "import" && H.groups[0].value === "url" && H.groups.length === 2;
            }
            function D(z) {
              return z.type === "value-func" && z.value.toLowerCase() === "url";
            }
            function v(z, H) {
              var Z;
              let ne = (Z = z.getParentNode()) === null || Z === void 0 ? void 0 : Z.nodes;
              return ne && ne.indexOf(H) === ne.length - 1;
            }
            function w(z) {
              let { selector: H } = z;
              return H ? typeof H == "string" && /^@.+:.*$/.test(H) || H.value && /^@.+:.*$/.test(H.value) : false;
            }
            function T(z) {
              return z.type === "value-word" && ["from", "through", "end"].includes(z.value);
            }
            function F(z) {
              return z.type === "value-word" && ["and", "or", "not"].includes(z.value);
            }
            function A(z) {
              return z.type === "value-word" && z.value === "in";
            }
            function B(z) {
              return z.type === "value-operator" && z.value === "*";
            }
            function I(z) {
              return z.type === "value-operator" && z.value === "/";
            }
            function P(z) {
              return z.type === "value-operator" && z.value === "+";
            }
            function R(z) {
              return z.type === "value-operator" && z.value === "-";
            }
            function f(z) {
              return z.type === "value-operator" && z.value === "%";
            }
            function x(z) {
              return B(z) || I(z) || P(z) || R(z) || f(z);
            }
            function m(z) {
              return z.type === "value-word" && ["==", "!="].includes(z.value);
            }
            function E(z) {
              return z.type === "value-word" && ["<", ">", "<=", ">="].includes(z.value);
            }
            function o(z) {
              return z.type === "css-atrule" && ["if", "else", "for", "each", "while"].includes(z.name);
            }
            function d(z) {
              var H;
              return ((H = z.raws) === null || H === void 0 ? void 0 : H.params) && /^\(\s*\)$/.test(z.raws.params);
            }
            function C(z) {
              return z.name.startsWith("prettier-placeholder");
            }
            function _(z) {
              return z.prop.startsWith("@prettier-placeholder");
            }
            function b(z, H) {
              return z.value === "$$" && z.type === "value-func" && (H == null ? void 0 : H.type) === "value-word" && !H.raws.before;
            }
            function N(z) {
              var H, Z;
              return ((H = z.value) === null || H === void 0 ? void 0 : H.type) === "value-root" && ((Z = z.value.group) === null || Z === void 0 ? void 0 : Z.type) === "value-value" && z.prop.toLowerCase() === "composes";
            }
            function k(z) {
              var H, Z, ne;
              return ((H = z.value) === null || H === void 0 || (Z = H.group) === null || Z === void 0 || (ne = Z.group) === null || ne === void 0 ? void 0 : ne.type) === "value-paren_group" && z.value.group.group.open !== null && z.value.group.group.close !== null;
            }
            function $(z) {
              var H;
              return ((H = z.raws) === null || H === void 0 ? void 0 : H.before) === "";
            }
            function M(z) {
              var H, Z;
              return z.type === "value-comma_group" && ((H = z.groups) === null || H === void 0 || (Z = H[1]) === null || Z === void 0 ? void 0 : Z.type) === "value-colon";
            }
            function q(z) {
              var H;
              return z.type === "value-paren_group" && ((H = z.groups) === null || H === void 0 ? void 0 : H[0]) && M(z.groups[0]);
            }
            function J(z) {
              var H;
              let Z = z.getValue();
              if (Z.groups.length === 0)
                return false;
              let ne = z.getParentNode(1);
              if (!q(Z) && !(ne && q(ne)))
                return false;
              let fe = a(z, "css-decl");
              return !!(fe != null && (H = fe.prop) !== null && H !== void 0 && H.startsWith("$") || q(ne) || ne.type === "value-func");
            }
            function L(z) {
              return z.type === "value-comment" && z.inline;
            }
            function Y(z) {
              return z.type === "value-word" && z.value === "#";
            }
            function V(z) {
              return z.type === "value-word" && z.value === "{";
            }
            function O(z) {
              return z.type === "value-word" && z.value === "}";
            }
            function K(z) {
              return ["value-word", "value-atword"].includes(z.type);
            }
            function se(z) {
              return (z == null ? void 0 : z.type) === "value-colon";
            }
            function Q(z, H) {
              if (!M(H))
                return false;
              let { groups: Z } = H, ne = Z.indexOf(z);
              return ne === -1 ? false : se(Z[ne + 1]);
            }
            function le(z) {
              return z.value && ["not", "and", "or"].includes(z.value.toLowerCase());
            }
            function W(z) {
              return z.type !== "value-func" ? false : t3.has(z.value.toLowerCase());
            }
            function X(z) {
              return /\/\//.test(z.split(/[\n\r]/).pop());
            }
            function oe(z) {
              return (z == null ? void 0 : z.type) === "value-atword" && z.value.startsWith("prettier-placeholder-");
            }
            function ae(z, H) {
              var Z, ne;
              if (((Z = z.open) === null || Z === void 0 ? void 0 : Z.value) !== "(" || ((ne = z.close) === null || ne === void 0 ? void 0 : ne.value) !== ")" || z.groups.some((fe) => fe.type !== "value-comma_group"))
                return false;
              if (H.type === "value-comma_group") {
                let fe = H.groups.indexOf(z) - 1, ge = H.groups[fe];
                if ((ge == null ? void 0 : ge.type) === "value-word" && ge.value === "with")
                  return true;
              }
              return false;
            }
            function Ae(z) {
              var H, Z;
              return z.type === "value-paren_group" && ((H = z.open) === null || H === void 0 ? void 0 : H.value) === "(" && ((Z = z.close) === null || Z === void 0 ? void 0 : Z.value) === ")";
            }
            n.exports = { getAncestorCounter: s, getAncestorNode: a, getPropOfDeclNode: r, maybeToLowerCase: c, insideValueFunctionNode: y, insideICSSRuleNode: h, insideAtRuleNode: g, insideURLFunctionInImportAtRuleNode: p, isKeyframeAtRuleKeywords: l, isWideKeywords: i, isLastNode: v, isSCSSControlDirectiveNode: o, isDetachedRulesetDeclarationNode: w, isRelationalOperatorNode: E, isEqualityOperatorNode: m, isMultiplicationNode: B, isDivisionNode: I, isAdditionNode: P, isSubtractionNode: R, isModuloNode: f, isMathOperatorNode: x, isEachKeywordNode: A, isForKeywordNode: T, isURLFunctionNode: D, isIfElseKeywordNode: F, hasComposesNode: N, hasParensAroundNode: k, hasEmptyRawBefore: $, isDetachedRulesetCallNode: d, isTemplatePlaceholderNode: C, isTemplatePropNode: _, isPostcssSimpleVarNode: b, isKeyValuePairNode: M, isKeyValuePairInParenGroupNode: q, isKeyInValuePairNode: Q, isSCSSMapItemNode: J, isInlineValueCommentNode: L, isHashNode: Y, isLeftCurlyBraceNode: V, isRightCurlyBraceNode: O, isWordNode: K, isColonNode: se, isMediaAndSupportsKeywords: le, isColorAdjusterFuncNode: W, lastLineHasInlineComment: X, isAtWordPlaceholderNode: oe, isConfigurationNode: ae, isParenGroupNode: Ae };
          } }), id = ee({ "src/utils/line-column-to-index.js"(e, n) {
            "use strict";
            re(), n.exports = function(t3, s) {
              let a = 0;
              for (let r = 0; r < t3.line - 1; ++r)
                a = s.indexOf(`
`, a) + 1;
              return a + t3.column;
            };
          } }), ad = ee({ "src/language-css/loc.js"(e, n) {
            "use strict";
            re();
            var { skipEverythingButNewLine: t3 } = _r(), s = lt2(), a = id();
            function r(p, D) {
              return typeof p.sourceIndex == "number" ? p.sourceIndex : p.source ? a(p.source.start, D) - 1 : null;
            }
            function u(p, D) {
              if (p.type === "css-comment" && p.inline)
                return t3(D, p.source.startOffset);
              let v = p.nodes && s(p.nodes);
              return v && p.source && !p.source.end && (p = v), p.source && p.source.end ? a(p.source.end, D) : null;
            }
            function i(p, D) {
              p.source && (p.source.startOffset = r(p, D), p.source.endOffset = u(p, D));
              for (let v in p) {
                let w = p[v];
                v === "source" || !w || typeof w != "object" || (w.type === "value-root" || w.type === "value-unknown" ? l(w, c(p), w.text || w.value) : i(w, D));
              }
            }
            function l(p, D, v) {
              p.source && (p.source.startOffset = r(p, v) + D, p.source.endOffset = u(p, v) + D);
              for (let w in p) {
                let T = p[w];
                w === "source" || !T || typeof T != "object" || l(T, D, v);
              }
            }
            function c(p) {
              let D = p.source.startOffset;
              return typeof p.prop == "string" && (D += p.prop.length), p.type === "css-atrule" && typeof p.name == "string" && (D += 1 + p.name.length + p.raws.afterName.match(/^\s*:?\s*/)[0].length), p.type !== "css-atrule" && p.raws && typeof p.raws.between == "string" && (D += p.raws.between.length), D;
            }
            function y(p) {
              let D = "initial", v = "initial", w, T = false, F = [];
              for (let A = 0; A < p.length; A++) {
                let B = p[A];
                switch (D) {
                  case "initial":
                    if (B === "'") {
                      D = "single-quotes";
                      continue;
                    }
                    if (B === '"') {
                      D = "double-quotes";
                      continue;
                    }
                    if ((B === "u" || B === "U") && p.slice(A, A + 4).toLowerCase() === "url(") {
                      D = "url", A += 3;
                      continue;
                    }
                    if (B === "*" && p[A - 1] === "/") {
                      D = "comment-block";
                      continue;
                    }
                    if (B === "/" && p[A - 1] === "/") {
                      D = "comment-inline", w = A - 1;
                      continue;
                    }
                    continue;
                  case "single-quotes":
                    if (B === "'" && p[A - 1] !== "\\" && (D = v, v = "initial"), B === `
` || B === "\r")
                      return p;
                    continue;
                  case "double-quotes":
                    if (B === '"' && p[A - 1] !== "\\" && (D = v, v = "initial"), B === `
` || B === "\r")
                      return p;
                    continue;
                  case "url":
                    if (B === ")" && (D = "initial"), B === `
` || B === "\r")
                      return p;
                    if (B === "'") {
                      D = "single-quotes", v = "url";
                      continue;
                    }
                    if (B === '"') {
                      D = "double-quotes", v = "url";
                      continue;
                    }
                    continue;
                  case "comment-block":
                    B === "/" && p[A - 1] === "*" && (D = "initial");
                    continue;
                  case "comment-inline":
                    (B === '"' || B === "'" || B === "*") && (T = true), (B === `
` || B === "\r") && (T && F.push([w, A]), D = "initial", T = false);
                    continue;
                }
              }
              for (let [A, B] of F)
                p = p.slice(0, A) + p.slice(A, B).replace(/["'*]/g, " ") + p.slice(B);
              return p;
            }
            function h(p) {
              return p.source.startOffset;
            }
            function g(p) {
              return p.source.endOffset;
            }
            n.exports = { locStart: h, locEnd: g, calculateLoc: i, replaceQuotesInInlineComments: y };
          } }), od = ee({ "src/language-css/utils/is-less-parser.js"(e, n) {
            "use strict";
            re();
            function t3(s) {
              return s.parser === "css" || s.parser === "less";
            }
            n.exports = t3;
          } }), ld = ee({ "src/language-css/utils/is-scss.js"(e, n) {
            "use strict";
            re();
            function t3(s, a) {
              return s === "less" || s === "scss" ? s === "scss" : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(a);
            }
            n.exports = t3;
          } }), cd = ee({ "src/language-css/utils/css-units.evaluate.js"(e, n) {
            n.exports = { em: "em", rem: "rem", ex: "ex", rex: "rex", cap: "cap", rcap: "rcap", ch: "ch", rch: "rch", ic: "ic", ric: "ric", lh: "lh", rlh: "rlh", vw: "vw", svw: "svw", lvw: "lvw", dvw: "dvw", vh: "vh", svh: "svh", lvh: "lvh", dvh: "dvh", vi: "vi", svi: "svi", lvi: "lvi", dvi: "dvi", vb: "vb", svb: "svb", lvb: "lvb", dvb: "dvb", vmin: "vmin", svmin: "svmin", lvmin: "lvmin", dvmin: "dvmin", vmax: "vmax", svmax: "svmax", lvmax: "lvmax", dvmax: "dvmax", cm: "cm", mm: "mm", q: "Q", in: "in", pt: "pt", pc: "pc", px: "px", deg: "deg", grad: "grad", rad: "rad", turn: "turn", s: "s", ms: "ms", hz: "Hz", khz: "kHz", dpi: "dpi", dpcm: "dpcm", dppx: "dppx", x: "x" };
          } }), pd = ee({ "src/language-css/utils/print-unit.js"(e, n) {
            "use strict";
            re();
            var t3 = cd();
            function s(a) {
              let r = a.toLowerCase();
              return Object.prototype.hasOwnProperty.call(t3, r) ? t3[r] : a;
            }
            n.exports = s;
          } }), fd = ee({ "src/language-css/printer-postcss.js"(e, n) {
            "use strict";
            re();
            var t3 = lt2(), { printNumber: s, printString: a, hasNewline: r, isFrontMatterNode: u, isNextLineEmpty: i, isNonEmptyArray: l } = Ge(), { builders: { join: c, line: y, hardline: h, softline: g, group: p, fill: D, indent: v, dedent: w, ifBreak: T, breakParent: F }, utils: { removeLines: A, getDocParts: B } } = qe(), I = rd(), P = nd(), { insertPragma: R } = ud(), { getAncestorNode: f, getPropOfDeclNode: x, maybeToLowerCase: m, insideValueFunctionNode: E, insideICSSRuleNode: o, insideAtRuleNode: d, insideURLFunctionInImportAtRuleNode: C, isKeyframeAtRuleKeywords: _, isWideKeywords: b, isLastNode: N, isSCSSControlDirectiveNode: k, isDetachedRulesetDeclarationNode: $, isRelationalOperatorNode: M, isEqualityOperatorNode: q, isMultiplicationNode: J, isDivisionNode: L, isAdditionNode: Y, isSubtractionNode: V, isMathOperatorNode: O, isEachKeywordNode: K, isForKeywordNode: se, isURLFunctionNode: Q, isIfElseKeywordNode: le, hasComposesNode: W, hasParensAroundNode: X, hasEmptyRawBefore: oe, isKeyValuePairNode: ae, isKeyInValuePairNode: Ae, isDetachedRulesetCallNode: z, isTemplatePlaceholderNode: H, isTemplatePropNode: Z, isPostcssSimpleVarNode: ne, isSCSSMapItemNode: fe, isInlineValueCommentNode: ge, isHashNode: Ce, isLeftCurlyBraceNode: _e, isRightCurlyBraceNode: Oe, isWordNode: pe, isColonNode: ie, isMediaAndSupportsKeywords: ve, isColorAdjusterFuncNode: ce, lastLineHasInlineComment: U, isAtWordPlaceholderNode: de, isConfigurationNode: De, isParenGroupNode: he } = sd(), { locStart: Be, locEnd: Se } = ad(), ye = od(), S = ld(), G = pd();
            function te(be) {
              return be.trailingComma === "es5" || be.trailingComma === "all";
            }
            function Ee(be, ke, Me) {
              let ue = be.getValue();
              if (!ue)
                return "";
              if (typeof ue == "string")
                return ue;
              switch (ue.type) {
                case "front-matter":
                  return [ue.raw, h];
                case "css-root": {
                  let He = Re(be, ke, Me), Ue = ue.raws.after.trim();
                  return [He, Ue ? ` ${Ue}` : "", B(He).length > 0 ? h : ""];
                }
                case "css-comment": {
                  let He = ue.inline || ue.raws.inline, Ue = ke.originalText.slice(Be(ue), Se(ue));
                  return He ? Ue.trimEnd() : Ue;
                }
                case "css-rule":
                  return [Me("selector"), ue.important ? " !important" : "", ue.nodes ? [ue.selector && ue.selector.type === "selector-unknown" && U(ue.selector.value) ? y : " ", "{", ue.nodes.length > 0 ? v([h, Re(be, ke, Me)]) : "", h, "}", $(ue) ? ";" : ""] : ";"];
                case "css-decl": {
                  let He = be.getParentNode(), { between: Ue } = ue.raws, Xe = Ue.trim(), at2 = Xe === ":", nt = W(ue) ? A(Me("value")) : Me("value");
                  return !at2 && U(Xe) && (nt = v([h, w(nt)])), [ue.raws.before.replace(/[\s;]/g, ""), o(be) ? ue.prop : m(ue.prop), Xe.startsWith("//") ? " " : "", Xe, ue.extend ? "" : " ", ye(ke) && ue.extend && ue.selector ? ["extend(", Me("selector"), ")"] : "", nt, ue.raws.important ? ue.raws.important.replace(/\s*!\s*important/i, " !important") : ue.important ? " !important" : "", ue.raws.scssDefault ? ue.raws.scssDefault.replace(/\s*!default/i, " !default") : ue.scssDefault ? " !default" : "", ue.raws.scssGlobal ? ue.raws.scssGlobal.replace(/\s*!global/i, " !global") : ue.scssGlobal ? " !global" : "", ue.nodes ? [" {", v([g, Re(be, ke, Me)]), g, "}"] : Z(ue) && !He.raws.semicolon && ke.originalText[Se(ue) - 1] !== ";" ? "" : ke.__isHTMLStyleAttribute && N(be, ue) ? T(";") : ";"];
                }
                case "css-atrule": {
                  let He = be.getParentNode(), Ue = H(ue) && !He.raws.semicolon && ke.originalText[Se(ue) - 1] !== ";";
                  if (ye(ke)) {
                    if (ue.mixin)
                      return [Me("selector"), ue.important ? " !important" : "", Ue ? "" : ";"];
                    if (ue.function)
                      return [ue.name, Me("params"), Ue ? "" : ";"];
                    if (ue.variable)
                      return ["@", ue.name, ": ", ue.value ? Me("value") : "", ue.raws.between.trim() ? ue.raws.between.trim() + " " : "", ue.nodes ? ["{", v([ue.nodes.length > 0 ? g : "", Re(be, ke, Me)]), g, "}"] : "", Ue ? "" : ";"];
                  }
                  return ["@", z(ue) || ue.name.endsWith(":") ? ue.name : m(ue.name), ue.params ? [z(ue) ? "" : H(ue) ? ue.raws.afterName === "" ? "" : ue.name.endsWith(":") ? " " : /^\s*\n\s*\n/.test(ue.raws.afterName) ? [h, h] : /^\s*\n/.test(ue.raws.afterName) ? h : " " : " ", Me("params")] : "", ue.selector ? v([" ", Me("selector")]) : "", ue.value ? p([" ", Me("value"), k(ue) ? X(ue) ? " " : y : ""]) : ue.name === "else" ? " " : "", ue.nodes ? [k(ue) ? "" : ue.selector && !ue.selector.nodes && typeof ue.selector.value == "string" && U(ue.selector.value) || !ue.selector && typeof ue.params == "string" && U(ue.params) ? y : " ", "{", v([ue.nodes.length > 0 ? g : "", Re(be, ke, Me)]), g, "}"] : Ue ? "" : ";"];
                }
                case "media-query-list": {
                  let He = [];
                  return be.each((Ue) => {
                    let Xe = Ue.getValue();
                    Xe.type === "media-query" && Xe.value === "" || He.push(Me());
                  }, "nodes"), p(v(c(y, He)));
                }
                case "media-query":
                  return [c(" ", be.map(Me, "nodes")), N(be, ue) ? "" : ","];
                case "media-type":
                  return Le(Je(ue.value, ke));
                case "media-feature-expression":
                  return ue.nodes ? ["(", ...be.map(Me, "nodes"), ")"] : ue.value;
                case "media-feature":
                  return m(Je(ue.value.replace(/ +/g, " "), ke));
                case "media-colon":
                  return [ue.value, " "];
                case "media-value":
                  return Le(Je(ue.value, ke));
                case "media-keyword":
                  return Je(ue.value, ke);
                case "media-url":
                  return Je(ue.value.replace(/^url\(\s+/gi, "url(").replace(/\s+\)$/g, ")"), ke);
                case "media-unknown":
                  return ue.value;
                case "selector-root":
                  return p([d(be, "custom-selector") ? [f(be, "css-atrule").customSelector, y] : "", c([",", d(be, ["extend", "custom-selector", "nest"]) ? y : h], be.map(Me, "nodes"))]);
                case "selector-selector":
                  return p(v(be.map(Me, "nodes")));
                case "selector-comment":
                  return ue.value;
                case "selector-string":
                  return Je(ue.value, ke);
                case "selector-tag": {
                  let He = be.getParentNode(), Ue = He && He.nodes.indexOf(ue), Xe = Ue && He.nodes[Ue - 1];
                  return [ue.namespace ? [ue.namespace === true ? "" : ue.namespace.trim(), "|"] : "", Xe.type === "selector-nesting" ? ue.value : Le(_(be, ue.value) ? ue.value.toLowerCase() : ue.value)];
                }
                case "selector-id":
                  return ["#", ue.value];
                case "selector-class":
                  return [".", Le(Je(ue.value, ke))];
                case "selector-attribute": {
                  var st;
                  return ["[", ue.namespace ? [ue.namespace === true ? "" : ue.namespace.trim(), "|"] : "", ue.attribute.trim(), (st = ue.operator) !== null && st !== void 0 ? st : "", ue.value ? we(Je(ue.value.trim(), ke), ke) : "", ue.insensitive ? " i" : "", "]"];
                }
                case "selector-combinator": {
                  if (ue.value === "+" || ue.value === ">" || ue.value === "~" || ue.value === ">>>") {
                    let Xe = be.getParentNode();
                    return [Xe.type === "selector-selector" && Xe.nodes[0] === ue ? "" : y, ue.value, N(be, ue) ? "" : " "];
                  }
                  let He = ue.value.trim().startsWith("(") ? y : "", Ue = Le(Je(ue.value.trim(), ke)) || y;
                  return [He, Ue];
                }
                case "selector-universal":
                  return [ue.namespace ? [ue.namespace === true ? "" : ue.namespace.trim(), "|"] : "", ue.value];
                case "selector-pseudo":
                  return [m(ue.value), l(ue.nodes) ? p(["(", v([g, c([",", y], be.map(Me, "nodes"))]), g, ")"]) : ""];
                case "selector-nesting":
                  return ue.value;
                case "selector-unknown": {
                  let He = f(be, "css-rule");
                  if (He && He.isSCSSNesterProperty)
                    return Le(Je(m(ue.value), ke));
                  let Ue = be.getParentNode();
                  if (Ue.raws && Ue.raws.selector) {
                    let at2 = Be(Ue), nt = at2 + Ue.raws.selector.length;
                    return ke.originalText.slice(at2, nt).trim();
                  }
                  let Xe = be.getParentNode(1);
                  if (Ue.type === "value-paren_group" && Xe && Xe.type === "value-func" && Xe.value === "selector") {
                    let at2 = Se(Ue.open) + 1, nt = Be(Ue.close), j = ke.originalText.slice(at2, nt).trim();
                    return U(j) ? [F, j] : j;
                  }
                  return ue.value;
                }
                case "value-value":
                case "value-root":
                  return Me("group");
                case "value-comment":
                  return ke.originalText.slice(Be(ue), Se(ue));
                case "value-comma_group": {
                  let He = be.getParentNode(), Ue = be.getParentNode(1), Xe = x(be), at2 = Xe && He.type === "value-value" && (Xe === "grid" || Xe.startsWith("grid-template")), nt = f(be, "css-atrule"), j = nt && k(nt), me = ue.groups.some((ot) => ge(ot)), Ie = be.map(Me, "groups"), je = [], Ye = E(be, "url"), ut = false, ze = false;
                  for (let ot = 0; ot < ue.groups.length; ++ot) {
                    var rt;
                    je.push(Ie[ot]);
                    let tt = ue.groups[ot - 1], $e = ue.groups[ot], We = ue.groups[ot + 1], nr = ue.groups[ot + 2];
                    if (Ye) {
                      (We && Y(We) || Y($e)) && je.push(" ");
                      continue;
                    }
                    if (d(be, "forward") && $e.type === "value-word" && $e.value && tt !== void 0 && tt.type === "value-word" && tt.value === "as" && We.type === "value-operator" && We.value === "*" || !We || $e.type === "value-word" && $e.value.endsWith("-") && de(We))
                      continue;
                    let go = $e.type === "value-string" && $e.value.startsWith("#{"), yo = ut && We.type === "value-string" && We.value.endsWith("}");
                    if (go || yo) {
                      ut = !ut;
                      continue;
                    }
                    if (ut || ie($e) || ie(We) || $e.type === "value-atword" && $e.value === "" || $e.value === "~" || $e.value && $e.value.includes("\\") && We && We.type !== "value-comment" || tt && tt.value && tt.value.indexOf("\\") === tt.value.length - 1 && $e.type === "value-operator" && $e.value === "/" || $e.value === "\\" || ne($e, We) || Ce($e) || _e($e) || Oe(We) || _e(We) && oe(We) || Oe($e) && oe(We) || $e.value === "--" && Ce(We))
                      continue;
                    let Zn = O($e), eu = O(We);
                    if ((Zn && Ce(We) || eu && Oe($e)) && oe(We) || !tt && L($e) || E(be, "calc") && (Y($e) || Y(We) || V($e) || V(We)) && oe(We))
                      continue;
                    let ho = (Y($e) || V($e)) && ot === 0 && (We.type === "value-number" || We.isHex) && Ue && ce(Ue) && !oe(We), tu = nr && nr.type === "value-func" || nr && pe(nr) || $e.type === "value-func" || pe($e), ru = We.type === "value-func" || pe(We) || tt && tt.type === "value-func" || tt && pe(tt);
                    if (!(!(J(We) || J($e)) && !E(be, "calc") && !ho && (L(We) && !tu || L($e) && !ru || Y(We) && !tu || Y($e) && !ru || V(We) || V($e)) && (oe(We) || Zn && (!tt || tt && O(tt))))) {
                      if (ge($e)) {
                        if (He.type === "value-paren_group") {
                          je.push(w(h));
                          continue;
                        }
                        je.push(h);
                        continue;
                      }
                      if (j && (q(We) || M(We) || le(We) || K($e) || se($e))) {
                        je.push(" ");
                        continue;
                      }
                      if (nt && nt.name.toLowerCase() === "namespace") {
                        je.push(" ");
                        continue;
                      }
                      if (at2) {
                        $e.source && We.source && $e.source.start.line !== We.source.start.line ? (je.push(h), ze = true) : je.push(" ");
                        continue;
                      }
                      if (eu) {
                        je.push(" ");
                        continue;
                      }
                      if (!(We && We.value === "...") && !(de($e) && de(We) && Se($e) === Be(We))) {
                        if (de($e) && he(We) && Se($e) === Be(We.open)) {
                          je.push(g);
                          continue;
                        }
                        if ($e.value === "with" && he(We)) {
                          je.push(" ");
                          continue;
                        }
                        (rt = $e.value) !== null && rt !== void 0 && rt.endsWith("#") && We.value === "{" && he(We.group) || je.push(y);
                      }
                    }
                  }
                  return me && je.push(F), ze && je.unshift(h), j ? p(v(je)) : C(be) ? p(D(je)) : p(v(D(je)));
                }
                case "value-paren_group": {
                  let He = be.getParentNode();
                  if (He && Q(He) && (ue.groups.length === 1 || ue.groups.length > 0 && ue.groups[0].type === "value-comma_group" && ue.groups[0].groups.length > 0 && ue.groups[0].groups[0].type === "value-word" && ue.groups[0].groups[0].value.startsWith("data:")))
                    return [ue.open ? Me("open") : "", c(",", be.map(Me, "groups")), ue.close ? Me("close") : ""];
                  if (!ue.open) {
                    let Ye = be.map(Me, "groups"), ut = [];
                    for (let ze = 0; ze < Ye.length; ze++)
                      ze !== 0 && ut.push([",", y]), ut.push(Ye[ze]);
                    return p(v(D(ut)));
                  }
                  let Ue = fe(be), Xe = t3(ue.groups), at2 = Xe && Xe.type === "value-comment", nt = Ae(ue, He), j = De(ue, He), me = j || Ue && !nt, Ie = j || nt, je = p([ue.open ? Me("open") : "", v([g, c([y], be.map((Ye, ut) => {
                    let ze = Ye.getValue(), ot = ut === ue.groups.length - 1, tt = [Me(), ot ? "" : ","];
                    if (ae(ze) && ze.type === "value-comma_group" && ze.groups && ze.groups[0].type !== "value-paren_group" && ze.groups[2] && ze.groups[2].type === "value-paren_group") {
                      let $e = B(tt[0].contents.contents);
                      return $e[1] = p($e[1]), p(w(tt));
                    }
                    if (!ot && ze.type === "value-comma_group" && l(ze.groups)) {
                      let $e = t3(ze.groups);
                      $e.source && i(ke.originalText, $e, Se) && tt.push(h);
                    }
                    return tt;
                  }, "groups"))]), T(!at2 && S(ke.parser, ke.originalText) && Ue && te(ke) ? "," : ""), g, ue.close ? Me("close") : ""], { shouldBreak: me });
                  return Ie ? w(je) : je;
                }
                case "value-func":
                  return [ue.value, d(be, "supports") && ve(ue) ? " " : "", Me("group")];
                case "value-paren":
                  return ue.value;
                case "value-number":
                  return [Ve(ue.value), G(ue.unit)];
                case "value-operator":
                  return ue.value;
                case "value-word":
                  return ue.isColor && ue.isHex || b(ue.value) ? ue.value.toLowerCase() : ue.value;
                case "value-colon": {
                  let He = be.getParentNode(), Ue = He && He.groups.indexOf(ue), Xe = Ue && He.groups[Ue - 1];
                  return [ue.value, Xe && typeof Xe.value == "string" && t3(Xe.value) === "\\" || E(be, "url") ? "" : y];
                }
                case "value-comma":
                  return [ue.value, " "];
                case "value-string":
                  return a(ue.raws.quote + ue.value + ue.raws.quote, ke);
                case "value-atword":
                  return ["@", ue.value];
                case "value-unicode-range":
                  return ue.value;
                case "value-unknown":
                  return ue.value;
                default:
                  throw new Error(`Unknown postcss type ${JSON.stringify(ue.type)}`);
              }
            }
            function Re(be, ke, Me) {
              let ue = [];
              return be.each((st, rt, He) => {
                let Ue = He[rt - 1];
                if (Ue && Ue.type === "css-comment" && Ue.text.trim() === "prettier-ignore") {
                  let Xe = st.getValue();
                  ue.push(ke.originalText.slice(Be(Xe), Se(Xe)));
                } else
                  ue.push(Me());
                rt !== He.length - 1 && (He[rt + 1].type === "css-comment" && !r(ke.originalText, Be(He[rt + 1]), { backwards: true }) && !u(He[rt]) || He[rt + 1].type === "css-atrule" && He[rt + 1].name === "else" && He[rt].type !== "css-comment" ? ue.push(" ") : (ue.push(ke.__isHTMLStyleAttribute ? y : h), i(ke.originalText, st.getValue(), Se) && !u(He[rt]) && ue.push(h)));
              }, "nodes"), ue;
            }
            var Te = /(["'])(?:(?!\1)[^\\]|\\.)*\1/gs, Pe = /(?:\d*\.\d+|\d+\.?)(?:[Ee][+-]?\d+)?/g, Fe = /[A-Za-z]+/g, Ze = /[$@]?[A-Z_a-z\u0080-\uFFFF][\w\u0080-\uFFFF-]*/g, xe = new RegExp(Te.source + `|(${Ze.source})?(${Pe.source})(${Fe.source})?`, "g");
            function Je(be, ke) {
              return be.replace(Te, (Me) => a(Me, ke));
            }
            function we(be, ke) {
              let Me = ke.singleQuote ? "'" : '"';
              return be.includes('"') || be.includes("'") ? be : Me + be + Me;
            }
            function Le(be) {
              return be.replace(xe, (ke, Me, ue, st, rt) => !ue && st ? Ve(st) + m(rt || "") : ke);
            }
            function Ve(be) {
              return s(be).replace(/\.0(?=$|e)/, "");
            }
            n.exports = { print: Ee, embed: P, insertPragma: R, massageAstNode: I };
          } }), Dd = ee({ "src/language-css/options.js"(e, n) {
            "use strict";
            re();
            var t3 = qt();
            n.exports = { singleQuote: t3.singleQuote };
          } }), md = ee({ "src/language-css/parsers.js"() {
            re();
          } }), dd = ee({ "node_modules/linguist-languages/data/CSS.json"(e, n) {
            n.exports = { name: "CSS", type: "markup", tmScope: "source.css", aceMode: "css", codemirrorMode: "css", codemirrorMimeType: "text/css", color: "#563d7c", extensions: [".css"], languageId: 50 };
          } }), gd = ee({ "node_modules/linguist-languages/data/PostCSS.json"(e, n) {
            n.exports = { name: "PostCSS", type: "markup", color: "#dc3a0c", tmScope: "source.postcss", group: "CSS", extensions: [".pcss", ".postcss"], aceMode: "text", languageId: 262764437 };
          } }), yd = ee({ "node_modules/linguist-languages/data/Less.json"(e, n) {
            n.exports = { name: "Less", type: "markup", color: "#1d365d", aliases: ["less-css"], extensions: [".less"], tmScope: "source.css.less", aceMode: "less", codemirrorMode: "css", codemirrorMimeType: "text/css", languageId: 198 };
          } }), hd = ee({ "node_modules/linguist-languages/data/SCSS.json"(e, n) {
            n.exports = { name: "SCSS", type: "markup", color: "#c6538c", tmScope: "source.css.scss", aceMode: "scss", codemirrorMode: "css", codemirrorMimeType: "text/x-scss", extensions: [".scss"], languageId: 329 };
          } }), vd = ee({ "src/language-css/index.js"(e, n) {
            "use strict";
            re();
            var t3 = wt(), s = fd(), a = Dd(), r = md(), u = [t3(dd(), (l) => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["css"], extensions: [...l.extensions, ".wxss"] })), t3(gd(), () => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["postcss"] })), t3(yd(), () => ({ since: "1.4.0", parsers: ["less"], vscodeLanguageIds: ["less"] })), t3(hd(), () => ({ since: "1.4.0", parsers: ["scss"], vscodeLanguageIds: ["scss"] }))], i = { postcss: s };
            n.exports = { languages: u, options: a, printers: i, parsers: r };
          } }), Cd = ee({ "src/language-handlebars/loc.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return a.loc.start.offset;
            }
            function s(a) {
              return a.loc.end.offset;
            }
            n.exports = { locStart: t3, locEnd: s };
          } }), Ed = ee({ "src/language-handlebars/clean.js"(e, n) {
            "use strict";
            re();
            function t3(s, a) {
              if (s.type === "TextNode") {
                let r = s.chars.trim();
                if (!r)
                  return null;
                a.chars = r.replace(/[\t\n\f\r ]+/g, " ");
              }
              s.type === "AttrNode" && s.name.toLowerCase() === "class" && delete a.value;
            }
            t3.ignoredProperties = /* @__PURE__ */ new Set(["loc", "selfClosing"]), n.exports = t3;
          } }), Fd = ee({ "vendors/html-void-elements.json"(e, n) {
            n.exports = { htmlVoidElements: ["area", "base", "basefont", "bgsound", "br", "col", "command", "embed", "frame", "hr", "image", "img", "input", "isindex", "keygen", "link", "menuitem", "meta", "nextid", "param", "source", "track", "wbr"] };
          } }), Ad = ee({ "src/language-handlebars/utils.js"(e, n) {
            "use strict";
            re();
            var { htmlVoidElements: t3 } = Fd(), s = lt2();
            function a(A) {
              let B = A.getValue(), I = A.getParentNode(0);
              return !!(h(A, ["ElementNode"]) && s(I.children) === B || h(A, ["Block"]) && s(I.body) === B);
            }
            function r(A) {
              return A.toUpperCase() === A;
            }
            function u(A) {
              return y(A, ["ElementNode"]) && typeof A.tag == "string" && !A.tag.startsWith(":") && (r(A.tag[0]) || A.tag.includes("."));
            }
            var i = new Set(t3);
            function l(A) {
              return i.has(A.tag) || u(A) && A.children.every((B) => c(B));
            }
            function c(A) {
              return y(A, ["TextNode"]) && !/\S/.test(A.chars);
            }
            function y(A, B) {
              return A && B.includes(A.type);
            }
            function h(A, B) {
              let I = A.getParentNode(0);
              return y(I, B);
            }
            function g(A, B) {
              let I = v(A);
              return y(I, B);
            }
            function p(A, B) {
              let I = w(A);
              return y(I, B);
            }
            function D(A, B) {
              var I, P, R, f;
              let x = A.getValue(), m = (I = A.getParentNode(0)) !== null && I !== void 0 ? I : {}, E = (P = (R = (f = m.children) !== null && f !== void 0 ? f : m.body) !== null && R !== void 0 ? R : m.parts) !== null && P !== void 0 ? P : [], o = E.indexOf(x);
              return o !== -1 && E[o + B];
            }
            function v(A) {
              let B = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
              return D(A, -B);
            }
            function w(A) {
              return D(A, 1);
            }
            function T(A) {
              return y(A, ["MustacheCommentStatement"]) && typeof A.value == "string" && A.value.trim() === "prettier-ignore";
            }
            function F(A) {
              let B = A.getValue(), I = v(A, 2);
              return T(B) || T(I);
            }
            n.exports = { getNextNode: w, getPreviousNode: v, hasPrettierIgnore: F, isLastNodeOfSiblings: a, isNextNodeOfSomeType: p, isNodeOfSomeType: y, isParentOfSomeType: h, isPreviousNodeOfSomeType: g, isVoid: l, isWhitespaceNode: c };
          } }), Sd = ee({ "src/language-handlebars/printer-glimmer.js"(e, n) {
            "use strict";
            re();
            var { builders: { dedent: t3, fill: s, group: a, hardline: r, ifBreak: u, indent: i, join: l, line: c, softline: y }, utils: { getDocParts: h, replaceTextEndOfLine: g } } = qe(), { getPreferredQuote: p, isNonEmptyArray: D } = Ge(), { locStart: v, locEnd: w } = Cd(), T = Ed(), { getNextNode: F, getPreviousNode: A, hasPrettierIgnore: B, isLastNodeOfSiblings: I, isNextNodeOfSomeType: P, isNodeOfSomeType: R, isParentOfSomeType: f, isPreviousNodeOfSomeType: x, isVoid: m, isWhitespaceNode: E } = Ad(), o = 2;
            function d(U, de, De) {
              let he = U.getValue();
              if (!he)
                return "";
              if (B(U))
                return de.originalText.slice(v(he), w(he));
              let Be = de.singleQuote ? "'" : '"';
              switch (he.type) {
                case "Block":
                case "Program":
                case "Template":
                  return a(U.map(De, "body"));
                case "ElementNode": {
                  let Se = a(_(U, De)), ye = de.htmlWhitespaceSensitivity === "ignore" && P(U, ["ElementNode"]) ? y : "";
                  if (m(he))
                    return [Se, ye];
                  let S = ["</", he.tag, ">"];
                  return he.children.length === 0 ? [Se, i(S), ye] : de.htmlWhitespaceSensitivity === "ignore" ? [Se, i(b(U, de, De)), r, i(S), ye] : [Se, i(a(b(U, de, De))), i(S), ye];
                }
                case "BlockStatement": {
                  let Se = U.getParentNode(1);
                  return Se && Se.inverse && Se.inverse.body.length === 1 && Se.inverse.body[0] === he && Se.inverse.body[0].path.parts[0] === Se.path.parts[0] ? [se(U, De, Se.inverse.body[0].path.parts[0]), oe(U, De, de), ae(U, De, de)] : [O(U, De), a([oe(U, De, de), ae(U, De, de), Q(U, De, de)])];
                }
                case "ElementModifierStatement":
                  return a(["{{", pe(U, De), "}}"]);
                case "MustacheStatement":
                  return a([k(he), pe(U, De), $(he)]);
                case "SubExpression":
                  return a(["(", Oe(U, De), y, ")"]);
                case "AttrNode": {
                  let Se = he.value.type === "TextNode";
                  if (Se && he.value.chars === "" && v(he.value) === w(he.value))
                    return he.name;
                  let S = Se ? p(he.value.chars, Be).quote : he.value.type === "ConcatStatement" ? p(he.value.parts.filter((te) => te.type === "TextNode").map((te) => te.chars).join(""), Be).quote : "", G = De("value");
                  return [he.name, "=", S, he.name === "class" && S ? a(i(G)) : G, S];
                }
                case "ConcatStatement":
                  return U.map(De, "parts");
                case "Hash":
                  return l(c, U.map(De, "pairs"));
                case "HashPair":
                  return [he.key, "=", De("value")];
                case "TextNode": {
                  let Se = he.chars.replace(/{{/g, "\\{{"), ye = H(U);
                  if (ye) {
                    if (ye === "class") {
                      let xe = Se.trim().split(/\s+/).join(" "), Je = false, we = false;
                      return f(U, ["ConcatStatement"]) && (x(U, ["MustacheStatement"]) && /^\s/.test(Se) && (Je = true), P(U, ["MustacheStatement"]) && /\s$/.test(Se) && xe !== "" && (we = true)), [Je ? c : "", xe, we ? c : ""];
                    }
                    return g(Se);
                  }
                  let G = /^[\t\n\f\r ]*$/.test(Se), te = !A(U), Ee = !F(U);
                  if (de.htmlWhitespaceSensitivity !== "ignore") {
                    let xe = /^[\t\n\f\r ]*/, Je = /[\t\n\f\r ]*$/, we = Ee && f(U, ["Template"]), Le = te && f(U, ["Template"]);
                    if (G) {
                      if (Le || we)
                        return "";
                      let ue = [c], st = Z(Se);
                      return st && (ue = ge(st)), I(U) && (ue = ue.map((rt) => t3(rt))), ue;
                    }
                    let [Ve] = Se.match(xe), [be] = Se.match(Je), ke = [];
                    if (Ve) {
                      ke = [c];
                      let ue = Z(Ve);
                      ue && (ke = ge(ue)), Se = Se.replace(xe, "");
                    }
                    let Me = [];
                    if (be) {
                      if (!we) {
                        Me = [c];
                        let ue = Z(be);
                        ue && (Me = ge(ue)), I(U) && (Me = Me.map((st) => t3(st)));
                      }
                      Se = Se.replace(Je, "");
                    }
                    return [...ke, s(Ae(Se)), ...Me];
                  }
                  let Re = Z(Se), Te = ne(Se), Pe = fe(Se);
                  if ((te || Ee) && G && f(U, ["Block", "ElementNode", "Template"]))
                    return "";
                  G && Re ? (Te = Math.min(Re, o), Pe = 0) : (P(U, ["BlockStatement", "ElementNode"]) && (Pe = Math.max(Pe, 1)), x(U, ["BlockStatement", "ElementNode"]) && (Te = Math.max(Te, 1)));
                  let Fe = "", Ze = "";
                  return Pe === 0 && P(U, ["MustacheStatement"]) && (Ze = " "), Te === 0 && x(U, ["MustacheStatement"]) && (Fe = " "), te && (Te = 0, Fe = ""), Ee && (Pe = 0, Ze = ""), Se = Se.replace(/^[\t\n\f\r ]+/g, Fe).replace(/[\t\n\f\r ]+$/, Ze), [...ge(Te), s(Ae(Se)), ...ge(Pe)];
                }
                case "MustacheCommentStatement": {
                  let Se = v(he), ye = w(he), S = de.originalText.charAt(Se + 2) === "~", G = de.originalText.charAt(ye - 3) === "~", te = he.value.includes("}}") ? "--" : "";
                  return ["{{", S ? "~" : "", "!", te, he.value, te, G ? "~" : "", "}}"];
                }
                case "PathExpression":
                  return he.original;
                case "BooleanLiteral":
                  return String(he.value);
                case "CommentStatement":
                  return ["<!--", he.value, "-->"];
                case "StringLiteral": {
                  if (_e(U)) {
                    let Se = de.singleQuote ? '"' : "'";
                    return Ce(he.value, Se);
                  }
                  return Ce(he.value, Be);
                }
                case "NumberLiteral":
                  return String(he.value);
                case "UndefinedLiteral":
                  return "undefined";
                case "NullLiteral":
                  return "null";
                default:
                  throw new Error("unknown glimmer type: " + JSON.stringify(he.type));
              }
            }
            function C(U, de) {
              return v(U) - v(de);
            }
            function _(U, de) {
              let De = U.getValue(), he = ["attributes", "modifiers", "comments"].filter((Se) => D(De[Se])), Be = he.flatMap((Se) => De[Se]).sort(C);
              for (let Se of he)
                U.each((ye) => {
                  let S = Be.indexOf(ye.getValue());
                  Be.splice(S, 1, [c, de()]);
                }, Se);
              return D(De.blockParams) && Be.push(c, ce(De)), ["<", De.tag, i(Be), N(De)];
            }
            function b(U, de, De) {
              let Be = U.getValue().children.every((Se) => E(Se));
              return de.htmlWhitespaceSensitivity === "ignore" && Be ? "" : U.map((Se, ye) => {
                let S = De();
                return ye === 0 && de.htmlWhitespaceSensitivity === "ignore" ? [y, S] : S;
              }, "children");
            }
            function N(U) {
              return m(U) ? u([y, "/>"], [" />", y]) : u([y, ">"], ">");
            }
            function k(U) {
              let de = U.escaped === false ? "{{{" : "{{", De = U.strip && U.strip.open ? "~" : "";
              return [de, De];
            }
            function $(U) {
              let de = U.escaped === false ? "}}}" : "}}";
              return [U.strip && U.strip.close ? "~" : "", de];
            }
            function M(U) {
              let de = k(U), De = U.openStrip.open ? "~" : "";
              return [de, De, "#"];
            }
            function q(U) {
              let de = $(U);
              return [U.openStrip.close ? "~" : "", de];
            }
            function J(U) {
              let de = k(U), De = U.closeStrip.open ? "~" : "";
              return [de, De, "/"];
            }
            function L(U) {
              let de = $(U);
              return [U.closeStrip.close ? "~" : "", de];
            }
            function Y(U) {
              let de = k(U), De = U.inverseStrip.open ? "~" : "";
              return [de, De];
            }
            function V(U) {
              let de = $(U);
              return [U.inverseStrip.close ? "~" : "", de];
            }
            function O(U, de) {
              let De = U.getValue(), he = M(De), Be = q(De), Se = [ie(U, de)], ye = ve(U, de);
              if (ye && Se.push(c, ye), D(De.program.blockParams)) {
                let S = ce(De.program);
                Se.push(c, S);
              }
              return a([he, i(Se), y, Be]);
            }
            function K(U, de) {
              return [de.htmlWhitespaceSensitivity === "ignore" ? r : "", Y(U), "else", V(U)];
            }
            function se(U, de, De) {
              let he = U.getParentNode(1);
              return [Y(he), "else ", De, " ", ve(U, de), V(he)];
            }
            function Q(U, de, De) {
              let he = U.getValue();
              return De.htmlWhitespaceSensitivity === "ignore" ? [le(he) ? y : r, J(he), de("path"), L(he)] : [J(he), de("path"), L(he)];
            }
            function le(U) {
              return R(U, ["BlockStatement"]) && U.program.body.every((de) => E(de));
            }
            function W(U) {
              return X(U) && U.inverse.body.length === 1 && R(U.inverse.body[0], ["BlockStatement"]) && U.inverse.body[0].path.parts[0] === U.path.parts[0];
            }
            function X(U) {
              return R(U, ["BlockStatement"]) && U.inverse;
            }
            function oe(U, de, De) {
              let he = U.getValue();
              if (le(he))
                return "";
              let Be = de("program");
              return De.htmlWhitespaceSensitivity === "ignore" ? i([r, Be]) : i(Be);
            }
            function ae(U, de, De) {
              let he = U.getValue(), Be = de("inverse"), Se = De.htmlWhitespaceSensitivity === "ignore" ? [r, Be] : Be;
              return W(he) ? Se : X(he) ? [K(he, De), i(Se)] : "";
            }
            function Ae(U) {
              return h(l(c, z(U)));
            }
            function z(U) {
              return U.split(/[\t\n\f\r ]+/);
            }
            function H(U) {
              for (let de = 0; de < 2; de++) {
                let De = U.getParentNode(de);
                if (De && De.type === "AttrNode")
                  return De.name.toLowerCase();
              }
            }
            function Z(U) {
              return U = typeof U == "string" ? U : "", U.split(`
`).length - 1;
            }
            function ne(U) {
              U = typeof U == "string" ? U : "";
              let de = (U.match(/^([^\S\n\r]*[\n\r])+/g) || [])[0] || "";
              return Z(de);
            }
            function fe(U) {
              U = typeof U == "string" ? U : "";
              let de = (U.match(/([\n\r][^\S\n\r]*)+$/g) || [])[0] || "";
              return Z(de);
            }
            function ge() {
              let U = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
              return Array.from({ length: Math.min(U, o) }).fill(r);
            }
            function Ce(U, de) {
              let { quote: De, regex: he } = p(U, de);
              return [De, U.replace(he, `\\${De}`), De];
            }
            function _e(U) {
              let de = 0, De = U.getParentNode(de);
              for (; De && R(De, ["SubExpression"]); )
                de++, De = U.getParentNode(de);
              return !!(De && R(U.getParentNode(de + 1), ["ConcatStatement"]) && R(U.getParentNode(de + 2), ["AttrNode"]));
            }
            function Oe(U, de) {
              let De = ie(U, de), he = ve(U, de);
              return he ? i([De, c, a(he)]) : De;
            }
            function pe(U, de) {
              let De = ie(U, de), he = ve(U, de);
              return he ? [i([De, c, he]), y] : De;
            }
            function ie(U, de) {
              return de("path");
            }
            function ve(U, de) {
              let De = U.getValue(), he = [];
              if (De.params.length > 0) {
                let Be = U.map(de, "params");
                he.push(...Be);
              }
              if (De.hash && De.hash.pairs.length > 0) {
                let Be = de("hash");
                he.push(Be);
              }
              return he.length === 0 ? "" : l(c, he);
            }
            function ce(U) {
              return ["as |", U.blockParams.join(" "), "|"];
            }
            n.exports = { print: d, massageAstNode: T };
          } }), xd = ee({ "src/language-handlebars/parsers.js"() {
            re();
          } }), bd = ee({ "node_modules/linguist-languages/data/Handlebars.json"(e, n) {
            n.exports = { name: "Handlebars", type: "markup", color: "#f7931e", aliases: ["hbs", "htmlbars"], extensions: [".handlebars", ".hbs"], tmScope: "text.html.handlebars", aceMode: "handlebars", languageId: 155 };
          } }), Td = ee({ "src/language-handlebars/index.js"(e, n) {
            "use strict";
            re();
            var t3 = wt(), s = Sd(), a = xd(), r = [t3(bd(), () => ({ since: "2.3.0", parsers: ["glimmer"], vscodeLanguageIds: ["handlebars"] }))], u = { glimmer: s };
            n.exports = { languages: r, printers: u, parsers: a };
          } }), Bd = ee({ "src/language-graphql/pragma.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return /^\s*#[^\S\n]*@(?:format|prettier)\s*(?:\n|$)/.test(a);
            }
            function s(a) {
              return `# @format

` + a;
            }
            n.exports = { hasPragma: t3, insertPragma: s };
          } }), Nd = ee({ "src/language-graphql/loc.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return typeof a.start == "number" ? a.start : a.loc && a.loc.start;
            }
            function s(a) {
              return typeof a.end == "number" ? a.end : a.loc && a.loc.end;
            }
            n.exports = { locStart: t3, locEnd: s };
          } }), wd = ee({ "src/language-graphql/printer-graphql.js"(e, n) {
            "use strict";
            re();
            var { builders: { join: t3, hardline: s, line: a, softline: r, group: u, indent: i, ifBreak: l } } = qe(), { isNextLineEmpty: c, isNonEmptyArray: y } = Ge(), { insertPragma: h } = Bd(), { locStart: g, locEnd: p } = Nd();
            function D(P, R, f) {
              let x = P.getValue();
              if (!x)
                return "";
              if (typeof x == "string")
                return x;
              switch (x.kind) {
                case "Document": {
                  let m = [];
                  return P.each((E, o, d) => {
                    m.push(f()), o !== d.length - 1 && (m.push(s), c(R.originalText, E.getValue(), p) && m.push(s));
                  }, "definitions"), [...m, s];
                }
                case "OperationDefinition": {
                  let m = R.originalText[g(x)] !== "{", E = Boolean(x.name);
                  return [m ? x.operation : "", m && E ? [" ", f("name")] : "", m && !E && y(x.variableDefinitions) ? " " : "", y(x.variableDefinitions) ? u(["(", i([r, t3([l("", ", "), r], P.map(f, "variableDefinitions"))]), r, ")"]) : "", v(P, f, x), x.selectionSet ? !m && !E ? "" : " " : "", f("selectionSet")];
                }
                case "FragmentDefinition":
                  return ["fragment ", f("name"), y(x.variableDefinitions) ? u(["(", i([r, t3([l("", ", "), r], P.map(f, "variableDefinitions"))]), r, ")"]) : "", " on ", f("typeCondition"), v(P, f, x), " ", f("selectionSet")];
                case "SelectionSet":
                  return ["{", i([s, t3(s, w(P, R, f, "selections"))]), s, "}"];
                case "Field":
                  return u([x.alias ? [f("alias"), ": "] : "", f("name"), x.arguments.length > 0 ? u(["(", i([r, t3([l("", ", "), r], w(P, R, f, "arguments"))]), r, ")"]) : "", v(P, f, x), x.selectionSet ? " " : "", f("selectionSet")]);
                case "Name":
                  return x.value;
                case "StringValue": {
                  if (x.block) {
                    let m = x.value.replace(/"""/g, "\\$&").split(`
`);
                    return m.length === 1 && (m[0] = m[0].trim()), m.every((E) => E === "") && (m.length = 0), t3(s, ['"""', ...m, '"""']);
                  }
                  return ['"', x.value.replace(/["\\]/g, "\\$&").replace(/\n/g, "\\n"), '"'];
                }
                case "IntValue":
                case "FloatValue":
                case "EnumValue":
                  return x.value;
                case "BooleanValue":
                  return x.value ? "true" : "false";
                case "NullValue":
                  return "null";
                case "Variable":
                  return ["$", f("name")];
                case "ListValue":
                  return u(["[", i([r, t3([l("", ", "), r], P.map(f, "values"))]), r, "]"]);
                case "ObjectValue":
                  return u(["{", R.bracketSpacing && x.fields.length > 0 ? " " : "", i([r, t3([l("", ", "), r], P.map(f, "fields"))]), r, l("", R.bracketSpacing && x.fields.length > 0 ? " " : ""), "}"]);
                case "ObjectField":
                case "Argument":
                  return [f("name"), ": ", f("value")];
                case "Directive":
                  return ["@", f("name"), x.arguments.length > 0 ? u(["(", i([r, t3([l("", ", "), r], w(P, R, f, "arguments"))]), r, ")"]) : ""];
                case "NamedType":
                  return f("name");
                case "VariableDefinition":
                  return [f("variable"), ": ", f("type"), x.defaultValue ? [" = ", f("defaultValue")] : "", v(P, f, x)];
                case "ObjectTypeExtension":
                case "ObjectTypeDefinition":
                  return [f("description"), x.description ? s : "", x.kind === "ObjectTypeExtension" ? "extend " : "", "type ", f("name"), x.interfaces.length > 0 ? [" implements ", ...A(P, R, f)] : "", v(P, f, x), x.fields.length > 0 ? [" {", i([s, t3(s, w(P, R, f, "fields"))]), s, "}"] : ""];
                case "FieldDefinition":
                  return [f("description"), x.description ? s : "", f("name"), x.arguments.length > 0 ? u(["(", i([r, t3([l("", ", "), r], w(P, R, f, "arguments"))]), r, ")"]) : "", ": ", f("type"), v(P, f, x)];
                case "DirectiveDefinition":
                  return [f("description"), x.description ? s : "", "directive ", "@", f("name"), x.arguments.length > 0 ? u(["(", i([r, t3([l("", ", "), r], w(P, R, f, "arguments"))]), r, ")"]) : "", x.repeatable ? " repeatable" : "", " on ", t3(" | ", P.map(f, "locations"))];
                case "EnumTypeExtension":
                case "EnumTypeDefinition":
                  return [f("description"), x.description ? s : "", x.kind === "EnumTypeExtension" ? "extend " : "", "enum ", f("name"), v(P, f, x), x.values.length > 0 ? [" {", i([s, t3(s, w(P, R, f, "values"))]), s, "}"] : ""];
                case "EnumValueDefinition":
                  return [f("description"), x.description ? s : "", f("name"), v(P, f, x)];
                case "InputValueDefinition":
                  return [f("description"), x.description ? x.description.block ? s : a : "", f("name"), ": ", f("type"), x.defaultValue ? [" = ", f("defaultValue")] : "", v(P, f, x)];
                case "InputObjectTypeExtension":
                case "InputObjectTypeDefinition":
                  return [f("description"), x.description ? s : "", x.kind === "InputObjectTypeExtension" ? "extend " : "", "input ", f("name"), v(P, f, x), x.fields.length > 0 ? [" {", i([s, t3(s, w(P, R, f, "fields"))]), s, "}"] : ""];
                case "SchemaExtension":
                  return ["extend schema", v(P, f, x), ...x.operationTypes.length > 0 ? [" {", i([s, t3(s, w(P, R, f, "operationTypes"))]), s, "}"] : []];
                case "SchemaDefinition":
                  return [f("description"), x.description ? s : "", "schema", v(P, f, x), " {", x.operationTypes.length > 0 ? i([s, t3(s, w(P, R, f, "operationTypes"))]) : "", s, "}"];
                case "OperationTypeDefinition":
                  return [f("operation"), ": ", f("type")];
                case "InterfaceTypeExtension":
                case "InterfaceTypeDefinition":
                  return [f("description"), x.description ? s : "", x.kind === "InterfaceTypeExtension" ? "extend " : "", "interface ", f("name"), x.interfaces.length > 0 ? [" implements ", ...A(P, R, f)] : "", v(P, f, x), x.fields.length > 0 ? [" {", i([s, t3(s, w(P, R, f, "fields"))]), s, "}"] : ""];
                case "FragmentSpread":
                  return ["...", f("name"), v(P, f, x)];
                case "InlineFragment":
                  return ["...", x.typeCondition ? [" on ", f("typeCondition")] : "", v(P, f, x), " ", f("selectionSet")];
                case "UnionTypeExtension":
                case "UnionTypeDefinition":
                  return u([f("description"), x.description ? s : "", u([x.kind === "UnionTypeExtension" ? "extend " : "", "union ", f("name"), v(P, f, x), x.types.length > 0 ? [" =", l("", " "), i([l([a, "  "]), t3([a, "| "], P.map(f, "types"))])] : ""])]);
                case "ScalarTypeExtension":
                case "ScalarTypeDefinition":
                  return [f("description"), x.description ? s : "", x.kind === "ScalarTypeExtension" ? "extend " : "", "scalar ", f("name"), v(P, f, x)];
                case "NonNullType":
                  return [f("type"), "!"];
                case "ListType":
                  return ["[", f("type"), "]"];
                default:
                  throw new Error("unknown graphql type: " + JSON.stringify(x.kind));
              }
            }
            function v(P, R, f) {
              if (f.directives.length === 0)
                return "";
              let x = t3(a, P.map(R, "directives"));
              return f.kind === "FragmentDefinition" || f.kind === "OperationDefinition" ? u([a, x]) : [" ", u(i([r, x]))];
            }
            function w(P, R, f, x) {
              return P.map((m, E, o) => {
                let d = f();
                return E < o.length - 1 && c(R.originalText, m.getValue(), p) ? [d, s] : d;
              }, x);
            }
            function T(P) {
              return P.kind && P.kind !== "Comment";
            }
            function F(P) {
              let R = P.getValue();
              if (R.kind === "Comment")
                return "#" + R.value.trimEnd();
              throw new Error("Not a comment: " + JSON.stringify(R));
            }
            function A(P, R, f) {
              let x = P.getNode(), m = [], { interfaces: E } = x, o = P.map((d) => f(d), "interfaces");
              for (let d = 0; d < E.length; d++) {
                let C = E[d];
                m.push(o[d]);
                let _ = E[d + 1];
                if (_) {
                  let b = R.originalText.slice(C.loc.end, _.loc.start), N = b.includes("#"), k = b.replace(/#.*/g, "").trim();
                  m.push(k === "," ? "," : " &", N ? a : " ");
                }
              }
              return m;
            }
            function B(P, R) {
              P.kind === "StringValue" && P.block && !P.value.includes(`
`) && (R.value = R.value.trim());
            }
            B.ignoredProperties = /* @__PURE__ */ new Set(["loc", "comments"]);
            function I(P) {
              var R;
              let f = P.getValue();
              return f == null || (R = f.comments) === null || R === void 0 ? void 0 : R.some((x) => x.value.trim() === "prettier-ignore");
            }
            n.exports = { print: D, massageAstNode: B, hasPrettierIgnore: I, insertPragma: h, printComment: F, canAttachComment: T };
          } }), _d = ee({ "src/language-graphql/options.js"(e, n) {
            "use strict";
            re();
            var t3 = qt();
            n.exports = { bracketSpacing: t3.bracketSpacing };
          } }), Pd = ee({ "src/language-graphql/parsers.js"() {
            re();
          } }), Id = ee({ "node_modules/linguist-languages/data/GraphQL.json"(e, n) {
            n.exports = { name: "GraphQL", type: "data", color: "#e10098", extensions: [".graphql", ".gql", ".graphqls"], tmScope: "source.graphql", aceMode: "text", languageId: 139 };
          } }), kd = ee({ "src/language-graphql/index.js"(e, n) {
            "use strict";
            re();
            var t3 = wt(), s = wd(), a = _d(), r = Pd(), u = [t3(Id(), () => ({ since: "1.5.0", parsers: ["graphql"], vscodeLanguageIds: ["graphql"] }))], i = { graphql: s };
            n.exports = { languages: u, options: a, printers: i, parsers: r };
          } }), co = ee({ "src/language-markdown/loc.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return a.position.start.offset;
            }
            function s(a) {
              return a.position.end.offset;
            }
            n.exports = { locStart: t3, locEnd: s };
          } }), Ld = ee({ "src/language-markdown/constants.evaluate.js"(e, n) {
            n.exports = { cjkPattern: "(?:[\\u02ea-\\u02eb\\u1100-\\u11ff\\u2e80-\\u2e99\\u2e9b-\\u2ef3\\u2f00-\\u2fd5\\u2ff0-\\u303f\\u3041-\\u3096\\u3099-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312f\\u3131-\\u318e\\u3190-\\u3191\\u3196-\\u31ba\\u31c0-\\u31e3\\u31f0-\\u321e\\u322a-\\u3247\\u3260-\\u327e\\u328a-\\u32b0\\u32c0-\\u32cb\\u32d0-\\u3370\\u337b-\\u337f\\u33e0-\\u33fe\\u3400-\\u4db5\\u4e00-\\u9fef\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufe10-\\ufe1f\\ufe30-\\ufe6f\\uff00-\\uffef]|[\\ud840-\\ud868\\ud86a-\\ud86c\\ud86f-\\ud872\\ud874-\\ud879][\\udc00-\\udfff]|\\ud82c[\\udc00-\\udd1e\\udd50-\\udd52\\udd64-\\udd67]|\\ud83c[\\ude00\\ude50-\\ude51]|\\ud869[\\udc00-\\uded6\\udf00-\\udfff]|\\ud86d[\\udc00-\\udf34\\udf40-\\udfff]|\\ud86e[\\udc00-\\udc1d\\udc20-\\udfff]|\\ud873[\\udc00-\\udea1\\udeb0-\\udfff]|\\ud87a[\\udc00-\\udfe0]|\\ud87e[\\udc00-\\ude1d])(?:[\\ufe00-\\ufe0f]|\\udb40[\\udd00-\\uddef])?", kPattern: "[\\u1100-\\u11ff\\u3001-\\u3003\\u3008-\\u3011\\u3013-\\u301f\\u302e-\\u3030\\u3037\\u30fb\\u3131-\\u318e\\u3200-\\u321e\\u3260-\\u327e\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\ufe45-\\ufe46\\uff61-\\uff65\\uffa0-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc]", punctuationPattern: "[\\u0021-\\u002f\\u003a-\\u0040\\u005b-\\u0060\\u007b-\\u007e\\u00a1\\u00a7\\u00ab\\u00b6-\\u00b7\\u00bb\\u00bf\\u037e\\u0387\\u055a-\\u055f\\u0589-\\u058a\\u05be\\u05c0\\u05c3\\u05c6\\u05f3-\\u05f4\\u0609-\\u060a\\u060c-\\u060d\\u061b\\u061e-\\u061f\\u066a-\\u066d\\u06d4\\u0700-\\u070d\\u07f7-\\u07f9\\u0830-\\u083e\\u085e\\u0964-\\u0965\\u0970\\u09fd\\u0a76\\u0af0\\u0c77\\u0c84\\u0df4\\u0e4f\\u0e5a-\\u0e5b\\u0f04-\\u0f12\\u0f14\\u0f3a-\\u0f3d\\u0f85\\u0fd0-\\u0fd4\\u0fd9-\\u0fda\\u104a-\\u104f\\u10fb\\u1360-\\u1368\\u1400\\u166e\\u169b-\\u169c\\u16eb-\\u16ed\\u1735-\\u1736\\u17d4-\\u17d6\\u17d8-\\u17da\\u1800-\\u180a\\u1944-\\u1945\\u1a1e-\\u1a1f\\u1aa0-\\u1aa6\\u1aa8-\\u1aad\\u1b5a-\\u1b60\\u1bfc-\\u1bff\\u1c3b-\\u1c3f\\u1c7e-\\u1c7f\\u1cc0-\\u1cc7\\u1cd3\\u2010-\\u2027\\u2030-\\u2043\\u2045-\\u2051\\u2053-\\u205e\\u207d-\\u207e\\u208d-\\u208e\\u2308-\\u230b\\u2329-\\u232a\\u2768-\\u2775\\u27c5-\\u27c6\\u27e6-\\u27ef\\u2983-\\u2998\\u29d8-\\u29db\\u29fc-\\u29fd\\u2cf9-\\u2cfc\\u2cfe-\\u2cff\\u2d70\\u2e00-\\u2e2e\\u2e30-\\u2e4f\\u3001-\\u3003\\u3008-\\u3011\\u3014-\\u301f\\u3030\\u303d\\u30a0\\u30fb\\ua4fe-\\ua4ff\\ua60d-\\ua60f\\ua673\\ua67e\\ua6f2-\\ua6f7\\ua874-\\ua877\\ua8ce-\\ua8cf\\ua8f8-\\ua8fa\\ua8fc\\ua92e-\\ua92f\\ua95f\\ua9c1-\\ua9cd\\ua9de-\\ua9df\\uaa5c-\\uaa5f\\uaade-\\uaadf\\uaaf0-\\uaaf1\\uabeb\\ufd3e-\\ufd3f\\ufe10-\\ufe19\\ufe30-\\ufe52\\ufe54-\\ufe61\\ufe63\\ufe68\\ufe6a-\\ufe6b\\uff01-\\uff03\\uff05-\\uff0a\\uff0c-\\uff0f\\uff1a-\\uff1b\\uff1f-\\uff20\\uff3b-\\uff3d\\uff3f\\uff5b\\uff5d\\uff5f-\\uff65]|\\ud800[\\udd00-\\udd02\\udf9f\\udfd0]|\\ud801[\\udd6f]|\\ud802[\\udc57\\udd1f\\udd3f\\ude50-\\ude58\\ude7f\\udef0-\\udef6\\udf39-\\udf3f\\udf99-\\udf9c]|\\ud803[\\udf55-\\udf59]|\\ud804[\\udc47-\\udc4d\\udcbb-\\udcbc\\udcbe-\\udcc1\\udd40-\\udd43\\udd74-\\udd75\\uddc5-\\uddc8\\uddcd\\udddb\\udddd-\\udddf\\ude38-\\ude3d\\udea9]|\\ud805[\\udc4b-\\udc4f\\udc5b\\udc5d\\udcc6\\uddc1-\\uddd7\\ude41-\\ude43\\ude60-\\ude6c\\udf3c-\\udf3e]|\\ud806[\\udc3b\\udde2\\ude3f-\\ude46\\ude9a-\\ude9c\\ude9e-\\udea2]|\\ud807[\\udc41-\\udc45\\udc70-\\udc71\\udef7-\\udef8\\udfff]|\\ud809[\\udc70-\\udc74]|\\ud81a[\\ude6e-\\ude6f\\udef5\\udf37-\\udf3b\\udf44]|\\ud81b[\\ude97-\\ude9a\\udfe2]|\\ud82f[\\udc9f]|\\ud836[\\ude87-\\ude8b]|\\ud83a[\\udd5e-\\udd5f]" };
          } }), Yn = ee({ "src/language-markdown/utils.js"(e, n) {
            "use strict";
            re();
            var { getLast: t3 } = Ge(), { locStart: s, locEnd: a } = co(), { cjkPattern: r, kPattern: u, punctuationPattern: i } = Ld(), l = ["liquidNode", "inlineCode", "emphasis", "esComment", "strong", "delete", "wikiLink", "link", "linkReference", "image", "imageReference", "footnote", "footnoteReference", "sentence", "whitespace", "word", "break", "inlineMath"], c = [...l, "tableCell", "paragraph", "heading"], y = new RegExp(u), h = new RegExp(i);
            function g(F, A) {
              let B = "non-cjk", I = "cj-letter", P = "k-letter", R = "cjk-punctuation", f = [], x = (A.proseWrap === "preserve" ? F : F.replace(new RegExp(`(${r})
(${r})`, "g"), "$1$2")).split(/([\t\n ]+)/);
              for (let [E, o] of x.entries()) {
                if (E % 2 === 1) {
                  f.push({ type: "whitespace", value: /\n/.test(o) ? `
` : " " });
                  continue;
                }
                if ((E === 0 || E === x.length - 1) && o === "")
                  continue;
                let d = o.split(new RegExp(`(${r})`));
                for (let [C, _] of d.entries())
                  if (!((C === 0 || C === d.length - 1) && _ === "")) {
                    if (C % 2 === 0) {
                      _ !== "" && m({ type: "word", value: _, kind: B, hasLeadingPunctuation: h.test(_[0]), hasTrailingPunctuation: h.test(t3(_)) });
                      continue;
                    }
                    m(h.test(_) ? { type: "word", value: _, kind: R, hasLeadingPunctuation: true, hasTrailingPunctuation: true } : { type: "word", value: _, kind: y.test(_) ? P : I, hasLeadingPunctuation: false, hasTrailingPunctuation: false });
                  }
              }
              return f;
              function m(E) {
                let o = t3(f);
                o && o.type === "word" && (o.kind === B && E.kind === I && !o.hasTrailingPunctuation || o.kind === I && E.kind === B && !E.hasLeadingPunctuation ? f.push({ type: "whitespace", value: " " }) : !d(B, R) && ![o.value, E.value].some((C) => /\u3000/.test(C)) && f.push({ type: "whitespace", value: "" })), f.push(E);
                function d(C, _) {
                  return o.kind === C && E.kind === _ || o.kind === _ && E.kind === C;
                }
              }
            }
            function p(F, A) {
              let [, B, I, P] = A.slice(F.position.start.offset, F.position.end.offset).match(/^\s*(\d+)(\.|\))(\s*)/);
              return { numberText: B, marker: I, leadingSpaces: P };
            }
            function D(F, A) {
              if (!F.ordered || F.children.length < 2)
                return false;
              let B = Number(p(F.children[0], A.originalText).numberText), I = Number(p(F.children[1], A.originalText).numberText);
              if (B === 0 && F.children.length > 2) {
                let P = Number(p(F.children[2], A.originalText).numberText);
                return I === 1 && P === 1;
              }
              return I === 1;
            }
            function v(F, A) {
              let { value: B } = F;
              return F.position.end.offset === A.length && B.endsWith(`
`) && A.endsWith(`
`) ? B.slice(0, -1) : B;
            }
            function w(F, A) {
              return function B(I, P, R) {
                let f = Object.assign({}, A(I, P, R));
                return f.children && (f.children = f.children.map((x, m) => B(x, m, [f, ...R]))), f;
              }(F, null, []);
            }
            function T(F) {
              if ((F == null ? void 0 : F.type) !== "link" || F.children.length !== 1)
                return false;
              let [A] = F.children;
              return s(F) === s(A) && a(F) === a(A);
            }
            n.exports = { mapAst: w, splitText: g, punctuationPattern: i, getFencedCodeBlockValue: v, getOrderedListItemInfo: p, hasGitDiffFriendlyOrderedList: D, INLINE_NODE_TYPES: l, INLINE_NODE_WRAPPER_TYPES: c, isAutolink: T };
          } }), jd = ee({ "src/language-markdown/embed.js"(e, n) {
            "use strict";
            re();
            var { inferParserByLanguage: t3, getMaxContinuousCount: s } = Ge(), { builders: { hardline: a, markAsRoot: r }, utils: { replaceEndOfLine: u } } = qe(), i = Kn(), { getFencedCodeBlockValue: l } = Yn();
            function c(y, h, g, p) {
              let D = y.getValue();
              if (D.type === "code" && D.lang !== null) {
                let v = t3(D.lang, p);
                if (v) {
                  let w = p.__inJsTemplate ? "~" : "`", T = w.repeat(Math.max(3, s(D.value, w) + 1)), F = { parser: v };
                  D.lang === "tsx" && (F.filepath = "dummy.tsx");
                  let A = g(l(D, p.originalText), F, { stripTrailingHardline: true });
                  return r([T, D.lang, D.meta ? " " + D.meta : "", a, u(A), a, T]);
                }
              }
              switch (D.type) {
                case "front-matter":
                  return i(D, g);
                case "importExport":
                  return [g(D.value, { parser: "babel" }, { stripTrailingHardline: true }), a];
                case "jsx":
                  return g(`<$>${D.value}</$>`, { parser: "__js_expression", rootMarker: "mdx" }, { stripTrailingHardline: true });
              }
              return null;
            }
            n.exports = c;
          } }), po = ee({ "src/language-markdown/pragma.js"(e, n) {
            "use strict";
            re();
            var t3 = lo(), s = ["format", "prettier"];
            function a(r) {
              let u = `@(${s.join("|")})`, i = new RegExp([`<!--\\s*${u}\\s*-->`, `{\\s*\\/\\*\\s*${u}\\s*\\*\\/\\s*}`, `<!--.*\r?
[\\s\\S]*(^|
)[^\\S
]*${u}[^\\S
]*($|
)[\\s\\S]*
.*-->`].join("|"), "m"), l = r.match(i);
              return (l == null ? void 0 : l.index) === 0;
            }
            n.exports = { startWithPragma: a, hasPragma: (r) => a(t3(r).content.trimStart()), insertPragma: (r) => {
              let u = t3(r), i = `<!-- @${s[0]} -->`;
              return u.frontMatter ? `${u.frontMatter.raw}

${i}

${u.content}` : `${i}

${u.content}`;
            } };
          } }), Od = ee({ "src/language-markdown/print-preprocess.js"(e, n) {
            "use strict";
            re();
            var t3 = lt2(), { getOrderedListItemInfo: s, mapAst: a, splitText: r } = Yn(), u = /^.$/su;
            function i(T, F) {
              return T = y(T, F), T = p(T), T = c(T, F), T = v(T, F), T = w(T, F), T = D(T, F), T = l(T), T = h(T), T;
            }
            function l(T) {
              return a(T, (F) => F.type !== "import" && F.type !== "export" ? F : Object.assign(Object.assign({}, F), {}, { type: "importExport" }));
            }
            function c(T, F) {
              return a(T, (A) => A.type !== "inlineCode" || F.proseWrap === "preserve" ? A : Object.assign(Object.assign({}, A), {}, { value: A.value.replace(/\s+/g, " ") }));
            }
            function y(T, F) {
              return a(T, (A) => A.type !== "text" || A.value === "*" || A.value === "_" || !u.test(A.value) || A.position.end.offset - A.position.start.offset === A.value.length ? A : Object.assign(Object.assign({}, A), {}, { value: F.originalText.slice(A.position.start.offset, A.position.end.offset) }));
            }
            function h(T) {
              return g(T, (F, A) => F.type === "importExport" && A.type === "importExport", (F, A) => ({ type: "importExport", value: F.value + `

` + A.value, position: { start: F.position.start, end: A.position.end } }));
            }
            function g(T, F, A) {
              return a(T, (B) => {
                if (!B.children)
                  return B;
                let I = B.children.reduce((P, R) => {
                  let f = t3(P);
                  return f && F(f, R) ? P.splice(-1, 1, A(f, R)) : P.push(R), P;
                }, []);
                return Object.assign(Object.assign({}, B), {}, { children: I });
              });
            }
            function p(T) {
              return g(T, (F, A) => F.type === "text" && A.type === "text", (F, A) => ({ type: "text", value: F.value + A.value, position: { start: F.position.start, end: A.position.end } }));
            }
            function D(T, F) {
              return a(T, (A, B, I) => {
                let [P] = I;
                if (A.type !== "text")
                  return A;
                let { value: R } = A;
                return P.type === "paragraph" && (B === 0 && (R = R.trimStart()), B === P.children.length - 1 && (R = R.trimEnd())), { type: "sentence", position: A.position, children: r(R, F) };
              });
            }
            function v(T, F) {
              return a(T, (A, B, I) => {
                if (A.type === "code") {
                  let P = /^\n?(?: {4,}|\t)/.test(F.originalText.slice(A.position.start.offset, A.position.end.offset));
                  if (A.isIndented = P, P)
                    for (let R = 0; R < I.length; R++) {
                      let f = I[R];
                      if (f.hasIndentedCodeblock)
                        break;
                      f.type === "list" && (f.hasIndentedCodeblock = true);
                    }
                }
                return A;
              });
            }
            function w(T, F) {
              return a(T, (I, P, R) => {
                if (I.type === "list" && I.children.length > 0) {
                  for (let f = 0; f < R.length; f++) {
                    let x = R[f];
                    if (x.type === "list" && !x.isAligned)
                      return I.isAligned = false, I;
                  }
                  I.isAligned = B(I);
                }
                return I;
              });
              function A(I) {
                return I.children.length === 0 ? -1 : I.children[0].position.start.column - 1;
              }
              function B(I) {
                if (!I.ordered)
                  return true;
                let [P, R] = I.children;
                if (s(P, F.originalText).leadingSpaces.length > 1)
                  return true;
                let x = A(P);
                if (x === -1)
                  return false;
                if (I.children.length === 1)
                  return x % F.tabWidth === 0;
                let m = A(R);
                return x !== m ? false : x % F.tabWidth === 0 ? true : s(R, F.originalText).leadingSpaces.length > 1;
              }
            }
            n.exports = i;
          } }), qd = ee({ "src/language-markdown/clean.js"(e, n) {
            "use strict";
            re();
            var { isFrontMatterNode: t3 } = Ge(), { startWithPragma: s } = po(), a = /* @__PURE__ */ new Set(["position", "raw"]);
            function r(u, i, l) {
              if ((u.type === "front-matter" || u.type === "code" || u.type === "yaml" || u.type === "import" || u.type === "export" || u.type === "jsx") && delete i.value, u.type === "list" && delete i.isAligned, (u.type === "list" || u.type === "listItem") && (delete i.spread, delete i.loose), u.type === "text" || (u.type === "inlineCode" && (i.value = u.value.replace(/[\t\n ]+/g, " ")), u.type === "wikiLink" && (i.value = u.value.trim().replace(/[\t\n]+/g, " ")), (u.type === "definition" || u.type === "linkReference") && (i.label = u.label.trim().replace(/[\t\n ]+/g, " ").toLowerCase()), (u.type === "definition" || u.type === "link" || u.type === "image") && u.title && (i.title = u.title.replace(/\\(["')])/g, "$1")), l && l.type === "root" && l.children.length > 0 && (l.children[0] === u || t3(l.children[0]) && l.children[1] === u) && u.type === "html" && s(u.value)))
                return null;
            }
            r.ignoredProperties = a, n.exports = r;
          } }), Md = ee({ "src/language-markdown/printer-markdown.js"(e, n) {
            "use strict";
            re();
            var { getLast: t3, getMinNotPresentContinuousCount: s, getMaxContinuousCount: a, getStringWidth: r, isNonEmptyArray: u } = Ge(), { builders: { breakParent: i, join: l, line: c, literalline: y, markAsRoot: h, hardline: g, softline: p, ifBreak: D, fill: v, align: w, indent: T, group: F, hardlineWithoutBreakParent: A }, utils: { normalizeDoc: B, replaceTextEndOfLine: I }, printer: { printDocToString: P } } = qe(), R = jd(), { insertPragma: f } = po(), { locStart: x, locEnd: m } = co(), E = Od(), o = qd(), { getFencedCodeBlockValue: d, hasGitDiffFriendlyOrderedList: C, splitText: _, punctuationPattern: b, INLINE_NODE_TYPES: N, INLINE_NODE_WRAPPER_TYPES: k, isAutolink: $ } = Yn(), M = /* @__PURE__ */ new Set(["importExport"]), q = ["heading", "tableCell", "link", "wikiLink"], J = /* @__PURE__ */ new Set(["listItem", "definition", "footnoteDefinition"]);
            function L(pe, ie, ve) {
              let ce = pe.getValue();
              if (fe(pe))
                return _(ie.originalText.slice(ce.position.start.offset, ce.position.end.offset), ie).map((U) => U.type === "word" ? U.value : U.value === "" ? "" : le(pe, U.value, ie));
              switch (ce.type) {
                case "front-matter":
                  return ie.originalText.slice(ce.position.start.offset, ce.position.end.offset);
                case "root":
                  return ce.children.length === 0 ? "" : [B(X(pe, ie, ve)), M.has(Ae(ce).type) ? "" : g];
                case "paragraph":
                  return oe(pe, ie, ve, { postprocessor: v });
                case "sentence":
                  return oe(pe, ie, ve);
                case "word": {
                  let U = ce.value.replace(/\*/g, "\\$&").replace(new RegExp([`(^|${b})(_+)`, `(_+)(${b}|$)`].join("|"), "g"), (he, Be, Se, ye, S) => (Se ? `${Be}${Se}` : `${ye}${S}`).replace(/_/g, "\\_")), de = (he, Be, Se) => he.type === "sentence" && Se === 0, De = (he, Be, Se) => $(he.children[Se - 1]);
                  return U !== ce.value && (pe.match(void 0, de, De) || pe.match(void 0, de, (he, Be, Se) => he.type === "emphasis" && Se === 0, De)) && (U = U.replace(/^(\\?[*_])+/, (he) => he.replace(/\\/g, ""))), U;
                }
                case "whitespace": {
                  let U = pe.getParentNode(), de = U.children.indexOf(ce), De = U.children[de + 1], he = De && /^>|^(?:[*+-]|#{1,6}|\d+[).])$/.test(De.value) ? "never" : ie.proseWrap;
                  return le(pe, ce.value, { proseWrap: he });
                }
                case "emphasis": {
                  let U;
                  if ($(ce.children[0]))
                    U = ie.originalText[ce.position.start.offset];
                  else {
                    let de = pe.getParentNode(), De = de.children.indexOf(ce), he = de.children[De - 1], Be = de.children[De + 1];
                    U = he && he.type === "sentence" && he.children.length > 0 && t3(he.children).type === "word" && !t3(he.children).hasTrailingPunctuation || Be && Be.type === "sentence" && Be.children.length > 0 && Be.children[0].type === "word" && !Be.children[0].hasLeadingPunctuation || Q(pe, "emphasis") ? "*" : "_";
                  }
                  return [U, oe(pe, ie, ve), U];
                }
                case "strong":
                  return ["**", oe(pe, ie, ve), "**"];
                case "delete":
                  return ["~~", oe(pe, ie, ve), "~~"];
                case "inlineCode": {
                  let U = s(ce.value, "`"), de = "`".repeat(U || 1), De = U && !/^\s/.test(ce.value) ? " " : "";
                  return [de, De, ce.value, De, de];
                }
                case "wikiLink": {
                  let U = "";
                  return ie.proseWrap === "preserve" ? U = ce.value : U = ce.value.replace(/[\t\n]+/g, " "), ["[[", U, "]]"];
                }
                case "link":
                  switch (ie.originalText[ce.position.start.offset]) {
                    case "<": {
                      let U = "mailto:", de = ce.url.startsWith(U) && ie.originalText.slice(ce.position.start.offset + 1, ce.position.start.offset + 1 + U.length) !== U ? ce.url.slice(U.length) : ce.url;
                      return ["<", de, ">"];
                    }
                    case "[":
                      return ["[", oe(pe, ie, ve), "](", ge(ce.url, ")"), Ce(ce.title, ie), ")"];
                    default:
                      return ie.originalText.slice(ce.position.start.offset, ce.position.end.offset);
                  }
                case "image":
                  return ["![", ce.alt || "", "](", ge(ce.url, ")"), Ce(ce.title, ie), ")"];
                case "blockquote":
                  return ["> ", w("> ", oe(pe, ie, ve))];
                case "heading":
                  return ["#".repeat(ce.depth) + " ", oe(pe, ie, ve)];
                case "code": {
                  if (ce.isIndented) {
                    let De = " ".repeat(4);
                    return w(De, [De, ...I(ce.value, g)]);
                  }
                  let U = ie.__inJsTemplate ? "~" : "`", de = U.repeat(Math.max(3, a(ce.value, U) + 1));
                  return [de, ce.lang || "", ce.meta ? " " + ce.meta : "", g, ...I(d(ce, ie.originalText), g), g, de];
                }
                case "html": {
                  let U = pe.getParentNode(), de = U.type === "root" && t3(U.children) === ce ? ce.value.trimEnd() : ce.value, De = /^<!--.*-->$/s.test(de);
                  return I(de, De ? g : h(y));
                }
                case "list": {
                  let U = O(ce, pe.getParentNode()), de = C(ce, ie);
                  return oe(pe, ie, ve, { processor: (De, he) => {
                    let Be = ye(), Se = De.getValue();
                    if (Se.children.length === 2 && Se.children[1].type === "html" && Se.children[0].position.start.column !== Se.children[1].position.start.column)
                      return [Be, Y(De, ie, ve, Be)];
                    return [Be, w(" ".repeat(Be.length), Y(De, ie, ve, Be))];
                    function ye() {
                      let S = ce.ordered ? (he === 0 ? ce.start : de ? 1 : ce.start + he) + (U % 2 === 0 ? ". " : ") ") : U % 2 === 0 ? "- " : "* ";
                      return ce.isAligned || ce.hasIndentedCodeblock ? V(S, ie) : S;
                    }
                  } });
                }
                case "thematicBreak": {
                  let U = se(pe, "list");
                  return U === -1 ? "---" : O(pe.getParentNode(U), pe.getParentNode(U + 1)) % 2 === 0 ? "***" : "---";
                }
                case "linkReference":
                  return ["[", oe(pe, ie, ve), "]", ce.referenceType === "full" ? ["[", ce.identifier, "]"] : ce.referenceType === "collapsed" ? "[]" : ""];
                case "imageReference":
                  switch (ce.referenceType) {
                    case "full":
                      return ["![", ce.alt || "", "][", ce.identifier, "]"];
                    default:
                      return ["![", ce.alt, "]", ce.referenceType === "collapsed" ? "[]" : ""];
                  }
                case "definition": {
                  let U = ie.proseWrap === "always" ? c : " ";
                  return F(["[", ce.identifier, "]:", T([U, ge(ce.url), ce.title === null ? "" : [U, Ce(ce.title, ie, false)]])]);
                }
                case "footnote":
                  return ["[^", oe(pe, ie, ve), "]"];
                case "footnoteReference":
                  return ["[^", ce.identifier, "]"];
                case "footnoteDefinition": {
                  let U = pe.getParentNode().children[pe.getName() + 1], de = ce.children.length === 1 && ce.children[0].type === "paragraph" && (ie.proseWrap === "never" || ie.proseWrap === "preserve" && ce.children[0].position.start.line === ce.children[0].position.end.line);
                  return ["[^", ce.identifier, "]: ", de ? oe(pe, ie, ve) : F([w(" ".repeat(4), oe(pe, ie, ve, { processor: (De, he) => he === 0 ? F([p, ve()]) : ve() })), U && U.type === "footnoteDefinition" ? p : ""])];
                }
                case "table":
                  return W(pe, ie, ve);
                case "tableCell":
                  return oe(pe, ie, ve);
                case "break":
                  return /\s/.test(ie.originalText[ce.position.start.offset]) ? ["  ", h(y)] : ["\\", g];
                case "liquidNode":
                  return I(ce.value, g);
                case "importExport":
                  return [ce.value, g];
                case "esComment":
                  return ["{/* ", ce.value, " */}"];
                case "jsx":
                  return ce.value;
                case "math":
                  return ["$$", g, ce.value ? [...I(ce.value, g), g] : "", "$$"];
                case "inlineMath":
                  return ie.originalText.slice(x(ce), m(ce));
                case "tableRow":
                case "listItem":
                default:
                  throw new Error(`Unknown markdown type ${JSON.stringify(ce.type)}`);
              }
            }
            function Y(pe, ie, ve, ce) {
              let U = pe.getValue(), de = U.checked === null ? "" : U.checked ? "[x] " : "[ ] ";
              return [de, oe(pe, ie, ve, { processor: (De, he) => {
                if (he === 0 && De.getValue().type !== "list")
                  return w(" ".repeat(de.length), ve());
                let Be = " ".repeat(_e(ie.tabWidth - ce.length, 0, 3));
                return [Be, w(Be, ve())];
              } })];
            }
            function V(pe, ie) {
              let ve = ce();
              return pe + " ".repeat(ve >= 4 ? 0 : ve);
              function ce() {
                let U = pe.length % ie.tabWidth;
                return U === 0 ? 0 : ie.tabWidth - U;
              }
            }
            function O(pe, ie) {
              return K(pe, ie, (ve) => ve.ordered === pe.ordered);
            }
            function K(pe, ie, ve) {
              let ce = -1;
              for (let U of ie.children)
                if (U.type === pe.type && ve(U) ? ce++ : ce = -1, U === pe)
                  return ce;
            }
            function se(pe, ie) {
              let ve = Array.isArray(ie) ? ie : [ie], ce = -1, U;
              for (; U = pe.getParentNode(++ce); )
                if (ve.includes(U.type))
                  return ce;
              return -1;
            }
            function Q(pe, ie) {
              let ve = se(pe, ie);
              return ve === -1 ? null : pe.getParentNode(ve);
            }
            function le(pe, ie, ve) {
              if (ve.proseWrap === "preserve" && ie === `
`)
                return g;
              let ce = ve.proseWrap === "always" && !Q(pe, q);
              return ie !== "" ? ce ? c : " " : ce ? p : "";
            }
            function W(pe, ie, ve) {
              let ce = pe.getValue(), U = [], de = pe.map((S) => S.map((G, te) => {
                let Ee = P(ve(), ie).formatted, Re = r(Ee);
                return U[te] = Math.max(U[te] || 3, Re), { text: Ee, width: Re };
              }, "children"), "children"), De = Be(false);
              if (ie.proseWrap !== "never")
                return [i, De];
              let he = Be(true);
              return [i, F(D(he, De))];
              function Be(S) {
                let G = [ye(de[0], S), Se(S)];
                return de.length > 1 && G.push(l(A, de.slice(1).map((te) => ye(te, S)))), l(A, G);
              }
              function Se(S) {
                return `| ${U.map((te, Ee) => {
                  let Re = ce.align[Ee], Te = Re === "center" || Re === "left" ? ":" : "-", Pe = Re === "center" || Re === "right" ? ":" : "-", Fe = S ? "-" : "-".repeat(te - 2);
                  return `${Te}${Fe}${Pe}`;
                }).join(" | ")} |`;
              }
              function ye(S, G) {
                return `| ${S.map((Ee, Re) => {
                  let { text: Te, width: Pe } = Ee;
                  if (G)
                    return Te;
                  let Fe = U[Re] - Pe, Ze = ce.align[Re], xe = 0;
                  Ze === "right" ? xe = Fe : Ze === "center" && (xe = Math.floor(Fe / 2));
                  let Je = Fe - xe;
                  return `${" ".repeat(xe)}${Te}${" ".repeat(Je)}`;
                }).join(" | ")} |`;
              }
            }
            function X(pe, ie, ve) {
              let ce = [], U = null, { children: de } = pe.getValue();
              for (let [De, he] of de.entries())
                switch (z(he)) {
                  case "start":
                    U === null && (U = { index: De, offset: he.position.end.offset });
                    break;
                  case "end":
                    U !== null && (ce.push({ start: U, end: { index: De, offset: he.position.start.offset } }), U = null);
                    break;
                  default:
                    break;
                }
              return oe(pe, ie, ve, { processor: (De, he) => {
                if (ce.length > 0) {
                  let Be = ce[0];
                  if (he === Be.start.index)
                    return [ae(de[Be.start.index]), ie.originalText.slice(Be.start.offset, Be.end.offset), ae(de[Be.end.index])];
                  if (Be.start.index < he && he < Be.end.index)
                    return false;
                  if (he === Be.end.index)
                    return ce.shift(), false;
                }
                return ve();
              } });
            }
            function oe(pe, ie, ve) {
              let ce = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, { postprocessor: U } = ce, de = ce.processor || (() => ve()), De = pe.getValue(), he = [], Be;
              return pe.each((Se, ye) => {
                let S = Se.getValue(), G = de(Se, ye);
                if (G !== false) {
                  let te = { parts: he, prevNode: Be, parentNode: De, options: ie };
                  H(S, te) && (he.push(g), Be && M.has(Be.type) || (Z(S, te) || ne(S, te)) && he.push(g), ne(S, te) && he.push(g)), he.push(G), Be = S;
                }
              }, "children"), U ? U(he) : he;
            }
            function ae(pe) {
              if (pe.type === "html")
                return pe.value;
              if (pe.type === "paragraph" && Array.isArray(pe.children) && pe.children.length === 1 && pe.children[0].type === "esComment")
                return ["{/* ", pe.children[0].value, " */}"];
            }
            function Ae(pe) {
              let ie = pe;
              for (; u(ie.children); )
                ie = t3(ie.children);
              return ie;
            }
            function z(pe) {
              let ie;
              if (pe.type === "html")
                ie = pe.value.match(/^<!--\s*prettier-ignore(?:-(start|end))?\s*-->$/);
              else {
                let ve;
                pe.type === "esComment" ? ve = pe : pe.type === "paragraph" && pe.children.length === 1 && pe.children[0].type === "esComment" && (ve = pe.children[0]), ve && (ie = ve.value.match(/^prettier-ignore(?:-(start|end))?$/));
              }
              return ie ? ie[1] || "next" : false;
            }
            function H(pe, ie) {
              let ve = ie.parts.length === 0, ce = N.includes(pe.type), U = pe.type === "html" && k.includes(ie.parentNode.type);
              return !ve && !ce && !U;
            }
            function Z(pe, ie) {
              var ve, ce, U;
              let De = (ie.prevNode && ie.prevNode.type) === pe.type && J.has(pe.type), he = ie.parentNode.type === "listItem" && !ie.parentNode.loose, Be = ((ve = ie.prevNode) === null || ve === void 0 ? void 0 : ve.type) === "listItem" && ie.prevNode.loose, Se = z(ie.prevNode) === "next", ye = pe.type === "html" && ((ce = ie.prevNode) === null || ce === void 0 ? void 0 : ce.type) === "html" && ie.prevNode.position.end.line + 1 === pe.position.start.line, S = pe.type === "html" && ie.parentNode.type === "listItem" && ((U = ie.prevNode) === null || U === void 0 ? void 0 : U.type) === "paragraph" && ie.prevNode.position.end.line + 1 === pe.position.start.line;
              return Be || !(De || he || Se || ye || S);
            }
            function ne(pe, ie) {
              let ve = ie.prevNode && ie.prevNode.type === "list", ce = pe.type === "code" && pe.isIndented;
              return ve && ce;
            }
            function fe(pe) {
              let ie = Q(pe, ["linkReference", "imageReference"]);
              return ie && (ie.type !== "linkReference" || ie.referenceType !== "full");
            }
            function ge(pe) {
              let ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], ve = [" ", ...Array.isArray(ie) ? ie : [ie]];
              return new RegExp(ve.map((ce) => `\\${ce}`).join("|")).test(pe) ? `<${pe}>` : pe;
            }
            function Ce(pe, ie) {
              let ve = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
              if (!pe)
                return "";
              if (ve)
                return " " + Ce(pe, ie, false);
              if (pe = pe.replace(/\\(["')])/g, "$1"), pe.includes('"') && pe.includes("'") && !pe.includes(")"))
                return `(${pe})`;
              let ce = pe.split("'").length - 1, U = pe.split('"').length - 1, de = ce > U ? '"' : U > ce || ie.singleQuote ? "'" : '"';
              return pe = pe.replace(/\\/, "\\\\"), pe = pe.replace(new RegExp(`(${de})`, "g"), "\\$1"), `${de}${pe}${de}`;
            }
            function _e(pe, ie, ve) {
              return pe < ie ? ie : pe > ve ? ve : pe;
            }
            function Oe(pe) {
              let ie = Number(pe.getName());
              if (ie === 0)
                return false;
              let ve = pe.getParentNode().children[ie - 1];
              return z(ve) === "next";
            }
            n.exports = { preprocess: E, print: L, embed: R, massageAstNode: o, hasPrettierIgnore: Oe, insertPragma: f };
          } }), Rd = ee({ "src/language-markdown/options.js"(e, n) {
            "use strict";
            re();
            var t3 = qt();
            n.exports = { proseWrap: t3.proseWrap, singleQuote: t3.singleQuote };
          } }), $d = ee({ "src/language-markdown/parsers.js"() {
            re();
          } }), ca = ee({ "node_modules/linguist-languages/data/Markdown.json"(e, n) {
            n.exports = { name: "Markdown", type: "prose", color: "#083fa1", aliases: ["pandoc"], aceMode: "markdown", codemirrorMode: "gfm", codemirrorMimeType: "text/x-gfm", wrap: true, extensions: [".md", ".livemd", ".markdown", ".mdown", ".mdwn", ".mdx", ".mkd", ".mkdn", ".mkdown", ".ronn", ".scd", ".workbook"], filenames: ["contents.lr"], tmScope: "source.gfm", languageId: 222 };
          } }), Vd = ee({ "src/language-markdown/index.js"(e, n) {
            "use strict";
            re();
            var t3 = wt(), s = Md(), a = Rd(), r = $d(), u = [t3(ca(), (l) => ({ since: "1.8.0", parsers: ["markdown"], vscodeLanguageIds: ["markdown"], filenames: [...l.filenames, "README"], extensions: l.extensions.filter((c) => c !== ".mdx") })), t3(ca(), () => ({ name: "MDX", since: "1.15.0", parsers: ["mdx"], vscodeLanguageIds: ["mdx"], filenames: [], extensions: [".mdx"] }))], i = { mdast: s };
            n.exports = { languages: u, options: a, printers: i, parsers: r };
          } }), Wd = ee({ "src/language-html/clean.js"(e, n) {
            "use strict";
            re();
            var { isFrontMatterNode: t3 } = Ge(), s = /* @__PURE__ */ new Set(["sourceSpan", "startSourceSpan", "endSourceSpan", "nameSpan", "valueSpan"]);
            function a(r, u) {
              if (r.type === "text" || r.type === "comment" || t3(r) || r.type === "yaml" || r.type === "toml")
                return null;
              r.type === "attribute" && delete u.value, r.type === "docType" && delete u.value;
            }
            a.ignoredProperties = s, n.exports = a;
          } }), Hd = ee({ "src/language-html/constants.evaluate.js"(e, n) {
            n.exports = { CSS_DISPLAY_TAGS: { area: "none", base: "none", basefont: "none", datalist: "none", head: "none", link: "none", meta: "none", noembed: "none", noframes: "none", param: "block", rp: "none", script: "block", source: "block", style: "none", template: "inline", track: "block", title: "none", html: "block", body: "block", address: "block", blockquote: "block", center: "block", div: "block", figure: "block", figcaption: "block", footer: "block", form: "block", header: "block", hr: "block", legend: "block", listing: "block", main: "block", p: "block", plaintext: "block", pre: "block", xmp: "block", slot: "contents", ruby: "ruby", rt: "ruby-text", article: "block", aside: "block", h1: "block", h2: "block", h3: "block", h4: "block", h5: "block", h6: "block", hgroup: "block", nav: "block", section: "block", dir: "block", dd: "block", dl: "block", dt: "block", ol: "block", ul: "block", li: "list-item", table: "table", caption: "table-caption", colgroup: "table-column-group", col: "table-column", thead: "table-header-group", tbody: "table-row-group", tfoot: "table-footer-group", tr: "table-row", td: "table-cell", th: "table-cell", fieldset: "block", button: "inline-block", details: "block", summary: "block", dialog: "block", meter: "inline-block", progress: "inline-block", object: "inline-block", video: "inline-block", audio: "inline-block", select: "inline-block", option: "block", optgroup: "block" }, CSS_DISPLAY_DEFAULT: "inline", CSS_WHITE_SPACE_TAGS: { listing: "pre", plaintext: "pre", pre: "pre", xmp: "pre", nobr: "nowrap", table: "initial", textarea: "pre-wrap" }, CSS_WHITE_SPACE_DEFAULT: "normal" };
          } }), Gd = ee({ "src/language-html/utils/is-unknown-namespace.js"(e, n) {
            "use strict";
            re();
            function t3(s) {
              return s.type === "element" && !s.hasExplicitNamespace && !["html", "svg"].includes(s.namespace);
            }
            n.exports = t3;
          } }), Mt = ee({ "src/language-html/utils/index.js"(e, n) {
            "use strict";
            re();
            var { inferParserByLanguage: t3, isFrontMatterNode: s } = Ge(), { builders: { line: a, hardline: r, join: u }, utils: { getDocParts: i, replaceTextEndOfLine: l } } = qe(), { CSS_DISPLAY_TAGS: c, CSS_DISPLAY_DEFAULT: y, CSS_WHITE_SPACE_TAGS: h, CSS_WHITE_SPACE_DEFAULT: g } = Hd(), p = Gd(), D = /* @__PURE__ */ new Set(["	", `
`, "\f", "\r", " "]), v = (S) => S.replace(/^[\t\n\f\r ]+/, ""), w = (S) => S.replace(/[\t\n\f\r ]+$/, ""), T = (S) => v(w(S)), F = (S) => S.replace(/^[\t\f\r ]*\n/g, ""), A = (S) => F(w(S)), B = (S) => S.split(/[\t\n\f\r ]+/), I = (S) => S.match(/^[\t\n\f\r ]*/)[0], P = (S) => {
              let [, G, te, Ee] = S.match(/^([\t\n\f\r ]*)(.*?)([\t\n\f\r ]*)$/s);
              return { leadingWhitespace: G, trailingWhitespace: Ee, text: te };
            }, R = (S) => /[\t\n\f\r ]/.test(S);
            function f(S, G) {
              return !!(S.type === "ieConditionalComment" && S.lastChild && !S.lastChild.isSelfClosing && !S.lastChild.endSourceSpan || S.type === "ieConditionalComment" && !S.complete || ne(S) && S.children.some((te) => te.type !== "text" && te.type !== "interpolation") || De(S, G) && !o(S) && S.type !== "interpolation");
            }
            function x(S) {
              return S.type === "attribute" || !S.parent || !S.prev ? false : m(S.prev);
            }
            function m(S) {
              return S.type === "comment" && S.value.trim() === "prettier-ignore";
            }
            function E(S) {
              return S.type === "text" || S.type === "comment";
            }
            function o(S) {
              return S.type === "element" && (S.fullName === "script" || S.fullName === "style" || S.fullName === "svg:style" || p(S) && (S.name === "script" || S.name === "style"));
            }
            function d(S) {
              return S.children && !o(S);
            }
            function C(S) {
              return o(S) || S.type === "interpolation" || _(S);
            }
            function _(S) {
              return _e(S).startsWith("pre");
            }
            function b(S, G) {
              let te = Ee();
              if (te && !S.prev && S.parent && S.parent.tagDefinition && S.parent.tagDefinition.ignoreFirstLf)
                return S.type === "interpolation";
              return te;
              function Ee() {
                return s(S) ? false : (S.type === "text" || S.type === "interpolation") && S.prev && (S.prev.type === "text" || S.prev.type === "interpolation") ? true : !S.parent || S.parent.cssDisplay === "none" ? false : ne(S.parent) ? true : !(!S.prev && (S.parent.type === "root" || ne(S) && S.parent || o(S.parent) || U(S.parent, G) || !ae(S.parent.cssDisplay)) || S.prev && !H(S.prev.cssDisplay));
              }
            }
            function N(S, G) {
              return s(S) ? false : (S.type === "text" || S.type === "interpolation") && S.next && (S.next.type === "text" || S.next.type === "interpolation") ? true : !S.parent || S.parent.cssDisplay === "none" ? false : ne(S.parent) ? true : !(!S.next && (S.parent.type === "root" || ne(S) && S.parent || o(S.parent) || U(S.parent, G) || !Ae(S.parent.cssDisplay)) || S.next && !z(S.next.cssDisplay));
            }
            function k(S) {
              return Z(S.cssDisplay) && !o(S);
            }
            function $(S) {
              return s(S) || S.next && S.sourceSpan.end && S.sourceSpan.end.line + 1 < S.next.sourceSpan.start.line;
            }
            function M(S) {
              return q(S) || S.type === "element" && S.children.length > 0 && (["body", "script", "style"].includes(S.name) || S.children.some((G) => Q(G))) || S.firstChild && S.firstChild === S.lastChild && S.firstChild.type !== "text" && V(S.firstChild) && (!S.lastChild.isTrailingSpaceSensitive || O(S.lastChild));
            }
            function q(S) {
              return S.type === "element" && S.children.length > 0 && (["html", "head", "ul", "ol", "select"].includes(S.name) || S.cssDisplay.startsWith("table") && S.cssDisplay !== "table-cell");
            }
            function J(S) {
              return K(S) || S.prev && L(S.prev) || Y(S);
            }
            function L(S) {
              return K(S) || S.type === "element" && S.fullName === "br" || Y(S);
            }
            function Y(S) {
              return V(S) && O(S);
            }
            function V(S) {
              return S.hasLeadingSpaces && (S.prev ? S.prev.sourceSpan.end.line < S.sourceSpan.start.line : S.parent.type === "root" || S.parent.startSourceSpan.end.line < S.sourceSpan.start.line);
            }
            function O(S) {
              return S.hasTrailingSpaces && (S.next ? S.next.sourceSpan.start.line > S.sourceSpan.end.line : S.parent.type === "root" || S.parent.endSourceSpan && S.parent.endSourceSpan.start.line > S.sourceSpan.end.line);
            }
            function K(S) {
              switch (S.type) {
                case "ieConditionalComment":
                case "comment":
                case "directive":
                  return true;
                case "element":
                  return ["script", "select"].includes(S.name);
              }
              return false;
            }
            function se(S) {
              return S.lastChild ? se(S.lastChild) : S;
            }
            function Q(S) {
              return S.children && S.children.some((G) => G.type !== "text");
            }
            function le(S) {
              let { type: G, lang: te } = S.attrMap;
              if (G === "module" || G === "text/javascript" || G === "text/babel" || G === "application/javascript" || te === "jsx")
                return "babel";
              if (G === "application/x-typescript" || te === "ts" || te === "tsx")
                return "typescript";
              if (G === "text/markdown")
                return "markdown";
              if (G === "text/html")
                return "html";
              if (G && (G.endsWith("json") || G.endsWith("importmap")) || G === "speculationrules")
                return "json";
              if (G === "text/x-handlebars-template")
                return "glimmer";
            }
            function W(S, G) {
              let { lang: te } = S.attrMap;
              if (!te || te === "postcss" || te === "css")
                return "css";
              if (te === "scss")
                return "scss";
              if (te === "less")
                return "less";
              if (te === "stylus")
                return t3("stylus", G);
            }
            function X(S, G) {
              if (S.name === "script" && !S.attrMap.src)
                return !S.attrMap.lang && !S.attrMap.type ? "babel" : le(S);
              if (S.name === "style")
                return W(S, G);
              if (G && De(S, G))
                return le(S) || !("src" in S.attrMap) && t3(S.attrMap.lang, G);
            }
            function oe(S) {
              return S === "block" || S === "list-item" || S.startsWith("table");
            }
            function ae(S) {
              return !oe(S) && S !== "inline-block";
            }
            function Ae(S) {
              return !oe(S) && S !== "inline-block";
            }
            function z(S) {
              return !oe(S);
            }
            function H(S) {
              return !oe(S);
            }
            function Z(S) {
              return !oe(S) && S !== "inline-block";
            }
            function ne(S) {
              return _e(S).startsWith("pre");
            }
            function fe(S, G) {
              let te = 0;
              for (let Ee = S.stack.length - 1; Ee >= 0; Ee--) {
                let Re = S.stack[Ee];
                Re && typeof Re == "object" && !Array.isArray(Re) && G(Re) && te++;
              }
              return te;
            }
            function ge(S, G) {
              let te = S;
              for (; te; ) {
                if (G(te))
                  return true;
                te = te.parent;
              }
              return false;
            }
            function Ce(S, G) {
              if (S.prev && S.prev.type === "comment") {
                let Ee = S.prev.value.match(/^\s*display:\s*([a-z]+)\s*$/);
                if (Ee)
                  return Ee[1];
              }
              let te = false;
              if (S.type === "element" && S.namespace === "svg")
                if (ge(S, (Ee) => Ee.fullName === "svg:foreignObject"))
                  te = true;
                else
                  return S.name === "svg" ? "inline-block" : "block";
              switch (G.htmlWhitespaceSensitivity) {
                case "strict":
                  return "inline";
                case "ignore":
                  return "block";
                default:
                  return G.parser === "vue" && S.parent && S.parent.type === "root" ? "block" : S.type === "element" && (!S.namespace || te || p(S)) && c[S.name] || y;
              }
            }
            function _e(S) {
              return S.type === "element" && (!S.namespace || p(S)) && h[S.name] || g;
            }
            function Oe(S) {
              let G = Number.POSITIVE_INFINITY;
              for (let te of S.split(`
`)) {
                if (te.length === 0)
                  continue;
                if (!D.has(te[0]))
                  return 0;
                let Ee = I(te).length;
                te.length !== Ee && Ee < G && (G = Ee);
              }
              return G === Number.POSITIVE_INFINITY ? 0 : G;
            }
            function pe(S) {
              let G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Oe(S);
              return G === 0 ? S : S.split(`
`).map((te) => te.slice(G)).join(`
`);
            }
            function ie(S, G) {
              let te = 0;
              for (let Ee = 0; Ee < S.length; Ee++)
                S[Ee] === G && te++;
              return te;
            }
            function ve(S) {
              return S.replace(/&apos;/g, "'").replace(/&quot;/g, '"');
            }
            var ce = /* @__PURE__ */ new Set(["template", "style", "script"]);
            function U(S, G) {
              return de(S, G) && !ce.has(S.fullName);
            }
            function de(S, G) {
              return G.parser === "vue" && S.type === "element" && S.parent.type === "root" && S.fullName.toLowerCase() !== "html";
            }
            function De(S, G) {
              return de(S, G) && (U(S, G) || S.attrMap.lang && S.attrMap.lang !== "html");
            }
            function he(S) {
              let G = S.fullName;
              return G.charAt(0) === "#" || G === "slot-scope" || G === "v-slot" || G.startsWith("v-slot:");
            }
            function Be(S, G) {
              let te = S.parent;
              if (!de(te, G))
                return false;
              let Ee = te.fullName, Re = S.fullName;
              return Ee === "script" && Re === "setup" || Ee === "style" && Re === "vars";
            }
            function Se(S) {
              let G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : S.value;
              return S.parent.isWhitespaceSensitive ? S.parent.isIndentationSensitive ? l(G) : l(pe(A(G)), r) : i(u(a, B(G)));
            }
            function ye(S, G) {
              return de(S, G) && S.name === "script";
            }
            n.exports = { htmlTrim: T, htmlTrimPreserveIndentation: A, hasHtmlWhitespace: R, getLeadingAndTrailingHtmlWhitespace: P, canHaveInterpolation: d, countChars: ie, countParents: fe, dedentString: pe, forceBreakChildren: q, forceBreakContent: M, forceNextEmptyLine: $, getLastDescendant: se, getNodeCssStyleDisplay: Ce, getNodeCssStyleWhiteSpace: _e, hasPrettierIgnore: x, inferScriptParser: X, isVueCustomBlock: U, isVueNonHtmlBlock: De, isVueScriptTag: ye, isVueSlotAttribute: he, isVueSfcBindingsAttribute: Be, isVueSfcBlock: de, isDanglingSpaceSensitiveNode: k, isIndentationSensitiveNode: _, isLeadingSpaceSensitiveNode: b, isPreLikeNode: ne, isScriptLikeTag: o, isTextLikeNode: E, isTrailingSpaceSensitiveNode: N, isWhitespaceSensitiveNode: C, isUnknownNamespace: p, preferHardlineAsLeadingSpaces: J, preferHardlineAsTrailingSpaces: L, shouldPreserveContent: f, unescapeQuoteEntities: ve, getTextValueParts: Se };
          } }), Ud = ee({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.$EOF = 0, e.$BSPACE = 8, e.$TAB = 9, e.$LF = 10, e.$VTAB = 11, e.$FF = 12, e.$CR = 13, e.$SPACE = 32, e.$BANG = 33, e.$DQ = 34, e.$HASH = 35, e.$$ = 36, e.$PERCENT = 37, e.$AMPERSAND = 38, e.$SQ = 39, e.$LPAREN = 40, e.$RPAREN = 41, e.$STAR = 42, e.$PLUS = 43, e.$COMMA = 44, e.$MINUS = 45, e.$PERIOD = 46, e.$SLASH = 47, e.$COLON = 58, e.$SEMICOLON = 59, e.$LT = 60, e.$EQ = 61, e.$GT = 62, e.$QUESTION = 63, e.$0 = 48, e.$7 = 55, e.$9 = 57, e.$A = 65, e.$E = 69, e.$F = 70, e.$X = 88, e.$Z = 90, e.$LBRACKET = 91, e.$BACKSLASH = 92, e.$RBRACKET = 93, e.$CARET = 94, e.$_ = 95, e.$a = 97, e.$b = 98, e.$e = 101, e.$f = 102, e.$n = 110, e.$r = 114, e.$t = 116, e.$u = 117, e.$v = 118, e.$x = 120, e.$z = 122, e.$LBRACE = 123, e.$BAR = 124, e.$RBRACE = 125, e.$NBSP = 160, e.$PIPE = 124, e.$TILDA = 126, e.$AT = 64, e.$BT = 96;
            function n(i) {
              return i >= e.$TAB && i <= e.$SPACE || i == e.$NBSP;
            }
            e.isWhitespace = n;
            function t3(i) {
              return e.$0 <= i && i <= e.$9;
            }
            e.isDigit = t3;
            function s(i) {
              return i >= e.$a && i <= e.$z || i >= e.$A && i <= e.$Z;
            }
            e.isAsciiLetter = s;
            function a(i) {
              return i >= e.$a && i <= e.$f || i >= e.$A && i <= e.$F || t3(i);
            }
            e.isAsciiHexDigit = a;
            function r(i) {
              return i === e.$LF || i === e.$CR;
            }
            e.isNewLine = r;
            function u(i) {
              return e.$0 <= i && i <= e.$7;
            }
            e.isOctalDigit = u;
          } }), Jd = ee({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = class {
              constructor(s, a, r) {
                this.filePath = s, this.name = a, this.members = r;
              }
              assertNoMembers() {
                if (this.members.length)
                  throw new Error(`Illegal state: symbol without members expected, but got ${JSON.stringify(this)}.`);
              }
            };
            e.StaticSymbol = n;
            var t3 = class {
              constructor() {
                this.cache = /* @__PURE__ */ new Map();
              }
              get(s, a, r) {
                r = r || [];
                let u = r.length ? `.${r.join(".")}` : "", i = `"${s}".${a}${u}`, l = this.cache.get(i);
                return l || (l = new n(s, a, r), this.cache.set(i, l)), l;
              }
            };
            e.StaticSymbolCache = t3;
          } }), zd = ee({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = /-+([a-z0-9])/g;
            function t3(o) {
              return o.replace(n, function() {
                for (var d = arguments.length, C = new Array(d), _ = 0; _ < d; _++)
                  C[_] = arguments[_];
                return C[1].toUpperCase();
              });
            }
            e.dashCaseToCamelCase = t3;
            function s(o, d) {
              return r(o, ":", d);
            }
            e.splitAtColon = s;
            function a(o, d) {
              return r(o, ".", d);
            }
            e.splitAtPeriod = a;
            function r(o, d, C) {
              let _ = o.indexOf(d);
              return _ == -1 ? C : [o.slice(0, _).trim(), o.slice(_ + 1).trim()];
            }
            function u(o, d, C) {
              return Array.isArray(o) ? d.visitArray(o, C) : F(o) ? d.visitStringMap(o, C) : o == null || typeof o == "string" || typeof o == "number" || typeof o == "boolean" ? d.visitPrimitive(o, C) : d.visitOther(o, C);
            }
            e.visitValue = u;
            function i(o) {
              return o != null;
            }
            e.isDefined = i;
            function l(o) {
              return o === void 0 ? null : o;
            }
            e.noUndefined = l;
            var c = class {
              visitArray(o, d) {
                return o.map((C) => u(C, this, d));
              }
              visitStringMap(o, d) {
                let C = {};
                return Object.keys(o).forEach((_) => {
                  C[_] = u(o[_], this, d);
                }), C;
              }
              visitPrimitive(o, d) {
                return o;
              }
              visitOther(o, d) {
                return o;
              }
            };
            e.ValueTransformer = c, e.SyncAsync = { assertSync: (o) => {
              if (P(o))
                throw new Error("Illegal state: value cannot be a promise");
              return o;
            }, then: (o, d) => P(o) ? o.then(d) : d(o), all: (o) => o.some(P) ? Promise.all(o) : o };
            function y(o) {
              throw new Error(`Internal Error: ${o}`);
            }
            e.error = y;
            function h(o, d) {
              let C = Error(o);
              return C[g] = true, d && (C[p] = d), C;
            }
            e.syntaxError = h;
            var g = "ngSyntaxError", p = "ngParseErrors";
            function D(o) {
              return o[g];
            }
            e.isSyntaxError = D;
            function v(o) {
              return o[p] || [];
            }
            e.getParseErrors = v;
            function w(o) {
              return o.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
            }
            e.escapeRegExp = w;
            var T = Object.getPrototypeOf({});
            function F(o) {
              return typeof o == "object" && o !== null && Object.getPrototypeOf(o) === T;
            }
            function A(o) {
              let d = "";
              for (let C = 0; C < o.length; C++) {
                let _ = o.charCodeAt(C);
                if (_ >= 55296 && _ <= 56319 && o.length > C + 1) {
                  let b = o.charCodeAt(C + 1);
                  b >= 56320 && b <= 57343 && (C++, _ = (_ - 55296 << 10) + b - 56320 + 65536);
                }
                _ <= 127 ? d += String.fromCharCode(_) : _ <= 2047 ? d += String.fromCharCode(_ >> 6 & 31 | 192, _ & 63 | 128) : _ <= 65535 ? d += String.fromCharCode(_ >> 12 | 224, _ >> 6 & 63 | 128, _ & 63 | 128) : _ <= 2097151 && (d += String.fromCharCode(_ >> 18 & 7 | 240, _ >> 12 & 63 | 128, _ >> 6 & 63 | 128, _ & 63 | 128));
              }
              return d;
            }
            e.utf8Encode = A;
            function B(o) {
              if (typeof o == "string")
                return o;
              if (o instanceof Array)
                return "[" + o.map(B).join(", ") + "]";
              if (o == null)
                return "" + o;
              if (o.overriddenName)
                return `${o.overriddenName}`;
              if (o.name)
                return `${o.name}`;
              if (!o.toString)
                return "object";
              let d = o.toString();
              if (d == null)
                return "" + d;
              let C = d.indexOf(`
`);
              return C === -1 ? d : d.substring(0, C);
            }
            e.stringify = B;
            function I(o) {
              return typeof o == "function" && o.hasOwnProperty("__forward_ref__") ? o() : o;
            }
            e.resolveForwardRef = I;
            function P(o) {
              return !!o && typeof o.then == "function";
            }
            e.isPromise = P;
            var R = class {
              constructor(o) {
                this.full = o;
                let d = o.split(".");
                this.major = d[0], this.minor = d[1], this.patch = d.slice(2).join(".");
              }
            };
            e.Version = R;
            var f = typeof window < "u" && window, x = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, m = typeof globalThis < "u" && globalThis, E = m || f || x;
            e.global = E;
          } }), Xd = ee({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Jd(), t3 = zd(), s = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
            function a(C) {
              return C.replace(/\W/g, "_");
            }
            e.sanitizeIdentifier = a;
            var r = 0;
            function u(C) {
              if (!C || !C.reference)
                return null;
              let _ = C.reference;
              if (_ instanceof n.StaticSymbol)
                return _.name;
              if (_.__anonymousType)
                return _.__anonymousType;
              let b = t3.stringify(_);
              return b.indexOf("(") >= 0 ? (b = `anonymous_${r++}`, _.__anonymousType = b) : b = a(b), b;
            }
            e.identifierName = u;
            function i(C) {
              let _ = C.reference;
              return _ instanceof n.StaticSymbol ? _.filePath : `./${t3.stringify(_)}`;
            }
            e.identifierModuleUrl = i;
            function l(C, _) {
              return `View_${u({ reference: C })}_${_}`;
            }
            e.viewClassName = l;
            function c(C) {
              return `RenderType_${u({ reference: C })}`;
            }
            e.rendererTypeName = c;
            function y(C) {
              return `HostView_${u({ reference: C })}`;
            }
            e.hostViewClassName = y;
            function h(C) {
              return `${u({ reference: C })}NgFactory`;
            }
            e.componentFactoryName = h;
            var g;
            (function(C) {
              C[C.Pipe = 0] = "Pipe", C[C.Directive = 1] = "Directive", C[C.NgModule = 2] = "NgModule", C[C.Injectable = 3] = "Injectable";
            })(g = e.CompileSummaryKind || (e.CompileSummaryKind = {}));
            function p(C) {
              return C.value != null ? a(C.value) : u(C.identifier);
            }
            e.tokenName = p;
            function D(C) {
              return C.identifier != null ? C.identifier.reference : C.value;
            }
            e.tokenReference = D;
            var v = class {
              constructor() {
                let { moduleUrl: C, styles: _, styleUrls: b } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.moduleUrl = C || null, this.styles = P(_), this.styleUrls = P(b);
              }
            };
            e.CompileStylesheetMetadata = v;
            var w = class {
              constructor(C) {
                let { encapsulation: _, template: b, templateUrl: N, htmlAst: k, styles: $, styleUrls: M, externalStylesheets: q, animations: J, ngContentSelectors: L, interpolation: Y, isInline: V, preserveWhitespaces: O } = C;
                if (this.encapsulation = _, this.template = b, this.templateUrl = N, this.htmlAst = k, this.styles = P($), this.styleUrls = P(M), this.externalStylesheets = P(q), this.animations = J ? f(J) : [], this.ngContentSelectors = L || [], Y && Y.length != 2)
                  throw new Error("'interpolation' should have a start and an end symbol.");
                this.interpolation = Y, this.isInline = V, this.preserveWhitespaces = O;
              }
              toSummary() {
                return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
              }
            };
            e.CompileTemplateMetadata = w;
            var T = class {
              static create(C) {
                let { isHost: _, type: b, isComponent: N, selector: k, exportAs: $, changeDetection: M, inputs: q, outputs: J, host: L, providers: Y, viewProviders: V, queries: O, guards: K, viewQueries: se, entryComponents: Q, template: le, componentViewType: W, rendererType: X, componentFactory: oe } = C, ae = {}, Ae = {}, z = {};
                L != null && Object.keys(L).forEach((ne) => {
                  let fe = L[ne], ge = ne.match(s);
                  ge === null ? z[ne] = fe : ge[1] != null ? Ae[ge[1]] = fe : ge[2] != null && (ae[ge[2]] = fe);
                });
                let H = {};
                q != null && q.forEach((ne) => {
                  let fe = t3.splitAtColon(ne, [ne, ne]);
                  H[fe[0]] = fe[1];
                });
                let Z = {};
                return J != null && J.forEach((ne) => {
                  let fe = t3.splitAtColon(ne, [ne, ne]);
                  Z[fe[0]] = fe[1];
                }), new T({ isHost: _, type: b, isComponent: !!N, selector: k, exportAs: $, changeDetection: M, inputs: H, outputs: Z, hostListeners: ae, hostProperties: Ae, hostAttributes: z, providers: Y, viewProviders: V, queries: O, guards: K, viewQueries: se, entryComponents: Q, template: le, componentViewType: W, rendererType: X, componentFactory: oe });
              }
              constructor(C) {
                let { isHost: _, type: b, isComponent: N, selector: k, exportAs: $, changeDetection: M, inputs: q, outputs: J, hostListeners: L, hostProperties: Y, hostAttributes: V, providers: O, viewProviders: K, queries: se, guards: Q, viewQueries: le, entryComponents: W, template: X, componentViewType: oe, rendererType: ae, componentFactory: Ae } = C;
                this.isHost = !!_, this.type = b, this.isComponent = N, this.selector = k, this.exportAs = $, this.changeDetection = M, this.inputs = q, this.outputs = J, this.hostListeners = L, this.hostProperties = Y, this.hostAttributes = V, this.providers = P(O), this.viewProviders = P(K), this.queries = P(se), this.guards = Q, this.viewQueries = P(le), this.entryComponents = P(W), this.template = X, this.componentViewType = oe, this.rendererType = ae, this.componentFactory = Ae;
              }
              toSummary() {
                return { summaryKind: g.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
              }
            };
            e.CompileDirectiveMetadata = T;
            var F = class {
              constructor(C) {
                let { type: _, name: b, pure: N } = C;
                this.type = _, this.name = b, this.pure = !!N;
              }
              toSummary() {
                return { summaryKind: g.Pipe, type: this.type, name: this.name, pure: this.pure };
              }
            };
            e.CompilePipeMetadata = F;
            var A = class {
            };
            e.CompileShallowModuleMetadata = A;
            var B = class {
              constructor(C) {
                let { type: _, providers: b, declaredDirectives: N, exportedDirectives: k, declaredPipes: $, exportedPipes: M, entryComponents: q, bootstrapComponents: J, importedModules: L, exportedModules: Y, schemas: V, transitiveModule: O, id: K } = C;
                this.type = _ || null, this.declaredDirectives = P(N), this.exportedDirectives = P(k), this.declaredPipes = P($), this.exportedPipes = P(M), this.providers = P(b), this.entryComponents = P(q), this.bootstrapComponents = P(J), this.importedModules = P(L), this.exportedModules = P(Y), this.schemas = P(V), this.id = K || null, this.transitiveModule = O || null;
              }
              toSummary() {
                let C = this.transitiveModule;
                return { summaryKind: g.NgModule, type: this.type, entryComponents: C.entryComponents, providers: C.providers, modules: C.modules, exportedDirectives: C.exportedDirectives, exportedPipes: C.exportedPipes };
              }
            };
            e.CompileNgModuleMetadata = B;
            var I = class {
              constructor() {
                this.directivesSet = /* @__PURE__ */ new Set(), this.directives = [], this.exportedDirectivesSet = /* @__PURE__ */ new Set(), this.exportedDirectives = [], this.pipesSet = /* @__PURE__ */ new Set(), this.pipes = [], this.exportedPipesSet = /* @__PURE__ */ new Set(), this.exportedPipes = [], this.modulesSet = /* @__PURE__ */ new Set(), this.modules = [], this.entryComponentsSet = /* @__PURE__ */ new Set(), this.entryComponents = [], this.providers = [];
              }
              addProvider(C, _) {
                this.providers.push({ provider: C, module: _ });
              }
              addDirective(C) {
                this.directivesSet.has(C.reference) || (this.directivesSet.add(C.reference), this.directives.push(C));
              }
              addExportedDirective(C) {
                this.exportedDirectivesSet.has(C.reference) || (this.exportedDirectivesSet.add(C.reference), this.exportedDirectives.push(C));
              }
              addPipe(C) {
                this.pipesSet.has(C.reference) || (this.pipesSet.add(C.reference), this.pipes.push(C));
              }
              addExportedPipe(C) {
                this.exportedPipesSet.has(C.reference) || (this.exportedPipesSet.add(C.reference), this.exportedPipes.push(C));
              }
              addModule(C) {
                this.modulesSet.has(C.reference) || (this.modulesSet.add(C.reference), this.modules.push(C));
              }
              addEntryComponent(C) {
                this.entryComponentsSet.has(C.componentType) || (this.entryComponentsSet.add(C.componentType), this.entryComponents.push(C));
              }
            };
            e.TransitiveCompileNgModuleMetadata = I;
            function P(C) {
              return C || [];
            }
            var R = class {
              constructor(C, _) {
                let { useClass: b, useValue: N, useExisting: k, useFactory: $, deps: M, multi: q } = _;
                this.token = C, this.useClass = b || null, this.useValue = N, this.useExisting = k, this.useFactory = $ || null, this.dependencies = M || null, this.multi = !!q;
              }
            };
            e.ProviderMeta = R;
            function f(C) {
              return C.reduce((_, b) => {
                let N = Array.isArray(b) ? f(b) : b;
                return _.concat(N);
              }, []);
            }
            e.flatten = f;
            function x(C) {
              return C.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
            }
            function m(C, _, b) {
              let N;
              return b.isInline ? _.type.reference instanceof n.StaticSymbol ? N = `${_.type.reference.filePath}.${_.type.reference.name}.html` : N = `${u(C)}/${u(_.type)}.html` : N = b.templateUrl, _.type.reference instanceof n.StaticSymbol ? N : x(N);
            }
            e.templateSourceUrl = m;
            function E(C, _) {
              let b = C.moduleUrl.split(/\/\\/g), N = b[b.length - 1];
              return x(`css/${_}${N}.ngstyle.js`);
            }
            e.sharedStylesheetJitUrl = E;
            function o(C) {
              return x(`${u(C.type)}/module.ngfactory.js`);
            }
            e.ngModuleJitUrl = o;
            function d(C, _) {
              return x(`${u(C)}/${u(_.type)}.ngfactory.js`);
            }
            e.templateJitUrl = d;
          } }), Kd = ee({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Ud(), t3 = Xd(), s = class {
              constructor(y, h, g, p) {
                this.file = y, this.offset = h, this.line = g, this.col = p;
              }
              toString() {
                return this.offset != null ? `${this.file.url}@${this.line}:${this.col}` : this.file.url;
              }
              moveBy(y) {
                let h = this.file.content, g = h.length, p = this.offset, D = this.line, v = this.col;
                for (; p > 0 && y < 0; )
                  if (p--, y++, h.charCodeAt(p) == n.$LF) {
                    D--;
                    let T = h.substr(0, p - 1).lastIndexOf(String.fromCharCode(n.$LF));
                    v = T > 0 ? p - T : p;
                  } else
                    v--;
                for (; p < g && y > 0; ) {
                  let w = h.charCodeAt(p);
                  p++, y--, w == n.$LF ? (D++, v = 0) : v++;
                }
                return new s(this.file, p, D, v);
              }
              getContext(y, h) {
                let g = this.file.content, p = this.offset;
                if (p != null) {
                  p > g.length - 1 && (p = g.length - 1);
                  let D = p, v = 0, w = 0;
                  for (; v < y && p > 0 && (p--, v++, !(g[p] == `
` && ++w == h)); )
                    ;
                  for (v = 0, w = 0; v < y && D < g.length - 1 && (D++, v++, !(g[D] == `
` && ++w == h)); )
                    ;
                  return { before: g.substring(p, this.offset), after: g.substring(this.offset, D + 1) };
                }
                return null;
              }
            };
            e.ParseLocation = s;
            var a = class {
              constructor(y, h) {
                this.content = y, this.url = h;
              }
            };
            e.ParseSourceFile = a;
            var r = class {
              constructor(y, h) {
                let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                this.start = y, this.end = h, this.details = g;
              }
              toString() {
                return this.start.file.content.substring(this.start.offset, this.end.offset);
              }
            };
            e.ParseSourceSpan = r, e.EMPTY_PARSE_LOCATION = new s(new a("", ""), 0, 0, 0), e.EMPTY_SOURCE_SPAN = new r(e.EMPTY_PARSE_LOCATION, e.EMPTY_PARSE_LOCATION);
            var u;
            (function(y) {
              y[y.WARNING = 0] = "WARNING", y[y.ERROR = 1] = "ERROR";
            })(u = e.ParseErrorLevel || (e.ParseErrorLevel = {}));
            var i = class {
              constructor(y, h) {
                let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : u.ERROR;
                this.span = y, this.msg = h, this.level = g;
              }
              contextualMessage() {
                let y = this.span.start.getContext(100, 3);
                return y ? `${this.msg} ("${y.before}[${u[this.level]} ->]${y.after}")` : this.msg;
              }
              toString() {
                let y = this.span.details ? `, ${this.span.details}` : "";
                return `${this.contextualMessage()}: ${this.span.start}${y}`;
              }
            };
            e.ParseError = i;
            function l(y, h) {
              let g = t3.identifierModuleUrl(h), p = g != null ? `in ${y} ${t3.identifierName(h)} in ${g}` : `in ${y} ${t3.identifierName(h)}`, D = new a("", p);
              return new r(new s(D, -1, -1, -1), new s(D, -1, -1, -1));
            }
            e.typeSourceSpan = l;
            function c(y, h, g) {
              let p = `in ${y} ${h} in ${g}`, D = new a("", p);
              return new r(new s(D, -1, -1, -1), new s(D, -1, -1, -1));
            }
            e.r3JitTypeSourceSpan = c;
          } }), Yd = ee({ "src/language-html/print-preprocess.js"(e, n) {
            "use strict";
            re();
            var { ParseSourceSpan: t3 } = Kd(), { htmlTrim: s, getLeadingAndTrailingHtmlWhitespace: a, hasHtmlWhitespace: r, canHaveInterpolation: u, getNodeCssStyleDisplay: i, isDanglingSpaceSensitiveNode: l, isIndentationSensitiveNode: c, isLeadingSpaceSensitiveNode: y, isTrailingSpaceSensitiveNode: h, isWhitespaceSensitiveNode: g, isVueScriptTag: p } = Mt(), D = [w, T, A, I, P, x, R, f, m, B, E];
            function v(o, d) {
              for (let C of D)
                C(o, d);
              return o;
            }
            function w(o) {
              o.walk((d) => {
                if (d.type === "element" && d.tagDefinition.ignoreFirstLf && d.children.length > 0 && d.children[0].type === "text" && d.children[0].value[0] === `
`) {
                  let C = d.children[0];
                  C.value.length === 1 ? d.removeChild(C) : C.value = C.value.slice(1);
                }
              });
            }
            function T(o) {
              let d = (C) => C.type === "element" && C.prev && C.prev.type === "ieConditionalStartComment" && C.prev.sourceSpan.end.offset === C.startSourceSpan.start.offset && C.firstChild && C.firstChild.type === "ieConditionalEndComment" && C.firstChild.sourceSpan.start.offset === C.startSourceSpan.end.offset;
              o.walk((C) => {
                if (C.children)
                  for (let _ = 0; _ < C.children.length; _++) {
                    let b = C.children[_];
                    if (!d(b))
                      continue;
                    let N = b.prev, k = b.firstChild;
                    C.removeChild(N), _--;
                    let $ = new t3(N.sourceSpan.start, k.sourceSpan.end), M = new t3($.start, b.sourceSpan.end);
                    b.condition = N.condition, b.sourceSpan = M, b.startSourceSpan = $, b.removeChild(k);
                  }
              });
            }
            function F(o, d, C) {
              o.walk((_) => {
                if (_.children)
                  for (let b = 0; b < _.children.length; b++) {
                    let N = _.children[b];
                    if (N.type !== "text" && !d(N))
                      continue;
                    N.type !== "text" && (N.type = "text", N.value = C(N));
                    let k = N.prev;
                    !k || k.type !== "text" || (k.value += N.value, k.sourceSpan = new t3(k.sourceSpan.start, N.sourceSpan.end), _.removeChild(N), b--);
                  }
              });
            }
            function A(o) {
              return F(o, (d) => d.type === "cdata", (d) => `<![CDATA[${d.value}]]>`);
            }
            function B(o) {
              let d = (C) => C.type === "element" && C.attrs.length === 0 && C.children.length === 1 && C.firstChild.type === "text" && !r(C.children[0].value) && !C.firstChild.hasLeadingSpaces && !C.firstChild.hasTrailingSpaces && C.isLeadingSpaceSensitive && !C.hasLeadingSpaces && C.isTrailingSpaceSensitive && !C.hasTrailingSpaces && C.prev && C.prev.type === "text" && C.next && C.next.type === "text";
              o.walk((C) => {
                if (C.children)
                  for (let _ = 0; _ < C.children.length; _++) {
                    let b = C.children[_];
                    if (!d(b))
                      continue;
                    let N = b.prev, k = b.next;
                    N.value += `<${b.rawName}>` + b.firstChild.value + `</${b.rawName}>` + k.value, N.sourceSpan = new t3(N.sourceSpan.start, k.sourceSpan.end), N.isTrailingSpaceSensitive = k.isTrailingSpaceSensitive, N.hasTrailingSpaces = k.hasTrailingSpaces, C.removeChild(b), _--, C.removeChild(k);
                  }
              });
            }
            function I(o, d) {
              if (d.parser === "html")
                return;
              let C = /{{(.+?)}}/s;
              o.walk((_) => {
                if (!!u(_))
                  for (let b of _.children) {
                    if (b.type !== "text")
                      continue;
                    let N = b.sourceSpan.start, k = null, $ = b.value.split(C);
                    for (let M = 0; M < $.length; M++, N = k) {
                      let q = $[M];
                      if (M % 2 === 0) {
                        k = N.moveBy(q.length), q.length > 0 && _.insertChildBefore(b, { type: "text", value: q, sourceSpan: new t3(N, k) });
                        continue;
                      }
                      k = N.moveBy(q.length + 4), _.insertChildBefore(b, { type: "interpolation", sourceSpan: new t3(N, k), children: q.length === 0 ? [] : [{ type: "text", value: q, sourceSpan: new t3(N.moveBy(2), k.moveBy(-2)) }] });
                    }
                    _.removeChild(b);
                  }
              });
            }
            function P(o) {
              o.walk((d) => {
                if (!d.children)
                  return;
                if (d.children.length === 0 || d.children.length === 1 && d.children[0].type === "text" && s(d.children[0].value).length === 0) {
                  d.hasDanglingSpaces = d.children.length > 0, d.children = [];
                  return;
                }
                let C = g(d), _ = c(d);
                if (!C)
                  for (let b = 0; b < d.children.length; b++) {
                    let N = d.children[b];
                    if (N.type !== "text")
                      continue;
                    let { leadingWhitespace: k, text: $, trailingWhitespace: M } = a(N.value), q = N.prev, J = N.next;
                    $ ? (N.value = $, N.sourceSpan = new t3(N.sourceSpan.start.moveBy(k.length), N.sourceSpan.end.moveBy(-M.length)), k && (q && (q.hasTrailingSpaces = true), N.hasLeadingSpaces = true), M && (N.hasTrailingSpaces = true, J && (J.hasLeadingSpaces = true))) : (d.removeChild(N), b--, (k || M) && (q && (q.hasTrailingSpaces = true), J && (J.hasLeadingSpaces = true)));
                  }
                d.isWhitespaceSensitive = C, d.isIndentationSensitive = _;
              });
            }
            function R(o) {
              o.walk((d) => {
                d.isSelfClosing = !d.children || d.type === "element" && (d.tagDefinition.isVoid || d.startSourceSpan === d.endSourceSpan);
              });
            }
            function f(o, d) {
              o.walk((C) => {
                C.type === "element" && (C.hasHtmComponentClosingTag = C.endSourceSpan && /^<\s*\/\s*\/\s*>$/.test(d.originalText.slice(C.endSourceSpan.start.offset, C.endSourceSpan.end.offset)));
              });
            }
            function x(o, d) {
              o.walk((C) => {
                C.cssDisplay = i(C, d);
              });
            }
            function m(o, d) {
              o.walk((C) => {
                let { children: _ } = C;
                if (!!_) {
                  if (_.length === 0) {
                    C.isDanglingSpaceSensitive = l(C);
                    return;
                  }
                  for (let b of _)
                    b.isLeadingSpaceSensitive = y(b, d), b.isTrailingSpaceSensitive = h(b, d);
                  for (let b = 0; b < _.length; b++) {
                    let N = _[b];
                    N.isLeadingSpaceSensitive = (b === 0 || N.prev.isTrailingSpaceSensitive) && N.isLeadingSpaceSensitive, N.isTrailingSpaceSensitive = (b === _.length - 1 || N.next.isLeadingSpaceSensitive) && N.isTrailingSpaceSensitive;
                  }
                }
              });
            }
            function E(o, d) {
              if (d.parser === "vue") {
                let C = o.children.find((b) => p(b, d));
                if (!C)
                  return;
                let { lang: _ } = C.attrMap;
                (_ === "ts" || _ === "typescript") && (d.__should_parse_vue_template_with_ts = true);
              }
            }
            n.exports = v;
          } }), Qd = ee({ "src/language-html/pragma.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(a);
            }
            function s(a) {
              return `<!-- @format -->

` + a.replace(/^\s*\n/, "");
            }
            n.exports = { hasPragma: t3, insertPragma: s };
          } }), Qn = ee({ "src/language-html/loc.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return a.sourceSpan.start.offset;
            }
            function s(a) {
              return a.sourceSpan.end.offset;
            }
            n.exports = { locStart: t3, locEnd: s };
          } }), rr = ee({ "src/language-html/print/tag.js"(e, n) {
            "use strict";
            re();
            var t3 = Yt(), { isNonEmptyArray: s } = Ge(), { builders: { indent: a, join: r, line: u, softline: i, hardline: l }, utils: { replaceTextEndOfLine: c } } = qe(), { locStart: y, locEnd: h } = Qn(), { isTextLikeNode: g, getLastDescendant: p, isPreLikeNode: D, hasPrettierIgnore: v, shouldPreserveContent: w, isVueSfcBlock: T } = Mt();
            function F(L, Y) {
              return [L.isSelfClosing ? "" : A(L, Y), B(L, Y)];
            }
            function A(L, Y) {
              return L.lastChild && o(L.lastChild) ? "" : [I(L, Y), R(L, Y)];
            }
            function B(L, Y) {
              return (L.next ? m(L.next) : E(L.parent)) ? "" : [f(L, Y), P(L, Y)];
            }
            function I(L, Y) {
              return E(L) ? f(L.lastChild, Y) : "";
            }
            function P(L, Y) {
              return o(L) ? R(L.parent, Y) : d(L) ? q(L.next) : "";
            }
            function R(L, Y) {
              if (t3(!L.isSelfClosing), x(L, Y))
                return "";
              switch (L.type) {
                case "ieConditionalComment":
                  return "<!";
                case "element":
                  if (L.hasHtmComponentClosingTag)
                    return "<//";
                default:
                  return `</${L.rawName}`;
              }
            }
            function f(L, Y) {
              if (x(L, Y))
                return "";
              switch (L.type) {
                case "ieConditionalComment":
                case "ieConditionalEndComment":
                  return "[endif]-->";
                case "ieConditionalStartComment":
                  return "]><!-->";
                case "interpolation":
                  return "}}";
                case "element":
                  if (L.isSelfClosing)
                    return "/>";
                default:
                  return ">";
              }
            }
            function x(L, Y) {
              return !L.isSelfClosing && !L.endSourceSpan && (v(L) || w(L.parent, Y));
            }
            function m(L) {
              return L.prev && L.prev.type !== "docType" && !g(L.prev) && L.isLeadingSpaceSensitive && !L.hasLeadingSpaces;
            }
            function E(L) {
              return L.lastChild && L.lastChild.isTrailingSpaceSensitive && !L.lastChild.hasTrailingSpaces && !g(p(L.lastChild)) && !D(L);
            }
            function o(L) {
              return !L.next && !L.hasTrailingSpaces && L.isTrailingSpaceSensitive && g(p(L));
            }
            function d(L) {
              return L.next && !g(L.next) && g(L) && L.isTrailingSpaceSensitive && !L.hasTrailingSpaces;
            }
            function C(L) {
              let Y = L.trim().match(/^prettier-ignore-attribute(?:\s+(.+))?$/s);
              return Y ? Y[1] ? Y[1].split(/\s+/) : true : false;
            }
            function _(L) {
              return !L.prev && L.isLeadingSpaceSensitive && !L.hasLeadingSpaces;
            }
            function b(L, Y, V) {
              let O = L.getValue();
              if (!s(O.attrs))
                return O.isSelfClosing ? " " : "";
              let K = O.prev && O.prev.type === "comment" && C(O.prev.value), se = typeof K == "boolean" ? () => K : Array.isArray(K) ? (ae) => K.includes(ae.rawName) : () => false, Q = L.map((ae) => {
                let Ae = ae.getValue();
                return se(Ae) ? c(Y.originalText.slice(y(Ae), h(Ae))) : V();
              }, "attrs"), le = O.type === "element" && O.fullName === "script" && O.attrs.length === 1 && O.attrs[0].fullName === "src" && O.children.length === 0, X = Y.singleAttributePerLine && O.attrs.length > 1 && !T(O, Y) ? l : u, oe = [a([le ? " " : u, r(X, Q)])];
              return O.firstChild && _(O.firstChild) || O.isSelfClosing && E(O.parent) || le ? oe.push(O.isSelfClosing ? " " : "") : oe.push(Y.bracketSameLine ? O.isSelfClosing ? " " : "" : O.isSelfClosing ? u : i), oe;
            }
            function N(L) {
              return L.firstChild && _(L.firstChild) ? "" : J(L);
            }
            function k(L, Y, V) {
              let O = L.getValue();
              return [$(O, Y), b(L, Y, V), O.isSelfClosing ? "" : N(O)];
            }
            function $(L, Y) {
              return L.prev && d(L.prev) ? "" : [M(L, Y), q(L)];
            }
            function M(L, Y) {
              return _(L) ? J(L.parent) : m(L) ? f(L.prev, Y) : "";
            }
            function q(L) {
              switch (L.type) {
                case "ieConditionalComment":
                case "ieConditionalStartComment":
                  return `<!--[if ${L.condition}`;
                case "ieConditionalEndComment":
                  return "<!--<!";
                case "interpolation":
                  return "{{";
                case "docType":
                  return "<!DOCTYPE";
                case "element":
                  if (L.condition)
                    return `<!--[if ${L.condition}]><!--><${L.rawName}`;
                default:
                  return `<${L.rawName}`;
              }
            }
            function J(L) {
              switch (t3(!L.isSelfClosing), L.type) {
                case "ieConditionalComment":
                  return "]>";
                case "element":
                  if (L.condition)
                    return "><!--<![endif]-->";
                default:
                  return ">";
              }
            }
            n.exports = { printClosingTag: F, printClosingTagStart: A, printClosingTagStartMarker: R, printClosingTagEndMarker: f, printClosingTagSuffix: P, printClosingTagEnd: B, needsToBorrowLastChildClosingTagEndMarker: E, needsToBorrowParentClosingTagStartMarker: o, needsToBorrowPrevClosingTagEndMarker: m, printOpeningTag: k, printOpeningTagStart: $, printOpeningTagPrefix: M, printOpeningTagStartMarker: q, printOpeningTagEndMarker: J, needsToBorrowNextOpeningTagStartMarker: d, needsToBorrowParentOpeningTagEndMarker: _ };
          } }), Zd = ee({ "node_modules/parse-srcset/src/parse-srcset.js"(e, n) {
            re(), function(t3, s) {
              typeof define == "function" && define.amd ? define([], s) : typeof n == "object" && n.exports ? n.exports = s() : t3.parseSrcset = s();
            }(e, function() {
              return function(t3, s) {
                var a = s && s.logger || console;
                function r(R) {
                  return R === " " || R === "	" || R === `
` || R === "\f" || R === "\r";
                }
                function u(R) {
                  var f, x = R.exec(t3.substring(A));
                  if (x)
                    return f = x[0], A += f.length, f;
                }
                for (var i = t3.length, l = /^[ \t\n\r\u000c]+/, c = /^[, \t\n\r\u000c]+/, y = /^[^ \t\n\r\u000c]+/, h = /[,]+$/, g = /^\d+$/, p = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, D, v, w, T, F, A = 0, B = []; ; ) {
                  if (u(c), A >= i)
                    return B;
                  D = u(y), v = [], D.slice(-1) === "," ? (D = D.replace(h, ""), P()) : I();
                }
                function I() {
                  for (u(l), w = "", T = "in descriptor"; ; ) {
                    if (F = t3.charAt(A), T === "in descriptor")
                      if (r(F))
                        w && (v.push(w), w = "", T = "after descriptor");
                      else if (F === ",") {
                        A += 1, w && v.push(w), P();
                        return;
                      } else if (F === "(")
                        w = w + F, T = "in parens";
                      else if (F === "") {
                        w && v.push(w), P();
                        return;
                      } else
                        w = w + F;
                    else if (T === "in parens")
                      if (F === ")")
                        w = w + F, T = "in descriptor";
                      else if (F === "") {
                        v.push(w), P();
                        return;
                      } else
                        w = w + F;
                    else if (T === "after descriptor" && !r(F))
                      if (F === "") {
                        P();
                        return;
                      } else
                        T = "in descriptor", A -= 1;
                    A += 1;
                  }
                }
                function P() {
                  var R = false, f, x, m, E, o = {}, d, C, _, b, N;
                  for (E = 0; E < v.length; E++)
                    d = v[E], C = d[d.length - 1], _ = d.substring(0, d.length - 1), b = parseInt(_, 10), N = parseFloat(_), g.test(_) && C === "w" ? ((f || x) && (R = true), b === 0 ? R = true : f = b) : p.test(_) && C === "x" ? ((f || x || m) && (R = true), N < 0 ? R = true : x = N) : g.test(_) && C === "h" ? ((m || x) && (R = true), b === 0 ? R = true : m = b) : R = true;
                  R ? a && a.error && a.error("Invalid srcset descriptor found in '" + t3 + "' at '" + d + "'.") : (o.url = D, f && (o.w = f), x && (o.d = x), m && (o.h = m), B.push(o));
                }
              };
            });
          } }), eg = ee({ "src/language-html/syntax-attribute.js"(e, n) {
            "use strict";
            re();
            var t3 = Zd(), { builders: { ifBreak: s, join: a, line: r } } = qe();
            function u(l) {
              let c = t3(l, { logger: { error(I) {
                throw new Error(I);
              } } }), y = c.some((I) => {
                let { w: P } = I;
                return P;
              }), h = c.some((I) => {
                let { h: P } = I;
                return P;
              }), g = c.some((I) => {
                let { d: P } = I;
                return P;
              });
              if (y + h + g > 1)
                throw new Error("Mixed descriptor in srcset is not supported");
              let p = y ? "w" : h ? "h" : "d", D = y ? "w" : h ? "h" : "x", v = (I) => Math.max(...I), w = c.map((I) => I.url), T = v(w.map((I) => I.length)), F = c.map((I) => I[p]).map((I) => I ? I.toString() : ""), A = F.map((I) => {
                let P = I.indexOf(".");
                return P === -1 ? I.length : P;
              }), B = v(A);
              return a([",", r], w.map((I, P) => {
                let R = [I], f = F[P];
                if (f) {
                  let x = T - I.length + 1, m = B - A[P], E = " ".repeat(x + m);
                  R.push(s(E, " "), f + D);
                }
                return R;
              }));
            }
            function i(l) {
              return l.trim().split(/\s+/).join(" ");
            }
            n.exports = { printImgSrcset: u, printClassNames: i };
          } }), tg = ee({ "src/language-html/syntax-vue.js"(e, n) {
            "use strict";
            re();
            var { builders: { group: t3 } } = qe();
            function s(i, l) {
              let { left: c, operator: y, right: h } = a(i);
              return [t3(l(`function _(${c}) {}`, { parser: "babel", __isVueForBindingLeft: true })), " ", y, " ", l(h, { parser: "__js_expression" }, { stripTrailingHardline: true })];
            }
            function a(i) {
              let l = /(.*?)\s+(in|of)\s+(.*)/s, c = /,([^,\]}]*)(?:,([^,\]}]*))?$/, y = /^\(|\)$/g, h = i.match(l);
              if (!h)
                return;
              let g = {};
              if (g.for = h[3].trim(), !g.for)
                return;
              let p = h[1].trim().replace(y, ""), D = p.match(c);
              D ? (g.alias = p.replace(c, ""), g.iterator1 = D[1].trim(), D[2] && (g.iterator2 = D[2].trim())) : g.alias = p;
              let v = [g.alias, g.iterator1, g.iterator2];
              if (!v.some((w, T) => !w && (T === 0 || v.slice(T + 1).some(Boolean))))
                return { left: v.filter(Boolean).join(","), operator: h[2], right: g.for };
            }
            function r(i, l) {
              return l(`function _(${i}) {}`, { parser: "babel", __isVueBindings: true });
            }
            function u(i) {
              let l = /^(?:[\w$]+|\([^)]*\))\s*=>|^function\s*\(/, c = /^[$A-Z_a-z][\w$]*(?:\.[$A-Z_a-z][\w$]*|\['[^']*']|\["[^"]*"]|\[\d+]|\[[$A-Z_a-z][\w$]*])*$/, y = i.trim();
              return l.test(y) || c.test(y);
            }
            n.exports = { isVueEventBindingExpression: u, printVueFor: s, printVueBindings: r };
          } }), fo = ee({ "src/language-html/get-node-content.js"(e, n) {
            "use strict";
            re();
            var { needsToBorrowParentClosingTagStartMarker: t3, printClosingTagStartMarker: s, needsToBorrowLastChildClosingTagEndMarker: a, printClosingTagEndMarker: r, needsToBorrowParentOpeningTagEndMarker: u, printOpeningTagEndMarker: i } = rr();
            function l(c, y) {
              let h = c.startSourceSpan.end.offset;
              c.firstChild && u(c.firstChild) && (h -= i(c).length);
              let g = c.endSourceSpan.start.offset;
              return c.lastChild && t3(c.lastChild) ? g += s(c, y).length : a(c) && (g -= r(c.lastChild, y).length), y.originalText.slice(h, g);
            }
            n.exports = l;
          } }), rg = ee({ "src/language-html/embed.js"(e, n) {
            "use strict";
            re();
            var { builders: { breakParent: t3, group: s, hardline: a, indent: r, line: u, fill: i, softline: l }, utils: { mapDoc: c, replaceTextEndOfLine: y } } = qe(), h = Kn(), { printClosingTag: g, printClosingTagSuffix: p, needsToBorrowPrevClosingTagEndMarker: D, printOpeningTagPrefix: v, printOpeningTag: w } = rr(), { printImgSrcset: T, printClassNames: F } = eg(), { printVueFor: A, printVueBindings: B, isVueEventBindingExpression: I } = tg(), { isScriptLikeTag: P, isVueNonHtmlBlock: R, inferScriptParser: f, htmlTrimPreserveIndentation: x, dedentString: m, unescapeQuoteEntities: E, isVueSlotAttribute: o, isVueSfcBindingsAttribute: d, getTextValueParts: C } = Mt(), _ = fo();
            function b(k, $, M) {
              let q = (Q) => new RegExp(Q.join("|")).test(k.fullName), J = () => E(k.value), L = false, Y = (Q, le) => {
                let W = Q.type === "NGRoot" ? Q.node.type === "NGMicrosyntax" && Q.node.body.length === 1 && Q.node.body[0].type === "NGMicrosyntaxExpression" ? Q.node.body[0].expression : Q.node : Q.type === "JsExpressionRoot" ? Q.node : Q;
                W && (W.type === "ObjectExpression" || W.type === "ArrayExpression" || le.parser === "__vue_expression" && (W.type === "TemplateLiteral" || W.type === "StringLiteral")) && (L = true);
              }, V = (Q) => s(Q), O = function(Q) {
                let le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return s([r([l, Q]), le ? l : ""]);
              }, K = (Q) => L ? V(Q) : O(Q), se = (Q, le) => $(Q, Object.assign({ __onHtmlBindingRoot: Y, __embeddedInHtml: true }, le));
              if (k.fullName === "srcset" && (k.parent.fullName === "img" || k.parent.fullName === "source"))
                return O(T(J()));
              if (k.fullName === "class" && !M.parentParser) {
                let Q = J();
                if (!Q.includes("{{"))
                  return F(Q);
              }
              if (k.fullName === "style" && !M.parentParser) {
                let Q = J();
                if (!Q.includes("{{"))
                  return O(se(Q, { parser: "css", __isHTMLStyleAttribute: true }));
              }
              if (M.parser === "vue") {
                if (k.fullName === "v-for")
                  return A(J(), se);
                if (o(k) || d(k, M))
                  return B(J(), se);
                let Q = ["^@", "^v-on:"], le = ["^:", "^v-bind:"], W = ["^v-"];
                if (q(Q)) {
                  let X = J(), oe = I(X) ? "__js_expression" : M.__should_parse_vue_template_with_ts ? "__vue_ts_event_binding" : "__vue_event_binding";
                  return K(se(X, { parser: oe }));
                }
                if (q(le))
                  return K(se(J(), { parser: "__vue_expression" }));
                if (q(W))
                  return K(se(J(), { parser: "__js_expression" }));
              }
              if (M.parser === "angular") {
                let Q = (z, H) => se(z, Object.assign(Object.assign({}, H), {}, { trailingComma: "none" })), le = ["^\\*"], W = ["^\\(.+\\)$", "^on-"], X = ["^\\[.+\\]$", "^bind(on)?-", "^ng-(if|show|hide|class|style)$"], oe = ["^i18n(-.+)?$"];
                if (q(W))
                  return K(Q(J(), { parser: "__ng_action" }));
                if (q(X))
                  return K(Q(J(), { parser: "__ng_binding" }));
                if (q(oe)) {
                  let z = J().trim();
                  return O(i(C(k, z)), !z.includes("@@"));
                }
                if (q(le))
                  return K(Q(J(), { parser: "__ng_directive" }));
                let ae = /{{(.+?)}}/s, Ae = J();
                if (ae.test(Ae)) {
                  let z = [];
                  for (let [H, Z] of Ae.split(ae).entries())
                    if (H % 2 === 0)
                      z.push(y(Z));
                    else
                      try {
                        z.push(s(["{{", r([u, Q(Z, { parser: "__ng_interpolation", __isInHtmlInterpolation: true })]), u, "}}"]));
                      } catch {
                        z.push("{{", y(Z), "}}");
                      }
                  return s(z);
                }
              }
              return null;
            }
            function N(k, $, M, q) {
              let J = k.getValue();
              switch (J.type) {
                case "element": {
                  if (P(J) || J.type === "interpolation")
                    return;
                  if (!J.isSelfClosing && R(J, q)) {
                    let L = f(J, q);
                    if (!L)
                      return;
                    let Y = _(J, q), V = /^\s*$/.test(Y), O = "";
                    return V || (O = M(x(Y), { parser: L, __embeddedInHtml: true }, { stripTrailingHardline: true }), V = O === ""), [v(J, q), s(w(k, q, $)), V ? "" : a, O, V ? "" : a, g(J, q), p(J, q)];
                  }
                  break;
                }
                case "text": {
                  if (P(J.parent)) {
                    let L = f(J.parent, q);
                    if (L) {
                      let Y = L === "markdown" ? m(J.value.replace(/^[^\S\n]*\n/, "")) : J.value, V = { parser: L, __embeddedInHtml: true };
                      if (q.parser === "html" && L === "babel") {
                        let O = "script", { attrMap: K } = J.parent;
                        K && (K.type === "module" || K.type === "text/babel" && K["data-type"] === "module") && (O = "module"), V.__babelSourceType = O;
                      }
                      return [t3, v(J, q), M(Y, V, { stripTrailingHardline: true }), p(J, q)];
                    }
                  } else if (J.parent.type === "interpolation") {
                    let L = { __isInHtmlInterpolation: true, __embeddedInHtml: true };
                    return q.parser === "angular" ? (L.parser = "__ng_interpolation", L.trailingComma = "none") : q.parser === "vue" ? L.parser = q.__should_parse_vue_template_with_ts ? "__vue_ts_expression" : "__vue_expression" : L.parser = "__js_expression", [r([u, M(J.value, L, { stripTrailingHardline: true })]), J.parent.next && D(J.parent.next) ? " " : u];
                  }
                  break;
                }
                case "attribute": {
                  if (!J.value)
                    break;
                  if (/^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(q.originalText.slice(J.valueSpan.start.offset, J.valueSpan.end.offset)))
                    return [J.rawName, "=", J.value];
                  if (q.parser === "lwc" && /^{.*}$/s.test(q.originalText.slice(J.valueSpan.start.offset, J.valueSpan.end.offset)))
                    return [J.rawName, "=", J.value];
                  let L = b(J, (Y, V) => M(Y, Object.assign({ __isInHtmlAttribute: true, __embeddedInHtml: true }, V), { stripTrailingHardline: true }), q);
                  if (L)
                    return [J.rawName, '="', s(c(L, (Y) => typeof Y == "string" ? Y.replace(/"/g, "&quot;") : Y)), '"'];
                  break;
                }
                case "front-matter":
                  return h(J, M);
              }
            }
            n.exports = N;
          } }), Do = ee({ "src/language-html/print/children.js"(e, n) {
            "use strict";
            re();
            var { builders: { breakParent: t3, group: s, ifBreak: a, line: r, softline: u, hardline: i }, utils: { replaceTextEndOfLine: l } } = qe(), { locStart: c, locEnd: y } = Qn(), { forceBreakChildren: h, forceNextEmptyLine: g, isTextLikeNode: p, hasPrettierIgnore: D, preferHardlineAsLeadingSpaces: v } = Mt(), { printOpeningTagPrefix: w, needsToBorrowNextOpeningTagStartMarker: T, printOpeningTagStartMarker: F, needsToBorrowPrevClosingTagEndMarker: A, printClosingTagEndMarker: B, printClosingTagSuffix: I, needsToBorrowParentClosingTagStartMarker: P } = rr();
            function R(m, E, o) {
              let d = m.getValue();
              return D(d) ? [w(d, E), ...l(E.originalText.slice(c(d) + (d.prev && T(d.prev) ? F(d).length : 0), y(d) - (d.next && A(d.next) ? B(d, E).length : 0))), I(d, E)] : o();
            }
            function f(m, E) {
              return p(m) && p(E) ? m.isTrailingSpaceSensitive ? m.hasTrailingSpaces ? v(E) ? i : r : "" : v(E) ? i : u : T(m) && (D(E) || E.firstChild || E.isSelfClosing || E.type === "element" && E.attrs.length > 0) || m.type === "element" && m.isSelfClosing && A(E) ? "" : !E.isLeadingSpaceSensitive || v(E) || A(E) && m.lastChild && P(m.lastChild) && m.lastChild.lastChild && P(m.lastChild.lastChild) ? i : E.hasLeadingSpaces ? r : u;
            }
            function x(m, E, o) {
              let d = m.getValue();
              if (h(d))
                return [t3, ...m.map((_) => {
                  let b = _.getValue(), N = b.prev ? f(b.prev, b) : "";
                  return [N ? [N, g(b.prev) ? i : ""] : "", R(_, E, o)];
                }, "children")];
              let C = d.children.map(() => Symbol(""));
              return m.map((_, b) => {
                let N = _.getValue();
                if (p(N)) {
                  if (N.prev && p(N.prev)) {
                    let Y = f(N.prev, N);
                    if (Y)
                      return g(N.prev) ? [i, i, R(_, E, o)] : [Y, R(_, E, o)];
                  }
                  return R(_, E, o);
                }
                let k = [], $ = [], M = [], q = [], J = N.prev ? f(N.prev, N) : "", L = N.next ? f(N, N.next) : "";
                return J && (g(N.prev) ? k.push(i, i) : J === i ? k.push(i) : p(N.prev) ? $.push(J) : $.push(a("", u, { groupId: C[b - 1] }))), L && (g(N) ? p(N.next) && q.push(i, i) : L === i ? p(N.next) && q.push(i) : M.push(L)), [...k, s([...$, s([R(_, E, o), ...M], { id: C[b] })]), ...q];
              }, "children");
            }
            n.exports = { printChildren: x };
          } }), ng = ee({ "src/language-html/print/element.js"(e, n) {
            "use strict";
            re();
            var { builders: { breakParent: t3, dedentToRoot: s, group: a, ifBreak: r, indentIfBreak: u, indent: i, line: l, softline: c }, utils: { replaceTextEndOfLine: y } } = qe(), h = fo(), { shouldPreserveContent: g, isScriptLikeTag: p, isVueCustomBlock: D, countParents: v, forceBreakContent: w } = Mt(), { printOpeningTagPrefix: T, printOpeningTag: F, printClosingTagSuffix: A, printClosingTag: B, needsToBorrowPrevClosingTagEndMarker: I, needsToBorrowLastChildClosingTagEndMarker: P } = rr(), { printChildren: R } = Do();
            function f(x, m, E) {
              let o = x.getValue();
              if (g(o, m))
                return [T(o, m), a(F(x, m, E)), ...y(h(o, m)), ...B(o, m), A(o, m)];
              let d = o.children.length === 1 && o.firstChild.type === "interpolation" && o.firstChild.isLeadingSpaceSensitive && !o.firstChild.hasLeadingSpaces && o.lastChild.isTrailingSpaceSensitive && !o.lastChild.hasTrailingSpaces, C = Symbol("element-attr-group-id"), _ = ($) => a([a(F(x, m, E), { id: C }), $, B(o, m)]), b = ($) => d ? u($, { groupId: C }) : (p(o) || D(o, m)) && o.parent.type === "root" && m.parser === "vue" && !m.vueIndentScriptAndStyle ? $ : i($), N = () => d ? r(c, "", { groupId: C }) : o.firstChild.hasLeadingSpaces && o.firstChild.isLeadingSpaceSensitive ? l : o.firstChild.type === "text" && o.isWhitespaceSensitive && o.isIndentationSensitive ? s(c) : c, k = () => (o.next ? I(o.next) : P(o.parent)) ? o.lastChild.hasTrailingSpaces && o.lastChild.isTrailingSpaceSensitive ? " " : "" : d ? r(c, "", { groupId: C }) : o.lastChild.hasTrailingSpaces && o.lastChild.isTrailingSpaceSensitive ? l : (o.lastChild.type === "comment" || o.lastChild.type === "text" && o.isWhitespaceSensitive && o.isIndentationSensitive) && new RegExp(`\\n[\\t ]{${m.tabWidth * v(x, (M) => M.parent && M.parent.type !== "root")}}$`).test(o.lastChild.value) ? "" : c;
              return o.children.length === 0 ? _(o.hasDanglingSpaces && o.isDanglingSpaceSensitive ? l : "") : _([w(o) ? t3 : "", b([N(), R(x, m, E)]), k()]);
            }
            n.exports = { printElement: f };
          } }), ug = ee({ "src/language-html/printer-html.js"(e, n) {
            "use strict";
            re();
            var { builders: { fill: t3, group: s, hardline: a, literalline: r }, utils: { cleanDoc: u, getDocParts: i, isConcat: l, replaceTextEndOfLine: c } } = qe(), y = Wd(), { countChars: h, unescapeQuoteEntities: g, getTextValueParts: p } = Mt(), D = Yd(), { insertPragma: v } = Qd(), { locStart: w, locEnd: T } = Qn(), F = rg(), { printClosingTagSuffix: A, printClosingTagEnd: B, printOpeningTagPrefix: I, printOpeningTagStart: P } = rr(), { printElement: R } = ng(), { printChildren: f } = Do();
            function x(m, E, o) {
              let d = m.getValue();
              switch (d.type) {
                case "front-matter":
                  return c(d.raw);
                case "root":
                  return E.__onHtmlRoot && E.__onHtmlRoot(d), [s(f(m, E, o)), a];
                case "element":
                case "ieConditionalComment":
                  return R(m, E, o);
                case "ieConditionalStartComment":
                case "ieConditionalEndComment":
                  return [P(d), B(d)];
                case "interpolation":
                  return [P(d, E), ...m.map(o, "children"), B(d, E)];
                case "text": {
                  if (d.parent.type === "interpolation") {
                    let _ = /\n[^\S\n]*$/, b = _.test(d.value), N = b ? d.value.replace(_, "") : d.value;
                    return [...c(N), b ? a : ""];
                  }
                  let C = u([I(d, E), ...p(d), A(d, E)]);
                  return l(C) || C.type === "fill" ? t3(i(C)) : C;
                }
                case "docType":
                  return [s([P(d, E), " ", d.value.replace(/^html\b/i, "html").replace(/\s+/g, " ")]), B(d, E)];
                case "comment":
                  return [I(d, E), ...c(E.originalText.slice(w(d), T(d)), r), A(d, E)];
                case "attribute": {
                  if (d.value === null)
                    return d.rawName;
                  let C = g(d.value), _ = h(C, "'"), b = h(C, '"'), N = _ < b ? "'" : '"';
                  return [d.rawName, "=", N, ...c(N === '"' ? C.replace(/"/g, "&quot;") : C.replace(/'/g, "&apos;")), N];
                }
                default:
                  throw new Error(`Unexpected node type ${d.type}`);
              }
            }
            n.exports = { preprocess: D, print: x, insertPragma: v, massageAstNode: y, embed: F };
          } }), sg = ee({ "src/language-html/options.js"(e, n) {
            "use strict";
            re();
            var t3 = qt(), s = "HTML";
            n.exports = { bracketSameLine: t3.bracketSameLine, htmlWhitespaceSensitivity: { since: "1.15.0", category: s, type: "choice", default: "css", description: "How to handle whitespaces in HTML.", choices: [{ value: "css", description: "Respect the default value of CSS display property." }, { value: "strict", description: "Whitespaces are considered sensitive." }, { value: "ignore", description: "Whitespaces are considered insensitive." }] }, singleAttributePerLine: t3.singleAttributePerLine, vueIndentScriptAndStyle: { since: "1.19.0", category: s, type: "boolean", default: false, description: "Indent script and style tags in Vue files." } };
          } }), ig = ee({ "src/language-html/parsers.js"() {
            re();
          } }), Tn = ee({ "node_modules/linguist-languages/data/HTML.json"(e, n) {
            n.exports = { name: "HTML", type: "markup", tmScope: "text.html.basic", aceMode: "html", codemirrorMode: "htmlmixed", codemirrorMimeType: "text/html", color: "#e34c26", aliases: ["xhtml"], extensions: [".html", ".hta", ".htm", ".html.hl", ".inc", ".xht", ".xhtml"], languageId: 146 };
          } }), ag = ee({ "node_modules/linguist-languages/data/Vue.json"(e, n) {
            n.exports = { name: "Vue", type: "markup", color: "#41b883", extensions: [".vue"], tmScope: "text.html.vue", aceMode: "html", languageId: 391 };
          } }), og = ee({ "src/language-html/index.js"(e, n) {
            "use strict";
            re();
            var t3 = wt(), s = ug(), a = sg(), r = ig(), u = [t3(Tn(), () => ({ name: "Angular", since: "1.15.0", parsers: ["angular"], vscodeLanguageIds: ["html"], extensions: [".component.html"], filenames: [] })), t3(Tn(), (l) => ({ since: "1.15.0", parsers: ["html"], vscodeLanguageIds: ["html"], extensions: [...l.extensions, ".mjml"] })), t3(Tn(), () => ({ name: "Lightning Web Components", since: "1.17.0", parsers: ["lwc"], vscodeLanguageIds: ["html"], extensions: [], filenames: [] })), t3(ag(), () => ({ since: "1.10.0", parsers: ["vue"], vscodeLanguageIds: ["vue"] }))], i = { html: s };
            n.exports = { languages: u, printers: i, options: a, parsers: r };
          } }), lg = ee({ "src/language-yaml/pragma.js"(e, n) {
            "use strict";
            re();
            function t3(r) {
              return /^\s*@(?:prettier|format)\s*$/.test(r);
            }
            function s(r) {
              return /^\s*#[^\S\n]*@(?:prettier|format)\s*?(?:\n|$)/.test(r);
            }
            function a(r) {
              return `# @format

${r}`;
            }
            n.exports = { isPragma: t3, hasPragma: s, insertPragma: a };
          } }), cg = ee({ "src/language-yaml/loc.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return a.position.start.offset;
            }
            function s(a) {
              return a.position.end.offset;
            }
            n.exports = { locStart: t3, locEnd: s };
          } }), pg = ee({ "src/language-yaml/embed.js"(e, n) {
            "use strict";
            re();
            function t3(s, a, r, u) {
              if (s.getValue().type === "root" && u.filepath && /(?:[/\\]|^)\.(?:prettier|stylelint|lintstaged)rc$/.test(u.filepath))
                return r(u.originalText, Object.assign(Object.assign({}, u), {}, { parser: "json" }));
            }
            n.exports = t3;
          } }), Rt = ee({ "src/language-yaml/utils.js"(e, n) {
            "use strict";
            re();
            var { getLast: t3, isNonEmptyArray: s } = Ge();
            function a(f, x) {
              let m = 0, E = f.stack.length - 1;
              for (let o = 0; o < E; o++) {
                let d = f.stack[o];
                r(d) && x(d) && m++;
              }
              return m;
            }
            function r(f, x) {
              return f && typeof f.type == "string" && (!x || x.includes(f.type));
            }
            function u(f, x, m) {
              return x("children" in f ? Object.assign(Object.assign({}, f), {}, { children: f.children.map((E) => u(E, x, f)) }) : f, m);
            }
            function i(f, x, m) {
              Object.defineProperty(f, x, { get: m, enumerable: false });
            }
            function l(f, x) {
              let m = 0, E = x.length;
              for (let o = f.position.end.offset - 1; o < E; o++) {
                let d = x[o];
                if (d === `
` && m++, m === 1 && /\S/.test(d))
                  return false;
                if (m === 2)
                  return true;
              }
              return false;
            }
            function c(f) {
              switch (f.getValue().type) {
                case "tag":
                case "anchor":
                case "comment":
                  return false;
              }
              let m = f.stack.length;
              for (let E = 1; E < m; E++) {
                let o = f.stack[E], d = f.stack[E - 1];
                if (Array.isArray(d) && typeof o == "number" && o !== d.length - 1)
                  return false;
              }
              return true;
            }
            function y(f) {
              return s(f.children) ? y(t3(f.children)) : f;
            }
            function h(f) {
              return f.value.trim() === "prettier-ignore";
            }
            function g(f) {
              let x = f.getValue();
              if (x.type === "documentBody") {
                let m = f.getParentNode();
                return A(m.head) && h(t3(m.head.endComments));
              }
              return v(x) && h(t3(x.leadingComments));
            }
            function p(f) {
              return !s(f.children) && !D(f);
            }
            function D(f) {
              return v(f) || w(f) || T(f) || F(f) || A(f);
            }
            function v(f) {
              return s(f == null ? void 0 : f.leadingComments);
            }
            function w(f) {
              return s(f == null ? void 0 : f.middleComments);
            }
            function T(f) {
              return f == null ? void 0 : f.indicatorComment;
            }
            function F(f) {
              return f == null ? void 0 : f.trailingComment;
            }
            function A(f) {
              return s(f == null ? void 0 : f.endComments);
            }
            function B(f) {
              let x = [], m;
              for (let E of f.split(/( +)/))
                E !== " " ? m === " " ? x.push(E) : x.push((x.pop() || "") + E) : m === void 0 && x.unshift(""), m = E;
              return m === " " && x.push((x.pop() || "") + " "), x[0] === "" && (x.shift(), x.unshift(" " + (x.shift() || ""))), x;
            }
            function I(f, x, m) {
              let E = x.split(`
`).map((o, d, C) => d === 0 && d === C.length - 1 ? o : d !== 0 && d !== C.length - 1 ? o.trim() : d === 0 ? o.trimEnd() : o.trimStart());
              return m.proseWrap === "preserve" ? E.map((o) => o.length === 0 ? [] : [o]) : E.map((o) => o.length === 0 ? [] : B(o)).reduce((o, d, C) => C !== 0 && E[C - 1].length > 0 && d.length > 0 && !(f === "quoteDouble" && t3(t3(o)).endsWith("\\")) ? [...o.slice(0, -1), [...t3(o), ...d]] : [...o, d], []).map((o) => m.proseWrap === "never" ? [o.join(" ")] : o);
            }
            function P(f, x) {
              let { parentIndent: m, isLastDescendant: E, options: o } = x, d = f.position.start.line === f.position.end.line ? "" : o.originalText.slice(f.position.start.offset, f.position.end.offset).match(/^[^\n]*\n(.*)$/s)[1], C;
              if (f.indent === null) {
                let N = d.match(/^(?<leadingSpace> *)[^\n\r ]/m);
                C = N ? N.groups.leadingSpace.length : Number.POSITIVE_INFINITY;
              } else
                C = f.indent - 1 + m;
              let _ = d.split(`
`).map((N) => N.slice(C));
              if (o.proseWrap === "preserve" || f.type === "blockLiteral")
                return b(_.map((N) => N.length === 0 ? [] : [N]));
              return b(_.map((N) => N.length === 0 ? [] : B(N)).reduce((N, k, $) => $ !== 0 && _[$ - 1].length > 0 && k.length > 0 && !/^\s/.test(k[0]) && !/^\s|\s$/.test(t3(N)) ? [...N.slice(0, -1), [...t3(N), ...k]] : [...N, k], []).map((N) => N.reduce((k, $) => k.length > 0 && /\s$/.test(t3(k)) ? [...k.slice(0, -1), t3(k) + " " + $] : [...k, $], [])).map((N) => o.proseWrap === "never" ? [N.join(" ")] : N));
              function b(N) {
                if (f.chomping === "keep")
                  return t3(N).length === 0 ? N.slice(0, -1) : N;
                let k = 0;
                for (let $ = N.length - 1; $ >= 0 && N[$].length === 0; $--)
                  k++;
                return k === 0 ? N : k >= 2 && !E ? N.slice(0, -(k - 1)) : N.slice(0, -k);
              }
            }
            function R(f) {
              if (!f)
                return true;
              switch (f.type) {
                case "plain":
                case "quoteDouble":
                case "quoteSingle":
                case "alias":
                case "flowMapping":
                case "flowSequence":
                  return true;
                default:
                  return false;
              }
            }
            n.exports = { getLast: t3, getAncestorCount: a, isNode: r, isEmptyNode: p, isInlineNode: R, mapNode: u, defineShortcut: i, isNextLineEmpty: l, isLastDescendantNode: c, getBlockValueLineContents: P, getFlowScalarLineContents: I, getLastDescendantNode: y, hasPrettierIgnore: g, hasLeadingComments: v, hasMiddleComments: w, hasIndicatorComment: T, hasTrailingComment: F, hasEndComments: A };
          } }), fg = ee({ "src/language-yaml/print-preprocess.js"(e, n) {
            "use strict";
            re();
            var { defineShortcut: t3, mapNode: s } = Rt();
            function a(u) {
              return s(u, r);
            }
            function r(u) {
              switch (u.type) {
                case "document":
                  t3(u, "head", () => u.children[0]), t3(u, "body", () => u.children[1]);
                  break;
                case "documentBody":
                case "sequenceItem":
                case "flowSequenceItem":
                case "mappingKey":
                case "mappingValue":
                  t3(u, "content", () => u.children[0]);
                  break;
                case "mappingItem":
                case "flowMappingItem":
                  t3(u, "key", () => u.children[0]), t3(u, "value", () => u.children[1]);
                  break;
              }
              return u;
            }
            n.exports = a;
          } }), qr = ee({ "src/language-yaml/print/misc.js"(e, n) {
            "use strict";
            re();
            var { builders: { softline: t3, align: s } } = qe(), { hasEndComments: a, isNextLineEmpty: r, isNode: u } = Rt(), i = /* @__PURE__ */ new WeakMap();
            function l(h, g) {
              let p = h.getValue(), D = h.stack[0], v;
              return i.has(D) ? v = i.get(D) : (v = /* @__PURE__ */ new Set(), i.set(D, v)), !v.has(p.position.end.line) && (v.add(p.position.end.line), r(p, g) && !c(h.getParentNode())) ? t3 : "";
            }
            function c(h) {
              return a(h) && !u(h, ["documentHead", "documentBody", "flowMapping", "flowSequence"]);
            }
            function y(h, g) {
              return s(" ".repeat(h), g);
            }
            n.exports = { alignWithSpaces: y, shouldPrintEndComments: c, printNextEmptyLine: l };
          } }), Dg = ee({ "src/language-yaml/print/flow-mapping-sequence.js"(e, n) {
            "use strict";
            re();
            var { builders: { ifBreak: t3, line: s, softline: a, hardline: r, join: u } } = qe(), { isEmptyNode: i, getLast: l, hasEndComments: c } = Rt(), { printNextEmptyLine: y, alignWithSpaces: h } = qr();
            function g(D, v, w) {
              let T = D.getValue(), F = T.type === "flowMapping", A = F ? "{" : "[", B = F ? "}" : "]", I = a;
              F && T.children.length > 0 && w.bracketSpacing && (I = s);
              let P = l(T.children), R = P && P.type === "flowMappingItem" && i(P.key) && i(P.value);
              return [A, h(w.tabWidth, [I, p(D, v, w), w.trailingComma === "none" ? "" : t3(","), c(T) ? [r, u(r, D.map(v, "endComments"))] : ""]), R ? "" : I, B];
            }
            function p(D, v, w) {
              let T = D.getValue();
              return D.map((A, B) => [v(), B === T.children.length - 1 ? "" : [",", s, T.children[B].position.start.line !== T.children[B + 1].position.start.line ? y(A, w.originalText) : ""]], "children");
            }
            n.exports = { printFlowMapping: g, printFlowSequence: g };
          } }), mg = ee({ "src/language-yaml/print/mapping-item.js"(e, n) {
            "use strict";
            re();
            var { builders: { conditionalGroup: t3, group: s, hardline: a, ifBreak: r, join: u, line: i } } = qe(), { hasLeadingComments: l, hasMiddleComments: c, hasTrailingComment: y, hasEndComments: h, isNode: g, isEmptyNode: p, isInlineNode: D } = Rt(), { alignWithSpaces: v } = qr();
            function w(B, I, P, R, f) {
              let { key: x, value: m } = B, E = p(x), o = p(m);
              if (E && o)
                return ": ";
              let d = R("key"), C = F(B) ? " " : "";
              if (o)
                return B.type === "flowMappingItem" && I.type === "flowMapping" ? d : B.type === "mappingItem" && T(x.content, f) && !y(x.content) && (!I.tag || I.tag.value !== "tag:yaml.org,2002:set") ? [d, C, ":"] : ["? ", v(2, d)];
              let _ = R("value");
              if (E)
                return [": ", v(2, _)];
              if (l(m) || !D(x.content))
                return ["? ", v(2, d), a, u("", P.map(R, "value", "leadingComments").map((q) => [q, a])), ": ", v(2, _)];
              if (A(x.content) && !l(x.content) && !c(x.content) && !y(x.content) && !h(x) && !l(m.content) && !c(m.content) && !h(m) && T(m.content, f))
                return [d, C, ": ", _];
              let b = Symbol("mappingKey"), N = s([r("? "), s(v(2, d), { id: b })]), k = [a, ": ", v(2, _)], $ = [C, ":"];
              l(m.content) || h(m) && m.content && !g(m.content, ["mapping", "sequence"]) || I.type === "mapping" && y(x.content) && D(m.content) || g(m.content, ["mapping", "sequence"]) && m.content.tag === null && m.content.anchor === null ? $.push(a) : m.content && $.push(i), $.push(_);
              let M = v(f.tabWidth, $);
              return T(x.content, f) && !l(x.content) && !c(x.content) && !h(x) ? t3([[d, M]]) : t3([[N, r(k, M, { groupId: b })]]);
            }
            function T(B, I) {
              if (!B)
                return true;
              switch (B.type) {
                case "plain":
                case "quoteSingle":
                case "quoteDouble":
                  break;
                case "alias":
                  return true;
                default:
                  return false;
              }
              if (I.proseWrap === "preserve")
                return B.position.start.line === B.position.end.line;
              if (/\\$/m.test(I.originalText.slice(B.position.start.offset, B.position.end.offset)))
                return false;
              switch (I.proseWrap) {
                case "never":
                  return !B.value.includes(`
`);
                case "always":
                  return !/[\n ]/.test(B.value);
                default:
                  return false;
              }
            }
            function F(B) {
              return B.key.content && B.key.content.type === "alias";
            }
            function A(B) {
              if (!B)
                return true;
              switch (B.type) {
                case "plain":
                case "quoteDouble":
                case "quoteSingle":
                  return B.position.start.line === B.position.end.line;
                case "alias":
                  return true;
                default:
                  return false;
              }
            }
            n.exports = w;
          } }), dg = ee({ "src/language-yaml/print/block.js"(e, n) {
            "use strict";
            re();
            var { builders: { dedent: t3, dedentToRoot: s, fill: a, hardline: r, join: u, line: i, literalline: l, markAsRoot: c }, utils: { getDocParts: y } } = qe(), { getAncestorCount: h, getBlockValueLineContents: g, hasIndicatorComment: p, isLastDescendantNode: D, isNode: v } = Rt(), { alignWithSpaces: w } = qr();
            function T(F, A, B) {
              let I = F.getValue(), P = h(F, (E) => v(E, ["sequence", "mapping"])), R = D(F), f = [I.type === "blockFolded" ? ">" : "|"];
              I.indent !== null && f.push(I.indent.toString()), I.chomping !== "clip" && f.push(I.chomping === "keep" ? "+" : "-"), p(I) && f.push(" ", A("indicatorComment"));
              let x = g(I, { parentIndent: P, isLastDescendant: R, options: B }), m = [];
              for (let [E, o] of x.entries())
                E === 0 && m.push(r), m.push(a(y(u(i, o)))), E !== x.length - 1 ? m.push(o.length === 0 ? r : c(l)) : I.chomping === "keep" && R && m.push(s(o.length === 0 ? r : l));
              return I.indent === null ? f.push(t3(w(B.tabWidth, m))) : f.push(s(w(I.indent - 1 + P, m))), f;
            }
            n.exports = T;
          } }), gg = ee({ "src/language-yaml/printer-yaml.js"(e, n) {
            "use strict";
            re();
            var { builders: { breakParent: t3, fill: s, group: a, hardline: r, join: u, line: i, lineSuffix: l, literalline: c }, utils: { getDocParts: y, replaceTextEndOfLine: h } } = qe(), { isPreviousLineEmpty: g } = Ge(), { insertPragma: p, isPragma: D } = lg(), { locStart: v } = cg(), w = pg(), { getFlowScalarLineContents: T, getLastDescendantNode: F, hasLeadingComments: A, hasMiddleComments: B, hasTrailingComment: I, hasEndComments: P, hasPrettierIgnore: R, isLastDescendantNode: f, isNode: x, isInlineNode: m } = Rt(), E = fg(), { alignWithSpaces: o, printNextEmptyLine: d, shouldPrintEndComments: C } = qr(), { printFlowMapping: _, printFlowSequence: b } = Dg(), N = mg(), k = dg();
            function $(O, K, se) {
              let Q = O.getValue(), le = [];
              Q.type !== "mappingValue" && A(Q) && le.push([u(r, O.map(se, "leadingComments")), r]);
              let { tag: W, anchor: X } = Q;
              W && le.push(se("tag")), W && X && le.push(" "), X && le.push(se("anchor"));
              let oe = "";
              x(Q, ["mapping", "sequence", "comment", "directive", "mappingItem", "sequenceItem"]) && !f(O) && (oe = d(O, K.originalText)), (W || X) && (x(Q, ["sequence", "mapping"]) && !B(Q) ? le.push(r) : le.push(" ")), B(Q) && le.push([Q.middleComments.length === 1 ? "" : r, u(r, O.map(se, "middleComments")), r]);
              let ae = O.getParentNode();
              return R(O) ? le.push(h(K.originalText.slice(Q.position.start.offset, Q.position.end.offset).trimEnd(), c)) : le.push(a(M(Q, ae, O, K, se))), I(Q) && !x(Q, ["document", "documentHead"]) && le.push(l([Q.type === "mappingValue" && !Q.content ? "" : " ", ae.type === "mappingKey" && O.getParentNode(2).type === "mapping" && m(Q) ? "" : t3, se("trailingComment")])), C(Q) && le.push(o(Q.type === "sequenceItem" ? 2 : 0, [r, u(r, O.map((Ae) => [g(K.originalText, Ae.getValue(), v) ? r : "", se()], "endComments"))])), le.push(oe), le;
            }
            function M(O, K, se, Q, le) {
              switch (O.type) {
                case "root": {
                  let { children: W } = O, X = [];
                  se.each((ae, Ae) => {
                    let z = W[Ae], H = W[Ae + 1];
                    Ae !== 0 && X.push(r), X.push(le()), J(z, H) ? (X.push(r, "..."), I(z) && X.push(" ", le("trailingComment"))) : H && !I(H.head) && X.push(r, "---");
                  }, "children");
                  let oe = F(O);
                  return (!x(oe, ["blockLiteral", "blockFolded"]) || oe.chomping !== "keep") && X.push(r), X;
                }
                case "document": {
                  let W = K.children[se.getName() + 1], X = [];
                  return L(O, W, K, Q) === "head" && ((O.head.children.length > 0 || O.head.endComments.length > 0) && X.push(le("head")), I(O.head) ? X.push(["---", " ", le(["head", "trailingComment"])]) : X.push("---")), q(O) && X.push(le("body")), u(r, X);
                }
                case "documentHead":
                  return u(r, [...se.map(le, "children"), ...se.map(le, "endComments")]);
                case "documentBody": {
                  let { children: W, endComments: X } = O, oe = "";
                  if (W.length > 0 && X.length > 0) {
                    let ae = F(O);
                    x(ae, ["blockFolded", "blockLiteral"]) ? ae.chomping !== "keep" && (oe = [r, r]) : oe = r;
                  }
                  return [u(r, se.map(le, "children")), oe, u(r, se.map(le, "endComments"))];
                }
                case "directive":
                  return ["%", u(" ", [O.name, ...O.parameters])];
                case "comment":
                  return ["#", O.value];
                case "alias":
                  return ["*", O.value];
                case "tag":
                  return Q.originalText.slice(O.position.start.offset, O.position.end.offset);
                case "anchor":
                  return ["&", O.value];
                case "plain":
                  return Y(O.type, Q.originalText.slice(O.position.start.offset, O.position.end.offset), Q);
                case "quoteDouble":
                case "quoteSingle": {
                  let W = "'", X = '"', oe = Q.originalText.slice(O.position.start.offset + 1, O.position.end.offset - 1);
                  if (O.type === "quoteSingle" && oe.includes("\\") || O.type === "quoteDouble" && /\\[^"]/.test(oe)) {
                    let Ae = O.type === "quoteDouble" ? X : W;
                    return [Ae, Y(O.type, oe, Q), Ae];
                  }
                  if (oe.includes(X))
                    return [W, Y(O.type, O.type === "quoteDouble" ? oe.replace(/\\"/g, X).replace(/'/g, W.repeat(2)) : oe, Q), W];
                  if (oe.includes(W))
                    return [X, Y(O.type, O.type === "quoteSingle" ? oe.replace(/''/g, W) : oe, Q), X];
                  let ae = Q.singleQuote ? W : X;
                  return [ae, Y(O.type, oe, Q), ae];
                }
                case "blockFolded":
                case "blockLiteral":
                  return k(se, le, Q);
                case "mapping":
                case "sequence":
                  return u(r, se.map(le, "children"));
                case "sequenceItem":
                  return ["- ", o(2, O.content ? le("content") : "")];
                case "mappingKey":
                case "mappingValue":
                  return O.content ? le("content") : "";
                case "mappingItem":
                case "flowMappingItem":
                  return N(O, K, se, le, Q);
                case "flowMapping":
                  return _(se, le, Q);
                case "flowSequence":
                  return b(se, le, Q);
                case "flowSequenceItem":
                  return le("content");
                default:
                  throw new Error(`Unexpected node type ${O.type}`);
              }
            }
            function q(O) {
              return O.body.children.length > 0 || P(O.body);
            }
            function J(O, K) {
              return I(O) || K && (K.head.children.length > 0 || P(K.head));
            }
            function L(O, K, se, Q) {
              return se.children[0] === O && /---(?:\s|$)/.test(Q.originalText.slice(v(O), v(O) + 4)) || O.head.children.length > 0 || P(O.head) || I(O.head) ? "head" : J(O, K) ? false : K ? "root" : false;
            }
            function Y(O, K, se) {
              let Q = T(O, K, se);
              return u(r, Q.map((le) => s(y(u(i, le)))));
            }
            function V(O, K) {
              if (x(K))
                switch (delete K.position, K.type) {
                  case "comment":
                    if (D(K.value))
                      return null;
                    break;
                  case "quoteDouble":
                  case "quoteSingle":
                    K.type = "quote";
                    break;
                }
            }
            n.exports = { preprocess: E, embed: w, print: $, massageAstNode: V, insertPragma: p };
          } }), yg = ee({ "src/language-yaml/options.js"(e, n) {
            "use strict";
            re();
            var t3 = qt();
            n.exports = { bracketSpacing: t3.bracketSpacing, singleQuote: t3.singleQuote, proseWrap: t3.proseWrap };
          } }), hg = ee({ "src/language-yaml/parsers.js"() {
            re();
          } }), vg = ee({ "node_modules/linguist-languages/data/YAML.json"(e, n) {
            n.exports = { name: "YAML", type: "data", color: "#cb171e", tmScope: "source.yaml", aliases: ["yml"], extensions: [".yml", ".mir", ".reek", ".rviz", ".sublime-syntax", ".syntax", ".yaml", ".yaml-tmlanguage", ".yaml.sed", ".yml.mysql"], filenames: [".clang-format", ".clang-tidy", ".gemrc", "CITATION.cff", "glide.lock", "yarn.lock"], aceMode: "yaml", codemirrorMode: "yaml", codemirrorMimeType: "text/x-yaml", languageId: 407 };
          } }), Cg = ee({ "src/language-yaml/index.js"(e, n) {
            "use strict";
            re();
            var t3 = wt(), s = gg(), a = yg(), r = hg(), u = [t3(vg(), (i) => ({ since: "1.14.0", parsers: ["yaml"], vscodeLanguageIds: ["yaml", "ansible", "home-assistant"], filenames: [...i.filenames.filter((l) => l !== "yarn.lock"), ".prettierrc", ".stylelintrc", ".lintstagedrc"] }))];
            n.exports = { languages: u, printers: { yaml: s }, options: a, parsers: r };
          } }), Eg = ee({ "src/languages.js"(e, n) {
            "use strict";
            re(), n.exports = [td(), vd(), Td(), kd(), Vd(), og(), Cg()];
          } });
          re();
          var { version: Fg } = fa(), kt = vm(), { getSupportInfo: Ag } = Rn(), Sg = Cm(), xg = Eg(), bg = qe();
          function Bt(e) {
            let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
            return function() {
              for (var t3 = arguments.length, s = new Array(t3), a = 0; a < t3; a++)
                s[a] = arguments[a];
              let r = s[n] || {}, u = r.plugins || [];
              return s[n] = Object.assign(Object.assign({}, r), {}, { plugins: [...xg, ...Array.isArray(u) ? u : Object.values(u)] }), e(...s);
            };
          }
          var Bn = Bt(kt.formatWithCursor);
          mo.exports = { formatWithCursor: Bn, format(e, n) {
            return Bn(e, n).formatted;
          }, check(e, n) {
            let { formatted: t3 } = Bn(e, n);
            return t3 === e;
          }, doc: bg, getSupportInfo: Bt(Ag, 0), version: Fg, util: Sg, __debug: { parse: Bt(kt.parse), formatAST: Bt(kt.formatAST), formatDoc: Bt(kt.formatDoc), printToDoc: Bt(kt.printToDoc), printDocToString: Bt(kt.printDocToString) } };
        });
        return Tg();
      });
    }
  });

  // node_modules/prettier/parser-babel.js
  var require_parser_babel = __commonJS({
    "node_modules/prettier/parser-babel.js"(exports2, module2) {
      init_define_process();
      (function(e) {
        if (typeof exports2 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var i = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          i.prettierPlugins = i.prettierPlugins || {}, i.prettierPlugins.babel = e();
        }
      })(function() {
        "use strict";
        var C = (l, u) => () => (u || l((u = { exports: {} }).exports, u), u.exports);
        var W = C((Hd, si) => {
          var vt = function(l) {
            return l && l.Math == Math && l;
          };
          si.exports = vt(typeof globalThis == "object" && globalThis) || vt(typeof window == "object" && window) || vt(typeof self == "object" && self) || vt(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var ge = C(($d, ri) => {
          ri.exports = function(l) {
            try {
              return !!l();
            } catch {
              return true;
            }
          };
        });
        var De = C((zd, ii) => {
          var uh = ge();
          ii.exports = !uh(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var Et = C((Vd, ai) => {
          var ch = ge();
          ai.exports = !ch(function() {
            var l = function() {
            }.bind();
            return typeof l != "function" || l.hasOwnProperty("prototype");
          });
        });
        var bt = C((Kd, ni) => {
          var ph = Et(), Ct = Function.prototype.call;
          ni.exports = ph ? Ct.bind(Ct) : function() {
            return Ct.apply(Ct, arguments);
          };
        });
        var ui = C((hi) => {
          "use strict";
          var oi = {}.propertyIsEnumerable, li = Object.getOwnPropertyDescriptor, dh = li && !oi.call({ 1: 2 }, 1);
          hi.f = dh ? function(u) {
            var d = li(this, u);
            return !!d && d.enumerable;
          } : oi;
        });
        var xs = C((Gd, ci) => {
          ci.exports = function(l, u) {
            return { enumerable: !(l & 1), configurable: !(l & 2), writable: !(l & 4), value: u };
          };
        });
        var ne = C((Jd, fi) => {
          var pi = Et(), di = Function.prototype, fh = di.bind, gs = di.call, mh = pi && fh.bind(gs, gs);
          fi.exports = pi ? function(l) {
            return l && mh(l);
          } : function(l) {
            return l && function() {
              return gs.apply(l, arguments);
            };
          };
        });
        var St = C((Xd, yi) => {
          var mi = ne(), yh = mi({}.toString), xh = mi("".slice);
          yi.exports = function(l) {
            return xh(yh(l), 8, -1);
          };
        });
        var gi = C((Yd, xi) => {
          var gh = W(), Ph = ne(), Ah = ge(), Th = St(), Ps = gh.Object, vh = Ph("".split);
          xi.exports = Ah(function() {
            return !Ps("z").propertyIsEnumerable(0);
          }) ? function(l) {
            return Th(l) == "String" ? vh(l, "") : Ps(l);
          } : Ps;
        });
        var As = C((Qd, Pi) => {
          var Eh = W(), Ch = Eh.TypeError;
          Pi.exports = function(l) {
            if (l == null)
              throw Ch("Can't call method on " + l);
            return l;
          };
        });
        var wt = C((Zd, Ai) => {
          var bh = gi(), Sh = As();
          Ai.exports = function(l) {
            return bh(Sh(l));
          };
        });
        var oe = C((ef, Ti) => {
          Ti.exports = function(l) {
            return typeof l == "function";
          };
        });
        var Fe = C((tf, vi) => {
          var wh = oe();
          vi.exports = function(l) {
            return typeof l == "object" ? l !== null : wh(l);
          };
        });
        var tt = C((sf, Ei) => {
          var Ts = W(), Ih = oe(), Nh = function(l) {
            return Ih(l) ? l : void 0;
          };
          Ei.exports = function(l, u) {
            return arguments.length < 2 ? Nh(Ts[l]) : Ts[l] && Ts[l][u];
          };
        });
        var bi = C((rf, Ci) => {
          var kh = ne();
          Ci.exports = kh({}.isPrototypeOf);
        });
        var wi = C((af, Si) => {
          var Dh = tt();
          Si.exports = Dh("navigator", "userAgent") || "";
        });
        var Oi = C((nf, Li) => {
          var Fi = W(), vs = wi(), Ii = Fi.process, Ni = Fi.Deno, ki = Ii && Ii.versions || Ni && Ni.version, Di = ki && ki.v8, le, It;
          Di && (le = Di.split("."), It = le[0] > 0 && le[0] < 4 ? 1 : +(le[0] + le[1]));
          !It && vs && (le = vs.match(/Edge\/(\d+)/), (!le || le[1] >= 74) && (le = vs.match(/Chrome\/(\d+)/), le && (It = +le[1])));
          Li.exports = It;
        });
        var Es = C((of, Bi) => {
          var Mi = Oi(), Fh = ge();
          Bi.exports = !!Object.getOwnPropertySymbols && !Fh(function() {
            var l = Symbol();
            return !String(l) || !(Object(l) instanceof Symbol) || !Symbol.sham && Mi && Mi < 41;
          });
        });
        var Cs = C((lf, _i) => {
          var Lh = Es();
          _i.exports = Lh && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var bs = C((hf, Ri) => {
          var Oh = W(), Mh = tt(), Bh = oe(), _h = bi(), Rh = Cs(), jh = Oh.Object;
          Ri.exports = Rh ? function(l) {
            return typeof l == "symbol";
          } : function(l) {
            var u = Mh("Symbol");
            return Bh(u) && _h(u.prototype, jh(l));
          };
        });
        var qi = C((uf, ji) => {
          var qh = W(), Uh = qh.String;
          ji.exports = function(l) {
            try {
              return Uh(l);
            } catch {
              return "Object";
            }
          };
        });
        var Nt = C((cf, Ui) => {
          var Hh = W(), $h = oe(), zh = qi(), Vh = Hh.TypeError;
          Ui.exports = function(l) {
            if ($h(l))
              return l;
            throw Vh(zh(l) + " is not a function");
          };
        });
        var $i = C((pf, Hi) => {
          var Kh = Nt();
          Hi.exports = function(l, u) {
            var d = l[u];
            return d == null ? void 0 : Kh(d);
          };
        });
        var Vi = C((df, zi) => {
          var Wh = W(), Ss = bt(), ws = oe(), Is = Fe(), Gh = Wh.TypeError;
          zi.exports = function(l, u) {
            var d, f;
            if (u === "string" && ws(d = l.toString) && !Is(f = Ss(d, l)) || ws(d = l.valueOf) && !Is(f = Ss(d, l)) || u !== "string" && ws(d = l.toString) && !Is(f = Ss(d, l)))
              return f;
            throw Gh("Can't convert object to primitive value");
          };
        });
        var Wi = C((ff, Ki) => {
          Ki.exports = false;
        });
        var kt = C((mf, Ji) => {
          var Gi = W(), Jh = Object.defineProperty;
          Ji.exports = function(l, u) {
            try {
              Jh(Gi, l, { value: u, configurable: true, writable: true });
            } catch {
              Gi[l] = u;
            }
            return u;
          };
        });
        var Dt = C((yf, Yi) => {
          var Xh = W(), Yh = kt(), Xi = "__core-js_shared__", Qh = Xh[Xi] || Yh(Xi, {});
          Yi.exports = Qh;
        });
        var Ns = C((xf, Zi) => {
          var Zh = Wi(), Qi = Dt();
          (Zi.exports = function(l, u) {
            return Qi[l] || (Qi[l] = u !== void 0 ? u : {});
          })("versions", []).push({ version: "3.22.2", mode: Zh ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.22.2/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var ks = C((gf, ea) => {
          var eu = W(), tu = As(), su = eu.Object;
          ea.exports = function(l) {
            return su(tu(l));
          };
        });
        var Ce = C((Pf, ta) => {
          var ru = ne(), iu = ks(), au = ru({}.hasOwnProperty);
          ta.exports = Object.hasOwn || function(u, d) {
            return au(iu(u), d);
          };
        });
        var Ds = C((Af, sa) => {
          var nu = ne(), ou = 0, lu = Math.random(), hu = nu(1 .toString);
          sa.exports = function(l) {
            return "Symbol(" + (l === void 0 ? "" : l) + ")_" + hu(++ou + lu, 36);
          };
        });
        var st = C((Tf, oa) => {
          var uu = W(), cu = Ns(), ra = Ce(), pu = Ds(), ia = Es(), na = Cs(), ze = cu("wks"), Le = uu.Symbol, aa = Le && Le.for, du = na ? Le : Le && Le.withoutSetter || pu;
          oa.exports = function(l) {
            if (!ra(ze, l) || !(ia || typeof ze[l] == "string")) {
              var u = "Symbol." + l;
              ia && ra(Le, l) ? ze[l] = Le[l] : na && aa ? ze[l] = aa(u) : ze[l] = du(u);
            }
            return ze[l];
          };
        });
        var ca = C((vf, ua) => {
          var fu = W(), mu = bt(), la = Fe(), ha = bs(), yu = $i(), xu = Vi(), gu = st(), Pu = fu.TypeError, Au = gu("toPrimitive");
          ua.exports = function(l, u) {
            if (!la(l) || ha(l))
              return l;
            var d = yu(l, Au), f;
            if (d) {
              if (u === void 0 && (u = "default"), f = mu(d, l, u), !la(f) || ha(f))
                return f;
              throw Pu("Can't convert object to primitive value");
            }
            return u === void 0 && (u = "number"), xu(l, u);
          };
        });
        var Fs = C((Ef, pa) => {
          var Tu = ca(), vu = bs();
          pa.exports = function(l) {
            var u = Tu(l, "string");
            return vu(u) ? u : u + "";
          };
        });
        var ma = C((Cf, fa) => {
          var Eu = W(), da = Fe(), Ls = Eu.document, Cu = da(Ls) && da(Ls.createElement);
          fa.exports = function(l) {
            return Cu ? Ls.createElement(l) : {};
          };
        });
        var Os = C((bf, ya) => {
          var bu = De(), Su = ge(), wu = ma();
          ya.exports = !bu && !Su(function() {
            return Object.defineProperty(wu("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var Ms = C((ga) => {
          var Iu = De(), Nu = bt(), ku = ui(), Du = xs(), Fu = wt(), Lu = Fs(), Ou = Ce(), Mu = Os(), xa = Object.getOwnPropertyDescriptor;
          ga.f = Iu ? xa : function(u, d) {
            if (u = Fu(u), d = Lu(d), Mu)
              try {
                return xa(u, d);
              } catch {
              }
            if (Ou(u, d))
              return Du(!Nu(ku.f, u, d), u[d]);
          };
        });
        var Aa = C((wf, Pa) => {
          var Bu = De(), _u = ge();
          Pa.exports = Bu && _u(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var Bs = C((If, va) => {
          var Ta = W(), Ru = Fe(), ju = Ta.String, qu = Ta.TypeError;
          va.exports = function(l) {
            if (Ru(l))
              return l;
            throw qu(ju(l) + " is not an object");
          };
        });
        var Us = C((Ca) => {
          var Uu = W(), Hu = De(), $u = Os(), zu = Aa(), Ft = Bs(), Ea = Fs(), Vu = Uu.TypeError, _s = Object.defineProperty, Ku = Object.getOwnPropertyDescriptor, Rs = "enumerable", js = "configurable", qs = "writable";
          Ca.f = Hu ? zu ? function(u, d, f) {
            if (Ft(u), d = Ea(d), Ft(f), typeof u == "function" && d === "prototype" && "value" in f && qs in f && !f[qs]) {
              var y = Ku(u, d);
              y && y[qs] && (u[d] = f.value, f = { configurable: js in f ? f[js] : y[js], enumerable: Rs in f ? f[Rs] : y[Rs], writable: false });
            }
            return _s(u, d, f);
          } : _s : function(u, d, f) {
            if (Ft(u), d = Ea(d), Ft(f), $u)
              try {
                return _s(u, d, f);
              } catch {
              }
            if ("get" in f || "set" in f)
              throw Vu("Accessors not supported");
            return "value" in f && (u[d] = f.value), u;
          };
        });
        var Lt = C((kf, ba) => {
          var Wu = De(), Gu = Us(), Ju = xs();
          ba.exports = Wu ? function(l, u, d) {
            return Gu.f(l, u, Ju(1, d));
          } : function(l, u, d) {
            return l[u] = d, l;
          };
        });
        var Ot = C((Df, Sa) => {
          var Xu = ne(), Yu = oe(), Hs = Dt(), Qu = Xu(Function.toString);
          Yu(Hs.inspectSource) || (Hs.inspectSource = function(l) {
            return Qu(l);
          });
          Sa.exports = Hs.inspectSource;
        });
        var Na = C((Ff, Ia) => {
          var Zu = W(), ec = oe(), tc = Ot(), wa = Zu.WeakMap;
          Ia.exports = ec(wa) && /native code/.test(tc(wa));
        });
        var Fa = C((Lf, Da) => {
          var sc = Ns(), rc = Ds(), ka = sc("keys");
          Da.exports = function(l) {
            return ka[l] || (ka[l] = rc(l));
          };
        });
        var $s = C((Of, La) => {
          La.exports = {};
        });
        var ja = C((Mf, Ra) => {
          var ic = Na(), _a = W(), zs = ne(), ac = Fe(), nc = Lt(), Vs = Ce(), Ks = Dt(), oc = Fa(), lc = $s(), Oa = "Object already initialized", Gs = _a.TypeError, hc = _a.WeakMap, Mt, rt, Bt, uc = function(l) {
            return Bt(l) ? rt(l) : Mt(l, {});
          }, cc = function(l) {
            return function(u) {
              var d;
              if (!ac(u) || (d = rt(u)).type !== l)
                throw Gs("Incompatible receiver, " + l + " required");
              return d;
            };
          };
          ic || Ks.state ? (be = Ks.state || (Ks.state = new hc()), Ma = zs(be.get), Ws = zs(be.has), Ba = zs(be.set), Mt = function(l, u) {
            if (Ws(be, l))
              throw new Gs(Oa);
            return u.facade = l, Ba(be, l, u), u;
          }, rt = function(l) {
            return Ma(be, l) || {};
          }, Bt = function(l) {
            return Ws(be, l);
          }) : (Oe = oc("state"), lc[Oe] = true, Mt = function(l, u) {
            if (Vs(l, Oe))
              throw new Gs(Oa);
            return u.facade = l, nc(l, Oe, u), u;
          }, rt = function(l) {
            return Vs(l, Oe) ? l[Oe] : {};
          }, Bt = function(l) {
            return Vs(l, Oe);
          });
          var be, Ma, Ws, Ba, Oe;
          Ra.exports = { set: Mt, get: rt, has: Bt, enforce: uc, getterFor: cc };
        });
        var Ha = C((Bf, Ua) => {
          var Js = De(), pc = Ce(), qa = Function.prototype, dc = Js && Object.getOwnPropertyDescriptor, Xs = pc(qa, "name"), fc = Xs && function() {
          }.name === "something", mc = Xs && (!Js || Js && dc(qa, "name").configurable);
          Ua.exports = { EXISTS: Xs, PROPER: fc, CONFIGURABLE: mc };
        });
        var Wa = C((_f, Ka) => {
          var yc = W(), $a = oe(), xc = Ce(), za = Lt(), gc = kt(), Pc = Ot(), Va = ja(), Ac = Ha().CONFIGURABLE, Tc = Va.get, vc = Va.enforce, Ec = String(String).split("String");
          (Ka.exports = function(l, u, d, f) {
            var y = f ? !!f.unsafe : false, A = f ? !!f.enumerable : false, g = f ? !!f.noTargetGet : false, T = f && f.name !== void 0 ? f.name : u, S;
            if ($a(d) && (String(T).slice(0, 7) === "Symbol(" && (T = "[" + String(T).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!xc(d, "name") || Ac && d.name !== T) && za(d, "name", T), S = vc(d), S.source || (S.source = Ec.join(typeof T == "string" ? T : ""))), l === yc) {
              A ? l[u] = d : gc(u, d);
              return;
            } else
              y ? !g && l[u] && (A = true) : delete l[u];
            A ? l[u] = d : za(l, u, d);
          })(Function.prototype, "toString", function() {
            return $a(this) && Tc(this).source || Pc(this);
          });
        });
        var Ys = C((Rf, Ga) => {
          var Cc = Math.ceil, bc = Math.floor;
          Ga.exports = function(l) {
            var u = +l;
            return u !== u || u === 0 ? 0 : (u > 0 ? bc : Cc)(u);
          };
        });
        var Xa = C((jf, Ja) => {
          var Sc = Ys(), wc = Math.max, Ic = Math.min;
          Ja.exports = function(l, u) {
            var d = Sc(l);
            return d < 0 ? wc(d + u, 0) : Ic(d, u);
          };
        });
        var Qa = C((qf, Ya) => {
          var Nc = Ys(), kc = Math.min;
          Ya.exports = function(l) {
            return l > 0 ? kc(Nc(l), 9007199254740991) : 0;
          };
        });
        var _t = C((Uf, Za) => {
          var Dc = Qa();
          Za.exports = function(l) {
            return Dc(l.length);
          };
        });
        var sn = C((Hf, tn) => {
          var Fc = wt(), Lc = Xa(), Oc = _t(), en = function(l) {
            return function(u, d, f) {
              var y = Fc(u), A = Oc(y), g = Lc(f, A), T;
              if (l && d != d) {
                for (; A > g; )
                  if (T = y[g++], T != T)
                    return true;
              } else
                for (; A > g; g++)
                  if ((l || g in y) && y[g] === d)
                    return l || g || 0;
              return !l && -1;
            };
          };
          tn.exports = { includes: en(true), indexOf: en(false) };
        });
        var nn = C(($f, an) => {
          var Mc = ne(), Qs = Ce(), Bc = wt(), _c = sn().indexOf, Rc = $s(), rn = Mc([].push);
          an.exports = function(l, u) {
            var d = Bc(l), f = 0, y = [], A;
            for (A in d)
              !Qs(Rc, A) && Qs(d, A) && rn(y, A);
            for (; u.length > f; )
              Qs(d, A = u[f++]) && (~_c(y, A) || rn(y, A));
            return y;
          };
        });
        var ln = C((zf, on) => {
          on.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var un = C((hn) => {
          var jc = nn(), qc = ln(), Uc = qc.concat("length", "prototype");
          hn.f = Object.getOwnPropertyNames || function(u) {
            return jc(u, Uc);
          };
        });
        var pn = C((cn) => {
          cn.f = Object.getOwnPropertySymbols;
        });
        var fn = C((Wf, dn) => {
          var Hc = tt(), $c = ne(), zc = un(), Vc = pn(), Kc = Bs(), Wc = $c([].concat);
          dn.exports = Hc("Reflect", "ownKeys") || function(u) {
            var d = zc.f(Kc(u)), f = Vc.f;
            return f ? Wc(d, f(u)) : d;
          };
        });
        var xn = C((Gf, yn) => {
          var mn = Ce(), Gc = fn(), Jc = Ms(), Xc = Us();
          yn.exports = function(l, u, d) {
            for (var f = Gc(u), y = Xc.f, A = Jc.f, g = 0; g < f.length; g++) {
              var T = f[g];
              !mn(l, T) && !(d && mn(d, T)) && y(l, T, A(u, T));
            }
          };
        });
        var Pn = C((Jf, gn) => {
          var Yc = ge(), Qc = oe(), Zc = /#|\.prototype\./, it = function(l, u) {
            var d = tp[ep(l)];
            return d == rp ? true : d == sp ? false : Qc(u) ? Yc(u) : !!u;
          }, ep = it.normalize = function(l) {
            return String(l).replace(Zc, ".").toLowerCase();
          }, tp = it.data = {}, sp = it.NATIVE = "N", rp = it.POLYFILL = "P";
          gn.exports = it;
        });
        var er = C((Xf, An) => {
          var Zs = W(), ip = Ms().f, ap = Lt(), np = Wa(), op = kt(), lp = xn(), hp = Pn();
          An.exports = function(l, u) {
            var d = l.target, f = l.global, y = l.stat, A, g, T, S, F, I;
            if (f ? g = Zs : y ? g = Zs[d] || op(d, {}) : g = (Zs[d] || {}).prototype, g)
              for (T in u) {
                if (F = u[T], l.noTargetGet ? (I = ip(g, T), S = I && I.value) : S = g[T], A = hp(f ? T : d + (y ? "." : "#") + T, l.forced), !A && S !== void 0) {
                  if (typeof F == typeof S)
                    continue;
                  lp(F, S);
                }
                (l.sham || S && S.sham) && ap(F, "sham", true), np(g, T, F, l);
              }
          };
        });
        var Tn = C(() => {
          var up = er(), cp = W();
          up({ global: true }, { globalThis: cp });
        });
        var vn = C(() => {
          Tn();
        });
        var tr = C((tm, En) => {
          var pp = St();
          En.exports = Array.isArray || function(u) {
            return pp(u) == "Array";
          };
        });
        var Sn = C((sm, bn) => {
          var Cn = ne(), dp = Nt(), fp = Et(), mp = Cn(Cn.bind);
          bn.exports = function(l, u) {
            return dp(l), u === void 0 ? l : fp ? mp(l, u) : function() {
              return l.apply(u, arguments);
            };
          };
        });
        var Nn = C((rm, In) => {
          "use strict";
          var yp = W(), xp = tr(), gp = _t(), Pp = Sn(), Ap = yp.TypeError, wn = function(l, u, d, f, y, A, g, T) {
            for (var S = y, F = 0, I = g ? Pp(g, T) : false, E, L; F < f; ) {
              if (F in d) {
                if (E = I ? I(d[F], F, u) : d[F], A > 0 && xp(E))
                  L = gp(E), S = wn(l, u, E, L, S, A - 1) - 1;
                else {
                  if (S >= 9007199254740991)
                    throw Ap("Exceed the acceptable array length");
                  l[S] = E;
                }
                S++;
              }
              F++;
            }
            return S;
          };
          In.exports = wn;
        });
        var Fn = C((im, Dn) => {
          var Tp = st(), vp = Tp("toStringTag"), kn = {};
          kn[vp] = "z";
          Dn.exports = String(kn) === "[object z]";
        });
        var On = C((am, Ln) => {
          var Ep = W(), Cp = Fn(), bp = oe(), Rt = St(), Sp = st(), wp = Sp("toStringTag"), Ip = Ep.Object, Np = Rt(function() {
            return arguments;
          }()) == "Arguments", kp = function(l, u) {
            try {
              return l[u];
            } catch {
            }
          };
          Ln.exports = Cp ? Rt : function(l) {
            var u, d, f;
            return l === void 0 ? "Undefined" : l === null ? "Null" : typeof (d = kp(u = Ip(l), wp)) == "string" ? d : Np ? Rt(u) : (f = Rt(u)) == "Object" && bp(u.callee) ? "Arguments" : f;
          };
        });
        var qn = C((nm2, jn) => {
          var Dp = ne(), Fp = ge(), Mn = oe(), Lp = On(), Op = tt(), Mp = Ot(), Bn = function() {
          }, Bp = [], _n = Op("Reflect", "construct"), sr = /^\s*(?:class|function)\b/, _p = Dp(sr.exec), Rp = !sr.exec(Bn), at2 = function(u) {
            if (!Mn(u))
              return false;
            try {
              return _n(Bn, Bp, u), true;
            } catch {
              return false;
            }
          }, Rn = function(u) {
            if (!Mn(u))
              return false;
            switch (Lp(u)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return false;
            }
            try {
              return Rp || !!_p(sr, Mp(u));
            } catch {
              return true;
            }
          };
          Rn.sham = true;
          jn.exports = !_n || Fp(function() {
            var l;
            return at2(at2.call) || !at2(Object) || !at2(function() {
              l = true;
            }) || l;
          }) ? Rn : at2;
        });
        var zn = C((om, $n) => {
          var jp = W(), Un = tr(), qp = qn(), Up = Fe(), Hp = st(), $p = Hp("species"), Hn = jp.Array;
          $n.exports = function(l) {
            var u;
            return Un(l) && (u = l.constructor, qp(u) && (u === Hn || Un(u.prototype)) ? u = void 0 : Up(u) && (u = u[$p], u === null && (u = void 0))), u === void 0 ? Hn : u;
          };
        });
        var Kn = C((lm, Vn) => {
          var zp = zn();
          Vn.exports = function(l, u) {
            return new (zp(l))(u === 0 ? 0 : u);
          };
        });
        var Wn = C(() => {
          "use strict";
          var Vp = er(), Kp = Nn(), Wp = Nt(), Gp = ks(), Jp = _t(), Xp = Kn();
          Vp({ target: "Array", proto: true }, { flatMap: function(u) {
            var d = Gp(this), f = Jp(d), y;
            return Wp(u), y = Xp(d, 0), y.length = Kp(y, d, d, f, 0, 1, u, arguments.length > 1 ? arguments[1] : void 0), y;
          } });
        });
        var qd = C((xm, Eo) => {
          vn();
          Wn();
          var nr = Object.defineProperty, Yp = Object.getOwnPropertyDescriptor, or = Object.getOwnPropertyNames, Qp = Object.prototype.hasOwnProperty, Zn = (l, u) => function() {
            return l && (u = (0, l[or(l)[0]])(l = 0)), u;
          }, K = (l, u) => function() {
            return u || (0, l[or(l)[0]])((u = { exports: {} }).exports, u), u.exports;
          }, Zp = (l, u) => {
            for (var d in u)
              nr(l, d, { get: u[d], enumerable: true });
          }, ed = (l, u, d, f) => {
            if (u && typeof u == "object" || typeof u == "function")
              for (let y of or(u))
                !Qp.call(l, y) && y !== d && nr(l, y, { get: () => u[y], enumerable: !(f = Yp(u, y)) || f.enumerable });
            return l;
          }, td = (l) => ed(nr({}, "__esModule", { value: true }), l), V = Zn({ "<define:process>"() {
          } }), sd = K({ "src/utils/try-combinations.js"(l, u) {
            "use strict";
            V();
            function d() {
              let f;
              for (var y = arguments.length, A = new Array(y), g = 0; g < y; g++)
                A[g] = arguments[g];
              for (let [T, S] of A.entries())
                try {
                  return { result: S() };
                } catch (F) {
                  T === 0 && (f = F);
                }
              return { error: f };
            }
            u.exports = d;
          } }), eo = K({ "src/language-js/utils/get-shebang.js"(l, u) {
            "use strict";
            V();
            function d(f) {
              if (!f.startsWith("#!"))
                return "";
              let y = f.indexOf(`
`);
              return y === -1 ? f : f.slice(0, y);
            }
            u.exports = d;
          } }), rd = K({ "src/utils/text/skip-inline-comment.js"(l, u) {
            "use strict";
            V();
            function d(f, y) {
              if (y === false)
                return false;
              if (f.charAt(y) === "/" && f.charAt(y + 1) === "*") {
                for (let A = y + 2; A < f.length; ++A)
                  if (f.charAt(A) === "*" && f.charAt(A + 1) === "/")
                    return A + 2;
              }
              return y;
            }
            u.exports = d;
          } }), id = K({ "src/utils/text/skip-newline.js"(l, u) {
            "use strict";
            V();
            function d(f, y, A) {
              let g = A && A.backwards;
              if (y === false)
                return false;
              let T = f.charAt(y);
              if (g) {
                if (f.charAt(y - 1) === "\r" && T === `
`)
                  return y - 2;
                if (T === `
` || T === "\r" || T === "\u2028" || T === "\u2029")
                  return y - 1;
              } else {
                if (T === "\r" && f.charAt(y + 1) === `
`)
                  return y + 2;
                if (T === `
` || T === "\r" || T === "\u2028" || T === "\u2029")
                  return y + 1;
              }
              return y;
            }
            u.exports = d;
          } }), to = K({ "src/utils/text/skip.js"(l, u) {
            "use strict";
            V();
            function d(T) {
              return (S, F, I) => {
                let E = I && I.backwards;
                if (F === false)
                  return false;
                let { length: L } = S, j = F;
                for (; j >= 0 && j < L; ) {
                  let k = S.charAt(j);
                  if (T instanceof RegExp) {
                    if (!T.test(k))
                      return j;
                  } else if (!T.includes(k))
                    return j;
                  E ? j-- : j++;
                }
                return j === -1 || j === L ? j : false;
              };
            }
            var f = d(/\s/), y = d(" 	"), A = d(",; 	"), g = d(/[^\n\r]/);
            u.exports = { skipWhitespace: f, skipSpaces: y, skipToLineEnd: A, skipEverythingButNewLine: g };
          } }), ad = K({ "src/utils/text/skip-trailing-comment.js"(l, u) {
            "use strict";
            V();
            var { skipEverythingButNewLine: d } = to();
            function f(y, A) {
              return A === false ? false : y.charAt(A) === "/" && y.charAt(A + 1) === "/" ? d(y, A) : A;
            }
            u.exports = f;
          } }), nd = K({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(l, u) {
            "use strict";
            V();
            var d = rd(), f = id(), y = ad(), { skipSpaces: A } = to();
            function g(T, S) {
              let F = null, I = S;
              for (; I !== F; )
                F = I, I = A(T, I), I = d(T, I), I = y(T, I), I = f(T, I);
              return I;
            }
            u.exports = g;
          } }), so = {};
          Zp(so, { EOL: () => ar, arch: () => od, cpus: () => ho, default: () => mo, endianness: () => ro, freemem: () => oo, getNetworkInterfaces: () => fo, hostname: () => io, loadavg: () => ao, networkInterfaces: () => po, platform: () => ld, release: () => co, tmpDir: () => rr, tmpdir: () => ir, totalmem: () => lo, type: () => uo, uptime: () => no });
          function ro() {
            if (typeof jt > "u") {
              var l = new ArrayBuffer(2), u = new Uint8Array(l), d = new Uint16Array(l);
              if (u[0] = 1, u[1] = 2, d[0] === 258)
                jt = "BE";
              else if (d[0] === 513)
                jt = "LE";
              else
                throw new Error("unable to figure out endianess");
            }
            return jt;
          }
          function io() {
            return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
          }
          function ao() {
            return [];
          }
          function no() {
            return 0;
          }
          function oo() {
            return Number.MAX_VALUE;
          }
          function lo() {
            return Number.MAX_VALUE;
          }
          function ho() {
            return [];
          }
          function uo() {
            return "Browser";
          }
          function co() {
            return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
          }
          function po() {
          }
          function fo() {
          }
          function od() {
            return "javascript";
          }
          function ld() {
            return "browser";
          }
          function rr() {
            return "/tmp";
          }
          var jt, ir, ar, mo, hd = Zn({ "node-modules-polyfills:os"() {
            V(), ir = rr, ar = `
`, mo = { EOL: ar, tmpdir: ir, tmpDir: rr, networkInterfaces: po, getNetworkInterfaces: fo, release: co, type: uo, cpus: ho, totalmem: lo, freemem: oo, uptime: no, loadavg: ao, hostname: io, endianness: ro };
          } }), ud = K({ "node-modules-polyfills-commonjs:os"(l, u) {
            V();
            var d = (hd(), td(so));
            if (d && d.default) {
              u.exports = d.default;
              for (let f in d)
                u.exports[f] = d[f];
            } else
              d && (u.exports = d);
          } }), cd = K({ "node_modules/detect-newline/index.js"(l, u) {
            "use strict";
            V();
            var d = (f) => {
              if (typeof f != "string")
                throw new TypeError("Expected a string");
              let y = f.match(/(?:\r?\n)/g) || [];
              if (y.length === 0)
                return;
              let A = y.filter((T) => T === `\r
`).length, g = y.length - A;
              return A > g ? `\r
` : `
`;
            };
            u.exports = d, u.exports.graceful = (f) => typeof f == "string" && d(f) || `
`;
          } }), pd = K({ "node_modules/jest-docblock/build/index.js"(l) {
            "use strict";
            V(), Object.defineProperty(l, "__esModule", { value: true }), l.extract = j, l.parse = z, l.parseWithComments = G, l.print = B, l.strip = k;
            function u() {
              let h = ud();
              return u = function() {
                return h;
              }, h;
            }
            function d() {
              let h = f(cd());
              return d = function() {
                return h;
              }, h;
            }
            function f(h) {
              return h && h.__esModule ? h : { default: h };
            }
            var y = /\*\/$/, A = /^\/\*\*?/, g = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, T = /(^|\s+)\/\/([^\r\n]*)/g, S = /^(\r?\n)+/, F = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, I = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, E = /(\r?\n|^) *\* ?/g, L = [];
            function j(h) {
              let J = h.match(g);
              return J ? J[0].trimLeft() : "";
            }
            function k(h) {
              let J = h.match(g);
              return J && J[0] ? h.substring(J[0].length) : h;
            }
            function z(h) {
              return G(h).pragmas;
            }
            function G(h) {
              let J = (0, d().default)(h) || u().EOL;
              h = h.replace(A, "").replace(y, "").replace(E, "$1");
              let ae = "";
              for (; ae !== h; )
                ae = h, h = h.replace(F, `${J}$1 $2${J}`);
              h = h.replace(S, "").trimRight();
              let Y = /* @__PURE__ */ Object.create(null), Me = h.replace(I, "").replace(S, "").trimRight(), ee;
              for (; ee = I.exec(h); ) {
                let H = ee[2].replace(T, "");
                typeof Y[ee[1]] == "string" || Array.isArray(Y[ee[1]]) ? Y[ee[1]] = L.concat(Y[ee[1]], H) : Y[ee[1]] = H;
              }
              return { comments: Me, pragmas: Y };
            }
            function B(h) {
              let { comments: J = "", pragmas: ae = {} } = h, Y = (0, d().default)(J) || u().EOL, Me = "/**", ee = " *", H = " */", M = Object.keys(ae), v = M.map((te) => _(te, ae[te])).reduce((te, he) => te.concat(he), []).map((te) => `${ee} ${te}${Y}`).join("");
              if (!J) {
                if (M.length === 0)
                  return "";
                if (M.length === 1 && !Array.isArray(ae[M[0]])) {
                  let te = ae[M[0]];
                  return `${Me} ${_(M[0], te)[0]}${H}`;
                }
              }
              let We = J.split(Y).map((te) => `${ee} ${te}`).join(Y) + Y;
              return Me + Y + (J ? We : "") + (J && M.length ? ee + Y : "") + v + H;
            }
            function _(h, J) {
              return L.concat(J).map((ae) => `@${h} ${ae}`.trim());
            }
          } }), dd = K({ "src/common/end-of-line.js"(l, u) {
            "use strict";
            V();
            function d(g) {
              let T = g.indexOf("\r");
              return T >= 0 ? g.charAt(T + 1) === `
` ? "crlf" : "cr" : "lf";
            }
            function f(g) {
              switch (g) {
                case "cr":
                  return "\r";
                case "crlf":
                  return `\r
`;
                default:
                  return `
`;
              }
            }
            function y(g, T) {
              let S;
              switch (T) {
                case `
`:
                  S = /\n/g;
                  break;
                case "\r":
                  S = /\r/g;
                  break;
                case `\r
`:
                  S = /\r\n/g;
                  break;
                default:
                  throw new Error(`Unexpected "eol" ${JSON.stringify(T)}.`);
              }
              let F = g.match(S);
              return F ? F.length : 0;
            }
            function A(g) {
              return g.replace(/\r\n?/g, `
`);
            }
            u.exports = { guessEndOfLine: d, convertEndOfLineToChars: f, countEndOfLineChars: y, normalizeEndOfLine: A };
          } }), fd = K({ "src/language-js/pragma.js"(l, u) {
            "use strict";
            V();
            var { parseWithComments: d, strip: f, extract: y, print: A } = pd(), { normalizeEndOfLine: g } = dd(), T = eo();
            function S(E) {
              let L = T(E);
              L && (E = E.slice(L.length + 1));
              let j = y(E), { pragmas: k, comments: z } = d(j);
              return { shebang: L, text: E, pragmas: k, comments: z };
            }
            function F(E) {
              let L = Object.keys(S(E).pragmas);
              return L.includes("prettier") || L.includes("format");
            }
            function I(E) {
              let { shebang: L, text: j, pragmas: k, comments: z } = S(E), G = f(j), B = A({ pragmas: Object.assign({ format: "" }, k), comments: z.trimStart() });
              return (L ? `${L}
` : "") + g(B) + (G.startsWith(`
`) ? `
` : `

`) + G;
            }
            u.exports = { hasPragma: F, insertPragma: I };
          } }), lr = K({ "src/utils/is-non-empty-array.js"(l, u) {
            "use strict";
            V();
            function d(f) {
              return Array.isArray(f) && f.length > 0;
            }
            u.exports = d;
          } }), yo = K({ "src/language-js/loc.js"(l, u) {
            "use strict";
            V();
            var d = lr();
            function f(S) {
              var F, I;
              let E = S.range ? S.range[0] : S.start, L = (F = (I = S.declaration) === null || I === void 0 ? void 0 : I.decorators) !== null && F !== void 0 ? F : S.decorators;
              return d(L) ? Math.min(f(L[0]), E) : E;
            }
            function y(S) {
              return S.range ? S.range[1] : S.end;
            }
            function A(S, F) {
              let I = f(S);
              return Number.isInteger(I) && I === f(F);
            }
            function g(S, F) {
              let I = y(S);
              return Number.isInteger(I) && I === y(F);
            }
            function T(S, F) {
              return A(S, F) && g(S, F);
            }
            u.exports = { locStart: f, locEnd: y, hasSameLocStart: A, hasSameLoc: T };
          } }), xo = K({ "src/language-js/parse/utils/create-parser.js"(l, u) {
            "use strict";
            V();
            var { hasPragma: d } = fd(), { locStart: f, locEnd: y } = yo();
            function A(g) {
              return g = typeof g == "function" ? { parse: g } : g, Object.assign({ astFormat: "estree", hasPragma: d, locStart: f, locEnd: y }, g);
            }
            u.exports = A;
          } }), hr = K({ "src/common/parser-create-error.js"(l, u) {
            "use strict";
            V();
            function d(f, y) {
              let A = new SyntaxError(f + " (" + y.start.line + ":" + y.start.column + ")");
              return A.loc = y, A;
            }
            u.exports = d;
          } }), go = K({ "src/language-js/parse/utils/create-babel-parse-error.js"(l, u) {
            "use strict";
            V();
            var d = hr();
            function f(y) {
              let { message: A, loc: g } = y;
              return d(A.replace(/ \(.*\)/, ""), { start: { line: g ? g.line : 0, column: g ? g.column + 1 : 0 } });
            }
            u.exports = f;
          } }), md = K({ "src/language-js/utils/is-ts-keyword-type.js"(l, u) {
            "use strict";
            V();
            function d(f) {
              let { type: y } = f;
              return y.startsWith("TS") && y.endsWith("Keyword");
            }
            u.exports = d;
          } }), yd = K({ "src/language-js/utils/is-block-comment.js"(l, u) {
            "use strict";
            V();
            var d = /* @__PURE__ */ new Set(["Block", "CommentBlock", "MultiLine"]), f = (y) => d.has(y == null ? void 0 : y.type);
            u.exports = f;
          } }), xd = K({ "src/language-js/utils/is-type-cast-comment.js"(l, u) {
            "use strict";
            V();
            var d = yd();
            function f(y) {
              return d(y) && y.value[0] === "*" && /@type\b/.test(y.value);
            }
            u.exports = f;
          } }), gd = K({ "src/utils/get-last.js"(l, u) {
            "use strict";
            V();
            var d = (f) => f[f.length - 1];
            u.exports = d;
          } }), Po = K({ "src/language-js/parse/postprocess/visit-node.js"(l, u) {
            "use strict";
            V();
            function d(f, y) {
              if (Array.isArray(f)) {
                for (let A = 0; A < f.length; A++)
                  f[A] = d(f[A], y);
                return f;
              }
              if (f && typeof f == "object" && typeof f.type == "string") {
                let A = Object.keys(f);
                for (let g = 0; g < A.length; g++)
                  f[A[g]] = d(f[A[g]], y);
                return y(f) || f;
              }
              return f;
            }
            u.exports = d;
          } }), Ao = K({ "src/language-js/parse/postprocess/throw-syntax-error.js"(l, u) {
            "use strict";
            V();
            var d = hr();
            function f(y, A) {
              let { start: g, end: T } = y.loc;
              throw d(A, { start: { line: g.line, column: g.column + 1 }, end: { line: T.line, column: T.column + 1 } });
            }
            u.exports = f;
          } }), Pd = K({ "src/language-js/parse/postprocess/typescript.js"(l, u) {
            "use strict";
            V();
            var d = lr(), f = Po(), y = Ao(), A = { AbstractKeyword: 126, SourceFile: 308, PropertyDeclaration: 169 };
            function g(I) {
              for (; I && I.kind !== A.SourceFile; )
                I = I.parent;
              return I;
            }
            function T(I) {
              let { illegalDecorators: E } = I;
              if (!d(E))
                return;
              let [{ expression: L }] = E, j = g(L), [k, z] = [L.pos, L.end].map((G) => {
                let { line: B, character: _ } = j.getLineAndCharacterOfPosition(G);
                return { line: B + 1, column: _ };
              });
              y({ loc: { start: k, end: z } }, "Decorators are not valid here.");
            }
            function S(I, E) {
              I.kind !== A.PropertyDeclaration || I.modifiers && !I.modifiers.some((L) => L.kind === A.AbstractKeyword) || I.initializer && E.value === null && y(E, "Abstract property cannot have an initializer");
            }
            function F(I, E) {
              let { esTreeNodeToTSNodeMap: L, tsNodeToESTreeNodeMap: j } = E.tsParseResult;
              f(I, (k) => {
                let z = L.get(k);
                if (!z)
                  return;
                let G = j.get(z);
                G === k && (T(z), S(z, G));
              });
            }
            u.exports = { throwErrorForInvalidNodes: F };
          } }), Ad = K({ "src/language-js/parse/postprocess/index.js"(l, u) {
            "use strict";
            V();
            var { locStart: d, locEnd: f } = yo(), y = md(), A = xd(), g = gd(), T = Po(), { throwErrorForInvalidNodes: S } = Pd(), F = Ao();
            function I(k, z) {
              if (z.parser === "typescript" && /@|abstract/.test(z.originalText) && S(k, z), z.parser !== "typescript" && z.parser !== "flow" && z.parser !== "acorn" && z.parser !== "espree" && z.parser !== "meriyah") {
                let B = /* @__PURE__ */ new Set();
                k = T(k, (_) => {
                  _.leadingComments && _.leadingComments.some(A) && B.add(d(_));
                }), k = T(k, (_) => {
                  if (_.type === "ParenthesizedExpression") {
                    let { expression: h } = _;
                    if (h.type === "TypeCastExpression")
                      return h.range = _.range, h;
                    let J = d(_);
                    if (!B.has(J))
                      return h.extra = Object.assign(Object.assign({}, h.extra), {}, { parenthesized: true }), h;
                  }
                });
              }
              return k = T(k, (B) => {
                switch (B.type) {
                  case "ChainExpression":
                    return E(B.expression);
                  case "LogicalExpression": {
                    if (L(B))
                      return j(B);
                    break;
                  }
                  case "VariableDeclaration": {
                    let _ = g(B.declarations);
                    _ && _.init && G(B, _);
                    break;
                  }
                  case "TSParenthesizedType":
                    return y(B.typeAnnotation) || B.typeAnnotation.type === "TSThisType" || (B.typeAnnotation.range = [d(B), f(B)]), B.typeAnnotation;
                  case "TSTypeParameter":
                    if (typeof B.name == "string") {
                      let _ = d(B);
                      B.name = { type: "Identifier", name: B.name, range: [_, _ + B.name.length] };
                    }
                    break;
                  case "ObjectExpression":
                    if (z.parser === "typescript") {
                      let _ = B.properties.find((h) => h.type === "Property" && h.value.type === "TSEmptyBodyFunctionExpression");
                      _ && F(_.value, "Unexpected token.");
                    }
                    break;
                  case "SequenceExpression": {
                    let _ = g(B.expressions);
                    B.range = [d(B), Math.min(f(_), f(B))];
                    break;
                  }
                  case "TopicReference":
                    z.__isUsingHackPipeline = true;
                    break;
                  case "ExportAllDeclaration": {
                    let { exported: _ } = B;
                    if (z.parser === "meriyah" && _ && _.type === "Identifier") {
                      let h = z.originalText.slice(d(_), f(_));
                      (h.startsWith('"') || h.startsWith("'")) && (B.exported = Object.assign(Object.assign({}, B.exported), {}, { type: "Literal", value: B.exported.name, raw: h }));
                    }
                    break;
                  }
                }
              }), k;
              function G(B, _) {
                z.originalText[f(_)] !== ";" && (B.range = [d(B), f(_)]);
              }
            }
            function E(k) {
              switch (k.type) {
                case "CallExpression":
                  k.type = "OptionalCallExpression", k.callee = E(k.callee);
                  break;
                case "MemberExpression":
                  k.type = "OptionalMemberExpression", k.object = E(k.object);
                  break;
                case "TSNonNullExpression":
                  k.expression = E(k.expression);
                  break;
              }
              return k;
            }
            function L(k) {
              return k.type === "LogicalExpression" && k.right.type === "LogicalExpression" && k.operator === k.right.operator;
            }
            function j(k) {
              return L(k) ? j({ type: "LogicalExpression", operator: k.operator, left: j({ type: "LogicalExpression", operator: k.operator, left: k.left, right: k.right.left, range: [d(k.left), f(k.right.left)] }), right: k.right.right, range: [d(k), f(k)] }) : k;
            }
            u.exports = I;
          } }), To = K({ "node_modules/@babel/parser/lib/index.js"(l) {
            "use strict";
            V(), Object.defineProperty(l, "__esModule", { value: true });
            function u(t3, r) {
              if (t3 == null)
                return {};
              var e = {}, s = Object.keys(t3), i, a;
              for (a = 0; a < s.length; a++)
                i = s[a], !(r.indexOf(i) >= 0) && (e[i] = t3[i]);
              return e;
            }
            var d = class {
              constructor(t3, r, e) {
                this.line = void 0, this.column = void 0, this.index = void 0, this.line = t3, this.column = r, this.index = e;
              }
            }, f = class {
              constructor(t3, r) {
                this.start = void 0, this.end = void 0, this.filename = void 0, this.identifierName = void 0, this.start = t3, this.end = r;
              }
            };
            function y(t3, r) {
              let { line: e, column: s, index: i } = t3;
              return new d(e, s + r, i + r);
            }
            var A = { SyntaxError: "BABEL_PARSER_SYNTAX_ERROR", SourceTypeModuleError: "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED" }, g = function(t3) {
              let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t3.length - 1;
              return { get() {
                return t3.reduce((e, s) => e[s], this);
              }, set(e) {
                t3.reduce((s, i, a) => a === r ? s[i] = e : s[i], this);
              } };
            }, T = (t3, r, e) => Object.keys(e).map((s) => [s, e[s]]).filter((s) => {
              let [, i] = s;
              return !!i;
            }).map((s) => {
              let [i, a] = s;
              return [i, typeof a == "function" ? { value: a, enumerable: false } : typeof a.reflect == "string" ? Object.assign({}, a, g(a.reflect.split("."))) : a];
            }).reduce((s, i) => {
              let [a, n] = i;
              return Object.defineProperty(s, a, Object.assign({ configurable: true }, n));
            }, Object.assign(new t3(), r)), S = { ImportMetaOutsideModule: { message: `import.meta may appear only with 'sourceType: "module"'`, code: A.SourceTypeModuleError }, ImportOutsideModule: { message: `'import' and 'export' may appear only with 'sourceType: "module"'`, code: A.SourceTypeModuleError } }, F = { ArrayPattern: "array destructuring pattern", AssignmentExpression: "assignment expression", AssignmentPattern: "assignment expression", ArrowFunctionExpression: "arrow function expression", ConditionalExpression: "conditional expression", CatchClause: "catch clause", ForOfStatement: "for-of statement", ForInStatement: "for-in statement", ForStatement: "for-loop", FormalParameters: "function parameter list", Identifier: "identifier", ImportSpecifier: "import specifier", ImportDefaultSpecifier: "import default specifier", ImportNamespaceSpecifier: "import namespace specifier", ObjectPattern: "object destructuring pattern", ParenthesizedExpression: "parenthesized expression", RestElement: "rest element", UpdateExpression: { true: "prefix operation", false: "postfix operation" }, VariableDeclarator: "variable declaration", YieldExpression: "yield expression" }, I = (t3) => {
              let { type: r, prefix: e } = t3;
              return r === "UpdateExpression" ? F.UpdateExpression[String(e)] : F[r];
            }, E = { AccessorIsGenerator: (t3) => {
              let { kind: r } = t3;
              return `A ${r}ter cannot be a generator.`;
            }, ArgumentsInClass: "'arguments' is only allowed in functions and class methods.", AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block.", AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function.", AwaitBindingIdentifierInStaticBlock: "Can not use 'await' as identifier inside a static block.", AwaitExpressionFormalParameter: "'await' is not allowed in async function parameters.", AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules.", AwaitNotInAsyncFunction: "'await' is only allowed within async functions.", BadGetterArity: "A 'get' accesor must not have any formal parameters.", BadSetterArity: "A 'set' accesor must have exactly one formal parameter.", BadSetterRestParameter: "A 'set' accesor function argument must not be a rest parameter.", ConstructorClassField: "Classes may not have a field named 'constructor'.", ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'.", ConstructorIsAccessor: "Class constructor may not be an accessor.", ConstructorIsAsync: "Constructor can't be an async function.", ConstructorIsGenerator: "Constructor can't be a generator.", DeclarationMissingInitializer: (t3) => {
              let { kind: r } = t3;
              return `Missing initializer in ${r} declaration.`;
            }, DecoratorArgumentsOutsideParentheses: "Decorator arguments must be moved inside parentheses: use '@(decorator(args))' instead of '@(decorator)(args)'.", DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. You can set the 'decoratorsBeforeExport' option to false to use the 'export @decorator class {}' syntax.", DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?", DecoratorExportClass: "Using the export keyword between a decorator and a class is not allowed. Please use `export @dec class` instead.", DecoratorSemicolon: "Decorators must not be followed by a semicolon.", DecoratorStaticBlock: "Decorators can't be used with a static block.", DeletePrivateField: "Deleting a private field is not allowed.", DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.", DuplicateConstructor: "Duplicate constructor in the same class.", DuplicateDefaultExport: "Only one default export allowed per module.", DuplicateExport: (t3) => {
              let { exportName: r } = t3;
              return `\`${r}\` has already been exported. Exported identifiers must be unique.`;
            }, DuplicateProto: "Redefinition of __proto__ property.", DuplicateRegExpFlags: "Duplicate regular expression flag.", ElementAfterRest: "Rest element must be last element.", EscapedCharNotAnIdentifier: "Invalid Unicode escape.", ExportBindingIsString: (t3) => {
              let { localName: r, exportName: e } = t3;
              return `A string literal cannot be used as an exported binding without \`from\`.
- Did you mean \`export { '${r}' as '${e}' } from 'some-module'\`?`;
            }, ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'.", ForInOfLoopInitializer: (t3) => {
              let { type: r } = t3;
              return `'${r === "ForInStatement" ? "for-in" : "for-of"}' loop variable declaration may not have an initializer.`;
            }, ForInUsing: "For-in loop may not start with 'using' declaration.", ForOfAsync: "The left-hand side of a for-of loop may not be 'async'.", ForOfLet: "The left-hand side of a for-of loop may not start with 'let'.", GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block.", IllegalBreakContinue: (t3) => {
              let { type: r } = t3;
              return `Unsyntactic ${r === "BreakStatement" ? "break" : "continue"}.`;
            }, IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list.", IllegalReturn: "'return' outside of function.", ImportBindingIsString: (t3) => {
              let { importName: r } = t3;
              return `A string literal cannot be used as an imported binding.
- Did you mean \`import { "${r}" as foo }\`?`;
            }, ImportCallArgumentTrailingComma: "Trailing comma is disallowed inside import(...) arguments.", ImportCallArity: (t3) => {
              let { maxArgumentCount: r } = t3;
              return `\`import()\` requires exactly ${r === 1 ? "one argument" : "one or two arguments"}.`;
            }, ImportCallNotNewExpression: "Cannot use new with import(...).", ImportCallSpreadArgument: "`...` is not allowed in `import()`.", ImportJSONBindingNotDefault: "A JSON module can only be imported with `default`.", ImportReflectionHasAssertion: "`import module x` cannot have assertions.", ImportReflectionNotBinding: 'Only `import module x from "./module"` is valid.', IncompatibleRegExpUVFlags: "The 'u' and 'v' regular expression flags cannot be enabled at the same time.", InvalidBigIntLiteral: "Invalid BigIntLiteral.", InvalidCodePoint: "Code point out of bounds.", InvalidCoverInitializedName: "Invalid shorthand property initializer.", InvalidDecimal: "Invalid decimal.", InvalidDigit: (t3) => {
              let { radix: r } = t3;
              return `Expected number in radix ${r}.`;
            }, InvalidEscapeSequence: "Bad character escape sequence.", InvalidEscapeSequenceTemplate: "Invalid escape sequence in template.", InvalidEscapedReservedWord: (t3) => {
              let { reservedWord: r } = t3;
              return `Escape sequence in keyword ${r}.`;
            }, InvalidIdentifier: (t3) => {
              let { identifierName: r } = t3;
              return `Invalid identifier ${r}.`;
            }, InvalidLhs: (t3) => {
              let { ancestor: r } = t3;
              return `Invalid left-hand side in ${I(r)}.`;
            }, InvalidLhsBinding: (t3) => {
              let { ancestor: r } = t3;
              return `Binding invalid left-hand side in ${I(r)}.`;
            }, InvalidNumber: "Invalid number.", InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'.", InvalidOrUnexpectedToken: (t3) => {
              let { unexpected: r } = t3;
              return `Unexpected character '${r}'.`;
            }, InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern.", InvalidPrivateFieldResolution: (t3) => {
              let { identifierName: r } = t3;
              return `Private name #${r} is not defined.`;
            }, InvalidPropertyBindingPattern: "Binding member expression.", InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions.", InvalidRestAssignmentPattern: "Invalid rest operator's argument.", LabelRedeclaration: (t3) => {
              let { labelName: r } = t3;
              return `Label '${r}' is already declared.`;
            }, LetInLexicalBinding: "'let' is not allowed to be used as a name in 'let' or 'const' declarations.", LineTerminatorBeforeArrow: "No line break is allowed before '=>'.", MalformedRegExpFlags: "Invalid regular expression flag.", MissingClassName: "A class name is required.", MissingEqInAssignment: "Only '=' operator can be used for specifying default value.", MissingSemicolon: "Missing semicolon.", MissingPlugin: (t3) => {
              let { missingPlugin: r } = t3;
              return `This experimental syntax requires enabling the parser plugin: ${r.map((e) => JSON.stringify(e)).join(", ")}.`;
            }, MissingOneOfPlugins: (t3) => {
              let { missingPlugin: r } = t3;
              return `This experimental syntax requires enabling one of the following parser plugin(s): ${r.map((e) => JSON.stringify(e)).join(", ")}.`;
            }, MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX.", MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators.", ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`.", ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values.", ModuleAttributesWithDuplicateKeys: (t3) => {
              let { key: r } = t3;
              return `Duplicate key "${r}" is not allowed in module attributes.`;
            }, ModuleExportNameHasLoneSurrogate: (t3) => {
              let { surrogateCharCode: r } = t3;
              return `An export name cannot include a lone surrogate, found '\\u${r.toString(16)}'.`;
            }, ModuleExportUndefined: (t3) => {
              let { localName: r } = t3;
              return `Export '${r}' is not defined.`;
            }, MultipleDefaultsInSwitch: "Multiple default clauses.", NewlineAfterThrow: "Illegal newline after throw.", NoCatchOrFinally: "Missing catch or finally clause.", NumberIdentifier: "Identifier directly after number.", NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences.", ObsoleteAwaitStar: "'await*' has been removed from the async functions proposal. Use Promise.all() instead.", OptionalChainingNoNew: "Constructors in/after an Optional Chain are not allowed.", OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain.", OverrideOnConstructor: "'override' modifier cannot appear on a constructor declaration.", ParamDupe: "Argument name clash.", PatternHasAccessor: "Object pattern can't contain getter or setter.", PatternHasMethod: "Object pattern can't contain methods.", PrivateInExpectedIn: (t3) => {
              let { identifierName: r } = t3;
              return `Private names are only allowed in property accesses (\`obj.#${r}\`) or in \`in\` expressions (\`#${r} in obj\`).`;
            }, PrivateNameRedeclaration: (t3) => {
              let { identifierName: r } = t3;
              return `Duplicate private name #${r}.`;
            }, RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", RecordNoProto: "'__proto__' is not allowed in Record expressions.", RestTrailingComma: "Unexpected trailing comma after rest element.", SloppyFunction: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement.", StaticPrototype: "Classes may not have static property named prototype.", SuperNotAllowed: "`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?", SuperPrivateField: "Private fields can't be accessed on super.", TrailingDecorator: "Decorators must be attached to a class element.", TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", UnexpectedArgumentPlaceholder: "Unexpected argument placeholder.", UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.', UnexpectedDigitAfterHash: "Unexpected digit after hash token.", UnexpectedImportExport: "'import' and 'export' may only appear at the top level.", UnexpectedKeyword: (t3) => {
              let { keyword: r } = t3;
              return `Unexpected keyword '${r}'.`;
            }, UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration.", UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context.", UnexpectedNewTarget: "`new.target` can only be used in functions or class properties.", UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits.", UnexpectedPrivateField: "Unexpected private name.", UnexpectedReservedWord: (t3) => {
              let { reservedWord: r } = t3;
              return `Unexpected reserved word '${r}'.`;
            }, UnexpectedSuper: "'super' is only allowed in object methods and classes.", UnexpectedToken: (t3) => {
              let { expected: r, unexpected: e } = t3;
              return `Unexpected token${e ? ` '${e}'.` : ""}${r ? `, expected "${r}"` : ""}`;
            }, UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.", UnexpectedUsingDeclaration: "Using declaration cannot appear in the top level when source type is `script`.", UnsupportedBind: "Binding should be performed on object property.", UnsupportedDecoratorExport: "A decorated export must export a class declaration.", UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.", UnsupportedImport: "`import` can only be used in `import()` or `import.meta`.", UnsupportedMetaProperty: (t3) => {
              let { target: r, onlyValidPropertyName: e } = t3;
              return `The only valid meta property for ${r} is ${r}.${e}.`;
            }, UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters.", UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties.", UnsupportedSuper: "'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop]).", UnterminatedComment: "Unterminated comment.", UnterminatedRegExp: "Unterminated regular expression.", UnterminatedString: "Unterminated string constant.", UnterminatedTemplate: "Unterminated template.", UsingDeclarationHasBindingPattern: "Using declaration cannot have destructuring patterns.", VarRedeclaration: (t3) => {
              let { identifierName: r } = t3;
              return `Identifier '${r}' has already been declared.`;
            }, YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator.", YieldInParameter: "Yield expression is not allowed in formal parameters.", ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0." }, L = { StrictDelete: "Deleting local variable in strict mode.", StrictEvalArguments: (t3) => {
              let { referenceName: r } = t3;
              return `Assigning to '${r}' in strict mode.`;
            }, StrictEvalArgumentsBinding: (t3) => {
              let { bindingName: r } = t3;
              return `Binding '${r}' in strict mode.`;
            }, StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block.", StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'.", StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode.", StrictWith: "'with' in strict mode." }, j = /* @__PURE__ */ new Set(["ArrowFunctionExpression", "AssignmentExpression", "ConditionalExpression", "YieldExpression"]), k = { PipeBodyIsTighter: "Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence.", PipeTopicRequiresHackPipes: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.', PipeTopicUnbound: "Topic reference is unbound; it must be inside a pipe body.", PipeTopicUnconfiguredToken: (t3) => {
              let { token: r } = t3;
              return `Invalid topic token ${r}. In order to use ${r} as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "${r}" }.`;
            }, PipeTopicUnused: "Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once.", PipeUnparenthesizedBody: (t3) => {
              let { type: r } = t3;
              return `Hack-style pipe body cannot be an unparenthesized ${I({ type: r })}; please wrap it in parentheses.`;
            }, PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.', PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression.", PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression.", PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference.", PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding.", PrimaryTopicRequiresSmartPipeline: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.' }, z = ["toMessage"], G = ["message"];
            function B(t3) {
              let { toMessage: r } = t3, e = u(t3, z);
              return function s(i) {
                let { loc: a, details: n } = i;
                return T(SyntaxError, Object.assign({}, e, { loc: a }), { clone() {
                  let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = o.loc || {};
                  return s({ loc: new d("line" in c ? c.line : this.loc.line, "column" in c ? c.column : this.loc.column, "index" in c ? c.index : this.loc.index), details: Object.assign({}, this.details, o.details) });
                }, details: { value: n, enumerable: false }, message: { get() {
                  return `${r(this.details)} (${this.loc.line}:${this.loc.column})`;
                }, set(o) {
                  Object.defineProperty(this, "message", { value: o });
                } }, pos: { reflect: "loc.index", enumerable: true }, missingPlugin: "missingPlugin" in n && { reflect: "details.missingPlugin", enumerable: true } });
              };
            }
            function _(t3, r) {
              if (Array.isArray(t3))
                return (s) => _(s, t3[0]);
              let e = {};
              for (let s of Object.keys(t3)) {
                let i = t3[s], a = typeof i == "string" ? { message: () => i } : typeof i == "function" ? { message: i } : i, { message: n } = a, o = u(a, G), c = typeof n == "string" ? () => n : n;
                e[s] = B(Object.assign({ code: A.SyntaxError, reasonCode: s, toMessage: c }, r ? { syntaxPlugin: r } : {}, o));
              }
              return e;
            }
            var h = Object.assign({}, _(S), _(E), _(L), _`pipelineOperator`(k)), { defineProperty: J } = Object, ae = (t3, r) => J(t3, r, { enumerable: false, value: t3[r] });
            function Y(t3) {
              return t3.loc.start && ae(t3.loc.start, "index"), t3.loc.end && ae(t3.loc.end, "index"), t3;
            }
            var Me = (t3) => class extends t3 {
              parse() {
                let e = Y(super.parse());
                return this.options.tokens && (e.tokens = e.tokens.map(Y)), e;
              }
              parseRegExpLiteral(e) {
                let { pattern: s, flags: i } = e, a = null;
                try {
                  a = new RegExp(s, i);
                } catch {
                }
                let n = this.estreeParseLiteral(a);
                return n.regex = { pattern: s, flags: i }, n;
              }
              parseBigIntLiteral(e) {
                let s;
                try {
                  s = BigInt(e);
                } catch {
                  s = null;
                }
                let i = this.estreeParseLiteral(s);
                return i.bigint = String(i.value || e), i;
              }
              parseDecimalLiteral(e) {
                let i = this.estreeParseLiteral(null);
                return i.decimal = String(i.value || e), i;
              }
              estreeParseLiteral(e) {
                return this.parseLiteral(e, "Literal");
              }
              parseStringLiteral(e) {
                return this.estreeParseLiteral(e);
              }
              parseNumericLiteral(e) {
                return this.estreeParseLiteral(e);
              }
              parseNullLiteral() {
                return this.estreeParseLiteral(null);
              }
              parseBooleanLiteral(e) {
                return this.estreeParseLiteral(e);
              }
              directiveToStmt(e) {
                let s = e.value;
                delete e.value, s.type = "Literal", s.raw = s.extra.raw, s.value = s.extra.expressionValue;
                let i = e;
                return i.type = "ExpressionStatement", i.expression = s, i.directive = s.extra.rawValue, delete s.extra, i;
              }
              initFunction(e, s) {
                super.initFunction(e, s), e.expression = false;
              }
              checkDeclaration(e) {
                e != null && this.isObjectProperty(e) ? this.checkDeclaration(e.value) : super.checkDeclaration(e);
              }
              getObjectOrClassMethodParams(e) {
                return e.value.params;
              }
              isValidDirective(e) {
                var s;
                return e.type === "ExpressionStatement" && e.expression.type === "Literal" && typeof e.expression.value == "string" && !((s = e.expression.extra) != null && s.parenthesized);
              }
              parseBlockBody(e, s, i, a, n) {
                super.parseBlockBody(e, s, i, a, n);
                let o = e.directives.map((c) => this.directiveToStmt(c));
                e.body = o.concat(e.body), delete e.directives;
              }
              pushClassMethod(e, s, i, a, n, o) {
                this.parseMethod(s, i, a, n, o, "ClassMethod", true), s.typeParameters && (s.value.typeParameters = s.typeParameters, delete s.typeParameters), e.body.push(s);
              }
              parsePrivateName() {
                let e = super.parsePrivateName();
                return this.getPluginOption("estree", "classFeatures") ? this.convertPrivateNameToPrivateIdentifier(e) : e;
              }
              convertPrivateNameToPrivateIdentifier(e) {
                let s = super.getPrivateNameSV(e);
                return e = e, delete e.id, e.name = s, e.type = "PrivateIdentifier", e;
              }
              isPrivateName(e) {
                return this.getPluginOption("estree", "classFeatures") ? e.type === "PrivateIdentifier" : super.isPrivateName(e);
              }
              getPrivateNameSV(e) {
                return this.getPluginOption("estree", "classFeatures") ? e.name : super.getPrivateNameSV(e);
              }
              parseLiteral(e, s) {
                let i = super.parseLiteral(e, s);
                return i.raw = i.extra.raw, delete i.extra, i;
              }
              parseFunctionBody(e, s) {
                let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                super.parseFunctionBody(e, s, i), e.expression = e.body.type !== "BlockStatement";
              }
              parseMethod(e, s, i, a, n, o) {
                let c = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, p = this.startNode();
                return p.kind = e.kind, p = super.parseMethod(p, s, i, a, n, o, c), p.type = "FunctionExpression", delete p.kind, e.value = p, o === "ClassPrivateMethod" && (e.computed = false), this.finishNode(e, "MethodDefinition");
              }
              parseClassProperty() {
                let e = super.parseClassProperty(...arguments);
                return this.getPluginOption("estree", "classFeatures") && (e.type = "PropertyDefinition"), e;
              }
              parseClassPrivateProperty() {
                let e = super.parseClassPrivateProperty(...arguments);
                return this.getPluginOption("estree", "classFeatures") && (e.type = "PropertyDefinition", e.computed = false), e;
              }
              parseObjectMethod(e, s, i, a, n) {
                let o = super.parseObjectMethod(e, s, i, a, n);
                return o && (o.type = "Property", o.kind === "method" && (o.kind = "init"), o.shorthand = false), o;
              }
              parseObjectProperty(e, s, i, a) {
                let n = super.parseObjectProperty(e, s, i, a);
                return n && (n.kind = "init", n.type = "Property"), n;
              }
              isValidLVal(e, s, i) {
                return e === "Property" ? "value" : super.isValidLVal(e, s, i);
              }
              isAssignable(e, s) {
                return e != null && this.isObjectProperty(e) ? this.isAssignable(e.value, s) : super.isAssignable(e, s);
              }
              toAssignable(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (e != null && this.isObjectProperty(e)) {
                  let { key: i, value: a } = e;
                  this.isPrivateName(i) && this.classScope.usePrivateName(this.getPrivateNameSV(i), i.loc.start), this.toAssignable(a, s);
                } else
                  super.toAssignable(e, s);
              }
              toAssignableObjectExpressionProp(e, s, i) {
                e.kind === "get" || e.kind === "set" ? this.raise(h.PatternHasAccessor, { at: e.key }) : e.method ? this.raise(h.PatternHasMethod, { at: e.key }) : super.toAssignableObjectExpressionProp(e, s, i);
              }
              finishCallExpression(e, s) {
                let i = super.finishCallExpression(e, s);
                if (i.callee.type === "Import") {
                  if (i.type = "ImportExpression", i.source = i.arguments[0], this.hasPlugin("importAssertions")) {
                    var a;
                    i.attributes = (a = i.arguments[1]) != null ? a : null;
                  }
                  delete i.arguments, delete i.callee;
                }
                return i;
              }
              toReferencedArguments(e) {
                e.type !== "ImportExpression" && super.toReferencedArguments(e);
              }
              parseExport(e, s) {
                let i = this.state.lastTokStartLoc, a = super.parseExport(e, s);
                switch (a.type) {
                  case "ExportAllDeclaration":
                    a.exported = null;
                    break;
                  case "ExportNamedDeclaration":
                    a.specifiers.length === 1 && a.specifiers[0].type === "ExportNamespaceSpecifier" && (a.type = "ExportAllDeclaration", a.exported = a.specifiers[0].exported, delete a.specifiers);
                  case "ExportDefaultDeclaration":
                    {
                      var n;
                      let { declaration: o } = a;
                      (o == null ? void 0 : o.type) === "ClassDeclaration" && ((n = o.decorators) == null ? void 0 : n.length) > 0 && o.start === a.start && this.resetStartLocation(a, i);
                    }
                    break;
                }
                return a;
              }
              parseSubscript(e, s, i, a) {
                let n = super.parseSubscript(e, s, i, a);
                if (a.optionalChainMember) {
                  if ((n.type === "OptionalMemberExpression" || n.type === "OptionalCallExpression") && (n.type = n.type.substring(8)), a.stop) {
                    let o = this.startNodeAtNode(n);
                    return o.expression = n, this.finishNode(o, "ChainExpression");
                  }
                } else
                  (n.type === "MemberExpression" || n.type === "CallExpression") && (n.optional = false);
                return n;
              }
              hasPropertyAsPrivateName(e) {
                return e.type === "ChainExpression" && (e = e.expression), super.hasPropertyAsPrivateName(e);
              }
              isOptionalChain(e) {
                return e.type === "ChainExpression";
              }
              isObjectProperty(e) {
                return e.type === "Property" && e.kind === "init" && !e.method;
              }
              isObjectMethod(e) {
                return e.method || e.kind === "get" || e.kind === "set";
              }
              finishNodeAt(e, s, i) {
                return Y(super.finishNodeAt(e, s, i));
              }
              resetStartLocation(e, s) {
                super.resetStartLocation(e, s), Y(e);
              }
              resetEndLocation(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
                super.resetEndLocation(e, s), Y(e);
              }
            }, ee = class {
              constructor(t3, r) {
                this.token = void 0, this.preserveSpace = void 0, this.token = t3, this.preserveSpace = !!r;
              }
            }, H = { brace: new ee("{"), j_oTag: new ee("<tag"), j_cTag: new ee("</tag"), j_expr: new ee("<tag>...</tag>", true) };
            H.template = new ee("`", true);
            var M = true, v = true, We = true, te = true, he = true, Co = true, ur = class {
              constructor(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.label = void 0, this.keyword = void 0, this.beforeExpr = void 0, this.startsExpr = void 0, this.rightAssociative = void 0, this.isLoop = void 0, this.isAssign = void 0, this.prefix = void 0, this.postfix = void 0, this.binop = void 0, this.label = t3, this.keyword = r.keyword, this.beforeExpr = !!r.beforeExpr, this.startsExpr = !!r.startsExpr, this.rightAssociative = !!r.rightAssociative, this.isLoop = !!r.isLoop, this.isAssign = !!r.isAssign, this.prefix = !!r.prefix, this.postfix = !!r.postfix, this.binop = r.binop != null ? r.binop : null, this.updateContext = null;
              }
            }, qt = /* @__PURE__ */ new Map();
            function U(t3) {
              let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              r.keyword = t3;
              let e = N(t3, r);
              return qt.set(t3, e), e;
            }
            function ie(t3, r) {
              return N(t3, { beforeExpr: M, binop: r });
            }
            var Ge = -1, ce = [], Ut = [], Ht = [], $t = [], zt = [], Vt = [];
            function N(t3) {
              let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              var e, s, i, a;
              return ++Ge, Ut.push(t3), Ht.push((e = r.binop) != null ? e : -1), $t.push((s = r.beforeExpr) != null ? s : false), zt.push((i = r.startsExpr) != null ? i : false), Vt.push((a = r.prefix) != null ? a : false), ce.push(new ur(t3, r)), Ge;
            }
            function q(t3) {
              let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              var e, s, i, a;
              return ++Ge, qt.set(t3, Ge), Ut.push(t3), Ht.push((e = r.binop) != null ? e : -1), $t.push((s = r.beforeExpr) != null ? s : false), zt.push((i = r.startsExpr) != null ? i : false), Vt.push((a = r.prefix) != null ? a : false), ce.push(new ur("name", r)), Ge;
            }
            var bo = { bracketL: N("[", { beforeExpr: M, startsExpr: v }), bracketHashL: N("#[", { beforeExpr: M, startsExpr: v }), bracketBarL: N("[|", { beforeExpr: M, startsExpr: v }), bracketR: N("]"), bracketBarR: N("|]"), braceL: N("{", { beforeExpr: M, startsExpr: v }), braceBarL: N("{|", { beforeExpr: M, startsExpr: v }), braceHashL: N("#{", { beforeExpr: M, startsExpr: v }), braceR: N("}"), braceBarR: N("|}"), parenL: N("(", { beforeExpr: M, startsExpr: v }), parenR: N(")"), comma: N(",", { beforeExpr: M }), semi: N(";", { beforeExpr: M }), colon: N(":", { beforeExpr: M }), doubleColon: N("::", { beforeExpr: M }), dot: N("."), question: N("?", { beforeExpr: M }), questionDot: N("?."), arrow: N("=>", { beforeExpr: M }), template: N("template"), ellipsis: N("...", { beforeExpr: M }), backQuote: N("`", { startsExpr: v }), dollarBraceL: N("${", { beforeExpr: M, startsExpr: v }), templateTail: N("...`", { startsExpr: v }), templateNonTail: N("...${", { beforeExpr: M, startsExpr: v }), at: N("@"), hash: N("#", { startsExpr: v }), interpreterDirective: N("#!..."), eq: N("=", { beforeExpr: M, isAssign: te }), assign: N("_=", { beforeExpr: M, isAssign: te }), slashAssign: N("_=", { beforeExpr: M, isAssign: te }), xorAssign: N("_=", { beforeExpr: M, isAssign: te }), moduloAssign: N("_=", { beforeExpr: M, isAssign: te }), incDec: N("++/--", { prefix: he, postfix: Co, startsExpr: v }), bang: N("!", { beforeExpr: M, prefix: he, startsExpr: v }), tilde: N("~", { beforeExpr: M, prefix: he, startsExpr: v }), doubleCaret: N("^^", { startsExpr: v }), doubleAt: N("@@", { startsExpr: v }), pipeline: ie("|>", 0), nullishCoalescing: ie("??", 1), logicalOR: ie("||", 1), logicalAND: ie("&&", 2), bitwiseOR: ie("|", 3), bitwiseXOR: ie("^", 4), bitwiseAND: ie("&", 5), equality: ie("==/!=/===/!==", 6), lt: ie("</>/<=/>=", 7), gt: ie("</>/<=/>=", 7), relational: ie("</>/<=/>=", 7), bitShift: ie("<</>>/>>>", 8), bitShiftL: ie("<</>>/>>>", 8), bitShiftR: ie("<</>>/>>>", 8), plusMin: N("+/-", { beforeExpr: M, binop: 9, prefix: he, startsExpr: v }), modulo: N("%", { binop: 10, startsExpr: v }), star: N("*", { binop: 10 }), slash: ie("/", 10), exponent: N("**", { beforeExpr: M, binop: 11, rightAssociative: true }), _in: U("in", { beforeExpr: M, binop: 7 }), _instanceof: U("instanceof", { beforeExpr: M, binop: 7 }), _break: U("break"), _case: U("case", { beforeExpr: M }), _catch: U("catch"), _continue: U("continue"), _debugger: U("debugger"), _default: U("default", { beforeExpr: M }), _else: U("else", { beforeExpr: M }), _finally: U("finally"), _function: U("function", { startsExpr: v }), _if: U("if"), _return: U("return", { beforeExpr: M }), _switch: U("switch"), _throw: U("throw", { beforeExpr: M, prefix: he, startsExpr: v }), _try: U("try"), _var: U("var"), _const: U("const"), _with: U("with"), _new: U("new", { beforeExpr: M, startsExpr: v }), _this: U("this", { startsExpr: v }), _super: U("super", { startsExpr: v }), _class: U("class", { startsExpr: v }), _extends: U("extends", { beforeExpr: M }), _export: U("export"), _import: U("import", { startsExpr: v }), _null: U("null", { startsExpr: v }), _true: U("true", { startsExpr: v }), _false: U("false", { startsExpr: v }), _typeof: U("typeof", { beforeExpr: M, prefix: he, startsExpr: v }), _void: U("void", { beforeExpr: M, prefix: he, startsExpr: v }), _delete: U("delete", { beforeExpr: M, prefix: he, startsExpr: v }), _do: U("do", { isLoop: We, beforeExpr: M }), _for: U("for", { isLoop: We }), _while: U("while", { isLoop: We }), _as: q("as", { startsExpr: v }), _assert: q("assert", { startsExpr: v }), _async: q("async", { startsExpr: v }), _await: q("await", { startsExpr: v }), _from: q("from", { startsExpr: v }), _get: q("get", { startsExpr: v }), _let: q("let", { startsExpr: v }), _meta: q("meta", { startsExpr: v }), _of: q("of", { startsExpr: v }), _sent: q("sent", { startsExpr: v }), _set: q("set", { startsExpr: v }), _static: q("static", { startsExpr: v }), _using: q("using", { startsExpr: v }), _yield: q("yield", { startsExpr: v }), _asserts: q("asserts", { startsExpr: v }), _checks: q("checks", { startsExpr: v }), _exports: q("exports", { startsExpr: v }), _global: q("global", { startsExpr: v }), _implements: q("implements", { startsExpr: v }), _intrinsic: q("intrinsic", { startsExpr: v }), _infer: q("infer", { startsExpr: v }), _is: q("is", { startsExpr: v }), _mixins: q("mixins", { startsExpr: v }), _proto: q("proto", { startsExpr: v }), _require: q("require", { startsExpr: v }), _satisfies: q("satisfies", { startsExpr: v }), _keyof: q("keyof", { startsExpr: v }), _readonly: q("readonly", { startsExpr: v }), _unique: q("unique", { startsExpr: v }), _abstract: q("abstract", { startsExpr: v }), _declare: q("declare", { startsExpr: v }), _enum: q("enum", { startsExpr: v }), _module: q("module", { startsExpr: v }), _namespace: q("namespace", { startsExpr: v }), _interface: q("interface", { startsExpr: v }), _type: q("type", { startsExpr: v }), _opaque: q("opaque", { startsExpr: v }), name: N("name", { startsExpr: v }), string: N("string", { startsExpr: v }), num: N("num", { startsExpr: v }), bigint: N("bigint", { startsExpr: v }), decimal: N("decimal", { startsExpr: v }), regexp: N("regexp", { startsExpr: v }), privateName: N("#name", { startsExpr: v }), eof: N("eof"), jsxName: N("jsxName"), jsxText: N("jsxText", { beforeExpr: true }), jsxTagStart: N("jsxTagStart", { startsExpr: true }), jsxTagEnd: N("jsxTagEnd"), placeholder: N("%%", { startsExpr: true }) };
            function $(t3) {
              return t3 >= 93 && t3 <= 130;
            }
            function So(t3) {
              return t3 <= 92;
            }
            function pe(t3) {
              return t3 >= 58 && t3 <= 130;
            }
            function cr(t3) {
              return t3 >= 58 && t3 <= 134;
            }
            function wo(t3) {
              return $t[t3];
            }
            function Kt(t3) {
              return zt[t3];
            }
            function Io(t3) {
              return t3 >= 29 && t3 <= 33;
            }
            function pr(t3) {
              return t3 >= 127 && t3 <= 129;
            }
            function No(t3) {
              return t3 >= 90 && t3 <= 92;
            }
            function Wt(t3) {
              return t3 >= 58 && t3 <= 92;
            }
            function ko(t3) {
              return t3 >= 39 && t3 <= 59;
            }
            function Do(t3) {
              return t3 === 34;
            }
            function Fo(t3) {
              return Vt[t3];
            }
            function Lo(t3) {
              return t3 >= 119 && t3 <= 121;
            }
            function Oo(t3) {
              return t3 >= 122 && t3 <= 128;
            }
            function Pe(t3) {
              return Ut[t3];
            }
            function nt(t3) {
              return Ht[t3];
            }
            function Mo(t3) {
              return t3 === 57;
            }
            function ot(t3) {
              return t3 >= 24 && t3 <= 25;
            }
            function de(t3) {
              return ce[t3];
            }
            ce[8].updateContext = (t3) => {
              t3.pop();
            }, ce[5].updateContext = ce[7].updateContext = ce[23].updateContext = (t3) => {
              t3.push(H.brace);
            }, ce[22].updateContext = (t3) => {
              t3[t3.length - 1] === H.template ? t3.pop() : t3.push(H.template);
            }, ce[140].updateContext = (t3) => {
              t3.push(H.j_expr, H.j_oTag);
            };
            var Gt = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", dr = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F", Bo = new RegExp("[" + Gt + "]"), _o = new RegExp("[" + Gt + dr + "]");
            Gt = dr = null;
            var fr = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938, 6, 4191], Ro = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
            function Jt(t3, r) {
              let e = 65536;
              for (let s = 0, i = r.length; s < i; s += 2) {
                if (e += r[s], e > t3)
                  return false;
                if (e += r[s + 1], e >= t3)
                  return true;
              }
              return false;
            }
            function fe(t3) {
              return t3 < 65 ? t3 === 36 : t3 <= 90 ? true : t3 < 97 ? t3 === 95 : t3 <= 122 ? true : t3 <= 65535 ? t3 >= 170 && Bo.test(String.fromCharCode(t3)) : Jt(t3, fr);
            }
            function Be(t3) {
              return t3 < 48 ? t3 === 36 : t3 < 58 ? true : t3 < 65 ? false : t3 <= 90 ? true : t3 < 97 ? t3 === 95 : t3 <= 122 ? true : t3 <= 65535 ? t3 >= 170 && _o.test(String.fromCharCode(t3)) : Jt(t3, fr) || Jt(t3, Ro);
            }
            var Xt = { keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"], strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"], strictBind: ["eval", "arguments"] }, jo = new Set(Xt.keyword), qo = new Set(Xt.strict), Uo = new Set(Xt.strictBind);
            function mr(t3, r) {
              return r && t3 === "await" || t3 === "enum";
            }
            function yr(t3, r) {
              return mr(t3, r) || qo.has(t3);
            }
            function xr(t3) {
              return Uo.has(t3);
            }
            function gr(t3, r) {
              return yr(t3, r) || xr(t3);
            }
            function Ho(t3) {
              return jo.has(t3);
            }
            function $o(t3, r, e) {
              return t3 === 64 && r === 64 && fe(e);
            }
            var zo = /* @__PURE__ */ new Set(["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete", "implements", "interface", "let", "package", "private", "protected", "public", "static", "yield", "eval", "arguments", "enum", "await"]);
            function Vo(t3) {
              return zo.has(t3);
            }
            var _e = 0, Re = 1, me = 2, Yt = 4, Pr = 8, lt2 = 16, Ar = 32, Se = 64, ht = 128, je = 256, ut = Re | me | ht | je, ye = 1, we = 2, Tr = 4, Ae = 8, ct = 16, vr = 64, pt = 128, Qt = 256, Zt = 512, es = 1024, ts = 2048, Je = 4096, Er = ye | we | Ae | pt, Ie = ye | 0 | Ae | 0, dt = ye | 0 | Tr | 0, Cr = ye | 0 | ct | 0, Ko = 0 | we | 0 | pt, Wo = 0 | we | 0 | 0, br = ye | we | Ae | Qt, Sr = 0 | es, Te = 0 | vr, Go = ye | 0 | 0 | vr, Jo = br | Zt, Xo = 0 | es, wr = 0 | we | 0 | Je, Yo = ts, ft = 4, ss = 2, rs = 1, is = ss | rs, Qo = ss | ft, Zo = rs | ft, el = ss, tl = rs, as = 0, ns = class {
              constructor(t3) {
                this.var = /* @__PURE__ */ new Set(), this.lexical = /* @__PURE__ */ new Set(), this.functions = /* @__PURE__ */ new Set(), this.flags = t3;
              }
            }, os = class {
              constructor(t3, r) {
                this.parser = void 0, this.scopeStack = [], this.inModule = void 0, this.undefinedExports = /* @__PURE__ */ new Map(), this.parser = t3, this.inModule = r;
              }
              get inTopLevel() {
                return (this.currentScope().flags & Re) > 0;
              }
              get inFunction() {
                return (this.currentVarScopeFlags() & me) > 0;
              }
              get allowSuper() {
                return (this.currentThisScopeFlags() & lt2) > 0;
              }
              get allowDirectSuper() {
                return (this.currentThisScopeFlags() & Ar) > 0;
              }
              get inClass() {
                return (this.currentThisScopeFlags() & Se) > 0;
              }
              get inClassAndNotInNonArrowFunction() {
                let t3 = this.currentThisScopeFlags();
                return (t3 & Se) > 0 && (t3 & me) === 0;
              }
              get inStaticBlock() {
                for (let t3 = this.scopeStack.length - 1; ; t3--) {
                  let { flags: r } = this.scopeStack[t3];
                  if (r & ht)
                    return true;
                  if (r & (ut | Se))
                    return false;
                }
              }
              get inNonArrowFunction() {
                return (this.currentThisScopeFlags() & me) > 0;
              }
              get treatFunctionsAsVar() {
                return this.treatFunctionsAsVarInScope(this.currentScope());
              }
              createScope(t3) {
                return new ns(t3);
              }
              enter(t3) {
                this.scopeStack.push(this.createScope(t3));
              }
              exit() {
                return this.scopeStack.pop().flags;
              }
              treatFunctionsAsVarInScope(t3) {
                return !!(t3.flags & (me | ht) || !this.parser.inModule && t3.flags & Re);
              }
              declareName(t3, r, e) {
                let s = this.currentScope();
                if (r & Ae || r & ct)
                  this.checkRedeclarationInScope(s, t3, r, e), r & ct ? s.functions.add(t3) : s.lexical.add(t3), r & Ae && this.maybeExportDefined(s, t3);
                else if (r & Tr)
                  for (let i = this.scopeStack.length - 1; i >= 0 && (s = this.scopeStack[i], this.checkRedeclarationInScope(s, t3, r, e), s.var.add(t3), this.maybeExportDefined(s, t3), !(s.flags & ut)); --i)
                    ;
                this.parser.inModule && s.flags & Re && this.undefinedExports.delete(t3);
              }
              maybeExportDefined(t3, r) {
                this.parser.inModule && t3.flags & Re && this.undefinedExports.delete(r);
              }
              checkRedeclarationInScope(t3, r, e, s) {
                this.isRedeclaredInScope(t3, r, e) && this.parser.raise(h.VarRedeclaration, { at: s, identifierName: r });
              }
              isRedeclaredInScope(t3, r, e) {
                return e & ye ? e & Ae ? t3.lexical.has(r) || t3.functions.has(r) || t3.var.has(r) : e & ct ? t3.lexical.has(r) || !this.treatFunctionsAsVarInScope(t3) && t3.var.has(r) : t3.lexical.has(r) && !(t3.flags & Pr && t3.lexical.values().next().value === r) || !this.treatFunctionsAsVarInScope(t3) && t3.functions.has(r) : false;
              }
              checkLocalExport(t3) {
                let { name: r } = t3, e = this.scopeStack[0];
                !e.lexical.has(r) && !e.var.has(r) && !e.functions.has(r) && this.undefinedExports.set(r, t3.loc.start);
              }
              currentScope() {
                return this.scopeStack[this.scopeStack.length - 1];
              }
              currentVarScopeFlags() {
                for (let t3 = this.scopeStack.length - 1; ; t3--) {
                  let { flags: r } = this.scopeStack[t3];
                  if (r & ut)
                    return r;
                }
              }
              currentThisScopeFlags() {
                for (let t3 = this.scopeStack.length - 1; ; t3--) {
                  let { flags: r } = this.scopeStack[t3];
                  if (r & (ut | Se) && !(r & Yt))
                    return r;
                }
              }
            }, sl = class extends ns {
              constructor() {
                super(...arguments), this.declareFunctions = /* @__PURE__ */ new Set();
              }
            }, rl = class extends os {
              createScope(t3) {
                return new sl(t3);
              }
              declareName(t3, r, e) {
                let s = this.currentScope();
                if (r & ts) {
                  this.checkRedeclarationInScope(s, t3, r, e), this.maybeExportDefined(s, t3), s.declareFunctions.add(t3);
                  return;
                }
                super.declareName(t3, r, e);
              }
              isRedeclaredInScope(t3, r, e) {
                return super.isRedeclaredInScope(t3, r, e) ? true : e & ts ? !t3.declareFunctions.has(r) && (t3.lexical.has(r) || t3.functions.has(r)) : false;
              }
              checkLocalExport(t3) {
                this.scopeStack[0].declareFunctions.has(t3.name) || super.checkLocalExport(t3);
              }
            }, il = class {
              constructor() {
                this.sawUnambiguousESM = false, this.ambiguousScriptDifferentAst = false;
              }
              hasPlugin(t3) {
                if (typeof t3 == "string")
                  return this.plugins.has(t3);
                {
                  let [r, e] = t3;
                  if (!this.hasPlugin(r))
                    return false;
                  let s = this.plugins.get(r);
                  for (let i of Object.keys(e))
                    if ((s == null ? void 0 : s[i]) !== e[i])
                      return false;
                  return true;
                }
              }
              getPluginOption(t3, r) {
                var e;
                return (e = this.plugins.get(t3)) == null ? void 0 : e[r];
              }
            };
            function Ir(t3, r) {
              t3.trailingComments === void 0 ? t3.trailingComments = r : t3.trailingComments.unshift(...r);
            }
            function al(t3, r) {
              t3.leadingComments === void 0 ? t3.leadingComments = r : t3.leadingComments.unshift(...r);
            }
            function Xe(t3, r) {
              t3.innerComments === void 0 ? t3.innerComments = r : t3.innerComments.unshift(...r);
            }
            function Ye(t3, r, e) {
              let s = null, i = r.length;
              for (; s === null && i > 0; )
                s = r[--i];
              s === null || s.start > e.start ? Xe(t3, e.comments) : Ir(s, e.comments);
            }
            var nl = class extends il {
              addComment(t3) {
                this.filename && (t3.loc.filename = this.filename), this.state.comments.push(t3);
              }
              processComment(t3) {
                let { commentStack: r } = this.state, e = r.length;
                if (e === 0)
                  return;
                let s = e - 1, i = r[s];
                i.start === t3.end && (i.leadingNode = t3, s--);
                let { start: a } = t3;
                for (; s >= 0; s--) {
                  let n = r[s], o = n.end;
                  if (o > a)
                    n.containingNode = t3, this.finalizeComment(n), r.splice(s, 1);
                  else {
                    o === a && (n.trailingNode = t3);
                    break;
                  }
                }
              }
              finalizeComment(t3) {
                let { comments: r } = t3;
                if (t3.leadingNode !== null || t3.trailingNode !== null)
                  t3.leadingNode !== null && Ir(t3.leadingNode, r), t3.trailingNode !== null && al(t3.trailingNode, r);
                else {
                  let { containingNode: e, start: s } = t3;
                  if (this.input.charCodeAt(s - 1) === 44)
                    switch (e.type) {
                      case "ObjectExpression":
                      case "ObjectPattern":
                      case "RecordExpression":
                        Ye(e, e.properties, t3);
                        break;
                      case "CallExpression":
                      case "OptionalCallExpression":
                        Ye(e, e.arguments, t3);
                        break;
                      case "FunctionDeclaration":
                      case "FunctionExpression":
                      case "ArrowFunctionExpression":
                      case "ObjectMethod":
                      case "ClassMethod":
                      case "ClassPrivateMethod":
                        Ye(e, e.params, t3);
                        break;
                      case "ArrayExpression":
                      case "ArrayPattern":
                      case "TupleExpression":
                        Ye(e, e.elements, t3);
                        break;
                      case "ExportNamedDeclaration":
                      case "ImportDeclaration":
                        Ye(e, e.specifiers, t3);
                        break;
                      default:
                        Xe(e, r);
                    }
                  else
                    Xe(e, r);
                }
              }
              finalizeRemainingComments() {
                let { commentStack: t3 } = this.state;
                for (let r = t3.length - 1; r >= 0; r--)
                  this.finalizeComment(t3[r]);
                this.state.commentStack = [];
              }
              resetPreviousNodeTrailingComments(t3) {
                let { commentStack: r } = this.state, { length: e } = r;
                if (e === 0)
                  return;
                let s = r[e - 1];
                s.leadingNode === t3 && (s.leadingNode = null);
              }
              takeSurroundingComments(t3, r, e) {
                let { commentStack: s } = this.state, i = s.length;
                if (i === 0)
                  return;
                let a = i - 1;
                for (; a >= 0; a--) {
                  let n = s[a], o = n.end;
                  if (n.start === e)
                    n.leadingNode = t3;
                  else if (o === r)
                    n.trailingNode = t3;
                  else if (o < r)
                    break;
                }
              }
            }, ls = /\r\n?|[\n\u2028\u2029]/, mt = new RegExp(ls.source, "g");
            function Qe(t3) {
              switch (t3) {
                case 10:
                case 13:
                case 8232:
                case 8233:
                  return true;
                default:
                  return false;
              }
            }
            var hs = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, ol = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/y, Nr = new RegExp("(?=(" + ol.source + "))\\1" + /(?=[\n\r\u2028\u2029]|\/\*(?!.*?\*\/)|$)/.source, "y");
            function ll(t3) {
              switch (t3) {
                case 9:
                case 11:
                case 12:
                case 32:
                case 160:
                case 5760:
                case 8192:
                case 8193:
                case 8194:
                case 8195:
                case 8196:
                case 8197:
                case 8198:
                case 8199:
                case 8200:
                case 8201:
                case 8202:
                case 8239:
                case 8287:
                case 12288:
                case 65279:
                  return true;
                default:
                  return false;
              }
            }
            var kr = class {
              constructor() {
                this.strict = void 0, this.curLine = void 0, this.lineStart = void 0, this.startLoc = void 0, this.endLoc = void 0, this.errors = [], this.potentialArrowAt = -1, this.noArrowAt = [], this.noArrowParamsConversionAt = [], this.maybeInArrowParameters = false, this.inType = false, this.noAnonFunctionType = false, this.hasFlowComment = false, this.isAmbientContext = false, this.inAbstractClass = false, this.inDisallowConditionalTypesContext = false, this.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null }, this.soloAwait = false, this.inFSharpPipelineDirectBody = false, this.labels = [], this.comments = [], this.commentStack = [], this.pos = 0, this.type = 137, this.value = null, this.start = 0, this.end = 0, this.lastTokEndLoc = null, this.lastTokStartLoc = null, this.lastTokStart = 0, this.context = [H.brace], this.canStartJSXElement = true, this.containsEsc = false, this.firstInvalidTemplateEscapePos = null, this.strictErrors = /* @__PURE__ */ new Map(), this.tokensLength = 0;
              }
              init(t3) {
                let { strictMode: r, sourceType: e, startLine: s, startColumn: i } = t3;
                this.strict = r === false ? false : r === true ? true : e === "module", this.curLine = s, this.lineStart = -i, this.startLoc = this.endLoc = new d(s, i, 0);
              }
              curPosition() {
                return new d(this.curLine, this.pos - this.lineStart, this.pos);
              }
              clone(t3) {
                let r = new kr(), e = Object.keys(this);
                for (let s = 0, i = e.length; s < i; s++) {
                  let a = e[s], n = this[a];
                  !t3 && Array.isArray(n) && (n = n.slice()), r[a] = n;
                }
                return r;
              }
            }, hl = function(r) {
              return r >= 48 && r <= 57;
            }, Dr = { decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]), hex: /* @__PURE__ */ new Set([46, 88, 95, 120]) }, yt = { bin: (t3) => t3 === 48 || t3 === 49, oct: (t3) => t3 >= 48 && t3 <= 55, dec: (t3) => t3 >= 48 && t3 <= 57, hex: (t3) => t3 >= 48 && t3 <= 57 || t3 >= 65 && t3 <= 70 || t3 >= 97 && t3 <= 102 };
            function Fr(t3, r, e, s, i, a) {
              let n = e, o = s, c = i, p = "", m = null, x = e, { length: P } = r;
              for (; ; ) {
                if (e >= P) {
                  a.unterminated(n, o, c), p += r.slice(x, e);
                  break;
                }
                let b = r.charCodeAt(e);
                if (ul(t3, b, r, e)) {
                  p += r.slice(x, e);
                  break;
                }
                if (b === 92) {
                  p += r.slice(x, e);
                  let O = cl(r, e, s, i, t3 === "template", a);
                  O.ch === null && !m ? m = { pos: e, lineStart: s, curLine: i } : p += O.ch, { pos: e, lineStart: s, curLine: i } = O, x = e;
                } else
                  b === 8232 || b === 8233 ? (++e, ++i, s = e) : b === 10 || b === 13 ? t3 === "template" ? (p += r.slice(x, e) + `
`, ++e, b === 13 && r.charCodeAt(e) === 10 && ++e, ++i, x = s = e) : a.unterminated(n, o, c) : ++e;
              }
              return { pos: e, str: p, firstInvalidLoc: m, lineStart: s, curLine: i, containsInvalid: !!m };
            }
            function ul(t3, r, e, s) {
              return t3 === "template" ? r === 96 || r === 36 && e.charCodeAt(s + 1) === 123 : r === (t3 === "double" ? 34 : 39);
            }
            function cl(t3, r, e, s, i, a) {
              let n = !i;
              r++;
              let o = (p) => ({ pos: r, ch: p, lineStart: e, curLine: s }), c = t3.charCodeAt(r++);
              switch (c) {
                case 110:
                  return o(`
`);
                case 114:
                  return o("\r");
                case 120: {
                  let p;
                  return { code: p, pos: r } = us(t3, r, e, s, 2, false, n, a), o(p === null ? null : String.fromCharCode(p));
                }
                case 117: {
                  let p;
                  return { code: p, pos: r } = Or(t3, r, e, s, n, a), o(p === null ? null : String.fromCodePoint(p));
                }
                case 116:
                  return o("	");
                case 98:
                  return o("\b");
                case 118:
                  return o("\v");
                case 102:
                  return o("\f");
                case 13:
                  t3.charCodeAt(r) === 10 && ++r;
                case 10:
                  e = r, ++s;
                case 8232:
                case 8233:
                  return o("");
                case 56:
                case 57:
                  if (i)
                    return o(null);
                  a.strictNumericEscape(r - 1, e, s);
                default:
                  if (c >= 48 && c <= 55) {
                    let p = r - 1, x = t3.slice(p, r + 2).match(/^[0-7]+/)[0], P = parseInt(x, 8);
                    P > 255 && (x = x.slice(0, -1), P = parseInt(x, 8)), r += x.length - 1;
                    let b = t3.charCodeAt(r);
                    if (x !== "0" || b === 56 || b === 57) {
                      if (i)
                        return o(null);
                      a.strictNumericEscape(p, e, s);
                    }
                    return o(String.fromCharCode(P));
                  }
                  return o(String.fromCharCode(c));
              }
            }
            function us(t3, r, e, s, i, a, n, o) {
              let c = r, p;
              return { n: p, pos: r } = Lr(t3, r, e, s, 16, i, a, false, o, !n), p === null && (n ? o.invalidEscapeSequence(c, e, s) : r = c - 1), { code: p, pos: r };
            }
            function Lr(t3, r, e, s, i, a, n, o, c, p) {
              let m = r, x = i === 16 ? Dr.hex : Dr.decBinOct, P = i === 16 ? yt.hex : i === 10 ? yt.dec : i === 8 ? yt.oct : yt.bin, b = false, O = 0;
              for (let R = 0, Q = a == null ? 1 / 0 : a; R < Q; ++R) {
                let Z = t3.charCodeAt(r), X;
                if (Z === 95 && o !== "bail") {
                  let re = t3.charCodeAt(r - 1), $e = t3.charCodeAt(r + 1);
                  if (o) {
                    if (Number.isNaN($e) || !P($e) || x.has(re) || x.has($e)) {
                      if (p)
                        return { n: null, pos: r };
                      c.unexpectedNumericSeparator(r, e, s);
                    }
                  } else {
                    if (p)
                      return { n: null, pos: r };
                    c.numericSeparatorInEscapeSequence(r, e, s);
                  }
                  ++r;
                  continue;
                }
                if (Z >= 97 ? X = Z - 97 + 10 : Z >= 65 ? X = Z - 65 + 10 : hl(Z) ? X = Z - 48 : X = 1 / 0, X >= i) {
                  if (X <= 9 && p)
                    return { n: null, pos: r };
                  if (X <= 9 && c.invalidDigit(r, e, s, i))
                    X = 0;
                  else if (n)
                    X = 0, b = true;
                  else
                    break;
                }
                ++r, O = O * i + X;
              }
              return r === m || a != null && r - m !== a || b ? { n: null, pos: r } : { n: O, pos: r };
            }
            function Or(t3, r, e, s, i, a) {
              let n = t3.charCodeAt(r), o;
              if (n === 123) {
                if (++r, { code: o, pos: r } = us(t3, r, e, s, t3.indexOf("}", r) - r, true, i, a), ++r, o !== null && o > 1114111)
                  if (i)
                    a.invalidCodePoint(r, e, s);
                  else
                    return { code: null, pos: r };
              } else
                ({ code: o, pos: r } = us(t3, r, e, s, 4, false, i, a));
              return { code: o, pos: r };
            }
            var pl = ["at"], dl = ["at"];
            function Ze(t3, r, e) {
              return new d(e, t3 - r, t3);
            }
            var fl = /* @__PURE__ */ new Set([103, 109, 115, 105, 121, 117, 100, 118]), ve = class {
              constructor(t3) {
                this.type = t3.type, this.value = t3.value, this.start = t3.start, this.end = t3.end, this.loc = new f(t3.startLoc, t3.endLoc);
              }
            }, ml = class extends nl {
              constructor(t3, r) {
                super(), this.isLookahead = void 0, this.tokens = [], this.errorHandlers_readInt = { invalidDigit: (e, s, i, a) => this.options.errorRecovery ? (this.raise(h.InvalidDigit, { at: Ze(e, s, i), radix: a }), true) : false, numericSeparatorInEscapeSequence: this.errorBuilder(h.NumericSeparatorInEscapeSequence), unexpectedNumericSeparator: this.errorBuilder(h.UnexpectedNumericSeparator) }, this.errorHandlers_readCodePoint = Object.assign({}, this.errorHandlers_readInt, { invalidEscapeSequence: this.errorBuilder(h.InvalidEscapeSequence), invalidCodePoint: this.errorBuilder(h.InvalidCodePoint) }), this.errorHandlers_readStringContents_string = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: (e, s, i) => {
                  this.recordStrictModeErrors(h.StrictNumericEscape, { at: Ze(e, s, i) });
                }, unterminated: (e, s, i) => {
                  throw this.raise(h.UnterminatedString, { at: Ze(e - 1, s, i) });
                } }), this.errorHandlers_readStringContents_template = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: this.errorBuilder(h.StrictNumericEscape), unterminated: (e, s, i) => {
                  throw this.raise(h.UnterminatedTemplate, { at: Ze(e, s, i) });
                } }), this.state = new kr(), this.state.init(t3), this.input = r, this.length = r.length, this.isLookahead = false;
              }
              pushToken(t3) {
                this.tokens.length = this.state.tokensLength, this.tokens.push(t3), ++this.state.tokensLength;
              }
              next() {
                this.checkKeywordEscapes(), this.options.tokens && this.pushToken(new ve(this.state)), this.state.lastTokStart = this.state.start, this.state.lastTokEndLoc = this.state.endLoc, this.state.lastTokStartLoc = this.state.startLoc, this.nextToken();
              }
              eat(t3) {
                return this.match(t3) ? (this.next(), true) : false;
              }
              match(t3) {
                return this.state.type === t3;
              }
              createLookaheadState(t3) {
                return { pos: t3.pos, value: null, type: t3.type, start: t3.start, end: t3.end, context: [this.curContext()], inType: t3.inType, startLoc: t3.startLoc, lastTokEndLoc: t3.lastTokEndLoc, curLine: t3.curLine, lineStart: t3.lineStart, curPosition: t3.curPosition };
              }
              lookahead() {
                let t3 = this.state;
                this.state = this.createLookaheadState(t3), this.isLookahead = true, this.nextToken(), this.isLookahead = false;
                let r = this.state;
                return this.state = t3, r;
              }
              nextTokenStart() {
                return this.nextTokenStartSince(this.state.pos);
              }
              nextTokenStartSince(t3) {
                return hs.lastIndex = t3, hs.test(this.input) ? hs.lastIndex : t3;
              }
              lookaheadCharCode() {
                return this.input.charCodeAt(this.nextTokenStart());
              }
              codePointAtPos(t3) {
                let r = this.input.charCodeAt(t3);
                if ((r & 64512) === 55296 && ++t3 < this.input.length) {
                  let e = this.input.charCodeAt(t3);
                  (e & 64512) === 56320 && (r = 65536 + ((r & 1023) << 10) + (e & 1023));
                }
                return r;
              }
              setStrict(t3) {
                this.state.strict = t3, t3 && (this.state.strictErrors.forEach((r) => {
                  let [e, s] = r;
                  return this.raise(e, { at: s });
                }), this.state.strictErrors.clear());
              }
              curContext() {
                return this.state.context[this.state.context.length - 1];
              }
              nextToken() {
                if (this.skipSpace(), this.state.start = this.state.pos, this.isLookahead || (this.state.startLoc = this.state.curPosition()), this.state.pos >= this.length) {
                  this.finishToken(137);
                  return;
                }
                this.getTokenFromCode(this.codePointAtPos(this.state.pos));
              }
              skipBlockComment(t3) {
                let r;
                this.isLookahead || (r = this.state.curPosition());
                let e = this.state.pos, s = this.input.indexOf(t3, e + 2);
                if (s === -1)
                  throw this.raise(h.UnterminatedComment, { at: this.state.curPosition() });
                for (this.state.pos = s + t3.length, mt.lastIndex = e + 2; mt.test(this.input) && mt.lastIndex <= s; )
                  ++this.state.curLine, this.state.lineStart = mt.lastIndex;
                if (this.isLookahead)
                  return;
                let i = { type: "CommentBlock", value: this.input.slice(e + 2, s), start: e, end: s + t3.length, loc: new f(r, this.state.curPosition()) };
                return this.options.tokens && this.pushToken(i), i;
              }
              skipLineComment(t3) {
                let r = this.state.pos, e;
                this.isLookahead || (e = this.state.curPosition());
                let s = this.input.charCodeAt(this.state.pos += t3);
                if (this.state.pos < this.length)
                  for (; !Qe(s) && ++this.state.pos < this.length; )
                    s = this.input.charCodeAt(this.state.pos);
                if (this.isLookahead)
                  return;
                let i = this.state.pos, a = this.input.slice(r + t3, i), n = { type: "CommentLine", value: a, start: r, end: i, loc: new f(e, this.state.curPosition()) };
                return this.options.tokens && this.pushToken(n), n;
              }
              skipSpace() {
                let t3 = this.state.pos, r = [];
                e:
                  for (; this.state.pos < this.length; ) {
                    let e = this.input.charCodeAt(this.state.pos);
                    switch (e) {
                      case 32:
                      case 160:
                      case 9:
                        ++this.state.pos;
                        break;
                      case 13:
                        this.input.charCodeAt(this.state.pos + 1) === 10 && ++this.state.pos;
                      case 10:
                      case 8232:
                      case 8233:
                        ++this.state.pos, ++this.state.curLine, this.state.lineStart = this.state.pos;
                        break;
                      case 47:
                        switch (this.input.charCodeAt(this.state.pos + 1)) {
                          case 42: {
                            let s = this.skipBlockComment("*/");
                            s !== void 0 && (this.addComment(s), this.options.attachComment && r.push(s));
                            break;
                          }
                          case 47: {
                            let s = this.skipLineComment(2);
                            s !== void 0 && (this.addComment(s), this.options.attachComment && r.push(s));
                            break;
                          }
                          default:
                            break e;
                        }
                        break;
                      default:
                        if (ll(e))
                          ++this.state.pos;
                        else if (e === 45 && !this.inModule) {
                          let s = this.state.pos;
                          if (this.input.charCodeAt(s + 1) === 45 && this.input.charCodeAt(s + 2) === 62 && (t3 === 0 || this.state.lineStart > t3)) {
                            let i = this.skipLineComment(3);
                            i !== void 0 && (this.addComment(i), this.options.attachComment && r.push(i));
                          } else
                            break e;
                        } else if (e === 60 && !this.inModule) {
                          let s = this.state.pos;
                          if (this.input.charCodeAt(s + 1) === 33 && this.input.charCodeAt(s + 2) === 45 && this.input.charCodeAt(s + 3) === 45) {
                            let i = this.skipLineComment(4);
                            i !== void 0 && (this.addComment(i), this.options.attachComment && r.push(i));
                          } else
                            break e;
                        } else
                          break e;
                    }
                  }
                if (r.length > 0) {
                  let e = this.state.pos, s = { start: t3, end: e, comments: r, leadingNode: null, trailingNode: null, containingNode: null };
                  this.state.commentStack.push(s);
                }
              }
              finishToken(t3, r) {
                this.state.end = this.state.pos, this.state.endLoc = this.state.curPosition();
                let e = this.state.type;
                this.state.type = t3, this.state.value = r, this.isLookahead || this.updateContext(e);
              }
              replaceToken(t3) {
                this.state.type = t3, this.updateContext();
              }
              readToken_numberSign() {
                if (this.state.pos === 0 && this.readToken_interpreter())
                  return;
                let t3 = this.state.pos + 1, r = this.codePointAtPos(t3);
                if (r >= 48 && r <= 57)
                  throw this.raise(h.UnexpectedDigitAfterHash, { at: this.state.curPosition() });
                if (r === 123 || r === 91 && this.hasPlugin("recordAndTuple")) {
                  if (this.expectPlugin("recordAndTuple"), this.getPluginOption("recordAndTuple", "syntaxType") === "bar")
                    throw this.raise(r === 123 ? h.RecordExpressionHashIncorrectStartSyntaxType : h.TupleExpressionHashIncorrectStartSyntaxType, { at: this.state.curPosition() });
                  this.state.pos += 2, r === 123 ? this.finishToken(7) : this.finishToken(1);
                } else
                  fe(r) ? (++this.state.pos, this.finishToken(136, this.readWord1(r))) : r === 92 ? (++this.state.pos, this.finishToken(136, this.readWord1())) : this.finishOp(27, 1);
              }
              readToken_dot() {
                let t3 = this.input.charCodeAt(this.state.pos + 1);
                if (t3 >= 48 && t3 <= 57) {
                  this.readNumber(true);
                  return;
                }
                t3 === 46 && this.input.charCodeAt(this.state.pos + 2) === 46 ? (this.state.pos += 3, this.finishToken(21)) : (++this.state.pos, this.finishToken(16));
              }
              readToken_slash() {
                this.input.charCodeAt(this.state.pos + 1) === 61 ? this.finishOp(31, 2) : this.finishOp(56, 1);
              }
              readToken_interpreter() {
                if (this.state.pos !== 0 || this.length < 2)
                  return false;
                let t3 = this.input.charCodeAt(this.state.pos + 1);
                if (t3 !== 33)
                  return false;
                let r = this.state.pos;
                for (this.state.pos += 1; !Qe(t3) && ++this.state.pos < this.length; )
                  t3 = this.input.charCodeAt(this.state.pos);
                let e = this.input.slice(r + 2, this.state.pos);
                return this.finishToken(28, e), true;
              }
              readToken_mult_modulo(t3) {
                let r = t3 === 42 ? 55 : 54, e = 1, s = this.input.charCodeAt(this.state.pos + 1);
                t3 === 42 && s === 42 && (e++, s = this.input.charCodeAt(this.state.pos + 2), r = 57), s === 61 && !this.state.inType && (e++, r = t3 === 37 ? 33 : 30), this.finishOp(r, e);
              }
              readToken_pipe_amp(t3) {
                let r = this.input.charCodeAt(this.state.pos + 1);
                if (r === t3) {
                  this.input.charCodeAt(this.state.pos + 2) === 61 ? this.finishOp(30, 3) : this.finishOp(t3 === 124 ? 41 : 42, 2);
                  return;
                }
                if (t3 === 124) {
                  if (r === 62) {
                    this.finishOp(39, 2);
                    return;
                  }
                  if (this.hasPlugin("recordAndTuple") && r === 125) {
                    if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                      throw this.raise(h.RecordExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                    this.state.pos += 2, this.finishToken(9);
                    return;
                  }
                  if (this.hasPlugin("recordAndTuple") && r === 93) {
                    if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                      throw this.raise(h.TupleExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                    this.state.pos += 2, this.finishToken(4);
                    return;
                  }
                }
                if (r === 61) {
                  this.finishOp(30, 2);
                  return;
                }
                this.finishOp(t3 === 124 ? 43 : 45, 1);
              }
              readToken_caret() {
                let t3 = this.input.charCodeAt(this.state.pos + 1);
                if (t3 === 61 && !this.state.inType)
                  this.finishOp(32, 2);
                else if (t3 === 94 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "^^" }])) {
                  if (this.finishOp(37, 2), this.input.codePointAt(this.state.pos) === 94)
                    throw this.unexpected();
                } else
                  this.finishOp(44, 1);
              }
              readToken_atSign() {
                this.input.charCodeAt(this.state.pos + 1) === 64 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "@@" }]) ? this.finishOp(38, 2) : this.finishOp(26, 1);
              }
              readToken_plus_min(t3) {
                let r = this.input.charCodeAt(this.state.pos + 1);
                if (r === t3) {
                  this.finishOp(34, 2);
                  return;
                }
                r === 61 ? this.finishOp(30, 2) : this.finishOp(53, 1);
              }
              readToken_lt() {
                let { pos: t3 } = this.state, r = this.input.charCodeAt(t3 + 1);
                if (r === 60) {
                  if (this.input.charCodeAt(t3 + 2) === 61) {
                    this.finishOp(30, 3);
                    return;
                  }
                  this.finishOp(51, 2);
                  return;
                }
                if (r === 61) {
                  this.finishOp(49, 2);
                  return;
                }
                this.finishOp(47, 1);
              }
              readToken_gt() {
                let { pos: t3 } = this.state, r = this.input.charCodeAt(t3 + 1);
                if (r === 62) {
                  let e = this.input.charCodeAt(t3 + 2) === 62 ? 3 : 2;
                  if (this.input.charCodeAt(t3 + e) === 61) {
                    this.finishOp(30, e + 1);
                    return;
                  }
                  this.finishOp(52, e);
                  return;
                }
                if (r === 61) {
                  this.finishOp(49, 2);
                  return;
                }
                this.finishOp(48, 1);
              }
              readToken_eq_excl(t3) {
                let r = this.input.charCodeAt(this.state.pos + 1);
                if (r === 61) {
                  this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
                  return;
                }
                if (t3 === 61 && r === 62) {
                  this.state.pos += 2, this.finishToken(19);
                  return;
                }
                this.finishOp(t3 === 61 ? 29 : 35, 1);
              }
              readToken_question() {
                let t3 = this.input.charCodeAt(this.state.pos + 1), r = this.input.charCodeAt(this.state.pos + 2);
                t3 === 63 ? r === 61 ? this.finishOp(30, 3) : this.finishOp(40, 2) : t3 === 46 && !(r >= 48 && r <= 57) ? (this.state.pos += 2, this.finishToken(18)) : (++this.state.pos, this.finishToken(17));
              }
              getTokenFromCode(t3) {
                switch (t3) {
                  case 46:
                    this.readToken_dot();
                    return;
                  case 40:
                    ++this.state.pos, this.finishToken(10);
                    return;
                  case 41:
                    ++this.state.pos, this.finishToken(11);
                    return;
                  case 59:
                    ++this.state.pos, this.finishToken(13);
                    return;
                  case 44:
                    ++this.state.pos, this.finishToken(12);
                    return;
                  case 91:
                    if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                      if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                        throw this.raise(h.TupleExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                      this.state.pos += 2, this.finishToken(2);
                    } else
                      ++this.state.pos, this.finishToken(0);
                    return;
                  case 93:
                    ++this.state.pos, this.finishToken(3);
                    return;
                  case 123:
                    if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                      if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                        throw this.raise(h.RecordExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                      this.state.pos += 2, this.finishToken(6);
                    } else
                      ++this.state.pos, this.finishToken(5);
                    return;
                  case 125:
                    ++this.state.pos, this.finishToken(8);
                    return;
                  case 58:
                    this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58 ? this.finishOp(15, 2) : (++this.state.pos, this.finishToken(14));
                    return;
                  case 63:
                    this.readToken_question();
                    return;
                  case 96:
                    this.readTemplateToken();
                    return;
                  case 48: {
                    let r = this.input.charCodeAt(this.state.pos + 1);
                    if (r === 120 || r === 88) {
                      this.readRadixNumber(16);
                      return;
                    }
                    if (r === 111 || r === 79) {
                      this.readRadixNumber(8);
                      return;
                    }
                    if (r === 98 || r === 66) {
                      this.readRadixNumber(2);
                      return;
                    }
                  }
                  case 49:
                  case 50:
                  case 51:
                  case 52:
                  case 53:
                  case 54:
                  case 55:
                  case 56:
                  case 57:
                    this.readNumber(false);
                    return;
                  case 34:
                  case 39:
                    this.readString(t3);
                    return;
                  case 47:
                    this.readToken_slash();
                    return;
                  case 37:
                  case 42:
                    this.readToken_mult_modulo(t3);
                    return;
                  case 124:
                  case 38:
                    this.readToken_pipe_amp(t3);
                    return;
                  case 94:
                    this.readToken_caret();
                    return;
                  case 43:
                  case 45:
                    this.readToken_plus_min(t3);
                    return;
                  case 60:
                    this.readToken_lt();
                    return;
                  case 62:
                    this.readToken_gt();
                    return;
                  case 61:
                  case 33:
                    this.readToken_eq_excl(t3);
                    return;
                  case 126:
                    this.finishOp(36, 1);
                    return;
                  case 64:
                    this.readToken_atSign();
                    return;
                  case 35:
                    this.readToken_numberSign();
                    return;
                  case 92:
                    this.readWord();
                    return;
                  default:
                    if (fe(t3)) {
                      this.readWord(t3);
                      return;
                    }
                }
                throw this.raise(h.InvalidOrUnexpectedToken, { at: this.state.curPosition(), unexpected: String.fromCodePoint(t3) });
              }
              finishOp(t3, r) {
                let e = this.input.slice(this.state.pos, this.state.pos + r);
                this.state.pos += r, this.finishToken(t3, e);
              }
              readRegexp() {
                let t3 = this.state.startLoc, r = this.state.start + 1, e, s, { pos: i } = this.state;
                for (; ; ++i) {
                  if (i >= this.length)
                    throw this.raise(h.UnterminatedRegExp, { at: y(t3, 1) });
                  let c = this.input.charCodeAt(i);
                  if (Qe(c))
                    throw this.raise(h.UnterminatedRegExp, { at: y(t3, 1) });
                  if (e)
                    e = false;
                  else {
                    if (c === 91)
                      s = true;
                    else if (c === 93 && s)
                      s = false;
                    else if (c === 47 && !s)
                      break;
                    e = c === 92;
                  }
                }
                let a = this.input.slice(r, i);
                ++i;
                let n = "", o = () => y(t3, i + 2 - r);
                for (; i < this.length; ) {
                  let c = this.codePointAtPos(i), p = String.fromCharCode(c);
                  if (fl.has(c))
                    c === 118 ? (this.expectPlugin("regexpUnicodeSets", o()), n.includes("u") && this.raise(h.IncompatibleRegExpUVFlags, { at: o() })) : c === 117 && n.includes("v") && this.raise(h.IncompatibleRegExpUVFlags, { at: o() }), n.includes(p) && this.raise(h.DuplicateRegExpFlags, { at: o() });
                  else if (Be(c) || c === 92)
                    this.raise(h.MalformedRegExpFlags, { at: o() });
                  else
                    break;
                  ++i, n += p;
                }
                this.state.pos = i, this.finishToken(135, { pattern: a, flags: n });
              }
              readInt(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, { n: i, pos: a } = Lr(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t3, r, e, s, this.errorHandlers_readInt, false);
                return this.state.pos = a, i;
              }
              readRadixNumber(t3) {
                let r = this.state.curPosition(), e = false;
                this.state.pos += 2;
                let s = this.readInt(t3);
                s == null && this.raise(h.InvalidDigit, { at: y(r, 2), radix: t3 });
                let i = this.input.charCodeAt(this.state.pos);
                if (i === 110)
                  ++this.state.pos, e = true;
                else if (i === 109)
                  throw this.raise(h.InvalidDecimal, { at: r });
                if (fe(this.codePointAtPos(this.state.pos)))
                  throw this.raise(h.NumberIdentifier, { at: this.state.curPosition() });
                if (e) {
                  let a = this.input.slice(r.index, this.state.pos).replace(/[_n]/g, "");
                  this.finishToken(133, a);
                  return;
                }
                this.finishToken(132, s);
              }
              readNumber(t3) {
                let r = this.state.pos, e = this.state.curPosition(), s = false, i = false, a = false, n = false, o = false;
                !t3 && this.readInt(10) === null && this.raise(h.InvalidNumber, { at: this.state.curPosition() });
                let c = this.state.pos - r >= 2 && this.input.charCodeAt(r) === 48;
                if (c) {
                  let P = this.input.slice(r, this.state.pos);
                  if (this.recordStrictModeErrors(h.StrictOctalLiteral, { at: e }), !this.state.strict) {
                    let b = P.indexOf("_");
                    b > 0 && this.raise(h.ZeroDigitNumericSeparator, { at: y(e, b) });
                  }
                  o = c && !/[89]/.test(P);
                }
                let p = this.input.charCodeAt(this.state.pos);
                if (p === 46 && !o && (++this.state.pos, this.readInt(10), s = true, p = this.input.charCodeAt(this.state.pos)), (p === 69 || p === 101) && !o && (p = this.input.charCodeAt(++this.state.pos), (p === 43 || p === 45) && ++this.state.pos, this.readInt(10) === null && this.raise(h.InvalidOrMissingExponent, { at: e }), s = true, n = true, p = this.input.charCodeAt(this.state.pos)), p === 110 && ((s || c) && this.raise(h.InvalidBigIntLiteral, { at: e }), ++this.state.pos, i = true), p === 109 && (this.expectPlugin("decimal", this.state.curPosition()), (n || c) && this.raise(h.InvalidDecimal, { at: e }), ++this.state.pos, a = true), fe(this.codePointAtPos(this.state.pos)))
                  throw this.raise(h.NumberIdentifier, { at: this.state.curPosition() });
                let m = this.input.slice(r, this.state.pos).replace(/[_mn]/g, "");
                if (i) {
                  this.finishToken(133, m);
                  return;
                }
                if (a) {
                  this.finishToken(134, m);
                  return;
                }
                let x = o ? parseInt(m, 8) : parseFloat(m);
                this.finishToken(132, x);
              }
              readCodePoint(t3) {
                let { code: r, pos: e } = Or(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t3, this.errorHandlers_readCodePoint);
                return this.state.pos = e, r;
              }
              readString(t3) {
                let { str: r, pos: e, curLine: s, lineStart: i } = Fr(t3 === 34 ? "double" : "single", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_string);
                this.state.pos = e + 1, this.state.lineStart = i, this.state.curLine = s, this.finishToken(131, r);
              }
              readTemplateContinuation() {
                this.match(8) || this.unexpected(null, 8), this.state.pos--, this.readTemplateToken();
              }
              readTemplateToken() {
                let t3 = this.input[this.state.pos], { str: r, firstInvalidLoc: e, pos: s, curLine: i, lineStart: a } = Fr("template", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_template);
                this.state.pos = s + 1, this.state.lineStart = a, this.state.curLine = i, e && (this.state.firstInvalidTemplateEscapePos = new d(e.curLine, e.pos - e.lineStart, e.pos)), this.input.codePointAt(s) === 96 ? this.finishToken(24, e ? null : t3 + r + "`") : (this.state.pos++, this.finishToken(25, e ? null : t3 + r + "${"));
              }
              recordStrictModeErrors(t3, r) {
                let { at: e } = r, s = e.index;
                this.state.strict && !this.state.strictErrors.has(s) ? this.raise(t3, { at: e }) : this.state.strictErrors.set(s, [t3, e]);
              }
              readWord1(t3) {
                this.state.containsEsc = false;
                let r = "", e = this.state.pos, s = this.state.pos;
                for (t3 !== void 0 && (this.state.pos += t3 <= 65535 ? 1 : 2); this.state.pos < this.length; ) {
                  let i = this.codePointAtPos(this.state.pos);
                  if (Be(i))
                    this.state.pos += i <= 65535 ? 1 : 2;
                  else if (i === 92) {
                    this.state.containsEsc = true, r += this.input.slice(s, this.state.pos);
                    let a = this.state.curPosition(), n = this.state.pos === e ? fe : Be;
                    if (this.input.charCodeAt(++this.state.pos) !== 117) {
                      this.raise(h.MissingUnicodeEscape, { at: this.state.curPosition() }), s = this.state.pos - 1;
                      continue;
                    }
                    ++this.state.pos;
                    let o = this.readCodePoint(true);
                    o !== null && (n(o) || this.raise(h.EscapedCharNotAnIdentifier, { at: a }), r += String.fromCodePoint(o)), s = this.state.pos;
                  } else
                    break;
                }
                return r + this.input.slice(s, this.state.pos);
              }
              readWord(t3) {
                let r = this.readWord1(t3), e = qt.get(r);
                e !== void 0 ? this.finishToken(e, Pe(e)) : this.finishToken(130, r);
              }
              checkKeywordEscapes() {
                let { type: t3 } = this.state;
                Wt(t3) && this.state.containsEsc && this.raise(h.InvalidEscapedReservedWord, { at: this.state.startLoc, reservedWord: Pe(t3) });
              }
              raise(t3, r) {
                let { at: e } = r, s = u(r, pl), i = e instanceof d ? e : e.loc.start, a = t3({ loc: i, details: s });
                if (!this.options.errorRecovery)
                  throw a;
                return this.isLookahead || this.state.errors.push(a), a;
              }
              raiseOverwrite(t3, r) {
                let { at: e } = r, s = u(r, dl), i = e instanceof d ? e : e.loc.start, a = i.index, n = this.state.errors;
                for (let o = n.length - 1; o >= 0; o--) {
                  let c = n[o];
                  if (c.loc.index === a)
                    return n[o] = t3({ loc: i, details: s });
                  if (c.loc.index < a)
                    break;
                }
                return this.raise(t3, r);
              }
              updateContext(t3) {
              }
              unexpected(t3, r) {
                throw this.raise(h.UnexpectedToken, { expected: r ? Pe(r) : null, at: t3 != null ? t3 : this.state.startLoc });
              }
              expectPlugin(t3, r) {
                if (this.hasPlugin(t3))
                  return true;
                throw this.raise(h.MissingPlugin, { at: r != null ? r : this.state.startLoc, missingPlugin: [t3] });
              }
              expectOnePlugin(t3) {
                if (!t3.some((r) => this.hasPlugin(r)))
                  throw this.raise(h.MissingOneOfPlugins, { at: this.state.startLoc, missingPlugin: t3 });
              }
              errorBuilder(t3) {
                return (r, e, s) => {
                  this.raise(t3, { at: Ze(r, e, s) });
                };
              }
            }, yl = class {
              constructor() {
                this.privateNames = /* @__PURE__ */ new Set(), this.loneAccessors = /* @__PURE__ */ new Map(), this.undefinedPrivateNames = /* @__PURE__ */ new Map();
              }
            }, xl = class {
              constructor(t3) {
                this.parser = void 0, this.stack = [], this.undefinedPrivateNames = /* @__PURE__ */ new Map(), this.parser = t3;
              }
              current() {
                return this.stack[this.stack.length - 1];
              }
              enter() {
                this.stack.push(new yl());
              }
              exit() {
                let t3 = this.stack.pop(), r = this.current();
                for (let [e, s] of Array.from(t3.undefinedPrivateNames))
                  r ? r.undefinedPrivateNames.has(e) || r.undefinedPrivateNames.set(e, s) : this.parser.raise(h.InvalidPrivateFieldResolution, { at: s, identifierName: e });
              }
              declarePrivateName(t3, r, e) {
                let { privateNames: s, loneAccessors: i, undefinedPrivateNames: a } = this.current(), n = s.has(t3);
                if (r & is) {
                  let o = n && i.get(t3);
                  if (o) {
                    let c = o & ft, p = r & ft, m = o & is, x = r & is;
                    n = m === x || c !== p, n || i.delete(t3);
                  } else
                    n || i.set(t3, r);
                }
                n && this.parser.raise(h.PrivateNameRedeclaration, { at: e, identifierName: t3 }), s.add(t3), a.delete(t3);
              }
              usePrivateName(t3, r) {
                let e;
                for (e of this.stack)
                  if (e.privateNames.has(t3))
                    return;
                e ? e.undefinedPrivateNames.set(t3, r) : this.parser.raise(h.InvalidPrivateFieldResolution, { at: r, identifierName: t3 });
              }
            }, gl = 0, Mr = 1, cs = 2, Br = 3, xt = class {
              constructor() {
                let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : gl;
                this.type = void 0, this.type = t3;
              }
              canBeArrowParameterDeclaration() {
                return this.type === cs || this.type === Mr;
              }
              isCertainlyParameterDeclaration() {
                return this.type === Br;
              }
            }, _r = class extends xt {
              constructor(t3) {
                super(t3), this.declarationErrors = /* @__PURE__ */ new Map();
              }
              recordDeclarationError(t3, r) {
                let { at: e } = r, s = e.index;
                this.declarationErrors.set(s, [t3, e]);
              }
              clearDeclarationError(t3) {
                this.declarationErrors.delete(t3);
              }
              iterateErrors(t3) {
                this.declarationErrors.forEach(t3);
              }
            }, Pl = class {
              constructor(t3) {
                this.parser = void 0, this.stack = [new xt()], this.parser = t3;
              }
              enter(t3) {
                this.stack.push(t3);
              }
              exit() {
                this.stack.pop();
              }
              recordParameterInitializerError(t3, r) {
                let { at: e } = r, s = { at: e.loc.start }, { stack: i } = this, a = i.length - 1, n = i[a];
                for (; !n.isCertainlyParameterDeclaration(); ) {
                  if (n.canBeArrowParameterDeclaration())
                    n.recordDeclarationError(t3, s);
                  else
                    return;
                  n = i[--a];
                }
                this.parser.raise(t3, s);
              }
              recordArrowParemeterBindingError(t3, r) {
                let { at: e } = r, { stack: s } = this, i = s[s.length - 1], a = { at: e.loc.start };
                if (i.isCertainlyParameterDeclaration())
                  this.parser.raise(t3, a);
                else if (i.canBeArrowParameterDeclaration())
                  i.recordDeclarationError(t3, a);
                else
                  return;
              }
              recordAsyncArrowParametersError(t3) {
                let { at: r } = t3, { stack: e } = this, s = e.length - 1, i = e[s];
                for (; i.canBeArrowParameterDeclaration(); )
                  i.type === cs && i.recordDeclarationError(h.AwaitBindingIdentifier, { at: r }), i = e[--s];
              }
              validateAsPattern() {
                let { stack: t3 } = this, r = t3[t3.length - 1];
                !r.canBeArrowParameterDeclaration() || r.iterateErrors((e) => {
                  let [s, i] = e;
                  this.parser.raise(s, { at: i });
                  let a = t3.length - 2, n = t3[a];
                  for (; n.canBeArrowParameterDeclaration(); )
                    n.clearDeclarationError(i.index), n = t3[--a];
                });
              }
            };
            function Al() {
              return new xt(Br);
            }
            function Tl() {
              return new _r(Mr);
            }
            function vl() {
              return new _r(cs);
            }
            function Rr() {
              return new xt();
            }
            var qe = 0, jr = 1, gt2 = 2, qr = 4, Ue = 8, El = class {
              constructor() {
                this.stacks = [];
              }
              enter(t3) {
                this.stacks.push(t3);
              }
              exit() {
                this.stacks.pop();
              }
              currentFlags() {
                return this.stacks[this.stacks.length - 1];
              }
              get hasAwait() {
                return (this.currentFlags() & gt2) > 0;
              }
              get hasYield() {
                return (this.currentFlags() & jr) > 0;
              }
              get hasReturn() {
                return (this.currentFlags() & qr) > 0;
              }
              get hasIn() {
                return (this.currentFlags() & Ue) > 0;
              }
            };
            function Pt(t3, r) {
              return (t3 ? gt2 : 0) | (r ? jr : 0);
            }
            var Cl = class extends ml {
              addExtra(t3, r, e) {
                let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
                if (!t3)
                  return;
                let i = t3.extra = t3.extra || {};
                s ? i[r] = e : Object.defineProperty(i, r, { enumerable: s, value: e });
              }
              isContextual(t3) {
                return this.state.type === t3 && !this.state.containsEsc;
              }
              isUnparsedContextual(t3, r) {
                let e = t3 + r.length;
                if (this.input.slice(t3, e) === r) {
                  let s = this.input.charCodeAt(e);
                  return !(Be(s) || (s & 64512) === 55296);
                }
                return false;
              }
              isLookaheadContextual(t3) {
                let r = this.nextTokenStart();
                return this.isUnparsedContextual(r, t3);
              }
              eatContextual(t3) {
                return this.isContextual(t3) ? (this.next(), true) : false;
              }
              expectContextual(t3, r) {
                if (!this.eatContextual(t3))
                  throw r != null ? this.raise(r, { at: this.state.startLoc }) : this.unexpected(null, t3);
              }
              canInsertSemicolon() {
                return this.match(137) || this.match(8) || this.hasPrecedingLineBreak();
              }
              hasPrecedingLineBreak() {
                return ls.test(this.input.slice(this.state.lastTokEndLoc.index, this.state.start));
              }
              hasFollowingLineBreak() {
                return Nr.lastIndex = this.state.end, Nr.test(this.input);
              }
              isLineTerminator() {
                return this.eat(13) || this.canInsertSemicolon();
              }
              semicolon() {
                ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true) ? this.isLineTerminator() : this.eat(13)) || this.raise(h.MissingSemicolon, { at: this.state.lastTokEndLoc });
              }
              expect(t3, r) {
                this.eat(t3) || this.unexpected(r, t3);
              }
              tryParse(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.clone(), e = { node: null };
                try {
                  let s = t3(function() {
                    let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                    throw e.node = i, e;
                  });
                  if (this.state.errors.length > r.errors.length) {
                    let i = this.state;
                    return this.state = r, this.state.tokensLength = i.tokensLength, { node: s, error: i.errors[r.errors.length], thrown: false, aborted: false, failState: i };
                  }
                  return { node: s, error: null, thrown: false, aborted: false, failState: null };
                } catch (s) {
                  let i = this.state;
                  if (this.state = r, s instanceof SyntaxError)
                    return { node: null, error: s, thrown: true, aborted: false, failState: i };
                  if (s === e)
                    return { node: e.node, error: null, thrown: false, aborted: true, failState: i };
                  throw s;
                }
              }
              checkExpressionErrors(t3, r) {
                if (!t3)
                  return false;
                let { shorthandAssignLoc: e, doubleProtoLoc: s, privateKeyLoc: i, optionalParametersLoc: a } = t3, n = !!e || !!s || !!a || !!i;
                if (!r)
                  return n;
                e != null && this.raise(h.InvalidCoverInitializedName, { at: e }), s != null && this.raise(h.DuplicateProto, { at: s }), i != null && this.raise(h.UnexpectedPrivateField, { at: i }), a != null && this.unexpected(a);
              }
              isLiteralPropertyName() {
                return cr(this.state.type);
              }
              isPrivateName(t3) {
                return t3.type === "PrivateName";
              }
              getPrivateNameSV(t3) {
                return t3.id.name;
              }
              hasPropertyAsPrivateName(t3) {
                return (t3.type === "MemberExpression" || t3.type === "OptionalMemberExpression") && this.isPrivateName(t3.property);
              }
              isOptionalChain(t3) {
                return t3.type === "OptionalMemberExpression" || t3.type === "OptionalCallExpression";
              }
              isObjectProperty(t3) {
                return t3.type === "ObjectProperty";
              }
              isObjectMethod(t3) {
                return t3.type === "ObjectMethod";
              }
              initializeScopes() {
                let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.sourceType === "module", r = this.state.labels;
                this.state.labels = [];
                let e = this.exportedIdentifiers;
                this.exportedIdentifiers = /* @__PURE__ */ new Set();
                let s = this.inModule;
                this.inModule = t3;
                let i = this.scope, a = this.getScopeHandler();
                this.scope = new a(this, t3);
                let n = this.prodParam;
                this.prodParam = new El();
                let o = this.classScope;
                this.classScope = new xl(this);
                let c = this.expressionScope;
                return this.expressionScope = new Pl(this), () => {
                  this.state.labels = r, this.exportedIdentifiers = e, this.inModule = s, this.scope = i, this.prodParam = n, this.classScope = o, this.expressionScope = c;
                };
              }
              enterInitialScopes() {
                let t3 = qe;
                this.inModule && (t3 |= gt2), this.scope.enter(Re), this.prodParam.enter(t3);
              }
              checkDestructuringPrivate(t3) {
                let { privateKeyLoc: r } = t3;
                r !== null && this.expectPlugin("destructuringPrivate", r);
              }
            }, At = class {
              constructor() {
                this.shorthandAssignLoc = null, this.doubleProtoLoc = null, this.privateKeyLoc = null, this.optionalParametersLoc = null;
              }
            }, Tt = class {
              constructor(t3, r, e) {
                this.type = "", this.start = r, this.end = 0, this.loc = new f(e), t3 != null && t3.options.ranges && (this.range = [r, 0]), t3 != null && t3.filename && (this.loc.filename = t3.filename);
              }
            }, ps = Tt.prototype;
            ps.__clone = function() {
              let t3 = new Tt(void 0, this.start, this.loc.start), r = Object.keys(this);
              for (let e = 0, s = r.length; e < s; e++) {
                let i = r[e];
                i !== "leadingComments" && i !== "trailingComments" && i !== "innerComments" && (t3[i] = this[i]);
              }
              return t3;
            };
            function bl(t3) {
              return xe(t3);
            }
            function xe(t3) {
              let { type: r, start: e, end: s, loc: i, range: a, extra: n, name: o } = t3, c = Object.create(ps);
              return c.type = r, c.start = e, c.end = s, c.loc = i, c.range = a, c.extra = n, c.name = o, r === "Placeholder" && (c.expectedNode = t3.expectedNode), c;
            }
            function Sl(t3) {
              let { type: r, start: e, end: s, loc: i, range: a, extra: n } = t3;
              if (r === "Placeholder")
                return bl(t3);
              let o = Object.create(ps);
              return o.type = r, o.start = e, o.end = s, o.loc = i, o.range = a, t3.raw !== void 0 ? o.raw = t3.raw : o.extra = n, o.value = t3.value, o;
            }
            var wl = class extends Cl {
              startNode() {
                return new Tt(this, this.state.start, this.state.startLoc);
              }
              startNodeAt(t3) {
                return new Tt(this, t3.index, t3);
              }
              startNodeAtNode(t3) {
                return this.startNodeAt(t3.loc.start);
              }
              finishNode(t3, r) {
                return this.finishNodeAt(t3, r, this.state.lastTokEndLoc);
              }
              finishNodeAt(t3, r, e) {
                return t3.type = r, t3.end = e.index, t3.loc.end = e, this.options.ranges && (t3.range[1] = e.index), this.options.attachComment && this.processComment(t3), t3;
              }
              resetStartLocation(t3, r) {
                t3.start = r.index, t3.loc.start = r, this.options.ranges && (t3.range[0] = r.index);
              }
              resetEndLocation(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
                t3.end = r.index, t3.loc.end = r, this.options.ranges && (t3.range[1] = r.index);
              }
              resetStartLocationFromNode(t3, r) {
                this.resetStartLocation(t3, r.loc.start);
              }
            }, Il = /* @__PURE__ */ new Set(["_", "any", "bool", "boolean", "empty", "extends", "false", "interface", "mixed", "null", "number", "static", "string", "true", "typeof", "void"]), D = _`flow`({ AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.", AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module.", AssignReservedType: (t3) => {
              let { reservedType: r } = t3;
              return `Cannot overwrite reserved type ${r}.`;
            }, DeclareClassElement: "The `declare` modifier can only appear on class fields.", DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.", DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement.", EnumBooleanMemberNotInitialized: (t3) => {
              let { memberName: r, enumName: e } = t3;
              return `Boolean enum members need to be initialized. Use either \`${r} = true,\` or \`${r} = false,\` in enum \`${e}\`.`;
            }, EnumDuplicateMemberName: (t3) => {
              let { memberName: r, enumName: e } = t3;
              return `Enum member names need to be unique, but the name \`${r}\` has already been used before in enum \`${e}\`.`;
            }, EnumInconsistentMemberValues: (t3) => {
              let { enumName: r } = t3;
              return `Enum \`${r}\` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.`;
            }, EnumInvalidExplicitType: (t3) => {
              let { invalidEnumType: r, enumName: e } = t3;
              return `Enum type \`${r}\` is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${e}\`.`;
            }, EnumInvalidExplicitTypeUnknownSupplied: (t3) => {
              let { enumName: r } = t3;
              return `Supplied enum type is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${r}\`.`;
            }, EnumInvalidMemberInitializerPrimaryType: (t3) => {
              let { enumName: r, memberName: e, explicitType: s } = t3;
              return `Enum \`${r}\` has type \`${s}\`, so the initializer of \`${e}\` needs to be a ${s} literal.`;
            }, EnumInvalidMemberInitializerSymbolType: (t3) => {
              let { enumName: r, memberName: e } = t3;
              return `Symbol enum members cannot be initialized. Use \`${e},\` in enum \`${r}\`.`;
            }, EnumInvalidMemberInitializerUnknownType: (t3) => {
              let { enumName: r, memberName: e } = t3;
              return `The enum member initializer for \`${e}\` needs to be a literal (either a boolean, number, or string) in enum \`${r}\`.`;
            }, EnumInvalidMemberName: (t3) => {
              let { enumName: r, memberName: e, suggestion: s } = t3;
              return `Enum member names cannot start with lowercase 'a' through 'z'. Instead of using \`${e}\`, consider using \`${s}\`, in enum \`${r}\`.`;
            }, EnumNumberMemberNotInitialized: (t3) => {
              let { enumName: r, memberName: e } = t3;
              return `Number enum members need to be initialized, e.g. \`${e} = 1\` in enum \`${r}\`.`;
            }, EnumStringMemberInconsistentlyInitailized: (t3) => {
              let { enumName: r } = t3;
              return `String enum members need to consistently either all use initializers, or use no initializers, in enum \`${r}\`.`;
            }, GetterMayNotHaveThisParam: "A getter cannot have a `this` parameter.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` or `typeof` keyword.", ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements.", InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type.", InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions.", InexactVariance: "Explicit inexact syntax cannot have variance.", InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`.", MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.", NestedDeclareModule: "`declare module` cannot be used inside another `declare module`.", NestedFlowComment: "Cannot have a flow comment inside another flow comment.", PatternIsOptional: Object.assign({ message: "A binding pattern parameter cannot be optional in an implementation signature." }, { reasonCode: "OptionalBindingPattern" }), SetterMayNotHaveThisParam: "A setter cannot have a `this` parameter.", SpreadVariance: "Spread properties cannot have variance.", ThisParamAnnotationRequired: "A type annotation is required for the `this` parameter.", ThisParamBannedInConstructor: "Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions.", ThisParamMayNotBeOptional: "The `this` parameter cannot be optional.", ThisParamMustBeFirst: "The `this` parameter must be the first function parameter.", ThisParamNoDefault: "The `this` parameter may not have a default value.", TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis.", UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object.", UnexpectedReservedType: (t3) => {
              let { reservedType: r } = t3;
              return `Unexpected reserved type ${r}.`;
            }, UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new.", UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.", UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions.", UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint".', UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration.", UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`.", UnsupportedDeclareExportKind: (t3) => {
              let { unsupportedExportKind: r, suggestion: e } = t3;
              return `\`declare export ${r}\` is not supported. Use \`${e}\` instead.`;
            }, UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module.", UnterminatedFlowComment: "Unterminated flow-comment." });
            function Nl(t3) {
              return t3.type === "DeclareExportAllDeclaration" || t3.type === "DeclareExportDeclaration" && (!t3.declaration || t3.declaration.type !== "TypeAlias" && t3.declaration.type !== "InterfaceDeclaration");
            }
            function ds(t3) {
              return t3.importKind === "type" || t3.importKind === "typeof";
            }
            function Ur(t3) {
              return pe(t3) && t3 !== 97;
            }
            var kl = { const: "declare export var", let: "declare export var", type: "export type", interface: "export interface" };
            function Dl(t3, r) {
              let e = [], s = [];
              for (let i = 0; i < t3.length; i++)
                (r(t3[i], i, t3) ? e : s).push(t3[i]);
              return [e, s];
            }
            var Fl = /\*?\s*@((?:no)?flow)\b/, Ll = (t3) => class extends t3 {
              constructor() {
                super(...arguments), this.flowPragma = void 0;
              }
              getScopeHandler() {
                return rl;
              }
              shouldParseTypes() {
                return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
              }
              shouldParseEnums() {
                return !!this.getPluginOption("flow", "enums");
              }
              finishToken(e, s) {
                return e !== 131 && e !== 13 && e !== 28 && this.flowPragma === void 0 && (this.flowPragma = null), super.finishToken(e, s);
              }
              addComment(e) {
                if (this.flowPragma === void 0) {
                  let s = Fl.exec(e.value);
                  if (s)
                    if (s[1] === "flow")
                      this.flowPragma = "flow";
                    else if (s[1] === "noflow")
                      this.flowPragma = "noflow";
                    else
                      throw new Error("Unexpected flow pragma");
                }
                return super.addComment(e);
              }
              flowParseTypeInitialiser(e) {
                let s = this.state.inType;
                this.state.inType = true, this.expect(e || 14);
                let i = this.flowParseType();
                return this.state.inType = s, i;
              }
              flowParsePredicate() {
                let e = this.startNode(), s = this.state.startLoc;
                return this.next(), this.expectContextual(108), this.state.lastTokStart > s.index + 1 && this.raise(D.UnexpectedSpaceBetweenModuloChecks, { at: s }), this.eat(10) ? (e.value = super.parseExpression(), this.expect(11), this.finishNode(e, "DeclaredPredicate")) : this.finishNode(e, "InferredPredicate");
              }
              flowParseTypeAndPredicateInitialiser() {
                let e = this.state.inType;
                this.state.inType = true, this.expect(14);
                let s = null, i = null;
                return this.match(54) ? (this.state.inType = e, i = this.flowParsePredicate()) : (s = this.flowParseType(), this.state.inType = e, this.match(54) && (i = this.flowParsePredicate())), [s, i];
              }
              flowParseDeclareClass(e) {
                return this.next(), this.flowParseInterfaceish(e, true), this.finishNode(e, "DeclareClass");
              }
              flowParseDeclareFunction(e) {
                this.next();
                let s = e.id = this.parseIdentifier(), i = this.startNode(), a = this.startNode();
                this.match(47) ? i.typeParameters = this.flowParseTypeParameterDeclaration() : i.typeParameters = null, this.expect(10);
                let n = this.flowParseFunctionTypeParams();
                return i.params = n.params, i.rest = n.rest, i.this = n._this, this.expect(11), [i.returnType, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), a.typeAnnotation = this.finishNode(i, "FunctionTypeAnnotation"), s.typeAnnotation = this.finishNode(a, "TypeAnnotation"), this.resetEndLocation(s), this.semicolon(), this.scope.declareName(e.id.name, Yo, e.id.loc.start), this.finishNode(e, "DeclareFunction");
              }
              flowParseDeclare(e, s) {
                if (this.match(80))
                  return this.flowParseDeclareClass(e);
                if (this.match(68))
                  return this.flowParseDeclareFunction(e);
                if (this.match(74))
                  return this.flowParseDeclareVariable(e);
                if (this.eatContextual(125))
                  return this.match(16) ? this.flowParseDeclareModuleExports(e) : (s && this.raise(D.NestedDeclareModule, { at: this.state.lastTokStartLoc }), this.flowParseDeclareModule(e));
                if (this.isContextual(128))
                  return this.flowParseDeclareTypeAlias(e);
                if (this.isContextual(129))
                  return this.flowParseDeclareOpaqueType(e);
                if (this.isContextual(127))
                  return this.flowParseDeclareInterface(e);
                if (this.match(82))
                  return this.flowParseDeclareExportDeclaration(e, s);
                throw this.unexpected();
              }
              flowParseDeclareVariable(e) {
                return this.next(), e.id = this.flowParseTypeAnnotatableIdentifier(true), this.scope.declareName(e.id.name, dt, e.id.loc.start), this.semicolon(), this.finishNode(e, "DeclareVariable");
              }
              flowParseDeclareModule(e) {
                this.scope.enter(_e), this.match(131) ? e.id = super.parseExprAtom() : e.id = this.parseIdentifier();
                let s = e.body = this.startNode(), i = s.body = [];
                for (this.expect(5); !this.match(8); ) {
                  let o = this.startNode();
                  this.match(83) ? (this.next(), !this.isContextual(128) && !this.match(87) && this.raise(D.InvalidNonTypeImportInDeclareModule, { at: this.state.lastTokStartLoc }), super.parseImport(o)) : (this.expectContextual(123, D.UnsupportedStatementInDeclareModule), o = this.flowParseDeclare(o, true)), i.push(o);
                }
                this.scope.exit(), this.expect(8), this.finishNode(s, "BlockStatement");
                let a = null, n = false;
                return i.forEach((o) => {
                  Nl(o) ? (a === "CommonJS" && this.raise(D.AmbiguousDeclareModuleKind, { at: o }), a = "ES") : o.type === "DeclareModuleExports" && (n && this.raise(D.DuplicateDeclareModuleExports, { at: o }), a === "ES" && this.raise(D.AmbiguousDeclareModuleKind, { at: o }), a = "CommonJS", n = true);
                }), e.kind = a || "CommonJS", this.finishNode(e, "DeclareModule");
              }
              flowParseDeclareExportDeclaration(e, s) {
                if (this.expect(82), this.eat(65))
                  return this.match(68) || this.match(80) ? e.declaration = this.flowParseDeclare(this.startNode()) : (e.declaration = this.flowParseType(), this.semicolon()), e.default = true, this.finishNode(e, "DeclareExportDeclaration");
                if (this.match(75) || this.isLet() || (this.isContextual(128) || this.isContextual(127)) && !s) {
                  let i = this.state.value;
                  throw this.raise(D.UnsupportedDeclareExportKind, { at: this.state.startLoc, unsupportedExportKind: i, suggestion: kl[i] });
                }
                if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(129))
                  return e.declaration = this.flowParseDeclare(this.startNode()), e.default = false, this.finishNode(e, "DeclareExportDeclaration");
                if (this.match(55) || this.match(5) || this.isContextual(127) || this.isContextual(128) || this.isContextual(129))
                  return e = this.parseExport(e, null), e.type === "ExportNamedDeclaration" && (e.type = "ExportDeclaration", e.default = false, delete e.exportKind), e.type = "Declare" + e.type, e;
                throw this.unexpected();
              }
              flowParseDeclareModuleExports(e) {
                return this.next(), this.expectContextual(109), e.typeAnnotation = this.flowParseTypeAnnotation(), this.semicolon(), this.finishNode(e, "DeclareModuleExports");
              }
              flowParseDeclareTypeAlias(e) {
                this.next();
                let s = this.flowParseTypeAlias(e);
                return s.type = "DeclareTypeAlias", s;
              }
              flowParseDeclareOpaqueType(e) {
                this.next();
                let s = this.flowParseOpaqueType(e, true);
                return s.type = "DeclareOpaqueType", s;
              }
              flowParseDeclareInterface(e) {
                return this.next(), this.flowParseInterfaceish(e), this.finishNode(e, "DeclareInterface");
              }
              flowParseInterfaceish(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (e.id = this.flowParseRestrictedIdentifier(!s, true), this.scope.declareName(e.id.name, s ? Cr : Ie, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.extends = [], e.implements = [], e.mixins = [], this.eat(81))
                  do
                    e.extends.push(this.flowParseInterfaceExtends());
                  while (!s && this.eat(12));
                if (this.isContextual(115)) {
                  this.next();
                  do
                    e.mixins.push(this.flowParseInterfaceExtends());
                  while (this.eat(12));
                }
                if (this.isContextual(111)) {
                  this.next();
                  do
                    e.implements.push(this.flowParseInterfaceExtends());
                  while (this.eat(12));
                }
                e.body = this.flowParseObjectType({ allowStatic: s, allowExact: false, allowSpread: false, allowProto: s, allowInexact: false });
              }
              flowParseInterfaceExtends() {
                let e = this.startNode();
                return e.id = this.flowParseQualifiedTypeIdentifier(), this.match(47) ? e.typeParameters = this.flowParseTypeParameterInstantiation() : e.typeParameters = null, this.finishNode(e, "InterfaceExtends");
              }
              flowParseInterface(e) {
                return this.flowParseInterfaceish(e), this.finishNode(e, "InterfaceDeclaration");
              }
              checkNotUnderscore(e) {
                e === "_" && this.raise(D.UnexpectedReservedUnderscore, { at: this.state.startLoc });
              }
              checkReservedType(e, s, i) {
                !Il.has(e) || this.raise(i ? D.AssignReservedType : D.UnexpectedReservedType, { at: s, reservedType: e });
              }
              flowParseRestrictedIdentifier(e, s) {
                return this.checkReservedType(this.state.value, this.state.startLoc, s), this.parseIdentifier(e);
              }
              flowParseTypeAlias(e) {
                return e.id = this.flowParseRestrictedIdentifier(false, true), this.scope.declareName(e.id.name, Ie, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.right = this.flowParseTypeInitialiser(29), this.semicolon(), this.finishNode(e, "TypeAlias");
              }
              flowParseOpaqueType(e, s) {
                return this.expectContextual(128), e.id = this.flowParseRestrictedIdentifier(true, true), this.scope.declareName(e.id.name, Ie, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.supertype = null, this.match(14) && (e.supertype = this.flowParseTypeInitialiser(14)), e.impltype = null, s || (e.impltype = this.flowParseTypeInitialiser(29)), this.semicolon(), this.finishNode(e, "OpaqueType");
              }
              flowParseTypeParameter() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, s = this.state.startLoc, i = this.startNode(), a = this.flowParseVariance(), n = this.flowParseTypeAnnotatableIdentifier();
                return i.name = n.name, i.variance = a, i.bound = n.typeAnnotation, this.match(29) ? (this.eat(29), i.default = this.flowParseType()) : e && this.raise(D.MissingTypeParamDefault, { at: s }), this.finishNode(i, "TypeParameter");
              }
              flowParseTypeParameterDeclaration() {
                let e = this.state.inType, s = this.startNode();
                s.params = [], this.state.inType = true, this.match(47) || this.match(140) ? this.next() : this.unexpected();
                let i = false;
                do {
                  let a = this.flowParseTypeParameter(i);
                  s.params.push(a), a.default && (i = true), this.match(48) || this.expect(12);
                } while (!this.match(48));
                return this.expect(48), this.state.inType = e, this.finishNode(s, "TypeParameterDeclaration");
              }
              flowParseTypeParameterInstantiation() {
                let e = this.startNode(), s = this.state.inType;
                e.params = [], this.state.inType = true, this.expect(47);
                let i = this.state.noAnonFunctionType;
                for (this.state.noAnonFunctionType = false; !this.match(48); )
                  e.params.push(this.flowParseType()), this.match(48) || this.expect(12);
                return this.state.noAnonFunctionType = i, this.expect(48), this.state.inType = s, this.finishNode(e, "TypeParameterInstantiation");
              }
              flowParseTypeParameterInstantiationCallOrNew() {
                let e = this.startNode(), s = this.state.inType;
                for (e.params = [], this.state.inType = true, this.expect(47); !this.match(48); )
                  e.params.push(this.flowParseTypeOrImplicitInstantiation()), this.match(48) || this.expect(12);
                return this.expect(48), this.state.inType = s, this.finishNode(e, "TypeParameterInstantiation");
              }
              flowParseInterfaceType() {
                let e = this.startNode();
                if (this.expectContextual(127), e.extends = [], this.eat(81))
                  do
                    e.extends.push(this.flowParseInterfaceExtends());
                  while (this.eat(12));
                return e.body = this.flowParseObjectType({ allowStatic: false, allowExact: false, allowSpread: false, allowProto: false, allowInexact: false }), this.finishNode(e, "InterfaceTypeAnnotation");
              }
              flowParseObjectPropertyKey() {
                return this.match(132) || this.match(131) ? super.parseExprAtom() : this.parseIdentifier(true);
              }
              flowParseObjectTypeIndexer(e, s, i) {
                return e.static = s, this.lookahead().type === 14 ? (e.id = this.flowParseObjectPropertyKey(), e.key = this.flowParseTypeInitialiser()) : (e.id = null, e.key = this.flowParseType()), this.expect(3), e.value = this.flowParseTypeInitialiser(), e.variance = i, this.finishNode(e, "ObjectTypeIndexer");
              }
              flowParseObjectTypeInternalSlot(e, s) {
                return e.static = s, e.id = this.flowParseObjectPropertyKey(), this.expect(3), this.expect(3), this.match(47) || this.match(10) ? (e.method = true, e.optional = false, e.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e.loc.start))) : (e.method = false, this.eat(17) && (e.optional = true), e.value = this.flowParseTypeInitialiser()), this.finishNode(e, "ObjectTypeInternalSlot");
              }
              flowParseObjectTypeMethodish(e) {
                for (e.params = [], e.rest = null, e.typeParameters = null, e.this = null, this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration()), this.expect(10), this.match(78) && (e.this = this.flowParseFunctionTypeParam(true), e.this.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
                  e.params.push(this.flowParseFunctionTypeParam(false)), this.match(11) || this.expect(12);
                return this.eat(21) && (e.rest = this.flowParseFunctionTypeParam(false)), this.expect(11), e.returnType = this.flowParseTypeInitialiser(), this.finishNode(e, "FunctionTypeAnnotation");
              }
              flowParseObjectTypeCallProperty(e, s) {
                let i = this.startNode();
                return e.static = s, e.value = this.flowParseObjectTypeMethodish(i), this.finishNode(e, "ObjectTypeCallProperty");
              }
              flowParseObjectType(e) {
                let { allowStatic: s, allowExact: i, allowSpread: a, allowProto: n, allowInexact: o } = e, c = this.state.inType;
                this.state.inType = true;
                let p = this.startNode();
                p.callProperties = [], p.properties = [], p.indexers = [], p.internalSlots = [];
                let m, x, P = false;
                for (i && this.match(6) ? (this.expect(6), m = 9, x = true) : (this.expect(5), m = 8, x = false), p.exact = x; !this.match(m); ) {
                  let O = false, R = null, Q = null, Z = this.startNode();
                  if (n && this.isContextual(116)) {
                    let re = this.lookahead();
                    re.type !== 14 && re.type !== 17 && (this.next(), R = this.state.startLoc, s = false);
                  }
                  if (s && this.isContextual(104)) {
                    let re = this.lookahead();
                    re.type !== 14 && re.type !== 17 && (this.next(), O = true);
                  }
                  let X = this.flowParseVariance();
                  if (this.eat(0))
                    R != null && this.unexpected(R), this.eat(0) ? (X && this.unexpected(X.loc.start), p.internalSlots.push(this.flowParseObjectTypeInternalSlot(Z, O))) : p.indexers.push(this.flowParseObjectTypeIndexer(Z, O, X));
                  else if (this.match(10) || this.match(47))
                    R != null && this.unexpected(R), X && this.unexpected(X.loc.start), p.callProperties.push(this.flowParseObjectTypeCallProperty(Z, O));
                  else {
                    let re = "init";
                    if (this.isContextual(98) || this.isContextual(103)) {
                      let hh = this.lookahead();
                      cr(hh.type) && (re = this.state.value, this.next());
                    }
                    let $e = this.flowParseObjectTypeProperty(Z, O, R, X, re, a, o != null ? o : !x);
                    $e === null ? (P = true, Q = this.state.lastTokStartLoc) : p.properties.push($e);
                  }
                  this.flowObjectTypeSemicolon(), Q && !this.match(8) && !this.match(9) && this.raise(D.UnexpectedExplicitInexactInObject, { at: Q });
                }
                this.expect(m), a && (p.inexact = P);
                let b = this.finishNode(p, "ObjectTypeAnnotation");
                return this.state.inType = c, b;
              }
              flowParseObjectTypeProperty(e, s, i, a, n, o, c) {
                if (this.eat(21))
                  return this.match(12) || this.match(13) || this.match(8) || this.match(9) ? (o ? c || this.raise(D.InexactInsideExact, { at: this.state.lastTokStartLoc }) : this.raise(D.InexactInsideNonObject, { at: this.state.lastTokStartLoc }), a && this.raise(D.InexactVariance, { at: a }), null) : (o || this.raise(D.UnexpectedSpreadType, { at: this.state.lastTokStartLoc }), i != null && this.unexpected(i), a && this.raise(D.SpreadVariance, { at: a }), e.argument = this.flowParseType(), this.finishNode(e, "ObjectTypeSpreadProperty"));
                {
                  e.key = this.flowParseObjectPropertyKey(), e.static = s, e.proto = i != null, e.kind = n;
                  let p = false;
                  return this.match(47) || this.match(10) ? (e.method = true, i != null && this.unexpected(i), a && this.unexpected(a.loc.start), e.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e.loc.start)), (n === "get" || n === "set") && this.flowCheckGetterSetterParams(e), !o && e.key.name === "constructor" && e.value.this && this.raise(D.ThisParamBannedInConstructor, { at: e.value.this })) : (n !== "init" && this.unexpected(), e.method = false, this.eat(17) && (p = true), e.value = this.flowParseTypeInitialiser(), e.variance = a), e.optional = p, this.finishNode(e, "ObjectTypeProperty");
                }
              }
              flowCheckGetterSetterParams(e) {
                let s = e.kind === "get" ? 0 : 1, i = e.value.params.length + (e.value.rest ? 1 : 0);
                e.value.this && this.raise(e.kind === "get" ? D.GetterMayNotHaveThisParam : D.SetterMayNotHaveThisParam, { at: e.value.this }), i !== s && this.raise(e.kind === "get" ? h.BadGetterArity : h.BadSetterArity, { at: e }), e.kind === "set" && e.value.rest && this.raise(h.BadSetterRestParameter, { at: e });
              }
              flowObjectTypeSemicolon() {
                !this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9) && this.unexpected();
              }
              flowParseQualifiedTypeIdentifier(e, s) {
                var i;
                (i = e) != null || (e = this.state.startLoc);
                let a = s || this.flowParseRestrictedIdentifier(true);
                for (; this.eat(16); ) {
                  let n = this.startNodeAt(e);
                  n.qualification = a, n.id = this.flowParseRestrictedIdentifier(true), a = this.finishNode(n, "QualifiedTypeIdentifier");
                }
                return a;
              }
              flowParseGenericType(e, s) {
                let i = this.startNodeAt(e);
                return i.typeParameters = null, i.id = this.flowParseQualifiedTypeIdentifier(e, s), this.match(47) && (i.typeParameters = this.flowParseTypeParameterInstantiation()), this.finishNode(i, "GenericTypeAnnotation");
              }
              flowParseTypeofType() {
                let e = this.startNode();
                return this.expect(87), e.argument = this.flowParsePrimaryType(), this.finishNode(e, "TypeofTypeAnnotation");
              }
              flowParseTupleType() {
                let e = this.startNode();
                for (e.types = [], this.expect(0); this.state.pos < this.length && !this.match(3) && (e.types.push(this.flowParseType()), !this.match(3)); )
                  this.expect(12);
                return this.expect(3), this.finishNode(e, "TupleTypeAnnotation");
              }
              flowParseFunctionTypeParam(e) {
                let s = null, i = false, a = null, n = this.startNode(), o = this.lookahead(), c = this.state.type === 78;
                return o.type === 14 || o.type === 17 ? (c && !e && this.raise(D.ThisParamMustBeFirst, { at: n }), s = this.parseIdentifier(c), this.eat(17) && (i = true, c && this.raise(D.ThisParamMayNotBeOptional, { at: n })), a = this.flowParseTypeInitialiser()) : a = this.flowParseType(), n.name = s, n.optional = i, n.typeAnnotation = a, this.finishNode(n, "FunctionTypeParam");
              }
              reinterpretTypeAsFunctionTypeParam(e) {
                let s = this.startNodeAt(e.loc.start);
                return s.name = null, s.optional = false, s.typeAnnotation = e, this.finishNode(s, "FunctionTypeParam");
              }
              flowParseFunctionTypeParams() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = null, i = null;
                for (this.match(78) && (i = this.flowParseFunctionTypeParam(true), i.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
                  e.push(this.flowParseFunctionTypeParam(false)), this.match(11) || this.expect(12);
                return this.eat(21) && (s = this.flowParseFunctionTypeParam(false)), { params: e, rest: s, _this: i };
              }
              flowIdentToTypeAnnotation(e, s, i) {
                switch (i.name) {
                  case "any":
                    return this.finishNode(s, "AnyTypeAnnotation");
                  case "bool":
                  case "boolean":
                    return this.finishNode(s, "BooleanTypeAnnotation");
                  case "mixed":
                    return this.finishNode(s, "MixedTypeAnnotation");
                  case "empty":
                    return this.finishNode(s, "EmptyTypeAnnotation");
                  case "number":
                    return this.finishNode(s, "NumberTypeAnnotation");
                  case "string":
                    return this.finishNode(s, "StringTypeAnnotation");
                  case "symbol":
                    return this.finishNode(s, "SymbolTypeAnnotation");
                  default:
                    return this.checkNotUnderscore(i.name), this.flowParseGenericType(e, i);
                }
              }
              flowParsePrimaryType() {
                let e = this.state.startLoc, s = this.startNode(), i, a, n = false, o = this.state.noAnonFunctionType;
                switch (this.state.type) {
                  case 5:
                    return this.flowParseObjectType({ allowStatic: false, allowExact: false, allowSpread: true, allowProto: false, allowInexact: true });
                  case 6:
                    return this.flowParseObjectType({ allowStatic: false, allowExact: true, allowSpread: true, allowProto: false, allowInexact: false });
                  case 0:
                    return this.state.noAnonFunctionType = false, a = this.flowParseTupleType(), this.state.noAnonFunctionType = o, a;
                  case 47:
                    return s.typeParameters = this.flowParseTypeParameterDeclaration(), this.expect(10), i = this.flowParseFunctionTypeParams(), s.params = i.params, s.rest = i.rest, s.this = i._this, this.expect(11), this.expect(19), s.returnType = this.flowParseType(), this.finishNode(s, "FunctionTypeAnnotation");
                  case 10:
                    if (this.next(), !this.match(11) && !this.match(21))
                      if ($(this.state.type) || this.match(78)) {
                        let c = this.lookahead().type;
                        n = c !== 17 && c !== 14;
                      } else
                        n = true;
                    if (n) {
                      if (this.state.noAnonFunctionType = false, a = this.flowParseType(), this.state.noAnonFunctionType = o, this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19))
                        return this.expect(11), a;
                      this.eat(12);
                    }
                    return a ? i = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(a)]) : i = this.flowParseFunctionTypeParams(), s.params = i.params, s.rest = i.rest, s.this = i._this, this.expect(11), this.expect(19), s.returnType = this.flowParseType(), s.typeParameters = null, this.finishNode(s, "FunctionTypeAnnotation");
                  case 131:
                    return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
                  case 85:
                  case 86:
                    return s.value = this.match(85), this.next(), this.finishNode(s, "BooleanLiteralTypeAnnotation");
                  case 53:
                    if (this.state.value === "-") {
                      if (this.next(), this.match(132))
                        return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", s);
                      if (this.match(133))
                        return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", s);
                      throw this.raise(D.UnexpectedSubtractionOperand, { at: this.state.startLoc });
                    }
                    throw this.unexpected();
                  case 132:
                    return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
                  case 133:
                    return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
                  case 88:
                    return this.next(), this.finishNode(s, "VoidTypeAnnotation");
                  case 84:
                    return this.next(), this.finishNode(s, "NullLiteralTypeAnnotation");
                  case 78:
                    return this.next(), this.finishNode(s, "ThisTypeAnnotation");
                  case 55:
                    return this.next(), this.finishNode(s, "ExistsTypeAnnotation");
                  case 87:
                    return this.flowParseTypeofType();
                  default:
                    if (Wt(this.state.type)) {
                      let c = Pe(this.state.type);
                      return this.next(), super.createIdentifier(s, c);
                    } else if ($(this.state.type))
                      return this.isContextual(127) ? this.flowParseInterfaceType() : this.flowIdentToTypeAnnotation(e, s, this.parseIdentifier());
                }
                throw this.unexpected();
              }
              flowParsePostfixType() {
                let e = this.state.startLoc, s = this.flowParsePrimaryType(), i = false;
                for (; (this.match(0) || this.match(18)) && !this.canInsertSemicolon(); ) {
                  let a = this.startNodeAt(e), n = this.eat(18);
                  i = i || n, this.expect(0), !n && this.match(3) ? (a.elementType = s, this.next(), s = this.finishNode(a, "ArrayTypeAnnotation")) : (a.objectType = s, a.indexType = this.flowParseType(), this.expect(3), i ? (a.optional = n, s = this.finishNode(a, "OptionalIndexedAccessType")) : s = this.finishNode(a, "IndexedAccessType"));
                }
                return s;
              }
              flowParsePrefixType() {
                let e = this.startNode();
                return this.eat(17) ? (e.typeAnnotation = this.flowParsePrefixType(), this.finishNode(e, "NullableTypeAnnotation")) : this.flowParsePostfixType();
              }
              flowParseAnonFunctionWithoutParens() {
                let e = this.flowParsePrefixType();
                if (!this.state.noAnonFunctionType && this.eat(19)) {
                  let s = this.startNodeAt(e.loc.start);
                  return s.params = [this.reinterpretTypeAsFunctionTypeParam(e)], s.rest = null, s.this = null, s.returnType = this.flowParseType(), s.typeParameters = null, this.finishNode(s, "FunctionTypeAnnotation");
                }
                return e;
              }
              flowParseIntersectionType() {
                let e = this.startNode();
                this.eat(45);
                let s = this.flowParseAnonFunctionWithoutParens();
                for (e.types = [s]; this.eat(45); )
                  e.types.push(this.flowParseAnonFunctionWithoutParens());
                return e.types.length === 1 ? s : this.finishNode(e, "IntersectionTypeAnnotation");
              }
              flowParseUnionType() {
                let e = this.startNode();
                this.eat(43);
                let s = this.flowParseIntersectionType();
                for (e.types = [s]; this.eat(43); )
                  e.types.push(this.flowParseIntersectionType());
                return e.types.length === 1 ? s : this.finishNode(e, "UnionTypeAnnotation");
              }
              flowParseType() {
                let e = this.state.inType;
                this.state.inType = true;
                let s = this.flowParseUnionType();
                return this.state.inType = e, s;
              }
              flowParseTypeOrImplicitInstantiation() {
                if (this.state.type === 130 && this.state.value === "_") {
                  let e = this.state.startLoc, s = this.parseIdentifier();
                  return this.flowParseGenericType(e, s);
                } else
                  return this.flowParseType();
              }
              flowParseTypeAnnotation() {
                let e = this.startNode();
                return e.typeAnnotation = this.flowParseTypeInitialiser(), this.finishNode(e, "TypeAnnotation");
              }
              flowParseTypeAnnotatableIdentifier(e) {
                let s = e ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
                return this.match(14) && (s.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(s)), s;
              }
              typeCastToParameter(e) {
                return e.expression.typeAnnotation = e.typeAnnotation, this.resetEndLocation(e.expression, e.typeAnnotation.loc.end), e.expression;
              }
              flowParseVariance() {
                let e = null;
                return this.match(53) ? (e = this.startNode(), this.state.value === "+" ? e.kind = "plus" : e.kind = "minus", this.next(), this.finishNode(e, "Variance")) : e;
              }
              parseFunctionBody(e, s) {
                let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return s ? this.forwardNoArrowParamsConversionAt(e, () => super.parseFunctionBody(e, true, i)) : super.parseFunctionBody(e, false, i);
              }
              parseFunctionBodyAndFinish(e, s) {
                let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (this.match(14)) {
                  let a = this.startNode();
                  [a.typeAnnotation, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), e.returnType = a.typeAnnotation ? this.finishNode(a, "TypeAnnotation") : null;
                }
                return super.parseFunctionBodyAndFinish(e, s, i);
              }
              parseStatement(e, s) {
                if (this.state.strict && this.isContextual(127)) {
                  let a = this.lookahead();
                  if (pe(a.type)) {
                    let n = this.startNode();
                    return this.next(), this.flowParseInterface(n);
                  }
                } else if (this.shouldParseEnums() && this.isContextual(124)) {
                  let a = this.startNode();
                  return this.next(), this.flowParseEnumDeclaration(a);
                }
                let i = super.parseStatement(e, s);
                return this.flowPragma === void 0 && !this.isValidDirective(i) && (this.flowPragma = null), i;
              }
              parseExpressionStatement(e, s, i) {
                if (s.type === "Identifier") {
                  if (s.name === "declare") {
                    if (this.match(80) || $(this.state.type) || this.match(68) || this.match(74) || this.match(82))
                      return this.flowParseDeclare(e);
                  } else if ($(this.state.type)) {
                    if (s.name === "interface")
                      return this.flowParseInterface(e);
                    if (s.name === "type")
                      return this.flowParseTypeAlias(e);
                    if (s.name === "opaque")
                      return this.flowParseOpaqueType(e, false);
                  }
                }
                return super.parseExpressionStatement(e, s, i);
              }
              shouldParseExportDeclaration() {
                let { type: e } = this.state;
                return pr(e) || this.shouldParseEnums() && e === 124 ? !this.state.containsEsc : super.shouldParseExportDeclaration();
              }
              isExportDefaultSpecifier() {
                let { type: e } = this.state;
                return pr(e) || this.shouldParseEnums() && e === 124 ? this.state.containsEsc : super.isExportDefaultSpecifier();
              }
              parseExportDefaultExpression() {
                if (this.shouldParseEnums() && this.isContextual(124)) {
                  let e = this.startNode();
                  return this.next(), this.flowParseEnumDeclaration(e);
                }
                return super.parseExportDefaultExpression();
              }
              parseConditional(e, s, i) {
                if (!this.match(17))
                  return e;
                if (this.state.maybeInArrowParameters) {
                  let P = this.lookaheadCharCode();
                  if (P === 44 || P === 61 || P === 58 || P === 41)
                    return this.setOptionalParametersError(i), e;
                }
                this.expect(17);
                let a = this.state.clone(), n = this.state.noArrowAt, o = this.startNodeAt(s), { consequent: c, failed: p } = this.tryParseConditionalConsequent(), [m, x] = this.getArrowLikeExpressions(c);
                if (p || x.length > 0) {
                  let P = [...n];
                  if (x.length > 0) {
                    this.state = a, this.state.noArrowAt = P;
                    for (let b = 0; b < x.length; b++)
                      P.push(x[b].start);
                    ({ consequent: c, failed: p } = this.tryParseConditionalConsequent()), [m, x] = this.getArrowLikeExpressions(c);
                  }
                  p && m.length > 1 && this.raise(D.AmbiguousConditionalArrow, { at: a.startLoc }), p && m.length === 1 && (this.state = a, P.push(m[0].start), this.state.noArrowAt = P, { consequent: c, failed: p } = this.tryParseConditionalConsequent());
                }
                return this.getArrowLikeExpressions(c, true), this.state.noArrowAt = n, this.expect(14), o.test = e, o.consequent = c, o.alternate = this.forwardNoArrowParamsConversionAt(o, () => this.parseMaybeAssign(void 0, void 0)), this.finishNode(o, "ConditionalExpression");
              }
              tryParseConditionalConsequent() {
                this.state.noArrowParamsConversionAt.push(this.state.start);
                let e = this.parseMaybeAssignAllowIn(), s = !this.match(14);
                return this.state.noArrowParamsConversionAt.pop(), { consequent: e, failed: s };
              }
              getArrowLikeExpressions(e, s) {
                let i = [e], a = [];
                for (; i.length !== 0; ) {
                  let n = i.pop();
                  n.type === "ArrowFunctionExpression" ? (n.typeParameters || !n.returnType ? this.finishArrowValidation(n) : a.push(n), i.push(n.body)) : n.type === "ConditionalExpression" && (i.push(n.consequent), i.push(n.alternate));
                }
                return s ? (a.forEach((n) => this.finishArrowValidation(n)), [a, []]) : Dl(a, (n) => n.params.every((o) => this.isAssignable(o, true)));
              }
              finishArrowValidation(e) {
                var s;
                this.toAssignableList(e.params, (s = e.extra) == null ? void 0 : s.trailingCommaLoc, false), this.scope.enter(me | Yt), super.checkParams(e, false, true), this.scope.exit();
              }
              forwardNoArrowParamsConversionAt(e, s) {
                let i;
                return this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1 ? (this.state.noArrowParamsConversionAt.push(this.state.start), i = s(), this.state.noArrowParamsConversionAt.pop()) : i = s(), i;
              }
              parseParenItem(e, s) {
                if (e = super.parseParenItem(e, s), this.eat(17) && (e.optional = true, this.resetEndLocation(e)), this.match(14)) {
                  let i = this.startNodeAt(s);
                  return i.expression = e, i.typeAnnotation = this.flowParseTypeAnnotation(), this.finishNode(i, "TypeCastExpression");
                }
                return e;
              }
              assertModuleNodeAllowed(e) {
                e.type === "ImportDeclaration" && (e.importKind === "type" || e.importKind === "typeof") || e.type === "ExportNamedDeclaration" && e.exportKind === "type" || e.type === "ExportAllDeclaration" && e.exportKind === "type" || super.assertModuleNodeAllowed(e);
              }
              parseExport(e, s) {
                let i = super.parseExport(e, s);
                return (i.type === "ExportNamedDeclaration" || i.type === "ExportAllDeclaration") && (i.exportKind = i.exportKind || "value"), i;
              }
              parseExportDeclaration(e) {
                if (this.isContextual(128)) {
                  e.exportKind = "type";
                  let s = this.startNode();
                  return this.next(), this.match(5) ? (e.specifiers = this.parseExportSpecifiers(true), super.parseExportFrom(e), null) : this.flowParseTypeAlias(s);
                } else if (this.isContextual(129)) {
                  e.exportKind = "type";
                  let s = this.startNode();
                  return this.next(), this.flowParseOpaqueType(s, false);
                } else if (this.isContextual(127)) {
                  e.exportKind = "type";
                  let s = this.startNode();
                  return this.next(), this.flowParseInterface(s);
                } else if (this.shouldParseEnums() && this.isContextual(124)) {
                  e.exportKind = "value";
                  let s = this.startNode();
                  return this.next(), this.flowParseEnumDeclaration(s);
                } else
                  return super.parseExportDeclaration(e);
              }
              eatExportStar(e) {
                return super.eatExportStar(e) ? true : this.isContextual(128) && this.lookahead().type === 55 ? (e.exportKind = "type", this.next(), this.next(), true) : false;
              }
              maybeParseExportNamespaceSpecifier(e) {
                let { startLoc: s } = this.state, i = super.maybeParseExportNamespaceSpecifier(e);
                return i && e.exportKind === "type" && this.unexpected(s), i;
              }
              parseClassId(e, s, i) {
                super.parseClassId(e, s, i), this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration());
              }
              parseClassMember(e, s, i) {
                let { startLoc: a } = this.state;
                if (this.isContextual(123)) {
                  if (super.parseClassMemberFromModifier(e, s))
                    return;
                  s.declare = true;
                }
                super.parseClassMember(e, s, i), s.declare && (s.type !== "ClassProperty" && s.type !== "ClassPrivateProperty" && s.type !== "PropertyDefinition" ? this.raise(D.DeclareClassElement, { at: a }) : s.value && this.raise(D.DeclareClassFieldInitializer, { at: s.value }));
              }
              isIterator(e) {
                return e === "iterator" || e === "asyncIterator";
              }
              readIterator() {
                let e = super.readWord1(), s = "@@" + e;
                (!this.isIterator(e) || !this.state.inType) && this.raise(h.InvalidIdentifier, { at: this.state.curPosition(), identifierName: s }), this.finishToken(130, s);
              }
              getTokenFromCode(e) {
                let s = this.input.charCodeAt(this.state.pos + 1);
                return e === 123 && s === 124 ? this.finishOp(6, 2) : this.state.inType && (e === 62 || e === 60) ? this.finishOp(e === 62 ? 48 : 47, 1) : this.state.inType && e === 63 ? s === 46 ? this.finishOp(18, 2) : this.finishOp(17, 1) : $o(e, s, this.input.charCodeAt(this.state.pos + 2)) ? (this.state.pos += 2, this.readIterator()) : super.getTokenFromCode(e);
              }
              isAssignable(e, s) {
                return e.type === "TypeCastExpression" ? this.isAssignable(e.expression, s) : super.isAssignable(e, s);
              }
              toAssignable(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                !s && e.type === "AssignmentExpression" && e.left.type === "TypeCastExpression" && (e.left = this.typeCastToParameter(e.left)), super.toAssignable(e, s);
              }
              toAssignableList(e, s, i) {
                for (let a = 0; a < e.length; a++) {
                  let n = e[a];
                  (n == null ? void 0 : n.type) === "TypeCastExpression" && (e[a] = this.typeCastToParameter(n));
                }
                super.toAssignableList(e, s, i);
              }
              toReferencedList(e, s) {
                for (let a = 0; a < e.length; a++) {
                  var i;
                  let n = e[a];
                  n && n.type === "TypeCastExpression" && !((i = n.extra) != null && i.parenthesized) && (e.length > 1 || !s) && this.raise(D.TypeCastInPattern, { at: n.typeAnnotation });
                }
                return e;
              }
              parseArrayLike(e, s, i, a) {
                let n = super.parseArrayLike(e, s, i, a);
                return s && !this.state.maybeInArrowParameters && this.toReferencedList(n.elements), n;
              }
              isValidLVal(e, s, i) {
                return e === "TypeCastExpression" || super.isValidLVal(e, s, i);
              }
              parseClassProperty(e) {
                return this.match(14) && (e.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassProperty(e);
              }
              parseClassPrivateProperty(e) {
                return this.match(14) && (e.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassPrivateProperty(e);
              }
              isClassMethod() {
                return this.match(47) || super.isClassMethod();
              }
              isClassProperty() {
                return this.match(14) || super.isClassProperty();
              }
              isNonstaticConstructor(e) {
                return !this.match(14) && super.isNonstaticConstructor(e);
              }
              pushClassMethod(e, s, i, a, n, o) {
                if (s.variance && this.unexpected(s.variance.loc.start), delete s.variance, this.match(47) && (s.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassMethod(e, s, i, a, n, o), s.params && n) {
                  let c = s.params;
                  c.length > 0 && this.isThisParam(c[0]) && this.raise(D.ThisParamBannedInConstructor, { at: s });
                } else if (s.type === "MethodDefinition" && n && s.value.params) {
                  let c = s.value.params;
                  c.length > 0 && this.isThisParam(c[0]) && this.raise(D.ThisParamBannedInConstructor, { at: s });
                }
              }
              pushClassPrivateMethod(e, s, i, a) {
                s.variance && this.unexpected(s.variance.loc.start), delete s.variance, this.match(47) && (s.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassPrivateMethod(e, s, i, a);
              }
              parseClassSuper(e) {
                if (super.parseClassSuper(e), e.superClass && this.match(47) && (e.superTypeParameters = this.flowParseTypeParameterInstantiation()), this.isContextual(111)) {
                  this.next();
                  let s = e.implements = [];
                  do {
                    let i = this.startNode();
                    i.id = this.flowParseRestrictedIdentifier(true), this.match(47) ? i.typeParameters = this.flowParseTypeParameterInstantiation() : i.typeParameters = null, s.push(this.finishNode(i, "ClassImplements"));
                  } while (this.eat(12));
                }
              }
              checkGetterSetterParams(e) {
                super.checkGetterSetterParams(e);
                let s = this.getObjectOrClassMethodParams(e);
                if (s.length > 0) {
                  let i = s[0];
                  this.isThisParam(i) && e.kind === "get" ? this.raise(D.GetterMayNotHaveThisParam, { at: i }) : this.isThisParam(i) && this.raise(D.SetterMayNotHaveThisParam, { at: i });
                }
              }
              parsePropertyNamePrefixOperator(e) {
                e.variance = this.flowParseVariance();
              }
              parseObjPropValue(e, s, i, a, n, o, c) {
                e.variance && this.unexpected(e.variance.loc.start), delete e.variance;
                let p;
                this.match(47) && !o && (p = this.flowParseTypeParameterDeclaration(), this.match(10) || this.unexpected());
                let m = super.parseObjPropValue(e, s, i, a, n, o, c);
                return p && ((m.value || m).typeParameters = p), m;
              }
              parseAssignableListItemTypes(e) {
                return this.eat(17) && (e.type !== "Identifier" && this.raise(D.PatternIsOptional, { at: e }), this.isThisParam(e) && this.raise(D.ThisParamMayNotBeOptional, { at: e }), e.optional = true), this.match(14) ? e.typeAnnotation = this.flowParseTypeAnnotation() : this.isThisParam(e) && this.raise(D.ThisParamAnnotationRequired, { at: e }), this.match(29) && this.isThisParam(e) && this.raise(D.ThisParamNoDefault, { at: e }), this.resetEndLocation(e), e;
              }
              parseMaybeDefault(e, s) {
                let i = super.parseMaybeDefault(e, s);
                return i.type === "AssignmentPattern" && i.typeAnnotation && i.right.start < i.typeAnnotation.start && this.raise(D.TypeBeforeInitializer, { at: i.typeAnnotation }), i;
              }
              shouldParseDefaultImport(e) {
                return ds(e) ? Ur(this.state.type) : super.shouldParseDefaultImport(e);
              }
              checkImportReflection(e) {
                super.checkImportReflection(e), e.module && e.importKind !== "value" && this.raise(D.ImportReflectionHasImportType, { at: e.specifiers[0].loc.start });
              }
              parseImportSpecifierLocal(e, s, i) {
                s.local = ds(e) ? this.flowParseRestrictedIdentifier(true, true) : this.parseIdentifier(), e.specifiers.push(this.finishImportSpecifier(s, i));
              }
              maybeParseDefaultImportSpecifier(e) {
                e.importKind = "value";
                let s = null;
                if (this.match(87) ? s = "typeof" : this.isContextual(128) && (s = "type"), s) {
                  let i = this.lookahead(), { type: a } = i;
                  s === "type" && a === 55 && this.unexpected(null, i.type), (Ur(a) || a === 5 || a === 55) && (this.next(), e.importKind = s);
                }
                return super.maybeParseDefaultImportSpecifier(e);
              }
              parseImportSpecifier(e, s, i, a, n) {
                let o = e.imported, c = null;
                o.type === "Identifier" && (o.name === "type" ? c = "type" : o.name === "typeof" && (c = "typeof"));
                let p = false;
                if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
                  let x = this.parseIdentifier(true);
                  c !== null && !pe(this.state.type) ? (e.imported = x, e.importKind = c, e.local = xe(x)) : (e.imported = o, e.importKind = null, e.local = this.parseIdentifier());
                } else {
                  if (c !== null && pe(this.state.type))
                    e.imported = this.parseIdentifier(true), e.importKind = c;
                  else {
                    if (s)
                      throw this.raise(h.ImportBindingIsString, { at: e, importName: o.value });
                    e.imported = o, e.importKind = null;
                  }
                  this.eatContextual(93) ? e.local = this.parseIdentifier() : (p = true, e.local = xe(e.imported));
                }
                let m = ds(e);
                return i && m && this.raise(D.ImportTypeShorthandOnlyInPureImport, { at: e }), (i || m) && this.checkReservedType(e.local.name, e.local.loc.start, true), p && !i && !m && this.checkReservedWord(e.local.name, e.loc.start, true, true), this.finishImportSpecifier(e, "ImportSpecifier");
              }
              parseBindingAtom() {
                switch (this.state.type) {
                  case 78:
                    return this.parseIdentifier(true);
                  default:
                    return super.parseBindingAtom();
                }
              }
              parseFunctionParams(e, s) {
                let i = e.kind;
                i !== "get" && i !== "set" && this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration()), super.parseFunctionParams(e, s);
              }
              parseVarId(e, s) {
                super.parseVarId(e, s), this.match(14) && (e.id.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(e.id));
              }
              parseAsyncArrowFromCallExpression(e, s) {
                if (this.match(14)) {
                  let i = this.state.noAnonFunctionType;
                  this.state.noAnonFunctionType = true, e.returnType = this.flowParseTypeAnnotation(), this.state.noAnonFunctionType = i;
                }
                return super.parseAsyncArrowFromCallExpression(e, s);
              }
              shouldParseAsyncArrow() {
                return this.match(14) || super.shouldParseAsyncArrow();
              }
              parseMaybeAssign(e, s) {
                var i;
                let a = null, n;
                if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
                  if (a = this.state.clone(), n = this.tryParse(() => super.parseMaybeAssign(e, s), a), !n.error)
                    return n.node;
                  let { context: p } = this.state, m = p[p.length - 1];
                  (m === H.j_oTag || m === H.j_expr) && p.pop();
                }
                if ((i = n) != null && i.error || this.match(47)) {
                  var o, c;
                  a = a || this.state.clone();
                  let p, m = this.tryParse((P) => {
                    var b;
                    p = this.flowParseTypeParameterDeclaration();
                    let O = this.forwardNoArrowParamsConversionAt(p, () => {
                      let Q = super.parseMaybeAssign(e, s);
                      return this.resetStartLocationFromNode(Q, p), Q;
                    });
                    (b = O.extra) != null && b.parenthesized && P();
                    let R = this.maybeUnwrapTypeCastExpression(O);
                    return R.type !== "ArrowFunctionExpression" && P(), R.typeParameters = p, this.resetStartLocationFromNode(R, p), O;
                  }, a), x = null;
                  if (m.node && this.maybeUnwrapTypeCastExpression(m.node).type === "ArrowFunctionExpression") {
                    if (!m.error && !m.aborted)
                      return m.node.async && this.raise(D.UnexpectedTypeParameterBeforeAsyncArrowFunction, { at: p }), m.node;
                    x = m.node;
                  }
                  if ((o = n) != null && o.node)
                    return this.state = n.failState, n.node;
                  if (x)
                    return this.state = m.failState, x;
                  throw (c = n) != null && c.thrown ? n.error : m.thrown ? m.error : this.raise(D.UnexpectedTokenAfterTypeParameter, { at: p });
                }
                return super.parseMaybeAssign(e, s);
              }
              parseArrow(e) {
                if (this.match(14)) {
                  let s = this.tryParse(() => {
                    let i = this.state.noAnonFunctionType;
                    this.state.noAnonFunctionType = true;
                    let a = this.startNode();
                    return [a.typeAnnotation, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), this.state.noAnonFunctionType = i, this.canInsertSemicolon() && this.unexpected(), this.match(19) || this.unexpected(), a;
                  });
                  if (s.thrown)
                    return null;
                  s.error && (this.state = s.failState), e.returnType = s.node.typeAnnotation ? this.finishNode(s.node, "TypeAnnotation") : null;
                }
                return super.parseArrow(e);
              }
              shouldParseArrow(e) {
                return this.match(14) || super.shouldParseArrow(e);
              }
              setArrowFunctionParameters(e, s) {
                this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1 ? e.params = s : super.setArrowFunctionParameters(e, s);
              }
              checkParams(e, s, i) {
                let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
                if (!(i && this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1)) {
                  for (let n = 0; n < e.params.length; n++)
                    this.isThisParam(e.params[n]) && n > 0 && this.raise(D.ThisParamMustBeFirst, { at: e.params[n] });
                  return super.checkParams(e, s, i, a);
                }
              }
              parseParenAndDistinguishExpression(e) {
                return super.parseParenAndDistinguishExpression(e && this.state.noArrowAt.indexOf(this.state.start) === -1);
              }
              parseSubscripts(e, s, i) {
                if (e.type === "Identifier" && e.name === "async" && this.state.noArrowAt.indexOf(s.index) !== -1) {
                  this.next();
                  let a = this.startNodeAt(s);
                  a.callee = e, a.arguments = super.parseCallExpressionArguments(11, false), e = this.finishNode(a, "CallExpression");
                } else if (e.type === "Identifier" && e.name === "async" && this.match(47)) {
                  let a = this.state.clone(), n = this.tryParse((c) => this.parseAsyncArrowWithTypeParameters(s) || c(), a);
                  if (!n.error && !n.aborted)
                    return n.node;
                  let o = this.tryParse(() => super.parseSubscripts(e, s, i), a);
                  if (o.node && !o.error)
                    return o.node;
                  if (n.node)
                    return this.state = n.failState, n.node;
                  if (o.node)
                    return this.state = o.failState, o.node;
                  throw n.error || o.error;
                }
                return super.parseSubscripts(e, s, i);
              }
              parseSubscript(e, s, i, a) {
                if (this.match(18) && this.isLookaheadToken_lt()) {
                  if (a.optionalChainMember = true, i)
                    return a.stop = true, e;
                  this.next();
                  let n = this.startNodeAt(s);
                  return n.callee = e, n.typeArguments = this.flowParseTypeParameterInstantiation(), this.expect(10), n.arguments = this.parseCallExpressionArguments(11, false), n.optional = true, this.finishCallExpression(n, true);
                } else if (!i && this.shouldParseTypes() && this.match(47)) {
                  let n = this.startNodeAt(s);
                  n.callee = e;
                  let o = this.tryParse(() => (n.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew(), this.expect(10), n.arguments = super.parseCallExpressionArguments(11, false), a.optionalChainMember && (n.optional = false), this.finishCallExpression(n, a.optionalChainMember)));
                  if (o.node)
                    return o.error && (this.state = o.failState), o.node;
                }
                return super.parseSubscript(e, s, i, a);
              }
              parseNewCallee(e) {
                super.parseNewCallee(e);
                let s = null;
                this.shouldParseTypes() && this.match(47) && (s = this.tryParse(() => this.flowParseTypeParameterInstantiationCallOrNew()).node), e.typeArguments = s;
              }
              parseAsyncArrowWithTypeParameters(e) {
                let s = this.startNodeAt(e);
                if (this.parseFunctionParams(s), !!this.parseArrow(s))
                  return super.parseArrowExpression(s, void 0, true);
              }
              readToken_mult_modulo(e) {
                let s = this.input.charCodeAt(this.state.pos + 1);
                if (e === 42 && s === 47 && this.state.hasFlowComment) {
                  this.state.hasFlowComment = false, this.state.pos += 2, this.nextToken();
                  return;
                }
                super.readToken_mult_modulo(e);
              }
              readToken_pipe_amp(e) {
                let s = this.input.charCodeAt(this.state.pos + 1);
                if (e === 124 && s === 125) {
                  this.finishOp(9, 2);
                  return;
                }
                super.readToken_pipe_amp(e);
              }
              parseTopLevel(e, s) {
                let i = super.parseTopLevel(e, s);
                return this.state.hasFlowComment && this.raise(D.UnterminatedFlowComment, { at: this.state.curPosition() }), i;
              }
              skipBlockComment() {
                if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
                  if (this.state.hasFlowComment)
                    throw this.raise(D.NestedFlowComment, { at: this.state.startLoc });
                  this.hasFlowCommentCompletion();
                  let e = this.skipFlowComment();
                  e && (this.state.pos += e, this.state.hasFlowComment = true);
                  return;
                }
                return super.skipBlockComment(this.state.hasFlowComment ? "*-/" : "*/");
              }
              skipFlowComment() {
                let { pos: e } = this.state, s = 2;
                for (; [32, 9].includes(this.input.charCodeAt(e + s)); )
                  s++;
                let i = this.input.charCodeAt(s + e), a = this.input.charCodeAt(s + e + 1);
                return i === 58 && a === 58 ? s + 2 : this.input.slice(s + e, s + e + 12) === "flow-include" ? s + 12 : i === 58 && a !== 58 ? s : false;
              }
              hasFlowCommentCompletion() {
                if (this.input.indexOf("*/", this.state.pos) === -1)
                  throw this.raise(h.UnterminatedComment, { at: this.state.curPosition() });
              }
              flowEnumErrorBooleanMemberNotInitialized(e, s) {
                let { enumName: i, memberName: a } = s;
                this.raise(D.EnumBooleanMemberNotInitialized, { at: e, memberName: a, enumName: i });
              }
              flowEnumErrorInvalidMemberInitializer(e, s) {
                return this.raise(s.explicitType ? s.explicitType === "symbol" ? D.EnumInvalidMemberInitializerSymbolType : D.EnumInvalidMemberInitializerPrimaryType : D.EnumInvalidMemberInitializerUnknownType, Object.assign({ at: e }, s));
              }
              flowEnumErrorNumberMemberNotInitialized(e, s) {
                let { enumName: i, memberName: a } = s;
                this.raise(D.EnumNumberMemberNotInitialized, { at: e, enumName: i, memberName: a });
              }
              flowEnumErrorStringMemberInconsistentlyInitailized(e, s) {
                let { enumName: i } = s;
                this.raise(D.EnumStringMemberInconsistentlyInitailized, { at: e, enumName: i });
              }
              flowEnumMemberInit() {
                let e = this.state.startLoc, s = () => this.match(12) || this.match(8);
                switch (this.state.type) {
                  case 132: {
                    let i = this.parseNumericLiteral(this.state.value);
                    return s() ? { type: "number", loc: i.loc.start, value: i } : { type: "invalid", loc: e };
                  }
                  case 131: {
                    let i = this.parseStringLiteral(this.state.value);
                    return s() ? { type: "string", loc: i.loc.start, value: i } : { type: "invalid", loc: e };
                  }
                  case 85:
                  case 86: {
                    let i = this.parseBooleanLiteral(this.match(85));
                    return s() ? { type: "boolean", loc: i.loc.start, value: i } : { type: "invalid", loc: e };
                  }
                  default:
                    return { type: "invalid", loc: e };
                }
              }
              flowEnumMemberRaw() {
                let e = this.state.startLoc, s = this.parseIdentifier(true), i = this.eat(29) ? this.flowEnumMemberInit() : { type: "none", loc: e };
                return { id: s, init: i };
              }
              flowEnumCheckExplicitTypeMismatch(e, s, i) {
                let { explicitType: a } = s;
                a !== null && a !== i && this.flowEnumErrorInvalidMemberInitializer(e, s);
              }
              flowEnumMembers(e) {
                let { enumName: s, explicitType: i } = e, a = /* @__PURE__ */ new Set(), n = { booleanMembers: [], numberMembers: [], stringMembers: [], defaultedMembers: [] }, o = false;
                for (; !this.match(8); ) {
                  if (this.eat(21)) {
                    o = true;
                    break;
                  }
                  let c = this.startNode(), { id: p, init: m } = this.flowEnumMemberRaw(), x = p.name;
                  if (x === "")
                    continue;
                  /^[a-z]/.test(x) && this.raise(D.EnumInvalidMemberName, { at: p, memberName: x, suggestion: x[0].toUpperCase() + x.slice(1), enumName: s }), a.has(x) && this.raise(D.EnumDuplicateMemberName, { at: p, memberName: x, enumName: s }), a.add(x);
                  let P = { enumName: s, explicitType: i, memberName: x };
                  switch (c.id = p, m.type) {
                    case "boolean": {
                      this.flowEnumCheckExplicitTypeMismatch(m.loc, P, "boolean"), c.init = m.value, n.booleanMembers.push(this.finishNode(c, "EnumBooleanMember"));
                      break;
                    }
                    case "number": {
                      this.flowEnumCheckExplicitTypeMismatch(m.loc, P, "number"), c.init = m.value, n.numberMembers.push(this.finishNode(c, "EnumNumberMember"));
                      break;
                    }
                    case "string": {
                      this.flowEnumCheckExplicitTypeMismatch(m.loc, P, "string"), c.init = m.value, n.stringMembers.push(this.finishNode(c, "EnumStringMember"));
                      break;
                    }
                    case "invalid":
                      throw this.flowEnumErrorInvalidMemberInitializer(m.loc, P);
                    case "none":
                      switch (i) {
                        case "boolean":
                          this.flowEnumErrorBooleanMemberNotInitialized(m.loc, P);
                          break;
                        case "number":
                          this.flowEnumErrorNumberMemberNotInitialized(m.loc, P);
                          break;
                        default:
                          n.defaultedMembers.push(this.finishNode(c, "EnumDefaultedMember"));
                      }
                  }
                  this.match(8) || this.expect(12);
                }
                return { members: n, hasUnknownMembers: o };
              }
              flowEnumStringMembers(e, s, i) {
                let { enumName: a } = i;
                if (e.length === 0)
                  return s;
                if (s.length === 0)
                  return e;
                if (s.length > e.length) {
                  for (let n of e)
                    this.flowEnumErrorStringMemberInconsistentlyInitailized(n, { enumName: a });
                  return s;
                } else {
                  for (let n of s)
                    this.flowEnumErrorStringMemberInconsistentlyInitailized(n, { enumName: a });
                  return e;
                }
              }
              flowEnumParseExplicitType(e) {
                let { enumName: s } = e;
                if (!this.eatContextual(101))
                  return null;
                if (!$(this.state.type))
                  throw this.raise(D.EnumInvalidExplicitTypeUnknownSupplied, { at: this.state.startLoc, enumName: s });
                let { value: i } = this.state;
                return this.next(), i !== "boolean" && i !== "number" && i !== "string" && i !== "symbol" && this.raise(D.EnumInvalidExplicitType, { at: this.state.startLoc, enumName: s, invalidEnumType: i }), i;
              }
              flowEnumBody(e, s) {
                let i = s.name, a = s.loc.start, n = this.flowEnumParseExplicitType({ enumName: i });
                this.expect(5);
                let { members: o, hasUnknownMembers: c } = this.flowEnumMembers({ enumName: i, explicitType: n });
                switch (e.hasUnknownMembers = c, n) {
                  case "boolean":
                    return e.explicitType = true, e.members = o.booleanMembers, this.expect(8), this.finishNode(e, "EnumBooleanBody");
                  case "number":
                    return e.explicitType = true, e.members = o.numberMembers, this.expect(8), this.finishNode(e, "EnumNumberBody");
                  case "string":
                    return e.explicitType = true, e.members = this.flowEnumStringMembers(o.stringMembers, o.defaultedMembers, { enumName: i }), this.expect(8), this.finishNode(e, "EnumStringBody");
                  case "symbol":
                    return e.members = o.defaultedMembers, this.expect(8), this.finishNode(e, "EnumSymbolBody");
                  default: {
                    let p = () => (e.members = [], this.expect(8), this.finishNode(e, "EnumStringBody"));
                    e.explicitType = false;
                    let m = o.booleanMembers.length, x = o.numberMembers.length, P = o.stringMembers.length, b = o.defaultedMembers.length;
                    if (!m && !x && !P && !b)
                      return p();
                    if (!m && !x)
                      return e.members = this.flowEnumStringMembers(o.stringMembers, o.defaultedMembers, { enumName: i }), this.expect(8), this.finishNode(e, "EnumStringBody");
                    if (!x && !P && m >= b) {
                      for (let O of o.defaultedMembers)
                        this.flowEnumErrorBooleanMemberNotInitialized(O.loc.start, { enumName: i, memberName: O.id.name });
                      return e.members = o.booleanMembers, this.expect(8), this.finishNode(e, "EnumBooleanBody");
                    } else if (!m && !P && x >= b) {
                      for (let O of o.defaultedMembers)
                        this.flowEnumErrorNumberMemberNotInitialized(O.loc.start, { enumName: i, memberName: O.id.name });
                      return e.members = o.numberMembers, this.expect(8), this.finishNode(e, "EnumNumberBody");
                    } else
                      return this.raise(D.EnumInconsistentMemberValues, { at: a, enumName: i }), p();
                  }
                }
              }
              flowParseEnumDeclaration(e) {
                let s = this.parseIdentifier();
                return e.id = s, e.body = this.flowEnumBody(this.startNode(), s), this.finishNode(e, "EnumDeclaration");
              }
              isLookaheadToken_lt() {
                let e = this.nextTokenStart();
                if (this.input.charCodeAt(e) === 60) {
                  let s = this.input.charCodeAt(e + 1);
                  return s !== 60 && s !== 61;
                }
                return false;
              }
              maybeUnwrapTypeCastExpression(e) {
                return e.type === "TypeCastExpression" ? e.expression : e;
              }
            }, Ol = { __proto__: null, quot: '"', amp: "&", apos: "'", lt: "<", gt: ">", nbsp: "\xA0", iexcl: "\xA1", cent: "\xA2", pound: "\xA3", curren: "\xA4", yen: "\xA5", brvbar: "\xA6", sect: "\xA7", uml: "\xA8", copy: "\xA9", ordf: "\xAA", laquo: "\xAB", not: "\xAC", shy: "\xAD", reg: "\xAE", macr: "\xAF", deg: "\xB0", plusmn: "\xB1", sup2: "\xB2", sup3: "\xB3", acute: "\xB4", micro: "\xB5", para: "\xB6", middot: "\xB7", cedil: "\xB8", sup1: "\xB9", ordm: "\xBA", raquo: "\xBB", frac14: "\xBC", frac12: "\xBD", frac34: "\xBE", iquest: "\xBF", Agrave: "\xC0", Aacute: "\xC1", Acirc: "\xC2", Atilde: "\xC3", Auml: "\xC4", Aring: "\xC5", AElig: "\xC6", Ccedil: "\xC7", Egrave: "\xC8", Eacute: "\xC9", Ecirc: "\xCA", Euml: "\xCB", Igrave: "\xCC", Iacute: "\xCD", Icirc: "\xCE", Iuml: "\xCF", ETH: "\xD0", Ntilde: "\xD1", Ograve: "\xD2", Oacute: "\xD3", Ocirc: "\xD4", Otilde: "\xD5", Ouml: "\xD6", times: "\xD7", Oslash: "\xD8", Ugrave: "\xD9", Uacute: "\xDA", Ucirc: "\xDB", Uuml: "\xDC", Yacute: "\xDD", THORN: "\xDE", szlig: "\xDF", agrave: "\xE0", aacute: "\xE1", acirc: "\xE2", atilde: "\xE3", auml: "\xE4", aring: "\xE5", aelig: "\xE6", ccedil: "\xE7", egrave: "\xE8", eacute: "\xE9", ecirc: "\xEA", euml: "\xEB", igrave: "\xEC", iacute: "\xED", icirc: "\xEE", iuml: "\xEF", eth: "\xF0", ntilde: "\xF1", ograve: "\xF2", oacute: "\xF3", ocirc: "\xF4", otilde: "\xF5", ouml: "\xF6", divide: "\xF7", oslash: "\xF8", ugrave: "\xF9", uacute: "\xFA", ucirc: "\xFB", uuml: "\xFC", yacute: "\xFD", thorn: "\xFE", yuml: "\xFF", OElig: "\u0152", oelig: "\u0153", Scaron: "\u0160", scaron: "\u0161", Yuml: "\u0178", fnof: "\u0192", circ: "\u02C6", tilde: "\u02DC", Alpha: "\u0391", Beta: "\u0392", Gamma: "\u0393", Delta: "\u0394", Epsilon: "\u0395", Zeta: "\u0396", Eta: "\u0397", Theta: "\u0398", Iota: "\u0399", Kappa: "\u039A", Lambda: "\u039B", Mu: "\u039C", Nu: "\u039D", Xi: "\u039E", Omicron: "\u039F", Pi: "\u03A0", Rho: "\u03A1", Sigma: "\u03A3", Tau: "\u03A4", Upsilon: "\u03A5", Phi: "\u03A6", Chi: "\u03A7", Psi: "\u03A8", Omega: "\u03A9", alpha: "\u03B1", beta: "\u03B2", gamma: "\u03B3", delta: "\u03B4", epsilon: "\u03B5", zeta: "\u03B6", eta: "\u03B7", theta: "\u03B8", iota: "\u03B9", kappa: "\u03BA", lambda: "\u03BB", mu: "\u03BC", nu: "\u03BD", xi: "\u03BE", omicron: "\u03BF", pi: "\u03C0", rho: "\u03C1", sigmaf: "\u03C2", sigma: "\u03C3", tau: "\u03C4", upsilon: "\u03C5", phi: "\u03C6", chi: "\u03C7", psi: "\u03C8", omega: "\u03C9", thetasym: "\u03D1", upsih: "\u03D2", piv: "\u03D6", ensp: "\u2002", emsp: "\u2003", thinsp: "\u2009", zwnj: "\u200C", zwj: "\u200D", lrm: "\u200E", rlm: "\u200F", ndash: "\u2013", mdash: "\u2014", lsquo: "\u2018", rsquo: "\u2019", sbquo: "\u201A", ldquo: "\u201C", rdquo: "\u201D", bdquo: "\u201E", dagger: "\u2020", Dagger: "\u2021", bull: "\u2022", hellip: "\u2026", permil: "\u2030", prime: "\u2032", Prime: "\u2033", lsaquo: "\u2039", rsaquo: "\u203A", oline: "\u203E", frasl: "\u2044", euro: "\u20AC", image: "\u2111", weierp: "\u2118", real: "\u211C", trade: "\u2122", alefsym: "\u2135", larr: "\u2190", uarr: "\u2191", rarr: "\u2192", darr: "\u2193", harr: "\u2194", crarr: "\u21B5", lArr: "\u21D0", uArr: "\u21D1", rArr: "\u21D2", dArr: "\u21D3", hArr: "\u21D4", forall: "\u2200", part: "\u2202", exist: "\u2203", empty: "\u2205", nabla: "\u2207", isin: "\u2208", notin: "\u2209", ni: "\u220B", prod: "\u220F", sum: "\u2211", minus: "\u2212", lowast: "\u2217", radic: "\u221A", prop: "\u221D", infin: "\u221E", ang: "\u2220", and: "\u2227", or: "\u2228", cap: "\u2229", cup: "\u222A", int: "\u222B", there4: "\u2234", sim: "\u223C", cong: "\u2245", asymp: "\u2248", ne: "\u2260", equiv: "\u2261", le: "\u2264", ge: "\u2265", sub: "\u2282", sup: "\u2283", nsub: "\u2284", sube: "\u2286", supe: "\u2287", oplus: "\u2295", otimes: "\u2297", perp: "\u22A5", sdot: "\u22C5", lceil: "\u2308", rceil: "\u2309", lfloor: "\u230A", rfloor: "\u230B", lang: "\u2329", rang: "\u232A", loz: "\u25CA", spades: "\u2660", clubs: "\u2663", hearts: "\u2665", diams: "\u2666" }, Ne = _`jsx`({ AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression.", MissingClosingTagElement: (t3) => {
              let { openingTagName: r } = t3;
              return `Expected corresponding JSX closing tag for <${r}>.`;
            }, MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>.", UnexpectedSequenceExpression: "Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?", UnexpectedToken: (t3) => {
              let { unexpected: r, HTMLEntity: e } = t3;
              return `Unexpected token \`${r}\`. Did you mean \`${e}\` or \`{'${r}'}\`?`;
            }, UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text.", UnterminatedJsxContent: "Unterminated JSX contents.", UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?" });
            function Ee(t3) {
              return t3 ? t3.type === "JSXOpeningFragment" || t3.type === "JSXClosingFragment" : false;
            }
            function He(t3) {
              if (t3.type === "JSXIdentifier")
                return t3.name;
              if (t3.type === "JSXNamespacedName")
                return t3.namespace.name + ":" + t3.name.name;
              if (t3.type === "JSXMemberExpression")
                return He(t3.object) + "." + He(t3.property);
              throw new Error("Node had unexpected type: " + t3.type);
            }
            var Ml = (t3) => class extends t3 {
              jsxReadToken() {
                let e = "", s = this.state.pos;
                for (; ; ) {
                  if (this.state.pos >= this.length)
                    throw this.raise(Ne.UnterminatedJsxContent, { at: this.state.startLoc });
                  let i = this.input.charCodeAt(this.state.pos);
                  switch (i) {
                    case 60:
                    case 123:
                      return this.state.pos === this.state.start ? i === 60 && this.state.canStartJSXElement ? (++this.state.pos, this.finishToken(140)) : super.getTokenFromCode(i) : (e += this.input.slice(s, this.state.pos), this.finishToken(139, e));
                    case 38:
                      e += this.input.slice(s, this.state.pos), e += this.jsxReadEntity(), s = this.state.pos;
                      break;
                    case 62:
                    case 125:
                    default:
                      Qe(i) ? (e += this.input.slice(s, this.state.pos), e += this.jsxReadNewLine(true), s = this.state.pos) : ++this.state.pos;
                  }
                }
              }
              jsxReadNewLine(e) {
                let s = this.input.charCodeAt(this.state.pos), i;
                return ++this.state.pos, s === 13 && this.input.charCodeAt(this.state.pos) === 10 ? (++this.state.pos, i = e ? `
` : `\r
`) : i = String.fromCharCode(s), ++this.state.curLine, this.state.lineStart = this.state.pos, i;
              }
              jsxReadString(e) {
                let s = "", i = ++this.state.pos;
                for (; ; ) {
                  if (this.state.pos >= this.length)
                    throw this.raise(h.UnterminatedString, { at: this.state.startLoc });
                  let a = this.input.charCodeAt(this.state.pos);
                  if (a === e)
                    break;
                  a === 38 ? (s += this.input.slice(i, this.state.pos), s += this.jsxReadEntity(), i = this.state.pos) : Qe(a) ? (s += this.input.slice(i, this.state.pos), s += this.jsxReadNewLine(false), i = this.state.pos) : ++this.state.pos;
                }
                return s += this.input.slice(i, this.state.pos++), this.finishToken(131, s);
              }
              jsxReadEntity() {
                let e = ++this.state.pos;
                if (this.codePointAtPos(this.state.pos) === 35) {
                  ++this.state.pos;
                  let s = 10;
                  this.codePointAtPos(this.state.pos) === 120 && (s = 16, ++this.state.pos);
                  let i = this.readInt(s, void 0, false, "bail");
                  if (i !== null && this.codePointAtPos(this.state.pos) === 59)
                    return ++this.state.pos, String.fromCodePoint(i);
                } else {
                  let s = 0, i = false;
                  for (; s++ < 10 && this.state.pos < this.length && !(i = this.codePointAtPos(this.state.pos) == 59); )
                    ++this.state.pos;
                  if (i) {
                    let a = this.input.slice(e, this.state.pos), n = Ol[a];
                    if (++this.state.pos, n)
                      return n;
                  }
                }
                return this.state.pos = e, "&";
              }
              jsxReadWord() {
                let e, s = this.state.pos;
                do
                  e = this.input.charCodeAt(++this.state.pos);
                while (Be(e) || e === 45);
                return this.finishToken(138, this.input.slice(s, this.state.pos));
              }
              jsxParseIdentifier() {
                let e = this.startNode();
                return this.match(138) ? e.name = this.state.value : Wt(this.state.type) ? e.name = Pe(this.state.type) : this.unexpected(), this.next(), this.finishNode(e, "JSXIdentifier");
              }
              jsxParseNamespacedName() {
                let e = this.state.startLoc, s = this.jsxParseIdentifier();
                if (!this.eat(14))
                  return s;
                let i = this.startNodeAt(e);
                return i.namespace = s, i.name = this.jsxParseIdentifier(), this.finishNode(i, "JSXNamespacedName");
              }
              jsxParseElementName() {
                let e = this.state.startLoc, s = this.jsxParseNamespacedName();
                if (s.type === "JSXNamespacedName")
                  return s;
                for (; this.eat(16); ) {
                  let i = this.startNodeAt(e);
                  i.object = s, i.property = this.jsxParseIdentifier(), s = this.finishNode(i, "JSXMemberExpression");
                }
                return s;
              }
              jsxParseAttributeValue() {
                let e;
                switch (this.state.type) {
                  case 5:
                    return e = this.startNode(), this.setContext(H.brace), this.next(), e = this.jsxParseExpressionContainer(e, H.j_oTag), e.expression.type === "JSXEmptyExpression" && this.raise(Ne.AttributeIsEmpty, { at: e }), e;
                  case 140:
                  case 131:
                    return this.parseExprAtom();
                  default:
                    throw this.raise(Ne.UnsupportedJsxValue, { at: this.state.startLoc });
                }
              }
              jsxParseEmptyExpression() {
                let e = this.startNodeAt(this.state.lastTokEndLoc);
                return this.finishNodeAt(e, "JSXEmptyExpression", this.state.startLoc);
              }
              jsxParseSpreadChild(e) {
                return this.next(), e.expression = this.parseExpression(), this.setContext(H.j_expr), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e, "JSXSpreadChild");
              }
              jsxParseExpressionContainer(e, s) {
                if (this.match(8))
                  e.expression = this.jsxParseEmptyExpression();
                else {
                  let i = this.parseExpression();
                  e.expression = i;
                }
                return this.setContext(s), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e, "JSXExpressionContainer");
              }
              jsxParseAttribute() {
                let e = this.startNode();
                return this.match(5) ? (this.setContext(H.brace), this.next(), this.expect(21), e.argument = this.parseMaybeAssignAllowIn(), this.setContext(H.j_oTag), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e, "JSXSpreadAttribute")) : (e.name = this.jsxParseNamespacedName(), e.value = this.eat(29) ? this.jsxParseAttributeValue() : null, this.finishNode(e, "JSXAttribute"));
              }
              jsxParseOpeningElementAt(e) {
                let s = this.startNodeAt(e);
                return this.eat(141) ? this.finishNode(s, "JSXOpeningFragment") : (s.name = this.jsxParseElementName(), this.jsxParseOpeningElementAfterName(s));
              }
              jsxParseOpeningElementAfterName(e) {
                let s = [];
                for (; !this.match(56) && !this.match(141); )
                  s.push(this.jsxParseAttribute());
                return e.attributes = s, e.selfClosing = this.eat(56), this.expect(141), this.finishNode(e, "JSXOpeningElement");
              }
              jsxParseClosingElementAt(e) {
                let s = this.startNodeAt(e);
                return this.eat(141) ? this.finishNode(s, "JSXClosingFragment") : (s.name = this.jsxParseElementName(), this.expect(141), this.finishNode(s, "JSXClosingElement"));
              }
              jsxParseElementAt(e) {
                let s = this.startNodeAt(e), i = [], a = this.jsxParseOpeningElementAt(e), n = null;
                if (!a.selfClosing) {
                  e:
                    for (; ; )
                      switch (this.state.type) {
                        case 140:
                          if (e = this.state.startLoc, this.next(), this.eat(56)) {
                            n = this.jsxParseClosingElementAt(e);
                            break e;
                          }
                          i.push(this.jsxParseElementAt(e));
                          break;
                        case 139:
                          i.push(this.parseExprAtom());
                          break;
                        case 5: {
                          let o = this.startNode();
                          this.setContext(H.brace), this.next(), this.match(21) ? i.push(this.jsxParseSpreadChild(o)) : i.push(this.jsxParseExpressionContainer(o, H.j_expr));
                          break;
                        }
                        default:
                          throw this.unexpected();
                      }
                  Ee(a) && !Ee(n) && n !== null ? this.raise(Ne.MissingClosingTagFragment, { at: n }) : !Ee(a) && Ee(n) ? this.raise(Ne.MissingClosingTagElement, { at: n, openingTagName: He(a.name) }) : !Ee(a) && !Ee(n) && He(n.name) !== He(a.name) && this.raise(Ne.MissingClosingTagElement, { at: n, openingTagName: He(a.name) });
                }
                if (Ee(a) ? (s.openingFragment = a, s.closingFragment = n) : (s.openingElement = a, s.closingElement = n), s.children = i, this.match(47))
                  throw this.raise(Ne.UnwrappedAdjacentJSXElements, { at: this.state.startLoc });
                return Ee(a) ? this.finishNode(s, "JSXFragment") : this.finishNode(s, "JSXElement");
              }
              jsxParseElement() {
                let e = this.state.startLoc;
                return this.next(), this.jsxParseElementAt(e);
              }
              setContext(e) {
                let { context: s } = this.state;
                s[s.length - 1] = e;
              }
              parseExprAtom(e) {
                return this.match(139) ? this.parseLiteral(this.state.value, "JSXText") : this.match(140) ? this.jsxParseElement() : this.match(47) && this.input.charCodeAt(this.state.pos) !== 33 ? (this.replaceToken(140), this.jsxParseElement()) : super.parseExprAtom(e);
              }
              skipSpace() {
                this.curContext().preserveSpace || super.skipSpace();
              }
              getTokenFromCode(e) {
                let s = this.curContext();
                if (s === H.j_expr)
                  return this.jsxReadToken();
                if (s === H.j_oTag || s === H.j_cTag) {
                  if (fe(e))
                    return this.jsxReadWord();
                  if (e === 62)
                    return ++this.state.pos, this.finishToken(141);
                  if ((e === 34 || e === 39) && s === H.j_oTag)
                    return this.jsxReadString(e);
                }
                return e === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33 ? (++this.state.pos, this.finishToken(140)) : super.getTokenFromCode(e);
              }
              updateContext(e) {
                let { context: s, type: i } = this.state;
                if (i === 56 && e === 140)
                  s.splice(-2, 2, H.j_cTag), this.state.canStartJSXElement = false;
                else if (i === 140)
                  s.push(H.j_oTag);
                else if (i === 141) {
                  let a = s[s.length - 1];
                  a === H.j_oTag && e === 56 || a === H.j_cTag ? (s.pop(), this.state.canStartJSXElement = s[s.length - 1] === H.j_expr) : (this.setContext(H.j_expr), this.state.canStartJSXElement = true);
                } else
                  this.state.canStartJSXElement = wo(i);
              }
            }, Bl = class extends ns {
              constructor() {
                super(...arguments), this.types = /* @__PURE__ */ new Set(), this.enums = /* @__PURE__ */ new Set(), this.constEnums = /* @__PURE__ */ new Set(), this.classes = /* @__PURE__ */ new Set(), this.exportOnlyBindings = /* @__PURE__ */ new Set();
              }
            }, _l = class extends os {
              constructor() {
                super(...arguments), this.importsStack = [];
              }
              createScope(t3) {
                return this.importsStack.push(/* @__PURE__ */ new Set()), new Bl(t3);
              }
              enter(t3) {
                t3 == je && this.importsStack.push(/* @__PURE__ */ new Set()), super.enter(t3);
              }
              exit() {
                let t3 = super.exit();
                return t3 == je && this.importsStack.pop(), t3;
              }
              hasImport(t3, r) {
                let e = this.importsStack.length;
                if (this.importsStack[e - 1].has(t3))
                  return true;
                if (!r && e > 1) {
                  for (let s = 0; s < e - 1; s++)
                    if (this.importsStack[s].has(t3))
                      return true;
                }
                return false;
              }
              declareName(t3, r, e) {
                if (r & Je) {
                  this.hasImport(t3, true) && this.parser.raise(h.VarRedeclaration, { at: e, identifierName: t3 }), this.importsStack[this.importsStack.length - 1].add(t3);
                  return;
                }
                let s = this.currentScope();
                if (r & es) {
                  this.maybeExportDefined(s, t3), s.exportOnlyBindings.add(t3);
                  return;
                }
                super.declareName(t3, r, e), r & we && (r & ye || (this.checkRedeclarationInScope(s, t3, r, e), this.maybeExportDefined(s, t3)), s.types.add(t3)), r & Qt && s.enums.add(t3), r & Zt && s.constEnums.add(t3), r & pt && s.classes.add(t3);
              }
              isRedeclaredInScope(t3, r, e) {
                if (t3.enums.has(r)) {
                  if (e & Qt) {
                    let s = !!(e & Zt), i = t3.constEnums.has(r);
                    return s !== i;
                  }
                  return true;
                }
                return e & pt && t3.classes.has(r) ? t3.lexical.has(r) ? !!(e & ye) : false : e & we && t3.types.has(r) ? true : super.isRedeclaredInScope(t3, r, e);
              }
              checkLocalExport(t3) {
                let { name: r } = t3;
                if (this.hasImport(r))
                  return;
                let e = this.scopeStack.length;
                for (let s = e - 1; s >= 0; s--) {
                  let i = this.scopeStack[s];
                  if (i.types.has(r) || i.exportOnlyBindings.has(r))
                    return;
                }
                super.checkLocalExport(t3);
              }
            }, Rl = (t3, r) => Object.hasOwnProperty.call(t3, r) && t3[r];
            function jl(t3) {
              if (t3 == null)
                throw new Error(`Unexpected ${t3} value.`);
              return t3;
            }
            function Hr(t3) {
              if (!t3)
                throw new Error("Assert fail");
            }
            var w = _`typescript`({ AbstractMethodHasImplementation: (t3) => {
              let { methodName: r } = t3;
              return `Method '${r}' cannot have an implementation because it is marked abstract.`;
            }, AbstractPropertyHasInitializer: (t3) => {
              let { propertyName: r } = t3;
              return `Property '${r}' cannot have an initializer because it is marked abstract.`;
            }, AccesorCannotDeclareThisParameter: "'get' and 'set' accessors cannot declare 'this' parameters.", AccesorCannotHaveTypeParameters: "An accessor cannot have type parameters.", ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier.", ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier.", ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference: "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference.", ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.", DeclareAccessor: (t3) => {
              let { kind: r } = t3;
              return `'declare' is not allowed in ${r}ters.`;
            }, DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.", DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.", DuplicateAccessibilityModifier: (t3) => {
              let { modifier: r } = t3;
              return "Accessibility modifier already seen.";
            }, DuplicateModifier: (t3) => {
              let { modifier: r } = t3;
              return `Duplicate modifier: '${r}'.`;
            }, EmptyHeritageClauseType: (t3) => {
              let { token: r } = t3;
              return `'${r}' list cannot be empty.`;
            }, EmptyTypeArguments: "Type argument list cannot be empty.", EmptyTypeParameters: "Type parameter list cannot be empty.", ExpectedAmbientAfterExportDeclare: "'export declare' must be followed by an ambient declaration.", ImportAliasHasImportType: "An import alias can not use 'import type'.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` modifier", IncompatibleModifiers: (t3) => {
              let { modifiers: r } = t3;
              return `'${r[0]}' modifier cannot be used with '${r[1]}' modifier.`;
            }, IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier.", IndexSignatureHasAccessibility: (t3) => {
              let { modifier: r } = t3;
              return `Index signatures cannot have an accessibility modifier ('${r}').`;
            }, IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier.", IndexSignatureHasOverride: "'override' modifier cannot appear on an index signature.", IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier.", InitializerNotAllowedInAmbientContext: "Initializers are not allowed in ambient contexts.", InvalidModifierOnTypeMember: (t3) => {
              let { modifier: r } = t3;
              return `'${r}' modifier cannot appear on a type member.`;
            }, InvalidModifierOnTypeParameter: (t3) => {
              let { modifier: r } = t3;
              return `'${r}' modifier cannot appear on a type parameter.`;
            }, InvalidModifierOnTypeParameterPositions: (t3) => {
              let { modifier: r } = t3;
              return `'${r}' modifier can only appear on a type parameter of a class, interface or type alias.`;
            }, InvalidModifiersOrder: (t3) => {
              let { orderedModifiers: r } = t3;
              return `'${r[0]}' modifier must precede '${r[1]}' modifier.`;
            }, InvalidPropertyAccessAfterInstantiationExpression: "Invalid property access after an instantiation expression. You can either wrap the instantiation expression in parentheses, or delete the type arguments.", InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.", MissingInterfaceName: "'interface' declarations must be followed by an identifier.", MixedLabeledAndUnlabeledElements: "Tuple members must all have names or all not have names.", NonAbstractClassHasAbstractMethod: "Abstract methods can only appear within an abstract class.", NonClassMethodPropertyHasAbstractModifer: "'abstract' modifier can only appear on a class, method, or property declaration.", OptionalTypeBeforeRequired: "A required element cannot follow an optional element.", OverrideNotInSubClass: "This member cannot have an 'override' modifier because its containing class does not extend another class.", PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.", PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.", PrivateElementHasAccessibility: (t3) => {
              let { modifier: r } = t3;
              return `Private elements cannot have an accessibility modifier ('${r}').`;
            }, ReadonlyForMethodSignature: "'readonly' modifier can only appear on a property declaration or index signature.", ReservedArrowTypeParam: "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`.", ReservedTypeAssertion: "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead.", SetAccesorCannotHaveOptionalParameter: "A 'set' accessor cannot have an optional parameter.", SetAccesorCannotHaveRestParameter: "A 'set' accessor cannot have rest parameter.", SetAccesorCannotHaveReturnType: "A 'set' accessor cannot have a return type annotation.", SingleTypeParameterWithoutTrailingComma: (t3) => {
              let { typeParameterName: r } = t3;
              return `Single type parameter ${r} should have a trailing comma. Example usage: <${r},>.`;
            }, StaticBlockCannotHaveModifier: "Static class blocks cannot have any modifier.", TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeImportCannotSpecifyDefaultAndNamed: "A type-only import can specify a default import or named bindings, but not both.", TypeModifierIsUsedInTypeExports: "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement.", TypeModifierIsUsedInTypeImports: "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement.", UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.", UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.", UnexpectedTypeAnnotation: "Did not expect a type annotation here.", UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.", UnsupportedImportTypeArgument: "Argument in a type import must be a string literal.", UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.", UnsupportedSignatureParameterKind: (t3) => {
              let { type: r } = t3;
              return `Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ${r}.`;
            } });
            function ql(t3) {
              switch (t3) {
                case "any":
                  return "TSAnyKeyword";
                case "boolean":
                  return "TSBooleanKeyword";
                case "bigint":
                  return "TSBigIntKeyword";
                case "never":
                  return "TSNeverKeyword";
                case "number":
                  return "TSNumberKeyword";
                case "object":
                  return "TSObjectKeyword";
                case "string":
                  return "TSStringKeyword";
                case "symbol":
                  return "TSSymbolKeyword";
                case "undefined":
                  return "TSUndefinedKeyword";
                case "unknown":
                  return "TSUnknownKeyword";
                default:
                  return;
              }
            }
            function $r(t3) {
              return t3 === "private" || t3 === "public" || t3 === "protected";
            }
            function Ul(t3) {
              return t3 === "in" || t3 === "out";
            }
            var Hl = (t3) => class extends t3 {
              getScopeHandler() {
                return _l;
              }
              tsIsIdentifier() {
                return $(this.state.type);
              }
              tsTokenCanFollowModifier() {
                return (this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(136) || this.isLiteralPropertyName()) && !this.hasPrecedingLineBreak();
              }
              tsNextTokenCanFollowModifier() {
                return this.next(), this.tsTokenCanFollowModifier();
              }
              tsParseModifier(e, s) {
                if (!$(this.state.type) && this.state.type !== 58)
                  return;
                let i = this.state.value;
                if (e.indexOf(i) !== -1) {
                  if (s && this.tsIsStartOfStaticBlocks())
                    return;
                  if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this)))
                    return i;
                }
              }
              tsParseModifiers(e) {
                let { modified: s, allowedModifiers: i, disallowedModifiers: a, stopOnStartOfClassStaticBlock: n, errorTemplate: o = w.InvalidModifierOnTypeMember } = e, c = (m, x, P, b) => {
                  x === P && s[b] && this.raise(w.InvalidModifiersOrder, { at: m, orderedModifiers: [P, b] });
                }, p = (m, x, P, b) => {
                  (s[P] && x === b || s[b] && x === P) && this.raise(w.IncompatibleModifiers, { at: m, modifiers: [P, b] });
                };
                for (; ; ) {
                  let { startLoc: m } = this.state, x = this.tsParseModifier(i.concat(a != null ? a : []), n);
                  if (!x)
                    break;
                  $r(x) ? s.accessibility ? this.raise(w.DuplicateAccessibilityModifier, { at: m, modifier: x }) : (c(m, x, x, "override"), c(m, x, x, "static"), c(m, x, x, "readonly"), s.accessibility = x) : Ul(x) ? (s[x] && this.raise(w.DuplicateModifier, { at: m, modifier: x }), s[x] = true, c(m, x, "in", "out")) : (Object.hasOwnProperty.call(s, x) ? this.raise(w.DuplicateModifier, { at: m, modifier: x }) : (c(m, x, "static", "readonly"), c(m, x, "static", "override"), c(m, x, "override", "readonly"), c(m, x, "abstract", "override"), p(m, x, "declare", "override"), p(m, x, "static", "abstract")), s[x] = true), a != null && a.includes(x) && this.raise(o, { at: m, modifier: x });
                }
              }
              tsIsListTerminator(e) {
                switch (e) {
                  case "EnumMembers":
                  case "TypeMembers":
                    return this.match(8);
                  case "HeritageClauseElement":
                    return this.match(5);
                  case "TupleElementTypes":
                    return this.match(3);
                  case "TypeParametersOrArguments":
                    return this.match(48);
                }
                throw new Error("Unreachable");
              }
              tsParseList(e, s) {
                let i = [];
                for (; !this.tsIsListTerminator(e); )
                  i.push(s());
                return i;
              }
              tsParseDelimitedList(e, s, i) {
                return jl(this.tsParseDelimitedListWorker(e, s, true, i));
              }
              tsParseDelimitedListWorker(e, s, i, a) {
                let n = [], o = -1;
                for (; !this.tsIsListTerminator(e); ) {
                  o = -1;
                  let c = s();
                  if (c == null)
                    return;
                  if (n.push(c), this.eat(12)) {
                    o = this.state.lastTokStart;
                    continue;
                  }
                  if (this.tsIsListTerminator(e))
                    break;
                  i && this.expect(12);
                  return;
                }
                return a && (a.value = o), n;
              }
              tsParseBracketedList(e, s, i, a, n) {
                a || (i ? this.expect(0) : this.expect(47));
                let o = this.tsParseDelimitedList(e, s, n);
                return i ? this.expect(3) : this.expect(48), o;
              }
              tsParseImportType() {
                let e = this.startNode();
                return this.expect(83), this.expect(10), this.match(131) || this.raise(w.UnsupportedImportTypeArgument, { at: this.state.startLoc }), e.argument = super.parseExprAtom(), this.expect(11), this.eat(16) && (e.qualifier = this.tsParseEntityName()), this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSImportType");
              }
              tsParseEntityName() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, s = this.parseIdentifier(e);
                for (; this.eat(16); ) {
                  let i = this.startNodeAtNode(s);
                  i.left = s, i.right = this.parseIdentifier(e), s = this.finishNode(i, "TSQualifiedName");
                }
                return s;
              }
              tsParseTypeReference() {
                let e = this.startNode();
                return e.typeName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSTypeReference");
              }
              tsParseThisTypePredicate(e) {
                this.next();
                let s = this.startNodeAtNode(e);
                return s.parameterName = e, s.typeAnnotation = this.tsParseTypeAnnotation(false), s.asserts = false, this.finishNode(s, "TSTypePredicate");
              }
              tsParseThisTypeNode() {
                let e = this.startNode();
                return this.next(), this.finishNode(e, "TSThisType");
              }
              tsParseTypeQuery() {
                let e = this.startNode();
                return this.expect(87), this.match(83) ? e.exprName = this.tsParseImportType() : e.exprName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSTypeQuery");
              }
              tsParseInOutModifiers(e) {
                this.tsParseModifiers({ modified: e, allowedModifiers: ["in", "out"], disallowedModifiers: ["public", "private", "protected", "readonly", "declare", "abstract", "override"], errorTemplate: w.InvalidModifierOnTypeParameter });
              }
              tsParseNoneModifiers(e) {
                this.tsParseModifiers({ modified: e, allowedModifiers: [], disallowedModifiers: ["in", "out"], errorTemplate: w.InvalidModifierOnTypeParameterPositions });
              }
              tsParseTypeParameter() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.tsParseNoneModifiers.bind(this), s = this.startNode();
                return e(s), s.name = this.tsParseTypeParameterName(), s.constraint = this.tsEatThenParseType(81), s.default = this.tsEatThenParseType(29), this.finishNode(s, "TSTypeParameter");
              }
              tsTryParseTypeParameters(e) {
                if (this.match(47))
                  return this.tsParseTypeParameters(e);
              }
              tsParseTypeParameters(e) {
                let s = this.startNode();
                this.match(47) || this.match(140) ? this.next() : this.unexpected();
                let i = { value: -1 };
                return s.params = this.tsParseBracketedList("TypeParametersOrArguments", this.tsParseTypeParameter.bind(this, e), false, true, i), s.params.length === 0 && this.raise(w.EmptyTypeParameters, { at: s }), i.value !== -1 && this.addExtra(s, "trailingComma", i.value), this.finishNode(s, "TSTypeParameterDeclaration");
              }
              tsFillSignature(e, s) {
                let i = e === 19, a = "parameters", n = "typeAnnotation";
                s.typeParameters = this.tsTryParseTypeParameters(), this.expect(10), s[a] = this.tsParseBindingListForSignature(), i ? s[n] = this.tsParseTypeOrTypePredicateAnnotation(e) : this.match(e) && (s[n] = this.tsParseTypeOrTypePredicateAnnotation(e));
              }
              tsParseBindingListForSignature() {
                return super.parseBindingList(11, 41).map((e) => (e.type !== "Identifier" && e.type !== "RestElement" && e.type !== "ObjectPattern" && e.type !== "ArrayPattern" && this.raise(w.UnsupportedSignatureParameterKind, { at: e, type: e.type }), e));
              }
              tsParseTypeMemberSemicolon() {
                !this.eat(12) && !this.isLineTerminator() && this.expect(13);
              }
              tsParseSignatureMember(e, s) {
                return this.tsFillSignature(14, s), this.tsParseTypeMemberSemicolon(), this.finishNode(s, e);
              }
              tsIsUnambiguouslyIndexSignature() {
                return this.next(), $(this.state.type) ? (this.next(), this.match(14)) : false;
              }
              tsTryParseIndexSignature(e) {
                if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this))))
                  return;
                this.expect(0);
                let s = this.parseIdentifier();
                s.typeAnnotation = this.tsParseTypeAnnotation(), this.resetEndLocation(s), this.expect(3), e.parameters = [s];
                let i = this.tsTryParseTypeAnnotation();
                return i && (e.typeAnnotation = i), this.tsParseTypeMemberSemicolon(), this.finishNode(e, "TSIndexSignature");
              }
              tsParsePropertyOrMethodSignature(e, s) {
                this.eat(17) && (e.optional = true);
                let i = e;
                if (this.match(10) || this.match(47)) {
                  s && this.raise(w.ReadonlyForMethodSignature, { at: e });
                  let a = i;
                  a.kind && this.match(47) && this.raise(w.AccesorCannotHaveTypeParameters, { at: this.state.curPosition() }), this.tsFillSignature(14, a), this.tsParseTypeMemberSemicolon();
                  let n = "parameters", o = "typeAnnotation";
                  if (a.kind === "get")
                    a[n].length > 0 && (this.raise(h.BadGetterArity, { at: this.state.curPosition() }), this.isThisParam(a[n][0]) && this.raise(w.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }));
                  else if (a.kind === "set") {
                    if (a[n].length !== 1)
                      this.raise(h.BadSetterArity, { at: this.state.curPosition() });
                    else {
                      let c = a[n][0];
                      this.isThisParam(c) && this.raise(w.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }), c.type === "Identifier" && c.optional && this.raise(w.SetAccesorCannotHaveOptionalParameter, { at: this.state.curPosition() }), c.type === "RestElement" && this.raise(w.SetAccesorCannotHaveRestParameter, { at: this.state.curPosition() });
                    }
                    a[o] && this.raise(w.SetAccesorCannotHaveReturnType, { at: a[o] });
                  } else
                    a.kind = "method";
                  return this.finishNode(a, "TSMethodSignature");
                } else {
                  let a = i;
                  s && (a.readonly = true);
                  let n = this.tsTryParseTypeAnnotation();
                  return n && (a.typeAnnotation = n), this.tsParseTypeMemberSemicolon(), this.finishNode(a, "TSPropertySignature");
                }
              }
              tsParseTypeMember() {
                let e = this.startNode();
                if (this.match(10) || this.match(47))
                  return this.tsParseSignatureMember("TSCallSignatureDeclaration", e);
                if (this.match(77)) {
                  let i = this.startNode();
                  return this.next(), this.match(10) || this.match(47) ? this.tsParseSignatureMember("TSConstructSignatureDeclaration", e) : (e.key = this.createIdentifier(i, "new"), this.tsParsePropertyOrMethodSignature(e, false));
                }
                this.tsParseModifiers({ modified: e, allowedModifiers: ["readonly"], disallowedModifiers: ["declare", "abstract", "private", "protected", "public", "static", "override"] });
                let s = this.tsTryParseIndexSignature(e);
                return s || (super.parsePropertyName(e), !e.computed && e.key.type === "Identifier" && (e.key.name === "get" || e.key.name === "set") && this.tsTokenCanFollowModifier() && (e.kind = e.key.name, super.parsePropertyName(e)), this.tsParsePropertyOrMethodSignature(e, !!e.readonly));
              }
              tsParseTypeLiteral() {
                let e = this.startNode();
                return e.members = this.tsParseObjectTypeMembers(), this.finishNode(e, "TSTypeLiteral");
              }
              tsParseObjectTypeMembers() {
                this.expect(5);
                let e = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
                return this.expect(8), e;
              }
              tsIsStartOfMappedType() {
                return this.next(), this.eat(53) ? this.isContextual(120) : (this.isContextual(120) && this.next(), !this.match(0) || (this.next(), !this.tsIsIdentifier()) ? false : (this.next(), this.match(58)));
              }
              tsParseMappedTypeParameter() {
                let e = this.startNode();
                return e.name = this.tsParseTypeParameterName(), e.constraint = this.tsExpectThenParseType(58), this.finishNode(e, "TSTypeParameter");
              }
              tsParseMappedType() {
                let e = this.startNode();
                return this.expect(5), this.match(53) ? (e.readonly = this.state.value, this.next(), this.expectContextual(120)) : this.eatContextual(120) && (e.readonly = true), this.expect(0), e.typeParameter = this.tsParseMappedTypeParameter(), e.nameType = this.eatContextual(93) ? this.tsParseType() : null, this.expect(3), this.match(53) ? (e.optional = this.state.value, this.next(), this.expect(17)) : this.eat(17) && (e.optional = true), e.typeAnnotation = this.tsTryParseType(), this.semicolon(), this.expect(8), this.finishNode(e, "TSMappedType");
              }
              tsParseTupleType() {
                let e = this.startNode();
                e.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), true, false);
                let s = false, i = null;
                return e.elementTypes.forEach((a) => {
                  var n;
                  let { type: o } = a;
                  s && o !== "TSRestType" && o !== "TSOptionalType" && !(o === "TSNamedTupleMember" && a.optional) && this.raise(w.OptionalTypeBeforeRequired, { at: a }), s || (s = o === "TSNamedTupleMember" && a.optional || o === "TSOptionalType");
                  let c = o;
                  o === "TSRestType" && (a = a.typeAnnotation, c = a.type);
                  let p = c === "TSNamedTupleMember";
                  (n = i) != null || (i = p), i !== p && this.raise(w.MixedLabeledAndUnlabeledElements, { at: a });
                }), this.finishNode(e, "TSTupleType");
              }
              tsParseTupleElementType() {
                let { startLoc: e } = this.state, s = this.eat(21), i = this.tsParseType(), a = this.eat(17);
                if (this.eat(14)) {
                  let o = this.startNodeAtNode(i);
                  o.optional = a, i.type === "TSTypeReference" && !i.typeParameters && i.typeName.type === "Identifier" ? o.label = i.typeName : (this.raise(w.InvalidTupleMemberLabel, { at: i }), o.label = i), o.elementType = this.tsParseType(), i = this.finishNode(o, "TSNamedTupleMember");
                } else if (a) {
                  let o = this.startNodeAtNode(i);
                  o.typeAnnotation = i, i = this.finishNode(o, "TSOptionalType");
                }
                if (s) {
                  let o = this.startNodeAt(e);
                  o.typeAnnotation = i, i = this.finishNode(o, "TSRestType");
                }
                return i;
              }
              tsParseParenthesizedType() {
                let e = this.startNode();
                return this.expect(10), e.typeAnnotation = this.tsParseType(), this.expect(11), this.finishNode(e, "TSParenthesizedType");
              }
              tsParseFunctionOrConstructorType(e, s) {
                let i = this.startNode();
                return e === "TSConstructorType" && (i.abstract = !!s, s && this.next(), this.next()), this.tsInAllowConditionalTypesContext(() => this.tsFillSignature(19, i)), this.finishNode(i, e);
              }
              tsParseLiteralTypeNode() {
                let e = this.startNode();
                return e.literal = (() => {
                  switch (this.state.type) {
                    case 132:
                    case 133:
                    case 131:
                    case 85:
                    case 86:
                      return super.parseExprAtom();
                    default:
                      throw this.unexpected();
                  }
                })(), this.finishNode(e, "TSLiteralType");
              }
              tsParseTemplateLiteralType() {
                let e = this.startNode();
                return e.literal = super.parseTemplate(false), this.finishNode(e, "TSLiteralType");
              }
              parseTemplateSubstitution() {
                return this.state.inType ? this.tsParseType() : super.parseTemplateSubstitution();
              }
              tsParseThisTypeOrThisTypePredicate() {
                let e = this.tsParseThisTypeNode();
                return this.isContextual(114) && !this.hasPrecedingLineBreak() ? this.tsParseThisTypePredicate(e) : e;
              }
              tsParseNonArrayType() {
                switch (this.state.type) {
                  case 131:
                  case 132:
                  case 133:
                  case 85:
                  case 86:
                    return this.tsParseLiteralTypeNode();
                  case 53:
                    if (this.state.value === "-") {
                      let e = this.startNode(), s = this.lookahead();
                      if (s.type !== 132 && s.type !== 133)
                        throw this.unexpected();
                      return e.literal = this.parseMaybeUnary(), this.finishNode(e, "TSLiteralType");
                    }
                    break;
                  case 78:
                    return this.tsParseThisTypeOrThisTypePredicate();
                  case 87:
                    return this.tsParseTypeQuery();
                  case 83:
                    return this.tsParseImportType();
                  case 5:
                    return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
                  case 0:
                    return this.tsParseTupleType();
                  case 10:
                    return this.tsParseParenthesizedType();
                  case 25:
                  case 24:
                    return this.tsParseTemplateLiteralType();
                  default: {
                    let { type: e } = this.state;
                    if ($(e) || e === 88 || e === 84) {
                      let s = e === 88 ? "TSVoidKeyword" : e === 84 ? "TSNullKeyword" : ql(this.state.value);
                      if (s !== void 0 && this.lookaheadCharCode() !== 46) {
                        let i = this.startNode();
                        return this.next(), this.finishNode(i, s);
                      }
                      return this.tsParseTypeReference();
                    }
                  }
                }
                throw this.unexpected();
              }
              tsParseArrayTypeOrHigher() {
                let e = this.tsParseNonArrayType();
                for (; !this.hasPrecedingLineBreak() && this.eat(0); )
                  if (this.match(3)) {
                    let s = this.startNodeAtNode(e);
                    s.elementType = e, this.expect(3), e = this.finishNode(s, "TSArrayType");
                  } else {
                    let s = this.startNodeAtNode(e);
                    s.objectType = e, s.indexType = this.tsParseType(), this.expect(3), e = this.finishNode(s, "TSIndexedAccessType");
                  }
                return e;
              }
              tsParseTypeOperator() {
                let e = this.startNode(), s = this.state.value;
                return this.next(), e.operator = s, e.typeAnnotation = this.tsParseTypeOperatorOrHigher(), s === "readonly" && this.tsCheckTypeAnnotationForReadOnly(e), this.finishNode(e, "TSTypeOperator");
              }
              tsCheckTypeAnnotationForReadOnly(e) {
                switch (e.typeAnnotation.type) {
                  case "TSTupleType":
                  case "TSArrayType":
                    return;
                  default:
                    this.raise(w.UnexpectedReadonly, { at: e });
                }
              }
              tsParseInferType() {
                let e = this.startNode();
                this.expectContextual(113);
                let s = this.startNode();
                return s.name = this.tsParseTypeParameterName(), s.constraint = this.tsTryParse(() => this.tsParseConstraintForInferType()), e.typeParameter = this.finishNode(s, "TSTypeParameter"), this.finishNode(e, "TSInferType");
              }
              tsParseConstraintForInferType() {
                if (this.eat(81)) {
                  let e = this.tsInDisallowConditionalTypesContext(() => this.tsParseType());
                  if (this.state.inDisallowConditionalTypesContext || !this.match(17))
                    return e;
                }
              }
              tsParseTypeOperatorOrHigher() {
                return Lo(this.state.type) && !this.state.containsEsc ? this.tsParseTypeOperator() : this.isContextual(113) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(() => this.tsParseArrayTypeOrHigher());
              }
              tsParseUnionOrIntersectionType(e, s, i) {
                let a = this.startNode(), n = this.eat(i), o = [];
                do
                  o.push(s());
                while (this.eat(i));
                return o.length === 1 && !n ? o[0] : (a.types = o, this.finishNode(a, e));
              }
              tsParseIntersectionTypeOrHigher() {
                return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
              }
              tsParseUnionTypeOrHigher() {
                return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
              }
              tsIsStartOfFunctionType() {
                return this.match(47) ? true : this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
              }
              tsSkipParameterStart() {
                if ($(this.state.type) || this.match(78))
                  return this.next(), true;
                if (this.match(5)) {
                  let { errors: e } = this.state, s = e.length;
                  try {
                    return this.parseObjectLike(8, true), e.length === s;
                  } catch {
                    return false;
                  }
                }
                if (this.match(0)) {
                  this.next();
                  let { errors: e } = this.state, s = e.length;
                  try {
                    return super.parseBindingList(3, 93, true), e.length === s;
                  } catch {
                    return false;
                  }
                }
                return false;
              }
              tsIsUnambiguouslyStartOfFunctionType() {
                return this.next(), !!(this.match(11) || this.match(21) || this.tsSkipParameterStart() && (this.match(14) || this.match(12) || this.match(17) || this.match(29) || this.match(11) && (this.next(), this.match(19))));
              }
              tsParseTypeOrTypePredicateAnnotation(e) {
                return this.tsInType(() => {
                  let s = this.startNode();
                  this.expect(e);
                  let i = this.startNode(), a = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
                  if (a && this.match(78)) {
                    let c = this.tsParseThisTypeOrThisTypePredicate();
                    return c.type === "TSThisType" ? (i.parameterName = c, i.asserts = true, i.typeAnnotation = null, c = this.finishNode(i, "TSTypePredicate")) : (this.resetStartLocationFromNode(c, i), c.asserts = true), s.typeAnnotation = c, this.finishNode(s, "TSTypeAnnotation");
                  }
                  let n = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
                  if (!n)
                    return a ? (i.parameterName = this.parseIdentifier(), i.asserts = a, i.typeAnnotation = null, s.typeAnnotation = this.finishNode(i, "TSTypePredicate"), this.finishNode(s, "TSTypeAnnotation")) : this.tsParseTypeAnnotation(false, s);
                  let o = this.tsParseTypeAnnotation(false);
                  return i.parameterName = n, i.typeAnnotation = o, i.asserts = a, s.typeAnnotation = this.finishNode(i, "TSTypePredicate"), this.finishNode(s, "TSTypeAnnotation");
                });
              }
              tsTryParseTypeOrTypePredicateAnnotation() {
                return this.match(14) ? this.tsParseTypeOrTypePredicateAnnotation(14) : void 0;
              }
              tsTryParseTypeAnnotation() {
                return this.match(14) ? this.tsParseTypeAnnotation() : void 0;
              }
              tsTryParseType() {
                return this.tsEatThenParseType(14);
              }
              tsParseTypePredicatePrefix() {
                let e = this.parseIdentifier();
                if (this.isContextual(114) && !this.hasPrecedingLineBreak())
                  return this.next(), e;
              }
              tsParseTypePredicateAsserts() {
                if (this.state.type !== 107)
                  return false;
                let e = this.state.containsEsc;
                return this.next(), !$(this.state.type) && !this.match(78) ? false : (e && this.raise(h.InvalidEscapedReservedWord, { at: this.state.lastTokStartLoc, reservedWord: "asserts" }), true);
              }
              tsParseTypeAnnotation() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.startNode();
                return this.tsInType(() => {
                  e && this.expect(14), s.typeAnnotation = this.tsParseType();
                }), this.finishNode(s, "TSTypeAnnotation");
              }
              tsParseType() {
                Hr(this.state.inType);
                let e = this.tsParseNonConditionalType();
                if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81))
                  return e;
                let s = this.startNodeAtNode(e);
                return s.checkType = e, s.extendsType = this.tsInDisallowConditionalTypesContext(() => this.tsParseNonConditionalType()), this.expect(17), s.trueType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.expect(14), s.falseType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.finishNode(s, "TSConditionalType");
              }
              isAbstractConstructorSignature() {
                return this.isContextual(122) && this.lookahead().type === 77;
              }
              tsParseNonConditionalType() {
                return this.tsIsStartOfFunctionType() ? this.tsParseFunctionOrConstructorType("TSFunctionType") : this.match(77) ? this.tsParseFunctionOrConstructorType("TSConstructorType") : this.isAbstractConstructorSignature() ? this.tsParseFunctionOrConstructorType("TSConstructorType", true) : this.tsParseUnionTypeOrHigher();
              }
              tsParseTypeAssertion() {
                this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(w.ReservedTypeAssertion, { at: this.state.startLoc });
                let e = this.startNode();
                return e.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? this.tsParseTypeReference() : this.tsParseType())), this.expect(48), e.expression = this.parseMaybeUnary(), this.finishNode(e, "TSTypeAssertion");
              }
              tsParseHeritageClause(e) {
                let s = this.state.startLoc, i = this.tsParseDelimitedList("HeritageClauseElement", () => {
                  let a = this.startNode();
                  return a.expression = this.tsParseEntityName(), this.match(47) && (a.typeParameters = this.tsParseTypeArguments()), this.finishNode(a, "TSExpressionWithTypeArguments");
                });
                return i.length || this.raise(w.EmptyHeritageClauseType, { at: s, token: e }), i;
              }
              tsParseInterfaceDeclaration(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.hasFollowingLineBreak())
                  return null;
                this.expectContextual(127), s.declare && (e.declare = true), $(this.state.type) ? (e.id = this.parseIdentifier(), this.checkIdentifier(e.id, Ko)) : (e.id = null, this.raise(w.MissingInterfaceName, { at: this.state.startLoc })), e.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this)), this.eat(81) && (e.extends = this.tsParseHeritageClause("extends"));
                let i = this.startNode();
                return i.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this)), e.body = this.finishNode(i, "TSInterfaceBody"), this.finishNode(e, "TSInterfaceDeclaration");
              }
              tsParseTypeAliasDeclaration(e) {
                return e.id = this.parseIdentifier(), this.checkIdentifier(e.id, Wo), e.typeAnnotation = this.tsInType(() => {
                  if (e.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this)), this.expect(29), this.isContextual(112) && this.lookahead().type !== 16) {
                    let s = this.startNode();
                    return this.next(), this.finishNode(s, "TSIntrinsicKeyword");
                  }
                  return this.tsParseType();
                }), this.semicolon(), this.finishNode(e, "TSTypeAliasDeclaration");
              }
              tsInNoContext(e) {
                let s = this.state.context;
                this.state.context = [s[0]];
                try {
                  return e();
                } finally {
                  this.state.context = s;
                }
              }
              tsInType(e) {
                let s = this.state.inType;
                this.state.inType = true;
                try {
                  return e();
                } finally {
                  this.state.inType = s;
                }
              }
              tsInDisallowConditionalTypesContext(e) {
                let s = this.state.inDisallowConditionalTypesContext;
                this.state.inDisallowConditionalTypesContext = true;
                try {
                  return e();
                } finally {
                  this.state.inDisallowConditionalTypesContext = s;
                }
              }
              tsInAllowConditionalTypesContext(e) {
                let s = this.state.inDisallowConditionalTypesContext;
                this.state.inDisallowConditionalTypesContext = false;
                try {
                  return e();
                } finally {
                  this.state.inDisallowConditionalTypesContext = s;
                }
              }
              tsEatThenParseType(e) {
                return this.match(e) ? this.tsNextThenParseType() : void 0;
              }
              tsExpectThenParseType(e) {
                return this.tsDoThenParseType(() => this.expect(e));
              }
              tsNextThenParseType() {
                return this.tsDoThenParseType(() => this.next());
              }
              tsDoThenParseType(e) {
                return this.tsInType(() => (e(), this.tsParseType()));
              }
              tsParseEnumMember() {
                let e = this.startNode();
                return e.id = this.match(131) ? super.parseStringLiteral(this.state.value) : this.parseIdentifier(true), this.eat(29) && (e.initializer = super.parseMaybeAssignAllowIn()), this.finishNode(e, "TSEnumMember");
              }
              tsParseEnumDeclaration(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return s.const && (e.const = true), s.declare && (e.declare = true), this.expectContextual(124), e.id = this.parseIdentifier(), this.checkIdentifier(e.id, e.const ? Jo : br), this.expect(5), e.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this)), this.expect(8), this.finishNode(e, "TSEnumDeclaration");
              }
              tsParseModuleBlock() {
                let e = this.startNode();
                return this.scope.enter(_e), this.expect(5), super.parseBlockOrModuleBlockBody(e.body = [], void 0, true, 8), this.scope.exit(), this.finishNode(e, "TSModuleBlock");
              }
              tsParseModuleOrNamespaceDeclaration(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (e.id = this.parseIdentifier(), s || this.checkIdentifier(e.id, Xo), this.eat(16)) {
                  let i = this.startNode();
                  this.tsParseModuleOrNamespaceDeclaration(i, true), e.body = i;
                } else
                  this.scope.enter(je), this.prodParam.enter(qe), e.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit();
                return this.finishNode(e, "TSModuleDeclaration");
              }
              tsParseAmbientExternalModuleDeclaration(e) {
                return this.isContextual(110) ? (e.global = true, e.id = this.parseIdentifier()) : this.match(131) ? e.id = super.parseStringLiteral(this.state.value) : this.unexpected(), this.match(5) ? (this.scope.enter(je), this.prodParam.enter(qe), e.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit()) : this.semicolon(), this.finishNode(e, "TSModuleDeclaration");
              }
              tsParseImportEqualsDeclaration(e, s) {
                e.isExport = s || false, e.id = this.parseIdentifier(), this.checkIdentifier(e.id, Je), this.expect(29);
                let i = this.tsParseModuleReference();
                return e.importKind === "type" && i.type !== "TSExternalModuleReference" && this.raise(w.ImportAliasHasImportType, { at: i }), e.moduleReference = i, this.semicolon(), this.finishNode(e, "TSImportEqualsDeclaration");
              }
              tsIsExternalModuleReference() {
                return this.isContextual(117) && this.lookaheadCharCode() === 40;
              }
              tsParseModuleReference() {
                return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(false);
              }
              tsParseExternalModuleReference() {
                let e = this.startNode();
                if (this.expectContextual(117), this.expect(10), !this.match(131))
                  throw this.unexpected();
                return e.expression = super.parseExprAtom(), this.expect(11), this.finishNode(e, "TSExternalModuleReference");
              }
              tsLookAhead(e) {
                let s = this.state.clone(), i = e();
                return this.state = s, i;
              }
              tsTryParseAndCatch(e) {
                let s = this.tryParse((i) => e() || i());
                if (!(s.aborted || !s.node))
                  return s.error && (this.state = s.failState), s.node;
              }
              tsTryParse(e) {
                let s = this.state.clone(), i = e();
                if (i !== void 0 && i !== false)
                  return i;
                this.state = s;
              }
              tsTryParseDeclare(e) {
                if (this.isLineTerminator())
                  return;
                let s = this.state.type, i;
                return this.isContextual(99) && (s = 74, i = "let"), this.tsInAmbientContext(() => {
                  if (s === 68)
                    return e.declare = true, super.parseFunctionStatement(e, false, true);
                  if (s === 80)
                    return e.declare = true, this.parseClass(e, true, false);
                  if (s === 124)
                    return this.tsParseEnumDeclaration(e, { declare: true });
                  if (s === 110)
                    return this.tsParseAmbientExternalModuleDeclaration(e);
                  if (s === 75 || s === 74)
                    return !this.match(75) || !this.isLookaheadContextual("enum") ? (e.declare = true, this.parseVarStatement(e, i || this.state.value, true)) : (this.expect(75), this.tsParseEnumDeclaration(e, { const: true, declare: true }));
                  if (s === 127) {
                    let a = this.tsParseInterfaceDeclaration(e, { declare: true });
                    if (a)
                      return a;
                  }
                  if ($(s))
                    return this.tsParseDeclaration(e, this.state.value, true, null);
                });
              }
              tsTryParseExportDeclaration() {
                return this.tsParseDeclaration(this.startNode(), this.state.value, true, null);
              }
              tsParseExpressionStatement(e, s, i) {
                switch (s.name) {
                  case "declare": {
                    let a = this.tsTryParseDeclare(e);
                    if (a)
                      return a.declare = true, a;
                    break;
                  }
                  case "global":
                    if (this.match(5)) {
                      this.scope.enter(je), this.prodParam.enter(qe);
                      let a = e;
                      return a.global = true, a.id = s, a.body = this.tsParseModuleBlock(), this.scope.exit(), this.prodParam.exit(), this.finishNode(a, "TSModuleDeclaration");
                    }
                    break;
                  default:
                    return this.tsParseDeclaration(e, s.name, false, i);
                }
              }
              tsParseDeclaration(e, s, i, a) {
                switch (s) {
                  case "abstract":
                    if (this.tsCheckLineTerminator(i) && (this.match(80) || $(this.state.type)))
                      return this.tsParseAbstractDeclaration(e, a);
                    break;
                  case "module":
                    if (this.tsCheckLineTerminator(i)) {
                      if (this.match(131))
                        return this.tsParseAmbientExternalModuleDeclaration(e);
                      if ($(this.state.type))
                        return this.tsParseModuleOrNamespaceDeclaration(e);
                    }
                    break;
                  case "namespace":
                    if (this.tsCheckLineTerminator(i) && $(this.state.type))
                      return this.tsParseModuleOrNamespaceDeclaration(e);
                    break;
                  case "type":
                    if (this.tsCheckLineTerminator(i) && $(this.state.type))
                      return this.tsParseTypeAliasDeclaration(e);
                    break;
                }
              }
              tsCheckLineTerminator(e) {
                return e ? this.hasFollowingLineBreak() ? false : (this.next(), true) : !this.isLineTerminator();
              }
              tsTryParseGenericAsyncArrowFunction(e) {
                if (!this.match(47))
                  return;
                let s = this.state.maybeInArrowParameters;
                this.state.maybeInArrowParameters = true;
                let i = this.tsTryParseAndCatch(() => {
                  let a = this.startNodeAt(e);
                  return a.typeParameters = this.tsParseTypeParameters(), super.parseFunctionParams(a), a.returnType = this.tsTryParseTypeOrTypePredicateAnnotation(), this.expect(19), a;
                });
                if (this.state.maybeInArrowParameters = s, !!i)
                  return super.parseArrowExpression(i, null, true);
              }
              tsParseTypeArgumentsInExpression() {
                if (this.reScan_lt() === 47)
                  return this.tsParseTypeArguments();
              }
              tsParseTypeArguments() {
                let e = this.startNode();
                return e.params = this.tsInType(() => this.tsInNoContext(() => (this.expect(47), this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this))))), e.params.length === 0 && this.raise(w.EmptyTypeArguments, { at: e }), this.expect(48), this.finishNode(e, "TSTypeParameterInstantiation");
              }
              tsIsDeclarationStart() {
                return Oo(this.state.type);
              }
              isExportDefaultSpecifier() {
                return this.tsIsDeclarationStart() ? false : super.isExportDefaultSpecifier();
              }
              parseAssignableListItem(e, s) {
                let i = this.state.startLoc, a, n = false, o = false;
                if (e !== void 0) {
                  let m = {};
                  this.tsParseModifiers({ modified: m, allowedModifiers: ["public", "private", "protected", "override", "readonly"] }), a = m.accessibility, o = m.override, n = m.readonly, e === false && (a || n || o) && this.raise(w.UnexpectedParameterModifier, { at: i });
                }
                let c = this.parseMaybeDefault();
                this.parseAssignableListItemTypes(c);
                let p = this.parseMaybeDefault(c.loc.start, c);
                if (a || n || o) {
                  let m = this.startNodeAt(i);
                  return s.length && (m.decorators = s), a && (m.accessibility = a), n && (m.readonly = n), o && (m.override = o), p.type !== "Identifier" && p.type !== "AssignmentPattern" && this.raise(w.UnsupportedParameterPropertyKind, { at: m }), m.parameter = p, this.finishNode(m, "TSParameterProperty");
                }
                return s.length && (c.decorators = s), p;
              }
              isSimpleParameter(e) {
                return e.type === "TSParameterProperty" && super.isSimpleParameter(e.parameter) || super.isSimpleParameter(e);
              }
              parseFunctionBodyAndFinish(e, s) {
                let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                this.match(14) && (e.returnType = this.tsParseTypeOrTypePredicateAnnotation(14));
                let a = s === "FunctionDeclaration" ? "TSDeclareFunction" : s === "ClassMethod" || s === "ClassPrivateMethod" ? "TSDeclareMethod" : void 0;
                return a && !this.match(5) && this.isLineTerminator() ? this.finishNode(e, a) : a === "TSDeclareFunction" && this.state.isAmbientContext && (this.raise(w.DeclareFunctionHasImplementation, { at: e }), e.declare) ? super.parseFunctionBodyAndFinish(e, a, i) : super.parseFunctionBodyAndFinish(e, s, i);
              }
              registerFunctionStatementId(e) {
                !e.body && e.id ? this.checkIdentifier(e.id, Sr) : super.registerFunctionStatementId(e);
              }
              tsCheckForInvalidTypeCasts(e) {
                e.forEach((s) => {
                  (s == null ? void 0 : s.type) === "TSTypeCastExpression" && this.raise(w.UnexpectedTypeAnnotation, { at: s.typeAnnotation });
                });
              }
              toReferencedList(e, s) {
                return this.tsCheckForInvalidTypeCasts(e), e;
              }
              parseArrayLike(e, s, i, a) {
                let n = super.parseArrayLike(e, s, i, a);
                return n.type === "ArrayExpression" && this.tsCheckForInvalidTypeCasts(n.elements), n;
              }
              parseSubscript(e, s, i, a) {
                if (!this.hasPrecedingLineBreak() && this.match(35)) {
                  this.state.canStartJSXElement = false, this.next();
                  let o = this.startNodeAt(s);
                  return o.expression = e, this.finishNode(o, "TSNonNullExpression");
                }
                let n = false;
                if (this.match(18) && this.lookaheadCharCode() === 60) {
                  if (i)
                    return a.stop = true, e;
                  a.optionalChainMember = n = true, this.next();
                }
                if (this.match(47) || this.match(51)) {
                  let o, c = this.tsTryParseAndCatch(() => {
                    if (!i && this.atPossibleAsyncArrow(e)) {
                      let P = this.tsTryParseGenericAsyncArrowFunction(s);
                      if (P)
                        return P;
                    }
                    let p = this.tsParseTypeArgumentsInExpression();
                    if (!p)
                      return;
                    if (n && !this.match(10)) {
                      o = this.state.curPosition();
                      return;
                    }
                    if (ot(this.state.type)) {
                      let P = super.parseTaggedTemplateExpression(e, s, a);
                      return P.typeParameters = p, P;
                    }
                    if (!i && this.eat(10)) {
                      let P = this.startNodeAt(s);
                      return P.callee = e, P.arguments = this.parseCallExpressionArguments(11, false), this.tsCheckForInvalidTypeCasts(P.arguments), P.typeParameters = p, a.optionalChainMember && (P.optional = n), this.finishCallExpression(P, a.optionalChainMember);
                    }
                    let m = this.state.type;
                    if (m === 48 || m === 52 || m !== 10 && Kt(m) && !this.hasPrecedingLineBreak())
                      return;
                    let x = this.startNodeAt(s);
                    return x.expression = e, x.typeParameters = p, this.finishNode(x, "TSInstantiationExpression");
                  });
                  if (o && this.unexpected(o, 10), c)
                    return c.type === "TSInstantiationExpression" && (this.match(16) || this.match(18) && this.lookaheadCharCode() !== 40) && this.raise(w.InvalidPropertyAccessAfterInstantiationExpression, { at: this.state.startLoc }), c;
                }
                return super.parseSubscript(e, s, i, a);
              }
              parseNewCallee(e) {
                var s;
                super.parseNewCallee(e);
                let { callee: i } = e;
                i.type === "TSInstantiationExpression" && !((s = i.extra) != null && s.parenthesized) && (e.typeParameters = i.typeParameters, e.callee = i.expression);
              }
              parseExprOp(e, s, i) {
                let a;
                if (nt(58) > i && !this.hasPrecedingLineBreak() && (this.isContextual(93) || (a = this.isContextual(118)))) {
                  let n = this.startNodeAt(s);
                  return n.expression = e, n.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? (a && this.raise(h.UnexpectedKeyword, { at: this.state.startLoc, keyword: "const" }), this.tsParseTypeReference()) : this.tsParseType())), this.finishNode(n, a ? "TSSatisfiesExpression" : "TSAsExpression"), this.reScan_lt_gt(), this.parseExprOp(n, s, i);
                }
                return super.parseExprOp(e, s, i);
              }
              checkReservedWord(e, s, i, a) {
                this.state.isAmbientContext || super.checkReservedWord(e, s, i, a);
              }
              checkImportReflection(e) {
                super.checkImportReflection(e), e.module && e.importKind !== "value" && this.raise(w.ImportReflectionHasImportType, { at: e.specifiers[0].loc.start });
              }
              checkDuplicateExports() {
              }
              parseImport(e) {
                if (e.importKind = "value", $(this.state.type) || this.match(55) || this.match(5)) {
                  let i = this.lookahead();
                  if (this.isContextual(128) && i.type !== 12 && i.type !== 97 && i.type !== 29 && (e.importKind = "type", this.next(), i = this.lookahead()), $(this.state.type) && i.type === 29)
                    return this.tsParseImportEqualsDeclaration(e);
                }
                let s = super.parseImport(e);
                return s.importKind === "type" && s.specifiers.length > 1 && s.specifiers[0].type === "ImportDefaultSpecifier" && this.raise(w.TypeImportCannotSpecifyDefaultAndNamed, { at: s }), s;
              }
              parseExport(e, s) {
                if (this.match(83))
                  return this.next(), this.isContextual(128) && this.lookaheadCharCode() !== 61 ? (e.importKind = "type", this.next()) : e.importKind = "value", this.tsParseImportEqualsDeclaration(e, true);
                if (this.eat(29)) {
                  let i = e;
                  return i.expression = super.parseExpression(), this.semicolon(), this.finishNode(i, "TSExportAssignment");
                } else if (this.eatContextual(93)) {
                  let i = e;
                  return this.expectContextual(126), i.id = this.parseIdentifier(), this.semicolon(), this.finishNode(i, "TSNamespaceExportDeclaration");
                } else
                  return this.isContextual(128) && this.lookahead().type === 5 ? (this.next(), e.exportKind = "type") : e.exportKind = "value", super.parseExport(e, s);
              }
              isAbstractClass() {
                return this.isContextual(122) && this.lookahead().type === 80;
              }
              parseExportDefaultExpression() {
                if (this.isAbstractClass()) {
                  let e = this.startNode();
                  return this.next(), e.abstract = true, this.parseClass(e, true, true);
                }
                if (this.match(127)) {
                  let e = this.tsParseInterfaceDeclaration(this.startNode());
                  if (e)
                    return e;
                }
                return super.parseExportDefaultExpression();
              }
              parseVarStatement(e, s) {
                let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, { isAmbientContext: a } = this.state, n = super.parseVarStatement(e, s, i || a);
                if (!a)
                  return n;
                for (let { id: o, init: c } of n.declarations)
                  !c || (s !== "const" || !!o.typeAnnotation ? this.raise(w.InitializerNotAllowedInAmbientContext, { at: c }) : c.type !== "StringLiteral" && c.type !== "BooleanLiteral" && c.type !== "NumericLiteral" && c.type !== "BigIntLiteral" && (c.type !== "TemplateLiteral" || c.expressions.length > 0) && !$l(c) && this.raise(w.ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference, { at: c }));
                return n;
              }
              parseStatementContent(e, s, i) {
                if (this.match(75) && this.isLookaheadContextual("enum")) {
                  let a = this.startNode();
                  return this.expect(75), this.tsParseEnumDeclaration(a, { const: true });
                }
                if (this.isContextual(124))
                  return this.tsParseEnumDeclaration(this.startNode());
                if (this.isContextual(127)) {
                  let a = this.tsParseInterfaceDeclaration(this.startNode());
                  if (a)
                    return a;
                }
                return super.parseStatementContent(e, s, i);
              }
              parseAccessModifier() {
                return this.tsParseModifier(["public", "protected", "private"]);
              }
              tsHasSomeModifiers(e, s) {
                return s.some((i) => $r(i) ? e.accessibility === i : !!e[i]);
              }
              tsIsStartOfStaticBlocks() {
                return this.isContextual(104) && this.lookaheadCharCode() === 123;
              }
              parseClassMember(e, s, i) {
                let a = ["declare", "private", "public", "protected", "override", "abstract", "readonly", "static"];
                this.tsParseModifiers({ modified: s, allowedModifiers: a, disallowedModifiers: ["in", "out"], stopOnStartOfClassStaticBlock: true, errorTemplate: w.InvalidModifierOnTypeParameterPositions });
                let n = () => {
                  this.tsIsStartOfStaticBlocks() ? (this.next(), this.next(), this.tsHasSomeModifiers(s, a) && this.raise(w.StaticBlockCannotHaveModifier, { at: this.state.curPosition() }), super.parseClassStaticBlock(e, s)) : this.parseClassMemberWithIsStatic(e, s, i, !!s.static);
                };
                s.declare ? this.tsInAmbientContext(n) : n();
              }
              parseClassMemberWithIsStatic(e, s, i, a) {
                let n = this.tsTryParseIndexSignature(s);
                if (n) {
                  e.body.push(n), s.abstract && this.raise(w.IndexSignatureHasAbstract, { at: s }), s.accessibility && this.raise(w.IndexSignatureHasAccessibility, { at: s, modifier: s.accessibility }), s.declare && this.raise(w.IndexSignatureHasDeclare, { at: s }), s.override && this.raise(w.IndexSignatureHasOverride, { at: s });
                  return;
                }
                !this.state.inAbstractClass && s.abstract && this.raise(w.NonAbstractClassHasAbstractMethod, { at: s }), s.override && (i.hadSuperClass || this.raise(w.OverrideNotInSubClass, { at: s })), super.parseClassMemberWithIsStatic(e, s, i, a);
              }
              parsePostMemberNameModifiers(e) {
                this.eat(17) && (e.optional = true), e.readonly && this.match(10) && this.raise(w.ClassMethodHasReadonly, { at: e }), e.declare && this.match(10) && this.raise(w.ClassMethodHasDeclare, { at: e });
              }
              parseExpressionStatement(e, s, i) {
                return (s.type === "Identifier" ? this.tsParseExpressionStatement(e, s, i) : void 0) || super.parseExpressionStatement(e, s, i);
              }
              shouldParseExportDeclaration() {
                return this.tsIsDeclarationStart() ? true : super.shouldParseExportDeclaration();
              }
              parseConditional(e, s, i) {
                if (!this.state.maybeInArrowParameters || !this.match(17))
                  return super.parseConditional(e, s, i);
                let a = this.tryParse(() => super.parseConditional(e, s));
                return a.node ? (a.error && (this.state = a.failState), a.node) : (a.error && super.setOptionalParametersError(i, a.error), e);
              }
              parseParenItem(e, s) {
                if (e = super.parseParenItem(e, s), this.eat(17) && (e.optional = true, this.resetEndLocation(e)), this.match(14)) {
                  let i = this.startNodeAt(s);
                  return i.expression = e, i.typeAnnotation = this.tsParseTypeAnnotation(), this.finishNode(i, "TSTypeCastExpression");
                }
                return e;
              }
              parseExportDeclaration(e) {
                if (!this.state.isAmbientContext && this.isContextual(123))
                  return this.tsInAmbientContext(() => this.parseExportDeclaration(e));
                let s = this.state.startLoc, i = this.eatContextual(123);
                if (i && (this.isContextual(123) || !this.shouldParseExportDeclaration()))
                  throw this.raise(w.ExpectedAmbientAfterExportDeclare, { at: this.state.startLoc });
                let n = $(this.state.type) && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(e);
                return n ? ((n.type === "TSInterfaceDeclaration" || n.type === "TSTypeAliasDeclaration" || i) && (e.exportKind = "type"), i && (this.resetStartLocation(n, s), n.declare = true), n) : null;
              }
              parseClassId(e, s, i, a) {
                if ((!s || i) && this.isContextual(111))
                  return;
                super.parseClassId(e, s, i, e.declare ? Sr : Er);
                let n = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this));
                n && (e.typeParameters = n);
              }
              parseClassPropertyAnnotation(e) {
                !e.optional && this.eat(35) && (e.definite = true);
                let s = this.tsTryParseTypeAnnotation();
                s && (e.typeAnnotation = s);
              }
              parseClassProperty(e) {
                if (this.parseClassPropertyAnnotation(e), this.state.isAmbientContext && !(e.readonly && !e.typeAnnotation) && this.match(29) && this.raise(w.DeclareClassFieldHasInitializer, { at: this.state.startLoc }), e.abstract && this.match(29)) {
                  let { key: s } = e;
                  this.raise(w.AbstractPropertyHasInitializer, { at: this.state.startLoc, propertyName: s.type === "Identifier" && !e.computed ? s.name : `[${this.input.slice(s.start, s.end)}]` });
                }
                return super.parseClassProperty(e);
              }
              parseClassPrivateProperty(e) {
                return e.abstract && this.raise(w.PrivateElementHasAbstract, { at: e }), e.accessibility && this.raise(w.PrivateElementHasAccessibility, { at: e, modifier: e.accessibility }), this.parseClassPropertyAnnotation(e), super.parseClassPrivateProperty(e);
              }
              pushClassMethod(e, s, i, a, n, o) {
                let c = this.tsTryParseTypeParameters();
                c && n && this.raise(w.ConstructorHasTypeParameters, { at: c });
                let { declare: p = false, kind: m } = s;
                p && (m === "get" || m === "set") && this.raise(w.DeclareAccessor, { at: s, kind: m }), c && (s.typeParameters = c), super.pushClassMethod(e, s, i, a, n, o);
              }
              pushClassPrivateMethod(e, s, i, a) {
                let n = this.tsTryParseTypeParameters();
                n && (s.typeParameters = n), super.pushClassPrivateMethod(e, s, i, a);
              }
              declareClassPrivateMethodInScope(e, s) {
                e.type !== "TSDeclareMethod" && (e.type === "MethodDefinition" && !e.value.body || super.declareClassPrivateMethodInScope(e, s));
              }
              parseClassSuper(e) {
                super.parseClassSuper(e), e.superClass && (this.match(47) || this.match(51)) && (e.superTypeParameters = this.tsParseTypeArgumentsInExpression()), this.eatContextual(111) && (e.implements = this.tsParseHeritageClause("implements"));
              }
              parseObjPropValue(e, s, i, a, n, o, c) {
                let p = this.tsTryParseTypeParameters();
                return p && (e.typeParameters = p), super.parseObjPropValue(e, s, i, a, n, o, c);
              }
              parseFunctionParams(e, s) {
                let i = this.tsTryParseTypeParameters();
                i && (e.typeParameters = i), super.parseFunctionParams(e, s);
              }
              parseVarId(e, s) {
                super.parseVarId(e, s), e.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35) && (e.definite = true);
                let i = this.tsTryParseTypeAnnotation();
                i && (e.id.typeAnnotation = i, this.resetEndLocation(e.id));
              }
              parseAsyncArrowFromCallExpression(e, s) {
                return this.match(14) && (e.returnType = this.tsParseTypeAnnotation()), super.parseAsyncArrowFromCallExpression(e, s);
              }
              parseMaybeAssign(e, s) {
                var i, a, n, o, c, p, m;
                let x, P, b;
                if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
                  if (x = this.state.clone(), P = this.tryParse(() => super.parseMaybeAssign(e, s), x), !P.error)
                    return P.node;
                  let { context: Q } = this.state, Z = Q[Q.length - 1];
                  (Z === H.j_oTag || Z === H.j_expr) && Q.pop();
                }
                if (!((i = P) != null && i.error) && !this.match(47))
                  return super.parseMaybeAssign(e, s);
                (!x || x === this.state) && (x = this.state.clone());
                let O, R = this.tryParse((Q) => {
                  var Z, X;
                  O = this.tsParseTypeParameters();
                  let re = super.parseMaybeAssign(e, s);
                  return (re.type !== "ArrowFunctionExpression" || (Z = re.extra) != null && Z.parenthesized) && Q(), ((X = O) == null ? void 0 : X.params.length) !== 0 && this.resetStartLocationFromNode(re, O), re.typeParameters = O, re;
                }, x);
                if (!R.error && !R.aborted)
                  return O && this.reportReservedArrowTypeParam(O), R.node;
                if (!P && (Hr(!this.hasPlugin("jsx")), b = this.tryParse(() => super.parseMaybeAssign(e, s), x), !b.error))
                  return b.node;
                if ((a = P) != null && a.node)
                  return this.state = P.failState, P.node;
                if (R.node)
                  return this.state = R.failState, O && this.reportReservedArrowTypeParam(O), R.node;
                if ((n = b) != null && n.node)
                  return this.state = b.failState, b.node;
                throw (o = P) != null && o.thrown ? P.error : R.thrown ? R.error : (c = b) != null && c.thrown ? b.error : ((p = P) == null ? void 0 : p.error) || R.error || ((m = b) == null ? void 0 : m.error);
              }
              reportReservedArrowTypeParam(e) {
                var s;
                e.params.length === 1 && !((s = e.extra) != null && s.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(w.ReservedArrowTypeParam, { at: e });
              }
              parseMaybeUnary(e, s) {
                return !this.hasPlugin("jsx") && this.match(47) ? this.tsParseTypeAssertion() : super.parseMaybeUnary(e, s);
              }
              parseArrow(e) {
                if (this.match(14)) {
                  let s = this.tryParse((i) => {
                    let a = this.tsParseTypeOrTypePredicateAnnotation(14);
                    return (this.canInsertSemicolon() || !this.match(19)) && i(), a;
                  });
                  if (s.aborted)
                    return;
                  s.thrown || (s.error && (this.state = s.failState), e.returnType = s.node);
                }
                return super.parseArrow(e);
              }
              parseAssignableListItemTypes(e) {
                this.eat(17) && (e.type !== "Identifier" && !this.state.isAmbientContext && !this.state.inType && this.raise(w.PatternIsOptional, { at: e }), e.optional = true);
                let s = this.tsTryParseTypeAnnotation();
                return s && (e.typeAnnotation = s), this.resetEndLocation(e), e;
              }
              isAssignable(e, s) {
                switch (e.type) {
                  case "TSTypeCastExpression":
                    return this.isAssignable(e.expression, s);
                  case "TSParameterProperty":
                    return true;
                  default:
                    return super.isAssignable(e, s);
                }
              }
              toAssignable(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                switch (e.type) {
                  case "ParenthesizedExpression":
                    this.toAssignableParenthesizedExpression(e, s);
                    break;
                  case "TSAsExpression":
                  case "TSSatisfiesExpression":
                  case "TSNonNullExpression":
                  case "TSTypeAssertion":
                    s ? this.expressionScope.recordArrowParemeterBindingError(w.UnexpectedTypeCastInParameter, { at: e }) : this.raise(w.UnexpectedTypeCastInParameter, { at: e }), this.toAssignable(e.expression, s);
                    break;
                  case "AssignmentExpression":
                    !s && e.left.type === "TSTypeCastExpression" && (e.left = this.typeCastToParameter(e.left));
                  default:
                    super.toAssignable(e, s);
                }
              }
              toAssignableParenthesizedExpression(e, s) {
                switch (e.expression.type) {
                  case "TSAsExpression":
                  case "TSSatisfiesExpression":
                  case "TSNonNullExpression":
                  case "TSTypeAssertion":
                  case "ParenthesizedExpression":
                    this.toAssignable(e.expression, s);
                    break;
                  default:
                    super.toAssignable(e, s);
                }
              }
              checkToRestConversion(e, s) {
                switch (e.type) {
                  case "TSAsExpression":
                  case "TSSatisfiesExpression":
                  case "TSTypeAssertion":
                  case "TSNonNullExpression":
                    this.checkToRestConversion(e.expression, false);
                    break;
                  default:
                    super.checkToRestConversion(e, s);
                }
              }
              isValidLVal(e, s, i) {
                return Rl({ TSTypeCastExpression: true, TSParameterProperty: "parameter", TSNonNullExpression: "expression", TSAsExpression: (i !== Te || !s) && ["expression", true], TSSatisfiesExpression: (i !== Te || !s) && ["expression", true], TSTypeAssertion: (i !== Te || !s) && ["expression", true] }, e) || super.isValidLVal(e, s, i);
              }
              parseBindingAtom() {
                switch (this.state.type) {
                  case 78:
                    return this.parseIdentifier(true);
                  default:
                    return super.parseBindingAtom();
                }
              }
              parseMaybeDecoratorArguments(e) {
                if (this.match(47) || this.match(51)) {
                  let s = this.tsParseTypeArgumentsInExpression();
                  if (this.match(10)) {
                    let i = super.parseMaybeDecoratorArguments(e);
                    return i.typeParameters = s, i;
                  }
                  this.unexpected(null, 10);
                }
                return super.parseMaybeDecoratorArguments(e);
              }
              checkCommaAfterRest(e) {
                return this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === e ? (this.next(), false) : super.checkCommaAfterRest(e);
              }
              isClassMethod() {
                return this.match(47) || super.isClassMethod();
              }
              isClassProperty() {
                return this.match(35) || this.match(14) || super.isClassProperty();
              }
              parseMaybeDefault(e, s) {
                let i = super.parseMaybeDefault(e, s);
                return i.type === "AssignmentPattern" && i.typeAnnotation && i.right.start < i.typeAnnotation.start && this.raise(w.TypeAnnotationAfterAssign, { at: i.typeAnnotation }), i;
              }
              getTokenFromCode(e) {
                if (this.state.inType) {
                  if (e === 62)
                    return this.finishOp(48, 1);
                  if (e === 60)
                    return this.finishOp(47, 1);
                }
                return super.getTokenFromCode(e);
              }
              reScan_lt_gt() {
                let { type: e } = this.state;
                e === 47 ? (this.state.pos -= 1, this.readToken_lt()) : e === 48 && (this.state.pos -= 1, this.readToken_gt());
              }
              reScan_lt() {
                let { type: e } = this.state;
                return e === 51 ? (this.state.pos -= 2, this.finishOp(47, 1), 47) : e;
              }
              toAssignableList(e, s, i) {
                for (let a = 0; a < e.length; a++) {
                  let n = e[a];
                  (n == null ? void 0 : n.type) === "TSTypeCastExpression" && (e[a] = this.typeCastToParameter(n));
                }
                super.toAssignableList(e, s, i);
              }
              typeCastToParameter(e) {
                return e.expression.typeAnnotation = e.typeAnnotation, this.resetEndLocation(e.expression, e.typeAnnotation.loc.end), e.expression;
              }
              shouldParseArrow(e) {
                return this.match(14) ? e.every((s) => this.isAssignable(s, true)) : super.shouldParseArrow(e);
              }
              shouldParseAsyncArrow() {
                return this.match(14) || super.shouldParseAsyncArrow();
              }
              canHaveLeadingDecorator() {
                return super.canHaveLeadingDecorator() || this.isAbstractClass();
              }
              jsxParseOpeningElementAfterName(e) {
                if (this.match(47) || this.match(51)) {
                  let s = this.tsTryParseAndCatch(() => this.tsParseTypeArgumentsInExpression());
                  s && (e.typeParameters = s);
                }
                return super.jsxParseOpeningElementAfterName(e);
              }
              getGetterSetterExpectedParamCount(e) {
                let s = super.getGetterSetterExpectedParamCount(e), a = this.getObjectOrClassMethodParams(e)[0];
                return a && this.isThisParam(a) ? s + 1 : s;
              }
              parseCatchClauseParam() {
                let e = super.parseCatchClauseParam(), s = this.tsTryParseTypeAnnotation();
                return s && (e.typeAnnotation = s, this.resetEndLocation(e)), e;
              }
              tsInAmbientContext(e) {
                let s = this.state.isAmbientContext;
                this.state.isAmbientContext = true;
                try {
                  return e();
                } finally {
                  this.state.isAmbientContext = s;
                }
              }
              parseClass(e, s, i) {
                let a = this.state.inAbstractClass;
                this.state.inAbstractClass = !!e.abstract;
                try {
                  return super.parseClass(e, s, i);
                } finally {
                  this.state.inAbstractClass = a;
                }
              }
              tsParseAbstractDeclaration(e, s) {
                if (this.match(80))
                  return e.abstract = true, this.maybeTakeDecorators(s, this.parseClass(e, true, false));
                if (this.isContextual(127)) {
                  if (!this.hasFollowingLineBreak())
                    return e.abstract = true, this.raise(w.NonClassMethodPropertyHasAbstractModifer, { at: e }), this.tsParseInterfaceDeclaration(e);
                } else
                  this.unexpected(null, 80);
              }
              parseMethod(e, s, i, a, n, o, c) {
                let p = super.parseMethod(e, s, i, a, n, o, c);
                if (p.abstract && (this.hasPlugin("estree") ? !!p.value.body : !!p.body)) {
                  let { key: x } = p;
                  this.raise(w.AbstractMethodHasImplementation, { at: p, methodName: x.type === "Identifier" && !p.computed ? x.name : `[${this.input.slice(x.start, x.end)}]` });
                }
                return p;
              }
              tsParseTypeParameterName() {
                return this.parseIdentifier().name;
              }
              shouldParseAsAmbientContext() {
                return !!this.getPluginOption("typescript", "dts");
              }
              parse() {
                return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = true), super.parse();
              }
              getExpression() {
                return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = true), super.getExpression();
              }
              parseExportSpecifier(e, s, i, a) {
                return !s && a ? (this.parseTypeOnlyImportExportSpecifier(e, false, i), this.finishNode(e, "ExportSpecifier")) : (e.exportKind = "value", super.parseExportSpecifier(e, s, i, a));
              }
              parseImportSpecifier(e, s, i, a, n) {
                return !s && a ? (this.parseTypeOnlyImportExportSpecifier(e, true, i), this.finishNode(e, "ImportSpecifier")) : (e.importKind = "value", super.parseImportSpecifier(e, s, i, a, i ? wr : Je));
              }
              parseTypeOnlyImportExportSpecifier(e, s, i) {
                let a = s ? "imported" : "local", n = s ? "local" : "exported", o = e[a], c, p = false, m = true, x = o.loc.start;
                if (this.isContextual(93)) {
                  let b = this.parseIdentifier();
                  if (this.isContextual(93)) {
                    let O = this.parseIdentifier();
                    pe(this.state.type) ? (p = true, o = b, c = s ? this.parseIdentifier() : this.parseModuleExportName(), m = false) : (c = O, m = false);
                  } else
                    pe(this.state.type) ? (m = false, c = s ? this.parseIdentifier() : this.parseModuleExportName()) : (p = true, o = b);
                } else
                  pe(this.state.type) && (p = true, s ? (o = this.parseIdentifier(true), this.isContextual(93) || this.checkReservedWord(o.name, o.loc.start, true, true)) : o = this.parseModuleExportName());
                p && i && this.raise(s ? w.TypeModifierIsUsedInTypeImports : w.TypeModifierIsUsedInTypeExports, { at: x }), e[a] = o, e[n] = c;
                let P = s ? "importKind" : "exportKind";
                e[P] = p ? "type" : "value", m && this.eatContextual(93) && (e[n] = s ? this.parseIdentifier() : this.parseModuleExportName()), e[n] || (e[n] = xe(e[a])), s && this.checkIdentifier(e[n], p ? wr : Je);
              }
            };
            function $l(t3) {
              if (t3.type !== "MemberExpression")
                return false;
              let { computed: r, property: e } = t3;
              return r && e.type !== "StringLiteral" && (e.type !== "TemplateLiteral" || e.expressions.length > 0) ? false : zr(t3.object);
            }
            function zr(t3) {
              return t3.type === "Identifier" ? true : t3.type !== "MemberExpression" || t3.computed ? false : zr(t3.object);
            }
            var Vr = _`placeholders`({ ClassNameIsRequired: "A class name is required.", UnexpectedSpace: "Unexpected space in placeholder." }), zl = (t3) => class extends t3 {
              parsePlaceholder(e) {
                if (this.match(142)) {
                  let s = this.startNode();
                  return this.next(), this.assertNoSpace(), s.name = super.parseIdentifier(true), this.assertNoSpace(), this.expect(142), this.finishPlaceholder(s, e);
                }
              }
              finishPlaceholder(e, s) {
                let i = !!(e.expectedNode && e.type === "Placeholder");
                return e.expectedNode = s, i ? e : this.finishNode(e, "Placeholder");
              }
              getTokenFromCode(e) {
                return e === 37 && this.input.charCodeAt(this.state.pos + 1) === 37 ? this.finishOp(142, 2) : super.getTokenFromCode(e);
              }
              parseExprAtom(e) {
                return this.parsePlaceholder("Expression") || super.parseExprAtom(e);
              }
              parseIdentifier(e) {
                return this.parsePlaceholder("Identifier") || super.parseIdentifier(e);
              }
              checkReservedWord(e, s, i, a) {
                e !== void 0 && super.checkReservedWord(e, s, i, a);
              }
              parseBindingAtom() {
                return this.parsePlaceholder("Pattern") || super.parseBindingAtom();
              }
              isValidLVal(e, s, i) {
                return e === "Placeholder" || super.isValidLVal(e, s, i);
              }
              toAssignable(e, s) {
                e && e.type === "Placeholder" && e.expectedNode === "Expression" ? e.expectedNode = "Pattern" : super.toAssignable(e, s);
              }
              hasFollowingIdentifier(e) {
                return super.hasFollowingIdentifier(e) ? true : e ? false : this.lookahead().type === 142;
              }
              verifyBreakContinue(e, s) {
                e.label && e.label.type === "Placeholder" || super.verifyBreakContinue(e, s);
              }
              parseExpressionStatement(e, s) {
                if (s.type !== "Placeholder" || s.extra && s.extra.parenthesized)
                  return super.parseExpressionStatement(e, s);
                if (this.match(14)) {
                  let i = e;
                  return i.label = this.finishPlaceholder(s, "Identifier"), this.next(), i.body = super.parseStatement("label"), this.finishNode(i, "LabeledStatement");
                }
                return this.semicolon(), e.name = s.name, this.finishPlaceholder(e, "Statement");
              }
              parseBlock(e, s, i) {
                return this.parsePlaceholder("BlockStatement") || super.parseBlock(e, s, i);
              }
              parseFunctionId(e) {
                return this.parsePlaceholder("Identifier") || super.parseFunctionId(e);
              }
              parseClass(e, s, i) {
                let a = s ? "ClassDeclaration" : "ClassExpression";
                this.next();
                let n = this.state.strict, o = this.parsePlaceholder("Identifier");
                if (o)
                  if (this.match(81) || this.match(142) || this.match(5))
                    e.id = o;
                  else {
                    if (i || !s)
                      return e.id = null, e.body = this.finishPlaceholder(o, "ClassBody"), this.finishNode(e, a);
                    throw this.raise(Vr.ClassNameIsRequired, { at: this.state.startLoc });
                  }
                else
                  this.parseClassId(e, s, i);
                return super.parseClassSuper(e), e.body = this.parsePlaceholder("ClassBody") || super.parseClassBody(!!e.superClass, n), this.finishNode(e, a);
              }
              parseExport(e, s) {
                let i = this.parsePlaceholder("Identifier");
                if (!i)
                  return super.parseExport(e, s);
                if (!this.isContextual(97) && !this.match(12))
                  return e.specifiers = [], e.source = null, e.declaration = this.finishPlaceholder(i, "Declaration"), this.finishNode(e, "ExportNamedDeclaration");
                this.expectPlugin("exportDefaultFrom");
                let a = this.startNode();
                return a.exported = i, e.specifiers = [this.finishNode(a, "ExportDefaultSpecifier")], super.parseExport(e, s);
              }
              isExportDefaultSpecifier() {
                if (this.match(65)) {
                  let e = this.nextTokenStart();
                  if (this.isUnparsedContextual(e, "from") && this.input.startsWith(Pe(142), this.nextTokenStartSince(e + 4)))
                    return true;
                }
                return super.isExportDefaultSpecifier();
              }
              maybeParseExportDefaultSpecifier(e) {
                return e.specifiers && e.specifiers.length > 0 ? true : super.maybeParseExportDefaultSpecifier(e);
              }
              checkExport(e) {
                let { specifiers: s } = e;
                s != null && s.length && (e.specifiers = s.filter((i) => i.exported.type === "Placeholder")), super.checkExport(e), e.specifiers = s;
              }
              parseImport(e) {
                let s = this.parsePlaceholder("Identifier");
                if (!s)
                  return super.parseImport(e);
                if (e.specifiers = [], !this.isContextual(97) && !this.match(12))
                  return e.source = this.finishPlaceholder(s, "StringLiteral"), this.semicolon(), this.finishNode(e, "ImportDeclaration");
                let i = this.startNodeAtNode(s);
                return i.local = s, e.specifiers.push(this.finishNode(i, "ImportDefaultSpecifier")), this.eat(12) && (this.maybeParseStarImportSpecifier(e) || this.parseNamedImportSpecifiers(e)), this.expectContextual(97), e.source = this.parseImportSource(), this.semicolon(), this.finishNode(e, "ImportDeclaration");
              }
              parseImportSource() {
                return this.parsePlaceholder("StringLiteral") || super.parseImportSource();
              }
              assertNoSpace() {
                this.state.start > this.state.lastTokEndLoc.index && this.raise(Vr.UnexpectedSpace, { at: this.state.lastTokEndLoc });
              }
            }, Vl = (t3) => class extends t3 {
              parseV8Intrinsic() {
                if (this.match(54)) {
                  let e = this.state.startLoc, s = this.startNode();
                  if (this.next(), $(this.state.type)) {
                    let i = this.parseIdentifierName(), a = this.createIdentifier(s, i);
                    if (a.type = "V8IntrinsicIdentifier", this.match(10))
                      return a;
                  }
                  this.unexpected(e);
                }
              }
              parseExprAtom(e) {
                return this.parseV8Intrinsic() || super.parseExprAtom(e);
              }
            };
            function se(t3, r) {
              let [e, s] = typeof r == "string" ? [r, {}] : r, i = Object.keys(s), a = i.length === 0;
              return t3.some((n) => {
                if (typeof n == "string")
                  return a && n === e;
                {
                  let [o, c] = n;
                  if (o !== e)
                    return false;
                  for (let p of i)
                    if (c[p] !== s[p])
                      return false;
                  return true;
                }
              });
            }
            function ke(t3, r, e) {
              let s = t3.find((i) => Array.isArray(i) ? i[0] === r : i === r);
              return s && Array.isArray(s) && s.length > 1 ? s[1][e] : null;
            }
            var Kr = ["minimal", "fsharp", "hack", "smart"], Wr = ["^^", "@@", "^", "%", "#"], Gr = ["hash", "bar"];
            function Kl(t3) {
              if (se(t3, "decorators")) {
                if (se(t3, "decorators-legacy"))
                  throw new Error("Cannot use the decorators and decorators-legacy plugin together");
                let r = ke(t3, "decorators", "decoratorsBeforeExport");
                if (r != null && typeof r != "boolean")
                  throw new Error("'decoratorsBeforeExport' must be a boolean.");
                let e = ke(t3, "decorators", "allowCallParenthesized");
                if (e != null && typeof e != "boolean")
                  throw new Error("'allowCallParenthesized' must be a boolean.");
              }
              if (se(t3, "flow") && se(t3, "typescript"))
                throw new Error("Cannot combine flow and typescript plugins.");
              if (se(t3, "placeholders") && se(t3, "v8intrinsic"))
                throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
              if (se(t3, "pipelineOperator")) {
                let r = ke(t3, "pipelineOperator", "proposal");
                if (!Kr.includes(r)) {
                  let s = Kr.map((i) => `"${i}"`).join(", ");
                  throw new Error(`"pipelineOperator" requires "proposal" option whose value must be one of: ${s}.`);
                }
                let e = se(t3, ["recordAndTuple", { syntaxType: "hash" }]);
                if (r === "hack") {
                  if (se(t3, "placeholders"))
                    throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
                  if (se(t3, "v8intrinsic"))
                    throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
                  let s = ke(t3, "pipelineOperator", "topicToken");
                  if (!Wr.includes(s)) {
                    let i = Wr.map((a) => `"${a}"`).join(", ");
                    throw new Error(`"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: ${i}.`);
                  }
                  if (s === "#" && e)
                    throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "hack", topicToken: "#" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
                } else if (r === "smart" && e)
                  throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "smart" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
              }
              if (se(t3, "moduleAttributes")) {
                if (se(t3, "importAssertions"))
                  throw new Error("Cannot combine importAssertions and moduleAttributes plugins.");
                if (ke(t3, "moduleAttributes", "version") !== "may-2020")
                  throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
              }
              if (se(t3, "recordAndTuple") && ke(t3, "recordAndTuple", "syntaxType") != null && !Gr.includes(ke(t3, "recordAndTuple", "syntaxType")))
                throw new Error("The 'syntaxType' option of the 'recordAndTuple' plugin must be one of: " + Gr.map((r) => `'${r}'`).join(", "));
              if (se(t3, "asyncDoExpressions") && !se(t3, "doExpressions")) {
                let r = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
                throw r.missingPlugins = "doExpressions", r;
              }
            }
            var Jr = { estree: Me, jsx: Ml, flow: Ll, typescript: Hl, v8intrinsic: Vl, placeholders: zl }, Wl = Object.keys(Jr), Xr = { sourceType: "script", sourceFilename: void 0, startColumn: 0, startLine: 1, allowAwaitOutsideFunction: false, allowReturnOutsideFunction: false, allowImportExportEverywhere: false, allowSuperOutsideMethod: false, allowUndeclaredExports: false, plugins: [], strictMode: null, ranges: false, tokens: false, createParenthesizedExpressions: false, errorRecovery: false, attachComment: true };
            function Gl(t3) {
              let r = {};
              for (let e of Object.keys(Xr))
                r[e] = t3 && t3[e] != null ? t3[e] : Xr[e];
              return r;
            }
            var Jl = (t3, r) => Object.hasOwnProperty.call(t3, r) && t3[r], Yr = (t3) => t3.type === "ParenthesizedExpression" ? Yr(t3.expression) : t3, Xl = class extends wl {
              toAssignable(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var e, s;
                let i;
                switch ((t3.type === "ParenthesizedExpression" || (e = t3.extra) != null && e.parenthesized) && (i = Yr(t3), r ? i.type === "Identifier" ? this.expressionScope.recordArrowParemeterBindingError(h.InvalidParenthesizedAssignment, { at: t3 }) : i.type !== "MemberExpression" && this.raise(h.InvalidParenthesizedAssignment, { at: t3 }) : this.raise(h.InvalidParenthesizedAssignment, { at: t3 })), t3.type) {
                  case "Identifier":
                  case "ObjectPattern":
                  case "ArrayPattern":
                  case "AssignmentPattern":
                  case "RestElement":
                    break;
                  case "ObjectExpression":
                    t3.type = "ObjectPattern";
                    for (let n = 0, o = t3.properties.length, c = o - 1; n < o; n++) {
                      var a;
                      let p = t3.properties[n], m = n === c;
                      this.toAssignableObjectExpressionProp(p, m, r), m && p.type === "RestElement" && (a = t3.extra) != null && a.trailingCommaLoc && this.raise(h.RestTrailingComma, { at: t3.extra.trailingCommaLoc });
                    }
                    break;
                  case "ObjectProperty": {
                    let { key: n, value: o } = t3;
                    this.isPrivateName(n) && this.classScope.usePrivateName(this.getPrivateNameSV(n), n.loc.start), this.toAssignable(o, r);
                    break;
                  }
                  case "SpreadElement":
                    throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
                  case "ArrayExpression":
                    t3.type = "ArrayPattern", this.toAssignableList(t3.elements, (s = t3.extra) == null ? void 0 : s.trailingCommaLoc, r);
                    break;
                  case "AssignmentExpression":
                    t3.operator !== "=" && this.raise(h.MissingEqInAssignment, { at: t3.left.loc.end }), t3.type = "AssignmentPattern", delete t3.operator, this.toAssignable(t3.left, r);
                    break;
                  case "ParenthesizedExpression":
                    this.toAssignable(i, r);
                    break;
                }
              }
              toAssignableObjectExpressionProp(t3, r, e) {
                if (t3.type === "ObjectMethod")
                  this.raise(t3.kind === "get" || t3.kind === "set" ? h.PatternHasAccessor : h.PatternHasMethod, { at: t3.key });
                else if (t3.type === "SpreadElement") {
                  t3.type = "RestElement";
                  let s = t3.argument;
                  this.checkToRestConversion(s, false), this.toAssignable(s, e), r || this.raise(h.RestTrailingComma, { at: t3 });
                } else
                  this.toAssignable(t3, e);
              }
              toAssignableList(t3, r, e) {
                let s = t3.length - 1;
                for (let i = 0; i <= s; i++) {
                  let a = t3[i];
                  if (!!a) {
                    if (a.type === "SpreadElement") {
                      a.type = "RestElement";
                      let n = a.argument;
                      this.checkToRestConversion(n, true), this.toAssignable(n, e);
                    } else
                      this.toAssignable(a, e);
                    a.type === "RestElement" && (i < s ? this.raise(h.RestTrailingComma, { at: a }) : r && this.raise(h.RestTrailingComma, { at: r }));
                  }
                }
              }
              isAssignable(t3, r) {
                switch (t3.type) {
                  case "Identifier":
                  case "ObjectPattern":
                  case "ArrayPattern":
                  case "AssignmentPattern":
                  case "RestElement":
                    return true;
                  case "ObjectExpression": {
                    let e = t3.properties.length - 1;
                    return t3.properties.every((s, i) => s.type !== "ObjectMethod" && (i === e || s.type !== "SpreadElement") && this.isAssignable(s));
                  }
                  case "ObjectProperty":
                    return this.isAssignable(t3.value);
                  case "SpreadElement":
                    return this.isAssignable(t3.argument);
                  case "ArrayExpression":
                    return t3.elements.every((e) => e === null || this.isAssignable(e));
                  case "AssignmentExpression":
                    return t3.operator === "=";
                  case "ParenthesizedExpression":
                    return this.isAssignable(t3.expression);
                  case "MemberExpression":
                  case "OptionalMemberExpression":
                    return !r;
                  default:
                    return false;
                }
              }
              toReferencedList(t3, r) {
                return t3;
              }
              toReferencedListDeep(t3, r) {
                this.toReferencedList(t3, r);
                for (let e of t3)
                  (e == null ? void 0 : e.type) === "ArrayExpression" && this.toReferencedListDeep(e.elements);
              }
              parseSpread(t3) {
                let r = this.startNode();
                return this.next(), r.argument = this.parseMaybeAssignAllowIn(t3, void 0), this.finishNode(r, "SpreadElement");
              }
              parseRestBinding() {
                let t3 = this.startNode();
                return this.next(), t3.argument = this.parseBindingAtom(), this.finishNode(t3, "RestElement");
              }
              parseBindingAtom() {
                switch (this.state.type) {
                  case 0: {
                    let t3 = this.startNode();
                    return this.next(), t3.elements = this.parseBindingList(3, 93, true), this.finishNode(t3, "ArrayPattern");
                  }
                  case 5:
                    return this.parseObjectLike(8, true);
                }
                return this.parseIdentifier();
              }
              parseBindingList(t3, r, e, s) {
                let i = [], a = true;
                for (; !this.eat(t3); )
                  if (a ? a = false : this.expect(12), e && this.match(12))
                    i.push(null);
                  else {
                    if (this.eat(t3))
                      break;
                    if (this.match(21)) {
                      if (i.push(this.parseAssignableListItemTypes(this.parseRestBinding())), !this.checkCommaAfterRest(r)) {
                        this.expect(t3);
                        break;
                      }
                    } else {
                      let n = [];
                      for (this.match(26) && this.hasPlugin("decorators") && this.raise(h.UnsupportedParameterDecorator, { at: this.state.startLoc }); this.match(26); )
                        n.push(this.parseDecorator());
                      i.push(this.parseAssignableListItem(s, n));
                    }
                  }
                return i;
              }
              parseBindingRestProperty(t3) {
                return this.next(), t3.argument = this.parseIdentifier(), this.checkCommaAfterRest(125), this.finishNode(t3, "RestElement");
              }
              parseBindingProperty() {
                let t3 = this.startNode(), { type: r, startLoc: e } = this.state;
                return r === 21 ? this.parseBindingRestProperty(t3) : (r === 136 ? (this.expectPlugin("destructuringPrivate", e), this.classScope.usePrivateName(this.state.value, e), t3.key = this.parsePrivateName()) : this.parsePropertyName(t3), t3.method = false, this.parseObjPropValue(t3, e, false, false, true, false));
              }
              parseAssignableListItem(t3, r) {
                let e = this.parseMaybeDefault();
                this.parseAssignableListItemTypes(e);
                let s = this.parseMaybeDefault(e.loc.start, e);
                return r.length && (e.decorators = r), s;
              }
              parseAssignableListItemTypes(t3) {
                return t3;
              }
              parseMaybeDefault(t3, r) {
                var e, s;
                if ((e = t3) != null || (t3 = this.state.startLoc), r = (s = r) != null ? s : this.parseBindingAtom(), !this.eat(29))
                  return r;
                let i = this.startNodeAt(t3);
                return i.left = r, i.right = this.parseMaybeAssignAllowIn(), this.finishNode(i, "AssignmentPattern");
              }
              isValidLVal(t3, r, e) {
                return Jl({ AssignmentPattern: "left", RestElement: "argument", ObjectProperty: "value", ParenthesizedExpression: "expression", ArrayPattern: "elements", ObjectPattern: "properties" }, t3);
              }
              checkLVal(t3, r) {
                let { in: e, binding: s = Te, checkClashes: i = false, strictModeChanged: a = false, allowingSloppyLetBinding: n = !(s & Ae), hasParenthesizedAncestor: o = false } = r;
                var c;
                let p = t3.type;
                if (this.isObjectMethod(t3))
                  return;
                if (p === "MemberExpression") {
                  s !== Te && this.raise(h.InvalidPropertyBindingPattern, { at: t3 });
                  return;
                }
                if (t3.type === "Identifier") {
                  this.checkIdentifier(t3, s, a, n);
                  let { name: O } = t3;
                  i && (i.has(O) ? this.raise(h.ParamDupe, { at: t3 }) : i.add(O));
                  return;
                }
                let m = this.isValidLVal(t3.type, !(o || (c = t3.extra) != null && c.parenthesized) && e.type === "AssignmentExpression", s);
                if (m === true)
                  return;
                if (m === false) {
                  let O = s === Te ? h.InvalidLhs : h.InvalidLhsBinding;
                  this.raise(O, { at: t3, ancestor: e.type === "UpdateExpression" ? { type: "UpdateExpression", prefix: e.prefix } : { type: e.type } });
                  return;
                }
                let [x, P] = Array.isArray(m) ? m : [m, p === "ParenthesizedExpression"], b = t3.type === "ArrayPattern" || t3.type === "ObjectPattern" || t3.type === "ParenthesizedExpression" ? t3 : e;
                for (let O of [].concat(t3[x]))
                  O && this.checkLVal(O, { in: b, binding: s, checkClashes: i, allowingSloppyLetBinding: n, strictModeChanged: a, hasParenthesizedAncestor: P });
              }
              checkIdentifier(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !(r & Ae);
                this.state.strict && (e ? gr(t3.name, this.inModule) : xr(t3.name)) && (r === Te ? this.raise(h.StrictEvalArguments, { at: t3, referenceName: t3.name }) : this.raise(h.StrictEvalArgumentsBinding, { at: t3, bindingName: t3.name })), !s && t3.name === "let" && this.raise(h.LetInLexicalBinding, { at: t3 }), r & Te || this.declareNameFromIdentifier(t3, r);
              }
              declareNameFromIdentifier(t3, r) {
                this.scope.declareName(t3.name, r, t3.loc.start);
              }
              checkToRestConversion(t3, r) {
                switch (t3.type) {
                  case "ParenthesizedExpression":
                    this.checkToRestConversion(t3.expression, r);
                    break;
                  case "Identifier":
                  case "MemberExpression":
                    break;
                  case "ArrayExpression":
                  case "ObjectExpression":
                    if (r)
                      break;
                  default:
                    this.raise(h.InvalidRestAssignmentPattern, { at: t3 });
                }
              }
              checkCommaAfterRest(t3) {
                return this.match(12) ? (this.raise(this.lookaheadCharCode() === t3 ? h.RestTrailingComma : h.ElementAfterRest, { at: this.state.startLoc }), true) : false;
              }
            }, Yl = class extends Xl {
              checkProto(t3, r, e, s) {
                if (t3.type === "SpreadElement" || this.isObjectMethod(t3) || t3.computed || t3.shorthand)
                  return;
                let i = t3.key;
                if ((i.type === "Identifier" ? i.name : i.value) === "__proto__") {
                  if (r) {
                    this.raise(h.RecordNoProto, { at: i });
                    return;
                  }
                  e.used && (s ? s.doubleProtoLoc === null && (s.doubleProtoLoc = i.loc.start) : this.raise(h.DuplicateProto, { at: i })), e.used = true;
                }
              }
              shouldExitDescending(t3, r) {
                return t3.type === "ArrowFunctionExpression" && t3.start === r;
              }
              getExpression() {
                this.enterInitialScopes(), this.nextToken();
                let t3 = this.parseExpression();
                return this.match(137) || this.unexpected(), this.finalizeRemainingComments(), t3.comments = this.state.comments, t3.errors = this.state.errors, this.options.tokens && (t3.tokens = this.tokens), t3;
              }
              parseExpression(t3, r) {
                return t3 ? this.disallowInAnd(() => this.parseExpressionBase(r)) : this.allowInAnd(() => this.parseExpressionBase(r));
              }
              parseExpressionBase(t3) {
                let r = this.state.startLoc, e = this.parseMaybeAssign(t3);
                if (this.match(12)) {
                  let s = this.startNodeAt(r);
                  for (s.expressions = [e]; this.eat(12); )
                    s.expressions.push(this.parseMaybeAssign(t3));
                  return this.toReferencedList(s.expressions), this.finishNode(s, "SequenceExpression");
                }
                return e;
              }
              parseMaybeAssignDisallowIn(t3, r) {
                return this.disallowInAnd(() => this.parseMaybeAssign(t3, r));
              }
              parseMaybeAssignAllowIn(t3, r) {
                return this.allowInAnd(() => this.parseMaybeAssign(t3, r));
              }
              setOptionalParametersError(t3, r) {
                var e;
                t3.optionalParametersLoc = (e = r == null ? void 0 : r.loc) != null ? e : this.state.startLoc;
              }
              parseMaybeAssign(t3, r) {
                let e = this.state.startLoc;
                if (this.isContextual(106) && this.prodParam.hasYield) {
                  let n = this.parseYield();
                  return r && (n = r.call(this, n, e)), n;
                }
                let s;
                t3 ? s = false : (t3 = new At(), s = true);
                let { type: i } = this.state;
                (i === 10 || $(i)) && (this.state.potentialArrowAt = this.state.start);
                let a = this.parseMaybeConditional(t3);
                if (r && (a = r.call(this, a, e)), Io(this.state.type)) {
                  let n = this.startNodeAt(e), o = this.state.value;
                  if (n.operator = o, this.match(29)) {
                    this.toAssignable(a, true), n.left = a;
                    let c = e.index;
                    t3.doubleProtoLoc != null && t3.doubleProtoLoc.index >= c && (t3.doubleProtoLoc = null), t3.shorthandAssignLoc != null && t3.shorthandAssignLoc.index >= c && (t3.shorthandAssignLoc = null), t3.privateKeyLoc != null && t3.privateKeyLoc.index >= c && (this.checkDestructuringPrivate(t3), t3.privateKeyLoc = null);
                  } else
                    n.left = a;
                  return this.next(), n.right = this.parseMaybeAssign(), this.checkLVal(a, { in: this.finishNode(n, "AssignmentExpression") }), n;
                } else
                  s && this.checkExpressionErrors(t3, true);
                return a;
              }
              parseMaybeConditional(t3) {
                let r = this.state.startLoc, e = this.state.potentialArrowAt, s = this.parseExprOps(t3);
                return this.shouldExitDescending(s, e) ? s : this.parseConditional(s, r, t3);
              }
              parseConditional(t3, r, e) {
                if (this.eat(17)) {
                  let s = this.startNodeAt(r);
                  return s.test = t3, s.consequent = this.parseMaybeAssignAllowIn(), this.expect(14), s.alternate = this.parseMaybeAssign(), this.finishNode(s, "ConditionalExpression");
                }
                return t3;
              }
              parseMaybeUnaryOrPrivate(t3) {
                return this.match(136) ? this.parsePrivateName() : this.parseMaybeUnary(t3);
              }
              parseExprOps(t3) {
                let r = this.state.startLoc, e = this.state.potentialArrowAt, s = this.parseMaybeUnaryOrPrivate(t3);
                return this.shouldExitDescending(s, e) ? s : this.parseExprOp(s, r, -1);
              }
              parseExprOp(t3, r, e) {
                if (this.isPrivateName(t3)) {
                  let i = this.getPrivateNameSV(t3);
                  (e >= nt(58) || !this.prodParam.hasIn || !this.match(58)) && this.raise(h.PrivateInExpectedIn, { at: t3, identifierName: i }), this.classScope.usePrivateName(i, t3.loc.start);
                }
                let s = this.state.type;
                if (ko(s) && (this.prodParam.hasIn || !this.match(58))) {
                  let i = nt(s);
                  if (i > e) {
                    if (s === 39) {
                      if (this.expectPlugin("pipelineOperator"), this.state.inFSharpPipelineDirectBody)
                        return t3;
                      this.checkPipelineAtInfixOperator(t3, r);
                    }
                    let a = this.startNodeAt(r);
                    a.left = t3, a.operator = this.state.value;
                    let n = s === 41 || s === 42, o = s === 40;
                    if (o && (i = nt(42)), this.next(), s === 39 && this.hasPlugin(["pipelineOperator", { proposal: "minimal" }]) && this.state.type === 96 && this.prodParam.hasAwait)
                      throw this.raise(h.UnexpectedAwaitAfterPipelineBody, { at: this.state.startLoc });
                    a.right = this.parseExprOpRightExpr(s, i);
                    let c = this.finishNode(a, n || o ? "LogicalExpression" : "BinaryExpression"), p = this.state.type;
                    if (o && (p === 41 || p === 42) || n && p === 40)
                      throw this.raise(h.MixingCoalesceWithLogical, { at: this.state.startLoc });
                    return this.parseExprOp(c, r, e);
                  }
                }
                return t3;
              }
              parseExprOpRightExpr(t3, r) {
                let e = this.state.startLoc;
                switch (t3) {
                  case 39:
                    switch (this.getPluginOption("pipelineOperator", "proposal")) {
                      case "hack":
                        return this.withTopicBindingContext(() => this.parseHackPipeBody());
                      case "smart":
                        return this.withTopicBindingContext(() => {
                          if (this.prodParam.hasYield && this.isContextual(106))
                            throw this.raise(h.PipeBodyIsTighter, { at: this.state.startLoc });
                          return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(t3, r), e);
                        });
                      case "fsharp":
                        return this.withSoloAwaitPermittingContext(() => this.parseFSharpPipelineBody(r));
                    }
                  default:
                    return this.parseExprOpBaseRightExpr(t3, r);
                }
              }
              parseExprOpBaseRightExpr(t3, r) {
                let e = this.state.startLoc;
                return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), e, Mo(t3) ? r - 1 : r);
              }
              parseHackPipeBody() {
                var t3;
                let { startLoc: r } = this.state, e = this.parseMaybeAssign();
                return j.has(e.type) && !((t3 = e.extra) != null && t3.parenthesized) && this.raise(h.PipeUnparenthesizedBody, { at: r, type: e.type }), this.topicReferenceWasUsedInCurrentContext() || this.raise(h.PipeTopicUnused, { at: r }), e;
              }
              checkExponentialAfterUnary(t3) {
                this.match(57) && this.raise(h.UnexpectedTokenUnaryExponentiation, { at: t3.argument });
              }
              parseMaybeUnary(t3, r) {
                let e = this.state.startLoc, s = this.isContextual(96);
                if (s && this.isAwaitAllowed()) {
                  this.next();
                  let o = this.parseAwait(e);
                  return r || this.checkExponentialAfterUnary(o), o;
                }
                let i = this.match(34), a = this.startNode();
                if (Fo(this.state.type)) {
                  a.operator = this.state.value, a.prefix = true, this.match(72) && this.expectPlugin("throwExpressions");
                  let o = this.match(89);
                  if (this.next(), a.argument = this.parseMaybeUnary(null, true), this.checkExpressionErrors(t3, true), this.state.strict && o) {
                    let c = a.argument;
                    c.type === "Identifier" ? this.raise(h.StrictDelete, { at: a }) : this.hasPropertyAsPrivateName(c) && this.raise(h.DeletePrivateField, { at: a });
                  }
                  if (!i)
                    return r || this.checkExponentialAfterUnary(a), this.finishNode(a, "UnaryExpression");
                }
                let n = this.parseUpdate(a, i, t3);
                if (s) {
                  let { type: o } = this.state;
                  if ((this.hasPlugin("v8intrinsic") ? Kt(o) : Kt(o) && !this.match(54)) && !this.isAmbiguousAwait())
                    return this.raiseOverwrite(h.AwaitNotInAsyncContext, { at: e }), this.parseAwait(e);
                }
                return n;
              }
              parseUpdate(t3, r, e) {
                if (r) {
                  let a = t3;
                  return this.checkLVal(a.argument, { in: this.finishNode(a, "UpdateExpression") }), t3;
                }
                let s = this.state.startLoc, i = this.parseExprSubscripts(e);
                if (this.checkExpressionErrors(e, false))
                  return i;
                for (; Do(this.state.type) && !this.canInsertSemicolon(); ) {
                  let a = this.startNodeAt(s);
                  a.operator = this.state.value, a.prefix = false, a.argument = i, this.next(), this.checkLVal(i, { in: i = this.finishNode(a, "UpdateExpression") });
                }
                return i;
              }
              parseExprSubscripts(t3) {
                let r = this.state.startLoc, e = this.state.potentialArrowAt, s = this.parseExprAtom(t3);
                return this.shouldExitDescending(s, e) ? s : this.parseSubscripts(s, r);
              }
              parseSubscripts(t3, r, e) {
                let s = { optionalChainMember: false, maybeAsyncArrow: this.atPossibleAsyncArrow(t3), stop: false };
                do
                  t3 = this.parseSubscript(t3, r, e, s), s.maybeAsyncArrow = false;
                while (!s.stop);
                return t3;
              }
              parseSubscript(t3, r, e, s) {
                let { type: i } = this.state;
                if (!e && i === 15)
                  return this.parseBind(t3, r, e, s);
                if (ot(i))
                  return this.parseTaggedTemplateExpression(t3, r, s);
                let a = false;
                if (i === 18) {
                  if (e && this.lookaheadCharCode() === 40)
                    return s.stop = true, t3;
                  s.optionalChainMember = a = true, this.next();
                }
                if (!e && this.match(10))
                  return this.parseCoverCallAndAsyncArrowHead(t3, r, s, a);
                {
                  let n = this.eat(0);
                  return n || a || this.eat(16) ? this.parseMember(t3, r, s, n, a) : (s.stop = true, t3);
                }
              }
              parseMember(t3, r, e, s, i) {
                let a = this.startNodeAt(r);
                return a.object = t3, a.computed = s, s ? (a.property = this.parseExpression(), this.expect(3)) : this.match(136) ? (t3.type === "Super" && this.raise(h.SuperPrivateField, { at: r }), this.classScope.usePrivateName(this.state.value, this.state.startLoc), a.property = this.parsePrivateName()) : a.property = this.parseIdentifier(true), e.optionalChainMember ? (a.optional = i, this.finishNode(a, "OptionalMemberExpression")) : this.finishNode(a, "MemberExpression");
              }
              parseBind(t3, r, e, s) {
                let i = this.startNodeAt(r);
                return i.object = t3, this.next(), i.callee = this.parseNoCallExpr(), s.stop = true, this.parseSubscripts(this.finishNode(i, "BindExpression"), r, e);
              }
              parseCoverCallAndAsyncArrowHead(t3, r, e, s) {
                let i = this.state.maybeInArrowParameters, a = null;
                this.state.maybeInArrowParameters = true, this.next();
                let n = this.startNodeAt(r);
                n.callee = t3;
                let { maybeAsyncArrow: o, optionalChainMember: c } = e;
                o && (this.expressionScope.enter(vl()), a = new At()), c && (n.optional = s), s ? n.arguments = this.parseCallExpressionArguments(11) : n.arguments = this.parseCallExpressionArguments(11, t3.type === "Import", t3.type !== "Super", n, a);
                let p = this.finishCallExpression(n, c);
                return o && this.shouldParseAsyncArrow() && !s ? (e.stop = true, this.checkDestructuringPrivate(a), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), p = this.parseAsyncArrowFromCallExpression(this.startNodeAt(r), p)) : (o && (this.checkExpressionErrors(a, true), this.expressionScope.exit()), this.toReferencedArguments(p)), this.state.maybeInArrowParameters = i, p;
              }
              toReferencedArguments(t3, r) {
                this.toReferencedListDeep(t3.arguments, r);
              }
              parseTaggedTemplateExpression(t3, r, e) {
                let s = this.startNodeAt(r);
                return s.tag = t3, s.quasi = this.parseTemplate(true), e.optionalChainMember && this.raise(h.OptionalChainingNoTemplate, { at: r }), this.finishNode(s, "TaggedTemplateExpression");
              }
              atPossibleAsyncArrow(t3) {
                return t3.type === "Identifier" && t3.name === "async" && this.state.lastTokEndLoc.index === t3.end && !this.canInsertSemicolon() && t3.end - t3.start === 5 && t3.start === this.state.potentialArrowAt;
              }
              finishCallExpression(t3, r) {
                if (t3.callee.type === "Import")
                  if (t3.arguments.length === 2 && (this.hasPlugin("moduleAttributes") || this.expectPlugin("importAssertions")), t3.arguments.length === 0 || t3.arguments.length > 2)
                    this.raise(h.ImportCallArity, { at: t3, maxArgumentCount: this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? 2 : 1 });
                  else
                    for (let e of t3.arguments)
                      e.type === "SpreadElement" && this.raise(h.ImportCallSpreadArgument, { at: e });
                return this.finishNode(t3, r ? "OptionalCallExpression" : "CallExpression");
              }
              parseCallExpressionArguments(t3, r, e, s, i) {
                let a = [], n = true, o = this.state.inFSharpPipelineDirectBody;
                for (this.state.inFSharpPipelineDirectBody = false; !this.eat(t3); ) {
                  if (n)
                    n = false;
                  else if (this.expect(12), this.match(t3)) {
                    r && !this.hasPlugin("importAssertions") && !this.hasPlugin("moduleAttributes") && this.raise(h.ImportCallArgumentTrailingComma, { at: this.state.lastTokStartLoc }), s && this.addTrailingCommaExtraToNode(s), this.next();
                    break;
                  }
                  a.push(this.parseExprListItem(false, i, e));
                }
                return this.state.inFSharpPipelineDirectBody = o, a;
              }
              shouldParseAsyncArrow() {
                return this.match(19) && !this.canInsertSemicolon();
              }
              parseAsyncArrowFromCallExpression(t3, r) {
                var e;
                return this.resetPreviousNodeTrailingComments(r), this.expect(19), this.parseArrowExpression(t3, r.arguments, true, (e = r.extra) == null ? void 0 : e.trailingCommaLoc), r.innerComments && Xe(t3, r.innerComments), r.callee.trailingComments && Xe(t3, r.callee.trailingComments), t3;
              }
              parseNoCallExpr() {
                let t3 = this.state.startLoc;
                return this.parseSubscripts(this.parseExprAtom(), t3, true);
              }
              parseExprAtom(t3) {
                let r, e = null, { type: s } = this.state;
                switch (s) {
                  case 79:
                    return this.parseSuper();
                  case 83:
                    return r = this.startNode(), this.next(), this.match(16) ? this.parseImportMetaProperty(r) : (this.match(10) || this.raise(h.UnsupportedImport, { at: this.state.lastTokStartLoc }), this.finishNode(r, "Import"));
                  case 78:
                    return r = this.startNode(), this.next(), this.finishNode(r, "ThisExpression");
                  case 90:
                    return this.parseDo(this.startNode(), false);
                  case 56:
                  case 31:
                    return this.readRegexp(), this.parseRegExpLiteral(this.state.value);
                  case 132:
                    return this.parseNumericLiteral(this.state.value);
                  case 133:
                    return this.parseBigIntLiteral(this.state.value);
                  case 134:
                    return this.parseDecimalLiteral(this.state.value);
                  case 131:
                    return this.parseStringLiteral(this.state.value);
                  case 84:
                    return this.parseNullLiteral();
                  case 85:
                    return this.parseBooleanLiteral(true);
                  case 86:
                    return this.parseBooleanLiteral(false);
                  case 10: {
                    let i = this.state.potentialArrowAt === this.state.start;
                    return this.parseParenAndDistinguishExpression(i);
                  }
                  case 2:
                  case 1:
                    return this.parseArrayLike(this.state.type === 2 ? 4 : 3, false, true);
                  case 0:
                    return this.parseArrayLike(3, true, false, t3);
                  case 6:
                  case 7:
                    return this.parseObjectLike(this.state.type === 6 ? 9 : 8, false, true);
                  case 5:
                    return this.parseObjectLike(8, false, false, t3);
                  case 68:
                    return this.parseFunctionOrFunctionSent();
                  case 26:
                    e = this.parseDecorators();
                  case 80:
                    return this.parseClass(this.maybeTakeDecorators(e, this.startNode()), false);
                  case 77:
                    return this.parseNewOrNewTarget();
                  case 25:
                  case 24:
                    return this.parseTemplate(false);
                  case 15: {
                    r = this.startNode(), this.next(), r.object = null;
                    let i = r.callee = this.parseNoCallExpr();
                    if (i.type === "MemberExpression")
                      return this.finishNode(r, "BindExpression");
                    throw this.raise(h.UnsupportedBind, { at: i });
                  }
                  case 136:
                    return this.raise(h.PrivateInExpectedIn, { at: this.state.startLoc, identifierName: this.state.value }), this.parsePrivateName();
                  case 33:
                    return this.parseTopicReferenceThenEqualsSign(54, "%");
                  case 32:
                    return this.parseTopicReferenceThenEqualsSign(44, "^");
                  case 37:
                  case 38:
                    return this.parseTopicReference("hack");
                  case 44:
                  case 54:
                  case 27: {
                    let i = this.getPluginOption("pipelineOperator", "proposal");
                    if (i)
                      return this.parseTopicReference(i);
                    throw this.unexpected();
                  }
                  case 47: {
                    let i = this.input.codePointAt(this.nextTokenStart());
                    if (fe(i) || i === 62) {
                      this.expectOnePlugin(["jsx", "flow", "typescript"]);
                      break;
                    } else
                      throw this.unexpected();
                  }
                  default:
                    if ($(s)) {
                      if (this.isContextual(125) && this.lookaheadCharCode() === 123 && !this.hasFollowingLineBreak())
                        return this.parseModuleExpression();
                      let i = this.state.potentialArrowAt === this.state.start, a = this.state.containsEsc, n = this.parseIdentifier();
                      if (!a && n.name === "async" && !this.canInsertSemicolon()) {
                        let { type: o } = this.state;
                        if (o === 68)
                          return this.resetPreviousNodeTrailingComments(n), this.next(), this.parseFunction(this.startNodeAtNode(n), void 0, true);
                        if ($(o))
                          return this.lookaheadCharCode() === 61 ? this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(n)) : n;
                        if (o === 90)
                          return this.resetPreviousNodeTrailingComments(n), this.parseDo(this.startNodeAtNode(n), true);
                      }
                      return i && this.match(19) && !this.canInsertSemicolon() ? (this.next(), this.parseArrowExpression(this.startNodeAtNode(n), [n], false)) : n;
                    } else
                      throw this.unexpected();
                }
              }
              parseTopicReferenceThenEqualsSign(t3, r) {
                let e = this.getPluginOption("pipelineOperator", "proposal");
                if (e)
                  return this.state.type = t3, this.state.value = r, this.state.pos--, this.state.end--, this.state.endLoc = y(this.state.endLoc, -1), this.parseTopicReference(e);
                throw this.unexpected();
              }
              parseTopicReference(t3) {
                let r = this.startNode(), e = this.state.startLoc, s = this.state.type;
                return this.next(), this.finishTopicReference(r, e, t3, s);
              }
              finishTopicReference(t3, r, e, s) {
                if (this.testTopicReferenceConfiguration(e, r, s)) {
                  let i = e === "smart" ? "PipelinePrimaryTopicReference" : "TopicReference";
                  return this.topicReferenceIsAllowedInCurrentContext() || this.raise(e === "smart" ? h.PrimaryTopicNotAllowed : h.PipeTopicUnbound, { at: r }), this.registerTopicReference(), this.finishNode(t3, i);
                } else
                  throw this.raise(h.PipeTopicUnconfiguredToken, { at: r, token: Pe(s) });
              }
              testTopicReferenceConfiguration(t3, r, e) {
                switch (t3) {
                  case "hack":
                    return this.hasPlugin(["pipelineOperator", { topicToken: Pe(e) }]);
                  case "smart":
                    return e === 27;
                  default:
                    throw this.raise(h.PipeTopicRequiresHackPipes, { at: r });
                }
              }
              parseAsyncArrowUnaryFunction(t3) {
                this.prodParam.enter(Pt(true, this.prodParam.hasYield));
                let r = [this.parseIdentifier()];
                return this.prodParam.exit(), this.hasPrecedingLineBreak() && this.raise(h.LineTerminatorBeforeArrow, { at: this.state.curPosition() }), this.expect(19), this.parseArrowExpression(t3, r, true);
              }
              parseDo(t3, r) {
                this.expectPlugin("doExpressions"), r && this.expectPlugin("asyncDoExpressions"), t3.async = r, this.next();
                let e = this.state.labels;
                return this.state.labels = [], r ? (this.prodParam.enter(gt2), t3.body = this.parseBlock(), this.prodParam.exit()) : t3.body = this.parseBlock(), this.state.labels = e, this.finishNode(t3, "DoExpression");
              }
              parseSuper() {
                let t3 = this.startNode();
                return this.next(), this.match(10) && !this.scope.allowDirectSuper && !this.options.allowSuperOutsideMethod ? this.raise(h.SuperNotAllowed, { at: t3 }) : !this.scope.allowSuper && !this.options.allowSuperOutsideMethod && this.raise(h.UnexpectedSuper, { at: t3 }), !this.match(10) && !this.match(0) && !this.match(16) && this.raise(h.UnsupportedSuper, { at: t3 }), this.finishNode(t3, "Super");
              }
              parsePrivateName() {
                let t3 = this.startNode(), r = this.startNodeAt(y(this.state.startLoc, 1)), e = this.state.value;
                return this.next(), t3.id = this.createIdentifier(r, e), this.finishNode(t3, "PrivateName");
              }
              parseFunctionOrFunctionSent() {
                let t3 = this.startNode();
                if (this.next(), this.prodParam.hasYield && this.match(16)) {
                  let r = this.createIdentifier(this.startNodeAtNode(t3), "function");
                  return this.next(), this.match(102) ? this.expectPlugin("functionSent") : this.hasPlugin("functionSent") || this.unexpected(), this.parseMetaProperty(t3, r, "sent");
                }
                return this.parseFunction(t3);
              }
              parseMetaProperty(t3, r, e) {
                t3.meta = r;
                let s = this.state.containsEsc;
                return t3.property = this.parseIdentifier(true), (t3.property.name !== e || s) && this.raise(h.UnsupportedMetaProperty, { at: t3.property, target: r.name, onlyValidPropertyName: e }), this.finishNode(t3, "MetaProperty");
              }
              parseImportMetaProperty(t3) {
                let r = this.createIdentifier(this.startNodeAtNode(t3), "import");
                return this.next(), this.isContextual(100) && (this.inModule || this.raise(h.ImportMetaOutsideModule, { at: r }), this.sawUnambiguousESM = true), this.parseMetaProperty(t3, r, "meta");
              }
              parseLiteralAtNode(t3, r, e) {
                return this.addExtra(e, "rawValue", t3), this.addExtra(e, "raw", this.input.slice(e.start, this.state.end)), e.value = t3, this.next(), this.finishNode(e, r);
              }
              parseLiteral(t3, r) {
                let e = this.startNode();
                return this.parseLiteralAtNode(t3, r, e);
              }
              parseStringLiteral(t3) {
                return this.parseLiteral(t3, "StringLiteral");
              }
              parseNumericLiteral(t3) {
                return this.parseLiteral(t3, "NumericLiteral");
              }
              parseBigIntLiteral(t3) {
                return this.parseLiteral(t3, "BigIntLiteral");
              }
              parseDecimalLiteral(t3) {
                return this.parseLiteral(t3, "DecimalLiteral");
              }
              parseRegExpLiteral(t3) {
                let r = this.parseLiteral(t3.value, "RegExpLiteral");
                return r.pattern = t3.pattern, r.flags = t3.flags, r;
              }
              parseBooleanLiteral(t3) {
                let r = this.startNode();
                return r.value = t3, this.next(), this.finishNode(r, "BooleanLiteral");
              }
              parseNullLiteral() {
                let t3 = this.startNode();
                return this.next(), this.finishNode(t3, "NullLiteral");
              }
              parseParenAndDistinguishExpression(t3) {
                let r = this.state.startLoc, e;
                this.next(), this.expressionScope.enter(Tl());
                let s = this.state.maybeInArrowParameters, i = this.state.inFSharpPipelineDirectBody;
                this.state.maybeInArrowParameters = true, this.state.inFSharpPipelineDirectBody = false;
                let a = this.state.startLoc, n = [], o = new At(), c = true, p, m;
                for (; !this.match(11); ) {
                  if (c)
                    c = false;
                  else if (this.expect(12, o.optionalParametersLoc === null ? null : o.optionalParametersLoc), this.match(11)) {
                    m = this.state.startLoc;
                    break;
                  }
                  if (this.match(21)) {
                    let b = this.state.startLoc;
                    if (p = this.state.startLoc, n.push(this.parseParenItem(this.parseRestBinding(), b)), !this.checkCommaAfterRest(41))
                      break;
                  } else
                    n.push(this.parseMaybeAssignAllowIn(o, this.parseParenItem));
                }
                let x = this.state.lastTokEndLoc;
                this.expect(11), this.state.maybeInArrowParameters = s, this.state.inFSharpPipelineDirectBody = i;
                let P = this.startNodeAt(r);
                return t3 && this.shouldParseArrow(n) && (P = this.parseArrow(P)) ? (this.checkDestructuringPrivate(o), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), this.parseArrowExpression(P, n, false), P) : (this.expressionScope.exit(), n.length || this.unexpected(this.state.lastTokStartLoc), m && this.unexpected(m), p && this.unexpected(p), this.checkExpressionErrors(o, true), this.toReferencedListDeep(n, true), n.length > 1 ? (e = this.startNodeAt(a), e.expressions = n, this.finishNode(e, "SequenceExpression"), this.resetEndLocation(e, x)) : e = n[0], this.wrapParenthesis(r, e));
              }
              wrapParenthesis(t3, r) {
                if (!this.options.createParenthesizedExpressions)
                  return this.addExtra(r, "parenthesized", true), this.addExtra(r, "parenStart", t3.index), this.takeSurroundingComments(r, t3.index, this.state.lastTokEndLoc.index), r;
                let e = this.startNodeAt(t3);
                return e.expression = r, this.finishNode(e, "ParenthesizedExpression");
              }
              shouldParseArrow(t3) {
                return !this.canInsertSemicolon();
              }
              parseArrow(t3) {
                if (this.eat(19))
                  return t3;
              }
              parseParenItem(t3, r) {
                return t3;
              }
              parseNewOrNewTarget() {
                let t3 = this.startNode();
                if (this.next(), this.match(16)) {
                  let r = this.createIdentifier(this.startNodeAtNode(t3), "new");
                  this.next();
                  let e = this.parseMetaProperty(t3, r, "target");
                  return !this.scope.inNonArrowFunction && !this.scope.inClass && this.raise(h.UnexpectedNewTarget, { at: e }), e;
                }
                return this.parseNew(t3);
              }
              parseNew(t3) {
                if (this.parseNewCallee(t3), this.eat(10)) {
                  let r = this.parseExprList(11);
                  this.toReferencedList(r), t3.arguments = r;
                } else
                  t3.arguments = [];
                return this.finishNode(t3, "NewExpression");
              }
              parseNewCallee(t3) {
                t3.callee = this.parseNoCallExpr(), t3.callee.type === "Import" ? this.raise(h.ImportCallNotNewExpression, { at: t3.callee }) : this.isOptionalChain(t3.callee) ? this.raise(h.OptionalChainingNoNew, { at: this.state.lastTokEndLoc }) : this.eat(18) && this.raise(h.OptionalChainingNoNew, { at: this.state.startLoc });
              }
              parseTemplateElement(t3) {
                let { start: r, startLoc: e, end: s, value: i } = this.state, a = r + 1, n = this.startNodeAt(y(e, 1));
                i === null && (t3 || this.raise(h.InvalidEscapeSequenceTemplate, { at: y(this.state.firstInvalidTemplateEscapePos, 1) }));
                let o = this.match(24), c = o ? -1 : -2, p = s + c;
                n.value = { raw: this.input.slice(a, p).replace(/\r\n?/g, `
`), cooked: i === null ? null : i.slice(1, c) }, n.tail = o, this.next();
                let m = this.finishNode(n, "TemplateElement");
                return this.resetEndLocation(m, y(this.state.lastTokEndLoc, c)), m;
              }
              parseTemplate(t3) {
                let r = this.startNode();
                r.expressions = [];
                let e = this.parseTemplateElement(t3);
                for (r.quasis = [e]; !e.tail; )
                  r.expressions.push(this.parseTemplateSubstitution()), this.readTemplateContinuation(), r.quasis.push(e = this.parseTemplateElement(t3));
                return this.finishNode(r, "TemplateLiteral");
              }
              parseTemplateSubstitution() {
                return this.parseExpression();
              }
              parseObjectLike(t3, r, e, s) {
                e && this.expectPlugin("recordAndTuple");
                let i = this.state.inFSharpPipelineDirectBody;
                this.state.inFSharpPipelineDirectBody = false;
                let a = /* @__PURE__ */ Object.create(null), n = true, o = this.startNode();
                for (o.properties = [], this.next(); !this.match(t3); ) {
                  if (n)
                    n = false;
                  else if (this.expect(12), this.match(t3)) {
                    this.addTrailingCommaExtraToNode(o);
                    break;
                  }
                  let p;
                  r ? p = this.parseBindingProperty() : (p = this.parsePropertyDefinition(s), this.checkProto(p, e, a, s)), e && !this.isObjectProperty(p) && p.type !== "SpreadElement" && this.raise(h.InvalidRecordProperty, { at: p }), p.shorthand && this.addExtra(p, "shorthand", true), o.properties.push(p);
                }
                this.next(), this.state.inFSharpPipelineDirectBody = i;
                let c = "ObjectExpression";
                return r ? c = "ObjectPattern" : e && (c = "RecordExpression"), this.finishNode(o, c);
              }
              addTrailingCommaExtraToNode(t3) {
                this.addExtra(t3, "trailingComma", this.state.lastTokStart), this.addExtra(t3, "trailingCommaLoc", this.state.lastTokStartLoc, false);
              }
              maybeAsyncOrAccessorProp(t3) {
                return !t3.computed && t3.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
              }
              parsePropertyDefinition(t3) {
                let r = [];
                if (this.match(26))
                  for (this.hasPlugin("decorators") && this.raise(h.UnsupportedPropertyDecorator, { at: this.state.startLoc }); this.match(26); )
                    r.push(this.parseDecorator());
                let e = this.startNode(), s = false, i = false, a;
                if (this.match(21))
                  return r.length && this.unexpected(), this.parseSpread();
                r.length && (e.decorators = r, r = []), e.method = false, t3 && (a = this.state.startLoc);
                let n = this.eat(55);
                this.parsePropertyNamePrefixOperator(e);
                let o = this.state.containsEsc, c = this.parsePropertyName(e, t3);
                if (!n && !o && this.maybeAsyncOrAccessorProp(e)) {
                  let p = c.name;
                  p === "async" && !this.hasPrecedingLineBreak() && (s = true, this.resetPreviousNodeTrailingComments(c), n = this.eat(55), this.parsePropertyName(e)), (p === "get" || p === "set") && (i = true, this.resetPreviousNodeTrailingComments(c), e.kind = p, this.match(55) && (n = true, this.raise(h.AccessorIsGenerator, { at: this.state.curPosition(), kind: p }), this.next()), this.parsePropertyName(e));
                }
                return this.parseObjPropValue(e, a, n, s, false, i, t3);
              }
              getGetterSetterExpectedParamCount(t3) {
                return t3.kind === "get" ? 0 : 1;
              }
              getObjectOrClassMethodParams(t3) {
                return t3.params;
              }
              checkGetterSetterParams(t3) {
                var r;
                let e = this.getGetterSetterExpectedParamCount(t3), s = this.getObjectOrClassMethodParams(t3);
                s.length !== e && this.raise(t3.kind === "get" ? h.BadGetterArity : h.BadSetterArity, { at: t3 }), t3.kind === "set" && ((r = s[s.length - 1]) == null ? void 0 : r.type) === "RestElement" && this.raise(h.BadSetterRestParameter, { at: t3 });
              }
              parseObjectMethod(t3, r, e, s, i) {
                if (i) {
                  let a = this.parseMethod(t3, r, false, false, false, "ObjectMethod");
                  return this.checkGetterSetterParams(a), a;
                }
                if (e || r || this.match(10))
                  return s && this.unexpected(), t3.kind = "method", t3.method = true, this.parseMethod(t3, r, e, false, false, "ObjectMethod");
              }
              parseObjectProperty(t3, r, e, s) {
                if (t3.shorthand = false, this.eat(14))
                  return t3.value = e ? this.parseMaybeDefault(this.state.startLoc) : this.parseMaybeAssignAllowIn(s), this.finishNode(t3, "ObjectProperty");
                if (!t3.computed && t3.key.type === "Identifier") {
                  if (this.checkReservedWord(t3.key.name, t3.key.loc.start, true, false), e)
                    t3.value = this.parseMaybeDefault(r, xe(t3.key));
                  else if (this.match(29)) {
                    let i = this.state.startLoc;
                    s != null ? s.shorthandAssignLoc === null && (s.shorthandAssignLoc = i) : this.raise(h.InvalidCoverInitializedName, { at: i }), t3.value = this.parseMaybeDefault(r, xe(t3.key));
                  } else
                    t3.value = xe(t3.key);
                  return t3.shorthand = true, this.finishNode(t3, "ObjectProperty");
                }
              }
              parseObjPropValue(t3, r, e, s, i, a, n) {
                let o = this.parseObjectMethod(t3, e, s, i, a) || this.parseObjectProperty(t3, r, i, n);
                return o || this.unexpected(), o;
              }
              parsePropertyName(t3, r) {
                if (this.eat(0))
                  t3.computed = true, t3.key = this.parseMaybeAssignAllowIn(), this.expect(3);
                else {
                  let { type: e, value: s } = this.state, i;
                  if (pe(e))
                    i = this.parseIdentifier(true);
                  else
                    switch (e) {
                      case 132:
                        i = this.parseNumericLiteral(s);
                        break;
                      case 131:
                        i = this.parseStringLiteral(s);
                        break;
                      case 133:
                        i = this.parseBigIntLiteral(s);
                        break;
                      case 134:
                        i = this.parseDecimalLiteral(s);
                        break;
                      case 136: {
                        let a = this.state.startLoc;
                        r != null ? r.privateKeyLoc === null && (r.privateKeyLoc = a) : this.raise(h.UnexpectedPrivateField, { at: a }), i = this.parsePrivateName();
                        break;
                      }
                      default:
                        throw this.unexpected();
                    }
                  t3.key = i, e !== 136 && (t3.computed = false);
                }
                return t3.key;
              }
              initFunction(t3, r) {
                t3.id = null, t3.generator = false, t3.async = !!r;
              }
              parseMethod(t3, r, e, s, i, a) {
                let n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
                this.initFunction(t3, e), t3.generator = !!r;
                let o = s;
                this.scope.enter(me | lt2 | (n ? Se : 0) | (i ? Ar : 0)), this.prodParam.enter(Pt(e, t3.generator)), this.parseFunctionParams(t3, o);
                let c = this.parseFunctionBodyAndFinish(t3, a, true);
                return this.prodParam.exit(), this.scope.exit(), c;
              }
              parseArrayLike(t3, r, e, s) {
                e && this.expectPlugin("recordAndTuple");
                let i = this.state.inFSharpPipelineDirectBody;
                this.state.inFSharpPipelineDirectBody = false;
                let a = this.startNode();
                return this.next(), a.elements = this.parseExprList(t3, !e, s, a), this.state.inFSharpPipelineDirectBody = i, this.finishNode(a, e ? "TupleExpression" : "ArrayExpression");
              }
              parseArrowExpression(t3, r, e, s) {
                this.scope.enter(me | Yt);
                let i = Pt(e, false);
                !this.match(5) && this.prodParam.hasIn && (i |= Ue), this.prodParam.enter(i), this.initFunction(t3, e);
                let a = this.state.maybeInArrowParameters;
                return r && (this.state.maybeInArrowParameters = true, this.setArrowFunctionParameters(t3, r, s)), this.state.maybeInArrowParameters = false, this.parseFunctionBody(t3, true), this.prodParam.exit(), this.scope.exit(), this.state.maybeInArrowParameters = a, this.finishNode(t3, "ArrowFunctionExpression");
              }
              setArrowFunctionParameters(t3, r, e) {
                this.toAssignableList(r, e, false), t3.params = r;
              }
              parseFunctionBodyAndFinish(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return this.parseFunctionBody(t3, false, e), this.finishNode(t3, r);
              }
              parseFunctionBody(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, s = r && !this.match(5);
                if (this.expressionScope.enter(Rr()), s)
                  t3.body = this.parseMaybeAssign(), this.checkParams(t3, false, r, false);
                else {
                  let i = this.state.strict, a = this.state.labels;
                  this.state.labels = [], this.prodParam.enter(this.prodParam.currentFlags() | qr), t3.body = this.parseBlock(true, false, (n) => {
                    let o = !this.isSimpleParamList(t3.params);
                    n && o && this.raise(h.IllegalLanguageModeDirective, { at: (t3.kind === "method" || t3.kind === "constructor") && !!t3.key ? t3.key.loc.end : t3 });
                    let c = !i && this.state.strict;
                    this.checkParams(t3, !this.state.strict && !r && !e && !o, r, c), this.state.strict && t3.id && this.checkIdentifier(t3.id, Go, c);
                  }), this.prodParam.exit(), this.state.labels = a;
                }
                this.expressionScope.exit();
              }
              isSimpleParameter(t3) {
                return t3.type === "Identifier";
              }
              isSimpleParamList(t3) {
                for (let r = 0, e = t3.length; r < e; r++)
                  if (!this.isSimpleParameter(t3[r]))
                    return false;
                return true;
              }
              checkParams(t3, r, e) {
                let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, i = !r && /* @__PURE__ */ new Set(), a = { type: "FormalParameters" };
                for (let n of t3.params)
                  this.checkLVal(n, { in: a, binding: dt, checkClashes: i, strictModeChanged: s });
              }
              parseExprList(t3, r, e, s) {
                let i = [], a = true;
                for (; !this.eat(t3); ) {
                  if (a)
                    a = false;
                  else if (this.expect(12), this.match(t3)) {
                    s && this.addTrailingCommaExtraToNode(s), this.next();
                    break;
                  }
                  i.push(this.parseExprListItem(r, e));
                }
                return i;
              }
              parseExprListItem(t3, r, e) {
                let s;
                if (this.match(12))
                  t3 || this.raise(h.UnexpectedToken, { at: this.state.curPosition(), unexpected: "," }), s = null;
                else if (this.match(21)) {
                  let i = this.state.startLoc;
                  s = this.parseParenItem(this.parseSpread(r), i);
                } else if (this.match(17)) {
                  this.expectPlugin("partialApplication"), e || this.raise(h.UnexpectedArgumentPlaceholder, { at: this.state.startLoc });
                  let i = this.startNode();
                  this.next(), s = this.finishNode(i, "ArgumentPlaceholder");
                } else
                  s = this.parseMaybeAssignAllowIn(r, this.parseParenItem);
                return s;
              }
              parseIdentifier(t3) {
                let r = this.startNode(), e = this.parseIdentifierName(t3);
                return this.createIdentifier(r, e);
              }
              createIdentifier(t3, r) {
                return t3.name = r, t3.loc.identifierName = r, this.finishNode(t3, "Identifier");
              }
              parseIdentifierName(t3) {
                let r, { startLoc: e, type: s } = this.state;
                if (pe(s))
                  r = this.state.value;
                else
                  throw this.unexpected();
                let i = So(s);
                return t3 ? i && this.replaceToken(130) : this.checkReservedWord(r, e, i, false), this.next(), r;
              }
              checkReservedWord(t3, r, e, s) {
                if (t3.length > 10 || !Vo(t3))
                  return;
                if (t3 === "yield") {
                  if (this.prodParam.hasYield) {
                    this.raise(h.YieldBindingIdentifier, { at: r });
                    return;
                  }
                } else if (t3 === "await") {
                  if (this.prodParam.hasAwait) {
                    this.raise(h.AwaitBindingIdentifier, { at: r });
                    return;
                  }
                  if (this.scope.inStaticBlock) {
                    this.raise(h.AwaitBindingIdentifierInStaticBlock, { at: r });
                    return;
                  }
                  this.expressionScope.recordAsyncArrowParametersError({ at: r });
                } else if (t3 === "arguments" && this.scope.inClassAndNotInNonArrowFunction) {
                  this.raise(h.ArgumentsInClass, { at: r });
                  return;
                }
                if (e && Ho(t3)) {
                  this.raise(h.UnexpectedKeyword, { at: r, keyword: t3 });
                  return;
                }
                (this.state.strict ? s ? gr : yr : mr)(t3, this.inModule) && this.raise(h.UnexpectedReservedWord, { at: r, reservedWord: t3 });
              }
              isAwaitAllowed() {
                return !!(this.prodParam.hasAwait || this.options.allowAwaitOutsideFunction && !this.scope.inFunction);
              }
              parseAwait(t3) {
                let r = this.startNodeAt(t3);
                return this.expressionScope.recordParameterInitializerError(h.AwaitExpressionFormalParameter, { at: r }), this.eat(55) && this.raise(h.ObsoleteAwaitStar, { at: r }), !this.scope.inFunction && !this.options.allowAwaitOutsideFunction && (this.isAmbiguousAwait() ? this.ambiguousScriptDifferentAst = true : this.sawUnambiguousESM = true), this.state.soloAwait || (r.argument = this.parseMaybeUnary(null, true)), this.finishNode(r, "AwaitExpression");
              }
              isAmbiguousAwait() {
                if (this.hasPrecedingLineBreak())
                  return true;
                let { type: t3 } = this.state;
                return t3 === 53 || t3 === 10 || t3 === 0 || ot(t3) || t3 === 135 || t3 === 56 || this.hasPlugin("v8intrinsic") && t3 === 54;
              }
              parseYield() {
                let t3 = this.startNode();
                this.expressionScope.recordParameterInitializerError(h.YieldInParameter, { at: t3 }), this.next();
                let r = false, e = null;
                if (!this.hasPrecedingLineBreak())
                  switch (r = this.eat(55), this.state.type) {
                    case 13:
                    case 137:
                    case 8:
                    case 11:
                    case 3:
                    case 9:
                    case 14:
                    case 12:
                      if (!r)
                        break;
                    default:
                      e = this.parseMaybeAssign();
                  }
                return t3.delegate = r, t3.argument = e, this.finishNode(t3, "YieldExpression");
              }
              checkPipelineAtInfixOperator(t3, r) {
                this.hasPlugin(["pipelineOperator", { proposal: "smart" }]) && t3.type === "SequenceExpression" && this.raise(h.PipelineHeadSequenceExpression, { at: r });
              }
              parseSmartPipelineBodyInStyle(t3, r) {
                if (this.isSimpleReference(t3)) {
                  let e = this.startNodeAt(r);
                  return e.callee = t3, this.finishNode(e, "PipelineBareFunction");
                } else {
                  let e = this.startNodeAt(r);
                  return this.checkSmartPipeTopicBodyEarlyErrors(r), e.expression = t3, this.finishNode(e, "PipelineTopicExpression");
                }
              }
              isSimpleReference(t3) {
                switch (t3.type) {
                  case "MemberExpression":
                    return !t3.computed && this.isSimpleReference(t3.object);
                  case "Identifier":
                    return true;
                  default:
                    return false;
                }
              }
              checkSmartPipeTopicBodyEarlyErrors(t3) {
                if (this.match(19))
                  throw this.raise(h.PipelineBodyNoArrow, { at: this.state.startLoc });
                this.topicReferenceWasUsedInCurrentContext() || this.raise(h.PipelineTopicUnused, { at: t3 });
              }
              withTopicBindingContext(t3) {
                let r = this.state.topicContext;
                this.state.topicContext = { maxNumOfResolvableTopics: 1, maxTopicIndex: null };
                try {
                  return t3();
                } finally {
                  this.state.topicContext = r;
                }
              }
              withSmartMixTopicForbiddingContext(t3) {
                if (this.hasPlugin(["pipelineOperator", { proposal: "smart" }])) {
                  let r = this.state.topicContext;
                  this.state.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null };
                  try {
                    return t3();
                  } finally {
                    this.state.topicContext = r;
                  }
                } else
                  return t3();
              }
              withSoloAwaitPermittingContext(t3) {
                let r = this.state.soloAwait;
                this.state.soloAwait = true;
                try {
                  return t3();
                } finally {
                  this.state.soloAwait = r;
                }
              }
              allowInAnd(t3) {
                let r = this.prodParam.currentFlags();
                if (Ue & ~r) {
                  this.prodParam.enter(r | Ue);
                  try {
                    return t3();
                  } finally {
                    this.prodParam.exit();
                  }
                }
                return t3();
              }
              disallowInAnd(t3) {
                let r = this.prodParam.currentFlags();
                if (Ue & r) {
                  this.prodParam.enter(r & ~Ue);
                  try {
                    return t3();
                  } finally {
                    this.prodParam.exit();
                  }
                }
                return t3();
              }
              registerTopicReference() {
                this.state.topicContext.maxTopicIndex = 0;
              }
              topicReferenceIsAllowedInCurrentContext() {
                return this.state.topicContext.maxNumOfResolvableTopics >= 1;
              }
              topicReferenceWasUsedInCurrentContext() {
                return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
              }
              parseFSharpPipelineBody(t3) {
                let r = this.state.startLoc;
                this.state.potentialArrowAt = this.state.start;
                let e = this.state.inFSharpPipelineDirectBody;
                this.state.inFSharpPipelineDirectBody = true;
                let s = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), r, t3);
                return this.state.inFSharpPipelineDirectBody = e, s;
              }
              parseModuleExpression() {
                this.expectPlugin("moduleBlocks");
                let t3 = this.startNode();
                this.next(), this.match(5) || this.unexpected(null, 5);
                let r = this.startNodeAt(this.state.endLoc);
                this.next();
                let e = this.initializeScopes(true);
                this.enterInitialScopes();
                try {
                  t3.body = this.parseProgram(r, 8, "module");
                } finally {
                  e();
                }
                return this.finishNode(t3, "ModuleExpression");
              }
              parsePropertyNamePrefixOperator(t3) {
              }
            }, fs = { kind: "loop" }, Ql = { kind: "switch" }, Zl = 0, ms = 1, Qr = 2, Zr = 4, eh = /[\uD800-\uDFFF]/u, ys = /in(?:stanceof)?/y;
            function th(t3, r) {
              for (let e = 0; e < t3.length; e++) {
                let s = t3[e], { type: i } = s;
                if (typeof i == "number") {
                  {
                    if (i === 136) {
                      let { loc: a, start: n, value: o, end: c } = s, p = n + 1, m = y(a.start, 1);
                      t3.splice(e, 1, new ve({ type: de(27), value: "#", start: n, end: p, startLoc: a.start, endLoc: m }), new ve({ type: de(130), value: o, start: p, end: c, startLoc: m, endLoc: a.end })), e++;
                      continue;
                    }
                    if (ot(i)) {
                      let { loc: a, start: n, value: o, end: c } = s, p = n + 1, m = y(a.start, 1), x;
                      r.charCodeAt(n) === 96 ? x = new ve({ type: de(22), value: "`", start: n, end: p, startLoc: a.start, endLoc: m }) : x = new ve({ type: de(8), value: "}", start: n, end: p, startLoc: a.start, endLoc: m });
                      let P, b, O, R;
                      i === 24 ? (b = c - 1, O = y(a.end, -1), P = o === null ? null : o.slice(1, -1), R = new ve({ type: de(22), value: "`", start: b, end: c, startLoc: O, endLoc: a.end })) : (b = c - 2, O = y(a.end, -2), P = o === null ? null : o.slice(1, -2), R = new ve({ type: de(23), value: "${", start: b, end: c, startLoc: O, endLoc: a.end })), t3.splice(e, 1, x, new ve({ type: de(20), value: P, start: p, end: b, startLoc: m, endLoc: O }), R), e += 2;
                      continue;
                    }
                  }
                  s.type = de(i);
                }
              }
              return t3;
            }
            var sh = class extends Yl {
              parseTopLevel(t3, r) {
                return t3.program = this.parseProgram(r), t3.comments = this.state.comments, this.options.tokens && (t3.tokens = th(this.tokens, this.input)), this.finishNode(t3, "File");
              }
              parseProgram(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 137, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.options.sourceType;
                if (t3.sourceType = e, t3.interpreter = this.parseInterpreterDirective(), this.parseBlockBody(t3, true, true, r), this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0)
                  for (let [i, a] of Array.from(this.scope.undefinedExports))
                    this.raise(h.ModuleExportUndefined, { at: a, localName: i });
                let s;
                return r === 137 ? s = this.finishNode(t3, "Program") : s = this.finishNodeAt(t3, "Program", y(this.state.startLoc, -1)), s;
              }
              stmtToDirective(t3) {
                let r = t3;
                r.type = "Directive", r.value = r.expression, delete r.expression;
                let e = r.value, s = e.value, i = this.input.slice(e.start, e.end), a = e.value = i.slice(1, -1);
                return this.addExtra(e, "raw", i), this.addExtra(e, "rawValue", a), this.addExtra(e, "expressionValue", s), e.type = "DirectiveLiteral", r;
              }
              parseInterpreterDirective() {
                if (!this.match(28))
                  return null;
                let t3 = this.startNode();
                return t3.value = this.state.value, this.next(), this.finishNode(t3, "InterpreterDirective");
              }
              isLet(t3) {
                return this.isContextual(99) ? this.hasFollowingIdentifier(t3) : false;
              }
              hasFollowingIdentifier(t3) {
                let r = this.nextTokenStart(), e = this.codePointAtPos(r);
                if (e === 92 || e === 91)
                  return true;
                if (t3)
                  return false;
                if (e === 123)
                  return true;
                if (fe(e)) {
                  if (ys.lastIndex = r, ys.test(this.input)) {
                    let s = this.codePointAtPos(ys.lastIndex);
                    if (!Be(s) && s !== 92)
                      return false;
                  }
                  return true;
                }
                return false;
              }
              startsUsingForOf() {
                let t3 = this.lookahead();
                return t3.type === 101 && !t3.containsEsc ? false : (this.expectPlugin("explicitResourceManagement"), true);
              }
              parseStatement(t3, r) {
                let e = null;
                return this.match(26) && (e = this.parseDecorators(true)), this.parseStatementContent(t3, r, e);
              }
              parseStatementContent(t3, r, e) {
                let s = this.state.type, i = this.startNode();
                switch (s) {
                  case 60:
                    return this.parseBreakContinueStatement(i, true);
                  case 63:
                    return this.parseBreakContinueStatement(i, false);
                  case 64:
                    return this.parseDebuggerStatement(i);
                  case 90:
                    return this.parseDoStatement(i);
                  case 91:
                    return this.parseForStatement(i);
                  case 68:
                    if (this.lookaheadCharCode() === 46)
                      break;
                    return t3 && (this.state.strict ? this.raise(h.StrictFunction, { at: this.state.startLoc }) : t3 !== "if" && t3 !== "label" && this.raise(h.SloppyFunction, { at: this.state.startLoc })), this.parseFunctionStatement(i, false, !t3);
                  case 80:
                    return t3 && this.unexpected(), this.parseClass(this.maybeTakeDecorators(e, i), true);
                  case 69:
                    return this.parseIfStatement(i);
                  case 70:
                    return this.parseReturnStatement(i);
                  case 71:
                    return this.parseSwitchStatement(i);
                  case 72:
                    return this.parseThrowStatement(i);
                  case 73:
                    return this.parseTryStatement(i);
                  case 105:
                    if (this.hasFollowingLineBreak())
                      break;
                  case 99:
                    if (this.state.containsEsc || !this.hasFollowingIdentifier(t3))
                      break;
                  case 75:
                  case 74: {
                    let o = this.state.value;
                    return o === "using" && (this.expectPlugin("explicitResourceManagement"), !this.scope.inModule && this.scope.inTopLevel && this.raise(h.UnexpectedUsingDeclaration, { at: this.state.startLoc })), t3 && o !== "var" && this.raise(h.UnexpectedLexicalDeclaration, { at: this.state.startLoc }), this.parseVarStatement(i, o);
                  }
                  case 92:
                    return this.parseWhileStatement(i);
                  case 76:
                    return this.parseWithStatement(i);
                  case 5:
                    return this.parseBlock();
                  case 13:
                    return this.parseEmptyStatement(i);
                  case 83: {
                    let o = this.lookaheadCharCode();
                    if (o === 40 || o === 46)
                      break;
                  }
                  case 82: {
                    !this.options.allowImportExportEverywhere && !r && this.raise(h.UnexpectedImportExport, { at: this.state.startLoc }), this.next();
                    let o;
                    return s === 83 ? (o = this.parseImport(i), o.type === "ImportDeclaration" && (!o.importKind || o.importKind === "value") && (this.sawUnambiguousESM = true)) : (o = this.parseExport(i, e), (o.type === "ExportNamedDeclaration" && (!o.exportKind || o.exportKind === "value") || o.type === "ExportAllDeclaration" && (!o.exportKind || o.exportKind === "value") || o.type === "ExportDefaultDeclaration") && (this.sawUnambiguousESM = true)), this.assertModuleNodeAllowed(o), o;
                  }
                  default:
                    if (this.isAsyncFunction())
                      return t3 && this.raise(h.AsyncFunctionInSingleStatementContext, { at: this.state.startLoc }), this.next(), this.parseFunctionStatement(i, true, !t3);
                }
                let a = this.state.value, n = this.parseExpression();
                return $(s) && n.type === "Identifier" && this.eat(14) ? this.parseLabeledStatement(i, a, n, t3) : this.parseExpressionStatement(i, n, e);
              }
              assertModuleNodeAllowed(t3) {
                !this.options.allowImportExportEverywhere && !this.inModule && this.raise(h.ImportOutsideModule, { at: t3 });
              }
              decoratorsEnabledBeforeExport() {
                return this.hasPlugin("decorators-legacy") ? true : this.hasPlugin("decorators") && !!this.getPluginOption("decorators", "decoratorsBeforeExport");
              }
              maybeTakeDecorators(t3, r, e) {
                return t3 && (r.decorators = t3, this.resetStartLocationFromNode(r, t3[0]), e && this.resetStartLocationFromNode(e, r)), r;
              }
              canHaveLeadingDecorator() {
                return this.match(80);
              }
              parseDecorators(t3) {
                let r = [];
                do
                  r.push(this.parseDecorator());
                while (this.match(26));
                if (this.match(82))
                  t3 || this.unexpected(), this.decoratorsEnabledBeforeExport() || this.raise(h.DecoratorExportClass, { at: this.state.startLoc });
                else if (!this.canHaveLeadingDecorator())
                  throw this.raise(h.UnexpectedLeadingDecorator, { at: this.state.startLoc });
                return r;
              }
              parseDecorator() {
                this.expectOnePlugin(["decorators", "decorators-legacy"]);
                let t3 = this.startNode();
                if (this.next(), this.hasPlugin("decorators")) {
                  let r = this.state.startLoc, e;
                  if (this.match(10)) {
                    let s = this.state.startLoc;
                    this.next(), e = this.parseExpression(), this.expect(11), e = this.wrapParenthesis(s, e);
                    let i = this.state.startLoc;
                    t3.expression = this.parseMaybeDecoratorArguments(e), this.getPluginOption("decorators", "allowCallParenthesized") === false && t3.expression !== e && this.raise(h.DecoratorArgumentsOutsideParentheses, { at: i });
                  } else {
                    for (e = this.parseIdentifier(false); this.eat(16); ) {
                      let s = this.startNodeAt(r);
                      s.object = e, this.match(136) ? (this.classScope.usePrivateName(this.state.value, this.state.startLoc), s.property = this.parsePrivateName()) : s.property = this.parseIdentifier(true), s.computed = false, e = this.finishNode(s, "MemberExpression");
                    }
                    t3.expression = this.parseMaybeDecoratorArguments(e);
                  }
                } else
                  t3.expression = this.parseExprSubscripts();
                return this.finishNode(t3, "Decorator");
              }
              parseMaybeDecoratorArguments(t3) {
                if (this.eat(10)) {
                  let r = this.startNodeAtNode(t3);
                  return r.callee = t3, r.arguments = this.parseCallExpressionArguments(11, false), this.toReferencedList(r.arguments), this.finishNode(r, "CallExpression");
                }
                return t3;
              }
              parseBreakContinueStatement(t3, r) {
                return this.next(), this.isLineTerminator() ? t3.label = null : (t3.label = this.parseIdentifier(), this.semicolon()), this.verifyBreakContinue(t3, r), this.finishNode(t3, r ? "BreakStatement" : "ContinueStatement");
              }
              verifyBreakContinue(t3, r) {
                let e;
                for (e = 0; e < this.state.labels.length; ++e) {
                  let s = this.state.labels[e];
                  if ((t3.label == null || s.name === t3.label.name) && (s.kind != null && (r || s.kind === "loop") || t3.label && r))
                    break;
                }
                if (e === this.state.labels.length) {
                  let s = r ? "BreakStatement" : "ContinueStatement";
                  this.raise(h.IllegalBreakContinue, { at: t3, type: s });
                }
              }
              parseDebuggerStatement(t3) {
                return this.next(), this.semicolon(), this.finishNode(t3, "DebuggerStatement");
              }
              parseHeaderExpression() {
                this.expect(10);
                let t3 = this.parseExpression();
                return this.expect(11), t3;
              }
              parseDoStatement(t3) {
                return this.next(), this.state.labels.push(fs), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("do")), this.state.labels.pop(), this.expect(92), t3.test = this.parseHeaderExpression(), this.eat(13), this.finishNode(t3, "DoWhileStatement");
              }
              parseForStatement(t3) {
                this.next(), this.state.labels.push(fs);
                let r = null;
                if (this.isAwaitAllowed() && this.eatContextual(96) && (r = this.state.lastTokStartLoc), this.scope.enter(_e), this.expect(10), this.match(13))
                  return r !== null && this.unexpected(r), this.parseFor(t3, null);
                let e = this.isContextual(99), s = this.isContextual(105) && !this.hasFollowingLineBreak(), i = e && this.hasFollowingIdentifier() || s && this.hasFollowingIdentifier() && this.startsUsingForOf();
                if (this.match(74) || this.match(75) || i) {
                  let p = this.startNode(), m = this.state.value;
                  this.next(), this.parseVar(p, true, m);
                  let x = this.finishNode(p, "VariableDeclaration"), P = this.match(58);
                  return P && s && this.raise(h.ForInUsing, { at: x }), (P || this.isContextual(101)) && x.declarations.length === 1 ? this.parseForIn(t3, x, r) : (r !== null && this.unexpected(r), this.parseFor(t3, x));
                }
                let a = this.isContextual(95), n = new At(), o = this.parseExpression(true, n), c = this.isContextual(101);
                if (c && (e && this.raise(h.ForOfLet, { at: o }), r === null && a && o.type === "Identifier" && this.raise(h.ForOfAsync, { at: o })), c || this.match(58)) {
                  this.checkDestructuringPrivate(n), this.toAssignable(o, true);
                  let p = c ? "ForOfStatement" : "ForInStatement";
                  return this.checkLVal(o, { in: { type: p } }), this.parseForIn(t3, o, r);
                } else
                  this.checkExpressionErrors(n, true);
                return r !== null && this.unexpected(r), this.parseFor(t3, o);
              }
              parseFunctionStatement(t3, r, e) {
                return this.next(), this.parseFunction(t3, ms | (e ? 0 : Qr), r);
              }
              parseIfStatement(t3) {
                return this.next(), t3.test = this.parseHeaderExpression(), t3.consequent = this.parseStatement("if"), t3.alternate = this.eat(66) ? this.parseStatement("if") : null, this.finishNode(t3, "IfStatement");
              }
              parseReturnStatement(t3) {
                return !this.prodParam.hasReturn && !this.options.allowReturnOutsideFunction && this.raise(h.IllegalReturn, { at: this.state.startLoc }), this.next(), this.isLineTerminator() ? t3.argument = null : (t3.argument = this.parseExpression(), this.semicolon()), this.finishNode(t3, "ReturnStatement");
              }
              parseSwitchStatement(t3) {
                this.next(), t3.discriminant = this.parseHeaderExpression();
                let r = t3.cases = [];
                this.expect(5), this.state.labels.push(Ql), this.scope.enter(_e);
                let e;
                for (let s; !this.match(8); )
                  if (this.match(61) || this.match(65)) {
                    let i = this.match(61);
                    e && this.finishNode(e, "SwitchCase"), r.push(e = this.startNode()), e.consequent = [], this.next(), i ? e.test = this.parseExpression() : (s && this.raise(h.MultipleDefaultsInSwitch, { at: this.state.lastTokStartLoc }), s = true, e.test = null), this.expect(14);
                  } else
                    e ? e.consequent.push(this.parseStatement(null)) : this.unexpected();
                return this.scope.exit(), e && this.finishNode(e, "SwitchCase"), this.next(), this.state.labels.pop(), this.finishNode(t3, "SwitchStatement");
              }
              parseThrowStatement(t3) {
                return this.next(), this.hasPrecedingLineBreak() && this.raise(h.NewlineAfterThrow, { at: this.state.lastTokEndLoc }), t3.argument = this.parseExpression(), this.semicolon(), this.finishNode(t3, "ThrowStatement");
              }
              parseCatchClauseParam() {
                let t3 = this.parseBindingAtom(), r = t3.type === "Identifier";
                return this.scope.enter(r ? Pr : 0), this.checkLVal(t3, { in: { type: "CatchClause" }, binding: Ie, allowingSloppyLetBinding: true }), t3;
              }
              parseTryStatement(t3) {
                if (this.next(), t3.block = this.parseBlock(), t3.handler = null, this.match(62)) {
                  let r = this.startNode();
                  this.next(), this.match(10) ? (this.expect(10), r.param = this.parseCatchClauseParam(), this.expect(11)) : (r.param = null, this.scope.enter(_e)), r.body = this.withSmartMixTopicForbiddingContext(() => this.parseBlock(false, false)), this.scope.exit(), t3.handler = this.finishNode(r, "CatchClause");
                }
                return t3.finalizer = this.eat(67) ? this.parseBlock() : null, !t3.handler && !t3.finalizer && this.raise(h.NoCatchOrFinally, { at: t3 }), this.finishNode(t3, "TryStatement");
              }
              parseVarStatement(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return this.next(), this.parseVar(t3, false, r, e), this.semicolon(), this.finishNode(t3, "VariableDeclaration");
              }
              parseWhileStatement(t3) {
                return this.next(), t3.test = this.parseHeaderExpression(), this.state.labels.push(fs), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("while")), this.state.labels.pop(), this.finishNode(t3, "WhileStatement");
              }
              parseWithStatement(t3) {
                return this.state.strict && this.raise(h.StrictWith, { at: this.state.startLoc }), this.next(), t3.object = this.parseHeaderExpression(), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("with")), this.finishNode(t3, "WithStatement");
              }
              parseEmptyStatement(t3) {
                return this.next(), this.finishNode(t3, "EmptyStatement");
              }
              parseLabeledStatement(t3, r, e, s) {
                for (let a of this.state.labels)
                  a.name === r && this.raise(h.LabelRedeclaration, { at: e, labelName: r });
                let i = No(this.state.type) ? "loop" : this.match(71) ? "switch" : null;
                for (let a = this.state.labels.length - 1; a >= 0; a--) {
                  let n = this.state.labels[a];
                  if (n.statementStart === t3.start)
                    n.statementStart = this.state.start, n.kind = i;
                  else
                    break;
                }
                return this.state.labels.push({ name: r, kind: i, statementStart: this.state.start }), t3.body = this.parseStatement(s ? s.indexOf("label") === -1 ? s + "label" : s : "label"), this.state.labels.pop(), t3.label = e, this.finishNode(t3, "LabeledStatement");
              }
              parseExpressionStatement(t3, r, e) {
                return t3.expression = r, this.semicolon(), this.finishNode(t3, "ExpressionStatement");
              }
              parseBlock() {
                let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, e = arguments.length > 2 ? arguments[2] : void 0, s = this.startNode();
                return t3 && this.state.strictErrors.clear(), this.expect(5), r && this.scope.enter(_e), this.parseBlockBody(s, t3, false, 8, e), r && this.scope.exit(), this.finishNode(s, "BlockStatement");
              }
              isValidDirective(t3) {
                return t3.type === "ExpressionStatement" && t3.expression.type === "StringLiteral" && !t3.expression.extra.parenthesized;
              }
              parseBlockBody(t3, r, e, s, i) {
                let a = t3.body = [], n = t3.directives = [];
                this.parseBlockOrModuleBlockBody(a, r ? n : void 0, e, s, i);
              }
              parseBlockOrModuleBlockBody(t3, r, e, s, i) {
                let a = this.state.strict, n = false, o = false;
                for (; !this.match(s); ) {
                  let c = this.parseStatement(null, e);
                  if (r && !o) {
                    if (this.isValidDirective(c)) {
                      let p = this.stmtToDirective(c);
                      r.push(p), !n && p.value.value === "use strict" && (n = true, this.setStrict(true));
                      continue;
                    }
                    o = true, this.state.strictErrors.clear();
                  }
                  t3.push(c);
                }
                i && i.call(this, n), a || this.setStrict(false), this.next();
              }
              parseFor(t3, r) {
                return t3.init = r, this.semicolon(false), t3.test = this.match(13) ? null : this.parseExpression(), this.semicolon(false), t3.update = this.match(11) ? null : this.parseExpression(), this.expect(11), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("for")), this.scope.exit(), this.state.labels.pop(), this.finishNode(t3, "ForStatement");
              }
              parseForIn(t3, r, e) {
                let s = this.match(58);
                return this.next(), s ? e !== null && this.unexpected(e) : t3.await = e !== null, r.type === "VariableDeclaration" && r.declarations[0].init != null && (!s || this.state.strict || r.kind !== "var" || r.declarations[0].id.type !== "Identifier") && this.raise(h.ForInOfLoopInitializer, { at: r, type: s ? "ForInStatement" : "ForOfStatement" }), r.type === "AssignmentPattern" && this.raise(h.InvalidLhs, { at: r, ancestor: { type: "ForStatement" } }), t3.left = r, t3.right = s ? this.parseExpression() : this.parseMaybeAssignAllowIn(), this.expect(11), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("for")), this.scope.exit(), this.state.labels.pop(), this.finishNode(t3, s ? "ForInStatement" : "ForOfStatement");
              }
              parseVar(t3, r, e) {
                let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, i = t3.declarations = [];
                for (t3.kind = e; ; ) {
                  let a = this.startNode();
                  if (this.parseVarId(a, e), a.init = this.eat(29) ? r ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn() : null, a.init === null && !s && (a.id.type !== "Identifier" && !(r && (this.match(58) || this.isContextual(101))) ? this.raise(h.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "destructuring" }) : e === "const" && !(this.match(58) || this.isContextual(101)) && this.raise(h.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "const" })), i.push(this.finishNode(a, "VariableDeclarator")), !this.eat(12))
                    break;
                }
                return t3;
              }
              parseVarId(t3, r) {
                let e = this.parseBindingAtom();
                r === "using" && e.type !== "Identifier" && this.raise(h.UsingDeclarationHasBindingPattern, { at: e }), this.checkLVal(e, { in: { type: "VariableDeclarator" }, binding: r === "var" ? dt : Ie }), t3.id = e;
              }
              parseFunction(t3) {
                let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Zl, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, s = r & ms, i = r & Qr, a = !!s && !(r & Zr);
                this.initFunction(t3, e), this.match(55) && i && this.raise(h.GeneratorInSingleStatementContext, { at: this.state.startLoc }), t3.generator = this.eat(55), s && (t3.id = this.parseFunctionId(a));
                let n = this.state.maybeInArrowParameters;
                return this.state.maybeInArrowParameters = false, this.scope.enter(me), this.prodParam.enter(Pt(e, t3.generator)), s || (t3.id = this.parseFunctionId()), this.parseFunctionParams(t3, false), this.withSmartMixTopicForbiddingContext(() => {
                  this.parseFunctionBodyAndFinish(t3, s ? "FunctionDeclaration" : "FunctionExpression");
                }), this.prodParam.exit(), this.scope.exit(), s && !i && this.registerFunctionStatementId(t3), this.state.maybeInArrowParameters = n, t3;
              }
              parseFunctionId(t3) {
                return t3 || $(this.state.type) ? this.parseIdentifier() : null;
              }
              parseFunctionParams(t3, r) {
                this.expect(10), this.expressionScope.enter(Al()), t3.params = this.parseBindingList(11, 41, false, r), this.expressionScope.exit();
              }
              registerFunctionStatementId(t3) {
                !t3.id || this.scope.declareName(t3.id.name, this.state.strict || t3.generator || t3.async ? this.scope.treatFunctionsAsVar ? dt : Ie : Cr, t3.id.loc.start);
              }
              parseClass(t3, r, e) {
                this.next();
                let s = this.state.strict;
                return this.state.strict = true, this.parseClassId(t3, r, e), this.parseClassSuper(t3), t3.body = this.parseClassBody(!!t3.superClass, s), this.finishNode(t3, r ? "ClassDeclaration" : "ClassExpression");
              }
              isClassProperty() {
                return this.match(29) || this.match(13) || this.match(8);
              }
              isClassMethod() {
                return this.match(10);
              }
              isNonstaticConstructor(t3) {
                return !t3.computed && !t3.static && (t3.key.name === "constructor" || t3.key.value === "constructor");
              }
              parseClassBody(t3, r) {
                this.classScope.enter();
                let e = { hadConstructor: false, hadSuperClass: t3 }, s = [], i = this.startNode();
                if (i.body = [], this.expect(5), this.withSmartMixTopicForbiddingContext(() => {
                  for (; !this.match(8); ) {
                    if (this.eat(13)) {
                      if (s.length > 0)
                        throw this.raise(h.DecoratorSemicolon, { at: this.state.lastTokEndLoc });
                      continue;
                    }
                    if (this.match(26)) {
                      s.push(this.parseDecorator());
                      continue;
                    }
                    let a = this.startNode();
                    s.length && (a.decorators = s, this.resetStartLocationFromNode(a, s[0]), s = []), this.parseClassMember(i, a, e), a.kind === "constructor" && a.decorators && a.decorators.length > 0 && this.raise(h.DecoratorConstructor, { at: a });
                  }
                }), this.state.strict = r, this.next(), s.length)
                  throw this.raise(h.TrailingDecorator, { at: this.state.startLoc });
                return this.classScope.exit(), this.finishNode(i, "ClassBody");
              }
              parseClassMemberFromModifier(t3, r) {
                let e = this.parseIdentifier(true);
                if (this.isClassMethod()) {
                  let s = r;
                  return s.kind = "method", s.computed = false, s.key = e, s.static = false, this.pushClassMethod(t3, s, false, false, false, false), true;
                } else if (this.isClassProperty()) {
                  let s = r;
                  return s.computed = false, s.key = e, s.static = false, t3.body.push(this.parseClassProperty(s)), true;
                }
                return this.resetPreviousNodeTrailingComments(e), false;
              }
              parseClassMember(t3, r, e) {
                let s = this.isContextual(104);
                if (s) {
                  if (this.parseClassMemberFromModifier(t3, r))
                    return;
                  if (this.eat(5)) {
                    this.parseClassStaticBlock(t3, r);
                    return;
                  }
                }
                this.parseClassMemberWithIsStatic(t3, r, e, s);
              }
              parseClassMemberWithIsStatic(t3, r, e, s) {
                let i = r, a = r, n = r, o = r, c = r, p = i, m = i;
                if (r.static = s, this.parsePropertyNamePrefixOperator(r), this.eat(55)) {
                  p.kind = "method";
                  let R = this.match(136);
                  if (this.parseClassElementName(p), R) {
                    this.pushClassPrivateMethod(t3, a, true, false);
                    return;
                  }
                  this.isNonstaticConstructor(i) && this.raise(h.ConstructorIsGenerator, { at: i.key }), this.pushClassMethod(t3, i, true, false, false, false);
                  return;
                }
                let x = $(this.state.type) && !this.state.containsEsc, P = this.match(136), b = this.parseClassElementName(r), O = this.state.startLoc;
                if (this.parsePostMemberNameModifiers(m), this.isClassMethod()) {
                  if (p.kind = "method", P) {
                    this.pushClassPrivateMethod(t3, a, false, false);
                    return;
                  }
                  let R = this.isNonstaticConstructor(i), Q = false;
                  R && (i.kind = "constructor", e.hadConstructor && !this.hasPlugin("typescript") && this.raise(h.DuplicateConstructor, { at: b }), R && this.hasPlugin("typescript") && r.override && this.raise(h.OverrideOnConstructor, { at: b }), e.hadConstructor = true, Q = e.hadSuperClass), this.pushClassMethod(t3, i, false, false, R, Q);
                } else if (this.isClassProperty())
                  P ? this.pushClassPrivateProperty(t3, o) : this.pushClassProperty(t3, n);
                else if (x && b.name === "async" && !this.isLineTerminator()) {
                  this.resetPreviousNodeTrailingComments(b);
                  let R = this.eat(55);
                  m.optional && this.unexpected(O), p.kind = "method";
                  let Q = this.match(136);
                  this.parseClassElementName(p), this.parsePostMemberNameModifiers(m), Q ? this.pushClassPrivateMethod(t3, a, R, true) : (this.isNonstaticConstructor(i) && this.raise(h.ConstructorIsAsync, { at: i.key }), this.pushClassMethod(t3, i, R, true, false, false));
                } else if (x && (b.name === "get" || b.name === "set") && !(this.match(55) && this.isLineTerminator())) {
                  this.resetPreviousNodeTrailingComments(b), p.kind = b.name;
                  let R = this.match(136);
                  this.parseClassElementName(i), R ? this.pushClassPrivateMethod(t3, a, false, false) : (this.isNonstaticConstructor(i) && this.raise(h.ConstructorIsAccessor, { at: i.key }), this.pushClassMethod(t3, i, false, false, false, false)), this.checkGetterSetterParams(i);
                } else if (x && b.name === "accessor" && !this.isLineTerminator()) {
                  this.expectPlugin("decoratorAutoAccessors"), this.resetPreviousNodeTrailingComments(b);
                  let R = this.match(136);
                  this.parseClassElementName(n), this.pushClassAccessorProperty(t3, c, R);
                } else
                  this.isLineTerminator() ? P ? this.pushClassPrivateProperty(t3, o) : this.pushClassProperty(t3, n) : this.unexpected();
              }
              parseClassElementName(t3) {
                let { type: r, value: e } = this.state;
                if ((r === 130 || r === 131) && t3.static && e === "prototype" && this.raise(h.StaticPrototype, { at: this.state.startLoc }), r === 136) {
                  e === "constructor" && this.raise(h.ConstructorClassPrivateField, { at: this.state.startLoc });
                  let s = this.parsePrivateName();
                  return t3.key = s, s;
                }
                return this.parsePropertyName(t3);
              }
              parseClassStaticBlock(t3, r) {
                var e;
                this.scope.enter(Se | ht | lt2);
                let s = this.state.labels;
                this.state.labels = [], this.prodParam.enter(qe);
                let i = r.body = [];
                this.parseBlockOrModuleBlockBody(i, void 0, false, 8), this.prodParam.exit(), this.scope.exit(), this.state.labels = s, t3.body.push(this.finishNode(r, "StaticBlock")), (e = r.decorators) != null && e.length && this.raise(h.DecoratorStaticBlock, { at: r });
              }
              pushClassProperty(t3, r) {
                !r.computed && (r.key.name === "constructor" || r.key.value === "constructor") && this.raise(h.ConstructorClassField, { at: r.key }), t3.body.push(this.parseClassProperty(r));
              }
              pushClassPrivateProperty(t3, r) {
                let e = this.parseClassPrivateProperty(r);
                t3.body.push(e), this.classScope.declarePrivateName(this.getPrivateNameSV(e.key), as, e.key.loc.start);
              }
              pushClassAccessorProperty(t3, r, e) {
                if (!e && !r.computed) {
                  let i = r.key;
                  (i.name === "constructor" || i.value === "constructor") && this.raise(h.ConstructorClassField, { at: i });
                }
                let s = this.parseClassAccessorProperty(r);
                t3.body.push(s), e && this.classScope.declarePrivateName(this.getPrivateNameSV(s.key), as, s.key.loc.start);
              }
              pushClassMethod(t3, r, e, s, i, a) {
                t3.body.push(this.parseMethod(r, e, s, i, a, "ClassMethod", true));
              }
              pushClassPrivateMethod(t3, r, e, s) {
                let i = this.parseMethod(r, e, s, false, false, "ClassPrivateMethod", true);
                t3.body.push(i);
                let a = i.kind === "get" ? i.static ? Qo : el : i.kind === "set" ? i.static ? Zo : tl : as;
                this.declareClassPrivateMethodInScope(i, a);
              }
              declareClassPrivateMethodInScope(t3, r) {
                this.classScope.declarePrivateName(this.getPrivateNameSV(t3.key), r, t3.key.loc.start);
              }
              parsePostMemberNameModifiers(t3) {
              }
              parseClassPrivateProperty(t3) {
                return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassPrivateProperty");
              }
              parseClassProperty(t3) {
                return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassProperty");
              }
              parseClassAccessorProperty(t3) {
                return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassAccessorProperty");
              }
              parseInitializer(t3) {
                this.scope.enter(Se | lt2), this.expressionScope.enter(Rr()), this.prodParam.enter(qe), t3.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null, this.expressionScope.exit(), this.prodParam.exit(), this.scope.exit();
              }
              parseClassId(t3, r, e) {
                let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Er;
                if ($(this.state.type))
                  t3.id = this.parseIdentifier(), r && this.declareNameFromIdentifier(t3.id, s);
                else if (e || !r)
                  t3.id = null;
                else
                  throw this.raise(h.MissingClassName, { at: this.state.startLoc });
              }
              parseClassSuper(t3) {
                t3.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
              }
              parseExport(t3, r) {
                let e = this.maybeParseExportDefaultSpecifier(t3), s = !e || this.eat(12), i = s && this.eatExportStar(t3), a = i && this.maybeParseExportNamespaceSpecifier(t3), n = s && (!a || this.eat(12)), o = e || i;
                if (i && !a) {
                  if (e && this.unexpected(), r)
                    throw this.raise(h.UnsupportedDecoratorExport, { at: t3 });
                  return this.parseExportFrom(t3, true), this.finishNode(t3, "ExportAllDeclaration");
                }
                let c = this.maybeParseExportNamedSpecifiers(t3);
                if (e && s && !i && !c || a && n && !c)
                  throw this.unexpected(null, 5);
                let p;
                if (o || c) {
                  if (p = false, r)
                    throw this.raise(h.UnsupportedDecoratorExport, { at: t3 });
                  this.parseExportFrom(t3, o);
                } else
                  p = this.maybeParseExportDeclaration(t3);
                if (o || c || p) {
                  var m;
                  let x = t3;
                  if (this.checkExport(x, true, false, !!x.source), ((m = x.declaration) == null ? void 0 : m.type) === "ClassDeclaration")
                    this.maybeTakeDecorators(r, x.declaration, x);
                  else if (r)
                    throw this.raise(h.UnsupportedDecoratorExport, { at: t3 });
                  return this.finishNode(x, "ExportNamedDeclaration");
                }
                if (this.eat(65)) {
                  let x = t3, P = this.parseExportDefaultExpression();
                  if (x.declaration = P, P.type === "ClassDeclaration")
                    this.maybeTakeDecorators(r, P, x);
                  else if (r)
                    throw this.raise(h.UnsupportedDecoratorExport, { at: t3 });
                  return this.checkExport(x, true, true), this.finishNode(x, "ExportDefaultDeclaration");
                }
                throw this.unexpected(null, 5);
              }
              eatExportStar(t3) {
                return this.eat(55);
              }
              maybeParseExportDefaultSpecifier(t3) {
                if (this.isExportDefaultSpecifier()) {
                  this.expectPlugin("exportDefaultFrom");
                  let r = this.startNode();
                  return r.exported = this.parseIdentifier(true), t3.specifiers = [this.finishNode(r, "ExportDefaultSpecifier")], true;
                }
                return false;
              }
              maybeParseExportNamespaceSpecifier(t3) {
                if (this.isContextual(93)) {
                  t3.specifiers || (t3.specifiers = []);
                  let r = this.startNodeAt(this.state.lastTokStartLoc);
                  return this.next(), r.exported = this.parseModuleExportName(), t3.specifiers.push(this.finishNode(r, "ExportNamespaceSpecifier")), true;
                }
                return false;
              }
              maybeParseExportNamedSpecifiers(t3) {
                if (this.match(5)) {
                  t3.specifiers || (t3.specifiers = []);
                  let r = t3.exportKind === "type";
                  return t3.specifiers.push(...this.parseExportSpecifiers(r)), t3.source = null, t3.declaration = null, this.hasPlugin("importAssertions") && (t3.assertions = []), true;
                }
                return false;
              }
              maybeParseExportDeclaration(t3) {
                return this.shouldParseExportDeclaration() ? (t3.specifiers = [], t3.source = null, this.hasPlugin("importAssertions") && (t3.assertions = []), t3.declaration = this.parseExportDeclaration(t3), true) : false;
              }
              isAsyncFunction() {
                if (!this.isContextual(95))
                  return false;
                let t3 = this.nextTokenStart();
                return !ls.test(this.input.slice(this.state.pos, t3)) && this.isUnparsedContextual(t3, "function");
              }
              parseExportDefaultExpression() {
                let t3 = this.startNode(), r = this.isAsyncFunction();
                if (this.match(68) || r)
                  return this.next(), r && this.next(), this.parseFunction(t3, ms | Zr, r);
                if (this.match(80))
                  return this.parseClass(t3, true, true);
                if (this.match(26))
                  return this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") && this.raise(h.DecoratorBeforeExport, { at: this.state.startLoc }), this.parseClass(this.maybeTakeDecorators(this.parseDecorators(false), this.startNode()), true, true);
                if (this.match(75) || this.match(74) || this.isLet())
                  throw this.raise(h.UnsupportedDefaultExport, { at: this.state.startLoc });
                let e = this.parseMaybeAssignAllowIn();
                return this.semicolon(), e;
              }
              parseExportDeclaration(t3) {
                return this.match(80) ? this.parseClass(this.startNode(), true, false) : this.parseStatement(null);
              }
              isExportDefaultSpecifier() {
                let { type: t3 } = this.state;
                if ($(t3)) {
                  if (t3 === 95 && !this.state.containsEsc || t3 === 99)
                    return false;
                  if ((t3 === 128 || t3 === 127) && !this.state.containsEsc) {
                    let { type: s } = this.lookahead();
                    if ($(s) && s !== 97 || s === 5)
                      return this.expectOnePlugin(["flow", "typescript"]), false;
                  }
                } else if (!this.match(65))
                  return false;
                let r = this.nextTokenStart(), e = this.isUnparsedContextual(r, "from");
                if (this.input.charCodeAt(r) === 44 || $(this.state.type) && e)
                  return true;
                if (this.match(65) && e) {
                  let s = this.input.charCodeAt(this.nextTokenStartSince(r + 4));
                  return s === 34 || s === 39;
                }
                return false;
              }
              parseExportFrom(t3, r) {
                if (this.eatContextual(97)) {
                  t3.source = this.parseImportSource(), this.checkExport(t3);
                  let e = this.maybeParseImportAssertions();
                  e && (t3.assertions = e, this.checkJSONModuleImport(t3));
                } else
                  r && this.unexpected();
                this.semicolon();
              }
              shouldParseExportDeclaration() {
                let { type: t3 } = this.state;
                if (t3 === 26 && (this.expectOnePlugin(["decorators", "decorators-legacy"]), this.hasPlugin("decorators"))) {
                  if (this.getPluginOption("decorators", "decoratorsBeforeExport"))
                    throw this.raise(h.DecoratorBeforeExport, { at: this.state.startLoc });
                  return true;
                }
                return t3 === 74 || t3 === 75 || t3 === 68 || t3 === 80 || this.isLet() || this.isAsyncFunction();
              }
              checkExport(t3, r, e, s) {
                if (r) {
                  if (e) {
                    if (this.checkDuplicateExports(t3, "default"), this.hasPlugin("exportDefaultFrom")) {
                      var i;
                      let a = t3.declaration;
                      a.type === "Identifier" && a.name === "from" && a.end - a.start === 4 && !((i = a.extra) != null && i.parenthesized) && this.raise(h.ExportDefaultFromAsIdentifier, { at: a });
                    }
                  } else if (t3.specifiers && t3.specifiers.length)
                    for (let a of t3.specifiers) {
                      let { exported: n } = a, o = n.type === "Identifier" ? n.name : n.value;
                      if (this.checkDuplicateExports(a, o), !s && a.local) {
                        let { local: c } = a;
                        c.type !== "Identifier" ? this.raise(h.ExportBindingIsString, { at: a, localName: c.value, exportName: o }) : (this.checkReservedWord(c.name, c.loc.start, true, false), this.scope.checkLocalExport(c));
                      }
                    }
                  else if (t3.declaration) {
                    if (t3.declaration.type === "FunctionDeclaration" || t3.declaration.type === "ClassDeclaration") {
                      let a = t3.declaration.id;
                      if (!a)
                        throw new Error("Assertion failure");
                      this.checkDuplicateExports(t3, a.name);
                    } else if (t3.declaration.type === "VariableDeclaration")
                      for (let a of t3.declaration.declarations)
                        this.checkDeclaration(a.id);
                  }
                }
              }
              checkDeclaration(t3) {
                if (t3.type === "Identifier")
                  this.checkDuplicateExports(t3, t3.name);
                else if (t3.type === "ObjectPattern")
                  for (let r of t3.properties)
                    this.checkDeclaration(r);
                else if (t3.type === "ArrayPattern")
                  for (let r of t3.elements)
                    r && this.checkDeclaration(r);
                else
                  t3.type === "ObjectProperty" ? this.checkDeclaration(t3.value) : t3.type === "RestElement" ? this.checkDeclaration(t3.argument) : t3.type === "AssignmentPattern" && this.checkDeclaration(t3.left);
              }
              checkDuplicateExports(t3, r) {
                this.exportedIdentifiers.has(r) && (r === "default" ? this.raise(h.DuplicateDefaultExport, { at: t3 }) : this.raise(h.DuplicateExport, { at: t3, exportName: r })), this.exportedIdentifiers.add(r);
              }
              parseExportSpecifiers(t3) {
                let r = [], e = true;
                for (this.expect(5); !this.eat(8); ) {
                  if (e)
                    e = false;
                  else if (this.expect(12), this.eat(8))
                    break;
                  let s = this.isContextual(128), i = this.match(131), a = this.startNode();
                  a.local = this.parseModuleExportName(), r.push(this.parseExportSpecifier(a, i, t3, s));
                }
                return r;
              }
              parseExportSpecifier(t3, r, e, s) {
                return this.eatContextual(93) ? t3.exported = this.parseModuleExportName() : r ? t3.exported = Sl(t3.local) : t3.exported || (t3.exported = xe(t3.local)), this.finishNode(t3, "ExportSpecifier");
              }
              parseModuleExportName() {
                if (this.match(131)) {
                  let t3 = this.parseStringLiteral(this.state.value), r = t3.value.match(eh);
                  return r && this.raise(h.ModuleExportNameHasLoneSurrogate, { at: t3, surrogateCharCode: r[0].charCodeAt(0) }), t3;
                }
                return this.parseIdentifier(true);
              }
              isJSONModuleImport(t3) {
                return t3.assertions != null ? t3.assertions.some((r) => {
                  let { key: e, value: s } = r;
                  return s.value === "json" && (e.type === "Identifier" ? e.name === "type" : e.value === "type");
                }) : false;
              }
              checkImportReflection(t3) {
                if (t3.module) {
                  var r;
                  (t3.specifiers.length !== 1 || t3.specifiers[0].type !== "ImportDefaultSpecifier") && this.raise(h.ImportReflectionNotBinding, { at: t3.specifiers[0].loc.start }), ((r = t3.assertions) == null ? void 0 : r.length) > 0 && this.raise(h.ImportReflectionHasAssertion, { at: t3.specifiers[0].loc.start });
                }
              }
              checkJSONModuleImport(t3) {
                if (this.isJSONModuleImport(t3) && t3.type !== "ExportAllDeclaration") {
                  let { specifiers: r } = t3;
                  if (r != null) {
                    let e = r.find((s) => {
                      let i;
                      if (s.type === "ExportSpecifier" ? i = s.local : s.type === "ImportSpecifier" && (i = s.imported), i !== void 0)
                        return i.type === "Identifier" ? i.name !== "default" : i.value !== "default";
                    });
                    e !== void 0 && this.raise(h.ImportJSONBindingNotDefault, { at: e.loc.start });
                  }
                }
              }
              parseMaybeImportReflection(t3) {
                let r = false;
                if (this.isContextual(125)) {
                  let e = this.lookahead();
                  $(e.type) ? (e.type !== 97 || this.input.charCodeAt(this.nextTokenStartSince(e.end)) === 102) && (r = true) : r = true;
                }
                r ? (this.expectPlugin("importReflection"), this.next(), t3.module = true) : this.hasPlugin("importReflection") && (t3.module = false);
              }
              parseImport(t3) {
                if (t3.specifiers = [], !this.match(131)) {
                  this.parseMaybeImportReflection(t3);
                  let s = !this.maybeParseDefaultImportSpecifier(t3) || this.eat(12), i = s && this.maybeParseStarImportSpecifier(t3);
                  s && !i && this.parseNamedImportSpecifiers(t3), this.expectContextual(97);
                }
                t3.source = this.parseImportSource();
                let r = this.maybeParseImportAssertions();
                if (r)
                  t3.assertions = r;
                else {
                  let e = this.maybeParseModuleAttributes();
                  e && (t3.attributes = e);
                }
                return this.checkImportReflection(t3), this.checkJSONModuleImport(t3), this.semicolon(), this.finishNode(t3, "ImportDeclaration");
              }
              parseImportSource() {
                return this.match(131) || this.unexpected(), this.parseExprAtom();
              }
              shouldParseDefaultImport(t3) {
                return $(this.state.type);
              }
              parseImportSpecifierLocal(t3, r, e) {
                r.local = this.parseIdentifier(), t3.specifiers.push(this.finishImportSpecifier(r, e));
              }
              finishImportSpecifier(t3, r) {
                let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ie;
                return this.checkLVal(t3.local, { in: t3, binding: e }), this.finishNode(t3, r);
              }
              parseAssertEntries() {
                let t3 = [], r = /* @__PURE__ */ new Set();
                do {
                  if (this.match(8))
                    break;
                  let e = this.startNode(), s = this.state.value;
                  if (r.has(s) && this.raise(h.ModuleAttributesWithDuplicateKeys, { at: this.state.startLoc, key: s }), r.add(s), this.match(131) ? e.key = this.parseStringLiteral(s) : e.key = this.parseIdentifier(true), this.expect(14), !this.match(131))
                    throw this.raise(h.ModuleAttributeInvalidValue, { at: this.state.startLoc });
                  e.value = this.parseStringLiteral(this.state.value), t3.push(this.finishNode(e, "ImportAttribute"));
                } while (this.eat(12));
                return t3;
              }
              maybeParseModuleAttributes() {
                if (this.match(76) && !this.hasPrecedingLineBreak())
                  this.expectPlugin("moduleAttributes"), this.next();
                else
                  return this.hasPlugin("moduleAttributes") ? [] : null;
                let t3 = [], r = /* @__PURE__ */ new Set();
                do {
                  let e = this.startNode();
                  if (e.key = this.parseIdentifier(true), e.key.name !== "type" && this.raise(h.ModuleAttributeDifferentFromType, { at: e.key }), r.has(e.key.name) && this.raise(h.ModuleAttributesWithDuplicateKeys, { at: e.key, key: e.key.name }), r.add(e.key.name), this.expect(14), !this.match(131))
                    throw this.raise(h.ModuleAttributeInvalidValue, { at: this.state.startLoc });
                  e.value = this.parseStringLiteral(this.state.value), this.finishNode(e, "ImportAttribute"), t3.push(e);
                } while (this.eat(12));
                return t3;
              }
              maybeParseImportAssertions() {
                if (this.isContextual(94) && !this.hasPrecedingLineBreak())
                  this.expectPlugin("importAssertions"), this.next();
                else
                  return this.hasPlugin("importAssertions") ? [] : null;
                this.eat(5);
                let t3 = this.parseAssertEntries();
                return this.eat(8), t3;
              }
              maybeParseDefaultImportSpecifier(t3) {
                return this.shouldParseDefaultImport(t3) ? (this.parseImportSpecifierLocal(t3, this.startNode(), "ImportDefaultSpecifier"), true) : false;
              }
              maybeParseStarImportSpecifier(t3) {
                if (this.match(55)) {
                  let r = this.startNode();
                  return this.next(), this.expectContextual(93), this.parseImportSpecifierLocal(t3, r, "ImportNamespaceSpecifier"), true;
                }
                return false;
              }
              parseNamedImportSpecifiers(t3) {
                let r = true;
                for (this.expect(5); !this.eat(8); ) {
                  if (r)
                    r = false;
                  else {
                    if (this.eat(14))
                      throw this.raise(h.DestructureNamedImport, { at: this.state.startLoc });
                    if (this.expect(12), this.eat(8))
                      break;
                  }
                  let e = this.startNode(), s = this.match(131), i = this.isContextual(128);
                  e.imported = this.parseModuleExportName();
                  let a = this.parseImportSpecifier(e, s, t3.importKind === "type" || t3.importKind === "typeof", i, void 0);
                  t3.specifiers.push(a);
                }
              }
              parseImportSpecifier(t3, r, e, s, i) {
                if (this.eatContextual(93))
                  t3.local = this.parseIdentifier();
                else {
                  let { imported: a } = t3;
                  if (r)
                    throw this.raise(h.ImportBindingIsString, { at: t3, importName: a.value });
                  this.checkReservedWord(a.name, t3.loc.start, true, true), t3.local || (t3.local = xe(a));
                }
                return this.finishImportSpecifier(t3, "ImportSpecifier", i);
              }
              isThisParam(t3) {
                return t3.type === "Identifier" && t3.name === "this";
              }
            }, ei = class extends sh {
              constructor(t3, r) {
                t3 = Gl(t3), super(t3, r), this.options = t3, this.initializeScopes(), this.plugins = rh(this.options.plugins), this.filename = t3.sourceFilename;
              }
              getScopeHandler() {
                return os;
              }
              parse() {
                this.enterInitialScopes();
                let t3 = this.startNode(), r = this.startNode();
                return this.nextToken(), t3.errors = null, this.parseTopLevel(t3, r), t3.errors = this.state.errors, t3;
              }
            };
            function rh(t3) {
              let r = /* @__PURE__ */ new Map();
              for (let e of t3) {
                let [s, i] = Array.isArray(e) ? e : [e, {}];
                r.has(s) || r.set(s, i || {});
              }
              return r;
            }
            function ih(t3, r) {
              var e;
              if (((e = r) == null ? void 0 : e.sourceType) === "unambiguous") {
                r = Object.assign({}, r);
                try {
                  r.sourceType = "module";
                  let s = et(r, t3), i = s.parse();
                  if (s.sawUnambiguousESM)
                    return i;
                  if (s.ambiguousScriptDifferentAst)
                    try {
                      return r.sourceType = "script", et(r, t3).parse();
                    } catch {
                    }
                  else
                    i.program.sourceType = "script";
                  return i;
                } catch (s) {
                  try {
                    return r.sourceType = "script", et(r, t3).parse();
                  } catch {
                  }
                  throw s;
                }
              } else
                return et(r, t3).parse();
            }
            function ah(t3, r) {
              let e = et(r, t3);
              return e.options.strictMode && (e.state.strict = true), e.getExpression();
            }
            function nh(t3) {
              let r = {};
              for (let e of Object.keys(t3))
                r[e] = de(t3[e]);
              return r;
            }
            var oh = nh(bo);
            function et(t3, r) {
              let e = ei;
              return t3 != null && t3.plugins && (Kl(t3.plugins), e = lh(t3.plugins)), new e(t3, r);
            }
            var ti = {};
            function lh(t3) {
              let r = Wl.filter((i) => se(t3, i)), e = r.join("/"), s = ti[e];
              if (!s) {
                s = ei;
                for (let i of r)
                  s = Jr[i](s);
                ti[e] = s;
              }
              return s;
            }
            l.parse = ih, l.parseExpression = ah, l.tokTypes = oh;
          } }), Td = K({ "src/language-js/parse/json.js"(l, u) {
            "use strict";
            V();
            var d = lr(), f = hr(), y = xo(), A = go();
            function g() {
              let E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { allowComments: L = true } = E;
              return function(k) {
                let { parseExpression: z } = To(), G;
                try {
                  G = z(k, { tokens: true, ranges: true });
                } catch (B) {
                  throw A(B);
                }
                if (!L && d(G.comments))
                  throw T(G.comments[0], "Comment");
                return S(G), G;
              };
            }
            function T(E, L) {
              let [j, k] = [E.loc.start, E.loc.end].map((z) => {
                let { line: G, column: B } = z;
                return { line: G, column: B + 1 };
              });
              return f(`${L} is not allowed in JSON.`, { start: j, end: k });
            }
            function S(E) {
              switch (E.type) {
                case "ArrayExpression":
                  for (let L of E.elements)
                    L !== null && S(L);
                  return;
                case "ObjectExpression":
                  for (let L of E.properties)
                    S(L);
                  return;
                case "ObjectProperty":
                  if (E.computed)
                    throw T(E.key, "Computed key");
                  if (E.shorthand)
                    throw T(E.key, "Shorthand property");
                  E.key.type !== "Identifier" && S(E.key), S(E.value);
                  return;
                case "UnaryExpression": {
                  let { operator: L, argument: j } = E;
                  if (L !== "+" && L !== "-")
                    throw T(E, `Operator '${E.operator}'`);
                  if (j.type === "NumericLiteral" || j.type === "Identifier" && (j.name === "Infinity" || j.name === "NaN"))
                    return;
                  throw T(j, `Operator '${L}' before '${j.type}'`);
                }
                case "Identifier":
                  if (E.name !== "Infinity" && E.name !== "NaN" && E.name !== "undefined")
                    throw T(E, `Identifier '${E.name}'`);
                  return;
                case "TemplateLiteral":
                  if (d(E.expressions))
                    throw T(E.expressions[0], "'TemplateLiteral' with expression");
                  for (let L of E.quasis)
                    S(L);
                  return;
                case "NullLiteral":
                case "BooleanLiteral":
                case "NumericLiteral":
                case "StringLiteral":
                case "TemplateElement":
                  return;
                default:
                  throw T(E, `'${E.type}'`);
              }
            }
            var F = g(), I = { json: y({ parse: F, hasPragma() {
              return true;
            } }), json5: y(F), "json-stringify": y({ parse: g({ allowComments: false }), astFormat: "estree-json" }) };
            u.exports = I;
          } });
          V();
          var vd = sd(), Ed = eo(), Cd = nd(), Ve = xo(), bd = go(), Sd = Ad(), wd = Td(), Id = { sourceType: "module", allowImportExportEverywhere: true, allowReturnOutsideFunction: true, allowSuperOutsideMethod: true, allowUndeclaredExports: true, errorRecovery: true, createParenthesizedExpressions: true, plugins: ["doExpressions", "exportDefaultFrom", "functionBind", "functionSent", "throwExpressions", "partialApplication", ["decorators", { decoratorsBeforeExport: false }], "importAssertions", "decimal", "moduleBlocks", "asyncDoExpressions", "regexpUnicodeSets", "destructuringPrivate", "decoratorAutoAccessors"], tokens: true, ranges: true }, Nd = ["recordAndTuple", { syntaxType: "hash" }], Gn = "v8intrinsic", Jn = [["pipelineOperator", { proposal: "hack", topicToken: "%" }], ["pipelineOperator", { proposal: "minimal" }], ["pipelineOperator", { proposal: "fsharp" }]], ue = function(l) {
            let u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Id;
            return Object.assign(Object.assign({}, u), {}, { plugins: [...u.plugins, ...l] });
          }, kd = /@(?:no)?flow\b/;
          function Dd(l, u) {
            if (u.filepath && u.filepath.endsWith(".js.flow"))
              return true;
            let d = Ed(l);
            d && (l = l.slice(d.length));
            let f = Cd(l, 0);
            return f !== false && (l = l.slice(0, f)), kd.test(l);
          }
          function Fd(l, u, d) {
            let y = To()[l](u, d), A = y.errors.find((g) => !Rd.has(g.reasonCode));
            if (A)
              throw A;
            return y;
          }
          function Ke(l) {
            for (var u = arguments.length, d = new Array(u > 1 ? u - 1 : 0), f = 1; f < u; f++)
              d[f - 1] = arguments[f];
            return function(y, A) {
              let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              if ((g.parser === "babel" || g.parser === "__babel_estree") && Dd(y, g))
                return g.parser = "babel-flow", vo(y, A, g);
              let T = d;
              g.__babelSourceType === "script" && (T = T.map((E) => Object.assign(Object.assign({}, E), {}, { sourceType: "script" }))), /#[[{]/.test(y) && (T = T.map((E) => ue([Nd], E)));
              let S = /%[A-Z]/.test(y);
              y.includes("|>") ? T = (S ? [...Jn, Gn] : Jn).flatMap((L) => T.map((j) => ue([L], j))) : S && (T = T.map((E) => ue([Gn], E)));
              let { result: F, error: I } = vd(...T.map((E) => () => Fd(l, y, E)));
              if (!F)
                throw bd(I);
              return g.originalText = y, Sd(F, g);
            };
          }
          var Ld = Ke("parse", ue(["jsx", "flow"])), vo = Ke("parse", ue(["jsx", ["flow", { all: true, enums: true }]])), Od = Ke("parse", ue(["jsx", "typescript"]), ue(["typescript"])), Md = Ke("parse", ue(["jsx", "flow", "estree"])), Bd = Ke("parseExpression", ue(["jsx"])), _d = Ke("parseExpression", ue(["typescript"])), Rd = /* @__PURE__ */ new Set(["StrictNumericEscape", "StrictWith", "StrictOctalLiteral", "StrictDelete", "StrictEvalArguments", "StrictEvalArgumentsBinding", "StrictFunction", "EmptyTypeArguments", "EmptyTypeParameters", "ConstructorHasTypeParameters", "UnsupportedParameterPropertyKind", "UnexpectedParameterModifier", "MixedLabeledAndUnlabeledElements", "InvalidTupleMemberLabel", "NonClassMethodPropertyHasAbstractModifer", "ReadonlyForMethodSignature", "ClassMethodHasDeclare", "ClassMethodHasReadonly", "InvalidModifierOnTypeMember", "DuplicateAccessibilityModifier", "IndexSignatureHasDeclare", "DecoratorExportClass", "ParamDupe", "InvalidDecimal", "RestTrailingComma", "UnsupportedParameterDecorator", "UnterminatedJsxContent", "UnexpectedReservedWord", "ModuleAttributesWithDuplicateKeys", "LineTerminatorBeforeArrow", "InvalidEscapeSequenceTemplate", "NonAbstractClassHasAbstractMethod", "UnsupportedPropertyDecorator", "OptionalTypeBeforeRequired", "PatternIsOptional", "OptionalBindingPattern", "DeclareClassFieldHasInitializer", "TypeImportCannotSpecifyDefaultAndNamed", "DeclareFunctionHasImplementation", "ConstructorClassField", "VarRedeclaration", "InvalidPrivateFieldResolution", "DuplicateExport"]), Xn = Ve(Ld), Yn = Ve(Od), Qn = Ve(Bd), jd = Ve(_d);
          Eo.exports = { parsers: Object.assign(Object.assign({ babel: Xn, "babel-flow": Ve(vo), "babel-ts": Yn }, wd), {}, { __js_expression: Qn, __vue_expression: Qn, __vue_ts_expression: jd, __vue_event_binding: Xn, __vue_ts_event_binding: Yn, __babel_estree: Ve(Md) }) };
        });
        return qd();
      });
    }
  });

  // node_modules/prettier/parser-postcss.js
  var require_parser_postcss = __commonJS({
    "node_modules/prettier/parser-postcss.js"(exports2, module2) {
      init_define_process();
      (function(e) {
        if (typeof exports2 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var i = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          i.prettierPlugins = i.prettierPlugins || {}, i.prettierPlugins.postcss = e();
        }
      })(function() {
        "use strict";
        var V = (e, n) => () => (n || e((n = { exports: {} }).exports, n), n.exports);
        var ee = V((pp, Ut) => {
          var er = function(e) {
            return e && e.Math == Math && e;
          };
          Ut.exports = er(typeof globalThis == "object" && globalThis) || er(typeof window == "object" && window) || er(typeof self == "object" && self) || er(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var ke = V((hp, Wt) => {
          Wt.exports = function(e) {
            try {
              return !!e();
            } catch {
              return true;
            }
          };
        });
        var Te = V((dp, $t) => {
          var fa = ke();
          $t.exports = !fa(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var Sr = V((vp, Vt) => {
          var pa = ke();
          Vt.exports = !pa(function() {
            var e = function() {
            }.bind();
            return typeof e != "function" || e.hasOwnProperty("prototype");
          });
        });
        var tr = V((mp, Gt) => {
          var ha = Sr(), rr = Function.prototype.call;
          Gt.exports = ha ? rr.bind(rr) : function() {
            return rr.apply(rr, arguments);
          };
        });
        var Qt = V((Kt) => {
          "use strict";
          var Ht = {}.propertyIsEnumerable, Jt = Object.getOwnPropertyDescriptor, da = Jt && !Ht.call({ 1: 2 }, 1);
          Kt.f = da ? function(n) {
            var i = Jt(this, n);
            return !!i && i.enumerable;
          } : Ht;
        });
        var Or = V((yp, Yt) => {
          Yt.exports = function(e, n) {
            return { enumerable: !(e & 1), configurable: !(e & 2), writable: !(e & 4), value: n };
          };
        });
        var de = V((wp, en) => {
          var Xt = Sr(), Zt = Function.prototype, va = Zt.bind, Tr = Zt.call, ma = Xt && va.bind(Tr, Tr);
          en.exports = Xt ? function(e) {
            return e && ma(e);
          } : function(e) {
            return e && function() {
              return Tr.apply(e, arguments);
            };
          };
        });
        var nn = V((_p, tn) => {
          var rn = de(), ga = rn({}.toString), ya = rn("".slice);
          tn.exports = function(e) {
            return ya(ga(e), 8, -1);
          };
        });
        var on = V((bp, sn) => {
          var wa = ee(), _a = de(), ba = ke(), xa = nn(), Er = wa.Object, ka = _a("".split);
          sn.exports = ba(function() {
            return !Er("z").propertyIsEnumerable(0);
          }) ? function(e) {
            return xa(e) == "String" ? ka(e, "") : Er(e);
          } : Er;
        });
        var qr = V((xp, an) => {
          var Sa = ee(), Oa = Sa.TypeError;
          an.exports = function(e) {
            if (e == null)
              throw Oa("Can't call method on " + e);
            return e;
          };
        });
        var nr = V((kp, un) => {
          var Ta = on(), Ea = qr();
          un.exports = function(e) {
            return Ta(Ea(e));
          };
        });
        var ve = V((Sp, cn) => {
          cn.exports = function(e) {
            return typeof e == "function";
          };
        });
        var Me = V((Op, ln) => {
          var qa = ve();
          ln.exports = function(e) {
            return typeof e == "object" ? e !== null : qa(e);
          };
        });
        var ir = V((Tp, fn) => {
          var Ar = ee(), Aa = ve(), Pa = function(e) {
            return Aa(e) ? e : void 0;
          };
          fn.exports = function(e, n) {
            return arguments.length < 2 ? Pa(Ar[e]) : Ar[e] && Ar[e][n];
          };
        });
        var hn = V((Ep, pn) => {
          var Ra = de();
          pn.exports = Ra({}.isPrototypeOf);
        });
        var vn = V((qp, dn) => {
          var Ia = ir();
          dn.exports = Ia("navigator", "userAgent") || "";
        });
        var xn = V((Ap, bn) => {
          var _n = ee(), Pr = vn(), mn = _n.process, gn = _n.Deno, yn = mn && mn.versions || gn && gn.version, wn = yn && yn.v8, he, sr;
          wn && (he = wn.split("."), sr = he[0] > 0 && he[0] < 4 ? 1 : +(he[0] + he[1]));
          !sr && Pr && (he = Pr.match(/Edge\/(\d+)/), (!he || he[1] >= 74) && (he = Pr.match(/Chrome\/(\d+)/), he && (sr = +he[1])));
          bn.exports = sr;
        });
        var Rr = V((Pp, Sn) => {
          var kn = xn(), Ca = ke();
          Sn.exports = !!Object.getOwnPropertySymbols && !Ca(function() {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && kn && kn < 41;
          });
        });
        var Ir = V((Rp, On) => {
          var Na = Rr();
          On.exports = Na && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var Cr = V((Ip, Tn) => {
          var ja = ee(), Ma = ir(), Da = ve(), La = hn(), za = Ir(), Ba = ja.Object;
          Tn.exports = za ? function(e) {
            return typeof e == "symbol";
          } : function(e) {
            var n = Ma("Symbol");
            return Da(n) && La(n.prototype, Ba(e));
          };
        });
        var qn = V((Cp, En) => {
          var Fa = ee(), Ua = Fa.String;
          En.exports = function(e) {
            try {
              return Ua(e);
            } catch {
              return "Object";
            }
          };
        });
        var Pn = V((Np, An) => {
          var Wa = ee(), $a = ve(), Va = qn(), Ga = Wa.TypeError;
          An.exports = function(e) {
            if ($a(e))
              return e;
            throw Ga(Va(e) + " is not a function");
          };
        });
        var In = V((jp, Rn) => {
          var Ha = Pn();
          Rn.exports = function(e, n) {
            var i = e[n];
            return i == null ? void 0 : Ha(i);
          };
        });
        var Nn = V((Mp, Cn) => {
          var Ja = ee(), Nr = tr(), jr = ve(), Mr = Me(), Ka = Ja.TypeError;
          Cn.exports = function(e, n) {
            var i, c;
            if (n === "string" && jr(i = e.toString) && !Mr(c = Nr(i, e)) || jr(i = e.valueOf) && !Mr(c = Nr(i, e)) || n !== "string" && jr(i = e.toString) && !Mr(c = Nr(i, e)))
              return c;
            throw Ka("Can't convert object to primitive value");
          };
        });
        var Mn = V((Dp, jn) => {
          jn.exports = false;
        });
        var or = V((Lp, Ln) => {
          var Dn = ee(), Qa = Object.defineProperty;
          Ln.exports = function(e, n) {
            try {
              Qa(Dn, e, { value: n, configurable: true, writable: true });
            } catch {
              Dn[e] = n;
            }
            return n;
          };
        });
        var ar = V((zp, Bn) => {
          var Ya = ee(), Xa = or(), zn = "__core-js_shared__", Za = Ya[zn] || Xa(zn, {});
          Bn.exports = Za;
        });
        var Dr = V((Bp, Un) => {
          var eu = Mn(), Fn = ar();
          (Un.exports = function(e, n) {
            return Fn[e] || (Fn[e] = n !== void 0 ? n : {});
          })("versions", []).push({ version: "3.22.2", mode: eu ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.22.2/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var $n = V((Fp, Wn) => {
          var ru = ee(), tu = qr(), nu = ru.Object;
          Wn.exports = function(e) {
            return nu(tu(e));
          };
        });
        var Se = V((Up, Vn) => {
          var iu = de(), su = $n(), ou = iu({}.hasOwnProperty);
          Vn.exports = Object.hasOwn || function(n, i) {
            return ou(su(n), i);
          };
        });
        var Lr = V((Wp, Gn) => {
          var au = de(), uu = 0, cu = Math.random(), lu = au(1 .toString);
          Gn.exports = function(e) {
            return "Symbol(" + (e === void 0 ? "" : e) + ")_" + lu(++uu + cu, 36);
          };
        });
        var Xn = V(($p, Yn) => {
          var fu = ee(), pu = Dr(), Hn = Se(), hu = Lr(), Jn = Rr(), Qn = Ir(), De = pu("wks"), Ee = fu.Symbol, Kn = Ee && Ee.for, du = Qn ? Ee : Ee && Ee.withoutSetter || hu;
          Yn.exports = function(e) {
            if (!Hn(De, e) || !(Jn || typeof De[e] == "string")) {
              var n = "Symbol." + e;
              Jn && Hn(Ee, e) ? De[e] = Ee[e] : Qn && Kn ? De[e] = Kn(n) : De[e] = du(n);
            }
            return De[e];
          };
        });
        var ti = V((Vp, ri) => {
          var vu = ee(), mu = tr(), Zn = Me(), ei = Cr(), gu = In(), yu = Nn(), wu = Xn(), _u = vu.TypeError, bu = wu("toPrimitive");
          ri.exports = function(e, n) {
            if (!Zn(e) || ei(e))
              return e;
            var i = gu(e, bu), c;
            if (i) {
              if (n === void 0 && (n = "default"), c = mu(i, e, n), !Zn(c) || ei(c))
                return c;
              throw _u("Can't convert object to primitive value");
            }
            return n === void 0 && (n = "number"), yu(e, n);
          };
        });
        var zr = V((Gp, ni) => {
          var xu = ti(), ku = Cr();
          ni.exports = function(e) {
            var n = xu(e, "string");
            return ku(n) ? n : n + "";
          };
        });
        var oi = V((Hp, si) => {
          var Su = ee(), ii = Me(), Br = Su.document, Ou = ii(Br) && ii(Br.createElement);
          si.exports = function(e) {
            return Ou ? Br.createElement(e) : {};
          };
        });
        var Fr = V((Jp, ai) => {
          var Tu = Te(), Eu = ke(), qu = oi();
          ai.exports = !Tu && !Eu(function() {
            return Object.defineProperty(qu("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var Ur = V((ci) => {
          var Au = Te(), Pu = tr(), Ru = Qt(), Iu = Or(), Cu = nr(), Nu = zr(), ju = Se(), Mu = Fr(), ui = Object.getOwnPropertyDescriptor;
          ci.f = Au ? ui : function(n, i) {
            if (n = Cu(n), i = Nu(i), Mu)
              try {
                return ui(n, i);
              } catch {
              }
            if (ju(n, i))
              return Iu(!Pu(Ru.f, n, i), n[i]);
          };
        });
        var fi = V((Qp, li) => {
          var Du = Te(), Lu = ke();
          li.exports = Du && Lu(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var Wr = V((Yp, hi) => {
          var pi = ee(), zu = Me(), Bu = pi.String, Fu = pi.TypeError;
          hi.exports = function(e) {
            if (zu(e))
              return e;
            throw Fu(Bu(e) + " is not an object");
          };
        });
        var Jr = V((vi) => {
          var Uu = ee(), Wu = Te(), $u = Fr(), Vu = fi(), ur = Wr(), di = zr(), Gu = Uu.TypeError, $r = Object.defineProperty, Hu = Object.getOwnPropertyDescriptor, Vr = "enumerable", Gr = "configurable", Hr = "writable";
          vi.f = Wu ? Vu ? function(n, i, c) {
            if (ur(n), i = di(i), ur(c), typeof n == "function" && i === "prototype" && "value" in c && Hr in c && !c[Hr]) {
              var o = Hu(n, i);
              o && o[Hr] && (n[i] = c.value, c = { configurable: Gr in c ? c[Gr] : o[Gr], enumerable: Vr in c ? c[Vr] : o[Vr], writable: false });
            }
            return $r(n, i, c);
          } : $r : function(n, i, c) {
            if (ur(n), i = di(i), ur(c), $u)
              try {
                return $r(n, i, c);
              } catch {
              }
            if ("get" in c || "set" in c)
              throw Gu("Accessors not supported");
            return "value" in c && (n[i] = c.value), n;
          };
        });
        var cr = V((Zp, mi) => {
          var Ju = Te(), Ku = Jr(), Qu = Or();
          mi.exports = Ju ? function(e, n, i) {
            return Ku.f(e, n, Qu(1, i));
          } : function(e, n, i) {
            return e[n] = i, e;
          };
        });
        var Qr = V((eh, gi) => {
          var Yu = de(), Xu = ve(), Kr = ar(), Zu = Yu(Function.toString);
          Xu(Kr.inspectSource) || (Kr.inspectSource = function(e) {
            return Zu(e);
          });
          gi.exports = Kr.inspectSource;
        });
        var _i = V((rh, wi) => {
          var ec = ee(), rc = ve(), tc = Qr(), yi = ec.WeakMap;
          wi.exports = rc(yi) && /native code/.test(tc(yi));
        });
        var ki = V((th, xi) => {
          var nc = Dr(), ic = Lr(), bi = nc("keys");
          xi.exports = function(e) {
            return bi[e] || (bi[e] = ic(e));
          };
        });
        var Yr = V((nh, Si) => {
          Si.exports = {};
        });
        var Pi = V((ih, Ai) => {
          var sc = _i(), qi = ee(), Xr = de(), oc = Me(), ac = cr(), Zr = Se(), et = ar(), uc = ki(), cc = Yr(), Oi = "Object already initialized", tt = qi.TypeError, lc = qi.WeakMap, lr, Fe, fr, fc = function(e) {
            return fr(e) ? Fe(e) : lr(e, {});
          }, pc = function(e) {
            return function(n) {
              var i;
              if (!oc(n) || (i = Fe(n)).type !== e)
                throw tt("Incompatible receiver, " + e + " required");
              return i;
            };
          };
          sc || et.state ? (Oe = et.state || (et.state = new lc()), Ti = Xr(Oe.get), rt = Xr(Oe.has), Ei = Xr(Oe.set), lr = function(e, n) {
            if (rt(Oe, e))
              throw new tt(Oi);
            return n.facade = e, Ei(Oe, e, n), n;
          }, Fe = function(e) {
            return Ti(Oe, e) || {};
          }, fr = function(e) {
            return rt(Oe, e);
          }) : (qe = uc("state"), cc[qe] = true, lr = function(e, n) {
            if (Zr(e, qe))
              throw new tt(Oi);
            return n.facade = e, ac(e, qe, n), n;
          }, Fe = function(e) {
            return Zr(e, qe) ? e[qe] : {};
          }, fr = function(e) {
            return Zr(e, qe);
          });
          var Oe, Ti, rt, Ei, qe;
          Ai.exports = { set: lr, get: Fe, has: fr, enforce: fc, getterFor: pc };
        });
        var Ci = V((sh, Ii) => {
          var nt = Te(), hc = Se(), Ri = Function.prototype, dc = nt && Object.getOwnPropertyDescriptor, it = hc(Ri, "name"), vc = it && function() {
          }.name === "something", mc = it && (!nt || nt && dc(Ri, "name").configurable);
          Ii.exports = { EXISTS: it, PROPER: vc, CONFIGURABLE: mc };
        });
        var Li = V((oh, Di) => {
          var gc = ee(), Ni = ve(), yc = Se(), ji = cr(), wc = or(), _c = Qr(), Mi = Pi(), bc = Ci().CONFIGURABLE, xc = Mi.get, kc = Mi.enforce, Sc = String(String).split("String");
          (Di.exports = function(e, n, i, c) {
            var o = c ? !!c.unsafe : false, h = c ? !!c.enumerable : false, l = c ? !!c.noTargetGet : false, f = c && c.name !== void 0 ? c.name : n, m;
            if (Ni(i) && (String(f).slice(0, 7) === "Symbol(" && (f = "[" + String(f).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!yc(i, "name") || bc && i.name !== f) && ji(i, "name", f), m = kc(i), m.source || (m.source = Sc.join(typeof f == "string" ? f : ""))), e === gc) {
              h ? e[n] = i : wc(n, i);
              return;
            } else
              o ? !l && e[n] && (h = true) : delete e[n];
            h ? e[n] = i : ji(e, n, i);
          })(Function.prototype, "toString", function() {
            return Ni(this) && xc(this).source || _c(this);
          });
        });
        var st = V((ah, zi) => {
          var Oc = Math.ceil, Tc = Math.floor;
          zi.exports = function(e) {
            var n = +e;
            return n !== n || n === 0 ? 0 : (n > 0 ? Tc : Oc)(n);
          };
        });
        var Fi = V((uh, Bi) => {
          var Ec = st(), qc = Math.max, Ac = Math.min;
          Bi.exports = function(e, n) {
            var i = Ec(e);
            return i < 0 ? qc(i + n, 0) : Ac(i, n);
          };
        });
        var Wi = V((ch, Ui) => {
          var Pc = st(), Rc = Math.min;
          Ui.exports = function(e) {
            return e > 0 ? Rc(Pc(e), 9007199254740991) : 0;
          };
        });
        var Vi = V((lh, $i) => {
          var Ic = Wi();
          $i.exports = function(e) {
            return Ic(e.length);
          };
        });
        var Ji = V((fh, Hi) => {
          var Cc = nr(), Nc = Fi(), jc = Vi(), Gi = function(e) {
            return function(n, i, c) {
              var o = Cc(n), h = jc(o), l = Nc(c, h), f;
              if (e && i != i) {
                for (; h > l; )
                  if (f = o[l++], f != f)
                    return true;
              } else
                for (; h > l; l++)
                  if ((e || l in o) && o[l] === i)
                    return e || l || 0;
              return !e && -1;
            };
          };
          Hi.exports = { includes: Gi(true), indexOf: Gi(false) };
        });
        var Yi = V((ph, Qi) => {
          var Mc = de(), ot = Se(), Dc = nr(), Lc = Ji().indexOf, zc = Yr(), Ki = Mc([].push);
          Qi.exports = function(e, n) {
            var i = Dc(e), c = 0, o = [], h;
            for (h in i)
              !ot(zc, h) && ot(i, h) && Ki(o, h);
            for (; n.length > c; )
              ot(i, h = n[c++]) && (~Lc(o, h) || Ki(o, h));
            return o;
          };
        });
        var Zi = V((hh, Xi) => {
          Xi.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var rs = V((es) => {
          var Bc = Yi(), Fc = Zi(), Uc = Fc.concat("length", "prototype");
          es.f = Object.getOwnPropertyNames || function(n) {
            return Bc(n, Uc);
          };
        });
        var ns = V((ts) => {
          ts.f = Object.getOwnPropertySymbols;
        });
        var ss = V((mh, is) => {
          var Wc = ir(), $c = de(), Vc = rs(), Gc = ns(), Hc = Wr(), Jc = $c([].concat);
          is.exports = Wc("Reflect", "ownKeys") || function(n) {
            var i = Vc.f(Hc(n)), c = Gc.f;
            return c ? Jc(i, c(n)) : i;
          };
        });
        var us = V((gh, as) => {
          var os = Se(), Kc = ss(), Qc = Ur(), Yc = Jr();
          as.exports = function(e, n, i) {
            for (var c = Kc(n), o = Yc.f, h = Qc.f, l = 0; l < c.length; l++) {
              var f = c[l];
              !os(e, f) && !(i && os(i, f)) && o(e, f, h(n, f));
            }
          };
        });
        var ls = V((yh, cs) => {
          var Xc = ke(), Zc = ve(), el = /#|\.prototype\./, Ue = function(e, n) {
            var i = tl[rl(e)];
            return i == il ? true : i == nl ? false : Zc(n) ? Xc(n) : !!n;
          }, rl = Ue.normalize = function(e) {
            return String(e).replace(el, ".").toLowerCase();
          }, tl = Ue.data = {}, nl = Ue.NATIVE = "N", il = Ue.POLYFILL = "P";
          cs.exports = Ue;
        });
        var ps = V((wh, fs) => {
          var at2 = ee(), sl = Ur().f, ol = cr(), al = Li(), ul = or(), cl = us(), ll = ls();
          fs.exports = function(e, n) {
            var i = e.target, c = e.global, o = e.stat, h, l, f, m, u, t3;
            if (c ? l = at2 : o ? l = at2[i] || ul(i, {}) : l = (at2[i] || {}).prototype, l)
              for (f in n) {
                if (u = n[f], e.noTargetGet ? (t3 = sl(l, f), m = t3 && t3.value) : m = l[f], h = ll(c ? f : i + (o ? "." : "#") + f, e.forced), !h && m !== void 0) {
                  if (typeof u == typeof m)
                    continue;
                  cl(u, m);
                }
                (e.sham || m && m.sham) && ol(u, "sham", true), al(l, f, u, e);
              }
          };
        });
        var hs = V(() => {
          var fl = ps(), pl = ee();
          fl({ global: true }, { globalThis: pl });
        });
        var ds = V(() => {
          hs();
        });
        var lp = V((Ph, la) => {
          ds();
          var kt = Object.defineProperty, hl = Object.getOwnPropertyDescriptor, St = Object.getOwnPropertyNames, dl = Object.prototype.hasOwnProperty, Le = (e, n) => function() {
            return e && (n = (0, e[St(e)[0]])(e = 0)), n;
          }, R = (e, n) => function() {
            return n || (0, e[St(e)[0]])((n = { exports: {} }).exports, n), n.exports;
          }, Ot = (e, n) => {
            for (var i in n)
              kt(e, i, { get: n[i], enumerable: true });
          }, vl = (e, n, i, c) => {
            if (n && typeof n == "object" || typeof n == "function")
              for (let o of St(n))
                !dl.call(e, o) && o !== i && kt(e, o, { get: () => n[o], enumerable: !(c = hl(n, o)) || c.enumerable });
            return e;
          }, Tt = (e) => vl(kt({}, "__esModule", { value: true }), e), A = Le({ "<define:process>"() {
          } }), ml = R({ "src/common/parser-create-error.js"(e, n) {
            "use strict";
            A();
            function i(c, o) {
              let h = new SyntaxError(c + " (" + o.start.line + ":" + o.start.column + ")");
              return h.loc = o, h;
            }
            n.exports = i;
          } }), Cs = R({ "src/utils/get-last.js"(e, n) {
            "use strict";
            A();
            var i = (c) => c[c.length - 1];
            n.exports = i;
          } }), Ns = R({ "src/utils/front-matter/parse.js"(e, n) {
            "use strict";
            A();
            var i = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
            function c(o) {
              let h = o.match(i);
              if (!h)
                return { content: o };
              let { startDelimiter: l, language: f, value: m = "", endDelimiter: u } = h.groups, t3 = f.trim() || "yaml";
              if (l === "+++" && (t3 = "toml"), t3 !== "yaml" && l !== u)
                return { content: o };
              let [r] = h;
              return { frontMatter: { type: "front-matter", lang: t3, value: m, startDelimiter: l, endDelimiter: u, raw: r.replace(/\n$/, "") }, content: r.replace(/[^\n]/g, " ") + o.slice(r.length) };
            }
            n.exports = c;
          } }), js = {};
          Ot(js, { EOL: () => gt2, arch: () => gl, cpus: () => Us, default: () => Hs, endianness: () => Ms, freemem: () => Bs, getNetworkInterfaces: () => Gs, hostname: () => Ds, loadavg: () => Ls, networkInterfaces: () => Vs, platform: () => yl, release: () => $s, tmpDir: () => vt, tmpdir: () => mt, totalmem: () => Fs, type: () => Ws, uptime: () => zs });
          function Ms() {
            if (typeof pr > "u") {
              var e = new ArrayBuffer(2), n = new Uint8Array(e), i = new Uint16Array(e);
              if (n[0] = 1, n[1] = 2, i[0] === 258)
                pr = "BE";
              else if (i[0] === 513)
                pr = "LE";
              else
                throw new Error("unable to figure out endianess");
            }
            return pr;
          }
          function Ds() {
            return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
          }
          function Ls() {
            return [];
          }
          function zs() {
            return 0;
          }
          function Bs() {
            return Number.MAX_VALUE;
          }
          function Fs() {
            return Number.MAX_VALUE;
          }
          function Us() {
            return [];
          }
          function Ws() {
            return "Browser";
          }
          function $s() {
            return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
          }
          function Vs() {
          }
          function Gs() {
          }
          function gl() {
            return "javascript";
          }
          function yl() {
            return "browser";
          }
          function vt() {
            return "/tmp";
          }
          var pr, mt, gt2, Hs, wl = Le({ "node-modules-polyfills:os"() {
            A(), mt = vt, gt2 = `
`, Hs = { EOL: gt2, tmpdir: mt, tmpDir: vt, networkInterfaces: Vs, getNetworkInterfaces: Gs, release: $s, type: Ws, cpus: Us, totalmem: Fs, freemem: Bs, uptime: zs, loadavg: Ls, hostname: Ds, endianness: Ms };
          } }), _l = R({ "node-modules-polyfills-commonjs:os"(e, n) {
            A();
            var i = (wl(), Tt(js));
            if (i && i.default) {
              n.exports = i.default;
              for (let c in i)
                n.exports[c] = i[c];
            } else
              i && (n.exports = i);
          } }), bl = R({ "node_modules/detect-newline/index.js"(e, n) {
            "use strict";
            A();
            var i = (c) => {
              if (typeof c != "string")
                throw new TypeError("Expected a string");
              let o = c.match(/(?:\r?\n)/g) || [];
              if (o.length === 0)
                return;
              let h = o.filter((f) => f === `\r
`).length, l = o.length - h;
              return h > l ? `\r
` : `
`;
            };
            n.exports = i, n.exports.graceful = (c) => typeof c == "string" && i(c) || `
`;
          } }), xl = R({ "node_modules/jest-docblock/build/index.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true }), e.extract = s, e.parse = g, e.parseWithComments = v, e.print = y, e.strip = p;
            function n() {
              let d = _l();
              return n = function() {
                return d;
              }, d;
            }
            function i() {
              let d = c(bl());
              return i = function() {
                return d;
              }, d;
            }
            function c(d) {
              return d && d.__esModule ? d : { default: d };
            }
            var o = /\*\/$/, h = /^\/\*\*?/, l = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, f = /(^|\s+)\/\/([^\r\n]*)/g, m = /^(\r?\n)+/, u = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, t3 = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, r = /(\r?\n|^) *\* ?/g, a = [];
            function s(d) {
              let _ = d.match(l);
              return _ ? _[0].trimLeft() : "";
            }
            function p(d) {
              let _ = d.match(l);
              return _ && _[0] ? d.substring(_[0].length) : d;
            }
            function g(d) {
              return v(d).pragmas;
            }
            function v(d) {
              let _ = (0, i().default)(d) || n().EOL;
              d = d.replace(h, "").replace(o, "").replace(r, "$1");
              let S = "";
              for (; S !== d; )
                S = d, d = d.replace(u, `${_}$1 $2${_}`);
              d = d.replace(m, "").trimRight();
              let x = /* @__PURE__ */ Object.create(null), N = d.replace(t3, "").replace(m, "").trimRight(), P;
              for (; P = t3.exec(d); ) {
                let W = P[2].replace(f, "");
                typeof x[P[1]] == "string" || Array.isArray(x[P[1]]) ? x[P[1]] = a.concat(x[P[1]], W) : x[P[1]] = W;
              }
              return { comments: N, pragmas: x };
            }
            function y(d) {
              let { comments: _ = "", pragmas: S = {} } = d, x = (0, i().default)(_) || n().EOL, N = "/**", P = " *", W = " */", U = Object.keys(S), H = U.map(($) => w($, S[$])).reduce(($, B) => $.concat(B), []).map(($) => `${P} ${$}${x}`).join("");
              if (!_) {
                if (U.length === 0)
                  return "";
                if (U.length === 1 && !Array.isArray(S[U[0]])) {
                  let $ = S[U[0]];
                  return `${N} ${w(U[0], $)[0]}${W}`;
                }
              }
              let D = _.split(x).map(($) => `${P} ${$}`).join(x) + x;
              return N + x + (_ ? D : "") + (_ && U.length ? P + x : "") + H + W;
            }
            function w(d, _) {
              return a.concat(_).map((S) => `@${d} ${S}`.trim());
            }
          } }), kl = R({ "src/common/end-of-line.js"(e, n) {
            "use strict";
            A();
            function i(l) {
              let f = l.indexOf("\r");
              return f >= 0 ? l.charAt(f + 1) === `
` ? "crlf" : "cr" : "lf";
            }
            function c(l) {
              switch (l) {
                case "cr":
                  return "\r";
                case "crlf":
                  return `\r
`;
                default:
                  return `
`;
              }
            }
            function o(l, f) {
              let m;
              switch (f) {
                case `
`:
                  m = /\n/g;
                  break;
                case "\r":
                  m = /\r/g;
                  break;
                case `\r
`:
                  m = /\r\n/g;
                  break;
                default:
                  throw new Error(`Unexpected "eol" ${JSON.stringify(f)}.`);
              }
              let u = l.match(m);
              return u ? u.length : 0;
            }
            function h(l) {
              return l.replace(/\r\n?/g, `
`);
            }
            n.exports = { guessEndOfLine: i, convertEndOfLineToChars: c, countEndOfLineChars: o, normalizeEndOfLine: h };
          } }), Sl = R({ "src/language-js/utils/get-shebang.js"(e, n) {
            "use strict";
            A();
            function i(c) {
              if (!c.startsWith("#!"))
                return "";
              let o = c.indexOf(`
`);
              return o === -1 ? c : c.slice(0, o);
            }
            n.exports = i;
          } }), Ol = R({ "src/language-js/pragma.js"(e, n) {
            "use strict";
            A();
            var { parseWithComments: i, strip: c, extract: o, print: h } = xl(), { normalizeEndOfLine: l } = kl(), f = Sl();
            function m(r) {
              let a = f(r);
              a && (r = r.slice(a.length + 1));
              let s = o(r), { pragmas: p, comments: g } = i(s);
              return { shebang: a, text: r, pragmas: p, comments: g };
            }
            function u(r) {
              let a = Object.keys(m(r).pragmas);
              return a.includes("prettier") || a.includes("format");
            }
            function t3(r) {
              let { shebang: a, text: s, pragmas: p, comments: g } = m(r), v = c(s), y = h({ pragmas: Object.assign({ format: "" }, p), comments: g.trimStart() });
              return (a ? `${a}
` : "") + l(y) + (v.startsWith(`
`) ? `
` : `

`) + v;
            }
            n.exports = { hasPragma: u, insertPragma: t3 };
          } }), Tl = R({ "src/language-css/pragma.js"(e, n) {
            "use strict";
            A();
            var i = Ol(), c = Ns();
            function o(l) {
              return i.hasPragma(c(l).content);
            }
            function h(l) {
              let { frontMatter: f, content: m } = c(l);
              return (f ? f.raw + `

` : "") + i.insertPragma(m);
            }
            n.exports = { hasPragma: o, insertPragma: h };
          } }), El = R({ "src/utils/text/skip.js"(e, n) {
            "use strict";
            A();
            function i(f) {
              return (m, u, t3) => {
                let r = t3 && t3.backwards;
                if (u === false)
                  return false;
                let { length: a } = m, s = u;
                for (; s >= 0 && s < a; ) {
                  let p = m.charAt(s);
                  if (f instanceof RegExp) {
                    if (!f.test(p))
                      return s;
                  } else if (!f.includes(p))
                    return s;
                  r ? s-- : s++;
                }
                return s === -1 || s === a ? s : false;
              };
            }
            var c = i(/\s/), o = i(" 	"), h = i(",; 	"), l = i(/[^\n\r]/);
            n.exports = { skipWhitespace: c, skipSpaces: o, skipToLineEnd: h, skipEverythingButNewLine: l };
          } }), ql = R({ "src/utils/line-column-to-index.js"(e, n) {
            "use strict";
            A(), n.exports = function(i, c) {
              let o = 0;
              for (let h = 0; h < i.line - 1; ++h)
                o = c.indexOf(`
`, o) + 1;
              return o + i.column;
            };
          } }), Js = R({ "src/language-css/loc.js"(e, n) {
            "use strict";
            A();
            var { skipEverythingButNewLine: i } = El(), c = Cs(), o = ql();
            function h(s, p) {
              return typeof s.sourceIndex == "number" ? s.sourceIndex : s.source ? o(s.source.start, p) - 1 : null;
            }
            function l(s, p) {
              if (s.type === "css-comment" && s.inline)
                return i(p, s.source.startOffset);
              let g = s.nodes && c(s.nodes);
              return g && s.source && !s.source.end && (s = g), s.source && s.source.end ? o(s.source.end, p) : null;
            }
            function f(s, p) {
              s.source && (s.source.startOffset = h(s, p), s.source.endOffset = l(s, p));
              for (let g in s) {
                let v = s[g];
                g === "source" || !v || typeof v != "object" || (v.type === "value-root" || v.type === "value-unknown" ? m(v, u(s), v.text || v.value) : f(v, p));
              }
            }
            function m(s, p, g) {
              s.source && (s.source.startOffset = h(s, g) + p, s.source.endOffset = l(s, g) + p);
              for (let v in s) {
                let y = s[v];
                v === "source" || !y || typeof y != "object" || m(y, p, g);
              }
            }
            function u(s) {
              let p = s.source.startOffset;
              return typeof s.prop == "string" && (p += s.prop.length), s.type === "css-atrule" && typeof s.name == "string" && (p += 1 + s.name.length + s.raws.afterName.match(/^\s*:?\s*/)[0].length), s.type !== "css-atrule" && s.raws && typeof s.raws.between == "string" && (p += s.raws.between.length), p;
            }
            function t3(s) {
              let p = "initial", g = "initial", v, y = false, w = [];
              for (let d = 0; d < s.length; d++) {
                let _ = s[d];
                switch (p) {
                  case "initial":
                    if (_ === "'") {
                      p = "single-quotes";
                      continue;
                    }
                    if (_ === '"') {
                      p = "double-quotes";
                      continue;
                    }
                    if ((_ === "u" || _ === "U") && s.slice(d, d + 4).toLowerCase() === "url(") {
                      p = "url", d += 3;
                      continue;
                    }
                    if (_ === "*" && s[d - 1] === "/") {
                      p = "comment-block";
                      continue;
                    }
                    if (_ === "/" && s[d - 1] === "/") {
                      p = "comment-inline", v = d - 1;
                      continue;
                    }
                    continue;
                  case "single-quotes":
                    if (_ === "'" && s[d - 1] !== "\\" && (p = g, g = "initial"), _ === `
` || _ === "\r")
                      return s;
                    continue;
                  case "double-quotes":
                    if (_ === '"' && s[d - 1] !== "\\" && (p = g, g = "initial"), _ === `
` || _ === "\r")
                      return s;
                    continue;
                  case "url":
                    if (_ === ")" && (p = "initial"), _ === `
` || _ === "\r")
                      return s;
                    if (_ === "'") {
                      p = "single-quotes", g = "url";
                      continue;
                    }
                    if (_ === '"') {
                      p = "double-quotes", g = "url";
                      continue;
                    }
                    continue;
                  case "comment-block":
                    _ === "/" && s[d - 1] === "*" && (p = "initial");
                    continue;
                  case "comment-inline":
                    (_ === '"' || _ === "'" || _ === "*") && (y = true), (_ === `
` || _ === "\r") && (y && w.push([v, d]), p = "initial", y = false);
                    continue;
                }
              }
              for (let [d, _] of w)
                s = s.slice(0, d) + s.slice(d, _).replace(/["'*]/g, " ") + s.slice(_);
              return s;
            }
            function r(s) {
              return s.source.startOffset;
            }
            function a(s) {
              return s.source.endOffset;
            }
            n.exports = { locStart: r, locEnd: a, calculateLoc: f, replaceQuotesInInlineComments: t3 };
          } }), Al = R({ "src/utils/is-non-empty-array.js"(e, n) {
            "use strict";
            A();
            function i(c) {
              return Array.isArray(c) && c.length > 0;
            }
            n.exports = i;
          } }), Pl = R({ "src/language-css/utils/has-scss-interpolation.js"(e, n) {
            "use strict";
            A();
            var i = Al();
            function c(o) {
              if (i(o)) {
                for (let h = o.length - 1; h > 0; h--)
                  if (o[h].type === "word" && o[h].value === "{" && o[h - 1].type === "word" && o[h - 1].value.endsWith("#"))
                    return true;
              }
              return false;
            }
            n.exports = c;
          } }), Rl = R({ "src/language-css/utils/has-string-or-function.js"(e, n) {
            "use strict";
            A();
            function i(c) {
              return c.some((o) => o.type === "string" || o.type === "func");
            }
            n.exports = i;
          } }), Il = R({ "src/language-css/utils/is-less-parser.js"(e, n) {
            "use strict";
            A();
            function i(c) {
              return c.parser === "css" || c.parser === "less";
            }
            n.exports = i;
          } }), Cl = R({ "src/language-css/utils/is-scss.js"(e, n) {
            "use strict";
            A();
            function i(c, o) {
              return c === "less" || c === "scss" ? c === "scss" : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(o);
            }
            n.exports = i;
          } }), Nl = R({ "src/language-css/utils/is-scss-nested-property-node.js"(e, n) {
            "use strict";
            A();
            function i(c) {
              return c.selector ? c.selector.replace(/\/\*.*?\*\//, "").replace(/\/\/.*\n/, "").trim().endsWith(":") : false;
            }
            n.exports = i;
          } }), jl = R({ "src/language-css/utils/is-scss-variable.js"(e, n) {
            "use strict";
            A();
            function i(c) {
              return Boolean((c == null ? void 0 : c.type) === "word" && c.value.startsWith("$"));
            }
            n.exports = i;
          } }), Ml = R({ "src/language-css/utils/stringify-node.js"(e, n) {
            "use strict";
            A();
            function i(c) {
              var o, h, l;
              if (c.groups) {
                var f, m, u;
                let y = ((f = c.open) === null || f === void 0 ? void 0 : f.value) || "", w = c.groups.map((_) => i(_)).join(((m = c.groups[0]) === null || m === void 0 ? void 0 : m.type) === "comma_group" ? "," : ""), d = ((u = c.close) === null || u === void 0 ? void 0 : u.value) || "";
                return y + w + d;
              }
              let t3 = ((o = c.raws) === null || o === void 0 ? void 0 : o.before) || "", r = ((h = c.raws) === null || h === void 0 ? void 0 : h.quote) || "", a = c.type === "atword" ? "@" : "", s = c.value || "", p = c.unit || "", g = c.group ? i(c.group) : "", v = ((l = c.raws) === null || l === void 0 ? void 0 : l.after) || "";
              return t3 + r + a + s + r + p + g + v;
            }
            n.exports = i;
          } }), Dl = R({ "src/language-css/utils/is-module-rule-name.js"(e, n) {
            "use strict";
            A();
            var i = /* @__PURE__ */ new Set(["import", "use", "forward"]);
            function c(o) {
              return i.has(o);
            }
            n.exports = c;
          } }), we = R({ "node_modules/postcss-values-parser/lib/node.js"(e, n) {
            "use strict";
            A();
            var i = function(c, o) {
              let h = new c.constructor();
              for (let l in c) {
                if (!c.hasOwnProperty(l))
                  continue;
                let f = c[l], m = typeof f;
                l === "parent" && m === "object" ? o && (h[l] = o) : l === "source" ? h[l] = f : f instanceof Array ? h[l] = f.map((u) => i(u, h)) : l !== "before" && l !== "after" && l !== "between" && l !== "semicolon" && (m === "object" && f !== null && (f = i(f)), h[l] = f);
              }
              return h;
            };
            n.exports = class {
              constructor(o) {
                o = o || {}, this.raws = { before: "", after: "" };
                for (let h in o)
                  this[h] = o[h];
              }
              remove() {
                return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
              }
              toString() {
                return [this.raws.before, String(this.value), this.raws.after].join("");
              }
              clone(o) {
                o = o || {};
                let h = i(this);
                for (let l in o)
                  h[l] = o[l];
                return h;
              }
              cloneBefore(o) {
                o = o || {};
                let h = this.clone(o);
                return this.parent.insertBefore(this, h), h;
              }
              cloneAfter(o) {
                o = o || {};
                let h = this.clone(o);
                return this.parent.insertAfter(this, h), h;
              }
              replaceWith() {
                let o = Array.prototype.slice.call(arguments);
                if (this.parent) {
                  for (let h of o)
                    this.parent.insertBefore(this, h);
                  this.remove();
                }
                return this;
              }
              moveTo(o) {
                return this.cleanRaws(this.root() === o.root()), this.remove(), o.append(this), this;
              }
              moveBefore(o) {
                return this.cleanRaws(this.root() === o.root()), this.remove(), o.parent.insertBefore(o, this), this;
              }
              moveAfter(o) {
                return this.cleanRaws(this.root() === o.root()), this.remove(), o.parent.insertAfter(o, this), this;
              }
              next() {
                let o = this.parent.index(this);
                return this.parent.nodes[o + 1];
              }
              prev() {
                let o = this.parent.index(this);
                return this.parent.nodes[o - 1];
              }
              toJSON() {
                let o = {};
                for (let h in this) {
                  if (!this.hasOwnProperty(h) || h === "parent")
                    continue;
                  let l = this[h];
                  l instanceof Array ? o[h] = l.map((f) => typeof f == "object" && f.toJSON ? f.toJSON() : f) : typeof l == "object" && l.toJSON ? o[h] = l.toJSON() : o[h] = l;
                }
                return o;
              }
              root() {
                let o = this;
                for (; o.parent; )
                  o = o.parent;
                return o;
              }
              cleanRaws(o) {
                delete this.raws.before, delete this.raws.after, o || delete this.raws.between;
              }
              positionInside(o) {
                let h = this.toString(), l = this.source.start.column, f = this.source.start.line;
                for (let m = 0; m < o; m++)
                  h[m] === `
` ? (l = 1, f += 1) : l += 1;
                return { line: f, column: l };
              }
              positionBy(o) {
                let h = this.source.start;
                if (Object(o).index)
                  h = this.positionInside(o.index);
                else if (Object(o).word) {
                  let l = this.toString().indexOf(o.word);
                  l !== -1 && (h = this.positionInside(l));
                }
                return h;
              }
            };
          } }), ue = R({ "node_modules/postcss-values-parser/lib/container.js"(e, n) {
            "use strict";
            A();
            var i = we(), c = class extends i {
              constructor(o) {
                super(o), this.nodes || (this.nodes = []);
              }
              push(o) {
                return o.parent = this, this.nodes.push(o), this;
              }
              each(o) {
                this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
                let h = this.lastEach, l, f;
                if (this.indexes[h] = 0, !!this.nodes) {
                  for (; this.indexes[h] < this.nodes.length && (l = this.indexes[h], f = o(this.nodes[l], l), f !== false); )
                    this.indexes[h] += 1;
                  return delete this.indexes[h], f;
                }
              }
              walk(o) {
                return this.each((h, l) => {
                  let f = o(h, l);
                  return f !== false && h.walk && (f = h.walk(o)), f;
                });
              }
              walkType(o, h) {
                if (!o || !h)
                  throw new Error("Parameters {type} and {callback} are required.");
                let l = typeof o == "function";
                return this.walk((f, m) => {
                  if (l && f instanceof o || !l && f.type === o)
                    return h.call(this, f, m);
                });
              }
              append(o) {
                return o.parent = this, this.nodes.push(o), this;
              }
              prepend(o) {
                return o.parent = this, this.nodes.unshift(o), this;
              }
              cleanRaws(o) {
                if (super.cleanRaws(o), this.nodes)
                  for (let h of this.nodes)
                    h.cleanRaws(o);
              }
              insertAfter(o, h) {
                let l = this.index(o), f;
                this.nodes.splice(l + 1, 0, h);
                for (let m in this.indexes)
                  f = this.indexes[m], l <= f && (this.indexes[m] = f + this.nodes.length);
                return this;
              }
              insertBefore(o, h) {
                let l = this.index(o), f;
                this.nodes.splice(l, 0, h);
                for (let m in this.indexes)
                  f = this.indexes[m], l <= f && (this.indexes[m] = f + this.nodes.length);
                return this;
              }
              removeChild(o) {
                o = this.index(o), this.nodes[o].parent = void 0, this.nodes.splice(o, 1);
                let h;
                for (let l in this.indexes)
                  h = this.indexes[l], h >= o && (this.indexes[l] = h - 1);
                return this;
              }
              removeAll() {
                for (let o of this.nodes)
                  o.parent = void 0;
                return this.nodes = [], this;
              }
              every(o) {
                return this.nodes.every(o);
              }
              some(o) {
                return this.nodes.some(o);
              }
              index(o) {
                return typeof o == "number" ? o : this.nodes.indexOf(o);
              }
              get first() {
                if (!!this.nodes)
                  return this.nodes[0];
              }
              get last() {
                if (!!this.nodes)
                  return this.nodes[this.nodes.length - 1];
              }
              toString() {
                let o = this.nodes.map(String).join("");
                return this.value && (o = this.value + o), this.raws.before && (o = this.raws.before + o), this.raws.after && (o += this.raws.after), o;
              }
            };
            c.registerWalker = (o) => {
              let h = "walk" + o.name;
              h.lastIndexOf("s") !== h.length - 1 && (h += "s"), !c.prototype[h] && (c.prototype[h] = function(l) {
                return this.walkType(o, l);
              });
            }, n.exports = c;
          } }), Ll = R({ "node_modules/postcss-values-parser/lib/root.js"(e, n) {
            "use strict";
            A();
            var i = ue();
            n.exports = class extends i {
              constructor(o) {
                super(o), this.type = "root";
              }
            };
          } }), Ks = R({ "node_modules/postcss-values-parser/lib/value.js"(e, n) {
            "use strict";
            A();
            var i = ue();
            n.exports = class extends i {
              constructor(o) {
                super(o), this.type = "value", this.unbalanced = 0;
              }
            };
          } }), Qs = R({ "node_modules/postcss-values-parser/lib/atword.js"(e, n) {
            "use strict";
            A();
            var i = ue(), c = class extends i {
              constructor(o) {
                super(o), this.type = "atword";
              }
              toString() {
                let o = this.quoted ? this.raws.quote : "";
                return [this.raws.before, "@", String.prototype.toString.call(this.value), this.raws.after].join("");
              }
            };
            i.registerWalker(c), n.exports = c;
          } }), Ys = R({ "node_modules/postcss-values-parser/lib/colon.js"(e, n) {
            "use strict";
            A();
            var i = ue(), c = we(), o = class extends c {
              constructor(h) {
                super(h), this.type = "colon";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), Xs = R({ "node_modules/postcss-values-parser/lib/comma.js"(e, n) {
            "use strict";
            A();
            var i = ue(), c = we(), o = class extends c {
              constructor(h) {
                super(h), this.type = "comma";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), Zs = R({ "node_modules/postcss-values-parser/lib/comment.js"(e, n) {
            "use strict";
            A();
            var i = ue(), c = we(), o = class extends c {
              constructor(h) {
                super(h), this.type = "comment", this.inline = Object(h).inline || false;
              }
              toString() {
                return [this.raws.before, this.inline ? "//" : "/*", String(this.value), this.inline ? "" : "*/", this.raws.after].join("");
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), eo = R({ "node_modules/postcss-values-parser/lib/function.js"(e, n) {
            "use strict";
            A();
            var i = ue(), c = class extends i {
              constructor(o) {
                super(o), this.type = "func", this.unbalanced = -1;
              }
            };
            i.registerWalker(c), n.exports = c;
          } }), ro = R({ "node_modules/postcss-values-parser/lib/number.js"(e, n) {
            "use strict";
            A();
            var i = ue(), c = we(), o = class extends c {
              constructor(h) {
                super(h), this.type = "number", this.unit = Object(h).unit || "";
              }
              toString() {
                return [this.raws.before, String(this.value), this.unit, this.raws.after].join("");
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), to = R({ "node_modules/postcss-values-parser/lib/operator.js"(e, n) {
            "use strict";
            A();
            var i = ue(), c = we(), o = class extends c {
              constructor(h) {
                super(h), this.type = "operator";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), no = R({ "node_modules/postcss-values-parser/lib/paren.js"(e, n) {
            "use strict";
            A();
            var i = ue(), c = we(), o = class extends c {
              constructor(h) {
                super(h), this.type = "paren", this.parenType = "";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), io = R({ "node_modules/postcss-values-parser/lib/string.js"(e, n) {
            "use strict";
            A();
            var i = ue(), c = we(), o = class extends c {
              constructor(h) {
                super(h), this.type = "string";
              }
              toString() {
                let h = this.quoted ? this.raws.quote : "";
                return [this.raws.before, h, this.value + "", h, this.raws.after].join("");
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), so = R({ "node_modules/postcss-values-parser/lib/word.js"(e, n) {
            "use strict";
            A();
            var i = ue(), c = we(), o = class extends c {
              constructor(h) {
                super(h), this.type = "word";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), oo = R({ "node_modules/postcss-values-parser/lib/unicode-range.js"(e, n) {
            "use strict";
            A();
            var i = ue(), c = we(), o = class extends c {
              constructor(h) {
                super(h), this.type = "unicode-range";
              }
            };
            i.registerWalker(o), n.exports = o;
          } });
          function ao() {
            throw new Error("setTimeout has not been defined");
          }
          function uo() {
            throw new Error("clearTimeout has not been defined");
          }
          function co(e) {
            if (be === setTimeout)
              return setTimeout(e, 0);
            if ((be === ao || !be) && setTimeout)
              return be = setTimeout, setTimeout(e, 0);
            try {
              return be(e, 0);
            } catch {
              try {
                return be.call(null, e, 0);
              } catch {
                return be.call(this, e, 0);
              }
            }
          }
          function zl(e) {
            if (xe === clearTimeout)
              return clearTimeout(e);
            if ((xe === uo || !xe) && clearTimeout)
              return xe = clearTimeout, clearTimeout(e);
            try {
              return xe(e);
            } catch {
              try {
                return xe.call(null, e);
              } catch {
                return xe.call(this, e);
              }
            }
          }
          function Bl() {
            !Ne || !Ce || (Ne = false, Ce.length ? me = Ce.concat(me) : $e = -1, me.length && lo());
          }
          function lo() {
            if (!Ne) {
              var e = co(Bl);
              Ne = true;
              for (var n = me.length; n; ) {
                for (Ce = me, me = []; ++$e < n; )
                  Ce && Ce[$e].run();
                $e = -1, n = me.length;
              }
              Ce = null, Ne = false, zl(e);
            }
          }
          function Fl(e) {
            var n = new Array(arguments.length - 1);
            if (arguments.length > 1)
              for (var i = 1; i < arguments.length; i++)
                n[i - 1] = arguments[i];
            me.push(new fo(e, n)), me.length === 1 && !Ne && co(lo);
          }
          function fo(e, n) {
            this.fun = e, this.array = n;
          }
          function Ae() {
          }
          function Ul(e) {
            throw new Error("process.binding is not supported");
          }
          function Wl() {
            return "/";
          }
          function $l(e) {
            throw new Error("process.chdir is not supported");
          }
          function Vl() {
            return 0;
          }
          function Gl(e) {
            var n = po.call(Re) * 1e-3, i = Math.floor(n), c = Math.floor(n % 1 * 1e9);
            return e && (i = i - e[0], c = c - e[1], c < 0 && (i--, c += 1e9)), [i, c];
          }
          function Hl() {
            var e = new Date(), n = e - ho;
            return n / 1e3;
          }
          var be, xe, me, Ne, Ce, $e, vs, ms, gs, ys, ws, _s, bs, xs, ks, Ss, Os, Ts, Es, qs, As, Ps, Re, po, ho, Rs, Ve, Jl = Le({ "node-modules-polyfills:process"() {
            A(), be = ao, xe = uo, typeof globalThis.setTimeout == "function" && (be = setTimeout), typeof globalThis.clearTimeout == "function" && (xe = clearTimeout), me = [], Ne = false, $e = -1, fo.prototype.run = function() {
              this.fun.apply(null, this.array);
            }, vs = "browser", ms = "browser", gs = true, ys = {}, ws = [], _s = "", bs = {}, xs = {}, ks = {}, Ss = Ae, Os = Ae, Ts = Ae, Es = Ae, qs = Ae, As = Ae, Ps = Ae, Re = globalThis.performance || {}, po = Re.now || Re.mozNow || Re.msNow || Re.oNow || Re.webkitNow || function() {
              return new Date().getTime();
            }, ho = new Date(), Rs = { nextTick: Fl, title: vs, browser: gs, env: ys, argv: ws, version: _s, versions: bs, on: Ss, addListener: Os, once: Ts, off: Es, removeListener: qs, removeAllListeners: As, emit: Ps, binding: Ul, cwd: Wl, chdir: $l, umask: Vl, hrtime: Gl, platform: ms, release: xs, config: ks, uptime: Hl }, Ve = Rs;
          } }), ut, Et, Kl = Le({ "node_modules/rollup-plugin-node-polyfills/polyfills/inherits.js"() {
            A(), typeof Object.create == "function" ? ut = function(n, i) {
              n.super_ = i, n.prototype = Object.create(i.prototype, { constructor: { value: n, enumerable: false, writable: true, configurable: true } });
            } : ut = function(n, i) {
              n.super_ = i;
              var c = function() {
              };
              c.prototype = i.prototype, n.prototype = new c(), n.prototype.constructor = n;
            }, Et = ut;
          } }), vo = {};
          Ot(vo, { _extend: () => It, debuglog: () => mo, default: () => Oo, deprecate: () => qt, format: () => gr, inherits: () => Et, inspect: () => ye, isArray: () => At, isBoolean: () => yr, isBuffer: () => _o, isDate: () => vr, isError: () => He, isFunction: () => Je, isNull: () => Ke, isNullOrUndefined: () => go, isNumber: () => Pt, isObject: () => je, isPrimitive: () => wo, isRegExp: () => Ge, isString: () => Qe, isSymbol: () => yo, isUndefined: () => ge, log: () => bo });
          function gr(e) {
            if (!Qe(e)) {
              for (var n = [], i = 0; i < arguments.length; i++)
                n.push(ye(arguments[i]));
              return n.join(" ");
            }
            for (var i = 1, c = arguments, o = c.length, h = String(e).replace(ko, function(f) {
              if (f === "%%")
                return "%";
              if (i >= o)
                return f;
              switch (f) {
                case "%s":
                  return String(c[i++]);
                case "%d":
                  return Number(c[i++]);
                case "%j":
                  try {
                    return JSON.stringify(c[i++]);
                  } catch {
                    return "[Circular]";
                  }
                default:
                  return f;
              }
            }), l = c[i]; i < o; l = c[++i])
              Ke(l) || !je(l) ? h += " " + l : h += " " + ye(l);
            return h;
          }
          function qt(e, n) {
            if (ge(globalThis.process))
              return function() {
                return qt(e, n).apply(this, arguments);
              };
            if (Ve.noDeprecation === true)
              return e;
            var i = false;
            function c() {
              if (!i) {
                if (Ve.throwDeprecation)
                  throw new Error(n);
                Ve.traceDeprecation ? console.trace(n) : console.error(n), i = true;
              }
              return e.apply(this, arguments);
            }
            return c;
          }
          function mo(e) {
            if (ge(ft) && (ft = Ve.env.NODE_DEBUG || ""), e = e.toUpperCase(), !We[e])
              if (new RegExp("\\b" + e + "\\b", "i").test(ft)) {
                var n = 0;
                We[e] = function() {
                  var i = gr.apply(null, arguments);
                  console.error("%s %d: %s", e, n, i);
                };
              } else
                We[e] = function() {
                };
            return We[e];
          }
          function ye(e, n) {
            var i = { seen: [], stylize: Yl };
            return arguments.length >= 3 && (i.depth = arguments[2]), arguments.length >= 4 && (i.colors = arguments[3]), yr(n) ? i.showHidden = n : n && It(i, n), ge(i.showHidden) && (i.showHidden = false), ge(i.depth) && (i.depth = 2), ge(i.colors) && (i.colors = false), ge(i.customInspect) && (i.customInspect = true), i.colors && (i.stylize = Ql), dr(i, e, i.depth);
          }
          function Ql(e, n) {
            var i = ye.styles[n];
            return i ? "\x1B[" + ye.colors[i][0] + "m" + e + "\x1B[" + ye.colors[i][1] + "m" : e;
          }
          function Yl(e, n) {
            return e;
          }
          function Xl(e) {
            var n = {};
            return e.forEach(function(i, c) {
              n[i] = true;
            }), n;
          }
          function dr(e, n, i) {
            if (e.customInspect && n && Je(n.inspect) && n.inspect !== ye && !(n.constructor && n.constructor.prototype === n)) {
              var c = n.inspect(i, e);
              return Qe(c) || (c = dr(e, c, i)), c;
            }
            var o = Zl(e, n);
            if (o)
              return o;
            var h = Object.keys(n), l = Xl(h);
            if (e.showHidden && (h = Object.getOwnPropertyNames(n)), He(n) && (h.indexOf("message") >= 0 || h.indexOf("description") >= 0))
              return ct(n);
            if (h.length === 0) {
              if (Je(n)) {
                var f = n.name ? ": " + n.name : "";
                return e.stylize("[Function" + f + "]", "special");
              }
              if (Ge(n))
                return e.stylize(RegExp.prototype.toString.call(n), "regexp");
              if (vr(n))
                return e.stylize(Date.prototype.toString.call(n), "date");
              if (He(n))
                return ct(n);
            }
            var m = "", u = false, t3 = ["{", "}"];
            if (At(n) && (u = true, t3 = ["[", "]"]), Je(n)) {
              var r = n.name ? ": " + n.name : "";
              m = " [Function" + r + "]";
            }
            if (Ge(n) && (m = " " + RegExp.prototype.toString.call(n)), vr(n) && (m = " " + Date.prototype.toUTCString.call(n)), He(n) && (m = " " + ct(n)), h.length === 0 && (!u || n.length == 0))
              return t3[0] + m + t3[1];
            if (i < 0)
              return Ge(n) ? e.stylize(RegExp.prototype.toString.call(n), "regexp") : e.stylize("[Object]", "special");
            e.seen.push(n);
            var a;
            return u ? a = ef(e, n, i, l, h) : a = h.map(function(s) {
              return yt(e, n, i, l, s, u);
            }), e.seen.pop(), rf(a, m, t3);
          }
          function Zl(e, n) {
            if (ge(n))
              return e.stylize("undefined", "undefined");
            if (Qe(n)) {
              var i = "'" + JSON.stringify(n).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
              return e.stylize(i, "string");
            }
            if (Pt(n))
              return e.stylize("" + n, "number");
            if (yr(n))
              return e.stylize("" + n, "boolean");
            if (Ke(n))
              return e.stylize("null", "null");
          }
          function ct(e) {
            return "[" + Error.prototype.toString.call(e) + "]";
          }
          function ef(e, n, i, c, o) {
            for (var h = [], l = 0, f = n.length; l < f; ++l)
              xo(n, String(l)) ? h.push(yt(e, n, i, c, String(l), true)) : h.push("");
            return o.forEach(function(m) {
              m.match(/^\d+$/) || h.push(yt(e, n, i, c, m, true));
            }), h;
          }
          function yt(e, n, i, c, o, h) {
            var l, f, m;
            if (m = Object.getOwnPropertyDescriptor(n, o) || { value: n[o] }, m.get ? m.set ? f = e.stylize("[Getter/Setter]", "special") : f = e.stylize("[Getter]", "special") : m.set && (f = e.stylize("[Setter]", "special")), xo(c, o) || (l = "[" + o + "]"), f || (e.seen.indexOf(m.value) < 0 ? (Ke(i) ? f = dr(e, m.value, null) : f = dr(e, m.value, i - 1), f.indexOf(`
`) > -1 && (h ? f = f.split(`
`).map(function(u) {
              return "  " + u;
            }).join(`
`).substr(2) : f = `
` + f.split(`
`).map(function(u) {
              return "   " + u;
            }).join(`
`))) : f = e.stylize("[Circular]", "special")), ge(l)) {
              if (h && o.match(/^\d+$/))
                return f;
              l = JSON.stringify("" + o), l.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (l = l.substr(1, l.length - 2), l = e.stylize(l, "name")) : (l = l.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), l = e.stylize(l, "string"));
            }
            return l + ": " + f;
          }
          function rf(e, n, i) {
            var c = 0, o = e.reduce(function(h, l) {
              return c++, l.indexOf(`
`) >= 0 && c++, h + l.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0);
            return o > 60 ? i[0] + (n === "" ? "" : n + `
 `) + " " + e.join(`,
  `) + " " + i[1] : i[0] + n + " " + e.join(", ") + " " + i[1];
          }
          function At(e) {
            return Array.isArray(e);
          }
          function yr(e) {
            return typeof e == "boolean";
          }
          function Ke(e) {
            return e === null;
          }
          function go(e) {
            return e == null;
          }
          function Pt(e) {
            return typeof e == "number";
          }
          function Qe(e) {
            return typeof e == "string";
          }
          function yo(e) {
            return typeof e == "symbol";
          }
          function ge(e) {
            return e === void 0;
          }
          function Ge(e) {
            return je(e) && Rt(e) === "[object RegExp]";
          }
          function je(e) {
            return typeof e == "object" && e !== null;
          }
          function vr(e) {
            return je(e) && Rt(e) === "[object Date]";
          }
          function He(e) {
            return je(e) && (Rt(e) === "[object Error]" || e instanceof Error);
          }
          function Je(e) {
            return typeof e == "function";
          }
          function wo(e) {
            return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || typeof e > "u";
          }
          function _o(e) {
            return Buffer.isBuffer(e);
          }
          function Rt(e) {
            return Object.prototype.toString.call(e);
          }
          function lt2(e) {
            return e < 10 ? "0" + e.toString(10) : e.toString(10);
          }
          function tf() {
            var e = new Date(), n = [lt2(e.getHours()), lt2(e.getMinutes()), lt2(e.getSeconds())].join(":");
            return [e.getDate(), So[e.getMonth()], n].join(" ");
          }
          function bo() {
            console.log("%s - %s", tf(), gr.apply(null, arguments));
          }
          function It(e, n) {
            if (!n || !je(n))
              return e;
            for (var i = Object.keys(n), c = i.length; c--; )
              e[i[c]] = n[i[c]];
            return e;
          }
          function xo(e, n) {
            return Object.prototype.hasOwnProperty.call(e, n);
          }
          var ko, We, ft, So, Oo, nf = Le({ "node-modules-polyfills:util"() {
            A(), Jl(), Kl(), ko = /%[sdj%]/g, We = {}, ye.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, ye.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" }, So = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], Oo = { inherits: Et, _extend: It, log: bo, isBuffer: _o, isPrimitive: wo, isFunction: Je, isError: He, isDate: vr, isObject: je, isRegExp: Ge, isUndefined: ge, isSymbol: yo, isString: Qe, isNumber: Pt, isNullOrUndefined: go, isNull: Ke, isBoolean: yr, isArray: At, inspect: ye, deprecate: qt, format: gr, debuglog: mo };
          } }), sf = R({ "node-modules-polyfills-commonjs:util"(e, n) {
            A();
            var i = (nf(), Tt(vo));
            if (i && i.default) {
              n.exports = i.default;
              for (let c in i)
                n.exports[c] = i[c];
            } else
              i && (n.exports = i);
          } }), of = R({ "node_modules/postcss-values-parser/lib/errors/TokenizeError.js"(e, n) {
            "use strict";
            A();
            var i = class extends Error {
              constructor(c) {
                super(c), this.name = this.constructor.name, this.message = c || "An error ocurred while tokzenizing.", typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(c).stack;
              }
            };
            n.exports = i;
          } }), af = R({ "node_modules/postcss-values-parser/lib/tokenize.js"(e, n) {
            "use strict";
            A();
            var i = "{".charCodeAt(0), c = "}".charCodeAt(0), o = "(".charCodeAt(0), h = ")".charCodeAt(0), l = "'".charCodeAt(0), f = '"'.charCodeAt(0), m = "\\".charCodeAt(0), u = "/".charCodeAt(0), t3 = ".".charCodeAt(0), r = ",".charCodeAt(0), a = ":".charCodeAt(0), s = "*".charCodeAt(0), p = "-".charCodeAt(0), g = "+".charCodeAt(0), v = "#".charCodeAt(0), y = `
`.charCodeAt(0), w = " ".charCodeAt(0), d = "\f".charCodeAt(0), _ = "	".charCodeAt(0), S = "\r".charCodeAt(0), x = "@".charCodeAt(0), N = "e".charCodeAt(0), P = "E".charCodeAt(0), W = "0".charCodeAt(0), U = "9".charCodeAt(0), H = "u".charCodeAt(0), D = "U".charCodeAt(0), $ = /[ \n\t\r\{\(\)'"\\;,/]/g, B = /[ \n\t\r\(\)\{\}\*:;@!&'"\+\|~>,\[\]\\]|\/(?=\*)/g, O = /[ \n\t\r\(\)\{\}\*:;@!&'"\-\+\|~>,\[\]\\]|\//g, j = /^[a-z0-9]/i, C = /^[a-f0-9?\-]/i, I = sf(), X = of();
            n.exports = function(Q, K) {
              K = K || {};
              let J = [], M = Q.valueOf(), Y = M.length, G = -1, E = 1, k = 0, b = 0, L = null, q, T, F, z, re, ne, ce, fe, te, ie, ae, se;
              function le(Ze) {
                let _e = I.format("Unclosed %s at line: %d, column: %d, token: %d", Ze, E, k - G, k);
                throw new X(_e);
              }
              function pe() {
                let Ze = I.format("Syntax error at line: %d, column: %d, token: %d", E, k - G, k);
                throw new X(Ze);
              }
              for (; k < Y; ) {
                switch (q = M.charCodeAt(k), q === y && (G = k, E += 1), q) {
                  case y:
                  case w:
                  case _:
                  case S:
                  case d:
                    T = k;
                    do
                      T += 1, q = M.charCodeAt(T), q === y && (G = T, E += 1);
                    while (q === w || q === y || q === _ || q === S || q === d);
                    J.push(["space", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    break;
                  case a:
                    T = k + 1, J.push(["colon", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    break;
                  case r:
                    T = k + 1, J.push(["comma", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    break;
                  case i:
                    J.push(["{", "{", E, k - G, E, T - G, k]);
                    break;
                  case c:
                    J.push(["}", "}", E, k - G, E, T - G, k]);
                    break;
                  case o:
                    b++, L = !L && b === 1 && J.length > 0 && J[J.length - 1][0] === "word" && J[J.length - 1][1] === "url", J.push(["(", "(", E, k - G, E, T - G, k]);
                    break;
                  case h:
                    b--, L = L && b > 0, J.push([")", ")", E, k - G, E, T - G, k]);
                    break;
                  case l:
                  case f:
                    F = q === l ? "'" : '"', T = k;
                    do
                      for (ie = false, T = M.indexOf(F, T + 1), T === -1 && le("quote", F), ae = T; M.charCodeAt(ae - 1) === m; )
                        ae -= 1, ie = !ie;
                    while (ie);
                    J.push(["string", M.slice(k, T + 1), E, k - G, E, T - G, k]), k = T;
                    break;
                  case x:
                    $.lastIndex = k + 1, $.test(M), $.lastIndex === 0 ? T = M.length - 1 : T = $.lastIndex - 2, J.push(["atword", M.slice(k, T + 1), E, k - G, E, T - G, k]), k = T;
                    break;
                  case m:
                    T = k, q = M.charCodeAt(T + 1), ce && q !== u && q !== w && q !== y && q !== _ && q !== S && q !== d && (T += 1), J.push(["word", M.slice(k, T + 1), E, k - G, E, T - G, k]), k = T;
                    break;
                  case g:
                  case p:
                  case s:
                    T = k + 1, se = M.slice(k + 1, T + 1);
                    let Ze = M.slice(k - 1, k);
                    if (q === p && se.charCodeAt(0) === p) {
                      T++, J.push(["word", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                      break;
                    }
                    J.push(["operator", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    break;
                  default:
                    if (q === u && (M.charCodeAt(k + 1) === s || K.loose && !L && M.charCodeAt(k + 1) === u)) {
                      if (M.charCodeAt(k + 1) === s)
                        T = M.indexOf("*/", k + 2) + 1, T === 0 && le("comment", "*/");
                      else {
                        let Be = M.indexOf(`
`, k + 2);
                        T = Be !== -1 ? Be - 1 : Y;
                      }
                      ne = M.slice(k, T + 1), z = ne.split(`
`), re = z.length - 1, re > 0 ? (fe = E + re, te = T - z[re].length) : (fe = E, te = G), J.push(["comment", ne, E, k - G, fe, T - te, k]), G = te, E = fe, k = T;
                    } else if (q === v && !j.test(M.slice(k + 1, k + 2)))
                      T = k + 1, J.push(["#", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    else if ((q === H || q === D) && M.charCodeAt(k + 1) === g) {
                      T = k + 2;
                      do
                        T += 1, q = M.charCodeAt(T);
                      while (T < Y && C.test(M.slice(T, T + 1)));
                      J.push(["unicoderange", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    } else if (q === u)
                      T = k + 1, J.push(["operator", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    else {
                      let _e = B;
                      if (q >= W && q <= U && (_e = O), _e.lastIndex = k + 1, _e.test(M), _e.lastIndex === 0 ? T = M.length - 1 : T = _e.lastIndex - 2, _e === O || q === t3) {
                        let Be = M.charCodeAt(T), Bt = M.charCodeAt(T + 1), Ft = M.charCodeAt(T + 2);
                        (Be === N || Be === P) && (Bt === p || Bt === g) && Ft >= W && Ft <= U && (O.lastIndex = T + 2, O.test(M), O.lastIndex === 0 ? T = M.length - 1 : T = O.lastIndex - 2);
                      }
                      J.push(["word", M.slice(k, T + 1), E, k - G, E, T - G, k]), k = T;
                    }
                    break;
                }
                k++;
              }
              return J;
            };
          } }), To = R({ "node_modules/flatten/index.js"(e, n) {
            A(), n.exports = function(c, o) {
              if (o = typeof o == "number" ? o : 1 / 0, !o)
                return Array.isArray(c) ? c.map(function(l) {
                  return l;
                }) : c;
              return h(c, 1);
              function h(l, f) {
                return l.reduce(function(m, u) {
                  return Array.isArray(u) && f < o ? m.concat(h(u, f + 1)) : m.concat(u);
                }, []);
              }
            };
          } }), Eo = R({ "node_modules/indexes-of/index.js"(e, n) {
            A(), n.exports = function(i, c) {
              for (var o = -1, h = []; (o = i.indexOf(c, o + 1)) !== -1; )
                h.push(o);
              return h;
            };
          } }), qo = R({ "node_modules/uniq/uniq.js"(e, n) {
            "use strict";
            A();
            function i(h, l) {
              for (var f = 1, m = h.length, u = h[0], t3 = h[0], r = 1; r < m; ++r)
                if (t3 = u, u = h[r], l(u, t3)) {
                  if (r === f) {
                    f++;
                    continue;
                  }
                  h[f++] = u;
                }
              return h.length = f, h;
            }
            function c(h) {
              for (var l = 1, f = h.length, m = h[0], u = h[0], t3 = 1; t3 < f; ++t3, u = m)
                if (u = m, m = h[t3], m !== u) {
                  if (t3 === l) {
                    l++;
                    continue;
                  }
                  h[l++] = m;
                }
              return h.length = l, h;
            }
            function o(h, l, f) {
              return h.length === 0 ? h : l ? (f || h.sort(l), i(h, l)) : (f || h.sort(), c(h));
            }
            n.exports = o;
          } }), uf = R({ "node_modules/postcss-values-parser/lib/errors/ParserError.js"(e, n) {
            "use strict";
            A();
            var i = class extends Error {
              constructor(c) {
                super(c), this.name = this.constructor.name, this.message = c || "An error ocurred while parsing.", typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(c).stack;
              }
            };
            n.exports = i;
          } }), cf = R({ "node_modules/postcss-values-parser/lib/parser.js"(e, n) {
            "use strict";
            A();
            var i = Ll(), c = Ks(), o = Qs(), h = Ys(), l = Xs(), f = Zs(), m = eo(), u = ro(), t3 = to(), r = no(), a = io(), s = so(), p = oo(), g = af(), v = To(), y = Eo(), w = qo(), d = uf();
            function _(S) {
              return S.sort((x, N) => x - N);
            }
            n.exports = class {
              constructor(x, N) {
                let P = { loose: false };
                this.cache = [], this.input = x, this.options = Object.assign({}, P, N), this.position = 0, this.unbalanced = 0, this.root = new i();
                let W = new c();
                this.root.append(W), this.current = W, this.tokens = g(x, this.options);
              }
              parse() {
                return this.loop();
              }
              colon() {
                let x = this.currToken;
                this.newNode(new h({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++;
              }
              comma() {
                let x = this.currToken;
                this.newNode(new l({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++;
              }
              comment() {
                let x = false, N = this.currToken[1].replace(/\/\*|\*\//g, ""), P;
                this.options.loose && N.startsWith("//") && (N = N.substring(2), x = true), P = new f({ value: N, inline: x, source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] }), this.newNode(P), this.position++;
              }
              error(x, N) {
                throw new d(x + ` at line: ${N[2]}, column ${N[3]}`);
              }
              loop() {
                for (; this.position < this.tokens.length; )
                  this.parseTokens();
                return !this.current.last && this.spaces ? this.current.raws.before += this.spaces : this.spaces && (this.current.last.raws.after += this.spaces), this.spaces = "", this.root;
              }
              operator() {
                let x = this.currToken[1], N;
                if (x === "+" || x === "-") {
                  if (this.options.loose || this.position > 0 && (this.current.type === "func" && this.current.value === "calc" ? this.prevToken[0] !== "space" && this.prevToken[0] !== "(" ? this.error("Syntax Error", this.currToken) : this.nextToken[0] !== "space" && this.nextToken[0] !== "word" ? this.error("Syntax Error", this.currToken) : this.nextToken[0] === "word" && this.current.last.type !== "operator" && this.current.last.value !== "(" && this.error("Syntax Error", this.currToken) : (this.nextToken[0] === "space" || this.nextToken[0] === "operator" || this.prevToken[0] === "operator") && this.error("Syntax Error", this.currToken)), this.options.loose) {
                    if ((!this.current.nodes.length || this.current.last && this.current.last.type === "operator") && this.nextToken[0] === "word")
                      return this.word();
                  } else if (this.nextToken[0] === "word")
                    return this.word();
                }
                return N = new t3({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }), this.position++, this.newNode(N);
              }
              parseTokens() {
                switch (this.currToken[0]) {
                  case "space":
                    this.space();
                    break;
                  case "colon":
                    this.colon();
                    break;
                  case "comma":
                    this.comma();
                    break;
                  case "comment":
                    this.comment();
                    break;
                  case "(":
                    this.parenOpen();
                    break;
                  case ")":
                    this.parenClose();
                    break;
                  case "atword":
                  case "word":
                    this.word();
                    break;
                  case "operator":
                    this.operator();
                    break;
                  case "string":
                    this.string();
                    break;
                  case "unicoderange":
                    this.unicodeRange();
                    break;
                  default:
                    this.word();
                    break;
                }
              }
              parenOpen() {
                let x = 1, N = this.position + 1, P = this.currToken, W;
                for (; N < this.tokens.length && x; ) {
                  let U = this.tokens[N];
                  U[0] === "(" && x++, U[0] === ")" && x--, N++;
                }
                if (x && this.error("Expected closing parenthesis", P), W = this.current.last, W && W.type === "func" && W.unbalanced < 0 && (W.unbalanced = 0, this.current = W), this.current.unbalanced++, this.newNode(new r({ value: P[1], source: { start: { line: P[2], column: P[3] }, end: { line: P[4], column: P[5] } }, sourceIndex: P[6] })), this.position++, this.current.type === "func" && this.current.unbalanced && this.current.value === "url" && this.currToken[0] !== "string" && this.currToken[0] !== ")" && !this.options.loose) {
                  let U = this.nextToken, H = this.currToken[1], D = { line: this.currToken[2], column: this.currToken[3] };
                  for (; U && U[0] !== ")" && this.current.unbalanced; )
                    this.position++, H += this.currToken[1], U = this.nextToken;
                  this.position !== this.tokens.length - 1 && (this.position++, this.newNode(new s({ value: H, source: { start: D, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] })));
                }
              }
              parenClose() {
                let x = this.currToken;
                this.newNode(new r({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++, !(this.position >= this.tokens.length - 1 && !this.current.unbalanced) && (this.current.unbalanced--, this.current.unbalanced < 0 && this.error("Expected opening parenthesis", x), !this.current.unbalanced && this.cache.length && (this.current = this.cache.pop()));
              }
              space() {
                let x = this.currToken;
                this.position === this.tokens.length - 1 || this.nextToken[0] === "," || this.nextToken[0] === ")" ? (this.current.last.raws.after += x[1], this.position++) : (this.spaces = x[1], this.position++);
              }
              unicodeRange() {
                let x = this.currToken;
                this.newNode(new p({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++;
              }
              splitWord() {
                let x = this.nextToken, N = this.currToken[1], P = /^[\+\-]?((\d+(\.\d*)?)|(\.\d+))([eE][\+\-]?\d+)?/, W = /^(?!\#([a-z0-9]+))[\#\{\}]/gi, U, H;
                if (!W.test(N))
                  for (; x && x[0] === "word"; )
                    this.position++, N += this.currToken[1], x = this.nextToken;
                U = y(N, "@"), H = _(w(v([[0], U]))), H.forEach((D, $) => {
                  let B = H[$ + 1] || N.length, O = N.slice(D, B), j;
                  if (~U.indexOf(D))
                    j = new o({ value: O.slice(1), source: { start: { line: this.currToken[2], column: this.currToken[3] + D }, end: { line: this.currToken[4], column: this.currToken[3] + (B - 1) } }, sourceIndex: this.currToken[6] + H[$] });
                  else if (P.test(this.currToken[1])) {
                    let C = O.replace(P, "");
                    j = new u({ value: O.replace(C, ""), source: { start: { line: this.currToken[2], column: this.currToken[3] + D }, end: { line: this.currToken[4], column: this.currToken[3] + (B - 1) } }, sourceIndex: this.currToken[6] + H[$], unit: C });
                  } else
                    j = new (x && x[0] === "(" ? m : s)({ value: O, source: { start: { line: this.currToken[2], column: this.currToken[3] + D }, end: { line: this.currToken[4], column: this.currToken[3] + (B - 1) } }, sourceIndex: this.currToken[6] + H[$] }), j.type === "word" ? (j.isHex = /^#(.+)/.test(O), j.isColor = /^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(O)) : this.cache.push(this.current);
                  this.newNode(j);
                }), this.position++;
              }
              string() {
                let x = this.currToken, N = this.currToken[1], P = /^(\"|\')/, W = P.test(N), U = "", H;
                W && (U = N.match(P)[0], N = N.slice(1, N.length - 1)), H = new a({ value: N, source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6], quoted: W }), H.raws.quote = U, this.newNode(H), this.position++;
              }
              word() {
                return this.splitWord();
              }
              newNode(x) {
                return this.spaces && (x.raws.before += this.spaces, this.spaces = ""), this.current.append(x);
              }
              get currToken() {
                return this.tokens[this.position];
              }
              get nextToken() {
                return this.tokens[this.position + 1];
              }
              get prevToken() {
                return this.tokens[this.position - 1];
              }
            };
          } }), lf = R({ "node_modules/postcss-values-parser/lib/index.js"(e, n) {
            "use strict";
            A();
            var i = cf(), c = Qs(), o = Ys(), h = Xs(), l = Zs(), f = eo(), m = ro(), u = to(), t3 = no(), r = io(), a = oo(), s = Ks(), p = so(), g = function(v, y) {
              return new i(v, y);
            };
            g.atword = function(v) {
              return new c(v);
            }, g.colon = function(v) {
              return new o(Object.assign({ value: ":" }, v));
            }, g.comma = function(v) {
              return new h(Object.assign({ value: "," }, v));
            }, g.comment = function(v) {
              return new l(v);
            }, g.func = function(v) {
              return new f(v);
            }, g.number = function(v) {
              return new m(v);
            }, g.operator = function(v) {
              return new u(v);
            }, g.paren = function(v) {
              return new t3(Object.assign({ value: "(" }, v));
            }, g.string = function(v) {
              return new r(Object.assign({ quote: "'" }, v));
            }, g.value = function(v) {
              return new s(v);
            }, g.word = function(v) {
              return new p(v);
            }, g.unicodeRange = function(v) {
              return new a(v);
            }, n.exports = g;
          } }), ze = R({ "node_modules/postcss-selector-parser/dist/selectors/node.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
              return typeof l;
            } : function(l) {
              return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
            };
            function c(l, f) {
              if (!(l instanceof f))
                throw new TypeError("Cannot call a class as a function");
            }
            var o = function l(f, m) {
              if ((typeof f > "u" ? "undefined" : i(f)) !== "object")
                return f;
              var u = new f.constructor();
              for (var t3 in f)
                if (!!f.hasOwnProperty(t3)) {
                  var r = f[t3], a = typeof r > "u" ? "undefined" : i(r);
                  t3 === "parent" && a === "object" ? m && (u[t3] = m) : r instanceof Array ? u[t3] = r.map(function(s) {
                    return l(s, u);
                  }) : u[t3] = l(r, u);
                }
              return u;
            }, h = function() {
              function l() {
                var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                c(this, l);
                for (var m in f)
                  this[m] = f[m];
                var u = f.spaces;
                u = u === void 0 ? {} : u;
                var t3 = u.before, r = t3 === void 0 ? "" : t3, a = u.after, s = a === void 0 ? "" : a;
                this.spaces = { before: r, after: s };
              }
              return l.prototype.remove = function() {
                return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
              }, l.prototype.replaceWith = function() {
                if (this.parent) {
                  for (var m in arguments)
                    this.parent.insertBefore(this, arguments[m]);
                  this.remove();
                }
                return this;
              }, l.prototype.next = function() {
                return this.parent.at(this.parent.index(this) + 1);
              }, l.prototype.prev = function() {
                return this.parent.at(this.parent.index(this) - 1);
              }, l.prototype.clone = function() {
                var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = o(this);
                for (var t3 in m)
                  u[t3] = m[t3];
                return u;
              }, l.prototype.toString = function() {
                return [this.spaces.before, String(this.value), this.spaces.after].join("");
              }, l;
            }();
            e.default = h, n.exports = e.default;
          } }), oe = R({ "node_modules/postcss-selector-parser/dist/selectors/types.js"(e) {
            "use strict";
            A(), e.__esModule = true;
            var n = e.TAG = "tag", i = e.STRING = "string", c = e.SELECTOR = "selector", o = e.ROOT = "root", h = e.PSEUDO = "pseudo", l = e.NESTING = "nesting", f = e.ID = "id", m = e.COMMENT = "comment", u = e.COMBINATOR = "combinator", t3 = e.CLASS = "class", r = e.ATTRIBUTE = "attribute", a = e.UNIVERSAL = "universal";
          } }), Ct = R({ "node_modules/postcss-selector-parser/dist/selectors/container.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function s(p, g) {
                for (var v = 0; v < g.length; v++) {
                  var y = g[v];
                  y.enumerable = y.enumerable || false, y.configurable = true, "value" in y && (y.writable = true), Object.defineProperty(p, y.key, y);
                }
              }
              return function(p, g, v) {
                return g && s(p.prototype, g), v && s(p, v), p;
              };
            }(), c = ze(), o = m(c), h = oe(), l = f(h);
            function f(s) {
              if (s && s.__esModule)
                return s;
              var p = {};
              if (s != null)
                for (var g in s)
                  Object.prototype.hasOwnProperty.call(s, g) && (p[g] = s[g]);
              return p.default = s, p;
            }
            function m(s) {
              return s && s.__esModule ? s : { default: s };
            }
            function u(s, p) {
              if (!(s instanceof p))
                throw new TypeError("Cannot call a class as a function");
            }
            function t3(s, p) {
              if (!s)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return p && (typeof p == "object" || typeof p == "function") ? p : s;
            }
            function r(s, p) {
              if (typeof p != "function" && p !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof p);
              s.prototype = Object.create(p && p.prototype, { constructor: { value: s, enumerable: false, writable: true, configurable: true } }), p && (Object.setPrototypeOf ? Object.setPrototypeOf(s, p) : s.__proto__ = p);
            }
            var a = function(s) {
              r(p, s);
              function p(g) {
                u(this, p);
                var v = t3(this, s.call(this, g));
                return v.nodes || (v.nodes = []), v;
              }
              return p.prototype.append = function(v) {
                return v.parent = this, this.nodes.push(v), this;
              }, p.prototype.prepend = function(v) {
                return v.parent = this, this.nodes.unshift(v), this;
              }, p.prototype.at = function(v) {
                return this.nodes[v];
              }, p.prototype.index = function(v) {
                return typeof v == "number" ? v : this.nodes.indexOf(v);
              }, p.prototype.removeChild = function(v) {
                v = this.index(v), this.at(v).parent = void 0, this.nodes.splice(v, 1);
                var y = void 0;
                for (var w in this.indexes)
                  y = this.indexes[w], y >= v && (this.indexes[w] = y - 1);
                return this;
              }, p.prototype.removeAll = function() {
                for (var w = this.nodes, v = Array.isArray(w), y = 0, w = v ? w : w[Symbol.iterator](); ; ) {
                  var d;
                  if (v) {
                    if (y >= w.length)
                      break;
                    d = w[y++];
                  } else {
                    if (y = w.next(), y.done)
                      break;
                    d = y.value;
                  }
                  var _ = d;
                  _.parent = void 0;
                }
                return this.nodes = [], this;
              }, p.prototype.empty = function() {
                return this.removeAll();
              }, p.prototype.insertAfter = function(v, y) {
                var w = this.index(v);
                this.nodes.splice(w + 1, 0, y);
                var d = void 0;
                for (var _ in this.indexes)
                  d = this.indexes[_], w <= d && (this.indexes[_] = d + this.nodes.length);
                return this;
              }, p.prototype.insertBefore = function(v, y) {
                var w = this.index(v);
                this.nodes.splice(w, 0, y);
                var d = void 0;
                for (var _ in this.indexes)
                  d = this.indexes[_], w <= d && (this.indexes[_] = d + this.nodes.length);
                return this;
              }, p.prototype.each = function(v) {
                this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach++;
                var y = this.lastEach;
                if (this.indexes[y] = 0, !!this.length) {
                  for (var w = void 0, d = void 0; this.indexes[y] < this.length && (w = this.indexes[y], d = v(this.at(w), w), d !== false); )
                    this.indexes[y] += 1;
                  if (delete this.indexes[y], d === false)
                    return false;
                }
              }, p.prototype.walk = function(v) {
                return this.each(function(y, w) {
                  var d = v(y, w);
                  if (d !== false && y.length && (d = y.walk(v)), d === false)
                    return false;
                });
              }, p.prototype.walkAttributes = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.ATTRIBUTE)
                    return v.call(y, w);
                });
              }, p.prototype.walkClasses = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.CLASS)
                    return v.call(y, w);
                });
              }, p.prototype.walkCombinators = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.COMBINATOR)
                    return v.call(y, w);
                });
              }, p.prototype.walkComments = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.COMMENT)
                    return v.call(y, w);
                });
              }, p.prototype.walkIds = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.ID)
                    return v.call(y, w);
                });
              }, p.prototype.walkNesting = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.NESTING)
                    return v.call(y, w);
                });
              }, p.prototype.walkPseudos = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.PSEUDO)
                    return v.call(y, w);
                });
              }, p.prototype.walkTags = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.TAG)
                    return v.call(y, w);
                });
              }, p.prototype.walkUniversals = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === l.UNIVERSAL)
                    return v.call(y, w);
                });
              }, p.prototype.split = function(v) {
                var y = this, w = [];
                return this.reduce(function(d, _, S) {
                  var x = v.call(y, _);
                  return w.push(_), x ? (d.push(w), w = []) : S === y.length - 1 && d.push(w), d;
                }, []);
              }, p.prototype.map = function(v) {
                return this.nodes.map(v);
              }, p.prototype.reduce = function(v, y) {
                return this.nodes.reduce(v, y);
              }, p.prototype.every = function(v) {
                return this.nodes.every(v);
              }, p.prototype.some = function(v) {
                return this.nodes.some(v);
              }, p.prototype.filter = function(v) {
                return this.nodes.filter(v);
              }, p.prototype.sort = function(v) {
                return this.nodes.sort(v);
              }, p.prototype.toString = function() {
                return this.map(String).join("");
              }, i(p, [{ key: "first", get: function() {
                return this.at(0);
              } }, { key: "last", get: function() {
                return this.at(this.length - 1);
              } }, { key: "length", get: function() {
                return this.nodes.length;
              } }]), p;
            }(o.default);
            e.default = a, n.exports = e.default;
          } }), Ao = R({ "node_modules/postcss-selector-parser/dist/selectors/root.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ct(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.ROOT, s;
              }
              return r.prototype.toString = function() {
                var s = this.reduce(function(p, g) {
                  var v = String(g);
                  return v ? p + v + "," : "";
                }, "").slice(0, -1);
                return this.trailingComma ? s + "," : s;
              }, r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), Po = R({ "node_modules/postcss-selector-parser/dist/selectors/selector.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ct(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.SELECTOR, s;
              }
              return r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), Ye = R({ "node_modules/postcss-selector-parser/dist/selectors/namespace.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function t3(r, a) {
                for (var s = 0; s < a.length; s++) {
                  var p = a[s];
                  p.enumerable = p.enumerable || false, p.configurable = true, "value" in p && (p.writable = true), Object.defineProperty(r, p.key, p);
                }
              }
              return function(r, a, s) {
                return a && t3(r.prototype, a), s && t3(r, s), r;
              };
            }(), c = ze(), o = h(c);
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r() {
                return l(this, r), f(this, t3.apply(this, arguments));
              }
              return r.prototype.toString = function() {
                return [this.spaces.before, this.ns, String(this.value), this.spaces.after].join("");
              }, i(r, [{ key: "ns", get: function() {
                var s = this.namespace;
                return s ? (typeof s == "string" ? s : "") + "|" : "";
              } }]), r;
            }(o.default);
            e.default = u, n.exports = e.default;
          } }), Ro = R({ "node_modules/postcss-selector-parser/dist/selectors/className.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.CLASS, s;
              }
              return r.prototype.toString = function() {
                return [this.spaces.before, this.ns, String("." + this.value), this.spaces.after].join("");
              }, r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), Io = R({ "node_modules/postcss-selector-parser/dist/selectors/comment.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.COMMENT, s;
              }
              return r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), Co = R({ "node_modules/postcss-selector-parser/dist/selectors/id.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.ID, s;
              }
              return r.prototype.toString = function() {
                return [this.spaces.before, this.ns, String("#" + this.value), this.spaces.after].join("");
              }, r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), No = R({ "node_modules/postcss-selector-parser/dist/selectors/tag.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.TAG, s;
              }
              return r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), jo = R({ "node_modules/postcss-selector-parser/dist/selectors/string.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.STRING, s;
              }
              return r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), Mo = R({ "node_modules/postcss-selector-parser/dist/selectors/pseudo.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ct(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.PSEUDO, s;
              }
              return r.prototype.toString = function() {
                var s = this.length ? "(" + this.map(String).join(",") + ")" : "";
                return [this.spaces.before, String(this.value), s, this.spaces.after].join("");
              }, r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), Do = R({ "node_modules/postcss-selector-parser/dist/selectors/attribute.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.ATTRIBUTE, s.raws = {}, s;
              }
              return r.prototype.toString = function() {
                var s = [this.spaces.before, "[", this.ns, this.attribute];
                return this.operator && s.push(this.operator), this.value && s.push(this.value), this.raws.insensitive ? s.push(this.raws.insensitive) : this.insensitive && s.push(" i"), s.push("]"), s.concat(this.spaces.after).join("");
              }, r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), Lo = R({ "node_modules/postcss-selector-parser/dist/selectors/universal.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.UNIVERSAL, s.value = "*", s;
              }
              return r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), zo = R({ "node_modules/postcss-selector-parser/dist/selectors/combinator.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.COMBINATOR, s;
              }
              return r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), Bo = R({ "node_modules/postcss-selector-parser/dist/selectors/nesting.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), c = h(i), o = oe();
            function h(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function l(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function m(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var u = function(t3) {
              m(r, t3);
              function r(a) {
                l(this, r);
                var s = f(this, t3.call(this, a));
                return s.type = o.NESTING, s.value = "&", s;
              }
              return r;
            }(c.default);
            e.default = u, n.exports = e.default;
          } }), ff = R({ "node_modules/postcss-selector-parser/dist/sortAscending.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = i;
            function i(c) {
              return c.sort(function(o, h) {
                return o - h;
              });
            }
            n.exports = e.default;
          } }), pf = R({ "node_modules/postcss-selector-parser/dist/tokenize.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = H;
            var i = 39, c = 34, o = 92, h = 47, l = 10, f = 32, m = 12, u = 9, t3 = 13, r = 43, a = 62, s = 126, p = 124, g = 44, v = 40, y = 41, w = 91, d = 93, _ = 59, S = 42, x = 58, N = 38, P = 64, W = /[ \n\t\r\{\(\)'"\\;/]/g, U = /[ \n\t\r\(\)\*:;@!&'"\+\|~>,\[\]\\]|\/(?=\*)/g;
            function H(D) {
              for (var $ = [], B = D.css.valueOf(), O = void 0, j = void 0, C = void 0, I = void 0, X = void 0, Z = void 0, Q = void 0, K = void 0, J = void 0, M = void 0, Y = void 0, G = B.length, E = -1, k = 1, b = 0, L = function(T, F) {
                if (D.safe)
                  B += F, j = B.length - 1;
                else
                  throw D.error("Unclosed " + T, k, b - E, b);
              }; b < G; ) {
                switch (O = B.charCodeAt(b), O === l && (E = b, k += 1), O) {
                  case l:
                  case f:
                  case u:
                  case t3:
                  case m:
                    j = b;
                    do
                      j += 1, O = B.charCodeAt(j), O === l && (E = j, k += 1);
                    while (O === f || O === l || O === u || O === t3 || O === m);
                    $.push(["space", B.slice(b, j), k, b - E, b]), b = j - 1;
                    break;
                  case r:
                  case a:
                  case s:
                  case p:
                    j = b;
                    do
                      j += 1, O = B.charCodeAt(j);
                    while (O === r || O === a || O === s || O === p);
                    $.push(["combinator", B.slice(b, j), k, b - E, b]), b = j - 1;
                    break;
                  case S:
                    $.push(["*", "*", k, b - E, b]);
                    break;
                  case N:
                    $.push(["&", "&", k, b - E, b]);
                    break;
                  case g:
                    $.push([",", ",", k, b - E, b]);
                    break;
                  case w:
                    $.push(["[", "[", k, b - E, b]);
                    break;
                  case d:
                    $.push(["]", "]", k, b - E, b]);
                    break;
                  case x:
                    $.push([":", ":", k, b - E, b]);
                    break;
                  case _:
                    $.push([";", ";", k, b - E, b]);
                    break;
                  case v:
                    $.push(["(", "(", k, b - E, b]);
                    break;
                  case y:
                    $.push([")", ")", k, b - E, b]);
                    break;
                  case i:
                  case c:
                    C = O === i ? "'" : '"', j = b;
                    do
                      for (M = false, j = B.indexOf(C, j + 1), j === -1 && L("quote", C), Y = j; B.charCodeAt(Y - 1) === o; )
                        Y -= 1, M = !M;
                    while (M);
                    $.push(["string", B.slice(b, j + 1), k, b - E, k, j - E, b]), b = j;
                    break;
                  case P:
                    W.lastIndex = b + 1, W.test(B), W.lastIndex === 0 ? j = B.length - 1 : j = W.lastIndex - 2, $.push(["at-word", B.slice(b, j + 1), k, b - E, k, j - E, b]), b = j;
                    break;
                  case o:
                    for (j = b, Q = true; B.charCodeAt(j + 1) === o; )
                      j += 1, Q = !Q;
                    O = B.charCodeAt(j + 1), Q && O !== h && O !== f && O !== l && O !== u && O !== t3 && O !== m && (j += 1), $.push(["word", B.slice(b, j + 1), k, b - E, k, j - E, b]), b = j;
                    break;
                  default:
                    O === h && B.charCodeAt(b + 1) === S ? (j = B.indexOf("*/", b + 2) + 1, j === 0 && L("comment", "*/"), Z = B.slice(b, j + 1), I = Z.split(`
`), X = I.length - 1, X > 0 ? (K = k + X, J = j - I[X].length) : (K = k, J = E), $.push(["comment", Z, k, b - E, K, j - J, b]), E = J, k = K, b = j) : (U.lastIndex = b + 1, U.test(B), U.lastIndex === 0 ? j = B.length - 1 : j = U.lastIndex - 2, $.push(["word", B.slice(b, j + 1), k, b - E, k, j - E, b]), b = j);
                    break;
                }
                b++;
              }
              return $;
            }
            n.exports = e.default;
          } }), hf = R({ "node_modules/postcss-selector-parser/dist/parser.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function E(k, b) {
                for (var L = 0; L < b.length; L++) {
                  var q = b[L];
                  q.enumerable = q.enumerable || false, q.configurable = true, "value" in q && (q.writable = true), Object.defineProperty(k, q.key, q);
                }
              }
              return function(k, b, L) {
                return b && E(k.prototype, b), L && E(k, L), k;
              };
            }(), c = To(), o = M(c), h = Eo(), l = M(h), f = qo(), m = M(f), u = Ao(), t3 = M(u), r = Po(), a = M(r), s = Ro(), p = M(s), g = Io(), v = M(g), y = Co(), w = M(y), d = No(), _ = M(d), S = jo(), x = M(S), N = Mo(), P = M(N), W = Do(), U = M(W), H = Lo(), D = M(H), $ = zo(), B = M($), O = Bo(), j = M(O), C = ff(), I = M(C), X = pf(), Z = M(X), Q = oe(), K = J(Q);
            function J(E) {
              if (E && E.__esModule)
                return E;
              var k = {};
              if (E != null)
                for (var b in E)
                  Object.prototype.hasOwnProperty.call(E, b) && (k[b] = E[b]);
              return k.default = E, k;
            }
            function M(E) {
              return E && E.__esModule ? E : { default: E };
            }
            function Y(E, k) {
              if (!(E instanceof k))
                throw new TypeError("Cannot call a class as a function");
            }
            var G = function() {
              function E(k) {
                Y(this, E), this.input = k, this.lossy = k.options.lossless === false, this.position = 0, this.root = new t3.default();
                var b = new a.default();
                return this.root.append(b), this.current = b, this.lossy ? this.tokens = (0, Z.default)({ safe: k.safe, css: k.css.trim() }) : this.tokens = (0, Z.default)(k), this.loop();
              }
              return E.prototype.attribute = function() {
                var b = "", L = void 0, q = this.currToken;
                for (this.position++; this.position < this.tokens.length && this.currToken[0] !== "]"; )
                  b += this.tokens[this.position][1], this.position++;
                this.position === this.tokens.length && !~b.indexOf("]") && this.error("Expected a closing square bracket.");
                var T = b.split(/((?:[*~^$|]?=))([^]*)/), F = T[0].split(/(\|)/g), z = { operator: T[1], value: T[2], source: { start: { line: q[2], column: q[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: q[4] };
                if (F.length > 1 ? (F[0] === "" && (F[0] = true), z.attribute = this.parseValue(F[2]), z.namespace = this.parseNamespace(F[0])) : z.attribute = this.parseValue(T[0]), L = new U.default(z), T[2]) {
                  var re = T[2].split(/(\s+i\s*?)$/), ne = re[0].trim();
                  L.value = this.lossy ? ne : re[0], re[1] && (L.insensitive = true, this.lossy || (L.raws.insensitive = re[1])), L.quoted = ne[0] === "'" || ne[0] === '"', L.raws.unquoted = L.quoted ? ne.slice(1, -1) : ne;
                }
                this.newNode(L), this.position++;
              }, E.prototype.combinator = function() {
                if (this.currToken[1] === "|")
                  return this.namespace();
                for (var b = new B.default({ value: "", source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }); this.position < this.tokens.length && this.currToken && (this.currToken[0] === "space" || this.currToken[0] === "combinator"); )
                  this.nextToken && this.nextToken[0] === "combinator" ? (b.spaces.before = this.parseSpace(this.currToken[1]), b.source.start.line = this.nextToken[2], b.source.start.column = this.nextToken[3], b.source.end.column = this.nextToken[3], b.source.end.line = this.nextToken[2], b.sourceIndex = this.nextToken[4]) : this.prevToken && this.prevToken[0] === "combinator" ? b.spaces.after = this.parseSpace(this.currToken[1]) : this.currToken[0] === "combinator" ? b.value = this.currToken[1] : this.currToken[0] === "space" && (b.value = this.parseSpace(this.currToken[1], " ")), this.position++;
                return this.newNode(b);
              }, E.prototype.comma = function() {
                if (this.position === this.tokens.length - 1) {
                  this.root.trailingComma = true, this.position++;
                  return;
                }
                var b = new a.default();
                this.current.parent.append(b), this.current = b, this.position++;
              }, E.prototype.comment = function() {
                var b = new v.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] });
                this.newNode(b), this.position++;
              }, E.prototype.error = function(b) {
                throw new this.input.error(b);
              }, E.prototype.missingBackslash = function() {
                return this.error("Expected a backslash preceding the semicolon.");
              }, E.prototype.missingParenthesis = function() {
                return this.error("Expected opening parenthesis.");
              }, E.prototype.missingSquareBracket = function() {
                return this.error("Expected opening square bracket.");
              }, E.prototype.namespace = function() {
                var b = this.prevToken && this.prevToken[1] || true;
                if (this.nextToken[0] === "word")
                  return this.position++, this.word(b);
                if (this.nextToken[0] === "*")
                  return this.position++, this.universal(b);
              }, E.prototype.nesting = function() {
                this.newNode(new j.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] })), this.position++;
              }, E.prototype.parentheses = function() {
                var b = this.current.last;
                if (b && b.type === K.PSEUDO) {
                  var L = new a.default(), q = this.current;
                  b.append(L), this.current = L;
                  var T = 1;
                  for (this.position++; this.position < this.tokens.length && T; )
                    this.currToken[0] === "(" && T++, this.currToken[0] === ")" && T--, T ? this.parse() : (L.parent.source.end.line = this.currToken[2], L.parent.source.end.column = this.currToken[3], this.position++);
                  T && this.error("Expected closing parenthesis."), this.current = q;
                } else {
                  var F = 1;
                  for (this.position++, b.value += "("; this.position < this.tokens.length && F; )
                    this.currToken[0] === "(" && F++, this.currToken[0] === ")" && F--, b.value += this.parseParenthesisToken(this.currToken), this.position++;
                  F && this.error("Expected closing parenthesis.");
                }
              }, E.prototype.pseudo = function() {
                for (var b = this, L = "", q = this.currToken; this.currToken && this.currToken[0] === ":"; )
                  L += this.currToken[1], this.position++;
                if (!this.currToken)
                  return this.error("Expected pseudo-class or pseudo-element");
                if (this.currToken[0] === "word") {
                  var T = void 0;
                  this.splitWord(false, function(F, z) {
                    L += F, T = new P.default({ value: L, source: { start: { line: q[2], column: q[3] }, end: { line: b.currToken[4], column: b.currToken[5] } }, sourceIndex: q[4] }), b.newNode(T), z > 1 && b.nextToken && b.nextToken[0] === "(" && b.error("Misplaced parenthesis.");
                  });
                } else
                  this.error('Unexpected "' + this.currToken[0] + '" found.');
              }, E.prototype.space = function() {
                var b = this.currToken;
                this.position === 0 || this.prevToken[0] === "," || this.prevToken[0] === "(" ? (this.spaces = this.parseSpace(b[1]), this.position++) : this.position === this.tokens.length - 1 || this.nextToken[0] === "," || this.nextToken[0] === ")" ? (this.current.last.spaces.after = this.parseSpace(b[1]), this.position++) : this.combinator();
              }, E.prototype.string = function() {
                var b = this.currToken;
                this.newNode(new x.default({ value: this.currToken[1], source: { start: { line: b[2], column: b[3] }, end: { line: b[4], column: b[5] } }, sourceIndex: b[6] })), this.position++;
              }, E.prototype.universal = function(b) {
                var L = this.nextToken;
                if (L && L[1] === "|")
                  return this.position++, this.namespace();
                this.newNode(new D.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }), b), this.position++;
              }, E.prototype.splitWord = function(b, L) {
                for (var q = this, T = this.nextToken, F = this.currToken[1]; T && T[0] === "word"; ) {
                  this.position++;
                  var z = this.currToken[1];
                  if (F += z, z.lastIndexOf("\\") === z.length - 1) {
                    var re = this.nextToken;
                    re && re[0] === "space" && (F += this.parseSpace(re[1], " "), this.position++);
                  }
                  T = this.nextToken;
                }
                var ne = (0, l.default)(F, "."), ce = (0, l.default)(F, "#"), fe = (0, l.default)(F, "#{");
                fe.length && (ce = ce.filter(function(ie) {
                  return !~fe.indexOf(ie);
                }));
                var te = (0, I.default)((0, m.default)((0, o.default)([[0], ne, ce])));
                te.forEach(function(ie, ae) {
                  var se = te[ae + 1] || F.length, le = F.slice(ie, se);
                  if (ae === 0 && L)
                    return L.call(q, le, te.length);
                  var pe = void 0;
                  ~ne.indexOf(ie) ? pe = new p.default({ value: le.slice(1), source: { start: { line: q.currToken[2], column: q.currToken[3] + ie }, end: { line: q.currToken[4], column: q.currToken[3] + (se - 1) } }, sourceIndex: q.currToken[6] + te[ae] }) : ~ce.indexOf(ie) ? pe = new w.default({ value: le.slice(1), source: { start: { line: q.currToken[2], column: q.currToken[3] + ie }, end: { line: q.currToken[4], column: q.currToken[3] + (se - 1) } }, sourceIndex: q.currToken[6] + te[ae] }) : pe = new _.default({ value: le, source: { start: { line: q.currToken[2], column: q.currToken[3] + ie }, end: { line: q.currToken[4], column: q.currToken[3] + (se - 1) } }, sourceIndex: q.currToken[6] + te[ae] }), q.newNode(pe, b);
                }), this.position++;
              }, E.prototype.word = function(b) {
                var L = this.nextToken;
                return L && L[1] === "|" ? (this.position++, this.namespace()) : this.splitWord(b);
              }, E.prototype.loop = function() {
                for (; this.position < this.tokens.length; )
                  this.parse(true);
                return this.root;
              }, E.prototype.parse = function(b) {
                switch (this.currToken[0]) {
                  case "space":
                    this.space();
                    break;
                  case "comment":
                    this.comment();
                    break;
                  case "(":
                    this.parentheses();
                    break;
                  case ")":
                    b && this.missingParenthesis();
                    break;
                  case "[":
                    this.attribute();
                    break;
                  case "]":
                    this.missingSquareBracket();
                    break;
                  case "at-word":
                  case "word":
                    this.word();
                    break;
                  case ":":
                    this.pseudo();
                    break;
                  case ";":
                    this.missingBackslash();
                    break;
                  case ",":
                    this.comma();
                    break;
                  case "*":
                    this.universal();
                    break;
                  case "&":
                    this.nesting();
                    break;
                  case "combinator":
                    this.combinator();
                    break;
                  case "string":
                    this.string();
                    break;
                }
              }, E.prototype.parseNamespace = function(b) {
                if (this.lossy && typeof b == "string") {
                  var L = b.trim();
                  return L.length ? L : true;
                }
                return b;
              }, E.prototype.parseSpace = function(b, L) {
                return this.lossy ? L || "" : b;
              }, E.prototype.parseValue = function(b) {
                return this.lossy && b && typeof b == "string" ? b.trim() : b;
              }, E.prototype.parseParenthesisToken = function(b) {
                return this.lossy ? b[0] === "space" ? this.parseSpace(b[1], " ") : this.parseValue(b[1]) : b[1];
              }, E.prototype.newNode = function(b, L) {
                return L && (b.namespace = this.parseNamespace(L)), this.spaces && (b.spaces.before = this.spaces, this.spaces = ""), this.current.append(b);
              }, i(E, [{ key: "currToken", get: function() {
                return this.tokens[this.position];
              } }, { key: "nextToken", get: function() {
                return this.tokens[this.position + 1];
              } }, { key: "prevToken", get: function() {
                return this.tokens[this.position - 1];
              } }]), E;
            }();
            e.default = G, n.exports = e.default;
          } }), df = R({ "node_modules/postcss-selector-parser/dist/processor.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function m(u, t3) {
                for (var r = 0; r < t3.length; r++) {
                  var a = t3[r];
                  a.enumerable = a.enumerable || false, a.configurable = true, "value" in a && (a.writable = true), Object.defineProperty(u, a.key, a);
                }
              }
              return function(u, t3, r) {
                return t3 && m(u.prototype, t3), r && m(u, r), u;
              };
            }(), c = hf(), o = h(c);
            function h(m) {
              return m && m.__esModule ? m : { default: m };
            }
            function l(m, u) {
              if (!(m instanceof u))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function() {
              function m(u) {
                return l(this, m), this.func = u || function() {
                }, this;
              }
              return m.prototype.process = function(t3) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = new o.default({ css: t3, error: function(p) {
                  throw new Error(p);
                }, options: r });
                return this.res = a, this.func(a), this;
              }, i(m, [{ key: "result", get: function() {
                return String(this.res);
              } }]), m;
            }();
            e.default = f, n.exports = e.default;
          } }), vf = R({ "node_modules/postcss-selector-parser/dist/index.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = df(), c = O(i), o = Do(), h = O(o), l = Ro(), f = O(l), m = zo(), u = O(m), t3 = Io(), r = O(t3), a = Co(), s = O(a), p = Bo(), g = O(p), v = Mo(), y = O(v), w = Ao(), d = O(w), _ = Po(), S = O(_), x = jo(), N = O(x), P = No(), W = O(P), U = Lo(), H = O(U), D = oe(), $ = B(D);
            function B(C) {
              if (C && C.__esModule)
                return C;
              var I = {};
              if (C != null)
                for (var X in C)
                  Object.prototype.hasOwnProperty.call(C, X) && (I[X] = C[X]);
              return I.default = C, I;
            }
            function O(C) {
              return C && C.__esModule ? C : { default: C };
            }
            var j = function(I) {
              return new c.default(I);
            };
            j.attribute = function(C) {
              return new h.default(C);
            }, j.className = function(C) {
              return new f.default(C);
            }, j.combinator = function(C) {
              return new u.default(C);
            }, j.comment = function(C) {
              return new r.default(C);
            }, j.id = function(C) {
              return new s.default(C);
            }, j.nesting = function(C) {
              return new g.default(C);
            }, j.pseudo = function(C) {
              return new y.default(C);
            }, j.root = function(C) {
              return new d.default(C);
            }, j.selector = function(C) {
              return new S.default(C);
            }, j.string = function(C) {
              return new N.default(C);
            }, j.tag = function(C) {
              return new W.default(C);
            }, j.universal = function(C) {
              return new H.default(C);
            }, Object.keys($).forEach(function(C) {
              C !== "__esModule" && (j[C] = $[C]);
            }), e.default = j, n.exports = e.default;
          } }), Fo = R({ "node_modules/postcss-media-query-parser/dist/nodes/Node.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true });
            function n(i) {
              this.after = i.after, this.before = i.before, this.type = i.type, this.value = i.value, this.sourceIndex = i.sourceIndex;
            }
            e.default = n;
          } }), Uo = R({ "node_modules/postcss-media-query-parser/dist/nodes/Container.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Fo(), i = c(n);
            function c(h) {
              return h && h.__esModule ? h : { default: h };
            }
            function o(h) {
              var l = this;
              this.constructor(h), this.nodes = h.nodes, this.after === void 0 && (this.after = this.nodes.length > 0 ? this.nodes[this.nodes.length - 1].after : ""), this.before === void 0 && (this.before = this.nodes.length > 0 ? this.nodes[0].before : ""), this.sourceIndex === void 0 && (this.sourceIndex = this.before.length), this.nodes.forEach(function(f) {
                f.parent = l;
              });
            }
            o.prototype = Object.create(i.default.prototype), o.constructor = i.default, o.prototype.walk = function(l, f) {
              for (var m = typeof l == "string" || l instanceof RegExp, u = m ? f : l, t3 = typeof l == "string" ? new RegExp(l) : l, r = 0; r < this.nodes.length; r++) {
                var a = this.nodes[r], s = m ? t3.test(a.type) : true;
                if (s && u && u(a, r, this.nodes) === false || a.nodes && a.walk(l, f) === false)
                  return false;
              }
              return true;
            }, o.prototype.each = function() {
              for (var l = arguments.length <= 0 || arguments[0] === void 0 ? function() {
              } : arguments[0], f = 0; f < this.nodes.length; f++) {
                var m = this.nodes[f];
                if (l(m, f, this.nodes) === false)
                  return false;
              }
              return true;
            }, e.default = o;
          } }), mf = R({ "node_modules/postcss-media-query-parser/dist/parsers.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true }), e.parseMediaFeature = l, e.parseMediaQuery = f, e.parseMediaList = m;
            var n = Fo(), i = h(n), c = Uo(), o = h(c);
            function h(u) {
              return u && u.__esModule ? u : { default: u };
            }
            function l(u) {
              var t3 = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1], r = [{ mode: "normal", character: null }], a = [], s = 0, p = "", g = null, v = null, y = t3, w = u;
              u[0] === "(" && u[u.length - 1] === ")" && (w = u.substring(1, u.length - 1), y++);
              for (var d = 0; d < w.length; d++) {
                var _ = w[d];
                if ((_ === "'" || _ === '"') && (r[s].isCalculationEnabled === true ? (r.push({ mode: "string", isCalculationEnabled: false, character: _ }), s++) : r[s].mode === "string" && r[s].character === _ && w[d - 1] !== "\\" && (r.pop(), s--)), _ === "{" ? (r.push({ mode: "interpolation", isCalculationEnabled: true }), s++) : _ === "}" && (r.pop(), s--), r[s].mode === "normal" && _ === ":") {
                  var S = w.substring(d + 1);
                  v = { type: "value", before: /^(\s*)/.exec(S)[1], after: /(\s*)$/.exec(S)[1], value: S.trim() }, v.sourceIndex = v.before.length + d + 1 + y, g = { type: "colon", sourceIndex: d + y, after: v.before, value: ":" };
                  break;
                }
                p += _;
              }
              return p = { type: "media-feature", before: /^(\s*)/.exec(p)[1], after: /(\s*)$/.exec(p)[1], value: p.trim() }, p.sourceIndex = p.before.length + y, a.push(p), g !== null && (g.before = p.after, a.push(g)), v !== null && a.push(v), a;
            }
            function f(u) {
              var t3 = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1], r = [], a = 0, s = false, p = void 0;
              function g() {
                return { before: "", after: "", value: "" };
              }
              p = g();
              for (var v = 0; v < u.length; v++) {
                var y = u[v];
                s ? (p.value += y, (y === "{" || y === "(") && a++, (y === ")" || y === "}") && a--) : y.search(/\s/) !== -1 ? p.before += y : (y === "(" && (p.type = "media-feature-expression", a++), p.value = y, p.sourceIndex = t3 + v, s = true), s && a === 0 && (y === ")" || v === u.length - 1 || u[v + 1].search(/\s/) !== -1) && (["not", "only", "and"].indexOf(p.value) !== -1 && (p.type = "keyword"), p.type === "media-feature-expression" && (p.nodes = l(p.value, p.sourceIndex)), r.push(Array.isArray(p.nodes) ? new o.default(p) : new i.default(p)), p = g(), s = false);
              }
              for (var w = 0; w < r.length; w++)
                if (p = r[w], w > 0 && (r[w - 1].after = p.before), p.type === void 0) {
                  if (w > 0) {
                    if (r[w - 1].type === "media-feature-expression") {
                      p.type = "keyword";
                      continue;
                    }
                    if (r[w - 1].value === "not" || r[w - 1].value === "only") {
                      p.type = "media-type";
                      continue;
                    }
                    if (r[w - 1].value === "and") {
                      p.type = "media-feature-expression";
                      continue;
                    }
                    r[w - 1].type === "media-type" && (r[w + 1] ? p.type = r[w + 1].type === "media-feature-expression" ? "keyword" : "media-feature-expression" : p.type = "media-feature-expression");
                  }
                  if (w === 0) {
                    if (!r[w + 1]) {
                      p.type = "media-type";
                      continue;
                    }
                    if (r[w + 1] && (r[w + 1].type === "media-feature-expression" || r[w + 1].type === "keyword")) {
                      p.type = "media-type";
                      continue;
                    }
                    if (r[w + 2]) {
                      if (r[w + 2].type === "media-feature-expression") {
                        p.type = "media-type", r[w + 1].type = "keyword";
                        continue;
                      }
                      if (r[w + 2].type === "keyword") {
                        p.type = "keyword", r[w + 1].type = "media-type";
                        continue;
                      }
                    }
                    if (r[w + 3] && r[w + 3].type === "media-feature-expression") {
                      p.type = "keyword", r[w + 1].type = "media-type", r[w + 2].type = "keyword";
                      continue;
                    }
                  }
                }
              return r;
            }
            function m(u) {
              var t3 = [], r = 0, a = 0, s = /^(\s*)url\s*\(/.exec(u);
              if (s !== null) {
                for (var p = s[0].length, g = 1; g > 0; ) {
                  var v = u[p];
                  v === "(" && g++, v === ")" && g--, p++;
                }
                t3.unshift(new i.default({ type: "url", value: u.substring(0, p).trim(), sourceIndex: s[1].length, before: s[1], after: /^(\s*)/.exec(u.substring(p))[1] })), r = p;
              }
              for (var y = r; y < u.length; y++) {
                var w = u[y];
                if (w === "(" && a++, w === ")" && a--, a === 0 && w === ",") {
                  var d = u.substring(r, y), _ = /^(\s*)/.exec(d)[1];
                  t3.push(new o.default({ type: "media-query", value: d.trim(), sourceIndex: r + _.length, nodes: f(d, r), before: _, after: /(\s*)$/.exec(d)[1] })), r = y + 1;
                }
              }
              var S = u.substring(r), x = /^(\s*)/.exec(S)[1];
              return t3.push(new o.default({ type: "media-query", value: S.trim(), sourceIndex: r + x.length, nodes: f(S, r), before: x, after: /(\s*)$/.exec(S)[1] })), t3;
            }
          } }), gf = R({ "node_modules/postcss-media-query-parser/dist/index.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true }), e.default = h;
            var n = Uo(), i = o(n), c = mf();
            function o(l) {
              return l && l.__esModule ? l : { default: l };
            }
            function h(l) {
              return new i.default({ nodes: (0, c.parseMediaList)(l), type: "media-query-list", value: l.trim() });
            }
          } }), Wo = {};
          Ot(Wo, { basename: () => Jo, default: () => Qo, delimiter: () => _t, dirname: () => Ho, extname: () => Ko, isAbsolute: () => jt, join: () => Vo, normalize: () => Nt, relative: () => Go, resolve: () => mr, sep: () => wt });
          function $o(e, n) {
            for (var i = 0, c = e.length - 1; c >= 0; c--) {
              var o = e[c];
              o === "." ? e.splice(c, 1) : o === ".." ? (e.splice(c, 1), i++) : i && (e.splice(c, 1), i--);
            }
            if (n)
              for (; i--; i)
                e.unshift("..");
            return e;
          }
          function mr() {
            for (var e = "", n = false, i = arguments.length - 1; i >= -1 && !n; i--) {
              var c = i >= 0 ? arguments[i] : "/";
              if (typeof c != "string")
                throw new TypeError("Arguments to path.resolve must be strings");
              if (!c)
                continue;
              e = c + "/" + e, n = c.charAt(0) === "/";
            }
            return e = $o(Mt(e.split("/"), function(o) {
              return !!o;
            }), !n).join("/"), (n ? "/" : "") + e || ".";
          }
          function Nt(e) {
            var n = jt(e), i = Yo(e, -1) === "/";
            return e = $o(Mt(e.split("/"), function(c) {
              return !!c;
            }), !n).join("/"), !e && !n && (e = "."), e && i && (e += "/"), (n ? "/" : "") + e;
          }
          function jt(e) {
            return e.charAt(0) === "/";
          }
          function Vo() {
            var e = Array.prototype.slice.call(arguments, 0);
            return Nt(Mt(e, function(n, i) {
              if (typeof n != "string")
                throw new TypeError("Arguments to path.join must be strings");
              return n;
            }).join("/"));
          }
          function Go(e, n) {
            e = mr(e).substr(1), n = mr(n).substr(1);
            function i(u) {
              for (var t3 = 0; t3 < u.length && u[t3] === ""; t3++)
                ;
              for (var r = u.length - 1; r >= 0 && u[r] === ""; r--)
                ;
              return t3 > r ? [] : u.slice(t3, r - t3 + 1);
            }
            for (var c = i(e.split("/")), o = i(n.split("/")), h = Math.min(c.length, o.length), l = h, f = 0; f < h; f++)
              if (c[f] !== o[f]) {
                l = f;
                break;
              }
            for (var m = [], f = l; f < c.length; f++)
              m.push("..");
            return m = m.concat(o.slice(l)), m.join("/");
          }
          function Ho(e) {
            var n = wr(e), i = n[0], c = n[1];
            return !i && !c ? "." : (c && (c = c.substr(0, c.length - 1)), i + c);
          }
          function Jo(e, n) {
            var i = wr(e)[2];
            return n && i.substr(-1 * n.length) === n && (i = i.substr(0, i.length - n.length)), i;
          }
          function Ko(e) {
            return wr(e)[3];
          }
          function Mt(e, n) {
            if (e.filter)
              return e.filter(n);
            for (var i = [], c = 0; c < e.length; c++)
              n(e[c], c, e) && i.push(e[c]);
            return i;
          }
          var Is, wr, wt, _t, Qo, Yo, yf = Le({ "node-modules-polyfills:path"() {
            A(), Is = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, wr = function(e) {
              return Is.exec(e).slice(1);
            }, wt = "/", _t = ":", Qo = { extname: Ko, basename: Jo, dirname: Ho, sep: wt, delimiter: _t, relative: Go, join: Vo, isAbsolute: jt, normalize: Nt, resolve: mr }, Yo = "ab".substr(-1) === "b" ? function(e, n, i) {
              return e.substr(n, i);
            } : function(e, n, i) {
              return n < 0 && (n = e.length + n), e.substr(n, i);
            };
          } }), wf = R({ "node-modules-polyfills-commonjs:path"(e, n) {
            A();
            var i = (yf(), Tt(Wo));
            if (i && i.default) {
              n.exports = i.default;
              for (let c in i)
                n.exports[c] = i[c];
            } else
              i && (n.exports = i);
          } }), _f = R({ "node_modules/picocolors/picocolors.browser.js"(e, n) {
            A();
            var i = String, c = function() {
              return { isColorSupported: false, reset: i, bold: i, dim: i, italic: i, underline: i, inverse: i, hidden: i, strikethrough: i, black: i, red: i, green: i, yellow: i, blue: i, magenta: i, cyan: i, white: i, gray: i, bgBlack: i, bgRed: i, bgGreen: i, bgYellow: i, bgBlue: i, bgMagenta: i, bgCyan: i, bgWhite: i };
            };
            n.exports = c(), n.exports.createColors = c;
          } }), bf = R({ "(disabled):node_modules/postcss/lib/terminal-highlight"() {
            A();
          } }), Xo = R({ "node_modules/postcss/lib/css-syntax-error.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = o(_f()), c = o(bf());
            function o(g) {
              return g && g.__esModule ? g : { default: g };
            }
            function h(g) {
              if (g === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return g;
            }
            function l(g, v) {
              g.prototype = Object.create(v.prototype), g.prototype.constructor = g, g.__proto__ = v;
            }
            function f(g) {
              var v = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
              return f = function(w) {
                if (w === null || !t3(w))
                  return w;
                if (typeof w != "function")
                  throw new TypeError("Super expression must either be null or a function");
                if (typeof v < "u") {
                  if (v.has(w))
                    return v.get(w);
                  v.set(w, d);
                }
                function d() {
                  return m(w, arguments, a(this).constructor);
                }
                return d.prototype = Object.create(w.prototype, { constructor: { value: d, enumerable: false, writable: true, configurable: true } }), r(d, w);
              }, f(g);
            }
            function m(g, v, y) {
              return u() ? m = Reflect.construct : m = function(d, _, S) {
                var x = [null];
                x.push.apply(x, _);
                var N = Function.bind.apply(d, x), P = new N();
                return S && r(P, S.prototype), P;
              }, m.apply(null, arguments);
            }
            function u() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return false;
              if (typeof Proxy == "function")
                return true;
              try {
                return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
                })), true;
              } catch {
                return false;
              }
            }
            function t3(g) {
              return Function.toString.call(g).indexOf("[native code]") !== -1;
            }
            function r(g, v) {
              return r = Object.setPrototypeOf || function(w, d) {
                return w.__proto__ = d, w;
              }, r(g, v);
            }
            function a(g) {
              return a = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, a(g);
            }
            var s = function(g) {
              l(v, g);
              function v(w, d, _, S, x, N) {
                var P;
                return P = g.call(this, w) || this, P.name = "CssSyntaxError", P.reason = w, x && (P.file = x), S && (P.source = S), N && (P.plugin = N), typeof d < "u" && typeof _ < "u" && (P.line = d, P.column = _), P.setMessage(), Error.captureStackTrace && Error.captureStackTrace(h(P), v), P;
              }
              var y = v.prototype;
              return y.setMessage = function() {
                this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
              }, y.showSourceCode = function(d) {
                var _ = this;
                if (!this.source)
                  return "";
                var S = this.source;
                c.default && (typeof d > "u" && (d = i.default.isColorSupported), d && (S = (0, c.default)(S)));
                var x = S.split(/\r?\n/), N = Math.max(this.line - 3, 0), P = Math.min(this.line + 2, x.length), W = String(P).length;
                function U(D) {
                  return d && i.default.red ? i.default.red(i.default.bold(D)) : D;
                }
                function H(D) {
                  return d && i.default.gray ? i.default.gray(D) : D;
                }
                return x.slice(N, P).map(function(D, $) {
                  var B = N + 1 + $, O = " " + (" " + B).slice(-W) + " | ";
                  if (B === _.line) {
                    var j = H(O.replace(/\d/g, " ")) + D.slice(0, _.column - 1).replace(/[^\t]/g, " ");
                    return U(">") + H(O) + D + `
 ` + j + U("^");
                  }
                  return " " + H(O) + D;
                }).join(`
`);
              }, y.toString = function() {
                var d = this.showSourceCode();
                return d && (d = `

` + d + `
`), this.name + ": " + this.message + d;
              }, v;
            }(f(Error)), p = s;
            e.default = p, n.exports = e.default;
          } }), xf = R({ "node_modules/postcss/lib/previous-map.js"(e, n) {
            A(), n.exports = class {
            };
          } }), _r = R({ "node_modules/postcss/lib/input.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = h(wf()), c = h(Xo()), o = h(xf());
            function h(r) {
              return r && r.__esModule ? r : { default: r };
            }
            function l(r, a) {
              for (var s = 0; s < a.length; s++) {
                var p = a[s];
                p.enumerable = p.enumerable || false, p.configurable = true, "value" in p && (p.writable = true), Object.defineProperty(r, p.key, p);
              }
            }
            function f(r, a, s) {
              return a && l(r.prototype, a), s && l(r, s), r;
            }
            var m = 0, u = function() {
              function r(s, p) {
                if (p === void 0 && (p = {}), s === null || typeof s > "u" || typeof s == "object" && !s.toString)
                  throw new Error("PostCSS received " + s + " instead of CSS string");
                this.css = s.toString(), this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE" ? (this.hasBOM = true, this.css = this.css.slice(1)) : this.hasBOM = false, p.from && (/^\w+:\/\//.test(p.from) || i.default.isAbsolute(p.from) ? this.file = p.from : this.file = i.default.resolve(p.from));
                var g = new o.default(this.css, p);
                if (g.text) {
                  this.map = g;
                  var v = g.consumer().file;
                  !this.file && v && (this.file = this.mapResolve(v));
                }
                this.file || (m += 1, this.id = "<input css " + m + ">"), this.map && (this.map.file = this.from);
              }
              var a = r.prototype;
              return a.error = function(p, g, v, y) {
                y === void 0 && (y = {});
                var w, d = this.origin(g, v);
                return d ? w = new c.default(p, d.line, d.column, d.source, d.file, y.plugin) : w = new c.default(p, g, v, this.css, this.file, y.plugin), w.input = { line: g, column: v, source: this.css }, this.file && (w.input.file = this.file), w;
              }, a.origin = function(p, g) {
                if (!this.map)
                  return false;
                var v = this.map.consumer(), y = v.originalPositionFor({ line: p, column: g });
                if (!y.source)
                  return false;
                var w = { file: this.mapResolve(y.source), line: y.line, column: y.column }, d = v.sourceContentFor(y.source);
                return d && (w.source = d), w;
              }, a.mapResolve = function(p) {
                return /^\w+:\/\//.test(p) ? p : i.default.resolve(this.map.consumer().sourceRoot || ".", p);
              }, f(r, [{ key: "from", get: function() {
                return this.file || this.id;
              } }]), r;
            }(), t3 = u;
            e.default = t3, n.exports = e.default;
          } }), br = R({ "node_modules/postcss/lib/stringifier.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = { colon: ": ", indent: "    ", beforeDecl: `
`, beforeRule: `
`, beforeOpen: " ", beforeClose: `
`, beforeComment: `
`, after: `
`, emptyBody: "", commentLeft: " ", commentRight: " ", semicolon: false };
            function c(l) {
              return l[0].toUpperCase() + l.slice(1);
            }
            var o = function() {
              function l(m) {
                this.builder = m;
              }
              var f = l.prototype;
              return f.stringify = function(u, t3) {
                this[u.type](u, t3);
              }, f.root = function(u) {
                this.body(u), u.raws.after && this.builder(u.raws.after);
              }, f.comment = function(u) {
                var t3 = this.raw(u, "left", "commentLeft"), r = this.raw(u, "right", "commentRight");
                this.builder("/*" + t3 + u.text + r + "*/", u);
              }, f.decl = function(u, t3) {
                var r = this.raw(u, "between", "colon"), a = u.prop + r + this.rawValue(u, "value");
                u.important && (a += u.raws.important || " !important"), t3 && (a += ";"), this.builder(a, u);
              }, f.rule = function(u) {
                this.block(u, this.rawValue(u, "selector")), u.raws.ownSemicolon && this.builder(u.raws.ownSemicolon, u, "end");
              }, f.atrule = function(u, t3) {
                var r = "@" + u.name, a = u.params ? this.rawValue(u, "params") : "";
                if (typeof u.raws.afterName < "u" ? r += u.raws.afterName : a && (r += " "), u.nodes)
                  this.block(u, r + a);
                else {
                  var s = (u.raws.between || "") + (t3 ? ";" : "");
                  this.builder(r + a + s, u);
                }
              }, f.body = function(u) {
                for (var t3 = u.nodes.length - 1; t3 > 0 && u.nodes[t3].type === "comment"; )
                  t3 -= 1;
                for (var r = this.raw(u, "semicolon"), a = 0; a < u.nodes.length; a++) {
                  var s = u.nodes[a], p = this.raw(s, "before");
                  p && this.builder(p), this.stringify(s, t3 !== a || r);
                }
              }, f.block = function(u, t3) {
                var r = this.raw(u, "between", "beforeOpen");
                this.builder(t3 + r + "{", u, "start");
                var a;
                u.nodes && u.nodes.length ? (this.body(u), a = this.raw(u, "after")) : a = this.raw(u, "after", "emptyBody"), a && this.builder(a), this.builder("}", u, "end");
              }, f.raw = function(u, t3, r) {
                var a;
                if (r || (r = t3), t3 && (a = u.raws[t3], typeof a < "u"))
                  return a;
                var s = u.parent;
                if (r === "before" && (!s || s.type === "root" && s.first === u))
                  return "";
                if (!s)
                  return i[r];
                var p = u.root();
                if (p.rawCache || (p.rawCache = {}), typeof p.rawCache[r] < "u")
                  return p.rawCache[r];
                if (r === "before" || r === "after")
                  return this.beforeAfter(u, r);
                var g = "raw" + c(r);
                return this[g] ? a = this[g](p, u) : p.walk(function(v) {
                  if (a = v.raws[t3], typeof a < "u")
                    return false;
                }), typeof a > "u" && (a = i[r]), p.rawCache[r] = a, a;
              }, f.rawSemicolon = function(u) {
                var t3;
                return u.walk(function(r) {
                  if (r.nodes && r.nodes.length && r.last.type === "decl" && (t3 = r.raws.semicolon, typeof t3 < "u"))
                    return false;
                }), t3;
              }, f.rawEmptyBody = function(u) {
                var t3;
                return u.walk(function(r) {
                  if (r.nodes && r.nodes.length === 0 && (t3 = r.raws.after, typeof t3 < "u"))
                    return false;
                }), t3;
              }, f.rawIndent = function(u) {
                if (u.raws.indent)
                  return u.raws.indent;
                var t3;
                return u.walk(function(r) {
                  var a = r.parent;
                  if (a && a !== u && a.parent && a.parent === u && typeof r.raws.before < "u") {
                    var s = r.raws.before.split(`
`);
                    return t3 = s[s.length - 1], t3 = t3.replace(/[^\s]/g, ""), false;
                  }
                }), t3;
              }, f.rawBeforeComment = function(u, t3) {
                var r;
                return u.walkComments(function(a) {
                  if (typeof a.raws.before < "u")
                    return r = a.raws.before, r.indexOf(`
`) !== -1 && (r = r.replace(/[^\n]+$/, "")), false;
                }), typeof r > "u" ? r = this.raw(t3, null, "beforeDecl") : r && (r = r.replace(/[^\s]/g, "")), r;
              }, f.rawBeforeDecl = function(u, t3) {
                var r;
                return u.walkDecls(function(a) {
                  if (typeof a.raws.before < "u")
                    return r = a.raws.before, r.indexOf(`
`) !== -1 && (r = r.replace(/[^\n]+$/, "")), false;
                }), typeof r > "u" ? r = this.raw(t3, null, "beforeRule") : r && (r = r.replace(/[^\s]/g, "")), r;
              }, f.rawBeforeRule = function(u) {
                var t3;
                return u.walk(function(r) {
                  if (r.nodes && (r.parent !== u || u.first !== r) && typeof r.raws.before < "u")
                    return t3 = r.raws.before, t3.indexOf(`
`) !== -1 && (t3 = t3.replace(/[^\n]+$/, "")), false;
                }), t3 && (t3 = t3.replace(/[^\s]/g, "")), t3;
              }, f.rawBeforeClose = function(u) {
                var t3;
                return u.walk(function(r) {
                  if (r.nodes && r.nodes.length > 0 && typeof r.raws.after < "u")
                    return t3 = r.raws.after, t3.indexOf(`
`) !== -1 && (t3 = t3.replace(/[^\n]+$/, "")), false;
                }), t3 && (t3 = t3.replace(/[^\s]/g, "")), t3;
              }, f.rawBeforeOpen = function(u) {
                var t3;
                return u.walk(function(r) {
                  if (r.type !== "decl" && (t3 = r.raws.between, typeof t3 < "u"))
                    return false;
                }), t3;
              }, f.rawColon = function(u) {
                var t3;
                return u.walkDecls(function(r) {
                  if (typeof r.raws.between < "u")
                    return t3 = r.raws.between.replace(/[^\s:]/g, ""), false;
                }), t3;
              }, f.beforeAfter = function(u, t3) {
                var r;
                u.type === "decl" ? r = this.raw(u, null, "beforeDecl") : u.type === "comment" ? r = this.raw(u, null, "beforeComment") : t3 === "before" ? r = this.raw(u, null, "beforeRule") : r = this.raw(u, null, "beforeClose");
                for (var a = u.parent, s = 0; a && a.type !== "root"; )
                  s += 1, a = a.parent;
                if (r.indexOf(`
`) !== -1) {
                  var p = this.raw(u, null, "indent");
                  if (p.length)
                    for (var g = 0; g < s; g++)
                      r += p;
                }
                return r;
              }, f.rawValue = function(u, t3) {
                var r = u[t3], a = u.raws[t3];
                return a && a.value === r ? a.raw : r;
              }, l;
            }(), h = o;
            e.default = h, n.exports = e.default;
          } }), Zo = R({ "node_modules/postcss/lib/stringify.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = c(br());
            function c(l) {
              return l && l.__esModule ? l : { default: l };
            }
            function o(l, f) {
              var m = new i.default(f);
              m.stringify(l);
            }
            var h = o;
            e.default = h, n.exports = e.default;
          } }), Dt = R({ "node_modules/postcss/lib/node.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = h(Xo()), c = h(br()), o = h(Zo());
            function h(u) {
              return u && u.__esModule ? u : { default: u };
            }
            function l(u, t3) {
              var r = new u.constructor();
              for (var a in u)
                if (!!u.hasOwnProperty(a)) {
                  var s = u[a], p = typeof s;
                  a === "parent" && p === "object" ? t3 && (r[a] = t3) : a === "source" ? r[a] = s : s instanceof Array ? r[a] = s.map(function(g) {
                    return l(g, r);
                  }) : (p === "object" && s !== null && (s = l(s)), r[a] = s);
                }
              return r;
            }
            var f = function() {
              function u(r) {
                r === void 0 && (r = {}), this.raws = {};
                for (var a in r)
                  this[a] = r[a];
              }
              var t3 = u.prototype;
              return t3.error = function(a, s) {
                if (s === void 0 && (s = {}), this.source) {
                  var p = this.positionBy(s);
                  return this.source.input.error(a, p.line, p.column, s);
                }
                return new i.default(a);
              }, t3.warn = function(a, s, p) {
                var g = { node: this };
                for (var v in p)
                  g[v] = p[v];
                return a.warn(s, g);
              }, t3.remove = function() {
                return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
              }, t3.toString = function(a) {
                a === void 0 && (a = o.default), a.stringify && (a = a.stringify);
                var s = "";
                return a(this, function(p) {
                  s += p;
                }), s;
              }, t3.clone = function(a) {
                a === void 0 && (a = {});
                var s = l(this);
                for (var p in a)
                  s[p] = a[p];
                return s;
              }, t3.cloneBefore = function(a) {
                a === void 0 && (a = {});
                var s = this.clone(a);
                return this.parent.insertBefore(this, s), s;
              }, t3.cloneAfter = function(a) {
                a === void 0 && (a = {});
                var s = this.clone(a);
                return this.parent.insertAfter(this, s), s;
              }, t3.replaceWith = function() {
                if (this.parent) {
                  for (var a = arguments.length, s = new Array(a), p = 0; p < a; p++)
                    s[p] = arguments[p];
                  for (var g = 0, v = s; g < v.length; g++) {
                    var y = v[g];
                    this.parent.insertBefore(this, y);
                  }
                  this.remove();
                }
                return this;
              }, t3.next = function() {
                if (!!this.parent) {
                  var a = this.parent.index(this);
                  return this.parent.nodes[a + 1];
                }
              }, t3.prev = function() {
                if (!!this.parent) {
                  var a = this.parent.index(this);
                  return this.parent.nodes[a - 1];
                }
              }, t3.before = function(a) {
                return this.parent.insertBefore(this, a), this;
              }, t3.after = function(a) {
                return this.parent.insertAfter(this, a), this;
              }, t3.toJSON = function() {
                var a = {};
                for (var s in this)
                  if (!!this.hasOwnProperty(s) && s !== "parent") {
                    var p = this[s];
                    p instanceof Array ? a[s] = p.map(function(g) {
                      return typeof g == "object" && g.toJSON ? g.toJSON() : g;
                    }) : typeof p == "object" && p.toJSON ? a[s] = p.toJSON() : a[s] = p;
                  }
                return a;
              }, t3.raw = function(a, s) {
                var p = new c.default();
                return p.raw(this, a, s);
              }, t3.root = function() {
                for (var a = this; a.parent; )
                  a = a.parent;
                return a;
              }, t3.cleanRaws = function(a) {
                delete this.raws.before, delete this.raws.after, a || delete this.raws.between;
              }, t3.positionInside = function(a) {
                for (var s = this.toString(), p = this.source.start.column, g = this.source.start.line, v = 0; v < a; v++)
                  s[v] === `
` ? (p = 1, g += 1) : p += 1;
                return { line: g, column: p };
              }, t3.positionBy = function(a) {
                var s = this.source.start;
                if (a.index)
                  s = this.positionInside(a.index);
                else if (a.word) {
                  var p = this.toString().indexOf(a.word);
                  p !== -1 && (s = this.positionInside(p));
                }
                return s;
              }, u;
            }(), m = f;
            e.default = m, n.exports = e.default;
          } }), xr = R({ "node_modules/postcss/lib/comment.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = c(Dt());
            function c(f) {
              return f && f.__esModule ? f : { default: f };
            }
            function o(f, m) {
              f.prototype = Object.create(m.prototype), f.prototype.constructor = f, f.__proto__ = m;
            }
            var h = function(f) {
              o(m, f);
              function m(u) {
                var t3;
                return t3 = f.call(this, u) || this, t3.type = "comment", t3;
              }
              return m;
            }(i.default), l = h;
            e.default = l, n.exports = e.default;
          } }), ea = R({ "node_modules/postcss/lib/declaration.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = c(Dt());
            function c(f) {
              return f && f.__esModule ? f : { default: f };
            }
            function o(f, m) {
              f.prototype = Object.create(m.prototype), f.prototype.constructor = f, f.__proto__ = m;
            }
            var h = function(f) {
              o(m, f);
              function m(u) {
                var t3;
                return t3 = f.call(this, u) || this, t3.type = "decl", t3;
              }
              return m;
            }(i.default), l = h;
            e.default = l, n.exports = e.default;
          } }), Lt = R({ "node_modules/postcss/lib/tokenize.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = W;
            var i = "'".charCodeAt(0), c = '"'.charCodeAt(0), o = "\\".charCodeAt(0), h = "/".charCodeAt(0), l = `
`.charCodeAt(0), f = " ".charCodeAt(0), m = "\f".charCodeAt(0), u = "	".charCodeAt(0), t3 = "\r".charCodeAt(0), r = "[".charCodeAt(0), a = "]".charCodeAt(0), s = "(".charCodeAt(0), p = ")".charCodeAt(0), g = "{".charCodeAt(0), v = "}".charCodeAt(0), y = ";".charCodeAt(0), w = "*".charCodeAt(0), d = ":".charCodeAt(0), _ = "@".charCodeAt(0), S = /[ \n\t\r\f{}()'"\\;/[\]#]/g, x = /[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g, N = /.[\\/("'\n]/, P = /[a-f0-9]/i;
            function W(U, H) {
              H === void 0 && (H = {});
              var D = U.css.valueOf(), $ = H.ignoreErrors, B, O, j, C, I, X, Z, Q, K, J, M, Y, G, E, k = D.length, b = -1, L = 1, q = 0, T = [], F = [];
              function z() {
                return q;
              }
              function re(te) {
                throw U.error("Unclosed " + te, L, q - b);
              }
              function ne() {
                return F.length === 0 && q >= k;
              }
              function ce(te) {
                if (F.length)
                  return F.pop();
                if (!(q >= k)) {
                  var ie = te ? te.ignoreUnclosed : false;
                  switch (B = D.charCodeAt(q), (B === l || B === m || B === t3 && D.charCodeAt(q + 1) !== l) && (b = q, L += 1), B) {
                    case l:
                    case f:
                    case u:
                    case t3:
                    case m:
                      O = q;
                      do
                        O += 1, B = D.charCodeAt(O), B === l && (b = O, L += 1);
                      while (B === f || B === l || B === u || B === t3 || B === m);
                      E = ["space", D.slice(q, O)], q = O - 1;
                      break;
                    case r:
                    case a:
                    case g:
                    case v:
                    case d:
                    case y:
                    case p:
                      var ae = String.fromCharCode(B);
                      E = [ae, ae, L, q - b];
                      break;
                    case s:
                      if (Y = T.length ? T.pop()[1] : "", G = D.charCodeAt(q + 1), Y === "url" && G !== i && G !== c && G !== f && G !== l && G !== u && G !== m && G !== t3) {
                        O = q;
                        do {
                          if (J = false, O = D.indexOf(")", O + 1), O === -1)
                            if ($ || ie) {
                              O = q;
                              break;
                            } else
                              re("bracket");
                          for (M = O; D.charCodeAt(M - 1) === o; )
                            M -= 1, J = !J;
                        } while (J);
                        E = ["brackets", D.slice(q, O + 1), L, q - b, L, O - b], q = O;
                      } else
                        O = D.indexOf(")", q + 1), X = D.slice(q, O + 1), O === -1 || N.test(X) ? E = ["(", "(", L, q - b] : (E = ["brackets", X, L, q - b, L, O - b], q = O);
                      break;
                    case i:
                    case c:
                      j = B === i ? "'" : '"', O = q;
                      do {
                        if (J = false, O = D.indexOf(j, O + 1), O === -1)
                          if ($ || ie) {
                            O = q + 1;
                            break;
                          } else
                            re("string");
                        for (M = O; D.charCodeAt(M - 1) === o; )
                          M -= 1, J = !J;
                      } while (J);
                      X = D.slice(q, O + 1), C = X.split(`
`), I = C.length - 1, I > 0 ? (Q = L + I, K = O - C[I].length) : (Q = L, K = b), E = ["string", D.slice(q, O + 1), L, q - b, Q, O - K], b = K, L = Q, q = O;
                      break;
                    case _:
                      S.lastIndex = q + 1, S.test(D), S.lastIndex === 0 ? O = D.length - 1 : O = S.lastIndex - 2, E = ["at-word", D.slice(q, O + 1), L, q - b, L, O - b], q = O;
                      break;
                    case o:
                      for (O = q, Z = true; D.charCodeAt(O + 1) === o; )
                        O += 1, Z = !Z;
                      if (B = D.charCodeAt(O + 1), Z && B !== h && B !== f && B !== l && B !== u && B !== t3 && B !== m && (O += 1, P.test(D.charAt(O)))) {
                        for (; P.test(D.charAt(O + 1)); )
                          O += 1;
                        D.charCodeAt(O + 1) === f && (O += 1);
                      }
                      E = ["word", D.slice(q, O + 1), L, q - b, L, O - b], q = O;
                      break;
                    default:
                      B === h && D.charCodeAt(q + 1) === w ? (O = D.indexOf("*/", q + 2) + 1, O === 0 && ($ || ie ? O = D.length : re("comment")), X = D.slice(q, O + 1), C = X.split(`
`), I = C.length - 1, I > 0 ? (Q = L + I, K = O - C[I].length) : (Q = L, K = b), E = ["comment", X, L, q - b, Q, O - K], b = K, L = Q, q = O) : (x.lastIndex = q + 1, x.test(D), x.lastIndex === 0 ? O = D.length - 1 : O = x.lastIndex - 2, E = ["word", D.slice(q, O + 1), L, q - b, L, O - b], T.push(E), q = O);
                      break;
                  }
                  return q++, E;
                }
              }
              function fe(te) {
                F.push(te);
              }
              return { back: fe, nextToken: ce, endOfFile: ne, position: z };
            }
            n.exports = e.default;
          } }), ra = R({ "node_modules/postcss/lib/parse.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = o(zt()), c = o(_r());
            function o(f) {
              return f && f.__esModule ? f : { default: f };
            }
            function h(f, m) {
              var u = new c.default(f, m), t3 = new i.default(u);
              try {
                t3.parse();
              } catch (r) {
                throw r;
              }
              return t3.root;
            }
            var l = h;
            e.default = l, n.exports = e.default;
          } }), kf = R({ "node_modules/postcss/lib/list.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = { split: function(h, l, f) {
              for (var m = [], u = "", t3 = false, r = 0, a = false, s = false, p = 0; p < h.length; p++) {
                var g = h[p];
                a ? s ? s = false : g === "\\" ? s = true : g === a && (a = false) : g === '"' || g === "'" ? a = g : g === "(" ? r += 1 : g === ")" ? r > 0 && (r -= 1) : r === 0 && l.indexOf(g) !== -1 && (t3 = true), t3 ? (u !== "" && m.push(u.trim()), u = "", t3 = false) : u += g;
              }
              return (f || u !== "") && m.push(u.trim()), m;
            }, space: function(h) {
              var l = [" ", `
`, "	"];
              return i.split(h, l);
            }, comma: function(h) {
              return i.split(h, [","], true);
            } }, c = i;
            e.default = c, n.exports = e.default;
          } }), ta = R({ "node_modules/postcss/lib/rule.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = o(kr()), c = o(kf());
            function o(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function h(t3, r) {
              for (var a = 0; a < r.length; a++) {
                var s = r[a];
                s.enumerable = s.enumerable || false, s.configurable = true, "value" in s && (s.writable = true), Object.defineProperty(t3, s.key, s);
              }
            }
            function l(t3, r, a) {
              return r && h(t3.prototype, r), a && h(t3, a), t3;
            }
            function f(t3, r) {
              t3.prototype = Object.create(r.prototype), t3.prototype.constructor = t3, t3.__proto__ = r;
            }
            var m = function(t3) {
              f(r, t3);
              function r(a) {
                var s;
                return s = t3.call(this, a) || this, s.type = "rule", s.nodes || (s.nodes = []), s;
              }
              return l(r, [{ key: "selectors", get: function() {
                return c.default.comma(this.selector);
              }, set: function(s) {
                var p = this.selector ? this.selector.match(/,\s*/) : null, g = p ? p[0] : "," + this.raw("between", "beforeOpen");
                this.selector = s.join(g);
              } }]), r;
            }(i.default), u = m;
            e.default = u, n.exports = e.default;
          } }), kr = R({ "node_modules/postcss/lib/container.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = h(ea()), c = h(xr()), o = h(Dt());
            function h(g) {
              return g && g.__esModule ? g : { default: g };
            }
            function l(g, v) {
              var y;
              if (typeof Symbol > "u" || g[Symbol.iterator] == null) {
                if (Array.isArray(g) || (y = f(g)) || v && g && typeof g.length == "number") {
                  y && (g = y);
                  var w = 0;
                  return function() {
                    return w >= g.length ? { done: true } : { done: false, value: g[w++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return y = g[Symbol.iterator](), y.next.bind(y);
            }
            function f(g, v) {
              if (!!g) {
                if (typeof g == "string")
                  return m(g, v);
                var y = Object.prototype.toString.call(g).slice(8, -1);
                if (y === "Object" && g.constructor && (y = g.constructor.name), y === "Map" || y === "Set")
                  return Array.from(g);
                if (y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y))
                  return m(g, v);
              }
            }
            function m(g, v) {
              (v == null || v > g.length) && (v = g.length);
              for (var y = 0, w = new Array(v); y < v; y++)
                w[y] = g[y];
              return w;
            }
            function u(g, v) {
              for (var y = 0; y < v.length; y++) {
                var w = v[y];
                w.enumerable = w.enumerable || false, w.configurable = true, "value" in w && (w.writable = true), Object.defineProperty(g, w.key, w);
              }
            }
            function t3(g, v, y) {
              return v && u(g.prototype, v), y && u(g, y), g;
            }
            function r(g, v) {
              g.prototype = Object.create(v.prototype), g.prototype.constructor = g, g.__proto__ = v;
            }
            function a(g) {
              return g.map(function(v) {
                return v.nodes && (v.nodes = a(v.nodes)), delete v.source, v;
              });
            }
            var s = function(g) {
              r(v, g);
              function v() {
                return g.apply(this, arguments) || this;
              }
              var y = v.prototype;
              return y.push = function(d) {
                return d.parent = this, this.nodes.push(d), this;
              }, y.each = function(d) {
                this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
                var _ = this.lastEach;
                if (this.indexes[_] = 0, !!this.nodes) {
                  for (var S, x; this.indexes[_] < this.nodes.length && (S = this.indexes[_], x = d(this.nodes[S], S), x !== false); )
                    this.indexes[_] += 1;
                  return delete this.indexes[_], x;
                }
              }, y.walk = function(d) {
                return this.each(function(_, S) {
                  var x;
                  try {
                    x = d(_, S);
                  } catch (P) {
                    if (P.postcssNode = _, P.stack && _.source && /\n\s{4}at /.test(P.stack)) {
                      var N = _.source;
                      P.stack = P.stack.replace(/\n\s{4}at /, "$&" + N.input.from + ":" + N.start.line + ":" + N.start.column + "$&");
                    }
                    throw P;
                  }
                  return x !== false && _.walk && (x = _.walk(d)), x;
                });
              }, y.walkDecls = function(d, _) {
                return _ ? d instanceof RegExp ? this.walk(function(S, x) {
                  if (S.type === "decl" && d.test(S.prop))
                    return _(S, x);
                }) : this.walk(function(S, x) {
                  if (S.type === "decl" && S.prop === d)
                    return _(S, x);
                }) : (_ = d, this.walk(function(S, x) {
                  if (S.type === "decl")
                    return _(S, x);
                }));
              }, y.walkRules = function(d, _) {
                return _ ? d instanceof RegExp ? this.walk(function(S, x) {
                  if (S.type === "rule" && d.test(S.selector))
                    return _(S, x);
                }) : this.walk(function(S, x) {
                  if (S.type === "rule" && S.selector === d)
                    return _(S, x);
                }) : (_ = d, this.walk(function(S, x) {
                  if (S.type === "rule")
                    return _(S, x);
                }));
              }, y.walkAtRules = function(d, _) {
                return _ ? d instanceof RegExp ? this.walk(function(S, x) {
                  if (S.type === "atrule" && d.test(S.name))
                    return _(S, x);
                }) : this.walk(function(S, x) {
                  if (S.type === "atrule" && S.name === d)
                    return _(S, x);
                }) : (_ = d, this.walk(function(S, x) {
                  if (S.type === "atrule")
                    return _(S, x);
                }));
              }, y.walkComments = function(d) {
                return this.walk(function(_, S) {
                  if (_.type === "comment")
                    return d(_, S);
                });
              }, y.append = function() {
                for (var d = arguments.length, _ = new Array(d), S = 0; S < d; S++)
                  _[S] = arguments[S];
                for (var x = 0, N = _; x < N.length; x++)
                  for (var P = N[x], W = this.normalize(P, this.last), U = l(W), H; !(H = U()).done; ) {
                    var D = H.value;
                    this.nodes.push(D);
                  }
                return this;
              }, y.prepend = function() {
                for (var d = arguments.length, _ = new Array(d), S = 0; S < d; S++)
                  _[S] = arguments[S];
                _ = _.reverse();
                for (var x = l(_), N; !(N = x()).done; ) {
                  for (var P = N.value, W = this.normalize(P, this.first, "prepend").reverse(), U = l(W), H; !(H = U()).done; ) {
                    var D = H.value;
                    this.nodes.unshift(D);
                  }
                  for (var $ in this.indexes)
                    this.indexes[$] = this.indexes[$] + W.length;
                }
                return this;
              }, y.cleanRaws = function(d) {
                if (g.prototype.cleanRaws.call(this, d), this.nodes)
                  for (var _ = l(this.nodes), S; !(S = _()).done; ) {
                    var x = S.value;
                    x.cleanRaws(d);
                  }
              }, y.insertBefore = function(d, _) {
                d = this.index(d);
                for (var S = d === 0 ? "prepend" : false, x = this.normalize(_, this.nodes[d], S).reverse(), N = l(x), P; !(P = N()).done; ) {
                  var W = P.value;
                  this.nodes.splice(d, 0, W);
                }
                var U;
                for (var H in this.indexes)
                  U = this.indexes[H], d <= U && (this.indexes[H] = U + x.length);
                return this;
              }, y.insertAfter = function(d, _) {
                d = this.index(d);
                for (var S = this.normalize(_, this.nodes[d]).reverse(), x = l(S), N; !(N = x()).done; ) {
                  var P = N.value;
                  this.nodes.splice(d + 1, 0, P);
                }
                var W;
                for (var U in this.indexes)
                  W = this.indexes[U], d < W && (this.indexes[U] = W + S.length);
                return this;
              }, y.removeChild = function(d) {
                d = this.index(d), this.nodes[d].parent = void 0, this.nodes.splice(d, 1);
                var _;
                for (var S in this.indexes)
                  _ = this.indexes[S], _ >= d && (this.indexes[S] = _ - 1);
                return this;
              }, y.removeAll = function() {
                for (var d = l(this.nodes), _; !(_ = d()).done; ) {
                  var S = _.value;
                  S.parent = void 0;
                }
                return this.nodes = [], this;
              }, y.replaceValues = function(d, _, S) {
                return S || (S = _, _ = {}), this.walkDecls(function(x) {
                  _.props && _.props.indexOf(x.prop) === -1 || _.fast && x.value.indexOf(_.fast) === -1 || (x.value = x.value.replace(d, S));
                }), this;
              }, y.every = function(d) {
                return this.nodes.every(d);
              }, y.some = function(d) {
                return this.nodes.some(d);
              }, y.index = function(d) {
                return typeof d == "number" ? d : this.nodes.indexOf(d);
              }, y.normalize = function(d, _) {
                var S = this;
                if (typeof d == "string") {
                  var x = ra();
                  d = a(x(d).nodes);
                } else if (Array.isArray(d)) {
                  d = d.slice(0);
                  for (var N = l(d), P; !(P = N()).done; ) {
                    var W = P.value;
                    W.parent && W.parent.removeChild(W, "ignore");
                  }
                } else if (d.type === "root") {
                  d = d.nodes.slice(0);
                  for (var U = l(d), H; !(H = U()).done; ) {
                    var D = H.value;
                    D.parent && D.parent.removeChild(D, "ignore");
                  }
                } else if (d.type)
                  d = [d];
                else if (d.prop) {
                  if (typeof d.value > "u")
                    throw new Error("Value field is missed in node creation");
                  typeof d.value != "string" && (d.value = String(d.value)), d = [new i.default(d)];
                } else if (d.selector) {
                  var $ = ta();
                  d = [new $(d)];
                } else if (d.name) {
                  var B = na();
                  d = [new B(d)];
                } else if (d.text)
                  d = [new c.default(d)];
                else
                  throw new Error("Unknown node type in node creation");
                var O = d.map(function(j) {
                  return j.parent && j.parent.removeChild(j), typeof j.raws.before > "u" && _ && typeof _.raws.before < "u" && (j.raws.before = _.raws.before.replace(/[^\s]/g, "")), j.parent = S, j;
                });
                return O;
              }, t3(v, [{ key: "first", get: function() {
                if (!!this.nodes)
                  return this.nodes[0];
              } }, { key: "last", get: function() {
                if (!!this.nodes)
                  return this.nodes[this.nodes.length - 1];
              } }]), v;
            }(o.default), p = s;
            e.default = p, n.exports = e.default;
          } }), na = R({ "node_modules/postcss/lib/at-rule.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = c(kr());
            function c(f) {
              return f && f.__esModule ? f : { default: f };
            }
            function o(f, m) {
              f.prototype = Object.create(m.prototype), f.prototype.constructor = f, f.__proto__ = m;
            }
            var h = function(f) {
              o(m, f);
              function m(t3) {
                var r;
                return r = f.call(this, t3) || this, r.type = "atrule", r;
              }
              var u = m.prototype;
              return u.append = function() {
                var r;
                this.nodes || (this.nodes = []);
                for (var a = arguments.length, s = new Array(a), p = 0; p < a; p++)
                  s[p] = arguments[p];
                return (r = f.prototype.append).call.apply(r, [this].concat(s));
              }, u.prepend = function() {
                var r;
                this.nodes || (this.nodes = []);
                for (var a = arguments.length, s = new Array(a), p = 0; p < a; p++)
                  s[p] = arguments[p];
                return (r = f.prototype.prepend).call.apply(r, [this].concat(s));
              }, m;
            }(i.default), l = h;
            e.default = l, n.exports = e.default;
          } }), Sf = R({ "node_modules/postcss/lib/map-generator.js"(e, n) {
            A(), n.exports = class {
              generate() {
              }
            };
          } }), Of = R({ "node_modules/postcss/lib/warn-once.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = c;
            var i = {};
            function c(o) {
              i[o] || (i[o] = true, typeof console < "u" && console.warn && console.warn(o));
            }
            n.exports = e.default;
          } }), Tf = R({ "node_modules/postcss/lib/warning.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = function() {
              function o(l, f) {
                if (f === void 0 && (f = {}), this.type = "warning", this.text = l, f.node && f.node.source) {
                  var m = f.node.positionBy(f);
                  this.line = m.line, this.column = m.column;
                }
                for (var u in f)
                  this[u] = f[u];
              }
              var h = o.prototype;
              return h.toString = function() {
                return this.node ? this.node.error(this.text, { plugin: this.plugin, index: this.index, word: this.word }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
              }, o;
            }(), c = i;
            e.default = c, n.exports = e.default;
          } }), Ef = R({ "node_modules/postcss/lib/result.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = c(Tf());
            function c(m) {
              return m && m.__esModule ? m : { default: m };
            }
            function o(m, u) {
              for (var t3 = 0; t3 < u.length; t3++) {
                var r = u[t3];
                r.enumerable = r.enumerable || false, r.configurable = true, "value" in r && (r.writable = true), Object.defineProperty(m, r.key, r);
              }
            }
            function h(m, u, t3) {
              return u && o(m.prototype, u), t3 && o(m, t3), m;
            }
            var l = function() {
              function m(t3, r, a) {
                this.processor = t3, this.messages = [], this.root = r, this.opts = a, this.css = void 0, this.map = void 0;
              }
              var u = m.prototype;
              return u.toString = function() {
                return this.css;
              }, u.warn = function(r, a) {
                a === void 0 && (a = {}), a.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (a.plugin = this.lastPlugin.postcssPlugin);
                var s = new i.default(r, a);
                return this.messages.push(s), s;
              }, u.warnings = function() {
                return this.messages.filter(function(r) {
                  return r.type === "warning";
                });
              }, h(m, [{ key: "content", get: function() {
                return this.css;
              } }]), m;
            }(), f = l;
            e.default = f, n.exports = e.default;
          } }), ia = R({ "node_modules/postcss/lib/lazy-result.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = f(Sf()), c = f(Zo()), o = f(Of()), h = f(Ef()), l = f(ra());
            function f(v) {
              return v && v.__esModule ? v : { default: v };
            }
            function m(v, y) {
              var w;
              if (typeof Symbol > "u" || v[Symbol.iterator] == null) {
                if (Array.isArray(v) || (w = u(v)) || y && v && typeof v.length == "number") {
                  w && (v = w);
                  var d = 0;
                  return function() {
                    return d >= v.length ? { done: true } : { done: false, value: v[d++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return w = v[Symbol.iterator](), w.next.bind(w);
            }
            function u(v, y) {
              if (!!v) {
                if (typeof v == "string")
                  return t3(v, y);
                var w = Object.prototype.toString.call(v).slice(8, -1);
                if (w === "Object" && v.constructor && (w = v.constructor.name), w === "Map" || w === "Set")
                  return Array.from(v);
                if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w))
                  return t3(v, y);
              }
            }
            function t3(v, y) {
              (y == null || y > v.length) && (y = v.length);
              for (var w = 0, d = new Array(y); w < y; w++)
                d[w] = v[w];
              return d;
            }
            function r(v, y) {
              for (var w = 0; w < y.length; w++) {
                var d = y[w];
                d.enumerable = d.enumerable || false, d.configurable = true, "value" in d && (d.writable = true), Object.defineProperty(v, d.key, d);
              }
            }
            function a(v, y, w) {
              return y && r(v.prototype, y), w && r(v, w), v;
            }
            function s(v) {
              return typeof v == "object" && typeof v.then == "function";
            }
            var p = function() {
              function v(w, d, _) {
                this.stringified = false, this.processed = false;
                var S;
                if (typeof d == "object" && d !== null && d.type === "root")
                  S = d;
                else if (d instanceof v || d instanceof h.default)
                  S = d.root, d.map && (typeof _.map > "u" && (_.map = {}), _.map.inline || (_.map.inline = false), _.map.prev = d.map);
                else {
                  var x = l.default;
                  _.syntax && (x = _.syntax.parse), _.parser && (x = _.parser), x.parse && (x = x.parse);
                  try {
                    S = x(d, _);
                  } catch (N) {
                    this.error = N;
                  }
                }
                this.result = new h.default(w, S, _);
              }
              var y = v.prototype;
              return y.warnings = function() {
                return this.sync().warnings();
              }, y.toString = function() {
                return this.css;
              }, y.then = function(d, _) {
                return this.async().then(d, _);
              }, y.catch = function(d) {
                return this.async().catch(d);
              }, y.finally = function(d) {
                return this.async().then(d, d);
              }, y.handleError = function(d, _) {
                try {
                  if (this.error = d, d.name === "CssSyntaxError" && !d.plugin)
                    d.plugin = _.postcssPlugin, d.setMessage();
                  else if (_.postcssVersion && false)
                    var S, x, N, P, W;
                } catch (U) {
                  console && console.error && console.error(U);
                }
              }, y.asyncTick = function(d, _) {
                var S = this;
                if (this.plugin >= this.processor.plugins.length)
                  return this.processed = true, d();
                try {
                  var x = this.processor.plugins[this.plugin], N = this.run(x);
                  this.plugin += 1, s(N) ? N.then(function() {
                    S.asyncTick(d, _);
                  }).catch(function(P) {
                    S.handleError(P, x), S.processed = true, _(P);
                  }) : this.asyncTick(d, _);
                } catch (P) {
                  this.processed = true, _(P);
                }
              }, y.async = function() {
                var d = this;
                return this.processed ? new Promise(function(_, S) {
                  d.error ? S(d.error) : _(d.stringify());
                }) : this.processing ? this.processing : (this.processing = new Promise(function(_, S) {
                  if (d.error)
                    return S(d.error);
                  d.plugin = 0, d.asyncTick(_, S);
                }).then(function() {
                  return d.processed = true, d.stringify();
                }), this.processing);
              }, y.sync = function() {
                if (this.processed)
                  return this.result;
                if (this.processed = true, this.processing)
                  throw new Error("Use process(css).then(cb) to work with async plugins");
                if (this.error)
                  throw this.error;
                for (var d = m(this.result.processor.plugins), _; !(_ = d()).done; ) {
                  var S = _.value, x = this.run(S);
                  if (s(x))
                    throw new Error("Use process(css).then(cb) to work with async plugins");
                }
                return this.result;
              }, y.run = function(d) {
                this.result.lastPlugin = d;
                try {
                  return d(this.result.root, this.result);
                } catch (_) {
                  throw this.handleError(_, d), _;
                }
              }, y.stringify = function() {
                if (this.stringified)
                  return this.result;
                this.stringified = true, this.sync();
                var d = this.result.opts, _ = c.default;
                d.syntax && (_ = d.syntax.stringify), d.stringifier && (_ = d.stringifier), _.stringify && (_ = _.stringify);
                var S = new i.default(_, this.result.root, this.result.opts), x = S.generate();
                return this.result.css = x[0], this.result.map = x[1], this.result;
              }, a(v, [{ key: "processor", get: function() {
                return this.result.processor;
              } }, { key: "opts", get: function() {
                return this.result.opts;
              } }, { key: "css", get: function() {
                return this.stringify().css;
              } }, { key: "content", get: function() {
                return this.stringify().content;
              } }, { key: "map", get: function() {
                return this.stringify().map;
              } }, { key: "root", get: function() {
                return this.sync().root;
              } }, { key: "messages", get: function() {
                return this.sync().messages;
              } }]), v;
            }(), g = p;
            e.default = g, n.exports = e.default;
          } }), qf = R({ "node_modules/postcss/lib/processor.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = c(ia());
            function c(u) {
              return u && u.__esModule ? u : { default: u };
            }
            function o(u, t3) {
              var r;
              if (typeof Symbol > "u" || u[Symbol.iterator] == null) {
                if (Array.isArray(u) || (r = h(u)) || t3 && u && typeof u.length == "number") {
                  r && (u = r);
                  var a = 0;
                  return function() {
                    return a >= u.length ? { done: true } : { done: false, value: u[a++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return r = u[Symbol.iterator](), r.next.bind(r);
            }
            function h(u, t3) {
              if (!!u) {
                if (typeof u == "string")
                  return l(u, t3);
                var r = Object.prototype.toString.call(u).slice(8, -1);
                if (r === "Object" && u.constructor && (r = u.constructor.name), r === "Map" || r === "Set")
                  return Array.from(u);
                if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                  return l(u, t3);
              }
            }
            function l(u, t3) {
              (t3 == null || t3 > u.length) && (t3 = u.length);
              for (var r = 0, a = new Array(t3); r < t3; r++)
                a[r] = u[r];
              return a;
            }
            var f = function() {
              function u(r) {
                r === void 0 && (r = []), this.version = "7.0.39", this.plugins = this.normalize(r);
              }
              var t3 = u.prototype;
              return t3.use = function(a) {
                return this.plugins = this.plugins.concat(this.normalize([a])), this;
              }, t3.process = function(r) {
                function a(s) {
                  return r.apply(this, arguments);
                }
                return a.toString = function() {
                  return r.toString();
                }, a;
              }(function(r, a) {
                return a === void 0 && (a = {}), this.plugins.length === 0 && (a.parser, a.stringifier), new i.default(this, r, a);
              }), t3.normalize = function(a) {
                for (var s = [], p = o(a), g; !(g = p()).done; ) {
                  var v = g.value;
                  if (v.postcss === true) {
                    var y = v();
                    throw new Error("PostCSS plugin " + y.postcssPlugin + ` requires PostCSS 8.
Migration guide for end-users:
https://github.com/postcss/postcss/wiki/PostCSS-8-for-end-users`);
                  }
                  if (v.postcss && (v = v.postcss), typeof v == "object" && Array.isArray(v.plugins))
                    s = s.concat(v.plugins);
                  else if (typeof v == "function")
                    s.push(v);
                  else if (!(typeof v == "object" && (v.parse || v.stringify)))
                    throw typeof v == "object" && v.postcssPlugin ? new Error("PostCSS plugin " + v.postcssPlugin + ` requires PostCSS 8.
Migration guide for end-users:
https://github.com/postcss/postcss/wiki/PostCSS-8-for-end-users`) : new Error(v + " is not a PostCSS plugin");
                }
                return s;
              }, u;
            }(), m = f;
            e.default = m, n.exports = e.default;
          } }), Af = R({ "node_modules/postcss/lib/root.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = c(kr());
            function c(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function o(t3, r) {
              var a;
              if (typeof Symbol > "u" || t3[Symbol.iterator] == null) {
                if (Array.isArray(t3) || (a = h(t3)) || r && t3 && typeof t3.length == "number") {
                  a && (t3 = a);
                  var s = 0;
                  return function() {
                    return s >= t3.length ? { done: true } : { done: false, value: t3[s++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return a = t3[Symbol.iterator](), a.next.bind(a);
            }
            function h(t3, r) {
              if (!!t3) {
                if (typeof t3 == "string")
                  return l(t3, r);
                var a = Object.prototype.toString.call(t3).slice(8, -1);
                if (a === "Object" && t3.constructor && (a = t3.constructor.name), a === "Map" || a === "Set")
                  return Array.from(t3);
                if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a))
                  return l(t3, r);
              }
            }
            function l(t3, r) {
              (r == null || r > t3.length) && (r = t3.length);
              for (var a = 0, s = new Array(r); a < r; a++)
                s[a] = t3[a];
              return s;
            }
            function f(t3, r) {
              t3.prototype = Object.create(r.prototype), t3.prototype.constructor = t3, t3.__proto__ = r;
            }
            var m = function(t3) {
              f(r, t3);
              function r(s) {
                var p;
                return p = t3.call(this, s) || this, p.type = "root", p.nodes || (p.nodes = []), p;
              }
              var a = r.prototype;
              return a.removeChild = function(p, g) {
                var v = this.index(p);
                return !g && v === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[v].raws.before), t3.prototype.removeChild.call(this, p);
              }, a.normalize = function(p, g, v) {
                var y = t3.prototype.normalize.call(this, p);
                if (g) {
                  if (v === "prepend")
                    this.nodes.length > 1 ? g.raws.before = this.nodes[1].raws.before : delete g.raws.before;
                  else if (this.first !== g)
                    for (var w = o(y), d; !(d = w()).done; ) {
                      var _ = d.value;
                      _.raws.before = g.raws.before;
                    }
                }
                return y;
              }, a.toResult = function(p) {
                p === void 0 && (p = {});
                var g = ia(), v = qf(), y = new g(new v(), this, p);
                return y.stringify();
              }, r;
            }(i.default), u = m;
            e.default = u, n.exports = e.default;
          } }), zt = R({ "node_modules/postcss/lib/parser.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = m(ea()), c = m(Lt()), o = m(xr()), h = m(na()), l = m(Af()), f = m(ta());
            function m(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            var u = function() {
              function t3(a) {
                this.input = a, this.root = new l.default(), this.current = this.root, this.spaces = "", this.semicolon = false, this.createTokenizer(), this.root.source = { input: a, start: { line: 1, column: 1 } };
              }
              var r = t3.prototype;
              return r.createTokenizer = function() {
                this.tokenizer = (0, c.default)(this.input);
              }, r.parse = function() {
                for (var s; !this.tokenizer.endOfFile(); )
                  switch (s = this.tokenizer.nextToken(), s[0]) {
                    case "space":
                      this.spaces += s[1];
                      break;
                    case ";":
                      this.freeSemicolon(s);
                      break;
                    case "}":
                      this.end(s);
                      break;
                    case "comment":
                      this.comment(s);
                      break;
                    case "at-word":
                      this.atrule(s);
                      break;
                    case "{":
                      this.emptyRule(s);
                      break;
                    default:
                      this.other(s);
                      break;
                  }
                this.endFile();
              }, r.comment = function(s) {
                var p = new o.default();
                this.init(p, s[2], s[3]), p.source.end = { line: s[4], column: s[5] };
                var g = s[1].slice(2, -2);
                if (/^\s*$/.test(g))
                  p.text = "", p.raws.left = g, p.raws.right = "";
                else {
                  var v = g.match(/^(\s*)([^]*[^\s])(\s*)$/);
                  p.text = v[2], p.raws.left = v[1], p.raws.right = v[3];
                }
              }, r.emptyRule = function(s) {
                var p = new f.default();
                this.init(p, s[2], s[3]), p.selector = "", p.raws.between = "", this.current = p;
              }, r.other = function(s) {
                for (var p = false, g = null, v = false, y = null, w = [], d = [], _ = s; _; ) {
                  if (g = _[0], d.push(_), g === "(" || g === "[")
                    y || (y = _), w.push(g === "(" ? ")" : "]");
                  else if (w.length === 0)
                    if (g === ";")
                      if (v) {
                        this.decl(d);
                        return;
                      } else
                        break;
                    else if (g === "{") {
                      this.rule(d);
                      return;
                    } else if (g === "}") {
                      this.tokenizer.back(d.pop()), p = true;
                      break;
                    } else
                      g === ":" && (v = true);
                  else
                    g === w[w.length - 1] && (w.pop(), w.length === 0 && (y = null));
                  _ = this.tokenizer.nextToken();
                }
                if (this.tokenizer.endOfFile() && (p = true), w.length > 0 && this.unclosedBracket(y), p && v) {
                  for (; d.length && (_ = d[d.length - 1][0], !(_ !== "space" && _ !== "comment")); )
                    this.tokenizer.back(d.pop());
                  this.decl(d);
                } else
                  this.unknownWord(d);
              }, r.rule = function(s) {
                s.pop();
                var p = new f.default();
                this.init(p, s[0][2], s[0][3]), p.raws.between = this.spacesAndCommentsFromEnd(s), this.raw(p, "selector", s), this.current = p;
              }, r.decl = function(s) {
                var p = new i.default();
                this.init(p);
                var g = s[s.length - 1];
                for (g[0] === ";" && (this.semicolon = true, s.pop()), g[4] ? p.source.end = { line: g[4], column: g[5] } : p.source.end = { line: g[2], column: g[3] }; s[0][0] !== "word"; )
                  s.length === 1 && this.unknownWord(s), p.raws.before += s.shift()[1];
                for (p.source.start = { line: s[0][2], column: s[0][3] }, p.prop = ""; s.length; ) {
                  var v = s[0][0];
                  if (v === ":" || v === "space" || v === "comment")
                    break;
                  p.prop += s.shift()[1];
                }
                p.raws.between = "";
                for (var y; s.length; )
                  if (y = s.shift(), y[0] === ":") {
                    p.raws.between += y[1];
                    break;
                  } else
                    y[0] === "word" && /\w/.test(y[1]) && this.unknownWord([y]), p.raws.between += y[1];
                (p.prop[0] === "_" || p.prop[0] === "*") && (p.raws.before += p.prop[0], p.prop = p.prop.slice(1)), p.raws.between += this.spacesAndCommentsFromStart(s), this.precheckMissedSemicolon(s);
                for (var w = s.length - 1; w > 0; w--) {
                  if (y = s[w], y[1].toLowerCase() === "!important") {
                    p.important = true;
                    var d = this.stringFrom(s, w);
                    d = this.spacesFromEnd(s) + d, d !== " !important" && (p.raws.important = d);
                    break;
                  } else if (y[1].toLowerCase() === "important") {
                    for (var _ = s.slice(0), S = "", x = w; x > 0; x--) {
                      var N = _[x][0];
                      if (S.trim().indexOf("!") === 0 && N !== "space")
                        break;
                      S = _.pop()[1] + S;
                    }
                    S.trim().indexOf("!") === 0 && (p.important = true, p.raws.important = S, s = _);
                  }
                  if (y[0] !== "space" && y[0] !== "comment")
                    break;
                }
                this.raw(p, "value", s), p.value.indexOf(":") !== -1 && this.checkMissedSemicolon(s);
              }, r.atrule = function(s) {
                var p = new h.default();
                p.name = s[1].slice(1), p.name === "" && this.unnamedAtrule(p, s), this.init(p, s[2], s[3]);
                for (var g, v, y = false, w = false, d = []; !this.tokenizer.endOfFile(); ) {
                  if (s = this.tokenizer.nextToken(), s[0] === ";") {
                    p.source.end = { line: s[2], column: s[3] }, this.semicolon = true;
                    break;
                  } else if (s[0] === "{") {
                    w = true;
                    break;
                  } else if (s[0] === "}") {
                    if (d.length > 0) {
                      for (v = d.length - 1, g = d[v]; g && g[0] === "space"; )
                        g = d[--v];
                      g && (p.source.end = { line: g[4], column: g[5] });
                    }
                    this.end(s);
                    break;
                  } else
                    d.push(s);
                  if (this.tokenizer.endOfFile()) {
                    y = true;
                    break;
                  }
                }
                p.raws.between = this.spacesAndCommentsFromEnd(d), d.length ? (p.raws.afterName = this.spacesAndCommentsFromStart(d), this.raw(p, "params", d), y && (s = d[d.length - 1], p.source.end = { line: s[4], column: s[5] }, this.spaces = p.raws.between, p.raws.between = "")) : (p.raws.afterName = "", p.params = ""), w && (p.nodes = [], this.current = p);
              }, r.end = function(s) {
                this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = false, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = { line: s[2], column: s[3] }, this.current = this.current.parent) : this.unexpectedClose(s);
              }, r.endFile = function() {
                this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces;
              }, r.freeSemicolon = function(s) {
                if (this.spaces += s[1], this.current.nodes) {
                  var p = this.current.nodes[this.current.nodes.length - 1];
                  p && p.type === "rule" && !p.raws.ownSemicolon && (p.raws.ownSemicolon = this.spaces, this.spaces = "");
                }
              }, r.init = function(s, p, g) {
                this.current.push(s), s.source = { start: { line: p, column: g }, input: this.input }, s.raws.before = this.spaces, this.spaces = "", s.type !== "comment" && (this.semicolon = false);
              }, r.raw = function(s, p, g) {
                for (var v, y, w = g.length, d = "", _ = true, S, x, N = /^([.|#])?([\w])+/i, P = 0; P < w; P += 1) {
                  if (v = g[P], y = v[0], y === "comment" && s.type === "rule") {
                    x = g[P - 1], S = g[P + 1], x[0] !== "space" && S[0] !== "space" && N.test(x[1]) && N.test(S[1]) ? d += v[1] : _ = false;
                    continue;
                  }
                  y === "comment" || y === "space" && P === w - 1 ? _ = false : d += v[1];
                }
                if (!_) {
                  var W = g.reduce(function(U, H) {
                    return U + H[1];
                  }, "");
                  s.raws[p] = { value: d, raw: W };
                }
                s[p] = d;
              }, r.spacesAndCommentsFromEnd = function(s) {
                for (var p, g = ""; s.length && (p = s[s.length - 1][0], !(p !== "space" && p !== "comment")); )
                  g = s.pop()[1] + g;
                return g;
              }, r.spacesAndCommentsFromStart = function(s) {
                for (var p, g = ""; s.length && (p = s[0][0], !(p !== "space" && p !== "comment")); )
                  g += s.shift()[1];
                return g;
              }, r.spacesFromEnd = function(s) {
                for (var p, g = ""; s.length && (p = s[s.length - 1][0], p === "space"); )
                  g = s.pop()[1] + g;
                return g;
              }, r.stringFrom = function(s, p) {
                for (var g = "", v = p; v < s.length; v++)
                  g += s[v][1];
                return s.splice(p, s.length - p), g;
              }, r.colon = function(s) {
                for (var p = 0, g, v, y, w = 0; w < s.length; w++) {
                  if (g = s[w], v = g[0], v === "(" && (p += 1), v === ")" && (p -= 1), p === 0 && v === ":")
                    if (!y)
                      this.doubleColon(g);
                    else {
                      if (y[0] === "word" && y[1] === "progid")
                        continue;
                      return w;
                    }
                  y = g;
                }
                return false;
              }, r.unclosedBracket = function(s) {
                throw this.input.error("Unclosed bracket", s[2], s[3]);
              }, r.unknownWord = function(s) {
                throw this.input.error("Unknown word", s[0][2], s[0][3]);
              }, r.unexpectedClose = function(s) {
                throw this.input.error("Unexpected }", s[2], s[3]);
              }, r.unclosedBlock = function() {
                var s = this.current.source.start;
                throw this.input.error("Unclosed block", s.line, s.column);
              }, r.doubleColon = function(s) {
                throw this.input.error("Double colon", s[2], s[3]);
              }, r.unnamedAtrule = function(s, p) {
                throw this.input.error("At-rule without name", p[2], p[3]);
              }, r.precheckMissedSemicolon = function() {
              }, r.checkMissedSemicolon = function(s) {
                var p = this.colon(s);
                if (p !== false) {
                  for (var g = 0, v, y = p - 1; y >= 0 && (v = s[y], !(v[0] !== "space" && (g += 1, g === 2))); y--)
                    ;
                  throw this.input.error("Missed semicolon", v[2], v[3]);
                }
              }, t3;
            }();
            e.default = u, n.exports = e.default;
          } }), Pf = R({ "node_modules/postcss-less/lib/nodes/inline-comment.js"(e, n) {
            A();
            var i = Lt(), c = _r();
            n.exports = { isInlineComment(o) {
              if (o[0] === "word" && o[1].slice(0, 2) === "//") {
                let h = o, l = [], f;
                for (; o; ) {
                  if (/\r?\n/.test(o[1])) {
                    if (/['"].*\r?\n/.test(o[1])) {
                      l.push(o[1].substring(0, o[1].indexOf(`
`)));
                      let u = o[1].substring(o[1].indexOf(`
`));
                      u += this.input.css.valueOf().substring(this.tokenizer.position()), this.input = new c(u), this.tokenizer = i(this.input);
                    } else
                      this.tokenizer.back(o);
                    break;
                  }
                  l.push(o[1]), f = o, o = this.tokenizer.nextToken({ ignoreUnclosed: true });
                }
                let m = ["comment", l.join(""), h[2], h[3], f[2], f[3]];
                return this.inlineComment(m), true;
              } else if (o[1] === "/") {
                let h = this.tokenizer.nextToken({ ignoreUnclosed: true });
                if (h[0] === "comment" && /^\/\*/.test(h[1]))
                  return h[0] = "word", h[1] = h[1].slice(1), o[1] = "//", this.tokenizer.back(h), n.exports.isInlineComment.bind(this)(o);
              }
              return false;
            } };
          } }), Rf = R({ "node_modules/postcss-less/lib/nodes/interpolation.js"(e, n) {
            A(), n.exports = { interpolation(i) {
              let c = i, o = [i], h = ["word", "{", "}"];
              if (i = this.tokenizer.nextToken(), c[1].length > 1 || i[0] !== "{")
                return this.tokenizer.back(i), false;
              for (; i && h.includes(i[0]); )
                o.push(i), i = this.tokenizer.nextToken();
              let l = o.map((r) => r[1]);
              [c] = o;
              let f = o.pop(), m = [c[2], c[3]], u = [f[4] || f[2], f[5] || f[3]], t3 = ["word", l.join("")].concat(m, u);
              return this.tokenizer.back(i), this.tokenizer.back(t3), true;
            } };
          } }), If = R({ "node_modules/postcss-less/lib/nodes/mixin.js"(e, n) {
            A();
            var i = /^#[0-9a-fA-F]{6}$|^#[0-9a-fA-F]{3}$/, c = /\.[0-9]/, o = (h) => {
              let [, l] = h, [f] = l;
              return (f === "." || f === "#") && i.test(l) === false && c.test(l) === false;
            };
            n.exports = { isMixinToken: o };
          } }), Cf = R({ "node_modules/postcss-less/lib/nodes/import.js"(e, n) {
            A();
            var i = Lt(), c = /^url\((.+)\)/;
            n.exports = (o) => {
              let { name: h, params: l = "" } = o;
              if (h === "import" && l.length) {
                o.import = true;
                let f = i({ css: l });
                for (o.filename = l.replace(c, "$1"); !f.endOfFile(); ) {
                  let [m, u] = f.nextToken();
                  if (m === "word" && u === "url")
                    return;
                  if (m === "brackets") {
                    o.options = u, o.filename = l.replace(u, "").trim();
                    break;
                  }
                }
              }
            };
          } }), Nf = R({ "node_modules/postcss-less/lib/nodes/variable.js"(e, n) {
            A();
            var i = /:$/, c = /^:(\s+)?/;
            n.exports = (o) => {
              let { name: h, params: l = "" } = o;
              if (o.name.slice(-1) === ":") {
                if (i.test(h)) {
                  let [f] = h.match(i);
                  o.name = h.replace(f, ""), o.raws.afterName = f + (o.raws.afterName || ""), o.variable = true, o.value = o.params;
                }
                if (c.test(l)) {
                  let [f] = l.match(c);
                  o.value = l.replace(f, ""), o.raws.afterName = (o.raws.afterName || "") + f, o.variable = true;
                }
              }
            };
          } }), jf = R({ "node_modules/postcss-less/lib/LessParser.js"(e, n) {
            A();
            var i = xr(), c = zt(), { isInlineComment: o } = Pf(), { interpolation: h } = Rf(), { isMixinToken: l } = If(), f = Cf(), m = Nf(), u = /(!\s*important)$/i;
            n.exports = class extends c {
              constructor() {
                super(...arguments), this.lastNode = null;
              }
              atrule(r) {
                h.bind(this)(r) || (super.atrule(r), f(this.lastNode), m(this.lastNode));
              }
              decl() {
                super.decl(...arguments), /extend\(.+\)/i.test(this.lastNode.value) && (this.lastNode.extend = true);
              }
              each(r) {
                r[0][1] = ` ${r[0][1]}`;
                let a = r.findIndex((y) => y[0] === "("), s = r.reverse().find((y) => y[0] === ")"), p = r.reverse().indexOf(s), v = r.splice(a, p).map((y) => y[1]).join("");
                for (let y of r.reverse())
                  this.tokenizer.back(y);
                this.atrule(this.tokenizer.nextToken()), this.lastNode.function = true, this.lastNode.params = v;
              }
              init(r, a, s) {
                super.init(r, a, s), this.lastNode = r;
              }
              inlineComment(r) {
                let a = new i(), s = r[1].slice(2);
                if (this.init(a, r[2], r[3]), a.source.end = { line: r[4], column: r[5] }, a.inline = true, a.raws.begin = "//", /^\s*$/.test(s))
                  a.text = "", a.raws.left = s, a.raws.right = "";
                else {
                  let p = s.match(/^(\s*)([^]*[^\s])(\s*)$/);
                  [, a.raws.left, a.text, a.raws.right] = p;
                }
              }
              mixin(r) {
                let [a] = r, s = a[1].slice(0, 1), p = r.findIndex((d) => d[0] === "brackets"), g = r.findIndex((d) => d[0] === "("), v = "";
                if ((p < 0 || p > 3) && g > 0) {
                  let d = r.reduce(($, B, O) => B[0] === ")" ? O : $), S = r.slice(g, d + g).map(($) => $[1]).join(""), [x] = r.slice(g), N = [x[2], x[3]], [P] = r.slice(d, d + 1), W = [P[2], P[3]], U = ["brackets", S].concat(N, W), H = r.slice(0, g), D = r.slice(d + 1);
                  r = H, r.push(U), r = r.concat(D);
                }
                let y = [];
                for (let d of r)
                  if ((d[1] === "!" || y.length) && y.push(d), d[1] === "important")
                    break;
                if (y.length) {
                  let [d] = y, _ = r.indexOf(d), S = y[y.length - 1], x = [d[2], d[3]], N = [S[4], S[5]], P = y.map((U) => U[1]).join(""), W = ["word", P].concat(x, N);
                  r.splice(_, y.length, W);
                }
                let w = r.findIndex((d) => u.test(d[1]));
                w > 0 && ([, v] = r[w], r.splice(w, 1));
                for (let d of r.reverse())
                  this.tokenizer.back(d);
                this.atrule(this.tokenizer.nextToken()), this.lastNode.mixin = true, this.lastNode.raws.identifier = s, v && (this.lastNode.important = true, this.lastNode.raws.important = v);
              }
              other(r) {
                o.bind(this)(r) || super.other(r);
              }
              rule(r) {
                let a = r[r.length - 1], s = r[r.length - 2];
                if (s[0] === "at-word" && a[0] === "{" && (this.tokenizer.back(a), h.bind(this)(s))) {
                  let g = this.tokenizer.nextToken();
                  r = r.slice(0, r.length - 2).concat([g]);
                  for (let v of r.reverse())
                    this.tokenizer.back(v);
                  return;
                }
                super.rule(r), /:extend\(.+\)/i.test(this.lastNode.selector) && (this.lastNode.extend = true);
              }
              unknownWord(r) {
                let [a] = r;
                if (r[0][1] === "each" && r[1][0] === "(") {
                  this.each(r);
                  return;
                }
                if (l(a)) {
                  this.mixin(r);
                  return;
                }
                super.unknownWord(r);
              }
            };
          } }), Mf = R({ "node_modules/postcss-less/lib/LessStringifier.js"(e, n) {
            A();
            var i = br();
            n.exports = class extends i {
              atrule(o, h) {
                if (!o.mixin && !o.variable && !o.function) {
                  super.atrule(o, h);
                  return;
                }
                let f = `${o.function ? "" : o.raws.identifier || "@"}${o.name}`, m = o.params ? this.rawValue(o, "params") : "", u = o.raws.important || "";
                if (o.variable && (m = o.value), typeof o.raws.afterName < "u" ? f += o.raws.afterName : m && (f += " "), o.nodes)
                  this.block(o, f + m + u);
                else {
                  let t3 = (o.raws.between || "") + u + (h ? ";" : "");
                  this.builder(f + m + t3, o);
                }
              }
              comment(o) {
                if (o.inline) {
                  let h = this.raw(o, "left", "commentLeft"), l = this.raw(o, "right", "commentRight");
                  this.builder(`//${h}${o.text}${l}`, o);
                } else
                  super.comment(o);
              }
            };
          } }), Df = R({ "node_modules/postcss-less/lib/index.js"(e, n) {
            A();
            var i = _r(), c = jf(), o = Mf();
            n.exports = { parse(h, l) {
              let f = new i(h, l), m = new c(f);
              return m.parse(), m.root;
            }, stringify(h, l) {
              new o(l).stringify(h);
            }, nodeToString(h) {
              let l = "";
              return n.exports.stringify(h, (f) => {
                l += f;
              }), l;
            } };
          } }), Lf = R({ "node_modules/postcss-scss/lib/scss-stringifier.js"(e, n) {
            "use strict";
            A();
            function i(h, l) {
              h.prototype = Object.create(l.prototype), h.prototype.constructor = h, h.__proto__ = l;
            }
            var c = br(), o = function(h) {
              i(l, h);
              function l() {
                return h.apply(this, arguments) || this;
              }
              var f = l.prototype;
              return f.comment = function(u) {
                var t3 = this.raw(u, "left", "commentLeft"), r = this.raw(u, "right", "commentRight");
                if (u.raws.inline) {
                  var a = u.raws.text || u.text;
                  this.builder("//" + t3 + a + r, u);
                } else
                  this.builder("/*" + t3 + u.text + r + "*/", u);
              }, f.decl = function(u, t3) {
                if (!u.isNested)
                  h.prototype.decl.call(this, u, t3);
                else {
                  var r = this.raw(u, "between", "colon"), a = u.prop + r + this.rawValue(u, "value");
                  u.important && (a += u.raws.important || " !important"), this.builder(a + "{", u, "start");
                  var s;
                  u.nodes && u.nodes.length ? (this.body(u), s = this.raw(u, "after")) : s = this.raw(u, "after", "emptyBody"), s && this.builder(s), this.builder("}", u, "end");
                }
              }, f.rawValue = function(u, t3) {
                var r = u[t3], a = u.raws[t3];
                return a && a.value === r ? a.scss ? a.scss : a.raw : r;
              }, l;
            }(c);
            n.exports = o;
          } }), zf = R({ "node_modules/postcss-scss/lib/scss-stringify.js"(e, n) {
            "use strict";
            A();
            var i = Lf();
            n.exports = function(o, h) {
              var l = new i(h);
              l.stringify(o);
            };
          } }), Bf = R({ "node_modules/postcss-scss/lib/nested-declaration.js"(e, n) {
            "use strict";
            A();
            function i(h, l) {
              h.prototype = Object.create(l.prototype), h.prototype.constructor = h, h.__proto__ = l;
            }
            var c = kr(), o = function(h) {
              i(l, h);
              function l(f) {
                var m;
                return m = h.call(this, f) || this, m.type = "decl", m.isNested = true, m.nodes || (m.nodes = []), m;
              }
              return l;
            }(c);
            n.exports = o;
          } }), Ff = R({ "node_modules/postcss-scss/lib/scss-tokenize.js"(e, n) {
            "use strict";
            A();
            var i = "'".charCodeAt(0), c = '"'.charCodeAt(0), o = "\\".charCodeAt(0), h = "/".charCodeAt(0), l = `
`.charCodeAt(0), f = " ".charCodeAt(0), m = "\f".charCodeAt(0), u = "	".charCodeAt(0), t3 = "\r".charCodeAt(0), r = "[".charCodeAt(0), a = "]".charCodeAt(0), s = "(".charCodeAt(0), p = ")".charCodeAt(0), g = "{".charCodeAt(0), v = "}".charCodeAt(0), y = ";".charCodeAt(0), w = "*".charCodeAt(0), d = ":".charCodeAt(0), _ = "@".charCodeAt(0), S = ",".charCodeAt(0), x = "#".charCodeAt(0), N = /[ \n\t\r\f{}()'"\\;/[\]#]/g, P = /[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g, W = /.[\\/("'\n]/, U = /[a-f0-9]/i, H = /[\r\f\n]/g;
            n.exports = function($, B) {
              B === void 0 && (B = {});
              var O = $.css.valueOf(), j = B.ignoreErrors, C, I, X, Z, Q, K, J, M, Y, G, E, k, b, L, q = O.length, T = -1, F = 1, z = 0, re = [], ne = [];
              function ce(se) {
                throw $.error("Unclosed " + se, F, z - T);
              }
              function fe() {
                return ne.length === 0 && z >= q;
              }
              function te() {
                for (var se = 1, le = false, pe = false; se > 0; )
                  I += 1, O.length <= I && ce("interpolation"), C = O.charCodeAt(I), k = O.charCodeAt(I + 1), le ? !pe && C === le ? (le = false, pe = false) : C === o ? pe = !G : pe && (pe = false) : C === i || C === c ? le = C : C === v ? se -= 1 : C === x && k === g && (se += 1);
              }
              function ie() {
                if (ne.length)
                  return ne.pop();
                if (!(z >= q)) {
                  switch (C = O.charCodeAt(z), (C === l || C === m || C === t3 && O.charCodeAt(z + 1) !== l) && (T = z, F += 1), C) {
                    case l:
                    case f:
                    case u:
                    case t3:
                    case m:
                      I = z;
                      do
                        I += 1, C = O.charCodeAt(I), C === l && (T = I, F += 1);
                      while (C === f || C === l || C === u || C === t3 || C === m);
                      b = ["space", O.slice(z, I)], z = I - 1;
                      break;
                    case r:
                      b = ["[", "[", F, z - T];
                      break;
                    case a:
                      b = ["]", "]", F, z - T];
                      break;
                    case g:
                      b = ["{", "{", F, z - T];
                      break;
                    case v:
                      b = ["}", "}", F, z - T];
                      break;
                    case S:
                      b = ["word", ",", F, z - T, F, z - T + 1];
                      break;
                    case d:
                      b = [":", ":", F, z - T];
                      break;
                    case y:
                      b = [";", ";", F, z - T];
                      break;
                    case s:
                      if (E = re.length ? re.pop()[1] : "", k = O.charCodeAt(z + 1), E === "url" && k !== i && k !== c) {
                        for (L = 1, G = false, I = z + 1; I <= O.length - 1; ) {
                          if (k = O.charCodeAt(I), k === o)
                            G = !G;
                          else if (k === s)
                            L += 1;
                          else if (k === p && (L -= 1, L === 0))
                            break;
                          I += 1;
                        }
                        K = O.slice(z, I + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = I - Z[Q].length) : (M = F, Y = T), b = ["brackets", K, F, z - T, M, I - Y], T = Y, F = M, z = I;
                      } else
                        I = O.indexOf(")", z + 1), K = O.slice(z, I + 1), I === -1 || W.test(K) ? b = ["(", "(", F, z - T] : (b = ["brackets", K, F, z - T, F, I - T], z = I);
                      break;
                    case p:
                      b = [")", ")", F, z - T];
                      break;
                    case i:
                    case c:
                      for (X = C, I = z, G = false; I < q && (I++, I === q && ce("string"), C = O.charCodeAt(I), k = O.charCodeAt(I + 1), !(!G && C === X)); )
                        C === o ? G = !G : G ? G = false : C === x && k === g && te();
                      K = O.slice(z, I + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = I - Z[Q].length) : (M = F, Y = T), b = ["string", O.slice(z, I + 1), F, z - T, M, I - Y], T = Y, F = M, z = I;
                      break;
                    case _:
                      N.lastIndex = z + 1, N.test(O), N.lastIndex === 0 ? I = O.length - 1 : I = N.lastIndex - 2, b = ["at-word", O.slice(z, I + 1), F, z - T, F, I - T], z = I;
                      break;
                    case o:
                      for (I = z, J = true; O.charCodeAt(I + 1) === o; )
                        I += 1, J = !J;
                      if (C = O.charCodeAt(I + 1), J && C !== h && C !== f && C !== l && C !== u && C !== t3 && C !== m && (I += 1, U.test(O.charAt(I)))) {
                        for (; U.test(O.charAt(I + 1)); )
                          I += 1;
                        O.charCodeAt(I + 1) === f && (I += 1);
                      }
                      b = ["word", O.slice(z, I + 1), F, z - T, F, I - T], z = I;
                      break;
                    default:
                      k = O.charCodeAt(z + 1), C === x && k === g ? (I = z, te(), K = O.slice(z, I + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = I - Z[Q].length) : (M = F, Y = T), b = ["word", K, F, z - T, M, I - Y], T = Y, F = M, z = I) : C === h && k === w ? (I = O.indexOf("*/", z + 2) + 1, I === 0 && (j ? I = O.length : ce("comment")), K = O.slice(z, I + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = I - Z[Q].length) : (M = F, Y = T), b = ["comment", K, F, z - T, M, I - Y], T = Y, F = M, z = I) : C === h && k === h ? (H.lastIndex = z + 1, H.test(O), H.lastIndex === 0 ? I = O.length - 1 : I = H.lastIndex - 2, K = O.slice(z, I + 1), b = ["comment", K, F, z - T, F, I - T, "inline"], z = I) : (P.lastIndex = z + 1, P.test(O), P.lastIndex === 0 ? I = O.length - 1 : I = P.lastIndex - 2, b = ["word", O.slice(z, I + 1), F, z - T, F, I - T], re.push(b), z = I);
                      break;
                  }
                  return z++, b;
                }
              }
              function ae(se) {
                ne.push(se);
              }
              return { back: ae, nextToken: ie, endOfFile: fe };
            };
          } }), Uf = R({ "node_modules/postcss-scss/lib/scss-parser.js"(e, n) {
            "use strict";
            A();
            function i(m, u) {
              m.prototype = Object.create(u.prototype), m.prototype.constructor = m, m.__proto__ = u;
            }
            var c = xr(), o = zt(), h = Bf(), l = Ff(), f = function(m) {
              i(u, m);
              function u() {
                return m.apply(this, arguments) || this;
              }
              var t3 = u.prototype;
              return t3.createTokenizer = function() {
                this.tokenizer = l(this.input);
              }, t3.rule = function(a) {
                for (var s = false, p = 0, g = "", w = a, v = Array.isArray(w), y = 0, w = v ? w : w[Symbol.iterator](); ; ) {
                  var d;
                  if (v) {
                    if (y >= w.length)
                      break;
                    d = w[y++];
                  } else {
                    if (y = w.next(), y.done)
                      break;
                    d = y.value;
                  }
                  var _ = d;
                  if (s)
                    _[0] !== "comment" && _[0] !== "{" && (g += _[1]);
                  else {
                    if (_[0] === "space" && _[1].indexOf(`
`) !== -1)
                      break;
                    _[0] === "(" ? p += 1 : _[0] === ")" ? p -= 1 : p === 0 && _[0] === ":" && (s = true);
                  }
                }
                if (!s || g.trim() === "" || /^[a-zA-Z-:#]/.test(g))
                  m.prototype.rule.call(this, a);
                else {
                  a.pop();
                  var S = new h();
                  this.init(S);
                  var x = a[a.length - 1];
                  for (x[4] ? S.source.end = { line: x[4], column: x[5] } : S.source.end = { line: x[2], column: x[3] }; a[0][0] !== "word"; )
                    S.raws.before += a.shift()[1];
                  for (S.source.start = { line: a[0][2], column: a[0][3] }, S.prop = ""; a.length; ) {
                    var N = a[0][0];
                    if (N === ":" || N === "space" || N === "comment")
                      break;
                    S.prop += a.shift()[1];
                  }
                  S.raws.between = "";
                  for (var P; a.length; )
                    if (P = a.shift(), P[0] === ":") {
                      S.raws.between += P[1];
                      break;
                    } else
                      S.raws.between += P[1];
                  (S.prop[0] === "_" || S.prop[0] === "*") && (S.raws.before += S.prop[0], S.prop = S.prop.slice(1)), S.raws.between += this.spacesAndCommentsFromStart(a), this.precheckMissedSemicolon(a);
                  for (var W = a.length - 1; W > 0; W--) {
                    if (P = a[W], P[1] === "!important") {
                      S.important = true;
                      var U = this.stringFrom(a, W);
                      U = this.spacesFromEnd(a) + U, U !== " !important" && (S.raws.important = U);
                      break;
                    } else if (P[1] === "important") {
                      for (var H = a.slice(0), D = "", $ = W; $ > 0; $--) {
                        var B = H[$][0];
                        if (D.trim().indexOf("!") === 0 && B !== "space")
                          break;
                        D = H.pop()[1] + D;
                      }
                      D.trim().indexOf("!") === 0 && (S.important = true, S.raws.important = D, a = H);
                    }
                    if (P[0] !== "space" && P[0] !== "comment")
                      break;
                  }
                  this.raw(S, "value", a), S.value.indexOf(":") !== -1 && this.checkMissedSemicolon(a), this.current = S;
                }
              }, t3.comment = function(a) {
                if (a[6] === "inline") {
                  var s = new c();
                  this.init(s, a[2], a[3]), s.raws.inline = true, s.source.end = { line: a[4], column: a[5] };
                  var p = a[1].slice(2);
                  if (/^\s*$/.test(p))
                    s.text = "", s.raws.left = p, s.raws.right = "";
                  else {
                    var g = p.match(/^(\s*)([^]*[^\s])(\s*)$/), v = g[2].replace(/(\*\/|\/\*)/g, "*//*");
                    s.text = v, s.raws.left = g[1], s.raws.right = g[3], s.raws.text = g[2];
                  }
                } else
                  m.prototype.comment.call(this, a);
              }, t3.raw = function(a, s, p) {
                if (m.prototype.raw.call(this, a, s, p), a.raws[s]) {
                  var g = a.raws[s].raw;
                  a.raws[s].raw = p.reduce(function(v, y) {
                    if (y[0] === "comment" && y[6] === "inline") {
                      var w = y[1].slice(2).replace(/(\*\/|\/\*)/g, "*//*");
                      return v + "/*" + w + "*/";
                    } else
                      return v + y[1];
                  }, ""), g !== a.raws[s].raw && (a.raws[s].scss = g);
                }
              }, u;
            }(o);
            n.exports = f;
          } }), Wf = R({ "node_modules/postcss-scss/lib/scss-parse.js"(e, n) {
            "use strict";
            A();
            var i = _r(), c = Uf();
            n.exports = function(h, l) {
              var f = new i(h, l), m = new c(f);
              return m.parse(), m.root;
            };
          } }), $f = R({ "node_modules/postcss-scss/lib/scss-syntax.js"(e, n) {
            "use strict";
            A();
            var i = zf(), c = Wf();
            n.exports = { parse: c, stringify: i };
          } });
          A();
          var Vf = ml(), pt = Cs(), Gf = Ns(), { hasPragma: Hf } = Tl(), { locStart: Jf, locEnd: Kf } = Js(), { calculateLoc: Qf, replaceQuotesInInlineComments: Yf } = Js(), Xf = Pl(), Zf = Rl(), ht = Il(), sa = Cl(), ep = Nl(), rp = jl(), tp = Ml(), np = Dl(), ip = (e) => {
            for (; e.parent; )
              e = e.parent;
            return e;
          };
          function sp(e, n) {
            let { nodes: i } = e, c = { open: null, close: null, groups: [], type: "paren_group" }, o = [c], h = c, l = { groups: [], type: "comma_group" }, f = [l];
            for (let m = 0; m < i.length; ++m) {
              let u = i[m];
              if (sa(n.parser, u.value) && u.type === "number" && u.unit === ".." && pt(u.value) === "." && (u.value = u.value.slice(0, -1), u.unit = "..."), u.type === "func" && u.value === "selector" && (u.group.groups = [Ie(ip(e).text.slice(u.group.open.sourceIndex + 1, u.group.close.sourceIndex))]), u.type === "func" && u.value === "url") {
                let t3 = u.group && u.group.groups || [], r = [];
                for (let a = 0; a < t3.length; a++) {
                  let s = t3[a];
                  s.type === "comma_group" ? r = [...r, ...s.groups] : r.push(s);
                }
                if (Xf(r) || !Zf(r) && !rp(r[0])) {
                  let a = tp({ groups: u.group.groups });
                  u.group.groups = [a.trim()];
                }
              }
              if (u.type === "paren" && u.value === "(")
                c = { open: u, close: null, groups: [], type: "paren_group" }, o.push(c), l = { groups: [], type: "comma_group" }, f.push(l);
              else if (u.type === "paren" && u.value === ")") {
                if (l.groups.length > 0 && c.groups.push(l), c.close = u, f.length === 1)
                  throw new Error("Unbalanced parenthesis");
                f.pop(), l = pt(f), l.groups.push(c), o.pop(), c = pt(o);
              } else
                u.type === "comma" ? (c.groups.push(l), l = { groups: [], type: "comma_group" }, f[f.length - 1] = l) : l.groups.push(u);
            }
            return l.groups.length > 0 && c.groups.push(l), h;
          }
          function hr(e) {
            return e.type === "paren_group" && !e.open && !e.close && e.groups.length === 1 || e.type === "comma_group" && e.groups.length === 1 ? hr(e.groups[0]) : e.type === "paren_group" || e.type === "comma_group" ? Object.assign(Object.assign({}, e), {}, { groups: e.groups.map(hr) }) : e;
          }
          function Xe(e, n, i) {
            if (e && typeof e == "object") {
              delete e.parent;
              for (let c in e)
                Xe(e[c], n, i), c === "type" && typeof e[c] == "string" && !e[c].startsWith(n) && (!i || !i.test(e[c])) && (e[c] = n + e[c]);
            }
            return e;
          }
          function oa(e) {
            if (e && typeof e == "object") {
              delete e.parent;
              for (let n in e)
                oa(e[n]);
              !Array.isArray(e) && e.value && !e.type && (e.type = "unknown");
            }
            return e;
          }
          function aa(e, n) {
            if (e && typeof e == "object") {
              for (let i in e)
                i !== "parent" && (aa(e[i], n), i === "nodes" && (e.group = hr(sp(e, n)), delete e[i]));
              delete e.parent;
            }
            return e;
          }
          function Pe(e, n) {
            let i = lf(), c = null;
            try {
              c = i(e, { loose: true }).parse();
            } catch {
              return { type: "value-unknown", value: e };
            }
            c.text = e;
            let o = aa(c, n);
            return Xe(o, "value-", /^selector-/);
          }
          function Ie(e) {
            if (/\/\/|\/\*/.test(e))
              return { type: "selector-unknown", value: e.trim() };
            let n = vf(), i = null;
            try {
              n((c) => {
                i = c;
              }).process(e);
            } catch {
              return { type: "selector-unknown", value: e };
            }
            return Xe(i, "selector-");
          }
          function op(e) {
            let n = gf().default, i = null;
            try {
              i = n(e);
            } catch {
              return { type: "selector-unknown", value: e };
            }
            return Xe(oa(i), "media-");
          }
          var ap = /(\s*)(!default).*$/, up = /(\s*)(!global).*$/;
          function ua(e, n) {
            if (e && typeof e == "object") {
              delete e.parent;
              for (let m in e)
                ua(e[m], n);
              if (!e.type)
                return e;
              e.raws || (e.raws = {});
              let h = "";
              if (typeof e.selector == "string") {
                var i;
                h = e.raws.selector ? (i = e.raws.selector.scss) !== null && i !== void 0 ? i : e.raws.selector.raw : e.selector, e.raws.between && e.raws.between.trim().length > 0 && (h += e.raws.between), e.raws.selector = h;
              }
              let l = "";
              if (typeof e.value == "string") {
                var c;
                l = e.raws.value ? (c = e.raws.value.scss) !== null && c !== void 0 ? c : e.raws.value.raw : e.value, l = l.trim(), e.raws.value = l;
              }
              let f = "";
              if (typeof e.params == "string") {
                var o;
                f = e.raws.params ? (o = e.raws.params.scss) !== null && o !== void 0 ? o : e.raws.params.raw : e.params, e.raws.afterName && e.raws.afterName.trim().length > 0 && (f = e.raws.afterName + f), e.raws.between && e.raws.between.trim().length > 0 && (f = f + e.raws.between), f = f.trim(), e.raws.params = f;
              }
              if (h.trim().length > 0)
                return h.startsWith("@") && h.endsWith(":") ? e : e.mixin ? (e.selector = Pe(h, n), e) : (ep(e) && (e.isSCSSNesterProperty = true), e.selector = Ie(h), e);
              if (l.length > 0) {
                let m = l.match(ap);
                m && (l = l.slice(0, m.index), e.scssDefault = true, m[0].trim() !== "!default" && (e.raws.scssDefault = m[0]));
                let u = l.match(up);
                if (u && (l = l.slice(0, u.index), e.scssGlobal = true, u[0].trim() !== "!global" && (e.raws.scssGlobal = u[0])), l.startsWith("progid:"))
                  return { type: "value-unknown", value: l };
                e.value = Pe(l, n);
              }
              if (ht(n) && e.type === "css-decl" && l.startsWith("extend(") && (e.extend || (e.extend = e.raws.between === ":"), e.extend && !e.selector && (delete e.value, e.selector = Ie(l.slice(7, -1)))), e.type === "css-atrule") {
                if (ht(n)) {
                  if (e.mixin) {
                    let m = e.raws.identifier + e.name + e.raws.afterName + e.raws.params;
                    return e.selector = Ie(m), delete e.params, e;
                  }
                  if (e.function)
                    return e;
                }
                if (n.parser === "css" && e.name === "custom-selector") {
                  let m = e.params.match(/:--\S+\s+/)[0].trim();
                  return e.customSelector = m, e.selector = Ie(e.params.slice(m.length).trim()), delete e.params, e;
                }
                if (ht(n)) {
                  if (e.name.includes(":") && !e.params) {
                    e.variable = true;
                    let m = e.name.split(":");
                    e.name = m[0], e.value = Pe(m.slice(1).join(":"), n);
                  }
                  if (!["page", "nest", "keyframes"].includes(e.name) && e.params && e.params[0] === ":" && (e.variable = true, e.value = Pe(e.params.slice(1), n), e.raws.afterName += ":"), e.variable)
                    return delete e.params, e;
                }
              }
              if (e.type === "css-atrule" && f.length > 0) {
                let { name: m } = e, u = e.name.toLowerCase();
                return m === "warn" || m === "error" ? (e.params = { type: "media-unknown", value: f }, e) : m === "extend" || m === "nest" ? (e.selector = Ie(f), delete e.params, e) : m === "at-root" ? (/^\(\s*(?:without|with)\s*:.+\)$/s.test(f) ? e.params = Pe(f, n) : (e.selector = Ie(f), delete e.params), e) : np(u) ? (e.import = true, delete e.filename, e.params = Pe(f, n), e) : ["namespace", "supports", "if", "else", "for", "each", "while", "debug", "mixin", "include", "function", "return", "define-mixin", "add-mixin"].includes(m) ? (f = f.replace(/(\$\S+?)(\s+)?\.{3}/, "$1...$2"), f = f.replace(/^(?!if)(\S+)(\s+)\(/, "$1($2"), e.value = Pe(f, n), delete e.params, e) : ["media", "custom-media"].includes(u) ? f.includes("#{") ? { type: "media-unknown", value: f } : (e.params = op(f), e) : (e.params = f, e);
              }
            }
            return e;
          }
          function ca(e, n, i) {
            let c = Gf(n), { frontMatter: o } = c;
            n = c.content;
            let h;
            try {
              h = e(n);
            } catch (l) {
              let { name: f, reason: m, line: u, column: t3 } = l;
              throw typeof u != "number" ? l : Vf(`${f}: ${m}`, { start: { line: u, column: t3 } });
            }
            return h = ua(Xe(h, "css-"), i), Qf(h, n), o && (o.source = { startOffset: 0, endOffset: o.raw.length }, h.nodes.unshift(o)), h;
          }
          function cp(e, n) {
            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = sa(i.parser, e) ? [xt, bt] : [bt, xt], h;
            for (let l of o)
              try {
                return l(e, n, i);
              } catch (f) {
                h = h || f;
              }
            if (h)
              throw h;
          }
          function bt(e, n) {
            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, c = Df();
            return ca((o) => c.parse(Yf(o)), e, i);
          }
          function xt(e, n) {
            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, { parse: c } = $f();
            return ca(c, e, i);
          }
          var dt = { astFormat: "postcss", hasPragma: Hf, locStart: Jf, locEnd: Kf };
          la.exports = { parsers: { css: Object.assign(Object.assign({}, dt), {}, { parse: cp }), less: Object.assign(Object.assign({}, dt), {}, { parse: bt }), scss: Object.assign(Object.assign({}, dt), {}, { parse: xt }) } };
        });
        return lp();
      });
    }
  });

  // node_modules/prettier/parser-html.js
  var require_parser_html = __commonJS({
    "node_modules/prettier/parser-html.js"(exports2, module2) {
      init_define_process();
      (function(e) {
        if (typeof exports2 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var i = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          i.prettierPlugins = i.prettierPlugins || {}, i.prettierPlugins.html = e();
        }
      })(function() {
        "use strict";
        var y = (e, r) => () => (r || e((r = { exports: {} }).exports, r), r.exports);
        var G = y((uc, Hr) => {
          var be = function(e) {
            return e && e.Math == Math && e;
          };
          Hr.exports = be(typeof globalThis == "object" && globalThis) || be(typeof window == "object" && window) || be(typeof self == "object" && self) || be(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var se = y((tc, zr) => {
          zr.exports = function(e) {
            try {
              return !!e();
            } catch {
              return true;
            }
          };
        });
        var oe = y((nc, Wr) => {
          var As = se();
          Wr.exports = !As(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var we = y((sc, Yr) => {
          var vs = se();
          Yr.exports = !vs(function() {
            var e = function() {
            }.bind();
            return typeof e != "function" || e.hasOwnProperty("prototype");
          });
        });
        var De = y((ic, Qr) => {
          var _s = we(), Ne = Function.prototype.call;
          Qr.exports = _s ? Ne.bind(Ne) : function() {
            return Ne.apply(Ne, arguments);
          };
        });
        var eu = y((Zr) => {
          "use strict";
          var Kr = {}.propertyIsEnumerable, Jr = Object.getOwnPropertyDescriptor, Ss = Jr && !Kr.call({ 1: 2 }, 1);
          Zr.f = Ss ? function(r) {
            var u = Jr(this, r);
            return !!u && u.enumerable;
          } : Kr;
        });
        var Oe = y((oc, ru) => {
          ru.exports = function(e, r) {
            return { enumerable: !(e & 1), configurable: !(e & 2), writable: !(e & 4), value: r };
          };
        });
        var Q = y((Dc, nu) => {
          var uu = we(), tu = Function.prototype, ys = tu.bind, Ze = tu.call, Ts = uu && ys.bind(Ze, Ze);
          nu.exports = uu ? function(e) {
            return e && Ts(e);
          } : function(e) {
            return e && function() {
              return Ze.apply(e, arguments);
            };
          };
        });
        var qe = y((lc, iu) => {
          var su = Q(), Bs = su({}.toString), bs = su("".slice);
          iu.exports = function(e) {
            return bs(Bs(e), 8, -1);
          };
        });
        var ou = y((cc, au) => {
          var ws = G(), Ns = Q(), Os = se(), qs = qe(), er = ws.Object, Is = Ns("".split);
          au.exports = Os(function() {
            return !er("z").propertyIsEnumerable(0);
          }) ? function(e) {
            return qs(e) == "String" ? Is(e, "") : er(e);
          } : er;
        });
        var rr = y((hc, Du) => {
          var Rs = G(), xs = Rs.TypeError;
          Du.exports = function(e) {
            if (e == null)
              throw xs("Can't call method on " + e);
            return e;
          };
        });
        var Ie = y((pc, lu) => {
          var Ps = ou(), ks = rr();
          lu.exports = function(e) {
            return Ps(ks(e));
          };
        });
        var K = y((fc, cu) => {
          cu.exports = function(e) {
            return typeof e == "function";
          };
        });
        var le = y((dc, hu) => {
          var Ls = K();
          hu.exports = function(e) {
            return typeof e == "object" ? e !== null : Ls(e);
          };
        });
        var me = y((Ec, pu) => {
          var ur = G(), $s = K(), Ms = function(e) {
            return $s(e) ? e : void 0;
          };
          pu.exports = function(e, r) {
            return arguments.length < 2 ? Ms(ur[e]) : ur[e] && ur[e][r];
          };
        });
        var tr = y((Cc, fu) => {
          var js = Q();
          fu.exports = js({}.isPrototypeOf);
        });
        var Eu = y((mc, du) => {
          var Us = me();
          du.exports = Us("navigator", "userAgent") || "";
        });
        var _u = y((gc, vu) => {
          var Au = G(), nr = Eu(), Cu = Au.process, mu = Au.Deno, gu = Cu && Cu.versions || mu && mu.version, Fu = gu && gu.v8, ue, Re;
          Fu && (ue = Fu.split("."), Re = ue[0] > 0 && ue[0] < 4 ? 1 : +(ue[0] + ue[1]));
          !Re && nr && (ue = nr.match(/Edge\/(\d+)/), (!ue || ue[1] >= 74) && (ue = nr.match(/Chrome\/(\d+)/), ue && (Re = +ue[1])));
          vu.exports = Re;
        });
        var sr = y((Fc, yu) => {
          var Su = _u(), Gs = se();
          yu.exports = !!Object.getOwnPropertySymbols && !Gs(function() {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && Su && Su < 41;
          });
        });
        var ir = y((Ac, Tu) => {
          var Vs = sr();
          Tu.exports = Vs && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var ar = y((vc, Bu) => {
          var Xs = G(), Hs = me(), zs = K(), Ws = tr(), Ys = ir(), Qs = Xs.Object;
          Bu.exports = Ys ? function(e) {
            return typeof e == "symbol";
          } : function(e) {
            var r = Hs("Symbol");
            return zs(r) && Ws(r.prototype, Qs(e));
          };
        });
        var xe = y((_c, bu) => {
          var Ks = G(), Js = Ks.String;
          bu.exports = function(e) {
            try {
              return Js(e);
            } catch {
              return "Object";
            }
          };
        });
        var ge = y((Sc, wu) => {
          var Zs = G(), ei = K(), ri = xe(), ui = Zs.TypeError;
          wu.exports = function(e) {
            if (ei(e))
              return e;
            throw ui(ri(e) + " is not a function");
          };
        });
        var Pe = y((yc, Nu) => {
          var ti = ge();
          Nu.exports = function(e, r) {
            var u = e[r];
            return u == null ? void 0 : ti(u);
          };
        });
        var qu = y((Tc, Ou) => {
          var ni = G(), or = De(), Dr = K(), lr = le(), si = ni.TypeError;
          Ou.exports = function(e, r) {
            var u, s;
            if (r === "string" && Dr(u = e.toString) && !lr(s = or(u, e)) || Dr(u = e.valueOf) && !lr(s = or(u, e)) || r !== "string" && Dr(u = e.toString) && !lr(s = or(u, e)))
              return s;
            throw si("Can't convert object to primitive value");
          };
        });
        var Ru = y((Bc, Iu) => {
          Iu.exports = false;
        });
        var ke = y((bc, Pu) => {
          var xu = G(), ii = Object.defineProperty;
          Pu.exports = function(e, r) {
            try {
              ii(xu, e, { value: r, configurable: true, writable: true });
            } catch {
              xu[e] = r;
            }
            return r;
          };
        });
        var Le = y((wc, Lu) => {
          var ai = G(), oi = ke(), ku = "__core-js_shared__", Di = ai[ku] || oi(ku, {});
          Lu.exports = Di;
        });
        var cr = y((Nc, Mu) => {
          var li = Ru(), $u = Le();
          (Mu.exports = function(e, r) {
            return $u[e] || ($u[e] = r !== void 0 ? r : {});
          })("versions", []).push({ version: "3.22.2", mode: li ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.22.2/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var hr = y((Oc, ju) => {
          var ci = G(), hi = rr(), pi = ci.Object;
          ju.exports = function(e) {
            return pi(hi(e));
          };
        });
        var ie = y((qc, Uu) => {
          var fi = Q(), di = hr(), Ei = fi({}.hasOwnProperty);
          Uu.exports = Object.hasOwn || function(r, u) {
            return Ei(di(r), u);
          };
        });
        var pr = y((Ic, Gu) => {
          var Ci = Q(), mi = 0, gi = Math.random(), Fi = Ci(1 .toString);
          Gu.exports = function(e) {
            return "Symbol(" + (e === void 0 ? "" : e) + ")_" + Fi(++mi + gi, 36);
          };
        });
        var he = y((Rc, Wu) => {
          var Ai = G(), vi = cr(), Vu = ie(), _i = pr(), Xu = sr(), zu = ir(), fe = vi("wks"), ce = Ai.Symbol, Hu = ce && ce.for, Si = zu ? ce : ce && ce.withoutSetter || _i;
          Wu.exports = function(e) {
            if (!Vu(fe, e) || !(Xu || typeof fe[e] == "string")) {
              var r = "Symbol." + e;
              Xu && Vu(ce, e) ? fe[e] = ce[e] : zu && Hu ? fe[e] = Hu(r) : fe[e] = Si(r);
            }
            return fe[e];
          };
        });
        var Ju = y((xc, Ku) => {
          var yi = G(), Ti = De(), Yu = le(), Qu = ar(), Bi = Pe(), bi = qu(), wi = he(), Ni = yi.TypeError, Oi = wi("toPrimitive");
          Ku.exports = function(e, r) {
            if (!Yu(e) || Qu(e))
              return e;
            var u = Bi(e, Oi), s;
            if (u) {
              if (r === void 0 && (r = "default"), s = Ti(u, e, r), !Yu(s) || Qu(s))
                return s;
              throw Ni("Can't convert object to primitive value");
            }
            return r === void 0 && (r = "number"), bi(e, r);
          };
        });
        var $e = y((Pc, Zu) => {
          var qi = Ju(), Ii = ar();
          Zu.exports = function(e) {
            var r = qi(e, "string");
            return Ii(r) ? r : r + "";
          };
        });
        var ut = y((kc, rt) => {
          var Ri = G(), et = le(), fr = Ri.document, xi = et(fr) && et(fr.createElement);
          rt.exports = function(e) {
            return xi ? fr.createElement(e) : {};
          };
        });
        var dr = y((Lc, tt) => {
          var Pi = oe(), ki = se(), Li = ut();
          tt.exports = !Pi && !ki(function() {
            return Object.defineProperty(Li("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var Er = y((st) => {
          var $i = oe(), Mi = De(), ji = eu(), Ui = Oe(), Gi = Ie(), Vi = $e(), Xi = ie(), Hi = dr(), nt = Object.getOwnPropertyDescriptor;
          st.f = $i ? nt : function(r, u) {
            if (r = Gi(r), u = Vi(u), Hi)
              try {
                return nt(r, u);
              } catch {
              }
            if (Xi(r, u))
              return Ui(!Mi(ji.f, r, u), r[u]);
          };
        });
        var at2 = y((Mc, it) => {
          var zi = oe(), Wi = se();
          it.exports = zi && Wi(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var de = y((jc, Dt) => {
          var ot = G(), Yi = le(), Qi = ot.String, Ki = ot.TypeError;
          Dt.exports = function(e) {
            if (Yi(e))
              return e;
            throw Ki(Qi(e) + " is not an object");
          };
        });
        var je = y((ct) => {
          var Ji = G(), Zi = oe(), ea = dr(), ra = at2(), Me = de(), lt2 = $e(), ua = Ji.TypeError, Cr = Object.defineProperty, ta = Object.getOwnPropertyDescriptor, mr = "enumerable", gr = "configurable", Fr = "writable";
          ct.f = Zi ? ra ? function(r, u, s) {
            if (Me(r), u = lt2(u), Me(s), typeof r == "function" && u === "prototype" && "value" in s && Fr in s && !s[Fr]) {
              var D = ta(r, u);
              D && D[Fr] && (r[u] = s.value, s = { configurable: gr in s ? s[gr] : D[gr], enumerable: mr in s ? s[mr] : D[mr], writable: false });
            }
            return Cr(r, u, s);
          } : Cr : function(r, u, s) {
            if (Me(r), u = lt2(u), Me(s), ea)
              try {
                return Cr(r, u, s);
              } catch {
              }
            if ("get" in s || "set" in s)
              throw ua("Accessors not supported");
            return "value" in s && (r[u] = s.value), r;
          };
        });
        var Ue = y((Gc, ht) => {
          var na = oe(), sa = je(), ia = Oe();
          ht.exports = na ? function(e, r, u) {
            return sa.f(e, r, ia(1, u));
          } : function(e, r, u) {
            return e[r] = u, e;
          };
        });
        var Ge = y((Vc, pt) => {
          var aa = Q(), oa = K(), Ar = Le(), Da = aa(Function.toString);
          oa(Ar.inspectSource) || (Ar.inspectSource = function(e) {
            return Da(e);
          });
          pt.exports = Ar.inspectSource;
        });
        var Et = y((Xc, dt) => {
          var la = G(), ca = K(), ha = Ge(), ft = la.WeakMap;
          dt.exports = ca(ft) && /native code/.test(ha(ft));
        });
        var gt2 = y((Hc, mt) => {
          var pa = cr(), fa = pr(), Ct = pa("keys");
          mt.exports = function(e) {
            return Ct[e] || (Ct[e] = fa(e));
          };
        });
        var vr = y((zc, Ft) => {
          Ft.exports = {};
        });
        var Tt = y((Wc, yt) => {
          var da = Et(), St = G(), _r = Q(), Ea = le(), Ca = Ue(), Sr = ie(), yr = Le(), ma = gt2(), ga = vr(), At = "Object already initialized", Br = St.TypeError, Fa = St.WeakMap, Ve, Fe, Xe, Aa = function(e) {
            return Xe(e) ? Fe(e) : Ve(e, {});
          }, va = function(e) {
            return function(r) {
              var u;
              if (!Ea(r) || (u = Fe(r)).type !== e)
                throw Br("Incompatible receiver, " + e + " required");
              return u;
            };
          };
          da || yr.state ? (ae = yr.state || (yr.state = new Fa()), vt = _r(ae.get), Tr = _r(ae.has), _t = _r(ae.set), Ve = function(e, r) {
            if (Tr(ae, e))
              throw new Br(At);
            return r.facade = e, _t(ae, e, r), r;
          }, Fe = function(e) {
            return vt(ae, e) || {};
          }, Xe = function(e) {
            return Tr(ae, e);
          }) : (pe = ma("state"), ga[pe] = true, Ve = function(e, r) {
            if (Sr(e, pe))
              throw new Br(At);
            return r.facade = e, Ca(e, pe, r), r;
          }, Fe = function(e) {
            return Sr(e, pe) ? e[pe] : {};
          }, Xe = function(e) {
            return Sr(e, pe);
          });
          var ae, vt, Tr, _t, pe;
          yt.exports = { set: Ve, get: Fe, has: Xe, enforce: Aa, getterFor: va };
        });
        var wt = y((Yc, bt) => {
          var br = oe(), _a = ie(), Bt = Function.prototype, Sa = br && Object.getOwnPropertyDescriptor, wr = _a(Bt, "name"), ya = wr && function() {
          }.name === "something", Ta = wr && (!br || br && Sa(Bt, "name").configurable);
          bt.exports = { EXISTS: wr, PROPER: ya, CONFIGURABLE: Ta };
        });
        var Rt = y((Qc, It) => {
          var Ba = G(), Nt = K(), ba = ie(), Ot = Ue(), wa = ke(), Na = Ge(), qt = Tt(), Oa = wt().CONFIGURABLE, qa = qt.get, Ia = qt.enforce, Ra = String(String).split("String");
          (It.exports = function(e, r, u, s) {
            var D = s ? !!s.unsafe : false, n = s ? !!s.enumerable : false, i = s ? !!s.noTargetGet : false, p = s && s.name !== void 0 ? s.name : r, l;
            if (Nt(u) && (String(p).slice(0, 7) === "Symbol(" && (p = "[" + String(p).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!ba(u, "name") || Oa && u.name !== p) && Ot(u, "name", p), l = Ia(u), l.source || (l.source = Ra.join(typeof p == "string" ? p : ""))), e === Ba) {
              n ? e[r] = u : wa(r, u);
              return;
            } else
              D ? !i && e[r] && (n = true) : delete e[r];
            n ? e[r] = u : Ot(e, r, u);
          })(Function.prototype, "toString", function() {
            return Nt(this) && qa(this).source || Na(this);
          });
        });
        var Nr = y((Kc, xt) => {
          var xa = Math.ceil, Pa = Math.floor;
          xt.exports = function(e) {
            var r = +e;
            return r !== r || r === 0 ? 0 : (r > 0 ? Pa : xa)(r);
          };
        });
        var kt = y((Jc, Pt) => {
          var ka = Nr(), La = Math.max, $a = Math.min;
          Pt.exports = function(e, r) {
            var u = ka(e);
            return u < 0 ? La(u + r, 0) : $a(u, r);
          };
        });
        var $t = y((Zc, Lt) => {
          var Ma = Nr(), ja = Math.min;
          Lt.exports = function(e) {
            return e > 0 ? ja(Ma(e), 9007199254740991) : 0;
          };
        });
        var Ae = y((e2, Mt) => {
          var Ua = $t();
          Mt.exports = function(e) {
            return Ua(e.length);
          };
        });
        var Gt = y((r2, Ut) => {
          var Ga = Ie(), Va = kt(), Xa = Ae(), jt = function(e) {
            return function(r, u, s) {
              var D = Ga(r), n = Xa(D), i = Va(s, n), p;
              if (e && u != u) {
                for (; n > i; )
                  if (p = D[i++], p != p)
                    return true;
              } else
                for (; n > i; i++)
                  if ((e || i in D) && D[i] === u)
                    return e || i || 0;
              return !e && -1;
            };
          };
          Ut.exports = { includes: jt(true), indexOf: jt(false) };
        });
        var Ht = y((u2, Xt) => {
          var Ha = Q(), Or = ie(), za = Ie(), Wa = Gt().indexOf, Ya = vr(), Vt = Ha([].push);
          Xt.exports = function(e, r) {
            var u = za(e), s = 0, D = [], n;
            for (n in u)
              !Or(Ya, n) && Or(u, n) && Vt(D, n);
            for (; r.length > s; )
              Or(u, n = r[s++]) && (~Wa(D, n) || Vt(D, n));
            return D;
          };
        });
        var Wt = y((t22, zt) => {
          zt.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var Qt = y((Yt) => {
          var Qa = Ht(), Ka = Wt(), Ja = Ka.concat("length", "prototype");
          Yt.f = Object.getOwnPropertyNames || function(r) {
            return Qa(r, Ja);
          };
        });
        var Jt = y((Kt) => {
          Kt.f = Object.getOwnPropertySymbols;
        });
        var en = y((i2, Zt) => {
          var Za = me(), eo = Q(), ro = Qt(), uo = Jt(), to = de(), no = eo([].concat);
          Zt.exports = Za("Reflect", "ownKeys") || function(r) {
            var u = ro.f(to(r)), s = uo.f;
            return s ? no(u, s(r)) : u;
          };
        });
        var tn = y((a2, un) => {
          var rn = ie(), so = en(), io = Er(), ao = je();
          un.exports = function(e, r, u) {
            for (var s = so(r), D = ao.f, n = io.f, i = 0; i < s.length; i++) {
              var p = s[i];
              !rn(e, p) && !(u && rn(u, p)) && D(e, p, n(r, p));
            }
          };
        });
        var sn = y((o2, nn) => {
          var oo = se(), Do = K(), lo = /#|\.prototype\./, ve = function(e, r) {
            var u = ho[co(e)];
            return u == fo ? true : u == po ? false : Do(r) ? oo(r) : !!r;
          }, co = ve.normalize = function(e) {
            return String(e).replace(lo, ".").toLowerCase();
          }, ho = ve.data = {}, po = ve.NATIVE = "N", fo = ve.POLYFILL = "P";
          nn.exports = ve;
        });
        var He = y((D2, an) => {
          var qr = G(), Eo = Er().f, Co = Ue(), mo = Rt(), go = ke(), Fo = tn(), Ao = sn();
          an.exports = function(e, r) {
            var u = e.target, s = e.global, D = e.stat, n, i, p, l, g, a;
            if (s ? i = qr : D ? i = qr[u] || go(u, {}) : i = (qr[u] || {}).prototype, i)
              for (p in r) {
                if (g = r[p], e.noTargetGet ? (a = Eo(i, p), l = a && a.value) : l = i[p], n = Ao(s ? p : u + (D ? "." : "#") + p, e.forced), !n && l !== void 0) {
                  if (typeof g == typeof l)
                    continue;
                  Fo(g, l);
                }
                (e.sham || l && l.sham) && Co(g, "sham", true), mo(i, p, g, e);
              }
          };
        });
        var on = y(() => {
          var vo = He(), _o = G();
          vo({ global: true }, { globalThis: _o });
        });
        var Dn = y(() => {
          on();
        });
        var Ir = y((f2, ln) => {
          var So = qe();
          ln.exports = Array.isArray || function(r) {
            return So(r) == "Array";
          };
        });
        var Rr = y((d2, hn) => {
          var cn = Q(), yo = ge(), To = we(), Bo = cn(cn.bind);
          hn.exports = function(e, r) {
            return yo(e), r === void 0 ? e : To ? Bo(e, r) : function() {
              return e.apply(r, arguments);
            };
          };
        });
        var dn = y((E2, fn) => {
          "use strict";
          var bo = G(), wo = Ir(), No = Ae(), Oo = Rr(), qo = bo.TypeError, pn = function(e, r, u, s, D, n, i, p) {
            for (var l = D, g = 0, a = i ? Oo(i, p) : false, c, h; g < s; ) {
              if (g in u) {
                if (c = a ? a(u[g], g, r) : u[g], n > 0 && wo(c))
                  h = No(c), l = pn(e, r, c, h, l, n - 1) - 1;
                else {
                  if (l >= 9007199254740991)
                    throw qo("Exceed the acceptable array length");
                  e[l] = c;
                }
                l++;
              }
              g++;
            }
            return l;
          };
          fn.exports = pn;
        });
        var mn = y((C2, Cn) => {
          var Io = he(), Ro = Io("toStringTag"), En = {};
          En[Ro] = "z";
          Cn.exports = String(En) === "[object z]";
        });
        var xr = y((m2, gn) => {
          var xo = G(), Po = mn(), ko = K(), ze = qe(), Lo = he(), $o = Lo("toStringTag"), Mo = xo.Object, jo = ze(function() {
            return arguments;
          }()) == "Arguments", Uo = function(e, r) {
            try {
              return e[r];
            } catch {
            }
          };
          gn.exports = Po ? ze : function(e) {
            var r, u, s;
            return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (u = Uo(r = Mo(e), $o)) == "string" ? u : jo ? ze(r) : (s = ze(r)) == "Object" && ko(r.callee) ? "Arguments" : s;
          };
        });
        var yn = y((g2, Sn) => {
          var Go = Q(), Vo = se(), Fn = K(), Xo = xr(), Ho = me(), zo = Ge(), An = function() {
          }, Wo = [], vn = Ho("Reflect", "construct"), Pr = /^\s*(?:class|function)\b/, Yo = Go(Pr.exec), Qo = !Pr.exec(An), _e = function(r) {
            if (!Fn(r))
              return false;
            try {
              return vn(An, Wo, r), true;
            } catch {
              return false;
            }
          }, _n = function(r) {
            if (!Fn(r))
              return false;
            switch (Xo(r)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return false;
            }
            try {
              return Qo || !!Yo(Pr, zo(r));
            } catch {
              return true;
            }
          };
          _n.sham = true;
          Sn.exports = !vn || Vo(function() {
            var e;
            return _e(_e.call) || !_e(Object) || !_e(function() {
              e = true;
            }) || e;
          }) ? _n : _e;
        });
        var wn = y((F2, bn) => {
          var Ko = G(), Tn = Ir(), Jo = yn(), Zo = le(), eD = he(), rD = eD("species"), Bn = Ko.Array;
          bn.exports = function(e) {
            var r;
            return Tn(e) && (r = e.constructor, Jo(r) && (r === Bn || Tn(r.prototype)) ? r = void 0 : Zo(r) && (r = r[rD], r === null && (r = void 0))), r === void 0 ? Bn : r;
          };
        });
        var On = y((A2, Nn) => {
          var uD = wn();
          Nn.exports = function(e, r) {
            return new (uD(e))(r === 0 ? 0 : r);
          };
        });
        var qn = y(() => {
          "use strict";
          var tD = He(), nD = dn(), sD = ge(), iD = hr(), aD = Ae(), oD = On();
          tD({ target: "Array", proto: true }, { flatMap: function(r) {
            var u = iD(this), s = aD(u), D;
            return sD(r), D = oD(u, 0), D.length = nD(D, u, u, s, 0, 1, r, arguments.length > 1 ? arguments[1] : void 0), D;
          } });
        });
        var kr = y((S2, In) => {
          In.exports = {};
        });
        var xn = y((y2, Rn) => {
          var DD = he(), lD = kr(), cD = DD("iterator"), hD = Array.prototype;
          Rn.exports = function(e) {
            return e !== void 0 && (lD.Array === e || hD[cD] === e);
          };
        });
        var Lr = y((T2, kn) => {
          var pD = xr(), Pn = Pe(), fD = kr(), dD = he(), ED = dD("iterator");
          kn.exports = function(e) {
            if (e != null)
              return Pn(e, ED) || Pn(e, "@@iterator") || fD[pD(e)];
          };
        });
        var $n = y((B2, Ln) => {
          var CD = G(), mD = De(), gD = ge(), FD = de(), AD = xe(), vD = Lr(), _D = CD.TypeError;
          Ln.exports = function(e, r) {
            var u = arguments.length < 2 ? vD(e) : r;
            if (gD(u))
              return FD(mD(u, e));
            throw _D(AD(e) + " is not iterable");
          };
        });
        var Un = y((b2, jn) => {
          var SD = De(), Mn = de(), yD = Pe();
          jn.exports = function(e, r, u) {
            var s, D;
            Mn(e);
            try {
              if (s = yD(e, "return"), !s) {
                if (r === "throw")
                  throw u;
                return u;
              }
              s = SD(s, e);
            } catch (n) {
              D = true, s = n;
            }
            if (r === "throw")
              throw u;
            if (D)
              throw s;
            return Mn(s), u;
          };
        });
        var zn = y((w2, Hn) => {
          var TD = G(), BD = Rr(), bD = De(), wD = de(), ND = xe(), OD = xn(), qD = Ae(), Gn = tr(), ID = $n(), RD = Lr(), Vn = Un(), xD = TD.TypeError, We = function(e, r) {
            this.stopped = e, this.result = r;
          }, Xn = We.prototype;
          Hn.exports = function(e, r, u) {
            var s = u && u.that, D = !!(u && u.AS_ENTRIES), n = !!(u && u.IS_ITERATOR), i = !!(u && u.INTERRUPTED), p = BD(r, s), l, g, a, c, h, C, d, m = function(B) {
              return l && Vn(l, "normal", B), new We(true, B);
            }, T = function(B) {
              return D ? (wD(B), i ? p(B[0], B[1], m) : p(B[0], B[1])) : i ? p(B, m) : p(B);
            };
            if (n)
              l = e;
            else {
              if (g = RD(e), !g)
                throw xD(ND(e) + " is not iterable");
              if (OD(g)) {
                for (a = 0, c = qD(e); c > a; a++)
                  if (h = T(e[a]), h && Gn(Xn, h))
                    return h;
                return new We(false);
              }
              l = ID(e, g);
            }
            for (C = l.next; !(d = bD(C, l)).done; ) {
              try {
                h = T(d.value);
              } catch (B) {
                Vn(l, "throw", B);
              }
              if (typeof h == "object" && h && Gn(Xn, h))
                return h;
            }
            return new We(false);
          };
        });
        var Yn = y((N2, Wn) => {
          "use strict";
          var PD = $e(), kD = je(), LD = Oe();
          Wn.exports = function(e, r, u) {
            var s = PD(r);
            s in e ? kD.f(e, s, LD(0, u)) : e[s] = u;
          };
        });
        var Qn = y(() => {
          var $D = He(), MD = zn(), jD = Yn();
          $D({ target: "Object", stat: true }, { fromEntries: function(r) {
            var u = {};
            return MD(r, function(s, D) {
              jD(u, s, D);
            }, { AS_ENTRIES: true }), u;
          } });
        });
        var ec = y((I2, Fs) => {
          var UD = ["cliName", "cliCategory", "cliDescription"];
          function GD(e, r) {
            if (e == null)
              return {};
            var u = VD(e, r), s, D;
            if (Object.getOwnPropertySymbols) {
              var n = Object.getOwnPropertySymbols(e);
              for (D = 0; D < n.length; D++)
                s = n[D], !(r.indexOf(s) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, s) || (u[s] = e[s]));
            }
            return u;
          }
          function VD(e, r) {
            if (e == null)
              return {};
            var u = {}, s = Object.keys(e), D, n;
            for (n = 0; n < s.length; n++)
              D = s[n], !(r.indexOf(D) >= 0) && (u[D] = e[D]);
            return u;
          }
          Dn();
          qn();
          Qn();
          var XD = Object.create, Ke = Object.defineProperty, HD = Object.getOwnPropertyDescriptor, Mr = Object.getOwnPropertyNames, zD = Object.getPrototypeOf, WD = Object.prototype.hasOwnProperty, Ee = (e, r) => function() {
            return e && (r = (0, e[Mr(e)[0]])(e = 0)), r;
          }, I = (e, r) => function() {
            return r || (0, e[Mr(e)[0]])((r = { exports: {} }).exports, r), r.exports;
          }, us = (e, r) => {
            for (var u in r)
              Ke(e, u, { get: r[u], enumerable: true });
          }, ts = (e, r, u, s) => {
            if (r && typeof r == "object" || typeof r == "function")
              for (let D of Mr(r))
                !WD.call(e, D) && D !== u && Ke(e, D, { get: () => r[D], enumerable: !(s = HD(r, D)) || s.enumerable });
            return e;
          }, YD = (e, r, u) => (u = e != null ? XD(zD(e)) : {}, ts(r || !e || !e.__esModule ? Ke(u, "default", { value: e, enumerable: true }) : u, e)), ns = (e) => ts(Ke({}, "__esModule", { value: true }), e), Kn, Jn, Se, q = Ee({ "<define:process>"() {
            Kn = {}, Jn = [], Se = { env: Kn, argv: Jn };
          } }), ss = I({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true }), e.$EOF = 0, e.$BSPACE = 8, e.$TAB = 9, e.$LF = 10, e.$VTAB = 11, e.$FF = 12, e.$CR = 13, e.$SPACE = 32, e.$BANG = 33, e.$DQ = 34, e.$HASH = 35, e.$$ = 36, e.$PERCENT = 37, e.$AMPERSAND = 38, e.$SQ = 39, e.$LPAREN = 40, e.$RPAREN = 41, e.$STAR = 42, e.$PLUS = 43, e.$COMMA = 44, e.$MINUS = 45, e.$PERIOD = 46, e.$SLASH = 47, e.$COLON = 58, e.$SEMICOLON = 59, e.$LT = 60, e.$EQ = 61, e.$GT = 62, e.$QUESTION = 63, e.$0 = 48, e.$7 = 55, e.$9 = 57, e.$A = 65, e.$E = 69, e.$F = 70, e.$X = 88, e.$Z = 90, e.$LBRACKET = 91, e.$BACKSLASH = 92, e.$RBRACKET = 93, e.$CARET = 94, e.$_ = 95, e.$a = 97, e.$b = 98, e.$e = 101, e.$f = 102, e.$n = 110, e.$r = 114, e.$t = 116, e.$u = 117, e.$v = 118, e.$x = 120, e.$z = 122, e.$LBRACE = 123, e.$BAR = 124, e.$RBRACE = 125, e.$NBSP = 160, e.$PIPE = 124, e.$TILDA = 126, e.$AT = 64, e.$BT = 96;
            function r(p) {
              return p >= e.$TAB && p <= e.$SPACE || p == e.$NBSP;
            }
            e.isWhitespace = r;
            function u(p) {
              return e.$0 <= p && p <= e.$9;
            }
            e.isDigit = u;
            function s(p) {
              return p >= e.$a && p <= e.$z || p >= e.$A && p <= e.$Z;
            }
            e.isAsciiLetter = s;
            function D(p) {
              return p >= e.$a && p <= e.$f || p >= e.$A && p <= e.$F || u(p);
            }
            e.isAsciiHexDigit = D;
            function n(p) {
              return p === e.$LF || p === e.$CR;
            }
            e.isNewLine = n;
            function i(p) {
              return e.$0 <= p && p <= e.$7;
            }
            e.isOctalDigit = i;
          } }), QD = I({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = class {
              constructor(s, D, n) {
                this.filePath = s, this.name = D, this.members = n;
              }
              assertNoMembers() {
                if (this.members.length)
                  throw new Error(`Illegal state: symbol without members expected, but got ${JSON.stringify(this)}.`);
              }
            };
            e.StaticSymbol = r;
            var u = class {
              constructor() {
                this.cache = /* @__PURE__ */ new Map();
              }
              get(s, D, n) {
                n = n || [];
                let i = n.length ? `.${n.join(".")}` : "", p = `"${s}".${D}${i}`, l = this.cache.get(p);
                return l || (l = new r(s, D, n), this.cache.set(p, l)), l;
              }
            };
            e.StaticSymbolCache = u;
          } }), KD = I({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = /-+([a-z0-9])/g;
            function u(o) {
              return o.replace(r, function() {
                for (var E = arguments.length, f = new Array(E), F = 0; F < E; F++)
                  f[F] = arguments[F];
                return f[1].toUpperCase();
              });
            }
            e.dashCaseToCamelCase = u;
            function s(o, E) {
              return n(o, ":", E);
            }
            e.splitAtColon = s;
            function D(o, E) {
              return n(o, ".", E);
            }
            e.splitAtPeriod = D;
            function n(o, E, f) {
              let F = o.indexOf(E);
              return F == -1 ? f : [o.slice(0, F).trim(), o.slice(F + 1).trim()];
            }
            function i(o, E, f) {
              return Array.isArray(o) ? E.visitArray(o, f) : A(o) ? E.visitStringMap(o, f) : o == null || typeof o == "string" || typeof o == "number" || typeof o == "boolean" ? E.visitPrimitive(o, f) : E.visitOther(o, f);
            }
            e.visitValue = i;
            function p(o) {
              return o != null;
            }
            e.isDefined = p;
            function l(o) {
              return o === void 0 ? null : o;
            }
            e.noUndefined = l;
            var g = class {
              visitArray(o, E) {
                return o.map((f) => i(f, this, E));
              }
              visitStringMap(o, E) {
                let f = {};
                return Object.keys(o).forEach((F) => {
                  f[F] = i(o[F], this, E);
                }), f;
              }
              visitPrimitive(o, E) {
                return o;
              }
              visitOther(o, E) {
                return o;
              }
            };
            e.ValueTransformer = g, e.SyncAsync = { assertSync: (o) => {
              if (_(o))
                throw new Error("Illegal state: value cannot be a promise");
              return o;
            }, then: (o, E) => _(o) ? o.then(E) : E(o), all: (o) => o.some(_) ? Promise.all(o) : o };
            function a(o) {
              throw new Error(`Internal Error: ${o}`);
            }
            e.error = a;
            function c(o, E) {
              let f = Error(o);
              return f[h] = true, E && (f[C] = E), f;
            }
            e.syntaxError = c;
            var h = "ngSyntaxError", C = "ngParseErrors";
            function d(o) {
              return o[h];
            }
            e.isSyntaxError = d;
            function m(o) {
              return o[C] || [];
            }
            e.getParseErrors = m;
            function T(o) {
              return o.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
            }
            e.escapeRegExp = T;
            var B = Object.getPrototypeOf({});
            function A(o) {
              return typeof o == "object" && o !== null && Object.getPrototypeOf(o) === B;
            }
            function N(o) {
              let E = "";
              for (let f = 0; f < o.length; f++) {
                let F = o.charCodeAt(f);
                if (F >= 55296 && F <= 56319 && o.length > f + 1) {
                  let P = o.charCodeAt(f + 1);
                  P >= 56320 && P <= 57343 && (f++, F = (F - 55296 << 10) + P - 56320 + 65536);
                }
                F <= 127 ? E += String.fromCharCode(F) : F <= 2047 ? E += String.fromCharCode(F >> 6 & 31 | 192, F & 63 | 128) : F <= 65535 ? E += String.fromCharCode(F >> 12 | 224, F >> 6 & 63 | 128, F & 63 | 128) : F <= 2097151 && (E += String.fromCharCode(F >> 18 & 7 | 240, F >> 12 & 63 | 128, F >> 6 & 63 | 128, F & 63 | 128));
              }
              return E;
            }
            e.utf8Encode = N;
            function R(o) {
              if (typeof o == "string")
                return o;
              if (o instanceof Array)
                return "[" + o.map(R).join(", ") + "]";
              if (o == null)
                return "" + o;
              if (o.overriddenName)
                return `${o.overriddenName}`;
              if (o.name)
                return `${o.name}`;
              if (!o.toString)
                return "object";
              let E = o.toString();
              if (E == null)
                return "" + E;
              let f = E.indexOf(`
`);
              return f === -1 ? E : E.substring(0, f);
            }
            e.stringify = R;
            function j(o) {
              return typeof o == "function" && o.hasOwnProperty("__forward_ref__") ? o() : o;
            }
            e.resolveForwardRef = j;
            function _(o) {
              return !!o && typeof o.then == "function";
            }
            e.isPromise = _;
            var O = class {
              constructor(o) {
                this.full = o;
                let E = o.split(".");
                this.major = E[0], this.minor = E[1], this.patch = E.slice(2).join(".");
              }
            };
            e.Version = O;
            var x = typeof window < "u" && window, k = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, $ = typeof globalThis < "u" && globalThis, t3 = $ || x || k;
            e.global = t3;
          } }), JD = I({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = QD(), u = KD(), s = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
            function D(f) {
              return f.replace(/\W/g, "_");
            }
            e.sanitizeIdentifier = D;
            var n = 0;
            function i(f) {
              if (!f || !f.reference)
                return null;
              let F = f.reference;
              if (F instanceof r.StaticSymbol)
                return F.name;
              if (F.__anonymousType)
                return F.__anonymousType;
              let P = u.stringify(F);
              return P.indexOf("(") >= 0 ? (P = `anonymous_${n++}`, F.__anonymousType = P) : P = D(P), P;
            }
            e.identifierName = i;
            function p(f) {
              let F = f.reference;
              return F instanceof r.StaticSymbol ? F.filePath : `./${u.stringify(F)}`;
            }
            e.identifierModuleUrl = p;
            function l(f, F) {
              return `View_${i({ reference: f })}_${F}`;
            }
            e.viewClassName = l;
            function g(f) {
              return `RenderType_${i({ reference: f })}`;
            }
            e.rendererTypeName = g;
            function a(f) {
              return `HostView_${i({ reference: f })}`;
            }
            e.hostViewClassName = a;
            function c(f) {
              return `${i({ reference: f })}NgFactory`;
            }
            e.componentFactoryName = c;
            var h;
            (function(f) {
              f[f.Pipe = 0] = "Pipe", f[f.Directive = 1] = "Directive", f[f.NgModule = 2] = "NgModule", f[f.Injectable = 3] = "Injectable";
            })(h = e.CompileSummaryKind || (e.CompileSummaryKind = {}));
            function C(f) {
              return f.value != null ? D(f.value) : i(f.identifier);
            }
            e.tokenName = C;
            function d(f) {
              return f.identifier != null ? f.identifier.reference : f.value;
            }
            e.tokenReference = d;
            var m = class {
              constructor() {
                let { moduleUrl: f, styles: F, styleUrls: P } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.moduleUrl = f || null, this.styles = _(F), this.styleUrls = _(P);
              }
            };
            e.CompileStylesheetMetadata = m;
            var T = class {
              constructor(f) {
                let { encapsulation: F, template: P, templateUrl: M, htmlAst: W, styles: X, styleUrls: H, externalStylesheets: z, animations: J, ngContentSelectors: Z, interpolation: ee, isInline: v, preserveWhitespaces: S } = f;
                if (this.encapsulation = F, this.template = P, this.templateUrl = M, this.htmlAst = W, this.styles = _(X), this.styleUrls = _(H), this.externalStylesheets = _(z), this.animations = J ? x(J) : [], this.ngContentSelectors = Z || [], ee && ee.length != 2)
                  throw new Error("'interpolation' should have a start and an end symbol.");
                this.interpolation = ee, this.isInline = v, this.preserveWhitespaces = S;
              }
              toSummary() {
                return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
              }
            };
            e.CompileTemplateMetadata = T;
            var B = class {
              static create(f) {
                let { isHost: F, type: P, isComponent: M, selector: W, exportAs: X, changeDetection: H, inputs: z, outputs: J, host: Z, providers: ee, viewProviders: v, queries: S, guards: b, viewQueries: w, entryComponents: L, template: U, componentViewType: V, rendererType: Y, componentFactory: te } = f, Te = {}, Be = {}, Gr = {};
                Z != null && Object.keys(Z).forEach((re) => {
                  let ne = Z[re], Ce = re.match(s);
                  Ce === null ? Gr[re] = ne : Ce[1] != null ? Be[Ce[1]] = ne : Ce[2] != null && (Te[Ce[2]] = ne);
                });
                let Vr = {};
                z != null && z.forEach((re) => {
                  let ne = u.splitAtColon(re, [re, re]);
                  Vr[ne[0]] = ne[1];
                });
                let Xr = {};
                return J != null && J.forEach((re) => {
                  let ne = u.splitAtColon(re, [re, re]);
                  Xr[ne[0]] = ne[1];
                }), new B({ isHost: F, type: P, isComponent: !!M, selector: W, exportAs: X, changeDetection: H, inputs: Vr, outputs: Xr, hostListeners: Te, hostProperties: Be, hostAttributes: Gr, providers: ee, viewProviders: v, queries: S, guards: b, viewQueries: w, entryComponents: L, template: U, componentViewType: V, rendererType: Y, componentFactory: te });
              }
              constructor(f) {
                let { isHost: F, type: P, isComponent: M, selector: W, exportAs: X, changeDetection: H, inputs: z, outputs: J, hostListeners: Z, hostProperties: ee, hostAttributes: v, providers: S, viewProviders: b, queries: w, guards: L, viewQueries: U, entryComponents: V, template: Y, componentViewType: te, rendererType: Te, componentFactory: Be } = f;
                this.isHost = !!F, this.type = P, this.isComponent = M, this.selector = W, this.exportAs = X, this.changeDetection = H, this.inputs = z, this.outputs = J, this.hostListeners = Z, this.hostProperties = ee, this.hostAttributes = v, this.providers = _(S), this.viewProviders = _(b), this.queries = _(w), this.guards = L, this.viewQueries = _(U), this.entryComponents = _(V), this.template = Y, this.componentViewType = te, this.rendererType = Te, this.componentFactory = Be;
              }
              toSummary() {
                return { summaryKind: h.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
              }
            };
            e.CompileDirectiveMetadata = B;
            var A = class {
              constructor(f) {
                let { type: F, name: P, pure: M } = f;
                this.type = F, this.name = P, this.pure = !!M;
              }
              toSummary() {
                return { summaryKind: h.Pipe, type: this.type, name: this.name, pure: this.pure };
              }
            };
            e.CompilePipeMetadata = A;
            var N = class {
            };
            e.CompileShallowModuleMetadata = N;
            var R = class {
              constructor(f) {
                let { type: F, providers: P, declaredDirectives: M, exportedDirectives: W, declaredPipes: X, exportedPipes: H, entryComponents: z, bootstrapComponents: J, importedModules: Z, exportedModules: ee, schemas: v, transitiveModule: S, id: b } = f;
                this.type = F || null, this.declaredDirectives = _(M), this.exportedDirectives = _(W), this.declaredPipes = _(X), this.exportedPipes = _(H), this.providers = _(P), this.entryComponents = _(z), this.bootstrapComponents = _(J), this.importedModules = _(Z), this.exportedModules = _(ee), this.schemas = _(v), this.id = b || null, this.transitiveModule = S || null;
              }
              toSummary() {
                let f = this.transitiveModule;
                return { summaryKind: h.NgModule, type: this.type, entryComponents: f.entryComponents, providers: f.providers, modules: f.modules, exportedDirectives: f.exportedDirectives, exportedPipes: f.exportedPipes };
              }
            };
            e.CompileNgModuleMetadata = R;
            var j = class {
              constructor() {
                this.directivesSet = /* @__PURE__ */ new Set(), this.directives = [], this.exportedDirectivesSet = /* @__PURE__ */ new Set(), this.exportedDirectives = [], this.pipesSet = /* @__PURE__ */ new Set(), this.pipes = [], this.exportedPipesSet = /* @__PURE__ */ new Set(), this.exportedPipes = [], this.modulesSet = /* @__PURE__ */ new Set(), this.modules = [], this.entryComponentsSet = /* @__PURE__ */ new Set(), this.entryComponents = [], this.providers = [];
              }
              addProvider(f, F) {
                this.providers.push({ provider: f, module: F });
              }
              addDirective(f) {
                this.directivesSet.has(f.reference) || (this.directivesSet.add(f.reference), this.directives.push(f));
              }
              addExportedDirective(f) {
                this.exportedDirectivesSet.has(f.reference) || (this.exportedDirectivesSet.add(f.reference), this.exportedDirectives.push(f));
              }
              addPipe(f) {
                this.pipesSet.has(f.reference) || (this.pipesSet.add(f.reference), this.pipes.push(f));
              }
              addExportedPipe(f) {
                this.exportedPipesSet.has(f.reference) || (this.exportedPipesSet.add(f.reference), this.exportedPipes.push(f));
              }
              addModule(f) {
                this.modulesSet.has(f.reference) || (this.modulesSet.add(f.reference), this.modules.push(f));
              }
              addEntryComponent(f) {
                this.entryComponentsSet.has(f.componentType) || (this.entryComponentsSet.add(f.componentType), this.entryComponents.push(f));
              }
            };
            e.TransitiveCompileNgModuleMetadata = j;
            function _(f) {
              return f || [];
            }
            var O = class {
              constructor(f, F) {
                let { useClass: P, useValue: M, useExisting: W, useFactory: X, deps: H, multi: z } = F;
                this.token = f, this.useClass = P || null, this.useValue = M, this.useExisting = W, this.useFactory = X || null, this.dependencies = H || null, this.multi = !!z;
              }
            };
            e.ProviderMeta = O;
            function x(f) {
              return f.reduce((F, P) => {
                let M = Array.isArray(P) ? x(P) : P;
                return F.concat(M);
              }, []);
            }
            e.flatten = x;
            function k(f) {
              return f.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
            }
            function $(f, F, P) {
              let M;
              return P.isInline ? F.type.reference instanceof r.StaticSymbol ? M = `${F.type.reference.filePath}.${F.type.reference.name}.html` : M = `${i(f)}/${i(F.type)}.html` : M = P.templateUrl, F.type.reference instanceof r.StaticSymbol ? M : k(M);
            }
            e.templateSourceUrl = $;
            function t3(f, F) {
              let P = f.moduleUrl.split(/\/\\/g), M = P[P.length - 1];
              return k(`css/${F}${M}.ngstyle.js`);
            }
            e.sharedStylesheetJitUrl = t3;
            function o(f) {
              return k(`${i(f.type)}/module.ngfactory.js`);
            }
            e.ngModuleJitUrl = o;
            function E(f, F) {
              return k(`${i(f)}/${i(F.type)}.ngfactory.js`);
            }
            e.templateJitUrl = E;
          } }), ye = I({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = ss(), u = JD(), s = class {
              constructor(a, c, h, C) {
                this.file = a, this.offset = c, this.line = h, this.col = C;
              }
              toString() {
                return this.offset != null ? `${this.file.url}@${this.line}:${this.col}` : this.file.url;
              }
              moveBy(a) {
                let c = this.file.content, h = c.length, C = this.offset, d = this.line, m = this.col;
                for (; C > 0 && a < 0; )
                  if (C--, a++, c.charCodeAt(C) == r.$LF) {
                    d--;
                    let B = c.substr(0, C - 1).lastIndexOf(String.fromCharCode(r.$LF));
                    m = B > 0 ? C - B : C;
                  } else
                    m--;
                for (; C < h && a > 0; ) {
                  let T = c.charCodeAt(C);
                  C++, a--, T == r.$LF ? (d++, m = 0) : m++;
                }
                return new s(this.file, C, d, m);
              }
              getContext(a, c) {
                let h = this.file.content, C = this.offset;
                if (C != null) {
                  C > h.length - 1 && (C = h.length - 1);
                  let d = C, m = 0, T = 0;
                  for (; m < a && C > 0 && (C--, m++, !(h[C] == `
` && ++T == c)); )
                    ;
                  for (m = 0, T = 0; m < a && d < h.length - 1 && (d++, m++, !(h[d] == `
` && ++T == c)); )
                    ;
                  return { before: h.substring(C, this.offset), after: h.substring(this.offset, d + 1) };
                }
                return null;
              }
            };
            e.ParseLocation = s;
            var D = class {
              constructor(a, c) {
                this.content = a, this.url = c;
              }
            };
            e.ParseSourceFile = D;
            var n = class {
              constructor(a, c) {
                let h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                this.start = a, this.end = c, this.details = h;
              }
              toString() {
                return this.start.file.content.substring(this.start.offset, this.end.offset);
              }
            };
            e.ParseSourceSpan = n, e.EMPTY_PARSE_LOCATION = new s(new D("", ""), 0, 0, 0), e.EMPTY_SOURCE_SPAN = new n(e.EMPTY_PARSE_LOCATION, e.EMPTY_PARSE_LOCATION);
            var i;
            (function(a) {
              a[a.WARNING = 0] = "WARNING", a[a.ERROR = 1] = "ERROR";
            })(i = e.ParseErrorLevel || (e.ParseErrorLevel = {}));
            var p = class {
              constructor(a, c) {
                let h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : i.ERROR;
                this.span = a, this.msg = c, this.level = h;
              }
              contextualMessage() {
                let a = this.span.start.getContext(100, 3);
                return a ? `${this.msg} ("${a.before}[${i[this.level]} ->]${a.after}")` : this.msg;
              }
              toString() {
                let a = this.span.details ? `, ${this.span.details}` : "";
                return `${this.contextualMessage()}: ${this.span.start}${a}`;
              }
            };
            e.ParseError = p;
            function l(a, c) {
              let h = u.identifierModuleUrl(c), C = h != null ? `in ${a} ${u.identifierName(c)} in ${h}` : `in ${a} ${u.identifierName(c)}`, d = new D("", C);
              return new n(new s(d, -1, -1, -1), new s(d, -1, -1, -1));
            }
            e.typeSourceSpan = l;
            function g(a, c, h) {
              let C = `in ${a} ${c} in ${h}`, d = new D("", C);
              return new n(new s(d, -1, -1, -1), new s(d, -1, -1, -1));
            }
            e.r3JitTypeSourceSpan = g;
          } }), ZD = I({ "src/utils/front-matter/parse.js"(e, r) {
            "use strict";
            q();
            var u = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
            function s(D) {
              let n = D.match(u);
              if (!n)
                return { content: D };
              let { startDelimiter: i, language: p, value: l = "", endDelimiter: g } = n.groups, a = p.trim() || "yaml";
              if (i === "+++" && (a = "toml"), a !== "yaml" && i !== g)
                return { content: D };
              let [c] = n;
              return { frontMatter: { type: "front-matter", lang: a, value: l, startDelimiter: i, endDelimiter: g, raw: c.replace(/\n$/, "") }, content: c.replace(/[^\n]/g, " ") + D.slice(c.length) };
            }
            r.exports = s;
          } }), is = I({ "src/utils/get-last.js"(e, r) {
            "use strict";
            q();
            var u = (s) => s[s.length - 1];
            r.exports = u;
          } }), el = I({ "src/common/parser-create-error.js"(e, r) {
            "use strict";
            q();
            function u(s, D) {
              let n = new SyntaxError(s + " (" + D.start.line + ":" + D.start.column + ")");
              return n.loc = D, n;
            }
            r.exports = u;
          } }), as = {};
          us(as, { default: () => rl });
          function rl(e) {
            if (typeof e != "string")
              throw new TypeError("Expected a string");
            return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
          }
          var ul = Ee({ "node_modules/escape-string-regexp/index.js"() {
            q();
          } }), os = I({ "node_modules/semver/internal/debug.js"(e, r) {
            q();
            var u = typeof Se == "object" && Se.env && Se.env.NODE_DEBUG && /\bsemver\b/i.test(Se.env.NODE_DEBUG) ? function() {
              for (var s = arguments.length, D = new Array(s), n = 0; n < s; n++)
                D[n] = arguments[n];
              return console.error("SEMVER", ...D);
            } : () => {
            };
            r.exports = u;
          } }), Ds = I({ "node_modules/semver/internal/constants.js"(e, r) {
            q();
            var u = "2.0.0", s = 256, D = Number.MAX_SAFE_INTEGER || 9007199254740991, n = 16;
            r.exports = { SEMVER_SPEC_VERSION: u, MAX_LENGTH: s, MAX_SAFE_INTEGER: D, MAX_SAFE_COMPONENT_LENGTH: n };
          } }), tl = I({ "node_modules/semver/internal/re.js"(e, r) {
            q();
            var { MAX_SAFE_COMPONENT_LENGTH: u } = Ds(), s = os();
            e = r.exports = {};
            var D = e.re = [], n = e.src = [], i = e.t = {}, p = 0, l = (g, a, c) => {
              let h = p++;
              s(g, h, a), i[g] = h, n[h] = a, D[h] = new RegExp(a, c ? "g" : void 0);
            };
            l("NUMERICIDENTIFIER", "0|[1-9]\\d*"), l("NUMERICIDENTIFIERLOOSE", "[0-9]+"), l("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), l("MAINVERSION", `(${n[i.NUMERICIDENTIFIER]})\\.(${n[i.NUMERICIDENTIFIER]})\\.(${n[i.NUMERICIDENTIFIER]})`), l("MAINVERSIONLOOSE", `(${n[i.NUMERICIDENTIFIERLOOSE]})\\.(${n[i.NUMERICIDENTIFIERLOOSE]})\\.(${n[i.NUMERICIDENTIFIERLOOSE]})`), l("PRERELEASEIDENTIFIER", `(?:${n[i.NUMERICIDENTIFIER]}|${n[i.NONNUMERICIDENTIFIER]})`), l("PRERELEASEIDENTIFIERLOOSE", `(?:${n[i.NUMERICIDENTIFIERLOOSE]}|${n[i.NONNUMERICIDENTIFIER]})`), l("PRERELEASE", `(?:-(${n[i.PRERELEASEIDENTIFIER]}(?:\\.${n[i.PRERELEASEIDENTIFIER]})*))`), l("PRERELEASELOOSE", `(?:-?(${n[i.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${n[i.PRERELEASEIDENTIFIERLOOSE]})*))`), l("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), l("BUILD", `(?:\\+(${n[i.BUILDIDENTIFIER]}(?:\\.${n[i.BUILDIDENTIFIER]})*))`), l("FULLPLAIN", `v?${n[i.MAINVERSION]}${n[i.PRERELEASE]}?${n[i.BUILD]}?`), l("FULL", `^${n[i.FULLPLAIN]}$`), l("LOOSEPLAIN", `[v=\\s]*${n[i.MAINVERSIONLOOSE]}${n[i.PRERELEASELOOSE]}?${n[i.BUILD]}?`), l("LOOSE", `^${n[i.LOOSEPLAIN]}$`), l("GTLT", "((?:<|>)?=?)"), l("XRANGEIDENTIFIERLOOSE", `${n[i.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), l("XRANGEIDENTIFIER", `${n[i.NUMERICIDENTIFIER]}|x|X|\\*`), l("XRANGEPLAIN", `[v=\\s]*(${n[i.XRANGEIDENTIFIER]})(?:\\.(${n[i.XRANGEIDENTIFIER]})(?:\\.(${n[i.XRANGEIDENTIFIER]})(?:${n[i.PRERELEASE]})?${n[i.BUILD]}?)?)?`), l("XRANGEPLAINLOOSE", `[v=\\s]*(${n[i.XRANGEIDENTIFIERLOOSE]})(?:\\.(${n[i.XRANGEIDENTIFIERLOOSE]})(?:\\.(${n[i.XRANGEIDENTIFIERLOOSE]})(?:${n[i.PRERELEASELOOSE]})?${n[i.BUILD]}?)?)?`), l("XRANGE", `^${n[i.GTLT]}\\s*${n[i.XRANGEPLAIN]}$`), l("XRANGELOOSE", `^${n[i.GTLT]}\\s*${n[i.XRANGEPLAINLOOSE]}$`), l("COERCE", `(^|[^\\d])(\\d{1,${u}})(?:\\.(\\d{1,${u}}))?(?:\\.(\\d{1,${u}}))?(?:$|[^\\d])`), l("COERCERTL", n[i.COERCE], true), l("LONETILDE", "(?:~>?)"), l("TILDETRIM", `(\\s*)${n[i.LONETILDE]}\\s+`, true), e.tildeTrimReplace = "$1~", l("TILDE", `^${n[i.LONETILDE]}${n[i.XRANGEPLAIN]}$`), l("TILDELOOSE", `^${n[i.LONETILDE]}${n[i.XRANGEPLAINLOOSE]}$`), l("LONECARET", "(?:\\^)"), l("CARETTRIM", `(\\s*)${n[i.LONECARET]}\\s+`, true), e.caretTrimReplace = "$1^", l("CARET", `^${n[i.LONECARET]}${n[i.XRANGEPLAIN]}$`), l("CARETLOOSE", `^${n[i.LONECARET]}${n[i.XRANGEPLAINLOOSE]}$`), l("COMPARATORLOOSE", `^${n[i.GTLT]}\\s*(${n[i.LOOSEPLAIN]})$|^$`), l("COMPARATOR", `^${n[i.GTLT]}\\s*(${n[i.FULLPLAIN]})$|^$`), l("COMPARATORTRIM", `(\\s*)${n[i.GTLT]}\\s*(${n[i.LOOSEPLAIN]}|${n[i.XRANGEPLAIN]})`, true), e.comparatorTrimReplace = "$1$2$3", l("HYPHENRANGE", `^\\s*(${n[i.XRANGEPLAIN]})\\s+-\\s+(${n[i.XRANGEPLAIN]})\\s*$`), l("HYPHENRANGELOOSE", `^\\s*(${n[i.XRANGEPLAINLOOSE]})\\s+-\\s+(${n[i.XRANGEPLAINLOOSE]})\\s*$`), l("STAR", "(<|>)?=?\\s*\\*"), l("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), l("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
          } }), nl = I({ "node_modules/semver/internal/parse-options.js"(e, r) {
            q();
            var u = ["includePrerelease", "loose", "rtl"], s = (D) => D ? typeof D != "object" ? { loose: true } : u.filter((n) => D[n]).reduce((n, i) => (n[i] = true, n), {}) : {};
            r.exports = s;
          } }), sl = I({ "node_modules/semver/internal/identifiers.js"(e, r) {
            q();
            var u = /^[0-9]+$/, s = (n, i) => {
              let p = u.test(n), l = u.test(i);
              return p && l && (n = +n, i = +i), n === i ? 0 : p && !l ? -1 : l && !p ? 1 : n < i ? -1 : 1;
            }, D = (n, i) => s(i, n);
            r.exports = { compareIdentifiers: s, rcompareIdentifiers: D };
          } }), il = I({ "node_modules/semver/classes/semver.js"(e, r) {
            q();
            var u = os(), { MAX_LENGTH: s, MAX_SAFE_INTEGER: D } = Ds(), { re: n, t: i } = tl(), p = nl(), { compareIdentifiers: l } = sl(), g = class {
              constructor(a, c) {
                if (c = p(c), a instanceof g) {
                  if (a.loose === !!c.loose && a.includePrerelease === !!c.includePrerelease)
                    return a;
                  a = a.version;
                } else if (typeof a != "string")
                  throw new TypeError(`Invalid Version: ${a}`);
                if (a.length > s)
                  throw new TypeError(`version is longer than ${s} characters`);
                u("SemVer", a, c), this.options = c, this.loose = !!c.loose, this.includePrerelease = !!c.includePrerelease;
                let h = a.trim().match(c.loose ? n[i.LOOSE] : n[i.FULL]);
                if (!h)
                  throw new TypeError(`Invalid Version: ${a}`);
                if (this.raw = a, this.major = +h[1], this.minor = +h[2], this.patch = +h[3], this.major > D || this.major < 0)
                  throw new TypeError("Invalid major version");
                if (this.minor > D || this.minor < 0)
                  throw new TypeError("Invalid minor version");
                if (this.patch > D || this.patch < 0)
                  throw new TypeError("Invalid patch version");
                h[4] ? this.prerelease = h[4].split(".").map((C) => {
                  if (/^[0-9]+$/.test(C)) {
                    let d = +C;
                    if (d >= 0 && d < D)
                      return d;
                  }
                  return C;
                }) : this.prerelease = [], this.build = h[5] ? h[5].split(".") : [], this.format();
              }
              format() {
                return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
              }
              toString() {
                return this.version;
              }
              compare(a) {
                if (u("SemVer.compare", this.version, this.options, a), !(a instanceof g)) {
                  if (typeof a == "string" && a === this.version)
                    return 0;
                  a = new g(a, this.options);
                }
                return a.version === this.version ? 0 : this.compareMain(a) || this.comparePre(a);
              }
              compareMain(a) {
                return a instanceof g || (a = new g(a, this.options)), l(this.major, a.major) || l(this.minor, a.minor) || l(this.patch, a.patch);
              }
              comparePre(a) {
                if (a instanceof g || (a = new g(a, this.options)), this.prerelease.length && !a.prerelease.length)
                  return -1;
                if (!this.prerelease.length && a.prerelease.length)
                  return 1;
                if (!this.prerelease.length && !a.prerelease.length)
                  return 0;
                let c = 0;
                do {
                  let h = this.prerelease[c], C = a.prerelease[c];
                  if (u("prerelease compare", c, h, C), h === void 0 && C === void 0)
                    return 0;
                  if (C === void 0)
                    return 1;
                  if (h === void 0)
                    return -1;
                  if (h === C)
                    continue;
                  return l(h, C);
                } while (++c);
              }
              compareBuild(a) {
                a instanceof g || (a = new g(a, this.options));
                let c = 0;
                do {
                  let h = this.build[c], C = a.build[c];
                  if (u("prerelease compare", c, h, C), h === void 0 && C === void 0)
                    return 0;
                  if (C === void 0)
                    return 1;
                  if (h === void 0)
                    return -1;
                  if (h === C)
                    continue;
                  return l(h, C);
                } while (++c);
              }
              inc(a, c) {
                switch (a) {
                  case "premajor":
                    this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", c);
                    break;
                  case "preminor":
                    this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", c);
                    break;
                  case "prepatch":
                    this.prerelease.length = 0, this.inc("patch", c), this.inc("pre", c);
                    break;
                  case "prerelease":
                    this.prerelease.length === 0 && this.inc("patch", c), this.inc("pre", c);
                    break;
                  case "major":
                    (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                    break;
                  case "minor":
                    (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                    break;
                  case "patch":
                    this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                    break;
                  case "pre":
                    if (this.prerelease.length === 0)
                      this.prerelease = [0];
                    else {
                      let h = this.prerelease.length;
                      for (; --h >= 0; )
                        typeof this.prerelease[h] == "number" && (this.prerelease[h]++, h = -2);
                      h === -1 && this.prerelease.push(0);
                    }
                    c && (l(this.prerelease[0], c) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [c, 0]) : this.prerelease = [c, 0]);
                    break;
                  default:
                    throw new Error(`invalid increment argument: ${a}`);
                }
                return this.format(), this.raw = this.version, this;
              }
            };
            r.exports = g;
          } }), jr = I({ "node_modules/semver/functions/compare.js"(e, r) {
            q();
            var u = il(), s = (D, n, i) => new u(D, i).compare(new u(n, i));
            r.exports = s;
          } }), al = I({ "node_modules/semver/functions/lt.js"(e, r) {
            q();
            var u = jr(), s = (D, n, i) => u(D, n, i) < 0;
            r.exports = s;
          } }), ol = I({ "node_modules/semver/functions/gte.js"(e, r) {
            q();
            var u = jr(), s = (D, n, i) => u(D, n, i) >= 0;
            r.exports = s;
          } }), Dl = I({ "src/utils/arrayify.js"(e, r) {
            "use strict";
            q(), r.exports = (u, s) => Object.entries(u).map((D) => {
              let [n, i] = D;
              return Object.assign({ [s]: n }, i);
            });
          } }), ll = I({ "package.json"(e, r) {
            r.exports = { version: "2.8.0" };
          } }), cl = I({ "node_modules/outdent/lib/index.js"(e, r) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true }), e.outdent = void 0;
            function u() {
              for (var A = [], N = 0; N < arguments.length; N++)
                A[N] = arguments[N];
            }
            function s() {
              return typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : D();
            }
            function D() {
              return { add: u, delete: u, get: u, set: u, has: function(A) {
                return false;
              } };
            }
            var n = Object.prototype.hasOwnProperty, i = function(A, N) {
              return n.call(A, N);
            };
            function p(A, N) {
              for (var R in N)
                i(N, R) && (A[R] = N[R]);
              return A;
            }
            var l = /^[ \t]*(?:\r\n|\r|\n)/, g = /(?:\r\n|\r|\n)[ \t]*$/, a = /^(?:[\r\n]|$)/, c = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, h = /^[ \t]*[\r\n][ \t\r\n]*$/;
            function C(A, N, R) {
              var j = 0, _ = A[0].match(c);
              _ && (j = _[1].length);
              var O = "(\\r\\n|\\r|\\n).{0," + j + "}", x = new RegExp(O, "g");
              N && (A = A.slice(1));
              var k = R.newline, $ = R.trimLeadingNewline, t3 = R.trimTrailingNewline, o = typeof k == "string", E = A.length, f = A.map(function(F, P) {
                return F = F.replace(x, "$1"), P === 0 && $ && (F = F.replace(l, "")), P === E - 1 && t3 && (F = F.replace(g, "")), o && (F = F.replace(/\r\n|\n|\r/g, function(M) {
                  return k;
                })), F;
              });
              return f;
            }
            function d(A, N) {
              for (var R = "", j = 0, _ = A.length; j < _; j++)
                R += A[j], j < _ - 1 && (R += N[j]);
              return R;
            }
            function m(A) {
              return i(A, "raw") && i(A, "length");
            }
            function T(A) {
              var N = s(), R = s();
              function j(O) {
                for (var x = [], k = 1; k < arguments.length; k++)
                  x[k - 1] = arguments[k];
                if (m(O)) {
                  var $ = O, t3 = (x[0] === j || x[0] === B) && h.test($[0]) && a.test($[1]), o = t3 ? R : N, E = o.get($);
                  if (E || (E = C($, t3, A), o.set($, E)), x.length === 0)
                    return E[0];
                  var f = d(E, t3 ? x.slice(1) : x);
                  return f;
                } else
                  return T(p(p({}, A), O || {}));
              }
              var _ = p(j, { string: function(O) {
                return C([O], false, A)[0];
              } });
              return _;
            }
            var B = T({ trimLeadingNewline: true, trimTrailingNewline: true });
            if (e.outdent = B, e.default = B, typeof r < "u")
              try {
                r.exports = B, Object.defineProperty(B, "__esModule", { value: true }), B.default = B, B.outdent = B;
              } catch {
              }
          } }), hl = I({ "src/main/core-options.js"(e, r) {
            "use strict";
            q();
            var { outdent: u } = cl(), s = "Config", D = "Editor", n = "Format", i = "Other", p = "Output", l = "Global", g = "Special", a = { cursorOffset: { since: "1.4.0", category: g, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: u`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `, cliCategory: D }, endOfLine: { since: "1.15.0", category: l, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: u`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        ` }] }, filepath: { since: "1.4.0", category: g, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: i, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: g, type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: i }, parser: { since: "0.0.10", category: l, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (c) => typeof c == "string" || typeof c == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: true, default: [{ value: [] }], category: l, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (c) => typeof c == "string" || typeof c == "object", cliName: "plugin", cliCategory: s }, pluginSearchDirs: { since: "1.13.0", type: "path", array: true, default: [{ value: [] }], category: l, description: u`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `, exception: (c) => typeof c == "string" || typeof c == "object", cliName: "plugin-search-dir", cliCategory: s }, printWidth: { since: "0.0.0", category: l, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: g, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: u`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: D }, rangeStart: { since: "1.4.0", category: g, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: u`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: D }, requirePragma: { since: "1.7.0", category: g, type: "boolean", default: false, description: u`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `, cliCategory: i }, tabWidth: { type: "int", category: l, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: l, type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: l, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
            r.exports = { CATEGORY_CONFIG: s, CATEGORY_EDITOR: D, CATEGORY_FORMAT: n, CATEGORY_OTHER: i, CATEGORY_OUTPUT: p, CATEGORY_GLOBAL: l, CATEGORY_SPECIAL: g, options: a };
          } }), pl = I({ "src/main/support.js"(e, r) {
            "use strict";
            q();
            var u = { compare: jr(), lt: al(), gte: ol() }, s = Dl(), D = ll().version, n = hl().options;
            function i() {
              let { plugins: l = [], showUnreleased: g = false, showDeprecated: a = false, showInternal: c = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h = D.split("-", 1)[0], C = l.flatMap((A) => A.languages || []).filter(m), d = s(Object.assign({}, ...l.map((A) => {
                let { options: N } = A;
                return N;
              }), n), "name").filter((A) => m(A) && T(A)).sort((A, N) => A.name === N.name ? 0 : A.name < N.name ? -1 : 1).map(B).map((A) => {
                A = Object.assign({}, A), Array.isArray(A.default) && (A.default = A.default.length === 1 ? A.default[0].value : A.default.filter(m).sort((R, j) => u.compare(j.since, R.since))[0].value), Array.isArray(A.choices) && (A.choices = A.choices.filter((R) => m(R) && T(R)), A.name === "parser" && p(A, C, l));
                let N = Object.fromEntries(l.filter((R) => R.defaultOptions && R.defaultOptions[A.name] !== void 0).map((R) => [R.name, R.defaultOptions[A.name]]));
                return Object.assign(Object.assign({}, A), {}, { pluginDefaults: N });
              });
              return { languages: C, options: d };
              function m(A) {
                return g || !("since" in A) || A.since && u.gte(h, A.since);
              }
              function T(A) {
                return a || !("deprecated" in A) || A.deprecated && u.lt(h, A.deprecated);
              }
              function B(A) {
                if (c)
                  return A;
                let { cliName: N, cliCategory: R, cliDescription: j } = A;
                return GD(A, UD);
              }
            }
            function p(l, g, a) {
              let c = new Set(l.choices.map((h) => h.value));
              for (let h of g)
                if (h.parsers) {
                  for (let C of h.parsers)
                    if (!c.has(C)) {
                      c.add(C);
                      let d = a.find((T) => T.parsers && T.parsers[C]), m = h.name;
                      d && d.name && (m += ` (plugin: ${d.name})`), l.choices.push({ value: C, description: m });
                    }
                }
            }
            r.exports = { getSupportInfo: i };
          } }), fl = I({ "src/utils/is-non-empty-array.js"(e, r) {
            "use strict";
            q();
            function u(s) {
              return Array.isArray(s) && s.length > 0;
            }
            r.exports = u;
          } });
          function dl() {
            let { onlyFirst: e = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
            return new RegExp(r, e ? void 0 : "g");
          }
          var El = Ee({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
            q();
          } });
          function Cl(e) {
            if (typeof e != "string")
              throw new TypeError(`Expected a \`string\`, got \`${typeof e}\``);
            return e.replace(dl(), "");
          }
          var ml = Ee({ "node_modules/strip-ansi/index.js"() {
            q(), El();
          } });
          function gl(e) {
            return Number.isInteger(e) ? e >= 4352 && (e <= 4447 || e === 9001 || e === 9002 || 11904 <= e && e <= 12871 && e !== 12351 || 12880 <= e && e <= 19903 || 19968 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510 || 110592 <= e && e <= 110593 || 127488 <= e && e <= 127569 || 131072 <= e && e <= 262141) : false;
          }
          var Fl = Ee({ "node_modules/is-fullwidth-code-point/index.js"() {
            q();
          } }), Al = I({ "node_modules/emoji-regex/index.js"(e, r) {
            "use strict";
            q(), r.exports = function() {
              return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
            };
          } }), ls = {};
          us(ls, { default: () => vl });
          function vl(e) {
            if (typeof e != "string" || e.length === 0 || (e = Cl(e), e.length === 0))
              return 0;
            e = e.replace((0, cs.default)(), "  ");
            let r = 0;
            for (let u = 0; u < e.length; u++) {
              let s = e.codePointAt(u);
              s <= 31 || s >= 127 && s <= 159 || s >= 768 && s <= 879 || (s > 65535 && u++, r += gl(s) ? 2 : 1);
            }
            return r;
          }
          var cs, _l = Ee({ "node_modules/string-width/index.js"() {
            q(), ml(), Fl(), cs = YD(Al());
          } }), Sl = I({ "src/utils/get-string-width.js"(e, r) {
            "use strict";
            q();
            var u = (_l(), ns(ls)).default, s = /[^\x20-\x7F]/;
            function D(n) {
              return n ? s.test(n) ? u(n) : n.length : 0;
            }
            r.exports = D;
          } }), Ur = I({ "src/utils/text/skip.js"(e, r) {
            "use strict";
            q();
            function u(p) {
              return (l, g, a) => {
                let c = a && a.backwards;
                if (g === false)
                  return false;
                let { length: h } = l, C = g;
                for (; C >= 0 && C < h; ) {
                  let d = l.charAt(C);
                  if (p instanceof RegExp) {
                    if (!p.test(d))
                      return C;
                  } else if (!p.includes(d))
                    return C;
                  c ? C-- : C++;
                }
                return C === -1 || C === h ? C : false;
              };
            }
            var s = u(/\s/), D = u(" 	"), n = u(",; 	"), i = u(/[^\n\r]/);
            r.exports = { skipWhitespace: s, skipSpaces: D, skipToLineEnd: n, skipEverythingButNewLine: i };
          } }), hs = I({ "src/utils/text/skip-inline-comment.js"(e, r) {
            "use strict";
            q();
            function u(s, D) {
              if (D === false)
                return false;
              if (s.charAt(D) === "/" && s.charAt(D + 1) === "*") {
                for (let n = D + 2; n < s.length; ++n)
                  if (s.charAt(n) === "*" && s.charAt(n + 1) === "/")
                    return n + 2;
              }
              return D;
            }
            r.exports = u;
          } }), ps = I({ "src/utils/text/skip-trailing-comment.js"(e, r) {
            "use strict";
            q();
            var { skipEverythingButNewLine: u } = Ur();
            function s(D, n) {
              return n === false ? false : D.charAt(n) === "/" && D.charAt(n + 1) === "/" ? u(D, n) : n;
            }
            r.exports = s;
          } }), fs = I({ "src/utils/text/skip-newline.js"(e, r) {
            "use strict";
            q();
            function u(s, D, n) {
              let i = n && n.backwards;
              if (D === false)
                return false;
              let p = s.charAt(D);
              if (i) {
                if (s.charAt(D - 1) === "\r" && p === `
`)
                  return D - 2;
                if (p === `
` || p === "\r" || p === "\u2028" || p === "\u2029")
                  return D - 1;
              } else {
                if (p === "\r" && s.charAt(D + 1) === `
`)
                  return D + 2;
                if (p === `
` || p === "\r" || p === "\u2028" || p === "\u2029")
                  return D + 1;
              }
              return D;
            }
            r.exports = u;
          } }), yl = I({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(e, r) {
            "use strict";
            q();
            var u = hs(), s = fs(), D = ps(), { skipSpaces: n } = Ur();
            function i(p, l) {
              let g = null, a = l;
              for (; a !== g; )
                g = a, a = n(p, a), a = u(p, a), a = D(p, a), a = s(p, a);
              return a;
            }
            r.exports = i;
          } }), Tl = I({ "src/common/util.js"(e, r) {
            "use strict";
            q();
            var { default: u } = (ul(), ns(as)), s = is(), { getSupportInfo: D } = pl(), n = fl(), i = Sl(), { skipWhitespace: p, skipSpaces: l, skipToLineEnd: g, skipEverythingButNewLine: a } = Ur(), c = hs(), h = ps(), C = fs(), d = yl(), m = (v) => v[v.length - 2];
            function T(v) {
              return (S, b, w) => {
                let L = w && w.backwards;
                if (b === false)
                  return false;
                let { length: U } = S, V = b;
                for (; V >= 0 && V < U; ) {
                  let Y = S.charAt(V);
                  if (v instanceof RegExp) {
                    if (!v.test(Y))
                      return V;
                  } else if (!v.includes(Y))
                    return V;
                  L ? V-- : V++;
                }
                return V === -1 || V === U ? V : false;
              };
            }
            function B(v, S) {
              let b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, w = l(v, b.backwards ? S - 1 : S, b), L = C(v, w, b);
              return w !== L;
            }
            function A(v, S, b) {
              for (let w = S; w < b; ++w)
                if (v.charAt(w) === `
`)
                  return true;
              return false;
            }
            function N(v, S, b) {
              let w = b(S) - 1;
              w = l(v, w, { backwards: true }), w = C(v, w, { backwards: true }), w = l(v, w, { backwards: true });
              let L = C(v, w, { backwards: true });
              return w !== L;
            }
            function R(v, S) {
              let b = null, w = S;
              for (; w !== b; )
                b = w, w = g(v, w), w = c(v, w), w = l(v, w);
              return w = h(v, w), w = C(v, w), w !== false && B(v, w);
            }
            function j(v, S, b) {
              return R(v, b(S));
            }
            function _(v, S, b) {
              return d(v, b(S));
            }
            function O(v, S, b) {
              return v.charAt(_(v, S, b));
            }
            function x(v, S) {
              let b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              return l(v, b.backwards ? S - 1 : S, b) !== S;
            }
            function k(v, S) {
              let b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, w = 0;
              for (let L = b; L < v.length; ++L)
                v[L] === "	" ? w = w + S - w % S : w++;
              return w;
            }
            function $(v, S) {
              let b = v.lastIndexOf(`
`);
              return b === -1 ? 0 : k(v.slice(b + 1).match(/^[\t ]*/)[0], S);
            }
            function t3(v, S) {
              let b = { quote: '"', regex: /"/g, escaped: "&quot;" }, w = { quote: "'", regex: /'/g, escaped: "&apos;" }, L = S === "'" ? w : b, U = L === w ? b : w, V = L;
              if (v.includes(L.quote) || v.includes(U.quote)) {
                let Y = (v.match(L.regex) || []).length, te = (v.match(U.regex) || []).length;
                V = Y > te ? U : L;
              }
              return V;
            }
            function o(v, S) {
              let b = v.slice(1, -1), w = S.parser === "json" || S.parser === "json5" && S.quoteProps === "preserve" && !S.singleQuote ? '"' : S.__isInHtmlAttribute ? "'" : t3(b, S.singleQuote ? "'" : '"').quote;
              return E(b, w, !(S.parser === "css" || S.parser === "less" || S.parser === "scss" || S.__embeddedInHtml));
            }
            function E(v, S, b) {
              let w = S === '"' ? "'" : '"', L = /\\(.)|(["'])/gs, U = v.replace(L, (V, Y, te) => Y === w ? Y : te === S ? "\\" + te : te || (b && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(Y) ? Y : "\\" + Y));
              return S + U + S;
            }
            function f(v) {
              return v.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
            }
            function F(v, S) {
              let b = v.match(new RegExp(`(${u(S)})+`, "g"));
              return b === null ? 0 : b.reduce((w, L) => Math.max(w, L.length / S.length), 0);
            }
            function P(v, S) {
              let b = v.match(new RegExp(`(${u(S)})+`, "g"));
              if (b === null)
                return 0;
              let w = /* @__PURE__ */ new Map(), L = 0;
              for (let U of b) {
                let V = U.length / S.length;
                w.set(V, true), V > L && (L = V);
              }
              for (let U = 1; U < L; U++)
                if (!w.get(U))
                  return U;
              return L + 1;
            }
            function M(v, S) {
              (v.comments || (v.comments = [])).push(S), S.printed = false, S.nodeDescription = ee(v);
            }
            function W(v, S) {
              S.leading = true, S.trailing = false, M(v, S);
            }
            function X(v, S, b) {
              S.leading = false, S.trailing = false, b && (S.marker = b), M(v, S);
            }
            function H(v, S) {
              S.leading = false, S.trailing = true, M(v, S);
            }
            function z(v, S) {
              let { languages: b } = D({ plugins: S.plugins }), w = b.find((L) => {
                let { name: U } = L;
                return U.toLowerCase() === v;
              }) || b.find((L) => {
                let { aliases: U } = L;
                return Array.isArray(U) && U.includes(v);
              }) || b.find((L) => {
                let { extensions: U } = L;
                return Array.isArray(U) && U.includes(`.${v}`);
              });
              return w && w.parsers[0];
            }
            function J(v) {
              return v && v.type === "front-matter";
            }
            function Z(v) {
              let S = /* @__PURE__ */ new WeakMap();
              return function(b) {
                return S.has(b) || S.set(b, Symbol(v)), S.get(b);
              };
            }
            function ee(v) {
              let S = v.type || v.kind || "(unknown type)", b = String(v.name || v.id && (typeof v.id == "object" ? v.id.name : v.id) || v.key && (typeof v.key == "object" ? v.key.name : v.key) || v.value && (typeof v.value == "object" ? "" : String(v.value)) || v.operator || "");
              return b.length > 20 && (b = b.slice(0, 19) + "\u2026"), S + (b ? " " + b : "");
            }
            r.exports = { inferParserByLanguage: z, getStringWidth: i, getMaxContinuousCount: F, getMinNotPresentContinuousCount: P, getPenultimate: m, getLast: s, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: d, getNextNonSpaceNonCommentCharacterIndex: _, getNextNonSpaceNonCommentCharacter: O, skip: T, skipWhitespace: p, skipSpaces: l, skipToLineEnd: g, skipEverythingButNewLine: a, skipInlineComment: c, skipTrailingComment: h, skipNewline: C, isNextLineEmptyAfterIndex: R, isNextLineEmpty: j, isPreviousLineEmpty: N, hasNewline: B, hasNewlineInRange: A, hasSpaces: x, getAlignmentSize: k, getIndentSize: $, getPreferredQuote: t3, printString: o, printNumber: f, makeString: E, addLeadingComment: W, addDanglingComment: X, addTrailingComment: H, isFrontMatterNode: J, isNonEmptyArray: n, createGroupIdMapper: Z };
          } }), Bl = I({ "vendors/html-tag-names.json"(e, r) {
            r.exports = { htmlTagNames: ["a", "abbr", "acronym", "address", "applet", "area", "article", "aside", "audio", "b", "base", "basefont", "bdi", "bdo", "bgsound", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "command", "content", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "embed", "fieldset", "figcaption", "figure", "font", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "image", "img", "input", "ins", "isindex", "kbd", "keygen", "label", "legend", "li", "link", "listing", "main", "map", "mark", "marquee", "math", "menu", "menuitem", "meta", "meter", "multicol", "nav", "nextid", "nobr", "noembed", "noframes", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "plaintext", "pre", "progress", "q", "rb", "rbc", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "tt", "u", "ul", "var", "video", "wbr", "xmp"] };
          } }), ds = I({ "src/language-html/utils/array-to-map.js"(e, r) {
            "use strict";
            q();
            function u(s) {
              let D = /* @__PURE__ */ Object.create(null);
              for (let n of s)
                D[n] = true;
              return D;
            }
            r.exports = u;
          } }), bl = I({ "src/language-html/utils/html-tag-names.js"(e, r) {
            "use strict";
            q();
            var { htmlTagNames: u } = Bl(), s = ds(), D = s(u);
            r.exports = D;
          } }), wl = I({ "vendors/html-element-attributes.json"(e, r) {
            r.exports = { htmlElementAttributes: { "*": ["accesskey", "autocapitalize", "autofocus", "class", "contenteditable", "dir", "draggable", "enterkeyhint", "hidden", "id", "inputmode", "is", "itemid", "itemprop", "itemref", "itemscope", "itemtype", "lang", "nonce", "slot", "spellcheck", "style", "tabindex", "title", "translate"], a: ["charset", "coords", "download", "href", "hreflang", "name", "ping", "referrerpolicy", "rel", "rev", "shape", "target", "type"], applet: ["align", "alt", "archive", "code", "codebase", "height", "hspace", "name", "object", "vspace", "width"], area: ["alt", "coords", "download", "href", "hreflang", "nohref", "ping", "referrerpolicy", "rel", "shape", "target", "type"], audio: ["autoplay", "controls", "crossorigin", "loop", "muted", "preload", "src"], base: ["href", "target"], basefont: ["color", "face", "size"], blockquote: ["cite"], body: ["alink", "background", "bgcolor", "link", "text", "vlink"], br: ["clear"], button: ["disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "name", "type", "value"], canvas: ["height", "width"], caption: ["align"], col: ["align", "char", "charoff", "span", "valign", "width"], colgroup: ["align", "char", "charoff", "span", "valign", "width"], data: ["value"], del: ["cite", "datetime"], details: ["open"], dialog: ["open"], dir: ["compact"], div: ["align"], dl: ["compact"], embed: ["height", "src", "type", "width"], fieldset: ["disabled", "form", "name"], font: ["color", "face", "size"], form: ["accept", "accept-charset", "action", "autocomplete", "enctype", "method", "name", "novalidate", "target"], frame: ["frameborder", "longdesc", "marginheight", "marginwidth", "name", "noresize", "scrolling", "src"], frameset: ["cols", "rows"], h1: ["align"], h2: ["align"], h3: ["align"], h4: ["align"], h5: ["align"], h6: ["align"], head: ["profile"], hr: ["align", "noshade", "size", "width"], html: ["manifest", "version"], iframe: ["align", "allow", "allowfullscreen", "allowpaymentrequest", "allowusermedia", "frameborder", "height", "loading", "longdesc", "marginheight", "marginwidth", "name", "referrerpolicy", "sandbox", "scrolling", "src", "srcdoc", "width"], img: ["align", "alt", "border", "crossorigin", "decoding", "height", "hspace", "ismap", "loading", "longdesc", "name", "referrerpolicy", "sizes", "src", "srcset", "usemap", "vspace", "width"], input: ["accept", "align", "alt", "autocomplete", "checked", "dirname", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "height", "ismap", "list", "max", "maxlength", "min", "minlength", "multiple", "name", "pattern", "placeholder", "readonly", "required", "size", "src", "step", "type", "usemap", "value", "width"], ins: ["cite", "datetime"], isindex: ["prompt"], label: ["for", "form"], legend: ["align"], li: ["type", "value"], link: ["as", "charset", "color", "crossorigin", "disabled", "href", "hreflang", "imagesizes", "imagesrcset", "integrity", "media", "referrerpolicy", "rel", "rev", "sizes", "target", "type"], map: ["name"], menu: ["compact"], meta: ["charset", "content", "http-equiv", "media", "name", "scheme"], meter: ["high", "low", "max", "min", "optimum", "value"], object: ["align", "archive", "border", "classid", "codebase", "codetype", "data", "declare", "form", "height", "hspace", "name", "standby", "type", "typemustmatch", "usemap", "vspace", "width"], ol: ["compact", "reversed", "start", "type"], optgroup: ["disabled", "label"], option: ["disabled", "label", "selected", "value"], output: ["for", "form", "name"], p: ["align"], param: ["name", "type", "value", "valuetype"], pre: ["width"], progress: ["max", "value"], q: ["cite"], script: ["async", "charset", "crossorigin", "defer", "integrity", "language", "nomodule", "referrerpolicy", "src", "type"], select: ["autocomplete", "disabled", "form", "multiple", "name", "required", "size"], slot: ["name"], source: ["height", "media", "sizes", "src", "srcset", "type", "width"], style: ["media", "type"], table: ["align", "bgcolor", "border", "cellpadding", "cellspacing", "frame", "rules", "summary", "width"], tbody: ["align", "char", "charoff", "valign"], td: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], textarea: ["autocomplete", "cols", "dirname", "disabled", "form", "maxlength", "minlength", "name", "placeholder", "readonly", "required", "rows", "wrap"], tfoot: ["align", "char", "charoff", "valign"], th: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], thead: ["align", "char", "charoff", "valign"], time: ["datetime"], tr: ["align", "bgcolor", "char", "charoff", "valign"], track: ["default", "kind", "label", "src", "srclang"], ul: ["compact", "type"], video: ["autoplay", "controls", "crossorigin", "height", "loop", "muted", "playsinline", "poster", "preload", "src", "width"] } };
          } }), Nl = I({ "src/language-html/utils/map-object.js"(e, r) {
            "use strict";
            q();
            function u(s, D) {
              let n = /* @__PURE__ */ Object.create(null);
              for (let [i, p] of Object.entries(s))
                n[i] = D(p, i);
              return n;
            }
            r.exports = u;
          } }), Ol = I({ "src/language-html/utils/html-elements-attributes.js"(e, r) {
            "use strict";
            q();
            var { htmlElementAttributes: u } = wl(), s = Nl(), D = ds(), n = s(u, D);
            r.exports = n;
          } }), ql = I({ "src/language-html/utils/is-unknown-namespace.js"(e, r) {
            "use strict";
            q();
            function u(s) {
              return s.type === "element" && !s.hasExplicitNamespace && !["html", "svg"].includes(s.namespace);
            }
            r.exports = u;
          } }), Il = I({ "src/language-html/pragma.js"(e, r) {
            "use strict";
            q();
            function u(D) {
              return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(D);
            }
            function s(D) {
              return `<!-- @format -->

` + D.replace(/^\s*\n/, "");
            }
            r.exports = { hasPragma: u, insertPragma: s };
          } }), Rl = I({ "src/language-html/ast.js"(e, r) {
            "use strict";
            q();
            var u = { attrs: true, children: true }, s = /* @__PURE__ */ new Set(["parent"]), D = class {
              constructor() {
                let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                for (let p of /* @__PURE__ */ new Set([...s, ...Object.keys(i)]))
                  this.setProperty(p, i[p]);
              }
              setProperty(i, p) {
                if (this[i] !== p) {
                  if (i in u && (p = p.map((l) => this.createChild(l))), !s.has(i)) {
                    this[i] = p;
                    return;
                  }
                  Object.defineProperty(this, i, { value: p, enumerable: false, configurable: true });
                }
              }
              map(i) {
                let p;
                for (let l in u) {
                  let g = this[l];
                  if (g) {
                    let a = n(g, (c) => c.map(i));
                    p !== g && (p || (p = new D({ parent: this.parent })), p.setProperty(l, a));
                  }
                }
                if (p)
                  for (let l in this)
                    l in u || (p[l] = this[l]);
                return i(p || this);
              }
              walk(i) {
                for (let p in u) {
                  let l = this[p];
                  if (l)
                    for (let g = 0; g < l.length; g++)
                      l[g].walk(i);
                }
                i(this);
              }
              createChild(i) {
                let p = i instanceof D ? i.clone() : new D(i);
                return p.setProperty("parent", this), p;
              }
              insertChildBefore(i, p) {
                this.children.splice(this.children.indexOf(i), 0, this.createChild(p));
              }
              removeChild(i) {
                this.children.splice(this.children.indexOf(i), 1);
              }
              replaceChild(i, p) {
                this.children[this.children.indexOf(i)] = this.createChild(p);
              }
              clone() {
                return new D(this);
              }
              get firstChild() {
                var i;
                return (i = this.children) === null || i === void 0 ? void 0 : i[0];
              }
              get lastChild() {
                var i;
                return (i = this.children) === null || i === void 0 ? void 0 : i[this.children.length - 1];
              }
              get prev() {
                var i;
                return (i = this.parent) === null || i === void 0 ? void 0 : i.children[this.parent.children.indexOf(this) - 1];
              }
              get next() {
                var i;
                return (i = this.parent) === null || i === void 0 ? void 0 : i.children[this.parent.children.indexOf(this) + 1];
              }
              get rawName() {
                return this.hasExplicitNamespace ? this.fullName : this.name;
              }
              get fullName() {
                return this.namespace ? this.namespace + ":" + this.name : this.name;
              }
              get attrMap() {
                return Object.fromEntries(this.attrs.map((i) => [i.fullName, i.value]));
              }
            };
            function n(i, p) {
              let l = i.map(p);
              return l.some((g, a) => g !== i[a]) ? l : i;
            }
            r.exports = { Node: D };
          } }), xl = I({ "src/language-html/conditional-comment.js"(e, r) {
            "use strict";
            q();
            var { ParseSourceSpan: u } = ye(), s = [{ regex: /^(\[if([^\]]*)]>)(.*?)<!\s*\[endif]$/s, parse: n }, { regex: /^\[if([^\]]*)]><!$/, parse: i }, { regex: /^<!\s*\[endif]$/, parse: p }];
            function D(l, g) {
              if (l.value)
                for (let { regex: a, parse: c } of s) {
                  let h = l.value.match(a);
                  if (h)
                    return c(l, g, h);
                }
              return null;
            }
            function n(l, g, a) {
              let [, c, h, C] = a, d = 4 + c.length, m = l.sourceSpan.start.moveBy(d), T = m.moveBy(C.length), [B, A] = (() => {
                try {
                  return [true, g(C, m).children];
                } catch {
                  let N = { type: "text", value: C, sourceSpan: new u(m, T) };
                  return [false, [N]];
                }
              })();
              return { type: "ieConditionalComment", complete: B, children: A, condition: h.trim().replace(/\s+/g, " "), sourceSpan: l.sourceSpan, startSourceSpan: new u(l.sourceSpan.start, m), endSourceSpan: new u(T, l.sourceSpan.end) };
            }
            function i(l, g, a) {
              let [, c] = a;
              return { type: "ieConditionalStartComment", condition: c.trim().replace(/\s+/g, " "), sourceSpan: l.sourceSpan };
            }
            function p(l) {
              return { type: "ieConditionalEndComment", sourceSpan: l.sourceSpan };
            }
            r.exports = { parseIeConditionalComment: D };
          } }), Pl = I({ "src/language-html/loc.js"(e, r) {
            "use strict";
            q();
            function u(D) {
              return D.sourceSpan.start.offset;
            }
            function s(D) {
              return D.sourceSpan.end.offset;
            }
            r.exports = { locStart: u, locEnd: s };
          } }), Je = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/tags.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r;
            (function(l) {
              l[l.RAW_TEXT = 0] = "RAW_TEXT", l[l.ESCAPABLE_RAW_TEXT = 1] = "ESCAPABLE_RAW_TEXT", l[l.PARSABLE_DATA = 2] = "PARSABLE_DATA";
            })(r = e.TagContentType || (e.TagContentType = {}));
            function u(l) {
              if (l[0] != ":")
                return [null, l];
              let g = l.indexOf(":", 1);
              if (g == -1)
                throw new Error(`Unsupported format "${l}" expecting ":namespace:name"`);
              return [l.slice(1, g), l.slice(g + 1)];
            }
            e.splitNsName = u;
            function s(l) {
              return u(l)[1] === "ng-container";
            }
            e.isNgContainer = s;
            function D(l) {
              return u(l)[1] === "ng-content";
            }
            e.isNgContent = D;
            function n(l) {
              return u(l)[1] === "ng-template";
            }
            e.isNgTemplate = n;
            function i(l) {
              return l === null ? null : u(l)[0];
            }
            e.getNsPrefix = i;
            function p(l, g) {
              return l ? `:${l}:${g}` : g;
            }
            e.mergeNsAndName = p, e.NAMED_ENTITIES = { Aacute: "\xC1", aacute: "\xE1", Abreve: "\u0102", abreve: "\u0103", ac: "\u223E", acd: "\u223F", acE: "\u223E\u0333", Acirc: "\xC2", acirc: "\xE2", acute: "\xB4", Acy: "\u0410", acy: "\u0430", AElig: "\xC6", aelig: "\xE6", af: "\u2061", Afr: "\u{1D504}", afr: "\u{1D51E}", Agrave: "\xC0", agrave: "\xE0", alefsym: "\u2135", aleph: "\u2135", Alpha: "\u0391", alpha: "\u03B1", Amacr: "\u0100", amacr: "\u0101", amalg: "\u2A3F", AMP: "&", amp: "&", And: "\u2A53", and: "\u2227", andand: "\u2A55", andd: "\u2A5C", andslope: "\u2A58", andv: "\u2A5A", ang: "\u2220", ange: "\u29A4", angle: "\u2220", angmsd: "\u2221", angmsdaa: "\u29A8", angmsdab: "\u29A9", angmsdac: "\u29AA", angmsdad: "\u29AB", angmsdae: "\u29AC", angmsdaf: "\u29AD", angmsdag: "\u29AE", angmsdah: "\u29AF", angrt: "\u221F", angrtvb: "\u22BE", angrtvbd: "\u299D", angsph: "\u2222", angst: "\xC5", angzarr: "\u237C", Aogon: "\u0104", aogon: "\u0105", Aopf: "\u{1D538}", aopf: "\u{1D552}", ap: "\u2248", apacir: "\u2A6F", apE: "\u2A70", ape: "\u224A", apid: "\u224B", apos: "'", ApplyFunction: "\u2061", approx: "\u2248", approxeq: "\u224A", Aring: "\xC5", aring: "\xE5", Ascr: "\u{1D49C}", ascr: "\u{1D4B6}", Assign: "\u2254", ast: "*", asymp: "\u2248", asympeq: "\u224D", Atilde: "\xC3", atilde: "\xE3", Auml: "\xC4", auml: "\xE4", awconint: "\u2233", awint: "\u2A11", backcong: "\u224C", backepsilon: "\u03F6", backprime: "\u2035", backsim: "\u223D", backsimeq: "\u22CD", Backslash: "\u2216", Barv: "\u2AE7", barvee: "\u22BD", Barwed: "\u2306", barwed: "\u2305", barwedge: "\u2305", bbrk: "\u23B5", bbrktbrk: "\u23B6", bcong: "\u224C", Bcy: "\u0411", bcy: "\u0431", bdquo: "\u201E", becaus: "\u2235", Because: "\u2235", because: "\u2235", bemptyv: "\u29B0", bepsi: "\u03F6", bernou: "\u212C", Bernoullis: "\u212C", Beta: "\u0392", beta: "\u03B2", beth: "\u2136", between: "\u226C", Bfr: "\u{1D505}", bfr: "\u{1D51F}", bigcap: "\u22C2", bigcirc: "\u25EF", bigcup: "\u22C3", bigodot: "\u2A00", bigoplus: "\u2A01", bigotimes: "\u2A02", bigsqcup: "\u2A06", bigstar: "\u2605", bigtriangledown: "\u25BD", bigtriangleup: "\u25B3", biguplus: "\u2A04", bigvee: "\u22C1", bigwedge: "\u22C0", bkarow: "\u290D", blacklozenge: "\u29EB", blacksquare: "\u25AA", blacktriangle: "\u25B4", blacktriangledown: "\u25BE", blacktriangleleft: "\u25C2", blacktriangleright: "\u25B8", blank: "\u2423", blk12: "\u2592", blk14: "\u2591", blk34: "\u2593", block: "\u2588", bne: "=\u20E5", bnequiv: "\u2261\u20E5", bNot: "\u2AED", bnot: "\u2310", Bopf: "\u{1D539}", bopf: "\u{1D553}", bot: "\u22A5", bottom: "\u22A5", bowtie: "\u22C8", boxbox: "\u29C9", boxDL: "\u2557", boxDl: "\u2556", boxdL: "\u2555", boxdl: "\u2510", boxDR: "\u2554", boxDr: "\u2553", boxdR: "\u2552", boxdr: "\u250C", boxH: "\u2550", boxh: "\u2500", boxHD: "\u2566", boxHd: "\u2564", boxhD: "\u2565", boxhd: "\u252C", boxHU: "\u2569", boxHu: "\u2567", boxhU: "\u2568", boxhu: "\u2534", boxminus: "\u229F", boxplus: "\u229E", boxtimes: "\u22A0", boxUL: "\u255D", boxUl: "\u255C", boxuL: "\u255B", boxul: "\u2518", boxUR: "\u255A", boxUr: "\u2559", boxuR: "\u2558", boxur: "\u2514", boxV: "\u2551", boxv: "\u2502", boxVH: "\u256C", boxVh: "\u256B", boxvH: "\u256A", boxvh: "\u253C", boxVL: "\u2563", boxVl: "\u2562", boxvL: "\u2561", boxvl: "\u2524", boxVR: "\u2560", boxVr: "\u255F", boxvR: "\u255E", boxvr: "\u251C", bprime: "\u2035", Breve: "\u02D8", breve: "\u02D8", brvbar: "\xA6", Bscr: "\u212C", bscr: "\u{1D4B7}", bsemi: "\u204F", bsim: "\u223D", bsime: "\u22CD", bsol: "\\", bsolb: "\u29C5", bsolhsub: "\u27C8", bull: "\u2022", bullet: "\u2022", bump: "\u224E", bumpE: "\u2AAE", bumpe: "\u224F", Bumpeq: "\u224E", bumpeq: "\u224F", Cacute: "\u0106", cacute: "\u0107", Cap: "\u22D2", cap: "\u2229", capand: "\u2A44", capbrcup: "\u2A49", capcap: "\u2A4B", capcup: "\u2A47", capdot: "\u2A40", CapitalDifferentialD: "\u2145", caps: "\u2229\uFE00", caret: "\u2041", caron: "\u02C7", Cayleys: "\u212D", ccaps: "\u2A4D", Ccaron: "\u010C", ccaron: "\u010D", Ccedil: "\xC7", ccedil: "\xE7", Ccirc: "\u0108", ccirc: "\u0109", Cconint: "\u2230", ccups: "\u2A4C", ccupssm: "\u2A50", Cdot: "\u010A", cdot: "\u010B", cedil: "\xB8", Cedilla: "\xB8", cemptyv: "\u29B2", cent: "\xA2", CenterDot: "\xB7", centerdot: "\xB7", Cfr: "\u212D", cfr: "\u{1D520}", CHcy: "\u0427", chcy: "\u0447", check: "\u2713", checkmark: "\u2713", Chi: "\u03A7", chi: "\u03C7", cir: "\u25CB", circ: "\u02C6", circeq: "\u2257", circlearrowleft: "\u21BA", circlearrowright: "\u21BB", circledast: "\u229B", circledcirc: "\u229A", circleddash: "\u229D", CircleDot: "\u2299", circledR: "\xAE", circledS: "\u24C8", CircleMinus: "\u2296", CirclePlus: "\u2295", CircleTimes: "\u2297", cirE: "\u29C3", cire: "\u2257", cirfnint: "\u2A10", cirmid: "\u2AEF", cirscir: "\u29C2", ClockwiseContourIntegral: "\u2232", CloseCurlyDoubleQuote: "\u201D", CloseCurlyQuote: "\u2019", clubs: "\u2663", clubsuit: "\u2663", Colon: "\u2237", colon: ":", Colone: "\u2A74", colone: "\u2254", coloneq: "\u2254", comma: ",", commat: "@", comp: "\u2201", compfn: "\u2218", complement: "\u2201", complexes: "\u2102", cong: "\u2245", congdot: "\u2A6D", Congruent: "\u2261", Conint: "\u222F", conint: "\u222E", ContourIntegral: "\u222E", Copf: "\u2102", copf: "\u{1D554}", coprod: "\u2210", Coproduct: "\u2210", COPY: "\xA9", copy: "\xA9", copysr: "\u2117", CounterClockwiseContourIntegral: "\u2233", crarr: "\u21B5", Cross: "\u2A2F", cross: "\u2717", Cscr: "\u{1D49E}", cscr: "\u{1D4B8}", csub: "\u2ACF", csube: "\u2AD1", csup: "\u2AD0", csupe: "\u2AD2", ctdot: "\u22EF", cudarrl: "\u2938", cudarrr: "\u2935", cuepr: "\u22DE", cuesc: "\u22DF", cularr: "\u21B6", cularrp: "\u293D", Cup: "\u22D3", cup: "\u222A", cupbrcap: "\u2A48", CupCap: "\u224D", cupcap: "\u2A46", cupcup: "\u2A4A", cupdot: "\u228D", cupor: "\u2A45", cups: "\u222A\uFE00", curarr: "\u21B7", curarrm: "\u293C", curlyeqprec: "\u22DE", curlyeqsucc: "\u22DF", curlyvee: "\u22CE", curlywedge: "\u22CF", curren: "\xA4", curvearrowleft: "\u21B6", curvearrowright: "\u21B7", cuvee: "\u22CE", cuwed: "\u22CF", cwconint: "\u2232", cwint: "\u2231", cylcty: "\u232D", Dagger: "\u2021", dagger: "\u2020", daleth: "\u2138", Darr: "\u21A1", dArr: "\u21D3", darr: "\u2193", dash: "\u2010", Dashv: "\u2AE4", dashv: "\u22A3", dbkarow: "\u290F", dblac: "\u02DD", Dcaron: "\u010E", dcaron: "\u010F", Dcy: "\u0414", dcy: "\u0434", DD: "\u2145", dd: "\u2146", ddagger: "\u2021", ddarr: "\u21CA", DDotrahd: "\u2911", ddotseq: "\u2A77", deg: "\xB0", Del: "\u2207", Delta: "\u0394", delta: "\u03B4", demptyv: "\u29B1", dfisht: "\u297F", Dfr: "\u{1D507}", dfr: "\u{1D521}", dHar: "\u2965", dharl: "\u21C3", dharr: "\u21C2", DiacriticalAcute: "\xB4", DiacriticalDot: "\u02D9", DiacriticalDoubleAcute: "\u02DD", DiacriticalGrave: "`", DiacriticalTilde: "\u02DC", diam: "\u22C4", Diamond: "\u22C4", diamond: "\u22C4", diamondsuit: "\u2666", diams: "\u2666", die: "\xA8", DifferentialD: "\u2146", digamma: "\u03DD", disin: "\u22F2", div: "\xF7", divide: "\xF7", divideontimes: "\u22C7", divonx: "\u22C7", DJcy: "\u0402", djcy: "\u0452", dlcorn: "\u231E", dlcrop: "\u230D", dollar: "$", Dopf: "\u{1D53B}", dopf: "\u{1D555}", Dot: "\xA8", dot: "\u02D9", DotDot: "\u20DC", doteq: "\u2250", doteqdot: "\u2251", DotEqual: "\u2250", dotminus: "\u2238", dotplus: "\u2214", dotsquare: "\u22A1", doublebarwedge: "\u2306", DoubleContourIntegral: "\u222F", DoubleDot: "\xA8", DoubleDownArrow: "\u21D3", DoubleLeftArrow: "\u21D0", DoubleLeftRightArrow: "\u21D4", DoubleLeftTee: "\u2AE4", DoubleLongLeftArrow: "\u27F8", DoubleLongLeftRightArrow: "\u27FA", DoubleLongRightArrow: "\u27F9", DoubleRightArrow: "\u21D2", DoubleRightTee: "\u22A8", DoubleUpArrow: "\u21D1", DoubleUpDownArrow: "\u21D5", DoubleVerticalBar: "\u2225", DownArrow: "\u2193", Downarrow: "\u21D3", downarrow: "\u2193", DownArrowBar: "\u2913", DownArrowUpArrow: "\u21F5", DownBreve: "\u0311", downdownarrows: "\u21CA", downharpoonleft: "\u21C3", downharpoonright: "\u21C2", DownLeftRightVector: "\u2950", DownLeftTeeVector: "\u295E", DownLeftVector: "\u21BD", DownLeftVectorBar: "\u2956", DownRightTeeVector: "\u295F", DownRightVector: "\u21C1", DownRightVectorBar: "\u2957", DownTee: "\u22A4", DownTeeArrow: "\u21A7", drbkarow: "\u2910", drcorn: "\u231F", drcrop: "\u230C", Dscr: "\u{1D49F}", dscr: "\u{1D4B9}", DScy: "\u0405", dscy: "\u0455", dsol: "\u29F6", Dstrok: "\u0110", dstrok: "\u0111", dtdot: "\u22F1", dtri: "\u25BF", dtrif: "\u25BE", duarr: "\u21F5", duhar: "\u296F", dwangle: "\u29A6", DZcy: "\u040F", dzcy: "\u045F", dzigrarr: "\u27FF", Eacute: "\xC9", eacute: "\xE9", easter: "\u2A6E", Ecaron: "\u011A", ecaron: "\u011B", ecir: "\u2256", Ecirc: "\xCA", ecirc: "\xEA", ecolon: "\u2255", Ecy: "\u042D", ecy: "\u044D", eDDot: "\u2A77", Edot: "\u0116", eDot: "\u2251", edot: "\u0117", ee: "\u2147", efDot: "\u2252", Efr: "\u{1D508}", efr: "\u{1D522}", eg: "\u2A9A", Egrave: "\xC8", egrave: "\xE8", egs: "\u2A96", egsdot: "\u2A98", el: "\u2A99", Element: "\u2208", elinters: "\u23E7", ell: "\u2113", els: "\u2A95", elsdot: "\u2A97", Emacr: "\u0112", emacr: "\u0113", empty: "\u2205", emptyset: "\u2205", EmptySmallSquare: "\u25FB", emptyv: "\u2205", EmptyVerySmallSquare: "\u25AB", emsp: "\u2003", emsp13: "\u2004", emsp14: "\u2005", ENG: "\u014A", eng: "\u014B", ensp: "\u2002", Eogon: "\u0118", eogon: "\u0119", Eopf: "\u{1D53C}", eopf: "\u{1D556}", epar: "\u22D5", eparsl: "\u29E3", eplus: "\u2A71", epsi: "\u03B5", Epsilon: "\u0395", epsilon: "\u03B5", epsiv: "\u03F5", eqcirc: "\u2256", eqcolon: "\u2255", eqsim: "\u2242", eqslantgtr: "\u2A96", eqslantless: "\u2A95", Equal: "\u2A75", equals: "=", EqualTilde: "\u2242", equest: "\u225F", Equilibrium: "\u21CC", equiv: "\u2261", equivDD: "\u2A78", eqvparsl: "\u29E5", erarr: "\u2971", erDot: "\u2253", Escr: "\u2130", escr: "\u212F", esdot: "\u2250", Esim: "\u2A73", esim: "\u2242", Eta: "\u0397", eta: "\u03B7", ETH: "\xD0", eth: "\xF0", Euml: "\xCB", euml: "\xEB", euro: "\u20AC", excl: "!", exist: "\u2203", Exists: "\u2203", expectation: "\u2130", ExponentialE: "\u2147", exponentiale: "\u2147", fallingdotseq: "\u2252", Fcy: "\u0424", fcy: "\u0444", female: "\u2640", ffilig: "\uFB03", fflig: "\uFB00", ffllig: "\uFB04", Ffr: "\u{1D509}", ffr: "\u{1D523}", filig: "\uFB01", FilledSmallSquare: "\u25FC", FilledVerySmallSquare: "\u25AA", fjlig: "fj", flat: "\u266D", fllig: "\uFB02", fltns: "\u25B1", fnof: "\u0192", Fopf: "\u{1D53D}", fopf: "\u{1D557}", ForAll: "\u2200", forall: "\u2200", fork: "\u22D4", forkv: "\u2AD9", Fouriertrf: "\u2131", fpartint: "\u2A0D", frac12: "\xBD", frac13: "\u2153", frac14: "\xBC", frac15: "\u2155", frac16: "\u2159", frac18: "\u215B", frac23: "\u2154", frac25: "\u2156", frac34: "\xBE", frac35: "\u2157", frac38: "\u215C", frac45: "\u2158", frac56: "\u215A", frac58: "\u215D", frac78: "\u215E", frasl: "\u2044", frown: "\u2322", Fscr: "\u2131", fscr: "\u{1D4BB}", gacute: "\u01F5", Gamma: "\u0393", gamma: "\u03B3", Gammad: "\u03DC", gammad: "\u03DD", gap: "\u2A86", Gbreve: "\u011E", gbreve: "\u011F", Gcedil: "\u0122", Gcirc: "\u011C", gcirc: "\u011D", Gcy: "\u0413", gcy: "\u0433", Gdot: "\u0120", gdot: "\u0121", gE: "\u2267", ge: "\u2265", gEl: "\u2A8C", gel: "\u22DB", geq: "\u2265", geqq: "\u2267", geqslant: "\u2A7E", ges: "\u2A7E", gescc: "\u2AA9", gesdot: "\u2A80", gesdoto: "\u2A82", gesdotol: "\u2A84", gesl: "\u22DB\uFE00", gesles: "\u2A94", Gfr: "\u{1D50A}", gfr: "\u{1D524}", Gg: "\u22D9", gg: "\u226B", ggg: "\u22D9", gimel: "\u2137", GJcy: "\u0403", gjcy: "\u0453", gl: "\u2277", gla: "\u2AA5", glE: "\u2A92", glj: "\u2AA4", gnap: "\u2A8A", gnapprox: "\u2A8A", gnE: "\u2269", gne: "\u2A88", gneq: "\u2A88", gneqq: "\u2269", gnsim: "\u22E7", Gopf: "\u{1D53E}", gopf: "\u{1D558}", grave: "`", GreaterEqual: "\u2265", GreaterEqualLess: "\u22DB", GreaterFullEqual: "\u2267", GreaterGreater: "\u2AA2", GreaterLess: "\u2277", GreaterSlantEqual: "\u2A7E", GreaterTilde: "\u2273", Gscr: "\u{1D4A2}", gscr: "\u210A", gsim: "\u2273", gsime: "\u2A8E", gsiml: "\u2A90", GT: ">", Gt: "\u226B", gt: ">", gtcc: "\u2AA7", gtcir: "\u2A7A", gtdot: "\u22D7", gtlPar: "\u2995", gtquest: "\u2A7C", gtrapprox: "\u2A86", gtrarr: "\u2978", gtrdot: "\u22D7", gtreqless: "\u22DB", gtreqqless: "\u2A8C", gtrless: "\u2277", gtrsim: "\u2273", gvertneqq: "\u2269\uFE00", gvnE: "\u2269\uFE00", Hacek: "\u02C7", hairsp: "\u200A", half: "\xBD", hamilt: "\u210B", HARDcy: "\u042A", hardcy: "\u044A", hArr: "\u21D4", harr: "\u2194", harrcir: "\u2948", harrw: "\u21AD", Hat: "^", hbar: "\u210F", Hcirc: "\u0124", hcirc: "\u0125", hearts: "\u2665", heartsuit: "\u2665", hellip: "\u2026", hercon: "\u22B9", Hfr: "\u210C", hfr: "\u{1D525}", HilbertSpace: "\u210B", hksearow: "\u2925", hkswarow: "\u2926", hoarr: "\u21FF", homtht: "\u223B", hookleftarrow: "\u21A9", hookrightarrow: "\u21AA", Hopf: "\u210D", hopf: "\u{1D559}", horbar: "\u2015", HorizontalLine: "\u2500", Hscr: "\u210B", hscr: "\u{1D4BD}", hslash: "\u210F", Hstrok: "\u0126", hstrok: "\u0127", HumpDownHump: "\u224E", HumpEqual: "\u224F", hybull: "\u2043", hyphen: "\u2010", Iacute: "\xCD", iacute: "\xED", ic: "\u2063", Icirc: "\xCE", icirc: "\xEE", Icy: "\u0418", icy: "\u0438", Idot: "\u0130", IEcy: "\u0415", iecy: "\u0435", iexcl: "\xA1", iff: "\u21D4", Ifr: "\u2111", ifr: "\u{1D526}", Igrave: "\xCC", igrave: "\xEC", ii: "\u2148", iiiint: "\u2A0C", iiint: "\u222D", iinfin: "\u29DC", iiota: "\u2129", IJlig: "\u0132", ijlig: "\u0133", Im: "\u2111", Imacr: "\u012A", imacr: "\u012B", image: "\u2111", ImaginaryI: "\u2148", imagline: "\u2110", imagpart: "\u2111", imath: "\u0131", imof: "\u22B7", imped: "\u01B5", Implies: "\u21D2", in: "\u2208", incare: "\u2105", infin: "\u221E", infintie: "\u29DD", inodot: "\u0131", Int: "\u222C", int: "\u222B", intcal: "\u22BA", integers: "\u2124", Integral: "\u222B", intercal: "\u22BA", Intersection: "\u22C2", intlarhk: "\u2A17", intprod: "\u2A3C", InvisibleComma: "\u2063", InvisibleTimes: "\u2062", IOcy: "\u0401", iocy: "\u0451", Iogon: "\u012E", iogon: "\u012F", Iopf: "\u{1D540}", iopf: "\u{1D55A}", Iota: "\u0399", iota: "\u03B9", iprod: "\u2A3C", iquest: "\xBF", Iscr: "\u2110", iscr: "\u{1D4BE}", isin: "\u2208", isindot: "\u22F5", isinE: "\u22F9", isins: "\u22F4", isinsv: "\u22F3", isinv: "\u2208", it: "\u2062", Itilde: "\u0128", itilde: "\u0129", Iukcy: "\u0406", iukcy: "\u0456", Iuml: "\xCF", iuml: "\xEF", Jcirc: "\u0134", jcirc: "\u0135", Jcy: "\u0419", jcy: "\u0439", Jfr: "\u{1D50D}", jfr: "\u{1D527}", jmath: "\u0237", Jopf: "\u{1D541}", jopf: "\u{1D55B}", Jscr: "\u{1D4A5}", jscr: "\u{1D4BF}", Jsercy: "\u0408", jsercy: "\u0458", Jukcy: "\u0404", jukcy: "\u0454", Kappa: "\u039A", kappa: "\u03BA", kappav: "\u03F0", Kcedil: "\u0136", kcedil: "\u0137", Kcy: "\u041A", kcy: "\u043A", Kfr: "\u{1D50E}", kfr: "\u{1D528}", kgreen: "\u0138", KHcy: "\u0425", khcy: "\u0445", KJcy: "\u040C", kjcy: "\u045C", Kopf: "\u{1D542}", kopf: "\u{1D55C}", Kscr: "\u{1D4A6}", kscr: "\u{1D4C0}", lAarr: "\u21DA", Lacute: "\u0139", lacute: "\u013A", laemptyv: "\u29B4", lagran: "\u2112", Lambda: "\u039B", lambda: "\u03BB", Lang: "\u27EA", lang: "\u27E8", langd: "\u2991", langle: "\u27E8", lap: "\u2A85", Laplacetrf: "\u2112", laquo: "\xAB", Larr: "\u219E", lArr: "\u21D0", larr: "\u2190", larrb: "\u21E4", larrbfs: "\u291F", larrfs: "\u291D", larrhk: "\u21A9", larrlp: "\u21AB", larrpl: "\u2939", larrsim: "\u2973", larrtl: "\u21A2", lat: "\u2AAB", lAtail: "\u291B", latail: "\u2919", late: "\u2AAD", lates: "\u2AAD\uFE00", lBarr: "\u290E", lbarr: "\u290C", lbbrk: "\u2772", lbrace: "{", lbrack: "[", lbrke: "\u298B", lbrksld: "\u298F", lbrkslu: "\u298D", Lcaron: "\u013D", lcaron: "\u013E", Lcedil: "\u013B", lcedil: "\u013C", lceil: "\u2308", lcub: "{", Lcy: "\u041B", lcy: "\u043B", ldca: "\u2936", ldquo: "\u201C", ldquor: "\u201E", ldrdhar: "\u2967", ldrushar: "\u294B", ldsh: "\u21B2", lE: "\u2266", le: "\u2264", LeftAngleBracket: "\u27E8", LeftArrow: "\u2190", Leftarrow: "\u21D0", leftarrow: "\u2190", LeftArrowBar: "\u21E4", LeftArrowRightArrow: "\u21C6", leftarrowtail: "\u21A2", LeftCeiling: "\u2308", LeftDoubleBracket: "\u27E6", LeftDownTeeVector: "\u2961", LeftDownVector: "\u21C3", LeftDownVectorBar: "\u2959", LeftFloor: "\u230A", leftharpoondown: "\u21BD", leftharpoonup: "\u21BC", leftleftarrows: "\u21C7", LeftRightArrow: "\u2194", Leftrightarrow: "\u21D4", leftrightarrow: "\u2194", leftrightarrows: "\u21C6", leftrightharpoons: "\u21CB", leftrightsquigarrow: "\u21AD", LeftRightVector: "\u294E", LeftTee: "\u22A3", LeftTeeArrow: "\u21A4", LeftTeeVector: "\u295A", leftthreetimes: "\u22CB", LeftTriangle: "\u22B2", LeftTriangleBar: "\u29CF", LeftTriangleEqual: "\u22B4", LeftUpDownVector: "\u2951", LeftUpTeeVector: "\u2960", LeftUpVector: "\u21BF", LeftUpVectorBar: "\u2958", LeftVector: "\u21BC", LeftVectorBar: "\u2952", lEg: "\u2A8B", leg: "\u22DA", leq: "\u2264", leqq: "\u2266", leqslant: "\u2A7D", les: "\u2A7D", lescc: "\u2AA8", lesdot: "\u2A7F", lesdoto: "\u2A81", lesdotor: "\u2A83", lesg: "\u22DA\uFE00", lesges: "\u2A93", lessapprox: "\u2A85", lessdot: "\u22D6", lesseqgtr: "\u22DA", lesseqqgtr: "\u2A8B", LessEqualGreater: "\u22DA", LessFullEqual: "\u2266", LessGreater: "\u2276", lessgtr: "\u2276", LessLess: "\u2AA1", lesssim: "\u2272", LessSlantEqual: "\u2A7D", LessTilde: "\u2272", lfisht: "\u297C", lfloor: "\u230A", Lfr: "\u{1D50F}", lfr: "\u{1D529}", lg: "\u2276", lgE: "\u2A91", lHar: "\u2962", lhard: "\u21BD", lharu: "\u21BC", lharul: "\u296A", lhblk: "\u2584", LJcy: "\u0409", ljcy: "\u0459", Ll: "\u22D8", ll: "\u226A", llarr: "\u21C7", llcorner: "\u231E", Lleftarrow: "\u21DA", llhard: "\u296B", lltri: "\u25FA", Lmidot: "\u013F", lmidot: "\u0140", lmoust: "\u23B0", lmoustache: "\u23B0", lnap: "\u2A89", lnapprox: "\u2A89", lnE: "\u2268", lne: "\u2A87", lneq: "\u2A87", lneqq: "\u2268", lnsim: "\u22E6", loang: "\u27EC", loarr: "\u21FD", lobrk: "\u27E6", LongLeftArrow: "\u27F5", Longleftarrow: "\u27F8", longleftarrow: "\u27F5", LongLeftRightArrow: "\u27F7", Longleftrightarrow: "\u27FA", longleftrightarrow: "\u27F7", longmapsto: "\u27FC", LongRightArrow: "\u27F6", Longrightarrow: "\u27F9", longrightarrow: "\u27F6", looparrowleft: "\u21AB", looparrowright: "\u21AC", lopar: "\u2985", Lopf: "\u{1D543}", lopf: "\u{1D55D}", loplus: "\u2A2D", lotimes: "\u2A34", lowast: "\u2217", lowbar: "_", LowerLeftArrow: "\u2199", LowerRightArrow: "\u2198", loz: "\u25CA", lozenge: "\u25CA", lozf: "\u29EB", lpar: "(", lparlt: "\u2993", lrarr: "\u21C6", lrcorner: "\u231F", lrhar: "\u21CB", lrhard: "\u296D", lrm: "\u200E", lrtri: "\u22BF", lsaquo: "\u2039", Lscr: "\u2112", lscr: "\u{1D4C1}", Lsh: "\u21B0", lsh: "\u21B0", lsim: "\u2272", lsime: "\u2A8D", lsimg: "\u2A8F", lsqb: "[", lsquo: "\u2018", lsquor: "\u201A", Lstrok: "\u0141", lstrok: "\u0142", LT: "<", Lt: "\u226A", lt: "<", ltcc: "\u2AA6", ltcir: "\u2A79", ltdot: "\u22D6", lthree: "\u22CB", ltimes: "\u22C9", ltlarr: "\u2976", ltquest: "\u2A7B", ltri: "\u25C3", ltrie: "\u22B4", ltrif: "\u25C2", ltrPar: "\u2996", lurdshar: "\u294A", luruhar: "\u2966", lvertneqq: "\u2268\uFE00", lvnE: "\u2268\uFE00", macr: "\xAF", male: "\u2642", malt: "\u2720", maltese: "\u2720", Map: "\u2905", map: "\u21A6", mapsto: "\u21A6", mapstodown: "\u21A7", mapstoleft: "\u21A4", mapstoup: "\u21A5", marker: "\u25AE", mcomma: "\u2A29", Mcy: "\u041C", mcy: "\u043C", mdash: "\u2014", mDDot: "\u223A", measuredangle: "\u2221", MediumSpace: "\u205F", Mellintrf: "\u2133", Mfr: "\u{1D510}", mfr: "\u{1D52A}", mho: "\u2127", micro: "\xB5", mid: "\u2223", midast: "*", midcir: "\u2AF0", middot: "\xB7", minus: "\u2212", minusb: "\u229F", minusd: "\u2238", minusdu: "\u2A2A", MinusPlus: "\u2213", mlcp: "\u2ADB", mldr: "\u2026", mnplus: "\u2213", models: "\u22A7", Mopf: "\u{1D544}", mopf: "\u{1D55E}", mp: "\u2213", Mscr: "\u2133", mscr: "\u{1D4C2}", mstpos: "\u223E", Mu: "\u039C", mu: "\u03BC", multimap: "\u22B8", mumap: "\u22B8", nabla: "\u2207", Nacute: "\u0143", nacute: "\u0144", nang: "\u2220\u20D2", nap: "\u2249", napE: "\u2A70\u0338", napid: "\u224B\u0338", napos: "\u0149", napprox: "\u2249", natur: "\u266E", natural: "\u266E", naturals: "\u2115", nbsp: "\xA0", nbump: "\u224E\u0338", nbumpe: "\u224F\u0338", ncap: "\u2A43", Ncaron: "\u0147", ncaron: "\u0148", Ncedil: "\u0145", ncedil: "\u0146", ncong: "\u2247", ncongdot: "\u2A6D\u0338", ncup: "\u2A42", Ncy: "\u041D", ncy: "\u043D", ndash: "\u2013", ne: "\u2260", nearhk: "\u2924", neArr: "\u21D7", nearr: "\u2197", nearrow: "\u2197", nedot: "\u2250\u0338", NegativeMediumSpace: "\u200B", NegativeThickSpace: "\u200B", NegativeThinSpace: "\u200B", NegativeVeryThinSpace: "\u200B", nequiv: "\u2262", nesear: "\u2928", nesim: "\u2242\u0338", NestedGreaterGreater: "\u226B", NestedLessLess: "\u226A", NewLine: `
`, nexist: "\u2204", nexists: "\u2204", Nfr: "\u{1D511}", nfr: "\u{1D52B}", ngE: "\u2267\u0338", nge: "\u2271", ngeq: "\u2271", ngeqq: "\u2267\u0338", ngeqslant: "\u2A7E\u0338", nges: "\u2A7E\u0338", nGg: "\u22D9\u0338", ngsim: "\u2275", nGt: "\u226B\u20D2", ngt: "\u226F", ngtr: "\u226F", nGtv: "\u226B\u0338", nhArr: "\u21CE", nharr: "\u21AE", nhpar: "\u2AF2", ni: "\u220B", nis: "\u22FC", nisd: "\u22FA", niv: "\u220B", NJcy: "\u040A", njcy: "\u045A", nlArr: "\u21CD", nlarr: "\u219A", nldr: "\u2025", nlE: "\u2266\u0338", nle: "\u2270", nLeftarrow: "\u21CD", nleftarrow: "\u219A", nLeftrightarrow: "\u21CE", nleftrightarrow: "\u21AE", nleq: "\u2270", nleqq: "\u2266\u0338", nleqslant: "\u2A7D\u0338", nles: "\u2A7D\u0338", nless: "\u226E", nLl: "\u22D8\u0338", nlsim: "\u2274", nLt: "\u226A\u20D2", nlt: "\u226E", nltri: "\u22EA", nltrie: "\u22EC", nLtv: "\u226A\u0338", nmid: "\u2224", NoBreak: "\u2060", NonBreakingSpace: "\xA0", Nopf: "\u2115", nopf: "\u{1D55F}", Not: "\u2AEC", not: "\xAC", NotCongruent: "\u2262", NotCupCap: "\u226D", NotDoubleVerticalBar: "\u2226", NotElement: "\u2209", NotEqual: "\u2260", NotEqualTilde: "\u2242\u0338", NotExists: "\u2204", NotGreater: "\u226F", NotGreaterEqual: "\u2271", NotGreaterFullEqual: "\u2267\u0338", NotGreaterGreater: "\u226B\u0338", NotGreaterLess: "\u2279", NotGreaterSlantEqual: "\u2A7E\u0338", NotGreaterTilde: "\u2275", NotHumpDownHump: "\u224E\u0338", NotHumpEqual: "\u224F\u0338", notin: "\u2209", notindot: "\u22F5\u0338", notinE: "\u22F9\u0338", notinva: "\u2209", notinvb: "\u22F7", notinvc: "\u22F6", NotLeftTriangle: "\u22EA", NotLeftTriangleBar: "\u29CF\u0338", NotLeftTriangleEqual: "\u22EC", NotLess: "\u226E", NotLessEqual: "\u2270", NotLessGreater: "\u2278", NotLessLess: "\u226A\u0338", NotLessSlantEqual: "\u2A7D\u0338", NotLessTilde: "\u2274", NotNestedGreaterGreater: "\u2AA2\u0338", NotNestedLessLess: "\u2AA1\u0338", notni: "\u220C", notniva: "\u220C", notnivb: "\u22FE", notnivc: "\u22FD", NotPrecedes: "\u2280", NotPrecedesEqual: "\u2AAF\u0338", NotPrecedesSlantEqual: "\u22E0", NotReverseElement: "\u220C", NotRightTriangle: "\u22EB", NotRightTriangleBar: "\u29D0\u0338", NotRightTriangleEqual: "\u22ED", NotSquareSubset: "\u228F\u0338", NotSquareSubsetEqual: "\u22E2", NotSquareSuperset: "\u2290\u0338", NotSquareSupersetEqual: "\u22E3", NotSubset: "\u2282\u20D2", NotSubsetEqual: "\u2288", NotSucceeds: "\u2281", NotSucceedsEqual: "\u2AB0\u0338", NotSucceedsSlantEqual: "\u22E1", NotSucceedsTilde: "\u227F\u0338", NotSuperset: "\u2283\u20D2", NotSupersetEqual: "\u2289", NotTilde: "\u2241", NotTildeEqual: "\u2244", NotTildeFullEqual: "\u2247", NotTildeTilde: "\u2249", NotVerticalBar: "\u2224", npar: "\u2226", nparallel: "\u2226", nparsl: "\u2AFD\u20E5", npart: "\u2202\u0338", npolint: "\u2A14", npr: "\u2280", nprcue: "\u22E0", npre: "\u2AAF\u0338", nprec: "\u2280", npreceq: "\u2AAF\u0338", nrArr: "\u21CF", nrarr: "\u219B", nrarrc: "\u2933\u0338", nrarrw: "\u219D\u0338", nRightarrow: "\u21CF", nrightarrow: "\u219B", nrtri: "\u22EB", nrtrie: "\u22ED", nsc: "\u2281", nsccue: "\u22E1", nsce: "\u2AB0\u0338", Nscr: "\u{1D4A9}", nscr: "\u{1D4C3}", nshortmid: "\u2224", nshortparallel: "\u2226", nsim: "\u2241", nsime: "\u2244", nsimeq: "\u2244", nsmid: "\u2224", nspar: "\u2226", nsqsube: "\u22E2", nsqsupe: "\u22E3", nsub: "\u2284", nsubE: "\u2AC5\u0338", nsube: "\u2288", nsubset: "\u2282\u20D2", nsubseteq: "\u2288", nsubseteqq: "\u2AC5\u0338", nsucc: "\u2281", nsucceq: "\u2AB0\u0338", nsup: "\u2285", nsupE: "\u2AC6\u0338", nsupe: "\u2289", nsupset: "\u2283\u20D2", nsupseteq: "\u2289", nsupseteqq: "\u2AC6\u0338", ntgl: "\u2279", Ntilde: "\xD1", ntilde: "\xF1", ntlg: "\u2278", ntriangleleft: "\u22EA", ntrianglelefteq: "\u22EC", ntriangleright: "\u22EB", ntrianglerighteq: "\u22ED", Nu: "\u039D", nu: "\u03BD", num: "#", numero: "\u2116", numsp: "\u2007", nvap: "\u224D\u20D2", nVDash: "\u22AF", nVdash: "\u22AE", nvDash: "\u22AD", nvdash: "\u22AC", nvge: "\u2265\u20D2", nvgt: ">\u20D2", nvHarr: "\u2904", nvinfin: "\u29DE", nvlArr: "\u2902", nvle: "\u2264\u20D2", nvlt: "<\u20D2", nvltrie: "\u22B4\u20D2", nvrArr: "\u2903", nvrtrie: "\u22B5\u20D2", nvsim: "\u223C\u20D2", nwarhk: "\u2923", nwArr: "\u21D6", nwarr: "\u2196", nwarrow: "\u2196", nwnear: "\u2927", Oacute: "\xD3", oacute: "\xF3", oast: "\u229B", ocir: "\u229A", Ocirc: "\xD4", ocirc: "\xF4", Ocy: "\u041E", ocy: "\u043E", odash: "\u229D", Odblac: "\u0150", odblac: "\u0151", odiv: "\u2A38", odot: "\u2299", odsold: "\u29BC", OElig: "\u0152", oelig: "\u0153", ofcir: "\u29BF", Ofr: "\u{1D512}", ofr: "\u{1D52C}", ogon: "\u02DB", Ograve: "\xD2", ograve: "\xF2", ogt: "\u29C1", ohbar: "\u29B5", ohm: "\u03A9", oint: "\u222E", olarr: "\u21BA", olcir: "\u29BE", olcross: "\u29BB", oline: "\u203E", olt: "\u29C0", Omacr: "\u014C", omacr: "\u014D", Omega: "\u03A9", omega: "\u03C9", Omicron: "\u039F", omicron: "\u03BF", omid: "\u29B6", ominus: "\u2296", Oopf: "\u{1D546}", oopf: "\u{1D560}", opar: "\u29B7", OpenCurlyDoubleQuote: "\u201C", OpenCurlyQuote: "\u2018", operp: "\u29B9", oplus: "\u2295", Or: "\u2A54", or: "\u2228", orarr: "\u21BB", ord: "\u2A5D", order: "\u2134", orderof: "\u2134", ordf: "\xAA", ordm: "\xBA", origof: "\u22B6", oror: "\u2A56", orslope: "\u2A57", orv: "\u2A5B", oS: "\u24C8", Oscr: "\u{1D4AA}", oscr: "\u2134", Oslash: "\xD8", oslash: "\xF8", osol: "\u2298", Otilde: "\xD5", otilde: "\xF5", Otimes: "\u2A37", otimes: "\u2297", otimesas: "\u2A36", Ouml: "\xD6", ouml: "\xF6", ovbar: "\u233D", OverBar: "\u203E", OverBrace: "\u23DE", OverBracket: "\u23B4", OverParenthesis: "\u23DC", par: "\u2225", para: "\xB6", parallel: "\u2225", parsim: "\u2AF3", parsl: "\u2AFD", part: "\u2202", PartialD: "\u2202", Pcy: "\u041F", pcy: "\u043F", percnt: "%", period: ".", permil: "\u2030", perp: "\u22A5", pertenk: "\u2031", Pfr: "\u{1D513}", pfr: "\u{1D52D}", Phi: "\u03A6", phi: "\u03C6", phiv: "\u03D5", phmmat: "\u2133", phone: "\u260E", Pi: "\u03A0", pi: "\u03C0", pitchfork: "\u22D4", piv: "\u03D6", planck: "\u210F", planckh: "\u210E", plankv: "\u210F", plus: "+", plusacir: "\u2A23", plusb: "\u229E", pluscir: "\u2A22", plusdo: "\u2214", plusdu: "\u2A25", pluse: "\u2A72", PlusMinus: "\xB1", plusmn: "\xB1", plussim: "\u2A26", plustwo: "\u2A27", pm: "\xB1", Poincareplane: "\u210C", pointint: "\u2A15", Popf: "\u2119", popf: "\u{1D561}", pound: "\xA3", Pr: "\u2ABB", pr: "\u227A", prap: "\u2AB7", prcue: "\u227C", prE: "\u2AB3", pre: "\u2AAF", prec: "\u227A", precapprox: "\u2AB7", preccurlyeq: "\u227C", Precedes: "\u227A", PrecedesEqual: "\u2AAF", PrecedesSlantEqual: "\u227C", PrecedesTilde: "\u227E", preceq: "\u2AAF", precnapprox: "\u2AB9", precneqq: "\u2AB5", precnsim: "\u22E8", precsim: "\u227E", Prime: "\u2033", prime: "\u2032", primes: "\u2119", prnap: "\u2AB9", prnE: "\u2AB5", prnsim: "\u22E8", prod: "\u220F", Product: "\u220F", profalar: "\u232E", profline: "\u2312", profsurf: "\u2313", prop: "\u221D", Proportion: "\u2237", Proportional: "\u221D", propto: "\u221D", prsim: "\u227E", prurel: "\u22B0", Pscr: "\u{1D4AB}", pscr: "\u{1D4C5}", Psi: "\u03A8", psi: "\u03C8", puncsp: "\u2008", Qfr: "\u{1D514}", qfr: "\u{1D52E}", qint: "\u2A0C", Qopf: "\u211A", qopf: "\u{1D562}", qprime: "\u2057", Qscr: "\u{1D4AC}", qscr: "\u{1D4C6}", quaternions: "\u210D", quatint: "\u2A16", quest: "?", questeq: "\u225F", QUOT: '"', quot: '"', rAarr: "\u21DB", race: "\u223D\u0331", Racute: "\u0154", racute: "\u0155", radic: "\u221A", raemptyv: "\u29B3", Rang: "\u27EB", rang: "\u27E9", rangd: "\u2992", range: "\u29A5", rangle: "\u27E9", raquo: "\xBB", Rarr: "\u21A0", rArr: "\u21D2", rarr: "\u2192", rarrap: "\u2975", rarrb: "\u21E5", rarrbfs: "\u2920", rarrc: "\u2933", rarrfs: "\u291E", rarrhk: "\u21AA", rarrlp: "\u21AC", rarrpl: "\u2945", rarrsim: "\u2974", Rarrtl: "\u2916", rarrtl: "\u21A3", rarrw: "\u219D", rAtail: "\u291C", ratail: "\u291A", ratio: "\u2236", rationals: "\u211A", RBarr: "\u2910", rBarr: "\u290F", rbarr: "\u290D", rbbrk: "\u2773", rbrace: "}", rbrack: "]", rbrke: "\u298C", rbrksld: "\u298E", rbrkslu: "\u2990", Rcaron: "\u0158", rcaron: "\u0159", Rcedil: "\u0156", rcedil: "\u0157", rceil: "\u2309", rcub: "}", Rcy: "\u0420", rcy: "\u0440", rdca: "\u2937", rdldhar: "\u2969", rdquo: "\u201D", rdquor: "\u201D", rdsh: "\u21B3", Re: "\u211C", real: "\u211C", realine: "\u211B", realpart: "\u211C", reals: "\u211D", rect: "\u25AD", REG: "\xAE", reg: "\xAE", ReverseElement: "\u220B", ReverseEquilibrium: "\u21CB", ReverseUpEquilibrium: "\u296F", rfisht: "\u297D", rfloor: "\u230B", Rfr: "\u211C", rfr: "\u{1D52F}", rHar: "\u2964", rhard: "\u21C1", rharu: "\u21C0", rharul: "\u296C", Rho: "\u03A1", rho: "\u03C1", rhov: "\u03F1", RightAngleBracket: "\u27E9", RightArrow: "\u2192", Rightarrow: "\u21D2", rightarrow: "\u2192", RightArrowBar: "\u21E5", RightArrowLeftArrow: "\u21C4", rightarrowtail: "\u21A3", RightCeiling: "\u2309", RightDoubleBracket: "\u27E7", RightDownTeeVector: "\u295D", RightDownVector: "\u21C2", RightDownVectorBar: "\u2955", RightFloor: "\u230B", rightharpoondown: "\u21C1", rightharpoonup: "\u21C0", rightleftarrows: "\u21C4", rightleftharpoons: "\u21CC", rightrightarrows: "\u21C9", rightsquigarrow: "\u219D", RightTee: "\u22A2", RightTeeArrow: "\u21A6", RightTeeVector: "\u295B", rightthreetimes: "\u22CC", RightTriangle: "\u22B3", RightTriangleBar: "\u29D0", RightTriangleEqual: "\u22B5", RightUpDownVector: "\u294F", RightUpTeeVector: "\u295C", RightUpVector: "\u21BE", RightUpVectorBar: "\u2954", RightVector: "\u21C0", RightVectorBar: "\u2953", ring: "\u02DA", risingdotseq: "\u2253", rlarr: "\u21C4", rlhar: "\u21CC", rlm: "\u200F", rmoust: "\u23B1", rmoustache: "\u23B1", rnmid: "\u2AEE", roang: "\u27ED", roarr: "\u21FE", robrk: "\u27E7", ropar: "\u2986", Ropf: "\u211D", ropf: "\u{1D563}", roplus: "\u2A2E", rotimes: "\u2A35", RoundImplies: "\u2970", rpar: ")", rpargt: "\u2994", rppolint: "\u2A12", rrarr: "\u21C9", Rrightarrow: "\u21DB", rsaquo: "\u203A", Rscr: "\u211B", rscr: "\u{1D4C7}", Rsh: "\u21B1", rsh: "\u21B1", rsqb: "]", rsquo: "\u2019", rsquor: "\u2019", rthree: "\u22CC", rtimes: "\u22CA", rtri: "\u25B9", rtrie: "\u22B5", rtrif: "\u25B8", rtriltri: "\u29CE", RuleDelayed: "\u29F4", ruluhar: "\u2968", rx: "\u211E", Sacute: "\u015A", sacute: "\u015B", sbquo: "\u201A", Sc: "\u2ABC", sc: "\u227B", scap: "\u2AB8", Scaron: "\u0160", scaron: "\u0161", sccue: "\u227D", scE: "\u2AB4", sce: "\u2AB0", Scedil: "\u015E", scedil: "\u015F", Scirc: "\u015C", scirc: "\u015D", scnap: "\u2ABA", scnE: "\u2AB6", scnsim: "\u22E9", scpolint: "\u2A13", scsim: "\u227F", Scy: "\u0421", scy: "\u0441", sdot: "\u22C5", sdotb: "\u22A1", sdote: "\u2A66", searhk: "\u2925", seArr: "\u21D8", searr: "\u2198", searrow: "\u2198", sect: "\xA7", semi: ";", seswar: "\u2929", setminus: "\u2216", setmn: "\u2216", sext: "\u2736", Sfr: "\u{1D516}", sfr: "\u{1D530}", sfrown: "\u2322", sharp: "\u266F", SHCHcy: "\u0429", shchcy: "\u0449", SHcy: "\u0428", shcy: "\u0448", ShortDownArrow: "\u2193", ShortLeftArrow: "\u2190", shortmid: "\u2223", shortparallel: "\u2225", ShortRightArrow: "\u2192", ShortUpArrow: "\u2191", shy: "\xAD", Sigma: "\u03A3", sigma: "\u03C3", sigmaf: "\u03C2", sigmav: "\u03C2", sim: "\u223C", simdot: "\u2A6A", sime: "\u2243", simeq: "\u2243", simg: "\u2A9E", simgE: "\u2AA0", siml: "\u2A9D", simlE: "\u2A9F", simne: "\u2246", simplus: "\u2A24", simrarr: "\u2972", slarr: "\u2190", SmallCircle: "\u2218", smallsetminus: "\u2216", smashp: "\u2A33", smeparsl: "\u29E4", smid: "\u2223", smile: "\u2323", smt: "\u2AAA", smte: "\u2AAC", smtes: "\u2AAC\uFE00", SOFTcy: "\u042C", softcy: "\u044C", sol: "/", solb: "\u29C4", solbar: "\u233F", Sopf: "\u{1D54A}", sopf: "\u{1D564}", spades: "\u2660", spadesuit: "\u2660", spar: "\u2225", sqcap: "\u2293", sqcaps: "\u2293\uFE00", sqcup: "\u2294", sqcups: "\u2294\uFE00", Sqrt: "\u221A", sqsub: "\u228F", sqsube: "\u2291", sqsubset: "\u228F", sqsubseteq: "\u2291", sqsup: "\u2290", sqsupe: "\u2292", sqsupset: "\u2290", sqsupseteq: "\u2292", squ: "\u25A1", Square: "\u25A1", square: "\u25A1", SquareIntersection: "\u2293", SquareSubset: "\u228F", SquareSubsetEqual: "\u2291", SquareSuperset: "\u2290", SquareSupersetEqual: "\u2292", SquareUnion: "\u2294", squarf: "\u25AA", squf: "\u25AA", srarr: "\u2192", Sscr: "\u{1D4AE}", sscr: "\u{1D4C8}", ssetmn: "\u2216", ssmile: "\u2323", sstarf: "\u22C6", Star: "\u22C6", star: "\u2606", starf: "\u2605", straightepsilon: "\u03F5", straightphi: "\u03D5", strns: "\xAF", Sub: "\u22D0", sub: "\u2282", subdot: "\u2ABD", subE: "\u2AC5", sube: "\u2286", subedot: "\u2AC3", submult: "\u2AC1", subnE: "\u2ACB", subne: "\u228A", subplus: "\u2ABF", subrarr: "\u2979", Subset: "\u22D0", subset: "\u2282", subseteq: "\u2286", subseteqq: "\u2AC5", SubsetEqual: "\u2286", subsetneq: "\u228A", subsetneqq: "\u2ACB", subsim: "\u2AC7", subsub: "\u2AD5", subsup: "\u2AD3", succ: "\u227B", succapprox: "\u2AB8", succcurlyeq: "\u227D", Succeeds: "\u227B", SucceedsEqual: "\u2AB0", SucceedsSlantEqual: "\u227D", SucceedsTilde: "\u227F", succeq: "\u2AB0", succnapprox: "\u2ABA", succneqq: "\u2AB6", succnsim: "\u22E9", succsim: "\u227F", SuchThat: "\u220B", Sum: "\u2211", sum: "\u2211", sung: "\u266A", Sup: "\u22D1", sup: "\u2283", sup1: "\xB9", sup2: "\xB2", sup3: "\xB3", supdot: "\u2ABE", supdsub: "\u2AD8", supE: "\u2AC6", supe: "\u2287", supedot: "\u2AC4", Superset: "\u2283", SupersetEqual: "\u2287", suphsol: "\u27C9", suphsub: "\u2AD7", suplarr: "\u297B", supmult: "\u2AC2", supnE: "\u2ACC", supne: "\u228B", supplus: "\u2AC0", Supset: "\u22D1", supset: "\u2283", supseteq: "\u2287", supseteqq: "\u2AC6", supsetneq: "\u228B", supsetneqq: "\u2ACC", supsim: "\u2AC8", supsub: "\u2AD4", supsup: "\u2AD6", swarhk: "\u2926", swArr: "\u21D9", swarr: "\u2199", swarrow: "\u2199", swnwar: "\u292A", szlig: "\xDF", Tab: "	", target: "\u2316", Tau: "\u03A4", tau: "\u03C4", tbrk: "\u23B4", Tcaron: "\u0164", tcaron: "\u0165", Tcedil: "\u0162", tcedil: "\u0163", Tcy: "\u0422", tcy: "\u0442", tdot: "\u20DB", telrec: "\u2315", Tfr: "\u{1D517}", tfr: "\u{1D531}", there4: "\u2234", Therefore: "\u2234", therefore: "\u2234", Theta: "\u0398", theta: "\u03B8", thetasym: "\u03D1", thetav: "\u03D1", thickapprox: "\u2248", thicksim: "\u223C", ThickSpace: "\u205F\u200A", thinsp: "\u2009", ThinSpace: "\u2009", thkap: "\u2248", thksim: "\u223C", THORN: "\xDE", thorn: "\xFE", Tilde: "\u223C", tilde: "\u02DC", TildeEqual: "\u2243", TildeFullEqual: "\u2245", TildeTilde: "\u2248", times: "\xD7", timesb: "\u22A0", timesbar: "\u2A31", timesd: "\u2A30", tint: "\u222D", toea: "\u2928", top: "\u22A4", topbot: "\u2336", topcir: "\u2AF1", Topf: "\u{1D54B}", topf: "\u{1D565}", topfork: "\u2ADA", tosa: "\u2929", tprime: "\u2034", TRADE: "\u2122", trade: "\u2122", triangle: "\u25B5", triangledown: "\u25BF", triangleleft: "\u25C3", trianglelefteq: "\u22B4", triangleq: "\u225C", triangleright: "\u25B9", trianglerighteq: "\u22B5", tridot: "\u25EC", trie: "\u225C", triminus: "\u2A3A", TripleDot: "\u20DB", triplus: "\u2A39", trisb: "\u29CD", tritime: "\u2A3B", trpezium: "\u23E2", Tscr: "\u{1D4AF}", tscr: "\u{1D4C9}", TScy: "\u0426", tscy: "\u0446", TSHcy: "\u040B", tshcy: "\u045B", Tstrok: "\u0166", tstrok: "\u0167", twixt: "\u226C", twoheadleftarrow: "\u219E", twoheadrightarrow: "\u21A0", Uacute: "\xDA", uacute: "\xFA", Uarr: "\u219F", uArr: "\u21D1", uarr: "\u2191", Uarrocir: "\u2949", Ubrcy: "\u040E", ubrcy: "\u045E", Ubreve: "\u016C", ubreve: "\u016D", Ucirc: "\xDB", ucirc: "\xFB", Ucy: "\u0423", ucy: "\u0443", udarr: "\u21C5", Udblac: "\u0170", udblac: "\u0171", udhar: "\u296E", ufisht: "\u297E", Ufr: "\u{1D518}", ufr: "\u{1D532}", Ugrave: "\xD9", ugrave: "\xF9", uHar: "\u2963", uharl: "\u21BF", uharr: "\u21BE", uhblk: "\u2580", ulcorn: "\u231C", ulcorner: "\u231C", ulcrop: "\u230F", ultri: "\u25F8", Umacr: "\u016A", umacr: "\u016B", uml: "\xA8", UnderBar: "_", UnderBrace: "\u23DF", UnderBracket: "\u23B5", UnderParenthesis: "\u23DD", Union: "\u22C3", UnionPlus: "\u228E", Uogon: "\u0172", uogon: "\u0173", Uopf: "\u{1D54C}", uopf: "\u{1D566}", UpArrow: "\u2191", Uparrow: "\u21D1", uparrow: "\u2191", UpArrowBar: "\u2912", UpArrowDownArrow: "\u21C5", UpDownArrow: "\u2195", Updownarrow: "\u21D5", updownarrow: "\u2195", UpEquilibrium: "\u296E", upharpoonleft: "\u21BF", upharpoonright: "\u21BE", uplus: "\u228E", UpperLeftArrow: "\u2196", UpperRightArrow: "\u2197", Upsi: "\u03D2", upsi: "\u03C5", upsih: "\u03D2", Upsilon: "\u03A5", upsilon: "\u03C5", UpTee: "\u22A5", UpTeeArrow: "\u21A5", upuparrows: "\u21C8", urcorn: "\u231D", urcorner: "\u231D", urcrop: "\u230E", Uring: "\u016E", uring: "\u016F", urtri: "\u25F9", Uscr: "\u{1D4B0}", uscr: "\u{1D4CA}", utdot: "\u22F0", Utilde: "\u0168", utilde: "\u0169", utri: "\u25B5", utrif: "\u25B4", uuarr: "\u21C8", Uuml: "\xDC", uuml: "\xFC", uwangle: "\u29A7", vangrt: "\u299C", varepsilon: "\u03F5", varkappa: "\u03F0", varnothing: "\u2205", varphi: "\u03D5", varpi: "\u03D6", varpropto: "\u221D", vArr: "\u21D5", varr: "\u2195", varrho: "\u03F1", varsigma: "\u03C2", varsubsetneq: "\u228A\uFE00", varsubsetneqq: "\u2ACB\uFE00", varsupsetneq: "\u228B\uFE00", varsupsetneqq: "\u2ACC\uFE00", vartheta: "\u03D1", vartriangleleft: "\u22B2", vartriangleright: "\u22B3", Vbar: "\u2AEB", vBar: "\u2AE8", vBarv: "\u2AE9", Vcy: "\u0412", vcy: "\u0432", VDash: "\u22AB", Vdash: "\u22A9", vDash: "\u22A8", vdash: "\u22A2", Vdashl: "\u2AE6", Vee: "\u22C1", vee: "\u2228", veebar: "\u22BB", veeeq: "\u225A", vellip: "\u22EE", Verbar: "\u2016", verbar: "|", Vert: "\u2016", vert: "|", VerticalBar: "\u2223", VerticalLine: "|", VerticalSeparator: "\u2758", VerticalTilde: "\u2240", VeryThinSpace: "\u200A", Vfr: "\u{1D519}", vfr: "\u{1D533}", vltri: "\u22B2", vnsub: "\u2282\u20D2", vnsup: "\u2283\u20D2", Vopf: "\u{1D54D}", vopf: "\u{1D567}", vprop: "\u221D", vrtri: "\u22B3", Vscr: "\u{1D4B1}", vscr: "\u{1D4CB}", vsubnE: "\u2ACB\uFE00", vsubne: "\u228A\uFE00", vsupnE: "\u2ACC\uFE00", vsupne: "\u228B\uFE00", Vvdash: "\u22AA", vzigzag: "\u299A", Wcirc: "\u0174", wcirc: "\u0175", wedbar: "\u2A5F", Wedge: "\u22C0", wedge: "\u2227", wedgeq: "\u2259", weierp: "\u2118", Wfr: "\u{1D51A}", wfr: "\u{1D534}", Wopf: "\u{1D54E}", wopf: "\u{1D568}", wp: "\u2118", wr: "\u2240", wreath: "\u2240", Wscr: "\u{1D4B2}", wscr: "\u{1D4CC}", xcap: "\u22C2", xcirc: "\u25EF", xcup: "\u22C3", xdtri: "\u25BD", Xfr: "\u{1D51B}", xfr: "\u{1D535}", xhArr: "\u27FA", xharr: "\u27F7", Xi: "\u039E", xi: "\u03BE", xlArr: "\u27F8", xlarr: "\u27F5", xmap: "\u27FC", xnis: "\u22FB", xodot: "\u2A00", Xopf: "\u{1D54F}", xopf: "\u{1D569}", xoplus: "\u2A01", xotime: "\u2A02", xrArr: "\u27F9", xrarr: "\u27F6", Xscr: "\u{1D4B3}", xscr: "\u{1D4CD}", xsqcup: "\u2A06", xuplus: "\u2A04", xutri: "\u25B3", xvee: "\u22C1", xwedge: "\u22C0", Yacute: "\xDD", yacute: "\xFD", YAcy: "\u042F", yacy: "\u044F", Ycirc: "\u0176", ycirc: "\u0177", Ycy: "\u042B", ycy: "\u044B", yen: "\xA5", Yfr: "\u{1D51C}", yfr: "\u{1D536}", YIcy: "\u0407", yicy: "\u0457", Yopf: "\u{1D550}", yopf: "\u{1D56A}", Yscr: "\u{1D4B4}", yscr: "\u{1D4CE}", YUcy: "\u042E", yucy: "\u044E", Yuml: "\u0178", yuml: "\xFF", Zacute: "\u0179", zacute: "\u017A", Zcaron: "\u017D", zcaron: "\u017E", Zcy: "\u0417", zcy: "\u0437", Zdot: "\u017B", zdot: "\u017C", zeetrf: "\u2128", ZeroWidthSpace: "\u200B", Zeta: "\u0396", zeta: "\u03B6", Zfr: "\u2128", zfr: "\u{1D537}", ZHcy: "\u0416", zhcy: "\u0436", zigrarr: "\u21DD", Zopf: "\u2124", zopf: "\u{1D56B}", Zscr: "\u{1D4B5}", zscr: "\u{1D4CF}", zwj: "\u200D", zwnj: "\u200C" }, e.NGSP_UNICODE = "\uE500", e.NAMED_ENTITIES.ngsp = e.NGSP_UNICODE;
          } }), Es = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_tags.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Je(), u = class {
              constructor() {
                let { closedByChildren: i, implicitNamespacePrefix: p, contentType: l = r.TagContentType.PARSABLE_DATA, closedByParent: g = false, isVoid: a = false, ignoreFirstLf: c = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.closedByChildren = {}, this.closedByParent = false, this.canSelfClose = false, i && i.length > 0 && i.forEach((h) => this.closedByChildren[h] = true), this.isVoid = a, this.closedByParent = g || a, this.implicitNamespacePrefix = p || null, this.contentType = l, this.ignoreFirstLf = c;
              }
              isClosedByChild(i) {
                return this.isVoid || i.toLowerCase() in this.closedByChildren;
              }
            };
            e.HtmlTagDefinition = u;
            var s, D;
            function n(i) {
              return D || (s = new u(), D = { base: new u({ isVoid: true }), meta: new u({ isVoid: true }), area: new u({ isVoid: true }), embed: new u({ isVoid: true }), link: new u({ isVoid: true }), img: new u({ isVoid: true }), input: new u({ isVoid: true }), param: new u({ isVoid: true }), hr: new u({ isVoid: true }), br: new u({ isVoid: true }), source: new u({ isVoid: true }), track: new u({ isVoid: true }), wbr: new u({ isVoid: true }), p: new u({ closedByChildren: ["address", "article", "aside", "blockquote", "div", "dl", "fieldset", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "main", "nav", "ol", "p", "pre", "section", "table", "ul"], closedByParent: true }), thead: new u({ closedByChildren: ["tbody", "tfoot"] }), tbody: new u({ closedByChildren: ["tbody", "tfoot"], closedByParent: true }), tfoot: new u({ closedByChildren: ["tbody"], closedByParent: true }), tr: new u({ closedByChildren: ["tr"], closedByParent: true }), td: new u({ closedByChildren: ["td", "th"], closedByParent: true }), th: new u({ closedByChildren: ["td", "th"], closedByParent: true }), col: new u({ isVoid: true }), svg: new u({ implicitNamespacePrefix: "svg" }), math: new u({ implicitNamespacePrefix: "math" }), li: new u({ closedByChildren: ["li"], closedByParent: true }), dt: new u({ closedByChildren: ["dt", "dd"] }), dd: new u({ closedByChildren: ["dt", "dd"], closedByParent: true }), rb: new u({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), rt: new u({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), rtc: new u({ closedByChildren: ["rb", "rtc", "rp"], closedByParent: true }), rp: new u({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), optgroup: new u({ closedByChildren: ["optgroup"], closedByParent: true }), option: new u({ closedByChildren: ["option", "optgroup"], closedByParent: true }), pre: new u({ ignoreFirstLf: true }), listing: new u({ ignoreFirstLf: true }), style: new u({ contentType: r.TagContentType.RAW_TEXT }), script: new u({ contentType: r.TagContentType.RAW_TEXT }), title: new u({ contentType: r.TagContentType.ESCAPABLE_RAW_TEXT }), textarea: new u({ contentType: r.TagContentType.ESCAPABLE_RAW_TEXT, ignoreFirstLf: true }) }), D[i] || s;
            }
            e.getHtmlTagDefinition = n;
          } }), kl = I({ "node_modules/angular-html-parser/lib/compiler/src/ast_path.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = class {
              constructor(u) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
                this.path = u, this.position = s;
              }
              get empty() {
                return !this.path || !this.path.length;
              }
              get head() {
                return this.path[0];
              }
              get tail() {
                return this.path[this.path.length - 1];
              }
              parentOf(u) {
                return u && this.path[this.path.indexOf(u) - 1];
              }
              childOf(u) {
                return this.path[this.path.indexOf(u) + 1];
              }
              first(u) {
                for (let s = this.path.length - 1; s >= 0; s--) {
                  let D = this.path[s];
                  if (D instanceof u)
                    return D;
                }
              }
              push(u) {
                this.path.push(u);
              }
              pop() {
                return this.path.pop();
              }
            };
            e.AstPath = r;
          } }), Cs = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/ast.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = kl(), u = class {
              constructor(d, m, T) {
                this.value = d, this.sourceSpan = m, this.i18n = T, this.type = "text";
              }
              visit(d, m) {
                return d.visitText(this, m);
              }
            };
            e.Text = u;
            var s = class {
              constructor(d, m) {
                this.value = d, this.sourceSpan = m, this.type = "cdata";
              }
              visit(d, m) {
                return d.visitCdata(this, m);
              }
            };
            e.CDATA = s;
            var D = class {
              constructor(d, m, T, B, A, N) {
                this.switchValue = d, this.type = m, this.cases = T, this.sourceSpan = B, this.switchValueSourceSpan = A, this.i18n = N;
              }
              visit(d, m) {
                return d.visitExpansion(this, m);
              }
            };
            e.Expansion = D;
            var n = class {
              constructor(d, m, T, B, A) {
                this.value = d, this.expression = m, this.sourceSpan = T, this.valueSourceSpan = B, this.expSourceSpan = A;
              }
              visit(d, m) {
                return d.visitExpansionCase(this, m);
              }
            };
            e.ExpansionCase = n;
            var i = class {
              constructor(d, m, T) {
                let B = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, N = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
                this.name = d, this.value = m, this.sourceSpan = T, this.valueSpan = B, this.nameSpan = A, this.i18n = N, this.type = "attribute";
              }
              visit(d, m) {
                return d.visitAttribute(this, m);
              }
            };
            e.Attribute = i;
            var p = class {
              constructor(d, m, T, B) {
                let A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, N = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, R = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, j = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
                this.name = d, this.attrs = m, this.children = T, this.sourceSpan = B, this.startSourceSpan = A, this.endSourceSpan = N, this.nameSpan = R, this.i18n = j, this.type = "element";
              }
              visit(d, m) {
                return d.visitElement(this, m);
              }
            };
            e.Element = p;
            var l = class {
              constructor(d, m) {
                this.value = d, this.sourceSpan = m, this.type = "comment";
              }
              visit(d, m) {
                return d.visitComment(this, m);
              }
            };
            e.Comment = l;
            var g = class {
              constructor(d, m) {
                this.value = d, this.sourceSpan = m, this.type = "docType";
              }
              visit(d, m) {
                return d.visitDocType(this, m);
              }
            };
            e.DocType = g;
            function a(d, m) {
              let T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, B = [], A = d.visit ? (N) => d.visit(N, T) || N.visit(d, T) : (N) => N.visit(d, T);
              return m.forEach((N) => {
                let R = A(N);
                R && B.push(R);
              }), B;
            }
            e.visitAll = a;
            var c = class {
              constructor() {
              }
              visitElement(d, m) {
                this.visitChildren(m, (T) => {
                  T(d.attrs), T(d.children);
                });
              }
              visitAttribute(d, m) {
              }
              visitText(d, m) {
              }
              visitCdata(d, m) {
              }
              visitComment(d, m) {
              }
              visitDocType(d, m) {
              }
              visitExpansion(d, m) {
                return this.visitChildren(m, (T) => {
                  T(d.cases);
                });
              }
              visitExpansionCase(d, m) {
              }
              visitChildren(d, m) {
                let T = [], B = this;
                function A(N) {
                  N && T.push(a(B, N, d));
                }
                return m(A), Array.prototype.concat.apply([], T);
              }
            };
            e.RecursiveVisitor = c;
            function h(d) {
              let m = d.sourceSpan.start.offset, T = d.sourceSpan.end.offset;
              return d instanceof p && (d.endSourceSpan ? T = d.endSourceSpan.end.offset : d.children && d.children.length && (T = h(d.children[d.children.length - 1]).end)), { start: m, end: T };
            }
            function C(d, m) {
              let T = [], B = new class extends c {
                visit(A, N) {
                  let R = h(A);
                  if (R.start <= m && m < R.end)
                    T.push(A);
                  else
                    return true;
                }
              }();
              return a(B, d), new r.AstPath(T, m);
            }
            e.findNode = C;
          } }), Ll = I({ "node_modules/angular-html-parser/lib/compiler/src/assertions.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            function r(D, n) {
              if (n != null) {
                if (!Array.isArray(n))
                  throw new Error(`Expected '${D}' to be an array of strings.`);
                for (let i = 0; i < n.length; i += 1)
                  if (typeof n[i] != "string")
                    throw new Error(`Expected '${D}' to be an array of strings.`);
              }
            }
            e.assertArrayOfStrings = r;
            var u = [/^\s*$/, /[<>]/, /^[{}]$/, /&(#|[a-z])/i, /^\/\//];
            function s(D, n) {
              if (n != null && !(Array.isArray(n) && n.length == 2))
                throw new Error(`Expected '${D}' to be an array, [start, end].`);
              if (n != null) {
                let i = n[0], p = n[1];
                u.forEach((l) => {
                  if (l.test(i) || l.test(p))
                    throw new Error(`['${i}', '${p}'] contains unusable interpolation symbol.`);
                });
              }
            }
            e.assertInterpolationSymbols = s;
          } }), $l = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/interpolation_config.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Ll(), u = class {
              constructor(s, D) {
                this.start = s, this.end = D;
              }
              static fromArray(s) {
                return s ? (r.assertInterpolationSymbols("interpolation", s), new u(s[0], s[1])) : e.DEFAULT_INTERPOLATION_CONFIG;
              }
            };
            e.InterpolationConfig = u, e.DEFAULT_INTERPOLATION_CONFIG = new u("{{", "}}");
          } }), Ml = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/lexer.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = ss(), u = ye(), s = $l(), D = Je(), n;
            (function(t3) {
              t3[t3.TAG_OPEN_START = 0] = "TAG_OPEN_START", t3[t3.TAG_OPEN_END = 1] = "TAG_OPEN_END", t3[t3.TAG_OPEN_END_VOID = 2] = "TAG_OPEN_END_VOID", t3[t3.TAG_CLOSE = 3] = "TAG_CLOSE", t3[t3.TEXT = 4] = "TEXT", t3[t3.ESCAPABLE_RAW_TEXT = 5] = "ESCAPABLE_RAW_TEXT", t3[t3.RAW_TEXT = 6] = "RAW_TEXT", t3[t3.COMMENT_START = 7] = "COMMENT_START", t3[t3.COMMENT_END = 8] = "COMMENT_END", t3[t3.CDATA_START = 9] = "CDATA_START", t3[t3.CDATA_END = 10] = "CDATA_END", t3[t3.ATTR_NAME = 11] = "ATTR_NAME", t3[t3.ATTR_QUOTE = 12] = "ATTR_QUOTE", t3[t3.ATTR_VALUE = 13] = "ATTR_VALUE", t3[t3.DOC_TYPE_START = 14] = "DOC_TYPE_START", t3[t3.DOC_TYPE_END = 15] = "DOC_TYPE_END", t3[t3.EXPANSION_FORM_START = 16] = "EXPANSION_FORM_START", t3[t3.EXPANSION_CASE_VALUE = 17] = "EXPANSION_CASE_VALUE", t3[t3.EXPANSION_CASE_EXP_START = 18] = "EXPANSION_CASE_EXP_START", t3[t3.EXPANSION_CASE_EXP_END = 19] = "EXPANSION_CASE_EXP_END", t3[t3.EXPANSION_FORM_END = 20] = "EXPANSION_FORM_END", t3[t3.EOF = 21] = "EOF";
            })(n = e.TokenType || (e.TokenType = {}));
            var i = class {
              constructor(t3, o, E) {
                this.type = t3, this.parts = o, this.sourceSpan = E;
              }
            };
            e.Token = i;
            var p = class extends u.ParseError {
              constructor(t3, o, E) {
                super(E, t3), this.tokenType = o;
              }
            };
            e.TokenError = p;
            var l = class {
              constructor(t3, o) {
                this.tokens = t3, this.errors = o;
              }
            };
            e.TokenizeResult = l;
            function g(t3, o, E) {
              let f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
              return new d(new u.ParseSourceFile(t3, o), E, f).tokenize();
            }
            e.tokenize = g;
            var a = /\r\n?/g;
            function c(t3) {
              return `Unexpected character "${t3 === r.$EOF ? "EOF" : String.fromCharCode(t3)}"`;
            }
            function h(t3) {
              return `Unknown entity "${t3}" - use the "&#<decimal>;" or  "&#x<hex>;" syntax`;
            }
            var C = class {
              constructor(t3) {
                this.error = t3;
              }
            }, d = class {
              constructor(t3, o, E) {
                this._getTagContentType = o, this._currentTokenStart = null, this._currentTokenType = null, this._expansionCaseStack = [], this._inInterpolation = false, this._fullNameStack = [], this.tokens = [], this.errors = [], this._tokenizeIcu = E.tokenizeExpansionForms || false, this._interpolationConfig = E.interpolationConfig || s.DEFAULT_INTERPOLATION_CONFIG, this._leadingTriviaCodePoints = E.leadingTriviaChars && E.leadingTriviaChars.map((F) => F.codePointAt(0) || 0), this._canSelfClose = E.canSelfClose || false, this._allowHtmComponentClosingTags = E.allowHtmComponentClosingTags || false;
                let f = E.range || { endPos: t3.content.length, startPos: 0, startLine: 0, startCol: 0 };
                this._cursor = E.escapedString ? new k(t3, f) : new x(t3, f);
                try {
                  this._cursor.init();
                } catch (F) {
                  this.handleError(F);
                }
              }
              _processCarriageReturns(t3) {
                return t3.replace(a, `
`);
              }
              tokenize() {
                for (; this._cursor.peek() !== r.$EOF; ) {
                  let t3 = this._cursor.clone();
                  try {
                    if (this._attemptCharCode(r.$LT))
                      if (this._attemptCharCode(r.$BANG))
                        this._attemptStr("[CDATA[") ? this._consumeCdata(t3) : this._attemptStr("--") ? this._consumeComment(t3) : this._attemptStrCaseInsensitive("doctype") ? this._consumeDocType(t3) : this._consumeBogusComment(t3);
                      else if (this._attemptCharCode(r.$SLASH))
                        this._consumeTagClose(t3);
                      else {
                        let o = this._cursor.clone();
                        this._attemptCharCode(r.$QUESTION) ? (this._cursor = o, this._consumeBogusComment(t3)) : this._consumeTagOpen(t3);
                      }
                    else
                      this._tokenizeIcu && this._tokenizeExpansionForm() || this._consumeText();
                  } catch (o) {
                    this.handleError(o);
                  }
                }
                return this._beginToken(n.EOF), this._endToken([]), new l(O(this.tokens), this.errors);
              }
              _tokenizeExpansionForm() {
                if (this.isExpansionFormStart())
                  return this._consumeExpansionFormStart(), true;
                if (R(this._cursor.peek()) && this._isInExpansionForm())
                  return this._consumeExpansionCaseStart(), true;
                if (this._cursor.peek() === r.$RBRACE) {
                  if (this._isInExpansionCase())
                    return this._consumeExpansionCaseEnd(), true;
                  if (this._isInExpansionForm())
                    return this._consumeExpansionFormEnd(), true;
                }
                return false;
              }
              _beginToken(t3) {
                let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
                this._currentTokenStart = o, this._currentTokenType = t3;
              }
              _endToken(t3) {
                let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
                if (this._currentTokenStart === null)
                  throw new p("Programming error - attempted to end a token when there was no start to the token", this._currentTokenType, this._cursor.getSpan(o));
                if (this._currentTokenType === null)
                  throw new p("Programming error - attempted to end a token which has no token type", null, this._cursor.getSpan(this._currentTokenStart));
                let E = new i(this._currentTokenType, t3, this._cursor.getSpan(this._currentTokenStart, this._leadingTriviaCodePoints));
                return this.tokens.push(E), this._currentTokenStart = null, this._currentTokenType = null, E;
              }
              _createError(t3, o) {
                this._isInExpansionForm() && (t3 += ` (Do you have an unescaped "{" in your template? Use "{{ '{' }}") to escape it.)`);
                let E = new p(t3, this._currentTokenType, o);
                return this._currentTokenStart = null, this._currentTokenType = null, new C(E);
              }
              handleError(t3) {
                if (t3 instanceof $ && (t3 = this._createError(t3.msg, this._cursor.getSpan(t3.cursor))), t3 instanceof C)
                  this.errors.push(t3.error);
                else
                  throw t3;
              }
              _attemptCharCode(t3) {
                return this._cursor.peek() === t3 ? (this._cursor.advance(), true) : false;
              }
              _attemptCharCodeCaseInsensitive(t3) {
                return j(this._cursor.peek(), t3) ? (this._cursor.advance(), true) : false;
              }
              _requireCharCode(t3) {
                let o = this._cursor.clone();
                if (!this._attemptCharCode(t3))
                  throw this._createError(c(this._cursor.peek()), this._cursor.getSpan(o));
              }
              _attemptStr(t3) {
                let o = t3.length;
                if (this._cursor.charsLeft() < o)
                  return false;
                let E = this._cursor.clone();
                for (let f = 0; f < o; f++)
                  if (!this._attemptCharCode(t3.charCodeAt(f)))
                    return this._cursor = E, false;
                return true;
              }
              _attemptStrCaseInsensitive(t3) {
                for (let o = 0; o < t3.length; o++)
                  if (!this._attemptCharCodeCaseInsensitive(t3.charCodeAt(o)))
                    return false;
                return true;
              }
              _requireStr(t3) {
                let o = this._cursor.clone();
                if (!this._attemptStr(t3))
                  throw this._createError(c(this._cursor.peek()), this._cursor.getSpan(o));
              }
              _requireStrCaseInsensitive(t3) {
                let o = this._cursor.clone();
                if (!this._attemptStrCaseInsensitive(t3))
                  throw this._createError(c(this._cursor.peek()), this._cursor.getSpan(o));
              }
              _attemptCharCodeUntilFn(t3) {
                for (; !t3(this._cursor.peek()); )
                  this._cursor.advance();
              }
              _requireCharCodeUntilFn(t3, o) {
                let E = this._cursor.clone();
                if (this._attemptCharCodeUntilFn(t3), this._cursor.clone().diff(E) < o)
                  throw this._createError(c(this._cursor.peek()), this._cursor.getSpan(E));
              }
              _attemptUntilChar(t3) {
                for (; this._cursor.peek() !== t3; )
                  this._cursor.advance();
              }
              _readChar(t3) {
                if (t3 && this._cursor.peek() === r.$AMPERSAND)
                  return this._decodeEntity();
                {
                  let o = String.fromCodePoint(this._cursor.peek());
                  return this._cursor.advance(), o;
                }
              }
              _decodeEntity() {
                let t3 = this._cursor.clone();
                if (this._cursor.advance(), this._attemptCharCode(r.$HASH)) {
                  let o = this._attemptCharCode(r.$x) || this._attemptCharCode(r.$X), E = this._cursor.clone();
                  if (this._attemptCharCodeUntilFn(A), this._cursor.peek() != r.$SEMICOLON)
                    throw this._createError(c(this._cursor.peek()), this._cursor.getSpan());
                  let f = this._cursor.getChars(E);
                  this._cursor.advance();
                  try {
                    let F = parseInt(f, o ? 16 : 10);
                    return String.fromCharCode(F);
                  } catch {
                    throw this._createError(h(this._cursor.getChars(t3)), this._cursor.getSpan());
                  }
                } else {
                  let o = this._cursor.clone();
                  if (this._attemptCharCodeUntilFn(N), this._cursor.peek() != r.$SEMICOLON)
                    return this._cursor = o, "&";
                  let E = this._cursor.getChars(o);
                  this._cursor.advance();
                  let f = D.NAMED_ENTITIES[E];
                  if (!f)
                    throw this._createError(h(E), this._cursor.getSpan(t3));
                  return f;
                }
              }
              _consumeRawText(t3, o) {
                this._beginToken(t3 ? n.ESCAPABLE_RAW_TEXT : n.RAW_TEXT);
                let E = [];
                for (; ; ) {
                  let f = this._cursor.clone(), F = o();
                  if (this._cursor = f, F)
                    break;
                  E.push(this._readChar(t3));
                }
                return this._endToken([this._processCarriageReturns(E.join(""))]);
              }
              _consumeComment(t3) {
                this._beginToken(n.COMMENT_START, t3), this._endToken([]), this._consumeRawText(false, () => this._attemptStr("-->")), this._beginToken(n.COMMENT_END), this._requireStr("-->"), this._endToken([]);
              }
              _consumeBogusComment(t3) {
                this._beginToken(n.COMMENT_START, t3), this._endToken([]), this._consumeRawText(false, () => this._cursor.peek() === r.$GT), this._beginToken(n.COMMENT_END), this._cursor.advance(), this._endToken([]);
              }
              _consumeCdata(t3) {
                this._beginToken(n.CDATA_START, t3), this._endToken([]), this._consumeRawText(false, () => this._attemptStr("]]>")), this._beginToken(n.CDATA_END), this._requireStr("]]>"), this._endToken([]);
              }
              _consumeDocType(t3) {
                this._beginToken(n.DOC_TYPE_START, t3), this._endToken([]), this._consumeRawText(false, () => this._cursor.peek() === r.$GT), this._beginToken(n.DOC_TYPE_END), this._cursor.advance(), this._endToken([]);
              }
              _consumePrefixAndName() {
                let t3 = this._cursor.clone(), o = "";
                for (; this._cursor.peek() !== r.$COLON && !B(this._cursor.peek()); )
                  this._cursor.advance();
                let E;
                this._cursor.peek() === r.$COLON ? (o = this._cursor.getChars(t3), this._cursor.advance(), E = this._cursor.clone()) : E = t3, this._requireCharCodeUntilFn(T, o === "" ? 0 : 1);
                let f = this._cursor.getChars(E);
                return [o, f];
              }
              _consumeTagOpen(t3) {
                let o, E, f, F = this.tokens.length, P = this._cursor.clone(), M = [];
                try {
                  if (!r.isAsciiLetter(this._cursor.peek()))
                    throw this._createError(c(this._cursor.peek()), this._cursor.getSpan(t3));
                  for (f = this._consumeTagOpenStart(t3), E = f.parts[0], o = f.parts[1], this._attemptCharCodeUntilFn(m); this._cursor.peek() !== r.$SLASH && this._cursor.peek() !== r.$GT; ) {
                    let [X, H] = this._consumeAttributeName();
                    if (this._attemptCharCodeUntilFn(m), this._attemptCharCode(r.$EQ)) {
                      this._attemptCharCodeUntilFn(m);
                      let z = this._consumeAttributeValue();
                      M.push({ prefix: X, name: H, value: z });
                    } else
                      M.push({ prefix: X, name: H });
                    this._attemptCharCodeUntilFn(m);
                  }
                  this._consumeTagOpenEnd();
                } catch (X) {
                  if (X instanceof C) {
                    this._cursor = P, f && (this.tokens.length = F), this._beginToken(n.TEXT, t3), this._endToken(["<"]);
                    return;
                  }
                  throw X;
                }
                if (this._canSelfClose && this.tokens[this.tokens.length - 1].type === n.TAG_OPEN_END_VOID)
                  return;
                let W = this._getTagContentType(o, E, this._fullNameStack.length > 0, M);
                this._handleFullNameStackForTagOpen(E, o), W === D.TagContentType.RAW_TEXT ? this._consumeRawTextWithTagClose(E, o, false) : W === D.TagContentType.ESCAPABLE_RAW_TEXT && this._consumeRawTextWithTagClose(E, o, true);
              }
              _consumeRawTextWithTagClose(t3, o, E) {
                let f = this._consumeRawText(E, () => !this._attemptCharCode(r.$LT) || !this._attemptCharCode(r.$SLASH) || (this._attemptCharCodeUntilFn(m), !this._attemptStrCaseInsensitive(t3 ? `${t3}:${o}` : o)) ? false : (this._attemptCharCodeUntilFn(m), this._attemptCharCode(r.$GT)));
                this._beginToken(n.TAG_CLOSE), this._requireCharCodeUntilFn((F) => F === r.$GT, 3), this._cursor.advance(), this._endToken([t3, o]), this._handleFullNameStackForTagClose(t3, o);
              }
              _consumeTagOpenStart(t3) {
                this._beginToken(n.TAG_OPEN_START, t3);
                let o = this._consumePrefixAndName();
                return this._endToken(o);
              }
              _consumeAttributeName() {
                let t3 = this._cursor.peek();
                if (t3 === r.$SQ || t3 === r.$DQ)
                  throw this._createError(c(t3), this._cursor.getSpan());
                this._beginToken(n.ATTR_NAME);
                let o = this._consumePrefixAndName();
                return this._endToken(o), o;
              }
              _consumeAttributeValue() {
                let t3;
                if (this._cursor.peek() === r.$SQ || this._cursor.peek() === r.$DQ) {
                  this._beginToken(n.ATTR_QUOTE);
                  let o = this._cursor.peek();
                  this._cursor.advance(), this._endToken([String.fromCodePoint(o)]), this._beginToken(n.ATTR_VALUE);
                  let E = [];
                  for (; this._cursor.peek() !== o; )
                    E.push(this._readChar(true));
                  t3 = this._processCarriageReturns(E.join("")), this._endToken([t3]), this._beginToken(n.ATTR_QUOTE), this._cursor.advance(), this._endToken([String.fromCodePoint(o)]);
                } else {
                  this._beginToken(n.ATTR_VALUE);
                  let o = this._cursor.clone();
                  this._requireCharCodeUntilFn(T, 1), t3 = this._processCarriageReturns(this._cursor.getChars(o)), this._endToken([t3]);
                }
                return t3;
              }
              _consumeTagOpenEnd() {
                let t3 = this._attemptCharCode(r.$SLASH) ? n.TAG_OPEN_END_VOID : n.TAG_OPEN_END;
                this._beginToken(t3), this._requireCharCode(r.$GT), this._endToken([]);
              }
              _consumeTagClose(t3) {
                if (this._beginToken(n.TAG_CLOSE, t3), this._attemptCharCodeUntilFn(m), this._allowHtmComponentClosingTags && this._attemptCharCode(r.$SLASH))
                  this._attemptCharCodeUntilFn(m), this._requireCharCode(r.$GT), this._endToken([]);
                else {
                  let [o, E] = this._consumePrefixAndName();
                  this._attemptCharCodeUntilFn(m), this._requireCharCode(r.$GT), this._endToken([o, E]), this._handleFullNameStackForTagClose(o, E);
                }
              }
              _consumeExpansionFormStart() {
                this._beginToken(n.EXPANSION_FORM_START), this._requireCharCode(r.$LBRACE), this._endToken([]), this._expansionCaseStack.push(n.EXPANSION_FORM_START), this._beginToken(n.RAW_TEXT);
                let t3 = this._readUntil(r.$COMMA);
                this._endToken([t3]), this._requireCharCode(r.$COMMA), this._attemptCharCodeUntilFn(m), this._beginToken(n.RAW_TEXT);
                let o = this._readUntil(r.$COMMA);
                this._endToken([o]), this._requireCharCode(r.$COMMA), this._attemptCharCodeUntilFn(m);
              }
              _consumeExpansionCaseStart() {
                this._beginToken(n.EXPANSION_CASE_VALUE);
                let t3 = this._readUntil(r.$LBRACE).trim();
                this._endToken([t3]), this._attemptCharCodeUntilFn(m), this._beginToken(n.EXPANSION_CASE_EXP_START), this._requireCharCode(r.$LBRACE), this._endToken([]), this._attemptCharCodeUntilFn(m), this._expansionCaseStack.push(n.EXPANSION_CASE_EXP_START);
              }
              _consumeExpansionCaseEnd() {
                this._beginToken(n.EXPANSION_CASE_EXP_END), this._requireCharCode(r.$RBRACE), this._endToken([]), this._attemptCharCodeUntilFn(m), this._expansionCaseStack.pop();
              }
              _consumeExpansionFormEnd() {
                this._beginToken(n.EXPANSION_FORM_END), this._requireCharCode(r.$RBRACE), this._endToken([]), this._expansionCaseStack.pop();
              }
              _consumeText() {
                let t3 = this._cursor.clone();
                this._beginToken(n.TEXT, t3);
                let o = [];
                do
                  this._interpolationConfig && this._attemptStr(this._interpolationConfig.start) ? (o.push(this._interpolationConfig.start), this._inInterpolation = true) : this._interpolationConfig && this._inInterpolation && this._attemptStr(this._interpolationConfig.end) ? (o.push(this._interpolationConfig.end), this._inInterpolation = false) : o.push(this._readChar(true));
                while (!this._isTextEnd());
                this._endToken([this._processCarriageReturns(o.join(""))]);
              }
              _isTextEnd() {
                return !!(this._cursor.peek() === r.$LT || this._cursor.peek() === r.$EOF || this._tokenizeIcu && !this._inInterpolation && (this.isExpansionFormStart() || this._cursor.peek() === r.$RBRACE && this._isInExpansionCase()));
              }
              _readUntil(t3) {
                let o = this._cursor.clone();
                return this._attemptUntilChar(t3), this._cursor.getChars(o);
              }
              _isInExpansionCase() {
                return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === n.EXPANSION_CASE_EXP_START;
              }
              _isInExpansionForm() {
                return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === n.EXPANSION_FORM_START;
              }
              isExpansionFormStart() {
                if (this._cursor.peek() !== r.$LBRACE)
                  return false;
                if (this._interpolationConfig) {
                  let t3 = this._cursor.clone(), o = this._attemptStr(this._interpolationConfig.start);
                  return this._cursor = t3, !o;
                }
                return true;
              }
              _handleFullNameStackForTagOpen(t3, o) {
                let E = D.mergeNsAndName(t3, o);
                (this._fullNameStack.length === 0 || this._fullNameStack[this._fullNameStack.length - 1] === E) && this._fullNameStack.push(E);
              }
              _handleFullNameStackForTagClose(t3, o) {
                let E = D.mergeNsAndName(t3, o);
                this._fullNameStack.length !== 0 && this._fullNameStack[this._fullNameStack.length - 1] === E && this._fullNameStack.pop();
              }
            };
            function m(t3) {
              return !r.isWhitespace(t3) || t3 === r.$EOF;
            }
            function T(t3) {
              return r.isWhitespace(t3) || t3 === r.$GT || t3 === r.$SLASH || t3 === r.$SQ || t3 === r.$DQ || t3 === r.$EQ;
            }
            function B(t3) {
              return (t3 < r.$a || r.$z < t3) && (t3 < r.$A || r.$Z < t3) && (t3 < r.$0 || t3 > r.$9);
            }
            function A(t3) {
              return t3 == r.$SEMICOLON || t3 == r.$EOF || !r.isAsciiHexDigit(t3);
            }
            function N(t3) {
              return t3 == r.$SEMICOLON || t3 == r.$EOF || !r.isAsciiLetter(t3);
            }
            function R(t3) {
              return t3 === r.$EQ || r.isAsciiLetter(t3) || r.isDigit(t3);
            }
            function j(t3, o) {
              return _(t3) == _(o);
            }
            function _(t3) {
              return t3 >= r.$a && t3 <= r.$z ? t3 - r.$a + r.$A : t3;
            }
            function O(t3) {
              let o = [], E;
              for (let f = 0; f < t3.length; f++) {
                let F = t3[f];
                E && E.type == n.TEXT && F.type == n.TEXT ? (E.parts[0] += F.parts[0], E.sourceSpan.end = F.sourceSpan.end) : (E = F, o.push(E));
              }
              return o;
            }
            var x = class {
              constructor(t3, o) {
                if (t3 instanceof x)
                  this.file = t3.file, this.input = t3.input, this.end = t3.end, this.state = Object.assign({}, t3.state);
                else {
                  if (!o)
                    throw new Error("Programming error: the range argument must be provided with a file argument.");
                  this.file = t3, this.input = t3.content, this.end = o.endPos, this.state = { peek: -1, offset: o.startPos, line: o.startLine, column: o.startCol };
                }
              }
              clone() {
                return new x(this);
              }
              peek() {
                return this.state.peek;
              }
              charsLeft() {
                return this.end - this.state.offset;
              }
              diff(t3) {
                return this.state.offset - t3.state.offset;
              }
              advance() {
                this.advanceState(this.state);
              }
              init() {
                this.updatePeek(this.state);
              }
              getSpan(t3, o) {
                if (t3 = t3 || this, o)
                  for (t3 = t3.clone(); this.diff(t3) > 0 && o.indexOf(t3.peek()) !== -1; )
                    t3.advance();
                return new u.ParseSourceSpan(new u.ParseLocation(t3.file, t3.state.offset, t3.state.line, t3.state.column), new u.ParseLocation(this.file, this.state.offset, this.state.line, this.state.column));
              }
              getChars(t3) {
                return this.input.substring(t3.state.offset, this.state.offset);
              }
              charAt(t3) {
                return this.input.charCodeAt(t3);
              }
              advanceState(t3) {
                if (t3.offset >= this.end)
                  throw this.state = t3, new $('Unexpected character "EOF"', this);
                let o = this.charAt(t3.offset);
                o === r.$LF ? (t3.line++, t3.column = 0) : r.isNewLine(o) || t3.column++, t3.offset++, this.updatePeek(t3);
              }
              updatePeek(t3) {
                t3.peek = t3.offset >= this.end ? r.$EOF : this.charAt(t3.offset);
              }
            }, k = class extends x {
              constructor(t3, o) {
                t3 instanceof k ? (super(t3), this.internalState = Object.assign({}, t3.internalState)) : (super(t3, o), this.internalState = this.state);
              }
              advance() {
                this.state = this.internalState, super.advance(), this.processEscapeSequence();
              }
              init() {
                super.init(), this.processEscapeSequence();
              }
              clone() {
                return new k(this);
              }
              getChars(t3) {
                let o = t3.clone(), E = "";
                for (; o.internalState.offset < this.internalState.offset; )
                  E += String.fromCodePoint(o.peek()), o.advance();
                return E;
              }
              processEscapeSequence() {
                let t3 = () => this.internalState.peek;
                if (t3() === r.$BACKSLASH)
                  if (this.internalState = Object.assign({}, this.state), this.advanceState(this.internalState), t3() === r.$n)
                    this.state.peek = r.$LF;
                  else if (t3() === r.$r)
                    this.state.peek = r.$CR;
                  else if (t3() === r.$v)
                    this.state.peek = r.$VTAB;
                  else if (t3() === r.$t)
                    this.state.peek = r.$TAB;
                  else if (t3() === r.$b)
                    this.state.peek = r.$BSPACE;
                  else if (t3() === r.$f)
                    this.state.peek = r.$FF;
                  else if (t3() === r.$u)
                    if (this.advanceState(this.internalState), t3() === r.$LBRACE) {
                      this.advanceState(this.internalState);
                      let o = this.clone(), E = 0;
                      for (; t3() !== r.$RBRACE; )
                        this.advanceState(this.internalState), E++;
                      this.state.peek = this.decodeHexDigits(o, E);
                    } else {
                      let o = this.clone();
                      this.advanceState(this.internalState), this.advanceState(this.internalState), this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(o, 4);
                    }
                  else if (t3() === r.$x) {
                    this.advanceState(this.internalState);
                    let o = this.clone();
                    this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(o, 2);
                  } else if (r.isOctalDigit(t3())) {
                    let o = "", E = 0, f = this.clone();
                    for (; r.isOctalDigit(t3()) && E < 3; )
                      f = this.clone(), o += String.fromCodePoint(t3()), this.advanceState(this.internalState), E++;
                    this.state.peek = parseInt(o, 8), this.internalState = f.internalState;
                  } else
                    r.isNewLine(this.internalState.peek) ? (this.advanceState(this.internalState), this.state = this.internalState) : this.state.peek = this.internalState.peek;
              }
              decodeHexDigits(t3, o) {
                let E = this.input.substr(t3.internalState.offset, o), f = parseInt(E, 16);
                if (isNaN(f))
                  throw t3.state = t3.internalState, new $("Invalid hexadecimal escape sequence", t3);
                return f;
              }
            }, $ = class {
              constructor(t3, o) {
                this.msg = t3, this.cursor = o;
              }
            };
            e.CursorError = $;
          } }), Zn = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/parser.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = ye(), u = Cs(), s = Ml(), D = Je(), n = class extends r.ParseError {
              constructor(a, c, h) {
                super(c, h), this.elementName = a;
              }
              static create(a, c, h) {
                return new n(a, c, h);
              }
            };
            e.TreeError = n;
            var i = class {
              constructor(a, c) {
                this.rootNodes = a, this.errors = c;
              }
            };
            e.ParseTreeResult = i;
            var p = class {
              constructor(a) {
                this.getTagDefinition = a;
              }
              parse(a, c, h) {
                let C = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, d = arguments.length > 4 ? arguments[4] : void 0, m = (x) => function(k) {
                  for (var $ = arguments.length, t3 = new Array($ > 1 ? $ - 1 : 0), o = 1; o < $; o++)
                    t3[o - 1] = arguments[o];
                  return x(k.toLowerCase(), ...t3);
                }, T = C ? this.getTagDefinition : m(this.getTagDefinition), B = (x) => T(x).contentType, A = C ? d : m(d), N = d ? (x, k, $, t3) => {
                  let o = A(x, k, $, t3);
                  return o !== void 0 ? o : B(x);
                } : B, R = s.tokenize(a, c, N, h), j = h && h.canSelfClose || false, _ = h && h.allowHtmComponentClosingTags || false, O = new l(R.tokens, T, j, _, C).build();
                return new i(O.rootNodes, R.errors.concat(O.errors));
              }
            };
            e.Parser = p;
            var l = class {
              constructor(a, c, h, C, d) {
                this.tokens = a, this.getTagDefinition = c, this.canSelfClose = h, this.allowHtmComponentClosingTags = C, this.isTagNameCaseSensitive = d, this._index = -1, this._rootNodes = [], this._errors = [], this._elementStack = [], this._advance();
              }
              build() {
                for (; this._peek.type !== s.TokenType.EOF; )
                  this._peek.type === s.TokenType.TAG_OPEN_START ? this._consumeStartTag(this._advance()) : this._peek.type === s.TokenType.TAG_CLOSE ? (this._closeVoidElement(), this._consumeEndTag(this._advance())) : this._peek.type === s.TokenType.CDATA_START ? (this._closeVoidElement(), this._consumeCdata(this._advance())) : this._peek.type === s.TokenType.COMMENT_START ? (this._closeVoidElement(), this._consumeComment(this._advance())) : this._peek.type === s.TokenType.TEXT || this._peek.type === s.TokenType.RAW_TEXT || this._peek.type === s.TokenType.ESCAPABLE_RAW_TEXT ? (this._closeVoidElement(), this._consumeText(this._advance())) : this._peek.type === s.TokenType.EXPANSION_FORM_START ? this._consumeExpansion(this._advance()) : this._peek.type === s.TokenType.DOC_TYPE_START ? this._consumeDocType(this._advance()) : this._advance();
                return new i(this._rootNodes, this._errors);
              }
              _advance() {
                let a = this._peek;
                return this._index < this.tokens.length - 1 && this._index++, this._peek = this.tokens[this._index], a;
              }
              _advanceIf(a) {
                return this._peek.type === a ? this._advance() : null;
              }
              _consumeCdata(a) {
                let c = this._advance(), h = this._getText(c), C = this._advanceIf(s.TokenType.CDATA_END);
                this._addToParent(new u.CDATA(h, new r.ParseSourceSpan(a.sourceSpan.start, (C || c).sourceSpan.end)));
              }
              _consumeComment(a) {
                let c = this._advanceIf(s.TokenType.RAW_TEXT), h = this._advanceIf(s.TokenType.COMMENT_END), C = c != null ? c.parts[0].trim() : null, d = new r.ParseSourceSpan(a.sourceSpan.start, (h || c || a).sourceSpan.end);
                this._addToParent(new u.Comment(C, d));
              }
              _consumeDocType(a) {
                let c = this._advanceIf(s.TokenType.RAW_TEXT), h = this._advanceIf(s.TokenType.DOC_TYPE_END), C = c != null ? c.parts[0].trim() : null, d = new r.ParseSourceSpan(a.sourceSpan.start, (h || c || a).sourceSpan.end);
                this._addToParent(new u.DocType(C, d));
              }
              _consumeExpansion(a) {
                let c = this._advance(), h = this._advance(), C = [];
                for (; this._peek.type === s.TokenType.EXPANSION_CASE_VALUE; ) {
                  let m = this._parseExpansionCase();
                  if (!m)
                    return;
                  C.push(m);
                }
                if (this._peek.type !== s.TokenType.EXPANSION_FORM_END) {
                  this._errors.push(n.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '}'."));
                  return;
                }
                let d = new r.ParseSourceSpan(a.sourceSpan.start, this._peek.sourceSpan.end);
                this._addToParent(new u.Expansion(c.parts[0], h.parts[0], C, d, c.sourceSpan)), this._advance();
              }
              _parseExpansionCase() {
                let a = this._advance();
                if (this._peek.type !== s.TokenType.EXPANSION_CASE_EXP_START)
                  return this._errors.push(n.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '{'.")), null;
                let c = this._advance(), h = this._collectExpansionExpTokens(c);
                if (!h)
                  return null;
                let C = this._advance();
                h.push(new s.Token(s.TokenType.EOF, [], C.sourceSpan));
                let d = new l(h, this.getTagDefinition, this.canSelfClose, this.allowHtmComponentClosingTags, this.isTagNameCaseSensitive).build();
                if (d.errors.length > 0)
                  return this._errors = this._errors.concat(d.errors), null;
                let m = new r.ParseSourceSpan(a.sourceSpan.start, C.sourceSpan.end), T = new r.ParseSourceSpan(c.sourceSpan.start, C.sourceSpan.end);
                return new u.ExpansionCase(a.parts[0], d.rootNodes, m, a.sourceSpan, T);
              }
              _collectExpansionExpTokens(a) {
                let c = [], h = [s.TokenType.EXPANSION_CASE_EXP_START];
                for (; ; ) {
                  if ((this._peek.type === s.TokenType.EXPANSION_FORM_START || this._peek.type === s.TokenType.EXPANSION_CASE_EXP_START) && h.push(this._peek.type), this._peek.type === s.TokenType.EXPANSION_CASE_EXP_END)
                    if (g(h, s.TokenType.EXPANSION_CASE_EXP_START)) {
                      if (h.pop(), h.length == 0)
                        return c;
                    } else
                      return this._errors.push(n.create(null, a.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
                  if (this._peek.type === s.TokenType.EXPANSION_FORM_END)
                    if (g(h, s.TokenType.EXPANSION_FORM_START))
                      h.pop();
                    else
                      return this._errors.push(n.create(null, a.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
                  if (this._peek.type === s.TokenType.EOF)
                    return this._errors.push(n.create(null, a.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
                  c.push(this._advance());
                }
              }
              _getText(a) {
                let c = a.parts[0];
                if (c.length > 0 && c[0] == `
`) {
                  let h = this._getParentElement();
                  h != null && h.children.length == 0 && this.getTagDefinition(h.name).ignoreFirstLf && (c = c.substring(1));
                }
                return c;
              }
              _consumeText(a) {
                let c = this._getText(a);
                c.length > 0 && this._addToParent(new u.Text(c, a.sourceSpan));
              }
              _closeVoidElement() {
                let a = this._getParentElement();
                a && this.getTagDefinition(a.name).isVoid && this._elementStack.pop();
              }
              _consumeStartTag(a) {
                let c = a.parts[0], h = a.parts[1], C = [];
                for (; this._peek.type === s.TokenType.ATTR_NAME; )
                  C.push(this._consumeAttr(this._advance()));
                let d = this._getElementFullName(c, h, this._getParentElement()), m = false;
                if (this._peek.type === s.TokenType.TAG_OPEN_END_VOID) {
                  this._advance(), m = true;
                  let R = this.getTagDefinition(d);
                  this.canSelfClose || R.canSelfClose || D.getNsPrefix(d) !== null || R.isVoid || this._errors.push(n.create(d, a.sourceSpan, `Only void and foreign elements can be self closed "${a.parts[1]}"`));
                } else
                  this._peek.type === s.TokenType.TAG_OPEN_END && (this._advance(), m = false);
                let T = this._peek.sourceSpan.start, B = new r.ParseSourceSpan(a.sourceSpan.start, T), A = new r.ParseSourceSpan(a.sourceSpan.start.moveBy(1), a.sourceSpan.end), N = new u.Element(d, C, [], B, B, void 0, A);
                this._pushElement(N), m && (this._popElement(d), N.endSourceSpan = B);
              }
              _pushElement(a) {
                let c = this._getParentElement();
                c && this.getTagDefinition(c.name).isClosedByChild(a.name) && this._elementStack.pop(), this._addToParent(a), this._elementStack.push(a);
              }
              _consumeEndTag(a) {
                let c = this.allowHtmComponentClosingTags && a.parts.length === 0 ? null : this._getElementFullName(a.parts[0], a.parts[1], this._getParentElement());
                if (this._getParentElement() && (this._getParentElement().endSourceSpan = a.sourceSpan), c && this.getTagDefinition(c).isVoid)
                  this._errors.push(n.create(c, a.sourceSpan, `Void elements do not have end tags "${a.parts[1]}"`));
                else if (!this._popElement(c)) {
                  let h = `Unexpected closing tag "${c}". It may happen when the tag has already been closed by another tag. For more info see https://www.w3.org/TR/html5/syntax.html#closing-elements-that-have-implied-end-tags`;
                  this._errors.push(n.create(c, a.sourceSpan, h));
                }
              }
              _popElement(a) {
                for (let c = this._elementStack.length - 1; c >= 0; c--) {
                  let h = this._elementStack[c];
                  if (!a || (D.getNsPrefix(h.name) ? h.name == a : h.name.toLowerCase() == a.toLowerCase()))
                    return this._elementStack.splice(c, this._elementStack.length - c), true;
                  if (!this.getTagDefinition(h.name).closedByParent)
                    return false;
                }
                return false;
              }
              _consumeAttr(a) {
                let c = D.mergeNsAndName(a.parts[0], a.parts[1]), h = a.sourceSpan.end, C = "", d, m;
                if (this._peek.type === s.TokenType.ATTR_QUOTE && (m = this._advance().sourceSpan.start), this._peek.type === s.TokenType.ATTR_VALUE) {
                  let T = this._advance();
                  C = T.parts[0], h = T.sourceSpan.end, d = T.sourceSpan;
                }
                return this._peek.type === s.TokenType.ATTR_QUOTE && (h = this._advance().sourceSpan.end, d = new r.ParseSourceSpan(m, h)), new u.Attribute(c, C, new r.ParseSourceSpan(a.sourceSpan.start, h), d, a.sourceSpan);
              }
              _getParentElement() {
                return this._elementStack.length > 0 ? this._elementStack[this._elementStack.length - 1] : null;
              }
              _getParentElementSkippingContainers() {
                let a = null;
                for (let c = this._elementStack.length - 1; c >= 0; c--) {
                  if (!D.isNgContainer(this._elementStack[c].name))
                    return { parent: this._elementStack[c], container: a };
                  a = this._elementStack[c];
                }
                return { parent: null, container: a };
              }
              _addToParent(a) {
                let c = this._getParentElement();
                c != null ? c.children.push(a) : this._rootNodes.push(a);
              }
              _insertBeforeContainer(a, c, h) {
                if (!c)
                  this._addToParent(h), this._elementStack.push(h);
                else {
                  if (a) {
                    let C = a.children.indexOf(c);
                    a.children[C] = h;
                  } else
                    this._rootNodes.push(h);
                  h.children.push(c), this._elementStack.splice(this._elementStack.indexOf(c), 0, h);
                }
              }
              _getElementFullName(a, c, h) {
                return a === "" && (a = this.getTagDefinition(c).implicitNamespacePrefix || "", a === "" && h != null && (a = D.getNsPrefix(h.name))), D.mergeNsAndName(a, c);
              }
            };
            function g(a, c) {
              return a.length > 0 && a[a.length - 1] === c;
            }
          } }), jl = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_parser.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Es(), u = Zn(), s = Zn();
            e.ParseTreeResult = s.ParseTreeResult, e.TreeError = s.TreeError;
            var D = class extends u.Parser {
              constructor() {
                super(r.getHtmlTagDefinition);
              }
              parse(n, i, p) {
                let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, g = arguments.length > 4 ? arguments[4] : void 0;
                return super.parse(n, i, p, l, g);
              }
            };
            e.HtmlParser = D;
          } }), ms = I({ "node_modules/angular-html-parser/lib/angular-html-parser/src/index.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = jl(), u = Je();
            e.TagContentType = u.TagContentType;
            var s = null, D = () => (s || (s = new r.HtmlParser()), s);
            function n(i) {
              let p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { canSelfClose: l = false, allowHtmComponentClosingTags: g = false, isTagNameCaseSensitive: a = false, getTagContentType: c } = p;
              return D().parse(i, "angular-html-parser", { tokenizeExpansionForms: false, interpolationConfig: void 0, canSelfClose: l, allowHtmComponentClosingTags: g }, a, c);
            }
            e.parse = n;
          } });
          q();
          var { ParseSourceSpan: Ye, ParseLocation: es, ParseSourceFile: Ul } = ye(), Gl = ZD(), Vl = is(), Xl = el(), { inferParserByLanguage: Hl } = Tl(), zl = bl(), $r = Ol(), rs = ql(), { hasPragma: Wl } = Il(), { Node: Yl } = Rl(), { parseIeConditionalComment: Ql } = xl(), { locStart: Kl, locEnd: Jl } = Pl();
          function Zl(e, r, u) {
            let { recognizeSelfClosing: s, normalizeTagName: D, normalizeAttributeName: n, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: p, getTagContentType: l } = r, g = ms(), { RecursiveVisitor: a, visitAll: c } = Cs(), { ParseSourceSpan: h } = ye(), { getHtmlTagDefinition: C } = Es(), { rootNodes: d, errors: m } = g.parse(e, { canSelfClose: s, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: p, getTagContentType: l });
            if (u.parser === "vue")
              if (d.some((O) => O.type === "docType" && O.value === "html" || O.type === "element" && O.name.toLowerCase() === "html")) {
                s = true, D = true, n = true, i = true, p = false;
                let O = g.parse(e, { canSelfClose: s, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: p });
                d = O.rootNodes, m = O.errors;
              } else {
                let O = (x) => {
                  if (!x || x.type !== "element" || x.name !== "template")
                    return false;
                  let k = x.attrs.find((t3) => t3.name === "lang"), $ = k && k.value;
                  return !$ || Hl($, u) === "html";
                };
                if (d.some(O)) {
                  let x, k = () => g.parse(e, { canSelfClose: s, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: p }), $ = () => x || (x = k()), t3 = (o) => $().rootNodes.find((E) => {
                    let { startSourceSpan: f } = E;
                    return f && f.start.offset === o.startSourceSpan.start.offset;
                  });
                  for (let o = 0; o < d.length; o++) {
                    let E = d[o], { endSourceSpan: f, startSourceSpan: F } = E;
                    if (f === null)
                      m = $().errors, d[o] = t3(E) || E;
                    else if (O(E)) {
                      let M = $(), W = F.end.offset, X = f.start.offset;
                      for (let H of M.errors) {
                        let { offset: z } = H.span.start;
                        if (W < z && z < X) {
                          m = [H];
                          break;
                        }
                      }
                      d[o] = t3(E) || E;
                    }
                  }
                }
              }
            if (m.length > 0) {
              let { msg: _, span: { start: O, end: x } } = m[0];
              throw Xl(_, { start: { line: O.line + 1, column: O.col + 1 }, end: { line: x.line + 1, column: x.col + 1 } });
            }
            let T = (_) => {
              let O = _.name.startsWith(":") ? _.name.slice(1).split(":")[0] : null, x = _.nameSpan.toString(), k = O !== null && x.startsWith(`${O}:`), $ = k ? x.slice(O.length + 1) : x;
              _.name = $, _.namespace = O, _.hasExplicitNamespace = k;
            }, B = (_) => {
              switch (_.type) {
                case "element":
                  T(_);
                  for (let O of _.attrs)
                    T(O), O.valueSpan ? (O.value = O.valueSpan.toString(), /["']/.test(O.value[0]) && (O.value = O.value.slice(1, -1))) : O.value = null;
                  break;
                case "comment":
                  _.value = _.sourceSpan.toString().slice(4, -3);
                  break;
                case "text":
                  _.value = _.sourceSpan.toString();
                  break;
              }
            }, A = (_, O) => {
              let x = _.toLowerCase();
              return O(x) ? x : _;
            }, N = (_) => {
              if (_.type === "element" && (D && (!_.namespace || _.namespace === _.tagDefinition.implicitNamespacePrefix || rs(_)) && (_.name = A(_.name, (O) => O in zl)), n)) {
                let O = $r[_.name] || /* @__PURE__ */ Object.create(null);
                for (let x of _.attrs)
                  x.namespace || (x.name = A(x.name, (k) => _.name in $r && (k in $r["*"] || k in O)));
              }
            }, R = (_) => {
              _.sourceSpan && _.endSourceSpan && (_.sourceSpan = new h(_.sourceSpan.start, _.endSourceSpan.end));
            }, j = (_) => {
              if (_.type === "element") {
                let O = C(p ? _.name : _.name.toLowerCase());
                !_.namespace || _.namespace === O.implicitNamespacePrefix || rs(_) ? _.tagDefinition = O : _.tagDefinition = C("");
              }
            };
            return c(new class extends a {
              visit(_) {
                B(_), j(_), N(_), R(_);
              }
            }(), d), d;
          }
          function gs(e, r, u) {
            let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, { frontMatter: D, content: n } = s ? Gl(e) : { frontMatter: null, content: e }, i = new Ul(e, r.filepath), p = new es(i, 0, 0, 0), l = p.moveBy(e.length), g = { type: "root", sourceSpan: new Ye(p, l), children: Zl(n, u, r) };
            if (D) {
              let h = new es(i, 0, 0, 0), C = h.moveBy(D.raw.length);
              D.sourceSpan = new Ye(h, C), g.children.unshift(D);
            }
            let a = new Yl(g), c = (h, C) => {
              let { offset: d } = C, m = e.slice(0, d).replace(/[^\n\r]/g, " "), B = gs(m + h, r, u, false);
              B.sourceSpan = new Ye(C, Vl(B.children).sourceSpan.end);
              let A = B.children[0];
              return A.length === d ? B.children.shift() : (A.sourceSpan = new Ye(A.sourceSpan.start.moveBy(d), A.sourceSpan.end), A.value = A.value.slice(d)), B;
            };
            return a.walk((h) => {
              if (h.type === "comment") {
                let C = Ql(h, c);
                C && h.parent.replaceChild(h, C);
              }
            }), a;
          }
          function Qe() {
            let { name: e, recognizeSelfClosing: r = false, normalizeTagName: u = false, normalizeAttributeName: s = false, allowHtmComponentClosingTags: D = false, isTagNameCaseSensitive: n = false, getTagContentType: i } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return { parse: (p, l, g) => gs(p, Object.assign({ parser: e }, g), { recognizeSelfClosing: r, normalizeTagName: u, normalizeAttributeName: s, allowHtmComponentClosingTags: D, isTagNameCaseSensitive: n, getTagContentType: i }), hasPragma: Wl, astFormat: "html", locStart: Kl, locEnd: Jl };
          }
          Fs.exports = { parsers: { html: Qe({ name: "html", recognizeSelfClosing: true, normalizeTagName: true, normalizeAttributeName: true, allowHtmComponentClosingTags: true }), angular: Qe({ name: "angular" }), vue: Qe({ name: "vue", recognizeSelfClosing: true, isTagNameCaseSensitive: true, getTagContentType: (e, r, u, s) => {
            if (e.toLowerCase() !== "html" && !u && (e !== "template" || s.some((D) => {
              let { name: n, value: i } = D;
              return n === "lang" && i !== "html" && i !== "" && i !== void 0;
            })))
              return ms().TagContentType.RAW_TEXT;
          } }), lwc: Qe({ name: "lwc" }) } };
        });
        return ec();
      });
    }
  });

  // node_modules/semver/internal/constants.js
  var require_constants2 = __commonJS({
    "node_modules/semver/internal/constants.js"(exports2, module2) {
      init_define_process();
      var SEMVER_SPEC_VERSION = "2.0.0";
      var MAX_LENGTH = 256;
      var MAX_SAFE_INTEGER7 = Number.MAX_SAFE_INTEGER || 9007199254740991;
      var MAX_SAFE_COMPONENT_LENGTH = 16;
      module2.exports = {
        SEMVER_SPEC_VERSION,
        MAX_LENGTH,
        MAX_SAFE_INTEGER: MAX_SAFE_INTEGER7,
        MAX_SAFE_COMPONENT_LENGTH
      };
    }
  });

  // node_modules/semver/internal/debug.js
  var require_debug2 = __commonJS({
    "node_modules/semver/internal/debug.js"(exports2, module2) {
      init_define_process();
      var debug2 = typeof define_process_default === "object" && define_process_default.env && define_process_default.env.NODE_DEBUG && /\bsemver\b/i.test(define_process_default.env.NODE_DEBUG) ? (...args) => console.error("SEMVER", ...args) : () => {
      };
      module2.exports = debug2;
    }
  });

  // node_modules/semver/internal/re.js
  var require_re = __commonJS({
    "node_modules/semver/internal/re.js"(exports2, module2) {
      init_define_process();
      var { MAX_SAFE_COMPONENT_LENGTH } = require_constants2();
      var debug2 = require_debug2();
      exports2 = module2.exports = {};
      var re = exports2.re = [];
      var src = exports2.src = [];
      var t3 = exports2.t = {};
      var R = 0;
      var createToken = (name, value, isGlobal) => {
        const index = R++;
        debug2(name, index, value);
        t3[name] = index;
        src[index] = value;
        re[index] = new RegExp(value, isGlobal ? "g" : void 0);
      };
      createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
      createToken("NUMERICIDENTIFIERLOOSE", "[0-9]+");
      createToken("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*");
      createToken("MAINVERSION", `(${src[t3.NUMERICIDENTIFIER]})\\.(${src[t3.NUMERICIDENTIFIER]})\\.(${src[t3.NUMERICIDENTIFIER]})`);
      createToken("MAINVERSIONLOOSE", `(${src[t3.NUMERICIDENTIFIERLOOSE]})\\.(${src[t3.NUMERICIDENTIFIERLOOSE]})\\.(${src[t3.NUMERICIDENTIFIERLOOSE]})`);
      createToken("PRERELEASEIDENTIFIER", `(?:${src[t3.NUMERICIDENTIFIER]}|${src[t3.NONNUMERICIDENTIFIER]})`);
      createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t3.NUMERICIDENTIFIERLOOSE]}|${src[t3.NONNUMERICIDENTIFIER]})`);
      createToken("PRERELEASE", `(?:-(${src[t3.PRERELEASEIDENTIFIER]}(?:\\.${src[t3.PRERELEASEIDENTIFIER]})*))`);
      createToken("PRERELEASELOOSE", `(?:-?(${src[t3.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t3.PRERELEASEIDENTIFIERLOOSE]})*))`);
      createToken("BUILDIDENTIFIER", "[0-9A-Za-z-]+");
      createToken("BUILD", `(?:\\+(${src[t3.BUILDIDENTIFIER]}(?:\\.${src[t3.BUILDIDENTIFIER]})*))`);
      createToken("FULLPLAIN", `v?${src[t3.MAINVERSION]}${src[t3.PRERELEASE]}?${src[t3.BUILD]}?`);
      createToken("FULL", `^${src[t3.FULLPLAIN]}$`);
      createToken("LOOSEPLAIN", `[v=\\s]*${src[t3.MAINVERSIONLOOSE]}${src[t3.PRERELEASELOOSE]}?${src[t3.BUILD]}?`);
      createToken("LOOSE", `^${src[t3.LOOSEPLAIN]}$`);
      createToken("GTLT", "((?:<|>)?=?)");
      createToken("XRANGEIDENTIFIERLOOSE", `${src[t3.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
      createToken("XRANGEIDENTIFIER", `${src[t3.NUMERICIDENTIFIER]}|x|X|\\*`);
      createToken("XRANGEPLAIN", `[v=\\s]*(${src[t3.XRANGEIDENTIFIER]})(?:\\.(${src[t3.XRANGEIDENTIFIER]})(?:\\.(${src[t3.XRANGEIDENTIFIER]})(?:${src[t3.PRERELEASE]})?${src[t3.BUILD]}?)?)?`);
      createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:${src[t3.PRERELEASELOOSE]})?${src[t3.BUILD]}?)?)?`);
      createToken("XRANGE", `^${src[t3.GTLT]}\\s*${src[t3.XRANGEPLAIN]}$`);
      createToken("XRANGELOOSE", `^${src[t3.GTLT]}\\s*${src[t3.XRANGEPLAINLOOSE]}$`);
      createToken("COERCE", `${"(^|[^\\d])(\\d{1,"}${MAX_SAFE_COMPONENT_LENGTH}})(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?(?:$|[^\\d])`);
      createToken("COERCERTL", src[t3.COERCE], true);
      createToken("LONETILDE", "(?:~>?)");
      createToken("TILDETRIM", `(\\s*)${src[t3.LONETILDE]}\\s+`, true);
      exports2.tildeTrimReplace = "$1~";
      createToken("TILDE", `^${src[t3.LONETILDE]}${src[t3.XRANGEPLAIN]}$`);
      createToken("TILDELOOSE", `^${src[t3.LONETILDE]}${src[t3.XRANGEPLAINLOOSE]}$`);
      createToken("LONECARET", "(?:\\^)");
      createToken("CARETTRIM", `(\\s*)${src[t3.LONECARET]}\\s+`, true);
      exports2.caretTrimReplace = "$1^";
      createToken("CARET", `^${src[t3.LONECARET]}${src[t3.XRANGEPLAIN]}$`);
      createToken("CARETLOOSE", `^${src[t3.LONECARET]}${src[t3.XRANGEPLAINLOOSE]}$`);
      createToken("COMPARATORLOOSE", `^${src[t3.GTLT]}\\s*(${src[t3.LOOSEPLAIN]})$|^$`);
      createToken("COMPARATOR", `^${src[t3.GTLT]}\\s*(${src[t3.FULLPLAIN]})$|^$`);
      createToken("COMPARATORTRIM", `(\\s*)${src[t3.GTLT]}\\s*(${src[t3.LOOSEPLAIN]}|${src[t3.XRANGEPLAIN]})`, true);
      exports2.comparatorTrimReplace = "$1$2$3";
      createToken("HYPHENRANGE", `^\\s*(${src[t3.XRANGEPLAIN]})\\s+-\\s+(${src[t3.XRANGEPLAIN]})\\s*$`);
      createToken("HYPHENRANGELOOSE", `^\\s*(${src[t3.XRANGEPLAINLOOSE]})\\s+-\\s+(${src[t3.XRANGEPLAINLOOSE]})\\s*$`);
      createToken("STAR", "(<|>)?=?\\s*\\*");
      createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
      createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
    }
  });

  // node_modules/semver/internal/parse-options.js
  var require_parse_options = __commonJS({
    "node_modules/semver/internal/parse-options.js"(exports2, module2) {
      init_define_process();
      var opts = ["includePrerelease", "loose", "rtl"];
      var parseOptions = (options) => !options ? {} : typeof options !== "object" ? { loose: true } : opts.filter((k) => options[k]).reduce((o, k) => {
        o[k] = true;
        return o;
      }, {});
      module2.exports = parseOptions;
    }
  });

  // node_modules/semver/internal/identifiers.js
  var require_identifiers = __commonJS({
    "node_modules/semver/internal/identifiers.js"(exports2, module2) {
      init_define_process();
      var numeric = /^[0-9]+$/;
      var compareIdentifiers = (a, b) => {
        const anum = numeric.test(a);
        const bnum = numeric.test(b);
        if (anum && bnum) {
          a = +a;
          b = +b;
        }
        return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
      };
      var rcompareIdentifiers = (a, b) => compareIdentifiers(b, a);
      module2.exports = {
        compareIdentifiers,
        rcompareIdentifiers
      };
    }
  });

  // node_modules/semver/classes/semver.js
  var require_semver = __commonJS({
    "node_modules/semver/classes/semver.js"(exports2, module2) {
      init_define_process();
      var debug2 = require_debug2();
      var { MAX_LENGTH, MAX_SAFE_INTEGER: MAX_SAFE_INTEGER7 } = require_constants2();
      var { re, t: t3 } = require_re();
      var parseOptions = require_parse_options();
      var { compareIdentifiers } = require_identifiers();
      var SemVer = class {
        constructor(version, options) {
          options = parseOptions(options);
          if (version instanceof SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) {
              return version;
            } else {
              version = version.version;
            }
          } else if (typeof version !== "string") {
            throw new TypeError(`Invalid Version: ${version}`);
          }
          if (version.length > MAX_LENGTH) {
            throw new TypeError(
              `version is longer than ${MAX_LENGTH} characters`
            );
          }
          debug2("SemVer", version, options);
          this.options = options;
          this.loose = !!options.loose;
          this.includePrerelease = !!options.includePrerelease;
          const m = version.trim().match(options.loose ? re[t3.LOOSE] : re[t3.FULL]);
          if (!m) {
            throw new TypeError(`Invalid Version: ${version}`);
          }
          this.raw = version;
          this.major = +m[1];
          this.minor = +m[2];
          this.patch = +m[3];
          if (this.major > MAX_SAFE_INTEGER7 || this.major < 0) {
            throw new TypeError("Invalid major version");
          }
          if (this.minor > MAX_SAFE_INTEGER7 || this.minor < 0) {
            throw new TypeError("Invalid minor version");
          }
          if (this.patch > MAX_SAFE_INTEGER7 || this.patch < 0) {
            throw new TypeError("Invalid patch version");
          }
          if (!m[4]) {
            this.prerelease = [];
          } else {
            this.prerelease = m[4].split(".").map((id) => {
              if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < MAX_SAFE_INTEGER7) {
                  return num;
                }
              }
              return id;
            });
          }
          this.build = m[5] ? m[5].split(".") : [];
          this.format();
        }
        format() {
          this.version = `${this.major}.${this.minor}.${this.patch}`;
          if (this.prerelease.length) {
            this.version += `-${this.prerelease.join(".")}`;
          }
          return this.version;
        }
        toString() {
          return this.version;
        }
        compare(other) {
          debug2("SemVer.compare", this.version, this.options, other);
          if (!(other instanceof SemVer)) {
            if (typeof other === "string" && other === this.version) {
              return 0;
            }
            other = new SemVer(other, this.options);
          }
          if (other.version === this.version) {
            return 0;
          }
          return this.compareMain(other) || this.comparePre(other);
        }
        compareMain(other) {
          if (!(other instanceof SemVer)) {
            other = new SemVer(other, this.options);
          }
          return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
        }
        comparePre(other) {
          if (!(other instanceof SemVer)) {
            other = new SemVer(other, this.options);
          }
          if (this.prerelease.length && !other.prerelease.length) {
            return -1;
          } else if (!this.prerelease.length && other.prerelease.length) {
            return 1;
          } else if (!this.prerelease.length && !other.prerelease.length) {
            return 0;
          }
          let i = 0;
          do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            debug2("prerelease compare", i, a, b);
            if (a === void 0 && b === void 0) {
              return 0;
            } else if (b === void 0) {
              return 1;
            } else if (a === void 0) {
              return -1;
            } else if (a === b) {
              continue;
            } else {
              return compareIdentifiers(a, b);
            }
          } while (++i);
        }
        compareBuild(other) {
          if (!(other instanceof SemVer)) {
            other = new SemVer(other, this.options);
          }
          let i = 0;
          do {
            const a = this.build[i];
            const b = other.build[i];
            debug2("prerelease compare", i, a, b);
            if (a === void 0 && b === void 0) {
              return 0;
            } else if (b === void 0) {
              return 1;
            } else if (a === void 0) {
              return -1;
            } else if (a === b) {
              continue;
            } else {
              return compareIdentifiers(a, b);
            }
          } while (++i);
        }
        inc(release, identifier3) {
          switch (release) {
            case "premajor":
              this.prerelease.length = 0;
              this.patch = 0;
              this.minor = 0;
              this.major++;
              this.inc("pre", identifier3);
              break;
            case "preminor":
              this.prerelease.length = 0;
              this.patch = 0;
              this.minor++;
              this.inc("pre", identifier3);
              break;
            case "prepatch":
              this.prerelease.length = 0;
              this.inc("patch", identifier3);
              this.inc("pre", identifier3);
              break;
            case "prerelease":
              if (this.prerelease.length === 0) {
                this.inc("patch", identifier3);
              }
              this.inc("pre", identifier3);
              break;
            case "major":
              if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) {
                this.major++;
              }
              this.minor = 0;
              this.patch = 0;
              this.prerelease = [];
              break;
            case "minor":
              if (this.patch !== 0 || this.prerelease.length === 0) {
                this.minor++;
              }
              this.patch = 0;
              this.prerelease = [];
              break;
            case "patch":
              if (this.prerelease.length === 0) {
                this.patch++;
              }
              this.prerelease = [];
              break;
            case "pre":
              if (this.prerelease.length === 0) {
                this.prerelease = [0];
              } else {
                let i = this.prerelease.length;
                while (--i >= 0) {
                  if (typeof this.prerelease[i] === "number") {
                    this.prerelease[i]++;
                    i = -2;
                  }
                }
                if (i === -1) {
                  this.prerelease.push(0);
                }
              }
              if (identifier3) {
                if (compareIdentifiers(this.prerelease[0], identifier3) === 0) {
                  if (isNaN(this.prerelease[1])) {
                    this.prerelease = [identifier3, 0];
                  }
                } else {
                  this.prerelease = [identifier3, 0];
                }
              }
              break;
            default:
              throw new Error(`invalid increment argument: ${release}`);
          }
          this.format();
          this.raw = this.version;
          return this;
        }
      };
      module2.exports = SemVer;
    }
  });

  // node_modules/semver/functions/parse.js
  var require_parse2 = __commonJS({
    "node_modules/semver/functions/parse.js"(exports2, module2) {
      init_define_process();
      var { MAX_LENGTH } = require_constants2();
      var { re, t: t3 } = require_re();
      var SemVer = require_semver();
      var parseOptions = require_parse_options();
      var parse3 = (version, options) => {
        options = parseOptions(options);
        if (version instanceof SemVer) {
          return version;
        }
        if (typeof version !== "string") {
          return null;
        }
        if (version.length > MAX_LENGTH) {
          return null;
        }
        const r = options.loose ? re[t3.LOOSE] : re[t3.FULL];
        if (!r.test(version)) {
          return null;
        }
        try {
          return new SemVer(version, options);
        } catch (er) {
          return null;
        }
      };
      module2.exports = parse3;
    }
  });

  // node_modules/semver/functions/valid.js
  var require_valid = __commonJS({
    "node_modules/semver/functions/valid.js"(exports2, module2) {
      init_define_process();
      var parse3 = require_parse2();
      var valid = (version, options) => {
        const v = parse3(version, options);
        return v ? v.version : null;
      };
      module2.exports = valid;
    }
  });

  // node_modules/semver/functions/clean.js
  var require_clean = __commonJS({
    "node_modules/semver/functions/clean.js"(exports2, module2) {
      init_define_process();
      var parse3 = require_parse2();
      var clean = (version, options) => {
        const s = parse3(version.trim().replace(/^[=v]+/, ""), options);
        return s ? s.version : null;
      };
      module2.exports = clean;
    }
  });

  // node_modules/semver/functions/inc.js
  var require_inc = __commonJS({
    "node_modules/semver/functions/inc.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var inc = (version, release, options, identifier3) => {
        if (typeof options === "string") {
          identifier3 = options;
          options = void 0;
        }
        try {
          return new SemVer(
            version instanceof SemVer ? version.version : version,
            options
          ).inc(release, identifier3).version;
        } catch (er) {
          return null;
        }
      };
      module2.exports = inc;
    }
  });

  // node_modules/semver/functions/compare.js
  var require_compare = __commonJS({
    "node_modules/semver/functions/compare.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var compare = (a, b, loose) => new SemVer(a, loose).compare(new SemVer(b, loose));
      module2.exports = compare;
    }
  });

  // node_modules/semver/functions/eq.js
  var require_eq = __commonJS({
    "node_modules/semver/functions/eq.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var eq2 = (a, b, loose) => compare(a, b, loose) === 0;
      module2.exports = eq2;
    }
  });

  // node_modules/semver/functions/diff.js
  var require_diff = __commonJS({
    "node_modules/semver/functions/diff.js"(exports2, module2) {
      init_define_process();
      var parse3 = require_parse2();
      var eq2 = require_eq();
      var diff = (version1, version2) => {
        if (eq2(version1, version2)) {
          return null;
        } else {
          const v1 = parse3(version1);
          const v2 = parse3(version2);
          const hasPre = v1.prerelease.length || v2.prerelease.length;
          const prefix = hasPre ? "pre" : "";
          const defaultResult = hasPre ? "prerelease" : "";
          for (const key in v1) {
            if (key === "major" || key === "minor" || key === "patch") {
              if (v1[key] !== v2[key]) {
                return prefix + key;
              }
            }
          }
          return defaultResult;
        }
      };
      module2.exports = diff;
    }
  });

  // node_modules/semver/functions/major.js
  var require_major = __commonJS({
    "node_modules/semver/functions/major.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var major = (a, loose) => new SemVer(a, loose).major;
      module2.exports = major;
    }
  });

  // node_modules/semver/functions/minor.js
  var require_minor = __commonJS({
    "node_modules/semver/functions/minor.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var minor = (a, loose) => new SemVer(a, loose).minor;
      module2.exports = minor;
    }
  });

  // node_modules/semver/functions/patch.js
  var require_patch = __commonJS({
    "node_modules/semver/functions/patch.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var patch = (a, loose) => new SemVer(a, loose).patch;
      module2.exports = patch;
    }
  });

  // node_modules/semver/functions/prerelease.js
  var require_prerelease = __commonJS({
    "node_modules/semver/functions/prerelease.js"(exports2, module2) {
      init_define_process();
      var parse3 = require_parse2();
      var prerelease = (version, options) => {
        const parsed = parse3(version, options);
        return parsed && parsed.prerelease.length ? parsed.prerelease : null;
      };
      module2.exports = prerelease;
    }
  });

  // node_modules/semver/functions/rcompare.js
  var require_rcompare = __commonJS({
    "node_modules/semver/functions/rcompare.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var rcompare = (a, b, loose) => compare(b, a, loose);
      module2.exports = rcompare;
    }
  });

  // node_modules/semver/functions/compare-loose.js
  var require_compare_loose = __commonJS({
    "node_modules/semver/functions/compare-loose.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var compareLoose = (a, b) => compare(a, b, true);
      module2.exports = compareLoose;
    }
  });

  // node_modules/semver/functions/compare-build.js
  var require_compare_build = __commonJS({
    "node_modules/semver/functions/compare-build.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var compareBuild = (a, b, loose) => {
        const versionA = new SemVer(a, loose);
        const versionB = new SemVer(b, loose);
        return versionA.compare(versionB) || versionA.compareBuild(versionB);
      };
      module2.exports = compareBuild;
    }
  });

  // node_modules/semver/functions/sort.js
  var require_sort = __commonJS({
    "node_modules/semver/functions/sort.js"(exports2, module2) {
      init_define_process();
      var compareBuild = require_compare_build();
      var sort = (list, loose) => list.sort((a, b) => compareBuild(a, b, loose));
      module2.exports = sort;
    }
  });

  // node_modules/semver/functions/rsort.js
  var require_rsort = __commonJS({
    "node_modules/semver/functions/rsort.js"(exports2, module2) {
      init_define_process();
      var compareBuild = require_compare_build();
      var rsort = (list, loose) => list.sort((a, b) => compareBuild(b, a, loose));
      module2.exports = rsort;
    }
  });

  // node_modules/semver/functions/gt.js
  var require_gt = __commonJS({
    "node_modules/semver/functions/gt.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var gt2 = (a, b, loose) => compare(a, b, loose) > 0;
      module2.exports = gt2;
    }
  });

  // node_modules/semver/functions/lt.js
  var require_lt = __commonJS({
    "node_modules/semver/functions/lt.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var lt2 = (a, b, loose) => compare(a, b, loose) < 0;
      module2.exports = lt2;
    }
  });

  // node_modules/semver/functions/neq.js
  var require_neq = __commonJS({
    "node_modules/semver/functions/neq.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var neq = (a, b, loose) => compare(a, b, loose) !== 0;
      module2.exports = neq;
    }
  });

  // node_modules/semver/functions/gte.js
  var require_gte = __commonJS({
    "node_modules/semver/functions/gte.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var gte2 = (a, b, loose) => compare(a, b, loose) >= 0;
      module2.exports = gte2;
    }
  });

  // node_modules/semver/functions/lte.js
  var require_lte = __commonJS({
    "node_modules/semver/functions/lte.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var lte2 = (a, b, loose) => compare(a, b, loose) <= 0;
      module2.exports = lte2;
    }
  });

  // node_modules/semver/functions/cmp.js
  var require_cmp = __commonJS({
    "node_modules/semver/functions/cmp.js"(exports2, module2) {
      init_define_process();
      var eq2 = require_eq();
      var neq = require_neq();
      var gt2 = require_gt();
      var gte2 = require_gte();
      var lt2 = require_lt();
      var lte2 = require_lte();
      var cmp = (a, op, b, loose) => {
        switch (op) {
          case "===":
            if (typeof a === "object") {
              a = a.version;
            }
            if (typeof b === "object") {
              b = b.version;
            }
            return a === b;
          case "!==":
            if (typeof a === "object") {
              a = a.version;
            }
            if (typeof b === "object") {
              b = b.version;
            }
            return a !== b;
          case "":
          case "=":
          case "==":
            return eq2(a, b, loose);
          case "!=":
            return neq(a, b, loose);
          case ">":
            return gt2(a, b, loose);
          case ">=":
            return gte2(a, b, loose);
          case "<":
            return lt2(a, b, loose);
          case "<=":
            return lte2(a, b, loose);
          default:
            throw new TypeError(`Invalid operator: ${op}`);
        }
      };
      module2.exports = cmp;
    }
  });

  // node_modules/semver/functions/coerce.js
  var require_coerce = __commonJS({
    "node_modules/semver/functions/coerce.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var parse3 = require_parse2();
      var { re, t: t3 } = require_re();
      var coerce = (version, options) => {
        if (version instanceof SemVer) {
          return version;
        }
        if (typeof version === "number") {
          version = String(version);
        }
        if (typeof version !== "string") {
          return null;
        }
        options = options || {};
        let match = null;
        if (!options.rtl) {
          match = version.match(re[t3.COERCE]);
        } else {
          let next;
          while ((next = re[t3.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)) {
            if (!match || next.index + next[0].length !== match.index + match[0].length) {
              match = next;
            }
            re[t3.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
          }
          re[t3.COERCERTL].lastIndex = -1;
        }
        if (match === null) {
          return null;
        }
        return parse3(`${match[2]}.${match[3] || "0"}.${match[4] || "0"}`, options);
      };
      module2.exports = coerce;
    }
  });

  // node_modules/yallist/iterator.js
  var require_iterator = __commonJS({
    "node_modules/yallist/iterator.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function(Yallist) {
        Yallist.prototype[Symbol.iterator] = function* () {
          for (let walker = this.head; walker; walker = walker.next) {
            yield walker.value;
          }
        };
      };
    }
  });

  // node_modules/yallist/yallist.js
  var require_yallist = __commonJS({
    "node_modules/yallist/yallist.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = Yallist;
      Yallist.Node = Node2;
      Yallist.create = Yallist;
      function Yallist(list) {
        var self2 = this;
        if (!(self2 instanceof Yallist)) {
          self2 = new Yallist();
        }
        self2.tail = null;
        self2.head = null;
        self2.length = 0;
        if (list && typeof list.forEach === "function") {
          list.forEach(function(item) {
            self2.push(item);
          });
        } else if (arguments.length > 0) {
          for (var i = 0, l = arguments.length; i < l; i++) {
            self2.push(arguments[i]);
          }
        }
        return self2;
      }
      Yallist.prototype.removeNode = function(node) {
        if (node.list !== this) {
          throw new Error("removing node which does not belong to this list");
        }
        var next = node.next;
        var prev = node.prev;
        if (next) {
          next.prev = prev;
        }
        if (prev) {
          prev.next = next;
        }
        if (node === this.head) {
          this.head = next;
        }
        if (node === this.tail) {
          this.tail = prev;
        }
        node.list.length--;
        node.next = null;
        node.prev = null;
        node.list = null;
        return next;
      };
      Yallist.prototype.unshiftNode = function(node) {
        if (node === this.head) {
          return;
        }
        if (node.list) {
          node.list.removeNode(node);
        }
        var head2 = this.head;
        node.list = this;
        node.next = head2;
        if (head2) {
          head2.prev = node;
        }
        this.head = node;
        if (!this.tail) {
          this.tail = node;
        }
        this.length++;
      };
      Yallist.prototype.pushNode = function(node) {
        if (node === this.tail) {
          return;
        }
        if (node.list) {
          node.list.removeNode(node);
        }
        var tail2 = this.tail;
        node.list = this;
        node.prev = tail2;
        if (tail2) {
          tail2.next = node;
        }
        this.tail = node;
        if (!this.head) {
          this.head = node;
        }
        this.length++;
      };
      Yallist.prototype.push = function() {
        for (var i = 0, l = arguments.length; i < l; i++) {
          push(this, arguments[i]);
        }
        return this.length;
      };
      Yallist.prototype.unshift = function() {
        for (var i = 0, l = arguments.length; i < l; i++) {
          unshift(this, arguments[i]);
        }
        return this.length;
      };
      Yallist.prototype.pop = function() {
        if (!this.tail) {
          return void 0;
        }
        var res = this.tail.value;
        this.tail = this.tail.prev;
        if (this.tail) {
          this.tail.next = null;
        } else {
          this.head = null;
        }
        this.length--;
        return res;
      };
      Yallist.prototype.shift = function() {
        if (!this.head) {
          return void 0;
        }
        var res = this.head.value;
        this.head = this.head.next;
        if (this.head) {
          this.head.prev = null;
        } else {
          this.tail = null;
        }
        this.length--;
        return res;
      };
      Yallist.prototype.forEach = function(fn, thisp) {
        thisp = thisp || this;
        for (var walker = this.head, i = 0; walker !== null; i++) {
          fn.call(thisp, walker.value, i, this);
          walker = walker.next;
        }
      };
      Yallist.prototype.forEachReverse = function(fn, thisp) {
        thisp = thisp || this;
        for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
          fn.call(thisp, walker.value, i, this);
          walker = walker.prev;
        }
      };
      Yallist.prototype.get = function(n) {
        for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
          walker = walker.next;
        }
        if (i === n && walker !== null) {
          return walker.value;
        }
      };
      Yallist.prototype.getReverse = function(n) {
        for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
          walker = walker.prev;
        }
        if (i === n && walker !== null) {
          return walker.value;
        }
      };
      Yallist.prototype.map = function(fn, thisp) {
        thisp = thisp || this;
        var res = new Yallist();
        for (var walker = this.head; walker !== null; ) {
          res.push(fn.call(thisp, walker.value, this));
          walker = walker.next;
        }
        return res;
      };
      Yallist.prototype.mapReverse = function(fn, thisp) {
        thisp = thisp || this;
        var res = new Yallist();
        for (var walker = this.tail; walker !== null; ) {
          res.push(fn.call(thisp, walker.value, this));
          walker = walker.prev;
        }
        return res;
      };
      Yallist.prototype.reduce = function(fn, initial2) {
        var acc;
        var walker = this.head;
        if (arguments.length > 1) {
          acc = initial2;
        } else if (this.head) {
          walker = this.head.next;
          acc = this.head.value;
        } else {
          throw new TypeError("Reduce of empty list with no initial value");
        }
        for (var i = 0; walker !== null; i++) {
          acc = fn(acc, walker.value, i);
          walker = walker.next;
        }
        return acc;
      };
      Yallist.prototype.reduceReverse = function(fn, initial2) {
        var acc;
        var walker = this.tail;
        if (arguments.length > 1) {
          acc = initial2;
        } else if (this.tail) {
          walker = this.tail.prev;
          acc = this.tail.value;
        } else {
          throw new TypeError("Reduce of empty list with no initial value");
        }
        for (var i = this.length - 1; walker !== null; i--) {
          acc = fn(acc, walker.value, i);
          walker = walker.prev;
        }
        return acc;
      };
      Yallist.prototype.toArray = function() {
        var arr = new Array(this.length);
        for (var i = 0, walker = this.head; walker !== null; i++) {
          arr[i] = walker.value;
          walker = walker.next;
        }
        return arr;
      };
      Yallist.prototype.toArrayReverse = function() {
        var arr = new Array(this.length);
        for (var i = 0, walker = this.tail; walker !== null; i++) {
          arr[i] = walker.value;
          walker = walker.prev;
        }
        return arr;
      };
      Yallist.prototype.slice = function(from, to) {
        to = to || this.length;
        if (to < 0) {
          to += this.length;
        }
        from = from || 0;
        if (from < 0) {
          from += this.length;
        }
        var ret = new Yallist();
        if (to < from || to < 0) {
          return ret;
        }
        if (from < 0) {
          from = 0;
        }
        if (to > this.length) {
          to = this.length;
        }
        for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
          walker = walker.next;
        }
        for (; walker !== null && i < to; i++, walker = walker.next) {
          ret.push(walker.value);
        }
        return ret;
      };
      Yallist.prototype.sliceReverse = function(from, to) {
        to = to || this.length;
        if (to < 0) {
          to += this.length;
        }
        from = from || 0;
        if (from < 0) {
          from += this.length;
        }
        var ret = new Yallist();
        if (to < from || to < 0) {
          return ret;
        }
        if (from < 0) {
          from = 0;
        }
        if (to > this.length) {
          to = this.length;
        }
        for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
          walker = walker.prev;
        }
        for (; walker !== null && i > from; i--, walker = walker.prev) {
          ret.push(walker.value);
        }
        return ret;
      };
      Yallist.prototype.splice = function(start, deleteCount, ...nodes) {
        if (start > this.length) {
          start = this.length - 1;
        }
        if (start < 0) {
          start = this.length + start;
        }
        for (var i = 0, walker = this.head; walker !== null && i < start; i++) {
          walker = walker.next;
        }
        var ret = [];
        for (var i = 0; walker && i < deleteCount; i++) {
          ret.push(walker.value);
          walker = this.removeNode(walker);
        }
        if (walker === null) {
          walker = this.tail;
        }
        if (walker !== this.head && walker !== this.tail) {
          walker = walker.prev;
        }
        for (var i = 0; i < nodes.length; i++) {
          walker = insert(this, walker, nodes[i]);
        }
        return ret;
      };
      Yallist.prototype.reverse = function() {
        var head2 = this.head;
        var tail2 = this.tail;
        for (var walker = head2; walker !== null; walker = walker.prev) {
          var p = walker.prev;
          walker.prev = walker.next;
          walker.next = p;
        }
        this.head = tail2;
        this.tail = head2;
        return this;
      };
      function insert(self2, node, value) {
        var inserted = node === self2.head ? new Node2(value, null, node, self2) : new Node2(value, node, node.next, self2);
        if (inserted.next === null) {
          self2.tail = inserted;
        }
        if (inserted.prev === null) {
          self2.head = inserted;
        }
        self2.length++;
        return inserted;
      }
      function push(self2, item) {
        self2.tail = new Node2(item, self2.tail, null, self2);
        if (!self2.head) {
          self2.head = self2.tail;
        }
        self2.length++;
      }
      function unshift(self2, item) {
        self2.head = new Node2(item, null, self2.head, self2);
        if (!self2.tail) {
          self2.tail = self2.head;
        }
        self2.length++;
      }
      function Node2(value, prev, next, list) {
        if (!(this instanceof Node2)) {
          return new Node2(value, prev, next, list);
        }
        this.list = list;
        this.value = value;
        if (prev) {
          prev.next = this;
          this.prev = prev;
        } else {
          this.prev = null;
        }
        if (next) {
          next.prev = this;
          this.next = next;
        } else {
          this.next = null;
        }
      }
      try {
        require_iterator()(Yallist);
      } catch (er) {
      }
    }
  });

  // node_modules/lru-cache/index.js
  var require_lru_cache = __commonJS({
    "node_modules/lru-cache/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var Yallist = require_yallist();
      var MAX = Symbol("max");
      var LENGTH = Symbol("length");
      var LENGTH_CALCULATOR = Symbol("lengthCalculator");
      var ALLOW_STALE = Symbol("allowStale");
      var MAX_AGE = Symbol("maxAge");
      var DISPOSE = Symbol("dispose");
      var NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
      var LRU_LIST = Symbol("lruList");
      var CACHE = Symbol("cache");
      var UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
      var naiveLength = () => 1;
      var LRUCache = class {
        constructor(options) {
          if (typeof options === "number")
            options = { max: options };
          if (!options)
            options = {};
          if (options.max && (typeof options.max !== "number" || options.max < 0))
            throw new TypeError("max must be a non-negative number");
          const max2 = this[MAX] = options.max || Infinity;
          const lc = options.length || naiveLength;
          this[LENGTH_CALCULATOR] = typeof lc !== "function" ? naiveLength : lc;
          this[ALLOW_STALE] = options.stale || false;
          if (options.maxAge && typeof options.maxAge !== "number")
            throw new TypeError("maxAge must be a number");
          this[MAX_AGE] = options.maxAge || 0;
          this[DISPOSE] = options.dispose;
          this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
          this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
          this.reset();
        }
        set max(mL) {
          if (typeof mL !== "number" || mL < 0)
            throw new TypeError("max must be a non-negative number");
          this[MAX] = mL || Infinity;
          trim2(this);
        }
        get max() {
          return this[MAX];
        }
        set allowStale(allowStale) {
          this[ALLOW_STALE] = !!allowStale;
        }
        get allowStale() {
          return this[ALLOW_STALE];
        }
        set maxAge(mA) {
          if (typeof mA !== "number")
            throw new TypeError("maxAge must be a non-negative number");
          this[MAX_AGE] = mA;
          trim2(this);
        }
        get maxAge() {
          return this[MAX_AGE];
        }
        set lengthCalculator(lC) {
          if (typeof lC !== "function")
            lC = naiveLength;
          if (lC !== this[LENGTH_CALCULATOR]) {
            this[LENGTH_CALCULATOR] = lC;
            this[LENGTH] = 0;
            this[LRU_LIST].forEach((hit) => {
              hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key);
              this[LENGTH] += hit.length;
            });
          }
          trim2(this);
        }
        get lengthCalculator() {
          return this[LENGTH_CALCULATOR];
        }
        get length() {
          return this[LENGTH];
        }
        get itemCount() {
          return this[LRU_LIST].length;
        }
        rforEach(fn, thisp) {
          thisp = thisp || this;
          for (let walker = this[LRU_LIST].tail; walker !== null; ) {
            const prev = walker.prev;
            forEachStep(this, fn, walker, thisp);
            walker = prev;
          }
        }
        forEach(fn, thisp) {
          thisp = thisp || this;
          for (let walker = this[LRU_LIST].head; walker !== null; ) {
            const next = walker.next;
            forEachStep(this, fn, walker, thisp);
            walker = next;
          }
        }
        keys() {
          return this[LRU_LIST].toArray().map((k) => k.key);
        }
        values() {
          return this[LRU_LIST].toArray().map((k) => k.value);
        }
        reset() {
          if (this[DISPOSE] && this[LRU_LIST] && this[LRU_LIST].length) {
            this[LRU_LIST].forEach((hit) => this[DISPOSE](hit.key, hit.value));
          }
          this[CACHE] = /* @__PURE__ */ new Map();
          this[LRU_LIST] = new Yallist();
          this[LENGTH] = 0;
        }
        dump() {
          return this[LRU_LIST].map((hit) => isStale(this, hit) ? false : {
            k: hit.key,
            v: hit.value,
            e: hit.now + (hit.maxAge || 0)
          }).toArray().filter((h) => h);
        }
        dumpLru() {
          return this[LRU_LIST];
        }
        set(key, value, maxAge) {
          maxAge = maxAge || this[MAX_AGE];
          if (maxAge && typeof maxAge !== "number")
            throw new TypeError("maxAge must be a number");
          const now2 = maxAge ? Date.now() : 0;
          const len = this[LENGTH_CALCULATOR](value, key);
          if (this[CACHE].has(key)) {
            if (len > this[MAX]) {
              del(this, this[CACHE].get(key));
              return false;
            }
            const node = this[CACHE].get(key);
            const item = node.value;
            if (this[DISPOSE]) {
              if (!this[NO_DISPOSE_ON_SET])
                this[DISPOSE](key, item.value);
            }
            item.now = now2;
            item.maxAge = maxAge;
            item.value = value;
            this[LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            trim2(this);
            return true;
          }
          const hit = new Entry(key, value, len, now2, maxAge);
          if (hit.length > this[MAX]) {
            if (this[DISPOSE])
              this[DISPOSE](key, value);
            return false;
          }
          this[LENGTH] += hit.length;
          this[LRU_LIST].unshift(hit);
          this[CACHE].set(key, this[LRU_LIST].head);
          trim2(this);
          return true;
        }
        has(key) {
          if (!this[CACHE].has(key))
            return false;
          const hit = this[CACHE].get(key).value;
          return !isStale(this, hit);
        }
        get(key) {
          return get2(this, key, true);
        }
        peek(key) {
          return get2(this, key, false);
        }
        pop() {
          const node = this[LRU_LIST].tail;
          if (!node)
            return null;
          del(this, node);
          return node.value;
        }
        del(key) {
          del(this, this[CACHE].get(key));
        }
        load(arr) {
          this.reset();
          const now2 = Date.now();
          for (let l = arr.length - 1; l >= 0; l--) {
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0)
              this.set(hit.k, hit.v);
            else {
              const maxAge = expiresAt - now2;
              if (maxAge > 0) {
                this.set(hit.k, hit.v, maxAge);
              }
            }
          }
        }
        prune() {
          this[CACHE].forEach((value, key) => get2(this, key, false));
        }
      };
      var get2 = (self2, key, doUse) => {
        const node = self2[CACHE].get(key);
        if (node) {
          const hit = node.value;
          if (isStale(self2, hit)) {
            del(self2, node);
            if (!self2[ALLOW_STALE])
              return void 0;
          } else {
            if (doUse) {
              if (self2[UPDATE_AGE_ON_GET])
                node.value.now = Date.now();
              self2[LRU_LIST].unshiftNode(node);
            }
          }
          return hit.value;
        }
      };
      var isStale = (self2, hit) => {
        if (!hit || !hit.maxAge && !self2[MAX_AGE])
          return false;
        const diff = Date.now() - hit.now;
        return hit.maxAge ? diff > hit.maxAge : self2[MAX_AGE] && diff > self2[MAX_AGE];
      };
      var trim2 = (self2) => {
        if (self2[LENGTH] > self2[MAX]) {
          for (let walker = self2[LRU_LIST].tail; self2[LENGTH] > self2[MAX] && walker !== null; ) {
            const prev = walker.prev;
            del(self2, walker);
            walker = prev;
          }
        }
      };
      var del = (self2, node) => {
        if (node) {
          const hit = node.value;
          if (self2[DISPOSE])
            self2[DISPOSE](hit.key, hit.value);
          self2[LENGTH] -= hit.length;
          self2[CACHE].delete(hit.key);
          self2[LRU_LIST].removeNode(node);
        }
      };
      var Entry = class {
        constructor(key, value, length, now2, maxAge) {
          this.key = key;
          this.value = value;
          this.length = length;
          this.now = now2;
          this.maxAge = maxAge || 0;
        }
      };
      var forEachStep = (self2, fn, node, thisp) => {
        let hit = node.value;
        if (isStale(self2, hit)) {
          del(self2, node);
          if (!self2[ALLOW_STALE])
            hit = void 0;
        }
        if (hit)
          fn.call(thisp, hit.value, hit.key, self2);
      };
      module2.exports = LRUCache;
    }
  });

  // node_modules/semver/classes/range.js
  var require_range = __commonJS({
    "node_modules/semver/classes/range.js"(exports2, module2) {
      init_define_process();
      var Range = class {
        constructor(range2, options) {
          options = parseOptions(options);
          if (range2 instanceof Range) {
            if (range2.loose === !!options.loose && range2.includePrerelease === !!options.includePrerelease) {
              return range2;
            } else {
              return new Range(range2.raw, options);
            }
          }
          if (range2 instanceof Comparator) {
            this.raw = range2.value;
            this.set = [[range2]];
            this.format();
            return this;
          }
          this.options = options;
          this.loose = !!options.loose;
          this.includePrerelease = !!options.includePrerelease;
          this.raw = range2;
          this.set = range2.split("||").map((r) => this.parseRange(r.trim())).filter((c) => c.length);
          if (!this.set.length) {
            throw new TypeError(`Invalid SemVer Range: ${range2}`);
          }
          if (this.set.length > 1) {
            const first = this.set[0];
            this.set = this.set.filter((c) => !isNullSet(c[0]));
            if (this.set.length === 0) {
              this.set = [first];
            } else if (this.set.length > 1) {
              for (const c of this.set) {
                if (c.length === 1 && isAny(c[0])) {
                  this.set = [c];
                  break;
                }
              }
            }
          }
          this.format();
        }
        format() {
          this.range = this.set.map((comps) => {
            return comps.join(" ").trim();
          }).join("||").trim();
          return this.range;
        }
        toString() {
          return this.range;
        }
        parseRange(range2) {
          range2 = range2.trim();
          const memoOpts = Object.keys(this.options).join(",");
          const memoKey = `parseRange:${memoOpts}:${range2}`;
          const cached = cache.get(memoKey);
          if (cached) {
            return cached;
          }
          const loose = this.options.loose;
          const hr = loose ? re[t3.HYPHENRANGELOOSE] : re[t3.HYPHENRANGE];
          range2 = range2.replace(hr, hyphenReplace(this.options.includePrerelease));
          debug2("hyphen replace", range2);
          range2 = range2.replace(re[t3.COMPARATORTRIM], comparatorTrimReplace);
          debug2("comparator trim", range2);
          range2 = range2.replace(re[t3.TILDETRIM], tildeTrimReplace);
          range2 = range2.replace(re[t3.CARETTRIM], caretTrimReplace);
          range2 = range2.split(/\s+/).join(" ");
          let rangeList = range2.split(" ").map((comp) => parseComparator(comp, this.options)).join(" ").split(/\s+/).map((comp) => replaceGTE0(comp, this.options));
          if (loose) {
            rangeList = rangeList.filter((comp) => {
              debug2("loose invalid filter", comp, this.options);
              return !!comp.match(re[t3.COMPARATORLOOSE]);
            });
          }
          debug2("range list", rangeList);
          const rangeMap = /* @__PURE__ */ new Map();
          const comparators = rangeList.map((comp) => new Comparator(comp, this.options));
          for (const comp of comparators) {
            if (isNullSet(comp)) {
              return [comp];
            }
            rangeMap.set(comp.value, comp);
          }
          if (rangeMap.size > 1 && rangeMap.has("")) {
            rangeMap.delete("");
          }
          const result2 = [...rangeMap.values()];
          cache.set(memoKey, result2);
          return result2;
        }
        intersects(range2, options) {
          if (!(range2 instanceof Range)) {
            throw new TypeError("a Range is required");
          }
          return this.set.some((thisComparators) => {
            return isSatisfiable(thisComparators, options) && range2.set.some((rangeComparators) => {
              return isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator) => {
                return rangeComparators.every((rangeComparator) => {
                  return thisComparator.intersects(rangeComparator, options);
                });
              });
            });
          });
        }
        test(version) {
          if (!version) {
            return false;
          }
          if (typeof version === "string") {
            try {
              version = new SemVer(version, this.options);
            } catch (er) {
              return false;
            }
          }
          for (let i = 0; i < this.set.length; i++) {
            if (testSet(this.set[i], version, this.options)) {
              return true;
            }
          }
          return false;
        }
      };
      module2.exports = Range;
      var LRU = require_lru_cache();
      var cache = new LRU({ max: 1e3 });
      var parseOptions = require_parse_options();
      var Comparator = require_comparator();
      var debug2 = require_debug2();
      var SemVer = require_semver();
      var {
        re,
        t: t3,
        comparatorTrimReplace,
        tildeTrimReplace,
        caretTrimReplace
      } = require_re();
      var isNullSet = (c) => c.value === "<0.0.0-0";
      var isAny = (c) => c.value === "";
      var isSatisfiable = (comparators, options) => {
        let result2 = true;
        const remainingComparators = comparators.slice();
        let testComparator = remainingComparators.pop();
        while (result2 && remainingComparators.length) {
          result2 = remainingComparators.every((otherComparator) => {
            return testComparator.intersects(otherComparator, options);
          });
          testComparator = remainingComparators.pop();
        }
        return result2;
      };
      var parseComparator = (comp, options) => {
        debug2("comp", comp, options);
        comp = replaceCarets(comp, options);
        debug2("caret", comp);
        comp = replaceTildes(comp, options);
        debug2("tildes", comp);
        comp = replaceXRanges(comp, options);
        debug2("xrange", comp);
        comp = replaceStars(comp, options);
        debug2("stars", comp);
        return comp;
      };
      var isX = (id) => !id || id.toLowerCase() === "x" || id === "*";
      var replaceTildes = (comp, options) => comp.trim().split(/\s+/).map((c) => {
        return replaceTilde(c, options);
      }).join(" ");
      var replaceTilde = (comp, options) => {
        const r = options.loose ? re[t3.TILDELOOSE] : re[t3.TILDE];
        return comp.replace(r, (_, M, m, p, pr) => {
          debug2("tilde", comp, _, M, m, p, pr);
          let ret;
          if (isX(M)) {
            ret = "";
          } else if (isX(m)) {
            ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
          } else if (isX(p)) {
            ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
          } else if (pr) {
            debug2("replaceTilde pr", pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
          } else {
            ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
          }
          debug2("tilde return", ret);
          return ret;
        });
      };
      var replaceCarets = (comp, options) => comp.trim().split(/\s+/).map((c) => {
        return replaceCaret(c, options);
      }).join(" ");
      var replaceCaret = (comp, options) => {
        debug2("caret", comp, options);
        const r = options.loose ? re[t3.CARETLOOSE] : re[t3.CARET];
        const z = options.includePrerelease ? "-0" : "";
        return comp.replace(r, (_, M, m, p, pr) => {
          debug2("caret", comp, _, M, m, p, pr);
          let ret;
          if (isX(M)) {
            ret = "";
          } else if (isX(m)) {
            ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
          } else if (isX(p)) {
            if (M === "0") {
              ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            } else {
              ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
            }
          } else if (pr) {
            debug2("replaceCaret pr", pr);
            if (M === "0") {
              if (m === "0") {
                ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
              } else {
                ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
              }
            } else {
              ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
            }
          } else {
            debug2("no pr");
            if (M === "0") {
              if (m === "0") {
                ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
              } else {
                ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
              }
            } else {
              ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
            }
          }
          debug2("caret return", ret);
          return ret;
        });
      };
      var replaceXRanges = (comp, options) => {
        debug2("replaceXRanges", comp, options);
        return comp.split(/\s+/).map((c) => {
          return replaceXRange(c, options);
        }).join(" ");
      };
      var replaceXRange = (comp, options) => {
        comp = comp.trim();
        const r = options.loose ? re[t3.XRANGELOOSE] : re[t3.XRANGE];
        return comp.replace(r, (ret, gtlt, M, m, p, pr) => {
          debug2("xRange", comp, ret, gtlt, M, m, p, pr);
          const xM = isX(M);
          const xm = xM || isX(m);
          const xp = xm || isX(p);
          const anyX = xp;
          if (gtlt === "=" && anyX) {
            gtlt = "";
          }
          pr = options.includePrerelease ? "-0" : "";
          if (xM) {
            if (gtlt === ">" || gtlt === "<") {
              ret = "<0.0.0-0";
            } else {
              ret = "*";
            }
          } else if (gtlt && anyX) {
            if (xm) {
              m = 0;
            }
            p = 0;
            if (gtlt === ">") {
              gtlt = ">=";
              if (xm) {
                M = +M + 1;
                m = 0;
                p = 0;
              } else {
                m = +m + 1;
                p = 0;
              }
            } else if (gtlt === "<=") {
              gtlt = "<";
              if (xm) {
                M = +M + 1;
              } else {
                m = +m + 1;
              }
            }
            if (gtlt === "<") {
              pr = "-0";
            }
            ret = `${gtlt + M}.${m}.${p}${pr}`;
          } else if (xm) {
            ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
          } else if (xp) {
            ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
          }
          debug2("xRange return", ret);
          return ret;
        });
      };
      var replaceStars = (comp, options) => {
        debug2("replaceStars", comp, options);
        return comp.trim().replace(re[t3.STAR], "");
      };
      var replaceGTE0 = (comp, options) => {
        debug2("replaceGTE0", comp, options);
        return comp.trim().replace(re[options.includePrerelease ? t3.GTE0PRE : t3.GTE0], "");
      };
      var hyphenReplace = (incPr) => ($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) => {
        if (isX(fM)) {
          from = "";
        } else if (isX(fm)) {
          from = `>=${fM}.0.0${incPr ? "-0" : ""}`;
        } else if (isX(fp)) {
          from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}`;
        } else if (fpr) {
          from = `>=${from}`;
        } else {
          from = `>=${from}${incPr ? "-0" : ""}`;
        }
        if (isX(tM)) {
          to = "";
        } else if (isX(tm)) {
          to = `<${+tM + 1}.0.0-0`;
        } else if (isX(tp)) {
          to = `<${tM}.${+tm + 1}.0-0`;
        } else if (tpr) {
          to = `<=${tM}.${tm}.${tp}-${tpr}`;
        } else if (incPr) {
          to = `<${tM}.${tm}.${+tp + 1}-0`;
        } else {
          to = `<=${to}`;
        }
        return `${from} ${to}`.trim();
      };
      var testSet = (set2, version, options) => {
        for (let i = 0; i < set2.length; i++) {
          if (!set2[i].test(version)) {
            return false;
          }
        }
        if (version.prerelease.length && !options.includePrerelease) {
          for (let i = 0; i < set2.length; i++) {
            debug2(set2[i].semver);
            if (set2[i].semver === Comparator.ANY) {
              continue;
            }
            if (set2[i].semver.prerelease.length > 0) {
              const allowed = set2[i].semver;
              if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) {
                return true;
              }
            }
          }
          return false;
        }
        return true;
      };
    }
  });

  // node_modules/semver/classes/comparator.js
  var require_comparator = __commonJS({
    "node_modules/semver/classes/comparator.js"(exports2, module2) {
      init_define_process();
      var ANY = Symbol("SemVer ANY");
      var Comparator = class {
        static get ANY() {
          return ANY;
        }
        constructor(comp, options) {
          options = parseOptions(options);
          if (comp instanceof Comparator) {
            if (comp.loose === !!options.loose) {
              return comp;
            } else {
              comp = comp.value;
            }
          }
          debug2("comparator", comp, options);
          this.options = options;
          this.loose = !!options.loose;
          this.parse(comp);
          if (this.semver === ANY) {
            this.value = "";
          } else {
            this.value = this.operator + this.semver.version;
          }
          debug2("comp", this);
        }
        parse(comp) {
          const r = this.options.loose ? re[t3.COMPARATORLOOSE] : re[t3.COMPARATOR];
          const m = comp.match(r);
          if (!m) {
            throw new TypeError(`Invalid comparator: ${comp}`);
          }
          this.operator = m[1] !== void 0 ? m[1] : "";
          if (this.operator === "=") {
            this.operator = "";
          }
          if (!m[2]) {
            this.semver = ANY;
          } else {
            this.semver = new SemVer(m[2], this.options.loose);
          }
        }
        toString() {
          return this.value;
        }
        test(version) {
          debug2("Comparator.test", version, this.options.loose);
          if (this.semver === ANY || version === ANY) {
            return true;
          }
          if (typeof version === "string") {
            try {
              version = new SemVer(version, this.options);
            } catch (er) {
              return false;
            }
          }
          return cmp(version, this.operator, this.semver, this.options);
        }
        intersects(comp, options) {
          if (!(comp instanceof Comparator)) {
            throw new TypeError("a Comparator is required");
          }
          if (!options || typeof options !== "object") {
            options = {
              loose: !!options,
              includePrerelease: false
            };
          }
          if (this.operator === "") {
            if (this.value === "") {
              return true;
            }
            return new Range(comp.value, options).test(this.value);
          } else if (comp.operator === "") {
            if (comp.value === "") {
              return true;
            }
            return new Range(this.value, options).test(comp.semver);
          }
          const sameDirectionIncreasing = (this.operator === ">=" || this.operator === ">") && (comp.operator === ">=" || comp.operator === ">");
          const sameDirectionDecreasing = (this.operator === "<=" || this.operator === "<") && (comp.operator === "<=" || comp.operator === "<");
          const sameSemVer = this.semver.version === comp.semver.version;
          const differentDirectionsInclusive = (this.operator === ">=" || this.operator === "<=") && (comp.operator === ">=" || comp.operator === "<=");
          const oppositeDirectionsLessThan = cmp(this.semver, "<", comp.semver, options) && (this.operator === ">=" || this.operator === ">") && (comp.operator === "<=" || comp.operator === "<");
          const oppositeDirectionsGreaterThan = cmp(this.semver, ">", comp.semver, options) && (this.operator === "<=" || this.operator === "<") && (comp.operator === ">=" || comp.operator === ">");
          return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
        }
      };
      module2.exports = Comparator;
      var parseOptions = require_parse_options();
      var { re, t: t3 } = require_re();
      var cmp = require_cmp();
      var debug2 = require_debug2();
      var SemVer = require_semver();
      var Range = require_range();
    }
  });

  // node_modules/semver/functions/satisfies.js
  var require_satisfies = __commonJS({
    "node_modules/semver/functions/satisfies.js"(exports2, module2) {
      init_define_process();
      var Range = require_range();
      var satisfies = (version, range2, options) => {
        try {
          range2 = new Range(range2, options);
        } catch (er) {
          return false;
        }
        return range2.test(version);
      };
      module2.exports = satisfies;
    }
  });

  // node_modules/semver/ranges/to-comparators.js
  var require_to_comparators = __commonJS({
    "node_modules/semver/ranges/to-comparators.js"(exports2, module2) {
      init_define_process();
      var Range = require_range();
      var toComparators = (range2, options) => new Range(range2, options).set.map((comp) => comp.map((c) => c.value).join(" ").trim().split(" "));
      module2.exports = toComparators;
    }
  });

  // node_modules/semver/ranges/max-satisfying.js
  var require_max_satisfying = __commonJS({
    "node_modules/semver/ranges/max-satisfying.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var Range = require_range();
      var maxSatisfying = (versions, range2, options) => {
        let max2 = null;
        let maxSV = null;
        let rangeObj = null;
        try {
          rangeObj = new Range(range2, options);
        } catch (er) {
          return null;
        }
        versions.forEach((v) => {
          if (rangeObj.test(v)) {
            if (!max2 || maxSV.compare(v) === -1) {
              max2 = v;
              maxSV = new SemVer(max2, options);
            }
          }
        });
        return max2;
      };
      module2.exports = maxSatisfying;
    }
  });

  // node_modules/semver/ranges/min-satisfying.js
  var require_min_satisfying = __commonJS({
    "node_modules/semver/ranges/min-satisfying.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var Range = require_range();
      var minSatisfying = (versions, range2, options) => {
        let min2 = null;
        let minSV = null;
        let rangeObj = null;
        try {
          rangeObj = new Range(range2, options);
        } catch (er) {
          return null;
        }
        versions.forEach((v) => {
          if (rangeObj.test(v)) {
            if (!min2 || minSV.compare(v) === 1) {
              min2 = v;
              minSV = new SemVer(min2, options);
            }
          }
        });
        return min2;
      };
      module2.exports = minSatisfying;
    }
  });

  // node_modules/semver/ranges/min-version.js
  var require_min_version = __commonJS({
    "node_modules/semver/ranges/min-version.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var Range = require_range();
      var gt2 = require_gt();
      var minVersion = (range2, loose) => {
        range2 = new Range(range2, loose);
        let minver = new SemVer("0.0.0");
        if (range2.test(minver)) {
          return minver;
        }
        minver = new SemVer("0.0.0-0");
        if (range2.test(minver)) {
          return minver;
        }
        minver = null;
        for (let i = 0; i < range2.set.length; ++i) {
          const comparators = range2.set[i];
          let setMin = null;
          comparators.forEach((comparator) => {
            const compver = new SemVer(comparator.semver.version);
            switch (comparator.operator) {
              case ">":
                if (compver.prerelease.length === 0) {
                  compver.patch++;
                } else {
                  compver.prerelease.push(0);
                }
                compver.raw = compver.format();
              case "":
              case ">=":
                if (!setMin || gt2(compver, setMin)) {
                  setMin = compver;
                }
                break;
              case "<":
              case "<=":
                break;
              default:
                throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
          });
          if (setMin && (!minver || gt2(minver, setMin))) {
            minver = setMin;
          }
        }
        if (minver && range2.test(minver)) {
          return minver;
        }
        return null;
      };
      module2.exports = minVersion;
    }
  });

  // node_modules/semver/ranges/valid.js
  var require_valid2 = __commonJS({
    "node_modules/semver/ranges/valid.js"(exports2, module2) {
      init_define_process();
      var Range = require_range();
      var validRange = (range2, options) => {
        try {
          return new Range(range2, options).range || "*";
        } catch (er) {
          return null;
        }
      };
      module2.exports = validRange;
    }
  });

  // node_modules/semver/ranges/outside.js
  var require_outside = __commonJS({
    "node_modules/semver/ranges/outside.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var Comparator = require_comparator();
      var { ANY } = Comparator;
      var Range = require_range();
      var satisfies = require_satisfies();
      var gt2 = require_gt();
      var lt2 = require_lt();
      var lte2 = require_lte();
      var gte2 = require_gte();
      var outside = (version, range2, hilo, options) => {
        version = new SemVer(version, options);
        range2 = new Range(range2, options);
        let gtfn, ltefn, ltfn, comp, ecomp;
        switch (hilo) {
          case ">":
            gtfn = gt2;
            ltefn = lte2;
            ltfn = lt2;
            comp = ">";
            ecomp = ">=";
            break;
          case "<":
            gtfn = lt2;
            ltefn = gte2;
            ltfn = gt2;
            comp = "<";
            ecomp = "<=";
            break;
          default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
        }
        if (satisfies(version, range2, options)) {
          return false;
        }
        for (let i = 0; i < range2.set.length; ++i) {
          const comparators = range2.set[i];
          let high = null;
          let low = null;
          comparators.forEach((comparator) => {
            if (comparator.semver === ANY) {
              comparator = new Comparator(">=0.0.0");
            }
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) {
              high = comparator;
            } else if (ltfn(comparator.semver, low.semver, options)) {
              low = comparator;
            }
          });
          if (high.operator === comp || high.operator === ecomp) {
            return false;
          }
          if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) {
            return false;
          } else if (low.operator === ecomp && ltfn(version, low.semver)) {
            return false;
          }
        }
        return true;
      };
      module2.exports = outside;
    }
  });

  // node_modules/semver/ranges/gtr.js
  var require_gtr = __commonJS({
    "node_modules/semver/ranges/gtr.js"(exports2, module2) {
      init_define_process();
      var outside = require_outside();
      var gtr = (version, range2, options) => outside(version, range2, ">", options);
      module2.exports = gtr;
    }
  });

  // node_modules/semver/ranges/ltr.js
  var require_ltr = __commonJS({
    "node_modules/semver/ranges/ltr.js"(exports2, module2) {
      init_define_process();
      var outside = require_outside();
      var ltr = (version, range2, options) => outside(version, range2, "<", options);
      module2.exports = ltr;
    }
  });

  // node_modules/semver/ranges/intersects.js
  var require_intersects = __commonJS({
    "node_modules/semver/ranges/intersects.js"(exports2, module2) {
      init_define_process();
      var Range = require_range();
      var intersects = (r1, r2, options) => {
        r1 = new Range(r1, options);
        r2 = new Range(r2, options);
        return r1.intersects(r2);
      };
      module2.exports = intersects;
    }
  });

  // node_modules/semver/ranges/simplify.js
  var require_simplify = __commonJS({
    "node_modules/semver/ranges/simplify.js"(exports2, module2) {
      init_define_process();
      var satisfies = require_satisfies();
      var compare = require_compare();
      module2.exports = (versions, range2, options) => {
        const set2 = [];
        let first = null;
        let prev = null;
        const v = versions.sort((a, b) => compare(a, b, options));
        for (const version of v) {
          const included = satisfies(version, range2, options);
          if (included) {
            prev = version;
            if (!first) {
              first = version;
            }
          } else {
            if (prev) {
              set2.push([first, prev]);
            }
            prev = null;
            first = null;
          }
        }
        if (first) {
          set2.push([first, null]);
        }
        const ranges = [];
        for (const [min2, max2] of set2) {
          if (min2 === max2) {
            ranges.push(min2);
          } else if (!max2 && min2 === v[0]) {
            ranges.push("*");
          } else if (!max2) {
            ranges.push(`>=${min2}`);
          } else if (min2 === v[0]) {
            ranges.push(`<=${max2}`);
          } else {
            ranges.push(`${min2} - ${max2}`);
          }
        }
        const simplified = ranges.join(" || ");
        const original = typeof range2.raw === "string" ? range2.raw : String(range2);
        return simplified.length < original.length ? simplified : range2;
      };
    }
  });

  // node_modules/semver/ranges/subset.js
  var require_subset = __commonJS({
    "node_modules/semver/ranges/subset.js"(exports2, module2) {
      init_define_process();
      var Range = require_range();
      var Comparator = require_comparator();
      var { ANY } = Comparator;
      var satisfies = require_satisfies();
      var compare = require_compare();
      var subset = (sub, dom, options = {}) => {
        if (sub === dom) {
          return true;
        }
        sub = new Range(sub, options);
        dom = new Range(dom, options);
        let sawNonNull = false;
        OUTER:
          for (const simpleSub of sub.set) {
            for (const simpleDom of dom.set) {
              const isSub = simpleSubset(simpleSub, simpleDom, options);
              sawNonNull = sawNonNull || isSub !== null;
              if (isSub) {
                continue OUTER;
              }
            }
            if (sawNonNull) {
              return false;
            }
          }
        return true;
      };
      var simpleSubset = (sub, dom, options) => {
        if (sub === dom) {
          return true;
        }
        if (sub.length === 1 && sub[0].semver === ANY) {
          if (dom.length === 1 && dom[0].semver === ANY) {
            return true;
          } else if (options.includePrerelease) {
            sub = [new Comparator(">=0.0.0-0")];
          } else {
            sub = [new Comparator(">=0.0.0")];
          }
        }
        if (dom.length === 1 && dom[0].semver === ANY) {
          if (options.includePrerelease) {
            return true;
          } else {
            dom = [new Comparator(">=0.0.0")];
          }
        }
        const eqSet = /* @__PURE__ */ new Set();
        let gt2, lt2;
        for (const c of sub) {
          if (c.operator === ">" || c.operator === ">=") {
            gt2 = higherGT(gt2, c, options);
          } else if (c.operator === "<" || c.operator === "<=") {
            lt2 = lowerLT(lt2, c, options);
          } else {
            eqSet.add(c.semver);
          }
        }
        if (eqSet.size > 1) {
          return null;
        }
        let gtltComp;
        if (gt2 && lt2) {
          gtltComp = compare(gt2.semver, lt2.semver, options);
          if (gtltComp > 0) {
            return null;
          } else if (gtltComp === 0 && (gt2.operator !== ">=" || lt2.operator !== "<=")) {
            return null;
          }
        }
        for (const eq2 of eqSet) {
          if (gt2 && !satisfies(eq2, String(gt2), options)) {
            return null;
          }
          if (lt2 && !satisfies(eq2, String(lt2), options)) {
            return null;
          }
          for (const c of dom) {
            if (!satisfies(eq2, String(c), options)) {
              return false;
            }
          }
          return true;
        }
        let higher, lower;
        let hasDomLT, hasDomGT;
        let needDomLTPre = lt2 && !options.includePrerelease && lt2.semver.prerelease.length ? lt2.semver : false;
        let needDomGTPre = gt2 && !options.includePrerelease && gt2.semver.prerelease.length ? gt2.semver : false;
        if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt2.operator === "<" && needDomLTPre.prerelease[0] === 0) {
          needDomLTPre = false;
        }
        for (const c of dom) {
          hasDomGT = hasDomGT || c.operator === ">" || c.operator === ">=";
          hasDomLT = hasDomLT || c.operator === "<" || c.operator === "<=";
          if (gt2) {
            if (needDomGTPre) {
              if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) {
                needDomGTPre = false;
              }
            }
            if (c.operator === ">" || c.operator === ">=") {
              higher = higherGT(gt2, c, options);
              if (higher === c && higher !== gt2) {
                return false;
              }
            } else if (gt2.operator === ">=" && !satisfies(gt2.semver, String(c), options)) {
              return false;
            }
          }
          if (lt2) {
            if (needDomLTPre) {
              if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) {
                needDomLTPre = false;
              }
            }
            if (c.operator === "<" || c.operator === "<=") {
              lower = lowerLT(lt2, c, options);
              if (lower === c && lower !== lt2) {
                return false;
              }
            } else if (lt2.operator === "<=" && !satisfies(lt2.semver, String(c), options)) {
              return false;
            }
          }
          if (!c.operator && (lt2 || gt2) && gtltComp !== 0) {
            return false;
          }
        }
        if (gt2 && hasDomLT && !lt2 && gtltComp !== 0) {
          return false;
        }
        if (lt2 && hasDomGT && !gt2 && gtltComp !== 0) {
          return false;
        }
        if (needDomGTPre || needDomLTPre) {
          return false;
        }
        return true;
      };
      var higherGT = (a, b, options) => {
        if (!a) {
          return b;
        }
        const comp = compare(a.semver, b.semver, options);
        return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
      };
      var lowerLT = (a, b, options) => {
        if (!a) {
          return b;
        }
        const comp = compare(a.semver, b.semver, options);
        return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
      };
      module2.exports = subset;
    }
  });

  // node_modules/semver/index.js
  var require_semver2 = __commonJS({
    "node_modules/semver/index.js"(exports2, module2) {
      init_define_process();
      var internalRe = require_re();
      var constants = require_constants2();
      var SemVer = require_semver();
      var identifiers = require_identifiers();
      var parse3 = require_parse2();
      var valid = require_valid();
      var clean = require_clean();
      var inc = require_inc();
      var diff = require_diff();
      var major = require_major();
      var minor = require_minor();
      var patch = require_patch();
      var prerelease = require_prerelease();
      var compare = require_compare();
      var rcompare = require_rcompare();
      var compareLoose = require_compare_loose();
      var compareBuild = require_compare_build();
      var sort = require_sort();
      var rsort = require_rsort();
      var gt2 = require_gt();
      var lt2 = require_lt();
      var eq2 = require_eq();
      var neq = require_neq();
      var gte2 = require_gte();
      var lte2 = require_lte();
      var cmp = require_cmp();
      var coerce = require_coerce();
      var Comparator = require_comparator();
      var Range = require_range();
      var satisfies = require_satisfies();
      var toComparators = require_to_comparators();
      var maxSatisfying = require_max_satisfying();
      var minSatisfying = require_min_satisfying();
      var minVersion = require_min_version();
      var validRange = require_valid2();
      var outside = require_outside();
      var gtr = require_gtr();
      var ltr = require_ltr();
      var intersects = require_intersects();
      var simplifyRange = require_simplify();
      var subset = require_subset();
      module2.exports = {
        parse: parse3,
        valid,
        clean,
        inc,
        diff,
        major,
        minor,
        patch,
        prerelease,
        compare,
        rcompare,
        compareLoose,
        compareBuild,
        sort,
        rsort,
        gt: gt2,
        lt: lt2,
        eq: eq2,
        neq,
        gte: gte2,
        lte: lte2,
        cmp,
        coerce,
        Comparator,
        Range,
        satisfies,
        toComparators,
        maxSatisfying,
        minSatisfying,
        minVersion,
        validRange,
        outside,
        gtr,
        ltr,
        intersects,
        simplifyRange,
        subset,
        SemVer,
        re: internalRe.re,
        src: internalRe.src,
        tokens: internalRe.t,
        SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
        compareIdentifiers: identifiers.compareIdentifiers,
        rcompareIdentifiers: identifiers.rcompareIdentifiers
      };
    }
  });

  // src/standalone-worker.ts
  init_define_process();

  // src/standalone.ts
  init_define_process();

  // src/polyfills/buffer.ts
  init_define_process();
  var import_buffer = __toESM(require_buffer());
  if (self && !self.Buffer) {
    Object.assign(self, {
      Buffer: import_buffer.Buffer
    });
  }

  // src/generator/ProjectBuilder.ts
  init_define_process();

  // src/parser/SchemaParser.ts
  init_define_process();
  var import_change_case2 = __toESM(require_change_case());

  // src/types/index.ts
  init_define_process();

  // src/types/core.ts
  init_define_process();

  // src/types/deps.ts
  init_define_process();

  // src/types/error.ts
  init_define_process();
  var CodeGeneratorError = class extends Error {
    constructor(message, detail) {
      super(message);
      __publicField(this, "detail");
      this.name = this.constructor.name;
      this.detail = detail;
      Object.setPrototypeOf(this, new.target.prototype);
    }
  };
  var CompatibilityError = class extends CodeGeneratorError {
  };
  var PublisherError = class extends CodeGeneratorError {
  };

  // src/types/analyze.ts
  init_define_process();

  // src/types/intermediate.ts
  init_define_process();

  // src/types/publisher.ts
  init_define_process();

  // src/types/jsx.ts
  init_define_process();

  // src/const/index.ts
  var const_exports = {};
  __export(const_exports, {
    CLASS_DEFINE_CHUNK_NAME: () => CLASS_DEFINE_CHUNK_NAME,
    COMMON_CHUNK_NAME: () => COMMON_CHUNK_NAME,
    COMMON_SUB_MODULE_NAME: () => COMMON_SUB_MODULE_NAME,
    CONTAINER_TYPE: () => CONTAINER_TYPE,
    DEFAULT_LINK_AFTER: () => DEFAULT_LINK_AFTER,
    FILE_TYPE_FAMILY: () => FILE_TYPE_FAMILY,
    NATIVE_ELE_PKG: () => NATIVE_ELE_PKG,
    SUPPORT_SCHEMA_VERSION_LIST: () => SUPPORT_SCHEMA_VERSION_LIST
  });
  init_define_process();

  // src/const/file.ts
  init_define_process();
  var FILE_TYPE_FAMILY = [["tsx" /* TSX */, "ts" /* TS */, "jsx" /* JSX */, "js" /* JS */]];

  // src/const/generator.ts
  init_define_process();
  var COMMON_CHUNK_NAME = {
    ExternalDepsImport: "CommonExternalDependencyImport",
    InternalDepsImport: "CommonInternalDependencyImport",
    ImportAliasDefine: "CommonImportAliasDefine",
    FileVarDefine: "CommonFileScopeVarDefine",
    FileUtilDefine: "CommonFileScopeMethodDefine",
    FileMainContent: "CommonFileMainContent",
    FileExport: "CommonFileExport",
    StyleDepsImport: "CommonStyleDepsImport",
    StyleCssContent: "CommonStyleCssContent",
    HtmlContent: "CommonHtmlContent",
    CustomContent: "CommonCustomContent"
  };
  var CLASS_DEFINE_CHUNK_NAME = {
    Start: "CommonClassDefineStart",
    ConstructorStart: "CommonClassDefineConstructorStart",
    ConstructorContent: "CommonClassDefineConstructorContent",
    ConstructorEnd: "CommonClassDefineConstructorEnd",
    StaticVar: "CommonClassDefineStaticVar",
    StaticMethod: "CommonClassDefineStaticMethod",
    InsVar: "CommonClassDefineInsVar",
    InsVarMethod: "CommonClassDefineInsVarMethod",
    InsMethod: "CommonClassDefineInsMethod",
    InsPrivateMethod: "CommonClassDefineInsPrivateMethod",
    End: "CommonClassDefineEnd"
  };
  var DEFAULT_LINK_AFTER = {
    [COMMON_CHUNK_NAME.ExternalDepsImport]: [],
    [COMMON_CHUNK_NAME.InternalDepsImport]: [COMMON_CHUNK_NAME.ExternalDepsImport],
    [COMMON_CHUNK_NAME.ImportAliasDefine]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport
    ],
    [COMMON_CHUNK_NAME.FileVarDefine]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine
    ],
    [COMMON_CHUNK_NAME.FileUtilDefine]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine
    ],
    [CLASS_DEFINE_CHUNK_NAME.Start]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine,
      COMMON_CHUNK_NAME.FileUtilDefine
    ],
    [CLASS_DEFINE_CHUNK_NAME.ConstructorStart]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod
    ],
    [CLASS_DEFINE_CHUNK_NAME.ConstructorContent]: [CLASS_DEFINE_CHUNK_NAME.ConstructorStart],
    [CLASS_DEFINE_CHUNK_NAME.ConstructorEnd]: [
      CLASS_DEFINE_CHUNK_NAME.ConstructorStart,
      CLASS_DEFINE_CHUNK_NAME.ConstructorContent
    ],
    [CLASS_DEFINE_CHUNK_NAME.StaticVar]: [CLASS_DEFINE_CHUNK_NAME.Start],
    [CLASS_DEFINE_CHUNK_NAME.StaticMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsVar]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsVarMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod,
      CLASS_DEFINE_CHUNK_NAME.ConstructorEnd
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod,
      CLASS_DEFINE_CHUNK_NAME.InsMethod,
      CLASS_DEFINE_CHUNK_NAME.ConstructorEnd
    ],
    [CLASS_DEFINE_CHUNK_NAME.End]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod,
      CLASS_DEFINE_CHUNK_NAME.InsMethod,
      CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
      CLASS_DEFINE_CHUNK_NAME.ConstructorEnd
    ],
    [COMMON_CHUNK_NAME.FileMainContent]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine,
      COMMON_CHUNK_NAME.FileUtilDefine,
      CLASS_DEFINE_CHUNK_NAME.End
    ],
    [COMMON_CHUNK_NAME.FileExport]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine,
      COMMON_CHUNK_NAME.FileUtilDefine,
      CLASS_DEFINE_CHUNK_NAME.End,
      COMMON_CHUNK_NAME.FileMainContent
    ],
    [COMMON_CHUNK_NAME.StyleDepsImport]: [],
    [COMMON_CHUNK_NAME.StyleCssContent]: [COMMON_CHUNK_NAME.StyleDepsImport],
    [COMMON_CHUNK_NAME.HtmlContent]: []
  };
  var COMMON_SUB_MODULE_NAME = "index";

  // src/const/index.ts
  var NATIVE_ELE_PKG = "native";
  var CONTAINER_TYPE = {
    COMPONENT: "Component",
    BLOCK: "Block",
    PAGE: "Page"
  };
  var SUPPORT_SCHEMA_VERSION_LIST = ["0.0.1", "1.0.0"];

  // src/utils/errors.ts
  init_define_process();
  function getErrorMessage(error) {
    if (!error) {
      return null;
    }
    if (error instanceof Error) {
      return error.message;
    }
    if (typeof error === "string") {
      return error;
    }
    if (typeof error === "object" && error !== null) {
      return getErrorMessage(error.message) || getErrorMessage(error.errorMessage) || getErrorMessage(error.detail);
    }
    return null;
  }

  // src/utils/schema.ts
  var schema_exports = {};
  __export(schema_exports, {
    handleSubNodes: () => handleSubNodes,
    isContainerSchema: () => isContainerSchema,
    isNpmInfo: () => isNpmInfo
  });
  init_define_process();

  // node_modules/lodash-es/lodash.js
  init_define_process();

  // node_modules/lodash-es/add.js
  init_define_process();

  // node_modules/lodash-es/_createMathOperation.js
  init_define_process();

  // node_modules/lodash-es/_baseToNumber.js
  init_define_process();

  // node_modules/lodash-es/isSymbol.js
  init_define_process();

  // node_modules/lodash-es/_baseGetTag.js
  init_define_process();

  // node_modules/lodash-es/_Symbol.js
  init_define_process();

  // node_modules/lodash-es/_root.js
  init_define_process();

  // node_modules/lodash-es/_freeGlobal.js
  init_define_process();
  var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
  var freeGlobal_default = freeGlobal;

  // node_modules/lodash-es/_root.js
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal_default || freeSelf || Function("return this")();
  var root_default = root;

  // node_modules/lodash-es/_Symbol.js
  var Symbol2 = root_default.Symbol;
  var Symbol_default = Symbol2;

  // node_modules/lodash-es/_getRawTag.js
  init_define_process();
  var objectProto = Object.prototype;
  var hasOwnProperty = objectProto.hasOwnProperty;
  var nativeObjectToString = objectProto.toString;
  var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result2 = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result2;
  }
  var getRawTag_default = getRawTag;

  // node_modules/lodash-es/_objectToString.js
  init_define_process();
  var objectProto2 = Object.prototype;
  var nativeObjectToString2 = objectProto2.toString;
  function objectToString(value) {
    return nativeObjectToString2.call(value);
  }
  var objectToString_default = objectToString;

  // node_modules/lodash-es/_baseGetTag.js
  var nullTag = "[object Null]";
  var undefinedTag = "[object Undefined]";
  var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
  }
  var baseGetTag_default = baseGetTag;

  // node_modules/lodash-es/isObjectLike.js
  init_define_process();
  function isObjectLike(value) {
    return value != null && typeof value == "object";
  }
  var isObjectLike_default = isObjectLike;

  // node_modules/lodash-es/isSymbol.js
  var symbolTag = "[object Symbol]";
  function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
  }
  var isSymbol_default = isSymbol;

  // node_modules/lodash-es/_baseToNumber.js
  var NAN = 0 / 0;
  function baseToNumber(value) {
    if (typeof value == "number") {
      return value;
    }
    if (isSymbol_default(value)) {
      return NAN;
    }
    return +value;
  }
  var baseToNumber_default = baseToNumber;

  // node_modules/lodash-es/_baseToString.js
  init_define_process();

  // node_modules/lodash-es/_arrayMap.js
  init_define_process();
  function arrayMap(array, iteratee2) {
    var index = -1, length = array == null ? 0 : array.length, result2 = Array(length);
    while (++index < length) {
      result2[index] = iteratee2(array[index], index, array);
    }
    return result2;
  }
  var arrayMap_default = arrayMap;

  // node_modules/lodash-es/isArray.js
  init_define_process();
  var isArray = Array.isArray;
  var isArray_default = isArray;

  // node_modules/lodash-es/_baseToString.js
  var INFINITY = 1 / 0;
  var symbolProto = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolToString = symbolProto ? symbolProto.toString : void 0;
  function baseToString(value) {
    if (typeof value == "string") {
      return value;
    }
    if (isArray_default(value)) {
      return arrayMap_default(value, baseToString) + "";
    }
    if (isSymbol_default(value)) {
      return symbolToString ? symbolToString.call(value) : "";
    }
    var result2 = value + "";
    return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
  }
  var baseToString_default = baseToString;

  // node_modules/lodash-es/_createMathOperation.js
  function createMathOperation(operator, defaultValue) {
    return function(value, other) {
      var result2;
      if (value === void 0 && other === void 0) {
        return defaultValue;
      }
      if (value !== void 0) {
        result2 = value;
      }
      if (other !== void 0) {
        if (result2 === void 0) {
          return other;
        }
        if (typeof value == "string" || typeof other == "string") {
          value = baseToString_default(value);
          other = baseToString_default(other);
        } else {
          value = baseToNumber_default(value);
          other = baseToNumber_default(other);
        }
        result2 = operator(value, other);
      }
      return result2;
    };
  }
  var createMathOperation_default = createMathOperation;

  // node_modules/lodash-es/add.js
  var add = createMathOperation_default(function(augend, addend) {
    return augend + addend;
  }, 0);
  var add_default = add;

  // node_modules/lodash-es/after.js
  init_define_process();

  // node_modules/lodash-es/toInteger.js
  init_define_process();

  // node_modules/lodash-es/toFinite.js
  init_define_process();

  // node_modules/lodash-es/toNumber.js
  init_define_process();

  // node_modules/lodash-es/_baseTrim.js
  init_define_process();

  // node_modules/lodash-es/_trimmedEndIndex.js
  init_define_process();
  var reWhitespace = /\s/;
  function trimmedEndIndex(string) {
    var index = string.length;
    while (index-- && reWhitespace.test(string.charAt(index))) {
    }
    return index;
  }
  var trimmedEndIndex_default = trimmedEndIndex;

  // node_modules/lodash-es/_baseTrim.js
  var reTrimStart = /^\s+/;
  function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex_default(string) + 1).replace(reTrimStart, "") : string;
  }
  var baseTrim_default = baseTrim;

  // node_modules/lodash-es/isObject.js
  init_define_process();
  function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
  }
  var isObject_default = isObject;

  // node_modules/lodash-es/toNumber.js
  var NAN2 = 0 / 0;
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  var reIsBinary = /^0b[01]+$/i;
  var reIsOctal = /^0o[0-7]+$/i;
  var freeParseInt = parseInt;
  function toNumber(value) {
    if (typeof value == "number") {
      return value;
    }
    if (isSymbol_default(value)) {
      return NAN2;
    }
    if (isObject_default(value)) {
      var other = typeof value.valueOf == "function" ? value.valueOf() : value;
      value = isObject_default(other) ? other + "" : other;
    }
    if (typeof value != "string") {
      return value === 0 ? value : +value;
    }
    value = baseTrim_default(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN2 : +value;
  }
  var toNumber_default = toNumber;

  // node_modules/lodash-es/toFinite.js
  var INFINITY2 = 1 / 0;
  var MAX_INTEGER = 17976931348623157e292;
  function toFinite(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }
    value = toNumber_default(value);
    if (value === INFINITY2 || value === -INFINITY2) {
      var sign = value < 0 ? -1 : 1;
      return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
  }
  var toFinite_default = toFinite;

  // node_modules/lodash-es/toInteger.js
  function toInteger(value) {
    var result2 = toFinite_default(value), remainder = result2 % 1;
    return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
  }
  var toInteger_default = toInteger;

  // node_modules/lodash-es/after.js
  var FUNC_ERROR_TEXT = "Expected a function";
  function after(n, func) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    n = toInteger_default(n);
    return function() {
      if (--n < 1) {
        return func.apply(this, arguments);
      }
    };
  }
  var after_default = after;

  // node_modules/lodash-es/ary.js
  init_define_process();

  // node_modules/lodash-es/_createWrap.js
  init_define_process();

  // node_modules/lodash-es/_baseSetData.js
  init_define_process();

  // node_modules/lodash-es/identity.js
  init_define_process();
  function identity(value) {
    return value;
  }
  var identity_default = identity;

  // node_modules/lodash-es/_metaMap.js
  init_define_process();

  // node_modules/lodash-es/_WeakMap.js
  init_define_process();

  // node_modules/lodash-es/_getNative.js
  init_define_process();

  // node_modules/lodash-es/_baseIsNative.js
  init_define_process();

  // node_modules/lodash-es/isFunction.js
  init_define_process();
  var asyncTag = "[object AsyncFunction]";
  var funcTag = "[object Function]";
  var genTag = "[object GeneratorFunction]";
  var proxyTag = "[object Proxy]";
  function isFunction(value) {
    if (!isObject_default(value)) {
      return false;
    }
    var tag = baseGetTag_default(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  var isFunction_default = isFunction;

  // node_modules/lodash-es/_isMasked.js
  init_define_process();

  // node_modules/lodash-es/_coreJsData.js
  init_define_process();
  var coreJsData = root_default["__core-js_shared__"];
  var coreJsData_default = coreJsData;

  // node_modules/lodash-es/_isMasked.js
  var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData_default && coreJsData_default.keys && coreJsData_default.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  var isMasked_default = isMasked;

  // node_modules/lodash-es/_toSource.js
  init_define_process();
  var funcProto = Function.prototype;
  var funcToString = funcProto.toString;
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  var toSource_default = toSource;

  // node_modules/lodash-es/_baseIsNative.js
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var funcProto2 = Function.prototype;
  var objectProto3 = Object.prototype;
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto3.hasOwnProperty;
  var reIsNative = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function baseIsNative(value) {
    if (!isObject_default(value) || isMasked_default(value)) {
      return false;
    }
    var pattern = isFunction_default(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource_default(value));
  }
  var baseIsNative_default = baseIsNative;

  // node_modules/lodash-es/_getValue.js
  init_define_process();
  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }
  var getValue_default = getValue;

  // node_modules/lodash-es/_getNative.js
  function getNative(object, key) {
    var value = getValue_default(object, key);
    return baseIsNative_default(value) ? value : void 0;
  }
  var getNative_default = getNative;

  // node_modules/lodash-es/_WeakMap.js
  var WeakMap2 = getNative_default(root_default, "WeakMap");
  var WeakMap_default = WeakMap2;

  // node_modules/lodash-es/_metaMap.js
  var metaMap = WeakMap_default && new WeakMap_default();
  var metaMap_default = metaMap;

  // node_modules/lodash-es/_baseSetData.js
  var baseSetData = !metaMap_default ? identity_default : function(func, data) {
    metaMap_default.set(func, data);
    return func;
  };
  var baseSetData_default = baseSetData;

  // node_modules/lodash-es/_createBind.js
  init_define_process();

  // node_modules/lodash-es/_createCtor.js
  init_define_process();

  // node_modules/lodash-es/_baseCreate.js
  init_define_process();
  var objectCreate = Object.create;
  var baseCreate = function() {
    function object() {
    }
    return function(proto) {
      if (!isObject_default(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result2 = new object();
      object.prototype = void 0;
      return result2;
    };
  }();
  var baseCreate_default = baseCreate;

  // node_modules/lodash-es/_createCtor.js
  function createCtor(Ctor) {
    return function() {
      var args = arguments;
      switch (args.length) {
        case 0:
          return new Ctor();
        case 1:
          return new Ctor(args[0]);
        case 2:
          return new Ctor(args[0], args[1]);
        case 3:
          return new Ctor(args[0], args[1], args[2]);
        case 4:
          return new Ctor(args[0], args[1], args[2], args[3]);
        case 5:
          return new Ctor(args[0], args[1], args[2], args[3], args[4]);
        case 6:
          return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
        case 7:
          return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
      }
      var thisBinding = baseCreate_default(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
      return isObject_default(result2) ? result2 : thisBinding;
    };
  }
  var createCtor_default = createCtor;

  // node_modules/lodash-es/_createBind.js
  var WRAP_BIND_FLAG = 1;
  function createBind(func, bitmask, thisArg) {
    var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor_default(func);
    function wrapper() {
      var fn = this && this !== root_default && this instanceof wrapper ? Ctor : func;
      return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
  }
  var createBind_default = createBind;

  // node_modules/lodash-es/_createCurry.js
  init_define_process();

  // node_modules/lodash-es/_apply.js
  init_define_process();
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  var apply_default = apply;

  // node_modules/lodash-es/_createHybrid.js
  init_define_process();

  // node_modules/lodash-es/_composeArgs.js
  init_define_process();
  var nativeMax = Math.max;
  function composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while (++leftIndex < leftLength) {
      result2[leftIndex] = partials[leftIndex];
    }
    while (++argsIndex < holdersLength) {
      if (isUncurried || argsIndex < argsLength) {
        result2[holders[argsIndex]] = args[argsIndex];
      }
    }
    while (rangeLength--) {
      result2[leftIndex++] = args[argsIndex++];
    }
    return result2;
  }
  var composeArgs_default = composeArgs;

  // node_modules/lodash-es/_composeArgsRight.js
  init_define_process();
  var nativeMax2 = Math.max;
  function composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while (++argsIndex < rangeLength) {
      result2[argsIndex] = args[argsIndex];
    }
    var offset = argsIndex;
    while (++rightIndex < rightLength) {
      result2[offset + rightIndex] = partials[rightIndex];
    }
    while (++holdersIndex < holdersLength) {
      if (isUncurried || argsIndex < argsLength) {
        result2[offset + holders[holdersIndex]] = args[argsIndex++];
      }
    }
    return result2;
  }
  var composeArgsRight_default = composeArgsRight;

  // node_modules/lodash-es/_countHolders.js
  init_define_process();
  function countHolders(array, placeholder) {
    var length = array.length, result2 = 0;
    while (length--) {
      if (array[length] === placeholder) {
        ++result2;
      }
    }
    return result2;
  }
  var countHolders_default = countHolders;

  // node_modules/lodash-es/_createRecurry.js
  init_define_process();

  // node_modules/lodash-es/_isLaziable.js
  init_define_process();

  // node_modules/lodash-es/_LazyWrapper.js
  init_define_process();

  // node_modules/lodash-es/_baseLodash.js
  init_define_process();
  function baseLodash() {
  }
  var baseLodash_default = baseLodash;

  // node_modules/lodash-es/_LazyWrapper.js
  var MAX_ARRAY_LENGTH = 4294967295;
  function LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = MAX_ARRAY_LENGTH;
    this.__views__ = [];
  }
  LazyWrapper.prototype = baseCreate_default(baseLodash_default.prototype);
  LazyWrapper.prototype.constructor = LazyWrapper;
  var LazyWrapper_default = LazyWrapper;

  // node_modules/lodash-es/_getData.js
  init_define_process();

  // node_modules/lodash-es/noop.js
  init_define_process();
  function noop() {
  }
  var noop_default = noop;

  // node_modules/lodash-es/_getData.js
  var getData = !metaMap_default ? noop_default : function(func) {
    return metaMap_default.get(func);
  };
  var getData_default = getData;

  // node_modules/lodash-es/_getFuncName.js
  init_define_process();

  // node_modules/lodash-es/_realNames.js
  init_define_process();
  var realNames = {};
  var realNames_default = realNames;

  // node_modules/lodash-es/_getFuncName.js
  var objectProto4 = Object.prototype;
  var hasOwnProperty3 = objectProto4.hasOwnProperty;
  function getFuncName(func) {
    var result2 = func.name + "", array = realNames_default[result2], length = hasOwnProperty3.call(realNames_default, result2) ? array.length : 0;
    while (length--) {
      var data = array[length], otherFunc = data.func;
      if (otherFunc == null || otherFunc == func) {
        return data.name;
      }
    }
    return result2;
  }
  var getFuncName_default = getFuncName;

  // node_modules/lodash-es/wrapperLodash.js
  init_define_process();

  // node_modules/lodash-es/_LodashWrapper.js
  init_define_process();
  function LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = void 0;
  }
  LodashWrapper.prototype = baseCreate_default(baseLodash_default.prototype);
  LodashWrapper.prototype.constructor = LodashWrapper;
  var LodashWrapper_default = LodashWrapper;

  // node_modules/lodash-es/_wrapperClone.js
  init_define_process();

  // node_modules/lodash-es/_copyArray.js
  init_define_process();
  function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }
  var copyArray_default = copyArray;

  // node_modules/lodash-es/_wrapperClone.js
  function wrapperClone(wrapper) {
    if (wrapper instanceof LazyWrapper_default) {
      return wrapper.clone();
    }
    var result2 = new LodashWrapper_default(wrapper.__wrapped__, wrapper.__chain__);
    result2.__actions__ = copyArray_default(wrapper.__actions__);
    result2.__index__ = wrapper.__index__;
    result2.__values__ = wrapper.__values__;
    return result2;
  }
  var wrapperClone_default = wrapperClone;

  // node_modules/lodash-es/wrapperLodash.js
  var objectProto5 = Object.prototype;
  var hasOwnProperty4 = objectProto5.hasOwnProperty;
  function lodash(value) {
    if (isObjectLike_default(value) && !isArray_default(value) && !(value instanceof LazyWrapper_default)) {
      if (value instanceof LodashWrapper_default) {
        return value;
      }
      if (hasOwnProperty4.call(value, "__wrapped__")) {
        return wrapperClone_default(value);
      }
    }
    return new LodashWrapper_default(value);
  }
  lodash.prototype = baseLodash_default.prototype;
  lodash.prototype.constructor = lodash;
  var wrapperLodash_default = lodash;

  // node_modules/lodash-es/_isLaziable.js
  function isLaziable(func) {
    var funcName = getFuncName_default(func), other = wrapperLodash_default[funcName];
    if (typeof other != "function" || !(funcName in LazyWrapper_default.prototype)) {
      return false;
    }
    if (func === other) {
      return true;
    }
    var data = getData_default(other);
    return !!data && func === data[0];
  }
  var isLaziable_default = isLaziable;

  // node_modules/lodash-es/_setData.js
  init_define_process();

  // node_modules/lodash-es/_shortOut.js
  init_define_process();
  var HOT_COUNT = 800;
  var HOT_SPAN = 16;
  var nativeNow = Date.now;
  function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
      var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(void 0, arguments);
    };
  }
  var shortOut_default = shortOut;

  // node_modules/lodash-es/_setData.js
  var setData = shortOut_default(baseSetData_default);
  var setData_default = setData;

  // node_modules/lodash-es/_setWrapToString.js
  init_define_process();

  // node_modules/lodash-es/_getWrapDetails.js
  init_define_process();
  var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/;
  var reSplitDetails = /,? & /;
  function getWrapDetails(source) {
    var match = source.match(reWrapDetails);
    return match ? match[1].split(reSplitDetails) : [];
  }
  var getWrapDetails_default = getWrapDetails;

  // node_modules/lodash-es/_insertWrapDetails.js
  init_define_process();
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
  function insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) {
      return source;
    }
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
    details = details.join(length > 2 ? ", " : " ");
    return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
  }
  var insertWrapDetails_default = insertWrapDetails;

  // node_modules/lodash-es/_setToString.js
  init_define_process();

  // node_modules/lodash-es/_baseSetToString.js
  init_define_process();

  // node_modules/lodash-es/constant.js
  init_define_process();
  function constant(value) {
    return function() {
      return value;
    };
  }
  var constant_default = constant;

  // node_modules/lodash-es/_defineProperty.js
  init_define_process();
  var defineProperty = function() {
    try {
      var func = getNative_default(Object, "defineProperty");
      func({}, "", {});
      return func;
    } catch (e) {
    }
  }();
  var defineProperty_default = defineProperty;

  // node_modules/lodash-es/_baseSetToString.js
  var baseSetToString = !defineProperty_default ? identity_default : function(func, string) {
    return defineProperty_default(func, "toString", {
      "configurable": true,
      "enumerable": false,
      "value": constant_default(string),
      "writable": true
    });
  };
  var baseSetToString_default = baseSetToString;

  // node_modules/lodash-es/_setToString.js
  var setToString = shortOut_default(baseSetToString_default);
  var setToString_default = setToString;

  // node_modules/lodash-es/_updateWrapDetails.js
  init_define_process();

  // node_modules/lodash-es/_arrayEach.js
  init_define_process();
  function arrayEach(array, iteratee2) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (iteratee2(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }
  var arrayEach_default = arrayEach;

  // node_modules/lodash-es/_arrayIncludes.js
  init_define_process();

  // node_modules/lodash-es/_baseIndexOf.js
  init_define_process();

  // node_modules/lodash-es/_baseFindIndex.js
  init_define_process();
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while (fromRight ? index-- : ++index < length) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }
  var baseFindIndex_default = baseFindIndex;

  // node_modules/lodash-es/_baseIsNaN.js
  init_define_process();
  function baseIsNaN(value) {
    return value !== value;
  }
  var baseIsNaN_default = baseIsNaN;

  // node_modules/lodash-es/_strictIndexOf.js
  init_define_process();
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }
  var strictIndexOf_default = strictIndexOf;

  // node_modules/lodash-es/_baseIndexOf.js
  function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf_default(array, value, fromIndex) : baseFindIndex_default(array, baseIsNaN_default, fromIndex);
  }
  var baseIndexOf_default = baseIndexOf;

  // node_modules/lodash-es/_arrayIncludes.js
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf_default(array, value, 0) > -1;
  }
  var arrayIncludes_default = arrayIncludes;

  // node_modules/lodash-es/_updateWrapDetails.js
  var WRAP_BIND_FLAG2 = 1;
  var WRAP_BIND_KEY_FLAG = 2;
  var WRAP_CURRY_FLAG = 8;
  var WRAP_CURRY_RIGHT_FLAG = 16;
  var WRAP_PARTIAL_FLAG = 32;
  var WRAP_PARTIAL_RIGHT_FLAG = 64;
  var WRAP_ARY_FLAG = 128;
  var WRAP_REARG_FLAG = 256;
  var WRAP_FLIP_FLAG = 512;
  var wrapFlags = [
    ["ary", WRAP_ARY_FLAG],
    ["bind", WRAP_BIND_FLAG2],
    ["bindKey", WRAP_BIND_KEY_FLAG],
    ["curry", WRAP_CURRY_FLAG],
    ["curryRight", WRAP_CURRY_RIGHT_FLAG],
    ["flip", WRAP_FLIP_FLAG],
    ["partial", WRAP_PARTIAL_FLAG],
    ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
    ["rearg", WRAP_REARG_FLAG]
  ];
  function updateWrapDetails(details, bitmask) {
    arrayEach_default(wrapFlags, function(pair) {
      var value = "_." + pair[0];
      if (bitmask & pair[1] && !arrayIncludes_default(details, value)) {
        details.push(value);
      }
    });
    return details.sort();
  }
  var updateWrapDetails_default = updateWrapDetails;

  // node_modules/lodash-es/_setWrapToString.js
  function setWrapToString(wrapper, reference, bitmask) {
    var source = reference + "";
    return setToString_default(wrapper, insertWrapDetails_default(source, updateWrapDetails_default(getWrapDetails_default(source), bitmask)));
  }
  var setWrapToString_default = setWrapToString;

  // node_modules/lodash-es/_createRecurry.js
  var WRAP_BIND_FLAG3 = 1;
  var WRAP_BIND_KEY_FLAG2 = 2;
  var WRAP_CURRY_BOUND_FLAG = 4;
  var WRAP_CURRY_FLAG2 = 8;
  var WRAP_PARTIAL_FLAG2 = 32;
  var WRAP_PARTIAL_RIGHT_FLAG2 = 64;
  function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
    var isCurry = bitmask & WRAP_CURRY_FLAG2, newHolders = isCurry ? holders : void 0, newHoldersRight = isCurry ? void 0 : holders, newPartials = isCurry ? partials : void 0, newPartialsRight = isCurry ? void 0 : partials;
    bitmask |= isCurry ? WRAP_PARTIAL_FLAG2 : WRAP_PARTIAL_RIGHT_FLAG2;
    bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG2 : WRAP_PARTIAL_FLAG2);
    if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
      bitmask &= ~(WRAP_BIND_FLAG3 | WRAP_BIND_KEY_FLAG2);
    }
    var newData = [
      func,
      bitmask,
      thisArg,
      newPartials,
      newHolders,
      newPartialsRight,
      newHoldersRight,
      argPos,
      ary2,
      arity
    ];
    var result2 = wrapFunc.apply(void 0, newData);
    if (isLaziable_default(func)) {
      setData_default(result2, newData);
    }
    result2.placeholder = placeholder;
    return setWrapToString_default(result2, func, bitmask);
  }
  var createRecurry_default = createRecurry;

  // node_modules/lodash-es/_getHolder.js
  init_define_process();
  function getHolder(func) {
    var object = func;
    return object.placeholder;
  }
  var getHolder_default = getHolder;

  // node_modules/lodash-es/_reorder.js
  init_define_process();

  // node_modules/lodash-es/_isIndex.js
  init_define_process();
  var MAX_SAFE_INTEGER = 9007199254740991;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  var isIndex_default = isIndex;

  // node_modules/lodash-es/_reorder.js
  var nativeMin = Math.min;
  function reorder(array, indexes) {
    var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray_default(array);
    while (length--) {
      var index = indexes[length];
      array[length] = isIndex_default(index, arrLength) ? oldArray[index] : void 0;
    }
    return array;
  }
  var reorder_default = reorder;

  // node_modules/lodash-es/_replaceHolders.js
  init_define_process();
  var PLACEHOLDER = "__lodash_placeholder__";
  function replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result2[resIndex++] = index;
      }
    }
    return result2;
  }
  var replaceHolders_default = replaceHolders;

  // node_modules/lodash-es/_createHybrid.js
  var WRAP_BIND_FLAG4 = 1;
  var WRAP_BIND_KEY_FLAG3 = 2;
  var WRAP_CURRY_FLAG3 = 8;
  var WRAP_CURRY_RIGHT_FLAG2 = 16;
  var WRAP_ARY_FLAG2 = 128;
  var WRAP_FLIP_FLAG2 = 512;
  function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
    var isAry = bitmask & WRAP_ARY_FLAG2, isBind = bitmask & WRAP_BIND_FLAG4, isBindKey = bitmask & WRAP_BIND_KEY_FLAG3, isCurried = bitmask & (WRAP_CURRY_FLAG3 | WRAP_CURRY_RIGHT_FLAG2), isFlip = bitmask & WRAP_FLIP_FLAG2, Ctor = isBindKey ? void 0 : createCtor_default(func);
    function wrapper() {
      var length = arguments.length, args = Array(length), index = length;
      while (index--) {
        args[index] = arguments[index];
      }
      if (isCurried) {
        var placeholder = getHolder_default(wrapper), holdersCount = countHolders_default(args, placeholder);
      }
      if (partials) {
        args = composeArgs_default(args, partials, holders, isCurried);
      }
      if (partialsRight) {
        args = composeArgsRight_default(args, partialsRight, holdersRight, isCurried);
      }
      length -= holdersCount;
      if (isCurried && length < arity) {
        var newHolders = replaceHolders_default(args, placeholder);
        return createRecurry_default(
          func,
          bitmask,
          createHybrid,
          wrapper.placeholder,
          thisArg,
          args,
          newHolders,
          argPos,
          ary2,
          arity - length
        );
      }
      var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
      length = args.length;
      if (argPos) {
        args = reorder_default(args, argPos);
      } else if (isFlip && length > 1) {
        args.reverse();
      }
      if (isAry && ary2 < length) {
        args.length = ary2;
      }
      if (this && this !== root_default && this instanceof wrapper) {
        fn = Ctor || createCtor_default(fn);
      }
      return fn.apply(thisBinding, args);
    }
    return wrapper;
  }
  var createHybrid_default = createHybrid;

  // node_modules/lodash-es/_createCurry.js
  function createCurry(func, bitmask, arity) {
    var Ctor = createCtor_default(func);
    function wrapper() {
      var length = arguments.length, args = Array(length), index = length, placeholder = getHolder_default(wrapper);
      while (index--) {
        args[index] = arguments[index];
      }
      var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders_default(args, placeholder);
      length -= holders.length;
      if (length < arity) {
        return createRecurry_default(
          func,
          bitmask,
          createHybrid_default,
          wrapper.placeholder,
          void 0,
          args,
          holders,
          void 0,
          void 0,
          arity - length
        );
      }
      var fn = this && this !== root_default && this instanceof wrapper ? Ctor : func;
      return apply_default(fn, this, args);
    }
    return wrapper;
  }
  var createCurry_default = createCurry;

  // node_modules/lodash-es/_createPartial.js
  init_define_process();
  var WRAP_BIND_FLAG5 = 1;
  function createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & WRAP_BIND_FLAG5, Ctor = createCtor_default(func);
    function wrapper() {
      var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== root_default && this instanceof wrapper ? Ctor : func;
      while (++leftIndex < leftLength) {
        args[leftIndex] = partials[leftIndex];
      }
      while (argsLength--) {
        args[leftIndex++] = arguments[++argsIndex];
      }
      return apply_default(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
  }
  var createPartial_default = createPartial;

  // node_modules/lodash-es/_mergeData.js
  init_define_process();
  var PLACEHOLDER2 = "__lodash_placeholder__";
  var WRAP_BIND_FLAG6 = 1;
  var WRAP_BIND_KEY_FLAG4 = 2;
  var WRAP_CURRY_BOUND_FLAG2 = 4;
  var WRAP_CURRY_FLAG4 = 8;
  var WRAP_ARY_FLAG3 = 128;
  var WRAP_REARG_FLAG2 = 256;
  var nativeMin2 = Math.min;
  function mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG6 | WRAP_BIND_KEY_FLAG4 | WRAP_ARY_FLAG3);
    var isCombo = srcBitmask == WRAP_ARY_FLAG3 && bitmask == WRAP_CURRY_FLAG4 || srcBitmask == WRAP_ARY_FLAG3 && bitmask == WRAP_REARG_FLAG2 && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG3 | WRAP_REARG_FLAG2) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG4;
    if (!(isCommon || isCombo)) {
      return data;
    }
    if (srcBitmask & WRAP_BIND_FLAG6) {
      data[2] = source[2];
      newBitmask |= bitmask & WRAP_BIND_FLAG6 ? 0 : WRAP_CURRY_BOUND_FLAG2;
    }
    var value = source[3];
    if (value) {
      var partials = data[3];
      data[3] = partials ? composeArgs_default(partials, value, source[4]) : value;
      data[4] = partials ? replaceHolders_default(data[3], PLACEHOLDER2) : source[4];
    }
    value = source[5];
    if (value) {
      partials = data[5];
      data[5] = partials ? composeArgsRight_default(partials, value, source[6]) : value;
      data[6] = partials ? replaceHolders_default(data[5], PLACEHOLDER2) : source[6];
    }
    value = source[7];
    if (value) {
      data[7] = value;
    }
    if (srcBitmask & WRAP_ARY_FLAG3) {
      data[8] = data[8] == null ? source[8] : nativeMin2(data[8], source[8]);
    }
    if (data[9] == null) {
      data[9] = source[9];
    }
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
  }
  var mergeData_default = mergeData;

  // node_modules/lodash-es/_createWrap.js
  var FUNC_ERROR_TEXT2 = "Expected a function";
  var WRAP_BIND_FLAG7 = 1;
  var WRAP_BIND_KEY_FLAG5 = 2;
  var WRAP_CURRY_FLAG5 = 8;
  var WRAP_CURRY_RIGHT_FLAG3 = 16;
  var WRAP_PARTIAL_FLAG3 = 32;
  var WRAP_PARTIAL_RIGHT_FLAG3 = 64;
  var nativeMax3 = Math.max;
  function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
    var isBindKey = bitmask & WRAP_BIND_KEY_FLAG5;
    if (!isBindKey && typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT2);
    }
    var length = partials ? partials.length : 0;
    if (!length) {
      bitmask &= ~(WRAP_PARTIAL_FLAG3 | WRAP_PARTIAL_RIGHT_FLAG3);
      partials = holders = void 0;
    }
    ary2 = ary2 === void 0 ? ary2 : nativeMax3(toInteger_default(ary2), 0);
    arity = arity === void 0 ? arity : toInteger_default(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & WRAP_PARTIAL_RIGHT_FLAG3) {
      var partialsRight = partials, holdersRight = holders;
      partials = holders = void 0;
    }
    var data = isBindKey ? void 0 : getData_default(func);
    var newData = [
      func,
      bitmask,
      thisArg,
      partials,
      holders,
      partialsRight,
      holdersRight,
      argPos,
      ary2,
      arity
    ];
    if (data) {
      mergeData_default(newData, data);
    }
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === void 0 ? isBindKey ? 0 : func.length : nativeMax3(newData[9] - length, 0);
    if (!arity && bitmask & (WRAP_CURRY_FLAG5 | WRAP_CURRY_RIGHT_FLAG3)) {
      bitmask &= ~(WRAP_CURRY_FLAG5 | WRAP_CURRY_RIGHT_FLAG3);
    }
    if (!bitmask || bitmask == WRAP_BIND_FLAG7) {
      var result2 = createBind_default(func, bitmask, thisArg);
    } else if (bitmask == WRAP_CURRY_FLAG5 || bitmask == WRAP_CURRY_RIGHT_FLAG3) {
      result2 = createCurry_default(func, bitmask, arity);
    } else if ((bitmask == WRAP_PARTIAL_FLAG3 || bitmask == (WRAP_BIND_FLAG7 | WRAP_PARTIAL_FLAG3)) && !holders.length) {
      result2 = createPartial_default(func, bitmask, thisArg, partials);
    } else {
      result2 = createHybrid_default.apply(void 0, newData);
    }
    var setter = data ? baseSetData_default : setData_default;
    return setWrapToString_default(setter(result2, newData), func, bitmask);
  }
  var createWrap_default = createWrap;

  // node_modules/lodash-es/ary.js
  var WRAP_ARY_FLAG4 = 128;
  function ary(func, n, guard) {
    n = guard ? void 0 : n;
    n = func && n == null ? func.length : n;
    return createWrap_default(func, WRAP_ARY_FLAG4, void 0, void 0, void 0, void 0, n);
  }
  var ary_default = ary;

  // node_modules/lodash-es/assign.js
  init_define_process();

  // node_modules/lodash-es/_assignValue.js
  init_define_process();

  // node_modules/lodash-es/_baseAssignValue.js
  init_define_process();
  function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty_default) {
      defineProperty_default(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
      });
    } else {
      object[key] = value;
    }
  }
  var baseAssignValue_default = baseAssignValue;

  // node_modules/lodash-es/eq.js
  init_define_process();
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  var eq_default = eq;

  // node_modules/lodash-es/_assignValue.js
  var objectProto6 = Object.prototype;
  var hasOwnProperty5 = objectProto6.hasOwnProperty;
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty5.call(object, key) && eq_default(objValue, value)) || value === void 0 && !(key in object)) {
      baseAssignValue_default(object, key, value);
    }
  }
  var assignValue_default = assignValue;

  // node_modules/lodash-es/_copyObject.js
  init_define_process();
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
      if (newValue === void 0) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue_default(object, key, newValue);
      } else {
        assignValue_default(object, key, newValue);
      }
    }
    return object;
  }
  var copyObject_default = copyObject;

  // node_modules/lodash-es/_createAssigner.js
  init_define_process();

  // node_modules/lodash-es/_baseRest.js
  init_define_process();

  // node_modules/lodash-es/_overRest.js
  init_define_process();
  var nativeMax4 = Math.max;
  function overRest(func, start, transform2) {
    start = nativeMax4(start === void 0 ? func.length - 1 : start, 0);
    return function() {
      var args = arguments, index = -1, length = nativeMax4(args.length - start, 0), array = Array(length);
      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform2(array);
      return apply_default(func, this, otherArgs);
    };
  }
  var overRest_default = overRest;

  // node_modules/lodash-es/_baseRest.js
  function baseRest(func, start) {
    return setToString_default(overRest_default(func, start, identity_default), func + "");
  }
  var baseRest_default = baseRest;

  // node_modules/lodash-es/_isIterateeCall.js
  init_define_process();

  // node_modules/lodash-es/isArrayLike.js
  init_define_process();

  // node_modules/lodash-es/isLength.js
  init_define_process();
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  var isLength_default = isLength;

  // node_modules/lodash-es/isArrayLike.js
  function isArrayLike(value) {
    return value != null && isLength_default(value.length) && !isFunction_default(value);
  }
  var isArrayLike_default = isArrayLike;

  // node_modules/lodash-es/_isIterateeCall.js
  function isIterateeCall(value, index, object) {
    if (!isObject_default(object)) {
      return false;
    }
    var type = typeof index;
    if (type == "number" ? isArrayLike_default(object) && isIndex_default(index, object.length) : type == "string" && index in object) {
      return eq_default(object[index], value);
    }
    return false;
  }
  var isIterateeCall_default = isIterateeCall;

  // node_modules/lodash-es/_createAssigner.js
  function createAssigner(assigner) {
    return baseRest_default(function(object, sources) {
      var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
      customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
      if (guard && isIterateeCall_default(sources[0], sources[1], guard)) {
        customizer = length < 3 ? void 0 : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }
  var createAssigner_default = createAssigner;

  // node_modules/lodash-es/_isPrototype.js
  init_define_process();
  var objectProto7 = Object.prototype;
  function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto7;
    return value === proto;
  }
  var isPrototype_default = isPrototype;

  // node_modules/lodash-es/keys.js
  init_define_process();

  // node_modules/lodash-es/_arrayLikeKeys.js
  init_define_process();

  // node_modules/lodash-es/_baseTimes.js
  init_define_process();
  function baseTimes(n, iteratee2) {
    var index = -1, result2 = Array(n);
    while (++index < n) {
      result2[index] = iteratee2(index);
    }
    return result2;
  }
  var baseTimes_default = baseTimes;

  // node_modules/lodash-es/isArguments.js
  init_define_process();

  // node_modules/lodash-es/_baseIsArguments.js
  init_define_process();
  var argsTag = "[object Arguments]";
  function baseIsArguments(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == argsTag;
  }
  var baseIsArguments_default = baseIsArguments;

  // node_modules/lodash-es/isArguments.js
  var objectProto8 = Object.prototype;
  var hasOwnProperty6 = objectProto8.hasOwnProperty;
  var propertyIsEnumerable = objectProto8.propertyIsEnumerable;
  var isArguments = baseIsArguments_default(function() {
    return arguments;
  }()) ? baseIsArguments_default : function(value) {
    return isObjectLike_default(value) && hasOwnProperty6.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
  };
  var isArguments_default = isArguments;

  // node_modules/lodash-es/isBuffer.js
  init_define_process();

  // node_modules/lodash-es/stubFalse.js
  init_define_process();
  function stubFalse() {
    return false;
  }
  var stubFalse_default = stubFalse;

  // node_modules/lodash-es/isBuffer.js
  var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer3 = moduleExports ? root_default.Buffer : void 0;
  var nativeIsBuffer = Buffer3 ? Buffer3.isBuffer : void 0;
  var isBuffer = nativeIsBuffer || stubFalse_default;
  var isBuffer_default = isBuffer;

  // node_modules/lodash-es/isTypedArray.js
  init_define_process();

  // node_modules/lodash-es/_baseIsTypedArray.js
  init_define_process();
  var argsTag2 = "[object Arguments]";
  var arrayTag = "[object Array]";
  var boolTag = "[object Boolean]";
  var dateTag = "[object Date]";
  var errorTag = "[object Error]";
  var funcTag2 = "[object Function]";
  var mapTag = "[object Map]";
  var numberTag = "[object Number]";
  var objectTag = "[object Object]";
  var regexpTag = "[object RegExp]";
  var setTag = "[object Set]";
  var stringTag = "[object String]";
  var weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]";
  var dataViewTag = "[object DataView]";
  var float32Tag = "[object Float32Array]";
  var float64Tag = "[object Float64Array]";
  var int8Tag = "[object Int8Array]";
  var int16Tag = "[object Int16Array]";
  var int32Tag = "[object Int32Array]";
  var uint8Tag = "[object Uint8Array]";
  var uint8ClampedTag = "[object Uint8ClampedArray]";
  var uint16Tag = "[object Uint16Array]";
  var uint32Tag = "[object Uint32Array]";
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  function baseIsTypedArray(value) {
    return isObjectLike_default(value) && isLength_default(value.length) && !!typedArrayTags[baseGetTag_default(value)];
  }
  var baseIsTypedArray_default = baseIsTypedArray;

  // node_modules/lodash-es/_baseUnary.js
  init_define_process();
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }
  var baseUnary_default = baseUnary;

  // node_modules/lodash-es/_nodeUtil.js
  init_define_process();
  var freeExports2 = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule2 = freeExports2 && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
  var freeProcess = moduleExports2 && freeGlobal_default.process;
  var nodeUtil = function() {
    try {
      var types = freeModule2 && freeModule2.require && freeModule2.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeUtil_default = nodeUtil;

  // node_modules/lodash-es/isTypedArray.js
  var nodeIsTypedArray = nodeUtil_default && nodeUtil_default.isTypedArray;
  var isTypedArray = nodeIsTypedArray ? baseUnary_default(nodeIsTypedArray) : baseIsTypedArray_default;
  var isTypedArray_default = isTypedArray;

  // node_modules/lodash-es/_arrayLikeKeys.js
  var objectProto9 = Object.prototype;
  var hasOwnProperty7 = objectProto9.hasOwnProperty;
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray_default(value), isArg = !isArr && isArguments_default(value), isBuff = !isArr && !isArg && isBuffer_default(value), isType = !isArr && !isArg && !isBuff && isTypedArray_default(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes_default(value.length, String) : [], length = result2.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty7.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex_default(key, length)))) {
        result2.push(key);
      }
    }
    return result2;
  }
  var arrayLikeKeys_default = arrayLikeKeys;

  // node_modules/lodash-es/_baseKeys.js
  init_define_process();

  // node_modules/lodash-es/_nativeKeys.js
  init_define_process();

  // node_modules/lodash-es/_overArg.js
  init_define_process();
  function overArg(func, transform2) {
    return function(arg) {
      return func(transform2(arg));
    };
  }
  var overArg_default = overArg;

  // node_modules/lodash-es/_nativeKeys.js
  var nativeKeys = overArg_default(Object.keys, Object);
  var nativeKeys_default = nativeKeys;

  // node_modules/lodash-es/_baseKeys.js
  var objectProto10 = Object.prototype;
  var hasOwnProperty8 = objectProto10.hasOwnProperty;
  function baseKeys(object) {
    if (!isPrototype_default(object)) {
      return nativeKeys_default(object);
    }
    var result2 = [];
    for (var key in Object(object)) {
      if (hasOwnProperty8.call(object, key) && key != "constructor") {
        result2.push(key);
      }
    }
    return result2;
  }
  var baseKeys_default = baseKeys;

  // node_modules/lodash-es/keys.js
  function keys(object) {
    return isArrayLike_default(object) ? arrayLikeKeys_default(object) : baseKeys_default(object);
  }
  var keys_default = keys;

  // node_modules/lodash-es/assign.js
  var objectProto11 = Object.prototype;
  var hasOwnProperty9 = objectProto11.hasOwnProperty;
  var assign = createAssigner_default(function(object, source) {
    if (isPrototype_default(source) || isArrayLike_default(source)) {
      copyObject_default(source, keys_default(source), object);
      return;
    }
    for (var key in source) {
      if (hasOwnProperty9.call(source, key)) {
        assignValue_default(object, key, source[key]);
      }
    }
  });
  var assign_default = assign;

  // node_modules/lodash-es/assignIn.js
  init_define_process();

  // node_modules/lodash-es/keysIn.js
  init_define_process();

  // node_modules/lodash-es/_baseKeysIn.js
  init_define_process();

  // node_modules/lodash-es/_nativeKeysIn.js
  init_define_process();
  function nativeKeysIn(object) {
    var result2 = [];
    if (object != null) {
      for (var key in Object(object)) {
        result2.push(key);
      }
    }
    return result2;
  }
  var nativeKeysIn_default = nativeKeysIn;

  // node_modules/lodash-es/_baseKeysIn.js
  var objectProto12 = Object.prototype;
  var hasOwnProperty10 = objectProto12.hasOwnProperty;
  function baseKeysIn(object) {
    if (!isObject_default(object)) {
      return nativeKeysIn_default(object);
    }
    var isProto = isPrototype_default(object), result2 = [];
    for (var key in object) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty10.call(object, key)))) {
        result2.push(key);
      }
    }
    return result2;
  }
  var baseKeysIn_default = baseKeysIn;

  // node_modules/lodash-es/keysIn.js
  function keysIn(object) {
    return isArrayLike_default(object) ? arrayLikeKeys_default(object, true) : baseKeysIn_default(object);
  }
  var keysIn_default = keysIn;

  // node_modules/lodash-es/assignIn.js
  var assignIn = createAssigner_default(function(object, source) {
    copyObject_default(source, keysIn_default(source), object);
  });
  var assignIn_default = assignIn;

  // node_modules/lodash-es/assignInWith.js
  init_define_process();
  var assignInWith = createAssigner_default(function(object, source, srcIndex, customizer) {
    copyObject_default(source, keysIn_default(source), object, customizer);
  });
  var assignInWith_default = assignInWith;

  // node_modules/lodash-es/assignWith.js
  init_define_process();
  var assignWith = createAssigner_default(function(object, source, srcIndex, customizer) {
    copyObject_default(source, keys_default(source), object, customizer);
  });
  var assignWith_default = assignWith;

  // node_modules/lodash-es/at.js
  init_define_process();

  // node_modules/lodash-es/_baseAt.js
  init_define_process();

  // node_modules/lodash-es/get.js
  init_define_process();

  // node_modules/lodash-es/_baseGet.js
  init_define_process();

  // node_modules/lodash-es/_castPath.js
  init_define_process();

  // node_modules/lodash-es/_isKey.js
  init_define_process();
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
  var reIsPlainProp = /^\w*$/;
  function isKey(value, object) {
    if (isArray_default(value)) {
      return false;
    }
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol_default(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  var isKey_default = isKey;

  // node_modules/lodash-es/_stringToPath.js
  init_define_process();

  // node_modules/lodash-es/_memoizeCapped.js
  init_define_process();

  // node_modules/lodash-es/memoize.js
  init_define_process();

  // node_modules/lodash-es/_MapCache.js
  init_define_process();

  // node_modules/lodash-es/_mapCacheClear.js
  init_define_process();

  // node_modules/lodash-es/_Hash.js
  init_define_process();

  // node_modules/lodash-es/_hashClear.js
  init_define_process();

  // node_modules/lodash-es/_nativeCreate.js
  init_define_process();
  var nativeCreate = getNative_default(Object, "create");
  var nativeCreate_default = nativeCreate;

  // node_modules/lodash-es/_hashClear.js
  function hashClear() {
    this.__data__ = nativeCreate_default ? nativeCreate_default(null) : {};
    this.size = 0;
  }
  var hashClear_default = hashClear;

  // node_modules/lodash-es/_hashDelete.js
  init_define_process();
  function hashDelete(key) {
    var result2 = this.has(key) && delete this.__data__[key];
    this.size -= result2 ? 1 : 0;
    return result2;
  }
  var hashDelete_default = hashDelete;

  // node_modules/lodash-es/_hashGet.js
  init_define_process();
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var objectProto13 = Object.prototype;
  var hasOwnProperty11 = objectProto13.hasOwnProperty;
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate_default) {
      var result2 = data[key];
      return result2 === HASH_UNDEFINED ? void 0 : result2;
    }
    return hasOwnProperty11.call(data, key) ? data[key] : void 0;
  }
  var hashGet_default = hashGet;

  // node_modules/lodash-es/_hashHas.js
  init_define_process();
  var objectProto14 = Object.prototype;
  var hasOwnProperty12 = objectProto14.hasOwnProperty;
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate_default ? data[key] !== void 0 : hasOwnProperty12.call(data, key);
  }
  var hashHas_default = hashHas;

  // node_modules/lodash-es/_hashSet.js
  init_define_process();
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate_default && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  var hashSet_default = hashSet;

  // node_modules/lodash-es/_Hash.js
  function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  Hash.prototype.clear = hashClear_default;
  Hash.prototype["delete"] = hashDelete_default;
  Hash.prototype.get = hashGet_default;
  Hash.prototype.has = hashHas_default;
  Hash.prototype.set = hashSet_default;
  var Hash_default = Hash;

  // node_modules/lodash-es/_ListCache.js
  init_define_process();

  // node_modules/lodash-es/_listCacheClear.js
  init_define_process();
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  var listCacheClear_default = listCacheClear;

  // node_modules/lodash-es/_listCacheDelete.js
  init_define_process();

  // node_modules/lodash-es/_assocIndexOf.js
  init_define_process();
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq_default(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  var assocIndexOf_default = assocIndexOf;

  // node_modules/lodash-es/_listCacheDelete.js
  var arrayProto = Array.prototype;
  var splice = arrayProto.splice;
  function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  var listCacheDelete_default = listCacheDelete;

  // node_modules/lodash-es/_listCacheGet.js
  init_define_process();
  function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  var listCacheGet_default = listCacheGet;

  // node_modules/lodash-es/_listCacheHas.js
  init_define_process();
  function listCacheHas(key) {
    return assocIndexOf_default(this.__data__, key) > -1;
  }
  var listCacheHas_default = listCacheHas;

  // node_modules/lodash-es/_listCacheSet.js
  init_define_process();
  function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  var listCacheSet_default = listCacheSet;

  // node_modules/lodash-es/_ListCache.js
  function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  ListCache.prototype.clear = listCacheClear_default;
  ListCache.prototype["delete"] = listCacheDelete_default;
  ListCache.prototype.get = listCacheGet_default;
  ListCache.prototype.has = listCacheHas_default;
  ListCache.prototype.set = listCacheSet_default;
  var ListCache_default = ListCache;

  // node_modules/lodash-es/_Map.js
  init_define_process();
  var Map2 = getNative_default(root_default, "Map");
  var Map_default = Map2;

  // node_modules/lodash-es/_mapCacheClear.js
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash_default(),
      "map": new (Map_default || ListCache_default)(),
      "string": new Hash_default()
    };
  }
  var mapCacheClear_default = mapCacheClear;

  // node_modules/lodash-es/_mapCacheDelete.js
  init_define_process();

  // node_modules/lodash-es/_getMapData.js
  init_define_process();

  // node_modules/lodash-es/_isKeyable.js
  init_define_process();
  function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  var isKeyable_default = isKeyable;

  // node_modules/lodash-es/_getMapData.js
  function getMapData(map2, key) {
    var data = map2.__data__;
    return isKeyable_default(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  var getMapData_default = getMapData;

  // node_modules/lodash-es/_mapCacheDelete.js
  function mapCacheDelete(key) {
    var result2 = getMapData_default(this, key)["delete"](key);
    this.size -= result2 ? 1 : 0;
    return result2;
  }
  var mapCacheDelete_default = mapCacheDelete;

  // node_modules/lodash-es/_mapCacheGet.js
  init_define_process();
  function mapCacheGet(key) {
    return getMapData_default(this, key).get(key);
  }
  var mapCacheGet_default = mapCacheGet;

  // node_modules/lodash-es/_mapCacheHas.js
  init_define_process();
  function mapCacheHas(key) {
    return getMapData_default(this, key).has(key);
  }
  var mapCacheHas_default = mapCacheHas;

  // node_modules/lodash-es/_mapCacheSet.js
  init_define_process();
  function mapCacheSet(key, value) {
    var data = getMapData_default(this, key), size2 = data.size;
    data.set(key, value);
    this.size += data.size == size2 ? 0 : 1;
    return this;
  }
  var mapCacheSet_default = mapCacheSet;

  // node_modules/lodash-es/_MapCache.js
  function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  MapCache.prototype.clear = mapCacheClear_default;
  MapCache.prototype["delete"] = mapCacheDelete_default;
  MapCache.prototype.get = mapCacheGet_default;
  MapCache.prototype.has = mapCacheHas_default;
  MapCache.prototype.set = mapCacheSet_default;
  var MapCache_default = MapCache;

  // node_modules/lodash-es/memoize.js
  var FUNC_ERROR_TEXT3 = "Expected a function";
  function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") {
      throw new TypeError(FUNC_ERROR_TEXT3);
    }
    var memoized = function() {
      var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result2 = func.apply(this, args);
      memoized.cache = cache.set(key, result2) || cache;
      return result2;
    };
    memoized.cache = new (memoize.Cache || MapCache_default)();
    return memoized;
  }
  memoize.Cache = MapCache_default;
  var memoize_default = memoize;

  // node_modules/lodash-es/_memoizeCapped.js
  var MAX_MEMOIZE_SIZE = 500;
  function memoizeCapped(func) {
    var result2 = memoize_default(func, function(key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });
    var cache = result2.cache;
    return result2;
  }
  var memoizeCapped_default = memoizeCapped;

  // node_modules/lodash-es/_stringToPath.js
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  var reEscapeChar = /\\(\\)?/g;
  var stringToPath = memoizeCapped_default(function(string) {
    var result2 = [];
    if (string.charCodeAt(0) === 46) {
      result2.push("");
    }
    string.replace(rePropName, function(match, number, quote, subString) {
      result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result2;
  });
  var stringToPath_default = stringToPath;

  // node_modules/lodash-es/toString.js
  init_define_process();
  function toString(value) {
    return value == null ? "" : baseToString_default(value);
  }
  var toString_default = toString;

  // node_modules/lodash-es/_castPath.js
  function castPath(value, object) {
    if (isArray_default(value)) {
      return value;
    }
    return isKey_default(value, object) ? [value] : stringToPath_default(toString_default(value));
  }
  var castPath_default = castPath;

  // node_modules/lodash-es/_toKey.js
  init_define_process();
  var INFINITY3 = 1 / 0;
  function toKey(value) {
    if (typeof value == "string" || isSymbol_default(value)) {
      return value;
    }
    var result2 = value + "";
    return result2 == "0" && 1 / value == -INFINITY3 ? "-0" : result2;
  }
  var toKey_default = toKey;

  // node_modules/lodash-es/_baseGet.js
  function baseGet(object, path) {
    path = castPath_default(path, object);
    var index = 0, length = path.length;
    while (object != null && index < length) {
      object = object[toKey_default(path[index++])];
    }
    return index && index == length ? object : void 0;
  }
  var baseGet_default = baseGet;

  // node_modules/lodash-es/get.js
  function get(object, path, defaultValue) {
    var result2 = object == null ? void 0 : baseGet_default(object, path);
    return result2 === void 0 ? defaultValue : result2;
  }
  var get_default = get;

  // node_modules/lodash-es/_baseAt.js
  function baseAt(object, paths) {
    var index = -1, length = paths.length, result2 = Array(length), skip = object == null;
    while (++index < length) {
      result2[index] = skip ? void 0 : get_default(object, paths[index]);
    }
    return result2;
  }
  var baseAt_default = baseAt;

  // node_modules/lodash-es/_flatRest.js
  init_define_process();

  // node_modules/lodash-es/flatten.js
  init_define_process();

  // node_modules/lodash-es/_baseFlatten.js
  init_define_process();

  // node_modules/lodash-es/_arrayPush.js
  init_define_process();
  function arrayPush(array, values2) {
    var index = -1, length = values2.length, offset = array.length;
    while (++index < length) {
      array[offset + index] = values2[index];
    }
    return array;
  }
  var arrayPush_default = arrayPush;

  // node_modules/lodash-es/_isFlattenable.js
  init_define_process();
  var spreadableSymbol = Symbol_default ? Symbol_default.isConcatSpreadable : void 0;
  function isFlattenable(value) {
    return isArray_default(value) || isArguments_default(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
  }
  var isFlattenable_default = isFlattenable;

  // node_modules/lodash-es/_baseFlatten.js
  function baseFlatten(array, depth, predicate, isStrict, result2) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable_default);
    result2 || (result2 = []);
    while (++index < length) {
      var value = array[index];
      if (depth > 0 && predicate(value)) {
        if (depth > 1) {
          baseFlatten(value, depth - 1, predicate, isStrict, result2);
        } else {
          arrayPush_default(result2, value);
        }
      } else if (!isStrict) {
        result2[result2.length] = value;
      }
    }
    return result2;
  }
  var baseFlatten_default = baseFlatten;

  // node_modules/lodash-es/flatten.js
  function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten_default(array, 1) : [];
  }
  var flatten_default = flatten;

  // node_modules/lodash-es/_flatRest.js
  function flatRest(func) {
    return setToString_default(overRest_default(func, void 0, flatten_default), func + "");
  }
  var flatRest_default = flatRest;

  // node_modules/lodash-es/at.js
  var at = flatRest_default(baseAt_default);
  var at_default = at;

  // node_modules/lodash-es/attempt.js
  init_define_process();

  // node_modules/lodash-es/isError.js
  init_define_process();

  // node_modules/lodash-es/isPlainObject.js
  init_define_process();

  // node_modules/lodash-es/_getPrototype.js
  init_define_process();
  var getPrototype = overArg_default(Object.getPrototypeOf, Object);
  var getPrototype_default = getPrototype;

  // node_modules/lodash-es/isPlainObject.js
  var objectTag2 = "[object Object]";
  var funcProto3 = Function.prototype;
  var objectProto15 = Object.prototype;
  var funcToString3 = funcProto3.toString;
  var hasOwnProperty13 = objectProto15.hasOwnProperty;
  var objectCtorString = funcToString3.call(Object);
  function isPlainObject(value) {
    if (!isObjectLike_default(value) || baseGetTag_default(value) != objectTag2) {
      return false;
    }
    var proto = getPrototype_default(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty13.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString3.call(Ctor) == objectCtorString;
  }
  var isPlainObject_default = isPlainObject;

  // node_modules/lodash-es/isError.js
  var domExcTag = "[object DOMException]";
  var errorTag2 = "[object Error]";
  function isError(value) {
    if (!isObjectLike_default(value)) {
      return false;
    }
    var tag = baseGetTag_default(value);
    return tag == errorTag2 || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject_default(value);
  }
  var isError_default = isError;

  // node_modules/lodash-es/attempt.js
  var attempt = baseRest_default(function(func, args) {
    try {
      return apply_default(func, void 0, args);
    } catch (e) {
      return isError_default(e) ? e : new Error(e);
    }
  });
  var attempt_default = attempt;

  // node_modules/lodash-es/before.js
  init_define_process();
  var FUNC_ERROR_TEXT4 = "Expected a function";
  function before(n, func) {
    var result2;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT4);
    }
    n = toInteger_default(n);
    return function() {
      if (--n > 0) {
        result2 = func.apply(this, arguments);
      }
      if (n <= 1) {
        func = void 0;
      }
      return result2;
    };
  }
  var before_default = before;

  // node_modules/lodash-es/bind.js
  init_define_process();
  var WRAP_BIND_FLAG8 = 1;
  var WRAP_PARTIAL_FLAG4 = 32;
  var bind = baseRest_default(function(func, thisArg, partials) {
    var bitmask = WRAP_BIND_FLAG8;
    if (partials.length) {
      var holders = replaceHolders_default(partials, getHolder_default(bind));
      bitmask |= WRAP_PARTIAL_FLAG4;
    }
    return createWrap_default(func, bitmask, thisArg, partials, holders);
  });
  bind.placeholder = {};
  var bind_default = bind;

  // node_modules/lodash-es/bindAll.js
  init_define_process();
  var bindAll = flatRest_default(function(object, methodNames) {
    arrayEach_default(methodNames, function(key) {
      key = toKey_default(key);
      baseAssignValue_default(object, key, bind_default(object[key], object));
    });
    return object;
  });
  var bindAll_default = bindAll;

  // node_modules/lodash-es/bindKey.js
  init_define_process();
  var WRAP_BIND_FLAG9 = 1;
  var WRAP_BIND_KEY_FLAG6 = 2;
  var WRAP_PARTIAL_FLAG5 = 32;
  var bindKey = baseRest_default(function(object, key, partials) {
    var bitmask = WRAP_BIND_FLAG9 | WRAP_BIND_KEY_FLAG6;
    if (partials.length) {
      var holders = replaceHolders_default(partials, getHolder_default(bindKey));
      bitmask |= WRAP_PARTIAL_FLAG5;
    }
    return createWrap_default(key, bitmask, object, partials, holders);
  });
  bindKey.placeholder = {};
  var bindKey_default = bindKey;

  // node_modules/lodash-es/camelCase.js
  init_define_process();

  // node_modules/lodash-es/capitalize.js
  init_define_process();

  // node_modules/lodash-es/upperFirst.js
  init_define_process();

  // node_modules/lodash-es/_createCaseFirst.js
  init_define_process();

  // node_modules/lodash-es/_castSlice.js
  init_define_process();

  // node_modules/lodash-es/_baseSlice.js
  init_define_process();
  function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result2 = Array(length);
    while (++index < length) {
      result2[index] = array[index + start];
    }
    return result2;
  }
  var baseSlice_default = baseSlice;

  // node_modules/lodash-es/_castSlice.js
  function castSlice(array, start, end) {
    var length = array.length;
    end = end === void 0 ? length : end;
    return !start && end >= length ? array : baseSlice_default(array, start, end);
  }
  var castSlice_default = castSlice;

  // node_modules/lodash-es/_hasUnicode.js
  init_define_process();
  var rsAstralRange = "\\ud800-\\udfff";
  var rsComboMarksRange = "\\u0300-\\u036f";
  var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange = "\\u20d0-\\u20ff";
  var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
  var rsVarRange = "\\ufe0e\\ufe0f";
  var rsZWJ = "\\u200d";
  var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }
  var hasUnicode_default = hasUnicode;

  // node_modules/lodash-es/_stringToArray.js
  init_define_process();

  // node_modules/lodash-es/_asciiToArray.js
  init_define_process();
  function asciiToArray(string) {
    return string.split("");
  }
  var asciiToArray_default = asciiToArray;

  // node_modules/lodash-es/_unicodeToArray.js
  init_define_process();
  var rsAstralRange2 = "\\ud800-\\udfff";
  var rsComboMarksRange2 = "\\u0300-\\u036f";
  var reComboHalfMarksRange2 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange2 = "\\u20d0-\\u20ff";
  var rsComboRange2 = rsComboMarksRange2 + reComboHalfMarksRange2 + rsComboSymbolsRange2;
  var rsVarRange2 = "\\ufe0e\\ufe0f";
  var rsAstral = "[" + rsAstralRange2 + "]";
  var rsCombo = "[" + rsComboRange2 + "]";
  var rsFitz = "\\ud83c[\\udffb-\\udfff]";
  var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
  var rsNonAstral = "[^" + rsAstralRange2 + "]";
  var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
  var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var rsZWJ2 = "\\u200d";
  var reOptMod = rsModifier + "?";
  var rsOptVar = "[" + rsVarRange2 + "]?";
  var rsOptJoin = "(?:" + rsZWJ2 + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
  var rsSeq = rsOptVar + reOptMod + rsOptJoin;
  var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
  var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }
  var unicodeToArray_default = unicodeToArray;

  // node_modules/lodash-es/_stringToArray.js
  function stringToArray(string) {
    return hasUnicode_default(string) ? unicodeToArray_default(string) : asciiToArray_default(string);
  }
  var stringToArray_default = stringToArray;

  // node_modules/lodash-es/_createCaseFirst.js
  function createCaseFirst(methodName) {
    return function(string) {
      string = toString_default(string);
      var strSymbols = hasUnicode_default(string) ? stringToArray_default(string) : void 0;
      var chr = strSymbols ? strSymbols[0] : string.charAt(0);
      var trailing = strSymbols ? castSlice_default(strSymbols, 1).join("") : string.slice(1);
      return chr[methodName]() + trailing;
    };
  }
  var createCaseFirst_default = createCaseFirst;

  // node_modules/lodash-es/upperFirst.js
  var upperFirst = createCaseFirst_default("toUpperCase");
  var upperFirst_default = upperFirst;

  // node_modules/lodash-es/capitalize.js
  function capitalize(string) {
    return upperFirst_default(toString_default(string).toLowerCase());
  }
  var capitalize_default = capitalize;

  // node_modules/lodash-es/_createCompounder.js
  init_define_process();

  // node_modules/lodash-es/_arrayReduce.js
  init_define_process();
  function arrayReduce(array, iteratee2, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee2(accumulator, array[index], index, array);
    }
    return accumulator;
  }
  var arrayReduce_default = arrayReduce;

  // node_modules/lodash-es/deburr.js
  init_define_process();

  // node_modules/lodash-es/_deburrLetter.js
  init_define_process();

  // node_modules/lodash-es/_basePropertyOf.js
  init_define_process();
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? void 0 : object[key];
    };
  }
  var basePropertyOf_default = basePropertyOf;

  // node_modules/lodash-es/_deburrLetter.js
  var deburredLetters = {
    "\xC0": "A",
    "\xC1": "A",
    "\xC2": "A",
    "\xC3": "A",
    "\xC4": "A",
    "\xC5": "A",
    "\xE0": "a",
    "\xE1": "a",
    "\xE2": "a",
    "\xE3": "a",
    "\xE4": "a",
    "\xE5": "a",
    "\xC7": "C",
    "\xE7": "c",
    "\xD0": "D",
    "\xF0": "d",
    "\xC8": "E",
    "\xC9": "E",
    "\xCA": "E",
    "\xCB": "E",
    "\xE8": "e",
    "\xE9": "e",
    "\xEA": "e",
    "\xEB": "e",
    "\xCC": "I",
    "\xCD": "I",
    "\xCE": "I",
    "\xCF": "I",
    "\xEC": "i",
    "\xED": "i",
    "\xEE": "i",
    "\xEF": "i",
    "\xD1": "N",
    "\xF1": "n",
    "\xD2": "O",
    "\xD3": "O",
    "\xD4": "O",
    "\xD5": "O",
    "\xD6": "O",
    "\xD8": "O",
    "\xF2": "o",
    "\xF3": "o",
    "\xF4": "o",
    "\xF5": "o",
    "\xF6": "o",
    "\xF8": "o",
    "\xD9": "U",
    "\xDA": "U",
    "\xDB": "U",
    "\xDC": "U",
    "\xF9": "u",
    "\xFA": "u",
    "\xFB": "u",
    "\xFC": "u",
    "\xDD": "Y",
    "\xFD": "y",
    "\xFF": "y",
    "\xC6": "Ae",
    "\xE6": "ae",
    "\xDE": "Th",
    "\xFE": "th",
    "\xDF": "ss",
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
  };
  var deburrLetter = basePropertyOf_default(deburredLetters);
  var deburrLetter_default = deburrLetter;

  // node_modules/lodash-es/deburr.js
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
  var rsComboMarksRange3 = "\\u0300-\\u036f";
  var reComboHalfMarksRange3 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange3 = "\\u20d0-\\u20ff";
  var rsComboRange3 = rsComboMarksRange3 + reComboHalfMarksRange3 + rsComboSymbolsRange3;
  var rsCombo2 = "[" + rsComboRange3 + "]";
  var reComboMark = RegExp(rsCombo2, "g");
  function deburr(string) {
    string = toString_default(string);
    return string && string.replace(reLatin, deburrLetter_default).replace(reComboMark, "");
  }
  var deburr_default = deburr;

  // node_modules/lodash-es/words.js
  init_define_process();

  // node_modules/lodash-es/_asciiWords.js
  init_define_process();
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }
  var asciiWords_default = asciiWords;

  // node_modules/lodash-es/_hasUnicodeWord.js
  init_define_process();
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }
  var hasUnicodeWord_default = hasUnicodeWord;

  // node_modules/lodash-es/_unicodeWords.js
  init_define_process();
  var rsAstralRange3 = "\\ud800-\\udfff";
  var rsComboMarksRange4 = "\\u0300-\\u036f";
  var reComboHalfMarksRange4 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange4 = "\\u20d0-\\u20ff";
  var rsComboRange4 = rsComboMarksRange4 + reComboHalfMarksRange4 + rsComboSymbolsRange4;
  var rsDingbatRange = "\\u2700-\\u27bf";
  var rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff";
  var rsMathOpRange = "\\xac\\xb1\\xd7\\xf7";
  var rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf";
  var rsPunctuationRange = "\\u2000-\\u206f";
  var rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000";
  var rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde";
  var rsVarRange3 = "\\ufe0e\\ufe0f";
  var rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
  var rsApos = "['\u2019]";
  var rsBreak = "[" + rsBreakRange + "]";
  var rsCombo3 = "[" + rsComboRange4 + "]";
  var rsDigits = "\\d+";
  var rsDingbat = "[" + rsDingbatRange + "]";
  var rsLower = "[" + rsLowerRange + "]";
  var rsMisc = "[^" + rsAstralRange3 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]";
  var rsFitz2 = "\\ud83c[\\udffb-\\udfff]";
  var rsModifier2 = "(?:" + rsCombo3 + "|" + rsFitz2 + ")";
  var rsNonAstral2 = "[^" + rsAstralRange3 + "]";
  var rsRegional2 = "(?:\\ud83c[\\udde6-\\uddff]){2}";
  var rsSurrPair2 = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var rsUpper = "[" + rsUpperRange + "]";
  var rsZWJ3 = "\\u200d";
  var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")";
  var rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")";
  var rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?";
  var rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?";
  var reOptMod2 = rsModifier2 + "?";
  var rsOptVar2 = "[" + rsVarRange3 + "]?";
  var rsOptJoin2 = "(?:" + rsZWJ3 + "(?:" + [rsNonAstral2, rsRegional2, rsSurrPair2].join("|") + ")" + rsOptVar2 + reOptMod2 + ")*";
  var rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])";
  var rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])";
  var rsSeq2 = rsOptVar2 + reOptMod2 + rsOptJoin2;
  var rsEmoji = "(?:" + [rsDingbat, rsRegional2, rsSurrPair2].join("|") + ")" + rsSeq2;
  var reUnicodeWord = RegExp([
    rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
    rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
    rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
    rsUpper + "+" + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join("|"), "g");
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }
  var unicodeWords_default = unicodeWords;

  // node_modules/lodash-es/words.js
  function words(string, pattern, guard) {
    string = toString_default(string);
    pattern = guard ? void 0 : pattern;
    if (pattern === void 0) {
      return hasUnicodeWord_default(string) ? unicodeWords_default(string) : asciiWords_default(string);
    }
    return string.match(pattern) || [];
  }
  var words_default = words;

  // node_modules/lodash-es/_createCompounder.js
  var rsApos2 = "['\u2019]";
  var reApos = RegExp(rsApos2, "g");
  function createCompounder(callback) {
    return function(string) {
      return arrayReduce_default(words_default(deburr_default(string).replace(reApos, "")), callback, "");
    };
  }
  var createCompounder_default = createCompounder;

  // node_modules/lodash-es/camelCase.js
  var camelCase = createCompounder_default(function(result2, word, index) {
    word = word.toLowerCase();
    return result2 + (index ? capitalize_default(word) : word);
  });
  var camelCase_default = camelCase;

  // node_modules/lodash-es/castArray.js
  init_define_process();
  function castArray() {
    if (!arguments.length) {
      return [];
    }
    var value = arguments[0];
    return isArray_default(value) ? value : [value];
  }
  var castArray_default = castArray;

  // node_modules/lodash-es/ceil.js
  init_define_process();

  // node_modules/lodash-es/_createRound.js
  init_define_process();
  var nativeIsFinite = root_default.isFinite;
  var nativeMin3 = Math.min;
  function createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
      number = toNumber_default(number);
      precision = precision == null ? 0 : nativeMin3(toInteger_default(precision), 292);
      if (precision && nativeIsFinite(number)) {
        var pair = (toString_default(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
        pair = (toString_default(value) + "e").split("e");
        return +(pair[0] + "e" + (+pair[1] - precision));
      }
      return func(number);
    };
  }
  var createRound_default = createRound;

  // node_modules/lodash-es/ceil.js
  var ceil = createRound_default("ceil");
  var ceil_default = ceil;

  // node_modules/lodash-es/chain.js
  init_define_process();
  function chain(value) {
    var result2 = wrapperLodash_default(value);
    result2.__chain__ = true;
    return result2;
  }
  var chain_default = chain;

  // node_modules/lodash-es/chunk.js
  init_define_process();
  var nativeCeil = Math.ceil;
  var nativeMax5 = Math.max;
  function chunk(array, size2, guard) {
    if (guard ? isIterateeCall_default(array, size2, guard) : size2 === void 0) {
      size2 = 1;
    } else {
      size2 = nativeMax5(toInteger_default(size2), 0);
    }
    var length = array == null ? 0 : array.length;
    if (!length || size2 < 1) {
      return [];
    }
    var index = 0, resIndex = 0, result2 = Array(nativeCeil(length / size2));
    while (index < length) {
      result2[resIndex++] = baseSlice_default(array, index, index += size2);
    }
    return result2;
  }
  var chunk_default = chunk;

  // node_modules/lodash-es/clamp.js
  init_define_process();

  // node_modules/lodash-es/_baseClamp.js
  init_define_process();
  function baseClamp(number, lower, upper) {
    if (number === number) {
      if (upper !== void 0) {
        number = number <= upper ? number : upper;
      }
      if (lower !== void 0) {
        number = number >= lower ? number : lower;
      }
    }
    return number;
  }
  var baseClamp_default = baseClamp;

  // node_modules/lodash-es/clamp.js
  function clamp(number, lower, upper) {
    if (upper === void 0) {
      upper = lower;
      lower = void 0;
    }
    if (upper !== void 0) {
      upper = toNumber_default(upper);
      upper = upper === upper ? upper : 0;
    }
    if (lower !== void 0) {
      lower = toNumber_default(lower);
      lower = lower === lower ? lower : 0;
    }
    return baseClamp_default(toNumber_default(number), lower, upper);
  }
  var clamp_default = clamp;

  // node_modules/lodash-es/clone.js
  init_define_process();

  // node_modules/lodash-es/_baseClone.js
  init_define_process();

  // node_modules/lodash-es/_Stack.js
  init_define_process();

  // node_modules/lodash-es/_stackClear.js
  init_define_process();
  function stackClear() {
    this.__data__ = new ListCache_default();
    this.size = 0;
  }
  var stackClear_default = stackClear;

  // node_modules/lodash-es/_stackDelete.js
  init_define_process();
  function stackDelete(key) {
    var data = this.__data__, result2 = data["delete"](key);
    this.size = data.size;
    return result2;
  }
  var stackDelete_default = stackDelete;

  // node_modules/lodash-es/_stackGet.js
  init_define_process();
  function stackGet(key) {
    return this.__data__.get(key);
  }
  var stackGet_default = stackGet;

  // node_modules/lodash-es/_stackHas.js
  init_define_process();
  function stackHas(key) {
    return this.__data__.has(key);
  }
  var stackHas_default = stackHas;

  // node_modules/lodash-es/_stackSet.js
  init_define_process();
  var LARGE_ARRAY_SIZE = 200;
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache_default) {
      var pairs = data.__data__;
      if (!Map_default || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache_default(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  var stackSet_default = stackSet;

  // node_modules/lodash-es/_Stack.js
  function Stack(entries) {
    var data = this.__data__ = new ListCache_default(entries);
    this.size = data.size;
  }
  Stack.prototype.clear = stackClear_default;
  Stack.prototype["delete"] = stackDelete_default;
  Stack.prototype.get = stackGet_default;
  Stack.prototype.has = stackHas_default;
  Stack.prototype.set = stackSet_default;
  var Stack_default = Stack;

  // node_modules/lodash-es/_baseAssign.js
  init_define_process();
  function baseAssign(object, source) {
    return object && copyObject_default(source, keys_default(source), object);
  }
  var baseAssign_default = baseAssign;

  // node_modules/lodash-es/_baseAssignIn.js
  init_define_process();
  function baseAssignIn(object, source) {
    return object && copyObject_default(source, keysIn_default(source), object);
  }
  var baseAssignIn_default = baseAssignIn;

  // node_modules/lodash-es/_cloneBuffer.js
  init_define_process();
  var freeExports3 = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule3 = freeExports3 && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports3 = freeModule3 && freeModule3.exports === freeExports3;
  var Buffer4 = moduleExports3 ? root_default.Buffer : void 0;
  var allocUnsafe = Buffer4 ? Buffer4.allocUnsafe : void 0;
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result2);
    return result2;
  }
  var cloneBuffer_default = cloneBuffer;

  // node_modules/lodash-es/_copySymbols.js
  init_define_process();

  // node_modules/lodash-es/_getSymbols.js
  init_define_process();

  // node_modules/lodash-es/_arrayFilter.js
  init_define_process();
  function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result2[resIndex++] = value;
      }
    }
    return result2;
  }
  var arrayFilter_default = arrayFilter;

  // node_modules/lodash-es/stubArray.js
  init_define_process();
  function stubArray() {
    return [];
  }
  var stubArray_default = stubArray;

  // node_modules/lodash-es/_getSymbols.js
  var objectProto16 = Object.prototype;
  var propertyIsEnumerable2 = objectProto16.propertyIsEnumerable;
  var nativeGetSymbols = Object.getOwnPropertySymbols;
  var getSymbols = !nativeGetSymbols ? stubArray_default : function(object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter_default(nativeGetSymbols(object), function(symbol) {
      return propertyIsEnumerable2.call(object, symbol);
    });
  };
  var getSymbols_default = getSymbols;

  // node_modules/lodash-es/_copySymbols.js
  function copySymbols(source, object) {
    return copyObject_default(source, getSymbols_default(source), object);
  }
  var copySymbols_default = copySymbols;

  // node_modules/lodash-es/_copySymbolsIn.js
  init_define_process();

  // node_modules/lodash-es/_getSymbolsIn.js
  init_define_process();
  var nativeGetSymbols2 = Object.getOwnPropertySymbols;
  var getSymbolsIn = !nativeGetSymbols2 ? stubArray_default : function(object) {
    var result2 = [];
    while (object) {
      arrayPush_default(result2, getSymbols_default(object));
      object = getPrototype_default(object);
    }
    return result2;
  };
  var getSymbolsIn_default = getSymbolsIn;

  // node_modules/lodash-es/_copySymbolsIn.js
  function copySymbolsIn(source, object) {
    return copyObject_default(source, getSymbolsIn_default(source), object);
  }
  var copySymbolsIn_default = copySymbolsIn;

  // node_modules/lodash-es/_getAllKeys.js
  init_define_process();

  // node_modules/lodash-es/_baseGetAllKeys.js
  init_define_process();
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result2 = keysFunc(object);
    return isArray_default(object) ? result2 : arrayPush_default(result2, symbolsFunc(object));
  }
  var baseGetAllKeys_default = baseGetAllKeys;

  // node_modules/lodash-es/_getAllKeys.js
  function getAllKeys(object) {
    return baseGetAllKeys_default(object, keys_default, getSymbols_default);
  }
  var getAllKeys_default = getAllKeys;

  // node_modules/lodash-es/_getAllKeysIn.js
  init_define_process();
  function getAllKeysIn(object) {
    return baseGetAllKeys_default(object, keysIn_default, getSymbolsIn_default);
  }
  var getAllKeysIn_default = getAllKeysIn;

  // node_modules/lodash-es/_getTag.js
  init_define_process();

  // node_modules/lodash-es/_DataView.js
  init_define_process();
  var DataView = getNative_default(root_default, "DataView");
  var DataView_default = DataView;

  // node_modules/lodash-es/_Promise.js
  init_define_process();
  var Promise2 = getNative_default(root_default, "Promise");
  var Promise_default = Promise2;

  // node_modules/lodash-es/_Set.js
  init_define_process();
  var Set2 = getNative_default(root_default, "Set");
  var Set_default = Set2;

  // node_modules/lodash-es/_getTag.js
  var mapTag2 = "[object Map]";
  var objectTag3 = "[object Object]";
  var promiseTag = "[object Promise]";
  var setTag2 = "[object Set]";
  var weakMapTag2 = "[object WeakMap]";
  var dataViewTag2 = "[object DataView]";
  var dataViewCtorString = toSource_default(DataView_default);
  var mapCtorString = toSource_default(Map_default);
  var promiseCtorString = toSource_default(Promise_default);
  var setCtorString = toSource_default(Set_default);
  var weakMapCtorString = toSource_default(WeakMap_default);
  var getTag = baseGetTag_default;
  if (DataView_default && getTag(new DataView_default(new ArrayBuffer(1))) != dataViewTag2 || Map_default && getTag(new Map_default()) != mapTag2 || Promise_default && getTag(Promise_default.resolve()) != promiseTag || Set_default && getTag(new Set_default()) != setTag2 || WeakMap_default && getTag(new WeakMap_default()) != weakMapTag2) {
    getTag = function(value) {
      var result2 = baseGetTag_default(value), Ctor = result2 == objectTag3 ? value.constructor : void 0, ctorString = Ctor ? toSource_default(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag2;
          case mapCtorString:
            return mapTag2;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag2;
          case weakMapCtorString:
            return weakMapTag2;
        }
      }
      return result2;
    };
  }
  var getTag_default = getTag;

  // node_modules/lodash-es/_initCloneArray.js
  init_define_process();
  var objectProto17 = Object.prototype;
  var hasOwnProperty14 = objectProto17.hasOwnProperty;
  function initCloneArray(array) {
    var length = array.length, result2 = new array.constructor(length);
    if (length && typeof array[0] == "string" && hasOwnProperty14.call(array, "index")) {
      result2.index = array.index;
      result2.input = array.input;
    }
    return result2;
  }
  var initCloneArray_default = initCloneArray;

  // node_modules/lodash-es/_initCloneByTag.js
  init_define_process();

  // node_modules/lodash-es/_cloneArrayBuffer.js
  init_define_process();

  // node_modules/lodash-es/_Uint8Array.js
  init_define_process();
  var Uint8Array2 = root_default.Uint8Array;
  var Uint8Array_default = Uint8Array2;

  // node_modules/lodash-es/_cloneArrayBuffer.js
  function cloneArrayBuffer(arrayBuffer) {
    var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array_default(result2).set(new Uint8Array_default(arrayBuffer));
    return result2;
  }
  var cloneArrayBuffer_default = cloneArrayBuffer;

  // node_modules/lodash-es/_cloneDataView.js
  init_define_process();
  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer_default(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  var cloneDataView_default = cloneDataView;

  // node_modules/lodash-es/_cloneRegExp.js
  init_define_process();
  var reFlags = /\w*$/;
  function cloneRegExp(regexp) {
    var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result2.lastIndex = regexp.lastIndex;
    return result2;
  }
  var cloneRegExp_default = cloneRegExp;

  // node_modules/lodash-es/_cloneSymbol.js
  init_define_process();
  var symbolProto2 = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolValueOf = symbolProto2 ? symbolProto2.valueOf : void 0;
  function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  var cloneSymbol_default = cloneSymbol;

  // node_modules/lodash-es/_cloneTypedArray.js
  init_define_process();
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer_default(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  var cloneTypedArray_default = cloneTypedArray;

  // node_modules/lodash-es/_initCloneByTag.js
  var boolTag2 = "[object Boolean]";
  var dateTag2 = "[object Date]";
  var mapTag3 = "[object Map]";
  var numberTag2 = "[object Number]";
  var regexpTag2 = "[object RegExp]";
  var setTag3 = "[object Set]";
  var stringTag2 = "[object String]";
  var symbolTag2 = "[object Symbol]";
  var arrayBufferTag2 = "[object ArrayBuffer]";
  var dataViewTag3 = "[object DataView]";
  var float32Tag2 = "[object Float32Array]";
  var float64Tag2 = "[object Float64Array]";
  var int8Tag2 = "[object Int8Array]";
  var int16Tag2 = "[object Int16Array]";
  var int32Tag2 = "[object Int32Array]";
  var uint8Tag2 = "[object Uint8Array]";
  var uint8ClampedTag2 = "[object Uint8ClampedArray]";
  var uint16Tag2 = "[object Uint16Array]";
  var uint32Tag2 = "[object Uint32Array]";
  function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag2:
        return cloneArrayBuffer_default(object);
      case boolTag2:
      case dateTag2:
        return new Ctor(+object);
      case dataViewTag3:
        return cloneDataView_default(object, isDeep);
      case float32Tag2:
      case float64Tag2:
      case int8Tag2:
      case int16Tag2:
      case int32Tag2:
      case uint8Tag2:
      case uint8ClampedTag2:
      case uint16Tag2:
      case uint32Tag2:
        return cloneTypedArray_default(object, isDeep);
      case mapTag3:
        return new Ctor();
      case numberTag2:
      case stringTag2:
        return new Ctor(object);
      case regexpTag2:
        return cloneRegExp_default(object);
      case setTag3:
        return new Ctor();
      case symbolTag2:
        return cloneSymbol_default(object);
    }
  }
  var initCloneByTag_default = initCloneByTag;

  // node_modules/lodash-es/_initCloneObject.js
  init_define_process();
  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype_default(object) ? baseCreate_default(getPrototype_default(object)) : {};
  }
  var initCloneObject_default = initCloneObject;

  // node_modules/lodash-es/isMap.js
  init_define_process();

  // node_modules/lodash-es/_baseIsMap.js
  init_define_process();
  var mapTag4 = "[object Map]";
  function baseIsMap(value) {
    return isObjectLike_default(value) && getTag_default(value) == mapTag4;
  }
  var baseIsMap_default = baseIsMap;

  // node_modules/lodash-es/isMap.js
  var nodeIsMap = nodeUtil_default && nodeUtil_default.isMap;
  var isMap = nodeIsMap ? baseUnary_default(nodeIsMap) : baseIsMap_default;
  var isMap_default = isMap;

  // node_modules/lodash-es/isSet.js
  init_define_process();

  // node_modules/lodash-es/_baseIsSet.js
  init_define_process();
  var setTag4 = "[object Set]";
  function baseIsSet(value) {
    return isObjectLike_default(value) && getTag_default(value) == setTag4;
  }
  var baseIsSet_default = baseIsSet;

  // node_modules/lodash-es/isSet.js
  var nodeIsSet = nodeUtil_default && nodeUtil_default.isSet;
  var isSet = nodeIsSet ? baseUnary_default(nodeIsSet) : baseIsSet_default;
  var isSet_default = isSet;

  // node_modules/lodash-es/_baseClone.js
  var CLONE_DEEP_FLAG = 1;
  var CLONE_FLAT_FLAG = 2;
  var CLONE_SYMBOLS_FLAG = 4;
  var argsTag3 = "[object Arguments]";
  var arrayTag2 = "[object Array]";
  var boolTag3 = "[object Boolean]";
  var dateTag3 = "[object Date]";
  var errorTag3 = "[object Error]";
  var funcTag3 = "[object Function]";
  var genTag2 = "[object GeneratorFunction]";
  var mapTag5 = "[object Map]";
  var numberTag3 = "[object Number]";
  var objectTag4 = "[object Object]";
  var regexpTag3 = "[object RegExp]";
  var setTag5 = "[object Set]";
  var stringTag3 = "[object String]";
  var symbolTag3 = "[object Symbol]";
  var weakMapTag3 = "[object WeakMap]";
  var arrayBufferTag3 = "[object ArrayBuffer]";
  var dataViewTag4 = "[object DataView]";
  var float32Tag3 = "[object Float32Array]";
  var float64Tag3 = "[object Float64Array]";
  var int8Tag3 = "[object Int8Array]";
  var int16Tag3 = "[object Int16Array]";
  var int32Tag3 = "[object Int32Array]";
  var uint8Tag3 = "[object Uint8Array]";
  var uint8ClampedTag3 = "[object Uint8ClampedArray]";
  var uint16Tag3 = "[object Uint16Array]";
  var uint32Tag3 = "[object Uint32Array]";
  var cloneableTags = {};
  cloneableTags[argsTag3] = cloneableTags[arrayTag2] = cloneableTags[arrayBufferTag3] = cloneableTags[dataViewTag4] = cloneableTags[boolTag3] = cloneableTags[dateTag3] = cloneableTags[float32Tag3] = cloneableTags[float64Tag3] = cloneableTags[int8Tag3] = cloneableTags[int16Tag3] = cloneableTags[int32Tag3] = cloneableTags[mapTag5] = cloneableTags[numberTag3] = cloneableTags[objectTag4] = cloneableTags[regexpTag3] = cloneableTags[setTag5] = cloneableTags[stringTag3] = cloneableTags[symbolTag3] = cloneableTags[uint8Tag3] = cloneableTags[uint8ClampedTag3] = cloneableTags[uint16Tag3] = cloneableTags[uint32Tag3] = true;
  cloneableTags[errorTag3] = cloneableTags[funcTag3] = cloneableTags[weakMapTag3] = false;
  function baseClone(value, bitmask, customizer, key, object, stack) {
    var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) {
      result2 = object ? customizer(value, key, object, stack) : customizer(value);
    }
    if (result2 !== void 0) {
      return result2;
    }
    if (!isObject_default(value)) {
      return value;
    }
    var isArr = isArray_default(value);
    if (isArr) {
      result2 = initCloneArray_default(value);
      if (!isDeep) {
        return copyArray_default(value, result2);
      }
    } else {
      var tag = getTag_default(value), isFunc = tag == funcTag3 || tag == genTag2;
      if (isBuffer_default(value)) {
        return cloneBuffer_default(value, isDeep);
      }
      if (tag == objectTag4 || tag == argsTag3 || isFunc && !object) {
        result2 = isFlat || isFunc ? {} : initCloneObject_default(value);
        if (!isDeep) {
          return isFlat ? copySymbolsIn_default(value, baseAssignIn_default(result2, value)) : copySymbols_default(value, baseAssign_default(result2, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }
        result2 = initCloneByTag_default(value, tag, isDeep);
      }
    }
    stack || (stack = new Stack_default());
    var stacked = stack.get(value);
    if (stacked) {
      return stacked;
    }
    stack.set(value, result2);
    if (isSet_default(value)) {
      value.forEach(function(subValue) {
        result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
      });
    } else if (isMap_default(value)) {
      value.forEach(function(subValue, key2) {
        result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
      });
    }
    var keysFunc = isFull ? isFlat ? getAllKeysIn_default : getAllKeys_default : isFlat ? keysIn_default : keys_default;
    var props = isArr ? void 0 : keysFunc(value);
    arrayEach_default(props || value, function(subValue, key2) {
      if (props) {
        key2 = subValue;
        subValue = value[key2];
      }
      assignValue_default(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
    });
    return result2;
  }
  var baseClone_default = baseClone;

  // node_modules/lodash-es/clone.js
  var CLONE_SYMBOLS_FLAG2 = 4;
  function clone(value) {
    return baseClone_default(value, CLONE_SYMBOLS_FLAG2);
  }
  var clone_default = clone;

  // node_modules/lodash-es/cloneDeep.js
  init_define_process();
  var CLONE_DEEP_FLAG2 = 1;
  var CLONE_SYMBOLS_FLAG3 = 4;
  function cloneDeep(value) {
    return baseClone_default(value, CLONE_DEEP_FLAG2 | CLONE_SYMBOLS_FLAG3);
  }
  var cloneDeep_default = cloneDeep;

  // node_modules/lodash-es/cloneDeepWith.js
  init_define_process();
  var CLONE_DEEP_FLAG3 = 1;
  var CLONE_SYMBOLS_FLAG4 = 4;
  function cloneDeepWith(value, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    return baseClone_default(value, CLONE_DEEP_FLAG3 | CLONE_SYMBOLS_FLAG4, customizer);
  }
  var cloneDeepWith_default = cloneDeepWith;

  // node_modules/lodash-es/cloneWith.js
  init_define_process();
  var CLONE_SYMBOLS_FLAG5 = 4;
  function cloneWith(value, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    return baseClone_default(value, CLONE_SYMBOLS_FLAG5, customizer);
  }
  var cloneWith_default = cloneWith;

  // node_modules/lodash-es/commit.js
  init_define_process();
  function wrapperCommit() {
    return new LodashWrapper_default(this.value(), this.__chain__);
  }
  var commit_default = wrapperCommit;

  // node_modules/lodash-es/compact.js
  init_define_process();
  function compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index];
      if (value) {
        result2[resIndex++] = value;
      }
    }
    return result2;
  }
  var compact_default = compact;

  // node_modules/lodash-es/concat.js
  init_define_process();
  function concat() {
    var length = arguments.length;
    if (!length) {
      return [];
    }
    var args = Array(length - 1), array = arguments[0], index = length;
    while (index--) {
      args[index - 1] = arguments[index];
    }
    return arrayPush_default(isArray_default(array) ? copyArray_default(array) : [array], baseFlatten_default(args, 1));
  }
  var concat_default = concat;

  // node_modules/lodash-es/cond.js
  init_define_process();

  // node_modules/lodash-es/_baseIteratee.js
  init_define_process();

  // node_modules/lodash-es/_baseMatches.js
  init_define_process();

  // node_modules/lodash-es/_baseIsMatch.js
  init_define_process();

  // node_modules/lodash-es/_baseIsEqual.js
  init_define_process();

  // node_modules/lodash-es/_baseIsEqualDeep.js
  init_define_process();

  // node_modules/lodash-es/_equalArrays.js
  init_define_process();

  // node_modules/lodash-es/_SetCache.js
  init_define_process();

  // node_modules/lodash-es/_setCacheAdd.js
  init_define_process();
  var HASH_UNDEFINED3 = "__lodash_hash_undefined__";
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED3);
    return this;
  }
  var setCacheAdd_default = setCacheAdd;

  // node_modules/lodash-es/_setCacheHas.js
  init_define_process();
  function setCacheHas(value) {
    return this.__data__.has(value);
  }
  var setCacheHas_default = setCacheHas;

  // node_modules/lodash-es/_SetCache.js
  function SetCache(values2) {
    var index = -1, length = values2 == null ? 0 : values2.length;
    this.__data__ = new MapCache_default();
    while (++index < length) {
      this.add(values2[index]);
    }
  }
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd_default;
  SetCache.prototype.has = setCacheHas_default;
  var SetCache_default = SetCache;

  // node_modules/lodash-es/_arraySome.js
  init_define_process();
  function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  var arraySome_default = arraySome;

  // node_modules/lodash-es/_cacheHas.js
  init_define_process();
  function cacheHas(cache, key) {
    return cache.has(key);
  }
  var cacheHas_default = cacheHas;

  // node_modules/lodash-es/_equalArrays.js
  var COMPARE_PARTIAL_FLAG = 1;
  var COMPARE_UNORDERED_FLAG = 2;
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array;
    }
    var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache_default() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index < arrLength) {
      var arrValue = array[index], othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result2 = false;
        break;
      }
      if (seen) {
        if (!arraySome_default(other, function(othValue2, othIndex) {
          if (!cacheHas_default(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result2 = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result2 = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result2;
  }
  var equalArrays_default = equalArrays;

  // node_modules/lodash-es/_equalByTag.js
  init_define_process();

  // node_modules/lodash-es/_mapToArray.js
  init_define_process();
  function mapToArray(map2) {
    var index = -1, result2 = Array(map2.size);
    map2.forEach(function(value, key) {
      result2[++index] = [key, value];
    });
    return result2;
  }
  var mapToArray_default = mapToArray;

  // node_modules/lodash-es/_setToArray.js
  init_define_process();
  function setToArray(set2) {
    var index = -1, result2 = Array(set2.size);
    set2.forEach(function(value) {
      result2[++index] = value;
    });
    return result2;
  }
  var setToArray_default = setToArray;

  // node_modules/lodash-es/_equalByTag.js
  var COMPARE_PARTIAL_FLAG2 = 1;
  var COMPARE_UNORDERED_FLAG2 = 2;
  var boolTag4 = "[object Boolean]";
  var dateTag4 = "[object Date]";
  var errorTag4 = "[object Error]";
  var mapTag6 = "[object Map]";
  var numberTag4 = "[object Number]";
  var regexpTag4 = "[object RegExp]";
  var setTag6 = "[object Set]";
  var stringTag4 = "[object String]";
  var symbolTag4 = "[object Symbol]";
  var arrayBufferTag4 = "[object ArrayBuffer]";
  var dataViewTag5 = "[object DataView]";
  var symbolProto3 = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolValueOf2 = symbolProto3 ? symbolProto3.valueOf : void 0;
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag5:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag4:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array_default(object), new Uint8Array_default(other))) {
          return false;
        }
        return true;
      case boolTag4:
      case dateTag4:
      case numberTag4:
        return eq_default(+object, +other);
      case errorTag4:
        return object.name == other.name && object.message == other.message;
      case regexpTag4:
      case stringTag4:
        return object == other + "";
      case mapTag6:
        var convert = mapToArray_default;
      case setTag6:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
        convert || (convert = setToArray_default);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG2;
        stack.set(object, other);
        var result2 = equalArrays_default(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack["delete"](object);
        return result2;
      case symbolTag4:
        if (symbolValueOf2) {
          return symbolValueOf2.call(object) == symbolValueOf2.call(other);
        }
    }
    return false;
  }
  var equalByTag_default = equalByTag;

  // node_modules/lodash-es/_equalObjects.js
  init_define_process();
  var COMPARE_PARTIAL_FLAG3 = 1;
  var objectProto18 = Object.prototype;
  var hasOwnProperty15 = objectProto18.hasOwnProperty;
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG3, objProps = getAllKeys_default(object), objLength = objProps.length, othProps = getAllKeys_default(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty15.call(other, key))) {
        return false;
      }
    }
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object;
    }
    var result2 = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result2 = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result2 && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result2 = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result2;
  }
  var equalObjects_default = equalObjects;

  // node_modules/lodash-es/_baseIsEqualDeep.js
  var COMPARE_PARTIAL_FLAG4 = 1;
  var argsTag4 = "[object Arguments]";
  var arrayTag3 = "[object Array]";
  var objectTag5 = "[object Object]";
  var objectProto19 = Object.prototype;
  var hasOwnProperty16 = objectProto19.hasOwnProperty;
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray_default(object), othIsArr = isArray_default(other), objTag = objIsArr ? arrayTag3 : getTag_default(object), othTag = othIsArr ? arrayTag3 : getTag_default(other);
    objTag = objTag == argsTag4 ? objectTag5 : objTag;
    othTag = othTag == argsTag4 ? objectTag5 : othTag;
    var objIsObj = objTag == objectTag5, othIsObj = othTag == objectTag5, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer_default(object)) {
      if (!isBuffer_default(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack_default());
      return objIsArr || isTypedArray_default(object) ? equalArrays_default(object, other, bitmask, customizer, equalFunc, stack) : equalByTag_default(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG4)) {
      var objIsWrapped = objIsObj && hasOwnProperty16.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty16.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack_default());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack_default());
    return equalObjects_default(object, other, bitmask, customizer, equalFunc, stack);
  }
  var baseIsEqualDeep_default = baseIsEqualDeep;

  // node_modules/lodash-es/_baseIsEqual.js
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike_default(value) && !isObjectLike_default(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep_default(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  var baseIsEqual_default = baseIsEqual;

  // node_modules/lodash-es/_baseIsMatch.js
  var COMPARE_PARTIAL_FLAG5 = 1;
  var COMPARE_UNORDERED_FLAG3 = 2;
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0], objValue = object[key], srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === void 0 && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack_default();
        if (customizer) {
          var result2 = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result2 === void 0 ? baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG5 | COMPARE_UNORDERED_FLAG3, customizer, stack) : result2)) {
          return false;
        }
      }
    }
    return true;
  }
  var baseIsMatch_default = baseIsMatch;

  // node_modules/lodash-es/_getMatchData.js
  init_define_process();

  // node_modules/lodash-es/_isStrictComparable.js
  init_define_process();
  function isStrictComparable(value) {
    return value === value && !isObject_default(value);
  }
  var isStrictComparable_default = isStrictComparable;

  // node_modules/lodash-es/_getMatchData.js
  function getMatchData(object) {
    var result2 = keys_default(object), length = result2.length;
    while (length--) {
      var key = result2[length], value = object[key];
      result2[length] = [key, value, isStrictComparable_default(value)];
    }
    return result2;
  }
  var getMatchData_default = getMatchData;

  // node_modules/lodash-es/_matchesStrictComparable.js
  init_define_process();
  function matchesStrictComparable(key, srcValue) {
    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
    };
  }
  var matchesStrictComparable_default = matchesStrictComparable;

  // node_modules/lodash-es/_baseMatches.js
  function baseMatches(source) {
    var matchData = getMatchData_default(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable_default(matchData[0][0], matchData[0][1]);
    }
    return function(object) {
      return object === source || baseIsMatch_default(object, source, matchData);
    };
  }
  var baseMatches_default = baseMatches;

  // node_modules/lodash-es/_baseMatchesProperty.js
  init_define_process();

  // node_modules/lodash-es/hasIn.js
  init_define_process();

  // node_modules/lodash-es/_baseHasIn.js
  init_define_process();
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }
  var baseHasIn_default = baseHasIn;

  // node_modules/lodash-es/_hasPath.js
  init_define_process();
  function hasPath(object, path, hasFunc) {
    path = castPath_default(path, object);
    var index = -1, length = path.length, result2 = false;
    while (++index < length) {
      var key = toKey_default(path[index]);
      if (!(result2 = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result2 || ++index != length) {
      return result2;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength_default(length) && isIndex_default(key, length) && (isArray_default(object) || isArguments_default(object));
  }
  var hasPath_default = hasPath;

  // node_modules/lodash-es/hasIn.js
  function hasIn(object, path) {
    return object != null && hasPath_default(object, path, baseHasIn_default);
  }
  var hasIn_default = hasIn;

  // node_modules/lodash-es/_baseMatchesProperty.js
  var COMPARE_PARTIAL_FLAG6 = 1;
  var COMPARE_UNORDERED_FLAG4 = 2;
  function baseMatchesProperty(path, srcValue) {
    if (isKey_default(path) && isStrictComparable_default(srcValue)) {
      return matchesStrictComparable_default(toKey_default(path), srcValue);
    }
    return function(object) {
      var objValue = get_default(object, path);
      return objValue === void 0 && objValue === srcValue ? hasIn_default(object, path) : baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG6 | COMPARE_UNORDERED_FLAG4);
    };
  }
  var baseMatchesProperty_default = baseMatchesProperty;

  // node_modules/lodash-es/property.js
  init_define_process();

  // node_modules/lodash-es/_baseProperty.js
  init_define_process();
  function baseProperty(key) {
    return function(object) {
      return object == null ? void 0 : object[key];
    };
  }
  var baseProperty_default = baseProperty;

  // node_modules/lodash-es/_basePropertyDeep.js
  init_define_process();
  function basePropertyDeep(path) {
    return function(object) {
      return baseGet_default(object, path);
    };
  }
  var basePropertyDeep_default = basePropertyDeep;

  // node_modules/lodash-es/property.js
  function property(path) {
    return isKey_default(path) ? baseProperty_default(toKey_default(path)) : basePropertyDeep_default(path);
  }
  var property_default = property;

  // node_modules/lodash-es/_baseIteratee.js
  function baseIteratee(value) {
    if (typeof value == "function") {
      return value;
    }
    if (value == null) {
      return identity_default;
    }
    if (typeof value == "object") {
      return isArray_default(value) ? baseMatchesProperty_default(value[0], value[1]) : baseMatches_default(value);
    }
    return property_default(value);
  }
  var baseIteratee_default = baseIteratee;

  // node_modules/lodash-es/cond.js
  var FUNC_ERROR_TEXT5 = "Expected a function";
  function cond(pairs) {
    var length = pairs == null ? 0 : pairs.length, toIteratee = baseIteratee_default;
    pairs = !length ? [] : arrayMap_default(pairs, function(pair) {
      if (typeof pair[1] != "function") {
        throw new TypeError(FUNC_ERROR_TEXT5);
      }
      return [toIteratee(pair[0]), pair[1]];
    });
    return baseRest_default(function(args) {
      var index = -1;
      while (++index < length) {
        var pair = pairs[index];
        if (apply_default(pair[0], this, args)) {
          return apply_default(pair[1], this, args);
        }
      }
    });
  }
  var cond_default = cond;

  // node_modules/lodash-es/conforms.js
  init_define_process();

  // node_modules/lodash-es/_baseConforms.js
  init_define_process();

  // node_modules/lodash-es/_baseConformsTo.js
  init_define_process();
  function baseConformsTo(object, source, props) {
    var length = props.length;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (length--) {
      var key = props[length], predicate = source[key], value = object[key];
      if (value === void 0 && !(key in object) || !predicate(value)) {
        return false;
      }
    }
    return true;
  }
  var baseConformsTo_default = baseConformsTo;

  // node_modules/lodash-es/_baseConforms.js
  function baseConforms(source) {
    var props = keys_default(source);
    return function(object) {
      return baseConformsTo_default(object, source, props);
    };
  }
  var baseConforms_default = baseConforms;

  // node_modules/lodash-es/conforms.js
  var CLONE_DEEP_FLAG4 = 1;
  function conforms(source) {
    return baseConforms_default(baseClone_default(source, CLONE_DEEP_FLAG4));
  }
  var conforms_default = conforms;

  // node_modules/lodash-es/conformsTo.js
  init_define_process();
  function conformsTo(object, source) {
    return source == null || baseConformsTo_default(object, source, keys_default(source));
  }
  var conformsTo_default = conformsTo;

  // node_modules/lodash-es/countBy.js
  init_define_process();

  // node_modules/lodash-es/_createAggregator.js
  init_define_process();

  // node_modules/lodash-es/_arrayAggregator.js
  init_define_process();
  function arrayAggregator(array, setter, iteratee2, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee2(value), array);
    }
    return accumulator;
  }
  var arrayAggregator_default = arrayAggregator;

  // node_modules/lodash-es/_baseAggregator.js
  init_define_process();

  // node_modules/lodash-es/_baseEach.js
  init_define_process();

  // node_modules/lodash-es/_baseForOwn.js
  init_define_process();

  // node_modules/lodash-es/_baseFor.js
  init_define_process();

  // node_modules/lodash-es/_createBaseFor.js
  init_define_process();
  function createBaseFor(fromRight) {
    return function(object, iteratee2, keysFunc) {
      var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee2(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  var createBaseFor_default = createBaseFor;

  // node_modules/lodash-es/_baseFor.js
  var baseFor = createBaseFor_default();
  var baseFor_default = baseFor;

  // node_modules/lodash-es/_baseForOwn.js
  function baseForOwn(object, iteratee2) {
    return object && baseFor_default(object, iteratee2, keys_default);
  }
  var baseForOwn_default = baseForOwn;

  // node_modules/lodash-es/_createBaseEach.js
  init_define_process();
  function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee2) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike_default(collection)) {
        return eachFunc(collection, iteratee2);
      }
      var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
      while (fromRight ? index-- : ++index < length) {
        if (iteratee2(iterable[index], index, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }
  var createBaseEach_default = createBaseEach;

  // node_modules/lodash-es/_baseEach.js
  var baseEach = createBaseEach_default(baseForOwn_default);
  var baseEach_default = baseEach;

  // node_modules/lodash-es/_baseAggregator.js
  function baseAggregator(collection, setter, iteratee2, accumulator) {
    baseEach_default(collection, function(value, key, collection2) {
      setter(accumulator, value, iteratee2(value), collection2);
    });
    return accumulator;
  }
  var baseAggregator_default = baseAggregator;

  // node_modules/lodash-es/_createAggregator.js
  function createAggregator(setter, initializer) {
    return function(collection, iteratee2) {
      var func = isArray_default(collection) ? arrayAggregator_default : baseAggregator_default, accumulator = initializer ? initializer() : {};
      return func(collection, setter, baseIteratee_default(iteratee2, 2), accumulator);
    };
  }
  var createAggregator_default = createAggregator;

  // node_modules/lodash-es/countBy.js
  var objectProto20 = Object.prototype;
  var hasOwnProperty17 = objectProto20.hasOwnProperty;
  var countBy = createAggregator_default(function(result2, value, key) {
    if (hasOwnProperty17.call(result2, key)) {
      ++result2[key];
    } else {
      baseAssignValue_default(result2, key, 1);
    }
  });
  var countBy_default = countBy;

  // node_modules/lodash-es/create.js
  init_define_process();
  function create(prototype, properties) {
    var result2 = baseCreate_default(prototype);
    return properties == null ? result2 : baseAssign_default(result2, properties);
  }
  var create_default = create;

  // node_modules/lodash-es/curry.js
  init_define_process();
  var WRAP_CURRY_FLAG6 = 8;
  function curry(func, arity, guard) {
    arity = guard ? void 0 : arity;
    var result2 = createWrap_default(func, WRAP_CURRY_FLAG6, void 0, void 0, void 0, void 0, void 0, arity);
    result2.placeholder = curry.placeholder;
    return result2;
  }
  curry.placeholder = {};
  var curry_default = curry;

  // node_modules/lodash-es/curryRight.js
  init_define_process();
  var WRAP_CURRY_RIGHT_FLAG4 = 16;
  function curryRight(func, arity, guard) {
    arity = guard ? void 0 : arity;
    var result2 = createWrap_default(func, WRAP_CURRY_RIGHT_FLAG4, void 0, void 0, void 0, void 0, void 0, arity);
    result2.placeholder = curryRight.placeholder;
    return result2;
  }
  curryRight.placeholder = {};
  var curryRight_default = curryRight;

  // node_modules/lodash-es/debounce.js
  init_define_process();

  // node_modules/lodash-es/now.js
  init_define_process();
  var now = function() {
    return root_default.Date.now();
  };
  var now_default = now;

  // node_modules/lodash-es/debounce.js
  var FUNC_ERROR_TEXT6 = "Expected a function";
  var nativeMax6 = Math.max;
  var nativeMin4 = Math.min;
  function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT6);
    }
    wait = toNumber_default(wait) || 0;
    if (isObject_default(options)) {
      leading = !!options.leading;
      maxing = "maxWait" in options;
      maxWait = maxing ? nativeMax6(toNumber_default(options.maxWait) || 0, wait) : maxWait;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
      var args = lastArgs, thisArg = lastThis;
      lastArgs = lastThis = void 0;
      lastInvokeTime = time;
      result2 = func.apply(thisArg, args);
      return result2;
    }
    function leadingEdge(time) {
      lastInvokeTime = time;
      timerId = setTimeout(timerExpired, wait);
      return leading ? invokeFunc(time) : result2;
    }
    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
      return maxing ? nativeMin4(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
      return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
      var time = now_default();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
      timerId = void 0;
      if (trailing && lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = void 0;
      return result2;
    }
    function cancel() {
      if (timerId !== void 0) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = void 0;
    }
    function flush() {
      return timerId === void 0 ? result2 : trailingEdge(now_default());
    }
    function debounced() {
      var time = now_default(), isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;
      if (isInvoking) {
        if (timerId === void 0) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          clearTimeout(timerId);
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === void 0) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result2;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }
  var debounce_default = debounce;

  // node_modules/lodash-es/defaultTo.js
  init_define_process();
  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
  var defaultTo_default = defaultTo;

  // node_modules/lodash-es/defaults.js
  init_define_process();
  var objectProto21 = Object.prototype;
  var hasOwnProperty18 = objectProto21.hasOwnProperty;
  var defaults = baseRest_default(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : void 0;
    if (guard && isIterateeCall_default(sources[0], sources[1], guard)) {
      length = 1;
    }
    while (++index < length) {
      var source = sources[index];
      var props = keysIn_default(source);
      var propsIndex = -1;
      var propsLength = props.length;
      while (++propsIndex < propsLength) {
        var key = props[propsIndex];
        var value = object[key];
        if (value === void 0 || eq_default(value, objectProto21[key]) && !hasOwnProperty18.call(object, key)) {
          object[key] = source[key];
        }
      }
    }
    return object;
  });
  var defaults_default = defaults;

  // node_modules/lodash-es/defaultsDeep.js
  init_define_process();

  // node_modules/lodash-es/_customDefaultsMerge.js
  init_define_process();

  // node_modules/lodash-es/_baseMerge.js
  init_define_process();

  // node_modules/lodash-es/_assignMergeValue.js
  init_define_process();
  function assignMergeValue(object, key, value) {
    if (value !== void 0 && !eq_default(object[key], value) || value === void 0 && !(key in object)) {
      baseAssignValue_default(object, key, value);
    }
  }
  var assignMergeValue_default = assignMergeValue;

  // node_modules/lodash-es/_baseMergeDeep.js
  init_define_process();

  // node_modules/lodash-es/isArrayLikeObject.js
  init_define_process();
  function isArrayLikeObject(value) {
    return isObjectLike_default(value) && isArrayLike_default(value);
  }
  var isArrayLikeObject_default = isArrayLikeObject;

  // node_modules/lodash-es/_safeGet.js
  init_define_process();
  function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") {
      return;
    }
    if (key == "__proto__") {
      return;
    }
    return object[key];
  }
  var safeGet_default = safeGet;

  // node_modules/lodash-es/toPlainObject.js
  init_define_process();
  function toPlainObject(value) {
    return copyObject_default(value, keysIn_default(value));
  }
  var toPlainObject_default = toPlainObject;

  // node_modules/lodash-es/_baseMergeDeep.js
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet_default(object, key), srcValue = safeGet_default(source, key), stacked = stack.get(srcValue);
    if (stacked) {
      assignMergeValue_default(object, key, stacked);
      return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
    var isCommon = newValue === void 0;
    if (isCommon) {
      var isArr = isArray_default(srcValue), isBuff = !isArr && isBuffer_default(srcValue), isTyped = !isArr && !isBuff && isTypedArray_default(srcValue);
      newValue = srcValue;
      if (isArr || isBuff || isTyped) {
        if (isArray_default(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject_default(objValue)) {
          newValue = copyArray_default(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer_default(srcValue, true);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray_default(srcValue, true);
        } else {
          newValue = [];
        }
      } else if (isPlainObject_default(srcValue) || isArguments_default(srcValue)) {
        newValue = objValue;
        if (isArguments_default(objValue)) {
          newValue = toPlainObject_default(objValue);
        } else if (!isObject_default(objValue) || isFunction_default(objValue)) {
          newValue = initCloneObject_default(srcValue);
        }
      } else {
        isCommon = false;
      }
    }
    if (isCommon) {
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack["delete"](srcValue);
    }
    assignMergeValue_default(object, key, newValue);
  }
  var baseMergeDeep_default = baseMergeDeep;

  // node_modules/lodash-es/_baseMerge.js
  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }
    baseFor_default(source, function(srcValue, key) {
      stack || (stack = new Stack_default());
      if (isObject_default(srcValue)) {
        baseMergeDeep_default(object, source, key, srcIndex, baseMerge, customizer, stack);
      } else {
        var newValue = customizer ? customizer(safeGet_default(object, key), srcValue, key + "", object, source, stack) : void 0;
        if (newValue === void 0) {
          newValue = srcValue;
        }
        assignMergeValue_default(object, key, newValue);
      }
    }, keysIn_default);
  }
  var baseMerge_default = baseMerge;

  // node_modules/lodash-es/_customDefaultsMerge.js
  function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if (isObject_default(objValue) && isObject_default(srcValue)) {
      stack.set(srcValue, objValue);
      baseMerge_default(objValue, srcValue, void 0, customDefaultsMerge, stack);
      stack["delete"](srcValue);
    }
    return objValue;
  }
  var customDefaultsMerge_default = customDefaultsMerge;

  // node_modules/lodash-es/mergeWith.js
  init_define_process();
  var mergeWith = createAssigner_default(function(object, source, srcIndex, customizer) {
    baseMerge_default(object, source, srcIndex, customizer);
  });
  var mergeWith_default = mergeWith;

  // node_modules/lodash-es/defaultsDeep.js
  var defaultsDeep = baseRest_default(function(args) {
    args.push(void 0, customDefaultsMerge_default);
    return apply_default(mergeWith_default, void 0, args);
  });
  var defaultsDeep_default = defaultsDeep;

  // node_modules/lodash-es/defer.js
  init_define_process();

  // node_modules/lodash-es/_baseDelay.js
  init_define_process();
  var FUNC_ERROR_TEXT7 = "Expected a function";
  function baseDelay(func, wait, args) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT7);
    }
    return setTimeout(function() {
      func.apply(void 0, args);
    }, wait);
  }
  var baseDelay_default = baseDelay;

  // node_modules/lodash-es/defer.js
  var defer = baseRest_default(function(func, args) {
    return baseDelay_default(func, 1, args);
  });
  var defer_default = defer;

  // node_modules/lodash-es/delay.js
  init_define_process();
  var delay = baseRest_default(function(func, wait, args) {
    return baseDelay_default(func, toNumber_default(wait) || 0, args);
  });
  var delay_default = delay;

  // node_modules/lodash-es/difference.js
  init_define_process();

  // node_modules/lodash-es/_baseDifference.js
  init_define_process();

  // node_modules/lodash-es/_arrayIncludesWith.js
  init_define_process();
  function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }
  var arrayIncludesWith_default = arrayIncludesWith;

  // node_modules/lodash-es/_baseDifference.js
  var LARGE_ARRAY_SIZE2 = 200;
  function baseDifference(array, values2, iteratee2, comparator) {
    var index = -1, includes2 = arrayIncludes_default, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
    if (!length) {
      return result2;
    }
    if (iteratee2) {
      values2 = arrayMap_default(values2, baseUnary_default(iteratee2));
    }
    if (comparator) {
      includes2 = arrayIncludesWith_default;
      isCommon = false;
    } else if (values2.length >= LARGE_ARRAY_SIZE2) {
      includes2 = cacheHas_default;
      isCommon = false;
      values2 = new SetCache_default(values2);
    }
    outer:
      while (++index < length) {
        var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values2[valuesIndex] === computed) {
              continue outer;
            }
          }
          result2.push(value);
        } else if (!includes2(values2, computed, comparator)) {
          result2.push(value);
        }
      }
    return result2;
  }
  var baseDifference_default = baseDifference;

  // node_modules/lodash-es/difference.js
  var difference = baseRest_default(function(array, values2) {
    return isArrayLikeObject_default(array) ? baseDifference_default(array, baseFlatten_default(values2, 1, isArrayLikeObject_default, true)) : [];
  });
  var difference_default = difference;

  // node_modules/lodash-es/differenceBy.js
  init_define_process();

  // node_modules/lodash-es/last.js
  init_define_process();
  function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
  }
  var last_default = last;

  // node_modules/lodash-es/differenceBy.js
  var differenceBy = baseRest_default(function(array, values2) {
    var iteratee2 = last_default(values2);
    if (isArrayLikeObject_default(iteratee2)) {
      iteratee2 = void 0;
    }
    return isArrayLikeObject_default(array) ? baseDifference_default(array, baseFlatten_default(values2, 1, isArrayLikeObject_default, true), baseIteratee_default(iteratee2, 2)) : [];
  });
  var differenceBy_default = differenceBy;

  // node_modules/lodash-es/differenceWith.js
  init_define_process();
  var differenceWith = baseRest_default(function(array, values2) {
    var comparator = last_default(values2);
    if (isArrayLikeObject_default(comparator)) {
      comparator = void 0;
    }
    return isArrayLikeObject_default(array) ? baseDifference_default(array, baseFlatten_default(values2, 1, isArrayLikeObject_default, true), void 0, comparator) : [];
  });
  var differenceWith_default = differenceWith;

  // node_modules/lodash-es/divide.js
  init_define_process();
  var divide = createMathOperation_default(function(dividend, divisor) {
    return dividend / divisor;
  }, 1);
  var divide_default = divide;

  // node_modules/lodash-es/drop.js
  init_define_process();
  function drop(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    return baseSlice_default(array, n < 0 ? 0 : n, length);
  }
  var drop_default = drop;

  // node_modules/lodash-es/dropRight.js
  init_define_process();
  function dropRight(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    n = length - n;
    return baseSlice_default(array, 0, n < 0 ? 0 : n);
  }
  var dropRight_default = dropRight;

  // node_modules/lodash-es/dropRightWhile.js
  init_define_process();

  // node_modules/lodash-es/_baseWhile.js
  init_define_process();
  function baseWhile(array, predicate, isDrop, fromRight) {
    var length = array.length, index = fromRight ? length : -1;
    while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
    }
    return isDrop ? baseSlice_default(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice_default(array, fromRight ? index + 1 : 0, fromRight ? length : index);
  }
  var baseWhile_default = baseWhile;

  // node_modules/lodash-es/dropRightWhile.js
  function dropRightWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3), true, true) : [];
  }
  var dropRightWhile_default = dropRightWhile;

  // node_modules/lodash-es/dropWhile.js
  init_define_process();
  function dropWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3), true) : [];
  }
  var dropWhile_default = dropWhile;

  // node_modules/lodash-es/each.js
  init_define_process();

  // node_modules/lodash-es/forEach.js
  init_define_process();

  // node_modules/lodash-es/_castFunction.js
  init_define_process();
  function castFunction(value) {
    return typeof value == "function" ? value : identity_default;
  }
  var castFunction_default = castFunction;

  // node_modules/lodash-es/forEach.js
  function forEach(collection, iteratee2) {
    var func = isArray_default(collection) ? arrayEach_default : baseEach_default;
    return func(collection, castFunction_default(iteratee2));
  }
  var forEach_default = forEach;

  // node_modules/lodash-es/eachRight.js
  init_define_process();

  // node_modules/lodash-es/forEachRight.js
  init_define_process();

  // node_modules/lodash-es/_arrayEachRight.js
  init_define_process();
  function arrayEachRight(array, iteratee2) {
    var length = array == null ? 0 : array.length;
    while (length--) {
      if (iteratee2(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }
  var arrayEachRight_default = arrayEachRight;

  // node_modules/lodash-es/_baseEachRight.js
  init_define_process();

  // node_modules/lodash-es/_baseForOwnRight.js
  init_define_process();

  // node_modules/lodash-es/_baseForRight.js
  init_define_process();
  var baseForRight = createBaseFor_default(true);
  var baseForRight_default = baseForRight;

  // node_modules/lodash-es/_baseForOwnRight.js
  function baseForOwnRight(object, iteratee2) {
    return object && baseForRight_default(object, iteratee2, keys_default);
  }
  var baseForOwnRight_default = baseForOwnRight;

  // node_modules/lodash-es/_baseEachRight.js
  var baseEachRight = createBaseEach_default(baseForOwnRight_default, true);
  var baseEachRight_default = baseEachRight;

  // node_modules/lodash-es/forEachRight.js
  function forEachRight(collection, iteratee2) {
    var func = isArray_default(collection) ? arrayEachRight_default : baseEachRight_default;
    return func(collection, castFunction_default(iteratee2));
  }
  var forEachRight_default = forEachRight;

  // node_modules/lodash-es/endsWith.js
  init_define_process();
  function endsWith(string, target, position) {
    string = toString_default(string);
    target = baseToString_default(target);
    var length = string.length;
    position = position === void 0 ? length : baseClamp_default(toInteger_default(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
  }
  var endsWith_default = endsWith;

  // node_modules/lodash-es/entries.js
  init_define_process();

  // node_modules/lodash-es/toPairs.js
  init_define_process();

  // node_modules/lodash-es/_createToPairs.js
  init_define_process();

  // node_modules/lodash-es/_baseToPairs.js
  init_define_process();
  function baseToPairs(object, props) {
    return arrayMap_default(props, function(key) {
      return [key, object[key]];
    });
  }
  var baseToPairs_default = baseToPairs;

  // node_modules/lodash-es/_setToPairs.js
  init_define_process();
  function setToPairs(set2) {
    var index = -1, result2 = Array(set2.size);
    set2.forEach(function(value) {
      result2[++index] = [value, value];
    });
    return result2;
  }
  var setToPairs_default = setToPairs;

  // node_modules/lodash-es/_createToPairs.js
  var mapTag7 = "[object Map]";
  var setTag7 = "[object Set]";
  function createToPairs(keysFunc) {
    return function(object) {
      var tag = getTag_default(object);
      if (tag == mapTag7) {
        return mapToArray_default(object);
      }
      if (tag == setTag7) {
        return setToPairs_default(object);
      }
      return baseToPairs_default(object, keysFunc(object));
    };
  }
  var createToPairs_default = createToPairs;

  // node_modules/lodash-es/toPairs.js
  var toPairs = createToPairs_default(keys_default);
  var toPairs_default = toPairs;

  // node_modules/lodash-es/entriesIn.js
  init_define_process();

  // node_modules/lodash-es/toPairsIn.js
  init_define_process();
  var toPairsIn = createToPairs_default(keysIn_default);
  var toPairsIn_default = toPairsIn;

  // node_modules/lodash-es/escape.js
  init_define_process();

  // node_modules/lodash-es/_escapeHtmlChar.js
  init_define_process();
  var htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  };
  var escapeHtmlChar = basePropertyOf_default(htmlEscapes);
  var escapeHtmlChar_default = escapeHtmlChar;

  // node_modules/lodash-es/escape.js
  var reUnescapedHtml = /[&<>"']/g;
  var reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
  function escape(string) {
    string = toString_default(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar_default) : string;
  }
  var escape_default = escape;

  // node_modules/lodash-es/escapeRegExp.js
  init_define_process();
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reHasRegExpChar = RegExp(reRegExpChar2.source);
  function escapeRegExp(string) {
    string = toString_default(string);
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar2, "\\$&") : string;
  }
  var escapeRegExp_default = escapeRegExp;

  // node_modules/lodash-es/every.js
  init_define_process();

  // node_modules/lodash-es/_arrayEvery.js
  init_define_process();
  function arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }
  var arrayEvery_default = arrayEvery;

  // node_modules/lodash-es/_baseEvery.js
  init_define_process();
  function baseEvery(collection, predicate) {
    var result2 = true;
    baseEach_default(collection, function(value, index, collection2) {
      result2 = !!predicate(value, index, collection2);
      return result2;
    });
    return result2;
  }
  var baseEvery_default = baseEvery;

  // node_modules/lodash-es/every.js
  function every(collection, predicate, guard) {
    var func = isArray_default(collection) ? arrayEvery_default : baseEvery_default;
    if (guard && isIterateeCall_default(collection, predicate, guard)) {
      predicate = void 0;
    }
    return func(collection, baseIteratee_default(predicate, 3));
  }
  var every_default = every;

  // node_modules/lodash-es/extend.js
  init_define_process();

  // node_modules/lodash-es/extendWith.js
  init_define_process();

  // node_modules/lodash-es/fill.js
  init_define_process();

  // node_modules/lodash-es/_baseFill.js
  init_define_process();

  // node_modules/lodash-es/toLength.js
  init_define_process();
  var MAX_ARRAY_LENGTH2 = 4294967295;
  function toLength(value) {
    return value ? baseClamp_default(toInteger_default(value), 0, MAX_ARRAY_LENGTH2) : 0;
  }
  var toLength_default = toLength;

  // node_modules/lodash-es/_baseFill.js
  function baseFill(array, value, start, end) {
    var length = array.length;
    start = toInteger_default(start);
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end === void 0 || end > length ? length : toInteger_default(end);
    if (end < 0) {
      end += length;
    }
    end = start > end ? 0 : toLength_default(end);
    while (start < end) {
      array[start++] = value;
    }
    return array;
  }
  var baseFill_default = baseFill;

  // node_modules/lodash-es/fill.js
  function fill(array, value, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    if (start && typeof start != "number" && isIterateeCall_default(array, value, start)) {
      start = 0;
      end = length;
    }
    return baseFill_default(array, value, start, end);
  }
  var fill_default = fill;

  // node_modules/lodash-es/filter.js
  init_define_process();

  // node_modules/lodash-es/_baseFilter.js
  init_define_process();
  function baseFilter(collection, predicate) {
    var result2 = [];
    baseEach_default(collection, function(value, index, collection2) {
      if (predicate(value, index, collection2)) {
        result2.push(value);
      }
    });
    return result2;
  }
  var baseFilter_default = baseFilter;

  // node_modules/lodash-es/filter.js
  function filter(collection, predicate) {
    var func = isArray_default(collection) ? arrayFilter_default : baseFilter_default;
    return func(collection, baseIteratee_default(predicate, 3));
  }
  var filter_default = filter;

  // node_modules/lodash-es/find.js
  init_define_process();

  // node_modules/lodash-es/_createFind.js
  init_define_process();
  function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
      var iterable = Object(collection);
      if (!isArrayLike_default(collection)) {
        var iteratee2 = baseIteratee_default(predicate, 3);
        collection = keys_default(collection);
        predicate = function(key) {
          return iteratee2(iterable[key], key, iterable);
        };
      }
      var index = findIndexFunc(collection, predicate, fromIndex);
      return index > -1 ? iterable[iteratee2 ? collection[index] : index] : void 0;
    };
  }
  var createFind_default = createFind;

  // node_modules/lodash-es/findIndex.js
  init_define_process();
  var nativeMax7 = Math.max;
  function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = fromIndex == null ? 0 : toInteger_default(fromIndex);
    if (index < 0) {
      index = nativeMax7(length + index, 0);
    }
    return baseFindIndex_default(array, baseIteratee_default(predicate, 3), index);
  }
  var findIndex_default = findIndex;

  // node_modules/lodash-es/find.js
  var find = createFind_default(findIndex_default);
  var find_default = find;

  // node_modules/lodash-es/findKey.js
  init_define_process();

  // node_modules/lodash-es/_baseFindKey.js
  init_define_process();
  function baseFindKey(collection, predicate, eachFunc) {
    var result2;
    eachFunc(collection, function(value, key, collection2) {
      if (predicate(value, key, collection2)) {
        result2 = key;
        return false;
      }
    });
    return result2;
  }
  var baseFindKey_default = baseFindKey;

  // node_modules/lodash-es/findKey.js
  function findKey(object, predicate) {
    return baseFindKey_default(object, baseIteratee_default(predicate, 3), baseForOwn_default);
  }
  var findKey_default = findKey;

  // node_modules/lodash-es/findLast.js
  init_define_process();

  // node_modules/lodash-es/findLastIndex.js
  init_define_process();
  var nativeMax8 = Math.max;
  var nativeMin5 = Math.min;
  function findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = length - 1;
    if (fromIndex !== void 0) {
      index = toInteger_default(fromIndex);
      index = fromIndex < 0 ? nativeMax8(length + index, 0) : nativeMin5(index, length - 1);
    }
    return baseFindIndex_default(array, baseIteratee_default(predicate, 3), index, true);
  }
  var findLastIndex_default = findLastIndex;

  // node_modules/lodash-es/findLast.js
  var findLast = createFind_default(findLastIndex_default);
  var findLast_default = findLast;

  // node_modules/lodash-es/findLastKey.js
  init_define_process();
  function findLastKey(object, predicate) {
    return baseFindKey_default(object, baseIteratee_default(predicate, 3), baseForOwnRight_default);
  }
  var findLastKey_default = findLastKey;

  // node_modules/lodash-es/first.js
  init_define_process();

  // node_modules/lodash-es/head.js
  init_define_process();
  function head(array) {
    return array && array.length ? array[0] : void 0;
  }
  var head_default = head;

  // node_modules/lodash-es/flatMap.js
  init_define_process();

  // node_modules/lodash-es/map.js
  init_define_process();

  // node_modules/lodash-es/_baseMap.js
  init_define_process();
  function baseMap(collection, iteratee2) {
    var index = -1, result2 = isArrayLike_default(collection) ? Array(collection.length) : [];
    baseEach_default(collection, function(value, key, collection2) {
      result2[++index] = iteratee2(value, key, collection2);
    });
    return result2;
  }
  var baseMap_default = baseMap;

  // node_modules/lodash-es/map.js
  function map(collection, iteratee2) {
    var func = isArray_default(collection) ? arrayMap_default : baseMap_default;
    return func(collection, baseIteratee_default(iteratee2, 3));
  }
  var map_default = map;

  // node_modules/lodash-es/flatMap.js
  function flatMap(collection, iteratee2) {
    return baseFlatten_default(map_default(collection, iteratee2), 1);
  }
  var flatMap_default = flatMap;

  // node_modules/lodash-es/flatMapDeep.js
  init_define_process();
  var INFINITY4 = 1 / 0;
  function flatMapDeep(collection, iteratee2) {
    return baseFlatten_default(map_default(collection, iteratee2), INFINITY4);
  }
  var flatMapDeep_default = flatMapDeep;

  // node_modules/lodash-es/flatMapDepth.js
  init_define_process();
  function flatMapDepth(collection, iteratee2, depth) {
    depth = depth === void 0 ? 1 : toInteger_default(depth);
    return baseFlatten_default(map_default(collection, iteratee2), depth);
  }
  var flatMapDepth_default = flatMapDepth;

  // node_modules/lodash-es/flattenDeep.js
  init_define_process();
  var INFINITY5 = 1 / 0;
  function flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten_default(array, INFINITY5) : [];
  }
  var flattenDeep_default = flattenDeep;

  // node_modules/lodash-es/flattenDepth.js
  init_define_process();
  function flattenDepth(array, depth) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    depth = depth === void 0 ? 1 : toInteger_default(depth);
    return baseFlatten_default(array, depth);
  }
  var flattenDepth_default = flattenDepth;

  // node_modules/lodash-es/flip.js
  init_define_process();
  var WRAP_FLIP_FLAG3 = 512;
  function flip(func) {
    return createWrap_default(func, WRAP_FLIP_FLAG3);
  }
  var flip_default = flip;

  // node_modules/lodash-es/floor.js
  init_define_process();
  var floor = createRound_default("floor");
  var floor_default = floor;

  // node_modules/lodash-es/flow.js
  init_define_process();

  // node_modules/lodash-es/_createFlow.js
  init_define_process();
  var FUNC_ERROR_TEXT8 = "Expected a function";
  var WRAP_CURRY_FLAG7 = 8;
  var WRAP_PARTIAL_FLAG6 = 32;
  var WRAP_ARY_FLAG5 = 128;
  var WRAP_REARG_FLAG3 = 256;
  function createFlow(fromRight) {
    return flatRest_default(function(funcs) {
      var length = funcs.length, index = length, prereq = LodashWrapper_default.prototype.thru;
      if (fromRight) {
        funcs.reverse();
      }
      while (index--) {
        var func = funcs[index];
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT8);
        }
        if (prereq && !wrapper && getFuncName_default(func) == "wrapper") {
          var wrapper = new LodashWrapper_default([], true);
        }
      }
      index = wrapper ? index : length;
      while (++index < length) {
        func = funcs[index];
        var funcName = getFuncName_default(func), data = funcName == "wrapper" ? getData_default(func) : void 0;
        if (data && isLaziable_default(data[0]) && data[1] == (WRAP_ARY_FLAG5 | WRAP_CURRY_FLAG7 | WRAP_PARTIAL_FLAG6 | WRAP_REARG_FLAG3) && !data[4].length && data[9] == 1) {
          wrapper = wrapper[getFuncName_default(data[0])].apply(wrapper, data[3]);
        } else {
          wrapper = func.length == 1 && isLaziable_default(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
      }
      return function() {
        var args = arguments, value = args[0];
        if (wrapper && args.length == 1 && isArray_default(value)) {
          return wrapper.plant(value).value();
        }
        var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
        while (++index2 < length) {
          result2 = funcs[index2].call(this, result2);
        }
        return result2;
      };
    });
  }
  var createFlow_default = createFlow;

  // node_modules/lodash-es/flow.js
  var flow = createFlow_default();
  var flow_default = flow;

  // node_modules/lodash-es/flowRight.js
  init_define_process();
  var flowRight = createFlow_default(true);
  var flowRight_default = flowRight;

  // node_modules/lodash-es/forIn.js
  init_define_process();
  function forIn(object, iteratee2) {
    return object == null ? object : baseFor_default(object, castFunction_default(iteratee2), keysIn_default);
  }
  var forIn_default = forIn;

  // node_modules/lodash-es/forInRight.js
  init_define_process();
  function forInRight(object, iteratee2) {
    return object == null ? object : baseForRight_default(object, castFunction_default(iteratee2), keysIn_default);
  }
  var forInRight_default = forInRight;

  // node_modules/lodash-es/forOwn.js
  init_define_process();
  function forOwn(object, iteratee2) {
    return object && baseForOwn_default(object, castFunction_default(iteratee2));
  }
  var forOwn_default = forOwn;

  // node_modules/lodash-es/forOwnRight.js
  init_define_process();
  function forOwnRight(object, iteratee2) {
    return object && baseForOwnRight_default(object, castFunction_default(iteratee2));
  }
  var forOwnRight_default = forOwnRight;

  // node_modules/lodash-es/fromPairs.js
  init_define_process();
  function fromPairs(pairs) {
    var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
    while (++index < length) {
      var pair = pairs[index];
      result2[pair[0]] = pair[1];
    }
    return result2;
  }
  var fromPairs_default = fromPairs;

  // node_modules/lodash-es/functions.js
  init_define_process();

  // node_modules/lodash-es/_baseFunctions.js
  init_define_process();
  function baseFunctions(object, props) {
    return arrayFilter_default(props, function(key) {
      return isFunction_default(object[key]);
    });
  }
  var baseFunctions_default = baseFunctions;

  // node_modules/lodash-es/functions.js
  function functions(object) {
    return object == null ? [] : baseFunctions_default(object, keys_default(object));
  }
  var functions_default = functions;

  // node_modules/lodash-es/functionsIn.js
  init_define_process();
  function functionsIn(object) {
    return object == null ? [] : baseFunctions_default(object, keysIn_default(object));
  }
  var functionsIn_default = functionsIn;

  // node_modules/lodash-es/groupBy.js
  init_define_process();
  var objectProto22 = Object.prototype;
  var hasOwnProperty19 = objectProto22.hasOwnProperty;
  var groupBy = createAggregator_default(function(result2, value, key) {
    if (hasOwnProperty19.call(result2, key)) {
      result2[key].push(value);
    } else {
      baseAssignValue_default(result2, key, [value]);
    }
  });
  var groupBy_default = groupBy;

  // node_modules/lodash-es/gt.js
  init_define_process();

  // node_modules/lodash-es/_baseGt.js
  init_define_process();
  function baseGt(value, other) {
    return value > other;
  }
  var baseGt_default = baseGt;

  // node_modules/lodash-es/_createRelationalOperation.js
  init_define_process();
  function createRelationalOperation(operator) {
    return function(value, other) {
      if (!(typeof value == "string" && typeof other == "string")) {
        value = toNumber_default(value);
        other = toNumber_default(other);
      }
      return operator(value, other);
    };
  }
  var createRelationalOperation_default = createRelationalOperation;

  // node_modules/lodash-es/gt.js
  var gt = createRelationalOperation_default(baseGt_default);
  var gt_default = gt;

  // node_modules/lodash-es/gte.js
  init_define_process();
  var gte = createRelationalOperation_default(function(value, other) {
    return value >= other;
  });
  var gte_default = gte;

  // node_modules/lodash-es/has.js
  init_define_process();

  // node_modules/lodash-es/_baseHas.js
  init_define_process();
  var objectProto23 = Object.prototype;
  var hasOwnProperty20 = objectProto23.hasOwnProperty;
  function baseHas(object, key) {
    return object != null && hasOwnProperty20.call(object, key);
  }
  var baseHas_default = baseHas;

  // node_modules/lodash-es/has.js
  function has(object, path) {
    return object != null && hasPath_default(object, path, baseHas_default);
  }
  var has_default = has;

  // node_modules/lodash-es/inRange.js
  init_define_process();

  // node_modules/lodash-es/_baseInRange.js
  init_define_process();
  var nativeMax9 = Math.max;
  var nativeMin6 = Math.min;
  function baseInRange(number, start, end) {
    return number >= nativeMin6(start, end) && number < nativeMax9(start, end);
  }
  var baseInRange_default = baseInRange;

  // node_modules/lodash-es/inRange.js
  function inRange(number, start, end) {
    start = toFinite_default(start);
    if (end === void 0) {
      end = start;
      start = 0;
    } else {
      end = toFinite_default(end);
    }
    number = toNumber_default(number);
    return baseInRange_default(number, start, end);
  }
  var inRange_default = inRange;

  // node_modules/lodash-es/includes.js
  init_define_process();

  // node_modules/lodash-es/isString.js
  init_define_process();
  var stringTag5 = "[object String]";
  function isString(value) {
    return typeof value == "string" || !isArray_default(value) && isObjectLike_default(value) && baseGetTag_default(value) == stringTag5;
  }
  var isString_default = isString;

  // node_modules/lodash-es/values.js
  init_define_process();

  // node_modules/lodash-es/_baseValues.js
  init_define_process();
  function baseValues(object, props) {
    return arrayMap_default(props, function(key) {
      return object[key];
    });
  }
  var baseValues_default = baseValues;

  // node_modules/lodash-es/values.js
  function values(object) {
    return object == null ? [] : baseValues_default(object, keys_default(object));
  }
  var values_default = values;

  // node_modules/lodash-es/includes.js
  var nativeMax10 = Math.max;
  function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike_default(collection) ? collection : values_default(collection);
    fromIndex = fromIndex && !guard ? toInteger_default(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) {
      fromIndex = nativeMax10(length + fromIndex, 0);
    }
    return isString_default(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf_default(collection, value, fromIndex) > -1;
  }
  var includes_default = includes;

  // node_modules/lodash-es/indexOf.js
  init_define_process();
  var nativeMax11 = Math.max;
  function indexOf(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = fromIndex == null ? 0 : toInteger_default(fromIndex);
    if (index < 0) {
      index = nativeMax11(length + index, 0);
    }
    return baseIndexOf_default(array, value, index);
  }
  var indexOf_default = indexOf;

  // node_modules/lodash-es/initial.js
  init_define_process();
  function initial(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseSlice_default(array, 0, -1) : [];
  }
  var initial_default = initial;

  // node_modules/lodash-es/intersection.js
  init_define_process();

  // node_modules/lodash-es/_baseIntersection.js
  init_define_process();
  var nativeMin7 = Math.min;
  function baseIntersection(arrays, iteratee2, comparator) {
    var includes2 = comparator ? arrayIncludesWith_default : arrayIncludes_default, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result2 = [];
    while (othIndex--) {
      var array = arrays[othIndex];
      if (othIndex && iteratee2) {
        array = arrayMap_default(array, baseUnary_default(iteratee2));
      }
      maxLength = nativeMin7(array.length, maxLength);
      caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache_default(othIndex && array) : void 0;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer:
      while (++index < length && result2.length < maxLength) {
        var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? cacheHas_default(seen, computed) : includes2(result2, computed, comparator))) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache ? cacheHas_default(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result2.push(value);
        }
      }
    return result2;
  }
  var baseIntersection_default = baseIntersection;

  // node_modules/lodash-es/_castArrayLikeObject.js
  init_define_process();
  function castArrayLikeObject(value) {
    return isArrayLikeObject_default(value) ? value : [];
  }
  var castArrayLikeObject_default = castArrayLikeObject;

  // node_modules/lodash-es/intersection.js
  var intersection = baseRest_default(function(arrays) {
    var mapped = arrayMap_default(arrays, castArrayLikeObject_default);
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection_default(mapped) : [];
  });
  var intersection_default = intersection;

  // node_modules/lodash-es/intersectionBy.js
  init_define_process();
  var intersectionBy = baseRest_default(function(arrays) {
    var iteratee2 = last_default(arrays), mapped = arrayMap_default(arrays, castArrayLikeObject_default);
    if (iteratee2 === last_default(mapped)) {
      iteratee2 = void 0;
    } else {
      mapped.pop();
    }
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection_default(mapped, baseIteratee_default(iteratee2, 2)) : [];
  });
  var intersectionBy_default = intersectionBy;

  // node_modules/lodash-es/intersectionWith.js
  init_define_process();
  var intersectionWith = baseRest_default(function(arrays) {
    var comparator = last_default(arrays), mapped = arrayMap_default(arrays, castArrayLikeObject_default);
    comparator = typeof comparator == "function" ? comparator : void 0;
    if (comparator) {
      mapped.pop();
    }
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection_default(mapped, void 0, comparator) : [];
  });
  var intersectionWith_default = intersectionWith;

  // node_modules/lodash-es/invert.js
  init_define_process();

  // node_modules/lodash-es/_createInverter.js
  init_define_process();

  // node_modules/lodash-es/_baseInverter.js
  init_define_process();
  function baseInverter(object, setter, iteratee2, accumulator) {
    baseForOwn_default(object, function(value, key, object2) {
      setter(accumulator, iteratee2(value), key, object2);
    });
    return accumulator;
  }
  var baseInverter_default = baseInverter;

  // node_modules/lodash-es/_createInverter.js
  function createInverter(setter, toIteratee) {
    return function(object, iteratee2) {
      return baseInverter_default(object, setter, toIteratee(iteratee2), {});
    };
  }
  var createInverter_default = createInverter;

  // node_modules/lodash-es/invert.js
  var objectProto24 = Object.prototype;
  var nativeObjectToString3 = objectProto24.toString;
  var invert = createInverter_default(function(result2, value, key) {
    if (value != null && typeof value.toString != "function") {
      value = nativeObjectToString3.call(value);
    }
    result2[value] = key;
  }, constant_default(identity_default));
  var invert_default = invert;

  // node_modules/lodash-es/invertBy.js
  init_define_process();
  var objectProto25 = Object.prototype;
  var hasOwnProperty21 = objectProto25.hasOwnProperty;
  var nativeObjectToString4 = objectProto25.toString;
  var invertBy = createInverter_default(function(result2, value, key) {
    if (value != null && typeof value.toString != "function") {
      value = nativeObjectToString4.call(value);
    }
    if (hasOwnProperty21.call(result2, value)) {
      result2[value].push(key);
    } else {
      result2[value] = [key];
    }
  }, baseIteratee_default);
  var invertBy_default = invertBy;

  // node_modules/lodash-es/invoke.js
  init_define_process();

  // node_modules/lodash-es/_baseInvoke.js
  init_define_process();

  // node_modules/lodash-es/_parent.js
  init_define_process();
  function parent(object, path) {
    return path.length < 2 ? object : baseGet_default(object, baseSlice_default(path, 0, -1));
  }
  var parent_default = parent;

  // node_modules/lodash-es/_baseInvoke.js
  function baseInvoke(object, path, args) {
    path = castPath_default(path, object);
    object = parent_default(object, path);
    var func = object == null ? object : object[toKey_default(last_default(path))];
    return func == null ? void 0 : apply_default(func, object, args);
  }
  var baseInvoke_default = baseInvoke;

  // node_modules/lodash-es/invoke.js
  var invoke = baseRest_default(baseInvoke_default);
  var invoke_default = invoke;

  // node_modules/lodash-es/invokeMap.js
  init_define_process();
  var invokeMap = baseRest_default(function(collection, path, args) {
    var index = -1, isFunc = typeof path == "function", result2 = isArrayLike_default(collection) ? Array(collection.length) : [];
    baseEach_default(collection, function(value) {
      result2[++index] = isFunc ? apply_default(path, value, args) : baseInvoke_default(value, path, args);
    });
    return result2;
  });
  var invokeMap_default = invokeMap;

  // node_modules/lodash-es/isArrayBuffer.js
  init_define_process();

  // node_modules/lodash-es/_baseIsArrayBuffer.js
  init_define_process();
  var arrayBufferTag5 = "[object ArrayBuffer]";
  function baseIsArrayBuffer(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == arrayBufferTag5;
  }
  var baseIsArrayBuffer_default = baseIsArrayBuffer;

  // node_modules/lodash-es/isArrayBuffer.js
  var nodeIsArrayBuffer = nodeUtil_default && nodeUtil_default.isArrayBuffer;
  var isArrayBuffer = nodeIsArrayBuffer ? baseUnary_default(nodeIsArrayBuffer) : baseIsArrayBuffer_default;
  var isArrayBuffer_default = isArrayBuffer;

  // node_modules/lodash-es/isBoolean.js
  init_define_process();
  var boolTag5 = "[object Boolean]";
  function isBoolean(value) {
    return value === true || value === false || isObjectLike_default(value) && baseGetTag_default(value) == boolTag5;
  }
  var isBoolean_default = isBoolean;

  // node_modules/lodash-es/isDate.js
  init_define_process();

  // node_modules/lodash-es/_baseIsDate.js
  init_define_process();
  var dateTag5 = "[object Date]";
  function baseIsDate(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == dateTag5;
  }
  var baseIsDate_default = baseIsDate;

  // node_modules/lodash-es/isDate.js
  var nodeIsDate = nodeUtil_default && nodeUtil_default.isDate;
  var isDate = nodeIsDate ? baseUnary_default(nodeIsDate) : baseIsDate_default;
  var isDate_default = isDate;

  // node_modules/lodash-es/isElement.js
  init_define_process();
  function isElement(value) {
    return isObjectLike_default(value) && value.nodeType === 1 && !isPlainObject_default(value);
  }
  var isElement_default = isElement;

  // node_modules/lodash-es/isEmpty.js
  init_define_process();
  var mapTag8 = "[object Map]";
  var setTag8 = "[object Set]";
  var objectProto26 = Object.prototype;
  var hasOwnProperty22 = objectProto26.hasOwnProperty;
  function isEmpty(value) {
    if (value == null) {
      return true;
    }
    if (isArrayLike_default(value) && (isArray_default(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer_default(value) || isTypedArray_default(value) || isArguments_default(value))) {
      return !value.length;
    }
    var tag = getTag_default(value);
    if (tag == mapTag8 || tag == setTag8) {
      return !value.size;
    }
    if (isPrototype_default(value)) {
      return !baseKeys_default(value).length;
    }
    for (var key in value) {
      if (hasOwnProperty22.call(value, key)) {
        return false;
      }
    }
    return true;
  }
  var isEmpty_default = isEmpty;

  // node_modules/lodash-es/isEqual.js
  init_define_process();
  function isEqual(value, other) {
    return baseIsEqual_default(value, other);
  }
  var isEqual_default = isEqual;

  // node_modules/lodash-es/isEqualWith.js
  init_define_process();
  function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    var result2 = customizer ? customizer(value, other) : void 0;
    return result2 === void 0 ? baseIsEqual_default(value, other, void 0, customizer) : !!result2;
  }
  var isEqualWith_default = isEqualWith;

  // node_modules/lodash-es/isFinite.js
  init_define_process();
  var nativeIsFinite2 = root_default.isFinite;
  function isFinite2(value) {
    return typeof value == "number" && nativeIsFinite2(value);
  }
  var isFinite_default = isFinite2;

  // node_modules/lodash-es/isInteger.js
  init_define_process();
  function isInteger(value) {
    return typeof value == "number" && value == toInteger_default(value);
  }
  var isInteger_default = isInteger;

  // node_modules/lodash-es/isMatch.js
  init_define_process();
  function isMatch(object, source) {
    return object === source || baseIsMatch_default(object, source, getMatchData_default(source));
  }
  var isMatch_default = isMatch;

  // node_modules/lodash-es/isMatchWith.js
  init_define_process();
  function isMatchWith(object, source, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    return baseIsMatch_default(object, source, getMatchData_default(source), customizer);
  }
  var isMatchWith_default = isMatchWith;

  // node_modules/lodash-es/isNaN.js
  init_define_process();

  // node_modules/lodash-es/isNumber.js
  init_define_process();
  var numberTag5 = "[object Number]";
  function isNumber(value) {
    return typeof value == "number" || isObjectLike_default(value) && baseGetTag_default(value) == numberTag5;
  }
  var isNumber_default = isNumber;

  // node_modules/lodash-es/isNaN.js
  function isNaN2(value) {
    return isNumber_default(value) && value != +value;
  }
  var isNaN_default = isNaN2;

  // node_modules/lodash-es/isNative.js
  init_define_process();

  // node_modules/lodash-es/_isMaskable.js
  init_define_process();
  var isMaskable = coreJsData_default ? isFunction_default : stubFalse_default;
  var isMaskable_default = isMaskable;

  // node_modules/lodash-es/isNative.js
  var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.";
  function isNative(value) {
    if (isMaskable_default(value)) {
      throw new Error(CORE_ERROR_TEXT);
    }
    return baseIsNative_default(value);
  }
  var isNative_default = isNative;

  // node_modules/lodash-es/isNil.js
  init_define_process();
  function isNil(value) {
    return value == null;
  }
  var isNil_default = isNil;

  // node_modules/lodash-es/isNull.js
  init_define_process();
  function isNull(value) {
    return value === null;
  }
  var isNull_default = isNull;

  // node_modules/lodash-es/isRegExp.js
  init_define_process();

  // node_modules/lodash-es/_baseIsRegExp.js
  init_define_process();
  var regexpTag5 = "[object RegExp]";
  function baseIsRegExp(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == regexpTag5;
  }
  var baseIsRegExp_default = baseIsRegExp;

  // node_modules/lodash-es/isRegExp.js
  var nodeIsRegExp = nodeUtil_default && nodeUtil_default.isRegExp;
  var isRegExp = nodeIsRegExp ? baseUnary_default(nodeIsRegExp) : baseIsRegExp_default;
  var isRegExp_default = isRegExp;

  // node_modules/lodash-es/isSafeInteger.js
  init_define_process();
  var MAX_SAFE_INTEGER3 = 9007199254740991;
  function isSafeInteger(value) {
    return isInteger_default(value) && value >= -MAX_SAFE_INTEGER3 && value <= MAX_SAFE_INTEGER3;
  }
  var isSafeInteger_default = isSafeInteger;

  // node_modules/lodash-es/isUndefined.js
  init_define_process();
  function isUndefined(value) {
    return value === void 0;
  }
  var isUndefined_default = isUndefined;

  // node_modules/lodash-es/isWeakMap.js
  init_define_process();
  var weakMapTag4 = "[object WeakMap]";
  function isWeakMap(value) {
    return isObjectLike_default(value) && getTag_default(value) == weakMapTag4;
  }
  var isWeakMap_default = isWeakMap;

  // node_modules/lodash-es/isWeakSet.js
  init_define_process();
  var weakSetTag = "[object WeakSet]";
  function isWeakSet(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == weakSetTag;
  }
  var isWeakSet_default = isWeakSet;

  // node_modules/lodash-es/iteratee.js
  init_define_process();
  var CLONE_DEEP_FLAG5 = 1;
  function iteratee(func) {
    return baseIteratee_default(typeof func == "function" ? func : baseClone_default(func, CLONE_DEEP_FLAG5));
  }
  var iteratee_default = iteratee;

  // node_modules/lodash-es/join.js
  init_define_process();
  var arrayProto2 = Array.prototype;
  var nativeJoin = arrayProto2.join;
  function join(array, separator) {
    return array == null ? "" : nativeJoin.call(array, separator);
  }
  var join_default = join;

  // node_modules/lodash-es/kebabCase.js
  init_define_process();
  var kebabCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? "-" : "") + word.toLowerCase();
  });
  var kebabCase_default = kebabCase;

  // node_modules/lodash-es/keyBy.js
  init_define_process();
  var keyBy = createAggregator_default(function(result2, value, key) {
    baseAssignValue_default(result2, key, value);
  });
  var keyBy_default = keyBy;

  // node_modules/lodash-es/lastIndexOf.js
  init_define_process();

  // node_modules/lodash-es/_strictLastIndexOf.js
  init_define_process();
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }
  var strictLastIndexOf_default = strictLastIndexOf;

  // node_modules/lodash-es/lastIndexOf.js
  var nativeMax12 = Math.max;
  var nativeMin8 = Math.min;
  function lastIndexOf(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = length;
    if (fromIndex !== void 0) {
      index = toInteger_default(fromIndex);
      index = index < 0 ? nativeMax12(length + index, 0) : nativeMin8(index, length - 1);
    }
    return value === value ? strictLastIndexOf_default(array, value, index) : baseFindIndex_default(array, baseIsNaN_default, index, true);
  }
  var lastIndexOf_default = lastIndexOf;

  // node_modules/lodash-es/lowerCase.js
  init_define_process();
  var lowerCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? " " : "") + word.toLowerCase();
  });
  var lowerCase_default = lowerCase;

  // node_modules/lodash-es/lowerFirst.js
  init_define_process();
  var lowerFirst = createCaseFirst_default("toLowerCase");
  var lowerFirst_default = lowerFirst;

  // node_modules/lodash-es/lt.js
  init_define_process();

  // node_modules/lodash-es/_baseLt.js
  init_define_process();
  function baseLt(value, other) {
    return value < other;
  }
  var baseLt_default = baseLt;

  // node_modules/lodash-es/lt.js
  var lt = createRelationalOperation_default(baseLt_default);
  var lt_default = lt;

  // node_modules/lodash-es/lte.js
  init_define_process();
  var lte = createRelationalOperation_default(function(value, other) {
    return value <= other;
  });
  var lte_default = lte;

  // node_modules/lodash-es/mapKeys.js
  init_define_process();
  function mapKeys(object, iteratee2) {
    var result2 = {};
    iteratee2 = baseIteratee_default(iteratee2, 3);
    baseForOwn_default(object, function(value, key, object2) {
      baseAssignValue_default(result2, iteratee2(value, key, object2), value);
    });
    return result2;
  }
  var mapKeys_default = mapKeys;

  // node_modules/lodash-es/mapValues.js
  init_define_process();
  function mapValues(object, iteratee2) {
    var result2 = {};
    iteratee2 = baseIteratee_default(iteratee2, 3);
    baseForOwn_default(object, function(value, key, object2) {
      baseAssignValue_default(result2, key, iteratee2(value, key, object2));
    });
    return result2;
  }
  var mapValues_default = mapValues;

  // node_modules/lodash-es/matches.js
  init_define_process();
  var CLONE_DEEP_FLAG6 = 1;
  function matches(source) {
    return baseMatches_default(baseClone_default(source, CLONE_DEEP_FLAG6));
  }
  var matches_default = matches;

  // node_modules/lodash-es/matchesProperty.js
  init_define_process();
  var CLONE_DEEP_FLAG7 = 1;
  function matchesProperty(path, srcValue) {
    return baseMatchesProperty_default(path, baseClone_default(srcValue, CLONE_DEEP_FLAG7));
  }
  var matchesProperty_default = matchesProperty;

  // node_modules/lodash-es/max.js
  init_define_process();

  // node_modules/lodash-es/_baseExtremum.js
  init_define_process();
  function baseExtremum(array, iteratee2, comparator) {
    var index = -1, length = array.length;
    while (++index < length) {
      var value = array[index], current = iteratee2(value);
      if (current != null && (computed === void 0 ? current === current && !isSymbol_default(current) : comparator(current, computed))) {
        var computed = current, result2 = value;
      }
    }
    return result2;
  }
  var baseExtremum_default = baseExtremum;

  // node_modules/lodash-es/max.js
  function max(array) {
    return array && array.length ? baseExtremum_default(array, identity_default, baseGt_default) : void 0;
  }
  var max_default = max;

  // node_modules/lodash-es/maxBy.js
  init_define_process();
  function maxBy(array, iteratee2) {
    return array && array.length ? baseExtremum_default(array, baseIteratee_default(iteratee2, 2), baseGt_default) : void 0;
  }
  var maxBy_default = maxBy;

  // node_modules/lodash-es/mean.js
  init_define_process();

  // node_modules/lodash-es/_baseMean.js
  init_define_process();

  // node_modules/lodash-es/_baseSum.js
  init_define_process();
  function baseSum(array, iteratee2) {
    var result2, index = -1, length = array.length;
    while (++index < length) {
      var current = iteratee2(array[index]);
      if (current !== void 0) {
        result2 = result2 === void 0 ? current : result2 + current;
      }
    }
    return result2;
  }
  var baseSum_default = baseSum;

  // node_modules/lodash-es/_baseMean.js
  var NAN3 = 0 / 0;
  function baseMean(array, iteratee2) {
    var length = array == null ? 0 : array.length;
    return length ? baseSum_default(array, iteratee2) / length : NAN3;
  }
  var baseMean_default = baseMean;

  // node_modules/lodash-es/mean.js
  function mean(array) {
    return baseMean_default(array, identity_default);
  }
  var mean_default = mean;

  // node_modules/lodash-es/meanBy.js
  init_define_process();
  function meanBy(array, iteratee2) {
    return baseMean_default(array, baseIteratee_default(iteratee2, 2));
  }
  var meanBy_default = meanBy;

  // node_modules/lodash-es/merge.js
  init_define_process();
  var merge = createAssigner_default(function(object, source, srcIndex) {
    baseMerge_default(object, source, srcIndex);
  });
  var merge_default = merge;

  // node_modules/lodash-es/method.js
  init_define_process();
  var method = baseRest_default(function(path, args) {
    return function(object) {
      return baseInvoke_default(object, path, args);
    };
  });
  var method_default = method;

  // node_modules/lodash-es/methodOf.js
  init_define_process();
  var methodOf = baseRest_default(function(object, args) {
    return function(path) {
      return baseInvoke_default(object, path, args);
    };
  });
  var methodOf_default = methodOf;

  // node_modules/lodash-es/min.js
  init_define_process();
  function min(array) {
    return array && array.length ? baseExtremum_default(array, identity_default, baseLt_default) : void 0;
  }
  var min_default = min;

  // node_modules/lodash-es/minBy.js
  init_define_process();
  function minBy(array, iteratee2) {
    return array && array.length ? baseExtremum_default(array, baseIteratee_default(iteratee2, 2), baseLt_default) : void 0;
  }
  var minBy_default = minBy;

  // node_modules/lodash-es/mixin.js
  init_define_process();
  function mixin(object, source, options) {
    var props = keys_default(source), methodNames = baseFunctions_default(source, props);
    var chain2 = !(isObject_default(options) && "chain" in options) || !!options.chain, isFunc = isFunction_default(object);
    arrayEach_default(methodNames, function(methodName) {
      var func = source[methodName];
      object[methodName] = func;
      if (isFunc) {
        object.prototype[methodName] = function() {
          var chainAll = this.__chain__;
          if (chain2 || chainAll) {
            var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray_default(this.__actions__);
            actions.push({ "func": func, "args": arguments, "thisArg": object });
            result2.__chain__ = chainAll;
            return result2;
          }
          return func.apply(object, arrayPush_default([this.value()], arguments));
        };
      }
    });
    return object;
  }
  var mixin_default = mixin;

  // node_modules/lodash-es/multiply.js
  init_define_process();
  var multiply = createMathOperation_default(function(multiplier, multiplicand) {
    return multiplier * multiplicand;
  }, 1);
  var multiply_default = multiply;

  // node_modules/lodash-es/negate.js
  init_define_process();
  var FUNC_ERROR_TEXT9 = "Expected a function";
  function negate(predicate) {
    if (typeof predicate != "function") {
      throw new TypeError(FUNC_ERROR_TEXT9);
    }
    return function() {
      var args = arguments;
      switch (args.length) {
        case 0:
          return !predicate.call(this);
        case 1:
          return !predicate.call(this, args[0]);
        case 2:
          return !predicate.call(this, args[0], args[1]);
        case 3:
          return !predicate.call(this, args[0], args[1], args[2]);
      }
      return !predicate.apply(this, args);
    };
  }
  var negate_default = negate;

  // node_modules/lodash-es/next.js
  init_define_process();

  // node_modules/lodash-es/toArray.js
  init_define_process();

  // node_modules/lodash-es/_iteratorToArray.js
  init_define_process();
  function iteratorToArray(iterator) {
    var data, result2 = [];
    while (!(data = iterator.next()).done) {
      result2.push(data.value);
    }
    return result2;
  }
  var iteratorToArray_default = iteratorToArray;

  // node_modules/lodash-es/toArray.js
  var mapTag9 = "[object Map]";
  var setTag9 = "[object Set]";
  var symIterator = Symbol_default ? Symbol_default.iterator : void 0;
  function toArray(value) {
    if (!value) {
      return [];
    }
    if (isArrayLike_default(value)) {
      return isString_default(value) ? stringToArray_default(value) : copyArray_default(value);
    }
    if (symIterator && value[symIterator]) {
      return iteratorToArray_default(value[symIterator]());
    }
    var tag = getTag_default(value), func = tag == mapTag9 ? mapToArray_default : tag == setTag9 ? setToArray_default : values_default;
    return func(value);
  }
  var toArray_default = toArray;

  // node_modules/lodash-es/next.js
  function wrapperNext() {
    if (this.__values__ === void 0) {
      this.__values__ = toArray_default(this.value());
    }
    var done = this.__index__ >= this.__values__.length, value = done ? void 0 : this.__values__[this.__index__++];
    return { "done": done, "value": value };
  }
  var next_default = wrapperNext;

  // node_modules/lodash-es/nth.js
  init_define_process();

  // node_modules/lodash-es/_baseNth.js
  init_define_process();
  function baseNth(array, n) {
    var length = array.length;
    if (!length) {
      return;
    }
    n += n < 0 ? length : 0;
    return isIndex_default(n, length) ? array[n] : void 0;
  }
  var baseNth_default = baseNth;

  // node_modules/lodash-es/nth.js
  function nth(array, n) {
    return array && array.length ? baseNth_default(array, toInteger_default(n)) : void 0;
  }
  var nth_default = nth;

  // node_modules/lodash-es/nthArg.js
  init_define_process();
  function nthArg(n) {
    n = toInteger_default(n);
    return baseRest_default(function(args) {
      return baseNth_default(args, n);
    });
  }
  var nthArg_default = nthArg;

  // node_modules/lodash-es/omit.js
  init_define_process();

  // node_modules/lodash-es/_baseUnset.js
  init_define_process();
  function baseUnset(object, path) {
    path = castPath_default(path, object);
    object = parent_default(object, path);
    return object == null || delete object[toKey_default(last_default(path))];
  }
  var baseUnset_default = baseUnset;

  // node_modules/lodash-es/_customOmitClone.js
  init_define_process();
  function customOmitClone(value) {
    return isPlainObject_default(value) ? void 0 : value;
  }
  var customOmitClone_default = customOmitClone;

  // node_modules/lodash-es/omit.js
  var CLONE_DEEP_FLAG8 = 1;
  var CLONE_FLAT_FLAG2 = 2;
  var CLONE_SYMBOLS_FLAG6 = 4;
  var omit = flatRest_default(function(object, paths) {
    var result2 = {};
    if (object == null) {
      return result2;
    }
    var isDeep = false;
    paths = arrayMap_default(paths, function(path) {
      path = castPath_default(path, object);
      isDeep || (isDeep = path.length > 1);
      return path;
    });
    copyObject_default(object, getAllKeysIn_default(object), result2);
    if (isDeep) {
      result2 = baseClone_default(result2, CLONE_DEEP_FLAG8 | CLONE_FLAT_FLAG2 | CLONE_SYMBOLS_FLAG6, customOmitClone_default);
    }
    var length = paths.length;
    while (length--) {
      baseUnset_default(result2, paths[length]);
    }
    return result2;
  });
  var omit_default = omit;

  // node_modules/lodash-es/omitBy.js
  init_define_process();

  // node_modules/lodash-es/pickBy.js
  init_define_process();

  // node_modules/lodash-es/_basePickBy.js
  init_define_process();

  // node_modules/lodash-es/_baseSet.js
  init_define_process();
  function baseSet(object, path, value, customizer) {
    if (!isObject_default(object)) {
      return object;
    }
    path = castPath_default(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while (nested != null && ++index < length) {
      var key = toKey_default(path[index]), newValue = value;
      if (key === "__proto__" || key === "constructor" || key === "prototype") {
        return object;
      }
      if (index != lastIndex) {
        var objValue = nested[key];
        newValue = customizer ? customizer(objValue, key, nested) : void 0;
        if (newValue === void 0) {
          newValue = isObject_default(objValue) ? objValue : isIndex_default(path[index + 1]) ? [] : {};
        }
      }
      assignValue_default(nested, key, newValue);
      nested = nested[key];
    }
    return object;
  }
  var baseSet_default = baseSet;

  // node_modules/lodash-es/_basePickBy.js
  function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result2 = {};
    while (++index < length) {
      var path = paths[index], value = baseGet_default(object, path);
      if (predicate(value, path)) {
        baseSet_default(result2, castPath_default(path, object), value);
      }
    }
    return result2;
  }
  var basePickBy_default = basePickBy;

  // node_modules/lodash-es/pickBy.js
  function pickBy(object, predicate) {
    if (object == null) {
      return {};
    }
    var props = arrayMap_default(getAllKeysIn_default(object), function(prop) {
      return [prop];
    });
    predicate = baseIteratee_default(predicate);
    return basePickBy_default(object, props, function(value, path) {
      return predicate(value, path[0]);
    });
  }
  var pickBy_default = pickBy;

  // node_modules/lodash-es/omitBy.js
  function omitBy(object, predicate) {
    return pickBy_default(object, negate_default(baseIteratee_default(predicate)));
  }
  var omitBy_default = omitBy;

  // node_modules/lodash-es/once.js
  init_define_process();
  function once(func) {
    return before_default(2, func);
  }
  var once_default = once;

  // node_modules/lodash-es/orderBy.js
  init_define_process();

  // node_modules/lodash-es/_baseOrderBy.js
  init_define_process();

  // node_modules/lodash-es/_baseSortBy.js
  init_define_process();
  function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }
  var baseSortBy_default = baseSortBy;

  // node_modules/lodash-es/_compareMultiple.js
  init_define_process();

  // node_modules/lodash-es/_compareAscending.js
  init_define_process();
  function compareAscending(value, other) {
    if (value !== other) {
      var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol_default(value);
      var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol_default(other);
      if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
        return 1;
      }
      if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
        return -1;
      }
    }
    return 0;
  }
  var compareAscending_default = compareAscending;

  // node_modules/lodash-es/_compareMultiple.js
  function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while (++index < length) {
      var result2 = compareAscending_default(objCriteria[index], othCriteria[index]);
      if (result2) {
        if (index >= ordersLength) {
          return result2;
        }
        var order = orders[index];
        return result2 * (order == "desc" ? -1 : 1);
      }
    }
    return object.index - other.index;
  }
  var compareMultiple_default = compareMultiple;

  // node_modules/lodash-es/_baseOrderBy.js
  function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) {
      iteratees = arrayMap_default(iteratees, function(iteratee2) {
        if (isArray_default(iteratee2)) {
          return function(value) {
            return baseGet_default(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
          };
        }
        return iteratee2;
      });
    } else {
      iteratees = [identity_default];
    }
    var index = -1;
    iteratees = arrayMap_default(iteratees, baseUnary_default(baseIteratee_default));
    var result2 = baseMap_default(collection, function(value, key, collection2) {
      var criteria = arrayMap_default(iteratees, function(iteratee2) {
        return iteratee2(value);
      });
      return { "criteria": criteria, "index": ++index, "value": value };
    });
    return baseSortBy_default(result2, function(object, other) {
      return compareMultiple_default(object, other, orders);
    });
  }
  var baseOrderBy_default = baseOrderBy;

  // node_modules/lodash-es/orderBy.js
  function orderBy(collection, iteratees, orders, guard) {
    if (collection == null) {
      return [];
    }
    if (!isArray_default(iteratees)) {
      iteratees = iteratees == null ? [] : [iteratees];
    }
    orders = guard ? void 0 : orders;
    if (!isArray_default(orders)) {
      orders = orders == null ? [] : [orders];
    }
    return baseOrderBy_default(collection, iteratees, orders);
  }
  var orderBy_default = orderBy;

  // node_modules/lodash-es/over.js
  init_define_process();

  // node_modules/lodash-es/_createOver.js
  init_define_process();
  function createOver(arrayFunc) {
    return flatRest_default(function(iteratees) {
      iteratees = arrayMap_default(iteratees, baseUnary_default(baseIteratee_default));
      return baseRest_default(function(args) {
        var thisArg = this;
        return arrayFunc(iteratees, function(iteratee2) {
          return apply_default(iteratee2, thisArg, args);
        });
      });
    });
  }
  var createOver_default = createOver;

  // node_modules/lodash-es/over.js
  var over = createOver_default(arrayMap_default);
  var over_default = over;

  // node_modules/lodash-es/overArgs.js
  init_define_process();

  // node_modules/lodash-es/_castRest.js
  init_define_process();
  var castRest = baseRest_default;
  var castRest_default = castRest;

  // node_modules/lodash-es/overArgs.js
  var nativeMin9 = Math.min;
  var overArgs = castRest_default(function(func, transforms) {
    transforms = transforms.length == 1 && isArray_default(transforms[0]) ? arrayMap_default(transforms[0], baseUnary_default(baseIteratee_default)) : arrayMap_default(baseFlatten_default(transforms, 1), baseUnary_default(baseIteratee_default));
    var funcsLength = transforms.length;
    return baseRest_default(function(args) {
      var index = -1, length = nativeMin9(args.length, funcsLength);
      while (++index < length) {
        args[index] = transforms[index].call(this, args[index]);
      }
      return apply_default(func, this, args);
    });
  });
  var overArgs_default = overArgs;

  // node_modules/lodash-es/overEvery.js
  init_define_process();
  var overEvery = createOver_default(arrayEvery_default);
  var overEvery_default = overEvery;

  // node_modules/lodash-es/overSome.js
  init_define_process();
  var overSome = createOver_default(arraySome_default);
  var overSome_default = overSome;

  // node_modules/lodash-es/pad.js
  init_define_process();

  // node_modules/lodash-es/_createPadding.js
  init_define_process();

  // node_modules/lodash-es/_baseRepeat.js
  init_define_process();
  var MAX_SAFE_INTEGER4 = 9007199254740991;
  var nativeFloor = Math.floor;
  function baseRepeat(string, n) {
    var result2 = "";
    if (!string || n < 1 || n > MAX_SAFE_INTEGER4) {
      return result2;
    }
    do {
      if (n % 2) {
        result2 += string;
      }
      n = nativeFloor(n / 2);
      if (n) {
        string += string;
      }
    } while (n);
    return result2;
  }
  var baseRepeat_default = baseRepeat;

  // node_modules/lodash-es/_stringSize.js
  init_define_process();

  // node_modules/lodash-es/_asciiSize.js
  init_define_process();
  var asciiSize = baseProperty_default("length");
  var asciiSize_default = asciiSize;

  // node_modules/lodash-es/_unicodeSize.js
  init_define_process();
  var rsAstralRange4 = "\\ud800-\\udfff";
  var rsComboMarksRange5 = "\\u0300-\\u036f";
  var reComboHalfMarksRange5 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange5 = "\\u20d0-\\u20ff";
  var rsComboRange5 = rsComboMarksRange5 + reComboHalfMarksRange5 + rsComboSymbolsRange5;
  var rsVarRange4 = "\\ufe0e\\ufe0f";
  var rsAstral2 = "[" + rsAstralRange4 + "]";
  var rsCombo4 = "[" + rsComboRange5 + "]";
  var rsFitz3 = "\\ud83c[\\udffb-\\udfff]";
  var rsModifier3 = "(?:" + rsCombo4 + "|" + rsFitz3 + ")";
  var rsNonAstral3 = "[^" + rsAstralRange4 + "]";
  var rsRegional3 = "(?:\\ud83c[\\udde6-\\uddff]){2}";
  var rsSurrPair3 = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var rsZWJ4 = "\\u200d";
  var reOptMod3 = rsModifier3 + "?";
  var rsOptVar3 = "[" + rsVarRange4 + "]?";
  var rsOptJoin3 = "(?:" + rsZWJ4 + "(?:" + [rsNonAstral3, rsRegional3, rsSurrPair3].join("|") + ")" + rsOptVar3 + reOptMod3 + ")*";
  var rsSeq3 = rsOptVar3 + reOptMod3 + rsOptJoin3;
  var rsSymbol2 = "(?:" + [rsNonAstral3 + rsCombo4 + "?", rsCombo4, rsRegional3, rsSurrPair3, rsAstral2].join("|") + ")";
  var reUnicode2 = RegExp(rsFitz3 + "(?=" + rsFitz3 + ")|" + rsSymbol2 + rsSeq3, "g");
  function unicodeSize(string) {
    var result2 = reUnicode2.lastIndex = 0;
    while (reUnicode2.test(string)) {
      ++result2;
    }
    return result2;
  }
  var unicodeSize_default = unicodeSize;

  // node_modules/lodash-es/_stringSize.js
  function stringSize(string) {
    return hasUnicode_default(string) ? unicodeSize_default(string) : asciiSize_default(string);
  }
  var stringSize_default = stringSize;

  // node_modules/lodash-es/_createPadding.js
  var nativeCeil2 = Math.ceil;
  function createPadding(length, chars) {
    chars = chars === void 0 ? " " : baseToString_default(chars);
    var charsLength = chars.length;
    if (charsLength < 2) {
      return charsLength ? baseRepeat_default(chars, length) : chars;
    }
    var result2 = baseRepeat_default(chars, nativeCeil2(length / stringSize_default(chars)));
    return hasUnicode_default(chars) ? castSlice_default(stringToArray_default(result2), 0, length).join("") : result2.slice(0, length);
  }
  var createPadding_default = createPadding;

  // node_modules/lodash-es/pad.js
  var nativeCeil3 = Math.ceil;
  var nativeFloor2 = Math.floor;
  function pad(string, length, chars) {
    string = toString_default(string);
    length = toInteger_default(length);
    var strLength = length ? stringSize_default(string) : 0;
    if (!length || strLength >= length) {
      return string;
    }
    var mid = (length - strLength) / 2;
    return createPadding_default(nativeFloor2(mid), chars) + string + createPadding_default(nativeCeil3(mid), chars);
  }
  var pad_default = pad;

  // node_modules/lodash-es/padEnd.js
  init_define_process();
  function padEnd(string, length, chars) {
    string = toString_default(string);
    length = toInteger_default(length);
    var strLength = length ? stringSize_default(string) : 0;
    return length && strLength < length ? string + createPadding_default(length - strLength, chars) : string;
  }
  var padEnd_default = padEnd;

  // node_modules/lodash-es/padStart.js
  init_define_process();
  function padStart(string, length, chars) {
    string = toString_default(string);
    length = toInteger_default(length);
    var strLength = length ? stringSize_default(string) : 0;
    return length && strLength < length ? createPadding_default(length - strLength, chars) + string : string;
  }
  var padStart_default = padStart;

  // node_modules/lodash-es/parseInt.js
  init_define_process();
  var reTrimStart2 = /^\s+/;
  var nativeParseInt = root_default.parseInt;
  function parseInt2(string, radix, guard) {
    if (guard || radix == null) {
      radix = 0;
    } else if (radix) {
      radix = +radix;
    }
    return nativeParseInt(toString_default(string).replace(reTrimStart2, ""), radix || 0);
  }
  var parseInt_default = parseInt2;

  // node_modules/lodash-es/partial.js
  init_define_process();
  var WRAP_PARTIAL_FLAG7 = 32;
  var partial = baseRest_default(function(func, partials) {
    var holders = replaceHolders_default(partials, getHolder_default(partial));
    return createWrap_default(func, WRAP_PARTIAL_FLAG7, void 0, partials, holders);
  });
  partial.placeholder = {};
  var partial_default = partial;

  // node_modules/lodash-es/partialRight.js
  init_define_process();
  var WRAP_PARTIAL_RIGHT_FLAG4 = 64;
  var partialRight = baseRest_default(function(func, partials) {
    var holders = replaceHolders_default(partials, getHolder_default(partialRight));
    return createWrap_default(func, WRAP_PARTIAL_RIGHT_FLAG4, void 0, partials, holders);
  });
  partialRight.placeholder = {};
  var partialRight_default = partialRight;

  // node_modules/lodash-es/partition.js
  init_define_process();
  var partition = createAggregator_default(function(result2, value, key) {
    result2[key ? 0 : 1].push(value);
  }, function() {
    return [[], []];
  });
  var partition_default = partition;

  // node_modules/lodash-es/pick.js
  init_define_process();

  // node_modules/lodash-es/_basePick.js
  init_define_process();
  function basePick(object, paths) {
    return basePickBy_default(object, paths, function(value, path) {
      return hasIn_default(object, path);
    });
  }
  var basePick_default = basePick;

  // node_modules/lodash-es/pick.js
  var pick = flatRest_default(function(object, paths) {
    return object == null ? {} : basePick_default(object, paths);
  });
  var pick_default = pick;

  // node_modules/lodash-es/plant.js
  init_define_process();
  function wrapperPlant(value) {
    var result2, parent2 = this;
    while (parent2 instanceof baseLodash_default) {
      var clone2 = wrapperClone_default(parent2);
      clone2.__index__ = 0;
      clone2.__values__ = void 0;
      if (result2) {
        previous.__wrapped__ = clone2;
      } else {
        result2 = clone2;
      }
      var previous = clone2;
      parent2 = parent2.__wrapped__;
    }
    previous.__wrapped__ = value;
    return result2;
  }
  var plant_default = wrapperPlant;

  // node_modules/lodash-es/propertyOf.js
  init_define_process();
  function propertyOf(object) {
    return function(path) {
      return object == null ? void 0 : baseGet_default(object, path);
    };
  }
  var propertyOf_default = propertyOf;

  // node_modules/lodash-es/pull.js
  init_define_process();

  // node_modules/lodash-es/pullAll.js
  init_define_process();

  // node_modules/lodash-es/_basePullAll.js
  init_define_process();

  // node_modules/lodash-es/_baseIndexOfWith.js
  init_define_process();
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }
  var baseIndexOfWith_default = baseIndexOfWith;

  // node_modules/lodash-es/_basePullAll.js
  var arrayProto3 = Array.prototype;
  var splice2 = arrayProto3.splice;
  function basePullAll(array, values2, iteratee2, comparator) {
    var indexOf2 = comparator ? baseIndexOfWith_default : baseIndexOf_default, index = -1, length = values2.length, seen = array;
    if (array === values2) {
      values2 = copyArray_default(values2);
    }
    if (iteratee2) {
      seen = arrayMap_default(array, baseUnary_default(iteratee2));
    }
    while (++index < length) {
      var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
      while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
        if (seen !== array) {
          splice2.call(seen, fromIndex, 1);
        }
        splice2.call(array, fromIndex, 1);
      }
    }
    return array;
  }
  var basePullAll_default = basePullAll;

  // node_modules/lodash-es/pullAll.js
  function pullAll(array, values2) {
    return array && array.length && values2 && values2.length ? basePullAll_default(array, values2) : array;
  }
  var pullAll_default = pullAll;

  // node_modules/lodash-es/pull.js
  var pull = baseRest_default(pullAll_default);
  var pull_default = pull;

  // node_modules/lodash-es/pullAllBy.js
  init_define_process();
  function pullAllBy(array, values2, iteratee2) {
    return array && array.length && values2 && values2.length ? basePullAll_default(array, values2, baseIteratee_default(iteratee2, 2)) : array;
  }
  var pullAllBy_default = pullAllBy;

  // node_modules/lodash-es/pullAllWith.js
  init_define_process();
  function pullAllWith(array, values2, comparator) {
    return array && array.length && values2 && values2.length ? basePullAll_default(array, values2, void 0, comparator) : array;
  }
  var pullAllWith_default = pullAllWith;

  // node_modules/lodash-es/pullAt.js
  init_define_process();

  // node_modules/lodash-es/_basePullAt.js
  init_define_process();
  var arrayProto4 = Array.prototype;
  var splice3 = arrayProto4.splice;
  function basePullAt(array, indexes) {
    var length = array ? indexes.length : 0, lastIndex = length - 1;
    while (length--) {
      var index = indexes[length];
      if (length == lastIndex || index !== previous) {
        var previous = index;
        if (isIndex_default(index)) {
          splice3.call(array, index, 1);
        } else {
          baseUnset_default(array, index);
        }
      }
    }
    return array;
  }
  var basePullAt_default = basePullAt;

  // node_modules/lodash-es/pullAt.js
  var pullAt = flatRest_default(function(array, indexes) {
    var length = array == null ? 0 : array.length, result2 = baseAt_default(array, indexes);
    basePullAt_default(array, arrayMap_default(indexes, function(index) {
      return isIndex_default(index, length) ? +index : index;
    }).sort(compareAscending_default));
    return result2;
  });
  var pullAt_default = pullAt;

  // node_modules/lodash-es/random.js
  init_define_process();

  // node_modules/lodash-es/_baseRandom.js
  init_define_process();
  var nativeFloor3 = Math.floor;
  var nativeRandom = Math.random;
  function baseRandom(lower, upper) {
    return lower + nativeFloor3(nativeRandom() * (upper - lower + 1));
  }
  var baseRandom_default = baseRandom;

  // node_modules/lodash-es/random.js
  var freeParseFloat = parseFloat;
  var nativeMin10 = Math.min;
  var nativeRandom2 = Math.random;
  function random(lower, upper, floating) {
    if (floating && typeof floating != "boolean" && isIterateeCall_default(lower, upper, floating)) {
      upper = floating = void 0;
    }
    if (floating === void 0) {
      if (typeof upper == "boolean") {
        floating = upper;
        upper = void 0;
      } else if (typeof lower == "boolean") {
        floating = lower;
        lower = void 0;
      }
    }
    if (lower === void 0 && upper === void 0) {
      lower = 0;
      upper = 1;
    } else {
      lower = toFinite_default(lower);
      if (upper === void 0) {
        upper = lower;
        lower = 0;
      } else {
        upper = toFinite_default(upper);
      }
    }
    if (lower > upper) {
      var temp = lower;
      lower = upper;
      upper = temp;
    }
    if (floating || lower % 1 || upper % 1) {
      var rand = nativeRandom2();
      return nativeMin10(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
    }
    return baseRandom_default(lower, upper);
  }
  var random_default = random;

  // node_modules/lodash-es/range.js
  init_define_process();

  // node_modules/lodash-es/_createRange.js
  init_define_process();

  // node_modules/lodash-es/_baseRange.js
  init_define_process();
  var nativeCeil4 = Math.ceil;
  var nativeMax13 = Math.max;
  function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax13(nativeCeil4((end - start) / (step || 1)), 0), result2 = Array(length);
    while (length--) {
      result2[fromRight ? length : ++index] = start;
      start += step;
    }
    return result2;
  }
  var baseRange_default = baseRange;

  // node_modules/lodash-es/_createRange.js
  function createRange(fromRight) {
    return function(start, end, step) {
      if (step && typeof step != "number" && isIterateeCall_default(start, end, step)) {
        end = step = void 0;
      }
      start = toFinite_default(start);
      if (end === void 0) {
        end = start;
        start = 0;
      } else {
        end = toFinite_default(end);
      }
      step = step === void 0 ? start < end ? 1 : -1 : toFinite_default(step);
      return baseRange_default(start, end, step, fromRight);
    };
  }
  var createRange_default = createRange;

  // node_modules/lodash-es/range.js
  var range = createRange_default();
  var range_default = range;

  // node_modules/lodash-es/rangeRight.js
  init_define_process();
  var rangeRight = createRange_default(true);
  var rangeRight_default = rangeRight;

  // node_modules/lodash-es/rearg.js
  init_define_process();
  var WRAP_REARG_FLAG4 = 256;
  var rearg = flatRest_default(function(func, indexes) {
    return createWrap_default(func, WRAP_REARG_FLAG4, void 0, void 0, void 0, indexes);
  });
  var rearg_default = rearg;

  // node_modules/lodash-es/reduce.js
  init_define_process();

  // node_modules/lodash-es/_baseReduce.js
  init_define_process();
  function baseReduce(collection, iteratee2, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection2) {
      accumulator = initAccum ? (initAccum = false, value) : iteratee2(accumulator, value, index, collection2);
    });
    return accumulator;
  }
  var baseReduce_default = baseReduce;

  // node_modules/lodash-es/reduce.js
  function reduce(collection, iteratee2, accumulator) {
    var func = isArray_default(collection) ? arrayReduce_default : baseReduce_default, initAccum = arguments.length < 3;
    return func(collection, baseIteratee_default(iteratee2, 4), accumulator, initAccum, baseEach_default);
  }
  var reduce_default = reduce;

  // node_modules/lodash-es/reduceRight.js
  init_define_process();

  // node_modules/lodash-es/_arrayReduceRight.js
  init_define_process();
  function arrayReduceRight(array, iteratee2, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee2(accumulator, array[length], length, array);
    }
    return accumulator;
  }
  var arrayReduceRight_default = arrayReduceRight;

  // node_modules/lodash-es/reduceRight.js
  function reduceRight(collection, iteratee2, accumulator) {
    var func = isArray_default(collection) ? arrayReduceRight_default : baseReduce_default, initAccum = arguments.length < 3;
    return func(collection, baseIteratee_default(iteratee2, 4), accumulator, initAccum, baseEachRight_default);
  }
  var reduceRight_default = reduceRight;

  // node_modules/lodash-es/reject.js
  init_define_process();
  function reject(collection, predicate) {
    var func = isArray_default(collection) ? arrayFilter_default : baseFilter_default;
    return func(collection, negate_default(baseIteratee_default(predicate, 3)));
  }
  var reject_default = reject;

  // node_modules/lodash-es/remove.js
  init_define_process();
  function remove(array, predicate) {
    var result2 = [];
    if (!(array && array.length)) {
      return result2;
    }
    var index = -1, indexes = [], length = array.length;
    predicate = baseIteratee_default(predicate, 3);
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result2.push(value);
        indexes.push(index);
      }
    }
    basePullAt_default(array, indexes);
    return result2;
  }
  var remove_default = remove;

  // node_modules/lodash-es/repeat.js
  init_define_process();
  function repeat(string, n, guard) {
    if (guard ? isIterateeCall_default(string, n, guard) : n === void 0) {
      n = 1;
    } else {
      n = toInteger_default(n);
    }
    return baseRepeat_default(toString_default(string), n);
  }
  var repeat_default = repeat;

  // node_modules/lodash-es/replace.js
  init_define_process();
  function replace() {
    var args = arguments, string = toString_default(args[0]);
    return args.length < 3 ? string : string.replace(args[1], args[2]);
  }
  var replace_default = replace;

  // node_modules/lodash-es/rest.js
  init_define_process();
  var FUNC_ERROR_TEXT10 = "Expected a function";
  function rest(func, start) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT10);
    }
    start = start === void 0 ? start : toInteger_default(start);
    return baseRest_default(func, start);
  }
  var rest_default = rest;

  // node_modules/lodash-es/result.js
  init_define_process();
  function result(object, path, defaultValue) {
    path = castPath_default(path, object);
    var index = -1, length = path.length;
    if (!length) {
      length = 1;
      object = void 0;
    }
    while (++index < length) {
      var value = object == null ? void 0 : object[toKey_default(path[index])];
      if (value === void 0) {
        index = length;
        value = defaultValue;
      }
      object = isFunction_default(value) ? value.call(object) : value;
    }
    return object;
  }
  var result_default = result;

  // node_modules/lodash-es/reverse.js
  init_define_process();
  var arrayProto5 = Array.prototype;
  var nativeReverse = arrayProto5.reverse;
  function reverse(array) {
    return array == null ? array : nativeReverse.call(array);
  }
  var reverse_default = reverse;

  // node_modules/lodash-es/round.js
  init_define_process();
  var round = createRound_default("round");
  var round_default = round;

  // node_modules/lodash-es/sample.js
  init_define_process();

  // node_modules/lodash-es/_arraySample.js
  init_define_process();
  function arraySample(array) {
    var length = array.length;
    return length ? array[baseRandom_default(0, length - 1)] : void 0;
  }
  var arraySample_default = arraySample;

  // node_modules/lodash-es/_baseSample.js
  init_define_process();
  function baseSample(collection) {
    return arraySample_default(values_default(collection));
  }
  var baseSample_default = baseSample;

  // node_modules/lodash-es/sample.js
  function sample(collection) {
    var func = isArray_default(collection) ? arraySample_default : baseSample_default;
    return func(collection);
  }
  var sample_default = sample;

  // node_modules/lodash-es/sampleSize.js
  init_define_process();

  // node_modules/lodash-es/_arraySampleSize.js
  init_define_process();

  // node_modules/lodash-es/_shuffleSelf.js
  init_define_process();
  function shuffleSelf(array, size2) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size2 = size2 === void 0 ? length : size2;
    while (++index < size2) {
      var rand = baseRandom_default(index, lastIndex), value = array[rand];
      array[rand] = array[index];
      array[index] = value;
    }
    array.length = size2;
    return array;
  }
  var shuffleSelf_default = shuffleSelf;

  // node_modules/lodash-es/_arraySampleSize.js
  function arraySampleSize(array, n) {
    return shuffleSelf_default(copyArray_default(array), baseClamp_default(n, 0, array.length));
  }
  var arraySampleSize_default = arraySampleSize;

  // node_modules/lodash-es/_baseSampleSize.js
  init_define_process();
  function baseSampleSize(collection, n) {
    var array = values_default(collection);
    return shuffleSelf_default(array, baseClamp_default(n, 0, array.length));
  }
  var baseSampleSize_default = baseSampleSize;

  // node_modules/lodash-es/sampleSize.js
  function sampleSize(collection, n, guard) {
    if (guard ? isIterateeCall_default(collection, n, guard) : n === void 0) {
      n = 1;
    } else {
      n = toInteger_default(n);
    }
    var func = isArray_default(collection) ? arraySampleSize_default : baseSampleSize_default;
    return func(collection, n);
  }
  var sampleSize_default = sampleSize;

  // node_modules/lodash-es/set.js
  init_define_process();
  function set(object, path, value) {
    return object == null ? object : baseSet_default(object, path, value);
  }
  var set_default = set;

  // node_modules/lodash-es/setWith.js
  init_define_process();
  function setWith(object, path, value, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    return object == null ? object : baseSet_default(object, path, value, customizer);
  }
  var setWith_default = setWith;

  // node_modules/lodash-es/shuffle.js
  init_define_process();

  // node_modules/lodash-es/_arrayShuffle.js
  init_define_process();
  function arrayShuffle(array) {
    return shuffleSelf_default(copyArray_default(array));
  }
  var arrayShuffle_default = arrayShuffle;

  // node_modules/lodash-es/_baseShuffle.js
  init_define_process();
  function baseShuffle(collection) {
    return shuffleSelf_default(values_default(collection));
  }
  var baseShuffle_default = baseShuffle;

  // node_modules/lodash-es/shuffle.js
  function shuffle(collection) {
    var func = isArray_default(collection) ? arrayShuffle_default : baseShuffle_default;
    return func(collection);
  }
  var shuffle_default = shuffle;

  // node_modules/lodash-es/size.js
  init_define_process();
  var mapTag10 = "[object Map]";
  var setTag10 = "[object Set]";
  function size(collection) {
    if (collection == null) {
      return 0;
    }
    if (isArrayLike_default(collection)) {
      return isString_default(collection) ? stringSize_default(collection) : collection.length;
    }
    var tag = getTag_default(collection);
    if (tag == mapTag10 || tag == setTag10) {
      return collection.size;
    }
    return baseKeys_default(collection).length;
  }
  var size_default = size;

  // node_modules/lodash-es/slice.js
  init_define_process();
  function slice(array, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    if (end && typeof end != "number" && isIterateeCall_default(array, start, end)) {
      start = 0;
      end = length;
    } else {
      start = start == null ? 0 : toInteger_default(start);
      end = end === void 0 ? length : toInteger_default(end);
    }
    return baseSlice_default(array, start, end);
  }
  var slice_default = slice;

  // node_modules/lodash-es/snakeCase.js
  init_define_process();
  var snakeCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? "_" : "") + word.toLowerCase();
  });
  var snakeCase_default = snakeCase;

  // node_modules/lodash-es/some.js
  init_define_process();

  // node_modules/lodash-es/_baseSome.js
  init_define_process();
  function baseSome(collection, predicate) {
    var result2;
    baseEach_default(collection, function(value, index, collection2) {
      result2 = predicate(value, index, collection2);
      return !result2;
    });
    return !!result2;
  }
  var baseSome_default = baseSome;

  // node_modules/lodash-es/some.js
  function some(collection, predicate, guard) {
    var func = isArray_default(collection) ? arraySome_default : baseSome_default;
    if (guard && isIterateeCall_default(collection, predicate, guard)) {
      predicate = void 0;
    }
    return func(collection, baseIteratee_default(predicate, 3));
  }
  var some_default = some;

  // node_modules/lodash-es/sortBy.js
  init_define_process();
  var sortBy = baseRest_default(function(collection, iteratees) {
    if (collection == null) {
      return [];
    }
    var length = iteratees.length;
    if (length > 1 && isIterateeCall_default(collection, iteratees[0], iteratees[1])) {
      iteratees = [];
    } else if (length > 2 && isIterateeCall_default(iteratees[0], iteratees[1], iteratees[2])) {
      iteratees = [iteratees[0]];
    }
    return baseOrderBy_default(collection, baseFlatten_default(iteratees, 1), []);
  });
  var sortBy_default = sortBy;

  // node_modules/lodash-es/sortedIndex.js
  init_define_process();

  // node_modules/lodash-es/_baseSortedIndex.js
  init_define_process();

  // node_modules/lodash-es/_baseSortedIndexBy.js
  init_define_process();
  var MAX_ARRAY_LENGTH3 = 4294967295;
  var MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH3 - 1;
  var nativeFloor4 = Math.floor;
  var nativeMin11 = Math.min;
  function baseSortedIndexBy(array, value, iteratee2, retHighest) {
    var low = 0, high = array == null ? 0 : array.length;
    if (high === 0) {
      return 0;
    }
    value = iteratee2(value);
    var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol_default(value), valIsUndefined = value === void 0;
    while (low < high) {
      var mid = nativeFloor4((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== void 0, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol_default(computed);
      if (valIsNaN) {
        var setLow = retHighest || othIsReflexive;
      } else if (valIsUndefined) {
        setLow = othIsReflexive && (retHighest || othIsDefined);
      } else if (valIsNull) {
        setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
      } else if (valIsSymbol) {
        setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
      } else if (othIsNull || othIsSymbol) {
        setLow = false;
      } else {
        setLow = retHighest ? computed <= value : computed < value;
      }
      if (setLow) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }
    return nativeMin11(high, MAX_ARRAY_INDEX);
  }
  var baseSortedIndexBy_default = baseSortedIndexBy;

  // node_modules/lodash-es/_baseSortedIndex.js
  var MAX_ARRAY_LENGTH4 = 4294967295;
  var HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH4 >>> 1;
  function baseSortedIndex(array, value, retHighest) {
    var low = 0, high = array == null ? low : array.length;
    if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
      while (low < high) {
        var mid = low + high >>> 1, computed = array[mid];
        if (computed !== null && !isSymbol_default(computed) && (retHighest ? computed <= value : computed < value)) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return high;
    }
    return baseSortedIndexBy_default(array, value, identity_default, retHighest);
  }
  var baseSortedIndex_default = baseSortedIndex;

  // node_modules/lodash-es/sortedIndex.js
  function sortedIndex(array, value) {
    return baseSortedIndex_default(array, value);
  }
  var sortedIndex_default = sortedIndex;

  // node_modules/lodash-es/sortedIndexBy.js
  init_define_process();
  function sortedIndexBy(array, value, iteratee2) {
    return baseSortedIndexBy_default(array, value, baseIteratee_default(iteratee2, 2));
  }
  var sortedIndexBy_default = sortedIndexBy;

  // node_modules/lodash-es/sortedIndexOf.js
  init_define_process();
  function sortedIndexOf(array, value) {
    var length = array == null ? 0 : array.length;
    if (length) {
      var index = baseSortedIndex_default(array, value);
      if (index < length && eq_default(array[index], value)) {
        return index;
      }
    }
    return -1;
  }
  var sortedIndexOf_default = sortedIndexOf;

  // node_modules/lodash-es/sortedLastIndex.js
  init_define_process();
  function sortedLastIndex(array, value) {
    return baseSortedIndex_default(array, value, true);
  }
  var sortedLastIndex_default = sortedLastIndex;

  // node_modules/lodash-es/sortedLastIndexBy.js
  init_define_process();
  function sortedLastIndexBy(array, value, iteratee2) {
    return baseSortedIndexBy_default(array, value, baseIteratee_default(iteratee2, 2), true);
  }
  var sortedLastIndexBy_default = sortedLastIndexBy;

  // node_modules/lodash-es/sortedLastIndexOf.js
  init_define_process();
  function sortedLastIndexOf(array, value) {
    var length = array == null ? 0 : array.length;
    if (length) {
      var index = baseSortedIndex_default(array, value, true) - 1;
      if (eq_default(array[index], value)) {
        return index;
      }
    }
    return -1;
  }
  var sortedLastIndexOf_default = sortedLastIndexOf;

  // node_modules/lodash-es/sortedUniq.js
  init_define_process();

  // node_modules/lodash-es/_baseSortedUniq.js
  init_define_process();
  function baseSortedUniq(array, iteratee2) {
    var index = -1, length = array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
      if (!index || !eq_default(computed, seen)) {
        var seen = computed;
        result2[resIndex++] = value === 0 ? 0 : value;
      }
    }
    return result2;
  }
  var baseSortedUniq_default = baseSortedUniq;

  // node_modules/lodash-es/sortedUniq.js
  function sortedUniq(array) {
    return array && array.length ? baseSortedUniq_default(array) : [];
  }
  var sortedUniq_default = sortedUniq;

  // node_modules/lodash-es/sortedUniqBy.js
  init_define_process();
  function sortedUniqBy(array, iteratee2) {
    return array && array.length ? baseSortedUniq_default(array, baseIteratee_default(iteratee2, 2)) : [];
  }
  var sortedUniqBy_default = sortedUniqBy;

  // node_modules/lodash-es/split.js
  init_define_process();
  var MAX_ARRAY_LENGTH5 = 4294967295;
  function split(string, separator, limit) {
    if (limit && typeof limit != "number" && isIterateeCall_default(string, separator, limit)) {
      separator = limit = void 0;
    }
    limit = limit === void 0 ? MAX_ARRAY_LENGTH5 : limit >>> 0;
    if (!limit) {
      return [];
    }
    string = toString_default(string);
    if (string && (typeof separator == "string" || separator != null && !isRegExp_default(separator))) {
      separator = baseToString_default(separator);
      if (!separator && hasUnicode_default(string)) {
        return castSlice_default(stringToArray_default(string), 0, limit);
      }
    }
    return string.split(separator, limit);
  }
  var split_default = split;

  // node_modules/lodash-es/spread.js
  init_define_process();
  var FUNC_ERROR_TEXT11 = "Expected a function";
  var nativeMax14 = Math.max;
  function spread(func, start) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT11);
    }
    start = start == null ? 0 : nativeMax14(toInteger_default(start), 0);
    return baseRest_default(function(args) {
      var array = args[start], otherArgs = castSlice_default(args, 0, start);
      if (array) {
        arrayPush_default(otherArgs, array);
      }
      return apply_default(func, this, otherArgs);
    });
  }
  var spread_default = spread;

  // node_modules/lodash-es/startCase.js
  init_define_process();
  var startCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? " " : "") + upperFirst_default(word);
  });
  var startCase_default = startCase;

  // node_modules/lodash-es/startsWith.js
  init_define_process();
  function startsWith(string, target, position) {
    string = toString_default(string);
    position = position == null ? 0 : baseClamp_default(toInteger_default(position), 0, string.length);
    target = baseToString_default(target);
    return string.slice(position, position + target.length) == target;
  }
  var startsWith_default = startsWith;

  // node_modules/lodash-es/stubObject.js
  init_define_process();
  function stubObject() {
    return {};
  }
  var stubObject_default = stubObject;

  // node_modules/lodash-es/stubString.js
  init_define_process();
  function stubString() {
    return "";
  }
  var stubString_default = stubString;

  // node_modules/lodash-es/stubTrue.js
  init_define_process();
  function stubTrue() {
    return true;
  }
  var stubTrue_default = stubTrue;

  // node_modules/lodash-es/subtract.js
  init_define_process();
  var subtract = createMathOperation_default(function(minuend, subtrahend) {
    return minuend - subtrahend;
  }, 0);
  var subtract_default = subtract;

  // node_modules/lodash-es/sum.js
  init_define_process();
  function sum(array) {
    return array && array.length ? baseSum_default(array, identity_default) : 0;
  }
  var sum_default = sum;

  // node_modules/lodash-es/sumBy.js
  init_define_process();
  function sumBy(array, iteratee2) {
    return array && array.length ? baseSum_default(array, baseIteratee_default(iteratee2, 2)) : 0;
  }
  var sumBy_default = sumBy;

  // node_modules/lodash-es/tail.js
  init_define_process();
  function tail(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseSlice_default(array, 1, length) : [];
  }
  var tail_default = tail;

  // node_modules/lodash-es/take.js
  init_define_process();
  function take(array, n, guard) {
    if (!(array && array.length)) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    return baseSlice_default(array, 0, n < 0 ? 0 : n);
  }
  var take_default = take;

  // node_modules/lodash-es/takeRight.js
  init_define_process();
  function takeRight(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    n = length - n;
    return baseSlice_default(array, n < 0 ? 0 : n, length);
  }
  var takeRight_default = takeRight;

  // node_modules/lodash-es/takeRightWhile.js
  init_define_process();
  function takeRightWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3), false, true) : [];
  }
  var takeRightWhile_default = takeRightWhile;

  // node_modules/lodash-es/takeWhile.js
  init_define_process();
  function takeWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3)) : [];
  }
  var takeWhile_default = takeWhile;

  // node_modules/lodash-es/tap.js
  init_define_process();
  function tap(value, interceptor) {
    interceptor(value);
    return value;
  }
  var tap_default = tap;

  // node_modules/lodash-es/template.js
  init_define_process();

  // node_modules/lodash-es/_customDefaultsAssignIn.js
  init_define_process();
  var objectProto27 = Object.prototype;
  var hasOwnProperty23 = objectProto27.hasOwnProperty;
  function customDefaultsAssignIn(objValue, srcValue, key, object) {
    if (objValue === void 0 || eq_default(objValue, objectProto27[key]) && !hasOwnProperty23.call(object, key)) {
      return srcValue;
    }
    return objValue;
  }
  var customDefaultsAssignIn_default = customDefaultsAssignIn;

  // node_modules/lodash-es/_escapeStringChar.js
  init_define_process();
  var stringEscapes = {
    "\\": "\\",
    "'": "'",
    "\n": "n",
    "\r": "r",
    "\u2028": "u2028",
    "\u2029": "u2029"
  };
  function escapeStringChar(chr) {
    return "\\" + stringEscapes[chr];
  }
  var escapeStringChar_default = escapeStringChar;

  // node_modules/lodash-es/_reInterpolate.js
  init_define_process();
  var reInterpolate = /<%=([\s\S]+?)%>/g;
  var reInterpolate_default = reInterpolate;

  // node_modules/lodash-es/templateSettings.js
  init_define_process();

  // node_modules/lodash-es/_reEscape.js
  init_define_process();
  var reEscape = /<%-([\s\S]+?)%>/g;
  var reEscape_default = reEscape;

  // node_modules/lodash-es/_reEvaluate.js
  init_define_process();
  var reEvaluate = /<%([\s\S]+?)%>/g;
  var reEvaluate_default = reEvaluate;

  // node_modules/lodash-es/templateSettings.js
  var templateSettings = {
    "escape": reEscape_default,
    "evaluate": reEvaluate_default,
    "interpolate": reInterpolate_default,
    "variable": "",
    "imports": {
      "_": { "escape": escape_default }
    }
  };
  var templateSettings_default = templateSettings;

  // node_modules/lodash-es/template.js
  var INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
  var reEmptyStringLeading = /\b__p \+= '';/g;
  var reEmptyStringMiddle = /\b(__p \+=) '' \+/g;
  var reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
  var reNoMatch = /($^)/;
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
  var objectProto28 = Object.prototype;
  var hasOwnProperty24 = objectProto28.hasOwnProperty;
  function template(string, options, guard) {
    var settings = templateSettings_default.imports._.templateSettings || templateSettings_default;
    if (guard && isIterateeCall_default(string, options, guard)) {
      options = void 0;
    }
    string = toString_default(string);
    options = assignInWith_default({}, options, settings, customDefaultsAssignIn_default);
    var imports = assignInWith_default({}, options.imports, settings.imports, customDefaultsAssignIn_default), importsKeys = keys_default(imports), importsValues = baseValues_default(imports, importsKeys);
    var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
    var reDelimiters = RegExp(
      (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate_default ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
      "g"
    );
    var sourceURL = hasOwnProperty24.call(options, "sourceURL") ? "//# sourceURL=" + (options.sourceURL + "").replace(/\s/g, " ") + "\n" : "";
    string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
      interpolateValue || (interpolateValue = esTemplateValue);
      source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar_default);
      if (escapeValue) {
        isEscaping = true;
        source += "' +\n__e(" + escapeValue + ") +\n'";
      }
      if (evaluateValue) {
        isEvaluating = true;
        source += "';\n" + evaluateValue + ";\n__p += '";
      }
      if (interpolateValue) {
        source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
      }
      index = offset + match.length;
      return match;
    });
    source += "';\n";
    var variable = hasOwnProperty24.call(options, "variable") && options.variable;
    if (!variable) {
      source = "with (obj) {\n" + source + "\n}\n";
    } else if (reForbiddenIdentifierChars.test(variable)) {
      throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
    }
    source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
    source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
    var result2 = attempt_default(function() {
      return Function(importsKeys, sourceURL + "return " + source).apply(void 0, importsValues);
    });
    result2.source = source;
    if (isError_default(result2)) {
      throw result2;
    }
    return result2;
  }
  var template_default = template;

  // node_modules/lodash-es/throttle.js
  init_define_process();
  var FUNC_ERROR_TEXT12 = "Expected a function";
  function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT12);
    }
    if (isObject_default(options)) {
      leading = "leading" in options ? !!options.leading : leading;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return debounce_default(func, wait, {
      "leading": leading,
      "maxWait": wait,
      "trailing": trailing
    });
  }
  var throttle_default = throttle;

  // node_modules/lodash-es/thru.js
  init_define_process();
  function thru(value, interceptor) {
    return interceptor(value);
  }
  var thru_default = thru;

  // node_modules/lodash-es/times.js
  init_define_process();
  var MAX_SAFE_INTEGER5 = 9007199254740991;
  var MAX_ARRAY_LENGTH6 = 4294967295;
  var nativeMin12 = Math.min;
  function times(n, iteratee2) {
    n = toInteger_default(n);
    if (n < 1 || n > MAX_SAFE_INTEGER5) {
      return [];
    }
    var index = MAX_ARRAY_LENGTH6, length = nativeMin12(n, MAX_ARRAY_LENGTH6);
    iteratee2 = castFunction_default(iteratee2);
    n -= MAX_ARRAY_LENGTH6;
    var result2 = baseTimes_default(length, iteratee2);
    while (++index < n) {
      iteratee2(index);
    }
    return result2;
  }
  var times_default = times;

  // node_modules/lodash-es/toIterator.js
  init_define_process();
  function wrapperToIterator() {
    return this;
  }
  var toIterator_default = wrapperToIterator;

  // node_modules/lodash-es/toJSON.js
  init_define_process();

  // node_modules/lodash-es/wrapperValue.js
  init_define_process();

  // node_modules/lodash-es/_baseWrapperValue.js
  init_define_process();
  function baseWrapperValue(value, actions) {
    var result2 = value;
    if (result2 instanceof LazyWrapper_default) {
      result2 = result2.value();
    }
    return arrayReduce_default(actions, function(result3, action) {
      return action.func.apply(action.thisArg, arrayPush_default([result3], action.args));
    }, result2);
  }
  var baseWrapperValue_default = baseWrapperValue;

  // node_modules/lodash-es/wrapperValue.js
  function wrapperValue() {
    return baseWrapperValue_default(this.__wrapped__, this.__actions__);
  }
  var wrapperValue_default = wrapperValue;

  // node_modules/lodash-es/toLower.js
  init_define_process();
  function toLower(value) {
    return toString_default(value).toLowerCase();
  }
  var toLower_default = toLower;

  // node_modules/lodash-es/toPath.js
  init_define_process();
  function toPath(value) {
    if (isArray_default(value)) {
      return arrayMap_default(value, toKey_default);
    }
    return isSymbol_default(value) ? [value] : copyArray_default(stringToPath_default(toString_default(value)));
  }
  var toPath_default = toPath;

  // node_modules/lodash-es/toSafeInteger.js
  init_define_process();
  var MAX_SAFE_INTEGER6 = 9007199254740991;
  function toSafeInteger(value) {
    return value ? baseClamp_default(toInteger_default(value), -MAX_SAFE_INTEGER6, MAX_SAFE_INTEGER6) : value === 0 ? value : 0;
  }
  var toSafeInteger_default = toSafeInteger;

  // node_modules/lodash-es/toUpper.js
  init_define_process();
  function toUpper(value) {
    return toString_default(value).toUpperCase();
  }
  var toUpper_default = toUpper;

  // node_modules/lodash-es/transform.js
  init_define_process();
  function transform(object, iteratee2, accumulator) {
    var isArr = isArray_default(object), isArrLike = isArr || isBuffer_default(object) || isTypedArray_default(object);
    iteratee2 = baseIteratee_default(iteratee2, 4);
    if (accumulator == null) {
      var Ctor = object && object.constructor;
      if (isArrLike) {
        accumulator = isArr ? new Ctor() : [];
      } else if (isObject_default(object)) {
        accumulator = isFunction_default(Ctor) ? baseCreate_default(getPrototype_default(object)) : {};
      } else {
        accumulator = {};
      }
    }
    (isArrLike ? arrayEach_default : baseForOwn_default)(object, function(value, index, object2) {
      return iteratee2(accumulator, value, index, object2);
    });
    return accumulator;
  }
  var transform_default = transform;

  // node_modules/lodash-es/trim.js
  init_define_process();

  // node_modules/lodash-es/_charsEndIndex.js
  init_define_process();
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while (index-- && baseIndexOf_default(chrSymbols, strSymbols[index], 0) > -1) {
    }
    return index;
  }
  var charsEndIndex_default = charsEndIndex;

  // node_modules/lodash-es/_charsStartIndex.js
  init_define_process();
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while (++index < length && baseIndexOf_default(chrSymbols, strSymbols[index], 0) > -1) {
    }
    return index;
  }
  var charsStartIndex_default = charsStartIndex;

  // node_modules/lodash-es/trim.js
  function trim(string, chars, guard) {
    string = toString_default(string);
    if (string && (guard || chars === void 0)) {
      return baseTrim_default(string);
    }
    if (!string || !(chars = baseToString_default(chars))) {
      return string;
    }
    var strSymbols = stringToArray_default(string), chrSymbols = stringToArray_default(chars), start = charsStartIndex_default(strSymbols, chrSymbols), end = charsEndIndex_default(strSymbols, chrSymbols) + 1;
    return castSlice_default(strSymbols, start, end).join("");
  }
  var trim_default = trim;

  // node_modules/lodash-es/trimEnd.js
  init_define_process();
  function trimEnd(string, chars, guard) {
    string = toString_default(string);
    if (string && (guard || chars === void 0)) {
      return string.slice(0, trimmedEndIndex_default(string) + 1);
    }
    if (!string || !(chars = baseToString_default(chars))) {
      return string;
    }
    var strSymbols = stringToArray_default(string), end = charsEndIndex_default(strSymbols, stringToArray_default(chars)) + 1;
    return castSlice_default(strSymbols, 0, end).join("");
  }
  var trimEnd_default = trimEnd;

  // node_modules/lodash-es/trimStart.js
  init_define_process();
  var reTrimStart3 = /^\s+/;
  function trimStart(string, chars, guard) {
    string = toString_default(string);
    if (string && (guard || chars === void 0)) {
      return string.replace(reTrimStart3, "");
    }
    if (!string || !(chars = baseToString_default(chars))) {
      return string;
    }
    var strSymbols = stringToArray_default(string), start = charsStartIndex_default(strSymbols, stringToArray_default(chars));
    return castSlice_default(strSymbols, start).join("");
  }
  var trimStart_default = trimStart;

  // node_modules/lodash-es/truncate.js
  init_define_process();
  var DEFAULT_TRUNC_LENGTH = 30;
  var DEFAULT_TRUNC_OMISSION = "...";
  var reFlags2 = /\w*$/;
  function truncate(string, options) {
    var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
    if (isObject_default(options)) {
      var separator = "separator" in options ? options.separator : separator;
      length = "length" in options ? toInteger_default(options.length) : length;
      omission = "omission" in options ? baseToString_default(options.omission) : omission;
    }
    string = toString_default(string);
    var strLength = string.length;
    if (hasUnicode_default(string)) {
      var strSymbols = stringToArray_default(string);
      strLength = strSymbols.length;
    }
    if (length >= strLength) {
      return string;
    }
    var end = length - stringSize_default(omission);
    if (end < 1) {
      return omission;
    }
    var result2 = strSymbols ? castSlice_default(strSymbols, 0, end).join("") : string.slice(0, end);
    if (separator === void 0) {
      return result2 + omission;
    }
    if (strSymbols) {
      end += result2.length - end;
    }
    if (isRegExp_default(separator)) {
      if (string.slice(end).search(separator)) {
        var match, substring = result2;
        if (!separator.global) {
          separator = RegExp(separator.source, toString_default(reFlags2.exec(separator)) + "g");
        }
        separator.lastIndex = 0;
        while (match = separator.exec(substring)) {
          var newEnd = match.index;
        }
        result2 = result2.slice(0, newEnd === void 0 ? end : newEnd);
      }
    } else if (string.indexOf(baseToString_default(separator), end) != end) {
      var index = result2.lastIndexOf(separator);
      if (index > -1) {
        result2 = result2.slice(0, index);
      }
    }
    return result2 + omission;
  }
  var truncate_default = truncate;

  // node_modules/lodash-es/unary.js
  init_define_process();
  function unary(func) {
    return ary_default(func, 1);
  }
  var unary_default = unary;

  // node_modules/lodash-es/unescape.js
  init_define_process();

  // node_modules/lodash-es/_unescapeHtmlChar.js
  init_define_process();
  var htmlUnescapes = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
  };
  var unescapeHtmlChar = basePropertyOf_default(htmlUnescapes);
  var unescapeHtmlChar_default = unescapeHtmlChar;

  // node_modules/lodash-es/unescape.js
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g;
  var reHasEscapedHtml = RegExp(reEscapedHtml.source);
  function unescape(string) {
    string = toString_default(string);
    return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar_default) : string;
  }
  var unescape_default = unescape;

  // node_modules/lodash-es/union.js
  init_define_process();

  // node_modules/lodash-es/_baseUniq.js
  init_define_process();

  // node_modules/lodash-es/_createSet.js
  init_define_process();
  var INFINITY6 = 1 / 0;
  var createSet = !(Set_default && 1 / setToArray_default(new Set_default([, -0]))[1] == INFINITY6) ? noop_default : function(values2) {
    return new Set_default(values2);
  };
  var createSet_default = createSet;

  // node_modules/lodash-es/_baseUniq.js
  var LARGE_ARRAY_SIZE3 = 200;
  function baseUniq(array, iteratee2, comparator) {
    var index = -1, includes2 = arrayIncludes_default, length = array.length, isCommon = true, result2 = [], seen = result2;
    if (comparator) {
      isCommon = false;
      includes2 = arrayIncludesWith_default;
    } else if (length >= LARGE_ARRAY_SIZE3) {
      var set2 = iteratee2 ? null : createSet_default(array);
      if (set2) {
        return setToArray_default(set2);
      }
      isCommon = false;
      includes2 = cacheHas_default;
      seen = new SetCache_default();
    } else {
      seen = iteratee2 ? [] : result2;
    }
    outer:
      while (++index < length) {
        var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee2) {
            seen.push(computed);
          }
          result2.push(value);
        } else if (!includes2(seen, computed, comparator)) {
          if (seen !== result2) {
            seen.push(computed);
          }
          result2.push(value);
        }
      }
    return result2;
  }
  var baseUniq_default = baseUniq;

  // node_modules/lodash-es/union.js
  var union = baseRest_default(function(arrays) {
    return baseUniq_default(baseFlatten_default(arrays, 1, isArrayLikeObject_default, true));
  });
  var union_default = union;

  // node_modules/lodash-es/unionBy.js
  init_define_process();
  var unionBy = baseRest_default(function(arrays) {
    var iteratee2 = last_default(arrays);
    if (isArrayLikeObject_default(iteratee2)) {
      iteratee2 = void 0;
    }
    return baseUniq_default(baseFlatten_default(arrays, 1, isArrayLikeObject_default, true), baseIteratee_default(iteratee2, 2));
  });
  var unionBy_default = unionBy;

  // node_modules/lodash-es/unionWith.js
  init_define_process();
  var unionWith = baseRest_default(function(arrays) {
    var comparator = last_default(arrays);
    comparator = typeof comparator == "function" ? comparator : void 0;
    return baseUniq_default(baseFlatten_default(arrays, 1, isArrayLikeObject_default, true), void 0, comparator);
  });
  var unionWith_default = unionWith;

  // node_modules/lodash-es/uniq.js
  init_define_process();
  function uniq(array) {
    return array && array.length ? baseUniq_default(array) : [];
  }
  var uniq_default = uniq;

  // node_modules/lodash-es/uniqBy.js
  init_define_process();
  function uniqBy(array, iteratee2) {
    return array && array.length ? baseUniq_default(array, baseIteratee_default(iteratee2, 2)) : [];
  }
  var uniqBy_default = uniqBy;

  // node_modules/lodash-es/uniqWith.js
  init_define_process();
  function uniqWith(array, comparator) {
    comparator = typeof comparator == "function" ? comparator : void 0;
    return array && array.length ? baseUniq_default(array, void 0, comparator) : [];
  }
  var uniqWith_default = uniqWith;

  // node_modules/lodash-es/uniqueId.js
  init_define_process();
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter;
    return toString_default(prefix) + id;
  }
  var uniqueId_default = uniqueId;

  // node_modules/lodash-es/unset.js
  init_define_process();
  function unset(object, path) {
    return object == null ? true : baseUnset_default(object, path);
  }
  var unset_default = unset;

  // node_modules/lodash-es/unzip.js
  init_define_process();
  var nativeMax15 = Math.max;
  function unzip(array) {
    if (!(array && array.length)) {
      return [];
    }
    var length = 0;
    array = arrayFilter_default(array, function(group) {
      if (isArrayLikeObject_default(group)) {
        length = nativeMax15(group.length, length);
        return true;
      }
    });
    return baseTimes_default(length, function(index) {
      return arrayMap_default(array, baseProperty_default(index));
    });
  }
  var unzip_default = unzip;

  // node_modules/lodash-es/unzipWith.js
  init_define_process();
  function unzipWith(array, iteratee2) {
    if (!(array && array.length)) {
      return [];
    }
    var result2 = unzip_default(array);
    if (iteratee2 == null) {
      return result2;
    }
    return arrayMap_default(result2, function(group) {
      return apply_default(iteratee2, void 0, group);
    });
  }
  var unzipWith_default = unzipWith;

  // node_modules/lodash-es/update.js
  init_define_process();

  // node_modules/lodash-es/_baseUpdate.js
  init_define_process();
  function baseUpdate(object, path, updater, customizer) {
    return baseSet_default(object, path, updater(baseGet_default(object, path)), customizer);
  }
  var baseUpdate_default = baseUpdate;

  // node_modules/lodash-es/update.js
  function update(object, path, updater) {
    return object == null ? object : baseUpdate_default(object, path, castFunction_default(updater));
  }
  var update_default = update;

  // node_modules/lodash-es/updateWith.js
  init_define_process();
  function updateWith(object, path, updater, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    return object == null ? object : baseUpdate_default(object, path, castFunction_default(updater), customizer);
  }
  var updateWith_default = updateWith;

  // node_modules/lodash-es/upperCase.js
  init_define_process();
  var upperCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? " " : "") + word.toUpperCase();
  });
  var upperCase_default = upperCase;

  // node_modules/lodash-es/valueOf.js
  init_define_process();

  // node_modules/lodash-es/valuesIn.js
  init_define_process();
  function valuesIn(object) {
    return object == null ? [] : baseValues_default(object, keysIn_default(object));
  }
  var valuesIn_default = valuesIn;

  // node_modules/lodash-es/without.js
  init_define_process();
  var without = baseRest_default(function(array, values2) {
    return isArrayLikeObject_default(array) ? baseDifference_default(array, values2) : [];
  });
  var without_default = without;

  // node_modules/lodash-es/wrap.js
  init_define_process();
  function wrap(value, wrapper) {
    return partial_default(castFunction_default(wrapper), value);
  }
  var wrap_default = wrap;

  // node_modules/lodash-es/wrapperAt.js
  init_define_process();
  var wrapperAt = flatRest_default(function(paths) {
    var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
      return baseAt_default(object, paths);
    };
    if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper_default) || !isIndex_default(start)) {
      return this.thru(interceptor);
    }
    value = value.slice(start, +start + (length ? 1 : 0));
    value.__actions__.push({
      "func": thru_default,
      "args": [interceptor],
      "thisArg": void 0
    });
    return new LodashWrapper_default(value, this.__chain__).thru(function(array) {
      if (length && !array.length) {
        array.push(void 0);
      }
      return array;
    });
  });
  var wrapperAt_default = wrapperAt;

  // node_modules/lodash-es/wrapperChain.js
  init_define_process();
  function wrapperChain() {
    return chain_default(this);
  }
  var wrapperChain_default = wrapperChain;

  // node_modules/lodash-es/wrapperReverse.js
  init_define_process();
  function wrapperReverse() {
    var value = this.__wrapped__;
    if (value instanceof LazyWrapper_default) {
      var wrapped = value;
      if (this.__actions__.length) {
        wrapped = new LazyWrapper_default(this);
      }
      wrapped = wrapped.reverse();
      wrapped.__actions__.push({
        "func": thru_default,
        "args": [reverse_default],
        "thisArg": void 0
      });
      return new LodashWrapper_default(wrapped, this.__chain__);
    }
    return this.thru(reverse_default);
  }
  var wrapperReverse_default = wrapperReverse;

  // node_modules/lodash-es/xor.js
  init_define_process();

  // node_modules/lodash-es/_baseXor.js
  init_define_process();
  function baseXor(arrays, iteratee2, comparator) {
    var length = arrays.length;
    if (length < 2) {
      return length ? baseUniq_default(arrays[0]) : [];
    }
    var index = -1, result2 = Array(length);
    while (++index < length) {
      var array = arrays[index], othIndex = -1;
      while (++othIndex < length) {
        if (othIndex != index) {
          result2[index] = baseDifference_default(result2[index] || array, arrays[othIndex], iteratee2, comparator);
        }
      }
    }
    return baseUniq_default(baseFlatten_default(result2, 1), iteratee2, comparator);
  }
  var baseXor_default = baseXor;

  // node_modules/lodash-es/xor.js
  var xor = baseRest_default(function(arrays) {
    return baseXor_default(arrayFilter_default(arrays, isArrayLikeObject_default));
  });
  var xor_default = xor;

  // node_modules/lodash-es/xorBy.js
  init_define_process();
  var xorBy = baseRest_default(function(arrays) {
    var iteratee2 = last_default(arrays);
    if (isArrayLikeObject_default(iteratee2)) {
      iteratee2 = void 0;
    }
    return baseXor_default(arrayFilter_default(arrays, isArrayLikeObject_default), baseIteratee_default(iteratee2, 2));
  });
  var xorBy_default = xorBy;

  // node_modules/lodash-es/xorWith.js
  init_define_process();
  var xorWith = baseRest_default(function(arrays) {
    var comparator = last_default(arrays);
    comparator = typeof comparator == "function" ? comparator : void 0;
    return baseXor_default(arrayFilter_default(arrays, isArrayLikeObject_default), void 0, comparator);
  });
  var xorWith_default = xorWith;

  // node_modules/lodash-es/zip.js
  init_define_process();
  var zip = baseRest_default(unzip_default);
  var zip_default = zip;

  // node_modules/lodash-es/zipObject.js
  init_define_process();

  // node_modules/lodash-es/_baseZipObject.js
  init_define_process();
  function baseZipObject(props, values2, assignFunc) {
    var index = -1, length = props.length, valsLength = values2.length, result2 = {};
    while (++index < length) {
      var value = index < valsLength ? values2[index] : void 0;
      assignFunc(result2, props[index], value);
    }
    return result2;
  }
  var baseZipObject_default = baseZipObject;

  // node_modules/lodash-es/zipObject.js
  function zipObject(props, values2) {
    return baseZipObject_default(props || [], values2 || [], assignValue_default);
  }
  var zipObject_default = zipObject;

  // node_modules/lodash-es/zipObjectDeep.js
  init_define_process();
  function zipObjectDeep(props, values2) {
    return baseZipObject_default(props || [], values2 || [], baseSet_default);
  }
  var zipObjectDeep_default = zipObjectDeep;

  // node_modules/lodash-es/zipWith.js
  init_define_process();
  var zipWith = baseRest_default(function(arrays) {
    var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : void 0;
    iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : void 0;
    return unzipWith_default(arrays, iteratee2);
  });
  var zipWith_default = zipWith;

  // node_modules/lodash-es/lodash.default.js
  init_define_process();

  // node_modules/lodash-es/array.js
  init_define_process();

  // node_modules/lodash-es/array.default.js
  init_define_process();
  var array_default_default = {
    chunk: chunk_default,
    compact: compact_default,
    concat: concat_default,
    difference: difference_default,
    differenceBy: differenceBy_default,
    differenceWith: differenceWith_default,
    drop: drop_default,
    dropRight: dropRight_default,
    dropRightWhile: dropRightWhile_default,
    dropWhile: dropWhile_default,
    fill: fill_default,
    findIndex: findIndex_default,
    findLastIndex: findLastIndex_default,
    first: head_default,
    flatten: flatten_default,
    flattenDeep: flattenDeep_default,
    flattenDepth: flattenDepth_default,
    fromPairs: fromPairs_default,
    head: head_default,
    indexOf: indexOf_default,
    initial: initial_default,
    intersection: intersection_default,
    intersectionBy: intersectionBy_default,
    intersectionWith: intersectionWith_default,
    join: join_default,
    last: last_default,
    lastIndexOf: lastIndexOf_default,
    nth: nth_default,
    pull: pull_default,
    pullAll: pullAll_default,
    pullAllBy: pullAllBy_default,
    pullAllWith: pullAllWith_default,
    pullAt: pullAt_default,
    remove: remove_default,
    reverse: reverse_default,
    slice: slice_default,
    sortedIndex: sortedIndex_default,
    sortedIndexBy: sortedIndexBy_default,
    sortedIndexOf: sortedIndexOf_default,
    sortedLastIndex: sortedLastIndex_default,
    sortedLastIndexBy: sortedLastIndexBy_default,
    sortedLastIndexOf: sortedLastIndexOf_default,
    sortedUniq: sortedUniq_default,
    sortedUniqBy: sortedUniqBy_default,
    tail: tail_default,
    take: take_default,
    takeRight: takeRight_default,
    takeRightWhile: takeRightWhile_default,
    takeWhile: takeWhile_default,
    union: union_default,
    unionBy: unionBy_default,
    unionWith: unionWith_default,
    uniq: uniq_default,
    uniqBy: uniqBy_default,
    uniqWith: uniqWith_default,
    unzip: unzip_default,
    unzipWith: unzipWith_default,
    without: without_default,
    xor: xor_default,
    xorBy: xorBy_default,
    xorWith: xorWith_default,
    zip: zip_default,
    zipObject: zipObject_default,
    zipObjectDeep: zipObjectDeep_default,
    zipWith: zipWith_default
  };

  // node_modules/lodash-es/collection.js
  init_define_process();

  // node_modules/lodash-es/collection.default.js
  init_define_process();
  var collection_default_default = {
    countBy: countBy_default,
    each: forEach_default,
    eachRight: forEachRight_default,
    every: every_default,
    filter: filter_default,
    find: find_default,
    findLast: findLast_default,
    flatMap: flatMap_default,
    flatMapDeep: flatMapDeep_default,
    flatMapDepth: flatMapDepth_default,
    forEach: forEach_default,
    forEachRight: forEachRight_default,
    groupBy: groupBy_default,
    includes: includes_default,
    invokeMap: invokeMap_default,
    keyBy: keyBy_default,
    map: map_default,
    orderBy: orderBy_default,
    partition: partition_default,
    reduce: reduce_default,
    reduceRight: reduceRight_default,
    reject: reject_default,
    sample: sample_default,
    sampleSize: sampleSize_default,
    shuffle: shuffle_default,
    size: size_default,
    some: some_default,
    sortBy: sortBy_default
  };

  // node_modules/lodash-es/date.js
  init_define_process();

  // node_modules/lodash-es/date.default.js
  init_define_process();
  var date_default_default = {
    now: now_default
  };

  // node_modules/lodash-es/function.js
  init_define_process();

  // node_modules/lodash-es/function.default.js
  init_define_process();
  var function_default_default = {
    after: after_default,
    ary: ary_default,
    before: before_default,
    bind: bind_default,
    bindKey: bindKey_default,
    curry: curry_default,
    curryRight: curryRight_default,
    debounce: debounce_default,
    defer: defer_default,
    delay: delay_default,
    flip: flip_default,
    memoize: memoize_default,
    negate: negate_default,
    once: once_default,
    overArgs: overArgs_default,
    partial: partial_default,
    partialRight: partialRight_default,
    rearg: rearg_default,
    rest: rest_default,
    spread: spread_default,
    throttle: throttle_default,
    unary: unary_default,
    wrap: wrap_default
  };

  // node_modules/lodash-es/lang.js
  init_define_process();

  // node_modules/lodash-es/lang.default.js
  init_define_process();
  var lang_default_default = {
    castArray: castArray_default,
    clone: clone_default,
    cloneDeep: cloneDeep_default,
    cloneDeepWith: cloneDeepWith_default,
    cloneWith: cloneWith_default,
    conformsTo: conformsTo_default,
    eq: eq_default,
    gt: gt_default,
    gte: gte_default,
    isArguments: isArguments_default,
    isArray: isArray_default,
    isArrayBuffer: isArrayBuffer_default,
    isArrayLike: isArrayLike_default,
    isArrayLikeObject: isArrayLikeObject_default,
    isBoolean: isBoolean_default,
    isBuffer: isBuffer_default,
    isDate: isDate_default,
    isElement: isElement_default,
    isEmpty: isEmpty_default,
    isEqual: isEqual_default,
    isEqualWith: isEqualWith_default,
    isError: isError_default,
    isFinite: isFinite_default,
    isFunction: isFunction_default,
    isInteger: isInteger_default,
    isLength: isLength_default,
    isMap: isMap_default,
    isMatch: isMatch_default,
    isMatchWith: isMatchWith_default,
    isNaN: isNaN_default,
    isNative: isNative_default,
    isNil: isNil_default,
    isNull: isNull_default,
    isNumber: isNumber_default,
    isObject: isObject_default,
    isObjectLike: isObjectLike_default,
    isPlainObject: isPlainObject_default,
    isRegExp: isRegExp_default,
    isSafeInteger: isSafeInteger_default,
    isSet: isSet_default,
    isString: isString_default,
    isSymbol: isSymbol_default,
    isTypedArray: isTypedArray_default,
    isUndefined: isUndefined_default,
    isWeakMap: isWeakMap_default,
    isWeakSet: isWeakSet_default,
    lt: lt_default,
    lte: lte_default,
    toArray: toArray_default,
    toFinite: toFinite_default,
    toInteger: toInteger_default,
    toLength: toLength_default,
    toNumber: toNumber_default,
    toPlainObject: toPlainObject_default,
    toSafeInteger: toSafeInteger_default,
    toString: toString_default
  };

  // node_modules/lodash-es/math.js
  init_define_process();

  // node_modules/lodash-es/math.default.js
  init_define_process();
  var math_default_default = {
    add: add_default,
    ceil: ceil_default,
    divide: divide_default,
    floor: floor_default,
    max: max_default,
    maxBy: maxBy_default,
    mean: mean_default,
    meanBy: meanBy_default,
    min: min_default,
    minBy: minBy_default,
    multiply: multiply_default,
    round: round_default,
    subtract: subtract_default,
    sum: sum_default,
    sumBy: sumBy_default
  };

  // node_modules/lodash-es/number.js
  init_define_process();

  // node_modules/lodash-es/number.default.js
  init_define_process();
  var number_default_default = {
    clamp: clamp_default,
    inRange: inRange_default,
    random: random_default
  };

  // node_modules/lodash-es/object.js
  init_define_process();

  // node_modules/lodash-es/object.default.js
  init_define_process();
  var object_default_default = {
    assign: assign_default,
    assignIn: assignIn_default,
    assignInWith: assignInWith_default,
    assignWith: assignWith_default,
    at: at_default,
    create: create_default,
    defaults: defaults_default,
    defaultsDeep: defaultsDeep_default,
    entries: toPairs_default,
    entriesIn: toPairsIn_default,
    extend: assignIn_default,
    extendWith: assignInWith_default,
    findKey: findKey_default,
    findLastKey: findLastKey_default,
    forIn: forIn_default,
    forInRight: forInRight_default,
    forOwn: forOwn_default,
    forOwnRight: forOwnRight_default,
    functions: functions_default,
    functionsIn: functionsIn_default,
    get: get_default,
    has: has_default,
    hasIn: hasIn_default,
    invert: invert_default,
    invertBy: invertBy_default,
    invoke: invoke_default,
    keys: keys_default,
    keysIn: keysIn_default,
    mapKeys: mapKeys_default,
    mapValues: mapValues_default,
    merge: merge_default,
    mergeWith: mergeWith_default,
    omit: omit_default,
    omitBy: omitBy_default,
    pick: pick_default,
    pickBy: pickBy_default,
    result: result_default,
    set: set_default,
    setWith: setWith_default,
    toPairs: toPairs_default,
    toPairsIn: toPairsIn_default,
    transform: transform_default,
    unset: unset_default,
    update: update_default,
    updateWith: updateWith_default,
    values: values_default,
    valuesIn: valuesIn_default
  };

  // node_modules/lodash-es/seq.js
  init_define_process();

  // node_modules/lodash-es/seq.default.js
  init_define_process();
  var seq_default_default = {
    at: wrapperAt_default,
    chain: chain_default,
    commit: commit_default,
    lodash: wrapperLodash_default,
    next: next_default,
    plant: plant_default,
    reverse: wrapperReverse_default,
    tap: tap_default,
    thru: thru_default,
    toIterator: toIterator_default,
    toJSON: wrapperValue_default,
    value: wrapperValue_default,
    valueOf: wrapperValue_default,
    wrapperChain: wrapperChain_default
  };

  // node_modules/lodash-es/string.js
  init_define_process();

  // node_modules/lodash-es/string.default.js
  init_define_process();
  var string_default_default = {
    camelCase: camelCase_default,
    capitalize: capitalize_default,
    deburr: deburr_default,
    endsWith: endsWith_default,
    escape: escape_default,
    escapeRegExp: escapeRegExp_default,
    kebabCase: kebabCase_default,
    lowerCase: lowerCase_default,
    lowerFirst: lowerFirst_default,
    pad: pad_default,
    padEnd: padEnd_default,
    padStart: padStart_default,
    parseInt: parseInt_default,
    repeat: repeat_default,
    replace: replace_default,
    snakeCase: snakeCase_default,
    split: split_default,
    startCase: startCase_default,
    startsWith: startsWith_default,
    template: template_default,
    templateSettings: templateSettings_default,
    toLower: toLower_default,
    toUpper: toUpper_default,
    trim: trim_default,
    trimEnd: trimEnd_default,
    trimStart: trimStart_default,
    truncate: truncate_default,
    unescape: unescape_default,
    upperCase: upperCase_default,
    upperFirst: upperFirst_default,
    words: words_default
  };

  // node_modules/lodash-es/util.js
  init_define_process();

  // node_modules/lodash-es/util.default.js
  init_define_process();
  var util_default_default = {
    attempt: attempt_default,
    bindAll: bindAll_default,
    cond: cond_default,
    conforms: conforms_default,
    constant: constant_default,
    defaultTo: defaultTo_default,
    flow: flow_default,
    flowRight: flowRight_default,
    identity: identity_default,
    iteratee: iteratee_default,
    matches: matches_default,
    matchesProperty: matchesProperty_default,
    method: method_default,
    methodOf: methodOf_default,
    mixin: mixin_default,
    noop: noop_default,
    nthArg: nthArg_default,
    over: over_default,
    overEvery: overEvery_default,
    overSome: overSome_default,
    property: property_default,
    propertyOf: propertyOf_default,
    range: range_default,
    rangeRight: rangeRight_default,
    stubArray: stubArray_default,
    stubFalse: stubFalse_default,
    stubObject: stubObject_default,
    stubString: stubString_default,
    stubTrue: stubTrue_default,
    times: times_default,
    toPath: toPath_default,
    uniqueId: uniqueId_default
  };

  // node_modules/lodash-es/_lazyClone.js
  init_define_process();
  function lazyClone() {
    var result2 = new LazyWrapper_default(this.__wrapped__);
    result2.__actions__ = copyArray_default(this.__actions__);
    result2.__dir__ = this.__dir__;
    result2.__filtered__ = this.__filtered__;
    result2.__iteratees__ = copyArray_default(this.__iteratees__);
    result2.__takeCount__ = this.__takeCount__;
    result2.__views__ = copyArray_default(this.__views__);
    return result2;
  }
  var lazyClone_default = lazyClone;

  // node_modules/lodash-es/_lazyReverse.js
  init_define_process();
  function lazyReverse() {
    if (this.__filtered__) {
      var result2 = new LazyWrapper_default(this);
      result2.__dir__ = -1;
      result2.__filtered__ = true;
    } else {
      result2 = this.clone();
      result2.__dir__ *= -1;
    }
    return result2;
  }
  var lazyReverse_default = lazyReverse;

  // node_modules/lodash-es/_lazyValue.js
  init_define_process();

  // node_modules/lodash-es/_getView.js
  init_define_process();
  var nativeMax16 = Math.max;
  var nativeMin13 = Math.min;
  function getView(start, end, transforms) {
    var index = -1, length = transforms.length;
    while (++index < length) {
      var data = transforms[index], size2 = data.size;
      switch (data.type) {
        case "drop":
          start += size2;
          break;
        case "dropRight":
          end -= size2;
          break;
        case "take":
          end = nativeMin13(end, start + size2);
          break;
        case "takeRight":
          start = nativeMax16(start, end - size2);
          break;
      }
    }
    return { "start": start, "end": end };
  }
  var getView_default = getView;

  // node_modules/lodash-es/_lazyValue.js
  var LAZY_FILTER_FLAG = 1;
  var LAZY_MAP_FLAG = 2;
  var nativeMin14 = Math.min;
  function lazyValue() {
    var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray_default(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView_default(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin14(length, this.__takeCount__);
    if (!isArr || !isRight && arrLength == length && takeCount == length) {
      return baseWrapperValue_default(array, this.__actions__);
    }
    var result2 = [];
    outer:
      while (length-- && resIndex < takeCount) {
        index += dir;
        var iterIndex = -1, value = array[index];
        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result2[resIndex++] = value;
      }
    return result2;
  }
  var lazyValue_default = lazyValue;

  // node_modules/lodash-es/lodash.default.js
  var VERSION = "4.17.21";
  var WRAP_BIND_KEY_FLAG7 = 2;
  var LAZY_FILTER_FLAG2 = 1;
  var LAZY_WHILE_FLAG = 3;
  var MAX_ARRAY_LENGTH7 = 4294967295;
  var arrayProto6 = Array.prototype;
  var objectProto29 = Object.prototype;
  var hasOwnProperty25 = objectProto29.hasOwnProperty;
  var symIterator2 = Symbol_default ? Symbol_default.iterator : void 0;
  var nativeMax17 = Math.max;
  var nativeMin15 = Math.min;
  var mixin2 = function(func) {
    return function(object, source, options) {
      if (options == null) {
        var isObj = isObject_default(source), props = isObj && keys_default(source), methodNames = props && props.length && baseFunctions_default(source, props);
        if (!(methodNames ? methodNames.length : isObj)) {
          options = source;
          source = object;
          object = this;
        }
      }
      return func(object, source, options);
    };
  }(mixin_default);
  wrapperLodash_default.after = function_default_default.after;
  wrapperLodash_default.ary = function_default_default.ary;
  wrapperLodash_default.assign = object_default_default.assign;
  wrapperLodash_default.assignIn = object_default_default.assignIn;
  wrapperLodash_default.assignInWith = object_default_default.assignInWith;
  wrapperLodash_default.assignWith = object_default_default.assignWith;
  wrapperLodash_default.at = object_default_default.at;
  wrapperLodash_default.before = function_default_default.before;
  wrapperLodash_default.bind = function_default_default.bind;
  wrapperLodash_default.bindAll = util_default_default.bindAll;
  wrapperLodash_default.bindKey = function_default_default.bindKey;
  wrapperLodash_default.castArray = lang_default_default.castArray;
  wrapperLodash_default.chain = seq_default_default.chain;
  wrapperLodash_default.chunk = array_default_default.chunk;
  wrapperLodash_default.compact = array_default_default.compact;
  wrapperLodash_default.concat = array_default_default.concat;
  wrapperLodash_default.cond = util_default_default.cond;
  wrapperLodash_default.conforms = util_default_default.conforms;
  wrapperLodash_default.constant = util_default_default.constant;
  wrapperLodash_default.countBy = collection_default_default.countBy;
  wrapperLodash_default.create = object_default_default.create;
  wrapperLodash_default.curry = function_default_default.curry;
  wrapperLodash_default.curryRight = function_default_default.curryRight;
  wrapperLodash_default.debounce = function_default_default.debounce;
  wrapperLodash_default.defaults = object_default_default.defaults;
  wrapperLodash_default.defaultsDeep = object_default_default.defaultsDeep;
  wrapperLodash_default.defer = function_default_default.defer;
  wrapperLodash_default.delay = function_default_default.delay;
  wrapperLodash_default.difference = array_default_default.difference;
  wrapperLodash_default.differenceBy = array_default_default.differenceBy;
  wrapperLodash_default.differenceWith = array_default_default.differenceWith;
  wrapperLodash_default.drop = array_default_default.drop;
  wrapperLodash_default.dropRight = array_default_default.dropRight;
  wrapperLodash_default.dropRightWhile = array_default_default.dropRightWhile;
  wrapperLodash_default.dropWhile = array_default_default.dropWhile;
  wrapperLodash_default.fill = array_default_default.fill;
  wrapperLodash_default.filter = collection_default_default.filter;
  wrapperLodash_default.flatMap = collection_default_default.flatMap;
  wrapperLodash_default.flatMapDeep = collection_default_default.flatMapDeep;
  wrapperLodash_default.flatMapDepth = collection_default_default.flatMapDepth;
  wrapperLodash_default.flatten = array_default_default.flatten;
  wrapperLodash_default.flattenDeep = array_default_default.flattenDeep;
  wrapperLodash_default.flattenDepth = array_default_default.flattenDepth;
  wrapperLodash_default.flip = function_default_default.flip;
  wrapperLodash_default.flow = util_default_default.flow;
  wrapperLodash_default.flowRight = util_default_default.flowRight;
  wrapperLodash_default.fromPairs = array_default_default.fromPairs;
  wrapperLodash_default.functions = object_default_default.functions;
  wrapperLodash_default.functionsIn = object_default_default.functionsIn;
  wrapperLodash_default.groupBy = collection_default_default.groupBy;
  wrapperLodash_default.initial = array_default_default.initial;
  wrapperLodash_default.intersection = array_default_default.intersection;
  wrapperLodash_default.intersectionBy = array_default_default.intersectionBy;
  wrapperLodash_default.intersectionWith = array_default_default.intersectionWith;
  wrapperLodash_default.invert = object_default_default.invert;
  wrapperLodash_default.invertBy = object_default_default.invertBy;
  wrapperLodash_default.invokeMap = collection_default_default.invokeMap;
  wrapperLodash_default.iteratee = util_default_default.iteratee;
  wrapperLodash_default.keyBy = collection_default_default.keyBy;
  wrapperLodash_default.keys = keys_default;
  wrapperLodash_default.keysIn = object_default_default.keysIn;
  wrapperLodash_default.map = collection_default_default.map;
  wrapperLodash_default.mapKeys = object_default_default.mapKeys;
  wrapperLodash_default.mapValues = object_default_default.mapValues;
  wrapperLodash_default.matches = util_default_default.matches;
  wrapperLodash_default.matchesProperty = util_default_default.matchesProperty;
  wrapperLodash_default.memoize = function_default_default.memoize;
  wrapperLodash_default.merge = object_default_default.merge;
  wrapperLodash_default.mergeWith = object_default_default.mergeWith;
  wrapperLodash_default.method = util_default_default.method;
  wrapperLodash_default.methodOf = util_default_default.methodOf;
  wrapperLodash_default.mixin = mixin2;
  wrapperLodash_default.negate = negate_default;
  wrapperLodash_default.nthArg = util_default_default.nthArg;
  wrapperLodash_default.omit = object_default_default.omit;
  wrapperLodash_default.omitBy = object_default_default.omitBy;
  wrapperLodash_default.once = function_default_default.once;
  wrapperLodash_default.orderBy = collection_default_default.orderBy;
  wrapperLodash_default.over = util_default_default.over;
  wrapperLodash_default.overArgs = function_default_default.overArgs;
  wrapperLodash_default.overEvery = util_default_default.overEvery;
  wrapperLodash_default.overSome = util_default_default.overSome;
  wrapperLodash_default.partial = function_default_default.partial;
  wrapperLodash_default.partialRight = function_default_default.partialRight;
  wrapperLodash_default.partition = collection_default_default.partition;
  wrapperLodash_default.pick = object_default_default.pick;
  wrapperLodash_default.pickBy = object_default_default.pickBy;
  wrapperLodash_default.property = util_default_default.property;
  wrapperLodash_default.propertyOf = util_default_default.propertyOf;
  wrapperLodash_default.pull = array_default_default.pull;
  wrapperLodash_default.pullAll = array_default_default.pullAll;
  wrapperLodash_default.pullAllBy = array_default_default.pullAllBy;
  wrapperLodash_default.pullAllWith = array_default_default.pullAllWith;
  wrapperLodash_default.pullAt = array_default_default.pullAt;
  wrapperLodash_default.range = util_default_default.range;
  wrapperLodash_default.rangeRight = util_default_default.rangeRight;
  wrapperLodash_default.rearg = function_default_default.rearg;
  wrapperLodash_default.reject = collection_default_default.reject;
  wrapperLodash_default.remove = array_default_default.remove;
  wrapperLodash_default.rest = function_default_default.rest;
  wrapperLodash_default.reverse = array_default_default.reverse;
  wrapperLodash_default.sampleSize = collection_default_default.sampleSize;
  wrapperLodash_default.set = object_default_default.set;
  wrapperLodash_default.setWith = object_default_default.setWith;
  wrapperLodash_default.shuffle = collection_default_default.shuffle;
  wrapperLodash_default.slice = array_default_default.slice;
  wrapperLodash_default.sortBy = collection_default_default.sortBy;
  wrapperLodash_default.sortedUniq = array_default_default.sortedUniq;
  wrapperLodash_default.sortedUniqBy = array_default_default.sortedUniqBy;
  wrapperLodash_default.split = string_default_default.split;
  wrapperLodash_default.spread = function_default_default.spread;
  wrapperLodash_default.tail = array_default_default.tail;
  wrapperLodash_default.take = array_default_default.take;
  wrapperLodash_default.takeRight = array_default_default.takeRight;
  wrapperLodash_default.takeRightWhile = array_default_default.takeRightWhile;
  wrapperLodash_default.takeWhile = array_default_default.takeWhile;
  wrapperLodash_default.tap = seq_default_default.tap;
  wrapperLodash_default.throttle = function_default_default.throttle;
  wrapperLodash_default.thru = thru_default;
  wrapperLodash_default.toArray = lang_default_default.toArray;
  wrapperLodash_default.toPairs = object_default_default.toPairs;
  wrapperLodash_default.toPairsIn = object_default_default.toPairsIn;
  wrapperLodash_default.toPath = util_default_default.toPath;
  wrapperLodash_default.toPlainObject = lang_default_default.toPlainObject;
  wrapperLodash_default.transform = object_default_default.transform;
  wrapperLodash_default.unary = function_default_default.unary;
  wrapperLodash_default.union = array_default_default.union;
  wrapperLodash_default.unionBy = array_default_default.unionBy;
  wrapperLodash_default.unionWith = array_default_default.unionWith;
  wrapperLodash_default.uniq = array_default_default.uniq;
  wrapperLodash_default.uniqBy = array_default_default.uniqBy;
  wrapperLodash_default.uniqWith = array_default_default.uniqWith;
  wrapperLodash_default.unset = object_default_default.unset;
  wrapperLodash_default.unzip = array_default_default.unzip;
  wrapperLodash_default.unzipWith = array_default_default.unzipWith;
  wrapperLodash_default.update = object_default_default.update;
  wrapperLodash_default.updateWith = object_default_default.updateWith;
  wrapperLodash_default.values = object_default_default.values;
  wrapperLodash_default.valuesIn = object_default_default.valuesIn;
  wrapperLodash_default.without = array_default_default.without;
  wrapperLodash_default.words = string_default_default.words;
  wrapperLodash_default.wrap = function_default_default.wrap;
  wrapperLodash_default.xor = array_default_default.xor;
  wrapperLodash_default.xorBy = array_default_default.xorBy;
  wrapperLodash_default.xorWith = array_default_default.xorWith;
  wrapperLodash_default.zip = array_default_default.zip;
  wrapperLodash_default.zipObject = array_default_default.zipObject;
  wrapperLodash_default.zipObjectDeep = array_default_default.zipObjectDeep;
  wrapperLodash_default.zipWith = array_default_default.zipWith;
  wrapperLodash_default.entries = object_default_default.toPairs;
  wrapperLodash_default.entriesIn = object_default_default.toPairsIn;
  wrapperLodash_default.extend = object_default_default.assignIn;
  wrapperLodash_default.extendWith = object_default_default.assignInWith;
  mixin2(wrapperLodash_default, wrapperLodash_default);
  wrapperLodash_default.add = math_default_default.add;
  wrapperLodash_default.attempt = util_default_default.attempt;
  wrapperLodash_default.camelCase = string_default_default.camelCase;
  wrapperLodash_default.capitalize = string_default_default.capitalize;
  wrapperLodash_default.ceil = math_default_default.ceil;
  wrapperLodash_default.clamp = number_default_default.clamp;
  wrapperLodash_default.clone = lang_default_default.clone;
  wrapperLodash_default.cloneDeep = lang_default_default.cloneDeep;
  wrapperLodash_default.cloneDeepWith = lang_default_default.cloneDeepWith;
  wrapperLodash_default.cloneWith = lang_default_default.cloneWith;
  wrapperLodash_default.conformsTo = lang_default_default.conformsTo;
  wrapperLodash_default.deburr = string_default_default.deburr;
  wrapperLodash_default.defaultTo = util_default_default.defaultTo;
  wrapperLodash_default.divide = math_default_default.divide;
  wrapperLodash_default.endsWith = string_default_default.endsWith;
  wrapperLodash_default.eq = lang_default_default.eq;
  wrapperLodash_default.escape = string_default_default.escape;
  wrapperLodash_default.escapeRegExp = string_default_default.escapeRegExp;
  wrapperLodash_default.every = collection_default_default.every;
  wrapperLodash_default.find = collection_default_default.find;
  wrapperLodash_default.findIndex = array_default_default.findIndex;
  wrapperLodash_default.findKey = object_default_default.findKey;
  wrapperLodash_default.findLast = collection_default_default.findLast;
  wrapperLodash_default.findLastIndex = array_default_default.findLastIndex;
  wrapperLodash_default.findLastKey = object_default_default.findLastKey;
  wrapperLodash_default.floor = math_default_default.floor;
  wrapperLodash_default.forEach = collection_default_default.forEach;
  wrapperLodash_default.forEachRight = collection_default_default.forEachRight;
  wrapperLodash_default.forIn = object_default_default.forIn;
  wrapperLodash_default.forInRight = object_default_default.forInRight;
  wrapperLodash_default.forOwn = object_default_default.forOwn;
  wrapperLodash_default.forOwnRight = object_default_default.forOwnRight;
  wrapperLodash_default.get = object_default_default.get;
  wrapperLodash_default.gt = lang_default_default.gt;
  wrapperLodash_default.gte = lang_default_default.gte;
  wrapperLodash_default.has = object_default_default.has;
  wrapperLodash_default.hasIn = object_default_default.hasIn;
  wrapperLodash_default.head = array_default_default.head;
  wrapperLodash_default.identity = identity_default;
  wrapperLodash_default.includes = collection_default_default.includes;
  wrapperLodash_default.indexOf = array_default_default.indexOf;
  wrapperLodash_default.inRange = number_default_default.inRange;
  wrapperLodash_default.invoke = object_default_default.invoke;
  wrapperLodash_default.isArguments = lang_default_default.isArguments;
  wrapperLodash_default.isArray = isArray_default;
  wrapperLodash_default.isArrayBuffer = lang_default_default.isArrayBuffer;
  wrapperLodash_default.isArrayLike = lang_default_default.isArrayLike;
  wrapperLodash_default.isArrayLikeObject = lang_default_default.isArrayLikeObject;
  wrapperLodash_default.isBoolean = lang_default_default.isBoolean;
  wrapperLodash_default.isBuffer = lang_default_default.isBuffer;
  wrapperLodash_default.isDate = lang_default_default.isDate;
  wrapperLodash_default.isElement = lang_default_default.isElement;
  wrapperLodash_default.isEmpty = lang_default_default.isEmpty;
  wrapperLodash_default.isEqual = lang_default_default.isEqual;
  wrapperLodash_default.isEqualWith = lang_default_default.isEqualWith;
  wrapperLodash_default.isError = lang_default_default.isError;
  wrapperLodash_default.isFinite = lang_default_default.isFinite;
  wrapperLodash_default.isFunction = lang_default_default.isFunction;
  wrapperLodash_default.isInteger = lang_default_default.isInteger;
  wrapperLodash_default.isLength = lang_default_default.isLength;
  wrapperLodash_default.isMap = lang_default_default.isMap;
  wrapperLodash_default.isMatch = lang_default_default.isMatch;
  wrapperLodash_default.isMatchWith = lang_default_default.isMatchWith;
  wrapperLodash_default.isNaN = lang_default_default.isNaN;
  wrapperLodash_default.isNative = lang_default_default.isNative;
  wrapperLodash_default.isNil = lang_default_default.isNil;
  wrapperLodash_default.isNull = lang_default_default.isNull;
  wrapperLodash_default.isNumber = lang_default_default.isNumber;
  wrapperLodash_default.isObject = isObject_default;
  wrapperLodash_default.isObjectLike = lang_default_default.isObjectLike;
  wrapperLodash_default.isPlainObject = lang_default_default.isPlainObject;
  wrapperLodash_default.isRegExp = lang_default_default.isRegExp;
  wrapperLodash_default.isSafeInteger = lang_default_default.isSafeInteger;
  wrapperLodash_default.isSet = lang_default_default.isSet;
  wrapperLodash_default.isString = lang_default_default.isString;
  wrapperLodash_default.isSymbol = lang_default_default.isSymbol;
  wrapperLodash_default.isTypedArray = lang_default_default.isTypedArray;
  wrapperLodash_default.isUndefined = lang_default_default.isUndefined;
  wrapperLodash_default.isWeakMap = lang_default_default.isWeakMap;
  wrapperLodash_default.isWeakSet = lang_default_default.isWeakSet;
  wrapperLodash_default.join = array_default_default.join;
  wrapperLodash_default.kebabCase = string_default_default.kebabCase;
  wrapperLodash_default.last = last_default;
  wrapperLodash_default.lastIndexOf = array_default_default.lastIndexOf;
  wrapperLodash_default.lowerCase = string_default_default.lowerCase;
  wrapperLodash_default.lowerFirst = string_default_default.lowerFirst;
  wrapperLodash_default.lt = lang_default_default.lt;
  wrapperLodash_default.lte = lang_default_default.lte;
  wrapperLodash_default.max = math_default_default.max;
  wrapperLodash_default.maxBy = math_default_default.maxBy;
  wrapperLodash_default.mean = math_default_default.mean;
  wrapperLodash_default.meanBy = math_default_default.meanBy;
  wrapperLodash_default.min = math_default_default.min;
  wrapperLodash_default.minBy = math_default_default.minBy;
  wrapperLodash_default.stubArray = util_default_default.stubArray;
  wrapperLodash_default.stubFalse = util_default_default.stubFalse;
  wrapperLodash_default.stubObject = util_default_default.stubObject;
  wrapperLodash_default.stubString = util_default_default.stubString;
  wrapperLodash_default.stubTrue = util_default_default.stubTrue;
  wrapperLodash_default.multiply = math_default_default.multiply;
  wrapperLodash_default.nth = array_default_default.nth;
  wrapperLodash_default.noop = util_default_default.noop;
  wrapperLodash_default.now = date_default_default.now;
  wrapperLodash_default.pad = string_default_default.pad;
  wrapperLodash_default.padEnd = string_default_default.padEnd;
  wrapperLodash_default.padStart = string_default_default.padStart;
  wrapperLodash_default.parseInt = string_default_default.parseInt;
  wrapperLodash_default.random = number_default_default.random;
  wrapperLodash_default.reduce = collection_default_default.reduce;
  wrapperLodash_default.reduceRight = collection_default_default.reduceRight;
  wrapperLodash_default.repeat = string_default_default.repeat;
  wrapperLodash_default.replace = string_default_default.replace;
  wrapperLodash_default.result = object_default_default.result;
  wrapperLodash_default.round = math_default_default.round;
  wrapperLodash_default.sample = collection_default_default.sample;
  wrapperLodash_default.size = collection_default_default.size;
  wrapperLodash_default.snakeCase = string_default_default.snakeCase;
  wrapperLodash_default.some = collection_default_default.some;
  wrapperLodash_default.sortedIndex = array_default_default.sortedIndex;
  wrapperLodash_default.sortedIndexBy = array_default_default.sortedIndexBy;
  wrapperLodash_default.sortedIndexOf = array_default_default.sortedIndexOf;
  wrapperLodash_default.sortedLastIndex = array_default_default.sortedLastIndex;
  wrapperLodash_default.sortedLastIndexBy = array_default_default.sortedLastIndexBy;
  wrapperLodash_default.sortedLastIndexOf = array_default_default.sortedLastIndexOf;
  wrapperLodash_default.startCase = string_default_default.startCase;
  wrapperLodash_default.startsWith = string_default_default.startsWith;
  wrapperLodash_default.subtract = math_default_default.subtract;
  wrapperLodash_default.sum = math_default_default.sum;
  wrapperLodash_default.sumBy = math_default_default.sumBy;
  wrapperLodash_default.template = string_default_default.template;
  wrapperLodash_default.times = util_default_default.times;
  wrapperLodash_default.toFinite = lang_default_default.toFinite;
  wrapperLodash_default.toInteger = toInteger_default;
  wrapperLodash_default.toLength = lang_default_default.toLength;
  wrapperLodash_default.toLower = string_default_default.toLower;
  wrapperLodash_default.toNumber = lang_default_default.toNumber;
  wrapperLodash_default.toSafeInteger = lang_default_default.toSafeInteger;
  wrapperLodash_default.toString = lang_default_default.toString;
  wrapperLodash_default.toUpper = string_default_default.toUpper;
  wrapperLodash_default.trim = string_default_default.trim;
  wrapperLodash_default.trimEnd = string_default_default.trimEnd;
  wrapperLodash_default.trimStart = string_default_default.trimStart;
  wrapperLodash_default.truncate = string_default_default.truncate;
  wrapperLodash_default.unescape = string_default_default.unescape;
  wrapperLodash_default.uniqueId = util_default_default.uniqueId;
  wrapperLodash_default.upperCase = string_default_default.upperCase;
  wrapperLodash_default.upperFirst = string_default_default.upperFirst;
  wrapperLodash_default.each = collection_default_default.forEach;
  wrapperLodash_default.eachRight = collection_default_default.forEachRight;
  wrapperLodash_default.first = array_default_default.head;
  mixin2(wrapperLodash_default, function() {
    var source = {};
    baseForOwn_default(wrapperLodash_default, function(func, methodName) {
      if (!hasOwnProperty25.call(wrapperLodash_default.prototype, methodName)) {
        source[methodName] = func;
      }
    });
    return source;
  }(), { "chain": false });
  wrapperLodash_default.VERSION = VERSION;
  (wrapperLodash_default.templateSettings = string_default_default.templateSettings).imports._ = wrapperLodash_default;
  arrayEach_default(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
    wrapperLodash_default[methodName].placeholder = wrapperLodash_default;
  });
  arrayEach_default(["drop", "take"], function(methodName, index) {
    LazyWrapper_default.prototype[methodName] = function(n) {
      n = n === void 0 ? 1 : nativeMax17(toInteger_default(n), 0);
      var result2 = this.__filtered__ && !index ? new LazyWrapper_default(this) : this.clone();
      if (result2.__filtered__) {
        result2.__takeCount__ = nativeMin15(n, result2.__takeCount__);
      } else {
        result2.__views__.push({
          "size": nativeMin15(n, MAX_ARRAY_LENGTH7),
          "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
        });
      }
      return result2;
    };
    LazyWrapper_default.prototype[methodName + "Right"] = function(n) {
      return this.reverse()[methodName](n).reverse();
    };
  });
  arrayEach_default(["filter", "map", "takeWhile"], function(methodName, index) {
    var type = index + 1, isFilter = type == LAZY_FILTER_FLAG2 || type == LAZY_WHILE_FLAG;
    LazyWrapper_default.prototype[methodName] = function(iteratee2) {
      var result2 = this.clone();
      result2.__iteratees__.push({
        "iteratee": baseIteratee_default(iteratee2, 3),
        "type": type
      });
      result2.__filtered__ = result2.__filtered__ || isFilter;
      return result2;
    };
  });
  arrayEach_default(["head", "last"], function(methodName, index) {
    var takeName = "take" + (index ? "Right" : "");
    LazyWrapper_default.prototype[methodName] = function() {
      return this[takeName](1).value()[0];
    };
  });
  arrayEach_default(["initial", "tail"], function(methodName, index) {
    var dropName = "drop" + (index ? "" : "Right");
    LazyWrapper_default.prototype[methodName] = function() {
      return this.__filtered__ ? new LazyWrapper_default(this) : this[dropName](1);
    };
  });
  LazyWrapper_default.prototype.compact = function() {
    return this.filter(identity_default);
  };
  LazyWrapper_default.prototype.find = function(predicate) {
    return this.filter(predicate).head();
  };
  LazyWrapper_default.prototype.findLast = function(predicate) {
    return this.reverse().find(predicate);
  };
  LazyWrapper_default.prototype.invokeMap = baseRest_default(function(path, args) {
    if (typeof path == "function") {
      return new LazyWrapper_default(this);
    }
    return this.map(function(value) {
      return baseInvoke_default(value, path, args);
    });
  });
  LazyWrapper_default.prototype.reject = function(predicate) {
    return this.filter(negate_default(baseIteratee_default(predicate)));
  };
  LazyWrapper_default.prototype.slice = function(start, end) {
    start = toInteger_default(start);
    var result2 = this;
    if (result2.__filtered__ && (start > 0 || end < 0)) {
      return new LazyWrapper_default(result2);
    }
    if (start < 0) {
      result2 = result2.takeRight(-start);
    } else if (start) {
      result2 = result2.drop(start);
    }
    if (end !== void 0) {
      end = toInteger_default(end);
      result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
    }
    return result2;
  };
  LazyWrapper_default.prototype.takeRightWhile = function(predicate) {
    return this.reverse().takeWhile(predicate).reverse();
  };
  LazyWrapper_default.prototype.toArray = function() {
    return this.take(MAX_ARRAY_LENGTH7);
  };
  baseForOwn_default(LazyWrapper_default.prototype, function(func, methodName) {
    var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = wrapperLodash_default[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
    if (!lodashFunc) {
      return;
    }
    wrapperLodash_default.prototype[methodName] = function() {
      var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper_default, iteratee2 = args[0], useLazy = isLazy || isArray_default(value);
      var interceptor = function(value2) {
        var result3 = lodashFunc.apply(wrapperLodash_default, arrayPush_default([value2], args));
        return isTaker && chainAll ? result3[0] : result3;
      };
      if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
        isLazy = useLazy = false;
      }
      var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
      if (!retUnwrapped && useLazy) {
        value = onlyLazy ? value : new LazyWrapper_default(this);
        var result2 = func.apply(value, args);
        result2.__actions__.push({ "func": thru_default, "args": [interceptor], "thisArg": void 0 });
        return new LodashWrapper_default(result2, chainAll);
      }
      if (isUnwrapped && onlyLazy) {
        return func.apply(this, args);
      }
      result2 = this.thru(interceptor);
      return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
    };
  });
  arrayEach_default(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
    var func = arrayProto6[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
    wrapperLodash_default.prototype[methodName] = function() {
      var args = arguments;
      if (retUnwrapped && !this.__chain__) {
        var value = this.value();
        return func.apply(isArray_default(value) ? value : [], args);
      }
      return this[chainName](function(value2) {
        return func.apply(isArray_default(value2) ? value2 : [], args);
      });
    };
  });
  baseForOwn_default(LazyWrapper_default.prototype, function(func, methodName) {
    var lodashFunc = wrapperLodash_default[methodName];
    if (lodashFunc) {
      var key = lodashFunc.name + "";
      if (!hasOwnProperty25.call(realNames_default, key)) {
        realNames_default[key] = [];
      }
      realNames_default[key].push({ "name": methodName, "func": lodashFunc });
    }
  });
  realNames_default[createHybrid_default(void 0, WRAP_BIND_KEY_FLAG7).name] = [{
    "name": "wrapper",
    "func": void 0
  }];
  LazyWrapper_default.prototype.clone = lazyClone_default;
  LazyWrapper_default.prototype.reverse = lazyReverse_default;
  LazyWrapper_default.prototype.value = lazyValue_default;
  wrapperLodash_default.prototype.at = seq_default_default.at;
  wrapperLodash_default.prototype.chain = seq_default_default.wrapperChain;
  wrapperLodash_default.prototype.commit = seq_default_default.commit;
  wrapperLodash_default.prototype.next = seq_default_default.next;
  wrapperLodash_default.prototype.plant = seq_default_default.plant;
  wrapperLodash_default.prototype.reverse = seq_default_default.reverse;
  wrapperLodash_default.prototype.toJSON = wrapperLodash_default.prototype.valueOf = wrapperLodash_default.prototype.value = seq_default_default.value;
  wrapperLodash_default.prototype.first = wrapperLodash_default.prototype.head;
  if (symIterator2) {
    wrapperLodash_default.prototype[symIterator2] = seq_default_default.toIterator;
  }
  var lodash_default_default = wrapperLodash_default;

  // ../../packages/types/src/index.ts
  init_define_process();

  // ../../node_modules/@alilc/lowcode-datasource-types/es/index.js
  init_define_process();

  // ../../node_modules/@alilc/lowcode-datasource-types/es/data-source.js
  init_define_process();
  var RuntimeDataSourceStatus;
  (function(RuntimeDataSourceStatus2) {
    RuntimeDataSourceStatus2["Initial"] = "init";
    RuntimeDataSourceStatus2["Loading"] = "loading";
    RuntimeDataSourceStatus2["Loaded"] = "loaded";
    RuntimeDataSourceStatus2["Error"] = "error";
  })(RuntimeDataSourceStatus || (RuntimeDataSourceStatus = {}));

  // ../../node_modules/@alilc/lowcode-datasource-types/es/data-source-handlers.js
  init_define_process();

  // ../../node_modules/@alilc/lowcode-datasource-types/es/data-source-interpret.js
  init_define_process();

  // ../../node_modules/@alilc/lowcode-datasource-types/es/data-source-runtime.js
  init_define_process();

  // ../../packages/types/src/editor.ts
  init_define_process();

  // ../../packages/types/src/field-config.ts
  init_define_process();

  // ../../packages/types/src/i18n.ts
  init_define_process();

  // ../../packages/types/src/icon.ts
  init_define_process();

  // ../../packages/types/src/metadata.ts
  init_define_process();

  // ../../packages/types/src/npm.ts
  init_define_process();

  // ../../packages/types/src/prop-config.ts
  init_define_process();

  // ../../packages/types/src/schema.ts
  init_define_process();
  function isDOMText(data) {
    return typeof data === "string";
  }
  function isNodeSchema(data) {
    return data && data.componentName;
  }

  // ../../packages/types/src/activity.ts
  init_define_process();

  // ../../packages/types/src/tip.ts
  init_define_process();

  // ../../packages/types/src/title.ts
  init_define_process();

  // ../../packages/types/src/utils.ts
  init_define_process();

  // ../../packages/types/src/value-type.ts
  init_define_process();
  function isJSExpression(data) {
    return data && data.type === "JSExpression";
  }
  function isJSFunction(x) {
    return typeof x === "object" && x && x.type === "JSFunction";
  }
  function isJSSlot(data) {
    return data && data.type === "JSSlot";
  }

  // ignore:./setter-config
  init_define_process();

  // ../../packages/types/src/setting-target.ts
  init_define_process();

  // ../../packages/types/src/node.ts
  init_define_process();

  // ../../packages/types/src/transform-stage.ts
  init_define_process();

  // ../../packages/types/src/code-intermediate.ts
  init_define_process();

  // ../../packages/types/src/code-result.ts
  init_define_process();

  // ../../packages/types/src/assets.ts
  init_define_process();

  // ../../packages/types/src/event/index.ts
  var event_exports = {};
  __export(event_exports, {
    Node: () => node_exports
  });
  init_define_process();

  // ../../packages/types/src/event/node.ts
  var node_exports = {};
  __export(node_exports, {
    Prop: () => prop_exports,
    Rerender: () => Rerender
  });
  init_define_process();

  // ../../packages/types/src/event/prop.ts
  var prop_exports = {};
  __export(prop_exports, {
    Change: () => Change,
    InnerChange: () => InnerChange
  });
  init_define_process();
  var Change = "node.prop.change";
  var InnerChange = "node.innerProp.change";

  // ../../packages/types/src/event/node.ts
  var Rerender = "node.edit.rerender.time";

  // ../../packages/types/src/disposable.ts
  init_define_process();

  // ../../packages/types/src/start-transaction.ts
  init_define_process();

  // src/utils/schema.ts
  function isContainerSchema(x) {
    return typeof x === "object" && x && typeof x.componentName === "string" && typeof x.fileName === "string";
  }
  function isNpmInfo(x) {
    return typeof x === "object" && x && typeof x.package === "string";
  }
  var noop2 = () => void 0;
  var handleChildrenDefaultOptions = {
    rerun: false
  };
  var DEFAULT_MAX_DEPTH = 1e5;
  function handleSubNodes(children, handlers, options) {
    var _a;
    const opt = {
      ...handleChildrenDefaultOptions,
      ...options || {}
    };
    const maxDepth = (_a = opt.maxDepth) != null ? _a : DEFAULT_MAX_DEPTH;
    if (maxDepth <= 0) {
      throw new Error("handleSubNodes maxDepth reached");
    }
    if (Array.isArray(children)) {
      const list = children;
      return list.map((child) => handleSubNodes(child, handlers, { ...opt, maxDepth: maxDepth - 1 })).reduce((p, c) => p.concat(c), []);
    }
    let result2;
    const childrenRes = [];
    if (children === null || children === void 0) {
      return [];
    } else if (isDOMText(children)) {
      const handler = handlers.string || noop2;
      result2 = handler(children);
    } else if (isJSExpression(children)) {
      const handler = handlers.expression || noop2;
      result2 = handler(children);
    } else if (isJSSlot(children)) {
      return handleSubNodes(children.value, handlers, { ...opt, maxDepth: maxDepth - 1 });
    } else if (isNodeSchema(children)) {
      const handler = handlers.node || noop2;
      const child = children;
      result2 = handler(child);
      if (child.children) {
        const childRes = handleSubNodes(child.children, handlers, opt);
        childrenRes.push(...childRes);
      }
      if (child.props) {
        if (Array.isArray(child.props)) {
          child.props.forEach(({ value }) => {
            const childRes = handleCompositeValueInProps(value);
            childrenRes.push(...childRes);
          });
        } else {
          Object.values(child.props).forEach((value) => {
            const childRes = handleCompositeValueInProps(value);
            childrenRes.push(...childRes);
          });
        }
      }
    } else {
      throw new CodeGeneratorError("handleSubNodes got invalid NodeData", children);
    }
    if (result2 !== void 0) {
      childrenRes.unshift(result2);
    }
    return childrenRes;
    function handleCompositeValueInProps(value) {
      if (isJSSlot(value)) {
        return handleSubNodes(value.value, handlers, { ...opt, maxDepth: maxDepth - 1 });
      }
      if (Array.isArray(value)) {
        return flatMap_default(value, (v) => handleCompositeValueInProps(v));
      }
      if (!isJSExpression(value) && !isJSFunction(value) && typeof value === "object" && value !== null) {
        return flatMap_default(Object.values(value), (v) => handleCompositeValueInProps(v));
      }
      return [];
    }
  }

  // src/utils/common.ts
  var common_exports = {};
  __export(common_exports, {
    camel2dash: () => camel2dash,
    camelize: () => camelize,
    generateID: () => generateID,
    getStaticExprValue: () => getStaticExprValue,
    uniqueArray: () => uniqueArray,
    upperCaseFirst: () => upperCaseFirst
  });
  init_define_process();
  var import_change_case = __toESM(require_change_case());
  var import_short_uuid = __toESM(require_short_uuid());
  function camel2dash(input) {
    return import_change_case.default.paramCase(input);
  }
  function camelize(str) {
    return import_change_case.default.camelCase(str);
  }
  function generateID() {
    return import_short_uuid.default.generate();
  }
  function upperCaseFirst(inputValue) {
    return import_change_case.default.upperCaseFirst(inputValue);
  }
  function uniqueArray(arr, by) {
    const map2 = {};
    arr.forEach((item) => {
      map2[by(item)] = item;
    });
    const uniqueKeys = Array.from(new Set(Object.keys(map2)));
    const uniqueItems = uniqueKeys.map((key) => map2[key]);
    return uniqueItems;
  }
  function getStaticExprValue(expr) {
    return Function(`"use strict";return (${expr})`)();
  }

  // src/analyzer/componentAnalyzer.ts
  init_define_process();
  var componentAnalyzer = (container) => {
    let hasRefAttr = false;
    const nodeValidator = (n) => {
      if (n.props) {
        const props = n.props;
        if (props.ref) {
          hasRefAttr = true;
        }
      }
    };
    nodeValidator(container);
    if (!hasRefAttr && container.children) {
      handleSubNodes(
        container.children,
        {
          node: nodeValidator
        },
        {
          rerun: true
        }
      );
    }
    return {
      isUsingRef: hasRefAttr
    };
  };

  // src/utils/validate.ts
  var validate_exports = {};
  __export(validate_exports, {
    ensureValidClassName: () => ensureValidClassName,
    isValidIdentifier: () => isValidIdentifier
  });
  init_define_process();
  var isValidIdentifier = (name) => {
    return /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/.test(name);
  };
  var ensureValidClassName = (name) => {
    if (!isValidIdentifier(name)) {
      return `$${name.replace(/[^_$a-zA-Z0-9]/g, "")}`;
    }
    return name;
  };

  // src/parser/SchemaParser.ts
  var defaultContainer = {
    containerType: "Component",
    componentName: "Component",
    moduleName: "Index",
    fileName: "Index",
    css: "",
    props: {}
  };
  function getRootComponentName(typeName, maps) {
    if (maps[typeName]) {
      const rec = maps[typeName];
      if (rec.destructuring) {
        return rec.componentName || typeName;
      }
      const peerName = Object.keys(maps).find((depName) => {
        const depInfo = maps[depName];
        return depName !== typeName && !depInfo.destructuring && depInfo.package === rec.package && depInfo.version === rec.version && depInfo.main === rec.main && depInfo.exportName === rec.exportName && depInfo.subName === rec.subName;
      });
      return peerName || typeName;
    }
    return typeName;
  }
  function processChildren(schema) {
    if (schema.props) {
      if (Array.isArray(schema.props)) {
      } else {
        const nodeProps = schema.props;
        if (nodeProps.children) {
          if (!schema.children) {
            schema.children = nodeProps.children;
          } else {
            let _children = [];
            if (Array.isArray(schema.children)) {
              _children = _children.concat(schema.children);
            } else {
              _children.push(schema.children);
            }
            if (Array.isArray(nodeProps.children)) {
              _children = _children.concat(nodeProps.children);
            } else {
              _children.push(nodeProps.children);
            }
            schema.children = _children;
          }
          delete nodeProps.children;
        }
      }
    }
  }
  var SchemaParser = class {
    validate(schema) {
      if (SUPPORT_SCHEMA_VERSION_LIST.indexOf(schema.version) < 0) {
        throw new CompatibilityError(`Not support schema with version [${schema.version}]`);
      }
      return true;
    }
    parse(schemaSrc) {
      const compDeps = {};
      const internalDeps = {};
      let utilsDeps = [];
      const schema = this.decodeSchema(schemaSrc);
      schema.componentsMap.forEach((info) => {
        var _a, _b;
        if (info.componentName) {
          compDeps[info.componentName] = {
            ...info,
            dependencyType: "External" /* External */,
            componentName: info.componentName,
            exportName: (_a = info.exportName) != null ? _a : info.componentName,
            version: info.version || "*",
            destructuring: (_b = info.destructuring) != null ? _b : false
          };
        }
      });
      let containers;
      if (schema.componentsTree.length > 0) {
        const firstRoot = schema.componentsTree[0];
        if (!("fileName" in firstRoot) || !firstRoot.fileName) {
          const container = {
            ...firstRoot,
            ...defaultContainer,
            props: firstRoot.props || defaultContainer.props,
            css: firstRoot.css || defaultContainer.css,
            moduleName: firstRoot.moduleName || defaultContainer.moduleName,
            children: schema.componentsTree
          };
          containers = [container];
        } else {
          containers = schema.componentsTree.map((n) => {
            const subRoot = n;
            const container = {
              ...subRoot,
              componentName: getRootComponentName(subRoot.componentName, compDeps),
              containerType: subRoot.componentName,
              moduleName: ensureValidClassName(import_change_case2.default.pascalCase(subRoot.fileName))
            };
            return container;
          });
        }
      } else {
        throw new CodeGeneratorError("Can't find anything to generate.");
      }
      containers = containers.map((con) => ({
        ...con,
        analyzeResult: componentAnalyzer(con)
      }));
      containers.forEach((container) => {
        let type;
        switch (container.containerType) {
          case "Page":
            type = "pages" /* PAGE */;
            break;
          case "Block":
            type = "components" /* BLOCK */;
            break;
          default:
            type = "components" /* COMPONENT */;
            break;
        }
        const dep = {
          type,
          moduleName: container.moduleName,
          destructuring: false,
          exportName: container.moduleName,
          dependencyType: "Internal" /* Internal */
        };
        internalDeps[dep.moduleName] = dep;
      });
      const containersDeps = [].concat(...containers.map((c) => c.deps || []));
      containers.forEach((container) => {
        if (container.children) {
          handleSubNodes(
            container.children,
            {
              node: (i) => processChildren(i)
            },
            {
              rerun: true
            }
          );
        }
      });
      containers.forEach((container) => {
        const depNames = this.getComponentNames(container);
        container.deps = uniqueArray(depNames, (i) => i).map((depName) => internalDeps[depName] || compDeps[depName]).filter(Boolean);
      });
      const routes = containers.filter((container) => container.containerType === "Page").map((page) => {
        const { meta } = page;
        if (meta) {
          return {
            path: meta.router || `/${page.fileName}`,
            fileName: page.fileName,
            componentName: page.moduleName
          };
        }
        return {
          path: "",
          fileName: page.fileName,
          componentName: page.moduleName
        };
      });
      const routerDeps = routes.map((r) => internalDeps[r.componentName] || compDeps[r.componentName]).filter((dep) => !!dep);
      let utils;
      if (schema.utils) {
        utils = schema.utils;
        utilsDeps = schema.utils.filter(
          (u) => u.type !== "function"
        ).map(
          (u) => {
            var _a, _b;
            return {
              ...u.content,
              componentName: u.name,
              version: u.content.version || "*",
              destructuring: (_a = u.content.destructuring) != null ? _a : false,
              exportName: (_b = u.content.exportName) != null ? _b : u.name
            };
          }
        );
      } else {
        utils = [];
      }
      let npms = [];
      containers.forEach((con) => {
        const p = (con.deps || []).map((dep) => {
          return dep.dependencyType === "External" /* External */ ? dep : null;
        }).filter((dep) => dep !== null);
        const npmInfos = p.filter(Boolean).map((i) => ({
          package: i.package,
          version: i.version
        }));
        npms.push(...npmInfos);
      });
      npms.push(
        ...utilsDeps.map((utilsDep) => ({
          package: utilsDep.package,
          version: utilsDep.version
        }))
      );
      npms = uniqueArray(npms, (i) => i.package).filter(Boolean);
      return {
        containers,
        globalUtils: {
          utils,
          deps: utilsDeps
        },
        globalI18n: schema.i18n,
        globalRouter: {
          routes,
          deps: routerDeps
        },
        project: {
          css: schema.css,
          constants: schema.constants,
          config: schema.config || {},
          meta: schema.meta || {},
          i18n: schema.i18n,
          containersDeps,
          utilsDeps,
          packages: npms || [],
          dataSourcesTypes: this.collectDataSourcesTypes(schema)
        }
      };
    }
    getComponentNames(children) {
      return handleSubNodes(
        children,
        {
          node: (i) => i.componentName
        },
        {
          rerun: true
        }
      );
    }
    decodeSchema(schemaSrc) {
      let schema;
      if (typeof schemaSrc === "string") {
        try {
          schema = JSON.parse(schemaSrc);
        } catch (error) {
          throw new CodeGeneratorError(
            `Parse schema failed: ${getErrorMessage(error) || "unknown reason"}`
          );
        }
      } else {
        schema = schemaSrc;
      }
      return schema;
    }
    collectDataSourcesTypes(schema) {
      var _a, _b;
      const dataSourcesTypes = /* @__PURE__ */ new Set();
      const defaultDataSourceType = "fetch";
      (_b = (_a = schema.dataSource) == null ? void 0 : _a.list) == null ? void 0 : _b.forEach((ds) => {
        dataSourcesTypes.add(ds.type || defaultDataSourceType);
      });
      schema.componentsTree.forEach((rootNode) => {
        var _a2, _b2;
        (_b2 = (_a2 = rootNode.dataSource) == null ? void 0 : _a2.list) == null ? void 0 : _b2.forEach((ds) => {
          dataSourcesTypes.add(ds.type || defaultDataSourceType);
        });
      });
      return Array.from(dataSourcesTypes.values());
    }
  };

  // src/utils/resultHelper.ts
  var resultHelper_exports = {};
  __export(resultHelper_exports, {
    addDirectory: () => addDirectory,
    addFile: () => addFile,
    createResultDir: () => createResultDir,
    createResultFile: () => createResultFile,
    findDir: () => findDir,
    findFile: () => findFile,
    flattenResult: () => flattenResult,
    getFileNameWithExt: () => getFileNameWithExt,
    globDirs: () => globDirs,
    globFiles: () => globFiles,
    removeDirsFromResult: () => removeDirsFromResult,
    removeFilesFromResult: () => removeFilesFromResult,
    scanDirs: () => scanDirs,
    scanFiles: () => scanFiles
  });
  init_define_process();
  var import_nanomatch = __toESM(require_nanomatch());
  function createResultFile(name, ext = "jsx", content = "") {
    return {
      name,
      ext,
      content
    };
  }
  function createResultDir(name) {
    return {
      name,
      dirs: [],
      files: []
    };
  }
  function addDirectory(target, dir) {
    if (target.dirs.findIndex((d) => d.name === dir.name) < 0) {
      target.dirs.push(dir);
    } else {
      throw new CodeGeneratorError(
        `Adding same directory to one directory: ${dir.name} -> ${target.name}`
      );
    }
  }
  function addFile(target, file2) {
    if (target.files.findIndex((f) => f.name === file2.name && f.ext === file2.ext) < 0) {
      target.files.push(file2);
    } else {
      throw new CodeGeneratorError(
        `Adding same file to one directory: ${file2.name} -> ${target.name}`
      );
    }
  }
  function flattenResult(dir, cwd = "") {
    if (!dir.files.length && !dir.dirs.length) {
      return [];
    }
    return [
      ...dir.files.map(
        (file2) => ({
          pathName: joinPath(cwd, `${file2.name}${file2.ext ? `.${file2.ext}` : ""}`),
          content: file2.content
        })
      )
    ].concat(...dir.dirs.map((subDir) => flattenResult(subDir, joinPath(cwd, subDir.name))));
  }
  function findFile(result2, fileGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const maxDepth = !/\/|\*\*/.test(fileGlobExpr) ? 1 : void 0;
    const files = scanFiles(result2, resultDirPath, maxDepth);
    for (let [filePath, file2] of files) {
      if (import_nanomatch.default.isMatch(filePath, fileGlobExpr, options)) {
        return file2;
      }
    }
    return null;
  }
  function* globFiles(result2, fileGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const files = scanFiles(result2, resultDirPath);
    for (let [filePath, file2] of files) {
      if (import_nanomatch.default.isMatch(filePath, fileGlobExpr, options)) {
        yield [filePath, file2];
      }
    }
  }
  function* scanFiles(result2, resultDirPath = getResultNameOrDefault(result2, ""), maxDepth = 1e4) {
    for (let file2 of result2.files) {
      const fileName = getFileNameWithExt(file2);
      yield [joinPath(resultDirPath, fileName), file2];
    }
    for (let subDir of result2.dirs) {
      yield* scanFiles(subDir, joinPath(resultDirPath, subDir.name), maxDepth - 1);
    }
  }
  function getFileNameWithExt(file2) {
    return `${file2.name}${file2.ext ? `.${file2.ext}` : ""}`;
  }
  function getResultNameOrDefault(result2, defaultDir = "/") {
    return result2.name && result2.name !== "." ? result2.name : defaultDir;
  }
  function joinPath(...pathParts) {
    return pathParts.filter((x) => x !== "" && x !== ".").join("/").replace(/\\+/g, "/").replace(/\/+/g, "/");
  }
  function* scanDirs(result2, resultDirPath = getResultNameOrDefault(result2, ""), maxDepth = 1e4) {
    yield [resultDirPath, result2];
    for (let subDir of result2.dirs) {
      yield* scanDirs(subDir, joinPath(resultDirPath, subDir.name), maxDepth - 1);
    }
  }
  function* globDirs(result2, dirGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const dirs = scanDirs(result2, resultDirPath);
    for (let [dirPath, dir] of dirs) {
      if (import_nanomatch.default.isMatch(dirPath, dirGlobExpr, options)) {
        yield [dirPath, dir];
      }
    }
  }
  function findDir(result2, dirGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const dirs = scanDirs(result2, resultDirPath);
    for (let [dirPath, dir] of dirs) {
      if (import_nanomatch.default.isMatch(dirPath, dirGlobExpr, options)) {
        return dir;
      }
    }
    return null;
  }
  function removeFilesFromResult(result2, filePathGlobExpr, globOptions = {}) {
    let removedCount = 0;
    const [dirPath, fileName] = splitPath(filePathGlobExpr);
    const dirs = dirPath ? globDirs(result2, dirPath) : [["", result2]];
    for (let [, dir] of dirs) {
      const files = globFiles(dir, fileName, globOptions, ".");
      for (let [, file2] of files) {
        dir.files.splice(dir.files.indexOf(file2), 1);
        removedCount += 1;
      }
    }
    return removedCount;
  }
  function removeDirsFromResult(result2, dirPathGlobExpr, globOptions = {}) {
    let removedCount = 0;
    const [dirPath, fileName] = splitPath(dirPathGlobExpr);
    const dirs = dirPath ? globDirs(result2, dirPath) : [["", result2]];
    for (let [, dir] of dirs) {
      const foundDirs = globDirs(dir, fileName, globOptions, ".");
      for (let [, foundDir] of foundDirs) {
        dir.dirs.splice(dir.dirs.indexOf(foundDir), 1);
        removedCount += 1;
      }
    }
    return removedCount;
  }
  function splitPath(filePath) {
    const parts = filePath.split("/");
    const fileName = parts.pop() || "";
    return [joinPath(...parts), fileName];
  }

  // src/generator/ModuleBuilder.ts
  init_define_process();

  // src/generator/ChunkBuilder.ts
  init_define_process();
  function whichFamily(type) {
    const idx = FILE_TYPE_FAMILY.findIndex((family) => family.indexOf(type) >= 0);
    if (idx < 0) {
      return void 0;
    }
    return [idx, FILE_TYPE_FAMILY[idx]];
  }
  var groupChunks = (chunks) => {
    const tmp = {};
    const col = chunks.reduce((chunksSet, chunk2) => {
      const fileKey = chunk2.subModule || COMMON_SUB_MODULE_NAME;
      if (!chunksSet[fileKey]) {
        chunksSet[fileKey] = [];
      }
      const res = whichFamily(chunk2.fileType);
      const info = {
        chunk: chunk2
      };
      if (res) {
        const [familyIdx, family] = res;
        const rank = family.indexOf(chunk2.fileType);
        if (tmp[fileKey]) {
          if (tmp[fileKey][familyIdx] !== void 0) {
            if (tmp[fileKey][familyIdx] > rank) {
              tmp[fileKey][familyIdx] = rank;
            }
          } else {
            tmp[fileKey][familyIdx] = rank;
          }
        } else {
          tmp[fileKey] = {};
          tmp[fileKey][familyIdx] = rank;
        }
        info.familyIdx = familyIdx;
      }
      chunksSet[fileKey].push(info);
      return chunksSet;
    }, {});
    const result2 = [];
    Object.keys(col).forEach((key) => {
      const byType = {};
      col[key].forEach((info) => {
        let t3 = info.chunk.fileType;
        if (info.familyIdx !== void 0) {
          t3 = FILE_TYPE_FAMILY[info.familyIdx][tmp[key][info.familyIdx]];
          info.chunk.fileType = t3;
        }
        if (!byType[t3]) {
          byType[t3] = [];
        }
        byType[t3].push(info.chunk);
      });
      result2.push(...Object.keys(byType).map((t3) => byType[t3]));
    });
    return result2;
  };
  var ChunkBuilder = class {
    constructor(plugins3 = []) {
      __publicField(this, "plugins");
      this.plugins = plugins3;
    }
    async run(ir, initialStructure = {
      ir,
      chunks: [],
      depNames: [],
      contextData: {}
    }) {
      const structure = initialStructure;
      const finalStructure = await this.plugins.reduce(
        async (previousPluginOperation, plugin) => {
          const modifiedStructure = await previousPluginOperation;
          return plugin(modifiedStructure);
        },
        Promise.resolve(structure)
      );
      const chunks = groupChunks(finalStructure.chunks);
      return {
        chunks
      };
    }
    getPlugins() {
      return this.plugins;
    }
    addPlugin(plugin) {
      this.plugins.push(plugin);
    }
  };

  // src/generator/CodeBuilder.ts
  init_define_process();
  var CodeBuilder = class {
    constructor(chunkDefinitions = []) {
      __publicField(this, "chunkDefinitions", []);
      __publicField(this, "generators", {
        ["string" /* STRING */]: (str) => str,
        ["json" /* JSON */]: (json) => JSON.stringify(json)
      });
      this.chunkDefinitions = chunkDefinitions;
    }
    link(chunkDefinitions = []) {
      const chunks = chunkDefinitions || this.chunkDefinitions;
      if (chunks.length <= 0) {
        return "";
      }
      const unprocessedChunks = chunks.map((chunk2) => {
        return {
          name: chunk2.name,
          type: chunk2.type,
          content: chunk2.content,
          linkAfter: this.cleanupInvalidChunks(chunk2.linkAfter, chunks)
        };
      });
      const resultingString = [];
      while (unprocessedChunks.length > 0) {
        let indexToRemove = 0;
        for (let index = 0; index < unprocessedChunks.length; index++) {
          if (unprocessedChunks[index].linkAfter.length <= 0) {
            indexToRemove = index;
            break;
          }
        }
        if (unprocessedChunks[indexToRemove].linkAfter.length > 0) {
          throw new CodeGeneratorError(
            "Operation aborted. Reason: cyclic dependency between chunks."
          );
        }
        const { type, content, name } = unprocessedChunks[indexToRemove];
        const compiledContent = this.generateByType(type, content);
        if (compiledContent) {
          resultingString.push(`${compiledContent}
`);
        }
        unprocessedChunks.splice(indexToRemove, 1);
        if (!unprocessedChunks.some((ch) => ch.name === name)) {
          unprocessedChunks.forEach(
            (ch) => {
              ch.linkAfter = ch.linkAfter.filter((after2) => after2 !== name);
            }
          );
        }
      }
      return resultingString.join("\n");
    }
    generateByType(type, content) {
      if (!content) {
        return "";
      }
      if (Array.isArray(content)) {
        return content.map((contentItem) => this.generateByType(type, contentItem)).join("\n");
      }
      if (!this.generators[type]) {
        throw new Error(
          `Attempted to generate unknown type ${type}. Please register a generator for this type in builder/index.ts`
        );
      }
      return this.generators[type](content);
    }
    cleanupInvalidChunks(linkAfter, chunks) {
      return linkAfter.filter((chunkName) => chunks.some((chunk2) => chunk2.name === chunkName));
    }
  };

  // src/generator/ModuleBuilder.ts
  function createModuleBuilder(options = {
    plugins: [],
    postProcessors: []
  }) {
    const chunkGenerator = new ChunkBuilder(options.plugins);
    const linker = new CodeBuilder();
    const generateModule = async (input) => {
      const moduleMainName = options.mainFileName || COMMON_SUB_MODULE_NAME;
      if (chunkGenerator.getPlugins().length <= 0) {
        throw new CodeGeneratorError(
          "No plugins found. Component generation cannot work without any plugins!"
        );
      }
      let files = [];
      const { chunks } = await chunkGenerator.run(input, {
        ir: input,
        chunks: [],
        depNames: [],
        contextData: options.contextData || {}
      });
      chunks.forEach((fileChunkList) => {
        const content = linker.link(fileChunkList);
        const file2 = createResultFile(
          fileChunkList[0].subModule || moduleMainName,
          fileChunkList[0].fileType,
          content
        );
        files.push(file2);
      });
      if (options.postProcessors.length > 0) {
        files = files.map((file2) => {
          let { content } = file2;
          const type = file2.ext;
          options.postProcessors.forEach((processer) => {
            content = processer(content, type);
          });
          return createResultFile(file2.name, type, content);
        });
      }
      return {
        files
      };
    };
    const generateModuleCode = async (schema) => {
      const schemaParser = new SchemaParser();
      const parseResult = schemaParser.parse(schema);
      const containerInfo = parseResult.containers[0];
      const { files } = await generateModule(containerInfo);
      const dir = createResultDir(containerInfo.moduleName);
      files.forEach((file2) => addFile(dir, file2));
      return dir;
    };
    const linkCodeChunks = (chunks, fileName) => {
      const files = [];
      Object.keys(chunks).forEach((fileKey) => {
        const fileChunkList = chunks[fileKey];
        const content = linker.link(fileChunkList);
        const file2 = createResultFile(
          fileChunkList[0].subModule || fileName,
          fileChunkList[0].fileType,
          content
        );
        files.push(file2);
      });
      return files;
    };
    return {
      generateModule,
      generateModuleCode,
      linkCodeChunks,
      addPlugin: chunkGenerator.addPlugin.bind(chunkGenerator)
    };
  }

  // src/generator/ProjectBuilder.ts
  var ProjectBuilder = class {
    constructor({
      template: template2,
      plugins: plugins3,
      postProcessors,
      schemaParser = new SchemaParser(),
      projectPreProcessors = [],
      projectPostProcessors = [],
      inStrictMode = false,
      extraContextData = {}
    }) {
      __publicField(this, "template");
      __publicField(this, "plugins");
      __publicField(this, "postProcessors");
      __publicField(this, "schemaParser");
      __publicField(this, "projectPreProcessors");
      __publicField(this, "projectPostProcessors");
      __publicField(this, "inStrictMode");
      __publicField(this, "extraContextData");
      this.template = template2;
      this.plugins = plugins3;
      this.postProcessors = postProcessors;
      this.schemaParser = schemaParser;
      this.projectPreProcessors = projectPreProcessors;
      this.projectPostProcessors = projectPostProcessors;
      this.inStrictMode = inStrictMode;
      this.extraContextData = extraContextData;
    }
    async generateProject(originalSchema) {
      const { schemaParser } = this;
      const builders = this.createModuleBuilders();
      const projectRoot = await this.template.generateTemplate();
      let schema = typeof originalSchema === "string" ? JSON.parse(originalSchema) : originalSchema;
      if (!schemaParser.validate(schema)) {
        throw new CodeGeneratorError("Schema is invalid");
      }
      for (const preProcessor of this.projectPreProcessors) {
        schema = await preProcessor(schema);
      }
      const parseResult = schemaParser.parse(schema);
      let buildResult = [];
      const containerBuildResult = await Promise.all(
        parseResult.containers.map(async (containerInfo) => {
          let builder;
          let path;
          if (containerInfo.containerType === "Page") {
            builder = builders.pages;
            path = this.template.slots.pages.path;
          } else {
            builder = builders.components;
            path = this.template.slots.components.path;
          }
          const { files } = await builder.generateModule(containerInfo);
          return {
            moduleName: containerInfo.moduleName,
            path,
            files
          };
        })
      );
      buildResult = buildResult.concat(containerBuildResult);
      buildResult.forEach((moduleInfo) => {
        let targetDir = getDirFromRoot(projectRoot, moduleInfo.path);
        if (moduleInfo.moduleName) {
          const dir = createResultDir(moduleInfo.moduleName);
          addDirectory(targetDir, dir);
          targetDir = dir;
        }
        moduleInfo.files.forEach((file2) => addFile(targetDir, file2));
      });
      let finalResult = projectRoot;
      for (const projectPostProcessor of this.projectPostProcessors) {
        finalResult = await projectPostProcessor(finalResult, schema, originalSchema);
      }
      return finalResult;
    }
    createModuleBuilders() {
      const builders = {};
      Object.keys(this.plugins).forEach((pluginName) => {
        if (this.plugins[pluginName].length > 0) {
          const options = {};
          if (this.template.slots[pluginName] && this.template.slots[pluginName].fileName) {
            options.mainFileName = this.template.slots[pluginName].fileName;
          }
          builders[pluginName] = createModuleBuilder({
            plugins: this.plugins[pluginName],
            postProcessors: this.postProcessors,
            contextData: {
              inStrictMode: this.inStrictMode,
              tolerateEvalErrors: true,
              evalErrorsHandler: "",
              ...this.extraContextData
            },
            ...options
          });
        }
      });
      return builders;
    }
  };
  function createProjectBuilder(initOptions) {
    return new ProjectBuilder(initOptions);
  }
  function getDirFromRoot(root2, path) {
    let current = root2;
    path.forEach((p) => {
      const exist = current.dirs.find((d) => d.name === p);
      if (exist) {
        current = exist;
      } else {
        const newDir = createResultDir(p);
        addDirectory(current, newDir);
        current = newDir;
      }
    });
    return current;
  }

  // src/publisher/zip/index.ts
  init_define_process();

  // src/publisher/zip/utils.ts
  init_define_process();
  var import_jszip = __toESM(require_jszip_min());
  var isNodeProcess = () => {
    return typeof define_process_default === "object" && typeof define_process_default.versions === "object" && typeof define_process_default.versions.node !== "undefined";
  };
  var writeZipToDisk = (zipFolderPath, content, zipName) => {
    if (!isNodeProcess()) {
      throw new Error("ZipPublisher: writeZipToDisk is only available in NodeJS");
    }
    const fs = require_fs();
    const path = require_path_browserify();
    if (!fs.existsSync(zipFolderPath)) {
      fs.mkdirSync(zipFolderPath, { recursive: true });
    }
    const zipPath = path.join(zipFolderPath, `${zipName}.zip`);
    const writeStream = fs.createWriteStream(zipPath);
    writeStream.write(content);
    writeStream.end();
  };
  var generateProjectZip = async (project) => {
    let zip2 = new import_jszip.default();
    zip2 = writeFolderToZip(project, zip2, true);
    const zipType = "nodebuffer";
    return zip2.generateAsync({ type: zipType });
  };
  var writeFolderToZip = (folder, parentFolder, ignoreFolder = false) => {
    const zipFolder = ignoreFolder ? parentFolder : parentFolder.folder(folder.name);
    if (zipFolder !== null) {
      folder.files.forEach((file2) => {
        const options = {};
        const fileName = file2.ext ? `${file2.name}.${file2.ext}` : file2.name;
        zipFolder.file(fileName, file2.content, options);
      });
      folder.dirs.forEach((subFolder) => {
        writeFolderToZip(subFolder, zipFolder);
      });
    }
    return parentFolder;
  };

  // src/publisher/zip/index.ts
  var createZipPublisher = (params = {}) => {
    let { project, outputPath } = params;
    const getProject = () => project;
    const setProject = (projectToSet) => {
      project = projectToSet;
    };
    const getOutputPath = () => outputPath;
    const setOutputPath = (path) => {
      outputPath = path;
    };
    const publish = async (options = {}) => {
      const projectToPublish = options.project || project;
      if (!projectToPublish) {
        throw new PublisherError("MissingProject");
      }
      const zipName = options.projectSlug || params.projectSlug || projectToPublish.name;
      try {
        const zipContent = await generateProjectZip(projectToPublish);
        const projectOutputPath = options.outputPath || outputPath;
        if (projectOutputPath && isNodeProcess()) {
          await writeZipToDisk(projectOutputPath, zipContent, zipName);
        }
        return { success: true, payload: zipContent };
      } catch (error) {
        throw new PublisherError(getErrorMessage(error) || "UnknownError");
      }
    };
    return {
      publish,
      getProject,
      setProject,
      getOutputPath,
      setOutputPath
    };
  };

  // src/solutions/icejs.ts
  init_define_process();

  // src/plugins/common/esmodule.ts
  init_define_process();
  var DEP_MAIN_BLOCKLIST = ["lib", "lib/index", "es", "es/index", "main"];
  var DEFAULT_EXPORT_NAME = "__default__";
  function groupDepsByPack(deps) {
    const depMap = {};
    const addDep = (pkg, dep) => {
      if (!depMap[pkg]) {
        depMap[pkg] = [];
      }
      depMap[pkg].push(dep);
    };
    deps.forEach((dep) => {
      if (dep.dependencyType === "Internal" /* Internal */) {
        addDep(`${dep.moduleName}${dep.main ? `/${dep.main}` : ""}`, dep);
      } else {
        let depMain = "";
        if (dep.main && DEP_MAIN_BLOCKLIST.indexOf(dep.main) < 0) {
          depMain = dep.main;
        }
        if (depMain.substring(0, 1) === "/") {
          depMain = depMain.substring(1);
        }
        addDep(`${dep.package}${depMain ? `/${depMain}` : ""}`, dep);
      }
    });
    return depMap;
  }
  function getDependencyIdentifier(info) {
    return info.aliasName || info.exportName;
  }
  function getExportNameOfDep(dep) {
    if (dep.destructuring) {
      return dep.exportName || dep.componentName || throwNewError("destructuring dependency must have exportName or componentName");
    }
    if (!dep.subName) {
      return dep.componentName || dep.exportName || throwNewError("dependency item must have componentName or exportName");
    }
    return dep.exportName || `__$${camelCase_default(
      get_default(dep, "moduleName") || get_default(dep, "package") || throwNewError("dep.moduleName or dep.package is undefined")
    )}_default`;
  }
  function throwNewError(msg) {
    throw new Error(msg);
  }
  function buildPackageImport(pkg, deps, targetFileType, useAliasName) {
    if (!pkg || pkg === "undefined" || pkg === "null") {
      return [];
    }
    const chunks = [];
    const exportItems = {};
    const defaultExportNames = [];
    const depsInfo = deps.map((dep) => {
      const info = {
        exportName: getExportNameOfDep(dep),
        isDefault: !dep.destructuring,
        subName: dep.subName || void 0,
        nodeIdentifier: dep.componentName || void 0,
        source: dep
      };
      if (info.isDefault) {
        if (defaultExportNames.indexOf(info.exportName) < 0) {
          defaultExportNames.push(info.exportName);
        }
      }
      if (!info.subName) {
        if (info.nodeIdentifier === info.exportName) {
          info.nodeIdentifier = void 0;
        }
        if (info.isDefault) {
          info.aliasName = info.nodeIdentifier || info.exportName;
          info.exportName = DEFAULT_EXPORT_NAME;
        }
        if (info.nodeIdentifier) {
          info.aliasName = info.nodeIdentifier;
          info.nodeIdentifier = void 0;
        }
      } else {
        if (info.isDefault) {
          info.aliasName = info.exportName;
          info.exportName = DEFAULT_EXPORT_NAME;
        }
        if (info.nodeIdentifier === `${info.exportName}.${info.subName}`) {
          info.nodeIdentifier = void 0;
        }
      }
      return info;
    });
    depsInfo.forEach((info) => {
      if (!exportItems[info.exportName]) {
        exportItems[info.exportName] = {
          exportName: info.exportName,
          isDefault: info.isDefault,
          aliasNames: [],
          needOriginExport: false
        };
      }
      if (!info.nodeIdentifier && !info.aliasName) {
        exportItems[info.exportName].needOriginExport = true;
      }
    });
    depsInfo.forEach((info) => {
      if (info.aliasName) {
        const { aliasNames } = exportItems[info.exportName];
        if (aliasNames.indexOf(info.aliasName) < 0) {
          aliasNames.push(info.aliasName);
        }
      }
    });
    depsInfo.forEach((info) => {
      if (info.nodeIdentifier) {
        const exportItem = exportItems[info.exportName];
        if (!exportItem.needOriginExport && exportItem.aliasNames.length > 0) {
          info.aliasName = exportItem.aliasNames[0];
        }
      }
    });
    const nodeIdentifiers = depsInfo.map((info) => info.nodeIdentifier).filter(Boolean);
    const conflictInfos = flatMap_default(Object.keys(exportItems), (exportName) => {
      const exportItem = exportItems[exportName];
      const usedNames = [
        ...exportItem.aliasNames,
        ...exportItem.needOriginExport || exportItem.aliasNames.length <= 0 ? [exportName] : []
      ];
      const conflictNames = usedNames.filter((n) => nodeIdentifiers.indexOf(n) >= 0);
      if (conflictNames.length > 0) {
        return [
          ...conflictNames.indexOf(exportName) >= 0 ? [[exportName, true, exportItem]] : [],
          ...conflictNames.filter((n) => n !== exportName).map((n) => [n, false, exportItem])
        ];
      }
      return [];
    });
    const conflictExports = conflictInfos.filter((c) => c[1]).map((c) => c[0]);
    const conflictAlias = conflictInfos.filter((c) => !c[1]).map((c) => c[0]);
    const solutions = {};
    depsInfo.forEach((info) => {
      if (info.aliasName && conflictAlias.indexOf(info.aliasName) >= 0) {
        let solution = solutions[info.aliasName];
        if (!solution) {
          solution = `${info.aliasName}Alias`;
          const conflictItem = (conflictInfos.find((c) => c[0] === info.aliasName) || [])[2];
          conflictItem.aliasNames = conflictItem.aliasNames.filter((a) => a !== info.aliasName);
          conflictItem.aliasNames.push(solution);
          solutions[info.aliasName] = solution;
        }
        info.aliasName = solution;
      }
      if (conflictExports.indexOf(info.exportName) >= 0) {
        let solution = solutions[info.exportName];
        if (!solution) {
          solution = `${info.exportName}Export`;
          const conflictItem = (conflictInfos.find((c) => c[0] === info.exportName) || [])[2];
          conflictItem.aliasNames.push(solution);
          conflictItem.needOriginExport = false;
          solutions[info.exportName] = solution;
        }
        info.aliasName = solution;
      }
    });
    depsInfo.forEach((info) => {
      const name = info.aliasName || info.exportName;
      if (!isValidIdentifier(name)) {
        throw new CodeGeneratorError(`Invalid Identifier [${name}]`);
      }
      if (info.nodeIdentifier && !isValidIdentifier(info.nodeIdentifier)) {
        throw new CodeGeneratorError(`Invalid Identifier [${info.nodeIdentifier}]`);
      }
    });
    const aliasDefineStatements = {};
    if (useAliasName) {
      Object.keys(exportItems).forEach((exportName) => {
        var _a;
        const aliasList = ((_a = exportItems[exportName]) == null ? void 0 : _a.aliasNames) || [];
        if (aliasList.length > 0) {
          const srcName = exportItems[exportName].needOriginExport ? exportName : aliasList[0];
          const aliasNameList = exportItems[exportName].needOriginExport ? aliasList : aliasList.slice(1);
          aliasNameList.forEach((a) => {
            if (!aliasDefineStatements[a]) {
              aliasDefineStatements[a] = `const ${a} = ${srcName};`;
            }
          });
        }
      });
    }
    function getDefaultExportName(info) {
      if (info.isDefault) {
        return defaultExportNames[0];
      }
      return info.exportName;
    }
    depsInfo.forEach((info) => {
      if (info.nodeIdentifier) {
        const ownerName = getDependencyIdentifier(info);
        chunks.push({
          type: "string" /* STRING */,
          fileType: targetFileType,
          name: COMMON_CHUNK_NAME.ImportAliasDefine,
          content: useAliasName ? `const ${info.nodeIdentifier} = ${ownerName}.${info.subName};` : "",
          linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport, COMMON_CHUNK_NAME.InternalDepsImport],
          ext: {
            originalName: `${getDefaultExportName(info)}.${info.subName}`,
            aliasName: info.nodeIdentifier,
            dependency: info.source
          }
        });
      } else if (info.aliasName) {
        if (info.isDefault && defaultExportNames.find((n) => n === info.aliasName)) {
          delete aliasDefineStatements[info.aliasName];
          return;
        }
        let contentStatement = "";
        if (aliasDefineStatements[info.aliasName]) {
          contentStatement = aliasDefineStatements[info.aliasName];
          delete aliasDefineStatements[info.aliasName];
        }
        chunks.push({
          type: "string" /* STRING */,
          fileType: targetFileType,
          name: COMMON_CHUNK_NAME.ImportAliasDefine,
          content: contentStatement,
          linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport, COMMON_CHUNK_NAME.InternalDepsImport],
          ext: {
            originalName: getDefaultExportName(info),
            aliasName: info.aliasName,
            dependency: info.source
          }
        });
      }
    });
    Object.keys(aliasDefineStatements).forEach((a) => {
      chunks.push({
        type: "string" /* STRING */,
        fileType: targetFileType,
        name: COMMON_CHUNK_NAME.ImportAliasDefine,
        content: aliasDefineStatements[a],
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport, COMMON_CHUNK_NAME.InternalDepsImport]
      });
    });
    const exportItemList = Object.keys(exportItems).map((k) => exportItems[k]);
    const defaultExport = exportItemList.filter((item) => item.isDefault);
    const otherExports = exportItemList.filter((item) => !item.isDefault);
    const statementL = ["import"];
    if (defaultExport.length > 0) {
      if (useAliasName) {
        statementL.push(defaultExportNames[0]);
      } else {
        statementL.push(defaultExport[0].aliasNames[0]);
      }
      if (otherExports.length > 0) {
        statementL.push(", ");
      }
    }
    if (otherExports.length > 0) {
      const items = otherExports.map((item) => {
        return !useAliasName || item.needOriginExport || item.aliasNames.length <= 0 ? item.exportName : `${item.exportName} as ${item.aliasNames[0]}`;
      });
      statementL.push(`{ ${items.join(", ")} }`);
    }
    statementL.push("from");
    const getInternalDependencyModuleId = () => `@/${deps[0].type}/${pkg}`;
    if (deps[0].dependencyType === "Internal" /* Internal */) {
      statementL.push(`'${getInternalDependencyModuleId()}';`);
      chunks.push({
        type: "string" /* STRING */,
        fileType: targetFileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: statementL.join(" "),
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
    } else {
      statementL.push(`'${pkg}';`);
      chunks.push({
        type: "string" /* STRING */,
        fileType: targetFileType,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: statementL.join(" "),
        linkAfter: []
      });
    }
    if (defaultExportNames.length > 1) {
      if (deps[0].dependencyType === "Internal" /* Internal */) {
        defaultExportNames.slice(1).forEach((exportName) => {
          chunks.push({
            type: "string" /* STRING */,
            fileType: targetFileType,
            name: COMMON_CHUNK_NAME.InternalDepsImport,
            content: `import ${exportName} from '${getInternalDependencyModuleId()}';`,
            linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
          });
        });
      } else {
        defaultExportNames.slice(1).forEach((exportName) => {
          chunks.push({
            type: "string" /* STRING */,
            fileType: targetFileType,
            name: COMMON_CHUNK_NAME.ExternalDepsImport,
            content: `import ${exportName} from '${pkg}';`,
            linkAfter: []
          });
          chunks.push({
            type: "string" /* STRING */,
            fileType: targetFileType,
            name: COMMON_CHUNK_NAME.ImportAliasDefine,
            content: "",
            linkAfter: [],
            ext: {
              aliasName: exportName,
              originalName: exportName,
              dependency: {
                package: pkg,
                componentName: exportName
              }
            }
          });
        });
      }
    }
    return chunks;
  }
  var pluginFactory = (config) => {
    const cfg = {
      fileType: "js" /* JS */,
      useAliasName: true,
      ...config || {}
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      if (ir && ir.deps && ir.deps.length > 0) {
        const packs = groupDepsByPack(ir.deps);
        Object.keys(packs).forEach((pkg) => {
          const chunks = buildPackageImport(pkg, packs[pkg], cfg.fileType, cfg.useAliasName);
          next.chunks.push(...chunks);
        });
      }
      return next;
    };
    return plugin;
  };
  var esmodule_default = pluginFactory;

  // src/plugins/component/react/containerClass.ts
  init_define_process();
  var import_change_case3 = __toESM(require_change_case());

  // src/plugins/component/react/const.ts
  init_define_process();
  var REACT_CHUNK_NAME = {
    ClassRenderStart: "ReactComponentClassRenderStart",
    ClassRenderPre: "ReactComponentClassRenderPre",
    ClassRenderEnd: "ReactComponentClassRenderEnd",
    ClassRenderJSX: "ReactComponentClassRenderJSX",
    ClassDidMountStart: "ReactComponentClassDidMountStart",
    ClassDidMountEnd: "ReactComponentClassDidMountEnd",
    ClassDidMountContent: "ReactComponentClassDidMountContent"
  };

  // src/plugins/component/react/containerClass.ts
  var pluginFactory2 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const componentClassName = ensureValidClassName(
        `${import_change_case3.default.pascalCase(ir.moduleName)}$$Page`
      );
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.Start,
        content: `class ${componentClassName} extends React.Component {`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.End,
        content: "}",
        linkAfter: [
          ...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End],
          REACT_CHUNK_NAME.ClassRenderEnd,
          REACT_CHUNK_NAME.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorStart,
        content: "constructor(props, context) { super(props); ",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorEnd,
        content: "}",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorEnd]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassDidMountStart,
        content: "componentDidMount() {",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassDidMountEnd,
        content: "}",
        linkAfter: [REACT_CHUNK_NAME.ClassDidMountContent, REACT_CHUNK_NAME.ClassDidMountStart]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassRenderStart,
        content: "render() {",
        linkAfter: [
          ...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End],
          REACT_CHUNK_NAME.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassRenderEnd,
        content: "}",
        linkAfter: [
          REACT_CHUNK_NAME.ClassRenderStart,
          REACT_CHUNK_NAME.ClassRenderPre,
          REACT_CHUNK_NAME.ClassRenderJSX
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `export default ${componentClassName};`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          CLASS_DEFINE_CHUNK_NAME.End
        ]
      });
      return next;
    };
    return plugin;
  };
  var containerClass_default = pluginFactory2;

  // src/plugins/component/react/containerInitState.ts
  init_define_process();

  // src/utils/compositeType.ts
  var compositeType_exports = {};
  __export(compositeType_exports, {
    generateCompositeType: () => generateCompositeType
  });
  init_define_process();

  // src/utils/jsExpression.ts
  var jsExpression_exports = {};
  __export(jsExpression_exports, {
    generateExpression: () => generateExpression,
    generateFunction: () => generateFunction,
    isJsCode: () => isJsCode
  });
  init_define_process();
  var parser2 = __toESM(require_lib2());
  var import_generator6 = __toESM(require_lib6());
  var import_traverse2 = __toESM(require_lib14());
  var t2 = __toESM(require_lib5());

  // src/utils/expressionParser.ts
  var expressionParser_exports = {};
  __export(expressionParser_exports, {
    ParseError: () => ParseError,
    parseExpression: () => parseExpression2,
    parseExpressionConvertThis2Context: () => parseExpressionConvertThis2Context,
    parseExpressionGetGlobalVariables: () => parseExpressionGetGlobalVariables,
    parseExpressionGetKeywords: () => parseExpressionGetKeywords,
    transformExpressionLocalRef: () => transformExpressionLocalRef
  });
  init_define_process();
  var parser = __toESM(require_lib2());
  var import_generator5 = __toESM(require_lib6());
  var import_traverse = __toESM(require_lib14());
  var t = __toESM(require_lib5());
  var import_types7 = __toESM(require_lib5());

  // src/utils/OrderedSet.ts
  init_define_process();
  var OrderedSet = class {
    constructor(items) {
      __publicField(this, "_set", /* @__PURE__ */ new Set());
      __publicField(this, "_arr", []);
      if (items) {
        this._set = new Set(items);
        this._arr = items.slice(0);
      }
    }
    add(item) {
      if (!this._set.has(item)) {
        this._set.add(item);
        this._arr.push(item);
      }
    }
    delete(item) {
      if (this._set.has(item)) {
        this._set.delete(item);
        this._arr.splice(this._arr.indexOf(item), 1);
      }
    }
    has(item) {
      return this._set.has(item);
    }
    toArray() {
      return this._arr.slice(0);
    }
  };

  // src/utils/expressionParser.ts
  var ParseError = class extends Error {
    constructor(expr, detail) {
      super(`Failed to parse expression "${typeof expr === "string" ? expr : (0, import_generator5.default)(expr)}"`);
      __publicField(this, "expr");
      __publicField(this, "detail");
      this.expr = expr;
      this.detail = detail;
      Object.setPrototypeOf(this, new.target.prototype);
    }
  };
  var MAYBE_EXPRESSIONS = {
    ArrayExpression: { fields: ["elements"] },
    AssignmentExpression: { fields: ["left", "right"] },
    BinaryExpression: { fields: ["left", "right"] },
    CallExpression: { fields: ["arguments", "callee"] },
    ConditionalExpression: { fields: ["test", "consequent", "alternate"] },
    DoWhileStatement: { fields: ["test"] },
    ExpressionStatement: { fields: ["expression"] },
    ForInStatement: { fields: ["right"] },
    ForStatement: { fields: ["init", "test", "update"] },
    IfStatement: { fields: ["test"] },
    LogicalExpression: { fields: ["left", "right"] },
    MemberExpression: {
      fields: (node) => {
        return node.type === "MemberExpression" && node.computed ? ["object", "property"] : ["object"];
      }
    },
    NewExpression: { fields: ["callee", "arguments"] },
    ObjectMethod: {
      fields: (node) => {
        return node.type === "ObjectMethod" && node.computed ? ["key"] : [];
      }
    },
    ObjectProperty: {
      fields: (node) => {
        return node.type === "ObjectProperty" && node.computed ? ["key", "value"] : ["value"];
      }
    },
    ReturnStatement: { fields: ["argument"] },
    SequenceExpression: { fields: ["expressions"] },
    ParenthesizedExpression: { fields: ["expression"] },
    SwitchCase: { fields: ["test"] },
    SwitchStatement: { fields: ["discriminant"] },
    ThrowStatement: { fields: ["argument"] },
    UnaryExpression: { fields: ["argument"] },
    UpdateExpression: { fields: ["argument"] },
    VariableDeclarator: { fields: ["init"] },
    WhileStatement: { fields: ["test"] },
    WithStatement: { fields: ["object"] },
    AssignmentPattern: { fields: ["right"] },
    ArrowFunctionExpression: { fields: ["body"] },
    ClassExpression: { fields: ["superClass"] },
    ClassDeclaration: { fields: ["superClass"] },
    ExportDefaultDeclaration: { fields: ["declaration"] },
    ForOfStatement: { fields: ["right"] },
    ClassMethod: {
      fields: (node) => {
        return node.type === "ClassMethod" && node.computed ? ["key"] : [];
      }
    },
    SpreadElement: { fields: ["argument"] },
    TaggedTemplateExpression: { fields: ["tag"] },
    TemplateLiteral: { fields: ["expressions"] },
    YieldExpression: { fields: ["argument"] },
    AwaitExpression: { fields: ["argument"] },
    OptionalMemberExpression: {
      fields: (node) => {
        return node.type === "OptionalMemberExpression" && node.computed ? ["object", "property"] : ["object"];
      }
    },
    OptionalCallExpression: { fields: ["callee", "arguments"] },
    JSXSpreadAttribute: { fields: ["argument"] },
    BindExpression: { fields: ["object", "callee"] },
    ClassProperty: {
      fields: (node) => {
        return node.type === "ClassProperty" && node.computed ? ["key", "value"] : ["value"];
      }
    },
    PipelineTopicExpression: { fields: ["expression"] },
    PipelineBareFunction: { fields: ["callee"] },
    ClassPrivateProperty: { fields: ["value"] },
    Decorator: { fields: ["expression"] },
    TupleExpression: { fields: ["elements"] },
    TSDeclareMethod: {
      fields: (node) => {
        return node.type === "TSDeclareMethod" && node.computed ? ["key"] : [];
      }
    },
    TSPropertySignature: {
      fields: (node) => {
        return node.type === "TSPropertySignature" && node.computed ? ["key", "initializer"] : ["initializer"];
      }
    },
    TSMethodSignature: {
      fields: (node) => {
        return node.type === "TSMethodSignature" && node.computed ? ["key"] : [];
      }
    },
    TSAsExpression: { fields: ["expression"] },
    TSTypeAssertion: { fields: ["expression"] },
    TSEnumDeclaration: { fields: ["initializer"] },
    TSEnumMember: { fields: ["initializer"] },
    TSNonNullExpression: { fields: ["expression"] },
    TSExportAssignment: { fields: ["expression"] }
  };
  var CROSS_THIS_SCOPE_TYPE_NODE = {
    ArrowFunctionExpression: false,
    FunctionExpression: true,
    FunctionDeclaration: true,
    ClassDeclaration: true,
    ClassExpression: true,
    ClassBody: true,
    ClassImplements: true,
    ClassMethod: true,
    ClassPrivateMethod: true,
    ClassProperty: true,
    ClassPrivateProperty: true,
    DeclareClass: true
  };
  var JS_KEYWORDS = ["arguments", "this", "super"];
  function parseExpressionGetKeywords(expr) {
    if (!expr) {
      return [];
    }
    try {
      const keywordVars = new OrderedSet();
      const ast = parser.parse(`!(${expr});`, {
        plugins: [
          "jsx"
        ]
      });
      const addIdentifierIfNeeded = (x) => {
        if (typeof x === "object" && (0, import_types7.isIdentifier)(x) && JS_KEYWORDS.includes(x.name)) {
          keywordVars.add(x.name);
        }
      };
      (0, import_traverse.default)(ast, {
        enter(path) {
          var _a;
          const { node } = path;
          const expressionFields = (_a = MAYBE_EXPRESSIONS[node.type]) == null ? void 0 : _a.fields;
          if (expressionFields) {
            (typeof expressionFields === "function" ? expressionFields(node) : expressionFields).forEach((fieldName) => {
              const fieldValue = node[fieldName];
              if (typeof fieldValue === "object") {
                if (Array.isArray(fieldValue)) {
                  fieldValue.forEach((item) => {
                    addIdentifierIfNeeded(item);
                  });
                } else {
                  addIdentifierIfNeeded(fieldValue);
                }
              }
            });
          }
        }
      });
      return keywordVars.toArray().filter(Boolean);
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function parseExpressionGetGlobalVariables(expr, { filter: filter2 = () => true } = {}) {
    if (!expr) {
      return [];
    }
    try {
      const undeclaredVars = new OrderedSet();
      const ast = parser.parse(`!(${expr});`);
      const addUndeclaredIdentifierIfNeeded = (x, path) => {
        if (typeof x === "object" && (0, import_types7.isIdentifier)(x) && !path.scope.hasBinding(x.name)) {
          undeclaredVars.add(x.name);
        }
      };
      (0, import_traverse.default)(ast, {
        enter(path) {
          var _a;
          const { node } = path;
          const expressionFields = (_a = MAYBE_EXPRESSIONS[node.type]) == null ? void 0 : _a.fields;
          if (expressionFields) {
            (typeof expressionFields === "function" ? expressionFields(node) : expressionFields).forEach((fieldName) => {
              const fieldValue = node[fieldName];
              if (typeof fieldValue === "object") {
                if (Array.isArray(fieldValue)) {
                  fieldValue.forEach((item) => {
                    addUndeclaredIdentifierIfNeeded(item, path);
                  });
                } else {
                  addUndeclaredIdentifierIfNeeded(fieldValue, path);
                }
              }
            });
          }
        }
      });
      return undeclaredVars.toArray().filter(filter2);
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function parseExpressionConvertThis2Context(expr, contextName = "__$$context", localVariables = []) {
    if (!expr) {
      return expr;
    }
    try {
      const exprAst = typeof expr === "string" ? parser.parseExpression(expr) : expr;
      const exprWrapAst = t.expressionStatement(exprAst);
      const fileAst = t.file(t.program([exprWrapAst]));
      const localVariablesSet = new Set(localVariables);
      let thisScopeLevel = CROSS_THIS_SCOPE_TYPE_NODE[exprAst.type] ? -1 : 0;
      (0, import_traverse.default)(fileAst, {
        enter(path) {
          if (CROSS_THIS_SCOPE_TYPE_NODE[path.node.type]) {
            thisScopeLevel++;
          }
        },
        exit(path) {
          if (CROSS_THIS_SCOPE_TYPE_NODE[path.node.type]) {
            thisScopeLevel--;
          }
        },
        MemberExpression(path) {
          if (!path.isMemberExpression()) {
            return;
          }
          const obj = path.get("object");
          if (!obj.isThisExpression()) {
            return;
          }
          if (!path.node.computed) {
            const prop = path.get("property");
            if (prop.isIdentifier() && localVariablesSet.has(prop.node.name)) {
              path.replaceWith(t.identifier(prop.node.name));
              return;
            }
          }
          if (thisScopeLevel <= 0) {
            obj.replaceWith(t.identifier(contextName));
          }
        },
        ThisExpression(path) {
          if (!path.isThisExpression()) {
            return;
          }
          if (path.parent.type === "MemberExpression") {
            return;
          }
          if (thisScopeLevel <= 0) {
            path.replaceWith(t.identifier(contextName));
          }
        }
      });
      const { code } = (0, import_generator5.default)(exprWrapAst.expression, { sourceMaps: false });
      return code;
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function parseExpression2(expr) {
    try {
      return parser.parseExpression(expr);
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function transformExpressionLocalRef(expr, scope) {
    if (!expr) {
      return expr;
    }
    if (!scope) {
      throw new Error("transform expression without scope");
    }
    try {
      const exprAst = typeof expr === "string" ? parser.parseExpression(expr) : expr;
      const exprWrapAst = t.expressionStatement(exprAst);
      const fileAst = t.file(t.program([exprWrapAst]));
      (0, import_traverse.default)(fileAst, {
        MemberExpression(path) {
          if (!path.isMemberExpression()) {
            return;
          }
          const obj = path.get("object");
          if (!obj.isThisExpression()) {
            return;
          }
          const prop = path.get("property");
          let memberName = "";
          if (!path.node.computed && prop.isIdentifier()) {
            memberName = prop.node.name;
          } else if (path.node.computed && prop.isStringLiteral()) {
            memberName = prop.node.value;
          }
          if (memberName && scope.bindings && scope.bindings.hasBinding(memberName)) {
            path.replaceWith(t.identifier(memberName));
          }
        }
      });
      const { code } = (0, import_generator5.default)(exprWrapAst.expression, { sourceMaps: false });
      return code;
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }

  // src/utils/jsExpression.ts
  function parseFunction(content) {
    try {
      const ast = parser2.parse(`(${content});`, {
        plugins: [
          "jsx"
        ]
      });
      let resultNode = null;
      (0, import_traverse2.default)(ast, {
        FunctionExpression(path) {
          resultNode = path.node;
          path.stop();
        }
      });
      return resultNode;
    } catch (e) {
      throw new ParseError(content, e);
    }
  }
  function transformFuncExpr2MethodMember(methodName, content) {
    const funcNode = parseFunction(content);
    if (funcNode) {
      const targetNode = t2.classMethod(
        "method",
        methodName && t2.identifier(methodName) || funcNode.id || t2.identifier("notDefineName"),
        funcNode.params,
        funcNode.body,
        void 0,
        void 0,
        void 0,
        funcNode.async || void 0
      );
      const { code: resultCode } = (0, import_generator6.default)(targetNode, { sourceMaps: false });
      return resultCode;
    }
    throw new Error("Can not find Function Statement");
  }
  function getArrowFunction(content) {
    const funcNode = parseFunction(content);
    if (funcNode) {
      const targetNode = t2.arrowFunctionExpression(
        funcNode.params,
        funcNode.body,
        funcNode.async || void 0
      );
      const { code: resultCode } = (0, import_generator6.default)(targetNode, { sourceMaps: false });
      return resultCode;
    }
    throw new Error("Can not find Function Statement");
  }
  function getBodyStatements(content) {
    const funcNode = parseFunction(content);
    if (funcNode) {
      const statements = funcNode.body.body;
      const targetNode = t2.program(statements, void 0, "module", void 0);
      const { code: resultCode } = (0, import_generator6.default)(targetNode, { sourceMaps: false });
      return resultCode;
    }
    throw new Error("Can not find Function Statement");
  }
  function isJsCode(value) {
    return isJSExpression(value) || isJSFunction(value);
  }
  function generateExpression(value, scope) {
    if (isJSExpression(value)) {
      const exprVal = value.value.trim();
      if (!exprVal) {
        return "null";
      }
      const afterProcessWithLocals = transformExpressionLocalRef(exprVal, scope);
      return afterProcessWithLocals;
    }
    throw new CodeGeneratorError("Not a JSExpression");
  }
  function generateFunction(value, config = {
    name: void 0,
    isMember: false,
    isBlock: false,
    isArrow: false,
    isBindExpr: false
  }) {
    if (isJsCode(value)) {
      const functionCfg = value;
      if (config.isMember) {
        return transformFuncExpr2MethodMember(config.name || "", functionCfg.value);
      }
      if (config.isBlock) {
        return getBodyStatements(functionCfg.value);
      }
      if (config.isArrow) {
        return getArrowFunction(functionCfg.value);
      }
      if (config.isBindExpr) {
        return `(${functionCfg.value}).bind(this)`;
      }
      return functionCfg.value;
    }
    throw new CodeGeneratorError("Not a JSFunction or JSExpression");
  }

  // src/utils/jsSlot.ts
  var jsSlot_exports = {};
  __export(jsSlot_exports, {
    generateJsSlot: () => generateJsSlot
  });
  init_define_process();

  // src/utils/jsxHelpers.ts
  init_define_process();
  function unwrapJsExprQuoteInJsx(jsxExpr) {
    if (jsxExpr.length >= 2 && jsxExpr[0] === "{" && jsxExpr[jsxExpr.length - 1] === "}") {
      return jsxExpr.slice(1, jsxExpr.length - 1);
    }
    return jsxExpr;
  }

  // src/utils/jsSlot.ts
  function generateSingleLineComment(commentText) {
    return `/* ${commentText.split("\n").join(" ").replace(/\*\//g, "*-/")}*/`;
  }
  function generateJsSlot(slot, scope, generator) {
    if (isJSSlot(slot)) {
      const { title, params, value } = slot;
      const slotScope = params ? scope.createSubScope(params || []) : scope;
      const contentExpr = !value ? "null" : generateNodeDataOrArrayForJsSlot(value, generator, slotScope);
      if (params) {
        return [
          title && generateSingleLineComment(title),
          "(",
          (params || []).join(", "),
          ") => ((__$$context) => (",
          contentExpr,
          "))(",
          `  __$$createChildContext(__$$context, { ${(params || []).join(", ")} }`,
          "))"
        ].filter(Boolean).join("");
      }
      return contentExpr || "[]";
    }
    throw new CodeGeneratorError("Not a JSSlot");
  }
  function generateNodeDataOrArrayForJsSlot(value, generator, scope) {
    if (Array.isArray(value)) {
      if (value.length === 0) {
        return "[]";
      }
      if (value.length === 1) {
        return unwrapJsExprQuoteInJsx(generator(value, scope)) || "null";
      }
      return `[
${value.map((v) => {
        if (typeof v === "string") {
          return JSON.stringify(v);
        }
        return unwrapJsExprQuoteInJsx(generator(v, scope)) || "null";
      }).join(",\n") || "null"}
]`;
    }
    return unwrapJsExprQuoteInJsx(generator(value, scope)) || "null";
  }

  // src/utils/aopHelper.ts
  init_define_process();
  function executeFunctionStack(input, scope, funcs, baseFunc, config) {
    const funcList = [];
    if (Array.isArray(funcs)) {
      funcList.push(...funcs);
    } else {
      funcList.push(funcs);
    }
    let next = baseFunc;
    while (funcList.length > 0) {
      const func = funcList.pop();
      if (func) {
        const warppedFunc = ((nextFunc) => (i, s, cfg) => func(i, s, cfg, nextFunc))(next);
        next = warppedFunc;
      }
    }
    return next(input, scope, config);
  }

  // src/utils/compositeType.ts
  function isVariable(v) {
    if (lodash_default_default.isObject(v) && v.type === "variable") {
      return true;
    }
    return false;
  }
  function isDataSource(v) {
    return typeof v === "object" && v != null && v.type === "DataSource";
  }
  function generateArray(value, scope, options = {}) {
    const body = value.map((v) => generateUnknownType(v, scope, options)).join(",");
    return `[${body}]`;
  }
  function generateObject(value, scope, options = {}) {
    if (value.type === "i18n") {
      if (value.params && typeof value.params === "object") {
        return `this._i18nText(${generateUnknownType(lodash_default_default.omit(value, "type"), scope, options)})`;
      }
      return `this._i18nText(${JSON.stringify(lodash_default_default.omit(value, "type"))})`;
    }
    const body = Object.keys(value).map((key) => {
      const propName = JSON.stringify(key);
      const v = generateUnknownType(value[key], scope, options);
      return `${propName}: ${v}`;
    }).join(",\n");
    return `{${body}}`;
  }
  function generateString(value) {
    return JSON.stringify(value);
  }
  function generateNumber(value) {
    return String(value);
  }
  function generateBool(value) {
    return value ? "true" : "false";
  }
  function genFunction(value) {
    const globalVars = parseExpressionGetKeywords(value.value);
    if (globalVars.includes("arguments")) {
      return generateFunction(value, { isBindExpr: true });
    }
    return generateFunction(value, { isArrow: true });
  }
  function genJsSlot(value, scope, options = {}) {
    if (options.nodeGenerator) {
      return generateJsSlot(value, scope, options.nodeGenerator);
    }
    return "";
  }
  function generateUnknownType(value, scope, options = {}) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    if (lodash_default_default.isUndefined(value)) {
      return "undefined";
    }
    if (lodash_default_default.isNull(value)) {
      return "null";
    }
    if (lodash_default_default.isArray(value)) {
      if ((_a = options.handlers) == null ? void 0 : _a.array) {
        return executeFunctionStack(value, scope, options.handlers.array, generateArray, options);
      }
      return generateArray(value, scope, options);
    }
    if (isVariable(value)) {
      const transValue = {
        type: "JSExpression",
        value: value.variable
      };
      if ((_b = options.handlers) == null ? void 0 : _b.expression) {
        const expression = executeFunctionStack(
          transValue,
          scope,
          options.handlers.expression,
          generateExpression,
          options
        );
        return expression || "undefined";
      }
      return generateExpression(transValue, scope);
    }
    if (isJSExpression(value)) {
      if ((_c = options.handlers) == null ? void 0 : _c.expression) {
        return executeFunctionStack(
          value,
          scope,
          options.handlers.expression,
          generateExpression,
          options
        );
      }
      return generateExpression(value, scope);
    }
    if (isJSFunction(value)) {
      if ((_d = options.handlers) == null ? void 0 : _d.function) {
        return executeFunctionStack(value, scope, options.handlers.function, genFunction, options);
      }
      return genFunction(value);
    }
    if (isJSSlot(value)) {
      if ((_e = options.handlers) == null ? void 0 : _e.slot) {
        return executeFunctionStack(value, scope, options.handlers.slot, genJsSlot, options);
      }
      return genJsSlot(value, scope, options);
    }
    if (isDataSource(value)) {
      return generateUnknownType(
        {
          type: "JSExpression",
          value: `this.dataSourceMap[${JSON.stringify(value.id)}]`
        },
        scope,
        options
      );
    }
    if (lodash_default_default.isObject(value)) {
      if ((_f = options.handlers) == null ? void 0 : _f.object) {
        return executeFunctionStack(value, scope, options.handlers.object, generateObject, options);
      }
      return generateObject(value, scope, options);
    }
    if (lodash_default_default.isString(value)) {
      if ((_g = options.handlers) == null ? void 0 : _g.string) {
        return executeFunctionStack(value, scope, options.handlers.string, generateString, options);
      }
      return generateString(value);
    }
    if (lodash_default_default.isNumber(value)) {
      if ((_h = options.handlers) == null ? void 0 : _h.number) {
        return executeFunctionStack(value, scope, options.handlers.number, generateNumber, options);
      }
      return generateNumber(value);
    }
    if (lodash_default_default.isBoolean(value)) {
      if ((_i = options.handlers) == null ? void 0 : _i.boolean) {
        return executeFunctionStack(value, scope, options.handlers.boolean, generateBool, options);
      }
      return generateBool(value);
    }
    throw new CodeGeneratorError("Meet unknown composite value type");
  }
  function generateCompositeType(value, scope, options = {}) {
    const result2 = generateUnknownType(value, scope, options);
    return result2;
  }

  // src/utils/Scope.ts
  var Scope_exports = {};
  __export(Scope_exports, {
    Scope: () => Scope
  });
  init_define_process();

  // src/utils/ScopeBindings.ts
  init_define_process();
  var ScopeBindings = class {
    constructor(p = null) {
      __publicField(this, "parent");
      __publicField(this, "_bindings", new OrderedSet());
      this.parent = p;
    }
    hasBinding(varName) {
      var _a;
      return this._bindings.has(varName) || !!((_a = this.parent) == null ? void 0 : _a.hasBinding(varName));
    }
    hasOwnBinding(varName) {
      return this._bindings.has(varName);
    }
    addBinding(varName) {
      this._bindings.add(varName);
    }
    removeBinding(varName) {
      this._bindings.delete(varName);
    }
    getAllBindings() {
      const allBindings = new OrderedSet(this._bindings.toArray());
      for (let { parent: parent2 } = this; parent2; parent2 = parent2 == null ? void 0 : parent2.parent) {
        parent2.getAllOwnedBindings().forEach((varName) => {
          allBindings.add(varName);
        });
      }
      return allBindings.toArray();
    }
    getAllOwnedBindings() {
      return this._bindings.toArray();
    }
  };

  // src/utils/Scope.ts
  var Scope = class {
    constructor(parent2 = null) {
      this.parent = parent2;
      __publicField(this, "bindings");
      this.bindings = void 0;
    }
    static createRootScope() {
      return new Scope();
    }
    createSubScope(ownIdentifiers) {
      const originalScopeBindings = this.bindings;
      const newScopeBindings = new ScopeBindings(originalScopeBindings);
      ownIdentifiers.forEach((identifier3) => {
        newScopeBindings.addBinding(identifier3);
      });
      const newScope = new Scope(this);
      newScope.bindings = newScopeBindings;
      return newScope;
    }
  };

  // src/plugins/component/react/containerInitState.ts
  var pluginFactory3 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      implementType: "inConstructor",
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const state = ir.state || {};
      const fields = Object.keys(state).map((stateName) => {
        const value = generateCompositeType(state[stateName], scope);
        return `${stateName}: ${value},`;
      });
      if (cfg.implementType === "inConstructor") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: `this.state = { ${fields.join("")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      } else if (cfg.implementType === "insMember") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `state = { ${fields.join("")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInitState_default = pluginFactory3;

  // src/plugins/component/react/containerInjectContext.ts
  init_define_process();
  var pluginFactory4 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const { inStrictMode } = next.contextData;
      if (!inStrictMode) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _context = this;
        `,
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
      } else {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _context = this._createContext();
        `,
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
          content: `
          _createContext() {
            const self = this;
            const context = {
              get state() { return self.state; },
              setState(newState, callback) { self.setState(newState, callback); },
              get dataSourceMap() { return self._dataSourceEngine.dataSourceMap || {}; },
              async reloadDataSource() { await self._dataSourceEngine.reloadDataSource(); },
              get utils() { return self.utils; },
              get page() { return context; },
              get component() { return context; },
              get props() { return self.props; },
              get constants() { return self.constants; },
              get $() { return self.$ },
              get $$() { return self.$$ },
              ...this._methods,
            };
  
            return context;
          }
        `,
          linkAfter: DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectContext_default = pluginFactory4;

  // src/plugins/component/react/containerInjectUtils.ts
  init_define_process();
  var pluginFactory5 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.contextData.useRefApi = true;
      const useRef = !!((_a = ir.analyzeResult) == null ? void 0 : _a.isUsingRef);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import utils${useRef ? ", { RefsManager }" : ""} from '../../utils';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
        content: "this.utils = utils;",
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.ConstructorStart]
      });
      if (useRef) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: "this._refsManager = new RefsManager();",
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
          $ = (refName) => {
            return this._refsManager.get(refName);
          }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
          $$ = (refName) => {
            return this._refsManager.getAll(refName);
          }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      } else {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: ` $ = () => null; `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: ` $$ = () => [];        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectUtils_default = pluginFactory5;

  // src/plugins/component/react/containerInjectDataSourceEngine.ts
  init_define_process();
  var import_change_case4 = __toESM(require_change_case());
  var pluginFactory6 = (config) => {
    const cfg = {
      ...config,
      fileType: (config == null ? void 0 : config.fileType) || "jsx" /* JSX */
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const scope = Scope.createRootScope();
      const dataSourceConfig = isContainerSchema(pre.ir) ? pre.ir.dataSource : null;
      const dataSourceItems = dataSourceConfig && dataSourceConfig.list || [];
      const dataSourceEngineOptions = { runtimeConfig: true };
      if (dataSourceItems.length > 0) {
        const requestHandlersMap = {};
        dataSourceItems.forEach((ds) => {
          var _a, _b;
          const dsType = ds.type || "fetch";
          if (!(dsType in requestHandlersMap) && dsType !== "custom") {
            const handlerFactoryName = `__$$create${import_change_case4.default.pascal(dsType)}RequestHandler`;
            requestHandlersMap[dsType] = {
              type: "JSExpression",
              value: handlerFactoryName + (dsType === "urlParams" ? "(window.location.search)" : "()")
            };
            const handlerFactoryExportName = `create${import_change_case4.default.pascal(dsType)}Handler`;
            const handlerPkgName = ((_b = (_a = cfg.datasourceConfig) == null ? void 0 : _a.handlersPackages) == null ? void 0 : _b[dsType]) || `@alilc/lowcode-datasource-${import_change_case4.default.kebab(dsType)}-handler`;
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: "jsx" /* JSX */,
              name: COMMON_CHUNK_NAME.ExternalDepsImport,
              content: `
              import { ${handlerFactoryExportName} as ${handlerFactoryName} } from '${handlerPkgName}';
            `,
              linkAfter: []
            });
          }
        });
        Object.assign(dataSourceEngineOptions, { requestHandlersMap });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "jsx" /* JSX */,
          name: COMMON_CHUNK_NAME.ExternalDepsImport,
          content: `
          import { create as __$$createDataSourceEngine } from '@alilc/lowcode-datasource-engine/runtime';
        `,
          linkAfter: []
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _dataSourceConfig = this._defineDataSourceConfig();
          _dataSourceEngine = __$$createDataSourceEngine(
            this._dataSourceConfig,
            this,
            ${generateCompositeType(dataSourceEngineOptions, scope)}
          );

          get dataSourceMap() {
            return this._dataSourceEngine.dataSourceMap || {};
          }

          reloadDataSource = async () => {
            await this._dataSourceEngine.reloadDataSource();
          }

          `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
        next.chunks.unshift({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: REACT_CHUNK_NAME.ClassDidMountContent,
          content: `
          this._dataSourceEngine.reloadDataSource();
        `,
          linkAfter: [REACT_CHUNK_NAME.ClassDidMountStart]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
  _defineDataSourceConfig() {
    const _this = this;
    return (${generateCompositeType(
            {
              ...dataSourceConfig,
              list: [
                ...dataSourceItems.map((item) => ({
                  ...item,
                  isInit: wrapAsFunction(item.isInit, scope),
                  options: wrapAsFunction(item.options, scope)
                }))
              ]
            },
            scope,
            {
              handlers: {
                function: (jsFunc) => parseExpressionConvertThis2Context(jsFunc.value, "_this"),
                expression: (jsExpr) => parseExpressionConvertThis2Context(jsExpr.value, "_this")
              }
            }
          )});
  }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectDataSourceEngine_default = pluginFactory6;
  function wrapAsFunction(value, scope) {
    if (isJSExpression(value) || isJSFunction(value)) {
      return {
        type: "JSExpression",
        value: `function(){ return ((${value.value}))}`
      };
    }
    return {
      type: "JSExpression",
      value: `function(){return((${generateCompositeType(value, scope)}))}`
    };
  }

  // src/plugins/component/react/containerInjectI18n.ts
  init_define_process();
  var pluginFactory7 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import * as __$$i18n from '../../i18n';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
        content: `
        __$$i18n._inject2(this);
      `,
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectI18n_default = pluginFactory7;

  // src/plugins/component/react/containerLifeCycle.ts
  init_define_process();
  var pluginFactory8 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      exportNameMapping: {},
      normalizeNameMapping: {},
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      if (ir.lifeCycles) {
        const { lifeCycles } = ir;
        const chunks = Object.keys(lifeCycles).map((lifeCycleName) => {
          if (!isJSFunction(lifeCycles[lifeCycleName]) && !isJSExpression(lifeCycles[lifeCycleName])) {
            return null;
          }
          let normalizeName;
          if (lifeCycleName === "constructor") {
            normalizeName = lifeCycleName;
          } else {
            normalizeName = cfg.normalizeNameMapping[lifeCycleName] || lifeCycleName;
          }
          const exportName = cfg.exportNameMapping[lifeCycleName] || lifeCycleName;
          if (normalizeName === "constructor") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]]
            };
          }
          if (normalizeName === "componentDidMount") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: REACT_CHUNK_NAME.ClassDidMountContent,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [REACT_CHUNK_NAME.ClassDidMountStart]
            };
          }
          if (normalizeName === "render") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: REACT_CHUNK_NAME.ClassRenderPre,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [REACT_CHUNK_NAME.ClassRenderStart]
            };
          }
          return {
            type: "string" /* STRING */,
            fileType: cfg.fileType,
            name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
            content: generateFunction(lifeCycles[lifeCycleName], {
              name: exportName,
              isMember: true
            }),
            linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
          };
        });
        next.chunks.push(...chunks.filter((x) => x !== null));
      }
      return next;
    };
    return plugin;
  };
  var containerLifeCycle_default = pluginFactory8;

  // src/plugins/component/react/containerMethod.ts
  init_define_process();
  var pluginFactory9 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const { inStrictMode } = next.contextData;
      if (!ir.methods) {
        return next;
      }
      const { methods } = ir;
      const chunks = Object.keys(methods).map((methodName) => ({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
        content: generateFunction(methods[methodName], { name: methodName, isMember: true }),
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
      }));
      next.chunks.push(...chunks);
      if (inStrictMode) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: Object.keys(ir.methods).map(
            (methodName) => isValidIdentifier(methodName) ? `.${methodName}` : `[${JSON.stringify(methodName)}]`
          ).map((method2) => `this._context${method2} = this${method2};`).join("\n"),
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerMethod_default = pluginFactory9;

  // src/plugins/component/react/jsx.ts
  init_define_process();

  // src/utils/nodeToJSX.ts
  var nodeToJSX_exports = {};
  __export(nodeToJSX_exports, {
    createNodeGenerator: () => createNodeGenerator,
    createReactNodeGenerator: () => createReactNodeGenerator,
    generateConditionReactCtrl: () => generateConditionReactCtrl,
    generateReactExprInJS: () => generateReactExprInJS,
    generateReactLoopCtrl: () => generateReactLoopCtrl,
    isPureString: () => isPureString
  });
  init_define_process();

  // node_modules/fp-ts/es6/function.js
  init_define_process();
  function pipe(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch (arguments.length) {
      case 1:
        return a;
      case 2:
        return ab(a);
      case 3:
        return bc(ab(a));
      case 4:
        return cd(bc(ab(a)));
      case 5:
        return de(cd(bc(ab(a))));
      case 6:
        return ef(de(cd(bc(ab(a)))));
      case 7:
        return fg(ef(de(cd(bc(ab(a))))));
      case 8:
        return gh(fg(ef(de(cd(bc(ab(a)))))));
      case 9:
        return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
      default: {
        var ret = arguments[0];
        for (var i = 1; i < arguments.length; i++) {
          ret = arguments[i](ret);
        }
        return ret;
      }
    }
  }

  // src/utils/encodeJsxAttrString.ts
  init_define_process();
  var SPECIAL_CHARS = `
\r'"<>&`;
  var SPECIAL_CHARS_REG = new RegExp(
    `[${SPECIAL_CHARS.split("").map((c) => `\\x${lodash_default_default.padStart(c.charCodeAt(0).toString(16), 2, "0")}`).join("")}]`,
    "g"
  );
  function encodeJsxStringNode(str) {
    return str.replace(SPECIAL_CHARS_REG, (c) => `&#${c.charCodeAt(0)};`);
  }

  // src/core/jsx/handlers/transformThis2Context.ts
  init_define_process();
  var import_generator14 = __toESM(require_lib6());
  function transformThis2Context(expr, scope, { ignoreRootScope = false } = {}) {
    var _a;
    if (ignoreRootScope && scope.parent == null) {
      return typeof expr === "string" ? expr : (0, import_generator14.default)(expr).code;
    }
    return parseExpressionConvertThis2Context(
      expr,
      "__$$context",
      ((_a = scope.bindings) == null ? void 0 : _a.getAllBindings()) || []
    );
  }

  // src/utils/nodeToJSX.ts
  function mergeNodeGeneratorConfig(cfg1, cfg2 = {}) {
    const resCfg = {};
    if (cfg1.handlers || cfg2.handlers) {
      resCfg.handlers = {
        ...cfg1.handlers || {},
        ...cfg2.handlers || {}
      };
    }
    if (cfg1.tagMapping || cfg2.tagMapping) {
      resCfg.tagMapping = cfg2.tagMapping || cfg1.tagMapping;
    }
    if (cfg1.attrPlugins || cfg2.attrPlugins) {
      resCfg.attrPlugins = [];
      resCfg.attrPlugins.push(...cfg2.attrPlugins || []);
      resCfg.attrPlugins.push(...cfg1.attrPlugins || []);
    }
    if (cfg1.nodePlugins || cfg2.nodePlugins) {
      resCfg.nodePlugins = [];
      resCfg.nodePlugins.push(...cfg2.nodePlugins || []);
      resCfg.nodePlugins.push(...cfg1.nodePlugins || []);
    }
    return resCfg;
  }
  function isPureString(v) {
    return v[0] === "'" && v[v.length - 1] === "'" || v[0] === '"' && v[v.length - 1] === '"';
  }
  function generateAttrValue(attrData, scope, config) {
    const valueStr = generateCompositeType(attrData.attrValue, scope, {
      handlers: config == null ? void 0 : config.handlers,
      nodeGenerator: config == null ? void 0 : config.self
    });
    return [
      {
        type: "NodeCodePieceAttr" /* ATTR */,
        name: attrData.attrName,
        value: valueStr
      }
    ];
  }
  function generateAttr(attrName, attrValue, scope, config) {
    let pieces;
    if (config == null ? void 0 : config.attrPlugins) {
      pieces = executeFunctionStack(
        { attrName, attrValue },
        scope,
        config.attrPlugins,
        generateAttrValue,
        config
      );
    } else {
      pieces = generateAttrValue({ attrName, attrValue }, scope, config);
    }
    pieces = pieces.map((p) => {
      let newValue;
      if (p.value && isPureString(p.value)) {
        const content = getStaticExprValue(p.value);
        newValue = JSON.stringify(encodeJsxStringNode(content));
      } else {
        newValue = `{${p.value}}`;
      }
      return {
        value: `${p.name}=${newValue}`,
        type: "NodeCodePieceAttr" /* ATTR */
      };
    });
    return pieces;
  }
  function generateAttrs(nodeItem, scope, config) {
    const { props } = nodeItem;
    let pieces = [];
    if (props) {
      if (!Array.isArray(props)) {
        Object.keys(props).forEach((propName) => {
          pieces = pieces.concat(generateAttr(propName, props[propName], scope, config));
        });
      } else {
        props.forEach((prop) => {
          if (prop.name && !prop.spread) {
            pieces = pieces.concat(generateAttr(prop.name, prop.value, scope, config));
          }
        });
      }
    }
    return pieces;
  }
  function generateBasicNode(nodeItem, scope, config) {
    const pieces = [];
    const tagName = ((config == null ? void 0 : config.tagMapping) || lodash_default_default.identity)(nodeItem.componentName);
    pieces.push({
      value: tagName || "",
      type: "NodeCodePieceTag" /* TAG */
    });
    return pieces;
  }
  function generateSimpleNode(nodeItem, scope, config) {
    const basicParts = generateBasicNode(nodeItem, scope, config) || [];
    const attrParts = generateAttrs(nodeItem, scope, config) || [];
    const childrenParts = [];
    if (nodeItem.children && (config == null ? void 0 : config.self)) {
      const childrenStr = config.self(nodeItem.children, scope);
      childrenParts.push({
        type: "NodeCodePieceChildren" /* CHILDREN */,
        value: childrenStr
      });
    }
    return [...basicParts, ...attrParts, ...childrenParts];
  }
  function linkPieces(pieces) {
    const tagsPieces = pieces.filter((p) => p.type === "NodeCodePieceTag" /* TAG */);
    if (tagsPieces.length !== 1) {
      throw new CodeGeneratorError("One node only need one tag define");
    }
    const tagName = tagsPieces[0].value;
    const beforeParts = pieces.filter((p) => p.type === "NodeCodePieceBefore" /* BEFORE */).map((p) => p.value).join("");
    const afterParts = pieces.filter((p) => p.type === "NodeCodePieceAfter" /* AFTER */).map((p) => p.value).join("");
    const childrenParts = pieces.filter((p) => p.type === "NodeCodePieceChildren" /* CHILDREN */).map((p) => p.value).join("");
    let attrsParts = pieces.filter((p) => p.type === "NodeCodePieceAttr" /* ATTR */).map((p) => p.value).join(" ");
    attrsParts = attrsParts ? ` ${attrsParts}` : "";
    if (childrenParts) {
      return `${beforeParts}<${tagName}${attrsParts}>${childrenParts}</${tagName}>${afterParts}`;
    }
    return `${beforeParts}<${tagName}${attrsParts} />${afterParts}`;
  }
  function generateNodeSchema(nodeItem, scope, config) {
    const pieces = [];
    if (config == null ? void 0 : config.nodePlugins) {
      const res = executeFunctionStack(
        nodeItem,
        scope,
        config.nodePlugins,
        generateSimpleNode,
        config
      );
      pieces.push(...res);
    } else {
      pieces.push(...generateSimpleNode(nodeItem, scope, config));
    }
    return linkPieces(pieces);
  }
  function generateReactLoopCtrl(nodeItem, scope, config, next) {
    var _a, _b, _c;
    if (nodeItem.loop) {
      const tolerateEvalErrors = (_a = config == null ? void 0 : config.tolerateEvalErrors) != null ? _a : true;
      const loopItemName = ((_b = nodeItem.loopArgs) == null ? void 0 : _b[0]) || "item";
      const loopIndexName = ((_c = nodeItem.loopArgs) == null ? void 0 : _c[1]) || "index";
      const subScope = scope.createSubScope([loopItemName, loopIndexName]);
      const pieces = next ? next(nodeItem, subScope, config) : [];
      const loopDataExpr = pipe(
        nodeItem.loop,
        (expr) => generateCompositeType(expr, scope, {
          handlers: config == null ? void 0 : config.handlers,
          tolerateEvalErrors: false
        }),
        (expr) => transformThis2Context(expr, scope, { ignoreRootScope: true }),
        (expr) => tolerateEvalErrors ? `__$$evalArray(() => (${expr}))` : expr
      );
      pieces.unshift({
        value: `(${loopDataExpr}).map((${loopItemName}, ${loopIndexName}) => ((__$$context) => (`,
        type: "NodeCodePieceBefore" /* BEFORE */
      });
      pieces.push({
        value: `))(__$$createChildContext(__$$context, { ${loopItemName}, ${loopIndexName} })))`,
        type: "NodeCodePieceAfter" /* AFTER */
      });
      return pieces;
    }
    return next ? next(nodeItem, scope, config) : [];
  }
  function generateConditionReactCtrl(nodeItem, scope, config, next) {
    const pieces = next ? next(nodeItem, scope, config) : [];
    if (nodeItem.condition != null && nodeItem.condition !== true) {
      const value = generateCompositeType(nodeItem.condition, scope, {
        handlers: config == null ? void 0 : config.handlers
      });
      pieces.unshift({
        value: `!!(${value}) && (`,
        type: "NodeCodePieceBefore" /* BEFORE */
      });
      pieces.push({
        value: ")",
        type: "NodeCodePieceAfter" /* AFTER */
      });
    }
    return pieces;
  }
  function generateReactExprInJS(nodeItem, scope, config, next) {
    const pieces = next ? next(nodeItem, scope, config) : [];
    if (nodeItem.condition != null && nodeItem.condition !== true || nodeItem.loop != null) {
      pieces.unshift({
        value: "{",
        type: "NodeCodePieceBefore" /* BEFORE */
      });
      pieces.push({
        value: "}",
        type: "NodeCodePieceAfter" /* AFTER */
      });
    }
    return pieces;
  }
  var handleChildren = (v) => v.join("");
  function createNodeGenerator(cfg = {}) {
    const generateNode = (nodeItem, scope) => {
      if (lodash_default_default.isArray(nodeItem)) {
        const resList = nodeItem.map((n) => generateNode(n, scope));
        return handleChildren(resList);
      }
      if (isNodeSchema(nodeItem)) {
        return generateNodeSchema(nodeItem, scope, {
          ...cfg,
          self: generateNode
        });
      }
      const valueStr = generateCompositeType(nodeItem, scope, {
        handlers: cfg.handlers,
        nodeGenerator: generateNode
      });
      if (isPureString(valueStr)) {
        return encodeJsxStringNode(getStaticExprValue(valueStr));
      }
      return `{${valueStr}}`;
    };
    return (nodeItem, scope) => unwrapJsExprQuoteInJsx(generateNode(nodeItem, scope));
  }
  var defaultReactGeneratorConfig = {
    nodePlugins: [generateReactExprInJS, generateReactLoopCtrl, generateConditionReactCtrl]
  };
  function createReactNodeGenerator(cfg) {
    const newCfg = mergeNodeGeneratorConfig(defaultReactGeneratorConfig, cfg);
    return createNodeGenerator(newCfg);
  }

  // src/core/jsx/handlers/transformJsExpression.ts
  init_define_process();

  // src/core/jsx/util/isLiteralAtomicExpr.ts
  init_define_process();
  function isLiteralAtomicExpr(expr) {
    return expr === "null" || expr === "undefined" || expr === "true" || expr === "false" || /^-?\d+(\.\d+)?$/.test(expr);
  }

  // src/core/jsx/util/isSimpleStraightLiteral.ts
  init_define_process();
  function isSimpleStraightLiteral(expr) {
    switch (expr.type) {
      case "BigIntLiteral":
      case "BooleanLiteral":
      case "DecimalLiteral":
      case "NullLiteral":
      case "NumericLiteral":
      case "RegExpLiteral":
      case "StringLiteral":
        return true;
      default:
        return false;
    }
  }

  // src/core/jsx/handlers/transformJsExpression.ts
  function transformJsExpr(expr, scope, { dontWrapEval = false, dontTransformThis2ContextAtRootScope = false } = {}) {
    if (!expr) {
      return "undefined";
    }
    if (isLiteralAtomicExpr(expr)) {
      return expr;
    }
    const exprAst = parseExpression2(expr);
    if (isSimpleStraightLiteral(exprAst)) {
      return expr;
    }
    if (dontWrapEval) {
      return transformThis2Context(exprAst, scope, {
        ignoreRootScope: dontTransformThis2ContextAtRootScope
      });
    }
    switch (exprAst.type) {
      case "ArrowFunctionExpression":
      case "FunctionExpression":
        return transformThis2Context(exprAst, scope, {
          ignoreRootScope: dontTransformThis2ContextAtRootScope
        });
      default:
        break;
    }
    return `__$$eval(() => (${transformThis2Context(exprAst, scope, {
      ignoreRootScope: dontTransformThis2ContextAtRootScope
    })}))`;
  }

  // src/plugins/component/react/jsx.ts
  var pluginFactory10 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      nodeTypeMapping: {},
      ...config
    };
    const { nodeTypeMapping } = cfg;
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const { tolerateEvalErrors = true, evalErrorsHandler = "" } = next.contextData;
      const customHandlers = {
        expression(input, scope2, config2) {
          var _a;
          return transformJsExpr(generateExpression(input, scope2), scope2, {
            dontWrapEval: !((_a = config2 == null ? void 0 : config2.tolerateEvalErrors) != null ? _a : tolerateEvalErrors),
            dontTransformThis2ContextAtRootScope: true
          });
        },
        function(input, scope2) {
          return transformThis2Context(
            generateCompositeType(
              {
                type: "JSFunction",
                value: input.value || "null"
              },
              Scope.createRootScope()
            ),
            scope2,
            { ignoreRootScope: true }
          );
        }
      };
      const generatorPlugins = {
        handlers: customHandlers,
        tagMapping: (v) => nodeTypeMapping[v] || v,
        tolerateEvalErrors
      };
      if (next.contextData.useRefApi) {
        generatorPlugins.attrPlugins = [
          (attrData, scope2, pluginCfg, nextFunc) => {
            if (attrData.attrName === "ref") {
              return [
                {
                  name: attrData.attrName,
                  value: `this._refsManager.linkRef('${attrData.attrValue}')`,
                  type: "NodeCodePieceAttr" /* ATTR */
                }
              ];
            }
            return nextFunc ? nextFunc(attrData, scope2, pluginCfg) : [];
          }
        ];
      }
      const generator = createReactNodeGenerator(generatorPlugins);
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const jsxContent = generator(ir, scope);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: REACT_CHUNK_NAME.ClassRenderJSX,
        content: `
        const __$$context = this._context || this;
        const { state } = __$$context;
        return ${jsxContent};
      `,
        linkAfter: [REACT_CHUNK_NAME.ClassRenderStart, REACT_CHUNK_NAME.ClassRenderPre]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: [
          tolerateEvalErrors && `
          function __$$eval(expr) {
            try {
              return expr();
            } catch (error) { 
              ${evalErrorsHandler}
            }
          }

          function __$$evalArray(expr) {
            const res = __$$eval(expr);
            return Array.isArray(res) ? res : [];
          }
      `,
          `
        function __$$createChildContext(oldContext, ext) {
          const childContext = {
            ...oldContext,
            ...ext,
          };
          childContext.__proto__ = oldContext;
          return childContext;
        }
      `
        ].filter(Boolean).join("\n"),
        linkAfter: [COMMON_CHUNK_NAME.FileExport]
      });
      return next;
    };
    return plugin;
  };
  var jsx_default = pluginFactory10;

  // src/plugins/component/react/reactCommonDeps.ts
  init_define_process();
  var pluginFactory11 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
// \u6CE8\u610F: \u51FA\u7801\u5F15\u64CE\u6CE8\u5165\u7684\u4E34\u65F6\u53D8\u91CF\u9ED8\u8BA4\u90FD\u4EE5 "__$$" \u5F00\u5934\uFF0C\u7981\u6B62\u5728\u642D\u5EFA\u7684\u4EE3\u7801\u4E2D\u76F4\u63A5\u8BBF\u95EE\u3002
// \u4F8B\u5916\uFF1Areact \u6846\u67B6\u7684\u5BFC\u51FA\u540D\u548C\u5404\u79CD\u7EC4\u4EF6\u540D\u9664\u5916\u3002
import React from 'react';`,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var reactCommonDeps_default = pluginFactory11;

  // src/plugins/component/style/css.ts
  init_define_process();
  var pluginFactory12 = (config) => {
    const cfg = {
      fileType: "css" /* CSS */,
      moduleFileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: ir.css,
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.moduleFileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `import './index.${cfg.fileType}';`,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      return next;
    };
    return plugin;
  };
  var css_default = pluginFactory12;

  // src/plugins/project/constants.ts
  init_define_process();
  var pluginFactory13 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const constantStr = generateCompositeType(ir.constants || {}, scope);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileVarDefine,
        content: `
        const __$$constants = (${constantStr});
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export default __$$constants;
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var constants_default = pluginFactory13;

  // src/plugins/project/i18n.ts
  init_define_process();
  var pluginFactory14 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const i18nStr = ir.i18n ? JSON.stringify(ir.i18n, null, 2) : "{}";
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: `
        const i18nConfig = ${i18nStr};

        let locale = typeof navigator === 'object' && typeof navigator.language === 'string' ? navigator.language : 'zh-CN';

        const getLocale = () => locale;

        const setLocale = (target) => {
          locale = target;
        };

        const isEmptyVariables = variables => (
          Array.isArray(variables) && variables.length === 0 
          || typeof variables === 'object' && (!variables || Object.keys(variables).length === 0)
        );

        // \u6309\u4F4E\u4EE3\u7801\u89C4\u8303\u91CC\u9762\u7684\u8981\u6C42\u8FDB\u884C\u53D8\u91CF\u66FF\u6362
        const format = (msg, variables) => (
          typeof msg === 'string' 
            ? msg.replace(/\\$\\{(\\w+)\\}/g, (match, key) => variables?.[key] ?? '')
            : msg
        );

        const i18nFormat = ({ id, defaultMessage, fallback }, variables) => {
          const msg = i18nConfig[locale]?.[id] ??  i18nConfig[locale.replace('-', '_')]?.[id] ??  defaultMessage;
          if (msg == null) {
            console.warn('[i18n]: unknown message id: %o (locale=%o)', id, locale);
            return fallback === undefined ? \`\${id}\` : fallback;
          }

          return format(msg, variables);
        }

        const i18n = (id, params) => {
          return i18nFormat({ id }, params);
        };

        // \u5C06\u56FD\u9645\u5316\u7684\u4E00\u4E9B\u65B9\u6CD5\u6CE8\u5165\u5230\u76EE\u6807\u5BF9\u8C61&\u4E0A\u4E0B\u6587\u4E2D
        const _inject2 = (target) => {
          target.i18n = i18n;
          target.getLocale = getLocale;
          target.setLocale = (locale) => {
            setLocale(locale);
            target.forceUpdate();
          };
          target._i18nText = (t) => {
            // \u4F18\u5148\u53D6\u76F4\u63A5\u4F20\u8FC7\u6765\u7684\u8BED\u6599
            const localMsg = t[locale] ?? t[String(locale).replace('-', '_')] 
            if (localMsg != null) {
              return format(localMsg, t.params);
            }

            // \u5176\u6B21\u7528\u9879\u76EE\u7EA7\u522B\u7684
            const projectMsg = i18nFormat({ id: t.key, fallback: null }, t.params);
            if (projectMsg != null) {
              return projectMsg;
            }

            // \u515C\u5E95\u7528 use \u6307\u5B9A\u7684\u6216\u9ED8\u8BA4\u8BED\u8A00\u7684
            return format(t[t.use || "zh_CN"] ?? t.en_US, t.params);
          }

          // \u6CE8\u5165\u5230\u4E0A\u4E0B\u6587\u4E2D\u53BB
          if (target._context && target._context !== target) {
            Object.assign(target._context, {
              i18n,
              getLocale, setLocale: target.setLocale
            });
          }
        }
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export {
          getLocale,
          setLocale,
          i18n,
          i18nFormat,
          _inject2,
        };
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var i18n_default = pluginFactory14;

  // src/plugins/project/utils.ts
  init_define_process();
  var pluginFactory15 = (baseFramework) => {
    const plugin = async (pre) => {
      const framework = baseFramework || "react";
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        import { createRef } from '${framework}';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileUtilDefine,
        content: `
        export class RefsManager {
          constructor() {
            this.refInsStore = {};
          }

          clearNullRefs() {
            Object.keys(this.refInsStore).forEach((refName) => {
              const filteredInsList = this.refInsStore[refName].filter(insRef => !!insRef.current);
              if (filteredInsList.length > 0) {
                this.refInsStore[refName] = filteredInsList;
              } else {
                delete this.refInsStore[refName];
              }
            });
          }

          get(refName) {
            this.clearNullRefs();
            if (this.refInsStore[refName] && this.refInsStore[refName].length > 0) {
              return this.refInsStore[refName][0].current;
            }

            return null;
          }

          getAll(refName) {
            this.clearNullRefs();
            if (this.refInsStore[refName] && this.refInsStore[refName].length > 0) {
              return this.refInsStore[refName].map(i => i.current);
            }

            return [];
          }

          linkRef(refName) {
            const refIns = createRef();
            this.refInsStore[refName] = this.refInsStore[refName] || [];
            this.refInsStore[refName].push(refIns);
            return refIns;
          }
        }
      `,
        linkAfter: [...DEFAULT_LINK_AFTER[COMMON_CHUNK_NAME.FileUtilDefine]]
      });
      if (ir.utils) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "js" /* JS */,
          name: COMMON_CHUNK_NAME.FileExport,
          content: `
          export default {
        `,
          linkAfter: [
            COMMON_CHUNK_NAME.ExternalDepsImport,
            COMMON_CHUNK_NAME.InternalDepsImport,
            COMMON_CHUNK_NAME.ImportAliasDefine,
            COMMON_CHUNK_NAME.FileVarDefine,
            COMMON_CHUNK_NAME.FileUtilDefine,
            COMMON_CHUNK_NAME.FileMainContent
          ]
        });
        ir.utils.forEach((util) => {
          if (util.type === "function") {
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: "js" /* JS */,
              name: COMMON_CHUNK_NAME.FileVarDefine,
              content: `
              const ${util.name} = ${util.content.value};
            `,
              linkAfter: [
                COMMON_CHUNK_NAME.ExternalDepsImport,
                COMMON_CHUNK_NAME.InternalDepsImport,
                COMMON_CHUNK_NAME.ImportAliasDefine
              ]
            });
          }
          next.chunks.push({
            type: "string" /* STRING */,
            fileType: "js" /* JS */,
            name: COMMON_CHUNK_NAME.FileExport,
            content: `${util.name},`,
            linkAfter: [
              COMMON_CHUNK_NAME.ExternalDepsImport,
              COMMON_CHUNK_NAME.InternalDepsImport,
              COMMON_CHUNK_NAME.ImportAliasDefine,
              COMMON_CHUNK_NAME.FileVarDefine,
              COMMON_CHUNK_NAME.FileUtilDefine,
              COMMON_CHUNK_NAME.FileMainContent
            ]
          });
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "js" /* JS */,
          name: COMMON_CHUNK_NAME.FileExport,
          content: `
          };
        `,
          linkAfter: [
            COMMON_CHUNK_NAME.ExternalDepsImport,
            COMMON_CHUNK_NAME.InternalDepsImport,
            COMMON_CHUNK_NAME.ImportAliasDefine,
            COMMON_CHUNK_NAME.FileVarDefine,
            COMMON_CHUNK_NAME.FileUtilDefine,
            COMMON_CHUNK_NAME.FileMainContent
          ]
        });
      }
      return next;
    };
    return plugin;
  };
  var utils_default = pluginFactory15;

  // src/plugins/project/framework/icejs/index.ts
  init_define_process();

  // src/plugins/project/framework/icejs/template/index.ts
  init_define_process();

  // src/plugins/project/framework/icejs/template/static-files.ts
  init_define_process();
  function generateStaticFiles(root2 = createResultDir(".")) {
    return root2;
  }

  // src/plugins/project/framework/icejs/template/index.ts
  var icejsTemplate = {
    slots: {
      components: {
        path: ["src", "components"]
      },
      pages: {
        path: ["src", "pages"]
      },
      router: {
        path: ["src"],
        fileName: "routes"
      },
      entry: {
        path: ["src"],
        fileName: "app"
      },
      constants: {
        path: ["src"],
        fileName: "constants"
      },
      utils: {
        path: ["src"],
        fileName: "utils"
      },
      i18n: {
        path: ["src"],
        fileName: "i18n"
      },
      globalStyle: {
        path: ["src"],
        fileName: "global"
      },
      htmlEntry: {
        path: ["public"],
        fileName: "index"
      },
      packageJSON: {
        path: [],
        fileName: "package"
      }
    },
    generateTemplate() {
      return generateStaticFiles();
    }
  };
  var template_default2 = icejsTemplate;

  // src/plugins/project/framework/icejs/plugins/entry.ts
  init_define_process();
  var pluginFactory16 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        import { createApp } from 'ice';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: `
        const appConfig = {
          app: {
            rootId: 'app',
          },
          router: {
            type: 'hash',
          },
        };
        createApp(appConfig);
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      return next;
    };
    return plugin;
  };
  var entry_default = pluginFactory16;

  // src/plugins/project/framework/icejs/plugins/entryHtml.ts
  init_define_process();
  var pluginFactory17 = () => {
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "html" /* HTML */,
        name: COMMON_CHUNK_NAME.HtmlContent,
        content: `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8" />
            <meta http-equiv="x-ua-compatible" content="ie=edge,chrome=1" />
            <meta name="viewport" content="width=device-width" />
            <title>${((_a = ir == null ? void 0 : ir.meta) == null ? void 0 : _a.name) || "Ice App"}</title>
          </head>
          <body>
            <div id="app"></div>
          </body>
        </html>
      `,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var entryHtml_default = pluginFactory17;

  // src/plugins/project/framework/icejs/plugins/globalStyle.ts
  init_define_process();
  var pluginFactory18 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleDepsImport,
        content: `
        // \u5F15\u5165\u9ED8\u8BA4\u5168\u5C40\u6837\u5F0F
        @import '@alifd/next/reset.scss';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: `
        body {
          -webkit-font-smoothing: antialiased;
        }
      `,
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: ir.css || "",
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      return next;
    };
    return plugin;
  };
  var globalStyle_default = pluginFactory18;

  // src/plugins/project/framework/icejs/plugins/packageJSON.ts
  init_define_process();

  // src/utils/dataSource.ts
  init_define_process();
  var import_change_case5 = __toESM(require_change_case());
  function buildDataSourceDependencies(ir, cfg = {}) {
    return {
      [cfg.enginePackage || "@alilc/lowcode-datasource-engine"]: cfg.engineVersion || "latest",
      ...(ir.dataSourcesTypes || []).reduce(
        (acc, dsType) => {
          var _a;
          return {
            ...acc,
            [getDataSourceHandlerPackageName(dsType)]: ((_a = cfg.handlersVersion) == null ? void 0 : _a[dsType]) || "latest"
          };
        },
        {}
      )
    };
    function getDataSourceHandlerPackageName(dsType) {
      var _a;
      return ((_a = cfg.handlersPackages) == null ? void 0 : _a[dsType]) || `@alilc/lowcode-datasource-${import_change_case5.default.kebab(dsType)}-handler`;
    }
  }

  // src/plugins/project/framework/icejs/plugins/packageJSON.ts
  var pluginFactory19 = (cfg) => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const packageJson = {
        name: (cfg == null ? void 0 : cfg.packageName) || "icejs-demo-app",
        version: (cfg == null ? void 0 : cfg.packageVersion) || "0.1.5",
        description: "\u8F7B\u91CF\u7EA7\u6A21\u677F\uFF0C\u4F7F\u7528 JavaScript\uFF0C\u4EC5\u5305\u542B\u57FA\u7840\u7684 Layout\u3002",
        dependencies: {
          moment: "^2.24.0",
          react: "^16.4.1",
          "react-dom": "^16.4.1",
          "react-router": "^5.2.1",
          "@alifd/theme-design-pro": "^0.x",
          "intl-messageformat": "^9.3.6",
          "@ice/store": "^1.4.3",
          "@loadable/component": "^5.15.2",
          ...buildDataSourceDependencies(ir, cfg == null ? void 0 : cfg.datasourceConfig)
        },
        devDependencies: {
          "@ice/spec": "^1.0.0",
          "build-plugin-fusion": "^0.1.0",
          "build-plugin-moment-locales": "^0.1.0",
          eslint: "^6.0.1",
          "ice.js": "^1.0.0",
          stylelint: "^13.2.0"
        },
        scripts: {
          start: "icejs start",
          build: "icejs build",
          lint: "npm run eslint && npm run stylelint",
          eslint: "eslint --cache --ext .js,.jsx ./",
          stylelint: "stylelint ./**/*.scss"
        },
        ideMode: {
          name: "ice-react"
        },
        iceworks: {
          type: "react",
          adapter: "adapter-react-v3"
        },
        engines: {
          node: ">=8.0.0"
        },
        repository: {
          type: "git",
          url: "http://gitlab.xxx.com/msd/leak-scan/tree/master"
        },
        private: true,
        originTemplate: "@alifd/scaffold-lite-js"
      };
      ir.packages.forEach((packageInfo) => {
        packageJson.dependencies[packageInfo.package] = packageInfo.version;
      });
      next.chunks.push({
        type: "json" /* JSON */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: packageJson,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var packageJSON_default = pluginFactory19;

  // src/plugins/project/framework/icejs/plugins/router.ts
  init_define_process();
  var pluginFactory20 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import BasicLayout from '@/layouts/BasicLayout';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileVarDefine,
        content: `
        const routerConfig = [
          {
            path: '/',
            component: BasicLayout,
            children: [
              ${ir.routes.map(
          (route) => `
                    {
                      path: '${route.path}',
                      component: ${route.componentName},
                    }
                  `
        ).join(",")}
            ],
          },
        ];
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export default routerConfig;
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var router_default = pluginFactory20;

  // src/plugins/project/framework/icejs/index.ts
  var icejs_default = {
    template: template_default2,
    plugins: {
      entry: entry_default,
      entryHtml: entryHtml_default,
      globalStyle: globalStyle_default,
      packageJSON: packageJSON_default,
      router: router_default
    }
  };

  // src/postprocessor/index.ts
  init_define_process();

  // src/postprocessor/prettier/index.ts
  init_define_process();
  var import_prettier = __toESM(require_standalone());
  var import_parser_babel = __toESM(require_parser_babel());
  var import_parser_postcss = __toESM(require_parser_postcss());
  var import_parser_html = __toESM(require_parser_html());
  var PARSERS = ["css", "scss", "less", "json", "html", "vue"];
  var factory = (config) => {
    const cfg = {
      customFileTypeParser: {},
      ...config
    };
    const codePrettier = (content, fileType) => {
      let parser3;
      if (fileType === "js" || fileType === "jsx") {
        parser3 = "babel";
      } else if (PARSERS.indexOf(fileType) >= 0) {
        parser3 = fileType;
      } else if (cfg.customFileTypeParser[fileType]) {
        parser3 = cfg.customFileTypeParser[fileType];
      } else {
        return content;
      }
      return import_prettier.default.format(content, {
        parser: parser3,
        plugins: [import_parser_babel.default, import_parser_postcss.default, import_parser_html.default, ...cfg.plugins || []]
      });
    };
    return codePrettier;
  };
  var prettier_default = factory;

  // src/solutions/icejs.ts
  function createIceJsProjectBuilder(options) {
    return createProjectBuilder({
      inStrictMode: options == null ? void 0 : options.inStrictMode,
      extraContextData: { ...options },
      template: icejs_default.template,
      plugins: {
        components: [
          reactCommonDeps_default(),
          esmodule_default({
            fileType: "jsx"
          }),
          containerClass_default(),
          containerInjectContext_default(),
          containerInjectUtils_default(),
          containerInjectDataSourceEngine_default(),
          containerInjectI18n_default(),
          containerInitState_default(),
          containerLifeCycle_default(),
          containerMethod_default(),
          jsx_default({
            nodeTypeMapping: {
              Div: "div",
              Component: "div",
              Page: "div",
              Block: "div"
            }
          }),
          css_default()
        ],
        pages: [
          reactCommonDeps_default(),
          esmodule_default({
            fileType: "jsx"
          }),
          containerClass_default(),
          containerInjectContext_default(),
          containerInjectUtils_default(),
          containerInjectDataSourceEngine_default(),
          containerInjectI18n_default(),
          containerInitState_default(),
          containerLifeCycle_default(),
          containerMethod_default(),
          jsx_default({
            nodeTypeMapping: {
              Div: "div",
              Component: "div",
              Page: "div",
              Block: "div"
            }
          }),
          css_default()
        ],
        router: [esmodule_default(), icejs_default.plugins.router()],
        entry: [icejs_default.plugins.entry()],
        constants: [constants_default()],
        utils: [esmodule_default(), utils_default("react")],
        i18n: [i18n_default()],
        globalStyle: [icejs_default.plugins.globalStyle()],
        htmlEntry: [icejs_default.plugins.entryHtml()],
        packageJSON: [icejs_default.plugins.packageJSON()]
      },
      postProcessors: [prettier_default()]
    });
  }
  var plugins = {
    containerClass: containerClass_default,
    containerInitState: containerInitState_default,
    containerInjectContext: containerInjectContext_default,
    containerInjectUtils: containerInjectUtils_default,
    containerInjectI18n: containerInjectI18n_default,
    containerInjectDataSourceEngine: containerInjectDataSourceEngine_default,
    containerLifeCycle: containerLifeCycle_default,
    containerMethod: containerMethod_default,
    jsx: jsx_default,
    commonDeps: reactCommonDeps_default,
    reactCommonDeps: reactCommonDeps_default
  };

  // src/solutions/rax-app.ts
  init_define_process();

  // src/plugins/component/rax/containerClass.ts
  init_define_process();
  var import_change_case6 = __toESM(require_change_case());

  // src/plugins/component/rax/const.ts
  init_define_process();
  var RAX_CHUNK_NAME = {
    ClassDidMountBegin: "RaxComponentClassDidMountBegin",
    ClassDidMountContent: "RaxComponentClassDidMountContent",
    ClassDidMountEnd: "RaxComponentClassDidMountEnd",
    ClassWillUnmountBegin: "RaxComponentClassWillUnmountBegin",
    ClassWillUnmountContent: "RaxComponentClassWillUnmountContent",
    ClassWillUnmountEnd: "RaxComponentClassWillUnmountEnd",
    ClassRenderBegin: "RaxComponentClassRenderBegin",
    ClassRenderPre: "RaxComponentClassRenderPre",
    ClassRenderJSX: "RaxComponentClassRenderJSX",
    ClassRenderEnd: "RaxComponentClassRenderEnd",
    MethodsBegin: "RaxComponentMethodsBegin",
    MethodsContent: "RaxComponentMethodsContent",
    MethodsEnd: "RaxComponentMethodsEnd",
    LifeCyclesBegin: "RaxComponentLifeCyclesBegin",
    LifeCyclesContent: "RaxComponentLifeCyclesContent",
    LifeCyclesEnd: "RaxComponentLifeCyclesEnd"
  };

  // src/plugins/component/rax/containerClass.ts
  var pluginFactory21 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const componentClassName = ensureValidClassName(
        `${import_change_case6.default.pascalCase(ir.moduleName)}$$Page`
      );
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.Start,
        content: `class ${componentClassName} extends Component {`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.End,
        content: "}",
        linkAfter: [
          CLASS_DEFINE_CHUNK_NAME.Start,
          CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
          RAX_CHUNK_NAME.ClassRenderEnd,
          RAX_CHUNK_NAME.MethodsEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorStart,
        content: "constructor(props, context) { super(props); ",
        linkAfter: DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorEnd,
        content: "} /* end of constructor */",
        linkAfter: DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorEnd]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassDidMountBegin,
        content: "componentDidMount() {",
        linkAfter: [
          CLASS_DEFINE_CHUNK_NAME.Start,
          CLASS_DEFINE_CHUNK_NAME.InsVar,
          CLASS_DEFINE_CHUNK_NAME.InsMethod,
          CLASS_DEFINE_CHUNK_NAME.ConstructorEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassDidMountEnd,
        content: "} /* end of componentDidMount */",
        linkAfter: [RAX_CHUNK_NAME.ClassDidMountBegin, RAX_CHUNK_NAME.ClassDidMountContent]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassWillUnmountBegin,
        content: "componentWillUnmount() {",
        linkAfter: [
          CLASS_DEFINE_CHUNK_NAME.Start,
          CLASS_DEFINE_CHUNK_NAME.InsVar,
          CLASS_DEFINE_CHUNK_NAME.InsMethod,
          RAX_CHUNK_NAME.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassWillUnmountEnd,
        content: "} /* end of componentWillUnmount */",
        linkAfter: [RAX_CHUNK_NAME.ClassWillUnmountBegin, RAX_CHUNK_NAME.ClassWillUnmountContent]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassRenderBegin,
        content: "render() {",
        linkAfter: [RAX_CHUNK_NAME.ClassDidMountEnd, RAX_CHUNK_NAME.ClassWillUnmountEnd]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassRenderEnd,
        content: "} /* end of render */",
        linkAfter: [
          RAX_CHUNK_NAME.ClassRenderBegin,
          RAX_CHUNK_NAME.ClassRenderPre,
          RAX_CHUNK_NAME.ClassRenderJSX
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `export default ${componentClassName};`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          CLASS_DEFINE_CHUNK_NAME.End
        ]
      });
      return next;
    };
    return plugin;
  };
  var containerClass_default2 = pluginFactory21;

  // src/plugins/component/rax/containerLifeCycle.ts
  init_define_process();

  // src/utils/debug.ts
  init_define_process();
  var import_debug = __toESM(require_browser2());
  var debug = (0, import_debug.default)("code-generator");

  // src/plugins/component/rax/containerLifeCycle.ts
  var pluginFactory22 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      exportNameMapping: {},
      normalizeNameMapping: {
        didMount: "componentDidMount",
        willUnmount: "componentWillUnmount"
      },
      ...config
    };
    const exportNameMapping = new Map(Object.entries(cfg.exportNameMapping));
    const normalizeNameMapping = new Map(Object.entries(cfg.normalizeNameMapping));
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const { lifeCycles } = ir;
      if (lifeCycles && !lodash_default_default.isEmpty(lifeCycles)) {
        Object.entries(lifeCycles).forEach(([lifeCycleName, lifeCycleMethodExpr]) => {
          if (!isJSFunction(lifeCycles[lifeCycleName]) && !isJSExpression(lifeCycles[lifeCycleName])) {
            return;
          }
          const normalizeName = normalizeNameMapping.get(lifeCycleName) || lifeCycleName;
          const exportName = exportNameMapping.get(lifeCycleName) || lifeCycleName;
          next.chunks.push({
            type: "string" /* STRING */,
            fileType: cfg.fileType,
            name: RAX_CHUNK_NAME.LifeCyclesContent,
            content: `${exportName}: (${lifeCycleMethodExpr.value}),`,
            linkAfter: [RAX_CHUNK_NAME.LifeCyclesBegin]
          });
          if (normalizeName === "constructor") {
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
              content: `this._lifeCycles.${exportName}();`,
              linkAfter: [CLASS_DEFINE_CHUNK_NAME.ConstructorStart]
            });
          } else if (normalizeName === "componentDidMount") {
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: RAX_CHUNK_NAME.ClassDidMountContent,
              content: `this._lifeCycles.${exportName}();`,
              linkAfter: [RAX_CHUNK_NAME.ClassDidMountBegin]
            });
          } else if (normalizeName === "componentWillUnmount") {
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: RAX_CHUNK_NAME.ClassWillUnmountContent,
              content: `this._lifeCycles.${exportName}();`,
              linkAfter: [RAX_CHUNK_NAME.ClassWillUnmountBegin]
            });
          } else {
            debug(`[CodeGen]: unknown life cycle: ${lifeCycleName}`);
          }
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: "_lifeCycles = this._defineLifeCycles();",
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: RAX_CHUNK_NAME.LifeCyclesBegin,
          content: `
          _defineLifeCycles() {
            const __$$lifeCycles = ({
        `,
          linkAfter: [RAX_CHUNK_NAME.ClassRenderEnd, CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: RAX_CHUNK_NAME.LifeCyclesEnd,
          content: `
            });

            // \u4E3A\u6240\u6709\u7684\u65B9\u6CD5\u7ED1\u5B9A\u4E0A\u4E0B\u6587
            Object.entries(__$$lifeCycles).forEach(([lifeCycleName, lifeCycleMethod]) => {
              if (typeof lifeCycleMethod === 'function') {
                __$$lifeCycles[lifeCycleName] = (...args) => {
                  return lifeCycleMethod.apply(this._context, args);
                }
              }
            });

            return __$$lifeCycles;
          }
        `,
          linkAfter: [RAX_CHUNK_NAME.LifeCyclesBegin, RAX_CHUNK_NAME.LifeCyclesContent]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerLifeCycle_default2 = pluginFactory22;

  // src/plugins/component/rax/containerMethods.ts
  init_define_process();
  var pluginFactory23 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsVar,
        content: `
         _methods = this._defineMethods();
      `,
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: RAX_CHUNK_NAME.MethodsBegin,
        content: `
        _defineMethods() {
          return ({
      `,
        linkAfter: [
          RAX_CHUNK_NAME.ClassRenderEnd,
          CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
          RAX_CHUNK_NAME.LifeCyclesEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: RAX_CHUNK_NAME.MethodsEnd,
        content: `
          });
        }
      `,
        linkAfter: [RAX_CHUNK_NAME.MethodsBegin, RAX_CHUNK_NAME.MethodsContent]
      });
      if (ir.methods && Object.keys(ir.methods).length > 0) {
        Object.entries(ir.methods).forEach(([methodName, methodDefine]) => {
          next.chunks.push({
            type: "string" /* STRING */,
            fileType: cfg.fileType,
            name: RAX_CHUNK_NAME.MethodsContent,
            content: `${methodName}: (${methodDefine.value}),`,
            linkAfter: [RAX_CHUNK_NAME.MethodsBegin]
          });
        });
      }
      return next;
    };
    return plugin;
  };
  var containerMethods_default = pluginFactory23;

  // src/plugins/component/rax/containerInitState.ts
  init_define_process();
  var pluginFactory24 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      implementType: "insMember",
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const state = ir.state || {};
      const fields = Object.keys(state).map((stateName) => {
        const value = generateCompositeType(state[stateName], scope);
        return `${JSON.stringify(stateName)}: ${value}`;
      });
      if (cfg.implementType === "inConstructor") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: `this.state = { ${fields.join(",")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      } else if (cfg.implementType === "insMember") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `state = { ${fields.join(",")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInitState_default2 = pluginFactory24;

  // src/plugins/component/rax/containerInjectContext.ts
  init_define_process();
  var pluginFactory25 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      const useRef = !!((_a = ir.analyzeResult) == null ? void 0 : _a.isUsingRef);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: "import __$$constants from '../../constants';",
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: "import * as __$$i18n from '../../i18n';",
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
        content: `
        __$$i18n._inject2(this);
      `,
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsVar,
        content: `
        _context = this._createContext();
      `,
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
        content: `
        _createContext() {
          const self = this;
          const context = {
            get state() {
              return self.state;
            },
            setState(newState, callback) {
              self.setState(newState, callback);
            },
            get dataSourceMap() {
              return self._dataSourceEngine.dataSourceMap || {};
            },
            async reloadDataSource() {
              await self._dataSourceEngine.reloadDataSource();
            },
            get utils() {
              return self._utils;
            },
            get page() {
              return context;
            },
            get component() {
              return context;
            },
            get props() {
              return self.props;
            },
            get constants() {
              return __$$constants;
            },
            i18n: __$$i18n.i18n,
            i18nFormat: __$$i18n.i18nFormat,
            getLocale: __$$i18n.getLocale,
            setLocale(locale) {
              __$$i18n.setLocale(locale);
              self.forceUpdate();
            },${useRef ? `
                  $(refName) {
                    return self._refsManager.get(refName);
                  },
                  $$(refName) {
                    return self._refsManager.getAll(refName);
                  },
                  get _refsManager() {
                    if (!self._refsManager) {
                      self._refsManager = new RefsManager();
                    }
                    return self._refsManager;
                  },
                ` : ""}
            ...this._methods,
          };

          return context;
        }
      `,
        linkAfter: [RAX_CHUNK_NAME.ClassRenderEnd]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectContext_default2 = pluginFactory25;

  // src/plugins/component/rax/containerInjectDataSourceEngine.ts
  init_define_process();
  var import_change_case7 = __toESM(require_change_case());
  var pluginFactory26 = (config) => {
    var _a;
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config,
      dataSourceHandlersPackageMap: (config == null ? void 0 : config.dataSourceHandlersPackageMap) || ((_a = config == null ? void 0 : config.datasourceConfig) == null ? void 0 : _a.handlersPackages)
    };
    const plugin = async (pre) => {
      var _a2;
      const next = {
        ...pre
      };
      const scope = Scope.createRootScope();
      const dataSourceConfig = isContainerSchema(pre.ir) ? pre.ir.dataSource : null;
      const dataSourceItems = dataSourceConfig && dataSourceConfig.list || [];
      const dataSourceEngineOptions = { runtimeConfig: true };
      if (dataSourceItems.length > 0) {
        const requestHandlersMap = {};
        dataSourceItems.forEach((ds) => {
          var _a3;
          const dsType = ds.type || "fetch";
          if (!(dsType in requestHandlersMap) && dsType !== "custom") {
            const handlerFactoryName = `__$$create${import_change_case7.default.pascal(dsType)}RequestHandler`;
            requestHandlersMap[dsType] = {
              type: "JSExpression",
              value: `${handlerFactoryName}(${dsType === "urlParams" ? "__$$getSearchParams()" : ""})`
            };
            const handlerFactoryExportName = `create${import_change_case7.default.pascal(dsType)}Handler`;
            const handlerPkgName = ((_a3 = cfg.dataSourceHandlersPackageMap) == null ? void 0 : _a3[dsType]) || `@alilc/lowcode-datasource-${import_change_case7.default.kebab(dsType)}-handler`;
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: "jsx" /* JSX */,
              name: COMMON_CHUNK_NAME.ExternalDepsImport,
              content: `
              import { ${handlerFactoryExportName} as ${handlerFactoryName} } from '${handlerPkgName}';
            `,
              linkAfter: []
            });
          }
        });
        Object.assign(dataSourceEngineOptions, { requestHandlersMap });
      }
      const datasourceEnginePackageName = ((_a2 = cfg.datasourceConfig) == null ? void 0 : _a2.enginePackage) || "@alilc/lowcode-datasource-engine";
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        import { create as __$$createDataSourceEngine } from '${datasourceEnginePackageName}/runtime';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsVar,
        content: `
        _dataSourceConfig = this._defineDataSourceConfig();
        _dataSourceEngine = __$$createDataSourceEngine(
          this._dataSourceConfig,
          this._context,
          ${generateCompositeType(dataSourceEngineOptions, scope)}
        );`,
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: RAX_CHUNK_NAME.ClassDidMountContent,
        content: `
        this._dataSourceEngine.reloadDataSource();
      `,
        linkAfter: [RAX_CHUNK_NAME.ClassDidMountBegin]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
        content: `
_defineDataSourceConfig() {
  const __$$context = this._context;
  return (${generateCompositeType(
          {
            ...dataSourceConfig,
            list: [
              ...dataSourceItems.map((item) => {
                var _a3;
                return {
                  errorHandler: {
                    type: "JSFunction",
                    value: `function (err){
              setTimeout(() => {
                this.setState({ __refresh: Date.now() + Math.random() });
              }, 0);
              throw err;
            }`
                  },
                  ...item,
                  isInit: typeof item.isInit === "boolean" || typeof item.isInit === "undefined" ? (_a3 = item.isInit) != null ? _a3 : true : wrapAsFunction2(item.isInit, scope),
                  options: wrapAsFunction2(item.options, scope)
                };
              })
            ]
          },
          scope,
          {
            handlers: {
              function: (jsFunc) => parseExpressionConvertThis2Context(jsFunc.value, "__$$context"),
              expression: (jsExpr) => parseExpressionConvertThis2Context(jsExpr.value, "__$$context")
            }
          }
        )});
}
      `,
        linkAfter: [RAX_CHUNK_NAME.ClassRenderEnd]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectDataSourceEngine_default2 = pluginFactory26;
  function wrapAsFunction2(value, scope) {
    if (isJSExpression(value) || isJSFunction(value)) {
      return {
        type: "JSExpression",
        value: `function(){ return ((${value.value}))}`
      };
    }
    return {
      type: "JSExpression",
      value: `function(){return((${generateCompositeType(value, scope)}))}`
    };
  }

  // src/plugins/component/rax/containerInjectUtils.ts
  init_define_process();
  var pluginFactory27 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      const useRef = !!((_a = ir.analyzeResult) == null ? void 0 : _a.isUsingRef);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import __$$projectUtils${useRef ? ", { RefsManager }" : ""} from '../../utils';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsVar,
        content: "_utils = this._defineUtils();",
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
        content: `
        _defineUtils() {
          return {
            ...__$$projectUtils,
          };
        }`,
        linkAfter: [RAX_CHUNK_NAME.ClassRenderEnd]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectUtils_default2 = pluginFactory27;

  // src/plugins/component/rax/jsx.ts
  init_define_process();
  var import_change_case8 = __toESM(require_change_case());
  var pluginFactory28 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const rootScope = Scope.createRootScope();
      const { tolerateEvalErrors = true, evalErrorsHandler = "" } = next.contextData;
      const componentsNameAliasMap = /* @__PURE__ */ new Map();
      next.chunks.forEach((chunk2) => {
        if (isImportAliasDefineChunk(chunk2)) {
          componentsNameAliasMap.set(chunk2.ext.aliasName, chunk2.ext.originalName);
        }
      });
      const mapComponentNameToAliasOrKeepIt = (componentName) => componentsNameAliasMap.get(componentName) || componentName;
      next.chunks = next.chunks.filter((chunk2) => !isImportAliasDefineChunk(chunk2));
      const customHandlers = {
        expression(input, scope) {
          return transformJsExpr(generateExpression(input, scope), scope, {
            dontWrapEval: !tolerateEvalErrors
          });
        },
        function(input, scope) {
          return transformThis2Context(input.value || "null", scope);
        }
      };
      const commonNodeGenerator = createNodeGenerator({
        handlers: customHandlers,
        tagMapping: mapComponentNameToAliasOrKeepIt,
        nodePlugins: [generateReactExprInJS, generateConditionReactCtrl, generateRaxLoopCtrl],
        attrPlugins: [generateNodeAttrForRax.bind({ cfg })]
      });
      const jsxContent = commonNodeGenerator(ir, rootScope);
      if (!cfg.ignoreMiniApp) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: COMMON_CHUNK_NAME.ExternalDepsImport,
          content: "import { isMiniApp as __$$isMiniApp } from 'universal-env';",
          linkAfter: []
        });
      }
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: RAX_CHUNK_NAME.ClassRenderPre,
        content: `
        const __$$context = this._context;
        const { state, setState, dataSourceMap, reloadDataSource, utils, constants, i18n, i18nFormat, getLocale, setLocale } = __$$context;
      `,
        linkAfter: [RAX_CHUNK_NAME.ClassRenderBegin]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: RAX_CHUNK_NAME.ClassRenderJSX,
        content: `return ${jsxContent};`,
        linkAfter: [RAX_CHUNK_NAME.ClassRenderBegin, RAX_CHUNK_NAME.ClassRenderPre]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: [
          tolerateEvalErrors && `
        function __$$eval(expr) {
          try {
            return expr();
          } catch (error) { 
            ${evalErrorsHandler}
          }
        }

        function __$$evalArray(expr) {
          const res = __$$eval(expr);
          return Array.isArray(res) ? res : [];
        }
        `,
          `
        function __$$createChildContext(oldContext, ext) {
          return Object.assign({}, oldContext, ext);
        }
      `
        ].filter(Boolean).join("\n"),
        linkAfter: [COMMON_CHUNK_NAME.FileExport]
      });
      return next;
      function generateRaxLoopCtrl(nodeItem, scope, config2, next2) {
        var _a, _b;
        if (nodeItem.loop) {
          const loopItemName = ((_a = nodeItem.loopArgs) == null ? void 0 : _a[0]) || "item";
          const loopIndexName = ((_b = nodeItem.loopArgs) == null ? void 0 : _b[1]) || "index";
          const subScope = scope.createSubScope([loopItemName, loopIndexName]);
          const pieces = next2 ? next2(nodeItem, subScope, config2) : [];
          const loopDataExpr = tolerateEvalErrors ? `__$$evalArray(() => (${transformThis2Context(
            generateCompositeType(nodeItem.loop, scope, { handlers: config2 == null ? void 0 : config2.handlers }),
            scope
          )}))` : `(${transformThis2Context(
            generateCompositeType(nodeItem.loop, scope, { handlers: config2 == null ? void 0 : config2.handlers }),
            scope
          )})`;
          pieces.unshift({
            value: `${loopDataExpr}.map((${loopItemName}, ${loopIndexName}) => ((__$$context) => (`,
            type: "NodeCodePieceBefore" /* BEFORE */
          });
          pieces.push({
            value: `))(__$$createChildContext(__$$context, { ${loopItemName}, ${loopIndexName} })))`,
            type: "NodeCodePieceAfter" /* AFTER */
          });
          return pieces;
        }
        return next2 ? next2(nodeItem, scope, config2) : [];
      }
    };
    return plugin;
  };
  var jsx_default2 = pluginFactory28;
  function isImportAliasDefineChunk(chunk2) {
    var _a;
    return chunk2.name === COMMON_CHUNK_NAME.ImportAliasDefine && !!chunk2.ext && typeof chunk2.ext.aliasName === "string" && typeof chunk2.ext.originalName === "string" && !!((_a = chunk2.ext.dependency) == null ? void 0 : _a.componentName);
  }
  function generateNodeAttrForRax(attrData, scope, config, next) {
    if (!this.cfg.ignoreMiniApp && /^on/.test(attrData.attrName)) {
      return generateEventHandlerAttrForRax(attrData.attrName, attrData.attrValue, scope, config);
    }
    if (attrData.attrName === "ref") {
      return [
        {
          name: attrData.attrName,
          value: `__$$context._refsManager.linkRef('${attrData.attrValue}')`,
          type: "NodeCodePieceAttr" /* ATTR */
        }
      ];
    }
    return next ? next(attrData, scope, config) : [];
  }
  function generateEventHandlerAttrForRax(attrName, attrValue, scope, config) {
    var _a;
    const valueExpr = generateCompositeType(
      isJSExpression(attrValue) ? { type: "JSFunction", value: attrValue.value } : attrValue,
      scope,
      {
        handlers: config == null ? void 0 : config.handlers
      }
    );
    const currentScopeVariables = ((_a = scope.bindings) == null ? void 0 : _a.getAllBindings()) || [];
    if (currentScopeVariables.length <= 0) {
      return [
        {
          type: "NodeCodePieceAttr" /* ATTR */,
          name: attrName,
          value: valueExpr
        }
      ];
    }
    const undeclaredVariablesInValueExpr = parseExpressionGetGlobalVariables(valueExpr);
    const referencedLocalVariables = lodash_default_default.intersection(
      undeclaredVariablesInValueExpr,
      currentScopeVariables
    );
    if (referencedLocalVariables.length <= 0) {
      return [
        {
          type: "NodeCodePieceAttr" /* ATTR */,
          name: attrName,
          value: valueExpr
        }
      ];
    }
    const wrappedAttrValueExpr = [
      "(...__$$args) => {",
      "  if (__$$isMiniApp) {",
      "    const __$$event = __$$args[0];",
      ...referencedLocalVariables.map(
        (localVar) => `const ${localVar} = __$$event.target.dataset.${localVar};`
      ),
      `    return (${valueExpr}).apply(this, __$$args);`,
      "  } else {",
      `    return (${valueExpr}).apply(this, __$$args);`,
      "  }",
      "}"
    ].join("\n");
    return [
      ...referencedLocalVariables.map((localVar) => ({
        type: "NodeCodePieceAttr" /* ATTR */,
        name: `data-${import_change_case8.default.snake(localVar)}`,
        value: localVar
      })),
      {
        type: "NodeCodePieceAttr" /* ATTR */,
        name: attrName,
        value: wrappedAttrValueExpr
      }
    ];
  }

  // src/plugins/component/rax/commonDeps.ts
  init_define_process();
  var pluginFactory29 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        // \u6CE8\u610F: \u51FA\u7801\u5F15\u64CE\u6CE8\u5165\u7684\u4E34\u65F6\u53D8\u91CF\u9ED8\u8BA4\u90FD\u4EE5 "__$$" \u5F00\u5934\uFF0C\u7981\u6B62\u5728\u642D\u5EFA\u7684\u4EE3\u7801\u4E2D\u76F4\u63A5\u8BBF\u95EE\u3002
        // \u4F8B\u5916\uFF1Arax \u6846\u67B6\u7684\u5BFC\u51FA\u540D\u548C\u5404\u79CD\u7EC4\u4EF6\u540D\u9664\u5916\u3002
        import { createElement, Component } from 'rax';
        import { getSearchParams as __$$getSearchParams } from 'rax-app';
      `,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var commonDeps_default = pluginFactory29;

  // src/plugins/project/framework/rax/index.ts
  init_define_process();

  // src/plugins/project/framework/rax/template/index.ts
  init_define_process();

  // src/plugins/project/framework/rax/template/static-files.ts
  init_define_process();

  // src/utils/templateHelper.ts
  var templateHelper_exports = {};
  __export(templateHelper_exports, {
    insertFile: () => insertFile,
    runFileGenerator: () => runFileGenerator
  });
  init_define_process();
  function insertFile(root2, path, file2) {
    let current = root2;
    path.forEach((pathNode) => {
      const dir = current.dirs.find((d) => d.name === pathNode);
      if (dir) {
        current = dir;
      } else {
        const newDir = createResultDir(pathNode);
        addDirectory(current, newDir);
        current = newDir;
      }
    });
    addFile(current, file2);
  }
  function runFileGenerator(root2, fun) {
    try {
      const result2 = fun();
      const [path, file2] = result2;
      insertFile(root2, path, file2);
    } catch (error) {
      throw new Error(`Error: ${typeof fun}`);
    }
  }

  // src/plugins/project/framework/rax/template/files/.eslintignore.ts
  init_define_process();
  function getFile() {
    return [
      ["."],
      {
        name: ".eslintignore",
        ext: "",
        content: "node_modules/\nlib/\ndist/\nbuild/\ncoverage/\ndemo/\nes/\n.rax/\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.eslintrc.js.ts
  init_define_process();
  function getFile2() {
    return [
      ["."],
      {
        name: ".eslintrc",
        ext: "js",
        content: "const { getESLintConfig } = require('@iceworks/spec');\n\n// https://www.npmjs.com/package/@iceworks/spec\nmodule.exports = {\n  ...getESLintConfig('rax'),\n  rules: {\n    'max-len': ['error', { code: 200 }],\n    'function-paren-newline': 'off',\n    '@typescript-eslint/indent': 'off',\n    'prettier/prettier': 'off',\n    'no-empty': 'off',\n    'no-unused-vars': 'off',\n    '@iceworks/best-practices/recommend-functional-component': 'off',\n  },\n};\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.gitignore.ts
  init_define_process();
  function getFile3() {
    return [
      ["."],
      {
        name: ".gitignore",
        ext: "",
        content: "# See https://help.github.com/articles/ignoring-files/ for more about ignoring files.\n\n*~\n*.swp\n*.log\n\n.DS_Store\n.idea/\n.temp/\n\nbuild/\ndist/\nlib/\ncoverage/\nnode_modules/\n.rax/\n\ntemplate.yml"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.prettierignore.ts
  init_define_process();
  function getFile4() {
    return [
      ["."],
      {
        name: ".prettierignore",
        ext: "",
        content: "node_modules/\nlib/\ndist/\nbuild/\ncoverage/\ndemo/\nes/\n.rax/\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.prettierrc.js.ts
  init_define_process();
  function getFile5() {
    return [
      ["."],
      {
        name: ".prettierrc",
        ext: "js",
        content: "const { getPrettierConfig } = require('@iceworks/spec');\n\nmodule.exports = getPrettierConfig('rax');\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.stylelintignore.ts
  init_define_process();
  function getFile6() {
    return [
      ["."],
      {
        name: ".stylelintignore",
        ext: "",
        content: "node_modules/\nlib/\ndist/\nbuild/\ncoverage/\ndemo/\nes/\n.rax/\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.stylelintrc.js.ts
  init_define_process();
  function getFile7() {
    return [
      ["."],
      {
        name: ".stylelintrc",
        ext: "js",
        content: "const { getStylelintConfig } = require('@iceworks/spec');\n\nmodule.exports = getStylelintConfig('rax');\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/jsconfig.json.ts
  init_define_process();
  function getFile8() {
    return [
      ["."],
      {
        name: "jsconfig",
        ext: "json",
        content: '{\n  "compilerOptions": {\n    "baseUrl": ".",\n    "jsx": "react",\n    "paths": {\n      "@/*": ["./src/*"],\n      "rax-app": [".rax/index.ts"]\n    }\n  }\n}\n'
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/README.md.ts
  init_define_process();
  function getFile9() {
    return [
      ["."],
      {
        name: "README",
        ext: "md",
        content: "# rax-materials-basic-app\n\n## Getting Started\n\n### `npm run start`\n\nRuns the app in development mode.\n\nOpen [http://localhost:3333](http://localhost:3333) to view it in the browser.\n\nThe page will reload if you make edits.\n\n### `npm run build`\n\nBuilds the app for production to the `build` folder.\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/tsconfig.json.ts
  init_define_process();
  function getFile10() {
    return [
      ["."],
      {
        name: "tsconfig",
        ext: "json",
        content: '{\n  "compileOnSave": false,\n  "buildOnSave": false,\n  "compilerOptions": {\n    "baseUrl": ".",\n    "outDir": "build",\n    "module": "esnext",\n    "target": "es6",\n    "jsx": "preserve",\n    "jsxFactory": "createElement",\n    "moduleResolution": "node",\n    "allowSyntheticDefaultImports": true,\n    "lib": ["es6", "dom"],\n    "sourceMap": true,\n    "allowJs": true,\n    "rootDir": "./",\n    "forceConsistentCasingInFileNames": true,\n    "noImplicitReturns": true,\n    "noImplicitThis": true,\n    "noImplicitAny": false,\n    "importHelpers": true,\n    "strictNullChecks": true,\n    "suppressImplicitAnyIndexErrors": true,\n    "noUnusedLocals": true,\n    "skipLibCheck": true,\n    "paths": {\n      "@/*": ["./src/*"],\n      "rax-app": [".rax/index.ts"]\n    }\n  },\n  "include": ["src", ".rax"],\n  "exclude": ["node_modules", "build", "public"]\n}'
      }
    ];
  }

  // src/plugins/project/framework/rax/template/static-files.ts
  function generateStaticFiles2(root2 = createResultDir(".")) {
    runFileGenerator(root2, getFile);
    runFileGenerator(root2, getFile2);
    runFileGenerator(root2, getFile3);
    runFileGenerator(root2, getFile4);
    runFileGenerator(root2, getFile5);
    runFileGenerator(root2, getFile6);
    runFileGenerator(root2, getFile7);
    runFileGenerator(root2, getFile8);
    runFileGenerator(root2, getFile9);
    runFileGenerator(root2, getFile10);
    return root2;
  }

  // src/plugins/project/framework/rax/template/index.ts
  var raxAppTemplate = {
    slots: {
      components: {
        path: ["src", "components"]
      },
      pages: {
        path: ["src", "pages"]
      },
      router: {
        path: ["src"],
        fileName: "router"
      },
      entry: {
        path: ["src"],
        fileName: "app"
      },
      appConfig: {
        path: ["src"],
        fileName: "app"
      },
      buildConfig: {
        path: [],
        fileName: "build"
      },
      constants: {
        path: ["src"],
        fileName: "constants"
      },
      utils: {
        path: ["src"],
        fileName: "utils"
      },
      i18n: {
        path: ["src"],
        fileName: "i18n"
      },
      globalStyle: {
        path: ["src"],
        fileName: "global"
      },
      htmlEntry: {
        path: ["src", "document"],
        fileName: "index"
      },
      packageJSON: {
        path: [],
        fileName: "package"
      }
    },
    async generateTemplate() {
      return generateStaticFiles2();
    }
  };
  var template_default3 = raxAppTemplate;

  // src/plugins/project/framework/rax/plugins/entry.ts
  init_define_process();
  var pluginFactory30 = (cfg) => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
import { runApp } from 'rax-app';

import './global.${(cfg == null ? void 0 : cfg.globalStylesFileType) || "css"}';
`,
        linkAfter: []
      });
      const appConfig = (cfg == null ? void 0 : cfg.appConfig) || {};
      Object.assign(appConfig, {
        router: {
          mode: "hash",
          ...appConfig.router
        }
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: `
runApp(${JSON.stringify(appConfig, null, 2)});
`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      return next;
    };
    return plugin;
  };
  var entry_default2 = pluginFactory30;

  // src/plugins/project/framework/rax/plugins/appConfig.ts
  init_define_process();
  var import_change_case9 = __toESM(require_change_case());
  var pluginFactory31 = (cfg) => {
    const plugin = async (pre) => {
      var _a, _b, _c, _d, _e, _f;
      const next = {
        ...pre
      };
      const ir = next.ir;
      const routes = ((_b = (_a = ir.globalRouter) == null ? void 0 : _a.routes) == null ? void 0 : _b.map((route) => ({
        path: route.path,
        source: `pages/${ensureValidClassName(import_change_case9.default.pascalCase(route.fileName))}/index`
      }))) || [{ path: "/", source: "pages/Home/index" }];
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: `
{
  "routes": ${JSON.stringify(routes, null, 2)},
  "window": {
    "title": ${JSON.stringify(
          (cfg == null ? void 0 : cfg.title) || ((_d = (_c = ir.project) == null ? void 0 : _c.meta) == null ? void 0 : _d.title) || ((_f = (_e = ir.project) == null ? void 0 : _e.meta) == null ? void 0 : _f.name) || ""
        )}
  }
}
      `,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var appConfig_default = pluginFactory31;

  // src/plugins/project/framework/rax/plugins/buildConfig.ts
  init_define_process();
  var pluginFactory32 = (cfg) => {
    const plugin = async (pre) => {
      var _a, _b, _c, _d, _e;
      const next = {
        ...pre
      };
      const ir = next.ir;
      const miniAppBuildType = ((_a = cfg == null ? void 0 : cfg.buildConfig) == null ? void 0 : _a.miniAppBuildType) || ((_c = (_b = ir.project) == null ? void 0 : _b.config) == null ? void 0 : _c.miniAppBuildType);
      const targets = (cfg == null ? void 0 : cfg.targets) || ["web"];
      const buildCfg = {
        inlineStyle: false,
        plugins: [],
        targets,
        miniapp: miniAppBuildType ? {
          buildType: miniAppBuildType,
          ...(_d = cfg == null ? void 0 : cfg.buildConfig) == null ? void 0 : _d.miniapp
        } : (_e = cfg == null ? void 0 : cfg.buildConfig) == null ? void 0 : _e.miniapp,
        ...cfg == null ? void 0 : cfg.buildConfig
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: `${JSON.stringify(buildCfg, null, 2)}
`,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var buildConfig_default = pluginFactory32;

  // src/plugins/project/framework/rax/plugins/entryDocument.ts
  init_define_process();
  var pluginFactory33 = (cfg) => {
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: `
import { createElement } from 'rax';
import { Root, Style, Script } from 'rax-document';

function Document() {
  return (
    <html>
      <head>
        <meta charset="utf-8" />
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no,viewport-fit=cover"
        />
        <title>${(cfg == null ? void 0 : cfg.title) || ((_a = ir == null ? void 0 : ir.meta) == null ? void 0 : _a.name) || "Rax App"}</title>
        <Style />
      </head>
      <body>
        {/* root container */}
        <Root />
        <Script />
      </body>
    </html>
  );
}

export default Document;
`,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var entryDocument_default = pluginFactory33;

  // src/plugins/project/framework/rax/plugins/globalStyle.ts
  init_define_process();
  var pluginFactory34 = (config) => {
    const cfg = {
      fileType: "scss" /* SCSS */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.StyleDepsImport,
        content: "",
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: `
body {
  -webkit-font-smoothing: antialiased;
}
`,
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: ir.css || "",
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      return next;
    };
    return plugin;
  };
  var globalStyle_default2 = pluginFactory34;

  // src/plugins/project/framework/rax/plugins/packageJSON.ts
  init_define_process();

  // src/utils/version.ts
  var version_exports = {};
  __export(version_exports, {
    calcCompatibleVersion: () => calcCompatibleVersion
  });
  init_define_process();
  var import_semver = __toESM(require_semver2());
  function calcCompatibleVersion(v1, v2) {
    if (!v1 && !v2) {
      return "*";
    }
    if (!v1 || v1 === "*") {
      return v2 || "*";
    }
    if (!v2 || v2 === "*") {
      return v1;
    }
    if (v1 === v2) {
      return v1;
    }
    if (!import_semver.default.intersects(v1, v2, { loose: true })) {
      throw new Error(`no compatible versions for "${v1}" and "${v2}"`);
    }
    if (import_semver.default.subset(v1, v2, { loose: true })) {
      return v1;
    }
    return v2;
  }

  // src/plugins/project/framework/rax/plugins/packageJSON.ts
  var pluginFactory35 = (cfg) => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const npmDeps = getNpmDependencies(ir);
      const packageJson = {
        name: (cfg == null ? void 0 : cfg.packageName) || "rax-demo-app",
        private: true,
        version: (cfg == null ? void 0 : cfg.packageVersion) || "1.0.0",
        scripts: {
          start: "rax-app start",
          build: "rax-app build",
          eslint: "eslint --ext .js,.jsx ./",
          stylelint: 'stylelint "**/*.{css,scss,less}"',
          prettier: "prettier **/* --write",
          lint: "npm run eslint && npm run stylelint"
        },
        dependencies: {
          ...buildDataSourceDependencies(ir, cfg == null ? void 0 : cfg.datasourceConfig),
          "universal-env": "^3.2.0",
          "intl-messageformat": "^9.3.6",
          rax: "^1.1.0",
          "rax-document": "^0.1.6",
          ...npmDeps.reduce(
            (acc, npm) => ({
              ...acc,
              [npm.package]: npm.version || "*"
            }),
            {}
          )
        },
        devDependencies: {
          "@iceworks/spec": "^1.0.0",
          "rax-app": "^3.0.0",
          eslint: "^6.8.0",
          prettier: "^2.1.2",
          stylelint: "^13.7.2"
        }
      };
      next.chunks.push({
        type: "json" /* JSON */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: packageJson,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var packageJSON_default2 = pluginFactory35;
  function getNpmDependencies(project) {
    const npmDeps = [];
    const npmNameToPkgMap = /* @__PURE__ */ new Map();
    const allDeps = project.packages;
    allDeps.forEach((dep) => {
      if (!isNpmInfo(dep)) {
        return;
      }
      const existing = npmNameToPkgMap.get(dep.package);
      if (!existing) {
        npmNameToPkgMap.set(dep.package, dep);
        npmDeps.push(dep);
        return;
      }
      if (existing.version !== dep.version) {
        try {
          npmNameToPkgMap.set(dep.package, {
            ...existing,
            version: calcCompatibleVersion(existing.version, dep.version)
          });
        } catch (e) {
          throw new Error(
            `Cannot find compatible version for ${dep.package}. Detail: ${getErrorMessage(e)}`
          );
        }
      }
    });
    return npmDeps;
  }

  // src/plugins/project/framework/rax/index.ts
  var rax_default = {
    template: template_default3,
    plugins: {
      appConfig: appConfig_default,
      buildConfig: buildConfig_default,
      entry: entry_default2,
      entryDocument: entryDocument_default,
      globalStyle: globalStyle_default2,
      packageJSON: packageJSON_default2
    }
  };

  // src/solutions/rax-app.ts
  function createRaxProjectBuilder(options) {
    return createProjectBuilder({
      inStrictMode: options == null ? void 0 : options.inStrictMode,
      extraContextData: { ...options },
      template: rax_default.template,
      plugins: {
        components: [
          commonDeps_default(),
          esmodule_default({ fileType: "jsx", useAliasName: false }),
          containerClass_default2(),
          containerInitState_default2(),
          containerMethods_default(),
          containerInjectContext_default2(),
          containerInjectDataSourceEngine_default2(options),
          containerInjectUtils_default2(),
          containerLifeCycle_default2(),
          jsx_default2(),
          css_default()
        ],
        pages: [
          commonDeps_default(),
          esmodule_default({ fileType: "jsx" }),
          containerClass_default2(),
          containerInitState_default2(),
          containerMethods_default(),
          containerInjectContext_default2(),
          containerInjectDataSourceEngine_default2(options),
          containerInjectUtils_default2(),
          containerLifeCycle_default2(),
          jsx_default2(),
          css_default()
        ],
        appConfig: [rax_default.plugins.appConfig(options)],
        buildConfig: [rax_default.plugins.buildConfig(options)],
        entry: [rax_default.plugins.entry(options)],
        constants: [constants_default()],
        utils: [esmodule_default(), utils_default("rax")],
        i18n: [i18n_default()],
        globalStyle: [
          rax_default.plugins.globalStyle({ fileType: (options == null ? void 0 : options.globalStylesFileType) || "css" })
        ],
        htmlEntry: [rax_default.plugins.entryDocument(options)],
        packageJSON: [rax_default.plugins.packageJSON(options)]
      },
      postProcessors: [prettier_default()]
    });
  }
  var plugins2 = {
    containerClass: containerClass_default2,
    containerLifeCycles: containerLifeCycle_default2,
    containerMethods: containerMethods_default,
    containerInitState: containerInitState_default2,
    containerInjectContext: containerInjectContext_default2,
    containerInjectDataSourceEngine: containerInjectDataSourceEngine_default2,
    containerInjectUtils: containerInjectUtils_default2,
    jsx: jsx_default2,
    commonDeps: commonDeps_default,
    raxApp: rax_default
  };

  // src/plugins/common/requireUtils.ts
  init_define_process();
  var pluginFactory36 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: "import * from 'react';",
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var requireUtils_default = pluginFactory36;

  // src/utils/index.ts
  var utils_exports = {};
  __export(utils_exports, {
    common: () => common_exports,
    compositeType: () => compositeType_exports,
    expressionParser: () => expressionParser_exports,
    jsExpression: () => jsExpression_exports,
    jsSlot: () => jsSlot_exports,
    nodeToJSX: () => nodeToJSX_exports,
    resultHelper: () => resultHelper_exports,
    schema: () => schema_exports,
    scope: () => Scope_exports,
    templateHelper: () => templateHelper_exports,
    validate: () => validate_exports,
    version: () => version_exports
  });
  init_define_process();

  // src/standalone.ts
  var standalone_default = {
    createProjectBuilder,
    createModuleBuilder,
    solutions: {
      icejs: createIceJsProjectBuilder,
      rax: createRaxProjectBuilder
    },
    solutionParts: {
      icejs: icejs_default,
      rax: rax_default
    },
    publishers: {
      zip: createZipPublisher
    },
    plugins: {
      common: {
        esmodule: esmodule_default,
        esModule: esmodule_default,
        requireUtils: requireUtils_default
      },
      react: {
        ...plugins
      },
      rax: {
        ...plugins2
      },
      style: {
        css: css_default
      },
      project: {
        constants: constants_default,
        i18n: i18n_default,
        utils: utils_default
      }
    },
    postprocessor: {
      prettier: prettier_default
    },
    utils: utils_exports,
    chunkNames: {
      COMMON_CHUNK_NAME,
      CLASS_DEFINE_CHUNK_NAME,
      REACT_CHUNK_NAME
    },
    defaultLinkAfter: {
      COMMON_DEFAULT_LINK_AFTER: DEFAULT_LINK_AFTER
    },
    constants: const_exports
  };

  // src/standalone-worker.ts
  self.onmessage = (event) => {
    const msg = event.data || {};
    if (msg.type === "run") {
      run(msg);
    }
  };
  self.postMessage({ type: "ready" });
  async function run(msg) {
    try {
      print("begin run...");
      self.postMessage({ type: "run:begin" });
      const { solution } = msg;
      if (!solution) {
        throw new Error("solution is required");
      }
      const createAppBuilder = standalone_default.solutions[solution];
      if (typeof createAppBuilder !== "function") {
        throw new Error(`solution '${solution}' is invalid`);
      }
      const appBuilder = createAppBuilder();
      print("generating from schema: %o", msg.schema);
      const result2 = await appBuilder.generateProject(msg.schema);
      print("generated result: %o", result2);
      const finalResult = msg.flattenResult ? standalone_default.utils.resultHelper.flattenResult(result2) : result2;
      if (msg.flattenResult) {
        print("flatten result: %o", finalResult);
      }
      self.postMessage({
        type: "run:end",
        result: finalResult
      });
    } catch (e) {
      printErr(`${e}`);
      self.postMessage({
        type: "run:error",
        errorMsg: `${(e == null ? void 0 : e.message) || e}`,
        errorDetail: `${e}`
      });
    }
  }
  function print(text, ...args) {
    console.debug(`[code-generator/worker]: ${text}`, ...args);
    self.postMessage({
      type: "stdout",
      data: text,
      args
    });
  }
  function printErr(text, ...args) {
    console.debug(`[code-generator/worker]: %c${text}`, "color:red", ...args);
    self.postMessage({
      type: "stderr",
      data: text,
      args
    });
  }
})();
//# sourceMappingURL=standalone-worker.js.map
